/**
 * @file counting-semaphore.js - Provides angular-external control over the store bootstrapping process to prevent
 *                               invalid initialization states. The implementation is a non-blocking counting semaphore.
 * @author John L. Singleton <john.singleton@accesso.com>
 */


function CountingSemaphore(maxSems) {
	var allSems = this.generateSemaphoreIds(maxSems);
	var availableSems = [];

	// copy all sems to the available queue
	allSems.forEach(function(s) {
		availableSems.push(s);
	});

	/**
	 * Takes sems from the pool. We return one at a time from the semaphore pool. We return false if a semaphore count not be allocated.
	 */
	this.take = function() {
		if (availableSems.length > 0) {
			return availableSems.pop();
		}
		return false;
	};

	/**
	 * Releases semaphore back to pool. Note that the sems must exist in the parent pool.
     * This function will return true if the semaphore is sucessfully replaced in the pool.
	 */
	this.release = function(sem) {
		if (allSems.indexOf(sem)!==-1) {
			if (availableSems.indexOf(sem)==-1) {
				availableSems.push(sem);
			}
			return true;
		}
		return false;
	};

	this.available = function() {
		return availableSems.length;
	};
}

CountingSemaphore.prototype.generateSemaphoreIds = function(howMany) {
	var sems = [];

	while (sems.length < howMany) {
		var canidate = Math.floor((Math.random() * 1000000) + 1);
		if (sems.indexOf(canidate)===-1) {
			sems.push(canidate);
		}
	}
	return sems;
};


//
// Shopland Specifc Initialization
//

// We only allow one store initialization attempt at a time

var ShoplandInitSemaphore = new CountingSemaphore(1);



/**
 * # Main application declaration file
 *
 * Allows main application to be declared. This seperate file is required in
 * order to properly isolate angular logic from requirejs module loading
 */
angular.module('app',
	[
		'ngResource',
		'ngSanitize',
		'ngMessages',
		'ngCookies',
		'ngTouch',
		'adyen-checkout',
		'logging',
		'test-strategy',
		'accesso-pay',
		'cybersource',
		'google-pay',
		'ui.bootstrap',
		'ui.router',
		'ui.router.state.events',
		'paramTypes',
		'gm.datepickerMultiSelect',
		'errorTracking',
		'bundle',
		'cart',
		'ngIdle',
		'snap-calendar',
		'ngAria',
		'LocalStorageModule',
		'activations',
		'birthdays',
		'restricted-packages',
		'comp-assignment',
		'generic-form',
		'giftcode',
		'group-sales',
		'group-sales-wizard',
		'info',
		'trip-select',
		'license-plate-capture',
		'participant-program',
		'paypal',
		'reservations',
		'analytics',
		'camps',
		'camps-enrollment',
		'idme',
		'cabanas',
		'donation-message',
		'adoptions-donations',
		'experience-scheduler',
		'simplified-calendar',
		'scheduling',
		'base-calendar',
		'calendar-pricing',
		'faq-page',
		'fast-lane',
		'date-time',
		'matrix',
		'interstitial-dining',
		'imagecaptures',
		'comp-selection',
		'reservation',
		'merch-size',
		'zoo-memberships',
		'membership-wizard',
		'entitlement-wizard',
		'upgrades-wizard',
		'gift-aid',
		'gift-membership',
		'multi-guest-generic-form',
		'ngCacheBuster',
		'static-include',
		'billing',
		'quicksell',
		'oc.lazyLoad',
		'cultural-member-benefits',
		'cultural-membership-wizard',
		'profile',
		'profile-login',
		'profile-manager',
		'profile-manager-new',
		'payment-plan',
		'assigned-seating',
		'seat-genius',
		'guest-options',
		'guest-app-ui',
		'recommender-wizard',
		'crosssell-choice',
		'package-comparison',
		'fast-lane-wizard',
		'upsell-wizard',
		'season-pass-select',
		'agreement',
		'addon-selection',
		'date-collection',
		'ui-components',
		'recaptcha',
		'reseller',
		'cart-abandonment',
		'wtp',
		'gender-input',
		'notification',
		'accesso-locale',
		'credit-cards',
		'event-search',
		'date-picker',
		'characters-remaining',
		'order',
		'configurable-objects',
		'booking-portal',
		'account-portal',
		'dynamic-toolbar-overrides',
		'sportal',
		'sms-verification',
		'request',
		'accessibility',
		'promo-code',
		'promo-code-override',
		'vertical-package-list',
		'video',
		'date-matrix-time-selection',
		'ab-test',
		'input-capture-modal',
		'upsell',
		'components',
		'te2',
		'te2-generic-modal',
		'te2-onboarding',
		'stored-payments',
		'jwt',
		'post-purchase-actions',
		'one-risk',
		'package-planner',
		'membership-experience',
		'simple-store',
		'post-purchase-survey',
		'package-details',
		'unified-package-details',
		'json-validator-constants',
		'pass-select',
		'quick-checkout',
		'resource-selector',
		'place-reservation',
		'passport-auth',
		'guest-profile',
		'guest-profile-menu',
		'buy-now'
	]);

/* eslint-disable no-implicit-globals, strict */
angular.module('app').config(appConfig);

/**
 * Defines the application's general configuration, except for routing which is defined in app-routing.js
 * @param {Provider} $urlServiceProvider urlServiceProvider
 * @param {Provider} localStorageServiceProvider The local storage service provider.
 * @param {Provider} IdleProvider IdleProvider
 * @param {Provider} KeepaliveProvider KeepaliveProvider
 * @param {Provider} $provide provide
 * @param {Service} IdleSettings IdleSettings
 * @param {Provider} httpRequestInterceptorCacheBusterProvider httpRequestInterceptorCacheBusterProvider
 * @param {Provider} $transitionsProvider UI Router Transitions Provider
 * @param {Provider} $sceDelegateProvider Angular SCE delegate provider
 * @returns {undefined}
 * @ngInject
 */
function appConfig($urlServiceProvider, localStorageServiceProvider, IdleProvider, KeepaliveProvider, $provide, IdleSettings, httpRequestInterceptorCacheBusterProvider, $transitionsProvider, $sceDelegateProvider) {
	// Trust module-scoped templateUrl keys of the form 'module-name:template-id'
	// (e.g. 'snap-calendar:results', 'unified-package-details:main').
	// Requiring a hyphen in the scheme prevents collisions with real URL schemes
	// (javascript:, data:, blob:, etc.) that are all single lowercase words.
	// A few older shared components ('components', 'component', 'preview') predate
	// that convention and use a non-hyphenated scheme, so they're allowlisted explicitly
	// by name rather than by loosening the hyphen requirement for all schemes.
	$sceDelegateProvider.trustedResourceUrlList([
		'self',
		/^[a-z][a-z0-9]*(-[a-z0-9][a-z0-9-]*)+:[a-z][a-z0-9-]*(::[a-z][a-z0-9-]+)?$/,
		/^(?:components?|preview):{1,2}[a-z][a-z0-9-]*(?::{1,2}[a-z][a-z0-9-]+)*$/,
	]);
	httpRequestInterceptorCacheBusterProvider.setMatchlist([/.*views\/.*html/, /.*scripts\/modules.*html/, /.*scripts\/modules.*js/], true);

	IdleProvider.idle(IdleSettings.IDLE_TIMEOUT);
	IdleProvider.timeout(IdleSettings.IDLE_WARNING);
	KeepaliveProvider.interval(IdleSettings.KEEPALIVE_INTERVAL);

	$urlServiceProvider.config.strictMode(false);

	// Any cookies must only be set for max 1 day.
	localStorageServiceProvider.setStorageCookie(1, '/');

	$provide.decorator('$state', function($delegate) {
		$transitionsProvider.onStart({}, function(trans) {
			$delegate.next = trans.to();
			$delegate.toParams = trans.params('to');
		});
		return $delegate;
	});
}
	angular
		.module('paramTypes', ['ui.router','app'])
		.config(ParamTypes);

	/**
	 * Custom Param Types to use the the
	 * @constructor
	 * @param {Service} $urlMatcherFactoryProvider - Angular UI Router URL matcher factory provider
	 * @returns {undefined}
	 * @ngInject
	 */
	function ParamTypes($urlMatcherFactoryProvider) {
		$urlMatcherFactoryProvider
			.type('guestselection', {
				encode: function encode(obj) {
					if (!angular.isObject(obj)) {
						return '';
					}

					return Object.entries(obj).map(function encodeObj(entry) {
						return entry[0] + '-' + entry[1];
					}).join('_');
				},
				decode: function decode(str) {
					if (!angular.isString(str)) {
						return str;
					}

					return str.split('_').reduce(function decodeStr(acc, item) {
						var keyValue = item.split('-');

						acc[keyValue[0]] = +keyValue[1];

						return acc;
					}, {});
				},
				is: function is(obj) {
					return angular.isObject(obj) && Object.entries(obj).every(function iterateObject(entry) {
						return entry[0] > 0 && entry[1] > 0;
					});
				},
				// Match the encoded string in the URL
				pattern: /\d+-\d+(?:_\d+-\d+)*/
			})
			.type('keyword', {
				encode: function encode(str) {
					return (str + '');
				},
				decode: function decode(str) {
					return (str || '');
				},
				is: function is(obj) {
					return angular.isString(obj);
				},
				equals: function (a, b) { return a == b; },
				// Match the encoded string in the URL
				pattern: /[^/]+/
			})
			.type('accessoDate', {
				encode: function encode(date) {
					return date instanceof Date ? new Date(date.getTime() - (date.getTimezoneOffset() * 60000)).toISOString().split('T')[0] : '';
				},
				decode: function decode(str) {
					var parts = /(\d{4})-(\d{2})-(\d{2})/.exec(str);

					if (!parts) {
						return null;
					}

					return new Date(+parts[1], +parts[2] - 1, +parts[3]);
				},
				is: function is(date) {
					return date instanceof Date;
				},
				pattern: /\d{4}-\d{2}-\d{2}/
			});
	}
/* eslint-disable no-implicit-globals, strict, sort-keys, camelcase */
angular
	.module('app')
	.config(routingConfig);

/**
 * Defines the application's routing configuration
 * @param {Provider} $locationProvider locationProvider
 * @param {Provider} $stateProvider stateProvider
 * @param {Provider} $urlRouterProvider urlRouterProvider
 * @param {Provider} $urlServiceProvider urlServiceProvider
 * @param {Service} ComponentLoaderEnums ComponentLoaderEnums
 * @returns {undefined}
 * @ngInject
 */
function routingConfig($locationProvider, $stateProvider, $urlRouterProvider, $urlServiceProvider, ComponentLoaderEnums) {
	var VENDOR_DIRECTORY = '../../vendor/',
		UTILITIES_MODULE_DIRECTORY = 'scripts/modules/utilities',
		BARCODE_ASSETS = [
			VENDOR_DIRECTORY + 'baren/lib/render/renlinear.js',
			VENDOR_DIRECTORY + 'baren/lib/barcodes/code128.js',
			VENDOR_DIRECTORY + 'baren/lib/barcodes/qrcode.js',
			VENDOR_DIRECTORY + 'baren/lib/render/renmatrix.js',
			UTILITIES_MODULE_DIRECTORY + '/numeral-system-service.js'
		],
		BAREN_ASSETS = [VENDOR_DIRECTORY + 'baren/baren.js'],
		inTestMode = window.xdescribe && window.jasmine;

	$locationProvider.html5Mode(true);

	// Always try and route package list
	if (!inTestMode) {
		$stateProvider.state('/', {
			components: [ ComponentLoaderEnums.cartFeeNotice ],
			url: '/',
			templateUrl: '/views/packageList.html',
			controller: 'PackageListCtrl',
			title: 'packageList',
			resolve: { initialData: initialData }
		});
	}

	$stateProvider
		.state('/error/:errorCode', {
			url: '/error/:errorCode',
			templateUrl: '/views/errorView.html',
			controller: 'ErrorPageCtrl',
			dynamic: true
		})
		.state('/error/:errorCode/:noButtons', {
			url: '/error/:errorCode/:noButtons',
			templateUrl: '/views/errorView.html',
			controller: 'ErrorPageCtrl',
			dynamic: true
		})
		.state('/pendingOrder/:authID', {
			url: '/pendingOrder/:authID',
			templateUrl: '/views/thankyou.html',
			controller: 'ThankYouCtrl',
			resolve: {
				initialData: initialData
			}
		})
		.state('/paymentProvider', {
			url: '/paymentProvider',
			templateUrl: '/views/paymentProvider.html',
			controller: 'PaymentProviderCtrl',
			resolve: { initialData: initialData }
		})
		.state('/packageList', {
			components: [ ComponentLoaderEnums.cartFeeNotice ],
			url: '/packageList',
			templateUrl: '/views/packageList.html',
			controller: 'PackageListCtrl',
			title: 'packageList',
			resolve: { initialData: initialData }
		})
		.state('/packageList/noPackageFound', {
			components: [ ComponentLoaderEnums.cartFeeNotice ],
			url: '/packageList/noPackageFound',
			templateUrl: '/views/packageList.html',
			controller: 'PackageListCtrl',
			title: 'packageList',
			resolve: {
				initialData: initialData,
				setupPackageService: function(initialData, PackageList) {
					return PackageList.initialize("noPackageFound");
				}
			}
		})
		.state('packageList/keyword', {
			components: [ ComponentLoaderEnums.cartFeeNotice ],
			url: '/packageList/keyword/:keyword',
			params: {
				keyword: {
					squash: true,
					value: ''
				}
			},
			templateUrl: '/views/packageList.html',
			controller: 'PackageListCtrl',
			title: 'packageList',
			resolve: {
				initialData: initialDataWithSpinner,
				setupPackageService: function(initialData, PackageList, $transition$) {
					return PackageList.initialize($transition$.params());
				},
				hideSpinner: function(setupPackageService, $rootScope) {
					$rootScope.hideSpinner();
				}
			}
		})
		.state('packageList/navItem', {
			components: [ ComponentLoaderEnums.cartFeeNotice ],
			url: '/packageList/navItem/:navItem',
			templateUrl: '/views/packageList.html',
			controller: 'PackageListCtrl',
			title: 'packageList',
			resolve: {
				initialData: initialDataWithSpinner,
				setupPackageService: function(initialData, PackageList, $transition$) {
					return PackageList.initialize($transition$.params());
				},
				hideSpinner: function(setupPackageService, $rootScope) {
					$rootScope.hideSpinner();
				}
			}
		})
		.state('/packageList/promocode/:promocode', {
			components: [ ComponentLoaderEnums.cartFeeNotice ],
			url: '/packageList/promocode/:promocode',
			templateUrl: '/views/packageList.html',
			controller: 'PackageListCtrl',
			title: 'packageList',
			resolve: {
				initialData: initialDataWithSpinner,
				setupPackageService: function(initialData, PackageList, $transition$) {
					return PackageList.initialize($transition$.params());
				},
				hideSpinner: function(setupPackageService, $rootScope) {
					$rootScope.hideSpinner();
				}
			}
		})
		.state('/packageList/promoOpen', {
			components: [ ComponentLoaderEnums.cartFeeNotice ],
			url: '/packageList/promoOpen',
			templateUrl: '/views/packageList.html',
			controller: 'PackageListCtrl',
			title: 'packageList',
			resolve: {
				initialData: initialData,
				displayModal: function(initialData, Modal) {
					Modal.displayModal({
						category: 'Promo',
						action: 'View',
						label: 'Promo Modal',
						view: Modal.PROMO,
						title: 'Promo Code'
					});
				}
			}
		})
		.state('/open-knowledge-base', {
			url: '/open-knowledge-base',
			template: '<div></div>',
			controller: 'KnowledgeBaseCtrl',
			resolve: { initialData: initialData }
		})
		.state('package-list-crosssells', {
			url: '/packageList/crosssells/:crosssell',
			templateUrl: '/views/packageList.html',
			controller: 'PackageListCtrl',
			title: 'packageList',
			resolve: {
				initialData: initialDataWithSpinner,
				setupPackageService: function(initialData, PackageList, $transition$) {
					return PackageList.initialize($transition$.params());
				},
				assessRoute: function(setupPackageService, $transition$, PackageList, Utilities) {
					var keyword = $transition$.params().crosssell;
					PackageList.getPackageKeywordList(keyword);

					if (Utilities.checkProp('PackageList.dataModel.packageList.0.0', PackageList, 'validObject')
					&& PackageList.dataModel.packageList.length === 1 && PackageList.dataModel.packageList[0].length === 1) {
						$transition$.abort();
						Utilities.goTo('packageDetails', {
							flowDetail: keyword,
							flowType: 'crosssells',
							packageId: PackageList.dataModel.packageList[0][0].id
						}, true)
					} else {
						return true;
					}
				},
				hideSpinner: function(assessRoute, $rootScope) {
					$rootScope.hideSpinner();
				}
			}
		})
		.state('packageList/packages/:packages', {
			url: '/packageList/packages/:packages',
			templateUrl: '/views/packageList.html',
			controller: 'PackageListCtrl',
			title: 'packageList',
			params: {
				dynamicPricing: {
					squash: true,
					value: {}
				}
			},
			resolve: {
				initialData: initialDataWithSpinner,
				setupPackageService: function(initialData, PackageList, $transition$) {
					return PackageList.initialize($transition$.params());
				},
				hideSpinner: function(setupPackageService, $rootScope) {
					$rootScope.hideSpinner();
				}
			}
		})
		.state('/crossSells', {
			url: '/crossSells/:pkgIds?',
			templateUrl: '/views/crossSells-switch.html',
			controller: 'CrossSellsCtrl',
			params: {
				pkgIds: {
					value: '',
					squash: true
				}
			},
			title: 'crossSells',
			resolve: {
				initialData: initialData,
				assessRoute: function(initialData, StandardFlowInitiatorService, RouteRejectionService, $rootScope) {
					if (StandardFlowInitiatorService.currentStandardFlowType === 'alternateEntry') {
						$rootScope.hideSpinner();
						throw new RouteRejectionService.UnrecoverableException(StandardFlowInitiatorService.alternateEntryState, StandardFlowInitiatorService.alternateEntryParams);
					}
				}
			}
		})

		.state('subKeyword', {
			url: '/subKeyword/:keyword',
			templateUrl: '/views/subKeyword.html',
			controller: 'SubKeywordController',
			title: 'subKeyword',
			resolve: {
				initialData: initialData,
				subKeywordCollection: function(initialData, SubKeyword, $transition$) {
					// eslint-disable-next-line new-cap
					return new SubKeyword.getCollection($transition$.params().keyword);
				},
				shouldSendBackToWtpReload: function shouldSendBackToWtpReloadFN(
					Utilities,
					UtilsValidation,
					Package,
					subKeywordCollection,
					RestrictedPackagesService,
					RouteRejectionService,
					WTPService
				) {
					var isWTP = true,
						removeIndexes = [],
						tiles = angular.copy(subKeywordCollection.items);

					tiles = UtilsValidation.validArray(tiles) ? tiles : [];

					if (tiles.length) {
						removeIndexes = tiles.reduce(function tilesReduction(acc, tile, index) {
							var allRestricted,
								hasAccessCount,
								keywords = [],
								packages = [];

							keywords = Utilities.getString(tile.keywords).split(',')
								.map(function keywordMapping(keyword) {
									return keyword.trim();
								});

							keywords.forEach(function keywordIteration(keyword) {
								packages = packages.concat(Package.getPackagesByKeyword(keyword));
							});


							packages = packages.reduce(function packagesReduction(pkgAcc, pkg) {
								var packageInArray = pkgAcc.some(function pkgAccTrial(somePackage) {
									return somePackage.id === pkg.id;
								});

								if (!packageInArray) {
									pkgAcc.push(pkg);
								}
								return pkgAcc;
							}, []);

							isWTP = isWTP && packages.every(WTPService.isWTPPackage);

							allRestricted = packages.every(function packagesLooping(pkg) {
								return RestrictedPackagesService.isRestrictedPackage(pkg);
							});

							if (allRestricted) {
								hasAccessCount = packages.reduce(function restrictedPackagesReduction(qty, pkg) {
									return qty + Number(RestrictedPackagesService.restrictedPackageLoaded(pkg.id));
								}, 0);

								if (!hasAccessCount) {
									acc.push(index);
								}
							}

							return acc;
						}, []);

						if (removeIndexes.length && removeIndexes.length === tiles.length) {
							if (isWTP) {
								throw new RouteRejectionService.UnrecoverableException('wtpnumber');
							} else {
								throw new RouteRejectionService.UnrecoverableException('/', undefined, false, true);
							}
						}
					}
				}
			}
		})
		.state('/cartRecovery/:email', {
			url: '/cartRecovery/:email',
			templateUrl: '/views/cartRecovery.html',
			controller: 'CartRecoveryCtrl',
			resolve: { initialData: initialData }
		})
		.state('/paymentMethod', {
			url: '/paymentMethod',
			templateUrl: '/scripts/modules/payment-method/templates/payment-method.html',
			controller: 'PaymentMethodController',
			dynamic: true,
			title: 'billing',
			resolve: {
				initialData: initialDataWithSpinner,
				redirectToCart: redirectToAccessoPay,
				loadBinRanges: loadBinRanges,
				loadCyberSourceAssets: loadCyberSourceAssets,
				loadGooglePayAssets: loadGooglePayAssets,
				loadAdyenAssets: loadAdyenAssets,
				verifyRecaptcha: verifyRecaptcha,
				loadRegisteredPaymentMethods: function(redirectToCart, loadBinRanges, loadCyberSourceAssets, loadGooglePayAssets, loadAdyenAssets, verifyRecaptcha, BillingService) {
					return BillingService.runRegisteredPaymentMethodsPromises();
				},
				registerCybersourceCustomAction: function(loadRegisteredPaymentMethods, CustomActionService, $injector) {
					var CyberSourceCreditCardsService = $injector.get('CyberSourceCreditCardsService');
					if (CyberSourceCreditCardsService.hasCreditCards()) {
						CustomActionService.registerCustomAction(CustomActionService.ACTIONS_ENUMS.GET_CREDIT_CARDS, CyberSourceCreditCardsService.getCreditCards);
					}
				},
				loadGooglePayAPIAssets: function(registerCybersourceCustomAction, CreditCardService, $injector, $q) {
					var GooglePayPreLoaderService;
					if (CreditCardService.hasGooglePay() && $injector.has('GooglePayPreLoaderService')) {
						GooglePayPreLoaderService = $injector.get('GooglePayPreLoaderService')
						return GooglePayPreLoaderService
							.loadAssets()
							.then(GooglePayPreLoaderService.performPostAssetsLoadAction.bind(null, false))
							.catch(function resolveGooglePay() {
								return $q.resolve();
							});
					}
				},
				paymentData: function(loadGooglePayAPIAssets, PaymentService) {
					return PaymentService.initialize();
				},
				updateCartCheckoutForShipping: function(paymentData, ShippingService) {
					return ShippingService.updateCartCheckoutWithShippingChoice();
				},
				agreementData: function(updateCartCheckoutForShipping, AgreementService, AppData) {
					AgreementService.initialize();
				},
				loadAgreements: loadAgreements,
				assessQuickFlow: function(loadAgreements, RouteRejectionService, BillingService) {
					if (BillingService.useZeroDollarQuickCheckout()) {
						throw new RouteRejectionService.UnrecoverableException('quick-checkout');
					}
				},
				hideSpinner: function(assessQuickFlow, $rootScope) {
					$rootScope.hideSpinner();
				}
			}
		})
		.state('/paymentResults', {
			url: '/paymentResults',
			templateUrl: '/views/paymentResults.html',
			controller: 'CartCtrl',
			dynamic: true,
			resolve: {
				initialData: initialDataWithSpinner,
				loadBinRanges: loadBinRanges,
				hideSpinner: function(loadBinRanges, $rootScope) {
					$rootScope.hideSpinner();
				}
			}
		})
		.state('shippingView', {
			url: '/shippingView',
			templateUrl: '/views/shippingView-new.html',
			controller: 'ShippingCtrl',
			title: 'shipping',
			resolve: {
				initialData: initialDataWithSpinner,
				loadAccessoPay: redirectToAccessoPay,
				loadCyberSourceAssets: loadCyberSourceAssets,
				loadGooglePayAssets: loadGooglePayAssets,
				loadAdyenAssets: loadAdyenAssets,
				verifyRecaptcha: verifyRecaptcha,
				assets: function(Utilities) {
					var COMPONENT_DIR = 'scripts/components/list';
					return Utilities.cacheBustAndLazyLoad([
						COMPONENT_DIR + '/list-component.js',
						COMPONENT_DIR + '/list-component.css',
						COMPONENT_DIR + '/list-component.html',
						COMPONENT_DIR + '/list-component-controller.js'
					]);
				},
				assessLogin: function(initialData, loadCyberSourceAssets, loadAdyenAssets, verifyRecaptcha, $rootScope, RouteRejectionService, ProfileLoginPrepService, ProfileLoginSessionService, Utilities, $state) {
					if ($rootScope.configuredForLogin && Utilities.getBoolean(ProfileLoginPrepService.config.require_login_for_non_member) && !ProfileLoginSessionService.isLoggedIn() && !ProfileLoginSessionService.isGuestCheckout()) {
						ProfileLoginSessionService.setPostSigninSuccessRoute($state.href('shippingView'));
						$rootScope.hideSpinner();
						throw new RouteRejectionService.UnrecoverableException('profile-login.signin', { showSignInOnly: $rootScope.disableCreateAccountOnGlobalLogin });
					} else {
						return true;
					}
				},
				loadGooglePayAPIAssets: function(assessLogin, CreditCardService, $injector, $q) {
					var GooglePayPreLoaderService;
					if (CreditCardService.hasGooglePay() && $injector.has('GooglePayPreLoaderService')) {
						GooglePayPreLoaderService = $injector.get('GooglePayPreLoaderService')
						return GooglePayPreLoaderService
							.loadAssets()
							.then(GooglePayPreLoaderService.performPostAssetsLoadAction.bind(null, false))
							.catch(function resolveGooglePay() {
								return $q.resolve();
							});
					}
				},
				agreementData: function(loadGooglePayAPIAssets, AgreementService) {
					AgreementService.initialize();
				},
				loadAgreements: loadAgreements,
				skipShipping: function(loadAgreements, ShippingService) {
					ShippingService.assessSkipShippingView();
				},
				hideSpinner: function(skipShipping, $rootScope, JSONValidator, AppData, Utilities) {
					var accessoPayConfig = JSONValidator.validate('accesso_pay', AppData.settings.accesso_pay) ? JSON.parse(AppData.settings.accesso_pay) : {};
					if (!Utilities.getBoolean(accessoPayConfig.enable)) {
						$rootScope.hideSpinner();
					}
				}
			}
		})
		.state('/billingView', {
			url: '/billingView',
			templateUrl: '/views/billingView.html',
			controller: 'BillingCtrl',
			title: 'billing',
			resolve: {
				initialData: initialDataWithSpinner,
				redirectToCart: redirectToCartForAccessoPay,
				loadBinRanges: loadBinRanges,
				loadCyberSourceAssets: loadCyberSourceAssets,
				loadGooglePayAssets: loadGooglePayAssets,
				loadAdyenAssets: loadAdyenAssets,
				verifyRecaptcha: verifyRecaptcha,
				assessLogin: function(redirectToCart, loadBinRanges, loadCyberSourceAssets, loadAdyenAssets, verifyRecaptcha, $rootScope, RouteRejectionService, ProfileLoginPrepService, ProfileLoginSessionService, Utilities, $state) {
					if ($rootScope.configuredForLogin && Utilities.getBoolean(ProfileLoginPrepService.config.require_login_for_non_member) && !ProfileLoginSessionService.isLoggedIn() && !ProfileLoginSessionService.isGuestCheckout()) {
						ProfileLoginSessionService.setPostSigninSuccessRoute($state.href('shippingView'));
						$rootScope.hideSpinner();
						throw new RouteRejectionService.UnrecoverableException('profile-login.signin', { showSignInOnly: $rootScope.disableCreateAccountOnGlobalLogin });
					} else {
						return true;
					}
				},
				loadFlexMicroform: function(assessLogin, $injector) {
					return $injector.get('FlexMicroformService').loadAssets();
				},
				getProfile: function(loadFlexMicroform, AppData, ProfileLoginSessionService, $q, $rootScope) {
					// this resolve determines whether or not information can be copied from the logged in profile to the shipping info.
					if (!$rootScope.configuredForLogin || !ProfileLoginSessionService.isLoggedIn()) {
						return true;
					}

					return true;
				},
				billingData: function(getProfile, BillingService) {
					return BillingService.initialize();
				},
				loadRegisteredPaymentMethods: function(initialData, BillingService) {
					return BillingService.runRegisteredPaymentMethodsPromises();
				},
				agreementData: function(loadRegisteredPaymentMethods, AgreementService) {
					AgreementService.initialize();
				},
				loadAgreements: loadAgreements,
				assessQuickFlow: function(loadAgreements, BillingService, RouteRejectionService) {
					if (BillingService.useZeroDollarQuickCheckout()) {
						throw new RouteRejectionService.UnrecoverableException('quick-checkout');
					}
				},
				loadAdditionalAssets: function(assessQuickFlow, Utilities) {
					return Utilities.cacheBustAndLazyLoad([
						'scripts/modules/billing/directives/zip-code-notice-directive.js',
						'scripts/modules/donation-message/donation-message-controller.js',
						'scripts/modules/donation-message/donation-message-directive.js'
					]);
				},
				hideSpinner: function(loadAdditionalAssets, $rootScope) {
					$rootScope.hideSpinner();
				}
			}
		})
		.state('/paymentView', {
			url: '/paymentView',
			templateUrl: '/views/paymentView.html',
			controller: 'PaymentCtrl',
			resolve: {
				initialData: initialDataWithSpinner,
				loadBinRanges: loadBinRanges,
				hideSpinner: function(loadBinRanges, $rootScope) {
					$rootScope.hideSpinner();
				}
			}
		})
		.state('/orderReview', {
			url: '/orderReview',
			templateUrl: '/scripts/modules/order-review/templates/order-review.html',
			controller: 'OrderReviewController',
			dynamic: true,
			title: 'orderReview',
			resolve: {
				initialData: initialDataWithSpinner,
				redirectToCart: redirectToCartForAccessoPay,
				loadLegacyCart: function loadLegacyCart(initialData, AppData, LegacyCart) {
					LegacyCart.updateInternals(AppData.GetCartSummary);
				},
				loadBinRanges: loadBinRanges,
				loadCyberSourceAssets: loadCyberSourceAssets,
				loadGooglePayAssets: loadGooglePayAssets,
				loadAdyenAssets: loadAdyenAssets,
				verifyRecaptcha: verifyRecaptcha,
				loadCardinalAssets: function(redirectToCart, loadLegacyCart, loadBinRanges, loadCyberSourceAssets, loadAdyenAssets, verifyRecaptcha, $injector) {
					var Cardinal3DSService = $injector.has('Cardinal3DSService') ? $injector.get('Cardinal3DSService') : null;
					if (Cardinal3DSService && Cardinal3DSService.currentPaymentHas3DSConfigured()) {
						return Cardinal3DSService.loadAssets();
					}
				},
				loadAdyen3dsAssets: function(loadCardinalAssets, $injector, CustomActionService) {
					var AdyenCheckout3DSService = $injector.has('AdyenCheckout3DSService') ? $injector.get('AdyenCheckout3DSService') : null;

					if (AdyenCheckout3DSService && AdyenCheckout3DSService.currentPaymentHas3DSConfigured()) {
						CustomActionService.registerCustomAction(CustomActionService.ACTIONS_ENUMS.INITIATE_SECURED_PURCHASE, AdyenCheckout3DSService.initiateAdyen3DS);
					}
				},
				loadRegisteredPaymentMethods: function(loadAdyen3dsAssets, BillingService) {
					//this is needed for redirect flows so if the user refreshes on this screen, we should take this into consideration
					return BillingService.runRegisteredPaymentMethodsPromises();
				},
				purchaseData: function(loadRegisteredPaymentMethods, Purchase) {
					return Purchase.initialize();
				},
				assessRoute: function(purchaseData, PaymentService) {
					return PaymentService.assessOrderReviewRouteForPartialPayments();
				},
				hideSpinner: function(assessRoute, $rootScope) {
					$rootScope.hideSpinner();
				}
			}
		})
		.state('/orderLookup', {
			url: '/orderLookup',
			templateUrl: '/views/orderLookup.html',
			controller: 'OrderLookupCtrl',
			title: 'orderLookup',
			resolve: { initialData: initialData }
		})
		.state('/orderHistory', {
			url: '/orderHistory',
			templateUrl: '/views/orderHistory.html',
			controller: 'OrderLookupCtrl',
			title: 'orderLookup',
			resolve: { initialData: initialData }
		})
		.state('order-view-encrypted', {
			controller: 'TicketCtrl',
			dynamic: true,
			resolve: {
				initialData: initialData,
				// Baren.js needs to be loaded before barcode assets due to dependency
				loadBaren: function(initialData, Utilities) {
					return Utilities.cacheBustAndLazyLoad(BAREN_ASSETS)
				},
				load: function(loadBaren, Utilities) {
					return Utilities.cacheBustAndLazyLoad(BARCODE_ASSETS);
				},
				// Lazy loading portal routing modal CSS
				loadCSS: function(load, Utilities) {
					return Utilities.cacheBustAndLazyLoad(['scripts/modules/portals/portal-routing-modal/portal-routing-modal.css']);
				},
				loadPostPurchaseSignup: function(initialData, BundleService) {
					return BundleService.lazyLoadCollectionFiles(BundleService.enums.POST_PURCHASE_SIGNUP);
				},
				loadExternalAccountCard: function(initialData, BundleService) {
					return BundleService.lazyLoadCollectionFiles(BundleService.enums.EXTERNAL_ACCOUNT_CARD);
				},
				routeAccessement: function(loadCSS, OrderService, $state, $transition$) {
					var params = $transition$.params();
					return OrderService.accessTokenizedRoute(params.oToken, null, params.cToken, $state, $state.toParams);
				}
			},
			templateUrl: '/views/ticketSwitch.html',
			url: '/orderView/token/:oToken/:disableAltRoute/:cToken'
		})
		.state('seasonPassOptionRenewal', {
			abstract: true,
			url: '/seasonPassOptionRenewal/:packageId',
			templateUrl: '/views/extraFlow/seasonPassOptRenewal.html',
			controller: 'SeasonPassOptRenewalCtrl',
			resolve: {
				initialData: initialData,
				xfcMap: function(initialData, Package) {
					return Package.buildXFCMap();
				},
				seasonPassSetup: function(xfcMap, Seasonpass, $transition$) {
					return Seasonpass.init($transition$.params().packageId);
				}
			},
			onEnter: function($rootScope, Package) {
				if (angular.isUndefined(Package.packageDetails) || angular.isUndefined(Package.itemsToBeAdded)) {
					$rootScope.routeTo('/');
				}
			}
		})
		.state('seasonPassOptionRenewal.selection', {
			url: '',
			templateUrl: '/views/templates/seasonPassRenewalStep1.html',
			title: 'seasonPassOption'
		})
		.state('seasonPassOptionRenewal.renewalPassInformation', {
			url: '/renewalPassInformation',
			templateUrl: '/views/templates/seasonPassRenewalStep2.html',
			title: 'seasonPassRenewalInfo'
		})
		.state('seasonPassOptionRenewal.newPassInformation', {
			url: '/newPassInformation',
			templateUrl: '/views/templates/seasonPassRenewalStep2.html',
			title: 'seasonPassDemographics'
		})
		.state('/verification/:packageId', {
			url: '/verification/:packageId',
			templateUrl: '/views/extraFlow/verification.html',
			controller: 'VerificationCtrl',
			resolve: {
				initialData: initialData,
				assessRoute: function(initialData, $transition$, Verification) {
					return Verification.assessRoute($transition$.params('to'));
				},
				xfcMap: function(assessRoute, Package) {
					return Package.buildXFCMap();
				},
				customerTypeValidation: function(xfcMap, $transition$, Verification) {
					return Verification.isVerificationNecessary($transition$.params('to'));
				}
			}
		})
		.state('/verify-pass/:keyword', {
			url: '/verify-pass/:keyword',
			templateUrl: '/views/extraFlow/verification.html',
			controller: 'VerificationCtrl',
			resolve: {
				initialData: initialData,
				assessRoute: function(initialData, $transition$, Verification) {
					return Verification.assessRoute($transition$.params('to'));
				},
				customerTypeValidation: function(assessRoute, $transition$, Verification) {
					return Verification.isVerificationNecessary($transition$.params('to'));
				}
			}
		})
		.state('/seasonPass', {
			url: '/seasonPass',
			templateUrl: '/views/extraFlow/seasonPass.html',
			controller: '',
			resolve: {
				initialData: initialData,
				xfcMap: function(initialData, Package) {
					return Package.buildXFCMap();
				}
			}
		})
		.state('/seasonPass/:packageId', {
			url: '/seasonPass/:packageId',
			templateUrl: '/views/extraFlow/seasonPass.html',
			controller: 'SeasonPassController',
			resolve: {
				initialData: initialData,
				xfcMap: function(initialData, Package) {
					return Package.buildXFCMap();
				},
				seasonPassSetup: function(initialData, xfcMap, Seasonpass, $transition$) {
					return Seasonpass.init($transition$.params().packageId);
				}
			}
		})
		.state('/reset/:clearQueryString/:language', {
			url: '/reset/:clearQueryString/:language',
			templateUrl: '/views/errorView.html',
			controller: 'ResetController'
		})
		.state('/reset/:clearQueryString', {
			url: '/reset/:clearQueryString',
			templateUrl: '/views/errorView.html',
			controller: 'ResetController'
		})
		.state('/reset/:clearQueryString/:language/:cart_id/:cart_key/:session_id', {
			url: '/reset/:clearQueryString/:language/:cart_id/:cart_key/:session_id',
			templateUrl: '/views/errorView.html',
			controller: 'ResetController'
		})
		.state('/reset', {
			url: '/reset',
			templateUrl: '/views/errorView.html',
			controller: 'ResetController'
		})
		.state('close', {
			url: '/close',
			controller: 'CloseController'
		});

	/**
	 * This custom rule removes the trailing slash from any URL
	 */

	$urlRouterProvider.rule(function($injector, $location) {
		var path = $location.url();
		if (path.indexOf('/') === -1) {
			return '/' + path;
		}

		// check to see if the path already has a slash where it should be
		if (/.\/$/.test(path)) {
			return path.replace(/\/$/, '');
		}

		/**
		 * Removes slash before query params if path exists on url
		 * Will Match https://psc-seattle.secure.accesso.com/packageList/keyword/Admission%20Tickets/?_d=true
		 * Will NOT Match https://psc-seattle.secure.accesso.com/?_d=true
		 * @see https://regex101.com/r/hT5hAg/1 for Regex Explanation
		 */
		if (/^.+\/\?/.test(path)) {
			return path.replace('/?', '?');
		}

		return false;
	});

	/**
	 * If no state is matched, route to our page not found error page
	 */
	if (!inTestMode) {
		$urlServiceProvider.rules.otherwise('/error/1004');
	}

	/**
	 * ROUTE GUARD
	 * Loads Adyen assets
	 * @public
	 * @param {Service} AppData AppData
	 * @param {Service} JSONValidator JSONValidator
	 * @param {Service} Utilities Utilities
	 * @param {Service} CreditCardService CreditCardService
	 * @param {Service} PaymentMethodService PaymentMethodService
	 * @param {String[]} ADYEN_ASSETS Adyen assets
	 * @param {Service} $injector $injector
	 * @returns {Promise} A promise to load the assets
	 * @ngInject
	 */
	function loadAdyenAssets(AppData, JSONValidator, Utilities, CreditCardService, PaymentMethodService, ADYEN_ASSETS, $injector) {
		var hasAdyenPaymentMethods = PaymentMethodService.hasAdyenPaymentMethods();
		var accessoPayConfig = JSONValidator.validate('accesso_pay', AppData.settings.accesso_pay) ? JSON.parse(AppData.settings.accesso_pay) : {};
		if (accessoPayConfig.enable) {
			return;
		} else if (hasAdyenPaymentMethods || CreditCardService.hasAdyenCreditCards()) {
			return Utilities.cacheBustAndLazyLoad(ADYEN_ASSETS)
				.then(function() {
					if (hasAdyenPaymentMethods) {
						$injector.get('AdyenCheckoutAltPaymentsService').setupAltPayments();
					}
					$injector.get('AdyenCheckoutPrepService').loadAssets();
				});
		}
	}

	/**
	 * ROUTE GUARD
	 * Loads our cybersource services
	 * @public
	 * @param {Promise} initialData Bootstrap initialization process
	 * @param {Service} AppData AppData
	 * @param {Service} CartDataService CartDataService
	 * @param {Service} JSONValidator JSONValidator
	 * @param {Service} Utilities Utilities
	 * @param {string[]} CYBERSOURCE_CREDIT_CARD_ASSETS The cybersource credit card assets array to download
	 * @param {Service} PaymentMethodService PaymentMethodService
	 * @param {Service} $injector $injector
	 * @returns {Promise} A promise to load the assets
	 * @ngInject
	 */
	function loadCyberSourceAssets(initialData, AppData, CartDataService, JSONValidator, Utilities, CYBERSOURCE_CREDIT_CARD_ASSETS, PaymentMethodService, $injector) {
		var accessoPayConfig = JSONValidator.validate('accesso_pay', AppData.settings.accesso_pay) ? JSON.parse(AppData.settings.accesso_pay) : {};
		if (accessoPayConfig.enable) {
			return;
		}

		return Utilities.cacheBustAndLazyLoad(CYBERSOURCE_CREDIT_CARD_ASSETS)
			.then(function() {
				var CYBSAltPaymentsPrepService;
				if (PaymentMethodService.hasCybersourcePaymentMethods()) {
					CYBSAltPaymentsPrepService = $injector.get('CYBSAltPaymentsPrepService');
					CYBSAltPaymentsPrepService.setupAltPayments();
				}
			});
	}

	/**
	 * ROUTE GUARD
	 * Loads our google pay services
	 * @public
	 * @param {Promise} loadCyberSourceAssets loadCyberSourceAssets
	 * @param {Service} Utilities Utilities
	 * @param {Service} CreditCardService CreditCardService
	 * @param {string[]} GOOGLE_PAY_ASSETS The google pay assets array to download
	 * @returns {Promise} A promise to load the assets
	 * @ngInject
	 */
	function loadGooglePayAssets(loadCyberSourceAssets, Utilities, CreditCardService, GOOGLE_PAY_ASSETS) {
		if (CreditCardService.hasGooglePay()) {
			return Utilities.cacheBustAndLazyLoad(['scripts/modules/external/polyfill/shadydom.min.js'].concat(GOOGLE_PAY_ASSETS));
		}
	}

	/**
	 * ROUTE GUARD
	 * Adds a route guard that verifies that recaptcha has been initialized and the user has gone through it.
	 * This guards against pages being refreshed and the RecaptchaService not being loaded as that means they never went through the page.
	 * @public
	 * @param {Prommise} initialData This is the Bootstrap promise.
	 * @param {Service} AppData AppData
	 * @param {Service} JSONValidator JSONValidator
	 * @param {Service} $injector $injector
	 * @param {Service} RouteRejectionService RouteRejectionService
	 * @returns {undefined}
	 * @throws {RouteRejectionService.UnrecoverableException} throws them back to cartView
	 * @ngInject
	 */
	function verifyRecaptcha(initialData, AppData, JSONValidator, $injector, RouteRejectionService) {
		if (JSONValidator.validate('recaptcha', AppData.settings.recaptcha) && !$injector.has('RecaptchaService')) {
			throw new RouteRejectionService.UnrecoverableException('/cartView');
		}
	}
	/**
	 * ROUTE GUARD
	 * Loads the bin ranges for the PAYMENTTYPE node in GetMerchantDetails
	 * @protected
	 * @param {Promise} initialData Bootstrap initialization process
	 * @param {Service} CreditCardBinRangesService To load the data
	 * @return {Promise} To resolve the bin ranges
	 * @ngInject
	 */
	function loadBinRanges(initialData, CreditCardBinRangesService) {
		return CreditCardBinRangesService.fetchBinRanges();
	}

	/**
	 * Redirect to cart if accessoPay is enabled
	 * @param {Promise} initialData Bootstrap initialization process
	 * @param {Service} AppData Our app data service
	 * @param {Service} CartDataService CartDataService
	 * @param {Service} RouteRejectionService RouteRejectionService
	 * @param {Service} Enums Enums
	 * @param {Service} JSONValidator JSONValidator
	 * @param {Service} UserInfo UserInfo
	 * @param {Service} Utilities Utilities
	 * @throws {UnrecoverableException} if accessoPay is enabled
	 * @returns {undefined}
	 * @ngInject
	 */
	function redirectToCartForAccessoPay(initialData, AppData, CartDataService, RouteRejectionService, Enums, JSONValidator, UserInfo, Utilities) {
		var accessoPayConfig = JSONValidator.validate('accesso_pay', AppData.settings.accesso_pay) ? JSON.parse(AppData.settings.accesso_pay) : {};
		var isResellerAuthType = Utilities.checkProp('payment.authType', (UserInfo.get('payment') || UserInfo.payment), function(authType) {
			return authType === Enums.authTypes.ACCOUNT;
		});
		// If accessoPay is enabled, we need to redirect to the cart page
		if (accessoPayConfig.enable && !isResellerAuthType) {
			throw new RouteRejectionService.UnrecoverableException(Enums.routes.CART);
		}
	}
	/**
	 * Redirect to accessoPay if accessoPay is enabled
	 * @param {Promise} initialData Bootstrap initialization process
	 * @param {Service} AppData Our app data service
	 * @param {Service} CartDataService CartDataService
	 * @param {Service} RouteRejectionService RouteRejectionService
	 * @param {Service} Enums Enums
	 * @param {Service} JSONValidator JSONValidator
	 * @throws {UnrecoverableException} if accessoPay is enabled
	 * @returns {undefined}
	 * @ngInject
	 */
	function redirectToAccessoPay(initialData, AppData, CartDataService, RouteRejectionService, Enums, JSONValidator) {
		var accessoPayConfig = JSONValidator.validate('accesso_pay', AppData.settings.accesso_pay) ? JSON.parse(AppData.settings.accesso_pay) : {};
		// If accessoPay is enabled, we need to redirect to the accessoPay page
		if (accessoPayConfig.enable) {
			throw new RouteRejectionService.UnrecoverableException(Enums.routes.ACCESSO_PAY);
		}
	}

	/**
	 * Load our bootstrap.
	 * @param {Service} Bootstrap Bootstrap
	 * @returns {Promise} to resolve our bootstrap process
	 * @ngInject
	 */
	function initialData(Bootstrap) {
		return Bootstrap.bootstrapApplication();
	}

	/**
	 * Load our bootstrap and continue showing spinner.
	 * @param {Service} Bootstrap Bootstrap
	 * @param {Scope} $rootScope $rootscope
	 * @returns {Promise} to resolve our bootstrap process
	 * @ngInject
	 */
	function initialDataWithSpinner(Bootstrap, $rootScope) {
		$rootScope.showSpinner();
		return Bootstrap.bootstrapApplication(undefined, true);
	}

	/**
	 * Checks if we need to route to agreements
	 * @param {Resolve} agreementData The resolve
	 * @param {Service} AgreementService Agreement service
	 * @returns {Promise} To check if we need to route the user to the correct agreement page
	 * @ngInject
	 */
	function loadAgreements(agreementData, AgreementService) {
		return AgreementService.routeGuard();
	}
}

/**
 * # Application Init
 *
 * Core application controller that includes all services needed to
 * kick-start the application.
 */
angular.module('app').run(
	function(
		$document,
		$injector,
		$location,
		$log,
		$q,
		$rootScope,
		$state,
		$stateParams,
		$timeout,
		$transitions,
		$uibModal,
		$window,
		AppData,
		AltRoutingService,
		errorTracking,
		CartDataService,
		ClientInfo,
		ComponentLoaderService,
		DynamicToolbarOverridesService,
		FocusService,
		GuestAppUiService,
		RouteRejectionService,
		Enums,
		Idle,
		Language,
		Logging,
		Modal,
		PageBackgroundService,
		ProfileLoginSessionService,
		Storage,
		FolioService,
		Utilities,
		IdleTimeout,
		UtilsValidation,
		UtilityFunctions,
		Viewport
	) {
		var debugEnabled = window.accessoDebugMode || $location.$$host === 'server',
			checkProp = Utilities.safelyCheckPropertyOnObject,
			isRealObject = UtilsValidation.isRealObject;

		$rootScope.isBrandMode = $location.search().brandmode === 'true';
		$rootScope.brandmodeNavEnabled = $rootScope.isBrandMode && $location.search().brandmodenav === 'true';
		$rootScope.headlessMode = Utilities.getBoolean($location.search()[Enums.urlParameters.headless]);

		// Begin ng-idle timeout watching
		Idle.watch();

		angular.element($window).bind('focus', IdleTimeout.assessLastActiveState);

		angular.element($window).bind('blur', IdleTimeout.setLastActiveToken);
		//turn off splash screen for orderView route
		RouteRejectionService.setSplashScreenOffForRoute('orderView');

		// Do not remove.
		// Initializes the template service which adds any templates defined in it.
		var _showedSplash = false;
		var validString = UtilsValidation.validString;



		/**
		 * This is for Google Optimize to work in a SPA. Code provided by Google
		 * @see {link=https://support.google.com/optimize/answer/7008840?hl=en}
		 */
		if ($rootScope.isBrandMode) {
			var lastResizeHeight = 0;
			// We need to send updates to the parent accesso.js so it can update the height of the iframe
			new ResizeObserver(function onHeightChanged(entries) {
				var event = entries[0];
				var height = event.contentRect.height;

				if (height === lastResizeHeight) {
					return;
				}

				lastResizeHeight = height;

				$window.parent.postMessage(JSON.stringify({
					height: height,
					messageType: Enums.messages.UPDATE_BRANDMODE_HEIGHT
				}), '*');
			}).observe(document.body);

			$window.addEventListener('message', UtilityFunctions.createEvent(function onReceiveMessage(event) {
				var msg;
				if (event.data) {
					try {
						msg = JSON.parse(event.data);
						if (msg.messageType === Enums.messages.BRANDMODE_ROUTING && validString(msg.routePath)) {
							Utilities.routeTo(msg.routePath);
						}
					} catch (ignore) { /* ignore */ }
				}
			}));
		}

		$rootScope.updateRadioStates = GuestAppUiService.updateRadioStates;

		$rootScope.encodeAsset = function(str) {
			str = encodeURIComponent(str);
			return str.replace(/%2F/g, '/');
		};

		$rootScope.getAssetUrl = function(str) {
			if (!validString(str)) {
				return $rootScope.customPlaceholder || '';
			}
			return $rootScope.assetsPath + $rootScope.encodeAsset(str);
		};

		$rootScope.setNoScroll = function(val) {
			if ($rootScope.isBrandMode) {
				return;
			}

			$rootScope.applicationNoScroll = !!val;
		}

		$rootScope.hasNavigation = true;
		$rootScope.pendingRequests = [];
		$rootScope.i18n = Language;
		$rootScope.viewport = Viewport.api;
		$rootScope.merchantFolder = Utilities.getMerchant();
		$rootScope.modalOpen = false;
		$rootScope.forceShowSpinner = false;
		// PEC perceived-load prototype: selects which skeleton layout loader.html renders
		// while showSkeletonLoader is on. Initialized from the landing route detected by
		// index.html (window.accesso.SKELETON_VARIANT) so a hard refresh shows the right
		// skeleton with no store->cart flash. Modules then own it across in-app navigation
		// (e.g. the cart sets 'cart' on enter and resets on exit — see cart-module.js).
		// Gated entirely by ?skeleton.
		$rootScope.skeletonVariant = (window.accesso && window.accesso.SKELETON_VARIANT) || 'store';
		/**
		 * A toolbar override that can at any state that is configured with an override of the menu items, can override
		 * what displays within both the desktop and mobile menus
		 * @type {undefined}
		 */
		$rootScope.toolbarOverride = undefined;

		$rootScope.develop = debugEnabled || ($location.$$search._d && Utilities.getBoolean($location.$$search._d));
		$rootScope.autofill = (debugEnabled && angular.isUndefined($location.$$search._a)) || ($location.$$search._a && Utilities.getBoolean($location.$$search._a));

		if ($rootScope.develop) {
			$transitions.onError({}, function(trans) {
				var error = trans.error();
				$log.debug('TRANSITION ERROR OCCURED ON: ' + checkProp('trans.router.locationService.$location.$$absUrl', trans, Utilities.returnValue));
				if (checkProp('error.detail.redirect', error)) {
					$log.debug('(->)', 'Transition has been aborted and is redirected')
				}
			});
			$rootScope.$on('$stateNotFound', function(event, unfoundState, fromState, fromParams) {
				$log.info('STATE NOT FOUND:  '+unfoundState.to+'  - fired when a state cannot be found by its name.');
				$log.info(unfoundState, fromState, fromParams);
			});
		}

		Logging.enabled = $rootScope.develop;
		$rootScope.developMenu = $rootScope.develop;
		$rootScope.errorData = {};

		$rootScope.routeParams = $stateParams;

		//Moving all of these out of rootscope. If you run into any undefined errors unexpectedly,
		// uncomment these to see if it fixes.

		$rootScope.pendingRequests = [];
		$rootScope.merchantFolder = Utilities.getMerchant();

		$rootScope.clientInfo = ClientInfo;
		$rootScope.parkName = '';
		$rootScope.parkLogo = '';
		$rootScope.assetsPath = '';
		$rootScope.currencyCode = '';
		$rootScope.displayAccessoBranding = true;
		$rootScope.displayKnowledgeBase = true;
		$rootScope.displayPromoCode = true;
		$rootScope.theme = {};


		//Check for the buy-now route only for now
		// maybe we open this up for clients to take advantage of passing text to this experience instead of our spinner
		if ($location.path().startsWith('/buy-now')) {
			$log.info('Buy Now detected, disabling initial loader and spinner');
			$rootScope.suppressInitialLoader = true;
			$rootScope.disableSpinner = true;
			if (!$rootScope.$$phase) {
					$rootScope.$apply();
			}
		} else {
			$rootScope.suppressInitialLoader = false;
		}
		// PEC perceived-load prototype: keep the data-less skeleton (set via ?skeleton=1
		// in index.html) visible through the bootstrap data wait instead of the spinner bar.
		$rootScope.showSkeletonLoader = !!(window.accesso && window.accesso.SHOW_SKELETON);
		$rootScope.state = {};
		$rootScope.state.loaded = false;
		$rootScope.configuredForLogin = false;
		$rootScope.configuredForPassportAuth = false;
		$rootScope.disableCreateAccountOnGlobalLogin = false;
		$rootScope.state.showMainMenu = false;
		$rootScope.state.showCrossSells = true;
		$rootScope.state.cart = CartDataService.api;
		$rootScope.state.loadingMessage;
		$rootScope.state.debugMenu = false;
		$rootScope.state.loadingEllipse = '';
		$rootScope.state.parkName = '';
		$rootScope.state.parkNameTitleTag = '';
		$rootScope.state.parkLogo = '';
		$rootScope.state.parkAlias = $rootScope.merchantFolder;

		FolioService.bootStrap();

		$rootScope.removePendingRequest = function(name) {
			for (var i = 0; i < $rootScope.pendingRequests.length; i++) {
				if ($rootScope.pendingRequests[i] == name) {
					$rootScope.pendingRequests.splice(i, 1);
					break;
				}
			}
		};

		/**
		 * Returns the icon to use for the login
		 * @returns {String} The gap-iconography person icon
		 */
		$rootScope.getLoginIcon = function() {
			// Check both ProfileLoginSessionService and OIDC authentication
			var isLoggedIn = ProfileLoginSessionService.isLoggedIn();
			var AuthService;

			// If using passport auth (OIDC), also check AuthService
			if ($rootScope.configuredForPassportAuth) {
				try {
					// Inject AuthService to check OIDC authentication status
					AuthService = $injector.get('AuthService');
					isLoggedIn = isLoggedIn || AuthService.isAuthenticated();
				} catch (e) {
					// If AuthService is not available, fall back to ProfileLoginSessionService
				}
			}

			return 'person-' + (isLoggedIn ? 'solid' : 'outline');
		};

		/**
		 * Returns the cart icon we should use
		 * @returns {String} The gap-iconography cart icon
		 */
		$rootScope.getCartIcon = function () {
			return 'shopping-cart-outline';
		}

		/**
		 * Returns if the request is in pending requests
		 * @public
		 * @param {String} name request name
		 * @returns {Boolean} true if pending request exists
		 */
		$rootScope.hasPendingRequest = function(name) {
			if (!UtilsValidation.validArray($rootScope.pendingRequests)) {
				return false;
			}
			return $rootScope.pendingRequests.some(function findPendingRequest(reqName) {
				return reqName === name;
			});
		};

		/**
		 * Show the spinner
		 * @param message
		 * @param optional - keepStateLoaded - this allows the state.loaded variable to remain true so that the main content behind spinner
		 * is not set to display:none via ngshow
		 * This comes in handy for events that need to access placement of elements on the screen in order to obtain coordinates (drawing of canvases etc)
		 * (This ensures that convenience methods such as element.getBoundingRect work properly)
		 *
		 */
		$rootScope.showSpinner = function(message, keepStateLoaded, ignoreScrollTo) {
			if ($rootScope.disableSpinner) {
				return;
			}

			if ($rootScope.offline) {
				// Overwrite message if it's offline. This will keep any other showSpinner function calls
				// from overwritting the offline message.
				$rootScope.state.loadingMessage = $rootScope.offlineMessage;
			} else if (angular.isDefined(message)) {
				$rootScope.state.loadingMessage = message;
			}

			if (!$rootScope.state.loaded) {
				return
			}

			// Shows dots under the loading message.
			$rootScope.loadingEllipseTimer = function() {
				$rootScope.state.loadingEllipse += '.'
				if (typeof $rootScope.state.loadingMessage != 'undefined') {
					if ($rootScope.state.loadingEllipse.length >= $rootScope.state.loadingMessage.length + 1) {
						$rootScope.state.loadingEllipse = ''
					}
				}
				if ($rootScope.loadingEllipseTimer) {
					loadingEllipseTimer = $timeout($rootScope.loadingEllipseTimer, 100)
				}
			}

			loadingEllipseTimer = $timeout($rootScope.loadingEllipseTimer, 100);

			if (!keepStateLoaded) {
				$rootScope.state.loaded = false;
			} else {
				$rootScope.forceShowSpinner = true;
			}

			try {
				if (!$rootScope.$$phase) {
					$rootScope.$apply()
				}
			} catch (e) {}

			if (!ignoreScrollTo) {
				$window.scrollTo(0, 0)
			}
		}

		$rootScope.setSpinnerMessage = function(message) {
			$rootScope.state.loadingMessage = message;
		}

		$rootScope.hideSpinner = function() {
			if ($rootScope.offline) {
				return;
			}

			$rootScope.state.loaded = true;
			$rootScope.forceShowSpinner = false;
			$rootScope.loadingEllipseTimer = null;
			$rootScope.state.loadingEllipse = '';
			$rootScope.state.loadingMessage = '';

			try {
				if (!$rootScope.$$phase) {
					$rootScope.$apply()
				}
			} catch (e) {}
		}

		/**
		 * Global function for determining if the user has anything is in her cart.
		 * If there are no items in her cart the Cart Empty modal will be displayed.
		 *
		 * @return {boolean} Returns true if there are items in the cart; false if not.
		 */
		$rootScope.hasItemsInCart = function() {
			var hasItems = false;

			if (Utilities.childDefined(AppData, 'GetCartSummary.CART.ITEMS.ITEM')) {
				hasItems = AppData.GetCartSummary.CART.ITEMS.ITEM.length > 0;
			} else {
				hasItems = CartDataService.api.totalQty > 0;
			}

			if (!hasItems && !$rootScope.modalOpen) {
				// Nothing in the cart. Alert user.
				Modal.displayModal(
					{
						category: 'Cart [hasItemsInCart]',
						label: 'Cart Empty',
						title: Language.getLocale('Alert', 'noItemsTitle'),
						icon: 'icon-cartmodal blue',
						description: Language.getLocale('Alert', 'cartEmptyMsg'),
						buttonFlags: [Enums.buttonFlags.CONTINUE_SHOPPING]
					}
				);
			}

			return hasItems;
		};

		$rootScope.routeURL = function(menuLink) {
			$rootScope.$broadcast('triggerSocialMediaClick', menuLink);
			window.open(menuLink.url, '_blank');
		}

		/**
		 * Run's wrapper of routeTo
		 * @see app/scripts/services/utilities.js Utilities.routeTo
		 * @param {String} page - The page to route to
		 * @param {String} menu -
		 * @param {String} search -
		 * @param {Boolean} shouldReplaceRoute -
		 * @param {Boolean} useTimeout - If the function should use a timeout on the routeTo call (to prevent transition collision)
		 * @param {Boolean} [disableScrollTo] Disables scrolling to the top of the page
		 * @returns {undefined}
		 */
		$rootScope.routeTo = function(page, menu, search, shouldReplaceRoute, useTimeout, disableScrollTo) {
			switch (page) {
			case Enums.routes.KNOWLEDGEBASE:
			case Enums.routes.ORDER_HISTORY:
			case Enums.routes.ORDER_SEARCH:
			case Enums.routes.ORDER_REVIEW:
			case Enums.routes.CROSS_SELLS:
			case Enums.routes.ORDER_VIEW:
			case Enums.routes.SHIPPING:
			case Enums.routes.BILLING:
			case Enums.routes.RESELLER_BILLING:
			case Enums.routes.PAYMENT:
			case Enums.routes.REVIEW:
			case Enums.routes.TICKET:
			case Enums.routes.INFO:
				resetMenuItems();
				break;
			case Enums.routes.CART:
				if ($rootScope.hasItemsInCart()) {
					resetMenuItems();
				}
				break;
			default:
				break;
			}

			if (useTimeout) {
				$timeout(function() {
					Utilities.routeTo(page, menu, search, undefined, shouldReplaceRoute, disableScrollTo);
				}, 0);
			} else {
				Utilities.routeTo(page, menu, search, undefined, shouldReplaceRoute, disableScrollTo);
			}
		};

		$rootScope.hasRegion = function(countryCode) {
			if (angular.isDefined(AppData.regions[countryCode])) {
				return true;
			}
			return false;
		};

		$rootScope.countryRequiresAZipCode = function(country) {
			var matchingCountryIndex = -1;

			if (angular.isDefined(AppData.settings.optional_postal_code_countries)) {
				matchingCountryIndex = AppData.settings.optional_postal_code_countries.indexOf(country);
			}
			return matchingCountryIndex <= -1;
		};

		/**
		 * Sets the min-height for the body element
		 * Brand Mode only
		 * @param {Number} minHeight - The minimum height to set
		 * @returns {undefined}
		 */
		$rootScope.setMinHeight = function setMinHeight(minHeight) {
			// If not brand mode
			if (!$rootScope.isBrandMode) {
				// Ignore
				return;
			}

			// Set the css variable to the document element
			$document[0].documentElement.style.setProperty('--body-min-height', (minHeight || 0) + 'px');
		}

		function resetMenuItems() {
			for (var i in AppData.menuItems) {
				AppData.menuItems[i].selected = false

				if (AppData.menuItems[i].MENUITEM && AppData.menuItems[i].MENUITEM.length > 0) {
					for (var m in AppData.menuItems[i].MENUITEM) {
						AppData.menuItems[i].MENUITEM[m].selected = false
					}
				}
			}
		}

		/**
		 * ## Global modal view handler.
		 *
		 * showModal receives option object that specifies behavior.
		 *
		 * Examples:
		 *
		 * $rootScope.$broadcast(enums.send, somestring)
		 * $rootScope.$broadcast(enums.send, {'somekey':'somevalue'})
		 *
		 */
		function swapParkTitle() {
			$rootScope.state.parkName = $rootScope.parkName;
			// The following three versions are added to ensure we catch any variation of it.
			$rootScope.state.parkNameTitleTag = $rootScope.parkName
				.split('<br>').join('')
				.split('<br/>').join('')
				.split('<br />').join('');

			if (typeof $rootScope.parkLogo == 'string' && $rootScope.parkLogo != '') {
				$rootScope.state.parkLogo = $rootScope.parkLogo;
			} else {
				$rootScope.state.parkLogo = '';
			}

			$rootScope.state.parkLogo = $rootScope.parkLogo
		}


		$transitions.onBefore({}, function(trans) {
			// Reset per-transition spinner ownership flag.
			$rootScope._skipNextOnSuccessHideSpinner = false;

			// Clears out background image
			if ($rootScope.bgImageUrl) {
				$rootScope.bgImageUrl = '';
				$rootScope.stretchBG = false;
			}
		});

		// Setup our transition hook that will execute even before the transition starts
		$transitions.onBefore({
			to: function hasComponents(state) {
				return ComponentLoaderService.hasComponents(state);
			}
		}, function onBefore(trans) {
				var state = trans.to();
				var deferred;

			// If ALL the components in the list have already been laoded
			if (ComponentLoaderService.areComponentsLoaded(ComponentLoaderService.getComponents(state))) {
				// Resolve and pass through
				return $q.resolve();
			}

			// Assign a deferred $q objected
			deferred = $q.defer();

			// Show spinner while assets load so the user isn't left with no feedback during this phase.
			$rootScope.showSpinner();

			// Load the component assets based upon the state
			ComponentLoaderService.loadComponentAssets(state).finally(function onFinally() {
				// Fixes an issue where the store loads but a blank module is loaded. Aborting and reinitializing the state solves the issue.

				// Flag tells onError not to hideSpinner — the re-initiated goTo will continue showing it.
				$rootScope._skipNextHideSpinner = true;
				trans.abort();
				Utilities.goTo(state.name, trans.params());

				// Resolve the deferred
				deferred.resolve();
			});

			// Return a promise that will resolve when the components are loaded
			return deferred.promise;
		});

		$transitions.onStart({}, function(trans) {
			var toParams = trans.params('to');

			if (angular.isUndefined(toParams.disableAltRoute) || !Utilities.getBoolean(toParams.disableAltRoute)) {
				var altRoute = AltRoutingService.getAltRoute(trans.to().name);
				if (angular.isDefined(altRoute)) {
					trans.abort();
					$rootScope.routeTo(altRoute, undefined, undefined, undefined, true);
					return false;
				}
			}
		});

		$transitions.onSuccess({}, function(trans) {
			$window.parent.postMessage(JSON.stringify({ messageType: 'accesso:didRoute' }), '*');

			PageBackgroundService.applyFromState(trans.to());

			if (!$rootScope._skipNextOnSuccessHideSpinner) {
				$rootScope.hideSpinner();
			}

			var toolbarOverride = DynamicToolbarOverridesService.getToolbarOverride(trans.to().name);

			if (angular.isDefined(toolbarOverride)) {
				$rootScope.toolbarOverride = angular.copy(toolbarOverride);
			} else {
				$rootScope.toolbarOverride = undefined;
			}

			if (!validString($rootScope.state.parkName)) {
				$rootScope.state.parkName = $rootScope.parkName;
			}

			if (!validString($rootScope.state.parkLogo)) {
				$rootScope.state.parkLogo = $rootScope.parkLogo;
			}

			if (!validString($rootScope.language)) {
				$rootScope.language = AppData.language;
			}
			swapParkTitle('view');
			createPageTitle();

			// Reset the minimum height
			$rootScope.setMinHeight(0);

			$rootScope.hasNavigation = !$rootScope.isBrandMode
			|| ($rootScope.isBrandMode
				&& $rootScope.brandmodeNavEnabled)
				&& (!$rootScope.toolbarOverride || !$rootScope.toolbarOverride.hide_toolbar);
		});

		function createPageTitle() {
			$rootScope.state.pageTitle = '';

			if (angular.isDefined($state.current.title)) {
				$rootScope.state.pageTitle = Language.getLocale('pageTitle', $state.current.title);
			} else if ($rootScope.develop) {
				$log.debug('No title defined for state: ' + $state.current.name + ' please add the "title" property in the respective route config.');
			}
		}

		$transitions.onSuccess({}, function removeTe2SessionToken() {
			var queryParams = $location.search();
			if (queryParams.te2_session) {
				delete queryParams.te2_session;

				$location.replace();
				$location.search(queryParams);
			}
		});


		$transitions.onError({}, function(trans) {
			// TODO better flesh out errors and cases here
			// rejection will be set to the contents of defer.reject()
			// This enables us to supply an error message and localize/route
			// accordingly
			var transitionError = trans.error();
			var error = transitionError.detail;

			// Superseded: the replacing transition manages the spinner.
			if (transitionError.type === Enums.transitionRejectionType.SUPERSEDED) {
				$rootScope._skipNextHideSpinner = false;  // prevent flag leakage
				$log.log('Transition superceeded');
				return;
			}

			// _skipNextHideSpinner: set by onBefore when aborting to lazy-load assets — the
			// spinner should stay visible since the route is immediately re-entered.
			if ($rootScope._skipNextHideSpinner) {
				$rootScope._skipNextHideSpinner = false;
			} else if (!error || !error.skipHideSpinner) {
				// Don't hide the spinner when an UnrecoverableException is about to redirect immediately.
				// Hiding here causes a visible flash of the previous view; the destination's onSuccess will dismiss it.
				if (!checkProp('error.redirect', error) || checkProp('error.forceModal', error)) {
					$rootScope.hideSpinner();
				}
			}

			if (transitionError.type === Enums.transitionRejectionType.ABORTED) {
				$log.log('Transition aborted');
				return;
			} else if (transitionError.type === Enums.transitionRejectionType.IGNORED) {
				$log.log('Transition ignored');
				return;
			}

			$log.error(trans.error());

			if (error && angular.isDefined(error.callback)) {
				trans.abort();
				error.callback();
			} else if (error && error.redirect && angular.isUndefined(error.forceModal)) {
				trans.abort();
				if (angular.isDefined(error.args)) {
					$rootScope.routeTo($state.href(error.redirect, error.args), undefined, undefined, true, true);
				} else {
					$rootScope.routeTo(error.redirect, undefined, undefined, true, true);
				}
			} else {
				$rootScope.hideSpinner();
				$rootScope.disableSpinner = false;

				// Set up the title and description
				var title,
					description;

				if (isRealObject(error) && error.title) {
					title = error.title;
				} else {
					var localeTitle = Language.getLocale('Alert', 'viewErrorTitle');
					title = localeTitle.length > 0 ? localeTitle : 'View Error';
				}

				if (isRealObject(error) && error.description) {
					description = error.description;
				} else {
					var localeDescription = Language.getLocale('Alert', 'viewErrorMsg');
					description = localeDescription.length > 0 ? localeDescription : 'Unable to load data required for view';
				}

				Modal.displayModal({
					label: 'Error',
					title: title,
					description: description,
					showCloseButton: false,
					callback: function() {
						//support the ability to pass in a direct path route rather than a state name and params
						if (isRealObject(error) && error.redirect) {
							if (angular.isDefined(error.args)) {
								$rootScope.routeTo($state.href(error.redirect, error.args));
							} else {
								$rootScope.routeTo(error.redirect);
							}
						} else {
							Utilities.routeTo();
						}
					}
				});
			}
		}
		)

		$rootScope.$on
		(
			Enums.services.APP_ACTIVATED,
			function(event, data) {
				if (data.status) {
					// setup errorTracking
					errorTracking.initialize(AppData);

					if (shouldShowSplashscreen()) {
						// Run once.
						_showedSplash = true;
						// Save to local storage.
						Storage.set('showedSplash', true);

						$rootScope.modalOpen = true;

						$uibModal.open({
							templateUrl: '/views/modals/splashScreen.html',
							controller: 'SplashscreenCtrl',
							windowClass: 'splash-screen-modal'
						}).closed.then(function onCloseSplashScreen() {
							FocusService.resetState();
						});
					}
				}
			}
		);

		/*
			Could be coded more succintly, but I like this because we can short circuit without needing to check all cases.
		 */
		/**
		 * Checks whether or not to show splash screen
		 * @protected
		 * @returns {Boolean} true/ false
		 */
		function shouldShowSplashscreen() {
			// Short circut if not configured
			var showSplashScreen = Utilities.getBoolean(AppData.settings.show_splash_screen);
			if (!showSplashScreen) {
				return false;
			}

			// Short circut if already shown
			var alreadyShown = _showedSplash || Storage.get('showedSplash');
			if (alreadyShown) {
				return false;
			}

			// Short circuit if route isn't valid
			var isValidRoute = isSplashscreenBlockedForRoute($location.path());
			if (isValidRoute) {
				return false;
			}

			// Valid state to show splashscreen
			return true;
		}

		/**
		 * Checks whether the path is present in list of blocked routes for splash screen
		 * @protected
		 * @param {String} path path
		 * @returns {Boolean} true/ false
		 */
		function isSplashscreenBlockedForRoute(path) {
			return RouteRejectionService.getSplashScreenTurnedOffRoutes().some(function(route) {
				return path.indexOf(route) !== -1;
			});
		}
	}
);



Element.prototype.remove = function() {
	this.parentElement.removeChild(this);
}

NodeList.prototype.remove = HTMLCollection.prototype.remove = function() {
	for (var i = 0, len = this.length; i < len; i++) {
		if (this[i] && this[i].parentElement) {
			this[i].parentElement.removeChild(this[i]);
		}
	}
}

if (!Object.values) {
	Object.values = function(obj) {
		if (obj === null || typeof obj === 'undefined') {
			return [];
		}

		return Object
			.keys(obj)
			.map(function(key) {
				return obj[key];
			});
	};
}

/**
 * Objectt.entries polyfill
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/entries#polyfill}
 * @returns {*[]} Collection of values from the object
 */
if (!Object.entries) {
	Object.entries = function(obj){
	  var ownProps = Object.keys(obj),
		  i = ownProps.length,
		  resArray = new Array(i); // preallocate the Array
	  while (i--)
		resArray[i] = [ownProps[i], obj[ownProps[i]]];

	  return resArray;
	};
  }

Object.defineProperty(Array.prototype, 'remove', {
	enumerable: false,
	value: function(from, to) {
		var rest = this.slice((to || from) + 1 || this.length);
		this.length = from < 0 ? this.length + from : from;
		return this.push.apply(this, rest);
	}
});

/**
 * toCamelCase
 * @return {[type]}       [description]
 */
if ('function' !== typeof String.prototype.toCamelCase) {
	String.prototype.toCamelCase = function() {
		'use strict';
		if (null === this || 'undefined' === typeof this) {
			throw new TypeError(
				'String.prototype.toCamelCase called on null or undefined');
		}

		if ('string' !== typeof this) {
			throw new TypeError(
				'Input object is not a String');
		}

		return this.toLowerCase().replace(/(\_|\-)+([a-z])/g, function(p1, p2, p3) {
			return p3.toUpperCase()
		});
	}
}

// https://tc39.github.io/ecma262/#sec-array.prototype.find
if (!Array.prototype.find) {
	Object.defineProperty(Array.prototype, 'find', {
		value: function(predicate) {
			// 1. Let O be ? ToObject(this value).
			if (this == null) {
				throw new TypeError('"this" is null or not defined');
			}

			var o = Object(this);

			// 2. Let len be ? ToLength(? Get(O, "length")).
			var len = o.length >>> 0;

			// 3. If IsCallable(predicate) is false, throw a TypeError exception.
			if (typeof predicate !== 'function') {
				throw new TypeError('predicate must be a function');
			}

			// 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
			var thisArg = arguments[1];

			// 5. Let k be 0.
			var k = 0;

			// 6. Repeat, while k < len
			while (k < len) {
				// a. Let Pk be ! ToString(k).
				// b. Let kValue be ? Get(O, Pk).
				// c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
				// d. If testResult is true, return kValue.
				var kValue = o[k];
				if (predicate.call(thisArg, kValue, k, o)) {
					return kValue;
				}
				// e. Increase k by 1.
				k++;
			}

			// 7. Return undefined.
			return undefined;
		},
		configurable: true,
		writable: true
	});
}

// https://tc39.github.io/ecma262/#sec-array.prototype.findIndex
if (!Array.prototype.findIndex) {
	Object.defineProperty(Array.prototype, 'findIndex', {
		value: function(predicate) {
		// 1. Let O be ? ToObject(this value).
			if (this == null) {
				throw new TypeError('"this" is null or not defined');
			}

			var o = Object(this);

			// 2. Let len be ? ToLength(? Get(O, "length")).
			var len = o.length >>> 0;

			// 3. If IsCallable(predicate) is false, throw a TypeError exception.
			if (typeof predicate !== 'function') {
				throw new TypeError('predicate must be a function');
			}

			// 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
			var thisArg = arguments[1];

			// 5. Let k be 0.
			var k = 0;

			// 6. Repeat, while k < len
			while (k < len) {
				// a. Let Pk be ! ToString(k).
				// b. Let kValue be ? Get(O, Pk).
				// c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
				// d. If testResult is true, return k.
				var kValue = o[k];
				if (predicate.call(thisArg, kValue, k, o)) {
					return k;
				}
				// e. Increase k by 1.
				k++;
			}

			// 7. Return -1.
			return -1;
		},
		configurable: true,
		writable: true
	});
}

/**
 * Array.prototype.flat()
 * Feature	        Chrome  Firefox Internet Explorer   Opera	Safari	Edge
 * Basic support	  69      62      (No)    	          56    12      (No)
 * -------------------------------------------------------------------------------
 */
 if (!Array.prototype.flat) {
	Object.defineProperty(Array.prototype, 'flat', {
	  configurable: true,
	  writable: true,
	  value: function () {
		var depth =
		  typeof arguments[0] === 'undefined' ? 1 : Number(arguments[0]) || 0;
		var result = [];
		var forEach = result.forEach;

		var flatDeep = function (arr, depth) {
		  forEach.call(arr, function (val) {
			if (depth > 0 && Array.isArray(val)) {
			  flatDeep(val, depth - 1);
			} else {
			  result.push(val);
			}
		  });
		};

		flatDeep(this, depth);
		return result;
	  },
	});
  }

/**
 * Array.includes polyfill
 * @see https://caniuse.com/#feat=array-includes
 * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/includes
 * @see https://github.com/kevlatus/polyfill-array-includes
 */
if (!Array.prototype.includes) {
	Object.defineProperty(Array.prototype, 'includes', {
	  value: function(searchElement, fromIndex) {
		// 1. Let O be ? ToObject(this value).
			if (this == null) {
		  throw new TypeError('"this" is null or not defined');
			}

			var o = Object(this);

			// 2. Let len be ? ToLength(? Get(O, "length")).
			var len = o.length >>> 0;

			// 3. If len is 0, return false.
			if (len === 0) {
		  return false;
			}

			// 4. Let n be ? ToInteger(fromIndex).
			//    (If fromIndex is undefined, this step produces the value 0.)
			var n = fromIndex | 0;

			// 5. If n ≥ 0, then
			//  a. Let k be n.
			// 6. Else n < 0,
			//  a. Let k be len + n.
			//  b. If k < 0, let k be 0.
			var k = Math.max(n >= 0 ? n : len - Math.abs(n), 0);

			function sameValueZero(x, y) {
		  return x === y || (typeof x === 'number' && typeof y === 'number' && isNaN(x) && isNaN(y));
			}

			// 7. Repeat, while k < len
			while (k < len) {
		  // a. Let elementK be the result of ? Get(O, ! ToString(k)).
		  // b. If SameValueZero(searchElement, elementK) is true, return true.
		  // c. Increase k by 1.
		  if (sameValueZero(o[k], searchElement)) {
					return true;
		  }
		  k++;
			}

			// 8. Return false
			return false;
	  }
	});
}

(function() {
	'use strict';

	angular.module('errorTracking', []);
}());

(function() {
	'use strict';

	angular
		.module('errorTracking')
		.factory('errorTracking', ErrorTracking);

	/**
	 * Our error tracking service (Coralogix RUM).
	 * @param {Service} $injector $injector
	 * @param {Window} $window $window
	 * @param {Service} UtilsValidation UtilsValidation
	 * @returns {self} our instance
	 * @ngInject
	 */
	function ErrorTracking($injector, $window, UtilsValidation) {
		var defaultMetaData = {},
			initialized = false;

		var service = {
			accessoPay: accessoPay,
			accessoPayStep: accessoPayStep,
			breadcrumb: breadcrumb,
			getDefaultMetaData: getDefaultMetaData,
			getLocation: getLocation,
			hasAccessoPayParams: hasAccessoPayParams,
			info: info,
			initialize: initialize,
			notify: notify,
			notifyException: notify,
			redactUrl: redactUrl,
			setDefaultMetaData: setDefaultMetaData
		};

		return service;

		/**
		 * Initialize Coralogix RUM.
		 * @public
		 * @param {Service} AppData The app data service otherwise we'll get circular dependencies
		 * @returns {undefined}
		 */
		function initialize(AppData) {
			if (initialized || !$window.CoralogixRum || AppData.environment !== 'production') {
				return;
			}

			service.setDefaultMetaData({
				details: {
					island: AppData.island,
					merchant: AppData.merchant,
					merchantId: AppData.merchantId
				}
			});

			if ($window.accessoRumEarlyInit) {
				// SDK was initialized before Angular to capture Web Vitals and sessions.
				// Only enrich with AppData labels here.
				$window.CoralogixRum.setLabels(service.getDefaultMetaData());
			} else {
				// Fallback: PHP early-init did not run (e.g. non-PHP test environment).
				$window.CoralogixRum.init({
					public_key: 'cxtp_pq8jnA7JbDJjptk1yEkaXUb8GgH3dP',
					application: 'ShoplandV6',
					version: $window.accessoShoplandVersion,
					coralogixDomain: 'US1',
					environment: AppData.environment,
					ignoreUrls: [
						// Any hostname containing "ecomm-api"
						/^(?:https?:)?\/\/[^/?#]*ecomm-api[^/?#]*(?:[/?#]|$)/i,
						// google.com and any subdomain, such as www.google.com
						/^(?:https?:)?\/\/(?:[^/?#]+\.)?google\.com(?::\d+)?(?:[/?#]|$)/i,
						// ad.doubleclick.net and any subdomain
						/^(?:https?:)?\/\/(?:[^/?#]+\.)?ad\.doubleclick\.net(?::\d+)?(?:[/?#]|$)/i,
						// Google Analytics & GTM — high-volume, no diagnostic value
						/googletagmanager\.com/,
						/google-analytics\.com/,
						/analytics\.google\.com/,
						// Font files — first-party assets; successful loads emit severity:3 resource events
						// by default in the SDK. Failures surface in visual QA, not RUM.
						/\.(ttf|woff2?|eot|otf)(\?|$)/,
						// Cloudflare RUM self-ping — CF's own monitoring endpoint, 404s when CF RUM is not
						// enabled for the zone; no diagnostic value for our application.
						/cdn-cgi\/rum/,
						// Instagram in-app WebView internal protocol — captured by XHR instrumentation
						// but is not a real network request; no diagnostic value.
						/^properties:\/\//,
						// Marketing/ad pixels — third-party resource errors with no diagnostic value
						/pixel/i,
						/analytics\.tiktok\.com/,
						/connect\.facebook\.net/,
						/facebook\.com\/tr/,
						/bat\.bing\.com/,
						/pixel\.quantserve\.com/,
						/secure\.quantserve\.com/,
						/pixeleze\.com/,
						/googleads\.g\.doubleclick\.net/,
						// BounceX/Wunderkind marketing pixel — high-volume, no diagnostic value
						/events\.bouncex\.net/
					],
					instrumentations: {
						errors: true,
						fetch: true,
						xhr: true,
						userActions: true,
						resources: true,
						longtasks: false,    // high volume, rarely actionable
						domMutation: false   // very noisy, rarely needed
					},
					beforeSend: function(event) {
						// Drop successful resource loads — only forward failures
						// (failed = transferSize 0 with no decoded body)
						if (event.type === 'resource'
							&& event.transferSize > 0
							&& event.decodedBodySize > 0) {
							return null;
						}
						return event;
					},
					ignoreErrors: [
						/infdig/,
						/does not have renewable status/,
						/inprog/,
						// Generated by third-party scripts with no actionable details
						/Blocked a frame with origin/,
						// Generated by CP_GuestLookup and CP_Login
						/Guest not found/,
						/Possibly unhandled rejection: undefined/,
						// UI-Router transition lifecycle errors — not application errors
						/Transition Rejection/,
						// Cross-origin script errors — browser strips details for security, no diagnostic value
						/^Script error\.?$/,
						// Analytics/ad globals not loaded (e.g. blocked by ad blocker) — not an application error
						/gtag is not defined/,
						/googletag is not defined/,
						/Can't find variable: ttq/
					]
				});
			}

			initialized = true;
		}

		/**
		 * Notify Coralogix of an error.
		 * @public
		 * @param {String|Error} msg The message or error to send
		 * @param {Object|null} metaData The extra fields to send
		 * @returns {undefined}
		 */
		function notify(msg, metaData) {
			if (initialized && $window.CoralogixRum) {
				var combinedMetaData = angular.extend({}, service.getDefaultMetaData(), metaData);
				$window.CoralogixRum.setLabels(combinedMetaData);
				$window.CoralogixRum.captureError(typeof msg === 'string' ? new Error(msg) : msg);
			}
		}

		/**
		 * Returns the default meta data.
		 * @public
		 * @returns {Object|null} the default meta data
		 */
		function getDefaultMetaData() {
			return angular.merge({ details: { session_id: $injector.get('AppData').cart.session_id } }, defaultMetaData);
		}

		/**
		 * Sets the default meta data to send with errors.
		 * @protected
		 * @param {Object} metaData The meta data to set as the default.
		 * @returns {undefined}
		 */
		function setDefaultMetaData(metaData) {
			if (UtilsValidation.isRealObject(metaData)) {
				defaultMetaData = metaData;
			}
		}

		/**
		 * Leave a breadcrumb
		 * @param {String} name The breadcrumb name
		 * @returns {undefined}
		 */
		function breadcrumb(name) {
			if (initialized && $window.CoralogixRum) {
				$window.CoralogixRum.log(name);
			}
		}

		/**
		 * Send an informational (non-error) log to Coralogix RUM. Also live once the early-init SDK is up, because
		 * `initialized` only flips on APP_ACTIVATED, after the first Bootstrap steps have already run.
		 * @public
		 * @param {String} message The message
		 * @param {Object} [data] Extra fields to send
		 * @returns {undefined}
		 */
		function info(message, data) {
			if (($window.accessoRumEarlyInit || initialized) && $window.CoralogixRum && angular.isFunction($window.CoralogixRum.info)) {
				try {
					$window.CoralogixRum.info(message, data);
				} catch (e) {
					// logging must never break the checkout flow
				}
			}
		}

		/**
		 * Replaces the value of every non-empty acsop_* query parameter and of access_token with REDACTED and drops the url fragment.
		 * @public
		 * @param {String} url The url to redact
		 * @param {String} [base] The base url used to resolve a relative url
		 * @returns {String} the redacted url, or the original url if it cannot be parsed
		 */
		function redactUrl(url, base) {
			try {
				var parsed = new $window.URL(url, base || service.getLocation().href),
					keys = [];

				parsed.searchParams.forEach(function collectKey(value, key) {
					if ((key.indexOf('acsop_') === 0 || key === 'access_token') && value && keys.indexOf(key) < 0) {
						keys.push(key);
					}
				});
				keys.forEach(function redactKey(key) {
					parsed.searchParams.set(key, 'REDACTED');
				});

				parsed.hash = '';

				return parsed.toString();
			} catch (e) {
				return url;
			}
		}

		/**
		 * Returns the window location.
		 * @public
		 * @returns {Location} the current window location
		 */
		function getLocation() {
			return $window.location;
		}

		/**
		 * Whether the current url carries any acsop_* query parameter.
		 * @public
		 * @returns {Boolean} true when at least one acsop_* parameter is present
		 */
		function hasAccessoPayParams() {
			return /[?&]acsop_/.test(service.getLocation().search);
		}

		/**
		 * Logs the step about to run on an accessoPay redirect landing, with the acsop_* values redacted.
		 * @public
		 * @param {String} source The area logging, e.g. Bootstrap
		 * @param {String} feature The name of the function about to run
		 * @returns {undefined}
		 */
		function accessoPay(source, feature) {
			service.info(source, {
				feature: feature,
				url: service.redactUrl(service.getLocation().href)
			});
		}

		/**
		 * Wraps a function so the step is logged right before it runs.
		 * @public
		 * @param {String} source The area logging, e.g. Bootstrap
		 * @param {String} feature The name of the function being wrapped
		 * @param {Function} fn The function to run
		 * @param {Boolean} enabled When false the wrapper only calls fn
		 * @returns {Function} a function that logs (when enabled) and then returns fn's result
		 */
		function accessoPayStep(source, feature, fn, enabled) {
			return function loggedStep() {
				if (enabled) {
					service.accessoPay(source, feature);
				}

				return fn.apply(this, arguments);
			};
		}
	}
}());

(function() {
	'use strict';

	angular
		.module('errorTracking')
		.config(config);

	/**
	 * Set our global exception capture
	 * @param {Service} $provide $provide
	 * @returns {undefined}
   * @ngInject
	 */
	function config($provide) {
		$provide.provider({
			$exceptionHandler: function() {
				this.$get = ['$log', 'errorTracking', function($log, errorTracking) {
					return function(exception, cause) {
						$log.error.apply($log, arguments);
						errorTracking.notify(exception, { errorDetails: { cause: cause } });
					};
				}];
			}
		});
	}
}());

(function() {
	'use strict';

	angular
		.module('test-strategy', []);
}());
(function() {
	'use strict';

	angular
		.module('test-strategy')
		.factory('TestStrategyService', TestStrategyService);

	/**
	 * Testing strategy service for google optimize.
	 * @param {Service} $templateRequest For resolving templates
	 * @param {Window} $window The window object
	 * @param {Service} $templateCache The template cache
	 * @returns {self} our instance
	 * @ngInject
	 */
	function TestStrategyService($templateRequest, $window, $templateCache) {
		var service = {
			getOptions: getOptions,
			swapRouteTemplate: swapRouteTemplate,
			test: test
		};

		return service;

		/**
		 * Find out if we should use the variant test case and not the original.
		 * @param {String} name The name of the test.
		 * @param {*} equalsValue If you want to test against a specific value.
		 * @returns {Boolean} If you passed the condition.
		 */
		function test(name, equalsValue) {
			var options = service.getOptions();
			if (name in options) {
				if (!angular.isUndefined(equalsValue)) {
					return options[name] === equalsValue;
				}
			}
			return false;
		}

		/**
		 * Get the optimize options on the window. We need to always ensure we return an object.
		 * @returns {Object} The options to use.
		 */
		function getOptions() {
			return ($window.accesso || {}).OPTIMIZE || {};
		}

		/**
		 * Swaps out the route template for another based on a AB test.
		 * @param {String} name AB Test property
		 * @param {*} equalsValue The value if you want it to match something
		 * @param {Object} originalTemplateUrl The original template url
		 * @param {String} newTemplateUrl The new template URL
		 * @returns {Promise<string>} The template url to use
		 */
		function swapRouteTemplate(name, equalsValue, originalTemplateUrl, newTemplateUrl) {
			var url = service.test(name, equalsValue) ? newTemplateUrl : originalTemplateUrl;
			var template = $templateCache.get(url);

			if (!template) {
				return $templateRequest(url, true);
			}

			return template;
		}
	}
}()); 

/* eslint-global jqLite */
(function() {
	'use strict';

	angular
		.module('test-strategy')
		.directive('testStrategy', testStrategyDirective);

	/**
	 * Our test strategy directive. Used as:
	 * @param {Service} $animate $animate
	 * @param {Service} $compile $compile
	 * @param {Service} TestStrategyService The testing strategy service
	 * @returns {Object} The directive configuration
	 * @see {@link https://github.com/angular/angular.js/blob/master/src/ng/directive/ngIf.js#L3}
	 * @ngInject
	 */
	function testStrategyDirective($animate, $compile, TestStrategyService) {
		return {
			$$tlb: true,
			link: function($scope, $element, $attr, ctrl, $transclude) {
				var block,
					childScope,
					previousElements;

				$scope.$watch('testStrategyValue', function ngTestStrategyWatchAction() {
					var value = TestStrategyService.test($attr.testStrategy, $scope.testStrategyValue);

					if (value) {
						if (!childScope) {
							$transclude(function(clone, newScope) {
								childScope = newScope;
								clone[clone.length++] = $compile.$$createComment('end ngIf', $attr.ngIf);
								// Note: We only need the first/last node of the cloned nodes.
								// However, we need to keep the reference to the jqlite wrapper as it might be changed later
								// by a directive with templateUrl when its template arrives.
								block = { clone: clone };
								$animate.enter(clone, $element.parent(), $element);
							});
						}
					} else {
						if (previousElements) {
							previousElements.remove();
							previousElements = null;
						}

						if (childScope) {
							childScope.$destroy();
							childScope = null;
						}

						if (block) {
							previousElements = getBlockNodes(block.clone);
							$animate.leave(previousElements).done(function doneAnimating(response) {
								if (response !== false) {
									previousElements = null;
								}
							});
							block = null;
						}
					}
				});
			},
			multiElement: true,
			priority: 600,
			restrict: 'A',
			scope: {
				testStrategyValue: '<'
			},
			terminal: true,
			transclude: 'element',
		};
	}

	/**
	 * Return the DOM siblings between the first and last node in the given array.
	 * @param {Array} nodes array like object
	 * @returns {Array} the inputted object or a jqLite collection containing the nodes
	 * @see {@link https://github.com/angular/angular.js/blob/9f7144b035800c6671a981ba7e5987aeb6c9e959/src/Angular.js#L2008}
	 */
	function getBlockNodes(nodes) {
		var node = nodes[0],
			endNode = nodes[nodes.length - 1],
			blockNodes,
			i = 1;

		for (; node !== endNode && (node = node.nextSibling); i++) {
			if (blockNodes || nodes[i] !== node) {
				if (!blockNodes) {
					blockNodes = jqLite([].slice.call(nodes, 0, i));
				}
				blockNodes.push(node);
			}
		}

		return blockNodes || nodes;
	}
}());

(function() {
	'use strict';

	angular
		.module('utilities', []);
})();

(function() {
	'use strict';

	angular
		.module('utilities')
		.value('UtilsValidation', {
			isBoolean: isBoolean,
			isDateString: isDateString,
			isEmptyObject: isEmptyObject,
			isNumeric: isNumeric,
			isRealObject: isRealObject,
			returnOrDefault: returnOrDefault,
			validArray: validArray,
			validNumber: validNumber,
			validObject: validObject,
			validString: validString
		});

	/**
	 * Returns a property. If its falsy it will return the defaultValue property. If you pass in a validator function,
	 * it will run the value through that and if its true, it will return the property otherwise the default.
	 * @param {*} value The value to test.
	 * @param {*} defaultValue The default value.
	 * @param {FUnction} validator The function to validate the property.
	 * @returns {*} The value or the defaultValue
	 */
	function returnOrDefault(value, defaultValue, validator) {
		if (angular.isFunction(validator)) {
			if (validator(value)) {
				return value;
			}

			return defaultValue;
		}

		return value || defaultValue;
	}

	/**
	 * Find out if something is a boolean type or not.
	 * @public
	 * @param {Boolean} test The variable to check against
	 * @returns {Boolean} If its a boolean or not.
	 */
	function isBoolean(test) {
		return typeof test === 'boolean';
	}

	/**
	 * Find out if something is a numeric type or not.
	 * @public
	 * @param {Boolean} test The variable to check against
	 * @returns {Boolean} If its a boolean or not.
	 */
	function isNumeric(test) {
		return !!test && !isBoolean(test) && !Array.isArray(test) && !isNaN(test);
	}

	/**
	 * Find out if something is a real object and not an array.
	 * @public
	 * @param {*} test The object to test
	 * @return {Boolean} If its a real object and not an array
	 */
	function isRealObject(test) {
		return angular.isObject(test) && !Array.isArray(test);
	}

	/**
	 * Find out if we have an empty object
	 * @public
	 * @param {*} test The object to test
	 * @return {Boolean} if it's an empty object
	 */
	function isEmptyObject(test) {
		if (!angular.isObject(test)) {
			return false;
		} else if (Array.isArray(test)) {
			return false;
		}

		return !Object.keys(test).length;
	}

	/**
	 * Matches the date string against a format
	 * @public
	 * @name isDateString
	 * @memberof {utilities.validation}
	 * @param {String} dateString
	 * @param {RegExp} [format=YYYY-MM-DD] The dateformat to check against
	 * @returns {Boolean} True if the date string matches the format, false otherwise
	 */
	function isDateString(dateString, format) {
		format = format instanceof RegExp
			? format
			: /^\d{4}-\d{2}-\d{2}$/;

		return format.test(dateString);
	}

	/**
	 * Verify that the object passed is a real object and has properties
	 * @public
	 * @function
	 * @name validObject
	 * @memberof {utilities.validation}
	 * @param {*} o - The value to check
	 * @returns {Boolean} True if a valid object, false otherwise
	 */
	function validObject(o) {
		return isRealObject(o) && Object.keys(o).length > 0;
	}

	/**
	 * Is the param a string that's not empty?
	 * @public
	 * @function
	 * @name validString
	 * @param {*} s The param to test
	 * @memberof {utilities.validation}
	 * @return {Boolean} Is the param a string that's not empty?
	 */
	function validString(s) {
		return angular.isString(s) && s.length > 0;
	}

	/**
	 * Is the param a number thats greater than zero?
	 * @public
	 * @function
	 * @name validString
	 * @param {*} n The param to test
	 * @memberof {utilities.validation}
	 * @return {Boolean} Is the param a number thats greater than zero?
	 */
	function validNumber(n) {
		return isNumeric(n) && n > 0;
	}

	/**
	 * Is the param an array that's not empty?
	 * @public
	 * @function
	 * @name validString
	 * @param {*} a The param to test
	 * @memberof {utilities.validation}
	 * @return {Boolean} Is the param an array that's not empty?
	 */
	function validArray(a) {
		return Array.isArray(a) && a.length > 0;
	}
})();

(function() {
	'use strict';

	angular.module('utilities').service('ScreenUtils', ScreenUtils);

	/**
     * Utilities pertaining to screen size
     * @param {service} $window Angular service for wrapping the window
     * @param {service} Enums Our Enums service
     * @ngInject
     */
	function ScreenUtils($window, Enums) {
		var sizeThresholds = Enums.screenSizeThresholds;
		var service = {
			getScreenResThreshold: getScreenResThreshold,
			isScreenWithinThresold: isScreenWithinThresold
		};

		return service;

		/**
         * Get the threshold that the screen size belongs to,
         * Dictated by our screen sizes in our CSS media queries, translated to Enum service
         * @public
         * @returns {Number} Returns a number that corresponds to an enum representing the screen threshold
         */
		function getScreenResThreshold() {
			var width = $window.innerWidth;

			if (width < sizeThresholds.SM) {
				return sizeThresholds.XS;
			} else if (width < sizeThresholds.MD) {
				return sizeThresholds.SM;
			} else if (width < sizeThresholds.LG) {
				return sizeThresholds.MD;
			} else {
				return sizeThresholds.LG;
			}
		}

		/**
         * Check to see if the screen size matches a given threshold.
         * @param {Number|enum} sizeExpectation A number that corresponds to an enum representing the screen threshold
         * @returns {boolean} True if the size matches the enum provided, False otherwise
         */
		function isScreenWithinThresold(sizeExpectation) {
			return service.getScreenResThreshold() === sizeExpectation;
		}
	}
})();
(function() {
	'use strict';

	angular
		.module('utilities')
		.factory('UtilsPricing', UtilsPricing);

	/**
	 * Returns a bunch of utility functions for pricing.
	 * @public
	 * @constructor
	 * @module utilities
	 * @param {Service} AppData To get our app config
	 * @param {Service} Utilities a bunch of utilities
	 * @param {Service} UtilsValidation a collection of utilities for validating variables
	 * @return {Object} a list of utilities
	 * @ngInject
	 */
	function UtilsPricing(AppData, Utilities, UtilsValidation) {
		var isObject = angular.isObject,
			isArray = Array.isArray,
			validArray = UtilsValidation.validArray;

		/**
		 * Our service
		 * @type {Object}
		 */
		var service = {
			getPrice: getPrice,
			hasFeeAmount: hasFeeAmount,
			getTotalFeeAmount: getTotalFeeAmount,
			toFixed: toFixed
		};

		return service;

		/**
		 * Returns a float for the price to display based on use_vat app config.
		 * @public
		 * @function
		 * @name getPrice
		 * @param {Number} retail The retail amount
		 * @param {Number} tax The tax amount
		 * @param {Object|Array} fees The fees being applied
		 * @param {Boolean} ignoreVatCheck If you want to ignore the vat check and just get the total with everything
		 * @return {Number} A float of the price to display
		 */
		function getPrice(retail, tax, fees, ignoreVatCheck) {
			var feeAmount;
			var useFeeInclusive = AppData.defaults.use_fee_inclusive_pricing;
			var useVat = AppData.defaults.use_vat;
			var price = isNaN(retail) ? 0 : parseFloat(retail);
			tax = isNaN(tax) ? 0 : parseFloat(tax);

			if (ignoreVatCheck || useVat) {
				price += tax;
			}

			if(ignoreVatCheck || useVat || useFeeInclusive) {
				if (validArray(fees)) {
					price += fees.reduce(function(total, fee) {
						return total + (service.hasFeeAmount(fee) ? parseFloat(fee.amount) : 0);
					}, 0);
				} else if (service.hasFeeAmount(fees)) {
					price += parseFloat(fees.amount);
				} else if (!isNaN(fees)) {
					feeAmount = parseFloat(fees);
					if (!isNaN(feeAmount)) {
						price += feeAmount;
					}
				}
			}

			return price;
		}

		/**
		 * Returns the total fee amount from a list of fees.
		 * @public
		 * @function
		 * @name getTotalFeeAmount
		 * @param {*} fees The fees to sum
		 * @return {Number} The total fee amount
		 */
		function getTotalFeeAmount(fees) {
			var feeAmount = 0;
			var parsedFees;
			if (validArray(fees)) {
				feeAmount += fees.reduce(function(total, fee) {
					return total + (service.hasFeeAmount(fee) ? parseFloat(fee.amount) : 0);
				}, 0);
			} else if (service.hasFeeAmount(fees)) {
				feeAmount += parseFloat(fees.amount);
			} else if (!isNaN(fees)) {
				parsedFees = parseFloat(fees);
				if (!isNaN(parsedFees)) {
					feeAmount += parsedFees;
				}
			}
			return feeAmount
		}

		/**
		 * Find out if an object has a fee amount greater than 0
		 * @public
		 * @function
		 * @name hasFeeAmount
		 * @param {Object} fee The object to test
		 * @return {Boolean} if it has an amount greater than 0
		 */
		function hasFeeAmount(fee) {
			return isObject(fee) && !isArray(fee) && !isNaN(fee.amount);
		}

		/**
		 * Formats a price to a fixed of 2 decimal places.
		 * @public
		 * @function
		 * @name toFixed
		 * @param {Number} num The number to format
		 * @return {Number} the formatted number
		 */
		function toFixed(num) {
			if (!Number.isNaN(num)) {
				return num;
			}

			return +num.toFixed(2);
		}
	}
}());

(function() {
	'use strict';

	angular
		.module('utilities')
		.factory('UtilsCustomerType', UtilsCustomerType);

	/**
	 * A collection of function for use with customer types
	 * @public
	 * @constructor
	 * @param {Service} $filter Angular's filter service
	 * @param {Service} AppData For getting configs
	 * @param {Service} Language Our language service
	 * @param {Service} UtilsPricing pricing utilities
	 * @param {Service} UtilsValidation data type validation
	 * @return {Object} A collection of functions
	 */
	function UtilsCustomerType($filter, AppData, Language, UtilsPricing, UtilsValidation) {
		var ERROR_PREFIX = '[UtilsCustomerTypes] ',
			getFullPrice = UtilsPricing.getFullPrice,
			getLocale = Language.getLocale,
			isNumber = angular.isNumber,
			useVat = AppData.settings.use_vat,
			validArray = UtilsValidation.validArray;

		var service = {
			buildSelectedDateCustomerTypes: buildSelectedDateCustomerTypes,
			getSubtotalForCustomerType: getSubtotalForCustomerType,
			hasCustomerTypes: hasCustomerTypes
		};

		return service;

		/**
		 * Builds the array which we use to show customer type subtotals.
		 * @public
		 * @function
		 * @name buildSelectedDateCustomerTypes
		 * @memberof {TripSelectUtilitiesService}
		 * @param {Array<Object>} customerTypes From our model
		 * @param {Array<Object>} selectedDateCustomerTypes The CT property from the date response
		 * @param {String} sectionTarget The local section for free and price point targets
		 * @param {String} freeTarget The locale target for "free" text
		 * @param {String} pricePointTarget The locale target for the price point (e.g. ".ea", "each", "per person")
		 * @return {Array<Object>} Our customer types array to use to show subtotals
		 */
		function buildSelectedDateCustomerTypes(customerTypes, selectedDateCustomerTypes, sectionTarget, freeTarget, pricePointTarget) {
			var freeLocale = getLocale(sectionTarget, freeTarget),
				pricePointLocale = getLocale(sectionTarget, pricePointTarget);

			if (!validArray(customerTypes)) {
				throw new TypeError(ERROR_PREFIX + 'invalid customer types array');
			} else if (!validArray(selectedDateCustomerTypes)) {
				throw new TypeError(ERROR_PREFIX + 'invalid selected date customer types array');
			}

			return customerTypes
				.filter(function(type) {
					return type.qty > 0;
				})
				.map(function(type) {
					var newType = angular.copy(type),
						subtotal = service.getSubtotalForCustomerType(selectedDateCustomerTypes, type.id, type.qty);

					newType.subtotal = subtotal <= 0 ? freeLocale : $filter('currencyFormatter')(subtotal) + ' ' + pricePointLocale;

					return newType;
				});
		}

		/**
		 * Fetch the routes for a specific keyword.
		 * @public
		 * @function
		 * @name fetchRoutesByKeyword
		 * @memberof {TripSelectUtilitiesService}
		 * @param {Array<CustomerType>} customerTypes The customer types to check against
		 * @return {Promise} A promise to be resolved later
		 */
		function hasCustomerTypes(customerTypes) {
			if (!validArray(customerTypes)) {
				throw new TypeError('invalid customer types array');
			}

			return customerTypes.some(function(type) {
				return type.qty > 0;
			});
		}

		/**
		 * Returns a subtotal
		 * @public
		 * @function
		 * @name getSubtotalForCustomerType
		 * @memberof {TripSelectUtilitiesService}
		 * @param {Array<Object>} customerTypes The customer types from the selected date response
		 * @param {Number} id The customer ID
		 * @param {Number} qty The total qty for this type
		 * @return {Float} The subtotal for the total qty
		 */
		function getSubtotalForCustomerType(customerTypes, id, qty) {
			var count = customerTypes.length,
				parsedId = Number(id),
				i = 0;

			if (isNaN(qty) || qty <= 0) {
				return 0;
			}

			for (; i < count; i++) {
				if (Number(customerTypes[i].id) === parsedId) {
					return getFullPrice(customerTypes[i], useVat);
				}
			}

			return 0;
		}
	}
})();

(function() {
	'use strict';

	angular
		.module('utilities')
		.factory('UrlUtils', UrlUtils);

	/**
	 * Our factory
	 * @param {Window} $window $window
	 * @param {Service} UtilsValidation UtilsValidation
	 * @returns {UrlUtils} the service
	 * @ngInject
	 */
	function UrlUtils($window, UtilsValidation) {
		var isRealObject = UtilsValidation.isRealObject,
			validString = UtilsValidation.validString,
			ERROR_PREFIX = '[UrlUtils] ';

		var service = {
			createCloseControllerUrl: createCloseControllerUrl,
			getAccessoAPIHostUrl: getAccessoAPIHostUrl,
			getWindow: getWindow,
			objectToQueryParams: objectToQueryParams
		};

		return service;

		/**
		 * Creates a URL to the store's close route
		 * @public
		 * @function
		 * @name createCloseControllerUrl
		 * @memberof {utilities.Urls}
		 * @return {String} Close controller URL
		 */
		function createCloseControllerUrl() {
			var url = $window.location.protocol + '//' + $window.location.host + '/close' + $window.location.search;
			return url.replace('/#', '');
		}

		/**
		 * Returns Window
		 * @public
		 * @returns {Window} window obj
		 */
		function getWindow() {
			return $window;
		}

		/**
		 * Returns url with accessoAPIHost
		 * @public
		 * @param {String} url url to be appended
		 * @throws {TypeError}
		 * @returns {String} accessoAPIHost url
		 */
		function getAccessoAPIHostUrl(url) {
			var $win = service.getWindow(),
				location = $win.location,
				hostname = location.hostname,
				accessoAPIHost = $win.accessoAPIHost,
				accessoHost = validString(accessoAPIHost) ? accessoAPIHost : hostname,
				origin = location.protocol + '//' + (accessoHost.indexOf('localhost') === -1 ? accessoHost : accessoHost + ':' + location.port);

			if (!validString(url)) {
				throw new TypeError(ERROR_PREFIX + 'url must be a valid string');
			}

			return origin + url;
		}

		/**
		 * Returns a query string build off of an object that has key > value pairs.
		 * @param {Object} data The object to convert into a query string
		 * @return {String} the query string
		 */
		function objectToQueryParams(data) {
			if (isRealObject(data) && !UtilsValidation.isEmptyObject(data)) {
				return Object
					.keys(data)
					.map(function(key) {
						var val = data[key];
						var current = encodeURIComponent(key) + '=';

						if (isRealObject(val) || Array.isArray(val)) {
							current += encodeURIComponent(JSON.stringify(val));
						} else if (!angular.isFunction(val) && val !== null && angular.isDefined(val)) {
							current += encodeURIComponent(val);
						}

						return current;
					})
					.join('&');
			}

			return '';
		}
	}
})();

(function() {
	'use strict';

	angular
		.module('utilities')
		.factory('UtilityFunctions', UtilityFunctions);

	/**
	 * Little utility functions revolving around functions themselves.
	 * @public
	 * @constructor
	 * @param {Scope} $rootScope $rootScope
	 * @param {Service} $timeout $timeout
	 * @returns {UtilityFunctions} Our new instance
	 */
	function UtilityFunctions($rootScope, $timeout) {
		return {
			createEvent: createEvent,
			filterById: filterById,
			memoize: memoize
		};

		/**
		 * Creates a function that wraps angulars change detection
		 * @param {Function} fn The function to wrap
		 * @returns {Function} A function
		 */
		function createEvent(fn) {
			return function() {
				var args = arguments;
				$rootScope.$apply(function() {
					fn.apply(null, args);
				});
			}
		}

		/**
		 * Memoize other functions
		 * @param {Function} fnc The function to memoize
		 * @param {Function|true} resolver The function tno resolve a key OR true to always return the same cached result (this can be used for functions you just want cached that have no args).
		 * @returns {Function} The memoized function
		 */
		function memoize(fnc, resolver) {
			var memoized;

			if (!angular.isFunction(fnc)) {
				throw new TypeError('memoize expects a function');
			}

			memoized = function() {
				var args = arguments,
					// eslint-disable-next-line no-invalid-this
					context = this,
					key = angular.isFunction(resolver) ? resolver.apply(context, args) : '' + args[0],
					cache = memoized._cache,
					result;

				if (cache.hasOwnProperty(key)) {
					return cache[key];
				}

				result = fnc.apply(context, args);
				cache[key] = result;
				return result;
			};

			memoized._cache = {};

			return memoized;
		}

		/**
		 * Returns a function to use to filter an array of objects with an ID property
		 * @param {String|Number} id The id
		 * @returns {Function} A function to use on an array of objects.
		 */
		function filterById(id) {
			return function filterById(obj) {
				return obj.id == id;
			}
		}
	}
}());
(function() {
	'use strict';

	angular
		.module('guest-app-ui', [])
		.factory('GuestAppUiService', GuestAppUiService);

	/**
	 * Our factory
	 * @constructor
	 * @param {Document} $document $document
	 * @param {Service} UtilsValidation UtilsValidation
	 * @param {Service} Utilities Utilities
	 * @returns {Object} our factory
	 */
	function GuestAppUiService($document, Utilities) {

		return {
			triggerMDCTextFieldLayout: triggerMDCTextFieldLayout,
			updateRadioStates: updateRadioStates,
		};

		/**
		 * Triggers an MDCTextField layout to recheck for value and updating the floating label
		 * @returns {undefined}
		 */
		function triggerMDCTextFieldLayout() {
			// Since we are updating inputs, we need to call gapOnInput and float the label if needed.
			Utilities.nextTick(function next() {
				[].slice.call($document[0].querySelectorAll('gap-input input')).forEach(function updateInputLayout(el) {
					el.dispatchEvent(new Event('reset', {
						bubbles: false,
					}));
				});
			});
		}

		/**
		 * Triggers an update on the radio states
		 * @returns {undefined}
		 */
		function updateRadioStates() {
			Utilities.nextTick(function next() {
				$document[0].querySelectorAll('gap-radio-option').forEach(function updateRadioState(el) {
					el.updateRadioState();
				});
			});
		}
	}
})();
(function() {
	'use strict';

	angular
		.module('app')
		.service('UiRouterOverrideService', UiRouterOverrideService);

	/**
	 * Override functions for the angular ui router
	 * @constructor
	 * @param {Service} $httpParamSerializer - The $httpParamSerializer service
	 * @param {Service} $location - The $location service
	 * @param {Service} $q - The $q service
	 * @param {Service} $state - The $state service
	 * @param {Service} $window - The $window service
	 * @param {Service} AppData - The AppData service
	 * @param {Service} CustomActionService - The CustomActionService service
	 * @param {Service} Enums - The Enums service
	 * @param {Service} JSONValidator - The JSONValidator service
	 * @param {Service} Utilities - The Utilities service
	 * @param {Service} UtilsValidation - The UtilsValidation service
	 * @ngInject
	 */
	function UiRouterOverrideService(
		$http,
	$httpParamSerializer,
		$location,
		$q,
		$state,
		$urlRouter,
		$window,
		AppData,
		CustomActionService,
		Enums,
		JSONValidator,
		Utilities,
		UtilsValidation
	) {
		// Utility
		var merge = Utilities.merge,
			validArray = UtilsValidation.validArray,
			validObject = UtilsValidation.validObject,
			validString = UtilsValidation.validString;

		// Aliases
		var locationService = $state.router.locationService;
		var location = locationService.$location;

		// Service
		var service = {
			// PUBLIC
			hasQuery: false,
			addWhitelistParam: addWhitelistParam,
			clearSensitiveParams: clearSensitiveParams,
			initialize: initialize,
			initialWhitelistParams: initialWhitelistParams,

			// PROTECTED
			_: {
				initialized: false,
				initalizedWhitelist: false,
				locationServiceHashOverride: _locationServiceHashOverride,
				locationServiceUrlOverride: _locationServiceUrlOverride,
				locationSearchOverride: _locationSearchOverride,
				resetClearAction: _resetClearAction,
				removedQuery: {},
				staticQuery: null,
				staticHash: null,
				updateSearch: _updateSearch,
				whiteList: [],
			}
		};

		return service;

		/***************************************
		 ** ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ **
		 ** ~ P R I V A T E ~ M E T H O D S ~ **
		 ** ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ **
		 ***************************************/

		/**
		 * Override function for the $location.hash method
		 * @protected
		 * @override
		 * @param {String} [hash] - The hash to set
		 * @returns {String|undefined} The hash if no arguments are present, otherwise undefined
		 */
		function _locationServiceHashOverride(hash) {
			// If there are arguments, set the hash
			if (arguments.length) {
				$location.$$hash = hash;

				// Exit
				return;
			}

			//Otherwise, return the hash
			return new URLSearchParams(
				merge(
					Object.fromEntries(new URLSearchParams($location.$$hash)),
					Object.fromEntries(new URLSearchParams(service._.staticHash))
				)
			).toString();
		}

		/**
		 * A copy of the ui-router location service > `url` method with adjustments to always add the query
		 * @protected
		 * @override
		 * @param {String} [newUrl] the url to redirect to
		 * @param {Boolean} [replace] If we should replace the current state with the new one
		 * @param {Object} [state] The state to change to
		 * @returns {Object} The location object for the url
		 */
		function _locationServiceUrlOverride(newUrl, replace, state) {
			var flatQuery,
				queryParams,
				newQueryParams = service.hasQuery ? angular.merge({}, service._.staticQuery) : {};

			// Is newUrl a valid string?
			if (validString(newUrl)) {
				queryParams = newUrl.split('?')[1];
				// Merge the old and new query params
				if (validString(queryParams)) {
					queryParams.split('&').forEach(function reduceQueryParams(part) {
						var parts = part.split('=');
						// Decode as the httpParamSerializer will encode them
						newQueryParams[decodeURIComponent(parts[0])] = decodeURIComponent(parts[1]);
					});
				}

				// If we have a static query to append
				if (validObject(newQueryParams)) {
					Object.keys(newQueryParams).forEach(function removeArrays(key) {
						var value = newQueryParams[key];

						if (angular.isArray(value)) {
							// Remove duplicates
							newQueryParams[key] = value.reduce(function reduceDuplicate(acc, val) {
								if (!acc.includes(val)) {
									acc.push(val);
								}
								return acc;
							}, []);
						}
					});
					// get the query as a string
					flatQuery = $httpParamSerializer(newQueryParams);

					if (validString(flatQuery)) {
						// Append the query to the url
						newUrl = newUrl.split('?')[0] + '?' + flatQuery;
					}
				}
				// Update the URL
				locationService.$location.url(newUrl);
			}

			// If replace is set, replace the route
			if (replace) locationService.$location.replace();

			// If state is set, replace the state
			if (state) locationService.$location.state(state);

			// Return the url object
			return locationService.$location.url();
		}

		/**
		 * A copy of the ui-router location service > `search` method with adjustments to return the full query
		 * @protected
		 * @override
		 * @param {String} [search] The query to search for
		 * @param {String} [paramValue] The value to set the query to
		 * @returns {Object} The location object for the search
		 */
		function _locationSearchOverride(search, paramValue) {
			// Assemble the full query with the ones removed
			var fullQuery = merge({}, $location.$$search, service._.removedQuery);

			switch (arguments.length) {
				case 0:
					// No arguments passed, return the full query
					return fullQuery;
				case 1:
					// Is the search a string or number?
					if (angular.isString(search) || angular.isNumber(search)) {
						// Force search to be a string
						search = search.toString();

						// Return the search value
						return Object.fromEntries(new URLSearchParams(fullQuery))[search];
					// Is the search an object?
					} else if (angular.isObject(search)) {
						search = angular.copy(search, {});
						// remove object undefined or null properties
						angular.forEach(search, function(value, key) {
							if (value == null) delete search[key];
						});

						return search;
					} else {
						throw angular.$$minErr('$location')('isrcharg', 'The first argument of the `$location#search()` call must be a string or an object.');
					}
			  default:
				// Assign new query to the window
				if (angular.isUndefined(paramValue) || paramValue === null) {
					delete $location.$$search[search];
				} else {
					$location.$$search[search] = paramValue;
				}
			}

			// Update the location
			$location.$$compose();

			// Return the location object
			return $location;
		}

		/**
		 * The custom action when the store is trying to be resetted
		 * @protected
		 * @returns {String} The default route to use (for custom action)
		 */
		function _resetClearAction() {
			var paramsString;

			// Clear sensitive parameters
			service.clearSensitiveParams();

			// Get the query as a string using the search override and convert to string
			paramsString = new URLSearchParams(service._.locationSearchOverride()).toString();

			// Return the default route to use (for custom action)
			return '/?' + paramsString;
		}

		/**
		 * Updates the search params without causing the application to reload
		 * @protected
		 * @returns {undefined}
		 */
		function _updateSearch() {
			// Takes the internal search params and generates the abs and relative urls
			$location.$$compose();

			// Turns off the flag that the url was updated by the location
			$location.$$urlUpdatedByLocation = false;

			// Disable the ui router from listening to url changes while we update the history
			$urlRouter.listen(false);

			// Using the history service, replace the state with the absolute URL
			$window.history.replaceState({}, '', $location.absUrl());
		}

		/*************************************
		 ** ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ **
		 ** ~ P U B L I C ~ M E T H O D S ~ **
		 ** ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ **
		 *************************************/

		/**
		 * Whitelists a custom paramter to be added to the query
		 * @public
		 * @param {String} param - The parameter to whitelist
		 * @returns {undefined}
		 */
		function addWhitelistParam(param) {
			// Is the param already set to the removeQuery?
			if (angular.isDefined(service._.removedQuery[param])) {
				// Set the param to the staticQuery
				service._.staticQuery[param] = service._.removedQuery[param];

				// Remove it form the removeQuery
				delete service._.removedQuery[param];

				// Set it to the location internals
				$location.$$search[param] = service._.staticQuery[param];
			}

			// Is the param not already in the whitelist?
			if (!service._.whiteList.includes(param)) {
				// Add the param to the whitelist
				service._.whiteList.push(param);
			}

			// Update the window url to reflect the changes
			service._.updateSearch();

			// Re-enable the ui router to listen to url changes
			$urlRouter.listen(true);
		}

		/**
		 * Wipes out sensitive parameters from the query and the static query
		 * @public
		 * @returns {undefined}
		 */
		function clearSensitiveParams() {
			var currentSearch = $location.search(),
				sensitiveParams = [
					Enums.urlParameters.accessToken,
					Enums.urlParameters.authToken,
					Enums.urlParameters.cartId,
					Enums.urlParameters.cartKey,
					Enums.urlParameters.guestCheckout,
					Enums.urlParameters.sessionId,
					Enums.urlParameters.sessionIdShort,
				].concat(Object.values(Enums.urlParametersAccessoPay));

			$http.post(AppData.getApiUrl() + '/api/log', {
				m: 'clearing sensitive params: params=' + Object.keys(currentSearch).join(','),
				s: AppData.cart.session_id,
				t: 'ui-router-override-clear'
			});

			// Remove sensitive params from the query
			sensitiveParams.forEach(function removeSensitiveParams(key) {
				// Remove the key to the removed query set
				delete service._.removedQuery[key];

				// Remove the key from the query
				$location.search(key, null);

				// Remove the key from the static query
				delete service._.staticQuery[key];
			});
		}

		/**
		 * The initialize function to boot that sets up the overrides for the ui router
		 * @public
		 * @see {@link app/scripts/services/bootstrap.js}
		 * @returns {undefined}
		 */
		function initialize() {
			// If the service is already initialized, exit
			if (service._.initialized) {
				return $q.resolve();
			}

			// Assemble the white list
			service._.whiteList = Object.values(Enums.urlParameters).concat(Object.values(Enums.urlParametersAccessoPay)).concat(service._.whiteList);

			// Gets the query that store was loaded with and assigns it to the service
			service._.staticQuery = $location.search();

			$http.post(AppData.getApiUrl() + '/api/log', {
				m: 'shopland init: params=' + Object.keys(service._.staticQuery).join(','),
				s: service._.staticQuery['session_id'] || 'unknown',
				t: 'ui-router-override-init'
			});

			// Gets the hash that store was loaded with and assigns it to the service
			service._.staticHash = $location.hash();

			// Clear the hash
			$location.hash('');

			Object.keys(service._.staticQuery).forEach(function removeKeys(key) {
				if (!service._.whiteList.includes(key) || [undefined, ''].includes($location.search()[key])) {
					// Add the key to the removed query set
					service._.removedQuery[key] = service._.staticQuery[key];

					// Remove the key from the static query
					delete service._.staticQuery[key];

					// Remove the key from the internal location object
					delete $location.$$search[key];
				}
			});

			// Update the window url to reflect the changes
			service._.updateSearch();

			// Boolean value to determine if there was a query
			service.hasQuery = validObject(service._.staticQuery);

			// Override the location service `hash` function
			location.hash = service._.locationServiceHashOverride;

			// Override the location service `url` function
			locationService.url = service._.locationServiceUrlOverride;
			location.search = service._.locationSearchOverride;

			// Tell the service to wipe sensitive params on purchase success
			CustomActionService.registerCustomActionForChain(CustomActionService.ACTIONS_ENUMS.PURCHASE_COMPLETE_SUCCESS, service.clearSensitiveParams);
			CustomActionService.registerCustomActionForChain(CustomActionService.ACTIONS_ENUMS.ON_RESET_STORE_URL_OVERRIDE, service._.resetClearAction);

			// Set the initialized flag
			service._.initialized = true;
		}

		/**
		 * Bootrap initialization for configurable whitelist params
		 * @public
		 * @returns {Promise} A promise that resolves when the whitelist params are initialized
		 */
		function initialWhitelistParams() {
			var setting;

			// If the service is already initialized, exit
			if (service._.initalizedWhitelist) {
				return $q.resolve();
			}

			// Try and parse the allowedOrderCharacs against the JSON schema
			if (JSONValidator.validate('allowedOrderCharacs', AppData.settings.allowedOrderCharacs)) {
				// Iterate and add to whitelist param
				JSON.parse(AppData.settings.allowedOrderCharacs).forEach(function whitelistCharacs(charac) {
					service.addWhitelistParam(charac);
				});
			// Legacy support for string based whitelist params
			} else if (validString(AppData.settings.allowedOrderCharacs)) {
				// Try and eval the string
				setting = eval(AppData.settings.allowedOrderCharacs);

				// If the eval is an array, iterate and add to whitelist param
				if (validArray(setting)) {
					setting.forEach(function whitelistCharacs(charac) {
						service.addWhitelistParam(charac);
					});
				}
			}

			// Try and parse the whitelist_params against the JSON schema
			if (JSONValidator.validate('whitelist_params', AppData.settings.whitelist_params)) {
				// Iterate and add to whitelist param
				JSON.parse(AppData.settings.whitelist_params).forEach(function whitelistCharacs(param) {
					service.addWhitelistParam(param);
				});
			}

			// Set the initialized flag to true
			service._.initalizedWhitelist = true;

			// Exit and resolve
			return $q.resolve();
		}
	}
})();
angular.module("bundle", ["app"])

.constant("BundleMap", {
	"accesso-calendar-preview": {
		"bundle": "app/scripts/components/accesso-calendar/__preview/bundle.json",
		"files": [
			"/scripts/components/accesso-calendar/__preview/styles/accesso-calendar-preview.css",
			"bundle/accesso-calendar-preview-templates.html",
			"bundle/accesso-calendar-preview-scripts.js"
		],
		"ignore": [],
		"canary": "AccessoCalendarComponentPreviewController"
	},
	"accesso-calendar": {
		"bundle": "app/scripts/components/accesso-calendar/bundle.json",
		"files": [
			"/scripts/components/accesso-calendar/styles/accesso-calendar.css",
			"/scripts/components/accesso-calendar/components/accesso-calendar-datepicker/styles/accesso-calendar-datepicker.css",
			"bundle/accesso-calendar-templates.html",
			"bundle/accesso-calendar-scripts.js"
		],
		"ignore": [],
		"canary": "AccessoCalendarDataService"
	},
	"banner": {
		"bundle": "app/scripts/components/banner/bundle.json",
		"files": [
			"/scripts/components/banner/styles/banner.css",
			"/scripts/components/banner/templates/banner.html",
			"bundle/banner-scripts.js"
		],
		"ignore": []
	},
	"external-account-card": {
		"bundle": "app/scripts/components/external-account-card/bundle.json",
		"files": [
			"/scripts/components/external-account-card/external-account-card.css",
			"bundle/external-account-card-scripts.js"
		],
		"ignore": [],
		"canary": "ExternalAccountCardController"
	},
	"image-capture": {
		"bundle": "app/scripts/components/image-capture/bundle.json",
		"files": [
			"bundle/image-capture-templates.html",
			"bundle/image-capture-scripts.js",
			"bundle/image-capture-styles.css"
		],
		"ignore": [],
		"canary": "ImageCaptureModal"
	},
	"mobile-cta": {
		"bundle": "app/scripts/components/mobile-cta/bundle.json",
		"files": [
			"/scripts/components/mobile-cta/styles/mobile-cta.css",
			"bundle/mobile-cta-scripts.js"
		],
		"ignore": [],
		"canary": "MobileCtaComponentController"
	},
	"modal-selector": {
		"bundle": "app/scripts/components/modal-selector/bundle.json",
		"files": [
			"/scripts/components/modal-selector/styles/modal-selector.css",
			"bundle/modal-selector-templates.html",
			"bundle/modal-selector-scripts.js"
		],
		"ignore": [],
		"canary": "ModalSelectorComponentController"
	},
	"payment-schedule": {
		"bundle": "app/scripts/components/payment-schedule/bundle.json",
		"files": [
			"bundle/payment-schedule-templates.html",
			"bundle/payment-schedule-scripts.js"
		],
		"ignore": [],
		"canary": "PaymentScheduleComponentController"
	},
	"post-purchase-signup": {
		"bundle": "app/scripts/components/post-purchase-signup/bundle.json",
		"files": [
			"/scripts/components/post-purchase-signup/post-purchase-signup.css",
			"bundle/post-purchase-signup-scripts.js"
		],
		"ignore": [],
		"canary": "PostPurchaseSignupController"
	},
	"quantity": {
		"bundle": "app/scripts/components/quantity/bundle.json",
		"files": [
			"bundle/quantity-scripts.js",
			"bundle/quantity-templates.html"
		],
		"ignore": [],
		"canary": "QuantityComponentController"
	},
	"skeleton": {
		"bundle": "app/scripts/components/skeleton/bundle.json",
		"files": [
			"/scripts/components/skeleton/price-skeleton-component.js",
			"/scripts/components/skeleton/price-skeleton.css",
			"bundle/skeleton-templates.html"
		],
		"ignore": []
	},
	"vertical-slider": {
		"bundle": "app/scripts/components/vertical-slider/bundle.json",
		"files": [
			"/scripts/components/vertical-slider/styles/vertical-slider.css",
			"bundle/vertical-slider-templates.html",
			"bundle/vertical-slider-scripts.js"
		],
		"ignore": [],
		"canary": "VerticalSliderController"
	},
	"models": {
		"bundle": "app/scripts/models/bundle.json",
		"files": [
			"bundle/models.js"
		],
		"ignore": [],
		"canary": "GetMerchantPackageEventDatesModel"
	},
	"camps-enrollment": {
		"bundle": "app/scripts/modules/alternate-modules/camps-enrollment/bundle.json",
		"files": [
			"/scripts/modules/alternate-modules/camps-enrollment/styles/camps-selection.css",
			"/scripts/modules/alternate-modules/camps-enrollment/styles/camp-participant-selection.css",
			"/scripts/modules/alternate-modules/camps-enrollment/components/camps-search-filter/styles/camps-search-filter.css",
			"/scripts/modules/alternate-modules/camps-enrollment/components/camps-status/styles/camps-status.css",
			"/scripts/modules/profile/services/profile-guest-additional-info-service.js",
			"/scripts/modules/waitlist/controllers/waitlist-controller.js",
			"/scripts/modules/waitlist/controllers/waitlist-logged-in-controller.js",
			"/scripts/modules/waitlist/services/waitlist-service.js",
			"/scripts/modules/event-search/event-search-models.js",
			"/scripts/modules/event-search/services/event-search-prep-service.js",
			"/scripts/modules/event-search/services/event-search-request-service.js",
			"/scripts/modules/event-search/components/search-legend/search-legend-component.js",
			"/scripts/modules/event-search/components/search-legend/search-legend-controller.js",
			"bundle/camps-enrollment-templates.html",
			"bundle/camps-enrollment-scripts.js"
		],
		"ignore": [
			"bundle/camps-enrollment-module.js"
		],
		"canary": "CampsEnrollmentPrepService"
	},
	"package-planner": {
		"bundle": "app/scripts/modules/alternate-modules/package-planner/bundle.json",
		"files": [
			"/scripts/modules/alternate-modules/package-planner/styles/package-planner.css",
			"bundle/package-planner-templates.html",
			"bundle/package-planner-scripts.js"
		],
		"ignore": [
			"bundle/package-planner-module.js"
		],
		"canary": "PackagePlannerService"
	},
	"snap-calendar": {
		"bundle": "app/scripts/modules/alternate-modules/snap-calendar/bundle.json",
		"files": [
			"bundle/snap-calendar-templates.html",
			"bundle/snap-calendar-scripts.js",
			"bundle/snap-calendar-styles.css"
		],
		"ignore": [],
		"canary": "SnapCalendarService"
	},
	"buy-now": {
		"bundle": "app/scripts/modules/buy-now/bundle.json",
		"files": [
			"bundle/buy-now-template.html",
			"bundle/buy-now-scripts.js",
			"bundle/buy-now-styles.css"
		],
		"ignore": [],
		"canary": "BuyNowService"
	},
	"cart-abandonment": {
		"bundle": "app/scripts/modules/cart-abandonment/bundle.json",
		"files": [
			"/scripts/modules/cart-abandonment/styles/cart-abandonment.css",
			"bundle/cart-abandonment-templates.html",
			"bundle/cart-abandonment-scripts.js"
		],
		"ignore": [
			"bundle/cart-abandonment-base.js"
		]
	},
	"cart": {
		"bundle": "app/scripts/modules/cart/bundle.json",
		"files": [
			"bundle/cart-templates.html",
			"bundle/cart-scripts.js",
			"bundle/cart-styles.css"
		],
		"ignore": [
			"bundle/cart-services-scripts.js"
		],
		"canary": "CartController"
	},
	"date-time": {
		"bundle": "app/scripts/modules/extraflow/date-time/bundle.json",
		"files": [
			"/scripts/modules/extraflow/date-time/styles/date-time.css",
			"bundle/date-time-scripts.js",
			"bundle/date-time-templates.html"
		],
		"ignore": [],
		"canary": "DateTimeService"
	},
	"gift-aid": {
		"bundle": "app/scripts/modules/gift-aid/bundle.json",
		"files": [
			"/scripts/modules/gift-aid/styles/gift-aid.css",
			"bundle/gift-aid-scripts.js",
			"bundle/gift-aid-templates.html"
		],
		"ignore": [
			"bundle/gift-aid-main.js"
		],
		"canary": "GiftAidServiceExtended",
		"invoke": [
			"GiftAidServiceExtended"
		]
	},
	"guest-profile-menu": {
		"bundle": "app/scripts/modules/guest-profile-menu/bundle.json",
		"files": [
			"bundle/guest-profile-menu-scripts.js"
		],
		"ignore": [],
		"canary": "GuestProfileMenuService"
	},
	"guest-profile": {
		"bundle": "app/scripts/modules/guest-profile/bundle.json",
		"files": [
			"bundle/guest-profile-scripts.js"
		],
		"ignore": [],
		"canary": "GuestProfileDataService"
	},
	"passport-auth": {
		"bundle": "app/scripts/modules/passport-auth/bundle.json",
		"files": [
			"bundle/passport-auth-scripts.js"
		],
		"ignore": [],
		"canary": "AuthService"
	},
	"payment-plan": {
		"bundle": "app/scripts/modules/payment-plan/bundle.json",
		"files": [
			"bundle/payment-plan-scripts.js"
		],
		"ignore": [],
		"canary": "PaymentPlanService"
	},
	"profile-manager-new": {
		"bundle": "app/scripts/modules/profile/modules/profile-manager-new/bundle.json",
		"files": [
			"/scripts/modules/waitlist/services/waitlist-service.js",
			"/scripts/modules/profile/services/profile-guest-additional-info-service.js",
			"bundle/profile-manager-scripts.js",
			"bundle/profile-manager-templates.html",
			"bundle/profile-manager-styles.css"
		],
		"ignore": [],
		"canary": "ProfileManagerNewService"
	},
	"seat-genius": {
		"bundle": "app/scripts/modules/seat-genius/bundle.json",
		"files": [
			"/scripts/modules/seat-genius/styles/seat-genius.css",
			"bundle/seat-genius-scripts.js",
			"bundle/seat-genius-templates.html"
		],
		"ignore": [],
		"canary": "SeatGeniusController"
	},
	"unified-package-details": {
		"bundle": "app/scripts/modules/unified-package-details/bundle.json",
		"files": [
			"bundle/unified-package-details-templates.html",
			"bundle/unified-package-details-scripts.js",
			"bundle/unified-package-details-styles.css"
		],
		"ignore": [
			"bundle/unified-package-details-main.js"
		],
		"canary": "UnifiedPackageDetailsService"
	}
})

;
(function() {
	'use strict';

	angular
		.module('bundle')
		.service('BundleService', BundleService);

	/**
	 * The Bundle Service
	 * @param {Object} BundleMap - The Bundle Map Constants
	 * @param {Service} $controller - The Controller Service
	 * @param {Service} $injector - The Injector Service
	 * @param {Service} $q - The Q service
	 * @param {Service} $timeout - The Timeout Service
	 * @param {Service} $templateCache - The Template Cache Service
	 * @param {Service} Utilities - The Utilities Service
	 * @param {Service} UtilsValidation - The Validation Service
	 * @returns {Service} - The Bundle Service
	 * @constructor
	 * @ngInject
	 */
	function BundleService(BundleMap, $controller, $injector, $q, $templateCache, $timeout, Utilities, UtilsValidation) {
		var checkProp = Utilities.checkProp,
			validArray = UtilsValidation.validArray;

		var service = {
			enums: {},
			lazyLoadCollectionFiles: lazyLoadCollectionFiles,
			_: {
				canaryWaitTime: 10,
				loadedCollections: [],
				initialize: _initialize
			}
		};

		// Initialize our service
		service._.initialize();

		// Return our service
		return service;

		/**
		 * Lazy loads the files for a bundle collection
		 * @param {String} collectionId - The unique bundle collection id
		 * @returns {Promise} - The Lazy Load Promise
		 */
		function lazyLoadCollectionFiles(collectionId) {
			var deferred = $q.defer();

			// If multiple collection ids were passed
			if (arguments.length > 1) {
				// Iterate and lazy load each collection id and wait for all to resolve
				$q.all(
					[].slice.call(arguments).reduce(function onEachCollectionId(acc, collectionId) {
						acc.push(service.lazyLoadCollectionFiles(collectionId));

						return acc;
					},
					[])
				).then(deferred.resolve);

				return deferred.promise;
			}

			// If we don't have a valid collection id or the collection is already loaded
			if (!BundleMap[collectionId] || service._.loadedCollections.includes(collectionId)) {
				// Resolve the promise
				return $q.resolve();
			}

			// Mark the collection as loaded so we don't load it again
			service._.loadedCollections.push(collectionId);

			// Lazy load the files
			Utilities.cacheBustAndLazyLoad(BundleMap[collectionId].files).then(function onFilesLoaded() {
				// If we have a canary set in the bundle
				if (checkProp('BundleMap.' + collectionId + '.canary', BundleMap, 'validString')) {
					// Wait for the canary file to be registered to angularjs
					$timeout(function waitForCanary() {
						var canary = BundleMap[collectionId].canary;
						// If the canary file is registered
						if ($injector.has(canary)) {
							// Resolve the promise
							return onComplete();
						} else {
							// Attempt to check if the file is a controller
							try {
								// Attempts to see if the controller is registered
								$controller(canary, {}, true);

								// Resolve the promise
								return onComplete();
							} catch (e) {
								// If the controller doesn't exist, it'll error and not resolve the promise
							}
						}

						// Otherwise, wait for the canary file to be registered
						$timeout(waitForCanary, service._.canaryWaitTime);
					}, service._.canaryWaitTime);
				} else {
					// Resolve the promise
					onComplete();
				}

				/**
				 * Once the assets are loaded, run any complete tasks
				 * @closure
				 * @returns {undefined}
				 */
				function onComplete() {
					// If the Bundle collection has a valid invoke array
					if (validArray(BundleMap[collectionId].invoke)) {
						// Iterate through the invoke array
						BundleMap[collectionId].invoke.forEach(function invokeDependency(inv) {
							// If the dependency is registered, initialize it
							$injector.has(inv) && $injector.get(inv);
						});
					}

					return deferred.resolve();
				}
			});

			return deferred.promise;
		}

		/**
		 * Initializes the Bundle Service
		 * @private
		 * @returns {undefined}
		 */
		function _initialize() {
			// Generate our enums from the BundleMap Keys
			Object.keys(BundleMap).forEach(function(collectionId) {
				// Convert keys to use constant format (e.g. some-collection -> SOME_COLLECTION)
				service.enums[collectionId.toUpperCase().replace(/-/g, '_')] = collectionId;
			});
		}
	}
})();

(function() {
	'use strict';

	var COMPONENT_DIRECTORY = '/scripts/components',
		CART_FEE_NOTICE_DIR = COMPONENT_DIRECTORY + '/cart-fee-notice',
		EXPANDABLE_INFO_DIR = COMPONENT_DIRECTORY + '/expandable-information',
		PACKAGE_CARD_DIR = COMPONENT_DIRECTORY + '/package-card',
		CART_ITEM_BUNDLE_DETAILS_DIR = COMPONENT_DIRECTORY + '/cart-item-bundle-details',
		AC_LIST_COMPONENT_DIR = COMPONENT_DIRECTORY + '/list',
		SNAP_PACKAGE_DETAIL_DIR = COMPONENT_DIRECTORY + '/snap-package-details',
		SNAP_PACKAGE_RESULT_DIR = COMPONENT_DIRECTORY + '/snap-package-result',
		SNAP_RATE_SELECTOR_DIR = COMPONENT_DIRECTORY + '/snap-rate-selector',
		SNAP_DT_LIST_DIR = COMPONENT_DIRECTORY + '/snap-date-time-list',
		SNAP_CALENDAR_SELECTOR_DIR = COMPONENT_DIRECTORY + '/snap-calendar-selector',
		CUSTOMER_QUANTITY_DIR = COMPONENT_DIRECTORY + '/customer-components/customer-quantity';

	angular
		.module('components', ['app', 'bundle'])
		.constant('CART_FEE_NOTICE_ASSETS', [
			CART_FEE_NOTICE_DIR + '/cart-fee-notice.js',
			CART_FEE_NOTICE_DIR + '/cart-fee-notice.css',
			CART_FEE_NOTICE_DIR + '/cart-fee-notice-component-controller.js',
			CART_FEE_NOTICE_DIR + '/cart-fee-notice.html'
		])
		.constant('CUSTOMER_QUANTITY_COMPONENT_ASSETS', [
			CUSTOMER_QUANTITY_DIR + '/customer-quantity-component.js',
			CUSTOMER_QUANTITY_DIR + '/customer-quantity-component.css',
			CUSTOMER_QUANTITY_DIR + '/customer-quantity-component-controller.js'
		])
		.constant('EXPANDABLE_INFO_COMPONENT_ASSETS', [
			EXPANDABLE_INFO_DIR + '/expandable-information-component.js',
			EXPANDABLE_INFO_DIR + '/expandable-information-component-controller.js'
		])
		.constant('PACKAGE_CARD_COMPONENT_ASSETS', [
			PACKAGE_CARD_DIR + '/package-card-component.css',
			PACKAGE_CARD_DIR + '/package-card-component.js',
			PACKAGE_CARD_DIR + '/package-card-component-controller.js'
		])
		.constant('CART_ITEM_BUNDLE_DETAILS_COMPONENT_ASSETS', [
			CART_ITEM_BUNDLE_DETAILS_DIR + '/cart-item-bundle-details-component.css',
			CART_ITEM_BUNDLE_DETAILS_DIR + '/cart-item-bundle-details-component.html',
			CART_ITEM_BUNDLE_DETAILS_DIR + '/cart-item-bundle-details-component-controller.js'
		])
		.constant('LIST_COMPONENT_ASSETS', [
			AC_LIST_COMPONENT_DIR + '/list-component.css',
			AC_LIST_COMPONENT_DIR + '/list-component.html',
			AC_LIST_COMPONENT_DIR + '/list-component.js',
			AC_LIST_COMPONENT_DIR + '/list-component-controller.js'
		])
		.constant('ESTIMATED_NOTICE_COMPONENT_ASSETS', [
			COMPONENT_DIRECTORY + '/estimated-notice/estimated-notice-component.js',
			COMPONENT_DIRECTORY + '/estimated-notice/estimated-notice-component.css'
		])
		.constant('SNAP_RATE_SELECTOR_COMPONENT_ASSETS', [
			SNAP_RATE_SELECTOR_DIR + '/snap-rate-selector-component.css',
			SNAP_RATE_SELECTOR_DIR + '/snap-rate-selector-component.js',
			SNAP_RATE_SELECTOR_DIR + '/snap-rate-selector-component-controller.js'
		])
		.constant('SNAP_CALENDAR_SELECTOR_COMPONENT_ASSETS', [
			SNAP_CALENDAR_SELECTOR_DIR + '/snap-calendar-selector-component.css',
			SNAP_CALENDAR_SELECTOR_DIR + '/snap-calendar-selector-component.js',
			SNAP_CALENDAR_SELECTOR_DIR + '/snap-calendar-selector-component-controller.js'
		])
		.constant('SNAP_DT_LIST_COMPONENT_ASSETS', [
			SNAP_DT_LIST_DIR + '/snap-date-time-list-component.css',
			SNAP_DT_LIST_DIR + '/snap-date-time-list-component.js',
			SNAP_DT_LIST_DIR + '/snap-date-time-list-component-controller.js'
		])
		.constant('SNAP_PACKAGE_DETAILS_COMPONENT_ASSETS', [
			SNAP_PACKAGE_DETAIL_DIR + '/snap-package-details-component.css',
			SNAP_PACKAGE_DETAIL_DIR + '/snap-package-details-component.js',
			SNAP_PACKAGE_DETAIL_DIR + '/snap-package-details-component-controller.js'
		])
		.constant('SNAP_PACKAGE_RESULT_COMPONENT_ASSETS', [
			SNAP_PACKAGE_RESULT_DIR + '/snap-package-result-component.css',
			SNAP_PACKAGE_RESULT_DIR + '/snap-package-result-component.js',
			SNAP_PACKAGE_RESULT_DIR + '/snap-package-result-component-controller.js'
		]);
}());

(function() {
	'use strict';

	angular
		.module('components')
		.component('cartItemBundleDetails', {
			bindings: { itemList: '<' },
			controller: 'CartItemsBundleComponentController',
			controllerAs: 'vm',
			templateUrl: '/scripts/components/cart-item-bundle-details/cart-item-bundle-details-component.html'
		});
}());
(function() {
	'use strict';

	var currentCount = 0;

	angular
		.module('components')
		.controller('CustomerQuantityComponentController', CustomerQuantityComponentController);

	/**
	 * Our component constructor
	 * @public
	 * @constructor
	 * @name CustomerQuantityComponentController
	 * @memberof {component.customer-quantity}
	 * @param {Service} Language The language service
	 * @param {Service} Utilities Utilities
	 * @param {Service} UtilsValidation UtilsValidation
	 * @return {self} A new component instance
	 * @ngInject
	 */
	function CustomerQuantityComponentController(Language, Utilities, UtilsValidation) {
		var isRealObject = UtilsValidation.isRealObject,
			validNumber = UtilsValidation.validNumber,
			validString = UtilsValidation.validString,
			checkProp = Utilities.safelyCheckPropertyOnObject,
			returnValue = Utilities.returnValue;

		var vm = this;
		vm.onDecrement = onDecrement;
		vm.onIncrement = onIncrement;
		vm.i18n = Language;
		vm.onInputChanged = onInputChanged;
		vm.shouldDisable = shouldDisable;
		vm.$onInit = $onInit;
		vm.$onChanges = $onChanges;

		/**
		 * Bind values to our controller after initializing
		 * @public
		 * @constructor
		 * @returns {undefined}
		 */
		function $onInit() {
			if (!validString(vm.inputUniqueId)) {
				vm.inputUniqueId = 'cq-counter-' + currentCount++;
			}

			if (!validNumber(vm.maxQuantity) && parseInt(vm.maxQuantity, 10) !== 0) {
				vm.maxQuantity = Infinity;
			}

			if (!validNumber(vm.minQuantity)) {
				vm.minQuantity = 0;
			}
		}

		/**
		 * Tells us when new data comes in.
		 * @public
		 * @function
		 * @name $onChanges
		 * @memberof {CustomerQuantityComponentController}
		 * @param {Object} changes The new data that came into the component
		 * @return {undefined}
		 */
		function $onChanges(changes) {
			var originalSelectedQuantity,
				customer = checkProp('changes.customer.currentValue', changes, returnValue),
				maxQuantity = checkProp('changes.maxQuantity.currentValue', changes, returnValue),
				inputUniqueId = checkProp('changes.inputUniqueId.currentValue', changes, returnValue);

			if (changes.inputUniqueId && validString(inputUniqueId)) {
				vm.inputUniqueId = inputUniqueId;
			}

			if (isRealObject(customer)) {
				vm.inputValue = customer.qty;
			}

			originalSelectedQuantity = vm.inputValue;

			if (isNaN(vm.inputValue)) {
				vm.inputValue = 0;
			}

			if (changes.maxQuantity && (isNaN(maxQuantity) || [false, null].indexOf(maxQuantity) !== -1)) {
				vm.maxQuantity = Infinity;
			}

			if (vm.inputValue > vm.maxQuantity) {
				vm.inputValue = vm.maxQuantity;
			}

			// Allows the quanity to decrement to 0
			vm.minQuantity = 0;

			if (vm.inputValue < 0) {
				vm.inputValue = 0;
			}

			if (customer && originalSelectedQuantity !== vm.inputValue) {
				vm.onChange(customer.type, vm.inputValue);
			}
		}

		/**
		 * Decrements the counter
		 * @public
		 * @function
		 * @name onDecrement
		 * @memberof {CustomerQuantityComponentController}
		 * @return {undefined}
		 */
		function onDecrement() {
			var qty = vm.customer.qty;
			if (qty <= 0) {
				return;
			}
			qty--;

			vm.onChange(vm.customer.type, qty);
		}

		/**
		 * Increments the counter
		 * @public
		 * @function
		 * @name onIncrement
		 * @memberof {CustomerQuantityComponentController}
		 * @return {undefined}
		 */
		function onIncrement() {
			var qty = vm.customer.qty;
			if (qty >= vm.maxQuantity) {
				return;
			} else if (qty === 0 && vm.customer.min_quantity) {
				qty += vm.customer.min_quantity;
			} else {
				qty++;
			}

			vm.onChange(vm.customer.type, qty);
		}

		/**
		 * Called when the user enters something into the input
		 * @public
		 * @function
		 * @name onInputChanged
		 * @memberof {CustomerQuantityComponentController}
		 * @param {String} qty The input value they typed in
		 * @return {undefined}
		 */
		function onInputChanged(qty) {
			var parsedQty = parseInt(qty, 10);

			if (isNaN(qty)) {
				vm.inputValue = vm.customer.qty;
				return;
			} else if (parsedQty < vm.minQuantity) {
				parsedQty = vm.minQuantity;
			} else if (parsedQty > vm.maxQuantity) {
				parsedQty = vm.maxQuantity;
			}

			vm.onChange(vm.customer.type, parsedQty);
		}

		/**
		 * Should we disable a specific button?
		 * @public
		 * @function
		 * @name shouldDisable
		 * @memberof {CustomerQuantityComponentController}
		 * @param {String} direction Test which direction?
		 * @return {Boolean} If we should disable for a specific direction
		 */
		function shouldDisable(direction) {
			var currentVal = vm.customer.qty;

			if (vm.disable) {
				return true;
			} else if (direction === 'increment' && currentVal + 1 > vm.maxQuantity) {
				return true;
			} else if (direction === 'decrement' && currentVal - 1 < vm.minQuantity) {
				return true;
			}

			return false;
		}
	}
}());

(function() {
	'use strict';

	angular
		.module('components')
		.component('customerQuantity', {
			bindings: {
				customer: '<',
				disableMaxQuantity: '<',
				disableMinQuantity: '<',
				disabled: '<',
				fixSelectionOnOne: '<',
				inputUniqueId: '<',
				maxQuantity: '<',
				minQuantity: '<',
				onChange: '<',
				readOnlyInput: '<'
			},
			controller: 'CustomerQuantityComponentController',
			controllerAs: 'vm',
			templateUrl: 'scripts/components/customer-components/customer-quantity/customer-quantity-component.html'
		});
}());

(function() {
	'use strict';

	angular
		.module('components')
		.component('alertMessage', {
			bindings: {
				alertType: '<',
				iconClass: '<',
				onClose: '='
			},
			controllerAs: 'vm',
			templateUrl: 'scripts/components/alert-message/alert-message-component.html',
			transclude: true
		});
})();

(function() {
	'use strict';

	angular
		.module('components')
		.component('messageBanner', {
			bindings: {
				outlineColor: '<?',
				infoTextColor: '<?',
				infoText: '<?'
			},
			controllerAs: 'vm',
			templateUrl: 'scripts/components/message-banner/message-banner-component.html',
			transclude: true
		});
})();

(function() {
	'use strict';

	angular
		.module('components')
		.component('truncateLocale', {
			bindings: {
				callbackFunction: '&',
				numberLimit: '<',
				stringText: '@'
			},
			controller: 'truncateLocaleComponentController',
			controllerAs: 'vm',
			templateUrl: 'scripts/components/truncate-locale/truncate-locale-component.html'
		});
}());
(function() {
	'use strict';
	angular
		.module('components')
		.controller('truncateLocaleComponentController', truncateLocaleComponentController);
	/**
	* Our component constructor
	* @public
	* @constructor
	* @name truncateLocaleComponentController
	* @memberof {component.customer-quantity}
	* @param {Service} Language The language service
	* @return {self} A new component instance
	* @ngInject
	*/
	function truncateLocaleComponentController(Language) {
		var vm = this,
			elipsis = Language.getLocale('TruncateLocale', 'elipsis');
		vm.showMoreInfo = false;
		vm.triggerCallbackFunction = triggerCallbackFunction;
		vm.$onInit = $onInit;
		/**
		 * Initialize the component
		 * @function
		 * @protected
		 * @returns {undefined}
		 */
		function $onInit() {
			if (vm.numberLimit > 0 && vm.stringText.length > vm.numberLimit) {
				vm.shortenText = vm.stringText.substring(0, vm.numberLimit) + elipsis;
				if (vm.callbackFunction) {
					vm.showMoreInfo = true;
				}
			} else if (vm.numberLimit > 0 && vm.stringText.length < vm.numberLimit) {
				vm.shortenText = vm.stringText;
			}
		}

		/**
		 * Trigger the call back function when clicking on moreinfo locale
		 * @function
		 * @public
		 * @returns {undefined}
		 */
		function triggerCallbackFunction() {
			vm.callbackFunction();
		}
	}
})();
(function() {
	'use strict';

	angular
		.module('components')
		.component('packageDisplay', {
			bindings: {
				// These functions are bound one-way instead of functional binding because it breaks otherwise (??)
				available: '<', /* function(package, ct) returns the total available for a package. Return undefined (or don't define the function) if you have no data  */
				backgroundImage: '<', /* function(package) returns a background image for the package */
				buttonClick: '<', /* function(package) performs the action of the button described by buttonText */
				buttonText: '<', /* function(package) returns the text of a button, if a button is supposed to be displayed on tha package */
				configuration: '<', /* Additional configuration, consumed by specific templates */
				deconflictCustomerTypesBy: '<',
				// If you want to disable the bootstrap col-xs-12 col-sm-4 classes
				disableBootstrap: '<?',
				highlightClass: '<', /* function(package) returns an additional class that used as a highlight on the package */
				image: '<', /* function(package) returns an image for the package */
				layout: '<', /* use to select the layout of the package list, see package-display-controller.js getTemplateUrl() for more details */
				localeSection: '@',
				pkg: '=',
				pkgDate: '<', /* function(package) returns the selected date for a given package. Only needed if pkgTimes is being used */
				respondToQuantity: '<', /* function(package, ct) called every time the quantity of a CT changes */
				respondToTime: '<', /* function(package, time) called every time the time of a pkg changes */
				times: '<' /* function(package) returns a list of times (on pkgDate) that the package is available. */
			},
			controller: 'PackageDisplayController',
			controllerAs: 'vm',
			template: '<ng-include src="vm.template"/>'
		});
}());

(function () {
	'use strict';

	var DECONFLICT_BY_QUANTITY = 'quantity';

	angular
		.module('components')
		.controller('PackageDisplayController', PackageDisplayController);

	/**
	 * PackageDisplayController
	 * @public
	 * @param {Scope} $rootScope The rootscope
	 * @param {Service} AppData Our AppData service
	 * @param {Service} DynamicPricingService Our Dynamic Pricing Service
	 * @param {Service} Enums Our Enums Service
	 * @param {Service} Language Our Language Service
	 * @param {Service} Modal Our Modal Service
	 * @param {Service} Utilities Our Utilities Service
	 * @param {Service} UtilsValidation Our UtilsValidation Service
	 * @returns {undefined}
	 * @ngInject
	 */
	function PackageDisplayController($rootScope, AppData, DynamicPricingService, Enums, Language, Modal, Utilities, UtilsValidation) {
		var vm = this,
			validArray = UtilsValidation.validArray,
			getLocale = Language.getLocale,
			forceInt = Utilities.forceInt,
			orderByDisplayOrder = Utilities.orderByDisplayOrder,
			isFunction = angular.isFunction,
			relativeFilePath = '/scripts/components/package-display/';

		vm.template = '';
		vm.includeGatePrice = false;
		vm.i18n = Language;

		// Methods
		vm.$onInit = $onInit;
		vm.deconflictByQuantity = deconflictByQuantity;
		vm.disableAllIncrementation = disableAllIncrementation;
		vm.onSelectTime = onSelectTime;
		vm.getCurrentQuantity = getCurrentQuantity;
		vm.getTemplateUrl = getTemplateUrl;
		vm.getBackgroundImage = getBackgroundImage;
		vm.getImage = getImage;
		vm.getButtonText = getButtonText;
		vm.getButtonClick = getButtonClick;
		vm.getHighlightClass = getHighlightClass;
		vm.isSoldOut = isSoldOut;
		vm.samePrice = samePrice;
		vm.gatePrice = gatePrice;
		vm.onlinePrice = onlinePrice;
		vm.getPkgDate = getPkgDate;
		vm.showTimeMenu = showTimeMenu;
		vm.disableMinusBtn = disableMinusBtn;
		vm.disablePlusBtn = disablePlusBtn;
		vm.maxAvailable = maxAvailable;
		vm.showInfoModal = showInfoModal;
		vm.handleDynamicPricing = handleDynamicPricing;
		vm.incrementQty = incrementQty;
		vm.decrementQty = decrementQty;
		vm.onQtyChange = onQtyChange;
		vm.getPackageImage = getPackageImage;
		vm.deconflictCustomerTypesByQuantity = deconflictCustomerTypesByQuantity;
		vm.toggleContent = toggleContent;
		vm.showContent = true;
		vm.showLess = false;

		/**
		 * Initialize the component
		 * Specifically, set up pk.CT quantities, min-max quantities, and some locales.
		 * @public
		 * @returns {undefined}
		 */
		function $onInit() {
			vm.template = vm.getTemplateUrl();
			vm.perPersonLabel = getLocale('FormLabels', 'perPersonLabel');
			vm.soldOutLabel = getLocale('FormLabels', 'soldOut');
			vm.originalPackage = angular.copy(vm.pkg);

			// loop through CTs to do some prep and error checking
			if (angular.isObject(vm.pkg) && validArray(vm.pkg.CT)) {
				vm.pkg.CT.forEach(function cleanCT(customerType) {
					// If any gate prices have been defined, we need to show the gate price
					vm.includeGatePrice = vm.includeGatePrice || customerType.gate_price;
					// make the qty an integer so that it can be manipulated. If it's not there, create it.
					customerType.qty = customerType.qty ? forceInt(customerType.qty) : 0;
				});

				orderByDisplayOrder(vm.pkg.CT);

				/* eslint-disable camelcase */
				vm.max_quantity = vm.pkg.max_quantity ? forceInt(vm.pkg.max_quantity) : 0;
				vm.min_quantity = vm.pkg.min_quantity ? forceInt(vm.pkg.min_quantity) : 0;
				/* eslint-disable camelcase */
			}

			if (vm.includeGatePrice) {
				vm.gatePriceLabel = getLocale('FormLabels', 'gatePrice');
			}

			vm.onlinePriceLabel = getLocale('FormLabels', 'onlinePrice');
		}

		/**
		 * Returns the template we should use.
		 * @returns {String} the template src
		 */
		function getTemplateUrl() {
			Utilities.cacheBustAndLazyLoad([relativeFilePath + '/styles/tile-compact.css']);
			switch (vm.layout) {
				case 0:
					return relativeFilePath + 'views/list-tile.html';
				case 1:
					return relativeFilePath + 'views/list-one-column.html';
				case 2:
					return relativeFilePath + 'views/list-one-column-simple.html';
				case 3:
					return relativeFilePath + 'views/list-with-image.html';
				case 4:
					vm.bannerColor = (vm.configuration && vm.configuration.bannerColor) || '#368FD3';
					vm.bannerTextColor = (vm.configuration && vm.configuration.bannerTextColor) || '#FFFFFF';
					return relativeFilePath + 'views/list-tile-compact.html'
				case 5:
					return relativeFilePath + 'views/list-tile-expanded.html';
				default:
					return relativeFilePath + 'views/list-tile.html';
			}
		}

		/**
		 * Returns the background image.
		 * @param {Object} pkg The package
		 * @returns {String} The url to the background image
		 */
		function getBackgroundImage(pkg) {
			if (isFunction(vm.backgroundImage)) {
				return vm.backgroundImage(pkg);
			}
			return '';
		}

		/**
		 * Returns the image file name of a package
		 * @param {Object} pkg The package
		 * @returns {String} the image filename
		 */
		function getImage(pkg) {
			if (isFunction(vm.image)) {
				return vm.image(pkg);
			}
			return '';
		}

		/**
		 * Returns the button text.
		 * @param {Object} pkg The package
		 * @returns {String} button text
		 */
		function getButtonText(pkg) {
			if (isFunction(vm.buttonText)) {
				return vm.buttonText(pkg);
			}
			return '';
		}

		/**
		 * Handles the button click event.
		 * @param {Object} pkg The package
		 * @returns {undefined}
		 */
		function getButtonClick(pkg) {
			if (isFunction(vm.buttonClick)) {
				vm.buttonClick(pkg);
			}
		}

		/**
		 * Returns the highlight class.
		 * @param {Object} pkg The package
		 * @returns {String} the highlight class
		 */
		function getHighlightClass(pkg) {
			if (isFunction(vm.highlightClass)) {
				return vm.highlightClass(pkg)
			}
			return '';
		}

		/**
		 * Find out if the package is sold out.
		 * @param {Object} pkg The package
		 * @param {Object} ct The customer type
		 * @returns {Boolean} true/false
		 */
		function isSoldOut(pkg, ct) {
			return (vm.maxAvailable(pkg, ct) < 1);
		}

		/**
		 * Find out if the gate and online price are the same
		 * @param {Object} ct The customer type
		 * @returns {Boolean} true/false
		 */
		function samePrice(ct) {
			return Number(vm.gatePrice(ct)) === Number(vm.onlinePrice(ct));
		}

		/**
		 * Returns the gate price for a customer type
		 * @param {Object} ct The customer type
		 * @returns {Number} the price to display
		 */
		function gatePrice(ct) {
			return ct.gate_price ? ct.gate_price : 0;
		}

		/**
		 * Returns the online price for a customer type
		 * @param {Object} ct The customer type
		 * @returns {Number} the price to display
		 */
		function onlinePrice(ct) {
			return Utilities.getTotalPrice(ct);
		}

		/**
		 * Returns the package's date
		 * @param {Object} pkg The package
		 * @returns {String} the formatted date
		 */
		function getPkgDate(pkg) {
			if (isFunction(vm.pkgDate)) {
				return vm.pkgDate(pkg);
			}
			return '';
		}

		/**
		 * Find out if we should show the time menu
		 * @returns {boolean} true/false
		 */
		function showTimeMenu() {
			return validArray(vm.times);
		}

		/**
		 * Find out if we should disable the minus button
		 * @param {Object} pkg The package
		 * @param {Object} ct The customer type
		 * @returns {boolean} true/false
		 */
		function disableMinusBtn(pkg, ct) {
			return forceInt(ct.qty) <= 0;
		}

		/**
		 * Find out if we should disable the plus button
		 * @param {Object} pkg The package
		 * @param {Object} ct The customer type
		 * @returns {Boolean} true/false
		 */
		function disablePlusBtn(pkg, ct) {
			if (forceInt(ct.qty) >= vm.maxAvailable(pkg, ct)) {
				return true;
			} else if (vm.deconflictCustomerTypesBy === DECONFLICT_BY_QUANTITY) {
				return vm.disableAllIncrementation();
			}
			return false;
		}

		/**
		 * Returns the max available
		 * @param {Object} pkg The package
		 * @param {Object} ct The customer type
		 * @returns {Number} The max available
		 */
		function maxAvailable(pkg, ct) {
			var available;

			if (vm.deconflictCustomerTypesBy === 'customer_id' && !isNaN(ct.max_quantity)) {
				return ct.max_quantity;
			}

			// if the available function is defined, get its value.
			// if it returns undefined, act as though the function has not been defined.
			available = isFunction(vm.available) ? vm.available(pkg, ct) : undefined;
			if (available === undefined) {
				return vm.max_quantity;
			}

			return vm.max_quantity > available ? available : vm.max_quantity;
		}

		/**
		 * Shows the package modal
		 * @param {Object} pkg The package to display
		 * @returns {undefined}
		 */
		function showInfoModal(pkg) {
			Modal.displayModal({
				action: 'Show Package Details',
				buttonFlags: [Enums.buttonFlags.OK],
				category: 'Package Info',
				description: '<p>' + pkg.desc + '</p>',
				desktop: true,
				image: AppData.assets.url + pkg.shop_image_v4,
				label: pkg.name,
				title: pkg.name
			});
		}

		/**
		 * Toggles the content of the Addons card
		 * @returns {undefined}
		 */
		function toggleContent() {
			vm.showContent = !vm.showContent;
		}

		/**
		 * Find out if we should disable incrementing on all customer types.
		 * @returns {Boolean} if we're at the maximum number of quantities allowed.
		 */
		function disableAllIncrementation() {
			return vm.getCurrentQuantity(vm.pkg.CT) >= vm.max_quantity;
		}

		/**
		 * When the user selects a time
		 * @param {String|null} time The time selected
		 * @returns {undefined}
		 */
		function onSelectTime() {
			if (isFunction(vm.respondToTime)) {
				Utilities.nextTick(function next() {
					vm.respondToTime(vm.pkg, vm.pkg.T[vm.pkg.selectedTime] ? vm.pkg.T[vm.pkg.selectedTime].time : '');
				})
			}
		}

		/**
		 * Sets the dynamic pricing for a customer type.
		 * @param {Object} ct The customer type
		 * @returns {undefined}
		 */
		function handleDynamicPricing(ct) {
			DynamicPricingService.setDynamicPrice(vm.originalPackage, [ct], undefined);

			if (isFunction(vm.respondToQuantity)) {
				vm.respondToQuantity(vm.pkg, ct);
			}
		}

		/**
		 * Business Logic: The numbers between 0 and minQuantity are skipped. For example,
		 *   if minQuantity = 4,
		 *      Pressing the decrement button on 4 sets the quantity to 0
		 *      Pressing the increment button on 0 sets the quantity to 4
		 *      Entering a number between 0 and 4 sets the quantity to 0.
		 *
		 *   One way of thinking about this is that the numbers between 0 and minQuantity don't exist.
		 *   Because they don't... at least not as far as ordering is concerned.
		 * @param {Object} pkg The package
		 * @param {Object} ct The customer type
		 * @returns {undefined}
		 */
		function incrementQty(pkg, ct) {
			var currentQty,
				newRate;

			if (vm.deconflictCustomerTypesBy === DECONFLICT_BY_QUANTITY) {
				currentQty = vm.getCurrentQuantity(pkg.CT);
				if (currentQty + 1 > vm.max_quantity) {
					return;
				}

				ct.qty++;
			} else {
				newRate = forceInt(ct.qty) + 1;
				if (newRate < vm.min_quantity) {
					newRate = vm.min_quantity;
				}
				ct.qty = (newRate > vm.maxAvailable(pkg, ct)) ? vm.maxAvailable(pkg, ct) : newRate;
			}

			vm.handleDynamicPricing(ct);
		}

		/**
		 * Handles decrementing the quantity when the user clicks the minus button.
		 * @param {Object} pkg The package
		 * @param {Object} ct The customer type
		 * @returns {undefined}
		 */
		function decrementQty(pkg, ct) {
			var currentQty,
				newRate;

			if (vm.deconflictCustomerTypesBy === DECONFLICT_BY_QUANTITY) {
				currentQty = vm.getCurrentQuantity(pkg.CT);

				if (currentQty - 1 < vm.min_quantity) {
					ct.qty = 0;
				} else {
					ct.qty--;
				}
			} else {
				newRate = forceInt(ct.qty) - 1;
				ct.qty = newRate < 1 || newRate < vm.min_quantity ? 0 : newRate;
			}

			vm.handleDynamicPricing(ct);
		}

		/**
		 * Handles the user entering numbers or anything into the input between the plus and minus buttons.
		 * @param {Object} pkg  The package
		 * @param {Object} customerType  The customer type
		 * @returns {undefined}
		 */
		function onQtyChange(pkg, customerType) {
			var qty = forceInt(customerType.qty),
				newRate,
				max;

			if (vm.deconflictCustomerTypesBy === DECONFLICT_BY_QUANTITY) {
				vm.deconflictByQuantity(qty, pkg, customerType);
			} else {
				max = vm.maxAvailable(pkg, customerType);
				// apply limits
				newRate = (qty > max) ? max : qty;
				customerType.qty = newRate < 1 || newRate < vm.min_quantity ? 0 : newRate;
			}

			vm.handleDynamicPricing(customerType);
		}

		/**
		 * Deconflicts by quantity
		 * @param {Number} qty The quantity
		 * @param {Object} pkg The package
		 * @param {Object} customerType The customer type
		 * @returns {undefined}
		 */
		function deconflictByQuantity(qty, pkg, customerType) {
			var currentQty,
				i,
				q;

			if (qty < 0 || isNaN(qty)) {
				qty = 0;
			}

			customerType.qty = qty;

			currentQty = vm.getCurrentQuantity(pkg.CT);

			if (currentQty < vm.min_quantity) {
				if (currentQty <= 0) {
					customerType.qty = 0;
				} else {
					// Add until we're at the min quantity
					for (i = pkg.CT.length - 1; vm.getCurrentQuantity(pkg.CT) < vm.min_quantity; i--) {
						for (q = pkg.CT[i].qty; vm.getCurrentQuantity(pkg.CT) < vm.min_quantity; q--) {
							pkg.CT[i].qty = q;
						}
					}
				}
				// reduce until we're under or at the max quantity
			} else if (currentQty > vm.max_quantity) {
				for (i = pkg.CT.length - 1; i > -1 && vm.getCurrentQuantity(pkg.CT) > vm.max_quantity; i--) {
					for (q = pkg.CT[i].qty; q > -1 && vm.getCurrentQuantity(pkg.CT) > vm.max_quantity; q--) {
						pkg.CT[i].qty = q;
					}
				}
			}
		}

		/**
		 * Should we deconflict by total quantity?
		 * @returns {Boolean} true/false
		 */
		function deconflictCustomerTypesByQuantity() {
			return vm.deconflictCustomerTypesBy === DECONFLICT_BY_QUANTITY;
		}

		/**
		 * Returns the total quantity select for all customer types passed in.
		 * @param {Object[]} customerTypes The customer types to use
		 * @returns {Number} the total quantity of customers
		 */
		function getCurrentQuantity(customerTypes) {
			return customerTypes.reduce(function (qty, ct) {
				var customerQty = forceInt(ct.qty);
				return isNaN(customerQty) || customerQty < 0 ? qty : qty + customerQty;
			}, 0);
		}

		/**
		 * Returns a package's fully-qualified image url.
		 * @param {Object} pkg The package to use.
		 * @returns {String} the full src url
		 */
		function getPackageImage(pkg) {
			return $rootScope.getAssetUrl(pkg.shop_image_v4);
		}
	}
}());

(function() {
	'use strict';

	angular
		.module('components')
		.component('paymentMethod', {
			bindings: {
				cssImageClasses: '@',
				formModel: '=',
				imageName: '@',
				imagePath: '<',
				imageText: '<',
				label: '@',
				selectedCallback: '&',
				type: '@',
				useCssImage: '<'
			},
			controllerAs: 'vm',
			templateUrl: 'scripts/components/payment-method/payment-method-view.html'
		});
}());
/* eslint-disable default-case */
(function() {
	'use strict';

	angular
		.module('components')
		.constant('ComponentLoaderEnums', {
			accessoCalendar: 'accesso-calendar',
			cartAbandonment: 'cart-abandonment',
			cartFeeNotice: 'cart-fee-notice',
			customerQuantity: 'customer-quantity',
			estimatedSummary: 'estimated-summary',
			imageCapture: 'image-capture',
			mobileCta: 'mobile-cta',
			modalSelector: 'modal-selector',
			paymentSchedule: 'payment-schedule',
			quantity: 'quantity',
			skeleton: 'skeleton',
			snapCalendarSelector: 'snap-calendar-selector',
			snapDateTimeList: 'snap-date-time-list',
			snapPackageDetail: 'snap-package-detail',
			snapPackageResult: 'snap-package-result',
			snapRateSelector: 'snap-rate-selector',
			verticalSlider: 'vertical-slider',
		})
		.service('ComponentLoaderService', ComponentLoaderService);

	/**
	 * The Component Loader Service
	 * @constructor
	 * @param {Service} $injector $injector
	 * @param {Service} $q - The Q service
	 * @param {Service} AppData AppData
	 * @param {Service} BundleService - The Bundle Service
	 * @param {Service} ComponentLoaderEnums - The Component Loader Enums object
	 * @param {Service} Utilities - The Utilities Service
	 * @param {Service} UtilsValidation Utils Validation
	 * @returns {Service} The Component Loader Service
	 * @ngInject
	 */
	function ComponentLoaderService($injector, $q, $transitions, AppData, BundleService, ComponentLoaderEnums, Utilities, UtilsValidation) {
		var bootstrapComplete = false,
			checkProp = Utilities.checkProp,
			lazyLoad = Utilities.cacheBustAndLazyLoad,
			toArray = Utilities.wrapObjectToArray,
			validArray = UtilsValidation.validArray;

		var service = {
			areComponentsLoaded: areComponentsLoaded,
			bootstrap: bootstrap,
			getComponents: getComponents,
			hasComponents: hasComponents,
			loadComponentAssets: loadComponentAssets,
			_: {
				loadedComponents: [],
				getLoadPromises: _getLoadPromises,
				waitForLazyLoad: _waitForLazyLoad
			}
		};

		// Return our service
		return service;

		/**
		 * Checks if all of the components in the list are loaded
		 * @public
		 * @param {String[]} components - List of components to check
		 * @returns {Boolean} - True if all components are loaded, false otherwise
		 */
		function areComponentsLoaded(components) {
			return toArray(components, true).every(function(component) {
				return service._.loadedComponents.includes(component);
			});
		}

		/**
		 * This function is responsible for preloading certain components on bootstrap
		 * @returns {Promise} The bootstrap promise
		 */
		function bootstrap() {
			var hasParkHours = Utilities.getBoolean(AppData.settings.enableParkHours);
			var preloadComponents = [
				ComponentLoaderEnums.cartAbandonment,
				ComponentLoaderEnums.quantity,
			];

			// Include accessoCalendar if park hours is enabled
			if (hasParkHours) {
				preloadComponents.push(ComponentLoaderEnums.accessoCalendar);
			}

			// If we have already bootstrapped, return a resolved promise
			if (bootstrapComplete) {
				return $q.resolve();
			}

			// Load in the components
			return $q.all(service._.getLoadPromises(preloadComponents))
				.finally(function setBootstrapComplete() {
					bootstrapComplete = true;
				});
		}

		/**
		 * Gets all the components for a given state
		 * @public
		 * @param {Object} state - The state object
		 * @returns {String[]} - The list of components
		 */
		function getComponents(state) {
			var components = [];

			// Get the internal object of state that we can read the parent states from
			state = state.$$state();

			// Always run the loop at least once
			do {
				// If the state has components listed
				if (checkProp('state.components', state, 'validArray')) {
					// Iterate over the components
					state.components.forEach(function iterateComponents(component) {
						// If the component isn't already in the list
						if (!components.includes(component)) {
							// Add it to the list
							components.push(component);
						}
					});
				}

				// Move up the state chain
				state = state.parent;
			} while (state);

			return components;
		}

		/**
		 * Checks if the state has components listed
		 * @public
		 * @param {Object} state - The state object
		 * @returns {Boolean} - True if the state has components, false otherwise
		 */
		function hasComponents(state) {
			// Does the state have a internal state object?
			if (state.$$state) {
				// Get the internal object of state that we can read the parent states from
				state = state.$$state();
			}

			// Check if the state has components listed
			return checkProp('state.self.components', state, 'validArray') || state.parent && service.hasComponents(state.parent);
		}

		/**
		 * Loads in component assets if the state has the components listed
		 * @public
		 * @returns {Promise} The Loader Promise
		 */
		function loadComponentAssets(state) {
			var components = service.getComponents(state);

			// Are there no components?
			if (!validArray(components)) {
				// Resolve and exit
				return $q.resolve();
			}

			// Load in main components once prerequisites have been loaded
			return $q.all(service._.getLoadPromises(components));
		}

		/**
		 * Once prerequisite/dependency files have been loaded in, load in the main items
		 * @private
		 * @param {String[]} components The component name collection
		 * @returns {Promise} The promise chain
		 */
		function _getLoadPromises(components) {
			// Iterate over all the components
			return components.reduce(function iterateComponents(promises, component) {
				var enumName = component.toUpperCase().replace(/-/g, '_');

				service._.loadedComponents.push(component);

				switch (component) {
				case ComponentLoaderEnums.cartFeeNotice:
					promises.push(service._.waitForLazyLoad($injector.get('CART_FEE_NOTICE_ASSETS')));
					break;
				case ComponentLoaderEnums.customerQuantity:
					promises.push(service._.waitForLazyLoad($injector.get('CUSTOMER_QUANTITY_COMPONENT_ASSETS')));
					break;
				case ComponentLoaderEnums.estimatedSummary:
					promises.push(service._.waitForLazyLoad($injector.get('ESTIMATED_NOTICE_COMPONENT_ASSETS')));
					break;
				case ComponentLoaderEnums.snapPackageDetail:
					promises.push(service._.waitForLazyLoad($injector.get('SNAP_PACKAGE_DETAILS_COMPONENT_ASSETS')));
					break;
				case ComponentLoaderEnums.snapPackageResult:
					promises.push(service._.waitForLazyLoad($injector.get('SNAP_PACKAGE_RESULT_COMPONENT_ASSETS')));
					break;
				case ComponentLoaderEnums.snapCalendarSelector:
					promises.push(service._.waitForLazyLoad($injector.get('SNAP_CALENDAR_SELECTOR_COMPONENT_ASSETS').concat($injector.get('SNAP_DT_LIST_COMPONENT_ASSETS'))));
					break;
				case ComponentLoaderEnums.snapRateSelector:
					promises.push(service._.waitForLazyLoad($injector.get('SNAP_RATE_SELECTOR_COMPONENT_ASSETS')));
					break;
				default:
					// If the component is a bundle asset
					if (BundleService.enums[enumName]) {
						promises.push(BundleService.lazyLoadCollectionFiles(BundleService.enums[enumName]));
					}
				}

				// No matches, return resolved promise
				return promises;
			}, []);
		}

		/**
		 * Generates a callback function that will load in the desired assets
		 * @private
		 * @param {String[]} files - The list of files to lazy load in after we have waited for a promise to finish
		 * @returns {Function} A function callback to be called once a Promise has completed.
		 */
		function _waitForLazyLoad(files) {
			// Lazy load the assets and return a promise
			return lazyLoad(files);
		}
	}
})();
!function(){"use strict";angular.module("app").component("banner",{controller:"BannerComponentController",controllerAs:"vm",templateUrl:"scripts/components/banner/templates/banner.html"})}(),function(){"use strict";function e(e,n,t,i,o,a,r,s,u){var c=this,l=s.first,p=s.merge,g=s.nextTick,f=u.validArray;p(c,{$onInit:function(){n.$on(o.event.QUEUE_UPDATED,c._.onQueueUpdate),n.$on("feeInclusiveBannerDismissed",function(){n.showMessage&&c._.setBannerTop()}),c._.gapBannerElement=e[0].querySelector(".banner__component"),c._.resizeObserver=new ResizeObserver(c._.resizeObserverCallback),c._.resizeObserver.observe(c._.gapBannerElement)},_:{ANIMATION_TIME:250,clearBanner:function(){p(n,{icon:null,message:null,messageId:null,showMessage:!1,theme:null})},executeAction:function(n){var t;if(!angular.isFunction(n.action))return;g(function(){t=e[0].offsetTop+parseInt(e[0].style.getPropertyValue("--banner-height"),10),n.action(t)})},gapIconElement:e[0].querySelector(".banner__icon"),onQueueUpdate:function(e,i){if(!f(i))return n.showMessage?t(function(){c._.setContainerHeight(0)},c._.ANIMATION_TIME):c._.setContainerHeight(0),void c._.clearBanner();if(l(i).id===n.messageId)return;if(n.showMessage)return n.showMessage=!1,void g(function(){t(c._.setMessage,c._.ANIMATION_TIME)});c._.setMessage()},resizeObserver:null,resizeObserverCallback:function(){if(!n.showMessage)return;g(function(){c._.setContainerHeight(c._.gapBannerElement.offsetHeight),c._.setBannerTop()})},setContainerHeight:function(n){e[0].style.setProperty("--banner-height",(n||0)+"px")},setMessage:function(){var e,a=l(i.api.queue);if(!a)return void t(function(){c._.setContainerHeight(0)},c._.ANIMATION_TIME);e=o.typeConfig[a.type],p(n,{callback:a.callback||null,closeText:a.closeText||null,icon:e.icon,message:a.message,messageId:a.id,theme:e.theme}),g(function(){c._.setContainerHeight(c._.gapBannerElement.offsetHeight),c._.executeAction(a),t(function(){n.showMessage=!0,c._.setBannerTop()},c._.ANIMATION_TIME)})},setBannerTop:function(){e[0].style.setProperty("--banner-top",e[0].offsetTop+"px")}}}),p(n,{closeMessage:function(){n.showMessage=!1,angular.isFunction(n.callback)&&n.callback(a.buttonFlags.CLOSE);t(function(){i.removeMessage(),c._.setMessage()},c._.ANIMATION_TIME)},icon:null,getLocale:r.getLocaleMerchant,message:null,messageId:null,showMessage:!1,theme:null})}e.$inject=["$element","$scope","$timeout","Banner","BannerEnums","Enums","Language","Utilities","UtilsValidation"],angular.module("app").controller("BannerComponentController",e)}(),function(){"use strict";function e(e,n,t,i,o,a){var r=o.checkProp,s=o.getString,u=o.sortArrayMultiple,c=a.validArray,l=a.validObject,p={api:{queue:[]},addMessage:function(e,n,t,o,a,u,c){var g={message:s(e),action:a,condition:{isScope:!1,source:o},priority:100,type:n,persistent:u,closeText:c||null};angular.isFunction(t)&&(g.callback=t);l(i.typeConfig[n])||(g.type=i.type.DEFAULT);if(p._.isMessageInQueue(e,n))return-1;if("Scope"===r("condition.constructor.name",o,"returnValue")){if(g.condition.isScope=!0,o.$$destroyed)return-1}else angular.isNumber(o)&&(g.condition.source=p._.generateTimeoutClosure(o));g.priority=i.typeConfig[g.type].priority,p._.addToQueue(g),p._.heartbeatActive||p._.setupHearbeatValidator();return g.id},clearAllMessages:function(){p._.clearAllMessages(),p._.broadcastMessageUpdate()},removeMessage:function(e){var n;angular.isNumber(e)&&(n=p.api.queue.findIndex(function(n){return n.id===e}));p.api.queue.splice(n||0,1),p._.broadcastMessageUpdate()},_:{addToQueue:function(n){n.id=p._.queueIndex++,p.api.queue.push(n),u(p.api.queue,"priority,id",!1),e.state.showBanner=!0,p._.broadcastMessageUpdate()},broadcastMessageUpdate:function(){e.$broadcast(i.event.QUEUE_UPDATED,p.api.queue)},clearAllMessages:function(){p.api.queue=p.api.queue.filter(function(e){return!0===e.persistent})},generateTimeoutClosure:function(e){var t=!1;return n(function(){t=!0},e),function(){return t}},heartbeatActive:!1,initialize:function(){t.onEnter({},p.clearAllMessages)},isMessageInQueue:function(e,n){return p.api.queue.some(function(t){return t.message===e&&t.type===n})},queueIndex:1,setupHearbeatValidator:function(){p._.heartbeatActive=!0,n(function e(){c(p.api.queue)?(p._.validateMessages(),n(e,1e3)):p._.heartbeatActive=!1},1e3)},validateMessages:function(){p.api.queue.forEach(function(e){(e.condition.isScope&&e.condition.source.$$destroyed||angular.isFunction(e.condition.source)&&e.condition.source())&&p.removeMessage(e.id)})}}};return p._.initialize(),p}e.$inject=["$rootScope","$timeout","$transitions","BannerEnums","Utilities","UtilsValidation"],angular.module("app").factory("Banner",e)}(),function(){"use strict";angular.module("app").constant("BannerEnums",{event:{QUEUE_UPDATED:"BANNER_QUEUE_UPDATED"},type:{DEFAULT:"DEFAULT",DEFAULT_NO_ICON:"DEFAULT_NO_ICON",ERROR:"ERROR",INFO:"INFO",SUCCESS:"SUCCESS",WARNING:"WARNING"},typeConfig:{DEFAULT:{icon:"help-outline",priority:100,theme:null},DEFAULT_NO_ICON:{icon:null,priority:100,theme:null},INFO:{icon:"info-outline",priority:50,theme:"tertiary"},ERROR:{icon:"priority-high-outline",priority:0,theme:"error"},SUCCESS:{icon:"check-outline",priority:75,theme:"success"},WARNING:{icon:"warning-outline",priority:25,theme:"warning"}}})}();
!function(){"use strict";angular.module("app").constant("GetMerchantPackageEventDatesModel",{dates:[{$:"D",date:"date:date",package:{id:"package_id:intarray"},times:[{$:"T",available:"!available:int",capacity:"!capacity:int",description:"?description:string",duration:"duration:int",externalId:"?external_id:int",minutes:"time:minutes",performanceCode:"?performance_code:string",time:"time:string",timeblock:"?timeblock:string",used:"!used:int"}]}],flags:{reservationAvailability:"GetReservationAvailability:boolean"},info:{month:"?month:int",year:"?year:int"},status:"status:string"})}(),function(){"use strict";angular.module("app").constant("GetKeywordCalendarModel",{dates:[{$:"DATES.D",date:"date:date",lowest:{price:"lowest_price:float",customerType:"?lowest_price_customer_type:int",package:"?lowest_price_package_price:int",savings:"?lowest_price_savings:float"},packages:[{$:"PS.P",id:"id:int",name:"name:string",event:{id:"event_id:int",available:"available:int",capacity:"capacity:int"},customer:[{$:"CT",id:"id:int",pricing:{retail:"retail_amount:float",tax:"tax_amount:float"},dynamicPricing:{maxDiscount:"?DYNAMIC_PRICING.max_discount_percentage:float",discountedRetail:"?DYNAMIC_PRICING.max_discounted_retail_amount:float",discountedTax:"?DYNAMIC_PRICING.max_discounted_tax_amount:float"}}]}]}],info:{anyDayTicket:"?any_day_ticket:int",image:"?keyword_image:string"},status:"status:string"})}(),function(){"use strict";angular.module("app").constant("GetWizardMpEventDatesModel",{dates:[{$:"D",capacity:"capacity:int",date:"date:date"}],info:{month:"month:int"},package:{id:"package_id:int"},status:"status:string"})}(),function(){"use strict";angular.module("app").constant("GetMPCTCalendarCustomerModel",{available:"?available:int",id:"id|type:int",name:"?name:string",pricing:{dynamic:{$:"?DYNAMIC_PRICING",fee:"?fee:float",id:"?id:int",per:"?total_amount/qty|retail_amount:float",perFee:"?fee/qty|fee:float",perTax:"?tax/qty|tax:float",qty:"?qty:int",tax:"?tax:float",total:"?total_amount:float"},per:"?DYNAMIC_PRICING.total_amount/DYNAMIC_PRICING.qty|retail_amount:float",retail:"retail_amount:float"},qty:"?qty:int"}).constant("GetMPCTCalendarModel",{dates:[{$:"DATES.D",available:"?available:int",date:"date:date",packages:[{$:"PS.P",customer:[{$:"?CT:GetMPCTCalendarCustomerModel"}],id:"id:int",times:[{$:"?T",available:"available:int",customer:[{$:"CT:GetMPCTCalendarCustomerModel"}],time:"time:time"}]}]}],flags:{hasDates:"!has_available_dates:boolean",isTimed:"!DATES.D[].0.PS.P[].0.T:boolean"},status:"status:string"})}(),function(){"use strict";angular.module("app").constant("PaymentScheduleModel",{id:"?id:int",payments:"PAYMENT[].length:int",schedule:[{$:"PAYMENT",adjustment:{amount:"?ca_amount:float",tax:"?ca_tax_amount:float"},date:"?date:date",order:"?index:int",pricing:{fee:"?fee_amount:float",retail:"?retail_amount:float",ship:"?ship_amount:float",tax:"?tax_amount:float",total:"?total_amount:float"}}]})}();
(function() {
	'use strict';

	angular
		.module('app')
		.config(accessoCalendarPreviewConfig);

	/**
	 * The Accesso Calendar Preview Module Config
	 * @constructor
	 * @param {Service} $stateProvider - The State Provider service
	 * @param {Object} ComponentLoaderEnums - The Component Loader Enums object
	 * @returns {undefined}
	 * @ngInject
	 */
	function accessoCalendarPreviewConfig($stateProvider, ComponentLoaderEnums) {
		$stateProvider
			.state('accesso-calendar', {
				abstract: true,
				components: [ ComponentLoaderEnums.accessoCalendar ],
				resolve: {
					initialData: function initialData(Bootstrap) {
						return Bootstrap.bootstrapApplication();
					},
					loadPreviewAssets: function loadPreviewAssets(initialData, BundleService) {
						return BundleService.lazyLoadCollectionFiles(BundleService.enums.ACCESSO_CALENDAR_PREVIEW);
					},
				},
			})
			.state('accesso-calendar.component', {
				controller: 'AccessoCalendarComponentPreviewController',
				controllerAs: 'vm',
				templateUrl: 'accesso-calendar-preview:component',
				url: '/preview/accesso-calendar-component',
			})
			.state('accesso-calendar.datepicker', {
				controller: 'AccessoCalendarDatepickerPreviewController',
				controllerAs: 'vm',
				templateUrl: 'accesso-calendar-preview:datepicker',
				url: '/preview/accesso-calendar-datepicker',
			});
	}
})();
(function() {
	'use strict';
	/**
	 * # Global logging module
	 *
	 * This is a global set of hooks that catch all $log messages sent out by the
	 * application. Currently they are simply passed off directly to console.log
	 * but this could be updated later to allow them to be stored locally, sent to
	 * a server etc.
	 */
	angular
		.module('logging', [])
		.config(function($provide) {
			$provide.decorator('$log', function($delegate, Logging) {
				var service = {
					debug: createLogger('log'),
					error: createLogger('error'),
					info: createLogger('info'),
					log: createLogger('log'),
					warn: createLogger('warn')
				};

				return service;

				/**
				 * Creates a logger based on a type
				 * @param {String} type Either 'log', 'info', 'warn', or 'error'
				 * @returns {Function} The function to use as the logger
				 */
				function createLogger(type) {
					return function() {
						if (Logging.enabled) {
							$delegate[type].apply(null, arguments);
						}
					}
				}
			})
		})
		.service('Logging', function() {
			return { enabled: true };
		});
}());
(function () {
	'use strict';

	angular
		.module('promo-code', [])
		.config(config);

	/**
	 * Our state provider
	 * @constructor
	 * @param {Service} $stateProvider State Provider
	 * @returns {undefined}
	 * @ngInject
	 */
	function config($stateProvider) {
		$stateProvider
			.state('promo-code', {
				resolve: {
					initialData: function ($rootScope, Bootstrap) {
						$rootScope.showSpinner();
						return Bootstrap.bootstrapApplication(undefined, true);
					},
					loadAssets: function (initialData, Utilities) {
						return Utilities.cacheBustAndLazyLoad([
							'/scripts/modules/promo-code/promo-code.css'
						]);
					}
				},
				templateUrl: '/scripts/modules/promo-code/promo-code.html',
				title: 'promocode',
				url: '/promo-code',

				controller: function($scope, $timeout) {
					$timeout(function setInputFocus() {
						var element = document.getElementById('promobox-nav');
						if (element) {
							element.focus();
						}
						// adding a delay because the focus is being set to the #application-view div which has a tabindex of -1
					}, 400);
				}
			});
	}
}());
angular.module('donation-message', ['app']);
angular.module('date-picker', []);
angular.module('date-picker')
	.directive('datePicker'
		, function( $rootScope,
					Language,
					Utilities,
					$templateCache,
					BaseCalendarTemplateConstant,
					AppData){
			return {
				restrict: 'E',
				require:'ngModel',
				templateUrl: '/scripts/modules/date-picker/directives/views/date-picker.html',
				scope: {
					"ngModel":"="
				},
				link: function( scope, element, attrs, ngModelCtrl ){
					scope.opened = false;
					scope.format = AppData.settings.date_format;
					scope.allowedDates = getAllowedDates();
					scope.placeHolder = Language.getLocale('datePicker', 'placeHolder');
					var selectedDate = scope.ngModel;
					function getAllowedDates(){
						var allowedDates = [];
						var minDate = new Date();
						var maxDate = new Date();
						maxDate.setYear(minDate.getFullYear() + 1);

						var currentDate = new Date();
						var d;

						while (currentDate <= maxDate) {
							d = new Date(currentDate);
							d.setHours(12, 0, 0, 0 );
							allowedDates.push(d.getTime());
							currentDate.setDate(d.getDate()+1); // add one day
						}

						return allowedDates;

					}

					scope.overrideYearRestriction = false;
					if(Utilities.getBoolean(AppData.settings['disable_year_restriction'])) {
						scope.overrideYearRestriction = true;
					}

					scope.currentMonthInfo = {
						currentMonth: new Date().getMonth() + 1,
						currentMonthObject : new Date()
					};

					$templateCache.put('uib/template/datepicker/day.html', BaseCalendarTemplateConstant.bootstrap);

					scope.open = function(){
						if (angular.equals(selectedDate,scope.ngModel)) {
							scope.opened = true;
						} else {
							selectedDate = scope.ngModel;
						}
					};

					/*
					 * Called after $setViewValue - will take the viewValue and apply it to the original model
					 */
					ngModelCtrl.$parsers.push( function( viewValue ){

						if( angular.isDefined( viewValue ) ){

							return  viewValue;
						}
					});
				}
			}
		});

angular.module('characters-remaining', []);
angular.module('characters-remaining')
.directive('charactersRemaining', function() {
	return {
		restrict: 'E',
		scope: {
			crModel: "=",
			crMaxLength: "@"
		},
		template: '<small class="pull-right subtle-text">{{ crMaxLength - crModel.length }} characters remaining</small>'
	}
});

/**
 * Created by ltischuk on 11/12/14.
 */
angular.module('cabanas',
	['app'])
	.constant("CabanasConstants", {
		"CABANA_ROUTE" : 'cabanas',
		"LOCALES":{
			"CABANA_SECTION": 'Cabanas',
			"GEN_TITLE": 'cabanaErrorTitle',
			"RESOURCE_REQ_ERR": 'cabanaResourceRequestError',
			"RESERVED": 'reservedLabel',
			"AVAILABLE": 'availableLabel',
			"SELECT_NUM_CABANAS_TITLE": 'pleaseSelectNumCabanasTitle',
			"SELECT_NUM_CABANAS_MSG" : 'pleaseSelectNumCabanasMsg',
			"CABANA_MAX_ERROR_TITLE": 'cabanaReachedMaxErrorTitle',
			"CABANA_MAX_ERROR_MSG": 'cabanaReachedMaxErrorMsg'
		},
		"LABEL_POSITIONS":{
			"RIGHT": 'right',
			"LEFT": 'left',
			"BOTTOM": 'bottom',
			"TOP": 'top'
		}
	})
	.config(function ($locationProvider, $stateProvider) {

		$stateProvider
			.state('cabanas', {
				abstract: true,
				url: '/cabanas/:packageId',
				templateUrl: '/scripts/modules/extraflow/cabanas/views/cabanas.html',
				controller: 'CabanasController',
				resolve: {
					//resolve failures are handled within run.js of main app
					load: function( $rootScope, Utilities ){
						$rootScope.showSpinner();

						return Utilities.cacheBustAndLazyLoad([
							'/scripts/modules/extraflow/cabanas/controllers/cabanas-controller.js',
							'/scripts/modules/extraflow/cabanas/services/cabanas-settings-service.js',
							'/scripts/modules/extraflow/cabanas/services/cabanas-legacy-configuration-service.js',
							'/scripts/modules/extraflow/cabanas/cabanas-models.js',
							'/scripts/modules/extraflow/cabanas/directives/cabanas-map-directive.js',
							'/scripts/modules/extraflow/cabanas/services/cabanas-scaler-service.js',
							'/scripts/modules/extraflow/cabanas/services/cabanas-image-preloader-service.js',
							'/scripts/modules/extraflow/cabanas/directives/cabanas-location-directive.js',
							'/scripts/modules/extraflow/cabanas/directives/cabanas-resource-directive.js',
							'/scripts/modules/extraflow/cabanas/services/cabanas-resource-request-service.js',
							'/scripts/modules/extraflow/cabanas/services/cabanas-service.js'
						]);
					},
					initialData: function(load, Bootstrap) {
						return Bootstrap.bootstrapApplication();
					},
					xfcMap: function(initialData, Package) {
						return Package.buildXFCMap();
					},
					   assessRoute: function(xfcMap,RouteRejectionService,Package,$state,$transition$){

						//if we are routing backward and the next state is the resource-selection, we need to reject the route
						//because xfcMap will reroute to the cabana parent, which defaults to cabanas.location-selection route
						//this will prevent dupe requests for resources
						if(!Package.isForwardExtraFlowRouting() && $state.next.name === 'cabanas.resource-selection'){
							throw new RouteRejectionService.UnrecoverableException('cabanas',{packageId :$transition$.params().packageId});
						}else{
							return true;
						}
					},
					resources: function(assessRoute, $injector, $transition$) {
						return $injector.get('CabanasResourceRequestService').requestResources($transition$.params().packageId);
					},
					model: function(resources, $injector) {
						return $injector.get('CabanasSettingsService').getModelFromSettings(resources);
					},
					imageLoadResult: function(model, $injector) {
						return $injector.get('CabanasImagePreloaderService').preloadImages(model);
					}
				},
				onEnter: function($rootScope){
					$rootScope.hideSpinner();
				}
			})
			.state('cabanas.location-selection',{
				url: '',
				templateUrl: '/scripts/modules/extraflow/cabanas/views/location-selection.html'
			})
			.state('cabanas.resource-selection',{
				url: '/resource-selection',
				templateUrl: '/scripts/modules/extraflow/cabanas/views/resource-selection.html'
			})
	})
	.run(function(ExtraFlow, CabanasConstants){
		// Register this extra flow module with the extra flow service
		ExtraFlow.registerXMC
			( 'cabana',
				{ name: 'cabana',
					view: CabanasConstants.CABANA_ROUTE,
					showCapacityRemaining: false,
					showTimeList: true,
					doEditMode: false,
					lockQuantity: true,
					writeSingleCharac: false,
					enabled: true,
					type: 'extraFlowControl',
					characsList:['resource_id']
				}
			);
	});

(function() {
	/* eslint-disable sort-keys */
	'use strict';

	angular.module('experience-scheduler', ['utilities']);		
})();

(function() {
	/* eslint-disable sort-keys */
	'use strict';

	angular
		.module('experience-scheduler')
		.config(config)
		.run(run);

	/**
	 * Registers our routing
	 * @public
	 * @param {Provider} $stateProvider For setting up routing
	 * @return {undefined}
	 * @ngInject
	 */
	function config($stateProvider) {
		var MODULE_DIRECTORY = 'scripts/modules/extraflow/experience-scheduler',
			COMPOSITION_DIRECTORY = 'scripts/modules/composition-library',
			TRIP_SELECT_DIRECTORY = 'scripts/modules/alternate-modules/trip-select',
			DEFAULT_FILES = [
				COMPOSITION_DIRECTORY + '/compose-keyword.js',
				COMPOSITION_DIRECTORY + '/compose-selected-date.js',
				COMPOSITION_DIRECTORY + '/customer/compose-customer-types.js',
				COMPOSITION_DIRECTORY + '/calendar/compose-start-date-override.js',
				COMPOSITION_DIRECTORY + '/calendar/compose-calendar-dates.js',
				MODULE_DIRECTORY + '/models/experience-scheduler-state-model.js',
				MODULE_DIRECTORY + '/services/experience-scheduler-utilities-service.js',
				TRIP_SELECT_DIRECTORY + '/services/trip-select-utilities-service.js',
				TRIP_SELECT_DIRECTORY + '/services/trip-select-data-service.js',
				TRIP_SELECT_DIRECTORY + '/trip-select-constants.js'
			];

		$stateProvider
			.state('experience-scheduler', {
				controller: 'ExperienceSchedulerCalendarController',
				controllerAs: 'vm',
				resolve: {
					initialData: initialData,
					buildXFCMap: buildXFCMap,
					initXFC: initXFC,
					loadAssets: function(initialData, Utilities) {
						return Utilities.cacheBustAndLazyLoad(DEFAULT_FILES.concat([
							MODULE_DIRECTORY + '/calendar/experience-scheduler-calendar-controller.js'
						]));
					},
					currentPackageModifications: getCurrentPackageModifications,
					stateModel: function($injector, $transition$, currentPackageModifications, Package) {
						var stateModel = new ($injector.get('ExperienceSchedulerStateModel'))(),
							packageId = $transition$.params().packageId;

						stateModel.validatePackageDetails(Package.packageDetails, packageId);
						stateModel.setKeyword(Package.packageDetails.keyword.split(',')[0]);
						stateModel.initializeCustomerTypes(currentPackageModifications, packageId);

						return stateModel;
					},
					initialCalendarData: function($injector, stateModel, Package) {
						return $injector.get('TripSelectDataService').fetchDatesForRoute(Package.packageDetails.CHARACS, stateModel.keyword, null, null, -1, stateModel.getCustomerTypes());
					}
				},
				templateUrl: MODULE_DIRECTORY + '/calendar/experience-scheduler-calendar.html',
				url: '/experience-scheduler/:packageId'
			})
			.state('experience-scheduler-times', {
				controller: 'ExperienceSchedulerTimesController',
				controllerAs: 'vm',
				resolve: {
					initialData: initialData,
					buildXFCMap: buildXFCMap,
					initXFC: initXFC,
					loadAssets: function(initialData, Utilities) {
						return Utilities.cacheBustAndLazyLoad(DEFAULT_FILES.concat([
							MODULE_DIRECTORY + '/components/time-selection/time-selection-component.js',
							MODULE_DIRECTORY + '/components/time-selection/time-selection-controller.js',
							COMPOSITION_DIRECTORY + '/scheduling/compose-scheduling.js',
							MODULE_DIRECTORY + '/times/experience-scheduler-times-controller.js',
							MODULE_DIRECTORY + '/times/experience-scheduler-times.css'
						]));
					},
					currentPackageModifications: getCurrentPackageModifications,
					stateModel: function($injector, $transition$, currentPackageModifications,  Package) {
						var stateModel = new ($injector.get('ExperienceSchedulerStateModel'))(),
							toParams = $transition$.params(),
							packageId = toParams.packageId;

						stateModel.validatePackageDetails(Package.packageDetails, packageId);
						stateModel.validateAndSetDate(toParams.selectedDate, packageId);
						// Since we do not get keywords in XFC's, we need to grab the first one in the keyword property.
						stateModel.setKeyword(Package.packageDetails.keyword.split(',')[0]);
						stateModel.initializeCustomerTypes(currentPackageModifications, packageId);

						return stateModel;
					},
					currentRouteTimes: function($injector, Package, stateModel) {
						return $injector.get('TripSelectDataService').fetchTimesForRoute(stateModel.keyword, Package.packageDetails.CHARACS, stateModel.customerTypes, stateModel.selectedDate);
					},
					checkTimes: function($transition$, currentRouteTimes, RouteRejectionService) {
						if (currentRouteTimes === null) {
							throw new RouteRejectionService.ViewException('TripSelect', 'noTimeErrorAlert', 'noTimeDesc', 'experience-scheduler', $transition$.params());
						}
					}
				},
				templateUrl: MODULE_DIRECTORY + '/times/experience-scheduler-times.html',
				url: '/experience-scheduler/times/{keyword:keyword}/:packageId/:selectedDate/:customerTypesHash/:routeId'
			});

		/**
		 * Makes sure we are bootstrapped.
		 * @public
		 * @param {Service} Bootstrap The bootstrap service
		 * @return {Promise} A promise of bootstrapping
		 * @ngInject
		 */
		function initialData(Bootstrap) {
			return Bootstrap.bootstrapApplication();
		}

		/**
		 * Makes sure we are bootstrapped.
		 * @public
		 * @param {Service} $transition$ To get our params
		 * @param {Promise} buildXFCMap Our promise to build XFC maps. This is a dependency of this function and must be completed before calling htis.
		 * @param {Service} Enums The service
		 * @param {Service} Package The service
		 * @param {Service} RouteRejectionService The servicve
		 * @throws {RouteRejectionService.UnrecoverableException}
		 * @return {undefined}
		 * @ngInject
		 */
		function initXFC($transition$, buildXFCMap, Enums, Package, RouteRejectionService) {
			var packageId = $transition$.params().packageId;
			var rejectRoute = Package.assessRoutabilityOfXFC(packageId);

			if (rejectRoute.length) {
				throw new RouteRejectionService.UnrecoverableException(rejectRoute);
			} else if (isNaN(Package.packageDetails.CHARACS.route_id)) {
				throw new RouteRejectionService.UnrecoverableException(Enums.routes.DETAILS + '/' + packageId);
			}
		}

		/**
		 * Builds and returns our XFC map.
		 * @public
		 * @param {Promise} loadAssets The load assets dependency. It must resolve before this gets called.
		 * @param {Service} Package the service
		 * @return {Promise} A promise of our xfc's
		 * @ngInject
		 */
		function buildXFCMap(loadAssets, Package) {
			return Package.buildXFCMap();
		}

		/**
		 * Returns the current package modifications
		 * @public
		 * @param {Promise} loadAssets A promise to load our route specific assets.
		 * @param {Service} Package the service
		 * @return {object[]} Our modifications to the current package
		 * @ngInject
		 */
		function getCurrentPackageModifications(loadAssets, Package) {
			return Package.itemsToBeAdded.filter(function(pkg) {
				return pkg.package_id === Package.packageDetails.id && !isNaN(pkg.qty) && pkg.qty > 0;
			});
		}
	}

	/**
	 * Registers the xmc.
	 * @public
	 * @param {Service} ExtraFlow The extra flow service
	 * @return {undefined}
	 * @ngInject
	 */
	function run(ExtraFlow) {
		ExtraFlow.registerXMC('experience-scheduler', {
			doEditMode: false,
			enabled: true,
			itemHasAnEditableXMC: false,
			lockQuantity: true,
			name: 'experience-scheduler',
			type: 'extraFlowControl',
			view: 'experience-scheduler'
		});
	}
})();

(function() {
	'use strict';

	angular.module('composition-library', ['utilities']);
}());

(function() {
	'use strict';

	angular
		.module('restricted-packages', ['utilities'])
		.factory('RESTRICTED_PACKAGES_ASSETS', function() {
			var COMPONENT_DIR = '/scripts/modules/restricted-packages/restricted-package-user';
			return [
				COMPONENT_DIR + '/restricted-package-user-component.js',
				COMPONENT_DIR + '/restricted-package-user-component.html'
			];
		});
}());
(function() {
	'use strict';

	angular
		.module('restricted-packages')
		.factory('RestrictedPackagesService', RestrictedPackagesService);

	/**
	 * Our restricted package servce
	 * @param {Scope} $rootScope The root scope
	 * @param {Service} $state $state
	 * @param {Service} AppData AppData
	 * @param {Service} Enums enums
	 * @param {Service} ExtraFlow Extra Flow
	 * @param {Service} Package Package service
	 * @param {Service} Utilities Utils
	 * @param {Service} UtilsValidation validation
	 * @returns {self} new instance
	 * @ngInject
	 */
	function RestrictedPackagesService($rootScope, $state, AppData, Enums, ExtraFlow, Package, Utilities, UtilsValidation) {
		var validString = UtilsValidation.validString,
			isArray = Array.isArray,
			validArray = UtilsValidation.validArray,
			getBoolean = Utilities.getBoolean,
			returnValue = Utilities.returnValue,
			isRealObject = UtilsValidation.isRealObject,
			returnOrDefault = UtilsValidation.returnOrDefault,
			checkProp = Utilities.safelyCheckPropertyOnObject,
			RESTRICTED_KEYWORD = 'Restricted',
			RESTRICTED_PACKAGE_CHARAC = 'is_restricted_package';

		var service = {
			_initialize: _initialize,
			_localeData: {},
			_packages: {},
			_restrictedNavTree: null,
			doRouting: doRouting,
			filterCalendarPricingPackageOverrides: filterCalendarPricingPackageOverrides,
			filterPackagesByKeyword: filterPackagesByKeyword,
			getLocaleData: getLocaleData,
			getMenuItemForKeyword: getMenuItemForKeyword,
			getModuleByPackage: getModuleByPackage,
			getRestrictedNavTree: getRestrictedNavTree,
			hasPackagesLoaded: hasPackagesLoaded,
			hasRegisteredPackagesForKeyword: hasRegisteredPackagesForKeyword,
			isRestrictedPackage: isRestrictedPackage,
			registerPackageList: registerPackageList,
			reset: reset,
			restrictedPackageLoaded: restrictedPackageLoaded,
			setLocaleData: setLocaleData
		};

		service._initialize();

		return service;

		/**
		 * Initialize the service.
		 * @returns {undefined}
		 */
		function _initialize() {
			var listener;

			if (AppData.applicationInitialized) {
				service._restrictedNavTree = service.getRestrictedNavTree();
				return;
			}

			listener = $rootScope.$on(Enums.services.APP_ACTIVATED, function() {
				service._restrictedNavTree = service.getRestrictedNavTree();

				listener();
			});
		}

		/**
		 * Find out if we have any restricted packages loaded.
		 * @returns {Boolean} if we have any packages loaded
		 */
		function hasPackagesLoaded() {
			return Object.keys(service._packages).some(function(key) {
				return validArray(service._packages[key]);
			});
		}

		/**
		 * Find out which module a package id is assigned to.
		 * @param {String} packageId The package id
		 * @returns {String} the module where the package resides.
		 */
		function getModuleByPackage(packageId) {
			var keys = Object.keys(service._localeData);
			var index = keys.findIndex(function(key) {
				return service._packages[key].some(function(pkg) {
					return packageId === pkg.id;
				});
			});

			index = index !== -1 ? index : 0;

			return keys[index];
		}

		/**
		 * Find if we have a restricted package loaded.
		 * @param {String} packageId The package id
		 * @returns {Boolean} if we have it loaded or not.
		 */
		function restrictedPackageLoaded(packageId) {
			return Object.keys(service._packages).some(function(key) {
				return service._packages[key].some(function(pkg) {
					return packageId === pkg.id;
				});
			});
		}

		/**
		 * Find out if a package is a restricted package.
		 * @param {String|PackageObject} packageIdOrObject The package id.
		 * @returns {Boolean} if it's restricted or not.
		 */
		function isRestrictedPackage(packageIdOrObject) {
			var pkg = validString(packageIdOrObject) ? Package.getPackageByID(packageIdOrObject) : packageIdOrObject;
			return checkProp('pkg.CHARACS.' + RESTRICTED_PACKAGE_CHARAC, pkg, getBoolean);
		}


		/**
		 * Registers a package list by a module.
		 * @public
		 * @param {String} moduleName The module that is registering it.
		 * @param {Object[]} packages The packages to register.
		 * @returns {undefined}
		 */
		function registerPackageList(moduleName, packages) {
			if (!validString(moduleName) || !isArray(packages)) {
				return;
			}

			service._packages[moduleName] = packages.slice(0);
		}

		/**
		 * Filters packages that are restricted.
		 * @param {Object[]} packages The packages to filter
		 * @param {String} keyword The keyword to find
		 * @param {Boolean} selectRestricted If you only want to select the restrcited packages
		 * @returns {Object[]} the packages that are restricted
		 */
		function filterPackagesByKeyword(packages, keyword, selectRestricted) {
			var filtered = [];
			keyword = trimToLower(keyword);
			selectRestricted = getBoolean(selectRestricted);

			if (!validArray(packages) || !validString(keyword)) {
				return filtered;
			}

			return packages.reduce(function(acc, pkg) {
				var keywords;
				var isRestricted = checkProp('pkg.CHARACS.' + RESTRICTED_PACKAGE_CHARAC, pkg, getBoolean);

				if ((selectRestricted && isRestricted && service.restrictedPackageLoaded(pkg.id)) || (!isRestricted && !selectRestricted)) {
					keywords = returnOrDefault(checkProp('pkg.keyword', pkg, returnValue), '', validString);
					if (keywords.split(',').map(trimToLower).indexOf(keyword) > -1) {
						acc.push(pkg);
					}
				}
				return acc;
			}, filtered);
		}

		/**
		 * Find out if we have registered packages.
		 * @param {String} keyword The keyword to search for.
		 * @returns {Boolean} if we have any or not
		 */
		function hasRegisteredPackagesForKeyword(keyword) {
			var keys = Object.keys(service._packages);
			keyword = trimToLower(keyword);

			if (!validString(keyword) || !keys.length) {
				return false;
			}

			return keys.some(function(key) {
				if (!validArray(service._packages[key])) {
					return false;
				}

				return service._packages[key].some(function(pkg) {
					var keywords = returnOrDefault(checkProp('pkg.keyword', pkg, returnValue), '', validString);
					return keywords.split(',').map(trimToLower).indexOf(keyword) > -1;
				});
			});
		}

		/**
		 * Handles routing for a module or sends them to the sub keyword module.
		 * @public
		 * @param {String} moduleName The module name to try and find.
		 * @param {String} promoCode The promocode coming from wtp/promocode flow
		 * @returns {undefined}
		 */
		function doRouting(moduleName, promocode) {
			var restrictedNavTree = service.getRestrictedNavTree(),
				packageKeywords,
				packageIds,
				packages,
				foundMenuItem,
				path,
				view,
				pkg;

			if (validArray(service._packages[moduleName])) {
				packages = service._packages[moduleName].slice(0);
			} else {
				packages = Object
					.keys(service._packages)
					.reduce(function(acc, key) {
						return acc.concat(service._packages[key]);
					}, []);
			}

			// If there's only one, try and route them to the alternate module. Otherwise, send them to package details.
			if (packages.length === 1) {
				pkg = packages.pop();
				packageKeywords = returnOrDefault(checkProp('package.keyword', pkg, returnValue), '', validString).split(',').map(trimToLower);

				if (restrictedNavTree) {
					foundMenuItem = restrictedNavTree.MENUITEM.find(function(menuItem) {
						return returnOrDefault(checkProp('menuItem.keywords', menuItem, returnValue), '', validString)
							.split(',')
							.map(trimToLower)
							.some(function(keyword) {
								return packageKeywords.indexOf(keyword) > -1;
							});
					});
				}

				if (foundMenuItem) {
					view = ExtraFlow.getAlternateFlowView(foundMenuItem.alternateModule, foundMenuItem.keyword);
					if (view) {
						path = ExtraFlow.isAlternateFlowViewRepresentedAsAStateName(foundMenuItem.alternateModule) ? '' : ('/' + foundMenuItem.keywords);
						return $rootScope.routeTo(view + path);
					}
				}

				return $rootScope.routeTo($state.href('/packageDetails/:packageId', { packageId: pkg.id, promocode: promocode }));

			// If someone added a alternate module to the main Restricted nav item, go there.
			} else if (checkProp('restrictedNavTree.alternateModule', restrictedNavTree, validString)) {
				view = ExtraFlow.getAlternateFlowView(restrictedNavTree.alternateModule, RESTRICTED_KEYWORD);
				if (view) {
					path = ExtraFlow.isAlternateFlowViewRepresentedAsAStateName(restrictedNavTree.alternateModule) ? '' : ('/' + RESTRICTED_KEYWORD);
					return $rootScope.routeTo(view + path);
				}
			}

			// If it doesn't match the above, route to packagelist
			packageIds = packages
				.map(function(pkg) {
					return pkg.id;
				})
				.join();

			$rootScope.routeTo($state.href('packageList/packages/:packages', { packages: packageIds }));
		}

		/**
		 * Deregisters packages by a module.
		 * @param {String} moduleName The module that is dregistering.
		 * @returns {undefined}
		 */
		function reset(moduleName) {
			delete service._packages[moduleName];
			delete service._localeData[moduleName];
		}

		/**
		 * Returns the locale data to use.
		 * @public
		 * @param {String} moduleName The module name
		 * @returns {Object} the locale data.
		 */
		function getLocaleData(moduleName) {
			return returnOrDefault(service._localeData[moduleName], {}, isRealObject);
		}

		/**
		 * Sets the locale data to use.
		 * @public
		 * @param {String} moduleName The module name
		 * @param {String} name The users name
		 * @param {String} title The title to use with the package-override-user component.
		 * @param {String} description The description to use with the package-override-user component.
		 * @returns {undefined}
		 */
		function setLocaleData(moduleName, name, title, description) {
			if (!validString(moduleName)) {
				return;
			}

			service._localeData[moduleName] = {
				description: returnOrDefault(description, '', validString),
				name: returnOrDefault(name, '', validString),
				title: returnOrDefault(title, '', validString)
			};
		}

		/**
		 * Finds the menu item for a keyword.
		 * @param {String} keywords The keywords as a string
		 * @param {Object[]} menuItems The menu items
		 * @returns {Object|undefined} The menu item if found.
		 */
		function getMenuItemForKeyword(keywords, menuItems) {
			if (!validString(keywords) || !validArray(menuItems)) {
				return;
			}

			keywords = keywords
				.split(',')
				.map(trimToLower);

			return menuItems.find(function(tree) {
				if (!validString(tree.keywords)) {
					return;
				}

				return tree.keywords
					.split(',')
					.map(trimToLower)
					.some(function(keyword) {
						return keywords.indexOf(keyword) > -1;
					});
			})
		}

		/**
		 * Returns the nav tree corresponding to the override keyword.
		 * @returns {Object|undefined} The nav tree item if found.
		 */
		function getRestrictedNavTree() {
			var items = AppData.menuItems,
				found;

			if (service._restrictedNavTree !== null) {
				return service._restrictedNavTree;
			}

			if (!validArray(items)) {
				service._restrictedNavTree = false;
				return false;
			}

			found = items.find(function(tree) {
				return returnOrDefault(tree.keywords, '', validString).split(',').some(function(keyword) {
					return keyword === RESTRICTED_KEYWORD;
				});
			});

			service._restrictedNavTree = found ? found : false;

			return service._restrictedNavTree;
		}

		/**
		 * Returns a string lowercased and trimmed.
		 * @param {String} str The string to use
		 * @returns {String} The string
		 */
		function trimToLower(str) {
			return returnOrDefault(str, '', validString).trim().toLowerCase();
		}

		/**
		 * Filters and modifies the array passed in.
		 * @param {Object[]} response The calendar data.
		 * @param {Boolean} selectRestricted Allow only restricted packages
		 * @returns {undefined}
		 */
		function filterCalendarPricingPackageOverrides(response, selectRestricted) {
			var dates,
				removeDateIndecies;

			dates = checkProp('data.DATES.D', response, returnValue);
			removeDateIndecies = [];

			if (!validArray(dates)) {
				return;
			}

			dates.reduce(function(acc, date, dateIndex) {
				var item = checkProp('date.PS.P', date, returnValue),
					removeItemIndecies = [];

				if (!validArray(item) && !isRealObject(item)) {
					acc.push(dateIndex);
					return acc;
				}

				// If it came back as a single object we need to fix that...
				if (!isArray(item)) {
					date.PS.P = item = [item];
				}

				item.reduce(function(acc, itemData, itemIndex) {
					var pkg = Package.getPackageByID(itemData.id);
					var isRestricted = checkProp('pkg.CHARACS.' + RESTRICTED_PACKAGE_CHARAC, pkg, getBoolean);
					// Remove any that aren't restricted packages
					if ((!selectRestricted && isRestricted) || (selectRestricted && !isRestricted) || (selectRestricted && isRestricted && !service.restrictedPackageLoaded(pkg.id))) {
						acc.push(itemIndex);
					}

					return acc;
				}, removeItemIndecies);

				removeItemIndecies.reverse().forEach(function(index) {
					item.splice(index, 1);
				});

				if (!item.length) {
					acc.push(dateIndex);
				}

				return acc;
			}, removeDateIndecies);

			removeDateIndecies.reverse().forEach(function(index) {
				dates.splice(index, 1);
			});
		}
	}
}());
(function() {
	'use strict';

	angular.module('simplified-calendar', ['utilities', 'app']);
})();
/* eslint-disable sort-keys */
(function() {
	'use strict';

	angular
		.module('simplified-calendar')
		.config(config)
		.run(run);

	/**
	 * Sets up routing for the Resource module
	 * @public
	 * @function
	 * @name config
	 * @memberof {Resource Selector}
	 * @param {Provider} $locationProvider To setup global params
	 * @param {Provider} $stateProvider Lets us set up state
	 * @returns {undefined}
	 * @ngInject
	 */
	function config($locationProvider, $stateProvider) {

		var MODULE = '/scripts/modules',
			MODULE_DIRECTORY = MODULE + '/alternate-modules/simplified-calendar',
			DEFAULT_FILES = [
				MODULE_DIRECTORY + '/simplified-calendar-data-service.js',
				MODULE_DIRECTORY + '/simplified-calendar-controller.js',
				MODULE_DIRECTORY + '/simplified-calendar.html',
				MODULE_DIRECTORY + '/simplified-calendar.css'
			];

		$stateProvider
			.state('simplified-calendar', {
				controller: 'SimplifiedCalendarController',
				controllerAs: 'vm',
				resolve: {
					initialData: initializeData,
					previousState: buildPreviousState,
					loadAssets: function(initialData, previousState, Utilities) {
						return Utilities.cacheBustAndLazyLoad(DEFAULT_FILES);
					}
				},
				title: 'simplifiedCalendar',
				templateUrl: MODULE_DIRECTORY + '/simplified-calendar.html',
				url: '/simplified-calendar/:keyword'
			});
	}

	/**
	 * Register our alternate module
	 * @public
	 * @function
	 * @name run
	 * @param {Service} ExtraFlow The extra flow service.
	 * @returns {undefined}
	 * @ngInject
	 */
	function run(ExtraFlow) {
		ExtraFlow.registerXMC('simplified-calendar', {
			doEditMode: false,
			enabled: true,
			itemHasAnEditableXMC: false,
			lockQuantity: true,
			name: 'simplified-calendar',
			type: 'alternateFlowModule',
			view: 'simplified-calendar'
		});
	}

	/**
	 * Resolves the bootstrap promise
	 * @public
	 * @function
	 * @name initializeData
	 * @param {Service} Bootstrap The bootstrap service
	 * @param {Service} $rootScope You know what this is.
	 * @returns {Promise} A promise that we bootstrapped
	 * @ngInject
	 */
	function initializeData(Bootstrap, $rootScope) {
		$rootScope.showSpinner();
		return Bootstrap.bootstrapApplication(undefined, true);
	}

	/**
	 * Resolves the current state so that once the page resolves, it will have the previous state.
	 * @public
	 * @function
	 * @name buildPreviousState
	 * @param {Object} $state The state before we resolve to the new state
	 * @returns {Object} the previous state
	 * @ngInject
	 */
	function buildPreviousState($state) {
		return {
			name: $state.current.name,
			params: $state.params
		};
	}
})();
(function() {
	'use strict';

	angular
		.module('trip-select', ['ui.router', 'ngResource']);
}());

(function() {
	/* eslint-disable sort-keys */
	'use strict';

	angular
		.module('trip-select')
		.config(config)
		.run(run);

	/**
	 * Sets up routing for the Boat Trip module
	 * @public
	 * @function
	 * @name config
	 * @memberof {TripSelect}
	 * @param {Provider} $locationProvider To setup global params
	 * @param {Provider} $stateProvider Lets us set up state
	 * @return {undefined}
	 * @ngInject
	 */
	function config($locationProvider, $stateProvider) {
		var MODULE_DIRECTORY = '/scripts/modules/alternate-modules/trip-select',
			COMPOSITION_DIRECTORY = '/scripts/modules/composition-library',
			DEFAULT_FILES = [
				COMPOSITION_DIRECTORY + '/calendar/compose-start-date-override.js',
				COMPOSITION_DIRECTORY + '/customer/compose-customer-types.js',
				COMPOSITION_DIRECTORY + '/compose-keyword.js',
				COMPOSITION_DIRECTORY + '/scheduling/compose-scheduling.js',
				MODULE_DIRECTORY + '/models/trip-select-state-model.js',
				MODULE_DIRECTORY + '/services/trip-select-utilities-service.js',
				MODULE_DIRECTORY + '/services/trip-select-data-service.js',
				MODULE_DIRECTORY + '/services/trip-select-tracking-service.js',
				MODULE_DIRECTORY + '/styles/trip-select.css',
				MODULE_DIRECTORY + '/trip-select-constants.js'
			];

		$stateProvider
			.state('trip-select', {
				controller: 'TripSelectTravelPlannerController',
				controllerAs: 'vm',
				resolve: {
					initialData: initializeData,
					previousState: buildPreviousState,
					loadAssets: function(initialData, Utilities) {
						return Utilities.cacheBustAndLazyLoad(DEFAULT_FILES.concat([
							MODULE_DIRECTORY + '/components/trip-type-option/trip-type-option-component.js',
							MODULE_DIRECTORY + '/components/trip-type-option/trip-type-option-controller.js',
							MODULE_DIRECTORY + '/travel-planner/trip-select-travel-planner-controller.js'
						]));
					},
					stateModel: buildStateModel,
					currentKeywordRoutes: fetchCurrentKeywordRoutes,
					checkState: function(currentKeywordRoutes, stateModel, $state) {
						stateModel.loadFromParams($state.toParams, currentKeywordRoutes);
					},
					finalizeRoute: function(checkState, $rootScope) {
						$rootScope.hideSpinner();
					}
				},
				params: {
					routeId: {
						squash: true,
						value: null
					},
					customerTypesHash: {
						squash: true,
						value: null
					}
				},
				templateUrl: MODULE_DIRECTORY + '/travel-planner/trip-select-travel-planner.html',
				url: '/trip-select/{keyword:keyword}/:routeId/:customerTypesHash'
			})
			.state('trip-select-calendar', {
				controller: 'TripSelectCalendarController',
				controllerAs: 'vm',
				resolve: {
					initialData: initializeData,
					previousState: buildPreviousState,
					loadAssets: function(initialData, Utilities) {
						return Utilities.cacheBustAndLazyLoad(DEFAULT_FILES.concat([
							MODULE_DIRECTORY + '/calendar/trip-select-calendar-controller.js',
							COMPOSITION_DIRECTORY + '/calendar/compose-dynamic-pricing-calendar-dates.js',
							'/scripts/modules/base-calendar/dynamic-pricing-calendar/dynamic-pricing-calendar.html',
							'/scripts/modules/base-calendar/dynamic-pricing-calendar/dynamic-pricing-calendar.css'
						]));
					},
					stateModel: buildStateModel,
					currentKeywordRoutes: fetchCurrentKeywordRoutes,
					checkState: function(currentKeywordRoutes, $state, RouteRejectionService, stateModel) {
						stateModel.loadFromParams($state.toParams, currentKeywordRoutes);

						if (!stateModel.inValidState()) {
							throw new RouteRejectionService.ViewException('TripSelect', 'routeErrorAlert', 'missingInfoDesc', 'trip-select', $state.toParams.keyword);
						}
					},
					initialCalendarData: function(checkState, $injector, stateModel) {
						return $injector.get('TripSelectDataService').fetchDatesForRoute(stateModel.route, stateModel.keyword, null, null, -1, stateModel.customerTypes);
					},
					finalizeRoute: function(initialCalendarData, $rootScope) {
						$rootScope.hideSpinner();
					}
				},
				templateUrl: MODULE_DIRECTORY + '/calendar/trip-select-calendar.html',
				url: '/trip-select/calendar/{keyword:keyword}/:routeId/:customerTypesHash'
			})
			.state('trip-select-times', {
				controller: 'TripSelectTimesController',
				controllerAs: 'vm',
				resolve: {
					initialData: initializeData,
					previousState: buildPreviousState,
					loadAssets: function(initialData, Utilities) {
						return Utilities.cacheBustAndLazyLoad(DEFAULT_FILES.concat([
							MODULE_DIRECTORY + '/components/location-time/location-time-component.js',
							MODULE_DIRECTORY + '/components/location-time/location-time-controller.js',
							MODULE_DIRECTORY + '/components/trip-status-bar/trip-status-bar.html',
							MODULE_DIRECTORY + '/components/trip-status-bar/trip-status-bar-component.js',
							MODULE_DIRECTORY + '/components/trip-status-bar/trip-status-bar-component-controller.js',
							MODULE_DIRECTORY + '/times/trip-select-times-controller.js'
						]));
					},
					stateModel: buildStateModel,
					currentKeywordRoutes: fetchCurrentKeywordRoutes,
					stateCheck: function(currentKeywordRoutes, $state, RouteRejectionService, stateModel, TripSelectUtilitiesService) {
						var selectedDate = $state.toParams.selectedDate;
						stateModel.loadFromParams($state.toParams, currentKeywordRoutes);

						if (!stateModel.inValidState()) {
							throw new RouteRejectionService.ViewException('TripSelect', 'missingErrorAlert', 'missingErrorDesc', 'trip-select', { keyword: $state.toParams.keyword });
						}

						if (!TripSelectUtilitiesService.validDateSelected(selectedDate, 'yyyy-mm-dd', '-')) {
							throw new RouteRejectionService.ViewException('TripSelect', 'dateErrorAlert', 'dateErrorDesc', 'trip-select-calendar', $state.toParams);
						}

						stateModel.selectedDate = TripSelectUtilitiesService.getParsedDate(selectedDate, 'yyyy-mm-dd', '-');
					},
					currentRouteTimes: function($injector, stateModel, stateCheck) {
						return $injector.get('TripSelectDataService').fetchTimesForRoute(stateModel.keyword, stateModel.route, stateModel.customerTypes, stateModel.selectedDate);
					},
					currentRoutePricing: function($filter, $injector, stateCheck, stateModel, TripSelectUtilitiesService) {
						var selectedDate = $filter('date')(stateModel.selectedDate, 'yyyy-MM-dd');

						return $injector
							.get('TripSelectDataService')
							.fetchDatesForRoute(stateModel.route, stateModel.keyword, selectedDate, selectedDate, null, stateModel.customerTypes)
							.then(TripSelectUtilitiesService.getFilterDatesBySelectedDate(selectedDate));
					},
					checkTimes: function(currentRouteTimes, $state, RouteRejectionService) {
						if (currentRouteTimes === null) {
							throw new RouteRejectionService.ViewException('TripSelect', 'noTimeErrorAlert', 'noTimeDesc', 'trip-select-calendar', $state.toParams);
						}
					},
					finalizeRoute: function(currentRouteTimes, $rootScope) {
						$rootScope.hideSpinner();
					}
				},
				templateUrl: MODULE_DIRECTORY + '/times/trip-select-times.html',
				url: '/trip-select/times/{keyword:keyword}/:routeId/:customerTypesHash/:selectedDate'
			});
	}

	/**
	 * Our run method for trip-select
	 * @public
	 * @function
	 * @name run
	 * @param {Service} ExtraFlow The etra flow service.
	 * @return {undefined}
	 */
	function run(ExtraFlow) {
		ExtraFlow.registerXMC('trip-select', {
			doEditMode: false,
			enabled: true,
			itemHasAnEditableXMC: false,
			lockQuantity: true,
			name: 'trip-select',
			type: 'alternateFlowModule',
			view: 'trip-select'
		});
	}

	/**
	 * Resolves the bootstrap promise
	 * @public
	 * @function
	 * @name initializeData
	 * @param {Service} Bootstrap The bootstrap service
	 * @param {Service} $rootScope You know what this is.
	 * @return {Promise} A promise that we bootstrapped
	 * @ngInject
	 */
	function initializeData(Bootstrap, $rootScope) {
		return Bootstrap.bootstrapApplication().then(function() {
			$rootScope.showSpinner();
		});
	}

	/**
	 * Resolves the current state so that once the page resolves, it will have the previous state.
	 * @public
	 * @function
	 * @name buildPreviousState
	 * @param {Object} $state The state before we resolve to the new state
	 * @return {Object} the previous state
	 * @ngInject
	 */
	function buildPreviousState($state) {
		return {
			name: $state.current.name,
			params: $state.params
		};
	}

	/**
	 * Resolves our keyword routes
	 * @public
	 * @function
	 * @name fetchCurrentKeywordRoutes
	 * @param {Service} $injector The injector service
	 * @param {Object} stateModel The state so we can grab the keyword
	 * @return {Promise} A promise to fetch our data
	 */
	function fetchCurrentKeywordRoutes($injector, stateModel) {
		return $injector.get('TripSelectDataService').fetchRoutesByKeyword(stateModel.getKeyword());
	}

	/**
	 * Resolves our stateModel and throws an exception if we have an invalid keyword
	 * @public
	 * @function
	 * @name stateModel
	 * @param {Promise} loadAssets We need this so that the resolved promise is a dependency of this function
	 * @param {Service} $injector The injector service
	 * @param {Service} $transition$ The transisition service
	 * @param {Service} RouteRejectionService So we can reject the route
	 * @return {Object} the state model
	 * @ngInject
	 */
	function buildStateModel(loadAssets, $injector, $transition$, RouteRejectionService) {
		var stateModel,
			TripSelectStateModel = $injector.get('TripSelectStateModel');

		try {
			stateModel = new TripSelectStateModel($transition$.params().keyword);
		} catch (err) {
			throw new RouteRejectionService.UnrecoverableException();
		}

		return stateModel;
	}
}());

(function() {
	'use strict';

	angular
		.module('simple-store', ['app', 'utilities']);
})();
(function() {
	'use strict';

	angular
		.module('simple-store')
		.factory('SimpleStoreRoutingService', SimpleStoreRoutingService);

	/**
	 * The Simple Store's routing service.
	 * @public
	 * @constructor
	 * @param {Service} $location $location
	 * @param {Scope} $rootScope $rootScope
	 * @param {Service} AppData For app data
	 * @param {Service} CustomActionService CustomActionService
	 * @param {Service} ExtraFlowValidationService ExtraFlowValidationService
	 * @param {Service} JSONValidator For validating our app configs
	 * @param {Service} Package For getting package details
	 * @param {Service} RouteRejectionService For rejecting route
	 * @param {Service} Utilities Utils
	 * @param {Service} UtilsValidation For validation
	 * @returns {Service} our public api
	 * @ngInject
	 */
	function SimpleStoreRoutingService($location, $rootScope, AppData, CustomActionService, ExtraFlowValidationService, JSONValidator, Package, RouteRejectionService, Utilities, UtilsValidation) {
		var validString = UtilsValidation.validString,
			validArray = UtilsValidation.validArray,
			isNumeric = UtilsValidation.isNumeric,
			isArray = Array.isArray,
			isRealObject = UtilsValidation.isRealObject,
			isSimpleStore = null,
			additionalValidRoutes = null;

		var service = {
			_changePostPurchaseRoute: _changePostPurchaseRoute,
			blockRoutingAwayFromSimpleStore: blockRoutingAwayFromSimpleStore,
			ensureHasKeyword: ensureHasKeyword,
			ensureHasPackageId: ensureHasPackageId,
			getAdditionalValidRoutes: getAdditionalValidRoutes,
			isValidRoute: isValidRoute,
			simpleStoreConfigured: simpleStoreConfigured,
			throwAndGoToKeyword: throwAndGoToKeyword
		};

		return service;


		/**
		 * Find out if the simple store is configured.
		 * @public
		 * @function
		 * @returns {Boolean} if its configured or not.
		 */
		function simpleStoreConfigured() {
			if (isSimpleStore !== null) {
				$rootScope.whiteBackground = isSimpleStore;

				return isSimpleStore;
			}

			isSimpleStore = $location.search().ignore_simple_store !== '1' && JSONValidator.validate('simpleStore', AppData.settings.simpleStore);

			if (isSimpleStore) {
				service._changePostPurchaseRoute();
			}

			return isSimpleStore;
		}

		/**
		 * Ensures the route has a keyword. If not, it tries to find the first one and redirects there.
		 * @public
		 * @param {Object} stateParams The state Params
		 * @throws {RouteRejectionService.UnrecoverableException} To reroute
		 * @returns {undefined}
		 */
		function ensureHasKeyword(stateParams) {
			var keyword = stateParams.keyword;
			if (validString(keyword)) {
				return;
			}

			service.throwAndGoToKeyword();
		}

		/**
		 * Ensures the route has a keyword. If not, it tries to find the first one and redirects there.
		 * @public
		 * @param {Object} stateParams The state params
		 * @throws {RouteRejectionService.UnrecoverableException} To reroute
		 * @returns {undefined}
		 */
		function ensureHasPackageId(stateParams) {
			var packageId = stateParams.packageId;

			// Make sure its a number and we can find the package.
			if (isNumeric(packageId) && Package.getPackageByID(stateParams.packageId)) {
				return;
			}

			service.throwAndGoToKeyword(stateParams.keyword);
		}

		/**
		 * Throws a route rejection and sends them to the simple store keyword route with the provided keyword.
		 * @public
		 * @param {String|null} keyword The keyword to use, if not provieded we find the first one available
		 * @throws {RouteRejection.UnrecoverableException}
		 * @return {undefined}
		 */
		function throwAndGoToKeyword(keyword) {
			if (!validString(keyword)) {
				keyword = ((AppData.GetMerchantKeywords || {}).keywords || '').split(',')[0].trim();
			}

			throw new RouteRejectionService.UnrecoverableException('simple-store.keyword', { keyword: keyword }, true);
		}

		/**
		 * Is this a valid simple store route?
		 * @public
		 * @param {Object} toState The route's toState
		 * @param {Object} toParams The routes toParams
		 * @returns {Boolean} if its valid or not
		 */
		function isValidRoute(toState, toParams) {
			var validRoutes = ['simple-store', 'orderView', 'order-view-encrypted'];
			var additionalRoutes = service.getAdditionalValidRoutes();
			var foundRoute = validRoutes
				.concat(additionalRoutes)
				.find(function(route) {
					var name = toState.name || '';
					return validString(name) && name.indexOf(route) > -1;
				});

			if (foundRoute) {
				return true;
			} else if (ExtraFlowValidationService.isActiveXFCRoute(toState, toParams)) {
				return true;
			}

			return false;
		}


		/**
		 * Returns the additional routes and caches them so we dont parse the config again.
		 * @public
		 * @returns {String[]} An array of available routes to be valid
		 */
		function getAdditionalValidRoutes() {
			if (isArray(additionalValidRoutes)) {
				return additionalValidRoutes;
			} else if (!service.simpleStoreConfigured()) {
				additionalValidRoutes = [];
				return additionalValidRoutes;
			}

			additionalValidRoutes = Utilities.safelyCheckPropertyOnObject('AppData.settings.simpleStore', AppData, function(jsonString) {
				var config = JSON.parse(jsonString);

				if (validArray(config.validRoutes)) {
					return config.validRoutes;
				}

				return [];
			});

			return additionalValidRoutes;
		}

		/**
		 * Blocks routing away from the simple-store module
		 * @public
		 * @param {Object} toState The to state
		 * @param {Object} toParams The to params
		 * @returns {undefined}
		 */
		function blockRoutingAwayFromSimpleStore(toState, toParams) {
			var params = { keyword: '' },
				route = 'simple-store';

			if (!service.isValidRoute(toState, toParams)) {
				if (isRealObject(toParams) && validString(toParams.keyword)) {
					params.keyword = toParams.keyword;
				} else if (validArray(Package.itemsToBeAdded) && Utilities.safelyCheckPropertyOnObject('item.CHARACS.0.keyword_used', Package.itemsToBeAdded[0], validString)) {
					params.keyword = Package.itemsToBeAdded[0].CHARACS[0].keyword_used;
				} else if (isRealObject(toParams) && toParams.flowType === 'keyword' && validString(toParams.flowDetail)) {
					params.keyword = toParams.flowDetail;
				}

				if (validString(params.keyword)) {
					route = 'simple-store.keyword';

					if (isNumeric(toParams.packageId)) {
						params.packageId = toParams.packageId;
						route = 'simple-store.quantity';
					}
				}

				throw new RouteRejectionService.UnrecoverableException(route, params);
			}
		}

		/**
		 * Registers the post purchase custom action that will change where we route on postpurchase.
		 * @protected
		 * @function
		 * @returns {undefined}
		 */
		function _changePostPurchaseRoute() {
			var action = CustomActionService.ACTIONS_ENUMS.MODIFY_POST_PURCHASE_ROUTE;
			CustomActionService.deregisterCustomAction(action);
			CustomActionService.registerCustomAction(action, function() {
				return 'simple-store-post-purchase';
			});
		}
	}
})();
/* eslint-disable sort-keys */
(function() {
	'use strict';

	angular
		.module('simple-store')
		.config(config)
		.run(run);

	/**
	 * Sets up routing for the Boat Trip module
	 * @public
	 * @function
	 * @name config
	 * @memberof {TripSelect}
	 * @param {Provider} $locationProvider To setup global params
	 * @param {Provider} $stateProvider Lets us set up state
	 * @return {undefined}
	 * @ngInject
	 */
	function config($locationProvider, $stateProvider) {
		var MODULE_DIRECTORY = '/scripts/modules/alternate-modules/simple-store',
			COMPOSITION_DIRECTORY = '/scripts/modules/composition-library',
			COMPONENT_DIRECTORY = '/scripts/components',
			SIMPLE_STORE_CHECKOUT_MODULE = MODULE_DIRECTORY + '/components/simple-store-checkout',
			ORDER_DIRECTORY = MODULE_DIRECTORY + '/order',
			NUMERAL_SERVICE = '/scripts/modules/utilities/numeral-system-service.js',
			NODE_MODULES_DIRECTORY = '/node_modules',
			VENDOR_DIRECTORY = '/vendor',
			SIMPLE_STORE_CHECKOUT_ASSETS = [
				MODULE_DIRECTORY + '/composition/compose-simple-store-route.js',
				SIMPLE_STORE_CHECKOUT_MODULE + '/simple-store-checkout-component.css',
				SIMPLE_STORE_CHECKOUT_MODULE + '/simple-store-checkout-component.js',
				SIMPLE_STORE_CHECKOUT_MODULE + '/simple-store-checkout-component-controller.js'
			];

		$stateProvider
			// This is not defined in the abstract route as the abstract route needs a keyword and/or package id.
			.state('simple-store-keywords', {
				controller: 'SimpleStoreKeywordListController',
				controllerAs: 'vm',
				resolve: {
					initialData: initializeData,
					loadKeywordListAssets: function(initialData, Utilities) {
						return Utilities.cacheBustAndLazyLoad([MODULE_DIRECTORY + '/keyword-list/simple-store-keyword-list-controller.js']);
					}
				},
				templateUrl: MODULE_DIRECTORY + '/keyword-list/simple-store-keyword-list.html',
				title: 'simpleStoreKeywordList',
				url: '/simple-store-keywords'
			})
			.state('simple-store', {
				abstract: true,
				resolve: {
					initialData: initializeData,
					loadAssets: loadAssets
				},
				template: '<div ui-view></div>',
				url: '/simple-store/:keyword'
			})
			.state('simple-store.keyword', {
				controller: 'SimpleStoreKeywordController',
				controllerAs: 'vm',
				resolve: {
					loadKeywordAssets: function(loadAssets, Utilities) {
						var ACTIONABLE_COMPONENT_DIR = COMPONENT_DIRECTORY + '/actionable-package';
						return Utilities.cacheBustAndLazyLoad([
							MODULE_DIRECTORY + '/keyword/simple-store-keyword-controller.js',
							MODULE_DIRECTORY + '/keyword/simple-store-keyword.css',
							ACTIONABLE_COMPONENT_DIR + '/actionable-package-component-controller.js',
							ACTIONABLE_COMPONENT_DIR + '/actionable-package-component.css',
							ACTIONABLE_COMPONENT_DIR + '/actionable-package-component.js'
						]);
					},
					clearCart: function(loadKeywordAssets, LegacyCart) {
						return LegacyCart.clear();
					},
					verifyRoute: function(clearCart, $transition$, SimpleStoreRoutingService, PackageList) {
						var stateParams = $transition$.params();
						SimpleStoreRoutingService.ensureHasKeyword(stateParams);
						PackageList.initialize(stateParams);
					}
				},
				templateUrl: MODULE_DIRECTORY + '/keyword/simple-store-keyword.html',
				title: 'simpleStoreKeyword',
				url: ''
			})
			.state('simple-store.quantity', {
				controller: 'SimpleStoreQuantityController',
				controllerAs: 'vm',
				resolve: {
					loadQuantityAssets: function(loadAssets, Utilities) {
						return Utilities.cacheBustAndLazyLoad(SIMPLE_STORE_CHECKOUT_ASSETS.concat([
							MODULE_DIRECTORY + '/quantity/simple-store-quantity-controller.js',
							MODULE_DIRECTORY + '/quantity/simple-store-quantity.css',
							COMPOSITION_DIRECTORY + '/customer/compose-customer-types.js'
						]));
					},
					clearCart: function(loadQuantityAssets, LegacyCart) {
						return LegacyCart.clear();
					},
					verifyRoute: function(clearCart, $transition$, SimpleStoreRoutingService) {
						var stateParams = $transition$.params();
						SimpleStoreRoutingService.ensureHasKeyword(stateParams);
						SimpleStoreRoutingService.ensureHasPackageId(stateParams);
					}
				},
				templateUrl: MODULE_DIRECTORY + '/quantity/simple-store-quantity.html',
				title: 'simpleStoreQuantity',
				url: '/quantity/:packageId'
			})
			.state('simple-store.calendar-xfc', {
				controller: 'SimpleStoreCalendarController',
				controllerAs: 'vm',
				resolve: {
					loadCalendarAssets: function(initialData, loadAssets, Utilities) {
						var DYNAMIC_CALENDAR_MODULE = '/scripts/modules/base-calendar/dynamic-pricing-calendar';
						return Utilities.cacheBustAndLazyLoad(SIMPLE_STORE_CHECKOUT_ASSETS.concat([
							DYNAMIC_CALENDAR_MODULE + '/dynamic-pricing-calendar.html',
							DYNAMIC_CALENDAR_MODULE + '/dynamic-pricing-calendar.css',
							MODULE_DIRECTORY + '/extra-flow/calendar/simple-store-calendar-controller.js',
							MODULE_DIRECTORY + '/extra-flow/calendar/simple-store-calendar.css'
						]));
					},
					xfcMap: function(loadCalendarAssets, DateTimeService, Package) {
						return Package
							.buildXFCMap()
							.then(DateTimeService.initialize);
					},
					verifyRoute: function(xfcMap, $rootScope, $transition$, SimpleStoreRoutingService) {
						var stateParams = $transition$.params();
						SimpleStoreRoutingService.ensureHasKeyword(stateParams);
						SimpleStoreRoutingService.ensureHasPackageId(stateParams);
						$rootScope.hideSpinner();
					}
				},
				templateUrl: MODULE_DIRECTORY + '/extra-flow/calendar/simple-store-calendar.html',
				title: 'simpleStoreCalendarXFC',
				url: '/extra-flow/calendar/:packageId'
			})
			.state('simple-store-post-purchase', {
				controller: 'TicketCtrl',
				controllerAs: 'vm',
				dynamic: true,
				resolve: {
					initialData: initializeData,
					loadAssets: loadAssets,
					accessViewOrder: accessViewOrder,
					loadPostPurchaseAssets: function(accessViewOrder, $rootScope, Utilities) {
						return Utilities
							.cacheBustAndLazyLoad([NUMERAL_SERVICE])
							.finally($rootScope.hideSpinner);
					}
				},
				templateUrl: MODULE_DIRECTORY + '/post-purchase/simple-store-post-purchase.html',
				title: 'simpleStorePostPurchase',
				url: '/simple-store-post-purchase/:oToken/:cToken'
			})
			.state('simple-store-order', {
				controller: 'TicketCtrl',
				controllerAs: 'vm',
				dynamic: true,
				resolve: {
					initialData: initializeData,
					loadAssets: loadAssets,
					accessViewOrder: accessViewOrder,
					// has to be separate than the other baren files as its a requirement when they are being parsed
					loadBaren: function(accessViewOrder, Utilities) {
						return Utilities.cacheBustAndLazyLoad([VENDOR_DIRECTORY + '/baren/baren.js']);
					},
					loadPostPurchaseAssets: function(loadBaren, $rootScope, Utilities) {
						var SWIPEABLE_BARCODE_COMPONENT_DIRECTORY = ORDER_DIRECTORY + '/components/swipeable-barcodes',
							VOID_BOX_DIRECTORY = COMPONENT_DIRECTORY + '/void-box';

						return Utilities.cacheBustAndLazyLoad([
							NUMERAL_SERVICE,
							NODE_MODULES_DIRECTORY + '/swiper/swiper-bundle.min.js',
							NODE_MODULES_DIRECTORY + '/swiper/swiper.min.css',
							VENDOR_DIRECTORY + '/baren/lib/render/renlinear.js',
							VENDOR_DIRECTORY + '/baren/lib/barcodes/code128.js',
							VENDOR_DIRECTORY + '/baren/lib/barcodes/qrcode.js',
							VENDOR_DIRECTORY + '/baren/lib/render/renmatrix.js',
							SWIPEABLE_BARCODE_COMPONENT_DIRECTORY + '/swipeable-barcodes-component.js',
							SWIPEABLE_BARCODE_COMPONENT_DIRECTORY + '/swipeable-barcodes-component-controller.js',
							VOID_BOX_DIRECTORY + '/void-box-component.js',
							VOID_BOX_DIRECTORY + '/void-box-component.css',
							ORDER_DIRECTORY + '/simple-store-order.css'
						]).finally($rootScope.hideSpinner);
					}
				},
				templateUrl: ORDER_DIRECTORY + '/simple-store-order.html',
				title: 'simpleStoreOrderPurchase',
				url: '/simple-store-order/:oToken/:cToken'
			});

		/**
		 * Resolves the bootstrap promise
		 * @protected
		 * @function
		 * @name initializeData
		 * @param {Service} Bootstrap The bootstrap service
		 * @return {Promise} A promise that we bootstrapped
		 * @ngInject
		 */
		function initializeData(Bootstrap) {
			return Bootstrap.bootstrapApplication();
		}

		/**
		 * Loads the main assets for the simple store config service
		 * @protected
		 * @function
		 * @name loadAssets
		 * @param {Promise} initialData The resolved initializeData response for bootstrapping
		 * @param {Service} Utilities Utilities
		 * @return {Promise} A promise that we bootstrapped
		 * @ngInject
		 */
		function loadAssets(initialData, Utilities) {
			return Utilities.cacheBustAndLazyLoad([
				COMPOSITION_DIRECTORY + '/compose-config-builder.js',
				MODULE_DIRECTORY + '/service/simple-store-config-service.js'
			]);
		}

		/**
		 * Assesses whether or not we need to load the order or not.
		 * @public
		 * @param {Promise} loadAssets The promise to load assets
		 * @param {Scope} $rootScope $rootScope
		 * @param {Service} $transition$ The transition service
		 * @param {Service} OrderService The service
		 * @param {Service} SimpleStoreConfigService the service
		 * @returns {undefined|Promise} A promise if we need to request.
		 * @ngInject
		 */
		function accessViewOrder(loadAssets, $rootScope, $transition$, OrderService, SimpleStoreConfigService) {
			var state = { current: { name: SimpleStoreConfigService.getOrderLookupRouteName() } },
				stateParams = $transition$.params();
			$rootScope.showSpinner();

			if (OrderService.orderLoaded(stateParams.oToken, stateParams.cToken)) {
				return;
			}

			return OrderService.accessTokenizedRoute(stateParams.oToken, null, stateParams.cToken, state, {});
		}
	}

	/**
	 * Our run method for trip-select
	 * @public
	 * @function
	 * @name run
	 * @param {Service} ExtraFlow The etra flow service.
	 * @return {undefined}
	 * @ngInject
	 */
	function run(ExtraFlow) {
		var registerXMC = ExtraFlow.registerXMC;

		registerXMC('simple-store', {
			doEditMode: false,
			enabled: true,
			itemHasAnEditableXMC: false,
			lockQuantity: true,
			name: 'simple-store',
			type: 'alternateFlowModule',
			view: 'simple-store'
		});

		registerXMC('simple-store-calendar', {
			aliases: ['simple-store-calendar_times'],
			doEditMode: false,
			enabled: true,
			itemHasAnEditableXMC: false,
			lockQuantity: true,
			name: 'simple-store-calendar',
			type: 'extraFlowControl',
			view: 'simple-store.calendar-xfc',
			viewIsStateName: true
		});
	}
})();

!function(){"use strict";function e(e,a){r.$inject=["$rootScope","Bootstrap"],i.$inject=["bootstrap","BundleService"],o.$inject=["lazyLoadAssets","$transition$","PackagePlannerService"],l.$inject=["keywordPackages","$transition$","RestrictedPackagesService"],c.$inject=["isRestricted","RestrictedPackagesService","UtilsValidation"],s.$inject=["restrictedLocales","keywordPackages","$q","$transition$","Enums","PackagePlannerService","RouteRejectionService","UtilsValidation"],p.$inject=["routeGuard","$transition$","PackagePlannerService"],u.$inject=["config","AccessoCalendarEnums","Viewport"],d.$inject=["config","AccessoCalendarService"],g.$inject=["config","initialDisplayType","initialStartDate","$rootScope","$transition$","AccessoCalendarEnums","PackagePlannerService"],k.$inject=["config","initialData","AccessoCalendarDataService"];var t=Object.assign||angular.merge,n={keywordPackages:o,isRestricted:l,restrictedLocales:c,routeGuard:s,config:p};function r(e,a){return e.showSpinner(),a.bootstrapApplication()}function i(e,a){return a.lazyLoadCollectionFiles(a.enums.PACKAGE_PLANNER)}function o(e,a,t){var n=a.params();return t.getPackagesByKeyword(n.keyword)}function l(e,a,t){var n=a.params();return t.hasRegisteredPackagesForKeyword(n.keyword)}function c(e,a,t){var n;return e?(n=a.getLocaleData("wtp"),t.validObject(n)?n:null):null}function s(e,a,t,n,r,i,o,l){var c=angular.copy(n.params());return l.validArray(a)?1===a.length&&n.to().name===r.routes.PACKAGE_PLANNER?(c.packageId=a[0].id,o.reroute(r.routes.PACKAGE_PLANNER_GUEST,c,!0)):l.validNumber(c.packageId)&&!i.isPackageInSet(a,c.packageId)?o.reroute(r.routes.PACKAGE_PLANNER,c,!0):c.guestSelection&&!i.isGuestSelectionValid(c.packageId,c.guestSelection)?o.reroute(r.routes.PACKAGE_PLANNER_GUEST,c,!0):t.resolve():o.reroute("/",null,!0)}function p(e,a,t){return t.getConfig(a.params().keyword,a.params().packageId)}function u(e,a,t){return t.api.isMobile?e.flags.hasDefaultDisplay&&!e.info.isTimed?e.info.defaultDisplayType:a.displayType.week:a.displayType.month}function d(e,a){return a.getValidPackageFirstAvailableDate(a.createDate(),e.info.packageId)}function g(e,a,t,n,r,i,o){var l=r.params();return n.showSpinner(o.getLocale(l.keyword,"LoadingDates")),o.requestDates(t,{displayType:i.displayType.month,guestSelection:l.guestSelection,isDualMonth:!e.info.isTimed,packageId:e.info.packageId,range:e.info.dateRange})}function k(e,a,t){return{limitedThreshold:e.calendar.accesso_calendar.limited_threshold||t.getLimitedAvailabilityThreshold()}}e.state("package-planner",{abstract:!0,components:[a.accessoCalendar,a.mobileCta],controllerAs:"vm",url:"/package-planner",resolve:{bootstrap:r,lazyLoadAssets:i}}).state("package-planner.package",{controller:"PackagePlannerPackageSelectionController",templateUrl:"package-planner:package-selection",title:"packagePlannerPackageSelection",url:"/{keyword:keyword}",resolve:n}).state("package-planner.guest",{components:[a.quantity],controller:"PackagePlannerGuestSelectionController",params:{guestSelection:{value:null,type:"guestselection"}},resolve:n,templateUrl:"package-planner:guest-selection",title:"packagePlannerGuestSelection",url:"/{keyword:keyword}/{packageId:int}"}).state("package-planner.calendar",{controller:"PackagePlannerCalendarController",templateUrl:"package-planner:calendar",title:"packagePlannerCalendar",url:"/{keyword:keyword}/{packageId:int}/{guestSelection:guestselection}",resolve:t(n,{initialDisplayType:u,initialStartDate:d,initialData:g,calendarOptions:k})})}e.$inject=["$stateProvider","ComponentLoaderEnums"],angular.module("package-planner",["app","components","wtp"]).config(e)}(),function(){"use strict";function e(e){e.registerXMC("package-planner",{doEditMode:!1,enabled:!0,itemHasAnEditableXMC:!1,lockQuantity:!0,name:"package-planner",type:"alternateFlowModule",view:"package-planner"})}e.$inject=["ExtraFlow"],angular.module("package-planner").run(e)}();
(function() {
	'use strict';
	angular
		.module('snap-calendar', ['app', 'components', 'ui.router'])
		.run(run);

	/**
	 * Our run sequence
	 * @param {Service} ExtraFlow Extra Flow
	 * @returns {undefined}
	 * @ngInject
	 */
	function run(ExtraFlow) {
		ExtraFlow.registerXMC('snap-calendar', {
			characsList: ['start_date', 'event_id'],
			doEditMode: false,
			enabled: true,
			itemHasAnEditableXMC: false,
			lockQuantity: true,
			name: 'snap-calendar',
			type: 'alternateFlowModule',
			view: 'snap-calendar'
		});

		ExtraFlow.registerXMC('snap-calendar-wizard', {
			characsList: ['start_date', 'event_id'],
			doEditMode: false,
			enabled: true,
			itemHasAnEditableXMC: false,
			lockQuantity: true,
			name: 'snap-calendar-wizard',
			type: 'alternateFlowModule',
			view: 'snap-calendar-wizard'
		});
	}
}());
(function() {
	'use strict';

	angular
		.module('snap-calendar')
		.constant('SnapCalendarRouteEnums', {
			param: {
				CROSS_SELL_TYPE: {
					squash: true,
					value: null
				},
				// Customer Type value must be in `{CUSTOMER_TYPE_ID}-{QTY}_{CUSTOMER_TYPE_ID}-{QTY}`
				GUEST_SELECTION: {
					squash: true,
					type: 'guestselection',
					value: null,
				},
				// Date value must be in YYYY-MM-DD
				DATE: {
					squash: true,
					type: 'accessoDate',
					value: null,
				},
				PROMO_CODE: {
					squash: true,
					value: null
				},
				FLOW_TYPE: {
					squash: true,
					value: null
				}
			},
			route: {
				RESULTS: 'snap-calendar.results',
				PACKAGE: 'snap-calendar.package',
				WIZARD_RESULTS: 'snap-calendar-wizard.results',
				WIZARD_PACKAGE: 'snap-calendar-wizard.package'
			},
		})
		.config(SnapCalendarRoutes);

	/**
	 * Snap Calendar routing
	 * @param {Service} $stateProvider - Angular UI Router state provider
	 * @param {Service} ComponentLoaderEnums - Our component loader enums
	 * @constructor
	 * @ngInject
	 */
	function SnapCalendarRoutes($stateProvider, ComponentLoaderEnums, SnapCalendarRouteEnums) {
		$stateProvider
			.state('snap-calendar', {
				abstract: true,
				components: [ ComponentLoaderEnums.accessoCalendar ],
				title: 'snapCalendar',
				url: '/snap-calendar',
				resolve: {
					initialData: initialData,
					loadFiles: loadFiles,
				}
			})
			.state(SnapCalendarRouteEnums.route.RESULTS, {
				url: '/{keyword:keyword}/:date/:customerTypesHash',
				components: [ ComponentLoaderEnums.cartFeeNotice, ComponentLoaderEnums.snapPackageResult ],
				controller: 'SnapCalendarResultsController',
				controllerAs: 'vm',
				params: {
					crosssell_type: SnapCalendarRouteEnums.param.CROSS_SELL_TYPE,
					customerTypesHash: SnapCalendarRouteEnums.param.GUEST_SELECTION,
					date: SnapCalendarRouteEnums.param.DATE,
					flow_type: SnapCalendarRouteEnums.param.FLOW_TYPE,
					promo_code: SnapCalendarRouteEnums.param.PROMO_CODE,
				},
				resolve: {
					setup: setup,
					config: config,
					keywordPackages: keywordPackages,
					routeGuard: function(keywordPackages, $transition$, RouteRejectionService, Utilities) {
						if (keywordPackages.length === 1) {
							return RouteRejectionService.reroute(SnapCalendarRouteEnums.route.PACKAGE, Utilities.merge({}, $transition$.params(), {
								packageId: keywordPackages[0].id,
							}));
						}

						return true;
					},
					initialModelData: initialModelData,
					finalize: function(initialModelData, $rootScope) {
						$rootScope.hideSpinner();
					}
				},
				templateUrl: 'snap-calendar:results',
				title: 'snapCalendarResults',
			})
			.state(SnapCalendarRouteEnums.route.PACKAGE, {
				url: '/package/{keyword:keyword}/:packageId/:date/:customerTypesHash',
				components: [ ComponentLoaderEnums.cartFeeNotice, ComponentLoaderEnums.customerQuantity, ComponentLoaderEnums.modalSelector, ComponentLoaderEnums.quantity ],
				controller: 'SnapCalendarPackageController',
				controllerAs: 'vm',
				params: {
					crosssell_type: SnapCalendarRouteEnums.param.CROSS_SELL_TYPE,
					customerTypesHash: SnapCalendarRouteEnums.param.GUEST_SELECTION,
					date: SnapCalendarRouteEnums.param.DATE,
					flow_type: SnapCalendarRouteEnums.param.FLOW_TYPE,
					packageId: SnapCalendarRouteEnums.param.packageId,
					promo_code: SnapCalendarRouteEnums.param.PROMO_CODE,
				},
				resolve: {
					setup: setup,
					config: config,
					keywordPackages: keywordPackages,
					routeGuard: function($transition$, RouteRejectionService, Utilities) {
						var params = $transition$.params(),
							yesterday = new Date();

						yesterday.setDate(yesterday.getDate() - 1);

						if (params.date && !(params.date > yesterday)) {
							return RouteRejectionService.reroute(SnapCalendarRouteEnums.route.PACKAGE, Utilities.merge({}, params, { date: null }));
						}

						return true;
					},
					isUPDEnabled: isUPDEnabled,
					initialModelData: initialModelDataAfterUPDCheck,
				},
				templateUrl: 'snap-calendar:package',
				title: 'snapCalendarPackage',
			});

		$stateProvider
			.state('snap-calendar-wizard', {
				abstract: true,
				components: [ ComponentLoaderEnums.accessoCalendar ],
				title: 'snapCalendarWizard',
				url: '/snap-calendar-wizard/:recommenderWizardKeyword',
				resolve: {
					initialData: initialData,
					loadFiles: loadFiles,
					setup: setup,
				},
			})
			.state(SnapCalendarRouteEnums.route.WIZARD_RESULTS, {
				url: '/{keyword:keyword}/:date/:customerTypesHash',
				components: [ ComponentLoaderEnums.cartFeeNotice, ComponentLoaderEnums.snapPackageResult ],
				controller: 'SnapCalendarResultsController',
				controllerAs: 'vm',
				params: {
					crosssell_type: SnapCalendarRouteEnums.param.CROSS_SELL_TYPE,
					customerTypesHash: SnapCalendarRouteEnums.param.GUEST_SELECTION,
					date: SnapCalendarRouteEnums.param.DATE,
					flow_type: SnapCalendarRouteEnums.param.FLOW_TYPE,
					promo_code: SnapCalendarRouteEnums.param.PROMO_CODE,
				},
				resolve: {
					config: config,
					recommenderWizard: recommenderWizard,
					keywordPackages: recommenderKeywordPackages,
					routeGuard: function(keywordPackages, $transition$, RouteRejectionService, Utilities) {
						if (keywordPackages.length === 1) {
							return RouteRejectionService.reroute(SnapCalendarRouteEnums.route.WIZARD_PACKAGE, Utilities.merge({}, $transition$.params(), {
								packageId: keywordPackages[0].id,
							}));
						}
						return true;
					},
					initialModelData: initialModelData,
					finalize: function(initialModelData, $rootScope) {
						$rootScope.hideSpinner();
					}
				},
				templateUrl: 'snap-calendar:results',
				title: 'snapCalendarWizardResults',
			})
			.state(SnapCalendarRouteEnums.route.WIZARD_PACKAGE, {
				url: '/package/{keyword:keyword}/:packageId/:date/:customerTypesHash',
				components: [ ComponentLoaderEnums.cartFeeNotice, ComponentLoaderEnums.customerQuantity, ComponentLoaderEnums.modalSelector ],
				controller: 'SnapCalendarPackageController',
				controllerAs: 'vm',
				params: {
					crosssell_type: SnapCalendarRouteEnums.param.CROSS_SELL_TYPE,
					customerTypesHash: SnapCalendarRouteEnums.param.GUEST_SELECTION,
					date: SnapCalendarRouteEnums.param.DATE,
					flow_type: SnapCalendarRouteEnums.param.FLOW_TYPE,
					promo_code: SnapCalendarRouteEnums.param.PROMO_CODE,
				},
				resolve: {
					config: config,
					recommenderWizard: recommenderWizard,
					keywordPackages: recommenderKeywordPackages,
					routeGuard: function($transition$, AccessoCalendarService, RouteRejectionService, Utilities) {
						var params = $transition$.params(),
							yesterday = AccessoCalendarService.alterDate(null, -1);

						if (params.date && !(params.date > yesterday)) {
							return RouteRejectionService.reroute(SnapCalendarRouteEnums.route.WIZARD_PACKAGE, Utilities.merge({}, params, { date: null }));
						}

						return true;
					},
					isUPDEnabled: isUPDEnabled,
					initialModelData: initialModelDataAfterUPDCheck,
				},
				templateUrl: 'snap-calendar:package',
				title: 'snapCalendarPackage',
			});

		/**
		 * Load Bootstrap data
		 * @resolve
		 * @param {Service} $rootScope - Angular root scope
		 * @param {Service} Bootstrap - Our Bootstrap service
		 * @returns {Promise}
		 * @ngInject
		 */
		function initialData($rootScope, Bootstrap) {
			$rootScope.showSpinner();

			return Bootstrap.bootstrapApplication(undefined, true);
		}


		/**
		 * Check if the 2025 flag is set
		 * @resolve
		 * @param {Service} $transition$ - Angular UI Router transition service
		 * @returns {boolean} Always true as we only use 2025 version now
		 * @ngInject
		 */
		function is2025Version() {
			// Always return true as 2025 is the only version now
			return true;
		}

		/**
		 * Load in the files for the Snap Calendar
		 * @resolve
		 * @param {Service} BundleService - Our Bundle service
		 * @returns {Promise}
		 * @ngInject
		 */
		function loadFiles(BundleService) {
			return BundleService.lazyLoadCollectionFiles(BundleService.enums.SNAP_CALENDAR);
		}

		/**
		 * Setup package details and customer types
		 * @resolve
		 * @param {Promise} loadFiles - Result of file loading
		 * @param {Service} $transition$ - Angular UI Router transition service
		 * @param {Service} Package - Package service
		 * @returns {undefined}
		 * @ngInject
		 */
		function setup(loadFiles, $transition$, Package) {
			var params = $transition$.params();

			if (params.packageId) {
				Package.packageDetails = Package.getPackageByID(params.packageId);
				Package.customerTypes = Package.setCustomerType(Package.packageDetails, Package.itemsToBeAdded);
			}
		}

		/**
		 * Get configuration for snap calendar
		 * @resolve
		 * @param {Promise} setup - Result of setup
		 * @param {Service} $transition$ - Angular UI Router transition service
		 * @param {Service} SnapCalendarService - Snap Calendar service
		 * @returns {Promise} Configuration object
		 * @ngInject
		 */
		function config(setup, $transition$, SnapCalendarService) {
			var params = $transition$.params();

			return SnapCalendarService.getConfig(params.keyword, params.packageId);
		}

		/**
		 * The recommender wizard resolve
		 * @resolve
		 * @param {Object} config - Snap Calendar configuration
		 * @param {Service} $transition$ - Angular UI Router transition service
		 * @param {Service} RecommenderWizardContextService - Our Recommender Wizard Context service
		 * @returns {undefined}
		 * @ngInject
		 */
		function recommenderWizard(config, $transition$, RecommenderWizardContextService) {
			if (RecommenderWizardContextService.bootstrapWizard($transition$.params().recommenderWizardKeyword, SnapCalendarRouteEnums.route.WIZARD_RESULTS)) {
				RecommenderWizardContextService.registerSnapCalendar();
			}
		}

		/**
		 * Get the keyword packages
		 * @resolve
		 * @param {Object} config - Snap Calendar configuration
		 * @param {Service} $transition$ - Angular UI Router transition service
		 * @param {Service} Package - Our Package service
		 * @param {Service} Utilities - Our Utilities service
		 * @returns {Promise}
		 * @ngInject
		 */
		function keywordPackages(config, $transition$, Package, Utilities) {
			return Utilities.orderByDisplayOrder(
				Package.filterByParentPackages(
					Package.getPackagesByKeyword($transition$.params().keyword)
				)
			);
		}

		/**
		 * Get the keyword packages
		 * @resolve
		 * @param {Promise} loadFiles - Load files
		 * @param {Object} recommenderWizard - Recommender wizard config
		 * @param {Service} $transition$ - Angular UI Router transition service
		 * @param {Service} Package - Our Package service
		 * @param {Service} Utilities - Our Utilities service
		 * @returns {Promise}
		 * @ngInject
		 */
		function recommenderKeywordPackages(loadFiles, recommenderWizard, $transition$, Package, Utilities) {
			return keywordPackages(loadFiles, $transition$, Package, Utilities);
		}

		/**
		 * Redirects opted-in stores to UnifiedPackageDetails instead of the snap-calendar package view.
		 * Depends on routeGuard (not initialModelData) so this still runs before initialModelData's per-date pricing fetch, without racing routeGuard's own date-validity reroute.
		 * @resolve
		 * @param {Resolve} routeGuard - Serialization dep: ensures the date-validity reroute (if any) ran first
		 * @param {Service} $transition$ - Angular UI Router transition service
		 * @param {Service} AppData - Application data service
		 * @param {Service} RouteRejectionService - Route rejection service
		 * @returns {boolean|Promise}
		 * @ngInject
		 */
		function isUPDEnabled(routeGuard, $transition$, AppData, RouteRejectionService) {
			if (!AppData.unifiedPackageDetailsEnabled) {
				return false;
			}

			var params = $transition$.params();

			return RouteRejectionService.reroute(
				'unified-package-details.main',
				{
					packageId: params.packageId,
					preSelectedDate: params.date || null,
					recommenderWizardKeyword: params.recommenderWizardKeyword || null
				},
				undefined,
				undefined,
				$transition$
			);
		}

		/**
		 * Get the initial calendar data. Used directly by the .results states; the .package states use initialModelDataAfterUPDCheck instead.
		 * @resolve
		 * @param {Resolve} keywordPackages - Keyword packages
		 * @param {Resolve} routeGuard - Route guard
		 * @param {Resolve} config - Config
		 * @param {Service} AccessoCalendarService - Our Accesso Calendar
		 * @param {Service} SnapCalendarService - Our Snap Calendar service
		 * @param {Service} $transition$ - Angular UI Router transition service
		 */
		function initialModelData(keywordPackages, routeGuard, config, AccessoCalendarService, SnapCalendarService, $transition$) {
			var params = $transition$.params(),
				options = {
					keyword: params.keyword,
					months: 2,
				};

			if (params.packageId) {
				if (params.date > AccessoCalendarService.createDate()) {
					options.months = 1;
				}

				options.packageId = params.packageId;
			}

			return SnapCalendarService.requestDates(params.date, null, options);
		}

		/**
		 * Wraps initialModelData with a dependency on isUPDEnabled, for the .package states only.
		 * @resolve
		 * @param {Resolve} keywordPackages - Keyword packages
		 * @param {Resolve} routeGuard - Route guard
		 * @param {Resolve} config - Config
		 * @param {Resolve} isUPDEnabled - Serialization dep: ensures the UPD redirect (if any) ran first
		 * @param {Service} AccessoCalendarService - Our Accesso Calendar
		 * @param {Service} SnapCalendarService - Our Snap Calendar service
		 * @param {Service} $transition$ - Angular UI Router transition service
		 * @returns {Promise}
		 * @ngInject
		 */
		function initialModelDataAfterUPDCheck(keywordPackages, routeGuard, config, isUPDEnabled, AccessoCalendarService, SnapCalendarService, $transition$) {
			return initialModelData(keywordPackages, routeGuard, config, AccessoCalendarService, SnapCalendarService, $transition$);
		}
	}
})();
(function() {
	'use strict';

	angular
		.module('resource-selector', ['app', 'ui.router', 'ngResource', 'composition-library', 'utilities']);
}());
(function() {
	/* eslint-disable sort-keys */
	'use strict';

	angular
		.module('resource-selector')
		.config(config)
		.run(run);

	/**
	 * Sets up routing for the Resource module
	 * @public
	 * @function
	 * @name config
	 * @memberof {Resource Selector}
	 * @param {Provider} $locationProvider To setup global params
	 * @param {Provider} $stateProvider Lets us set up state
	 * @returns {undefined}
	 * @ngInject
	 */
	function config($locationProvider, $stateProvider, ComponentLoaderEnums) {
		var MODULE = '/scripts/modules';
		var MODULE_DIRECTORY = MODULE + '/alternate-modules/resource-selector',
			COMPOSITION_DIRECTORY = MODULE + '/composition-library',
			DEFAULT_FILES = [
				COMPOSITION_DIRECTORY + '/calendar/compose-start-date-override.js',
				COMPOSITION_DIRECTORY + '/customer/compose-customer-types.js',
				COMPOSITION_DIRECTORY + '/tracking/compose-alternate-module-google-analytics.js',
				COMPOSITION_DIRECTORY + '/calendar/compose-dynamic-pricing-calendar-dates.js',
				COMPOSITION_DIRECTORY + '/compose-keyword.js',
				MODULE_DIRECTORY + '/services/resource-selector-data-service.js',
				MODULE_DIRECTORY + '/calendar/resource-selector-calendar-controller.js',
				MODULE_DIRECTORY + '/calendar/resource-selector-calendar.css',
				MODULE_DIRECTORY + '/options/resource-selector-options-controller.js',
				MODULE_DIRECTORY + '/options/resource-selector-options.css'
			];

		$stateProvider
			.state('resource-selector', {
				controller: 'ResourceSelectorCalendarController',
				controllerAs: 'vm',
				components: [ ComponentLoaderEnums.accessoCalendar ],
				resolve: {
					initialData: initializeData,
					previousState: buildPreviousState,
					loadAssets: function(initialData, Utilities, LIST_COMPONENT_ASSETS) {
						return Utilities.cacheBustAndLazyLoad(DEFAULT_FILES.concat(LIST_COMPONENT_ASSETS));
					},
					stateModel: buildStateModel,
					initialDisplayType: initialDisplayType,
					initialSelectedDate: initialSelectedDate,
					initialRawData: initialRawData,
					initialCalendarData: initialCalendarData
				},
				title: 'resourceSelector',
				templateUrl: MODULE_DIRECTORY + '/calendar/resource-selector-calendar.html',
				url: '/resource-selector/:keyword'
			})
			.state('resource-selector-options', {
				controller: 'ResourceSelectorOptionsController',
				controllerAs: 'vm',
				components: [ ComponentLoaderEnums.accessoCalendar ],
				params: {
					data: null,
					groupId: null,
					keyword: null,
					selectedDate: null
				},
				resolve: {
					initialData: initializeData,
					previousState: buildPreviousState,
					loadAssets: function(initialData, Utilities, LIST_COMPONENT_ASSETS) {
						return Utilities.cacheBustAndLazyLoad(DEFAULT_FILES.concat(LIST_COMPONENT_ASSETS));
					},
					stateModel: buildStateModel,
					dayData: function dayData(stateModel, $injector, $transition$) {
						var ResourceSelectorDataService = $injector.get('ResourceSelectorDataService');
						var params = $transition$.params();

						if (params.data) {
							return params.data;
						}

						// search single day
						return ResourceSelectorDataService.requestDates(params.keyword, params.selectedDate, params.selectedDate);
					},
					resourceData: function resourceData(dayData, $injector, $transition$) {
						var ResourceSelectorDataService = $injector.get('ResourceSelectorDataService');
						var params = $transition$.params();

						return ResourceSelectorDataService.buildResourceList(dayData, params.selectedDate, params.groupId);
					},
					finalizeRoute: function(resourceData, $rootScope) {
						$rootScope.hideSpinner();
					}
				},
				title: 'resourceSelectorOptions',
				templateUrl: MODULE_DIRECTORY + '/options/resource-selector-options.html',
				url: '/options/{keyword:keyword}/:groupId/:selectedDate'
			});
	}

	/**
	 * Register our alternate module
	 * @public
	 * @function
	 * @name run
	 * @param {Service} ExtraFlow The extra flow service.
	 * @returns {undefined}
	 * @ngInject
	 * */
	function run(ExtraFlow) {
		ExtraFlow.registerXMC('resource-selector', {
			doEditMode: false,
			enabled: true,
			itemHasAnEditableXMC: false,
			lockQuantity: true,
			name: 'resource-selector',
			type: 'alternateFlowModule',
			view: 'resource-selector'
		});
	}

	/**
	 * Resolves the bootstrap promise
	 * @public
	 * @function
	 * @name initializeData
	 * @param {Service} Bootstrap The bootstrap service
	 * @param {Service} $rootScope You know what this is.
	 * @returns {Promise} A promise that we bootstrapped
	 * @ngInject
	 */
	function initializeData(Bootstrap, $rootScope) {
		$rootScope.showSpinner();
		return Bootstrap.bootstrapApplication(undefined, true);
	}

	/**
	 * Resolves the current state so that once the page resolves, it will have the previous state.
	 * @public
	 * @function
	 * @name buildPreviousState
	 * @param {Object} $state The state before we resolve to the new state
	 * @returns {Object} the previous state
	 * @ngInject
	 */
	function buildPreviousState($state) {
		return {
			name: $state.current.name,
			params: $state.params
		};
	}

	/**
	 * Resolves our stateModel and throws an exception if we have an invalid keyword
	 * @public
	 * @function
	 * @name stateModel
	 * @param {Promise} loadAssets We need this so that the resolved promise is a dependency of this function
	 * @param {Service} $state Our state data
	 * @param {Service} $injector To create our model
	 * @param {Service} RouteRejectionService The rejection service
	 * @throws {UnrecoverableException}
	 * @returns {Object} the state model - https://www.tiktok.com/@cassidylea7/video/7022832612959882502
	 * @ngInject
	 */
	function buildStateModel(loadAssets, $state, $injector, RouteRejectionService) {
		var model = {};
		if (!angular.isObject($state.toParams)) {
			throw new RouteRejectionService.UnrecoverableException();
		}
		model.keyword = $state.toParams.keyword;
		return model;
	}

	/**
	 * The initial display type the calendar should show as
	 * @resolve
	 * @param {Resolve} lazyLoadAssets - The lazyLoadAssets resolve
	 * @param {Service} $injector - The injector service
	 * @returns {String} The display type to display as
	 * @ngInject
	 */
	function initialDisplayType(stateModel, $injector) {
		var AccessoCalendarEnums = $injector.get('AccessoCalendarEnums');

		return AccessoCalendarEnums.displayType.month;
	}

	/**
	 * Determines if there is a selected date or not
	 * @resolve
	 * @param {Resolve} initialDisplayType - The inititalDisplayType resolve
	 * @returns {Date|null} - The selected date, null otherwise
	 * @ngInject
	 */
	function initialSelectedDate(initialDisplayType) {
		return null;
	}

	/**
	 * Requests the initial raw data
	 * @resolve
	 * @param {Date|null} initialSelectedDate - The initial selected date, if set
	 * @param {Service} $injector - The $injector service
	 * @param {Service} $transition$ - The Transition Service
	 * @returns {Object[]}
	 * @ngInject
	 */
	function initialRawData(initialSelectedDate, $injector, $transition$) {
		var ResourceSelectorDataService = $injector.get('ResourceSelectorDataService');

		// Was a previous day selected
		if (initialSelectedDate) {
			// search single day
			return ResourceSelectorDataService.requestDates($transition$.params().keyword, initialSelectedDate, initialSelectedDate);
		}

		return ResourceSelectorDataService.requestDates($transition$.params().keyword);
	}

	/**
	 * Determines the initial calendar data
	 * @resolve
	 * @param {Object} initialRawData - The initial raw data
	 * @param {Date|null} initialSelectedDate - The initial selected date, if set
	 * @param {Service} $injector - The $injector service
	 * @returns {Object[]} - The calendar data
	 * @ngInject
	 */
	function initialCalendarData(initialRawData, initialSelectedDate, $injector, $transition$) {
		var AccessoCalendarDataService = $injector.get('AccessoCalendarDataService'),
			ResourceSelectorDataService = $injector.get('ResourceSelectorDataService');

		return AccessoCalendarDataService.normalizeDataFromResponse(initialRawData, ResourceSelectorDataService.getServiceRequest(), {
			limitedThreshold: ResourceSelectorDataService.getConfig($transition$.params().keyword, 'limited_avail') || 0
		});
	}
}());
(function() {
	'use strict';
	angular
		.module('place-reservation', ['app', 'utilities'])
		.run(run);

	/**
	 * Our run sequence
	 * @param {Service} ExtraFlow Extra Flow
	 * @returns {undefined}
	 * @ngInject
	 */
	function run(ExtraFlow) {
		ExtraFlow.registerXMC('place-reservation', {
			doEditMode: false,
			enabled: true,
			itemHasAnEditableXMC: false,
			lockQuantity: true,
			name: 'place-reservation',
			type: 'alternateFlowModule',
			view: 'place-reservation'
		});
	}
}());

/* eslint-disable sort-keys */
(function() {
	'use strict';

	angular
		.module('place-reservation')
		.config(config);

	/**
	 * Configure our module
	 * @param {Service} $stateProvider $stateProvider
	 * @returns {undefined}
	 * @ngInject
	 */
	function config($stateProvider) {
		var MODULE_ROOT = '/scripts/modules/alternate-modules/place-reservation';

		$stateProvider
			.state('place-reservation', {
				abstract: true,
				resolve: {
					initialData: function(Bootstrap) {
						return Bootstrap.bootstrapApplication(undefined, true);
					},
					loadAssets: function(initialData, $rootScope, Utilities) {
						$rootScope.showSpinner();

						return Utilities.cacheBustAndLazyLoad([
							MODULE_ROOT + '/place-reservation-utilities.js',
							MODULE_ROOT + '/place-reservation-service.js'
						]);
					}					
				},
				url: '/place-reservation'
			})
			.state('place-reservation.packageId', {
				resolve: {
					goBack: function(loadAssets, Package, $q, RouteRejectionService, $rootScope) {
						if (!Package.isForwardExtraFlowRouting()) {
							$rootScope.hideSpinner();
							return new $q(RouteRejectionService.BypassXFCExceptionCallback);
						}
					},
					makeReservationCall: function(goBack, $injector) {
						return $injector.get('PlaceReservationService').placeReservation();
					},
					hideSpinner: function(makeReservationCall, $rootScope) {
						$rootScope.hideSpinner();
					}
				},
				url: '/:packageId',
				template: ''
			});
	}
})();

(function () {
	'use strict';

	/**
	 * The `buy-now` module provides buy-now functionality for the application.
	 * It handles immediate purchase workflows and bypass cart flows.
	 */
	angular.module('buy-now', ['app', 'components', 'ui.router']);
})();
(function() {
	'use strict';

	angular
		.module('buy-now')
        .constant('BuyNowConstants', {
            param: {
                // Customer Type value must be in `{CUSTOMER_TYPE_ID}-{QTY}_{CUSTOMER_TYPE_ID}-{QTY}`
                GUEST_SELECTION: {
                    type: 'guestselection',
                    value: null,
                },
                // Date value must be in YYYY-MM-DD
                DATE: {
                    squash: true,
                    type: 'accessoDate',
                    value: null,
                },
				// simple boolean of true if desired
                DIRECT_TO_CHECKOUT: {
                    squash: true,
                    value: null,
                }
            }
        })
		.config(BuyNowRoutes);

	/**
	 * Buy Now routing configuration
	 * @param {Service} $stateProvider - Angular UI Router state provider
	 * @param {Constant} BuyNowConstants - Buy Now Constants
	 * @constructor
	 * @ngInject
	 */
	function BuyNowRoutes($stateProvider, BuyNowConstants) {
		$stateProvider
			.state('buy-now', {
				url: '/buy-now/:packageId/{customerTypesHash}/{date}/{directToCheckout}',
				templateUrl: 'buy-now-loading',
				title: 'buyNow',
				controller: 'BuyNowController',
                controllerAs: 'vm',
                params: {
					customerTypesHash: BuyNowConstants.param.GUEST_SELECTION,
					date: BuyNowConstants.param.DATE,
					directToCheckout: BuyNowConstants.param.DIRECT_TO_CHECKOUT
				},
				resolve: { 
					loadFiles: loadFiles
				}
			});

		/**
		 * Load in the files for the Buy Now module
		 * @resolve
		 * @param {Service} BundleService - Our Bundle service
		 * @returns {Promise}
		 * @ngInject
		 */
		function loadFiles(BundleService) {
			return BundleService.lazyLoadCollectionFiles(BundleService.enums.BUY_NOW);
		}
	}

})();
(function () {
	'use strict';

	angular
		.module('app')
		.directive('acInclude', acInclude);

	/**
	 * ac-include directive that acts just like ng-include without the creation of isolated scopes
	 * @constructor
	 * @param {Service} $http - The $http Service
	 * @param {Service} $templateCache - The $templateCache Service
	 * @param {Service} $compile - The $compile Service
	 * @returns {Function} - The directive definition
	 */
	function acInclude($http, $templateCache, $compile) {
		return function(scope, element, attrs) {
			var key = attrs.acInclude;

			if ($templateCache.get(key)) {
				$compile(element.html($templateCache.get(key)).contents())(scope);

				return;
			}

			$http
				.get(key, { cache: $templateCache })
				.then(function onSuccess(response) {
					$compile(element.html(response).contents())(scope);
				});
		};
	}
})();
/**
 * @ngdoc function
 * @name shoplandApp.directive:addrLookup
 * @description
 * # addrLookup
 * Directive of the shoplandApp
 */
angular.module('app')
	.directive('addrLookup'
		, function(
			$uibModal
			, AppData
			, Language
			, AddrLookup
			, Modal
			, Enums
		) {
			return {
				restrict: 'AE',
				templateUrl: '/views/templates/addrLookupTemplate.html',
				scope: {
					mainAddress: '=',
					secAddress: '=',
					city: '=',
					state: '=',
					province: '=',
					countryCode: '=',
					postalCode: '=',
					requiredCountry: '<',
					toggleAddrLookupOnOff: '&',
					handleCountryChanged: '&'
				},
				link: function(scope, element, attrs) {
					// Additional scope variables
					scope.i18n = Language;
					scope.showAddrLookupForm = AddrLookup.showAddrLookupForm;
					scope.countries = AppData.countries;
					scope.houseNumber = '';

					/**
             * changeCountry - calls handleCountryChanged from parent controller and formulates
             * the parameter into an object since directive-to-controller communication requires this
             * @public
             * @param {Number} - $index
             */
					scope.changeCountry = function($index) {
						scope.handleCountryChanged({ item: $index });
					}

					scope.toggleAddrLookupOff = function() {
						scope.toggleAddrLookupOnOff({ bool: false });
					}

					/**
             * searchAddress - validates inputs for address search and calls searchAddress from AddrLookup service
             * @public
             */
					scope.searchAddress = function() {
						if (scope.houseNumber && scope.postalCode && scope.countryCode) {
							var lookupData = {
								houseNumber: scope.houseNumber,
								postalCode: scope.postalCode,
								country: scope.countryCode
							};
							AddrLookup.searchAddress(lookupData, displayAddrLookupResultsModal, setFormattedAddress).catch(function() {
								// Failed to locate address, so switch to "Enter Address Manually" panel
								scope.enterAddrManually();
							});
						} else {
							Modal.displayModal(
								{
									category: 'Address Lookup Incomplete',
									action: 'Error',
									title: Language.getLocale('Alert', 'incompleteSearchAddressLookupTitle'),
									label: 'Address Lookup Incomplete',
									icon: 'icon-info red',
									description: Language.getLocale('Alert', 'incompleteSearchAddressLookupMsg'),
									buttonFlags: [Enums.buttonFlags.OK]
								}
							);
						}
					}

					/**
             * enterAddrManually - disables off address lookup directive from view so user can enter all fields
             * @public
             */
					scope.enterAddrManually = function() {
						scope.toggleAddrLookupOff();
					}

					/**
             * setFormattedAddress - sets scope variables to formatted address variables post address lookup selection
             * @private
             * @param {Object} formattedAddress
             */
					function setFormattedAddress(formattedAddress) {
						scope.mainAddress = formattedAddress.address1 ? formattedAddress.address1 : '';
						scope.secAddress = formattedAddress.address2 ? formattedAddress.address2 : '';
						scope.city = formattedAddress.city ? formattedAddress.city : '';
						scope.province = formattedAddress.province ? formattedAddress.province : '';
						scope.state = formattedAddress.state ? formattedAddress.state : '';
						scope.postalCode = formattedAddress.postalCode ? formattedAddress.postalCode : '';
						scope.toggleAddrLookupOff();
					}

					/**
             * displayAddrLookupModal - show the address lookup results modal
             * @private
             * @param {Object} formattedAddress
             */
					function displayAddrLookupResultsModal() {
						var modInstance = $uibModal.open({
							templateUrl: '/views/modals/addrLookupResults.html',
							controller: 'AddrLookupResultsCtrl',
							backdrop: 'static'
						});

						modInstance.result.then(function(result) {
							if (result) {
								AddrLookup.callAddressFormat(result, setFormattedAddress);
							} else {
								scope.enterAddrManually();
							}
						});
					}
				}
			}
		});

/**
 * Created by ltischuk on 11/20/14.
 */
angular.module('app')
	.directive('choiceQtyBubble'
		, function() {
			return {
				restrict: 'E',
				require: 'ngModel',
				scope:
			{
				bubbleQty: '@',
				//expect a comma separated list of values
				disabledValues: '@',
				enabledValues: '@',
				name: '@',
				onValid: '&',
				invalidValue: '@',
				getTotalQty: '&'
			},
				templateUrl: '/views/templates/choice-qty-bubble.html',
				controller: function($scope) {
					$scope.bubbles = [];
					$scope.bubbleQty = Number($scope.bubbleQty);
					$scope.disabledValues = ((angular.isDefined($scope.disabledValues) && $scope.disabledValues.length >0) ? $scope.disabledValues.split(',') : []).map(function(value) {
						return Number(value);
					});
					$scope.enabledValues = ((angular.isDefined($scope.enabledValues) && $scope.enabledValues.length >0) ? $scope.enabledValues.split(',') : []).map(function(value) {
						return Number(value);
					});
					$scope.invalidValue = Number($scope.invalidValue);

					for (var i =0; i <= $scope.bubbleQty; i++) {
						var bubble = {
							val: i,
							active: false,
							disabled: false
						};

						if ($scope.disabledValues.length > 0 && $scope.disabledValues.indexOf(i) > -1 ||
						($scope.enabledValues.length>0 && $scope.enabledValues.indexOf(i) == -1)) {
							bubble.disabled = true;
						}

						$scope.bubbles.push(bubble);
					}
				},
				link: function(scope, element, attrs, ngModelCtrl) {
					ngModelCtrl.$viewChangeListeners.push(function() {
						scope.$eval(attrs.ngChange);
					});

					// add a parser that will process each time the value is
					// parsed into the model when the user updates it.
					ngModelCtrl.$parsers.unshift(function(value) {
					// test and set the validity after update.
						testValidity(value);

						return value;
					});

					// add a formatter that will process each time the value
					// is updated on the DOM element.
					ngModelCtrl.$formatters.unshift(function(value) {
					// validate.
						testValidity(value);

						return value;
					});

					//the model can be updated outside of the view (e.g. pricing upsell selection)
					//so we must watch for it and update the bubbles accordingly
					scope.$watch(function() {
						return ngModelCtrl.$modelValue;
					}, function(newVal, oldVal) {
						if (angular.isDefined(newVal) && angular.isDefined(oldVal)) {
							updateBubbles(newVal);
						}
					});

					scope.selectQty = function(val) {
						if (!scope.bubbles[val].disabled) {
							ngModelCtrl.$setViewValue(val);
						}
					}

					function updateBubbles(val) {
						scope.bubbles.forEach(function(bubble) {
							if (bubble.val <= val && !bubble.disabled) {
								bubble.active = true;
							} else {
								bubble.active = false;
							}
						});
					}

					/**
					 * assess the validity of each value given an outside total that must be compared against
					 * For days its the total days
					 * @param value
					 */
					function testValidity(value) {
						var valid = (value != Number(scope.invalidValue));
						if (scope.getTotalQty) {
							var newTotal = scope.getTotalQty() + (value - ngModelCtrl.$modelValue);
							if (!angular.isNumber(newTotal) || newTotal == Number(scope.invalidValue)) {
								valid = false;
							} else {
								valid = true;
							}
						}

						ngModelCtrl.$setValidity('selection', valid);

						if (scope.onValid) {
							scope.onValid({ shouldOverride: valid });
						}
					}
				}
			}
		});

/**
 * Created by ltischuk on 02/20/14.
 */
angular.module('app')
	.directive('uiSpinner', uiSpinner);

/**
	 * @ngInject
	 */
function uiSpinner() {
	return {
		restrict: 'A',
		template: '<div class="ac-spinner" ng-class="classes"></div>',
		link: function(scope, element, attrs) {
			if (attrs.uiSpinner === 'absolute') {
				scope.classes = 'absolute';
			} else if (attrs.uiSpinner === 'input') {
				scope.classes = 'input';
			}
		}
	};
}
/**
 * Created by jwroblewski on 8/10/2015.
 * (Copied as-is from the deleted file app/scripts/directives/billing.js)
 */
angular.module('app').directive
('uiValidateEquals'
	, function() {
		return {
			restrict: 'A',
			require: 'ngModel',
			link: function(scope, elm, attrs, ctrl) {
				var ngIsDefined = angular.isDefined;
				/**
				 * Applies validation
				 * @protected
				 * @param {string} myValue value to be compared against base value
				 * @param {string} otherValue base value
				 * @returns {string} value to be compared against base value
				 */
				function validateEqual(myValue, otherValue) {
					if (attrs.required == false) {
					// email validation is based on config. Return true if email validation is not required.
						return validate(myValue, true);
					}

					if (ngIsDefined(myValue) && ngIsDefined(otherValue)) {
						if (attrs.checkcase === 'true') {
							if (myValue.toString() === otherValue.toString()) {
								return validate(myValue, true);
							} else {
								return validate(myValue, false);
							}
						}
						if (myValue.toString().toLowerCase() === otherValue.toString().toLowerCase()) {
							return validate(myValue, true);
						} else {
							return validate(myValue, false);
						}
					} else {
						return validate(myValue, false);
					}
				}

				/**
				 * Applies validation
				 * @private
				 * @param {string} myValue value to be compared against base value
				 * @param {boolean} bool validation variable
				 * @returns {string} value to be compared against base value
				 */
				function validate(myValue, bool) {
					ctrl.$setValidity('equal', bool);
					return myValue;
				}

				scope.$watch(attrs.uiValidateEquals, function(otherModelValue) {
					validateEqual(ctrl.$viewValue, otherModelValue);
				});

				scope.$watch(function() {
					return attrs.required
				}, function() {
				//no matter what the new value of attrs.required is, lets facilitate a
				// validateEqual check which will determine what to test if needed
					validateEqual(ctrl.$viewValue, scope.$eval(attrs.uiValidateEquals));
				});

				ctrl.$parsers.unshift(function(viewValue) {
					return validateEqual(viewValue, scope.$eval(attrs.uiValidateEquals));
				});

				ctrl.$formatters.unshift(function(modelValue) {
					return validateEqual(modelValue, scope.$eval(attrs.uiValidateEquals));
				});
			}
		};
	});

/**
 * Created by ltischuk on 9/28/15.
 */
angular.module('app').directive
('uiValidateNotEquals'
	, function() {
		return {
			restrict: 'A',
			require: 'ngModel',
			link: function(scope, elm, attrs, ctrl) {
				function validateNotEqual(myValue, otherValue) {
					if (attrs.required == false) {
						// email validation is based on config. Return true if email validation is not required.
						ctrl.$setValidity('notequal', true);
						return myValue;
					}

					if (typeof myValue != 'undefined' && typeof otherValue != 'undefined') {
						if (myValue.toString().toLowerCase() === otherValue.toString().toLowerCase()) {
							ctrl.$setValidity('notequal', false);
							return myValue;
						} else {
							ctrl.$setValidity('notequal', true);
							return myValue;
						}
					} else {
						ctrl.$setValidity('notequal', true);
						return myValue;
					}
				}

				scope.$watch(attrs.uiValidateNotEquals, function(otherModelValue) {
					validateNotEqual(ctrl.$viewValue, otherModelValue);
				});

				ctrl.$parsers.unshift(function(viewValue) {
					return validateNotEqual(viewValue, scope.$eval(attrs.uiValidateNotEquals));
				});

				ctrl.$formatters.unshift(function(modelValue) {
					return validateNotEqual(modelValue, scope.$eval(attrs.uiValidateNotEquals));
				});
			}
		};
	});

/**
 *
 * calendarBasePricing depends >> Calendar depends >> angular-datepicker
 *
 * EVENT BROADCAST:
 * 			$calendarBasePricingSetClassComplete
 *
 *
 *
 * The following directive is only specified to CalendarPricingCtrl,
 * This will set the class to each specific flag in the calendar
 *
 *
 */

angular.module('app')
	.directive('calendarBasePricing', [
		'Utilities',
		function(Utilities) {
			return {
				template: '<div'
						+ ' calendar'
						+ ' callbacks="callbacks"'
						+ ' options="calendarOptions" >'
						+ '</div>',

				link: function(scope) {
					//the different class colors available
					var cssClass = ['one', 'two', 'three', 'four', 'five']
					var last_key = null;

					scope.setClass = function(date) {
						var colorRange = cssClass.length;
						var colorClass = '';

						//if there is no data no need to loop
						if (Utilities.isEmpty(scope.calendarOptions.monthPackages) || typeof(scope.calendarOptions.monthPackages) == "undefined") {
							return false;
						}

						var monthPackages = scope.calendarOptions.monthPackages
						var selected = Utilities.getDateByString(date)

						//check that we have those packages
						if (typeof(monthPackages[selected]) != "undefined") {
							var minPrice = Number(monthPackages[selected].lowest_price)
							var rdiff = scope.maxRange - scope.minRange

							var mod = rdiff / colorRange;

							for (var m=0; m<colorRange; m++) {
								var price_diff = (mod * m) + scope.minRange
								if (minPrice >= price_diff) {
									colorClass = cssClass[m]
								}
							}

							//add class to object
							monthPackages[selected].colorClass = colorClass

							//if we have reached the end of loop send broadcast
							if (last_key == selected) {
								scope.$broadcast('$calendarBasePricingSetClassComplete')
							}
						}//close typeof

						return colorClass
					}

					function lastKey() {
						var count = 0;
						Object.keys(scope.calendarOptions.monthPackages).forEach(function(key) {
							count++
							if (count == Object.keys(scope.calendarOptions.monthPackages).length) {
								last_key = key
							}
						});
					}

					scope.$on('$CalendarCtrlMonthPackages', function(event, data) {
						lastKey()
					})
				}
			}
		}
	]
	);


angular.module('app')
	.directive('clearInputField', [
		'$compile',
		'$timeout',
		'$parse',
		'ClientInfo',
		'Utilities',
		'Language',
		function($compile, $timeout, $parse, ClientInfo, Utilities, Language) {
			var directive = {
				require: '?ngModel',
				link: function(scope, element, attrs, control) {
				//if the ngModel has not been build
					if (!control) {
						return;
					}

					var right =
					(
						function() {
							var attributes = attrs.$$element[0].attributes;
							if (Object.keys(attributes).length > 0) {
								for (var key in attributes) {
									if (attributes[key] !== null && angular.isDefined(attributes[key]) &&
										angular.isDefined(attributes[key]['localName']) &&
										attributes[ key ].localName == 'clear-input-field') {
										if (attributes[ key ].value != '') {
											return Number(attributes[ key ].value);
										}
									}
								}

								return 0;
							}
						}
					)();

					//due to timing issues the placeholder may not render
					//set the $render of the controller to build the
					//placeholders
					var getPlaceholder = scope.$watch
					(function() {
						return attrs.placeholder;
					},
					function(placeholder) {
						if (!placeholder) {
							return;
						}
						//oh the placeholder content arrived late
						//lets render the placeholder spoof
						control.$render()

						//cancel the function
						getPlaceholder();
					});

					// Wraps the input element with div and adds a div with close-button class.
					var wrapper = angular.element('<div class="input-wrapper">');
					var classes = 'icon-closesolid icon-medium z-4 hide';
					var cautionClasses = 'icon-caution icon-medium text-handle hide';
					classes = (right == 0) ? classes : 'right-extra ' + classes;

					var caution = angular.element('<span>').addClass(cautionClasses)
						.on('mousedown click touchstart', function() {
							element[ 0 ].focus();
						});

					var button = angular.element('<span>').addClass(classes)
						.on('keydown mousedown click touchstart', function(event) {
							if (event.type !== 'keydown' || event.keyCode === 13) {
								if (event.keyCode === 13) {
									event.preventDefault();
								}

								// Reset the input field and the data stored for it.
								control.$setViewValue('');
								element.val('');

								// Hide the button.
								button.addClass('hide');
								parent.addClass('no-padding-right');
								parent.removeClass('focus-push-down');

								// Set focus back on the button.
								//  TODO: Does this need to be wrapped in a timeout?
								$timeout(function() {
									try {
										element[0].focus()
									} catch (e) { }
								}, 100)

								// Apply the changes.
								scope.$apply();
							}
						})
						.on('focusout blur', function() {
							button.addClass('hide');
							parent.addClass('no-padding-right');

							if (element.val() === '') {
								parent.removeClass('focus-push-down');
							}
						});

					button.attr('aria-label', Language.getLocale('Accessibility', 'clearInputField'));
					button.attr('role', 'button');
					button.attr('tabindex', '0');

					var parent = element.parent();
					var label = parent.find("label");

					control.$render = function() {
					//controller may come back as empty, because it may not have been initiated
						//this is more for autofill options
						var updateView = true;
						if (angular.isUndefined(control.$viewValue)) {
						/*if the modul value is undefined just return
						- an angular parser (ng-minlength is an offender) see this https://github.com/angular/angular.js/issues/1412 on this issue
						in the case where both model and view are undefined, do not render,*/
							if (angular.isUndefined(control.$modelValue)) {
								updateView = false;
							} else {
								control.$viewValue = angular.copy(control.$modelValue);
							}
						}

						if (updateView) {
							element[0].value = control.$viewValue;
							if (element[0].value !== "") {
								parent.addClass('focus-push-down');
								parent.addClass('no-padding-right');
							} else {
								parent.removeClass('focus-push-down');
								parent.removeClass('no-padding-right');
							}

							//if there is data return set the input with the autofill info
							$parse(attrs.ngModel).assign(scope, control.$viewValue);
						}


						if (attrs.placeholder) {
						// IE 9 and below & Opera Mini v7 doesnt support placeholder although its DOM seems to indicate so
						//this injects a placeholder replacement span tag into the parent on this element
						//this acts like the input tag placeholder attribute in HTML5 standard
							var isOperaMini = Object.prototype.toString.call(window.operamini) == '[object OperaMini]';
							var isInputSupported = 'placeholder' in document.createElement('input') && !isOperaMini;
							var isTextareaSupported = 'placeholder' in document.createElement('textarea') && !isOperaMini;
							var navigator = window.navigator;
							var isIE = ClientInfo.browserName == "IE" && ClientInfo.browserName !== "Edge";

							if (isIE) {
								element.removeAttr('placeholder');
							}

							//only to display on website that dont support placeholder
							if (!isInputSupported && !isTextareaSupported || isIE) {
							//check if we already have the placeholder replacement
								var placeholder = getInpPlaceholderReplacement(parent);

								//if we don't have the placeholder, create it along with appropriate watchers
								if (!placeholder) {
									placeholder = angular.element('<span class="placeholder" >'+attrs.placeholder+'</span>');
									placeholder.css({
										position: 'absolute',
										'z-index': 4,
										top: '0px',
										padding: '13px',
										'font-size': '14px',
										opacity: '.50',
										display: 'inline-block',
										left: '0px'
									}).on('click', function() {
									//if the click on placeholder skin then focus on input box
										element[0].focus();
									});

									//only to hide when keyboard is press
									element.on('keyup', function(e) {
										if (e.which !== 9 && angular.isDefined(placeholder)) {
											placeholder.css({ display: 'none' });
										}
									});

									//once we remove focus out of input boxes,
									//and no data is present display the placeholder
									element.on('focusout blur', function() {
										if (element.val() == '' && angular.isDefined(placeholder)) {
											placeholder.css({ display: '' });
										}
									});

									//this watch is needed to observe model changes and update the css on the
									//placeholder replacement span tag. Otherwise, the css changes will only occur
									//if the user clicks in the actual element.  If the model value is updated on a different
									//input element, then the css will not reflect the change.
									attrs.$observe('ngModel', function(value) {
										scope.$watch(value, function(newValue) {
											if (angular.isDefined(value) && Utilities.isEmpty(newValue) && angular.isDefined(placeholder)) {
												placeholder.css({ display: 'inline-block' });
											} else if (!Utilities.isEmpty(newValue) && angular.isDefined(placeholder)) {
												placeholder.css({ display: 'none' });
											}
										});
									});

									//append the placeholder to the parent element,
									//THE PARENT ELEMENT MUST BE A 'RELATIVE POSITION'
									element.parent().append(placeholder);
								}

								if (element.val() != '' && angular.isDefined(placeholder)) {
									placeholder.css({ display: 'none' });
								}
							}
						}
					};

					element.on('mousedown focusin focus keyup keydown', function(event) {
						label.addClass('focus');

						if (element.val() != '') {
						// Show the button.
							button.removeClass('hide');
							parent.removeClass('no-padding-right');
							// Push text down
							parent.addClass('focus-push-down');
						} else {
							button.addClass('hide');
							parent.removeClass('focus-push-down');
							parent.addClass('no-padding-right');
						}

						// Hide clear X button when shift+tab into previous input field.
						if (event.type === 'keydown' && event.keyCode === 9 && event.shiftKey) {
							button.addClass('hide');
							parent.addClass('no-padding-right');
							if (element.val() === '') {
								parent.removeClass('focus-push-down');
							}
						}
					}).on('blur', function(event) {
						label.removeClass('focus');

						if (element.val() != '') {
						// When element receiving focus is not the clear button, then you can hide clear X button.
						// Need to fallback to document.activeElement for IE11 support
							var relTarget = event.relatedTarget || document.activeElement;

							if (relTarget !== button[0]) {
								button.addClass('hide');
							}

							parent.addClass('no-padding-right');
						}
					});

					if (ClientInfo.deviceType === 'mobile') {
						element.wrap(wrapper).parent().append(button);
					} else {
						element.wrap(wrapper);
					}

					element.parent().append(caution);

					/**
					 * getInpPlaceholderReplacement - obtain the placeholder replacement
					 * this will only be called for browsers that do not support HTML5 input tag placeholder attribute
					 * @param parentElement
					 * @returns {undefined or the actual span tag with placeholder class on the parent}
					 */
					function getInpPlaceholderReplacement(parentElement) {
						var spanTags = parentElement.find('span');
						var foundPlaceholder = undefined;
						for (var i = 0; i < spanTags.length; i++) {
							var tag = spanTags[i];
							if (tag.className && tag.className == 'placeholder') {
								foundPlaceholder = angular.element(tag);
								break;
							}
						}
						return foundPlaceholder;
					}
				}
			}

			return directive;
		}
	]
	);

(function() {
	'use strict';

	angular
		.module('app')
		.directive('currencyColor', currencyColor);

	/**
	 * This pattern will match any pricing
	 * @see {@link https://regex101.com/r/LOfQZm/1}
	 */
	var curSyms = /[\$\xA2-\xA5\u058F\u060B\u09F2\u09F3\u09FB\u0AF1\u0BF9\u0E3F\u17DB\u20A0-\u20BD\uA838\uFDFC\uFE69\uFF04\uFFE0\uFFE1\uFFE5\uFFE6]/,
		curVal = /\d{1,3}(?:[.,]?\d{3}|\d)*(?:[.,]\d{2})?/,
		currencyRe = new RegExp('(' + curSyms.source + curVal.source + '|' + curVal.source + curSyms.source + ')', 'g');

	/**
	 * The currencyColor directive
	 * @constructor
	 * @param {Service} Utilities - The Utilities service
	 * @returns {Object} - The directive definition
	 * @ngInject
	 */
	function currencyColor(Utilities) {
		return {
			link: function(scope, element) {
				scope.$watch(element.text(), function watchForElementUpdates(newVal, oldVal) {
					element.html(
						Utilities.getString(element.html())
							.replace(currencyRe, '<span class="gap-text--currency">$1</span>')
					);
				});
			},
			restrict: 'A'
		};
	}
})();
angular
	.module('app')
	.directive('desktopNavigation', function(
		$rootScope,
		$state,
		$timeout,
		AppData,
		ClientInfo,
		Enums,
		ExtraFlow,
		Navigation,
		Storage,
		Package,
		Utilities,
		UtilsValidation
	) {
		return {
			controller: function($scope) {
				$scope.menuParentClick = function(e, data) {
					resetNavigationOnRoute(e);

					// NOTE: Updating service data directly.
					AppData.keywordMenuItems = [data];
					desktopNavigationMenuClick(e, data);
				};

				$scope.subMenuClick = function(e, data) {
					resetNavigationOnRoute(e);

					if (data.alternateModule && data.alternateModule.length > 0) {
						Package.resetAdvancedTicket();
						// There's an alternateFlowModule and it's enabled.
						Navigation.routeToAlternateModule(data);
					} else {
						desktopNavigationMenuClick(e, data);
					}
				};

				$scope.childSubMenuClick = function(e, item) {
					resetNavigationOnRoute(e);

					if (angular.isDefined(item.alternateModule) && item.alternateModule.length > 0) {
						Package.resetAdvancedTicket();
						Navigation.routeToAlternateModule(item);
					} else if (angular.isDefined(item.promo_code)) {
						$scope.routeTo($state.href('/packageList/promocode/:promocode', { promocode: item.promo_code }));
					} else {
						$scope.routeTo($state.href('packageList/keyword', { keyword: item.keywords }));
					}
				};

				function resetNavigationOnRoute(e) {
					$rootScope.$broadcast('navbarOrMenuClicked');

					AppData.isInCheckout = false;

					// Destroy any storageInformation...
					Storage.remove('pkgDetailsReInitControls', true);

					// Don't let event bubble up.
					Utilities.stopEventPropagation(e);
					Utilities.scrollPosition();

					for (var i=0; i < $scope.desktopMenuItems.length; i++) {
						$scope.desktopMenuItems[i].selected = false;

						if (angular.isDefined($scope.desktopMenuItems[i].MENUITEM)) {
							for (var x=0; x < $scope.desktopMenuItems[i].MENUITEM.length; x++) {
								$scope.desktopMenuItems[i].MENUITEM[x].selected = false;
							}
						}
					}
				}

				function desktopNavigationMenuClick(e, data) {
					// Select the sub menu that was clicked.
					data.selected = true;
					AppData.updateLastKeyword(data.keywords, "desktopnavigation desktopNavigationMenuClick");

					var alternateFlow = ExtraFlow.isAlternateFlow(AppData.lastKeyword, [data]);
					if (alternateFlow != '') {
						Package.resetAdvancedTicket();
						var view = ExtraFlow.getAlternateFlowView(alternateFlow);
						var path = '';
						if (view && !ExtraFlow.isAlternateFlowViewRepresentedAsAStateName(alternateFlow)) {
							path = '/' + AppData.lastKeyword;
						}

						$scope.routeTo(view + path);
						return;
					}

					$scope.routeTo($state.href('packageList/navItem', { navItem: data.label }));
				}
			},
			link: function(scope, element) {
				var validArray = UtilsValidation.validArray,
					wrapObjectToArray = Utilities.wrapObjectToArray;

				//only if this is a desktop
				var appActivatedListener;

				// Before we can set the desktop menu items, we have to wait for the application to activate.
				if (AppData.applicationActivated) {
					setDesktopMenuItems();
				} else {
					appActivatedListener = $rootScope.$on(Enums.services.APP_ACTIVATED, function() {
						// Free memory
						appActivatedListener();
						appActivatedListener = null;
						setDesktopMenuItems();
					});
				}

				/**
				 * Sets the desktop menu items
				 * @protected
				 * @function
				 * @name setDesktopMenuItems
				 * @returns {undefined}
				 */
				function setDesktopMenuItems() {
					var runLayout = function() {
						element[0].layout();
					};

					scope.desktopMenuItems = AppData.menuItems = trimNavigationSet(AppData.menuItems);

					// #thanksangular for being so crappy that we have to do this
					if (element[0].layout) {
						$timeout(runLayout, 400);
						$timeout(runLayout, 800);
					}
				}

				/**
				 * Attempts to remove navigation items that have no packages listed
				 * @protected
				 * @function
				 * @param {Object[]} menuItems The menu item set reference
				 * @returns {Object[]} The filtered menu items
				 */
				function trimNavigationSet(menuItems) {
					return menuItems.filter(function filterMenuItemSet(item) {
						var MENUITEM = wrapObjectToArray(item.MENUITEM, true);
						var pkgs = Package.filterPackagesByKeyword(undefined, item.keywords, false);

						// If there is a MENUITEM defined, let's try to recursively trim it as well
						if (validArray(MENUITEM)) {
							item.MENUITEM = trimNavigationSet(MENUITEM);

							// Do another check to see if all the MENUITEMS were trimmed and we can remove this node
							if (!validArray(item.MENUITEM)) {
								delete item.MENUITEM;
							}
						} else {
							delete item.MENUITEM;
						}

						// Returns true if the menu has a valid submenu OR has valid packages under its' keywords
						return !!item.MENUITEM || validArray(pkgs);
					});
				}
			}
		};
	});

angular.module('app')
	.directive('formatDate', [
		'$q',
		'$filter',
		'AppData',
		'Utilities',
		function($q,
			$filter,
			AppData,
			Utilities
		) {
			return {
				restrict: 'A',
				require: '?ngModel',
				scope: { dateValidationType: '@' },
				link: function(scope, elm, attrs, ctrl) {
					if (!ctrl) {
						return;
					}

					scope.prevDOB = '';

					var date_format = AppData.settings.date_format || 'MM/dd/yyyy';
					var date_format_array = date_format.toLowerCase().split('/');

					elm.on('blur', function() {
						scope.$apply(handleBlur);
					});

					elm.on('keyup', function() {
						scope.$apply(handleChanged);

						if (angular.isDefined(ctrl.$modelValue) && ctrl.$modelValue.length === Number(attrs.maxlength)) {
							scope.$apply(handleBlur);
						}
					})

					init();

					function init() {
						handleChanged();
						handleBlur();
					}

					/**
						 * Renders the Inputed value back to the ctrl
						 * @private
						 * @param {string} value
						 * @return {null}
						 */
					function renderValue(value) {
						ctrl.$setViewValue(value);
						ctrl.$render();
						return;
					}

					/**
						 * Based on the validationType that is set on the scope then different criteria
						 * can be used to determine the validity of the date.
						 * @private
						 * @param {object} dateObj
						 * @returns {boolean}
						 */
					function isValidDateObj(dateObj) {
						switch (scope.dateValidationType) {
						case 'birthDate': {
							var calendarDateFlag = isValidCalendarDate(dateObj);
							var pastOrPresentDateFlag = isPastOrPresentDate(dateObj);
							var yearsFlag = isDateLessThanXYears(dateObj, 151);

							return (calendarDateFlag && pastOrPresentDateFlag && yearsFlag);
							break;
						}
						default: {
							var calendarDateFlag = isValidCalendarDate(dateObj);
							var yearsFlag = isDateLessThanXYears(dateObj, 151);
							return (calendarDateFlag && yearsFlag);
							break;
						}
						}
					}

					/**
						 * Checks to see if the date provided and the date generated are the
						 * same
						 * @private
						 * @param {object} genDate
						 * @param {string} providedDate
						 * @returns {boolean}
						 */
					function checkDate(genDate, providedDate) {
						if (genDate === providedDate) {
							return true;
						}
						return false;
					}

					function handleBlur() {
						//var value = ctrl.$modelValue;
						//ctrl.$setViewValue( '11/11/1963' )
						var value = ctrl.$modelValue || undefined;

						if (value === undefined) {
							return;
						}
						if (value != '') {
							var patt = new RegExp(/[0-9]\//)
							if (patt.test(value) == false) {
								renderValue('');
							}
						}
						value = fixSmallDates(value);
						var dateObj = Utilities.parseDate(value, date_format);
						if (isValidDateObj(dateObj)) {
							var dob = new Date(dateObj.year, dateObj.month, dateObj.day);
							dob = $filter('date')(dob, date_format);
							if (checkDate(dob, value)) {
								renderValue(dob);
								return dob;
							} else {
								renderValue(dob);
								return dob;
							}
						} else {
							renderValue('');
						}
					}

					/**
						 * Applies mask to DOB.
						 * @public
						 * @todo apply a mask on the input field
						 * @example 'XX/XX/XXXX'
						 * [Possible Solution]{@link http://stackoverflow.com/questions/2616395/regular-expression-with-mask}
						 * @returns undefined
						 */
					function handleChanged() {
						var dob = ctrl.$modelValue || undefined;

						if (dob === undefined) {
							return;
						}
						var err = true;
						if (dob.indexOf("//") != -1 || (charSearch(dob, '/').length > 2 && dob.lastIndexOf("/") === (dob.length - 1))) {
							dob = dob.slice(0, dob.length - 1)
						}

						// Remove slashes, then check for non-digits
						var temp_dob = dob.replace(/\//g, '');
						var pat = new RegExp(/\D/);
						if (pat.test(temp_dob)) {
							dob = dob.slice(0, dob.length -1)
						}

						/*
							Only run the masking logic if:

							1. dob's length is at least the length of the config date_format's first section
								A. This makes the masking responsive to the config, where the first section's length can vary (yyyy vs dd or mm)
								B. Previously, it was hardcoded to 2, which was sufficient for only dd or mm scenarios

							2. dob's length is greater than prevDOB's length
								A. This makes the masking only happen as the user types, not if they are backspacing
						 */
						if (dob.length >= date_format_array[0].length && dob.length > scope.prevDOB.length) {
							var indicies = charSearch(dob, '/');
							var prevIndicies = charSearch(scope.prevDOB, '/');
							var maxLen = (indicies.length > prevIndicies.length ? indicies.length : prevIndicies.length);

							for (var x = 0; x < maxLen; x++) {
								/*
									Setting err to false is key to triggering the else if below, which adds a /

									1. We must have less than 2 indicies or we don't want to add another /
										A. This logic will actually only handle adding the second /
											so technically the condition could be changed to indicies.length === 1

									2. The dob's length must equal the index of the / plus 3
										A. Regardless of the format (yyyy/mm/dd vs mm/dd/yyyy), the second / will always be 2 characters after the first
											Thus it is + 3 due to length not being zero indexed
								 */
								if (indicies.length < 2 && dob.length === indicies[x] + 3) {
									err = false;
								}
							}
							if (indicies.length == 0 && prevIndicies.length == 0 && err) {
								dob += '/';
							} else if (indicies.length == 1 && prevIndicies.length == 1 && !err) {
								dob += '/';
							}
						}
						scope.prevDOB = dob;
						ctrl.$setViewValue(dob);
						ctrl.$render();
						return dob;
					}

					/**
						 * Gets an array of all of the indicies of a character in a string
						 * @private
						 * @param {string} haystack
						 * @param {string} needle
						 * @returns {array} indicies
						 */
					function charSearch(haystack, needle) {
						var indicies = [];
						for (var i = 0; i < haystack.length; i++) {
							if (haystack[ i ] === needle) {
								indicies.push(i);
							}
						}
						return indicies;
					}

					/**
						 * Fixes small dates
						 * @private
						 * @param { string } dob
						 * @returns { string } dob
						 */
					function fixSmallDates(dob) {
						newDob = dob.split('/');
						var finalDate = "";
						if (newDob.length === 3) {
							for (var x = 0; x < newDob.length; x++) {
								if (newDob[ x ].length === 1) {
									newDob[ x ] = "0" + newDob[ x ];
								}
							}
						}
						finalDate = newDob.join('/');
						return finalDate;
					}

					// TODO: When Input masking for date of birth based on current locale is implemented (whether it is by mask or drop downs) - jeffery.wroblewski@accesso.com
					// TODO: This function will be replaced by functions in the FormValidation service. - jeffery.wroblewski@accesso.com
					/**
						 * Function to validate that a parsed date falls within a valid calendar date.
						 * @param dateObj {object} An object that contains the year, month, and day properties that each represent the
						 *                         numeric value to be passed to a JavaScript Date object.
						 *                         Example: { year: 1955, month: 9, day: 21 } which is October 21st, 1955
						 * @returns {boolean} True if the dateObj values are a valid date on the calendar.
						 *                    False if not (such as February 30th or June 31st)
						 */
					function isValidCalendarDate(dateObj) {
						var dateFlag = false;
						if (dateObj && angular.isDefined(dateObj.year) && angular.isDefined(dateObj.month) && angular.isDefined(dateObj.day)) {
							var d = new Date(dateObj.year, dateObj.month, dateObj.day);
							if (d.getFullYear() == dateObj.year && d.getMonth() == dateObj.month && d.getDate() == dateObj.day) {
								dateFlag = true;
							}
						}
						return dateFlag;
					}

					// TODO: When Input masking for date of birth based on current locale is implemented (whether it is by mask or drop downs) - jeffery.wroblewski@accesso.com
					// TODO: This function will be replaced by functions in the FormValidation service. - jeffery.wroblewski@accesso.com
					/**
						 * Function to validate that a parsed date is in the past or on the current date.
						 * @param dateObj  {object} An object that contains the year, month, and day properties that each represent the
						 *                         numeric value to be passed to a JavaScript Date object.
						 *                         Example: { year: 1955, month: 9, day: 21 } which is October 21st, 1955
						 * @returns {boolean} True if the dateObj values form a date that is less than or equal to the current date (in the past or is the present).
						 *                    False if the date is in the future.
						 */
					function isPastOrPresentDate(dateObj) {
						var pastFlag = false;
						if (dateObj && angular.isDefined(dateObj.year) && angular.isDefined(dateObj.month) && angular.isDefined(dateObj.day)) {
							var dateToCheck = new Date(dateObj.year, dateObj.month, dateObj.day);
							var currentDate = new Date();
							pastFlag = ((dateToCheck <= currentDate));
						}
						return pastFlag;
					}

					// TODO: When Input masking for date of birth based on current locale is implemented (whether it is by mask or drop downs) - jeffery.wroblewski@accesso.com
					// TODO: This function will be replaced by functions in the FormValidation service. - jeffery.wroblewski@accesso.com
					/**
						 * Function to validate that a parsed date is less than the number of years based on the current date.
						 * @param dateObj  {object} An object that contains the year, month, and day properties that each represent the
						 *                         numeric value to be passed to a JavaScript Date object.
						 *                         Example: { year: 1955, month: 9, day: 21 } which is October 21st, 1955
						 * @param years {number} the number of years compared to the current date
						 * @returns {boolean} True if the dateObj values form a date that is less than the specified number of years.
						 *                    False if the date is older than the specified number of years.
						 */
					function isDateLessThanXYears(dateObj, years) {
						var yearFlag = false;
						if (dateObj && angular.isDefined(dateObj.year) && angular.isDefined(dateObj.month) && angular.isDefined(dateObj.day)) {
							var dateToCheck = new Date(dateObj.year, dateObj.month, dateObj.day);
							var currentDate = new Date();
							yearFlag = dateToCheck.getFullYear() > (currentDate.getFullYear() - Number(years));
						}
						return yearFlag;
					}
				}
			}
		}
	]
	)

/**
 * # Global Directives
 *
 * Directives used in the application
 */

/**
 * Ensures text entered is numberical.
 */

angular.module('app').directive
('numbersOnly'
	, function() {
		var directive =
		{
			link: function(scope, elm, attrs) {
				elm.bind
				('keyup'
					, function(event) {
						var replacedValue = event.target.value.replace(/\D/g, '');
						if (event.target.value != replacedValue) {
							event.target.value = replacedValue;
						}
						scope.$apply();
					}
				);
				elm.bind
				('keypress'
					, function(event) {
						event.keyCode = event.charCode || event.keyCode;

						if
						(event.shiftKey						 // disallow Shift
						|| (event.keyCode < 48			 // disallow non-numbers
						|| event.keyCode > 57
						)
						&& (event.keyCode == 110 || event.keyCode == 190) // disallow period / decimal point
						&& event.keyCode != 46			 // allow delete
						&& event.keyCode != 8				 // allow backspace
						&& event.keyCode != 9				 // allow not tab
						&& event.keyCode != 27			 // allow escape
						&& event.keyCode != 13			 // allow enter
						&& event.keyCode != 39			 // allow right arrow
						&& event.keyCode != 40			 // allow left arrow
						&& !(event.keyCode == 65		 // allow CTRL+A
						&& event.ctrlKey === true
						)
						&& !(event.keyCode == 67		 // allow CTRL+C
						&& event.ctrlKey === true
						)
						&& !(event.keyCode == 80		 // allow CTRL+P
						&& event.ctrlKey === true
						) && event.keyCode != 0			// allow numbers
						) {
							scope.$apply();
						}
					}
				);
			}
		};
		return directive;
	}
);

angular.module('app').directive
('backButton', function() {
	return {
		restrict: 'A',
		link: function(scope, element, attrs) {
			element.bind('click', goBack);

			function goBack() {
				history.back();
				scope.$apply();
			}
		}
	}
});

angular.module('app').directive
('onEnterKey', [function() {
	var directive =
	{
 	 restrict: 'A',
		scope: { method: '&onEnterKey' },
		link: function(scope, elm) {
			var expressionHandler = scope.method;

			elm.on
			('keypress'
				, function(event) {
			 event.keyCode = event.charCode || event.keyCode;

			 if (event.keyCode == 13) {
						expressionHandler();
			 }
				}
			);
		}
	};
	return directive;
}]
);
// TODO:Should this be a directive in the first place?
angular.module('app')
	.directive('customIcon', [function() {
		var directive = {
			link: function(scope) {
				angular.forEach(scope.menuItems, function(value, key) {
					var icon;
					if (angular.isDefined(value.customIcon) && value.customIcon !== "") {
						icon = 'icon-tickets icon-'+value.customIcon.toLowerCase().replace(/ /g, '-');
					} else {
						icon = 'icon-tickets icon-'+value.keywords.toLowerCase().replace(/ /g, '-');
					}
					scope.menuItems[key].icon = icon;
				})
			}
		};
		return directive;
	}
	]);

/**
 * Autofills for USA addresses - not supported for international addresses yet as certain undesirable behavior is elicited at times for international addresses
 */
angular.module('app').directive
('autofillMyLocation'
	, function($http, $timeout, AppData, FormValidation, Utilities) {
		var directive =
		{
			require: 'ngModel',
			link: function(scope, elm, attrs, ctrl) {
				var zipAutofillLength = Utilities.safelyCheckPropertyOnObject('AppData.settings.zip_autofill_length', AppData) ? AppData.settings.zip_autofill_length : 5;
				var validCountryCodes = ['US'];
				var validationPattern = [];
				for (var i = 0; i < validCountryCodes.length; i++) {
					validationPattern.push(FormValidation.getZip(validCountryCodes[i]));
				}
				ctrl.$parsers.unshift(getAutoFillData);
				function getAutoFillData(value) {
					Utilities.autoFillLocation(value, zipAutofillLength, validCountryCodes, validationPattern, elm);
					return value;
				}
			}
		};
		return directive;
	}
);

/**
 * # interactiveLocale Directives
 *
 * Directive that takes locale data (or any string) with HTML markup, compiles and renders it.
 * The purpose was specifically because (but not limited to) the fact that we can get a locale
 * like this 'I agree to the <a href="event:showTerms">terms and conditions</a>.' We need to handle
 * that interaction (i.e. showTerms). It's expected that scope defines showTerms()
 */

angular
	.module('app')
	.directive('interactiveLocale', ['$compile', function($compile) {
		return function(scope, elm, attrs) {
			scope.$watch(attrs.interactiveLocale, function(newValue, oldValue) {
				var val = newValue;
				if (val) {
					var i = val.indexOf('<a href="event:'),
						j,
						funcName = '',
						newVal = '';

					if (i > -1) {
						j = val.indexOf('">', i + 6);

						// Extract the function name.
						funcName = val.substring(i + 15, j);

						// Add Angular specific code.
						newVal = val.substring(0, i) + '<a data-ng-click="' + funcName + '()"' + val.substring(j + 1);

						// Update the val string which will be used to set the HTML content of the element.
						val = newVal;
					}
				}
				elm.html(val);
				$compile(elm.contents())(scope);
			});
		}
	}]);

(function() {
	'use strict';

	angular
		.module('app')
		.directive('creditCardType', CreditCardTypeDirective)
		.directive('expirationMonth', ExpirationMonthDirective);

	/**
	 * The credit-card-type directive
	 * 		"credit-card-type-scope" attribute allows you to change the scope of where we save the ccType, ccTypeDisplayAlias and cvvRequired.
	 * @public
	 * @constructor
	 * @param {Service} CreditCardsVerificationService CreditCardsVerificationService
	 * @param {Service} Utilities Utilities
	 * @param {Service} UtilsValidation UtilsValidation
	 * @returns {Object} the directive definition
	 * @ngInject
	 */
	function CreditCardTypeDirective(CreditCardsVerificationService, Utilities, UtilsValidation) {
		return {
			link: function(scope, elm, attrs, ctrl) {
				var disableCVV = Utilities.getBoolean(attrs.disableCvvValidation);
				var useVM = Utilities.getBoolean(attrs.useVm);
				var realScope = useVM ? scope.vm : scope;
				var localScope = realScope.payment;

				if (UtilsValidation.validString(attrs.creditCardTypeScope)) {
					localScope = Utilities.safelyCheckPropertyOnObject(attrs.creditCardTypeScope, realScope, Utilities.returnValue);
				}

				ctrl.$parsers.unshift(function(value) {
					var type = CreditCardsVerificationService.getCreditCardType(value, localScope.type),
						lengthValidity,
						validity;

					localScope.ccType = type;
					ctrl.$typeError = type === 'phcard';
					lengthValidity = CreditCardsVerificationService.validateCardNumber(value, type);
					validity = CreditCardsVerificationService.getBillingType(localScope, { account: value }) !== null && lengthValidity;

					// Set the TypeDisplayAlias:
					localScope.ccTypeDisplayAlias = CreditCardsVerificationService.setTypeDisplayAlias(type);
					ctrl.$lenError = ctrl.$typeError ? false : !lengthValidity;
					ctrl.$setValidity('invalid', validity);

					if (type === 'maestro' || type === 'atm' || disableCVV) {
						localScope.cvvRequired = false;
					} else {
						localScope.cvvRequired = true;
					}

					return value;
				});
			},
			require: 'ngModel'
		};
	}

	/**
	 * The expiration-month directive
	 * @public
	 * @constructor
	 * @param {Service} $filter $filter
	 * @param {Service} UtilsValidation UtilsValidation
	 * @param {Service} Utilities Utilities
	 * @retirms {Object} the directives definition
	 * @ngInject
	 */
	function ExpirationMonthDirective($filter, UtilsValidation, Utilities) {
		return {
			link: function(scope, elm, attrs, ctrl) {
				var validString = UtilsValidation.validString;
				var watchProps = '[payment.month,payment.year]';

				if (validString(attrs.expirationYearProperty) && validString(attrs.expirationMonthProperty)) {
					watchProps = '[' + attrs.expirationYearProperty + ',' + attrs.expirationMonthProperty + ']';
				}

				scope.$watch(watchProps, function(value) {
					var checkProp = Utilities.safelyCheckPropertyOnObject,
						returnValue = Utilities.returnValue,
						localScope = scope.vm || scope,
						year = checkProp((validString(attrs.expirationYearProperty) ? attrs.expirationYearProperty : 'localScope.payment.year'), localScope, returnValue),
						month = checkProp((validString(attrs.expirationMonthProperty) ? attrs.expirationMonthProperty : 'localScope.payment.month'), localScope, returnValue);

					ctrl.$setValidity('invalid', true);

					if (year == $filter('rightSubstring')(localScope.currentYear, 2) && month < $filter('leadingZeros')(localScope.currentMonth, 2)) {
						ctrl.$setValidity('invalid', false);
					}

					return value;
				}, true);
			},
			require: 'ngModel'
		};
	}
}());
"use strict";

angular.module('app')
	.directive
	(
		'fastLaneBanner',
		function(AppData, errorTracking, JSONValidator, Language, Utilities, $rootScope) {
			var directive = {
				templateUrl: '/views/templates/fastlanebanner.html',
				scope: { fastLaneBanner: '=fastLaneBanner' },
				link: function(scope, element, attrs, ngModelCtrl) {
				// Attempt to parse the config JSON string. If error, don't show the banner at all.
				// If no config at all, use the default value.
					var keyword = scope.fastLaneBanner.replace(/ /g, '_').toLowerCase();
					scope.fastLaneBannerStyles = getConfigByKeyword(keyword);

					function getConfigByKeyword(keyword) {
					// Sample Config:
					// AppData.GetApplicationConsolidated.SETTINGS[ keyword + '_banner_styles' ] = '{"logoImage":"headerImage","bannerCopy":"header","bannerBackgroundColor":"#FF0C69","bannerBorderColor":"#3201FF"}';
						if (Utilities.safelyCheckPropertyOnObject('AppData.GetApplicationConsolidated.SETTINGS.' + keyword + '_banner_styles', AppData)) {
							try {
							// We have a config object. Use that to create the options for the banner.

								if (JSONValidator.validate('fast_lane_banner_styles', AppData.GetApplicationConsolidated.SETTINGS[ keyword + '_banner_styles' ])) {
									var obj = JSON.parse(AppData.GetApplicationConsolidated.SETTINGS[ keyword + '_banner_styles' ]);
									// Set the bannerCopy to the locale it references (i.e. bannerCopy and logoImage are references to the locale target in the FastLane section).
									obj.bannerCopy = Language.getLocale('FastLane', obj.bannerCopy);
									obj.logoImage = $rootScope.getAssetUrl(Language.getLocale('FastLane', obj.logoImage));

									return obj;
								} else {
									throw new Error('JSON Config ' + keyword + '_banner_styles is not set up correctly.');
								}
							} catch (e) {
								errorTracking.notify('Error Extracting Fast Lane Config', 'Failed to parse Fast Lane config. Ensure config is set up appropriately.');
							}
						}

						// We do not have a config. Use the default settings.
						return {
							logoImage: $rootScope.getAssetUrl(Language.getLocale('FastLane', 'headerImage')) || $rootScope.getAssetUrl('fast_lane_module.png'),
							bannerCopy: Language.getLocale('FastLane', 'header'),
							bannerBackgroundColor: '#450C69',
							bannerBorderColor: '#320152'
						};
					}
				}
			}

			return directive;
		}
	);

/**
 * Created by ltischuk on 02/20/14.
 */
angular.module('app')
	.directive('formValidation'
		, function(AppData,
			FormValidation,
			Utilities,
			UtilsValidation) {
			var getBoolean = Utilities.getBoolean,
				getString = Utilities.getString,
				validArray = UtilsValidation.validArray;


			return {
				restrict: 'A',
				require: 'ngModel',
				priority: 2,
				scope:
			{
				validityEffector: '=',
				validityEffectorAsNumber: '<',
				validityEffectorNumber: '<',
				disableFormValidationForCondition: '=',
				passwordOptions: '=?',
				validationType: '@',
				validationOptions: '=?',
				customValidation: '@?'
			},
				link: function(scope, element, attrs, ngModelCtrl) {
				//setup variables
					var isRequired = getBoolean(attrs.required),
						disableFormValidation = getBoolean(AppData.settings.disable_form_validation),
						checkForCreditCard;

					scope.validationPattern = new RegExp('.*');

					if (attrs.type === 'email') {
						ngModelCtrl.$validators.email = _emailValidationOverride;
					}

					//if attribute is not passed in, set to none so that the validation defaults to no validation
					scope.validationType = angular.isDefined(scope.validationType) ? scope.validationType : 'none';
					scope.validationOptions = scope.validationOptions || {};
					checkForCreditCard = getBoolean(scope.validationOptions.cc);

					function obtainValidation() {
					//TODO we could replace this with the new service FormValidationService.getValidationPattern
						switch (scope.validationType) {
						case 'name': {
							scope.validationPattern = FormValidation.getName();
							break;
						}
						case 'zip': {
							scope.validationPattern = angular.isDefined(scope.validityEffector) ? FormValidation.getZip(scope.validityEffector) : FormValidation.getZip();
							break;
						}
						case 'phone': {
							scope.validationPattern = FormValidation.getPhone();
							break;
						}
						case 'phonebycountry': {
							scope.validationPattern = angular.isDefined(scope.validityEffector) ? FormValidation.getPhoneByCountry(scope.validityEffector) : FormValidation.getPhone();
							break;
						}
						case 'email': {
							scope.validationPattern = FormValidation.getEmail();
							break;
						}
						case 'namewithnumbers': {
							scope.validationPattern = FormValidation.getName('number');
							break;
						}
						case 'taxid': {
							scope.validationPattern = FormValidation.getTaxPayerId();
							break;
						}
						case 'positivenumbers': {
							scope.validationPattern = FormValidation.getPositiveNumbersRegex();
							break;
						}
						case 'alphanumeric': {
							scope.validationPattern = FormValidation.getAlphanumeric();
							break;
						}
						case 'securitycode': {
							if (scope.validityEffectorAsNumber) {
								scope.validationPattern = new RegExp('^[0-9]{' + (scope.validityEffectorNumber ? scope.validityEffectorNumber : 3) + '}$');
							} else {
								scope.validationPattern = angular.isDefined(scope.validityEffector) ? FormValidation.getSecurityCodeRegex(scope.validityEffector) : FormValidation.getSecurityCodeRegex();
							}
							break;
						}
						case 'password': {
							scope.validationPattern = FormValidation.getPasswordRegEx();
							break;
						}
						case 'configurablepassword': {
						 scope.validationPattern = FormValidation.getConfigurablePasswordRegEx(scope.passwordOptions);
						 break;
						}
						case 'variablePrice': {
							scope.validationPattern = FormValidation.getVariablePriceRegEx();
							break;
						}
						//stateProvince validation REQUIRES validityEffector to work
						case 'stateProvince': {
						 scope.validationPattern = FormValidation.getStateProvinceMatchForCountry(scope.validityEffector);
						 break;
						}
						case 'city': {
							scope.validationPattern = FormValidation.getCityRegEx();
							break;
						}
						case 'seasonPass': {
							scope.validationPattern = FormValidation.getSeasonPass();
							break;
						}
						case 'minmaxnumber': {
							break;
						}
						case 'custom': {
							// if the developer didn't pass in a custom validation, continue to the default case.
							if (scope.customValidation) {
								var isEnclosedRegex = /\/(\^?.+\$?)\/([gimsuy]*)/g,
									flags = '',
									matches = isEnclosedRegex.exec(scope.customValidation);

								// Checks if the regex was generated off of a Regex.toString and removes the enclosure
								if (validArray(matches) && matches.length > 1) {
									scope.customValidation = matches[1];
									flags = matches[2] || flags;
								}
								scope.validationPattern = new RegExp(scope.customValidation, flags);
								break;
							}
						}
						default : {
							scope.validationPattern = new RegExp('.*');
							break;
						}
						}
					}


					// add a parser that will process each time the value is
					// parsed into the model when the user updates it.
					ngModelCtrl.$parsers.unshift(function(value) {
					// test and set the validity after update.
						testValidity(value);

						return value;
					});

					// add a formatter that will process each time the value
					// is updated on the DOM element.
					ngModelCtrl.$formatters.unshift(function(value) {
					// validate.
						testValidity(value);

						return value;
					});

					//the model's validation pattern can be dependent on another field
					// for instance, zip relies on the country so if country is changed, we need to retest validity of zip
					scope.$watch(function() {
						return scope.validityEffector;
					}, function(newVal, oldVal) {
						if (angular.isDefined(newVal) || angular.isDefined(oldVal)) {
							obtainValidation();
							testValidity(ngModelCtrl.$viewValue);
						}
					});

			 //the model's validation pattern can be dependent on another field
			 // for instance, zip relies on the country so if country is changed, we need to retest validity of zip
			 scope.$watch(function() {
						return scope.disableFormValidationForCondition;
			 }, function(newVal, oldVal) {
						if (angular.isDefined(newVal)) {
				 disableFormValidation = getBoolean(newVal) || getBoolean(AppData.settings.disable_form_validation);
				 testValidity(ngModelCtrl.$viewValue);
						}
			 });

					//the required attribute can change depending on certain changes in the controller so we need to watch this and retest validity
					//due to the ng-required attribute which evaluates
					scope.$watch(function() {
						return attrs.required;
					}, function(newVal, oldVal) {
						isRequired = newVal;
						testValidity(ngModelCtrl.$viewValue);
					});


					function testValidity(value) {
						var valid = true;
						var sensitive = true;

						value = getString(value);

						if (!disableFormValidation) {
							if (isRequired || value) {
								if (scope.validationType === 'minmaxnumber') {
									var min = parseFloat(scope.validationOptions.min);
									var max = parseFloat(scope.validationOptions.max);
									var val = parseFloat(value);
									valid = !isNaN(val) && val >= min && val <= max;
								} else {
									valid = angular.isFunction(scope.validationPattern) ? scope.validationPattern() : scope.validationPattern.test(value);
								}
							}

							if (checkForCreditCard && FormValidation.isCreditCardNumber(value)) {
								sensitive = false;
							}
						}

						if (scope.validationType === 'minmaxnumber') {
							ngModelCtrl.$setValidity('minmaxnumber', valid);
						} else {
							ngModelCtrl.$setValidity('pattern', valid);
							ngModelCtrl.$setValidity('sensitive', sensitive);
						}
					}

					/**
					 * Ovveride function for Angular's native $validators.email function
					 * @private
					 * @param {*} modelValue - The model value of an input to be validated
					 * @param {*} viewValue - The view value of an input to be validated
					 * @returns {boolean} if the value passes validation or not
					 */
					function _emailValidationOverride(modelValue, viewValue) {
						var value = modelValue || viewValue;
						return ngModelCtrl.$isEmpty(value) || scope.validationPattern.test(value);
					}

					obtainValidation();
				}
			}
		});


(function () {
	'use strict';
	angular
		.module('app')
		.directive('passwordValidation', passwordValidation);

	/**
	 * Password Validation Directive
	 * @param {Service} $compile compile service
	 * @param {Service} $document document service
	 * @param {Service} Language Language service
	 * @param {Service} Utilities utility service
	 * @param {Service} UtilsValidation validation utility service
	 * @returns {Object} The directive itself
	 */
	function passwordValidation($compile, $document, Language, Utilities, UtilsValidation) {
		return {
			require: 'ngModel',
			restrict: 'A',
			scope: {
				inPlaceValidationTitle: '@?',
				passwordOptions: '=?',
				showValidationDuringInput: '@?'
			},
			link: function parseUserUpdates(scope, element, attrs, ngModelCtrl) {
				// add a parser that will process each time the value is
				// parsed into the model when the user updates it.
				ngModelCtrl.$parsers.unshift(function testParsed(value) {
					// test and set the validity after update.
					testValidity(value);
					return value;
				});

				// add a formatter that will process each time the value
				// is updated on the DOM element.
				ngModelCtrl.$formatters.unshift(function processUpdate(value) {
					// validate.
					testValidity(value);
					return value;
				});


				function testValidity(value) {
					var valid = true;
					// Run the validators
					if (scope.validators.length > 0) {
						scope.validators.forEach(function testIfValid(validator) {
							validator.valid = !!(value && validator.pattern.test(value));
							valid = valid && validator.valid;
						});
						// If the validators are all good, close the window.
						scope.open = scope.hasFocus && !valid && scope.showValidationDuringInput;
					}
					ngModelCtrl.$setValidity('pattern', valid);
				}

				function correctLocale(options, tgt) {
					var result = Language.getLocale('FormLabels', tgt);
					result = Language.replaceAll('@@min', Utilities.forceInt(options.minLength), result);
					result = Language.replaceAll('@@max', Utilities.forceInt(options.maxLength), result);
					return result;
				}

				/**
				 * getValidatorsArray implements a storage of labeled RegEx tests, which are used to light up the
				 * requirements being shown while the user types.
				 *
				 * To add more validators, just push them in the section below, using result.push({valid:false,label:aLocale,pattern:regex});
				 *
				 * It would be nice to use ngValidators and ngMessages instead of this, but ngMessages are built around the idea
				 * that they only show when the corresponding error condition is true. Our use case for password validation is
				 * different. We want to show all the error messages, and only highlight the ones that are true.
				 *
				 * @param {Object} options The options that contain the requirements
				 * @returns {Array} the array of validator objects
				 */
				function getValidatorsArray(options) {
					var result = [];
					var regExp;
					if (angular.isUndefined(options)) {
						return [];
					}

					// Please note that this feature of options; 'regEx' is for a regular expression.
					// Also note that this is an override, such that, if it exists and is valid: ignore all other options.
					if (UtilsValidation.validString(options.regEx)) {
						try {
							regExp = new RegExp(options.regEx)
						} catch (e) {
							return [];
						}

						result.push({
							label: correctLocale(options, 'passwordPattern'),
							pattern: regExp,
							valid: false
						});
						return result;
					}

					// first some business rules (ported from previous implementation):
					// if there is no min length, set it to 8
					if (Utilities.forceInt(options.minLength) == 0) {
						scope.passwordOptions.minLength = 8;
					}
					// if there is no max length, set it to 15
					if (Utilities.forceInt(options.maxLength) == 0) {
						scope.passwordOptions.maxLength = 15;
					}

					// Now it's time to build the validators. See the comment above for an explanation
					if (Utilities.forceInt(options.minLength) > 0) {
						result.push({
							label: correctLocale(options, 'passwordTooShort'),
							pattern: new RegExp('.{' + options.minLength + ',}'),
							valid: false
						});
					}
					if (Utilities.forceInt(options.maxLength) > 0) {
						result.push({
							label: correctLocale(options, 'passwordTooLong'),
							pattern: new RegExp('^.{0,' + options.maxLength + '}$'),
							valid: false
						});
					}
					if (Utilities.getBoolean(options.requireUpperAndLowercaseAlpha)) {
						result.push({
							label: correctLocale(options, 'passwordUpperAndLower'),
							pattern: new RegExp('^((?=.*[A-Z])(?=.*[a-z]))'),
							valid: false
						});
					}
					if (Utilities.getBoolean(options.requireNumber)) {
						result.push({
							label: correctLocale(options, 'passwordNumber'),
							pattern: new RegExp('(?=.*\\d)'),
							valid: false
						});
					}
					if (Utilities.getBoolean(options.requireSpecialCharacter)) {
						result.push({
							label: correctLocale(options, 'passwordSpecialCharacter'),
							pattern: new RegExp('(?=.*[!@#$%^&*])'),
							valid: false
						});
					}
					if (Utilities.getBoolean(options.requireLetter)) {
						result.push({
							label: correctLocale(options, 'passwordLetter'),
							pattern: new RegExp('(?=.*[a-zA-Z])'),
							valid: false
						});
					}
					return result;
				}

				function Initialize() {
					// Establish the scope variables
					scope.showValidationDuringInput = Utilities.getBoolean(scope.showValidationDuringInput);
					scope.hasFocus = false;
					scope.open = false;

					// Build the validators
					scope.validators = getValidatorsArray(scope.passwordOptions);

					// Add the html and events for the case of in-place validation
					if (scope.showValidationDuringInput) {
						var htmlForValidationPopup =
						'<div class="password-validation-container" ng-show="open">' +
							'<div class="gap-col gap-8">' +
								'<div class="password-validation-header gap-font--body-1 gap-text--g3">' + scope.inPlaceValidationTitle + '</div>' +
								'<div class="password-validation-list gap-col gap-8">' +
									'<div class="password-validation-item gap-row gap-8 align--center" data-ng-repeat="validator in validators" ng-class="{\'green-text\': validator.valid}">' +
											'<gap-iconography gap-icon="check-circle-solid" ng-style="{\'--gap-iconography-fill-color\': validator.valid ? \'green\' : \'@greyscale-g3\'}"></gap-iconography>' +
											'<span class="gap-font--body-2" data-ng-bind="validator.label" ng-class="{\'green-text\': validator.valid, \'gap-text--g3\' : !validator.valid}"></span>' +
									'</div>' +
								'</div>' +
							'</div>' +
						'</div>';
						var template = angular.element(htmlForValidationPopup);

						angular.element(element[0].parentElement).after(template);
						$compile(template)(scope);

						// Watch the open state to toggle visibility of other elements
						scope.$watch('open', function watchOpenState(newValue) {
							angular.element($document[0].querySelectorAll('.elements-to-hide-while-validating'))[newValue ? 'addClass' : 'removeClass']('hidden-when-validation-open');
						});

						// On blur, hide the menu
						angular.element(element[0]).bind('blur', function hideOnBlur() {
							scope.$applyAsync(function () {
								scope.hasFocus = false;
								scope.open = false;
							});
						});

						// On focus, show the menu
						angular.element(element[0]).bind('focus', function showOnFocus() {
							scope.$applyAsync(function () {
								scope.hasFocus = true;
								scope.open = ngModelCtrl.$viewValue == '' || ngModelCtrl.$invalid;
							});
						});
					}
				}

				Initialize();
			}
		}
	}
})();
/**
 * Created by ltischuk on 02/20/14.
 */
angular.module('app')
	.directive('ageValidation'
		, function(Utilities) {
			return {
				restrict: 'A',
				require: 'ngModel',
				link: function(scope, element, attrs, ngModelCtrl) {
					var isRequired = Utilities.getBoolean(attrs.required);

					var minAge = scope.$eval(attrs.minAge);
					var maxAge = scope.$eval(attrs.maxAge);

					// add a parser that will process each time the value is
					// parsed into the model when the user updates it.
					ngModelCtrl.$parsers.unshift(function(value) {
					// test and set the validity after update.
						isValidAge(value);

						return value;
					});

					// add a formatter that will process each time the value
					// is updated on the DOM element.
					ngModelCtrl.$formatters.unshift(function(value) {
					// validate.
						isValidAge(value);

						return value;
					});


					function isValidAge(value) {
						var valid = true;

						if (angular.isDefined(value)) {
						//calculate age
							var baseDate = new Date();
							var dateOfBirth = new Date(value);
							var birthYear = dateOfBirth.getFullYear();
							var currYear = baseDate.getFullYear();
							var dateOfBirthThisYear = new Date(value);
							dateOfBirthThisYear.setFullYear(currYear);
							var adj = (baseDate - dateOfBirthThisYear < 0) ? 1 : 0;
							var age = currYear - birthYear - adj;
							valid = ((value.length > 0 || isRequired) ? (age >= minAge && age <= maxAge) : true);
						}

						ngModelCtrl.$setValidity('age', valid);
					}
				}
			}
		});

/**
 * Created by ltischuk on 02/20/14.
 * Directive to validate numbers within a given range
 */
angular.module('app')
	.directive('validNumericRange'
		, function(Utilities) {
			return {
				restrict: 'A',
				require: 'ngModel',
				link: function(scope, element, attrs, ngModelCtrl) {
					scope.disableRangeValidation = Utilities.getBoolean(attrs.disableRangeValidation);
					scope.minVal = Number(attrs.minVal);
					scope.maxVal = Number(attrs.maxVal);

					// add a parser that will process each time the value is
					// parsed into the model when the user updates it.
					ngModelCtrl.$parsers.unshift(function(value) {
					// test and set the validity after update.
						testValue(value);

						return value;
					});

					// add a formatter that will process each time the value
					// is updated on the DOM element.
					ngModelCtrl.$formatters.unshift(function(value) {
					// validate.
						testValue(value);

						return value;
					});


					/**
					 * Test the value to ensure that the number validates for the specified range
					 * @param value
					 */
					function testValue(value) {
						var valid = true;

						if (angular.isDefined(value) && ! scope.disableRangeValidation) {
							try {
								var number = Number(value);
								if (number < scope.minVal || number > scope.maxVal) {
									valid = false;
								}
							} catch (e) {

							}
						}

						ngModelCtrl.$setValidity('number', valid);
					}
				}
			}
		});

/**
 * Created by ltischuk on 02/20/14.
 */
angular.module('app')
	.directive('validateGroupQuantity'
		, function() {
			return {
				restrict: 'A',
				require: 'ngModel',
				scope:
			{
				groupMaxQty: '=',
				currentGroupQtyValue: '= '
			},
				link: function(scope, element, attrs, ngModelCtrl) {
				// add a parser that will process each time the value is
					// parsed into the model when the user updates it.
					ngModelCtrl.$parsers.unshift(function(value) {
					// test and set the validity after update.
						isValidForGroupQty(value);

						return value;
					});

					// add a formatter that will process each time the value
					// is updated on the DOM element.
					ngModelCtrl.$formatters.unshift(function(value) {
					// validate.
						isValidForGroupQty(value);

						return value;
					});


					function isValidForGroupQty(value) {
						var valid = true;

						if (angular.isDefined(value) && angular.isDefined(scope.groupMaxQty)) {
					 var newQty = scope.currentGroupQtyValue + Number(value);
					 valid = newQty <= scope.groupMaxQty;
						}

						ngModelCtrl.$setValidity('groupQuantity', valid);
					}
				}
			}
		});

/**
 * Created by ltischuk on 1/4/16.
 */
/**
 * Created by ltischuk on 9/28/15.
 */
angular.module('app').directive
('parseInputToNumber'
	, function() {
		return {
			restrict: 'A',
			require: 'ngModel',
			link: function(scope, elm, attrs, ctrl) {
				ctrl.$parsers.unshift(function(viewValue) {
					return Number(viewValue);
				});
			}
		};
	});

/**
 * Directive to restrict inputs to not include illegal characters (i.e. full width characters that we may not be expecting)
 *
 * This directive supports the following optional attributes:
 *
 *  data-block-illegal-keys : accepted values are 'nonNumeric' which blocks non-numeric key codes from being entered
 *
 *  data-block-illegal-replacement: this item will replace input with empty string that does not meet regex that after the keyup event.
 *  Accepted values are the following:
 *  'nonNumeric': this restricts the input to only numbers
 *  'nonNumericDate': restricts input to numbers and forward slashes
 *  'nonNumericDecimal': restricts input to a currency amount — digits and a single period, capped at 2 decimal places
 *  'nonAlphaNumericSpecialChars': restricts input to numbers, alpha, dashes, and spaces
 *
 */
angular
	.module('app')
	.directive('blockIllegalFormInput', function(
		UtilsValidation
	) {
		return {
			restrict: 'A',
			require: 'ngModel',
			link: function(scope, element, attrs, ngModelCtrl) {
				var NON_NUMERIC = 'nonNumeric';
				var NON_NUMERIC_DATE = 'nonNumericDate';
				var NON_NUMERIC_DECIMAL = 'nonNumericDecimal';
				var NON_ALPHA_NUM_SPEC_CHARS = 'nonAlphaNumericSpecialChars';

				// Strips characters disallowed by the selected replacement type on every input (typed or pasted).
				var replaceRegex;
				// Optional per-type post-strip formatter (e.g. currency decimal capping).
				var sanitize;

				if (UtilsValidation.validString(attrs.blockIllegalReplacement)) {
					switch (attrs.blockIllegalReplacement) {
					case NON_NUMERIC:
						replaceRegex = /[^0-9]/g;
						break;
					case NON_NUMERIC_DATE:
						replaceRegex = /[^0-9\/]/g;
						break;
					case NON_ALPHA_NUM_SPEC_CHARS:
						replaceRegex = /[^0-9-\sA-Za-z]/g;
						break;
					case NON_NUMERIC_DECIMAL:
						replaceRegex = /[^0-9.]/g;
						sanitize = clampCurrencyDecimals;
						break;
					}
				}

				// Collapses to a single decimal point and caps the fractional part at 2 digits,
				// so a third decimal cannot be typed/pasted into a currency amount.
				function clampCurrencyDecimals(value) {
					var firstDot = value.indexOf('.');
					if (firstDot === -1) { return value; }
					var intPart = value.slice(0, firstDot);
					var decPart = value.slice(firstDot + 1).replace(/\./g, '');
					return intPart + '.' + decPart.slice(0, 2);
				}

				// Instead of binding to specific key events, bind to input event
				// for changes. This will capture instances where a user will
				// type a value or use copy/paste, which key events won't capture.
				if (replaceRegex) {
					element.bind('input', function(event) {
						if (UtilsValidation.validString(event.target.value)) {
							var replacedValue = event.target.value.replace(replaceRegex, '');
							if (sanitize) {
								replacedValue = sanitize(replacedValue);
							}
							if (event.target.value !== replacedValue) {
								event.target.value = replacedValue;
							}

							ngModelCtrl.$setViewValue(event.target.value);
							scope.$apply();
						}
					});
				}
			}
		}
	});
/**
 * Created by ltischuk on 02/20/14.
 * Directive to validate numbers within a given range
 */
angular.module('app')
	.directive('appendDynamicElement'
		, function() {
			return {
				restrict: 'A',
				scope:
			{ elemToAppend: '=' },
				link: function(scope, element, attrs, ngModelCtrl) {
					element.append(scope.elemToAppend);
				}
			}
		});

(function() {
	'use strict';

	angular
		.module('app')
		.directive('dotDotDot', DotDotDotDirective);

	/**
	 * Directive that adds ellipsis functionality to text content
	 * @constructor
	 * @returns {Object} Directive definition object
	 * @ngInject
	 */
	function DotDotDotDirective() {
		return {
			restrict: 'A',
			templateUrl: '/views/templates/dot-dot-dot/dot-dot-dot.html',
			scope: {
				expand: '<?',
				lines: '<?',
				seeMoreAriaLabel: '<?'
			},
			transclude: true,
			/**
			 * Controller for dot-dot-dot directive
			 * @constructor
			 * @param {Object} $scope - Angular scope
			 * @param {Object} $element - jQuery/jqLite element
			 * @param {Service} Language - Language service
			 * @param {Service} Utilities - Utilities service
			 * @returns {undefined}
			 */
			controller:function($scope, $element, Language, Utilities) {
				var vm = this;
				var getLocale = Language.getLocaleMerchant;

				$scope.toggleLabel = getLocale('ButtonLabels', 'seemore');
				$scope.ariaLabel = $scope.seeMoreAriaLabel ? $scope.toggleLabel + ' ' + $scope.seeMoreAriaLabel : $scope.toggleLabel;

				/**
				 * Lifecycle hook for post-link initialization
				 * @lifecycle
				 * @returns {undefined}
				 */
				vm.$postLink = function $postLink() {
					var ellipsisText = $element[0].querySelector('.d3__ellipsis');

					$scope.lines = $scope.lines || 1;
					$scope.isEllipsis = false;

					ellipsisText.style.lineClamp = $scope.lines;
					ellipsisText.style.webkitLineClamp = $scope.lines;
					ellipsisText.style.mozLineClamp = $scope.lines;

					// Wait for everything to be rendered before checking the element
					Utilities.nextTick(function next() {
						$scope.showToggle = $scope.isEllipsis = vm.isEllipsis();

						// If expand is true, force ellipsis to start expanded
						if ($scope.expand && $scope.showToggle) {
							$scope.onToggle();
						}
					});
				};

				/**
				 * Check if content needs ellipsis
				 * @private
				 * @returns {boolean} True if content overflows configured lines
				 */
				vm.isEllipsis = function isEllipsis() {
					var ele = $element[0].querySelector('.d3__ellipsis');

					return ele && ele.scrollHeight > ele.clientHeight;
				};

				/**
				 * Toggle ellipsis state and update display
				 * @public
				 * @returns {undefined}
				 */
				$scope.onToggle = function onToggle() {
					// Toggle ellipsis state
					$scope.isEllipsis = !$scope.isEllipsis;

					// Update display
					$element[0].querySelector('.d3__ellipsis').style.display = $scope.isEllipsis ? null : 'block';

					// Update toggle label
					$scope.toggleLabel = getLocale('ButtonLabels', $scope.isEllipsis ? 'seemore' : 'seeless');
					$scope.ariaLabel = $scope.seeMoreAriaLabel ? $scope.toggleLabel + ' ' + $scope.seeMoreAriaLabel : $scope.toggleLabel;

					$scope.$emit('dotDotDotToggled', {
						isEllipsis: $scope.isEllipsis,
						toggleLabel: $scope.toggleLabel
					});
				};
			}
		};
	}
})();
(function() {
	'use strict';

	angular
		.module('app')
		.directive('ellipsis', EllipsisDirective);

	/**
	 * The Multiline Ellipsis Directive Constructor
	 * @usage <div ellipsis="toggleEllipsis" lines="2" ng-bind="longText"></div>
	 * @param {Function} $timeout - The $timeout function
	 * @param {Object} $window - The Window object
	 * @param {Service} Language - The Language Service
	 * @param {Service} Utilities - The Utilities Service
	 * @returns {Directive} The Multiline Ellipsis Directive
	 * @constructor
	 * @ngInject
	 */
	function EllipsisDirective($timeout, $window, Language, Utilities) {
		return {
			restrict: 'A',
			scope: {
				buttonContainerRef: '<?',
				ellipsis: '<',
				inlineButton: '<?',
				inlineLessLocale: '<?',
				inlineMoreLocale: '<?',
				inlineNewline: '<?',
				lines: '<?',
				moreTextDisplay: '@?',
				moreTextRef: '<?',
				shrinkSize: '<?'
			},
			template: '<div transclusion></div>',
			transclude: true,
			controller: function($scope, $element) {
				var originalSize = $window.getComputedStyle($element[0]).fontSize;
				var isEnabled = Utilities.getBoolean($scope.ellipsis) || $scope.ellipsis === undefined,
					transcludeHtml,
					transcludeText,
					ellipsisText,
					lines = ($scope.lines || 1) + (+$scope.inlineNewline);

				// Add onresize event listener
				$window.addEventListener('resize', onResize);

				// Apply extra functions to scope
				angular.merge($scope, {
					$onChanges: $onChanges,
					applyEllipsis: applyEllipsis
				});

				// Use watcher to pick up transclusion changes
				$scope.$watch('$element[0].innerHTML', function(newVal) {
					// assign value to innerHTML
					newVal = $element[0].innerHTML;

					// If the value we received is the same as last processed
					if (!$element[0] || !newVal || ellipsisText === newVal) {
						// Exit
						return;
					}

					// Assign HTML/Text values to closure vars
					transcludeHtml = newVal;
					transcludeText = $element.text();

					// Trigger the ellipsis to draw
					$scope.applyEllipsis();
				});

				// Add $destroy lifecycle hook
				$scope.$on('$destroy', function onDestroy() {
					// Remove the onresize event listener
					$window.removeEventListener('resize', onResize);
				});

				$timeout(onResize, 500);

				/**
				 * $onChanges function to listen for changes in the attributes
				 * @param {Object} chngs - The $onChanges object
				 * @lifcycle
				 * @returns {undefined}
				 */
				function $onChanges(chngs) {
					var moreTextRef;

					// `ellipsis` handles if the directive should truncate or not
					if (chngs.ellipsis) {
						// Set isEnabled
						isEnabled = Utilities.getBoolean(chngs.ellipsis.currentValue);

						// Try to apply ellipsis to value
						$scope.applyEllipsis();
					}

					if (!isEnabled && $scope.moreTextRef) {
						moreTextRef = document.getElementById($scope.moreTextRef);
						if (moreTextRef) {
							moreTextRef.style.setProperty('display', 'none', 'important');
						}
					}
				}

				/**
				 * The onResize listener callback that handles what the ellipsis needs to do upon resizing
				 * @function
				 * @callback
				 * @returns {undefined}
				 */
				function onResize() {
					if (!$element || !$element[0]) {
						return;
					}

					// Reset the element with the full trancluded HTML
					$element.html(transcludeHtml);

					// Try and apply the ellipsis
					$scope.applyEllipsis();
				}

				/**
				 * Applies the ellipsis, if possible
				 * @protected
				 * @returns {undefined}
				 */
				function applyEllipsis() {
					var computedStyles,
						lineHeight,
						originalHeight = $element[0].offsetHeight,
						removalRate,
						buttonContainerRef = $scope.buttonContainerRef ? document.getElementById($scope.buttonContainerRef) : null,
						moreTextRef = $scope.moreTextRef ? document.getElementById($scope.moreTextRef) : null,
						inlineLessLocale,
						inlineMoreLocale,
						textValue = transcludeText,
						lines = $scope.lines || 0;

					// Is the ellipsis Disabled?
					if (!isEnabled) {
						// Apply original html and exit
						$element.html(transcludeHtml);

						if ($scope.inlineButton) {
							inlineLessLocale = Language.getLocaleMerchant.apply(null, ($scope.inlineLessLocale || 'ButtonLabels.seeless').split('.'));
							$element.html($element.html() + ($scope.inlineNewline ? '<br />' : '&nbsp;'));
							$element.append(createInlineButton(inlineLessLocale));
						}

						if (moreTextRef) {
							moreTextRef.style.setProperty('display', 'none', 'important');
						}
						return;
					} else if (!textValue) {
						if (moreTextRef) {
							moreTextRef.style.setProperty('display', 'none', 'important');
						}
						// Is there no value to ellipsis? Exit
						return;
					} else if (originalHeight === 0) {
						// Has the page not rendered? Next Tick and Exit
						$timeout($scope.applyEllipsis, 0);
						return;
					}

					// Apply Text to element
					$element.text(textValue);

					// Get the computed Styles
					computedStyles = $window.getComputedStyle($element[0]);

					// Get the closest approximation of line height within the element
					lineHeight = parseInt(computedStyles.lineHeight, 10) || (parseInt(computedStyles.fontSize, 10) + 2.5);

					// Fix line height approximation issue
					var elementHeight = $element[0].offsetHeight,
						actualLines = Math.round(elementHeight / lineHeight);

					// Set font to original size before looping if shrinkSize is enabled
					if ($scope.shrinkSize) {
						$element[0].style.fontSize = originalSize;
					}

					// Loop and try to fit within the desired number of lines
					if (actualLines > lines) {
						// Shrink size before checking line height if enabled
						if ($scope.shrinkSize) {
							$element[0].style.fontSize = parseInt(originalSize.replace('px', '') - 2, 10) + 'px';
							lineHeight = parseInt(computedStyles.lineHeight, 10) || (parseInt(computedStyles.fontSize, 10) + 2.5);
						}

						while (Math.round($element[0].offsetHeight / lineHeight) > lines) {
							// Determines how big of a chunk it needs to take off
							removalRate = Math.round($element[0].offsetHeight / lineHeight) > lines + 1
								? Math.ceil(transcludeText.length / (originalHeight / lineHeight) * (($element[0].offsetHeight / lineHeight) - lines - 1))
								: 1;

							// Removes the chunk from the text
							textValue = textValue.slice(0, -removalRate).trim();

							// Adds text to an element with ellipsis
							$element.html(textValue + '&hellip;');

							if ($scope.inlineButton) {
								inlineMoreLocale = Language.getLocaleMerchant.apply(null, ($scope.inlineMoreLocale || 'ButtonLabels.seemore').split('.'));
								$element.html($element.text() + ($scope.inlineNewline ? '<br />' : '&nbsp;'));
								$element.append(createInlineButton(inlineMoreLocale));
							}
						}

						if (moreTextRef) {
							moreTextRef.style.setProperty('display', $scope.moreTextDisplay ? $scope.moreTextDisplay : 'block', 'important');
						}
					} else if (buttonContainerRef) {
						isEnabled = false;

						if (buttonContainerRef) {
							buttonContainerRef.style.setProperty('display', 'none', 'important');
						}

						$scope.applyEllipsis();
					} else if (moreTextRef) {
						moreTextRef.style.setProperty('display', 'none', 'important');
					}

					// Set the ellipsis value to closure variable
					ellipsisText = $element.text();
				}

				/**
				 * Generates a angular.element object for the inline button
				 * @function
				 * @param {String} inlineText - The text to display in the button
				 * @returns {angular.element} The inline button element
				 */
				function createInlineButton(inlineText) {
					var element = angular.element('<gap-link>');

					element[0].setAttribute('gap-color', 'secondary');
					element[0].innerHTML = inlineText;
					element.on('click', onInlineButtonClick);

					return element;
				}

				/**
				 * The inline button click handler to toggle the ellipsis
				 * @function
				 * @returns {undefined}
				 */
				function onInlineButtonClick() {
					isEnabled = !isEnabled;
					applyEllipsis();
				}
			}
		};
	}
})();
(function() {
	'use strict';

	angular
		.module('app')
		.directive('accessoTooltip', AccessoTooltipDirective);

	/**
	 * The Accesso Tooltip Directive Constructor. Renders an accessible tooltip bubble for
	 * the host element, shown on hover, keyboard focus, and touch/tap, and dismissed on
	 * mouse-leave, blur, Escape, or a tap outside the tooltip. The bubble is appended
	 * directly to `document.body` and positioned via `position: fixed` with coordinates
	 * computed from the host's `getBoundingClientRect()` — this deliberately escapes any
	 * ancestor stacking context between the host and body (the reason MDC's own tooltip
	 * uses the same technique), rather than relying on `z-index` alone, which a capping
	 * ancestor stacking context can defeat regardless of the value chosen. It renders above
	 * and centered on the host by default, flipping below it when there isn't enough
	 * viewport space above (e.g. near a sticky top nav), and clamping horizontally to stay
	 * clear of the left/right viewport edges. The attribute value is a locale key in
	 * "Section.Target" form, resolved the same way `accesso-locale` does: via
	 * `Language.getLocale`, which returns a `*Section.Target` debug placeholder for a
	 * missing key when `$rootScope.develop` is on, or an empty string otherwise. If the
	 * resolved text is empty, no tooltip markup is rendered at all — this is a
	 * defensive/config-driven guard, not a user-facing error.
	 * @usage <gap-iconography accesso-tooltip="CartView.CartTimerTooltip" gap-icon="info-outline" role="button"></gap-iconography>
	 * @param {Service} Language - The Language Service
	 * @param {Service} Utilities - The Utilities Service
	 * @returns {Directive} The Accesso Tooltip Directive
	 * @constructor
	 * @ngInject
	 */
	function AccessoTooltipDirective(Language, Utilities) {
		var VIEWPORT_EDGE_GAP = 8;

		return {
			restrict: 'A',
			link: link
		};

		function link(scope, element, attrs) {
			var attrValue = attrs.accessoTooltip || '',
				dotIndex = attrValue.indexOf('.'),
				section = dotIndex > -1 ? attrValue.substring(0, dotIndex) : '',
				target = dotIndex > -1 ? attrValue.substring(dotIndex + 1) : '',
				tooltipText = section && target ? Language.getLocale(section, target) : '',
				existingDescribedBy,
				tooltipId,
				bubbleElement,
				isOpen = false;

			if (!tooltipText) {
				return;
			}

			tooltipId = 'accesso-tooltip-' + Utilities.guid();
			existingDescribedBy = element.attr('aria-describedby');

			if (!angular.isDefined(attrs.tabindex)) {
				element.attr('tabindex', '0');
			}

			element.attr('aria-describedby', existingDescribedBy ? existingDescribedBy + ' ' + tooltipId : tooltipId);

			bubbleElement = angular.element('<span class="accesso-tooltip__bubble" role="tooltip" aria-hidden="true"></span>');
			bubbleElement.attr('id', tooltipId);
			bubbleElement.text(tooltipText);
			angular.element(document.body).append(bubbleElement);

			element.on('mouseenter focus', showTooltip);
			element.on('mouseleave blur', hideTooltip);
			element.on('keydown', onKeydown);

			// One document-level listener dismisses the tooltip on tap-outside, since touch
			// devices have no hover/blur equivalent to close it.
			document.addEventListener('touchstart', onDocumentTouchStart);

			scope.$on('$destroy', onDestroy);

			function showTooltip() {
				var anchorRect,
					viewportWidth = document.documentElement.clientWidth,
					viewportHeight = document.documentElement.clientHeight,
					bubbleWidth,
					bubbleHeight,
					idealLeft,
					idealTop;

				isOpen = true;
				bubbleElement.addClass('accesso-tooltip__bubble--open');

				// Measure only after adding the --open class — the bubble is `display: none`
				// until then, so offsetWidth/offsetHeight would read as 0 beforehand.
				anchorRect = element[0].getBoundingClientRect();
				bubbleWidth = bubbleElement[0].offsetWidth;
				bubbleHeight = bubbleElement[0].offsetHeight;

				idealLeft = anchorRect.left + (anchorRect.width / 2) - (bubbleWidth / 2);
				idealLeft = Math.max(VIEWPORT_EDGE_GAP, Math.min(idealLeft, viewportWidth - bubbleWidth - VIEWPORT_EDGE_GAP));

				idealTop = anchorRect.top - bubbleHeight - VIEWPORT_EDGE_GAP;
				if (idealTop < VIEWPORT_EDGE_GAP) {
					idealTop = Math.min(anchorRect.bottom + VIEWPORT_EDGE_GAP, viewportHeight - bubbleHeight - VIEWPORT_EDGE_GAP);
				}

				bubbleElement.css('left', idealLeft + 'px');
				bubbleElement.css('top', idealTop + 'px');
				bubbleElement.attr('aria-hidden', 'false');
			}

			function hideTooltip() {
				isOpen = false;
				bubbleElement.removeClass('accesso-tooltip__bubble--open');
				bubbleElement.attr('aria-hidden', 'true');
			}

			function onKeydown(event) {
				if (event.key === 'Escape' && isOpen) {
					hideTooltip();
				}
			}

			function onDocumentTouchStart(event) {
				if (isOpen && !element[0].contains(event.target) && !bubbleElement[0].contains(event.target)) {
					hideTooltip();
					element[0].blur();
				}
			}

			function onDestroy() {
				document.removeEventListener('touchstart', onDocumentTouchStart);
				bubbleElement.remove();
			}
		}
	}
})();

(function() {
	'use strict';

	/**
	 * This directive is used with the guest application lib components such as <gap-select>
	 */
	angular
		.module('app')
		.directive('gapOnChange', gapOnChange);

	/**
	 * Our factory
	 * @returns {Object} Our directive definition
	 * @ngInject
	 */
	function gapOnChange() {
		return {
			link: function(scope, element, attr, ctrl) {
				// Specify how UI should be updated
				ctrl.$render = function() {
					element.val(ctrl.$viewValue || '');
				};

				// Listen for change events to enable binding
				element.on('input', function() {
					scope.$evalAsync(read);
				});

				element.on('change', function() {
					scope.$evalAsync(read);
				});

				/**
				 * Handles reading and setting the view value
				 * @returns {undefined}
				 */
				function read() {
					ctrl.$setViewValue(element.val() || '');
				}

				ctrl.$viewChangeListeners.push(function() {
					scope.$eval(attr.gapOnChange);
				});
			},
			require: 'ngModel',
			restrict: 'A'
		};
	}
}());
(function() {
	'use strict';

	/**
	 * This directive is used with the guest application lib components such as <gap-select>
	 */
	angular
		.module('app')
		.directive('addGapMenu', addGapMenu);

	/**
	 * Adds the gap-menu attribute if needed
	 * @returns {Object} Our directive definition
	 */
	function addGapMenu() {
		return {
			link: function(scope, element, attr) {
				var realElement = element[0];

				if (attr.addGapMenu) {
					realElement.setAttribute('gap-menu', attr.addGapMenu);
				} else {
					realElement.removeAttribute('gap-menu');
				}
			},
			restrict: 'A'
		};
	}
}());
(function() {
	'use strict';

	/**
	 * This directive needed as we for some reason can't use sce.trustAsHtml to set the gap-icon attribute.
	 */
	[
		['setGapIcon', 'gap-icon'],
		['setGapColor', 'gap-color'],
		['setGapType', 'gap-type'],
		['setGapActiveStep', 'gap-active-step'],
		['setGapSelected', 'gap-selected']
	].forEach(function createDirective(directiveParts) {
		var watchAttribute = directiveParts[0],
			elementAttribute = directiveParts[1];

		angular
			.module('app')
			.directive(watchAttribute, function createDirectiveDefinition() {
				return createDefinition(watchAttribute, elementAttribute);
			});
	});

	/**
	 * Creates a directive definition
	 * @param {String} watchAttribute The attribute to watch on the scope
	 * @param {String} elementAttribute The attribute name for the DOM element
	 * @returns {Object} a directive definition
	 */
	function createDefinition(watchAttribute, elementAttribute) {
		return {
			link: function(scope, element, attrs) {
				var value;
				if (attrs[watchAttribute]) {
					value = scope.$eval(attrs[watchAttribute]);
					if (value) {
						element.attr(elementAttribute, value);
					}
				}
				scope.$watch(attrs[watchAttribute], setAttribute(element, elementAttribute));
			},
			priority: 100,
			restrict: 'A'
		};
	}

	/**
	 * Our watch callback
	 * @param {jQLite} element The jQuery element of the directive
	 * @param {String} attribute The attribute name
	 * @returns {Function} Our callback
	 */
	function setAttribute(element, attribute) {
		return function updateAttribute(value) {
			if (value) {
				element.attr(attribute, value);
			} else {
				element.removeAttr(attribute);
			}
		};
	}
}());
(function() {
	'use strict';

	/**
	 * This directive is used with the guest application lib components such as <gap-select>
	 */
	angular
		.module('app')
		.directive('setCssVariables', setCssVariables);

	/**
	 * Sets CSS variables
	 * @constructor
	 * @param {Service} UtilsValidation UtilsValidation
	 * @returns {Object} Our directive definition
	 * @ngInject
	 */
	function setCssVariables(UtilsValidation) {
		return {
			link: function(scope, element, attr) {
				scope.$watchCollection(attr.setCssVariables, function ngStyleWatchAction(newStyles, oldStyles) {
					var el = element[0];

					if (oldStyles && (newStyles !== oldStyles)) {
						angular.forEach(oldStyles, function(val, style) {
							el.style.removeProperty(style);
						});
					}

					if (newStyles) {
						angular.forEach(newStyles, function(val, style) {
							if (UtilsValidation.validString(val)) {
								el.style.setProperty(style, val);
							}
						});
					}
				});
			},
			restrict: 'A'
		};
	}
}());
(function() {
	"use strict";

	angular.module('app').directive('barcode', barcode);

	/**
	 * Barcode directive for rendering QR codes and barcodes
	 * @param {Service} $log The logging service
	 * @param {Service} $timeout The timeout service
	 * @returns {Directive} An instance of the barcode directive
	 * @ngInject
	 */
	function barcode($log, $timeout, Utilities) {
		/**
		 * An enumeration of the types of barcodes and their settings.
		 * These are used to describe how to render the barcode.
		 * These are the only possible barcode styles we support currently.
		 * @public
		 * @type {Enumerator<Object>}
		 */
		var BARCODE_TYPES = [
			{
				name: 'Code 128',
				opts: {
					includetext: true,
					parsefnc: true
				},
				rotate: 0,
				scale: 2,
				type: 'code128'
			},
			{
				name: 'HIBC Code 128',
				opts: { includetext: true },
				rotate: 0,
				scale: 1,
				type: 'hibccode128'
			},
			{
				name: 'HIBC MicroPDF417',
				opts: {},
				rotate: 0,
				scale: 2,
				type: 'hibcmicropdf417'
			},
			{
				name: 'HIBC PDF417',
				opts: {},
				rotate: 0,
				scale: 1,
				type: 'hibcpdf417'
			},
			{
				name: 'MicroPDF417',
				opts: {},
				rotate: 0,
				scale: 1,
				type: 'micropdf417'
			},
			{
				name: 'PDF417',
				opts: {},
				rotate: 0,
				scale: 2,
				type: 'pdf417'
			},
			{
				name: 'Aztec Code',
				opts: { format: 'full' },
				rotate: 0,
				scale: 2,
				type: 'azteccode'
			},
			{
				name: 'HIBC QR Code',
				opts: {},
				rotate: 0,
				scale: 2,
				type: 'hibcqrcode'
			},
			{
				name: 'QR Code',
				opts: { eclevel: 'M' },
				rotate: 0,
				scale: 5,
				type: 'qrcode'
			}
		];

		/**
		 * Array of options of rotation to render the barcode at
		 * @public
		 * @type {Array<String>}
		 */
		var VALID_ROTATIONS = ['N', 'L', 'R', 'I'];

		var directive = {
			link: link,
			scope: {
				index: '=',
				scale: '=',
				ticket: '='
			}
		};

		return directive;

		/**
		 * The directive's link function, which acts as a constructor
		 * @public
		 * @param {Scope} scope The scope that the directive is in
		 * @returns {undefined}
		 */
		function link(scope) {
			var ticket = {
				barcodeType: scope.ticket.barcodeType,
				location: 'canvas' + (scope.index),
				scaleOverride: scope.ticket.scale
			};

			// Bind directive functions to scope for testability
			scope.getBarcodeData = getBarcodeData;
			scope.getBarcodeSettings = getBarcodeSettings;
			scope.generateBarcode = generateBarcode;
			scope.getBaren = getBaren;
			scope.renderBarcode = renderBarcode;

			ticket.barcode = scope.getBarcodeData(scope.ticket);

			// Allow use of data-scale from the directive if it's a QR Code
			ticket.scaleOverride = scope.ticket.scale;
			if (ticket.barcodeType === 'qrcode' && !ticket.scaleOverride) {
				ticket.scaleOverride = scope.scale;
			}

			$timeout(function() {
				scope.generateBarcode(scope, ticket.barcode, ticket.barcodeType, ticket.location, ticket.scaleOverride, !!scope.ticket.primary_barcode);
			}, 10);
		}

		/**
		 * Determine what data to use to generate the barcode
		 * @public
		 * @param {Object} ticket The entire ticket object
		 * @returns {String} The barcode data as a string
		 */
		function getBarcodeData(ticket) {
			if (ticket.primary_barcode) {
				return ticket.primary_barcode;
			} else if (ticket.PRINT_AT_HOME && Utilities.getBoolean(ticket.PRINT_AT_HOME.use_order_id_as_barcode)) {
				return ticket.order_id.toString();
			} else if (ticket.qrBarCodeData) {
				return ticket.qrBarCodeData;
			}

			return ticket.barcode.toString();
		}

		/**
		 * Generate and render the barcode given an assortment of parameters
		 * @public
		 * @param {Scope} scope The scope containing data and public functions
		 * @param {String} barcode The barcode string
		 * @param {String} barcodeType The type of barcode that this is
		 * @param {String} location Where to render the barcode
		 * @param {String} scaleOverride At what scale to render the barcode
		 * @param {String} isPrimaryBarcode If this is the primary barcode and we dont want to modify it in any way
		 * @returns {undefined}
		 */
		function generateBarcode(scope, barcode, barcodeType, location, scaleOverride, isPrimaryBarcode) {
			var barcodeSettings = scope.getBarcodeSettings(barcode, barcodeType, scaleOverride, isPrimaryBarcode);

			if (barcodeSettings) {
				scope.renderBarcode(scope, location, barcodeSettings);
			} else {
				$log.error('Barcode Generation Failed - Barcode Type Mismatch');
			}
		}

		/**
		 * Effectively compiles an object to represent the barcode.
		 * @public
		 * @param {String} barcode The barcode string
		 * @param {String} barcodeType The type of barcode that this is
		 * @param {String} scaleOverride At what scale to render the barcode
		 * @param {String} isPrimaryBarcode If this is the primary barcode and we dont want to modify it in any way
		 * @returns {Object|undefined} An object containing settings to render the barcode off of. Undefined if barcodeType is unrecognized.
		 */
		function getBarcodeSettings(barcode, barcodeType, scaleOverride, isPrimaryBarcode) {
			var scaleOverrideInt = parseInt(scaleOverride, 10);
			var matchingBarcodeEnum = BARCODE_TYPES.find(function(typeToCheck) {
				return barcodeType === typeToCheck.type;
			});
			var barcodeText = isPrimaryBarcode ? barcode : barcode.trim();

			if (!matchingBarcodeEnum) {
				return;
			}

			return {
				// Barcode Text
				altx: barcodeText,
				opts: matchingBarcodeEnum.opts,
				rotate: VALID_ROTATIONS[matchingBarcodeEnum.rotate],
				scale: (!isNaN(scaleOverrideInt)) ? scaleOverride : matchingBarcodeEnum.scale,
				// Barcode Value
				text: barcodeText,
				type: matchingBarcodeEnum.type
			};
		}

		/**
		 * Render the barcode given an assortment of parameters
		 * @public
		 * @param {Scope} scope The scope containing data and public functions
		 * @param {String} location Where to render the barcode
		 * @param {Object} barcodeSettings Object containing specific settings for rendering the barcode
		 * @returns {undefined}
		 */
		function renderBarcode(scope, location, barcodeSettings) {
			var Baren = scope.getBaren();
			var bw = new Baren();
			var scl = parseInt(barcodeSettings.scale, 10) || 5;

			// Add the alternate text
			if (barcodeSettings.altx) {
				barcodeSettings.opts.alttext = bw.value(barcodeSettings.altx);
			}

			// Add any hard-coded options required to fix problems in the javascript emulation.
			barcodeSettings.opts.inkspread = bw.value(0);

			// eslint-disable-next-line no-undef
			if (Baren.needyoffset[barcodeSettings.type] && !barcodeSettings.opts.textxalign && !barcodeSettings.opts.textyalign && !barcodeSettings.opts.alttext && barcodeSettings.opts.textyoffset === undefined) {
				barcodeSettings.opts.textyoffset = bw.value(-10);
			}

			// eslint-disable-next-line no-undef
			bw.bitmap(new Baren.Bitmap());
			bw.scale(scl, scl);
			bw.push(barcodeSettings.text);
			bw.push(barcodeSettings.opts);

			try {
				bw.call(barcodeSettings.type);
				bw.bitmap().show(location, barcodeSettings.rotate);
				bw = null;
			} catch (e) {
				$log.error(e);
			}
		}

		/**
		 * Abstracting out Baren dependancy for testability
		 * @public
		 * @returns {Baren} The Baren library
		 */
		function getBaren() {
			// eslint-disable-next-line no-undef
			return Baren;
		}
	}
})();

angular.module('app')
	.directive('verifyImageSrc', function() {
		var directive = {
			restrict: 'A',
			scope: {
				onVerifySuccess: '<?'
			},
			link: function(scope, element, attrs) {
				/**
				 * This will get the image from the attribute and verify if the image exists
				 * onload, onerror
				 *
				 * If the image onload, it will place the image within the dom of the
				 * parent container, add new class to element 'ng-valid'
				 *
				 * onerror, add class to element 'ng-invalid'
				 *
				 * Acceptable attributes: data-true, place the image within the css of the parent element
				 *
				 * 	default 'NONE', inject new $childNode
				 *
				 * @type {Image}
				 */

				function initialize() {
					var image = new Image();
					var imageSource = attrs.verifyImageSrc,
						hideOnError = attrs.hideOnError === 'true',
						imgClass = attrs.imgClass,
						alt = attrs.alt;

					if (alt && alt !== '') {
						// Add alt to image
						image.alt = alt;
						element.find('img')
							.attr('alt', alt);
					}

					if (imgClass && imgClass !== '') {
						// Add class to image
						image.className = imgClass;
						element.find('img')
							.addClass(imgClass);
					}

					imageSource = attrs.verifyImageSrc;

					// Checks if the image exists
					emptyAttribute(imageSource);

					image.onload = function() {
						setClassesAndRemoveChildImageOnload();
						/**
						 * This is an additional style to verify-image-scr attribute, if it contains data-true it will
						 * set the image within the css of the parent container
						 */
						if (attrs.$attr.true) {
							element.css({ 'background-image': 'url(' + attrs.verifyImageSrc + ')' });
						} else {
							//append the new image
							element.append(image);
						}

						if (angular.isFunction(scope.onVerifySuccess)) {
							scope.onVerifySuccess();
						}

						return;
					};

					image.onerror = function() {
						if (attrs.$attr.true && attrs.fallbackSrc) {
							element.css({ 'background-image': 'url(' + attrs.fallbackSrc + ')' });
						}
						if (hideOnError) {
							element[0].style.display = 'none !important';
						}
						// append the ng-invalid class to indicate the image failed to load
						element.addClass('ng-invalid');
					};

					// Always set the src last so that way onload and onerror are already registered.
					image.src = imageSource;
				}


				function setClassesAndRemoveChildImageOnload() {
					//Remove images within the children of the element
					element.find('img').remove();

					//Add success class to manipulate
					element.removeClass('ng-invalid');
					element.addClass('ng-valid');
				}

				function emptyAttribute(data) {
					// If the string sent is empty then send resource back
					if (data === '') {
						element.css({ display: 'none' });
					} else {
						// If the element has 'display: none' style remove it
						if (element[0].style && element[0].style.cssText.indexOf('display: none;') !== -1) {
							element[0].style.cssText = '';
						}
					}
				}

				initialize();

				var updateModalWatch = scope.$on('$UpdateModal', function() {
					initialize();
				});

				scope.$on('$destroy', function() {
					updateModalWatch();
				});

				// Watch for changes due to js timing on dom load
				scope.$watch(function() {
					return attrs.verifyImageSrc;
				}, function(imageSource) {
					// Continue watching
					if (!imageSource) {
						return;
					}
					initialize();
				});
			}
		};
		return directive;
	});

/**
 * @ngdoc function
 * @name shoplandApp.directive:videoPlayer
 * @description
 * # videoPlayer
 * Directive of the shoplandApp
 */

angular.module('app')
	.directive
	('videoPlayer',

		function($sce, $document, $timeout, $rootScope, $log, ClientInfo, Modal, Package, Utilities, Language) {
			var dir = {
				templateUrl: '/views/templates/videoPlayerTemplate.html',
				scope: {
					videoSource: '=videoSource',
					isPlaying: '=',
					isMuted: '=',
					autoPlay: '=',
					showFullscreen: '='
				},
				link: function(scope, element, attrs) {
					scope.trustSrc = function(src) {
						return $sce.trustAsResourceUrl(src);
					}

					var isFullscreen = false;

					if (angular.isUndefined(scope.autoPlay)) {
						scope.autoPlay = 'true';
						scope.isPlaying = 'pause';
						scope.isMuted = 'unmuted';
					} else {
						scope.autoPlay = 'false';
						scope.isPlaying = 'play';
						scope.isMuted = 'muted';
					}

					$timeout(function() {
						// Video
						var app = $document[0];
						var video = angular.element(app.querySelector('#video'))[0];

						video.addEventListener("ended", function() {
							scope.isPlaying = 'play';
							if (isFullscreen == true) {
								scope.toggleFullscreen();
							}
						});

						scope.togglePlay = function() {
							video.paused == false ? video.pause() : video.play();
							scope.isPlaying = video.paused == false ? 'pause' : 'play';
							if (scope.isPlaying === 'pause') {
								$rootScope.$broadcast('triggerVideoView');
							}
						};

						scope.toggleVolume = function() {
							video.muted == false ? video.muted = true : video.muted = false;
							scope.isMuted = video.muted == false ? 'unmuted' : 'muted';
						};

						scope.toggleFullscreen = function() {
							if (isFullscreen) {
								if (video.exitFullscreen) {
									video.exitFullscreen();
								} else if (video.webkitExitFullscreen) {
									video.webkitExitFullscreen();
								} else if (app.mozCancelFullScreen) {
									app.mozCancelFullScreen();
								}
								isFullscreen = false;
							} else {
								if (video.enterFullscreen) {
									video.enterFullscreen();
								} else if (video.mozRequestFullScreen) {
									video.mozRequestFullScreen();
								} else if (video.webkitRequestFullScreen) {
									video.webkitRequestFullScreen();
								}
								isFullscreen = true;
							}
						}

						function checkVideoType() {
							// Ensure defined
							if (Utilities.safelyCheckPropertyOnObject('videoSource.videos', scope.videoSource)) {
								var video = document.createElement('video');

								// Iterate through videos
								for (var i = 0; i < scope.videoSource.videos.length; i++) {
									// If we have a webm video and the browser doesn't support webm
									if (scope.videoSource.videos[ i ].type.indexOf('webm') !== -1 &&
										video.canPlayType(scope.videoSource.videos[ i ].type) === '') {
										$log.error('This browser does not support the video type: webm');

										// Only show modal in debug mode
										if ($rootScope.develop) {
											Modal.displayModal({
												category: 'Unsupported Content - webm',
												action: 'Error',
												label: 'Unsupported Content - webm',
												title: Language.getLocale('Alert', 'generalErrorTitle'),
												description: 'This browser does not support the video type: webm'
											});
										}
									}
								}
							}
						}

						var setupFullscreenControls = function() {
							if (video.mozRequestFullScreen || video.webkitRequestFullscreen) {
								scope.showFullscreen = true;
							} else if (video.msRequestFullscreen) {
								scope.showFullscreen = false;
							} else {
								scope.showFullscreen = false;
							}
						}

						checkVideoType();
						setupFullscreenControls();
					});
				}
			};

			return dir;
		}
	);

angular.module('app')
	.directive('optionsDisabled', function($parse, $log) {
		var disableOptions = function(scope, attr, element, data, fnDisableIfTrue) {
			var realIndex = 0;
			angular.forEach(element.find("option"), function(value, index) {
				var elem = angular.element(value);
				if (elem.val() !== '?') {
					var locals = {};
					locals[attr] = data[realIndex];
					realIndex++; // this skips data[index] with empty value (IE first <option> with 'Please select from dropdown' item)
					elem.attr("disabled", fnDisableIfTrue(scope, locals));
				}
			});
		};

		return {
			priority: 0,
			require: 'ngModel',
			link: function(scope, iElement, iAttrs, ctrl) {
				// parse expression and build array of disabled options
				try {
					var expElements = iAttrs.optionsDisabled.match(/^\s*(.+)\s+for\s+(.+)\s+in\s+(.+)?\s*/);
					var attrToWatch = expElements[3];
					var fnDisableIfTrue = $parse(expElements[1]);
				} catch (e) {
					$log.error("optionsDisabled Directive not properly configured");
					$log.error(e);
				}

				scope.$watch(attrToWatch, function(newValue, oldValue) {
					if (newValue) {
						disableOptions(scope, expElements[2], iElement, newValue, fnDisableIfTrue);
					}
				}, true);
				// handle model updates properly
				scope.$watch(iAttrs.ngModel, function(newValue, oldValue) {
					var disOptions = $parse(attrToWatch)(scope);
					if (newValue) {
						disableOptions(scope, expElements[2], iElement, disOptions, fnDisableIfTrue);
					}
				});
			}
		};
	});

angular.module('app')
	.directive('seasonPassForm',
		function(
			$filter
			, $rootScope
			, $stateParams
			, $locale
			, AppData
			, AddrLookup
			, titlesJSon
			, countriesJSon
			, Enums
			, ExtraFlow
			, Language
			, Modal
			, Package
			, JSONValidator
			, Seasonpass
			, UserInfo
			, Utilities
			, UtilsValidation
			, OneBarcodeUtilities
			, FormValidation
			, $timeout
			, $log
			, StringUtils
		) {
		/**
		 * Season pass directive controller
		 * @param {Scope} $scope Directive Scope
		 * @returns {undefined}
		 * @ngInject
		 */
			function SeasonPassFormDirectiveController($scope) {
				$scope.emailType = JSONValidator.validate('disable_form_validation', AppData.settings.disable_form_validation) ? 'text' : 'email';
			}
			// NOTE: Use slash in front of templateUrl in order to have page load correctly.
			var dir = {
				templateUrl: '/views/templates/seasonPassFormTemplate.html',
				scope:
			{
				callbacks: '=callbacks',
				fieldSettings: '=fieldSettings',
				formData: '=formData',
				formOptions: '=formOptions',
				controllerScope: '=controllerScope',
				cartItems: '=cartItems',
				packageDetails: '=packageDetails',
				formIsPreFilled: '=formIsPreFilled',
				toggleNextRenewalStep: '&',
				deleteRenewalForm: '&'
			},
				controller: SeasonPassFormDirectiveController,
				link: function(scope, elm, attrs) {
					// Date format config - ensure MM is capitalized in config.
					var dConfig;
					var validArray = UtilsValidation.validArray;
					// this is a temporary solution until Europe is converted to
					// the new standard with angular locale files
					var checkProp = Utilities.safelyCheckPropertyOnObject,
						getBoolean = Utilities.getBoolean,
						isRealObject = UtilsValidation.isRealObject,
						validString = UtilsValidation.validString,
						agreementFormConfig = JSONValidator.validate('agreement_form', AppData.settings.agreement_form) ? JSON.parse(AppData.settings.agreement_form) : {};

					scope.isEmailVerificationComplete = false;
					scope.isContinueLoading = false;
					scope.isEmailVerificationEnabled = isEmailVerificationEnabled;
					scope.emailOptions = {
						autoCapitalize: 'off',
						cyEmailRequired: 'required-error',
						cyEmailPattern: 'pattern-error',
						emailPatternError: Language.FormValidation.emailPatternError,
						emailRequiredError: Language.FormValidation.emailRequiredError,
						enableEmailVerification: scope.isEmailVerificationEnabled(),
						label: Language.FormLabels.email,
						maxLength: '50',
						placeholder: Language.FormLabels.email,
						validationType: 'email'
					};
					scope.onEmailAddressChange = onEmailAddressChange;
					scope.onEmailVerificationSuccess = onEmailVerificationSuccess;
					scope.onEmailVerificationFailed = onEmailVerificationFailed;
					scope.setContinueLoading = setContinueLoading;
					scope.saveDataForAgreements = saveDataForAgreements;

					if (AppData.island === 'accesso95' || AppData.island === 'accesso70') {
						dConfig = $locale.DATETIME_FORMATS.shortDate;
						var shortDateReplacements = [
							{
								key: "d",
								value: "dd"
							},
							{
								key: "M",
								value: "MM"
							},
							{
								key: "yy",
								value: "yyyy"
							},
							{
								key: "y",
								value: "yyyy"
							}
						];

						shortDateReplacements.forEach(function(item) {
							if (StringUtils.countOccurrences(dConfig, item.key) === 1) {
								dConfig = dConfig.replace(item.key, item.value);
							}
						});
					} else {
						dConfig = AppData.settings.date_format;
					}

					var renewRegEx = Utilities.childDefined(AppData, 'GetApplicationConsolidated.SETTINGS.season_pass_renew_code_length')
						? new RegExp(AppData.GetApplicationConsolidated.SETTINGS.season_pass_renew_code_length)
						: '';

					var bDayRegEx = new RegExp(/^\d{4}\-\d{2}\-\d{2}/);

					var skipFieldsFromCopyToPasses = Utilities.safelyCheckPropertyOnObject('Package.packageDetails.CHARACS.skip_copy_to_passes_fields', Package) ? Package.packageDetails.CHARACS.skip_copy_to_passes_fields.split(',') : [];

					scope.showCopyEmailFromFirstPassOption = (Package.settings.name == 'season_pass_cf_v2_copy_email');
					if (Utilities.safelyCheckPropertyOnObject('Package.packageDetails.CHARACS.disableCopyToBillingOnPassForm', Package)) {
						scope.formOptions.showCopyInfoToBilling = false;
					}
					scope.isEditing = Package.isEditing();

					scope.showRegion = Utilities.childDefined(AppData, 'GetApplicationConsolidated.SETTINGS.show_region')
						? Utilities.getBoolean(AppData.GetApplicationConsolidated.SETTINGS.show_region)
						: true;

					scope.showPassCheck = Utilities.safelyCheckPropertyOnObject('AppData.settings.show_season_pass_check', AppData) ? Utilities.getBoolean(AppData.settings.show_season_pass_check) : false;

					scope.i18n = Language;
					scope.countryRequiresAZipCode = $rootScope.countryRequiresAZipCode;

					//variable to set certain view elements if this directive is showing from the renewal XMC flow
					scope.fromRenewalFlow = scope.formData.hasOwnProperty('renewalSelected');
					scope.hideRenewalStepHeader = (scope.formData.hasOwnProperty('renewalSelected') && scope.formData.renewalSelected === false);
					if (scope.fromRenewalFlow) {
						scope.formData.submitted = false;
					}

					scope.titles = titlesJSon;
					scope.countries = AppData.countries;
					scope.regions = countriesJSon.regions;
					scope.packageName = scope.packageDetails.name;

					if (Utilities.objectKeyExists('CHARACS', Package.packageDetails) &&
				Utilities.objectKeyExists('oneBarcodeKeyword', Package.packageDetails.CHARACS) &&
				OneBarcodeUtilities.performPackageLookup().length > 0) {
						scope.formOptions.hasAddOns = ! configuratorInXMCs();
					}

					for (var i = 0; i < scope.packageDetails.CT.length; i++) {
						if (((scope.packageDetails.CT[ i ] || {}).id || '') === scope.formData.rateType) {
							scope.packageHeadline = scope.packageDetails.CT[ i ].name;
						}
					}

					scope.formData.ph_children = 0;
					scope.useAddrLookup = AppData.use_addr_lookup;

					scope.$on('GOOGLEZIP', function(event, data) {
					// We only want to allow GOOGLEZIP if the addresslookup directive is not showing
						if (!scope.addrLookupActivated) {
							scope.formData.ph_country = scope.fieldSettings.country.visible ? data.country: scope.formData.ph_country;
							scope.formData.ph_city = scope.fieldSettings.city.visible ? data.city : scope.formData.ph_city;
							scope.formData.ph_state = scope.fieldSettings.state.visible ? data.state : scope.formData.ph_state;
							scope.formData.ph_country_code = scope.formData.ph_country;
						}
					});

					/**
					 * Initializes Season Pass Form.
					 * Passes reference to all forms in main controller.
					 * @private
					 */
					function init() {
						// Store a reference to each form (all the forms) in the main controller.
						scope.controllerScope.formCollection = scope.controllerScope.formCollection || [];
						scope.formData.ph_state = scope.formData.ph_state || null;
						scope.controllerScope.formCollection.push
						(
							{
								formID: scope.formData.formID,
								formScope: scope.theForm,
								formData: scope.formData,
								element: elm
							}
						);

						updateLocales();
						setDefaultCountry();
						setApplyToBillingInfo();

						$rootScope.$broadcast('triggerSeasonPassOpen');

						if (scope.useAddrLookup) {
							if (scope.controllerScope.formCollection.length > 1) {
								//turn off address lookup on subsequent forms but provide the option
								scope.toggleAddrLookupOnOff(false);
								scope.showAddrSearchBtnOnForm = AddrLookup.isAddrLookupCountry(scope.formData.ph_country_code);
							} else {
								//set activated address lookup first based on useAddrLookup and whether or not the showAddrLookupForm has been toggled on
								scope.addrLookupActivated = AddrLookup.getShowAddrLookupOnNextForm() && AddrLookup.isAddrLookupCountry(scope.formData.ph_country_code) && !scope.fromRenewalFlow;
								/*indicator to allow user to have opportunity to show address lookup directive in case they would like to look up another address
						only will appear if current selected country is an address lookup country*/
								scope.showAddrSearchBtnOnForm = AddrLookup.isAddrLookupCountry(scope.formData.ph_country_code);
							}
						}

						if (scope.fromRenewalFlow) {
							scope.theForm.$setPristine();
						}

						if (scope.isEditing) {
							scope.formData.emailConfirmation = scope.formData.ph_email;
						}

						//convert back to boolean if 'yes' or 'no'
						if (angular.isDefined(scope.formData.biometrics_required)) {
							scope.formData.biometrics_required = Utilities.getBoolean(scope.formData.biometrics_required) || scope.formData.biometrics_required == 'yes';
						}

						scope.shouldHideAddressColumn = Seasonpass.shouldHideAddressColumn();
					}

					function setApplyToBillingInfo() {
						scope.formData.copy_to_billing = (UserInfo.billing || {}).copy_to_billing || false;
					}

					function biometricThresholdAge() {
						return Utilities.safelyCheckPropertyOnObject('AppData.settings.biometrics_age', AppData) ? Utilities.forceInt(AppData.settings.biometrics_age) : 0;
					}

					function configuratorInXMCs() {
						return (Utilities.safelyCheckPropertyOnObject('Package.packageDetails.extra_movie', Package)
					&& (Package.packageDetails.extra_movie.indexOf('addonSelection') !=-1));
					}

					function biometricLocale(target) {
						var merchant_specific = target + "_"+ AppData.merchantId,
							biometricSection = 'SeasonPass'; // just preventing typos
						if (Language.localeExists(biometricSection, merchant_specific)) {
							return Language.getLocale(biometricSection, merchant_specific);
						}
						return Language.getLocale(biometricSection, target);
					}

					/***-----------------------------------------------------------------------
					 * PUBLIC
					 *------------------------------------------------------------------------**/
					/**
					 * Confirms the user's choice to decline biometrics
					 */
					scope.confirmBiometric=function() {
						var age = Utilities.forceInt(scope.formData.ph_age);

						if (! Utilities.getBoolean(scope.formData.biometrics_required)) {
							Modal.displayModal
							(
								{
									title: biometricLocale('biometricsnotAcknowledgedTitle'),
									description: (age>0 && age<biometricThresholdAge()) ? biometricLocale('biometricsnotAcknowledgedUnderAge') : biometricLocale('biometricsnotAcknowledged'),
									icon: 'icon-info red',
									buttonFlags: [Enums.buttonFlags.NO, Enums.buttonFlags.YES],
									callback: function(detail) {
										if (detail == Enums.buttonFlags.YES) {
											scope.formData.biometrics_required= true;
										}
									}
								}
							);
						}
					};

					scope.usingFolioData = function(formData) {
						return formData.client_media_number;
					};

					scope.biometricCheckBoxLabel = function(formData) {
						var age = Utilities.forceInt(formData.ph_age);

						if (age>0 && age<biometricThresholdAge()) {
							return biometricLocale('acknowledgeBiometricsUnderAge');
						}
						return biometricLocale('acknowledgeBiometrics');
					};
					/**
					 * Attempts to submit form.
					 * Checks that form fields are valid and passes the data to
					 * CHARACS.
					 * @public
					 * @returns {*}
					 */
					scope.submitForm = function() {
						if (scope.useAddrLookup && scope.addrLookupActivated) {
							AddrLookup.showAddrLookupIncompleteModal();
						}

						scope.formData.submitted = true;
						if (checkProp('scope.emailOptions.enableEmailVerification', scope, Utilities.getBoolean) && !scope.isEmailVerificationComplete && scope.theForm.$valid) {
							scope.setContinueLoading(true);
							return;
						}
						scope.setContinueLoading(false);
						formatFormData();

						saveOneBarcodeAddons();

						// Verify zip code is valid (primarily used to ensure prefilled zip is correct)
						scope.handleCountriesChanged();

						if (scope.fromRenewalFlow) {
							submitRenewalForm();
						} else {
							// Validate the form via form object value.
							// Validate custom sections if required (e.g. had pass options).
							// If form is invalid, show errors, otherwise proceed to next form.
							var nextFormID = getNextFormID();

							if (nextFormID != -1) {
								// Will validate and move on to the next form.
								scope.toggleForm(nextFormID);
								return;
							} else {
								// This is the only or the last form.
								// Validate and add to cart.
								var formIndex = scope.controllerScope.formCollection.length - 1;
								var currentForm = scope.controllerScope.formCollection[ formIndex ];
								var allSectionsValid = customSectionsValid(currentForm);

								if (handleMinAgeRequirement(currentForm.formID)) {
									return;
								}

								if (scope.theForm.$invalid || !allSectionsValid) {
									// Invalid. Mark form as submitted to toggle visible any errors.
									scope.formData.submitted = true;

									var field = Utilities.getFirstInvalidField(currentForm.formScope.$error);
									try {
										window.scrollTo(0, Utilities.getScrollPosition(
											document.getElementsByName('theForm')[formIndex].querySelectorAll(
												'[name="'+ field + '"]'
											)[0]
										).y
										);
									} catch (e) {}
									return;
								}
							}

							// All forms are valid. We are done!
							// Copy pass info to agreements
							if (!agreementFormConfig.skipCopyingPassInfoToAgreements) {
								scope.saveDataForAgreements(scope.controllerScope.dataModel[0]);
							}
							// If copy to billing was selected on the first form... Handle that!
							if (scope.controllerScope.dataModel[ 0 ].copy_to_billing) {
								saveDataForBilling(scope.controllerScope.dataModel[ 0 ]);
								//turn off default showing of address lookup on billing form since user selected same address to be used
								AddrLookup.setShowAddrLookupOnNextForm(false);
							} else {
								UserInfo.billing.copy_to_billing = false;
							}

							// Save data to CHARACS.
							saveDemographicsToCharacs();
						}
						$rootScope.$broadcast('triggerPushSeasonPassInfo', scope.formData);

						Utilities.scrollPosition();
					};

					/**
					 * submitRenewalForm - method to handle logic for validating and allowing next item in renewal flow
					 */
					function submitRenewalForm() {
						var formItem = {
							formScope: scope.formData,
							formData: scope.formData
						};

						if (scope.theForm.$invalid || !validateAge(formItem) || handleMinAgeRequirement(formItem)) {
							return;
						} else {
							scope.formData.valid = true;
							// Copy renewal pass info to agreements
							if (!agreementFormConfig.skipCopyingPassInfoToAgreements) {
								scope.saveDataForAgreements(scope.formData);
							}
							if (scope.formData.copy_to_billing) {
								saveDataForBilling(scope.formData);
							}
							AddrLookup.setShowAddrLookupOnNextForm(false);
							scope.toggleNextRenewalStep({ incDecStep: 1 });
							Utilities.scrollPosition();
						}
					}

					function deleteSelectedRenewalForm() {
						scope.deleteRenewalForm({ promptUserForConfirmation: false });
					}

					/**
					 * Saves form data to agreements
					 * @public
					 * @param {Object} formData form data
					 * @returns {undefined}
					 */
					function saveDataForAgreements(formData) {
						var formDataMappings = {
								birthDate: 'ph_birth_date',
								firstName: 'ph_first_name',
								lastName: 'ph_last_name',
								phone: 'ph_home_phone',
								email: 'ph_email',
								country: 'ph_country_code',
								address: 'ph_address',
								address2: 'ph_address2',
								city: 'ph_city',
								state: 'ph_state',
								zip: 'ph_zip'
							},
							fields = {},
							i;
						for (i in formDataMappings) {
							fields[i] = angular.copy(formData[formDataMappings[i]] || '');
						}
						if (Language.SeasonPass.noEmail) {
							fields['email'] = formData.ph_email && formData.ph_email.toLowerCase() !== Language.SeasonPass.noEmail.toLowerCase() ? formData.ph_email : '';
						} else {
							fields['email'] = formData.ph_email || '';
						}

						if (!validString(fields['state'])) {
							fields['state'] = formData['ph_province'] || '';
						}
						UserInfo.set('agreements', fields);
					}

					/*Toggles the address lookup on or off*/
					scope.toggleAddrLookupOnOff = function(bool) {
						scope.addrLookupActivated = bool;
						if (bool) {
							scope.showAddrSearchBtnOnForm = false;
						} else {
							scope.showAddrSearchBtnOnForm = true;
						}
					}

					/**
					 * Toggles for activity based on formID.
					 * Checks the form is valid before proceeding.
					 * @param formID {string}
					 * @returns {*}
					 */
					scope.toggleForm = function(formID) {
						// Active form's index.
						//we do not want to control this from
						if (scope.fromRenewalFlow) {
							return;
						}
						var selectedFormIndex = getSelectedFormIndex();

						// This form's index.
						var requestedFormIndex = Number(formID.split('_')[ 1 ]);

						if (selectedFormIndex == 0) {
							// Set the passesCopied field to false
							scope.controllerScope.formCollection[ 0 ].formData.passesCopied = false;
						}


						if (scope.formIsPreFilled!==true && scope.formOptions.showCopyInfoToPasses) {
							// Copy data to other passes if applicable.
							copyPassInfoToOtherPasses(selectedFormIndex);
						}


						// Ensure min age requirement is met.
						if (handleMinAgeRequirement(formID)) {
							return;
						}

						// Validate all previous forms if necessary.

						// Example:
						// Current form index = 0; Requested form index = 2.
						// Validate forms at index 0 and 1.
						// If 0 invalid, remain at 0.
						// If 1 invalid, jump to 1.
						// If 0 and 1 valid, jump to 2.

						// In other words, jump to first invalid form or the selected form.
						if (requestedFormIndex < selectedFormIndex) {
							// Loading a previous form... No need to validate, just toggle visibility.
							showFormByFormID(formID);
							return;
						}

						for (var i = selectedFormIndex; i < requestedFormIndex; i++) {
							// Data for the current form in this iteration.
							var currentFormItem = scope.controllerScope.formCollection[ i ];
							var allSectionsValid = customSectionsValid(currentFormItem);

							if (currentFormItem.formScope.$invalid || !allSectionsValid) {
								// Loading a subsequent form and a previous form is invalid...
								// Mark form as submitted to toggle visible any errors.
								currentFormItem.formData.submitted = true;

								// Expand the first invalid form.
								showFormByFormID(currentFormItem.formData.formID);

								var field = Utilities.getFirstInvalidField(currentFormItem.formScope.$error);
								try {
									window.scrollTo(0, Utilities.getScrollPosition(
										document.getElementsByName('theForm')[i].querySelectorAll(
											'[name="'+ field + '"]'
										)[0]
									).y
									);
								} catch (e) {}

								return;
							}
						}

						// Loading a subsequent form and all previous forms are valid...
						showFormByFormID(formID);

						// Mark as valid.
						scope.controllerScope.formCollection[ selectedFormIndex ].formData.valid = true;
						scope.toggleAddrLookupOnOff(false);
					}

					/**
					 * Calls updatePostalCodeDataType based on
					 * scope.formData.ph_country_code.
					 * @public
					 * @returns undefined
					 */
					scope.handleCountriesChanged = function(item) {
						if (!item) {
							item = scope.formData.ph_country_code;
						}
						updatePostalCodeDataType(item);
						if (AddrLookup.isAddrLookupCountry(item)) {
							scope.showAddrSearchBtnOnForm = true;
						} else {
							scope.showAddrSearchBtnOnForm = false;
							scope.addrLookupActivated = false;
						}
					}


					/**
					 * Toggles Had Pass Options.
					 * @public
					 * @returns undefined
					 */
					scope.handleHadPassOptionSelected = function() {
						scope.theForm.hasNotSeasonPass.$invalid = false;
						scope.theForm.hasNotSeasonPass.$valid = true;
					}

					/**
					 * Handles is the Current Form should have the same address as the
					 * primary pass holder
					 * @public
					 * @returns undefined
					 */
					scope.handleSameAsPrimaryChange = function() {
						var currentForm = scope.formData;
						if (currentForm.same_address) {
							var addressFields = [
								'ph_address',
								'ph_address2',
								'ph_country_code',
								'ph_state',
								'ph_zip'
							];
							for (key in currentForm) {
								if (addressFields.indexOf(key) != -1) {
									currentForm[ key ] = scope.controllerScope.formCollection[ 0 ].formData[ key ];
								}
							}
						}
					}

					/**
					 * Deletes a form by formID.
					 * Makes sure min quantity requirement remains.
					 * @public
					 * @param formID {string}
					 * @returns undefined
					 */
					scope.deleteForm = function(formID) {
						// Check if there is a minimum quantity before deleting.
						// Ensure min quantity requirement remains.
						var meetsMinQtyReq = meetsMinQtyRequirement();

						// Prompt to delete.
						var title = (meetsMinQtyReq)
							? Language.Alert.deleteSeasonPassTitle
							: Language.Alert.deleteSeasonPassMinQtyTitle;

						var msg = (meetsMinQtyReq)
							? Language.Alert.deleteSeasonPassMsg
							: Language.Alert.deleteSeasonPassMinQtyMsg;

						Modal.displayModal
						(
							{
								replacementKeys: ['minQty'],
								replacementValues: [scope.packageDetails.min_quantity],
								title: title,
								description: msg,
								icon: 'icon-info red',
								buttonFlags: [Enums.buttonFlags.NO, Enums.buttonFlags.YES],
								callback: function(detail) {
									if (detail == Enums.buttonFlags.YES) {
										if (meetsMinQtyReq) {
											if (scope.fromRenewalFlow) {
												deleteSelectedRenewalForm();
											} else {
												// Get the index from the formId
												var requestedFormIndex = Number(formID.split('_')[ 1 ]);
												// Use this to retrieve the form from the dataModel
												var formToDelete = scope.controllerScope.dataModel[ requestedFormIndex ];

												// If we have upsells, save the package_id because it will be deleted
												if (Package.preCartItems.length > 0) {
													var currentPackageId = Package.itemsToBeAdded[0].package_id;
												}

												for (var y = 0; y < Package.itemsToBeAdded.length; y++) {
													// Using the rate name to match form to item
													if (formToDelete.rateName === Package.itemsToBeAdded[ y ].client_rate_name) {
														makeCompAdjustmentsForDeletedForm(Package.itemsToBeAdded[y], y);

														// If the quanity is greater than 1, decrement and remove characs
														// At this point, the characs are identical
														// The form data hasn't been copied to the characs yet, so splicing the first is ok
														if (Package.itemsToBeAdded[ y ].qty > 1) {
															Package.itemsToBeAdded[ y ].qty--;
															Package.itemsToBeAdded[ y ].CHARACS.splice(0, 1);
														}
														// Or remove the item entirely
														else {
															Package.itemsToBeAdded.splice(y, 1);
														}

														break;
													}
												}

												// Delete the form and build new dataModel
												deleteForm(formID);

												// If we are dealing with upsells
												if (Package.preCartItemsIndex < Package.preCartItems.length && scope.controllerScope.dataModel.length === 0) {
													var nextPackage;
													var packageFound = false;

													for (var i = Package.preCartItemsIndex; i < Package.preCartItems.length; i++) {
														// If we find a package in the preCartItems that doesn't match our current packageId
														// Then this is an additional XFC to route to
														// packageDetails, itemsToBeAdded, and customerTypes are updated so setUpXFC can work properly
														if (Package.preCartItems[ i ].packageDetails.id != currentPackageId) {
															packageFound = true;
															nextPackage = Package.preCartItems[ i ];


															Package.packageDetails = Package.updatePackageRetailAmount(nextPackage.packageDetails);
															Package.itemsToBeAdded = validArray(nextPackage.itemsToBeAdded) ? nextPackage.itemsToBeAdded : [];
															Package.customerTypes = nextPackage.customerTypes;
															Package.preCartItemsIndex++;
															Package.setupXFC(0);
														}
													}

													// If there is no additional XFC, go to cart or back to packageDetails
													if (!packageFound) {
														Package.itemsToBeAdded = [];

														if (Package.finalCartItemsToBeAdded.length > 0) {
															Seasonpass.nextView();
														} else {
															$rootScope.routeTo(Enums.routes.DETAILS + '/' + $stateParams.packageId);
														}
													}
												}
											}
										} else {
											Seasonpass.cancel();
										}
									}
								}
							}
						);
					}

					/***-----------------------------------------------------------------------
					 * PRIVATE
					 *------------------------------------------------------------------------**/

					/**
					 * Updates the locales with dynamic data if necessary.
					 * @private
					 * @returns undefined
					 */
					function updateLocales() {
						// Some locales have strings that need to be replaced with dynamic data.
						// Do that here.
						var curYear = new Date().getFullYear();
						Language.SeasonPass.hasAnnualPass = Language.SeasonPass.hasAnnualPass.split('@@currentYear').join(curYear);
						Language.SeasonPass.hasNotAnnualPass = Language.SeasonPass.hasNotAnnualPass.split('@@currentYear').join(curYear);
						Language.SeasonPass.didYouHaveAnnualPass = Language.SeasonPass.didYouHaveAnnualPass.split('@@currentYear').join(curYear);
					}

					/**
					 * Sets the default Country.
					 * @private
					 * @returns undefined
					 */
					function setDefaultCountry() {
						// Set default country.
						if (!scope.formData.ph_country_code && scope.fieldSettings.country.visible) {
							scope.formData.ph_country_code = AppData.defaults.country;
							updatePostalCodeDataType(scope.formData.ph_country_code);
						}
					}

					/**
					 * Updates Datatype of Postal Code.
					 * @private
					 * @param {string} countryCode
					 * @returns {undefined}
					 */
					function updatePostalCodeDataType(countryCode) {
						// Update postal code data type.
						scope.formOptions.postalCodeDataType = (scope.formData.ph_country_code == 'US') ? 'tel' : 'text';
					}

					/**
					 * Checks that custom sections are valid.
					 * @private
					 * @param {object} formItem
					 * @returns {boolean}
					 */
					function customSectionsValid(formItem) {
						// Add sections needing validation here.
						var checkClientValid = validFromConfig(formItem);
						var validRenewCode = validateRenewCode(formItem);
						var emailsMatch = validateEmailsMatch(formItem);
						var genderSelected = validateGender();
						var ageValid = validateAge(formItem);

						return (emailsMatch && genderSelected && ageValid && validRenewCode && checkClientValid);
					}

					/**
					 * Checks if configValidation is set
					 * Validates based off the provided validation requirements and
					 * displays the proper errors if necessary
					 * @private
					 * @param {object} formItem
					 * @returns {boolean}
					 */
					function validFromConfig(currentFormItem) {
						scope.formData.ph_home_phone = StringUtils.formatPhoneNumber(scope.formData.ph_home_phone);
						scope.formData.ph_phone_number = StringUtils.formatPhoneNumber(scope.formData.ph_phone_number);
						var fieldSettings = scope.fieldSettings;
						var isErrored = false;
						var errType = null;

						if (fieldSettings.birthDate.visible) {
							scope.theForm.birthDate.$setValidity('minAgeNotMet', true);
							scope.theForm.birthDate.$setValidity('maxAgeExceeded', true);
						}
						for (var i in fieldSettings) {
							if (fieldSettings.hasOwnProperty(i)) {
								var field = fieldSettings[ i ];
								if (typeof field.configValidation == "object") {
									if (typeof (field.configValidation.validation || {}).type != "undefined" || (field.configValidation.validation || null) != null) {
										switch (field.configValidation.validation.type) {
										case 'pattern':
											var pat = new RegExp(field.configValidation.validation.value);
											if (pat.test(currentFormItem.formData[ field.characProp ])) {
												return true;
											}
											break;
										case 'multipart':
											var validationObj = (Utilities.childDefined(field, 'configValidation.validation.value') && typeof field.configValidation.validation.value.length != "undefined" ? JSON.parse(field.configValidation.validation.value) : false)
											if (!validationObj) {
												$log.error('Invalid Config set for validating field ' + field.characProp)
												return;
											}
											var validateBy = field.configValidation.validation.validateBy || null;
											for (var x in validationObj) {
												for (key in validateBy) {
													if (currentFormItem.formData.hasOwnProperty(key)) {
														var comparison = currentFormItem.formData[ key ];
														var compValue = validateBy[ key ];

														if (x == $stateParams.packageId) {
															for (var rateType in validationObj[ x ]) {
																if (validationObj[x][rateType][compValue] == comparison) {
																	for (var check in validationObj[ x ][ rateType ]) {
																		if (check != compValue) {
																			switch (check) {
																			case 'min_age':
																				var dob = parseDateFromModel();
																				var birthdate = new Date(dob.year, dob.month, dob.day);
																				if (tooYoung(birthdate, validationObj[ x ][ rateType ][ check ])) {
																					isErrored = true;
																					errType = 'minAge';
																					field.configValidation.error[errType].callback = function() {
																						scope.theForm.birthDate.$setValidity('minAgeNotMet', false);
																					}
																				}
																				break;
																			case 'max_age':
																				var dob = parseDateFromModel()
																				dob = new Date(dob.year, dob.month, dob.day)
																				var now = new Date();
																				var curAge = now.getFullYear() - dob.getFullYear()
																				if (tooOld(dob, validationObj[ x ][rateType][ check ])) {
																					isErrored = true;
																					errType = 'maxAge';
																					field.configValidation.error[errType].callback = function() {
																						scope.theForm.birthDate.$setValidity('maxAgeExceeded', false);
																					}
																				}
																				break;
																			}
																		}
																	}
																}
															}
														}
													} else {
														isErrored = true;
													}
												}
											}
											break;
										}
										// If there is not error. Return true
										if (isErrored == false) {
											return true
										}
										// If there is an error
										if (((field.configValidation.error || {}).type || '') === "modal" && field.required === true || isErrored) {
											if (errType == null) {
												Modal.displayModal
												(
													{
														title: field.configValidation.error.title || '',
														description: field.configValidation.error.description || '',
														icon: field.configValidation.error.icon || '',
														buttonFlags: field.configValidation.error.buttonFlags || [],
														callback: field.configValidation.error.callback || function() {}
													}
												);
											} else {
												Modal.displayModal(
													{
														title: field.configValidation.error[errType].title || '',
														description: field.configValidation.error[errType].description || '',
														icon: field.configValidation.error[errType].icon || '',
														buttonFlags: field.configValidation.error[errType].buttonFlags || [],
														callback: field.configValidation.error[errType].callback || function() {}
													}
												);
											}
											return false;
										}
									}
								}
							}
						}
						return true;
					}


					/**
					 * Handles minimum age requirement.
					 * @private
					 * @param {string} formID
					 * @returns {boolean}
					 */
					function handleMinAgeRequirement(formID) {
						// Validate min age.
						if (scope.formOptions.minAgeRequirement > 0) {
							// This will only happen once per ticket if applicable.
							if (validateMinAgeRequirements(formID)) {
								return true;
							}
						}

						return false;
					}

					/**
					 * Checks that minimum Qty requirement is met.
					 * @private
					 * @returns {boolean}
					 */
					function meetsMinQtyRequirement() {
						// Check the package's max-quantity and ensure deleting one will not go below min-qty.
						var minQty = Number(scope.packageDetails.min_quantity) || 0;

						if (minQty == 0) {
							return true;
						} else if (minQty > 1) {
							if (scope.fieldSettings.numPasses - 1 < minQty) {
								return false;
							}
						}

						return true;
					}

					/**
					 * Checks if a date of birth is below the minimum age requirement.
					 * @param {date} date1
					 * @param {integer} minAge
					 * @returns {boolean}
					 */
					function tooYoung(date1, minAge) {
						var ageDifMs = Date.now() - date1.getTime();
						var ageDate = new Date(ageDifMs);
						var age = Math.abs(ageDate.getFullYear() - 1970);
						return age < minAge;
					}

					/**
					 * Checks if a date is above the maxAge
					 * @param {date} date1
					 * @param {integer} minAge
					 * @retuns {boolean}
					 *
					 *         ∩＿＿＿∩
					 *        |ノ     ヽ
					 *        /  -   -  \
					 *       |   ( _●_)  ミ
					 *     	彡､    |_|  ､｀＼
					 * ------------------´>  )------
					 *         TOO OLD!  (_／
					 * -----------------------------
					 */
					function tooOld(date1, maxAge) {
						var ageDifMs = Date.now() - date1.getTime();
						var ageDate = new Date(ageDifMs);
						var age = Math.abs(ageDate.getFullYear() - 1970);
						return age > maxAge;
					}

					/**
					 * Validates minimum age Requrements based on formID.
					 * @private
					 * @param {string} forID
					 * @returns {boolean}
					 */
					function validateMinAgeRequirements(formID) {
						// If we are using birthday (month, day, year) vs age (a number) we need to extract the age from bday.
						var youngen = false;
						if (scope.fieldSettings.birthDate.required && scope.fieldSettings.birthDate.visible) {
							var dobObj = parseDateFromModel();

							if (!dobObj) {
								return false;
							}

							var dobDate = new Date(dobObj.year, dobObj.month, dobObj.day);
							youngen = tooYoung(dobDate, scope.formOptions.minAgeRequirement);
						}

						if ((scope.formOptions.minAgeRequirement >= Number(scope.formData.ph_age)) || youngen) {
							// Update locale used in in-line error message.
							Language.FormValidation.minAgeRequirementError = Language.FormValidation.minAgeRequirementError.split('@@minAge').join(scope.formOptions.minAgeRequirement);

							if (!scope.formData.promptedForMinAge) {
								Modal.displayModal
								(
									{
										replacementKeys: 'minAge',
										replacementValues: scope.formOptions.minAgeRequirement,
										title: Language.Alert.minAgeRequirementErrorTitle,
										description: Language.Alert.minAgeRequirementErrorMsg,
										icon: 'icon-info red',
										buttonFlags: [Enums.buttonFlags.OK],
										callback: function() {
											scope.formData.promptedForMinAge = true;
										}
									}
								);
							}

							scope.theForm.birthDate.$setValidity('minAgeError', false);
							return true;
						}

						scope.theForm.birthDate.$setValidity('minAgeError', true);
						return false;
					}

					/**
					 * Gets the age of a customer based on DOB
					 * @returns {null|integer}
					 */
					function getAgeFromDOB() {
						// Validate DOB is a valid date.
						// Consider config that specifies date format (i.e. MM-DD-YYYY vs DD-MM-YYYY).
						var dateObj = parseDateFromModel();

						if (!dateObj) {
							return null;
						}

						var currentDate = new Date();
						var day = currentDate.day;
						var month = currentDate.month - 1;
						var year = currentDate.getFullYear();

						var yearDiff = year - dateObj.year;
						return 0;
					}

					/**
					 * Parses the data in a model
					 * @param {object} model
					 * @returns {null|object}
					 */
					function parseDateFromModel(model) {
						// If model is not defined, assume it's from this scope.
						var modelData = model || scope.formData;

						if (typeof modelData.ph_birth_date == 'undefined' || (modelData.ph_birth_date || '').length == 0) {
							return null;
						}

						var dateArray = modelData.ph_birth_date.split('/');
						// after splitting the input, lets do some checks. To make sure they are entering
						// data correctly

 				var month = dateArray[0];
						var day = dateArray[1];
 				var year = dateArray[2];

						day = Number(day);
						month = Number(month) - 1;
						year = Number(year);

						return {
							day: day,
							month: month,
							year: year
						};
					}


					/**
					 * Format data in the model before form is submitted
					 */
					function formatFormData() {
						scope.formData.ph_first_name = Utilities.capitalizeFirst(scope.formData.ph_first_name);
						scope.formData.ph_last_name = Utilities.capitalizeFirst(scope.formData.ph_last_name);
					}

					scope.copyEmailFromFirstPass = function() {
						// If this isn't the first form and
						// the user clicks copy email from first
						// pass then this will execute.
						if (scope.formData.copy_email_from_first_pass) {
							scope.formData.ph_email = scope.formData.first_pass_email;
						}
					}

					/**
					 * Copies pass information from first pass into others
					 * @private
					 * @param {string} selectFormIndex
					 * @returns {undefinied}
					 */
					function copyPassInfoToOtherPasses(selectedFormIndex) {
						// If this is the first form and user opted to copy data and
						// the form is valid, copy data to other passes.
						// This should only happen if the data is valid.
						var firstFormData = scope.controllerScope.formCollection[ 0 ].formData;

						if (selectedFormIndex == 0 &&
					!firstFormData.passesCopied &&
					scope.controllerScope.formCollection[ 0 ].formScope.$valid &&
					customSectionsValid(scope.controllerScope.formCollection[ 0 ])) {
							if (firstFormData.copy_to_passes) {
								// Ensure this only happens once.
								firstFormData.passesCopied = true;

								// Iterate through copyable fields in settings and
								// set those fields in all passes to the value of the first pass.
								for (var key in scope.fieldSettings) {
									for (var j = 1; j < scope.controllerScope.formCollection.length; j++) {
										var passData = scope.controllerScope.formCollection[ j ].formData;
										if (scope.fieldSettings[ key ].copyable) {
											if ((skipFieldsFromCopyToPasses.indexOf(scope.fieldSettings[ key ].characProp) === -1)
										&& ! (scope.usingFolioData(passData) && key =='lastName')) {
												passData[ scope.fieldSettings[ key ].characProp ] = firstFormData[ scope.fieldSettings[ key ].characProp ];
											}
										}
										if (scope.formOptions[ 'showSameAddress' ] === true) {
											passData[ 'same_address' ] = true;
										}
									}
								}
								/**
								 * This line does a refresh from parent component so the ng-repeat directive can be aware the new changes.
								 */
								scope.controllerScope.refreshTemplate();
							} else if (!firstFormData.copy_to_passes) {
								// Everything is valid but the user chose not to
								// copy the information to other passes. Maybe they
								// missed the check-box. Prompt the user if they
								// want to copy after all.
								Modal.displayModal
								(
									{
										title: Language.Alert.copyPassDataTitle,
										description: Language.Alert.copyPassDataMsg,
										icon: 'icon-notice blue',
										buttonFlags: [Enums.buttonFlags.NO, Enums.buttonFlags.YES],
										callback: function(detail) {
											if (detail == Enums.buttonFlags.YES) {
												firstFormData.copy_to_passes = true;
												copyPassInfoToOtherPasses(selectedFormIndex);
											} else {
												// They confirmed no. Don't prompt again.
												firstFormData.passesCopied = true;
											}
										}
									}
								);
							}
						}
					}

					/**
					 * Gets the next form id.
					 * @private
					 * @returns {integer} the form id or -1
					 */
					function getNextFormID() {
						// Find the current form index.
						var selectedFormIndex = getSelectedFormIndex();

						// Select the form after that.
						if (selectedFormIndex < scope.controllerScope.dataModel.length - 1) {
							// This is not the only or last form.
							return scope.controllerScope.dataModel[ selectedFormIndex + 1 ].formID;
						}

						// Return -1 if there is no other form.
						return -1;
					}

					/**
					 * Gets the selected form index.
					 * @private
					 * @returns {integer} indexID or -1
					 */
					function getSelectedFormIndex() {
						// There can be any number of forms and this form may not be the one selected.
						// The dataModel in the controller has a flag checked for the selected form.
						for (var i = 0; i < scope.controllerScope.dataModel.length; i++) {
							if (scope.controllerScope.dataModel[ i ].isCurrentTicket) {
								return i;
							}
						}

						// Should never hit here.
						return -1;
					}

					/**
					 * Gets the current form by the index.
					 * @private
					 * @param {integer} index
					 * @returns {intger} the current form id or -1
					 */
					function getCurrentFormByIndex(index) {
						for (var i = 0; i < scope.controllerScope.formCollection.length; i++) {
							if (scope.controllerScope.dataModel[ i ].isCurrentTicket) {
								return i;
							}
						}

						// Should never hit here.
						return -1;
					}

					/**
					 * Shows the form based on the formID.
					 * Sets formObject.isCurrentTicket = true/false.
					 * @private
					 * @param {integer} formID
					 * @returns {undefined}
					 */
					function showFormByFormID(formID) {
						for (var i = 0; i < scope.controllerScope.dataModel.length; i++) {
							var formObject = scope.controllerScope.dataModel[ i ];
							formObject.isCurrentTicket = false;

							if (formObject.formID == formID) {
								formObject.isCurrentTicket = true;
							}
						}
					}

					/**
					 * Checks the email address to see if it is valid.
					 * @private
					 * @param {object} currentFormItem
					 * @returns {boolean}
					 */
					function validateEmailsMatch(currentFormItem) {
						// Validates the had pass section if required and visible.
						currentFormItem.formData.emailConfirmation = currentFormItem.formScope.emailConfirmation.$viewValue;

						if (angular.isObject(scope.fieldSettings.emailConfirmation) && scope.fieldSettings.emailConfirmation.visible
						&& scope.formOptions.showEmailConfirmation
						&& currentFormItem.formData.ph_email != currentFormItem.formData.emailConfirmation) {
							currentFormItem.formScope.emailConfirmation.$invalid = true;
							currentFormItem.formScope.emailConfirmation.$valid = false;
							return false;
						} else {
							return true;
						}
					}

					/**
					 * Validates Renew Code (Season Pass Code) based on length provided from App Config
					 * @private
					 * @param {object} currentFormItem
					 * @returns {boolean}
					 */
					function validateRenewCode(currentFormItem) {
						if (currentFormItem.formScope.renewCode.$valid &&
					scope.fieldSettings.renewCode.required) {
							if (renewRegEx == '' || renewRegEx.test(currentFormItem.formData.ph_member_code)) {
								return true;
							}

							Modal.displayModal({
						 title: Language.getLocale('Alert', 'renewCodeErrorTitle'),
								description: Language.getLocale('Alert', 'renewCodeErrorMsg'),
								icon: 'icon-info red',
								buttonFlags: [Enums.buttonFlags.OK]
							});

							return false;
						}

						return true;
					}

					/**
					 * Validate the gender field per the form field settings
					 * @returns {boolean}
					 */
					function validateGender() {
						var valid = true;
						if (angular.isDefined(scope.fieldSettings.sex) && scope.fieldSettings.sex.visible && scope.fieldSettings.sex.required) {
							valid = angular.isDefined(scope.formData.ph_sex);
						}

						return valid;
					}

					function validateAge(currentFormItem) {
						if (scope.fieldSettings.age.required &&
					scope.fieldSettings.age.visible) {
							if (isNaN(currentFormItem.formData.ph_age) || currentFormItem.formData.ph_age == '') {
								currentFormItem.formData.ph_age = '';
								return false;
							}
						}

						return true;
					}


					function saveDataForBilling(data) {
						// Flag to check if we are using season pass data for billing.
						UserInfo.userInfo = UserInfo.userInfo || {};
						UserInfo.userInfo.firstName = data.ph_first_name;
						UserInfo.userInfo.lastName = data.ph_last_name;
						UserInfo.userInfo.country = data.ph_country_code;
						UserInfo.userInfo.address = data.ph_address;
						UserInfo.userInfo.address2 = data.ph_address2;
						UserInfo.userInfo.city = data.ph_city;
						UserInfo.userInfo.state = data.ph_state || data.ph_province;
						UserInfo.userInfo.zip = data.ph_zip;
						UserInfo.userInfo.phone = String(data.ph_home_phone);
						UserInfo.userInfo.mobile = '';
						UserInfo.userInfo.copy_to_billing = true;
						UserInfo.userInfo.email = (!Language.SeasonPass.noEmail ? data.ph_email :
							data.ph_email.toLowerCase() !== Language.SeasonPass.noEmail.toLowerCase() ? data.ph_email : ''
						);
						//UserInfo.userInfo.emailVerify = UserInfo.userInfo.email;
						UserInfo.userInfo.sameAddress = 'yes';

						UserInfo.shipping = JSON.parse(JSON.stringify(UserInfo.userInfo));
						UserInfo.billing = JSON.parse(JSON.stringify(UserInfo.userInfo));
					}

					function deleteForm(formID) {
						// This form's index.
						var requestedFormIndex = Number(formID.split('_')[ 1 ]);
						var numPasses = scope.controllerScope.dataModel.length;

						scope.controllerScope.dataModel.splice(requestedFormIndex, 1);
						scope.controllerScope.formCollection.splice(requestedFormIndex, 1);
						numPasses--;

						if (numPasses > 0) {
							for (var i = 0; i < numPasses; i++) {
								// Update the form indexes and IDs.
								scope.controllerScope.dataModel[ i ].formID = 'theForm_' + i;
								scope.controllerScope.dataModel[ i ].formIndex = i;

								// Expand the first form.
								scope.controllerScope.dataModel[ i ].isCurrentTicket = (i == 0);
							}

							scope.fieldSettings.numPasses = numPasses;
						} else if (numPasses == 0) {
							// If we just deleted the last form, route to package details.
							if ($stateParams.packageId) {
								if (Package.preCartItems.length === 0) {
									$rootScope.routeTo(Enums.routes.DETAILS + '/' + $stateParams.packageId);
								}
							} else {
								$rootScope.routeTo(Enums.routes.LIST);
							}
						}
					}

					function saveDemographicsToCharacs() {
			 	Package.removeItemsToBeAddedMarkedForDeletion();
						var cartItems = splitCartItems();
						scope.cartItems = cartItems;
						Package.itemsToBeAdded = validArray(cartItems) ? cartItems : [];

						// Container to be used for passing formData to addOn function
						var passData = [];

						for (var i = 0; i < cartItems.length; i++) {
							// NOTE: We may need to separate each item.
							var item = cartItems[ i ];
							item.CHARACS = item.CHARACS || [];


							//for( var j = 0; j < scope.controllerScope.formCollection.length; j++ ){
							var formItemData = scope.controllerScope.formCollection[ i ].formData;
							passData.push(formItemData);
							//item.CHARACS[ 0 ] = item.CHARACS[ 0 ] || {};

							// If ph_aux_1 or ph_aux_2 exists and is empty. Call them
							// Guest
							if (scope.formOptions.showTwoGuests) {
								if ((formItemData.ph_aux_1 || '').trim().length === 0) {
									formItemData.ph_aux_1 = 'Guest';
								}
								if ((formItemData.ph_aux_2 || '').trim().length === 0) {
									formItemData.ph_aux_2 = 'Guest';
								}
							}

							// Iterate through each CHARAC and copy ph_ fields.
							for (var key in formItemData) {
								if (key.indexOf('ph_') > -1) {
									if (formItemData[ key ] != '' &&
								formItemData[ key ] != null &&
								formItemData[ key ] != undefined &&
								typeof formItemData[ key ] != undefined) {
										item.CHARACS[ 0 ][ key ] = formItemData[ key ];
									} else {
										item.CHARACS[ 0 ][ key ] = '';
									}
								}
							}

							// NOTE: The above loop copies fields with ph_. Any other fields should be manually added.
							// Ex: item.CHARACS[ 0 ].sampleProp1 = formItemData.sampleProp1;
							// Ex: item.CHARACS[ 0 ].sampleProp2 = formItemData.sampleProp2;

							item.CHARACS[ 0 ].ph_year = scope.packageDetails.season_pass_year;
							item.CHARACS[ 0 ].uid = Package.isEditing() ? item.CHARACS[ 0 ].uid : Utilities.guid();
							if (angular.isDefined(item.CHARACS[ 0 ].ph_province) && item.CHARACS[ 0 ].ph_province.length > 0) {
								item.CHARACS[ 0 ].ph_state = item.CHARACS[ 0 ].ph_province;
							}

							// Only capture the biometric acknowledgement if it's required for this merchant's season pass.
							if (Utilities.getBoolean(scope.fieldSettings.biometricsRequired.required)) {
								item.CHARACS[0].biometrics_required = Utilities.getBoolean(formItemData.biometrics_required) ? "yes" : "no";
							}

							// Add replaceMedia charac (if it exists)
							if (angular.isDefined(formItemData.replaceMedia)) {
								item.CHARACS[0].replaceMedia = Utilities.getBoolean(formItemData.replaceMedia) ? '1': '0';
							}

							// Overwrite birth date that may have been set in the condition above.
							var bDate = getFormattedBirthdate(formItemData);
							if (typeof(bDate) != 'undefined' && scope.fieldSettings.birthDate.visible) {
								item.CHARACS[ 0 ].ph_birth_date = bDate;

								// Ensures that birdays are set to the proper format due to PHD stating that they are not on occasion.
								// To test this fix uncomment below.
								// if( i == 0 ){ item.CHARACS[ 0 ].ph_birth_date = '0-01-31' }
								if (!bDayRegEx.test(item.CHARACS[ 0 ].ph_birth_date)) {
									scope.controllerScope.formCollection[ i ].formScope.birthDate.$invalid = true;
									scope.controllerScope.formCollection[ i ].formScope.birthDate.$valid = false;
									scope.controllerScope.formCollection[ i ].formScope.birthDate.$error.required = true;

									showFormByFormID(scope.controllerScope.formCollection[ i ].formID);
									return;
								}
							}
							//}
						}

						Seasonpass.pushSelectedAddOnPackages(cartItems, passData);

						// Add reference of XFC to CHARACs.
						ExtraFlow.addReferenceToCartItems(Seasonpass.xfcOptions.view, scope.cartItems, ExtraFlow.CLIENT_XFC_VIEW);
						ExtraFlow.addReferenceToCartItems(Seasonpass.xfcOptions.name, scope.cartItems, ExtraFlow.CLIENT_XFC_NAME);

						// Delegate control back to Seasonpass.
						Seasonpass.nextView();
					}

					function splitCartItems() {
						// TODO: Spliting takes place in LegacyCart. Remove dependency of this function if possible.
						var items = [];
						for (var i = 0; i < Package.itemsToBeAdded.length; i++) {
							for (var j = 0; j < Package.itemsToBeAdded[ i ].qty; j++) {
								var copy = JSON.parse(JSON.stringify(Package.itemsToBeAdded[ i ]));

								if (!Package.itemsToBeAdded[ i ].CHARACS[ j ].isSeasonPass) {
									continue;
								}

								delete copy.CHARACS;

								copy.qty = 1;
								copy.CHARACS = [Package.itemsToBeAdded[ i ].CHARACS[ j ] || {}];

								items.push(copy);
							}
						}

						return items;
					}

					function getFormattedBirthdate(formItemData) {
						// Ensure DOB (not age) is saved as expected from the back-end (YYYY-MM-DD).
						if (scope.fieldSettings.birthDate.required && scope.fieldSettings.birthDate.visible) {
							// Birthday is required. Extract the date but take into consideration the date format config.
							var dobObj = parseDateFromModel(formItemData);

							if (!dobObj) {
								return false;
							}

							// Months are zero based - add 1.
							dobObj.month++;

							if (String(dobObj.month).length == 1) {
								dobObj.month = '0' + String(dobObj.month);
							}

							if (String(dobObj.day).length == 1) {
								dobObj.day = '0' + String(dobObj.day);
							}

							return dobObj.year + '-' + dobObj.month + '-' + dobObj.day;
						}

						return undefined;
					}

					function saveOneBarcodeAddons() {
						// are we in one barcode mode

						// tell the Add On Directive to save data back to formData
						scope.$broadcast('saveData', { formHashKey: scope.formData.$$hashKey });
					}

					function makeCompAdjustmentsForDeletedForm(item, index) {
						// Determine if we are dealing with comps based on characs
						if (Utilities.safelyCheckPropertyOnObject('item.CHARACS.0', item)) {
							if (angular.isDefined(item.CHARACS[0].overrideCompQty)) {
								// TODO: This is the base pass - we need to adjust things before it is deleted
								swapBasePassForComp(item, index);
							}
							// This is a comp - adjust the overrideCompQty on base pass
							else if (angular.isDefined(item.CHARACS[0].flex_is_comp)) {
								for (var i=0; i < Package.itemsToBeAdded.length; i++) {
									// Find base pass and decrement overrideCompQty
									if (Utilities.safelyCheckPropertyOnObject('item.CHARACS.0.overrideCompQty', Package.itemsToBeAdded[i])) {
										Package.itemsToBeAdded[i].CHARACS[0].overrideCompQty--;
										break;
									}
								}
							}
						}
					}

					function swapBasePassForComp(item, index) {
						// 1) copy and decrement overrideCompQty because that is what we truly want to delete
						var newItem = angular.copy(item);
						newItem.CHARACS[0].overrideCompQty--;

						// 2) push into itemsToBeAdded immediately after the current basePass - this is so it will remain at the top in the UI
						Package.itemsToBeAdded.splice((index + 1), 0, newItem);

						// 3) formData
						var rateName = scope.controllerScope.dataModel[index].rateName,
							rateType = scope.controllerScope.dataModel[index].rateType;

						scope.controllerScope.dataModel[index+1].rateName = rateName;
						scope.controllerScope.dataModel[index+1].rateType = rateType;

						// 4) find the comp item (all will be together) and adjust - start from index after newly injected item (comps should always be after base pass)
						for (var i=(index+2); i < Package.itemsToBeAdded.length; i++) {
							// Find the comp or additional package
							if (angular.isDefined(Package.itemsToBeAdded[i].CHARACS[0].flex_is_comp) || angular.isDefined(Package.itemsToBeAdded[i].CHARACS[0].items_added_pkg_id_override)) {
								// If we have more than one, adjust the qty and characs
								if (Package.itemsToBeAdded[i].qty > 1) {
									// remove the last comp
									Package.itemsToBeAdded[i].CHARACS.pop();
									Package.itemsToBeAdded[i].qty--;
								}
								// Just trash it
								else {
									Package.itemsToBeAdded.splice(i, 1);
								}
								break;
							}
						}
					}

					/**
					 * Set Continue btn status
					 * @public
					 * @param {Boolean} status status
					 * @returns {undefined}
					 */
					function setContinueLoading(status) {
						scope.isContinueLoading = getBoolean(status);
					}

					/**
					 * Checks if email verification is configured
					 * @public
					 * @returns {Boolean} true if email verification is configured
					 */
					function isEmailVerificationEnabled() {
						var normalize = StringUtils.normalize;
						if (checkProp('AppData.settings.enableEmailVerificationOnSeasonPass', AppData, validString) && JSONValidator.validate('enableEmailVerificationOnSeasonPass', AppData.settings.enableEmailVerificationOnSeasonPass, true) && checkProp('Package.settings.name', Package, validString)) {
							return normalize(JSON.parse(AppData.settings.enableEmailVerificationOnSeasonPass)).split(',').indexOf(normalize(Package.settings.name)) !== -1;
						}
						return false;
					}

					/**
					 * Update on email change
					 * @public
					 * @param {String} email email
					 * @returns {undefined}
					 */
					function onEmailAddressChange(email) {
						scope.isEmailVerificationComplete = false;
						if (checkProp('scope.formData', scope, isRealObject) && validString(email)) {
							scope.formData.ph_email = email || '';
						}
					}

					/**
					 * On Email Verification Success
					 * @public
					 * @returns {undefined}
					 */
					function onEmailVerificationSuccess() {
						scope.isEmailVerificationComplete = true;
						if (scope.isContinueLoading) {
							scope.submitForm();
						}
					}

					/**
					 * On Email Verification Failed
					 * @public
					 * @returns {undefined}
					 */
					function onEmailVerificationFailed() {
						if (checkProp('scope.formData.ph_email', scope) && checkProp('scope.theForm.email', scope, isRealObject)) {
							scope.theForm.email.$setValidity('pattern', false);
							scope.isEmailVerificationComplete = false;
							scope.setContinueLoading(false);
						}
					}

					init();
				}
			}

			return dir;
		}
	)

/**
 * Simple directive to set the height of the panel so its the same heigh as the left columns
 */
angular.module('app')
	.directive
	('spHeight', function($timeout) {
		var directive =
		{
			link: function(scope, element) {
				function getOffsetHeight() {
					var leftHeight = angular.element(document.getElementById('sp-left-container'))[0];

					if (leftHeight && typeof(leftHeight) != 'undefined') {
						element.css({ 'min-height': Number(leftHeight.offsetHeight)+'px' })
					}
				}

				// Listen for orientation changes
				window.addEventListener("orientationchange", function() {
					getOffsetHeight()
				}, false);

				// Listen for resize changes
				window.addEventListener("resize", function() {
					if (window.innerWidth < 1020) {
						element.css({ 'min-height': '' })
					} else {
						getOffsetHeight()
					}
				}, false);

				element.ready(function() {
					$timeout(function() {
						getOffsetHeight()
					}, 100);
				})
			}
		}

		return directive;
	})

"use strict";

/**
 * Simple directive to set the height of the panel so its the same height as the left columns
 */
angular.module('app')
	.directive
	('spHeight', ['$timeout',
		function($timeout) {
			var directive =
			{
				link: function(scope, element) {
					function getOffsetHeight() {
						var leftHeight = angular.element(document.getElementById('sp-left-container'))[0];

						if (leftHeight && typeof(leftHeight) != 'undefined') {
							element.css({ 'min-height': Number(leftHeight.offsetHeight)+'px' })
						}
					}

					// Listen for orientation changes
					window.addEventListener("orientationchange", function() {
						getOffsetHeight()
					}, false);

					// Listen for resize changes
					window.addEventListener("resize", function() {
						if (window.innerWidth < 1020) {
							element.css({ 'min-height': '' })
						} else {
							getOffsetHeight()
						}
					}, false);

					element.ready(function() {
						$timeout(function() {
							getOffsetHeight()
						}, 100);
					})
				}
			}

			return directive;
		}]);

/**
 * @ngdoc function
 * @name app.directive:seasonPassRenewalOption
 * @description
 * # seasonPassRenewalOption
 * Directive of the app
 */
angular.module('app')
	.directive('seasonPassRenewalOption'
		, function(
			$filter
			, $rootScope
			, AppData
			, Enums
			, Language
			, Modal
			, Package
			, Seasonpass
			, Utilities
		) {
			return {
				restrict: 'AE',
				templateUrl: '/views/templates/seasonPassRenewalOption.html',
				scope:
			{
				pass: '=',
				fieldSettings: '=',
				deleteCurrentForm: '&',
				toggleNextRenewalStep: '&',
				checkSeasonPassNumberInPassData: '&'

			},

				link: function(scope, element, attrs) {
				//scope variables
					scope.i18n = Language;
					scope.packageName = Package.packageDetails.name;
					scope.dateOfBirthLocaleName = Enums.spRenewSearchOpts.DATEOFBIRTH;
					scope.phoneLocaleName = Enums.spRenewSearchOpts.PHONE;
					scope.streetLocaleName = Enums.spRenewSearchOpts.STREET;
					scope.lastNameLocaleName = Enums.spRenewSearchOpts.LASTNAME;
					scope.fullNameLocaleName = Enums.spRenewSearchOpts.FULLNAME;
					scope.packageSettings = angular.copy(Package.settings);
					scope.hideNewPassOption = Utilities.safelyCheckPropertyOnObject('Package.packageDetails.CHARACS.hideNewPassOption',
						Package,
						function(value) {
							return Utilities.getBoolean(value);
						});
					scope.renewalInfoButtonVerbiage = Utilities.safelyCheckPropertyOnObject('Package.packageDetails.CHARACS.renewalInfoButtonVerbiage', Package) ? Package.packageDetails.CHARACS.renewalInfoButtonVerbiage : '';
					scope.lookupNumber = '';


					//map the search options
					mapSearchOptions();


					/**
					 * handleOptionChanged - called from drop down to clear out the pass.verificationValue
					 */
					scope.handleOptionChanged = function() {
						resetPassValues();
					}

					/**
					 * selectRenewalOption method - used to select between offerings of new season pass or season pass renewal
					 * triggering certain behavior of form depending on selection
					 * @public
					 * @param isRenewal {boolean} - true if it is a renewal, false if not
					 */
					scope.selectRenewalOption = function(isRenewal) {
						scope.pass.renewalSelected = isRenewal;
					}

					/**
					 * showSeasonPassNumberModal - method to show modal that has season pass image on it to direct guests where
					 * to find their season pass number
					 */
					scope.showSeasonPassNumberModal = function() {
						Utilities.scrollPosition();
						Modal.displayModal(
							{
								category: 'Pass Help',
								action: 'View',
								label: 'Season Pass Number Location',
								title: Language.getLocale('SeasonPassRenewal', 'seasonPassNumberHelpTitle'),
								description: '<div class="center"><span class="sprite sprite-seasonpass"></span></div>',
								buttonFlags: [Enums.buttonFlags.OK]
							}
						);
					}

					/**
					 * showSeasonPassRenewalModal - method to show modal that has a help message to inform guests
					 * how to renew their season pass
					 */
					scope.showSeasonPassRenewalModal = function() {
						Modal.displayModal(
							{
								category: 'Help Modal',
								action: 'View',
								label: 'Help for Renewal',
								title: Language.getLocale('SeasonPassRenewal', 'seasonPassRenewalHelpTitle'),
								description: Language.getLocale('SeasonPassRenewal', 'seasonPassRenewalHelpMsg'),
								buttonFlags: [Enums.buttonFlags.OK]
							}
						);
					}

					/**
					 * showSeasonPassNewModal - method to show modal that has
					 */
					scope.showSeasonPassNewModal = function() {
						Modal.displayModal(
							{
								category: 'Help Modal',
								action: 'View',
								label: 'Help for New Passes',
								title: Language.getLocale('SeasonPassRenewal', 'seasonPassNewHelpTitle'),
								description: Language.getLocale('SeasonPassRenewal', 'seasonPassNewHelpMsg'),
								buttonFlags: [Enums.buttonFlags.OK]
							}
						);
					}

					/**
					 * verifyPassFromServer method - formulates backend request and calls GetRenewalSeasonPassInfo from server to verify pass
					 * @public
					 *
					 */
					scope.verifyPassFromServer = function() {
						scope.pass.submitted = true;
						if (scope.renewalLookupInfo.$valid) {
						//Check if the pass number has already been renewed in the cart and if so - display a modal letting guest no they can't renew
							if (Seasonpass.checkSeasonPassNumberRenewedInCart(scope.lookupNumber) || scope.checkSeasonPassNumberInPassData({ passNumber: scope.lookupNumber })) {
								Modal.displayModal(
									{
										category: 'Pass Renewal Error',
										action: 'Error',
										label: 'Season Pass Number Already Renewed ',
										title: Language.getLocale('SeasonPassRenewal', 'renewalAlreadyInCartErrorTitle'),
										description: Language.getLocale('SeasonPassRenewal', 'renewalAlreadyInCartErrorMsg'),
										buttonFlags: [Enums.buttonFlags.OK]
									}
								);
							} else {
								var request = {};
								switch (scope.pass.verificationOption.localeName) {
								case Enums.spRenewSearchOpts.LASTNAME:
								{
									request.last_name = scope.pass.verificationValue;
									break;
								}
								case Enums.spRenewSearchOpts.PHONE:
								{
									request.phone_number = scope.pass.verificationValue;
									break;
								}
								case Enums.spRenewSearchOpts.DATEOFBIRTH:
								{
									request.birth_date = Utilities.formatSetDateFormatToYYYY_MM_DD(scope.pass.verificationValue, AppData.settings.date_format);
									break;
								}
								case Enums.spRenewSearchOpts.STREET:
								{
									request.address = scope.pass.verificationValue;
									break;
								}
								case Enums.spRenewSearchOpts.FULLNAME:
								{
									request.first_name = scope.pass.verificationValueFirstName;
									request.last_name = scope.pass.verificationValueLastName;
									break;
								}
								}
								request.package_id = scope.pass.package_id;
								request.pass_number = scope.lookupNumber;
								if (angular.isDefined(scope.pass.season_pass_type)) {
									request.season_pass_type = scope.pass.season_pass_type;
								}

								Seasonpass.getSeasonPassRenewalInfo(request, Package.settings.renewalServiceCall, callbackPassVerified);
							}
						}
					}


					/**
					 * callbackPassVerified - callback to execute upon successful passholder verification
					 * @param data
					 */
					function callbackPassVerified(data) {
						scope.pass.pass_holder_status = data.pass_holder_status;
						scope.pass.ph_season_pass_number = data.seasonPassNumber;
						scope.pass.ph_address = data.address1;
						scope.pass.ph_birth_date = Utilities.formatYYYY_MM_DDToSetDateFormat(data.birthDate, 'MM/dd/yyyy');
						scope.pass.ph_city = data.city;
						scope.pass.ph_email = data.email;
						scope.pass.ph_first_name = data.firstName;
						scope.pass.ph_home_phone = data.homePhone;
						scope.pass.ph_last_name = data.lastName;
						scope.pass.ph_state = data.state;
						scope.pass.ph_zip = data.zip;
						scope.pass.ph_sex = ''; //we do not get gender yet
						scope.pass.ph_year = Package.packageDetails.season_pass_year;
						scope.pass.ph_park_passholder_id = (angular.isDefined(data.passholderId) ? data.passholderId : '');
						scope.pass.ph_park_passholder_id2 = (angular.isDefined(data.seasonPassId) ? data.seasonPassId : '');
						addRenewalVerificationCharacsToPass(data);
						scope.toggleNextRenewalStep({ incDecStep: 1 });
						$rootScope.hideSpinner();
					}

					/**
					 * mapSearchOptions method to parse search options from field settings and set it based on locale name
					 * Package.settings.searchOptions are preset with defaults if not specified in the SeasonPass
					 * so these will always be defined at this point
					 * @private
					 * @returns {[Array] search options for drop down}
					 */
					function mapSearchOptions() {
						if (Utilities.safelyCheckPropertyOnObject('packageSettings.searchOptions', scope.packageSettings)) {
							scope.packageSettings.searchOptions.forEach(function(item) {
								if (!Utilities.isEmpty(Language.getLocale('SeasonPassRenewal', item.localeName))) {
									item.localeValue = Language.getLocale('SeasonPassRenewal', item.localeName)
								} else {
									item.localeValue = item.localeName;
								}
							});
						}
					}

					/**
					 * addRenewalVerificationCharacsToPass - there are instances where a package charac can trigger checking of a
					 * value that may come back on the GetSeasonPassRenewalInfo
					 * @param data
					 */
					function addRenewalVerificationCharacsToPass(data) {
						Package.settings.renewalVerificationCharacs.map(function(item) {
							if (angular.isDefined(Package.packageDetails.CHARACS)
								&& angular.isDefined(Package.packageDetails.CHARACS[item.packageCharac])
								&& angular.isDefined(data[item.dataItem])) {
								scope.pass[item.dataItem] = data[item.dataItem];
							}
						}
						);
					}

					/**
					 * resetPassValues - reset the verification value and set pristine
					 */
					function resetPassValues() {
						scope.pass.verificationValue = "";
						scope.renewalLookupInfo.$setPristine();
					}
				}
			}
		});

/* eslint-disable strict */
angular
	.module('app')
	.directive('infoHours', function() {
		return {
			scope: {
				displayOnMenu: '@?',
				displayType: '@?',
				feedIndex: '@?',
				hideLegend: '@?',
				selectedDate: '='
			},
			templateUrl: "/views/templates/packageDetails/infoHoursTemplate.html",
			controller: function($rootScope, $attrs, $element, $scope, $filter, $uibModal, AccessoCalendarDataService, AnalyticsDataLayerService, AppData, FocusService, Language, Utilities, ParkHours, Package) {
				$scope.i18n = Language;
				$scope.loading = true;
				$element.attr('aria-busy', 'true');

				/**
				 * local scope to determine if the calendar is ready to be loaded
				 */
				$scope.ready = false;
				$scope.displayParkHoursOnMenu = Utilities.getBoolean($attrs.displayOnMenu);
				$scope.merchantName = '';
				$scope.localizedDate = '';
				$scope.longDate = '';
				$scope.expandParkHoursOnMenu = false;

				$scope.selectedDateObject = { selectedDate: undefined };

				/**
				 * Used when the accesso calendar date is selected
				 * @param {Date} date The selected date
				 * @returns {undefined}
				 */
				$scope.onCalendarSelectDate = function(date) {
					$scope.selectedDateObject.selectedDate = date;
					showDateInformation(date);
				};

				/**
				 * Opens the info hours modal
				 * @param {Event} $event The event
				 * @returns {undefined}
				 */
				$scope.openHoursModal = function($event) {
					var modal = $uibModal.open({
						scope: $scope,
						templateUrl: '/views/templates/packageDetails/infoHoursModal.html',
						windowClass: 'info-hours-modal-wrapper custom-modal'
					});
					modal.opened.then(function setModalFocus() {
						FocusService.setFocusToContainer('modal', $event.target);
					});
					modal.closed.then(function setModalFocus() {
						FocusService.setFocusToElement('open-hours-modal');
					});
				};

				// TODO: Roll out unified "Closed" approach to package details park hours as well to reduce needed 'ifs'
				$scope.showTheHours = function() {
					if ($scope.displayParkHoursOnMenu) {
						return (angular.isDefined($scope.selectedDateMap));
					} else {
						return (angular.isDefined($scope.selectedDateMap) && !Utilities.isEmpty($scope.selectedDateMap.parkHours));
					}
				};

				$scope.showTheWaterParkHours = function() {
					if (angular.isDefined($scope.selectedDateMap) && $scope.selectedDateMap.hasWaterPark) {
						return $scope.displayParkHoursOnMenu || !Utilities.isEmpty($scope.selectedDateMap.waterParkHours);
					}
					return false;
				};

				$scope.showAdditionalParkHours = function() {
					return (angular.isDefined($scope.selectedDateMap) && $scope.selectedDateMap.hasAdditionalPark && $scope.displayParkHoursOnMenu);
				};

				/**
				 * Returns the park hours title
				 * @function
				 * @name getParkHoursTitle
				 * @param {String} defaultTitle This is the merchant ID or overrided app config locale
				 * @return {String} The locale it use
				 */
				$scope.getParkHoursTitle = function(defaultTitle) {
					// Package override should come prior to merchant override
					if (Utilities.safelyCheckPropertyOnObject('Package.packageDetails.id', Package) && Language.localeExists('ParkHours', 'title_p_' + Package.packageDetails.id)) {
						return Language.getLocale('ParkHours', 'title_p_' + Package.packageDetails.id);
					// Then see if we have a merchant override
					} else if (Language.localeExists('ParkHours', 'title_m_' + AppData.merchantId)) {
						return Language.getLocale('ParkHours', 'title_m_' + AppData.merchantId);
					// Then see if we have an island override
					} else if (Language.localeExists('ParkHours', 'title')) {
						return Language.getLocale('ParkHours', 'title');
					}

					return defaultTitle;
				}

				function Initialize() {
					// The feedIndex specifies which set of park hours from the list of feed(s) to use.
					$scope.feedIndex = $attrs.feedIndex;
					$scope.loadedDates = {};
					$scope.hideParkHoursLegend = ($scope.hideLegend == 1 || $scope.hideLegend== "1");

					ParkHours
						.getParkHours()
						.then(function(data) {
							// Multiple feeds combine into one for side menu logic
							var menuUseCase = ParkHours.hasMultipleFeeds && $scope.displayParkHoursOnMenu;

							// Load the current hours feed into the service containers,
							// if displaying park hours in menu, combine the feeds into one
							// passing in 3rd param - true to fill in empty dates
							ParkHours.loadFeed($scope.feedIndex, menuUseCase, true);

							// Get the merchantName name from the service, which is really the feed name
							$scope.merchantName = $scope.getParkHoursTitle(ParkHours.feedName);

							// Setup additional feed name if using dual feed + additional feed setup
							$scope.additionalFeedName = Language.getLocale('ParkHours', 'title_additional_feed_m_' + AppData.merchantId);

							// Get the dates for the current feed from the service containers
							$scope.loadedDates = ParkHours.loadedDates;
							$scope.allowedDates = ParkHours.allowedDates;

							setupDisplay();

							$scope.accessoCalendarData = AccessoCalendarDataService.normalizeDataFromResponse(data, 'GetParkHours');

							// Keep $scope.ready outside of condition in order to show calendar in spite of not having days available (TT 20912).
							$scope.ready = true;
						}).finally(function() {
							$scope.loading = false;
							$rootScope.hideSpinner();

							$element.attr('aria-busy', 'false');
						});

					$scope.showParkNotice();
				}

				/**
				 * Check for parkHoursNotice locale, it it exists, show it on the view
				 * @function
				 * @public
				 * @return {undefined}
				 */
				$scope.showParkNotice = function() {
					if (Language.localeExists('ParkHours', 'parkHoursNotice' + '_m_' + AppData.merchantId) || Language.localeExists('ParkHours', 'parkHoursNotice')) {
						$scope.parkHoursNotice = Language.getLocaleWithSuffixAndFallback('ParkHours', 'parkHoursNotice', '_m_' + AppData.merchantId);
					}
				}

				/**
				 * Toggle park hours
				 * @public
				 * @returns {undefined}
				 */
				$scope.toggleParkHours = function() {
					$scope.expandParkHoursOnMenu = !$scope.expandParkHoursOnMenu;

					AnalyticsDataLayerService.triggerAnalyticsEvent(
						Utilities.generateEventData('Park Hours', 'click', 'Hamburger Menu - Expand')
					);
				};

				// Switch display types:
				// Regular display is the default.  This includes the calendar, park hours labels and open/closed status indicators
				// Min display is only enabled if the displayType value passed into the directive is 'min'.  This display only includes the park hours labels.
				function setupDisplay() {
					$scope.displayTypeRegular = false;
					$scope.displayTypeMin = false;
					$scope.displayTypeInfo = false;

					if (['min', 'info'].includes($scope.displayType)) {
						// The min/info display does not use a calendar
						// Therefore we have to get the selected date from
						// an external source and setup a watch on the external source
						$scope.$watch('selectedDate', function(newValue, oldValue) {
							if (angular.isUndefined(newValue)) {
								return;
							}
							showDateInformation(newValue);
						});

						// set the first date
						$scope.selectedDateObject.selectedDate = $scope.selectedDate;

						// enable the view
						if ($scope.displayType === 'min') {
							$scope.displayTypeMin = true;
						} else {
							$scope.displayTypeInfo = true;
						}
					} else {
						// The regular display has its own calendar
						// Therefore we can use the selected date from
						// its own scope.
						$scope.$watch('selectedDateObject.selectedDate', function(newValue, oldValue) {
							if (angular.isUndefined(newValue)) {
								return;
							}
							if (newValue instanceof Date) {
								showDateInformation(newValue);
								// Fire off event that the date has changed if user interacts with menu park hours
								if ($scope.displayOnMenu) {
									AnalyticsDataLayerService.triggerAnalyticsEvent(
										Utilities.generateEventData('Park Hours', 'click', 'Hamburger Menu - Change Date')
									);
								}
							}
						});

						// set first date
						$scope.selectedDateObject.selectedDate = ParkHours.firstOperationalDate;

						// enable the view
						$scope.displayTypeRegular = true;
					}
				}

				function getDateObjectByDate(date) {
					if (date instanceof Date) {
						var yearString = 'year' + date.getFullYear();
						var monthString = ParkHours.months[ date.getMonth() ];
						var dateString = Utilities.getDateByString(date.toString());

						if (Utilities.childDefined($scope.loadedDates, yearString + '.' + monthString + '.' + dateString)) {
							return $scope.loadedDates[ yearString ][ monthString ][ dateString ];
						}
					}

					return undefined;
				}

				function showDateInformation(date) {
					var dateObject = getDateObjectByDate(date);
					if (angular.isDefined(dateObject)) {
						$scope.selectedDateMap = getDateObjectByDate(date);
						$scope.localizedDate = $filter('date')(dateObject.dateObj, 'fullDate');
						$scope.longDate = $filter('date')(dateObject.dateObj, 'longDate');
					} else {
						$scope.selectedDateMap = undefined;
						$scope.localizedDate = '';
						$scope.longDate = '';
					}
				}

				Initialize();
			}
		};
	});

/**
 * Created by dsmith on 11/17/2014.
 */
angular.module('app')
	.directive('infoImage'
		, function(Language, Package, Utilities) {
			return {
				restrict: "EA",
				templateUrl: "/views/templates/packageDetails/infoImageTemplate.html",
				controller: function($scope, Language, Package, Utilities) {
					$scope.i18n = Language;

					$scope.infoImageText = "";

					$scope.sourceImageURL = "";

					function Initialize() {
						if (Utilities.childDefined(Package, 'packageDetails.CHARACS.imageTabURL')) {
							$scope.sourceImageURL = Package.packageDetails.CHARACS.imageTabURL;
						}

						if (Utilities.childDefined(Package, 'packageDetails.CHARACS.imageTabInfo')) {
							$scope.infoImageText = Package.packageDetails.CHARACS.imageTabInfo;
						}
					}

					Initialize();
				}
			};
		});

/**
 * @ngdoc function
 * @name shoplandApp.directive:fixNgTouchInput
 * @description
 * # fixNgTouchInput
 * Directive of the shoplandApp
 */
angular.module('app')
	.directive('fixNgTouchInput'
		, function() {
			return {
				restrict: 'A',
				scope: {},
				link: function(scope, elem, attr) {
					elem.on(attr.stopEvent, function(event) {
						event.stopPropagation();
					});
				}
			}
		});
/**
 * @ngdoc directive
 * @name app.directive:ngTouchstart
 * @description
 * # ngTouchstart
 * Directive to handle touchstart events in AngularJS
 * Usage: <div ng-touchstart="expression">...</div>
 */
angular.module('app')
	.directive('ngTouchstart', ['$parse', function($parse) {
		return {
			restrict: 'A',
			compile: function($element, attr) {
				var fn = $parse(attr.ngTouchstart, /* interceptorFn */ null, /* expensiveChecks */ true);

				return function ngEventHandler(scope, element) {
					element.on('touchstart', function(event) {
						var callback = function() {
							fn(scope, {$event: event});
						};

						if (scope.$root.$$phase) {
							scope.$evalAsync(callback);
						} else {
							scope.$apply(callback);
						}
					});
				};
			}
		};
	}]);

/**
 * @ngdoc directive
 * @name app.directive:ngTouchend
 * @description
 * # ngTouchend
 * Directive to handle touchend events in AngularJS
 * Usage: <div ng-touchend="expression">...</div>
 */
angular.module('app')
	.directive('ngTouchend', ['$parse', function($parse) {
		return {
			restrict: 'A',
			compile: function($element, attr) {
				var fn = $parse(attr.ngTouchend, /* interceptorFn */ null, /* expensiveChecks */ true);

				return function ngEventHandler(scope, element) {
					element.on('touchend', function(event) {
						var callback = function() {
							fn(scope, {$event: event});
						};

						if (scope.$root.$$phase) {
							scope.$evalAsync(callback);
						} else {
							scope.$apply(callback);
						}
					});
				};
			}
		};
	}]);

/**
 * @ngdoc directive
 * @name app.directive:ngTouchmove
 * @description
 * # ngTouchmove
 * Directive to handle touchmove events in AngularJS
 * Usage: <div ng-touchmove="expression">...</div>
 */
angular.module('app')
	.directive('ngTouchmove', ['$parse', function($parse) {
		return {
			restrict: 'A',
			compile: function($element, attr) {
				var fn = $parse(attr.ngTouchmove, /* interceptorFn */ null, /* expensiveChecks */ true);

				return function ngEventHandler(scope, element) {
					element.on('touchmove', function(event) {
						var callback = function() {
							fn(scope, {$event: event});
						};

						if (scope.$root.$$phase) {
							scope.$evalAsync(callback);
						} else {
							scope.$apply(callback);
						}
					});
				};
			}
		};
	}]);

/**
 * Created by ltischuk on 11/20/14.
 */
angular.module('app')
	.directive('dynamicLocale'
		, function(
			Language,
			Utilities,
			UtilsValidation
		) {
			return {
				restrict: 'E',
				transclude: true,
				scope: {
					localeTarget: '@',
					localeSection: '@',
					searchString: '@',
					excludeAfter: '@',
					hideFirstPart: '@',
					hideSecondPart: '@',
					transcludeClass: '@',
					suffix: "@",
					/**
					 * Boolean to assess whether or not to hide the transcluded model data if the search string replacement isn't in the locale
					 */
					hideTranscludedDataIfNoSearchString: '@'
				},
				template: '<span data-ng-show="firstPart && !hideFirstPart" data-ng-bind-html="firstPart"></span><span data-ng-hide="hideTranscludeData" class="{{transcludeClass}}" ng-transclude></span><span data-ng-show="secondPart && !hideSecondPart" data-ng-bind-html="secondPart">',
				link: function(scope) {
					scope.firstPart = '';
					scope.secondPart = '';
					scope.hideTranscludeData = false;

					if (UtilsValidation.isRealObject(Language[scope.localeSection])) {
						scope.localeText = Language.getLocaleWithSuffixAndFallback(scope.localeSection, scope.localeTarget, scope.suffix);
					} else {
						scope.localeText = '';
					}

					if (scope.excludeAfter && scope.localeText.indexOf(scope.excludeAfter) > -1) {
						scope.localeText = scope.localeText.substring(0, scope.localeText.indexOf(scope.excludeAfter));
					}
					var textItems = (angular.isDefined(scope.searchString) ? scope.localeText.split(scope.searchString) : []);
					if (textItems.length > 1) {
						scope.firstPart = textItems[0];
						scope.secondPart = textItems[1];
					} else {
						scope.firstPart = scope.localeText;
					}

					scope.hideTranscludeData = (Utilities.getBoolean(scope.hideTranscludedDataIfNoSearchString) && scope.localeText.indexOf(scope.searchString) === -1);
				}
			}
		}
	);

angular.module('app')
	.directive('setFieldOrderDirective', function(AppData, JSONValidator) {
		return {
			link: function(scope, element, attrs) {
				var namesContainerInverted = false;
				var setBillingLastBeforeFirstName = JSONValidator.validate('billing_last_before_first_name', AppData.settings.billing_last_before_first_name);

				init();

				function invertNamesContainer() {
					namesContainerInverted = true;
					var listItems = element.children();
					var reversed = Array.prototype.reverse.call(listItems);
					element.append(reversed);
				}

				function init() {
					if ((AppData.language == "ja-jp" || setBillingLastBeforeFirstName) && !namesContainerInverted) {
						invertNamesContainer();
					}
				}
			}
		}
	});
angular.module('ngCacheBuster', [])
	.config(['$httpProvider', function($httpProvider) {
		return $httpProvider.interceptors.push('httpRequestInterceptorCacheBuster');
	}])
	.provider('httpRequestInterceptorCacheBuster', function() {
		this.matchlist = [/.*partials.*/, /.*views.*/ ];
		this.logRequests = false;

		//Default to whitelist (i.e. block all except matches)
		this.black=false;

		//Select blacklist or whitelist, default to whitelist
		this.setMatchlist = function(list,black) {
			this.black = typeof black != 'undefined' ? black : false
			this.matchlist = list;
		};


		this.setLogRequests = function(logRequests) {
			this.logRequests = logRequests;
		};

		this.$get = ['$q', '$log', function($q, $log) {
			var matchlist = this.matchlist;
			var logRequests = this.logRequests;
			var black = this.black;
			if (logRequests) {
				$log.log("Blacklist? ", black);
			}

			return {
				'request': function(config) {
					//Blacklist by default, match with whitelist
					var busted= !black;

					for (var i = 0; i < matchlist.length; i++) {
						if (config.url.match(matchlist[i])) {
							busted=black;
							break;
						}
					}

					//Bust if the URL was on blacklist or not on whitelist
					if (busted) {
						var d = new Date();
						config.url = config.url.replace(/[?|&]cacheBuster=[^&]*/,'');
						//Some url's allready have '?' attached
						config.url += config.url.indexOf('?') === -1 ? '?' : '&'
						config.url += 'cacheBuster=' + window.version;
					}

					if (logRequests) {
						var log='request.url =' + config.url
						busted ? $log.warn(log) : $log.info(log)
					}

					return config || $q.when(config);
				}
			}
		}];
	});
angular
	.module('app')
	.factory('Utilities', function(
		$rootScope,
		$filter,
		$injector,
		$location,
		$log,
		$q,
		$state,
		$timeout,
		$urlService,
		$window,
		$http,
		$ocLazyLoad,
		$locale,
		Enums,
		FocusService,
		Security,
		RouteHistoryService,
		UtilsValidation
	) {
		"use strict";
		var utilities = {
			merge: Object.assign || angular.merge
		};

		/**
		 * @private
		 * @type {function}
		 */
		var ngIsString = angular.isString,
			validString = UtilsValidation.validString,
			validArray = UtilsValidation.validArray,
			isDate = angular.isDate,
			validObject = UtilsValidation.validObject;

		// US and Canadian postal code validation.
		utilities.US_POSTAL_CODE_RX = new RegExp(/(^\d{5}$)|(^\d{5}-\d{4}$)/);
		utilities.CA_POSTAL_CODE_RX = new RegExp(/^[ABCEGHJKLMNPRSTVXY]\d[ABCEGHJKLMNPRSTVWXYZ]( )?\d[ABCEGHJKLMNPRSTVWXYZ]\d$/i);
		utilities.DATE_YYYY_MM_DD = /(\d{4})-(\d{2})-(\d{2})/;

		utilities.groupByArrayProperties = groupByArrayProperties;
		utilities.replaceObjProperty = replaceObjProperty;
		utilities.replaceElementInArr = replaceElementInArr;

		/**
		 * Deprecated method for adding a script to the page
		 *
		 * @param {String} path 	the url for the script to add
		 * @see  addScriptToDocument
		 */
		utilities.addScript = function(path, async) {
			utilities.addScriptToDocument(path, Security.md5(path), undefined, (UtilsValidation.isBoolean(async) ? async : true), undefined);
		};

		utilities.scriptExists = function(path) {
			return !! document.getElementById(Security.md5(path));
		};


		/**
		 * Defines a computed property on an object.
		 * @public
		 * @function
		 * @name computed
		 * @param {Object} object The object to define the property on.
		 * @param {String} prop The property name to assign the computed property on
		 * @param {Function} fn The function used as the callback for the computed property
		 * @return {*} returns whatever you want
		 */
		utilities.computed = function(object, prop, fn) {
			Object.defineProperty(object, prop, {
				get: fn,
				set: function() {
					throw new Error('you cannot override computed property `' + prop + '`');
				}
			});
		};

		/**
		 * Method to write DOM objects to the parent window (for iframe only )
		 * @param {[type]} path [description]
		 */
		utilities.addDOToWindow = function(DOM) {
		//get the parent
			if (DOM.id) {
				var existing = window.parent.document.getElementById(DOM.id);
				if (existing) {
					existing.parentNode.removeChild(existing);
				}
			}

			var p = window.parent;
			p.document.body.appendChild(DOM);
		};

		utilities.doCommonUriParameterReplacements = function(uri, merchant, obj) {
			if (uri==undefined) {
				return undefined;
			}

			var knownReplacements = [
				{
					k: "client",
					v: merchant
				},
				{
					k: "email",
					v: obj.lastFour
				},
				{
					k: "phone",
					v: obj.phoneNumber
				},
				{
					k: "order",
					v: obj.orderId
				},
				{
					k: "cToken",
					v: obj.cToken
				},
				{
					k: "eToken",
					v: obj.eToken
				},
				{
					k: "oToken",
					v: obj.oToken
				},
				{
					k: "pToken",
					v: obj.pToken
				}
			];

			return knownReplacements.reduce(function(acc, x) {
				return acc.replace(new RegExp("\\{" + x.k + "\\}", "g"), x.v);
			}, uri);
		};

		/**
		 * IE9 does not support HTML5 urls without the hash so to properly provide redirect urls within IE9
		 * we must remove the hash
		 * @param url
		 * @returns {String} url without the /# section of the url
		 */
		utilities.removeHashFromUrlForIE9 = function(url) {
			return url.replace('/#', '');
		};

		/**
		 * method used to remove elements from DOM by ID
		 * @param  {[type]} id [description]
		 * @return {[type]}    [description]
		 * @todo move to Utilities Service
		 */
		utilities.removeElementByID = function(id) {
		// TODO: Abstract in Utilities.
			var element = document.getElementById(id);

			if (element) {
				element.parentNode.removeChild(element);
			}
		};

		/**
		 * Method to quickly spawn new elements and provide an ID or inner content.
		 * @param {String} element          div, center, i, span, etc...
		 * @param {String} id               the id string for this new element | undefined for no ID param.
		 * @param {array} children 					the inner content children as DOM objects in an array.
		 *
		 * @return {DOM Object} 						the newly created DOM object
		 */
		utilities.newElement = function(element, id, children) {
			var newElement = document.createElement(element);
			newElement.id = id;

			if (children && children.length > 0) {
				for (var i = children.length - 1; i >= 0; i--) {
					newElement.appendChild(children[i]);
				}
			}

			return newElement;
		};

		/**
		 * MEthod that sets all children of the ID provided to display=none
		 * @param  {[type]} parentId [description]
		 * @return {[type]}          [description]
		 */
		utilities.hideAllChildElems = function(parentId) {
			if (document.getElementById(parentId)) {
				var c = document.getElementById(parentId).children;
				for (var i = c.length - 1; i >= 0; i--) {
					try {
						c[i].style.display = "none";
					} catch (e) {
						console.log("unable to hide element...\n" + JSON.stringify(e));
					}
				}
			}
		};

		/**
		 * Method used to add a <script> tag to the DOM
		 * @param {String} path URL for sideloaded script to add
		 * @param {String} id   Name|ID for the script to add
		 * @param {String} id   Parent ID for adding to a specific element.
		 */
		utilities.addScriptToDocument = function(path, id, parent, async, innerHTMLContent, options) {
			var asPromise;

			options = UtilsValidation.isRealObject(options) ? options: {};

			if (options.asPromise) {
				asPromise = $q.defer();
			}

			if (document.getElementById(id)) {
				if (options.disableReinsert) {
					asPromise.resolve();
					return asPromise.promise;
				}
				utilities.removeElementByID(id);
			}

			var s = document.createElement('script');
			s.type = validString(options.type) ? options.type : 'text/javascript';
			s.async = (async !== undefined) ? async : 1;

			if (validString(options.subresourceIntegrity)) {
				s.integrity = options.subresourceIntegrity;
			}

			if (validString(options.crossorigin)) {
				s.crossOrigin = options.crossorigin;
			}

			if (path !== undefined && path !== null) {
				s.src = path;
			}

			if (id !== undefined) {
				s.id = id;
			}

			if (innerHTMLContent !== undefined) {
				s.innerHTML = innerHTMLContent;
			}

			if (options.asPromise) {
				s.onload = function() {
					asPromise.resolve();
				}

				s.onerror = function() {
					asPromise.reject();
				}
			}

			var x;
			if (parent !== undefined && parent !== "head") {
			//last index of body
				if (parent === -1 || parent === "body") {
					document.body.appendChild(s);
				} else {
					x = document.getElementById(parent);
					x.appendChild(s);
				}
			} else {
			//put it in the HEAD
				x = document.getElementsByTagName('script')[ 0 ];
				x.parentNode.insertBefore(s, x);
			}

			if (options.asPromise) {
				return asPromise.promise;
			}
		};

		/**
		 * Returns the value passed in. Useful when used as the last parameter of safelyCheckPropertyOnObject
		 * @param {*} value
		 * @returns {*} the value passed in
		 */
		utilities.returnValue = function(value) {
			return value;
		};


		/**
		 * Calculate the age given a date string
		 * @param dateString - a ISO8601 formatted date
		 * @param {Date} byDate an optional date to calulate age off of
		 * @returns {number}
		 */
		utilities.calculateAgeGivenDateString = function(dateString, byDate) {
		// calculate age
			// refactored to use dateStringToObject.
			var age = 0,
				date = isDate(byDate) ? byDate : new Date(),
				birthdate = utilities.dateStringToObject(dateString);
			if (angular.isUndefined(birthdate)) {
				return age;
			}
			age = date.getFullYear() - birthdate.getFullYear();
			if (birthdate.getMonth() > date.getMonth() || (birthdate.getMonth() == date.getMonth() && birthdate.getDate() > date.getDate())) {
				age = age - 1;
			}
			return age;
		};

		/**
		 * Method used to return the package name when the ID is provided.
		 * @param  {Number} packageId 	the accesso numeric package ID
		 * @param  {String} keyName 		a key on the standard accesso GetMerchantPackages.PS.P response
		 * @return {String}         		the packages[key] or 'undefined'
		 */
		utilities.getPackageKeyFromId = function(packageId, keyName, getMerchantPackageListData) {
			if (utilities.childDefined(getMerchantPackageListData, 'PS.P')) {
				var packages = getMerchantPackageListData.PS.P;
				for (var pkg in packages) {
					if (+packages[ pkg ].id === +packageId) {
						return packages[ pkg ][ keyName ];
					}
				}
			}

			return undefined;
		};

		/**
		 * This is a method used to replace @@variables for internal processing regarding analytics.
		 * This modifies a string value and replaces it with data from various sources, such as AppData
		 *
		 * @param  {String} inputString The string containing an @@variables for replacement
		 * @return {String}             The modified inputString value
		 */
		utilities.replaceInternalVars = function(inputString, appDataService) {
			inputString = inputString.replace(/@@keyword/ig, $rootScope.routeParams.keyword);
			inputString = inputString.replace(/@@packageName/ig, utilities.getPackageKeyFromId($rootScope.routeParams.packageId, 'name', appDataService.GetMerchantPackageList));

			//for post purchase
			if (appDataService.GuestViewOrder) {
				inputString = inputString.replace(/@@orderId/ig, appDataService.GuestViewOrder.VIEW_ORDER_REPLY.ORDER_STATUS_REPLY.order_id);
			}

			return inputString;
		};


		utilities.parseUrlParams = function(string) {
			var object = {};
			string.replace
			(new RegExp("([^?=&]+)(=([^&]*))?", "g")
				, function($0, $1, $2, $3) {
					object[$1] = $3;
				}
			);

			return object;
		};

		utilities.openAppStore = function(path) {
			if (path) {
				$window.open(path);
			}
		};

		utilities.stringifyURLParams = function(object) {
			var array = [];
			for (var p in object) {
				if (object.hasOwnProperty(p)) {
					array.push
					(encodeURIComponent(p)
					+ "=" + encodeURIComponent(object[p])
					);
				}
			}
			var string = array.join("&");
			return string;
		};

		/**
		 * Masking method for email address strings.
		 * Returns clean string of **** if it matches common email address patterns
		 * @ref http://en.wikipedia.org/wiki/Email_address
		 * @note DOES NOT allow for quotes (") in the string!
		 *
		 * @param  {string} data the string to be masked.
		 * @return {string}      the masked string of data
		 *
		 * @example in 			aj.seelund@accesso.com
		 * @example out 		**********************
		 */
		utilities.maskEmails = function(data) {
		//replace anything inside of a <tag> with nothing;
			data = data.replace(/<[\s\S]*?>/gi, "");

			//regex pattern to allow for mostly anything in an email address. better to be leniant than strict
			//@ref http://en.wikipedia.org/wiki/Email_address
			var emails = data.match(/[\w\d\._\-\+]+@([\.\w\d\[\]\:]{1,256})/gi);
			if (emails && emails.length > 0) {
				for (var i in emails) {
					var string = emails[i];
					var replacement = '';
					for (var j = 0; j < string.length; j++) {
						replacement += '*';
					}
					data = data.split(string).join(replacement);
				}
			}

			return data;
		};

		/**
		 * Returns an array of the English alphabet
		 *
		 * @return {Array}
		 */
		utilities.alphabet =
		(function() {
			var a = [];
			for (var i = 65; i <= 90; i++) {
				a[ a.length ] = String.fromCharCode(i);
			}

			return a;
		}
		)();

		utilities.correctFloatingPointError = function(number, precision) {
			precision = precision || 5;

			var correction = Math.pow(10, precision);
			return Math.round(correction * number) / correction;
		};

		/**
		 * A universal redirect/routing mechanism.
		 *
		 * @param {event} event that needs to no longer propagate in the DOM
		 * @return {null}
		 */
		utilities.stopEventPropagation = function(event) {
			event.preventDefault();
			if (event && event.stopPropagation) {
				event.stopPropagation();
			} else {
				window.event.cancelBubble = true;
			}
		};

		/**
		 * Merges an array of objects into a single object.
		 * @param  {array} objArray array of objects
		 * @return {object} a single object of all in array combined.
		 *
		 * @warning this will overwrite matching key names! (ex: objA[0] vs objB[0] )
		 *
		 */
		utilities.mergeObjects = function(objArray) {
			var output = {};

			for (var i = 0; i < objArray.length; i++) {
				for (var attrname in objArray[ i ]) {
					output[ attrname ] = objArray[ i ][ attrname ];
				}
			}

			return output;
		};

		/**
		 * Method to remove any obj properties that have a 0-length
		 * @param  {object} obj object to parse for empties
		 * @return {object}     the clean object
		 */
		utilities.removeEmptyValues = function(obj) {
			for (var k in obj) {
				if (obj[k] === null || obj[k] === "" || obj[k] === "undefined" || obj[k] === undefined) {
					delete obj[k];
				}
			}

			return obj;
		};

		/**
		 * Method to turn an object into an array
		 * @param  {object} object to turn into an array
		 * @return {array}    array
		 */
		utilities.objToArray = function(obj) {
			return [].map.call(obj, function(element) {
				return element;
			});
		}


		/**
		 * Verify a provided child object node and all parent nodes exist
		 *
		 * @param {object} object
		 * @param {string} name of child
		 * @return {null}
		 */
		utilities.childDefined = function(obj, child) {
			var result = true;
			try {
				if (angular.isUndefined(obj)) {
					result = false;
				}

				if (typeof obj == 'object' && typeof child == 'string') {
					var root = obj
					var nodes = child.split('.');
					for (var i=0; i < nodes.length; i++) {
						var node = nodes[i]
						if (root[node] && root.hasOwnProperty(node)) {
							root = root[node];
						} else {
							result = false;
							break;
						}
					}
				}
			} catch (e) {
				$log.error('Utilities.js : childDefined ' + e.message);
				result = false;
			}

			return result;
		};

		/**
		 * Parses a string into a date format
		 * @param {string} dateString
		 * @param {string} dConfig
		 * @returns {object|null} dateObj
		 */
		utilities.parseDate = function(dateString, dConfig, delimiter) {
			delimiter = ngIsString(delimiter) ? delimiter : '/';
			dConfig = ngIsString(dConfig) ? dConfig : 'MM/dd/yyyy';

			// If model is not defined, assume it's from this scope/
			if (typeof dateString === 'undefined' || (dateString || '').length === 0) {
				return null;
			}
			var dateConfig = dConfig.toLowerCase().split(delimiter);
			var dateArray = dateString.split(delimiter);

			var day = dateArray[ dateConfig.indexOf('dd') ];
			var month = dateArray[ dateConfig.indexOf('mm') ];
			var year = dateArray[ dateConfig.indexOf('yyyy') ];

			day = Number(day);
			month = Number(month) - 1;
			year = Number(year);

			return {
				day: day,
				month: month,
				year: year
			};
		};

		/**
		 * Backend often returns dates in YYYY-MM-DD format so this function will format the date
		 * @param dateStr in YYYY-MM-DD format
		 * @returns {String} date in the string as specified by format or the dateStr
		 */
		utilities.formatYYYY_MM_DDToSetDateFormat = function(dateStr, dateFormat) {
			if (angular.isDefined(dateStr) && angular.isDefined(dateFormat)) {
				var match = dateStr.match(utilities.DATE_YYYY_MM_DD);
				if (angular.isDefined(match) && angular.isArray(match) && match.length == 4) {
					dateStr = $filter('date')(new Date(Number(match[1]), Number(match[2] - 1), Number(match[3])), dateFormat);
				}
			}

			return dateStr;
		};

		/**
		 * Backend needs dates to be in YYYY-MM-DD format for some calls so this function will format the date
		 * @param dateStr to format
		 * @param dateFormat format of the date string
		 * @returns {String} formatted date
		 */
		utilities.formatSetDateFormatToYYYY_MM_DD = function(dateStr, dateFormat) {
			var dateObj = utilities.parseDate(dateStr, dateFormat);
			var dateStr = '';
			if (dateObj && !isNaN(dateObj.year) && !isNaN(dateObj.month) && !isNaN(dateObj.day)) {
				dateStr = $filter('date')(new Date(dateObj.year, dateObj.month, dateObj.day), 'yyyy-MM-dd');
			}

			return dateStr;
		};

		/**
		 * Returns a valid JavaScript date object from a MYSQL date format (YYYY/MM/DD)
		 * @param mysqlDateString
		 * @returns {Date}
		 */
		utilities.getJavaScriptDateFromMySQLDate = function(mysqlDateString) {
			return angular.isDefined(mysqlDateString) ? new Date(mysqlDateString.replace(/-/g, '/')) : new Date();
		}

		/**
		 * Get string indicating military or nonmilitary time format
		 * @param AppData object
		 * @return {string} time format
		 */
		utilities.getTimeFormat = function(settings) {
			return (angular.isDefined(settings) && utilities.getBoolean(settings.military_time)) ? 'HH:mm' : 'hh:mm a';
		};

		/**
		 * Adds hours and minutes to a JavaScript date object
		 * @param javaScriptDateObject
		 * @param timeString
		 */
		utilities.transformDateWithTimeFromTimeString = function(javaScriptDateObject, timeString) {
			if (angular.isDefined(javaScriptDateObject) && angular.isDefined(timeString)) {
				var javascriptDateCopyWithHours = angular.copy(javaScriptDateObject);
				var timePartsToCompare = timeString.replace(/(AM|PM)/g, '').split(':');
				if (timeString.indexOf('PM') > -1 && timePartsToCompare[0] != '12') {
					javascriptDateCopyWithHours.setHours(parseInt(timePartsToCompare[0]) + 12);
					javascriptDateCopyWithHours.setMinutes(parseInt(timePartsToCompare[1]));
				} else if (timeString.indexOf('AM') > -1 && timePartsToCompare[0] === '12') {
					javascriptDateCopyWithHours.setHours(0);
					javascriptDateCopyWithHours.setMinutes(parseInt(timePartsToCompare[1]));
				} else {
					javascriptDateCopyWithHours.setHours(timePartsToCompare[0]);
					javascriptDateCopyWithHours.setMinutes(parseInt(timePartsToCompare[1]));
				}

				return javascriptDateCopyWithHours;
			}

			return javaScriptDateObject;
		}

		/**
		 * Convert string with space delimitation to underscore delimitation
		 * @param {string} keyword
		 * @return {string} formatted keyword
		 */
		utilities.makeUnderscoreDelimited = function(keyword) {
			if (angular.isDefined(keyword)) {
				keyword = keyword.toLowerCase().split(' ').join('_');
			}
			return keyword;
		};

		/**
		 * Wrap the contents of a key in an array if defined and not an array
		 *
		 * @param {string} name of object key
		 * @return {null}
		 */
		utilities.arrayWrap = function(obj, child) {
			if (utilities.childDefined(obj, child)) {
				var parentObj;
				var root = obj;
				var nodes = child.split('.');
				var childNode = null;

				for (var i=0; i < nodes.length; i++) {
					childNode = nodes[ i ];
					parentObj = root;
					root = root[ childNode ];
				}

				parentObj[ childNode ] =
				angular.isArray(parentObj[ childNode ])
					? parentObj[ childNode ] : [parentObj[ childNode ]]
			}
		};

		/**
		 * Wrap an object within an array if it is not already an array
		 * @param item
		 * @returns {[*]}
		 */
		utilities.wrapObjectToArray = function(item, checkUndefined) {
			if (checkUndefined) {
				if (angular.isArray(item)) {
					return item;
				}

				if (angular.isUndefined(item)) {
					return [];
				}

				return [item];
			}

			return angular.isArray(item) ? item : [item];
		}

		/**
		 * Wrap a value to be an array, alias off wrapObjectToArray with checkUndefined set to true
		 * @alias wrapObjectToArray
		 * @param {*} item - The item to wrap
		 * @returns {*[]} - The item wrapped in an array
		 */
		utilities.toArray = function toArray(item) {
			return utilities.wrapObjectToArray(item, true);
		}

		/**
		 * Lock an object and all child objects with object.freeze()
		 *
		 * @param {event} event that needs to no longer propagate in the DOM
		 * @return {null}
		 */
		utilities.lockObject = function(obj) {
			var prop,
				propKey;
			Object.freeze(obj); // First freeze the object.
			for (propKey in obj) {
				prop = obj[propKey];
				if (!obj.hasOwnProperty(propKey) ||
				(typeof prop !== "object") ||
				Object.isFrozen(prop)) {
					continue;
				}
				utilities.lockObject(prop);
			}
		};

		/**
		 * A universal redirect/routing mechanism.
		 *
		 * @param {String} page URI of page, after the merchant string.
		 * @param {String} menu probably can be deprecated.
		 * @param {String} search text that can be added to the URI after the ?	mark.
		 * @param {String} stripParams to strip from the query string portion of the URL
		 * @param {Boolean} shouldReplaceRoute whether the route should be replaced in the window history
		 * (for scenarios where routing decisions are made upon initialization)
		 * @param {Boolean} disableScrollTo Disables scrolling to the top of the page
		 * @param {Object} urlParams Additional URL parameters to add to the URL in {key: value} format
		 * @return {undefined}
		 */
		utilities.routeTo = function(page, menu, search, stripParams, shouldReplaceRoute, disableScrollTo, urlParams) {
			var getParams = utilities.stripURLParams(stripParams),
				url = page;

			// Merge the URL params with the new properties
			if (angular.isDefined(urlParams)) {
				for (var key in urlParams) {
					if (urlParams.hasOwnProperty(key)) {
						getParams[key] = urlParams[key];
					}
				}
			}

			if (angular.isUndefined(page) || page === null) {
				page = url = '/';
			}

			if (angular.isDefined(page) && page[0] !== '/') {
				url = '/' + page;
			}

			menu = menu === undefined ? false : menu;
			search = search === undefined ? false : search;

			if (page == Enums.routes.CART) {
				if (!$rootScope.hasItemsInCart()) {
				// Alert is shown by function.
					return;
				}
			} else {
				if (page.indexOf(Enums.routes.ORDER_VIEW) > -1) {
				// The following line includes the search() to remove any data that could be left over from a paypal purchase.
					getParams = utilities.stripURLParams(stripParams);
				}
			}

			if ($rootScope.state.showMainMenu) {
				utilities.toggleMenu();
			}

			if (!disableScrollTo) {
				utilities.scrollPosition();
			}

			if (utilities.getBoolean(shouldReplaceRoute)) {
				RouteHistoryService.setDisableSaveOfRoute(true);
				$location.replace();
			} else {
				$rootScope.enable_pageview = true;
			}

			$location.path(decodeURIComponent(url)).search(getParams);
		};

		/**
		 * Route to a page. This is much different than routeTo() as it uses the $state.go functionality
		 * instead of the current way we handle it. Make sure you know what you're doing when using this.
		 * @public
		 * @param {String} stateName The state name. NOT THE FULL PATH. E.g. `camps-enrollment-account.profile` NOT `/camps-enrollment-account/Daily%20Tickets`
		 * @param {Object} [routeParams] The route param to use for the path
		 * @param {Boolean} [replaceState] If we should overwrite the current state in history instead of appending
		 * @param {Boolean} [reload] If we should reload the state
		 * @returns {undefined}
		 */
		utilities.goTo = function(stateName, routeParams, replaceState, reload) {
			var options = {};

			if (reload) {
				options.reload = reload;
			}

			// Is replaceState set?
			if (replaceState) {
				// Set the option to replace the state when routing
				options.location = 'replace';
			}

			// Access our new state that was based off the original
			$state.go(stateName, routeParams || {}, options);
		};

		/**
		 * Gets the state name and params based on a compiled URL
		 * @public
		 * @param {String} path - The path to get the state from
		 * @returns {Object|null} - The state and params, null otherwise
		 */
		utilities.getRouteFromUrl = function getRouteFromUrl(path) {
			// Get the match from the URL Service
			var match = $urlService.match({ path: path });

			// If there is no match
			if (match.rule.type === 'RAW') {
				// return null
				return null;
			}

			// Otherwise, we have amatch, so return the route and params
			return {
				route: match.rule.state,
				params: angular.copy(match.match),
			};
		};

		utilities.routeToExternal = function(path) {
			var target = document.body.dataset.qaRouteSameWindow === 'true' ? '_self' : '_blank';
			window.open(path, target);
		};


		utilities.isLeapYear = function(year) {
			year = Number(year);

			if (isNaN(year)) {
				return false;
			}

			return (year % 4 === 0) && ((year % 100 !== 0) || (year % 400 === 0));
		};

		utilities.stripURLParams = function(params) {
		// params: Array of URL param keys to delete.
			var getParams = $location.$$search;
			if (angular.isArray(params)) {
				for (var key in getParams) {
					for (var i = 0; i < params.length; i++) {
						if (key == params[ i ]) {
							delete getParams[ key ];
						}
					}
				}
			}

			return getParams;
		}

		/**
		 * Method used to determine if a value is contained within an array
		 * @param  {String}	value		needle
		 * @param  {Array} array		haystack
		 * @return {Boolean}			true | false
		 */
		utilities.inArray = function(value, array) {
			for (var i in array) {
				if (String(array[i]).toLowerCase() == String(value).trim().toLowerCase()) {
					return true;
				}
			}

			return false;
		}


		utilities.clearContents = function(element) {
			try {
				var node = $window.document.getElementById(element);
				while (node.hasChildNodes()) {
					node.removeChild(node.firstChild);
				}
			} catch (errror) {

			}
		}

		utilities.guid = function() {
			var s4 = function() {
				return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
			}
			return s4() + s4() + s4() + s4() + s4() + s4() + s4() + s4();
		}


		/**
	 * [getBoolean description]
	 * @param  {...*} value [description]
	 * @return {boolean}       [description]
	 *
	 * @todo		look at using !! inplace of this function
	 */
		utilities.getBoolean = function(value) {
			if (angular.isUndefined(value) || value === null) {
				return false;
			}

			if (typeof value != 'boolean') {
				switch (value.toString().toLowerCase()) {
				case 'true':
				case 'yes':
				case 'ok':
				case '1':
					value = true;
					break;

				case 'false':
				case 'no':
				case 'failed':
				case '0':
					value = false;
					break;

				default:
					value = Boolean(value).valueOf();
					break;
				}
			}

			return value;
		};

		/**
		 * A Universal String Conversion function
		 * @function
		 * @param {*} value - The value to convert to a string
		 * @returns {string} the converted value
		 */
		utilities.getString = function(value) {
			/**
			 * Removes bad values
			 * @function
			 * @private
			 * @param {string} value - String to check
			 * @returns {string} - The sanitized string
			 */
			function _checkBadValues(value) {
				return ['[object Object]'].indexOf(value) !== -1 ? '' : value;
			}

			if (ngIsString(value)) {
				return _checkBadValues(value);
			}

			switch (typeof value) {
			case 'number':
				if (isNaN(value)) {
					return '';
				}
			case 'boolean':
			case 'bigint':
				return value.toString();
			case 'object':
				if (value === null) {
					return '';
				}
			case 'function':
				return value.hasOwnProperty('toString') ? _checkBadValues(value.toString()) : '';
			}

			return '';
		}

		/**
	 * Method used mainly for google analytics referring hostname.
	 * @return {[type]} [description]
	 */
		utilities.getReferringHostname = function() {
			var isInIframe = (parent !== window),
				parentUrl = null;

			try {
				if (isInIframe) {
					if (document.referrer) {
						parentUrl = document.referrer.match(/([a-zA-Z0-9]([a-zA-Z0-9\-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,6}/)[0];
					} else {
						parentUrl = parent.document.referrer.match(/([a-zA-Z0-9]([a-zA-Z0-9\-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,6}/)[0];
					}
				} else {
					parentUrl	=	window.location.hostname;
				}
			} catch (e) {}


			return parentUrl;
		}

		utilities.isInIFrame = function() {
			return (parent !== window);
		}


		/**
		 * Checks that host is exactly domain, or a subdomain of domain
		 * @public
		 * @param {String} host - the host to check
		 * @param {String} domain - the domain host must match or be a subdomain of
		 * @returns {Boolean}
		 */
		utilities.isHostOrSubdomain = function(host, domain) {
			return host === domain || host.endsWith('.' + domain);
		};

		/**
	 * Method to get the merchant value from the URL
	 * @return {[type]} [description]
	 */
		utilities.getMerchant = function() {
			var merchant = $location.search()[Enums.urlParameters.merchant];

			try {
			//grab the m= GET param if it exists
				var host = $location.$$host.toLowerCase();
				if ((!utilities.isHostOrSubdomain(host, 'sixflags.com') || !utilities.isHostOrSubdomain(host, 'accesso.com')) && merchant) {
					return merchant.toUpperCase();
				} else {
					return window.location.host.split('.')[0].toUpperCase();
				}
			} catch (e) {
				return '';
			}
		};

		utilities.arrayUnique = function(array) {
			var a = array.concat();
			for (var i=0; i < a.length; ++i) {
				for (var j = i+1; j < a.length; ++j) {
					if (a[i] === a[j]) {
						a.splice(j--, 1);
					}
				}
			}
			return a;
		};
		/**
	 * Loop through an object to search if key exist
	 * @param value, string
	 * @param obj, object to search the string into
	 * @returns {boolean}
	 */
		utilities.objectKeyExists = function(value, obj) {
		// null and undefined are empty
			if (obj === null || angular.isUndefined(obj)) {
				return false;
			}
			var keyExists = false;
			Object.keys(obj).forEach(function(key) {
				if (key.toLowerCase() === value.trim().toLowerCase()) {
					keyExists = true;
				}
			});

			return keyExists;
		};

		utilities.arrayIntersection = function(x, y) {
			var ret = [];
			for (var i = 0; i < x.length; i++) {
				for (var z = 0; z < y.length; z++) {
					if (x[i] == y[z]) {
						ret.push(i);
						break;
					}
				}
			}
			return ret;
		};

		/*
	 * This function checks if an object is empty
	 *
	 * EXAMPLE USES:
	 * isEmpty("") // True
	 * isEmpty([]) // True
	 * isEmpty({}) // True
	 * isEmpty({length: 0, custom_property: []}) // True
	 * isEmpty("Hello") // False
	 * isEmpty([1,2,3]) // False
	 * isEmpty({test: 1}) // False
	 * isEmpty({length: 3, custom_property: [1,2,3]}) // False
	 */
		utilities.isEmpty = function(object) {
		// null and undefined are empty
			if (object === null || typeof(object) == 'undefined') {
				return true;
			}

			/*
			IE specifically will throw an error in the Object.keys() method
			if object is not of type Object.
			To avoid this, we can add a simple condition for strings.
		 */
			if (typeof(object) == 'string') {
				return object.length === 0;
			}

			// Assume if it has a length property with a non-zero value
			// that that property is correct.
			if (Object.keys(object).length && Object.keys(object).length > 0) {
				return false;
			}
			if (Object.keys(object).length === 0) {
				return true;
			}
			for (var key in object) {
				if (hasOwnProperty.call(object, key)) {
					return false;
				}
			}
			// Doesn't handle toString and toValue enumeration bugs in IE < 9
			return true;
		};


		/**
	 * Toggles the menu
	 * @return {[type]} [description]
	 */
		utilities.toggleMenu = function() {
			$rootScope.state.showMainMenu = !$rootScope.state.showMainMenu;
			$rootScope.state.showSubMenuTopBar = false; // Hide the top bar nav menu's submenu if it was left open.

			if ($rootScope.state.showMainMenu) {
				FocusService.setFocusToContainer('mainMenu', document.activeElement);
			} else {
				FocusService.setFocusToTriggeringElement();
			}
		};

		var setTransitionEvents = (function() {
			var handler = ['webkitTransitionEnd', 'oTransitionEnd', 'transitionend']
			var isSupported = null,
				protoKeys = null,
				key = null,
				testEvent = null;

			for (var i in handler) {
				testEvent = handler[ i ].trim();
				if (isSupported === null) {
					if ($window.__proto__) {
						protoKeys = Object.keys($window.__proto__);

						for (var c = protoKeys.length - 1; c >= 0; c--) {
							key = protoKeys[ c ];
							if (key.toLowerCase() === testEvent.toLowerCase() || key.toLowerCase() === 'on' + testEvent.toLowerCase()) {
								isSupported = testEvent;
							}
						}
					}
				}
			}

			return isSupported;
		})();

		/**
	 * gets an object
	 * @param  {[type]} name [description]
	 * @return {[type]}      [description]
	 * @todo  someone was working to create ability to gather js data-attributes. @see the if(){}else{} block
	 */
		utilities.getObject = function(name) {
			var n = name.substr(0, 4),
				value = [];

			if (n == 'data') {
				var allElements = angular.element(document);
			// @todo, find out what this is suppose to do and finish implementation
			// for (var i = 0; i < allElements.length; i++){
			// }
			} else {
				switch (name[0]) {
				case '#':
					value = angular.element(document.getElementById(name.substring(1)));
					break;
				case '.':
					value = angular.element(document.getElementsByClassName(name.substring(1)));
					break;
				default:
					value = angular.element(document.getElementsByTagName(name));
					break;
				}
			}

			return value;
		};


		/**
	 * Set the position of the window back to top
	 * This is currently being used in routeTo()
	 */
		utilities.scrollPosition = function() {
			$window.scrollTo(0, 0);
		};

		/**
	 * Finds offset of given element relative to the window
	 */
		utilities.getScrollPosition = function(element) {
			var xPosition = 0;
			var yPosition = 0;

			var windowHeight = Math.max(
				document.body.scrollHeight,
				document.body.offsetHeight,
				document.documentElement.clientHeight,
				document.documentElement.scrollHeight,
				document.documentElement.offsetHeight
			);
			var scrollHeight = windowHeight - window.innerHeight;

			do {
				yPosition += element.offsetTop || 0;
				xPosition += element.offsetLeft || 0;
				element = element.offsetParent || element.parentNode;
			} while (element);

			yPosition = Math.round(scrollHeight * (yPosition / windowHeight));

			return {
				x: xPosition,
				y: yPosition
			};
		};

		utilities.getFirstInvalidField = function(obj) {
			var name = undefined;
			for (var item in obj) {
				if (obj[item].$name) {
					name = obj[item].$name;
					break;
				}
				if (angular.isObject(obj[item])) {
					return utilities.getFirstInvalidField(obj[item]);
				}
			}
			return name;
		};

		function isWindow(obj) {
			return obj && obj.document && obj.location && obj.alert && obj.setInterval;
		}


		function isScope(obj) {
			return obj && obj.$evalAsync && obj.$watch;
		}

		utilities.copyObject = function(source, destination) {
			if (isWindow(source) || isScope(source)) {
				throw Error("Can't copy Window or Scope");
			}

			if (!destination) {
				destination = source;
				if (source) {
					if (angular.isArray(source)) {
						destination = utilities.copyObject(source, []);
					} else if (isDate(source)) {
						destination = new Date(source.getTime());
					} else if (angular.isObject(source)) {
						destination = utilities.copyObject(source, {});
					}
				}
			} else {
				if (source === destination) {
					throw Error("Can't copy equivalent objects or arrays");
				}

				if (angular.isArray(source)) {
					destination.length = 0;

					for (var i = 0; i < source.length; i++) {
						destination.push(utilities.copyObject(source[i]));
					}
				} else {
					angular.forEach(destination, function(value, key) {
						delete destination[key];
					});

					for (var key in source) {
						if (source.hasOwnProperty(key) && key.substr(0, 2) !== '$$') {
							destination[key] = utilities.copyObject(source[key]);
						}
					}
				}
			}

			return destination;
		};

		utilities.preventDefault = function(event) {
			event.preventDefault();

			if (event && event.stopPropagation) {
				event.stopPropagation();
			} else {
				var e = window.event;
				e.cancelBubble = true;
			}
		};

		utilities.getYear = function() {
			var d = new Date(); return d.getFullYear();
		};


		/**
	 *
	 * @param date {string}
	 * @returns {string}
	 */

		utilities.getDateByString = function(dt) {
			var date = new Date(dt);

			var dayStr,
				monthStr,
				currentDateString;

			dayStr = String(date.getDate());
			dayStr = (dayStr.length == 1) ? String('0' + dayStr) : dayStr;

			monthStr = String(date.getMonth() + 1);
			monthStr = (monthStr.length == 1) ? String('0' + monthStr) : monthStr;

			currentDateString = date.getFullYear() + '-' + monthStr + '-' + dayStr;

			return currentDateString;
		}

		utilities.getMonth = function(dt) {
			var date = new Date(dt);
			return String(date.getMonth() + 1);
		}

		utilities.getShortMonth = function(monthNum, settings) {
			var months = [];
			if (angular.isDefined($locale)) {
				months = $locale.DATETIME_FORMATS.SHORTMONTH
			}
			if (angular.isDefined(settings.shortMonths)) {
				months = settings.shortMonths.split(",");
			}

			return months.length >= monthNum ? months[monthNum] : '';
		};

		utilities.getDayOfWeekString = function(dt) {
			var date = new Date(dt);
			var daysOfWeek = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday']
			return daysOfWeek[String(date.getDay())];
		}

		utilities.getDayOfWeek = function(dt) {
			var date = new Date(dt);
			return date.getDay();
		}

		utilities.getDay = function(dt) {
			var date = new Date(dt);
			return String(date.getDate());
		}

		/**
	 * Expects a date string in YYYY-MM-DD
	 * @param string dateString string in YYYY-MM-DD format
	 * @return date Date object
		*/
		utilities.dateStringToObject = function(dateString, timeString) {
			if (angular.isUndefined(timeString)) {
				timeString = "12:00 PM";
			}

			if (!validString(dateString) || dateString.length < 8) {
				return undefined;
			}

			var dateArray = dateString.split('-'),
				mm = utilities.forceInt(dateArray[1]),
				dd = utilities.forceInt(dateArray[2]),
				yyyy = utilities.forceInt(dateArray[0]);

			if (mm<1 || mm>12 || dd<1 || dd>31 || yyyy<1000) {
				return undefined;
			}

			var dateObject = new Date(yyyy, mm - 1, dd);

			var time = timeString;
			var hour = 0;
			var minute = 0;

			time = time.replace(' ', '');
			time = time.replace('AM', '');

			var timeArray = time.split(':');
			if (timeArray.length > 0) {
				if (timeArray[1].indexOf('PM') > -1) {
					timeArray[1] = timeArray[1].replace('PM', '');
					if (Number(timeArray[0]) != 12) {
						timeArray[0] = Number(timeArray[0]) + 12;
					}
				}

				minute = Number(timeArray[1]);
			}

			hour = Number(timeArray[0]);

			dateObject.setHours(hour, minute, 0, 0);
			return dateObject;
		};


		/**
		 * Get a list of dates (Javascript Date Objects) for the given month
		 * If no month is provided, the default list will be the current month and a list of dates starting with todays date
		 * @returns {Array}
		 */
		utilities.getListOfDatesForMonth = function(monthsAheadOrBehind) {
			var dateList = [];
			var minDate = new Date();
			var maxDate = undefined;

			if (angular.isDefined(monthsAheadOrBehind) && monthsAheadOrBehind > 0) {
				minDate.setDate(1);
				minDate.setMonth(new Date().getMonth() + monthsAheadOrBehind);

				maxDate = new Date(minDate);
				maxDate.setMonth(minDate.getMonth() + 1);
				maxDate.setDate(0);
			} else {
				maxDate = new Date(minDate.getFullYear(), minDate.getMonth() + 1, 0);
			}

			var tempDate = minDate;
			var dateForList;

			while (tempDate <= maxDate) {
				dateForList = new Date(tempDate);
				dateForList.setHours(12, 0, 0, 0); //the format our date modules use to represent the current time
				dateList.push(dateForList.getTime());
				tempDate.setDate(dateForList.getDate()+1); // add one day
				tempDate.setHours(0, 0, 0, 0);//set to 0 so that we include the maxDate (which has time that defaults to 0,0,0,0)
			}

			return dateList;
		}

		utilities.getDaysInMonth = function(year, month) {
			return new Date(utilities.forceInt(year), utilities.forceInt(month), 0).getDate();
		};

		/**
		 * Retrieve a list of dates in ms format for one year from today
		 * @returns {Array}
		 */
		utilities.getListOfDateMsForOneYearFromToday = function() {
			var allowedDates = [];
			var minDate = new Date();
			var maxDate = new Date();
			maxDate.setYear(minDate.getFullYear() + 1);

			var currentDate = new Date();
			var d;

			while (currentDate <= maxDate) {
				d = new Date(currentDate);
				d.setHours(12, 0, 0, 0);
				allowedDates.push(d.getTime());
				currentDate.setDate(d.getDate()+1); // add one day
			}

			return allowedDates;
		}

		/**
		 * Calculate the difference in days between 2 dates
		 * @param d1
		 * @param d2
		 * @returns {number}
		 */
		utilities.getNumberOfDaysBetweenTwoDays = function(d1, d2) {
			var diff = Math.abs(d1.getTime() - d2.getTime());
			return parseInt(diff / (1000 * 60 * 60 * 24));
		}

		/**
	 * Returns the result of supported window.location.origin or equivalent if not supported
	 * (IE currently only browser that does not support)
	 */
		utilities.getWindowLocationOrigin = function() {
			return window.location.origin ? window.location.origin : window.location.protocol
			+ "//" + window.location.hostname
			+ (window.location.port ? ':'
				+ window.location.port: '');
		}


		/**
	 * capitalizeFirst - capitalize the first letter in a single string
	 * @param str
	 * @ return str with first letter capitalized
	 */
		utilities.capitalizeFirst = function(str) {
			if (angular.isDefined(str) && angular.isString(str) && str.length >0) {
				str = str.substring(0, 1).toUpperCase() + str.substring(1);
			}
			return str;
		}

		/**
	 * Matches the Route Parameter Keyword to a list of menu items and pulls the label
	 * from the matching item.
	 *
	 * @param {array} menuItem - Array of objects that make up the menu
	 * @param {string} rPKeywords - The keyword that is parsed from the URL
	 * @returns {string}
	 *
	 */

		utilities.getKeywordByUrl = function(menuItem, rPKeywords) {
			// If menuItem is null, use the AppData menuItems
			if (menuItem === null) {
				menuItem = $injector.get('AppData').GetApplicationConsolidated.TREE.MENUITEM;
			}

			// Testing to see if the parameters exist.
			if (!rPKeywords || !menuItem) {
				return 'undefined';
			}

			// Recursively searches all levels of menu nesting for a keyword match,
			// returning the label of the deepest matching item found.
			function searchItems(items) {
				for (var i = 0; i < items.length; i++) {
					var item = items[i];
					// Recurse into children first so the deepest match takes precedence
					if (typeof item.MENUITEM !== 'undefined') {
						var childResult = searchItems(item.MENUITEM);
						if (childResult !== '') {
							return childResult;
						}
					}
					// Check this item's own keywords
					if (item.keywords && item.keywords.toLowerCase().indexOf(rPKeywords.toLowerCase()) > -1) {
						return item.label;
					}
				}
				return '';
			}

			return searchItems(menuItem);
		}

		utilities.toOrderPreservingArray = function(a) {
			var copy = JSON.parse(JSON.stringify(a));
			copy.forEach(function(e, idx) {
				e._orderIdx=idx;
			});
			return copy;
		};

		utilities.finalizeArraysForEditing = function(a1, a2) {
			var finalArray = [];
			var insert = a2.shift();
			var temp = a1.concat(a2);

			temp.splice.apply(temp, [insert._orderIdx, 0].concat(insert));
			temp.forEach(function(ele, index) {
			// Remove this since it's no longer needed
				if (angular.isDefined(ele._orderIdx)) {
					delete ele._orderIdx;
				}
				// Reset one barcode packages
				if (angular.isDefined(ele.oneBarcodePackages)) {
					ele.oneBarcodePackages = [];
				}
				// Remove the edit flag
				if (angular.isDefined(ele.isEditMode)) {
					delete ele.isEditMode;
				}
				finalArray.push(ele);
			});

			return finalArray;
		};

		/**
	 * Safely check a property on an object. If the property is undefined, this function returns false.
	 * @function
	 * @name safelyCheckPropertyOnObject
	 * @param {String} prop - A string representing a property to check
	 * @param {Object} obj - The object to check
	 * @param {Function|String|*[]} [shouldSatisfy] - A callback function or a string referencing a function name in Utilities or UtilsValidation
	 */
		utilities.safelyCheckPropertyOnObject = function(prop, obj, shouldSatisfy) {
			var parts,
				theProperty,
				callbackArgs = [];

			// Accepts shouldSatify as an array e.g. ['replaceObjProperty', 'search', 'replace']
			// First value in the array should be of type function, or string (that is the function name located in utilities/utilsvalidation)
			// All other values in the array will be treated as arguments in the referenced function starting from parameter 2
			// The first parameter will be the result of this function
			if (validArray(shouldSatisfy)) {
				if (shouldSatisfy.length > 1) {
					callbackArgs = utilities.wrapObjectToArray(shouldSatisfy.slice(1), true);
				}

				shouldSatisfy = shouldSatisfy[0];
			}

			if (validString(shouldSatisfy) && (utilities[shouldSatisfy] || UtilsValidation[shouldSatisfy])) {
				shouldSatisfy = utilities[shouldSatisfy] || UtilsValidation[shouldSatisfy];
			}

			if (!angular.isFunction(shouldSatisfy)) {
				shouldSatisfy = function() {
					return true;
				};
			}

			// get the object, MINUS the leading property
			parts = prop.split('.').reverse();

			parts.pop();

			theProperty = (function propExists(obj, parts) {
				var nextPart;

				if (obj == undefined) {
					return undefined;
				}

				if (parts.length==0) {
					return obj;
				}

				nextPart = parts.pop();

				if (/[\w\n]\[\]$/.test(nextPart)) {
					return propExists(utilities.wrapObjectToArray(obj[nextPart.slice(0, -2)], true), parts);
				}

				return propExists(obj[nextPart], parts);
			}(obj, parts));

			return theProperty !== undefined && shouldSatisfy.apply(theProperty, [theProperty].concat(callbackArgs));
		};

		/**
		 * To easily reference a common name for this same function
		 * @alias utilities.safelyCheckPropertyOnObject
		 */
		utilities.checkProp = utilities.safelyCheckPropertyOnObject;

		/**
		 * Checks a series of properties on the supplied object and returns the first value that exists on the set
		 * @example Utilities.getFirstValue(someObj, 'val') - returns someObj.val if set, null otherwise
		 * @example Utilities.getFirstValue(someObj, 'val', 'subProperty1.val', 'differentProperty', ...)
		 * @function
		 * @name getFirstValue
		 * @param {Object} obj The object to grab values from
		 * @param {...String} prop All parameters after object are the string properties to check
		 * @returns {*|null} returns the first available value, null otherwise
		 */
		utilities.getFirstValue = function getFirstValue(obj) {
			var props = [].slice.call(arguments, 1),
				i = 0;

			// Was the function supplied with an object?
			// Was the function supplied with property arguments?
			if (!UtilsValidation.isRealObject(obj) || !validArray(props)) {
				// If not, return null
				return null;
			}

			// Iterate through the properties
			for (; i < props.length; i++) {
				// Is the argument is a valid string AND a proper chain on the object?
				if (validString(props[i]) && utilities.safelyCheckPropertyOnObject('obj.' + props[i], obj)) {
					// Grab the value and return it
					return utilities.safelyCheckPropertyOnObject('obj.' + props[i], obj, 'returnValue');
				}
			}

			// No property was found, return null
			return null;
		}

		/**
		 * Method used to convert a string to sentence case ('this is my tile' outputs 'This Is My Title')
		 * @param {String} string to convert to sentence case
		 */
		utilities.toTitleCase = function(str) {
			return str.replace(
				/\w\S*/g,
				function(txt) {
					return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
				}
			);
		}

		/**
		 * Public Method exposes private selectorExists() method.
		 * it will return true, otherwise false.
		 * @param {String} selector
		 */
		utilities.selectorExist = function(selector) {
			return selectorExists(selector);
		}

		/**
		 * Method used to get and cache all the classes defined in CSS,
		 * Returns collection of all the CSS selectors.
		 */
		function getAllSelectors() {
			var ret = [];

			if (!utilities.styleSelectors) {
				for (var i = 0; i < document.styleSheets.length; i++) {
					var rules = document.styleSheets[i].rules || document.styleSheets[i].cssRules;
					for (var x in rules) {
						if (typeof rules[x].selectorText == 'string') {
							ret.push(rules[x].selectorText);
						}
					}
				}
			} else {
			// Return cached selectors.
				return utilities.styleSelectors;
			}

			// Caches the selectors on first run.
			utilities.styleSelectors = ret;
			return ret;
		}

		/**
		 * Private Method used to verify a CSS selector exists. If .myCssClass is defined in the CSS,
		 * it will return true, otherwise false.
		 * @param {String} selector
		 */
		function selectorExists(selector) {
			var selectors = getAllSelectors();
			return selectors.indexOf(selector) > -1;
		}

		/**
		 * a container object for debugging functions
		 * @type {Object}
		 */
		var debugs = {};

		/**
		 * Development use only!
		 * Method to inject XFCs into the extra_movie list for any package, before or after an index.
		 * @param  {object} pkg            	the package object
		 * @param  {array} injectionArray  	an array of string values. ex: ['xfc_name_1','xfc_name_2']
		 * @param  {string} matchXfc       	the string name of the xfc key
		 * @param  {string} insertPosition 	'before' | 'after'
		 * @return {object}                	the altered package data
		 */
		debugs.injectTestXFC = function(pkg, injectionArray, matchXfc, insertPosition) {
			if (!$rootScope.develop) {
				return pkg;
			}

			if (pkg.extra_movie && pkg.extra_movie.indexOf(matchXfc) > -1) {
				var currentXfcs = pkg.extra_movie.split(',');

				pkg.extra_movie = injectionArray

				for (var i = currentXfcs.length - 1; i >= 0; i--) {
					if (currentXfcs.indexOf(currentXfcs[i]) == -1) {
						if (insertPosition == 'after') {
							pkg.extra_movie.unshift(currentXfcs[i]);
						} else if (insertPosition == 'before') {
							pkg.extra_movie.push(currentXfcs[i]);
						}
					} else {
						pkg.extra_movie = currentXfcs.join(',');
						return pkg;
					}
				}

				pkg.extra_movie = pkg.extra_movie.join(',');
			}

			return pkg;
		};

		utilities.findOne = function(ar, what) {
			var f = function(predicate) {
				if (this == null) {
					throw new TypeError('Array.prototype.find called on null or undefined');
				}
				if (typeof predicate !== 'function') {
					throw new TypeError('predicate must be a function');
				}
				var list = Object(this);
				var length = list.length >>> 0;
				var thisArg = arguments[ 1 ];
				var value;

				for (var i = 0; i < length; i++) {
					value = list[ i ];
					if (predicate.call(thisArg, value, i, list)) {
						return value;
					}
				}

				return undefined;
			}.bind(ar);

			return f(what);
		};

		utilities.escapeHtmlEntities = function(text) {
			if (angular.isUndefined(text)) {
				return '';
			}
			return text.replace(/[\u00A0-\u2666<>\&]/g, function(c) {
				return '&' +
				(utilities.entityTable[c.charCodeAt(0)] || '#'+c.charCodeAt(0)) + ';';
			});
		};

		// all HTML4 entities as defined here: http://www.w3.org/TR/html4/sgml/entities.html
		utilities.entityTable = {
			34: 'quot',
			38: 'amp',
			39: 'apos',
			60: 'lt',
			62: 'gt',
			160: 'nbsp',
			161: 'iexcl',
			162: 'cent',
			163: 'pound',
			164: 'curren',
			165: 'yen',
			166: 'brvbar',
			167: 'sect',
			168: 'uml',
			169: 'copy',
			170: 'ordf',
			171: 'laquo',
			172: 'not',
			173: 'shy',
			174: 'reg',
			175: 'macr',
			176: 'deg',
			177: 'plusmn',
			178: 'sup2',
			179: 'sup3',
			180: 'acute',
			181: 'micro',
			182: 'para',
			183: 'middot',
			184: 'cedil',
			185: 'sup1',
			186: 'ordm',
			187: 'raquo',
			188: 'frac14',
			189: 'frac12',
			190: 'frac34',
			191: 'iquest',
			192: 'Agrave',
			193: 'Aacute',
			194: 'Acirc',
			195: 'Atilde',
			196: 'Auml',
			197: 'Aring',
			198: 'AElig',
			199: 'Ccedil',
			200: 'Egrave',
			201: 'Eacute',
			202: 'Ecirc',
			203: 'Euml',
			204: 'Igrave',
			205: 'Iacute',
			206: 'Icirc',
			207: 'Iuml',
			208: 'ETH',
			209: 'Ntilde',
			210: 'Ograve',
			211: 'Oacute',
			212: 'Ocirc',
			213: 'Otilde',
			214: 'Ouml',
			215: 'times',
			216: 'Oslash',
			217: 'Ugrave',
			218: 'Uacute',
			219: 'Ucirc',
			220: 'Uuml',
			221: 'Yacute',
			222: 'THORN',
			223: 'szlig',
			224: 'agrave',
			225: 'aacute',
			226: 'acirc',
			227: 'atilde',
			228: 'auml',
			229: 'aring',
			230: 'aelig',
			231: 'ccedil',
			232: 'egrave',
			233: 'eacute',
			234: 'ecirc',
			235: 'euml',
			236: 'igrave',
			237: 'iacute',
			238: 'icirc',
			239: 'iuml',
			240: 'eth',
			241: 'ntilde',
			242: 'ograve',
			243: 'oacute',
			244: 'ocirc',
			245: 'otilde',
			246: 'ouml',
			247: 'divide',
			248: 'oslash',
			249: 'ugrave',
			250: 'uacute',
			251: 'ucirc',
			252: 'uuml',
			253: 'yacute',
			254: 'thorn',
			255: 'yuml',
			402: 'fnof',
			913: 'Alpha',
			914: 'Beta',
			915: 'Gamma',
			916: 'Delta',
			917: 'Epsilon',
			918: 'Zeta',
			919: 'Eta',
			920: 'Theta',
			921: 'Iota',
			922: 'Kappa',
			923: 'Lambda',
			924: 'Mu',
			925: 'Nu',
			926: 'Xi',
			927: 'Omicron',
			928: 'Pi',
			929: 'Rho',
			931: 'Sigma',
			932: 'Tau',
			933: 'Upsilon',
			934: 'Phi',
			935: 'Chi',
			936: 'Psi',
			937: 'Omega',
			945: 'alpha',
			946: 'beta',
			947: 'gamma',
			948: 'delta',
			949: 'epsilon',
			950: 'zeta',
			951: 'eta',
			952: 'theta',
			953: 'iota',
			954: 'kappa',
			955: 'lambda',
			956: 'mu',
			957: 'nu',
			958: 'xi',
			959: 'omicron',
			960: 'pi',
			961: 'rho',
			962: 'sigmaf',
			963: 'sigma',
			964: 'tau',
			965: 'upsilon',
			966: 'phi',
			967: 'chi',
			968: 'psi',
			969: 'omega',
			977: 'thetasym',
			978: 'upsih',
			982: 'piv',
			8226: 'bull',
			8230: 'hellip',
			8242: 'prime',
			8243: 'Prime',
			8254: 'oline',
			8260: 'frasl',
			8472: 'weierp',
			8465: 'image',
			8476: 'real',
			8482: 'trade',
			8501: 'alefsym',
			8592: 'larr',
			8593: 'uarr',
			8594: 'rarr',
			8595: 'darr',
			8596: 'harr',
			8629: 'crarr',
			8656: 'lArr',
			8657: 'uArr',
			8658: 'rArr',
			8659: 'dArr',
			8660: 'hArr',
			8704: 'forall',
			8706: 'part',
			8707: 'exist',
			8709: 'empty',
			8711: 'nabla',
			8712: 'isin',
			8713: 'notin',
			8715: 'ni',
			8719: 'prod',
			8721: 'sum',
			8722: 'minus',
			8727: 'lowast',
			8730: 'radic',
			8733: 'prop',
			8734: 'infin',
			8736: 'ang',
			8743: 'and',
			8744: 'or',
			8745: 'cap',
			8746: 'cup',
			8747: 'int',
			8756: 'there4',
			8764: 'sim',
			8773: 'cong',
			8776: 'asymp',
			8800: 'ne',
			8801: 'equiv',
			8804: 'le',
			8805: 'ge',
			8834: 'sub',
			8835: 'sup',
			8836: 'nsub',
			8838: 'sube',
			8839: 'supe',
			8853: 'oplus',
			8855: 'otimes',
			8869: 'perp',
			8901: 'sdot',
			8968: 'lceil',
			8969: 'rceil',
			8970: 'lfloor',
			8971: 'rfloor',
			9001: 'lang',
			9002: 'rang',
			9674: 'loz',
			9824: 'spades',
			9827: 'clubs',
			9829: 'hearts',
			9830: 'diams',
			338: 'OElig',
			339: 'oelig',
			352: 'Scaron',
			353: 'scaron',
			376: 'Yuml',
			710: 'circ',
			732: 'tilde',
			8194: 'ensp',
			8195: 'emsp',
			8201: 'thinsp',
			8204: 'zwnj',
			8205: 'zwj',
			8206: 'lrm',
			8207: 'rlm',
			8211: 'ndash',
			8212: 'mdash',
			8216: 'lsquo',
			8217: 'rsquo',
			8218: 'sbquo',
			8220: 'ldquo',
			8221: 'rdquo',
			8222: 'bdquo',
			8224: 'dagger',
			8225: 'Dagger',
			8240: 'permil',
			8249: 'lsaquo',
			8250: 'rsaquo',
			8364: 'euro'
		};

		/**
		 * Assess whether a given parent state name is indeed a valid state and a parent of a given child state
		 * @returns {boolean}
		 */
		utilities.isValidChildStateOfParent = function(parentStateName, childStateName) {
			var isValid = false;
			if (childStateName.indexOf(parentStateName + '.') > -1) {
				try {
					//attempt to get the state object from ui router state given the parent state to check that it is indeed a valid state in our state definitions
					if ($state.get(parentStateName) !== null) {
						isValid = true;
					}
				} catch (e) {
					isValid = false;
				}
			}

			return isValid;
		};

		/**
		 * forceInt casts the parameter to an integer and returns it. If it can't be cast, the function returns a zero.
		 * @param n
		 * @returns {Integer}
		 */
		utilities.forceInt = function(n) {
			var result = angular.isDefined(n) ? parseInt(n, 10) : 0;
			return isNaN(result) ? 0 : result;
		};

		/*
	 * Get the value from the given key in AppData.base_paths.
	 * If either base_paths doesn't exist or the value is an empty string,
	 * it will return the value from the key in AppData.SETTINGS.
	 *
	 * Eventually, base_paths will replace and phase out individual settins for:
	 * assets, passbook, gateway, shop.accesso.com (webapps), print_path, receipt_view, etc.
	 */
		utilities.getBasePath = function(AppData, key) {
			var env = AppData.environment.toLowerCase();

			if (utilities.safelyCheckPropertyOnObject('AppData.base_paths.' + env + '.' + key, AppData)
			&& AppData.base_paths[env][key] !== '') {
				return AppData.base_paths[env][key];
			} else {
				return AppData.settings[key];
			}
		};

		/**
		 * Approach to evaluate non-numeric key codes
		 * Similar to the approach Amazon uses
		 * @param which
		 * @returns {boolean}
		 */
		utilities.isNonNumericKeyCode = function(keycode) {
			return !(48 <= keycode && 57 >= keycode || 96 <= keycode && 105 >= keycode ||
		8 == keycode || 46 == keycode || 9 == keycode);
		};

		/**
		 * Compare two dates (without timestamp consideration) to see if they are the same day, same month, same year
		 * @param dt1
		 * @param dt2
		 * @returns {boolean} true if the dates are the same
		 */
		utilities.isSameDate = function(dt1, dt2) {
			return dt1 instanceof Date && dt2 instanceof Date && dt1.getDate() === dt2.getDate() && dt1.getMonth() === dt2.getMonth() &&
			dt1.getFullYear() === dt2.getFullYear();
		}


		/**
		 * Compare day, month, year of two different JavaScript Dates, removing timestamp from consideration
		 * @public
		 * @param dt1 {Date} - date to compare against another date
		 * @param dt2 {Date} - second date to compare if the first is before, after or equals
		 * @returns {number} - 1 if first date argument is in future compared to second param, 0 if equal and -1 if first date is in past
		 */
		utilities.compareDayMonthYearOfJsDates = function(dt1, dt2) {
			var y1 = dt1.getFullYear();
			var y2 = dt2.getFullYear();
			if (y1 > y2) {
				return 1;
			} else if (y1 < y2) {
				return -1;
			}

			var m1 = dt1.getMonth();
			var m2 = dt2.getMonth();
			if (m1 > m2) {
				return 1;
			} else if (m1 < m2) {
				return -1;
			}

			var d1 = dt1.getDate();
			var d2 = dt2.getDate();
			if (d1 > d2) {
				return 1;
			} else if (d1 < d2) {
				return -1;
			}

			return 0;
		}

		/**
			 * Compares two dates to eachother, returning
			 * @param  {Date} date1 Comparison value 1
			 * @param  {Date} date2 Comparison value 2
			 * @return {Number}       -1 if Date1 is before Date2
			 *                         0 if Date1 ~= Date2 ( accurate to the DAY, hours and beyond are dropped.  )
			 *                        +1 if Date1 is after Date2
			 */
		utilities.compareDate = function(date1, date2) {
			var date1Timestamp,
				date2Timestamp,
				result;
			if (!date1) {
				return 1;
			} else if (!date2) {
				return -1;
			}

			//This removes time data and only looks at DAY/MONTH/YEAR
			date1 = new Date(date1.getFullYear(), date1.getMonth(), date1.getDate(), 0, 0, 1, 0);
			date2 = new Date(date2.getFullYear(), date2.getMonth(), date2.getDate(), 0, 0, 1, 0);

			date1Timestamp = date1.getTime();
			date2Timestamp = date2.getTime();

			result = -1;

			if (date1Timestamp === date2Timestamp) {
				result = 0;
			} else if (date1Timestamp > date2Timestamp) {
				result = 1;
			}

			return result;
		}

		/**
		 * Parse the direct parent state from a given state name
		 * @param stateName
		 * @returns {null}
		 */
		utilities.parseDirectParentStateName = function(stateName) {
			var parentStateName = null;

			try {
				var stateParts = stateName.split('.');
				//attempt to get the state object from the first portion of the state (child and parent states are separated by periods (.)
				//so if there's a parent state, it should be the first part of the state name before the period. If there's no match state.get returns null.
				var parentState = '';
				stateParts.forEach(function(part, index) {
					if (index < (stateParts.length -1)) {
						parentState += ((index < stateParts.length - 2) ? part +'.' : part);
					}
				});
				parentStateName = stateParts.length > 1 ? $state.get(parentState).name : null;
			} catch (e) {
				parentStateName = null;
			}


			return parentStateName;
		};

		/**
		 * Sorts an array by a specified property
		 * @param {*[]} array The array to sort (by reference)
		 * @param {String} [propertyName] - if this is an array of objects, this is the property name of the object to compare
		 * @param {Boolean} [sortDescending] - configures the sort to descending order instead of ascending
		 * @returns {{*[]} The sorted array
		 */
		utilities.sortArray = function(array, propertyName, sortDescending) {
			return array.sort(function(a, b) {
				var tmpA = angular.isDefined(a[propertyName]) ? a[propertyName] : a;
				var tmpB = angular.isDefined(b[propertyName]) ? b[propertyName] : b;

				if (tmpA < tmpB) {
					return sortDescending ? 1 : -1;
				}
				if (tmpA > tmpB) {
					return sortDescending ? -1 : 1;
				} else {
					return 0;
				}
			})
		}

		/**
		 * Sorts an array by multiple properties
		 * @example Utilities.sortArrayMultiple(someArray, 'name,order', false)
		 * @public
		 * @param {Object[]} anArray The array of objects to sort
		 * @param {String} properties The CSV of properties to sort by e.g. "name,order"
		 * @param {Boolean} [sortDescending] To sort by properties in descending order
		 * @returns {*[]} The sorted array
		 */
		utilities.sortArrayMultiple = function sortArrayMultiple(anArray, properties, sortDescending) {
			var i;

			// Properties must be a valid string
			if (validString(properties)) {
				// remove any spaces and convert to an array
				properties = properties.replace(/\s/g, '').split(',');
			} else {
				// Otherwise return the original array
				return anArray;
			}

			// Sort array from last property to first to get the desired result
			for (i = properties.length - 1; i >= 0; i--) {
				anArray = utilities.sortArray(anArray, properties[i], sortDescending);
			}

			// Return sorted array
			return anArray;
		};

		/**
		 * Sinks any property/value combination to the bottom of an array
		 * @example utilities.sinkvalue(someArray, 'display_order', 0)
		 * @public
		 * @param {*[]} anArray The array to sink values in
		 * @param {String} [propertyName] The property to check (if object)
		 * @param {*} [value=0] The value to check to sink to the bottom
		 * @returns {*[]} The array with values sunk to bottom of the array
		 */
		utilities.sinkValues = function sinkValues(anArray, propertyName, value) {
			var propertyNameIsSet = validString(propertyName);
			value = angular.isDefined(value) ? value : 0;

			return anArray.sort(function sinkValuesSortFunc(a, b) {
				if (propertyNameIsSet && validObject(a) && validObject(b)) {
					a = utilities.checkProp('a.' + propertyName, a) ? a[propertyName] : a;
					b = utilities.checkProp('b.' + propertyName, b) ? b[propertyName] : b;
				}

				return a !== value && b === value ? -1 : 0;
			});
		};

		/**
		 * Cast to string and perform a localized comparison of the values
		 * @param a
		 * @param b
		 * @param locale {string}
		 * @returns {number}{1, 0, or -1}
		 */
		utilities.localeCompare = function(a, b, locale, collatorCompare) {
			if (angular.isUndefined(a) || angular.isUndefined(b)) {
				$log.error('One of the parameters is undefined: returning 0');
				return 0;
			}

			a = String(a);
			b = String(b);

			try {
				// If using Intl.Collator compare function
				if (collatorCompare) {
					return collatorCompare(a, b);
				}

				return a.localeCompare(b, locale);

			// This would occur if we are using a custom "locale" (en_BH) that is not a valid BCP 47 language tag
			} catch (e) {
				// Will still perform comparison (including special characters), but using the user's system locale
				return a.localeCompare(b);
			}
		};

		/**
		 * Cache busts files and lazy loads them async. Optionally can load sync.
		 * @param {Array} filesArr - Array of file paths (or objects containing path and ignoreCacheBust flag) to lazyload
		 * @param {Boolean} loadSync - Boolean to pass to lazyload library. True = Sync, False / Undefined = Async.
		 */
		utilities.cacheBustAndLazyLoad = function(filesArr, loadSync) {
			if (angular.isDefined($window.version)) {
			// Iterate through each file name and append the version
				var cacheBusterParam = 'cacheBuster=' + $window.version;

				for (var i = 0; i < filesArr.length; i++) {
					if (ngIsString(filesArr[i]) && !hasCacheBuster(filesArr[i])) {
						filesArr[i] += getQueryAppend(filesArr[i]) + cacheBusterParam;
					} else if (angular.isObject(filesArr[i]) && angular.isString(filesArr[i].path) && !filesArr[i].ignoreCacheBust && !hasCacheBuster(filesArr[i].path)) {
						filesArr[i].path += getQueryAppend(filesArr[i].path) + cacheBusterParam;
					}
				}
			}

			return $ocLazyLoad.load({
				serie: loadSync || false,
				files: filesArr
			});
		};

		utilities.autoFillLocation = function(value, zipAutofillLength, validCountryCodes, validationPattern, elm) {
			var q = null;
			var valid = false;
			var checkLength = (angular.isDefined(zipAutofillLength) && !isNaN(Number(zipAutofillLength))) ?
				Number(zipAutofillLength) : 5;

			if (angular.isUndefined(validCountryCodes)) {
				return
			}

			for (var i = 0; i < validationPattern.length; i++) {
				if (value && validationPattern[i] && (value.length >= checkLength) && validationPattern[i].test(value)) {
					valid = true;
					break;
				}
			}
			if (valid) {
				if (q) {
					$timeout.cancel(q);
				}
				q = $timeout(function() {
					$http.get('https://maps.googleapis.com/maps/api/geocode/json?address=' + value).then(function(response) {
						var data = response.data;
						if (data.status != "ZERO_RESULTS") {
							var results = parseData(data);
							// results can sometimes yield empty strings - we don't want to overwrite the user fields with empty values
							// only return results if values are present
							if (results.city.length > 0 && results.country.length > 0 && results.state.length > 0) {
								var validCountry = validCountryCodes.filter(function(element) {
									return results.country == element
								});
								if (angular.isDefined(validCountry) && !utilities.isEmpty(validCountry)) {
									$rootScope.$broadcast('GOOGLEZIP', results, elm);
								}
							}
						}
					});
					q = null;
				}, 250);
			}
		};

		/**
		 * This method provides a central source of calculating price when the app config use_vat is true and/or use_fee_inclusive_pricing is true.
		 * The only parameter is a customer type object, which is expected to have all necessary information - retail_amount, tax_amount, F/FEE node
		 * Vat price = retail_amount + tax_amount + any existing ticket-level fees on F node
		 * Fee inclusive pricing = retail_amount + any existing ticket-level fees on F node
		 * If both use_vat and use_fee_inclusive_pricing are true, the calculation is the same as use_vat alone.
		 *
		 * @param {Object} ct - Customer Type object
		 * @param {Array<Number>} [retailAndTaxOverride] - Array of numbers where [0] is retail amount, [1] is tax amount.
		 * While common, we cannot rely upon the retail_amount and tax_amount properties.
		 * Sometimes an array will be passed in with the values to be used in place of them.
		 * Note: fees are always calculated from the ct.F or ct.FEE node, not from the override array
		 * @returns {Number} - Price as float
		 */
		utilities.getTotalPrice = function(ct, retailAndTaxOverride) {
			var price = 0,
				AppData = $injector.get('AppData'),
				useVat = utilities.getBoolean(utilities.getFirstValue(AppData, 'settings.use_vat', 'defaults.use_vat')),
				useFeeInclusive = utilities.getBoolean(utilities.getFirstValue(AppData, 'settings.use_fee_inclusive_pricing', 'defaults.use_fee_inclusive_pricing'));

			// Retail and Tax
			if (angular.isDefined(retailAndTaxOverride) && angular.isArray(retailAndTaxOverride)) {
				for (var i = 0; i < retailAndTaxOverride.length; i++) {
					//tax is the second item in the array so only add it if useVat is configured
					if (useVat || i === 0) {
						price += parseFloat(retailAndTaxOverride[i]);
					}
				}
			} else {
				if (angular.isDefined(ct.retail_amount)) {
					price = parseFloat(ct.retail_amount);
				} else {
					$log.error('Why is retail_amount undefined on the CT?');
				}

				if (useVat && angular.isDefined(ct.tax_amount)) {
					price += parseFloat(ct.tax_amount);
				} else if (useVat && angular.isUndefined(ct.tax_amount)) {
					$log.error('Why is tax_amount undefined on the CT?');
				}
			}

			// Fees
			if (useVat || useFeeInclusive) {
				var feeNode = ct.F || ct.FEE || ct.fee_total;
				if (angular.isDefined(feeNode)) {
					// Normalize to array for consistent processing
					var fees = utilities.toArray(feeNode);

					for (var j = 0; j < fees.length; j++) {
						// Handle both object format {amount: "5.00"} and primitive "5.00"
						var feeAmount = fees[j].amount !== undefined ? fees[j].amount : fees[j];
						price += parseFloat(feeAmount) || 0;
					}
				}
			}

			return price;
		};

		/**
		 * @param  {Date} dateObj Javascript Date Object
		 * @returns {String} SQL Date
		 */
		utilities.javascriptDateToSQLDate = function(dateObj) {
			return $filter('date')(dateObj, 'yyyy-MM-dd');
		};

		/**
		 * Converts military time to civilian
		 * @public
		 * @param {String} militaryTime 24hour format
		 * @returns {String} 12hour format
		 */
		utilities.militaryToCivilianTime = function(militaryTime) {
			if (angular.isString(militaryTime) && militaryTime.length) {
				var hours24 = parseInt(militaryTime.substring(0, 2), 10);
				var hours = ((hours24 + 11) % 12) + 1;
				var amPm = hours24 > 11 ? ' PM' : ' AM';
				var minutes = militaryTime.substring(2);

				return hours + minutes + amPm;
			} else {
				$log.error('Invalid time passed to utilities.militaryToCivilianTime');
				return '';
			}
		}

		utilities.getFullDateFromJSDate = function(date) {
			return $filter('date')(date, 'fullDate');
		}

		/**
		 * Converts button value from enums to string for analytics
		 * @param  {String} buttonValue Button value from Modal.
		 * @returns {String} Button Name
		 */
		utilities.convertButtonValueToName = function(buttonValue) {
			var objKeys = Object.keys(Enums.buttonFlags);

			for (var i=0; i<objKeys.length; i++) {
				if (Enums.buttonFlags[objKeys[i]] == buttonValue) {
					return objKeys[i];
				}
			}

			return '';
		}

		/**
		 * Create an event data obj for datalayer and analytics
		 * @public
		 * @param {String} category The event category
		 * @param {String} action The event action
		 * @param {String} label The event label
		 * @param {Number} value The event value
		 * @returns {Object} An object to use with GA events
		 */
		utilities.generateEventData = function(category, action, label, value) {
			var data;

			if (!validString(action) || !validString(category)) {
				throw new TypeError('an analytics event must have a valid action and category');
			}

			data = {
				eventAction: action,
				eventCategory: category,
				eventLabel: label
			};

			if (!isNaN(value)) {
				data.eventValue = value;
			}

			return data;
		};

		/**
		 * Create an event timing data obj for datalayer and analytics
		 * @public
		 * @param {String} category The timing category
		 * @param {String} timingVariable A string to identify the variable being recorded
		 * @param {String} label The timing label
		 * @param {Number} value The number of milliseconds elapsed time to report to analytics
		 * @returns {Object} An object to use with GA events
		 */
		utilities.generateEventTimingData = function(category, timingVariable, label, value) {
			var data;

			if (!validString(category) || !validString(timingVariable)) {
				throw new TypeError('an analytics timing event must have a valid category and timing var');
			} else if (!angular.isNumber(value)) {
				throw new TypeError('analytics timing value must be a number');
			}

			data = {
				eventCategory: category,
				eventLabel: label,
				eventTimingVar: timingVariable,
				eventValue: value
			};

			if (!isNaN(value)) {
				data.eventValue = value;
			}

			return data;
		};

		/**
		 * Determines if the Season pass addon has the use_down_payment_plan charac enabled.
		 * @param  {Object} addon Season pass addon
		 * @returns {Boolean} useDownPaymentPlan
		 */
		utilities.useDownPaymentPlan = function(addon) {
			return utilities.safelyCheckPropertyOnObject('addon.addon_info.CHARACS.use_down_payment_plan', addon) && utilities.getBoolean(addon.addon_info.CHARACS.use_down_payment_plan);
		};

		/**
		 * Orders a list by display_order property
		 * @param {Object[]} list - the array of objects to order
		 * @param {String} [direction=ASC] - The direction that the list should be sorted. ENUM [ASC, DESC]
		 * @param {String} [property=display_order] - The direction that the list should be sorted. ENUM [ASC, DESC]
		 * @returns {undefined} - Object is passed by reference
		 */
		utilities.orderByDisplayOrder = function(list, direction, property) {
			var isDescending = (direction + '').toUpperCase() === 'DESC';

			property = property || 'display_order';

			list.sort(function(a, b) {
				var valA = utilities.checkProp('a.' + property, a, 'returnValue') || 0;
				var valB = utilities.checkProp('b.' + property, b, 'returnValue') || 0;

				if (valA === valB) {
					return 0;
				}
				return (+valA > +valB ? 1 : -1) * (isDescending ? -1 : 1);
			});

			return list;
		};


		/**
		 * Sanitize URL parameter to prevent XSS attacks
		 * @public
		 * @param {*} value 
		 * @returns 
		 */
		utilities.sanitizeUrlParam = function(value) {
			 if (!value) {
                return undefined;
            }
            try {
                // Decode the URI component
                var decoded = value;
				// Keep decoding while there are still encoded characters
                // This handles double-encoded values (e.g., %2520 -> %20 -> space)
                while (decoded !== decodeURIComponent(decoded)) {
                    decoded = decodeURIComponent(decoded);
                }
                // Repeat the strip passes (bounded) until stable, so a nested marker left behind by one pass gets caught by the next
                var stripped = decoded;
                var previous;
                var maxPasses = 10;
                do {
                    previous = stripped;
                    stripped = stripped
                        .replace(/<[^>]*>/g, '')
                        .replace(/(?:javascript|vbscript|data):/gi, '')
                        .replace(/on\w+\s*=/gi, '');
                    maxPasses--;
                } while (stripped !== previous && maxPasses > 0);
                // Catch any unclosed tag (e.g. '<script' with no trailing '>') the loop above can never match
                stripped = stripped.replace(/[<>]/g, '');
                return stripped;
            } catch (e) {
                return undefined;
            }
		}

		/**
		 * Takes query parameter and hash strings and converts them into an object
		 * @public
		 * @param {String} queryString - The query string to parse
		 * @param {String} [hash] - a URL hash
		 * @returns {Object} - Object of key/value pairs that correspond to the query string
		 */
		utilities.queryStringToObject = function queryStringToObject(queryString, hash) {
			var obj = {};
			var params = queryString.replace(/^\?/, '').split('&');

			params.forEach(function keyValue(param) {
				var keyVal = param.split('=');

				obj[keyVal[0]] = decodeURIComponent(keyVal[1]);
			});

			if (UtilsValidation.validString(hash)) {
				hash = hash.replace(/^#/, '').split('&');

				obj['#'] = {};

				hash.forEach(function keyValue(param) {
					var keyVal = param.split('=');

					obj['#'][keyVal[0]] = decodeURIComponent(keyVal[1]);
				});
			}

			return obj;
		};

		function parseData(data) {
			var parsedData = {
				city: '',
				state: '',
				country: ''
			};
			if (data && data.results && angular.isArray(data.results) && data.results.length >0 && data.results[0].address_components &&
			angular.isArray(data.results[0].address_components)) {
				var results = data.results[0].address_components;
				for (var item in results) {
					if (results[item].types && angular.isArray(results[item].types) & results[item].types.length > 0) {
						switch (results[item].types[0]) {
						case 'locality':
							parsedData.city = results[item].long_name ? results[item].long_name : '';
							break;
						case 'administrative_area_level_1':
							parsedData.state = results[item].short_name ? results[item].short_name : '';
							break;
						case 'country':
							parsedData.country = results[item].short_name ? results[item].short_name : '';
						default:
							break;
						}
					}
				}
			}
			return parsedData;
		}

		/**
		 * Group array object by property
		 * @public
		 * @function
		 * @param {Array} - ungrouped array
		 * @param {String} - Array object's property that being used to group
		 * @return {Object} Object that contains grouped arrays
		 */
		function groupByArrayProperties(ungroupedArray, property) {
			if (!validArray(ungroupedArray)) {
				return {};
			}
			return ungroupedArray.reduce(function(r, a) {
				r[a[property]] = r[a[property]] || [];
				r[a[property]].push(a);
				return r;
			}, Object.create(null));
		}

		/**
		 * Checks to see if a path has the cacheBuster param
		 * @public
		 * @function
		 * @param {String} path - Path to check to see if the cacheBuster param already exists
		 * @returns {Boolean} - True if the path has cacheBuster param, False if not
		 */
		function hasCacheBuster(path) {
			return /[?&]cacheBuster=[^&]+?/.test(path);
		}

		/**
		 * Determines what Append Character to use in the file path, if any
		 * @param {String} path - Path to determine what append character to use
		 * @returns {String} Will return '?', '&', or ''
		 */
		function getQueryAppend(path) {
			var charToAppend = path.indexOf('?') === -1 ? '?' : '&';

			return ['?', '&'].indexOf(path[path.length - 1]) === -1 ? charToAppend : '';
		}

		/**
		 * Replace null object properties
		 * @function
		 * @public
		 * @param {Object} obj - passed in object
		 * @param {String} oldPropertyVal - value that will be replaced
		 * @param {String} newPropertyVal - value that will replace object's properties
		 * @returns {Object} new object with properties replaced
		 */
		function replaceObjProperty(obj, oldPropertyVal, newPropertyVal) {
			var newObj = {};
			var objKeys = Object.keys(obj);

			objKeys.forEach(function(key) {
				var value = obj[key];

				if (value === oldPropertyVal) {
					value = newPropertyVal;
				} else if (Array.isArray(value)) {
					value = utilities.replaceElementInArr(value, oldPropertyVal, newPropertyVal);
				} else if (validObject(value)) {
					value = utilities.replaceObjProperty(value, oldPropertyVal, newPropertyVal);
				}
				newObj[key] = value;
			});
			return newObj;
		}

		/**
		 * Replace null array element
		 * @function
		 * @public
		 * @param {Array} arr - passed in array
		 * @param {String} newElementVal - value that will be replaced
		 * @param {String} oldElementVal - value that will replace array elements
		 * @returns {Array} new array with element replaced
		 */
		function replaceElementInArr(arr, oldElementVal, newElementVal) {
			if (!validArray(arr)) {
				return arr;
			}

			return arr.map(function(element) {
				if (element === oldElementVal) {
					element = newElementVal;
				}

				if (Array.isArray(element)) {
					element = utilities.replaceElementInArr(element, oldElementVal, newElementVal);
				} else if (validObject(element)) {
					element = utilities.replaceObjProperty(element, oldElementVal, newElementVal);
				}
				return element;
			});
		}

		/**
		 * Creates an object with Objects/Arrays
		 * NOTE: if structure hits an array, it will create the array and stop building the structure
		 * @param {Object} obj - The reference to the object to alter
		 * @param {String} structure The desired structure e.g. - obj.objectName[ArrayName]
		 * @returns {Boolean} true if structure was created, false otherwise
		 */
		utilities.createObjectNest = function(obj, structure) {
			var digestableStructure;
			var groupParts;
			var i;
			var reference;
			var determineRegex = /^(\[|\.)([^.\[\]]+)/;
			var groupRegex = /\[[^.\[\]]+\]|\.[^.\[\]]+/g;

			if (!UtilsValidation.isRealObject(obj)) {
				return false;
			}

			// breaks down the structure into groups
			digestableStructure = structure.match(groupRegex);

			if (!validArray(digestableStructure)) {
				return false;
			}

			// assigns the reference object
			reference = obj;

			for (i = 0; i < digestableStructure.length; i++) {
				// Get the cue character and name
				groupParts = digestableStructure[i].match(determineRegex);

				// If it's an array break the loop and exit
				if (angular.isArray(reference[groupParts[2]])) {
					break;
				// If it's undefined
				} else if (!reference[groupParts[2]]) {
					// Assign it to an object or array as declared by the structure
					reference[groupParts[2]] = groupParts[1] === '.' ? {} : [];

					// If an array was assigned, break the loop
					if (groupParts[1] === '[') {
						break;
					}
				// If it's anything other than an object, break the loop
				} else if (!angular.isObject(reference[groupParts[2]])) {
					break;
				}

				// Move the reference point
				reference = reference[groupParts[2]];
			}

			return true;
		}

		/**
		 * Removes null or undefined properties from an object
		 * @param {Object} object The object to remove null or undefined properties from
		 * @returns {Object | undefined} The object with null or undefined properties removed or undefined if the passed in object is undefined
		 */
		utilities.removeNullOrUndefinedFromObject = function(object) {
			if (angular.isUndefined(object)) {
				return object;
			} else {
				// Iterate over each property in the object
				for (var key in object) {
					if (object.hasOwnProperty(key)) {
						// Check if the property value is null or undefined
						if (object[key] === null || object[key] === undefined) {
							// Delete the property if it is null or undefined
							delete object[key];
						}
					}
				}
				return object;
			}
		};

		/**
		 * Replaces null or undefined properties from an object with passed in parameter
		 * @param {Object} object The object to remove null or undefined properties from
		 * @param {*} replaceWith The value to replace null or undefined properties with
		 * @returns {Object | undefined } The object with null or undefined properties replaced with the passed in parameter or undefined if the passed in object is undefined
		 */
		utilities.replaceNullOrUndefinedFromObject = function(object, replaceWith) {
			if (angular.isUndefined(object) || angular.isUndefined(replaceWith)) {
				return object;
			} else {
				// Iterate over each property in the object
				for (var key in object) {
					if (object.hasOwnProperty(key)) {
						// Check if the property value is null or undefined
						if (object[key] === null || object[key] === undefined) {
							// Replace the property if it is null or undefined
							object[key] = replaceWith;
						}
					}
				}
				return object;
			}
		};

		/**
		 * Grabs the first element of an array
		 * Will attempt to wrap the object to an array
		 * @param {*[]|Object} arr - The array/object to grab the first element from
		 * @returns {*|null} - The first element of the array or null if the array is empty
		 */
		utilities.first = function first(arr) {
			var value = utilities.wrapObjectToArray(arr, true)[0];

			return value === undefined ? null : value;
		}

		/**
		 * Generates a debounce function. The returned function also exposes a `cancel()`
		 * method so callers can discard a pending call before it fires — e.g. when a
		 * later immediate action (like removing the item being debounced) supersedes it.
		 * @example var deb = Utilities.debounce(function() { console.log('debounced'); }, 1000); deb(); deb();
		 * @param {Function} func - The Function to execute
		 * @param {Number} [duration=1000] - How long in milliseconds the debounce should wait before executing the function
		 * @returns {Function} - The debounce function to use. Its returned promise settles with func's resolved/rejected value.
		 */
		utilities.debounce = function debounce(func, duration) {
			var lastTimeout = null;

			// Default to 1000ms
			duration = angular.isNumber(duration) ? duration : 1000;

			function debounceClosure() {
				var args = arguments;
				var context = this;
				var deferred = $q.defer();

				$timeout.cancel(lastTimeout);

				lastTimeout = $timeout(function() {
					// $q.when normalizes func's return value whether it's a promise or a plain value
					$q.when(func.apply(context, args)).then(deferred.resolve, deferred.reject);
				}, duration);

				return deferred.promise;
			}

			// Cancels a pending debounced call so it never fires
			debounceClosure.cancel = function cancel() {
				$timeout.cancel(lastTimeout);
				lastTimeout = null;
			};

			return debounceClosure;
		};

		/**
		 * Changes the format of a given time string based upon the app military time setting
		 * @param {String} timeString - A time represented as a string
		 * @param {Boolean} [forceMilitary] - Forces the time format to be military if true, standard if false
		 * @returns {String} - The formatted time string
		 */
		utilities.getFormattedTime = function getFormattedTime(timeString, forceMilitary) {
			var useMilitary = forceMilitary === undefined
				? utilities.getBoolean($injector.get('AppData').settings.military_time)
				: !!forceMilitary;
			var isStandard = /^\d{1,2}:\d{2} ?[AP]M$/i.test(timeString);
			var timeRegex = /^(\d{1,2}):(\d{2}) ?([AP]M)?$/;
			var parts;

			if (!timeString) {
				return timeString;
			}

			if (isStandard && useMilitary) {
				parts = timeString.match(timeRegex);

				// if the time is 12:00 AM, it should be 00:00
				if (parts[3].toUpperCase() === 'AM' && parts[1] === '12') {
					parts[1] = 0;
				// if the time is PM and not 12, add 12 hours
				} else if (parts[3].toUpperCase() === 'PM' && parts[1] !== '12') {
					parts[1] = parseInt(parts[1], 10) + 12;
				}

				return utilities.getString(parts[1]).padStart(2, '0') + ':' + parts[2];
			} else if (!isStandard && !useMilitary) {
				parts = timeString.match(timeRegex);
				parts[3] = 'AM';

				if (parts[1] >= 12) {
					if (parts[1] < 24) {
						parts[3] = 'PM';
					}

					if (parts[1] > 12) {
						parts[1] = parseInt(parts[1], 10) - 12;
					}
				} else if (parts[1] === '00') {
					parts[1] = 12;
				}

				return parts[1] + ':' + parts[2] + ' ' + parts[3];
			}

			return timeString;
		};

		/**
		 * Executes the callback after angularjs can appropriately render updates to the DOM
		 * @param {Function} callback - The function to execute
		 * @param {Number} [waitFrames=2] - The number of frames to wait before executing the callback
		 * @returns {undefined}
		 */
		utilities.nextTick = function nextTick(callback, waitFrames) {
			waitFrames = (angular.isNumber(waitFrames) && waitFrames >= 0) ? waitFrames : 2;

			if (waitFrames > 0) {
				$timeout(function nextTickTimeout() {
					utilities.nextTick(callback, waitFrames - 1);
				}, 0);
			} else {
				callback();
			}
		}

		/**
		 * Mirrors an element's height onto a CSS custom property on that same element.
		 * @param {Element} element - The element to observe and write the CSS var onto
		 * @param {String} cssVarName - Custom property name, e.g. '--pane-height'
		 * @returns {ResizeObserver|null} The observer (caller must call .disconnect() on teardown), or null if element is falsy
		 */
		utilities.observeHeightAsCssVar = function observeHeightAsCssVar(element, cssVarName) {
			if (!element) { return null; }

			var observer = new ResizeObserver(function() {
				element.style.setProperty(cssVarName, element.offsetHeight + 'px');
			});
			observer.observe(element);
			return observer;
		};

		/**
		 * Converts a time string to minutes representation
		 * @param {String} time - The standard or military time string
		 * @returns {Number} - The time in minutes
		 */
		utilities.timeAsMinutes = function timeAsMinutes(time) {
			var parts = utilities.getFormattedTime(time, true).split(':');

			return (parseInt(parts[0], 10) * 60) + parseInt(parts[1], 10);
		}

		utilities.mergeDeep = function mergeDeep(target) {
			var key;
			var keyObj;
			var sources = Object.values(arguments).slice(1);
			var src;

			if (!sources.length) {
				return target;
			}

			src = sources.shift();

			if (angular.isObject(target) && angular.isObject(src)) {
				for (key in src) {
					keyObj = {};

					if (angular.isObject(src[key])) {
						if (src[key] instanceof Date || angular.isArray(src[key])) {
							target[key] = angular.copy(src[key]);
						} else {
							if (!target[key]) {
								keyObj[key] = {};
								utilities.merge(target, keyObj);
							}

							mergeDeep(target[key], src[key]);
						}
					} else {
						keyObj[key] = src[key];
						utilities.merge(target, keyObj);
					}
				}
			}

			return mergeDeep.apply(null, [target].concat(sources));
		};

		/**
		 * Add minutes to a given time string
		 * @private
		 * @param {String} time - The given time string to add minutes to
		 * @param {Number} minutes - The number of minutes to add
		 * @returns {String} - The new time string
		 */
		utilities.addMinutes = function addMinutes(time, minutes) {
			time = utilities.getFormattedTime(time, true);

			// Get the hour/minute values
			var parts = time.match(/^(\d+):(\d+)(.*)$/);
			// Add the full minutes value to the min part
			var min = utilities.forceInt(parts[2]) + utilities.forceInt(minutes);
			// Add how many hours the minutes exceed to the hr part - Then mod 24 to get the correct hour
			var hr = (utilities.forceInt(parts[1]) + Math.floor(min / 60)) % 24;

			// Mod the minutes to get the correct minute
			min %= 60;


			// Assemble the time and set the correct format
			return utilities.getFormattedTime(utilities.getString(hr).padStart(2, '0')
				+ ':'
				+ utilities.getString(min).padStart(2, '0'));
		};

		/**
		 * Resolves desktop and mobile banner image asset URLs from CalendarPricing-style locale keys.
		 * Both `{keyword}DesktopBannerImage` and `{keyword}MobileBannerImage` are looked up under the
		 * given section; each is only included in the result when the locale key exists and resolves
		 * to a non-empty value.
		 *
		 * This utility mirrors the `_assignBanners` pattern used in calendar-based controllers and
		 * allows any module to adopt the same banner configuration without duplicating the logic.
		 *
		 * @public
		 * @param {string} section - The locale section to look up (e.g. 'CalendarPricing')
		 * @param {string} keyword - The keyword prefix for the banner keys (e.g. 'FastLane')
		 * @returns {{ desktopBannerImage?: string, mobileBannerImage?: string }} Banner image asset URLs
		 */
		utilities.assignBannerImages = function assignBannerImages(section, keyword) {
			var Language = $injector.get('Language');
			var result = {};
			var desktopLocale, mobileLocale;

			desktopLocale = Language.localeExists(section, keyword + 'DesktopBannerImage') && Language.getLocaleMerchant(section, keyword + 'DesktopBannerImage');
			if (desktopLocale) {
				result.desktopBannerImage = $rootScope.getAssetUrl(desktopLocale);
			}

			mobileLocale = Language.localeExists(section, keyword + 'MobileBannerImage') && Language.getLocaleMerchant(section, keyword + 'MobileBannerImage');
			if (mobileLocale) {
				result.mobileBannerImage = $rootScope.getAssetUrl(mobileLocale);
			}

			return result;
		};

		return utilities;
	});

(function() {
	'use strict';

	angular
		.module('app')
		.factory('Viewport', ViewportService);

	/**
	 * The Viewport service
	 * @constructor
	 * @param {Enums} Enums - The Enums service
	 * @param {Utilities} Utilities - The Utilities service
	 * @param {UtilsValidation} UtilsValidation - The UtilsValidation service
	 * @returns {Object} The service instance
	 * @ngInject
	 */
	function ViewportService(Enums, Utilities, UtilsValidation) {
		var BREAKPOINT_EVENT_PREFIX = 'viewport.';

		var checkProp = Utilities.checkProp,
			nextTick = Utilities.nextTick,
			validArray = UtilsValidation.validArray;

		var service = {
			api: {
				isMobile: false,
				isDesktop: false,
				isTablet: false,
				notMobile: false,
				notDesktop: false,
				notTablet: false,
			},
			isGreaterEqualThan: isGreaterEqualThan,
			isLessThan: isLessThan,
			registerBreakpoint: registerBreakpoint,
			_: {
				breakpoints: {},
				lastWidth: document.body.offsetWidth,
				resizeObserver: null,
				resizeObserver: null,

				checkBreakpoints: _checkBreakpoints,
				generateHeartbeat: _generateHeartbeat,
				initialize: _initialize,
				resizeObserverCallback: _resizeObserverCallback,
			},
		};

		// Initialize the service
		service._.initialize();

		// Return the service
		return service;

		/***************************************
		 ** ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ **
		 ** ~ P R I V A T E ~ M E T H O D S ~ **
		 ** ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ **
		 ***************************************/

		/**
		 * Initializes the service
		 * @private
		 * @returns {undefined}
		 */
		function _initialize() {
			// Create the resize observer to track when the window is resized
			service._.resizeObserver = new ResizeObserver(service._.resizeObserverCallback);

			// Start observing the document body
			service._.resizeObserver.observe(document.body);
		}

		/**
		 * Creates a heartbeat object and returns it with a manual kill function
		 * @private
		 * @param {Scope} scope - The scope to tie the heartbeat to
		 * @returns {Object} - The heartbeat object and kill function
		 */
		function _generateHeartbeat(scope) {
			var heartbeatObj = {
				side: 0,
				flatline: false,
				scope: scope,
			};

			return {
				heartbeat: heartbeatObj,
				killFunc: function killFunc() {
					heartbeatObj.flatline = true;
				},
			};
		}

		/**
		 * The callback function for the resize observer
		 * @private
		 * @returns {undefined}
		 */
		function _resizeObserverCallback() {
			// Ensures everything is in order by using Next Tick
			nextTick(function next() {
				var api = service.api;

				// Determine if viewport is within mobile range
				api.isMobile = service.isLessThan(Enums.screenSizeThresholds.SM);

				// notMobile will be the inverse value of isMobile
				api.notMobile = !api.isMobile;

				// Determine if viewport is within desktop range
				api.isDesktop = service.isGreaterEqualThan(Enums.screenSizeThresholds.MD);

				// notDesktop will be the inverse value of isDesktop
				api.notDesktop = !api.isDesktop;

				// Determine if viewport is within tablet range
				api.isTablet = api.notMobile && api.notDesktop;

				// notTablet will be the inverse value of isTablet
				api.notTablet = !api.isTablet;

				// Check for breakpoints
				service._.checkBreakpoints(document.body.offsetWidth);
			});
		}

		/**
		 * Checks to see if any registered breakpoints have been crossed
		 * @private
		 * @param {Number} docWidth - The current document width
		 * @returns {undefined}
		 */
		function _checkBreakpoints(docWidth) {
			// Iterate through each breakpoint
			Object.keys(service._.breakpoints).forEach(function forEachBreakpoint(breakpoint) {
				var breakRef = service._.breakpoints[breakpoint];

				// Remove any destroyed scopes
				breakRef.heartbeat = breakRef.heartbeat.filter(function iterateHeartbeats(heartbeat) {
					return !heartbeat.flatline && !heartbeat.scope.$$destroyed;
				});

				// If there are no more heartbeat references
				if (!validArray(breakRef.heartbeat)) {
					// Remove the breakpoint
					delete service._.breakpoints[breakpoint];
				// If the document width is greater than or equal to the breakpoint and the last width is less than the breakpoint
				} else if (
					(docWidth >= breakpoint && breakpoint > service._.lastWidth)
					|| (docWidth <= breakpoint && breakpoint < service._.lastWidth)
				) {
					// Iterate through each heartbeat reference
					breakRef.heartbeat.forEach(function forEachHeartbeat(heartbeat) {
						// Determine the side of the breakpoint
						var side = docWidth >= breakpoint ? 1 : -1;

						// If the side has changed
						if (heartbeat.side !== side) {
							// Update the side
							heartbeat.side = side;

							// Broadcast the breakpoint event
							heartbeat.scope.$broadcast(BREAKPOINT_EVENT_PREFIX + breakpoint, {
								breakpoint: breakpoint,
								isAbove: side === 1,
							});
						}
					});
				}
			});

			// Wait until the next tick
			nextTick(function next() {
				// Update the last width
				service._.lastWidth = docWidth;
			});
		}

		/*************************************
		 ** ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ **
		 ** ~ P U B L I C ~ M E T H O D S ~ **
		 ** ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ **
		 *************************************/

		/**
		 * Determines if the current document width is greater than or equal to the specified breakpoint
		 * @public
		 * @param {Number} breakpoint - The breakpoint to check against
		 * @returns {Boolean} True if it's greater/equal, false if not
		 */
		function isGreaterEqualThan(breakpoint) {
			return document.body.offsetWidth >= breakpoint;
		}

		/**
		 * Determines if the current document width is less than to the specified breakpoint
		 * @public
		 * @param {Number} breakpoint - The breakpoint to check against
		 * @returns {Boolean} - True if it's less than, false if not
		 */
		function isLessThan(breakpoint) {
			return document.body.offsetWidth < breakpoint;
		}

		/**
		 * Registers a breakpoint to have the store broadcast when it is crossed
		 * @param {Number} breakpoint - The value to trigger
		 * @param {Scope} cleanupVariable - Scope reference to determine when to unregister the breakpoint
		 * @param {Function} callback - The callback function to execute when the breakpoint is crossed
		 * @returns {Function} - The deregistration function
		 */
		function registerBreakpoint(breakpoint, scope, callback) {
			var details;

			// Is the scope not a scope object or is it destroyed?
			if (!checkProp('scope.$$destroyed', scope) || scope.$$destroyed) {
				// scope is not a scope object, no way to clean up, so exit
				return null;
			}

			// Is the breakpoint not registered?
			if (!service._.breakpoints[breakpoint]) {
				// Create base breakpoint object
				service._.breakpoints[breakpoint] = {
					heartbeat: [],
				};
			}

			// Generate the heartbeat object
			details = service._.generateHeartbeat(scope);

			// Determine original side
			details.side = service.isGreaterEqualThan(breakpoint) ? 1 : -1;

			// Tie scope to breakpoint, if all scopes die, the breakpoint will be unregistered
			service._.breakpoints[breakpoint].heartbeat.push(details.heartbeat);

			// Assign listener for the breakpoint event
			scope.$on(BREAKPOINT_EVENT_PREFIX + breakpoint, callback);

			// Return the kill function
			return details.killFunc;
		}
	}
})();
/**
 * Created by ltischuk on 4/27/15.
 * Temporary solution to manually track routing until main entry points are reworked to using Resolve functions to handle
 * pre-routing decisions
 */
angular.module(
	'app'
).service
(
	'RouteHistoryService',

	function(
		$rootScope,
		$state,
		$transitions) {
		/**
		 * Setup the last route variable on rootScope
		 * @type {string}
		 */
		$rootScope.lastValidRoute = '';
		$rootScope.previousRoute = '';

		/**
		 * Private variable to disable saving the last valid route in certain instances
		 * @type {boolean}
		 */
		var disableSaveOfLastRoute = false;

		/**
		 * Is the next route a promo code route
		 * @type {boolean}
		 */
		var nextRouteIsPromoRoute = false;

		/**
		 * Private variable that keeps track of a history of URL of the previous 10 routes
		 * @type {Array}
		 */
		var routeHistoryChain = [];

		/**
       * Hooks to see if we should override the current state with the last valid route instead
       * @type {{name: string, check: Function}[]}
       */
		var lastRouteOverrideHooks = [
			{
				name: "packageDetailsWithLastRouteSavingsCalendar",
				check: function(currentState, stateParams) {
					return ((currentState.indexOf('packageDetails') > -1) && $rootScope.lastValidRoute.indexOf('savingsCalendar') > -1);
				}
			},
			{
				name: "fromCrossSellFlow",
				check: function(currentState, stateParams) {
					return ((currentState.indexOf('packageDetails') > -1) && $rootScope.lastValidRoute.indexOf('crossSells') > -1);
				}
			},
			{
				name: "fromPromoFlow",
				check: function(currentState, stateParams) {
					return ((currentState.indexOf('packageDetails') > -1 || currentState.indexOf('cartView') > -1) && $rootScope.lastValidRoute.indexOf('promocode') > -1);
				}
			}
		];

		/**
		 * Register the next route as a promo route
		 */
		this.registerNextRouteAsPromoRoute = function() {
			nextRouteIsPromoRoute = true;
		}

		/**
		 * Turn off the promo flag on the next route as there may have been a route exception thrown and we need to now turn off the notion of promo route
		 */
		this.unregisterNextRouteAsPromoRoute = function() {
			nextRouteIsPromoRoute = false;
		}

		/**
		 * Obtain whether or not the next route we are going to is a promocode route or not
		 * @returns {boolean}
		 */
		this.isNextRouteAPromoRoute = function() {
			return nextRouteIsPromoRoute;
		}

		/**
		 * Returns boolean of whether or not the current state name should be overridden with lastRoute
		 * @param currentState
		 * @param stateParams
		 * @returns {boolean}
		 */
		this.overrideRouteWithLastRoute = function(currentState, stateParams) {
			return lastRouteOverrideHooks.some(function(hook) {
				return hook.check(currentState, stateParams);
			});
		}

		/**
		 * Do not save the next route within the route history
		 * @param bool
		 */
		this.setDisableSaveOfRoute = function(bool) {
			disableSaveOfLastRoute = bool;
		}


		/**
		 * Tracking transitions onEnter event
		 */
		$transitions.onEnter
		({}
			, function(trans) {
				var fromState = trans.from(),
					fromParams = trans.params('from');
				// Only set the last route if we have a valid fromState and the fromState is NOT an extraflow state
				if (!disableSaveOfLastRoute) {
					$rootScope.lastValidRoute = fromState.name.length > 0 ? $state.href(fromState.name, fromParams) : '';
				}

				$rootScope.previousRoute = fromState.name.length > 0 ? $state.href(fromState.name, fromParams) : '';

				// Push it into the route chain so we can still keep track of where we've been
				routeHistoryChain.push($state.href(fromState.name, fromParams));
				if (routeHistoryChain.length > 10) {
					routeHistoryChain.shift();
				}
				// reset disable save of last route to false as we evaluated the value and are now onto a new state
				disableSaveOfLastRoute = false;
				nextRouteIsPromoRoute = false;
			}
		);

		/**
		 * Refresh of browser - reset lastValidRoute
		 * @param e
		 */
		window.onbeforeunload = function(e) {
			$rootScope.lastValidRoute = '';
		};
	}
);

"use strict";

angular.module('app').factory(
	'FormValidation', function(
		AppData
		, $injector
		, JSONValidator
		, Language
		, StringUtils
		, Utilities
		, UtilsValidation
	) {
		var CreditCardsVerificationService;
		var validation = {};
		var zipRegex = {
			US: new RegExp(/^[0-9]{5}(\-[0-9]{4})?$/i),
			GB: new RegExp(/^(GIR|[A-Z]\d[A-Z\d]??|[A-Z]{2}\d[A-Z\d]??)[ ]??(\d[A-Z]{2})$/i),
			CA: new RegExp(/^([ABCEGHJKLMNPRSTVXY]\d[ABCEGHJKLMNPRSTVWXYZ])\ {0,1}(\d[ABCEGHJKLMNPRSTVWXYZ]\d)$/i),
			DE: new RegExp(/\b((?:0[1-46-9]\d{3})|(?:[1-357-9]\d{4})|(?:[4][0-24-9]\d{3})|(?:[6][013-9]\d{3}))\b/),
			FR: new RegExp(/^(F-)?((2[A|B])|[0-9]{2})[0-9]{3}$/i),
			IT: new RegExp(/^(V-|I-)?[0-9]{5}$/i),
			AU: new RegExp(/^(0[289][0-9]{2})|([1345689][0-9]{3})|(2[0-8][0-9]{2})|(290[0-9])|(291[0-4])|(7[0-4][0-9]{2})|(7[8-9][0-9]{2})$/),
			NL: new RegExp(/^[1-9][0-9]{3}\s?([a-zA-Z]{2})?$/i),
			ES: new RegExp(/^([1-9]{2}|[0-9][1-9]|[1-9][0-9])[0-9]{3}$/),
			BE: new RegExp(/^[1-9]{1}[0-9]{3}$/),
			IN: new RegExp(/^\d{6}$/),
			INTL: new RegExp(/^[a-z0-9\s\-]+$/i)
		};
		var emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}])|(([a-zA-Z\-\d]+\.)+[a-zA-Z]{2,}))$/;

		var phoneRegex = { US: new RegExp(/^[0-9]{10}$/) };

		/**
		 * An array of possible input error types that include our own custom types.
		 * This is also in the order of precendence that the cooresponding error message should show (if exists).
		 * @type {String[]}
		 * @see https://docs.angularjs.org/api/ng/type/form.FormController#$error
		 */
		var ERROR_FIELD_TYPES = [
			'required',
			'max',
			'maxlength',
			'min',
			'minlength',
			'number',
			'url',
			'date',
			'datetimelocal',
			'time',
			'week',
			'month',
			'equal',
			'pattern',
			'sensitive'
		];

		var validString = UtilsValidation.validString,
			validArray = UtilsValidation.validArray,
			getString = Utilities.getString;

		/**
		 * Getter function to get the Credit Cards Verification Service
		 * Needed to prevent circular dependency
		 * @function
		 * @returns {Service} The Credit Cards Verification Service
		 */
		function getCreditCardsVerificationService() {
			if (!CreditCardsVerificationService) {
				CreditCardsVerificationService = $injector.get('CreditCardsVerificationService');
			}

			return CreditCardsVerificationService;
		}

	 	validation.getStateProvinceMatchForCountry = function(country) {
			var stateRegexString = '';
			if (angular.isDefined(country) && angular.isDefined(AppData.regions[country])) {
				AppData.regions[country].forEach(function(region, index) {
					stateRegexString += ((index > 0 ? '|' : '') + region.code);
				});

				return new RegExp(stateRegexString);
			} else {
				return new RegExp('.*');
		 	}
		};


		validation.getSeasonPass = function() {
			// I have to admit that I'm nervous reading regex from an external source, but that
			// external source is our own database, so hopefully it is trustworthy.
			// A typical RegEx code here would be "[0-9]{18}"
			var passRegEx = (Utilities.safelyCheckPropertyOnObject('AppData.settings.season_pass_renew_code_length', AppData))
				? new RegExp(AppData.settings.season_pass_renew_code_length)
				: new RegExp('.*');
			//passRegEx = new RegExp("[0-9]{18}");  // Used for testing
			return passRegEx;
		};

		validation.getName = function(type) {
			if (type === 'number') {
				return new RegExp("^[" + validation._getCharacterRange() + "\\s]+$", 'i');
			}

			return new RegExp("^[" + validation._getCharacterRange(['numeric']) + "\\s]+$", 'i');
		};

		validation.getZip = function(country) {
			var regEx = zipRegex.INTL;
			var json = '';
			if (Utilities.safelyCheckPropertyOnObject('AppData.settings.reg_ex', AppData) && JSONValidator.validate('reg_ex', AppData.settings.reg_ex)) {
				json = JSON.parse(AppData.settings.reg_ex);
			}
			if (angular.isDefined(country)) {
				if (angular.isDefined(json.zip) && angular.isDefined(json.zip[country])) {
					regEx = new RegExp(json.zip[country]);
					// Find the country in our list.
				} else if (zipRegex[country]) {
					regEx = zipRegex[country];
				}
			}
			return regEx;
		};

		validation.getPhone = function() {
			if (_isEnhancedPhoneNumber()) {
				// if the enhanced phone number field is on, then we rely mostly on the api to validate the phone number
				// the lowest possible phone number length is 4 digits
				// we only validate the phone number length in order to show the error message if the phone is too short
				return new RegExp(/^(?=.*?\d.*?\d.*?\d)[0-9.\-()+\s]{4,15}$/);
			} else {
				// if it is a regular phone input field and not enhanced phone number, then we consider the disable_min_phone_length setting
				// if allow phone characters is true, then we allow non-numeric up to 20 characters (character not currently in use by any island and not supported by our api)
				// For instance, (123) 456-7890 is a valid phone number
				if (_isAllowPhoneCharacters()) {
					return _disableMinPhoneLength() ? new RegExp(/^(?=.*?\d.*?\d.*?\d)[0-9.\-()+\s]{4,20}$/) : new RegExp(/^(?=.*?\d.*?\d.*?\d)[0-9.\-()+\s]{10,20}$/);
				}
				// if disable min phone length is true, we ignore the min phone length starting at 4, otherwise we use the min phone length of 10
				return _disableMinPhoneLength() ? new RegExp(/^[0-9]{4,15}$/) : new RegExp(/^[0-9]{10,15}$/);
			}
		};

		validation.getPhoneByCountry = function(country) {
			// Find the country in our list.
			if (angular.isDefined(country) && angular.isDefined(phoneRegex[country])) {
				return phoneRegex[country];
			}
			// We were unable to find a match, so default to previous method
			return validation.getPhone();
		};

		validation.getEmail = function() {
			var emailConfig = Utilities.getBoolean(AppData.settings.allow_no_email);
			var emailRegexAsString = emailRegex.toString();

			if (emailConfig && Language.SeasonPass.noEmail) {
				// Strip the regex literal's enclosing slashes so the pattern can be prefixed with the noEmail alternative.
				emailRegexAsString = emailRegexAsString.replace('/^', '^(' + Language.SeasonPass.noEmail + ')$|').replace('$/', '$');
				return new RegExp(emailRegexAsString, 'i');
			}

			return new RegExp(emailRegex);
		};

		validation.getTaxPayerId = function() {
			return new RegExp(/^[0-9\-]+$/);
		};

		validation.getPositiveNumbersRegex = function() {
			return new RegExp(/^[0-9]*$/);
		};

		validation.getAlphanumeric = function() {
			return new RegExp(/^[a-zA-Z0-9]*$/);
		};

		validation.getSecurityCodeRegex = function(ccType) {
			if (UtilsValidation.validString(ccType) && StringUtils.normalize(ccType) === 'americanexpress') {
				return new RegExp(/^[0-9]{4,4}$/);
			}

			return new RegExp(/^[0-9]{3,3}$/);
		};

		validation.getPasswordRegEx = function() {
			return new RegExp(/^((?=.*\d)(?=.*[a-zA-Z]).{8,15})$/);
		};

		validation.getCityRegEx = function() {
			var regEx = '';
			if (Utilities.safelyCheckPropertyOnObject('AppData.settings.disable_city_validation', AppData) && Utilities.getBoolean(AppData.settings.disable_city_validation)) {
				regEx = new RegExp('.*')
			} else if (Utilities.safelyCheckPropertyOnObject('AppData.settings.reg_ex', AppData) && JSONValidator.validate('reg_ex', AppData.settings.reg_ex)) {
				var json = JSON.parse(AppData.settings.reg_ex);
				regEx = new RegExp(json.city);
			} else {
				regEx = validation.getName('number');
			}
			return regEx;
		};

		/**
		 * Get configurable password regex
		 * @param (required) options (an object containing the following:
		 * 	requireNumber: if you want to require a number in the password
		 * 	requireSpecialCharacter: if you want to require a special character
		 * 	requireUpperAndLowercaseAlpha: if you want to require both a upper and a lowercase letter
		 * 	minLength: if you want to require a
		 * @returns {RegExp}
		 */
		validation.getConfigurablePasswordRegEx = function(options) {
		 // password min/max to 8/15 if not provided
		 var minLength = Number(options.minLength);
		 var maxLength = Number(options.maxLength);
		 minLength = ((isFinite(minLength) && minLength > 0) ? minLength : 8);
		 maxLength = ((isFinite(maxLength) && maxLength > 0) ? maxLength : 15);
		 var passwordRegexString = options.requireUpperAndLowercaseAlpha ? '^((?=.*[A-Z])(?=.*[a-z])' : '^(';

		 passwordRegexString += (Utilities.getBoolean(options.requireNumber) ? '(?=.*\\d)' : '');
		 passwordRegexString += (Utilities.getBoolean(options.requireLetter) ? '(?=.*[a-zA-Z])' : '');
		 passwordRegexString += (Utilities.getBoolean(options.requireSpecialCharacter) ? '(?=.*[!@#$%^&*])' : '');
		 passwordRegexString += ('.{' + minLength + ',' + maxLength + '})$');

		 return new RegExp(passwordRegexString);
		};

		validation.getVariablePriceRegEx = function() {
			return new RegExp(/^([0-9]\d*)?(\.\d\d)?$/);
		};

		/**
		 * Gets a character range for a Regular Expression
		 * @private
		 * @param {Array<String>} exclude An array of keys (from characters and ranges) to exclude
		 * @returns {String} The character range
		 */
		validation._getCharacterRange = function(exclude) {
			exclude = validArray(exclude) ? exclude : [];

			var escapeable = /[\\\(\)]/g,
				characters = {
					punctuation: "-,'‘’ʻ\?.()",
					turkish: 'ÇĞİÖŞÜı',
					unicode: 'ÀÁÂÃÄÅÆßÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖØÙÚÛÜÝŸÞ'
				},
				ranges = {
					alpha: 'A-Z',
					numeric: '\\d'
				},
				result = '',
				conjoin = function(obj) {
					for (var key in obj) {
						if (exclude.indexOf(key) !== -1) {
							continue;
						}

						result += obj[key];
					}
				};

			conjoin(characters);

			if (validString(result)) {
				// Ensures there are no duplicates and escapes certain characters
				result = result
					.split('')
					.filter(function(val, pos, orig) {
						return orig.indexOf(val) === pos;
					})
					.join('')
					.replace(escapeable, '\\$&');
			}

			conjoin(ranges);

			return result;
		}

		/**
		 * the AppData setting for disable_min_phone_length
		 * when it is true, we ignore the min phone length starting at 4, otherwise we use the min phone length of 10
		 * @private
		 * @returns {Boolean} true if the setting is enabled, false otherwise
		 */
		function _disableMinPhoneLength() {
			if (Utilities.safelyCheckPropertyOnObject('AppData.settings.disable_min_phone_length', AppData)) {
				return Utilities.getBoolean(AppData.settings.disable_min_phone_length);
			}
			return false;
		}

		/**
		 * the AppData setting for enhanced_phone_number
		 * when it is true, we rely mostly on the api to validate the phone number
		 * @private
		 * @returns {Boolean} true if enhanced phone number is enabled, false otherwise
		 */
		function _isEnhancedPhoneNumber() {
			var enhancePhone = JSONValidator.validate('enhanced_phone_number', AppData.settings.enhanced_phone_number) ? JSON.parse(AppData.settings.enhanced_phone_number) : {};
			return Utilities.safelyCheckPropertyOnObject('enhancePhone.use_enhanced_phone_number', enhancePhone, 'getBoolean');
		}
		/**
		 * the AppData setting for allow_phone_characters
		 * when it is true, we allow non-numeric up to 20 characters (character not currently in use by any island and not supported by our api)
		 * @private
		 * @returns {Boolean} true if allow special phone characters is enabled, false otherwise
		 */
		function _isAllowPhoneCharacters() {
			return Utilities.safelyCheckPropertyOnObject('AppData.settings.allow_phone_characters', AppData, 'getBoolean');
		}

		/**
		 * Checks to see if a value is a credit card number (sensitive check)
		 * @param {*} value - a value to check
		 * @returns {boolean} true if it is a credit card, false otherwise
		 */
		validation.isCreditCardNumber = function(value) {
			// Convert to a string and strip out any space characters
			value = Utilities.getString(value).replace(/\s/g, '');

			// Credit Cards are at minimum 12 digits long, is composed of numerics, and passes the luhn check algorithm
			return value.length > 11 && validation.getPositiveNumbersRegex().test(value) && getCreditCardsVerificationService().luhnAlgorithm(value);
		}

		/**
		 * Retrieve the validation pattern given certain parameters
		 * @param validationType
		 * @param [validityEffector] - optional but required if the intention is to watch another model
		 * @param [customValidationPattern] - optional but required if the pattern is custom
		 * @param [passwordOptions] - optional but required if the type is password
		 * @returns {RegExp}
		 */
		validation.getValidationPattern = function(validationType, validityEffector, customValidationPattern, passwordOptions) {
			var validationPattern = new RegExp('.*');
			switch (validationType) {
			case 'name': {
				validationPattern = this.getName();
				break;
			}
			case 'zip': {
				validationPattern = angular.isDefined(validityEffector) ? this.getZip(validityEffector) : this.getZip();
				break;
			}
			case 'phone': {
				validationPattern = this.getPhone();
				break;
			}
			case 'phonebycountry': {
				validationPattern = angular.isDefined(validityEffector) ? this.getPhoneByCountry(validityEffector) : this.getPhone();
				break;
			}
			case 'email': {
				validationPattern = this.getEmail();
				break;
			}
			case 'namewithnumbers': {
				validationPattern = this.getName('number');
				break;
			}
			case 'taxid': {
				validationPattern = this.getTaxPayerId();
				break;
			}
			case 'positivenumbers': {
				validationPattern = this.getPositiveNumbersRegex();
				break;
			}
			case 'alphanumeric': {
				validationPattern = this.getAlphanumeric();
				break;
			}
			case 'securitycode': {
				validationPattern = this.getSecurityCodeRegex();
				break;
			}
			case 'password': {
				validationPattern = this.getPasswordRegEx();
				break;
			}
			case 'configurablepassword': {
				validationPattern = this.getConfigurablePasswordRegEx(passwordOptions);
				break;
			}
			case 'variablePrice': {
				validationPattern = this.getVariablePriceRegEx();
				break;
			}
			//stateProvince validation REQUIRES validityEffector to work
			case 'stateProvince': {
				validationPattern = this.getStateProvinceMatchForCountry(validityEffector);
				break;
			}
			case 'city': {
				validationPattern = this.getCityRegEx();
				break;
			}
			case 'seasonPass': {
				validationPattern = this.getSeasonPass();
				break;
			}
			case 'custom': {
				if (customValidationPattern) {
					// if the developer didn't pass in a custom validation, continue to the default case.
					validationPattern = new RegExp(customValidationPattern);
					break;
				}
			}
			default : {
				validationPattern = new RegExp('.*');
				break;
			}
			}
			return validationPattern;
		}


		/**
		 * Checks to see if an input has an error
		 * @param {Object} input The model object for an input
		 * @param {String[]} [fieldsToCheck] An override array of error fields that will be checked
		 * @returns {Boolean} true if input has error, false otherwise
		 */
		validation.inputHasError = function(input, fieldsToCheck) {
			fieldsToCheck = validArray(fieldsToCheck) ? fieldsToCheck : ERROR_FIELD_TYPES;

			return fieldsToCheck.some(function(item) {
				return input.$error[item];
			});
		}

		/**
		 * If a particular field's error should be shown
		 * @param {Object} input The model object for an input
		 * @param {String} field The individal error field
		 * @param {String[]} [fieldOrder] An override array of error precedence
		 * @returns {Boolean} true if field is first error in order, false otherwise
		 */
		validation.inputShowError = function(input, field, fieldOrder) {
			fieldOrder = validArray(fieldOrder) ? fieldOrder : ERROR_FIELD_TYPES;

			return getString(fieldOrder.find(function(item) {
				return input.$error[item];
			})).toLowerCase() === field;
		}

		return validation;
	}
);

/* eslint-disable camelcase */
angular.module('app').service('JSONValidator', JSONValidator);

/**
 * JSON Validator
 * @param {Service} $log
 * @param {Service} $location
 * @param {Service} errorTracking
 * @param {Constant} JsonValidatorConfig
 * @param {Constant} InternalConfig
 * @param {Service} Utilities
 * @param {Service} UtilsValidation
 * @returns {Service} - The JSON validator Service
 */
function JSONValidator($log, $location, $window, errorTracking, JsonValidatorConfig, InternalConfig, Utilities, UtilsValidation) {
	var ERROR_PREFIX = '[APP CONFIG ERROR]: ';
	var schemas = angular.merge(JsonValidatorConfig, InternalConfig);

	var checkProp = Utilities.safelyCheckPropertyOnObject,
		isRealObject = UtilsValidation.isRealObject;

	initialize();

	this.getAvailableSchemas = function() {
		var available = [];

		for (var k in schemas) {
			available.push(k);
		}

		return available;
	};

	this.validate = function(schemaName, json, validateAsString) {
		var valid,
			data,
			schema;

		if (json === undefined) {
			return false;
		}

		data = json;

		try {
			if (typeof json === 'string' && !validateAsString) {
				data = JSON.parse(json);
			}
		} catch (e) {
			$log.error(ERROR_PREFIX + schemaName + ' has invalid JSON and won\'t be used');
			errorTracking.notify(ERROR_PREFIX + 'Invalid JSON app config for : ' + schemaName + ' on ' + $location.host());

			return false;
		}

		schema = schemas[schemaName];

		if (schema === undefined) {
			throw new Error('Undefined Schema');
		}

		valid = tv4.validate(data, schema);

		if (!valid) {
			$log.error(ERROR_PREFIX + schemaName + ' isn\'t valid and won\'t be used. ' + checkProp('tv4.error.message', tv4, Utilities.returnValue));
		}

		return valid;
	};

	/**
	 * Takes config and add defaults if the config doesn't have the property set
	 * and the schema specifies a default
	 * @public
	 * @param {string} schemaName the name of the schema to check against
	 * @param {string|object} config the config to check
	 * @throws {Error} if an invalid schema is specified
	 * @returns {object} the config with the supposed defaults
	 */
	this.fillDefaults = function(schemaName, config) {
		switch (typeof config) {
		case 'string':
			config = JSON.parse(string);
			break;
		case 'object': break;
		default:
			config = {};
		}

		if (!checkProp('schemas.' + schemaName + '.schema.properties', schemas, isRealObject)) {
			throw new Error('Undefined Schema:' + schemaName);
		}

		var schema = schemas[schemaName].schema.properties;

		for (var item in schema) {
			if (!config[item] && checkProp('schema.' + item + '.default', schema)) {
				config[item] = schema[item].default;
			}
		}

		return config;
	};


	/**
	 * Initialize logic that should be ran on startup
	 * @function
	 * @returns {undefined}
	 */
	function initialize() {
		// Makes a internal reference to all schemas so they may intereact with each other.
		Object.keys(schemas).forEach(function(name) {
			tv4.addSchema(schemas[name].$id || '1500_' + name, schemas[name]);
		});
	}
}

angular.module('app').service('AddrLookup',
	function(
		$location
		, $rootScope
		, $q
		, AppData
		, LegacyCart
		, Enums
		, Language
		, Modal
		, Package

	) {
		//private service variables
		var addrLookupCountriesArr = AppData.addr_lookup_countries ? AppData.addr_lookup_countries.split(',') : [];
		var i18n = Language;

		//mapping to define how address information should come back and mapping it to standard fields
		//we set province equal to county as well because only UK is using this at the moment and the forms use the state field
		var addressMapping =[{
			fieldName: 'address1',
			mapName: 'address0'
		},
		{
			fieldName: 'address2',
			mapName: 'address1'
		},
		{
			fieldName: 'city',
			mapName: 'town'
		},
		{
			fieldName: 'state',
			mapName: 'county'
		},
		{
			fieldName: 'province',
			mapName: 'county'
		},
		{
			fieldName: 'postalCode',
			mapName: 'postcode'
		}
		];

		var searchResultsData = undefined;

		//variable to guide whether or not we show the address lookup directive on forms
		var showAddrLookupOnNextForm = true;

		var addr_lookup_maxresults = (AppData.settings && AppData.settings.addr_lookup_maxresults &&
                angular.isNumber(AppData.settings.addr_lookup_maxresults)) ? Number(AppData.settings.addr_lookup_maxresults) : 20;

		/**
             * getMiscPackageId - pulls a package id from appropriate app object as Backend Service requires it
             * @private
             * @return {String} package_id
             */
		function getMiscPackageId() {
			return (Package.packageDetails && Package.packageDetails.id) ? Package.packageDetails.id :
				((angular.isArray(LegacyCart.cartItems) && LegacyCart.cartItems.length> 0) ? LegacyCart.cartItems[0].package_id : '000');
		}

		/**
             * parseAddressResultData - parses the AddressFormat result into an object in the format for all forms
             * @private
             * @param {Array} address lookup result data from AddressFormat call
             * @return {Object} address object as needed on forms
             */
		function parseAddressResultData(data) {
			var chosenAddrResult = {};
			if (data && data.A && angular.isArray(data.A) && data.A.length >0) {
				for (var i = 0; i<addressMapping.length; i++) {
					mapAddressResultToAddressObj(addressMapping[i], data.A, chosenAddrResult);
				}
			} else {
				Modal.displayModal(
					{
						category: 'Address Lookup Error',
						action: 'Error',
						title: Language.Alert.unableToFindAddressTitle,
						label: 'Address Lookup Incomplete',
						icon: 'icon-info red',
						description: Language.Alert.unableToFindAddressMsg,
						buttonFlags: [Enums.buttonFlags.OK]

					}
				);
			}
			return chosenAddrResult;
		}

		/**
             * mapAddressResultToAddressObj - map the address result from Backend into object with key/value pairs that our forms are defined by
             * @private
             * @param {mapItem} addressMapping array element to match to
             * @param {Array} addrResultArray - array of results from address format call
             * @param{Object} - resultingObject - object that we should add key/value pairs to
             *
             */
		function mapAddressResultToAddressObj(mapItem, addrResultArray, resultingObject) {
			var addressPart = addrResultArray.filter(function(element) {
				return mapItem.mapName == element.label.toLowerCase();
			});
			var propValue = (addressPart.length > 0 && addressPart[0].line) ? addressPart[0].line : '';
			resultingObject[mapItem.fieldName] = propValue;
		}

		/**
             * setSearchResultsData - setter function to set the searchResultsData variable
             * @public
             * @param {Object} data
             */
		this.setSearchResultsData = function(data) {
			searchResultsData = data;
		}

		/**
             * getSearchResultsData - getter function to get the searchResultsData variable
             * @public
             * @return {Object} searchResultsData
             */
		this.getSearchResultsData = function(data) {
			return searchResultsData;
		}

		/**
             * getMaxResultsAmount - getter function to get the maxResults allowed for display
             * @public
             * @return {Number} addr_lookup_maxresults
             */
		this.getMaxResultsAmount = function() {
			return addr_lookup_maxresults;
		}

		/**
             * setShowAddrLookupOnNextForm - setter function to set the showAddrLookupOnNextForm variable
             * @public
             * @param {boolean}
             */
		this.setShowAddrLookupOnNextForm = function(bool) {
			showAddrLookupOnNextForm = bool;
		}

		/**
             * setShowAddrLookupOnNextForm - getter function to get the showAddrLookupOnNextForm variable
             * @public
             * @return {boolean} showAddrLookupOnNextForm
             */
		this.getShowAddrLookupOnNextForm = function() {
			return showAddrLookupOnNextForm;
		}

		/**
             * isAddrLookupCountry - function to determine if a country is able to use address lookup service
             * @public
             * @param {String}  country code
             * @return {boolean} true if country is eligible for address lookup
             */
		   this.isAddrLookupCountry = function(countryToMatch) {
			if (countryToMatch && addrLookupCountriesArr.length > 0) {
				var matched = addrLookupCountriesArr.filter(function(item) {
					return item == countryToMatch;
				});
				return matched.length > 0;
			}
			return false;
		}

		/**
             * searchAddress - search function to call the backend for ADDRESS_SEARCH
             * @public
             * @param {Object}  data object with partial address to lookup
             * @param {Function} function to call on successful response if more than one address returned
             * @param {Function} function to call on successful response if only one address returned
             */
		   this.searchAddress = function(data, successManyAddrCallback, successOneAddrCallback) {
			var self = this;
			$rootScope.showSpinner(Language.ApplicationLabels.searchingAddress);
			$rootScope.pendingRequests.push(Enums.services.ADDRESS_SEARCH);
			var fetchResponse = AppData.fetch
			(
				Enums.services.ADDRESS_SEARCH
				, false
				, {
					cart_number: AppData.cart.cart_id,
					address: data.houseNumber,
					postal_code: data.postalCode,
					url: $location.$$absUrl,
					merchant_id: AppData.merchantId,
					package_id: getMiscPackageId()
				}
			).then
			(
				function(data) {
					$rootScope.hideSpinner();
					if (data.status == Enums.status.OK && data.A) {
						searchResultsData = (!angular.isArray(data.A)) ? [data.A] : data.A;
						$rootScope.removePendingRequest(Enums.services.ADDRESS_SEARCH);
						if (searchResultsData.length > 1) {
							successManyAddrCallback();
						} else {
							self.callAddressFormat(searchResultsData[0], successOneAddrCallback);
						}
					} else {
						Modal.displayModal(
							{
								category: 'Address Lookup Error',
								action: 'Error',
								title: Language.Alert.unableToFindAddressTitle,
								label: 'Address Lookup Incomplete',
								icon: 'icon-info red',
								description: Language.Alert.unableToFindAddressMsg,
								buttonFlags: [Enums.buttonFlags.OK]
							}
						);
						return $q.reject();
					}
				}
			);
			return fetchResponse;
		}

		/**
             * showAddrLookupIncompleteModal - shows a modal letting user know that address lookup information is incomplete
             * @public
             */
		this.showAddrLookupIncompleteModal = function() {
            	Modal.displayModal(
				{
					category: 'Address Lookup Incomplete',
					action: 'Error',
					title: Language.getLocale('Alert', 'incompleteAddressLookupTitle'),
					label: Language.getLocale('Alert', 'incompleteAddressLookupLbl'),
					icon: 'icon-info red',
					description: Language.getLocale('Alert', 'incompleteAddressLookupMsg'),
					buttonFlags: [Enums.buttonFlags.OK]
				}
			);
		}

		/**
             * callAddressFormat - calls backend service to format a chosen address
             * @public
             * @param {Object} - address to format
             * @param {Function} - function to callback on successful result
             */
		this.callAddressFormat = function(address, callback) {
			$rootScope.showSpinner(Language.ApplicationLabels.formattingAddress);
			AppData.fetch
			(
				Enums.services.ADDRESS_FORMAT
				, false
				, {
					address_id: address.id,
					package_id: getMiscPackageId()
				}
			).then
			(
				function(data) {
					$rootScope.hideSpinner();
					if (data.status == Enums.status.OK) {
						$rootScope.removePendingRequest(Enums.services.ADDRESS_FORMAT);
						var resultAddr = parseAddressResultData(data);
						callback(resultAddr);
					} else {
						Modal.displayModal(
							{
								category: 'Address Lookup Error',
								action: 'Error',
								title: Language.Alert.unableToFindAddressTitle,
								label: 'Address Lookup Incomplete',
								icon: 'icon-info red',
								description: Language.Alert.unableToFindAddressMsg,
								buttonFlags: [Enums.buttonFlags.OK]

							}
						);
					}
				}
			);
		}
	});


angular
	.module('app')
	.service('AppData', function(
		$document,
		$http,
		$location,
		$log,
		$rootScope,
		$state,
		$stateParams,
		$q,
		$filter,
		$injector,
		$timeout,
		$locale,
		$urlRouter,
		$window,
		errorTracking,
		ClientInfo,
		Connection,
		CustomActionService,
		DynamicToolbarOverridesService,
		titlesJSon,
		countriesJSon,
		Enums,
		GatePriceComparison,
		Language,
		Storage,
		Utilities,
		PaymentTypeService,
		PostRequestActionService,
		JSONValidator,
		StringUtils,
		Modal,
		CountriesService,
		UrlUtils,
		UtilsValidation
	) {
		var isDefined = angular.isDefined,
			checkProp = Utilities.safelyCheckPropertyOnObject,
			normalize = StringUtils.normalize,
			wrapObjectToArray = Utilities.wrapObjectToArray,
			validArray = UtilsValidation.validArray,
			validObject = UtilsValidation.validObject,
			validString = UtilsValidation.validString;

		var service =
			{
				anonClientId: null,
				clientId: null,
				dataLoaded: false,
				// Lockout duration (minutes) after a RATE_LIMITED discount response.
				// Set during bootstrap from merchant charac cart_level_discount_rate_limit_time_window.
				// Mirrors the backend default of 15 when the charac is not configured.
				discountRateLimitMinutes: 15,
				cartRecovery: false,
				flags: {},
				defaults: {},
				disabledKeywords: [],
				settings: {},
				cart: {},
				billingTypes: [],
				paymentMethodCount: 0,
				bankList: [],
				do3DSecureAuth: false,
				clientIP: '',
				shippingMethods: [],
				shipping:
				{
					deliveryMethod: 'M',
					deliveryAmount: '0.00',
					shippingAvailable: false
				},
				filteredShippingMethods: [],
				billing: {},
				payment: {},
				purchaseReceipt: {},
				optins: [],
				links: [],
				socialLinks: [],
				securityProvider: {},
				titles: titlesJSon,
				countries: countriesJSon.countries,
				regions: countriesJSon.regions,
				lastKeyword: false,
				environment: '',
				device: '',
				language: '',
				alias: '',
				island: '',
				userId: '',
				merchant: '',
				merchantId: '',
				currencyCode: 'USD',
				currencySymbol: $locale.NUMBER_FORMATS.CURRENCY_SYM,
				previousPage: '',
				currentPage: '',
				base_paths: {},
				assets: {},
				passbook: {},
				menuItems: [],
				promoCodes: [],
				merchantName: '',
				crossSells: true,
				useLocation: false,
				isInCheckout: false,
				geolocationOptions: {
					enableHighAccuracy: false,
					maximumAge: 0,
					timeout: 5000
				},
				localstorageTimeout: 900000,
				globalDependencies: {},
				tempData: {},
				unifiedPackageDetailsEnabled: false,
				use_addr_lookup: false,
				addr_lookup_countries: '',
				applicationInitialized: false,
				initMerchantKeywords: '',
				populateBillingShippingModelInfo: {

					shouldCopyFromOtherModel: false,
					shouldAllowCopy: function() {
						return false;
					},
					copyFromOtherModelAction: undefined

				},
				usesNewLocaleMethod: false,
				navTreeVersion: '',
				baseDomain: null,
				stack: null,
			};

		service.initializeData = function(extraRequests) {
			var requestArray = [];

			var processExtraRequests = function() {
				if (typeof extraRequests === 'undefined') {
					return $q.when();
				}

				for (var i = 0; i < extraRequests.length; i++) {
					var extraRequest = extraRequests[i];

					requestArray.push(service.fetch(Enums.services[extraRequest.key], extraRequest.useStorage, extraRequest.request, extraRequest.force));
				}

				$rootScope.showSpinner();

				return $q.all(requestArray);
			};

			service.cartRecovery = angular.isDefined($location.search()[Enums.urlParameters.cartRecovery]);

			if (!service.applicationInitialized) {
			// Take a semaphore, but don't give it back unless the store correctly initialized
				var sem = ShoplandInitSemaphore.take();
				return service
					.fetchStaticData()
					.then(function() {
						// Re-enable the ui router to listen to changes
						$urlRouter.listen();

						ShoplandInitSemaphore.release(sem);
						service.setStaticDataCartInfo();
						return processExtraRequests();
					})
					.then(service.handleSfOffer);
			} else {
				return processExtraRequests();
			}
		};

		/**
		 * Set the cart id, key and session info if using static data
		 * @returns {undefined}
		 */
		service.setStaticDataCartInfo = function() {
			var queryParams = $location.search();
			var GetNewCartIDKey = Enums.services.GET_NEW_CART_ID;
			var data = Storage.get(GetNewCartIDKey);
			var sessionId = queryParams[Enums.urlParameters.sessionIdShort] || queryParams[Enums.urlParameters.sessionId]

			if (queryParams[Enums.urlParameters.cartId] && queryParams[Enums.urlParameters.cartKey]) {
				service.cart.cart_id = queryParams[Enums.urlParameters.cartId];
				service.cart.cart_key = queryParams[Enums.urlParameters.cartKey];

				if (sessionId) {
					service.cart.session_id = sessionId;
				}
			} else if (data) {
				service[GetNewCartIDKey] = service.globalDependencies[GetNewCartIDKey] = data;

				if (validString(data.cart_id)) {
					service.cart.cart_id = data.cart_id;
				}
				if (validString(data.cart_key)) {
					service.cart.cart_key = data.cart_key;
				}
				if (validString(data.session_id)) {
					service.cart.session_id = data.session_id;
				}
			}
		};

		/**
		 * Handles whenever the backend cart gets into a bad state.
		 * @param {String} errorCode The error code from the response.
		 * @returns {undefined}
		 */
		service.handleInvalidCart = function(errorCode) {
			var errorCodeToUse = '5';
			if (errorCode && (validString(errorCode) || !Number.isNaN(errorCode))) {
				errorCodeToUse = errorCode.toString();
			}

			$rootScope.hideSpinner();

			Modal.displayModal({
				category: 'Error',
				label: 'Invalid cart',

				title: Language.replaceAll('@@errorCode', errorCodeToUse, Language.getLocale('ErrorCodes', 'errorCodeTitle')),
				icon: 'icon icon-caution caution-yellow',
				description: Language.getLocale('ErrorCodes', errorCodeToUse),
				showCloseButton: false,
				hideAllButtons: false,
				callback: function() {
					$rootScope.routeTo('reset/true');
				},
			});
		};

		/**
		 * Returns the query params to use with the fetch static data calls
		 * @param {Object} params The params to look in
		 * @returns {String} The query param string
		 */
		service.getStaticDataQueryParams = function(params) {
			/*
			 * NOTE: If you update paramKeys or queryParamsToStaticParams, you must also
			 * update the same in the php file StaticData::getQueryParams().
			 */
			var queryParams = { m: Utilities.getMerchant() };
			var paramKeys = ['l', 'merchant_id', 'trades_flag', 'reseller_id', 'reseller_location_id', 'reseller_affiliate_flag', 'user_id', 'user_token', 'navTreeVersion'];
			var queryParamsToStaticParams = {
				trades_flag: 'tf',
				reseller_affiliate_flag: 'raf',
				reseller_id: 'rid',
				reseller_location_id: 'rlid',
				user_id: 'uid',
				user_token: 'ut'
			};

			return UrlUtils.objectToQueryParams(
				paramKeys.reduce(function reduceParamsToQuery(acc, key) {
					if (!validString(params[key]) && !angular.isNumber(params[key])) {
						return acc;
					}

					if (queryParamsToStaticParams.hasOwnProperty(key)) {
						acc[queryParamsToStaticParams[key]] = params[key];
					} else {
						acc[key] = params[key];
					}

					return acc;
				}, queryParams)
			);
		};

		/**
		 * Fetches static data from the bootstrap endpoint.
		 * @returns {Promise} to resolve the data
		 */
		service.fetchStaticData = function() {
			var reseller = $injector.get('ResellerService').getReseller();
			var url = service.getApiUrl() + '/static-api/bootstrap';
			var params;
			var queryParams;

			if (!service.applicationActivated) {
				params = angular.merge({}, $location.search(), reseller || {});
				queryParams = service.getStaticDataQueryParams(params);

				if (validString(queryParams)) {
					url += '?' + queryParams;
				}

				// PHP emits an inline <script> that kicks off the bootstrap fetch before Angular loads.
				// If that pre-flight promise exists, consume it instead of issuing a duplicate request.
				var bootstrapPromise;
				if ($window.__accessoBootstrapPromise) {
					bootstrapPromise = $q.when($window.__accessoBootstrapPromise)
						.then(function(data) { return { data: data }; });
					$window.__accessoBootstrapPromise = null;
				} else {
					bootstrapPromise = $http.get(url);
				}

				return bootstrapPromise
					.then(function onReceivedStaticData(resp) {
						service.environment = resp.data.environment;

						['GetApplicationConsolidated', 'GetMerchantKeywords', 'GetMerchantDetails', 'GetMerchantPackageList'].forEach(function(key) {
							if (checkProp('resp.data.' + key + '.SERVICE', resp, 'isRealObject')) {
								service.injectStaticData(key, resp.data[key].SERVICE);
							}
						});

						processInitSettings(resp.data);

						if (checkProp('service.GetApplicationConsolidated.SETTINGS', service) && checkProp('service.GetMerchantPackageList.PS.P', service)) {
							checkPackagesOnKeyword();
						} else {
							routeToErrorPage({}, Enums.errorRoutes.FAILED_TO_INIT);
						}

						service.applicationActivated = true;

						// Do not call hideSpinner() here — Bootstrap.bootstrapApplication owns this lifecycle.
						// Previously caused a flash: spinner hid before Geolocation.initialize() re-showed it.
						$rootScope.state.showApplicationView = !Utilities.getBoolean(service.settings.offline);
						$rootScope.$broadcast(Enums.services.APP_ACTIVATED, { status: true });

						return resp.data;
					});
			}

			return $q.resolve();
		}


		/**
	 * ## Set Data
	 *
	 * @param {String} key Data source to request
	 * @param {Boolean} useStorage set/get from localStorage, NOTE, there is a 3rd option, we can append to it.
	 * @param {Object} request JSON formatted request for server
	 * @param {Boolean} force true to force the request and bypass cache
	 *
	 * @return {Object} a $q.defer().promise for the data requested
	 */
		service.setData = function(data, force) {
			force = !!((angular.isDefined(force) && force));

			if (!service.flags[data.request_type] || force) {
				service.flags[data.request_type] = true;

				if (data.request_type == Enums.services.GET_APPLICATION_CONSOLIDATED) {
				// processes data.SETTINGS.*
					processCountriesAndRegions(data);
					processAppConfigSettings(data);


					// processes data.TREE.*
					processAppConfigTree(data);
				}
			}
			PostRequestActionService.runActions(data);

			return data;
		};

		service.resolvePromisesAndSetData = function(data, force) {
			return PostRequestActionService.resolvePromises(data).then(function(newdata) {
				return service.setData(newdata, force);
			});
		};

		service.Storage = Storage;


		function createNonConvertedUIDs() {
			var nonConvertedUIDs = [
				'BH',
				'CDA-AQ',
				'CDA-BP',
				'CDA-DH',
				'CDA-PA',
				'CDA-WB',
				'CDA-WH-HFN',
				'CDA-WH',
				'ME-DGLONDON',
				'ME-LONDONEYE',
				'ME-MTLONDON',
				'ME-SALONDON',
				'ME-SLLONDON',
				'ME-TPDEMO',
				'SF-LR',
				'SF-MC'
			];
			if (angular.isDefined(service.settings.is_non_converted_uid)) {
				var addToNonConvertedUIDs = Utilities.getBoolean(service.settings.is_non_converted_uid);
				if (addToNonConvertedUIDs) {
					nonConvertedUIDs.push(service.merchant.toUpperCase());
				} else if (nonConvertedUIDs.indexOf(service.merchant.toUpperCase()) > -1) {
					nonConvertedUIDs.splice(nonConvertedUIDs.indexOf(service.merchant.toUpperCase()), 1);
				}
			}
			return nonConvertedUIDs;
		}

		/**
         * method to process response from initialize socket requests
         * @param  {Object} data
         * @example
         *      { "merchant": "ME-TP"
         *      , "merchant_id": 1001
         *  , "environment": "development"
         *  , "island": "accesso26"
         *  , "device": "desktop|tablet|mobile"
         *  , "language": "en"
         *      ....
         *  }
         *
         */
		function processInitSettings(data) {
			if (angular.isDefined(data.merchant)) {
				service.merchant = data.merchant;
			} else if (data.subdomain) {
				service.merchant = data.subdomain;
			}

			if (angular.isDefined(data.merchant_id)) {
				service.merchantId = data.merchant_id;
			} else if (data.merchantId) {
				service.merchantId = data.merchantId;
			}

			if (data.environment) {
				service.environment = data.environment;
			}

			if (angular.isDefined(data.island)) {
				service.island = data.island;
			}

			if (angular.isDefined(data.device)) {
				service.device = data.device;
			}

			if (angular.isDefined(data.language)) {
				service.language = data.language;
			}

			if (angular.isDefined(data.domain)) {
				service.baseDomain = data.domain;
			}

			if (angular.isDefined(data.stack)) {
				service.stack = data.stack;
			}

			if (angular.isDefined(data.anonClientId)) {
				service.anonClientId = data.anonClientId;
			}

			if (angular.isDefined(data.clientId)) {
				service.clientId = data.clientId;
			}
		}

		/**
		 * Process the data from GetApplicationConsolidated -> data.SETTINGS
		 */
		function processAppConfigSettings(data) {
			var LocaleService = $injector.get('LocaleService');
		// START // data.SETTINGS ////////////////////////////////////////

			if (angular.isDefined(data.SETTINGS)) {
				setCssOverrides(data.SETTINGS.css_overrides);
				setCssVariables(data.SETTINGS.css_variables);
				setTheme(data.SETTINGS.theme);

				try {
				// TODO: Need to re-introduce application controller (or some other method) to set these
				// application wide configurations coming from a service response.
					$rootScope.offline = Utilities.getBoolean(data.SETTINGS.offline);

					// Ensures Labels are present
					if (checkProp('data.LANGUAGE.ApplicationLabels.LT', data, 'validArray')) {
					// Grab Object
						$rootScope.offlineMessage = data.LANGUAGE.ApplicationLabels.LT.find(function findTarget(label) {
							return label.target === 'offlineMsg';
						});

						// Grab Value
						if (validObject($rootScope.offlineMessage)) {
							$rootScope.offlineMessage = $rootScope.offlineMessage.value;
						}
					}

					// Default if no offline message
					if (!$rootScope.offlineMessage) {
						$rootScope.offlineMessage = 'Application is Offline.<br />Please visit again shortly.';
					}
				} catch (e) {
				// Do Nothing
				}

				if (angular.isDefined(data.SETTINGS.agent_id)) {
					service.userId = data.SETTINGS.agent_id;
				}

				// Get the base paths from settings.
				if (angular.isDefined(data.SETTINGS.base_paths)) {
					try {
						service.base_paths = JSON.parse(data.SETTINGS.base_paths);
					} catch (e) {
						service.base_paths.error = e
					}
				}

				//	Get the assets path from settings.
				if (angular.isDefined(data.SETTINGS.assets_path)) {
					try {
						service.assets.config = data.SETTINGS.assets_path;
						service.assets.json = JSON.parse(data.SETTINGS.assets_path);

						if (service.environment && service.assets.json[service.environment]) {
							service.assets.url = service.assets.json[service.environment];
						} else {
							service.assets.url = service.assets.json['production'];
						}
					} catch (e) {
						service.assets.error = e;
					}
				}

				var nonConvertedUIDs = createNonConvertedUIDs();
				service.usesNewLocaleMethod = angular.isDefined(service.merchant) && nonConvertedUIDs.indexOf(service.merchant.toUpperCase()) <= -1;

				// Date format configuration.
				// island-specific exception for default date format during our transition period to the i18n shortDate
				if (service.usesNewLocaleMethod) {
					var dConfig = $locale.DATETIME_FORMATS.shortDate;
					var shortDateReplacements = [
						{
							key: "d",
							value: "dd"
						},
						{
							key: "M",
							value: "MM"
						},
						{
							key: "yy",
							value: "yyyy"
						},
						{
							key: "y",
							value: "yyyy"
						}
					];

					shortDateReplacements.forEach(function(item) {
						if (StringUtils.countOccurrences(dConfig, item.key) === 1) {
							dConfig = dConfig.replace(item.key, item.value);
						}
					});

					data.SETTINGS.date_format = (data.SETTINGS.date_format) ? data.SETTINGS.date_format.replace('mm', 'MM') : dConfig;
				} else {
					data.SETTINGS.date_format = (data.SETTINGS.date_format) ? data.SETTINGS.date_format.replace('mm', 'MM') : 'MM/dd/yyyy';
				}

				// Get the default calendar start date.
				if (angular.isDefined(data.SETTINGS.date_format)) {
					service.defaults.date_format = data.SETTINGS.date_format;
				}

				// Get the default calendar start date.
				if (angular.isDefined(data.SETTINGS.default_countries)) {
					var temp = data.SETTINGS.default_countries.split(',')
					var countries = [];
					for (var i in temp) {
						if (temp[i] != "") {
							countries.push(String(temp[i]).trim())
						}
					}

					service.defaults.default_countries = countries;

					service.countries = sortCountriesByDefault(service.countries, service.defaults.default_countries);
				}

				if (angular.isDefined(data.SETTINGS.currency_code)) {
					service.currencyCode = data.SETTINGS.currency_code;
					service.languageSettings = data.SETTINGS.language_settings;
				}

				// Get the default keyword from settings.
				if (angular.isDefined(data.SETTINGS.default_keyword)) {
					service.defaults.keyword = data.SETTINGS.default_keyword;
				}

				// Get the default country from settings. Default to US if no supplied
				if (angular.isDefined(data.SETTINGS.default_country)) {
					service.defaults.country = data.SETTINGS.default_country;
				} else {
					service.defaults.country = data.SETTINGS.default_country = 'US';
				}

				// Get the default calendar start date.
				if (angular.isDefined(data.SETTINGS.calendar_start_date)) {
					service.defaults.calendar_start_date = data.SETTINGS.calendar_start_date;
				}

				// Use Value Added Tax(United Kingdom)
				if (angular.isDefined(data.SETTINGS.use_vat)) {
					service.defaults.use_vat = Utilities.getBoolean(data.SETTINGS.use_vat);
				} else {
					service.defaults.use_vat = false;
				}

				// Use Fee Inclusive Pricing
				if (angular.isDefined(data.SETTINGS.use_fee_inclusive_pricing)) {
					service.defaults.use_fee_inclusive_pricing = Utilities.getBoolean(data.SETTINGS.use_fee_inclusive_pricing);
				} else {
					service.defaults.use_fee_inclusive_pricing = false;
				}

				// Get the default language from settings.
				if (angular.isDefined(data.SETTINGS.default_language)) {
					service.defaults.language = data.SETTINGS.default_language;
				}

				if (angular.isDefined(data.SETTINGS.display_accesso_branding)) {
					$rootScope.displayAccessoBranding = Utilities.getBoolean(data.SETTINGS.display_accesso_branding);
				}

				if (angular.isDefined(data.SETTINGS.display_disclaimer)) {
					$rootScope.displayDisclaimer = Utilities.getBoolean(data.SETTINGS.display_disclaimer);
				} else {
					$rootScope.displayDisclaimer = false;
				}

				if (angular.isDefined(data.SETTINGS.display_knowledge_base)) {
					$rootScope.displayKnowledgeBase = Utilities.getBoolean(data.SETTINGS.display_knowledge_base);
				} else {
					$rootScope.displayKnowledgeBase = true;
				}

				if (typeof data.SETTINGS.display_promo_code != 'undefined') {
					$rootScope.displayPromoCode = Utilities.getBoolean(data.SETTINGS.display_promo_code);
				} else {
					$rootScope.displayPromoCode = true;
				}

				if (angular.isDefined(data.SETTINGS.mobile_tickets_on_tablet)) {
					service.mobile_tickets_on_tablet = Utilities.getBoolean(data.SETTINGS.mobile_tickets_on_tablet);
				} else {
					service.mobile_tickets_on_tablet = true;
				}

				if (angular.isDefined(data.SETTINGS.legend_setup)) {
					// attempt to validate JSON
					var legendSetup = data.SETTINGS.legend_setup;
					if (JSONValidator.validate('legend_setup', legendSetup)) {
						service.settings.legendSetup = JSON.parse(legendSetup);
					}
				} else {
					service.settings.legendSetup = undefined;
				}

				// Get the links from the settings.
				if (angular.isDefined(data.SETTINGS.links) && (!service.links || !service.links.length)) {
					try {
						_links = JSON.parse(data.SETTINGS.links);
						for (var i in _links) {
							// Only add link if there is a url present
							if (angular.isDefined(_links[ i ]) && _links[ i ] !== '') {
								var obj = {};
								obj.label = i;
								obj.url = _links[ i ];

								if (obj.url.indexOf('facebook') > -1) {
									obj.icon = 'facebook-solid';
								} else if (obj.url.indexOf('tiktok') > -1) {
									obj.icon = 'tiktok-solid';
								} else if (obj.url.indexOf('pinterest') > -1) {
									obj.icon = 'pinterest-solid';
								} else if (obj.url.indexOf('instagram') > -1) {
									obj.icon = 'instagram-solid';
								} else if (obj.url.indexOf('twitter') > -1) {
									obj.icon = 'twitter-solid';
								} else if (obj.url.indexOf('youtube') > -1) {
									obj.icon = 'youtube-solid';
								}

								if (validString(obj.icon)) {
									service.socialLinks.push(obj);
								} else {
									service.links.push(obj);
								}
							}
						}
					} catch (e) {

					}
				}

				if (angular.isDefined(data.SETTINGS.localstorage_timeout)) {
					if (!isNaN(data.SETTINGS.localstorage_timeout)) {
						service.defaults.localstorageTimeout = data.SETTINGS.localstorage_timeout;
					}
				}

				if (angular.isDefined(data.SETTINGS.merchant_name)) {
					service.merchantName = data.SETTINGS.merchant_name;
				}

				// Get the optins from the settings.
				if (angular.isDefined(data.SETTINGS.optins)) {
					try {
						_optins = JSON.parse(data.SETTINGS.optins);
						service.optins = (angular.isArray(_optins)) ? _optins : [_optins];
					} catch (e) {

					}
				}

				if (angular.isDefined(data.SETTINGS.zip_code_keywords)) {
					service.zipCodeKeywords = data.SETTINGS.zip_code_keywords.split(',');
				}

				// Check for Cart Abandonment
				if (angular.isDefined(data.SETTINGS.cart_abandonment)) {
					service.cartAbandonment = data.SETTINGS.cart_abandonment;
				} else {
					service.cartAbandonment = false;
				}

				// Check for Autocapture Cart Abandonment
				if (angular.isDefined(data.SETTINGS.autocapture_cart_abandonment)) {
					service.autocaptureCartAbandonment = Utilities.getBoolean(data.SETTINGS.autocapture_cart_abandonment);
				} else {
					service.autocaptureCartAbandonment = false;
				}

				// URL param takes precedence over app config — enables session-scoped opt-in on non-opted stores.
				// validString rejects absent, no-value (?param), and empty (?param=) — only 'true'/'false' is respected.
				var updUrlParam = $location.search()[Enums.urlParameters.unifiedPackageDetails];
				service.unifiedPackageDetailsEnabled = validString(updUrlParam)
					? Utilities.getBoolean(updUrlParam)
					: Utilities.getBoolean(data.SETTINGS.unified_package_details_enabled);

				// Get the passbook path from settings.
				if (angular.isDefined(data.SETTINGS.passbook_path)) {
					try {
						service.passbook.config = data.SETTINGS.passbook_path;
						service.passbook.json = JSON.parse(data.SETTINGS.passbook_path);
						if (typeof service.environment != 'undefined' && service.environment != '') {
							service.passbook.url = service.passbook.json[service.environment];
						} else {
							service.passbook.url = service.passbook.json['production'];
						}
					} catch (e) {
						service.passbook.error = e;
					}
				}

				// Get the provider from the settings.
				if (angular.isDefined(data.SETTINGS.security_provider)) {
					var securityProviderLocale = data.LANGUAGE[data.SETTINGS.security_provider];

					if (checkProp('securityProviderAppConfig.LT', securityProviderLocale)) {
						try {
							_securityProvider = angular.isArray(data.LANGUAGE[data.SETTINGS.security_provider].LT)
								? data.LANGUAGE[data.SETTINGS.security_provider].LT
								: [data.LANGUAGE[data.SETTINGS.security_provider].LT];
							for (var i in _securityProvider) {
								service.securityProvider[_securityProvider[i].target] = _securityProvider[i].value;
							}
							service.securityProvider.provider = data.SETTINGS.security_provider.toLowerCase();
						} catch (e) {
							service.securityProvider.error = e;
						}
					}
				}

				if (angular.isDefined(data.SETTINGS.use_addr_lookup)) {
					service.use_addr_lookup = Utilities.getBoolean(data.SETTINGS.use_addr_lookup);
					if (service.use_addr_lookup && angular.isDefined(data.SETTINGS.addr_lookup_countries)) {
						service.addr_lookup_countries = data.SETTINGS.addr_lookup_countries;
					}
				}
				// apply elements to rootScope
				$rootScope.parkName = service.merchantName;
				$rootScope.assetsPath = service.assets.url;
				$rootScope.currencyCode = service.currencyCode;
				$rootScope.languageSettings = service.languageSettings;
				$rootScope.dateFormat = service.defaults.date_format;


				if (typeof data.SETTINGS.merchant_logo == 'string' && data.SETTINGS.merchant_logo != '') {
					$rootScope.parkLogo = $rootScope.getAssetUrl(data.SETTINGS.merchant_logo);
				}

				/**
				* Handles Custom Placeholder functionality for the package images
				*/
				if (angular.isDefined(data.SETTINGS.customPlaceholder)) {
					$rootScope.customPlaceholder = $rootScope.getAssetUrl(data.SETTINGS.customPlaceholder);
				} else {
					$rootScope.customPlaceholder = "/images/image-placeholder.png";
				}

				$rootScope.disablePromotionalCode = Utilities.getBoolean(data.SETTINGS.hide_promotional_code);

				updateDisabledCountries();
			}

			var modalElem = $document[0].getElementById('accessibilityFocus');
			if (modalElem) {
				modalElem.focus();
			}

			//check
			DynamicToolbarOverridesService.setupDynamicToolbarOverrides(service.settings);
		}

		/**
		 * Sets the css overrides cache buster for the merchant css overrides <link>
		 * @protected
		 * @memberof App.Run
		 * @param {Object} data from GetApplicationConsolidated
		 * @return {undefined}
		 */
		function processCountriesAndRegions(data) {
			var countries,
				lang = service.language.toLowerCase().trim();
			service.countries = CountriesService.getCountriesjsonOverride(service.settings.countriesjson_override, service.countries);
			countries = service.countries;
			countries = replaceNameForLanguage(countries, lang);
			countries = $filter('alphabeticalByLocale')(countries, 'name', lang);
			service.regions = processRegions(service.regions);
		}

		/**
		 * Sets the css overrides cache buster for the merchant css overrides <link>
		 * @protected
		 * @memberof App.Run
		 * @param {String} overridesString The merchant css overrides from app config
		 * @return {undefined}
		 */
		function setCssOverrides(overridesString) {
			try {
				if (JSONValidator.validate('css_overrides', overridesString)) {
					var overrides = JSON.parse(overridesString);
					$rootScope.cssOverridesCacheBuster = overrides.cacheBuster;
				}
			} catch (ignore) {
				// ignore
			}

			$rootScope.determineCssOverrides = true;
		}

		/**
		 * Updates the root CSS variable colors that ops can update
		 * @param {String} variablesString The JSON string
		 * @returns {undefined}
		 */
		function setCssVariables(variablesString) {
			var variables;
			var root;

			try {
				if (JSONValidator.validate('css_variables', variablesString)) {
					variables = JSON.parse(variablesString);
					root = document.documentElement;

					Object.keys(variables).forEach(function mapKeyToCssVariable(key) {
						if (checkProp('root.style.setProperty', root, angular.isFunction)) {
							root.style.setProperty('--' + key, variables[key]);
						}
					});

					$rootScope.useSelectedCSSOverride = determineCssSelectedOverride(variables);
				}
			} catch (ignore) {
				// ignore
			}
		}

		/**
		 * Checks the provided overrides to see if the selected colors are set
		 * @param {String} overrides The JSON string of css_overrides app config
		 * @returns {boolean} true if the selected colors are set
		 */
		function determineCssSelectedOverride(overrides) {
			// Check provided overrides string to see if
			// --gap-selected, --gap-selected-lighter, --gap-selected-darker are defined
			// If they aren't defined, use the default values
			return overrides['gap-selected'] && overrides['gap-selected-lighter'] && overrides['gap-selected-darker'];
		}


		/**
		 * Overrides the themes of the store
		 * @param {String} themeString The theme app config in JSON string format
		 * @returns {undefined}
		 */
		function setTheme(themeString) {
			if (!themeString) {
				return;
			}

			try {
				if (JSONValidator.validate('theme', themeString)) {
					$rootScope.theme = JSON.parse(themeString);
				}
			} catch (ignore) {}
		}

		/**
	 * Sorts Countries based on App Config
	 * @private
	 * @param counties {object}
	 * @param defaults {array}
	 * @return countries {object}
	 */
		function sortCountriesByDefault(countries, defaults) {
			var c = JSON.parse(JSON.stringify(countries));
			var sortBy = 'name'
			if (Utilities.childDefined(countries[0], service.language)) {
				sortBy = service.language;
			}

			var defaultCountries = []
			for (var i = c.length; i >= 0; i--) {
				if (c[ i ] && defaults.indexOf(c[ i ].code) != -1) {
					defaultCountries.push(c[i]);
					c.splice(i, 1)
				}
			}

			var newDefaults = [];
			for (var y = 0; y < defaultCountries.length; y++) {
				var value = defaultCountries[ y ];
				for (var x = 0; x < defaults.length; x++) {
					if (value.code == defaults[ x ]) {
						newDefaults[ x ] = value
					}
				}
			}

			return newDefaults.concat(c);
		}

		function processAppConfigTree(data) {
		// Start data.TREE
			if (typeof ((data).TREE || {}).MENUITEM != 'undefined') {
				_menuItems = [];
				_menu = angular.isArray(data.TREE.MENUITEM) ? data.TREE.MENUITEM : [data.TREE.MENUITEM];
				var i, j, k,
					submenu = [],
					subsubmenu = [],
					submenuItems = [],
					subsubmenuItems = [];
				// Logic for removing the inactive Menu Items
				// Top Level Menu Items
				for (i in _menu) {
					if (Utilities.getBoolean(_menu[i].isactive) && !service.shouldMenuItemBeDisabledForDevice(_menu[i])) {
						_isactive = true;
						// Check for Second Level Menu Items
						if (angular.isDefined(_menu[i].MENUITEM)) {
							submenuItems = [];
							submenu = angular.isArray(_menu[i].MENUITEM) ? _menu[i].MENUITEM : [_menu[i].MENUITEM];
							for (j in submenu) {
								if (Utilities.getBoolean(submenu[j].isactive) && !service.shouldMenuItemBeDisabledForDevice(submenu[j])) {
									submenu[j].isactive = true;
									submenuItems.push(submenu[j]);
									// Check for Third Level Menu Items
									if (angular.isDefined(submenu[j].MENUITEM)) {
										subsubmenuItems = [];
										subsubmenu = angular.isArray(submenu[j].MENUITEM) ? submenu[j].MENUITEM : [submenu[j].MENUITEM];
										for (k in subsubmenu) {
											if (Utilities.getBoolean(subsubmenu[k].isactive) && !service.shouldMenuItemBeDisabledForDevice(subsubmenu[k])) {
												subsubmenu[k].isactive = true;
												subsubmenuItems.push(subsubmenu[k]);
											}
										}
										if (subsubmenuItems.length > 0) {
											submenu[j].MENUITEM = subsubmenuItems;
										} else {
											delete submenu[j].MENUITEM;
										}
									}
								}
							}

							if (submenuItems.length > 0) {
								_menu[i].MENUITEM = submenuItems;
							} else {
								delete _menu[i].MENUITEM;
							}
						}

						if (Utilities.getBoolean(_isactive)) {
							_menu[i].isactive = true;
							_menuItems.push(_menu[i]);
						}
						// If this is an inactive item but it's a Restricted Package item or an accesso promo code (APC_) nav item for subkeywordmodule, keep it.
					} else if (!Utilities.getBoolean(_menu[i].isactive) && (_menu[i].keywords === 'Restricted' || (_menu[i].label || '').indexOf('APC_') === 0)) {
						_menu[i].isactive = false;
						_menuItems.push(_menu[i]);
					}
				}

				var swapArray = Storage.get('_geolocationSwap');
				if (angular.isArray(swapArray) && swapArray.length > 0) {
					for (var i in swapArray) {
						if (swapArray[i].keyword && swapArray[i].swap_keyword) {
							for (var j in _menuItems) {
								if (_menuItems[j].keywords == swapArray[i].keyword) {
									_menuItems[j]._keywords = _menuItems[j].keywords;
									_menuItems[j].keywords = swapArray[i].swap_keyword;
								}
								if (typeof _menuItems[j].MENUITEM != 'undefined') {
									for (var k in _menuItems[j].MENUITEM) {
										if (_menuItems[j].MENUITEM[k].keywords == swapArray[i].keyword) {
											_menuItems[j].MENUITEM[k]._keywords = _menuItems[j].MENUITEM[k].keywords;
											_menuItems[j].MENUITEM[k].keywords = swapArray[i].swap_keyword;
										}
									}
								}
							}
						}
					}
				}
				// Adding menu items
				service.menuItems = _menuItems;

				// Adding version
				if (Utilities.checkProp('data.TREE.VERSION', data, angular.isDefined)) {
					service.navTreeVersion = {
							desc: data.TREE.VERSION.desc || '',
							version: data.TREE.VERSION.version || ''
					};
				}

				// Log the version information
				$log.info('Navigation tree version:', service.navTreeVersion);

			}
		}

		/**
	 * Normalize the name as backend can change the casing on us...
	 * @param {Object} data The response from backend to modify
	 * @returns {undefined}
	 */
		service.normalizeRequestType = function(data) {
			var serviceNames = Enums.services,
				normalizedRequestType,
				realKey;

			if (!checkProp('data.request_type', data, validString)) {
				return;
			}

			normalizedRequestType = normalize(data.request_type);

			realKey = Object.keys(serviceNames).find(function(key) {
				return validString(serviceNames[key]) && normalize(serviceNames[key]) === normalizedRequestType;
			});

			if (validString(realKey)) {
				data.request_type = serviceNames[realKey];
			}
		};

		function getToken() {
			var token = ''
			for (var i = 0; i < 32; i++) {
				token +=
			Math.floor(Math.random() * 16).toString(16).toUpperCase();
			}
			return token;
		}

		/**
	 * Injects static data from the CDN into V5
	 * @param {String} key The response key
	 * @param {Object} data The actual data
	 * @returns {undefined}
	 */
		service.injectStaticData = function(key, data) {
			$log.log('<< static data', key, data);

			if (angular.isFunction(dataFormat[key])) {
				data = dataFormat[key](data);
			}

			service[key] = data;
			service.setData(data);
			service.globalDependencies[key] = data;
		};

		/**
		 * @description Returns the account portal URL for this merchant, including island, merchantId,
		 *   and normalized language. Priority order:
		 *   1. Localhost — returns a localhost URL using the _apPort param (persisted to localStorage)
		 *      or port 4200. Localhost detection is skipped in unit tests ($window.jasmine guard).
		 *   2. passport_auth.account-portal-url app config override — returned as-is (the full URL
		 *      up to the language segment is hardcoded in the config value).
		 *   3. AppData.stack + AppData.baseDomain — used on deployed environments; avoids .secure.
		 *      subdomain pollution that would result from parsing window.location.hostname.
		 *   Callers append the route suffix (e.g. '/accesso-login') and any tokens.
		 * @returns {string|null} Account portal URL up to the language segment, or null if required
		 *   AppData fields are missing
		 */
		service.getAccountPortalUrl = function() {
			var AP_PORT_KEY = '_apPort';
			var LANGUAGE_MAP = { de: 'de-DE', en: 'en-US', es: 'es-ES', fr: 'fr-FR' };
			var authConfig;
			var hostname;
			var isLocalhost;
			var language;
			var overrideUrl;
			var paramValue;
			var port;

			if (!service.island || !service.merchantId) {
				$log.error('[AppData] Cannot build account portal URL — required properties missing');
				return null;
			}

			language = StringUtils.normalizeLocale(service.language || 'en-US');
			language = LANGUAGE_MAP[language] || language;

			hostname = $window.jasmine ? '' : $window.location.hostname;
			isLocalhost = hostname === 'localhost' || hostname === '127.0.0.1';

			if (isLocalhost) {
				paramValue = $location.search()[AP_PORT_KEY];
				if (paramValue) {
					$window.localStorage.setItem(AP_PORT_KEY, paramValue);
				}
				port = paramValue || $window.localStorage.getItem(AP_PORT_KEY) || '4200';
				return `https://localhost:${port}/${service.island}/${service.merchantId}/${language}`;
			}

			if ($injector.has('AuthService')) {
				authConfig = $injector.get('AuthService').config;
				overrideUrl = checkProp('authConfig.account-portal-url', authConfig, 'returnValue');
				if (validString(overrideUrl)) {
					return overrideUrl;
				}
			}

			if (!service.stack || !service.baseDomain) {
				$log.error('[AppData] Cannot build account portal URL — required properties missing');
				return null;
			}

			return `https://accountportal.${service.stack}.${service.baseDomain}/${service.island}/${service.merchantId}/${language}`;
		};

		/**
		 * Returns the API url
		 * @returns {String} API URL
		 */
		service.getApiUrl = function() {
			var port = '',
				apiHost;

			if (typeof location.port !== 'undefined' && location.port.length != 0 && location.port != 80) {
				port = ':' + location.port;
			}

			apiHost = typeof window.accessoAPIHost !== 'undefined' ? window.accessoAPIHost : document.domain;

			return 'https://' + apiHost + '' + port;
		};

		/**
		 * Adds the standard properties
		 * @param {Object} request The request object
		 * @returns {Object} the request object
		 */
		service.addHttpStandardProperties = function(request) {
			var APP_CONFIG_PROP = 'GetApplicationConsolidated.SETTINGS',
				key = request.request_type,
				agentId = checkProp(APP_CONFIG_PROP + '.agent_id', service, 'returnValue'),
				machineId = checkProp(APP_CONFIG_PROP + '.machine_id', service, 'returnValue'),
				resellerParams = angular.merge(
					{},
					$location.search(),
					$injector.get('ResellerService').getReseller() || {}
				),
				resellerId = resellerParams.reseller_id,
				resellerLocationId = resellerParams.reseller_location_id,
				userId = resellerParams.user_id,
				userToken = resellerParams.user_token,
				tradesFlag = resellerParams.trades_flag,
				isReseller = false,
				isResellerAffiliate = false,
				promoCodesData;


			// I don't know why we do this, but Node adds it...
			if (key === 'GetCartSummary') {
				promoCodes = service.Storage.get('promo_codes');
				if (Array.isArray(promoCodesData)) {
					request.promoCodes = Utilities.arrayUnique(promoCodesData).join(',');
				}
			}

			// Add our standard cart data
			if (angular.isObject(service.cart)) {
				['cart_id', 'cart_key', 'session_id'].forEach(function addKey(key) {
					if (service.cart[key]) {
						request[key] = service.cart[key];
					}
				});
			}

			// Add agent information
			if (agentId && !request.agent_id) {
				request.agent_id = agentId;
				request.user_id = agentId;
			}

			// Add machine override if needed
			if (machineId && !request.machine_id) {
				request.machine_id = machineId;
			}

			// Append reseller information
			isReseller = !!(resellerId && resellerLocationId && tradesFlag && userId && userToken);
			isResellerAffiliate = !!(resellerId && resellerLocationId);
			if (isReseller) {
				request.reseller_id = resellerId;
				request.reseller_location_id = resellerLocationId;
				request.RESELLER = {
					reseller_id: resellerId,
					reseller_location_id: resellerLocationId,
					trades_flag: tradesFlag,
					user_id: userId,
					user_token: userToken
				};
			} else if (isResellerAffiliate) {
				request.reseller_id = resellerId;
				request.reseller_location_id = resellerLocationId;
				request.RESELLER = resellerAffiliateNode = {
					reseller_id: resellerId,
					reseller_location_id: resellerLocationId
				};
			}

			if (key === 'KeepaliveToken' && request.RESELLER) {
				request.user_id = request.RESELLER.user_id;
			}

			return request;
		};

		/**
		 * Handles the post http request fetching of other resources and finally resolving.
		 * @param {String} key The original request type
		 * @param {Object} request The original request
		 * @param {*} newData The data to resolve with
		 * @returns {Promise} A promise to resolve the original data
		 */
		service.postHttpFetch = function(key, request, newData) {
			return $q(function(resolve) {
				if (key === Enums.services.GET_NEW_CART_ID && newData.status !== Enums.status.OK) {
					$rootScope.offline = true;
					$rootScope.hideSpinner();

					// Ensures Labels are present
					if (checkProp('Language.ApplicationLabels.offlineMsg', Language)) {
						$rootScope.offlineMessage = Language.ApplicationLabels.offlineMsg;
					}

					// Default if no offline message
					if (!$rootScope.offlineMessage) {
						$rootScope.offlineMessage = 'Application is Offline.<br />Please visit again shortly.';
					}
				}

				return resolve(newData);
			}).then(function() {
				if (service.keyRequiresGetCartSummary(key)) {
					var gcsRequest = {};
					// Re-include the persisted discount code on cart-mutation GCS calls so the
					// discount survives item removal, qty changes, etc. Excluded for GetNewCartId
					// because a new cart is a clean slate — no discount should carry over.
					if (key !== Enums.services.GET_NEW_CART_ID) {
						var persistedCode = $injector.get('UserInfo').getDiscountCode();
						if (validString(persistedCode)) {
							gcsRequest.discount_code = persistedCode;
							gcsRequest.addRequestParameters = ['discount_code'];
						}
					}
					return service.fetch(Enums.services.GET_CART_SUMMARY, false, gcsRequest, true, false, true);
				}
			}).then(function() {
				if (service.keyRequiresGetNewCartId(key, newData)) {
					return service.handleInvalidCart(newData.error_code);
				}
			}).then(function() {
				if (service.keyRequiresSetExpressCheckout(key, request)) {
					return service.fetchSetExpressCheckout(newData);
				}
			}).then(function() {
				return newData;
			});
		};

		// Request types with their own dedicated node-api route (registered as a sibling
		// of, not nested under, the generic POST /api/request/:request_type proxy) --
		// e.g. PackageCalendar's POST /api/package-calendar, modeled on bootstrap-data's
		// "one endpoint fanning out to several backend calls" precedent. Every other
		// key falls through to the generic /api/request/<key> path unchanged.
		var DEDICATED_ROUTES = {};
		DEDICATED_ROUTES[Enums.services.PACKAGE_CALENDAR] = 'package-calendar';

		/**
		 * Makes an API request via our node endpoint instead of through the socket
		 * @param {Object} request The request object
		 * @returns {undefined}
		 */
		service.fetchHttp = function(request, options) {
			var AuthService = $injector.get('AuthService');

			var url,
				headers,
				key;

			request = service.addHttpStandardProperties(angular.isObject(request) ? request : {});
			key = request.request_type;

			url = DEDICATED_ROUTES[key]
				? service.getApiUrl() + '/api/' + DEDICATED_ROUTES[key]
				: service.getApiUrl() + '/api/request/' + (key ? key.toLowerCase() : '');

			if (!key || $rootScope.offline) {
				return $q.resolve({
					request_type: key,
					status: Enums.status.FAILED
				});
			}

			// Save purchase adds a property called SERVICE which also needs those same properties.
			if (angular.isObject(request.SERVICE)) {
				request.SERVICE = service.addHttpStandardProperties(request.SERVICE);
			}

			// If we dont have a cart_id and cart_key, we need to first request a getnewcartid
			if (key.toLowerCase() !== Enums.services.GET_NEW_CART_ID.toLowerCase() && (!service.cart.cart_id || !service.cart.cart_key)) {
				// Get a new cart, THEN call the original fetch.
				return service.fetch(Enums.services.GET_NEW_CART_ID, true, {}, true, true).then(function callOriginalFunction(data) {
					if (data.status === Enums.status.OK) {
						return service.fetchHttp(request, options);
					} else {
						$rootScope.hideSpinner();
						Modal.displayModal({
							category: 'Cart',
							action: 'Error',
							label: 'Error getting new cart id',
							title: Language.getLocale('Alert', 'generalErrorTitle'),
							description: Language.getLocale('Alert', 'generalErrorMsg')
						});
					}
				});
			}

			$log.log('[http request ]', key, '', request);

			headers = Utilities.merge({
				'com-accessopassport-app-id': 1500,
				'com-accessopassport-language': service.language,
				'com-accessopassport-merchant-id': service.merchantId,
				'com-accessopassport-client': options.sendToGlobalTenant ? 'Global' : service.island
			}, AuthService.getTokenRequestHeaders());

			return $http
				.post(url, request, {
					headers: headers,
				})
				.then(function handleHttpResponse(response) {
					var data = (response.data || {}).SERVICE || {};

					// Set the ip address if it comes back on the request
					if (checkProp('data._client_ip', data, 'validString')) {
						service.clientIP = data._client_ip;
					}

					return service
						.handleHttpResponseData(data, options)
						.then(function(newData) {
							return service.postHttpFetch(key, request, newData);
						});
				})
				.catch(function catchHttpError(err) {
					$log.error('fetchHttp error' + err);

					var data = {
						request_type: key,
						request_token: request.request_token,
						status: Enums.status.FAILED,
					};

					return service.handleHttpResponseData(data, options);
				});
		};

		/**
		 * Handles responses from fetchHttp
		 * @param {Object} data The response data
		 * @param {Object} options The options
		 * @returns {Promise} A Promise to resolve
		 */
		service.handleHttpResponseData = function(data, options) {
			var isOk = checkProp('data.status', data, 'returnValue') === Enums.status.OK,
				key = options.key,
				LegacyCart = $injector.get('LegacyCart');

			if (options.useStorage) {
				var storeIfOK = [
					Enums.services.INITIALIZE_SOCKET,
					Enums.services.GET_NEW_CART_ID,
					Enums.services.GET_APPLICATION_CONSOLIDATED,
					Enums.services.GET_MERCHANT_DETAILS,
					Enums.services.GET_MERCHANT_KEYWORDS,
					Enums.services.GET_MERCHANT_PACKAGE_LIST
				].map(normalize);

				if (isOk && storeIfOK.indexOf(normalize(key)) > -1) {
					// save data to AppData and localStorage
					service[key] = data;
					Storage.set(key, data, options.useCookie);
				}
			}

			if (options.saveOnService && isOk) {
				service[key] = data;
			}

			// update old cart service internals if the response is for get cart summary
			if (key === Enums.services.GET_CART_SUMMARY) {
				// If the response is OK, update the cart data
				if (isOk) {
					Storage.set('CartData', { qty: Utilities.forceInt(data.CART.qty), total: parseFloat(data.total || 0) }, options.useCookie);
				}

				LegacyCart.updateInternals(data);
			}

			if (CustomActionService.actionRegistered('RESPONSE_' + key)) {
				CustomActionService.executeCustomAction('RESPONSE_' + key, data);
			}

			if (service.keyRequiresGetNewCartId(key, data)) {
				service.handleInvalidCart(data.error_code);

				return $q.resolve(data);
			}

			if (checkProp('data.session_id', data, 'validString')) {
				$rootScope.sessionID = data.session_id;
			}

			$log.log('[http response]', key, data)

			// Do something with the data before responding to request.
			if (dataFormat[key]) {
				data = dataFormat[key](data);
			}

			//
			// Sometimes requests may not be valid due to V5 specific logic
			// that needs to be implemented. This gives us a chance to apply rules to
			// the results so that the results are correct.
			//
			try {
				if (service.postRequestHooks[key]) {
					var defer = $q.defer();

					service.postRequestHooks[key](data, function(d) {
						defer.resolve(service.resolvePromisesAndSetData(d || {}, options.force));
					});

					return defer.promise;
				}

				return service.resolvePromisesAndSetData(data || {}, options.force);
			} catch (e) {
				$log.error('Encountered error during post HTTP request hook processing: ' + e);
				return service.resolvePromisesAndSetData(data || {}, options.force);
			}
		};

		/**
		 * We make the following requests through the https endpoint
		 * @param {String} key The request key
		 * @returns {Boolean} true/false
		 */
		service.keyIsHttpRequest = function(key) {
			// We cant return true in our unit tests :(
			if ($window.jasmine) {
				return false;
			}

			return true;
		};

		/**
		 * Find out if the previous requests requires a GetCartSummary update call.
		 * @param {String} key  The request key
		 * @returns {Boolean} true/false
		 */
		service.keyRequiresGetCartSummary = function(key) {
			return ['getnewcartid', 'updatecartitems'].includes(key.toLowerCase());
		};

		/**
		 * Find out if we need to request SetExpressCheckout
		 * @param {String} key The request key
		 * @returns {Boolean} if we need to or not
		 */
		service.keyRequiresSetExpressCheckout = function(key, request) {
			return ['updatecartcheckoutinfo', 'getcartsummary'].includes(key.toLowerCase()) && (checkProp('req.skip_requests', request, 'getString') || '').toLowerCase().indexOf('setexpresscheckout') === -1;
		};

		/**
		 * Calls fetch set express checkout
		 * @param {Object} getCartSummaryResponse The GetCartSummary response
		 * @returns {Promise} To resolve this
		 */
		service.fetchSetExpressCheckout = function(getCartSummaryResponse) {
			var APP_CONFIG_PROP = 'AppData.GetApplicationConsolidated.SETTINGS',
				payPalAllowedBillingTypes = checkProp(APP_CONFIG_PROP + '.allowedBillingTypes', service, 'returnValue'),
				payPalBillingTypes = checkProp(APP_CONFIG_PROP + '.billing_types', service, 'returnValue'),
				canRequest = false,
				request = {};

			// Get one half of the PayPal information
			if (validString(payPalAllowedBillingTypes) && payPalAllowedBillingTypes.indexOf('PPA') > -1) {
				canRequest = true;
			} else if (validString(payPalBillingTypes) && payPalBillingTypes.indexOf('PPA') > -1) {
				canRequest = true;
			}

			// If we can't request, the GCS response failed or the total is 0, don't continue.
			if (!canRequest || checkProp('data.status', getCartSummaryResponse, 'returnValue') !== Enums.status.OK || !Utilities.forceInt(getCartSummaryResponse.total)) {
				return $q.resolve();
			}

			request.amount = getCartSummaryResponse.total || '';
			request.retail_total = getCartSummaryResponse.retail_total || '';
			request.fee_total = getCartSummaryResponse.fee_total || '';
			request.ship_total = getCartSummaryResponse.ship_total || '';
			request.tax_total = getCartSummaryResponse.tax_total || '';
			request.cart_adjustment_total = getCartSummaryResponse.cart_adjustment_total || '';
			request.ITEMS = getCartSummaryResponse.CART.ITEMS;
			request.CART_ADJUSTMENTS = getCartSummaryResponse.CART_ADJUSTMENTS;
			request.FEES = getCartSummaryResponse.FEES;

			if (checkProp('data.PAYMENT_SCHEDULE.PAYMENT', getCartSummaryResponse)) {
				request.has_deferred = '1';
			}

			// Verify we have sufficient data for sending this request. Taken directly from Node.
			canRequest = !['return_url', 'cancel_url', 'amount', 'retail_total', 'fee_total', 'ship_total', 'tax_total', 'cart_adjustment_total'].some(function(key) {
				return request[key] === '';
			})

			if (canRequest) {
				return $injector.get('PayPalService').handleExpressCheckout(null, request);
			}

			return $q.resolve();
		}

		/**
		 * Find out if the previous requests requires a GetNewCartID update call.
		 * @param {String} key  The request key
		 * @param {Object} response The response object
		 * @returns {Boolean} true/false
		 */
		service.keyRequiresGetNewCartId = function(key, response) {
			var errorMessage;

			if (key !== 'GetCartSummary' || response.status !== 'FAILED') {
				return false;
			}

			errorMessage = (response.error_msg || '').toLowerCase();

			return parseInt(response.error_code, 10) === 408 || errorMessage.indexOf('invalid cart_id or cart_key') > -1 || errorMessage.indexOf('failed to initialize cart info') > -1;
		};

		/**
	 * ## Fetch Data
	 *
	 * @param {String} key Data source to request
	 * @param {Boolean} useStorage set/get from localStorage, NOTE, there is a 3rd option, we can append to it.
	 * @param {Object} request JSON formatted request for server
	 * @param {Boolean} force true to force the request and bypass cache
	 * @param {Boolean} useCookie true to use cookies instead of localStorage
	 * @param {Boolean} saveOnService true to save the data on the service object
	 * @param {Boolean} sendToGlobalTenant [optional] true to send the request to the global tenant instead of the island specific one
	 *
	 * @return {Object} a $q.defer().promise for the data requested
	 *
	 */

		service.fetch = function(key, useStorage, request, force, useCookie, saveOnService, sendToGlobalTenant) {
		// Define a 2nd method for accessing the variables from within the event listener below.
			// adjust the request to add in the cartRecovery flag, if appropriate
			if (service.cartRecovery && key == Enums.services.GET_CART_SUMMARY) {
				if (angular.isObject(request) && request != null) {
					if (angular.isArray(request.addRequestParameters)) {
						request.addRequestParameters.push('cartRecovery');
					} else {
						request.addRequestParameters = ['cartRecovery'];
					}
					request.cartRecovery = "1";
				} else {
					request = {
						addRequestParameters: ['cartRecovery'],
						cartRecovery: "1"
					};
				}
				// once we've sent it once, don't send it again.
				service.cartRecovery = false;
			}

			var self = {};
			// Define the variables internal to function.
			self.key = key;
			self.saveOnService = saveOnService;
			self.useStorage = !!((angular.isDefined(useStorage) && useStorage));
			self.useCookie = !!((angular.isDefined(useCookie) && useCookie));
			self.request = (angular.isDefined(request) && request) ? request : false;
			self.force = !!((angular.isDefined(force) && force));
			// attach the is http key if we're going to send this as an http request instead of through the socket
			self.isHttpKey = service.keyIsHttpRequest(key);
			if (sendToGlobalTenant) {
				self.sendToGlobalTenant = sendToGlobalTenant;
			}

			// Define a 2nd method for accessing the variables from within the event listener below.

			// Using Angular.JS promise/defer system.
			var defer = $q.defer();

			// fail if no key is provided
			if (!self.key) {
				defer.reject('!! fetch invalid key');
				return defer.promise;
			}

			// use force to force the request and bypass cache
			var data;
			var dataSource = '';
			if (!self.force && self.useStorage) {
				data = service[self.key] ? service[self.key] : false;
				if (data) {
					if (checkProp('data.session_id', data, 'validString')) {
						$rootScope.sessionID = data.session_id;
					}
					dataSource = 'Memory';
				}
			}

			// set data from stored object AppData if it exists
			if (!self.force && !data && self.useStorage) {
				data = Storage.get(self.key);

				service[self.key] = data;
				if (data) {
					if (dataFormat[ self.key ]) {
						data = dataFormat[ self.key ](data, defer);
					}
					dataSource = 'LocalStorage';
				} else if (self.useCookie) {
					data = Storage.get(self.key, true);
					if (data) {
						if (dataFormat[ self.key ]) {
							data = dataFormat[ self.key ](data, defer);
						}
						dataSource = 'Cookie';
					}
				}
			}

			/**
		 * if we have data already, return right away, using defer.resolve,
		 * otherwise, get data.
		 */
			if (data) {
				$log.log('<< fetch', key, useStorage, request, force);
				$log.log('>> fetch', data.request_type, dataSource, data);
				service.resolvePromisesAndSetData(data, self.force).then(function(newdata) {
					defer.resolve(newdata);
				});
			} else {
				// no stored data, so we must depend on the server for it
				// if a request was defined, we should process it
				if (self.request) {
					self.request = typeof self.request === 'object' ? self.request : {};

					// replace 'null' properties/element from request
					self.request = validArray(self.request) ? Utilities.replaceElementInArr(self.request, null, '') : Utilities.replaceObjProperty(self.request, null, '');

					// let Connection format this request as needed
					self.request = Connection.format(self.key, self.request, service.merchantId);

					// attach a randomly generated token to the request
					self.request.request_token = getToken();

					return service.fetchHttp(self.request, self);
				}
				defer.reject('AppData.fetch(): Missing request object');
			}

			return defer.promise;
		};

		var validatingFlag = {
				notValidating: 0,
				duplicateUIDValidation: 1
			/* Currently only using the validatingFlag in the duplicateIDValidation rule. If we need it in other rules,
			 * uncomment and use the following constants:
			oneBarCodeValidation: 2,
			invalidQtyValidation: 3,
			merchantIdValidation: 4
			 */
			},
			currentlyValidating = validatingFlag.notValidating;
		service.postRequestHooks = {

			GetCartSummary: function(data, finalize) {
				var rules = [
					{
						name: "duplicateUIDValidation",
						validator: function(data) {
							/* We have found cases of duplicate items in the cart.
							 * This rule finds the duplicate items and deletes them, then shows the customer a modal.
							 */

							var
								cartWithDuplicatePackages = $q.defer(),
								result = {
									error: false,
									itemsRemoved: 0
								},
								errorData = { status: Enums.status.FAILED },
								idsFound = [],
								i = 0,
								cartItems = checkProp('data.CART.ITEMS.ITEM', data) ? angular.copy(data.CART.ITEMS.ITEM) : undefined;


							if (currentlyValidating == validatingFlag.duplicateUIDValidation) {
								// This stops a potential endless loop that could occur if a cart continues to have duplicate items in it.
								currentlyValidating = validatingFlag.notValidating;
								cartWithDuplicatePackages.resolve(data);
								return;
							}
							currentlyValidating = validatingFlag.duplicateUIDValidation;


							// find any duplicate ids
							if (angular.isDefined(cartItems)) {
								for (i = 0; i < cartItems.length; i++) {
									var characWithUid = (angular.isDefined(cartItems[i].CHARACS) ? cartItems[i].CHARACS.filter(function(charac) {
										return angular.isDefined(charac.uid);
									})[0]:undefined);
									if (angular.isDefined(characWithUid)) {
										var newId = {
											isDuplicate: false,
											uid: characWithUid.uid
										};
										for (var j = 0; j < idsFound.length && !newId.isDuplicate; j++) {
											if (newId.uid == idsFound[j].uid) {
												newId.isDuplicate = true;
												idsFound[j].isDuplicate = true;
												result.error = true;
											}
										}
										if (!newId.isDuplicate) {
											idsFound.push(newId);
										}
									}
								}
							}

							// Step through idsFound and delete the duplicates from the cart:
							if (result.error) {
								idsFound.forEach(function(uid) {
									if (uid.isDuplicate) {
										for (i = cartItems.length - 1; i >= 0; i--) {
											var characWithUid = (angular.isDefined(cartItems[i].CHARACS) ? cartItems[i].CHARACS.filter(function(charac) {
												return angular.isDefined(charac.uid);
											})[0]:undefined);
											if (angular.isDefined(characWithUid) && characWithUid.uid == uid.uid) {
												result.itemsRemoved = result.itemsRemoved + 1;
												cartItems.splice(i, 1);
											}
										}
									}
								});
								// We're in the error state. Update the cart items, and then generate another call to Get Cart Summary
								$log.info('Found ' + result.itemsRemoved.toString()+' Duplicate Item UIDs in Cart');
								errorTracking.notify('Duplicate Item UID', 'Found ' + result.itemsRemoved.toString()+' Duplicate Item UIDs in Cart');
								$rootScope.pendingRequests.push(Enums.services.UPDATE_CART_ITEMS);
								service.fetch
								(
									Enums.services.UPDATE_CART_ITEMS
									, false
									, cartItems
								).then
								(
									function(updateCartData) {
										$rootScope.removePendingRequest(Enums.services.UPDATE_CART_ITEMS);
										if (updateCartData.status == Enums.status.OK) {
											$rootScope.pendingRequests.push(Enums.services.GET_CART_SUMMARY);
											service.fetch
											(
												Enums.services.GET_CART_SUMMARY
												, false
											).then
											(
												function(newGetCartSummaryData) {
													currentlyValidating = validatingFlag.notValidating;
													$rootScope.removePendingRequest(Enums.services.GET_CART_SUMMARY);
													newGetCartSummaryData.status = Enums.status.ERROR;
													Modal.displayModal({
														category: 'Error',
														label: 'Duplicate Items in Cart',
														title: Language.getLocale('Alert', 'cartErrorAddingItemTitle'),
														icon: 'icon icon-caution caution-yellow',
														description: Language.getLocale('Alert', 'cartErrorAddingItemMsg'),
														showCloseButton: false,
														hideAllButtons: false,
														//callback: function(){$rootScope.routeTo('reset/true')},
														customCss: { topModal: 'top-modal' }
													});
													cartWithDuplicatePackages.resolve(newGetCartSummaryData);
												});
										} else {
											// If the update failed, resolve with errored data.
											errorTracking.notify('Duplicate Item UID', 'Unable to Remove Duplicate Item UIDs from Cart');
											currentlyValidating = validatingFlag.notValidating;
											Modal.displayModal({
												category: 'Error',
												label: 'Duplicate Items in Cart',
												title: Language.getLocale('Alert', 'cartErrorAddingItemTitle'),
												icon: 'icon icon-caution caution-yellow',
												description: Language.getLocale('Alert', 'cartErrorAddingItemMsg'),
												showCloseButton: false,
												hideAllButtons: false,
												//callback: function(){$rootScope.routeTo('reset/true')},
												customCss: { topModal: 'top-modal' }
											});
											cartWithDuplicatePackages.resolve(errorData);
										}
										// Notify the user the world has come to an end.
									});
							} else {
								currentlyValidating = validatingFlag.notValidating;
								cartWithDuplicatePackages.resolve(data);
							}
							return cartWithDuplicatePackages.promise;
						}

					},
					{
					/*
					 * When removing packages (or modifying them) it is possible for the cart to get into an invalid state
					 * that is legal to backend, but not legal in terms of OneBarCode. As such, this validator will
					 * examine the request to determine that no child packages exist without a parent onebarcode.
					 * If they exist, they will be removed.
					 */
						name: "OneBarCodeChecks",
						validator: function(data) {
						// look for cases of packages with the
						// group_uuid charac WITHOUT a matching parent.
							var oneBarCodeCheckPromise = $q.defer();

							if (checkProp("data.CART.ITEMS.ITEM", data)==false) {
								oneBarCodeCheckPromise.resolve(data);
							} else {
							// an array of cart items, minus error items.
								var cartItems = data.CART.ITEMS.ITEM.filter(function(item) {
									return angular.isUndefined(item.action) || (item.action.toLowerCase()!=="error" && item.action.toLowerCase()!=="warning");
								});

								// filter out anything with errors

								// extract a list of group uuids to check
								var groupUUIDS = cartItems.filter(
									function(item) {
										return angular.isDefined(item.CHARACS) && angular.isDefined(item.CHARACS[0].group_uuid);
									}).map(function(item) {
									return item.CHARACS[0].group_uuid;
								});

								// make sure EVERY one of these has a parent

								var itemsWithoutAParent = cartItems.filter(function(item) {
									if (!angular.isDefined(item.CHARACS)) {
										return false;
									}

									if (angular.isDefined(item.CHARACS[0].group_uuid) && (angular.isUndefined(item.CHARACS[0].one_barcode_parent) || item.CHARACS[0].one_barcode_parent === "0")) {
										// does this have a parent package?
										return cartItems.filter(function(subItem) {
											return angular.isDefined(subItem.CHARACS) && angular.isDefined(subItem.CHARACS[0].one_barcode_parent) && subItem.CHARACS[0].one_barcode_parent==="1" && subItem.CHARACS[0].group_uuid===item.CHARACS[0].group_uuid;
										}).length == 0;
									}
									return false;
								});


								if (itemsWithoutAParent.length > 0) {
									$log.info("[appdata] Detected cart items that violate the onebarcode parent rule. Scheduling them for removal.");

									var update = cartItems.filter(function(item) {
										return itemsWithoutAParent.filter(function(badItem) {
											$log.info("[appdata] Removing item: ", badItem);
											return badItem === item;
										}).length === 0;
									});

									$rootScope.pendingRequests.push(Enums.services.UPDATE_CART_ITEMS);
									service.fetch
									(
										Enums.services.UPDATE_CART_ITEMS
										, false
										, update
									).then
									(
										function(updateCartData) {
											$rootScope.removePendingRequest(Enums.services.UPDATE_CART_ITEMS);
											if (updateCartData.status == Enums.status.OK) {
												$rootScope.pendingRequests.push(Enums.services.GET_CART_SUMMARY);
												service.fetch
												(
													Enums.services.GET_CART_SUMMARY
													, false
												).then
												(
													function(newGetCartSummaryData) {
														$rootScope.removePendingRequest(Enums.services.GET_CART_SUMMARY);
														newGetCartSummaryData.status = Enums.status.ERROR;
														oneBarCodeCheckPromise.resolve(newGetCartSummaryData);
													});
											} else {
												oneBarCodeCheckPromise.resolve(data);
											}
										});
								} else {
									oneBarCodeCheckPromise.resolve(data);
								}
							}

							return oneBarCodeCheckPromise.promise;
						}
					},
					{
						/*
						 * When removing packages (or modifying them) it is possible for the cart to get into an invalid state
						 * that is legal to backend, but not legal in terms of OneBarCode. As such, this validator will
						 * examine the request to determine that no child packages exist without a parent onebarcode.
						 * If they exist, they will be removed.
						 */
						name: "OneBarCodeRequiresChildrenChecks",
						validator: function(data) {
							// look for cases of packages with the
							// group_uuid charac WITHOUT a matching parent.
							var oneBarCodeCheckPromise = $q.defer();

							if (!checkProp("data.CART.ITEMS.ITEM", data)) {
								oneBarCodeCheckPromise.resolve(data);
							} else {
								// an array of cart items, minus error items.
								var cartItems = data.CART.ITEMS.ITEM.filter(function(item) {
									return angular.isUndefined(item.action) || (item.action.toLowerCase()!=="error" && item.action.toLowerCase()!=="warning");
								});

								// filter out anything with errors

								// extract a list of group uuids to check
								var groupUUIDS = cartItems.filter(
									function(item) {
										return angular.isDefined(item.CHARACS) && angular.isDefined(item.CHARACS[0].group_uuid);
									}).map(function(item) {
									return item.CHARACS[0].group_uuid;
								});

								// make sure EVERY one of these has a parent

								var itemsWithoutChildren = cartItems.filter(function(item) {
									if (!angular.isDefined(item.CHARACS)) {
										return false;
									}

									if (angular.isDefined(item.CHARACS[0].group_uuid)
										&& Utilities.getBoolean(item.CHARACS[0].one_barcode_parent)
										&& Utilities.getBoolean(item.CHARACS[0].requires_onebarcode_children)) {
										// does this have a child package?
										return cartItems.filter(function(subItem) {
											return angular.isDefined(subItem.CHARACS)
												&& angular.isDefined(subItem.CHARACS[0].group_uuid)
												&& (angular.isUndefined(subItem.CHARACS[0].one_barcode_parent) || subItem.CHARACS[0].one_barcode_parent === "0")
												&& subItem.CHARACS[0].group_uuid===item.CHARACS[0].group_uuid;
										}).length == 0;
									}
									return false;
								});


								if (itemsWithoutChildren.length > 0) {
									$log.info("[appdata] Detected cart items that violate the onebarcode parent rule when requiring children. Scheduling them for removal.");

									var update = cartItems.filter(function(item) {
										return itemsWithoutChildren.filter(function(badItem) {
											$log.info("[appdata] Removing item: ", badItem);
											return badItem === item;
										}).length === 0;
									});

									$rootScope.pendingRequests.push(Enums.services.UPDATE_CART_ITEMS);
									service.fetch
									(
										Enums.services.UPDATE_CART_ITEMS
										, false
										, update
									).then
									(
										function(updateCartData) {
											$rootScope.removePendingRequest(Enums.services.UPDATE_CART_ITEMS);
											if (updateCartData.status == Enums.status.OK) {
												$rootScope.pendingRequests.push(Enums.services.GET_CART_SUMMARY);
												service.fetch
												(
													Enums.services.GET_CART_SUMMARY
													, false
												).then
												(
													function(newGetCartSummaryData) {
														$rootScope.removePendingRequest(Enums.services.GET_CART_SUMMARY);
														newGetCartSummaryData.status = Enums.status.ERROR;
														Modal.displayModal(
															{
																category: 'Cart [Update Cart Items]',
																action: 'Error',
																label: 'Cart Error No PreReq Items',
																title: Language.getLocale('Alert', 'cartErrorNoPreReqItemsTitle'),
																description: Language.getLocale('Alert', 'cartErrorNoPreReqItemsMsg')
															}
														);

														oneBarCodeCheckPromise.resolve(newGetCartSummaryData);
													});
											} else {
												oneBarCodeCheckPromise.resolve(data);
											}
										});
								} else {
									oneBarCodeCheckPromise.resolve(data);
								}
							}

							return oneBarCodeCheckPromise.promise;
						}
					},
					{
						/*
						 * When removing packages we may get an invalid qty when removing a multipack package
						 * The cart currently has logic to suppress the error message if invalid qty is returned back on getCartSummary
						 * but we really need to resend a GetCartSummary call to ensure that the cart comes back valid
						 */
						name: "CartWithInvalidQtyOnlyChk",
						validator: function(data) {
							var cartWithInvalidQtyOnlyChkPromise = $q.defer();
							if (!checkProp("data.CART.ITEMS.ITEM", data)) {
								cartWithInvalidQtyOnlyChkPromise.resolve(data);
							} else {
							// an array of cart items, minus error items.
								var totalErrorItems = data.CART.ITEMS.ITEM.filter(function(item) {
									return (angular.isDefined(item.action) && item.action.toLowerCase()==="error");
								});

								var invalidQtyErrorItems = totalErrorItems.filter(function(item) {
									return (item.error_msg.toLowerCase() === "invalid quantity");
								});

								//if we have only invalid qty errors we need to call getCartSummary again
								if (invalidQtyErrorItems.length > 0 && (totalErrorItems.length === invalidQtyErrorItems.length)) {
									$rootScope.pendingRequests.push(Enums.services.GET_CART_SUMMARY);
									service.fetch
									(
										Enums.services.GET_CART_SUMMARY,
										false,
										{},
										true
									).then
									(
										function(newGetCartSummaryData) {
											$rootScope.removePendingRequest(Enums.services.GET_CART_SUMMARY);
											cartWithInvalidQtyOnlyChkPromise.resolve(newGetCartSummaryData);
										});
								} else {
									cartWithInvalidQtyOnlyChkPromise.resolve(data);
								}
							}

							return cartWithInvalidQtyOnlyChkPromise.promise;
						}

					},
					{
						/*
						 * When attempting to recover a cart via cart abandonment link
						 * if the merchant id on the recovered cart is not the same as the merchant id of the current store then
						 * get a new empty cart
						 * This scenario occurs prior to single merchant and if the user attempts to recover a cart from the
						 * cart abandonment link using a mobile device.
						 */
						name: "CartMerchantIdMustMatchCurrentMerchantId",
						validator: function(data) {
							var cartMerchantIdMustMatchCurrentMerchantId = $q.defer();
							// Note, we do not check for any items in the cart prior to performing this check on purpose.
							// This condition is not a valid state for the store to be in
							// so an immediate reset is the best course of action as opposed to
							// waiting until the user has something in their cart.
							// - jeffery.wroblewski

							// test for matching merchant id's
							if (data.status === Enums.status.OK &&
								parseInt(data.CART.merchant_id) !== service.merchantId) {
								$log.info("[appdata] Finalizing request pipeline. Last executed hook: CartMerchantIdMustMatchCurrentMerchantId.");

								// Reset the store with a new empty cart
								// This removes all query string parameters (it won't re-load a valid store on localhost)
								Utilities.routeTo('/reset/true');
							} else {
								cartMerchantIdMustMatchCurrentMerchantId.resolve(data);
							}

							return cartMerchantIdMustMatchCurrentMerchantId.promise;
						} // validator function
					} // rule object
					//TODO: If onebarcode parent and has characs requires_onebarcode_children with no addons, delete parent
				];


				/**
				 * Ensure the rules get execute in order as the GetCartSummary data can change since some of the rules will run
				 * another GetCartSummary request.  If we do that, then the result data we get back from the rule will be different.
				 * If the data comes back different, lets replace the original data object with the new data we got back and ultimately
				 * that is what we will resolve.  This will prevent timing issues and the
				 *
				 * @param index
				 */
				function executeRuleValidation(index) {
					if (index < (rules.length - 1)) {
						//lets execute the validator promise
						rules[index].validator(data).then(function(resultData) {
							if (!angular.equals(resultData, data)) {
								data = angular.copy(resultData);
							}
							executeRuleValidation(index + 1);
						});
					} else {
						//lets finalize the data we have
						finalize(data);
					}
				}

				//lets execute the rules starting at the 0 index
				executeRuleValidation(0);
			}
		};


		var dataFormat =
			{
				GetCreditCardBinInfo: function(data) {
					var isObject = angular.isObject;

					if (!isObject(data)) {
						data = { RANGE: [] };
					} else if (!isObject(data.RANGE) && !Array.isArray(data.RANGE)) {
						data.RANGE = [];
					}

					data.RANGE = wrapObjectToArray(data.RANGE);

					return data;
				},
				GetApplicationConsolidated: function(data) {
					if (data.status == Enums.status.FAILED) {
					// TODO: Handle the reject
					// Hack to Route to 1001
						_data = {};
						_data.error = 1001;
						_data.data = data;
						routeToErrorPage(_data, Enums.errorRoutes.FAILED_TO_INIT);
						return;
					}

					Utilities.arrayWrap(data, 'TREE.MENUITEM');

					service.settings = data.SETTINGS;

					if (!$rootScope.sessionID && data.session_id) {
						$rootScope.sessionID = data.session_id;
					}

					if (!Utilities.childDefined(service, 'settings.cartAbandonment')) {
						service.settings.cartAbandonment = false
					} else {
						service.settings.cartAbandonment = Utilities.getBoolean(service.settings.cartAbandonment)
					}

					var replacements = [];
					if (((data).SETTINGS || {}).support_phone_number) {
						replacements.push({
							key: '@@supportPhoneNumber',
							value: data.SETTINGS.support_phone_number
						});
					}

					var locale_overrides = {};
					if (((data).SETTINGS || {}).locale_overrides) {
						try {
							locale_overrides = JSON.parse(data.SETTINGS.locale_overrides);
						} catch (error) { }
					}

					var monthCharacterToRemove = '';
					if (checkProp('data.SETTINGS.month_character_to_remove', data)) {
						monthCharacterToRemove = data.SETTINGS.month_character_to_remove;
					}

					Language.setData(data.LANGUAGE, replacements, locale_overrides, monthCharacterToRemove);
					$rootScope.state.loadingMessage = Language.getLocale('ApplicationLabels', 'loadingMsg');

					if (data.languages) {
						var availableLanguages = data.languages.split(' ').join('').split(',');
						var enabledLanguages = availableLanguages
						if (service.settings.languages) {
							enabledLanguages = service.settings.languages.split(' ').join('').split(',');
						}
						var langLocales = (((data).LANGUAGE || {}).Language || {}).LT || '';
						service.languages = [];
						angular.forEach
						(enabledLanguages
							, function(language) {
								if (availableLanguages.indexOf(language) > -1) {
									var languageLocale = $filter('filter')(langLocales, { target: language }, true);
									if (languageLocale.length) {
										service.languages.push(languageLocale[0]);
									}
								}
							}
						);
					}

					return data;
				},
				GetMerchantDetails: function(data) {
					if (data.status == Enums.status.FAILED) {
						// TODO: Handle the reject
						// Hack to Route to 1001
						_data = {};
						_data.error = 1001;
						_data.data = data;
						routeToErrorPage(_data, Enums.errorRoutes.FAILED_TO_INIT);
					} else if (typeof data.BILLINGTYPE === 'undefined' && typeof data.PAYMENTTYPE === 'undefined') {
						// TODO: Handle the reject
						// Hack to Route to 1001
						_data = {};
						_data.error = 1001;
						_data.data = data;
						routeToErrorPage(_data, Enums.errorRoutes.FAILED_TO_INIT);
					}
					/*
					else if( typeof data.SHIPPINGMETHOD == 'undefined' ){
					// TODO: Handle the reject
					// Hack to Route to 1001
					_data = {};
					_data.error = 1001;
					_data.data = data;
					routeToErrorPage( _data, Enums.errorRoutes.FAILED_TO_INIT );
					}
					 */
					if (typeof data.BILLINGTYPE != 'undefined') {
						data.BILLINGTYPE = angular.isArray(data.BILLINGTYPE) ? data.BILLINGTYPE : [data.BILLINGTYPE];
						var billingTypes = data.BILLINGTYPE;
						if (billingTypes.length > 0) {
							service.billingTypes = [];
							for (var i in billingTypes) {
							/*Check uniqueness of payment method and increment service.paymentMethodCount if unique*/
								var isUniquePaymentMethod = true;

								for (var k in service.billingTypes) {
								//we should set up unique payment methods based on auth types - not billing types - per backend
									if (billingTypes[i].auth_type == service.billingTypes[k].auth_type) {
										isUniquePaymentMethod = false;
										break;
									}
								}

								service.billingTypes.push(billingTypes[i]);

								if (isUniquePaymentMethod) {
									service.paymentMethodCount++;
								}
							}
						}
					} else {
						service.bankList = [];
						service.billingTypes = [];
					}

					if (angular.isObject(data.PAYMENTTYPE) || Array.isArray(data.PAYMENTTYPE)) {
						data.PAYMENTTYPE = wrapObjectToArray(data.PAYMENTTYPE);
						PaymentTypeService.mergeBillingTypesAndPaymentTypes(service, data.PAYMENTTYPE);
					}

					// ensure raw_card_type_list is always an array (it comes in as a comma-delimited list)
					service.billingTypes.forEach(function(type) {
						type.raw_card_type_list = validString(type.raw_card_type_list) ? type.raw_card_type_list.split(',') : [];
					});

					// Extract merchant characs included via include_characs="1"
					if (angular.isDefined(data.CHARAC)) {
						Utilities.arrayWrap(data, 'CHARAC');
						data.CHARAC.forEach(function iterateMerchantCharacs(charac) {
							if (charac && charac.key === 'cart_level_discount_rate_limit_time_window') {
								service.discountRateLimitMinutes = Math.max(15, Utilities.forceInt(charac.value) || 15);
							}
						});
					}

					return data;
				},
				GetMerchantKeywords: function(data) {
					return data;
				},
				GetMerchantPackageEventDates: function(data) {
					if (data.status == Enums.status.OK) {
						try {
							Utilities.arrayWrap(data, 'D');
						} catch (e) {}
					}
					return data;
				},
				GetEventSeats: function(data) {
					if (data.status == Enums.status.OK) {
						try {
							Utilities.arrayWrap(data, 'SEAT');
						} catch (e) {}
					}
					return data;
				},
				GetWizardMPEventDates: function(data) {
					if (data.status == Enums.status.OK) {
						try {
							Utilities.arrayWrap(data, 'D');
						} catch (e) {}
					}
					return data;
				},
				GetMerchantPackageList: function(data) {
					// Grabs the ul tag (if defined) in the package details and creates the list below the images.
					// TODO: This will need to be removed after back-end catches up with Enterprise update.
					/* Expected data:
					<ul>
					<li>Vestibulum vulputate ullamcorper</li>
					<li>Inceptos parturient egestas</li>
					<li>Malesuada porta</li>
					</ul>
					 */
					if (data.status == Enums.status.FAILED) {
						//defer.reject()
					} else {
						try {
							Utilities.arrayWrap(data, 'PS.P');

							angular.forEach
							(
								data.PS.P,
								function(pkgItem, i) {
									if (pkgItem.CT) {
										// Wrap all CTs in array.
										Utilities.arrayWrap(pkgItem, 'CT');

										if (angular.isDefined(pkgItem.KEYWORDS)) {
											Utilities.arrayWrap(pkgItem.KEYWORDS, 'K');
											pkgItem.keyword = pkgItem.KEYWORDS.K.map(function(k) {
												return k.keyword;
											}).join(',');
										}

										angular.forEach
										(
											pkgItem.CT,
											function(custType, j) {
												if (custType.APP) {
													// Wrap all APPs in array.
													Utilities.arrayWrap(custType, 'APP');
												}
											}
										)
									}
								}
							);

							// Could not inject AppData directly into GatePriceComparison due to circular dependency.
							// Configures packages with gate pricing details.
							GatePriceComparison.init(service);

							var packageList = data.PS.P;
							orderPackageList(packageList);
							for (var i = 0; i < packageList.length; i++) {
								packageList[i].listItems = packageList[i].listItems || [];

								if (packageList[i].listItems.length > 0) {
									continue;
								}

								var s = packageList[i].desc;
								// Debugging
								// var s = '<ul class="mobile-package-bullets"><li>H Vestibulum vulputate ullamcorper</li><li>H Inceptos parturient egestas</li><li>H Malesuada porta</li></ul>';
								// packageList[i].desc += s;

								var startingUlIdx = packageList[i].desc.indexOf('<ul class="mobile-package-bullets">');
								var endingUlIdx = packageList[i].desc.indexOf('</ul>');
								endingUlIdx = (endingUlIdx > -1) ? endingUlIdx + 5 : -1;

								if (startingUlIdx == -1 || endingUlIdx == -1) {
									continue;
								}

								var ul = packageList[i].desc.substring(startingUlIdx, endingUlIdx);

								// Remove the list from the description.
								packageList[i].desc = packageList[i].desc.split(ul).join(' ');

								ul = ul.substring(31, ul.length - 10);

								var listItems = ul.split('</li><li>');
								for (var j = 0; j < listItems.length; j++) {
									if (listItems[j] == "") {
										listItems.splice(j, 1);
									}
								}

								while (listItems.length > 3) {
									listItems.pop();
								}

								packageList[i].listItems = listItems;
							}
						} catch (e) {
							throw new Error('An error occured while transforming GetMerchantPackageList response.');
						}
					}

					return data;
				},
				GetNewCartID: function(data) {
					if (data.status == Enums.status.FAILED) {
						//defer.reject()
					} else {
						if (typeof data.cart_key == 'undefined' || typeof data.cart_id == 'undefined') {
							// Hack to Route to 1001
							_data = {};
							_data.error = 1001;
							_data.data = data;
							routeToErrorPage(_data, Enums.errorRoutes.FAILED_TO_INIT);
						} else {
							service.cart.cart_key = data.cart_key;
							service.cart.cart_id = data.cart_id;
							service.cart.session_id = data.session_id || '';

						}
					}

					if (!$rootScope.sessionID && data.session_id) {
						$rootScope.sessionID = data.session_id;
					}

					return data;
				},
				GuestViewOrder: function(data) {
					if (data.status == Enums.status.OK) {
						Utilities.arrayWrap(data, 'VIEW_ORDER_REPLY.TICKET_DETAILS_REPLY.TICKET');
						Utilities.arrayWrap(data, 'VIEW_ORDER_REPLY.PAYMENT_DETAILS.PAYMENT');

						if (angular.isArray((((data).VIEW_ORDER_REPLY || {}).TICKET_DETAILS_REPLY || {}).TICKET)) {
							angular.forEach
							(
								data.VIEW_ORDER_REPLY.TICKET_DETAILS_REPLY.TICKET,
								function(ticket) {
									if (ticket.CHARACS && ticket.CHARACS.customer_name && !ticket.CHARACS.ticket_customer_name) {
										ticket.CHARACS.ticket_customer_name = ticket.CHARACS.customer_name;
									}
								}
							);
						}
					} else if (data.status == Enums.status.FAILED) {
						//defer.reject()
					}

					return data;
				},
				GetCartSummary: function(data) {
					if (data.status == Enums.status.FAILED) {
						//defer.reject()
					} else {
						if (Utilities.childDefined(data, 'CART.ITEMS.ITEM')) {
							Utilities.arrayWrap(data, 'CART.ITEMS.ITEM')

							for (var i = data.CART.ITEMS.ITEM.length - 1; i >= 0; i--) {
								var cartItem = data.CART.ITEMS.ITEM[ i ];

								if (parseInt(cartItem.qty) == 0) {
									// remove 0 qty items. this can happen as part of the overrideCompQty CHARAC flow
									data.CART.ITEMS.ITEM.splice(i, 1);
									continue;
								}

								// Ensure CHARACS are stored as array.
								Utilities.arrayWrap(cartItem, 'CHARACS');
							}
						}

						if (Utilities.childDefined(data, 'PAYMENT_SCHEDULE.PAYMENT')) {
							Utilities.arrayWrap(data, 'PAYMENT_SCHEDULE.PAYMENT');
						}

						if (Utilities.childDefined(data, 'FUTURE_PAYMENTS.PAYMENT')) {
							Utilities.arrayWrap(data, 'FUTURE_PAYMENTS.PAYMENT');
						}

						Utilities.arrayWrap(data, 'CART_ADJUSTMENTS.CA');
						Utilities.arrayWrap(data, 'POTENTIAL_CART_ADJUSTMENTS.CA')
						Utilities.arrayWrap(data, 'FEES.F')
						Utilities.arrayWrap(data, 'SHIPPING_METHODS.S')
						Utilities.arrayWrap(data, 'CHECKOUT_KEYWORDS.K');

						service.GetCartSummary = data;

						$rootScope.$broadcast('getCartSummaryResponse', data);
					}

					return data;
				},
				GetKeywordCalendar: function(data) {
					if (data.status == Enums.status.FAILED) {
					} else if (angular.isDefined(data.DATES) && angular.isDefined(data.DATES.D)) {
						Utilities.arrayWrap(data.DATES, 'D');

						/**
						 * GetKeywordCalendar has a fun quirk. It can send a separate packages for each customer type... instead
						 * of them all being on the same package. Fun!
						 */
						data.DATES.D = data.DATES.D.map(function fixBadApi(date) {
							var packageMap = {};
							var datePackages = wrapObjectToArray(checkProp('date.PS.P', date, 'returnValue'), true);

							datePackages.forEach(function addCtsTogether(pkg) {
								if (!packageMap[pkg.id]) {
									pkg.CT = wrapObjectToArray(pkg.CT, true);
									packageMap[pkg.id] = pkg;
								} else {
									packageMap[pkg.id].CT = wrapObjectToArray(packageMap[pkg.id].CT, true).concat(wrapObjectToArray(pkg.CT, true));
								}
							});

							date.PS.P = Object.keys(packageMap).map(function(pkgId) {
								GatePriceComparison.setGatePriceOnPkgItem(packageMap[pkgId]);
								return packageMap[pkgId];
							});

							return date;
						});
					}

					return data;
				},
				GetPaymentSchedule: function(data) {
					if (angular.isDefined(data.PAYMENT_SCHEDULE) && angular.isArray(data.PAYMENT_SCHEDULE)) {
						data.PAYMENT_SCHEDULE.forEach(function(schedule) {
							Utilities.arrayWrap(schedule, 'PAYMENT_SCHEDULE.PAYMENT');
						});
					} else {
						Utilities.arrayWrap(data, 'PAYMENT_SCHEDULE.PAYMENT');
						Utilities.arrayWrap(data, 'PAYMENT_SCHEDULE');
					}

					return data;
				}
			}

		/**
	 * Orders the Packages by `display_order`
	 * @private
	 * @param {array} packageList
	 * @return {undefined}
	 */
		function orderPackageList(packageList) {
			packageList.sort(function(a, b) {
				if (a.display_order === b.display_order) {
					return 0;
				}

				return +a.display_order > +b.display_order ? 1 : -1;
			});
		}

		service.billingProviders = [];

		/**
		 * Provider object that has structure:
		 * billing_provider_auth_type
		 * 	billing_provider_id
		 * 	billing_provider_name
		 * 	billing_provider_card_type_codes
		 * 	billing_provider_image
		 * 	billing_provider_shortcut_image
		 * 	billing_provider_show_checkout_shortcut
		 * 	billing_provider_show_in_footer
		 * 	billing_provider_footer_image
		 * 	billing_provider_footer_verbiage
		 * 	billing_provider_footer_link
		 * 	billing_provider_order_review_icon
		 * 	billing_provider_mobile_payment_method_icon
		 *
		 * @param {Object} provider
		 * @param name
		 * @param cardTypeCode
		 * @param providerImage
		 * @param providerShortcutImage
		 * @param showCheckoutShortcut
		 */
		service.registerBillingProvider = function(provider) {
			if (service.billingProviders.indexOf(provider) === -1) {
				service.billingProviders.push(provider);
				service.paymentMethodCount++;
			}
		}

		/**
		 * Find out if we're using static CDN data.
		 * @returns {Boolean} If we're using static data.
		 */
		service.hasStaticData = function() {
			return $window.accesso.HAS_STATIC_DATA;
		};

		/**
		 * Unregister a billing type
		 * in the case that there is misconfiguration or we determine that we are missing some information required
		 * (e.g. if IDEAL is configured as a billingType, we need the IDEALBANKLIST - if that request fails or we do not get any banks back, we must unregister this billingType)
		 * @param authType
		 */
		service.unregisterBillingType = function(authType) {
			if (angular.isDefined(authType)) {
				var billingType = service.billingTypes.filter(function(item) {
					return item.auth_type == authType;
				})[0];
				if (angular.isDefined(billingType)) {
					service.billingTypes.splice(service.billingTypes.indexOf(billingType), 1);
					service.paymentMethodCount--;
				}
			}
		}

		/**
		 * Sets the additional params required for the new initialize endpoint
		 * @param {Object} request The request object
		 * @returns {undefined}
		 */
		service.setAdditionalSocketRequestData = function(request) {
			var APP_CONFIG_PROP = 'staticData.GetApplicationConsolidated.SETTINGS';

			var payPalAllowedBillingTypes = checkProp(APP_CONFIG_PROP + '.allowedBillingTypes', service, 'returnValue');
			var payPalBillingTypes = checkProp(APP_CONFIG_PROP + '.billing_types', service, 'returnValue');
			var agentId = checkProp(APP_CONFIG_PROP + '.agent_id', service, 'returnValue');
			var machineId = checkProp(APP_CONFIG_PROP + '.machine_id', service, 'returnValue');
			var keywords = checkProp('staticData.GetMerchantKeywords.keywords', service, 'getString');

			// Get one half of the PayPal information
			if (validString(payPalAllowedBillingTypes) && payPalAllowedBillingTypes.indexOf('PPA') > -1) {
				request.paypal_settings = payPalAllowedBillingTypes;
			} else if (validString(payPalBillingTypes) && payPalBillingTypes.indexOf('PPA') > -1) {
				request.paypal_settings = payPalBillingTypes;
			}

			request.island = service.island;
			request.merchant_id = service.merchantId;
			request.language = service.language;
			request.keywords = keywords;

			// Agent ID and user id
			if (agentId) {
				request.user_id = agentId;
				request.agent_id = agentId;
			}

			// Machine id
			if (machineId) {
				request.machine_id = machineId;
			}

			service.setKnowledgeBaseInfo(request);
		};

		/**
		 * Modifies the request object with the knowledgebase info
		 * @param {Object} request The request object
		 * @returns {undefined}
		 */
		service.setKnowledgeBaseInfo = function(request) {
			var APP_CONFIG_PROP = 'service.GetApplicationConsolidated.SETTINGS';
			var env = checkProp('service.environment', service, 'returnValue');

			var kbid;
			var knowledgeBaseID = checkProp(APP_CONFIG_PROP + '.knowledgeBaseID', service, 'returnValue');
			var knowledgebase_id = checkProp(APP_CONFIG_PROP + '.knowledgebase_id', service, 'returnValue');

			var gateway;
			var knowledgeBaseGateway = checkProp(APP_CONFIG_PROP + '.knowledgeBaseGateway', service, 'returnValue');
			var knowledgebase_gateway = checkProp(APP_CONFIG_PROP + '.knowledgebase_gateway', service, 'returnValue');

			if (knowledgeBaseGateway) {
				gateway = knowledgeBaseGateway;
			} else if (knowledgebase_gateway) {
				gateway = knowledgebase_gateway;

				// Select the value based on the environment
				try {
					knowledgebase_gateway = JSON.parse(knowledgebase_gateway);
					if (knowledgebase_gateway && validString(knowledgebase_gateway[env])) {
						gateway = knowledgebase_gateway[env];
					}
				} catch (e) {
					// ignore as its not set correctly
				}
			}

			if (gateway) {
				request.knowledgebase_gateway = gateway;
				// I need to grab the island from the end of this, for the purposes of caching.
				request.knowledgebase_island = gateway.split('-').pop();
			}

			// KNOWLEDGEBASE ID
			if (knowledgeBaseID) {
				kbid = knowledgeBaseID;
			} else if (knowledgebase_id) {
				kbid = knowledgebase_id;

				try {
					knowledgebase_id = JSON.parse(knowledgebase_id);
					if (knowledgebase_id[env]) {
						kbid = knowledgebase_id[env];
					}
				} catch (e) {
					// Ignore
				}
			}

			if (kbid) {
				request.knowledgebase_id = kbid;
			}
		}

		/**
		 * ## Check to see if we need to trigger a GetNewCartID for Six Flags Folios
		 */

		service.handleSfOffer = function() {
			if ($location.search()[Enums.urlParameters.sfOffer]) {
				return service.fetch(Enums.services.GET_NEW_CART_ID, true, {});
			}

			return $q.resolve();
		};

		/**
		* Checks if package is available (activated), by keyword
		* @param {String} keyword The keyword
		* @returns {Boolean} True if package(s) are available with given keyword
		*/
		function checkPackagesAvailableByKeyword(keyword) {
			var pl = wrapObjectToArray(service.GetMerchantPackageList.PS.P, true);
			var keywords;

			if (UtilsValidation.validString(keyword)) {
				keywords = keyword.trim().toLowerCase().split(',');
			} else {
				return false;
			}

			return pl.some(function findKeywordInPackage(pkg) {
				var pkgKeywords;
				var i = 0;

				if (!pkg || !validString(pkg.keyword)) {
					return false;
				}

				// Creates an array of keywords from the item's keywords, and associated keywords with removed white space and all words in lowercase
				pkgKeywords = (pkg.keyword + ',' + pkg.assoc_keywords)
					.replace(/,\s+/g, ',')
					.toLowerCase()
					.trim()
					.split(',');

				for (; i < keywords.length; i++) {
					if (pkgKeywords.includes(keywords[i])) {
						return true;
					}
				}

				return false;
			});
		}

		/**
     * Checks to make sure there are packages associated with the default keyword
     * If there are none, then goes through navTree and finds the next available navTree item with available package(s)
     * @returns {undefined}
     */
		function checkPackagesOnKeyword() {
			var defaultKeyword = Utilities.getString(service.defaults.keyword).trim().toLowerCase();
			var packAvailable = false;

			if (validString(defaultKeyword)) {
				packAvailable = checkPackagesAvailableByKeyword(defaultKeyword);
			}

			// If the default keyword is active but no packages available, find next available nav tree item with packages
			if (!packAvailable && validArray(service.menuItems)) {
				service.menuItems.some(recursivelyCheckAndSetDefaultKeyword);
			}
		}

		/**
		 * Finds the item that has packages or keywords.
		 * @param {Object} navItem The nav item to check
		 * @returns {Boolean} if it found a nav item with packages
		 */
		function recursivelyCheckAndSetDefaultKeyword(navItem) {
			var keywordHasPackages;

			if (!navItem.isactive || navItem.isactive === 'false') {
				return false;
			}

			keywordHasPackages = checkAndSetDefaultKeyword(navItem.keywords);
			// If we found something, return true to stop iterations.
			if (keywordHasPackages) {
				return true;
			}

			if (!navItem.MENUITEM) {
				return false;
			}

			navItem.MENUITEM = wrapObjectToArray(navItem.MENUITEM, true);

			return navItem.MENUITEM.some(recursivelyCheckAndSetDefaultKeyword);
		}

		/**
		 * Checks if the nav tree item has packages. If it does, sets it as the default key
		 * @param {String} keywords The keywords from the navitem
		 * @returns {Boolean} if it has packages and we updated it to be the new default keyword.
		 */
		function checkAndSetDefaultKeyword(keywords) {
			var packagesAvailable;

			if (!validString(keywords)) {
				return false;
			}

			packagesAvailable = keywords
				.trim()
				.toLowerCase()
				.split(',')
				.some(checkPackagesAvailableByKeyword)

			if (packagesAvailable) {
				service.defaults.keyword = keywords;
				return true;
			}
			return false;
		}

		/**
		 * This should execute if we are forcing requests to Node to get new Stage Two Request Data
		 * We are ensure that all requests EXCEPT GetMerchantPackageList are sent first so that we
		 * have a fresh copy of the keywords we received back from GetMerchantKeywords are stored in our local
		 * service variable (this is to remove reliance on local storage (initMerchantKeywords) that we can deprecate
		 * in the future once we determine that this sequence solves the keyword=undefined issue.
		 * (Something changed about the merchant setup and cache has new values different from local storage)
		 * @param requests
		 * @param getMerchantPackageListRequest
		 * @returns {Promise}
		 */
		function sendStagedRequestsBeforeMPList(requests) {
			var deferred = $q.defer();

			$q.all(requests).then(function(stagedRequestsResults) {
				//this should be set now that GetMerchantKeywords was called first and service variable set
				var mpListRequest = {
					show_details: 1,
					long_desc_flag: 1,
					keyword: service.initMerchantKeywords,
					_from_alt_boot_sequence: 1 // variable so we can identify this request for debugging purposes
				};

				service.fetch('GetMerchantPackageList', false, mpListRequest, true, undefined, true).then(
					function(mpListResults) {
						service.globalDependencies['GetMerchantPackageList'] = mpListResults;

						//resolve the promise - if the request truly fails, it will route to the No Packages Found page
						deferred.resolve();
					});
			});

			return deferred.promise;
		}

		service.updateMenuItem = function(kw) {
			var loweredKw = (kw || '').toLowerCase();

			if (validArray(service.menuItems)) {
				var found = service.menuItems.find(findItem);
				if (found) {
					found.selected = true;
				}

				/**
				 * Finds the item we're looking for with the specific lowered keyword.
				 * @param {Object} item The current nav item
				 * @returns {Boolean} True/False if it found it or not.
				 */
				function findItem(item) {
					item.selected = false;
					// Check children first — a child with the same keyword as its parent
					// must take precedence, otherwise the parent would match and force all
					// children unselected before a child match is ever attempted.
					if (validArray(item.MENUITEM) && item.MENUITEM.some(findItem)) {
						return true;
					}
					if (validString(item.keywords) && item.keywords.toLowerCase().indexOf(loweredKw) > -1) {
						item.selected = true;
						return true;
					}
					return false;
				}

				/**
				 * Set everything and all of it's items as unselected
				 * @param {Item} item The item to set selected as false
				 * @returns {undefined}
				 */
				function setSelectedFalse(item) {
					item.selected = false;

					if (validArray(item.MENUITEM)) {
						item.MENUITEM.forEach(setSelectedFalse);
					}
				}
			}
		}

		service.updateSelectedKeyword = function(keyword) {
			// TODO: Temporary solution for resetting the menu item data.
			// This should be moved into a service specifically to handle navigation.
			var kwIndex = -1;
			var kw = keyword || $stateParams.crosssell;
			if (angular.isDefined(kw) && service.menuItems) {
				for (var i = 0; i < service.menuItems.length; i++) {
					var itm = service.menuItems[ i ];

					// Reset selected flag on all items.
					itm.selected = false;

					if (itm.keywords == kw) {
						itm.selected = true;
					}

					if (typeof itm.MENUITEM != 'undefined') {
						for (var j = 0; j < itm.MENUITEM.length; j++) {
							var subItm = itm.MENUITEM[ j ];
							subItm.selected = false;
							if (subItm.keywords == kw) {
								subItm.selected = true;
								itm.selected = true;
							}
						}
					}
				}
			}
		}

		/**
		 * The purpose of the url is to have a generalized way to go to error pages,
		 * but to not cause other problems down the road. ie: storage getting cleared
		 * because we rerouted to an error page, without a merchant, causing a localStorage.clear();
		 */
		function routeToErrorPage(data, errorPage) {
			// Let's determine if we have a merchant string in the url
			var urlMerchant = Utilities.getMerchant();

			// TODO: Need to ensure we are checking for Merchant UID in the subdomain in which case we don't need to
			// do anything. But we also need to check the traditional URL schema and ensure MUID is added to the route path.
			var urlPrefix = ''; //( typeof urlMerchant != 'undefined' && urlMerchant !== '' ) ? '/' + urlMerchant : '';

			data = data || {};
			errorPage = errorPage || '';
			$rootScope.errorData = data;

			if (errorPage !== '') {
				$location.path(urlPrefix + '/' + Enums.routes.ERROR + '/' + errorPage);
			} else if (data) {
				if (typeof data.error_msg != 'undefined' && data.error_msg.indexOf('Failed to load') > -1) {
					$location.path(urlPrefix + '/' + Enums.routes.ERROR + '/' + Enums.errorRoutes.UNKNOWN_MERCHANT);
				} else {
					$location.path(urlPrefix + '/' + Enums.routes.ERROR + '/' + Enums.errorRoutes.FAILED_TO_INIT);
				}
			}
		}

		service.updateLastKeyword = function(keyword, source) {
			var logString = "Set AppData.lastKeyword to " + keyword;
			if (angular.isDefined(source)) {
				logString += " by " + source;
			}
			$log.log(logString);

			service.lastKeyword = keyword;
		}


		/**
		 * Activate a parent menu item given an id
		 * @param menuItemId
		 */
		service.activateParentMenuItemById = function(menuItemId) {
			var found = _menu.filter(function(item) {
				return item.id === menuItemId;
			})[0];

			if (angular.isDefined(found) && !Utilities.getBoolean(found.isactive)) {
				found.isactive = true;
				service.menuItems.push(found);
			}
		}

		/**
		 * Deactivate a parent menu item given an id
		 * @param menuItemId
		 */
		service.deActivateParentMenuItemById = function(menuItemId) {
			var found = service.menuItems.filter(function(item) {
				return item.id === menuItemId;
			})[0];
			service.menuItems.splice(service.menuItems.indexOf(found), 1);
		}

		/**
		 * This can be set if we want to allow the billing information to be copied from a logged in profile
		 */
		service.setActionToPopulateBillingShippingFromOtherModel = function(action, conditionToShowCopyOption) {
			service.populateBillingShippingModelInfo.copyFromOtherModelAction = action;
			service.populateBillingShippingModelInfo.shouldAllowCopy = conditionToShowCopyOption;
		};

		/**
		 * useJapaneseAddressSyntax returns true if the store is using the japanese language.
		 * @returns {boolean}
		 */
		service.useJapaneseAddressSyntax = function() {
			var lang = angular.isDefined(service.language) ? service.language.toLowerCase() : '';
			return (lang == 'ja-jp' || lang == 'en-jp');
		};


		/**
		 * Checks for a property hide_for_device_types to assess whether or not to show or hide a modal
		 * @param menuItem
		 * @returns {boolean}
		 */
		service.shouldMenuItemBeDisabledForDevice = function(menuItem) {
			var shouldDisable = false;
			if (angular.isDefined(menuItem) && angular.isDefined(menuItem.hide_for_device_types)) {
				var devicesToCheck = menuItem.hide_for_device_types.split(',');
				if (devicesToCheck.indexOf(ClientInfo.deviceType) > -1) {
					shouldDisable = true;
				}
			}

			return shouldDisable;
		}

		/**
		 * Adds a keyword to the disabled list
		 * @param {String} keyword - The keyword to add to the disabled list
		 * @returns {undefined}
		 */
		service.addDisabledKeyword = function addDisabledKeyword(keyword) {
			if (keyword && !service.disabledKeywords.includes(keyword)) {
				service.disabledKeywords.push(keyword);
			}
		}

		/**
		 * Checks to see if a keyword is on the disabled list
		 * @param {String} keyword - The keyword(s) to check if it is disabled
		 * @returns {Boolean} - True is disabled, false otherwise
		 */
		service.isDisabledKeyword = function isDisabledKeyword(keyword) {
			// If a multiple keyword string is passed
			if (/,/.test(keyword)) {
				// Count as disabled if any of the keywords are disabled
				return keyword.split(',').some(service.isDisabledKeyword);
			}

			// Is the keyword falsey or in the disabled list?
			return !!keyword && service.disabledKeywords.includes(keyword);
		}

		/**
		 * Check Cart from Local Storage
		 * This similar code used elsewhere in this file on the old initialization sequence - the NON-STATIC DATA flow
		 * Essentially, the assessment here will look for a cart coming in from the URL and leverage that to reinitialize the store
		 * This also allows for it to not conflict with the GetCartSummary that initializeSocket will be pushing based on these URL params
		 * @returns boolean on whether or not we initialzied
		 */
		function initializeCartFromURL() {
			var queryParams = $location.search();
			var GetNewCartIDKey = Enums.services.GET_NEW_CART_ID;
			var initializedCartFromURL = false;
			var sessionId = queryParams[Enums.urlParameters.sessionIdShort] || queryParams[Enums.urlParameters.sessionId];

			if (queryParams[Enums.urlParameters.cartId] && queryParams[Enums.urlParameters.cartKey]) {
				//the below code is copied directly from the old sequence prior to STATIC DATA flow
				var _token = getToken();
				var _data = {
					cart_id: queryParams[Enums.urlParameters.cartId],
					cart_key: queryParams[Enums.urlParameters.cartKey],
					request_type: GetNewCartIDKey,
					status: 'OK',
					request_token: _token,
					_from_cache: false,
					_request_token: _token,
					_skip_requests: '',
					_skip_cache: '',
					_no_cache: ''
				};

				if (sessionId) {
					_data.session_id = sessionId;
				}

				Storage.set(GetNewCartIDKey, _data);
				service[GetNewCartIDKey] = service.globalDependencies[GetNewCartIDKey] = _data;

				if (validString(_data.cart_id)) {
					service.cart.cart_id = _data.cart_id;
				}
				if (validString(_data.cart_key)) {
					service.cart.cart_key = _data.cart_key;
				}
				if (validString(_data.session_id)) {
					service.cart.session_id = _data.session_id;
				}

				initializedCartFromURL = true;
			}

			return initializedCartFromURL;
		}

		/*
		 * - iterate through map
		 * - replace name with language-specific name if present
		 * - alphabetize
		 */
		function processRegions(regions) {
			var languageCode = angular.isDefined(service.language) && service.language.length>1 ? service.language.substr(0, 2).toLowerCase() : '';

			if (['de-de', 'en-de'].indexOf(service.language) > -1) {
				regions.US.push({
					code: "AE",
					name: "AE"
				});
			}

			angular.forEach(regions, function(value, key) {
				value = replaceNameForLanguage(value, languageCode);
				value = $filter('alphabeticalByLocale')(value, 'name', languageCode);
			});

			return regions;
		}

		/*
		 * If the object from countriesJSon array has a property for the current language,
		 * replace the name with the value of that property.
		 */
		function replaceNameForLanguage(array, lang) {
			var languageCode = '',
				langArray = angular.isString(lang) && lang.length > 1 ? lang.split('-') : [],
				langArrayLength = langArray.length,
				i;

			for (i = 0; i < langArrayLength; i++) {
				languageCode += langArray[i];
				if (i < langArrayLength - 2) {
					languageCode += '-';
				} else if (i + 1 >= langArrayLength - 1) {
					break;
				}
			}

			if (languageCode !='') {
				for (var i = 0; i < array.length; i++) {
					var item = array[i];

					if (angular.isDefined(item[languageCode]) && item[languageCode] !== '') {
						item.name = item[languageCode];
					}
				}
			}

			return array;
		}

		function updateDisabledCountries() {
			if (angular.isUndefined(service.settings.disabled_countries)) {
				return;
			}

			try {
				var disabledCountries = service.settings.disabled_countries.replace(' ', '').split(',');

				for (var i = service.countries.length - 1; i >= 0; i--) {
					if (disabledCountries.indexOf(service.countries[i].code) > -1) {
						service.countries.splice(i, 1);
					}
				}
			} catch (e) {
				$log.error('Unable to filter disabled countries: ' + e.message);
			}
		}

		if (service.hasStaticData()) {
			initializeCartFromURL();
		}

		return service;
	});

(function() {
	'use strict';

	angular
		.module('app')
		.factory('EnvironmentService', EnvironmentService);

	/**
	 * Handles environment related changes
	 * @param {Service} AppData AppData Service
	 * @param {Service} UtilsValidation UtilsValidation Service
	 * @param {Service} UtilityFunctions UtilityFunctions Service
	 * @returns {EnvironmentService} The instance
	 * @ngInject
	 */
	function EnvironmentService(AppData, UtilsValidation, UtilityFunctions) {
		var memoize = UtilityFunctions.memoize,
			validString = UtilsValidation.validString;
		var service = {
			getCurrentEnvironment: memoize(getCurrentEnvironment),
			isProduction: memoize(isProduction)
		};

		return service;

		/**
		 * Check if the current environment is production
		 * @public
		 * @function
		 * @returns {Boolean} true/false
		 */
		function isProduction() {
			var environment = AppData.environment;
			return validString(environment) && environment.indexOf('prod') > -1;
		}

		/**
		 * Return current environment
		 * @public
		 * @function
		 * @returns {String} environment
		 */
		function getCurrentEnvironment() {
			return UtilsValidation.returnOrDefault(AppData.environment, '', validString);
		}
	}
})();
'use strict';

angular
	.module('app')
	.service('BillingService', function Billing(
		$rootScope,
		$q,
		UserInfo,
		AppData,
		CustomActionService,
		Utilities,
		Modal,
		Language,
		Enums,
		LegacyCart,
		Package,
		StringUtils,
		UtilsValidation,
		JSONValidator
	) {
		var validString = UtilsValidation.validString,
			isFunction = angular.isFunction,
			isArray = angular.isArray,
			getBoolean = Utilities.getBoolean,
			normalize = StringUtils.normalize,
			validArray = UtilsValidation.validArray,
			checkProp = Utilities.safelyCheckPropertyOnObject;

		/**
		 * Auth types that require collecting the card number and info within Shopland
		 * Other authtypes can be registered to be added to this list
		 * @type {string[]}
		 */
		var cardCaptureAuthTypes = ['EC'];

		/**
		 * Auth types that DO NOT require an expiration date
		 * @type {string[]}
		 */
		var expDateNotRequiredAuthTypes = ['ELV'];

		/**
		 * Auth types that require cvv collection on our billing payment screen
		 * @type {string[]}
		 */
		var cvvRequiredAuthTypes = ['EC', 'DSS'];

		/**
		 * Auth types that require cvv collection on our billing payment screen
		 * @type {string[]}
		 */
		var cvvOptionalAuthTypes = [];
		/**
		 * Controls whether or not we do a 3DSecure check on the payment form (credit card form)
		 * @type {boolean}
		 */
		var do3DSOnBillingPaymentFormCheck = false;

		/**
		 * Controls if we should show a payment method on the payment methods screen and there is a deferred package
		 * in the cart
		 * @type {string[]}
		 */
		var unsupportedPaymentMethodsForDeferredPackages = [];

		/**
		 * AuthType that does not need to show credit card form
		 * @type {string[]}
		 */
		var authTypesWithNoCreditCardForm = ['ELV'];

		/**
		 *  Hiding address fields on demographics screen if the billing type is on this array list
		 * @type {string[]}
		 */
		var authTypesWithoutAddress = [];

		var paymentMethodsWithExpressOption = [];
		var expressWalletPayments = [];
		/**
		 * Mapping of Auth Types to Payment Methods (Providers)
		 * TODO we need to consolidate all the scattered billing/payment logic and potentially put into the billing module
		 * @type {*[]}
		 */
		var paymentProviderAuthTypeMapping = [

			{
				name: Enums.paymentProvider.PAYPAL,
				authType: Enums.billingTypes.PAYPAL
			},
			{
				name: Enums.paymentProvider.IDEAL,
				authType: Enums.billingTypes.IDEAL
			},
			{
				name: Enums.paymentProvider.MRCASH,
				authType: Enums.billingTypes.MISTERCASH
			},
			{
				name: Enums.paymentProvider.CREDITCARD,
				authType: Enums.billingTypes.CREDITCARD
			},
			{
				name: Enums.paymentProvider.STOREDPAYMENTS,
				authType: Enums.billingTypes.STOREDPAYMENTS
			}
		];

		/**
		 * An action that can be registered to run after the user completes the billing demographic form
		 * @type {Array}
		 */
		var postBillingDemographicFormActions = [];

		/**
		 * Register a gift card payment method
		 * @type {Object}
		 */
		var registeredGiftCardPaymentMethod = undefined;

		/**
		 * A variable to hold registered payment methods (models of BillingModels.PaymentMethod classes)
		 * TODO we can migrate other payment methods to this route so that we can instead
		 * ng-repeat over this array and condense the paymentMethod HTML that is growing and
		 * becoming more difficult to manage
		 * @type {Array}
		 */
		var registeredPaymentMethods = [];

		var registeredPaymentMethodLoadPromises = [];

		var formFieldOverrides = {};

		var debugExpYear = ((new Date()).getFullYear() + 1).toString().slice(2, 4);

		var service = {
			zeroDollarBillingId: 9,
			defaults: {
				form: {
					firstName: '',
					lastName: '',
					middleInitial: '',
					country: '',
					address: '',
					address2: '',
					city: '',
					state: '',
					zip: '',
					phone: '',
					mobile: '',
					email: '',
					emailVerify: ''
				}
			},
			debugValues: {
				USERS: {
					V5DEV: {
						firstName: 'Shopland',
						lastName: 'Version Five',
						country: 'US',
						address: '1025 Greenwood Boulevard',
						address2: 'Suite 500',
						city: 'Lake Mary',
						state: 'FL',
						zip: '32746',
						phone: '1234567890',
						mobile: '',
						email: 'shopv5dev@accesso.com',
						emailVerify: 'shopv5dev@accesso.com',
						showLastFour: true
					},
					V5DEV_RESELLER_CUSTOMER: {
						firstName: 'Shopland',
						lastName: 'Version Five',
						email: 'shopv5dev@accesso.com',
						emailVerify: 'shopv5dev@accesso.com'
					}
				},

				CARDS: {
					EC_VISA_1601_ENROLLED: {
						payment: {
							ccType: 'Visa',
							month: '01',
							year: debugExpYear,
							cardExpirationDate: debugExpYear + '01',
							billingId: '2',
							billingType: 'CCD',
							authType: 'EC',
							cepayMerchantId: '999998',
							type: 'cc'
						},
						secAcctInfo: {
							account: '4015501150000216',
							securityCode: '444'
						}

					},

					EC_VISA_1602_NOTENROLLED: {
						payment: {
							ccType: 'Visa',
							month: '01',
							year: debugExpYear,
							cardExpirationDate: debugExpYear + '02',
							billingId: '2',
							billingType: 'CCD',
							authType: 'EC',
							cepayMerchantId: '999998',
							type: 'cc'
						},
						secAcctInfo: {
							account: '4015501150000216',
							securityCode: '444'
						}
					},

					EC_VISA_123: {
						payment: {
							ccType: 'Visa',
							month: '05',
							year: debugExpYear,
							cardExpirationDate: debugExpYear + '05',
							billingId: '2',
							billingType: 'CCD',
							authType: 'EC',
							cepayMerchantId: '106001',
							type: 'cc'
						},
						secAcctInfo: {
							account: '4111111111111111',
							securityCode: '123'
						}
					},

					ELV: { payment: { iban: "DE56200800000120122000" } }


				}
			}
		};

		service.doesAuthTypeRequireCreditCardForm = doesAuthTypeRequireCreditCardForm;
		service.useZeroDollarQuickCheckout = useZeroDollarQuickCheckout;

		/**
		 * Initializes this service
		 */
		service.initialize = function() {
			var initPromise = $q.defer();

			initPromise.resolve();
			formFieldOverrides = getFormFieldOverrides();

			return initPromise.promise;
		};

		/**
		 * Get the zero dollar billing type object.
		 * @public
		 * @return {Object|undefined} The billing type object if it finds one.
		 */
		service.getCashBillingType = function() {
			return AppData.billingTypes.find(function(type) {
				return type.billing_type === Enums.billingTypes.CASH && type.auth_type === 'CS';
			});
		};

		service.processFreeOrder = function(billingData, onSuccess) {
			$rootScope.showSpinner();
			initializeZeroDollarPaymentValues(billingData);

			var shipping = UserInfo.get('shipping');
			var requestData = {
				shippingMethod: shipping.deliveryMethod,
				shippingAmount: shipping.deliveryAmount
			};
			var cashBillingType = service.getCashBillingType();

			if (cashBillingType && cashBillingType.merchant_payment_type_ref_id) {
				requestData.merchant_payment_type_ref_id = cashBillingType.merchant_payment_type_ref_id;
			} else {
				requestData.billingId = service.zeroDollarBillingId;
			}

			//Update the Cart with the Zero dollar info.
			return AppData
				.fetch(Enums.services.UPDATE_CART_CHECKOUT_INFO, false, requestData)
				.then(function(data) {
					if (data.status == Enums.status.OK) {
						if (angular.isFunction(onSuccess)) {
							onSuccess();
						} else {
							$rootScope.routeTo(Enums.routes.ORDER_REVIEW);
						}
					} else if (data.status == Enums.status.FAILED) {
						Modal.displayModal(
							{
								category: 'Billing [save]',
								action: 'Error',
								label: data.error_msg,
								title: Language.getLocale('Alert', 'failedUpdateCheckoutInfoTitle'),
								icon: 'icon-info red',
								description: Language.getLocale('Alert', 'failedUpdateCheckoutInfoMsg'),
								callback: function(detail) {
									$rootScope.routeTo(Enums.routes.CART);
								}
							}
						);
					}

					// Hide the spinner.
					$rootScope.hideSpinner();
				});
		};

		/**
		 * Find out if we are in a zero dollar quick checkout situation.
		 * @public
		 * @returns {Boolean} if we are in a zero dollar quick checkout
		 */
		function useZeroDollarQuickCheckout() {
			var shippingAmount = parseFloat(checkProp('UserInfo.shipping.deliveryAmount', UserInfo, Utilities.returnValue));
			var isZeroDollarPurchase = checkProp('LegacyCart.cartDetails.total', LegacyCart)
				&& parseFloat(LegacyCart.cartDetails.total) - UserInfo.getPartialPaymentTotal() <= 0
				&& (isNaN(shippingAmount) || shippingAmount <= 0);

			if (!isZeroDollarPurchase) {
				return false;
			}

			return LegacyCart.cartItems.every(function(item) {
				var pkg = Package.getPackageByID(item.package_id);
				return checkProp('pkg.CHARACS.bill_quick_checkout', pkg, Utilities.returnValue) === '1';
			});
		}

		/**
		 * Subroutine to set UserInfo.payment and
		 * $scope.billing for a Zero dollar auth.
		 *
		 * Sets 'payment' and 'billing' in localStorage
		 *
		 * Used by BillingService.processFreeOrder()
		 */
		function initializeZeroDollarPaymentValues(billingData) {
			billingData.valid = true;

			UserInfo.set('billing', billingData);
		}

		/**
		 * Returns a list of all accepted cards
		 * @public
		 * @param {Boolean} useCardTypeCode True if you wish to retrieve the type codes instead of names
		 * @returns {String[]} Returns an array of names (or card type codes) denoting valid cards.
		 */
		service.getValidCardTypesList = function(useCardTypeCode) {
			var cardOverride = service._getCardOverride();

			return AppData.billingTypes.reduce(function(accu, type) {
				var cardIdentifier = '';

				// Including only the credit cards. Excludes paypal from list.
				if (type.auth_type === Enums.billingTypes.CREDITCARD && (!UtilsValidation.validString(cardOverride) || type.card_type_code === cardOverride)) {
					cardIdentifier = (useCardTypeCode && type.card_type_code) ? type.card_type_code : Utilities.getString(type.name).toLowerCase();
					accu.push(cardIdentifier);
				}

				return accu;
			}, []);
		};

		/**
		 * Determine if there is a package in the card that has card_type_required
		 * @protected
		 * @returns {String} The card_type_required that was found, or an empty string
		 */
		service._getCardOverride = function() {
			var i = 0;
			var j;
			var cartLength = LegacyCart.cartItems.length;
			var characsLength;
			var currentItem;

			// Get the card override if it exist in the CHARACS of any of the items in the cart.
			for (; i < cartLength; i++) {
				currentItem = LegacyCart.cartItems[i];

				if (validArray(currentItem.CHARACS)) {
					characsLength = currentItem.CHARACS.length;
					for (j = 0; j < characsLength; j++) {
						if (UtilsValidation.validString(currentItem.CHARACS[j].card_type_required)) {
							return currentItem.CHARACS[j].card_type_required;
						}
					}
				}
			}

			return '';
		};

		 /**
		  * Once the user fills out their billing demographics - we can register a custom action outside of our normal flow to
		  * intercept and execute.  We need to know the payment method (UserInfo.payment.type) and the action (function) we need to run
		  * //TODO standardize what we call the UserInfo.payment.type - in some places its paymentMethod and in some places its paymentProvider
		  * @see Enums.paymentProvider object for list of values
		  * @param paymentMethod {String representing a paymentMethod or the string represented on UserInfo.payment.type object
		  * @param action {function}
		  */
		service.registerPostDemographicFormAction = function(paymentMethod, action) {
			postBillingDemographicFormActions.push({
				paymentMethod: paymentMethod,
				doAction: action
			});
		};

		/**
		 * Check if a payment Method has an alternate action from the standard post-demo form action
		 * @see Enums.paymentProvider object for list of values
		 * @param {String} paymentMethod Payment method name
		 * @returns {Object} PostDemographicFormAction
		 */
		service.getAlternatePostDemographicFormAction = function(paymentMethod) {
			return postBillingDemographicFormActions.filter(function(item) {
				return item.paymentMethod === paymentMethod;
			})[0];
		};

		/**
		 * Registers a new auth type within the list of cardCaptureAuthTypes
		 * Some other auth types other than APD and EC require card capture where we have the user enter in their card number
		 * on our paymentForm -(For instance, for Ingenico payment processing, we need to capture Mistercash cards in our store)
		 * @param authType
		 */
		service.registerCardCaptureAuthType = function(authType) {
			if (cardCaptureAuthTypes.indexOf(authType) === -1) {
				cardCaptureAuthTypes.push(authType);
			}
		};

		/**
		 * Deregisters an auth type within the list of cardCaptureAuthTypes
		 * @param {String} authType auth type
		 * @returns {undefined}
		 */
		service.deregisterCardCaptureAuthType = function(authType) {
			var indexOfAuthType = cardCaptureAuthTypes.indexOf(authType);
			if (indexOfAuthType !== -1) {
				cardCaptureAuthTypes.splice(indexOfAuthType, 1);
			}
		};

		service.registerPaymentMethod = function(method) {
			if (registeredPaymentMethods.indexOf(method) === -1) {
				paymentProviderAuthTypeMapping.push({
					name: method.methodName,
					authType: method.authType
				});
				registeredPaymentMethods.push(method);
			}
		};

		/**
		 * Deregisters registered payment method
		 * @public
		 * @param {Object} method payment method
		 * @returns {undefined}
		 */
		service.deregisterRegisteredPaymentMethod = function(method) {
			var foundRegisteredPaymentMethodIndex;
			if (!validArray(registeredPaymentMethods)) {
				return;
			}
			foundRegisteredPaymentMethodIndex = registeredPaymentMethods.findIndex(function findPaymentMethod(paymentMethod) {
				return normalize(paymentMethod.methodName) === method.methodName && paymentMethod.authType === method.authType;
			});
			if (foundRegisteredPaymentMethodIndex > -1) {
				registeredPaymentMethods.splice(foundRegisteredPaymentMethodIndex, 1);
			}
		}

		/**
		 * Register a gift card payment method provider - can only have one exist on a merchant right now
		 * @param method
		 */
		service.registerGiftCardPaymentMethod = function(method) {
			if (angular.isUndefined(registeredGiftCardPaymentMethod)) {
				registeredGiftCardPaymentMethod = method;
			}
		};

		/**
		 * Returns whether or not a given payment method (type from payment method screen) supports partial payments
		 * Defaults to false for all methods EXCEPT cc at this time
		 * @param method
		 * @returns {boolean}
		 */
		service.doesPaymentMethodOrProviderSupportPartialPayments = function(method) {
			return angular.isDefined(method) ? method.toLowerCase() === 'cc' : false;
		};

		/**
		 * Getter for registered payment methods
		 * @returns {Array}
		 */
		service.getRegisteredPaymentMethods = function() {
			return registeredPaymentMethods;
		};

		/**
		 * Return the registered gift card payment method configured
		 * @returns {Object}
		 */
		service.getRegisteredGiftCardPaymentMethod = function() {
			return registeredGiftCardPaymentMethod;
		};

		/**
		 * Returns whether or not we should present the gift card option
		 * We show this if we have a registered gift card payment method AND there is currently no deferred payment method in the cart
		 * @returns {boolean}
		 */
		service.shouldPresentGiftCardOption = function() {
			return angular.isDefined(registeredGiftCardPaymentMethod) && !LegacyCart.checkForDeferredPayment();
		};

		/**
		 * Ad a payment method that's not supported with deferred payments.
		 * @public
		 * @function
		 * @name addUnsupportedPaymentForDeferredPayments
		 * @param {String} paymentMethod the payment method
		 * @return {undefined}
		 */
		service.addUnsupportedPaymentForDeferredPayments = function(paymentMethod) {
			if (validString(paymentMethod) && unsupportedPaymentMethodsForDeferredPackages.indexOf(paymentMethod) === -1) {
				unsupportedPaymentMethodsForDeferredPackages.push(paymentMethod.toUpperCase());
			}
		};

		service.paymentMethodThatDoesNotSupportDeferredPayments = function(paymentMethod) {
			return unsupportedPaymentMethodsForDeferredPackages.indexOf(paymentMethod.toUpperCase()) > -1;
		};

		/**
		 * Obtains a registered payment method given the name
		 * @param typeName
		 * @returns {*}
		 */
		service.getRegisteredPaymentMethodByName = function(typeName) {
			return registeredPaymentMethods.filter(function(method) {
				return method.methodName === typeName;
			})[0];
		};

		/**
		 * Obtains a registered payment method given the auth type
		 * @param typeName
		 * @returns {*}
		 */
		service.getRegisteredPaymentMethodByAuthType = function(authType) {
			return registeredPaymentMethods.filter(function(method) {
				return method.authType.toUpperCase() === authType.toUpperCase();
			})[0];
		};

		/**
		 * Get alternate card capture payment fields
		 * @param authType
		 * @returns {Array}
		 */
		service.getAlternateCardCapturePaymentFields = function(authType) {
			var method = registeredPaymentMethods.filter(function(method) {
				return method.authType === authType;
			})[0];

			if (angular.isDefined(method) && method.customInputFields.length > 0) {
				return method.customInputFields;
			} else {
				return [];
			}
		};


		/**
		 * Is a given auth type one that requires capturing the users card number (requires Payment Form screen)
		 * @param authType
		 * @returns {boolean}
		 */
		service.isCardCaptureAuthType = function(authType) {
			return cardCaptureAuthTypes.indexOf(authType) > -1;
		};

		/**
		 * Assesses whether or not the expDate is required for a given auth type
		 * @returns {boolean}
		 */
		service.isExpDateRequiredAuthType = function(authType) {
			return (expDateNotRequiredAuthTypes.indexOf(authType) == -1);
		};

		/**
		 * Assesses whether or not the cvv is required for a given auth type
		 * @returns {boolean}
		 */
		service.isCVVRequiredAuthType = function(authType) {
			return cvvRequiredAuthTypes.indexOf(authType) > -1;
		};

		/**
		 * Assesses whether or not the cvv is optional for a given auth type
		 * @returns {boolean}
		 */
		service.isCVVOptionalAuthType = function(authType) {
			return cvvOptionalAuthTypes.indexOf(authType) > -1;
		};

		/**
		 * getRestrictedPaymentMethodOrBillingProviderNameForCart - right now as it exists on Backend, this is a restriction guided by package characs
		 * as far as the payment methods that will display
		 * This function retrieves the name of the current restricted payment method on the cart that should be offered on the payment method screen
		 * If the cart happens to have a restricted payment method that MUST be used to purchase the item(s) with, this will return the payment method or billing provider name
		 * It should be noted that if a billing provider happens to be what is restricted - these are digital wallet-like offerings that can include card types (VISA, Mastercard)
		 * This will work in conjunction with the restricted card type codes so they can work together.
		 * If other payment methods ever needed to be restricted, this architecture on the Backend would need to be expanded and probably move away from using package characs
		 * @returns {undefined}
		 */
		service.getRestrictedPaymentMethodOrBillingProviderNameForCart = function() {
			var restrictedMethodName = service.getRestrictedBillingProviderNameForCart();
			//TODO in the future we can build this function out to include other payment methods - right now the only supported notions on Backend of restricting payments methods/providers
			// on a cart is via card types for the cc payment method OR a particular billing provider
			//laying this foundation for the future as we can add other assessments here

			return restrictedMethodName;
		}


		/**
		 * Get Billing Providers for Cart (taking into account the restricted ones)
		 */
		service.getBillingProvidersForCart = function() {
			var restrictedBillingProviderName = service.getRestrictedBillingProviderNameForCart();

			return AppData.billingProviders.filter(function(billingProvider) {
				var billingProviderName = billingProvider.billing_provider_name.toLowerCase();

				//assess whether or not this provider is allowed for partial payments
				var isAllowed = UserInfo.get('partialPayments').length > 0 ? service.doesPaymentMethodOrProviderSupportPartialPayments(billingProviderName) : true;
				if (restrictedBillingProviderName && isAllowed) {
					isAllowed = billingProviderName === restrictedBillingProviderName.toLowerCase();
				}

				return isAllowed;
			});
		};

		/**
		 * Is the 3DS Check enabled on the credit card payment form
		 * @returns {boolean}
		 */
		service.is3DSOnBillingPaymentFormCheckEnabled = function() {
			 return do3DSOnBillingPaymentFormCheck;
		}

		/**
		* Is the 3DSecure billing type enabled on the merchant
		* @function
		* @public
		* @returns {Boolean} true if auth_type is 3DS or one item has enabled_3ds
		*/
		service.has3DSBillingType = function() {
			return AppData.billingTypes.some(function(item) {
				return item.auth_type === Enums.billingTypes.SECURE3D || getBoolean(item.enabled_3ds);
			});
		}


		/**
		 * Finalize billing checkout process - call UpdateCartCheckoutInfo and then GetCartSummary
		 * @param shouldReplaceRoute
		 */
		service.finalizeBillingCheckout = function(ignoreAssessRoute, onSuccess, onError) {
			$rootScope.showSpinner();

			UserInfo.payment.shipMethod = UserInfo.shipping.deliveryMethod;
			UserInfo.payment.shipAmount = UserInfo.shipping.deliveryAmount;
			UserInfo.set('payment', UserInfo.payment);

			/* eslint-disable camelcase */
			var myUpdateCartCheckoutInfoData = {
				shippingMethod: UserInfo.payment.shipMethod,
				shippingAmount: UserInfo.payment.shipAmount,
				skip_requests: 'SetExpressCheckout'
			};

			if (UserInfo.payment.merchant_payment_type_ref_id) {
				myUpdateCartCheckoutInfoData.merchant_payment_type_ref_id = UserInfo.payment.merchant_payment_type_ref_id;
			} else {
				myUpdateCartCheckoutInfoData.billingId = UserInfo.payment.billingId || UserInfo.payment.billing_id;
			}
			/* eslint-disable camelcase */

			LegacyCart.callUpdateCartCheckoutInfo(myUpdateCartCheckoutInfoData, function() {
				if (!ignoreAssessRoute) {
					assessRouting();
				}
				if (isFunction(onSuccess)) {
					onSuccess();
				}
			}, function() {
				showUpdateCartCheckoutErrorModal();
				if (isFunction(onError)) {
					onError();
				}
			});
		}

		/**
		 * Show an error modal if updateCartCheckout fails
		 */
		function showUpdateCartCheckoutErrorModal() {
			$rootScope.hideSpinner();
			Modal.displayModal(
				{
					category: 'Cart',
					action: 'Error',
					label: 'Cart Checkout Failure',
					icon: 'icon-info red',
					title: Language.getLocale('Billing', 'errorBillingCheckoutTitle'),
					description: Language.getLocale('Billing', 'errorBillingCheckoutMsg'),
					buttonFlags: [Enums.buttonFlags.OK],
					showCloseButton: false,
					callback: function() {
						$rootScope.routeTo(Enums.routes.CART);
					}
				}
			);
		}

		 /**
		  * Do the items in the cart require a payment plan
		  */
		service.isPaymentPlanCart = function() {
			return checkProp('LegacyCart.cartDetails.PAYMENT_SCHEDULE.PAYMENT', LegacyCart,	function(paymentSchedulePayments) {
				return paymentSchedulePayments.length > 0;
			});
		}


		/**
		 * Assess whether or not we should go to the Agreement route or OrderReview
		 */
		function assessRouting() {
			if (!CustomActionService.executeCustomAction(CustomActionService.ACTIONS_ENUMS.BILLING_ROUTE_ASSESSMENT)) {
				$rootScope.routeTo(Enums.routes.REVIEW);
			}

			$rootScope.hideSpinner();
		}

		/**
		 * List of Payment methods that should route to the standard billing screen flow
		 * @type {*[]}
		 */
		service.billingRoutePaymentProviders = [

			Enums.paymentProvider.IDEAL,
			Enums.paymentProvider.MRCASH,
			Enums.paymentProvider.CREDITCARD,
			Enums.paymentProvider.STOREDPAYMENTS

		];

		/**
		 * Get Matching Auth Type Given Payment Provider
		 * @param paymentProvider
		 * @returns {string}
		 */
		service.getMatchingAuthTypeForPaymentProvider = function(paymentProvider) {
			var authType = '';
			if (!UtilsValidation.validString(paymentProvider)) {
				return authType;
			}

			var mapping = paymentProviderAuthTypeMapping.filter(function(item) {
				return item.name.toLowerCase() === paymentProvider.toLowerCase();
			})[0];

			if (angular.isDefined(mapping)) {
				authType = mapping.authType;
			}

			return authType;
		}

		/**
		 * Retrieve the billing provider that the cart is currently restricted to if it exists on a cart item
		 * @function
		 * @public
		 * @returns {undefined|String} billing provider
		 */
		service.getRestrictedBillingProviderNameForCart = function() {
			var restrictedBillingProvider,
				restrictedBillingCharac,
				i = 0,
				itemCharacsCopy,
				item;
			for (; i < LegacyCart.cartItems.length; i++) {
				item = LegacyCart.cartItems[i];
				if (item.CHARACS) {
					itemCharacsCopy = Utilities.wrapObjectToArray(item.CHARACS);

					//can only have one restriction on a merchant's active package suite
					restrictedBillingCharac = itemCharacsCopy.find(function(charac) {
						return validString(charac.payment_method_required) || validString(charac.billing_provider_required);
					});

					if (angular.isObject(restrictedBillingCharac)) {
						restrictedBillingProvider = restrictedBillingCharac.payment_method_required || restrictedBillingCharac.billing_provider_required;
						break;
					}
				}
			}

			return restrictedBillingProvider;
		}

		/**
		 * Register a billing route payment provider that will route directly to the standard billing flow
		 * @param provider
		 */
		service.registerBillingRoutePaymentProviders = function(provider) {
			if (service.billingRoutePaymentProviders.indexOf(provider) === -1) {
				service.billingRoutePaymentProviders.push(provider);
			}
		}

		/**
		 * Register Express Payment method option - can be used by Payment methods like PayPal that has express option
		 * Note that Express Payment methods are different from express billing providers like Apple Pay, Google Pay
		 * Billing Providers can have card types defined, Payment methods can't
		 * @public
		 * @function
		 * @returns {undefined}
		 */
		service.registerExpressPaymentMethodOption = function(options) {
			var optionFound = paymentMethodsWithExpressOption.some(function(expressOption) {
				return normalize(expressOption.paymentProvider) === normalize(options.paymentProvider) && normalize(expressOption.authType) === normalize(options.authType);
			});
			if (!optionFound) {
				paymentMethodsWithExpressOption.push(options);
			}
		};

		/**
		 * Returns express payment method options
		 * @public
		 * @function
		 * @returns {Object[]} payment methods express options
		 */
		service.getExpressPaymentMethodOptions = function() {
			return paymentMethodsWithExpressOption;
		};

		/**
		 * Register as Express Wallet Payment - can be used by Billing Providersthat has express option
		 * Note that Express Wallet Payments are different from express payment methods like PayPal
		 * @public
		 * @function
		 * @returns {undefined}
		 */
		service.registerExpressWalletPayment = function(expressPayment) {
			var paymentFound = expressWalletPayments.find(function(payment) {
				return normalize(payment.providerName) === normalize(expressPayment.providerName) && normalize(payment.authType) === normalize(expressPayment.authType);
			});
			if (!paymentFound) {
				expressWalletPayments.push(expressPayment);
			}
		};

		/**
		 * Returns express wallet payment
		 * @public
		 * @function
		 * @returns {Object[]} registered express wallet payments
		 */
		service.getExpressWalletPayments = function() {
			var restrictedPayment = service.getRestrictedPaymentMethodOrBillingProviderNameForCart();
			if (validString(restrictedPayment)) {
				return expressWalletPayments.filter(function filterWalletPayments(walletPayment) {
					return validString(walletPayment.providerName) && normalize(walletPayment.providerName) === normalize(restrictedPayment);
				});
			}
			return expressWalletPayments;
		};

		/**
		 * Asynchronous promises that will assess billing types and setup initial configuration and/or lazy load files needed for payment method
		 * @param promise
		 */
		service.appendPaymentMethodLoadPromise = function(promise) {
			if (registeredPaymentMethodLoadPromises.indexOf(promise) === -1) {
				registeredPaymentMethodLoadPromises.push(promise);
			}
		}

		/**
		 * Load all configs and lazyload files needed for configured payment methods that are registered
		 * @returns {Promise}
		 */
		service.runRegisteredPaymentMethodsPromises = function() {
			$rootScope.showSpinner(Language.getLocale('ApplicationLabels', 'updatingPaymentInfoLoadMsg'));
			var promiseRuns = registeredPaymentMethodLoadPromises.map(function(promise) {
				return promise();
			});
			return $q.all(promiseRuns)
				.then(function() {
					//remove all promises as they are no longer necessary for load when this is called once
					registeredPaymentMethodLoadPromises.length = 0;
				});
		};

		/**
		 * Checking selected authType, is it on authTypeWithoutAddress array list? if it is, then we
		 * want to hide address fields on Demographic Form
		 * @public
		 * @param {String} authType
		 * @returns {boolean}
		 */
		service.hideAddressFieldsCheck = function(authType) {
			return validString(authType) && authTypesWithoutAddress.indexOf(authType.toLowerCase()) !== -1;
		};

		/**
		 * Adding authType to authTypeWithoutAddress array list, so it can be used to determine does the selected
		 * payment need address info?
		 * @public
		 * @param {String} authType
		 * @returns {undefined}
		 */
		service.registerAuthTypeWithoutAddress = function(authType) {
			if (authTypesWithoutAddress.indexOf(authType) === -1) {
				authTypesWithoutAddress.push(authType.toLowerCase());
			}
		};

		/**
		 * Checks to see if 3DSecure is enabled
		 * @param {Object} payment used to determine the 3DS configuration
		 * @returns {boolean} determines if 3DS is enabled
         */
		service.is3DSecureEnabled = function(payment) {
			return angular.isObject(payment) &&
				payment.authType == Enums.billingTypes.CREDITCARD &&
				service.is3DSOnBillingPaymentFormCheckEnabled() &&
				payment.card_type_code !== 'AX';
		};
		/**
		 * Check if a form field is optional based on the demographic_form_field_overrides app config
		 * @public
		 * @function
		 * @name isOptionalField
		 * @memberof {BillingService}
		 * @param {string} field Name of the field being assessed
		 * @param {string} authType We can restict fields to be optional based on the auth type the user has selected
		 * @return {boolean} true if the form field is determined to be optional
		 */
		service.isOptionalField = function(field, authType) {
			return isAuthTypeInFormFieldOverrides(authType) && formFieldOverrides.formOptionalFields.indexOf(field) > -1;
		};
		/**
		 * Check if a form field should be removed based on the demographic_form_field_overrides app config
		 * @public
		 * @function
		 * @name isRemovedField
		 * @memberof {BillingService}
		 * @param {string} field Name of the field being assessed
		 * @param {string} authType We can restict fields to be optional based on the auth type the user has selected
		 * @return {boolean} true if the form field is determined to be removed
		 */
		service.isRemovedField = function(field, authType) {
			return isAuthTypeInFormFieldOverrides(authType) && formFieldOverrides.formRemoveFields.indexOf(field) > -1;
		};
		/**
		 * Assess if the user's auth type is in the demographic_form_field_overrides app config for field overrides
		 * @protected
		 * @function
		 * @name isAuthTypeInFormFieldOverrides
		 * @memberof {BillingService}
		 * @param {string} authType User's auth type
		 * @return {boolean} true if the auth type is in the app config OR if the app config does not have this restriction
		 */
		function isAuthTypeInFormFieldOverrides(authType) {
			if (validString(authType) && isArray(formFieldOverrides.authTypes)) {
				return !formFieldOverrides.authTypes.length || formFieldOverrides.authTypes.indexOf(authType.toLowerCase()) > -1;
			}
			return false;
		}

		/**
		 * Check if current user's auth type does not need credit card form
		 * @public
		 * @function
		 * @param {String} authType User's auth type
		 * @return {boolean} true if user's auth type match with the one on array list
		 */
		function doesAuthTypeRequireCreditCardForm(authType) {
			return authTypesWithNoCreditCardForm.indexOf(authType) > -1;
		}

		/**
		 * parse demographic_form_field_overrides app config for field overrides
		 * @protected
		 * @function
		 * @name getFormFieldOverrides
		 * @memberof {BillingService}
		 * @return {Object} demographic_form_field_overrides for the billing form
		 */
		function getFormFieldOverrides() {
			var config,
				optional = [],
				remove = [],
				authTypes = [],
				i = 0,
				configLength;
			if (JSONValidator.validate('demographic_form_field_overrides', AppData.settings.demographic_form_field_overrides)) {
				config = JSON.parse(AppData.settings.demographic_form_field_overrides);
				configLength = config.length;
				for (; i < configLength; i++) {
					if (config[i].forms.indexOf('billing') > -1) {
						optional = config[i].optional_fields;
						if (isArray(config[i].removed_fields)) {
							remove = config[i].removed_fields;
						}
						if (isArray(config[i].auth_types)) {
							authTypes = config[i].auth_types.map(function(authType) {
								return authType.toLowerCase();
							 });
						}
						break;
					}
				}
			}
			return {
				authTypes: authTypes,
				formOptionalFields: optional,
				formRemoveFields: remove
			};
		}

		return service;
	});

angular.module('app')
	.service('Bootstrap', function($q, $rootScope, $state, AppData, AccessoPayPrepService, AuthService, CartService, ComponentLoaderService, DynamicPricingService, Enums, errorTracking, ProfileLoginPrepService, RecaptchaV3Service, $rootScope, ResellerService, Utilities, Geolocation, Storage, TE2PrepService, SimpleStoreRoutingService, UiRouterOverrideService) {
		var service = {};

		/**
		 * Bootstrap the applciation
		 * @param extraRequests
		 * @param byPassHideSpinnerCall
		 * @param bootstrapLogging When true, each step is logged to Coralogix RUM (with acsop_* values redacted) right before it runs
		 */
		service.bootstrapApplication = function(extraRequests, byPassHideSpinnerCall, bootstrapLogging) {
			function logged(feature, fn) {
				return errorTracking.accessoPayStep('Bootstrap', feature, fn, bootstrapLogging);
			}

			// FolioService has to bootStrap before AppData so that its hooks will be called when AppData calls GetMerchantPackageList
			return logged('ResellerService.bootstrapReseller', function() {
				return ResellerService.bootstrapReseller();
			})()
				.then(logged('AuthService.hydrateState', AuthService.hydrateState))
				.then(function asyncSteps() {
					return $q.all([
						logged('Storage.bootstrap', function() { return Storage.bootstrap(); })(),
						logged('UiRouterOverrideService.initialize', function() { return UiRouterOverrideService.initialize(); })(),
					]);
				})
				.then(logged('AppData.initializeData', function() {
					return AppData.initializeData(extraRequests);
				}))
				.then(logged('AuthService.bootstrap', AuthService.bootstrap))
				.then(function asyncSteps() {
					return $q.all([
						logged('ResellerService.assessInvalidAccess', function() { return ResellerService.assessInvalidAccess(); })(),
						logged('Geolocation.initialize', function() { return Geolocation.initialize(); })(),
						logged('CartService.initialize', function() { return CartService.initialize(); })(),
						logged('ProfileLoginPrepService.configureProfileLogin', function() { return ProfileLoginPrepService.configureProfileLogin(); })(),
						logged('DynamicPricingService.getMultiPackMetaData', function() { return DynamicPricingService.getMultiPackMetaData(); })(),
						logged('TE2PrepService.initialize', function() { return TE2PrepService.initialize(); })(),
						logged('RecaptchaV3Service.loadAssets', function() { return RecaptchaV3Service.loadAssets(); })(),
						logged('ComponentLoaderService.bootstrap', function() { return ComponentLoaderService.bootstrap(); })(),
						logged('AccessoPayPrepService.loadAssetsAndSetup', function() { return AccessoPayPrepService.loadAssetsAndSetup(); })(),
						logged('UiRouterOverrideService.initialWhitelistParams', function() { return UiRouterOverrideService.initialWhitelistParams(); })(),
					]);
				})
				.then(logged('SimpleStoreRoutingService.blockRoutingAwayFromSimpleStore', function() {
					if (SimpleStoreRoutingService.simpleStoreConfigured()) {
						SimpleStoreRoutingService.blockRoutingAwayFromSimpleStore($state.next, $state.toParams, true);
					}
				}))
				.then(function() {
					var isFirstInit = !AppData.applicationInitialized;

					// Only hide the spinner on first load — on re-navigation the global onSuccess
					// hook in run.js owns the lifecycle to prevent the previous page from flashing.
					if (isFirstInit && !Utilities.getBoolean(byPassHideSpinnerCall)) {
						$rootScope.hideSpinner();
					}

					if (isFirstInit) {
						// This is the first time the application has been initialized
						// We need to set the applicationInitialized flag
						AppData.applicationInitialized = true;

						$rootScope.$broadcast(Enums.services.APP_INIT, { status: true });
					}
				});
		};

		return service;
	});

angular
	.module('app')
	.service('LegacyCart', function(
		$filter,
		$location,
		$log,
		$q,
		$injector,
		$rootScope,
		$state,
		$window,
		AbTestService,
		AnalyticsDataLayerService,
		AppData,
		CartDataService,
		CartService,
		ClientInfo,
		CustomActionService,
		DynamicCapacityPricingService,
		Enums,
		ExtraFlow,
		Language,
		Modal,
		OneBarcodeUtilities,
		Package,
		StandardFlowInitiatorService,
		Storage,
		StringUtils,
		Utilities,
		UtilsPricing,
		UtilsValidation,
		UserInfo,
		JSONValidator) {
		var validString = UtilsValidation.validString;
		var validArray = UtilsValidation.validArray;
		var returnValue = Utilities.returnValue;
		var normalize = StringUtils.normalize;
		var billingProviders = Enums.billingProviders;
		var NORMALIZED_BILLING_PROVIDER_GOOGLEPAY = normalize(billingProviders.CYBERSOURCE_GOOGLEPAY),
			NORMALIZED_BILLING_PROVIDER_APPLE_PAY = normalize(billingProviders.CYBERSOURCE_APPLEPAY);
		var flags =
			{
				hasQuickSells: false,
				hasCrossSells: false,
				hasPackageCrossSells: false,
				hasCartCrossSells: false,
				hasUpSells: false
			};
		var status = Enums.status;
		var services = Enums.services;
		var Cart = {
			cartItems: [],
			lastDateAdded: {},
			splitCartItems: splitCartItems,
			_: { sortOneBarcodePackages: sortOneBarcodePackages }
		};

		var qtyAdded = 0;
		var retainCharacs = ['card_type_required', 'isAddonPackage', 'billing_provider_required', 'payment_method_required', 'required_scheduling_selections', 'is_upfront_membership']; // Copy these CHARACS over to items being added.

		var resellerSkipCartModal = 0;
		var checkProp = Utilities.safelyCheckPropertyOnObject;
		var getBoolean = Utilities.getBoolean;

		Cart.listShipping = false;

		Cart.getInitialCartQuantity = getInitialCartQuantity;
		Cart.totalQty = 0;

		/**
		 * Set to true on GetCartSummary response if there are packages in the
		 * cart that contain the "one_barcode_parent" CHARAC
		 */
		Cart.hasOneBarcodePackages = false;

		/**
		 * If we should use Legacy front-end calculations for the cart.
		 * @type {boolean}
		 */
		Cart.useCartViewTotalCalculation = false;

		/**
		 * Copy of the cart without the items that are in edit mode.
		 * Array is used if act of editiing an item
		 * causes changes to other items in the cart.
		 * This can also be used to have a reference of other items that
		 * may be in the cart that are not for the current Package.packageDetails object.
		 * @type {Array}
		*/
		Cart.editingCartCopy = [];

		//Declaring functions
		Cart.setMembershipUpgradeTotalCalculation = setMembershipUpgradeTotalCalculation;

		//handler object for package-level cross sells
		var packageCrossSells = {
			crossSellsList: [],
		 addToCrossSells: function(packageId, crossSell) {
				if (crossSell.hasOwnProperty('description')) {
					var canBeAdded = true;
					for (var key in this.crossSellsList) {
						if (this.crossSellsList[key].description == crossSell.description) {
							canBeAdded = false;
							break;
						}
					}

					if (canBeAdded) {
						crossSell.desc = crossSell.description;
						crossSell.packageId = packageId;
						this.crossSellsList.push(crossSell);
						if (!flags.hasPackageCrossSells) {
							flags.hasPackageCrossSells = true;
						}
					}
				}
			},
		 getRouteForCrossSells: function() {
				var result = '';
				this.crossSellsList.forEach(function(cs) {
					if (angular.isDefined(cs.packageId)) {
						var idToAdd = cs.packageId.toString()+',';
						if (result.indexOf(idToAdd) == -1) {
							result += idToAdd
						}
					}
				});
				if (result != '') {
					result = Enums.routes.CROSS_SELLS +'/'+result.substring(0, result.length-1);
				}
				return result;
			},
			/**
		 * buildCrossSellsFromRouteParam populates packageCrossSells from the parameter built in getRouteForCrossSells
		 * This whole class should be in its own model.
		 * @param routeParam
          */
		 buildCrossSellsFromRouteParam: function(routeParam) {
				var packageList = routeParam.split(',');
				this.crossSellsList = [];

				if (!Utilities.safelyCheckPropertyOnObject('AppData.GetMerchantPackageList.PS.P', AppData) || packageList.length < 1) {
				// if there are no packages, just drop out. This should never happen.
					return;
				}

				// Looping through GetMerchantPackageList because it's faster to step through that (incredibly long) list once,
				// than it would be to step through it once for each element of routeParam (which will typically have between 1 and 6 elements).
				for (var i = 0; i < AppData.GetMerchantPackageList.PS.P.length; i++) {
					var idx = packageList.indexOf(AppData.GetMerchantPackageList.PS.P[i].id);

					if (idx > -1) {
						var pkg = AppData.GetMerchantPackageList.PS.P[i],
							crossSells = (!pkg.CROSS_SELL || !pkg.CROSS_SELL.CS) ? [] :
								angular.isArray(pkg.CROSS_SELL.CS) ? pkg.CROSS_SELL.CS : [pkg.CROSS_SELL.CS];

						for (var p in crossSells) {
							if (crossSells[p].hasOwnProperty('keyword')) {
							//Before adding any keywords to the cross sells screen, check to see that there are active packages
							//for that keyword.
								var packages = filterPackagesByAssocKeywords(AppData.GetMerchantPackageList.PS.P, crossSells[p]['keyword']);
								if (validArray(packages)) {
									this.addToCrossSells(pkg.id, crossSells[p]);
								}
							}
						}
						// since we found this element, splice it off.
						packageList.splice(idx, 1);
						if (packageList.length < 1) {
							break;
						}
					}
				}
			},
		 clearList: function() {
				this.crossSellsList = []
			}
		};

		/**
		* Filter packages by assoc keywords. This is specifically for the cross sells because backend doesn't always return the full
		* string array of keywords. To compensate for this, use the assoc_keywords string array instead.
		* @private
		* @function
		* @memberof {Cart}
		* @name filterPackagesByAssocKeywords
		* @param {string} keyword - The keyword to filter packages by.
		* @returns {Array} The full array with replaced packages for zip code override.
		*/
		function filterPackagesByAssocKeywords(packages, keyword) {
			if (!validArray(packages)) {
				return [];
			}

			var keywordListToMatch = validString(keyword) ? keyword.toLowerCase().split(',') : [];
			return packages.filter(function(item) {
				if (!validString(item.assoc_keywords)) {
					return false;
				}

				return keywordListToMatch.some(function(kw) {
					return item.assoc_keywords.toLowerCase().indexOf(kw) > -1;
				});
			});
		}

		/**
		 * Checks if crosssell is added to the cart
		 * @public
		 * @function
		 * @param {Object} crossSell crosssell object
		 * @returns {Boolean} crosssell exists in cart
		 */
		Cart.isCrossSellAddedToCart = function(crossSell) {
			return Cart.cartItems.some(function(cartItem) {
				return cartItem.CHARACS.some(function(cartItemCharacObj) {
					return cartItemCharacObj.crosssell === 'true' && cartItemCharacObj.keyword_used === crossSell.keyword;
				});
			});
		};

		/**
		 * Clears the cart if it has any.
		 * @public
		 * @function
		 * @returns {undefined}
		 */
		Cart.clear = function() {
			return $q(function(resolve) {
				var items = Utilities.safelyCheckPropertyOnObject('AppData.GetCartSummary.CART.ITEMS', AppData, function(val) {
					return val;
				});

				// clear the package items to be added
				if (validArray(Package.itemsToBeAdded)) {
					Package.itemsToBeAdded.length = 0;
				}

				if (validArray(items) || !UtilsValidation.isEmptyObject(items)) {
					Cart.updateCartItems([], resolve);
				} else {
					resolve();
				}
			});
		};

		Cart.hasPackageCrossSells = function() {
			return flags.hasPackageCrossSells;
		};

		Cart.getPackageCrossSells = function(crossSellsRouteParam) {
			if (crossSellsRouteParam) {
				packageCrossSells.buildCrossSellsFromRouteParam(crossSellsRouteParam);
				return packageCrossSells.crossSellsList;
			} else if (Cart.hasPackageCrossSells()) {
				return packageCrossSells.crossSellsList;
			}
			return [];
		};

		Cart.routeToCrossSellsOrCartAsAppropriate = function() {
			var packageCrossSellRoute = flags.hasPackageCrossSells ? packageCrossSells.getRouteForCrossSells() : '';

			// Show spinner eagerly to prevent previous view from flashing during route transition.
			// The destination controller or onSuccess hook dismisses it.
			$rootScope.showSpinner();

			if (packageCrossSellRoute != '') {
				// Begin Cross Sell Flow
				StandardFlowInitiatorService.setStandardFlow(undefined, 'crossSells', 'noDetail');
				$rootScope.routeTo(packageCrossSellRoute);
			} else {
				$rootScope.routeTo(Enums.routes.CART);
			}
		};

		/**
		 * Adds package level cross sells to the package if there are any defined for the current
		 * customerType
		 *
		 * @param customerType {Object} reference to the current customer type in the package
		 * @param packageDetails {Object} reference to the current packageDetails object in the package list
		 */
		Cart.setPackageCrossSells = function(customerType, packageDetails) {
			//check if we are in the cross sell flow or cross sells are defined.
			// If we are in cross sell flow, allow us to continue to see the cross sells, so don't clear them.
			if (StandardFlowInitiatorService.currentStandardFlowType !== 'crosssells' &&
						(angular.isUndefined(customerType.CHARACS) ||
						angular.isUndefined(customerType.CHARACS[0].crosssell) ||
						!customerType.CHARACS[0].crosssell)) {
				Cart.clearPackageCrossSells();
			}
			setCrossSellKeywords(packageDetails);
		};

		Cart.clearPackageCrossSells = function() {
			packageCrossSells.clearList();
			flags.hasPackageCrossSells = false;
		};

		// Update cart quantity functionality.
		Cart.updateQTY = function(cartItems) {
			for (var i = 0; i < cartItems.length; i++) {
				// Flag used to determine if the CHARACs should be copied.
				// Checks if currently, the length of the CHARACs = quantity.
				cartItems[ i ].copyCharacs =
					(cartItems[ i ].CHARACS
					&& Number(cartItems[ i ].qty) == cartItems[ i ].CHARACS.length
					);

				// Save a reference to the original quantity.
				cartItems[ i ].prevQty = cartItems[ i ].qty;
			}
		};

		Cart.cancelUpdate = function(cartItems) {
			for (var i = 0; i < cartItems.length; i++) {
				cartItems[ i ].qty = cartItems[ i ].prevQty;
				delete cartItems[ i ].prevQty;
				delete cartItems[ i ].copyCharacs;
			}
		};

		Cart.commitUpdateQTY = function(cartLimit, callback) {
			// Extract the difference of the items being added.
			// Verify adding more does not exceed cart limit.
			// Handle less qty then previously added.

			var numPrevQty = 0,
				originalQty = 0,
				diff = 0,
				moreItems = false,
				lessItems = false,
				noChange = false,
				itemsUpdated = 0;

			for (var i = 0; i < Cart.cartItems.length; i++) {
				var item = Cart.cartItems[ i ];
				// This will be true if the user deletes the qty but does not enter a value.
				// Assume the user meant to delete the item.
				if (item.qty == '') {
					item.qty = '0';
				}

				// For some reason, this property is failing the addToCart functionality.
				// Delete it.
				delete item.$$hashKey;

				numPrevQty = Number(item.prevQty);
				originalQty = Number(item.qty);
				moreItems = numPrevQty < originalQty;
				lessItems = numPrevQty > originalQty;
				noChange = numPrevQty == originalQty;

				if (noChange) {
					continue;
				}

				if (moreItems) {
					// Ensure we are not exceeding cart limit.
					if (Cart.getTotalLessOverride() <= Number(cartLimit)) {
						diff = originalQty - numPrevQty;
						item.qty = String(item.qty);

						if (item.copyCharacs) {
							// Copy the CHARACS.
							item.CHARACS = item.CHARACS || [];

							var characLen = item.CHARACS.length;
							for (var j = characLen; j < diff + characLen; j++) {
								item.CHARACS[ j ] = item.CHARACS[ 0 ] || {};
							}
						}

						itemsUpdated++;
					} else {
						// Alert User... Cart limit will be exceeded.
						showCartLimitModal();
						return;
					}
				} else if (lessItems) {
					diff = numPrevQty - originalQty;
					if (item.CHARACS && (item.CHARACS.length > 0) && item.copyCharacs) {
						while (item.CHARACS.length != originalQty) {
							item.CHARACS.splice(item.CHARACS.length -1, 1);
						}
					}

					itemsUpdated++;
				}

				delete item.prevQty;
				delete item.copyCharacs;
			}

			if (itemsUpdated) {
				// Update Cart Items.
				Cart.updateCartItems(Cart.cartItems, function(success) {
					if (callback) {
						callback(success);
					}
				}, true, true);
			} else {
				callback(true);
			}
		};

		/**
		 *	Customized Version of Cart.addToCart specific to handling upsells.
		 *  @public
		 *	@param {Array} preCartItems Upsell items to be added to cart
		 *	@returns {Boolean} true / false
		 */

		Cart.addUpsellsToCart = function(preCartItems) {
			// reset the preCartItems and preCartItemsIndex
			Package.preCartItems = [];
			Package.preCartItemsIndex = 0;

			// Reset the qty after message has been displayed.
			qtyAdded = 0;
			var totalLessOverrideBeingAdded = 0;

			// need to process this on a package basis.
			for (var i in preCartItems) {
				var customerTypes = preCartItems[i].customerTypes;
				var packageDetails = preCartItems[i].packageDetails;
				var itemsToBeAdded = [];
				var isAdvancedTicket = preCartItems[i].isAdvancedTicket;
				var advanceDateTime = preCartItems[i].advanceTicketDate;

				// check the limits on the cart.
				if (Cart.exceededPackageLimit(customerTypes, packageDetails)) {
					return false;
				}

				// loop through each of the customerTypes and make sure everything is good.
				for (var i in customerTypes) {
					var currentItem = customerTypes[ i ];
					// Skip rates with 0 qty selected.
					if (currentItem.qty <= 0) {
						continue;
					}

					// we will use the same functions for validating the qty amounts, but we need to make sure we've made adjustments
					// the adjustment would have occurred in UpsellController.js
					if (!Cart.validateMinQty(currentItem)) {
						return false;
					}

					if (!Cart.validateMaxQty(currentItem)) {
						return false;
					}

					// Do not consider packages with cart limit overrides.
					if (!getCartLimitOverride(currentItem)) {
						// If cart limit override is undefined, count this qty towards total.
						totalLessOverrideBeingAdded += Number(currentItem.qty);
					}

					// can't use it the same way. this is designed with one package in mind.
					var currentPackage = Cart.setItemsToBeAdded(currentItem);
					if (angular.isUndefined(currentPackage.CHARACS[0])) {
						currentPackage.CHARACS[0] = {};
					}
					if (currentPackage.package_id === Package.upsellPackage.packageDetails.id) {
						currentPackage.CHARACS[0].upsell = 'true';
					}
					itemsToBeAdded.push(currentPackage);
					addPackageCharacs(itemsToBeAdded, packageDetails);
					qtyAdded += currentItem.qty;
				} // end // for( var i in customerTypes ) {

				// check to see if we have anything in the list of items to be added.
				if (itemsToBeAdded.length > 0) {
					Cart.syncQuantityAndCharacs(itemsToBeAdded);

					if (Cart.getTotalLessOverrideBeingAdded(totalLessOverrideBeingAdded, Package.cartLimit)) {
						// If an advanced ticket, prompt user before adding to cart.
						promptAdvancedTicketModal(
							 isAdvancedTicket
							, advanceDateTime
							, function(isAdvanced) { // If it's advanced, add client charac to each item.
								if (isAdvanced) {
									for (var i = 0; i < itemsToBeAdded.length; i++) {
										itemsToBeAdded[ i ].CHARACS = itemsToBeAdded[ i ].CHARACS || [];

										for (var j = 0; j < itemsToBeAdded[ i ].qty; j++) {
											itemsToBeAdded[ i ].CHARACS[ j ] = itemsToBeAdded[ i ].CHARACS[ j ] || {};
											itemsToBeAdded[ i ].CHARACS[ j ].client_is_advanced_ticket = 'true';
											itemsToBeAdded[ i ].CHARACS[ j ].valid_from = Package.advanceTicketDate;
										}
									}
								}
							} // end // function ( isAdvanced )
						);

						Package.preCartItems.push(
							{
								packageDetails: packageDetails,
								customerTypes: customerTypes,
								itemsToBeAdded: itemsToBeAdded,
								isAdvancedTicket: isAdvancedTicket,
								advanceDateTime: advanceDateTime
							}
						);
					} else {
						qtyAdded = 0;
					}
				}
			} // end // for ( var i in preCartItems ) {

			if (Package.preCartItems.length > 0) {
				//Always set the cross sells to the first package's cross sells-- The first package in this list will
				// always be the upsell package if there is one OR the normal package if the user chose not to upsell.
				Cart.setPackageCrossSells(Package.preCartItems[0], Package.preCartItems[0].packageDetails);

				CustomActionService.executeCustomAction('postUpsellProcessing', undefined, [true, Package.preCartItems[0].itemsToBeAdded]);

				// at this point, I should have an array of objects where each element has the packageDetails, customerTypes, and itemsToBeAdded.
				// Advanced ticket check complete and user agreed to terms. // Check for XFCs and delegate to ExtraFlow if any.
				Package.doSeriesXFC(addUpsellCartItems);
			} else {
				// User didn't select a qty to add.
				Cart.addToCartNoQtyError();
			}
			return true;
		};

		Cart.syncQuantityAndCharacs = function(itemsToBeAdded) {
			for (var i=0; i < itemsToBeAdded.length; i++) {
				if (angular.isDefined(itemsToBeAdded[i].qty) && angular.isArray(itemsToBeAdded[i].CHARACS)) {
					/*
					 *	Clone characs according to the quantity so they are in sync
					 *
					 *	AXD 2303
					 *	It is possible to exceed the package/cart limit and be forced to adjust the upsell quantity.
					 *	For this reason, we must make sure to reset the current CHARACS array to 1 element and rebuild
					 *	so that our length of characs will always match the quantity.
					 *	- MY
					 */
					itemsToBeAdded[i].CHARACS.length = 1;

					for (var j = 1; j < itemsToBeAdded[i].qty; j++) {
						itemsToBeAdded[i].CHARACS.push(angular.copy(itemsToBeAdded[i].CHARACS[0]));
					}
				}
			}
		};


		/**
	 * Does the cart have payment plan items
	 */
		Cart.isPaymentPlanInCart = function() {
			return Utilities.safelyCheckPropertyOnObject('Cart.cartDetails.PAYMENT_SCHEDULE.PAYMENT', Cart,
				function(paymentSchedulePayments) {
					return paymentSchedulePayments.length > 0
				});
		}
		/**
	 * Checks if the cart items has exempt from payment plan
	 * @public
	 * @returns {Boolean} true / false
	 */
	 Cart.hasExemptPaymentPlanForms = function() {
			var i=0;
			var cartItems = Cart.cartItems;
			for (;i<cartItems.length; i++) {
				if (Array.isArray(cartItems[i].CHARACS) && getBoolean(cartItems[i].payment_plan) && !getBoolean(cartItems[i].CHARACS[0].is_exempt_from_paymentplan_forms)) {
					return false;
				}
			}
			return true;
		}

		/**
		 *	This function prepares the preCartItems data before we call the final function to add the items to the cart.
		 *	@return null
		 */

		function addUpsellCartItems() {
			CustomActionService.executeCustomAction('setSelectedUpsellPackages', Package.finalCartItemsToBeAdded);
			CustomActionService.executeCustomAction('addSessionDataToPackages', Package.finalCartItemsToBeAdded);

			addKeyword(Package.finalCartItemsToBeAdded);

			if (!CustomActionService.executeCustomAction('updateCartItems', Package.finalCartItemsToBeAdded)) {
				addCartItems(Package.finalCartItemsToBeAdded);
			}
		}

		function addKeyword(itemsToBeAdded) {
			for (var i in itemsToBeAdded) {
				for (var charac in itemsToBeAdded[i].CHARACS) {
					if (angular.isUndefined(itemsToBeAdded[i].CHARACS[charac].keyword_used)) {
						itemsToBeAdded[i].CHARACS[charac].keyword_used = AppData.lastKeyword;
					}
				}
			}
		}

		Cart.setPackageService_ItemsToBeAdded = function(itemsToBeAdded) {
			var deferred = $q.defer();

			if (!Utilities.isEmpty(Package.itemsToBeAdded)) {
				for (var i in itemsToBeAdded) {
					for (var k in Package.itemsToBeAdded) {
						if (itemsToBeAdded[i].package_id == Package.itemsToBeAdded[k].package_id && itemsToBeAdded[i].customer_type === Package.itemsToBeAdded[k].customer_type) {
							if (typeof(Package.itemsToBeAdded[k].CHARACS) != "undefined" && angular.isArray(Package.itemsToBeAdded[k].CHARACS) && Package.itemsToBeAdded[k].CHARACS.length > 0) {
								for (var c in itemsToBeAdded[i].CHARACS) {
									var characKeyArray = Object.keys(Package.itemsToBeAdded[k].CHARACS[0]);

									for (var characKeyIndex = 0; characKeyIndex < characKeyArray.length; characKeyIndex++) {
										var key = characKeyArray[characKeyIndex];
										if (key == 'group_uuid') {
											continue;
										}


										if (Utilities.objectKeyExists(key, itemsToBeAdded[i].CHARACS[c])) {
											//doing nothing for now
										} else {
											itemsToBeAdded[i].CHARACS[c][key] = Package.itemsToBeAdded[k].CHARACS[0][key]
										}
									}
								}
							}
						}
					}
				}

				//flush

				Package.itemsToBeAdded.length = 0;
			}

			Package.itemsToBeAdded = Utilities.copyObject(itemsToBeAdded);


			deferred.resolve(Package.itemsToBeAdded);
			return deferred.promise;
		}

		Cart.addToCartWithReturnUrl = function(customerTypes, packageDetails, returnUrl) {
			Cart.addToCart(customerTypes, packageDetails);

			Package.registerReturnUrl(returnUrl);
		};

		/**
		* listOfItemstToBeAdded is used by addListToCart. It creates a list of items to add to the cart.
		* If any minimum or maximum quantities are violated, it returns a string indicating the error.
		* Otherwise, it returns the list to add to the cart, and the total quantity of items added by that list.
		* @param customerTypes: array of CTs
		* @param packageDetails: the single Package that those CTs refer to.
		* @returns {{itemsToBeAdded: Array, error: string, qtyAdded: number}}
      */
		Cart.listOfItemsToBeAdded = function(customerTypes, packageDetails) {
			var result = {
				itemsToBeAdded: [],
				error: '',
				qtyAdded: 0
			};

			// check if the any of the customerTypes violates the package limits
			if (Cart.exceededPackageLimit(customerTypes, packageDetails)) {
				result.error = 'Exceeded Package Limit';
				return result;
			}

			// if it's an aliased package, respect the parent package's min/max qty
			if (packageDetails.type==="L") {
				var sumQty = customerTypes.reduce(function(acc, x) {
					return acc+Number(x.qty);
				}, 0);

				if (sumQty > 0) {
					if (!Cart.validateMinQty({
						qty: sumQty,
						min_quantity: packageDetails.min_quantity
					})) {
						result.error = 'Failed validateMinQty';
						return result;
					}

					if (!Cart.validateMaxQty({
						qty: sumQty,
						max_quantity: packageDetails.max_quantity
					})) {
						result.error = 'Failed validateMaxQty';
						return result;
					}
				}
			}

			for (var i in customerTypes) {
				var currentItem = customerTypes[ i ];

				if (parseInt(currentItem.qty) <= 0) {
				// Skip rates with 0 qty selected.
					continue;
				}

				// Check max and min quantities on on non-aliased packages.
				if (packageDetails.type!=="L") {
					if (!Cart.validateMinQty(currentItem)) {
						result.error = 'Failed validateMinQty';
						return result;
					}

					if (!Cart.validateMaxQty(currentItem)) {
						result.error = 'Failed validateMaxQty';
						return result;
					}
				}

				result.itemsToBeAdded.push(Cart.setItemsToBeAdded(currentItem));

				// addPackageCharacs makes sure there's a Charac for each CT.
				addPackageCharacs(result.itemsToBeAdded, packageDetails);

				// add CrossSells
				Cart.setPackageCrossSells(currentItem, packageDetails);
				result.qtyAdded += parseInt(currentItem.qty);
			}

			return result;
		};

		/**
	 * addListToCart is a function that accepts two arrays: customerTypes and packages.
	 * Each element of the customerTypes array must contain a package id that correspond to an element of the packages array.
	 * If the packages parameter is not an array, it builds one.
	 * In theory, addListToCart could be a drop-in replacement for addToCart,
	 * @param {Object[]} customerTypes A collection of items to add to the cart
	 * @param {Object[]} packages An array of packages
	 * @param {Function} onSuccessfulCallback A callback to call after adding to the cart. Overrides the default callback.
	 * @param {Function} onFailedCallback A callback to call after failing to add to the cart. Does not override the default funtionality.
	 * @returns {undefined}
	 */
		Cart.addListToCart = function(customerTypes, packages, onSuccessfulCallback, onFailedCallback) {
			var itemsForCart = [],
				qtyAdded = 0,
				packageList = (angular.isArray(packages)) ? packages : [packages];

			if (CustomActionService.actionRegistered(CustomActionService.ACTIONS_ENUMS.VALIDATE_CART_ADDITION)
				&& !CustomActionService.executeCustomAction(CustomActionService.ACTIONS_ENUMS.VALIDATE_CART_ADDITION,
					null, [customerTypes, Cart.cartItems, packages, function() {
						Cart.addListToCart.call(null, customerTypes, packages, onSuccessfulCallback, onFailedCallback);
					}])) {
				return;
			}

			// Reset the qty after message has been displayed.
			Package.registerReturnUrl(undefined);

			// build an array of CTs that applies to each package
			for (var p=0; p < packageList.length; p++) {
				var cts = [];
				for (var c=0; c < customerTypes.length; c++) {
					if (customerTypes[c].package_id === packageList[p].id) {
						cts.push(customerTypes[c]);
					}
				}

				var newlist = Cart.listOfItemsToBeAdded(cts, packageList[p]);
				if (newlist.error) {
					if(onFailedCallback) {
						// Add to cart operation failed due to quantity, thus the callback function gets called
						onFailedCallback();
					}
					return;
				}
				itemsForCart = itemsForCart.concat(newlist.itemsToBeAdded);
				qtyAdded += newlist.qtyAdded; // captures the total added for all CTs
				if (CustomActionService.actionRegistered('modifyCustomerTypesForCart')) {
					CustomActionService.executeCustomAction('modifyCustomerTypesForCart', null, [itemsForCart, packageList[p]]);
				}
			}

			// itemsForCart now holds a list of all the CTs for all the passed in packages.

			Cart.setPackageService_ItemsToBeAdded(itemsForCart).then(function(itemsAdded) {
				if (itemsAdded.length < 1) { // User didn't select a qty to add.
					Cart.addToCartNoQtyError();
					return;
				}

				// Now we do some counting to calculate the quantity that will be counted against the cart total
				// and to test the minimum required quantity for the sum of all the CTs in each package. To do that,
				// we have to build the total quantities for each package being added.
				//   qtyPerPkg will be populated with objects: { packageId: '', qty:0 };
				var qtyPerPkg = [],
				  qtyCountedAgainstCartTotal = 0;

				for (var i=0; i<itemsAdded.length; i++) {
					var item=itemsAdded[i];

					// For the quantity counted against the cart total, do not consider packages with cart limit overrides.
					if (!getCartLimitOverride(item)) {
					// If cart limit override is undefined, count this qty towards total.
						qtyCountedAgainstCartTotal += parseInt(item.qty);
					}


					// For the test of minimum quantity, we don't worry about the quantities of QuickSells
					if (itemsAdded.CHARACS && angular.isArray(itemsAdded.CHARACS) && itemsAdded.CHARACS.length > 0
					&& itemsAdded.CHARACS[ 0 ].quicksell === 'true') {
						continue;
					}

					var newQty = {
						package_id: item.package_id,
						qty: parseInt(item.qty)
					};

					for (var j=0; j<qtyPerPkg.length; j++) {
						if (qtyPerPkg[j].package_id === newQty.package_id) {
							qtyPerPkg[j].qty += newQty.qty;
							newQty.qty=0;
						}
					}

					if (newQty.qty>0) {
						qtyPerPkg.push(newQty);
					}
				}

				// qtyPerPkg now holds collection of {package_id, qty}
				// test these against the group min_qty

				for (var p = 0; p<qtyPerPkg.length; p++) {
					var inCart = false,
				    currentPkg = packageList.filter(function(pkg) {
							return (pkg.id === qtyPerPkg[p].package_id);
						})[0],
						minimum = (angular.isDefined(currentPkg.min_quantity)) ? parseInt(currentPkg.min_quantity) : 0;

					// First, no need to continue if there's no minimum.
					if (minimum<1) {
						continue;
					}

					// Make sure none of these packages are in the cart already.
					// This is matching previous functionality. It seems as though we should include the count of packages
					// in the cart... Deprecate this?
					for (var k=0; k < Cart.cartItems.length && ! inCart; k++) {
						inCart = (Cart.cartItems[k].package_id === qtyPerPkg[p].package_id);
					}
					if (inCart) {
						continue;
					}

					// Test the total CTs ordered for a package against that package's minimum quantity.
					if (qtyPerPkg[p].qty < minimum) {
						Cart.handleMinQtyModal({
							qty: qtyPerPkg[p].qty,
							min_quantity: minimum
						});
						return; // Not enough. drop out.
					}
				}

				// check if the total is going to go over the merchant's cart limit.
				if (Cart.getTotalLessOverrideBeingAdded(qtyCountedAgainstCartTotal, Package.cartLimit)) {
				// If an advanced ticket, prompt user before adding to cart.
					setAdvancedTicketNotification(
						function(isAdvanced) {
							// If it's advanced, add client charac to each item.
							if (isAdvanced) {
								for (var i = 0; i < itemsAdded.length; i++) {
									itemsAdded[ i ].CHARACS = itemsAdded[ i ].CHARACS || [];

									for (var j = 0; j < itemsAdded[ i ].qty; j++) {
										itemsAdded[ i ].CHARACS[ j ] = itemsAdded[ i ].CHARACS[ j ] || {};
										itemsAdded[ i ].CHARACS[ j ].client_is_advanced_ticket = 'true';
									}
								}
							}

							// Advanced ticket check complete and user agreed to terms.
							// Check for XFCs and delegate to ExtraFlow if any.
							Package.doXFCForPackageList(
								packageList,
								itemsAdded,
								customerTypes,
								function() {
									for (var j = 0; j < itemsAdded.length; j++) {
										var hasItem = false;
										for (var i = 0; i < Package.itemsToBeAdded.length; i++) {
											if (itemsAdded[ j ].package_id == Package.itemsToBeAdded[ i ].package_id) {
												hasItem = true;
											}
										}

										if (!hasItem) {
											Package.itemsToBeAdded.push(itemsAdded[ j ]);
										}
									}

									addKeyword(Package.itemsToBeAdded);

									CustomActionService.executeCustomAction('addSessionDataToPackages', Package.itemsToBeAdded);
									CustomActionService.executeCustomAction('setSelectedPackageList', customerTypes);


									// If in update mode execute an update cart instead of add to cart.
									if (!CustomActionService.executeCustomAction('updateCartItems', Package.itemsToBeAdded)) {
										addCartItems(Package.itemsToBeAdded, onSuccessfulCallback, onFailedCallback);
									}
								}
							);
						}
					);
				} else {
				// This is the case where the quantity being added is too large to put in the user's cart.
					qtyAdded = 0;
				}
			});
		};

		Cart.addToCart = function(customerTypes, packageDetails) {
			if (CustomActionService.actionRegistered(CustomActionService.ACTIONS_ENUMS.VALIDATE_CART_ADDITION) && !CustomActionService.executeCustomAction(CustomActionService.ACTIONS_ENUMS.VALIDATE_CART_ADDITION, null, [customerTypes, Cart.cartItems, packageDetails, function() {
				Cart.addToCart.call(null, customerTypes, packageDetails);
			}])) {
				return;
			}

			if (CustomActionService.actionRegistered('calendarAddToCart')) {
				customerTypes = CustomActionService.executeCustomAction('calendarAddToCart', undefined, [customerTypes, packageDetails]);
			}

			CustomActionService.executeCustomAction('setSelectedPackage', packageDetails);
			CustomActionService.executeCustomAction('modifyCustomerTypesForCart', null, [customerTypes, packageDetails]);

			// Reset the qty after message has been displayed.
			Package.registerReturnUrl(undefined);
			qtyAdded = 0;
			var totalLessOverrideBeingAdded = 0;

			var itemsToBeAdded = [];

			if (Cart.exceededPackageLimit(customerTypes, packageDetails)) {
				return;
			}

			// if it's a aliased package, respect the parent package's min/max qty
			if (packageDetails.type==="L") {
				for (var packageDetailsId in packageDetails) {
					if (packageDetailsId === "id" && packageDetails.hasOwnProperty("id")) {
						var pdId = packageDetails.id;
						var matchingCustomerTypes = [];
						// Iterate through customerTypes to find a match
						for (var i = 0; i < customerTypes.length; i++) {
							if (customerTypes[i].package_id === pdId) {
								matchingCustomerTypes.push(customerTypes[i]);
							}
						}
					}
				}
				var sumQty = matchingCustomerTypes.reduce(function(acc, x) {
					return acc+Number(x.qty);
				}, 0);

				if (sumQty > 0) {
					if (!Cart.validateMinQty({
						qty: sumQty,
						min_quantity: packageDetails.min_quantity
					})) {
						return;
					}

					if (!Cart.validateMaxQty({
						qty: sumQty,
						max_quantity: packageDetails.max_quantity
					})) {
						return;
					}
				}
			}

			for (var i in customerTypes) {
				var currentItem = customerTypes[ i ];

				//We only want to validate min and max quantity if the current item's quantity is great than 0.
				if (currentItem.qty <= 0) {
					// Skip rates with 0 qty selected.
					continue;
				}

				// only perform this check on non-aliased packages.
				if (packageDetails.type!=="L") {
					if (!Cart.validateMinQty(currentItem)) {
						return;
					}

					if (!Cart.validateMaxQty(currentItem)) {
						return;
					}
				}

				if (!validateVariablePriceRange(currentItem, packageDetails)) {
					return;
				}

				// Do not consider packages with cart limit overrides.
				if (!getCartLimitOverride(currentItem)) {
					// If cart limit override is undefined, count this qty towards total.
					totalLessOverrideBeingAdded += Number(currentItem.qty);
				}

				itemsToBeAdded.push(Cart.setItemsToBeAdded(currentItem));

				// TODO: Look at the Array of CHARACS (not duplicated)
				addPackageCharacs(itemsToBeAdded, packageDetails);

				Cart.setPackageCrossSells(currentItem, packageDetails);

				qtyAdded += currentItem.qty;
			}

			/**
			 * This function is to ensure that if min and max is set up for a variable pricing customer type
			 * that we are enforcing this and informing the user when there have been errors
			 * @param customerType is the customer type being evaluated
			 * @param packageDetails is where we get the min and max information from
			 * @returns boolean
			 */
			function validateVariablePriceRange(customerType, packageDetails) {
				var valid = true;
				if (getBoolean(customerType.variablePrice) && customerType.qty > 0) {
					var packageDetailsCT = undefined;
					for (var i = 0; i < packageDetails.CT.length; i++) {
						if (packageDetails.CT[i].id == customerType.id) {
							packageDetailsCT = packageDetails.CT[i];
							break;
						}
					}
					if (angular.isDefined(packageDetailsCT)) {
						if (angular.isDefined(packageDetailsCT.min_variable_price)
						&& packageDetailsCT.min_variable_price
							&& Number(customerType.cusTypeRetail) < Number(packageDetailsCT.min_variable_price)) {
							Modal.displayModal(
								{
									category: 'Cart',
									action: 'Error',
									label: 'Variable Price Min',
									title: Language.getLocale('Alert', 'variablePriceMinErrorTitle'),
									icon: 'icon-cartmodal blue',
									description: Language.getLocale('Alert', 'variablePriceMinErrorDescription')
								}
							);
							valid = false;
						} else if (angular.isDefined(packageDetailsCT.max_variable_price)
							&& packageDetailsCT.max_variable_price
							&& Number(customerType.cusTypeRetail) > Number(packageDetailsCT.max_variable_price)) {
							Modal.displayModal(
								{
									category: 'Cart',
									action: 'Error',
									label: 'Variable Price Max',
									title: Language.getLocale('Alert', 'variablePriceMaxErrorTitle'),
									icon: 'icon-cartmodal blue',
									description: Language.getLocale('Alert', 'variablePriceMaxErrorDescription')
								}
							);
							valid = false;
						}
					}
				}

				return valid;
			}

			// Create a copy of the customer tyoes, remove any object references that can alter it
			customerTypes = angular.copy(customerTypes);

			Cart.setPackageService_ItemsToBeAdded(itemsToBeAdded).then(function(itemAdded) {
				//if there is more than one customerTypes then lets compare the group min_qty
				if (customerTypes.length > 1) {
					if (!customerTypeExist(itemAdded)) {
						var _qty = 0;
						for (var i in itemAdded) {
							if (itemAdded.CHARACS &&
								angular.isArray(itemAdded.CHARACS)
								&& itemAdded.CHARACS.length > 0
								&& itemAdded.CHARACS[ 0 ].quicksell === 'true') {
								// If item is a quicksell, do not count towards the quantity.
								continue;
							}

							_qty += Number(itemAdded[ i ].qty);
						}

						if (_qty < Number(packageDetails.min_quantity)) {
							Cart.handleMinQtyModal({
								qty: _qty,
								min_quantity: packageDetails.min_quantity
							})
							return;
						}
					}
				}

				if (itemAdded.length > 0) {
					if (Cart.getTotalLessOverrideBeingAdded(totalLessOverrideBeingAdded, Package.cartLimit)) {
						// If an advanced ticket, prompt user before adding to cart.
						setAdvancedTicketNotification(
							function(isAdvanced) {
								// If it's advanced, add client charac to each item.
								if (isAdvanced) {
									for (var i = 0; i < itemAdded.length; i++) {
										itemAdded[ i ].CHARACS = itemAdded[ i ].CHARACS || [];

										for (var j = 0; j < itemAdded[ i ].qty; j++) {
											itemAdded[ i ].CHARACS[ j ] = itemAdded[ i ].CHARACS[ j ] || {};
											itemAdded[ i ].CHARACS[ j ].client_is_advanced_ticket = 'true';
										}
									}
								}

								// Advanced ticket check complete and user agreed to terms.
								// Check for XFCs and delegate to ExtraFlow if any.
								Package.doXFC(
									packageDetails
									, itemAdded
									, customerTypes
									, function() {
										// empty
										for (var j = 0; j < itemAdded.length; j++) {
											var hasItem = false;
											for (var i = 0; i < Package.itemsToBeAdded.length; i++) {
												if (itemAdded[ j ].package_id == Package.itemsToBeAdded[ i ].package_id) {
													hasItem = true;
												}
											}

											if (!hasItem) {
												Package.itemsToBeAdded.push(itemAdded[ j ]);
											}
										}

										addKeyword(Package.itemsToBeAdded)

										CustomActionService.executeCustomAction('addSessionDataToPackages', Package.itemsToBeAdded);
										CustomActionService.executeCustomAction('skipFolioMembershipUpgradeXFC');

										// If in update mode execute an update cart insted of add to cart.
										if (!CustomActionService.executeCustomAction('updateCartItems', Package.itemsToBeAdded)) {
											addCartItems(Package.itemsToBeAdded);
										}
									}
								);
							}
						);
					} else {
						qtyAdded = 0;
					}
				} else {
					// User didn't select a qty to add.
					Cart.addToCartNoQtyError();
				}
			})
		};

		/**
		 * Returns current due amount
		 * @protected
		 * @function
		 * @returns {Number} amount due
		 */
		Cart.getPaymentTotal = function() {
			var partialPayments;

			if (checkProp('AppData.GetCartSummary.deposit_transfer_total', AppData)) {
				return AppData.GetCartSummary.deposit_transfer_total;
			}

			// If there is a partial payment indicator, do calculation the left over amount
			if (UserInfo.partialPaymentsIndicator) {
				partialPayments = UserInfo.get('partialPayments') || [];

				return partialPayments.reduce(function(total, partialPayment) {
					if (checkProp('partialPayment.payment.total', partialPayment)) {
						return total - parseFloat(partialPayment.payment.total);
					}
					return total;
				}, parseFloat(Cart.total)).toFixed(2);
			}

			if (Cart.hasScheduledPayments()) {
				return AppData.GetCartSummary.current_amount_due;
			}

			return Cart.total;
		};

		/**
		 * Check if the cart has scheduled payments
		 * @protected
		 * @function
		 * @returns {Boolean} true/false
		 */
		Cart.hasScheduledPayments = function() {
			return checkProp('AppData.GetCartSummary.PAYMENT_SCHEDULE.PAYMENT', AppData, validArray);
		};

		/**
		 * Removes or swaps all membership items from the cart and executes updateCartItems() in Cart service.
		 */
		Cart.deleteMembershipPackagesFromCart = function() {
			if (!Utilities.childDefined(AppData, 'GetCartSummary.CART.ITEMS.ITEM')) {
				return;
			}

			var deletedItems = false;

			var cartItems = angular.copy(AppData.GetCartSummary.CART.ITEMS.ITEM);

			for (var i = 0; i < cartItems.length; i++) {
				if (cartItems[ i ].payment_plan === 'MEM') {
					cartItems.splice(i, 1);
					i--;
					deletedItems = true;
				}
			}

			var routeToCart = function() {
				if (!Cart.promptAndRouteIfEmpty()) {
					$rootScope.routeTo('/');
				}
			};

			if (deletedItems) {
				Cart.updateCartItems(cartItems, routeToCart, true);
			} else {
				Cart.fetchGetCartSummaryForced().then(routeToCart);
			}
		};

		/**
	 * Swaps all deferred items from the cart and executes updateCartItems() in Cart service.
	 */
		Cart.deleteDeferredPackagesFromCart = function() {
			if (!Utilities.childDefined(AppData, 'GetCartSummary.CART.ITEMS.ITEM')) {
				return;
			}

			var deletedItems = false;

			var cartItems = angular.copy(AppData.GetCartSummary.CART.ITEMS.ITEM);

			/**
		 * plpromo is a special extra movie used for BNPL packages that don't have the option for a Paid in Full - so in that scenario these packages
		 * wouldn't swap - they need to be removed from cart
		 * Other deferred payment should be swapped by the BE
		 */
			for (var i = 0; i < cartItems.length; i++) {
				for (var j = 0; j < cartItems[ i ].CHARACS.length; j++) {
					if (angular.isDefined(cartItems[i].CHARACS[j].extra_movie) && cartItems[i].CHARACS[j].extra_movie.indexOf('plpromo') > -1) {
						cartItems.splice(i, 1);
						i--;
						deletedItems = true;
						break;
					}
				}
			}

			var routeToCart = function() {
				if (!Cart.promptAndRouteIfEmpty()) {
					$rootScope.routeTo(Enums.routes.CART);
				}
			};

			/**
		 * In case there was a plpromo movie in cart, it is removed and cart should be updated
		 * If not, then fire fetchGetCartSummaryForced so BE can validate the cart items and doing the swap
		 */
			if (deletedItems) {
				Cart.updateCartItems(cartItems, routeToCart, true);
			} else {
				Cart.fetchGetCartSummaryForced().then(routeToCart);
			}
		};


		/**
		 * Display a modal when the there is no quantity for the packages selected.
		 * Display an error.
		 */
		Cart.addToCartNoQtyError = function() {
			Modal.displayModal(
				{
					category: 'Cart',
					action: 'Error',
					label: 'No qty selected',
					title: Language.Alert.cartNoQtySelectedTitle,
					icon: 'icon-cartmodal blue',
					description: Language.Alert.cartNoQtySelectedMsg,
					callback: function() {
					// HACK: If the user is prompted to select a quantity, ensure the view is set to rates.
						if (Cart.packageDetailsCtrl) {
							Cart.packageDetailsCtrl.toggleButtonBar(Language.ButtonLabels.rates);
						}
				 }
				}
			);
		};


		/**
		 *
		 * @param item
		 * @returns {object}
		 */
		Cart.setItemsToBeAdded = function(item) {
			var cartItem = {};
			cartItem.package_id = item.package_id;
			cartItem.customer_type = item.customer_type;
			cartItem.qty = Number(item.qty);
			cartItem.client_rate_name = item.cusTypeName;
			//if we showed a different price e.g. dynamic to the guest, including it here so the datalayer can pick it up
			if (item.shownPrice) {
				cartItem.shownPrice = item.shownPrice;
			}

			if (item.shownTax) {
				cartItem.shownTax = item.shownTax;
			}

			if (item.shownFee) {
				cartItem.shownFee = item.shownFee;
			}

			if (item.cart_limit_override) {
				cartItem.cart_limit_override = item.cart_limit_override;
			}

			if (item.extra_movie) {
				cartItem.extra_movie = item.extra_movie;
			}

			if (item.date) {
				cartItem.date = item.date;
			}

			if (item.time) {
				cartItem.time = item.time;
			}

			if (item.promo_code) {
				cartItem.promo_code = item.promo_code;
			}

			if (angular.isDefined(item.timeblock_id)) {
				cartItem.timeblock_id = item.timeblock_id;
			}


			cartItem.CHARACS = item.CHARACS || [];

			return cartItem;
		};

		/**
		 *	Checks to see if the quantities of the items we are going to add, would exceed the cart limit.
		 *	If true, we're good.
		 *	If false, we would be over, going to show a modal.
		 *
		 *	@return boolean
		 */

		Cart.getTotalLessOverrideBeingAdded = function(totalLessOverrideBeingAdded, cartLimit) {
			if (
				(Number(totalLessOverrideBeingAdded) > Number(cartLimit)) ||
				(Number(totalLessOverrideBeingAdded) + Cart.getTotalLessOverride()) > Number(cartLimit)
			) {
				showCartLimitModal();
				return false;
			} else {
				return true;
			}
		};

		/**
		 * Update the cart with items to be added, return true if successfull
		 * @param {array} itemsToBeAdded
		 * @param {boolean} callback
		 *
		 */
		Cart.addCartItems = function(itemsToBeAdded, callback, splitItems) {
			// TODO: Depracated. Remove.
			$rootScope.pendingRequests.push(Enums.services.ADD_CART_ITEM);

			AppData.fetch(Enums.services.ADD_CART_ITEM, false, itemsToBeAdded)
				.then(function(data) {
					Cart.groupingComplete = false;
					$rootScope.removePendingRequest(Enums.services.ADD_CART_ITEM);
					if (data.status == Enums.status.OK) {
						// ADD_CART_ITEM Response.
						$rootScope.pendingRequests.push(Enums.services.GET_CART_SUMMARY);

						// Reset isAdvancedTicket flag.
						Package.isAdvancedTicket = false;

						AppData.fetch(Enums.services.GET_CART_SUMMARY, true, {}, true).then(
							function(data) {
								$rootScope.removePendingRequest(Enums.services.GET_CART_SUMMARY);
								cleanUpCartData(data);

								if (!Cart.checkForItemErrors(data)) {
									Utilities.arrayWrap(data, 'CART.ITEMS.ITEM')

									if (data.status == Enums.status.OK) {
										// Update the cart object.
										Cart.updateInternals(data);

										callback.call(this, data);
									} else if (data.status == Enums.status.FAILED) {
										// @TODO: Do we update internals when there is a problem?
										// If we get an error, expect an inbound get new cart id.
										callback.call(this, data);
									}
								}
							}
						);
					} else if (data.status == Enums.status.FAILED) {
						// The request to updateCartItem failed.
						Modal.displayModal(
							{
								category: 'Cart',
								action: 'Error',
								label: data.error_msg,
								title: Language.Alert.cartErrorAddingItemTitle,
								description: Language.Alert.cartErrorAddingItemMsg
							}
						);
						Language.displayErrorCode(data, false, (((AppData || {}).GetApplicationConsolidated || {}).SETTINGS || {}).support_phone_number);
						// Hide the spinner.
						$rootScope.hideSpinner();
					} else {
						// TODO: Unknown Error occurred
					}
				}
				);
		};

		Cart.saveCart = function(data, skipModals, skipSpinner) {
			if (skipSpinner === false) {
				$rootScope.showSpinner();
			}

			AppData.fetch
			(Enums.services.SAVE_CART
				, false
				, data
				, true
				, false
			).then(
				function(data) {
					if (skipSpinner === false) {
						$rootScope.hideSpinner();
					}

					if (skipModals) {
						return;
					}

					if (data.status == Enums.status.OK) {
						Modal.displayModal(
							{
								category: 'Save Cart',
								customHTML: 'modal::save-cart-modal:success',
								action: 'Success',
								label: 'Save Cart Successful',
								singleButtonFullWidth: true,
								showBottomBorder: true,
								showCloseButton: false,
								title: false,
								view: Modal.SLIDEUP,
								callback: function() {
									$rootScope.$broadcast(Enums.messages.REQUESTS_CLOSE, {
										forceClose: true,
										status: true
									});
								}
							}
						);
					} else {
						Modal.displayModal(
							{
								category: 'Save Cart',
								action: 'Error',
								label: 'Save Cart Failed',
								title: Language.getLocale('CartAbandonment', 'saveFailureTitle'),
								description: Language.getLocale('CartAbandonment', 'saveFailureMessage'),
								view: Modal.SLIDEUP,
							}
						);
					}
				}
			)
		}
		Cart.retrieveCart = function(data) {
			var data =
			{
				email: data.email,
				merchant_id: data.merchant_id
			}
			AppData.fetch
			(Enums.services.RETRIEVE_CART
				, false
				, data
				, true
				, false
			).then(
				function(data) {
					if (data.status !== Enums.status.OK) {
						$rootScope.hideSpinner();
						Modal.displayModal(
							{
								category: 'Cart Recovery',
								action: 'Error',
								label: 'Cart Recovery Failed',
								title: Language.CartAbandonment.recoveryFailureTitle,
								description: Language.CartAbandonment.recoveryFailureMessage
							}
						);
					} else {
						$window.location.href = "/" + Utilities.getMerchant() + "/reset" + "?cart_id=" + data.CART.cart_id + "&cart_key=" + data.CART.cart_key + "&session_id=" + data.session_id;
					}
				}
			)
		};


		Cart.editCartItems = function(items) {
			Cart.editingCartCopy = [];

			// step 1, create a copy of the old cart.
			var cartCopy = Utilities.toOrderPreservingArray(Cart.cartItems);

			// step 2, extract the items from this copy.
			var itemsCopy = cartCopy.filter(function(e) {
				return items.some(function(i) {
					return i.$$hashKey==e.$$hashKey;
				});
			});

			// step 3, get a copy of the cart that contains none of the edited items
			cartCopy = cartCopy.filter(function(e) {
				return !items.some(function(i) {
					return i.$$hashKey==e.$$hashKey;
				});
			});

			// step 3A - remove related one barcode items from the cart as they will get readded
			if (OneBarcodeUtilities.hasOneBarcodeItems(itemsCopy)) {
				OneBarcodeUtilities.prepareOneBarcodeCartForEditing(itemsCopy, cartCopy);
			}

			// step 3B - make the cartCopy public
			Cart.editingCartCopy = cartCopy;

			// step 4, add a key to the object to be edited in the cart to indicate
			//         that we need to edit it.
			itemsCopy.forEach(function(e) {
				e.isEditMode = true;
			});

			Package.getOrRequestPackageDetailsForCartItem(itemsCopy[0]).then(function(packageDetails) {
				// step 5, Construct the package details for this package
				//var packageDetails = Package.getPackageDetailsForCartItem();

				// step 6, Extract the customer types needed.
				var customerTypes = packageDetails.CT.filter(function(c) {
					// select this node if it is a customer type mentioned in
					// ANY of the items
					return itemsCopy.some(function(e) {
						return Number(c.id)===Number(e.customer_type);
					});
				});

				// step 7, execute the XFC flow
				Package.doXFC(packageDetails, itemsCopy, customerTypes, function() {
					// step 8, merge the old cart with the new items to be added, **We must use Package.itemsToBeAdded as the reference
					// Package.itemsToBeAdded is the ACTUAL reference that gets modified,not necessarily itemsCopy
					var items = Utilities.finalizeArraysForEditing(Cart.editingCartCopy, Package.itemsToBeAdded);

					if (Package.hasDuplicateUidsInItemsList(items)) {
						Package.displayErrorModalForDuplicateUids();
					} else {
						Cart.updateCartItems(items, function() {
							// step 10, he gone.
							$rootScope.routeTo(Enums.routes.CART);
						}, true);
					}
				});
			})
		};


		/**
		 * @param	{array} itemsToBeUpdated Array of items to be updated [ description ]
		 * @param	{function} callback callback function to execute on promise resolution
		 */
		Cart.updateCartItems = function(itemsToBeUpdated, callback, showSpinner, skipSetExpressCheckout) {
			var i;

			// Item has been removed. Update the cart.
			if (angular.isUndefined(showSpinner) ||
				(angular.isDefined(showSpinner) && showSpinner === true)) {
				$rootScope.showSpinner(Language.ApplicationLabels.updatingCartLoadMsg);
			}

			itemsToBeUpdated = combineSplitCartItems(itemsToBeUpdated);

			for (i = 0; i < itemsToBeUpdated.length; i++) {
				// Delete this hashKey. Causing request to fail.
				try {
					if (angular.isDefined(itemsToBeUpdated[i])) {
						delete itemsToBeUpdated[ i ].$$hashKey;

						// Empty this to prevent the back end from appending oneBarcode CHARACS elements
						// to the parent item CHARACS array.
						itemsToBeUpdated[ i].oneBarcodePackages = [];
					}
				} catch (e) {}
			}

			CustomActionService.executeCustomActionChain(CustomActionService.ACTIONS_ENUMS.ON_UPDATE_CART_ITEMS, itemsToBeUpdated);

			if (itemsToBeUpdated.length === 0) {
				CustomActionService.executeCustomAction(CustomActionService.ACTIONS_ENUMS.ON_REMOVE_ALL_CART_ITEMS);
			}


			$rootScope.pendingRequests.push(Enums.services.UPDATE_CART_ITEMS);
			AppData.fetch
			(
					 Enums.services.UPDATE_CART_ITEMS
				, false
				, itemsToBeUpdated
			).then
			(
				function(data) {
					Cart.groupingComplete = false;
					$rootScope.removePendingRequest(Enums.services.UPDATE_CART_ITEMS);
					if (data.status == Enums.status.OK) {
						// Do nothing for now.
						// GET_CART_SUMMARY Response.
						Utilities.arrayWrap(data, 'CART.ITEMS.ITEM')

						$rootScope.pendingRequests.push(Enums.services.GET_CART_SUMMARY);

						AppData.fetch(Enums.services.GET_CART_SUMMARY, true, {}, true).then(
							function(data) {
								var updateExpressPaymentsCustomAction = CustomActionService.ACTIONS_ENUMS.UPDATE_EXPRESS_PAYMENT_METHODS;
								$rootScope.removePendingRequest(Enums.services.GET_CART_SUMMARY);

								if (!Cart.checkForItemErrors(data)) {
									if (data.status == Enums.status.OK) {
										// Update the cart object.
										Cart.updateInternals(data);

										if (!skipSetExpressCheckout && CustomActionService.actionRegistered(updateExpressPaymentsCustomAction)) {
											CustomActionService.executeCustomAction(updateExpressPaymentsCustomAction, callback);
										} else {
											$rootScope.hideSpinner();
											if (callback) {
												callback.call(this, true);
											}
										}
									} else if (data.status == Enums.status.FAILED || data.status == Enums.status.ERROR) {
										Cart.updateInternals(data);
										$rootScope.hideSpinner();
										if (callback) {
											callback.call(this, false);
										}
									}
								} else {
									$rootScope.hideSpinner();
									if (callback) {
										callback.call(this, false);
									}
								}
							}
						);
					} else if (data.status == Enums.status.FAILED) {
						// The request to updateCartItem failed.
						Modal.displayModal({
							category: 'Cart [Update Cart Items]',
							action: 'Error',
							label: data.error_msg,
							title: Language.Alert.cartErrorUpdatingItemTitle,
							description: Language.Alert.cartErrorUpdatingItemMsg
						});

						if (callback) {
							callback.call(this, false);
						}

						// Hide the spinner.
						$rootScope.hideSpinner();
					}
				}
			);
		};

		/**
		 * Return the total of items that does not include cart Override
		 * @return {[ integer ]} return integer cartLimit,
		 */
		Cart.getTotalLessOverride = function(excludeOverridden, filterByMovie, movieName) {
			var cartItems = CartService.getCartItems();
			excludeOverridden 	= typeof excludeOverridden !== 'undefined' ? excludeOverridden : true;
			filterByMovie 		= typeof filterByMovie !== 'undefined' ? filterByMovie : false;

			if (filterByMovie && (typeof movieName === 'undefined')) {
				throw "Cart.getTotalLessOverride() called without movieName defined";
			}


			var qtySum = 0;
			if (cartItems.length) {
				for (var i = 0; i < cartItems.length; i++) {
					var item = cartItems[ i ];
					var charac = Utilities.first(item.characs);

					if (filterByMovie && 'extra_movie' in charac) {
						// filter cart items by movie
						var re = new RegExp("\b" + movieName + "\b");
						var exists = (charac.extra_movie.search(re) > -1);

						if (!exists) {
							continue;
						}
					}

					if (CustomActionService.executeCustomAction('itemAddedThisSession', item)) {
						// If we're in the recommender wizard, don't include the count of items that
						// are about to be replaced.
						continue;
					}

					if (excludeOverridden) {
						if (!item.info.limitOverride) {
							qtySum += item.info.qty;
						}
					} else {
						qtySum += item.info.qty;
					}
				}
			}

			return qtySum;
		};

		/**
		 *	Call this if you want to clear the cart, and request a new cart id.
		 *
		 *	@return null
		 */
		Cart.getNewCartID = function() {
			// Reset total qty.
			Cart.totalQty = 0;

			// Reset cart details.
			Cart.cartDetails = {};

			// Get new CART ID.
			AppData.fetch(Enums.services.GET_NEW_CART_ID, true, true, false, true);
		};


		/**
		 *	Call this if you want to clear the cart, and only want to listen for an inbound response with a new cart id.
		 *
		 *	@return null
		 */

		Cart.fetchGetNewCartID = function() {
			// Reset total qty.
			Cart.totalQty = 0;

			// Reset cart details.
			Cart.cartDetails = {};

			// Get new CART ID. // use localStorage, don't generate the request, and overwrite existing.
			AppData.fetch(Enums.services.GET_NEW_CART_ID, true, false, true, true);

		};

		Cart.clearInternals = function() {
			// TODO: This is called from cartController after getCartSummary.
			// Maybe cartController should not be making getCartSummary request.
			// Move that functionality to the service and make this function private.
			Cart.cartDetails = {};
			Cart.cartItems = [];
			Cart.discountSource = 0;
			Cart.discountTotal = 0;
			Cart.taxAndCartAdjustmentAndShippingSource = {
				data: [],
				total: 0
			};
			Cart.feeSource = {
				fees: [],
				total: 0
			};
			Cart.potentialCartAdj = 0;
			Cart.potentialCartAdjTotal = 0;
			Cart.shippingSource = 0;
			Cart.showDiscounts = 0;
			Cart.subTotal = 0;
			Cart.total = 0;
			Cart.totalQty = 0;
		};

		/**********
		*  Cart.lastDateAdded
		*
		*  Usage: Stores the date (or time) of the items added to the cart. lastDateAdded is not a list. It simply holds the
		*     most recent date added to the cart. It was created so that dated CrossSells can tell what date to use.
		*     As of 4/27/2016, the start_time field of lastDateAdded is not used anywhere.
		*
		*  Methods:
		*  Cart.lastDateCurrent: returns true if the lastDateAdded applies to the current cart.
		*       This used to return false when ItemsToBeAdded had any items, but the cross sell flow
		*       adds items to ItemsToBeAdded before asking for their dates.
		*  Cart.storeLastDate: called when items are added to the cart.
		*  Cart.resetLastDate: called when the customer leaves the flow for the items that caused it to be set. This happens
		*    whenever ItemsToBeAdded is cleared.
		**********/
		Cart.resetLastDate = function() {
			Cart.lastDateAdded = {};
			CartService.setLastDate(null);
		};
		// pass in either start_date or start_time to check the relevant field.
		Cart.lastDateCurrent = function(fieldToCheck) {
		// only current if there are items in the cart
			if (Cart.cartItems.length<1) {
				return false;
			}
			// only current if there's actually a date that's been set
			return Utilities.safelyCheckPropertyOnObject('Cart.lastDateAdded.'+fieldToCheck, Cart);
		};
		Cart.storeLastDate = function(items) {
			var inAltModuleCrossSell = angular.isDefined($state.current) && ($state.current.altModuleCrossSell),
				inStandardCrossSell = (angular.isDefined(StandardFlowInitiatorService.currentStandardFlowType) ? StandardFlowInitiatorService.currentStandardFlowType == 'crosssells' : false);

			// Only empty the Last Date Added if we're not in a cross sell.
			if (! inAltModuleCrossSell && !inStandardCrossSell) {
				Cart.lastDateAdded = {};
				CartService.setLastDate(null);
			}
			items.some(function(item) {
				if (Utilities.safelyCheckPropertyOnObject('item.CHARACS', item)) {
					return item.CHARACS.some(function(charac) {
						if (charac.start_date) {
							Cart.lastDateAdded.start_date = charac.start_date;

							CartService.setLastDate(charac.start_date);

							return true;
						}
						if (charac.start_time) {
							Cart.lastDateAdded.start_time = charac.start_time;
						}

						return false;
					});
				}
			});
		};
		/**
		 * [ updateInternals description ]
		 * @param	{[ type ]} data [ description ]
		 * @return {[ type ]}			[ description ]
		 */
		Cart.updateInternals = function(data) {
			var shouldConsolidateFees = getBoolean(AppData.settings.consolidate_fees),
				i = 0;
			// @TODO: Break this into functions.

			/*
			 *	It is clear that the previous naming of this variable was confusing in the context of the architecture.
			 *	The way it works now, this object will accumulate all of the information about tax, cart adjustments, and shipping
			 *	to be displayed as line items on CartView and OrderReview.
			 *
			 *	Only fees have been refactored into Cart.buildFeeSource. But ideally the others will follow the same approach in time.
			 *	Until then, hopefully this naming makes it a bit more immediately clear.
			 */
			var taxAndCartAdjustmentAndShippingSource = {
					data: [],
					total: 0
				},
				discountSource = {
					discounts: [],
					total: 0
				},
				potentialCartAdj = [],
				potentialCartAdjTotal = 0,
				shippingSource = {};

			Cart.cartItems = [];
			Package.itemsToBeAdded = [];

			if (Utilities.safelyCheckPropertyOnObject('data.CART.ITEMS.ITEM', data)) {
				Cart.cartItems = Utilities.wrapObjectToArray(data.CART.ITEMS.ITEM, true);
				$rootScope.$emit('CART.ITEMS_UPDATED');
				Cart.setEditFlags(data);
			}

			// One Barcode Group UUID sorting
			sortOneBarcodePackages();

			//set the price to display on view
			setDisplayPrice();

			// @TODO: Request that cartTaxesAndFeesAmount be calculated on the backend.

			// Update all relevant cart information.
			// Cart adjustments first.
			sumCartAdjustments(data, taxAndCartAdjustmentAndShippingSource, discountSource);

			// Followed by taxes.
			if (data.tax_total && angular.isUndefined(AppData.settings.ignore_tax)) {
				if (!shouldConsolidateFees) {
					if (Utilities.safelyCheckPropertyOnObject('data.CART.TAX_TIERS.TAX', data)) {
						data.CART.TAX_TIERS.TAX = Utilities.wrapObjectToArray(data.CART.TAX_TIERS.TAX);
						for (i = 0; i < data.CART.TAX_TIERS.TAX.length; i++) {
							taxAndCartAdjustmentAndShippingSource.data.push({
								label: Language.getLocale('CartView', 'tax' + data.CART.TAX_TIERS.TAX[i].id),
								amount: data.CART.TAX_TIERS.TAX[i].amount
							});
							taxAndCartAdjustmentAndShippingSource.total += parseFloat(data.CART.TAX_TIERS.TAX[i].amount);
						}
					} else {
						taxAndCartAdjustmentAndShippingSource.data.push({
							label: Language.getLocale('CartView', 'taxLabel'),
							amount: data.tax_total
						});
						taxAndCartAdjustmentAndShippingSource.total += Number(data.tax_total);
					}
				}
			}

			// @TODO: Investigate how POTENTIAL_CART_ADJUSTMENTS is used in Shop V4.
			sumPotentialCartAdjustments(data, potentialCartAdjTotal, potentialCartAdj);

			/*
			 *	The following code is to support the legacy way of displaying fees.
			 *	In this manner, they are all added to the full taxAndCartAdjustmentAndShippingSource.data array.
			 *	If and when the consolidated fees method is accepted globally, this code can simply be removed as well as the config dependency
			 */
			var feeSource = Cart.buildFeeSource(data);

			if (!shouldConsolidateFees) {
				taxAndCartAdjustmentAndShippingSource.data = taxAndCartAdjustmentAndShippingSource.data.concat(feeSource.fees);
				taxAndCartAdjustmentAndShippingSource.total += feeSource.feeTotal + feeSource.taxTotal;
			}

			sumShipping(data, taxAndCartAdjustmentAndShippingSource, shippingSource);


			// Store all references to relevant information.
			Cart.subTotal = Cart.useCartViewTotalCalculation ? data.deposit_transfer_subtotal : data.payment_due;
			Cart.shippingSource = shippingSource;
			Cart.taxesAndFees = taxAndCartAdjustmentAndShippingSource.total;
			Cart.taxAndCartAdjustmentAndShippingSource = taxAndCartAdjustmentAndShippingSource.data;

			if (shouldConsolidateFees) {
				Cart.feeSource = feeSource;
			}

			Cart.potentialCartAdj = potentialCartAdj;
			Cart.potentialCartAdjTotal = potentialCartAdjTotal;
			Cart.discountSource = discountSource.discounts;
			Cart.discountTotal = discountSource.total;
			Cart.showDiscounts = discountSource.total > 0;
			Cart.total = data.total;

			// Total Qty.
			Cart.totalQty = getTotalQty();

			// Payment Plan
			Cart.hasPaymentPlan = checkPaymentPlan(data);

			// Keep a reference to all cart details.
			Cart.cartDetails = data;
			$rootScope.$broadcast('cartActivated', {
				data: data,
				status: true
			});
			$rootScope.$broadcast(Enums.messages.CART_UPDATE, {
				data: { qty: Utilities.forceInt(getTotalQty()), total: parseFloat(Cart.total || 0) },
				status: true
			});
		};

		Cart.buildFeeSource = function(GetCartSummaryResponse) {
			var feeSource = {
				fees: [],
				tax: [],
				feeTotal: 0,
				taxTotal: 0
			};

			if (Utilities.safelyCheckPropertyOnObject('GetCartSummaryResponse.FEES.F', GetCartSummaryResponse)) {
				for (var i=0; i < GetCartSummaryResponse.FEES.F.length; i++) {
					feeSource.fees.push({
						label: Language.getLocale('CartView', 'fee' + GetCartSummaryResponse.FEES.F[i].id),
						amount: GetCartSummaryResponse.FEES.F[i].amount
					});
					feeSource.feeTotal += parseFloat(GetCartSummaryResponse.FEES.F[i].amount);
				}
			}
			if (Utilities.safelyCheckPropertyOnObject('GetCartSummaryResponse.CART.TAX_TIERS.TAX', GetCartSummaryResponse)) {
				GetCartSummaryResponse.CART.TAX_TIERS.TAX = Utilities.wrapObjectToArray(GetCartSummaryResponse.CART.TAX_TIERS.TAX);
				for (i = 0; i < GetCartSummaryResponse.CART.TAX_TIERS.TAX.length; i++) {
					feeSource.tax.push({
						label: Language.getLocale('CartView', 'tax' + GetCartSummaryResponse.CART.TAX_TIERS.TAX[i].id),
						amount: GetCartSummaryResponse.CART.TAX_TIERS.TAX[i].amount
					});
					feeSource.taxTotal += parseFloat(GetCartSummaryResponse.CART.TAX_TIERS.TAX[i].amount);
				}
			}
			return feeSource;
		};

		/**
		 * Processes cart items to identify packages with "one_barcode_parent" characteristic
		 * and groups them with addon packages sharing the same group_uuid.
		 * Populates oneBarcodePackages array for each cart item that has a parent package.
		 *
		 * @private
		 * @throws {Error} "Unable to parse cart item for one barcode grouping"
		 * @returns {void}
		 */
		function sortOneBarcodePackages() {
			var addons,
				cartItem,
				firstCharac,
				hasGroupUuid,
				hasOneBarcodeParent,
				index,
				isNotParent,
				nestItems,
				sameGroup;

			Cart.hasOneBarcodePackages = false;

			for (index = 0; index < Cart.cartItems.length; index++) {
				cartItem = Cart.cartItems[index];
				cartItem.oneBarcodePackages = [];

				try {
					// Check if this cart item has the one_barcode_parent characteristic
					hasOneBarcodeParent = checkProp('cartItem.CHARACS.0.one_barcode_parent', cartItem);

					if (hasOneBarcodeParent) {
						Cart.hasOneBarcodePackages = true;

						// Find all addon packages
						addons = Cart.cartItems.filter(function(item) {
							// Ensure item has valid CHARACS structure before checking properties
							if (!checkProp('item.CHARACS.0', item)) {
								return false;
							}

							firstCharac = item.CHARACS[0];
							isNotParent = !firstCharac.hasOwnProperty("one_barcode_parent");
							hasGroupUuid = firstCharac.hasOwnProperty("group_uuid");
							sameGroup = hasGroupUuid && firstCharac.group_uuid === cartItem.CHARACS[0].group_uuid;

							return isNotParent && hasGroupUuid && sameGroup;
						});

						// If nested ITEM nodes exist, add them as addons
						nestItems = checkProp('cartItem.ITEM', cartItem, ['wrapObjectToArray', true]);

						if (nestItems) {
							nestItems.forEach(function nestItemsIterator(item, i) {
								nestItems[i].display_price = UtilsPricing.getPrice(item.retail_price, item.tax_amount, item.fee_amount);
								nestItems[i].nested_id = i + 1;
								nestItems[i].parent_id = cartItem.id;
							});

							addons = addons.concat(nestItems);
						}

						if (addons.length > 0) {
							cartItem.oneBarcodePackages = addons;
						}
					}
				} catch (e) {
					$log.error(e);
					throw new Error("Unable to parse cart item for one barcode grouping");
				}
			}
		}

		function sumCartAdjustments(data, taxAndCartAdjustmentAndShippingSource, discountSource) {
			if (Utilities.safelyCheckPropertyOnObject('data.CART_ADJUSTMENTS.CA', data)) {
				var cartAdj = data.CART_ADJUSTMENTS.CA;

				// Update the collection on data as well.
				data.CART_ADJUSTMENTS.CA = cartAdj;

				var locale,
					amount;

				for (i = 0; i < cartAdj.length; i++) {
					locale = Language.getLocale('CartView', 'cartAdjustment' + cartAdj[i].id);
					amount = cartAdj[ i ].amount;

					if (amount > 0) {
						// Keep sum of fees.
						taxAndCartAdjustmentAndShippingSource.data.push({
							label: locale,
							amount: amount
						});
						taxAndCartAdjustmentAndShippingSource.total += Number(amount);
					} else {
						// Amount is less than 0. Apply to discounts. Keep sum of discounts.
						discountSource.discounts.push({
							label: locale,
							amount: amount
						});
						discountSource.total += Number(amount);
					}
				}
			}
		}

		function sumPotentialCartAdjustments(data, potentialCartAdjTotal, potentialCartAdj) {
			if (Utilities.childDefined(data, 'POTENTIAL_CART_ADJUSTMENTS.CA')) {
				var potentialCartAdjustments = data.POTENTIAL_CART_ADJUSTMENTS.CA;

				// Update the collection on data as well.
				data.POTENTIAL_CART_ADJUSTMENTS.CA = potentialCartAdjustments;

				for (i = 0; i < potentialCartAdjustments.length; i++) {
					// Keep sum of fees.
					potentialCartAdjTotal += Number(potentialCartAdjustments[ i ].amount);
					var _label = ((Language).CartView || {})[ 'potentialCartAdjustment' + potentialCartAdjustments[ i ].id ] || '';
					potentialCartAdj.push({
						label: _label,
						amount: potentialCartAdjustments[ i ].amount
					});
				}
			}
		}

		function sumShipping(data, taxAndCartAdjustmentAndShippingSource, shippingSource) {
			// Shipping if applicable.
			if (data.ship_total) {
				var _label = Language.getLocale('CartView', 'deliveryFee');

				shippingSource = {
					label: _label + getDeliveryMethod(data),
					amount: (Number(data.ship_total) == 0 && ((Language).CartView || {}).free) ? Language.CartView.free : data.ship_total
				};

				taxAndCartAdjustmentAndShippingSource.data.push(shippingSource);
				taxAndCartAdjustmentAndShippingSource.total += Number(data.ship_total);
			}
		}

		Cart.checkForItemErrors = function(data) {
			var deleteItemsArr = [];
			var errorCodeMsg = '';
			var mssgs = {};
			var appendedDefaultError = false;
			var codeList = [];
			var numErrorItms = 1;
			var cartErrorRoute = Enums.routes.CART;

			if (Utilities.safelyCheckPropertyOnObject('data.CART.ITEMS.ITEM', data)) {
				for (var i = 0; i < data.CART.ITEMS.ITEM.length; i++) {
					var currentItem = data.CART.ITEMS.ITEM[ i ];

					if (!currentItem.action ||
						currentItem.action.toLowerCase() != 'error' &&
						currentItem.action.toLowerCase() != 'warning') {
						continue;
					}

					// Add default message... by default.
					if (!appendedDefaultError) {
						appendedDefaultError = true;
						errorCodeMsg = '<b>' + String(numErrorItms) + '</b> ' + Language.CheckCartTicketLevelErrors.defaultError + '<br /><br />';
					}

					if (currentItem.action.toLowerCase() === 'error') {
						//Get the index of the item to be deleted.
						deleteItemsArr.push(currentItem);

						var errorCode = currentItem.error_code;

						if (errorCode !== '' && angular.isDefined(errorCode)) {
							codeList.push(errorCode);
							if (!mssgs[ 'msg' + errorCode ]) {
								numErrorItms++;

								if (angular.isDefined(Language.CheckCartTicketLevelErrors[ errorCode ])) {
									mssgs[ 'msg' + errorCode ] = Language.CheckCartTicketLevelErrors[ errorCode ];
									errorCodeMsg += "<b>" + String(numErrorItms) + "</b> " + mssgs[ 'msg' + errorCode ] + "<br /><br />";
									numErrorItms--;
								}
							}
						}

						// Remove the offending item.
						data.CART.ITEMS.ITEM.splice(i, 1);
						i--;
					}
				}
			}

			if (deleteItemsArr.length > 0) {
				Cart.updateInternals(data);
				cartErrorRoute = StandardFlowInitiatorService.hasCurrentFlow
					? StandardFlowInitiatorService.getStandardFlowEntryRoute()
					: Enums.routes.LIST;
			}


			if (!Cart.suppressErrorOnInvalidQty(deleteItemsArr)) {
				if (errorCodeMsg.length > 0) {
					var supportPhoneNumber = AppData.settings.support_phone_number;
					errorCodeMsg = Language.replaceAll('@@supportPhoneNumber', supportPhoneNumber, errorCodeMsg);

					$rootScope.hideSpinner();

					Modal.displayModal({
						category: 'Cart',
						action: 'Error',
						label: data.error_msg,
						replacementKeys: 'errorCode',
						replacementValues: codeList.join(', '),
						title: Language.CheckCartTicketLevelErrors.errorCodeTitle,
						description: '<div class="text-left">' + errorCodeMsg + '</div>',
						callback: function(detail) {
							// What happens here is that we blow away this item from the cart on the backend.
							// This requires us to make a new call to the real get cart summary to update the internals.
							//
							$rootScope.showSpinner();
							Cart.fetchGetCartSummaryForced().then(function(e) {
								$rootScope.hideSpinner();
								$rootScope.routeTo(cartErrorRoute);
							});
						}
					});
					return true;
				}
			}
			return false;
		};

		function checkPaymentPlan(data) {
			return Utilities.childDefined(data, 'PAYMENT_SCHEDULE.PAYMENT') &&
					data.PAYMENT_SCHEDULE.PAYMENT.length > 0;
		}

		Cart.suppressErrorOnInvalidQty = function(deletedItemsArr) {
			var suppressError = false;
			for (var i = 0; i< deletedItemsArr.length; i++) {
				if (angular.isDefined(deletedItemsArr[i].error_msg) && deletedItemsArr[i].error_msg === "Invalid quantity") {
					suppressError = true;
				} else {
					suppressError = false;
					break;
				}
			}
			return suppressError;
		};

		Cart.setEditFlags = function(data) {
			var hasItems = Utilities.safelyCheckPropertyOnObject("data.CART.ITEMS.ITEM", data, function(item) {
				return angular.isArray(item) ? item.legnth > 0 : true;
			});

			if (hasItems) {
				$rootScope.displayChangeQtyOptions = true;
				data.CART.ITEMS.ITEM = angular.isArray(data.CART.ITEMS.ITEM) ? data.CART.ITEMS.ITEM: [data.CART.ITEMS.ITEM];
				// Toggle edit buttons.
				for (var i = 0; i < data.CART.ITEMS.ITEM.length; i++) {
					var cartItem = data.CART.ITEMS.ITEM[ i ];

					// Ensure CHARACS are stored as array.
					if (cartItem.CHARACS) {
						cartItem.CHARACS = (angular.isArray(cartItem.CHARACS)) ? cartItem.CHARACS: [cartItem.CHARACS];
					}
				}
			}
		};

		Cart.removeShipping = function() {
			if (angular.isDefined(Cart.cartDetails)) {
				Cart.cartDetails.ship_total = 0;
			}
			UserInfo.set('shipping', {});
		};

		/* fetchGetCartSummary
		 * This will collect the expected inbound response for SetExpressCheckout.
		 *
		 * @param	{[ type ]} data [ description ]
		 * @return {[ type ]}			[ description ]
		 */
		Cart.fetchGetCartSummary = function(callbackOk, callbackFailure, skipRequests) {
			// We should get the SetExpressCheckout on a GetCartSummary @status='OK'
			/** FETCH CART SUMMARY ***/
			var cartSummaryRequest = validString(skipRequests) ? { skip_requests: skipRequests } : {};
			return AppData.fetch(Enums.services.GET_CART_SUMMARY, false, cartSummaryRequest).then(
				function(data) {
					var i,
						scrubbed_data;
					cleanUpCartData(data);
					if (!Cart.checkForItemErrors(data)) {
						if (data.status == status.OK) {
							if (validString(data.last_ticket_error_code) && CustomActionService.actionRegistered(CustomActionService.ACTIONS_ENUMS.ON_CART_SUMMARY_ITEM_FAILURES)) {
								// Fire off custom action
								CustomActionService.executeCustomAction(CustomActionService.ACTIONS_ENUMS.ON_CART_SUMMARY_ITEM_FAILURES);
							}
							// Update the cart object.
							Cart.updateInternals(data);
							// Checks to see if App Config get_full_cart_summary exists
							if (JSONValidator.validate('analytics_data_layer', AppData.settings.analytics_data_layer)) {
								if (JSON.parse(AppData.settings.analytics_data_layer).get_full_cart_summary) {
									scrubbed_data = Utilities.wrapObjectToArray(data.CART.ITEMS, true).map(function createCopy(obj) {
										return angular.merge({}, obj);
									});
									scrubbed_data.forEach(function searchCartCharacs(item) {
										// Checks to see item.ITEM is undefined before running the for loop.
										if (!Array.isArray(item.ITEM)) {
											return;
										}
										// Runs through item object and removes the CHARACS object before pushing to the Data Layer.
										for (i = 0; i < item.ITEM.length; i++) {
											delete item.ITEM[i].CHARACS;
										}
									});
									AnalyticsDataLayerService.triggerGetCartSummary(scrubbed_data);
								}
							}

							if (typeof callbackOk == 'function') {
								callbackOk();
							}
						} else if (data.status == status.FAILED) {
							// @TODO: Do we update internals when there is a problem?
							// listen for a new cart_id/cart_key.
							if (typeof callbackFailure == 'function') {
								callbackFailure();
							}
							Cart.fetchGetNewCartID();
						}
					} else if (CustomActionService.actionRegistered(CustomActionService.ACTIONS_ENUMS.ON_CART_SUMMARY_ITEM_FAILURES)) {
						CustomActionService.executeCustomAction(CustomActionService.ACTIONS_ENUMS.ON_CART_SUMMARY_ITEM_FAILURES);
					}
					//$rootScope.$broadcast('cartActivated', { data : data, status : true});
				}
			);
		};

		Cart.fetchGetCartSummaryForced = function() {
			return AppData.fetch(
				Enums.services.GET_CART_SUMMARY,
				true,
				{},
				true
			).then(
				function(data) {
					cleanUpCartData(data);

					if (!Cart.checkForItemErrors(data) && data.status == status.OK) {
						Cart.updateInternals(data);
					}
				}
			);
		}


		/**
	 * Ensure GetCartSummary is sent to backend
	 * @returns {*}
	 */
	  Cart.fetchGetCartSummaryFromBackend = function() {
			return AppData.fetch(
				Enums.services.GET_CART_SUMMARY,
				false,
				{},
				true
			).then(
				function(data) {
			  cleanUpCartData(data);

			  if (!Cart.checkForItemErrors(data) && data.status == status.OK) {
						Cart.updateInternals(data);
			  }
				}
			);
	  }

		/**
		 * Checks if any of the cart item requests to have a specific billing provider
		 * if so returns the value of the charac, if not returns undefined
		 * @protected
		 * @returns {String/undefined} charac value/ undefined
		 */
		Cart.getBillingProviderByItems = function() {
			var cartItem = Cart.cartItems.find(function(cartItem) {
				if (Utilities.safelyCheckPropertyOnObject('cartItem.CHARACS', cartItem)) {
					return typeof cartItem.CHARACS[0].billing_provider_required !== 'undefined';
				}
			});

			if (!cartItem) {
				return;
			}
			return cartItem.CHARACS[0].billing_provider_required;
		}

		/**
		 *	@todo, I think there's another function floating around that tests the same thing.
		 */
		Cart.processUpdateCartCheckoutInfo = function() {
			// have to pass the service in as a param to get around circular dependency.
			var routeToShipping = false;

			if (angular.isDefined(AppData.GetMerchantDetails)) {
				if (angular.isDefined(AppData.GetMerchantDetails.SHIPPINGMETHOD)) {
					if (!angular.isArray(AppData.GetMerchantDetails.SHIPPINGMETHOD)) {
						AppData.GetMerchantDetails.SHIPPINGMETHOD = [AppData.GetMerchantDetails.SHIPPINGMETHOD];
					}

					if (AppData.GetMerchantDetails.SHIPPINGMETHOD.length > 0) {
						routeToShipping = true;
					}
				}
			}

			$rootScope.hideSpinner();

			// Check if we have options for shipping and if we previously filled them out.
	       // don't route to shipping if valid is true, means it's complete.
			if (routeToShipping && !UserInfo.shipping.valid) {
				$rootScope.routeTo(Enums.routes.SHIPPING);
			} else if (!CustomActionService.executeCustomAction(CustomActionService.ACTIONS_ENUMS.CART_ON_PROCESS_UPDATE_CART_CHECKOUT_INFO)) {
				$rootScope.routeTo(Enums.routes.REVIEW);
			}
		}

		/**
		 * Fetchs updated cart checkout info as a promise
		 * @param {Object} request The request
		 * @returns {Promise} To resolve update cart checkout info then get cart summary
		 */
		Cart.updateCartCheckoutInfo = function(request) {
			return AppData.fetch(services.UPDATE_CART_CHECKOUT_INFO, false, request).then(function(data) {
				if (data.status === status.OK) {
					return Cart.fetchGetCartSummary(request.skip_requests);
				}
			});
		};

		/**
		 * We now need to call UpdateCartCheckoutInfo, to tell the backend we have a PayPal order.
		 * YOU NEED TO ADD IN THE skip_requests='SetExpressCheckout'!!!, otherwise, a new token will
		 * be generated, replacing our existing token, something we DO NOT WANT at this stage.
		 * The current token is the last token we want, unless the user cancels and starts over again.
		 *
		 * If SetExpressCheckout gets called, you will LOSE the working token on the server side
		 * associated to the cart. It will get replaced with a new token, which we don't want at this time.
		 *
		 * UpdateCartCheckoutInfo calls GetCartSummary, which in turn calls SetExpressCheckout.
		 * that is why we will add the attribute of `skip_requests` to our call.
		 */
		Cart.callUpdateCartCheckoutInfo = function(requestData, callbackResponseOk, callbackResponseFailed) {
			// Add the service to the pending requests.
			$rootScope.pendingRequests.push(services.UPDATE_CART_CHECKOUT_INFO);

			AppData.fetch(
				services.UPDATE_CART_CHECKOUT_INFO
				, false
				, requestData
			).then(
				function(data) {
					if (data.status == status.OK) {
						//$scope.routeTo( Enums.routes.REVIEW );
						Cart.fetchGetCartSummary(callbackResponseOk, callbackResponseFailed, requestData.skip_requests);
					} else if (data.status == status.FAILED) {
						// The request to updateCartItem failed.
						if (typeof callbackResponseFailed == 'function') {
							callbackResponseFailed();
						}
					}

					// Remove the service from the pending requests.
					$rootScope.removePendingRequest(services.UPDATE_CART_CHECKOUT_INFO);
				}
			);
		};

		/**
		 * Returns the credit cards to display.
		 * @protected
		 * @function
		 * @getCardTypesToDisplay
		 * @return {Object[]} The credit cards to display
		 */
		Cart.getCardTypesToDisplay = function() {
			var cybsCredtCards,
				creditCards;
			if (CustomActionService.actionRegistered(CustomActionService.ACTIONS_ENUMS.GET_CREDIT_CARDS)) {
				cybsCredtCards = CustomActionService.executeCustomAction(CustomActionService.ACTIONS_ENUMS.GET_CREDIT_CARDS);
				if (validArray(cybsCredtCards)) {
					return Cart._getCardTypeValues(cybsCredtCards);
				}
			}
			// Filter out credit cards which doesn't go through the normal credit card flow
			creditCards = AppData.billingTypes.filter(function(card) {
				return !(validString(card.billing_provider_desc) && normalize(card.billing_provider_desc) === (NORMALIZED_BILLING_PROVIDER_GOOGLEPAY || NORMALIZED_BILLING_PROVIDER_APPLE_PAY));
			});
			return Cart._getCardTypeValues(creditCards);
		};

		/**
		 * Get cardType values
		 * @public
		 * @param {Array} billingTypes billing types
		 * @returns {Array<Object>} card types
		 */
		Cart._getCardTypeValues = function(billingTypes) {
			/* eslint-disable camelcase */
			var restrictedCardTypeCode = Cart.getValueOfFirstOccurrenceOfCartItemCharac('card_type_required');
			var maestroEnabled = getBoolean(AppData.settings.display_maestro);

			if (!validArray(billingTypes)) {
				return [];
			}

			return billingTypes.reduce(function(cardTypes, type) {
				var name = Utilities.getString(type.name);
				var correctedName;
				var cardDisplay;

				if (type.auth_type === Enums.billingTypes.CREDITCARD && type.visible === 'true' && !Cart._isCardAddedToCardTypesArray(cardTypes, name) && (Utilities.isEmpty(restrictedCardTypeCode) || type.card_type_code === restrictedCardTypeCode)) {
					correctedName = name.replace(/\s/g, '').toLowerCase();
					cardDisplay = {
						desktop_image: '/images/' + correctedName + '-payment.png',
						mobile_sprite: correctedName,
						name: name,
						show: true
					};

					if (validString(type.image_filename)) {
						cardDisplay.binImage = $rootScope.getAssetUrl(type.image_filename);
					}

					// override to hide card if it's a master card and maestro has been enabled.
					if (correctedName === 'mastercard' && maestroEnabled) {
						cardDisplay.show = false;
					}

					cardTypes.push(cardDisplay);
				}

				return cardTypes;
			}, []);
			/* eslint-disable camelcase */
		}

		/**
		 * Check if current billing type is in array list or not
		 * @public
		 * @param {array} cardTypesArray An array of billing types made from AppDAta.billingTypes
		 * @param {string} billingTypeName The billing type name to search for
		 * @returns {boolean} If its added or not
		 */
		Cart._isCardAddedToCardTypesArray = function(cardTypesArray, billingTypeName) {
			if (!validString(billingTypeName) || !validArray(cardTypesArray)) {
				return false;
			}
			return cardTypesArray.some(function(cardType) {
				return cardType.name.toLowerCase().indexOf(billingTypeName.toLowerCase()) !== -1;
			});
		}

		Cart.getBillingDetailsByName = function(merchantDetailsData, name) {
			var count,
				i = 0;

			if (validArray(AppData.billingTypes)) {
				for (count = AppData.billingTypes.length; i < count; i++) {
					if (AppData.billingTypes[i].name === name) {
						return AppData.billingTypes[i];
					}
				}
			} else {
				return false;
			}
		};

		Cart.getBillingDetailsMerchantPaymentTypeRef = function(merchantDetailsData, refId) {
			var count,
				i = 0;

			if (validArray(AppData.billingTypes)) {
				for (count = AppData.billingTypes.length; i < count; i++) {
					if (AppData.billingTypes[i].merchant_payment_type_ref_id === refId) {
						return AppData.billingTypes[i];
					}
				}
			}

			return null;
		};

		Cart.getBillingDetailsById = function(merchantDetailsData, billingId) {
			var count,
				i = 0;

			if (validArray(AppData.billingTypes)) {
				for (count = AppData.billingTypes.length; i < count; i++) {
					if (AppData.billingTypes[i].billing_id == billingId) {
						return AppData.billingTypes[i];
					}
				}
			} else {
				return false;
			}
		};


		/**
		*
		* Assess whether the cart has unassigned addons via the one barcode flow
		*	* @returns {boolean}
    */
		Cart.hasUnassignedAddons = function() {
			if (Cart.hasOneBarcodePackages) {
				for (var i = 0; i < Cart.cartItems.length; i++) {
					var cartItem = Cart.cartItems[i];

					if (angular.isDefined(cartItem.CHARACS) &&
					angular.isDefined(cartItem.CHARACS[0].isAddonPackage) &&
					angular.isUndefined(cartItem.CHARACS[0].group_uuid)) {
					// Unassigned addon found
						$log.info('Unassigned addon found');
						return true;
					}
				}
			}

			return false;
		}

		Cart.getShippingMethods = function() {
			if (
				Cart.cartDetails &&
			Cart.cartDetails.CART &&
			Cart.cartDetails.CART.SHIPPING_METHODS &&
			Cart.cartDetails.CART.SHIPPING_METHODS.S
			) {
			//Convert to array if needed.
				Cart.cartDetails.CART.SHIPPING_METHODS.S = angular.isArray(Cart.cartDetails.CART.SHIPPING_METHODS.S)
					? Cart.cartDetails.CART.SHIPPING_METHODS.S
					: [Cart.cartDetails.CART.SHIPPING_METHODS.S];

				return Cart.cartDetails.CART.SHIPPING_METHODS.S;
			}
		};

		function getDeliveryMethod(data) {
			// If a deliverymethod is used, return the methos name.
			if (data.CART && data.CART.ship_method && data.CART.ship_method != '') {
				if (data.CART.SHIPPING_METHODS) {
					data.CART.SHIPPING_METHODS.S = data.CART.SHIPPING_METHODS.S || [];

					for (var i = 0; i < data.CART.SHIPPING_METHODS.S.length; i++) {
						var delMethod = data.CART.SHIPPING_METHODS.S[ i ];
						if (delMethod.ship_method == data.CART.ship_method) {
							var _label = ((Language).ShippingView || {})[ delMethod.ship_method.toLowerCase() + 'Description' ] || '';
							return ': ' + _label;
						}
					}
				}
			}

			return '';
		}


		/**
		 * This function is almost identical to Cart.validateMaxQty
		 * @TODO Either merge these two functions or resolve otherwise
		 */
		Cart.exceededPackageLimit = function(customerTypes, packageDetails) {
			//Check the cart for items of the same package type that is to be added
			var cartSummary = CartDataService.getLastSummary();
			var totalQtyByRate = getTotalQtyForRatesBeingAdded(customerTypes, packageDetails.id);
			var totalQtyInCart = cartSummary.cart.items.reduce(function iterateCartItems(acc, item) {
				if (item.package.id === packageDetails.id) {
					acc += item.info.qty;
				}

				return acc;
			}, 0);

			if ((totalQtyByRate + totalQtyInCart) > Number(packageDetails.max_quantity) && Number(packageDetails.max_quantity) != 0) {
				$rootScope.hideSpinner();
				Modal.displayModal(
					{
						category: 'Cart',
						action: 'Error',
						label: 'Exceeded Package Max Qty',
						value: totalQtyByRate,
						replacementKeys: 'maxQty',
						replacementValues: packageDetails.max_quantity,
						title: Language.Alert.maxQtyTitle,
						description: Language.Alert.maxQtyMsg,
						callback: function(detail) {
							if (detail == Enums.buttonFlags.OK) {
								try {
									callback.call(this, true);
								} catch (error) {

								}
							}
						},
						buttonFlags: [Enums.buttonFlags.OK]
					}
				);

				return true;
			}

			return false;
		}

		Cart.getTotalFees = function() {
			var feeTotal = 0;

			if (angular.isDefined(AppData.GetMerchantDetails) &&
				angular.isDefined(AppData.GetMerchantDetails.CART_ADJUSTMENTS)) {
				var cartAdjustments = AppData.GetMerchantDetails.CART_ADJUSTMENTS;

				for (i = 0; i < cartAdjustments.length; i++) {
					var ca = cartAdjustments[i];

					if (ca.card_type == "") {
						feeTotal += parseFloat(ca.amount);
					}
				}
			}

			return feeTotal;
		}

		Cart.checkForDeferredPayment = function() {
			for (var i = 0; i < Cart.cartItems.length; i++) {
				if (angular.isDefined(Cart.cartItems[ i ].payment_schedule_id)) {
					return true;
				}
			}
			return false;
		};

		function getTotalQtyForRatesBeingAdded(customerTypes, packageId) {
			return customerTypes.reduce(function(acc, a) {
				return (Number(a.package_id)==Number(packageId)) ? acc+Number(a.qty) : acc;
			}, 0);
		}

		function getItemQtyFromCart(item) {
			var cartSummary = CartDataService.getLastSummary();
			var qtyInCart = 0;

			if (!cartSummary.cart.items.length) {
				return qtyInCart;
			}

			for (var i = 0; i < cartSummary.cart.items.length; i++) {
				var cartItem = cartSummary.cart.items[ i ],
					pkgId = cartItem.package.id,
					pkgQty = cartItem.info.qty;

				if (cartItem.info.id == item.id) {
					continue;
				}

				if (CustomActionService.executeCustomAction('itemAddedThisSession', cartItem)) {
					// If we're in the recommender wizard, don't include the count of items that
					// are about to be replaced.
					continue;
				}

				//if( getCartLimitOverride( cartItem ) != '1' && ctName != 'group' ) {
				if ((item.package_id || item.id) == pkgId) {
					qtyInCart += pkgQty;
				}
				//}
			}

			return qtyInCart;
		}

		/**
		 * Check every cart items and compare if vat is set witin GetApplicationConsolidated
		 * if its set to true then it will add tax with retail_price to display on screen
		 *
		 */
		function setDisplayPrice() {
			//TODO: there must be a better way
			//set the vat due to timing
			for (var i=0; i < Cart.cartItems.length; i++) {
				var item = Cart.cartItems[i];

				// Only do all this extra junk for VAT calculation
				if (getBoolean(AppData.defaults.use_vat)) {
					if (angular.isDefined(item)) {
						// Add all taxes and fees together when displaying VAT
						item.display_price = Number(item.retail_price) + Number(item.tax_amount) + Number(item.fee_amount);
					} else {
						$log.error('item not defined!');
					}
				} else {
					item.display_price = Number(item.retail_price);
				}
			}
		}

		/**
		 * Compare the customerTypes with the cartItems if the package has been added
		 * before, true if exist in Cart.cartItems
		 *
		 * Comparison is identify by unique identifier {object}.package_id
		 *
		 * @param customerTypes
		 * @returns {boolean} true:false
		 */
		function customerTypeExist(customerTypes) {
			for (var i in customerTypes) {
				for (var k in Cart.cartItems) {
					if (Cart.cartItems[k].package_id == customerTypes[i].package_id) {
						return true;
					}
				}
			}

			return false;
		}

		function showCartLimitModal() {
			// Alert user is adding a total qty that will exceed the cart limit.
			// OR... Alert user is adding a total qty that combined with cart
			// total will exceed the cart limit.
			Modal.displayModal({
				category: 'Cart',
				action: 'Error',
				label: 'Cart Limit',
				value: Package.cartLimit,
				replacementKeys: 'cartLimit',
				// replacementValues: '<span class="limit">' + $rootScope.cartLimit + '</span>'
				replacementValues: Package.cartLimit,
				title: Language.Alert.cartLimitTitle,
				description: Language.Alert.cartLimitMsg
			});
		}

		function cleanUpCartData(data) {
			if (Utilities.safelyCheckPropertyOnObject('data.CART.ITEMS.ITEM', data)) {
				data.CART.ITEMS.ITEM = angular.isArray(data.CART.ITEMS.ITEM) ? data.CART.ITEMS.ITEM : [data.CART.ITEMS.ITEM];
			}
		}

		/**
		 * Compares the items to be added with the cart Limit, making sure that this does not pass the limit of the
		 * cart not including those that are override Items
		 * @param {integer} totalLessOverrideBeingAdded
		 * @param {object} Cart
		 * @returns {boolean}
		 */
		function getCartLimitOverride(cartItem) {
			if (typeof(cartItem.cart_limit_override) == 'undefined') {
				return false;
			} else {
				return true;
			}
		}

		function addPackageCharacs(itemsToBeAdded, packageDetails) {
			var lastItem = itemsToBeAdded[ itemsToBeAdded.length - 1 ];

			for (var i = 0; i < lastItem.qty; i++) {
				// Add a CHARACs object for each qty if not already there.
				lastItem.CHARACS = lastItem.CHARACS || [];
				lastItem.CHARACS[ i ] = lastItem.CHARACS[ i ] || {};

				// Copy retained CHARACs from the package to the item being added to cart - if they exist in the package.
				if (typeof(packageDetails.CHARACS) != 'undefined') {
					for (var j = 0; j < retainCharacs.length; j++) {
						for (var key in packageDetails.CHARACS) {
							if (key == retainCharacs[ j ]) {
								lastItem.CHARACS[ i ][ key ] = packageDetails.CHARACS[ key ];
							}
						}
					}
					if (angular.isDefined(packageDetails.CHARACS.start_date)) {
						lastItem.CHARACS[i].start_date = packageDetails.CHARACS.start_date;
					}
				}
			}

		   // Sometimes in the case of swaps (and aliases), we lose the right base package, this handles that, excluding quicksells
			if (angular.isArray(lastItem.CHARACS) && !hasQuickSellCharac(lastItem.CHARACS)) {
				for (var i = 0; i<lastItem.CHARACS.length; i++) {
					lastItem.CHARACS[i].preswap_package_id = packageDetails.id;
				}
			}
		}

		function hasQuickSellCharac(characsArray) {
			var charac = characsArray.filter(function(item) {
				return (angular.isDefined(item.quicksell) && item.quicksell);
			});
			return (charac.length > 0);
		}

		/**set the package-level cross sell keywords depending on the item being added to the cart
		  this doesn't need to be on each item to reduce duplications
		*/
		function setCrossSellKeywords(packageDetails) {
			if (packageDetails.CROSS_SELL && packageDetails.CROSS_SELL.CS) {
				var crossSells = !angular.isArray(packageDetails.CROSS_SELL.CS) ? [packageDetails.CROSS_SELL.CS] : packageDetails.CROSS_SELL.CS;

				for (var p in crossSells) {
					if (crossSells[p].hasOwnProperty('keyword')) {
						//Before adding any keywords to the cross sells screen, check to see that there is active packages
						//for that keyword.
						var packages = filterPackagesByAssocKeywords(AppData.GetMerchantPackageList.PS.P, crossSells[p]['keyword']);
						if (validArray(packages)) {
							packageCrossSells.addToCrossSells(packageDetails.id, crossSells[p]);
						}
					}
				}
			}
		}

		Cart.validateMinQty = function(currentItem, checkCart, handleErrorCallback) {
			if (angular.isUndefined(currentItem) || (currentItem && angular.isUndefined(currentItem.min_quantity))) {
				return true;
			}

			// Ensure min qty or greater is selected for each rate type.
			var qtyInCart = 0,
				minQty,
				currentQuantity = parseInt(currentItem.qty);
			if (getBoolean(checkCart)) {
				qtyInCart = getItemQtyFromCart(currentItem);
				currentQuantity = qtyInCart + parseInt(currentItem.qty);
			}

			minQty = angular.isDefined(currentItem.ct_min_quantity) ? currentItem.ct_min_quantity : currentItem.min_quantity;


			if (currentQuantity < Number(minQty) && Number(minQty) != 0) {
				if (angular.isFunction(handleErrorCallback)) {
					handleErrorCallback.call(this, currentItem);
				} else {
					Cart.handleMinQtyModal(currentItem);
				}

				return false;
			}

			return true;
		}

		Cart.handleMinQtyModal = function(currentItem) {
			// Alert user has less than min qty.

			var minQty = angular.isDefined(currentItem.ct_min_quantity) ? currentItem.ct_min_quantity : currentItem.min_quantity;

			Modal.displayModal(
				{
					category: 'Cart',
					action: 'Error',
					label: 'Package Min Qty not reached',
					value: currentItem.qty,
					replacementKeys: 'minQty',
					replacementValues: minQty,
					title: Language.Alert.minQtyTitle,
					description: Language.Alert.minQtyMsg
				}
			);
		};

		Cart.validateMaxQty = function(currentItem, checkCart) {
			if (angular.isUndefined(currentItem) || (currentItem && angular.isUndefined(currentItem.max_quantity))) {
				return true;
			}

			// Ensure max qty is not exceeded for each rate type.
			// Account for the quantity in this cart.
			var qtyInCart = 0,
				maxQty,
				currentQuantity = parseInt(currentItem.qty, 10);

			if (getBoolean(checkCart)) {
				qtyInCart = getItemQtyFromCart(currentItem);
				currentQuantity = qtyInCart + currentQuantity;
			}

			maxQty = angular.isDefined(currentItem.ct_max_quantity) ? currentItem.ct_max_quantity : currentItem.max_quantity;

			if (currentQuantity > Number(maxQty) && Number(maxQty) != 0) {
				// Alert user has more than max qty.
				Modal.displayModal(
					{
						category: 'Cart',
						action: 'Error',
						label: 'Exceeded Package Max Qty',
						value: currentItem.qty,
						replacementKeys: 'maxQty',
						replacementValues: maxQty,
						title: Language.Alert.maxQtyTitle,
						description: Language.Alert.maxQtyMsg
					}
				);
				return false;
			}
			return true;
		};

		function promptAdvancedTicketModal(isAdvancedTicket, advanceTicketDate, callback) {
			if (isAdvancedTicket) {
				var selectedDate = Utilities.dateStringToObject(advanceTicketDate.split('/').join('-'));

				var formattedSelectedDate = $filter('date')(selectedDate, AppData.settings.date_format);
				Modal.displayModal({
					category: 'Cart',
					label: 'Advance Ticket Notification',
					replacementKeys: ['date'],
					replacementValues: [formattedSelectedDate],
					title: Language.getLocale('Alert', 'advancePackageTitle'),
					description: Language.getLocale('Alert', 'advancePackageMsg'),
					callback: function(detail) {
						if (detail == Enums.buttonFlags.YES) {
							callback.call(this, true);
						}
					},
					buttonFlags: [Enums.buttonFlags.NO, Enums.buttonFlags.YES]
				});
			} else {
				callback.call(this, false);
			}
		}

		// @TODO: Need to understand what is happening here. Don't know why this function exists
		function setAdvancedTicketNotification(callback) {
			return promptAdvancedTicketModal(Package.isAdvancedTicket, Package.advanceTicketDate, callback);
		}

		/**
		 * Fetches a setting in relation to membership upgrades
		 * @public
		 * @param {string} setting - the setting that is requested
		 * @returns {*|boolean}
		 */
		Cart.fetchMembershipUpgradeSetting = function(setting) {
			var schema = 'membership_upgrade',
				config = checkProp('AppData.settings.membership_upgrade', AppData, returnValue);

			if (!$injector.get('FolioService').membershipUpgrade) {
				return false;
			}
			try {
				config = JSONValidator.validate(schema, config) ? config : JSONValidator.fillDefaults(schema, config);
				return checkProp('config.' + setting, config) ? config[setting] : false;
			} catch (e) {
				return false;
			}
		}

		/**
		 * Update the cart with items to be added, return true if successful
		 * @param {array} itemsToBeAdded
		 * @param {boolean} callback
		 *
		 */

		var qtyBeingAdded = 0;

		/**
		 * This function should not be inside this other function but it is. It handles calling getcartsummary after adding items to the cart
		 * @param {Function} onAddedToCartCallback A callback to call after adding to the cart. This replaces the "handleAddCartItemResponse" functionality call for success.
		 * @param {Function} onFailedAddingToCart A callback to call after failing to add to the cart. This replaces the "handleAddCartItemResponse" functionality call for failure.
		 * @returns {undefined}
		 */
		function addCartItems(itemsToBeAdded, onAddedToCartCallback, onFailedAddingToCart) {
			// The value of $location.$$replace gets lost while waiting for AppData.fetch to return.
			var currentItemToBeAdded,
				replaceCurrentRoute = $location.$$replace;
			itemsToBeAdded = splitCartItems(itemsToBeAdded);
			qtyBeingAdded = getQtyAdded(itemsToBeAdded);

			flags.hasQuickSells = false;
			flags.hasCrossSells = false;
			flags.hasUpSells = false;
			for (var i in itemsToBeAdded) {
				currentItemToBeAdded = itemsToBeAdded[i];
				if (checkProp('currentItemToBeAdded.CHARACS.0.quicksell', currentItemToBeAdded, getBoolean)) {
					flags.hasQuickSells = true;
				}
				if (checkProp('currentItemToBeAdded.CHARACS.0.crosssell', currentItemToBeAdded, getBoolean)) {
					flags.hasCrossSells = true;
				}
				if (checkProp('currentItemToBeAdded.CHARACS.0.upsell', currentItemToBeAdded, getBoolean)) {
					flags.hasUpSells = true;
				}
			}
			Cart.storeLastDate(itemsToBeAdded);
				for (var i = 0; i < itemsToBeAdded.length; i++) {
					if (angular.isDefined(itemsToBeAdded[i].CHARACS)) {
						for (var j = 0; j < itemsToBeAdded[i].CHARACS.length; j++) {
							var charac = itemsToBeAdded[i].CHARACS[j];
							if (angular.isDefined(charac.start_time) && !(charac.start_time.includes('AM') || charac.start_time.includes('PM'))) {
    							charac.start_time = Utilities.militaryToCivilianTime(charac.start_time);
							}
						}
					}
				}

			CustomActionService.executeCustomActionChain(CustomActionService.ACTIONS_ENUMS.PRE_REQUEST_ADD_TO_CART_ITEMS, itemsToBeAdded);
			CustomActionService.executeCustomActionChain('modifyCustomerTypesForCartItems', itemsToBeAdded);
			$rootScope.showSpinner(Language.ApplicationLabels.updatingCartLoadMsg);
			$rootScope.pendingRequests.push(Enums.services.ADD_CART_ITEM);

			AppData
				.fetch(Enums.services.ADD_CART_ITEM, false, itemsToBeAdded)
				.then(function(response) {
					Cart.groupingComplete = false;
					$rootScope.removePendingRequest(Enums.services.ADD_CART_ITEM);

					if (response.status === Enums.status.OK) {
						// Capture backend capacity hold expiration. Field is omitted when capacity
						// hold is disabled globally or per-package; setter handles that case.
						CartDataService.setCapacityExpiration(response.capacity_expiration);

						CustomActionService.executeCustomActionChain(CustomActionService.ACTIONS_ENUMS.ON_ITEMS_ADDED_TO_CART, itemsToBeAdded);

						// Reset isAdvancedTicket flag.
						Package.isAdvancedTicket = false;

						$rootScope.pendingRequests.push(Enums.services.GET_CART_SUMMARY);
						AppData
							.fetch(Enums.services.GET_CART_SUMMARY, true, {}, true)
							.then(function(data) {
								if (replaceCurrentRoute) {
									$location.replace();
								}

								$rootScope.removePendingRequest(Enums.services.GET_CART_SUMMARY);
								cleanUpCartData(data);

								// Enhanced Ecommerce Call
								if (Utilities.safelyCheckPropertyOnObject('AppData.GetNewCartID', AppData)) {
									var cartInfo = AppData.GetNewCartID;
									AnalyticsDataLayerService.triggerAccertify(cartInfo.accertify_session_id);
								}

								$rootScope.$broadcast('triggerAddToCart', itemsToBeAdded);

								if (data.status === Enums.status.OK) {
									if (!Cart.checkForItemErrors(data)) {
										// Dynamic Capacity Pricing routine
										DynamicCapacityPricingService.verifyAddToCart(response, data);

										// Update the cart object.
										Cart.updateInternals(data);
										$rootScope.hideSpinner();
										if (!onAddedToCartCallback) {
											handleAddCartItemResponse(data, itemsToBeAdded);
										} else {
											onAddedToCartCallback();
										}
									}
								} else if (data.status === Enums.status.FAILED) {
									// If we get an error, expect an inbound get new cart id.
									if (!onFailedAddingToCart) {
										handleAddCartItemResponse(data);
									} else {
										onFailedAddingToCart();
									}
									$rootScope.hideSpinner();
								} else if (data.status === Enums.status.ERROR) {
									if (!onFailedAddingToCart) {
										$rootScope.routeTo(StandardFlowInitiatorService.getStandardFlowEntryRoute());
									} else {
										onFailedAddingToCart();
									}
								}
							});
					} else if (response.status === Enums.status.FAILED) {
						// The request to updateCartItem failed.
						$rootScope.hideSpinner();
						if (angular.isString(response.error_code) && !Utilities.isEmpty(response.error_code) && Language.ErrorCodes[response.error_code]) {
							Modal.displayErrorModal(response);
						} else {
							Modal.displayModal({
								category: 'Cart [Add Cart Item]',
								action: 'Error',
								label: response.error_msg,
								title: Language.Alert.cartErrorAddingItemTitle,
								description: Language.Alert.cartErrorAddingItemMsg
							});
							Language.displayErrorCode(response, false, (((AppData || {}).GetApplicationConsolidated || {}).SETTINGS || {}).support_phone_number);
							$rootScope.hideSpinner();
						}

						if (onFailedAddingToCart) {
							onFailedAddingToCart();
						}
					}
				});
		}

		//!WARNING!
		//This should only be used in cases where the items to be added does not have a clear package associated with it.
		//Currently, this only includes the upgrades wizard and the acs portal. Most modules can use the Cart.addToCart function
		//When using this function, the cross sells are not set up properly and more than likely will not work.
		Cart.addAlternateModuleItemsToCart = function(itemsToBeAdded) {
			addCartItems(itemsToBeAdded);
		}

		function splitCartItems(itemsToBeAdded) {
			var splitItems = false;

			try {
				// Add business rules to determine if items need to be split.
				splitItems = itemsToBeAdded[ 0 ].CHARACS[ 0 ].client_xfc_view == 'seasonPass';
			} catch (e) {
				splitItems = false;
			}

			if (!splitItems) {
				return itemsToBeAdded;
			}

			var items = [];
			for (var i = 0; i < itemsToBeAdded.length; i++) {
				if (angular.isDefined(itemsToBeAdded[i].CHARACS)) {
					items.push(itemsToBeAdded[i]);
					continue;
				}

				var firstCharacs = itemsToBeAdded[ i ].CHARACS[ 0 ] || {};
				for (var j = 0; j < itemsToBeAdded[ i ].qty; j++) {
					var copy = JSON.parse(JSON.stringify(itemsToBeAdded[ i ]));
					delete copy.CHARACS;

					copy.qty = 1;
					copy.CHARACS = [itemsToBeAdded[ i ].CHARACS[ j ] || firstCharacs];

					items.push(copy);
				}
			}

			return items;
		}

		function getQtyAdded(itemsToBeAdded) {
			var sum = 0;
			for (var i in itemsToBeAdded) {
				sum += itemsToBeAdded[ i ].qty;
			}

			return sum;
		}

		function handleAddCartItemResponse(data, itemsToBeAdded) {
			resellerSkipCartModal = CustomActionService.executeCustomAction(CustomActionService.ACTIONS_ENUMS.RESELLER_SKIP_STEP, 'add_to_cart');
			if (data.status == Enums.status.OK) {
				// if an onAddCartItemResponse custom action is defined and it is set to return true
				// it will bypass the current logic in this method.
				// If it returns a false value then the existing logic will also execute.
				if (CustomActionService.executeCustomAction('onAddCartItemResponse', null, [data, flags, qtyAdded, qtyBeingAdded])) {
					return;
				}

				Package.itemsToBeAdded = [];

				if (!resellerSkipCartModal) {
					var abTestResult = AbTestService.abTestDescription('checkoutLocaleSwitch');

					Modal.displayModal({
						category: 'Cart',
						label: 'Items Added',
						type: Enums.modalTypes.ADDTOCART,
						value: qtyAdded,
						replacementKeys: 'qtyAdded',
						replacementValues: qtyBeingAdded,
						replaceInTitle: true,
						icon: 'icon-cartmodal green',
						title: Language.Alert.cartAddedItemTitle,
						description: Language.Alert.cartOrContinueShoppingTitle,
						buttonFlags: validString(abTestResult) && abTestResult == 'A' ? [Enums.buttonFlags.CONTINUE_SHOPPING, Enums.buttonFlags.VIEW_CART] : [Enums.buttonFlags.CONTINUE_SHOPPING, Enums.buttonFlags.PROCEED_TO_CHECKOUT],
						showCloseButton: false,
						analyticsLabelAdditions: angular.isDefined(abTestResult) ? abTestResult : '',
						suppressedAction: function() {
							// If the action is suppressed, we do the following:
							Cart.routeToCrossSellsOrCartAsAppropriate();
						},
						callback: function(detail) {
							if (detail === Enums.buttonFlags.CONTINUE_SHOPPING) {
								if (!CustomActionService.executeCustomAction(CustomActionService.ACTIONS_ENUMS.ON_CONTINUE_SHOPPING, itemsToBeAdded)) {
									$rootScope.routeTo(StandardFlowInitiatorService.getStandardFlowEntryRoute());
								}

								StandardFlowInitiatorService.resetStandardFlow();
							} else if (detail === Enums.buttonFlags.PROCEED_TO_CHECKOUT || detail === Enums.buttonFlags.VIEW_CART) {
								Cart.routeToCrossSellsOrCartAsAppropriate();
							}
						}
					});
				} else {
					Cart.routeToCrossSellsOrCartAsAppropriate();
				}

				qtyBeingAdded = 0;

				// Prompt for cross-sells after each successful add to cart.
				if (ClientInfo.deviceType == 'mobile') {
					AppData.crossSells = true;
				} else {
					AppData.crossSells = false;
				}
			} else {
				// Problem adding the item to cart.
				Modal.displayErrorModal(data, 'CheckCartTicketLevelErrors', (((AppData || {}).GetApplicationConsolidated || {}).SETTINGS || {}).support_phone_number);
				Language.displayErrorCode(data, 'CheckCartTicketLevelErrors', (((AppData || {}).GetApplicationConsolidated || {}).SETTINGS || {}).support_phone_number);
				if (StandardFlowInitiatorService.hasCurrentFlow) {
					$rootScope.routeTo(StandardFlowInitiatorService.getStandardFlowEntryRoute());
				} else {
					$rootScope.routeTo(Enums.routes.DETAILS + '/' + Package.packageDetails.id);
				}
			}
		}

		function executeAndFetchABTestResult() {
			var result = AbTestService.abTestDescription('checkoutLocaleSwitch');
		}

		/**
		 * Use backend deposit calculation for total/sub total when we are in membership upgrade flow
		 * @function
		 * @public
		 * @returns {undefined}
		 */
		function setMembershipUpgradeTotalCalculation() {
			Cart.useCartViewTotalCalculation = !Cart.fetchMembershipUpgradeSetting('cart_view_legacy_calculations');
		}

		function routeToPackageListByKeyWord() {
			// Iterate through AppData menu items and determiine where to route.
			var alternateFlow = ExtraFlow.isAlternateFlow(AppData.lastKeyword, AppData.menuItems);
			if (alternateFlow != '') {
				var view = ExtraFlow.getAlternateFlowView(alternateFlow);
				if (view) {
					$rootScope.routeTo(view + '/' + AppData.lastKeyword)
					return;
				}
			}

			$rootScope.routeTo(Enums.routes.LISTKEYWORD + '/' + AppData.lastKeyword);
		}

		function getTotalQty() {
			var qtySum = 0;
			if (Cart.cartItems && typeof(Cart.cartItems) != 'undefined' && Cart.cartItems.length) {
				for (var i = 0; i < Cart.cartItems.length; i++) {
					var item = Cart.cartItems[ i ];
					if (Cart.useCartViewTotalCalculation && item.is_deposit) {
						continue;
					}
					qtySum += Number(item.qty);
				}
			}

			return qtySum;
		}

		/**
		* Prompt user and route back to main package list if we should
		* @param shouldReplaceRoute - should we replace the route
		* @returns {boolean}
		*/
		Cart.promptAndRouteIfEmpty = function(shouldReplaceRoute) {
			var isCartEmpty = false;
			if (!$rootScope.hasItemsInCart()) {
				// reset route history for back button on packageDetails
				StandardFlowInitiatorService.resetStandardFlow();

				// go to package list
				$rootScope.routeTo(Enums.routes.LIST, undefined, undefined, getBoolean(shouldReplaceRoute));

				isCartEmpty = true;
			}
			return isCartEmpty;
		};

		Cart.getFlags = function() {
		   return flags;
		};

		/**
		* Checks if there is a cart item present on the current cart that has a particular charac with a particular value
		* @param characName
		* @param characValue
		* @returns {boolean}
    */
		Cart.doesCartContainItemWithCharac = function(characName, characValue) {
			return Cart.cartItems.some(function(item) {
				return angular.isDefined(item.CHARACS) && item.CHARACS.some(
					function(charac) {
						return angular.isDefined(characValue) ? charac[characName] == characValue : angular.isDefined(charac[characName]);
					}
				)
			}
			);
		};

		/**
		 * Find and retrieve the value of the first occurrence of a charac within the cart items
		 * @param characName
		 * @returns {String}
		 */
		Cart.getValueOfFirstOccurrenceOfCartItemCharac = function(characName) {
			var characValue = '';
			for (var i = 0; i < Cart.cartItems.length; i++) {
				var item = Cart.cartItems[i];
				if (angular.isDefined(item.CHARACS)) {
					for (var j=0; j< item.CHARACS.length; j++) {
						var characList = item.CHARACS[j];
						if (angular.isDefined(characList[characName])) {
							characValue = characList[characName];
						}
					}
				}
			}

			return characValue;
		}


		/**
		 * Finds split items that were broken up for display/individual purposes and
		 * recombines them for BE
		 * @function
		 * @public
		 * @returns {Object[]} The Combined cart items.
		 */
		function combineSplitCartItems(cartItems) {
			var updated = [];
			var splitMap = {};
			var splitKeys;

			// If there is nothing to combine, return as-is
			if (cartItems.length < 2) {
				return cartItems;
			}

			// find split items and push non-split items
			cartItems.forEach(function(item, i) {
				if (item.split_id) {
					if (!splitMap[item.id]) {
						splitMap[item.id] = [];
					}

					splitMap[item.id].push(i);
				} else {
					updated.push(item);
				}
			});

			splitKeys = Object.keys(splitMap);

			// if no split items were found, end function
			if (splitKeys.length === 0) {
				return updated;
			}

			// assemble the split items back to be whole
			splitKeys.forEach(function(key) {
				var relevantCharacMarkers = ['WTP_number'];
				var combineList = splitMap[key];
				var cItem = angular.copy(cartItems[combineList[0]]);

				cItem.qty = parseInt(cItem.qty, 10);

				delete cItem.split_id;

				// If there is nothing to combine with, add it to updated and move on
				if (combineList.length < 2) {
					updated.push(cItem);
					return;
				}

				combineList.shift();

				// Go through each of the split items to grab pieces that need to be combined
				combineList.forEach(function(pos) {
					var relevantCharacs = angular.copy(cartItems[pos].CHARACS).reduce(function(acc, charac) {
						var characKeys = Object.keys(charac);
						var i;

						for (i = 0; i < relevantCharacMarkers.length; i++) {
							if (characKeys.includes(relevantCharacMarkers[i])) {
								acc.push(charac);
								return acc;
							}
						}
					}, []);

					cItem.CHARACS = cItem.CHARACS.concat(relevantCharacs);
					cItem.qty += parseInt(cartItems[pos].qty, 10);
				});

				updated.push(cItem);
			});

			return updated;
		}

		/**
		 * WTP Packages that have multiple WTP Numbers show as one and give a false impression
		 * that one WTP number has all the quantity. This separates each WTP Number out for each
		 * package
		 * @function
		 * @public
		 * @param {Object[]} cartItems The Cart Items
		 * @returns {Object[]} The same cart items with any needed adjustments for display
		 */
		Cart.declumpWtpCartItems = function(cartItems) {
			var updated = [];

			if (!validArray(cartItems)) {
				return cartItems;
			}

			// Run through all the cart items
			cartItems.forEach(function(item) {
				var otherCharacs = [];
				var wtpNums = [];

				// If the characs of the item is not an array or only has 1 in the set, add the item as the whole and move on
				if (!validArray(item.CHARACS) || item.CHARACS.length === 1) {
					return updated.push(item);
				}

				// Run through each charac looking for WTP_number
				item.CHARACS.forEach(function(charac) {
					if (charac.WTP_number) {
						// If we haven't already recorded it's existance, add it
						if (!wtpNums.includes(charac.WTP_number)) {
							wtpNums.push(charac.WTP_number);
						}
					} else {
						otherCharacs.push(charac);
					}
				});

				// if there is only one wtp number or if the item didn't possess a WTP Number, add it as a whole and move on
				if (wtpNums.length < 2) {
					return updated.push(item);
				}

				// Loop through the recorded WTP NUmbers
				wtpNums.forEach(function(wtpNumber, i) {
					var newItem = angular.copy(item);
					var filteredSet = item.CHARACS.filter(function(charac) {
						// Grab all the characs that match this WTP Number
						return charac.WTP_number === wtpNumber;
					});

					newItem.qty = filteredSet.length;
					newItem.CHARACS = angular.merge(filteredSet, otherCharacs);

					// Mark as split item and assign id
					newItem.split_id = item.id + '#' + i;

					// Add this as its' own separate Cart Item
					updated.push(newItem);
				});
			});

			return updated;
		}

		/**
		* Process sanitization
		* logic copied from purchase service
		* @public
		* @returns {undefined}
		*/
		Cart.processSanitization = function() {
		   var sanitize = true,
			   cartItem,
			   packageItem,
			   cartItemCharacs,
			   cartItemCharacItem,
			   characName,
			   packageXMCs,
			   pkg,
			   cartItemCharacs,
			   cartItemCharacXMCs,
			   xmcSettings,
			   keywordList,
			   alternateFlowSettings,
			   menuItem,
			   menuItemKeywords,
			   subMenuKeywords,
			   alternateModule,
			   subMenu,
			   subMenuItem;

		   /*
			   1. Iterate through all the items in the cart and collect the package ID
			   2. Iterate through the package list and grab each of those packages
			   3. Check if the package has special requirements (extra movie, package CHARAC, etc)
				   3.1 XMCs
				   3.2 Alternate Flow Module
					   3.2.1 Check keyword against navigation
				   3.3 TODO: Add package CHARAC check
			   4. If special requirements are set on the package, inspect items on the cart meet those requirements
		   */

		   if (!Utilities.childDefined(AppData, 'GetMerchantPackageList.PS.P')) {
			   return true;
		   }

		   for (var i = 0; i < Cart.cartItems.length; i++) {
			   cartItem = Cart.cartItems[i];

			   for (var j = 0; j < AppData.GetMerchantPackageList.PS.P.length; j++) {
				   packageItem = AppData.GetMerchantPackageList.PS.P[j];
				   keywordList = packageItem.keyword ? packageItem.keyword.split(', ').join().split(',') : [];

				   if (packageItem.id === cartItem.package_id) {
					   if (packageItem.extra_movie) {
						   // Get list of XMCs. Only extract enabled XMCs.
						   var enabledXFCS = ExtraFlow.getEnabledXFCsFromList(packageItem.extra_movie, true);
						   packageXMCs = enabledXFCS ? enabledXFCS.split(',') : [];
						   cartItemCharacs = cartItem.CHARACS || [];

						   if (cartItemCharacs[0].hasOwnProperty("group_uuid")) {
							   continue;
						   }

						   if (cartItemCharacs.length === Number(cartItem.qty)) {
							   // For each CHARAC item...
							   for (var k = 0; k < cartItemCharacs.length; k++) {
								   cartItemCharacItem = cartItemCharacs[ k ];

								   // If the cart item charac has a property called client_xfc_name, get the list (1 or more) or create an empty list.
								   cartItemCharacXMCs = (cartItemCharacItem.client_xfc_name) ? cartItemCharacItem.client_xfc_name.split(', ').join().split(',') : [];

								   // Verify that the package contains the same number of XMCs as the item in the cart has passed through.
								   // i.e. if the package specifies it requires two XMC, the cart item should note that it passed through those XMCs.
								   if (packageXMCs.length === cartItemCharacXMCs.length) {
									   // We have the same number of XMCs on the cart item CHARAC as we do on the package item.
									   // NOTE: That we only count the enabled XMCs on package item.
									   // Ensure the list is the same for cart items and package XMCs.
									   var pkgXMCList = packageXMCs.sort().join(',');
									   var cartXMCList = cartItemCharacXMCs.sort().join(',');
									   if (cartXMCList.toLowerCase() === pkgXMCList.toLowerCase()) {
										   // Solid list. Now let's ensure the proper CHARACs exist for each type of XMC.
										   for (var m = 0; m < packageXMCs.length; m++) {
											   xmcSettings = ExtraFlow[ packageXMCs[ m ] ];
											   if (xmcSettings) {
												   if (xmcSettings.characsList && xmcSettings.characsList.length) {
													   // For each item in the CHARAC list...
													   for (var n = 0; n < xmcSettings.characsList.length; n++) {
														   // Ensure CHARAC property exists on the CHARAC.
														   if (typeof(cartItemCharacItem[ xmcSettings.characsList[ n ] ]) == 'undefined' || !validString(cartItemCharacItem[xmcSettings.characsList[n]])) {
															   cartItem.sanitized = -1;
															   $log.error('Missing charac/charac value: ' + xmcSettings.characsList[n]);
															   sanitize = false;
														   }
													   }
												   }
											   } else {
												   // XMC has no settings - meaning it's not a real XMC.
												   // Should never hit this line.
												   cartItem.sanitized = -1;
												   sanitize = false;
											   }
										   }
									   } else {
										   // The list is not the same.
										   cartItem.sanitized = -1;
										   sanitize = false;
									   }
								   } else {
									   // Ohh Shhh... Discrepancy between cart item XMC list and package item XMC list...
									   cartItem.sanitized = -1;
									   sanitize = false;
									   $log.error('XMCs do not match');
									   $log.info('Package XMCs:');
									   $log.info(packageXMCs);
									   $log.info('Cart XMCs:');
									   $log.info(cartItemCharacXMCs);
								   }
							   }
						   } else {
							   // Nothing to see here. This item does not have the proper amount of CHARACS.
							   cartItem.sanitized = -1;
							   sanitize = false;
							   $log.error('Cart Item Characs List != XFC Charac Definition List');
						   }
					   }

					   // For each keyword in the package...
					   for (var o = 0; o < keywordList.length; o++) {
						   alternateModule = undefined;
						   // For each menu item in the menu...
						   for (var p = 0; p < AppData.menuItems.length; p++) {
							   var menuItem = AppData.menuItems[ p ];
							   if (menuItem.isactive) {
								   menuItemKeywords = menuItem.keywords.split(', ').join().split(',');

								   for (var q = 0; q < menuItemKeywords.length; q++) {
									   if (keywordList[ o ] === menuItemKeywords[ q ]) {
										   alternateModule = menuItem.alternateModule || '';
										   break;
									   }
								   }

								   if (alternateModule) {
									   break;
								   }

								   // If alternateModule is not defined, see if it's in the sub-menu.
								   subMenu = menuItem.MENUITEM || [];
								   if (subMenu.length) {
									   // For each sub-menu item in the menu...
									   for (var q = 0; q < subMenu.length; q++) {
										   subMenuItem = subMenu[ q ];
										   if (subMenuItem.isactive && subMenuItem.alternateModule) {
											   subMenuKeywords = subMenuItem.keywords.split(', ').join().split(',');
											   for (var r = 0; r < subMenuKeywords.length; r++) {
												   if (keywordList[ o ] === subMenuKeywords[ r ]) {
													   alternateModule = subMenu.alternateModule || '';
													   break;
												   }
											   }
										   }

										   if (alternateModule) {
											   break;
										   }
									   }
								   }

								   if (alternateModule) {
									   break;
								   }
							   }

							   if (alternateModule) {
								   break;
							   }
						   }
					   }

						if (alternateModule) {
						   // This item has alternate module. Get the CHARACS from the settings.
						   alternateFlowSettings = ExtraFlow.getAlternateFlowSettings(alternateModule);

						   if (alternateFlowSettings) {
								cartItemCharacs = cartItem.CHARACS || [];
								pkg = Package.getPackageByID(cartItem.package_id);

								if (cartItemCharacs.length === Number(cartItem.qty)) {
									// For each CHARAC item...
									for (var s = 0; s < cartItemCharacs.length; s++) {
										cartItemCharacItem = cartItemCharacs[ s ];

										if (alternateFlowSettings.characsList && alternateFlowSettings.characsList.length) {
											// For each item in the CHARAC list...
											for (var t = 0; t < alternateFlowSettings.characsList.length; t++) {
												// Ensure CHARAC property exists on the CHARAC.
												characName = alternateFlowSettings.characsList[t];

												if (typeof cartItemCharacItem[characName] == 'undefined') {
													// We need this section because we could end up with packages that don't require date/time and the alternate module might...
													if (!['start_date', 'start_time'].includes(characName)) {
														cartItem.sanitized = -1;
														sanitize = false;
													// Else if it is the start_date charac and the package is dated, fail the sanitization
													} else if (characName === 'start_date' && Package.isDated(pkg)) {
														cartItem.sanitized = -1;
														sanitize = false;
													// Else if it is the start_time charac and the package is timed, fail the sanitization
													} else if (characName === 'start_time' && Package.isTimed(pkg)) {
														cartItem.sanitized = -1;
														sanitize = false;
													}
												}
											}
										}
									}
								} else {
									// Nothing to see here. This item does not have the proper amount of CHARACS.
									cartItem.sanitized = -1;
									sanitize = false;
									$log.error('Item does not have the proper amount of CHARACS');
								}
							}
						}

					   // If we have a match, no need to examine the packages further.
					   // Proceed with the next cart item.
					   break;
				   }
			   }
		   }

		   // Remove all cart items that did not pass sanitation.
		   for (var i = 0; i < Cart.cartItems.length; i++) {
			   cartItem = Cart.cartItems[ i ];
			   if (cartItem.sanitized === -1) {
				   Cart.cartItems.splice(i, 1);
			   }
		   }
		   return sanitize;
	   }

		/**
		 * Returns the total number of items in the cart
		 * @protected
		 * @returns {Number} Number of items in the cart
		 */
		function getInitialCartQuantity() {
			var items;
			if (AppData.GetCartSummary) {
				items = checkProp('AppData.GetCartSummary.CART.ITEMS.ITEM', AppData, 'returnValue');
				Cart.totalQty = reduceCartQty(items);
			} else {
				var cartInfo = Storage.get('GetNewCartID');

				if (cartInfo) {
					AppData.cart.cart_id = cartInfo.cart_id;
					AppData.cart.cart_key = cartInfo.cart_key;
					AppData.cart.session_id = cartInfo.session_id;

					// Send Cart ID to Data Layer
					AnalyticsDataLayerService.triggerCartInfo(cartInfo);

					return AppData
						.fetch(Enums.services.GET_CART_SUMMARY, true, { skip_requests: 'SetExpressCheckout' }, true)
						.then(function(resp) {
							Cart.updateInternals(resp);
							if (resp.status === Enums.status.OK) {
								Cart.totalQty = reduceCartQty(checkProp('resp.CART.ITEMS.ITEM', resp, 'returnValue'));
							}
						})
				}
			}
		}

		/**
		 * Calculates and returns the total number of items in the cart
		 * @protected
		 * @returns {Number} Number of items in the cart
		 */
		function reduceCartQty(items) {
			forceInt = Utilities.forceInt;

			if (validArray(items)) {
				return items.reduce(function calculateTotalInCart(total, item) {
					return total + forceInt(item.qty);
				}, 0);
			} else if (angular.isObject(items)) {
				return forceInt(items.qty);
			}

			return 0;
		}

		return Cart;
	});
(function(){
	'use strict';

	angular
		.module('cart', ['app', 'components'])
		.config(CartConfig);

	/**
	 * The cart module configuration
	 * @constructor
	 * @param {Provider} $stateProvider The ui-router state provider
	 * @param {Service} ComponentLoaderEnums - The Component Loader Enums
	 * @returns {undefined}
	 * @ngInject
	 */
	function CartConfig($stateProvider, ComponentLoaderEnums) {
		$stateProvider
			.state('cart', {
				abstract: true,
				components: [ ComponentLoaderEnums.paymentSchedule, ComponentLoaderEnums.quantity ],
				onExit: onCartExit,
				resolve: {
					initialData: initialData,
					loadAssets: loadAssets,
					checkSMSVerification: checkSMSVerification,
					resetCheckoutInfo: function(checkSMSVerification, CartDataService) {
						return CartDataService.updateCartCheckoutInfo(true);
					},
					cartSummary: function(resetCheckoutInfo, CartDataService) {
						return CartDataService.fetchCartSummary();
					},
					routeGuard: routeGuard,
					agreementGuard: agreementGuard,
					oneRiskGuard: oneRiskGuard,
					cleanUpPreviousPayment: cleanUpPreviousPayment,
				}
			})
			.state('cart.view', {
				url: '/cartView',
				templateUrl: '/scripts/modules/cart/templates/cart-view.html',
				controller: 'CartController'
			})
			.state('/cartView', {
				// Purely an alias to cart.view as some app configurations still might use the legacy route
				redirectTo: 'cart.view',
			});
	}

	/**
	 * Bootstraps the application
	 * @function
	 * @param {Service} Bootstrap - The Bootstrap service
	 * @returns {Promise} - resolve of our bootstrap process
	 * @ngInject
	 */
	function initialData($rootScope, Bootstrap, Language) {
		// PEC perceived-load prototype: render the cart-styled skeleton (not the default store
		// layout) while the cart bootstraps, so the guest sees a cart-shaped shell. Only takes
		// effect when the skeleton is enabled via ?skeleton; reset in the cart state's onExit
		// (see onCartExit below).
		$rootScope.skeletonVariant = 'cart';

		// Show a spinner with
		$rootScope.showSpinner(Language.getLocaleMerchant('CartView', 'CartLoading'));

		// Bootstrap the application
		return Bootstrap.bootstrapApplication(undefined, true);
	}

	/**
	 * Resets the skeleton variant to the default store layout when leaving the cart subtree,
	 * so other routes render their own skeleton. Counterpart to the variant set in initialData.
	 * @function
	 * @param {Service} $rootScope - The Angular root scope
	 * @returns {undefined}
	 * @ngInject
	 */
	function onCartExit($rootScope) {
		$rootScope.skeletonVariant = 'store';
	}

	/**
	 * Checks and loads the SMS Verification Config
	 * @function
	 * @param {Object} initialData - The initial data resolve
	 * @param {Service} Utilities - The Utilities Service
	 * @param {Service} SMSVerificationService - The SMSVerification Service
	 * @returns {Boolean} - resolve of our sms verification process
	 * @ngInject
	 */
	function checkSMSVerification(initialData, Utilities, SMSVerificationService) {
		if (SMSVerificationService.isSMSVerificationConfigured()) {
			return Utilities.cacheBustAndLazyLoad(['scripts/modules/sms-verification/controllers/sms-verification-modal-controller.js']);
		}
		return true;
	}

	/**
	 * Loads any assets that the cart requires
	 * @function
	 * @param {Object} initialData - The initial data resolve
	 * @param {Object} checkSMSVerification - The sms verification resolve
	 * @param {Service} BundleService - The Bundle Service
	 * @returns {Promise} - resolve of our asset loading process
	 * @ngInject
	 */
	function loadAssets(initialData, checkSMSVerification, BundleService) {
		return BundleService.lazyLoadCollectionFiles(BundleService.enums.CART);
	}

	/**
	 * Guards the route from being accessed when certain conditions are met
	 * @param {Promise} cartSummary - The cart summary resolve
	 * @param {Service} $transition$ - The ui-router transition service
	 * @param {Service} $rootScope - The ui-router transition service
	 * @param {Service} $q - The ui-router transition service
	 * @param {Service} CartErrorService - CartErrorService service
	 * @param {Service} Enums - Enums service
	 * @param {Service} Language - The Language service
	 * @param {Service} Modal - The Modal service
	 * @param {Service} Utilities - The Utilities service
	 * @param {Service} UtilsValidation - The UtilsValidation service
	 * @returns {Promise} - resolve of our route guard process
	 * @ngInject
	 */
	function routeGuard(cartSummary, $transition$, $rootScope, $q, CartErrorService, Enums, Language, Modal, Utilities, UtilsValidation) {
		if (cartSummary.info.hasError || cartSummary.status === Enums.status.FAILED) {
			// If we have a cart summary with item-level errors - we need to display an error like we do in the cart controller on update
			$rootScope.hideSpinner();
			CartErrorService.handleError(cartSummary.error ? cartSummary.error.code : null);
			$transition$.abort();
			return $q.reject()

		} else if (!UtilsValidation.validArray(cartSummary.cart.items)) {
			// Display a modal to the user
			$rootScope.hideSpinner();
			Modal.displayModal({
				category: 'Cart',
				title: Language.getLocaleMerchant('CartView', 'ModalEmptyCartTitle'),
				description: Language.getLocaleMerchant('CartView', 'ModalEmptyCartDescription'),
				view: Modal.SLIDEUP,
				showBottomBorder: true,
				showTopBorder: true,
			});

			$transition$.abort();
			Utilities.goTo('/');
			return $q.reject();
		}
	}

	/**
	 * Checks if there is any pre-cart routes that need to be navigated to before the cart can be accessed
	 * @param {Promise} routeGuard - The route guard resolve
	 * @param {Service} $transition$ - The ui-router transition service
	 */
	function agreementGuard(routeGuard, $transition$, AgreementService) {
		return AgreementService.routeGuard($transition$);
	}

	/**
	 * Checks to see if there are any 1Risk waivers that need to be shown
	 * @param {Promise} agreementGuard - The agreement guard resolve
	 * @param {Object} $transition$ - The ui-router transition instance
	 * @param {Service} CustomActionService - The Custom Action Service
	 * @param {Service} OneRiskService - The One Risk Service
	 * @returns {undefined}
	 * @ngInject
	 */
	function oneRiskGuard(agreementGuard, $transition$, CustomActionService, OneRiskService) {
		var riskWaiverEnum = CustomActionService.ACTIONS_ENUMS.CUSTOM_WAIVERS_BEFORE_CART;

		if (CustomActionService.actionRegistered(riskWaiverEnum) && OneRiskService.cartHasOneRiskPackages()) {
			CustomActionService.executeCustomAction(riskWaiverEnum, $transition$);
		}
	}

	/**
	 * Cleans up any previous payment data
	 * @param {Promise} oneRiskGuard - The one risk guard resolve
	 * @param {Service} UserInfo - The User Info Service
	 * @returns {undefined}
	 * @ngInject
	 */
	function cleanUpPreviousPayment(oneRiskGuard, UserInfo) {
		var payment = UserInfo.get('payment') || {},
			accessoPayPaymentDetailAttrs = ['isAccessoPayPayment', 'rawCardBrand', 'paymentProviderName', 'paymentMethodCode', 'paymentMerchantId', 'paymentReference', 'auth_id'];

			Object.keys(payment).forEach(function deletePaymentDetails(key) {
			if (payment.hasOwnProperty(key) && accessoPayPaymentDetailAttrs.includes(key)) {
				delete payment[key];
			}
		});

		UserInfo.set('payment', payment);
	}
})();
(function() {
	'use strict';

	angular
		.module('app')
		.factory('DataModelService', DataModelService);

	/**
	 * Handles converting data from the API into a specified data model
	 * @constructor
	 * @param {Service} $injector - The $injector service
	 * @param {Constant} DataModelEnums - The DataModelEnums constant
	 * @param {Service} DataModelEnumsService - The DataModelEnumsService service
	 * @param {Service} Utilities - The Utilities service
	 * @param {Service} UtilsValidation - The UtilsValidation service
	 * @returns {Object} - The service object
	 * @ngInject
	 */
	function DataModelService($injector, DataModelEnums, DataModelEnumsService, Utilities, UtilsValidation) {
		var UNSET_VALUE = Symbol();

		var checkProp = Utilities.checkProp,
			isNumeric = UtilsValidation.isNumeric,
			merge = Utilities.merge,
			toArray = Utilities.wrapObjectToArray,
			validArray = UtilsValidation.validArray,
			validObject = UtilsValidation.validObject,
			validString = UtilsValidation.validString;

		var service = {
			convert: convert,
			enums: DataModelEnums,
			_: {
				cast: _cast,
				findKeyByPattern: _findKeyByPattern,
				getReference: _getReference,
				getValue: _getValue,
				performSimpleMath: _performSimpleMath,
				retrieveValue: _retrieveValue
			}
		};

		return service;

		/***************************************
		 ** ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ **
		 ** ~ P R I V A T E ~ M E T H O D S ~ **
		 ** ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ **
		 ***************************************/

		 /**
		  * Casts a value to a specified type
		  * @private
		  * @param {*} value - The base value to cast
		  * @param {String} key - The cast key to use
		  * @param {Object} customCast - Key/Value list of custom cast functions
		  * @returns {*} - The casted value
		  */
		function _cast(value, key, customCast) {
			// Check to see if the key exists in the customCast object and is a function
			if (checkProp('customCast.' + key, customCast, angular.isFunction)) {
				return customCast[key](value);
			}

			// Otherwise, cast the value using the DataModelEnumsService cast method
			return DataModelEnumsService.cast(value, key);
		}

		/**
		 * searches a shallow data set for a key that matches a pattern
		 * @private
		 * @param {Object} data - The data object to search
		 * @param {RegExp} pattern - The pattern to match
		 * @returns {String|null} - The key that matches the pattern or null
		 */
		function _findKeyByPattern(data, pattern) {
			var key;

			// If pattern is not a RegExp object
			if (!(pattern instanceof RegExp)) {
				// Exit and return null
				return null;
			}

			// Iterate through the keys of the data object
			key = Object.keys(data).find(function iterateKeys(key) {
				// Return true if the key matches the pattern
				return pattern.test(key);
			});

			// if a valid key was found return it, otherwise return null
			return key || null;
		}

		/**
		 * Breaks apart a `$` value into a reference and model
		 * @private
		 * @param {String} ref - The reference string
		 * @returns {Object} - The reference object
		 */
		function _getReference(ref) {
			var $ = ref.split(':'),
				match = null,
				reference = {
					ref: $[0],
					optional: false,
				},
				// Matches the sort instructions on a reference e.g. 'ReferenceName(sortProperty|sortMethod)'
				sortRe = /^(.+)\((.*)\=(\w+)\)$/;

			// If the reference is optional
			if (/^\W*\?/.test(reference.ref)) {
				// Remove the '?' prefix and set the optional flag
				reference.ref = reference.ref.replace(/^\?/, '');
				reference.optional = true;
			}

			// If we have a sort instruction
			if (sortRe.test(reference.ref)) {
				// Grab the match
				match = reference.ref.match(sortRe);

				// Set the ref without the sort context and set the sort instructions
				merge(reference, {
					ref: match[1],
					sort: {
						property: match[2],
						method: match[3]
					}
				});
			}

			// If the reference has a designated model e.g. 'reference:ModelName' and the injector has the model
			if (validString($[1]) && $injector.has($[1])) {
				// Set the model to the reference
				reference.model = $injector.get($[1]);
			}

			// Return the reference object
			return reference;
		}

		/**
		 * Returns the value of a property from a data object
		 * @private
		 * @param {Object} data - The data object
		 * @param {String} path - The path to the desired property
		 * @returns {*|null} - The value of the property, otherwise null
		 */
		function _getValue(data, path) {
			return checkProp(path, data) ? checkProp(path, data, 'returnValue') : null;
		}

		/**
		 * Performs simple math on two values
		 * @private
		 * @param {Object} data - The data object
		 * @param {String} operator - The operator to use (+, -, *, /, <, >)
		 * @param {String} keyA - The key to use for the first value
		 * @param {String} keyB - The key to use for the second value
		 * @returns {Number|null} - The result of the math, otherwise null
		 */
		function _performSimpleMath(data, operator, keyA, keyB) {
			var a = parseFloat(service._.getValue(data, 'data.' + keyA)),
				b = isNumeric(keyB) ? parseFloat(keyB) : parseFloat(service._.getValue(data, 'data.' + keyB));

			if (Number.isNaN(a) || Number.isNaN(b)) {
				return null;
			}

			switch (operator) {
				case '+':
					return a + b;
				case '-':
					return a - b;
				case '*':
					return a * b;
				case '/':
					return b === 0 ? null : a / b;
				case '>':
					return a > b ? 1 : 0;
				case '<':
					return a < b ? 1 : 0;
				default:
					return null;
			}
		}

		/**
		 * Takes the data and modelValue and returns the value from the data
		 * @private
		 * @param {Object} data - The data object
		 * @param {String} modelValue - The model value instructions
		 * @param {Object} [customCast] - Key/Value list of custom cast functions
		 * @returns {*|null} - The value from the data, otherwise null if required, or UNSET_VALUE if optional
		 */
		function _retrieveValue(data, modelValue, customCast) {
			var forceCast = false,
				isOptional = false,
				keySets,
				recipe = modelValue.split(':');

			// '?' prefix, value is optional
			if (/^\W*\?/.test(recipe[0])) {
				// Set as optional and remove the '?' prefix
				isOptional = true;
				recipe[0] = recipe[0].replace(/\?/, '');
			}

			// '!' prefix, value is forced to be cast
			if (/^\W*\!/.test(recipe[0])) {
				// Set as forced cast and remove the '!' prefix
				forceCast = true;
				recipe[0] = recipe[0].replace(/\!/, '');
			}

			// Split the key sets, delimited by a pipe
			keySets = recipe[0].split('|');

			// Iterate through the key sets and grab the first valid value
			recipe[0] = keySets.reduce(function iterateKeySets(acc, keySet, i) {
				var isPatternValid = false;
				var patterns;
				var value;

				// If we already have a valid value, exit loop iteration
				if (acc !== null) {
					return acc;
				}

				// The keyset contains patterns
				if (/{{.*?}}/.test(keySet)) {
					// Grab all the patterns
					patterns = keySet.match(/{{(.*?)}}/g);

					// Replace the patterns with the values from the data, set is only valid if ALL patterns receive a valid value
					isPatternValid = patterns.every(function iteratePatterns(pattern) {
						// Remove the pattern enclosures
						var patternKey = new RegExp(pattern.replace(/{{|}}/g, ''), 'i');

						// Find the key that matches the pattern
						var key = service._.findKeyByPattern(data, patternKey);

						// If a valid key was found, replace the pattern with the value from the data
						if (key) {
							keySet = keySet.replace(pattern, service._.getValue(data, 'data.' + key));

							// Mark pattern as valid
							return true;
						}

						// Otherwise, mark pattern as invalid
						return false;
					});

					// If all patterns were valid
					if (isPatternValid) {
						// Cast it to the desired type
						return service._.cast(keySet, recipe[1], customCast);
					}
				// Does the keyset contain simple math?
				} else if (/^[\w.]+[*+\/\-<>]([\w.]+|\d+)$/.test(keySet)) {
					patterns = keySet.match(/^([\w.]+)([*+\/\-<>])((?:[\w.]+|\d+))$/);

					// Perform the simple math
					value = service._.performSimpleMath(data, patterns[2], patterns[1], patterns[3]);

					if (value !== null) {
						// Cast it to the desired type
						return service._.cast(value, recipe[1], customCast);
					}
				// Otherwise treat as a normal scenario if the property path exists
				} else if (checkProp('data.' + keySet, data) || (forceCast && keySets.length -1 === i)) {
					// Grab the value from the data
					value = service._.getValue(data, 'data.' + keySet);

					// Cast it to the desired type
					return service._.cast(value, recipe[1], customCast);
				}

				// No matches, return null
				return null;
			}, null);

			// If the modelValue yielded a valid value
			if (![null, undefined].includes(recipe[0])) {
				// Return the value
				return recipe[0];
			}

			// Otherwise return null if required, or UNSET_VALUE if optional
			return isOptional ? UNSET_VALUE : null;
		}

		/*************************************
		 ** ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ **
		 ** ~ P U B L I C ~ M E T H O D S ~ **
		 ** ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ **
		 *************************************/

		/**
		 * Converts the data into the specified model
		 * @public
		 * @param {Object} data - The data object
		 * @param {Object} model - The data model to transform the data into
		 * @param {Object} customCast - Key/Value list of custom cast functions
		 * @param {String} [prefix] - The prefix to use for the data object (Used for recursive calls)
		 * @returns {Object} - The converted data object
		 */
		function convert(data, model, customCast, prefix) {
			var $ = null,
				base = prefix || 'data',
				compiled = {},
				ref = base;

			// Did we receive a model reference that we need to inject?
			if (validString(model) && $injector.has(model)) {
				// If the model is a string, we need to retrieve the model from the injector
				model = $injector.get(model);
			}

			// '$' denotes that we should base this iteration off deeper part of the data object
			if (model.$ && validString(model.$)) {
				// A child model can be specified by using a colon after the sub reference
				$ = service._.getReference(model.$);

				// Check to see if the child model is a valid string and is a registered model
				if ($.model) {
					// Overwrite the model with the specified child model
					model = $.model;
				}

				// Set the reference to the deeper part of the data object
				ref = base + '.' + $.ref;
			}

			// Iterate through the model
			Object.entries(model).forEach(function iterateModel(entries) {
				var key = entries[0],
					formattedValue = UNSET_VALUE,
					isOptional = false,
					pathValue,
					value = angular.copy(entries[1]);

				// Skip the '$' key, will never yield any returned value to the data model object
				if (key === '$') {
					return;
				// If the value is a string, we need to retrieve the value from the data object
				} else if (validString(value)) {
					// Retrieve the value from the data object
					formattedValue = service._.retrieveValue(service._.getValue(data, ref), value, customCast);
				// If the value is an array, we need to iterate through the array and retrieve the values from the data object
				} else if (validArray(value)) {
					// Grab the reference and model
					$ = service._.getReference(value[0].$);

					// Set the reference to the deeper part of the data object
					pathValue = service._.getValue(data, ref + '.' + $.ref);

					// Set formattedValue to an empty array
					formattedValue = [];

					// Set the optional flag
					isOptional = $.optional;

					// If the pulled path is iterable
					if (validArray(pathValue) || validObject(pathValue)) {
						// Assemble the array with the formatted values
						toArray(pathValue, true).forEach(function iterateArray(item) {
							// Remove the '$' key from the value object, we don't want to pass this along to the next iteration
							delete value[0].$;

							// Use the `$` specified model, otherwise continue using the current model
							formattedValue.push(convert(item, $.model || value[0], customCast));
						});

						// We have instructions to sort the data
						if ($.sort) {
							// Sort the array
							formattedValue = DataModelEnumsService.sort(formattedValue, $.sort.property, $.sort.method);
						}
					}

					// If the array is optional and the formatted value is empty, set the formatted value to be removed
					if (isOptional && !formattedValue.length) {
						formattedValue = UNSET_VALUE;
					}
				// If the value is an object, we need to recursively call this function
				} else if (validObject(value)) {
					// Convert this layer of the data object
					formattedValue = convert(service._.getValue(data, ref), value, customCast);

					// If the formatted value is not a valid object, set the formattedVale to be removed
					if (!validObject(formattedValue)) {
						formattedValue = UNSET_VALUE;
					}
				}

				// If the formatted value is not UNSET_VALUE
				if (formattedValue !== UNSET_VALUE) {
					// Add it to the compiled object
					compiled[key] = formattedValue;
				}
			});

			// Return the compiled object
			return compiled;
		}
	}
})();
(function() {
	'use strict';

	angular
		.module('app')
		.factory('DataModelEnumsService', DataModelEnumsService)
		.constant('DataModelEnums', {
			hydrate: {
				CART_ADJUSTMENT: 'CartAdjustmentHydrateModel',
				CART_ITEM: 'CartItemHydrateModel',
				CART_ITEMS: 'CartItemsHydrateModel',
				PACKAGE_PLANNER_CART: 'PackagePlannerCartHydrateModel',
				PAYMENT_SUMMARY: 'PaymentSummaryHydrateModel',
			},
			model: {
				CART_ITEM: 'CartItemModel',
				DISPLAY_CHARACS: 'DisplayCharacsModel',
				GET_CART_SUMMARY: 'GetCartSummaryModel',
				GET_KEYWORD_CALENDAR: 'GetKeywordCalendarModel',
				GET_MERCHANT_PACKAGE_EVENT_DATES: 'GetMerchantPackageEventDatesModel',
				GET_MPCT_CALENDAR: 'GetMPCTCalendarModel',
				GET_WIZARD_MP_EVENT_DATES: 'GetWizardMpEventDatesModel',
				MEMBERSHIP: 'MembershipModel',
				PACKAGE_PLANNER_LEGACY_CONFIG_CONVERSION: 'PackagePlannerLegacyConfigConversionModel',
				PAYMENT_SCHEDULE: 'PaymentScheduleModel',
			},
		});

	/**
	 * Enums for the DataModelService
	 * @constructor
	 * @param {Service} $log - The logging service
	 * @param {Service} Utilities - The utilities service
	 * @param {Service} UtilsValidation - The UtilsValidation service
	 * @returns {Object} - The service object
	 * @ngInject
	 */
	function DataModelEnumsService($log, Utilities, UtilsValidation) {
		var first = Utilities.first,
			forceInt = Utilities.forceInt,
			getBoolean = Utilities.getBoolean,
			getString = Utilities.getString,
			getFormattedTime = Utilities.getFormattedTime,
			isDateString = UtilsValidation.isDateString,
			sortArray = Utilities.sortArray,
			timeAsMinutes = Utilities.timeAsMinutes,
			toArray = Utilities.wrapObjectToArray,
			toDate = Utilities.dateStringToObject,
			toSqlDate = Utilities.javascriptDateToSQLDate,
			validObject = UtilsValidation.validObject;

		var service = {
			cast: cast,
			register: register,
			sort: sort,
			_: {
				customCast: {},

				isRegistered: _isRegistered,
			},
		};

		/***************************************
		 ** ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ **
		 ** ~ P R I V A T E ~ M E T H O D S ~ **
		 ** ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ **
		 ***************************************/

		/**
		 * Determines if a custom cast method is registered
		 * @private
		 * @param {String} key - The key to check
		 * @returns {Boolean} - True if the key is registered
		 */
		function _isRegistered(key) {
			return !!service._.customCast[key];
		}

		/*************************************
		 ** ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ **
		 ** ~ P U B L I C ~ M E T H O D S ~ **
		 ** ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ **
		 *************************************/

		/**
		 * Casts a value to a specified type
		 * @public
		 * @param {*} value - The value to cast
		 * @param {String} type - The type to cast the value to
		 * @returns {*} - The casted value
		 */
		function cast(value, type) {
			var searchType = getString(type).toLowerCase();

			switch (searchType) {
				case 'array':
					return toArray(value, true);
				case 'boolean':
					return getBoolean(value);
				case 'currency':
					// e.g. 1234.2 -> '1234.20'
					return service.cast(value, 'float').toFixed(2);
				case 'date':
					return isDateString(value)
						? toDate(value)
						: (Number.isNaN(new Date(value).valueOf()) ? new Date() : new Date(value));
				case 'datestring':
					return toSqlDate(value);
				case 'float':
					return value === undefined ? 0 : parseFloat(+value);
				case 'floatcurrency':
					// e.g. '1234.2000000000034' -> 1234.2
					return parseFloat(service.cast(value, 'currency'));
				case 'floatstring':
					return value === undefined ? '0' : getString(parseFloat(+value));
				case 'int':
					return value === undefined ? 0 : parseInt(+value, 10);
				case 'intarray':
					return value === undefined ? 0 : value.split(',').map(forceInt);
				case 'intstring':
					return value === undefined ? '0' : getString(parseInt(+value, 10));
				case 'invboolean':
					return !getBoolean(value);
				case 'minutes':
					return timeAsMinutes(value);
				case 'object':
					return Object(first(value));
				case 'string':
					return getString(value);
				case 'time':
					return getFormattedTime(value);
				case 'timemilitary':
					return getFormattedTime(value, true);
				case 'timestandard':
					return getFormattedTime(value, false);
				case '*':
					return value;
			}

			// If a custom cast method is registered, use it
			if (service._.isRegistered(searchType)) {
				return service._.customCast[searchType](value);
			}

			// If the type is not recognized, return null
			return null;

		}

		/**
		 * Registers a custom cast methods
		 * @public
		 * @usage [key, value] register('key', function(value) { return value; });
		 * @usage {key: value, ...} register({ key: function(value) { return value; } });
		 * @returns {undefined}
		 */
		function register() {
			// Object for key/value pairs was passed in
			if (arguments.length === 1 && validObject(arguments[0])) {
				// Iteratee over each key/valuye set
				Object.entries(arguments[0]).forEach(function(entry) {
					// Call the closure function
					$addToCustomCast(entry[0], entry[1])
				});

				// Exit
				return;
			}

			// Expecting key, value as arguments
			$addToCustomCast.apply(this, arguments);

			// Closure function
			function $addToCustomCast(key, value) {
				// Key MUST be all lowercase letters only
				if (!/^[a-z_]+$/.test(key)) {
					$log.error('DataModelEnumsService.register: Key must be lowercase letters / underscores only: ' + key);
				// Is the key already registered?
				} else if (service._.customCast[key]) {
					$log.error('DataModelEnumsService.register: Key already exists: ' + key);
				// Is the value a function?
				} else if (angular.isFunction(value)) {
					service._.customCast[key] = value;
				// Value is not a function
				} else {
					$log.error('DataModelEnumsService.register: Assignment for "' + key + '" must be a function');
				}
			}
		}

		/**
		 * Sorts a array type property in the model
		 * @public
		 * @param {*[]} data - The data to sort
		 * @param {String} key - The key to sort by
		 * @param {String} type - The type of sort
		 * @returns {*[]} - The sorted data
		 */
		function sort(data, key, type) {
			switch (getString(type).toLowerCase()) {
				case 'asc':
					return sortArray(data, key);
				case 'desc':
					return sortArray(data, key, true);
				default:
					return data;
			}
		}

		return service;
	}
})();
(function() {
	'use strict';

	angular
		.module('cart')
		.controller('PaymentMethodController', PaymentMethodController);


	/**
	 * The Payment Method Controller
	 * @constructor
	 * @param {Service} $location - The Angular location service
	 * @param {Scope} $rootScope - The Angular root scope object
	 * @param {Scope} $scope - The Angular scope object
	 * @param {Service} AppData - The app data service
	 * @param {Service} BillingService - The billing service
	 * @param {Service} CustomActionService - The custom action service
	 * @param {Service} Enums - The enums service
	 * @param {Service} JSONValidator - The JSON validator service
	 * @param {Service} LegacyCart - The legacy cart service
	 * @param {Service} Language - The language service
	 * @param {Service} PaymentService - The payment service
	 * @param {Service} StoredPaymentPrepService - The stored payment service
	 * @param {Service} StringUtils - The string utilities service
	 * @param {Service} Storage - The storage service
	 * @param {Service} UserInfo - The user info service
	 * @param {Service} Utilities - The utilities service
	 * @param {Service} UtilsValidation - The validation service
	 * @returns {undefined}
	 * @ngInject
	 */
	function PaymentMethodController(
		$location,
		$rootScope,
		$scope,
		AppData,
		BillingService,
		CustomActionService,
		Enums,
		JSONValidator,
		LegacyCart,
		Language,
		PaymentService,
		StoredPaymentPrepService,
		StringUtils,
		Storage,
		UserInfo,
		Utilities,
		UtilsValidation
	) {
		var vm = this;

		var getString = Utilities.getString,
			merge = Utilities.merge,
			normalize = StringUtils.normalize,
			validArray = UtilsValidation.validArray,
			validString = UtilsValidation.validString;

		merge(vm, {
			$onInit: $onInit,
			_: {
				filterWalletPayments: _filterWalletPayments,
				finalizePaymentMethodSelected: _finalizePaymentMethodSelected,
				getCustomPaymentMethodConfig: _getCustomPaymentMethodConfig,
				getRegisteredBillingProviderType: _getRegisteredBillingProviderType,
				partialPayments: [],
				restrictedPaymentMethodName: BillingService.getRestrictedPaymentMethodOrBillingProviderNameForCart(),
				setupBillingTypes: _setupBillingTypes,
			}
		});

		merge($scope, {
			billingProviders: BillingService.getBillingProvidersForCart(),
			cardTypes: LegacyCart.getCardTypesToDisplay(),
			disablePayMethodOrProviderForRestrictedCart: disablePayMethodOrProviderForRestrictedCart,
			handlePayMethSelected: handlePayMethSelected,
			hasGiftCardPaymentMethodConfigured: BillingService.shouldPresentGiftCardOption(),
			hideCreditCardPaymentOption: hideCreditCardPaymentOption,
			idealEnabled: false,
			mrcashEnabled: false,
			paymentMethodSelected: UserInfo.payment.type,
			selectingPaymentMethod: selectingPaymentMethod,
			storedPaymentsConfigured: StoredPaymentPrepService.storedPaymentsIsConfigured(),
			storedPaymentType: Enums.paymentProvider.STOREDPAYMENTS,
			useDefaultStoredPaymentFunctionality: !validString($location.search().sfOffer),
			validCardTypeList: BillingService.getValidCardTypesList(true),
		});

		/***************************************
		 ** ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ **
		 ** ~ L I F E C Y C L E ~ H O O K S ~ **
		 ** ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ **
		 ***************************************/

		function $onInit() {
			merge(vm._, {
				partialPayments: UserInfo.get('partialPayments'),
			});

			merge($scope, {
				ccImageOverride: AppData.settings.cc_image_override,
				configuredCCImage: AppData.settings.configured_cc_image,
				customPaymentMethodConfig: vm._.getCustomPaymentMethodConfig(),
				overrideCCLabel: AppData.settings.override_credit_card_label_target ? Language.getLocaleMerchant('PaymentMethodView', AppData.settings.override_credit_card_label_target) : undefined,
				paymentMethodTypes: 0,
				registeredPaymentMethods: BillingService.getRegisteredPaymentMethods().filter(vm._.filterWalletPayments),
			});

			vm._.setupBillingTypes();
		}

		/***************************************
		 ** ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ **
		 ** ~ P R I V A T E ~ M E T H O D S ~ **
		 ** ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ **
		 ***************************************/

		/**
		 * Filters registered payments if the cart has agreeements
		 * @public
		 * @param {Object[]} payment registered payment
		 * @returns {Boolean} filtered payment
		 */
		function _filterWalletPayments(payment) {
			if (!$scope.cartHasAgreements) {
				return true;
			}

			return ![
				normalize(Enums.billingProviders.CYBERSOURCE_APPLEPAY),
				normalize(Enums.billingProviders.CYBERSOURCE_GOOGLEPAY),
				normalize(Enums.billingProviders.ADYEN_GOOGLEPAY),
				normalize(Enums.billingProviders.ADYEN_APPLEPAY)
			].includes(normalize(payment.methodName));
		}

		/**
		 * Handles finalizing the payment method and storing payment info and billing type info
		 * @public
		 * @param {String} type payment provider type
		 * @returns {undefined}
		 */
		function _finalizePaymentMethodSelected(type) {
			var billingType;
			var _data;

			merge(UserInfo.payment, {
				type: type,
				authType: BillingService.getMatchingAuthTypeForPaymentProvider(type)
			});

			if (UserInfo.payment.authType != Enums.billingTypes.CREDITCARD) {
				for (var i in AppData.billingTypes) {
					if (
						AppData.billingTypes[i].auth_type == UserInfo.payment.authType
						&& !CustomActionService.executeCustomAction(CustomActionService.ACTIONS_ENUMS.PAYMENT_METHOD_BY_BILLINGTYPE, null, [UserInfo.payment.type, AppData.billingTypes[i]])
					) {
						billingType = AppData.billingTypes[i];

						_data = {
							auth_type: billingType.auth_type,
							billing_type: billingType.billing_type,
							card_type_code: billingType.card_type_code,
							category_desc: billingType.category_desc,
							category_id: billingType.category_id,
							cepay_merchant_id: billingType.cepay_merchant_id,
							name: billingType.name,
							type: UserInfo.payment.type,
							visible: UserInfo.payment.visible
						};

						if (billingType.merchant_payment_type_ref_id) {
							merge(_data, {
								merchant_payment_type_ref_id: billingType.merchant_payment_type_ref_id,
								pt_description: billingType.pt_description,
								credit_card_type_id: billingType.credit_card_type_id,
								payment_type_id: billingType.payment_type_id,
								ect_description: billingType.ect_description
							});
						} else {
							_data.billing_id = billingType.billing_id;
						}

						Storage.set('_billingType', _data);
						UserInfo.set('billingType', _data)
						break;
					}
				}
			} else {
				_data = {
					type: UserInfo.payment.type,
					auth_type: UserInfo.payment.authType
				};

				AppData.Storage.remove('_billingType');
			}

			UserInfo.set('payment', UserInfo.payment);
		}

		/**
		 * Get the Custom Payment Method config, or undefined if not set
		 * @private
		 * @returns {Object|undefined} The Custom Payment Method config, or undefined if not set
		 */
		function _getCustomPaymentMethodConfig() {
			var config;

			if (JSONValidator.validate('customPaymentMethod', AppData.settings.customPaymentMethod)) {
				config = JSON.parse(AppData.settings.customPaymentMethod);

				merge(config, {
					imagePath: $rootScope.getAssetUrl(config.image),
					label: Language.getLocaleMerchant('CustomPaymentMethod', 'label'),
					imageText: Language.getLocaleMerchant('CustomPaymentMethod', 'imageText')
				});
			}

			return config;
		}

		/**
		 * Gets Registered billing providers type
		 * @private
		 * @param {String} type - billing provider type
		 * @returns {String} - billing provider type
		 */
		function _getRegisteredBillingProviderType(type) {
			var billingProviderType = getString(LegacyCart.getBillingProviderByItems()).toLowerCase();

			if (BillingService.getRegisteredPaymentMethodByName(billingProviderType)) {
				return billingProviderType;
			}

			return type;
		}

		function _setupBillingTypes() {
			$scope.paymentMethodTypes = $scope.billingProviders.length + +validArray($scope.cardTypes);

			for (var i in AppData.billingTypes) {
				if (AppData.billingTypes[i].auth_type == Enums.billingTypes.IDEAL && !$scope.disablePayMethodOrProviderForRestrictedCart(Enums.billingTypes.IDEAL) && AppData.settings.adyen) {
				// TODO: Check for local storage
					$scope.paymentMethodTypes++;
					$scope.idealEnabled = true;
				}
				if (AppData.billingTypes[i].auth_type === Enums.authTypes.MISTERCASH && AppData.billingTypes[i].billing_type === Enums.billingTypes.MISTERCASH && !$scope.disablePayMethodOrProviderForRestrictedCart(Enums.billingTypes.MISTERCASH)) {
				// TODO: Check for local storage
					$scope.paymentMethodTypes++;
					$scope.mrcashEnabled = true;
				}

				//Ensure that we are incrementing paymentMethodTypes for dynamic displayed billing types for correct visual centering
				for (var j = 0; j < $scope.registeredPaymentMethods.length; j++) {
					if (AppData.billingTypes[i].auth_type == $scope.registeredPaymentMethods[j].authType && !$scope.disablePayMethodOrProviderForRestrictedCart(AppData.billingTypes[i].auth_type)) {
						$scope.paymentMethodTypes++;
					}
				}
			}
		}

		/*************************************
		 ** ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ **
		 ** ~ P U B L I C ~ M E T H O D S ~ **
		 ** ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ **
		 *************************************/

		/**
		 * Should disable due to restricted payment method or provider on cart
		 */
		function disablePayMethodOrProviderForRestrictedCart(methodOrProviderName) {
			var disable = false;

			if (validString(methodOrProviderName) && validString(vm._.restrictedPaymentMethodName)) {
				disable = vm._.restrictedPaymentMethodName.toLowerCase() !== methodOrProviderName.toLowerCase();
			}

			if (LegacyCart.checkForDeferredPayment() && !disable) {
				disable = BillingService.paymentMethodThatDoesNotSupportDeferredPayments(methodOrProviderName);
			}

			if (!disable && validArray(vm._.partialPayments)) {
				//if we currently have partial payments applied to our cart, we must ONLY enable the payment methods that support partial payments
				//right now this is only for CC but was coded to potentially support more in the future
				disable = !BillingService.doesPaymentMethodOrProviderSupportPartialPayments(methodOrProviderName);
			}


			return disable;
		};

		/**
		 * Handles selecting the payment method and storing payment info and billing type info
		 * @public
		 * @param {String} type Payment method provider type
		 * @returns {undefined}
		 */
		function handlePayMethSelected(type) {
			var billingProviderType = vm._.getRegisteredBillingProviderType(type);

			$scope.paymentMethodSelected = getString(billingProviderType).toLowerCase();

			if (type !== 'custom') {
				vm._.finalizePaymentMethodSelected($scope.paymentMethodSelected);
			}
		}

		/**
		 * Hide Credit Card payment option if there is only a single card type
		 * and the card type is set as custom payment method(sponsored card)
		 * @public
		 * @param {Object[]} cardTypes card types
		 * @returns {Boolean} hide if true
		 */
		function hideCreditCardPaymentOption(cardTypes) {
			if (cardTypes.length > 1 || !$scope.customPaymentMethodConfig) {
				return false;
			}

			return cardTypes.length === 1 && normalize($scope.customPaymentMethodConfig.subType) === normalize(cardTypes[0].name);
		}

		/**
		 * This is the function that gets called when they click "Continue" after selecting a payment method.
		 * @public
		 * @function
		 * @name selectingPaymentMethod
		 * @param {Boolean} replaceState Should we replace the current state?
		 * @return {undefined}
		 */
		function selectingPaymentMethod(replaceState) {
			var alternatePaymentAction,
				customWasSelected = false;

			if ($scope.customPaymentMethodConfig && $scope.paymentMethodSelected === 'custom') {
				customWasSelected = true;
				$scope.paymentMethodSelected = $scope.customPaymentMethodConfig.type;
				vm._.finalizePaymentMethodSelected($scope.paymentMethodSelected);
			}

			alternatePaymentAction = PaymentService.getAlternatePaymentAction($scope.paymentMethodSelected);

			// Since they are continuing, trigger the payment method selection GTM event.
			if (validString($scope.paymentMethodSelected)) {
				$rootScope.$broadcast('triggerPaymentSelection', $scope.paymentMethodSelected);
			}

			if (angular.isDefined(alternatePaymentAction)) {
				alternatePaymentAction.doAction();
			} else {
				if (BillingService.billingRoutePaymentProviders.indexOf($scope.paymentMethodSelected) > -1) {
				// A hack needed to keep the custom field selected in the circumstance of overriding cards instead of entire payment methods.
					if (customWasSelected) {
						$scope.paymentMethodSelected = 'custom';
					}

					$scope.routeTo(Enums.routes.BILLING, undefined, undefined, replaceState);
				}
			}
		};

	}
})();
(function() {
	'use strict';

	angular
		.module('cart')
		.controller('OrderReviewController', OrderReviewController);

	/**
	 * The order review controller
	 * @constructor
	 * @param {Service} $filter - The $filter service
	 * @param {Scope} $rootScope - The angular $rootScope object
	 * @param {Scope} $scope - The angular $scope object
	 * @param {Service} AppData - The app data service
	 * @param {Service} PaymentTypeService The service
	 * @param {Service} BillingService - The billing service
	 * @param {Service} CartDataService - The cart data service
	 * @param {Service} CartService - The cart service
	 * @param {Service} CreditCardBinRangesService - The credit card bin ranges service
	 * @param {Service} CustomActionService - The custom action service
	 * @param {Service} Enums - The enums service
	 * @param {Service} FolioService - The folio service
	 * @param {Service} Language - The language service
	 * @param {Service} LegacyCart - The legacy cart service
	 * @param {Service} Modal - The Modal Service
	 * @param {Service} OrderService - The order service
	 * @param {Service} Purchase - The purchase service
	 * @param {Service} Storage - The storage service
	 * @param {Service} StringUtils - The string utils service
	 * @param {Service} Ticket - The ticket service
	 * @param {Service} UserInfo - The user info service
	 * @param {Service} Utilities - The utilities service
	 * @param {Service} UtilsPricing - The utils pricing service
	 * @param {Service} UtilsValidation - The utils validation service
	 * @param {Service} Viewport - The viewport service
	 * @returns {undefined}
	 * @ngInject
	 */
	function OrderReviewController(
		$filter,
		$rootScope,
		$scope,
		AppData,
		PaymentTypeService,
		BillingService,
		CartDataService,
		CartService,
		CreditCardBinRangesService,
		CustomActionService,
		Enums,
		FolioService,
		Language,
		LegacyCart,
		Modal,
		OrderService,
		Purchase,
		Storage,
		StringUtils,
		Ticket,
		UserInfo,
		Utilities,
		UtilsPricing,
		UtilsValidation,
		Viewport
	) {
		var vm = this;

		var checkProp = Utilities.checkProp,
			getBoolean = Utilities.getBoolean,
			merge = Utilities.merge,
			normalize = StringUtils.normalize,
			validArray = UtilsValidation.validArray,
			validNumber = UtilsValidation.validNumber;

		merge(vm, {
			$onInit: $onInit,
			_: {
				executePurchase: _executePurchase,
				folioItemInCart: _folioItemInCart,
				getPaymentDetails: _getPaymentDetails,
				partialPayments: [],
				paymentType: null,
				setPriceLabels: _setPriceLabels,
				viewReceipt: _viewReceipt,
			}
		});

		merge($scope, {
			billing: UserInfo.billing || {},
			cartSummary: CartDataService.getLastSummary(),
			changeQty: false,
			completeOrder: completeOrder,
			displayMemberships: false,
			displayPaymentSchedule: false,
			editPayment: editPayment,
			editShipping: editShipping,
			extraCardLastFour: null,
			getOnlineSavingsPercent: getOnlineSavingsPercent,
			getRemainingCartTotalLessPartialPmts: getRemainingCartTotalLessPartialPmts,
			hasDeliveryMethods: validArray(UserInfo.deliveryMethods) || Storage.get('_deliveryMethods'),
			hasMemberships: false,
			heading: Language.getLocaleMerchant('CartView', 'orderReviewHeading'),
			hideAllAddressFields: false,
			hideCardPanelFooter: false,
			isPaymentSchedule: false,
			LegacyCart: LegacyCart,
			memberships: {},
			orderReviewBillingProviderImg: orderReviewBillingProviderImg,
			payment: {},
			PaymentSchedule: {},
			paymentScheduleBtnLabel: Language.getLocale('PaymentSchedule', 'show'),
			purchaseButtonLabel: Language.getLocaleMerchant('ButtonLabels', 'purchase'),
			purchaseReceipt: AppData.purchaseReceipt,
			shipping: UserInfo.shipping || {},
			showAlternatePaymentSummary: showAlternatePaymentSummary,
			showBilling: false,
			showPayPalPaymentMethod: false,
			showPayment: false,
			showResellerInfo: false,
			showSpritePaymentType: false,
			showZipField: false,
			toggleMemberships: toggleMemberships,
			togglePaymentSchedule: togglePaymentSchedule,
			viewport: Viewport.api
		});

		/***************************************
		 ** ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ **
		 ** ~ L I F E C Y C L E ~ H O O K S ~ **
		 ** ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ **
		 ***************************************/

		/**
		 * Initialize the controller
		 * @lifecycle
		 * @returns {undefined}
		 */
		function $onInit() {
			var billingDetails;
			var dynamicPurchaseButtonLocale = 'purchase' + UserInfo.payment.authType;

			vm._.paymentType = checkProp('UserInfo.payment.type', UserInfo, 'returnValue');

			if (CustomActionService.executeCustomAction(CustomActionService.ACTIONS_ENUMS.RESELLER_SKIP_STEP, 'order_review')) {
				$rootScope.showSpinner();
				$scope.completeOrder();
				return;
			}

			merge(vm._, {
				cartConfig: CartService.getConfig(),
				partialPayments: UserInfo.get('partialPayments'),
			});

			merge($scope, {
				cartSummaryLabel: Language.getLocaleMerchant((vm._.folioItemInCart() ? 'FolioLabels' : 'CartView'), 'cartSummary'),
				condenseTaxesAndFeesEnabled: vm._.cartConfig.taxes_and_fees.condense,
			});

			vm._.setPriceLabels();

			if (validArray($scope.cartSummary.cart.items)) {
				$scope.cartSummary.cart.items = $filter('ignoreOneBarcodeAddons')($scope.cartSummary.cart.items);
			}

			// if there is a purchase button locale that is specific to the selected authType, use it.
			if (Language.localeExistsMerchant('ButtonLabels', dynamicPurchaseButtonLocale)) {
				$scope.purchaseButtonLabel = Language.getLocaleMerchant('ButtonLabels', dynamicPurchaseButtonLocale);
			}

			/*
			 * When selecting Paypal, the user will bypass the billing view and these analytic events will not be fired.
			 * We can check the payment type and fire them here, on the Order Review.
			 */
			if (vm._.paymentType == Enums.paymentProvider.PAYPAL) {
				$rootScope.$broadcast('triggerCheckoutBilling', $scope.shipping.deliveryMethod);
				$rootScope.$broadcast('triggerCheckoutPaymentInfo', UserInfo.payment.authType, $scope.billing);
			}

			$rootScope.$broadcast('triggerCheckoutOrderReview', $scope.payment.ccType);

			vm._.getPaymentDetails();

			if (UserInfo.shippingRequired() && !$scope.shipping.valid && !$scope.shipping.isNonPhysicalDeliveryMethod) {
				// No shipping information. Alert and take user back to the shipping screen.
				Modal.displayModal(
					{
						category: 'Shipping [Cart]',
						action: 'Error',
						label: 'Missing Shipping',
						title: Language.getLocaleMerchant('Alert', 'shippingInfoNotSetTitle'),
						description: Language.getLocaleMerchant('Alert', 'shippingInfoNotSetMsg'),
						hideAllButtons: false
					}
				);

				$scope.routeTo(Enums.routes.SHIPPING);
				return;
			} else if (!$scope.billing || !$scope.billing.valid) {
				// No billing information. Alert and take user back to the billing screen.
				Modal.displayModal(
					{
						category: 'Billing [Cart]',
						action: 'Error',
						label: 'Missing Billing',
						title: Language.getLocaleMerchant('Alert', 'billingInfoNotSetTitle'),
						description: Language.getLocaleMerchant('Alert', 'billingInfoNotSetMsg'),
						hideAllButtons: false
					}
				);

				$scope.routeTo(Enums.routes.BILLING);
				return;
			} else if (vm._.paymentType == 'cc' && !UserInfo.payment.valid && !validArray(UserInfo.partialPayments)) {
			//if you are in development, dont route the user
				if ($rootScope.autofill && UserInfo.payment.valid === undefined) {
					UserInfo.payment.valid = true;
				} else {
				// No payment information. Alert and take user back to the payment screen.
					Modal.displayModal(
						{
							category: 'Payment [Cart]',
							action: 'Error',
							label: 'Missing Payment',
							title: Language.getLocaleMerchant('Alert', 'paymentInfoNotSetTitle'),
							description: Language.getLocaleMerchant('Alert', 'paymentInfoNotSetMsg'),
							hideAllButtons: false
						}
					);

					$scope.routeTo(Enums.routes.BILLING);
					return;
				}
			} else if (vm._.paymentType == Enums.paymentProvider.PAYPAL) {
				// Paypal.
				merge($scope, {
					showBilling: UserInfo.billing,
					showPayment: UserInfo.payment,
					showSpritePaymentType: false,
					showPayPalPaymentMethod: true,
				});

				if (UserInfo.payment.merchant_payment_type_ref_id) {
					billingDetails = LegacyCart.getBillingDetailsMerchantPaymentTypeRef(AppData.GetMerchantDetails, UserInfo.payment.merchant_payment_type_ref_id);
				} else {
					billingDetails = LegacyCart.getBillingDetailsById(AppData.GetMerchantDetails, UserInfo.payment.billingId);
				}

				if (angular.isDefined(UserInfo.payment.authType) && UserInfo.payment.authType === Enums.billingTypes.PAYPAL) {
					$scope.showPayPalPaymentMethod = true;
					$scope.showSpritePaymentType = UserInfo.payment.authType.toString().toLowerCase();
				} else if (validString(UserInfo.payment.billingId) || validString(UserInfo.payment.merchant_payment_type_ref_id)) {
					$scope.showSpritePaymentType = ((billingDetails || {}).card_type_code || '').toString().toLowerCase();
				}
			} else if (vm._.paymentType === Enums.paymentProvider.ACCOUNT) {
				merge($scope, {
					arrowPositioning: $scope.shipping.hasDeliveryMethods ? 2 : 1,
					hasDeliveryMethods: $scope.shipping.hasDeliveryMethods,
					hideAllAddressFields: true,
					showZipField: UserInfo.billing.showZipField,
					showResellerInfo: true,
					hideCardPanelFooter: true,
				});
			} else if (vm._.paymentType === Enums.paymentProvider.STOREDPAYMENTS) {
				merge($scope, {
					showBilling: UserInfo.billing,
					showPayment: UserInfo.payment,
					showSpritePaymentType: false,
					showPayPalPaymentMethod: false,
				});

				$scope.billing.showLastFour = true;
			} else {
				if (BillingService.hideAddressFieldsCheck(UserInfo.payment.authType)) {
					$scope.hideAllAddressFields = true;
				}
			}
		}

		/***************************************
		 ** ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ **
		 ** ~ P R I V A T E ~ M E T H O D S ~ **
		 ** ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ **
		 ***************************************/

		/**
		 * Executes the purchase
		 * @private
		 * @returns {undefined}
		 */
		function _executePurchase() {
			Purchase.executePurchase(vm._.viewReceipt);
		}

		/**
		 * Find membership upgrade folio item on cart using folio_id property under item's characs
		 * @private
		 * @returns {Boolean} is folio item on cart?
		 */
		function _folioItemInCart() {
			if (FolioService.membershipUpgrade) {
				return false;
			}

			return $scope.cartSummary.cart.items.some(function iterateCartItems(item) {
				return item.characs.some(function iterateCharacs(charac) {
					return charac.hasOwnProperty('folio_id');
				});
			});
		}

		/**
		 * Get the payment details
		 * @private
		 * @returns {undefined}
		 */
		function _getPaymentDetails() {
			var billingType,
				ccTypeNormalized;

			if (checkProp('UserInfo.payment.ccType', UserInfo)) {
				$scope.payment = UserInfo.payment;

				if (angular.isUndefined(UserInfo.payment.ccTypeDisplayAlias)) {
					UserInfo.payment.ccTypeDisplayAlias = UserInfo.payment.ccType;
				}

				if ($scope.payment.authType === Enums.billingTypes.CREDITCARD) {
					billingType = PaymentTypeService.getById(AppData, $scope.payment.merchant_payment_type_ref_id);

					if (billingType) {
						CreditCardBinRangesService.appendCardImageByBinRanges(billingType, $scope.payment);
					}
				} else {
					ccTypeNormalized = normalize($scope.payment.ccType);
					billingType = AppData.billingTypes
						.filter(PaymentTypeService.isPaymentType)
						.find(function(type) {
							return normalize(type.name) === ccTypeNormalized;
						});

					if (billingType) {
						CreditCardBinRangesService.appendCardImageByBinRanges(billingType, $scope.payment);
					}
				}
			} else {
				//load from localstorage
				$scope.payment = {};
			}

			$scope.partialPayments = UserInfo.get('partialPayments');
			$scope.disableRemovePartialPayments = BillingService.is3DSecureEnabled($scope.payment);
			$scope.extraCardLastFour = null;

			//AlternatePaymentSummary will be shown if additionalPaymentData exists with account number
			if (checkProp('UserInfo.additionalPaymentData.accountNumber', UserInfo)) {
				$scope.extraCardLastFour = UserInfo.additionalPaymentData.accountNumber.slice(-4);
			}

			if (BillingService.getRegisteredPaymentMethodByName(vm._.paymentType)) {
				$scope.payment.customIcon = BillingService.getRegisteredPaymentMethodByName(vm._.paymentType).customIcon;
			}
		}

		function _setPriceLabels() {
			$scope.cartSummary.cart.items.forEach(function iterateItems(item) {
				var displayPrice = UtilsPricing.getPrice(item.pricing.retail, item.pricing.tax, item.pricing.fee);
				var price = $filter('currencyFormatter')((displayPrice * item.info.qty));

				if (typeof price !== 'string' && Number.isNaN(price)) {
					return;
				}

				item.pricing.priceLabel = price;

				if (checkProp('item.paymentPlan.type', item, 'returnValue') === 'MEM' && item.paymentPlan.id) {
					item.pricing.priceLabel = item.pricing.priceLabel + ' ' + Language.getLocaleMerchant('CartView', 'perMonthLabel');
				}

				if (getBoolean(AppData.settings.tax_amount_denoted) && item.pricing.tax > 0) {
					var newPrice = $filter('currencyFormatter')(displayPrice * item.info.qty);
					item.pricing.priceLabel = newPrice + '*';
					item.pricing.taxLabel = $filter('currencyFormatter')((item.pricing.tax * item.info.qty));
					item.pricing.showTax = true;
				}

				item.pricing.priceLabel = Utilities.escapeHtmlEntities(item.pricing.priceLabel);
				item.pricing.taxLabel = Utilities.escapeHtmlEntities(item.pricing.taxLabel);
			});
		}

		/**
		 * View the receipt
		 * @private
		 * @param {Object} data - The receipt data
		 * @returns {undefined}
		 */
		function _viewReceipt(data) {
			if (data) {
				$scope.purchaseReceipt = data;
			}

			OrderService.clear();

			merge(OrderService, {
				phoneNumber: $scope.purchaseReceipt.phoneNumber,
				lastFour: $scope.purchaseReceipt.lastFour,
				orderID: $scope.purchaseReceipt.orderId,
				email: $scope.purchaseReceipt.emailAddress,
				customerID: $scope.purchaseReceipt.customerId,
			});

			OrderService.createToken(AppData.GuestViewOrder.VIEW_ORDER_REPLY);

			merge(OrderService, {
				cToken: $scope.purchaseReceipt.cToken,
				eToken: $scope.purchaseReceipt.eToken,
				oToken: $scope.purchaseReceipt.oToken,
				pToken: $scope.purchaseReceipt.pToken,
			});

			Ticket.determineState();
		}

		/*************************************
		 ** ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ **
		 ** ~ P U B L I C ~ M E T H O D S ~ **
		 ** ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ **
		 *************************************/

		/**
		 * Complete the order
		 * @public
		 * @returns {undefined}
		 */
		function completeOrder() {
			var alternatePurchaseAction = Purchase.getAlternatePurchaseAction(vm._.paymentType);
			var securedPurchaseAlternatePurchaseAction = CustomActionService.actionRegistered(CustomActionService.ACTIONS_ENUMS.INITIATE_SECURED_PURCHASE);;

			// Ensure there are items in the cart before proceeding.
			if (LegacyCart.promptAndRouteIfEmpty()) {
				return;
			}

			if (angular.isDefined(alternatePurchaseAction)) {
				alternatePurchaseAction.doAction();
			} else if (securedPurchaseAlternatePurchaseAction && Utilities.forceInt(UserInfo.payment.enabled3DS)) {
				CustomActionService.executeCustomAction(CustomActionService.ACTIONS_ENUMS.INITIATE_SECURED_PURCHASE);
			} else {
				vm._.executePurchase();
			}
		}

		/**
		 * Routes the user back to edit their payment info.
		 * @public
		 * @returns {undefined}
		 */
		function editPayment() {
			var isResellerAuthType = checkProp('payment.authType', (UserInfo.get('payment') || UserInfo.payment), function(authType) {
				return authType === Enums.authTypes.ACCOUNT;
			});

			Storage.set('_billingComplete', false, true);
			//reset the payment object and secAcctInfo
			// - otherwise guest remains in a loop where they can never change their payment
			// (especially if PayPal was selected)
			UserInfo.set('payment', {});
			UserInfo.set('secAcctInfo', {}, true);
			UserInfo.set('additionalPaymentData', {}, true);

			if (isResellerAuthType) {
				return $scope.routeTo('resellerBillingView');
			}

			$scope.routeTo('paymentMethod');
		}

		/**
		 * Edit shipping
		 * @public
		 * @returns {undefined}
		 */
		function editShipping() {
			$scope.routeTo('shippingView');
		}

		/**
		 * Get the online savings percent
		 * @public
		 * @returns {String} - The online savings percent text
		 */
		function getOnlineSavingsPercent() {
			var percent;

			if (validNumber($scope.cartSummary.savings) && validNumber($scope.cartSummary.total) && Language.localeExistsMerchant('CartView', 'percent')) {

				percent = +(($scope.cartSummary.savings / ($scope.cartSummary.total + $scope.cartSummary.savings)).toFixed(2)) * 100;

				if (percent > 0) {
					return Language.getLocaleMerchant('CartView', 'percent').replace('@@percent', percent);
				}
			}

			return '';
		};

		/**
		 * Retrieve the remaining total in the cart for the final payment
		 * @public
		 * @returns {Number}
		 */
		function getRemainingCartTotalLessPartialPmts() {
			// The current payment in the scope is actually the last chosen payment method
			var remainingTotal = 0;

			if (CartDataService.getTotal() > 0) {
				remainingTotal = CartDataService.getTotal() - UserInfo.getPartialPaymentTotal();
			}

			return remainingTotal;
		}

		/**
		 * Retrieves the image of the billing provider
		 * @public
		 * @param {Number} billingProviderId - The billing provider id
		 * @returns {String} - The URL of the image
		 */
		function orderReviewBillingProviderImg(billingProviderId) {
			var imgUrl;

			if (angular.isDefined(billingProviderId)) {
				var provider = AppData.billingProviders.filter(function(item) {
					return item.billing_provider_id == billingProviderId
				})[0];

				if (angular.isDefined(provider) && angular.isDefined(provider.billing_provider_order_review_icon)) {
					imgUrl = provider.billing_provider_order_review_icon;
				}
			}

			return imgUrl;
		}

		/**
		 * Alternate Payment Summary will be shown if partialPayment or additionalPaymentData exists
		 * @returns {Boolean}
		 */
		function showAlternatePaymentSummary() {
			return $scope.partialPayments.length > 0 || checkProp('UserInfo.additionalPaymentData.accountNumber', UserInfo);
		}

		/**
		 * Toggles the memberships
		 * @public
		 * @returns {undefined}
		 */
		function toggleMemberships() {
			merge($scope, {
				displayMemberships: !$scope.displayMemberships,
				mebershipsBtnLabel: Language.getLocale('ButtonLabels', $scope.displayMemberships ? 'hide' : 'show'),
			});
		}

		/**
		 * Toggles the payment schedule
		 * @public
		 * @returns {undefined}
		 */
		function togglePaymentSchedule() {
			$scope.displayPaymentSchedule = !$scope.displayPaymentSchedule;

			if ($scope.displayPaymentSchedule) {
				$scope.paymentScheduleBtnLabel = Language.getLocaleMerchant('PaymentSchedule', 'hide');
			} else {
				$scope.paymentScheduleBtnLabel = Language.getLocaleMerchant('PaymentSchedule', 'show');
			}
		}
	}
})();
!function(){"use strict";function t(t,e,a,n,r,i,o,c,s,u,l,_,d,m,E,C,p,f,g,T,I){var v=T.checkProp,y=(angular.copy,T.first),A=T.forceInt,R=T.getBoolean,S=u.getEditSummary,D=u.getLastSummary,h=T.getString,O=angular.isNumber,M=T.merge,N=T.wrapObjectToArray,P=T.javascriptDateToSQLDate,L=I.validArray,k=I.validString,U={add:function(t,e){if(!o.add(t,e))return},changeQty:function(e,a,n){var o,d,m=U.getConfig(),E=u.getEditTotalQty(),C=S();if(!(C&&a>0))return t.reject();var p=C.cart.items.filter(function(t){return t.info.id===e});o=p.reduce(function(t,e){return!t||O(e.info.splitIndex)&&e.info.splitIndex<t.info.splitIndex?e:t},null);var f=p.reduce(function(t,e){return t+e.info.qty},0);if(!o||O(o.info.splitId)||f===a)return t.reject();!o.info.limitOverride&&E+a-f>m.cartLimit&&(a-=E+a-f-m.cartLimit,r.addMessage(_.getMessage(l.errorName.CART_LIMIT),i.type.ERROR,s.getButtonCallback(c.action.BANNER.ERROR_X)));d=angular.copy(y(o.characs)),o.info.qty=a,o.characs=Array(a).fill(d),p.length>1&&(C.cart.items=C.cart.items.filter(function(t){return t===o||t.info.id!==e}));return n?u.updateCartItemsDebounced(C):u.updateCartItems(C)},getCartCharacs:function(t){var e=D().cart.characs;if(t)return e.find(function(e){return e.name===t});return e},getCartItemById:function(t){return D().cart.items.find(function(e){return e.info.id===t})},getCartItems:function(){return u.getLastSummary().cart.items},getConfig:function(){return angular.copy(U._.config)},getDates:function(){return D().cart.items.reduce(function(t,e){var a=y(e.characs);return a.start_date&&!t.includes(a.start_date)&&t.push(a.start_date),t},[])},getLastDate:function(){return U._.lastDate},getOptinName:function(t){return t?"optin"+t:"optin"},getQty:function(){return u.api.totalQty},getShipping:function(){return D().cart.shipping},hasDate:function(t){t instanceof Date&&(t=P(t));return D().cart.items.some(function(e){return y(e.characs).start_date===t})},hasMultipleDates:function(){return U.getDates().length>1},hasPaymentPlan:function(){return L(D().paymentSchedule.schedule)},hasUnassignedAddons:function(){return D().cart.items.some(function(t){return t.flags.isOneBarcode&&t.characs.some(function(t){return v("charac.isAddonPackage",t,"validString")&&!v("charac.group_uuid",t)})})},initialize:function(){if(U._.initialized)return;if(U._.config=U._.generateConfig(),U._.initialized=!0,T.safelyCheckPropertyOnObject("AppData.GetNewCartID",a)){var t=a.GetNewCartID;n.triggerAccertify(t.accertify_session_id)}return C.register("cart__iscomp",U._.isComp),u.fetchCartSummary(p.services.SET_EXPRESS_CHECKOUT)},isMultiVendorPurchase:function(t){var e,n;if(!R(a.settings.disable_multi_vendor_purchase))return!0;return e=g.getPackageDetails(t),n=v("pkg.E.vendor_id",e)?A(e.E.vendor_id):-1,!U.getCartItems().some(function(t){return t.characs.some(function(t){return t.flex_vendor_id_lock&&A(t.flex_vendor_id_lock)!==n})})},modify:function(t){var a=D(),n=a.cart.items.find(function(e){return e.info.id===t}),r=E.convert(n,d);r.isEditMode=!0,g.retrievePackageDetailsFromId(n.package.id).then(function(i){var o=N(i.customerTypes,!0).find(function(t){return t.id===h(n.customer.id)});g.doXFC(i,[r],o,function(){var n,r=a.cart.items.findIndex(function(e){return e.info.id===t});a.cart.items[r]=E.convert(g.itemsToBeAdded[0],m),(n=a.cart.items[r]).flags.isOneBarcode&&n.oneBarcode.isParent&&(a.cart.items=a.cart.items.filter(function(t){return!t.flags.isOneBarcode||t.oneBarcode.isParent||t.oneBarcode.group!==n.oneBarcode.group})),g.itemsToBeAdded.length>1&&g.itemsToBeAdded.forEach(function(t,e){0!==e&&a.cart.items.push(E.convert(t,m))}),e.showSpinner(),u.updateCartItems(a).then(function(){T.goTo(p.routes.CART_VIEW)})})})},remove:function(t,e){var a,n,r=D();if(!r)return;if(n=r.cart.items,!(a=n.find(function(e){return e.info.id===t})))return;n=n.filter(function(e){return e.info.id!==t}),a.flags.isOneBarcode&&a.oneBarcode.isParent&&(n=n.filter(function(t){return!t.flags.isOneBarcode||t.oneBarcode.group!==a.oneBarcode.group}));O(e)&&(a.characs.splice(e,1),L(a.characs)&&n.push(a));return r.cart.items=n,u.updateCartItems(r)},removeAddon:function(t,e){var a,n,r,i=D();if(!i)return;if(r=i.cart.items,a=r.find(function(e){return e.info.id===t}),n=y(a.characs),!v("characRef.addon",n,"validString"))return;n.addon=n.addon.replace(new RegExp(e+":\\d+:\\d+","g"),"").replace(/^,|(,),+|,$/g,"$1"),k(n.addon)||delete n.addon;return u.updateCartItems(i)},setLastDate:function(t){U._.lastDate=t},updateItems:function(t){var e=D();return e.cart.items=t,u.updateCartItems(e)},_:{checkPropAndReturn:function(t,e,a,n){try{e=JSON.parse(e)}catch(t){}return v("obj."+t,e)?v("obj."+t,e,a):void 0===n?null:n},config:null,generateConfig:function(){var t=U._.checkPropAndReturn,e=a.settings,n=U._.validateGetConfig("cartOptins"),r=U._.validateGetConfig("accesso_pay"),i={accessoPayEnabled:t("enable",r,"getBoolean",!1),advertisement:t("cartAdvertisement",e,"validString"),cartLimit:t("GetMerchantPackageList.cart_limit",a,"forceInt",10),cross_sell:{hide:!1,hide_query_params:t("hide_cart_cross_sells.url_params",a,"validArray")},discounts:{enable:t("discounts.enable",e.cartView,"getBoolean",!1)},hide_subtotal:t("hide_subtotal",e,"getBoolean",!1),items:{date_format:t("date_format",e,"getString",a.defaults.date_format)},opt_ins:{enable:v("optins.enable",n,"getBoolean")||t("enable_mandatory_optin_selection",n,"getBoolean",!1),mandatory_optins:{enabled:t("enable_mandatory_optin_selection",n,"getBoolean",!1),opt_in:t("mandatory_optins.optin",n,"returnValue"),opt_out:t("mandatory_optins.optout",n,"returnValue")},optins_label:U._.validateGetConfig("cartOptinFieldLabel"),standard_optins:U._.validateGetConfig("optins"),truncate_limit:t("truncateLimit",n,"validNumber",150)},recurring_billing:{memberships:{cumulative_total_includes_comps:t("recurring_billing.memberships.cumulative_total_includes_comps",e.cartView,"getBoolean",!1),show_cumulative_total:t("recurring_billing.memberships.show_cumulative_total",e.cartView,"getBoolean",!1)}},sanitization:{disable:t("disableSanitizationOnCartScreen",e,"getBoolean",!1)},taxes_and_fees:{condense:t("condense_taxes_and_fees",e.cartView,"getBoolean",!1),denote_tax:t("tax_amount_denoted",e,"getBoolean",!1),hide_tax:t("ignore_tax",e,"getBoolean",!1)||t("ignore_vat",e,"getBoolean",!1)},terms:{agreement:U._.validateGetConfig("agreement",!0),display_agreement:t("display_agreement",e,"getBoolean",!1),terms_label:U._.validateGetConfig("customTermsFieldLabel")}};f.validate("cartView",e.cartView)&&M(i,JSON.parse(e.cartView));return i},initialized:!1,isComp:function(t){return"COMP"===t},lastDate:null,validateGetConfig:function(t,e){try{return f.validate(t,a.settings[t],!!e)?e?a.settings[t]:JSON.parse(a.settings[t]):null}catch(t){return null}}}};return U}t.$inject=["$q","$rootScope","AppData","AnalyticsDataLayerService","Banner","BannerEnums","CartActionService","CartAnalyticsEnums","CartAnalyticsService","CartDataService","CartErrorEnums","CartErrorService","CartItemHydrateModel","CartItemModel","DataModelService","DataModelEnumsService","Enums","JSONValidator","Package","Utilities","UtilsValidation"],angular.module("cart").factory("CartService",t)}(),function(){"use strict";function t(t,e){var a=e.checkAndExecute,n=e.ACTIONS_ENUMS,r=e.executeCustomAction;e.executeCustomActionChain,e.actionRegistered;return{add:function(e,i){var o=t.get("CartService");if(a(n.VALIDATE_CART_ADDITION,null,[e,o.cartItems,i,function(){o.add.call(null,e,i)}],!0))return!1;return a(n.CALENDAR_ADD_TO_CART,void 0,[e,i]),r("setSelectedPackage",i),r("modifyCustomerTypesForCart",null,[e,i]),!0}}}t.$inject=["$injector","CustomActionService"],angular.module("cart").factory("CartActionService",t)}(),function(){"use strict";function t(t,e,a,n,r,i){var o=r.checkProp,c=i.validObject,s={getButtonCallback:function(t){return function(e){e===n.buttonFlags.CLOSE&&s.triggerEvent(t)}},triggerEvent:function(e){var a;if(!s._.isActionValid(e))return t.warn("CartAnalyticsService: Invalid action",e),!1;if(null===(a=s._.createEvent(e)))return t.warn("CartAnalyticsService: Invalid event for action",e),!1;return s._.sendEvent(a),!0},triggerEventWithData:function(e,a){var n;if(!s._.isActionValid(e))return t.warn("CartAnalyticsService: Invalid action",e),!1;if(null===(n=s._.createEvent(e)))return t.warn("CartAnalyticsService: Invalid event for action",e),!1;c(a)&&angular.extend(n,a);return s._.sendEvent(n),!0},_:{createEvent:function(e){if(!s._.isActionValid(e))return t.warn("CartAnalyticsService: Invalid action",e),null;return{event:s._.eventMap[e].event,value:s._.eventMap[e].value}},eventMap:{},initialize:function(){s._.eventMap=s._.mapEvents()},isActionValid:function(t){return c(s._.eventMap[t])},mapEvents:function(){var t={};return Object.keys(a.action).forEach(function(e){Object.entries(a.action[e]).forEach(function(n){o("CartAnalyticsEnums.event."+e+"."+n[0],a,"validObject")&&(t[n[1]]=a.event[e][n[0]])})}),t},sendEvent:function(n){var r=e[a.info.DATA_LAYER];if(!angular.isArray(r))return void t.warn("CartAnalyticsService: No data layer found");r.push(n),t.info("CartAnalyticsService: Event sent",n)}}};return s._.initialize(),s}t.$inject=["$log","$window","CartAnalyticsEnums","Enums","Utilities","UtilsValidation"],angular.module("cart").service("CartAnalyticsService",t)}(),function(){"use strict";function t(t,e,a,n,r,i,o,c,s,u,l,_,d,m,E,C){L.$inject=["skipRequests","options"];var p=d.checkProp,f=d.first,g=d.forceInt,T=d.getBoolean,I=d.getString,v=m.isDateString,y=angular.isNumber,A=d.merge,R=d.toArray,S=m.validArray,D=m.validObject,h=m.validString,O=d.debounce(k,1e3),M={api:{totalQty:0,capacityExpiresAt:null,holdRenewalMs:0},getCapacityExpirationMs:function(){if(null===M.api.capacityExpiresAt)return null;return Math.max(0,M.api.capacityExpiresAt-Date.now())},getEditSummary:function(){return M._.cartSummaryEdit},getEditTotalQty:function(){return M.getEditSummary().cart.items.reduce(function(t,e){return e.flags.isOneBarcode&&!e.oneBarcode.isParent||e.info.limitOverride?t:t+=e.info.qty},0)},getLastSummary:function(){return angular.copy(M._.cartSummary)},getPrice:P,getTotal:function(){return M._.cartTotal},fetchCartSummary:L,setCapacityExpiration:N,updateCartCheckoutInfo:function(e){var a=t.defer(),r={};e&&(r.reset_checkout_info="1");return n.fetch(c.services.UPDATE_CART_CHECKOUT_INFO,!1,r).then(function(t){a.resolve(t.status===c.status.OK)}).catch(function(){a.resolve(!1)}),a.promise},updateCartItems:k,updateCartItemsDebounced:O,_:{cartSummary:null,cartSummaryEdit:null,cartTotal:null,handleGetCartSummaryResponse:function(t){var e=o.convert(t,u);M._.setOneBarcode(e.cart.items),M._.setCorrectedMinQty(e.cart.items),M._.setCartItemFlags(e.cart.items),M._.setSplitItemFlags(e.cart.items),M._.setPaymentPlanType(e),M._.setAdjustedCartQuantity(e.cart),d.orderByDisplayOrder(e.cart.items,"infor.order"),d.sinkValues(e.cart.items,"info.order",0),M._.cartSummary=e,M._.setCrossSellHeaders(),M._.cartSummaryEdit=e,M.api.totalQty=e.cart.qty,M._.cartTotal=e.pricing.total,e.discount&&!1!==e.discount.valid||_.setDiscountCode(null);i.actionRegistered(i.ACTIONS_ENUMS.ON_CART_SUMMARY_UPDATE)&&i.executeCustomAction(i.ACTIONS_ENUMS.ON_CART_SUMMARY_UPDATE,M.getLastSummary());M.api.holdRenewalMs>0&&N(M.api.holdRenewalMs)},initialize:function(){i.registerCustomAction("RESPONSE_"+c.services.GET_CART_SUMMARY,M._.handleGetCartSummaryResponse),M._.cartSummary=o.convert({},u)},isItemComp:function(t){return"comp"===I(t.info.action).toLowerCase()},isItemEditDisabled:function(t){var e=f(t.characs);return T(e.disable_edit_mode)||v(e.start_date)},isItemModifiable:function(t){var e,a=f(t.characs),n=l.getPackageByID(t.package.id)||null;(n||a.client_xfc_name)&&(e=s.getEditableXMCsFromList(I(n?n.extra_movie:a.client_xfc_name),"doEditMode"));if(!e||0===e.length)return!1;return!M._.isItemEditDisabled(t)},isItemQtyEditable:function(t){var e=f(t.characs),a=I(e.client_alternate_name),n=!0,r=I(e.client_xfc_name);if(t.info.minQty===t.info.maxQty)return!1;if(t.flags.hasGiftCode)return!1;if(!D(e))return!0;C.isCartItemQuantityModifiable(t.characs)?a&&p("ExtraFlow."+a+".lockQuantity",s)&&(n=!s[a].lockQuantity):n=!1;n&&r&&(n=!s.getEditableXMCsFromList(r,"lockQuantity").length);return n&&!v(e.start_date)&&!M._.isItemComp(t)},isItemRemovable:function(t){if(M._.isItemComp(t))return!1;if(t.flags.isOneBarcode&&!t.oneBarcode.isParent){let e=t.oneBarcode.parent;return g(e.oneBarcode.minSelection)<e.oneBarcode.children.length}return!0},setAdjustedCartQuantity:function(t){t.qty=t.items.reduce(function(t,e){return e.flags.isOneBarcode&&!e.oneBarcode.isParent?t:t+=e.info.qty},0)},setCartItemFlags:function(t){t.forEach(function(t){const e=M._.isItemModifiable(t),a=M._.isItemQtyEditable(t);A(t.flags,{editQuantity:a&&!e,modify:e,remove:M._.isItemRemovable(t),showGate:!t.flags.hasDiscount&&t.pricing.gate>0&&t.pricing.gate>P(t.pricing)})})},setCorrectedMinQty:function(t){var e={},a={};t.forEach(function(t){var e=t.package.id;a[e]=(a[e]||0)+(t.info.qty||0)}),t.forEach(function(t){var n=t.package.id;t.info.pkgMinQty=t.info.minQty,e.hasOwnProperty(n)||(e[n]=l.getPackageByID(n)||null);var r=e[n];if(r){var i=R(r.CT),o=i.length>1,c=r.min_quantity?g(r.min_quantity):0;if(t.info.pkgMinQty=c,o){var s=i.find(function(e){return e&&e.id==t.customer.id}),u=s&&s.min_quantity?g(s.min_quantity):0;t.info.minQty=u>0&&u!==c?u:0;var _=r.max_quantity?g(r.max_quantity):t.info.maxQty,d=a[n]-t.info.qty;t.info.maxQty=Math.max(t.info.minQty,_-d)}}})},setCrossSellHeaders:function(){p("service._.cartSummary.crossSells",M,S)&&M._.cartSummary.crossSells.forEach(function(t){var e=l.getPackagesByKeyword(t.keyword);if(p("pkgs.0.KEYWORDS.K",e,S)){var a=e[0].KEYWORDS.K.find(function(e){return e.keyword===t.keyword});a&&(t.header=a.keyword_header)}})},setOneBarcode:function(t){var e=t.filter(function(t){return t.flags.isOneBarcode&&t.oneBarcode.isParent});if(!e.length)return;e.forEach(function(e){var a=t.filter(function(t){return t.flags.isOneBarcode&&t.oneBarcode.group===e.oneBarcode.group&&t.info.id!==e.info.id});a.length&&(e.oneBarcode.children=a,a.forEach(function(t){t.oneBarcode.parent=e}))})},setPaymentPlanType:function(t){var e;if(!t.info.hasPaymentSchedule)return;if(!(e=t.cart.items.filter(function(t){return t.flags.hasPaymentPlan})).length)return;switch(I(f(e).characs[0].payment_plan||f(e).paymentPlan.type).toLowerCase()){case"easypay":t.paymentSchedule.type="EasyPay";break;case"paylater":t.paymentSchedule.type="PayLater";break;case"multi":t.paymentSchedule.type="PaymentPlanMulti";break;case"mem":t.paymentSchedule.type="Membership";break;default:t.paymentSchedule.type=""}t.paymentSchedule.qty=e.length},setSplitItemFlags:function(t){var e=t.reduce(function(t,e){return y(e.info.splitIndex)&&(t[e.info.id]=t[e.info.id]||[],t[e.info.id].push(e)),t},{});Object.keys(e).forEach(function(t){var a=e[t];if(!(a.length<2)){var n=a.reduce(function(t,e){return e.info.splitIndex<t.info.splitIndex?e:t}),r=a.reduce(function(t,e){return t+e.info.qty},0);a.forEach(function(t){t.info.splitTotalQty=r,t!==n&&(t.info.isSplitRemainder=!0,A(t.flags,{editQuantity:!1,modify:!1,remove:!1}))})}})},triggerEmbeddedUpdate:function(){i.actionRegistered(i.ACTIONS_ENUMS.ON_EMBEDDED_CART_UPDATE)&&i.executeCustomAction(i.ACTIONS_ENUMS.ON_EMBEDDED_CART_UPDATE)}}};return M._.initialize(),M;function N(t){var a=parseInt(t,10);isNaN(a)||a<=0?M.api.capacityExpiresAt=null:(M.api.capacityExpiresAt=Date.now()+a,M.api.holdRenewalMs=a,e.$broadcast("cartHoldRenewed"))}function P(t){return E.getPrice(t.retail,t.tax,t.fee).toFixed(2)}function L(r,i){var o,s=t.defer(),u={},l=D(i)&&!0===i.forceRefresh;return h(r)&&(u.skip_requests=r),D(i)&&delete(u=A(u,i)).forceRefresh,o=_.getDiscountCode(),h(o)&&(u.discount_code=o,angular.isArray(u.addRequestParameters)?u.addRequestParameters.push("discount_code"):u.addRequestParameters=["discount_code"]),e.hasPendingRequest(c.services.GET_CART_SUMMARY)?(a(function t(){e.hasPendingRequest(c.services.GET_CART_SUMMARY)?a(t,50):Object.keys(u).length>0||l?n.fetch(c.services.GET_CART_SUMMARY,!1,u).then(M._.handleGetCartSummaryResponse).then(function(){s.resolve(M.getLastSummary())}).catch(function(){s.reject()}):(M._.handleGetCartSummaryResponse(n.GetCartSummary),s.resolve(M.getLastSummary()))},50),s.promise):(n.fetch(c.services.GET_CART_SUMMARY,!1,u).then(M._.handleGetCartSummaryResponse).then(function(){s.resolve(M.getLastSummary())}).catch(function(){s.reject()}),s.promise)}function k(e){O.cancel();var a=t.defer(),i=A({},o.convert(e,r));return M._.triggerEmbeddedUpdate(),n.fetch(c.services.UPDATE_CART_ITEMS,!1,i).then(function(t){var e=t.status===c.status.OK;e&&M.api.holdRenewalMs>0&&N(M.api.holdRenewalMs),a.resolve(e)}).catch(function(){a.resolve(!1)}),a.promise}}t.$inject=["$q","$rootScope","$timeout","AppData","CartItemsHydrateModel","CustomActionService","DataModelService","Enums","ExtraFlow","GetCartSummaryModel","Package","UserInfo","Utilities","UtilsValidation","UtilsPricing","WTPService"],angular.module("cart").factory("CartDataService",t)}(),function(){"use strict";function t(t,e,a,n,r,i,o,c,s,u,l){var _=u.forceInt,d=u.merge,m=l.validString,E=i.discount.reasonCode.RATE_LIMITED,C=e.search().merchant_id||"",p=C?"_"+C:"",f="discountCode"+p,g="discountRateLimitExpiry"+p,T="discountPerUserLimit"+p,I="ac_disc"+p,v={APPLIED:"applied",REJECTED:"rejected",NETWORK_ERROR:"network_error"},y={api:{activeCode:null,isPending:!1,lastResult:null,perUserLimit:null,rateLimitExpiry:0},applyCode:function(t){var e=a.defer(),n=t.toUpperCase();if(y.api.isPending)return e.resolve(y.api.lastResult||v.REJECTED),e.promise;if(y._.isPerUserLimitReached(n))return e.resolve({preCheckFailed:!0,error:i.discount.preCheckError.PER_USER_LIMIT}),e.promise;if(y._.isRateLimited())return e.resolve({preCheckFailed:!0,error:i.discount.preCheckError.RATE_LIMIT,remainingMs:y._.getRateLimitRemaining()}),e.promise;return s.set(f,n),d(y.api,{activeCode:n,isPending:!0,lastResult:null}),r.fetchCartSummary().then(function(t){var a,n=y._.parseResult(t);y.api.lastResult=n,y.api.isPending=!1,n===v.APPLIED?(a=t.discount?t.discount.perUserLimit:null,y.api.perUserLimit=a,s.set(T,a)):(s.set(f,null),y.api.activeCode=null),e.resolve(n)}).catch(function(){d(y.api,{lastResult:v.NETWORK_ERROR,isPending:!1,activeCode:null}),s.set(f,null),e.resolve(v.NETWORK_ERROR)}),e.promise},clearCode:A,RESULTS:v,_:{initialize:function(){var t=s.get(f),e=s.get(T),a=s.get(g);y.api.activeCode=m(t)?t:null,y.api.perUserLimit=e?_(e):null,y.api.rateLimitExpiry=a?_(a):0,o.registerCustomActionForChain(o.ACTIONS_ENUMS.PURCHASE_COMPLETE_SUCCESS,y._.onPurchaseComplete,"CART_DISCOUNT_CODE")},isRateLimited:function(){return y.api.rateLimitExpiry>Date.now()},onPurchaseComplete:function(){m(y.api.activeCode)&&y._.trackUsage(y.api.activeCode,y.api.perUserLimit);A()},parseResult:function(t){if(t.discount&&!0===t.discount.valid)return v.APPLIED;if(t.discount&&!1===t.discount.valid)return t.discount.reasonCode===E&&(y.api.rateLimitExpiry=Date.now()+y._.getRateLimitDurationMs(),s.set(g,y.api.rateLimitExpiry)),v.REJECTED;if(t.info.hasError||t.status===c.status.FAILED)return v.REJECTED;return v.APPLIED},getRateLimitDurationMs:function(){return 60*n.discountRateLimitMinutes*1e3},getRateLimitRemaining:function(){return Math.max(0,y.api.rateLimitExpiry-Date.now())},getUsageCookie:function(){try{var e=t.get(I);return e?JSON.parse(e):{}}catch(t){return{}}},setUsageCookie:function(e){try{var a=new Date;a.setFullYear(a.getFullYear()+1),t.put(I,JSON.stringify(e),{expires:a,secure:!0,samesite:"Strict"})}catch(t){}},isPerUserLimitReached:function(t){var e=y._.getUsageCookie()[t];return!!(e&&e.limit&&e.count>=e.limit)},trackUsage:function(t,e){var a=y._.getUsageCookie(),n=a[t]||{count:0};n.count=(n.count||0)+1,n.limit=e||null,a[t]=n,y._.setUsageCookie(a)}}};return y._.initialize(),y;function A(){s.set(f,null),s.set(T,null),y.api.activeCode=null,y.api.lastResult=null,y.api.perUserLimit=null}}t.$inject=["$cookies","$location","$q","AppData","CartDataService","CartEnums","CustomActionService","Enums","UserInfo","Utilities","UtilsValidation"],angular.module("cart").factory("CartDiscountCodeService",t)}(),function(){"use strict";function t(t,e){var a={SAVED:"saved",FAILED:"failed",NETWORK_ERROR:"network_error"};return{RESULTS:a,saveCart:function(n){var r={email:n,name:"",opt_in:"1",cart_id:t.GetCartSummary.CART.cart_id,cart_key:t.cart.cart_key,lang_id:t.language,merchant_id:t.GetMerchantDetails.merchant_id,mode:"1500"};return t.fetch(e.services.SAVE_CART,!1,r,!0,!1).then(function(t){return t&&t.status===e.status.OK?a.SAVED:a.FAILED}).catch(function(){return a.NETWORK_ERROR})},state:{email:"",isExpanded:!1}}}t.$inject=["AppData","Enums"],angular.module("cart").factory("CartSaveLinkService",t)}(),function(){function t(t,e,a,n,r,i,o){var c={getMessage:function(t){var e=c._.getLocale("CheckCartTicketLevelErrors",t,"defaultError");return c._.replaceVariables(e)},handleError:function(t){var e=t||a.errorName.GENERAL_FAILURE,n=c._.getError(e),r=c._.getAction(n.action);n.modal===a.modal.SHOW?c._.showModal(e,r):r()},_:{getAction:function(t){switch(t){case a.action.NAVIGATE_AWAY:return function(){o.goTo("/")};case a.action.RECALL:return function(){e.fetchCartSummary()};case a.action.IGNORE:default:return function(){}}},getError:function(t){if(a.errorCode[t])return a.errorCode[t];return a.errorCode[a.errorName.GENERAL_FAILURE]},getLocale:function(t,e,a){if(a=e||a,r.localeExistsMerchant(t,e))return r.getLocaleMerchant(t,e);return r.getLocaleMerchant(t,a)},replaceVariables:function(e){var a=t.get("CartService").getConfig();return e.replace(/@@cartLimit\b/g,a.cartLimit)},showModal:function(t,e){i.displayModal({category:"Cart",title:r.getLocaleMerchant("Alert","cartErrorUpdatingItemTitle"),description:c.getMessage(t),view:i.SLIDEUP,buttonFlags:[n.buttonFlags.OK],callback:e})}}};return c}t.$inject=["$injector","CartDataService","CartErrorEnums","Enums","Language","Modal","Utilities"],angular.module("cart").factory("CartErrorService",t)}(),function(){"use strict";function t(t,e,a,n){var r=a.checkProp,i=a.getString,o=n.validString,c={isAlternateModuleCharacsPresent:function(a){var n=e.getPackageByID(a.package.id);return a.characs.every(function(a){var i;return!o(a.client_alternate_name)||(i=t.getAlternateFlowSettings(a.client_alternate_name),!r("altModSettings.characsList",i,"validArray")||i.characsList.every(function(t){if(o(a[t]))return!0;switch(t){case"start_date":return!e.isDated(n);case"start_time":return!e.isTimed(n);default:return!1}}))})},isExtraMovieCharacsPresent:function(a){var n=e.getPackageByID(a.package.id);if(!c._.isPackageExtraMoviePresent(n))return!0;if(a.flags.isOneBarcode)return!0;return c._.processExtraMovieList(t.getEnabledXFCsFromList(n.extra_movie,!0)).every(function(e){return!!t[e]&&(!r("ExtraFlow."+e+".characsList",t,"validArray")||a.characs.every(function(a){return t[e].characsList.every(function(t){return o(a[t])})}))})},isExtraMoviesMatching:function(a){var n,r=e.getPackageByID(a.package.id);if(!c._.isPackageExtraMoviePresent(r))return!0;if(a.flags.isOneBarcode)return!0;return n=c._.processExtraMovieList(t.getEnabledXFCsFromList(r.extra_movie,!0)),a.characs.every(function(t){var e=c._.processExtraMovieList(t.client_xfc_name);return e.length===n.length&&e.every(function(t){return n.includes(t)})})},isQtyMatchingCharacs:function(t){return t.characs.length===t.info.qty},_:{isPackageExtraMoviePresent:function(t){return r("pkg.extra_movie",t,o)},processExtraMovieList:function(t){return i(t).replace(/\s*,\s*/g,",").split(",")}}};return c}t.$inject=["ExtraFlow","Package","Utilities","UtilsValidation"],angular.module("cart").factory("CartValidationService",t)}(),function(){"use strict";angular.module("cart").constant("CartAdjustmentHydrateModel",{amount:"amount:floatstring",id:"id:intstring",name:"name:string",percent_flag:"?isPercent:intstring",tax:"!tax:floatstring"})}(),function(){"use strict";angular.module("cart").constant("CartItemModel",{action:"?action:string",addons:[{$:"ITEM:CartItemAddonModel"}],characs:"CHARACS:array",comps:[{$:"COMPS.ITEMS.ITEM:CartItemAddonModel"}],customer:{id:"customer_type:int",name:"customer_type_name:string"},event:"?E:object",flags:{hasAddons:"!ITEM|COMPS.ITEMS.ITEM:boolean",hasDiscount:"!original_retail_price>retail_price:boolean",hasGiftAid:"!gift_aid_type:boolean",hasGiftCode:"!CHARACS[].0.gift_offer_id:boolean",hasPaymentPlan:"!payment_schedule_id:boolean",hasRequiredPayments:"!required_num_payments>1:boolean",isOneBarcode:"!CHARACS[].0.group_uuid:boolean",skipAgreement:"!skip_agreement_form:boolean"},info:{action:"?action:string",compId:"?CHARACS[].0.comp_item_id:int",errorCode:"?error_code:int",flow:"?extra_movie:string",giftAidOptIn:"?gift_aid_opt_in_type:string",giftAidType:"?gift_aid_type:string",id:"id:int",limitOverride:"!cart_limit_override:boolean",maxQty:"ct_max_quantity|max_quantity:int",minQty:"ct_min_quantity|min_quantity:int",order:"display_order:int",promoCode:"promo_code:string",qty:"qty:int",splitIndex:"?split_index:int"},oneBarcode:{group:"?CHARACS[].0.group_uuid:string",isParent:"?CHARACS[].0.one_barcode_parent:boolean",minSelection:"?CHARACS[].0.required_scheduling_selections:int"},package:{id:"package_id:int",name:"package_name:string",type:"?package_type:string"},paymentPlan:{id:"?payment_schedule_id:int",type:"?payment_plan:string"},pricing:{fee:"fee_amount:float",gate:"?gate_price:float",originalRetail:"?original_retail_price:float",originalTax:"?original_tax_amount:float",retail:"retail_price:float",tax:"tax_amount:float"},requiredPayments:{monthsBetween:"?months_between_payments:int",numPayments:"?required_num_payments:int"}})}(),function(){"use strict";angular.module("cart").constant("CartItemAddonModel",{action:"?action:string",customer:{id:"customer_type:int",name:"customer_type_name:string"},flag:{isComp:"!action:cart__iscomp"},info:{order:"display_order:int"},package:{id:"package_id:int",name:"package_name:string",type:"package_type:string"},pricing:{fee:"fee_amount:float",retail:"retail_price:float",tax:"tax_amount:float"},qty:"qty:int"})}(),function(){"use strict";angular.module("cart").constant("CartItemHydrateModel",{CHARACS:"characs:array",cart_limit_override:"!info.limitOverride:int",client_rate_name:"customer.name:string",customer_type:"customer.id:string",extra_movie:"?flow:string",id:"info.id:string",package_id:"package.id:string",payment_schedule_id:"?paymentPlan.id:string",promo_code:"?info.promoCode:string",qty:"info.qty:string",skip_agreement_form:"?flags.skipAgreement:int"})}(),function(){"use strict";angular.module("cart").constant("CartItemsHydrateModel",{$:"cart",ITEMS:{ITEM:[{$:"items:CartItemHydrateModel"}]}})}(),function(){"use strict";angular.module("cart").constant("GetCartSummaryModel",{adjustments:[{$:"CART_ADJUSTMENTS.CA",amount:"amount:floatcurrency",id:"id:int",isPercent:"?percent_flag:boolean",name:"name:string",tax:"!tax:floatcurrency"}],cart:{$:"CART",characs:[{$:"CART_CHARACS.CART_CHARAC",name:"name:string",value:"value:*"}],id:"cart_id:int",items:[{$:"ITEMS.ITEM:CartItemModel"}],qty:"qty:int",shipping:[{$:"SHIPPING_METHODS.S",description:"long_desc:string",method:"ship_method:string",price:"price:floatcurrency",title:"desc:string"}],taxTiers:[{$:"TAX_TIERS.TAX",amount:"amount:floatcurrency",id:"id:int"}]},crossSells:[{$:"CHECKOUT_KEYWORDS.K",description:"desc:string",id:"id:int",image:"image:string",keyword:"keyword:string",language:"language:string",pkgCount:"pkg_count:int"}],discount:{$:"?DISCOUNT",campaignMessage:"?campaign_message:string",campaignTag:"?campaign_tag:string",code:"?discount_code:string",id:"?discount_id:string",name:"?discount_name:string",perUserLimit:"?per_user_usage_limit:int",reasonCode:"?reason_code:string",type:"?discount_type:string",valid:"?valid:boolean",value:"?discount_value:float"},error:{code:"?last_ticket_error_code|error_code:int",message:"?last_ticket_error_msg|error_msg:string"},fees:[{$:"FEES.F",amount:"amount:floatcurrency",asTax:"fee_as_tax:boolean",id:"id:int",name:"name:string"}],futurePayments:{$:"FUTURE_PAYMENTS",payments:[{$:"PAYMENT",date:"?payment_date:date",info:{monthInterval:"?months_between_payments:int",requiredPayments:"?required_num_payments:int"},pricing:{fee:"?fee_amount:floatcurrency",retail:"?retail_amount:floatcurrency",tax:"?tax_amount:floatcurrency",total:"?total:floatcurrency"}}]},info:{hasDiscountSavings:"!original_total>total:boolean",hasError:"!last_ticket_error_msg|error_msg:boolean",hasFuturePayments:"!FUTURE_PAYMENTS.PAYMENT[].length:boolean",hasPaymentSchedule:"!PAYMENT_SCHEDULE.PAYMENT[].length:boolean",isValid:"?valid:boolean"},paymentSchedule:{$:"PAYMENT_SCHEDULE:PaymentScheduleModel"},pricing:{currentDue:"?current_amount_due:floatcurrency",currentTax:"?current_tax_total:floatcurrency",depositTotal:"?deposit_transfer_total:floatcurrency",discountSavings:"?original_retail_total-retail_total:floatcurrency",fee:"?fee_total:floatcurrency",originalPaymentDue:"?original_payment_due:floatcurrency",originalRetailTotal:"?original_retail_total:floatcurrency",originalSubtotal:"?original_subtotal:floatcurrency",originalTaxTotal:"?original_tax_total:floatcurrency",originalTotal:"?original_total:floatcurrency",paymentDue:"!payment_due:floatcurrency",retailTotal:"!retail_total:floatcurrency",savings:"?online_savings:floatcurrency",shipping:"!ship_total:floatcurrency",subtotal:"!subtotal:floatcurrency",taxTotal:"!tax_total:floatcurrency",total:"!total:floatcurrency"},status:"status:string"})}(),function(){"use strict";angular.module("cart").constant("PaymentSummaryHydrateModel",{PAYMENT_SUMMARY:{PAYMENT:[{$:"schedule",ca_amount:"adjustment.amount:currency",ca_tax_amount:"adjustment.tax:currency",date:"date:datestring",fee_amount:"pricing.fee:currency",index:"order:string",retail_amount:"pricing.retail:currency",ship_amount:"pricing.ship:currency",tax_amount:"pricing.tax:currency",total_amount:"pricing.total:currency"}],id:"id:string"}})}(),function(){"use strict";angular.module("cart").constant("CartAnalyticsEnums",{action:{BANNER:{ERROR_X:"banner_error_x",INFO_X:"banner_info_x"},CART_ITEM:{QTY_DECREASE:"cart_item_qty_decrease",QTY_DROPDOWN:"cart_item_qty_dropdown",QTY_EDIT:"cart_item_qty_edit",QTY_INCREASE:"cart_item_qty_increase",REMOVE:"cart_item_remove",REMOVE_CANCEL:"cart_item_remove_cancel",REMOVE_CONFIRM:"cart_item_remove_confirm",REMOVE_X:"cart_item_remove_x",MODIFY:"cart_item_modify"},CROSS_SELL:{MORE_INFO:"cross_sell_more_info",NEXT:"cross_sell_next",PREVIOUS:"cross_sell_previous"},DISCOUNT_CODE:{APPLIED:"cart_discount_applied",FOCUS:"cart_discount_focus",INVALID:"cart_discount_invalid",REMOVED:"cart_discount_removed"},ORDER_SUMMARY:{CHECKOUT:"order_summary_checkout",CHECKOUT_OPTIN_REQ:"order_summary_checkout_optins_required",MAND_OPTIN_YES:"order_summary_mand_optin_yes",MAND_OPTIN_NO:"order_summary_mand_optin_no",OPTIN_1_CHECKED:"order_summary_optin_1_checked",OPTIN_1_UNCHECKED:"order_summary_optin_1_unchecked",OPTIN_2_CHECKED:"order_summary_optin_2_checked",OPTIN_2_UNCHECKED:"order_summary_optin_2_unchecked",OPTIN_3_CHECKED:"order_summary_optin_3_checked",OPTIN_3_UNCHECKED:"order_summary_optin_3_unchecked",TAX_FEE_TOGGLE:"order_summary_tax_fee_toggle",TERMS_CHECKED:"order_summary_terms_checked",TERMS_UNCHECKED:"order_summary_terms_unchecked"},SAVE_CART_LINK:{DISPLAYED:"cart_save_link_displayed",CLICKED:"cart_save_link_clicked",EMAIL_SUBMITTED:"cart_save_link_email_submitted",ERROR:"cart_save_link_error"}},event:{BANNER:{ERROR_X:{event:"passport.buttonClick",value:"Cart_Dismiss_Error"},INFO_X:{event:"passport.buttonClick",value:"Cart_Dismiss_Info"}},CART_ITEM:{QTY_DECREASE:{event:"passport.buttonClick",value:"Cart_Qty_Decrease"},QTY_DROPDOWN:{event:"passport.buttonClick",value:"Cart_Item_Qty_Dropdown"},QTY_INCREASE:{event:"passport.buttonClick",value:"Cart_Qty_Increase"},REMOVE:{event:"passport.buttonClick",value:"Cart_Remove_Item"},REMOVE_CANCEL:{event:"passport.buttonClick",value:"CartModal_Cancel"},REMOVE_CONFIRM:{event:"passport.buttonClick",value:"CartModal_Confirm_Del"},REMOVE_X:{event:"passport.buttonClick",value:"CartModal_Close"},MODIFY:{event:"passport.buttonClick",value:"Cart_Modify_Item"}},CROSS_SELL:{MORE_INFO:{event:"passport.buttonClick",value:"Cart_CS_Selected"},NEXT:{event:"passport.buttonClick",value:"Cart_CS_Scroll"},PREVIOUS:{event:"passport.buttonClick",value:"Cart_CS_ScrollBack"}},DISCOUNT_CODE:{APPLIED:{event:"passport.buttonClick",value:"CartDiscountApplied"},FOCUS:{event:"passport.buttonClick",value:"CartDiscountFocus"},INVALID:{event:"passport.buttonClick",value:"CartDiscountInvalid"},REMOVED:{event:"passport.buttonClick",value:"CartDiscountRemoved"}},ORDER_SUMMARY:{CHECKOUT:{event:"passport.checkout",value:"Cart_Checkout_CTA"},CHECKOUT_OPTIN_REQ:{event:"passport.buttonClick",value:"Cart_Checkout_Optin_Required"},MAND_OPTIN_YES:{event:"passport.buttonClick",value:"MandOptin1_Yes"},MAND_OPTIN_NO:{event:"passport.buttonClick",value:"MandOptin1_No"},OPTIN_1_CHECKED:{event:"passport.buttonClick",value:"Cart_Optin1_Checked"},OPTIN_1_UNCHECKED:{event:"passport.buttonClick",value:"Cart_Optin1_Unchecked"},OPTIN_2_CHECKED:{event:"passport.buttonClick",value:"Cart_Optin2_Checked"},OPTIN_2_UNCHECKED:{event:"passport.buttonClick",value:"Cart_Optin2_Unchecked"},OPTIN_3_CHECKED:{event:"passport.buttonClick",value:"Cart_Optin3_Checked"},OPTIN_3_UNCHECKED:{event:"passport.buttonClick",value:"Cart_Optin3_Unchecked"},TAX_FEE_TOGGLE:{event:"passport.buttonClick",value:"Cart_Fees_Dropdown"},TERMS_CHECKED:{event:"passport.buttonClick",value:"CartTC_Check"},TERMS_UNCHECKED:{event:"passport.buttonClick",value:"CartTC_Uncheck"}},SAVE_CART_LINK:{DISPLAYED:{event:"passport.buttonClick",value:"CartSaveLinkDisplayed"},CLICKED:{event:"passport.buttonClick",value:"CartSaveLinkClicked"},EMAIL_SUBMITTED:{event:"passport.buttonClick",value:"CartSaveLinkEmailSubmitted"},ERROR:{event:"passport.buttonClick",value:"CartSaveLinkError"}}},info:{DATA_LAYER:"dataLayer"}})}(),function(){"use strict";angular.module("cart").constant("CartDiscountLocales",{section:"CartView",target:{APPLIED_DEFAULT:"DiscountCodeApplied",APPLIED_FIXED:"DiscountCodeAppliedFixed",APPLIED_PERCENTAGE:"DiscountCodeAppliedPercentage",APPLY_BUTTON:"DiscountCodeApplyButton",APPLYING_LABEL:"DiscountCodeApplyingLabel",ERROR_INVALID:"DiscountCodeErrorInvalid",ERROR_NO_ELIGIBLE_ITEMS:"DiscountCodeErrorNoEligibleItems",ERROR_NO_LONGER_VALID:"DiscountCodeErrorNoLongerValid",ERROR_RATE_LIMITED:"DiscountCodeErrorRateLimited",INPUT_PLACEHOLDER:"DiscountCodeInputPlaceholder",REMOVE:"DiscountCodeRemove",REMOVED_ANNOUNCEMENT:"DiscountCodeRemovedAnnouncement",REMOVING_LABEL:"DiscountCodeRemovingLabel",TOGGLE_LABEL:"DiscountCodeToggleLabel"},localeKey:{ERROR_INVALID:"errorInvalid",ERROR_NO_ELIGIBLE_ITEMS:"errorNoEligibleItems",ERROR_NO_LONGER_VALID:"errorNoLongerValid",ERROR_RATE_LIMITED:"errorRateLimited"}})}(),function(){"use strict";angular.module("cart").constant("CartErrorEnums",{action:{IGNORE:0,RECALL:1,NAVIGATE_AWAY:2},errorCode:{16:{action:2,modal:1,name:"Exception in GetCartSummary"},400:{action:1,modal:1,name:"General Failure"},401:{action:1,modal:1,name:"Cart Limit"},402:{action:1,modal:1,name:"PAH Limit"},403:{action:1,modal:1,name:"Duplicate Renewals"},404:{action:1,modal:1,name:"Comps Error"},406:{action:1,modal:1,name:"Resources Error"},407:{action:1,modal:1,name:"Dynamic Processing Fee Calculation Error"},408:{action:1,modal:1,name:"Cart Purchased"},450:{action:1,modal:1,name:"Ticket General Failure"},451:{action:1,modal:1,name:"Ticket Package Not Found"},452:{action:1,modal:1,name:"Ticket CT Not Found"},453:{action:1,modal:1,name:"Ticket Invalid Card Type"},454:{action:1,modal:1,name:"Ticket Mixed Rates Disallowed"},459:{action:1,modal:1,name:"Ticket Two Different Deffereds Not Allowed"},460:{action:1,modal:1,name:"Ticket Addon Invalid"},465:{action:1,modal:1,name:"Ticket Invalid Quantity"},466:{action:1,modal:1,name:"Ticket Invalid Birth Date"},467:{action:1,modal:1,name:"Ticket Invalid Minimum Age"},468:{action:1,modal:1,name:"Ticket Invalid Maximum Age"},469:{action:1,modal:1,name:"Ticket Missing Birth Date"},470:{action:1,modal:1,name:"Ticket Gift Code Missing"},471:{action:1,modal:1,name:"Ticket Gift Code Invalid"},472:{action:1,modal:1,name:"Ticket Gift Code Usage Error"},475:{action:1,modal:1,name:"Ticket Comp Invalid Parent"},476:{action:1,modal:1,name:"Ticket Comp Invalid Quantity"},477:{action:1,modal:1,name:"Ticket Comp Date Not Available"},480:{action:1,modal:1,name:"Ticket Capacity Missing Event Info"},481:{action:1,modal:1,name:"Ticket Capacity Sold Out"},482:{action:1,modal:1,name:"Ticket Already Renewed"},483:{action:1,modal:1,name:"Ticket Package Shipping Error"},484:{action:1,modal:1,name:"Ticket Group Package Minimum Not Met"},485:{action:1,modal:1,name:"Ticket Multiple Vendors Error"},486:{action:1,modal:1,name:"Ticket No Longer Valid"},487:{action:1,modal:1,name:"Ticket Prerequisite Missing"},488:{action:1,modal:1,name:"Ticket Mutually Exclusive Packages Found"},489:{action:1,modal:1,name:"Ticket IDME Authentication Expired"},490:{action:1,modal:1,name:"Ticket Invalid Park"},491:{action:1,modal:1,name:"Ticket Invalid Folio"},492:{action:1,modal:1,name:"Ticket No GR on Folio"},493:{action:1,modal:1,name:"Ticket Invalid Data"},494:{action:1,modal:1,name:"Ticket Outside Renewal Period"},495:{action:1,modal:1,name:"Ticket Capacity Item Expired"},496:{action:1,modal:1,name:"Ticket Capacity Rez Item Expired"},497:{action:1,modal:1,name:"Ticket Invalid Upgrade"},604:{action:1,modal:1,name:"Resource Already Booked"}},errorName:{GET_CART_SUMMARY_EXCEPTION:16,GENERAL_FAILURE:400,CART_LIMIT:401,PAH_LIMIT:402,DUPLICATE_RENEWALS:403,COMPS_ERROR:404,RESOURCES_ERROR:406,DYNAMIC_PROCESSING_FEE_CALCULATION_ERROR:407,CART_PURCHASED:408,TICKET_GENERAL_FAILURE:450,TICKET_PACKAGE_NOT_FOUND:451,TICKET_CT_NOT_FOUND:452,TICKET_INVALID_CARD_TYPE:453,TICKET_MIXED_RATES_DISALLOWED:454,TICKET_TWO_DIFFERENT_DEFFEREDS_NOT_ALLOWED:459,TICKET_ADDON_INVALID:460,TICKET_INVALID_QUANTITY:465,TICKET_INVALID_BIRTH_DATE:466,TICKET_INVALID_MINIMUM_AGE:467,TICKET_INVALID_MAXIMUM_AGE:468,TICKET_MISSING_BIRTH_DATE:469,TICKET_GIFT_CODE_MISSING:470,TICKET_GIFT_CODE_INVALID:471,TICKET_GIFT_CODE_USAGE_ERROR:472,TICKET_COMP_INVALID_PARENT:475,TICKET_COMP_INVALID_QUANTITY:476,TICKET_COMP_DATE_NOT_AVAILABLE:477,TICKET_CAPACITY_MISSING_EVENT_INFO:480,TICKET_CAPACITY_SOLD_OUT:481,TICKET_ALREADY_RENEWED:482,TICKET_PACKAGE_SHIPPING_ERROR:483,TICKET_GROUP_PACKAGE_MINIMUM_NOT_MET:484,TICKET_MULTIPLE_VENDORS_ERROR:485,TICKET_NO_LONGER_VALID:486,TICKET_PREREQUISITE_MISSING:487,TICKET_MUTUALLY_EXCLUSIVE_PACKAGES_FOUND:488,TICKET_IDME_AUTHENTICATION_EXPIRED:489,TICKET_INVALID_PARK:490,TICKET_INVALID_FOLIO:491,TICKET_NO_GR_ON_FOLIO:492,TICKET_INVALID_DATA:493,TICKET_OUTSIDE_RENEWAL_PERIOD:494,TICKET_CAPACITY_ITEM_EXPIRED:495,TICKET_CAPACITY_REZ_ITEM_EXPIRED:496,TICKET_INVALID_UPGRADE:497},modal:{IGNORE:0,SHOW:1}})}(),function(){"use strict";angular.module("cart").constant("CartEnums",{discount:{reasonCode:{CODE_INACTIVE:"CODE_INACTIVE",CODE_NOT_FOUND:"CODE_NOT_FOUND",CODE_OUTSIDE_DATE_RANGE:"CODE_OUTSIDE_DATE_RANGE",NO_ELIGIBLE_ITEMS:"NO_ELIGIBLE_ITEMS",RATE_LIMITED:"RATE_LIMIT_EXCEEDED",USAGE_LIMIT_REACHED:"USAGE_LIMIT_REACHED"},type:{FIXED:"FIXED_AMOUNT",PERCENTAGE:"PERCENTAGE"},analyticsType:{FIXED:"flat",PERCENTAGE:"percent"},toAnalyticsType:function(t){return"PERCENTAGE"===t?"percent":"flat"},preCheckError:{PER_USER_LIMIT:"PER_USER_LIMIT",RATE_LIMIT:"RATE_LIMIT"}},item:{quantifier:{NONE:0,GENERIC:1,PER_MONTH:2}}})}();
angular.module('app').service('CrossSellService'
	, function(AppData
		, Package
		, Utilities
		, ClientInfo
		, $rootScope
	) {
		var CrossSellService = {};
		var consolidatedData = AppData.GetApplicationConsolidated;

		CrossSellService.loadCrossSells = function(cartSummaryData) {
			if (ClientInfo.deviceType === 'desktop' || ClientInfo.deviceType === 'tablet') {
				if (Utilities.childDefined(cartSummaryData, 'CHECKOUT_KEYWORDS.K')) {
					$rootScope.crossSells = cartSummaryData.CHECKOUT_KEYWORDS.K;

					//TODO: have a way of creating an enhanced ecommerce impression for cross sells.
					//$rootScope.$broadcast('triggerImpression', $scope.crossSells);
				} else {
					$rootScope.crossSells = null;
				}

				$rootScope.hideSpinner();
			}

			AppData.crossSells = false;
		};

		return CrossSellService;
	});
angular
	.module('app')
	.factory('Connection', function(
		$injector,
		$stateParams,
		$location,
		ClientInfo,
		CustomActionService,
		Enums,
		RequestPropertyStorageService,
		Utilities,
		UtilsValidation
	) {
		var services = Enums.services;
		var routes = Enums.routes;
		var validArray = UtilsValidation.validArray;
		var service = {};

		service.format =
		function(key, data, merchantId) {
			var request = this[key] ? this[key](data) : data;

			request.request_type = key;
			request._version = window.version || 'local-dev';
			//add additional request properties to all outgoing requests
			request.application_id = '1500';

			if (merchantId) {
				request.merchant_id = merchantId;
			}

			request.machine_id = '500';
			request.agent_id = '5';
			request.user_id = '5';
			this.cleanObject(request);
            RequestPropertyStorageService.getGlobalAPIRequestProperties().forEach(function(item) {
				if (!request.hasOwnProperty(item.prop_name)) {
					request[item.prop_name] = item.prop_value;
				}
			});
			return request;
		};

		service.cleanObject = function(obj) {
			var isArray = obj instanceof Array;
			for (var k in obj) {
				if (obj[k]===null) {
					isArray ? obj.splice(k, 1) : delete obj[k];
				} else if (obj[k] instanceof Array) {
					if (!obj[k].length) {
						delete obj[k];
					}
				} else if (typeof obj[k]=="object") {
					var count = 0;
					for (var i in obj[k]) {
						if (obj[k].hasOwnProperty(i)) {
							++count;
						}
					}
					if (count) {
						service.cleanObject(obj[k]);
					} else {
						delete obj[k];
					}
				}
			}
		}

		service[services.INITIALIZE_SOCKET] =
		function(data) {
		//	==========================================================
		//		Start: PayPal Support.
		//	----------------------------------------------------------
			// Building the base url for the site.
			var paypal_base_url = $location.$$protocol + '://'
				+ $location.$$host
				+ (($location.$$port != '80') ? ':' + $location.$$port : '');

			var paypal_suffix_url = '?';
			paypal_suffix_url += ($location.$$search._e) ? '&_e=' + $location.$$search._e : ''; // environment override
			paypal_suffix_url += ($location.$$search._m) ? '&_m=' + $location.$$search._m : ''; // merchant override
			paypal_suffix_url += ($location.$$search._d) ? '&_d=' + $location.$$search._d : ''; // debug override
			paypal_suffix_url += ($location.$$search.l) ? '&l=' + $location.$$search.l : ''; // language override

			if (paypal_suffix_url === '?') {
				paypal_suffix_url = '';
			}

			// Setting the Return and Cancel URLs.
			var paypal_cancel_url = paypal_base_url + '/' + routes.PAYPAL_CANCEL_URL + paypal_suffix_url;
			var paypal_return_url = paypal_base_url + '/' + routes.PAYPAL_RETURN_URL + paypal_suffix_url;

			//	----------------------------------------------------------
			//		END: PayPal Support.
			//	==========================================================


			var request =
				{
					merchant: Utilities.getMerchant(),
					language: $location.$$search.l || '',
					device: ClientInfo.deviceType,
					hostname: $location.$$host,
					// PROPS is formerly global_api_req_props
					PROPS: RequestPropertyStorageService.getGlobalAPIRequestProperties(),
					cart_key: data.cart_key || false,
					cart_id: data.cart_id || false,
					session_id: data.session_id || false,
					environment: $location.$$search._e,
					paypal_cancel_url: paypal_cancel_url || '',
					paypal_return_url: paypal_return_url || '',
					skip_requests: data.skip_requests || '',
					_ua: ClientInfo.userAgent,
					_os: ClientInfo.osName + ' - ' + ClientInfo.osVersion,
					_device: ClientInfo.deviceType + ' - ' + ClientInfo.deviceName + ' - ' + ClientInfo.deviceVersion,
					_browser: ClientInfo.browserName + ' - ' + ClientInfo.browserVersion,
					_referrer: document.referrer || '',
					_location: window.location.href || ''
				};


			['useSimpleFlow', 'knowledgebase_id', 'knowledgebase_gateway', 'knowledgebase_island', 'agent_id', 'user_id', 'machine_id', 'paypal_settings'].forEach(function(key) {
				if (data[key]) {
					request[key] = data[key];
				}
			});

			if (request.useSimpleFlow) {
				['island', 'merchant_id', 'keywords'].forEach(function addInitializeSocketData(key) {
					request[key] = data[key];
				});

				if (!request.language && data.language) {
					request.language = data.language;
				}
			}

			if (typeof data.skip_requests != 'undefined') {
				request.skip_requests = data.skip_requests;
			}

			if (typeof data.paypal_payer_id != 'undefined') {
				request.paypal_payer_id = data.paypal_payer_id;
			}

			if (typeof data.paypal_paypal_id != 'undefined') {
				request.paypal_id = data.paypal_id;
			}

			if (typeof data.paypal_token != 'undefined') {
				request.paypal_token = data.paypal_token;
			}

			var merchant_id = parseInt($location.$$search.merchant_id);
			if (!isNaN(merchant_id)) {
				request.merchant_id = merchant_id;
			}

			CustomActionService.executeCustomAction(CustomActionService.ACTIONS_ENUMS.INITIALIZE_SOCKET_POST_BUILD_REQUEST, request);

			return request;
		};

		service[services.GET_APPLICATION_CONSOLIDATED] =
		function(data) {
			var request =
				{
					language: ClientInfo.language,
					section_list: data.sectionList
				};
			return request;
		};

		service[services.GET_APPLICATION_LOCALE] =
		function(data) {
			var request =
				{
					language: ClientInfo.language,
					section_list: data.sections
				};
			return request;
		};

		service[service.GET_MERCHANT_PACKAGE_LIST] =
		function(data) {
			var request =
				{
					include_merchant_tree: data.includeMerchantTree,
					choose_random_package: data.chooseRandomPackage,
					keyword: data.upsellKeyword ? data.upsellKeyword : data.keyword,
					packages: data.packages,
					promos_only: data.promosOnly,
					promo_codes: data.promoCodes,
					referring_url: data.referringURL,
					show_details: data.showDetails,
					long_desc_flag: data.longDescFlag,
					include_comps: data.includeComps,
					zip_code: data.zipCode,
					latitude: data.latitude,
					longitude: data.longitude,
					accuracy: data.accuracy,
					_skip_cache: data.skip_cache,
					_no_cache: data.no_cache,
					get_groups: data.get_groups
				};

			return request;
		};

		service[services.SAVE_PURCHASE] =
		function(data) {
			var request = data;
			request.tiny_response = '1';
			request.software = ClientInfo.software;
			request.ver_id="";
			request.verify_attempt="1";
			request.version="4";
			return request;
		};

		service[services.GET_GROUP_CATEGORY] =
		function(data) {
			var request =
				{ cart_id: data.cart_id };
			return request;
		};

		service[services.GET_EVENT_SEATS] =
		function(data) {
			var request = data;
			return request;
		};

		service[services.GET_MERCHANT_KEYWORDS] =
		function(data) {
			var request = {
				version: '1', // @TODO: Why is this hardcoded? This was causing issues on the promo flow with the way the store was handling the reinit process if checksums have changed
				show_invisible_flag: '1' // @TODO: Why is this hardcoded?
			};
			return request;
		};

		service[services.GET_MERCHANT_PACKAGE_EVENT_DATES] =
		function(data) {

			var request = {
				P: data.P,
				extra_movie: data.extraMovie,
				identify_customer_types: data.identifyCustomerTypes,
				min_capacity: data.minCapacity,
				version: data.version
			};

			if (angular.isDefined(data.month)) {
				request.month = data.month;
			}

			if (angular.isDefined(data.startDate)) {
				request.start_date = data.startDate;
			}

			if (angular.isDefined(data.endDate)) {
				request.end_date = data.endDate;
			}

			if (angular.isDefined(data.displayZeroCapacity)) {
				request.display_zero_capacity = data.displayZeroCapacity;
			}
			if (angular.isDefined(data.include_times)) {
				request.include_times = data.include_times;
			}

			return request;
		};

		service[services.GET_MATRIX_DATES] =
		function(data) {
			var request =
				{
					customer_type: data.customerType,
					end_date: data.endDate,
					event_id: data.eventId,
					extra_movie: data.extraMovie,
					identify_customer_types: data.identifyCustomerTypes,
					min_capacity: data.minCapacity,
					month: 0,
					package_id: data.packageId,
					start_date: data.startDate,
					version: data.version,
				};
			return request;
		};

		service[services.GET_RENEWAL_SEASON_PASS_INFO] =
        function(data) {
        	var request = {};

        	if (angular.isDefined(data.first_name)) {
        		request.first_name = data.first_name;
        	}
        	if (angular.isDefined(data.last_name)) {
        		request.last_name = data.last_name;
        	}
        	if (angular.isDefined(data.birth_date)) {
        		request.birth_date = data.birth_date;
        	}
        	if (angular.isDefined(data.phone_number)) {
        		request.phone_number = data.phone_number;
        	}
        	if (angular.isDefined(data.address)) {
        		request.address = data.address;
        	}
        	if (angular.isDefined(data.pass_number)) {
        		request.pass_number = data.pass_number;
        	}
        	if (angular.isDefined(data.package_id)) {
        		request.package_id = data.package_id;
        	}

        	return request;
        }

		service[services.GET_CART_SUMMARY] =
		function(data) {
			if (!data.promoCodes) {
				data.promoCodes = '';
			}
			if (typeof data.check_cart == 'undefined') {
				data.check_cart = '1';
			}
			if (typeof data.include_checkout_keywords == 'undefined') {
				data.include_checkout_keywords = '1';
			}
			var request = {
				check_cart: data.check_cart,
				include_checkout_keywords: data.include_checkout_keywords,
				promo_codes: data.promoCodes,
				skip_requests: data.skip_requests
			};

			//
			// It's possbile to override the parameters passed in here
			// To do it, add the attribute "addRequestParameters" as follows:
			//
			// addRequestParameters = ["myp1", "myp2"]
			//
			// And specify those parameters on your data object.
			//
			if (angular.isDefined(data.addRequestParameters)) {
				data.addRequestParameters.forEach(function(currentRequestParameter) {
					request[currentRequestParameter] = data[currentRequestParameter];
				});
			}

			// Inject persisted discount code when the caller didn't provide one.
			if (!request.discount_code) {
				var persistedCode = $injector.get('UserInfo').getDiscountCode();
				if (persistedCode) {
					request.discount_code = persistedCode;
				}
			}

			return request;
		};

		// NOTE: Shop V4 does a bunch of checks before it actually makes
		// this service. It seems like it's related to validating data required
		// by XMC is in place.
		service[services.ADD_CART_ITEM] =
		function(data) {
			var request =
				{
					ITEMS:
					{ ITEM: data }
				};
			return request;
		};

		service[services.UPDATE_CART_ITEMS] =
		function(data) {
			var request = data;

			if (!data.ITEMS) {
				request = {ITEMS: { ITEM: data }};
			}

			return request;
		};

		/**
		 * @skipRequests is set to SetExpressCheckout for supporting PayPal and not to overwrite a current token.
		 * I'm hardcoding skip_requests to 'SetExpressCheckout' for this particular call.
		 * called in specific cases, and I need to make sure it doesn't call
		 * a chain reaction of other calls.
		 */
		service[services.UPDATE_CART_CHECKOUT_INFO] =
		function(data) {
			var request = {
				ship_method: data.shippingMethod,
				ship_amount: data.shippingAmount,
				skip_requests: 'SetExpressCheckout'
			};

			if (angular.isDefined(data.reset_checkout_info)) {
				return {
					reset_checkout_info: data.reset_checkout_info
				};
			}

			if (data.merchant_payment_type_ref_id) {
				request.merchant_payment_type_ref_id = data.merchant_payment_type_ref_id;
			} else {
				request.billing_type_id = data.billingId;
			}
			//AXF 16751 - missing billing_provider_id on UPDATE_CART_CHECKOUT_INFO
			//in case we need to pass other attribute into this call, we should add that attribute name and value
			//into this additional_property object
			if (validArray(data.additional_attributes)) {
				data.additional_attributes.forEach(function addAttributesToRequest(attribute) {
					request[attribute.name] = attribute.value;
				});
			}

			if (angular.isDefined(data.reset_checkout_info)) {
				request.reset_checkout_info = data.reset_checkout_info;
			}

			return request;
		};

		//	==========================================================
		//		START :: PayPal Support.
		//	----------------------------------------------------------

		/**
		 * Used when the user returns to the site from PayPal either
		 * - cancelling their paypal checkout, set status=0
		 * - completeing their paypal checkout, set status=1
		 */
		service[services.SET_PAYPAL_STATUS] =
		function(data) {
			var request =
				{
					token: data.token,
					status: data.status
				};
			return request;
		};

		service[services.GET_EXPRESS_CHECKOUT_DETAILS] =
		function(data) {
			var request =
				{ token: data.token };
			return request;
		};

		//	----------------------------------------------------------
		//		END :: PayPal Support.
		//	==========================================================

		service[services.ORDER_SEARCH] =
		function(data) {
			var request = {};
			request.phone_number = data.phoneNumber;

			if (typeof data.emailAddress != 'undefined') {
				request.email = data.emailAddress;
			}

			if (typeof data.lastFourDigits != 'undefined') {
				request.card_number = data.lastFourDigits;
			}

			if (typeof data.userId != 'undefined') {
				request.user_id = data.userId;
			}

			if (angular.isString(data.auth_code)) {
				request.auth_code = data.auth_code;
			}

			if (angular.isDefined(data.merchantId)) {
				request.merchant_id = data.merchantId;
			}

			if (data.mfa_code !== undefined) {
				request.mfa_code = data.mfa_code;
			}

			return request;
		};

		service[services.VIEW_ORDER] =
		function(data) {
			if (angular.isUndefined(data.show_print_at_home_details)) {
				data.show_print_at_home_details = 1;
			}

			if (!Utilities.safelyCheckPropertyOnObject('data.show_all_bundle_items', data)) {
				data.show_all_bundle_items = 1;
			}
			return data;
		};

		service[services.SAVE_QSMART] =
		function(data) {
		// order_id: $routedata.order_id // the orderId will be in the route when called.
			var request =
				{ order_id: $stateParams.orderId };
			return request;
		};

		service[services.GUIDE_SERVICE] =
		function(data) {
			var request =
				{
					action: "Read",
					GUIDES:
					{ id: data.topic }
				};
			return request;
		};

		service[services.SEARCH_ARTICLES] = function(data) {
			return {
				search_string: data.searchString,
				kb_id: data.kb_id
			};
		};

		service[services.INCREMENT_READ_COUNT] = function(data) {
			return {
				article_id: data.article_id,
				kb_id: data.kb_id
			};
		};


		service[services.IDEAL_GET_BANK_LIST] =
		function(data) {
			var request = data;
			return request;
		};

		service[services.IDEAL_AUTH] =
		function(data) {
			var request = data;
			return request;
		};

		service[services.MRCASH_AUTH] =
		function(data) {
			var request = data;
			return request;
		};

		service[services.PURCHASE] =
		function(data) {
			var request = data;
			request.tiny_response = '1';
			request.software = ClientInfo.software;
			request.ver_id="";
			request.verify_attempt="1";
			request.version="4";
			return request;
		};
		service[services.GET_RESOURCE_USAGE] =
				function(data) {
					var request = data;
					return request;
				};
		service[services.GET_NEW_CART_ID] =
				function(data) {
					var request = data;
					return request;
				};

		service[services.GET_CUSTOMER_INFO] =
		function(data) {
			var request = data;
			return request;
		};
		service[services.GET_WIZARD_DAY_PRICES] =
		function(data) {
			var request = data;
			return request;
		};
		service[services.REMOVE_DATA_TO_APPEND_TO_BACKEND_REQS] =
		function(data) {
		 var request = data;
		 request.internal_node_request_type = 1;
		 return request;
		};

		service[services.CLEAR_DYNAMIC_PRICE_ADJUSTMENT_CACHE] =
		function(data) {
			var AppData = $injector.get('AppData'),
				request = angular.copy(data);

			request.internal_node_request_type = 1;
			request.island = AppData.island;

			return request;
		};

		service[services.SAVE_DATA_TO_APPEND_TO_BACKEND_REQS] =
		function(data) {
		 var request = data;
		 request.internal_node_request_type = 1;
		 return request;
		};

		service[services.GET_WIZARD_PARK_PRICES] =
		function(data) {
			var request = data;
			return request;
		};

		service[services.ADD_IMAGE] =
		function(data) {
			var request = {
				merchant_uid: Utilities.getMerchant(),
				order_id: data.orderId,
				FILE: { name: data.imageFileName }
			}
			return request;
		};


		//----------------------------------
		// CART ABANDONMENT
		//---------------------------------
		service[services.SAVE_CART] =
		function(data) {
			var request = data;
			return request;
		};
		service[services.RETRIEVE_CART] =
				function(data) {
					var request = data;
					return request;
				};


		service[services.SEASON_PASS_LOAD] =
		function(data) {
			var request = data;
			return request;
		};
		/**
		 * Season Pass Image Save
		 *
		 * @param {Number} season_passholderful_season_pass_id	the season pass ID returned from viewOrder
		 * @param {Base64} season_passholderful_customer_image 	the JPEG encoded Base64 raw image data
		 * @param {DateTime} season_passholderful_customer_image_last_updated the time of the update formated as: "MM/DD/YYYY HH:MM:SS"
		 * @param {Number} image_encoding 0, v4 was 0, POS uses 0, we use 0. I dont know why, but its 0.
		 */
		service[services.SEASON_PASS_IMAGE_SAVE] =
		function(data) {
			var request = {};
			var now = new Date().toLocaleString().split(' ');
			var strToRemove = 'data:image/jpeg;base64,';

			//prefix 0 for before october
			if (+now[0].split('/')[0] < 10) {
				now[0] = "0" + now[0];
			}

			request.season_passholderful_season_pass_id = data.seasonPassID;
			request.season_passholderful_customer_image = data.image.substring(strToRemove.length);
			request.season_passholderful_customer_image_last_updated = now[0] + " " + now[1];
			request.image_encoding = data.imageEncoding;

			return request;
		};

		/***********************
		 ** PLACE RESERVATION **
		 ***********************/
		service[services.PLACE_RESERVATION] = function placeReservation(req) {
			var AppData = $injector.get('AppData');

			// Adds Cart ID to request
			req.cart_id = Utilities.getString(AppData.cart.cart_id);

			return req;
		};

		return service;
	});

/**
 * # Client Information Service
 *
 * Provides various details that describe the browser being used to render the
 * application as well as global variables specific to this instance needed to
 * properly render the correct templates/data
 *
 */
angular.module('app')
	.factory('ClientInfo',
		function(
			$location,
			$log,
			Storage,
			Logging,
			Utilities
		) {
			var ua = window.navigator ? window.navigator.userAgent: window.request ? window.request.headers['user-agent']: 'No User Agent'
			var parser = new UAParser();

			var info = {
				userAgent: ua,
				browserName: parser.getBrowser().name,
				browserVersion: parser.getBrowser().version,
				osName: parser.getOS().name,
				osVersion: parser.getOS().version,
				engineName: parser.getEngine().name,
				engineVersion: parser.getEngine().version,
				deviceName: parser.getDevice().name,
				deviceVersion: parser.getDevice().version,
				deviceUnknown: false,
				browserResults: parser.getBrowser(),
				deviceResults: parser.getDevice(),
				osResults: parser.getOS(),
				viewport_size: function() {
					return {
						height: window.innerHeight,
						width: window.innerWidth
					}
				},
				document_size: (function() {
					var height = Math.max(document.body.scrollHeight, document.body.offsetHeight, document.documentElement.clientHeight, document.documentElement.scrollHeight, document.documentElement.offsetHeight)
					var width = Math.max(document.body.scrollWidth, document.body.offsetWidth, document.documentElement.clientWidth, document.documentElement.scrollWidth, document.documentElement.offsetWidth)
					return {
						height: height,
						width: width
					}
				}()),
				orientation: (function() {
					return window.innerHeight > window.innerWidth ? 'portrait' : (window.orientation || 1) == 0 ? 'portrait' : 'landscape'
				}()),
				software: 'ShopV5', // @TODO: Append mobile, tablet, or desktop.
				animations: true,
				cartKey: Storage.get('cartId') || 0,
				cartId: Storage.get('cartKey') || 0,
				sessionId: Storage.get('sessionId') || 0,
				currentPage: '',
				previousPage: '',
				previousPages: []
			}

			function initialize() {
				var detectionMechanism;
				if (angular.isDefined(window.accessoDeviceInfo) && window.accessoDeviceInfo !== "") {
					detectionMechanism = 'Device Atlas';
					info.deviceType = window.accessoDeviceInfo;
				} else {
					detectionMechanism = 'accesso User Agent Match';
					info.deviceType = userAgentMatch(ua);
				}

				$log.info("Using device detection mechanism: " + detectionMechanism);
			}

			initialize();

			// Append devicetype to software.
			info.software += ': ' + info.deviceType;

			/**
			 * TODO: hostname: change the hostname reference to value of the server you are connecting to..
			 */

			function userAgentMatch(ua) {
				var match = ua.match(/GoogleTV|SmartTV|Internet.TV|NetCast|NETTV|AppleTV|boxee|Kylo|Roku|DLNADOC|CE\-HTML/i) ? 'tv'
					: ua.match(/Xbox|PLAYSTATION.3|Wii/i) ? 'tv'
						: ua.match(/iPad/i) || ua.match(/tablet/i) && !ua.match(/RX-34/i) && !ua.match(/Windows NT/) || ua.match(/FOLIO/i) ? 'tablet'
							: ua.match('Windows NT') && ua.match('ARM') ? 'tablet'
								: ua.match(/Linux/i) && ua.match(/Android/i) && !ua.match(/Fennec|mobi|HTC.Magic|HTCX06HT|Nexus.One|SC-02B|fone.945/i) ? 'tablet'
									: ua.match(/Kindle/i) || ua.match(/Mac.OS|Linux/i) && ua.match(/Silk/i) ? 'tablet'
										: ua.match(/GT-P10|SC-01C|SHW-M180S|SGH-T849|SCH-I800|SHW-M180L|SPH-P100|SGH-I987|zt180|HTC(.Flyer|\_Flyer)|Sprint.ATP51|ViewPad7|pandigital(sprnova|nova)|Ideos.S7|Dell.Streak.7|Advent.Vega|A101IT|A70BHT|MID7015|Next2|nook/i) || ua.match(/MB511/i) && ua.match(/RUTEM/i) ? 'tablet'
											: ua.match(/BOLT|Fennec|Iris|Maemo|Minimo|Mobi|mowser|NetFront|Novarra|Prism|RX-34|Skyfire|Tear|XV6875|XV6975|Google.Wireless.Transcoder/i) ? 'mobile'
												: ua.match(/Opera/i) && ua.match(/Windows.NT.5/i) && ua.match(/HTC|Xda|Mini|Vario|SAMSUNG\-GT\-i8000|SAMSUNG\-SGH\-i9/i) ? 'mobile'
													:ua.match(/iPhone/i) ? 'mobile'
														//Not sure if necessary
														//: ua.match(/Edge/i) ? 'desktop'
														: ua.match(/Windows.(NT|XP|ME|9|10)/) && !ua.match(/Phone/i) || ua.match(/Win(9|.9|NT)/i) || ua.match(/Win(10|.10|NT)/i) ? 'desktop'
															: ua.match(/Macintosh|PowerPC/i) && !ua.match(/Silk/i) ? 'desktop'
																: ua.match(/Linux/i) && ua.match(/X11/i) ? 'desktop'
																	: ua.match(/Chrome/i) && ua.match(/CrOS/) ? 'desktop'
																		: ua.match(/Solaris|SunOS|BSD/i) ? 'desktop'
																			: ua.match(/Bot|Crawler|Spider|Yahoo|ia_archiver|Covario-IDS|findlinks|DataparkSearch|larbin|Mediapartners-Google|NG-Search|Snappy|Teoma|Jeeves|TinEye/i) && !ua.match(/Mobile/i) ? 'desktop'
																				: 'unknown';

				if (match === 'unknown') {
					Logging.enabled = true;
					$log.error('Unknown device type: ' + ua);
					info.deviceUnknown = true;
					match = 'mobile';
				}

				return match;
			}

			info.getStoreClassification = function() {
				var dimension = info.viewport_size();
				var classification = dimension.width < 768 ? 'mobile' : dimension.width < 992 ? 'tablet' : 'desktop';

				return classification;
			}

			function onTransitionSuccess() {
				/**
				 * The following code is used for elements we want to show an hide based on the user history page.
				 * I can't use javascript's window.history due to security and privacy, so this is my solution.
				 * NOTE, $state.current does not work with this because if I use an ng-switch, and loadedTemplateUrl,
				 * something falls out of wack.
				 */
				if (info.previousPages) {
					// @TODO: This is causing an error. previousPages is sometimes undefined.
					if (info.previousPages.length >= 3) {
						info.previousPages.shift();
					}

					info.previousPages.push(info.currentPage);
					info.previousPage = info.currentPage;
					info.currentPage = $location.path();
				}
			}

			onTransitionSuccess();

			info.isPassbookDevice = function() {
				if (angular.isUndefined(info.deviceResults.model) ||
				  angular.isUndefined(info.browserResults.name) ||
				  angular.isUndefined(info.osResults)) {
					return false;
				}

				var is_iPod 	= !!info.deviceResults.model.match(/iPod/i);
				var is_iPhone 	= !!info.deviceResults.model.match(/iPhone/i);
				var is_Safari 	= !!info.browserResults.name.match(/Safari/i);
				var is_Chrome 	= !!info.browserResults.name.match(/Chrome/i);
				var is_iOS6 	= !!(info.osResults.name.match(/iOS/i) && (parseInt(info.osResults.version) >= 6));

				return !!(((is_iPod || is_iPhone) && (is_Safari || is_Chrome) && is_iOS6));
			}

			info.isWebcamSupported = function() {
				return info.deviceType === 'desktop' && Utilities.safelyCheckPropertyOnObject('navigator.mediaDevices.getUserMedia', navigator, angular.isFunction);
			}

			info.isFileUploadSupported = function() {
				return !!(window.FileReader && window.File) && !(info.osName.toLowerCase() === 'android' && info.osVersion === '4.4.2');
			}

			return info;
		})

/**
 * # Global string enumerations file
 *
 * Any strings that are used as a part of application logic should be defined
 * here, and their object key be referenced instead.
 *
 * This is especially useful in cases like $on event listeners where a typo in
 * the name would not ever error, but would simply never catch.
 *
 * By the extra work of defining enumerations for all strings and using those
 * enumerations avoids this by at least throwing undefined argument errors.
 *
 */

// @TODO: Move this to enums directory and rename to globalEnums.
angular
	.module('app')
	.factory('Enums', function($rootScope) {
		var enums = {
			displaySizes: {
				phone: 480,
				tablet: 768,
				desktop: 992,
				wideDesktop: 1200
			},
			urlParameters: {
				accessToken: 'access_token',
				affiliateUserName: 'username',
				affiliatePassword: 'password',
				autoComplete: '_a',
				brandmode: 'brandmode',
				brandmodenav: 'brandmodenav',
				headless: 'headless',
				campaignId: 'campaign_id',
				cartId: 'cart_id',
				cartKey: 'cart_key',
				cartRecovery: 'cartRecovery',
				cid: '_cid',
				code: 'code',
				debugMode: '_d',
				eMerchantId: 'emerchant_id',
				environment: '_e',
				googleAnalytics: '_ga',
				googleLink: '_gl',
				guestCheckout: 'guest_checkout',
				gttd: 'gttd',
				isUpgrade: 'upgrade',
				language: 'l',
				merchant: '_m',
				merchantId: 'merchant_id',
				mobileAppTraffic: 'mobile_app_traffic',
				navTreeVersion: 'navTreeVersion',
				promoCode: 'promocode',
				resellerId: 'reseller_id',
				resellerLocationId: 'reseller_location_id',
				sessionId: 'session_id',
				sessionIdShort: 's_id',
				state: 'state',
				te2InApp: 'te2_in_app',
				te2Session: 'te2_session',
				tradesFlag: 'trades_flag',
				tradesOrigin: 'trades_origin',
				tradesUuid: 'trades_uuid',
				unifiedPackageDetails: 'unifiedpackagedetails',
				utmSource: 'utm_source',
				utmMedium: 'utm_medium',
				utmCampaign: 'utm_campaign',
				utmTerm: 'utm_term',
				utmContent: 'utm_content',
				userToken: 'sfOffer',
				variantId: 'variant_id',
				skeleton: 'skeleton'
			},
			urlParametersAccessoPay: {
				AUTH_ID: 'acsop_aid',
				CARD_EXPIRY: 'acsop_cexp',
				CARD_LAST_FOUR: 'acsop_clf',
				CARD_TYPE_CODE: 'acsop_ctc',
				DONATION_AMOUNT: 'acsop_da',
				DONATION_STATUS: 'acsop_dst',
				ERROR_CODE: 'acsop_er',
				ERROR_CODE_DETAILS: 'acsop_erd',
				INSURANCE_AMOUNT: 'acsop_ia',
				INSURANCE_STATUS: 'acsop_ist',
				INVOICE: 'acsop_inv',
				PAYMENT_MERCHANT_ID: 'acsop_pid',
				PAYMENT_REFERENCE_ID: 'acsop_prid',
				PAYMENT_TYPE: 'acsop_pt',
				REDIRECT_BACKEND_STATUS_CODE: 'acsop_bsc',
				REDIRECT_PAYMENT_ID: 'acsop_pi',
				REDIRECT_URL: 'acsop_ul',
				REDIRECT_SESSION_TOKEN: 'acsop_t',
				RESULT_CODE: 'acsop_co',
				RESULT_ERROR_CODE: 'acsop_reco',
				STATUS: 'acsop_st',
			},
			payPalStatus: {
				cancelled: '0',
				complete: '1',
				inProgress: '-1'
			},
			purchaseError: {
				PENDING: 'pending',
				MODAL: 'modal',
				CART: 'cart',
				GATHER_PURCHASE_DETAILS: 'gather',
				ERROR_116: '116',
				ERROR_161: '161',
				ERROR_700: '700',
				DISCONNECT: 'disconnect',
				CATCH: 'catch'
			},
			services: {
				ADD_CART_ITEM: 'AddCartItem',
				ADD_CART_FORM_DATA: 'AddCartFormData',
				DELETE_CART_FORM_DATA: 'DeleteCartFormData',
				UPDATE_CART_FORM_DATA: 'UpdateCartFormData',
				GET_CART_FORM_DATA: 'GetCartFormData',
				ADD_TICKET_CHARACTERISTIC: 'AddTicketCharacteristicSecure',
				ADD_TICKET_CHARACTERISTICS: 'AddTicketCharacteristicSecure',
				ADDRESS_SEARCH: 'AddressSearch',
				ADDRESS_FORMAT: 'AddressFormat',
				ADYEN_ENROLLMENT_CHECK_3DS: 'AdyenEnrollmentCheck3DS',
				ADYEN_UPDATE_3DS_RESULT: 'AdyenUpdate3DSResult',
				APP_ACTIVATED: 'ApplicationActivated',
				APP_INIT: 'ApplicationInitialized',
				CANCEL_PAYMENT: 'CancelPayment',
				CHECK_CART: 'CheckCart',
				CLEAR_DYNAMIC_PRICE_ADJUSTMENT_CACHE: 'ClearDynamicPriceAdjustmentCache',
				CONTINUATION: 'Continuation',
				CREATE_DEPENDENT: 'CP_CreateDependent',
				CREATE_JWK: 'CreateJwk',
				CREATE_CARDINAL_JWT: 'createjwt',
				ENROLLMENT_CHECK_3DS: 'enrollmentCheck3DS',
				GENERATE_PASSWORD_TOKEN: 'CP_GeneratePasswordToken',
				LOST_PASSWORD_EMAIL: 'CP_LostPasswordEmail',
				GUIDE_SERVICE: 'Guide',
				IDENTITY_VERIFICATION: 'IdentityVerification',
				INCREMENT_READ_COUNT: 'IncrementReadCount',
				LOG_IN: 'CP_Login',
				LOG_OUT: 'CP_Logout',
				MAKE_NEW_LOGIN: 'CP_CreateProfile',
				PRINT_AT_HOME_ORDER: 'PrintAtHomeOrder',
				SAVE_PURCHASE: 'SavePurchase',
				SAVE_QSMART: 'SaveQsmart',
				PASSWORD_TOKEN_SWAP: 'CP_PasswordTokenSwap',
				PREPURCHASEAUTH: 'PrePurchaseAuth',
				PURCHASE: 'Purchase',
				ADD_IMAGE: 'AddImage',
				ORDER_SEARCH: 'GuestOrderSearch',
				PLACE_RESERVATION: 'PlaceReservation',
				REQUEST_EVENT_RESOURCE: 'RequestEventResource',
				RELEASE_EVENT_RESOURCE: 'ReleaseEventResource',
				RESET_PASSWORD_WITH_TOKEN: 'CP_ResetPassword',
				SEARCH_ARTICLES: 'SearchArticles',
				SEASON_PASS_ACTIVE: 'seasonPassActive',
				SEASON_PASS_NUMBER_SEARCH: 'SeasonPassNumberSearch',
				SEASON_PASS_LOAD: 'SeasonPassLoad',
				SET_EXPRESS_CHECKOUT: 'SetExpressCheckout',
				VALIDATE_AGE: 'ValidateAge',
				VALIDATE_EMAIL: 'ValidateEmail',
				VALIDATE_SEASON_PASS: 'ValidateSeasonPassID',
				VERIFY_DEFERRED_PACKAGES: 'VerifyDeferredPackages',
				VERIFY_B2B_LOGIN: 'verifyB2BUserLogin',
				VERIFY_EMAIL: 'verifyemail',
				VIEW_ORDER: 'GuestViewOrder',
				UPDATE_CART_CHECKOUT_INFO: 'UpdateCartCheckoutInfo',
				UPDATE_CART_ITEMS: 'UpdateCartItems',
				UPDATE_DEPENDENT: 'CP_UpdateDependent',
				UPDATE_LOGIN: 'CP_UpdateProfile',
				IDEAL_GET_BANK_LIST: 'iDealBankList',
				INITIATE_ALT_PAY: 'InitiateAltPay',
				INITIATE_GOOGLEPAY_TXN: 'InitiateGooglePayTransaction',
				IDEAL_AUTH: 'iDealAuth',
				MRCASH_AUTH: 'MisterCashAuth',
				GET_APPLICATION_CONSOLIDATED: 'GetApplicationConsolidated',
				GET_APPLICATION_CONFIG: 'GetApplicationConfig',
				GET_APPLICATION_CONFIG_SERVICE: 'GetApplicationConfig',
				GET_APPLICATION_NAVIGATION_TREE: 'GetApplicationNavigationTree',
				GET_APPLICATION_LOCALE: 'GetApplicationLocale',
				GET_ARTICLES_BY_DISPLAY_ORDER: 'GetArticlesByDisplayOrder',
				GET_ARTICLES_BY_TOPIC: 'GetArticlesByTopic',
				GET_CART_ID: 'GetCartID',
				GET_CART_SUMMARY: 'GetCartSummary',
				GET_DYNAMIC_PRICING_ADJUSTMENT: 'GetDynamicPricingAdjustment',
				GET_DYNAMIC_PRICING_ADJUSTMENT_CACHED: 'GetDynamicPricingAdjustmentCached',
				GET_EVENT_SEATS: 'GetEventSeats',
				GET_EXPRESS_CHECKOUT_DETAILS: 'GetExpressCheckoutDetails',
				GET_FORM: 'GetForm',
				GET_PACKAGE_FORMS: 'GetPackageForms',
				GET_GIFT_CARD_BALANCE: 'GetGiftCardBalance',
				GET_GIFT_CODE_REMAINING_COUNT: 'GetGiftCodeRemainingCount',
				GET_GROUP_CATEGORY: 'GetGroupCategory',
				GET_GUIDES_BY_TOPIC: 'GetGuidesByTopic',
				GET_KEYWORD_CALENDAR: 'GetKeywordCalendar',
				GET_KEYWORD_COMBO_CREATOR: 'GetKeywordComboCreator',
				GET_MEMBER_BENEFITS_AVAILABILITY: 'MemberBenefitsAvailability',
				GET_MERCHANT_DETAILS: 'GetMerchantDetails',
				GET_MERCHANT_KEYWORDS: 'GetMerchantKeywords',
				GET_MERCHANT_PACKAGE_DETAILS: 'GetMerchantPackageDetails',
				GET_MERCHANT_PACKAGE_EVENT_DATES: 'GetMerchantPackageEventDates',
				GET_MERCHANT_PACKAGE_LIST: 'GetMerchantPackageList',
				GET_MPCT_CALENDAR: 'GetMPCTCalendar',
				GET_NEW_CART_ID: 'GetNewCartID',
				PACKAGE_CALENDAR: 'PackageCalendar',
				GET_NOTHING: 'GetNothing',
				GET_OFFERS: 'GetOffers',
				GET_ORDER_ID_BY_CART_ID: 'GetOrderIDByCartID',
				GET_PARK_HOURS: 'GetParkHours',
				GET_PAYMENT_SCHEDULE: 'GetPaymentSchedule',
				GET_PROMO_CODE: 'GetPromoCode',
				GET_PROFILE: 'CP_GetProfile',
				GET_REDEEM_OFFERS: 'RedeemOffer',
				GET_RELATIONSHIP_CONSTANTS: 'CP_GetRelationshipConstants',
				GET_RENEWAL_INFO: 'GetRenewalInfo',
				GET_RENEWAL_SEARCH: 'GetRenewalSearch',
				GET_RENEWAL_SEASON_PASS_INFO: 'GetRenewalSeasonPassInfo',
				GET_RESOURCE_KEYWORD_CALENDAR: 'GetResourceKeywordCalendar',
				GET_RESOURCE_USAGE: 'GetResourceUsage',
				GET_SEASON_PASS_COUNT: 'GetSeasonPassCount',
				GET_CUSTOMER_INFO: 'GetCustomerInfo',
				GET_WIZARD_DAY_PRICES: 'GetWizardDayPrices',
				GET_WIZARD_PARK_PRICES: 'GetWizardParkPrices',
				SET_PAYPAL_STATUS: 'SetPayPalStatus',
				GET_MATRIX_DATES: 'GetWizardMPEventDates',
				GET_MATRIX_TIMES: 'GetWizardMPEventTimes',
				GET_FOLIO_TOKEN_INFO: 'GetFolioTokenInfo',
				SAVE_CART: 'SaveCart',
				SEASON_PASS_IMAGE_SAVE: 'SeasonPassImageSave',
				RETRIEVE_CART: 'retrieveCart',
				GET_ACTIVATION_SEASON_PASS_INFO: 'GetActivationSeasonPassInfo',
				GET_MERCHANT_PACKAGE_LIST_ACTIVATION: 'GetMerchantPackageListActivation',
				SAVE_DATA_TO_APPEND_TO_BACKEND_REQS: 'SaveDataToAppendToBackendRequests',
				REMOVE_DATA_TO_APPEND_TO_BACKEND_REQS: 'RemoveDataToAppendToBackendRequests',
				GUEST_LOOKUP: 'CP_GuestLookUp',
				RANDOM_PASSWORD: 'CP_RandomPassword',
				CHANGE_PASSWORD: 'CP_ChangePassword',
				CREATE_PROFILE: 'CP_CreateProfile',
				ADD_GUEST: 'CP_AddGuest',
				UPDATE_PROFILE: 'CP_UpdateProfile',
				TRANSFER_TOKEN: 'TransferToken',
				GET_CUSTOMER_TYPE_CHARACS: 'GetMPCTCharacs',
				GET_PACKAGE_SWAPS: 'GetPackageSwaps',
				GET_WTP_RELOAD: 'GetWtpReloadList',
				KEEPALIVE_TOKEN: 'KeepaliveToken',
				SEARCH_EVENT_DATES: "SearchEventDates",
				ADD_EVENT_WAITLIST: "CP_AddEventWaitlist",
				GET_EVENT_DATES_BY_CALENDAR: "GetEventDatesByCalendar",
				GET_EVENT_WAITLIST: "CP_GetEventWaitlist",
				REMOVE_EVENT_WAITLIST: "CP_RemoveEventWaitlist",
				GET_DEPENDENT_OTHER_INFO: "CP_GetDependentOtherInfo",
				CREATE_DEPENDENT_OTHER_INFO: "CP_CreateDependentOtherInfo",
				UPDATE_DEPENDENT_OTHER_INFO: "CP_UpdateDependentOtherInfo",
				GET_EVENT_CALENDAR_DATES: "GetEventCalendarDates",
				GET_RESELLER_DETAILS: "GetResellerDetails",
				TE2_CREATE_ACCOUNT: "TE2CreateAccount",
				TE2_UPDATE_OPTSTATUS: "TE2SetEmptyOrderLinkStatus",
				TE2_GET_PROFILE: "TE2GetProfile",
				GET_STORED_PAYMENT_CARDS: "RetrieveTokens",
				DELETE_STORED_CARD: "DeleteToken",
				REQUEST_SMS_CODE: "RequestSMSCode",
				VALIDATE_3DS: "validate3DS",
				VERIFY_SMS_CODE: "VerifySMSCode"
			},
			routes: {
				ACCESSO_PAY: 'accesso-pay',
				PRE_CART_AGREEMENT: 'preCartAgreementView',
				PRE_CART_WAIVER: 'riskWaiver',
				AGREEMENT: 'agreementView',
				BILLING: 'billingView',
				MRCASH: 'paymentProvider',
				IDEAL: 'paymentProvider',
				INFO: 'info',
				CART: 'cartView',
				CART_VIEW: 'cart.view',
				PENDING_ORDER: 'pendingOrder',
				CROSS_SELLS: 'crossSells',
				COMP_ASSIGNMENT: 'compAssignment',
				DETAILS: 'packageDetails',
				ENTITLEMENT_WIZARD: 'entitlement-wizard',
				ERROR: 'error',
				GIFT_AID: 'gift-aid.selection',
				KNOWLEDGEBASE: 'knowledgeBaseView',
				LIST: 'packageList',
				LISTKEYWORD: 'packageList/keyword',
				NAVITEM: 'packageList/navItem',
				ORDER_SEARCH: 'orderLookup',
				ORDER_HISTORY: 'orderHistory',
				ORDER_VIEW: 'orderView',
				ORDER_REVIEW: 'orderReview',
				PACKAGE_PLANNER: 'package-planner.package',
				PACKAGE_PLANNER_GUEST: 'package-planner.guest',
				PACKAGE_PLANNER_CALENDAR: 'package-planner.calendar',
				PAYMENT: 'paymentView',
				PAYPAL_CANCEL_URL: 'paypalCancelled',
				PAYPAL_CHECKOUT: 'https://www.paypal.com/cgi-bin/webscr?cmd=_express-checkout&token=',
				PAYMENT_METHOD: 'paymentMethod',
				PAYPAL_MOBILE_CHECKOUT: 'https://www.paypal.com/cgi-bin/webscr?cmd=_express-checkout-mobile&token=',
				PAYPAL_SANDBOX_CHECKOUT: 'https://www.sandbox.paypal.com/cgi-bin/webscr?cmd=_express-checkout&token=',
				PAYPAL_SANDBOX_MOBILE_CHECKOUT: 'https://www.sandbox.paypal.com/cgi-bin/webscr?cmd=_express-checkout-mobile&token=',
				PAYPAL_RETURN_URL: 'paypalComplete',
				PRIVACY: 'http://accesso.com/privacy-policy',
				PROMO: 'promocode',
				PROMOCODE: 'packageList/promocode',
				SEARCH: 'search',
				RECEIPT: 'receiptView',
				REVIEW: 'orderReview',
				SHIPPING: 'shippingView',
				TICKET: 'ticketView',
				UNKNOWN_MERCHANT: 'unknownMerchant',
				UNKNOWN_PAGE: 'unknownPage',
				UPSELL: 'upgrade',
				UPSELL_ALT: 'upgrade-alt',
				UPSELL_WIZARD: 'upsellWizard',
				UPSELL_WIZARD_ALT: 'upsellWizardAlt',
				UPSELL_RECOMMENDER_WIZARD: 'upsellRecommenderWizard',
				UPGRADE_RECOMMENDER_WIZARD: 'upgradeRecommenderWizard',
				UNASSIGNEDADDONS: 'unassignedAddons',
				WTPNUMBER: 'wtpnumber',
				RESELLER_BILLING: 'resellerBillingView'
			},
			extraFlowRoutes: {
				ASSIGNEDSEATING: 'assignedSeating',
				SEATGENIUS: 'seatGenius',
				CALENDAR: 'calendar',
				CALENDAR_BY_DAY: 'calendarPricingByDay',
				CALENDAR_TIMES: 'calendarPricingTimesByDay',
				CALENDAR_PRICING_EVENT: 'calendarPricingEvent',
				CALENDAR_IMAGE: 'calendarPricingWithImage',
				SAVINGS_CALENDAR: 'savingsCalendar',
				WIZARD_CALENDAR: 'wizardCalendar',
				COMP_ASSIGNMENT: 'compAssignment',
				DATEONLY: 'date',
				DATETIME: 'dateTime',
				DATETIMECAPACITY: 'dateTimeCapacity',
				DATETIMEBYDAY: 'dateTimeByDay',
				DATEBYDAY: 'dateByDay',
				EASYPAY: 'paymentPlan/EasyPay',
				FASTLANE: 'fastLane',
				GENERICFORM: 'genericForm',
				GIFTCODE: 'giftcode',
				GROUPSALES: 'groupSales',
				GROUPSALESWIZARD: 'groupSalesWizard',
				INFO: 'info',
				LICENSEPLATECAPTURE: 'licensePlateCapture',
				MATRIX: 'matrix',
				PAYLATER: 'paymentPlan/PayLater',
				PAYMENTPLANMULTI: 'paymentPlanMulti',
				RESERVATIONS: 'reservations',
				PARTICIPANT_PROGRAM: 'participantProgram',
				SEASON_PASS_RENEWALS: '/seasonPassOptionRenewal',
				ACTIVATE: 'activations',
				VERIFICATION: 'verification',
				SUBKEYWORD: 'subKeyword',
				GUESTOPTIONS: 'guestOptions',
				RECOMMENDERWIZARD: 'recommenderWizard',
				MEALS: 'meals',
				EXTRAS: 'extras',
				PACKAGE_COMPARISON_WIZARD: 'packageComparisonWizard',
				PACKAGE_COMPARISON: 'packageComparison',
				UPSELL_WIZARD: 'upsellWizard',
				CAMPS_ENROLLMENT: 'camps-enrollment'
			},
			messages: {
				UPDATE_BRANDMODE_HEIGHT: 'accesso:updateBrandModeHeight',
				BRANDMODE_ROUTING: 'accesso:brandModeRouting',
				CART_UPDATE: "accesso:cartUpdate",
				WILL_CLOSE: "accesso:willClose",
				REQUESTS_CLOSE: "accesso:requestsClose",
				GET_ORIGIN_OF_PARENT_WINDOW: "accesso:getOriginOfParent",
				GET_CURRENT_URL: 'accesso:getCurrentUrl',
				SET_CURRENT_URL: 'accesso:setCurrentUrl',
				RETRIEVED_PARENT_ORIGIN_INFO: "accesso:parentOriginInfo",
				// ACCESSO PAY EVENTS
				ACCESSO_PAY_APPLE_PAY_AUTHORIZED: 'accessoPay::applePayAuthorized',
				ACCESSO_PAY_APPLE_PAY_AVAILABILITY: 'accessoPay::applePayAvailability',
				ACCESSO_PAY_APPLE_PAY_CANCEL: 'accessoPay::applePayCancel',
				ACCESSO_PAY_APPLE_PAY_VALIDATE_MERCHANT: 'accessoPay::applePayValidateMerchant',
				ACCESSO_PAY_REDIRECT: 'accesso:accessoPayRedirect',
				ACCESSO_PAY_CLEAR_QUERY_PARAMS: 'accesso:accessoPayClearQueryParams',
				PURCHASE_SUCCESS: 'accesso:purchaseSuccess',
				// APPLEPAY EVENTS
				APPLEPAY_CHECK: 'accesso:checkForApplePay',
				APPLEPAY_ON_AVAILABLE: 'accesso:applePayAvailability',
				APPLEPAY_START: 'accesso:applePayStartSession',
				APPLEPAY_VALIDATE_MERCHANT: 'accesso:applePayValidateMerchant',
				APPLEPAY_SHIPPING_METHOD_SELECTED: 'accesso:applePayShippingMethodSelected',
				APPLEPAY_SHIPPING_METHOD_UPDATED: 'accesso:applePayShippingMethodUpdated',
				APPLEPAY_SHIPPING_CONTACT_SELECTED: 'accesso:applePayShippingContactSelected',
				APPLEPAY_SHIPPING_CONTACT_UPDATED: 'accesso:applePayShippingContactUpdated',
				APPLEPAY_AUTHORIZED: 'accesso:applePayAuthorized',
				APPLEPAY_CANCEL: 'accesso:applePayCancel',
				APPLEPAY_PAYMENT_RESPONSE: 'accesso:applePayPaymentResponse',
				APPLEPAY_VALIDATE_RESPONSE: 'accesso:applePayValidateResponse'
			},
			NON_PROMO_ROUTE: 'nonPromo',
			errorRoutes: {
				UNSUPPORTED_BROWSER: '1000',
				FAILED_TO_INIT: '1001',
				MISSING_MERCHANT: '1002',
				UNKNOWN_MERCHANT: '1003',
				UNKNOWN_PAGE: '1004'
			},
			buttonFlags: {
				YES: '0',
				NO: '10',
				OK: '20',
				CANCEL: '30',
				I_AGREE: '40',
				VERIFY: '50',
				CONTINUE_SHOPPING: '60',
				MAKE_CHANGES: '70',
				YES_CONTINUE: '80',
				PROCEED_TO_CHECKOUT: '90',
				NONE: '100',
				CLOSE: '200',
				RESET_BUTTON: '300',
				NO_THANKS: '400',
				LEARN: '500',
				CONFIRM: '600',
				SUBMIT: '610',
				DELETE: '620',
				ADD_TO_WAIT_LIST: '700',
				VIEW_CART: '710',
				SAVE: '800',
			},
			status: {
				FAILED: 'FAILED',
				OK: 'OK',
				ERROR: 'ERROR',
				INELIGIBLE_PASS: 'INELIGIBLE',
				UPDATED: 'UPDATED',
				CREATED: 'CREATED'
			},
			events: {
				blur: 'blur',
				change: 'change',
				click: 'click',
				contextmenu: 'contextmenu',
				copy: 'copy',
				cut: 'cut',
				dblclick: 'dblclick',
				error: 'error',
				focus: 'focus',
				focusin: 'focusin',
				focusout: 'focusout',
				hashchange: 'hashchange',
				keydown: 'keydown',
				keypress: 'keypress',
				keyup: 'keyup',
				load: 'load',
				mousedown: 'mousedown',
				mouseenter: 'mouseenter',
				mouseleave: 'mouseleave',
				mousemove: 'mousemove',
				mouseout: 'mouseout',
				mouseover: 'mouseover',
				mouseup: 'mouseup',
				mousewheel: 'mousewheel',
				paste: 'paste',
				reset: 'reset',
				resize: 'resize',
				scroll: 'scroll',
				select: 'select',
				submit: 'submit',
				textinput: 'textinput',
				unload: 'unload',
				wheel: 'wheel',
				applicationReady: 'accesso:applicationReady',
				purchaseComplete: 'accesso:purchaseComplete',
				postPurchaseComplete: 'accesso:postPurchaseComplete',
				removeCartItem: 'accesso:removeCartItem',
				postPurchaseSuccessGetNewCartIdAndOrder: 'accesso:postPurchaseSuccessGetNewCartIdAndOrder',
				checkExpressPaymentStatus: 'checkExpressPaymentStatus',

			},
			addressTypes: {
				BILLING: 'B',
				SHIPPING: 'S'
			},
			deliveryMethods: {
				CESTATION: 'A',
				ENTERPRISE_SHIPPING: 'B',
				CANADA_POST: 'C',
				FIRST_CLASS_MAIL_AND_PRINT_AT_HOME: 'D',
				ENTERPRISE_NO_SHIPPING: 'E',
				FED_EX_OVERNIGHT: 'F',
				UPS_EXPEDITED_AND_PRINT_N_GO: 'G',
				WDW_AND_USO: 'H',
				INTERNATIONAL_SHIPPING: 'I',
				PRINT_AT_HOME_AND_USO: 'J',
				UPS_GROUND: 'K',
				UPS_EXPEDITED: 'L',
				MOBILE: 'M',
				UPS_GROUND_AND_PRINT_N_GO: 'N',
				PRINT_AT_HOME_AND_WDW: 'O',
				PRINT_N_GO: 'P',
				PRINT_AT_HOME_AND_WDW_AND_USO: 'Q',
				USO: 'R',
				UPS_EXPEDITED2: 'S',
				WDW: 'T',
				FIRST_CLASS_MAIL: 'U',
				FIRST_CLASS_MAIL_AND_PRINT_N_GO: 'V',
				NO_SHIPPING: 'W',
				NONE: 'X',
				WILL_CALL: 'Y',
				WILL_CALL_AND_PRINT_AT_HOME: 'Z'
			},
			printAtHomeDeliveryMethods: ['P', 'J', 'O', 'Q'],
			addlSpecialDelivery: ['R', 'T', 'H'],
			paymentProvider: {
				ACCOUNT: 'ACT',
				APPLEPAY: 'ApplePay',
				BANCONTACT: 'bancontact',
				CASH: 'cash',
				CREDITCARD: 'cc', // is this the same as EC ?
				ELV: 'elv',
				EPS: 'eps',
				GIROPAY: 'giropay',
				IDEAL: 'ideal',
				LINEPAY: 'lnp',
				KOREANADYEN: 'kcp',
				MASTERPASS: 'masterpass',
				MRCASH: 'mrcash',
				MRCASHMOBILE: 'mrcashmobile',
				PAYPAL: 'paypal',
				PAYTRAIL: 'pyt',
				STOREDPAYMENTS: 'stp',
				STOREDVALUECARD: 'svc'
			},
			prePurchaseAuthRoute: "PREP",
			cepayErrorCodeToTix: { 4401: "100" },
			paymentMethodLocaleMapping: {
				"3ds": {
					locale: "ThreeDSecure",
					spriteName: '3DS'
				},
				alipay: {
					locale: "Alipay",
					spriteName: 'alipay'
				},
				bancontact: {
					locale: 'Bancontact',
					spriteName: 'bancontact'
				},
				eps: {
					locale: 'EPS',
					spriteName: 'eps'
				},
				giropay: {
					locale: 'Giropay',
					spriteName: 'giropay'
				},
				lnp: {
					locale: "Linepay",
					spriteName: 'lnp'
				},
				mrcash: {
					locale: "MrCash",
					spriteName: 'mrcash'
				},
				ideal: {
					locale: "Ideal",
					spriteName: 'ideal'
				},
				pyt: {
					locale: "PayTrail",
					spriteName: 'pyt'
				},
				kcp: {
					locale: "KoreanAdyen",
					spriteName: 'kcp'
				}
			},
			misterCashIdealParams: [
				'cart_key', 'cart_id', 'session_id', 'status', 'request_type', 'DPGReferenceId', 'TransactionId', '_ga', '_gac'
			],
			USERINFO_TO_PURCHASE_PAYMENT_OBJECT_MAPPINGS: {
				total: "amount",
				authType: "auth_type",
				billingId: "billing_id",
				billingType: "billing_type",
				cepayMerchantId: "cepay_merchant_id"
			},
			authTypes: {
				ACCOUNT: 'ACT',
				CASH: 'CSH',
				BANCONTACT: 'BCMC',
				CREDITCARD: 'EC',
				ELV: 'ELV',
				EPS: 'EPS',
				GIROPAY: 'GPY',
				IDEAL: 'IDL',
				LINEPAY: 'LNP',
				KOREANADYEN: 'KCP',
				MISTERCASHMOBILE: 'MRM',
				PAYPAL: 'PPA',
				PAYTRAIL: 'PYT',
				SECURE3D: '3DS',
				STOREDPAYMENTS: 'EC',
				STOREDVALUECARD: 'SVC',
				TESCO: 'TSC',
				ALIPAYDOMESTIC: 'ALD',
				ALIPAYINTERNATIONAL: 'ALI',
				CREDITCARD: 'EC',
				MISTERCASH: 'MRC'
			},
			billingTypes: {
				ACCOUNT: 'ACT',
				ALIPAY: 'ALI',
				BANCONTACT: 'BCMC',
				CASH: 'CSH',
				CREDITCARD: 'EC',
				ELV: 'ELV',
				EPS: 'EPS',
				GIROPAY: 'GPY',
				IDEAL: 'IDL',
				LINEPAY: 'LNP',
				KOREANADYEN: 'KCP',
				MISTERCASH: 'MRC',
				MISTERCASHMOBILE: 'MRM',
				PAYPAL: 'PPA',
				PAYTRAIL: 'PYT',
				SECURE3D: '3DS',
				STOREDPAYMENTS: 'EC',
				STOREDVALUECARD: 'SVC',
				TESCO: 'TSC'
			},
			billingProviders: {
				ADYEN: 'Adyen',
				ADYEN_APPLEPAY: 'Adyen_ApplePay',
				ADYEN_GOOGLEPAY: 'Adyen_GooglePay',
				CYBERSOURCE: 'Cybersource',
				CYBERSOURCE_CREDITCARD: 'Cybersource',
				CYBERSOURCE_MASTERPASS: 'Cybersource_Masterpass',
				CYBERSOURCE_APPLEPAY: 'Cybersource_Applepay',
				CYBERSOURCE_GOOGLEPAY: 'Cybersource_GooglePay'
			},
			billingProviderMapping: [{
				billing_provider_name: 'masterpass',
				billing_provider_suffix: 'MP'
			}],
			savedPurchaseAuthStatuses: {
				NO_SAVED_PURCHASE_STATUS: '0',
				NEW_STATUS: '1', // this is pretty much the same as pending, but the email has not been sent out yet
				PENDING_STATUS: '10',
				CONFIRMED_STATUS: '20',
				PURCHASED_STATUS: '30',
				FAILED_STATUS: '40',
				INCOMPLETE_STATUS: '5'
			},
			orderRetrievalStatuses: {
				FAILED_RESPONSE: 'FAILED RESPONSE',
				INSUFFICIENT_REQUEST_DATA: 'INSUFFICIENT REQUEST DATA'
			},
			participantTypes: {
				DOLPHIN_PARTICIPANT: 'dolphin_participant',
				DOLPHIN_PARTICIPANT_MEAL: 'dolphin_participant_meal',
				SID_PARTICIPANT: 'sid_participant',
				TFAD_PARTICIPANT: 'tfad_participant',
				TFAD_PARTICIPANT_DYNAMIC: 'tfad_participant_dynamic'
			},
			packageEventType: {
				DATE_ONLY_EVENT: '2',
				DATE_TIME_EVENT: '1'
			},
			remarketingPageTypes: {
				HOME: "home",
				SEARCH_RESULTS: 'searchresults',
				PACKAGE_LIST: 'category',
				PACKAGE_DETAIL: 'product',
				CART: 'cart',
				PURCHASE: 'purchase',
				OTHER: 'other'
			},
			CART_DETAILS_MAPPING_FOR_SET_EXPRESS_CHECKOUT_LEGACY: {
				//clarified with backend that the subtotal property is INDEED what we
				// should be passing in here as that is the total without shipping cost, which is how this needs to be sent.
				amount: { propertyOnCartDetails: 'cartDetails.subtotal' },
				retail_total: { propertyOnCartDetails: 'cartDetails.retail_total' },
				fee_total: { propertyOnCartDetails: 'cartDetails.fee_total' },
				ship_total: { propertyOnCartDetails: 'cartDetails.ship_total' },
				tax_total: { propertyOnCartDetails: 'cartDetails.tax_total' },
				cart_adjustment_total: { propertyOnCartDetails: 'cartDetails.cart_adjustment_total' },
				ITEMS: { propertyOnCartDetails: 'cartDetails.CART.ITEMS' },
				CART_ADJUSTMENTS: { propertyOnCartDetails: 'cartDetails.CART_ADJUSTMENTS' },
				FEES: { propertyOnCartDetails: 'cartDetails.FEES' },
				has_deferred: {
					propertyOnCartDetails: 'details.PAYMENT_SCHEDULE.PAYMENT',
					valueIfPresent: '1'
				}

			},
			CART_DETAILS_MAPPING_FOR_SET_EXPRESS_CHECKOUT: {
				//clarified with backend that the subtotal property is INDEED what we
				// should be passing in here as that is the total without shipping cost, which is how this needs to be sent.
				amount: { propertyOnCartDetails: 'cartDetails.deposit_transfer_total' },
				retail_total: { propertyOnCartDetails: 'cartDetails.deposit_transfer_subtotal' },
				fee_total: { propertyOnCartDetails: 'cartDetails.fee_total' },
				ship_total: { propertyOnCartDetails: 'cartDetails.ship_total' },
				tax_total: { propertyOnCartDetails: 'cartDetails.tax_total' },
				cart_adjustment_total: { propertyOnCartDetails: 'cartDetails.cart_adjustment_total' },
				ITEMS: { propertyOnCartDetails: 'cartDetails.CART.ITEMS' },
				CART_ADJUSTMENTS: { propertyOnCartDetails: 'cartDetails.CART_ADJUSTMENTS' },
				FEES: { propertyOnCartDetails: 'cartDetails.FEES' },
				has_deferred: {
					propertyOnCartDetails: 'details.PAYMENT_SCHEDULE.PAYMENT',
					valueIfPresent: '1'
				}

			},
			spRenewSearchOpts: {
				LASTNAME: 'spRenewalSearchLnameLabel',
				FULLNAME: 'spRenewalSearchFullNameLabel',
				PHONE: 'spRenewalSearchPhoneLabel',
				DATEOFBIRTH: 'spRenewalSearchBirthdayLabel',
				STREET: 'spRenewalSearchAddressLabel'
			},
			spRenewViewTypes: {
				RENEWAL: 'renewal',
				NEWPASS: 'new_season_pass'
			},
			spToggleDirections: {
				FORWARD: 1,
				BACKWARD: -1
			},
			spStates: {
				SELECTION: 'seasonPassOptionRenewal.selection',
				NEWPASSFORM: 'seasonPassOptionRenewal.newPassInformation',
				RENEWALPASSFORM: 'seasonPassOptionRenewal.renewalPassInformation'
			},
			spPassNumber: { NEW: 'NEW' },
			imageTypes: { BASE64: 0 },
			imageCaptureMethodTypes: {
				UPLOAD: 'upload',
				WEBCAM: 'webcam',
				MAIL: 'mail',
				ONSITE: 'onsite'
			},
			imageCaptureSaveTypes: {
				AMAZONS3: 'amazonS3',
				BACKEND: 'backend'
			},
			imageUpload: { MAX_SIZE: 8192 },
			orderCharacs: {
				LATITUDE: 'latitude',
				LONGITUDE: 'longitude',
				PAYMENT_SCHEDULE_ID_IN_CART: 'payment_schedule_id_in_cart',
				RESELLER_ID: 'reseller_id',
				RESELLER_LOCATION_ID: 'reseller_location_id',
				RESELLER_NAME: 'reseller_name'
			},
			ticketCharacs: { GUESTCUSTOMERNAME: "guestCustomerInfo" },
			orderStatus: { REFUNDED: 'Refunded' },
			modalHeaderFlags: {
				DANGER: 'danger',
				DEFAULT: 'default',
				GIFT: 'gift',
				NEW: 'new',
				PRIMARY: 'primary',
				PROMO: 'promo',
				SUCCESS: 'success'
			},
			modalTypes: {
				ADDTOCART: 'AddToCart',
				CONFIRMDATETIME: 'ConfirmDateTime'
			},
			paymentGateways: {
				ADYEN: 'adyen',
				CYBERSOURCE: 'cybersource'
			},
			screenSizeThresholds: {
				XS: 0,
				SM: 768,
				MD: 992,
				LG: 1200
			},
			deviceType: {
				MOBILE: 'mobile',
				DESKTOP: 'desktop'
			},
			// UI-Router transition rejection types (@uirouter/core RejectType enum).
			transitionRejectionType: {
				SUPERSEDED: 2,
				ABORTED: 3,
				IGNORED: 5
			}
		};

		$rootScope.Enums = enums;
		return enums;
	});

angular.module('app')
	.service('ExtraFlow', function(
		Enums,
		Language,
		Storage,
		AppData,
		$state
	) {
		var copy = angular.copy;
		var settings = {
			date_time: {
				name: 'date_time',
				view: Enums.extraFlowRoutes.DATETIME,
				showCapacityRemaining: false,
				lockQuantity: true,
				showTimeList: true,
				doEditMode: false,
				writeSingleCharac: false,
				enabled: true,
				type: 'extraFlowControl',
				characsList: ['start_date', 'start_time', 'event_id']
			},
			date_time_capacity: {
				name: 'date_time_capacity',
				view: Enums.extraFlowRoutes.DATETIMECAPACITY,
				showCapacityRemaining: false,
				lockQuantity: true,
				showTimeList: true,
				doEditMode: false,
				writeSingleCharac: false,
				enabled: true,
				type: 'extraFlowControl',
				characsList: ['start_date', 'start_time', 'event_id']
			},
			date_time_by_day: {
				name: 'date_time_by_day',
				view: Enums.extraFlowRoutes.DATETIMEBYDAY,
				showCapacityRemaining: false,
				lockQuantity: true,
				showTimeList: true,
				makeRequestForTimesOnEachDateChange: true,
				doEditMode: false,
				writeSingleCharac: false,
				enabled: true,
				type: 'extraFlowControl',
				characsList: ['start_date', 'start_time', 'event_id', 'external_id']
			},
			date_by_day: {
				name: 'date_by_day',
				view: Enums.extraFlowRoutes.DATEBYDAY,
				showCapacityRemaining: false,
				lockQuantity: true,
				showTimeList: false,
				makeRequestForTimesOnEachDateChange: true,
				doEditMode: false,
				writeSingleCharac: false,
				enabled: true,
				type: 'extraFlowControl',
				characsList: ['start_date', 'event_id', 'external_id']
			},
			date_time_by_day_single: {
				name: 'date_time_by_day_single',
				view: 'dateTimeByDaySingle',
				showCapacityRemaining: false,
				lockQuantity: true,
				showTimeList: true,
				makeRequestForTimesOnEachDateChange: true,
				makeRequestForSingleDatesOnly: true,
				doEditMode: false,
				writeSingleCharac: false,
				enabled: true,
				type: 'extraFlowControl',
				characsList: ['start_date', 'start_time', 'event_id']
			},
			date_by_day_single: {
				name: 'date_by_day_single',
				view: 'dateByDaySingle',
				showCapacityRemaining: false,
				lockQuantity: true,
				showTimeList: false,
				makeRequestForSingleDatesOnly: true,
				doEditMode: false,
				writeSingleCharac: false,
				enabled: true,
				type: 'extraFlowControl',
				characsList: ['start_date', 'event_id']
			},
			date: {
				name: 'date',
				view: Enums.extraFlowRoutes.DATETIME,
				showCapacityRemaining: false,
				lockQuantity: true,
				showTimeList: false,
				doEditMode: false,
				writeSingleCharac: false,
				enabled: true,
				type: 'extraFlowControl',
				characsList: ['start_date', 'event_id']
			},
			date_group: {
				name: 'date_group',
				view: Enums.extraFlowRoutes.DATETIME,
				showCapacityRemaining: false,
				lockQuantity: true,
				showTimeList: true,
				doEditMode: false,
				writeSingleCharac: false,
				enabled: true,
				type: 'extraFlowControl'
			},
			date_wizard: {
				name: 'date_wizard',
				view: Enums.extraFlowRoutes.DATETIME,
				showCapacityRemaining: false,
				lockQuantity: true,
				showTimeList: false,
				doEditMode: false,
				writeSingleCharac: false,
				enabled: true,
				serviceRequest: Enums.services.GET_MATRIX_DATES,
				type: 'extraFlowControl'
			},
			camp_date_picker: {
				name: 'camp_date_picker',
				view: Enums.extraFlowRoutes.DATETIME,
				showCapacityRemaining: true,
				lockQuantity: true,
				showTimeList: true,
				doEditMode: false,
				writeSingleCharac: false,
				enabled: true,
				type: 'extraFlowControl'
			},
			bundle_camp_date_picker: {
				name: 'bundle_camp_date_picker',
				view: Enums.extraFlowRoutes.DATETIME,
				showCapacityRemaining: true,
				lockQuantity: true,
				showTimeList: true,
				doEditMode: false,
				writeSingleCharac: true,
				enabled: true,
				type: 'extraFlowControl'
			},
			date_time_dolphin: {
				name: 'date_time_dolphin',
				aliases: ['date_time_swim'],
				view: Enums.extraFlowRoutes.DATETIME,
				showCapacityRemaining: false,
				lockQuantity: true,
				showTimeList: true,
				doEditMode: false,
				writeSingleCharac: false,
				enabled: true,
				type: 'extraFlowControl'
			},
			easy_pay: {
				aliases: ['ezpay', 'easy_pay_retail_only'],
				name: 'easy_pay',
				view: Enums.extraFlowRoutes.EASYPAY,
				xfcMapView: '/paymentPlan/:planType',
				//, showCapacityRemaining: false
				//, showTimeList: false
				doEditMode: true,
				writeSingleCharac: false,
				enabled: true,
				type: 'extraFlowControl'
				//, service: PaymentPlan
			},
			paylater: {
				name: 'paylater',
				view: Enums.extraFlowRoutes.PAYLATER,
				xfcMapView: '/paymentPlan/:planType',
				//, showCapacityRemaining: false
				//, showTimeList: false
				doEditMode: false,
				writeSingleCharac: false,
				enabled: true,
				type: 'extraFlowControl'
				//, service: PaymentPlan
			},
			payment_plan_multi: {
			   aliases: ['PaymentPlanMulti', 'paymentPlanMulti'],
			   name: 'payment_plan_multi',
			   view: Enums.extraFlowRoutes.PAYMENTPLANMULTI,
			   xfcMapView: '/paymentPlanMulti',
			   doEditMode: false,
			   writeSingleCharac: false,
			   enabled: true,
			   type: 'extraFlowControl',
			   requestMultiplePlans: true
			},
			FastLaneModule: {
				name: 'FastLaneModule',
				view: Enums.extraFlowRoutes.FASTLANE,
				doEditMode: false,
				lockQuantity: true,
				writeSingleCharac: false,
				enabled: true,
				type: 'alternateFlowModule',
				characsList: ['start_date', 'event_id']
			},
			SubKeywordModule: {
				name: 'SubKeywordModule',
				view: Enums.extraFlowRoutes.SUBKEYWORD,
				enabled: true,
				type: 'alternateFlowModule'
			},
			season_pass: {
				aliases: [
					'season_pass_norenew',
					'season_pass_thorpe',
					'season_pass_thorpe_new',
					'season_pass_thorpe_renew',
					'small_season_pass',
					'season_pass_family',
					'season_pass_family_renew',
					'small_season_pass_membership',
					'small_season_pass_basic_info',
					'season_pass_birth_date'
				],
				name: 'season_pass',
				view: 'seasonPass',
				subView: 'interstitial-dining-choice',
				doEditMode: true,
				lockQuantity: true,
				writeSingleCharac: false,
				enabled: true,
				type: 'extraFlowControl'
			},
			season_pass_renewal: {
				aliases: [
					'season_pass_renewal_lastname',
					'season_pass_cf_v2',
					'season_pass_cf_v2_copy_email',
					'season_pass_newpass',
					'season_pass_scz_newpass',
					'season_pass_name',
					'season_pass_name_num_child',
					'season_pass_name_num_child_only',
					'season_pass_name_num_child_req',
					'season_pass_name_num_child_guest',
					'season_pass_renewal_dob_phone',
					'season_pass_renewal_full_name'
				],
				name: 'season_pass_renewal',
				view: 'seasonPassOptionRenewal',
				viewIsStateName: true,
				parentName: 'season_pass_renewal',
				doEditMode: true,
				lockQuantity: true,
				writeSingleCharac: false,
				enabled: true,
				type: 'extraFlowControl',
				//package characs to check for that should be passed onto AddCartItem call - we check the current Package characs to look for these
				// if they exist, we have to set special flags on the cart item characs for Backend to know the classification type

				swapOptions: [
					'PassOptionEasyPayRenewalPackageId',
					'PassOptionPayLaterRenewalPackageId',
					'PassOptionDeferredRenewalPackageId',
					'PassOptionRenewalPackageId',
					'PassOptionParkingRenewalPackageId'
				],
				swapCharacs: {
					renewalWithSwapRenewalCharacs: {
						renewal_pass: 1,
						sp_swap: 1,
						sp_swap_renewal_flag: 1
					},
					defaultRenewal: { renewal_pass: 1 },
					newPassValues: { renewal_pass: 0 }
				},

				//a package charac to indicate whether we should check for a certain value that may be returned on the GetRenewalSeasonPassInfo call
				renewalVerificationCharacs: [{
					packageCharac: 'renewal',
					dataItem: 'guest_no'
				}],
				//package characs to check for that should be just carry over onto AddCartItem call if they exist on Package for Backend

				specialPackageCharacs: ['package_type', 'season_pass_type'],
				// if renewalSelected on a pass, add these characs - this is for specific XFCs such as the cedar fair (season_pass_cf_v2)

				renewalSelectedCharacs: {
					season_pass_cf_v2: { flex_no_print: 'true' },
					season_pass_cf_v2_copy_email: { flex_no_print: 'true' },
					default: {}
				},
				//on renewal option these are specific

				searchOptions: {
					season_pass_renewal_lastname: [{ localeName: Enums.spRenewSearchOpts.LASTNAME }],
					season_pass_cf_v2: [{ localeName: Enums.spRenewSearchOpts.PHONE }],
					season_pass_cf_v2_copy_email: [{ localeName: Enums.spRenewSearchOpts.PHONE }],
					season_pass_renewal_dob_phone: [{ localeName: Enums.spRenewSearchOpts.PHONE }, { localeName: Enums.spRenewSearchOpts.DATEOFBIRTH }],
					season_pass_renewal_full_name: [{ localeName: Enums.spRenewSearchOpts.FULLNAME }],
					default: [{ localeName: Enums.spRenewSearchOpts.PHONE }, { localeName: Enums.spRenewSearchOpts.DATEOFBIRTH }, { localeName: Enums.spRenewSearchOpts.STREET }]
				},
				renewalServiceCall: {
					season_pass_cf_v2: Enums.services.GET_RENEWAL_INFO,
					season_pass_cf_v2_copy_email: Enums.services.GET_RENEWAL_INFO,
					default: Enums.services.GET_RENEWAL_SEASON_PASS_INFO
				}
			},
			verification: {
				name: 'verification',
				aliases: [
					'multi_verification',
					'multi_verification_e2e',
					'bz_collect_member_id',
					'cf_season_pass_active',
					'cf_sp_code_single',
					'cz_verify_member_id',
					'scz_collect_member_id',
					'cf_sp_code_multi',
					'verification_with_images'
				],
				view: Enums.extraFlowRoutes.VERIFICATION,
				doEditMode: false,
				lockQuantity: true,
				enabled: true,
				writeSingleCharac: false,
				type: 'extraFlowControl',
				multiValidate: {
					default: false,
					multi_verification: true,
					multi_verification_e2e: true,
					cf_sp_code_multi: true
				},
				uniqueValues: {
					default: false,
					multi_verification: true,
					cf_sp_code_multi: true
				},
				localePrefix: {
					default: '',
					cf_sp_code_multi: 'cf_'
				},
				serviceCall: {
					default: Enums.services.VALIDATE_SEASON_PASS,
					multi_verification: Enums.services.SEASON_PASS_ACTIVE,
					multi_verification_e2e: Enums.services.VALIDATE_SEASON_PASS,
					cf_sp_code_single: Enums.services.SEASON_PASS_ACTIVE,
					cf_sp_code_multi: Enums.services.SEASON_PASS_ACTIVE,
					cf_season_pass_active: Enums.services.SEASON_PASS_ACTIVE
				},
				showPassInstructionImages: {

					default: false,
					cf_sp_code_single: true,
					cf_season_pass_active: true,
					cf_sp_code_multi: true,
					verification_with_images: true

				}
			},
			verifyPass: {
				name: 'VerifyPass',
				view: 'verify-pass',
				doEditMode: false,
				lockQuantity: true,
				enabled: true,
				writeSingleCharac: false,
				type: 'alternateFlowControl'
			}
		};


		settings.CLIENT_XFC_VIEW = 'client_xfc_view';
		settings.CLIENT_XFC_NAME = 'client_xfc_name';
		settings.CLIENT_ALTERNATE_VIEW = 'client_alternate_view';
		settings.CLIENT_ALTERNATE_NAME = 'client_alternate_name';

		/**
		 *	Constructor
		 *	Iterates through all the settings and if it finds aliases array, it creates a copy of that configuration.
		 *	This helps by not having to replicate a config item for each XFC.
		 */

		settings.__constructor = (function() {
			for (var key in settings) {
				var setting = settings[key];
				processAliases(setting);
				adjustPropertiesPerName(setting);
			}

			// Add XFC custom settings for those that were generated through alias.
			// Example: settings.season_pass_family.someKey = 'foo';
			// Note that settings.season_pass_family is set in the for loop above.

			return settings;
		}());

		function processAliases(setting, characListMapping) {
			if (setting.aliases) {
				for (var j = 0; j < setting.aliases.length; j++) {
					var settingsCopy = JSON.parse(JSON.stringify(setting));


					if (angular.isDefined(setting.service)) {
						settingsCopy.service = setting.service;
					}

					settingsCopy.name = setting.aliases[j];
					settings[settingsCopy.name] = settingsCopy;
					if (characListMapping && characListMapping.hasOwnProperty(settingsCopy.name)) {
						settings[settingsCopy.name].characsList = characListMapping[settingsCopy.name];
					}

					adjustPropertiesPerName(settings[settingsCopy.name]);

					delete settingsCopy.aliases;
				}

				delete setting.aliases;
			}
		}

		/**
		 * Method used by __constructor to set XFC properties based
		 * on the movie alias name, if the given property is an object with keys
		 *
		 * @param  {Object} xfcObj the xfc or alias clone
		 * @return {null}          sets properties directly on obj.
		 *
		 */
		function adjustPropertiesPerName(xfcObj) {
			for (var param in xfcObj) {
				var movieName = xfcObj[param];

				if (typeof xfcObj[param] == 'object' && xfcObj[param][xfcObj.name]) {
					var setting = xfcObj[param][xfcObj.name];
					xfcObj[param] = (setting != undefined) ? setting : (xfcObj[param].default) ? xfcObj[param].default : false;
				} else if (typeof xfcObj[param] == 'object') {
					xfcObj[param] = (xfcObj[param].default != undefined) ? xfcObj[param].default : xfcObj[param];
				}
			}
		}

		/**
		 * Changes all top level keys of an object to lower case
		 *
		 * @param {Object} obj object that needs lowercase keys
		 * @returns {Object} the object with all its keys set to lower case
		 */
		function keysToLowerCase(obj) {
			Object.keys(obj)
				.forEach(function(key) {
					var lowerKey = key.toLowerCase();

					if (lowerKey != key) {
						obj[lowerKey] = obj[key];
						delete obj[key];
					}
				});
			return obj;
		}


		/**
		 * Compares movies in list to ExtraFlow.settings object
		 * @param list
		 * @param stringList
		 * @returns {string|[]}
		 */
		settings.getEnabledXFCsFromList = function(list, stringList) {
			if (!(list && list.length > 0)) {
				if (stringList) {
					return '';
				} else {
					return [];
				}
			}

			// Testing Only.
			if (false) {
				// Duplicate this line for any XFC.
				if (list.indexOf('sp_reservation') == -1) {
					list += ',sp_reservation';
				}
			}

			var enabledSettings = [];
			var strListCntr = [];
			list = list.toLowerCase()
				.split(', ')
				.join()
				.split(',');

			// Since we are changing the extra movie list to lower case,
			// we also need to change any keys are are comparing against in settings
			// to lower case
			var settingsCopy = keysToLowerCase(copy(settings));

			if (list.length >= 1) {
				// There are XFCs. Let's ensure we have settings for each one.
				for (var i = 0; i < list.length; i++) {
					if (!settingsCopy[list[i]] || !settingsCopy[list[i]].enabled) {
						// This XFC does not have settings associated with it. Remove it from the array.
						list.splice(i, 1);
						i--;
					} else {
						// The XFC has settings associated with it. Create a reference object for it.
						enabledSettings.push({
							completed: false,
							name: settingsCopy[list[i]].name,
							data: null,
							view: settingsCopy[ list[ i]].view,
							viewIsStateName: settingsCopy[ list[ i]].viewIsStateName
						});

						// Keep track of the name only.
						strListCntr.push(list[i]);
					}
				}
			}

			if (stringList) {
				return strListCntr.join(',');
			} else {
				return enabledSettings;
			}
		};

		settings.addReferenceToCartItems = function(value, cartItems, reference) {
			// References:
			// client_xfc_view, client_xfc_name,
			// client_alternate_view, client_alternate_name.
			if (angular.isDefined(cartItems)) {
				for (var i = 0; i < cartItems.length; i++) {
					var item = cartItems[i];
					item.CHARACS = item.CHARACS || [];

					for (var j = 0; j < item.CHARACS.length; j++) {
						item.CHARACS[j] = item.CHARACS[j] || {};
						var itemCharac = item.CHARACS[j];

						// Set value if it doesn't exist else append it.
						itemCharac[reference] = itemCharac[reference] || '';
						itemCharac[reference] =
							(itemCharac[reference] == '') ? value : (itemCharac[reference].indexOf(value) > -1) ? itemCharac[reference] : itemCharac[reference] + ',' + value;
					}
				}
			}
		};

		/**
		 * Get modules registered settings
		 * @public
		 * @function
		 * @name getSettings
		 * @param {String} moduleName The mmodule's name
		 * @return {Object|null} The settings or null if it can't find it
		 */
		settings.getSettings = function(moduleName) {
			var settingsKeys = Object.keys(settings),
				settingsCount = settingsKeys.length,
				setting,
				i = 0;

			for (; i < settingsCount; i++) {
				setting = settings[settingsKeys[i]];

				if (angular.isObject(setting) && setting.name === moduleName) {
					if (setting.enabled) {
						return copy(setting);
					}

					break;
				}
			}

			return null;
		};

		settings.getAlternateFlowView = function(moduleName, currentKeyword) {
			for (var key in settings) {
				if (settings[key] && settings[key].name == moduleName) {
					if (settings[key].enabled) {
						var handler = { alternateModule: settings[key] };

						// TODO: Why is this here? Consider alternate function.
						Storage.set('pkgDetailsReInitControls', handler, true);
						if (settings[key].viewIsStateName) {
							var params = { keyword: AppData.lastKeyword };
							if (settings[key].type === "alternateFlowModule" && angular.isDefined(currentKeyword)) {
								params.keyword = currentKeyword;
							}
							//if we have some default args to also attach to the view, we need to attach them
							//currently no AlternateFlow uses this but this is built out for stored-value-card
							if (angular.isDefined(settings[key].viewDefaultArgs)) {
								angular.extend(params, settings[key].viewDefaultArgs);
							}
							return $state.href(settings[key].view, params);
						}
						return settings[key].view;
					}
				}
			}

			return '';
		};

		/**
		 * Check if the alternate flow setting view property is actually a state name instead of a URL
		 * This allows using a state name to route to with NO state params
		 * Otherwise, the alternate module routings will occur with a keyword state param
		 * @param moduleName
		 * @returns {*}
		 */
		settings.isAlternateFlowViewRepresentedAsAStateName = function(moduleName) {
			for (var key in settings) {
				if (settings[key] && settings[key].name == moduleName) {
					return settings[key].viewIsStateName;
				}
			}

			return false;
		}

		settings.getAlternateFlowSettings = function(moduleName) {
			for (var key in settings) {
				if (settings[key] && settings[key].name == moduleName) {
					if (settings[key].enabled) {
						return settings[key];
					}
				}
			}

			return null;
		};

		settings.isAlternateFlow = function(keyword, menuItems) {
			// TODO: Check associated keywords too.

			if (angular.isUndefined(keyword)) {
				return '';
			}

			for (var i = 0; i < menuItems.length; i++) {
				if (!menuItems[i].isactive) {
					continue;
				}

				var kws = menuItems[i].keywords.toLowerCase();
				if (kws.indexOf(keyword.toLowerCase()) > -1) {
					if (menuItems[i].alternateModule) {
						return menuItems[i].alternateModule;
					}
				} else if (menuItems[i].MENUITEM) {
					for (var j = 0; j < menuItems[i].MENUITEM.length; j++) {
						if (!menuItems[i].MENUITEM[j].isactive) {
							continue;
						}

						kws = menuItems[i].MENUITEM[j].keywords.toLowerCase();

						if (kws.indexOf(keyword.toLowerCase()) > -1) {
							if (menuItems[i].MENUITEM[j].alternateModule) {
								var altModule = menuItems[i].MENUITEM[j].alternateModule;
								if (menuItems[i].MENUITEM[j].MENUITEM) {
									var childResult = checkSubMenusForKeyword(menuItems[i].MENUITEM[j], keyword);
									if (angular.isDefined(childResult)) {
										altModule = (angular.isDefined(childResult.alternateModule) ? childResult.alternateModule : '');
									}
								}

								return altModule;
							}
						}
					}
				}
			}

			return '';
		};

		function checkSubMenusForKeyword(menuItem, keyword) {
			var subMenuResult = undefined;
			if (angular.isDefined(menuItem.MENUITEM)) {
				var subMenuItems = copy(menuItem.MENUITEM);
				for (var j = 0; j < subMenuItems.length; j++) {
					if (subMenuItems[j].keywords.toLowerCase()
						.indexOf(keyword.toLowerCase()) > -1) {
						subMenuResult = subMenuItems[j];
						break;
					}
				}
			}

			return subMenuResult;
		}

		settings.getXFCNamesByView = function(view) {
			var arr = [];

			for (var key in settings) {
				var settingsObj = settings[key];
				if (settingsObj && settingsObj.view == view) {
					arr.push(settingsObj.name)
				}
			}

			return arr;
		};

		settings.isXFCType = function(item, movieName) {
			if (!item.hasOwnProperty(movieName)) {
				return false;
			}

			var regex = new RegExp('\\b' + movieName + '\\b');
			return exists = (item.extra_movie.search(regex) > -1);
		};

		settings.getEditableXMCsFromList = function(list, searchProperty) {
			var extraMovies = settings.getEnabledXFCsFromList(list);

			return extraMovies.filter(function(e) {
				return settings[e.name] && settings[e.name][searchProperty];
			});
		};

		/**
		 * Register an XMC (Extra Movie or Alternate Flow) to this service's settings.
		 * @param {String} xmcName Name of the XMC, should match the 'name' field
		 * @param {Object} config Object containing various flags for behavior of the XMC
		 * @param {Object} characListMapping charac list mapping for aliases
		 * @returns {undefined}
		 */
		settings.registerXMC = function(xmcName, config, characListMapping) {
			if (settings[xmcName] !== undefined) {
				throw new Error("Attempted to reregister XMC: " + xmcName);
			}
			settings[xmcName] = config;
			processAliases(config, characListMapping);
		};

		settings.getXMCByName = function(xmcName) {
			return settings[xmcName];
		};

		/**
		 * Determines if the scheduling extra movie is defined on the item
		 * (This may replace the settings.isXFCType function on this service)
		 *
		 * @param item {Object} the current package from the Package.itemsToBeAdded array
		 * @param packageRef {Object} a reference to the Package service
		 * @returns {boolean} true indicates that scheduling exists; false indicates that it does not.
		 */
		settings.isXFCOnPackage = function(item, packageRef) {
			// extra_movie shows up as a package CHARAC when isEditMode === true instead of at the root of the obj
			var extra_movie = item.extra_movie;
			if (packageRef.isEditing()) {
				extra_movie = item.CHARACS[0].extra_movie;
			}

			return (angular.isDefined(extra_movie) && extra_movie.split(',')
				.indexOf(packageRef.settings.name) != -1);
		};

		/**
		 * If the XFC exists on the package item this function
		 * will remove references of the specified XFC from within the package item
		 * @param item {Object} the package item to update
		 * @param xfcToRemove {String} the name of the XFC to remove
		 */
		settings.removeXFCFromPackage = function(item, xfcToRemove) {
			var extra_movie = item.extra_movie || '';
			if (extra_movie.indexOf(xfcToRemove) === -1) {
				return;
			}

			item.extra_movie = settings.removeXFCFromString(extra_movie, xfcToRemove);

			var xfcCharacsList = settings[xfcToRemove].characsList || [];

			for (var i = 0; i < item.CHARACS.length; i++) {
				var itemCharacs = item.CHARACS[i];

				itemCharacs.extra_movie = item.extra_movie;
				itemCharacs[settings.CLIENT_XFC_VIEW] = settings.removeXFCFromString(itemCharacs[settings.CLIENT_XFC_VIEW], xfcToRemove);
				itemCharacs[settings.CLIENT_XFC_NAME] = settings.removeXFCFromString(itemCharacs[settings.CLIENT_XFC_NAME], xfcToRemove);

				for (var j = 0; j < xfcCharacsList.length; j++) {
					delete itemCharacs[xfcCharacsList[j]];
				}
			}
		};

		/**
		 * Removes the specified XFC from a comma separated list of XFC's.
		 * @param xfcs {String} the comma separated list of XFC's.
		 * @param xfcToRemove {String} the name of the
		 * @returns {string}
		 */
		settings.removeXFCFromString = function(xfcs, xfcToRemove) {
			var xfcList = xfcs.split(',');
			xfcList.splice(xfcList.indexOf(xfcToRemove), 1);
			return xfcList.join(',');
		}


		return settings;
	});

(function() {
	'use strict';

	angular
		.module('app')
		.factory('ExtraFlowValidationService', ExtraFlowValidationService);

	/**
	 * Validation service for extra flows
	 * @param {Service} $state $state
	 * @param {Service} ExtraFlow ExtraFlow
	 * @param {Service} Package ExtraFlow
	 * @param {Service} Utilities Utilities
	 * @returns {ExtraFlowValidationService} Our new instance
	 * @ngInject
	 */
	function ExtraFlowValidationService($state, ExtraFlow, Package, Utilities) {
		var service = { isActiveXFCRoute: isActiveXFCRoute };

		return service;

		/**
		 * Find out if you're in an active XFC route.
		 * @param {Object} toState The to state object.
		 * @param {Object} toParams The to params object
		 * @returns {Boolean} if we're in an active XFC or not.
		 */
		function isActiveXFCRoute(toState, toParams) {
			var packageDetails;
			var pckXFCs;
			var targetURL = $state.href(toState.name, toParams);

			if (angular.isObject(toParams) && toParams.packageId) {
				packageDetails = Package.getPackageByID(toParams.packageId);

				if (packageDetails) {
					pckXFCs = ExtraFlow.getEnabledXFCsFromList(packageDetails.extra_movie);

					return pckXFCs.some(function(xfc) {
						if (xfc.viewIsStateName) {
							if (xfc.view === toState.name
								|| Utilities.isValidChildStateOfParent(xfc.view, toState.name)) {
								return true;
							}

							// Check if destination is a sibling under the same parent as the XFC entry point.
							var xfcSiblingParent = xfc.view.substring(0, xfc.view.lastIndexOf('.'));
							return !!xfcSiblingParent && Utilities.isValidChildStateOfParent(xfcSiblingParent, toState.name);
						} else {
							return targetURL.indexOf(xfc.view) != -1;
						}
					});
				}
			}

			return false;
		}
	}
})();
'use strict';

angular.module('app')
	.factory('GatePriceComparison',
		function($filter, $rootScope, Language, Utilities) {
		// Default locales.
			Language.GatePriceSavings = Language.GatePriceSavings ||
			{
				percentSavingsMessage: 'Save @@amount vs gate price.',
				dollarSavingsMessage: 'Save @@amount vs gate price.',
				savingsHeadlinePercentMessage: 'Save upto @@amount vs gate price.',
				savingsHeadlineDollarMessage: 'Save upto @@amount vs gate price.',
				savingsHeadlineSinglePercentMessage: 'Save @@amount vs gate price.',
				savingsHeadlineSingleDollarMessage: 'Save @@amount vs gate price.',
				cartItemMessage: 'You saved @@amount vs gate price.',
				total_savings: 'Total Savings vs Gate'
			};

			var VIEWS_CONST = ['pkg_headline', 'pkg_details', 'quick_sell', 'cal_pricing', 'matrix_wizard', 'cart', 'all'];

			// Could not inject _AppData directly into GatePriceComparison due to circular dependency.
			var _AppData = null;
			var _inited = false;

			function initialize(appData) {
				_AppData = appData;

				_service.useGatePricing = _AppData.settings.use_gate_pricing || '';

				_service.gatePricingCart = _AppData.settings.gate_pricing_cart || 'total';

				_service.gatePricingViews = _AppData.settings.gate_pricing_views || '';

				if (_service.useGatePricing &&
				_service.useGatePricing === '1') {
					_service.useGatePricing = 'dollar';
				}

				if (_service.useGatePricing === '0') {
					_service.useGatePricing = false;
				}

				if (!_service.useGatePricing) {
					_service.gatePricingCart = false;
					_service.gatePricingViews = '';
				}

				_service.gatePricingViews = setGatePricingViews();
				setGatePriceOnAllPkgs();

				// Store the view settings globally to be accessed in the views.
				$rootScope.gatePricingViewSettings = _service.gatePricingViews;
			}

			/*
			* Parses out the settings for each view.
			*/
			function setGatePricingViews() {
			// Get the configs for the views that will show GPC.
				var gpv = {};
				if (_service.useGatePricing && _service.gatePricingViews && _service.gatePricingViews.toLowerCase() != 'all') {
					var viewSettings = _service.gatePricingViews;
					viewSettings = viewSettings.split(' ').join('').split(',');

					for (var i = 0; i < viewSettings.length; i++) {
					// Converts 'pkg_headline:1' to { view: pkg_headline, enabled: true }.
						var setting = viewSettings[ i ].split(':');
						gpv[ setting[ 0 ] ] = Utilities.getBoolean(setting[ 1 ]);
					}
				}

				for (var i = 0; i < VIEWS_CONST.length; i++) {
					if (_service.gatePricingViews.toLowerCase() == 'all') {
					// If all is the views settings, then set flag for all views to true.
						gpv[ VIEWS_CONST[ i ] ] = true;
					} else if (typeof(gpv[ VIEWS_CONST[ i ] ]) == 'undefined') {
					// Set the visibility flag to views that aren't set to false.
						gpv[ VIEWS_CONST[ i ] ] = false;
					}
				}

				return gpv;
			}

			/**
		* Sets a gatePrice object on all applicable packages.
		*/
			function setGatePriceOnAllPkgs() {
				var setting = [];

				if (packageExist()) {
					for (var i = 0; i < _AppData.GetMerchantPackageList.PS.P.length; i++) {
						var pkgItem = _AppData.GetMerchantPackageList.PS.P[ i ];
						configurePackage(pkgItem);
					}
				}
			}

			function configurePackage(pkgItem) {
				var useVAT = _AppData.defaults.use_vat;

				var characs = pkgItem.CHARACS || { gate_price: '' };
				var setting = parseGatePriceSettings(characs.gate_price);
				var highestSavings = 0;

				if (setting && setting.length) {
					for (var j = 0; j < setting.length; j++) {
						for (var k = 0; k < pkgItem.CT.length; k++) {
							if (setting[ j ].ctID === pkgItem.CT[ k ].id &&
							setting[ j ].price != pkgItem.CT[ k ].retail_amount) {
								var ctItem = pkgItem.CT[ k ];

								// Set this based one whether we're using VAT or not.
								var retAmt = Utilities.getTotalPrice(ctItem);
								var dollarSavings = Utilities.correctFloatingPointError(Number(setting[ j ].price) - retAmt, 2);
								var percentSavings = Utilities.correctFloatingPointError((1 - (retAmt / setting[ j ].price)) * 100, 2);

								var percentMessage =
								Language.GatePriceSavings.percentSavingsMessage
									.split('@@amount')
									.join(percentSavings + '%');
								percentMessage = Utilities.escapeHtmlEntities(percentMessage);

								var dollarMessage =
								Language.GatePriceSavings.dollarSavingsMessage
									.split('@@amount')
									.join($filter('currencyFormatter')(dollarSavings));
								dollarMessage = Utilities.escapeHtmlEntities(dollarMessage);

								var finalMessage = (_service.useGatePricing.toLowerCase() === 'percent') ? percentMessage : dollarMessage;

								// Update the CT node with the gate price, difference and percentage savings.
								var client_app_gate_price =
								{
									gate_price: Number(setting[ j ].price),
									dollar_savings: dollarSavings,
									percent_savings: percentSavings,
									save_percent_message: percentMessage,
									save_dollar_message: dollarMessage,
									savings_message: finalMessage
								};

								// Get the highest savings so far (percentage or dollar).
								if (_service.useGatePricing.toLowerCase() == 'percent') {
									highestSavings = (highestSavings > percentSavings) ? highestSavings : percentSavings;
								} else {
									highestSavings = (highestSavings > dollarSavings) ? highestSavings : dollarSavings;
								}

								// If there are no savings, delete the message.
								if (highestSavings <= 0) {
									client_app_gate_price.savings_message = '';
								}

								pkgItem.CT[ k ].client_app_gate_price = client_app_gate_price;
							}
						}

						setSavingsMessage(pkgItem, highestSavings);
					}
				}
			}

			/*
			* Helper function to set the savings message.
			*/
			function setSavingsMessage(pkgItem, highestSavings) {
			// Set the package headline.
				if (highestSavings) {
					if (_service.useGatePricing.toLowerCase() === 'percent') {
						if (pkgItem.CT.length == 1) {
							pkgItem.client_gate_savings =
							Language.GatePriceSavings.savingsHeadlineSinglePercentMessage
								.split('@@amount')
								.join(highestSavings + '%');
						} else {
							pkgItem.client_gate_savings =
							Language.GatePriceSavings.savingsHeadlinePercentMessage
								.split('@@amount')
								.join(highestSavings + '%');
						}
					} else {
						if (pkgItem.CT.length == 1) {
							pkgItem.client_gate_savings =
							Language.GatePriceSavings.savingsHeadlineSingleDollarMessage
								.split('@@amount')
								.join($filter('currencyFormatter')(highestSavings));
						} else {
							pkgItem.client_gate_savings =
							Language.GatePriceSavings.savingsHeadlineDollarMessage
								.split('@@amount')
								.join($filter('currencyFormatter')(highestSavings));
						}
					}

					pkgItem.client_gate_savings = Utilities.escapeHtmlEntities(pkgItem.client_gate_savings);
				}
			}

			/*
			* Creates an array of objects containing the gate pricing for any given CT.
			* Expects string formatted as 230:10.99,231:15.99,232:12.99.
			*/
			function parseGatePriceSettings(setting) {
				var ctPrices = [];
				if (setting) {
					ctPrices = setting.split(' ').join('').split(',');

					for (var i = 0; i < ctPrices.length; i++) {
					// Converts '230:10.99' to { ctID: 230, price: 10.99 }.
						var ctIDPrice = ctPrices[ i ].split(':');
						ctPrices[ i ] = {
							ctID: ctIDPrice[ 0 ],
							price: ctIDPrice[ 1 ]
						}
					}

					return ctPrices;
				}

				return [];
			}

			/*
			* Helper function that determines if we have packages.
			*/
			function packageExist() {
				return _AppData &&
				  _AppData.GetMerchantPackageList &&
				  _AppData.GetMerchantPackageList.PS &&
				  _AppData.GetMerchantPackageList.PS.P &&
				  _AppData.GetMerchantPackageList.PS.P.length;
			}


			/*
			* Sets gate pricing details on cart items if applicable.
			*/
			function setCartItemGatePriceDetails(cartItems) {
				if (_service.useGatePricing && _service.gatePricingViews && _service.gatePricingViews.cart && cartItems) {
					var sumSavings = 0;
					for (var i = 0; i < cartItems.length; i++) {
						var cartItem = cartItems[ i ];

						for (var j = 0; j < _AppData.GetMerchantPackageList.PS.P.length; j++) {
							var pkgItem = _AppData.GetMerchantPackageList.PS.P[ j ]

							if (cartItem.package_id === pkgItem.id) {
								for (var k = 0; k < pkgItem.CT.length; k++) {
									var cType = pkgItem.CT[ k ];

									// Only set the Gate Price savings for the CT that matches
									if (parseInt(cartItem.customer_type) !== parseInt(pkgItem.CT[k].id)) {
										continue;
									}

									if (!cType.client_app_gate_price) {
										break;
									}

									var gatePriceData = cType.client_app_gate_price;
									var itemSavingsTotal = gatePriceData.dollar_savings * cartItem.qty;
									sumSavings += itemSavingsTotal;

									if ((_service.gatePricingCart.toLowerCase() == 'item' ||
									_service.gatePricingCart.toLowerCase() == 'both') &&
									gatePriceData) {
									// Add details pertaining to gate price savings on the cart item.

										// Get the highest savings so far (percentage or dollar).
										if (_service.useGatePricing.toLowerCase() == 'percent') {
											cartItem.client_gate_savings = Language.GatePriceSavings.cartItemMessage.split('@@amount').join(String(gatePriceData.percent_savings + '%'));
										} else {
											cartItem.client_gate_savings = Language.GatePriceSavings.cartItemMessage
												.split('@@amount')
												.join($filter('currencyFormatter')(itemSavingsTotal));
										}
									}
									cartItem.client_gate_savings = Utilities.escapeHtmlEntities(cartItem.client_gate_savings);
								}

								break;
							}
						}
					}

					// If we're not concerned with the total savings - wipe it out.
					if (_service.gatePricingCart.toLowerCase() == 'item') {
						sumSavings = 0;
					}

					_service.totalSavings = Utilities.correctFloatingPointError(sumSavings, 2);
					$rootScope.gatePriceTotalSavings = _service.totalSavings;
				}
		 }

			/**
		* Listening to ALL getCartSummary response.
		* Parse the response and add gate pricing details.
		*/
			$rootScope.$on
			(
				'getCartSummaryResponse',
				function(event, data) {
					if (data) {
						if (data &&
							data.CART &&
							data.CART.ITEMS &&
							data.CART.ITEMS.ITEM) {
							if (_inited) {
								setCartItemGatePriceDetails(data.CART.ITEMS.ITEM);
							}
						}
					}
				}
			);

			var _service =
			{
				/**
				 * Top flag to determine whether to show gate pricing or not.
				 * Values: 0 | 1 | percent | dollar. 1 is assumed to be dollar (1 and dollar are interchangeable).
				 * @type {Boolean, String}
				 */
				 useGatePricing: false,

				/**
				 * Flag to determine how it gate price savings should render on the cart (either on the item or total or both).
				 * Values: item | total | both. Determines where the gate price savings is shown (cart line item/total)
				 * @type {String}
				 */
				gatePricingCart: true,

				/**
				* Flags containing a list of views to explicitly show or hide. Not set defaults to gate pricing not showing for that view.
				* Setting it to 'all' renders gate pricing on all applicable views.
				* Not setting it is akin to setting useGatePricing to false.
				* Options: pkg_headline, pkg_details, cal_pricing, matrix_wizard, cart, all
				* Value: 1|0|all
				* Value (sample): pkg_headline:1,pkg_details:0,cal_pricing:1
				* Value: all
				*/
				gatePricingViews: '',

				/**
				* Keeps track of the total savings. This gets updated every time we have a new car summary.
				*/
				totalSavings: 0,

				init: function(appData) {
					if (!_inited) {
						initialize(appData);

						// Fake a get cart summary response.
						_inited = true;
						$rootScope.$broadcast('getCartSummaryResponse', _AppData.GetCartSummary);
					}
				 },

				setGatePriceOnPkgItem: function(pkgItem) {
					configurePackage(pkgItem);
				 }
			}

			return _service;
		}
	);

angular.module('app').service('Geolocation', function(
	$rootScope,
	CustomActionService,
	AppData,
	ClientInfo,
	Enums,
	JSONValidator,
	Storage,
	Utilities,
	$q
) {
	var _pendingFetch = false;

	var service = {
		assessedGeolocation: false,
		requestedGeolocation: false,
		position: {},
		error: {},
		useLocation: false,
		geoLocationEnabledForMerchant: false
	};

	/**
	 * Checks for the app config use_location
	 * @protected
	 * @returns {boolean} determines the validity of the app config
     */
	function isGeolocationEnabled() {
		var enabled = false;

		if (JSONValidator.validate('use_location', AppData.settings.use_location)) {
			var config = JSON.parse(AppData.settings.use_location);
			if ((Utilities.getBoolean(config.enableMobile) && ClientInfo.deviceType === 'mobile') || (Utilities.getBoolean(config.enableTablet) && ClientInfo.deviceType === 'tablet')) {
				enabled = true;
			}
		}

		return enabled;
	}

	/**
	 * This function is used to register a custom action that will add geolocation order characs to the purchase call
	 * @protected
	 * @return {boolean} determines if geo location has been turned on for the current device
	 */
	function shouldUseLocation() {
		var enabled = false;

		if (service.geoLocationEnabledForMerchant) {
			var config = JSON.parse(AppData.settings.use_location);

			if ((Utilities.getBoolean(config.enableMobile) && ClientInfo.deviceType === 'mobile') || (Utilities.getBoolean(config.enableTablet) && ClientInfo.deviceType === 'tablet')) {
				enabled = true;
			}
		}

		return enabled;
	}

	/**
	 * Adds order characs at the time of purchase for longitude and latitude if user has shared this data
	 * @protected
	 * @param {array} orderCharacs - characs used in reporting when purchase is made
	 * @return {undefined}
	 */
	function addGeolocationCharacs(orderCharacs) {
		if (Utilities.safelyCheckPropertyOnObject('service.position.coords', service)) {
			addCharac(Enums.orderCharacs.LATITUDE, service.position.coords.latitude);
			addCharac(Enums.orderCharacs.LONGITUDE, service.position.coords.longitude);
		}

		/**
		 * Adds characs to order characs
		 * @protected
		 * @param {string} key - key for charac
         * @param {number} value - value of charac
		 * @return {undefined}
         */
		function addCharac(key, value) {
			if (angular.isDefined(key) && angular.isDefined(value)) {
				var newCharac = {};
				newCharac[key] = value;
				orderCharacs.push(newCharac);
			}
		}
	}

	/**
	 * Makes GetMerchantPackageList call to determine package swaps
	 * @protected
	 * @param {boolean} geoLocationEnabled determines is geo location has been turned on for current device
	 * @returns {Promise} Indicates that the get merchant package list call was successful or not
     */
	function fetchGeolocationKeywordSwap(geoLocationEnabled) {
		return $q(function(resolve, reject) {
			if (_pendingFetch) {
				reject();
			}
			_pendingFetch = true;

			var requestObject = {
				geo_location_offered: geoLocationEnabled ? '1' : '0',
				_skip_cache: true,
				_no_cache: true,
				show_details: '1',
				long_desc_flag: '1',
				keyword: service.merchantKeywordsData.keywords || ''
			};

			var coordinates = service.position.coords;

			if (geoLocationEnabled) {
				requestObject.latitude = coordinates.latitude;
				requestObject.longitude = coordinates.longitude;
				requestObject.accuracy = coordinates.accuracy;
			}
			$rootScope.showSpinner();

			AppData.fetch(Enums.services.GET_MERCHANT_PACKAGE_LIST, false, requestObject).then(function(data) {
				var swappedCurrentKeyword = false;
				_pendingFetch = false;

				if (data.status == Enums.status.OK && Utilities.getBoolean(data.geoLoc_override) && typeof data.KEYWORDSWAP != 'undefined') {
					if (data.KEYWORDSWAP.type == 'geolocation' && typeof((data).KEYWORDSWAP || {}).SWAP != 'undefined') {
						data.KEYWORDSWAP.SWAP = angular.isArray(data.KEYWORDSWAP.SWAP) ? data.KEYWORDSWAP.SWAP : [data.KEYWORDSWAP.SWAP];
						Storage.set('_geolocationSwap', data.KEYWORDSWAP.SWAP, true);

						for (var i in data.KEYWORDSWAP.SWAP) {
							if (data.KEYWORDSWAP.SWAP[i].keyword && data.KEYWORDSWAP.SWAP[i].swap_keyword) {
								for (var j in AppData.menuItems) {
									var mItem = AppData.menuItems[j];

									if (mItem.keywords == data.KEYWORDSWAP.SWAP[i].keyword) {
										mItem._keywords = mItem.keywords;
										mItem.keywords = data.KEYWORDSWAP.SWAP[i].swap_keyword;
									}

									if (typeof mItem.MENUITEM != 'undefined') {
										for (var k in mItem.MENUITEM) {
											var mSubItem = mItem.MENUITEM[k];
											if (mSubItem.keywords == data.KEYWORDSWAP.SWAP[i].keyword) {
												mSubItem._keywords = mSubItem.keywords;
												mSubItem.keywords = data.KEYWORDSWAP.SWAP[i].swap_keyword;
											}
										}
									}
								}

								if (typeof AppData.lastKeyword == 'string' && AppData.lastKeyword == data.KEYWORDSWAP.SWAP[i].keyword && !swappedCurrentKeyword) {
									AppData.updateLastKeyword(data.KEYWORDSWAP.SWAP[i].swap_keyword, "geolocation fetchGeolocationKeywordSwap");
									swappedCurrentKeyword = true;
								}
							}
						}
					}
				}

				if (swappedCurrentKeyword) {
					if (AppData.lastKeyword) {
						$rootScope.routeTo(Enums.routes.LISTKEYWORD + '/' + AppData.lastKeyword);
					} else {
						$rootScope.routeTo();
					}
				}
				resolve();
			}).catch(function() {
				reject();
			});
		});
	}

	/**
	 * Handles asking user for gelocation or bypassing this question on desktop
	 * @protected
	 * @returns {Promise} Indicates if geolocation was gathers and/or if get merchant package list was successful
     */
	function gatherGeolocation() {
		return $q(function(resolve, reject) {
			if (browserSupportsGeolocation()) {
				if (!service.requestedGeolocation && service.useLocation) {
					// Gather Geolocation
					navigator.geolocation.getCurrentPosition(geolocationSuccess, geolocationError, AppData.geolocationOptions);
				} else if (service.geoLocationEnabledForMerchant) {
					return fetchGeolocationKeywordSwap(false).then(resolve);
				} else {
					return reject();
				}
			} else {
				return reject(handleUnsupportedBrowser);
			}

			/**
			 * Handles user accepting to share geolocation
			 * @protected
			 * @param {Object} position user's location. Format: {"timestamp":1382560112946,"coords":{"speed":null,"heading":null,"altitudeAccuracy":null,"accuracy":24000,"altitude":null,"longitude":-81.31784499999999,"latitude":28.758882999999997}}
			 * @returns {undefined}
             */
			function geolocationSuccess(position) {
				service.requestedGeolocation = true;
				service.position = position;
				Storage.set('_geolocationPosition', position, true);
				Storage.set('_geolocationError', {}, true);
				Storage.set('_geolocationSwap', [], true);
				fetchGeolocationKeywordSwap(true).then(function() {
					var result = JSON.parse(JSON.stringify(position));
					delete result.timestamp;
					var data = {};
					data.category = 'Geolocation';
					data.action = 'Success';
					data.label = JSON.stringify(result);

					CustomActionService.registerCustomAction(CustomActionService.ACTIONS_ENUMS.PURCHASE_ADD_ORDER_CHARACS, addGeolocationCharacs, 'GEO_LOCATION_INFO');

					resolve();
				}).catch(reject);
			}

			/**
			 * Handles user not accepting to share geolocation
			 * @protected
			 * @param {Object} error thrown when user does not or is not able to share location. Format: {"message":"User denied Geolocation","code":1,"timestamp":1382560173452}
			 * @returns {undefined}
             */
			function geolocationError(error) {
				if (error.code !== 0) {
					service.requestedGeolocation = true;
				}
				error.timestamp = new Date().getTime();
				service.error = error;
				Storage.set('_geolocationPosition', {}, true);
				Storage.set('_geolocationError', error, true);
				Storage.set('_geolocationSwap', [], true);
				delete error.timestamp;

				reject();
			}

			/**
			 * Called within reject when local storage is not supported by user's browser
			 * @protected
			 * @returns {undefined}
			 */
			function handleUnsupportedBrowser() {
				var error = {
					message: 'User\'s browser doesn\'t support Geolocation',
					code: -1
				};
				error.timestamp = new Date().getTime();
				geolocationError(error);
			}
		});
	}

	/**
	 * Checks to ensure that browser supports geolocation
	 * @protected
	 * @returns {boolean} determination on if browser supports geolocation
     */
	function browserSupportsGeolocation() {
		return 'geolocation' in navigator;
	}

	/**
	 * Handles setting up the geolocation service
	 * @returns {Promise} indicates if we have already assessed the geolocation configuration
     */
	function assessGeolocation() {
		return $q(function(resolve, reject) {
			if (!service.assessedGeolocation) {
				$rootScope.showSpinner();
				service.assessedGeolocation = true;
				service.geoLocationEnabledForMerchant = isGeolocationEnabled();
				service.useLocation = shouldUseLocation();
				service.merchantKeywordsData = AppData.globalDependencies.GetMerchantKeywords;
				if (!AppData.isInCheckout) {
					return resolve();
				}
			}
			return reject();
		});
	}

	/**
	 * Initializes the service
	 * @public
	 * @returns {Promise} indicating that the process is done
     */
	service.initialize = function() {
		return $q(function(resolve) {
			assessGeolocation()
				.then(gatherGeolocation)
				.then(resolve)
				.catch(resolve);
		});
	};

	return service;
});

/**
 * # Language definitions service
 *
 * All user-facing text should reference a key provided by this service. That
 * key is then set to corresponding text in the language defined in
 * ClientInfo.
 *
 */
angular.module('app')
	.constant('LanguageEnums', {
		MERCHANT_ID: '@@MERCHANT_ID',
		LOCALE_RE: /^[\w\d-]+\.[\w\d-]+$/i
	})
	.factory('Language'
	, function($rootScope
		, $injector
		, $locale
		, $log
		, $filter
		, errorTracking
		, Enums
		, LanguageEnums
		, Utilities
		, UtilsValidation
	) {
		var appActivated = false;

		var appActivatedListener = $rootScope.$on(
			Enums.services.APP_ACTIVATED,
			function(event, data) {
				//Dynamically set privacy url if there is a locale for it, otherwise, default to accesso's privacy statement.
				appActivated = true;
				appActivatedListener();
			}
		);

		//we sometimes need to override logic in run.js that listens on the socket and checks for responses with error codes to not display the errorcode modal
		//automatically but allow the calling method to handle display of the error code (there may be custom locale sections that we want to use instead of
		//the error modal) or we may not need to display an error modal at all.
		//An array of request types that we do not want to allow run.js to show the error modal for automatically
		var serviceCallErrorCodeOverrides = [];

		var languageData = {};

		languageData.currentYear = new Date().getFullYear();
		languageData.currentMonth = new Date().getMonth() + 1;
		languageData.months = $locale.DATETIME_FORMATS.MONTH;

		languageData.setData = function(data, replacements, overrides, monthCharacterToRemove) {
			for (var section in data) {
				if (data[section].LT) {
					languageData[section] = languageData[section] || {};
					data[section].LT = angular.isArray(data[section].LT) ? data[section].LT : [data[section].LT];
					for (var i in data[section].LT) {
						languageData[section][data[section].LT[i].target] = performReplacements(replacements, data[section].LT[i].value);
					}
				}
			}

			try {
				if (languageData.CalFormat) {
					languageData.months = [];
					languageData.months.push(languageData.CalFormat.January);
					languageData.months.push(languageData.CalFormat.February);
					languageData.months.push(languageData.CalFormat.March);
					languageData.months.push(languageData.CalFormat.April);
					languageData.months.push(languageData.CalFormat.May);
					languageData.months.push(languageData.CalFormat.June);
					languageData.months.push(languageData.CalFormat.July);
					languageData.months.push(languageData.CalFormat.August);
					languageData.months.push(languageData.CalFormat.September);
					languageData.months.push(languageData.CalFormat.October);
					languageData.months.push(languageData.CalFormat.November);
					languageData.months.push(languageData.CalFormat.December);
				}
			} catch (error) {
				languageData.months = $locale.DATETIME_FORMATS.MONTH;
			}

			if (!Utilities.isEmpty(monthCharacterToRemove)) {
				for (var i = 0; i < languageData.months.length; i++) {
					languageData.months[i] = languageData.months[i].replace(monthCharacterToRemove, '');
				}
			}

			performOverrides(replacements, overrides);

			try {
				if (!$rootScope.$$phase) {
					$rootScope.$apply();
				}
			} catch (e) {}
		};

		/**
		 * Provides the locales for the gap components
		 * @private
		 * @returns {undefined}
		 */
		function _provideLocalesForGapComponents() {
			// If the gapProvideLocales function is not defined
			if (!angular.isFunction(angular.gapProvideLocales)) {
				// Exit
				return;
			}

			angular.gapProvideLocales(function registerLocaleProvider(request) {
				var response = {};
				// Get the locale section name from the component name (e.g. gap-carousel -> GapCarousel)
				var section = request.componentName.toLowerCase().split('-').map(function capitalizeFirstLetter(part) {
					return part.charAt(0).toUpperCase() + part.slice(1);
				}).join('');

				// Iterate over the locale requested keys
				request.keys.forEach(function iterateKeys(key) {
					// Check if the locale exists in the languageData object
					if (languageData.localeExistsMerchant(section, key)) {
						// If it does, get the locale value and add it to the response object
						response[key] = languageData.getLocale(section, key);
					}
				});

				// Return the response object containing the requested locales
				return response;
			});
		}

		function performOverrides(replacements, overrides) {
			for (var section in overrides) {
				for (var target in overrides[section]) {
					if (overrides[section][target]) {
						if (!languageData[section]) {
							languageData[section] = {};
						}
						languageData[section][target] = performReplacements(replacements, overrides[section][target]);
					}
				}
			}
		}

		function performReplacements(replacements, locale) {
			var _locale = locale;
			try {
				if (angular.isArray(replacements) && replacements.length > 0) {
					for (var i in replacements) {
						if ((typeof replacements[i].key != 'undefined' && typeof replacements[i].value != 'undefined') && _locale.indexOf(replacements[i].key) > -1) {
							_locale = languageData.replaceAll(replacements[i].key, replacements[i].value, _locale);
						}
					}
				}
			} catch (error) {
				_locale = locale;
			}
			return _locale;
		}

		// @TODO: Refactor code below into a filter and update all references accordingly.

		/**
		 * Replaces all occurrences of a particular string in a string.
		 * @param {string} find  The string that will be replaced.
		 * @param {string} replace The string that will be used as the replacement.
		 * @param {string} str   The string that is being searched and updated.
		 * @return {string}     The updated string.
		 */
		languageData.replaceAll = function(find, replace, str) {
			if (!str) {
				return '';
			}

			if (find.indexOf('@@') == -1) {
				find = '@@' + find;
			}
			return str.replace(new RegExp(find, 'g'), replace);
		};

		/**
		 * Gives the ability to pass in an array of strings to search, and array of strings to use as replacements.
		 * @param {array} find  Array of strings that will be searched and replaced inside str.
		 * @param {array} replace Array of strings that will be used as the replacement.
		 * @param {string} str  The string that is being searched and updated
		 * @return {string}    The updated string.
		 */
		languageData.replaceAllMultiple = function(find, replace, str) {
			if (!str) {
				return '';
			}

			if (!(find instanceof Array && replace instanceof Array)) {
				// Log Warning
				$log.warn('This function requires array as parameters.');
				return;
			}

			if (find.length != replace.length) {
				// Log Warning
				$log.warn('This function requires the arrays to be of the same length.');
				return;
			}

			// Good to proceed.
			for (var i = 0; i < find.length; i++) {
				str = this.replaceAll(find[i], replace[i], str);
			}

			return str;
		};

		/**
		 * Takes a localized string (str) with singular/plural variables (i.e. @@[value, singularOption, pluralOption]) and based on value determines which option to replace the string with.
		 * @param {string} find  The key to search for without @@. In example @@[value, singularOption, pluralOption], you want to pass value for find parameter.
		 * @param {int} value   The value that will be checked in order to determine whether to select singular or plural option.
		 * @param {string} str   The string that is being searched and updated
		 * @return {string}     The updated string.
		 */
		languageData.updateLocaleKeyInArray = function(find, value, str) {
			if (!str) {
				return '';
			}

			// Mark the index of the locale array entry being searched for.
			var indexOfFind = str.indexOf('@@[' + find),
				indexOfClosingBracket = -1,
				localeArray,
				strArr;

			// Proceed only if the search term is in the locale entry.
			if (indexOfFind > -1) {
				// Increment the index by 3 to compensate for '@@['
				indexOfFind += 3;

				// Find the closing bracket for this locale array entry.
				indexOfClosingBracket = str.indexOf(']', indexOfFind);

				// Get the exact entry name i.e. @@[key, value, values].
				localeArray = str.substring(indexOfFind - 3, indexOfClosingBracket + 1);

				// Trim per-entry directly — replaceAll(' ', '', ...) auto-prepends '@@' and silently no-ops on a plain space.
				strArr = str.substring(indexOfFind, indexOfClosingBracket).split(',').map(function(entry) {
					return entry.trim();
				});

				// Determine selection based on value.
				if (value > 1) {
					// Plural selection.
					str = str.replace(localeArray, strArr[2]);
				} else {
					// Singular selection.
					str = str.replace(localeArray, strArr[1]);
				}
			}

			return str;
		};

		/**
		 * Gives the ability to pass in an array of strings to search, and array of strings to use as replacements.
		 * @param {array} find  An array of keys to search for without @@. In example @@[value, singularOption, pluralOption], you want to pass an array of value for find parameter.
		 * @param {array} value  An array of values that will be checked in order to determine whether to select singular or plural option.
		 * @param {string} str  The string that is being searched and updated
		 * @return {string}    The updated string.
		 */
		languageData.updateMultipleLocaleKeysInArray = function(find, value, str) {
			if (!str) {
				return '';
			}

			if (!(find instanceof Array && value instanceof Array)) {
				// Log Warning
				$log.warn('This function requires array as parameters.');
				return;
			}

			if (find.length != value.length) {
				// Log Warning
				$log.warn('This function requires the arrays to be of the same length.');
				return;
			}

			for (var i = 0; i < find.length; i++) {
				str = this.updateLocaleKeyInArray(find[i], value[i], str);
			}

			return str
		}

		languageData.displayErrorCode = function(data, section, replacement) {
			if (!section || section == undefined) {
				section = 'ErrorCodes'
			}

			if (data.error_code &&
					 languageData[section] &&
					 languageData[section][data.error_code]) {
				var title = languageData.replaceAll('@@errorCode', data.error_code, languageData[section].errorCodeTitle);
				var desc = languageData.replaceAllMultiple(['@@supportPhoneNumber'], [replacement], languageData[section][data.error_code]);
				desc += '<br /><br />' + languageData.replaceAllMultiple(['@@errorCode'], [data.error_code], languageData.CheckCartTicketLevelErrors.errorCodeLabel);
			} else if (data.error_code) {
				$log.warn('Missing error locale - No error code locale defined for: ' + data.error_code);
			}
		};

		languageData.sectionExists = function(section) {
			return (angular.isDefined(section) && angular.isDefined(languageData[section]));
		};
		 languageData.localeExistsSingle = function(section, target) {
			return (angular.isDefined(section)
				&& angular.isDefined(target)
				&& angular.isDefined(languageData[section])
				&& angular.isDefined(languageData[section][target]));
		};

		languageData.getLocaleSingle = function(section, target) {
			var found = false;
			var returnValue;

			if (angular.isUndefined(section) || angular.isUndefined(target)) {
				return ($rootScope.develop) ? '[Section or Target missing]' : '';
			}

			if (!angular.isDefined(languageData[section])) {
				//commenting this line out until we devise a solution for moving forward with reducing exceptions thrown to errorTracking which
				//causes errorTracking to consistently request sourcemaps
				//logException(new Error(section + ' not defined for island'), 'Missing Locale Section');
				returnValue = '[' + section + '] section missing';
			} else {
				if (angular.isDefined(languageData[section][target])) {
					returnValue = languageData[section][target];
					found = true;
				} else {
					returnValue = '*' + section + '.' + target;
				}
			}

			// If we are NOT in dev mode, return an empty string
			if (!$rootScope.develop && !found) {
				returnValue = '';
			}

			return returnValue;
		}

		function logException(error) {
			if (appActivated) {
				errorTracking.notifyException(error);
			}
		}

		/**
		 * Register a request type to disable automatically displaying an error modal in run.js
		 * @param requestType
		 */
		languageData.registerErrorCodeOverride = function(requestType) {
			if (serviceCallErrorCodeOverrides.indexOf(requestType) === -1) {
				serviceCallErrorCodeOverrides.push(requestType);
			}
		}

		/**
		 * Check to see if a given request type should not display the error code modal in run.js upon socket message receipt
		 * @param requestType
		 * @returns {boolean}
		 */
		languageData.hasErrorCodeOverrideForRequest = function(requestType) {
			return angular.isDefined(requestType) && serviceCallErrorCodeOverrides.indexOf(requestType) > -1;
		}

		/**
		 * Tries to get the custom locale specified (via suffix), but falls back to the base locale (without a suffix) if it doesn't exist.
		 * @param {string} section The section of the locale
		 * @param {string} target The target of the locale
		 * @param {string} suffix The optional suffix of the locale
		 * @returns {string} A locale or "[Section.Target] target/section missing"
		 */
		languageData.getLocaleWithSuffixAndFallback = function(section, target, suffix) {
			if (suffix === LanguageEnums.MERCHANT_ID) {
				suffix = ($injector.get('AppData')).merchantId;
			}

			if (angular.isString(suffix) && UtilsValidation.validString(suffix)) {
				if (suffix[0] !== '_') {
					suffix = '_' + suffix;
				}

				if (languageData.localeExistsSingle(section, target + suffix)) {
					return languageData.getLocaleSingle(section, target + suffix);
				}
			}

			return languageData.getLocaleSingle(section, target);
		}

		/**
		 * Tries and returns the desired locale; attempting to return the merchant suffix version first
		 * @public
		 * @param {String} section - The section of the locale
		 * @param {String} target - The target of the locale
		 * @returns {String} The desired locale, if exists
		 */
		languageData.getLocale = function(section, target) {
			return languageData.getLocaleWithSuffixAndFallback(section, target, LanguageEnums.MERCHANT_ID);
		};

		/**
		 * Get a locale for a merchant
		 * @alias getLocale
		 */
		languageData.getLocaleMerchant = languageData.getLocale;

		/**
		 * Checks to see if a locale exists with the merchant suffix or without
		 * @public
		 * @param {String} section - The section of the locale
		 * @param {String} target - The target of the locale
		 * @returns {Boolean} - True if the locale exists
		 */
		languageData.localeExists = function(section, target) {
			return languageData.localeExistsSingle(section, target + '_' + ($injector.get('AppData')).merchantId) || languageData.localeExistsSingle(section, target);
		};

		/**
		 * Checks to see if a locale exists with the merchant suffix or without
		 * @alias localeExists
		 */
		languageData.localeExistsMerchant = languageData.localeExists;

		// Setup the listener to provide the locales for the gap components
		_provideLocalesForGapComponents();

		return languageData;
	});

(function() {
	'use strict';

	angular
		.module('app')
		.service('LocalizationService', LocalizationService);

	/**
	 * The Localization Service
	 * @constructor
	 * @param {Service} $filter - The angular filter service
	 * @param {Constant} $locale - The locale constant
	 * @param {Scope} $rootScope - The root scope service
	 * @param {Service} AppData - The AppData service
	 * @param {Service} Enums - The Enums service
	 * @param {Service} JSONValidator - The JSONValidator service
	 * @param {Service} Utilities - The Utilities service
	 * @param {Service} UtilsValidation - The UtilsValidation service
	 * @ngInject
	 */
	function LocalizationService($filter, $locale, $rootScope, AppData, Enums, JSONValidator, Utilities, UtilsValidation) {
		var checkProp = Utilities.checkProp,
			getString = Utilities.getString,
			merge = Utilities.mergeDeep,
			nextTick = Utilities.nextTick,
			validString = UtilsValidation.validString;

		var DATETIME_FORMATS = $locale.DATETIME_FORMATS || {};

		var service = {
			formatDate: formatDate,
			getLocaleValue: getLocaleValue,
			setDateFilter: setDateFilter,

			_: {
				config: {
					dateTime: {
						// Calendar Defaults
						calendarDay: DATETIME_FORMATS.calendarDay || 'd',
						calendarDayHeader: DATETIME_FORMATS.calendarDayHeader || 'EEE',
						calendarMonth: DATETIME_FORMATS.calendarMonth || 'MMM',
						calendarMonthTitle: DATETIME_FORMATS.calendarMonthTitle || 'MMMM yyyy',
						calendarYearTitle: DATETIME_FORMATS.calendarYearTitle || 'yyyy',
						// Picker Defaults
						pickerRangeStartShort: DATETIME_FORMATS.pickerRangeStartShort || 'MMM d',
						pickerRangeStartMedium: DATETIME_FORMATS.pickerRangeStartMedium || 'MMM d',
						pickerRangeStartLong: DATETIME_FORMATS.pickerRangeStartLong || 'MMM d, yyyy',
						pickerRangeEndShort: DATETIME_FORMATS.pickerRangeEndShort || 'd, yyyy',
						pickerRangeEndMedium: DATETIME_FORMATS.pickerRangeEndMedium || 'MMM d, yyyy',
						pickerRangeEndLong: DATETIME_FORMATS.pickerRangeEndLong || 'MMM d, yyyy',
						pickerSelection: DATETIME_FORMATS.pickerSelection || 'EEEE, MMM d, y',
					}
				},
				filter: {
					date: null,
				},

				initialize: _initialize,
			},
		};

		// Initialize the service
		if (AppData.applicationInitialized) {
			nextTick(service._.initialize);
		} else {
			$rootScope.$on(Enums.services.APP_INIT, service._.initialize);
		}

		return service;


		/***************************************
		 ** ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ **
		 ** ~ P R I V A T E ~ M E T H O D S ~ **
		 ** ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ **
		 ***************************************/

		/**
		 * Initialize the service
		 * @private
		 * @returns {undefined}
		 */
		function _initialize() {
			if (JSONValidator.validate('localization', AppData.settings.localization)) {
				// Apply custom locale settings
				merge(service._.config, JSON.parse(AppData.settings.localization));
			}

			// Ensure date filter is set
			if (!angular.isFunction(service._.filter.date)) {
				// No custom date filter set, use default angular filter
				service._.filter.date = $filter('date');
			}
		}


		/*************************************
		 ** ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ **
		 ** ~ P U B L I C ~ M E T H O D S ~ **
		 ** ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ **
		 *************************************/

		/**
		 * Format a date using the LocalizationService date formats, if exists
		 * @public
		 * @param {Date} date - The date to format
		 * @param {String} [format] - The format to use (if not provided, will use medium format)
		 * @returns {String} The formatted date
		 */
		function formatDate(date, format) {
			// If the date is not valid, return empty string
			if (!date) {
				return '';
			}

			// Get the format from locale settings, or use medium format
			format = service.getLocaleValue('dateTime', getString(format) || $locale.DATETIME_FORMATS.medium);

			// Format the date using the date filter
			return service._.filter.date(date, format);
		}

		/**
		 * Get a locale value from the config or $locale
		 * @public
		 * @param {String} type - The type of locale value (e.g. 'dateTime')
		 * @param {String} format - The format key to retrieve
		 * @returns {String|null} The locale value or null if invalid inputs
		 */
		function getLocaleValue(type, format) {
			// Validate inputs
			if (!validString(type) || !validString(format)) {
				return null;
			}

			// Do we have overrides to use?
			if (checkProp('config.' + type + '.' + format, service._.config)) {
				// Use the override value
				return service._.config[type][format];
			// Does it exist in $locale?
			} else if (type === 'dateTime' && checkProp('DATETIME_FORMATS.' + format, $locale)) {
				// Use the $locale value
				return $locale.DATETIME_FORMATS[format];
			}

			// Otherwise the the format as is
			return format;
		}

		/**
		 * Set the date filter method to use for formatting dates
		 * @public
		 * @param {Function} method - The date filter method
		 * @returns {undefined}
		 */
		function setDateFilter(method) {
			// Validate input
			if (!angular.isFunction(method)) {
				return;
			}

			// Set the date filter method
			service._.filter.date = method;
		}
	}
})();
(function () {
	'use strict';

	angular.module('app').factory('Modal', ModalService);

	/**
	 * Modal Service
	 * @public
	 * @param {Service} $compile The compile service
	 * @param {Service} $filter The filter service
	 * @param {Document[]} $document The document service
	 * @param {Service} $injector The injector service
	 * @param {Service} $location The location service
	 * @param {Scope} $rootScope The Root scope
	 * @param {Service} $timeout The timeout service
	 * @param {Scope} $window The window service
	 * @param {ClientInfo} ClientInfo service
	 * @param {Service} Enums Our Enums
	 * @param {Service} FocusService Our Focus Service
	 * @param {Service} JSONValidator Our JSON Validator Service
	 * @param {Service} Language Our Language Service
	 * @param {Service} ModalEnums Our Modal Enums Service
	 * @param {Service} Utilities Our Utilities Service
	 * @param {Service} UtilsValidation Our Validation Service
	 * @returns {Service} This service
	 * @nginject
	 */
	function ModalService(
		$compile,
		$filter,
		$document,
		$injector,
		$location,
		$rootScope,
		$timeout,
		$window,
		ClientInfo,
		Enums,
		FocusService,
		JSONValidator,
		Language,
		ModalEnums,
		Utilities,
		UtilsValidation) {
		var isArray = UtilsValidation.validArray,
			nextTick = Utilities.nextTick,
			validObject = UtilsValidation.validObject,
			validString = UtilsValidation.validString;

		// Constants.
		var service = {
			DANGER: 'danger',
			DEFAULT: 'default',
			GIFT: 'gift',
			NEW: 'new',
			PRIMARY: 'primary',
			PROMO: 'promo',
			SLIDEUP: 'slideup',
			SUCCESS: 'success'
		}

		service.modal = {};

		service.displayModal = function (options) {
			var baseCardClasses,
				description = options.description || '',
				title = options.title || '',
				type = validString(options.type) ? options.type : '',
				sessionId = validString(options.sessionId) ? Language.getLocale('ApplicationLabels', 'sessionID') + ': ' + options.sessionId : '';

			// See if we should suppress this modal
			if (service.shouldSuppress(type)) {
				// See if we should take any specific action for this modal when it is suppressed
				// (Such as, force the user to the cart)
				if (angular.isFunction(options.suppressedAction)) {
					options.suppressedAction();
				}

				return;
			}
			options.sessionId = sessionId;



			service.modal = {
				//set the button to be fullwidth
				btnBlock: false,
				buttonFlags: [],
				buttons: [],
				callback: null,
				customButtons: Array.isArray(options.customButtons) ? options.customButtons : [],
				customCardClasses: options.customCardClasses || '',
				customCardContentClasses: options.customCardContentClasses || '',
				customCss: options.customCss || '',
				customDescription: '',
				customHTML: options.customHTML || false,
				customHTMLData: options.customHTMLData || {},
				customLabelOverride: null,
				description: '',
				desktop: options.desktop || false,
				element: Utilities.getObject('modal-description-container'),
				fullscreen: options.fullscreen || false,
				headerFlag: '',
				hideAllButtons: false,
				icon: '',
				image: null,
				noPad: options.noPad || false,
				onImageVerifySuccess: onImageVerifySuccess,
				sessionId: sessionId,
				show: false,
				showBottomBorder: options.showBottomBorder || false,
				showBottomBorderMobile: options.showBottomBorderMobile || false,
				showCloseButton: options.showCloseButton || true,
				showCtaBorderMobile: options.showCtaBorderMobile || false,
				showTopBorder: options.showTopBorder || false,
				showTopBorderMobile: options.showTopBorderMobile || false,
				singleButtonFullWidth: options.singleButtonFullWidth || false,
				singleElement: false,
				tagline: '',
				title: '',
				trueFullscreen: options.trueFullscreen || false,
				type: '',
				values: options.values || null,
				view: options.view || service.DEFAULT,
				widen: options.widen || false
			};

			/*
			Options:
				replacementKeys: Array (or string) of any text to be replaced in message.
				replacementValues: Array (or string) of what the replacementKeys should be replaced with.
				replaceInTitle: Flag that indicates whether the replacement should be in the title.
				replaceInDescription: Flag that indicates whether the replacement should be in the description.
				title: Modal title.
				description: Modal description.
				customCardClasses: Add any classes to the gap-card component
				customCardContentClasses: Add any classes to the gap-card-content container
				headerFlag: Determines the color of the modal header, default style.
				callback: Callback function to be executed after the button is clicked. Passes button flag item.
				buttonFlags: Array of the buttons to display in the modal.
				tagline:
				hideAllButtons: If no button flag is passed, it defaults to OK. Setting this to true shows no buttons.
				footer: Footer markup.
				compile: If passing markup with directive, this tells angular to compile the directive.
				suppressedAction: A function determining what to do in the event of the modal's suppression.

			Sample Usage:
				Modal.displayModal
					(
						{ replacementKeys: ['mollis','molli2']
						, replacementValues: [65,95]
						, title: '<span testdirective>FROM PACKAGE LIST</span>'
						, description: '<span testdirective>FROM PACKAGE LIST</span>'
						, compile: true
						, scope: $scope
						, headerFlag:'primary'
						, buttonFlags: [ Enums.buttonFlags.OK, Enums.buttonFlags.CANCEL ]
						, hideAllButtons: false
						, replaceInTitle: true
						, callback: function (detail){
							if(detail == Enums.buttonFlags.OK){
								//alert('OK')
							}
						}
						}
					);

				All buttons are 50% of the modal window, leftside of the screen are primary buttons, while the right side are
				success buttons or secondary
				Default style is no header, if a title string exist it will place a title above the header with default style,
				unless specify
				it buttons are hidden the footer will disappear

			Example Usage:
				Modal.displayModal
					(
						{	  title: "this is a title"
							, description: "this is a description"
							, hideAllButtons: false
							, btnBlock: true
							, buttonFlags : [Enums.buttonFlags.OK, Enums.buttonFlags.CANCEL]
						}
					);

			*/

			// Default values...
			options.compile = options.compile || false;
			options.scope = options.scope || null;
			options.hideAllButtons = options.hideAllButtons || false;
			options.btnBlock = options.btnBlock || false;

			if (service.modal.customButtons.length) {
				options.customButtons.forEach(function (btn) {
					if (!btn.flag || !Enums.buttonFlags[btn.flag]) {
						btn.flag = Enums.buttonFlags.OK;
					}

					if (!validString(btn.locale)) {
						btn.locale = 'ButtonLabels.ok';
					}

					if (!validString(btn.class)) {
						btn.class = 'btn-default';
					}
				});

				options.hideAllButtons = true;
			}

			if (!options.hideAllButtons) {
				options.buttonFlags = angular.isArray(options.buttonFlags) ? options.buttonFlags : [Enums.buttonFlags.OK];
			} else {
				options.buttonFlags = [];
			}
			options.headerFlag = options.headerFlag || service.DEFAULT;

			options.replacementValues = options.replacementValues || '';
			options.replacementValues = angular.isArray(options.replacementValues) ? options.replacementValues : [options.replacementValues];

			options.replacementKeys = options.replacementKeys || '';
			options.replacementKeys = angular.isArray(options.replacementKeys) ? options.replacementKeys : [options.replacementKeys];

			options.replaceInTitle = options.replaceInTitle || false;
			options.replaceInDescription = options.replaceInDescription || true;
			options.icon = options.icon || '';
			options.customDescription = options.customDescription || '';

			if (options.buttonFlags.length === 1) {
				options.btnBlock = true;
				options.singleElement = true;
			}

			if (options.compile && options.scope) {
				// Replace the description with the compiled directive.
				try {
					description = ($compile(desc)(options.scope))[0].innerHTML;
				} catch (e) { }

				try {
					title = ($compile(title)(options.scope))[0].innerHTML;
				} catch (e) { }
			}

			if (options.replacementKeys != '') {
				// Handles replacement of data in the description and/or title.
				if (options.replaceInTitle) {
					title =
						replaceKeys(options.replacementKeys, options.replacementValues, title);
				}

				if (options.replaceInDescription) {
					description =
						replaceKeys(options.replacementKeys, options.replacementValues, description);
				}
			}

			options.description = description;
			options.title = title.charAt(0).toUpperCase() + title.slice(1);

			options.label = options.label || title;

			delete options.replacementValues;
			delete options.replacementKeys;
			delete options.replaceInTitle;
			delete options.replaceInDescription;

			showModal(options);

			// Account for Slide-Up modal use of ViewPort Height when scrolling in certain circumstances, the Modal title
			// may appear out of view. This is a workaround to ensure the title is always visible
			if (options.view === service.SLIDEUP) {
				// When the browsers bar dissapears on scroll or other conditions that change the viewport height
				$window.addEventListener('resize', onResize);
			}
		};

		service.displayErrorModal = function (data, section, replacement) {
			if (!section) {
				section = 'ErrorCodes';
			}

			if (data.error_code &&
				Language[section] &&
				Language[section][data.error_code]) {
				var desc = Language.replaceAllMultiple(['@@supportPhoneNumber'], [replacement], Language[section][data.error_code]);
				desc += '<br /><br />' + Language.replaceAllMultiple(['@@errorCode'], [data.error_code], Language[section].errorCodeLabel);
				service.displayModal({
					category: section || '',
					action: 'Error',
					label: data.error_msg,
					title: Language.replaceAll('@@errorCode', data.error_code, Language[section].errorCodeTitle),
					description: desc
				});
			} else {
				service.displayModal({
					category: section || '',
					action: 'Error',
					label: data.error_msg || 'Error',
					title: 'Error ' + (data.error_code || ''),
					description: 'There was an error in processing your request.'
				});
			}
		};

		function replaceKeys(replacementKeys, replacementValues, text) {
			var str =
				Language.updateMultipleLocaleKeysInArray(
					replacementKeys, replacementValues, Language.replaceAllMultiple(
						replacementKeys, replacementValues, text
					)
				);

			return str;
		}

		/**
		 * The onResize callback that handles limiting modal height to within viewport on iOS Webkit browsers
		 * @function
		 * @callback
		 * @returns {undefined}
		 */
		function onResize() {
			service.setModalCardHeight();
		}

		/**
		 * Obtains the gap card element and sets max height to the calculated window height
		 * @private
		 * @returns {undefined}
		 */
		service.setModalCardHeight = function () {
			var modalCard;
			modalCard = document.querySelector('#modal-view-container gap-card');
			if (modalCard) {
				modalCard.style.maxHeight = $window.innerHeight + 'px';
			}
		};

		/**
		 * Method that displays the Modal service's modal
		 * @param  { Object } options { ... options passed in to service.displayModal() ... }
		 * @returns { undefined }
		 */
		function showModal(options) {
			//map option params to service.modal params
			for (var property in options) {
				service.modal[property] = options[property];
			}

			service.modal.btnPrimary = '';
			service.modal.primary = [];
			service.modal.buttonFlags = [];
			service.modal.buttons = [];

			options.buttonFlags.forEach(function iterateButtonFlags(buttonFlag, i) {
				var isObject = validObject(buttonFlag);
				var key = isObject ? buttonFlag.key : buttonFlag;
				var reference = ModalEnums.getButtonById(key);
				var locale = Language.getLocaleMerchant('ButtonLabels', reference.locale);

				if (isObject && validString(buttonFlag.locale)) {
					locale = Language.getLocaleMerchant.apply(null, buttonFlag.locale.split('.'));
				}

				service.modal.buttons.push({
					flag: key,
					label: Language.getLocaleMerchant('Accessibility', reference.label),
					locale: locale,
				});

				service.modal.primary[key] = (i == 0);
				service.modal.buttonFlags[key] = true;
			});

			service.modal.callback = options.callback;
			service.modal.show = true;

			$rootScope.state.showSubMenuTopBar = false; // Hide the top bar nav menu's submenu if it was left open.
			$rootScope.$broadcast('$UpdateModal');
			$rootScope.modal = service.modal;

			// Focus the modal when it is displayed, which effectively removes focus elsewhere to satisfy accessibility guidelines.
			// Use a timeout to ensure the modal is fully rendered before setting focus
			$timeout(function setModalFocus() {
				// Let FocusService handle focus trapping and ESC key with default close button
				FocusService.setFocusToContainer('modal', document.activeElement);

				// For image modals, override the focus placement after FocusService sets up
				if (options.customHTML === '/views/modals/image-full-screen.html') {
					$timeout(function tryTargetFocus() {
						// Try focus targets in priority order
						var selectors = [
							'#modal-view-container .modal__title',
							'#modal-view-container gap-card-name button',
							'#modal-view-container img[role="img"]',
							'#image-modal-focus-target'
						];

						for (var i = 0; i < selectors.length; i++) {
							var element = $document.querySelector(selectors[i]);
							if (element && element.offsetHeight > 0) {
								element.setAttribute('tabindex', '-1');
								element.focus();
								break;
							}
						}
					}, 50);
				}
			}, 150);

			// Set the min height to the current height of the modal (Brand Mode)
			service.modal.onImageVerifySuccess();
		}

		/**
		 * Method when a verify-image-src directive is successful for the modal
		 * @returns {undefined}
		 */
		function onImageVerifySuccess() {
			// Wait for the next tick
			nextTick(function next() {
				var modalEle = $document[0].querySelector('#modal-view-container .modal-type')

				// If the modal element exists
				if (modalEle) {
					// Set the min height of the modal to the height of the modal content (Brand Mode)
					$rootScope.setMinHeight(modalEle.scrollHeight);
				}
			}, 1);
		}

		function fireAnalyticsEvent(buttonValue) {
			var modalEventName = 'ModalInteraction';
			var modalAction = validString(buttonValue) ? Utilities.convertButtonValueToName(buttonValue) : 'System Action';

			var modalEventData = Utilities.generateEventData(
				modalEventName,
				modalAction,
				getModalEventLabel()
			);

			modalEventData.eventLocation = $location.path();
			$rootScope.$broadcast('triggerAnalyticsEvent', modalEventData);
		}

		function getModalEventLabel() {
			var label = service.modal.title + ' Modal';

			if (angular.isDefined(service.modal.analyticsLabelAdditions)) {
				label += service.modal.analyticsLabelAdditions;
			}

			return label;
		}

		/**
		 * Get modal suppression configs.
		 * Should be an array of strings, where each string correlates with the type of the modal being suppressed.
		 * @public
		 * @returns {Array<String>} The modal_suppression config object, or empty if not configured
		 */
		service.getModalSuppressionConfig = function () {
			//to avoid circular dependancy issue this must be injected here
			var appdata = $injector.get('AppData');
			var modalSuppressionConfig = appdata.settings.modal_suppression;

			if (JSONValidator.validate('modal_suppression', modalSuppressionConfig)) {
				return JSON.parse(modalSuppressionConfig);
			}

			return [];
		}

		/**
		 * Determines if the modal should be suppressed based on provided type
		 * @public
		 * @param {String} type The type of the modal (or label)
		 * @returns {Boolean} True if it should be suppressed, false otherwise
		 */
		service.shouldSuppress = function (type) {
			// Initialize the suppressedModalTypeList configuration
			if (!isArray(service.suppressedModalTypeList)) {
				service.suppressedModalTypeList = service.getModalSuppressionConfig();
			}

			return service.suppressedModalTypeList.some(function (toSuppress) {
				return type === toSuppress;
			});
		};

		/**
		 * Method called from the Modal View on the button tap/click. This is usually not called from the view controller
		 * @param {Object} detail Modal Data object for event tracking
		 * @param {String} action a string value for overriding the action reported to analytics
		 * @returns {undefined}
		 */
		service.hideModal = function (detail, action) {
			var data = {};
			var isSnapCalendar = window.location.pathname.includes('/snap-calendar');
			var checkProp = Utilities.safelyCheckPropertyOnObject;
			var isQuicksell = checkProp('service.modal.customHTMLData.isQuicksell', service);
			data.category = typeof service.modal.category != 'undefined' ? 'Modal - ' + service.modal.category : 'Modal';
			data.action = typeof action != 'undefined' ? action : (detail) ? detail : 'System Action';
			data.label = service.modal.label;
			if (typeof service.modal.value != 'undefined' && !isNaN(detail)) {
				data.value = parseInt(detail);
			}
			service.modal.show = false;

			// Fire analytics before the callback, since the callback may open a new modal and overwrite service.modal state
			fireAnalyticsEvent(detail);

			if (isSnapCalendar && checkProp('service.modal.customHTMLData.picker.date', service)) {
				$rootScope.$broadcast('triggerAnalyticsEvent', {
					eventCategory: 'datePicker',
					eventDetail: $filter('date')(service.modal.customHTMLData.picker.date, 'yyyy-MM-dd'),
					eventLabel: 'selectDateConfirmed'
				});
			}

			if (isQuicksell && checkProp('service.modal.customHTMLData.packageName', service)) {
				$rootScope.$broadcast('triggerAnalyticsEvent', {
					eventCategory: 'quicksell',
					eventDetail: service.modal.customHTMLData.packageName,
					eventLabel: 'quicksellModalCloseButton'
				});
			}

			// Reset view before callback so it doesn't clobber a new modal opened by the callback
			service.modal.view = null;

			if (service.modal.callback && detail != '') {
				var callback = service.modal.callback;
				service.modal.callback = null;
				callback(detail);
			}

			// Trigger a broadcast that can be used if the modal is closed and dont route to any other place.
			$rootScope.$broadcast('$ModalClosed');

			// Set the focus back to the triggering element that opened the modal now that modal is closed.
			FocusService.setFocusToTriggeringElement();

			// TODO: create controller for the modal view and put service reference in the $scope
			$rootScope.modal = service.modal;

			// Reset the body minimum height to 0 (Brand Mode)
			$rootScope.setMinHeight(0);
		};

		service.modalButtonLabel = function (detail, label) {
			if (service.modal.customLabelOverride) {
				return service.modal.customLabelOverride(detail, label);
			}
			return label;
		};

		$rootScope.$on('hidePreviousModals', function () {
			service.hideModal();
		});

		$rootScope.Modal = service;
		$rootScope.modal = service.modal;

		/**
		 * Opens a file upload modal with cropping functionality
		 * @public
		 * @param {Object} options - Configuration options
		 * @param {Function} options.onComplete - Called with cropped image data
		 * @param {Function} options.onCancel - Called when canceled
		 * @param {String} options.fileName - Optional filename
		 * @param {Number} options.orientation - Optional image orientation (1-8)
		 * @param {Number} options.cropZoneSize - Optional crop zone size in pixels
		 * @returns {Promise} Promise that resolves when modal opens
		 */
		service.openImageUpload = function (options) {
			options = options || {};

			// Check if we have the bundle-based ImageCaptureModal service
			try {
				var ImageCaptureModal = $injector.get('ImageCaptureModal');
				return ImageCaptureModal.openFileUpload({
					onComplete: options.onComplete,
					onCancel: options.onCancel
				}, {
					fileName: options.fileName,
					orientation: options.orientation,
					cropZoneSize: options.cropZoneSize
				});
			} catch (e) {
				// Fallback: create a basic file upload modal if ImageCaptureModal is not available
				return service.displayModal({
					title: 'Upload Image',
					description: 'Please select an image file to upload.',
					customHTML: 'views/modals/basic-file-upload.html',
					customHTMLData: {
						onComplete: options.onComplete,
						onCancel: options.onCancel
					},
					view: service.SLIDEUP,
					fullscreen: true,
					noPad: true,
					hideAllButtons: true,
					showCloseButton: false
				});
			}
		};

		/**
		 * Opens a webcam capture modal
		 * @public
		 * @param {Object} options - Configuration options
		 * @param {Function} options.onCapture - Called with captured dataURL
		 * @param {Function} options.onCancel - Called when canceled
		 * @param {Object} options.videoConstraints - Optional camera constraints
		 * @returns {Promise} Promise that resolves when modal opens
		 */
		service.openWebcamCapture = function (options) {
			options = options || {};

			// Check if we have the bundle-based ImageCaptureModal service
			try {
				var ImageCaptureModal = $injector.get('ImageCaptureModal');
				return ImageCaptureModal.openWebcamCapture({
					onCapture: options.onCapture,
					onCancel: options.onCancel
				});
			} catch (e) {
				// Fallback: create a basic webcam modal if ImageCaptureModal is not available
				return service.displayModal({
					title: 'Capture Photo',
					description: 'Use your camera to take a photo.',
					customHTML: 'views/modals/basic-webcam-capture.html',
					customHTMLData: {
						onCapture: options.onCapture,
						onCancel: options.onCancel
					},
					view: service.SLIDEUP,
					fullscreen: true,
					noPad: true,
					hideAllButtons: true,
					showCloseButton: false
				});
			}
		};

		/**
		 * Opens an image cropping modal
		 * @public
		 * @param {File|String} imageData - File object or dataURL to crop
		 * @param {Object} options - Configuration options
		 * @param {Function} options.onComplete - Called with cropped image data
		 * @param {Function} options.onCancel - Called when canceled
		 * @param {String} options.fileName - Optional filename
		 * @param {Number} options.orientation - Optional image orientation (1-8)
		 * @param {String} options.sourceType - Source type ('upload' or 'webcam')
		 * @param {Number} options.cropZoneSize - Optional crop zone size in pixels
		 * @returns {Promise} Promise that resolves when modal opens
		 */
		service.openImageCrop = function (imageData, options) {
			options = options || {};

			// Check if we have the bundle-based ImageCaptureModal service
			try {
				var ImageCaptureModal = $injector.get('ImageCaptureModal');
				return ImageCaptureModal.openImageCrop(imageData, {
					onComplete: options.onComplete,
					onCancel: options.onCancel
				}, {
					fileName: options.fileName,
					orientation: options.orientation,
					sourceType: options.sourceType,
					cropZoneSize: options.cropZoneSize
				});
			} catch (e) {
				// Fallback: create a basic crop modal if ImageCaptureModal is not available
				return service.displayModal({
					title: 'Crop Image',
					description: 'Adjust the crop area for your image.',
					customHTML: 'views/modals/basic-image-crop.html',
					customHTMLData: {
						imageData: imageData,
						onComplete: options.onComplete,
						onCancel: options.onCancel,
						fileName: options.fileName,
						orientation: options.orientation,
						sourceType: options.sourceType,
						cropZoneSize: options.cropZoneSize
					},
					view: service.SLIDEUP,
					fullscreen: true,
					noPad: true,
					hideAllButtons: true,
					showCloseButton: false
				});
			}
		};

		return service;
	}
})();
(function() {
	'use strict';

	angular
		.module('app')
		.service('ModalEnums', ModalEnums);

	/**
	 *
	 * @constructor
	 * @param {*} Enums
	 * @returns
	 * @ngInject
	 */
	function ModalEnums(Enums, Utilities) {
		var checkProp = Utilities.checkProp;

		var service = {
			button: {
				CANCEL: {
					flag: Enums.buttonFlags.CANCEL,
					label: 'modalCancelAndCloseButton',
					locale: 'cancel'
				},
				CLOSE: {
					flag: Enums.buttonFlags.CLOSE,
					label: 'modalCloseButton',
					locale: 'close'
				},
				CONFIRM: {
					flag: Enums.buttonFlags.CONFIRM,
					label: 'modalConfirmAndCloseButton',
					locale: 'confirm'
				},
				CONTINUE: {
					flag: Enums.buttonFlags.CONTINUE,
					label: 'modalContinueAndCloseButton',
					locale: 'continue'
				},
				CONTINUE_SHOPPING: {
					flag: Enums.buttonFlags.CONTINUE_SHOPPING,
					label: 'modalContinueShoppingAndCloseButton',
					locale: 'continueShopping'
				},
				LEARN: {
					flag: Enums.buttonFlags.LEARN,
					label: 'modalLearnMoreAndCloseButton',
					locale: 'learnMore'
				},
				NO: {
					flag: Enums.buttonFlags.NO,
					label: 'modalNoAndCloseButton',
					locale: 'no'
				},
				NO_THANKS: {
					flag: Enums.buttonFlags.NO_THANKS,
					label: 'modalNoThanksAndCloseButton',
					locale: 'noThanks'
				},
				OK: {
					flag: Enums.buttonFlags.OK,
					label: 'modalOkAndCloseButton',
					locale: 'ok'
				},
				PROCEED_TO_CHECKOUT: {
					flag: Enums.buttonFlags.PROCEED_TO_CHECKOUT,
					label: 'modalProceedToCheckoutAndCloseButton',
					locale: 'checkout'
				},
				RESET_BUTTON: {
					flag: Enums.buttonFlags.RESET_BUTTON,
					label: 'modalResetAndCloseButton',
					locale: 'resetButton'
				},
				SAVE: {
					flag: Enums.buttonFlags.SAVE,
					label: 'modalSaveAndCloseButton',
					locale: 'save'
				},
				VERIFY: {
					flag: Enums.buttonFlags.VERIFY,
					label: 'modalVerifyAndCloseButton',
					locale: 'verify'
				},
				VIEW_CART: {
					flag: Enums.buttonFlags.VIEW_CART,
					label: 'modalViewCartAndCloseButton',
					locale: 'viewCart'
				},
				YES: {
					flag: Enums.buttonFlags.YES,
					label: 'modalYesAndCloseButton',
					locale: 'yes'
				},
			},
			getButtonById: getButtonById,
		};

		return service;

		function getButtonById(id) {
			var found = Object.entries(Enums.buttonFlags).find(function FindKeyById(entries) {
				if (entries[1] === id) {
					return entries;
				}
			});

			if (found && checkProp('service.button.' + found[0], service)) {
				return angular.copy(service.button[found[0]]);
			}

			return null;
		}
	}
})();
angular
	.module('app')
	.service('Navigation', function(AppData,
		ExtraFlow,
		$rootScope,
		$state) {
		var service = {
			showAllKeywordItems: false,
			keywordMenuItems: []
		}

		/**
		 * @param  {Object} menuItem Menu item object from nav tree
		 * @param  {String} property menuItem property
		 * @param  {String} value menuItem value
		 * @returns {Object} menuItem
		 */
		function findItemInTree(menuItem, property, value) {
			var match = undefined;
			if (value) {
				var valueToTest = angular.isDefined(menuItem[property]) ? menuItem[property].toLowerCase() : '';
				valueToTest = property != 'label' ? angular.copy(valueToTest).split(',') : angular.copy(valueToTest);

				// this is insurance. split should automatically set value to array
				if (!angular.isArray(valueToTest)) {
					valueToTest = [valueToTest];
				}

				//trim each entry in the array to make sure indexOf will match
				for (var i = 0; i < valueToTest.length; i++) {
					valueToTest[i] = valueToTest[i].trim();
				}

				//look through the array to find a match
				if (valueToTest.indexOf(value.toLowerCase().trim()) != -1) {
					match = menuItem;
				}
			}

			return match;
		}

		/**
		 * Searches for a sub nav item.
		 * @param  {Object} menuItem Menu item object from nav tree
		 * @param  {String} property menuItem property
		 * @param  {String} value menuItem value
		 * @returns {Object} subMenuResult
		 */
		function findResultInSubMenus(menuItem, property, value) {
			var subMenuResult = findItemInTree(menuItem, property, value);

			if (angular.isDefined(menuItem.MENUITEM)) {
				var subMenuItems = angular.copy(menuItem.MENUITEM);
				for (var j=0; j < subMenuItems.length; j++) {
					var childSubMenuResult = findResultInSubMenus(subMenuItems[j], property, value);

					if (angular.isDefined(childSubMenuResult)) {
						subMenuResult = childSubMenuResult;
						break;
					}
				}
			}

			return subMenuResult;
		}

		/**
		 * Searches for a nav item in the tree by property.
		 * @param  {String} property menuItem property
		 * @param  {String} value menuItem value
		 * @param {Boolean} ignoreActiveState Ignores the active state check
		 * @returns {Object} menuItem
		 */
		service.lookupTreeByProperty = function(property, value, ignoreActiveState) {
			var result = undefined;
			if (angular.isDefined(property)) {
				var menuItems = AppData.globalDependencies['GetApplicationConsolidated'].TREE.MENUITEM

				for (var i = 0; i < menuItems.length; i++) {
					if (!menuItems[ i ].isactive && !ignoreActiveState) {
						continue;
					}


					result = findItemInTree(menuItems[i], property, value);

					if (angular.isDefined(result)) {
						break;
					} else if (angular.isUndefined(result) && menuItems[ i ].MENUITEM) {
						//do depth-first search
						result = findResultInSubMenus(menuItems[ i ], property, value);
						if (angular.isDefined(result)) {
							break;
						}
					}
				}
			}

			return result;
		}

		/**
		 * Routes the user to an alternate module
		 * @param  {Object} menuItem Menu item object from nav tree
		 * @returns {void}
		 */
		service.routeToAlternateModule = function(menuItem) {
			var view = ExtraFlow.getAlternateFlowView(menuItem.alternateModule, menuItem.keywords);
			if (view) {
				var path = ExtraFlow.isAlternateFlowViewRepresentedAsAStateName(menuItem.alternateModule) ? '' : ('/' + menuItem.keywords);
				$rootScope.routeTo(view + path);
				AppData.updateMenuItem(menuItem.keywords);
			} else {
				throw new Error('Unable to route to alternate module');
			}
		}


		/**
		 * Unselect the menu items in the navigation bar
		 * @returns {void}
		 */
		service.unSelectMenuItems = function() {
			var menuItems = AppData.menuItems;
			for (var i in menuItems) {
				menuItems[i].selected = false;
				if (menuItems[i].MENUITEM && menuItems[i].MENUITEM.length > 0) {
					for (var s in menuItems[i].MENUITEM) {
						menuItems[i].MENUITEM[s].selected = false;
						if (menuItems[i].MENUITEM[s].MENUITEM && menuItems[i].MENUITEM[s].MENUITEM.length > 0) {
							for (var g in menuItems[i].MENUITEM[s].MENUITEM) {
								menuItems[i].MENUITEM[s].MENUITEM[g].selected = false;
							}
						}
					}
				}
			}
		}


		return service;
	});
'use strict';

angular.module('app').factory('OrderService',
	function(AppData,
		Enums,
		RouteRejectionService,
		Language,
		Security,
		Storage,
		Utilities,
		$log,
		$q,
		$rootScope,
		$state,
		$stateParams,
		TicketUtilsService,
		UtilsValidation
	) {
		var validString = UtilsValidation.validString,
			isArray = Array.isArray,
			safelyCheckProp = Utilities.safelyCheckPropertyOnObject;

		var service = {
			// instance variables
			email: undefined,
			phoneNumber: undefined,
			orderID: undefined,
			lastFour: undefined,
			token: undefined,
			customerID: undefined,
			cToken: null,
			eToken: null,
			pToken: null,
			oToken: null,

			// Methods
			clear: clear,
			checkToken: checkToken,
			saveToken: saveToken,
			createToken: createToken,
			orderLoaded: orderLoaded,
			handleAccessToOrderViewRouting: handleAccessToOrderViewRouting,
			accessTokenizedRoute: accessTokenizedRoute,
			hasCompleteStoredOrderData: hasCompleteStoredOrderData,
			loadFromStorage: loadFromStorage,
			retrieveOrderInfo: retrieveOrderInfo,
			retrieveTokenizedOrderInfo: retrieveTokenizedOrderInfo,
			validateOrderIdCustomerIdOrToken: validateOrderIdCustomerIdOrToken,
			setOrderDetails: setOrderDetails,
			getPrintTicketURL: getPrintTicketURL,
			getOrderViewRoute: getOrderViewRoute
		};

		var getBoolean = Utilities.getBoolean;

		/**
		 * Returns the url to print the tickets.
		 * @public
		 * @function
		 * @name getPrintTicketURL
		 * @return {String} the url to print tickets
		 */
		function getPrintTicketURL() {
			var printPath = JSON.parse(AppData.settings.print_path);
			var url = validString(AppData.environment) && validString(printPath[AppData.environment]) ? printPath[AppData.environment] : printPath.production;

			// If we dont have a question mark, add it so we can append our params.
			if (url.indexOf('?') === -1) {
				url += '?';
			}

			// If we have params after the question mark, add an extra ampersand so we can append our params.
			if (validString(url.substr(url.indexOf('?') + 1))) {
				url += '&';
			}

			if (service.oToken && service.cToken) {
				return url + 'oToken='+ service.oToken + '&cToken=' + service.cToken + '&V4=true&print=true';
			}

			return url + 'order_id='+ service.orderID + '&ph=' + service.phoneNumber + '&V4=true&print=true';
		}

		/**
		 * Returns the route to the order view page
		 * @public
		 * @param {Boolean} disableAltRoute Disable the alternate route
		 * @return {String} the route to go to. For use with $rootState.routeTo();
		 */
		function getOrderViewRoute(disableAltRoute) {
			return $state.href('order-view-encrypted', {
				cToken: service.cToken,
				disableAltRoute: disableAltRoute,
				oToken: service.oToken
			});
		}

		function clear() {
			service.email = undefined;
			service.phoneNumber = undefined;
			service.orderID = undefined;
			service.lastFour = undefined;
			service.token = undefined;
			service.customerID = undefined;
			service.cToken = null;
			service.eToken = null;
			service.oToken = null;
			service.pToken = null;
		}

		/**
		 * Sets the main order details on the service.
		 * @public
		 * @function
		 * @name setOrderDetails
		 * @param {AppData.GuestViewOrder} viewOrderReply The view order response
		 * @return {undefined}
		 */
		function setOrderDetails(viewOrderReply) {
			var customer = viewOrderReply.CUSTOMER_DETAILS_REPLY.CUSTOMER,
				orderStatus = viewOrderReply.ORDER_STATUS_REPLY,
				email,
				phone;

			service.orderID = orderStatus.order_id;
			service.customerId = customer.id;
			service.createToken(viewOrderReply);

			service.cToken = customer.cToken;
			service.oToken = orderStatus.oToken;

			email = isArray(customer.EMAIL) ? customer.EMAIL[0] : customer.EMAIL;
			email = email || {};
			service.email = email.address;
			service.eToken = email.eToken;

			phone = isArray(customer.PHONE) ? customer.PHONE[0] : customer.PHONE;
			service.phoneNumber = phone.number;
			service.pToken = phone.pToken;
		}

		function createToken(viewOrderReply) {
			if (angular.isDefined(viewOrderReply.ORDER_STATUS_REPLY.cart_id)
			&& angular.isDefined(viewOrderReply.ORDER_STATUS_REPLY.order_date)) {
				service.token = Security.md5(viewOrderReply.ORDER_STATUS_REPLY.order_date + viewOrderReply.ORDER_STATUS_REPLY.cart_id);
			}
		}
		function saveToken() {
			if (angular.isDefined(service.token)) {
				Storage.set('_OrderServiceToken', service.token, true);
			}
		}

		function checkToken(viewOrderReply) {
			if (angular.isUndefined(service.token)) {
				service.token = Storage.get('_OrderServiceToken');
				if (!service.token) {
					service.token = undefined;
				}
			}
			if (angular.isDefined(service.token)
			&& angular.isDefined(viewOrderReply.ORDER_STATUS_REPLY.cart_id)
			&& angular.isDefined(viewOrderReply.ORDER_STATUS_REPLY.order_date)) {
				return (service.token == Security.md5(viewOrderReply.ORDER_STATUS_REPLY.order_date + viewOrderReply.ORDER_STATUS_REPLY.cart_id));
			}
			return false;
		}


		/**
		 * Returns true if current order data is present in memory for a requested order
		 * @param orderId
		 * @returns {*|boolean}
		 */
		function hasCompleteStoredOrderData(orderId) {
			return safelyCheckProp('AppData.GuestViewOrder.VIEW_ORDER_REPLY.ORDER_STATUS_REPLY.order_id', AppData) &&
				AppData.GuestViewOrder.VIEW_ORDER_REPLY.ORDER_STATUS_REPLY.order_id === orderId;
		}

		/**
		 * Has Data to make
		 * @param orderId
		 * @returns {boolean}
		 */
		function hasServiceDataToMakeOrderRequest(orderId) {
			return (angular.isDefined(service.orderID) &&
				service.orderID === orderId && angular.isDefined(service.phoneNumber) || angular.isDefined(service.customerID));
		}

		/**
		 * Promise to handle the order view routing for URLS that tokenized customerId, orderId and phoneNumber
		 * @param {String} orderId The order ID
		 * @param {String} stateToContinueTo The state to continue to
		 * @param {Object} The state params
		 * @param {Boolean} forceRealTimeRetrieval Not sure
		 * @returns {Promise}
		 */
		function handleAccessToOrderViewRouting(orderId, stateToContinueTo, stateParams, forceRealTimeRetrieval) {
			$rootScope.showSpinner(Language.getLocale('ApplicationLabels', 'orderSearchLoadMsg'));

			return retrieveOrderInfo(orderId, service.customerID, service.phoneNumber, forceRealTimeRetrieval)
				.then(function(response) {
					if (safelyCheckProp('response.status', response) && response.status === Enums.status.OK) {
						service.setOrderDetails(response.VIEW_ORDER_REPLY);

						return response;
					}

					return $q.reject(new Error(Enums.orderRetrievalStatuses.FAILED_RESPONSE));
				})
				.catch(function(err) {
					var newRoute,
						newParams;

					if (safelyCheckProp('err.message', err) && err.message === Enums.orderRetrievalStatuses.FAILED_RESPONSE) {
						newRoute = $state.current.name.length === 0 ? '/' : $state.current.name;
						newParams = newRoute === '/' ? {} : $stateParams;
						return $q.reject(new RouteRejectionService.ViewException('Alert', 'noOrdersFoundTitle', 'noOrdersFoundMsg', newRoute, newParams));
					} else {
						return $q.reject(new RouteRejectionService.UnrecoverableException('order-verification', {
							fromParams: JSON.stringify(stateParams),
							fromState: stateToContinueTo,
							orderId: orderId
						}));
					}
				});
		}

		function loadFromStorage(viewOrderReply) {
			// already loaded
			if (angular.isDefined(service.phoneNumber) && validString(service.pToken)) {
				return true;
			}

			if (angular.isObject(viewOrderReply)) {
				service.setOrderDetails(viewOrderReply);
			}
		}

		/**
		 * Find out if an order is already loaded into memory. Requires a minimum of two arguments to validate.
		 * @public
		 * @param {String} oToken The tokenized order id
		 * @param {String} cToken The tokenized customer id
		 * @param {String} pToken The tokenized phone number
		 * @returns {boolean} if it's loaded into memory or not
		 */
		function orderLoaded(oToken, cToken, pToken) {
			var oTokenSet = validString(oToken) && service.oToken === oToken,
				cTokenSet = validString(cToken) && service.cToken === cToken,
				pTokenSet = validString(pToken) && service.pToken === pToken,
				setCount = [oTokenSet, cTokenSet, pTokenSet].filter(function(val) {
					return val;
				}).length,
				returnProp = function(val) {
					return val;
				},
				viewOrderReply = (AppData.GuestViewOrder || {}).VIEW_ORDER_REPLY,
				loadedCToken,
				loadedOToken,
				loadedPToken,
				loadedCount = 0;

			// must match at least 2
			if (setCount < 2) {
				return false;
			}

			loadedCToken = safelyCheckProp('viewOrderReply.CUSTOMER_DETAILS_REPLY.CUSTOMER.cToken', viewOrderReply, returnProp);
			loadedOToken = safelyCheckProp('viewOrderReply.ORDER_STATUS_REPLY.oToken', viewOrderReply, returnProp);
			loadedPToken = safelyCheckProp('viewOrderReply.CUSTOMER_DETAILS_REPLY.CUSTOMER.PHONE', viewOrderReply, function(phone) {
				var foundPhone;
				if (Array.isArray(phone)) {
					foundPhone = phone.find(function(currentPhone) {
						return currentPhone.pToken === pToken;
					});
				} else if (UtilsValidation.isRealObject(phone)) {
					foundPhone = phone;
				}

				if (foundPhone) {
					return foundPhone.pToken;
				}

				return '';
			});

			if (oTokenSet && loadedOToken === oToken) {
				loadedCount++;
			}

			if (pTokenSet && loadedPToken === pToken) {
				loadedCount++;
			}

			if (cTokenSet && loadedCToken === cToken) {
				loadedCount++;
			}

			return loadedCount >= setCount;
		}

		/**
		 * Handles assessing the routability of a tokenized order view page
		 * @public
		 * @param {String} oToken The tokenized order ID
		 * @param {String} pToken The tokenized phone number
		 * @param {String} cToken The tokenized customer ID
		 * @param {Object} $state The service
		 * @param {Object} toParams The state params
		 * @return {Promise} A promise to fetch the data
		 */
		function accessTokenizedRoute(oToken, pToken, cToken, $state, toParams) {
			$rootScope.showSpinner(Language.getLocale('ApplicationLabels', 'orderSearchLoadMsg'));

			return service
				.retrieveTokenizedOrderInfo(oToken, pToken, cToken)
				.then(function(response) {
					if (safelyCheckProp('response.status', response) && response.status === Enums.status.OK) {
						service.setOrderDetails(response.VIEW_ORDER_REPLY);

						return response;
					}

					return $q.reject(new Error(Enums.orderRetrievalStatuses.FAILED_RESPONSE));
				})
				.catch(function() {
					var newRoute = $state.current.name.length === 0 ? '/' : $state.current.name;
					var newParams = newRoute === '/' ? {} : toParams;

					return $q.reject(new RouteRejectionService.ViewException('Alert', 'noOrdersFoundTitle', 'noOrdersFoundMsg', newRoute, newParams));
				});
		}

		/**
		 * Fetches an order view with the tokenized order id, phone number and customer id
		 * @public
		 * @param {String} oToken The tokenized order ID
		 * @param {String} pToken The tokenized phone number
		 * @param {String} cToken The tokenized customer ID
		 * @return {Promise} A promise to fetch the data
		 */
		function retrieveTokenizedOrderInfo(oToken, pToken, cToken) {
			var request = { oToken: oToken };

			if (validString(pToken)) {
				request.pToken = pToken;
			}

			if (validString(cToken)) {
				request.cToken = cToken;
			}

			return AppData.fetch(Enums.services.VIEW_ORDER, false, request, true, undefined, true)
				.then(function(response) {
					if (safelyCheckProp('response.status', response) && response.status === Enums.status.OK) {
						return response;
					} else {
						return $q.reject(new Error(Enums.orderRetrievalStatuses.FAILED_RESPONSE));
					}
				})
		}

		/**
		 * Retrieve an order given
		 * @param orderId - required parameter
		 * @param customerId - optional but must be supplied
		 * @param phoneNumber
		 * @param [forceRealTimeRetrieval] - optional param to force the retrieval of order data
		 * @returns {*}
		 */
		function retrieveOrderInfo(orderId, customerId, phoneNumber, forceRealTimeRetrieval) {
			if ((angular.isDefined(customerId) || angular.isDefined(phoneNumber)) || hasServiceDataToMakeOrderRequest(orderId)) {
				var request = { order_id: orderId };
				if (angular.isDefined(customerId) || angular.isDefined(service.customerID)) {
					request.customer_id = angular.isDefined(customerId) ? customerId : service.customerID;
				} else if (angular.isDefined(phoneNumber) || angular.isDefined(service.phoneNumber)) {
					request.phone_number = angular.isDefined(phoneNumber) ? phoneNumber : service.phoneNumber;
				}
				// make a ViewOrder request
				return AppData.fetch(Enums.services.VIEW_ORDER, false, request, true, undefined, true)
					.then(function(response) {
						if (safelyCheckProp('response.status', response) && response.status === Enums.status.OK) {
							return response;
						} else {
							return $q.reject(new Error(Enums.orderRetrievalStatuses.FAILED_RESPONSE));
						}
					})
			} else {
				return $q.reject(new Error(Enums.orderRetrievalStatuses.INSUFFICIENT_REQUEST_DATA));
			}
		}

		/**
		 * Validates that the ViewOrder response matches the token in the URL.
		 * @public
		 * @function
		 * @name validateOrderIdCustomerIdOrToken
		 * @param {Service} $currentParams The state params service
		 * @return {Function} the callback to handle the response from OrderService.handleAccessToOrderViewRouting
		 */
		function validateOrderIdCustomerIdOrToken($currentParams) {
			return function(data) {
				var customerId = $currentParams.customerId,
					cartId,
					orderDate,
					token;

				if ($currentParams.token) {
					cartId = data.VIEW_ORDER_REPLY.ORDER_STATUS_REPLY.cart_id;
					orderDate = data.VIEW_ORDER_REPLY.ORDER_STATUS_REPLY.order_date;
					token = Security.md5(orderDate + cartId);

					if (String(token).toLowerCase() !== String($currentParams.token).toLowerCase()) {
						$log.log("Redirect Warning: tokens don't match - redirecting home");
						throw new RouteRejectionService.UnrecoverableException('/');
					}
				} else if (customerId && customerId !== data.VIEW_ORDER_REPLY.CUSTOMER_DETAILS_REPLY.CUSTOMER.id) {
					$log.log("Redirect Warning: customerId don't match - redirecting home");
					throw new RouteRejectionService.UnrecoverableException('/');
				}

				return data;
			};
		}

		return service;
	});

angular
	.module('app')
	.factory('Package', function(
		$log,
		$q,
		$rootScope,
		$filter,
		$location,
		$stateParams,
		$state,
		$urlService,
		AppData,
		errorTracking,
		CustomActionService,
		Enums,
		ExtraFlow,
		JSONValidator,
		RouteHistoryService,
		Language,
		StandardFlowInitiatorService,
		Modal,
		Utilities,
		UtilsValidation,
		UtilityFunctions
	) {
		/**
		 * Find out if a variable is an object.
		 * @protected
		 * @type {Function}
		 */
		var isObject = angular.isObject,
			isArray = Array.isArray,
			checkProp = Utilities.checkProp,
			first = Utilities.first,
			getBoolean = Utilities.getBoolean,
			getString = Utilities.getString,
			merge = Utilities.merge,
			validArray = UtilsValidation.validArray,
			validObject = UtilsValidation.validObject,
			validString = UtilsValidation.validString;

		var Package = {
			// array -- used by doSeriesXFC. Items to be added to cart, before any XFC stuff and after upsell Processing.
			preCartItems: [],
			preCartItemsIndex: 0, // integer -- used by doSeriesXFC -- position in the preCartItems to work with.
			finalCartItemsToBeAdded: [],
			itemsToBeAdded: [],
			alternateModuleItemsToBeAdded: undefined,
			isAdvancedTicket: false,
			advanceTicketDate: null,
			lastAccessedPackageList: [],
			customerTypes: [],
			customerTypeGroups: [],
			packageDetails: {},
			originalPackage: {
				customerTypes: [],
				customerTypesTemp: [], // array -- used for changing quantities on the upgrade page. our workspace area.
				packageDetails: {},
				isAdvancedTicket: false,
				advancedTicketDate: null
			},
			upsellCustomerTypeMapping: {},
			upsellPackage: {
				customerTypes: [],
				customerTypesTemp: [], // array -- used for changing quantities on the upgrade page. our workspace area.
				packageDetails: {},
				isAdvancedTicket: false,
				advancedTicketDate: null,
				skip: false // boolean -- tells PackageDetails whether to display the modal or not for upsells.
			},
			configuredPackageDetailsCTGroups: [],
			isDated: isDated,
			isTimed: isTimed,
			getCurrentPackageCharacs: getCurrentPackageCharacs
		};

		/**
		 * Find out if a package is dated.
		 * @param {Object} pkg The package
		 * @returns {Boolean} If it's a dated product
		 */
		function isDated(pkg) {
			return [1, 2].includes(Utilities.forceInt(pkg.E.date));
		}

		/**
		 * Find out if a package is timed.
		 * @param {Object} pkg The package
		 * @returns {Boolean} If it's a dated product
		 */
		function isTimed(pkg) {
			return Utilities.forceInt(pkg.E.date) === 1;
		}

		/**
		 * Returns the current package's characs.
		 * @public
		 * @function
		 * @name getCurrentPackageCharacs
		 * @memberof {PackageService}
		 * @return {null|Object} The current package's characs
		 */
		function getCurrentPackageCharacs() {
			if (!isObject(this.packageDetails) || Array.isArray(this.packageDetails)) {
				return null;
			}

			return this.packageDetails.CHARACS;
		}

		Package.filterByParentPackages = function filterParentPackages(keywordPackages) {
			if (!Array.isArray(keywordPackages)) {
				return [];
			}

			return keywordPackages.filter(function filterPkgs(pkg) {
				var characs = pkg.CHARACS;
				return !characs || !characs.hasOwnProperty('parentPackageID');
			});
		};

		/**
		 * Copy of cart items that match the package Id from the current
		 * Package.packageDetails object.
		 * This is the opposite of the LegacyCart.editingCartCopy object.
		 * @type {Array}
		 */
		Package.cartItemsForCurrentPackage = [];


		Package.packageXFCs = [];
		var xfcFinalCallback;
		// integer -- Really?
		var currentXFC = -1;
		var previousXFC = -1;
		// integer -- Really?
		var qtyAdded = 0;
		var retainCharacs = ['card_type_required', 'isAddonPackage']; // Copy these CHARACS over to items being added.

		/**	-----------------------------------------------------------------------
		 *	FOLLOWING ARE CONTROLLER FOR PACKAGE QTY MANIPULATION
		 *	-----------------------------------------------------------------------
		 */

		/**
		 * Handles manual user input of the numeric stepper. Ensures that the
		 * value entered is not less than the min quantity on the package or
		 * greater than the max quantity.
		 *
		 * @param {Object} data data passed by the click event.
		 * @param {Boolean} editing if the user is editing
		 * @returns {undefined}
		 */
		Package.onQtyChange = function(data, editing) {
			data.qty = String(data.qty).replace(/\D/g, '');

			// Dealing with numbers.
			data.qty = Number(data.qty);
			data.min_quantity = Number(data.min_quantity);
			data.max_quantity = Number(data.max_quantity);

			if (!isNaN(data.overrideCustomerTypeMaxQty)) {
				data.max_quantity = data.overrideCustomerTypeMaxQty;
			}

			if (data.qty === '' || isNaN(data.qty)) {
				return;
			}

			var qtyEntered = data.qty;
			if (qtyEntered > data.min_quantity && qtyEntered <= data.max_quantity) {
				data.qty = qtyEntered;
			}

			if (Package.customerTypes.length <= 1) {
				if (editing && ((data.qty < data.min_quantity) || (data.qty <= 0))) {
					// Otherwise set to zero if less than min qty or some how they set it to less than 0.
					qtyEntered = 0;
				} else if (qtyEntered < data.min_quantity) {
					qtyEntered = data.min_quantity;
				}
			}

			if (editing && ((data.qty < data.min_quantity) || (data.qty <= 0))) {
				// Otherwise set to zero if less than min qty or some how they set it to less than 0.
				qtyEntered = 0;
			}

			if (data.min_quantity <= qtyEntered && qtyEntered <= data.max_quantity) {
				qtyEntered = Package.checkRateTypeConfig(data, qtyEntered);
			} else {
				if (qtyEntered >= data.max_quantity) {
					qtyEntered = data.max_quantity;
					// Show entry exceeded maximum allowed limit message.
					Modal.displayModal({
						label: 'Error',
						title: Language.getLocale('Alert', 'entryGreaterThanMaxError'),
						description: Language.getLocale('Alert', 'entryGreaterThanMaxErrorMsg')
					});
				} else if (qtyEntered < data.min_quantity && qtyEntered !== 0) {
					qtyEntered = data.min_quantity;
					// Show entry exceeded maximum allowed limit message.
					Modal.displayModal({
						label: 'Error',
						title: Language.getLocale('Alert', 'entryLessThanMinError'),
						description: Language.getLocale('Alert', 'entryLessThanMinErrorMsg')
					});
				}
			}

			data.qty = qtyEntered;
			$rootScope.$emit('qtyChanged');
		};

		/**
		 * Updates the last accessed package list, an array of IDs derived from the package list passed in.
		 * @param {Object} packageList The package list contained in an object
		 * @returns {undefined}
		 */
		Package.updateLastAccessedPackageList = function(packageList) {
			// Reset the array between uses
			this.lastAccessedPackageList = [];
			if (packageList) {
				packageList = !isArray ? Object.values(packageList) : packageList;
				packageList.forEach(function forEachPackage(pkg) {
					// If the IDs of the packages are found in the root object, add them to the list
					if (checkProp('pkg.id', pkg)) {
						Package.lastAccessedPackageList.push(pkg.id);
						// In some cases, it is found in the package details property of the object
					} else if (checkProp('pkg.packageDetails.id', pkg)) {
						Package.lastAccessedPackageList.push(pkg.packageDetails.id);
					}
				});
			}
		};

		/**
		 * Handles the increment button click event on the numeric stepper.
		 * Increments the quantity on the specific rate type data object. If it's
		 * a value greater than the package's max quantity, it sets the value to
		 * max quantity.
		 *
		 * @param {Object} data  current data item in the repeater.
		 * @returns {undefined}
		 */
		Package.incrementQty = function(data) {
			var qtyHandler = data.qty;
			qtyHandler++;

			//if min_quantity is not set
			if (isNaN(data.min_quantity)) {
				data.min_quantity = 1;
			}

			//if max_quantity is not set
			if (isNaN(data.max_quantity)) {
				data.max_quantity = 999;
			}

			if (!isNaN(data.overrideCustomerTypeMaxQty)) {
				data.max_quantity = data.overrideCustomerTypeMaxQty;
			}

			if (qtyHandler != 0 && qtyHandler < data.min_quantity && Package.packageDetails.type.toLowerCase() !== 'l') {
				qtyHandler = data.min_quantity;
			} else if (Package.packageDetails.type.toLowerCase() === 'l') {
				data.qty = qtyHandler;
			}

			if (data.min_quantity <= qtyHandler && qtyHandler <= data.max_quantity) {
				data.qty = Package.checkRateTypeConfig(data, qtyHandler);
			}

			return data.qty;
		};

		/**
		 * Performs check on Rate Type Max Qty Config
		 * @public
		 * @param {Object} data - Package Info
		 * @param {String} qtyHandler - Quantity handler
		 * @returns {Number} qty
		 */
		Package.checkRateTypeConfig = function(data, qtyHandler) {
			var packageConfig = '';

			if (Package &&
				Package.packageDetails &&
				Package.packageDetails.CHARACS) {
				packageConfig = Package.packageDetails.CHARACS.appConfig;
			}

			if (typeof packageConfig == 'undefined') {
				packageConfig = '';
			}
			if (!packageConfig) {
				Number(qtyHandler);
			}

			packageConfig = packageConfig.split(' ').join('').split(',');

			if (typeof AppData.settings.rate_type_max_quantity != "undefined" && packageConfig.indexOf('rate_type_max_quantity') != -1) {
				var handled = false,
					full_rtmq = JSON.parse(AppData.settings.rate_type_max_quantity),
					rtmq = full_rtmq[Package.packageDetails.id],
					basePackage = getBasePackage(rtmq);
				if (full_rtmq.hasOwnProperty(data.package_id)) {
					angular.forEach(rtmq, function(value, key) {
						if (basePackage != null) {
							if (basePackage.ct_id == value.ct_id && qtyHandler <= basePackage.max_qty) {
								basePackage.current_qty = Number(qtyHandler);
							}
							if (Utilities.childDefined(value, 'maxQtyIsMultiplier')) {
								if (value.maxQtyIsMultiplier == true) {
									basePackage.current_qty = basePackage.current_qty || 1;
									value.max_qty = basePackage.current_qty * value.max_qty;
								}
							}
						}
						for (rateType in Package.customerTypes) {
							if (Package.customerTypes[rateType].customer_type == value.ct_id) {
								setMaxQty(Package.customerTypes[rateType], value)
								setMinQty(Package.customerTypes[rateType], value);
							}
						}
					});
					for (idx in rtmq) {
						rtmq[idx].min_qty = rtmq[idx].min_qty || 1
						if (qtyHandler <= rtmq[idx].max_qty && qtyHandler >= rtmq[idx].min_qty && data.customer_type == rtmq[idx].ct_id) {
							return Number(qtyHandler);
						}
						if (qtyHandler > rtmq[idx].max_qty && data.customer_type == rtmq[idx].ct_id) {
							return Number(rtmq[idx].max_qty);
						}
					}
				}
				return Number(qtyHandler);
			} else {
				return Number(qtyHandler);
			}
		};

		/**
		 * Sets the Max Qty of a rate type
		 * @private
		 * @param {Object} rateType
		 * @returns {undefined}
		 */
		function setMaxQty(rateType, configObj) {
			rateType.max_quantity = configObj.max_qty;
		}

		/**
		 * Sets the Min Qty of a rate type
		 * @private
		 * @param {Object} rateType The rate Type Object
		 * @param {Object} configObj The config Object
		 * @returns {undefined}
		 */
		function setMinQty(rateType, configObj) {
			if (Utilities.childDefined(configObj, 'min_qty')) {
				rateType.min_quantity = configObj.min_qty;
			} else {
				rateType.min_quantity = 0;
			}
		}

		/**
		 * Gets the base package info
		 * @private
		 * @param {Object} rtmq
		 * @param {Object|null} base
		 */
		function getBasePackage(rtmq) {
			var base = null;
			angular.forEach(rtmq, function(r, idx) {
				if (Utilities.childDefined(r, 'isBase')) {
					if (r.isBase == true) {
						base = rtmq[ idx ];
					}
				}
			});
			return base;
		}

		/**
		 * Handles the decrement button click event on the numeric stepper.
		 * Decrements the quantity on the specific rate type data object. Resets
		 * the new value to 0 if its negative value. If it's a value less than
		 * the package's min quantity, it jumps down to zero. Also check against
		 * max quantity in case a user manually inserted a quantity > than max
		 * followed by clicking the decrement button.
		 *
		 * @param {Object} data data item in the repeater.
		 * @param {Boolean} editing if the user is editing the cart.
		 * @param {Boolean} isQuickSell if it's a quicksell item
		 * @returns {undefined}
		 */
		Package.decrementQty = function(data, editing, isQuickSell) {
			// Decrement the quantity stepper by 1. Ensure qty is never less than
			// min qty set on package level. Also, ensure qty is never less than 0.
			data.qty -= 1;

			if (isNaN(data.min_quantity)) {
				data.min_quantity = 1;
			}

			if (isNaN(data.max_quantity)) {
				data.max_quantity = 999;
			}

			if (!isNaN(data.overrideCustomerTypeMaxQty)) {
				data.max_quantity = data.overrideCustomerTypeMaxQty;
			}

			if (editing && ((data.qty < data.min_quantity) || (data.qty <= 0))) {
				// Otherwise set to zero if less than min qty or some how they set it to less than 0.
				data.qty = 0;
			} else if (data.qty > data.max_quantity) {
				data.qty = data.max_quantity;
			} else if (Package.customerTypes.length == 1 && !isQuickSell) {
				// Rebound to pkg min qty only when prepopulate_customer_type_qty_with_min is set
				// (PEC-24837); otherwise floor at 0 so the guest can freely deselect a single-CT item.
				var floor = checkProp('Package.packageDetails.CHARACS', Package) && getBoolean(Package.packageDetails.CHARACS.prepopulate_customer_type_qty_with_min)
					? data.min_quantity
					: 0;
				if (data.qty < floor) {
					data.qty = floor;
				}
			}
			return data.qty;
		};

		Package.getTotalToBeAdded = function(excludeOverridden, filterByMovie, movieName) {
			excludeOverridden = typeof excludeOverridden !== 'undefined' ? excludeOverridden : true;
			filterByMovie = typeof filterByMovie !== 'undefined' ? filterByMovie : false;

			if (filterByMovie && (typeof movieName === 'undefined')) {
				throw new Error("LegacyCart.getTotalLessOverride() called without movieName defined");
			}


			var qtySum = 0;
			if (Package.itemsToBeAdded.length) {
				for (var i = 0; i < Package.itemsToBeAdded.length; i++) {
					var item = Package.itemsToBeAdded[i];

					if (filterByMovie && 'extra_movie' in item) {
						// filter cart items by movie
						var regex = new RegExp('\\b' + movieName + '\\b');
						var exists = (item.extra_movie.search(regex) > -1);
						if (!exists) {
							continue;
						}
					}

					if (excludeOverridden) {
						if (Package.getCartLimitOverride(item) != '1') {
							qtySum += Number(item.qty);
						}
					} else {
						qtySum += Number(item.qty);
					}
				}
			}

			return qtySum;
		};

		/**
		 * Compares the items to be added with the cart Limit, making sure that this does not pass the limit of the
		 * cart not including those that are override Items
		 * @param {Number} totalLessOverrideBeingAdded
		 * @param {Object} LegacyCart
		 * @returns {Boolean}
		 */

		Package.getCartLimitOverride = function(item) {
			if (typeof(item.cart_limit_override) == 'undefined') {
				return 0;
			} else {
				return Number(item.cart_limit_override);
			}
		};


		/**
		 *	This handles upsells and their originating package, and helps to process XFC/movie controllers.
		 *	This will loop through the preCartItems, created from the UpsellCtrl, and place each item
		 *	in the array, into the relevant objects inside of Package, for processing by the xfc
		 *	related functions.  ie: doXFC(), nextXFC();
		 *
		 *	Once it has run through the XFCs for each page, it will finish by calling the callback function.
		 *
		 *	@param {Function} seriesCallback the function to call once all the XFCs per package have been coompleted.
		 *	@returns {null}
		 */

		Package.doSeriesXFC = function(seriesCallback) {
			if (Package.preCartItems.length > 0) {
				if (Package.preCartItemsIndex < Package.preCartItems.length) {
					if (Package.preCartItemsIndex == 0) {
						//reset the final items added list - currently only used by upsell seriesCallback
						Package.resetFinalizedItemsAddedList();
					}
					var packageDetails = Package.preCartItems[ Package.preCartItemsIndex ].packageDetails;
					var customerTypes = Package.preCartItems[ Package.preCartItemsIndex ].customerTypes;
					var itemsToBeAdded = Package.preCartItems[ Package.preCartItemsIndex ].itemsToBeAdded;

					// calling XFC will create handle the flow necessary for each package, if it applies.
					Package.doXFC(
						packageDetails
						, itemsToBeAdded
						, customerTypes
						, function() {
							// increment the index to the next position.
							Package.preCartItemsIndex++;
							Package.addCurrentItemsToBeAddedToFinalList();
							Package.doSeriesXFC(seriesCallback);
						}
					);
				} else {
					// we should be done. // move on to the add to cart functionality.
					Package.preCartItems.length = 0;
					seriesCallback();
				}
			} else {
				// we can not find any items in the preCartItems array.
				return false;
			}
		};


		/**
		 * Does the package settings require a particular charac
		 * @param characName
		 * @returns {Boolean}
		 */
		Package.doesPackageSettingsRequireCharac = function(characName) {
			var isRequiredCharac = false;
			if (checkProp('Package.settings.characsList', Package)) {
				isRequiredCharac = angular.isDefined(Package.settings.characsList.filter(function(charac) {
					return charac == characName;
				})[0]);
			}

			return isRequiredCharac;
		};

		/**
		 * Reset the final list for adding
		 * (currently upsells only uses this list because there is a different call back for upsells called
		 * addUpsellsToCart - but future should be to migrate all upsells to use
		 *
		 */
		Package.resetFinalizedItemsAddedList = function() {
			Package.finalCartItemsToBeAdded = [];
		};

		/**
		 * Add the current Package.ItemsToBeAdded array to the final list of items to be added
		 * Currently only upsells use this list but future will be to migrate all AddCart flow to use one
		 */
		Package.addCurrentItemsToBeAddedToFinalList = function() {
			if (angular.isDefined(Package.itemsToBeAdded)) {
				Package.finalCartItemsToBeAdded = Package.finalCartItemsToBeAdded.concat(angular.copy(Package.itemsToBeAdded));
			}
		};

		/**
		 * Reset the items to be added and other information that should be reset before we initiate another
		 * PackageDetails/XFC flow if coming from an alternate entry
		 * @returns {undefined}
		 */
		Package.resetPackageDetailsForAlternateEntryFlow = function() {
			Package.itemsToBeAdded.length = 0;
			Package.isAdvancedTicket = false;
		};

		/**
		 * Reset advanced ticket properties
		 * @public
		 * @returns {undefined}
		 */
		Package.resetAdvancedTicket = function() {
			Package.isAdvancedTicket = false;
			Package.advanceTicketDate = null;
		};


		/**
		 * Handles the case of multiple packages being added to the cart at the same time.
		 * It calls updatePackageRetailAmount on all the packages.
		 * The first package is used for the new Package.packageDetails, and for the XFCs.
		 * @param {Array} packageList The list of packages
		 * @param {Object} itemsToBeAdded The items to be added
		 * @param {Object} customerTypes The customer types object
		 * @param {Function} callback The callback function
		 * @returns {undefined}
		 **/
		Package.doXFCForPackageList = function(packageList, itemsToBeAdded, customerTypes, callback) {
			Package.packageXFCs.length = 0;
			var pkgCount = packageList.length - 1;

			// loop through packages, finding XFCs and calculated retail amounts.
			// The first package is the one that's controlling the XFCs and the packageDetails
			for (var i = pkgCount; i >= 0; i--) {
				if (i === 0) {
					if (Package.shouldEdit(itemsToBeAdded)) {
						Package.packageXFCs = ExtraFlow.getEditableXMCsFromList(packageList[i].extra_movie, 'doEditMode');
					} else {
						Package.packageXFCs = ExtraFlow.getEnabledXFCsFromList(packageList[i].extra_movie);
					}
				}
				// updatePackageRetailAmount updates the packages in the packageList as a side effect.
				Package.packageDetails = Package.updatePackageRetailAmount(packageList[i]);
			}
			if (Package.packageXFCs.length > 0) {
				for (var j = 0; j < itemsToBeAdded.length; j++) {
					if (itemsToBeAdded[j].package_id != Package.packageDetails.id) {
						if (angular.isArray(itemsToBeAdded[j].CHARACS)) {
							itemsToBeAdded[j].CHARACS.forEach(function(c) {
								c.items_added_pkg_id_override = Package.packageDetails.id;
							});
						} else {
							itemsToBeAdded[j].CHARACS.items_added_pkg_id_override = Package.packageDetails.id;
						}
					}
				}
			}
			currentXFC = -1;
			xfcFinalCallback = callback;

			Package.itemsToBeAdded = itemsToBeAdded;
			Package.customerTypes = customerTypes;

			// If there are still XFCs left, let's process those.
			// Route to the first view and wait for response from XFC.
			if (Package.packageXFCs.length > 0) {
				Package.nextXFC();
			} else {
				xfcFinalCallback();
			}
		};

		/**
		 * Check if there are XFCs in the package.
		 * Verify control has settings in ExtraFlow.
		 * @param {Object} packageDetails Package details object
		 * @param {Object} itemsToBeAdded The items to be added
		 * @param {Object} customerTypes The customer types object
		 * @param {Function} callback The callback function
		 * @return {undefined}
		 */
		Package.doXFC = function(packageDetails, itemsToBeAdded, customerTypes, callback) {
			if (Package.shouldEdit(itemsToBeAdded)) {
				Package.packageXFCs = ExtraFlow.getEditableXMCsFromList(packageDetails.extra_movie, 'doEditMode');
			} else {
				Package.packageXFCs = ExtraFlow.getEnabledXFCsFromList(packageDetails.extra_movie);
			}
			currentXFC = -1;
			xfcFinalCallback = callback;

			// Store a reference to the details and items to be added. this will be used by the XFCs.
			Package.packageDetails = Package.updatePackageRetailAmount(packageDetails);
			Package.itemsToBeAdded = itemsToBeAdded;
			Package.customerTypes = customerTypes;

			// If we are in SF Membership Upgrade flow, then skip all the XFC and add items to cart
			if (CustomActionService.actionRegistered('skipFolioMembershipUpgradeXFC')) {
				callback();
			} else {
				// If there are still XFCs left, let's process those.
				// Route to the first view and wait for response from XFC.
				if (Package.packageXFCs.length > 0) {
					Package.nextXFC();
				} else {
					if (Package.hasDuplicateUidsInItemsList()) {
						Package.displayErrorModalForDuplicateUids();
					} else {
						xfcFinalCallback();
					}
				}
			}
		};

		/**
		 * Restores XFC state after a page reload (e.g., post-OIDC login redirect) without triggering routing.
		 * Sets the private XFC bookkeeping (currentXFC, xfcFinalCallback) and public Package state so that
		 * an in-progress XFC flow (e.g., season-pass-select) can resume normally when the user is returned
		 * to the XFC state after authenticating.
		 * @param {Object} savedPackageDetails Serialized Package.packageDetails to restore
		 * @param {Array} savedItemsToBeAdded Serialized Package.itemsToBeAdded to restore
		 * @param {Function} callback Replaces xfcFinalCallback — invoked when all XFCs are complete
		 * @returns {undefined}
		 */
		Package.resumeXFCState = function(savedPackageDetails, savedItemsToBeAdded, callback) {
			// 'ticket_demographics' is the registered alias of season_pass_select; both are valid targets.
			// ExtraFlow.processAliases deletes the aliases array after registration so we enumerate explicitly.
			var SEASON_PASS_XFC_NAMES = ['season_pass_select', 'ticket_demographics'],
				xfcIdx = 0,
				i;

			// Rebuild packageXFCs from packageDetails.extra_movie exactly as doXFC would
			Package.packageXFCs = Package.shouldEdit(savedItemsToBeAdded)
				? ExtraFlow.getEditableXMCsFromList(savedPackageDetails.extra_movie, 'doEditMode')
				: ExtraFlow.getEnabledXFCsFromList(savedPackageDetails.extra_movie);

			// Find the index of the season_pass_select XFC — matches canonical name and alias
			for (i = 0; i < Package.packageXFCs.length; i++) {
				if (SEASON_PASS_XFC_NAMES.indexOf(Package.packageXFCs[i].name) !== -1) {
					xfcIdx = i;
					break;
				}
			}

			Package.packageDetails = Package.updatePackageRetailAmount(savedPackageDetails);
			Package.itemsToBeAdded = savedItemsToBeAdded;

			// Mirror doXFC setup so itemsToBeAddedForCurrentPackage(true) can rebuild the
			// current XFC pass collection correctly after a full-page auth redirect.
			if (Package.packageXFCs.length > 0) {
				for (i = 0; i < savedItemsToBeAdded.length; i++) {
					if (savedItemsToBeAdded[i].package_id != Package.packageDetails.id) {
						if (angular.isArray(savedItemsToBeAdded[i].CHARACS)) {
							savedItemsToBeAdded[i].CHARACS.forEach(function(c) {
								c.items_added_pkg_id_override = Package.packageDetails.id;
							});
						} else {
							savedItemsToBeAdded[i].CHARACS.items_added_pkg_id_override = Package.packageDetails.id;
						}
					}
				}
			}

			// Guard: verify the season_pass_select XFC (or its alias) was actually found before restoring
			if (Package.packageXFCs.length === 0 || SEASON_PASS_XFC_NAMES.indexOf(Package.packageXFCs[xfcIdx].name) === -1) {
				$log.warn('[GPS] resumeXFCState: season_pass_select XFC not found in package — aborting restore');
				return;
			}

			xfcFinalCallback = callback;
			currentXFC = xfcIdx;
			Package.setupXFC(xfcIdx, true); // sets Package.settings and Package.xfcName, skips routing
		};

		/**
		 * Assess whether we have duplicate uids in an itemsToBeAdded model - this should never be allowed
		 * There are instances of this occurring and this is a failsafe to eliminate this from happening.
		 * @param {Array} itemsList The list of items
		 * @returns {Boolean}
		 */
		Package.hasDuplicateUidsInItemsList = function(itemsList) {
			//default to itemsToBeAdded model if we do not pass in a specific list to check
			itemsList = angular.isUndefined(itemsList) ? Package.itemsToBeAdded : itemsList;
			var hasDuplicates = false;
			var uids = [];
			for (var i = 0; i < itemsList.length; i++) {
				var item = itemsList[i];

				if (angular.isDefined(item.CHARACS) && angular.isArray(item.CHARACS)) {
					for (var j = 0; j < item.CHARACS.length; j++) {
						if (angular.isDefined(item.CHARACS[j].uid)) {
							if (uids.indexOf(item.CHARACS[j].uid) > -1) {
								hasDuplicates = true;
								break;
							} else {
								uids.push(item.CHARACS[j].uid);
							}
						}
					}
				}

				if (hasDuplicates) {
					break;
				}
			}

			return hasDuplicates;
		};

		/**
		 * Display an error modal for the case of duplicate uids
		 * @returns {undefined}
		 */
		Package.displayErrorModalForDuplicateUids = function() {
			$rootScope.hideSpinner();
			Modal.displayModal({
				label: 'Error',
				title: Language.getLocale('Alert', 'duplicateUidsInItemsAddedTitle'),
				description: Language.getLocale('Alert', 'duplicateUidsInItemsAddedMsg'),
				showCloseButton: false,
				callback: function() {
					if (angular.isDefined(StandardFlowInitiatorService.currentStandardFlowType) &&
						angular.isDefined(StandardFlowInitiatorService.currentStandardFlowDetail)) {
						$rootScope.routeTo(StandardFlowInitiatorService.getStandardFlowEntryRoute());
					} else {
						$rootScope.routeTo(Enums.routes.LIST);
					}
				}
			});
		};

		/**
		 * Determines whether we should edit a package
		 * @param {Object} itemsToBeAdded The items to be added
		 * @returns {undefined}
		 */
		Package.shouldEdit = function(itemsToBeAdded) {
			return itemsToBeAdded.some(function(e) {
				return e.isEditMode;
			});
		};

		/**
		 * Determines whether we are currently editing a package
		 * @returns {Boolean} Whether we are editing a package
		 */
		Package.isEditing = function() {
			return Package.shouldEdit(Package.itemsToBeAdded);
		};

		/**
		 * Determines if the current package has extra_movies defined
		 * @returns {boolean} Whether the package has extra movies
		 */
		Package.hasXFC = function() {
			return validArray(checkProp('Package.packageDetails.extra_movie', Package, ExtraFlow.getEnabledXFCsFromList));
		};


		/**
		 * Checks if the package has a specific XFC
		 * @param {Object} item - The precart item to check
		 * @param {String[]} extraMovies - The extra movies to check against
		 * @returns {Boolean} Whether the package has the XFC
		 */
		Package.isExtraMovieOnItem = function(item, extraMovies) {
			// Iterate the extraMovies
			return extraMovies.some(function iterateXfc(xfc) {
				// Checks the first charac / base package if the extraMovie is in the list
				return (new RegExp('\\b' + xfc + '\\b'))
					.test(getString(checkProp('item.CHARACS[].0.extra_movie', item, 'returnValue') || item.extra_movie));
			});
		};

		/**
		 * Copies the CHARACS to all the objects in items.
		 * Verify control has settings in ExtraFlow.
		 * @param {Object} items Items to copy the characs to
		 * @returns {undefined}
		 */
		Package.copyCharacsToEachItem = function(items) {
			for (var i in items) {
				if (angular.isDefined(items[i].qty) && angular.isArray(items[i].CHARACS)) {
					if (items[i].qty > 1) {
						var copyCharacs = items[i].CHARACS[0];
						// ignore all one barcode type packages

						if (angular.isDefined(copyCharacs.group_uuid)) {
							continue;
						}

						for (var j = 1; j < items[i].qty; j++) {
							items[i].CHARACS[j] = JSON.parse(JSON.stringify(copyCharacs));
						}
					}
				}
			}
		};

		/**
		 * Gets customer type name by ID
		 * @param {String} ctID The customer type ID to search for
		 * @returns {String} The customer type name
		 */
		Package.getCTNameByID = function(ctID) {
			for (var i = 0; i < Package.itemsToBeAdded.length; i++) {
				for (var j = 0; j < Package.packageDetails.CT.length; j++) {
					if (ctID == Package.packageDetails.CT[j].id) {
						return Package.packageDetails.CT[j].name;
					}
				}
			}

			return '';
		};


		/**
		 * Used by ExtraFlow Controllers (XFC) to verify we have the necessary
		 * items to be added to the cart, prior to moving ahead.
		 * If it's not ready, it will route to packageDetails or the packageList
		 * based on the packageId, and return false, else return true.
		 * @param {String} packageId The package ID
		 * @returns {Boolean} Whether we have the necessary items to proceed
		 */
		Package.initXFC = function(packageId) {
			// Ensure we have packages to add. This would not be true if user refreshed the browser.
			if (!isArray(Package.itemsToBeAdded) ||
				(isArray(Package.itemsToBeAdded) && Package.itemsToBeAdded.length === 0)) {
				// Re-route back to packageDetails if packageId is defined otherwise to packageList.
				var packageIdParam = $stateParams.packageId || packageId;
				if (packageIdParam) {
					if (StandardFlowInitiatorService.resetToPackageDetailsScreen) {
						$rootScope.routeTo(Enums.routes.DETAILS + '/' + packageIdParam);
					} else {
						//if we have a
						$rootScope.routeTo(StandardFlowInitiatorService.getStandardFlowEntryRoute());
						StandardFlowInitiatorService.resetStandardFlow();
					}
				} else {
					$rootScope.routeTo(Enums.routes.LIST);
				}
				return false;
			}
			return true;
		};

		/**
		 * This function can be used in place of initXFC as a function call within a resolve in state definitions if we
		 * do not have itemsToBeAdded in an ok state, this will provide the rejection route to throw either to the
		 * RouteRejectionService or another custom action.
		 * The problem with the initXFC function is that it will allow the other resolves in the chain that follow to
		 * execute and can produce console errors, when really we need to gracefully reject the route
		 * @param {String} packageId The package ID
		 * @returns {String} The rejection route
		 */
		Package.assessRoutabilityOfXFC = function(packageId) {
			// Ensure we have packages to add. This would not be true if user refreshed the browser.
			var rejectionRoute = '';
			if (!isArray(Package.itemsToBeAdded) || (isArray(Package.itemsToBeAdded) && Package.itemsToBeAdded.length === 0)) {
				// Re-route back to packageDetails if packageId is defined otherwise to packageList.
				if (StandardFlowInitiatorService.resetToPackageDetailsScreen && packageId) {
					rejectionRoute = Enums.routes.DETAILS + '/' + packageId;
				} else {
					rejectionRoute = StandardFlowInitiatorService.getStandardFlowEntryRoute();
					StandardFlowInitiatorService.resetStandardFlow();
				}
			}
			return rejectionRoute;
		};

		/**
		 * Proceeds to the next step in the XFC process.
		 * @param {Boolean} replaceRouteInHistory Whether to replace the route in history
		 * @returns {undefined}
		 */
		Package.nextXFC = function(replaceRouteInHistory) {
			// Either load the next XFC or execute the callback from PackageDetailsCtrl.
			replaceRouteInHistory = !!replaceRouteInHistory;
			previousXFC = currentXFC;
			currentXFC += 1;

			// if skipXFC function is registered deregister it here as it wasn't used.
			// if skipXFC function is used then the function has to deregister itself as soon as it get's called.
			if (CustomActionService.actionRegistered('skipXFC')) {
				CustomActionService.deregisterCustomAction('skipXFC');
			}
			// Completed all XFCs.
			RouteHistoryService.setDisableSaveOfRoute(true);
			if (currentXFC < Package.packageXFCs.length && isArray(Package.itemsToBeAdded)) {
				// Show spinner eagerly to prevent previous view from flashing during route transition.
				// The destination controller or onSuccess hook dismisses it.
				$rootScope.showSpinner();
				Package.setupXFC(currentXFC, false, replaceRouteInHistory);
			} else {
				// Completed all XFCs.
				// Check for duplicate uids in the items to be added as this can prevent issues for the operations team.
				// This is a failsafe due to difficulty tracking down the duplication of the issue
				if (Package.hasDuplicateUidsInItemsList()) {
					Package.displayErrorModalForDuplicateUids();
				} else {
					if (replaceRouteInHistory) {
						// $location.replace causes the next route change to replace the current route in history.
						// it allows xfcFinalCallback to replace the current url with whatever it routs to.
						$location.replace();
					}

					xfcFinalCallback();
				}
			}
		};

		/**
		 * Registers the return URL
		 * @returns {undefined}
		 */
		Package.registerReturnUrl = function(returnUrl) {
			Package.returnUrl = returnUrl;
		};

		/**
		 * Proceeds to the next step in the XFC process.
		 * @param {Boolean} replaceRouteInHistory Whether to replace the route in history
		 * @returns {undefined}
		 */
		Package.cancelXFC = function(replaceRouteInHistory) {
			replaceRouteInHistory = !!replaceRouteInHistory;
			previousXFC = currentXFC;
			currentXFC -= 1;

			RouteHistoryService.setDisableSaveOfRoute(true);

			if (CustomActionService.actionRegistered('skipXFC')) {
				CustomActionService.executeCustomAction('skipXFC', currentXFC);
			} else if (currentXFC >= 0) {
				Package.setupXFC(currentXFC, false, replaceRouteInHistory);
			} else if (angular.isDefined(Package.returnUrl)) {
				$rootScope.routeTo(Package.returnUrl, undefined, undefined, replaceRouteInHistory);
			} else if (Package.isEditing()) {
				// Cancelled all XFCs and in edit mode - go back to the cart.
				$rootScope.routeTo(Enums.routes.CART, undefined, undefined, replaceRouteInHistory);
			} else {
				// Is the previous state using an alternate entry?
				if (StandardFlowInitiatorService.currentStandardFlowType === 'alternateEntry') {
					// Navigate to it directly using the params, unless the flow goes through the standard
					// package details screen — in that case honor resetToPackageDetailsScreen so that
					// canceling an XFC (e.g. addons_choice back) returns to package details, not the list.
					if (StandardFlowInitiatorService.resetToPackageDetailsScreen) {
						var pkgId = Package.packageDetails && Package.packageDetails.id;
						if (pkgId) {
							$rootScope.routeTo(Enums.routes.DETAILS + '/' + pkgId, undefined, undefined, replaceRouteInHistory);
						} else {
							Utilities.goTo(StandardFlowInitiatorService.alternateEntryState, StandardFlowInitiatorService.alternateEntryParams, replaceRouteInHistory);
						}
					} else {
						Utilities.goTo(StandardFlowInitiatorService.alternateEntryState, StandardFlowInitiatorService.alternateEntryParams, replaceRouteInHistory);
					}
				// Does the previous state have a route to go back to?
				} else if (StandardFlowInitiatorService.currentStandardFlowType && angular.isDefined(StandardFlowInitiatorService.currentStandardFlowDetail)) {
					// Navigate using the flow type and details
					$rootScope.routeTo(StandardFlowInitiatorService.getStandardFlowEntryRoute(), undefined, undefined, replaceRouteInHistory);
				// Otherwise, go back to package details or the standard flow entry route based on flow context
				} else if (!CustomActionService.executeCustomAction('routeToCurrentStep')) {
					if (!StandardFlowInitiatorService.resetToPackageDetailsScreen) {
						$rootScope.routeTo(StandardFlowInitiatorService.getStandardFlowEntryRoute(), undefined, undefined, replaceRouteInHistory);
						StandardFlowInitiatorService.resetStandardFlow();
					} else {
						var pkgId = Package.packageDetails && Package.packageDetails.id;
						if (pkgId) {
							$rootScope.routeTo(Enums.routes.DETAILS + '/' + pkgId, undefined, undefined, replaceRouteInHistory);
						} else {
							$rootScope.routeTo(StandardFlowInitiatorService.getStandardFlowEntryRoute(), undefined, undefined, replaceRouteInHistory);
							StandardFlowInitiatorService.resetStandardFlow();
						}
					}
				}
			}
		};


		/**
		 * Bootstrap the new XFC.Update Package settings to the new movie's settings
		 * @param {Number} currentXFC The current extra flow
		 * @param {Boolean} skipRoute Whether to skip the route
		 * @param {Boolean} replaceRouteInHistory Whether to replace the route in history
		 * @returns {undefined}
		 */
		Package.setupXFC = function(currentXFC, skipRoute, replaceRouteInHistory) {
			var matchedState;
			replaceRouteInHistory = !! replaceRouteInHistory;
			Package.settings = ExtraFlow[Package.packageXFCs[currentXFC].name];
			Package.xfcName = Package.packageXFCs[currentXFC].name;

			// If the settings has a service associated with it, delegate control to it.
			if (Package.settings.service) {

				// This needs to be deprecated in favor of ui-router nested resolves
				//				try {
				//					Package.settings.service.init( Package );
				//				} catch( e ){
				//					// service.init() doesn't exist. Developer error.
				//				}
			} else if (!skipRoute) {
				var xfcObject = ExtraFlow[Package.packageXFCs[currentXFC].name];
				var stateParams = { packageId: Package.packageDetails.id };
				var path = '/' + xfcObject.view + '/' + Package.packageDetails.id;

				// If the XFC uses view Default Args, merge them with the stateParams
				if (validObject(xfcObject.viewDefaultArgs)) {
					angular.extend(stateParams, xfcObject.viewDefaultArgs);
				}

				// If the XFC uses a state name, get the path from the state name
				if (xfcObject.viewIsStateName) {
					path = $state.href(xfcObject.view, stateParams);
				}

				// We need to check if the XFC has a view associated with it.
				matchedState = $urlService.match({ path: path.replace(/\/{2,}/g, '/') });

				// If a valid state was matched
				if (matchedState.rule.type === 'STATE') {
					// Route to the XFC view using the native UI Router methods
					Utilities.goTo(matchedState.rule.state.name, merge({}, matchedState.match || {}, stateParams), replaceRouteInHistory);
				} else {
					// Log that we have an error
					$log.error('No state found for XFC: ' + Package.packageXFCs[currentXFC].name);

					// Exit out of the XFC flow to the default route
					Utilities.goTo('/');
				}
			}
		};

		/**
		 * Returns an array of packages based off a keyword
		 * @public
		 * @param {String} keyword The keyword to search for.
		 * @returns {Object[]} an array of packages
		 */
		Package.getPackagesByKeyword = function(keyword) {
			var packages;

			if (!validString(keyword)) {
				return [];
			}

			packages = Utilities.wrapObjectToArray(checkProp('AppData.GetMerchantPackageList.PS.P', AppData, 'returnValue'), true);

			if (!packages.length) {
				return packages;
			}

			return Package
				.filterPackagesByKeyword(packages, keyword)
				.reduce(function uniquePackages(unique, pkg) {
					var isUnique = !unique.some(function isUnique(u) {
						return u.id === pkg.id;
					});

					if (isUnique) {
						unique.push(pkg);
					}

					return unique;
				}, []);
		};

		/**
		 * Gets packages based on customer types
		 * @param  {Object} customerTypes The customer types
		 * @param  {Array} packageArray The array of packages
		 * @returns {Array} The packages filtered by customer types
		 */
		Package.getPackagesByCustomerTypes = function(customerTypes, packageArray) {
			if (angular.isUndefined(packageArray)) {
				var packageArray = AppData.GetMerchantPackageList.PS.P;
			}
			return packageArray.filter(function(package) {
				for (var i = 0; i < package.CT.length; i++) {
					return !customerTypes.some(function(type) {
						return package.CT[i].id == type.id;
					});
				}
			});
		};

		/**
		 * Gets the associated keyword from the package
		 * @param {Object} obj The package object
		 * @returns {Array} The keywords
		 */
		Package.getAssociatedKeyword = function(obj) {
			var keyword;
			if (typeof (obj.assoc_keywords) != 'undefined') {
				keyword = (obj.assoc_keywords.indexOf(',') > -1) ? obj.assoc_keywords.split(',') : [obj.assoc_keywords];
			} else {
				if (typeof (obj.keyword) != 'undefined') {
					keyword = (obj.keyword.indexOf(',') > -1) ? obj.keyword.split(',') : [obj.keyword];
				}
			}

			return keyword;
		};

		/**
		 * Checks the object pass for the associated keyword or keywords in the object
		 * @param {Object} obj The object to inspect for keyword association
		 * @param {String} keyword The keyword to search for
		 * @returns {*} The package Details, return array or object of the package details
		 */
		Package.getPackageDetails = function(obj, keyword) {
			var packageArray = ((obj).PS || {}).P || [];
			var pkgData = [];
			//checks obj,PS is an array not just an object, coming from the backend
			packageArray = angular.isArray(packageArray) ? packageArray : [packageArray];

			if (packageArray.length == 0) {
				// No details for this package. Something went wrong.
				return;
			}

			// Collect the associated keyword or keywords
			// For every package found with the keyword it will be placed in pkgData array
			for (var i in packageArray) {
				var propValue = Package.getAssociatedKeyword(packageArray[i]);
				for (var k in propValue) {
					if (propValue[ k ].trim().toLowerCase() == keyword.toLowerCase()) {
						var temp = packageArray[i];
						if (typeof pkgData.shop_image_v4 == 'string' && temp.shop_image_v4 != '') {
							temp.image = pkgData.shop_image_v4;
						}

						pkgData.push(setStartingAt(temp))
					}
				}
			}

			//if there is only one package then send only the object, not array
			if (pkgData.length == 1) {
				pkgData = pkgData[0];
			}

			return pkgData;
		};

		/**
		 * Obtain package details for a cart item
		 * @param {Object} item The package item
		 * @returns {Object} The package details object
		 */
		Package.getPackageDetailsForCartItem = function(item) {
			var packageDetails = AppData.GetMerchantPackageList.PS.P.filter(function(p) {
				return angular.isDefined(item.package_id) && Number(item.package_id) === Number(p.id);
			})[0];
			return packageDetails;
		};

		/**
		 * Retrieve the package details from the package list or backend
		 * @public
		 * @param {Number} packageId - the package id to retrieve
		 * @returns {Promise} - A promise that resolves the package details
		 */
		Package.retrievePackageDetailsFromId = function retrievePackageDetailsFromId(packageId) {
			var deferred = $q.defer(),
				packageDetails = Package.getPackageByID(Utilities.getString(packageId));

			// If there is a valid packageDetails object
			if (validObject(packageDetails)) {
				// The package already exists in our package list. Resolve it.
				deferred.resolve(packageDetails);

				// Exit
				return deferred.promise;
			}

			// Show the spinner as we are about to fetch the missing package
			$rootScope.showSpinner();

			// Fetch the missing package
			AppData
				.fetch(Enums.services.GET_MERCHANT_PACKAGE_LIST, false, {
					packages: packageId,
					_no_cache: '1',
					_skip_cache: '1',
					show_details: 1
				})
				.then(function onSuccess(data) {
					// We received the data, hide the spinner
					$rootScope.hideSpinner();

					// If the data is valid and we have a single package
					if (data.status === Enums.status.OK && checkProp('data.PS.P', data, angular.isArray) && data.PS.P.length === 1) {
						// Set the packageDetails object
						packageDetails = Utilities.first(data.PS.P);
						packageDetails.do_not_include_in_pkg_list = 1;

						// Add the package to the master package list
						AppData.GetMerchantPackageList.PS.P.push(packageDetails);

						// Resolve the promise with the packageDetails object
						deferred.resolve(angular.copy(packageDetails));

						// Exit
						return;
					}

					// Otherwise, reject the promise
					deferred.reject();
				})
				.catch(function onError() {
					// Hide the Spinner
					$rootScope.hideSpinner();

					// Request failed, reject the promise
					deferred.reject();
				});

			// Return the deferred promise
			return deferred.promise;
		};

		/**
		 * Fetches and merges package ids missing from the boot cache into
		 * AppData.GetMerchantPackageList.PS.P, batched into a single request. Same
		 * fetch-and-merge shape as retrievePackageDetailsFromId, but for multiple ids
		 * and with no spinner (callers running inside a route resolve must not call
		 * showSpinner/hideSpinner there).
		 * @param {Array} packageIds the package ids to check and, if missing, fetch
		 * @returns {Promise} resolves once any needed fetch has completed; rejects if the fetch fails
		 */
		Package.requestAndMergeMissingPackages = function requestAndMergeMissingPackages(packageIds) {
			var missing = (packageIds || []).filter(function(id) { return !validObject(Package.getPackageByID(id)); });

			if (!missing.length) {
				return $q.resolve();
			}

			return AppData.fetch(Enums.services.GET_MERCHANT_PACKAGE_LIST, false, {
				packages: missing.join(','),
				_no_cache: '1',
				_skip_cache: '1',
				show_details: 1
			}).then(function(data) {
				if (data.status !== Enums.status.OK || !checkProp('data.PS.P', data, angular.isArray)) {
					return;
				}
				data.PS.P.forEach(function(pkg) {
					pkg.do_not_include_in_pkg_list = 1;
					AppData.GetMerchantPackageList.PS.P.push(pkg);
				});
			});
		};

		Package.getOrRequestPackageDetailsForCartItem = function(item) {
			$rootScope.showSpinner();
			var deferred = $q.defer();
			var packageDetails = Package.getPackageDetailsForCartItem(item);
			if (angular.isUndefined(packageDetails)) {
				AppData.fetch
				(
					Enums.services.GET_MERCHANT_PACKAGE_LIST
					, false
					, {
						packages: item.package_id,
						_no_cache: '1',
						_skip_cache: '1',
						show_details: 1
					}
				).then
				(
					function(data) {
						if (data.status == Enums.status.OK && checkProp('data.PS.P', data) && angular.isArray(data.PS.P) &&
							data.PS.P.length === 1) {
							// Update merchantPackageListData in localStorage with new data.
							packageDetails = data.PS.P[0];
							packageDetails.do_not_include_in_pkg_list = 1;
							AppData.GetMerchantPackageList.PS.P.push(angular.copy(packageDetails));
							$rootScope.hideSpinner();
							deferred.resolve(packageDetails);
						} else {
							deferred.reject();
						}
					}
				);
			} else {
				deferred.resolve(packageDetails);
			}

			return deferred.promise;
		};


		Package.requestPackageDetailsForPackageIds = function(ids) {
			$rootScope.showSpinner();
			return AppData.fetch(Enums.services.GET_MERCHANT_PACKAGE_LIST, false, {
				packages: ids,
				_no_cache: '1',
				_skip_cache: '1',
				show_details: 1
			}).then(function(data) {
				$rootScope.hideSpinner();
				if (data.status == Enums.status.OK && checkProp('data.PS.P', data) && angular.isArray(data.PS.P)) {
					return data.PS.P;
				} else {
					return $q.reject();
				}
			}).catch(function() {
				$rootScope.hideSpinner();
				return $q.reject();
			});
		};

		/**
		 * Obtain the packages from our current package list given a promocode
		 * @param promoCode
		 * @returns {Array.<T>}
		 */
		Package.getPackagesForCurrentPromoCode = function(promoCode) {
			return AppData.GetMerchantPackageList.PS.P.filter(function(pkg) {
				return pkg.isPromo && pkg.promo_code.toLowerCase() === promoCode.toLowerCase();
			});
		};

		Package.packageDetailsHasRenewalSwapCharacs = function() {
			return checkProp('Package.packageDetails.CHARACS.PassOptionRenewalPackageId', Package, function(renewalPackageId) {
				return renewalPackageId != Package.packageDetails.id;
			});
		};

		/**
		 * Removes an item from items to be added - ONLY if quantity of that item is greater than 1
		 * @returns {undefined}
		 */
		Package.removeItemsToBeAddedMarkedForDeletion = function() {
			if (!isArray(Package.itemsToBeAdded)) {
				Package.itemsToBeAdded = [];
			}

			Package.itemsToBeAdded = Package.itemsToBeAdded.reduce(function(acc, item) {
				item.CHARACS = item.CHARACS.reduce(function(bcc, charac) {
					if (charac.hasOwnProperty('markForDelete')) {
						item.qty ? item.qty-- : null;
					} else {
						bcc.push(charac);
					}

					return bcc;
				}, []);

				if (item.qty) {
					acc.push(item);
				}

				return acc;
			}, [])
		};

		Package.markItemToBeAddedForDeletion = function(itemIndex, characsIndex) {
			if (angular.isDefined(itemIndex) && angular.isDefined(characsIndex) &&
				angular.isDefined(Package.itemsToBeAdded[itemIndex]) && angular.isDefined(Package.itemsToBeAdded[itemIndex].CHARACS)) {
				if (angular.isDefined(Package.itemsToBeAdded[itemIndex].CHARACS[characsIndex])) {
					Package.itemsToBeAdded[itemIndex].CHARACS[characsIndex].markForDelete = true;
				}
			}
		};

		// ##############################################################
		// UPSELL RELATED FUNCTIONS
		// ##############################################################

		/**
		 * Returns an object with custom mappings, if one exists for the package with regards to upsells.
		 *
		 * @returns {Object} custom mapping of non-matching customerTypes
		 */
		Package.getUpsellCustomMappings = function() {
			//	get the backend configurations for custom mapping of non-matching customerTypes.
			var upsellCustomMappings = AppData.GetApplicationConsolidated.SETTINGS.upsellCustomerTypeCustomMappings || {};
			try {
				upsellCustomMappings = JSON.parse(upsellCustomMappings);
			} catch (e) {
				// return an empty object on an error.
				return {};
			}

			// find the matching custom mapping, and return the object.
			for (var k in upsellCustomMappings) {
				if (k == Package.packageDetails.id) {
					return upsellCustomMappings[k];
				}
			}
			// otherwise, return an empty object.
			return {};
		};

		/**
		 * Returns an array of mappings for Upsells in the case of many-to-many.
		 * There are two actions performed. Mapping on matching customerTypes, and a mapping for
		 * non-matching customerTypes that have been specified at the database level.
		 * This code is here, because it is called from PackageDetailCtrl and the Upsell service.
		 *
		 * @returns {Array} mapping of original customer_type_ids to upsell customer_type_ids
		 */
		Package.getUpsellManyToManyMappings = function() {
			// get the custom mapping for the current package, if one exists.
			var upsellCustomMappings = Package.getUpsellCustomMappings();

			// storage of our results.
			var mappings = [];

			// get a listing of ids, save them to two seperate arrays.
			var opIds = Package.getOriginalPackageCustomerTypeIds();

			// get a listing of ids, save them to two seperate arrays.
			var upIds = Package.getUpsellPackageCustomerTypeIds();

			for (var i in opIds) {
				// Step 1. Check for matching customerTypes.
				for (var j in upIds) {
					if (opIds[i] == upIds[j]) {
						if (Package.customerTypes[i].qty > 0) {
							// we only want the position of the customerTypes, not the real id for the types.
							mappings.push([i, j]);
						}
					} else if (hasRateUpsellCharac(opIds[i], upIds[j])) {
						mappings.push([i, j]);
					}
				}

				// Step 2. Check for non-matching customerTypes defined in the backend.
				if (upsellCustomMappings && (upsellCustomMappings[ opIds[i] ] || false) && Package.getCustomerTypeQtyById(opIds[i])) {
					// find the corresponding upsell customerType. if found, add the mapping.
					for (var j in upIds) {
						if (upsellCustomMappings[ opIds[i] ] == upIds[j]) {
							mappings.push([i, j]);
						}
					}
				}
			}

			return mappings;
		};

		/**
		 * hasRateUpsellCharac - check to see if charac rateUpsell_XXX where XXX is customer type number exists on Package
		 * If so, then check if the original customer type id matches the XXX on the end of the charac name
		 * If the rateUpsell_22 matches the opId (22), then we should upsell whatever the value of the rateUpsell_ charac is
		 * to this customer type if the value matches the upsell customer type id passed into this function.
		 * @param {String} opId - the original package customer type id
		 * @param {String} upId - the upsell package customer type id
		 * @returns {Boolean} - true if rateUpsell_ charac exists and matches the customer type ids
		 */
		function hasRateUpsellCharac(opId, upId) {
			var rateUpsellCharacName = 'rateUpsell_';
			var includeInMapping = false;
			if (Package.packageDetails && Package.packageDetails.CHARACS) {
				var characs = Package.packageDetails.CHARACS;
				for (var key in characs) {
					if (key.indexOf(rateUpsellCharacName) >-1) {
						var matchKeyId = key.substring(rateUpsellCharacName.length);
						var matchOpId = characs[key];
						if (matchKeyId == opId && matchOpId == upId) {
							includeInMapping = true;
						}
					}
				}
			}
			return includeInMapping;
		}

		/**
		 *	search through Package.customerTypes for the target type by id, and return the quantity.
		 *	@param {Number} id the customerType id.
		 *	@returns {Number} the amount of units selected for the desired customerType.
		 */
		Package.getCustomerTypeQtyById = function(id) {
			if (Package.customerTypes.length > 0) {
				for (var i in Package.customerTypes) {
					if (id == Package.customerTypes[i].customer_type) {
						// return the amount that's currently set.
						return Package.customerTypes[i].qty;
					}
				}
			}
			// otherwise, return 0.
			return 0;
		};

		/**
		 * Returns an array of ids of customer types from the original package.
		 * @returns {Array}
		 */
		Package.getOriginalPackageCustomerTypeIds = function() {
			var opIds = [];
			for (var i in Package.customerTypes) {
				opIds.push(Package.customerTypes[i].customer_type);
			}
			return opIds;
		};

		/**
		 * Returns an array of ids of customer types from the upsell package.
		 * @returns {Array}
		 */
		Package.getUpsellPackageCustomerTypeIds = function() {
			var upIds = [];
			for (var i in Package.upsellPackage.customerTypes) {
				upIds.push(Package.upsellPackage.customerTypes[i].customer_type);
			}
			return upIds;
		};

		Package.hasUpsellPackage = function() {
			return !!(Object.getOwnPropertyNames(Package.upsellPackage.packageDetails).length);
		};

		Package.resetUpsellSkip = function() {
			Package.upsellPackage.skip = false;
		};

		/**
		 *	Set the upsellPackage information when the PackageDetailsCtrl.js
		 *	@returns {Boolean}
		 */
		Package.setUpsellPackageDetails = function() {
			// reset the upsellSkip
			resetUpsellPackageObject();

			var upsellKeyword = Package.getUpsellKeywordForPackage(Package.packageDetails);

			if (typeof upsellKeyword != 'undefined' &&
				!CustomActionService.executeCustomAction(CustomActionService.ACTIONS_ENUMS.SHOULD_SKIP_UPSELL_KEYWORD_CHECK_FOR_PACKAGE, [upsellKeyword])) {

				AppData.GetMerchantPackageList.PS.P =
					(angular.isArray(AppData.GetMerchantPackageList.PS.P))
						? AppData.GetMerchantPackageList.PS.P
						: [AppData.GetMerchantPackageList.PS.P];
				var upsellPackage = Package.getUpsellForPackage(Package.packageDetails);

				if (!angular.isObject(upsellPackage)) {
					return false;
				}

				Package.upsellPackage.packageDetails = Package.updatePackageRetailAmount(upsellPackage);
				Package.upsellPackage.customerTypes = Package.setCustomerType(upsellPackage);

				if (Package.upsellPackage.packageDetails.CHARACS) {
					// Is it an advance ticket?
					if (Package.upsellPackage.packageDetails.CHARACS.valid_from) {
						Package.upsellPackage.isAdvancedTicket = true;
						Package.upsellPackage.advancedTicketDate = Package.upsellPackage.packageDetails.CHARACS.valid_from;
					}
					// Is this a membership package?
					// Primarily used for evaluating whether to display the "per month" text next to rate type info
					if (Utilities.childDefined(Package.upsellPackage.packageDetails, 'CHARACS.package_type') && Package.upsellPackage.packageDetails.CHARACS.package_type.toLowerCase() === 'membership') {
						Package.upsellPackage.packageDetails.isMembership = true;
					}
				}

				return true;
			} else {
				return false;
			}
		};

		/**
		 * Gets the appropriate upsell keyword for a package, considering parent/child relationships
		 * For snap-calendar, if a child package has its own upsell keyword that differs from parent, use child's
		 * @param {Object} packageDetails The package to check
		 * @returns {String|undefined} The upsell keyword to use
		 */
		Package.getUpsellKeywordForPackage = function(packageDetails) {
			if (!packageDetails) {
				return;
			}

			// For child packages, always use their own upsell keyword if they have one
			// This allows child packages to have different upsells than their parents
			if (packageDetails.upsell_keyword) {
				return packageDetails.upsell_keyword;
			}

			// If child doesn't have upsell keyword, check if parent does
			if (checkProp('packageDetails.CHARACS.parentPackageID', packageDetails)) {
				var parentPackage = Package.getPackageByID(packageDetails.CHARACS.parentPackageID);

				if (parentPackage && parentPackage.upsell_keyword) {
					return parentPackage.upsell_keyword;
				}
			}

			return;
		};

		/**
		 * Finds and returns an Upsell package if one is set for the provided package
		 * @param {Object} packageDetails Package to check for an Upsell on
		 * @returns {Object} an Upsell package if one is set for the provided package
		 */
		Package.getUpsellForPackage = function(packageDetails) {
			var upsellKeyword = Package.getUpsellKeywordForPackage(packageDetails);
			var i = 0;
			var packageListLength = AppData.GetMerchantPackageList.PS.P.length;
			var currentPackage;
			var upsellFound;

			for (; i < packageListLength; i++) {
				var currentPackage = AppData.GetMerchantPackageList.PS.P[i];
				if (!angular.isString(currentPackage.keyword)) {
					continue;
				}
				if (hasUpsellKeywordInList(currentPackage.keyword, upsellKeyword) && shouldChooseSpecificPackageForUpsell(currentPackage.id)) {
					upsellFound = currentPackage;
					break;
				}
			}

			return upsellFound;
		};

		/**
		 * Display the modal with the upsell package information.
		 * @param {Object} upsellPackageDetails .....
		 * @returns {undefined}
		 */
		Package.displayUpsellPackage = function(priceDifference) {
			// Hack for newer versions of iOS not rendering the Upsell
			// Modal correctly. This forces the browser to redraw the
			// page elements by scrolling to the top of the page.
			Utilities.scrollPosition();

			var upsellPackageDetails = Package.upsellPackage.packageDetails;

			var image = (typeof upsellPackageDetails.shop_image_v4 == 'string' && upsellPackageDetails.shop_image_v4 !== '') ?
				$rootScope.getAssetUrl(upsellPackageDetails.shop_image_v4) : null;


			priceDifference = $filter('currencyFormatter')(priceDifference);

			if (checkProp('packageDetails.CHARACS.package_type', upsellPackageDetails) && upsellPackageDetails.CHARACS.package_type.toLowerCase() === 'membership') {
				priceDifference += ' ' + Language.getLocale('PackageList', 'perMonthLabel');
			}

			var findStr = [];
			var replStr = [];

			findStr.push('@@upsellPackageName');
			replStr.push(Package.upsellPackage.packageDetails.name);

			findStr.push('@@difference');
			replStr.push(priceDifference);

			findStr.push('@@packageName');
			replStr.push(Package.packageDetails.name);

			var modalTitle = "";
			//If the upsell package charac has been set, use that, otherwise default to the title
			if (Utilities.childDefined(upsellPackageDetails, 'CHARACS.upsell_package_title')) {
				modalTitle = Language.replaceAllMultiple(findStr, replStr, upsellPackageDetails.CHARACS.upsell_package_title);
			} else {
				modalTitle = Language.replaceAllMultiple(findStr, replStr, Language.getLocale('UpSells', 'modalTitle'));
			}

			var modalBody = Language.replaceAllMultiple(findStr, replStr, Language.getLocale('UpSells', 'modalBody'));

			var desc = '<p class="blue"><b>' + modalBody + '</b></p>';
			//If the upsell package charac has been set, use that, otherwise default to the description
			if (Utilities.childDefined(upsellPackageDetails, 'CHARACS.upsell_package_desc')) {
				desc += '<p>' + upsellPackageDetails.CHARACS.upsell_package_desc; + '</p>';
			} else {
				desc += '<p>' + upsellPackageDetails.desc + '</p>';
			}

			// Store selected package info in wizard.
			CustomActionService.executeCustomAction('setSelectedPackage', Package.packageDetails);

			var enableUpsellWizard = false;
			if (Utilities.childDefined(upsellPackageDetails, 'CHARACS.upsell_wizard')) {
				enableUpsellWizard = Utilities.getBoolean(upsellPackageDetails.CHARACS.upsell_wizard);

				if (enableUpsellWizard) {
					if (!CustomActionService.executeCustomAction('routeToUpsell', Enums.routes.UPSELL_RECOMMENDER_WIZARD)) {
						Package.preUpsellPkg = Package.packageDetails;
						$rootScope.routeTo(Enums.routes.UPSELL_WIZARD + '/' + Package.packageDetails.id);
					}
				}
			}

			// Do default upsell
			if (!enableUpsellWizard) {
				Modal.displayModal({
					category: 'Upgrade',
					action: 'View',
					label: 'Upgrade Options',
					title: modalTitle,
					description: desc,
					desktop: true,
					image: image,
					showCloseButton: false,
					buttonFlags: [Enums.buttonFlags.NO_THANKS, Enums.buttonFlags.LEARN],
					callback: function(detail) {
						if (detail == Enums.buttonFlags.NO_THANKS) {
							Package.upsellPackage.skip = true;
						}
						if (detail == Enums.buttonFlags.LEARN) {
							// assume modal closes itself.

							// display the upsell version.
							if (!CustomActionService.executeCustomAction('routeToUpsell', Enums.routes.UPGRADE_RECOMMENDER_WIZARD)) {
								Package.preUpsellPkg = Package.packageDetails;
								var upsellRoute = Enums.routes.UPSELL + '/' + Package.packageDetails.id;

								if (checkProp('preupsellPkg.CHARACS.alt_upsell_route_state', Package.preUpsellPkg)) {
									upsellRoute = Package.preUpsellPkg.CHARACS.alt_upsell_route_state;
									if (checkProp('preupsellPkg.CHARACS.alt_upsell_route_params', Package.preUpsellPkg)) {
										Package.preUpsellPkg.CHARACS.alt_upsell_route_params.split(',').forEach(function(param) {
											upsellRoute += '/' + param;
										});
									}
									CustomActionService.registerCustomAction(CustomActionService.ACTIONS_ENUMS.ALT_MODULE_ON_CANCEL_UPSELL,
										Upsell.cancelUpsell, [false, Package.preUpsellPkg.id]);
								}

								$rootScope.routeTo(upsellRoute);
							}
						}
					}
				});
			}
		};

		/**
		 *
		 * @param packageId
		 * @returns {Boolean}
		 */
		function shouldChooseSpecificPackageForUpsell(packageId) {
			//check for an upsell package id as this is a way to drill down into a specific package if multiple exist under one keyword
			//default to true
			var shouldChoosePackage = true;
			if (checkProp('Package.packageDetails.CHARACS.upsell_package_id', Package)) {
				shouldChoosePackage = (packageId === Package.packageDetails.CHARACS.upsell_package_id);
			}

			return shouldChoosePackage;
		}

		/**
		 * Determines if the keyword specified is in the list of upsell keywords
		 * @param {Array} upsellKeywordList The list of keywords
		 * @param {String} keyword The keyword to search for
		 * @returns {Boolean} Whether the keyword is in the list
		 */
		function hasUpsellKeywordInList(upsellKeywordList, keyword) {
			var list = angular.isDefined(upsellKeywordList) ? upsellKeywordList.split(',') : [];
			return list.indexOf(keyword) > -1;
		}

		/**
		 * Finds any resources held within a cart item.
		 * Resources are comma-separated lists that are identical on each cart item.
		 * Obtaining the first matching criteria is sufficient.
		 * @param {Object} item The cart item
		 * @returns {Object} The resource information or undefined if none
		 */
		Package.findHeldResources = function(item) {
			// We only need one charac item because each charac has the same resource ids on them (they are not separated)
			if (angular.isDefined(item) && angular.isDefined(item.CHARACS) && angular.isArray(item.CHARACS) && item.CHARACS.length > 0) {
				var characs = item.CHARACS[0];
				if (angular.isDefined(characs.resource_id) && angular.isDefined(characs.extra_movie) && characs.extra_movie.indexOf('cabana') > -1) {
					return {
						resource_id: characs.resource_id,
						event_id: characs.event_id,
						start_date: characs.start_date,
						start_time: characs.start_time
					};
				}
			}
			return undefined;
		};

		/**
		 * Releases the event resource
		 * @param {Object} resourceInfo The resource information object
		 * @returns {undefined}
		 */
		Package.releaseEventResources = function(resourceInfo) {
			if (angular.isDefined(resourceInfo)) {
				AppData.fetch(
					Enums.services.RELEASE_EVENT_RESOURCE
					, false
					, resourceInfo
				).then(function(data) {
					if (data.status == Enums.status.OK) {

					} else {
						$log.error('Unable to release event resource for ' + resourceInfo.resource_id);
					}
				}, function() {
					$log.error('Error releasing event resources');
				});
			}
		};

		/**
		 * Updates the package retail amount
		 * @param {Object} obj The package object to update
		 * @returns {undefined}
		 */
		Package.updatePackageRetailAmount = function(obj) {
			if (!obj || !obj.CT) {
				return;
			}

			var cusType = (obj).CT ? angular.isArray(obj.CT) ? obj.CT : [obj.CT] : [];
			var handler = [];

			for (var i in cusType) {
				var rate = Utilities.getTotalPrice(cusType[i]);

				handler.push(rate);
			}

			// Get the last value.
			handler.sort(function(a, b) {
				return a - b;
			});

			if (cusType.length > 1) {
				/***
				 * TODO: bad variable name conventions
				 * We are using two variables for the same data, because we weren't consistent within naming convention,
				 * According to docs, lowelcaseCamel casing is the right format, well need to investigate the other variable
				 */

				obj.startingAt = handler[0];
				// Set starting_at whenever there are multiple customer types, regardless of price differences
				// This ensures consistent display of "Prices From" locale for packages with multiple CTs
				obj.starting_at = handler[0];
				obj.retail_amount = handler[0];
			} else if (cusType.length == 1 && handler.length > 0) {
				obj.retail_amount = handler[0];
			}
			return obj;
		};

		/**
		 * Sets customer type object data and returns it as an array
		 * Create the $scope.setCustomerType used in PackageDetailsCtrl, this will get the packageData{object}
		 * check if object[CT] exist and loop through the array.
		 * If there is more than one rateType it will set the minimum to 0
		 * @param {Object} packageData The package data object
		 * @param {Array} presetCTData The preset customer type data
		 * @returns {Array} Array of customer type objects
		 */
		Package.setCustomerType = function(packageData, presetCTData) {
			var customerTypes = [];

			if (!packageData || !packageData.CT) {
				return customerTypes;
			}

			packageData.CT = (angular.isArray(packageData.CT)) ? packageData.CT : [packageData.CT];

			var paymentPlan = '';
			var paymentPlanAmount = '';
			var numberOfPayments = '';
			var minRetailAmount = '';

			if (packageData.payment_plan) {
				paymentPlan = packageData.payment_plan;
			}

			if (packageData.payment_plan_amount) {
				paymentPlanAmount = packageData.payment_plan_amount;
			}

			if (packageData.number_of_payments) {
				numberOfPayments = packageData.number_of_payments;
			}

			if (packageData.min_retail_amount) {
				minRetailAmount = packageData.min_retail_amount;
			}

			// Iterate through all CTs in this package and store references to
			// relevant information in $scope.customerTypes.
			// If there is more than one rateType it will set the min to 0
			for (var i in packageData.CT) {
				var hasPresetCTCharacs = angular.isDefined(presetCTData) && angular.isArray(presetCTData) && presetCTData.length === packageData.CT.length,
					presetCTCharacs = (hasPresetCTCharacs && presetCTData[i].CHARACS.length) ? presetCTData[i].CHARACS[0] : [];
				var itemRef =
					{
						package_id: packageData.id,
						max_quantity: getThresholdQtyForPkgGivenCT(packageData.CT[i], packageData, 'max_quantity'),
						min_quantity: getThresholdQtyForPkgGivenCT(packageData.CT[i], packageData, 'min_quantity'),
						extra_movie: packageData.extra_movie,
						customer_type: packageData.CT[i].id,
						cusTypeName: packageData.CT[i].name,
						cusTypeNameMPInfo: getCTNameMPInfo(packageData.CT[i], packageData.CHARACS),
						paymentPlan: paymentPlan,
						displayOrder: packageData.CT[i].display_order,
						paymentPlanPrice: '',
						paymentPlanAmount: paymentPlanAmount,
						customerTypePaymentPlanAmount: (packageData.CT[i].hasOwnProperty("payment_plan_amount")) ? packageData.CT[i].payment_plan_amount : '',
						numberOfPayments: numberOfPayments,
						minRetailAmount: minRetailAmount,
						cusTypeRetail: Utilities.getTotalPrice(packageData.CT[i]),
						qty: 0,
						promo_code: (typeof packageData.promo_code != 'undefined') ? packageData.promo_code : '',
						cart_limit_override: packageData.cart_limit_override,
						membershipMessage: getMembershipMessage(packageData, packageData.CT[i]),
						CHARACS:
							[
								{
									shop_rate_name: packageData.CT[i].name,
									shop_rate_id: '',
									shop_google_sales_class_title: '',
									extra_movie: packageData.extra_movie,
								}
							],
						client_app_gate_price: packageData.CT[i].client_app_gate_price || {},
						group_id: packageData.CT[i].group_id,
						gate_price: angular.isDefined(packageData.CT[i].gate_price) ? packageData.CT[i].gate_price : 0,
						source_package_id: packageData.CT[i].source_package_id,
						id: packageData.CT[i].id
					};

				// Show the gate price if it is greater than the retail price
				itemRef.showGatePrice = parseFloat(itemRef.gate_price) > itemRef.cusTypeRetail;

				// If preset customer type data is passed in that the characs in the item ref are the union of the two
				// to ensure no data is missing
				if (hasPresetCTCharacs) {
					// Get all the keys from the object to set unique properties on item ref
					Object.keys(presetCTCharacs).forEach(function setUniqueCharac(key) {
						if (presetCTCharacs.hasOwnProperty(key) && !itemRef.CHARACS[0].hasOwnProperty(key)) {
							itemRef.CHARACS[0][key] = presetCTCharacs[key];
						}
					});
				}

				if (Package.isAdvancedTicket) {
					itemRef.CHARACS[0].valid_from = Package.advanceTicketDate;
				}

				// If presetCTData is defined and has Advanced Purchase Price, set those on the customer type.
				if (presetCTData && presetCTData.length) {
					for (var j in presetCTData) {
						var item = presetCTData[j];
						if (checkProp('item.customer_type', item, 'returnValue') == packageData.CT[i].id) {
							// Handle Advanced Purchase Pricing
							if (checkProp('packageData.CT[i].APP', packageData)) {
								if (checkProp('item.discountedRetailAmount', item)) {
									packageData.CT[i].discountedRetailAmount = item.discountedRetailAmount;
									packageData.CT[i].discountedTaxAmount = item.discountedTaxAmount;
									itemRef.cusTypeRetail = Utilities.getTotalPrice(item, [item.discountedRetailAmount, item.discountedTaxAmount]);
								}
							}
							// Handle Dynamic Pricing with fee-inclusive/VAT pricing
							// Only use cusTypeRetail from presetCTData if there's NO discountedRetailAmount
							// (meaning it's from calendar dynamic pricing, not leftover APP pricing)
							else if (checkProp('item.cusTypeRetail', item) && !checkProp('item.discountedRetailAmount', item)) {
								itemRef.cusTypeRetail = item.cusTypeRetail;
							}
						}
					}
				}

				customerTypes.push(itemRef);
			}

			// Process allowedRates if it exists. This is passed forward from the calpricing module
			// to restrict the rates that available for the day that was selected.

			if (angular.isArray(presetCTData) && presetCTData.length > 0) {
				if (presetCTData[0].package_id != packageData.id) {
					//in very small cases we can get here with the intention of having choices from an alt module
					//if Package.itemsToBeAdded was passed in as the presetCTData we just need to filter down to the relevant package
					//prior to this update it just used to set Package.itemstoBeAdded to a blank array
					Package.itemsToBeAdded = Package.itemsToBeAdded.length ? Package.itemsToBeAdded.filter(
						function(p) {
							return p.package_id === packageData.id;
						}
					) : [];
				} else if (angular.isDefined(presetCTData.allowedRates) && packageData.type==="L") {
					customerTypes = customerTypes.filter(function(e) {
						return (presetCTData.allowedRates.indexOf(Number(e.customer_type))!=-1);
					});
				}
			}

			// If there is only one rate type, set the qty to min qty — only when the merchant has
			// opted in via prepopulate_customer_type_qty_with_min (PEC-24837).
			if (customerTypes.length == 1 && checkProp('packageData.CHARACS', packageData) && getBoolean(packageData.CHARACS.prepopulate_customer_type_qty_with_min)) {
				customerTypes[ 0 ].qty = Number(customerTypes[ 0 ].min_quantity);
			}

			return customerTypes;
		};

		/**
		 * Get the Threshold Qty (min_quantity or max_quantity) for the given CT
		 * @param {Object} ct The customer type object
		 * @param {Object} pkgObject The package object
		 * @param {Number} minMaxQtyProperty The minimum or maximum quantity property
		 * @returns {Number} The threshold quantity
		 */
		function getThresholdQtyForPkgGivenCT(ct, pkgObject, minMaxQtyProperty) {
			var thresholdQty = 0,
				ctQty = (angular.isDefined(ct) && angular.isDefined(ct[minMaxQtyProperty])) ? Number(ct[minMaxQtyProperty]) : -1,
				pkgQty = Number(pkgObject[minMaxQtyProperty]);

			//if we have a customer type quantity and there's a difference between the ct quantity and package,
			// we use the ct quantity to overrule the pkg qty threshold
			if (ctQty > -1 && ctQty !== pkgQty) {
				thresholdQty = ctQty;
			} else {
				thresholdQty = ((minMaxQtyProperty === 'min_quantity' && pkgObject.CT.length > 1) ? 0 : pkgQty);
			}

			return thresholdQty;
		}


		/**
		 * Removes disabled rates from the customer types object that is used to present the available rates on
		 * the package details view.
		 * This currently exists for alternateModules that will route to the package details to collect rate/quantity
		 * @param {Array} customerTypes List of customer types
		 * @returns {Array} List of customer types with disabled rates removed
		 */
		Package.removeDisabledRatesFromCustomerTypes = function(customerTypes) {
			var ratesDisabledFromSelection = Package.itemsToBeAdded.filter(function(item) {
				return Utilities.getBoolean(item.disableRateFromSelection);
			});
			if (ratesDisabledFromSelection.length > 0) {
				customerTypes = customerTypes.filter(function(e) {
					return ratesDisabledFromSelection.filter(function(rate) {
						return rate.customer_type == e.customer_type;
					}).length == 0;
				});
			}
			return customerTypes;
		};

		/**
		 * Configure customerTypeGroups if they exist on the itemsToBeAdded (precompiled items list)
		 * Currently this functionality exists within alternateModules to influence how rate types should be shown on
		 * the PackageDetails view
		 * @param {Array} customerTypesList The list of customer types
		 */
		Package.setUpCustomerTypeGroups = function(customerTypesList) {
			Package.customerTypeGroups = [];
			if (UtilsValidation.validArray(Package.itemsToBeAdded)) {
				Package.itemsToBeAdded.forEach(function(item) {
					var matchingCustomerType = customerTypesList.filter(function(type) {
						return type.customer_type === item.customer_type;
					})[0];
					if (angular.isDefined(item.customerTypeGroup) && angular.isDefined(matchingCustomerType)) {
						var getCustomerTypeGroup = Package.customerTypeGroups.filter(function(group) {
							return group.customerTypeGroup == item.customerTypeGroup;
						})[0];
						if (angular.isUndefined(getCustomerTypeGroup)) {
							Package.customerTypeGroups.push({
								customerTypeGroup: item.customerTypeGroup,
								customerTypeGroupMaxQty: item.customerTypeGroupMaxQty
							});
						}
						matchingCustomerType.customerTypeGroup = item.customerTypeGroup;
						matchingCustomerType.customerTypeGroupMaxQty = item.customerTypeGroupMaxQty
					}
				});
			} else {
				appendConfiguredCustomerTypeGroupInfo(customerTypesList);
			}
		};

		/**
		 * Attempts to append configured customer type group information to the current customer types array
		 * @param {Array} customerTypesList The list of customer types
		 * @returns {undefined}
		 */
		function appendConfiguredCustomerTypeGroupInfo(customerTypesList) {
			if (Package.configuredPackageDetailsCTGroups.length || JSONValidator.validate('package_details_customer_type_groups', AppData.settings.package_details_customer_type_groups)) {
				if (!Package.configuredPackageDetailsCTGroups.length) {
					Package.configuredPackageDetailsCTGroups = JSON.parse(AppData.settings.package_details_customer_type_groups);
				}
				customerTypesList.forEach(function(ct) {
					if (angular.isDefined(ct.group_id)) {
						var matchingGroup = Package.configuredPackageDetailsCTGroups.filter(function(configuredCtGroup) {
							return configuredCtGroup.group_id === ct.group_id;
						})[0];
						if (angular.isDefined(matchingGroup)) {
							ct.customerTypeGroup = matchingGroup.group_name;
							var savedCustomerTypeGroup = Package.customerTypeGroups.filter(function(group) {
								return group.customerTypeGroup == ct.customerTypeGroup;
							})[0];
							if (angular.isUndefined(savedCustomerTypeGroup)) {
								// TODO perhaps in the future we can execute a custom action to grap the max qty but for now, this is being used by cultural clients
								// for member benefits and we do not have the notion if we end up in this block during adding an item outside of the member benefits portal
								Package.customerTypeGroups.push({
									customerTypeGroup: ct.customerTypeGroup,
									customerTypeGroupMaxQty: ct.customerTypeGroupMaxQty
								});
							}
						}
					}
				});
			}
		}

		/**
		 * Appends additional properties (currently listed in the Package.addlPropsToAppendToCustomerTypesFromItemsAdded
		 * to the CustomerTypes list that is used for display in PackageDetails
		 * @param {Array} customerTypesList The list of customer types
		 * @returns {undefined}
		 */
		Package.appendOverrideCustomerTypeMaxQuantity = function(customerTypesList) {
			Package.itemsToBeAdded.forEach(function(item) {
				var matchingCustomerType = customerTypesList.filter(function(type) {
					return type.customer_type === item.customer_type;
				})[0];
				if (angular.isDefined(matchingCustomerType) && angular.isDefined(item.overrideCustomerTypeMaxQty)) {
					matchingCustomerType.overrideCustomerTypeMaxQty = item.overrideCustomerTypeMaxQty;
					matchingCustomerType.displayOverrideCustomerTypeMaxQtyInlineOnCT = Utilities.getBoolean(item.displayOverrideCustomerTypeMaxQtyInlineOnCT);
				}
			});
		};

		/**
		 * Appends additional properties (currently listed in the Package.addlPropsToAppendToCustomerTypesFromItemsAdded
		 * to the CustomerTypes list that is used for display in PackageDetails
		 * @param {Object} packageDetails The package details object
		 * @param {Object} CT The customer types object
		 * @returns {undefined}
		 */
		function getMembershipMessage(packageDetails, CT) {
			var upfrontMessage = Package.getUpfrontMembershipMessage(packageDetails, CT);
			if (upfrontMessage) {
				return upfrontMessage;
			}

			var memOnPkgLevel = Utilities.childDefined(packageDetails, 'payment_plan') && packageDetails.payment_plan.toLowerCase() === 'mem';
			var memOnPkgCHARACLevel = Utilities.childDefined(packageDetails, 'CHARACS.package_type') && packageDetails.CHARACS.package_type.toLowerCase() === 'membership';

			if (!(memOnPkgLevel || memOnPkgCHARACLevel)) {
				return null;
			}

			var message = Language.PackageList.membershipLblDetails || '@@monthlyAmount per @@numMonths, <br>(@@minimumTerm month minimum)';
			var monthlyPrice = null;

			Language.FormLabels.month = Language.FormLabels.month || 'month';
			Language.FormLabels.months = Language.FormLabels.months || 'months';

			// If use_vat is on, then get price with tax and fee included, Utilities.getTotalPrice doesn't calculate vat
			// price for package detail so if useRate is false, then default it to packageDetails.min_retail_amount.
			monthlyPrice = Utilities.getTotalPrice(CT);
			//Override the membership message if membership_type Characs exists
			if (Utilities.childDefined(packageDetails, 'CHARACS.membership_type')) {
				var messageTarget = 'membershipMessage_' + packageDetails.CHARACS.membership_type;
				message = (Language.PackageList[messageTarget] || '')
					.split('@@amount')
					.join($filter('currencyFormatter')(monthlyPrice));
			} else {
				message = message
					.split('@@monthlyAmount')
					.join($filter('currencyFormatter')(monthlyPrice), ' ');

				var payments = +packageDetails.months_between_payments;
				message = message
					.split('@@numMonths')
					.join(Language.FormLabels.month, ' ');

				message = message
					.split('@@minimumTerm')
					.join(packageDetails.required_num_payments || ' ', ' ');
			}


			return message;
		}

		/**
		 * Up-front and monthly rates of an Upfront Membership customer type, read from the schedule 310 SP lines
		 * (first = up-front, last = monthly). Returns null when the package is not flagged, the lines are missing,
		 * or the first and last amounts match (no prepaid schedule).
		 * @param {Object} packageDetails The package details object
		 * @param {Object} CT The customer type object
		 * @returns {{upfront: Number, monthly: Number, resumeIndex: Number}|null} The rates
		 */
		Package.getUpfrontMembershipRates = function(packageDetails, CT) {
			if (!getBoolean(checkProp('packageDetails.CHARACS.is_upfront_membership', packageDetails, 'returnValue'))) {
				return null;
			}

			var lines = Utilities.toArray(checkProp('CT.PAYMENT_SCHEDULE.SP', CT, 'returnValue'));
			if (!CT || lines.length < 2) {
				return null;
			}

			var upfrontLine = lines[0],
				monthlyLine = lines[lines.length - 1],
				rates = {
					upfront: Utilities.getTotalPrice(CT, [upfrontLine.retail_amount, upfrontLine.tax_amount]),
					monthly: Utilities.getTotalPrice(CT, [monthlyLine.retail_amount, monthlyLine.tax_amount]),
					resumeIndex: Number(monthlyLine.payment_index) || lines.length
				};

			return rates.upfront === rates.monthly ? null : rates;
		};

		/**
		 * Up-front and monthly message for an Upfront Membership customer type
		 * @param {Object} packageDetails The package details object
		 * @param {Object} CT The customer type object
		 * @returns {String|null} The message with @@upfrontAmount, @@monthlyAmount, @@prepaidMonths and @@resumeMonth replaced
		 */
		Package.getUpfrontMembershipMessage = function(packageDetails, CT) {
			var rates = Package.getUpfrontMembershipRates(packageDetails, CT);

			if (!rates) {
				return null;
			}

			return (Language.PackageList.upfrontMembershipLbl || '@@upfrontAmount today (covers @@prepaidMonths months)<br> then @@monthlyAmount per month')
				.split('@@upfrontAmount').join($filter('currencyFormatter')(rates.upfront))
				.split('@@monthlyAmount').join($filter('currencyFormatter')(rates.monthly))
				.split('@@prepaidMonths').join(rates.resumeIndex - 1)
				.split('@@resumeMonth').join(rates.resumeIndex);
		};

		/**
		 * Looks up the package and customer type of a cart item in GetMerchantPackageList
		 * @param {Object} item The cart item
		 * @returns {{pkg: Object, CT: Object}|null} The package and customer type, or null when either is not found
		 */
		function getPackageAndCTForCartItem(item) {
			var packageId = checkProp('item.package.id', item, 'returnValue'),
				customerId = checkProp('item.customer.id', item, 'returnValue'),
				pkg = packageId ? Package.getPackageByID(packageId) : null,
				CT = validArray(checkProp('pkg.CT', pkg, 'returnValue')) ? pkg.CT.filter(function(customerType) {
					return String(customerType.id) === String(customerId);
				})[0] : null;

			return CT ? {pkg: pkg, CT: CT} : null;
		}

		/**
		 * Up-front and monthly rates for a cart item, built from the item's package and customer type in GetMerchantPackageList
		 * @param {Object} item The cart item
		 * @returns {{upfront: Number, monthly: Number, resumeIndex: Number}|null} The rates, or null when unavailable
		 */
		Package.getUpfrontMembershipRatesForCartItem = function(item) {
			var found = getPackageAndCTForCartItem(item);

			return found ? Package.getUpfrontMembershipRates(found.pkg, found.CT) : null;
		};

		/**
		 * Up-front and monthly message for a cart item
		 * @param {Object} item The cart item
		 * @returns {String|null} The message, or null when the package, customer type or SP lines are not available
		 */
		Package.getUpfrontMembershipMessageForCartItem = function(item) {
			var found = getPackageAndCTForCartItem(item);

			return found ? Package.getUpfrontMembershipMessage(found.pkg, found.CT) : null;
		};

		Package.itemsToBeAddedForCurrentPackage = function(includeComps) {
			if (!isArray(Package.itemsToBeAdded) || Package.packageDetails===undefined) {
				return [];
			}

			return Package.itemsToBeAdded.filter(function(pkg) {
				var condition = false;
				if (Package.isEditing()) {
					condition = Number(pkg.package_id)===Number(Package.packageDetails.id) ||
						Package.hasPreswapPackageCharacsMatch(pkg);
				} else if (Package.hasCharac(pkg, 'items_added_pkg_id_override')) {
					condition = Number(pkg.CHARACS[0].items_added_pkg_id_override)===Number(Package.packageDetails.id);
				} else {
					condition = Number(pkg.package_id)===Number(Package.packageDetails.id);
				}

				if (!condition && includeComps) {
					// look for the associated comps

					for (var i = 0; i < Package.packageDetails.CT.length; i++) {
						var customerType = Package.packageDetails.CT[i];
						if (angular.isDefined(customerType.COMP)) {
							Utilities.arrayWrap(customerType, 'COMP');
							for (var j = 0; j < customerType.COMP.length; j++) {
								var comp = customerType.COMP[j];

								if (comp.package_id == pkg.package_id) {
									condition = true;
									break;
								}
							}
						}
					}
				}

				return condition;
			});
		};

		Package.hasPreswapPackageCharacsMatch = function(pkgItem, packageId) {
			if (angular.isUndefined(packageId)) {
				packageId = Package.packageDetails.id;
			}

			return checkProp('pkgItem.CHARACS', pkgItem, function(characs) {
				if (angular.isArray(characs) && characs.length > 0 && angular.isDefined(characs[0].preswap_package_id)) {
					return characs[0].preswap_package_id == packageId;
				}
			});
		}

		Package.areCharacsEqual = function(pkgItemA, pkgItemB, characKey) {
			var valA;
			var valB;
			if (checkProp('pkgItemA.CHARACS', pkgItemA)) {
				if (angular.isArray(pkgItemA.CHARACS) && pkgItemA.CHARACS.length > 0) {
					valA = pkgItemA.CHARACS[0][characKey];
				} else {
					valA = pkgItemA.CHARACS[characKey];
				}
			}

			if (checkProp('pkgItemB.CHARACS', pkgItemB)) {
				if (angular.isArray(pkgItemB.CHARACS) && pkgItemB.CHARACS.length > 0) {
					valB = pkgItemB.CHARACS[0][characKey];
				} else {
					valB = pkgItemB.CHARACS[characKey];
				}
			}

			return (valA && valB && valA == valB);
		};

		Package.hasCharac = function(pkgItem, characKey) {
			return checkProp('pkgItem.CHARACS', pkgItem, function(characs) {
				if (angular.isArray(characs) && characs.length > 0) {
					return angular.isDefined(characs[0][characKey]);
				}
			});
		};


		/*Obtains multi-pack info to show on view via checking the typeName package charac for any additional data to add to the name*/
		function getCTNameMPInfo(typeData, characs) {
			var propToCheck = 'typeName_' + typeData.id;
			var mpInfo = '';
			if (characs && characs.hasOwnProperty(propToCheck)) {
				var startIndex = characs[propToCheck].indexOf('@@typeName') != -1 ? '@@typeName'.length : 0;
				mpInfo = startIndex ==0 ? characs[propToCheck] : characs[propToCheck].slice(startIndex, characs[propToCheck].length);
			}
			return mpInfo;
		}

		/*Parses the customer type name via checking the typeName package charac for any additional data to add to the name*/
		function parseCustomerTypeName(typeData, characs) {
			var propToCheck = 'typeName_' + typeData.id;
			var ctName = typeData.name;
			if (characs && characs.hasOwnProperty(propToCheck)) {
				var startIndex = characs[propToCheck].indexOf('@@typeName') != -1 ? '@@typeName'.length : 0;
				ctName = ctName + (startIndex ==0 ? characs[propToCheck] : characs[propToCheck].slice(startIndex, characs[propToCheck].length));
			}
			return ctName;
		}

		/**
		 * Checks if the object is an advance ticket ticket
		 * @param {object} packageData
		 * @return {boolean} true if the packageData contains CHARACS for advance date
		 *
		 */
		Package.hasValidFrom = function(packageData) {
			if (packageData.CHARACS && packageData.CHARACS.valid_from) {
				packageData.isAdvancedTicket = true;
				// Set the flag.
				packageData.advanceTicketDate = packageData.CHARACS.valid_from;
			} else {
				packageData.isAdvancedTicket = false;
				packageData.advanceTicketDate = null;
			}

			return Package.isAdvancedTicket;
		};

		Package.replaceDatesInText = function(pkg, field) {
			if (! checkProp('pkg.CHARACS.valid_from', pkg)) {
				return field;
			}
			return Language.replaceAllMultiple(['@@date'], [$filter('date')(pkg.CHARACS.valid_from, AppData.settings.date_format)], Language.replaceAllMultiple(['@@Date'], [$filter('date')(pkg.CHARACS.valid_from, AppData.settings.date_format)], field));
		};

		Package.splitItemsToBeAdded = function() {
			// Can't use forEach, because forEach does not account for the array increasing in size during the loop,
			// and splitMultipleQty inserts items into the array.
			for (var i=0; i<Package.itemsToBeAdded.length; i++) {
				Package.splitMultipleQty(Package.itemsToBeAdded[i]);
			}
		};

		Package.splitMultipleQty = function(sourcePackage) {
			//split up a package with multiple characs into multiple packages, each with a single charac
			var sourceI = -1,
				charac0 = null,
				newPackage = null,
				newPackageCharac = null,
				packagesAdded = false;

			// get the index of sourcePackage. This will be used to insert the new items into Package.itemsToBeAdded
			sourceI = Package.itemsToBeAdded.indexOf(sourcePackage);

			// Only split if sourcePackage is in Package.itemsToBeAdded
			if (sourceI >-1) {
				sourcePackage.CHARACS.forEach(function(pkgCharac) {
					if (charac0 === null) {
						// get the 0th charac, and don't do anything else. We'll set the sourcePackage charac array after the loop
						charac0 = angular.copy(pkgCharac);
					} else {
						packagesAdded = true;
						// create a new package with a 1-element charac array that only contains the current charac
						newPackage = angular.copy(sourcePackage);
						newPackage.qty = 1;
						delete newPackage.CHARACS;
						newPackageCharac = angular.copy(pkgCharac);
						newPackage.CHARACS = [newPackageCharac];
						// insert this package into the list after the previous one.
						Package.itemsToBeAdded.splice(++sourceI, 0, newPackage);
					}
				});
			}
			// if packages were added, eliminate all but the first item in sourcePackage's charac array
			if (packagesAdded) {
				delete sourcePackage.CHARACS;
				sourcePackage.CHARACS = [charac0];
				sourcePackage.qty=1;
			}
		};

		Package.getPackageByID = function(packageId) {
			if (!checkProp('AppData.GetMerchantPackageList.PS.P', AppData)) {
				$log.info('GetMerchantPackageList undefined');
				return;
			}

			for (var i = 0; i < AppData.GetMerchantPackageList.PS.P.length; i++) {
				var pkg = AppData.GetMerchantPackageList.PS.P[i];

				// Use double-equals so the string package id can match a numerical value
				if (pkg.id == packageId) {
					return angular.copy(setStartingAt(pkg));
				}
			}
		};

		Package.getPackagesByEventAndName = function(eventId, name) {
			if (!checkProp('AppData.GetMerchantPackageList.PS.P', AppData)) { return []; }
			return AppData.GetMerchantPackageList.PS.P.filter(function(p) {
				return checkProp('p.E.id', p, 'returnValue') == eventId && p.name === name;
			});
		};

		/**
		 * Checks to see if the current package items has a certain flow type
		 * @param {String} flowType - The flow type to check for
		 * @returns {Boolean} - Whether the package has the flow type
		 */
		Package.hasFlowType = function hasFlowType(flowType) {
			return new RegExp(flowType, 'i').test(Package.settings.name)
				&& Package.itemsToBeAddedForCurrentPackage().some(function iterateItemsToBeAdded(item) {
					var characs = first(item.CHARACS) || {};

					switch (flowType) {
						case 'date':
							return (getBoolean(characs.upsell) || characs.client_alternate_name) && characs.start_date;
						case 'time':
							return characs.client_alternate_name && characs.start_time;
					}

					return false;
				});
		};

		/**
		 * Returns a copy of the customer types.
		 * @param {String} packageId The package ID
		 * @returns {Object[]} An array of customer types
		 */
		Package.getCustomerTypes = function(packageId) {
			var pkg = Package.getPackageByID(packageId);
			return Utilities.wrapObjectToArray(pkg.CT, true).map(function copyObjects(ct) {
				return angular.copy(ct);
			});
		};

		/**
		 * Returns the main customer type for a package
		 * @param {String} packageId The package id
		 * @param {Object} [pkgDetails] A specified package object to use
		 * @returns {customerType|null}
		 */
		Package.getMainCustomerType = function(packageId, pkgDetails) {
			var pkg = pkgDetails || Package.getPackageByID(packageId),
				customerType,
				mainCustomerTypeId = checkProp('pkg.CHARACS.ct_id_to_display', pkg, 'returnValue'),
				cts;

			if (!pkg) {
				return null;
			}

			cts = Utilities.wrapObjectToArray(pkg.CT, true)
				.slice(0)
				.sort(function sortPackageCustomerTypes(a, b) {
					return a.display_order - b.display_order;
				});

			if (mainCustomerTypeId) {
				customerType = cts.find(UtilityFunctions.filterById(mainCustomerTypeId));
				if (customerType) {
					return customerType;
				}
			}

			return cts[0];
		};


		Package.filterPackagesByKeyword = function(packageArray, keyword, checkKeywordActiveInNavTree) {
			var keywordListToMatch = angular.isDefined(keyword) ? keyword.toLowerCase().split(',') : [];

			if (angular.isUndefined(packageArray)) {
				packageArray = checkProp('GetMerchantPackageList.PS.P', AppData.GetMerchantPackageList) ? AppData.GetMerchantPackageList.PS.P : [];
			}

			if (!angular.isArray(packageArray)) {
				throw new Error('Argument must be an array');
			}

			return packageArray.filter(function(item) {
				if (angular.isUndefined(item.keyword)) {
					return false;
				}

				var keywordArray = item.keyword.toLowerCase().split(',');

				//keyword can either be part of the array of keywords or if the keyword to match is also a keyword list, match exactly
				return keywordListToMatch.some(function(kw) {
					if (checkKeywordActiveInNavTree) {
						return keywordArray.indexOf(kw) > -1 && AppData.menuItems.filter(function(menuItem) {
							return menuItem.keywords.toLowerCase().indexOf(kw) > -1 && menuItem.isactive === true;
						}).length > 0;
					} else {
						return keywordArray.indexOf(kw) > -1;
					}
				});
			});
		};

		/**
		 * Gets the packages to request for a given package
		 * @param {String} packageId - The package ID
		 * @param {Object} [pkgOverride] - Already-resolved package object, to skip a redundant getPackageByID lookup
		 * @returns {Object[]} - An array of packages to request
		 */
		Package.getRequestList = function getRequestList(packageId, pkgOverride) {
			var pkg = pkgOverride || Package.getPackageByID(packageId);

			if (!pkg) {
				return [];
			}

			if (!Utilities.checkProp('pkg.CHARACS.block_purchase', pkg)) {
				return [ pkg ];
			}

			return Utilities.wrapObjectToArray(AppData.GetMerchantPackageList.PS.P, true).filter(function iteratePackages(p) {
				return Utilities.checkProp('p.CHARACS.parentPackageID', p, 'returnValue') == pkg.id;
			});
		};

		/**
		 * Gets the lowest advertised price from a list of package ids
		 * @param {Number[]} pkgList - An array of package ids
		 * @returns {Number} - The package with the lowest price for the main CT
		 */
		Package.getLowestPriced = function getLowestPriced(pkgList) {
			var packageId;

			Utilities.wrapObjectToArray(pkgList, true).reduce(function(acc, pkgId) {
				var compare = Package.getMainCustomerType(pkgId);

				if (!acc || parseFloat(compare.retail_amount) < parseFloat(acc.retail_amount)) {
					packageId = pkgId;

					return compare;
				}

				return acc;
			}, null);

			return packageId;
		}

		Package.getDisplayOrderForKeyword = function(pkg, keywords) {
			var displayOrder = parseInt(pkg.display_order, 10);

			if (angular.isDefined(keywords) && checkProp("pkg.KEYWORDS.K", pkg)) {
				pkg.KEYWORDS.K.forEach(function(item) {
					var keywordsArray = keywords.split(',');

					for (i = 0; i < keywordsArray.length; i++) {
						if (item.keyword.split(',').indexOf(keywordsArray[i]) > -1) {
							displayOrder = parseInt(item.display_order, 10);
							break;
						}
					}
				});
			}

			return displayOrder;
		};

		Package.buildXFCMap = function() {
			var deferred = $q.defer();
			try {
				// if package details is not defined
				// or we haven't setup the Package.packageXFCs variable yet, then we don't want to build the map
				if (angular.isUndefined(Package.packageDetails) || Package.packageXFCs.length === 0 || !packageIdsFromPreviousStateMatchCurrent()) {
					$log.info('Package.packageDetails is not defined, not building XFC map');
					deferred.resolve();
				} else {
					//get the parent state url
					var nextParentStateName = Utilities.parseDirectParentStateName($state.next.name);
					var currentParentStateName = Utilities.parseDirectParentStateName($state.current.name);

					//search in Package.packageXFCs, which gets set up prior to the route
					for (var i = 0; i < Package.packageXFCs.length; i++) {
						var xfcObject = ExtraFlow.getXMCByName(Package.packageXFCs[i].name);
						//most XFC views have only one state param, which is the packageId, however, we need to accommodate matching on views that have addl params
						// for example the paymentPlan view has additional params and the current xfcObject view does not accommodate the param so we will miss matching the view
						// added an optional extra property to the ExtraFlow setting object, xfcMapView to accommodate this scenario
						var view = angular.isDefined(xfcObject.xfcMapView) ? xfcObject.xfcMapView : xfcObject.view;


						if (!Utilities.getBoolean(xfcObject.viewIsStateName)) {
							if (view[0] !== '/') {
								view = ('/' + view);
							}
							view += '/:packageId';
						}

						if ($state.current.url == view || checkSubView($state.current.url, xfcObject) || (currentParentStateName !== null && currentParentStateName ==view)) {
							previousXFC = i;
						}

						if (($state.next.url == (view) || (angular.isDefined(nextParentStateName) && nextParentStateName == view)) && currentXFC !== i || checkSubView($state.next.url, xfcObject)) {
							// found our current state!
							currentXFC = i;
							//call setupXFC here with a parameter to skip rerouting since we are already in the middle of routing to the XFC
							//this function is called via a resolve on every XFC state
							//if we allowed the call again to routeTo, this can cause infinite routing loops, which we don't want
							//we just need to allow setupXFC to set the specific Package variables and the route will finish itself
							Package.setupXFC(i, true);
						}
						deferred.resolve();
					}
				}
			} catch (err) {
				$log.error(err);
				deferred.resolve();
			}

			return deferred.promise;
		};

		function checkSubView(url, xfcObject) {
			if (angular.isUndefined(xfcObject.subView)) {
				return false;
			}
			return (url.indexOf(xfcObject.subView) > -1);
		}

		/**
		 * Do the package ids from the previous state that we were just at match where we are going to
		 * @returns {Boolean}
		 */
		function packageIdsFromPreviousStateMatchCurrent() {
			return angular.isDefined($state.params.packageId) && angular.isDefined($state.toParams.packageId) && $state.params.packageId === $state.toParams.packageId;
		}

		/**
		 * Compares index of previousXFC and currentXFC to determine whether or not we are moving
		 * forward or backward in the XFC flow
		 * @returns {Boolean}
		 */
		Package.isForwardExtraFlowRouting = function() {
			return previousXFC < currentXFC;
		};

		Package.getStandardByPassXFCCallback = function() {
			return Package.isForwardExtraFlowRouting() ? Package.nextXFC : Package.cancelXFC;
		};

		Package.resetQuickSell = function() {
			delete Package.quickSell;
			delete Package.quickSellList;
		};

		/**
		 * Adds the start_date charac to all items passed in
		 * Adds the eventId if provided to all items passed in
		 * @public
		 * @param {Object[]} items the current items to be added to the cart
		 * @param {String} eventId the id of the event (calendar) used in a prior movie
		 * @returns {Object[]} Array of items to add to the cart that have been updated
		 */
		Package.addCalendarPricingDateToPackages = function(items, eventId) {
			items = angular.copy(items);
			if (angular.isDefined(Package.calendarPricingModuleDate)) {
				try {
					items.forEach(function(item) {
						if (angular.isUndefined(item.CHARACS)) {
							item.CHARACS = [{}];
						}
						item.CHARACS[0].start_date = Utilities.getDateByString(Package.calendarPricingModuleDate);
						if (validString(eventId) && !validString(item.CHARACS[0].event_id)) {
							item.CHARACS[0].event_id = eventId;
						}
					});
					Package.calendarPricingModuleDate = undefined;
				} catch (e) {
					$log.error(e);
					$log.error('Unable to add start_date or event_id to all items to be added to cart');
				}
			}

			return items;
		};

		// this gets a full package
		Package.getAllPricesForPackageByDate = function(cts, dateString) {
			if (angular.isDefined(cts)) {
				var prices = [];

				for (var i=0; i < cts.length; i++) {
					var price = Package.getFullPriceForDate(cts[i], dateString);

					prices.push(price);
				}

				return prices;
			}
		};

		/**
		 * Calculates the full price of an item including APP, and COMPs
		 * @public
		 * @param {Object} ct - Customer Type being used for calculation
		 * @param {Object} date - Date used to calculate APP pricing
		 * @param {Boolean} includeComps - flag to add COMPs to pricing calculation
		 * @returns {Number} price - full price for dated item
		 */
		Package.getFullPriceForDate = function(ct, date, includeComps) {
			//We want to set this object to empty obj because we don't want it to have the APP info
			//In case APP info is copied into ctForDate object, it will send those to package.getFullPrice function
			//and return incorrect full price amount
			var ctForDate = {};

			if (angular.isDefined(ct.APP)) {
				var currentDate = new Date();
				var packageDate = new Date(date);

				// This should be at midnight otherwise the price will not be calculated correctly
				currentDate.setHours(0, 0, 0, 0);
				packageDate.setHours(0, 0, 0, 0);

				var currentMilli = currentDate.getTime();
				var packageDateMilli = packageDate.getTime();
				var startRangeMilli = 0;

				ct.APP.forEach(function(ctAPP) {
					startRangeMilli = Number(ctAPP.start_range) * 24 * 60 * 60 * 1000;
					if (packageDateMilli - currentMilli >= startRangeMilli) {
						// Pull from the APP CT because it uses different props
						ctForDate.retail_amount = ctAPP.discounted_retail_amount;
						ctForDate.tax_amount = ctAPP.discounted_tax_amount;
					}
				});
			}

			// If we didn't populate the retail and tax from APP, just pull from the base of the ct
			if (Object.keys(ctForDate).length === 0) {
				ctForDate.retail_amount = ct.retail_amount;
				ctForDate.tax_amount = ct.tax_amount;
			}

			// Copy fee and comp nodes so Package.getFullPrice can calculate correctly
			['F', 'FEE', 'fee_total', 'COMP'].forEach(function(prop) {
				if (angular.isDefined(ct[prop])) {
					ctForDate[prop] = ct[prop];
				}
			});

			// Now we have the correct CT information for the given date - get the price
			var price = Package.getFullPrice(ctForDate, AppData.defaults.use_vat, includeComps);
			return price;
		};

		/**
		 * Gets the full price for a customer type, it may include retail amount, tax amount and fees, and also the full
		 * price of associated comps.
		 * @param {Object} ct The customer type object
		 * @param {Boolean} useVat expected to be the value of AppData.defaults.use_vat, or not included
		 * @param {Boolean} includeComps Should the value of any present comps be included in the full price
		 * @returns {Number} The full price
		 */
		Package.getFullPrice = function(ct, useVat, includeComps) {
			var useVat = Utilities.getBoolean(useVat),
				useFeeInclusivePricing = AppData.defaults.use_fee_inclusive_pricing;

			var retail = 0,
				tax = 0,
				fee = 0,
				compTotal = 0;

			// Retail Amount
			retail = Package.getRetailAmount(ct);

			// Tax & Fees - only applied if using VAT
			if (useVat) {
				tax = Package.getTaxAmount(ct);
			}

			if (useVat || useFeeInclusivePricing) {
				fee = Package.getFeeAmount(ct);
			}

			// APP - if APP node is present, the retail, tax, & fee will all be overridden
			if (angular.isDefined(ct.APP)) {
				var appObject = Package.getAppAmount(ct);

				// override
				retail = appObject.retail;

				// Only care if using VAT
				if (useVat) {
					tax = appObject.tax;
					fee = appObject.fee;
				}
			}

			// COMPs - because these can have non-zero pricing (le sigh)
			if (includeComps) {
				compTotal = Package.getFullCompPrice(ct, useVat);
			}

			// We can always just sum them because if N/A (not vat) the amounts will be 0
			// Should we round?
			return retail + tax + fee + compTotal;
		};

		/**
		 * Gets the retail amount for a customer type
		 * @param {Object} ct The customer type object
		 * @returns {Number} The retail amount
		 */
		Package.getRetailAmount = function(ct) {
			var retail = 0;

			if (angular.isDefined(ct.retail_amount)) {
				retail = parseFloat(ct.retail_amount);
			} else {
				$log.error('Why is retail_amount undefined on the CT?');
			}

			return retail;
		};

		/**
		 * Gets the tax amount for a customer type
		 * @param {Object} ct The customer type object
		 * @returns {Number} The retail amount
		 */
		Package.getTaxAmount = function(ct) {
			var tax = 0;

			if (angular.isDefined(ct.tax_amount)) {
				tax = parseFloat(ct.tax_amount);
			} else {
				$log.error('Why is tax_amount undefined on the CT?');
			}

			return tax;
		};

		/**
		 * Gets the fee amount for a customer type
		 * @param {Object} ct The customer type object
		 * @returns {Number} The fee amount
		 */
		Package.getFeeAmount = function(ct) {
			var fee = 0;

			if (angular.isDefined(ct.F) || angular.isDefined(ct.FEE)) {
				var feeNode = ct.F || ct.FEE;

				// If there is only one fee - it will be an object
				if (!angular.isArray(feeNode)) {
					fee += parseFloat(feeNode.amount);
				}
				// If there is more than one - it will be an array
				else {
					for (var i = 0; i < feeNode.length; i++) {
						fee += parseFloat(feeNode[i].amount);
					}
				}
			}

			return fee;
		};

		/**
		 * Retrieve the advance purchase pricing object from a customer type
		 * @param {Object} ct The customer type object
		 * @returns {Object} The advance purchase pricing object
		 */
		Package.getAppAmount = function(ct) {
			var appObject = {

				retail: 0,
				tax: 0,
				fee: 0
			};

			var items = Package.itemsToBeAddedForCurrentPackage();
			var doCurrentItemsHaveAPPAmounts= items.some(function(item) {
				return item.discountedRetailAmount > -1;
			});

			if (items.length && doCurrentItemsHaveAPPAmounts) {
				for (var i=0; i < items.length; i++) {
					if (ct.id === items[i].customer_type) {
						appObject.retail = Package.getRetailAmount({ retail_amount: items[i].discountedRetailAmount });
						appObject.tax = Package.getTaxAmount({ tax_amount: items[i].discountedTaxAmount });
						appObject.fee = Package.getFeeAmount(items[i]);
						break;
					}
				}
			} else {
				appObject.retail = Package.getRetailAmount(ct);
				appObject.tax = Package.getTaxAmount(ct);
				appObject.fee = Package.getFeeAmount(ct);
			}

			return appObject;
		};

		/**
		 * Retrieve the predefined start date for a selected customer type
		 * @param {Object} selectedCustomerType The selected customer type object
		 * @returns {undefined}
		 */
		Package.getSelectedCustomerTypeHaveItemsAddedStartDate = function(selectedCustomerType) {
			var selectedStartDateForCustomerType = undefined,
				items = Package.itemsToBeAddedForCurrentPackage();
			if (items.length) {
				for (var i=0; i < items.length; i++) {
					if (selectedCustomerType.id === items[i].customer_type && Package.hasCharac(items[i], 'start_date')) {
						selectedStartDateForCustomerType = Utilities.getJavaScriptDateFromMySQLDate(items[i].CHARACS[0].start_date);
						break;
					}
				}
			}

			return selectedStartDateForCustomerType;
		};

		Package.getFullCompPrice = function(ct, useVat) {
			var compTotal = 0;

			if (angular.isDefined(ct.COMP)) {
				// If there is only one COMP - it will be an object
				if (!angular.isArray(ct.COMP)) {
					if (angular.isDefined(ct.COMP.CT)) {
						compTotal = Package.getFullPrice(ct.COMP.CT, useVat);
					}
				}
				// If there is more than one - it will be an array
				else {
					for (var i=0; i < ct.COMP.length; i++) {
						if (angular.isDefined(ct.COMP[i].CT)) {
							compTotal += Package.getFullPrice(ct.COMP[i].CT, useVat);
						}
					}
				}
			}

			return compTotal;
		};

		/**
		 * Generates the customer types array for the get dates request
		 * @public
		 * @function
		 * @name getCustomerTypeQuantity
		 * @memberof {Package}
		 * @param {Number} [packageId] - The package ID
		 * @returns {Object[]} - The customer types array
		 */
		Package.getCustomerTypeQuantity = function getCustomerTypeQuantity(packageId) {
			var customerTypes = packageId
				? Package.setCustomerType(Package.getPackageByID(packageId), [])
				: Package.customerTypes;

			// Iterate over the customer types
			return Utilities.wrapObjectToArray(customerTypes, true).reverse().reduce(function iterateCustomerTypes(acc, ct, i, orig) {
				// If the quantity is greater than 0
				if ((ct.qty > 0 || (packageId && orig.length - 1 === i)) && ct.id) {
					// Add the customer type to the array
					acc.push({
						id: ct.id,
						qty: ct.qty || 1,
					});
				}

				// Return the accumulator
				return acc;
			}, []);
		}

		/**
		 * Assess and set the gate pricing display depending on configuration
		 * @public
		 * @function
		 * @name assessAndSetGatePricingDisplay
		 * @memberof {Package}
		 * @param {Array} customerTypes array of customer types to assess
		 * @returns {undefined}
		 */
		Package.assessAndSetGatePricingDisplay = function(customerTypes) {
			var i,
				customerTypesLength = customerTypes.length;
			if (!angular.isArray(customerTypes)) {
				return;
			}
			if (Utilities.getBoolean(AppData.settings.display_gate_pricing_on_package)) {
				for (i = 0; i < customerTypesLength; i++) {
					if (angular.isString(customerTypes[i].gate_price) && Number(customerTypes[i].gate_price) > 0) {
						customerTypes[i].wizardPriceLayout = true;
					}
				}
			}
		};

		/**
		 * Display a modal with the package description
		 * @public
		 * @param {Number} packageId - The package ID
		 * @param {Object} [options] - Options for the modal
		 * @returns {undefined}
		 */
		Package.showDescModal = function showDescModal(packageId, options) {
			var pkg = Package.getPackageByID(packageId);

			var modalOptions = Utilities.mergeDeep({
				customCss: 'small',
				customHTML: '/views/templates/package-details-modal.html',
				customHTMLData: {
					isQuicksell: Package.hasUpsellPackage(),
					packageName: pkg.name,
				},
				showCloseButton: false,
				title: pkg.name,
				values: {
					desc: pkg.desc,
					image: pkg.shop_image_v4,
					moreInfo: pkg.more_info,
					name: pkg.name
				},
				view: Modal.SLIDEUP
			}, options || {});

			Modal.displayModal(modalOptions);
		};

		/**
		 * It will loop through the object.CT to find packages, if multiple
		 * packages exist it will determine the starting price
		 *
		 * @param {Object} pkgData package object to gather object.CT
		 * @returns {Object} The modified package data object
		 */
		function setStartingAt(pkgData) {
			var ctCost = 0,
				ctCosts = [];

			var ct = (angular.isArray(pkgData.CT)) ? pkgData.CT : [pkgData.CT];

			for (var i = 0; i < ct.length; i++) {
				/*
				 * Find the lowest-cost customer type to display as the starting price.
				 * getTotalPrice() handles all pricing scenarios (standard, VAT, fee-inclusive) internally.
				 * When both use_vat and use_fee_inclusive_pricing are false, it returns the base retail_amount.
				 */
				ctCost = Utilities.getTotalPrice(ct[i]);
				if (ctCost > 0) {
					ctCosts.push(ctCost);
				} else if (!checkProp('ct.retail_amount', ct[i])) {
					// Only log error if retail_amount is completely missing
					errorTracking.notify('Why is there no retail amount on package' + ct[i].id + '?');
				}
			}


			// Now the first element is the lowest price
			ctCosts.sort(function sortCts(a, b) {
				return a - b;
			});

			// Set starting_at whenever there are multiple customer types, regardless of price differences
			// This ensures consistent display of "Prices From" locale for packages with multiple CTs
			if (ct.length > 1 && ctCosts.length > 1) {
				pkgData.starting_at = ctCosts[0];
			}

			return pkgData;
		}

		/**
		 * Resets the upsell to the empty version
		 * @returns {undefined}
		 */
		function resetUpsellPackageObject() {
			// reset the upsell to the empty version
			Package.upsellPackage = {
				customerTypes: [],
				customerTypesTemp: [],
				packageDetails: {},
				skip: false,
				isAdvancedTicket: false,
				advancedTicketDate: null
			};
		}


		/**
		 * The advance data parameters can be found within the packageDetails CHARACS or within the rates CHARACS
		 * If data is undefined it will check advance data parameter within the packageDetails
		 * @param {Object} pkg The package object
		 * @returns {Object} The modified package
		 */
		function updateAdvancedTicketDesciption(pkg) {
			// Set the advanceTicketDate identifier.
			Package.advanceTicketDate = pkg.CHARACS.valid_from;
			pkg.desc = replaceDatesInText(pkg, pkg.desc);
			pkg.headline = replaceDatesInText(pkg, pkg.headline);
			pkg.more_info = replaceDatesInText(pkg, pkg.more_info);
		}

		return Package;
	});
/**
	 * Created by ltischuk on 4/27/15.
	 * Temporary solution to manually track routing until main entry points are reworked to using Resolve functions to handle
	 * pre-routing decisions
	 * Standard flow is defined as PackageList --> PackageDetails --> XFC --> Add to cart
	 * We can either route directly to the packageDetails state from packageList or we can also come from alternative entry points
	 * This service handles routing back and forth between the two so that back buttons and refreshes can be accommodated
	 * We store alternateEntryInfo in local storage to handle refreshes once we are in the XFC flow and beyond -
	 * we don't need to do this for the standard entry point because the standard recovery state is the packageDetails screen
	 */
angular.module(
	'app'
).factory
(
	'StandardFlowInitiatorService',

	function(
		$injector,
		$rootScope,
		$state,
		$transitions,
		AppData,
		Enums,
		Storage,
		Utilities,
		UtilsValidation
	) {
		var checkProp = Utilities.checkProp,
			merge = Object.assign || angular.merge,
			validObject = UtilsValidation.validObject;

			var alternateEntryInfo = Storage.get('_alternateEntryInfo'),
				dereg;

		var factory = {
			/**
			 * Either the path proceeding a packageList state (packageList/navItem, packageList/promocode etc.) that depicts the entry or
			 * the state name of the flow we routed from (calendar/savingsCalendar etc)
			 */
			currentStandardFlowType: undefined,
			/**
			 * The param that the entry began with (promocode, keyword) - usually a stateParam
			 */
			currentStandardFlowDetail: undefined,
			/**
			 * Whether or not the current flow entry point was the packageList - since that is the most common entry
			 */
			routedFromPackageList: false,
			/**
			 * The state name of the alternate entry point we routed to the standard flow from
			 */
			alternateEntryState: undefined,
			/**
			 * The params of the alternate entry point we routed to the standard flow from
			 */
			alternateEntryParams: undefined,
			/**
			 * Identifies whether or not the current flow that uses either all or elements of the standard flow upon refresh while in the standard flow
			 * Determines whether or not we are allowed to route to the PackageDetails screen or requires routing to
			 * the appropriate module from where it came - this property is assessed within the Package.initXFC function to handle
			 * recovering to a particular state that is NOT packageDetails
			 */
			resetToPackageDetailsScreen: true,
			hasCurrentFlow: hasCurrentFlow,
			resetStandardFlow: resetStandardFlow,
			setAlternateEntryToStandardFlow: setAlternateEntryToStandardFlow,
			setStandardFlow: setStandardFlow,
			getStandardFlowEntryRoute: getStandardFlowEntryRoute,
			_: {
				registerAlternateEntryInfo: _registerAlternateEntryInfo
			}
		};


		$rootScope.$on('navbarOrMenuClicked', function() {
			factory.resetStandardFlow();
		});

		/**
		 * Application bootup logic
		 * When the application begins to perform its' first transition, we need to assess whether or not we have valid alternate entry info
		 * If not, remove it from storage
		 * @returns {Function} - The deregister function for the listener
		 */
		dereg = $transitions.onCreate({ from: '' }, function(trans) {
			// If the application has been activated
			if (AppData.applicationActivated) {
				// Try to register the alternate entry info
				factory._.registerAlternateEntryInfo(trans);
			} else {
				// Otherwise, wait for the application to be activated
				factory._.registerAlternateEntryInfo.deregHook = $rootScope.$on(Enums.services.APP_ACTIVATED, factory._.registerAlternateEntryInfo.bind(null, trans));
			}

			// Deregister the listener
			dereg();
		});

		return factory;

		/**
		 * Start up logic for the alternate entry info
		 * @function
		 * @protected
		 * @param {$transition$} trans - The current transition instance for the route
		 * @returns {undefined}
		 */
		function _registerAlternateEntryInfo(trans) {
			var Package = $injector.get('Package'),
				params = trans.params('to'),
				pkg,
				kw;

			// If we are trying to load the same flow as the one the store was previously on
			if (validObject(alternateEntryInfo) && alternateEntryInfo.flowDetail === checkProp('params.flowDetail', params, 'returnValue')) {
				// If a package id was supplied
				if (params.packageId) {
					// Grab the package details
					pkg = Package.getPackageByID(params.packageId);

					// If valid package details come back
					if (pkg) {
						// Grab the first keyword
						kw = checkProp('pkg.KEYWORDS.K', pkg, 'first');
						// Set the params to use the package id keyword, otherwise set it to null
						alternateEntryInfo.alternateEntryParams.keyword = kw ? kw.keyword : null;
					}
				}

				// Set the alternate entry info to the factory
				merge(factory, {
					currentStandardFlowType: 'alternateEntry',
					currentStandardFlowDetail: alternateEntryInfo.flowDetail,
					alternateEntryState: alternateEntryInfo.alternateEntryState,
					alternateEntryParams: alternateEntryInfo.alternateEntryParams,
					resetToPackageDetailsScreen: alternateEntryInfo.resetToPackageDetailsScreen
				});
			} else {
				// Bad alternate entry info - remove it
				Storage.remove('_alternateEntryInfo');
			}

			// Deregister the listener
			if (angular.isFunction(factory._.registerAlternateEntryInfo.deregHook)) {
				factory._.registerAlternateEntryInfo.deregHook();
			}
		}

		/**
		 * Has current flow in progress
		 * @returns {boolean}
		 */
		function hasCurrentFlow() {
			return angular.isDefined(factory.currentStandardFlowType) && angular.isDefined(factory.currentStandardFlowDetail);
		}

		/*
		 * Reset the data stores that have information what type of flow is currently underway
		 */
		function resetStandardFlow() {
			factory.currentStandardFlowType = undefined;
			factory.currentStandardFlowDetail = undefined;
			factory.routedFromPackageList = false;
			factory.alternateEntryState = undefined;
			factory.alternateEntryParams = undefined;
			factory.resetToPackageDetailsScreen = true;
			Storage.remove('_alternateEntryInfo');
		}


		/**
		 * Set the alternate entry for the standard flow (THIS MUST BE CALLED BEFORE ROUTING TO PACKAGEDETAILS OR COMING INTO THE XFC FLOW FROM AN ALTERNATE ENTRY POINT
		 * IF YOU ARE COMING FROM AN ALTERNATE ENTRY POINT
		 *
		 * @param alternateModuleFlowDetail
		 * @param alternateModuleState
		 * @param alternateModuleParams
		 * @param usesPackageDetailsScreen
		 */
		function setAlternateEntryToStandardFlow(alternateModuleFlowDetail, alternateModuleState, alternateModuleParams, usesPackageDetailsScreen) {
			factory.currentStandardFlowType = 'alternateEntry';
			factory.currentStandardFlowDetail = alternateModuleFlowDetail;
			factory.alternateEntryState = alternateModuleState;
			factory.alternateEntryParams = alternateModuleParams;
			factory.resetToPackageDetailsScreen = usesPackageDetailsScreen;
			Storage.set('_alternateEntryInfo', {
				flowDetail: alternateModuleFlowDetail,
				alternateEntryState: alternateModuleState,
				alternateEntryParams: alternateModuleParams,
				resetToPackageDetailsScreen: usesPackageDetailsScreen
			});
		}

		/**
		 * Assesses the type of flow the application is currently in regarding base PackageList through PackgeDetails to Adding an item to the cart
		 * @param stateParams - if this is a packageList route then we can just provide the startParams and set the flow accordingly
		 * @param flowType (optional for flows that route to package details that are NOT a variant of packageList)
		 * @param flowDetail (optional for flows that route to package details outside of packageList to force the detail (whether it be a keyword or some other param for package details)
		 */
		function setStandardFlow(stateParams, type, detail) {
			var flowType = undefined;
			var flowDetail = undefined;

			factory.routedFromPackageList = angular.isUndefined(type) && angular.isUndefined(detail);

			//if its not a package list route then lets just set the flowType and flowDetail to the params
			if (!factory.routedFromPackageList) {
				flowType = type;
				flowDetail = detail;
			}//otherwise its a packageList route so we can set the flow based on the state params
			else if (angular.isDefined(stateParams.promocode)) {
				flowType= 'promocode';
				flowDetail = stateParams.promocode;
			} else if (angular.isDefined(stateParams.crosssell)) {
				flowType = 'crosssells';
				flowDetail = stateParams.crosssell;
			} else if (angular.isDefined(stateParams.navItem)) {
				flowType = 'navItem';
				flowDetail = stateParams.navItem;
			} else if (angular.isDefined(stateParams.keyword)) {
				flowType = 'keyword';
				flowDetail = stateParams.keyword;
			} else if (angular.isDefined(stateParams.packages)) {
				flowType = 'packages';
				flowDetail = stateParams.packages;
			}

			factory.currentStandardFlowType = flowType;
			factory.currentStandardFlowDetail = flowDetail;
		}

		/**
		 * Get the entry route in URL form to navigate to
		 * (this is for navigating backward via the packageDetails back button AND to provide a route for the continueShopping button
		 * @returns {string}
		 */
		function getStandardFlowEntryRoute() {
			var route = '';
			//if we have a flowType then lets get a route
			 	if (factory.currentStandardFlowType === 'alternateEntry') {
				 route = $state.href(factory.alternateEntryState, factory.alternateEntryParams);
			} else if (angular.isDefined(factory.currentStandardFlowType)) {
				if (factory.routedFromPackageList) {
					 route = '/packageList/'+ factory.currentStandardFlowType + '/' + encodeURIComponent(factory.currentStandardFlowDetail);
				} else {
					//some flows that route directly to packageDetails don't have a stateParam keyword or any other stateParam so we just want to route back to the
					// value stored in currentStandardFlowType
					if (factory.currentStandardFlowDetail === 'noDetail') {
						route = '/'+ factory.currentStandardFlowType;
					} else {
						route = '/'+ factory.currentStandardFlowType + '/' + encodeURIComponent(factory.currentStandardFlowDetail);
					}
				}
			} else {
				route = '/packageList';
			}

			return route;
		}
	});

angular.module('app')
	.service('ParkHours', function(
		$rootScope,
		$filter,
		AppData,
		Enums,
		Utilities,
		$q,
		$log) {
		'use strict';
		/**
		 * service object
		 */
		var service = {
			allowedDates: [],
			loadedDates: [],
			feedName: undefined,
			firstOperationalDate: undefined,
			hasParkHours: false,
			hasMultipleFeeds: false
		};

		service.months = ['january', 'february', 'march', 'april', 'may', 'june', 'july', 'august', 'september', 'october', 'november', 'december'];

		var gettingParkHours = false;
		var parkHoursList;
		var parkHoursCurrentFeed = {};
		var parkHours = {};
		var request = $q.defer();

		service.getParkHours = function() {
			var getParkHoursEnum = Enums.services.GET_PARK_HOURS;
			if (Utilities.getBoolean(AppData.settings.enableParkHours)) {
				if ((!gettingParkHours || angular.isUndefined(parkHoursList)) && !$rootScope.hasPendingRequest(getParkHoursEnum)) {
					gettingParkHours = true;
					$rootScope.pendingRequests.push(getParkHoursEnum);
					AppData.fetch(
						getParkHoursEnum,
						false,
						{}
					).then(function(data) {
						$rootScope.removePendingRequest(getParkHoursEnum);
						if (data.status == Enums.status.OK) {
							service.hasParkHours = true;

							if (angular.isDefined(data.MultipleFeeds)) {
								parkHoursList = angular.copy(data.MultipleFeeds.Hours);
								service.hasMultipleFeeds = true;
							} else {
								Utilities.arrayWrap(data, 'Hours');
								parkHoursList = angular.copy(data.Hours);
							}

							request.resolve(parkHoursList);
						} else {
							request.reject();
						}
					});
				}
			} else {
				request.reject();
			}

			return request.promise;
		};

		service.reset = function() {
			parkHoursCurrentFeed = {};
			parkHours.Days = [];
			service.allowedDates = [];
			service.loadedDates = [];
			service.feedName = undefined;
			service.firstOperationalDate = undefined;
		}

		service.combineFeeds = function() {
			// Reference for each feed 0 index and 1 index
			var feed = parkHoursList[0],
				feed2 = parkHoursList[1];

			// Ensure days come back for both feeds
			if (Utilities.safelyCheckPropertyOnObject('feed.Days.Day', feed) && Utilities.safelyCheckPropertyOnObject('feed2.Days.Day', feed2)) {
				var originalFeedDates = feed.Days.Day,
					secondFeedDates = feed2.Days.Day;

				// Loop through additional feed and map attributes to initial feed
				secondFeedDates.forEach(function(date2) {
					var matchFound = false,
						originalFeedHasWaterpark = false;

					// Loop through initial feed and map attributes / days from additional feed
					originalFeedDates.forEach(function(date) {
						if (Utilities.getBoolean(date.HasWaterPark)) {
							originalFeedHasWaterpark = true;
						}
						if (date2.FormatDate === date.FormatDate) {
							matchFound = true;
							date.AdditionalParkHours = date2.ParkHours;
						}
						date.HasAdditionalPark = true;
					})
					// If there are additional park hours but not regular park hours, add the day to the feed
					if (!matchFound) {
						originalFeedDates.push({
							Date: date2.Date,
							FormatDate: date2.FormatDate,
							ParkHours: "",
							HasWaterPark: originalFeedHasWaterpark,
							WaterParkHours: "",
							AdditionalParkHours: date2.ParkHours,
							HasAdditionalPark: true
						});
						originalFeedHasWaterpark = false;
					}
				});

				originalFeedDates.sort(function(a, b) {
					return getFormatDateToTime(a.FormatDate) - getFormatDateToTime(b.FormatDate);
				});
			} else {
				$log.error("combineFeeds failed: Invalid date setup for combining park hour feeds")
			}
		}

		/**
		 * Returns a FormatDate from the response to the milliseconds it is. FormatDate is always in YYYYMMDD format.
		 * @param {String} str The string to convert
		 * @returns {Number} The time in milliseconds
		 */
		function getFormatDateToTime(str) {
			var datePart = Utilities.forceInt(str.substring(6));
			var monthPart = Utilities.forceInt(str.substring(4, 6)) - 1;
			var yearPart = Utilities.forceInt(str.substring(0, 4));
			return new Date(yearPart, monthPart, datePart, 0, 0, 0, 0).getTime();
		}

		/**
		 * Loads the ParkHours, if there are multiple feeds, calls the combineFeeds; if shouldFillInEmptyDays, calls fillInClosedDays; parses Days
		 * @param {Number} feedIndex which set of park hours from the list of feed(s) to use
		 * @param {Boolean} multiple Multiple feeds combine into one for side menu logic
		 * @param {Boolean} shouldFillEmptyDates for Park Hours to show Closed
		 * @returns {undefined}
		 */
		service.loadFeed = function(feedIndex, multiple, shouldFillEmptyDates) {
			// If feed index is undefined or not a number, default to 0
			// This way the first feed will be loaded by default
			feedIndex = parseInt(feedIndex);
			if (isNaN(feedIndex)) {
				feedIndex = 0;
			}

			service.reset();

			parkHoursCurrentFeed = parkHoursList[ feedIndex ];

			// If the Day array is not available then return without setting or loading anything
			if (!Utilities.safelyCheckPropertyOnObject('parkHoursCurrentFeed.Days.Day', parkHoursCurrentFeed)) {
				return;
			}

			// If there are multiple feeds and it's the side menu implementation then map the second feed attributes onto the first
			if (this.hasMultipleFeeds && multiple === true) {
				this.combineFeeds();
			}

			setFeedName(feedIndex);

			parkHours.Days = parkHoursCurrentFeed.Days.Day;
			Utilities.arrayWrap(parkHours, 'Days');

			// If shouldFillEmptyDates is passed as true this will fill parkHours.Days dates without park hours in
			// Needed to override disable and show hours as "Closed"
			if (shouldFillEmptyDates) {
				service.fillInClosedDays(parkHours);
			}

			parseDays(parkHours);
		};

		/**
		 * Returns today's date, also utilized for testing
		 * @returns new date
		 */
		service.getTodaysDate = function() {
			return new Date();
		};

		/**
		 * Check based on if park hours has multiple feeds, utilized for filling in closed days and testing
		 * @returns {Boolean} if park has AdditionalParkHours
		 */
		service.getHasAdditionalPark = function() {
			return service.hasMultipleFeeds;
		};

		/**
		 * Formats date as'yyyymmDD' to add to parkHours object
		 * @param {Date} date
		 * @returns {String} date reformatted to match parkHours Formatdate
		 */
		function getFormattedDate(date) {
			var year = date.getFullYear().toString();
			var month = (1 + date.getMonth()).toString();
			var day = date.getDate().toString();

			month = month.length > 1 ? month : '0' + month;
			day = day.length > 1 ? day : '0' + day;

			return year + month + day;
		}

		/**
		 * Starting with today's date, adds date object with no hours to parkHours object to display "Closed" for that day
		 * @param {Object[]} allParkHours ParkHours information
		 * @returns {null} no return; updates parkHours.Days with closed days
		 */
		service.fillInClosedDays = function(allParkHours) {
			var realDays = [];
			var today = service.getTodaysDate();
			var multipleFeeds = service.getHasAdditionalPark();
			var lastDate;
			var numberOfDays;
			var days;
			var currentIterationDay;
			var foundElement;
			var data;
			var i;

			// Set for comparison
			today.setHours(0, 0, 0, 0);

			// Ensures working with an Array
			realDays = Utilities.wrapObjectToArray(allParkHours.Days);
			realDays.sort(function ascendSortDates(a, b) {
				return a.FormatDate - b.FormatDate;
			});

			lastDate = new Date(getFormatDateToTime(realDays[realDays.length - 1].FormatDate));

			numberOfDays = Utilities.getNumberOfDaysBetweenTwoDays(today, lastDate);
			days = [];

			for (i = 0; i <= numberOfDays; i++) {
				currentIterationDay = new Date(today.getTime());
				currentIterationDay.setDate(currentIterationDay.getDate() + i);

				foundElement = getDayFromResponse(realDays, currentIterationDay);

				if (foundElement) {
					days.push(foundElement);
				} else {
					data = {
						Date: $filter('date')(currentIterationDay, AppData.settings.date_format || 'M/dd/yyyy'),
						FormatDate: getFormattedDate(currentIterationDay),
						ParkHours: ''
					};

					// Use Utilities.getBoolean to properly handle string "false" values from API
					// Only set HasWaterPark for filled-in days if at least one real day has water park hours configured
					const hasWaterParkInFeed = realDays.some(function(day) {
						return Utilities.getBoolean(day.HasWaterPark);
					});

					if (hasWaterParkInFeed) {
						data.HasWaterPark = true;
						data.WaterParkHours = '';
					}
					if (multipleFeeds) {
						data.HasAdditionalPark = true;
						data.AdditionalParkHours = '';
					}


					days.push(data);
				}
			}

			allParkHours.Days = days;
		};

		/**
		 * Check to see if date is in given array of dates
		 * @param {Object[]} array of parkHour days from getParkHours
		 * @param {Date} date of currentIteration day to check
		 * @returns {Boolean} true if date is found in days array
		 */
		function getDayFromResponse(days, date) {
			return days.find(function(ele) {
				return getFormatDateToTime(ele.FormatDate) === date.getTime();
			});
		}

		function setFeedName(feedIndex) {
			// Merchant name is the default feed name value
			if (angular.isDefined(AppData.settings.merchant_name)) {
				service.feedName = AppData.settings.merchant_name;
			}

			// Get the feed name from numbered application config if it exists
			var feedNameSetting = 'park_hours_' + (feedIndex + 1) + '_name';
			if (angular.isDefined(AppData.settings[ feedNameSetting ])) {
				service.feedName = AppData.settings[ feedNameSetting ];
			}
		}

		function parseDays(parkHours) {
			for (var key in parkHours.Days) {
				var dayObject = parkHours.Days[key];
				var day = { };

				day.date = Utilities.getDateByString(dayObject.Date);
				day.dateObj = new Date(dayObject.Date);
				day.requestMonth = day.dateObj.getMonth() + 1;
				day.parkHours = (angular.isDefined(dayObject.ParkHours) && dayObject.ParkHours !== 'Closed') ? dayObject.ParkHours : "";
				day.hasWaterPark = !!Utilities.getBoolean(dayObject.HasWaterPark);
				day.waterParkHours = (angular.isDefined(dayObject.WaterParkHours) && dayObject.WaterParkHours !== 'Closed') ? dayObject.WaterParkHours : "";
				day.hasAdditionalPark = !!Utilities.getBoolean(dayObject.HasAdditionalPark);
				day.additionalParkHours = dayObject.AdditionalParkHours || "";

				var d = angular.copy(day.dateObj);
				d.setHours(12);
				service.allowedDates.push(d.getTime());

				addToLoaded(day);

				if (angular.isUndefined(service.firstOperationalDate)) {
					service.firstOperationalDate = day.dateObj;
				}
			}
		}

		function addToLoaded(day) {
			var yearString = 'year' + day.dateObj.getFullYear();
			var monthString = service.months[ day.dateObj.getMonth() ];
			var dateString = day.date;

			if (angular.isUndefined(service.loadedDates[ yearString ])) {
				service.loadedDates[ yearString ] = { };
			}

			if (angular.isUndefined(service.loadedDates[ yearString ][ monthString ])) {
				service.loadedDates[ yearString ][ monthString ] = { };
			}

			service.loadedDates[ yearString ][ monthString ][ dateString ] = day;
		}

		return service;
	});

angular.module('app').service('PaymentService', function(
	$log,
	$q,
	UserInfo,
	$rootScope,
	Enums,
	RouteRejectionService,
	LegacyCart,
	AppData,
	BillingService,
	Utilities) {
	var service = {};

	service.initialize = function() {
		var cashBillingType;
		var initPromise = $q.defer();
		var routeToBilling = false;

		if (UserInfo.deliveryMethods.length === 0) {
			routeToBilling = true;
		}

		if (LegacyCart.total === '0.00' && parseFloat(UserInfo.shipping.deliveryAmount) < 0.01 && !Utilities.safelyCheckPropertyOnObject('LegacyCart.cartDetails.PAYMENT_SCHEDULE', LegacyCart)) {
			UserInfo.clearPaymentData(true);

			// All this payment data gets removed before we make a purchase call
			// Leaving in here because not sure of the impact with regards
			// to the rest of the billing flow.
			cashBillingType = BillingService.getCashBillingType();

			UserInfo.payment.valid = true;
			UserInfo.payment.type = Enums.paymentProvider.CASH;

			if (cashBillingType && cashBillingType.merchant_payment_type_ref_id) {
				/* eslint-disable camelcase */
				UserInfo.payment.merchant_payment_type_ref_id = cashBillingType.merchant_payment_type_ref_id;
				/* eslint-disable camelcase */
				UserInfo.payment.billingType = cashBillingType.billing_type;
				UserInfo.payment.authType = cashBillingType.auth_type;
			} else {
				UserInfo.payment.billingId = service.zeroDollarBillingId;
				UserInfo.payment.billingType = Enums.billingTypes.CASH;
				UserInfo.payment.authType = "CS";
			}

			UserInfo.set('payment', UserInfo.payment);

			routeToBilling = true;
		}

		initPromise.resolve();

		if (routeToBilling) {
			$rootScope.routeTo('/billingView');
		}

		return initPromise.promise;
	}

	service.alternatePaymentActions = [];


	/**
	 * This is a set of conditions that would warrant canceling the route and going back to the payment method selection screen
	 * Right now if the user refreshes the Order Review screen and they have a credit card, if they hit Purchase, they get a strange error message and then get routed back to Payment Method
	 * it would be better if in this condition, we just routed back to Payment method.  This was necessary especially for the partial payment case
	 */
	service.assessOrderReviewRouteForPartialPayments = function() {
		var partialPayments = UserInfo.get('partialPayments');

		if (partialPayments.length === 0 && UserInfo.partialPaymentsIndicator) {
			UserInfo.set('partialPaymentsIndicator', false);
			throw new RouteRejectionService.UnrecoverableException('/paymentMethod', {});
		} else {
			return true;
		}
	};

	/**
	 * Add an alternate PaymentMethod action when handling "selectingPaymentMethod" on our cart screen
	 * (to eventually encapsulate our billing payment methods into separate modules)
	 * @param paymentMethod
	 * @param route
	 */
	service.registerAlternatePaymentActions = function(paymentMethod, action) {
		service.alternatePaymentActions.push({
			paymentMethod: paymentMethod,
			doAction: action
		});
	}

	/**
	 * Deregister the Alternate Payment action
	 * @public
	 * @returns {undefined}
	 */
	service.deregisterAlternatePaymentAction = function(paymentMethod) {
		service.alternatePaymentActions = service.alternatePaymentActions.filter(function(action) {
			return action.paymentMethod !== paymentMethod;
		});
	}

	/**
	 * Check if a payment Method has a payment action
	 * @param paymentMethod
	 * @returns {*|T}
	 */
	service.getAlternatePaymentAction = function(paymentMethod) {
		return service.alternatePaymentActions.find(function(item) {
			return item.paymentMethod.toLowerCase() === paymentMethod.toLowerCase();
		});
	}

	service.routeToPaymentMethod = function() {
		$rootScope.routeTo(BillingService.useZeroDollarQuickCheckout() ? 'quick-checkout' : Enums.routes.PAYMENT_METHOD);
	}

	return service;
});

(function() {
	'use strict';

	angular
		.module('app')
		.service('ReservationService', ReservationService);

	/**
	 * @param {Service} $q The $q Service
	 * @param {Scope} $rootScope The $rootScope scope
	 * @param {Service} AppData The App Data Service
	 * @param {Service} Enums The Enums Service
	 * @param {Service} Language The Language Service
	 * @param {Service} Modal The Modal Service
	 * @param {Service} Package The Package Service
	 * @param {Service} Utilities The Utilities Service
	 * @constructor
	 * @ngInject
	 */
	function ReservationService($q, $rootScope, AppData, Enums, JSONValidator, Language, Modal, Package, Utilities) {
		/***********************
		 ** UTILITY FUNCTIONS **
		 ***********************/
		var checkProp = Utilities.checkProp;
		var getString = Utilities.getString;
		var getVal = Utilities.getFirstValue;
		var toSqlFormat = Utilities.javascriptDateToSQLDate;

		/*************
		 ** SERVICE **
		 *************/
		var service = {
			canCallPlaceReservation: canCallPlaceReservation,
			placeReservation: placeReservation,
			_: {
				buildCustomerTypeRequest: _buildCustomerTypeRequest,
				config: {},
				displayErrorModal: _displayErrorModal,
				initService: _initService,
				placeReservationEnabled: false
			},
		};

		// Do one-time initialize logic
		service._.initService();

		// Return the service
		return service;

		/********************
		 ** PUBLIC METHODS **
		 ********************/

		/**
		 * Checks to see if the given package has the place reservation charac
		 * @public
		 * @function
		 * @param {String} pkgId The package's id to check
		 * @returns {Boolean} true if it has the charac, false otherwise
		 */
		function canCallPlaceReservation(pkgId) {
			return service._.placeReservationEnabled && checkProp('pkg.CHARACS.reservation', Package.getPackageByID(pkgId));
		}

		/**
		 * Places a reservation of the specified package and customer types for a given cart
		 * @public
		 * @function
		 * @param {String} packageId The package ID
		 * @param {Object[]} customerTypes The customer type list to add to the request
		 * @param {Date|String} [startDate=Date<Now>] The start date
		 * @param {String} [startTime] The start time (if provided)
		 * @returns {Promise} Returns the promise for the call
		 */
		function placeReservation(packageId, customerTypes, startDate, startTime, modalCallback) {
			var defer = $q.defer()
			var request = {
				PS: [{
					P: [{
						CT: service._.buildCustomerTypeRequest(customerTypes),
						id: getString(packageId),
						start_date: angular.isString(startDate) ? startDate : toSqlFormat(startDate || new Date())
					}]
				}]
			};

			// Does the package not have the charac?
			if (!canCallPlaceReservation(packageId)) {
				// Return a resolved promise
				return $q.resolve();
			}

			// If start time was included, add it to the request
			if (startTime) {
				request.PS[0].P[0].start_time = getString(startTime);
			}

			/**
			 * Closure function to handle PlaceReservation call response
			 * Displays models if anything is wrong and calls callbacks if they are set.
			 * @private
			 * @function
			 * @param {Object} data The PlaceReservation data that is returned
			 * @returns {undefined}
			 */
			function checkForErrors(data) {
				var error = false;
				var statusCount;

				if (!data || data.status !== Enums.status.OK) {
					error = 'placeReservationDefault';
				} else if (data.has_error === '1') {
					statusCount = checkProp('data.PS.P.CT', data, ['wrapObjectToArray', true]);

					if (statusCount) {
						statusCount = statusCount.some(function checkCtIfFailed(ct) {
							return ct.status !== Enums.status.FAILED;
						});
					}

					error = statusCount ? 'placeReservationPartial' : 'placeReservationDefault';
				}

				if (error) {
					// Hide the spinner
					$rootScope.hideSpinner();

					// Display modal indicating that there was a failure of the PlaceReservation call
					service._.displayErrorModal(
						Language.getLocale('Alert', error + 'Title'),
						Language.getLocale('Alert', error),
						modalCallback
					);

					// Reject the promise
					return defer.reject(data);
				}

				// Resolve the promise
				defer.resolve(data);
			}

			// Submit the request
			AppData
				.fetch(Enums.services.PLACE_RESERVATION, false, request)
				.then(checkForErrors)
				.catch(checkForErrors);

			// Return a promise that can be chained
			return defer.promise;
		}

		/***********************
		 ** PROTECTED METHODS **
		 ***********************/

		/**
		 * Strips the surplus data and builds the customer type list for the request
		 * @protected
		 * @function
		 * @param {Object[]} customerTypes The customer type list
		 * @returns {Object} a new object of the customer type information that the request needed
		 */
		function _buildCustomerTypeRequest(customerTypes) {
			// Ensures we are dealing with an array
			customerTypes = Utilities.wrapObjectToArray(customerTypes, true);

			return customerTypes
				.map(function mapCustomerTypes(ct) {
					// Checks and pulls potential values that we can use
					return {
						id: getString(getVal(ct, 'id')) || getString(getVal(ct, 'customer_type')),
						qty: getString(getVal(ct, 'qty', 'DYNAMIC_PRICING.qty'))
					};
				})
				.filter(function filteForValidQuantities(ct) {
					// Converts qty to a number and checks to see if the value is greater than zero
					return +ct.qty > 0;
				});
		}

		/**
		 * Displays an Error Modal
		 * @protected
		 * @function
		 * @param {String} title The Modal Title
		 * @param {String} description The Modal Description
		 * @param {Function} callback The Callback Function to trigger once a guest makes a selection
		 * @returns {undefined}
		 */
		function _displayErrorModal(title, description, callback) {
			Modal.displayModal({
				action: 'Error',
				category: title + ' [Error]',
				description: description,
				label: title,
				title: title,
				icon: 'icon-info red',
				showCloseButton: false,
				buttonFlags: [Enums.buttonFlags.CANCEL, Enums.buttonFlags.CONTINUE_SHOPPING],
				callback: callback
			});
		}

		/**
		 * Initializes the service with one-time logic
		 * @protected
		 * @function
		 * @returns {undefined}
		 */
		function _initService() {
			// Grab configuration (if exists)
			if (checkProp('settings.reservation', AppData.settings) && JSONValidator.validate('reservation', AppData.settings.reservation)) {
				service._.config = JSON.parse(AppData.settings.reservation);

				// If the place reservation call should be enabled
				if (checkProp('reservation.place_reservation.enable', service._.config, 'getBoolean')) {
					service._.placeReservationEnabled = true;
				}
			}
		}
	}
})();
'use strict';

angular
	.module('app')
	.factory('ShippingService', function(
		AppData,
		CartService,
		LegacyCart,
		Enums,
		JSONValidator,
		Language,
		RouteRejectionService,
		UserInfo,
		Utilities,
		UtilsValidation,
		$rootScope,
		$location,
		$q
	) {
		var validString = UtilsValidation.validString,
			validArray = UtilsValidation.validArray;
		var safelyCheckPropertyOnObject = Utilities.safelyCheckPropertyOnObject,
			getBoolean = Utilities.getBoolean,
			safelyCheckPropertyOnObject = Utilities.safelyCheckPropertyOnObject;
		var service = {
			assessShippingMethods: assessShippingMethods,
			cartHasFolios: cartHasFolios,
			getDeliveryDescriptionSummaryByType: getDeliveryDescriptionSummaryByType,
			getShippingMethodOverrideLocale: getShippingMethodOverrideLocale,
			getUpdatedShippingMethodsForCurrentCart: getUpdatedShippingMethodsForCurrentCart,
			isNonPhysicalDeliveryMethod: isNonPhysicalDeliveryMethod
		};

		// Add all non physical delivery methods here. Default values are overwritten by config.
		service.nonisPhysicalDeliveryMethods = [
			'M', // Mobile
			'P', // Print at Home
			'Y', // Will Call
			'W', // Specific non-physical delivery methods
			'H',
			// 'T', WDW will be treated like a physical shipping method for Walt Disney for collecting guests info for pickup tickets
			'J',
			'O',
			'Q',
			'R'
		];
		service.shippingDisableRules = [];

		var alternatePostShippingActions = [];
		var listener = $rootScope.$on(Enums.services.APP_ACTIVATED, assessAppConfigForShippingConsiderations);

		service.assessSkipShippingView = assessSkipShippingView;

		/**
		 * Find out if this is a non physical delivery method
		 * @param {String} type The shipping type
		 * @returns {Boolean} if it is or not
		 */
		function isNonPhysicalDeliveryMethod(method) {
			method = validString(method) ? method.toLowerCase() : '';

			return service.nonisPhysicalDeliveryMethods.some(function(type) {
				return method === type.toLowerCase();
			});
		}

		/**
		 * Add an alternate post-shipping action after selecting shipping on the shipping view screen
		 * (to eventually encapsulate our shipping actions for billing types into separate modules)
		 * TODO: migrate other forms such as PayPal to use this flow
		 * @param paymentMethod
		 * @param {function} action
		 */
		service.registerAlternatePostShippingAction = function(paymentMethod, action) {
			alternatePostShippingActions.push({
				paymentMethod: paymentMethod,
				doAction: action
			});
		};

		/**
		 * Check if a payment Method has a post-shipping action
		 * @param paymentMethod
		 * @returns {*|T}
		 */
		service.getAlternatePostShippingAction = function(paymentMethod) {
			return alternatePostShippingActions.filter(function(item) {
				return item.paymentMethod === paymentMethod
			})[0];
		};

		/**
		 * Return the shipping methods that are allowable for the current cart
		 * @returns {Array.<*>}
		 */
		service.getShippingMethodsForCurrentCart = function() {
			return UserInfo.deliveryMethods.filter(function(method) {
				return !isShippingMethodRestrictedForCurrentCart(method);
			});
		};

		/**
		 * Assesses whether or not a shipping method is restricted for a current cart
		 * @return {boolean}
		 */
		function isShippingMethodRestrictedForCurrentCart(method) {
			var shouldRestrict = false;
			for (var i = 0; i < service.shippingDisableRules.length; i++) {
				var rule = service.shippingDisableRules[i];
				if (angular.isDefined(method) && rule.shipping_methods.indexOf(method.ship_method) > -1) {
					if (LegacyCart.doesCartContainItemWithCharac(rule.cart_item_charac_name, rule.cart_item_charac_value)) {
						shouldRestrict = true;
						break;
					}
				}
			}

			return shouldRestrict;
		}

		/**
		 * Call update cart checkout with the shipping choice so that the cart now accurately reflects what shipping decision was made
		 * This will help us have a more accurate depiction of the total the guest is required to pay on the cart so that for certain flows like 3DSecure,
		 * which occurs on our billing form, we have the accurate total amount with the shipping cost included to send to the payment processor for that flow
		 */
		service.updateCartCheckoutWithShippingChoice = function() {
			var updateCartCheckoutCall = $q.defer();

			$rootScope.showSpinner(Language.getLocale('ApplicationLabels', 'updatingCartLoadMsg'));

			var shippingInfo = UserInfo.get('shipping');
			var shipTotalOnCart = safelyCheckPropertyOnObject('LegacyCart.cartDetails.ship_total', LegacyCart) ? Number(LegacyCart.cartDetails.ship_total) : 0;
			var shipMethodOnCart = safelyCheckPropertyOnObject('LegacyCart.cartDetails.CART.ship_method', LegacyCart) ? LegacyCart.cartDetails.CART.ship_method : '';
			var currentShippingAmount = safelyCheckPropertyOnObject('shippingInfo.deliveryAmount', shippingInfo) ? Number(shippingInfo.deliveryAmount) : 0;
			var currentShippingMethod = safelyCheckPropertyOnObject('shippingInfo.deliveryMethod', shippingInfo) ? shippingInfo.deliveryMethod : '';
			var updateCartInfoMessage = {};
			var billingTypeMap;

			if ((shipTotalOnCart !== currentShippingAmount) || (validString(currentShippingMethod) && validString(shipMethodOnCart) && currentShippingMethod !== shipMethodOnCart)) {
				updateCartInfoMessage = {
					shippingAmount: shippingInfo.deliveryAmount,
					shippingMethod: shippingInfo.deliveryMethod
				}

				setBillingIdOrMerchantPaymentRefId(updateCartInfoMessage);

				//call update cart checkout info and just resolve the promise no matter what happens
				//an error will be shown once the billing is completed
				LegacyCart.callUpdateCartCheckoutInfo(updateCartInfoMessage, function() {
					return updateCartCheckoutCall.resolve()
				}, function() {
					return updateCartCheckoutCall.resolve()
				});
			} else {
				$rootScope.hideSpinner();
				//no need to make this call as the amounts are the same and the cart does not need to get updated with this info at this time
				updateCartCheckoutCall.resolve();
			}

			return updateCartCheckoutCall.promise;
		};

		/**
		 * Obtain a billing id for update cart checkout - this billing id cannot be blank so at the shipping step, we can just choose the first one.
		 * @returns {string}
		 */

		/**
		 * Obtain a billing id for update cart checkout - this billing id cannot be blank so at the shipping step, we can just choose the first one.
		 * @public
		 * @function
		 * @memberof {ShippingService}
		 * @name setBillingIdOrMerchantPaymentRefId
		 * @param {Object} message The message object to modify
		 * @return {undefined}
		 */
		function setBillingIdOrMerchantPaymentRefId(message) {
			/* eslint-disable camelcase */
			var payment = UserInfo.get('payment');
			var billingType;

			if (safelyCheckPropertyOnObject('payment.authType', payment, validString)) {
				//if we came here with a billing id (which we do with paypal shortcut), then use that
				if (safelyCheckPropertyOnObject('payment.billingId', payment) && payment.billingId) {
					message.billingId = payment.billingId;
					return;
				} else if (safelyCheckPropertyOnObject('payment.merchant_payment_type_ref_id', payment) && payment.merchant_payment_type_ref_id) {
					message.merchant_payment_type_ref_id = payment.merchant_payment_type_ref_id;
					return;
				}

				// retrieve the first matching billing type for the current defined auth type
				billingType = AppData.billingTypes.filter(function(item) {
					return item.auth_type === payment.authType
				})[0];
			} else {
				// grab first id just to have one from AppData billing types
				// ^--  this is so awful. why do we do this?
				billingType = AppData.billingTypes[0];
			}

			if (billingType.merchant_payment_type_ref_id) {
				message.merchant_payment_type_ref_id = billingType.merchant_payment_type_ref_id;
			} else {
				message.billingId = billingType.billing_id;
			}
			/* eslint-disable camelcase */
		}

		/**
		 * Assess the app config for shipping considerations (disabling of shipping methods for certain custom rules)
		 */
		function assessAppConfigForShippingConsiderations() {
			if (JSONValidator.validate('shipping_disable_rules', AppData.settings.shipping_disable_rules)) {
				service.shippingDisableRules = JSON.parse(AppData.settings.shipping_disable_rules);
			}

			if (JSONValidator.validate('shipment_overrides', AppData.settings.shipment_overrides)) {
				var config = JSON.parse(AppData.settings.shipment_overrides);

				for (var i = 0; i < config.length; i++) {
					if (service.nonisPhysicalDeliveryMethods.indexOf(config[i].shipment_override) > -1) {
						service.nonisPhysicalDeliveryMethods.push(config[i].shipment_method);
					} else if (service.nonisPhysicalDeliveryMethods.indexOf(config[i].shipment_method) > -1) {
						service.nonisPhysicalDeliveryMethods.splice(service.nonisPhysicalDeliveryMethods.indexOf(config[i].shipment_method), 1);
					}
				}
			}

			//turn off the listener
			listener();
		}

		/**
		 * Returns delivery method summary
		 * @param {String} type shipping method
		 * @returns {String} delivery summary
		 */
		function getDeliveryDescriptionSummaryByType(type) {
			var desc = '';

			for (var t in Enums.deliveryMethods) {
				if (Enums.deliveryMethods[t] === type) {
					if (Language.localeExists('ShippingView', type.toLowerCase() + 'Summary')) {
						desc = Language.getLocale('ShippingView', type.toLowerCase() + 'Summary');
					}
					break;
				}
			}

			return desc;
		}

		/**
		 * get the shipping method override locale and set it to the shipping method's desc property
		 * @public
		 * @function
		 * @name getShippingMethodOverrideLocale
		 * @memberof {ShippingCtrl}
		 * @param {Object} deliveryMethod that we are getting the overwritten locale for
		 * @param {Object} shippingLocaleOverrides config
		 * @param {String} type specifies the locale we are overriding
		 * @return {String} overwritten locale
		 */
		function getShippingMethodOverrideLocale(deliveryMethod, shippingLocaleOverrides, type) {
			var matchingOverride = shippingLocaleOverrides.overrides.filter(function(override) {
					return override.shipping_method == deliveryMethod;
				})[0],
				description = '';
			if (angular.isObject(matchingOverride)) {
				if (Language.localeExists(shippingLocaleOverrides.section, matchingOverride[type + '_target'])) {
					description = Language.getLocale(shippingLocaleOverrides.section, matchingOverride[type + '_target']);
				}
			}
			return description;
		}

		/**
		 * Check for app config/optins/shipping method, if all of those conditions are met,
		 * then skip shipping view
		 * @function
		 * @public
		 * @throws {RouteRejectionService.UnrecoverableException} throws exception to skip shipping
		 * @returns {Boolean} skip shipping boolean
		 */
		function assessSkipShippingView() {
			var shippingMethods = service.getShippingMethodsForCurrentCart(),
				hasOptins,
				disableSkipShippingConfig = JSONValidator.validate('disableSkipShippingPage', AppData.settings.disableSkipShippingPage),
				disableSkipFolioShippingConfig = JSONValidator.validate('disableSkipFolioShippingPage', AppData.settings.disableSkipFolioShippingPage),
				hasFolioUrlParam = validString($location.search().sfOffer);

			// Always skip delivery for membership upgrades, unless configured not to skip
			if ((hasFolioUrlParam || service.cartHasFolios()) && !disableSkipFolioShippingConfig) {
				UserInfo.set('shipping', {
					deliveryAmount: '0.00',
					deliveryMethod: 'P',
					isNonPhysicalDeliveryMethod: true
				});
				throw new RouteRejectionService.UnrecoverableException('/paymentMethod');
			}

			// Failfast if more than 1 shipping method or no app config added
			if (disableSkipShippingConfig
				|| !UtilsValidation.validArray(shippingMethods)
				|| shippingMethods.length > 1
				|| !service.isNonPhysicalDeliveryMethod(shippingMethods[0].ship_method)
			) {
				return;
			}

			if (Array.isArray(AppData.optins)) {
				hasOptins = AppData.optins.find(function(optin) {
					return optin.section === 'ShippingView';
				});
			}

			// Skip Shipping page when there is no optins
			if (!hasOptins) {
				UserInfo.set('shipping', {
					deliveryAmount: shippingMethods[0].price,
					deliveryMethod: shippingMethods[0].ship_method
				});
				throw new RouteRejectionService.UnrecoverableException('/paymentMethod');
			}
			return;
		}

		/**
		 * Assesses the shipping methods and sets the shipping method if there is only one
		 * @public
		 * @returns {undefined}
		 */
		function assessShippingMethods() {
			var shipping = CartService.getShipping();

			// If there is only one shipping method, set it
			if (shipping.length === 1) {
				// Set the shipping method
				UserInfo.set('shipping', {
					deliveryAmount: shipping[0].price,
					deliveryMethod: shipping[0].method,
				});
			}
		}

		/**
		 * Returns if cart has folios
		 * @public
		 * @returns {Boolean} true if cart has folio
		 */
		function cartHasFolios() {
			if (!safelyCheckPropertyOnObject('AppData.GetCartSummary.CART.ITEMS.ITEM', AppData, validArray)) {
				return false;
			}

			return AppData.GetCartSummary.CART.ITEMS.ITEM.some(function findFolioItem(cartItem) {
				var cartItemCharacs;
				if (!cartItem.CHARACS) {
					return false;
				}
				cartItemCharacs = Utilities.wrapObjectToArray(angular.copy(cartItem.CHARACS));
				return cartItemCharacs.some(function findFolioCharac(cartCharac) {
					return validString(cartCharac.folio_id);
				});
			});
		}

		/**
		 * Returns updated shipping methods (checks for international shipping)
		 * @public
		 * @param {Object} cartDetails current cart details from GetCartSummary
		 * @returns {Object[]} array of shipping methods
		 */
		function getUpdatedShippingMethodsForCurrentCart(cartDetails) {
			var shippingMethods = [],
				allowInternationalDelivery = false;
			UserInfo.shippingRequired(cartDetails);
			shippingMethods = service.getShippingMethodsForCurrentCart();

			if (JSONValidator.validate('allow_international_delivery', AppData.settings.allow_international_delivery)) {
				allowInternationalDelivery = getBoolean(AppData.settings.allow_international_delivery);
			} else if (safelyCheckPropertyOnObject('AppData.GetMerchantDetails.SHIPPINGMETHOD', AppData, validArray)) {
				allowInternationalDelivery = AppData.GetMerchantDetails.SHIPPINGMETHOD.some(function(shippingMethod) {
					return shippingMethod.ship_method.toLowerCase() === 'i';
				});
			}

			if (!allowInternationalDelivery) {
				return shippingMethods.filter(function(shippingMethod) {
					return shippingMethod.method.toLowerCase() !== 'i';
				});
			}
			return shippingMethods;
		}

		return service;
	});

angular
	.module('app')
	.service('Purchase', function(
		$log,
		$rootScope,
		$location,
		$q,
		$window,
		$injector,
		AppData,
		AgreementService,
		BillingService,
		errorTracking,
		CartDataService,
		ClientInfo,
		CustomActionService,
		DataModelService,
		Enums,
		ExtraFlow,
		Language,
		Modal,
		OrderService,
		RecaptchaV3Service,
		RouteRejectionService,
		Storage,
		Ticket,
		UserInfo,
		StringUtils,
		Utilities,
		AnalyticsDataLayerService,
		ProfileLoginSessionService,
		IDMeEnumsService,
		PostPurchaseActionsService,
		PayPalService,
		PaymentService,
		UtilsValidation,
		AuthService,
		AuthEnums
	) {
		var validArray = UtilsValidation.validArray,
			validString = UtilsValidation.validString,
			isRealObject = UtilsValidation.isRealObject,
			isEmptyObject = UtilsValidation.isEmptyObject,
			checkProp = Utilities.safelyCheckPropertyOnObject,
			pendingPurchase = false;

		var Purchase = {
			hasPendingPurchase: hasPendingPurchase
		};

		var alternatePurchaseActions = [];

		/**
		 * Do our checks to make sure we can purchase.
		 * @public
		 * @throws {UnrecoverableException} In the event we aren't in a good state
		 * @returns {Promise|undefined}
		 */
		Purchase.initialize = function() {
			var paypalSession = PayPalService.getPayPalSessionInfo() || {},
				savedPayment = UserInfo.payment || UserInfo.get('payment');

			if (savedPayment.authType !== Enums.authTypes.PAYPAL) {
				return;
			}

			if (!validString(paypalSession.paypalID) || !validString(paypalSession.token)) {
				['authType', 'auth_type', 'type', 'billingType'].forEach(function(key) {
					delete savedPayment[key];
				});
				UserInfo.payment = savedPayment;
				UserInfo.set('payment', savedPayment);
				throw new RouteRejectionService.UnrecoverableException('/cartView');
			}
		};

		/**
		 * Add agreement form data to the cart
		 * @param data
     */
		function addAgreementDataToCart(data) {
			var forms = [],
				paymentPlanForms = AgreementService.getCartFormData();
			customAgreementforms = AgreementService.getCustomFormData();

			if (angular.isDefined(paymentPlanForms) && paymentPlanForms !== null) {
				forms.push(paymentPlanForms);
			}

			if (angular.isDefined(customAgreementforms) && customAgreementforms !== null) {
				customAgreementforms.forEach(function(customform) {
					forms.push(customform);
				})
			}

			if (forms.length > 0) {
				data.FORMS = { FORM: forms };
			}

			//ExtraData is not needed for Purchase call - deleting it after passing birthDate info into CUSTOMER node
			if (Utilities.safelyCheckPropertyOnObject('paymentPlanForms.extraData.birthDate', paymentPlanForms)) {
				var parsedDate = Utilities.formatSetDateFormatToYYYY_MM_DD(paymentPlanForms.extraData.birthDate, 'MM/dd/yyyy');
				data.CUSTOMER.birth_date = parsedDate;
				delete paymentPlanForms.extraData;
			}
		}

		/**
		 * An array to track conditions for certain payment fields that may not need to be verified during Purchase.executePurchase
		 * (fields tracked are cvv2, expire_date, account_number)
		 * @type {Array}
		 */
		var noVerifyBeforePurchaseConditions = [];

		/**
		 * Ability to register a paymentMethod and a field that does NOT need to be in required format to send to Backend
		 * @param paymentMethod
		 * @param field
		 */
		Purchase.registerNoVerifyBeforePurchaseCondition = function(paymentMethod, field) {
			noVerifyBeforePurchaseConditions.push({
				paymentMethod: paymentMethod,
				field: field
			});
		}

		/**
		 * Method to return whether or not we should skip field for validation
		 * @param paymentMethod
		 * @param field
		 * @returns {boolean}
		 */
		Purchase.shouldSkipVerificationForField = function(paymentMethod, field) {
			return noVerifyBeforePurchaseConditions.filter(function(condition) {
				return condition.paymentMethod == paymentMethod && condition.field == field;
			}).length === 1;
		}

		function sanitizePurchaseV2() {
			// If this is a headless store, we do not want to perform sanitization as the client has done everything through the headless API.
			if ($rootScope.headlessMode) {
				return true;
			}
			// TODO: Re-factor into separate functions.

			/*
				1. Iterate through all the items in the cart and collect the package ID
				2. Iterate through the package list and grab each of those packages
				3. Check if the package has special requirements (extra movie, package CHARAC, etc)
					3.1 XMCs
					3.2 Alternate Flow Module
						3.2.1 Check keyword against navigation
					3.3 TODO: Add package CHARAC check
				4. If special requirements are set on the package, inspect items on the cart meet those requirements
			*/

			if (!AppData.settings.disableSanitizationOnCartScreen || !Utilities.childDefined(AppData, 'GetMerchantPackageList.PS.P')) {
				return true;
			}


			var sanitize = true,
				cartItem,
				cartSummary = CartDataService.getLastSummary(),
				packageItem,
				cartItemCharacs,
				cartItemCharacItem,
				packageXMCs,
				cartItemCharacs,
				cartItemCharacXMCs,
				xmcSettings,
				keywordList,
				alternateFlowSettings,
				menuItem,
				menuItemKeywords,
				subMenuKeywords,
				alternateModule,
				subMenu,
				subMenuItem;

			for (var i = 0; i < cartSummary.cart.items.length; i++) {
				cartItem = cartSummary.cart.items[i];

				for (var j = 0; j < AppData.GetMerchantPackageList.PS.P.length; j++) {
					packageItem = AppData.GetMerchantPackageList.PS.P[ j ];
					keywordList = (packageItem.keyword) ? packageItem.keyword.split(', ').join().split(',') : [];

					if (packageItem.id === cartItem.package.id) {
						if (packageItem.extra_movie) {
							// Get list of XMCs. Only extract enabled XMCs.
							var enabledXFCS = ExtraFlow.getEnabledXFCsFromList(packageItem.extra_movie, true);
							packageXMCs = enabledXFCS ? enabledXFCS.split(',') : [];
							cartItemCharacs = cartItem.characs;

							if (cartItemCharacs[0].hasOwnProperty("group_uuid")) {
								continue;
							}

							if (cartItemCharacs.length === cartItem.info.qty) {
								// For each CHARAC item...
								for (var k = 0; k < cartItemCharacs.length; k++) {
									cartItemCharacItem = cartItemCharacs[ k ];

									// If the cart item charac has a property called client_xfc_name, get the list (1 or more) or create an empty list.
									cartItemCharacXMCs = (cartItemCharacItem.client_xfc_name) ? cartItemCharacItem.client_xfc_name.split(', ').join().split(',') : [];

									// Verify that the package contains the same number of XMCs as the item in the cart has passed through.
									// i.e. if the package specifies it requires two XMC, the cart item should note that it passed through those XMCs.
									if (packageXMCs.length === cartItemCharacXMCs.length) {
										// We have the same number of XMCs on the cart item CHARAC as we do on the package item.
										// NOTE: That we only count the enabled XMCs on package item.
										// Ensure the list is the same for cart items and package XMCs.
										var pkgXMCList = packageXMCs.sort().join(',');
										var cartXMCList = cartItemCharacXMCs.sort().join(',');
										if (cartXMCList.toLowerCase() === pkgXMCList.toLowerCase()) {
											// Solid list. Now let's ensure the proper CHARACs exist for each type of XMC.
											for (var m = 0; m < packageXMCs.length; m++) {
												xmcSettings = ExtraFlow[ packageXMCs[ m ] ];
												if (xmcSettings) {
													if (xmcSettings.characsList && xmcSettings.characsList.length) {
														// For each item in the CHARAC list...
														for (var n = 0; n < xmcSettings.characsList.length; n++) {
															// Ensure CHARAC property exists on the CHARAC.
															if (typeof(cartItemCharacItem[ xmcSettings.characsList[ n ] ]) == 'undefined' || !validString(cartItemCharacItem[xmcSettings.characsList[n]])) {
																cartItem.sanitized = -1;
																errorTracking.breadcrumb('SanitizePurchaseV2: missing charac: ' + xmcSettings.characsList[n]);
																$log.error('Missing charac/charac value: ' + xmcSettings.characsList[n]);
																sanitize = false;
															}
														}
													}
												} else {
													errorTracking.breadcrumb('SanitizePurchaseV2: missing XMC settings: ' + packageXMCs[m]);
													// XMC has no settings - meaning it's not a real XMC.
													// Should never hit this line.
													cartItem.sanitized = -1;
													sanitize = false;
												}
											}
										} else {
											errorTracking.breadcrumb('SanitizePurchaseV2: list not the same');
											// The list is not the same.
											cartItem.sanitized = -1;
											sanitize = false;
										}
									} else {
										errorTracking.breadcrumb('SanitizePurchaseV2: xmc dont match');
										// Ohh Shhh... Discrepancy between cart item XMC list and package item XMC list...
										cartItem.sanitized = -1;
										sanitize = false;
										$log.error('XMCs do not match');
										$log.info('Package XMCs:');
										$log.info(packageXMCs);
										$log.info('Cart XMCs:');
										$log.info(cartItemCharacXMCs);
									}
								}
							} else {
								errorTracking.breadcrumb('SanitizePurchaseV2: charac list != definition list');
								// Nothing to see here. This item does not have the proper amount of CHARACS.
								cartItem.sanitized = -1;
								sanitize = false;
								$log.error('Cart Item Characs List != XFC Charac Definition List')
							}
						}

						// For each keyword in the package...
						for (var o = 0; o < keywordList.length; o++) {
							alternateModule = undefined;
							// For each menu item in the menu...
							for (var p = 0; p < AppData.menuItems.length; p++) {
								var menuItem = AppData.menuItems[ p ];
								if (menuItem.isactive) {
									menuItemKeywords = menuItem.keywords.split(', ').join().split(',');

									for (var q = 0; q < menuItemKeywords.length; q++) {
										if (keywordList[ o ] === menuItemKeywords[ q ]) {
											alternateModule = menuItem.alternateModule || '';
											break;
										}
									}

									if (alternateModule) {
										break;
									}

									// If alternateModule is not defined, see if it's in the sub-menu.
									subMenu = menuItem.MENUITEM || [];
									if (subMenu.length) {
										// For each sub-menu item in the menu...
										for (var q = 0; q < subMenu.length; q++) {
											subMenuItem = subMenu[ q ];
											if (subMenuItem.isactive && subMenuItem.alternateModule) {
												subMenuKeywords = subMenuItem.keywords.split(', ').join().split(',');
												for (var r = 0; r < subMenuKeywords.length; r++) {
													if (keywordList[ o ] === subMenuKeywords[ r ]) {
														alternateModule = subMenu.alternateModule || '';
														break;
													}
												}
											}

											if (alternateModule) {
												break;
											}
										}
									}

									if (alternateModule) {
										break;
									}
								}

								if (alternateModule) {
									break;
								}
							}
						}

						if (alternateModule) {
							// This item has alternate module. Get the CHARACS from the settings.
							alternateFlowSettings = ExtraFlow.getAlternateFlowSettings(alternateModule);
							if (alternateFlowSettings) {
								cartItemCharacs = cartItem.characs;

								if (cartItemCharacs.length === cartItem.info.qty) {
									// For each CHARAC item...
									for (var s = 0; s < cartItemCharacs.length; s++) {
										cartItemCharacItem = cartItemCharacs[ s ];

										if (alternateFlowSettings.characsList && alternateFlowSettings.characsList.length) {
											// For each item in the CHARAC list...
											for (var t = 0; t < alternateFlowSettings.characsList.length; t++) {
												// Ensure CHARAC property exists on the CHARAC.
												if (typeof(cartItemCharacItem[ alternateFlowSettings.characsList[ t ] ]) == 'undefined') {
													cartItem.sanitized = -1;
													errorTracking.breadcrumb('SanitizePurchaseV2: alternate flow charac missing');
													sanitize = false;
												}
											}
										}
									}
								} else {
									errorTracking.breadcrumb('SanitizePurchaseV2: alternate flow charac amount');
									// Nothing to see here. This item does not have the proper amount of CHARACS.
									cartItem.sanitized = -1;
									sanitize = false;
									$log.error('Item does not have the proper amount of CHARACS');
								}
							}
						}

						// If we have a match, no need to examine the packages further.
						// Proceed with the next cart item.
						break;
					}
				}
			}

			// Remove all cart items that did not pass sanitation.
			for (var i = 0; i < cartSummary.cart.items.length; i++) {
				cartItem = cartSummary.cart.items[i];
				if (cartItem.sanitized === -1) {
					cartSummary.cart.items.splice(i, 1);
				}

				delete cartItem.sanitized;
			}

			// if sanitize is false, return items to be updated in the cart, otherwise return true
			return sanitize ? true : cartSummary.cart.items;
		}

		function setOptIns(object, array) {
			var optProp;
			var value;
			if (array.optins) {
				for (var i = 0; i < array.optins.length; i++) {
					optProp = 'opt_in';
					if (i > 0) {
						optProp += String(i + 1);
					}
					object[optProp] = (array.optins[i].checked) ? 1 : 0;
					if (validString(array.optins[i].customer_purchase_property)) {
						optProp = array.optins[i].customer_purchase_property;
						value = array.optins[i].dataCollectionValue;

						if (array.optins[i].data_collection === 'date' && validString(value)) {
							value = Utilities.formatSetDateFormatToYYYY_MM_DD(value, AppData.settings.date_format);
							object[optProp] = value;
						}
					} else if (array.optins[i].data_collection === 'phone' && array.optins[i].checked && array.optins[i].optinPhoneNumber !== "") {
						value = array.optins[i].optinPhoneCountryCode + array.optins[i].optinPhoneNumber;
						if (validString(value)) {
							object['sms_mkt_phone'] = value;
						}
					}
				}
			}
		}

		/**
		 * Method to clear previous cart data
		 */
		Purchase.cleanupPreviousCart = function() {
			// Performing clean up of data in localStorage.
			AppData.Storage.remove('SetExpressCheckout');
			AppData.Storage.remove('SetPayPalStatus');
			AppData.Storage.remove('GetExpressCheckoutDetails');
			AppData.Storage.remove('UpdateCartCheckoutInfo');
			AppData.Storage.remove('paypalSessionInfo');
			AppData.Storage.remove('_geolocationPosition');
			AppData.Storage.remove('_geolocationError');
			AppData.Storage.remove('_geolocationSwap');
			AppData.Storage.remove('_UserInfo');
			AppData.Storage.remove('GetCartSummary');

			AppData.Storage.remove('_deliveryMethods');
			AgreementService.clearDataModel();
			AgreementService.clearCartFormData(true);
			AgreementService.clearCustomFormData(true);
			AppData.Storage.remove('_cartDetails');
			AppData.Storage.remove('_cartTotal');
			AppData.Storage.remove('_savedBilling');
			AppData.Storage.remove('_savedShipping');
			AppData.Storage.remove('_savedPayment');

			AppData.Storage.remove('_billingType');

			AppData.Storage.remove(IDMeEnumsService.tokens.OAUTH);
			AppData.Storage.remove(IDMeEnumsService.tokens.PREVIOUS_STATE);

			if (CustomActionService.actionRegistered(IDMeEnumsService.actions.CLEAR_AUTH)) {
				CustomActionService.executeCustomAction(IDMeEnumsService.actions.CLEAR_AUTH);
			}

			PayPalService.resetPayPalSession();
			UserInfo.destroy();

			UserInfo.set('billing', {});
			UserInfo.set('shipping', {});
			UserInfo.set('cartView', {});
			UserInfo.set('agreements', {});
			UserInfo.clearPartialPaymentData();
			UserInfo.clearPaymentData(true);

			// using the following, `fetch(requestType, true, false, true)` will say to useStorage, and replace the data in storage, but not make a request directly, only listen.

			CartDataService.fetchCartSummary();
		}

		function displayAppStoreModal() {
			// Save in $rooScope to make it accessible in the menu.
			$rootScope.appStoreURL = getAppStoreURL();

			if ($rootScope.appStoreURL) {
				Modal.displayModal
				(
					{
						category: 'Cart [App Store Link]',
						action: 'Modal View',
						label: 'Display App Store Link',
						title: Language.getLocale('Alert', 'appStoreMessageTitle'),
						description: Language.getLocale('Alert', 'appStoreMessage'),
						buttonFlags: [Enums.buttonFlags.OK, Enums.buttonFlags.NO],
						callback: function(detail) {
							if (detail == Enums.buttonFlags.OK) {
								Utilities.openAppStore($rootScope.appStoreURL);
							}
						 }
					}
				);
			}
		}

		function getAppStoreURL() {
			// OS Name Required - or show nothing.
			var osName = ClientInfo.osName;
			var appStoreURLS = Utilities.childDefined(AppData, 'GetApplicationConsolidated.SETTINGS.app_store_urls')
				? JSON.parse(AppData.GetApplicationConsolidated.SETTINGS.app_store_urls)
				: null;

			if (!ClientInfo.osName || !appStoreURLS) {
				return '';
			}

			// Lowercase after we've verified not null.
			osName = osName.toLowerCase();

			if (osName.indexOf('mac') > -1 || osName.indexOf('ios') > -1) {
				return appStoreURLS.apple;
			} else if (osName.indexOf('windows') > -1) {
				return appStoreURLS.windows;
			} else if (osName.indexOf('android') > -1) {
				return appStoreURLS.android;
			}

			return '';
		}

		function gatherPurchaseDetails(excludeSecAcctInfo, isForSavePurchase) {
			/* eslint-disable camelcase */
			var purchaseErrorMessages = [];
			var StoredPaymentsCollectionService;

			var cartSummary = CartDataService.getLastSummary();
			var cartTotal = angular.isNumber(cartSummary.pricing.total) ? cartSummary.pricing.total : Storage.get('_cartTotal');
			var savedPayment = UserInfo.payment ? UserInfo.payment : UserInfo.get('payment');
			var secAcctInfo = UserInfo.secAcctInfo;
			var adyenEncryptedCardInfo = secAcctInfo.adyenEncryptedCardInfo;
			var billingProviderInfo = (UserInfo.get('payment') || {}).billingProviderId;
			var savedBilling = UserInfo.localStorage.billing || {};
			var savedCartView = UserInfo.localStorage.cartView || {};
			var sanitized;
			// Remove all non-digits from phone (should only apply to SF currently)
			if (Utilities.safelyCheckPropertyOnObject('phone', savedBilling)) {
				savedBilling.phone = StringUtils.formatPhoneNumber(savedBilling.phone);
			}
			var savedMethod = UserInfo.localStorage.billingType || {};
			var savedShipping = UserInfo.localStorage.shipping || {};
			// Remove all non-digits from phone (should only apply to SF currently)
			if (Utilities.safelyCheckPropertyOnObject('phone', savedShipping)) {
				savedShipping.phone = StringUtils.formatPhoneNumber(savedShipping.phone);
			}

			var payment = {};
			var donation = UserInfo.get('donation');
			var insurance = UserInfo.get('insurance');
			if (savedPayment.merchant_payment_type_ref_id) {
				payment.merchant_payment_type_ref_id = savedPayment.merchant_payment_type_ref_id;
			} else {
				payment.billing_id = savedPayment.billingId;
			}

			if (angular.isNumber(cartSummary.pricing.currentDue) && validArray(cartSummary.paymentSchedule.schedule)) {
				// Override the total amount due with the payment plan amount
				cartTotal = cartSummary.pricing.currentDue;
			}

			// The value from here is related to the response from GetExpressCheckoutDetails.
			var paypalSession = PayPalService.getPayPalSessionInfo() || {};

			var customer =
			{
				f_name: savedBilling.firstName,
				m_name: '',
				l_name: savedBilling.lastName,
				mobile_phone: '',
				email: savedBilling.email
			};

			if (validString(customer.email)) {
				customer.email = customer.email.replace(/ /g, '');
			}

			if (savedBilling.phone) {
				customer.phone = savedBilling.phone;
			} else {
				customer.phone = '5555551234'; //Adding dummy phone number
				try {
					errorTracking.notify('Missing required information', 'Missing customer phone number in saved Billing Info', {
					  tags: {
						 session_id: AppData.cart.session_id,
						 merchant: AppData.merchant,
						 environment: AppData.environment,
						 billing_id: payment.billing_id,
						 merchant_payment_type_ref_id: payment.merchant_payment_type_ref_id
					  }
					});
				} catch (ignore) {}
			}
			if (savedBilling.countryCode) {
				customer.country_code = savedBilling.countryCode;
			}
			setOptIns(customer, savedBilling);
			setOptIns(customer, savedShipping);
			setOptIns(customer, savedCartView);

			// Billing Address.
			var address =
			{
				street1: savedBilling.address,
				street2: savedBilling.address2,
				city: savedBilling.city,
				state: savedBilling.state,
				zip: savedBilling.zip,
				country: savedBilling.country,
				type: Enums.addressTypes.BILLING
			};

			// Save the shipping address information if it's a physical delivery.
			var shippingAddress;
			if (savedShipping && savedShipping.isNonPhysicalDeliveryMethod === false) {
				shippingAddress =
				{
					street1: savedShipping.address,
					street2: savedShipping.address2,
					city: savedShipping.city,
					state: savedShipping.state,
					zip: savedShipping.zip,
					country: savedShipping.country,
					type: Enums.addressTypes.SHIPPING
				};

				customer.ship_f_name = savedShipping.firstName;
				customer.ship_m_name = '';
				customer.ship_l_name = savedShipping.lastName;
			}

			if (shouldDisableReceiptEmail()) {
				customer.disable_receipt_email = 1;
			}

			// Note year is first and month has to be two digits e.g Jan 2015 = 1501.
			if (savedPayment.isAccessoPayPayment) {
				errorTracking.breadcrumb('accesso Pay: Gather: set payment')
				angular.extend(payment, {
					accessoPay: 'true',
					amount: angular.isNumber(savedPayment.paymentAmount) ? savedPayment.paymentAmount : cartTotal.toFixed(2),
					cardholder_name: savedBilling.lastName + ', ' + savedBilling.firstName,
					cepay_merchant_id: savedPayment.paymentMerchantId,
					paymentReference: savedPayment.paymentReference,
					paymentMerchantId: savedPayment.paymentMerchantId,
					paymentMethodCode: savedPayment.paymentMethodCode,
					paymentProviderName: savedPayment.paymentProviderName,
					rawCardBrand: savedPayment.rawCardBrand
				});
				if (savedPayment.donationAmount) {
					angular.extend(payment, {
						donationAmount: savedPayment.donationAmount,
						donationStatus: savedPayment.donationStatus,
						splitDonation: savedPayment.splitDonation
					});
				}
				if (savedPayment.premiumAmount) {
					angular.extend(payment, {
						premiumAmount: savedPayment.premiumAmount,
						insuranceStatus: savedPayment.insuranceStatus,
						splitInsurance: savedPayment.splitInsurance
					});
				}
			} else if (!BillingService.isCardCaptureAuthType(savedPayment.authType)) {
				//if the auth type is NOT a card capture auth type - use the minimal data we have to populate the payment object
				angular.extend(payment, {
					amount: cartTotal,
					auth_type: savedPayment.authType,
					billing_type: savedPayment.billingType,
					cepay_merchant_id: savedPayment.cepayMerchantId
				});
			} else if (savedPayment.authType == Enums.billingTypes.CASH) {
				angular.extend(payment, {
					amount: cartTotal,
					auth_type: savedMethod.auth_type,
					billing_type: savedMethod.billing_type
				});
			} else {
				angular.extend(payment, {
					cvv2: (angular.isDefined(secAcctInfo.securityCode) && !excludeSecAcctInfo) ? secAcctInfo.securityCode : '',
					cvn: (angular.isDefined(secAcctInfo.securityCode) && !excludeSecAcctInfo) ? secAcctInfo.securityCode : '',
					card_expire_date: (angular.isDefined(savedPayment.cardExpirationDate) && !excludeSecAcctInfo) ? savedPayment.cardExpirationDate : '',
					exp_date_full_year: (angular.isDefined(savedPayment.cardExpirationDateFullYear) && !excludeSecAcctInfo) ? savedPayment.cardExpirationDateFullYear : '',
					account_number: (angular.isDefined(secAcctInfo.account) && !excludeSecAcctInfo) ? secAcctInfo.account : '',
					billing_type: savedPayment.billingType,
					auth_type: savedPayment.authType,
					cepay_merchant_id: savedPayment.cepayMerchantId,
					cardholder_name: savedBilling.lastName + ', ' + savedBilling.firstName,
					amount: cartTotal
				});

				if (savedPayment.adyen_save_card && savedPayment.store_payment_method && validString(UserInfo.identity_uuid)) {
					payment.identity_uuid = UserInfo.identity_uuid;
					// cePay expects 'Y' as they only accept it for truthy values
					payment.adyen_save_card = 'Y';
					payment.store_payment_method = '1';
					try {
						StoredPaymentsCollectionService = $injector.get('StoredPaymentsCollectionService');
						if (StoredPaymentsCollectionService) {
						  PostPurchaseActionsService.registerAction(StoredPaymentsCollectionService.initialize);
						}
					} catch (err) {
						$log.error('StoredPaymentsCollectionService not found. Post Purchase action cannot be registered.');
					}
				}

				if (!CustomActionService.executeCustomAction('GatherPurchaseDetailsPaymentNodeFormulation', undefined, [payment, purchaseErrorMessages, savedPayment]) &&
					savedPayment.authType === Enums.billingTypes.CREDITCARD) {
					// If it's a CC payment, validate items...
					// TODO: Find the source to why some of these fields are missing as per
					// TT 18698  https://app.getsentry.com/accesso-1/shopland-v5/group/25383294/

					if (!excludeSecAcctInfo) {
					 if (!payment.card_expire_date && !Purchase.shouldSkipVerificationForField(savedPayment.type, 'card_expire_date') && !adyenEncryptedCardInfo) {
							pushErrorMessage(purchaseErrorMessages, Language.getLocale('Purchase', 'missingExp'));
					 }

					 if (!payment.account_number && (!Purchase.shouldSkipVerificationForField(savedPayment.type, 'account_number') && !secAcctInfo.cyberSourceToken && !adyenEncryptedCardInfo)) {
							pushErrorMessage(purchaseErrorMessages, Language.getLocale('Purchase', 'missingAcctNumber'));
					 }

					 if ((!payment.cvv2 || payment.cvv2 === 'null') && savedPayment.cvvRequired && !Purchase.shouldSkipVerificationForField(savedPayment.type, 'cvv2') && !adyenEncryptedCardInfo) {
							pushErrorMessage(purchaseErrorMessages, Language.getLocale('Purchase', 'missingCVV'));
					 }

					 /*
					  * AXO 185 - Failsafe for Orders missing billing address
					  * Currently only applied to Credit Card purchases
					 */
					 if ((angular.isUndefined(savedBilling.address) || savedBilling.address.length === 0) && !BillingService.isOptionalField('address', payment.auth_type)) {
					 	pushErrorMessage(purchaseErrorMessages, Language.getLocale('Purchase', 'missingBillingInformation'));
					 }
					}

					if (isNaN(payment.amount)) {
						pushErrorMessage(purchaseErrorMessages, Language.getLocale('Purchase', 'missingAmount'));
					}
				}
			}

			// If using a CyberSource token (Credit Card, ApplePay, etc)
			if (isRealObject(secAcctInfo.cyberSourceToken)) {
				payment.token_response = JSON.stringify(secAcctInfo.cyberSourceToken);
			} else if (isRealObject(adyenEncryptedCardInfo) && !isEmptyObject(adyenEncryptedCardInfo)) {
				payment.token_response = JSON.stringify(adyenEncryptedCardInfo);
			}

			// Reseller Account
			// Add the account number to the payment node
			if (savedPayment.authType === Enums.billingTypes.ACCOUNT) {
				payment.account_number = secAcctInfo.account;
				if (!payment.account_number) {
					pushErrorMessage(purchaseErrorMessages, Language.getLocale('Purchase', 'missingAcctNumber'));
				}
			}

			//check to ensure we have pertinent billing information
			if (!shouldDisableBillingDemographicsCheck() && missingBillingInformation(savedBilling)) {
				pushErrorMessage(purchaseErrorMessages, Language.getLocale('Purchase', 'missingBillingInformation'));
			}

			if (angular.isDefined(savedPayment.billingProviderId) || billingProviderInfo) {
				payment.billing_provider_id = savedPayment.billingProviderId || billingProviderInfo;
			}

			if (angular.isDefined(savedPayment.payment_route)) {
				payment.payment_route = savedPayment.payment_route;
			}

			if (purchaseErrorMessages.length) {
				// Some errors were found. Display message.
				displayErrorMessages(purchaseErrorMessages, Language.getLocale('Alert', 'purchaseErrorListTitle'), Language.getLocale('Alert', 'purchaseErrorListMsg'), routeBackToBilling);
				errorTracking.notify('Purchase Error: One or more errors occured while trying to gather purchase details.', {
					purchase_errors: {
						errors: purchaseErrorMessages
					}
				});
				return null;
			}

			if (typeof savedPayment.auth_id != 'undefined') {
				payment.auth_id = savedPayment.auth_id;
			}

			if (typeof savedPayment.pares_message != 'undefined') {
				payment.pares_message = savedPayment.pares_message;
			}

			// Get cart adjustments.
			var cartAdj = cartSummary.adjustments;

			// Get CHARACS.
			var characs = [];

			// Adding an order charac for a Unified Design order
			characs.push({ unified_design_order: 'true' });

			//
			// For SixFlags we pass in two custom variables that may or may not be present
			// on the window object.
			//
			AnalyticsDataLayerService.dataLayerObjectsToCharacs(characs);

			//For AAA transform ui to member_ui charac to order characs
			var uiCharac = characs.filter(function(charac) {
				return angular.isDefined(charac.ui);
			})[0];

			if (angular.isDefined(uiCharac)) {
				characs.push({ member_ui: uiCharac.ui });
			}

			// Add the Voucher ID as an order charac
			var voucherId = savedBilling.voucherId;
			if (angular.isDefined(voucherId)) {
				characs.push({ voucher_id: voucherId });
			}

			if (shouldResellerDisableReceiptPrices()) {
				characs.push({ receipt_disable_prices: 1 });
			}

			// Nest address in customer object.
			// If address fields are not hidden for this billing type, then we set Customer node
			// otherwise, only set this node when shipping address available
			if (!BillingService.hideAddressFieldsCheck(savedPayment.authType)) {
				customer.ADDRESS = shippingAddress ? [address, shippingAddress] : address;
			} else if (shippingAddress) {
				customer.ADDRESS = shippingAddress;
			}

			var env = JSON.parse(JSON.stringify(ClientInfo));

			env.resolution = env.document_size.height +"x" +env.document_size.width;
			env.browser = env.browserName + " " + env.browserVersion;
			env.software = "V5";
			env.os = env.osName +" "+ env.osVersion;

			// Adding order characs for navTreeVersion
			characs.push(
				{ nav_tree_version: AppData.navTreeVersion.version },
				{ nav_tree_desc: AppData.navTreeVersion.desc }
			);

			// Track accessoID auth state for MCE receipt application (only when merchant has accessoID configured)
			if (AuthService.isAccessoIdConfigured()) {
				characs.push({
					accesso_id_auth_state: AuthService.isAuthenticated() ? AuthEnums.type.ACCESSO_ID : AuthEnums.type.ANON
				});
			}

			// Finalize the data and make purchase request.
			// @TODO: Replace hardcoded stuff.
			var shipping_method = savedShipping.deliveryMethod || savedPayment.shipMethod;
			var shipping_amount = savedShipping.deliveryAmount || savedPayment.shipAmount || 0;

			if (UserInfo.get('partialPayments').length > 0) {
				payment = convertPaymentObjectToList(payment);
			}

			CustomActionService.executeCustomActionChain(CustomActionService.ACTIONS_ENUMS.GATHER_PURCHASE_DETAILS_CUSTOMER_NODE, null, [savedMethod, customer]);

			var message = {
				ship_method: shipping_method,
				ship_amount: shipping_amount,
				tax_amount: cartSummary.pricing.taxTotal,
				order_amount: cartSummary.pricing.total,
				fee_total: cartSummary.pricing.fee,
				tiny_response: 0,
				software: ClientInfo.software,
				CUSTOMER: customer,
				PAYMENT: payment,
				CHARACS: characs,
				ENVIRONMENT: env
			};

			if (CustomActionService.actionRegistered(CustomActionService.ACTIONS_ENUMS.FOLIO_MEMBERSHIP_UPGRADE)) {
				var tempPaymentObj = CustomActionService.executeCustomAction(CustomActionService.ACTIONS_ENUMS.FOLIO_MEMBERSHIP_UPGRADE, message.PAYMENT);
				if (validArray(tempPaymentObj)) {
					message.PAYMENT = tempPaymentObj;
				}

				message.is_membership_upgrade = 1;
			}

			if (shouldDeletePayment()) {
				delete message.PAYMENT;
			}

			if (donation) {
				donation.splitDonation = Utilities.getString(donation.splitDonation);
				message.DONATION = donation;
			}
			if (insurance) {
				insurance.splitInsurance = Utilities.getString(insurance.splitInsurance);
				message.INSURANCE = insurance;
			}

			var profile = ProfileLoginSessionService.getCurrentLoggedInProfile();
			if (Utilities.safelyCheckPropertyOnObject('profile.customer_id', profile)) {
				message.customer_id = profile.customer_id;
			}

			// Paypal
			if (paypalSession && paypalSession.paypalID && paypalSession.token) {
				message.PAYPAL_INFO = {
					token: paypalSession.token,
					paypal_id: paypalSession.paypalID
				};
			}

			// Delete any unwanted properties from ENVIRONMENT.
			delete message.ENVIRONMENT.currentPage;
			delete message.ENVIRONMENT.previousPage;
			delete message.ENVIRONMENT.previousPages;
			delete message.ENVIRONMENT.viewport_size;
			delete message.ENVIRONMENT.getStoreClassification;

			try {
				// Append useful values to the backend call
				if (!Utilities.isEmpty(AppData.Storage.get('_geolocationPosition'))) {
					var geo = AppData.Storage.get('_geolocationPosition');
					var coords = geo.coords;

					delete geo.coords;

					for (var key in coords) {
						geo[key] = coords[key];
					}

					for (key in geo) {
						if (!angular.isString(geo[key])) {
							geo[key] = geo[key].toString();
						}
					}

					message.ENVIRONMENT.geolocation = geo;
				} else if (!Utilities.isEmpty(AppData.Storage.get('_geolocationError'))) {
					var geo = AppData.Storage.get('_geolocationError');

					for (var key in geo) {
						if (!angular.isString(geo[key])) {
							geo[key] = geo[key].toString();
						}
					}

					message.ENVIRONMENT.geolocation = geo;
				}

				message.ENVIRONMENT.host = $window.location.host;
				//message.ENVIRONMENT.queryString = $window.location.search;
				message.ENVIRONMENT.environment = AppData.environment;
				message.ENVIRONMENT.device = ClientInfo.deviceUnknown ? 'unknown' : ClientInfo.deviceType;
				message.ENVIRONMENT.merchant = AppData.merchant;
				message.ENVIRONMENT.merchantId = AppData.merchantId;
				message.ENVIRONMENT.language = AppData.language;

				// Also adding language as a charac, so it will flow through to ViewOrder
				characs.push({ language: AppData.language });
			} catch (error) {}

			message.CART_ADJUSTMENTS = {
				CA: Utilities.toArray(cartAdj).map(function hydrateCartAdjustments(ca) {
					return DataModelService.convert(ca, DataModelService.enums.hydrate.CART_ADJUSTMENT);
				})
			};

			// Sent on SavePurchase too: redirect flows complete from the saved request, and the backend
			// needs the code to reconcile the discounted PAYMENT.amount against DB totals.
			if (cartSummary.discount && cartSummary.discount.valid && validString(cartSummary.discount.code)) {
				// eslint-disable-next-line camelcase
				message.discount_code = cartSummary.discount.code;
			}

			// Add reference of request in pendingRequests.
			$rootScope.pendingRequests.push(Enums.services.PURCHASE);

			addAgreementDataToCart(message);

			addCustomOrderCharacs(message.CHARACS);

			var upfrontScheduleId = AgreementService.getUpfrontPaymentScheduleId(cartSummary.cart.items);
			if (angular.isDefined(upfrontScheduleId)) {
				var scheduleIdCharac = {};
				scheduleIdCharac[Enums.orderCharacs.PAYMENT_SCHEDULE_ID_IN_CART] = upfrontScheduleId;
				message.CHARACS.push(scheduleIdCharac);
			}

			sanitized = sanitizePurchaseV2();

			if (angular.isArray(sanitized)) {
				errorTracking.notify('Purchase Error: sanitizeV2 failed');
				$rootScope.hideSpinner();
				Modal.displayModal
				(
					{
						category: 'Cart [Purchase]',
						action: 'Error',
						label: 'No Date on Daily Ticket',
						title: Language.getLocale('Alert', 'noTicketErrortitle'),
						icon: 'icon-info red',
						description: Language.getLocale('Alert', 'noTicketErrorMessage'),
						buttonFlags: [Enums.buttonFlags.OK],
						callback: function(detail) {
							CartDataService
								.updateCartItems(sanitized)
								.then(function onSuccess() {
									Utilities.goTo(Enums.routes.CART_VIEW);
								});
						}
					}
				);

				return null;
			}

			//security measure!
			try {
				var reportedMsg = angular.copy(message);

				if (reportedMsg.PAYMENT) {
					delete reportedMsg.PAYMENT.account_number;
					delete reportedMsg.PAYMENT.cepay_merchant_id;
				}

				delete reportedMsg.CUSTOMER.l_name;
				delete reportedMsg.CUSTOMER.phone;
				delete reportedMsg.CUSTOMER.mobile_phone;
				delete reportedMsg.CUSTOMER.ADDRESS;
				reportedMsg.CUSTOMER.email = Utilities.maskEmails(reportedMsg.CUSTOMER.email);
			} catch (e) {
				errorTracking.notify('Exception: ' + e.name, e.message, {
					tags: {
						session_id: AppData.cart.session_id,
						merchant: AppData.merchant,
						environment: AppData.environment
					}
				});
			}

			// WARNING - This custom action mutates the request object by adding a new node, IDENTITY.
			if (CustomActionService.actionRegistered(CustomActionService.ACTIONS_ENUMS.TE2_ADD_IDENTITY_NODE)) {
				CustomActionService.executeCustomAction(CustomActionService.ACTIONS_ENUMS.TE2_ADD_IDENTITY_NODE, message);
			}
			return message;

			function addCustomOrderCharacs(orderCharacs) {
				if (CustomActionService.actionRegistered(CustomActionService.ACTIONS_ENUMS.PURCHASE_ADD_ORDER_CHARACS)) {
					CustomActionService.executeCustomActionChain(
						CustomActionService.ACTIONS_ENUMS.PURCHASE_ADD_ORDER_CHARACS,
						orderCharacs
					);
				}
			}

			function shouldDeletePayment() {
				// For SavePurchase calls, never delete the PAYMENT node - backend always needs it
				if (isForSavePurchase) {
					return false;
				}

				//only delete the payment node if its a 0 dollar cart AND
				// the cart does not have a payment schedule (BNPL) AND
				// there is no donation amount that needs to be processed
				var isZeroDollarCart = parseFloat(message.PAYMENT.amount).toFixed(2) === "0.00";
				var noPaymentScheduleInCart = !validArray(cartSummary.paymentSchedule.schedule);
				var hasDonationAmount = message.PAYMENT.donationAmount && parseFloat(message.PAYMENT.donationAmount) > 0;

				// Don't delete payment if there's a donation amount, even for zero dollar carts
				var deletePayment = isZeroDollarCart && noPaymentScheduleInCart && !hasDonationAmount;

				// only override the default deletion logic if the action is registered
				if (CustomActionService.actionRegistered(CustomActionService.ACTIONS_ENUMS.PURCHASE_DELETE_PAYMENT_OVERRIDE)) {
					deletePayment = CustomActionService.executeCustomAction(CustomActionService.ACTIONS_ENUMS.PURCHASE_DELETE_PAYMENT_OVERRIDE);
				}

				return deletePayment;
			}

			function shouldDisableReceiptEmail() {
				return CustomActionService.executeCustomAction(CustomActionService.ACTIONS_ENUMS.PURCHASE_DISABLE_RECEIPT_EMAIL, null, [savedBilling, savedMethod]);
			}

			function shouldDisableBillingDemographicsCheck() {
				return CustomActionService.executeCustomAction(CustomActionService.ACTIONS_ENUMS.PURCHASE_DISABLE_BILLING_CHECK, null, [savedBilling, savedMethod]);
			}

			function shouldResellerDisableReceiptPrices() {
				return CustomActionService.executeCustomAction(CustomActionService.ACTIONS_ENUMS.PURCHASE_DISABLE_RECEIPT_PRICES, savedBilling);
			}
			/* eslint-disable camelcase */
		}

		/**
		 * Convert the payment object to a list
		 * @param purchaseReqPaymentObj
		 * @returns {Array}
		 */
		function convertPaymentObjectToList(purchaseReqPaymentObj) {
			var cartSummary = CartDataService.getLastSummary(),
				paymentList = [],
				donation = UserInfo.get('donation'),
				insurance = UserInfo.get('insurance'),
				finalRemainingAmount = cartSummary.pricing.total,
				savedBilling = UserInfo.get('billing') || {};
				if (donation) {
					finalRemainingAmount += parseFloat(donation.donationAmount);
				}
				if (insurance && !insurance.splitInsurance) {
					finalRemainingAmount += parseFloat(insurance.premiumAmount);
				}
			UserInfo.get('partialPayments').forEach(function(partialPaymentObj) {
				var objForPaymentList = {},
					secAcctInfoObj,
					paymentObj;

				if (partialPaymentObj.isAccessoPayPayment) {
					objForPaymentList.accessoPay = 'true';
					objForPaymentList.auth_id = partialPaymentObj.auth_id;
					objForPaymentList.amount = partialPaymentObj.amount;
					objForPaymentList.cardholder_name = savedBilling.lastName + ', ' + savedBilling.firstName;
					objForPaymentList.cepay_merchant_id = partialPaymentObj.paymentMerchantId;
					objForPaymentList.paymentReference = partialPaymentObj.paymentReference;
					objForPaymentList.paymentMerchantId = partialPaymentObj.paymentMerchantId;
					objForPaymentList.paymentMethodCode = partialPaymentObj.paymentMethodCode;
					objForPaymentList.paymentProviderName = partialPaymentObj.paymentProviderName;
					objForPaymentList.rawCardBrand = partialPaymentObj.rawCardBrand;
					if (partialPaymentObj.donationAmount) {
						objForPaymentList.donationAmount = partialPaymentObj.donationAmount;
						objForPaymentList.donationStatus = partialPaymentObj.donationStatus;
						objForPaymentList.splitDonation = Utilities.getString(partialPaymentObj.splitDonation);
					}
					if (partialPaymentObj.premiumAmount) {
						objForPaymentList.premiumAmount = partialPaymentObj.premiumAmount;
						objForPaymentList.insuranceStatus = partialPaymentObj.insuranceStatus;
						objForPaymentList.splitInsurance = Utilities.getString(partialPaymentObj.splitInsurance);
					}
					finalRemainingAmount -= parseFloat(partialPaymentObj.amount + (partialPaymentObj.donationAmount || 0) + (partialPaymentObj.premiumAmount || 0));
				} else {
					secAcctInfoObj = partialPaymentObj.secAcctInfo;
					paymentObj = partialPaymentObj.payment;

					Object.keys(paymentObj).forEach(function(key) {
						if (angular.isDefined(Enums.USERINFO_TO_PURCHASE_PAYMENT_OBJECT_MAPPINGS[key])) {
							objForPaymentList[Enums.USERINFO_TO_PURCHASE_PAYMENT_OBJECT_MAPPINGS[key]] = paymentObj[key];
						} else {
							objForPaymentList[key] = paymentObj[key];
						}
					});

					objForPaymentList.amount = objForPaymentList.amount.toFixed(2);
					Object.keys(secAcctInfoObj).forEach(function(key) {
						objForPaymentList[key] = secAcctInfoObj[key];
					});

					finalRemainingAmount -= Number(paymentObj.total);
				}
				paymentList.push(objForPaymentList);
			});

			if (!(purchaseReqPaymentObj.accessoPay && purchaseReqPaymentObj.accessoPay === 'true')) {
				purchaseReqPaymentObj.amount = finalRemainingAmount.toFixed(2);
			}

			if (finalRemainingAmount.toFixed(2) > 0) {
				if (purchaseReqPaymentObj.donationAmount) {
					purchaseReqPaymentObj.splitDonation = Utilities.getString(purchaseReqPaymentObj.splitDonation);
				}
				if (purchaseReqPaymentObj.premiumAmount) {
					purchaseReqPaymentObj.splitInsurance = Utilities.getString(purchaseReqPaymentObj.splitInsurance);
				}
				paymentList.push(purchaseReqPaymentObj);
			}

			return paymentList;
		}

		/**
		 * Pushes a message to a collection to be displayed later.
		 * @param {errorMsgCollection} Array containing the list of errors to display.
		 * @param {message} String error message to be stored.
		 * returns false
		 */
		function pushErrorMessage(errorMsgCollection, message) {
			errorMsgCollection.push(message);
			return false;
		}

		/**
		 * Creates a list of error messages within an array or messages and displays all messages.
		 * @param {errorMsgCollection} Array containing the list of errors to display.
		 * @param {title} String for the title of the message.
		 * @param {desc} String with the prefix for the list of messages.
		 * @param {callback} Function to be executed after the modal is dismissed.
		 */
		function displayErrorMessages(errorMsgCollection, title, desc, callback) {
			var messages = desc + '<ul class="modal-error-list"><li>' + errorMsgCollection.join('</li><li>') + '</li></ul>';
		 	$rootScope.hideSpinner();
			Modal.displayModal
			(
				{
					category: 'One or More Purchase Errors',
					action: 'Error',
					label: 'Purchase Error',
					title: title,
					icon: 'icon-info red',
					description: messages,
					buttonFlags: [Enums.buttonFlags.OK],
					callback: function() {
						if (callback) {
							callback();
						}
					 }
				}
			);
		}

	 /**
	  * Verify a few critical pieces of billing information so that we can notify guest if missing
	  * This is to avoid creating orders without any customer information in our system
	  * @param billingObj
	  * @returns {boolean}
	  */
	 	function missingBillingInformation(billingObj) {
		 return (angular.isUndefined(billingObj.firstName) || billingObj.firstName.length === 0 ||
			 	 angular.isUndefined(billingObj.lastName) || billingObj.lastName.length === 0);
		}

		var message = {};

		/**
		 * Find out if we have a pending purchase
		 * @returns {Boolean} If we have a pending purchase or not
		 */
		function hasPendingPurchase() {
			return pendingPurchase;
		}

		/**
		 *
		 * @param callback
		 * @param (optional) - requestType: override the request type
		 * @param (optional) - requestMessage: override the request message
		 * @param (optional) - failureCallback: to override the default action of routing back to payment method screen upon Purchase failure
		 */
		Purchase.executePurchase = function(callback, requestType, requestMessage, failureCallback) {
			return $q(function(resolvePurchase, rejectPurchase) {
				var cartSummary = CartDataService.getLastSummary(),
					results = {},
					excludeSecureAccountInfo,
					savedPayment = UserInfo.get('payment') || {};

				if (pendingPurchase) {
					return rejectPurchase(Enums.purchaseError.PENDING);
				}

				if (CustomActionService.actionRegistered(CustomActionService.ACTIONS_ENUMS.REMOVING_TICKET_IDS_FROM_URL)) {
					CustomActionService.executeCustomAction(CustomActionService.ACTIONS_ENUMS.REMOVING_TICKET_IDS_FROM_URL);
				}

				if (!savedPayment.isAccessoPayPayment && UserInfo.getPartialPaymentTotal()) {
					excludeSecureAccountInfo = cartSummary.pricing.total - UserInfo.getPartialPaymentTotal() <= 0;
				}

				// Show the spinner.
				$rootScope.showSpinner(Language.getLocale('ApplicationLabels', 'purchaseLoadMsg'));
				message = angular.isDefined(requestMessage) ? requestMessage : gatherPurchaseDetails(excludeSecureAccountInfo);

				if (!message) {
					$rootScope.hideSpinner();
					return rejectPurchase(Enums.purchaseError.GATHER_PURCHASE_DETAILS);
				}

				pendingPurchase = true;

				RecaptchaV3Service.execute(RecaptchaV3Service.ACTION.PURCHASE, checkProp('message.PAYMENT.auth_id', message, 'returnValue')).then(function onRecaptchaToken(token) {
					if (validString(token)) {
						message.recaptcha_token = token;
					}

					AppData.fetch(requestType ? requestType : Enums.services.PURCHASE, false, message).then(function(data) {
						pendingPurchase = false;
						results.purchaseData = data;
						var purchaseData = data;

						var preOrderAmount = (message.PAYMENT) ? message.PAYMENT.amount : null;
						var paramsToClear = ['cart_id', 'cart_key', 'session_id'];
						var queryParams = $location.search();

						if (data.status == Enums.status.OK) {
							// Broadcast purchase complete event.
							// Triggers functionality in pixel tracking service.
							$rootScope.$broadcast(Enums.events.purchaseComplete, {
								purchaseResponse: data,
								orderAmount: AppData.GetCartSummary.payment_due
							});

							// Post message for accesso.js to remove params after save cart purchase
							if (Utilities.isInIFrame()){
								$window.parent.postMessage(JSON.stringify({
									messageType: Enums.messages.ACCESSO_PAY_CLEAR_QUERY_PARAMS,
									queryParams: paramsToClear
								}), '*');
							} else {
								// Remove params for save cart purchases not in iFrame
								paramsToClear.forEach(function clearQueryParam(value) {
									delete queryParams[value];
								});

								$location.replace();
								$location.search(queryParams);
							}

							CustomActionService.executeCustomActionChain(CustomActionService.ACTIONS_ENUMS.PURCHASE_COMPLETE_SUCCESS);

							if (CustomActionService.actionRegistered(CustomActionService.ACTIONS_ENUMS.SMS_VERIFICATION_PURCHASE_COMPLETE)) {
								CustomActionService.executeCustomAction(CustomActionService.ACTIONS_ENUMS.SMS_VERIFICATION_PURCHASE_COMPLETE);
							}


							// Display app store URL message.
							displayAppStoreModal();

							// I need the lastFour, orderId, and phoneNumber
							try {
								results.lastFour = data.PAYMENT.account_number.substr(data.PAYMENT.account_number.toString().length - 4);
							} catch (error) {
								results.lastFour = '';
							}

							//data.PAYMENT.account_number.substring
							results.orderId = data.order_id;

							// Add reference of request in pendingRequests.
							$rootScope.pendingRequests.push(Enums.services.GET_NEW_CART_ID);

							/* @TODO, moving into Cart */
							// Call GetNewCartID
							var old_cart_id = angular.copy(AppData.cart.cart_id);

							// Do not return so it can continue making requests here.
							resolvePurchase();
							$location.search(Enums.urlParameters.userToken, null);

							AppData.fetch(Enums.services.GET_NEW_CART_ID, true, {}, true, true).then(function(data) {
								Purchase.cleanupPreviousCart();
								results.cartData = data;

								// Remove reference of request in pendingRequests.
								$rootScope.removePendingRequest(Enums.services.GET_NEW_CART_ID);

								// Add reference of request in pendingRequests.
								$rootScope.pendingRequests.push(Enums.services.VIEW_ORDER);

								// Call ViewOrder.
								AppData.fetch(Enums.services.VIEW_ORDER, false, { oToken: purchaseData.oToken, cToken: purchaseData.cToken }, true, undefined, true).then(function(data) {
									$rootScope.$broadcast(Enums.events.postPurchaseComplete, { viewOrderResponse: data });

									results.vieworderData = data;

									// Remove reference of request in pendingRequests.
									$rootScope.removePendingRequest(Enums.services.VIEW_ORDER);

									// TODO: Check that email isn't an array of results
									if (data.status == Enums.status.OK) {
										if (Utilities.safelyCheckPropertyOnObject('data.VIEW_ORDER_REPLY.CUSTOMER_DETAILS_REPLY.CUSTOMER', data)) {
											customer = data.VIEW_ORDER_REPLY.CUSTOMER_DETAILS_REPLY.CUSTOMER;
											results.oToken = data.VIEW_ORDER_REPLY.ORDER_STATUS_REPLY.oToken;
											results.eToken = (customer.EMAIL || {}).eToken;
											results.cToken = customer.cToken;
											results.pToken = customer.PHONE.pToken;
										}
										results.emailAddress =
											angular.isDefined((((((data).VIEW_ORDER_REPLY || {}).CUSTOMER_DETAILS_REPLY || {}).CUSTOMER || {}).EMAIL || {}).address)
												? data.VIEW_ORDER_REPLY.CUSTOMER_DETAILS_REPLY.CUSTOMER.EMAIL.address
												: message.CUSTOMER.email;
										// TODO: Check that phone isn't an array of results
										results.phoneNumber =
											angular.isDefined((((((data).VIEW_ORDER_REPLY || {}).CUSTOMER_DETAILS_REPLY || {}).CUSTOMER || {}).PHONE || {}).number)
												? data.VIEW_ORDER_REPLY.CUSTOMER_DETAILS_REPLY.CUSTOMER.PHONE.number
												: message.CUSTOMER.phone;

										results.customerId = Utilities.safelyCheckPropertyOnObject('data.VIEW_ORDER_REPLY.CUSTOMER_DETAILS_REPLY.CUSTOMER.id', data) ? data.VIEW_ORDER_REPLY.CUSTOMER_DETAILS_REPLY.CUSTOMER.id :undefined;


										if (CustomActionService.actionRegistered(CustomActionService.ACTIONS_ENUMS.PURCHASE_COMPLETE_SUCCESS_GET_NEW_CART)) {
											CustomActionService.executeCustomAction(CustomActionService.ACTIONS_ENUMS.PURCHASE_COMPLETE_SUCCESS_GET_NEW_CART, undefined, [{ old_cart_id: old_cart_id }]);
										}

										if (!CustomActionService.actionRegistered(CustomActionService.ACTIONS_ENUMS.INVALIDATE_CP_PROFILE_CACHE)) {
											CustomActionService.registerCustomAction(CustomActionService.ACTIONS_ENUMS.INVALIDATE_CP_PROFILE_CACHE, angular.noop);
										}

										if (CustomActionService.actionRegistered(CustomActionService.ACTIONS_ENUMS.FOLIO_MEMBERSHIP_UPGRADE)) {
											CustomActionService.deregisterCustomAction(CustomActionService.ACTIONS_ENUMS.FOLIO_MEMBERSHIP_UPGRADE);
										}

										if (CustomActionService.actionRegistered(CustomActionService.ACTIONS_ENUMS.ALLOW_SMS_VERIFICATION)) {
											CustomActionService.deregisterCustomAction(CustomActionService.ACTIONS_ENUMS.ALLOW_SMS_VERIFICATION);
										}

										if (CustomActionService.actionRegistered(CustomActionService.ACTIONS_ENUMS.SMS_VERIFICATION_COMPLETE)) {
											CustomActionService.deregisterCustomAction(CustomActionService.ACTIONS_ENUMS.SMS_VERIFICATION_COMPLETE);
										}

										if (CustomActionService.actionRegistered(CustomActionService.ACTIONS_ENUMS.SMS_VERIFICATION_PURCHASE_COMPLETE)) {
											CustomActionService.deregisterCustomAction(CustomActionService.ACTIONS_ENUMS.SMS_VERIFICATION_PURCHASE_COMPLETE);
										}

										$window.parent.postMessage(
											JSON.stringify({
												messageType: Enums.messages.PURCHASE_SUCCESS,
												oToken: purchaseData.oToken,
												cToken: purchaseData.cToken
											}),
											'*'
										);

										// If this is a headless store, the client will route to their own order page.
										if ($location.search()[Enums.urlParameters.headless] === 'true') {
											return new $q(function(resolve) {
												// never resolve
											})
										}

										callback(results);
									} else {
										var title = Language.getLocale('Alert', 'viewOrderErrorTitle'),
											description = Language.getLocale('Alert', 'viewOrderErrorMsg');

										if (AppData.environment == 'development' || AppData.environment == 'staging') {
											title = 'Check ViewOrder Permissions';
											description = 'THIS MESSAGE ONLY APPEARS IN TEST AND STAGING! <br/><br/> Please check the permissions for ViewOrder for user ID 5 in Enterprise.';
										}

										// Error returning order response. User may have completed a purchase.
										// Alert user of problems and notify that purchase may have been completed.
										$rootScope.hideSpinner();
										Modal.displayModal(
											{
												category: 'Cart [View Order]',
												action: 'Error',
												label: '',
												title: title,
												description: description,
												icon: 'icon-info red',
												hideAllButtons: true,
												callback: function() {
												// If view order failed, we should do nothing - except maybe request View Order again.
												// Prompting the user to try again poses the risk of the user making the same purchase request.

													errorTracking.notify("Post Purchase View Order Failure", "ViewOrder has failed post purchase: " + data.error_msg);
												}
											}
										);
									}

								});
							});
						} else {
							var _title = '';
							var _description = '';

							if (checkProp('UserInfo.secAcctInfo.cyberSourceToken', UserInfo)) {
								UserInfo.secAcctInfo.cyberSourceToken = null;
							}

							if (data.error_code == '116') {
								_title = Language.getLocale('Alert', 'failedPurchaseTitle');
								_description = Language.getLocale('Alert', 'failedPurchaseMsg');

								// Display Error Message for the Error Code
								var errorCodes116 = Language.getLocale('ErrorCodes', '116');
								if (errorCodes116) {
									var errorCodeTitle = Language.getLocale('ErrorCodes', 'errorCodeTitle');
									if (errorCodeTitle) {
										_title = Language.replaceAll('@@errorCode', '116', errorCodeTitle);
									}
									_description = errorCodes116;
								}

								$rootScope.hideSpinner();

								Modal.displayModal({
									category: 'Cart [Purchase]',
									action: 'Error',
									label: data.error_msg,
									title: _title,
									icon: 'icon-info red',
									description: _description,
									buttonFlags: [Enums.buttonFlags.OK],
									callback: function() {
										$rootScope.routeTo('/reset/true');
									}
								});

								rejectPurchase(Enums.purchaseError.ERROR_116);
								return;
							}

							if (data.error_code == '161') {
								var cartInfo = Storage.get('GetNewCartID');
								var identifier = ((data).PAYMENT || {}).auth_id ? data.PAYMENT.auth_id : cartInfo.cart_id;

								AppData.fetch
								(Enums.services.GET_NEW_CART_ID
									, true
									, {}
									, true
									, true
								).then
								(function(data) {
									Purchase.cleanupPreviousCart();

									$rootScope.routeTo(Enums.routes.PENDING_ORDER + '/' + identifier);
								});
								rejectPurchase(Enums.purchaseError.ERROR_161);
								return;
							}


							/**
							 * If we get an error_code of 700 back on the Purchase call, this is specific to the SavedPurchase flow
							 * This error code means that the SavedPurchase for this cart has already been purchased.
							 */
							if (data.error_code == '700') {
								Purchase.getOrderAndRouteForPurchasedCart();
								rejectPurchase(Enums.purchaseError.ERROR_700);
								return;
							}

							if (data.status == Enums.status.FAILED && $rootScope.showingPurchaseDiconnectError) {
								rejectPurchase(Enums.purchaseError.DISCONNECT);
								return;
							} else {
								CartDataService.fetchCartSummary();

								_title = Language.getLocale('Alert', 'failedPurchaseTitle');
								_description = Language.getLocale('Alert', 'failedPurchaseMsg')

								// Display Error Message for the Error Code
								if (data.error_code && !Utilities.isEmpty(Language.getLocale('ErrorCodes', data.error_code))) {
									if (Language.getLocale('ErrorCodes', 'errorCodeTitle')) {
										_title = Language.replaceAll('@@errorCode', data.error_code, Language.getLocale('ErrorCodes', 'errorCodeTitle'));
									}
									_description = Language.getLocale('ErrorCodes', data.error_code);
								}

								var useCustomDescription = CustomActionService.actionRegistered(CustomActionService.ACTIONS_ENUMS.PURCHASE_ERROR_CODE_CUSTOM_DESCRIPTION);

								if (useCustomDescription) {
									_description = CustomActionService.executeCustomAction(CustomActionService.ACTIONS_ENUMS.PURCHASE_ERROR_CODE_CUSTOM_DESCRIPTION, undefined, [data.error_code, _description]);
								}

								$rootScope.hideSpinner();

								rejectPurchase(Enums.purchaseError.MODAL);

								if ((data.PAYMENT && data.PAYMENT.amount) && (Number(preOrderAmount) != Number(data.PAYMENT.amount)) && !useCustomDescription) {
									Modal.displayModal(
										{
											category: 'Cart [Purchase]',
											action: 'Error',
											label: data.error_msg,
											title: _title,
											icon: 'icon-info red',
											description: Language.getLocale('Alert', 'failedPurchaseMsg2'),
											buttonFlags: [Enums.buttonFlags.OK],
											callback: function(detail) {
												$rootScope.routeTo(Enums.routes.CART);
											}
										}
									);
								} else {
									Modal.displayModal(
										{
											category: 'Cart [Purchase]',
											action: 'Error',
											label: data.error_msg,
											title: _title,
											icon: 'icon-info red',
											description: _description,
											buttonFlags: [Enums.buttonFlags.OK],
											callback: function(detail) {
												try {
													if (data.reset_cart == '1') {
														$rootScope.routeTo('reset/true');
													} else {
														if (angular.isDefined(failureCallback)) {
															failureCallback(Enums.purchaseError.CART);
														} else if (CustomActionService.actionRegistered(CustomActionService.ACTIONS_ENUMS.PURCHASE_CATCHALL_FAILURE_ERROR_MODAL_CALLBACK)) {
															//actions that are registered for this event need to properly handle routing to payment method as the default action if the condition
															//to override this is not met
															CustomActionService.executeCustomAction(CustomActionService.ACTIONS_ENUMS.PURCHASE_CATCHALL_FAILURE_ERROR_MODAL_CALLBACK);
														} else {
															Purchase._determinRouteOnPurchaseFailure();
														}
													}
												} catch (error) {
													Purchase._determinRouteOnPurchaseFailure();
												}
											}
										}
									);
								}
							}
						}
					}).catch(function(data) {
						pendingPurchase = false;
						rejectPurchase(Enums.purchaseError.CATCH);
					});
				});
			});
		}

		var routeBackToBilling = function() {
			$rootScope.routeTo(Enums.routes.BILLING);
		}

		/**
		 * Determines the route based on accessoPay configuration
		 * @returns {undefined}
		 */
		Purchase._determinRouteOnPurchaseFailure = function() {
			var accessoPayAppConfig = validString(AppData.settings.accesso_pay) ? JSON.parse(AppData.settings.accesso_pay) : {};
			if (accessoPayAppConfig.enable) {
				$rootScope.routeTo(Enums.routes.CART);
			} else {
				PaymentService.routeToPaymentMethod();
			}
		}

		/**
		 * Default post purchase route depending on options such as shipping and status of view order response
		 * //TODO we can migrate the cart.js controller routing to here as well in the future
		 * @param viewOrderData
		 */
		Purchase.defaultPostPurchaseSuccess = function(viewOrderData) {
			AgreementService.clearDataModel();
			AgreementService.clearCartFormData(true);
			AgreementService.clearCustomFormData(true);
			if (UserInfo.get('donation')) {
				UserInfo.set('donation', null);
			}
			if (UserInfo.get('insurance')) {
				UserInfo.set('insurance', null);
			}

			if (viewOrderData) {
				OrderService.clear();
				OrderService.phoneNumber = viewOrderData.phoneNumber.split('-').join('');
				OrderService.lastFour = viewOrderData.lastFour;
				OrderService.orderID = viewOrderData.orderId;
				OrderService.email = viewOrderData.emailAddress;
				OrderService.customerID = viewOrderData.customerId;
				OrderService.cToken = viewOrderData.cToken;
				OrderService.eToken = viewOrderData.eToken;
				OrderService.oToken = viewOrderData.oToken;
				OrderService.pToken = viewOrderData.pToken;

				Ticket.determineState();
			}
		};


		Purchase.getOrderAndRouteForPurchasedCart = function(failureCallback) {
			$rootScope.showSpinner(Language.getLocale('ApplicationLabels', 'purchaseLoadMsg'));
			AppData.fetch('GetOrderIdByCartId', false, { cart_id: AppData.cart.cart_id }).then(function(response) {
				if (response.status == Enums.status.OK && angular.isDefined(response.oToken)) {
				 var oToken = response.oToken;
					AppData.fetch(
						Enums.services.VIEW_ORDER,
						false,
						{
							oToken: oToken,
							cToken: response.cToken
						},
						true,
						undefined,
						true
					).then(function(viewOrderResponse) {
						var results = {},
							customer,
							orderStatus;

						if (viewOrderResponse.status == Enums.status.OK) {
							results.orderId = viewOrderResponse.VIEW_ORDER_REPLY.ORDER_STATUS_REPLY.order_id;
							results.lastFour = '';

							if (Utilities.safelyCheckPropertyOnObject('viewOrderResponse.VIEW_ORDER_REPLY.CUSTOMER_DETAILS_REPLY.CUSTOMER', viewOrderResponse, function(obj) {
								return angular.isDefined(obj.EMAIL) && angular.isDefined(obj.EMAIL.address) && angular.isDefined(obj.PHONE.number);
							})) {
								customer = viewOrderResponse.VIEW_ORDER_REPLY.CUSTOMER_DETAILS_REPLY.CUSTOMER;
								results.phoneNumber = customer.PHONE.number;
								results.emailAddress = (customer.EMAIL || {}).address;
								results.customerId = customer.id;
								results.eToken = (customer.EMAIL || {}).eToken;
								results.cToken = customer.cToken;
								results.pToken = customer.PHONE.pToken;
							}

							if (Utilities.safelyCheckPropertyOnObject('viewOrderResponse.VIEW_ORDER_REPLY.ORDER_STATUS_REPLY', viewOrderResponse)) {
								results.oToken = viewOrderResponse.VIEW_ORDER_REPLY.ORDER_STATUS_REPLY.oToken;
							}

							Purchase.defaultPostPurchaseSuccess(results);
						} else {
							var title = Language.getLocale('Alert', 'viewOrderErrorTitle'),
								description = Language.getLocale('Alert', 'viewOrderErrorMsg');

							if (AppData.environment == 'development' || AppData.environment == 'staging') {
								title = 'Check ViewOrder Permissions';
								description = 'THIS MESSAGE ONLY APPEARS IN TEST AND STAGING! <br/><br/> Please check the permissions for ViewOrder for user ID 5 in Enterprise.';
							}

							// Error returning order response. User may have completed a purchase.
							// Alert user of problems and notify that purchase may have been completed.
							$rootScope.hideSpinner();
							Modal.displayModal({
								category: 'Cart [View Order]',
								action: 'Error',
								label: '',
								title: title,
								description: description,
								icon: 'icon-info red',
								hideAllButtons: true,
								showCloseButton: false,
								callback: function() {
									// If view order failed, we should do nothing - except maybe request View Order again.
									// Prompting the user to try again poses the risk of the user making the same purchase request.
									errorTracking.notify("Post Purchase View Order Failure", "ViewOrder has failed post purchase: " + data.error_msg);
								}
							});
						}
					})
				} else {
				 if (failureCallback) {
						failureCallback();
				 } else {
					// Alert user of problems - show viewOrderError since that should suffice if there are issues in calling GetOrderIdByCartId
						$rootScope.hideSpinner();
						var title = Language.getLocale('Alert', 'viewOrderErrorTitle'),
							description = Language.getLocale('Alert', 'viewOrderErrorMsg');

						if (AppData.environment == 'development' || AppData.environment == 'staging') {
							title = 'Check That GetOrderIdByCartId is in the Gateway';
							description = 'THIS MESSAGE ONLY APPEARS IN TEST AND STAGING! <br/><br/> Please check the config for GetOrderIdByCartId.';
						}
						Modal.displayModal({
							category: 'Cart [View Order]',
							action: 'Error',
							label: '',
							title: title,
							description: description,
							icon: 'icon-info red',
							showCloseButton: false,
							callback: function() {
								// If view order failed, we should do nothing - except maybe request View Order again.
								// Prompting the user to try again poses the risk of the user making the same purchase request.

								errorTracking.notify("Post Purchase View Order Failure", "GetOrderIdByCartId has failed post purchase");
								$rootScope.routeTo('/reset');
							}
						});
					}
				}
			});
		}

		/**
		 * Returns if the purchase has TESCO payments
		 * @private
		 * @function
		 * @param {Object} purchaseDetails purchase details
		 * @returns {Object[]} array of tesco payments
		 */
		Purchase._returnTescoPayments = function(purchaseDetails) {
			if (checkProp('purchaseDetails.PAYMENT', purchaseDetails, validArray)) {
				return purchaseDetails.PAYMENT.filter(function(payment) {
					return payment.auth_type === Enums.authTypes.TESCO;
				});
			}
			return [];
		}

		/**
		 * Request PrePurchaseAuth for Tesco and Call SavePurchase once all auth_id's are gathered
		 * @function
		 * @private
		 * @param {Object[]} tescoPayments array of tesco payments
		 * @param {Object} message message/req object
		 * @param {Function} successCallback success callback function
		 * @param {Function} failureCallback failure callback function
		 * @returns {undefined}
		 */
		Purchase._requestPrePurchaseAuthForTescoAndSavePurchase = function(tescoPayments, message, successCallback, failureCallback) {
			var prePurchaseAuthPromise;
			if (!validArray(tescoPayments)) {
				return;
			}

			tescoPayments.forEach(function(tescoPayment) {
				var reqObj = {
					amount: tescoPayment.amount,
					auth_type: tescoPayment.auth_type,
					billing_type: tescoPayment.billing_type,
					cart_id: AppData.cart.cart_id,
					card_number: tescoPayment.card_number,
					merchant_id: AppData.GetMerchantDetails.merchant_id
				};
				if (prePurchaseAuthPromise) {
					prePurchaseAuthPromise = prePurchaseAuthPromise.then(function() {
						return Purchase._prePurchaseAuthForTesco(reqObj, tescoPayment);
					});
				} else {
					prePurchaseAuthPromise = Purchase._prePurchaseAuthForTesco(reqObj, tescoPayment);
				}
			});

			prePurchaseAuthPromise
				.finally(function() {
					Purchase._savePurchase(message, successCallback, failureCallback);
				});

			return prePurchaseAuthPromise;
		}

		/**
		 * PrePurchaseAuth request for tesco payments
		 * @function
		 * @private
		 * @param {Object} reqObj request object
		 * @param {Object} tescoPayment tescoPaymentObject
		 * @returns {Promise} PrePurchaseAuth promise
		 */
		Purchase._prePurchaseAuthForTesco = function(reqObj, tescoPayment) {
			var defer = $q.defer();
			AppData.fetch(Enums.services.PREPURCHASEAUTH, false, reqObj).then(function(response) {
				tescoPayment.auth_id = response.auth_id;
				defer.resolve();
			});
			return defer.promise;
		}

		/**
		 * Save Purchase
		 * @private
		 * @function
		 * @param {Object} message message object
		 * @param {Function} successCallback success callback
		 * @param {Function} failureCallback failure callback
		 * @returns {undefined}
		 */
		Purchase._savePurchase = function(message, successCallback, failureCallback) {
			AppData.fetch(Enums.services.SAVE_PURCHASE, false, message).then(function(data) {
				if (data.status === Enums.status.OK) {
					successCallback(data);
				} else {
					failureCallback();
				}
			});
		}

		/**
		 * Save Purchase
		 * @public
		 * @param {Function} successCallback success callback
		 * @param {Function} failureCallback failure callback
		 * @param {Boolean/undefined} excludeSecAcctInfo exclude secure account information
		 * @returns {undefined}
		 */
		Purchase.savePurchase = function(successCallback, failureCallback, excludeSecAcctInfo) {
			var excludeAccountInformation = excludeSecAcctInfo === undefined ? true : Utilities.getBoolean(excludeSecAcctInfo);
			var tescoPayments;
			// Show the spinner.
			$rootScope.showSpinner();
			try {
				message = {};
				message.SERVICE = gatherPurchaseDetails(excludeAccountInformation, true);

				//copied logic from purchase method - we DO NOT want to send SavePurchase if gatherPurchaseDetails returns null
				if (!message.SERVICE) {
					//we display another error in gatherPurchaseDetails/sanitize so lets just return
					$rootScope.hideSpinner();
					return;
				}

				message.SERVICE.request_type = Enums.services.PURCHASE;
				message.SERVICE.tiny_response = '1';
				message.SERVICE.software = ClientInfo.software;
				message.SERVICE.ver_id = '';
				message.SERVICE.verify_attempt = '1';
				message.SERVICE.version = '4';

				//
				// ADD EXTRA HEADER INFO -- note, all of these values may be overwritten by node
				// during the request if they are known (stored in) the current connection on node
				//
				message.SERVICE.application_id = '1500';
				message.SERVICE.merchant_id = AppData.merchantId;
				message.SERVICE.machine_id = '500';
				message.SERVICE.agent_id = '5';
				message.SERVICE.user_id = '5';
				message.SERVICE.language = AppData.language;

				tescoPayments = Purchase._returnTescoPayments(message.SERVICE);

				if (validArray(tescoPayments)) {
					Purchase._requestPrePurchaseAuthForTescoAndSavePurchase(tescoPayments, message, successCallback, failureCallback);
				} else {
					Purchase._savePurchase(message, successCallback, failureCallback);
				}
			} catch (e) {
				failureCallback();
			}
		};

		/**
		 * Show a specific modal for failures
		 * @param showErrorModal
		 */
		Purchase.onSavePurchaseFailure = function(showErrorModal) {
			if (showErrorModal) {
				$rootScope.hideSpinner();
				Modal.displayModal
				(
					{
						category: 'Save Purchase',
						action: 'Save Purchase Error',
						label: Language.getLocale('Alert', 'apersSavePurchaseErrorTitle'),
						title: Language.getLocale('Alert', 'apersSavePurchaseErrorTitle'),
						description: Language.getLocale('Alert', 'apersSavePurchaseErrorMessage'),
						buttonFlags: [Enums.buttonFlags.OK],
						showCloseButton: false,
						callback: function() {
							Utilities.stripURLParams(Enums.misterCashIdealParams);
							Utilities.routeTo(Enums.routes.PAYMENT_METHOD);
						}
					}
				);
			}
		}

		/**
		 * Call the Backend service SavePurchaseAuthStatus to obtain a status code regarding the current cart's outstanding transaction (if one was created)
		 *
		 * @returns {Object} response with data regarding the auth status - the attribute we are interested in is saved_purchase_status
		 * If the Backend is UNABLE to get any information on the authorization we made to Ingenico, then this call returns with a FAILED status, indicating that
		 * we were not able to get any auth information.
		 *
		 * If the Backend is able to retrieve information regarding the auth status from Ingenico, the call returns with a SUCCESS status and a saved_purchase_status
		 * property is returned.  The different values are explained below.
		 *
		 * The saved_purchase_statuses are details in the Enums.savedPurchaseAuthStatus object:
		 *
		 * 	NO_SAVED_PURCHASE_STATUS : '0', - we have not yet sent a saved purchase call so we have no records sitting in the DB as of now - no transactions have been started
		 * 	NEW_STATUS : '1', - this is pretty much the same as pending, but the guest has not received an official email confirming or denying the transaction at this point
		 * 	PENDING_STATUS : '10', - this means Ingenico has officially indicated that the payment processor is still processing the transaction
		 * 	CONFIRMED_STATUS : '20', - this means the status of the authorization is officially successful and confirmed and we are ready to create an order in our system
		 * 	PURCHASED_STATUS : '30', - this means we have successfully authorized a transaction and already created an order in our database for this cart already
		 * 	FAILED_STATUS : '40' - this means that Ingenico has officially indicated that this authorization failed
		 *
		 */
		Purchase.savePurchaseAuthStatus = function() {
			$rootScope.showSpinner(Language.getLocale('Purchase', 'savePurchaseAuthStatusLoadingMsg'));

			return AppData.fetch(
				'SavedPurchaseAuthStatus'
				, false
				, { cart_id: AppData.cart.cart_id })
				.then(function(response) {
					return response;
				}
				);
		}

		/**
		 * Call backend service DeleteSavedPurchase to delete the savedPurchase entry in the DB
		 * (this allows the guest to choose another payment method and continue on)
		 * @param {Object} extendedReq - additional request properties to merge into the delete request (e.g. adding override: 1 for a redirect payment provider's failed state)
		 * @param {Boolean} supressSpinner - True if the spinner should be suppressed, and not show (done this way, because undefined is a falsy value)
		 * @returns {Promise}
		 */
		Purchase.deleteSavedPurchase = function(extendedReq, supressSpinner) {
			var req = { cart_id: AppData.cart.cart_id };
			if (!supressSpinner) {
				$rootScope.showSpinner(Language.getLocale('Purchase', 'deletePurchaseStatusLoadingMsg'));
			}

			if (angular.isObject(extendedReq)) {
				angular.extend(req, extendedReq);
			}

			return AppData.fetch('DeleteSavedPurchase', false, req).then(function(response) {
				return response;
			});
		}

		/**
		 * Register an alternate purchase action for a particular paymentMethod
		 * @param paymentMethod
		 * @param action
		 */
		Purchase.registerAlternatePurchaseAction = function(paymentMethod, action) {
			alternatePurchaseActions.push({
				paymentMethod: paymentMethod,
				doAction: action
			});
		};

		/**
		 * Deregister an alternate purchase action for a particular paymentMethod
		 * @param {String} paymentMethod The payment method
		 * @param {Function} action The action
		 * @returns {undefined}
		 */
		Purchase.deregisterAlternatePurchaseAction = function(paymentMethod, action) {
			var index = alternatePurchaseActions.findIndex(function(type) {
				return type.paymentMethod === paymentMethod && type.doAction === action;
			});

			if (index > -1) {
				alternatePurchaseActions.splice(index, 1);
			}
		};

		/**
		 * Get the alternatePurchaseAction for a particular paymentMethod
		 * @param paymentMethod
		 * @returns {Object}
		 */
		Purchase.getAlternatePurchaseAction = function(paymentMethod) {
			return alternatePurchaseActions.filter(function(item) {
				return item.paymentMethod === paymentMethod;
			})[0];
		}

		return Purchase;
	});

/*
	NOTES:
	type: The type of season pass XMC (e.g. season_pass, small_season_pass, season_pass_thorp).
	views: The list of views that should be shown (in that order) when this season pass XMC is loaded.
	currentViewIndex: The view that is currently loaded.
	init: Function to overwrite default settings. NOTE: The init function can be different for each XMC.
*/
angular.module('app').factory
('Seasonpass', function(
	$log,
	$rootScope,
	$state,
	$q,
	AppData,
	LegacyCart,
	Enums,
	ExtraFlow,
	Language,
	JSONValidator,
	Modal,
	Package,
	UserInfo,
	Utilities,
	InterstitialDiningConstants,
	InterstitialDiningService) {
	var service =
			{
				type:
				{
					season_pass:
					{
						views: ['seasonPass'],
						name: 'season_pass',
						init: function() {
							service.fieldSettings.memberCode.required = false;
							service.fieldSettings.memberCode.visible = false;
							service.fieldSettings.emailConfirmation.required = false;
							service.fieldSettings.emailConfirmation.visible = false;
							service.fieldSettings.birthDate.required = false;
							service.fieldSettings.birthDate.visible = false;
					 }
					},
					season_pass_name_num_child:
					{
						views: ['seasonPass'],
						name: 'season_pass_name_num_child',
						init: function() {
							service.fieldSettings.memberCode.required = false;
							service.fieldSettings.memberCode.visible = false;
							service.fieldSettings.hadPass.required = false;
							service.fieldSettings.hadPass.visible = false;
							service.fieldSettings.emailConfirmation.required = false;
							service.fieldSettings.emailConfirmation.visible = false;
							service.fieldSettings.birthDate.required = false;
							service.fieldSettings.birthDate.visible = false;

							service.formOptions.showSecondaryPassholder = true;
							service.formOptions.showTwoGuests = false;
							service.formOptions.showChildCounter = true;
					 }
					},
					season_pass_name_num_child_guest:
					{
						views: ['seasonPass'],
						name: 'season_pass_name_num_child_guest',
						init: function() {
							service.fieldSettings.memberCode.required = false;
							service.fieldSettings.memberCode.visible = false;
							service.fieldSettings.hadPass.required = false;
							service.fieldSettings.hadPass.visible = false;
							service.fieldSettings.emailConfirmation.required = false;
							service.fieldSettings.emailConfirmation.visible = false;
							service.fieldSettings.birthDate.required = false;
							service.fieldSettings.birthDate.visible = false;

							service.formOptions.showSecondaryPassholder = true;
							service.formOptions.showTwoGuests = true;
							service.formOptions.showChildCounter = true;
					 }
					},
					season_pass_norenew:
					{
						views: ['seasonPass'],
						name: 'season_pass_norenew',
						init: function() {
							service.fieldSettings.memberCode.required = false;
							service.fieldSettings.memberCode.visible = false;
							service.fieldSettings.emailConfirmation.required = false;
							service.fieldSettings.emailConfirmation.visible = false;
							service.fieldSettings.birthDate.required = false;
							service.fieldSettings.birthDate.visible = false;
							service.fieldSettings.hadPass.required = false;
							service.fieldSettings.hadPass.visible = false;
					 }
					},
					small_season_pass:
					{
						views: ['seasonPass'],
						name: 'small_season_pass',
						init: function() {
							var fieldsArr =
							{
								age: {
									required: true,
									visible: true,
									copyable: false,
									characProp: 'ph_age'
								},
								email: {
									required: true,
									visible: true,
									copyable: true,
									characProp: 'ph_email'
								},
								firstName: {
									required: true,
									visible: true,
									copyable: false,
									characProp: 'ph_first_name'
								},
								hadPass: {
									required: true,
									visible: true,
									copyable: false,
									characProp: 'ph_had_pass'
								},
								lastName: {
									required: true,
									visible: true,
									copyable: true,
									characProp: 'ph_last_name'
								},
								zip: {
									required: true,
									visible: true,
									copyable: true,
									characProp: 'ph_zip'
								},
								emailConfirmation: {
									required: false,
									visible: false,
									copyable: true,
									characProp: 'emailConfirmation'
								}
							};

						 if (service.fieldSettings.biometricsRequired.required) {
								// if the merchant is requiring biometrics, they should be included on the small_season_pass, as well.
								fieldsArr.biometricsRequired = {
									required: true,
									visible: true,
									copyable: true,
									characProp: 'biometrics_required'
								};
							}

							service.formOptions.showEmailConfirmation = false;

							for (var key in service.fieldSettings) {
								var hasKey = false;

								for (var key2 in fieldsArr) {
									if (key == key2) {
										hasKey = true;
										service.fieldSettings[ key ] = fieldsArr[ key ];
										break;
									}
								}

								if (!hasKey) {
									try {
										service.fieldSettings[ key ].required = false;
										service.fieldSettings[ key ].visible = false;
									} catch (e) {}
								}
							}

							// show a modal upon open if modal package characs are present
							if (Utilities.safelyCheckPropertyOnObject('Package.packageDetails.CHARACS.open_modal_locale_target_msg', Package) &&
								Utilities.safelyCheckPropertyOnObject('Package.packageDetails.CHARACS.open_modal_locale_target_title', Package)) {
								Modal.displayModal(
									{
										category: 'Small Season Pass',
										action: 'Modal',
										label: 'Disclaimer',
										title: Language.getLocale('XMCSmallSeasonPass', Package.packageDetails.CHARACS.open_modal_locale_target_title),
										description: Language.getLocale('XMCSmallSeasonPass', Package.packageDetails.CHARACS.open_modal_locale_target_msg)
									}
								);
							}
							if (JSONValidator.validate('season_pass', AppData.settings.season_pass)) {
								var seasonPassConfig = JSON.parse(AppData.settings.season_pass);
								service.formOptions.showCopyInfoToPasses = !Utilities.getBoolean(seasonPassConfig.disable_copy_to_other_passes);
							}
						}
					},
					small_season_pass_membership:
					{
						views: ['seasonPass'],
						name: 'small_season_pass_membership',
						init: function() {
							service.type.small_season_pass.init();
					 }
					},
					small_season_pass_basic_info:
					{
						views: ['seasonPass'],
						name: 'small_season_pass_basic_info',
						init: function() {
							var fieldsArr =
						{
							email: {
								required: true,
								visible: true,
								copyable: true,
								characProp: 'ph_email'
							},
							firstName: {
								required: true,
								visible: true,
								copyable: false,
								characProp: 'ph_first_name'
							},
							lastName: {
								required: true,
								visible: true,
								copyable: true,
								characProp: 'ph_last_name'
							},
							zip: {
								required: true,
								visible: true,
								copyable: true,
								characProp: 'ph_zip'
							},
							emailConfirmation: {
								required: false,
								visible: false,
								copyable: true,
								characProp: 'emailConfirmation'
							}
						};

							service.formOptions.showEmailConfirmation = false;

							for (var key in service.fieldSettings) {
								var hasKey = false;

								for (var key2 in fieldsArr) {
									if (key == key2) {
										hasKey = true;
										service.fieldSettings[ key ] = fieldsArr[ key ];
										break;
									}
								}

								if (!hasKey) {
									try {
										service.fieldSettings[ key ].required = false;
										service.fieldSettings[ key ].visible = false;
									} catch (e) {}
								}
							}

							// show a modal upon open if modal package characs are present
							if (Utilities.safelyCheckPropertyOnObject('Package.packageDetails.CHARACS.open_modal_locale_target_msg', Package) &&
							Utilities.safelyCheckPropertyOnObject('Package.packageDetails.CHARACS.open_modal_locale_target_title', Package)) {
								Modal.displayModal(
									{
										category: 'Small Season Pass',
										action: 'Modal',
										label: 'Disclaimer',
										title: Language.getLocale('XMCSmallSeasonPass', Package.packageDetails.CHARACS.open_modal_locale_target_title),
										description: Language.getLocale('XMCSmallSeasonPass', Package.packageDetails.CHARACS.open_modal_locale_target_msg)
									}
								);
							}
						}
					},
					season_pass_thorpe:
					{
						views: ['seasonPass'],
						name: 'season_pass_thorpe',
						init: function() {
							service.fieldSettings.memberCode.required = false;
							service.fieldSettings.memberCode.visible = false;
							service.fieldSettings.age.required = false;
							service.fieldSettings.age.visible = false;
							service.fieldSettings.emailConfirmation.required = true;
							service.fieldSettings.emailConfirmation.visible = true;

							service.formOptions.showEmailConfirmation = true;
					 }
					},
					season_pass_thorpe_new:
					{
						views: ['seasonPass'],
						name: 'season_pass_thorpe_new',
						init: function() {
							service.fieldSettings.memberCode.required = false;
							service.fieldSettings.memberCode.visible = false;
							service.fieldSettings.age.required = false;
							service.fieldSettings.age.visible = false;
							service.fieldSettings.emailConfirmation.required = true;
							service.fieldSettings.emailConfirmation.visible = true;
							service.fieldSettings.hadPass.required = false;
							service.fieldSettings.hadPass.visible = false;

							service.formOptions.showEmailConfirmation = true;
					 }
					},
					season_pass_thorpe_renew:
					{
						views: ['seasonPass'],
						name: 'season_pass_thorpe_renew',
						init: function() {
							service.fieldSettings.memberCode.required = true;
							service.fieldSettings.memberCode.visible = true;
							service.fieldSettings.renewCode.required = true;
							service.fieldSettings.renewCode.visible = true;
							service.fieldSettings.memberCode.maxLength = 35;
							service.fieldSettings.memberCode.configValidation =
							{
								validation:
								{
									type: 'pattern',
									value: AppData.settings.season_pass_renew_code_length
								},
								  error:
								{
									type: 'modal',
									title: Language.getLocale('Alert', 'renewCodeErrorTitle'),
									description: Language.getLocale('Alert', 'renewCodeErrorMsg'),
									icon: 'icon-info red',
									buttonFlags: [Enums.buttonFlags.OK]
								}
							};
							service.fieldSettings.memberCode.placeholder = Language.getLocale('SeasonPass', 'renewCode');
							service.fieldSettings.memberCode.upperLabel = Language.getLocale('FormLabels', 'seasonPassRenew');
							service.fieldSettings.age.required = false;
							service.fieldSettings.age.visible = false;
							service.fieldSettings.emailConfirmation.required = true;
							service.fieldSettings.emailConfirmation.visible = true;
							service.fieldSettings.hadPass.visible = false;
							service.fieldSettings.hadPass.required = false;

							service.formOptions.showEmailConfirmation = true;
					 }
					},
					season_pass_family:
					{
						views: ['seasonPass'],
						name: 'season_pass_family',
						init: function() {
							service.fieldSettings.memberCode.required = false;
							service.fieldSettings.memberCode.visible = false;
							service.fieldSettings.age.required = false;
							service.fieldSettings.age.visible = false;
							service.fieldSettings.emailConfirmation.required = true;
							service.fieldSettings.emailConfirmation.visible = true;
							service.fieldSettings.hadPass.required = false;
							service.fieldSettings.hadPass.visible = false;
							service.fieldSettings.birthDate.visible = true;
							service.fieldSettings.birthDate.required = true;
							service.fieldSettings.birthDate.configValidation =
						{
							validation:
							{
								type: 'multipart',
								value: AppData.settings.rate_type_max_quantity || {},
								validateBy: { rateType: 'ct_id' }
							},
							error:
							{
								minAge:
								{
									type: 'modal',
									title: Language.getLocale('Alert', 'minAgeRequirementNotMetTitle'),
									description: Language.getLocale('Alert', 'minAgeRequirementNotMetMsg'),
									icon: 'icon-info red',
									buttonFlags: [Enums.buttonFlags.OK]
								},
								maxAge:
									{
										type: 'modal',
										title: Language.getLocale('Alert', 'maxAgeRequirementExceededTitle'),
										description: Language.getLocale('Alert', 'maxAgeRequirementExceededMsg'),
										icon: 'icon-info red',
										buttonFlags: [Enums.buttonFlags.OK]
									}
							}
						}

							service.formOptions.showEmailConfirmation = true;
							service.formOptions.showSameAddress = true;
					 }
					},
					season_pass_family_renew:
					{
						views: ['seasonPass'],
						name: 'season_pass_family_renew',
						init: function() {
							service.fieldSettings.memberCode.required = true;
							service.fieldSettings.memberCode.visible = true;
							service.fieldSettings.memberCode.maxLength = 35;
							service.fieldSettings.memberCode.configValidation =
							{
								validation:
								{
									type: 'pattern',
									value: AppData.settings.season_pass_renew_code_length
								},
								  error:
								{
									type: 'modal',
									title: Language.getLocale('Alert', 'renewCodeErrorTitle'),
									description: Language.getLocale('Alert', 'renewCodeErrorMsg'),
									icon: 'icon-info red',
									buttonFlags: [Enums.buttonFlags.OK]
								}
							};

							service.fieldSettings.age.required = false;
							service.fieldSettings.age.visible = false;
							service.fieldSettings.emailConfirmation.required = true;
							service.fieldSettings.emailConfirmation.visible = true;
							service.fieldSettings.hadPass.required = false;
							service.fieldSettings.hadPass.visible = false;
							service.fieldSettings.birthDate.visible = true;
							service.fieldSettings.birthDate.required = true;
							service.fieldSettings.memberCode.placeholder = Language.getLocale('SeasonPass', 'renewCode');
							service.fieldSettings.memberCode.upperLabel = Language.getLocale('FormLabels', 'seasonPassRenew');
							service.fieldSettings.birthDate.configValidation =
						{
							validation:
							{
								type: 'multipart',
								value: AppData.settings.rate_type_max_quantity || {},
								validateBy: { rateType: 'ct_id' }
							},
							error:
							{
								minAge:
								{
									type: 'modal',
									title: Language.getLocale('Alert', 'minAgeRequirementNotMetTitle'),
									description: Language.getLocale('Alert', 'minAgeRequirementNotMetMsg'),
									icon: 'icon-info red',
									buttonFlags: [Enums.buttonFlags.OK]
								},
								maxAge:
									{
										type: 'modal',
										title: Language.getLocale('Alert', 'maxAgeRequirementExceededTitle'),
										description: Language.getLocale('Alert', 'maxAgeRequirementExceededMsg'),
										icon: 'icon-info red',
										buttonFlags: [Enums.buttonFlags.OK]
									}
							}
						}

							service.formOptions.showEmailConfirmation = true;
							service.formOptions.showSameAddress = true;
					 }
					},
					season_pass_newpass:
					{
						views: ['seasonPass'],
						name: 'season_pass_newpass',
						init: function() {
							service.fieldSettings.memberCode.required = false;
							service.fieldSettings.memberCode.visible = false;
							service.fieldSettings.emailConfirmation.required = false;
							service.fieldSettings.emailConfirmation.visible = false;
							service.fieldSettings.age.visible = false;
							service.fieldSettings.age.required = false;
							service.fieldSettings.birthDate.visible = true;
							service.fieldSettings.birthDate.required = true;
					 }
					},
					season_pass_birth_date:
					{
						views: ['seasonPass'],
						name: 'season_pass_birth_date',
						init: function() {
							service.fieldSettings.memberCode.required = false;
							service.fieldSettings.memberCode.visible = false;
							service.fieldSettings.emailConfirmation.required = false;
							service.fieldSettings.emailConfirmation.visible = false;
							service.fieldSettings.age.visible = false;
							service.fieldSettings.age.required = false;
							service.fieldSettings.birthDate.visible = true;
							service.fieldSettings.birthDate.required = true;
							service.fieldSettings.hadPass.visible = false;
							service.fieldSettings.hadPass.required = false;
					 }
					},
					season_pass_renewal:
					{
						views: [Enums.extraFlowRoutes.SEASON_PASS_RENEWALS],
						name: 'season_pass_renewal',
						swapRenewalCharacs: undefined,
						init: function(settings) {
							service.fieldSettings.memberCode.required = false;
							service.fieldSettings.memberCode.visible = false;
							service.fieldSettings.emailConfirmation.required = false;
							service.fieldSettings.emailConfirmation.visible = false;
							service.fieldSettings.age.required = false;
							service.fieldSettings.age.visible = false;
							service.fieldSettings.province.required = false;
							service.fieldSettings.hadPass.visible = false;
							service.fieldSettings.hadPass.required = false;

											 if (Utilities.safelyCheckPropertyOnObject('Package.packageDetails.CHARACS.license_plate_capture', Package)) {
								service.fieldSettings.licensePlate.visible = true;

								//If the license plate input is visible, set the max input to be 8 or what is in the app config.
								if (Utilities.safelyCheckPropertyOnObject('AppData.settings.license_plate_max_length', AppData)) {
									service.fieldSettings.maxLicensePlateLength = Number(AppData.settings.license_plate_max_length);
								} else {
									service.fieldSettings.maxLicensePlateLength = 8;
								}
							}

							if (settings) {
								for (var i in settings) {
									var propName = 'extraflow_' + i;
									service.fieldSettings[propName] = getExtraFlowXMCSetting(this.name, settings[i]);
								}
							}

											 this.hasSwapRenewalCharacs = hasRenewalOptionPkgCharacs();
						}
					}
				}
			};

		// Current index of view (relevant when XMC requires multiple views).
	var currentViewIndex = -1;
	var renewalStepUrl = '/views/templates/seasonPassRenewalStep1.html';
	var passRegistrationUrl = '/views/templates/seasonPassRenewalStep2.html';
	var formFieldOverrides = {};
	var isArray = angular.isArray;


	// This is set on init().
	service.xfcOptions = null;

	/**
		 * Initializes the Season Pass Service
		 * @public
		 * @param Package
		 * @returns {null}
		 */
	service.init = function(packageId) {
		if (!Package.initXFC(packageId)) {
			return true;
		}

		// Reset default options.
		reset();

		// Get settings for this XFC and load appropriate view.

		try {
			service.xfcOptions = (angular.isDefined(service.type[ Package.settings.name ]) ? service.type[ Package.settings.name ] : service.type[Package.settings.parentName]);
			service.xfcOptions.view = service.xfcOptions.views[ 0 ];
			service.xfcOptions.init(Package.settings);
		} catch (e) {
			// No options for this XMC.
			Package.nextXFC();
			return;
		}

		if (typeof (service.xfcOptions) == 'undefined') {
			// No options for this XMC. Assume we can continue.
			Package.nextXFC();
			return;
		}
		formFieldOverrides = setFormFieldOverrides();

		// Reset the currentViewIndex.
		currentViewIndex = -1;

		// Route to the first view.
		service.nextView();
	}

	/**
		 * Navigates to the next view
		 * @public
		 */
	service.nextView = function() {
		if (!service.xfcOptions) {
			// Error. xfcOptions has not been set by controller.
			return;
		}

		// Update the currentViewIndex to navigate to that view.
		currentViewIndex++;

		if (currentViewIndex < service.xfcOptions.views.length) {
			$rootScope.routeTo(service.xfcOptions.views[ currentViewIndex ] + '/' + Package.packageDetails.id);
		} else {
			// This was the final view. Delegate control back to package service.

			// Determine if we need to show the interstitial dining upsell for Six Flags
			determineInterstitialDining();
		}
	}

	function determineInterstitialDining() {
		try {
			var hasInterstitial = false;

			if (Utilities.safelyCheckPropertyOnObject('Package.packageDetails.CHARACS.interstitial_dining_keyword', Package)) {
				// yes, let's go! but which one

				var interstitialDiningKeyword = Package.packageDetails.CHARACS.interstitial_dining_keyword;

				// if a package exists, then go to the interstitial dining module

				var interstitialPackage = Package.filterPackagesByKeyword(AppData.GetMerchantPackageList.PS.P, interstitialDiningKeyword);

				if (interstitialPackage.length !== 0 &&
						InterstitialDiningService.determineEligibility(interstitialPackage[0].id)) {
					hasInterstitial = true;
					InterstitialDiningService.diningPackage = interstitialPackage[0];

					// determine proper route based on business rules + charac
					var flowType = InterstitialDiningService.determineFlowType();

					if (flowType) {
						return $rootScope.routeTo($state.href(InterstitialDiningConstants.CHOICE_STATE, {
							flowType: flowType,
							packageId: interstitialPackage[0].id
						}));
					} else {
						hasInterstitial = false;
					}
				}
			}

			if (!hasInterstitial) {
				Package.nextXFC();
			}
		} catch (e) {
			Package.nextXFC();
		}
	}

	/**
		 * Navigates to the previous view.
		 * If the current view is the first view, cancels XFC and delegates control
		 * back to the package service
		 * @public
		 */
	service.previousView = function() {
		currentViewIndex--;
		if (currentViewIndex > service.xfcOptions.views.length) {
			$rootScope.routeTo(service.xfcOptions.views[ currentViewIndex ] + '/' + Package.packageDetails.id);
		} else {
			// This was the first view. Delegate control back to package service.
			Package.cancelXFC();
		}
	}

	/**
		 * Cancels package service XFC
		 * @public
		 */
	service.cancel = function() {
		Package.cancelXFC();
	}

	/**
		 * getSeasonPassRenewalInfo -method to call GETRENEWALSEASONPASSINFO
		 * from backend to verify season pass renewal info
		 * This call only returns one passholder within the PASSHOLDER object portion of response
		 * @param request - the request object
		 * @param callback - function to execute on successful return of verified pass
		 */
	service.getSeasonPassRenewalInfo = function(request, requestName, callback) {
		// Add reference of request in pendingRequests.
		$rootScope.pendingRequests.push(requestName);
		$rootScope.showSpinner(Language.getLocale('ApplicationLabels', 'seasonPassVerification'));
		AppData.fetch
		(
			requestName
			, false
			, request
		).then
		(
			function(data) {
				if (data.status == Enums.status.OK && data.RENEWAL) {
					if (callback) {
						var renewalData = angular.isArray(data.RENEWAL) ? data.RENEWAL[0] : data.RENEWAL;
						callback(renewalData);
					}
				} else {
					$rootScope.hideSpinner();
					Modal.displayModal({
						category: 'Season Pass Renewal Error',
						action: 'Renewal Errors',
						title: Language.getLocale('SeasonPassRenewal', 'spRenewalVerificationFailTitle'),
						label: 'Error Retrieving Season Pass Verification',
						icon: 'icon-info red',
						description: Language.getLocale('SeasonPassRenewal', 'spRenewalVerificationFailMsg'),
						buttonFlags: [Enums.buttonFlags.OK]
					});
				}

				$rootScope.removePendingRequest(requestName);
			}
		);
	}


	/**
		 * valuateShowRenewalOption -method to assess whether to show renewal option to guest based on certain conditions
		 * Condition 1: checks the packageDetailCT for renewal flag to be set to 1
		 * OR Condition 2: checks the package characs on the xfcOptions showRenewalOptionPkgCharacIndicators
		 * are on the packageDetails object
		 * @param item
		 * @returns {boolean} true or false to indicate whether to show the renewal option screen
		 */
	service.valuateShowRenewalOption = function(itemToBeAdded) {
		return service.isRenewalCustomerType(itemToBeAdded.customer_type) || service.xfcOptions.hasSwapRenewalCharacs;
	}

	/**
		 * Assesses whether or not the customer types have the renewal flag of 1
		 * @param customerTypeId
		 * @param packageDetails
		 * @returns {boolean}
		 */
	service.isRenewalCustomerType = function(customerTypeId) {
		var isRenewalCT = false;

		if (angular.isDefined(customerTypeId) && angular.isDefined(Package.packageDetails.CT) && Package.packageDetails.CT.length > 0) {
			var packageItemDetailCTNode = Package.packageDetails.CT.filter(function(ctType) {
				return ctType.id == customerTypeId;
			}
			)[0];

			if (angular.isDefined(packageItemDetailCTNode) && Utilities.getBoolean(packageItemDetailCTNode.renewal_flag)) {
				isRenewalCT = true;
			}
		}

		return isRenewalCT;
	}

	/**
		 * Retrieve the baseCustomerTypeInfo (if available) on a
		 * @param customerType
		 * @returns {Object} - the base customer type info or an empty object
		 */
	service.getBaseCustomerTypeInfo = function(customerType) {
		var baseCustomerType = [];
		var packageDetails = Package.packageDetails;
		if (angular.isDefined(packageDetails) && angular.isDefined(packageDetails.CT) && angular.isArray(packageDetails.CT)) {
			for (var i=0; i < packageDetails.CT.length; i++) {
				var ctNode = packageDetails.CT[i];
				if (ctNode.id == customerType) {
					if (angular.isDefined(ctNode.base_customer_type)) {
						baseCustomerType = packageDetails.CT.filter(function(item) {
							return item.id == ctNode.base_customer_type;
						});
						break;
					}
				}
			}
		}
		return (baseCustomerType.length > 0 ? baseCustomerType[0] : {});
	}

	/**
		 * Copied this function from SeasonPassForm directive
		 * This function splits the package items added into two separate items for season passes
		 * This is a requirement
		 */
	service.splitPackageItemsToBeAdded = function() {
		// TODO: Spliting takes place in LegacyCart. Remove dependency of this function if possible.
		var items = [];
		for (var i = 0; i < Package.itemsToBeAdded.length; i++) {
			for (var j = 0; j < Package.itemsToBeAdded[ i ].qty; j++) {
				var copy = JSON.parse(JSON.stringify(Package.itemsToBeAdded[ i ]));

				if (!Package.itemsToBeAdded[ i ].CHARACS[ j ].isSeasonPass) {
					continue;
				}

				delete copy.CHARACS;

				copy.qty = 1;
				copy.CHARACS = [Package.itemsToBeAdded[ i ].CHARACS[ j ] || {}];

				items.push(copy);
			}
		}

		Package.itemsToBeAdded = items;
	}


	/**
		 * Swap the packageItemsToBeAdded customer type with the base_customer_type
		 * Used for the case when a user is on the renewal flow but opts to purchase a new season pass
		 * @param itemToBeAdded - the item we need to swap the customer_type on
		 * @param baseCustomerType
		 */
	service.swapPackageWithBaseCustomerType = function(itemToBeAdded, baseCustomerType) {
		if (angular.isDefined(baseCustomerType)) {
			itemToBeAdded.customer_type = baseCustomerType.id;
			itemToBeAdded.client_rate_name = baseCustomerType.name;
			if (angular.isDefined(itemToBeAdded.CHARACS) &&
					angular.isArray(itemToBeAdded.CHARACS) &&
					itemToBeAdded.CHARACS.length >0) {
				itemToBeAdded.CHARACS[0].shop_rate_name = baseCustomerType.name;
			}
		}
	}

	/**
		 * Create and return a data model for season pass renewals
		 *
		 * @returns {Array}
		 */
	service.createRenewalDataModel =function(isAutoFill) {
		//initialize the ph charac properties from the Seasonpass service
		var characs = JSON.parse(JSON.stringify(service.characProps));

		//renewal data models require ph_birth_date so we need to ensure that property is not undefined here but rather initialized as an empty string
		characs.ph_birth_date = '';

		var regex = new RegExp('\\b' + Package.settings.name + '\\b');
		angular.extend(characs, getRenewalPassThroughPackageCharacs());
		var formid = 0;
		var passData = [];
		var itemsToBeAdded = Package.itemsToBeAddedForCurrentPackage();

		itemsToBeAdded.forEach(function(item, index) {
			//another side effect of season passes - some items in the cart may NOT be season passes, so make sure the extra movie matches item in the pre-cart otherwise,
			// don't add it to the scope data model
			var extra_movie = (Package.isEditing()) ? Package.packageDetails.extra_movie : item.extra_movie;
			if (angular.isDefined(extra_movie) && extra_movie.search(regex) > -1) {
				var showRenewalOption = service.valuateShowRenewalOption(item);
				for (var i = 0; i < item.qty; i++) {
					var pass = {
						itemsAddedIndex: index,
						characsIndex: i,
						valid: false,
						submitted: false,
						rateType: angular.copy(item.customer_type),
						rateName: angular.copy(item.client_rate_name),
						formID: 'theForm_' + (++formid),
						formIndex: formid,
						passIndexInfo: '',
						isCurrentTicket: false,
						showRenewalOption: showRenewalOption,
						renewalSelected: !!showRenewalOption,
						isRenewalCustomerType: service.isRenewalCustomerType(item.customer_type),
						package_id: angular.copy(item.package_id),
						baseCustomerTypeInfo: service.getBaseCustomerTypeInfo(item.customer_type)
					};

						// If the group_uuid is defined, we need to capture it. We'll need it later,
						// to identify which addons should be associated with which package.
					if (angular.isDefined(item.CHARACS[i].group_uuid)) {
						pass.group_uuid=item.CHARACS[i].group_uuid;
					}
					angular.extend(pass, characs);
					pass.copy_to_billing = !!((i == 0 && index == 0));
					pass.ph_season_pass_number = ''; //reset pass number
					pass.ph_year = Package.packageDetails.season_pass_year; //set ph_year
					pass.verificationOption = (showRenewalOption ? Package.settings.searchOptions[0] : null);
					pass.verificationValue = '';
					pass.verificationValueFirstName = '';
					pass.verificationValueLastName = '';
					prefillFormData(pass, index, i, isAutoFill);

					//set starting state
					if (!showRenewalOption) {
						//start at new pass form
						pass.currentState = Enums.spStates.NEWPASSFORM;
					} else {
						//assess whether starting at renewal pass form or selection screen
						pass.currentState = (Package.isEditing() ? Enums.spStates.RENEWALPASSFORM : Enums.spStates.SELECTION);
					}

					passData.push(pass);
					item.CHARACS[i].isSeasonPass = true;
				}
			}
		});
		service.setPassIndexInfo(passData);
		service.fieldSettings.allowRenewalFlowCopyPasses = service.allowCopyPassesInRenewalFlow(passData);
		return passData;
	}


	/**
		 * Set the display of the pass index on the mobile views for renewal/option renewal flow
		 * @param passData
		 */
	service.setPassIndexInfo = function(passData) {
		var total = passData.length;
		passData.forEach(function(pass, index) {
			if (angular.isDefined(Language.SeasonPassRenewal) && angular.isDefined(Language.SeasonPassRenewal.passIndexIndicator)) {
				var indicatorInfo = Language.getLocale('SeasonPassRenewal', 'passIndexIndicator').replace('@@index', index + 1);
				pass.passIndexInfo = indicatorInfo.replace('@@total', total);
			}
		});
	}

	/**
		 * Check if the form should allow to copy to other passes (Renewal Flow)
		 * @param passData
		 * @returns {boolean}
		 */
	service.allowCopyPassesInRenewalFlow = function(passData) {
		return passData.filter(function(pass) {
			return (pass.isRenewalCustomerType);
		}).length == 0;
	}

	/**
		 * This executes only for the renewal flow
		 * Copy all info except (first name, sex and DOB) to other NEW passes (Renewals are NOT eligible)
		 * @param pass
		 * @param passData
		 */
	service.copyInfoToOtherNewPasses = function(pass, passData) {
		var skipFieldsFromCopyToPasses = Utilities.safelyCheckPropertyOnObject('Package.packageDetails.CHARACS.skip_copy_to_passes_fields', Package) ? Package.packageDetails.CHARACS.skip_copy_to_passes_fields.split(',') : [];
		if (Package.settings.name == 'season_pass_cf_v2_copy_email') {
			skipFieldsFromCopyToPasses.push('ph_email');
		}
		if (pass.copy_to_passes) {
			passData.forEach(function(item) {
				if (!item.valid && !item.isRenewalCustomerType) {
					for (var i in service.fieldSettings) {
						var prop = service.fieldSettings[i];
						var characName = prop.characProp;

						//only copy the copyable props to
						// item.mediaNumber is defined on passes that are associated with folios. For those passes, the name should not be overwritten
						if (prop.copyable && angular.isDefined(characName) && angular.isDefined(item[characName]) &&
								skipFieldsFromCopyToPasses.indexOf(characName) === -1 &&
								(! (angular.isDefined(item.mediaNumber) && prop.characProp=='lastName'))
						) {
							//copy the charac property to the pass
							item[prop.characProp] = pass[prop.characProp];
						}
					}
					item.infoCopiedFromOtherPass = true;
				}
			});
		}
	}

	/**
		 * Assess if the season pass number is renewed in the cart
		 * @param passNumber
		 * @returns {boolean}
		 */
	service.checkSeasonPassNumberRenewedInCart = function(passNumber) {
		var found = false;
		for (var i = 0; i< LegacyCart.cartItems.length; i++) {
			var item = LegacyCart.cartItems[i];
			if (Utilities.safelyCheckPropertyOnObject('item.CHARACS', item, function(characs) {
				return angular.isArray(characs) && characs.length > 0 &&
						angular.isDefined(characs[0].ph_season_pass_number) && characs[0].ph_season_pass_number === passNumber;
			})) {
				found = true;
				break;
			}
		}

		return found;
	};

	/**
		 * prefill the form data or use
		 * @param passData
		 * @param index
		 */
	function prefillFormData(pass, index, characsIndex, isAutoFill) {
		// Dev mode only. Pre-populate the pass information.
		if (isAutoFill &&
				(typeof(pass.ph_first_name) == 'undefined' ||
					pass.ph_first_name == '')) {
			pass.ph_address = '212 Main St';
			pass.ph_address2 = 'Suite 1001';
			pass.ph_age = '34';
			pass.ph_birth_date = '02/01/2008';
			pass.ph_city = 'Orlando';
			pass.ph_country_code = 'US';
			pass.ph_email = 'shopv5dev@accesso.com';
			pass.emailConfirmation = 'shopv5dev@accesso.com';
			pass.ph_first_name = 'Test';
			pass.ph_had_pass = 'Y';
			pass.ph_home_phone = '1234567890';
			pass.ph_phone_number = '1234567890';
			pass.ph_last_name = 'Accesso';
			pass.ph_member_code = '29729348570245';
			pass.ph_mi = 'M';
			pass.ph_province = 'FL';
			pass.ph_state = 'FL';
			pass.ph_sex = 'm';
			pass.ph_zip = '32765';
			pass.copy_to_billing = true;
		}

		var passInfo = undefined;
		var currentItemToBeAddedCharacs = Package.itemsToBeAdded[index].CHARACS[characsIndex];

		if (UserInfo.get('seasonPass')!==undefined && UserInfo.get('seasonPass').length > index) {
			passInfo = UserInfo.get('seasonPass')[index];
		} else if (Package.isEditing() || (angular.isDefined(currentItemToBeAddedCharacs.ph_first_name) &&
				currentItemToBeAddedCharacs.ph_first_name.length > 0)) {
			passInfo = currentItemToBeAddedCharacs;
		}

		if (passInfo!==undefined) {
			service.copyCharacs(passInfo, pass);
			pass.valid = true;
			pass.formIsPreFilled = true;
			if (angular.isDefined(passInfo.renewal_pass) && passInfo.renewal_pass =='0') {
				pass.renewalSelected = false;
			}
		} else {
			pass.formIsPreFilled = false;
		}
	}


	/**
		 * hasRenewalOptionPkgCharacs - check if any certain package characs exist that should trigger renewal option to show
		 * These are usually characs that initiate season pass swap chracs (in
		 *
		 * @param packageDetailsCharacs
		 * @returns {Boolean}
		 */
	function hasRenewalOptionPkgCharacs() {
		var hasRenewalOptionSwapCharacs = false;
		if (angular.isDefined(Package.packageDetails) && angular.isDefined(Package.packageDetails.CHARACS) &&
				angular.isDefined(Package.settings.swapOptions)) {
			var characNames = Object.keys(Package.packageDetails.CHARACS);
			for (var i = 0; i < characNames.length; i++) {
				if (Package.settings.swapOptions.indexOf(characNames[i]) > -1) {
					hasRenewalOptionSwapCharacs =true;
					break;
				}
			}
		}
		return hasRenewalOptionSwapCharacs;
	}

	/**
		 * get special package characs to add to the pass to carry onto the addCartItem call
		 * @returns {{object}} of special package characs for renewals
		 */
	function getRenewalPassThroughPackageCharacs() {
		var addedCharacs = {};
		if (angular.isDefined(Package.settings.specialPackageCharacs)) {
			Package.settings.specialPackageCharacs.forEach(function(item) {
				if (angular.isDefined(Package.packageDetails.CHARACS)
					&& angular.isDefined(Package.packageDetails.CHARACS[item])) {
					addedCharacs[item] =Package.packageDetails.CHARACS[item];
				}
			});
		}
		return addedCharacs;
	}

	/**
		 * setAndFinalizeCharacs - map the characs needed for the addCartItem call,
		 * add reference to XFC to characs, and go to next view
		 */
	service.finalizeRenewalXFC= function(passData) {
		var renewalError = false;
		passData.forEach(function(pass) {
			var packageItemCharacs = Package.itemsToBeAdded[pass.itemsAddedIndex].CHARACS[pass.characsIndex];

			//add Phcharacs and special package characs to packageItemCharacs first
			var passCharacs = Object.getOwnPropertyNames(pass).filter(function(key) {
				return shouldAddPropertyToItem(key);
			});
			passCharacs.forEach(function(characName) {
				packageItemCharacs[characName] = pass[characName];
			});

			//add guid and additional required characs if defined in Extraflow service for this XMC
			if (!Package.isEditing()) {
				packageItemCharacs.uid = Utilities.guid();
				pass.uid = packageItemCharacs.uid;
			}

			if (pass.renewalSelected) {
				//add specific characs to the package items if
				if (angular.isDefined(service.xfcOptions.hasSwapRenewalCharacs) && service.xfcOptions.hasSwapRenewalCharacs) {
					angular.extend(packageItemCharacs, Package.settings.swapCharacs['renewalWithSwapRenewalCharacs']);
				} else {
					angular.extend(packageItemCharacs, Package.settings.swapCharacs['defaultRenewal']);
				}
				if (angular.isDefined(Package.settings.renewalSelectedCharacs) && Object.keys(Package.settings.renewalSelectedCharacs).length > 0) {
					angular.extend(packageItemCharacs, Package.settings.renewalSelectedCharacs);
				}
			} else {
				angular.extend(packageItemCharacs, Package.settings.swapCharacs['newPassValues']);
				packageItemCharacs.ph_season_pass_number = Enums.spPassNumber.NEW; //triggers the backend to add as a new pass
			}

			// Failsafe for the instance that this charac is an empty string instead of 'NEW' or the number
			if (packageItemCharacs[ 'ph_season_pass_number' ] === '') {
				renewalError = true;
				showRenewalErrorModal(pass.package_id);
			}
		});
		if (!renewalError) {
			Package.removeItemsToBeAddedMarkedForDeletion();
			service.splitPackageItemsToBeAdded();

			service.pushSelectedAddOnPackages(Package.itemsToBeAdded, passData);

			//execute swapping customer type if needed after the items have been split so that the customer type on the item node can be changed
			Package.itemsToBeAdded.forEach(function(item) {
				var matchingPass = passData.filter(function(pass) {
					return pass.uid == item.CHARACS[0].uid && Utilities.getBoolean(pass.swapPackageWithBaseCustomerType);
				})[0];

				if (angular.isDefined(matchingPass)) {
					service.swapPackageWithBaseCustomerType(item, matchingPass.baseCustomerTypeInfo);
				}
			});

			// Add reference of XFC to CHARACs.
			ExtraFlow.addReferenceToCartItems(Package.settings.view, Package.itemsToBeAdded, ExtraFlow.CLIENT_XFC_VIEW);
			ExtraFlow.addReferenceToCartItems(Package.settings.name, Package.itemsToBeAdded, ExtraFlow.CLIENT_XFC_NAME);

			// Delegate control back to Seasonpass.
			service.nextView();
		}
	}

	// Show an error modal if a renewal pass has an empty ph_season_pass_number
	function showRenewalErrorModal(packageId) {
		$rootScope.hideSpinner();
		Modal.displayModal({
			category: 'Season Pass Charac Error',
			action: 'Error',
			label: 'Season Pass Empty ph_season_pass_number Charac Error',
			icon: 'icon-info red',
			title: Language.getLocale('SeasonPassRenewal', 'spRenewalCharacFailTitle'),
			description: Language.getLocale('SeasonPassRenewal', 'spRenewalCharacFailMsg'),
			buttonFlags: [Enums.buttonFlags.OK],
			callback: function() {
				$rootScope.routeTo(Enums.routes.DETAILS + '/' + packageId);
			}
		});
	}

	/**
		 * Calls GetSeasonPassCount to obtain the packages/quantities of comp packages to add
		 * onto the current items to be added
		 * @returns {Promise}
		 */
	service.getPackagesFromGetSeasonPassCount = function() {
		$rootScope.showSpinner();
		var pkgs = [];
		var request = getSeasonPassCountRequest();

		return AppData.fetch(
			Enums.services.GET_SEASON_PASS_COUNT
			, false
			, request
		).then(function(data) {
			if (data.status == Enums.status.OK && data.PACKAGES && data.PACKAGES.P) {
				pkgs = !angular.isArray(data.PACKAGES.P) ? [data.PACKAGES.P] : data.PACKAGES.P;
			}
			$rootScope.hideSpinner();
			return pkgs;
		},
		function(err) {
			$rootScope.hideSpinner();
			$log.error('Error with Get Season Pass Count');
			return pkgs;
		}
		);
	};

	/**
		 * Create a request to call GetSeasonPassCount
		 * @returns {Object request}
		 */
	function getSeasonPassCountRequest() {
		var request = {
			cart_id: AppData.cart.cart_id,
			merchant_id: AppData.merchantId,
			P: []
		}

		Package.itemsToBeAddedForCurrentPackage().forEach(function(pkg) {
			request.P.push({
				ct: pkg.customer_type,
				id: pkg.package_id,
				qty: pkg.qty
			})
		});

		return request;
	}

	/**
		 * shouldAddPropertyToSeasonPassItem - if the key is a ph_ key or is within
		 * the specialPackageCharacs identified in the extraflow service
		 * or is one of the renewal verification characs identified in the extra flow
		 * returns true so that it can be added to the itemsToBeAdded characs, otherwise false
		 * @param key
		 * @returns {boolean}
		 */
	function shouldAddPropertyToItem(key) {
		return (key.indexOf('ph_') > -1
				|| Package.settings.specialPackageCharacs.indexOf(key) > -1
				|| Package.settings.renewalVerificationCharacs.filter(function(item) {
					return item.dataItem == key;
				}).length >0);
	}


	/***
		 * getExtraFlowXMCSetting if the extra flow setting has a default value and the name of the XMC does not
		 * have a setting other than the default this method returns that particular setting value for that setting
		 * otherwise the whole setting is returned
		 * @param setting the extra flow setting that pertains to the particular XMC or the default setting
		 */
	function getExtraFlowXMCSetting(XMCName, setting) {
		if (angular.isDefined(setting['default'])) {
			return angular.isDefined(setting[XMCName]) ? setting[XMCName] : setting['default'];
		} else {
			return setting;
		}
	}

	/**
		 * Resets the view back to an empty form
		 */
	function reset() {
		// This is set on init().
		service.xfcOptions = null;
		currentViewIndex = -1;

		// Default fields - gets overwritten by each XMC view.
		service.fieldSettings =
				{
					address: {
						required: true,
						visible: true,
						copyable: true,
						characProp: 'ph_address'
					},
					address2: {
						required: false,
						visible: true,
						copyable: true,
						characProp: 'ph_address2'
					},
					age: {
						required: true,
						visible: true,
						copyable: false,
						characProp: 'ph_age'
					},
					birthDate: {
						required: true,
						visible: true,
						copyable: false,
						characProp: 'ph_birth_date'
					},
					city: {
						required: true,
						visible: true,
						copyable: true,
						characProp: 'ph_city'
					},
					country: {
						required: true,
						visible: true,
						copyable: true,
						characProp: 'ph_country_code'
					},
					email: {
						required: true,
						visible: true,
						copyable: true,
						characProp: 'ph_email'
					},
					firstName: {
						required: true,
						visible: true,
						copyable: false,
						characProp: 'ph_first_name'
					},
					hadPass: {
						required: true,
						visible: true,
						copyable: false,
						characProp: 'ph_had_pass'
					},
					renewCode:	{
						required: false,
						visible: false,
						copyable: false,
						characProp: 'ph_renew_code'
					},
					lastName: {
						required: true,
						visible: true,
						copyable: true,
						characProp: 'ph_last_name'
					},
					licensePlate: {
						required: false,
						visible: false,
						copyable: true,
						characProp: 'ph_license'
					},
					memberCode: {
						required: true,
						visible: true,
						copyable: false,
						characProp: 'ph_member_code',
						maxLength: 32,
						placeholder: Language.getLocale('FormLabels', 'memberCode'),
						upperLabel: false,
						configValidation: {
							validation: null,
							error: null
						}
					},
					mi: {
						required: false,
						visible: true,
						copyable: false,
						characProp: 'ph_mi'
					},
					homePhone: {
						required: true,
						visible: true,
						copyable: true,
						characProp: 'ph_home_phone'
					},
					phoneNumber: {
						required: true,
						visible: true,
						copyable: true,
						characProp: 'ph_home_phone'
					},
					province: {
						required: true,
						visible: true,
						copyable: true,
						characProp: 'ph_province'
					},
					sex: {
						required: true,
						visible: true,
						copyable: false,
						characProp: 'ph_sex'
					},
					state: {
						required: true,
						visible: true,
						copyable: true,
						characProp: 'ph_state'
					},
					zip: {
						required: true,
						visible: true,
						copyable: true,
						characProp: 'ph_zip'
					},
					emailConfirmation: {
						required: true,
						visible: true,
						copyable: true,
						characProp: 'emailConfirmation'
					},
					applyBillingRadio: {
						required: false,
						visible: true
					},
					sameAddress: {
						required: false,
						visible: false,
						copyable: true,
						characProp: 'same_address'
					},
					biometricsRequired: {
						required: false,
						visible: false,
						copyable: true,
						characProp: 'biometrics_required'
					}
				};

		service.fieldSettings.biometricsRequired.required = Utilities.getBoolean(AppData.settings.biometrics_required);
		service.fieldSettings.biometricsRequired.visible = service.fieldSettings.biometricsRequired.required;

		service.allAvailableCharacKeys = function() {
			var keySet = [];

			for (var k in service.characProps) {
				keySet.push(k);
			}

			return keySet;
		};

		service.copyCharacs = function(from, to) {
			var masterCharacs = service.allAvailableCharacKeys();

			var transformers = {
				ph_birth_date: function(k) {
					return Utilities.formatYYYY_MM_DDToSetDateFormat(k, 'MM/dd/yyyy');
				},
				ph_sex: function(k) {
					return k.toLowerCase();
				}
			};

			masterCharacs.forEach(function(k) {
				if (from[k]!==undefined) {
					to[k] = from[k];

					if (transformers[k]!==undefined) {
						to[k] = transformers[k](from[k]);
					}
				}
			});

			// replaceMedia is a charac that is only needed for season passes that are associated with folios.
			// It is not a part of AllAvailableCharacKeys, so we need to copy it here.
			if (angular.isDefined(from.replaceMedia)) {
				to.replaceMedia = from.replaceMedia;
			}
		};

		// Data model template for demographics.
		service.characProps = {
			ph_address: '',
			ph_address2: '',
			ph_age: undefined,
			ph_birth_date: undefined,
			ph_city: '',
			ph_country_code: '',
			ph_email: '',
			ph_first_name: '',
			ph_had_pass: '',
			ph_home_phone: '',
			ph_last_name: '',
			ph_member_code: '',
			ph_mi: '',
			ph_phone_number: '',
			ph_province: '',
			ph_sex: undefined,
			ph_state: '',
			ph_zip: '',
			ph_year: undefined,
			ph_season_pass_number: 'NEW',
			ph_park_passholder_id: '',
			ph_park_passholder_id2: '',
			copy_to_billing: true,
			copy_to_passes: (angular.isDefined(Package.packageDetails.CHARACS) && Utilities.getBoolean(Package.packageDetails.CHARACS.copy_to_passes_default)),
			same_address: false,
			emailConfirmation: '',
			promptedToCopyPassData: false,
			promptedForMinAge: false,
			biometrics_required: true
		};

		// Default form options.
		service.formOptions = {
			showCopyInfoToBilling: true,
			showEmailConfirmation: false,
			showCopyInfoToPasses: true,
			postalCodeDataType: 'text',
			minAgeRequirement: (angular.isDefined(AppData.settings.dob_minimum_age) ? Utilities.forceInt(AppData.settings.dob_minimum_age) : 0),
			showSameAddress: false,
			showSecondaryPassholder: false,
			showTwoGuests: false,
			showChildCounter: false,
			useJapaneseAddressSyntax: AppData.useJapaneseAddressSyntax()
		};
	}


	/**
		 * Pushes selected addon (oneBarcode) packages to the array that is passed to the itemsToBeAdded parameter
		 * The original array will be modified in place if there are any addon pacakges selected.
		 * If there are no selected addon packages the array will not be unmodified.
		 *
		 * @param itemsToBeAdded {Array} Selected addon pacakges will be appended to this array
		 * @param passData {Array} The array of season pass forms that contains guest selections
		 */
	service.pushSelectedAddOnPackages = function(itemsToBeAdded, passData) {
		var addOnPackages = [];

		for (var i = 0; i < itemsToBeAdded.length; i++) {
			var item = itemsToBeAdded[ i ];
			var formItemData = passData[i] || {};

			// Determine One Barcode eligibility
			if (Utilities.childDefined(Package.packageDetails.CHARACS, 'oneBarcodeKeyword')) {
				var groupUUID = Package.isEditing() ? item.CHARACS[0].group_uuid : Utilities.guid();
				item.CHARACS[ 0 ].group_uuid = groupUUID;
				item.CHARACS[ 0 ].one_barcode_parent = '1';

				formItemData.addOnPackages = formItemData.addOnPackages || [];

				if (angular.isArray(formItemData.addOnPackages) && formItemData.addOnPackages.length > 0) {
					angular.forEach(formItemData.addOnPackages, function(item, i) {
						var addOnPackage = {};
						addOnPackage.package_id = item.id;
						addOnPackage.name = item.name;
						addOnPackage.customer_type = item.CT[0].id;
						addOnPackage.qty = 1;
						addOnPackage.CHARACS = [];
						var characsObject = {};
						characsObject.group_uuid = groupUUID;

						addOnPackage.CHARACS.push(characsObject);


						addOnPackages.push(addOnPackage);
					});
				}
			}
		}

		// append selected Add On Packages to the itemsToBeAdded array if there are any
		if (addOnPackages.length > 0) {
			var addOnPackagesLength = addOnPackages.length;
			for (var addOnIndex = 0; addOnIndex < addOnPackagesLength; addOnIndex++) {
				itemsToBeAdded.push(addOnPackages[addOnIndex]);
			}
		}
	};

	/**
		 * parse demographic_form_field_overrides app config for field overrides and set them on the fieldSettings
		 * @protected
		 * @function
		 * @name setFormFieldOverrides
		 * @memberof {SeasonPass}
		 * @return {Object} demographic_form_field_overrides for the season pass form
		 */
	function setFormFieldOverrides() {
		var config,
			optional = [],
			remove = [],
			authTypes = [],
			i = 0,
			setting,
			configLength;
		if (JSONValidator.validate('demographic_form_field_overrides', AppData.settings.demographic_form_field_overrides)) {
			config = JSON.parse(AppData.settings.demographic_form_field_overrides);
			configLength = config.length;
			for (; i < configLength; i++) {
				if (config[i].forms.indexOf('season_pass') > -1) {
					optional = config[i].optional_fields;
					if (isArray(config[i].removed_fields)) {
						remove = config[i].removed_fields;
					}
					break;
				}
			}
			Object
				.keys(service.fieldSettings)
				.forEach(function(setting) {
					if (optional.indexOf(setting) > -1) {
						service.fieldSettings[setting].required = false;
					}
					if (remove.indexOf(setting) > -1) {
						service.fieldSettings[setting].visible = false;
					}
				});
			//Special case to remove email confirmation when email is optional
			if (optional.indexOf('email') > -1) {
				service.fieldSettings.emailConfirmation.required = false;
				service.fieldSettings.emailConfirmation.visible = false;
			}
		}
		return {
			formOptionalFields: optional,
			formRemoveFields: remove
		};
	}

	/**
		 * determine if the address section of the season pass form should be hidden
		 * @public
		 * @function
		 * @name shouldHideAddressColumn
		 * @memberof {SeasonPass}
		 * @return {Boolean} true if the address section is hidden
		 */
	service.shouldHideAddressColumn = function() {
		return formFieldOverrides.formRemoveFields.indexOf('addressFields') > -1;
	}

	return service;
}
)


angular.module('app').factory
('Security'
	, function($location
		, $log
		, $rootScope
		, $timeout
		, $window
		, Enums
	) {
		var security = {};

		security.generateUID = function() {
			function _p8(s) {
				var p = (Math.random().toString(16) + "000000000").substr(2, 8);
				return s ? "-" + p.substr(0, 4) + "-" + p.substr(4, 4) : p;
			}

			return _p8() + _p8(true) + _p8(true) + _p8();
		}

		// Taken from http://phpjs.org/functions/utf8_encode/
		security.utf8_encode = function(argString) {
			// http://kevin.vanzonneveld.net
			// +   original by: Webtoolkit.info (http://www.webtoolkit.info/)
			// +   improved by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
			// +   improved by: sowberry
			// +	tweaked by: Jack
			// +   bugfixed by: Onno Marsman
			// +   improved by: Yves Sucaet
			// +   bugfixed by: Onno Marsman
			// +   bugfixed by: Ulrich
			// +   bugfixed by: Rafal Kukawski
			// +   improved by: kirilloid
			// +   bugfixed by: kirilloid
			// *	 example 1: utf8_encode('Kevin van Zonneveld');
			// *	 returns 1: 'Kevin van Zonneveld'

			if (argString === null || typeof argString === "undefined") {
				return "";
			}

			var string = (argString + ''); // .replace(/\r\n/g, "\n").replace(/\r/g, "\n");
			var utftext = '',
				start,
				end,
				stringl = 0;

			start = end = 0;
			stringl = string.length;
			for (var n = 0; n < stringl; n++) {
				var c1 = string.charCodeAt(n);
				var enc = null;

				if (c1 < 128) {
					end++;
				} else if (c1 > 127 && c1 < 2048) {
					enc = String.fromCharCode(
						(c1 >> 6)		| 192,
						(c1		& 63) | 128
					);
				} else if (c1 & 0xF800 != 0xD800) {
					enc = String.fromCharCode(
						(c1 >> 12) | 224,
						((c1 >> 6) & 63) | 128,
						(c1		& 63) | 128
					);
				} else { // surrogate pairs
					if (c1 & 0xFC00 != 0xD800) {
						throw new RangeError("Unmatched trail surrogate at " + n);
					}
					var c2 = string.charCodeAt(++n);
					if (c2 & 0xFC00 != 0xDC00) {
						throw new RangeError("Unmatched lead surrogate at " + (n-1));
					}
					c1 = ((c1 & 0x3FF) << 10) + (c2 & 0x3FF) + 0x10000;
					enc = String.fromCharCode(
						(c1 >> 18) | 240,
						((c1 >> 12) & 63) | 128,
						((c1 >> 6) & 63) | 128,
						(c1		& 63) | 128
					);
				}
				if (enc !== null) {
					if (end > start) {
						utftext += string.slice(start, end);
					}
					utftext += enc;
					start = end = n + 1;
				}
			}

			if (end > start) {
				utftext += string.slice(start, stringl);
			}

			return utftext;
		};


		// Taken from http://phpjs.org/functions/md5/
		security.md5 = function(str) {
			// http://kevin.vanzonneveld.net
			// +   original by: Webtoolkit.info (http://www.webtoolkit.info/)
			// + namespaced by: Michael White (http://getsprink.com)
			// +	tweaked by: Jack
			// +   improved by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
			// +	  input by: Brett Zamir (http://brett-zamir.me)
			// +   bugfixed by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
			// -	depends on: utf8_encode
			// *	 example 1: md5('Kevin van Zonneveld');
			// *	 returns 1: '6e658d4bfcb59cc13f96c14450ac40b9'
			var xl;

			var rotateLeft = function(lValue, iShiftBits) {
				return (lValue << iShiftBits) | (lValue >>> (32 - iShiftBits));
			};

			var addUnsigned = function(lX, lY) {
				var lX4,
					lY4,
					lX8,
					lY8,
					lResult;
				lX8 = (lX & 0x80000000);
				lY8 = (lY & 0x80000000);
				lX4 = (lX & 0x40000000);
				lY4 = (lY & 0x40000000);
				lResult = (lX & 0x3FFFFFFF) + (lY & 0x3FFFFFFF);
				if (lX4 & lY4) {
					return (lResult ^ 0x80000000 ^ lX8 ^ lY8);
				}
				if (lX4 | lY4) {
					if (lResult & 0x40000000) {
						return (lResult ^ 0xC0000000 ^ lX8 ^ lY8);
					} else {
						return (lResult ^ 0x40000000 ^ lX8 ^ lY8);
					}
				} else {
					return (lResult ^ lX8 ^ lY8);
				}
			};

			var _F = function(x, y, z) {
				return (x & y) | ((~x) & z);
			};
			var _G = function(x, y, z) {
				return (x & z) | (y & (~z));
			};
			var _H = function(x, y, z) {
				return (x ^ y ^ z);
			};
			var _I = function(x, y, z) {
				return (y ^ (x | (~z)));
			};

			var _FF = function(a, b, c, d, x, s, ac) {
				a = addUnsigned(a, addUnsigned(addUnsigned(_F(b, c, d), x), ac));
				return addUnsigned(rotateLeft(a, s), b);
			};

			var _GG = function(a, b, c, d, x, s, ac) {
				a = addUnsigned(a, addUnsigned(addUnsigned(_G(b, c, d), x), ac));
				return addUnsigned(rotateLeft(a, s), b);
			};

			var _HH = function(a, b, c, d, x, s, ac) {
				a = addUnsigned(a, addUnsigned(addUnsigned(_H(b, c, d), x), ac));
				return addUnsigned(rotateLeft(a, s), b);
			};

			var _II = function(a, b, c, d, x, s, ac) {
				a = addUnsigned(a, addUnsigned(addUnsigned(_I(b, c, d), x), ac));
				return addUnsigned(rotateLeft(a, s), b);
			};

			var convertToWordArray = function(str) {
				var lWordCount;
				var lMessageLength = str.length;
				var lNumberOfWords_temp1 = lMessageLength + 8;
				var lNumberOfWords_temp2 = (lNumberOfWords_temp1 - (lNumberOfWords_temp1 % 64)) / 64;
				var lNumberOfWords = (lNumberOfWords_temp2 + 1) * 16;
				var lWordArray = new Array(lNumberOfWords - 1);
				var lBytePosition = 0;
				var lByteCount = 0;
				while (lByteCount < lMessageLength) {
					lWordCount = (lByteCount - (lByteCount % 4)) / 4;
					lBytePosition = (lByteCount % 4) * 8;
					lWordArray[lWordCount] = (lWordArray[lWordCount] | (str.charCodeAt(lByteCount) << lBytePosition));
					lByteCount++;
				}
				lWordCount = (lByteCount - (lByteCount % 4)) / 4;
				lBytePosition = (lByteCount % 4) * 8;
				lWordArray[lWordCount] = lWordArray[lWordCount] | (0x80 << lBytePosition);
				lWordArray[lNumberOfWords - 2] = lMessageLength << 3;
				lWordArray[lNumberOfWords - 1] = lMessageLength >>> 29;
				return lWordArray;
			};

			var wordToHex = function(lValue) {
				var wordToHexValue = "",
					wordToHexValue_temp = "",
					lByte,
					lCount;
				for (lCount = 0; lCount <= 3; lCount++) {
					lByte = (lValue >>> (lCount * 8)) & 255;
					wordToHexValue_temp = "0" + lByte.toString(16);
					wordToHexValue = wordToHexValue + wordToHexValue_temp.substr(wordToHexValue_temp.length - 2, 2);
				}
				return wordToHexValue;
			};

			var x = [],
				k,
				AA,
				BB,
				CC,
				DD,
				a,
				b,
				c,
				d,
				S11 = 7,
				S12 = 12,
				S13 = 17,
				S14 = 22,
				S21 = 5,
				S22 = 9,
				S23 = 14,
				S24 = 20,
				S31 = 4,
				S32 = 11,
				S33 = 16,
				S34 = 23,
				S41 = 6,
				S42 = 10,
				S43 = 15,
				S44 = 21;

			str = this.utf8_encode(str);
			x = convertToWordArray(str);
			a = 0x67452301;
			b = 0xEFCDAB89;
			c = 0x98BADCFE;
			d = 0x10325476;

			xl = x.length;
			for (k = 0; k < xl; k += 16) {
				AA = a;
				BB = b;
				CC = c;
				DD = d;
				a = _FF(a, b, c, d, x[k + 0], S11, 0xD76AA478);
				d = _FF(d, a, b, c, x[k + 1], S12, 0xE8C7B756);
				c = _FF(c, d, a, b, x[k + 2], S13, 0x242070DB);
				b = _FF(b, c, d, a, x[k + 3], S14, 0xC1BDCEEE);
				a = _FF(a, b, c, d, x[k + 4], S11, 0xF57C0FAF);
				d = _FF(d, a, b, c, x[k + 5], S12, 0x4787C62A);
				c = _FF(c, d, a, b, x[k + 6], S13, 0xA8304613);
				b = _FF(b, c, d, a, x[k + 7], S14, 0xFD469501);
				a = _FF(a, b, c, d, x[k + 8], S11, 0x698098D8);
				d = _FF(d, a, b, c, x[k + 9], S12, 0x8B44F7AF);
				c = _FF(c, d, a, b, x[k + 10], S13, 0xFFFF5BB1);
				b = _FF(b, c, d, a, x[k + 11], S14, 0x895CD7BE);
				a = _FF(a, b, c, d, x[k + 12], S11, 0x6B901122);
				d = _FF(d, a, b, c, x[k + 13], S12, 0xFD987193);
				c = _FF(c, d, a, b, x[k + 14], S13, 0xA679438E);
				b = _FF(b, c, d, a, x[k + 15], S14, 0x49B40821);
				a = _GG(a, b, c, d, x[k + 1], S21, 0xF61E2562);
				d = _GG(d, a, b, c, x[k + 6], S22, 0xC040B340);
				c = _GG(c, d, a, b, x[k + 11], S23, 0x265E5A51);
				b = _GG(b, c, d, a, x[k + 0], S24, 0xE9B6C7AA);
				a = _GG(a, b, c, d, x[k + 5], S21, 0xD62F105D);
				d = _GG(d, a, b, c, x[k + 10], S22, 0x2441453);
				c = _GG(c, d, a, b, x[k + 15], S23, 0xD8A1E681);
				b = _GG(b, c, d, a, x[k + 4], S24, 0xE7D3FBC8);
				a = _GG(a, b, c, d, x[k + 9], S21, 0x21E1CDE6);
				d = _GG(d, a, b, c, x[k + 14], S22, 0xC33707D6);
				c = _GG(c, d, a, b, x[k + 3], S23, 0xF4D50D87);
				b = _GG(b, c, d, a, x[k + 8], S24, 0x455A14ED);
				a = _GG(a, b, c, d, x[k + 13], S21, 0xA9E3E905);
				d = _GG(d, a, b, c, x[k + 2], S22, 0xFCEFA3F8);
				c = _GG(c, d, a, b, x[k + 7], S23, 0x676F02D9);
				b = _GG(b, c, d, a, x[k + 12], S24, 0x8D2A4C8A);
				a = _HH(a, b, c, d, x[k + 5], S31, 0xFFFA3942);
				d = _HH(d, a, b, c, x[k + 8], S32, 0x8771F681);
				c = _HH(c, d, a, b, x[k + 11], S33, 0x6D9D6122);
				b = _HH(b, c, d, a, x[k + 14], S34, 0xFDE5380C);
				a = _HH(a, b, c, d, x[k + 1], S31, 0xA4BEEA44);
				d = _HH(d, a, b, c, x[k + 4], S32, 0x4BDECFA9);
				c = _HH(c, d, a, b, x[k + 7], S33, 0xF6BB4B60);
				b = _HH(b, c, d, a, x[k + 10], S34, 0xBEBFBC70);
				a = _HH(a, b, c, d, x[k + 13], S31, 0x289B7EC6);
				d = _HH(d, a, b, c, x[k + 0], S32, 0xEAA127FA);
				c = _HH(c, d, a, b, x[k + 3], S33, 0xD4EF3085);
				b = _HH(b, c, d, a, x[k + 6], S34, 0x4881D05);
				a = _HH(a, b, c, d, x[k + 9], S31, 0xD9D4D039);
				d = _HH(d, a, b, c, x[k + 12], S32, 0xE6DB99E5);
				c = _HH(c, d, a, b, x[k + 15], S33, 0x1FA27CF8);
				b = _HH(b, c, d, a, x[k + 2], S34, 0xC4AC5665);
				a = _II(a, b, c, d, x[k + 0], S41, 0xF4292244);
				d = _II(d, a, b, c, x[k + 7], S42, 0x432AFF97);
				c = _II(c, d, a, b, x[k + 14], S43, 0xAB9423A7);
				b = _II(b, c, d, a, x[k + 5], S44, 0xFC93A039);
				a = _II(a, b, c, d, x[k + 12], S41, 0x655B59C3);
				d = _II(d, a, b, c, x[k + 3], S42, 0x8F0CCC92);
				c = _II(c, d, a, b, x[k + 10], S43, 0xFFEFF47D);
				b = _II(b, c, d, a, x[k + 1], S44, 0x85845DD1);
				a = _II(a, b, c, d, x[k + 8], S41, 0x6FA87E4F);
				d = _II(d, a, b, c, x[k + 15], S42, 0xFE2CE6E0);
				c = _II(c, d, a, b, x[k + 6], S43, 0xA3014314);
				b = _II(b, c, d, a, x[k + 13], S44, 0x4E0811A1);
				a = _II(a, b, c, d, x[k + 4], S41, 0xF7537E82);
				d = _II(d, a, b, c, x[k + 11], S42, 0xBD3AF235);
				c = _II(c, d, a, b, x[k + 2], S43, 0x2AD7D2BB);
				b = _II(b, c, d, a, x[k + 9], S44, 0xEB86D391);
				a = addUnsigned(a, AA);
				b = addUnsigned(b, BB);
				c = addUnsigned(c, CC);
				d = addUnsigned(d, DD);
			}

			var temp = wordToHex(a) + wordToHex(b) + wordToHex(c) + wordToHex(d);

			return temp.toLowerCase();
		};


		var base64 = {};
		base64.PADCHAR = '=';
		base64.ALPHA = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';

		base64.makeDOMException = function() {
		   // sadly in FF,Safari,Chrome you can't make a DOMException
		   var e,
				tmp;

		   try {
		       return new DOMException(DOMException.INVALID_CHARACTER_ERR);
		   } catch (tmp) {
		       // not available, just passback a duck-typed equiv
		       // https://developer.mozilla.org/en/Core_JavaScript_1.5_Reference/Global_Objects/Error
		       // https://developer.mozilla.org/en/Core_JavaScript_1.5_Reference/Global_Objects/Error/prototype
		       var ex = new Error("DOM Exception 5");

		       // ex.number and ex.description is IE-specific.
		       ex.code = ex.number = 5;
		       ex.name = ex.description = "INVALID_CHARACTER_ERR";

		       // Safari/Chrome output format
		       ex.toString = function() {
					return 'Error: ' + ex.name + ': ' + ex.message;
				};
		       return ex;
		   }
		}

		base64.getbyte64 = function(s, i) {
		   // This is oddly fast, except on Chrome/V8.
		   //  Minimal or no improvement in performance by using a
		   //   object with properties mapping chars to value (eg. 'A': 0)
		   var idx = base64.ALPHA.indexOf(s.charAt(i));
		   if (idx === -1) {
		       throw base64.makeDOMException();
		   }
		   return idx;
		}

		base64.decode = function(s) {
		   // convert to string
		   s = '' + s;
		   var getbyte64 = base64.getbyte64;
		   var pads,
				i,
				b10;
		   var imax = s.length
		   if (imax === 0) {
		       return s;
		   }

		   if (imax % 4 !== 0) {
		       throw base64.makeDOMException();
		   }

		   pads = 0
		   if (s.charAt(imax - 1) === base64.PADCHAR) {
		       pads = 1;
		       if (s.charAt(imax - 2) === base64.PADCHAR) {
		           pads = 2;
		       }
		       // either way, we want to ignore this last block
		       imax -= 4;
		   }

		   var x = [];
		   for (i = 0; i < imax; i += 4) {
		       b10 = (getbyte64(s, i) << 18) | (getbyte64(s, i+1) << 12) |
		           (getbyte64(s, i+2) << 6) | getbyte64(s, i+3);
		       x.push(String.fromCharCode(b10 >> 16, (b10 >> 8) & 0xff, b10 & 0xff));
		   }

		   switch (pads) {
		   case 1:
		       b10 = (getbyte64(s, i) << 18) | (getbyte64(s, i+1) << 12) | (getbyte64(s, i+2) << 6);
		       x.push(String.fromCharCode(b10 >> 16, (b10 >> 8) & 0xff));
		       break;
		   case 2:
		       b10 = (getbyte64(s, i) << 18) | (getbyte64(s, i+1) << 12);
		       x.push(String.fromCharCode(b10 >> 16));
		       break;
		   }
		   return x.join('');
		}

		base64.getbyte = function(s, i) {
		   var x = s.charCodeAt(i);
		   if (x > 255) {
		       throw base64.makeDOMException();
		   }
		   return x;
		}

		base64.encode = function(s) {
		   if (arguments.length !== 1) {
		       throw new SyntaxError("Not enough arguments");
		   }
		   var padchar = base64.PADCHAR;
		   var alpha = base64.ALPHA;
		   var getbyte = base64.getbyte;

		   var i,
				b10;
		   var x = [];

		   // convert to string
		   s = '' + s;

		   var imax = s.length - s.length % 3;

		   if (s.length === 0) {
		       return s;
		   }
		   for (i = 0; i < imax; i += 3) {
		       b10 = (getbyte(s, i) << 16) | (getbyte(s, i+1) << 8) | getbyte(s, i+2);
		       x.push(alpha.charAt(b10 >> 18));
		       x.push(alpha.charAt((b10 >> 12) & 0x3F));
		       x.push(alpha.charAt((b10 >> 6) & 0x3f));
		       x.push(alpha.charAt(b10 & 0x3f));
		   }
		   switch (s.length - imax) {
		   case 1:
		       b10 = getbyte(s, i) << 16;
		       x.push(alpha.charAt(b10 >> 18) + alpha.charAt((b10 >> 12) & 0x3F) +
		              padchar + padchar);
		       break;
		   case 2:
		       b10 = (getbyte(s, i) << 16) | (getbyte(s, i+1) << 8);
		       x.push(alpha.charAt(b10 >> 18) + alpha.charAt((b10 >> 12) & 0x3F) +
		              alpha.charAt((b10 >> 6) & 0x3f) + padchar);
		       break;
		   }
		   return x.join('');
		}

		security.base64 = base64;

		// TODO: Add IE 9 support as it does not have a btoa function.
		if (!window.btoa) {
			window.btoa = security.base64.encode;
		}

		if (!window.atob) {
			window.atob = security.base64.decode;
		}

		return security;
	});

angular
	.module('app')
	.service('SubKeyword', function(
		$rootScope,
		AppData,
		RouteRejectionService,
		Language,
		Utilities,
		UtilsValidation
	) {
		/**
		 * Access to our SubKeywordItemCollection class.
		 * @public
		 * @var {SubKeywordItemCollection}
		 */
		this.SubKeywordItemCollection = SubKeywordItemCollection;

		/**
		 * Returns a subkeyword collection based off a keyword.
		 * @public
		 * @param {String} keyword The keyword to use.
		 * @returns {SubKeywordItemCollection} The collection
		 */
		this.getCollection = function(keywordOrPromo) {
			var isPromo = UtilsValidation.validString(keywordOrPromo) && keywordOrPromo.indexOf('APC_') === 0,
				collection = new SubKeywordItemCollection(keywordOrPromo);

			if (isPromo) {
				collection.setLookupBy('label');
			}

			collection.initialize();

			return collection;
		};

		/**
		 * SubKeywordItemCollection class.
		 * @public
		 * @class
		 * @param {String} keywordOrPromo The keyword or the promocode.
		 */
		function SubKeywordItemCollection(keywordOrPromo) {
			this.items = [];
			this._keywordOrPromo = keywordOrPromo;
			this._lookupBy = 'keywords';
		}

		angular.extend(SubKeywordItemCollection.prototype, {
			initialize: function() {
				this.items = this.setupItemsToDisplayInModule(this._keywordOrPromo);
				this.processLocales(this.items);
			},
			setLookupBy: function(lookupBy) {
				if (['keywords', 'label'].indexOf(lookupBy) > -1) {
					this._lookupBy = lookupBy;
				}
			},

			/**
			 *
			 * @param keyword
			 * @returns {string|TREE.MENUITEM|{0, 1}|*|Array}
			 */
			setupItemsToDisplayInModule: function(keyword) {
				var subKeywordItem = this.findMatchForKeywordInNavTree(keyword);

				if (subKeywordItem) {
					subKeywordItem.MENUITEM = Utilities.wrapObjectToArray(subKeywordItem.MENUITEM, true);
				}

				if (angular.isDefined(subKeywordItem) && angular.isDefined(subKeywordItem.MENUITEM) && UtilsValidation.validArray(subKeywordItem.MENUITEM)) {
					return subKeywordItem.MENUITEM.filter(function(item) {
						return Utilities.getBoolean(item.isactive);
					});
				} else {
					throw new RouteRejectionService.UnrecoverableException('packageList/keyword', { keyword: keyword });
				}
			},

			/**
			 * Search the menuItems array, recursively checking each menuitem and children to accommodate all levels of the tree
			 * @param keyword
			 * @returns {Object} menuItem found from the search or undefined
			 */
			findMatchForKeywordInNavTree: function(keyword) {
				for (var i = 0; i < AppData.menuItems.length; i++) {
					var currentMenuItem = AppData.menuItems[i];
					var selectedMenuItem = this.recursiveSearchMenuItemForKeyword(keyword, currentMenuItem);

					if (selectedMenuItem) {
						return selectedMenuItem;
					}
				}
			},

			/**
			 * Recursively search a menuitem and children for a matching keyword
			 * @param keyword
			 * @param menuItem
			 * @returns {Object} Returns the menuItem or child menuItem on a particular menuItem branch
			 * if found otherwise will return undefined if not found
			 */
			recursiveSearchMenuItemForKeyword: function(keyword, menuItem) {
				if (menuItem[this._lookupBy] === keyword) {
					return menuItem;
				} else {
					if (menuItem.MENUITEM) {
						for (var i = 0; i < menuItem.MENUITEM.length; i++) {
							var child = menuItem.MENUITEM[i];
							var found = this.recursiveSearchMenuItemForKeyword(keyword, child);

							if (angular.isDefined(found)) {
								return found;
							}
						}
					}

					return undefined;
				}
			},

			/*
			*	The subkeyword footer is going to be determined by the keywords on the menuItem.
			*	The footer consists of 2 locales - priceLocale and buyLocale.
			*	We check each keyword for the existence of these locales - the target is footer-price + keyword & footer-buy + keyword respectively.
			*	The keyword is first made all lower case to remove case sensitivity issues, and spaces are replaced with hyphens.
			*
			*	Then, we will only set the footer property if BOTH locales are present. If not, no footer will be displayed.
			*/
			processLocales: function(items) {
				for (var i=0; i < items.length; i++) {
					if (angular.isDefined(items[i].keywords)) {
						var keywords = items[i].keywords.split(',');

						for (var x=0; x < keywords.length; x++) {
							var keyword = keywords[x];

							keyword = keyword.trim();

							// to lower case and replace spaces with -
							keyword = keyword.toLowerCase().replace(/\s/g, '-');

							var footer = {
								priceLocale: undefined,
								buyLocale: undefined
							};

							footer.priceLocale = Language.getLocale('Subkeyword', 'footer-price-' + keyword);
							footer.buyLocale = Language.getLocale('Subkeyword', 'footer-buy-' + keyword);


							if (!Utilities.isEmpty(footer.priceLocale) && !Utilities.isEmpty(footer.buyLocale)) {
								if ($rootScope.develop && (footer.priceLocale.indexOf('missing') > -1 || footer.buyLocale.indexOf('missing') > -1)) {
									footer = undefined;
								}

								items[i].footer = footer;
								break;
							} else {
								items[i].footer = undefined;
							}
						}
					}
				}

				return items;
			}
		});
	});

angular.module('app')
	.service
	('IneligibleForPaymentAlert', function(
		AppData,
		Enums,
		Language,
		UserInfo,
		Utilities,
		Modal,
		$uibModal,
		$rootScope
	) {
		/**
		 * Checks the items in the cart for memberships. Makes the VERIFY_DEFERRED_PACKAGES request.
		 * @private
		 * @param {Object} cartData contains cart details.
		 * @param {String} email contains email address to check.
		 */
		function verifyDeferredPayments() {
			var servicePromise;

			if (!UserInfo.billing.email) {
				return;
			}

			if (!AppData.cart || !AppData.cart.cart_id || !AppData.cart.cart_key || !AppData.cart.session_id) {
				return;
			}

			// If there is a scheduled payment. We need to verify the user hasn't defaulted.
			if (AppData.GetCartSummary.PAYMENT_SCHEDULE &&
				AppData.GetApplicationConsolidated &&
				AppData.GetApplicationConsolidated.SETTINGS &&
				Utilities.getBoolean(AppData.GetApplicationConsolidated.SETTINGS.do_deffered_payment_fraud_check)) {
				$rootScope.showSpinner('');
				servicePromise = AppData.fetch(Enums.services.VERIFY_DEFERRED_PACKAGES, false, {
					cart_id: AppData.cart.cart_id,
					cart_key: AppData.cart.cart_key,
					session_id: AppData.cart.session_id,
					version: 5,
					CUSTOMER: { email: UserInfo.billing.email }
						 },
				true
				).then
				(
					function(data) {
						$rootScope.hideSpinner();

						if (data.status === Enums.status.FAILED) {
							setAlertDetails(data);
							return Enums.status.FAILED;
						}
					}
				);
			}

			return servicePromise;
		}

		/**
			 * Sets the information for the alert.
			 * @private
			 * @param {Object} response from VERIFY_DEFERRED_PACKAGES request.
			 */
		function setAlertDetails(data) {
			var errorMsgBody = Language.Alert.verifySchedulePackageErrorMsg;

			// Include the order ID that the user originally defaulted on.
			if (data.defaulted_on_order && data.defaulted_on_order.length > 1) {
				errorMsgBody = errorMsgBody + '<br /><br />' + Language.DeferredFraudAlert.defaultedOnOrderMsg + ' ' + data.defaulted_on_order;
			}

			service.description = errorMsgBody;
			displayModal();
		}

		/**
			 * Displays the modal with the description from the VERIFY_DEFERRED_PACKAGES request.
			 * @private
			 * @param {Object} response from VERIFY_DEFERRED_PACKAGES request.
			 */
		function displayModal() {
			if (service.modalInView) {
				return;
			}

			$rootScope.modalOpen = true;

			var modalInstance =
				$uibModal.open
				(
					{
						templateUrl: '/views/modals/ineligibleForPaymentAlert.html',
						controller: 'IneligibleForPaymentAlertCtrl',
						keyboard: false,
						backdrop: 'static'
					}
				);

			service.modalInView = true;
		}

		/**
			 * Main service object. Exposes verifyDeferredPayments() function.
			 */
		var service = {
			verifyDeferredPayments: verifyDeferredPayments,
			description: {},
			modalInView: false
		};

		return service;
	});



angular.module('app')
	.constant('IdleSettings', {
		// Time is in SECONDS
		IDLE_TIMEOUT: 18000,
		IDLE_WARNING: 16200,
		KEEPALIVE_INTERVAL: 10
	})
	.service('IdleTimeout', function(
		$rootScope,
		Idle,
		$timeout,
		$injector,
		$q,
		Modal,
		Storage,
		Language,
		IdleSettings,
		Enums) {
		var lastActiveToken = undefined;

		var service = {
			timeoutTarget: '/reset/false',
			idle_timeout_minutes: IdleSettings.IDLE_TIMEOUT,
			idle_warning_minutes: IdleSettings.IDLE_WARNING,
			changeIdleTimeout: changeIdleTimeout,
			changeIdleWarning: changeIdleWarning

		};
		var idleTimeout = false;

		function changeIdleTimeout(newVal) {
			service.idle_warning_minutes = newVal;
			//This relates to IdleSettings.IDLE_WARNING;
			Idle.setTimeout(newVal);
		}

		function changeIdleWarning(newVal) {
			service.idle_timeout_minutes = newVal;
			//This relates to IdleSettings.IDLE_TIMEOUT;
			Idle.setIdle(newVal);
		}

		$rootScope.$on('IdleTimeout', function() {
			idleTimeout = true;
			hidePreviousModals();
			displayTimeoutModal();
		});

		$rootScope.$on('IdleWarn', function(e, countdown) {
			$rootScope.hideSpinner();
			if (parseInt(countdown) === service.idle_warning_minutes) {
				hidePreviousModals();
				displayWarningModal();
			} else if (countdown === 0) {
				// close the modal
				Modal.hideModal();
			}
		});

		function hidePreviousModals() {
			$rootScope.$broadcast('hidePreviousModals');
			// in case the navigation is open...
			$rootScope.state.showMainMenu = false;
		}

		service.timingOut = function() {
			return idleTimeout;
		};
		service.handleTimeoutComplete = function() {
			var logoutPromise = $q.resolve();

			if ($rootScope.configuredForPassportAuth) {
				try {
					var AuthService = $injector.get('AuthService');
					if (AuthService.isAuthenticated()) {
						logoutPromise = AuthService.terminateSessionSilently();
					}
				} catch (e) {
					// AuthService unavailable — proceed without OIDC logout
				}
			}

			logoutPromise.finally(function() {
				Storage.clearAll();
				$rootScope.routeTo(service.timeoutTarget);
			});
		};


		/**
		 * Set the lastactiveToken to account for scenarios when guest
		 */
		service.setLastActiveToken = function() {
			lastActiveToken = Storage.storage_id + new Date().getTime();
		};

		/**
		 * Set the assess the last active state
		 */
		service.assessLastActiveState = function() {
			if (angular.isDefined(lastActiveToken) && angular.isDefined(Storage.storage_id)) {
				var parts = lastActiveToken.split(Storage.storage_id);

				if (parts.length > 1) {
					var lastActiveTime = parts[1];

					if ((new Date().getTime() - lastActiveTime)/1000 > IdleSettings.IDLE_TIMEOUT) {
						lastActiveToken = undefined;
						$rootScope.$broadcast('hidePreviousModals');
						$timeout(function() {
							displayTimeoutModal();
						});
					}
				}
			}
		};

		return service;

		function displayTimeoutModal() {
			Modal.displayModal({
				category: 'Idle',
				label: 'Idle Timeout',
				title: Language.getLocale('Alert', 'timeoutTitle'),
				icon: 'icon-notice',
				description: Language.getLocale('Alert', 'timeoutMessage'),
				buttonFlags: [Enums.buttonFlags.OK],
				callback: function(details) {
					if (details == Enums.buttonFlags.OK) {
						service.handleTimeoutComplete();
					}
				},
				customCss: { topModal: 'top-modal' }
			});

			/**
			 * Calling $apply here to update the displayed modal to timeout;
			 * Idle.watch() used to do this as it uses $interval which triggers $digest loops
			 * but that was removed from the warning modal callback as it was restarting idle after timeout;
			 */

			$rootScope.$apply();
		}

		function displayWarningModal() {
			Modal.displayModal({
				category: 'Idle',
				label: 'Idle Warning',
				title: Language.getLocale('Alert', 'timeoutWarningTitle'),
				icon: 'icon-notice',
				description: Language.getLocale('Alert', 'timeoutWarningMessage'),
				buttonFlags: [Enums.buttonFlags.OK],
				callback: function(details) {
					if (details == Enums.buttonFlags.OK) {
						if (!idleTimeout) {
							$rootScope.$broadcast('showPreviousModals');
						}
					}
				},
				customCss: { topModal: 'top-modal' }
			});
		}
	});

'use strict';

/**
 * # HTML5 localStorage management service
 *
 * Allows for storing and recalling data from localStorage prefixed with an
 * application specific key. Also handles object stringification and
 * de-stringification as needed
 *
 * Examples:
 *
 *	 Storage.set('somekey','somevalue')
 *	 Storage.set('somekey',{'key':'value'})
 *	 var storedKey = Storage.get('somekey')
 *
 */
angular.module('app')
	.factory('Storage',
		function(
			$location,
			$log,
			$rootScope,
			$transitions,
			Enums,
			Utilities,
			Security,
			errorTracking,
			localStorageService,
			ResellerUrlService,
			UtilsValidation
		) {
			var EXPIRY_MAP_KEY = 'accessoExpiryMap';
			var merchantID = angular.isDefined($location.search().merchant_id) ? $location.search().merchant_id : '',
				isStorageSupported = testForStorage(),
				currentHash = Security.md5(getMD5String()),
				isRealObject = UtilsValidation.isRealObject,
				validArray = UtilsValidation.validArray;

			var factory = {
				bootstrap: bootstrap,
				data: {},
				generateExpiredMap: generateExpiredMap,
				flagSessionIdsWithNoDataAsExpired: flagSessionIdsWithNoDataAsExpired,
				purgeExpiredData: purgeExpiredData,
				purgeExpiredLocalStorageData: purgeExpiredLocalStorageData,
				purgeExpiredSessionsFromLocalStorage: purgeExpiredSessionsFromLocalStorage,
				inited: false,
				storage_id: currentHash + '_',
				isStorageSupported: isStorageSupported,
				isStorageTypeLocalStorage: isStorageTypeLocalStorage,
				get: function(key, useCookie, useStorageKey) {
					var data,
						result = null;

					if (factory.isStorageSupported) {
						if (key.charAt(0) == '_') {
							key = key.substring(1, key.length);
						}

						if (angular.isUndefined(useStorageKey)) {
							useStorageKey = true;
						}

						try {
							data = localStorageService.get(merchantID + (useStorageKey ? this.storage_id : '') + key);
						} catch (e) {
							$log.error(e);
							return null;
						}

						try {
							result = data;
						} catch (e) {
							result = data;
						}
					}

					return result;
				},
				set: function(key, data, useCookie, useStorageKey) {
					if (factory.isStorageSupported) {
						if (key.charAt(0) == '_') {
							key = key.substring(1, key.length);
						}

						if (typeof(useStorageKey) == 'undefined') {
							useStorageKey = true;
						}

						try {
							if (useStorageKey) {
								localStorageService.set(merchantID + this.storage_id + key, data);
							} else {
								localStorageService.set(merchantID + key, data);
							}
						} catch (e) {
							//do not throw error here
							errorTracking.notifyException(e, 'Unable to access local storage:');
						}
					}
				},
				remove: function(key, useCookie) {
					var status = false;


					if (factory.isStorageSupported) {
						if (key.charAt(0) == '_') {
							key = key.substring(1, key.length);
						}

						try {
							localStorageService.remove(merchantID + this.storage_id+key);
							status = true;
						} catch (e) {
							status = false;
						}
					}

					return status;
				},
				clearAll: clearStorage,
				getKey: function() {
					return currentHash;
				},
				_: {
					didBootstrap: false,
				}
			};

			/**
			 * Watcher for route changes
			 * @param {Transition} trans The Transition object
			 * @return {null}
			 */
			$transitions.onStart({},
				function(trans) {
					var _key = currentHash + '_',
						sessionKey = getSessionKey(),
						_session;

					// Do we have reseller URL parameters?
					var resellerUrlParams = ResellerUrlService.getParameterValuesAsString();
					var resellerUrlParamsExist = false;
					if (resellerUrlParams.length > 0) {
						resellerUrlParamsExist = true;
					}

					// Leave if theres nothing we can do
					if (!testForStorage()) {
						return;
					}

					// Pull the session.
					_session = getItemFromStorage(sessionKey);

					if (_session === null) {
						try {
							localStorageService.set(sessionKey, { key: _key });
						} catch (e) {
							throw new Error('Unable to set item in local storage: ' + e.message);
						}
					}
				}
			);

			/**
			 * Bootstraps the storage service
			 * @public
			 * @return {undefined}
			 */
			function bootstrap() {
				if (factory._.didBootstrap) {
					return;
				}

				factory._.didBootstrap = true;

				factory.purgeExpiredData(merchantID, currentHash);
			}

			function getItemFromStorage(key) {
				var value = null;

				if (factory.isStorageSupported) {
					try {
						value = localStorageService.get(key);
					} catch (e) {
						errorTracking.notifyException(e, 'Unable to retrieve item from local storage');
					}
				}

				return value;
			}

			function clearStorage() {
				if (factory.isStorageSupported) {
					try {
						var session = getItemFromStorage(getSessionKey());
						if (angular.isObject(session) && UtilsValidation.validString(session.key)) {
							var regExKey = new RegExp(session.key);
							localStorageService.clearAll(regExKey);
							localStorageService.clearAll(getSessionKey());
						}
					} catch (e) {
						errorTracking.notifyException(e, 'Unable to clear local storage');
					}
				}
			}

			/**
			 * gets a concatenated string of the
			 * 	host, merchant, environment, version, and language to create a unique key.
			 * @return {[type]} [description]
			 */
			function getMD5String() {
				return $location.$$host
				+ Utilities.getMerchant()
				+ $location.$$search._e
				+ $location.$$search._v
				+ $location.$$search.l
				+ window.accessoShoplandVersion
				+ merchantID
				+ $location.$$search.emerchant_id
				+ ResellerUrlService.getParameterValuesAsString();
			}

			/**
			 * Method used specifically to test if localStorage is available.
			 * @return {boolean} true | false
			 */
			function testForStorage() {
				return (localStorageService.isSupported || (localStorageService.getStorageType() === 'cookie' && localStorageService.cookie.isSupported));
			}

			/**
			 * Is the current storage mechanism local storage
			 * @returns {boolean}
			 */
			function isStorageTypeLocalStorage() {
				return localStorageService.isSupported && localStorageService.getStorageType() === 'localStorage';
			}

			function getSessionKey() {
				var sessionKey = merchantID + '_session';

				// Add md5 hash to session key if reseller params are present
				var resellerParameterValues = ResellerUrlService.getParameterValuesAsString();
				if (resellerParameterValues.length > 0) {
					sessionKey = merchantID + currentHash + '_session';
				}

				return sessionKey;
			}

			/**
			 * Purges expired data from local storage.
			 * @protected
			 * @return {undefined}
			 */
			function purgeExpiredData(merchantId, currentHashString) {
				var hashMap,
					expiredSessionHashMap,
					localStorageKeys;

				if (!isStorageSupported || !isStorageTypeLocalStorage()) {
					return;
				}

				hashMap = localStorageService.get(EXPIRY_MAP_KEY);
				if (!isRealObject(hashMap)) {
					hashMap = {};
				}

				expiredSessionHashMap = factory.generateExpiredMap(hashMap);
				localStorageKeys = localStorageService.keys();

				// remove expired data
				factory.purgeExpiredLocalStorageData(localStorageKeys, expiredSessionHashMap, hashMap);

				// grab the latest local storage keys since many were just purged in purgeExpiredLocalStorageData()
				localStorageKeys = localStorageService.keys();

				// flag session Ids for removal if they have no data in local storage
				factory.flagSessionIdsWithNoDataAsExpired(expiredSessionHashMap, localStorageKeys);

				// remove any session IDs that are expired
				factory.purgeExpiredSessionsFromLocalStorage(expiredSessionHashMap, hashMap);

				// If our current hash isn't in the hashMap, add it and the current time as that's when we'll end up saving data.
				if (!hashMap[merchantId + currentHashString]) {
					hashMap[merchantId + currentHashString] = Date.now();
				}

				// update the expirty map in localstorage for the next refresh
				localStorageService.set(EXPIRY_MAP_KEY, hashMap);
			}

			/**
			 * Purges expired session ids from the hashMap
			 * @public
			 * @param {Object} expiredSessionHashMap This is the key->value where key is the sesion ID and the value is a boolean which tells us if its expired (true) or not (false)
			 * @param {Object} hashMap This is the main hash map saved in local storage that gives us a key->value where key is the session id and the value is the timestamp it was saved at
			 * @return {undefined}
			 */
			function purgeExpiredSessionsFromLocalStorage(expiredSessionHashMap, hashMap) {
				if (!isRealObject(expiredSessionHashMap) || !isRealObject(hashMap)) {
					return;
				}

				Object.keys(expiredSessionHashMap)
					.forEach(function(key) {
						if (expiredSessionHashMap[key]) {
							delete hashMap[key];
						}
					});
			}

			/**
			 * Flags sessionIds as expired if they have no associative data in local storage
			 * @public
			 * @param {Object} expiredSessionHashMap This is the key->value where key is the sesion ID and the value is a boolean which tells us if its expired (true) or not (false)
			 * @param {String[]} localStorageKeys The local storage keys pertaining to the application. They are in the format of {hash}_{key}
			 * @return {undefined}
			 */
			function flagSessionIdsWithNoDataAsExpired(expiredSessionHashMap, localStorageKeys) {
				if (!isRealObject(expiredSessionHashMap) || !validArray(localStorageKeys)) {
					return;
				}

				Object.keys(expiredSessionHashMap)
					.forEach(function(key) {
						var hasData = localStorageKeys.some(function(localStorageKey) {
							return localStorageKey.indexOf(key) === 0;
						});

						if (!hasData) {
							expiredSessionHashMap[key] = true;
						}
					});
			}

			/**
			 * Purges expired local storage data if it's session is expired or if its session doesn't exist on the hashMap
			 * @public
			 * @param {String[]} localStorageKeys The local storage keys pertaining to the application. They are in the format of {hash}_{key}
			 * @param {Object} expiredSessionHashMap This is the key->value where key is the sesion ID and the value is a boolean which tells us if its expired (true) or not (false)
			 * @param {Object} hashMap This is the main hash map saved in local storage that gives us a key->value where key is the session id and the value is the timestamp it was saved at
			 * @return {undefined}
			 */
			function purgeExpiredLocalStorageData(localStorageKeys, expiredSessionHashMap, hashMap) {
				if (!validArray(localStorageKeys) || !isRealObject(expiredSessionHashMap) || !isRealObject(hashMap)) {
					return;
				}

				localStorageKeys
					.forEach(function(key) {
						var sessionId;

						if (!UtilsValidation.validString(key)) {
							return;
						}

						sessionId = key.split('_')[0];

						// If the hash is expired OR the hash doesn't exist in the hash map, delete it.
						if (expiredSessionHashMap[sessionId] || !hashMap.hasOwnProperty(sessionId)) {
							localStorageService.remove(key);
						}
					});
			}

			/**
			 * This function generates a hash of sessionID and true/false for whether it's expired.
			 * @public
			 * @param {Object} hashMap The current hash map of sessionIds and the timestamp of when they were saved
			 * @return {Object} The hash map of session ids and if they are expired or not
			 *		{
			 *			"234asek37f831l1k": true,		// expired
			 *			"23487clk37134913": false		// not expired
			 *		}
			 */
			function generateExpiredMap(hashMap) {
				// 24 hours in milliseconds
				var threshold = 3600000 * 24;
				var now = Date.now();

				if (!isRealObject(hashMap)) {
					return {};
				}

				return Object.keys(hashMap).reduce(function(acc, sessionId) {
					var timestamp = hashMap[sessionId];

					acc[sessionId] = isNaN(timestamp) || now - timestamp >= threshold;

					return acc;
				}, {});
			}

			// End of factory line.
			return factory;
		});

"use strict";

angular
	.module('app')
	.service('PackageList', function(
		AppData,
		Package,
		$rootScope,
		$stateParams,
		$filter,
		$q,
		Language,
		Navigation,
		RestrictedPackagesService,
		Utilities,
		UtilsValidation,
		ZipCodeOverride
	) {
		var isArray = Array.isArray,
			checkProp = Utilities.checkProp,
			validArray = UtilsValidation.validArray,
			getVatPrice = Utilities.getTotalPrice;

		var service = {
			requestPending: false,
			isMembership: false,
			packages: [],
			isPromoFlow: false,
			filterRestricted: filterRestricted
		};

		service.dataModel = {};
		service.dataModel.packageList = [];

		service.initialize = function(stateParams) {
			var initPromise = $q.defer();

			service.isPromoFlow = false;
			service.dataModel.packageList = [];

			if (stateParams=="noPackageFound") {
				service.forceNoPackageFound=true;
				// handle url to no packages found page
				return;
			}

			service.forceNoPackageFound=false;
			if (Utilities.safelyCheckPropertyOnObject('AppData.GetMerchantPackageList.PS.P', AppData)) {
				service.packages = AppData.GetMerchantPackageList.PS.P;
			} else {
				//no packages found.
				return;
			}


			var keyword;

			if (angular.isDefined(stateParams.keyword)) {
				keyword = decodeURIComponent(stateParams.keyword);
			} else if (angular.isDefined(stateParams.navItem)) {
				var navItem = decodeURIComponent(stateParams.navItem);

				// find keyword associated with nav item
				var treeObject = Navigation.lookupTreeByProperty('label', navItem);
				if (angular.isDefined(treeObject)) {
					keyword = treeObject.keywords;
				}
			}

			// if zip override is configured prompt the user and wait for their response
			// before completing the initialize
			// If no zip override is configured, do not wait and complete the
			// initialization immediately.
			if (AppData.GetMerchantPackageList.zip_override_available &&
					angular.isDefined(AppData.zipCodeKeywords) &&
					angular.isDefined(keyword) &&
					AppData.zipCodeKeywords.indexOf(keyword) > -1) {
				if (angular.isUndefined(ZipCodeOverride.zipCode)) {
					// search the zip_code_keywords list for this keyword
					ZipCodeOverride.promptUserForZipCode(keyword, function() {
						 	service.getPackageKeywordList(service.selectedKeyword, service.overridePackageList);
						   initPromise.resolve();
					});
				} else if (angular.isDefined(ZipCodeOverride.zipCode)) {
					// search the zip_code_keywords list for this keyword
					ZipCodeOverride.showZipCodeOverridePackages(keyword).then(function() {
						initPromise.resolve();
					}, function() {
						service.forceNoPackageFound=true; // show the "no packages found" view
						initPromise.resolve();
					});
				}
			} else {
				initPromise.resolve();
			}

			return initPromise.promise;
		};

		service.getPackageKeywordList = function(keyword, override, disableFilterRestricted) {
			var keyword = keyword || '';
			service.dataModel.packageList = [];
			if (angular.isDefined(ZipCodeOverride.overridePackageList) && ZipCodeOverride.selectedKeyword == keyword) {
				override = ZipCodeOverride.overridePackageList;
			}

			if (angular.isDefined(override)) {
				service.packages = override;
				service.dataModel.packageList = override;
			} else {
				service.packages = AppData.GetMerchantPackageList.PS.P;

				for (var i in service.packages) {
					// Check if Keyword, promo_code, or assoc_keywords matches.
					if (addPackageDataByProperty(service.packages[ i ], 'keyword', keyword, true) ||
							(
								angular.isDefined($stateParams.promocode) &&
								addPackageDataByProperty(service.packages[ i ], 'promo_code', keyword, false)
							) ||
							addPackageDataByProperty(service.packages[ i ], 'assoc_keywords', keyword, true)) {

					}
				}
			}

			//replace package list data
			for (var packageIndex in service.dataModel.packageList) {
				replaceDateWithValidFrom(service.dataModel.packageList[ packageIndex ]);
			}

			if (!disableFilterRestricted) {
				service.filterRestricted();
			}

			orderPackages(keyword);
			service.SetInitializeCtrl();
		}

		service.getPackagesByID = function(packageIDs) {
			var packageArray = packageIDs.split(',');

			service.dataModel.packageList = [];
			if (!UtilsValidation.validArray(packageArray)) {
				return;
			}
			service.packages.forEach(function(item) {
				if (packageArray.indexOf(item.id) > -1) {
					service.dataModel.packageList.push(angular.copy(item));
				}
			});

			service.filterRestricted();

			orderPackages();
			service.SetInitializeCtrl();
		}

		/**
		 * Filters out restricted if we have no packages loaded.
		 * @public
		 * @returns {undefined}
		 */
		function filterRestricted() {
			var isRestrictedPackage = RestrictedPackagesService.isRestrictedPackage,
				restrictedPackageLoaded = RestrictedPackagesService.restrictedPackageLoaded,
				hasRestrictedPackagesLoaded = RestrictedPackagesService.hasPackagesLoaded();

			// This service supports restricted packages.
			service.dataModel.packageList = service.dataModel.packageList.filter(function(pkg) {
				if (!hasRestrictedPackagesLoaded) {
					return !isRestrictedPackage(pkg);
				} else if (isRestrictedPackage(pkg)) {
					return restrictedPackageLoaded(pkg.id);
				}
				return true;
			});
		}

		function orderPackages(keywords) {
			// ok for "keywords" to be undefined!

			// sort packageList by display order
			service.dataModel.packageList = service.dataModel.packageList.sort(function compare(packageA, packageB) {
				var displayOrderA = Package.getDisplayOrderForKeyword(packageA, keywords);
				var displayOrderB = Package.getDisplayOrderForKeyword(packageB, keywords);
				return (displayOrderA - displayOrderB);
			}
			);
		}

		/**
		 *  Once we have gathered all the service.dataModel.packageList, from either the menuItem
		 *  or from fetch Call.
		 *  This will continue to finish the InitializeCtrl.
		 */
		service.SetInitializeCtrl = function() {
			if (!service.requestPending) {
				$rootScope.hideSpinner();
			}

			addStartRateToAllPackages();


			for (var i in AppData.menuItems) {
				if (AppData.lastKeyword && AppData.lastKeyword.toLowerCase() == AppData.menuItems[i].keywords.toLowerCase()) {
					//AppData.menuItems[i].selected = true
					if (typeof AppData.menuItems[i].MENUITEM != 'undefined') {
						AppData.menuItems[i].showSubMenu = true
					}
				}
			}

			setPackageListItems();
		}

		/**
		 *
		 * @param packageData {object}
		 * @param property {string}, key identifier to search within the object
		 * @param filter {string} , keyword to search within key indentifier
		 * @param hidePromo {boolean}
		 * @returns {boolean}
		 */
		function addPackageDataByProperty(packageData, property, filter, hidePromo) {
			var filter = String(filter.toLowerCase()).trim()

			// Determines if the property exists and if it matches the filter.
			// If so, it adds this package to $scope to be rendered.
			var propValue = '';
			if (typeof packageData[ property ] != 'undefined') {
				propValue = packageData[ property ].toLowerCase();
			}

			if (propValue.length > 0) {
				propValue = propValue.split(', ').join().split(',');

				for (var j in propValue) {
					var pVal = String(propValue[ j ].toLowerCase()).trim();

					if (filter.indexOf(',') > -1) {
						// splitting up the filter i.e. multiple keywords
						filter = filter.split(',');
					}

					if (!isArray(filter)) {
						filter = [filter];
					}

					if (filter.indexOf(pVal) > -1) {
						var notExist = !service.packageExists(packageData.id);
						var isPromo = packageData.isPromo;
						var isPromoAndPkg = !!packageData.promoAndPackage;

						if (
							(!isPromo && notExist) ||
									(isPromo && isPromoAndPkg && notExist) ||
									(isPromo && !hidePromo && notExist)
						) {
							service.dataModel.packageList.push(angular.copy(packageData));
							return true;
						}
					}
				}
			}

			return false;
		}

		/**
		 * Checks if the package already exist in scope.packageList array
		 * @param packageID
		 * @returns {boolean}
		 */
		service.packageExists = function(packageID) {
			for (var i = 0; i < service.dataModel.packageList.length; i++) {
				if (service.dataModel.packageList[ i ].id == packageID) {
					return true;
				}
			}

			return false;
		}


		function replaceDateWithValidFrom(packageData) {
			// TODO: Refactor. Should be in service since this is not DRY.
			// This was occuring every view to this controller hence packageData.validFromUpdated.
			// Replace @@date in advanced ticket with valid-from date.
			if (packageData.CHARACS && packageData.CHARACS.valid_from && !packageData.validFromUpdated) {
				packageData.headline =
						Language.replaceAllMultiple
						(['@@date']
							, [$filter('date')(packageData.CHARACS.valid_from, AppData.settings.date_format)]
							, Language.replaceAllMultiple
							(['@@Date']
								, [$filter('date')(packageData.CHARACS.valid_from, AppData.settings.date_format)]
								, packageData.headline
							)
						);

				packageData.validFromUpdated = true;
			}
		}

		/**
		 * Compares package CustomerType if they have more than one item.
		 * If more than one CT exist it will check the least and most expensive
		 * package,
		 *
		 * Additional object keys will be added
		 * startRate
		 *
		 */
		function addStartRateToAllPackages() {
			var i,
				j,
				p,
				hiddenPrices,
				lowestMembershipPrice,
				lowestPrice,
				currentPrice,
				lowestPriceCT,
				messageTarget,
				upfrontMessage,
				startRate = 0,
				currentRate = 0,
				tax_amount = 0,
				handler = [],
				taxes = [],
				nonHiddenPrices = [],
				ctCost = 0,
				ctCosts = [];

			// Determine if we have a starting price.
			for (i = 0; i < service.dataModel.packageList.length; i++) {
				p = service.dataModel.packageList[ i ];
				hiddenPrices = getHiddenRateTypes(p);
				p.CT = (isArray(p.CT)) ? p.CT : [p.CT];

				// default show starting at label to false
				p.showStartingLabel = false;

				// Check if we have a price label override, if so, use it, otherwise, determine a starting price.
				if (angular.isDefined(p.CHARACS) && angular.isDefined(p.CHARACS.price_label_override)) {
					p.startRate = p.CHARACS.price_label_override;
				} else if (Utilities.childDefined(p, 'CHARACS.package_type') && p.CHARACS.package_type.toLowerCase() === 'membership') {
					service.isMembership = true;
					p.showStartingLabel = validArray(p.CT);

					if (validArray(p.CT) && Utilities.getBoolean(AppData.settings.use_vat)) {
						lowestMembershipPrice = p.CT.reduce(function(lowestPrice, customerType) {
							currentPrice = Package.getFullPrice(customerType, AppData.settings.use_vat);

							if (currentPrice < lowestPrice) {
								return currentPrice;
							}

							return lowestPrice;
						}, Infinity);
					} else {
						lowestMembershipPrice = p.min_retail_amount;
					}

					// Loop through CTs to find lowest price and grab the COMP amount if available.
					if (validArray(p.CT)) {
						// Grab the lowest price CT based on getFullPrice()
						lowestPriceCT = p.CT.reduce(function(lowest, current) {
							currentPrice = Package.getFullPrice(current, AppData.settings.use_vat);
							lowestPrice = Package.getFullPrice(lowest, AppData.settings.use_vat);
							return currentPrice < lowestPrice ? current : lowest;
						});

						// Check if the lowest price CT has a COMP and grab the VAT specific COMP amount and retail amount.
						p.monthly_rate = getVatPrice(lowestPriceCT);

						// if the CT has a comp then assign the comp_retail_amount
						p.comp_retail_amount = checkProp('lowestPrice.COMP.CT', lowestPriceCT) ? getVatPrice(lowestPriceCT.COMP.CT) : 0;

					} else {
						// There is only one CT, use it as the "lowest".
						p.monthly_rate = getVatPrice(p.CT[0]);
						p.comp_retail_amount = checkProp('p.CT.0.COMP.CT', p) ? getVatPrice(p.CT[0].COMP.CT) : 0;
					}

					upfrontMessage = Package.getUpfrontMembershipMessage(p, validArray(p.CT) ? lowestPriceCT : p.CT[0]);

					if (upfrontMessage) {
						p.startRate = upfrontMessage;
					} else if (Utilities.childDefined(p, 'CHARACS.membership_type')) {
						messageTarget = 'membershipMessage_' + p.CHARACS.membership_type;
						p.startRate = Utilities.getString(Language.PackageList[messageTarget])
							.replace(/@@amount/g, $filter('currencyFormatter')(lowestMembershipPrice));
					} else {
						p.startRate = $filter('currencyFormatter')(lowestMembershipPrice) + ' ' + Language.PackageList.perMonthLabel;
					}

					p.startRatePrice = lowestMembershipPrice;
				} else {
					//reset variables
					startRate = 0,
					currentRate = 0,
					tax_amount = 0,
					handler = [],
					taxes = [],
					nonHiddenPrices = [],
					ctCost = 0,
					ctCosts = [];

					//needed to check if more than 1
					if (p.CT.length > 1) {
						p.showStartingLabel = true;
					}

					/*
					 * Iterate through Customer Types to find the lowest-cost option for the starting price display.
					 * getTotalPrice() handles all pricing scenarios (standard, VAT, fee-inclusive) internally.
					 */
					for (j = 0; j < p.CT.length; j++) {
						// Calculate the total cost including fees / tax for each CT
						ctCost = Utilities.getTotalPrice(p.CT[j]);

						if (ctCost > 0) {
							ctCosts.push(ctCost);
						}

						currentRate = Number(p.CT[ j ].retail_amount);
						tax_amount = Number(p.CT[ j ].tax_amount);
						taxes[ currentRate ] = tax_amount;
						handler.push(currentRate);

						if (hiddenPrices.length > 0) {
							if (hiddenPrices.indexOf(p.CT[ j ].id) != -1) {
								nonHiddenPrices.push(currentRate);
							}
						}
					}

					// Now the first element is the lowest price
					ctCosts.sort(function(a, b) {
						return a - b;
					});

					handler.sort(function(a, b) {
						return a - b;
					});

					/*
					 * When fee - inclusive pricing is enabled(VAT or fee - inclusive flags):
					 * - Use ctCosts array(prices from getTotalPrice including fees / tax)
					 * - Show all customer types regardless of hidden price settings
					*/
					if (AppData.defaults.use_vat || AppData.defaults.use_fee_inclusive_pricing) {
						startRate = ctCosts[0];
					} else {
						if (nonHiddenPrices.length > 0) {
							startRate = nonHiddenPrices[ 0 ];
							p.showStartingLabel = false;
						} else {
							startRate = handler[ 0 ];
						}
					}

					// Final formatting of data before the presentation.
					p.startRate = $filter('currencyFormatter')(startRate);
				}
			}
		}

		/**
		 * Makes an array for hidden prices for rate types in a package
		 * @private
		 * @param p {object}
		 * @returns {array}
		 */
		function getHiddenRateTypes(p) {
			if (Utilities.childDefined(p, 'CHARACS.hide_price')) {
				return p.CHARACS.hide_price.split(',').join();
			}
			return [];
		}

		/**
		 * Creates a multidimensional array of the packageList
		 * row by cell, cell limit is 3
		 *
		 */
		function setPackageListItems() {
			var cellLimit = 3;
			var stateParams = $stateParams;
			//check if there is a package stacking config for this keyword
			var keyword = stateParams.keyword || stateParams.navItem;
			if (angular.isDefined(keyword)) {
				keyword = Utilities.makeUnderscoreDelimited(keyword);
				if (angular.isDefined(AppData.settings['package_stacking_' + keyword]) && Utilities.getBoolean(AppData.settings['package_stacking_' + keyword])) {
					cellLimit = 2;
				}
			}

			var handler = [],
				temp = [],
				count = 1;

			var filteredPackageItems = service.dataModel.packageList.filter(function(item) {
				return !Utilities.getBoolean(item.do_not_include_in_pkg_list);
			});

			for (var i in filteredPackageItems) {
				temp.push(filteredPackageItems[i]);
				//ensure that if the cell limit was set to 2 for the first page in the package list, that it gets reset
				//for all other package list pages.
				if (i > 3) {
					cellLimit = 3;
				}
				if ((cellLimit/count) == 1) {
					count = 0;
					handler.push(temp)
					temp = [];
				}
				count++;
			}

			//if there is anything left on temp
			if (temp.length > 0) {
				handler.push(temp);
			}
			service.dataModel.packageList = handler;
		}

		/**
		 *  getRequestListItems returns copies of the items in GetMerchantPackageList that have the specified keyword.
		 *  The keyword parameter here is not a list. It's a single keyword.
		 *
		 *  Each item in the returned list of items will its display_order set to match the display_order of the keyword
		 *  that it shares.
		 *
		 * @param keyword
		 * @returns {{eventIDs: string, customerTypeIDs: string, packageIDs: string, packages: Array, maxQuantity: number}}
		 */
		service.getRequestListItems = function(keyword, filterByDeviceType) {
			// Get a list of all the packageIDs, eventIDs, and customerTypeIDs.
			var listCntr = {
				eventIDs: '',
				customerTypeIDs: '',
				packageIDs: '',
				packages: [],
				maxQuantity: 0
			};

			if (! Utilities.safelyCheckPropertyOnObject('AppData.GetMerchantPackageList.PS.P', AppData) || angular.isUndefined(keyword) || keyword =='') {
				return listCntr; // should never happen
			}
			var packageList = AppData.GetMerchantPackageList.PS.P;
			if (Utilities.getBoolean(filterByDeviceType)) {
				packageList = $filter('filterByDeviceType')(packageList);
			}

			for (var i = 0; i < packageList.length; i++) {
				var item = angular.copy(packageList[i]);
				var max = 0;

				/* item.keyword and item.assoc_keywords are comma-delimited lists of strings.
				 * item.KEYWORDS.K is an array of keywords, each in the format of
				 *   { display_order, keyword, keyword_description }
				 *  We need the display_order, so we'll use item.KEYWORDS.K
				 */

				// if item has no keywords, skip it.
				if (! Utilities.safelyCheckPropertyOnObject("item.KEYWORDS.K", item) || item.KEYWORDS.K.length < 1) {
					continue;
				}

				for (var j = 0; j < item.KEYWORDS.K.length; j++) {
					if (keyword == item.KEYWORDS.K[j].keyword) {
						// set display_order
						if (angular.isDefined(item.KEYWORDS.K[j].display_order)) {
							item.display_order = item.KEYWORDS.K[j].display_order;
						}
						// Make E (events) array.
						item.E = item.E || [];
						item.E = isArray(item.E) ? item.E : [item.E];

						// Make CT (customer types) array.
						item.CT = item.CT || [];
						item.CT = isArray(item.CT) ? item.CT : [item.CT];

						// Verify there are Events or Customer Types.
						if (item.E.length > 0 || item.CT.length > 0) {
							listCntr.packages.push(item);

							// Event IDs.
							for (var k = 0; k < item.E.length; k++) {
								if (listCntr.eventIDs) {
									listCntr.eventIDs += ',';
								}

								listCntr.eventIDs += item.E[k].id;
							}

							// Customer Type IDs.
							for (var l = 0; l < item.CT.length; l++) {
								if (listCntr.customerTypeIDs.indexOf(item.CT[l].id) == -1) {
									if (listCntr.customerTypeIDs) {
										listCntr.customerTypeIDs += ',';
									}

									listCntr.customerTypeIDs += item.CT[l].id;
								}
							}

							// Package IDs
							if (listCntr.packageIDs.indexOf(item.id) == -1) {
								if (listCntr.packageIDs) {
									listCntr.packageIDs += ',';
								}

								listCntr.packageIDs += item.id;
							}

							// Max Quantity
							listCntr.maxQuantity = (Number(item.max_quantity) > max) ? Number(item.max_quantity) : max;
						}
					}
				}
			}

			return listCntr;
		};

		service.getFirstKeywordLabelFromMenu = function() {
			return getFirstKeywordLabelFromMenuItems(AppData.menuItems, 0);
		}

		var MAX_MENU_DEPTH = 3;

		// Recurses into nested MENUITEM children (child, grandchild) since side-nav items can be 3 levels deep.
		// Capped at MAX_MENU_DEPTH so a misconfigured 4th level (unreachable in the rendered menu) is never returned.
		function getFirstKeywordLabelFromMenuItems(menuItems, depth) {
			for (var i = 0; i < menuItems.length; i++) {
				// Skip items that are not active.
				if (!menuItems[ i ].isactive) {
					continue;
				}

				// If it has a sub-keyword, use that keyword if it's active.
				// @TODO: Mark the selected keyword as selected.
				if (depth < MAX_MENU_DEPTH - 1 && angular.isDefined(menuItems[ i ].MENUITEM) && menuItems[i].MENUITEM.length > 0) {
					var keyword = getFirstKeywordLabelFromMenuItems(menuItems[ i ].MENUITEM, depth + 1);
					if (keyword != '') {
						return keyword;
					}
				} else if (!AppData.isDisabledKeyword(menuItems[ i ].keywords)) {
					return menuItems[ i ].label;
				}
			}
			return '';
		}


		return service;
	}

	)

angular
	.module('app')
	.service('Ticket', function(
		$q,
		$log,
		$rootScope,
		$state,
		AppData,
		ClientInfo,
		CustomActionService,
		Enums,
		JSONValidator,
		OrderService,
		Utilities,
		UtilsValidation
	) {
		'use strict';
		var validString = UtilsValidation.validString;

		var service = {
			addTicketCharacteristicsForTicket: addTicketCharacteristicsForTicket,
			determineIsPrintAndGo: determineIsPrintAndGo,
			determineState: determineState,
			getDesktopPrintTicketUrl: getDesktopPrintTicketUrl,
			myOrdersLink: null,
			setMyOrderLink: setMyOrderLink
		};

		return service;

		/**
		 * Determines where to route to.
		 * @public
		 * @function
		 * @param {Boolean} disableAltRoute If you want to disable the alternate route
		 * @returns {undefined}
		 */
		function determineState(disableAltRoute) {
			var modifyRouteAction = CustomActionService.ACTIONS_ENUMS.MODIFY_POST_PURCHASE_ROUTE,
				modifiedRoute,
				disabledModifiedRoute;

			if (Utilities.childDefined(AppData, 'GuestViewOrder.VIEW_ORDER_REPLY.ORDER_STATUS_REPLY')) {
				modifiedRoute = CustomActionService.actionRegistered(modifyRouteAction) ? CustomActionService.executeCustomAction(modifyRouteAction) : '';
				disabledModifiedRoute = JSONValidator.validate('disable_modified_post_purchase_route', AppData.settings.disable_modified_post_purchase_route);

				if (!disabledModifiedRoute && validString(modifiedRoute)) {
					$rootScope.routeTo($state.href(modifiedRoute, {
						cToken: OrderService.cToken,
						eToken: OrderService.eToken,
						oToken: OrderService.oToken,
						pToken: OrderService.pToken
					}));
					return;
				}

				if (angular.isUndefined(disableAltRoute)) {
					disableAltRoute = false;
				}

				$rootScope.routeTo(OrderService.getOrderViewRoute(disableAltRoute));
			} else {
				$log.error('Missing order status reply in response');
			}
		}

		/**
		 * Set what should display at the bottom of the orderView page.
		 * @param {String} label The label to display to the user
		 * @param {String} url  The url it should route to (the result of $state.href('state-name'))
		 */
		function setMyOrderLink(label, url) {
			if (validString(label) && validString(url)) {
				service.myOrdersLink = {
					label: label,
					url: url
				}
			}
		}

		/**
		 * Call ADD_TICKET_CHARACTERISTICS call for a ticket
		 *
		 * @param {Array} characKeyValueArray
		 * @param {string} oToken - the otoken from the order
		 * @return {promise}
		 */
		function addTicketCharacteristicsForTicket(ticketId, characKeyValueArray, oToken) {
			var request = {
				oToken: oToken,
				ticket_id: ticketId,
				CHARACS: characKeyValueArray,
			};

			if (JSONValidator.validate('master_merchant_id', AppData.settings.master_merchant_id)) {
				request.master_merchant_id = AppData.settings.master_merchant_id;
			}

			return AppData.fetch(Enums.services.ADD_TICKET_CHARACTERISTICS, false, request).then(
				function(response) {
					if (Utilities.safelyCheckPropertyOnObject('response.status', response) && response.status == Enums.status.OK) {
						return $q.when();
					} else {
						return $q.reject();
					}
				}
			).catch(
				function(err) {
					return $q.reject();
				}
			);
		}

		/**
		 * Retrieve the desktop print url
		 * @param {String} oToken oToken
		 * @param {String} cToken cToken
		 * @param {Boolean} missingCustomerName If we're missing the customer name
		 * @returns {String} the url or an empty string
		 */
		function getDesktopPrintTicketUrl(oToken, cToken, missingCustomerName) {
			var url = '',
				printSetting;

			//	Get the print_path from settings.
			if (Utilities.safelyCheckPropertyOnObject('AppData.settings.print_path', AppData)) {
				printSetting = JSON.parse(AppData.settings.print_path);

				if (angular.isDefined(AppData.environment)) {
					url = printSetting[AppData.environment];
				} else {
					url = printSetting['production'];
				}

				// If we dont have a question mar, add it so we can append our params.
				if (url.indexOf('?') === -1) {
					url += '?';
				}

				// If we have params after the question mark, add an extra ampersand so we can append our params.
				if (validString(url.substr(url.indexOf('?') + 1))) {
					url += '&';
				}

				url += 'oToken=' + oToken + '&cToken=' + cToken + (!missingCustomerName ? '&V4=true' : '');
			}

			return url;
		}

		function determineIsPrintAndGo(shipMeth) {
			if (Utilities.safelyCheckPropertyOnObject('AppData.settings.shipment_overrides', AppData) && JSONValidator.validate('shipment_overrides', AppData.settings.shipment_overrides)) {
				var config = JSON.parse(AppData.settings.shipment_overrides);

				for (var i = 0; i < config.length; i++) {
					if (config[i].shipment_method == shipMeth) {
						if (Enums.printAtHomeDeliveryMethods.indexOf(config[i].shipment_override) > -1) {
							return true;
						} else if (Enums.printAtHomeDeliveryMethods.indexOf(config[i].shipment_method) > -1) {
							return false;
						}
					}
				}
			}
			return Enums.printAtHomeDeliveryMethods.indexOf(shipMeth) > -1;
		}
	});

(function () {
	'use strict';

	angular
		.module('app')
		.service('TicketUtilsService', TicketUtilsService);

	/**
	 * The Ticket Utils Service
	 * @constructor
	 * @param {Service} AppData AppData
	 * @param {Service} Enums Enums
	 * @param {Service} UtilsValidation UtilsValidation
	 * @param {Service} Utilities Utilities
	 * @returns {Service} Our service itself
	 * @ngInject
	 */
	function TicketUtilsService(AppData, Enums, StringUtils, UtilsValidation, Utilities) {
		var checkProp = Utilities.safelyCheckPropertyOnObject;
		var getString = Utilities.getString;
		var validString = UtilsValidation.validString;
		var normalize = StringUtils.normalize;

		var service = { assignTicketNameCharacs: assignTicketNameCharacs, getTenant: getTenant};

		return service;

		/**
		 * Assigns name characs to ticket
		 * @function
		 * @param {Object} ticket The ticket to add characs to
		 * @returns {Boolean} If item has new ticket_customer_name charac assigned
		 */
		function addNameCharacsToTicket(ticket) {
			var name,
				firstName,
				lastName,
				shouldUpdate = false;

			// Copy reservation first name with last name to customer name.
			// Verify that the  `ticket.CHARACS` exists before proceeding.
			ticket.isRegister = false;
			if (angular.isDefined(ticket.CHARACS)) {
				firstName = ticket.CHARACS.rv_first_name ||
					ticket.CHARACS.ph_first_name ||
					ticket.CHARACS.np_first_name ||
					ticket.CHARACS.gr_pc_first_name ||
					ticket.CHARACS.FirstName ||
					ticket.CHARACS.firstName ||
					ticket.CHARACS.first_name;

				lastName = ticket.CHARACS.rv_last_name ||
					ticket.CHARACS.ph_last_name ||
					ticket.CHARACS.np_last_name ||
					ticket.CHARACS.gr_pc_last_name ||
					ticket.CHARACS.LastName ||
					ticket.CHARACS.lastName ||
					ticket.CHARACS.last_name;

				if (firstName && !validString(ticket.CHARACS.ticket_customer_name)) {
					ticket.customerFirstName = firstName;
					ticket.customerLastName = lastName || '';
					ticket.CHARACS.ticket_customer_name = [firstName, lastName].filter(validString).join(' ');
					ticket.isRegister = true

					shouldUpdate = true;
				}

				if (validString(ticket.CHARACS.ticket_customer_name)) {
					name = ticket.CHARACS.ticket_customer_name.split(' ');
					ticket.isRegister = true;
					ticket.customerFirstName = name.shift();
					ticket.customerLastName = name.join(' ');
				}
			}
			return shouldUpdate;
		}

		/**
		 * Updates a ticket to have ticket_customer_name
		 * @function
		 * @param {Object[]} tickets the tickets to update
		 * @param {string} oToken for the order
		 * @returns {undefined}
		 */
		function updateTicketName(tickets, oToken) {
			var ticketsRequest;
			var serviceRequest = { oToken: oToken };

			// Nothing to update, do nothing
			if (!tickets.length) {
				return;
			}

			ticketsRequest = tickets.map(function (ticket) {
				ticket.ticket_view = true;
				ticket.isRegister = true;

				return {
					ticket_id: ticket.ticket_id,
					CHARACS: [{
						key: 'ticket_customer_name',
						value: ticket.customerFirstName + ' ' + ticket.customerLastName
					}, {
						key: 'selected',
						value: 'true'
					}]
				};
			});
			serviceRequest.TICKETS = { TICKET: ticketsRequest };

			AppData.fetch(Enums.services.ADD_TICKET_CHARACTERISTICS, false, serviceRequest)
				.then(function addTickCharacCallback(data) {
					if (data.status === Enums.status.OK) {
						tickets.forEach(function setTickCustomerNameCharacIterator(ticket) {
							ticket.CHARACS = ticket.CHARACS || {};
							ticket.CHARACS.ticket_customer_name = ticket.customerFirstName + ' ' + ticket.customerLastName;
							ticket.submitted = true;
						});
					}
				});
		}

		/**
		 * Loop through each package and determine which one is good for showing barcode
		 * if print_movie value is not none, then add ticket to printables
		 * if there is multi group ticket charac on ticket, then only add the main ticket (of the whole multigroup package) to the list, and other single tickets (like daily ticket/passes/) to printables
		 * NOTE: main ticket of the multi group package should have group_multi_ticket charac and group_multi_qty property
		 * @function
		 * @public
		 * @param {Object[]} tickets - package array object list
		 * @return {Object[]} array list of all ticket objects that can be printed
		 */
		function getPrintableTickets(tickets) {
			var i,
				printables,
				ticket;

			printables = tickets.reduce(function findPrintables(acc, item) {
				if (getString(item.print_movie).toLowerCase() !== 'none') {
					acc.push(item);
				}

				return acc;
			}, []);

			i = printables.length;
			if (i > 0) {
				while (i--) {
					ticket = printables[i];
					if (!ticket.group_multi_qty && checkProp('ticket.CHARACS.group_multi_ticket', ticket, 'getBoolean')) {
						printables.splice(i, 1);
					}
				}
			}

			return printables;
		}

		/**
		 * Assigns and adds name characs to tickets when Print at Home is skipped
		 * @public
		 * @param {Object[]} tickets the tickets response object
		 * @param {string} oToken for the order
		 * @returns {undefined}
		 */
		function assignTicketNameCharacs(tickets, oToken) {
			var printTickets = getPrintableTickets(tickets);
			var updateTickets = [];
			var ticket;
			var i;

			if (printTickets.length > 0) {
				for (i in printTickets) {
					ticket = tickets[i];

					if (addNameCharacsToTicket(ticket)) {
						updateTickets.push(ticket);
					}
				}

				updateTicketName(updateTickets, oToken);
			}
		}

		/**
		 * Returns the tenant name instead of the island
		 * @param {String} island The island name
		 * @returns The tenant name if not the same as the island
		 */
		function getTenant(island) {
			var islandLowerCased = normalize(island);

			switch (islandLowerCased) {
				case 'sixflagsv3':
					return 'sixflags';
				case 'czv3':
					return 'columbuszoo';
				default:
					return island;
			}
		}
	}
})();

"use strict";
var angular = angular || {};

/**
 * User information Service
 * Provides data about the user
 *
 * @todo Globally update references to billing, payment and shipping by using:
 * @todo Re-write this whole thing! --> I refactored it post-yo :)
 */
angular.module('app')
	.factory('UserInfo',
		function(
			$injector,
			$rootScope,
			AppData,
			Enums,
			Storage,
			Utilities,
			UtilsValidation
		) {

			var merge = Utilities.merge,
				validArray = UtilsValidation.validArray,
				validString = UtilsValidation.validString,
				$location = $injector.get('$location');
		/**
		 * Base properties
		 * @type {Object}
		 */
			var UserInfo =
			{
				additionalPaymentData: {},
				userInfo: {},
				payment: {},
				/**
				 * A list of partial payments in the form {payment:{},secAcctInfo:{}}
				 */
				partialPayments: [],
				/**
				 * We do not store partial payments in local storage right now as it would need to be assessed security-wise
				 * We can track whether or not a refreshed page with a current cart had partialPayments applied  so that we can redirect the
				 * user back to the payment method screen
				 */
				partialPaymentsIndicator: false,
				shipping: {},
				billing: {},
				paypalSession: {},
				localStorage: {},
				paymentMethod: {},
				seasonPass: [],
				secAcctInfo: {},
				deliveryMethods: []
			};

			var ss = Storage;
			var GETTING_CART_SUMMARY = 'gettingCartSummary';

			/**
			 * constructor for the user info service
			 * @return {[type]} [description]
			 */
			(UserInfo.__constructor = function() {
				UserInfo.localStorage = ss.get('_UserInfo') || {};

				if (UserInfo.localStorage) {
					UserInfo.billing = UserInfo.localStorage.billing || {};
					UserInfo.payment = UserInfo.localStorage.payment || {};
					UserInfo.billingType = UserInfo.localStorage.billingType || {};
				}

				//if localStorage is not empty set the values to their keys
				if (!Utilities.isEmpty(UserInfo.localStorage)) {
					Object.keys(UserInfo.localStorage).forEach(function(key) {
						UserInfo[key] = UserInfo.localStorage[key];
					});
				}
			})();


			/**
			 * Basic accessor methods for User Info
			 * @param {[type]} key  [description]
			 * @param {[type]} data [description]
			 * @param {Boolean} optional
			 */
			UserInfo.set = function(key, data, omitFromLocalStorage) {
				UserInfo[key] = data;
				if (angular.isUndefined(omitFromLocalStorage) || !omitFromLocalStorage) {
					UserInfo.localStorage[key] = data;
					ss.set('_UserInfo', UserInfo.localStorage, true);
				}
			};

			UserInfo.get = function(key) {
				if (angular.isDefined(UserInfo.localStorage[key])) {
					return UserInfo.localStorage[key];
				} else {
					return UserInfo[key];
				}
			};

			UserInfo.getDiscountCode = function() {
				var key = 'discountCode' + ($location.search().merchant_id ? '_' + $location.search().merchant_id : '');
				return UserInfo.get(key) || null;
			};

			UserInfo.setDiscountCode = function(value) {
				var key = 'discountCode' + ($location.search().merchant_id ? '_' + $location.search().merchant_id : '');
				UserInfo.set(key, value);
			};

			UserInfo.mapModelToBillingAndShipping = function(model) {
				angular.extend(UserInfo.shipping, model);
				angular.extend(UserInfo.billing, model);
			};

			/**
			 * User billing information
			 * @return {[type]} [description]
			 */
			UserInfo.getBilling = function() {
				if (Utilities.isEmpty(UserInfo.billing && Storage.get('_UserInfo'))) {
					UserInfo.localStorage = Storage.get('_UserInfo');
					UserInfo.billing = UserInfo.localStorage.billing;
					UserInfo.payment = UserInfo.localStorage.payment;
				}

				return UserInfo.billing;
			};

			/**
			 * Remove all user info from local storage
			 * @return {[type]} [description]
			 */
			UserInfo.destroy = function() {
				ss.remove('_UserInfo', true);
			};


			UserInfo.shippingRequired = function shippingRequired() {
				var CartDataService = $injector.get('CartDataService');
				var storageVal = Storage.get('_deliveryMethods', true);
				var cartSummary = CartDataService.getLastSummary();

				UserInfo.deliveryMethods = [];

				if (validArray(cartSummary.cart.shipping)) {
					UserInfo.deliveryMethods = angular.copy(cartSummary.cart.shipping);
				} else if (![null, undefined, 'undefined'].includes(storageVal)) {
					UserInfo.deliveryMethods = angular.copy(storageVal);
				}

				if (validArray(UserInfo.deliveryMethods) || validString(UserInfo.deliveryMethods)) {
					Storage.set('_deliveryMethods', UserInfo.deliveryMethods, true);

					if (UserInfo.deliveryMethods.length > 1) {
						return true;
					}
				}

				return false;
			};

			/**
			 * Clear the payment data
			 * @param clearPartialPaymentData
			 */
			UserInfo.clearPaymentData = function(clearPartialPaymentData) {
				UserInfo.set('payment', {});
				UserInfo.set('secAcctInfo', {}, true);
				UserInfo.set('additionalPaymentData', {}, true);
				if (clearPartialPaymentData) {
					UserInfo.clearPartialPaymentData();
				}
			}

			/**
			 * Clear the partial payment data currently in memory and in storage
			 */
			UserInfo.clearPartialPaymentData = function() {
				UserInfo.set('partialPayments', []);
				UserInfo.set('partialPaymentsIndicator', false);
				$rootScope.$broadcast('UPDATE_PARTIAL_PAYMENTS');
				return true;
			}

			/**
			 * Are P and M the only delivery methods configured for this merchant
			 * @returns {boolean}
			 */
			UserInfo.areOnlyFreeDeliveryMethodsConfigured = function() {
				if (UserInfo.deliveryMethods.length > 0 && UserInfo.deliveryMethods.filter(function(method) {
					return method.ship_method === 'P' || method.ship_method === 'M' || method.ship_method === 'Y'
				}).length === UserInfo.deliveryMethods.length) {
				// If the cart delivery methods are only P, M, or Y, there's no need to check the Merchant methods. Just return true
					return true;
				}

				// if the cart delivery methods include other methods, check the GetMerchantDetails to see if it is limited to only M, P, and Y:
				return (Utilities.safelyCheckPropertyOnObject('AppData.GetMerchantDetails.SHIPPINGMETHOD', AppData, function() {
					var shippingMethods = AppData.GetMerchantDetails.SHIPPINGMETHOD;
					return shippingMethods.length > 0 && shippingMethods.filter(function(method) {
						return method.ship_method === 'P' || method.ship_method === 'M' || method.ship_method === 'Y'
					}).length === shippingMethods.length;
				})
				);
			};

			UserInfo.getDeliveryRouting = function getDeliveryRouting() {
				var CartService = $injector.get('CartService');
				var cartConfig = CartService.getConfig();
				var accessoPayEnabled = cartConfig.accessoPayEnabled;

				if (UserInfo.shippingRequired() === GETTING_CART_SUMMARY) {
					return;
				}

				if ((UserInfo.deliveryMethods.length === 1 && UserInfo.deliveryMethods[0].method === 'M') || !validArray(UserInfo.deliveryMethods)) {
					UserInfo.shipping = merge(UserInfo.shipping || {}, {
						deliveryMethod: 'M',
						deliveryAmount: '0.00',
						shippingAvailable: false
					});

					UserInfo.set('shipping', UserInfo.shipping);
					Storage.set('_shipping', UserInfo.shipping, true);

					return accessoPayEnabled ? Enums.routes.ACCESSO_PAY : Enums.routes.PAYMENT_METHOD;
				}

				return accessoPayEnabled ? Enums.routes.ACCESSO_PAY : Enums.routes.SHIPPING;
			};

			/**
			 * Partial Payment Data
			 * @param paymentData
			 * @param secureAccountInfoData
			 */
			UserInfo.addPartialPayment = function(paymentData, secureAccountInfoData) {
			//partial payments are not stored in local storage
				UserInfo.partialPayments.push({
					payment: paymentData,
					secAcctInfo: secureAccountInfoData
				});
				if (UserInfo.partialPayments.length > 0) {
					UserInfo.set('partialPaymentsIndicator', true);
				} else {
					UserInfo.set('partialPaymentsIndicator', false);
				}
				$rootScope.$broadcast('UPDATE_PARTIAL_PAYMENTS');
			};


			/**
			 * Retrieve the partial payment for a particular auth type
			 * @param authType
			 * @returns {Array.<*>}
			 */
			UserInfo.getPartialPaymentsForAuthType = function(authType) {
				return UserInfo.partialPayments.filter(function(partialPayment) {
					return partialPayment.payment.authType === authType;
				});
			};

			/**
			 * Obtain the partial payment total currently on hand
			 */
			UserInfo.getPartialPaymentTotal = function() {
				var total = 0;
				UserInfo.partialPayments.forEach(function(pmt) {
					total += pmt.payment.total;
				});

				return total;
			};

			/**
			 * Remove a particular partial payment
			 * @param partialPayment
			 */
			UserInfo.removePartialPayment = function(partialPayment) {
				var indexOfPayment = UserInfo.partialPayments.indexOf(partialPayment);
				if (indexOfPayment > -1) {
					UserInfo.partialPayments.splice(indexOfPayment, 1);
				}

				if (UserInfo.partialPayments.length > 0) {
					UserInfo.set('partialPaymentsIndicator', true);
				} else {
					UserInfo.set('partialPaymentsIndicator', false);
				}
				$rootScope.$broadcast('UPDATE_PARTIAL_PAYMENTS');
			};


			return UserInfo;
		});

angular.module('app')
	.service
	('SteppedView',
		function() {
			/**
         * Private Class for a individual steps
         * @param name
         * @param url - template url for the  partial
         */
			var Step = function(name, url) {
				var stepName = name;
				var stepUrl = url;
				if (!angular.isString(name)) {
					throw new Error("Step name must be a string");
				}

				this.getName = function() {
					return stepName;
				}
				this.getUrl = function() {
					return stepUrl;
				}
			}


			/**
         * SteppedView - Public Class that contains logic for SteppedView collection
         */
			this.SteppedView = function() {
				//private variable steps
				var steps = [];

				//private function to find a step by name
				var findStepByName = function(stepName) {
					var foundStep = steps.filter(function(step) {
						return step.getName() == stepName;
					});
					return (foundStep.length ==1 ? foundStep[0] : {});
				}

				this.addViewStep = function(stepName, url) {
					var step = findStepByName(stepName);
					if (Object.keys(step).length != 0) {
						throw new Error("SteppedView already has a step with this name.  Names must be unique.");
					} else {
						steps.push(new Step(stepName, url));
					}
				};

				this.getFirstStep = function() {
					return (steps.length >0 ? steps[0] : []);
				};

				this.getStepName = function(step) {
					return (step.getName());
				}


				this.getStepIndex = function(step) {
					return steps.indexOf(step);
				}

				this.getNextStep = function(currentStep) {
					var nextIndex = steps.indexOf(currentStep) + 1;
					return ((nextIndex < steps.length && nextIndex >=0) ? steps[nextIndex] : undefined);
				}

				this.getPreviousStep = function(currentStep) {
					var nextIndex = steps.indexOf(currentStep) - 1;
					return ((nextIndex < steps.length && nextIndex >=0) ? steps[nextIndex] : undefined);
				}
			};
		}
	);
angular.module('app')
	.service('StringUtils',
		function($log) {
			/**
			 * Returns a string that is trimmed, in all lower case and no spaces.
			 * @public
			 * @function
			 * @name normalize
			 * @param {*} str The string to test against
			 * @return {String} The string, but normalized
			 */
			this.normalize = function(str) {
				if (angular.isString(str)) {
					return str.trim().toLowerCase().replace(/\s/g, '');
				}

				return '';
			}

			/** Function count the occurrences of substring in a string;
			 * @param {String} haystack   Required. The string;
			 * @param {String} needle    Required. The string to search for;
			 * @param {Boolean} allowOverlapping    Optional. Default: false;
			 */
			this.countOccurrences = function(haystack, needle, allowOverlapping) {
				haystack+=""; needle+="";
				if (needle.length<=0) {
					return haystack.length+1;
				}

				var n=0,
					pos=0;
				var step=(allowOverlapping)?(1):(needle.length);

				while (true) {
					pos=haystack.indexOf(needle, pos);
					if (pos>=0) {
						n++; pos+=step;
					} else {
						break;
					}
				}
				return (n);
			}

			/**
			 * Normalizes a locale/language string to standard BCP 47 casing:
			 * uppercases the region subtag(s) and lowercases the language subtag.
			 * e.g. 'en-gb' → 'en-GB', 'de-de' → 'de-DE', 'en-fe-posix' → 'en-fe-POSIX'
			 * Returns the input unchanged if it is not a string.
			 * @public
			 * @function
			 * @name normalizeLocale
			 * @param {String} language The locale/language string to normalize
			 * @returns {String} The normalized locale string
			 */
			this.normalizeLocale = function(language) {
				var langArr;

				if (!angular.isString(language) || !language) {
					return language;
				}

				langArr = language.split('-');

				switch (langArr.length) {
					case 3:
						return [langArr[0].toLowerCase(), langArr[1], langArr[2].toUpperCase()].join('-');
					case 2:
						return [langArr[0].toLowerCase(), langArr[1].toUpperCase()].join('-');
					default:
						return langArr[0].toLowerCase();
				}
			};

			/**
			 * Method to convert a Six Flag's phone number that allows special characters to the
			 * numerical phone number only
			 * @param {String} phoneNumber initial phone number value.
			 */
			this.formatPhoneNumber = function(phoneNumber) {
				if (angular.isDefined(phoneNumber)) {
					return phoneNumber.replace(/\D/g, '');
				}
				return phoneNumber;
			};
		});

angular.module('app')
	.service
	('MockAppData',
		function(
	 Modal
	 , Language
	 , Enums
	 , $rootScope
	 , $q
		) {
	 //
	 // We use this to keep track of the various request types and mock data for them
	 //
	 this.requests = [];

	 this.setDataForRequest = function(key, data) {
		 this.requests[key] = data;
	 };

	 /**
	  * Sumulates a promise. Before calling this function, call setDataForRequest. The attributes
	  * that must be in your object are `response_valid`. If you specify the `request_valid` attribute it
	  * will be check against the request passed in.
	  *
	  * @function
	  * @name fetch
	  * @param {string} key - the request key (must be set with setDataForRequest)
	  * @param {boolean} useStorage - unused
	  * @param {object} request - the JSON object to request
	  * @param {boolean} useCookie - unused
	  * @throws Will throw error if the `request_valid` attribute is specified and does not match `request`.
	  * @throws Will throw an error if the requested key does not exist in the request cache.
	  */
	 this.fetch = function(key, useStorage, request, force, useCookie) {
		 var response = undefined;

		 if (this.requests[key]===undefined || this.requests[key].response_valid===undefined) {
			 throw new Error("Undefined Request type: " + key);
		 } else {
			 response = this.requests[key];
		 }

		 //
		 // If the user specified a "request_valid" attribute of their
		 // request, check that too
		 //
		 if (this.requests[key].request_valid!==undefined && angular.equals(request, this.requests[key].request_valid)==false) {
			 throw new Error("Mocked request does not match reference value");
		 }

		 return {
			 then: function(f) {
				 f(response.response_valid);
			 }
		 };
	 };
		});

/**
 * The embed service is responsible for communication between the store
 * and the iframe in the case of a desktop store.
 */
angular.module('app')
	.service('Embed',
		function(
			$uibModal,
			$rootScope,
			$q,
			AppData,
			CartDataService,
			Enums,
			Language,
			Modal,
			Utilities,
			UtilsValidation,
			$location,
			$window,
			$log
		) {
			var service = {
				parentOriginUrl: undefined,
				parentHref: undefined,
				cartAbandonmentCaptured: false,
				getParentUrl: getParentUrl,
			};

			/**
			 * Returns the top level parent url
			 * @returns {Promise<string|void>} The parent url
			 */
			function getParentUrl() {
				var resellerOrigin = $location.search()[Enums.urlParameters.tradesOrigin];
				if (service.parentHref) {
					return $q.resolve(service.parentHref);
				} else if (resellerOrigin) {
					//return the reseller trades origin as its expected to be passed in as a query param if provided
					return $q.resolve(resellerOrigin);
				} else if (!Utilities.isInIFrame()) {
					return $q.resolve();
				}

				return $q(function returnParentUrl(resolve) {
					$window.addEventListener('message', function onGetCurrentUrl(message) {
						var msg;

						try {
							msg = JSON.parse(message.data);

							if (!UtilsValidation.isRealObject(msg) || msg.messageType !== Enums.messages.SET_CURRENT_URL) {
								return;
							}

							service.parentHref = msg.url;

							$window.removeEventListener('message', onGetCurrentUrl);
							resolve(service.parentHref);
						} catch (err) {
							resolve();
						}
					}, false);

					$window.parent.postMessage(JSON.stringify({ messageType: Enums.messages.GET_CURRENT_URL }), '*');
				});
			}

			service.processRequestsClose = function(event, data) {
				var cartSummary = CartDataService.getLastSummary();
				if (data.status) {
					if (cartSummary.cart.qty > 0 &&
						!$rootScope.offline &&
						angular.isDefined(AppData.settings.cart_abandonment) &&
						Utilities.getBoolean(AppData.settings.cart_abandonment) &&
						!service.cartAbandonmentCaptured &&
						data.forceClose == false &&
						!$uibModal.CartAbandonmentActive &&
						service.processCartAbandonmentRules()
					) {
						Modal.displayModal({
							customCss: 'xsmall',
							customHTML: 'modal::cart-abandonment:template',
							hideAllButtons: true,
							title: Language.getLocale('CartAbandonment', 'SaveCartModalTitle'),
							view: Modal.SLIDEUP,
						});
					} else {
						$window.parent.postMessage(
							JSON.stringify({ messageType: Enums.messages.WILL_CLOSE }),
							"*"
						);
					}
				}
			};

			/**
			 * Each rule must be an object with two keys: name, func
			 * name is the string name of the rule
			 * func is a function
			 * The function must return true if we're good to proceed, false
			 * to stop processing completely.
			 */
			var cartAbandonmentRules = [{
				// do not show the cart abandonment dialog if any ID.ME packages are present
				name: "failForIDMEPackages",
				func: function() {
					var cartSummary = CartDataService.getLastSummary();
					var status = true;

					if (cartSummary.cart.qty > 0) {
						status = cartSummary.cart.items.every(function iterateCartItems(item) {
							return !Utilities.checkProp('item.characs.0.idme_token', item);
						});
					}

					return status;
				}
			}];

			service.processCartAbandonmentRules = function() {
				var ruleSuccess = true;
				for (var i = 0; i < cartAbandonmentRules.length; i++) {
					var rule = cartAbandonmentRules[i];

					$log.log("Processing cart abandonment rule: " + rule.name);

					var result = false;
					try {
						result = rule.func();
					} catch (e) {
						$log.log(e);
						$log.log("Error processing rule! Moving on");
					}

					if (!result) {
						ruleSuccess = false;
						break;
					}
				}

				if (ruleSuccess === true) {
					$log.log("All cart abandonment rules processed successfully");
					return true;
				}

				$log.log("Cart abandonment rule failures!");
				return false;
			}

			// do not execute if we aren't in an iframe
			if (angular.isDefined($window.parent) &&
				angular.isDefined($window.parent.postMessage) &&
				$window.self != $window.top) {
				$window.parent.postMessage(
					JSON.stringify({ messageType: Enums.messages.GET_ORIGIN_OF_PARENT_WINDOW }),
					"*"
				);

				// Handles broadcasting of cart update events.
				$rootScope.$on(
					Enums.messages.CART_UPDATE,
					function(event, data) {
						if (data.status) {
							$window.parent.postMessage(
								JSON.stringify({
									data: data.data,
									messageType: Enums.messages.CART_UPDATE
								}), '*'
							);
						}
					}
				);

				$rootScope.$on(Enums.messages.REQUESTS_CLOSE, service.processRequestsClose);

				// Handles communication between the IFRAME host and the store
				// in the case of close events.
				$window.addEventListener("message", function(msg) {
					if (msg.data === Enums.messages.REQUESTS_CLOSE) {
						$rootScope.$broadcast(Enums.messages.REQUESTS_CLOSE, {
							forceClose: false,
							status: true
						});
					} else if (!UtilsValidation.validObject(msg.data)) {
						try {
							//attempt to parse the data from the message
							var parsedMessageData = JSON.parse(msg.data);
							if (parsedMessageData.messageType === Enums.messages.RETRIEVED_PARENT_ORIGIN_INFO) {
								service.parentOriginUrl = parsedMessageData.parentOriginUrl;
							}
						} catch (e) {
							$log.error('Unable to parse post message: ' + e);
						}
					}
				});
			}

			$rootScope.$on('triggerSaveCart', function() {
				service.cartAbandonmentCaptured = true;
			});

			return service;
		});
angular.module('app')
	.service
	('RouteRejectionService',
		function(
			AppData,
			Enums,
			Language,
			Utilities,
			Package,
			$log,
			$q,
			$rootScope,
			$transitions
		) {
		//TODO - look at removing dependency on Package service here so we can encapsulate some error throwing in the package service

			//base package setup error
			var error300Msg = '';
			var error300Title = '';

			var splashScreenList = [];

			/**
			 * Populate the error 300 with a locale information once application is activated
			 */
			function populateError300Locales() {
				error300Msg = Language.getLocale('ErrorCodes', '300');
				error300Title = replaceErrorCodeInTitle(Language.getLocale('ErrorCodes', "errorCodeTitle"), '@@errorCode', '300');
			}

			function replaceErrorCodeInTitle(localeText, searchString, replacement) {
				var regex = new RegExp(searchString, "g");
				return localeText.replace(regex, replacement);
			}


			/**
			 * Generic exception class
			 * @constructor
			 */
			function Exception() {

			}
			this.Exception = Exception;

			/**
			 * adds route to blacklist splash screen
			 * @public
			 * @param {String} route route
			 * @returns {undefined}
			 */
			this.setSplashScreenOffForRoute = function(route) {
				if (angular.isString(route)) {
					splashScreenList.push(route);
				}
			}

			/**
			 * returns splash screen blacklist
			 * @public
			 * @returns {Array} list of blacklisted routes
			 */
			this.getSplashScreenTurnedOffRoutes = function() {
				return splashScreenList;
			}

			/**
			 * UnrecoverableException - an exception to handle unrecoverable application states and redirects back to a certain path
			 * @param {String} redirect - state name to redirect to
			 * @param {Object} [args] - stateParams
			 * @param {Boolean} [skipHideSpinner] - whether or not we should hide the spinner - defaults to false
			 * @param {Boolean} [disableKeyword] - if the current keyword should be added to the disabled keyword list (for default routing)
			 * @constructor
			 */
			function UnrecoverableException(redirect, args, skipHideSpinner, disableKeyword) {
				var keyword = Utilities.checkProp('$transitions.$view.router.stateService.toParams.keyword', $transitions, 'returnValue');

				Exception.call(this);
				this.redirect = (redirect!= undefined ? redirect : '/');
				this.args = args;
				this.skipHideSpinner = Utilities.getBoolean(skipHideSpinner);

				// If this is a reroute and the keyword should be disabled for default routing
				if (disableKeyword && keyword) {
					// Add to the disabled list for keywords to default routing
					AppData.addDisabledKeyword(keyword);

					// Add a reason to this exception
					this.reason = 'The "' + keyword + '" keyword was disabled due to lack of setup/availability.';

					// Log to console why this was disabled
					$log.warn(this.reason);
				}
			}

			UnrecoverableException.prototype = Object.create(Exception.prototype);
			UnrecoverableException.prototype.constructor = UnrecoverableException;

			this.UnrecoverableException = UnrecoverableException;


			/**
			 * BypassXFCException - an exception to handle special cases where we must bypass
			 * an extra flow module and call Package.nextXFC or Package.cancelXFC depending on whether or not we are
			 * moving forward or backward
			 * @constructor
			 */
			function BypassXFCException() {
				Exception.call(this);
				this.callback = BypassXFCExceptionCallback;
			}

			/**
			 * Callback function for the BypassXFCException
			 * Pubically exposed
			 * @function
			 * @public
			 * @returns {undefined}
			 */
			function BypassXFCExceptionCallback() {
				if (Package.isForwardExtraFlowRouting()) {
					Package.nextXFC(true);
				} else {
					Package.cancelXFC(true);
				}
			}

			BypassXFCException.prototype = Object.create(Exception.prototype);
			BypassXFCException.prototype.constructor = BypassXFCException;

			this.BypassXFCExceptionCallback = BypassXFCExceptionCallback;
			this.BypassXFCException = BypassXFCException;

			// trans: the specific Transition instance to abort, when the caller has one (e.g. a
			// resolve's own injected $transition$) -- preferred over the router's global "current
			// transition" pointer, which can point at a DIFFERENT, newer transition than the one
			// that actually invoked reroute() (e.g. a parallel resolve on re-entry), aborting the
			// wrong transition and leaving both it and the new goTo() call racing to the same
			// destination (matches agreement-bootstrap-service.js's cartHasAgreements pattern).
			this.reroute = function reroute(stateName, params, replaceState, reload, trans) {
				// goTo() below re-enters immediately; skip the hide so it doesn't flash
				// before the new transition's own work is done (mirrors run.js's
				// onBefore({to: hasComponents}) hook).
				$rootScope._skipNextHideSpinner = true;

				if (trans) {
					trans.abort();
				} else {
					$transitions._router.globals.$get().transition.abort();
				}

				Utilities.goTo(stateName, params, replaceState, reload);

				// Resolve, don't reject: trans.abort() already marks this ABORTED, which
				// UI-Router silences. A bare $q.reject() would instead surface as a
				// console-logged ERROR-type rejection.
				return $q.resolve();
			};

			/**
			 * ViewException - an exception to handle display of information to user if package setup prevents XFC from being shown
			 * so that OPS can understand that there is an issue (coordinated with customer support)
			 * Handled as a stateChangeError in run.js
			 * Defaults to ErrorCode 300
			 * (Error Code 300:  There was a challenge due to package configuration.
			 * Please contact Technical Support at @@support_number and advise you have encountered this error.)
			 * @param localeSection
			 * @param localeTarget
			 * @constructor
			 */
			function ViewException(localeSection, localeTargetTitle, localeTargetMsg, redirect, args) {
				Exception.call(this);

				this.name = 'ViewException';
				//default to error 300 generic error
				this.title = error300Title;
				this.description = error300Msg;

				if (angular.isDefined(localeSection) &&
				angular.isDefined(localeTargetTitle) &&
				angular.isDefined(localeTargetMsg)) {
					this.title = Language.getLocale(localeSection, localeTargetTitle);
					this.description = Language.getLocale(localeSection, localeTargetMsg);
				}

				if (angular.isDefined(redirect)) {
					this.redirect = redirect;
					this.args = args;
					this.forceModal = true;
				} else if (angular.isDefined(Package.packageDetails)) {
					this.redirect = '/packageDetails/:packageId';
					this.args = { packageId: Package.packageDetails.id };
					this.forceModal = true;
				}
			}

			ViewException.prototype = Object.create(Exception.prototype);
			ViewException.prototype.constructor = ViewException;

			this.ViewException = ViewException;


			$rootScope.$on(Enums.services.APP_ACTIVATED, function(event, data) {
				populateError300Locales();
			});
		}
	);

(function() {
	'use strict';

	angular
		.module('app')
		.factory('PageBackgroundService', PageBackgroundService);

	/**
	 * Drives the `--page-background` CSS custom property on the root element
	 * from UI-Router state metadata.
	 *
	 * Routes opt in by setting `data: { pageBackground: '#RRGGBB' }` on their
	 * state definition. The global onSuccess hook in run.js calls applyFromState()
	 * on every transition so the variable is always in sync with the active route.
	 * The global scaffolding rule `background-color: var(--page-background, @color-bg)`
	 * on `body, html` consumes it — @color-bg is the compile-time fallback when no
	 * route has declared a color.
	 *
	 * @param {Object} $document Angular $document service
	 * @returns {Object} Service instance
	 * @ngInject
	 */
	function PageBackgroundService($document) {
		var root = $document[0].documentElement;
		var body = $document[0].body;

		var service = {
			applyFromState: applyFromState
		};

		return service;

		/**
		 * Reads `state.data.pageBackground` and either applies or clears the page
		 * background color.
		 *
		 * Two layers for reliability:
		 *  1. `--page-background` CSS variable on :root — for any stylesheet that
		 *     wants to reference it (e.g. scaffolding.less uses it as its bg fallback).
		 *  2. Inline `backgroundColor` on <html> and <body> — beats any non-!important
		 *     stylesheet rule including merchant overrides that hard-code a color.
		 *
		 * Removing both on navigation away lets the next route's stylesheet rules
		 * (or the global default) take over naturally.
		 *
		 * @param {Object} state - UI-Router state descriptor (trans.to())
		 */
		function applyFromState(state) {
			var color = state && state.data && state.data.pageBackground;
			if (color) {
				root.style.setProperty('--page-background', color);
				root.style.backgroundColor = color;
				body.style.backgroundColor = color;
			} else {
				root.style.removeProperty('--page-background');
				root.style.backgroundColor = '';
				body.style.backgroundColor = '';
			}
		}
	}
})();

'use strict';

angular.module('app')
	.factory(
		'ZipCodeOverride',
		function($uibModal, $q, $rootScope, AppData, Enums, Language, Storage, Utilities, Modal, RouteRejectionService) {
			var service = {};

			service.zipCode = undefined;
			service.selectedKeyword = undefined;

			service.processZipCode = function(zipCode) {
				var zipCodePromise = $q.defer();

				if (angular.isDefined(zipCode)) {
					$rootScope.showSpinner();

					var oldGetMerchantPackageList = angular.copy(AppData.GetMerchantPackageList);
					var servicePromise = AppData.fetch(Enums.services.GET_MERCHANT_PACKAGE_LIST, false, {
						_skip_cache: true,
						_no_cache: true,
						show_details: '1',
						keyword: service.selectedKeyword,
						long_desc_flag: '1',
						zip_code: zipCode
					}).then(
						function(data) {
							if (data.status === Enums.status.OK) {
								service.zipCode = zipCode;
								oldGetMerchantPackageList.PS.P = replacePackages(oldGetMerchantPackageList.PS.P, data.PS.P);
								AppData.GetMerchantPackageList = oldGetMerchantPackageList;
								service.overridePackageList = data.PS.P;
								zipCodePromise.resolve();
							} else {
								zipCodePromise.reject();
							}

							$rootScope.hideSpinner();
						}
					);
				}

				return zipCodePromise.promise;
			};

			service.showInvalidModal = function(keyword, callback) {
				service.zipCode = undefined;
				Modal.displayModal(
					{
						title: Language.getLocale('Alert', 'invalidZipTitle'),
						description: Language.getLocale('Alert', 'invalidZipDescription'),
						icon: 'icon-info red',
						buttonFlags: [Enums.buttonFlags.NO, Enums.buttonFlags.YES],
						callback: function(detail) {
							if (detail == Enums.buttonFlags.YES) {
								service.promptUserForZipCode(keyword, callback);
							} else {
							//If we entered the store on a zip override tab, go to the default keyword on cancel
							//Otherwise, go back to the last place the user was in the store.
								if (Utilities.isEmpty($rootScope.previousRoute)) {
									$rootScope.routeTo('/');
								} else {
									$rootScope.routeTo($rootScope.previousRoute);
								}
							}
						}
					}
				);
			};
			service.promptUserForZipCode = function(keyword, callback) {
				$rootScope.hideSpinner();
				service.selectedKeyword = keyword;
				var modalInstance =
					$uibModal.open({
						templateUrl: '/views/modals/zipCodeOverridePrompt.html',
						controller: 'ZipCodeOverrideCtrl',
						keyboard: false,
						backdrop: 'static'
					});
				modalInstance.result.then(function(result) {
					 service.processZipCode(result).then(
						 	function() {
							if (hasInvalidZipCode(keyword)) {
								service.showInvalidModal(keyword, callback);
							} else {
								callback();
							}
						 	},
						function() {
							service.showInvalidModal(keyword, callback);
						}
					);
				});
			};

			function hasInvalidZipCode(keyword) {
				var invalid = false;
				var formattedKeyword = Utilities.makeUnderscoreDelimited(keyword);
				if (angular.isDefined(AppData.settings['invalid_zip_' + formattedKeyword])) {
					var invalidPackageId = AppData.settings['invalid_zip_' + formattedKeyword];
					for (var i = 0; i < service.overridePackageList.length; i++) {
						if (service.overridePackageList[i].id == invalidPackageId) {
							invalid = true;
							break;
						}
					}
				}

				return invalid;
			}

			/**
			 * Replace the AppData GetMerchantPackageList with the new fetched data packages from service call to
			 * only return those packages by keyword for the zip code override.
			 * @private
			 * @function
			 * @memberof {ZipCodeOverride}
			 * @name replacePackages
			 * @param {Array} oldPackages - The current AppData GetMerchantPackageList.PS.P array items.
			 * @param {Array} newPackages - The new packages retrieved from new call to GetMerchantPackageList.
			 * @returns {Array} The full array with replaced packages for zip code override.
			 */
			function replacePackages(oldPackages, newPackages) {
				var replacedPackages = [];
				replacedPackages = oldPackages.filter(function(packageItem) {
					return !packageItem.keyword.match(new RegExp("\\b" + service.selectedKeyword + "\\b"));
				});

				return replacedPackages.concat(newPackages);
			}

			service.showZipCodeOverridePackages = function(keyword) {
				service.selectedKeyword = keyword;
				return service.processZipCode(service.zipCode);
			};

			return service;
		}
	);

"use strict";
var angular = angular || {};

angular.module('app')
	.factory('Template'
		, function($templateCache) {
			var factory = {};

			// $templateCache.put('uib/template/datepicker/day.html',
			// 		 '<div class="calendar-panel">'
			// 			+'<div class="panel-heading">'
			// 				+'<div ng-click="$parent.$parent.move(-1, move)" class="thead move-cal left"><span class="icon-leftarrow"></span></div>'
			// 				+'<div class="thead cal-title" data-ng-bind="title"></div>'
			// 				+'<div ng-click="$parent.$parent.move(1, move)" class="thead move-cal right"><span class="icon-rightarrow"></span></div>'
			// 			+'</div>'
			// 			+'<div class="panel-body">'
			// 			+'<div class="cal-row calendar-week-names">'
			// 				+'<div class="cal-cell" data-ng-repeat="label in labels track by $index" data-ng-bind="label.abbr"></div>'
			// 			+'</div>'
			// 			+'<div class="tbody">'
			// 				+'<div class="cal-row" data-ng-repeat="row in rows track by $index" id="row{{$index}}">'
			// 					+'<div class="cal-cell" data-ng-repeat="dt in row track by dt.date"  id="cell{{dt.label}}" ng-class="{\'selected\': dt.selected, \'disabled\':dt.disabled}">'
			// 						+'<span class="size-contain">&nbsp;'
			// 			 				+'<span class="cal-btn-contain">'
			// 							+ "<button type=\"button\" class=\"cal-btn \" data-ng-class=\"{'selected': dt.selected, active: isActive(dt), 'date-disabled': dt.disabled}\" ng-click=\"select(dt.date)\" ng-disabled=\"dt.disabled\" tabindex=\"-1\">"
			// 							+ "<span ng-class=\"{'text-muted': dt.secondary, 'text-info': dt.current}\">{{dt.label}}</span>"
			// 							+ "</button>"
			// 			 				+'</span>'
			// 			 			+'</span>' //size contain
			// 					+'</div>'
			// 				+'</div>'
			// 			+'</div>'
			// 			+'</div>'
			// 		+'</div>'//calendar-panel
			// );

			return factory;
		});

angular.module('app').service('LocaleService', function(
	$log,
	$rootScope,
	iso4217,
	AppData,
	Enums) {
	var service = { options: {} };

	$rootScope.$on(Enums.services.APP_ACTIVATED, function(event, data) {
		setupOptions();
	});

	function setupOptions() {
		if (angular.isDefined(AppData.currencyCode) && angular.isDefined(AppData.languageSettings)) {
			service.options = service.getOptionByCode(AppData.currencyCode, AppData.languageSettings);
		} else {
			$log.error('Currency Code / Language Settings not defined');
		}
	}

	service.getOptionByCode = function(currencyCode, langCode) {
		var formatOptions = iso4217;
		// Get the currency format by currencyCode. If array of objects, then select by langCode.
		var options = formatOptions[currencyCode.toUpperCase()];
		if (options) {
			if (angular.isArray(options)) {
				var optionsObj;

				if (langCode) {
					for (var i = 0; i < options.length; i++) {
						if (options[i][langCode]) {
							optionsObj = options[i][langCode];
							break;
						}
					}
				}

				if (!optionsObj) {
					// No options for this currencyCode + langCode. Should we use USD by default?
					return null;
				} else {
					options = optionsObj;
				}
			}
		} else {
			// No options for this currencyCode. Should we use USD by default?
			return null;
		}

		return options;
	}

	return service;
});
/**
 * Description:
 *  CustomActionService sets up a mapping between strings (keys) and functions, allowing modules to execute functionality provided by other
 *  modules. It is essentially a method of interfacing between running services, factories, and controllers.
 *  For example, modules A and B could both register custom actions: registerCustomActionForChain('someImportantThing');
 *  Module C could then call executeCustomActionChain('someImportantThing'), triggering both the actions in modules A and B.
 *
 * Usage:
 *
 *  actionRegistered: returns true if at least one action (or action chain) has been registered with that keyword.
 *
 *  registerCustomAction: registers a custom action which will be run when the program calls executeCustomAction.
 *
 *  customActions have three properties - a key name, an action, and a group. The group is used to quickly deregister actions.
 *
 *  registerCustomActionForChain: registers a custom action and adds it to a chain of actions which will be called when executeCustomActionChain is called.
 *
 *  deregisterCustomAction, deregisterArrayofActions, deregisterCustomActionsForGroup: are all ways to deregister custom actions
 *
 *  executeCustomAction: executes the first action associated with a keyword, returning the return result of that action.
 *
 *  executeCustomActionChain: executes the chain of actions associated with a keyword, returning true if any actions were executed and false, otherwise.
 *
 */
angular.module('app').factory('CustomActionService',
	function () {
		var customActions = [];
		var service = {
			/**
			 * Typical actions that are used across the platform
			 * We can start keeping track of these here or break out this functionality into a separate module some day
			 * but may not need to since its small
			 */
			ACTIONS_ENUMS: {
				AGREEMENTS_BEFORE_CART: 'agreementsBeforeCart',
				HAS_GET_OVERRIDE_PACKAGE_LIST_KEYWORD: 'HAS_GET_OVERRIDE_PACKAGE_LIST_KEYWORD',
				GET_OVERRIDE_PACKAGE_LIST: 'GET_OVERRIDE_PACKAGE_LIST',
				GET_PAYMENT_INFO_FOR_FOLIOS: 'getPaymentInfoForFolios',
				// Chains you can hook into
				ON_ITEMS_ADDED_TO_CART: 'onItemsAddedToCart', // Called in cart.js in response to a successful ADD_CART_ITEM call. Receives data from that call.
				ON_REMOVE_ALL_CART_ITEMS: 'onRemoveAllCartItems',
				ON_UPDATE_CART_ITEMS: 'onUpdateCartItems',

				// Custom actions that are not yet being used as chains
				ALT_MODULE_ON_CANCEL_UPSELL: 'altModuleOnCancelUpsell',
				SHOULD_SKIP_UPSELL_KEYWORD_CHECK_FOR_PACKAGE: 'shouldSkipUpsellKeywordCheckForPackage',
				BY_PASS_UPSELL_STATE_CHANGE_SUCCESS: 'byPassUpsellStateChangeSuccess',
				POST_UPSELL_PROCESSING: 'postUpsellProcessing',
				PROCESS_REMOVE_CART_ITEM: 'processRemoveCartItem',
				BILLING_POST_UPDATE_CHECKOUT_CART_INFO: 'billingPostUpdateCheckoutCartInfo',
				SHIPPING_POST_UPDATE_CHECKOUT_CART_INFO: 'shippingPostUpdateCheckoutCartInfo',
				MASTERPASS_POST_UPDATE_CHECKOUT_CART_INFO: 'masterpassPostUpdateCheckoutCartInfo',
				STORED_PAYMENTS_POST_UPDATE_CHECKOUT_CART_INFO: 'storedPaymentsPostUpdateCheckoutCartInfo',
				BILLING_ROUTE_ASSESSMENT: 'billingRouteAssessment',
				CART_ON_PROCESS_UPDATE_CART_CHECKOUT_INFO: 'cartOnProcessUpdateCartCheckoutInfo',

				// Season pass selection pass verification
				VERIFY_PASS_FROM_SERVER: 'verifyPassFromServer',

				EXECUTE_ON_SOCKET_RE_INITIALIAZTION: 'ExecuteOnSocketReInitialization',

				GET_CREDIT_CARDS: 'GetCreditCards',
				GET_LOGGEDIN_PROFILE: 'GetLoggedInProfile',
				GET_PAYMENT_MERCHANT_INFO: 'GetPaymentMerchantInfo',
				// Allows you to change the Route that the Cart Checkout button uses
				CART_CHECKOUT_GET_ROUTE: 'cartOnCheckoutGetRoute',
				CUSTOM_AGREEMENTS_BEFORE_CART: 'customAgreementsBeforeCart',
				CUSTOM_WAIVERS_BEFORE_CART: 'customWaiversBeforeCart',
				UPDATE_AGREEMENTS_ON_CART_UPDATE: 'updateAgreementsOnCartUpdate',
				INITIALIZE_SOCKET_POST_BUILD_REQUEST: 'initializeSocketPostBuildRequest',
				PURCHASE_COMPLETE_SUCCESS: 'purchaseCompleteSuccess',
				PURCHASE_COMPLETE_SUCCESS_GET_NEW_CART: 'purchaseCompleteSuccessGetNewCart',
				PURCHASE_CATCHALL_FAILURE_ERROR_MODAL_CALLBACK: 'purchaseCatchallFailureErrorModalCallback',
				PURCHASE_ERROR_CODE_CUSTOM_DESCRIPTION: 'purchaseErrorCodeCustomDescription',

				// Cart Specific Custom Actions
				CALENDAR_ADD_TO_CART: 'calendarAddToCart',

				// Allows you to cancel an addition to the cart based on a boolean returning from the action
				VALIDATE_CART_ADDITION: 'validateCartAddition',

				// allows you to initate a secured transaction flow
				INITIATE_SECURED_PURCHASE: 'InitiateSecuredPurchase',

				// allows you to modify the payment node
				GATHER_PURCHASE_DETAILS_PAYMENT_NODE: 'GatherPurchaseDetailsPaymentNodeFormulation',
				// allows you to modify the customer node for purchase
				GATHER_PURCHASE_DETAILS_CUSTOMER_NODE: 'GatherPurchaseDetailsCustomerNode',

				NOTIFY_USER_AT_CHECKOUT: 'NotifyUserAtCheckout',
				LOGOUT_POST_PURCHASE: 'logoutPostPurchase',
				REGISTER_POST_PURCHASE_LOGOUT_ACTION: 'registerPostPurchaseLogoutAction',

				// allows you to change the post purchase route. just return the route string
				MODIFY_POST_PURCHASE_ROUTE: 'MODIFY_POST_PURCHASE_ROUTE',
				// allows you to register configs for the simple store post purchase
				SIMPLE_STORE_CONFIG: 'SIMPLE_STORE_CONFIG',
				PREVENT_DATE_SELECTION: 'preventDateSelection',

				RESELLER_POS_PRINT_ORDER_VIEW: 'resellerPOSPrintOrderView',

				//This option allows to hook into the moment right before the application fires an AddCartItem request with a list of items
				PRE_REQUEST_ADD_TO_CART_ITEMS: 'preRequestItemsAddedToCart',

				// This option allows you to get a custom description for an error code
				PRE_PURCHASE_AUTH_ERROR_CODE_CUSTOM_DESCRIPTION: 'PrePurchaseAuthErrorCodeCustomDescription',

				// This option allows you to add any custom order characs to be included in the Purchase request
				PURCHASE_ADD_ORDER_CHARACS: 'purchaseAddOrderCharacs',

				// This option allows you to override the logic used to determine
				// if the PAYMENT node is not included in the Purchase request
				// @deprecated - PAYMENT node should always be sent regardless of cart amount
				PURCHASE_DELETE_PAYMENT_OVERRIDE: 'purchaseDeletePaymentOverride',

				// This option allows you to instruct the back end to disable the receipt e-mail
				// that is sent to the guest during a purchase
				PURCHASE_DISABLE_RECEIPT_EMAIL: 'purchaseDisableReceiptEmail',

				// This options allows you to skip the check in gather purchase details that will fail if there is no demographics
				PURCHASE_DISABLE_BILLING_CHECK: 'purchaseDisableBillingCheck',

				// This option allows you to instruct the back end to hide the prices on the receipt e-mail
				// that is sent to the guest during a purchase
				PURCHASE_DISABLE_RECEIPT_PRICES: 'purchaseDisableReceiptPrices',

				// Removing Mobile Ticket Option - gift voucher ticket ids params from URL - ticket_ids
				REMOVING_TICKET_IDS_FROM_URL: 'removingTicketIDsFromURL',

				// This option allows you to use custom logic to show/hide the terms and conditions
				ORDER_REVIEW_SHOW_TERMS_AND_CONDITIONS_OVERRIDE: 'orderReviewShowTermsAndConditionsOverride',

				// this option allows you to autofill the terms and conditions selection
				ORDER_REVIEW_AUTOFILL_TERMS_AND_CONDITIONS: 'orderReviewAutofillTermsAndConditions',

				// this option enables the reset cart button on the cartView
				ENABLE_RESET_CART: 'enableResetCart',
				ATTACH_ADDITIONAL_CHARAC_TO_COMP: 'attachAdditionalCharacToComp',
				FOLIO_MEMBERSHIP_UPGRADE: 'folioMembershipUpgrade',
				ON_CONTINUE_SHOPPING: 'onContinueShopping',

				//this option allows the URL that we reset the store on to be overriden by a different URL for when the store times out/etc
				ON_RESET_STORE_URL_OVERRIDE: 'onResetStoreUrlOverride',
				ON_ALTERNATE_GIFT_CARD_PAYMENT: 'onAlternateGiftCardPayment',

				// Add an IDENTITY node to the Purchase Request based on TE2 profile information
				TE2_ADD_IDENTITY_NODE: 'TE2AddIdentityNode',

				//This option allows you to check if SMS Verification is configured and not completed
				ALLOW_SMS_VERIFICATION: 'AllowSMSVerification',
				//This option allows you to complete SMS Verification
				SMS_VERIFICATION_COMPLETE: 'CompleteSMSVerification',

				//This option allows you to re-register SMS Verification once purchase is complete
				SMS_VERIFICATION_PURCHASE_COMPLETE: 'SMSVerificationPurchaseComplete',

				//This is a hook that is called when setting up season-pass-select xfc
				SETUP_SEASON_PASS_SELECT_XFC: 'SetupSeasonPassXFC',

				//This is a hook that is called when setting up profile-login
				SETUP_PROFILE_LOGIN: 'SetupProfileLogin',

				//This option allows you to check a payment method based on billing type
				PAYMENT_METHOD_BY_BILLINGTYPE: 'PaymentMethodByBillingType',

				CREATE_VALIDATE_AGE_REQUEST: 'CreateValidateAgeRequest',
				RESELLER_SKIP_STEP: 'resellerSkipStep',

				//This hook is to see if we should invalidate cache for profiles
				INVALIDATE_CP_PROFILE_CACHE: 'InvalidateCpProfileCache',

				UPDATE_EXPRESS_PAYMENT_METHODS: 'UpdateExpressPaymentMethods',

				ON_CART_SUMMARY_UPDATE: 'OnCartSummaryUpdate',

				ON_EMBEDDED_CART_UPDATE: 'CartOnEmbeddedCartUpdate',

				ON_CART_SUMMARY_ITEM_FAILURES: 'OnCartSummaryItemFailures',
			},
			actionRegistered: actionRegistered,
			checkAndExecute: checkAndExecute,
			deregisterArrayofActions: deregisterArrayofActions,
			deregisterCustomAction: deregisterCustomAction,
			deregisterCustomActionsForGroup: deregisterCustomActionsForGroup,
			executeCustomAction: executeCustomAction,
			executeCustomActionChain: executeCustomActionChain,
			registerCustomAction: registerCustomAction,
			registerCustomActionForChain: registerCustomActionForChain
		};

		/**
		 * Checks if a custom action is registered
		 * @param {String} keyName Custom action key name
		 * @returns {Boolean} Whether the custom action is registered
		 */
		function actionRegistered(keyName) {
			var actions = getCustomActionsByKey(keyName);
			return (angular.isDefined(actions) && actions.length > 0);
		}

		/**
		 * Checks if a custom action is registered and executes it if it is
		 * @param {String} keyName Custom action key name
		 * @param {Object} param The parameter to pass when there is only one
		 * @param {Array} optionalParamsList The array of parameters when there is multiple
		 * @param {Boolean} inverse Whether to return the inverse of the custom action
		 * @returns {Function} Allows you to control whether to execute an action based on its registration status
		 */
		function checkAndExecute(keyName, param, optionalParamsList, inverse) {
			return service.actionRegistered(keyName)
				? (inverse
					? !service.executeCustomAction(keyName, param, optionalParamsList)
					: service.executeCustomAction(keyName, param, optionalParamsList)
				)
				: !!inverse;
		}

		/**
		 * Gets custom action by key reference
		 * @param {String} keyName Custom action key name
		 * @returns {Function} The custom action or undefined if not found
		 */
		function getCustomActionsByKey(keyName) {
			return customActions.filter(function(item) {
				return item.keyName === keyName;
			});
		}

		/**
		 * Gets custom action by key reference and group
		 * @param {String} keyName Custom action key name
		 * @param {Function} action The custom action to register
		 * @param {String} group The optional group to group the items
		 * @returns {Function|undefined} The custom action or undefined if not found
		 */
		function getCustomActionByKeyReferenceAndGroup(keyName, action, group) {
			for (var i = 0; i < customActions.length; i++) {
				if (customActions[i].keyName === keyName && customActions[i].doAction === action && customActions[i].group === group) {
					return customActions[i];
				}
			}
			return undefined;
		}

		/**
		 * Registers custom action
		 * @param {String} keyName Custom action key name
		 * @param {Function} action The custom action to register
		 * @param {String} group The optional group to group the items
		 * @returns {undefined}
		 */
		function registerCustomAction(keyName, action, group) {
			var found = getCustomActionByKeyReferenceAndGroup(keyName, action, group);
			// Make sure the action being added hasn't already been registered
			if (angular.isUndefined(found)) {
				customActions.push({
					keyName: keyName,
					doAction: action,
					group: group,
					chain: false
				});
			}
		}

		/**
		 * Registers custom action to a chain of actions
		 * @param {String} keyName Custom action key name
		 * @param {Function} action The custom action to register to chain
		 * @param {String} group optional group to group the items
		 * @returns {undefined}
		 */
		function registerCustomActionForChain(keyName, action, group) {
			var found = getCustomActionByKeyReferenceAndGroup(keyName, action, group);
			// Make sure the action being added hasn't already been registered
			if (angular.isUndefined(found)) {
				customActions.push({
					keyName: keyName,
					doAction: action,
					group: group,
					chain: true
				});
			}
		}

		/**
		 * Removes a single action from the customActions list. If funcRef is defined, it will only remove a custom
		 * action that has both the indicated key and a reference to that function. If funcRef is not defined, all
		 * actions with the specified key are removed.
		 * @param {String} key Custom action key name
		 * @param {Function} funcRef Reference to registered function
		 * @returns {undefined}
		 **/
		function deregisterCustomAction(key, funcRef) {
			for (var i = customActions.length - 1; i >= 0; i--) {
				if (customActions[i].keyName == key) {
					if (angular.isUndefined(funcRef) || funcRef == customActions[i].doAction) {
						customActions.splice(i, 1);
					}
				}
			}
		}

		/**
		 * Removes an array of custom actions.
		 * Each element of the array can either be a class of the form {key: string, action: function} or a string.
		 * If an element is only a string, it is assumed to be a key, and all actions with that key are deleted.
		 * @param {Array} actionList The list of custom actions to deregister as an array
		 * @returns {undefined}
		 **/
		function deregisterArrayofActions(actionList) {
			if (angular.isUndefined(actionList)) {
				return;
			}
			var actionsToDeregister = angular.isArray(actionList) ? actionList : [actionList];

			actionsToDeregister.forEach(function (customAction) {
				var action = angular.isDefined(customAction.action) ? customAction.action : undefined,
					keyname = angular.isDefined(customAction.key) ? customAction.key : angular.isString(customAction) ? customAction : undefined;

				if (angular.isDefined(keyname)) {
					deregisterCustomAction(keyname, action)
				}
			});
		}

		/**
		 * Deregister a custom action for a particular group of actions
		 * @param {String} groupName The group name to deregister
		 * @returns {undefined}
		 */
		function deregisterCustomActionsForGroup(groupName) {
			for (var i = customActions.length - 1; i >= 0; i--) {
				if (angular.isDefined(customActions[i].group) && customActions[i].group === groupName) {
					customActions.splice(i, 1);
				}
			}
		}

		/**
		 * This function was originally written to accept ONLY one param argument - if you need to execute a custom
		 * action with an array of arguments, for backwards compatability, an optional array list of arguments can be
		 * provided which will execute the function with the list of arguments.
		 * Right now, the functions this calls MUST return boolean, or it won't work properly
		 * @param {String} keyName The custom action key name to execute
		 * @param {Object} param The parameter to pass when there is only one
		 * @param {Array} optionalParamsList The array of parameters when there is multiple
		 * @returns {*} The return value of the custom action
		 */
		function executeCustomAction(keyName, param, optionalParamsList) {
			var actions = getCustomActionsByKey(keyName);

			if (angular.isDefined(actions) && actions.length > 0) {
				if (angular.isArray(optionalParamsList)) {
					return actions[0].doAction.apply(null, optionalParamsList);
				} else {
					return actions[0].doAction(param);
				}
			} else {
				return undefined;
			}
		}

		/**
		 * Executes all the custom actions with the given keyName. It returns true if actions were executed and false
		 * if not. As with executeCustomAction, a single parameter should be passed as param. If there are multiple
		 * parameters, pass them as executeCustomActionChain(key, null, [param1, param2, param3...]);
		 *
		 * @param {String} keyName The custom action chain key name to execute
		 * @param {Object} param The parameter to pass when there is only one
		 * @param {Array} optionalParamsList The array of parameters when there is multiple
		 * @returns {Boolean} Whether or not the custom action chain was run
		 */
		function executeCustomActionChain(keyName, param, optionalParamsList) {
			var actions = getCustomActionsByKey(keyName),
				cachedActions = [];
			// if there are no actions, drop out.
			if (angular.isUndefined(actions) || actions.length < 1) {
				return false;
			}
			actions.forEach(function (action) {
				var alreadyCalled = false;
				// safeguard against the same action being called twice. This eliminates the chance of
				// a custom action that was accidentally registered twice from being called twice.
				for (var i = 0; i < cachedActions.length && !alreadyCalled; i++) {
					alreadyCalled = (action.doAction === cachedActions[i] && action.group === cachedActions[i].group);
				}
				if (!alreadyCalled) {
					cachedActions.push(action.doAction);
					if (angular.isArray(optionalParamsList)) {
						actions[i].doAction.apply(null, optionalParamsList);
					} else {
						actions[i].doAction(param);
					}
				}
			});
			return true; // Returns true when the customActionChain has been run
		}

		return service;
	}
);


/**
 * created by pMatthews 6/27/2016
 *
 * PostRequestActionService manages a list of callbacks to be called after each API request. It is currently accessed
 * in AppData.setData.
 *
 * To Use:
 *   1. call PostRequestActionService.addCallBack(request, callBack, returnsPromise) for each function that
 *      you want to have called after the associated API request.
 *      Each callBack function is called with a single parameter (data), which is the result of the API request.
 *
 *      If your callBack function doesn't run asynchronously, set returnsPromise to false (or leave it undefined).
 *         In this case, the return value of the function is ignored.
 *      If your callBack function returns a promise, set returnsPromise to true, and make sure that your promise
 *         resolves with the API request data passed to it. (i.e., deferred.resolve(data)).
 *
 **/
angular.module('app').factory
('PostRequestActionService',
	function($q) {
		var service = {
		 callBackList: [],
			addCallBack: addCallBack,
			resolvePromises: resolvePromises,
			clearCallBacks: clearCallBacks,
			runActions: runActions
		};

		/**
		 * addCallBack adds a callback to callBackList. Each callback is associated with a request, which maps to a request
		 * that is used in AppData.fetch. The callback functions should be of the format function(data). They are
		 * passed the data fetched by the AppData.fetch call.
		 *
		 * When returnsPromise is false, the return value of the callback function is ignored.
		 * There is no graceful way to fail at the point where these are called, so that is not an option.
		 *
		 * When returnsPromise is true, make sure your callback function returns a promise and resolve that promise with the
		 * API request data.
		 *
		 * @param request
		 * @param callBack
		 * @param returnsPromise Boolean
     **/
		function addCallBack(request, callBack, returnsPromise) {
			var hook = {
				request: request,
				callBack: callBack,
				isPromise: !! returnsPromise
			};
			// ensure uniqueness!
			for (var i=0; i<service.callBackList.length; i++) {
				if (hook.request === service.callBackList[i].request && hook.callBack === service.callBackList[i].callBack) {
					return;
				}
			}
			service.callBackList.push(hook);
		}

		/**
		 * clearCallBacks(request) clears all the hooks for a given request out of callBackList. If you do not pass in
		 * request, this function clears the entire hook callBackList.
		 *
		 * @param request
     **/
		function clearCallBacks(request) {
			if (angular.isUndefined(request)) {
				service.callBackList = [];
			} else {
				for (var i=service.callBackList.length-1; i>=0; i--) {
					if (service.callBackList[i].request==request) {
						service.callBackList.splice(i, 1);
					}
				}
			}
		}

		/**
		 * resolvePromises inspects data for a data_request field and runs all the hooks in callBackList that have a matching
		 * request.
		 *
		 * @param data
		 **/
		function resolvePromises(data) {
			var promiseChain = [];
			// do nothing if the data is not in the proper format.
			if (angular.isDefined(data.request_type)) {
				// build the list of promises to chain.
				service.callBackList.forEach(function(hook) {
					if (hook.request == data.request_type && hook.isPromise) {
						promiseChain.push(hook.callBack);
					}
				});
			}
			// Return the chain resolve
			if (promiseChain.length>0) {
				return resolveChain(promiseChain, data);
			} else {
				return $q.when(data);
			}
		}

		function resolveChain(promiseChain, data) {
			var callBack = promiseChain.pop(),
				thisOne = $q.defer();

			if (promiseChain.length>0) {
				resolveChain(promiseChain, data).then(function() {
					callBack(data).then(function(data) {
						thisOne.resolve(data);
					});
				})
			} else {
				callBack(data).then(function(data) {
					thisOne.resolve(data);
				});
			}
			return thisOne.promise;
		}
		/**
		 * runActions inspects data for a data_request field and runs all the hooks in callBackList that have a matching
		 * request.
		 *
		 * @param data
     **/
		function runActions(data) {
			// do nothing if the data is not in the proper format.
			if (angular.isUndefined(data.request_type)) {
				return;
			}
			service.callBackList.forEach(function(hook) {
				if (hook.request == data.request_type && ! hook.isPromise) {
					hook.callBack(data);
				}
			});
		}

		return service;
	});

(function() {
	'use strict';

	angular
		.module('app')
		.factory('CountriesService', CountriesService);

	/**
	 * @constructor
	 * @memberOf app
	 * @param {Service} JSONValidator JSONValidator
	 * @param {Service} UtilsValidation UtilsValidation
	 * @return {CountriesService} the public api
	 * @ngInject
	 */
	function CountriesService(JSONValidator, UtilsValidation) {
		var service = { getCountriesjsonOverride: getCountriesjsonOverride };

		return service;

		/**
		 * Get the parsed countriesjson_override app config
		 * @public
		 * @function
		 * @memberOf CountriesService
		 * @param {String} appConfig countriesjson_override app config
        * @param {Array} countriesjson Appdata.countries which is initially set to the values in countriesjson.js
		 * @name checkOptInSelections
		 * @return {Array} Parsed countriesjson Override or countriesjson Array originally passed to the function
		 */
		function getCountriesjsonOverride(appConfig, countriesjson) {
			if (UtilsValidation.validString(appConfig) && JSONValidator.validate('countriesjson_override', appConfig)) {
				return JSON.parse(appConfig);
			}
			return countriesjson;
		}
	}
})();

angular.module('app')
	.factory
	('OneBarcodeUtilities'
		, function(AppData
			, $rootScope
			, Enums
			, Package
			, PackageList
			, Utilities
		) {
			var service =
			{
				findAddonPackages: function(packageCollection, groupUUID) {
					var addonPackages = [];
					for (var i = 0; i < packageCollection.length; i++) {
						var pkg = packageCollection[i];

						if (angular.isDefined(pkg.CHARACS)) {
							var packageCharacs = (angular.isArray(pkg.CHARACS)) ? pkg.CHARACS : [pkg.CHARACS];
							if (angular.isUndefined(packageCharacs[0].one_barcode_parent) &&
						 	(angular.isDefined(packageCharacs[0].group_uuid) && packageCharacs[0].group_uuid === groupUUID)) {
								addonPackages.push(pkg);
							}
						}
					}

					return addonPackages;
				},

				getSortedPackages: function(keyword) {
					return PackageList.getRequestListItems(keyword).packages.sort(function(a, b) {
						return Utilities.forceInt(a.display_order) - Utilities.forceInt(b.display_order);
					});
				},
				performPackageLookup: function() {
					return this.getSortedPackages(Utilities.safelyCheckPropertyOnObject('Package.packageDetails.CHARACS.oneBarcodeKeyword', Package) ? Package.packageDetails.CHARACS.oneBarcodeKeyword : '');
				},
				performPackageLookupForSpecificPackage: function(pkgItem) {
					return this.getSortedPackages(angular.isDefined(pkgItem.CHARACS) ? pkgItem.CHARACS.oneBarcodeKeyword : '');
				},
				hasOneBarcodeKeyword: function(pkgId, oneBarcodeKeyword) {
					//First find the package via package id
					var pkg = Package.getPackageByID(pkgId);
					//If a package was found, check to see that the package contains the correct keyword.
					return !!(angular.isDefined(pkg) && pkg.keyword.match(new RegExp("\\b" + oneBarcodeKeyword + "\\b")));
				},

				/**
				 * Determines if the parameter p is a one barcode package by
				 * checking if p.CHARACS.group_uuid is defined
				 * @return Boolean
				 */
				isOneBarcodePackage: function(p) {
					if (angular.isDefined(p.CHARACS) &&
						angular.isDefined(p.CHARACS.group_uuid)) {
						return true;
					}

					return false;
				},
				hasOneBarcodeItems: function(itemsToEdit) {
					return itemsToEdit.filter(function(item) {
						return angular.isDefined(item.oneBarcodePackages) && item.oneBarcodePackages.length > 0
					}).length > 0;
				},
				isGateEnhancementItem: function(item) {
					return Utilities.safelyCheckPropertyOnObject('item.CHARACS.0.is_gate_enhancement', item, 'getBoolean');
				},
				prepareOneBarcodeCartForEditing: function(itemsToEdit, addlCartItems) {
					var groupUUID = '';
					var oneBarcodeKeyword = '';
					itemsToEdit.forEach(function(editItem) {
						if (angular.isDefined(editItem.CHARACS) && angular.isArray(editItem.CHARACS) && editItem.CHARACS.length > 0) {
							var editItemCharacs = editItem.CHARACS[0];
							groupUUID = angular.isDefined(editItemCharacs.one_barcode_parent) && Utilities.getBoolean(editItemCharacs.one_barcode_parent) ? editItemCharacs.group_uuid : groupUUID;

							//We need to get the original oneBarcodeKeyword to ensure we splice the correct addons
							var pkg = AppData.GetMerchantPackageList.PS.P.filter(function(element) {
								if (/*element.id == editItemCharacs.preswap_package_id || */ element.id == editItem.package_id) {
									return element;
								}
							});

							oneBarcodeKeyword = '';

							if (Utilities.safelyCheckPropertyOnObject('pkg.0.CHARACS', pkg)) {
								if (Utilities.safelyCheckPropertyOnObject('editItem.CHARACS.0.gate_enhancement_keyword', editItem, 'validString')) {
									oneBarcodeKeyword = editItem.CHARACS[0].gate_enhancement_keyword;
								} else {
									oneBarcodeKeyword = pkg[0].CHARACS.oneBarcodeKeyword;
								}
							}
						}
					});
					for (var i = 0; i < addlCartItems.length; i++) {
						var addlItem = addlCartItems[i];
						if (angular.isDefined(addlItem.CHARACS) && angular.isArray(addlItem.CHARACS) && addlItem.CHARACS.length > 0) {
							var addlItemsCharacs = addlItem.CHARACS[0];
							//We must not only check the group uuid, but also that this item is part of the original season pass/membership
							//addon list. This does not include addons that have gone through the unassigned addon flow because once editing
							//we have no way of adding these packages back to the group.
							if (
								addlItemsCharacs.group_uuid &&
								addlItemsCharacs.group_uuid == groupUUID &&
								(
									service.hasOneBarcodeKeyword(addlItem.package_id, oneBarcodeKeyword) ||
									service.isGateEnhancementItem(addlItem)
								)
							) {
								addlCartItems.splice(i, 1);
								i--;
							}
						}
					}
				}
			};

			return service;
		}

	);

/**
 * Created by dsmith on 10/27/2014.
 */
angular.module('app')
	.service('Verification', function(
		AppData,
		Enums,
		ExtraFlow,
		Package,
		LegacyCart,
		Utilities,
		UtilsValidation,
		$q,
		$stateParams,
		RouteRejectionService,
		StandardFlowInitiatorService) {
		/**
		 * service object
		 */
		var service = {},
			isString = angular.isString,
			isDuplicateBarcode = false,
			getBoolean = Utilities.getBoolean,
			safelyCheckPropertyOnObject = Utilities.safelyCheckPropertyOnObject,
			validObject = UtilsValidation.validObject,
			validString = UtilsValidation.validString,
			validArray = UtilsValidation.validArray,
			wrapObjectToArray = Utilities.wrapObjectToArray,
			verificationAppConfig;

		/**
		 * array of verification information (only needed if multi-verification is enabled)
		 */
		service.data = [];

		/**
		 * whether multi-verification is enabled or not
		 */
		service.multiVerification = false;

		/**
		 * whether each entry must have a unique value (only affects multi-verification)
		 */
		service.uniqueValues = true;

		/**
		 * the service call to make to backend
		 */
		service.verifyService = '';

		// Methods
		service.checkforDuplicatedBarcodeOrMediaNumber = checkforDuplicatedBarcodeOrMediaNumber;
		service.getLookUpCharacMapping = getLookUpCharacMapping;

		/**
		 * resets service data and settings
		 */
		service.reset = function() {
			service.multiVerification = false;
			service.data = [];
			service.verifyService = '';
		};

		service.validate = function(index) {
			if (angular.isUndefined(index)) {
				index = service.data.length - 1;
			}

			var item = service.data[ index ];

			item.unique = true;

			//check to make sure all entries are unique
			if (service.uniqueValues) {
				var i,
					j;
				for (i = index - 1; i >= 0; i--) {
					if (service.data[ i ].value == item.value) {
						item.valid = false;
						item.unique = false;
						return false;
					}
				}

				//check items in cart
				for (i = 0, j = LegacyCart.cartItems.length; i < j; i++) {
					var cartItem = LegacyCart.cartItems[ i ];

					if (cartItem.package_id != item.package.package_id || cartItem.customer_type != item.package.customer_type) {
						//the package in the cart does not match the current package
						continue;
					}

					var cartItemXMCs = cartItem.CHARACS[ 0 ][ ExtraFlow.CLIENT_XFC_NAME ].split(',');
					if (cartItemXMCs.indexOf(Package.settings.name) == -1) {
						//cart item did not go through verification xmc
						continue;
					}

					for (var charac in cartItem.CHARACS) {
						switch (Package.settings.serviceCall) {
						case Enums.services.VALIDATE_SEASON_PASS:
						case Enums.services.SEASON_PASS_ACTIVE:
							if (cartItem.CHARACS[ charac ][ 'season_pass_id' ] == item.value) {
								item.valid = false;
								item.unique = false;
								return false;
							}
							break;
						default:
							break;
						}
					}
				}
			}

			return true;
		};

		/**
		 * Verifies on BE SeasonPassId, if it doesn't find it then it checks against barcodeNumber, lastly clientMediaNumber
		 * @param {Number} index
		 * @returns {Promise} if index is undefined or the service call is not a function, the promise will be rejected
		 * else it will return ValidateSesonPassID
		 */
		service.verify = function(index) {
			if (!angular.isFunction(service[ service.verifyService ]) || angular.isUndefined(index)) {
				var deferred = $q.defer();
				deferred.reject();
				return deferred.promise;
			} else {
				// Changing value to all uppercase to make checking barcodes case insensitive
				service.data[index].value = service.data[index].value.toUpperCase();
				return service[ service.verifyService ](service.data[ index ]);
			}
		};

		/**
		 * verification function for seasonPassActive service
		 */
		service.seasonPassActive = function(verifyItem) {
			var reqObj = {},
				packageCharacs;

			if (safelyCheckPropertyOnObject('verificationAppConfig.sendEventDetails', verificationAppConfig) && validArray(Package.itemsToBeAdded) && validArray(Package.itemsToBeAdded[0].CHARACS)) {
				packageCharacs = Package.itemsToBeAdded[0].CHARACS[0];
				if (safelyCheckPropertyOnObject('packageCharacs.start_date', packageCharacs, validString)) {
					reqObj.start_date = packageCharacs.start_date;
				}

				if (safelyCheckPropertyOnObject('packageCharacs.start_time', packageCharacs, validString)) {
					reqObj.start_time = packageCharacs.start_time;
				}
			}

			if (validObject(verificationAppConfig) && verificationAppConfig.validateAsMediaNumber) {
				reqObj.media_number = verifyItem.value;
			} else {
				reqObj.barcode = verifyItem.value;
				reqObj.package_id = Package.packageDetails.id;
			}

			return handleBasicSeasonPassCheck(verifyItem, Enums.services.SEASON_PASS_ACTIVE, reqObj);
		};

		/**
		 * verification function for ValidateSeasonPassID service
		 */
		service.ValidateSeasonPassID = function(verifyItem) {
			var reqObj = {
				season_pass_id: verifyItem.value,
				package_id: Package.packageDetails.id
			};

			return handleBasicSeasonPassCheck(verifyItem, Enums.services.VALIDATE_SEASON_PASS, reqObj);
		};

		/**
		 * Handles season pass check
		 * @param {Object} verifyItem item to be verified
		 * @param {String} serviceCall service call
		 * @param {Object} requestObject request object
		 * @returns {Promise} season pass verification validation promise
		 */
		function handleBasicSeasonPassCheck(verifyItem, serviceCall, requestObject) {
			var item = verifyItem;

			var deferred = $q.defer();

			// Adding for Merlin: the ability to have the verification module not actually do any verification:
			if (getBoolean(AppData.settings.do_not_verify_season_pass)) {
				item.CHARACS = { season_pass_id: item.value };
				item.valid = true;
				deferred.resolve();
			} else {
				AppData.fetch(serviceCall, false, requestObject).then(function(data) {
					var result = "";

					isDuplicateBarcode = service.checkforDuplicatedBarcodeOrMediaNumber(data.TicketBarcodeNo, requestObject.media_number, item.value);
					if (data.status === Enums.status.OK && !isDuplicateBarcode) {
						if (safelyCheckPropertyOnObject('data.PS.P', data)) {
							var pkgData = wrapObjectToArray(data.PS.P);
							var validPackages = pkgData.map(function(item) {
								return item.id;
							 }).join(',');
							item.valid = true;
							if (requestObject.media_number) {
								item.CHARACS = { client_media_number: requestObject.media_number };
							}
							if (data.order_id && data.ticket_id) {
								item.CHARACS.verified_order_id = data.order_id;
								item.CHARACS.verified_ticket_id = data.ticket_id;
							}
							deferred.resolve(validPackages);
						} else if (isString(data.season_pass_status)) {
							result = data.season_pass_status;
						} else if (isString(data.SeasonPassActive)) {
							result = data.SeasonPassActive;
						}
						result = result.toLowerCase();

						if (result === "ok" || result === "true") {
							item.CHARACS = {
								season_pass_id: item.value,
								ticket_barcode_no: data.TicketBarcodeNo
							};
							item.valid = true;
							deferred.resolve(data);
						} else {
							item.valid = false;
							deferred.reject(data);
						}
					} else {
						item.valid = false;
						deferred.reject(data);
					}
				});
			}

			return deferred.promise;
		}

		/**
		 * return isDuplicatedBarcode value
		 * @public
		 * @return {boolean} isDuplicatedBarcode
		 */
		service.getDuplicateBarcode = function() {
			return isDuplicateBarcode;
		};

		/**
		 * Set verification appconfig when it's validated in controller
		 * @public
		 * @return {undefined}
		 */
		service.setVerificationAppConfig = function(config) {
			verificationAppConfig = config;
		};

		/**
		 * Returns lookup mapping
		 * @param {String} barcodeNumber bar code number
		 * @param {String} clientMediaNumber media number
		 * @param {String} seasonPassId season pass id
		 * @returns {Object} lookup value charac mapping
		 */
		function getLookUpCharacMapping(barcodeNumber, clientMediaNumber, seasonPassId) {
			var lookUpValues = [{
				value: barcodeNumber,
				charac: 'ticket_barcode_no'
			}, {
				value: clientMediaNumber,
				charac: 'client_media_number'
			}, {
				value: seasonPassId,
				charac: 'season_pass_id'
			}];

			var validLookUpValue = lookUpValues.find(function findValidValue(lookUpVal) {
				return validString(lookUpVal.value);
			});

			return validLookUpValue || {};
		}

		/**
		 * If barcode is duplicated and appconfig is added, then we should stop guests from purchasing the addon
		 * @public
		 * @param {String} barcodeNumber barcode number
		 * @param {String} clientMediaNumber media number
		 * @param {String} seasonPassId season pass id
		 * @returns {Boolean} has duplicate
		 */
		function checkforDuplicatedBarcodeOrMediaNumber(barcodeNumber, clientMediaNumber, seasonPassId) {
			var lookupCharac = service.getLookUpCharacMapping(barcodeNumber, clientMediaNumber, seasonPassId);
			if (verificationAppConfig && getBoolean(verificationAppConfig.validate_duplicated_barcode)) {
				if (service.checkBarcodeAgainstServiceData(barcodeNumber, clientMediaNumber, seasonPassId)) {
					return true;
				}
				//Checking against cart items
				return LegacyCart.cartItems.some(function(item) {
					if (safelyCheckPropertyOnObject('item.CHARACS.0.' + lookupCharac.charac, item)) {
						return item.CHARACS[0][lookupCharac.charac] === lookupCharac.value;
					}
					return false;
				});
			}
			return false;
		}

		/**
		 * If barcode is matched with other service data passes, then we should stop guests from purchasing the addon
		 * @protected
		 * @param {String} barcodeNumber - barcode number that we are validating
		 * @param {String} clientMediaNumber - optional client media  number that we are validating
		 * @param {String} seasonPassId - season pass id that we are validating
		 * @return {Boolean} - is barcode duplicated?
		 */
		service.checkBarcodeAgainstServiceData = function(barcodeNumber, clientMediaNumber, seasonPassId) {
			var lookupCharac = service.getLookUpCharacMapping(barcodeNumber, clientMediaNumber, seasonPassId);
			return service.data.some(function(data) {
				if (safelyCheckPropertyOnObject('data.CHARACS.' + lookupCharac.charac, data)) {
					return data.CHARACS[lookupCharac.charac] === lookupCharac.value;
				}
				return false;
			});
		};

		service.interactionComplete = function(overridePackageIds, isVerifyPassKeywordFlow) {
			var items = [];
			var sourceI = 0;
			var verificationPackages = overridePackageIds ? retrievePackageArrayFromId(overridePackageIds) : service.getItemsEligibleForVerification();
			for (var i = 0; i < verificationPackages.length; i++) {
				var item = verificationPackages[ i ];

				item.CHARACS = item.CHARACS || [];
				items.push(item);

				for (var charac = 0; charac < item.qty; charac++) {
					item.CHARACS[ charac ] = item.CHARACS[ charac ] || {};

					for (var key in service.data[ sourceI ].CHARACS) {
						item.CHARACS[ charac ][ key ] = service.data[ sourceI ].CHARACS[ key ];
					}

					if (service.multiVerification) {
						sourceI++;
					}
				}
			}

			// Add reference of XFC to CHARACs.
			if (!isVerifyPassKeywordFlow) {
				ExtraFlow.addReferenceToCartItems(Package.settings.view, items, ExtraFlow.CLIENT_XFC_VIEW);
				ExtraFlow.addReferenceToCartItems(Package.settings.name, items, ExtraFlow.CLIENT_XFC_NAME);
			} else {
				Package.alternateModuleItemsToBeAdded = items;
				StandardFlowInitiatorService.setAlternateEntryToStandardFlow('verify-pass', 'verify-pass', $stateParams, false);
			}
		};

		service.getQty = function() {
			var qty = 0;
			var pkgs = service.getItemsEligibleForVerification();
			for (var i = 0; i < pkgs.length; i++) {
				qty += Number(pkgs[ i ].qty);
			}
			return qty;
		};

		/*
		 *	Wrapper for Package.itemsToBeAddedForCurrentPackage
		 *	With the introduction of customer type validation to the verification movie,
		 *	we can have a scenario with 2 customer types where only 1 requires verification.
		 *	Thus, we still go through the verification movie, but only want to do so for the 1 that requires verification.
		 *	This provides a minimally intrusive way of doing so throughout verification, and also simplifies the logic for
		 *	checking if verification is necessary.
		 */
		service.getItemsEligibleForVerification = function() {
			var items = Package.itemsToBeAddedForCurrentPackage();

			if (safelyCheckPropertyOnObject('Package.packageDetails.CHARACS.verification_customer_types', Package)) {
				// The charac is a csl of customer types that REQUIRE verification
				var customerTypes = Package.packageDetails.CHARACS.verification_customer_types.replace(/\s/g, '').split(',');

				items = items.filter(function(item) {
					// Only return items in the charac signaling them to be eligible for verification
					if (customerTypes.indexOf(item.customer_type) === -1) {
						// add reference characs to item so the sanitization will pass on purchase
						ExtraFlow.addReferenceToCartItems(Package.settings.view, [item], ExtraFlow.CLIENT_XFC_VIEW);
						ExtraFlow.addReferenceToCartItems(Package.settings.name, [item], ExtraFlow.CLIENT_XFC_NAME);
						return false;
					} else {
						return true;
					}
				});
			}

			return items;
		};

		/*
		 *	Historically, if the extra movie was present (package level), then verification was performed for all customer types.
		 *	This allows us to only perform verification if necessary
		 *	- specifically to skip verification if a customer type does not require it AND it is the only ct selected
		 *
		 *	If a user selects multiple customer types, and 1 requires verification and 1 does not, the verification movie will
		 *	still occur, but only for the 1 that is required.
		 */
		service.isVerificationNecessary = function(trans) {
			var items = service.getItemsEligibleForVerification();

			// We need to check if certain characs are present in the items, if they are we do not need to verify
			items = items.filter(function(item) {
				ExtraFlow.addReferenceToCartItems(Package.settings.view, [item], ExtraFlow.CLIENT_XFC_VIEW);
				ExtraFlow.addReferenceToCartItems(Package.settings.name, [item], ExtraFlow.CLIENT_XFC_NAME);
				return !(Package.hasCharac(item, 'client_media_number') || Package.hasCharac(item, 'ticket_barcode_no') || Package.hasCharac(item, 'season_pass_id'));
			});

			// If none of our selected customer types require verification - we will have no items and can skip
			if (items.length === 0 && trans.packageId) {
				// Make sure we are forward routing
				if (Package.isForwardExtraFlowRouting()) {
					Package.nextXFC();
				}
				// Backwards routing - cancel so we don't get stuck in an infinite loop
				else {
					Package.cancelXFC();
				}
			}

			return true;
		};

		/**
		 * Checks to see if we are at a valid route
		 * @returns {boolean} true if route is valid
		 * @throws {UnrecoverableException}
         */
		service.assessRoute = function(trans) {
			if (trans.packageId) {
				var rejectionRoute = Package.assessRoutabilityOfXFC(trans.packageId);
				if (!Utilities.isEmpty(rejectionRoute)) {
					throw new RouteRejectionService.UnrecoverableException(rejectionRoute);
				}
				return true;
			} else {
				return true;
			}
		};

		/**
		 * Retrieve the package array needed
		 * @param {String} packageIds - comma-separated list of packageIds
		 * @return {Array} Array of Package objects (in this case a single one for a stub for alternate module items to be added)
		 */
		function retrievePackageArrayFromId(packageIds) {
			var ids = packageIds.split(',');
			var pkgArray = [];
			var package, ct;
			ids.forEach(function iterateIds(id) {
				package = Package.getPackageByID(id);
				ct = Utilities.first(package.CT);
				pkgArray.push({
					qty: 1, // Set to one since this is going to change in packageDetails
					package_name: package.name,
					customer_type: ct.id,
					package_id: package.id,
					cusTypeName: ct.name,
					cusTypeRetail: (ct.discountedRetailAmount != -1 ? ct.discountedRetailAmount : ct.retail_amount),
					extra_movie: package.extra_movie || '',
					promo_code: package.promo_code || '',
					cart_limit_override: package.cart_limit_override || '',
					CHARACS: [{}]
				});
			});
			return pkgArray;
		}

		return service;
	});

/**
 * Created by ltischuk on 2/3/15.
 */
angular.module(
	'app'
).service
(
	'AltRoutingService',

	function(
		AppData,
		Utilities,
		 Enums) {
		//mutually exclusive hooks for interceptive routing to alternate views
		var actions = {}

		//here we can check for certain conditions that exist post purchase
		this.getAltRoute = function(stateName) {
			var altRoute = undefined;
			try {
				if (actions[stateName]) {
					var action = actions[stateName];
					if (angular.isDefined(action)) {
						altRoute = action();
					}
				}
			} catch (e) {
				altRoute = undefined;
			}

			return altRoute;
		}

		this.registerAltRoute = function(stateName, shouldSatisfy) {
			actions[stateName] = shouldSatisfy;
		}
	}
);

/**
 * Created by ltischuk on 1/6/15.
 */

angular.module('app')
	.service
	('ImagePreloaderService'
		, function($q) {
		/**
		 * Helper class to handle actions post image preload for resolving images in promises
		 * @param callback
		 * @param params
		 * @constructor
		 */
			function ImageResult(callback, params) {
				this.callback = callback;
				this.params = params;
			}

			ImageResult.prototype = {

				success: function() {
					this.callback.apply(this, this.params);
				}

			}

			//ImagePreloader private class to help preload images so they can be easily drawn
			function ImagePreloader() {

			}

			/**
			 * A promise to resolve an ImageResult which allows for proper executing of actions post-load by the calling class
			 * This ensures that any variables that are dependent on these images get properly updated with the image data at the right time
			 * @param {Object} imgUrl - the image data to load (URL or base64 string)
			 * @param {Function} successCallback - function to call on successful image preload
			 * @param {Array} params - array of params to pass as arguments when executing the callback function
			 * @returns {*}
			 */
			ImagePreloader.prototype.preloadImage = function(imgUrl, successCallback, params) {
				var deferred = $q.defer();

				if (angular.isUndefined(imgUrl)) {
					deferred.reject('Url not defined');
				}

				var img = new Image();

				img.onload = function() {
					params = params.concat(this);
					deferred.resolve(new ImageResult(successCallback, params));
				}

				img.onerror = function() {
					deferred.reject('Image load error');
				}

				img.src = imgUrl;

				return deferred.promise;
			}

			this.ImagePreloader = ImagePreloader;
		}

	)


/**
 * Created by ltischuk on 2/8/16.
 */
'use strict';

angular.module('app')
	.service('CustomerTypeService',
		function CustomerTypeService(
			Enums,
			AppData,
			Package,
			RequestService,
			Utilities,
			$q) {
			/**
			 * Get the online price for a customer type
			 * @param customerType {object: id,rate_id, retail_amount,tax_amount}
			 * @returns {number}
			 */
			this.getOnlinePriceForCustomerType = function(customerType) {
				return Utilities.getTotalPrice(customerType);
			};

			/**
			 * Get the gate price for a customer type
			 * @param customerType {object: id,rate_id, retail_amount,tax_amount}
			 * @returns {number}
			 */
			this.getGatePriceForCustomerType = function(customerType) {
				return (angular.isDefined(customerType.gate_price)) ? Number(customerType.gate_price) : 0;
			};

			this.loadCTCharacs = function(packageId) {
				// don't do anything if there's no package Id
				if (angular.isUndefined(packageId)) {
					return true;
				}
				var packageCT = undefined,
					request = { PACKAGE: [{ package_id: packageId }] };

				for (var i = 0; i < AppData.GetMerchantPackageList.PS.P.length; i++) {
					var pkg = AppData.GetMerchantPackageList.PS.P[i];
					if (pkg.id === packageId) {
						if (Utilities.getBoolean(pkg.CHARACS.useCTCharacs)) {
							packageCT = pkg.CT;
						}
						break;
					}
				}

				// if we found the package and it needs CT CHARACS but doesn't have any:
				if (angular.isDefined(packageCT) && angular.isUndefined(packageCT[0].CHARACS)) {
					// set up all the characs to start (this will prevent us from making this call again, even if it fails).
					packageCT.forEach(function(ct) {
						ct.CHARACS = {};
					});

					return AppData.fetch(Enums.services.GET_CUSTOMER_TYPE_CHARACS, false, request).then(
						function(response) {
							/*
							 * Structure of data coming back from GetMPCTCharacs:
							 * status, PACKAGE: [{id, CUSTOMER_TYPE:[{name, value},{name, value}...]}]
							 */
							if (response.status === Enums.status.OK && angular.isDefined(response.PACKAGE)) {
								var pkgItem = angular.isArray(response.PACKAGE) ? response.PACKAGE[0] : response.PACKAGE;
								if (angular.isDefined(pkgItem.CUSTOMER_TYPE)) {
									pkgItem.CUSTOMER_TYPE = (angular.isArray(pkgItem.CUSTOMER_TYPE) ? pkgItem.CUSTOMER_TYPE : [pkgItem.CUSTOMER_TYPE]);
									// pkgItem now has an array of customer Types on it.
									pkgItem.CUSTOMER_TYPE.forEach(function(ct) {
										var ctMatch = packageCT.filter(function(ctItem) {
											return ct.customer_type === ctItem.id;
										})[0];

										// in the response, CHARAC is singular (instead of plural like it is elsewhere)
										if (angular.isDefined(ctMatch) && angular.isDefined(ct.CHARAC)) {
											var characArray = angular.isArray(ct.CHARAC) ? ct.CHARAC : [ct.CHARAC];

											// the response from the back end is an array of name, value pairs.
											characArray.forEach(function(charac) {
												ctMatch.CHARACS[charac.name] = charac.value;
											});
										}
									});

									appendCTCharacsResponseToPackageList(response, [Package.packageDetails]);
								}
							}
						});
				} else {
					return $q.when();
				}
			};


			/**
			 * Append CT characs to a specific list of packages
			 * This is currently a very heavy call for BE so having them do all of this up front is not plausible at this time
			 * Instead, we request these as we need them for different flows - this function can be used to request these CT Characs for a sublist of packages from the
			 * GetMerchantPackageList call (AppData.GetMerchantPackageList array)
			 * We can positively affect the packages by appending "CHARACS" to the CT objects on the package objects
			 * This function will check for that in the future so that we don't end up re-requesting CT Characs for packages that already have them
			 * @param {Array} packageList
			 * @returns {*}
			 */
			this.appendCTCharacsForSpecificListOfPackages = function(packageList) {
				return $q(function(resolve, reject) {
					var request = { PACKAGE: [] };
					if (angular.isArray(packageList)) {
						packageList.forEach(function(p) {
							//if we don't already have CT Characs on this package, add the package to the request
							if (!p.CT.some(function(ct) {
								return angular.isDefined(ct.CHARACS);
							})) {
								request.PACKAGE.push({ package_id: p.id });
							}
						});

						//only request CT Characs if we have packages to actually request - otherwise, we already appended them to the package so lets resolve
						if (request.PACKAGE.length) {
							RequestService.sendRequest(Enums.services.GET_CUSTOMER_TYPE_CHARACS, request)
								.then(function(response) {
									if (angular.isDefined(response.PACKAGE)) {
										appendCTCharacsResponseToPackageList(response, packageList);
										resolve();
									} else {
										reject();
									}
								})
								.catch(reject);
						} else {
							resolve();
						}
					} else {
						reject();
					}
				});
			}


			/**
			 * Append the CT Characs response to the package list
			 * @param response
			 * @param packageList
			 */
			function appendCTCharacsResponseToPackageList(response, packageList) {
				var responsePackages = Utilities.wrapObjectToArray(response.PACKAGE);
				packageList.forEach(function(p) {
					var matchingPkgInResponse = responsePackages.filter(function(rp) {
						return rp.package_id === p.id;
					})[0];
					matchingPkgInResponse.CUSTOMER_TYPE = Utilities.wrapObjectToArray(matchingPkgInResponse.CUSTOMER_TYPE);
					if (angular.isDefined(matchingPkgInResponse) && angular.isDefined(p.CT)) {
						p.CT.forEach(function(ct) {
							var responsePkgMatchinCT = matchingPkgInResponse.CUSTOMER_TYPE.filter(function(rpct) {
								return rpct.customer_type === ct.id;
							})[0];

							if (angular.isDefined(responsePkgMatchinCT) && angular.isDefined(responsePkgMatchinCT.CHARAC)) {
								var characArray = Utilities.wrapObjectToArray(responsePkgMatchinCT.CHARAC);

								ct.CHARACS = angular.isUndefined(ct.CHARACS) ? {} : ct.CHARACS;
								// the response from the back end is an array of name, value pairs.
								characArray.forEach(function(charac) {
									ct.CHARACS[charac.name] = charac.value;
								});
							}
						});
					}
				});
			}
		});

/**
 * Created by jwroblewski on 2/5/2016.
 */
angular.module('app').factory
('DynamicPricingService',
	function(
		$q,
		$rootScope,
		AppData,
		LegacyCart,
		Enums,
		Language,
		Package,
		Utilities
	) {
		/**
         * Stores the GROUP objects that is returned by GetMerchantPackageList.
         * This is the list of Package Id's that are all related in the MultiPack setup
         * This is used to determine the quantity of all MultiPack packages to determine
         * if the MultiPack price should be set.
         * @type {Array}
         */
		var multiPackGroupList = [];

		/**
         * Store the MULTIPACK objects that is returned by GetMerchantPackageList.
         * This object contains the meta data for each source package that the dynamic
         * price logic uses.
         * @type {Array}
         */
		var multiPackMetaDataList = [];

		/**
         * Stores the count of Customer Types where the price has changed.
         * This is used to determine if a callBack should be called so the
         * consumer of the service can format the updated Customer Type(s) appropriately.
         * @type {number}
         */
		var customerTypeChangeCount = 0;

			 /**
			  * getPackageSwapsCalled is a flag that lets us know we don't have to call
				 * GetMerchantPackageList again. It's necessary for islands that don't have any dynamic
				 * pricing. In that situation, the calls return empty data, which was causing us to make the
				 * API call over and over again.
			  * @type {boolean}
         */
			 var getPackageSwapsCalled = false;

		var factory = {
			enabled: false,
			getMultiPackMetaData: getMultiPackMetaData,
			setDynamicPrice: setDynamicPrice,
			     getMultiPackData: getMultiPackData
		};

		//--------------------------------------------------------------------------------------------------------------
		// Public Functions
		//--------------------------------------------------------------------------------------------------------------

		/**
         * Retrieves the MultiPack meta data required to set the dynamic price from
         * a new GetMerchantPackageList request.
         * @returns {defer.promise|{then, catch, finally}|p.promise|{then, fail, end}|Document.promise|k.promise|*}
         */
		function getMultiPackMetaData() {
			var defer = $q.defer();
			factory.enabled = Utilities.getBoolean(AppData.settings.dynamic_pricing_enabled);

			if (factory.enabled && !getPackageSwapsCalled) {
				$rootScope.showSpinner(Language.getLocale('ApplicationLabels', 'loadingMsg'));

				AppData.fetch(Enums.services.GET_PACKAGE_SWAPS,
					false,
					{ merchant_id: AppData.merchantId }
				).then(function(data) {
					getPackageSwapsCalled = true;

					if (Utilities.safelyCheckPropertyOnObject('data.GROUPS.GROUP', data)) {
						// Wrap all GROUPS in array.
						Utilities.arrayWrap(data.GROUPS, 'GROUP');
						multiPackGroupList = angular.copy(data.GROUPS.GROUP);
					}

					if (Utilities.safelyCheckPropertyOnObject('data.MULTIPACKS.MULTIPACK', data)) {
						Utilities.arrayWrap(data.MULTIPACKS, 'MULTIPACK');
						multiPackMetaDataList = angular.copy(data.MULTIPACKS.MULTIPACK);
					}

					defer.resolve(data);
				});
			} else {
				defer.resolve();
			}

			return defer.promise;
		}

		/**
         * Sets the price properties in the customerTypes to either MultiPack equivalent
         * or back to the original price.
         * @param packageDetails {Object} The current package
         * @param customerTypes {Array} An array of the customerTypes of the current package
         * @param setPriceCallback {function} Allows the consumer to pass in custom logic to handle
         *   any updated customerTypes.  Use this to format the price information required for the
         *   specific module/service/controller/directive, etc.
         */
		function setDynamicPrice(packageDetails, customerTypes, setPriceCallback) {
			customerTypeChangeCount = 0;

			// Dynamic Pricing must be enabled and
			// the required multipack metadata must be present.
			if (factory.enabled &&
                multiPackGroupList.length > 0 &&
                multiPackMetaDataList.length > 0) {
				customerTypes.forEach(function(customerType) {
					var currentMetaData;
					if (angular.isDefined(customerType.source_package_id)) {
						currentMetaData = getCurrentMultiPackMetaData(customerType.source_package_id);
					} else if (angular.isDefined(packageDetails)) {
						currentMetaData = getCurrentMultiPackMetaData(packageDetails.id);
					}
					if (angular.isDefined(currentMetaData)) {
						var totalQty = getTotalCustomerTypeQty(currentMetaData.link_id, customerTypes, packageDetails);
						var ctSwapUpQty = Number(currentMetaData.multipack_min_quantity) || 0;

						// Swap "up" or "down"
						if (totalQty >= ctSwapUpQty) {
							swapToMultiPackPrice(currentMetaData, customerType);
						} else {
							swapToOriginalPrice(packageDetails, customerType);
						}
					}
				});

				// Only do the callback if any changes were made
				if (angular.isDefined(setPriceCallback) && customerTypeChangeCount > 0) {
					setPriceCallback();
				}
			}
		}

		function getMultiPackData(packageDetails, customerType) {
			if (factory.enabled &&
            multiPackGroupList.length > 0 &&
            multiPackMetaDataList.length > 0) {
				var currentMetaData;
				if (angular.isDefined(customerType.source_package_id)) {
					currentMetaData = getCurrentMultiPackMetaData(customerType.source_package_id);
				} else if (angular.isDefined(packageDetails)) {
					currentMetaData = getCurrentMultiPackMetaData(packageDetails.id);
				}
				if (angular.isDefined(currentMetaData)) {
					return currentMetaData;
				}
			}
			return undefined;
		}

		//--------------------------------------------------------------------------------------------------------------
		// Private Functions
		//--------------------------------------------------------------------------------------------------------------
		function getCurrentMultiPackMetaData(sourcePackageId) {
			if (angular.isDefined(sourcePackageId)) {
				for (var mpIdx = 0; mpIdx < multiPackMetaDataList.length; mpIdx++) {
					var mpMetaData = multiPackMetaDataList[mpIdx];
					if (multipackMetaDataHasRequiredProperties(mpMetaData) &&
                        mpMetaData.source_package_id == sourcePackageId) {
						return mpMetaData;
					}
				}
			}
		}

		function multipackMetaDataHasRequiredProperties(mpMetaData) {
			return (Utilities.safelyCheckPropertyOnObject('mpMetaData.source_package_id', mpMetaData) &&
                Utilities.safelyCheckPropertyOnObject('mpMetaData.multipack_min_quantity', mpMetaData) &&
                Utilities.safelyCheckPropertyOnObject('mpMetaData.multipack_package_id', mpMetaData) &&
                Utilities.safelyCheckPropertyOnObject('mpMetaData.link_id', mpMetaData));
		}

		function getTotalCustomerTypeQty(currentGroupId, customerTypes, packageDetails) {
			var groupItems = getItemsForCurrentGroup(currentGroupId);
			var currentCTQty = getCurrentCustomerTypeQty(customerTypes, groupItems, packageDetails);
			var cartCTQty = getCartItemsQty(groupItems);

			// add these two sums to get the total
			return currentCTQty + cartCTQty;
		}

		function getItemsForCurrentGroup(groupId) {
			var items = [];
			if (angular.isDefined(groupId)) {
				for (var grpIdx = 0; grpIdx < multiPackGroupList.length; grpIdx++) {
					var mpGroup = multiPackGroupList[grpIdx];
					if (mpGroup.id == groupId) {
						return mpGroup.P;
					}
				}
			}
			return items;
		}

		function getCurrentCustomerTypeQty(customerTypes, groupItems, packageDetails) {
			var currentCTQty = 0;

			customerTypes.forEach(function(customerType) {
				var inGroup;
				if (angular.isDefined(customerType.source_package_id)) {
								 inGroup = groupItems.some(function(item) {
						return item.id == customerType.source_package_id;
					});
				} else if (angular.isDefined(packageDetails)) {
					inGroup = groupItems.some(function(item) {
						return item.id == packageDetails.id;
					});
				}
				if (inGroup) {
					currentCTQty += Number(customerType.qty);
				}
			});
			return currentCTQty;
		}

		function getCartItemsQty(groupItems) {
			var cartItemQty = 0;
			var cartItems = LegacyCart.cartItems;

			cartItems.forEach(function(cartItem) {
				var inGroup = groupItems.some(function(item) {
					return item.id == cartItem.package_id;
				});

				if (inGroup) {
					cartItemQty += Number(cartItem.qty);
				}
			});
			return cartItemQty;
		}

		function swapToMultiPackPrice(currentMetaData, customerType) {
			// this check is here to allow the service to only change the CT when appropriate
			customerType.dynamicPricingSwapUp = angular.isUndefined(customerType.dynamicPricingSwapUp) ? true : customerType.dynamicPricingSwapUp;
			if (customerType.dynamicPricingSwapUp) {
				var mpCustomerTypes = getMultiPackCustomerTypes(currentMetaData.multipack_package_id);

				mpCustomerTypes.forEach(function(mpCustomerType) {
					if (mpCustomerType.id == customerType.id) {
						mapCustomerTypes(mpCustomerType, customerType);
						customerTypeChangeCount++;
					}
				});

				// disable swap up because we have already swapped up
				customerType.dynamicPricingSwapUp = false;

				// enable swap down in case the qty gets decreased
				customerType.dynamicPricingSwapDown = true;
			}
		}

		function swapToOriginalPrice(packageDetails, customerType) {
			var origCustomerTypes = packageDetails.CT || [];

			// this check is here to allow the service to only change the CT when appropriate
			customerType.dynamicPricingSwapDown = angular.isUndefined(customerType.dynamicPricingSwapDown) ? true : customerType.dynamicPricingSwapDown;
			if (customerType.dynamicPricingSwapDown) {
				origCustomerTypes.forEach(function(origCustomerType) {
					if (customerType.id == origCustomerType.id) {
						mapCustomerTypes(origCustomerType, customerType);
						customerTypeChangeCount++;
					}
				});

				// enable swap up in case the qty is increased
				customerType.dynamicPricingSwapUp = true;

				// disable the swap down because we have already swapped down
				customerType.dynamicPricingSwapDown = false;
			}
		}

		function getMultiPackCustomerTypes(sourcePackageId) {
			var sourcePackage = Package.getPackageByID(sourcePackageId);
			if (angular.isDefined(sourcePackage)) {
				return sourcePackage.CT || [];
			}
		}

		function mapCustomerTypes(srcCT, destCT) {
			var customerTypeProperties = [
				'gate_price',
				'payment_plan_amount',
				'subsequent_payment_plan_amount',
				'retail_amount',
				'tax_amount'
			];

			customerTypeProperties.forEach(function(prop) {
				destCT[prop] = srcCT[prop];
			});
		}

		return factory;
	}
);


(function() {
	'use strict';

	angular
		.module('app')
		.constant('DynamicCapacityPricingLocales', {
			fromPricing: 'fromPricing',
			startingFrom: 'startingFrom'
		})
		.service('DynamicCapacityPricingService', DynamicCapacityPricingService);

	/**
	 * The Dynamic Capacity Pricing Service
	 * @constructor
	 * @param {Service} $filter - The $filter service
	 * @param {Service} $q $q
	 * @param {Service} AppData - The AppData service
	 * @param {Object} DynamicCapacityPricingLocales - The DynamicCapacityPricingLocales constants
	 * @param {Object} Enums Enums
	 * @param {Service} ExtraFlow - The ExtraFlow Service
	 * @param {Service} Language - The Language service
	 * @param {Service} Package - The Package service
	 * @param {Service} ResellerService - The ResellerService service
	 * @param {Service} Utilities - The Utilities service
	 * @param {Service} UtilityFunctions Utilities
	 * @param {Service} UtilsPricing - The UtilsPricing service
	 * @param {Service} UtilsValidation - The UtilsValidation service
	 * @returns {Service} The DynamicCapacityPricingService
	 * @ngInject
	 */
	function DynamicCapacityPricingService($filter, $q, AppData, DynamicCapacityPricingLocales, Enums, ExtraFlow, Language, Package, ResellerService, Utilities, UtilityFunctions, UtilsPricing, UtilsValidation) {
		var $currency = $filter('currencyFormatter'),
			bind = angular.bind,
			checkProp = Utilities.checkProp,
			getString = Utilities.getString,
			isNumeric = UtilsValidation.isNumeric,
			toArray = Utilities.wrapObjectToArray,
			validArray = UtilsValidation.validArray,
			validObject = UtilsValidation.validObject;

		var service = {
			clearCachedPricing: clearCachedPricing,
			fetchCachedPricing: bind(null, fetchPricing, false),
			fetchLivePricing: bind(null, fetchPricing, true),
			getCalculatedPricingForCts: getCalculatedPricingForCts,
			getCtsForAdjustmentCall: getCtsForAdjustmentCall,
			getAlternateEntryRoute: getAlternateEntryRoute,
			getDynamicPricingValues: getDynamicPricingValues,
			getDynamicPricingValuesFromAdjustments: getDynamicPricingValuesFromAdjustments,
			getFromPriceLocale: getFromPriceLocale,
			getLocale: getLocale,
			getPackageDetailsResolve: getPackageDetailsResolve,
			getPrice: getPrice,
			getRouteParams: getRouteParams,
			getDynTotalPrice: getDynTotalPrice,
			hasDynamicPricing: hasDynamicPricing,
			isCustomerTypeDynamic: isCustomerTypeDynamic,
			isPackageDynamic: isPackageDynamic,
			isPackageSetDynamic: isPackageSetDynamic,
			verifyAddToCart: verifyAddToCart,
			_: {
				findCtFromItemsToBeAdded: _findCtFromItemsToBeAdded,
				formatPricingFromAdjustedPricing: _formatPricingFromAdjustedPricing,
				getListformatPricingFromAdjustedPricing: _getListformatPricingFromAdjustedPricing,
				localeSection: 'DynamicPricing',
				locales: {}
			}
		};

		return service;

		/**
		 * Clears the cache for pricing if we determine it's invalid.
		 * @public
		 * @param {String} packageId - The package ID
		 * @param {String} startDate - The Start Date
		 * @param {String} startTime - The Start Time
		 * @returns {Promise} The fetch promise
		 */
		function clearCachedPricing(packageId, startDate, startTime) {
			var cts = service.getCtsForAdjustmentCall(packageId);

			return AppData
				.fetch(Enums.services.CLEAR_DYNAMIC_PRICE_ADJUSTMENT_CACHE, false, {
					customer_type: cts.join(','),
					package_id: packageId,
					start_date: startDate,
					start_time: startTime
				});
		}

		/**
		 * Fetches pricing
		 * @public
		 * @param {Boolean} useLive If we should use the live call or not
		 * @param {Object} packageId The package Id
		 * @param {String} startDate In the format YYYY-MM-DD
		 * @param {String} [startTime] In the format HH:MM AM/PM
		 * @param {String[]} [customerTypes] Specified Customer Types to use
		 * @returns {Promise} for the cached pricing
		 */
		function fetchPricing(useLive, packageId, startDate, startTime, customerTypes) {
			var deferred = $q.defer(),
				forceQuantity = validArray(customerTypes),
				cts = forceQuantity ? customerTypes : service.getCtsForAdjustmentCall(packageId, useLive),
				serviceName = useLive
					? Enums.services.GET_DYNAMIC_PRICING_ADJUSTMENT
					: Enums.services.GET_DYNAMIC_PRICING_ADJUSTMENT_CACHED;

			/* eslint-disable camelcase */
			var request = {
				customer_type: cts.join(','),
				package_id: packageId,
				start_date: startDate
			};

			// If start item is passed?
			if (startDate instanceof Date) {
				// Set it to the request
				request.start_date = Utilities.javascriptDateToSQLDate(startDate);
			}

			// If start item is passed?
			if (startTime) {
				// Set it to the request
				request.start_time = startTime;
			}

			// If we are in reseller mode
			if (ResellerService.isResellerMode()) {
				// Set it to the request
				request.RESELLER = angular.copy(ResellerService.getReseller());
			}

			// Fetch The Dynamic Pricing Adjustment
			AppData
				.fetch(serviceName, false, request, true, false, false)
				.then(function addPricing(data) {
					// Resolve our fetchCachedPricing Promise and returned a parsed response for pricing
					deferred.resolve(service._.getListformatPricingFromAdjustedPricing(packageId, data, forceQuantity));
				});

			// Return a promise as we fetch the pricing and parse it
			return deferred.promise;
		}

		/**
		 * Tries and finds out what alternate module this package should begin from
		 * @public
		 * @param {String} packageId - The Package ID to check
		 * @returns {Object|Boolean} If a alternate module could be found, return an object with information to route, otherwise false
		 */
		function getAlternateEntryRoute(packageId) {
			var acceptedAlternateModules = ['CalendarPricingModule', 'CalendarPricingWithImage', 'WizardCalendarPricingModule'],
				menuItem,
				pkg = Package.getPackageByID(getString(packageId)),
				keywords = toArray(pkg.KEYWORDS.K, true).map(function getKeywords(keyItem) {
					return keyItem.keyword;
				});

			// Iterate through the menu items
			AppData.menuItems.some(function iterateMenuItems(item) {
				// If our current menu item matches our conditions
				var found = keywords.includes(item.keywords) && acceptedAlternateModules.includes(item.alternateModule);

				// Have we not previous found an item?
				if (!menuItem) {
					// Did we find an item this time?
					if (found) {
						// Mark our item as found -- End game!
						menuItem = item;
					} else if (item.MENUITEM) {
						// Is there a sub menu item? try to search for our condition there
						toArray(item.MENUITEM, true).some(iterateMenuItems);
					}
				}

				// See if we can short-circuit the loop if we found what we came for
				return found;
			});

			// Did we find a match?
			if (menuItem) {
				// We found a match, therefore
				return {
					alternateModule: menuItem.alternateModule,
					params: {
						keyword: menuItem.keywords
					},
					stateName: ExtraFlow.getAlternateFlowSettings(menuItem.alternateModule).view
				};

			}

			// No match was found, return false
			return false;
		}

		/**
		 * Takes a cross section of the customer types from the package and the items to be added and returns the intersection
		 * @public
		 * @param {String} packageId - The package ID
		 * @param {Boolean} [skipItemsToBeAddedCheck] - If we want to skip checking itemsToBeAdded and get a list of all CTs
		 * @returns {String[]} A list of the applicable CTs
		 */
		function getCtsForAdjustmentCall(packageId, skipItemsToBeAddedCheck) {
			var pkg = Package.getPackageByID(packageId),
				cts = [];

			// Iterate over package CTs
			toArray(pkg.CT, true).forEach(function iteratePackageCt(ct) {
				// Does the CT exist from items to be added?
				if (skipItemsToBeAddedCheck || service._.findCtFromItemsToBeAdded(packageId, ct.id)) {
					// Add to CTs
					cts.push(ct.id);
				}
			});

			// Return the CTs
			return cts;
		}

		/**
		 * Returns the price to display for the response
		 * @param {String} packageId Package ID for the customer type
		 * @param {Object} ct The customer type from the response
		 * @param {Object} [mapping] - Custom mapping to retrieve DYNAMIC_PRICING values
		 * @returns {Number} the price
		 */
		function getPrice(packageId, ct, mapping) {
			var dynamicPrice = service.getDynamicPricingValues(ct, packageId, mapping),
				useFeeInclusive = AppData.defaults.use_fee_inclusive_pricing,
				pkg,
				pkgCt,
				fees;

			// Always get package CT to access ticket-level fees
			pkg = Package.getPackageByID(packageId);
			pkgCt = pkg.CT.find(UtilityFunctions.filterById(ct.id));

			if (dynamicPrice) {
				return !dynamicPrice.isTaxInclusive || useFeeInclusive ? service.getDynTotalPrice(dynamicPrice) : parseFloat(dynamicPrice.price);
			}

			// Fallback for packages without dynamic pricing
			fees = pkgCt.F || pkgCt.FEE || pkgCt.fee_total;
			return UtilsPricing.getPrice(pkgCt.retail_amount, pkgCt.tax_amount, fees);
		}

		/**
		 * Returns a vat inclusive price.
		 * @public
		 * @param {Object} prices A object from getDynamicPricingValues or getDynamicPricingValuesFromAdjustment
		 * @returns {Number} the total
		 */
		function getDynTotalPrice(prices) {
			var useVat = AppData.defaults.use_vat,
				useFeeInclusive = AppData.defaults.use_fee_inclusive_pricing,
				price = parseFloat(prices.price),
				tax = parseFloat(prices.tax),
				fees = parseFloat(prices.fees);

			if (Number.isNaN(price)) {
				price = 0;
			}

			if (Number.isNaN(tax)) {
				tax = 0;
			}

			if (Number.isNaN(fees)) {
				fees = 0;
			}

			return +(price + (useVat ? tax : 0) + (useVat || useFeeInclusive ? fees : 0)).toFixed(2);
		}

		/**
		 * Generates a consumable pricing object for the customer types
		 * @public
		 * @param {String} packageId - The package ID
		 * @param {Object} ctPriceObj - The raw customer type pricing object
		 * @param {Boolean} [forceQuantity] - If we should default customer types to quantity of 1
		 * @returns {Object} A consumable pricing object with calculations
		 */
		function getCalculatedPricingForCts(packageId, ctPriceObj, forceQuantity) {
			var priceObj = {},
				totalPrice = 0;

			Object.keys(ctPriceObj).forEach(function iterateCtId(ctId) {
				var ctPrice,
					adjPrice,
					item = service._.findCtFromItemsToBeAdded(packageId, ctId);

				// If there is nothing in the items to be added, ignore
				if (!item) {
					// If we are not forcing the quantity, quit
					if (!forceQuantity) {
						return;
					}

					// Set the quantity to one and proceed
					item = { qty: 1 };
				}

				// Grab a more friendly version of the pricing
				adjPrice = service.getDynamicPricingValuesFromAdjustments(ctPriceObj[ctId], ctId, packageId);

				// Add to the price without rounding issues
				ctPrice = service.getDynTotalPrice(adjPrice);
				totalPrice = +(totalPrice + (ctPrice * item.qty)).toFixed(2);

				// Create CT Pricing Object
				priceObj[ctId] = {
					displayPrice: $currency(ctPrice),
					price: ctPrice,
					retail: parseFloat(adjPrice.price),
					qty: item.qty,
					tax: parseFloat(adjPrice.tax)
				};
			});

			// Did we assigned anything to the price object?
			if (validObject(priceObj)) {
				// Assign Total Pricing
				priceObj.displayTotalPrice = $currency(totalPrice);
				priceObj.totalPrice = totalPrice;
			}

			// Return the entire pricing object
			return priceObj;
		}

		/**
		 * Takes an adjustment and returns the dynamic pricing values
		 * @public
		 * @param {Object} adjustment The adjustments from the GetDynamicPricingAdjustments call
		 * @param {Object} customerTypeId The customer type on the package
		 * @param {String} [packageId] The package id
		 * @returns {Object} The dynamic pricing values if exists, false otherwise
		 */
		function getDynamicPricingValuesFromAdjustments(adjustment, customerTypeId, packageId) {
			var pkg = packageId ? Package.getPackageByID(packageId) : Package.packageDetails;
			var customerType = toArray(pkg.CT, true).find(function findCtById(ct) {
				return ct.id === customerTypeId;
			});

			return {
				discountPercentage: adjustment.discount_percentage,
				fees: checkProp('customerType.DYNAMIC_PRICING.fee_total', customerType, 'returnValue'),
				price: adjustment.discounted_retail_price,
				tax: adjustment.discounted_tax_amount
			};
		}

		/**
		 * Takes a customer type and returns the dynamic pricing values
		 * @public
		 * @param {Object} ct - The customer type object
		 * @param {Number} [packageId] Optional package id. If it's passed we'll include the fees
		 * @param {Object} [mapping] - Custom mapping that map to a specified property
		 * @returns {Object|Boolean} The dynamic pricing values if exists, false otherwise
		 */
		function getDynamicPricingValues(ct, packageId, mapping) {
			// Isolate the Dynamic Pricing Node
			var dynamic = checkProp('ct.DYNAMIC_PRICING', ct, 'returnValue') || checkProp('ct.pricing.dynamic', ct, 'returnValue') || checkProp('ct.dynamicPricing', ct, 'returnValue'),
				customerType,
				pkg,
				pricing,
				dynamicPriceValue;

			mapping = mapping || {};

			// Parse the data, otherwise return false
			if (validObject(dynamic)) {
				/**
				 * Dynamic pricing value fallback chain:
				 * 1. ct.dynamic_price - Pre-calculated price (tax-inclusive if applicable)
				 * 2. dynamic[mapping.price] or dynamic.max_discounted_retail_amount - Standard dynamic pricing
				 * 3. dynamic.discountedRetail - Alternative dynamic pricing property
				 * 4. dynamic.per - Fallback for zero-dollar customer types
				 *
				 * Note: The backend sends zero-price customer types with pricing data in the 'per'
				 * property instead of the standard DYNAMIC_PRICING structure. This fallback ensures
				 * zero-dollar rates display as $0.00 instead of undefined/NaN.
				 */
				dynamicPriceValue = ct.dynamic_price ||
					(dynamic[mapping.price || 'max_discounted_retail_amount']) ||
					dynamic.discountedRetail ||
					dynamic.per;

				pricing = {
					discountPercentage: dynamic[mapping.discountPercentage || 'max_discount_percentage'] || dynamic.maxDiscount,
					fees: dynamic[mapping.fees || 'fee_total'] || 0,
					hasAdvance: dynamic[mapping.hasAdvance || 'has_days_in_advance_rule'],
					hasCapacity: dynamic[mapping.hasCapacity || 'has_capacity_remaining_rule'],
					//if ct.dynamic_price is present, we had already calculcated the tax-inclusive price if needed on this
					isTaxInclusive: checkProp('ct.dynamic_price', ct),
					price: dynamicPriceValue,
					tax: dynamic[mapping.tax || 'max_discounted_tax_amount'] || dynamic.discountedTax
				};

				if (packageId) {
					pkg = Package.getPackageByID(packageId);
					customerType = pkg.CT.find(function findCustomerTypeById(pkgCt) {
						return ct.id == pkgCt.id;
					});

					if (!isNumeric(pricing.fees)) {
						pricing.fees = +checkProp('customerType.DYNAMIC_PRICING.fee_total', customerType, 'returnValue') ||
							+(customerType.F || customerType.FEE || customerType.fee_total || 0);
					}
					if (!isNumeric(pricing.tax)) {
						pricing.tax = +checkProp('customerType.DYNAMIC_PRICING.max_discounted_tax_amount', customerType, 'returnValue');
					}
				}
			}

			return pricing;
		}

		/**
		 * Returns the text that should accompany the dynamic price amount
		 * @public
		 * @param {Number} price - The Price
		 * @returns {String} The fromPricing Locale with the pricing inserted
		 */
		function getFromPriceLocale(price) {
			// Returns the fromPricing locale with the @@price swapped with the currency value
			return service
				.getLocale(DynamicCapacityPricingLocales.fromPricing)
				.replace(/@@price\b/g, price ? $filter('currencyFormatter')(price) : '');
		}

		/**
		 * Gets a Dynamic Pricing locale
		 * @param {String} target - The specified target that matches with the DynamicCapacityPricingLocales constant
		 * @returns {String} The locale string, blank string otherwise
		 */
		function getLocale(target) {
			// Does the requested target exist in the contant defintion?
			if (DynamicCapacityPricingLocales[target]) {
				// Is the locale NOT saved in the service?
				if (!service._.locales[target]) {
					// Save to the service
					service._.locales[target] = Language.getLocaleWithSuffixAndFallback(service._.localeSection, target, AppData.merchantId);
				}

				// Return the locale
				return service._.locales[target];
			}

			// Locale does not exist, return a blank string
			return '';
		}

		/**
		 * Returns the data needed for passing values as route params.
		 * @param {Object} customerTypes The customer types
		 * @param {String} packageId The package id for grabbing taxes and fees
		 * @returns {Object} The data model
		 */
		function getRouteParams(customerTypes, packageId) {
			return customerTypes.reduce(function getDynamicPricingForCustomerType(acc, ct) {
				acc[ct.id.toString()] = service.getDynamicPricingValues(ct, packageId);
				return acc;
			}, {});
		}

		/**
		 * Used to fetch live dynamic pricing if this is a date-only package details page.
		 * @param {Object} $stateParams $stateParams
		 * @param {Object[]} itemsToBeAdded An array of items from an alternate module
		 * @returns {Promise} to resolve live data for date-only package details
		 */
		function getPackageDetailsResolve($stateParams, itemsToBeAdded) {
			var packageId = $stateParams.packageId,
				paramsDynamicPricing = angular.copy($stateParams.dynamicPricing),
				pkg = Package.getPackageByID(packageId),
				isDynamic = service.isPackageDynamic(packageId),
				startDate,
				startTime;

			// If it's timed, don't do anything with the pricing or we dont have itemsToBeAdded from alternate modules
			if (!isDynamic || pkg.E.date == '1' || !UtilsValidation.validArray(itemsToBeAdded)) {
				paramsDynamicPricing.isCached = true;

				return $q.resolve(paramsDynamicPricing);
			}

			startDate = itemsToBeAdded[0].CHARACS[0].start_date;
			startTime = itemsToBeAdded[0].CHARACS[0].start_time;

			return service.fetchLivePricing(packageId, startDate, startTime);
		}

		/**
		 * Find out if a returned customer type has dynamic pricing.
		 * @param {Object} ct The customer type
		 * @returns {Boolean} if it has dynamic pricing or not
		 */
		function hasDynamicPricing(ct) {
			// support for both raw data and model data
			var ctHasDynamicPricing = ct.DYNAMIC_PRICING || ct.dynamicPricing;
			return UtilsValidation.isRealObject(ctHasDynamicPricing);
		}

		/**
		 * Checks a collection of Customer Types if it contains Dynamic Pricing
		 * @public
		 * @param {Object|Object[]} ct - A single or collection of Customer Types
		 * @returns {Boolean} if any of the CTs contain Dynamic Pricing
		 */
		function isCustomerTypeDynamic(ct) {
			if (validArray(ct)) {
				return ct.some(service.isCustomerTypeDynamic);
			}

			return service.hasDynamicPricing(ct);
		}

		/**
		 * Checks if the package has dynamic pricing by the package id
		 * @public
		 * @param {Number} packageId The package id
		 * @returns {Boolean} If the package has dynamic pricing or not
		 */
		function isPackageDynamic(packageId) {
			// Grab the package and ensure getPackageByID gets the package id as a string
			var pkg = Package.getPackageByID(getString(packageId));

			// If the package has no customer types, return false
			if (!checkProp('pkg.CT', pkg)) {
				return false;
			}

			// If any customer types has the dynamic pricing node
			return toArray(pkg.CT, true).some(service.hasDynamicPricing);
		}

		/**
		 * Iterates through the package set to determine if any package is using dynamic pricing
		 * @public
		 * @param {Object[]} packages The Set of packages to iterate through
		 * @returns {Boolean} True if dynamic pricing exists, false otherwise
		 */
		function isPackageSetDynamic(packages) {
			return toArray(packages, true).some(function iteratePackages(pkg) {
				return service.isPackageDynamic(pkg.id);
			});
		}

		/**
		 * Verifies that the item's total price just added to cart, matches the cached price
		 * If it doesn't match, we will call node to clear it from cache
		 * @public
		 * @param {Object} addToCartResponse The add to cart response
		 * @param {Object} getCartSummaryResponse The get cart summary response
		 * @returns {undefined}
		 */
		function verifyAddToCart(addToCartResponse, getCartSummaryResponse) {
			var cartItems = toArray(checkProp('data.CART.ITEMS.ITEM', getCartSummaryResponse, 'returnValue'), true);

			// Iterates through the items just added to cart
			toArray(checkProp('data.ITEMS.ITEM', addToCartResponse, 'returnValue'), true).forEach(function iterateAddedItems(addedItem) {
				var preCartItem,
					matchedCartItem = cartItems.find(function iterateCartItems(cartItem) {
						// Tries to find the cart id that was added
						return cartItem.id === addedItem.item_id;
					});

				// Was a cart item not found?
				if (!matchedCartItem) {
					// Exit
					return;
				}

				// Find the item in itemsToBeAdded
				preCartItem = Package.itemsToBeAdded.find(function iterateItemsToBeAdded(item) {
					// Does it have a cachedPrice? Do the package id's match?
					return item.cachedPrice && matchedCartItem.package_id === item.package_id;
				});

				// Did we not find the item from tiemsToBeAdded?
				if (!preCartItem) {
					// Exit
					return;
				}

				// Does the cached price not match the cart item price?
				if (preCartItem.cachedPrice !== UtilsPricing.getPrice(matchedCartItem.retail_price, matchedCartItem.tax_amount, matchedCartItem.fee_amount)) {
					// Clear it from the cache
					service.clearCachedPricing(preCartItem.package_id, preCartItem.CHARACS[0].start_date, preCartItem.CHARACS[0].start_time);
				}
			});
		}

		/**
		 * Iterates against itemsToBeAdded to match with given criteria
		 * @private
		 * @param {String} packageId - The Package ID
		 * @param {Sting} ctId - The Customer Type ID
		 * @returns {Object|undefined} The record from itemsToBeAdded
		 */
		function _findCtFromItemsToBeAdded(packageId, ctId) {
			var items = validArray(Package.alternateModuleItemsToBeAdded) ? Package.alternateModuleItemsToBeAdded : Package.itemsToBeAdded;

			return toArray(items, true).find(function findCt(item) {
				return item.package_id === packageId && item.customer_type === ctId;
			});
		}

		/**
		 * Formats the response and returns the calcuated pricing
		 * @private
		 * @param {String} packageId - The Package ID
		 * @param {Object} data - The Dynamic Pricing Adjusted Price Response
		 * @param {Boolean} [forceQuantity] - If we should force the quantity for the customer types to 1
		 * @returns {Object} The Pricing Object
		 */
		function _formatPricingFromAdjustedPricing(packageId, data, forceQuantity) {
			var formatted = {};

			// Grab the CT information and assign it to our object
			toArray(data.CT, true).forEach(function iterateCtFromData(ct) {
				// Assign using the CT Id as the key
				formatted[ct.id] = ct;
			});

			// Resolve our fetchCachedPricing Promise and returned a parsed response for pricing
			return service.getCalculatedPricingForCts(packageId, formatted, forceQuantity);
		}

		/**
		 * Gets formatted pricing for adjusted pricing for a list of times
		 * @private
		 * @param {String} packageId - The Package ID
		 * @param {Object} data - The Dynamic Pricing Adjusted Price Response
		 * @param {Boolean} [forceQuantity] - If we should force the quantity for the customer types to 1
		 * @returns {Object|Object[]} The Pricing Object(s) for the list of times
		 */
		function _getListformatPricingFromAdjustedPricing(packageId, data, forceQuantity) {
			if (!checkProp('data.T', data)) {
				return _formatPricingFromAdjustedPricing(packageId, data, forceQuantity);
			}

			return toArray(data.T, true).reduce(function reduceTimesArrayCtPricing(acc, t) {
				acc.push({
					pricing: service._.formatPricingFromAdjustedPricing(packageId, t, forceQuantity),
					time: t.time
				});

				return acc;
			}, []);
		}
	}
})();
/**
 * Global currency enumerations. Work in progress. Add currency here as required.
 * 	See CAD, fr-CA, en-CA for setting currency format based on currency code and language code.
 */
angular.module('app').factory('iso4217', function() {
	var data = {
		CAD: [{
			'fr-CA': {
				symbol: ' $',
				decSeparator: ',',
				thousandSeparator: '.',
				symbolPlacement: 'right',
				precision: 2,
				leadingZeros: 1
			}
		}, {
			'en-CA': {
				symbol: '$',
				decSeparator: '.',
				thousandSeparator: ',',
				symbolPlacement: 'left',
				precision: 2,
				leadingZeros: 1
			}
		}],
		USD: {
			symbol: '$',
			decSeparator: '.',
			thousandSeparator: ',',
			symbolPlacement: 'left',
			precision: 2,
			leadingZeros: 1
		},
		MXN: {
			symbol: '$',
			decSeparator: '.',
			thousandSeparator: ',',
			symbolPlacement: 'left',
			precision: 2,
			leadingZeros: 1
		},
		GBP: {
			symbol: '£',
			decSeparator: '.',
			thousandSeparator: ',',
			symbolPlacement: 'left',
			precision: 2,
			leadingZeros: 1,
			startingDay: 1
		},
		EUR: [{
			'nl-NL': {
				symbol: '€ ',
				decSeparator: ',',
				thousandSeparator: '.',
				symbolPlacement: 'left',
				precision: 2,
				leadingZeros: 1,
				startingDay: 1
			}

		}, {
			'fr-FR': {
				symbol: ' €',
				decSeparator: ',',
				thousandSeparator: ' ',
				symbolPlacement: 'right',
				precision: 2,
				leadingZeros: 1,
				startingDay: 1
			}
		}, {
			'de-DE': {
				symbol: ' €',
				decSeparator: ',',
				thousandSeparator: '.',
				symbolPlacement: 'right',
				precision: 2,
				leadingZeros: 1,
				startingDay: 1
			}
		}, {
			default: {
				symbol: '€ ',
				decSeparator: ',',
				thousandSeparator: '.',
				symbolPlacement: 'left',
				precision: 2,
				leadingZeros: 1,
				startingDay: 1
			}
		}]
	}

	return data;
});
/**
 * # Global countries and regions enumerations.
 *
 * For some reason, the word `native` is causing an error on some browsers.
 * The error message shows as up: "Uncaught SyntaxError: Unexpected token native"
 */
angular.module('app')
	.service('countriesJSon', [
		function() {
			var data = {
				countries: [{
					code: "CA",
					countryCode: "+1",
					name: "Canada",
					nativeSpelling: "Canada",
					de: "Kanada",
					es: "Canadá",
					pt: "Canadá",
					"zh-hant": "加拿大",
					"zh-hans": "加拿大"
				}, {
					code: "MX",
					countryCode: "+52",
					name: "Mexico",
					nativeSpelling: "Mexico",
					de: "Mexiko",
					fr: "Mexique",
					es: "México",
					pt: "México",
					"zh-hant": "墨西哥",
					"zh-hans": "墨西哥"
				}, {
					code: "US",
					countryCode: "+1",
					name: "United States",
					nativeSpelling: "United States",
					de: "Vereinigte Staaten",
					fr: "États-Unis",
					nl: "Verenigde Staten",
					es: "Estados Unidos",
					pt: "Estados Unidos",
					"zh-hant": "美國",
					"zh-hans": "美国"
				}, {
					code: "GB",
					countryCode: "+44",
					name: "United Kingdom",
					nativeSpelling: "United Kingdom",
					de: "Vereinigtes Königreich",
					fr: "Royaume-Uni",
					nl: "Verenigd Koninkrijk",
					es: "Reino Unido",
					pt: "Reino Unido",
					"zh-hant": "英國",
					"zh-hans": "英国"
				}, {
					code: "AF",
					countryCode: "+93",
					name: "Afghanistan",
					nativeSpelling: "Afghanestan",
					de: "Afghanistan",
					es: "Afganistán",
					pt: "Afeganistão",
					"zh-hant": "阿富汗",
					"zh-hans": "阿富汗"
				}, {
					code: "AL",
					countryCode: "+355",
					name: "Albania",
					nativeSpelling: "Shqiperia",
					de: "Albanien",
					fr: "Albanie",
					nl: "Albanië",
					es: "Albania",
					pt: "Albânia",
					"zh-hant": "阿爾巴尼亞",
					"zh-hans": "阿尔巴尼亚"
				}, {
					code: "NF",
					countryCode: "+672",
					name: "Norfolk Island",
					nativeSpelling: "Norfolk Island",
					fr: "Norfolk (île)",
					de: "Norfolkinsel",
					es: "Isla Norfolk",
					pt: "Ilha Norfolk",
					"zh-hant": "諾福克島",
					"zh-hans": "诺福克岛"
				}, {
					code: "DZ",
					countryCode: "+213",
					name: "Algeria",
					nativeSpelling: "Al Jaza\"ir",
					de: "Algerien",
					fr: "Algérie",
					nl: "Algerije",
					es: "Argelia",
					pt: "Argélia",
					"zh-hant": "阿爾及利亞",
					"zh-hans": "阿尔及利亚"
				}, {
					code: "MP",
					countryCode: "+1",
					name: "Northern Mariana Islands",
					nativeSpelling: "Commonwealth of The Northern Mariana Islands",
					de: "Nördliche Marianen",
					fr: "Mariannes du Nord (îles)",
					nl: "Noordelijke Marianen",
					es: "Islas Marianas del Norte",
					pt: "Ilhas Marianas do Norte",
					"zh-hant": "北馬利安納群島",
					"zh-hans": "北马里亚纳群岛"
				}, {
					code: "AD",
					countryCode: "+376",
					name: "Andorra",
					nativeSpelling: "Andorra",
					fr: "Andorre",
					de: "Andorra",
					es: "Andorra",
					pt: "Andorra",
					"zh-hant": "安道爾",
					"zh-hans": "安道尔"
				}, {
					code: "AI",
					countryCode: "+1",
					name: "Anguilla",
					nativeSpelling: "Anguilla",
					de: "Anguilla",
					es: "Anguila",
					pt: "Anguilla",
					"zh-hant": "安奎拉",
					"zh-hans": "安圭拉"
				}, {
					code: "AO",
					countryCode: "+244",
					name: "Angola",
					nativeSpelling: "Angola",
					de: "Angola",
					es: "Angola",
					pt: "Angola",
					"zh-hant": "安哥拉",
					"zh-hans": "安哥拉"
				}, {
					code: "AG",
					countryCode: "+1",
					name: "Antigua and Barbuda",
					nativeSpelling: "Antigua and Barbuda",
					de: "Antigua und Barbuda",
					fr: "Antigua-et-Barbuda",
					es: "Antigua y Barbuda",
					pt: "Antígua e Barbuda",
					"zh-hant": "安提瓜和巴布達",
					"zh-hans": "安提瓜和巴布达"
				}, {
					code: "AR",
					countryCode: "+54",
					name: "Argentina",
					nativeSpelling: "Argentina",
					de: "Argentinien",
					fr: "Argentine",
					nl: "Argentinië",
					es: "Argentina",
					pt: "Argentina",
					"zh-hant": "阿根廷",
					"zh-hans": "阿根廷"
				}, {
					code: "AM",
					countryCode: "+374",
					name: "Armenia",
					nativeSpelling: "Hayastan",
					de: "Armenien",
					fr: "Arménie",
					nl: "Armenië",
					es: "Armenia",
					pt: "Armênia",
					"zh-hant": "亞美尼亞",
					"zh-hans": "亚美尼亚"
				}, {
					code: "AU",
					countryCode: "+61",
					name: "Australia",
					nativeSpelling: "Australia",
					de: "Australien",
					fr: "Australie",
					nl: "Australië",
					es: "Australia",
					pt: "Austrália",
					"zh-hant": "澳洲",
					"zh-hans": "澳大利亚"
				}, {
					code: "AW",
					countryCode: "+297",
					name: "Aruba",
					nativeSpelling: "Aruba",
					de: "Aruba",
					es: "Aruba",
					pt: "Aruba",
					"zh-hant": "阿魯巴",
					"zh-hans": "阿鲁巴"
				}, {
					code: "AT",
					countryCode: "+43",
					name: "Austria",
					nativeSpelling: "Oesterreich",
					de: "Österreich",
					nl: "Oostenrijk",
					es: "Austria",
					pt: "Áustria",
					"zh-hant": "奧地利",
					"zh-hans": "奥地利"
				}, {
					code: "AZ",
					countryCode: "+994",
					name: "Azerbaijan",
					nativeSpelling: "Azarbaycan Respublikasi",
					de: "Aserbaidschan",
					fr: "Azerbaïdjan",
					nl: "Azerbeidzjan",
					es: "Azerbaiyán",
					pt: "Azerbaijão",
					"zh-hant": "阿塞拜疆",
					"zh-hans": "阿塞拜疆"
				}, {
					code: "BS",
					countryCode: "+1",
					name: "Bahamas",
					nativeSpelling: "The Bahamas",
					de: "Bahamas",
					es: "Bahamas",
					pt: "Bahamas",
					"zh-hant": "巴哈馬",
					"zh-hans": "巴哈马"
				}, {
					code: "BH",
					countryCode: "+973",
					name: "Bahrain",
					nativeSpelling: "Al Bahrayn",
					fr: "Bahreïn",
					nl: "Bahrein",
					de: "Bahrain",
					es: "Bahréin",
					pt: "Bahrain",
					"zh-hant": "巴林",
					"zh-hans": "巴林"
				}, {
					code: "BD",
					countryCode: "+880",
					name: "Bangladesh",
					nativeSpelling: "Bangladesh",
					de: "Bangladesch",
					es: "Bangladesh",
					pt: "Bangladesh",
					"zh-hant": "孟加拉",
					"zh-hans": "孟加拉国"
				}, {
					code: "BB",
					countryCode: "+1",
					name: "Barbados",
					nativeSpelling: "Barbados",
					fr: "Barbade",
					de: "Barbados",
					es: "Barbados",
					pt: "Barbados",
					"zh-hant": "巴巴多斯",
					"zh-hans": "巴巴多斯"
				}, {
					code: "BY",
					countryCode: "+375",
					name: "Belarus",
					nativeSpelling: "Byelarus",
					de: "Weißrussland",
					fr: "Biélorussie",
					es: "Bielorrusia",
					pt: "Belarus",
					"zh-hant": "白俄羅斯",
					"zh-hans": "白俄罗斯"
				}, {
					code: "BE",
					countryCode: "+32",
					name: "Belgium",
					nativeSpelling: "Belgique (French) or Belgie (Flemish)",
					fr: "Belgique",
					nl: "Belgie",
					de: "Belgium",
					nl: "België",
					es: "Bélgica",
					pt: "Bélgica",
					"zh-hant": "比利時",
					"zh-hans": "比利时"
				}, {
					code: "BZ",
					countryCode: "+501",
					name: "Belize",
					nativeSpelling: "Belice",
					de: "Belize",
					es: "Belice",
					pt: "Belize",
					"zh-hant": "伯利茲",
					"zh-hans": "伯利兹"
				}, {
					code: "BJ",
					countryCode: "+229",
					name: "Benin",
					nativeSpelling: "Benin",
					fr: "Bénin",
					de: "Benin",
					es: "Benín",
					pt: "Benin",
					"zh-hant": "貝寧",
					"zh-hans": "贝宁"
				}, {
					code: "BM",
					countryCode: "+1",
					name: "Bermuda",
					nativeSpelling: "Bermuda",
					fr: "Bermudes",
					de: "Bermuda",
					es: "Bermudas",
					pt: "Bermudas",
					"zh-hant": "百慕達",
					"zh-hans": "百慕大"
				}, {
					code: "BT",
					countryCode: "+975",
					name: "Bhutan",
					nativeSpelling: "Drukyul",
					fr: "Bhoutan",
					de: "Bhutan",
					es: "Bután",
					pt: "Butão",
					"zh-hant": "不丹",
					"zh-hans": "不丹"
				}, {
					code: "BO",
					countryCode: "+591",
					name: "Bolivia",
					nativeSpelling: "Bolivia, Plurinational State of",
					de: "Bolivien",
					fr: "Bolivie",
					es: "Bolivia",
					pt: "Bolívia",
					"zh-hant": "玻利維亞",
					"zh-hans": "玻利维亚"
				}, {
					code: "BQ",
					countryCode: "+599",
					name: "Bonaire, Sint Eustatius, and Saba",
					de: "Bonaire",
					es: "Caribe neerlandés",
					pt: "BQ",
					"zh-hant": "荷蘭加勒比區",
					"zh-hans": "荷属加勒比区"
				}, {
					code: "BA",
					countryCode: "+387",
					name: "Bosnia and Herzegovina",
					nativeSpelling: "Bosna i Hercegovina",
					de: "Bosnien und Herzegowina",
					fr: "Bosnie-Herzégovine",
					nl: "Bosnië en Herzegovina",
					es: "Bosnia-Herzegovina",
					pt: "Bósnia-Herzegovina",
					"zh-hant": "波斯尼亞和黑塞哥維那",
					"zh-hans": "波斯尼亚和黑塞哥维那"
				}, {
					code: "BW",
					countryCode: "+267",
					name: "Botswana",
					nativeSpelling: "Botswana",
					de: "Botsuana",
					es: "Botsuana",
					pt: "Botsuana",
					"zh-hant": "博茨瓦納",
					"zh-hans": "博茨瓦纳"
				}, {
					code: "BV",
					countryCode: "+55",
					name: "Bouvet Island",
					nativeSpelling: "Bouvet Island",
					de: "Bouvetinsel",
					fr: "Bouvet (île)",
					nl: "Bouveteiland",
					es: "Isla Bouvet",
					pt: "Ilha Bouvet",
					"zh-hant": "鮑威特島",
					"zh-hans": "布韦岛"
				}, {
					code: "BR",
					countryCode: "+55",
					name: "Brazil",
					nativeSpelling: "Brasil",
					de: "Brasilien",
					fr: "Brésil",
					nl: "Brazilië",
					es: "Brasil",
					pt: "Brasil",
					"zh-hant": "巴西",
					"zh-hans": "巴西"
				}, {
					code: "IO",
					countryCode: "+246",
					name: "British Indian Ocean Territory",
					nativeSpelling: "British Indian Ocean Territory",
					de: "Britisches Territorium im Indischen Ozean",
					fr: "Territoires britanniques de l'Océan Indien",
					nl: "Brits Indische Oceaanterritorium",
					es: "Territorio Británico del Océano Índico",
					pt: "Território Britânico do Oceano Índico",
					"zh-hant": "英屬印度洋領地",
					"zh-hans": "英属印度洋领地"
				}, {
					code: "VG",
					countryCode: "+1",
					name: "British Virgin Islands",
					nativeSpelling: "British Virgin Islands",
					de: "Jungferninseln (Britisch)",
					fr: "Vierges britanniques (îles)",
					nl: "Britse Maagdeneilanden",
					es: "Islas Vírgenes Británicas",
					pt: "Ilhas Virgens Britânicas",
					"zh-hant": "英屬維爾京群島",
					"zh-hans": "英属维尔京群岛"
				}, {
					code: "VI",
					countryCode: "+1",
					name: "U.S. Virgin Islands",
					nativeSpelling: "United States Virgin Islands",
					de: "Jungferninseln (Amerikanisch)",
					nl: "Amerikaanse Maagdeneilanden",
					es: "Islas Vírgenes de los Estados Unidos",
					pt: "Ilhas Virgens dos EUA",
					"zh-hant": "美屬維爾京群島",
					"zh-hans": "美属维尔京群岛"
				}, {
					code: "WF",
					countryCode: "+681",
					name: "Wallis and Futuna",
					nativeSpelling: "Collectivity of the Wallis and Futuna Islands",
					de: "Wallis und Futuna",
					fr: "Wallis-et-Futuna (îles)",
					nl: "Wallis en Futuna",
					es: "Wallis y Futuna",
					pt: "Wallis e Futuna",
					"zh-hant": "瓦利斯群島和富圖那群島",
					"zh-hans": "瓦利斯和富图纳"
				}, {
					code: "BN",
					countryCode: "+673",
					name: "Brunei",
					nativeSpelling: "Brunei",
					de: "Brunei Darussalam",
					nl: "Brunei Darussalam",
					es: "Brunéi",
					pt: "Brunei",
					"zh-hant": "汶萊",
					"zh-hans": "文莱"
				}, {
					code: "BG",
					countryCode: "+359",
					name: "Bulgaria",
					nativeSpelling: "Republika Bulgariya",
					de: "Bulgarien",
					fr: "Bulgarie",
					nl: "Bulgarije",
					es: "Bulgaria",
					pt: "Bulgária",
					"zh-hant": "保加利亞",
					"zh-hans": "保加利亚"
				}, {
					code: "BF",
					countryCode: "+226",
					name: "Burkina Faso",
					nativeSpelling: "Burkina Faso",
					fr: "Burkina Faso",
					de: "Burkina Faso",
					es: "Burkina Faso",
					pt: "Burquina Faso",
					"zh-hant": "布基納法索",
					"zh-hans": "布基纳法索"
				}, {
					code: "BI",
					countryCode: "+257",
					name: "Burundi",
					nativeSpelling: "Burundi",
					de: "Burundi",
					es: "Burundi",
					pt: "Burundi",
					"zh-hant": "布隆迪",
					"zh-hans": "布隆迪"
				}, {
					code: "KH",
					countryCode: "+855",
					name: "Cambodia",
					nativeSpelling: "Kampuchea",
					de: "Kambodscha",
					fr: "Cambodge",
					nl: "Cambodja",
					es: "Camboya",
					pt: "Camboja",
					"zh-hant": "柬埔寨",
					"zh-hans": "柬埔寨"
				}, {
					code: "CM",
					countryCode: "+237",
					name: "Cameroon",
					nativeSpelling: "Cameroon or Cameroun (French)",
					fr: "Cameroun",
					de: "Kamerun",
					nl: "Kameroen",
					es: "Camerún",
					pt: "República dos Camarões",
					"zh-hant": "喀麥隆",
					"zh-hans": "喀麦隆"
				}, {
					code: "CV",
					countryCode: "+238",
					name: "Cape Verde",
					nativeSpelling: "Cabo Verde",
					de: "Kap Verde",
					fr: "Cap-Vert",
					nl: "Kaapverdië",
					es: "Cabo Verde",
					pt: "Cabo Verde",
					"zh-hant": "佛得角",
					"zh-hans": "佛得角"
				}, {
					code: "KY",
					countryCode: "+1",
					name: "Cayman Islands",
					nativeSpelling: "Cayman Islands",
					de: "Kaimaninseln",
					fr: "Caïmans (îles)",
					nl: "Kaaimaneilanden",
					es: "Islas Caimán",
					pt: "Ilhas Caiman",
					"zh-hant": "開曼群島",
					"zh-hans": "开曼群岛"
				}, {
					code: "CF",
					countryCode: "+236",
					name: "Central African Republic",
					nativeSpelling: "Republique Centrafricaine",
					de: "Zentralafrikanische Republik",
					fr: "République centrafricaine",
					nl: "Centraal-Afrikaanse Republiek",
					es: "República Centroafricana",
					pt: "República Centro-Africana",
					"zh-hant": "中非共和國",
					"zh-hans": "中非共和国"
				}, {
					code: "TD",
					countryCode: "+235",
					name: "Chad",
					nativeSpelling: "Tchad",
					de: "Tschad",
					fr: "Tchad",
					nl: "Tsjaad",
					es: "Chad",
					pt: "Chade",
					"zh-hant": "乍得",
					"zh-hans": "乍得"
				}, {
					code: "CL",
					countryCode: "+56",
					name: "Chile",
					nativeSpelling: "Chile",
					fr: "Chili",
					nl: "Chili",
					de: "Chile",
					es: "Chile",
					pt: "Chile",
					"zh-hant": "智利",
					"zh-hans": "智利"
				}, {
					code: "CN",
					countryCode: "+86",
					name: "China",
					nativeSpelling: "Zhong Guo",
					fr: "Chine",
					de: "China",
					es: "China",
					pt: "China",
					"zh-hant": "中國",
					"zh-hans": "中国"
				}, {
					code: "CX",
					countryCode: "+61",
					name: "Christmas Island",
					nativeSpelling: "Territory of Christmas Island",
					de: "Weihnachtsinsel",
					fr: "Christmas (île)",
					nl: "Christmaseiland",
					es: "Isla Christmas",
					pt: "Ilhas Natal",
					"zh-hant": "聖誕島",
					"zh-hans": "圣诞岛"
				}, {
					code: "CC",
					countryCode: "+891",
					name: "Cocos (Keeling) Islands",
					nativeSpelling: "Territory of Cocos (Keeling) Islands",
					de: "Kokosinseln",
					fr: "Cocos-Keeling (îles)",
					nl: "Cocoseilanden (Keelingeilanden)",
					es: "Islas Cocos",
					pt: "Ilhas Coco",
					"zh-hant": "可可斯群島",
					"zh-hans": "科科斯（基林）群岛"
				}, {
					code: "CO",
					countryCode: "+57",
					name: "Colombia",
					nativeSpelling: "Colombia",
					de: "Kolumbien",
					fr: "Colombie",
					es: "Colombia",
					pt: "Colômbia",
					"zh-hant": "哥倫比亞",
					"zh-hans": "哥伦比亚"
				}, {
					code: "KM",
					countryCode: "+269",
					name: "Comoros",
					nativeSpelling: "Comores",
					de: "Komoren",
					fr: "Comores",
					nl: "Comoren",
					es: "Comoras",
					pt: "Comores",
					"zh-hant": "科摩羅",
					"zh-hans": "科摩罗"
				}, {
					code: "CG",
					countryCode: "+242",
					name: "Congo, Republic of the",
					nativeSpelling: "Republique du Congo",
					de: "Kongo",
					es: "Congo - Brazzaville",
					pt: "Congo - Brazzaville",
					"zh-hant": "剛果（布拉薩）",
					"zh-hans": "刚果（布）"
				}, {
					code: "CD",
					countryCode: "+243",
					name: "Congo, Democratic Republic of the",
					nativeSpelling: "Republique Democratique du Congo",
					de: "Kongo, Demokratische Republik",
					fr: "Congo, République démocratique du",
					nl: "Congo, Democratische Republiek",
					es: "República Democrática del Congo",
					pt: "Congo-Kinshasa",
					"zh-hant": "剛果（金夏沙）",
					"zh-hans": "刚果（金）"
				}, {
					code: "CK",
					countryCode: "+682",
					name: "Cook Islands",
					nativeSpelling: "Cook Islands",
					de: "Cookinseln",
					fr: "Cook (îles)",
					nl: "Cookeilanden",
					es: "Islas Cook",
					pt: "Ilhas Cook",
					"zh-hant": "庫克群島",
					"zh-hans": "库克群岛"
				}, {
					code: "CR",
					countryCode: "+506",
					name: "Costa Rica",
					nativeSpelling: "Costa Rica",
					de: "Costa Rica",
					es: "Costa Rica",
					pt: "Costa Rica",
					"zh-hant": "哥斯達黎加",
					"zh-hans": "哥斯达黎加"
				}, {
					code: "CI",
					countryCode: "+225",
					name: "Cote d'Ivoire (Ivory Coast)",
					nativeSpelling: "Republic of Cote d'Ivoire",
					de: "Côte d'Ivoire",
					nl: "Ivoorkust",
					es: "Costa de Marfil",
					pt: "Costa do Marfim",
					"zh-hant": "科特迪瓦",
					"zh-hans": "科特迪瓦"
				}, {
					code: "HR",
					countryCode: "+385",
					name: "Croatia",
					nativeSpelling: "Hrvatska",
					de: "Kroatien",
					fr: "Croatie",
					nl: "Kroatië",
					es: "Croacia",
					pt: "Croácia",
					"zh-hant": "克羅地亞",
					"zh-hans": "克罗地亚"
				}, {
					code: "CU",
					countryCode: "+53",
					name: "Cuba",
					nativeSpelling: "Cuba",
					de: "Kuba",
					es: "Cuba",
					pt: "Cuba",
					"zh-hant": "古巴",
					"zh-hans": "古巴"
				}, {
					code: "CY",
					countryCode: "+357",
					name: "Cyprus",
					nativeSpelling: "Kypros (Greek) or Kibris (Turkish)",
					gr: "Kypros",
					tr: "Kibris",
					de: "Zypern",
					fr: "Chypre",
					es: "Chipre",
					pt: "Chipre",
					"zh-hant": "塞浦路斯",
					"zh-hans": "塞浦路斯"
				}, {
					code: "CZ",
					countryCode: "+420",
					name: "Czech Republic",
					nativeSpelling: "Ceska Republika",
					de: "Tschechische Republik",
					fr: "République tchèque",
					nl: "Tsjechië",
					es: "República Checa",
					pt: "República Tcheca",
					"zh-hant": "捷克",
					"zh-hans": "捷克"
				}, {
					code: "DK",
					countryCode: "+45",
					name: "Denmark",
					nativeSpelling: "Danmark",
					de: "Dänemark",
					fr: "Danemark",
					nl: "Denemarken",
					es: "Dinamarca",
					pt: "Dinamarca",
					"zh-hant": "丹麥",
					"zh-hans": "丹麦"
				}, {
					code: "DJ",
					countryCode: "+253",
					name: "Djibouti",
					nativeSpelling: "Djibouti",
					de: "Dschibuti",
					es: "Yibuti",
					pt: "Djibuti",
					"zh-hant": "吉布提",
					"zh-hans": "吉布提"
				}, {
					code: "DM",
					countryCode: "+1",
					name: "Dominica",
					nativeSpelling: "Dominica",
					nl: "Dominica",
					de: "Dominica",
					es: "Dominica",
					pt: "Dominica",
					"zh-hant": "多米尼克",
					"zh-hans": "多米尼克"
				}, {
					code: "DO",
					countryCode: "+1",
					name: "Dominican Republic",
					nativeSpelling: "Republica Dominicana",
					de: "Dominikanische Republik",
					fr: "République dominicaine",
					nl: "Dominicaanse Republiek",
					es: "República Dominicana",
					pt: "República Dominicana",
					"zh-hant": "多明尼加共和國",
					"zh-hans": "多米尼加共和国"
				}, {
					code: "TL",
					countryCode: "+670",
					name: "Timor-Leste",
					nativeSpelling: "Democratic Republic of Timor-Leste",
					de: "Timor-Leste",
					fr: "Timor-Oriental",
					nl: "Oost-Timor",
					es: "Timor Oriental",
					pt: "Timor-Leste",
					"zh-hant": "東帝汶",
					"zh-hans": "东帝汶"
				}, {
					code: "EC",
					countryCode: "+593",
					name: "Ecuador",
					nativeSpelling: "Ecuador",
					fr: "Équateur",
					de: "Ecuador",
					es: "Ecuador",
					pt: "Equador",
					"zh-hant": "厄瓜多爾",
					"zh-hans": "厄瓜多尔"
				}, {
					code: "EG",
					countryCode: "+20",
					name: "Egypt",
					nativeSpelling: "Misr",
					de: "Ägypten",
					fr: "Égypte",
					nl: "Egypte",
					es: "Egipto",
					pt: "Egito",
					"zh-hant": "埃及",
					"zh-hans": "埃及"
				}, {
					code: "SV",
					countryCode: "+503",
					name: "El Salvador",
					nativeSpelling: "El Salvador",
					de: "El Salvador",
					es: "El Salvador",
					pt: "El Salvador",
					"zh-hant": "薩爾瓦多",
					"zh-hans": "萨尔瓦多"
				}, {
					code: "GQ",
					countryCode: "+240",
					name: "Equatorial Guinea",
					nativeSpelling: "Guinea Ecuatorial",
					de: "Äquatorialguinea",
					fr: "Guinée équatoriale",
					nl: "Equatoriaal-Guinea",
					es: "Guinea Ecuatorial",
					pt: "Guiné Equatorial",
					"zh-hant": "赤道幾內亞",
					"zh-hans": "赤道几内亚"
				}, {
					code: "ER",
					countryCode: "+291",
					name: "Eritrea",
					nativeSpelling: "Ertra",
					fr: "Érythrée",
					de: "Eritrea",
					es: "Eritrea",
					pt: "Eritreia",
					"zh-hant": "厄立特里亞",
					"zh-hans": "厄立特里亚"
				}, {
					code: "EE",
					countryCode: "+372",
					name: "Estonia",
					nativeSpelling: "Eesti",
					de: "Estland",
					fr: "Estonie",
					nl: "Estland",
					es: "Estonia",
					pt: "Estônia",
					"zh-hant": "愛沙尼亞",
					"zh-hans": "爱沙尼亚"
				}, {
					code: "ET",
					countryCode: "+251",
					name: "Ethiopia",
					nativeSpelling: "YeItyop\"iya",
					de: "Äthiopien",
					fr: "Éthiopie",
					nl: "Ethiopië",
					es: "Etiopía",
					pt: "Etiópia",
					"zh-hant": "埃塞俄比亞",
					"zh-hans": "埃塞俄比亚"
				}, {
					code: "FJ",
					countryCode: "+679",
					name: "Fiji",
					nativeSpelling: "Fiji",
					de: "Fidschi",
					fr: "Fidji",
					es: "Fiyi",
					pt: "Fiji",
					"zh-hant": "斐濟",
					"zh-hans": "斐济"
				}, {
					code: "FK",
					countryCode: "+500",
					name: "Falkland Islands",
					nativeSpelling: "Falkland Islands",
					de: "Falklandinseln (Malwinen)",
					fr: "Falkland (îles Falkland ou Malouines)",
					nl: "Falklandeilanden (Malvinas)",
					es: "Islas Malvinas",
					pt: "Ilhas Malvinas",
					"zh-hant": "福克蘭群島",
					"zh-hans": "福克兰群岛"
				}, {
					code: "FO",
					countryCode: "+298",
					name: "Faroe Islands",
					nativeSpelling: "Faroe Islands",
					de: "Färöer",
					fr: "Féroé (îles)",
					nl: "Faeröer",
					es: "Islas Feroe",
					pt: "Ilhas Faroe",
					"zh-hant": "法羅群島",
					"zh-hans": "法罗群岛"
				}, {
					code: "FI",
					countryCode: "+358",
					name: "Finland",
					nativeSpelling: "Suomi",
					de: "Finnland",
					fr: "Finlande",
					es: "Finlandia",
					pt: "Finlândia",
					"zh-hant": "芬蘭",
					"zh-hans": "芬兰"
				}, {
					code: "FR",
					countryCode: "+33",
					name: "France",
					nativeSpelling: "France or Republique Francaise",
					de: "Frankreich",
					nl: "Frankrijk",
					es: "Francia",
					pt: "França",
					"zh-hant": "法國",
					"zh-hans": "法国"
				}, {
					code: "GF",
					countryCode: "+594",
					name: "French Guiana",
					nativeSpelling: "Overseas Region of Guiana",
					de: "Französisch-Guayana",
					fr: "Guyane française",
					nl: "Frans-Guyana",
					es: "Guayana Francesa",
					pt: "Guiana Francesa",
					"zh-hant": "法屬圭亞那",
					"zh-hans": "法属圭亚那"
				}, {
					code: "PF",
					countryCode: "+689",
					name: "French Polynesia",
					nativeSpelling: "Overseas Country of French Polynesia",
					de: "Französisch-Polynesien",
					fr: "Polynésie française",
					nl: "Frans-Polynesië",
					es: "Polinesia Francesa",
					pt: "Polinésia Francesa",
					"zh-hant": "法屬波利尼西亞",
					"zh-hans": "法属波利尼西亚"
				}, {
					code: "TF",
					countryCode: "+262",
					name: "French Southern Territories",
					nativeSpelling: "Territory of the French Southern and Antarctic Lands",
					de: "Französische Südgebiete",
					fr: "Terres Australes françaises",
					nl: "Franse Zuidelijke Gebieden",
					es: "Territorios Australes Franceses",
					pt: "Territórios Franceses do Sul",
					"zh-hant": "法屬南部領地",
					"zh-hans": "法属南部领地"
				}, {
					code: "GA",
					countryCode: "+241",
					name: "Gabon",
					nativeSpelling: "Gabon",
					de: "Gabun",
					es: "Gabón",
					pt: "Gabão",
					"zh-hant": "加蓬",
					"zh-hans": "加蓬"
				}, {
					code: "GM",
					countryCode: "+220",
					name: "Gambia",
					nativeSpelling: "Gambia",
					fr: "Gambie",
					de: "Gambia",
					es: "Gambia",
					pt: "Gâmbia",
					"zh-hant": "岡比亞",
					"zh-hans": "冈比亚"
				}, {
					code: "GE",
					countryCode: "+995",
					name: "Georgia",
					nativeSpelling: "Sak\"art\"velo",
					de: "Georgien",
					fr: "Géorgie",
					nl: "Georgië",
					es: "Georgia",
					pt: "Geórgia",
					"zh-hant": "格魯吉亞",
					"zh-hans": "格鲁吉亚"
				}, {
					code: "GS",
					countryCode: "+500",
					name: "South Georgia and the South Sandwich Islands",
					nativeSpelling: "SGSSI",
					de: "Südgeorgien, Südliche Sandwichinseln",
					fr: "Géorgie du Sud, Îles Sandwich",
					nl: "Zuid-Georgia, en de Zuidelijke Sandwicheilanden",
					es: "Islas Georgia del Sur y Sandwich del Sur",
					pt: "Geórgia do Sul e Ilhas Sandwich do Sul",
					"zh-hant": "南佐治亞島與南桑威奇群島",
					"zh-hans": "南乔治亚和南桑威奇群岛"
				}, {
					code: "DE",
					countryCode: "+49",
					name: "Germany",
					nativeSpelling: "Deutschland",
					de: "Deutschland",
					fr: "Allemagne",
					nl: "Duitsland",
					es: "Alemania",
					pt: "Alemanha",
					"zh-hant": "德國",
					"zh-hans": "德国"
				}, {
					code: "GH",
					countryCode: "+233",
					name: "Ghana",
					nativeSpelling: "Ghana",
					de: "Ghana",
					es: "Ghana",
					pt: "Gana",
					"zh-hant": "加納",
					"zh-hans": "加纳"
				}, {
					code: "GR",
					countryCode: "+30",
					name: "Greece",
					nativeSpelling: "Ellas",
					de: "Griechenland",
					fr: "Grèce",
					nl: "Griekenland",
					es: "Grecia",
					pt: "Grécia",
					"zh-hant": "希臘",
					"zh-hans": "希腊"
				}, {
					code: "GL",
					countryCode: "+299",
					name: "Greenland",
					nativeSpelling: "Greenland",
					de: "Grönland",
					fr: "Groenland",
					nl: "Groenland",
					es: "Groenlandia",
					pt: "Groênlandia",
					"zh-hant": "格陵蘭",
					"zh-hans": "格陵兰"
				}, {
					code: "GD",
					countryCode: "+1",
					name: "Grenada",
					nativeSpelling: "Grenada",
					fr: "Grenade",
					de: "Grenada",
					es: "Granada",
					pt: "Granada",
					"zh-hant": "格林納達",
					"zh-hans": "格林纳达"
				}, {
					code: "GT",
					countryCode: "+502",
					name: "Guatemala",
					nativeSpelling: "Guatemala",
					de: "Guatemala",
					es: "Guatemala",
					pt: "Guatemala",
					"zh-hant": "危地馬拉",
					"zh-hans": "危地马拉"
				}, {
					code: "GI",
					countryCode: "+350",
					name: "Gibraltar",
					nativeSpelling: "Gibraltar",
					de: "Kolonie Gibraltar",
					es: "Gibraltar",
					pt: "Gibraltar",
					"zh-hant": "直布羅陀",
					"zh-hans": "直布罗陀"
				}, {
					code: "GP",
					countryCode: "+590",
					name: "Guadeloupe",
					nativeSpelling: "Overseas Region of Guadeloupe",
					de: "Guadeloupe",
					es: "Guadalupe",
					pt: "Guadalupe",
					"zh-hant": "瓜地洛普",
					"zh-hans": "瓜德罗普"
				}, {
					code: "GN",
					countryCode: "+224",
					name: "Guinea",
					nativeSpelling: "Guinee",
					fr: "Guinée",
					nl: "Guinee",
					de: "Guinea",
					es: "Guinea",
					pt: "Guiné",
					"zh-hant": "幾內亞",
					"zh-hans": "几内亚"
				}, {
					code: "GW",
					countryCode: "+245",
					name: "Guinea-Bissau",
					nativeSpelling: "Guine-Bissau",
					fr: "Guinée-Bissau",
					de: "Guinea-Bissau",
					es: "Guinea-Bissau",
					pt: "Guiné Bissau",
					"zh-hant": "幾內亞比紹",
					"zh-hans": "几内亚比绍"
				}, {
					code: "GY",
					countryCode: "+592",
					name: "Guyana",
					nativeSpelling: "Guyana",
					de: "Guyana",
					es: "Guyana",
					pt: "Guiana",
					"zh-hant": "圭亞那",
					"zh-hans": "圭亚那"
				}, {
					code: "HT",
					countryCode: "+509",
					name: "Haiti",
					nativeSpelling: "Haiti",
					de: "Haiti",
					es: "Haití",
					pt: "Haiti",
					"zh-hant": "海地",
					"zh-hans": "海地"
				}, {
					code: "HN",
					countryCode: "+504",
					name: "Honduras",
					nativeSpelling: "Honduras",
					de: "Honduras",
					es: "Honduras",
					pt: "Honduras",
					"zh-hant": "洪都拉斯",
					"zh-hans": "洪都拉斯"
				}, {
					code: "HM",
					countryCode: "+0",
					name: "Heard Island and McDonald Islands",
					nativeSpelling: "Territory of Heard Island and McDonald Islands",
					de: "Heard und McDonaldinseln",
					fr: "Heard et Mc Donald (îles)",
					nl: "Heard en McDonaldeilanden",
					es: "Islas Heard y McDonald",
					pt: "Ilha Heard e Ilhas McDonald",
					"zh-hant": "赫德島及麥唐納群島",
					"zh-hans": "赫德岛和麦克唐纳群岛"
				}, {
					code: "HK",
					countryCode: "+852",
					name: "Hong Kong SAR",
					nativeSpelling: "Hong Kong Special Administrative Region",
					nl: "Hongkong",
					de: "Hong Kong SAR",
					es: "Región Administrativa Especial de Hong Kong de la República Popular China",
					pt: "Hong Kong, RAE da China",
					"zh-hant": "中國香港特別行政區",
					"zh-hans": "中国香港特别行政区"
				}, {
					code: "HU",
					countryCode: "+36",
					name: "Hungary",
					nativeSpelling: "Magyarorszag",
					de: "Ungarn",
					fr: "Hongrie",
					nl: "Hongarije",
					es: "Hungría",
					pt: "Hungria",
					"zh-hant": "匈牙利",
					"zh-hans": "匈牙利"
				}, {
					code: "IS",
					countryCode: "+354",
					name: "Iceland",
					nativeSpelling: "Island",
					de: "Island",
					fr: "Islande",
					nl: "IJsland",
					es: "Islandia",
					pt: "Islândia",
					"zh-hant": "冰島",
					"zh-hans": "冰岛"
				}, {
					code: "IN",
					countryCode: "+91",
					name: "India",
					nativeSpelling: "India, Bharat",
					de: "Indien",
					fr: "Inde",
					es: "India",
					pt: "Índia",
					"zh-hant": "印度",
					"zh-hans": "印度"
				}, {
					code: "ID",
					countryCode: "+62",
					name: "Indonesia",
					nativeSpelling: "Indonesia",
					de: "Indonesien",
					fr: "Indonésie",
					nl: "Indonesië",
					es: "Indonesia",
					pt: "Indonésia",
					"zh-hant": "印尼",
					"zh-hans": "印度尼西亚"
				}, {
					code: "IR",
					countryCode: "+98",
					name: "Iran",
					nativeSpelling: "Iran, Persia",
					de: "Iran (Islamische Republik)",
					fr: "Iran (République islamique de)",
					nl: "Iran (Islamitische Republiek)",
					es: "Irán",
					pt: "Irã",
					"zh-hant": "伊朗",
					"zh-hans": "伊朗"
				}, {
					code: "IQ",
					countryCode: "+964",
					name: "Iraq",
					nativeSpelling: "Al Iraq",
					de: "Irak",
					nl: "Irak",
					es: "Iraq",
					pt: "Iraque",
					"zh-hant": "伊拉克",
					"zh-hans": "伊拉克"
				}, {
					code: "IE",
					countryCode: "+353",
					name: "Ireland",
					nativeSpelling: "Ireland or Eire",
					de: "Irland",
					fr: "Irlande",
					nl: "Ierland",
					es: "Irlanda",
					pt: "Irlanda",
					"zh-hant": "愛爾蘭",
					"zh-hans": "爱尔兰"
				}, {
					code: "IL",
					countryCode: "+972",
					name: "Israel",
					nativeSpelling: "Yisra\"el",
					fr: "Israël",
					nl: "Israël",
					de: "Israel",
					es: "Israel",
					pt: "Israel",
					"zh-hant": "以色列",
					"zh-hans": "以色列"
				}, {
					code: "UM",
					countryCode: "+1",
					name: "United States Minor Outlying Islands",
					nativeSpelling: "United States Minor Outlying Islands",
					de: "Kleinere Amerikanische Überseeinseln ",
					nl: "Kleine afgelegen eilanden van de Verenigde Staten",
					es: "Islas menores alejadas de los Estados Unidos",
					pt: "Ilhas Distantes dos EUA",
					"zh-hant": "美國本土外小島嶼",
					"zh-hans": "美国本土外小岛屿"
				}, {
					code: "IT",
					countryCode: "+39",
					name: "Italy",
					nativeSpelling: "Italia",
					de: "Italien",
					fr: "Italie",
					nl: "Italië",
					es: "Italia",
					pt: "Itália",
					"zh-hant": "意大利",
					"zh-hans": "意大利"
				}, {
					code: "JM",
					countryCode: "+1",
					name: "Jamaica",
					nativeSpelling: "Jamaica",
					de: "Jamaika",
					fr: "Jamaïque",
					es: "Jamaica",
					pt: "Jamaica",
					"zh-hant": "牙買加",
					"zh-hans": "牙买加"
				}, {
					code: "JP",
					countryCode: "+81",
					name: "Japan",
					nativeSpelling: "Nippon",
					fr: "Japon",
					de: "Japan",
					es: "Japón",
					pt: "Japão",
					"zh-hant": "日本",
					"zh-hans": "日本"
				}, {
					code: "JO",
					countryCode: "+962",
					name: "Jordan",
					nativeSpelling: "Al Urdun",
					de: "Jordanien",
					fr: "Jordanie",
					nl: "Jordanië",
					es: "Jordania",
					pt: "Jordânia",
					"zh-hant": "約旦",
					"zh-hans": "约旦"
				}, {
					code: "KZ",
					countryCode: "+7",
					name: "Kazakhstan",
					nativeSpelling: "Qazaqstan",
					de: "Kasachstan",
					nl: "Kazachstan",
					es: "Kazajistán",
					pt: "Casaquistão",
					"zh-hant": "哈薩克",
					"zh-hans": "哈萨克斯坦"
				}, {
					code: "KE",
					countryCode: "+254",
					name: "Kenya",
					nativeSpelling: "Kenya",
					de: "Kenia",
					es: "Kenia",
					pt: "Quênia",
					"zh-hant": "肯雅",
					"zh-hans": "肯尼亚"
				}, {
					code: "KI",
					countryCode: "+686",
					name: "Kiribati",
					nativeSpelling: "Kiribati",
					de: "Kiribati",
					es: "Kiribati",
					pt: "Quiribati",
					"zh-hant": "吉里巴斯",
					"zh-hans": "基里巴斯"
				}, {
					code: "KP",
					countryCode: "+850",
					name: "North Korea",
					nativeSpelling: "Choson or Choson-minjujuui-inmin-konghwaguk",
					de: "Korea, Demokratische Volksrepublik",
					fr: "Corée, République populaire démocratique de",
					nl: "Korea, Democratische Volksrepubliek",
					es: "Corea del Norte",
					pt: "Coreia do Norte",
					"zh-hant": "北韓",
					"zh-hans": "朝鲜"
				}, {
					code: "KR",
					countryCode: "+82",
					name: "South Korea",
					nativeSpelling: "Taehan-min\"guk",
					de: "Korea, Republik",
					fr: "Corée, République de",
					nl: "Korea, Republiek",
					es: "Corea del Sur",
					pt: "Coreia do Sul",
					"zh-hant": "南韓",
					"zh-hans": "韩国"
				}, {
					code: "KW",
					countryCode: "+965",
					name: "Kuwait",
					nativeSpelling: "Al Kuwayt",
					fr: "Koweït",
					nl: "Koeweit",
					de: "Kuwait",
					es: "Kuwait",
					pt: "Kuwait",
					"zh-hant": "科威特",
					"zh-hans": "科威特"
				}, {
					code: "KG",
					countryCode: "+996",
					name: "Kyrgyzstan",
					nativeSpelling: "Kyrgyz Respublikasy",
					de: "Kirgisistan",
					fr: "Kirghizistan",
					nl: "Kirgistan",
					es: "Kirguistán",
					pt: "Quirguistão",
					"zh-hant": "吉爾吉斯",
					"zh-hans": "吉尔吉斯斯坦"
				}, {
					code: "LA",
					countryCode: "+856",
					name: "Laos",
					nativeSpelling: "Sathalanalat Paxathipatai Paxaxon Lao",
					de: "Laos, Demokratische Volksrepublik",
					fr: "Lao (République démocratique populaire)",
					nl: "Laos, Democratische Volksrepubliek",
					es: "Laos",
					pt: "Laos",
					"zh-hant": "老撾",
					"zh-hans": "老挝"
				}, {
					code: "LV",
					countryCode: "+371",
					name: "Latvia",
					nativeSpelling: "Latvija",
					de: "Lettland",
					fr: "Lettonie",
					nl: "Letland",
					es: "Letonia",
					pt: "Letônia",
					"zh-hant": "拉脱維亞",
					"zh-hans": "拉脱维亚"
				}, {
					code: "LB",
					countryCode: "+961",
					name: "Lebanon",
					nativeSpelling: "Lubnan",
					de: "Libanon",
					fr: "Liban",
					es: "Líbano",
					pt: "Líbano",
					"zh-hant": "黎巴嫩",
					"zh-hans": "黎巴嫩"
				}, {
					code: "LS",
					countryCode: "+266",
					name: "Lesotho",
					nativeSpelling: "Lesotho",
					de: "Lesotho",
					es: "Lesoto",
					pt: "Lesoto",
					"zh-hant": "賴索托",
					"zh-hans": "莱索托"
				}, {
					code: "LR",
					countryCode: "+231",
					name: "Liberia",
					nativeSpelling: "Liberia",
					de: "Liberia",
					es: "Liberia",
					pt: "Libéria",
					"zh-hant": "利比里亞",
					"zh-hans": "利比里亚"
				}, {
					code: "LY",
					countryCode: "+218",
					name: "Libya",
					nativeSpelling: "Libya",
					de: "Libysch-Arabische Dschamahirija",
					fr: "Jamahiriya arabe libyenne",
					nl: "Libië",
					es: "Libia",
					pt: "Líbia",
					"zh-hant": "利比亞",
					"zh-hans": "利比亚"
				}, {
					code: "LI",
					countryCode: "+423",
					name: "Liechtenstein",
					nativeSpelling: "Liechtenstein",
					de: "Liechtenstein",
					fr: "Liechtenstein",
					es: "Liechtenstein",
					pt: "Liechtenstein",
					"zh-hant": "列支敦士登",
					"zh-hans": "列支敦士登"
				}, {
					code: "LT",
					countryCode: "+370",
					name: "Lithuania",
					nativeSpelling: "Lietuva",
					de: "Litauen",
					fr: "Lituanie",
					nl: "Litouwen",
					es: "Lituania",
					pt: "Lituânia",
					"zh-hant": "立陶宛",
					"zh-hans": "立陶宛"
				}, {
					code: "LU",
					countryCode: "+352",
					name: "Luxembourg",
					nativeSpelling: "Luxembourg",
					de: "Luxemburg",
					es: "Luxemburgo",
					pt: "Luxemburgo",
					"zh-hant": "盧森堡",
					"zh-hans": "卢森堡"
				}, {
					code: "MK",
					countryCode: "+389",
					name: "Macedonia",
					nativeSpelling: "Makedonija",
					de: "Mazedonien, ehemalige jugoslawische Republik",
					fr: "Macédoine, Ex-République yougoslave",
					nl: "Macedonië, Voormalig Joegoslavische Republiek",
					es: "Macedonia",
					pt: "Macedônia",
					"zh-hant": "馬其頓",
					"zh-hans": "马其顿"
				}, {
					code: "MO",
					countryCode: "+853",
					name: "Macau SAR China",
					nativeSpelling: "Macau Special Administrative Region",
					de: "Macau",
					es: "Región Administrativa Especial de Macao de la República Popular China",
					pt: "Macau, RAE da China",
					"zh-hant": "中國澳門特別行政區",
					"zh-hans": "中国澳门特别行政区"
				}, {
					code: "MG",
					countryCode: "+261",
					name: "Madagascar",
					nativeSpelling: "Madagascar",
					de: "Madagaskar",
					nl: "Madagaskar",
					es: "Madagascar",
					pt: "Madagascar",
					"zh-hant": "馬達加斯加",
					"zh-hans": "马达加斯加"
				}, {
					code: "MW",
					countryCode: "+265",
					name: "Malawi",
					nativeSpelling: "Malawi",
					de: "Malawi",
					es: "Malaui",
					pt: "Malawi",
					"zh-hant": "馬拉維",
					"zh-hans": "马拉维"
				}, {
					code: "MY",
					countryCode: "+60",
					name: "Malaysia",
					nativeSpelling: "Malaysia",
					fr: "Malaisie",
					nl: "Maleisië",
					de: "Malaysia",
					es: "Malasia",
					pt: "Malásia",
					"zh-hant": "馬來西亞",
					"zh-hans": "马来西亚"
				}, {
					code: "MV",
					countryCode: "+960",
					name: "Maldives",
					nativeSpelling: "Dhivehi Raajje",
					de: "Malediven",
					nl: "Malediven",
					es: "Maldivas",
					pt: "Maldivas",
					"zh-hant": "馬爾代夫",
					"zh-hans": "马尔代夫"
				}, {
					code: "ML",
					countryCode: "+223",
					name: "Mali",
					nativeSpelling: "Mali",
					de: "Mali",
					es: "Mali",
					pt: "Mali",
					"zh-hant": "馬里",
					"zh-hans": "马里"
				}, {
					code: "MT",
					countryCode: "+36",
					name: "Malta",
					nativeSpelling: "Malta",
					fr: "Malte",
					de: "Malta",
					es: "Malta",
					pt: "Malta",
					"zh-hant": "馬耳他",
					"zh-hans": "马耳他"
				}, {
					code: "MH",
					countryCode: "+692",
					name: "Marshall Islands",
					nativeSpelling: "Marshall Islands",
					de: "Marshallinseln",
					fr: "Marshall (îles)",
					nl: "Marshalleilanden",
					es: "Islas Marshall",
					pt: "Ilhas Marshall",
					"zh-hant": "馬紹爾群島",
					"zh-hans": "马绍尔群岛"
				}, {
					code: "MQ",
					countryCode: "+596",
					name: "Martinique",
					nativeSpelling: "Overseas Region of Martinique",
					de: "Martinique",
					es: "Martinica",
					pt: "Martinica",
					"zh-hant": "馬丁尼克",
					"zh-hans": "马提尼克"
				}, {
					code: "MR",
					countryCode: "+222",
					name: "Mauritania",
					nativeSpelling: "Muritaniyah",
					de: "Mauretanien",
					nl: "Mauritanië",
					es: "Mauritania",
					pt: "Mauritânia",
					"zh-hant": "毛里塔尼亞",
					"zh-hans": "毛里塔尼亚"
				}, {
					code: "MU",
					countryCode: "+230",
					name: "Mauritius",
					nativeSpelling: "Mauritius",
					de: "Mauritius",
					es: "Mauricio",
					pt: "Maurício",
					"zh-hant": "毛里裘斯",
					"zh-hans": "毛里求斯"
				}, {
					code: "YT",
					countryCode: "+262",
					name: "Mayotte",
					nativeSpelling: "Departmental Collectivity of Mayotte",
					de: "Mayotte",
					es: "Mayotte",
					pt: "Mayotte",
					"zh-hant": "馬約特",
					"zh-hans": "马约特"
				}, {
					code: "FM",
					countryCode: "+691",
					name: "Federated States of Micronesia",
					nativeSpelling: "Federated States of Micronesia",
					de: "Mikronesien, Föderierte Staaten",
					fr: "Micronésie, États fédérés de",
					nl: "Micronesia, Gefedereerde Staten van",
					es: "Micronesia",
					pt: "Micronésia",
					"zh-hant": "密克羅尼西亞",
					"zh-hans": "密克罗尼西亚"
				}, {
					code: "MD",
					countryCode: "+373",
					name: "Moldova",
					nativeSpelling: "Moldova",
					de: "Moldau, Republik",
					fr: "Moldavie, République de",
					nl: "Moldavië, Republiek",
					es: "Moldavia",
					pt: "Moldávia",
					"zh-hant": "摩爾多瓦",
					"zh-hans": "摩尔多瓦"
				}, {
					code: "MC",
					countryCode: "+377",
					name: "Monaco",
					nativeSpelling: "Monaco",
					de: "Monaco",
					es: "Mónaco",
					pt: "Mônaco",
					"zh-hant": "摩納哥",
					"zh-hans": "摩纳哥"
				}, {
					code: "MN",
					countryCode: "+976",
					name: "Mongolia",
					nativeSpelling: "Mongol Uls",
					de: "Mongolei",
					fr: "Mongolie",
					nl: "Mongolië",
					es: "Mongolia",
					pt: "Mongólia",
					"zh-hant": "蒙古",
					"zh-hans": "蒙古"
				}, {
					code: "ME",
					countryCode: "+382",
					name: "Montenegro",
					nativeSpelling: "Montenegro",
					de: "Montenegro",
					fr: "Montenegro",
					nl: "Montenegro",
					es: "Montenegro",
					pt: "Montenegro",
					"zh-hant": "黑山",
					"zh-hans": "黑山"
				}, {
					code: "MS",
					countryCode: "+1",
					name: "Montserrat",
					nativeSpelling: "Montserrat",
					de: "Montserrat",
					es: "Montserrat",
					pt: "Montserrat",
					"zh-hant": "蒙特塞拉特",
					"zh-hans": "蒙特塞拉特"
				}, {
					code: "MA",
					countryCode: "+212",
					name: "Morocco",
					nativeSpelling: "Al Maghrib",
					de: "Marokko",
					fr: "Maroc",
					nl: "Marokko",
					es: "Marruecos",
					pt: "Marrocos",
					"zh-hant": "摩洛哥",
					"zh-hans": "摩洛哥"
				}, {
					code: "MZ",
					countryCode: "+258",
					name: "Mozambique",
					nativeSpelling: "Mocambique",
					de: "Mosambik",
					es: "Mozambique",
					pt: "Moçambique",
					"zh-hant": "莫桑比克",
					"zh-hans": "莫桑比克"
				}, {
					code: "MM",
					countryCode: "+95",
					name: "Myanmar (Burma)",
					nativeSpelling: "Myanma Naingngandaw",
					de: "Myanmar (Birma)",
					es: "Myanmar [Birmania]",
					pt: "Mianmar [Birmânia]",
					"zh-hant": "緬甸",
					"zh-hans": "缅甸"
				}, {
					code: "NA",
					countryCode: "+264",
					name: "Namibia",
					nativeSpelling: "Namibia",
					fr: "Namibie",
					nl: "Namibië",
					de: "Namibia",
					es: "Namibia",
					pt: "Namíbia",
					"zh-hant": "納米比亞",
					"zh-hans": "纳米比亚"
				}, {
					code: "NR",
					countryCode: "+674",
					name: "Nauru",
					nativeSpelling: "Nauru",
					de: "Nauru",
					es: "Nauru",
					pt: "Nauru",
					"zh-hant": "瑙魯",
					"zh-hans": "瑙鲁"
				}, {
					code: "NP",
					countryCode: "+977",
					name: "Nepal",
					nativeSpelling: "Nepal",
					de: "Nepal",
					es: "Nepal",
					pt: "Nepal",
					"zh-hant": "尼泊爾",
					"zh-hans": "尼泊尔"
				}, {
					code: "NL",
					countryCode: "+31",
					name: "Netherlands",
					nativeSpelling: "Nederland",
					de: "Niederlande",
					fr: "Pays-Bas",
					nl: "Nederland",
					es: "Países Bajos",
					pt: "Holanda",
					"zh-hant": "荷蘭",
					"zh-hans": "荷兰"
				}, {
					code: "AN",
					countryCode: "+599",
					name: "Netherlands Antilles",
					nativeSpelling: "Netherlands Antilles",
					de: "Niederländische Antillen",
					fr: "Antilles néerlandaises",
					nl: "Nederlandse Antillen",
					es: "Antillas Neerlandesas",
					pt: "Antilhas Holandesas",
					"zh-hant": "荷屬安的列斯",
					"zh-hans": "荷属安的列斯"
				}, {
					code: "NC",
					countryCode: "+687",
					name: "New Caledonia",
					nativeSpelling: "New Caledonia",
					de: "Neukaledonien",
					fr: "Nouvelle-Calédonie",
					nl: "Nieuw-Caledonië",
					es: "Nueva Caledonia",
					pt: "Nova Caledônia",
					"zh-hant": "新喀里多尼亞",
					"zh-hans": "新喀里多尼亚"
				}, {
					code: "NZ",
					countryCode: "+64",
					name: "New Zealand",
					nativeSpelling: "New Zealand",
					de: "Neuseeland",
					fr: "Nouvelle-Zélande",
					nl: "Nieuw-Zeeland",
					es: "Nueva Zelanda",
					pt: "Nova Zelândia",
					"zh-hant": "紐西蘭",
					"zh-hans": "新西兰"
				}, {
					code: "NI",
					countryCode: "+505",
					name: "Nicaragua",
					nativeSpelling: "Nicaragua",
					de: "Nicaragua",
					es: "Nicaragua",
					pt: "Nicarágua",
					"zh-hant": "尼加拉瓜",
					"zh-hans": "尼加拉瓜"
				}, {
					code: "NE",
					countryCode: "+227",
					name: "Niger",
					nativeSpelling: "Niger",
					de: "Niger",
					es: "Níger",
					pt: "Níger",
					"zh-hant": "尼日爾",
					"zh-hans": "尼日尔"
				}, {
					code: "NG",
					countryCode: "+234",
					name: "Nigeria",
					nativeSpelling: "Nigeria",
					de: "Nigeria",
					es: "Nigeria",
					pt: "Nigéria",
					"zh-hant": "尼日利亞",
					"zh-hans": "尼日利亚"
				}, {
					code: "NO",
					countryCode: "+47",
					name: "Norway",
					nativeSpelling: "Norge",
					de: "Norwegen",
					fr: "Norvège",
					nl: "Noorwegen",
					es: "Noruega",
					pt: "Noruega",
					"zh-hant": "挪威",
					"zh-hans": "挪威"
				}, {
					code: "NU",
					countryCode: "+683",
					name: "Niue",
					nativeSpelling: "Niue",
					de: "Niue",
					es: "Isla Niue",
					pt: "Niue",
					"zh-hant": "紐埃島",
					"zh-hans": "纽埃"
				}, {
					code: "OM",
					countryCode: "+968",
					name: "Oman",
					nativeSpelling: "Uman",
					de: "Oman",
					es: "Omán",
					pt: "Omã",
					"zh-hant": "阿曼",
					"zh-hans": "阿曼"
				}, {
					code: "PK",
					countryCode: "+92",
					name: "Pakistan",
					nativeSpelling: "Pakistan",
					de: "Pakistan",
					es: "Pakistán",
					pt: "Paquistão",
					"zh-hant": "巴基斯坦",
					"zh-hans": "巴基斯坦"
				}, {
					code: "PW",
					countryCode: "+680",
					name: "Palau",
					nativeSpelling: "Belau",
					de: "Palau",
					es: "Palau",
					pt: "Palau",
					"zh-hant": "帛琉",
					"zh-hans": "帕劳"
				}, {
					code: "PA",
					countryCode: "+507",
					name: "Panama",
					nativeSpelling: "Panama",
					de: "Panama",
					es: "Panamá",
					pt: "Panamá",
					"zh-hant": "巴拿馬",
					"zh-hans": "巴拿马"
				}, {
					code: "PG",
					countryCode: "+675",
					name: "Papua New Guinea",
					nativeSpelling: "Papua New Guinea",
					de: "Papua-Neuguinea",
					fr: "Papouasie-Nouvelle-Guinée",
					nl: "Papoea-Nieuw-Guinea",
					es: "Papúa Nueva Guinea",
					pt: "Papua-Nova Guiné",
					"zh-hant": "巴布亞新幾內亞",
					"zh-hans": "巴布亚新几内亚"
				}, {
					code: "PY",
					countryCode: "+595",
					name: "Paraguay",
					nativeSpelling: "Paraguay",
					de: "Paraguay",
					es: "Paraguay",
					pt: "Paraguai",
					"zh-hant": "巴拉圭",
					"zh-hans": "巴拉圭"
				}, {
					code: "PE",
					countryCode: "+51",
					name: "Peru",
					nativeSpelling: "Peru",
					fr: "Pérou",
					de: "Peru",
					es: "Perú",
					pt: "Peru",
					"zh-hant": "秘魯",
					"zh-hans": "秘鲁"
				}, {
					code: "PH",
					countryCode: "+63",
					name: "Philippines",
					nativeSpelling: "Pilipinas",
					de: "Philippinen",
					nl: "Filipijnen",
					es: "Filipinas",
					pt: "Filipinas",
					"zh-hant": "菲律賓",
					"zh-hans": "菲律宾"
				}, {
					code: "PL",
					countryCode: "+48",
					name: "Poland",
					nativeSpelling: "Polska",
					de: "Polen",
					fr: "Pologne",
					nl: "Polen",
					es: "Polonia",
					pt: "Polônia",
					"zh-hant": "波蘭",
					"zh-hans": "波兰"
				}, {
					code: "PN",
					countryCode: "+64",
					name: "Pitcairn Islands",
					nativeSpelling: "Pitcairn Islands",
					de: "Pitcairninseln",
					fr: "Pitcairn (Île)",
					nl: "Pitcairneilanden",
					es: "Islas Pitcairn",
					pt: "Ilhas Pitcairn",
					"zh-hant": "皮特凱恩島",
					"zh-hans": "皮特凯恩群岛"
				}, {
					code: "PT",
					countryCode: "+351",
					name: "Portugal",
					nativeSpelling: "Portugal",
					de: "Portugal",
					es: "Portugal",
					pt: "Portugal",
					"zh-hant": "葡萄牙",
					"zh-hans": "葡萄牙"
				}, {
					code: "QA",
					countryCode: "+974",
					name: "Qatar",
					nativeSpelling: "Qatar",
					de: "Katar",
					es: "Qatar",
					pt: "Catar",
					"zh-hant": "卡塔爾",
					"zh-hans": "卡塔尔"
				}, {
					code: "RE",
					countryCode: "+262",
					name: "Reunion",
					nativeSpelling: "Overseas Region of Reunion",
					de: "Réunion",
					fr: "Réunion (Île de la)",
					es: "Reunión",
					pt: "Reunião",
					"zh-hant": "留尼旺",
					"zh-hans": "留尼汪"
				}, {
					code: "RO",
					countryCode: "+40",
					name: "Romania",
					nativeSpelling: "Romania",
					de: "Rumänien",
					fr: "Roumanie",
					nl: "Roemenië",
					es: "Rumanía",
					pt: "Romênia",
					"zh-hant": "羅馬尼亞",
					"zh-hans": "罗马尼亚"
				}, {
					code: "RU",
					countryCode: "+7",
					name: "Russia",
					nativeSpelling: "Rossiya",
					de: "Russische Föderation",
					fr: "Fédération de Russie",
					nl: "Russische Federatie",
					es: "Rusia",
					pt: "Rússia",
					"zh-hant": "俄羅斯",
					"zh-hans": "俄罗斯"
				}, {
					code: "RW",
					countryCode: "+250",
					name: "Rwanda",
					nativeSpelling: "Rwanda",
					de: "Ruanda",
					es: "Ruanda",
					pt: "Ruanda",
					"zh-hant": "盧旺達",
					"zh-hans": "卢旺达"
				}, {
					code: "VC",
					countryCode: "+1",
					name: "Saint Vincent and the Grenadines",
					nativeSpelling: "Saint Vincent and the Grenadines",
					de: "St. Vincent und die Grenadinen",
					fr: "Saint-Vincent-et-les-Grenadines",
					nl: "Saint Vincent en de Grenadines",
					es: "San Vicente y las Granadinas",
					pt: "São Vicente e Granadinas",
					"zh-hant": "聖文森特和格林納丁斯",
					"zh-hans": "圣文森特和格林纳丁斯"
				}, {
					code: "KN",
					countryCode: "+1",
					name: "Saint Kitts and Nevis",
					nativeSpelling: "Saint Kitts and Nevis",
					de: "St. Kitts und Nevis",
					fr: "Saint-Christophe-et-Niévès",
					nl: "Saint Kitts en Nevis",
					es: "San Cristóbal y Nieves",
					pt: "São Cristovão e Nevis",
					"zh-hant": "聖基茨和尼維斯",
					"zh-hans": "圣基茨和尼维斯"
				}, {
					code: "LC",
					countryCode: "+1",
					name: "Saint Lucia",
					nativeSpelling: "Saint Lucia",
					de: "St. Lucia",
					fr: "Sainte Lucie",
					es: "Santa Lucía",
					pt: "Santa Lúcia",
					"zh-hant": "聖盧西亞",
					"zh-hans": "圣卢西亚"
				}, {
					code: "WS",
					countryCode: "+685",
					name: "Samoa",
					nativeSpelling: "Samoa",
					de: "Samoa",
					es: "Samoa",
					pt: "Samoa",
					"zh-hant": "薩摩亞",
					"zh-hans": "萨摩亚"
				}, {
					code: "SM",
					countryCode: "+378",
					name: "San Marino",
					nativeSpelling: "San Marino",
					fr: "Saint-Marin",
					de: "San Marino",
					es: "San Marino",
					pt: "San Marino",
					"zh-hant": "聖馬利諾",
					"zh-hans": "圣马力诺"
				}, {
					code: "ST",
					countryCode: "+239",
					name: "Sao Tome and Principe",
					nativeSpelling: "Sao Tome e Principe",
					de: "São Tomé und Príncipe",
					fr: "Sao Tomé-et-Principe",
					nl: "Sao Tomé en Principe",
					es: "Santo Tomé y Príncipe",
					pt: "São Tomé e Príncipe",
					"zh-hant": "聖多美和普林西比",
					"zh-hans": "圣多美和普林西比"
				}, {
					code: "SA",
					countryCode: "+966",
					name: "Saudi Arabia",
					nativeSpelling: "Al Arabiyah as Suudiyah",
					de: "Saudi-Arabien",
					fr: "Arabie saoudite",
					nl: "Saoedi-Arabië",
					es: "Arabia Saudí",
					pt: "Arábia Saudita",
					"zh-hant": "沙地阿拉伯",
					"zh-hans": "沙特阿拉伯"
				}, {
					code: "SN",
					countryCode: "+221",
					name: "Senegal",
					nativeSpelling: "Senegal",
					fr: "Sénégal",
					de: "Senegal",
					es: "Senegal",
					pt: "Senegal",
					"zh-hant": "塞內加爾",
					"zh-hans": "塞内加尔"
				}, {
					code: "RS",
					countryCode: "+381",
					name: "Serbia",
					nativeSpelling: "Srbija",
					de: "Serbia",
					fr: "Serbia",
					nl: "Serbia",
					es: "Serbia",
					pt: "Sérvia",
					"zh-hant": "塞爾維亞",
					"zh-hans": "塞尔维亚"
				}, {
					code: "SC",
					countryCode: "+248",
					name: "Seychelles",
					nativeSpelling: "Seychelles",
					de: "Seychellen",
					nl: "Seychellen",
					es: "Seychelles",
					pt: "Seychelles",
					"zh-hant": "塞舌爾",
					"zh-hans": "塞舌尔"
				}, {
					code: "SL",
					countryCode: "+232",
					name: "Sierra Leone",
					nativeSpelling: "Sierra Leone",
					de: "Sierra Leone",
					es: "Sierra Leona",
					pt: "Serra Leoa",
					"zh-hant": "塞拉利昂",
					"zh-hans": "塞拉利昂"
				}, {
					code: "SG",
					countryCode: "+65",
					name: "Singapore",
					nativeSpelling: "Singapore",
					de: "Singapur",
					fr: "Singapour",
					es: "Singapur",
					pt: "Cingapura",
					"zh-hant": "新加坡",
					"zh-hans": "新加坡"
				}, {
					code: "SK",
					countryCode: "+421",
					name: "Slovakia",
					nativeSpelling: "Slovensko",
					de: "Slowakei (Slowakische Republik)",
					fr: "Slovaquie (République slovaque)",
					nl: "Slowakije (Slowaakse Republiek)",
					es: "Eslovaquia",
					pt: "Eslováquia",
					"zh-hant": "斯洛伐克",
					"zh-hans": "斯洛伐克"
				}, {
					code: "SI",
					countryCode: "+386",
					name: "Slovenia",
					nativeSpelling: "Slovenija",
					de: "Slowenien",
					fr: "Slovénie",
					nl: "Slovenië",
					es: "Eslovenia",
					pt: "Eslovênia",
					"zh-hant": "斯洛文尼亞",
					"zh-hans": "斯洛文尼亚"
				}, {
					code: "SB",
					countryCode: "+677",
					name: "Solomon Islands",
					nativeSpelling: "Solomon Islands",
					de: "Salomonen",
					fr: "Salomon (îles)",
					nl: "Salomonseilanden",
					es: "Islas Salomón",
					pt: "Ilhas Salomão",
					"zh-hant": "所羅門群島",
					"zh-hans": "所罗门群岛"
				}, {
					code: "SO",
					countryCode: "+252",
					name: "Somalia",
					nativeSpelling: "Somalia",
					nl: "Somalië",
					de: "Somalia",
					es: "Somalia",
					pt: "Somália",
					"zh-hant": "索馬里",
					"zh-hans": "索马里"
				}, {
					code: "ZA",
					countryCode: "+27",
					name: "South Africa",
					nativeSpelling: "South Africa",
					de: "Südafrika",
					fr: "Afrique du Sud",
					nl: "Zuid-Afrika",
					es: "Sudáfrica",
					pt: "África do Sul",
					"zh-hant": "南非",
					"zh-hans": "南非"
				}, {
					code: "ES",
					countryCode: "+34",
					name: "Spain",
					nativeSpelling: "Espana",
					de: "Spanien",
					fr: "Espagne",
					nl: "Spanje",
					es: "España",
					pt: "Espanha",
					"zh-hant": "西班牙",
					"zh-hans": "西班牙"
				}, {
					code: "LK",
					countryCode: "+94",
					name: "Sri Lanka",
					nativeSpelling: "Sri Lanka",
					nl: "Sri Lanka",
					de: "Sri Lanka",
					es: "Sri Lanka",
					pt: "Sri Lanka",
					"zh-hant": "斯里蘭卡",
					"zh-hans": "斯里兰卡"
				}, {
					code: "SD",
					countryCode: "+294",
					name: "Sudan",
					nativeSpelling: "As-Sudan",
					de: "Sudan",
					es: "Sudán",
					pt: "Sudão",
					"zh-hant": "蘇丹",
					"zh-hans": "苏丹"
				}, {
					code: "SR",
					countryCode: "+597",
					name: "Suriname",
					nativeSpelling: "Suriname",
					de: "Suriname",
					es: "Surinam",
					pt: "Suriname",
					"zh-hant": "蘇里南",
					"zh-hans": "苏里南"
				}, {
					code: "SZ",
					countryCode: "+268",
					name: "Swaziland",
					nativeSpelling: "Swaziland",
					de: "Swasiland",
					es: "Suazilandia",
					pt: "Suazilândia",
					"zh-hant": "斯威士蘭",
					"zh-hans": "斯威士兰"
				}, {
					code: "SE",
					countryCode: "+46",
					name: "Sweden",
					nativeSpelling: "Sverige",
					de: "Schweden",
					nl: "Zweden",
					es: "Suecia",
					pt: "Suécia",
					"zh-hant": "瑞典",
					"zh-hans": "瑞典"
				}, {
					code: "PM",
					countryCode: "+508",
					name: "Saint Pierre and Miquelon",
					nativeSpelling: "Territorial Collectivity of Saint Pierre and Miquelon",
					de: "St. Pierre und Miquelon",
					fr: "Saint-Pierre-et-Miquelon",
					es: "San Pedro y Miquelón",
					pt: "Saint Pierre e Miquelon",
					"zh-hant": "聖皮埃與密克隆群島",
					"zh-hans": "圣皮埃尔和密克隆群岛"
				}, {
					code: "SJ",
					countryCode: "+47",
					name: "Svalbard and Jan Mayen",
					nativeSpelling: "Svalbard and Jan Mayen",
					de: "Svalbard und Jan Mayen",
					fr: "Svalbard et Jan Mayen (Îles de)",
					nl: "Spitsbergen en Jan Mayen",
					es: "Svalbard y Jan Mayen",
					pt: "Svalbard e Jan Mayen",
					"zh-hant": "斯瓦爾巴特群島及揚馬延島",
					"zh-hans": "斯瓦尔巴和扬马延"
				}, {
					code: "SH",
					countryCode: "+290",
					name: "Saint Helena",
					nativeSpelling: "Saint Helena",
					de: "St. Helena",
					fr: "Sainte-Hélène",
					nl: "Sint-Helena",
					es: "Santa Elena",
					pt: "Santa Helena",
					"zh-hant": "聖赫勒拿島",
					"zh-hans": "圣赫勒拿"
				}, {
					code: "CH",
					countryCode: "+41",
					name: "Switzerland",
					nativeSpelling: "Schweiz (German), Suisse (French), Svizzera (Italian)",
					de: "Schweiz",
					fr: "Suisse",
					it: "Svizzera",
					nl: "Zwitserland",
					es: "Suiza",
					pt: "Suíça",
					"zh-hant": "瑞士",
					"zh-hans": "瑞士"
				}, {
					code: "SY",
					countryCode: "+963",
					name: "Syria",
					nativeSpelling: "Suriyah",
					de: "Syrien, Arabische Republik",
					nl: "Syrië, Arabische Republiek",
					es: "Siria",
					pt: "Síria",
					"zh-hant": "敘利亞",
					"zh-hans": "叙利亚"
				}, {
					code: "TW",
					countryCode: "+886",
					name: "Taiwan",
					nativeSpelling: "T\"ai-wan",
					de: "Taiwan",
					es: "Taiwán",
					pt: "Taiwan",
					"zh-hant": "台灣",
					"zh-hans": "台湾"
				}, {
					code: "TJ",
					countryCode: "+992",
					name: "Tajikistan",
					nativeSpelling: "Jumhurii Tojikistan",
					de: "Tadschikistan",
					fr: "Tadjikistan",
					nl: "Tadzjikistan",
					es: "Tayikistán",
					pt: "Tadjiquistão",
					"zh-hant": "塔吉克",
					"zh-hans": "塔吉克斯坦"
				}, {
					code: "TZ",
					countryCode: "+255",
					name: "Tanzania",
					nativeSpelling: "Tanzania",
					de: "Tansania, Vereinigte Republik",
					fr: "Tanzanie, République unie de",
					nl: "Tanzania, Verenigde Republiek",
					es: "Tanzania",
					pt: "Tanzânia",
					"zh-hant": "坦桑尼亞",
					"zh-hans": "坦桑尼亚"
				}, {
					code: "TH",
					countryCode: "+66",
					name: "Thailand",
					nativeSpelling: "Muang Thai",
					fr: "Thaïlande",
					de: "Thailand",
					es: "Tailandia",
					pt: "Tailândia",
					"zh-hant": "泰國",
					"zh-hans": "泰国"
				}, {
					code: "TG",
					countryCode: "+228",
					name: "Togo",
					nativeSpelling: "Togo",
					de: "Togo",
					es: "Togo",
					pt: "Togo",
					"zh-hant": "多哥共和國",
					"zh-hans": "多哥"
				}, {
					code: "TO",
					countryCode: "+676",
					name: "Tonga",
					nativeSpelling: "Tonga",
					de: "Tonga",
					es: "Tonga",
					pt: "Tonga",
					"zh-hant": "湯加",
					"zh-hans": "汤加"
				}, {
					code: "TK",
					countryCode: "+690",
					name: "Tokelau",
					nativeSpelling: "Tokelau",
					nl: "Tokelau-eilanden",
					de: "Tokelau",
					es: "Tokelau",
					pt: "Tokelau",
					"zh-hant": "托克勞群島",
					"zh-hans": "托克劳"
				}, {
					code: "TT",
					countryCode: "+1",
					name: "Trinidad and Tobago",
					nativeSpelling: "Trinidad and Tobago",
					de: "Trinidad und Tobago",
					fr: "Trinité-et-Tobago",
					nl: "Trinidad en Tobago",
					es: "Trinidad y Tobago",
					pt: "Trinidad e Tobago",
					"zh-hant": "千里達和多巴哥",
					"zh-hans": "特立尼达和多巴哥"
				}, {
					code: "TN",
					countryCode: "+216",
					name: "Tunisia",
					nativeSpelling: "Tunis",
					de: "Tunesien",
					fr: "Tunisie",
					nl: "Tunesië",
					es: "Túnez",
					pt: "Tunísia",
					"zh-hant": "突尼西亞",
					"zh-hans": "突尼斯"
				}, {
					code: "TR",
					countryCode: "+90",
					name: "Turkey",
					nativeSpelling: "Turkiye",
					de: "Türkei",
					fr: "Turquie",
					nl: "Turkije",
					es: "Turquía",
					pt: "Turquia",
					"zh-hant": "土耳其",
					"zh-hans": "土耳其"
				}, {
					code: "TM",
					countryCode: "+993",
					name: "Turkmenistan",
					nativeSpelling: "Turkmenistan",
					fr: "Turkménistan",
					de: "Turkmenistan",
					es: "Turkmenistán",
					pt: "Turcomenistão",
					"zh-hant": "土庫曼",
					"zh-hans": "土库曼斯坦"
				}, {
					code: "TV",
					countryCode: "+688",
					name: "Tuvalu",
					nativeSpelling: "Tuvalu",
					de: "Tuvalu",
					es: "Tuvalu",
					pt: "Tuvalu",
					"zh-hant": "圖瓦盧",
					"zh-hans": "图瓦卢"
				}, {
					code: "UG",
					countryCode: "+256",
					name: "Uganda",
					nativeSpelling: "Uganda",
					fr: "Ouganda",
					de: "Uganda",
					es: "Uganda",
					pt: "Uganda",
					"zh-hant": "烏干達",
					"zh-hans": "乌干达"
				}, {
					code: "TC",
					countryCode: "+1",
					name: "Turks and Caicos Islands",
					nativeSpelling: "Turks and Caicos Islands",
					de: "Turks- und Caicosinseln",
					fr: "Turks et Caicos (îles)",
					nl: "Turks-en Caicoseilanden",
					es: "Islas Turcas y Caicos",
					pt: "Ilhas Turks e Caicos",
					"zh-hant": "特克斯和凱科斯群島",
					"zh-hans": "特克斯和凯科斯群岛"
				}, {
					code: "UA",
					countryCode: "+380",
					name: "Ukraine",
					nativeSpelling: "Ukrayina",
					nl: "Oekraïne",
					de: "Ukraine",
					es: "Ucrania",
					pt: "Ucrânia",
					"zh-hant": "烏克蘭",
					"zh-hans": "乌克兰"
				}, {
					code: "AE",
					countryCode: "+971",
					name: "United Arab Emirates",
					nativeSpelling: "Al Imarat al Arabiyah al Muttahidah",
					de: "Vereinigte Arabische Emirate",
					fr: "Émirats arabes unis",
					nl: "Verenigde Arabische Emiraten",
					es: "Emiratos Árabes Unidos",
					pt: "Emirados Árabes Unidos",
					"zh-hant": "阿拉伯聯合酋長國",
					"zh-hans": "阿拉伯联合酋长国"
				}, {
					code: "UY",
					countryCode: "+598",
					name: "Uruguay",
					nativeSpelling: "Uruguay",
					de: "Uruguay",
					es: "Uruguay",
					pt: "Uruguai",
					"zh-hant": "烏拉圭",
					"zh-hans": "乌拉圭"
				}, {
					code: "UZ",
					countryCode: "+998",
					name: "Uzbekistan",
					nativeSpelling: "Uzbekiston Respublikasi",
					de: "Usbekistan",
					fr: "Ouzbékistan",
					nl: "Oezbekistan",
					es: "Uzbekistán",
					pt: "Uzbequistão",
					"zh-hant": "烏茲別克",
					"zh-hans": "乌兹别克斯坦"
				}, {
					code: "VU",
					countryCode: "+678",
					name: "Vanuatu",
					nativeSpelling: "Vanuatu",
					de: "Vanuatu",
					es: "Vanuatu",
					pt: "Vanuatu",
					"zh-hant": "瓦努阿圖",
					"zh-hans": "瓦努阿图"
				}, {
					code: "VA",
					countryCode: "+379",
					name: "Vatican City",
					nativeSpelling: "Santa Sede (Citta del Vaticano)",
					de: "Heiliger Stuhl (die Vatikanstadt)",
					fr: "Saint-Siège (Cité du Vatican)",
					nl: "Heilige Stoel (Vaticaanstad)",
					es: "Ciudad del Vaticano",
					pt: "Vaticano",
					"zh-hant": "梵蒂岡",
					"zh-hans": "梵蒂冈"
				}, {
					code: "VE",
					countryCode: "+58",
					name: "Venezuela",
					nativeSpelling: "Venezuela",
					de: "Venezuela",
					es: "Venezuela",
					pt: "Venezuela",
					"zh-hant": "委內瑞拉",
					"zh-hans": "委内瑞拉"
				}, {
					code: "VN",
					countryCode: "+84",
					name: "Vietnam",
					nativeSpelling: "Viet Nam",
					de: "Vietnam",
					es: "Vietnam",
					pt: "Vietnã",
					"zh-hant": "越南",
					"zh-hans": "越南"
				}, {
					code: "YE",
					countryCode: "+967",
					name: "Yemen",
					nativeSpelling: "Al Yaman",
					de: "Jemen",
					nl: "Jemen",
					es: "Yemen",
					pt: "Iêmen",
					"zh-hant": "也門",
					"zh-hans": "也门"
				}, {
					code: "ZM",
					countryCode: "+260",
					name: "Zambia",
					nativeSpelling: "Zambia",
					de: "Sambia",
					fr: "Zambie",
					es: "Zambia",
					pt: "Zâmbia",
					"zh-hant": "贊比亞",
					"zh-hans": "赞比亚"
				}, {
					code: "ZW",
					countryCode: "+263",
					name: "Zimbabwe",
					nativeSpelling: "Zimbabwe",
					de: "Simbabwe",
					fr: "Zimbabwe",
					es: "Zimbabue",
					pt: "Zimbábue",
					"zh-hant": "津巴布韋",
					"zh-hans": "津巴布韦"
				}],
				regions: {
					AU: [{
						code: "ACT",
						name: "Australian Capital Territory"
					},
					{
						code: "NSW",
						name: "New South Wales"
					},
					{
						code: "NT",
						name: "Northern Territory"
					},
					{
						code: "QLD",
						name: "Queensland"
					},
					{
						code: "SA",
						name: "South Australia"
					},
					{
						code: "TAS",
						name: "Tasmania"
					},
					{
						code: "VIC",
						name: "Victoria"
					},
					{
						code: "WA",
						name: "Western Australia"
					}],
					CA: [{
						code: "AB",
						name: "Alberta"
					}, {
						code: "BC",
						name: "British Columbia",
						en: "British Columbia",
						fr: "Colombie-Britannique"
					}, {
						code: "MB",
						name: "Manitoba"
					}, {
						code: "NB",
						name: "New Brunswick",
						en: "New Brunswick",
						fr: "Nouveau-Brunswick"
					}, {
						code: "NL",
						name: "Newfoundland and Labrador",
						en: "Newfoundland and Labrador",
						fr: "Terre-Neuve-et-Labrador"
					}, {
						code: "NT",
						name: "Northwest Territories",
						en: "Northwest Territories",
						fr: "Territoires du Nord-Ouest"
					}, {
						code: "NS",
						name: "Nova Scotia",
						en: "Nova Scotia",
						fr: "Nouvelle-Écosse"
					}, {
						code: "NU",
						name: "Nunavut"
					}, {
						code: "ON",
						name: "Ontario"
					}, {
						code: "PE",
						name: "Prince Edward Island",
						en: "Prince Edward Island",
						fr: "Nouvelle-Écosse"
					}, {
						code: "QC",
						name: "Québec"
					}, {
						code: "SK",
						name: "Saskatchewan"
					}, {
						code: "YT",
						name: "Yukon"
					}],
					MX: [{
						code: "AG",
						name: "Aguascalientes"
					}, {
						code: "BC",
						name: "Baja California"
					}, {
						code: "BS",
						name: "Baja California Sur"
					}, {
						code: "CM",
						name: "Campeche"
					}, {
						code: "CS",
						name: "Chiapas"
					}, {
						code: "CH",
						name: "Chihuahua"
					}, {
						code: "CO",
						name: "Coahuila"
					}, {
						code: "CL",
						name: "Colima"
					}, {
						code: "DF",
						name: "Federal District"
					}, {
						code: "DG",
						name: "Durango"
					}, {
						code: "GT",
						name: "Guanajuato"
					}, {
						code: "GR",
						name: "Guerrero"
					}, {
						code: "HG",
						name: "Hidalgo"
					}, {
						code: "JA",
						name: "Jalisco"
					}, {
						code: "ME",
						name: "Mexico State"
					}, {
						code: "MI",
						name: "Michoacán"
					}, {
						code: "MO",
						name: "Morelos"
					}, {
						code: "NA",
						name: "Nayarit"
					}, {
						code: "NL",
						name: "Nuevo León"
					}, {
						code: "OA",
						name: "Oaxaca"
					}, {
						code: "PB",
						name: "Puebla"
					}, {
						code: "QE",
						name: "Querétaro"
					}, {
						code: "QR",
						name: "Quintana Roo"
					}, {
						code: "SL",
						name: "San Luis Potosí"
					}, {
						code: "SI",
						name: "Sinaloa"
					}, {
						code: "SO",
						name: "Sonora"
					}, {
						code: "TB",
						name: "Tabasco"
					}, {
						code: "TM",
						name: "Tamaulipas"
					}, {
						code: "TL",
						name: "Tlaxcala"
					}, {
						code: "VE",
						name: "Veracruz"
					}, {
						code: "YU",
						name: "Yucatán"
					}, {
						code: "ZA",
						name: "Zacatecas"
					}],
					US: [{
						code: "AL",
						name: "Alabama"
					}, {
						code: "AK",
						name: "Alaska"
					}, {
						code: "AZ",
						name: "Arizona"
					}, {
						code: "AR",
						name: "Arkansas"
					}, {
						code: "CA",
						name: "California"
					}, {
						code: "CO",
						name: "Colorado"
					}, {
						code: "CT",
						name: "Connecticut"
					}, {
						code: "DC",
						name: "District of Columbia"
					}, {
						code: "DE",
						name: "Delaware"
					}, {
						code: "FL",
						name: "Florida"
					}, {
						code: "GA",
						name: "Georgia"
					}, {
						code: "GU",
						name: "Guam"
					}, {
						code: "HI",
						name: "Hawaii"
					}, {
						code: "ID",
						name: "Idaho"
					}, {
						code: "IL",
						name: "Illinois"
					}, {
						code: "IN",
						name: "Indiana"
					}, {
						code: "IA",
						name: "Iowa"
					}, {
						code: "KS",
						name: "Kansas"
					}, {
						code: "KY",
						name: "Kentucky"
					}, {
						code: "LA",
						name: "Louisiana"
					}, {
						code: "ME",
						name: "Maine"
					}, {
						code: "MD",
						name: "Maryland"
					}, {
						code: "MA",
						name: "Massachusetts"
					}, {
						code: "MI",
						name: "Michigan"
					}, {
						code: "MN",
						name: "Minnesota"
					}, {
						code: "MS",
						name: "Mississippi"
					}, {
						code: "MO",
						name: "Missouri"
					}, {
						code: "MT",
						name: "Montana"
					}, {
						code: "NE",
						name: "Nebraska"
					}, {
						code: "NV",
						name: "Nevada"
					}, {
						code: "NH",
						name: "New Hampshire"
					}, {
						code: "NJ",
						name: "New Jersey"
					}, {
						code: "NM",
						name: "New Mexico"
					}, {
						code: "NY",
						name: "New York"
					}, {
						code: "NC",
						name: "North Carolina"
					}, {
						code: "ND",
						name: "North Dakota"
					}, {
						code: "OH",
						name: "Ohio"
					}, {
						code: "OK",
						name: "Oklahoma"
					}, {
						code: "OR",
						name: "Oregon"
					}, {
						code: "PA",
						name: "Pennsylvania"
					}, {
						code: "PR",
						name: "Puerto Rico"
					}, {
						code: "RI",
						name: "Rhode Island"
					}, {
						code: "SC",
						name: "South Carolina"
					}, {
						code: "SD",
						name: "South Dakota"
					}, {
						code: "TN",
						name: "Tennessee"
					}, {
						code: "TX",
						name: "Texas"
					}, {
						code: "UT",
						name: "Utah"
					}, {
						code: "VT",
						name: "Vermont"
					}, {
						code: "VA",
						name: "Virginia"
					}, {
						code: "WA",
						name: "Washington"
					}, {
						code: "WV",
						name: "West Virginia"
					}, {
						code: "WI",
						name: "Wisconsin"
					}, {
						code: "WY",
						name: "Wyoming"
					}]
				}
			}
			return data;
		}
	])

angular.module('app').factory
('titlesJSon'
	, function() {
		var data =
			{
				titles:
				[
					{
						code: "Mr",
						name: "Mr"
					},
					{
						code: "Mrs",
						name: "Mrs"
					},
					{
						code: "Sir",
						name: "Sir"
					},
					{
						code: "Miss",
						name: "Miss"
					},
					{
						code: "Lord",
						name: "Lord"
					}
				]
			}
		return data
	}
)
'use strict';

angular
	.module('app')
	.filter('alphabeticalByLocale', alphabeticalByLocale);

/**
 * The filter which returns a new function each time.
 * @param {Service} Utilities The service
 * @return {Array} the sorted array
 * @ngInject
 */
function alphabeticalByLocale(Utilities) {
	return function(array, property, locale, reverseOrder) {
		var collator = getIntlCollator(locale);

		if (!Array.isArray(array)) {
			return array;
		}

		return array.sort(function(a, b) {
			if (angular.isDefined(property)) {
				a = a[ property ];
				b = b[ property ];
			}

			if (angular.isDefined(reverseOrder) && Utilities.getBoolean(reverseOrder)) {
				return Utilities.localeCompare(b, a, locale, collator);
			} else {
				return Utilities.localeCompare(a, b, locale, collator);
			}
		});
	};
}

/**
 * Returns our Intl.Collator or null if not supported.
 * @public
 * @function
 * @param {String} locale The locale to compare
 * @return {Intl.Collator|null} the collator or null if not supported
 */
function getIntlCollator(locale) {
	try {
		/* eslint-disable */
		return new Intl.Collator(locale.split('-')[0]).compare;
		/* eslint-disable */
	} catch (e) {
		return null;
	}
}

angular.module('app').filter('currencyFormatter',
	function(AppData, LocaleService, $filter, Utilities) {

		return function(amount, wholeNumber) {
			// Don't process the undefined values, anything else should get processed.
			if (typeof amount == 'undefined') {
				return '';
			} else if (isNaN(Number(amount))) {
				// Could be the word 'Free'.
				return amount;
			}

			// TODO: Deprecate currencyFormatter filter
			// This is a hack until we can formally deprecate this filter
			if (AppData.usesNewLocaleMethod) {
				if (wholeNumber || Utilities.getBoolean(AppData.settings.whole_number_currency)) {
					return $filter('currency')(amount, undefined, 0);
				} else {
					return $filter('currency')(amount);
				}
			}

			// CONSTs.
			var LEFT = 'left';
			var RIGHT = 'right';

			// Local properties.
			var i,
				value,
				amountArr,
				wholeAmtStr,
				finalAmtStr = '',
				options,
				lessThanZero = amount < 0;

			if (lessThanZero) {
				amount = amount * -1;
			}

			if (angular.isDefined(AppData.currencyCode) && angular.isDefined(AppData.languageSettings)) {
				options = LocaleService.getOptionByCode(AppData.currencyCode, AppData.languageSettings);
			}

			// Use USD as default.
			if (!options) {
				options = LocaleService.getOptionByCode('USD');
			}

			// Set local references.
			symbol = options.symbol;
			decSeparator = options.decSeparator;
			thousandSeparator = options.thousandSeparator;
			symbolPlacement = options.symbolPlacement;
			precision = options.precision;
			leadingZeros = options.leadingZeros;

			if (symbolPlacement != LEFT) {
				symbolPlacement = RIGHT;
			}

			value = amount.toString().trim().replace(/^\+/, '');

			var n = Number(value);
			n = n.toFixed(precision);

			amountArr = n.split('.');
			wholeAmtStr = amountArr[0];

			var c = 0;
			for (i = wholeAmtStr.length; i > 0; i--) {
				if (c % 3 == 0 && c != 0) {
					// Is thousand separator always in the same place?
					finalAmtStr = thousandSeparator + finalAmtStr;
				}

				finalAmtStr = wholeAmtStr.charAt(i - 1) + finalAmtStr;
				c++;
			}

			if (n < 1) {
				for (i = 0; i < leadingZeros - 1; i++) {
					finalAmtStr += '0';
				}
			}
			if (wholeNumber || Utilities.getBoolean(AppData.settings.whole_number_currency)) {
				if (symbolPlacement == LEFT) {
					finalAmtStr = symbol + finalAmtStr;
				} else {
					finalAmtStr = finalAmtStr + symbol;
				}
			} else {
				if (symbolPlacement == LEFT) {
					finalAmtStr = symbol + finalAmtStr + decSeparator + amountArr[1];
				} else {
					finalAmtStr = finalAmtStr + decSeparator + amountArr[1] + symbol;
				}
			}

			if (lessThanZero) {
				finalAmtStr = '-' + finalAmtStr;
			}

			return finalAmtStr;
		}
	}

)

/**
 * # Filters
 *
 * Helpers to be used in templates to format data displayed to a user
 */

angular.module('app').filter('range', function() {
	return function(arr, lower, upper) {
		 for (var i = lower; i <= upper; i++) {
			arr.push(i);
		}
		return arr;
	};
});

angular.module('app').filter('JSONtoString', function() {
	return function(obj) {
		try {
			return JSON.stringify(obj);
		} catch (error) {
			return JSON.stringify(error);
		}
	};
});

angular.module('app').filter('truncate', ['$window', function($window) {
	return function(text, length, end, ellipsis) {
		if (!text || text == undefined) {
			return '';
		}

		if (typeof length == 'string') {
			var handler = length.split(":");
			length = $window.innerWidth <= 320 ? Number(handler[0]) : Number(handler[1]);
		}

		var str = text,
			maxChars = Number(length),
			appendEllipsis = ellipsis || true;

		if (str.length > maxChars) {
			var arr = str.split(' '), // Array of words.
				s = '', // Final string.
				lsum = 0, // Local Sum of the string length.
				i, // Iterator.
				ls; // Local String in for loop.

			for (i = 0; i < arr.length; i++) {
				ls = arr[i];
				lsum += ls.length;

				if (lsum <= maxChars) {
					if (s != '') {
						s += ' ';
					}

					s += arr[i];
				} else {
					// If we don't have at least one word, set s = to the first word.
					if (s == '') {
						s = arr[0];
					}

					break;
				}
			}

			// Append ellipsis.
			if (appendEllipsis) {
				s += "...";
			}

			return s;
		}

		// Return original string. No formatting applied.
		return str;
	};
}]);

angular.module('app').filter('maxChar', function() {
	return function(text, length, end) {
		if (isNaN(length)) {
			length = 10;
		}

		if (end === undefined) {
			end = "...";
		}

		if (typeof(text) == "undefined") {
			return;
		}

		if (text.length <= length || text.length - end.length <= length) {
			return text;
		} else {
			return String(text).substring(0, length-end.length) + end;
		}
	};
});

angular.module('app').filter('rightSubstring', function() {
	return function(value, length) {
		var string = '' + value;
		return string.substring(string.length - length);
	};
});

angular.module('app').filter('leadingZeros', function() {
	return function(value, length) {
		var string = '' + value;
		while (string.length < length) {
			string = '0' + string;
		}
		return string;
	};
});

angular.module('app').filter('camelCase', function() {
	return function(text) {
		var str = text.toLowerCase();
		var arr = str.split(" ");
		str = arr[0];
		for (i in arr) {
			if (i > 0) {
				str += arr[i].charAt(0).toUpperCase() + arr[i].slice(1);
			}
		}
		return str;
	};
});

angular.module('app').filter('localize', ['$filter', function($filter) {
	return function(text) {
		return $filter('date')(text, 'fullDate');
	};
}]);

angular.module('app').filter('encodeURIComponent', function() {
	return function(o) {
		return encodeURIComponent(o);
	};
});

angular.module('app').filter('setupCartFlagsOnItems', function(ExtraFlow, Package, Utilities, UtilsValidation, WTPService) {
	return function(items) {
		var checkProp = Utilities.checkProp;
		// If items is undefined, we cannot loop through it.
		// return what was passed to the filter
		if (angular.isUndefined(items)) {
			return items;
		}

		for (var i = 0; i < items.length; i++) {
			var item = items[i];
			var characs = item.characs || Utilities.wrapObjectToArray(item.CHARACS, true);

			var package;
			var editable = undefined;
			var lockQuantity = false;
			var disableEditing = false;

			if (checkProp('item.package.id', item, 'validNumber')) {
				package = Package.getPackageByID(item.package.id);
			} else {
				package = Package.getPackageDetailsForCartItem(item);
			}

			if (UtilsValidation.validArray(characs)) {
				// This segment of code is explicitly for altenrate modules / alternate flows (starts to flows that are unique)
				var alternateModuleName = checkProp('characs[0].client_alternate_name', characs[0]) ? characs[0].client_alternate_name : undefined;

				if (!WTPService.isCartItemQuantityModifiable(characs)) {
					lockQuantity = true;
				} else if (angular.isDefined(alternateModuleName) && checkProp('ExtraFlow.' + alternateModuleName + '.lockQuantity', ExtraFlow)) {
					lockQuantity = ExtraFlow[alternateModuleName].lockQuantity;
				}

				if (!lockQuantity) {
					var moduleName = checkProp('characs[0].client_xfc_name', characs[0]) ? characs[0].client_xfc_name : undefined;

					if (angular.isDefined(moduleName)) {
						lockQuantity = (ExtraFlow.getEditableXMCsFromList(moduleName, 'lockQuantity').length > 0);
					}
				}

				if (checkProp('characs[0].disable_edit_mode', characs[0], 'getBoolean')) {
					disableEditing = true;
				} else if (checkProp('characs[0].start_date', characs[0], 'validString')) {
					disableEditing = true;
					lockQuantity = true;
				}
			}

			// this segment of code is explicitly for extra movies
			if (package !== undefined || (UtilsValidation.validArray(characs) && angular.isDefined(characs[0].client_xfc_name))) {
				var extraMovieList = angular.isDefined(package) ? package.extra_movie : characs[0].client_xfc_name;
				editable = ExtraFlow.getEditableXMCsFromList(extraMovieList, 'doEditMode');
			}

			if (editable == undefined || editable.length == 0) {
				item.itemHasAnEditableXMC = false;
			} else {
				item.itemHasAnEditableXMC = !disableEditing;
			}

			// item must NOT have an editable XMC AND lockQuantity should be false
			item.itemCanHaveQtyChanged = (item.itemHasAnEditableXMC === false && lockQuantity === false);

			// comps cannot have their quantity changed
			if (angular.isDefined(item.action) && item.action.toLowerCase() == 'comp') {
				item.itemCanHaveQtyChanged = false;
			}

			item.showDeleteBtn = (!item.action || (item.action && item.action.toLowerCase() != 'comp'));
		}
		return items;
	};
});

"use strict";

angular.module('app')
	.filter('filterByDeviceType',
		function(
			ClientInfo,
			Utilities
		) {
			var filter = function(arr) {
				if (!arr) {
					return;
				}

				var newArray = [];
				for (var i = 0; i < arr.length; i++) {
					var item = arr[i];

					if (Utilities.safelyCheckPropertyOnObject('item.CHARACS', item, angular.isObject)) {
						if (Utilities.getBoolean(item.CHARACS.exclude_desktop) && ClientInfo.deviceType === 'desktop') {
							continue;
						}

						if (Utilities.getBoolean(item.CHARACS.exclude_mobile) && ClientInfo.deviceType === 'mobile') {
							continue;
						}

						if (Utilities.getBoolean(item.CHARACS.exclude_tablet) && ClientInfo.deviceType === 'tablet') {
							continue;
						}
					}

					newArray.push(item);
				}

				return newArray;
			};
			return filter;
		});

/**
 * # Telephone Number Filter
 *
 * A filter that formats a telephone number.
 */

angular.module('app').filter('telephoneNumber', [
	'$log',
	function($log) {
		return function(tel) {
			if (!tel) {
				return ''
			}

			var value = tel.toString().trim().replace(/^\+/, '')

			if (value.match(/[^0-9]/)) {
				return tel
			}

			var areaCode,
				firstThree,
				lastFour

			switch (value.length) {
			case 10: // +1PPP####### -> C(PPP) ###-####
				areaCode = 1
				firstThree = value.slice(0, 3)
				lastFour = value.slice(3)
				break

			case 11: // +CPPP####### -> CCC(PP) ###-####
				areaCode = value[0]
				firstThree = value.slice(1, 4)
				lastFour = value.slice(4)
				break

			case 12: // +CCCPP####### -> CCC(PP) ###-####
				areaCode = value.slice(0, 3)
				firstThree = value.slice(3, 5)
				lastFour = value.slice(5)
				break

			default:
				return tel
			}

			if (areaCode == 1) {
				areaCode = ""
			}

			lastFour = lastFour.slice(0, 3) + '-' + lastFour.slice(3)
			return ("(" + firstThree + ") " + lastFour).trim()
			//return(areaCode + "(" + firstThree + ") " + lastFour).trim()
		}
	}]);

"use strict";

angular.module('app')
	.filter('partition', function() {
		var cache = {};
		var filter = function(arr, size) {
			if (!arr) {
				return;
			}

			var newArray = [];
			var arrayLength = arr.length;
			for (var i = 0; i < arrayLength; i += size) {
				newArray.push(arr.slice(i, i + size));
			}

			var arrString = JSON.stringify(arr);
			var fromCache = cache[arrString + size];
			if (JSON.stringify(fromCache) === JSON.stringify(newArray)) {
				return fromCache;
			}

			cache[arrString + size] = newArray;
			return newArray;
		};
		return filter;
	});
"use strict";

angular.module('app')
	.filter('ignoreOneBarcodeAddons', function() {
		var filter = function(arr, size) {
			if (!arr) {
				return;
			}

			var newArray = [];
			for (var i = 0; i<arr.length; i++) {
				var item = angular.copy(arr[i]);
				var characs = item.characs || item.CHARACS;

				if (characs) {
					if (angular.isArray(characs)) {
						characs = characs[0];
					}

					if (angular.isDefined(characs)
					   && !characs.hasOwnProperty("one_barcode_parent")
					   && characs.hasOwnProperty("group_uuid")) {
						continue;
					}
				}


				newArray.push(item);
			}

			return newArray;
		};

		return filter;
	});
(function() {
	'use strict';

	angular
		.module('app')
		.filter('replaceVars', replaceVars);

	/**
	 * replaceVars filter
	 * @param {Service} AppData
	 * @param {Service} UtilsValidation
	 * @returns {Filter}
	 * @ngInject
	 */
	function replaceVars(AppData, UtilsValidation) {
		var validObject = UtilsValidation.validObject;

		/**
		 * The default list of key/value pairs made available to replace
		 * @type {Object}
		 * @constant
		 */
		var defaultReplace = { merchantName: AppData.merchantName };

		/**
		 * Closure function to handle replacement of locale variables
		 * @example 'Welcome to {{merchantName}}' -> 'Welcome to Some Merchant'
		 * @param {String} input The input to transform
		 * @param {Object} [externalReplace] The Object with extra key/value pairs to replace in the input
		 * @returns {String} The modified input
		 */
		return function(input, externalReplace) {
			var replace = angular.copy(defaultReplace);

			if (!angular.isString(input)) {
				return '';
			}

			if (validObject(externalReplace)) {
				angular.merge(replace, externalReplace)
			}

			Object.keys(replace).forEach(function(key) {
				input = input.replace(new RegExp('@@' + key, 'gi'), replace[key]);
			});

			return input;
		};
	}
})();

(function() {
	'use strict';
	/*
	* Filter that sets the required value of the input field via config value.
	*
	* Example Usage:
	* <input type="text"
	* 	ng-required="fieldSettings.required | requiredByConfig : 'first_name_required'" />
	*
	* first_name_required is the key to search in AppData.GetApplicationConsolidated.SETTINGS. If
	* that property exists, a boolean value is evaluated and returned. Otherwise, the initial value
	* is returned. In the example above, if first_name_required is not defined, it will return the
	* value of fieldSettings.required.
	*
	* Optionaly pass a visible expression:
	*
	* <input type="text"
	* 	ng-required="fieldSettings.required | requiredByConfig : 'first_name_required':fieldSettings.visible" />
	*
	* If it's not visible, then it's not required.
	*
	*/

	angular.module('app').filter
	('requiredByConfig',
		function(AppData, Utilities) {
			return function(initialValue, configKey, visible) {
				if (angular.isDefined(visible) && !visible) {
					// If the input is hidden, we don't want to require it.
					return false;
				}

				// Get the config setting. If available, overwrite the default.
				if (angular.isDefined(AppData.settings[ configKey ])) {
					// A config exists for this field. Return the value of the config.
					return Utilities.getBoolean(AppData.settings[ configKey ]);
				} else {
					// Return the initial required value
					return initialValue;
				}
			}
		}
	);
})();


(function() {
	'use strict';

	angular
		.module('app')
		.config(dateOverride);

		/**
		 * Date filter override to use LocalizationService date formats
		 * @param {Service} $provide - The angular provide service
		 * @returns {undefined}
		 * @ngInject
		 */
		function dateOverride($provide) {
			// Override the date filter
			$provide.decorator('dateFilter', function($delegate, LocalizationService) {
				// Set the date filter method to use to the original date filter
				LocalizationService.setDateFilter($delegate);

				// Return a new date filter function that uses LocalizationService to format dates
				return function dateFilterLocalizationOverride(input, format) {
					return LocalizationService.formatDate(input, format);
				};
			});
		}
})();
/**
 * @ngdoc function
 * @name shoplandApp.controller:AddrLookupResultsCtrl
 * @description
 * # AddrLookupResultsCtrl
 * Controller of the shoplandApp
 */
angular
	.module('app')
	.controller('AddrLookupResultsCtrl', function(
		$uibModalInstance,
		$scope,
		$rootScope,
		AddrLookup,
		ClientInfo,
		Language
	) {
		//scope variables
		$scope.i18n = Language;

		/**
			 * cancel - discard the modal from view
			 * @public
			 */
		$scope.cancel = function() {
			$rootScope.modalOpen = false
			$uibModalInstance.dismiss('cancel')
		}

		/**
			 * select - select a particular address to use from the results
			 * @public
			 * @param {Number} $index of result to use
			 */
		$scope.select = function($index) {
			$scope.currentSelectedResult = $index;
		}

		/**
			 * isSelected - given an index, returns whether or not an item is selected (for css on view)
			 * @public
			 * @param {Number} $index of result to use
			 * @return true if selected
			 */
		$scope.isSelected = function($index) {
			if (currentPage == $index) {
				return true;
			}
			return false;
		}

		/**
			 * paginateDirection - move up or down a page (positive numbers move up, negative down)
			 * used for paging through results and showing results on modal
			 * @public
			 * @param {Number} incremental value to indicate paging up or down
			 */
		$scope.paginateDirection = function(pageUpDown) {
			var newPage = $scope.currentPage + pageUpDown;

			if ((pageUpDown === 1 && newPage < $scope.totalPages) || (pageUpDown === -1 && newPage >= 0)) {
				$scope.currentPage = newPage;
			}
		}

		/**
			 * goToPage - given an index, display a certain page
			 * @public
			 * @param {Number} $index of page to go to
			 */
		$scope.goToPage = function($index) {
			$scope.currentPage = $index;
		}

		/**
			 * showResult - given an index, show a particular address result on a page
			 * @public
			 * @param {Number} $index of address result
			 * @return true if index falls between threshold for view to display
			 */
		$scope.showResult = function($index) {
			var relIndex = $index + 1;
			var lowerThreshold = $scope.perPageAmt * $scope.currentPage;
			var upperThreshold = $scope.perPageAmt * ($scope.currentPage +1);
			if (relIndex > lowerThreshold && relIndex <= upperThreshold) {
				return true;
			}

			return false;
		}

		/**
			 * enterAddrManually - return to address view and enter fields manually, this discards the current modal
			 * @public
			 */
		$scope.enterAddrManually = function() {
			$rootScope.modalOpen = false;
			$uibModalInstance.close(false);
		}

		/**
			 * chooseAddrAndContinue - choose an address and continue on through the process
			 * @public
			 */
		$scope.chooseAddrAndContinue = function() {
			if ($scope.currentSelectedResult != -1) {
				//save off results in AddrLookup service
				$rootScope.modalOpen = false;
				$uibModalInstance.close($scope.results[$scope.currentSelectedResult]);
			}
		}

		$rootScope.$on('hidePreviousModals', function() {
			$rootScope.modalOpen = false;
			$uibModalInstance.close('');
		});

		/**
			 * init - initializes this modal controller
			 * @public
			 */
		function init() {
			var addrResults = AddrLookup.getSearchResultsData();
			$scope.results = addrResults.length > 0 ? addrResults.filter(function(item, index) {
				return index < AddrLookup.getMaxResultsAmount();
			}) : [];

			$scope.currentSelectedResult = -1;
			$scope.currentPage = 0;
			$scope.pageArray = [];
			$scope.perPageAmt = ClientInfo.deviceType != "mobile" ? 5 : 3;
			$scope.totalPages = Math.ceil($scope.results.length/$scope.perPageAmt);
			$scope.header = Language.getLocale('FormLabels', 'searchResultsHeader(' + $scope.results.length + ')');

			for (var i = 0; i < $scope.totalPages; i++) {
				$scope.pageArray.push(i+1);
			}
		}

		init();
	}
	);

'use strict';
angular
	.module('app')
	.controller('BillingCtrl', function(
		$document,
		$filter,
		$location,
		$rootScope,
		$scope,
		$state,
		$timeout,
		$window,
		AddrLookup,
		AgreementService,
		AppData,
		BillingService,
		CreditCardBinRangesService,
		CustomActionService,
		errorTracking,
		CartDataService,
		CartService,
		LegacyCart,
		CartAbandonmentService,
		CyberSourceCreditCardsService,
		CreditCardService,
		countriesJSon,
		Enums,
		FocusService,
		GuestAppUiService,
		Language,
		JSONValidator,
		Modal,
		Storage,
		titlesJSon,
		UserInfo,
		Utilities,
		JCBCardService,
		DankortCardService,
		DinersClubCardService,
		FormValidation,
		StoredValueCardPrepService,
		UtilsValidation,
		StoredPaymentPrepService,
		StringUtils,
		ShippingService,
		PhoneNumberService
	) {
		var validString = UtilsValidation.validString;
		var isRealObject = UtilsValidation.isRealObject;
		var isEmptyObject = UtilsValidation.isEmptyObject;
		var validArray = UtilsValidation.validArray;
		var returnOrDefault = UtilsValidation.returnOrDefault;
		var safelyCheckPropertyOnObject = Utilities.safelyCheckPropertyOnObject;
		var getLocaleWithSuffixAndFallback = Language.getLocaleWithSuffixAndFallback;
		var wrapObjectToArray = Utilities.wrapObjectToArray;
		var getLocale = Language.getLocale;
		var getBoolean = Utilities.getBoolean;
		var MERCHANT_ID = AppData.merchantId;
		var sessionId = AppData.cart.session_id;
		var EnumsOK = Enums.buttonFlags.OK;

		//Email Options that doesn't change
		$scope.emailOptions = {
			autoCapitalize: 'off',
			cyEmail: 'billing_email',
			enableEmailVerification: JSONValidator.validate('enableEmailVerification', AppData.settings.enableEmailVerification),
			emailPatternError: $scope.i18n.FormValidation.emailPatternError,
			emailRequiredError: $scope.i18n.FormValidation.emailRequiredError,
			maxLength: '50',
			placeholder: $scope.i18n.FormLabels.email,
			validationType: 'email',
			label: $scope.i18n.FormLabels.email
		};
		$scope.getRequiredCountry = getRequiredCountry;
		$scope.hasCyberSourceCreditCards = CyberSourceCreditCardsService.hasCreditCards();
		$scope.hasAdyenCreditCards = CreditCardService.hasAdyenCreditCards();
		$scope.useJapaneseAddressSyntax = AppData.useJapaneseAddressSyntax();
		$scope.captureAbandonment = captureAbandonment;
		$scope.onEmailAddressChange = onEmailAddressChange;
		$scope.onEmailVerificationFailed = onEmailVerificationFailed;
		$scope.onEmailVerificationSuccess = onEmailVerificationSuccess;
		$scope.setContinueLoading = setContinueLoading;
		$scope.onEmailVerifying = onEmailVerifying;
		$scope.providers = [];
		$scope.enhancedPhoneConfigs = {};
		$scope.disablePhoneNumber = false;
		$scope.suppress = false;
		$scope.clipForOptins = false;
		$scope.maestroEnabled = getBoolean(AppData.settings.display_maestro);
		$scope.getAssetsUrl = $rootScope.getAssetUrl;
		$scope.isMobile = $scope.clientInfo.deviceType === Enums.deviceType.MOBILE;
		// Retrieve all the card types
		$scope.cardTypes = LegacyCart.getCardTypesToDisplay();
		$scope.useAddrLookup = AppData.use_addr_lookup;
		$scope.personalInfoSectionHeader = getLocale('BillingView', 'personalInfoSection').length > 0 ? getLocale('BillingView', 'personalInfoSection') : getLocale('FormLabels', 'personalInfoSection');
		$scope.addressSectionHeader = getLocale('BillingView', 'addressSection').length > 0 ? getLocale('BillingView', 'addressSection') : getLocale('FormLabels', 'addressSection');

		$scope.hasDeliveryMethods = Storage.get('_deliveryMethods');
		$scope.showRegion = angular.isDefined(AppData.settings.show_region)
			? getBoolean(AppData.settings.show_region)
			: true;

		$scope.zipType = 'tel';
		$scope.useShipAddr = '0';
		$scope.emailType = 'email';

		// Whether seelcted CC is valid based on cardOverrides.
		$scope.invalidCCType = false;
		$scope.validCardTypes = {};
		$scope.shipping = UserInfo.shipping || {};
		//set in view the validated email
		$scope.validateEmail = true;

		$scope.isNonPhysicalDeliveryMethod = ShippingService.isNonPhysicalDeliveryMethod($scope.shipping.deliveryMethod);

		//set the min/max of creditcards
		$scope.ccMin = 12;
		$scope.ccMax = 19;

		$scope.zeroDollarBillingId = BillingService.zeroDollarBillingId;

		$scope.optins = [];
		$scope.titles = titlesJSon;
		$scope.countries = AppData.countries;
		$scope.regions = countriesJSon.regions;
		$scope.billingSources = BillingService.billingSources;

		$scope.hidePrepaidInfo = hidePrepaidInfo();

		$scope._setEmailType = _setEmailType;
		$scope._getPaymentLastFour = _getPaymentLastFour;
		$scope._getBillingType = _getBillingType;
		$scope._checkForMatchingBillingType = _checkForMatchingBillingType;
		$scope._performMisterCashCheckAndDeregister = _performMisterCashCheckAndDeregister;

		// Common function for hosted fields
		$scope.onHostedFieldsSetupError = onHostedFieldsSetupError;
		$scope.onCreatePaymentTokenFailure = onCreatePaymentTokenFailure;

		// For the cybersource-credit-card component
		$scope.onFormValidity = onFormValidity;
		$scope.onResetCreateToken = onResetCreateToken;
		$scope.onMicroformTokenCreated = onMicroformTokenCreated;
		$scope.onSubmitCreditCardForm = onSubmitCreditCardForm;
		$scope.onCreateJwkFailure = onHostedFieldsSetupError;
		$scope.onCreateTokenFailure = onCreatePaymentTokenFailure;
		$scope.onMicroformSetupFailure = onHostedFieldsSetupError;
		$scope.onResetFormSubmitted = onResetFormSubmitted;
		$scope.requestMicroformToken = false;
		$scope.getRouteToStateOrCartCallback = getRouteToStateOrCartCallback;

		// For adyen-credit-card-component
		$scope.onEncryptedCardDataReceived = onEncryptedCardDataReceived;
		$scope.onAdyenFormValid = onAdyenFormValid;
		$scope.onSecuredFieldsSetupError = onHostedFieldsSetupError;

		/* PaymentCtrl.js*/
		$scope.currentYear = Language.currentYear;
		$scope.currentMonth = Language.currentMonth;
		$scope.hasPaymentPlan = CartService.hasPaymentPlan();
		$scope.hasGiftCardPaymentMethodConfigured = BillingService.shouldPresentGiftCardOption();
		$scope.creditCardOptional = getBoolean(StoredValueCardPrepService.config.optionalCreditCardView);
		$scope.svcIsOptional = getBoolean(StoredValueCardPrepService.config.svcIsOptional);
		$scope.showGiftcardInput = angular.copy($scope.creditCardOptional) && !$scope.svcIsOptional;

		$scope.alternateCardCapturePaymentFields = [];

		/* Form Validation Utilities */
		$scope.inputHasError = FormValidation.inputHasError;
		$scope.inputShowError = FormValidation.inputShowError;
		$scope.regionList = [];
		$scope.loadStateOptions = loadStateOptions;

		/**
		 * Used for deciding to show the "Copy from Model" behavior
		 * @public
		 * @type {Boolean}
		 */
		$scope.userIsLoggedIn = false;

		/**
		 * Object that can dictate whether or not we can configure copying a model to another model
		 * @type {object}
		 */
		$scope.copyFromOtherModelInfo = angular.copy(AppData.populateBillingShippingModelInfo);

		/**
		 * Handle when the user clicks on the button to copy information to the billing/shipping model from another model (e.g. profile)
		 * @return {undefined}
		 */
		$scope.handleOptionToCopyFromOtherModelChanged = function() {
			if ($scope.copyFromOtherModelInfo.copyFromOtherModelAction && $scope.copyFromOtherModelInfo.shouldCopyFromOtherModel) {
				$scope.copyFromOtherModelInfo.copyFromOtherModelAction($scope.billing);
				$scope.disableIfPopulated = getBoolean(AppData.settings.disable_prepopulated_billing_fields);
			}

			GuestAppUiService.triggerMDCTextFieldLayout();
		}

		/**
		 * Used to determine whether or not we should show the 'Save Payment' checkbox
		 * @protected
		 * @type {boolean}
		 */
		$scope.storedPaymentsConfigured = StoredPaymentPrepService.storedPaymentsIsConfigured();
		$scope.savePaymentFlag = false;

		/**
		 * A regex for testing if an email is valid or not.
		 * @protected
		 * @type {RegEx}
		 */
		var validEmailRegex = FormValidation.getEmail();

		/**
		 * Holds the $timeout Promise for the CartAbandonment autocapture call so we can cancel it if we need to debounce.
		 * @private
		 * @type {Promise}
		 */
		var cartAbandonmentDebounce;

		/**
		 * Holds the last email address sent to cart abandonment so we do not send it multiple times if its the same.
		 * @private
		 * @type {String}
		 */
		var cartAbandonmentLastEmail;

		/**
		 * if expYearsRanges app config exists and is valid, then use it for the year range, if not, then default it to 10
		 * Maximum this config can go to is 50
		 * @type {number}
		 */
		var expYearsRange = JSONValidator.validate('expYearsRange', AppData.settings.expYearsRange) ? JSON.parse(AppData.settings.expYearsRange) : 10;

		/**
		 * The YEAR ranges
		 * @type {Array}
		 */
		$scope.range = $filter('range')([], $scope.currentYear, $scope.currentYear + expYearsRange);

		var _timer = null;
		var select = Utilities.getObject('#country-select');
		var merchantDetailsData = AppData.GetMerchantDetails;

		/**
		 * Set email type based on validation
		 * @protected
		 * @returns {undefined}
		 */
		function _setEmailType() {
			if (JSONValidator.validate('disable_form_validation', AppData.settings.disable_form_validation)) {
				$scope.emailType = 'text';
			}
		}

		/**
		 * Perform Mistercash check
		 * Deregisters card capture if user reloads on billing view
		 * @public
		 * @returns {undefined}
		 */
		function _performMisterCashCheckAndDeregister() {
			var savedBillingType = UserInfo.billingType,
				mrCashAuthType = Enums.authTypes.MISTERCASH;
			if (safelyCheckPropertyOnObject('savedBillingType.billing_type', savedBillingType, validString) && savedBillingType.billing_type === Enums.billingTypes.MISTERCASHMOBILE && BillingService.isCardCaptureAuthType(mrCashAuthType)) {
				BillingService.deregisterCardCaptureAuthType(mrCashAuthType);
			}
		}

		/**
		 * Returns a country code otherwise undefined.
		 * @public
		 * @param {Object[]} cartItems The cart items
		 * @returns {String} A string if we require a country, otherwise empty string
		 */
		function getRequiredCountry(cartItems) {
			var requireCountryIndex,
				CHARAC_KEY = 'require_country_zip',
				i = 0,
				count,
				itemCharacs,
				settings;

			if (AppData.settings.require_country_zip && JSONValidator.validate('require_country_zip', AppData.settings.require_country_zip)) {
				settings = JSON.parse(AppData.settings.require_country_zip);
				if (settings.disable) {
					return '';
				}
			}

			if (!validArray(cartItems)) {
				return '';
			}

			requireCountryIndex = cartItems.findIndex(function(item) {
				return item.characs.some(function(charac) {
					return charac.hasOwnProperty(CHARAC_KEY);
				});
			});

			if (requireCountryIndex > -1) {
				itemCharacs = cartItems[requireCountryIndex].characs;
				count = itemCharacs.length;
				for (; i < count; i++) {
					if (itemCharacs[i].hasOwnProperty(CHARAC_KEY) && validString(itemCharacs[i][CHARAC_KEY])) {
						return itemCharacs[i][CHARAC_KEY].toUpperCase();
					}
				}
			}

			return '';
		}

		/**
		 * Initialize Billing Controller
		 * @protected
		 * @returns {undefined}
		 */
		function InitializeCtrl() {
			var cartSummary = CartDataService.getLastSummary(),
				normalize = StringUtils.normalize,
				cartOptinsConfig = JSONValidator.validate('cartOptins', AppData.settings.cartOptins) ? JSON.parse(AppData.settings.cartOptins) : {},
				requiredCountry;
			$scope._setEmailType();
			setBillingAd();

			$scope.requiredCountry = $scope.getRequiredCountry(cartSummary.cart.items);
			if (validString($scope.requiredCountry)) {
				requiredCountry = AppData.countries.find(function(country) {
					return normalize(country.code) === normalize($scope.requiredCountry);
				}) || {};
				$scope.requiredCountryError = getLocale('Billing', 'requiredCountryZip').replace(/@@country/gi, requiredCountry.name);
			}

			//no cart items? go home, you're drunk.
			if (!$scope.hasItemsInCart()) {
				$scope.routeTo(Enums.routes.LIST);
				return;
			}

			// Set the billing information to the data stored in AppData.
			$scope.billing = angular.copy(UserInfo.billing) || {};
			$scope.billing.phone = ((($scope).billing || {}).phone || '');
			$scope.billing.countryCode = ((($scope).billing || {}).countryCode || '');
			$scope.billing.regionCode = ((($scope).billing || {}).regionCode || '');

			//create payment.ccType empty, avoid error within directive
			$scope.payment = {};
			$scope.secAcctInfo = {};
			$scope.payment.ccType = typeof($scope.payment.ccType) == 'undefined'?'phcard':$scope.payment.ccType;
			$scope.payment.cvvRequired = true;
			$scope.payment.expDateRequired = true;
			$scope.payment.type = UserInfo.payment.type;
			$scope.authType = UserInfo.payment.authType;
			$scope.isContinueLoading = false;
			$scope.isEmailVerificationComplete = false;

			if (isRealObject(UserInfo.billingType)) {
				$scope.billingType = UserInfo.billingType.billing_type;
			}
			setSMSVerificationConfigs();
			$scope._performMisterCashCheckAndDeregister();

			$rootScope.$broadcast('triggerCheckoutBilling', $scope.shipping.deliveryMethod);

			//set the checkmark for useShipAddress if available from localStorage
			$scope.useShipAddr = typeof($scope.billing.useShipAddr) == 'undefined'?'0':UserInfo.billing.useShipAddr;

			$scope.optins = [];

			$scope.validCardTypes = getValidCardTypes();

			$scope.accountMinMaxLengthError = getLocale('FormValidation', 'ccMinMaxLengthError');

			if (angular.isUndefined(AppData.settings.validate_email)) {
				$scope.validateEmail = true;
			} else {
				$scope.validateEmail = getBoolean(AppData.settings.validate_email);
			}

			//set the numeric position of the header placement and value, this will determine 1 shipping, 2 billing, 3 review
			$scope.arrowPositioning = $scope.hasDeliveryMethods ? 2 : 1;

			// Set default country.
			$scope.setDefaultCountry();

			// Set the zipType based on the selected country
			$scope.setZipType($scope.billing.country);

			//set activated address lookup first based on useAddrLookup and whether or not the showAddrLookupForm has been left on from previous uses
			$scope.addrLookupActivated = $scope.useAddrLookup && AddrLookup.getShowAddrLookupOnNextForm() && AddrLookup.isAddrLookupCountry($scope.billing.country);

			//indicator to allow user to switch to address lookup directive in case they would like to look up another address
			$scope.showAddrSearchBtnOnForm = $scope.useAddrLookup && AddrLookup.isAddrLookupCountry($scope.billing.country);

			for (var i in AppData.optins) {
				if (AppData.optins[i].section == 'BillingView' && !cartOptinsConfig.enable) {
					$scope.optins.push(angular.copy(AppData.optins[i]));
				}
			}

			if ($scope.billing.country === 'CA' && angular.isDefined(AppData.settings.email_default_opt_out) && getBoolean(AppData.settings.email_default_opt_out) === true) {
				$scope.turnOptInsOff();
			}

			// add "secure providers" to make available in $scope.providers
			initSecureProviders();

			populateBillingWithAffiliateInfo();

			$scope.initDebugValues();

			initializeOptins();

			// we no longer need to do the paymentformSuppressionCheck because this was only previously used to display the Idealbanklist for Datacash
			 	// The IdealBankList view and Mistercash specific routing has been moved to its own module within the billing modules
			// paymentFormSuppressionCheck();

			//If billing has previously been completed, clean that out.
			if (Storage.get('_billingComplete')) {
				Storage.remove('_billingComplete', true);
				$scope.continueToPaymentInformation()
			}

			//does selected authType need to show address fields? if not, then hide it
			$scope.hideAddressFields = BillingService.hideAddressFieldsCheck(UserInfo.payment.authType) || BillingService.isRemovedField('addressFields', UserInfo.payment.authType);

			$scope.hideSpinner();

			if (angular.isObject($scope.copyFromOtherModelInfo) && angular.isFunction($scope.copyFromOtherModelInfo.shouldAllowCopy)) {
				$scope.handleOptionToCopyFromOtherModelChanged();
				// Don't treat this as the user being logged in, if the data was populated from the TE2 process
				$scope.userIsLoggedIn = $scope.copyFromOtherModelInfo.shouldAllowCopy() && !$scope.billing.nonProfilePopulated;
			}
			$scope.loadStateOptions();
		}

		$scope.setDefaultCountry = function() {
			if (!$scope.billing.country) {
				$scope.billing.country = AppData.defaults.country;
			}
		}

		/**
		 * Sets up optins and sets the labels
		 * @protected
		 * @returns {undefined}
		 */
		function initializeOptins() {
			var i = 0,
				section = '',
				target = '';
			// Store the localized label as part of the optin object.
			for (i = 0; i < $scope.optins.length; i++) {
				section = $scope.optins[i].section;
				target = $scope.optins[i].target;
				$scope.optins[i].label = getLocale(section, target).replace('@@park', AppData.settings.merchant_name);
				if ($scope.optins[i].label.indexOf('<a') != -1 && $scope.optins[i].label.indexOf('href=') != -1) {
					$scope.clipForOptins = true;
				}
				if (angular.isString($scope.optins[i].data_collection)) {
					target = $scope.optins[i].data_collection_target;
					$scope.optins[i].dataCollectionLabel = getLocale(section, target).replace('@@park', AppData.settings.merchant_name);
					$scope.optins[i].showDateCollection = $scope.optins[i].data_collection === 'date';
				}
			}
		}

		/**
		 * Handle checking/unchecking optins
		 * @public
		 * @param {Object} optin optin object
		 * @returns {undefined}
		 */
		$scope.handleOptins = function(optin) {
			if (!optin.required) {
				optin.checked = !optin.checked;
			}
		}

		/**
		 * Update phone number
		 * @public
		 * @param {String} phone phone number
		 * @param {String} countryCode country code
		 * @param {String} regionCode region code
		 * @returns {undefined}
		 */
		$scope.onPhoneNumberChanged = function(phone, countryCode, regionCode) {
			if (isRealObject($scope.billing)) {
				$scope.billing.phone = phone;
				$scope.billing.countryCode = countryCode;
				$scope.billing.regionCode = regionCode;
			}
		}

		/**
		 * Set SMS Verification Configs
		 * @protected
		 * @returns {undefined}
		 */
		function setSMSVerificationConfigs() {
			var enhancedPhoneConfigs = $scope.enhancedPhoneConfigs;
			var smsConfig = JSONValidator.validate('sms_verification', AppData.settings.sms_verification) ? JSON.parse(AppData.settings.sms_verification) : {};
			var ehpConfig = PhoneNumberService.getEnhancedPhoneConfig();
			enhancedPhoneConfigs.useEnhancedPhoneNumber = false;
			enhancedPhoneConfigs.displayFlags = false;
			$scope.disablePhoneNumber = false;
			if (!isEmptyObject(smsConfig)) {
				enhancedPhoneConfigs.useEnhancedPhoneNumber = getBoolean(smsConfig.use_enhanced_phone_number);
				enhancedPhoneConfigs.displayFlags = getBoolean(smsConfig.display_flags);
				if (smsConfig.enable_sms_verification) {
					$scope.disablePhoneNumber = true;
				}
			} else if (!isEmptyObject(ehpConfig)) {
				enhancedPhoneConfigs.useEnhancedPhoneNumber = getBoolean(ehpConfig.use_enhanced_phone_number);
				enhancedPhoneConfigs.displayFlags = getBoolean(ehpConfig.display_with_flags);
			}
		}

		/**
		 * Self Executing method used to build an array of card overrides if available
		 * on any cart items, otherwise returns an array of cardTypes
		 * @return {Array} 	  An array of Card Types available based on cartItems and characs
		 *                    ex: ['VISA'];
		 *
		 * @todo Consider moving to Billing (service)
		 */
		var cardOverrides = (function() {
			var billingTypes = AppData.billingTypes;
			var cardCount = billingTypes.length;
			var cardTypes = [];
			var i = 0;
			// Set a filter to the card Types by the user selected payment method. Default to credit card.
			var billingTypesFilter = UserInfo.payment.authType || Enums.billingTypes.CREDITCARD;
			var cardOverride =
					(function() {
						var cartSummary = CartDataService.getLastSummary();

						// Get the card override if it exist in the CHARACS of any of the items in the cart.
						for (var i = 0; i < cartSummary.cart.items.length; i++) {
							var item = cartSummary.cart.items[ i ];
							for (var j = 0; j < item.characs.length; j++) {
								for (var key in item.characs[ j ]) {
									if (key == 'card_type_required') {
										return item.characs[ j ][ key ];
									}
								}
							}
						}
						return '';
					})();


			for (; i < cardCount; i++) {
				// Including only the credit cards. Excludes paypal from list.
				if (billingTypes[i].auth_type === billingTypesFilter) {
					if (cardOverride === '' || billingTypes[i].card_type_code === cardOverride) {
						cardTypes.push(billingTypes[i].name);
					}
				}
			}

			return cardTypes;
		}());

		/**
		 * Event Watcher for "GOOGLEZIP" to trigger input field value propogation
		 * @param  {Object} event the GOOGLEZIP event
		 * @param  {Object} data 	the event data
		 *                        ex: { country:'US', city:'City Name', state:'FL'}
		 */
		$scope.$on('GOOGLEZIP', function(event, data) {
			// We only want to allow GOOGLEZIP if the addresslookup directive is not showing
			if (!$scope.addrLookupActivated) {
				$scope.billing.country = data.country;
				$scope.billing.city = data.city;
				$scope.billing.state = data.state;
			}
		});

		function performBillingInformationVerification() {
			if (!verifyOptins()) {
				$scope.hideSpinner();
				return;
			}

			copyEmailToVerify();

			// Determine if we have payment plan. This will toggle 'Order Review' button vs 'Continue' in payment screen.
			$scope.billingForm.submitted = true;
			capitalizeFirstAndLastName();

			if ($scope.useAddrLookup && $scope.addrLookupActivated) {
				AddrLookup.showAddrLookupIncompleteModal();
			} else if ($scope.billingForm.$valid) {
				// Store the Billing Data
				UserInfo.set('billing', $scope.billing);

				$rootScope.$broadcast('triggerCheckoutPaymentInfo', UserInfo.payment.authType, $scope.billing);

				// parseFloat on the shipping to safely ensure the value is 0 and not a decimal < 1
				if (CartDataService.getTotal() === 0 && parseFloat(UserInfo.shipping.deliveryAmount) < 0.01) {
					BillingService.processFreeOrder($scope.billing);
				} else if (BillingService.isCardCaptureAuthType(UserInfo.payment.authType)) {
					$scope.payment.expDateRequired = BillingService.isExpDateRequiredAuthType(UserInfo.payment.authType);
					$scope.payment.cvvRequired = BillingService.isCVVRequiredAuthType(UserInfo.payment.authType);
					$scope.alternateCardCapturePaymentFields = BillingService.getAlternateCardCapturePaymentFields(UserInfo.payment.authType);
					$scope.billingComplete = true;
				} else {
					$scope.save();
					$scope.hideSpinner();
				}
			}

			if ($scope.billingForm.$invalid) {
				try {
					$scope.hideSpinner();
					FocusService.setFocusToError(false);
				} catch (e) {
				}
			}
		}

		/**
		 * Verifies that the date was collected when offered
		 * @protected
		 * @returns {boolean} indicates if the date was collected
         */
		function verifyOptins() {
			var i = 0,
				optinsLength = $scope.optins.length,
				optin = undefined,
				verified = true;
			for (i = 0; i < optinsLength; i++) {
				optin = $scope.optins[i];
				if (getBoolean(optin.checked) && optin.data_collection === "date" && !angular.isString(optin.dataCollectionValue)) {
					verified = false;
					Modal.displayModal({
						action: 'Error',
						category: 'Billing [save]',
						description: getLocale('Billing', 'optinErrorDescription'),
						icon: 'icon-info red',
						title: getLocale('Billing', 'optinErrorTitle')
					});
				}
			}
			return verified;
		}

		/**
		 * Assesses whether or not to show the CVV field
		 * Only EC authTypes require this field
		 * If we are on the credit card capture form with a APD (pin debit) or MRC (Ingenico) authType
		 * then we do not want to show the field
		 */
		$scope.showCVVField = function() {
			return BillingService.isCVVRequiredAuthType(UserInfo.payment.authType) || BillingService.isCVVOptionalAuthType(UserInfo.payment.authType);
		}

		/**
		 * If we show the payment form where we collect credit card data, if the chosen authtype is Mistercash
		 * Lets show the generic payment card sprite for the icon within the card number input field
		 * @type {string}
		 */
		$scope.ccTypeOverride = (UserInfo.payment.authType === 'MRC' ? 'phcard' : '');

		/**
		 * Checks if we have a ccTypeOverride for the icon that is shown in the credit card input field
		 * @returns {boolean}
		 */
		$scope.hasCCTypeOverride = function() {
			return $scope.ccTypeOverride.length > 0;
		};

		/**
		 * Returns the bin image if the billing type is a payment type and we have bin ranges registered
		 * @public
		 * @function
		 * @name getBinImage
		 * @return {null|string} the image else null
		 */
		$scope.getBinImage = function() {
			if (isRealObject($scope.payment)) {
				return CreditCardBinRangesService.getBinImage($scope.payment.merchant_payment_type_ref_id);
			}

			return null;
		};

		$scope.ccIcon = function() {
			if (angular.isDefined($scope.secAcctInfo)) {
				if (DankortCardService.validCardNumber($scope.secAcctInfo.account)) {
					return 'sprite sprite-' + DankortCardService.cardType();
				}
				if (DinersClubCardService.validCardNumber($scope.secAcctInfo.account)) {
					return 'sprite sprite-' + DinersClubCardService.spriteName;
				}
				if (JCBCardService.validCardNumber($scope.secAcctInfo.account)) {
					return 'sprite sprite-' + JCBCardService.spriteName;
				}
				if ($scope.hasCCTypeOverride()) {
					return 'sprite sprite-' + $scope.ccTypeOverride.toLowerCase();
				}
			}

			if (safelyCheckPropertyOnObject('$scope.payment.ccType', $scope)) {
				return 'sprite sprite-' + $scope.payment.ccType.split(' ').join('').toLowerCase();
			}

			return 'sprite sprite-phcard';
		};

		/**
		 * Set's continue button as loading
		 * @function
		 * @public
		 * @param {Boolean} value is loading
		 * @returns {undefined}
		 */
		function setContinueLoading(value) {
			$scope.isContinueLoading = getBoolean(value);
		}

		/**
		 * On Email Address Change
		 * @public
		 * @function
		 * @returns {undefined}
		 */
		function onEmailAddressChange(email) {
			$scope.isEmailVerificationComplete = false;
			if (validString(email) && safelyCheckPropertyOnObject('$scope.billing', $scope, isRealObject)) {
				$scope.emailVerified = false;
				$scope.billing.email = email;
			}
		}

		/**
		 * Set email in verifying status
		 * @function
		 * @public
		 * @param {Boolean} status status
		 * @returns {undefined}
		 */
		function onEmailVerifying(status) {
			$scope.emailVerifying = getBoolean(status);
		}

		/**
		 * On Email Verification Failure
		 * @public
		 * @function
		 * @returns {undefined}
		 */
		function onEmailVerificationFailed() {
			if (safelyCheckPropertyOnObject('$scope.billingForm.email', $scope)) {
				$scope.billingForm.email.$setValidity('pattern', false);
				$scope.isEmailVerificationComplete = false;
				$scope.onEmailVerifying(false);
				$scope.setContinueLoading(false);
			}
		}

		/**
		 * On Email Verification Success
		 * @public
		 * @function
		 * @returns {undefined}
		 */
		function onEmailVerificationSuccess() {
			$scope.isEmailVerificationComplete = true;
			if ($scope.isContinueLoading) {
				$scope.continueToPaymentInformation();
			}
		}

		/**
		 * User triggered method that determines if a payment plan is being used,
		 * then based on addr lookup values and cart values, will save or
		 * set billingComplete.
		 * Additionally tracks analytics event.
		 */
		$scope.continueToPaymentInformation = function() {
			if ($scope.emailOptions.enableEmailVerification && !$scope.isEmailVerificationComplete && $scope.billingForm.$valid) {
				$scope.setContinueLoading(true);
				return;
			}
			$scope.setContinueLoading(false);
			if (getBoolean(AppData.settings.validate_zips)) {
				$scope.showSpinner();

				if ($scope.billingForm.$valid) {
					AppData
						.fetch(Enums.services.GET_CART_SUMMARY, true,
							{
								addRequestParameters: ["zip_code"],
								zip_code: $scope.billing.zip
							}, true)
						.then(function(data) {
							$scope.hideSpinner();

							if (data.status === Enums.status.OK
								&& angular.isDefined(data.last_ticket_error_msg)
								&& angular.isDefined(data.last_ticket_error_code)
								&& Number(data.last_ticket_error_code)===163) {
								// display an error message and don't move on
								AgreementService.clearDataModel();
								AgreementService.clearCartFormData();
								AgreementService.clearCustomFormData();

								Modal.displayModal({
									category: 'Billing [save]',
									action: 'Error',
									label: data.error_msg,
									title: getLocale('Alert', 'zipCodeVerificationFailedTitle'),
									icon: 'icon-info red',
									description: getLocale('Alert', 'zipCodeVerificationFailedMsg'),
									callback: function(detail) {
										//
										// What happens here is that we blow away this item from the cart on the backend.
										// This requires us to make a new call to the real get cart summary to update the internals.
										//
										$scope.showSpinner();
										CartDataService.fetchCartSummary().then(function(e) {
											$scope.hideSpinner();
											$rootScope.routeTo('packageList');
										});
									}
								}
								);
							} else if (data.status === Enums.status.FAILED) {
								Modal.displayModal({
									category: 'Billing [save]',
									action: 'Error',
									label: data.error_msg,
									title: getLocale('Alert', 'failedUpdateCheckoutInfoTitle'),
									icon: 'icon-info red',
									description: getLocale('Alert', 'failedUpdateCheckoutInfoMsg'),
									callback: function(detail) {
										$rootScope.routeTo(Enums.routes.CART);
									}
								});
							} else {
								performBillingInformationVerification();
							}
						}
						);
				} else {
					performBillingInformationVerification();
				}
			} else {
				performBillingInformationVerification();
			}
		};

		/**
		 * Handles a Checkbox value changing.
		 * Additionally tracks an analytics Event
		 *
		 */
		$scope.handleChkChanged = function() {
			if ($scope.useShipAddr == '1' &&
			   angular.isDefined($scope.shipping) &&
			   $scope.shipping) {
				$scope.billing = Utilities.copyObject($scope.shipping);
			} else {
				$scope.billing = angular.copy(BillingService.defaults.form);
			}

			if ($scope.useAddrLookup && AddrLookup.isAddrLookupCountry($scope.shipping.country)) {
				if ($scope.useShipAddr) {
					$scope.toggleAddrLookupOnOff(false);
					$scope.showAddrSearchBtnOnForm = true;
				} else {
					$scope.toggleAddrLookupOnOff(true);
				}
			}

			GuestAppUiService.triggerMDCTextFieldLayout();
		};

		/**
		 * Opens a URL by handling clicks.
		 * @param  {String} url the qualified URL to open a new window with
		 */
		$scope.handleClick = function(url) {
			if (url) {
				$window.open(url, 'provider');
			}
		}

		/**
		 * User triggered method that invalidates $scope.billingComplete $scope.paymentComplete
		 */
		$scope.editBilling = function() {
			$scope.billingComplete = false;
			$scope.paymentComplete = false;
		}

		/**
		 * User triggered method that invalidates $scope.billingComplete
		 * @return {[type]} [description]
		 */
		$scope.editPayment = function() {
			$scope.billingComplete = true;
		}

		/**
		 * User triggered method that invalidates $scope.billingComplete,
		 * then routes user to shipping or cart based on shipping availability
		 */
		$scope.goBack = function() {
			if ($scope.billingComplete) {
				// If billing has been previously submitted, we are in the credit card screen.
				// Let's revert back to the billing screen.
				$scope.billingComplete = false;
			} else if (!$scope.isNonPhysicalDeliveryMethod) {
				$rootScope.routeTo(Enums.routes.SHIPPING);
			} else {
				$rootScope.routeTo(Enums.routes.CART);
			}
		}

		/**
		 * Updates the savePaymentFlag by a value given from a component
		 * @public
		 * @param {bool} newValue what to set the flag to
		 * @returns {undefined}
		 */
		$scope.toggleSavePayment = function(newValue) {
			$scope.savePayment = Boolean(newValue);
		}

		/**
		 * User triggered method that Saves al;l of the billing Demographics!
		 * @param  {Object} data [description]
		 * @return {[type]}      [description]
		 */
		$scope.save = function(data) {
			var isCardCapture = BillingService.isCardCaptureAuthType(UserInfo.payment.authType);
			copyEmailToVerify();
			$scope.billingForm.submitted = true;
			$scope.paymentForm.submitted = true;

			if (BillingService.doesAuthTypeRequireCreditCardForm(UserInfo.payment.authType)) {
				$scope.creditCardFormValid = true;
			}

			if (isCardCapture && !$scope.creditCardFormValid && !$scope.cartBalanceIsZero()) {
				//if we have a credit card authorization and currently have partial payments applied to the cart, display a message that we are only collecting the card
				//in case the gift cards do not cover the entire order amount
				if (UserInfo.payment.authType === Enums.billingTypes.CREDITCARD && UserInfo.partialPayments.length > 0) {
					$scope.displayCCPartialPaymentCollectionMsg();
				} else if ($scope.creditCardOptional && $scope.svcIsOptional) {
					// If we don't have any partial payments yet, and creditCardOptional is true,
					// Display some error denoting that the user should at least enter a gift card.
					$scope.displayStoredValueCardCollectionErrorMsg();
					return;
				}

				FocusService.setFocusToError(false);
				return;
			}

			// Ensure there are items in the cart before proceeding.
			if ($scope.hasItemsInCart()) {
				$scope.billingForm.submitted = true;

				if ($scope.billingForm.$valid) {
					/**
					 * Handle requesting the microform token.
					 */
					if (isCardCapture && $scope.hasCyberSourceCreditCards && !$scope.cartBalanceIsZero()) {
						if (!$scope.creditCardFormValid) {
							return;
						} else {
							if (!$scope.secAcctInfo.cyberSourceToken) {
								$scope.requestMicroformToken = true;
								return;
							}
						}
					}

					// Save the optins into the billing object.
					$scope.billing.optins = $scope.optins;
					$scope.billing.useShipAddr = $scope.useShipAddr;
					$scope.billing.valid = true;

					// Store the Billing Data to App Data.
					UserInfo.set('billing', $scope.billing);

					if (CartDataService.getTotal() === 0 && parseFloat(UserInfo.shipping.deliveryAmount) < 0.01) {
						BillingService.processFreeOrder($scope.billing);
					} else {
						if (isCardCapture) {
							if ($scope.creditCardOptional && $scope.cartBalanceIsZero()) {
								updateCartCheckout();
							} else {
								validatePayment();
							}
						} else {
							var match = false;
							for (var i in AppData.billingTypes) {
								if (AppData.billingTypes[i].auth_type == UserInfo.payment.authType &&
									!CustomActionService.executeCustomAction(CustomActionService.ACTIONS_ENUMS.PAYMENT_METHOD_BY_BILLINGTYPE, null, [UserInfo.payment.type, AppData.billingTypes[i]])) {
									if (AppData.billingTypes[i].merchant_payment_type_ref_id) {
										$scope.payment.merchant_payment_type_ref_id = AppData.billingTypes[i].merchant_payment_type_ref_id;
									} else {
										$scope.payment.billingId = AppData.billingTypes[i].billing_id;
									}
									$scope.payment.billingType = AppData.billingTypes[i].billing_type;
									$scope.payment.authType = AppData.billingTypes[i].auth_type;
									//$scope.payment.auth_type = AppData.billingTypes[i].auth_type;
									$scope.payment.type = UserInfo.payment.type;
									$scope.payment.cepayMerchantId = AppData.billingTypes[i].cepay_merchant_id;
									$scope.payment.card_type_code = AppData.billingTypes[i].card_type_code;
									$scope.payment.ccType = UserInfo.payment.type;
									$scope.payment.cvvRequired = false;

									//The IdealBankList view has been moved to a separate module and is routed to with registered postDemographicForm actions
								 	//Hence we no longer need this check here
									// if( UserInfo.payment.type == Enums.paymentProvider.IDEAL ){
									//	$scope.payment.bankId = $scope.payment.bank;
									//	/* paymentDetails.issuer_id = $scope.payment.bank; */
									//}

									$scope.payment.lastFour = "N/A";

									UserInfo.set('payment', $scope.payment);
									UserInfo.set('secAcctInfo', $scope.secAcctInfo, true);

									match = true;
									break;
								}
							}
							if (!match) {
								// Handle no match found
								// Modal.displayModal({
								// 	category: 'Payment [Method]',
								// 	action: 'Error',
								// 	label: 'Payment Unavailable',
								// 	title: getLocale('Alert', 'paymentMethodUnavailableTitle'),
								// 	description: getLocale('Alert', 'paymentMethodUnavailableMsg'),
								// 	hideAllButtons: false
								// });
								$scope.routeTo(Enums.routes.PAYMENT_METHOD);
							} else {
							 	//lets check for a specific registered action to run after we collect billing demographics
							 	// if there's an action registered, do the action, otherwise call updateCartCheckout
								var altPostDemographicFormAction = BillingService.getAlternatePostDemographicFormAction($scope.payment.type);
								if (angular.isDefined(altPostDemographicFormAction)) {
									altPostDemographicFormAction.doAction();
								} else {
									updateCartCheckout();
								}
							}
						}
					}
				}
			}
		};

		/**
		 * Display a message indicating why credit card numbers are still collected even if we have entered a gift card or partial payment on
		 * @public
		 * @returns {undefined}
		 */
		$scope.displayCCPartialPaymentCollectionMsg = function() {
			Modal.displayModal({
				category: 'Billing',
				action: 'Billing',
				label: 'Credit Card Collection with Gift Card Partial Payments Msg',
				title: getLocale('PaymentView', 'ccRequiredPartialPaymentTitle'),
				description: getLocale('PaymentView', 'ccRequiredPartialPaymentMsg'),
				buttonFlags: [EnumsOK]
			});
		}

		/**
		 * Display a message indicating that the user should enter a gift card or credit card
		 * @public
		 * @returns {undefined}
		 */
		$scope.displayStoredValueCardCollectionErrorMsg = function() {
			Modal.displayModal({
				category: 'Billing',
				action: 'Billing',
				label: 'Gift Card Collections Error Msg',
				title: getLocale('PaymentView', 'ccOrGiftcardRequiredTitle'),
				description: getLocale('PaymentView', 'ccOrGiftcardRequiredMsg'),
				buttonFlags: [EnumsOK]
			});
		}

		/**
		 * An array of month objects
		 * @return {Array} [{value:'01',text:'01 - LocalizedMonth'}, ...]
		 */
		$scope.months = (function() {
			var months = [];
			for (var i in Language.months) {
				var value = $filter('leadingZeros')(parseInt(i)+1, 2);

				if (AppData.language === 'ja-jp') {
					months.push(
						{
							value: value,
							text: Language.months[i]
						}
					);
				} else {
					months.push(
						{
							value: value,
							text: value + ' - ' + Language.months[i]
						}
					);
				}
			}
			return months;
		}());

		/**
		 * An array of YEARS based on $scope.range
		 * @return {Array} [{value:'YY',text:'YYYY'}, ...]
		 */
		$scope.years = (function() {
			var years = [];
			for (var i in $scope.range) {
				years.push(
					{
						value: $filter('rightSubstring')($scope.range[i], 2),
						text: '' + $scope.range[i]
					}
				);
			}
			return years;
		}());

		/**
		 * Checks the balance of the cart after adding partial payments
		 * @public
		 * @function
		 * @name cartBalanceIsZero
		 * @memberof {BillingCtrl}
		 * @return {boolean}
		 */
		$scope.cartBalanceIsZero = function() {
			return !(CartDataService.getTotal() - UserInfo.getPartialPaymentTotal() > 0);
		};


		/*

		____  _           _ _
		|  _ \(_)         | (_)
		| |_) |_ _ __   __| |_ _ __   __ _ ___
		|  _ <| | '_ \ / _` | | '_ \ / _` / __|
		| |_) | | | | | (_| | | | | | (_| \__ \
		|____/|_|_| |_|\__,_|_|_| |_|\__, |___/
									__/ |
									|___/

		*/
		$scope.showBackToShipping = ($scope.shipping && !$scope.isNonPhysicalDeliveryMethod);

		$scope.shippingAddressAvailable =
				($scope.showBackToShipping	&&
					(angular.isDefined($scope.shipping.deliveryMethod)	&&
						$scope.shipping.deliveryMethod == Enums.deliveryMethods.FIRST_CLASS_MAIL
					)
				);

		$scope.handleCountryChanged = function(countryCode) {
			// when country changes, delete the state.
			var element;
			$scope.billing.country = countryCode;
			$scope.billing.state = null;
			if ($scope.regions && $scope.regions[$scope.billing.country]) {
				element = angular.element($document[0].getElementById('billingStateInput'))[0];
				$scope.regionList = $scope.regions[$scope.billing.country];
				$timeout(function updateStateItems() {
					if (element) {
						element.updateMenuOptions();
					}
				 }, 0);
			} else {
				$scope.regionList = [];
			}

			$scope.setZipType(countryCode);

			if (AddrLookup.isAddrLookupCountry(countryCode)) {
				$scope.showAddrSearchBtnOnForm = true;
			} else {
				$scope.showAddrSearchBtnOnForm = false;
				$scope.toggleAddrLookupOnOff(false);
			}

			if (countryCode === 'CA' && angular.isDefined(AppData.settings.email_default_opt_out) && getBoolean(AppData.settings.email_default_opt_out) === true) {
				$scope.turnOptInsOff();
			}
		};

		/**
		 * Should load the options for state if it exist
		 * @returns {undefined}
		 */
		function loadStateOptions(){
			if ($scope.regions && $scope.billing && $scope.regions[$scope.billing.country]) {
				$scope.regionList = $scope.regions[$scope.billing.country];
			}
		}

		$scope.toggleAddrLookupOnOff = function(bool) {
			$scope.addrLookupActivated = AppData.settings.use_addr_lookup && bool;
		};

		$scope.setZipType = function($index) {
			$scope.zipType = ($index == 'US') ? 'tel' : 'text';
		};

		/**
		 * Turns billing opt ins off.
		 * This will happen if the country is set to Canada, because they have laws against
		 * having an opt in set to on-- the user MUST manually select opt ins.
		 */
		$scope.turnOptInsOff = function() {
			if (angular.isDefined($scope.optins)) {
				for (var i in $scope.optins) {
					$scope.optins[i].checked = $scope.optins[i].required ? 1 : 0;
				}
			}
		};

		/**
		 * Sets User and Card information if autoFill (debugmode ) is enabled.
		 * @return {[type]} [description]
		 */
		$scope.initDebugValues = function() {
			if ($scope.autofill &&
					angular.isUndefined($scope.billing.firstName)
			) {
				$scope.billing = angular.copy(BillingService.debugValues.USERS.V5DEV);
				if ($scope.enhancedPhoneConfigs.useEnhancedPhoneNumber) {
					$scope.billing.phone = UserInfo.billing.phone || '';
					$scope.billing.countryCode = UserInfo.billing.countryCode || '';
				}
			}

			// Dev mode only. // pre-populate the payment information.
			if ($scope.autofill && !validString($scope.secAcctInfo.account) && !$scope.hasCyberSourceCreditCards) {
				//} else

				// Credit Card
				if ($scope.payment.type == Enums.paymentProvider.CREDITCARD) {
					$scope.payment = angular.copy(BillingService.debugValues.CARDS.EC_VISA_123.payment);
					$scope.secAcctInfo = angular.copy(BillingService.debugValues.CARDS.EC_VISA_123.secAcctInfo);
				}
			}
		}
		/**
		 * Assess if the form field is optional
		 * @public
		 * @function
		 * @name isOptionalField
		 * @memberof {BillingCtrl}
		 * @param {string} field Field being assessed
		 * @return {boolean} true if the field is optional
		 */
		$scope.isOptionalField = function(field) {
			return BillingService.isOptionalField(field, UserInfo.payment.authType);
		};
		/**
		 * Assess if the form field should be removed
		 * @public
		 * @function
		 * @name isRemovedField
		 * @memberof {BillingCtrl}
		 * @param {string} field Field being assessed
		 * @return {boolean} true if the field should be removed
		 */
		$scope.isRemovedField = function(field) {
			return BillingService.isRemovedField(field, UserInfo.payment.authType);
		};

		/**
		 * capitalizeFirstAndLastName -method to capitalize data in data model
		 */
		function capitalizeFirstAndLastName() {
			$scope.billing.firstName = Utilities.capitalizeFirst($scope.billing.firstName);
			if (angular.isDefined($scope.billing.middleInitial) && $scope.billing.middleInitial) {
				$scope.billing.middleInitial = Utilities.capitalizeFirst($scope.billing.middleInitial);
			}
			$scope.billing.lastName = Utilities.capitalizeFirst($scope.billing.lastName);
		}

		function initSecureProviders() {
			var secureProviders;

			if (((AppData || {}).settings || {}).display_3d_secure && BillingService.has3DSBillingType()) {
				try {
					secureProviders = JSON.parse(AppData.settings.display_3d_secure);
				} catch (error) {
					secureProviders = [];
				}

				if (angular.isArray(secureProviders) && secureProviders.length > 0) {
					for (var i in secureProviders) {
						if (secureProviders[i].icon && getBoolean(secureProviders[i].enabled)) {
							$scope.providers.push(secureProviders[i]);
						}
					}
				}
			}
		}

		/**
		 * If we're not validating the email, copy it over to the email verification model.
		 * @see $scope.save() && $scope.continueToPaymentInformation()
		 *
		 */
		function copyEmailToVerify() {
			if (!getBoolean($scope.validateEmail)) {
				$scope.billing.emailVerify = $scope.billing.email;
			}
		}

		/**
		 * sets the billing ad image
		 * @see InitializeCtrl()
		 */
		function setBillingAd() {
			$scope.adImage = '';

			if (AppData.settings.card_promo_image) {
				$scope.adImage = $rootScope.getAssetUrl(AppData.settings.card_promo_image);
			}
		}

		$scope.showCardInfoModal = function() {
			$rootScope.$broadcast('triggerPrepaidCardModal');

			Modal.displayModal({
				category: 'Prepaid Card Info',
				view: 'new',
				customCss: 'large',
				title: getLocale('FormLabels', 'prepaidModalTitle'),
				showCloseButton: true,
				description: getLocale('FormLabels', 'prepaidModalInformation')
			})
		}


		/**
		 * Method used by updateCartCheckout to set shipping values
		 */
		function setShippingMethodAndAmount() {
			// Save this data in the shipping form when we implement it.
			if (angular.isDefined($scope.shipping) && $scope.shipping !== null) {
				$scope.payment.shipMethod = (angular.isDefined($scope.shipping.deliveryMethod)) ? $scope.shipping.deliveryMethod : Enums.deliveryMethods.MOBILE;
				$scope.payment.shipAmount = (angular.isDefined($scope.shipping.deliveryAmount)) ? $scope.shipping.deliveryAmount : '0.00';
			} else {
				$scope.payment.shipMethod = Enums.deliveryMethods.MOBILE;
				$scope.payment.shipAmount = '0.00';
			}
		}


		/**
		 * [getValidCardTypes description]
		 * @return {[type]} [description]
		 */
		function getValidCardTypes() {
			var cardTypeReplacement = '';
			for (var i = 0; i < cardOverrides.length; i++) {
				if (i == cardOverrides.length - 1 && cardOverrides.length > 1) {
					cardTypeReplacement += ' or ';
				}
				cardTypeReplacement += cardOverrides[i];
				if (i < cardOverrides.length - 1 && cardOverrides.length > 2) {
					cardTypeReplacement += ', ';
				}
			}

			var cardTypes = Language.replaceAll('@@cardTypes', cardTypeReplacement, getLocale('FormValidation', 'ccOverideTypes'));

			return cardTypes;
		}


		$scope.handleCardNumberChanged = function() {
			$scope.invalidCCType = false;
		}


		/**
		 * validate payment options and values
		 * cctype, month, year etc
		 */
		function validatePayment() {
			// Determine card type and set relevant information on payment object.
			// Get billing type information.
			var billTypeObj = $scope._getBillingType($scope.payment);

			if (billTypeObj) {
				$scope.invalidCCType = false;

				// Reset the payment information.
				UserInfo.payment = {};

				// (i.e. ensure that this merchant accepts the type of card entered).
				if (billTypeObj.merchant_payment_type_ref_id) {
					$scope.payment.merchant_payment_type_ref_id = billTypeObj.merchant_payment_type_ref_id;
				} else {
					$scope.payment.billingId = billTypeObj.billing_id;
				}
				$scope.payment.billingType = billTypeObj.billing_type;
				$scope.payment.authType = billTypeObj.auth_type;
				$scope.payment.cepayMerchantId = billTypeObj.cepay_merchant_id;
				$scope.payment.card_type_code = billTypeObj.card_type_code;

				// Format the expiration date as expected by the server.
				if ($scope.payment.expDateRequired || ($scope.payment.year && $scope.payment.month)) {
					var cardExpDate = $scope.payment.year + $scope.payment.month;
					$scope.payment.cardExpirationDate = (cardExpDate) ? cardExpDate : '';

					var yearObj = $scope.years.filter(function(item) {
						return item.value == $scope.payment.year
					});
					if (angular.isDefined(yearObj)) {
						var cardExpDateFullYear = yearObj[0].text + $scope.payment.month;
					}
					$scope.payment.cardExpirationDateFullYear = angular.isDefined(cardExpDateFullYear) ? cardExpDateFullYear : '';
				}

				$scope.payment.adyen_save_card = $scope.payment.store_payment_method = $scope.savePayment;
				$scope.payment.valid = true;

				//payment information is not to be save in localStorage, it is kept alive as long the user dont refresh
				$scope.payment.lastFour = $scope._getPaymentLastFour();
				// Determine whether or not to display the placeholder for the last four digits of the card
				$scope.billing.showLastFour = BillingService.isCardCaptureAuthType($scope.payment.authType);

				UserInfo.set('payment', $scope.payment);
				UserInfo.set('secAcctInfo', $scope.secAcctInfo, true);

				var altPostDemographicFormAction = BillingService.getAlternatePostDemographicFormAction($scope.payment.type);
				if (angular.isDefined(altPostDemographicFormAction)) {
					altPostDemographicFormAction.doAction();
				} else {
					updateCartCheckout();
				}
			} else {
				$scope.invalidCCType = true;
			}
		}

		/**
		 * Retrieve the last four digits for display on various screens in billing flow
		 * @protected
		 * @returns {String} last four digits of card number
		 */
		function _getPaymentLastFour() {
			if ($scope.hasCyberSourceCreditCards) {
				return validString($scope.secAcctInfo.maskedPan) ? $scope.secAcctInfo.maskedPan.substr(-4) : '';
			} else if ($scope.hasAdyenCreditCards) {
				return returnOrDefault($scope.secAcctInfo.adyenLastFour, '', validString);
			} else if ($scope.alternateCardCapturePaymentFields.length > 0) {
				var fieldForLastFour = $scope.alternateCardCapturePaymentFields.find(function(fld) {
					return fld.useAsLastFourForOrderReview;
				});

				if (fieldForLastFour) {
					return fieldForLastFour.fieldValue.substr(fieldForLastFour.fieldValue.length - 4);
				}
			} else {
				return $scope.secAcctInfo.account.substr($scope.secAcctInfo.account.toString().length - 4);
			}
		}

		/**
		 * Method that sets the payment.cardType to mastercard
		 *  in the case of maestro being selected.
		 * @param  {Object} pmt the payment object data, ex: { cardType: "maestro", account:"4111maestro1111"}
		 * @return {Object}     the modified pmt object
		 */
		function maestroToMastercardOverride(pmt) {
			if (pmt.ccType === 'maestro' && pmt.type !== 'mrcash') {
				pmt.ccType = 'mastercard';

				// add a ccTypeDisplayAlias so that the correct sprite and label can be displayed on the orderReview
				pmt.ccTypeDisplayAlias = 'maestro';
			} else if (pmt.type==='mrcash') {
				 pmt.ccType = 'mrcash';
			}
			return pmt;
		}

		/**
		 * Checks for matching billing type of the payment has billing type set while registering it
		 * @protected
		 * @param {Object} billingType billing type object
		 * @param {Object} registeredPaymentMethod registered payment method
		 * @returns {Boolean} true / false
		 */
		function _checkForMatchingBillingType(billingType, registeredPaymentMethod) {
			if (validString(registeredPaymentMethod.billingType)) {
				return billingType.billing_type === registeredPaymentMethod.billingType;
			}
			return true;
		}

		/**
		 * Method used to map the billing type to the card selected.
		 * @protected
		 * @param  {String} cardType visa, mastercard, discover, ...
		 * @return {Object}          selected billing type object in AppData.billingTypes
		 */
		function _getBillingType(paymentInfo) {
			var billType = null;
			var billingTypes = AppData.billingTypes;
			var billingCount = billingTypes.length;
			var i = 0;
			var registeredPaymentMethod = BillingService.getRegisteredPaymentMethodByName(paymentInfo.type);
			var billingId = safelyCheckPropertyOnObject('paymentInfo.billing_id', paymentInfo, Utilities.returnValue);
			var merchantPaymentTypeRefId = safelyCheckPropertyOnObject('paymentInfo.merchant_payment_type_ref_id', paymentInfo, Utilities.returnValue);
			var x;

			if (isRealObject(registeredPaymentMethod)) {
				for (; i < billingCount; i++) {
					if (billingTypes[i].auth_type === registeredPaymentMethod.authType && $scope._checkForMatchingBillingType(billingTypes[i], registeredPaymentMethod)) {
						billType = billingTypes[i];
						angular.extend(paymentInfo, billType);
						paymentInfo.isRegisteredPaymentMethod = true;
						angular.extend($scope.secAcctInfo, registeredPaymentMethod.getSecureFieldsJSON());
						angular.extend(paymentInfo, registeredPaymentMethod.getStorableFields());

						if (validString(registeredPaymentMethod.ccTypeOverride)) {
							paymentInfo.ccType = registeredPaymentMethod.ccTypeOverride;
						}

						return paymentInfo;
					}
				}
			}

			paymentInfo = maestroToMastercardOverride(paymentInfo);

			if (JCBCardService.validCardNumber($scope.secAcctInfo.account)) {
				paymentInfo.ccTypeDisplayAlias = JCBCardService.cardName;
			} else if (DinersClubCardService.validCardNumber($scope.secAcctInfo.account)) {
				paymentInfo.ccTypeDisplayAlias = DinersClubCardService.cardName;
			}

			if (paymentInfo.type === 'mrcash') {
				for (i = 0; i < billingCount; i++) {
					if (billingTypes[i].auth_type === Enums.billingTypes.MISTERCASH) {
						billType = billingTypes[i];
						angular.extend(paymentInfo, billType);
						return paymentInfo;
					}
				 }
			}

			var searchProp = paymentInfo.ccType === 'dynamic' ? 'name' : 'ccType';

			for (i = 0; i < billingCount; i++) {
				if (billingTypes[i].name.toLowerCase() == paymentInfo[searchProp].toLowerCase()) {
					billType = billingTypes[i];
					break;
				}
			}

			if (billType) {
				if (cardOverrides.length > 0) {
					for (x = 0; x < cardOverrides.length; x++) {
						if (billType.name.toLowerCase() === cardOverrides[x].toLowerCase()) {
							return billType;
						}
					}
				}
			}

			return AppData.billingTypes.find(function(type) {
				if (billingId) {
					return type.billing_id === billingId;
				} else if (merchantPaymentTypeRefId) {
					return type.merchant_payment_type_ref_id === merchantPaymentTypeRefId;
				}
			});
		}


		/**
		 * Method used to send the updateCartItems request
		 * @param  {Object} data undefined, doesnt ever seem to be sent
		 */
		function updateCartCheckout(data) {
			var billingId = $scope.payment.billingId;
			var merchantPaymentTypeRefId = $scope.payment.merchant_payment_type_ref_id;

			if ((!validString(billingId) && !validString(merchantPaymentTypeRefId)) && UtilsValidation.validArray(UserInfo.partialPayments) && isRealObject(UserInfo.partialPayments[0].payment)) {
				if (UserInfo.partialPayments[0].payment.merchant_payment_type_ref_id) {
					merchantPaymentTypeRefId = UserInfo.partialPayments[0].payment.merchant_payment_type_ref_id;
				} else {
					billingId = UserInfo.partialPayments[0].payment.billing_id;
				}
			}

			// Add reference of request in pendingRequests.
			$rootScope.pendingRequests.push(Enums.services.UPDATE_CART_CHECKOUT_INFO);

			// Show the spinner.
			$scope.showSpinner(getLocale('ApplicationLabels', 'updatingPaymentInfoLoadMsg'));

			if (_timer) {
				$timeout.cancel(_timer);
				_timer = null;
			}

			setShippingMethodAndAmount();

			/**
			 * Using Bugsnag to capture info regarding this elusive
			 * issue where billing_type_id is missing in request
			 */
			if (!billingId && !merchantPaymentTypeRefId) {
				var hasCCInfo = !!$scope.payment.account;
				errorTracking.notify('UpdateCartCheckoutInfo has no billing_type_id or merchant_payment_type_ref_id', 'card_type_code= '
						+ $scope.payment.card_type_code + ' billingType= ' + $scope.payment.billingType + ' UserInfo.billingId= ' + UserInfo.billingId + ' UserInfo.merchant_payment_type_ref_id= ' + UserInfo.merchant_payment_type_ref_id
						+ ' scope has creditcard=' + hasCCInfo,
				{
					tags: {
						session_id: AppData.cart.session_id,
								  merchant: AppData.merchant,
								  environment: AppData.environment
					}
				});
			}
			// This should come in from the selection by the user, or the defaulted value.
			var message = {
				shippingMethod: $scope.payment.shipMethod,
				shippingAmount: $scope.payment.shipAmount
			};

			if (merchantPaymentTypeRefId) {
				message.merchant_payment_type_ref_id = merchantPaymentTypeRefId;
			} else {
				message.billingId = billingId; // This could be missing
			}

			if (data) {
				// If data is defined, then overwrite the request object.
				message = data;
			}

			AppData
				.fetch(Enums.services.UPDATE_CART_CHECKOUT_INFO, false, message)
				.then(function(data) {
					// Remove reference of request in pendingRequests.
					$rootScope.removePendingRequest(Enums.services.UPDATE_CART_CHECKOUT_INFO)
					// Show the spinner.
					$scope.showSpinner(getLocale('ApplicationLabels', 'updatingPaymentInfoLoadMsg'));
					if (data.status == Enums.status.OK) {
						CartDataService
							.fetchCartSummary()
							.then(function() {
								if (!CustomActionService.executeCustomAction(CustomActionService.ACTIONS_ENUMS.BILLING_POST_UPDATE_CHECKOUT_CART_INFO)) {
									$scope.routeTo(Enums.routes.REVIEW);
								}
								$scope.hideSpinner();
							});
					} else if (data.status == Enums.status.FAILED) {
						// Hide the spinner.
						$scope.hideSpinner();

						// The request to updateCartItem failed.
						displayFailedUpdateCheckoutInfoModal(data);
					}
				}
				);
		}

		/**
		 * Displays a error modal if update checkout info fails.
		 * @param  {Object} data
		 * @returns {undefined}
		 */
		function displayFailedUpdateCheckoutInfoModal(data) {
			Modal.displayModal({
				category: 'Billing [validatePayment]',
				action: 'Error',
				label: data.error_msg,
				title: getLocale('Alert', 'failedUpdateCheckoutInfoTitle'),
				description: getLocale('Alert', 'failedUpdateCheckoutInfoMsg'),
				icon: 'icon-info red',
				hideAllButtons: false
			});
		}


		/**
		 * populates the billing demographics with affiliate data
		 * based on an application_config value and only if the store is launched with an affiliate merchant
		 */
		function populateBillingWithAffiliateInfo() {
			var merchantID = angular.isDefined($location.search().merchant_id) ? $location.search().merchant_id : '';
			var affiliate = merchantDetailsData.AFFILIATE;

			if (getBoolean(AppData.settings.populate_billing_with_affiliate_info) &&
				merchantID.length > 0	&&
				angular.isDefined(affiliate) && angular.isDefined(affiliate.contact_first_name) &&
				!$scope.billing.firstName) {
				// get the country code from the affiliate country name
				// Doing it this way instead of using a filter because the countries list can be very long
				// and we only need the data from a single country in the list.
				var countryCode = '';
				for (var i = 0; i < AppData.countries.length; i++) {
					var country = AppData.countries[i];
					if (country.nativeSpelling === affiliate.contact_country) {
						countryCode = country.code;
						break;
					}
				}

				$scope.billing = {
					firstName: affiliate.contact_first_name,
					lastName: affiliate.contact_last_name,
					country: countryCode,
					address: affiliate.contact_street,
					city: affiliate.contact_city,
					state: affiliate.contact_state,
					zip: affiliate.contact_zip,
					phone: affiliate.contact_phone,
					email: affiliate.contact_email,
					emailVerify: affiliate.contact_email
				};
			}
		}

		/**
		 * Tells the CartAbandonment service to go ahead and autocapture with the billing email address.
		 * @public
		 * @memberOf {BillingCtrl}
		 * @return {undefined}
		 */
		function captureAbandonment() {
			var email = $scope.billing.email;
			$scope.onEmailVerifying(false);
			$scope.emailVerified = true;

			if (cartAbandonmentLastEmail === email || !validEmailRegex.test(email)) {
				return;
			}

			// save so we can check it next time so we don't send the request if its the same email
			cartAbandonmentLastEmail = email;

			if (cartAbandonmentDebounce) {
				$timeout.cancel(cartAbandonmentDebounce);
			}

			cartAbandonmentDebounce = $timeout(function() {
				CartAbandonmentService.autocaptureCartAbandonment(email);
			}, 500);
		}

		/**
		 * Determines whether the Prepaid payment info should be hidden.
		 * The hide_prepaid_info setting is a csv of authTypes where the Prepaid payment
		 * info should be hidden.  If this setting is defined, set the Prepaid info to hidden
		 * if the selected authType is found within this csv list.
		 * If the hide_prepaid_info is not defined the default value is false.
		 * @returns {boolean} default value is false
		 */
		function hidePrepaidInfo() {
			var hide = false;

			if (angular.isDefined(AppData.settings.hide_prepaid_info) &&
				angular.isDefined(UserInfo.payment.authType)) {
				// trim spaces, convert to lowercase and get an array of authType values
				var hidePrepaidInfoAuthTypes = AppData.settings.hide_prepaid_info.replace(' ', '').split(',');

				// if the selected authType is in the list, hide the prepaid info
				var matchingAuthTypes = hidePrepaidInfoAuthTypes.filter(function(item) {
					return item.toLowerCase() === UserInfo.payment.authType.toLowerCase();
				});
				if (matchingAuthTypes.length != 0) {
					hide = true;
				}
			}

			return hide;
		}

		$scope.$watch('billingComplete', function(newVal, oldVal) {
			if (newVal !== oldVal) {
				$rootScope.$broadcast('accessibilityFocus');
			}
		});

		/**
		 * When the credit card form changes validity
		 * @public
		 * @param {Boolean} isValid If the credit card form is valid and completely filled out
		 * @param {Object} data The data from a valid credit card form. Only here if isValid is true
		 * @returns {undefined}
		 */
		function onFormValidity(isValid, data, billingType) {
			$scope.secAcctInfo = angular.isObject($scope.secAcctInfo) ? $scope.secAcctInfo : {};
			$scope.creditCardFormValid = isValid;
			$scope.secAcctInfo.cyberSourceToken = null;

			if (isValid) {
				if (validString(data.cardNumber)) {
					$scope.secAcctInfo.account = data.cardNumber;
				}
				$scope.secAcctInfo.securityCode = data.cvv;
				$scope.payment = {
					authType: billingType.auth_type,
					billingProviderId: billingType.billing_provider_id,
					billingType: billingType.billing_type,
					billingId: billingType.billing_id,
					ccType: data.ccType,
					ccTypeDisplayAlias: data.ccTypeDisplayAlias,
					cepayMerchantId: billingType.cepay_merchant_id,
					enabled3DS: billingType.enabled_3ds,
					merchant_payment_type_ref_id: billingType.merchant_payment_type_ref_id,
					month: data.month,
					name: billingType.name,
					year: data.year
				};

				$scope.payment.type = UserInfo.payment.type;
			}
		}

		/**
		 * When the credit card form changes validity
		 * @public
		 * @param {Boolean} isValid If the credit card form is valid and completely filled out
		 * @param {Object} data The data from a valid credit card form. Only here if isValid is true
		 * @param {Object} billingType billingtype object
		 * @returns {undefined}
		 */
		function onAdyenFormValid(isValid, data, billingType) {
			$scope.creditCardFormValid = isValid;
			$scope.secAcctInfo.adyenEncryptedCardInfo = null;

			if (isValid) {
				$scope.secAcctInfo.account = '';
				$scope.secAcctInfo.securityCode = '';
				$scope.payment = {
					authType: billingType.auth_type,
					billingProviderId: billingType.billing_provider_id,
					billingType: billingType.billing_type,
					billingId: billingType.billing_id,
					ccType: data.ccType,
					ccTypeDisplayAlias: data.ccTypeDisplayAlias,
					cepayMerchantId: billingType.cepay_merchant_id,
					enabled3DS: billingType.enabled_3ds,
					merchant_payment_type_ref_id: billingType.merchant_payment_type_ref_id
				};

				$scope.payment.type = UserInfo.payment.type;
			}
		}

		/**
		 * Resets the create token flag.
		 * @public
		 * @function
		 * @returns {undefined}
		 */
		function onResetCreateToken() {
			$scope.requestMicroformToken = false;
		}

		/**
		 * Handles when a user tries to submit the credit card form.
		 * @public
		 * @function
		 * @returns {undefined}
		 */
		function onSubmitCreditCardForm() {
			$scope.save($scope.billing);
		}

		/**
		 * Handles when creating hosted fields
		 * @public
		 * @function
		 * @param {String} section section for the locale
		 * @param {String} target target for the locale
		 * @param {String} category category for the modal
		 * @param {String} label label for the locale
		 * @param {String} state state to be routed to
		 * @returns {undefined}
		 */
		function onHostedFieldsSetupError(section, target, category, label, state) {
			Modal.displayModal({
				action: 'Error',
				buttonFlags: [EnumsOK],
				callback: $scope.getRouteToStateOrCartCallback(state),
				category: category,
				description: getLocaleWithSuffixAndFallback(section, target, MERCHANT_ID),
				icon: 'icon-info red',
				label: label,
				sessionId: sessionId,
				showCloseButton: false,
				title: getLocaleWithSuffixAndFallback(section, 'creditCardErrorTitle', MERCHANT_ID)
			});
		}

		/**
		 * Handles displaying create payment token error
		 * @public
		 * @function
		 * @param {String} section section for locale
		 * @param {String} target target for locale
		 * @param {String} label label
		 * @param {String} state state for redirection
		 * @returns {undefined}
		 */
		function onCreatePaymentTokenFailure(section, target, label, state) {
			Modal.displayModal({
				action: 'Error',
				buttonFlags: [EnumsOK],
				callback: function() {
					if (validString(state)) {
						$rootScope.routeTo($state.href(state, {}));
					}
				},
				category: label,
				description: getLocaleWithSuffixAndFallback(section, target, MERCHANT_ID),
				icon: 'icon-info red',
				label: label,
				sessionId: sessionId,
				showCloseButton: false,
				title: getLocaleWithSuffixAndFallback(section, 'creditCardErrorTitle', MERCHANT_ID)
			});
		}

		/**
		 * Handle the on microform token created.
		 * @public
		 * @function
		 * @param {Object} token The createTokenResponse
		 * @returns {undefined}
		 */
		function onMicroformTokenCreated(token) {
			$scope.secAcctInfo.cyberSourceToken = token;
			$scope.secAcctInfo.maskedPan = token.maskedPan;
			$scope.save($scope.billing);
		}

		/**
		 * Handle the on encryptd card data received
		 * @public
		 * @function
		 * @param {Object} encryptedCard encrypted card data
		 * @param {String} lastFour last four digits of card
		 * @returns {undefined}
		 */
		function onEncryptedCardDataReceived(encryptedCard, lastFour) {
			$scope.secAcctInfo.adyenEncryptedCardInfo = encryptedCard;
			$scope.secAcctInfo.adyenLastFour = lastFour;
		}

		/**
		 * Reset Form Submitted
		 * @public
		 * @returns {undefined}
		 */
		function onResetFormSubmitted() {
			if (isRealObject($scope.paymentForm)) {
				$scope.paymentForm.submitted = false;
			}
		}

		/**
		 * Returns a callback that routes to a state if its valid or the cartView.
		 * @param {String} state The state to route to.
		 * @returns {Function} The callback
		 */
		function getRouteToStateOrCartCallback(state) {
			return function() {
				$rootScope.routeTo(
					$state.href(validString(state) ? state : '/cartView', {})
				);
			};
		}

		InitializeCtrl();
	});

angular
	.module('app')
	.controller('CartRecoveryCtrl', [
		'$scope',
		'LegacyCart',
		'Language',
		'$log',
		'$rootScope',
		'$stateParams',
		'AppData',
		function(
			LegacyCart,
			$rootScope,
			$stateParams,
			AppData
		) {
			if (angular.isDefined($stateParams.email)) {
				$rootScope.showSpinner()
				var data =
				{
					email: $stateParams.email,
					merchant_id: AppData.GetMerchantDetails.merchant_id
				}
				LegacyCart.retrieveCart(data)
			}
		}]);


angular.module('app')
	.controller
	('CartRecoveryModalCtrl', [
		'$scope',
		'LegacyCart',
		'Language',
		'$log',
		'$rootScope',
		'AppData',
		'$uibModalInstance',
		function($scope,
			LegacyCart,
			$rootScope,
			AppData,
			$uibModalInstance
		) {
			$scope.cartRecovery = {};

			$scope.submitCartRecovery = function() {
				$scope.cartRecovery.merchant_id = AppData.GetMerchantDetails.merchant_id;
				LegacyCart.retrieveCart($scope.cartRecovery);
				$uibModalInstance.close('okay')
			};

			$scope.cancel = function() {
				$uibModalInstance.close('cancel');
			};

			$rootScope.$on('hidePreviousModals', function() {
				$rootScope.modalOpen = false;
				$uibModalInstance.close('');
			});
		}]);


angular
	.module('app')
	.controller('CrossSellsCtrl', function(
		$scope,
		$state,
		$rootScope,
		AppData,
		ExtraFlow,
		Enums,
		Language,
		Storage,
		Utilities,
		Package,
		ClientInfo,
		LegacyCart,
		StandardFlowInitiatorService,
		RouteHistoryService,
		UtilsValidation
	) {
		var validString = UtilsValidation.validString,
			validArray = UtilsValidation.validArray;

		$scope.crossSellTypes = []
		$scope.fullPageCrossSell = null;
		$scope.templateUrl = 'views/crossSells.html';
		$scope.isMobile = ClientInfo.deviceType == Enums.deviceType.MOBILE;

		var merchantPackageListData = AppData.GetMerchantPackageList;
		var consolidatedData = AppData.GetApplicationConsolidated;
		var cartSummaryData = AppData.GetCartSummary;

		/**
		 * Handles when a cross sell item is clicked
		 * @public
		 * @param {array} crossSell
		 * @returns {undefined}
		 */
		$scope.handleItemClick = function(crossSell) {
			var alternateFlow = ExtraFlow.isAlternateFlow(crossSell.keyword, consolidatedData.TREE.MENUITEM),
				flowSettings,
				view;

			$scope.state.showCrossSells = false;
			$scope.state.crosssell_type = 'package';

			$rootScope.$broadcast("triggerPromoClick", 'Package-Level Cross Sells', $scope.crossSells, crossSell);

			AppData.updateLastKeyword(crossSell.keyword, "crossell handleItemClick");

			// Route to alternate flow if applicable.
			if (validString(alternateFlow)) {
				view = ExtraFlow.getAlternateFlowView(alternateFlow);

				if (view) {
					flowSettings = ExtraFlow.getSettings(alternateFlow);

					/**
					 * If the view is the state name it will include and replace the `/:keyword` portion of the url so we dont
					 * need to add it. However, if its not, we need to manually add it ourselves like we've always done
					 */
					if (!angular.isObject(flowSettings) || !flowSettings.viewIsStateName) {
						view += '/' + crossSell.keyword
					}

					$scope.routeTo(view);
					return;
				}
			}

			$scope.routeTo(Enums.routes.LIST + '/crosssells/' + crossSell.keyword);
		};

		/**
		 * Continue to the cart review
		 * @returns {undefined}
		 */
		$scope.continueToCart = function() {
			RouteHistoryService.setDisableSaveOfRoute(true);
			$scope.routeTo(Enums.routes.CART);
		};

		/**
		 * Used to toggle the content of the cross-sell
		 * @param {number} index the cross-sell index
		 * @returns {undefined}
		 */
		$scope.toggleContent = function(index, event) {
			event.preventDefault();
			event.stopPropagation();
			var crossSells = LegacyCart.getPackageCrossSells($state.params.pkgIds);
			if(crossSells && crossSells.length > 0) {
				crossSells[index].showContent = !crossSells[index].showContent;
			}
		};

		/**
		 * Initializes Cross Sell Controller
		 * @private
		 * @returns {undefined}
		 */
		function initializeController() {
			var crossSells = LegacyCart.getPackageCrossSells($state.params.pkgIds),
				localeWithSuffix = Language.getLocaleWithSuffixAndFallback,
				crossSellCount,
				fullPageSuffix,
				pkg;

			if (angular.isUndefined(crossSells) || (crossSells.length === 1 && LegacyCart.isCrossSellAddedToCart(crossSells[0]))) {
				$scope.crossSells = [];
			} else {
				$scope.crossSells = crossSells;
			}

			$scope.crossSells.forEach(function(crossSell) {
				var pkgs = Package.getPackagesByKeyword(crossSell.keyword);
				if (Utilities.safelyCheckPropertyOnObject('pkgs.0.KEYWORDS.K', pkgs, validArray)) {
					var foundKeyword = pkgs[0].KEYWORDS.K.filter(function findKeyword(kw) {
						return kw.keyword === crossSell.keyword;
					})[0];
					if (foundKeyword) {
						crossSell.header = foundKeyword.keyword_header;
					}
				}
			});

			crossSellCount = $scope.crossSells.length;
			if (crossSellCount > 0) {
				$rootScope.$broadcast("triggerPromoImpressions", 'Package-Level Cross Sells', $scope.crossSells);
				$scope.hideSpinner();

				if (crossSellCount === 1) {
					pkg = Package.getPackageByID($scope.crossSells[0].packageId);

					if (angular.isObject(pkg) && Utilities.safelyCheckPropertyOnObject('pkg.CHARACS.cross_sell_full_page_suffix', pkg, validString)) {
						fullPageSuffix = pkg.CHARACS.cross_sell_full_page_suffix;

						$scope.templateUrl = 'views/crossSells-full-page.html';
						$rootScope.bgImageUrl = { 'background-image': 'url(' + $rootScope.getAssetUrl(localeWithSuffix('CrossSellFullPage', 'image', fullPageSuffix)) + ')' };

						if (Utilities.getBoolean(pkg.CHARACS.use_custom_full_page_cross_sell) && ClientInfo.deviceType === 'mobile') {
							$rootScope.bgImageUrl = { 'background-image': 'url(' + $rootScope.getAssetUrl(localeWithSuffix('CrossSellFullPage', 'image_mobile', fullPageSuffix)) + ')' };
						}
						$scope.fullPageCrossSell = {
							bulletList: localeWithSuffix('CrossSellFullPage', 'bullets', fullPageSuffix).split('|'),
							buttonText: localeWithSuffix('CrossSellFullPage', 'btnText', fullPageSuffix),
							crossSell: $scope.crossSells[0],
							css: { color: localeWithSuffix('CrossSellFullPage', 'color', fullPageSuffix) || '#FFF' },
							heading: localeWithSuffix('CrossSellFullPage', 'heading', fullPageSuffix).replace(/@@basename/gi, pkg.name),
							noThanks: localeWithSuffix('CrossSellFullPage', 'noThanks', fullPageSuffix),
							continue: localeWithSuffix('CrossSellFullPage', 'continue', fullPageSuffix)
						};
					}
				}

				return;
			}

			if (Utilities.childDefined(cartSummaryData, 'CHECKOUT_KEYWORDS.K')
					&& (ClientInfo.deviceType == 'desktop' || ClientInfo.deviceType == 'tablet')) {
				AppData.crossSells = true;
				$scope.continueToCart();
				return;
			}
			if (AppData.crossSells
					&& Utilities.childDefined(cartSummaryData, 'CHECKOUT_KEYWORDS.K')
			) {
				$scope.crossSells = cartSummaryData.CHECKOUT_KEYWORDS.K;
				$scope.hideSpinner();
			}
			AppData.crossSells = false;
			if (!validArray($scope.crossSells)) {
				$scope.hideSpinner();
				$scope.continueToCart();
				return;
			}

			$scope.$broadcast("triggerPromoImpressions", 'Package-Level Cross Sells', $scope.crossSells);
		}

		initializeController();
	});

angular.module('app')
	.controller('CartViewCrossSellsCtrl', function(
		$scope,
		$rootScope,
		AppData,
		ExtraFlow,
		Enums,
		CrossSellService
	) {
		var consolidatedData = AppData.GetApplicationConsolidated;
		var cartSummaryData = AppData.GetCartSummary;

		/**
		 * Handles when a cross sell item is clicked
		 * @public
		 * @param {array} keyword
		 * @returns {undefined}
		 */
		$scope.handleItemClick = function(keyword) {
			$scope.state.showCrossSells = false;
			$scope.state.crosssell_type = 'cart';
			$rootScope.$broadcast("triggerPromoClick", 'Cart-Level Cross Sells', $scope.crossSells, keyword);

			AppData.updateLastKeyword(keyword.keyword, "crossell handleItemClick");

			// Route to alternate flow if applicable.
			var alternateFlow = ExtraFlow.isAlternateFlow(keyword.keyword, consolidatedData.TREE.MENUITEM);
			if (alternateFlow != '') {
				var view = ExtraFlow.getAlternateFlowView(alternateFlow);

				if (view) {
					var keywordPath = ExtraFlow.isAlternateFlowViewRepresentedAsAStateName(alternateFlow) ? '' : '/' + keyword.keyword;
					$scope.routeTo(view + keywordPath);
					return;
				}
			}
			$scope.routeTo(Enums.routes.LIST + '/crosssells/' + keyword.keyword);
		};

		/**
		 * Initializes Cross Sell Controller
		 * @private
		 * @returns {undefined}
		 */
		function initializeController() {
			CrossSellService.loadCrossSells(cartSummaryData);

			$rootScope.$broadcast("triggerPromoImpressions", 'Cart-Level Cross Sells', $scope.crossSells);
		}

		initializeController();
	});

/**
 * # ErrorPageCtrl
 *
 * Controller that manages the larger error pages.

 @todo: DO NOT USE LOADING SERVICE FOR KNOWLEDGEBASE UNTIL THE API CODE IS UP TO THE 3.5 IMPLEMENTATION.
 */
angular
	.module('app')
	.controller('ErrorPageCtrl', [
		'$scope',
		'$stateParams',
		'$location',
		'ClientInfo',
		'Language',
		'Utilities',
		'Modal',
		'Enums',
		function(
			$scope,
			$stateParams,
			$location,
			ClientInfo,
			Language,
			Utilities,
			Modal,
			Enums
		) {
			window.scrollTo(0, 0);
			$scope.hideSpinner()

			$scope.errorCode = false;
			$scope.errorMsg = '';
			$scope.errorTest = 'qweqweqwe';
			$scope.showBackToStoreLink = true
			$scope.ClientInfo = ClientInfo;

			/**
		 * Might switch over to this in the future.
		 */
			$scope.goHome = function() {
				var merchant = $stateParams.merchant;
				if (angular.isDefined(merchant)) {
				// Need the following line to get rid of the querystring data that gets left behind.
					$location.search('unknownPage', null);
					// TODO: Use routeTo()
					$location.path('/' + merchant);
				} else {

				}
			}

			$scope.tryAgain = function(errorCode) {
				Utilities.routeTo('reset/true')
			}

			function resetScopeVars() {
				$scope.errorCode = false
				$scope.errorMsg = ''
				$scope.showAndroidBrowserLinks = false
			//$scope.showBackToStoreLink = false
			}

			function InitializeCtrl() {
				resetScopeVars()

				if (angular.isDefined($stateParams.errorCode)) {
					$scope.errorCode = $stateParams.errorCode;
					$scope.noButtons = $stateParams.noButtons || false;
					$scope.ClientInfo = ClientInfo;

					if (Language.localeExists('ErrorCodes', $scope.errorCode)) {
						$scope.errorMsg = Language.getLocale('ErrorCodes', $scope.errorCode);

						var icon = 'icon-info red';

						switch ($scope.errorCode) {
						case '1004':
							var icon = 'icon-pagenotfound red';
							break;
						default:
							break;
						}

						$scope.errorMsg = "<div class='error-message'><span class='"+ icon +" error'></span><span class='modal-description'>"+ $scope.errorMsg +"</span></div>"

						if ($scope.errorCode == 1000) {
							$scope.showBackToStoreLink = false

							var device = ClientInfo.deviceType.toLowerCase(),
								osName = ClientInfo.osName.toLowerCase(),
								//default url are for windows desktop users
								chrome = "www.google.com/chrome",
								opera= "http://www.opera.com/download/get/?partner=www&opsys=Windows",
								firefox= "www.getfirefox.com",
								safari = ""

							switch (device) {
							case "desktop":
								var mac = osName.indexOf("mac");
								if (mac > -1) {
									chrome = "http://appstore.com/chrome"
									opera = "https://itunes.apple.com/us/app/opera-mini-web-browser/id363729560?mt=8&uo=4"
									firefox = ""
								}
								break;
							default:
								switch (osName) {
								case "ios":
									chrome = "http://appstore.com/chrome"
									opera = "https://itunes.apple.com/us/app/opera-mini-web-browser/id363729560?mt=8&uo=4"
									firefox = ""
									break;
								case "android":

								/*
										For the Google Android Store.
										From a web site:
										http://play.google.com/store/apps/details?id=<package_name>
										From an Android App:
										market://details?id=<package_name>
										 */

									chrome = "market://details?id=com.android.chrome"
									firefox = "market://details?id=org.mozilla.firefox"
									opera = "market://details?id=com.opera.browser"

									break;
								}
								break;
							}

							$scope.errorMsg += "<div class='supported-browsers'>"

							if (chrome) {
								$scope.errorMsg += "<a class='btn "+ (!firefox?'single-btn':'') +"' href='"+ chrome +"'><span class='browsers sprite-firefox'></span></a>"
							}

							if (firefox) {
								$scope.errorMsg += "<a class='btn "+ (!chrome?'single-btn':'') +"' href='"+ firefox +"'><span class='browsers sprite-chrome'></span></a>"
							}

							$scope.errorMsg += "</div><div class='supported-browsers'>"

							if (opera) {
								$scope.errorMsg += "<a class='btn "+ (!safari?'single-btn':'') +"' href='"+ opera +"'><span class='browsers sprite-opera'></span></a>"
							}

							if (safari) {
								$scope.errorMsg += "<a class='btn "+ (!opera?'single-btn':'') +"' href='"+ safari +"'><span class='browsers sprite-safari'></span></a>"
							}
						}

						if ($scope.errorCode == 1004) {
							$scope.showBackToStoreLink = true
						}


						//closing the error message tag
						$scope.errorMsg +="</div>";
					} else {
						$scope.errorMsg = 'An error has occurred';
						if (!$scope.i18n.ButtonLabels) {
							$scope.i18n.ButtonLabels = {};
							$scope.i18n.ButtonLabels.resetButton = 'Try Again';
						}
					}

					Modal.displayModal(
						{
							category: 'Error',
							label: $scope.errorCode,
							description: $scope.errorMsg,
							//						, icon: icon
							buttonFlags: $scope.noButtons ? [] : [Enums.buttonFlags.RESET_BUTTON],
							hideAllButtons: !$scope.showBackToStoreLink,
							showCloseButton: false
						});
				} else {

				}
			}
			InitializeCtrl();
		}]);

/**
 * # KnowledgeBaseCtrl
 *
 * Controller that manages knowledge base modal

 @todo: DO NOT USE LOADING SERVICE FOR KNOWLEDGEBASE UNTIL THE API CODE IS UP TO THE 3.5 IMPLEMENTATION.
 @DONE @todo: IncrementReadCount on show of articles.
 @todo: implement a client side search.
 */
angular
	.module('app')
	.controller('KnowledgeBaseCtrl', function(
		$filter,
		$log,
		$scope,
		$stateParams,
		AnalyticsDataLayerService,
		AppData,
		AriaAnnouncer,
		ClientInfo,
		FocusService,
		Enums,
		KnowledgeBaseService,
		Language,
		Modal,
		Utilities,
		UtilsValidation
	) {
		var screenReaderCalloutLocale = Language.getLocale('KnowledgeBase', 'screenReaderCalloutFormat');
		var replaceAll = Language.replaceAll;
		var container = document.getElementById('faq-knowledge-articles-listbox');
		var keyCodes = {
			37: 'left',
			38: 'up',
			39: 'right',
			40: 'down',
			ArrowDown: 'down',
			ArrowLeft: 'left',
			ArrowRight: 'right',
			ArrowUp: 'up'
		};

		$scope.tabSelection = 'FAQs';
		$scope.articles = [];
		$scope.faqObject = {
			currentArticle: -1,
			articles: []
		};

		$scope.$watch('filterKb', function() {
			$scope.faqObject.articles = $filter('filter')($scope.articles, $scope.filterKb)
		});

		var init = function() {
			KnowledgeBaseService.getArticles()
				.then(function(data) {
					var articles = Utilities.safelyCheckPropertyOnObject('data.ARTICLES.A', data, function(val) {
						return val;
					});
					if (!$stateParams.disableFaqInModal) {
						KnowledgeBaseService.showFAQModal();
					}
					if (UtilsValidation.validArray(articles)) {
						$scope.articles = articles;
					} else if (UtilsValidation.isRealObject(articles)) {
						$scope.articles = [articles];
					}

					$scope.faqObject.articles = $scope.articles.slice(0);

					replaceSupportNumber();
					$scope.announceArticlesFound();
				}, function(error) {
				// promise rejected
					Modal.displayModal({
						action: 'Error',
						buttonFlags: [Enums.buttonFlags.OK],
						category: 'Knowledge Base',
						description: Language.getLocale('Alert', 'LoadFAQErrorMsg'),
						label: 'LoadFAQError Modal',
						title: Language.getLocale('Alert', 'loadFAQErrorTitle')
					});
	       });
		};

		/**
		 * Handles the base on keyup event for traversing articles with the keyboard.
		 * @public
		 * @param {Event} $event The event object
		 * @param {Number} index The current index
		 * @return {undefined}
		 */
		$scope.onKeyup = function($event, index) {
			var key = $event.code || $event.keyCode || $event.which;
			var pressed = keyCodes[key];

			if (!pressed || $event.defaultPrevented) {
				return;
			}

			switch (pressed) {
			case 'up':
			case 'down':
				$scope.handleUpDownArrow(pressed, index);
				break;
			case 'left':
			case 'right':
				$scope.handleLeftRightArrow(pressed, $event, index);
				break;
			}
		};

		/**
		 * Handles the left and right arrows when moving through articles.
		 * @public
		 * @param {String} pressed The pressed key either 'left' or 'right'
		 * @param {Event} $event The event object
		 * @param {Number} index The current index
		 * @return {undefined}
		 */
		$scope.handleLeftRightArrow = function(pressed, $event, index) {
			if (pressed === 'left') {
				if ($scope.faqObject.currentArticle === index) {
					$scope.faqObject.currentArticle = -1;
				}
			} else if ($scope.faqObject.currentArticle !== index) {
				$scope.incrementReadCount($event, index, $scope.faqObject.articles[index].id);
			}
		};

		/**
		 * Handles the up and down arrows when moving through articles.
		 * @public
		 * @param {String} pressed The pressed key either 'up' or 'down'
		 * @param {Number} index The current index
		 * @return {undefined}
		 */
		$scope.handleUpDownArrow = function(pressed, index) {
			var articles = $scope.faqObject.articles;
			var toIndex = null;

			if (pressed === 'up') {
				if (index === 0) {
					toIndex = articles.length - 1;
				} else {
					toIndex = index - 1;
				}
			} else {
				if (index === articles.length - 1) {
					toIndex = 0;
				} else {
					toIndex = index + 1;
				}
			}

			if (toIndex !== null) {
				document.getElementById('faq-modal-item-' + articles[toIndex].id + '-btn').focus();
			}
		};

		/**
		 * A Method used to track KB usage stats. This reports to google analytics
		 *  as events and pageviews, but also makes a service request to
		 *  "increment the read count" for KB views.
		 *
		 * @param  {Object} $event       The angular event
		 * @param  {Number} currentIndex Index of the currently selected article
		 * @param  {Number} articleId    ID of the currently selected article
		 *
		 */
		$scope.incrementReadCount = function($event, currentIndex, articleId) {
		// Prevent default behavior for spacebar (prevent scrolling when clicked)
			if ($event.keyCode == '32' || $event.code == 'Space') {
				$event.preventDefault();
			}

			// if the user is clicking an anchor tag then don't close the FAQ
			if ($event.target.nodeName === 'A') {
				return;
			}

			var lastChildIndex = container.children.length - 1;
			var search,
				article;

			// Only call if it's true.
			if (currentIndex > -1) {
				article = $scope.faqObject.articles[ currentIndex ];

				// attempting to close it.
				if ($scope.faqObject.currentArticle == currentIndex) {
					$scope.faqObject.currentArticle = -1;

					//else we're opening the KB item
				} else if ($scope.faqObject.currentArticle != currentIndex) {
					$scope.faqObject.currentArticle = currentIndex;

					try {
						AnalyticsDataLayerService.triggerInternalPageViewWithURL('/help/' + $scope.faqObject.articles[currentIndex].faq_link);
					} catch (e) {
						$log.error("Error Tracking Page View:", e);
					}

					//increment read count for backend
					AppData.fetch(Enums.services.INCREMENT_READ_COUNT, false, {
						article_id: articleId,
						kb_id: KnowledgeBaseService.getKbId()
					});

					// Necessary for scrolling the container to the bottom to show the content of the last FAQ when clicked
					if (lastChildIndex === currentIndex) {
						setTimeout(function() {
							container.scrollTop = container.scrollHeight;
						}, 100);
					}
				}

				article = null;
			}
		};

		/**
		 * Uses our AriaAnnouncer to announce some text that should be representative of
		 * what was typed and how many articles were found * relating to said search.
		 * @public
		 * @param {String} input what the user typed in the search box
		 * @returns {undefined}
		 */
		$scope.announceArticlesFound = function(input) {
			var updatedText = screenReaderCalloutLocale;
			var filteredArticles = $filter('filter')($scope.faqObject.articles, input);
			if (!UtilsValidation.validString(input)) {
				input = 'No Input'
			}

			updatedText = replaceAll('@@input', input, updatedText);
			updatedText = replaceAll('@@numberOfArticles', filteredArticles.length, updatedText);
			AriaAnnouncer.polite(updatedText);
		}

		function replaceSupportNumber() {
		// Only use phone hyperlinks for mobile devices
			if (ClientInfo.deviceType == 'mobile') {
				var supportPhoneNumber =
				'<a rel="external" target="_system" href="tel:' +
				AppData.settings.support_phone_number + '">' +
				AppData.settings.support_phone_number + '</a>';
			} else {
				var supportPhoneNumber = AppData.settings.support_phone_number;
			}

			// Replace @@supportPhoneNumber from the FAQ with value from settings.
			for (var i = 0; i < $scope.faqObject.articles.length; i++) {
				$scope.faqObject.articles[i].faq_text = Language.replaceAllMultiple(['@@supportPhoneNumber'], [supportPhoneNumber], $scope.faqObject.articles[i].faq_text);
			}
		}

		$scope.$watch('filterKb', function(newValue, oldValue) {
			if (angular.isDefined(newValue) && (newValue != oldValue)) {
				if (!Utilities.isEmpty(newValue)) {
					KnowledgeBaseService.searchArticles(newValue);
				}

				$scope.announceArticlesFound(newValue);

				// Reset the focus in the modal now that search results changed.
				FocusService.setFocusToContainer('modal', document.activeElement, document.activeElement);
			}
		});

		init();
	});

angular
	.module('app')
	.service('KnowledgeBaseService', function(
		$q,
		AppData,
		Enums,
		Language,
		Modal) {
		var service = {};

		/**
		 * Get the knowledgbase id to use for a request
		 * @returns {String|null} The knowledgbase id
		 */
		service.getKbId = function() {
			try {
				if (AppData.settings.knowledgebase_id) {
					kbId = JSON.parse(AppData.settings.knowledgebase_id);
					if (kbId[AppData.environment]) {
						return kbId[AppData.environment];
					}
				}
			} catch (ignore) {}

			return null;
		};

		service.getArticles = function() {
			var articleRequest = $q.defer(),
				kbId = service.getKbId();

			if (!kbId) {
				articleRequest.reject();
			} else {
				AppData
					.fetch(Enums.services.GET_ARTICLES_BY_DISPLAY_ORDER, true, {
						kb_id: kbId,
					})
					.then(function(data) {

						if (data.status == Enums.status.OK && angular.isDefined(data.ARTICLES.A)) {
							// Call success
							articleRequest.resolve(data);
						} else if (data.status == Enums.status.OK && typeof data.ARTICLES.A == 'undefined') {
							// Call success with no articles
							articleRequest.reject();
						} else {
							// Call fails
							articleRequest.reject();
						}
					});
			}

			return articleRequest.promise;
		};

		service.showFAQModal = function() {
			Modal.displayModal(
				{
					category: 'FAQ',
					action: 'FAQ',
					label: Language.getLocale('KnowledgeBase', 'pageHeading'),
					title: Language.getLocale('KnowledgeBase', 'pageHeading'),
					hideAllButtons: true,
					showCloseButton: true,
					customCss: 'large',
					view: Modal.NEW,
					customHTML: '/views/modals/faqs.html',
					headerFlag: Modal.DEFAULT
				}
			);
		};

		service.searchArticles = function(search) {
			var kbId = service.getKbId();
			if (kbId) {
				AppData.fetch(Enums.services.SEARCH_ARTICLES, true, {
					searchString: search,
					kb_id: kbId,
				});
			}
		};

		return service;
	});

/**
 * Created by ltischuk on 1/27/15.
 */
angular.module('app')
	.controller('CloseController', function() {
		window.close();
	});

angular
	.module('app')
	.controller('PackageListCtrl', PackageListCtrl);

/**
 * Package List Controller
 * @public
 * @constructor
 * @param {Service} $filter Filters
 * @param {Service} $log Logging service
 * @param {Service} $rootScope The rootscope
 * @param {Service} $scope The scope
 * @param {Service} $stateParams The state parameters
 * @param {Service} AnalyticsEnumsService Analytics Enums Service
 * @param {Service} AccessoLocaleModels The AccessoLocaleModel for locale replacements
 * @param {Service} AppData Our AppData service
 * @param {Service} ClientInfo Our Client Info service
 * @param {Service} DynamicCapacityPricingService Dynamic Capacity Service
 * @param {Service} ExtraFlow Our Extraflow service
 * @param {Service} Enums Our Enums service
 * @param {Service} JSONValidator The service
 * @param {Service} Language Our Locales service
 * @param {Service} Navigation Our Navigation service
 * @param {Service} Package Our Package service
 * @param {Service} RouteHistoryService Our Route History service
 * @param {Service} StandardFlowInitiatorService Our Flow Initiator service
 * @param {Service} Storage Our LocalStorage service
 * @param {Service} PackageList Our Package List service
 * @param {Service} Utilities Our Utilities service
 * @param {Service} UtilsValidation Our additional Utilities service
 * @return {Controller} self
 * @ngInject
 */
function PackageListCtrl(
	$filter,
	$log,
	$rootScope,
	$scope,
	$stateParams,
	AnalyticsEnumsService,
	AccessoLocaleModels,
	AppData,
	ClientInfo,
	DynamicCapacityPricingService,
	ExtraFlow,
	Enums,
	FeeService,
	Language,
	Navigation,
	Package,
	RouteHistoryService,
	StandardFlowInitiatorService,
	Storage,
	PackageList,
	Utilities,
	UtilsValidation
) {
	var consolidatedData = AppData.globalDependencies['GetApplicationConsolidated'],
		isObject = UtilsValidation.isRealObject,
		checkProp = Utilities.safelyCheckPropertyOnObject;

	var menuItems = AppData.menuItems;
	$scope.showNoPkgMsg = false;
	$scope.showSubMenu = true;
	$scope.showAllItems = false;
	$scope.isPromo = false;
	$scope.isWTPPromoCode = false;
	$scope.wtpPromoCodePkgsOverride = [];
	$scope.isMobile = ClientInfo.deviceType == "tablet" || ClientInfo.deviceType == "mobile";

	$scope.isMembership = PackageList.isMembership;
	$scope.showFeeNotice = FeeService.isPageActive(FeeService.enums.PACKAGE_LIST);

	$scope._checkForAndRouteToHiddenPromoNavTree = _checkForAndRouteToHiddenPromoNavTree;
	$scope.isKeywordActive = isKeywordActive;

	/*=======================================================
	* AppData Configurations
	=======================================================*/
	$scope.dateFormat = AppData.defaults.date_format;

	// @TODO: Consider using alternative to watch.
	var getKeywordMenuItems = $scope.$watch(function() {
		return AppData.keywordMenuItems;
	}, function(keywordMenuItems) {
		if (!keywordMenuItems) {
			return;
		}
		// Update the local property with the passed in service value.
		$scope.subMenuItems = keywordMenuItems;
		getKeywordMenuItems()
	});

	/**
	 * Initialiaze Controller contents
	 */
	var InitializeCtrl = function() {
		var kw = '',
			isPromo = false,
			isDefaulting = false,
			routeNavItem = false,
			keywordBasedNavigation = false;

		$scope.crossSellsEnabled = false;
		consolidatedData = AppData.globalDependencies['GetApplicationConsolidated'];

		// if we don't have any packages on this merchant, stop execution and display msg
		if (!checkProp('AppData.GetMerchantPackageList.PS.P', AppData)
			|| Utilities.getBoolean(PackageList.forceNoPackageFound)) {
			$scope.showNoPkgMsg = true;
			return;
		}

		// TODO: Make sure the Promo Code & Keyword matching is case insensitive
		if (angular.isDefined($stateParams.promocode)) {
			isPromo = true;
			kw = $stateParams.promocode;
			Storage.remove('pkgDetailsReInitControls', true);
			StandardFlowInitiatorService.resetStandardFlow();

			// Fetch the promocode.
			fetchPromoCodePackage();
			return;
		} else if (angular.isDefined($stateParams.crosssell)) {
			$scope.crossSellsEnabled = true;

			// We'll need to remove any XFC Flow
			kw = $stateParams.crosssell;
			Storage.remove('pkgDetailsReInitControls', true);
			StandardFlowInitiatorService.resetStandardFlow();
			$scope.showSubMenu = false;
		} else if (angular.isDefined($stateParams.keyword)) {
			kw = $stateParams.keyword;
			keywordBasedNavigation = true;
		} else if (angular.isDefined($stateParams.navItem)) {
			// lookup keywords based on nav item
			var keywords = findKeywords(decodeURIComponent($stateParams.navItem));

			if (keywords) {
				kw = keywords;
			} else {
				kw = '';
			}
		} else if (angular.isDefined($stateParams.packages)) {
			$log.log('SPECIFIC PACKAGES');
			setupPackages(undefined, decodeURI($stateParams.packages));
			return;
		} else if (typeof AppData.defaults.keyword != 'undefined' && AppData.defaults.keyword != '') {
			kw = AppData.defaults.keyword;
			isDefaulting = true;
		}

		// Is the keyword disabled?
		if (AppData.isDisabledKeyword(kw)) {
			// Erase keyword and set it up to be found in the navigation
			keywordBasedNavigation = false;
			kw = '';
		}

		var keywordActive = $scope.isKeywordActive(kw);
		var packAvailable = false;

		if (!keywordActive && !isPromo) {
			packAvailable = checkPackagesByKeyword(kw)
		}

		if (!kw || kw == '' || !(keywordActive || isPromo || packAvailable) && !keywordBasedNavigation) {
			kw = PackageList.getFirstKeywordLabelFromMenu();
			//if we lookup the label then we should be routing to packageList/navItem rather than packageList/keyword

			if (angular.isDefined(kw) && kw != "") {
				routeNavItem = true;
				isDefaulting = true;
			}
		}

		$scope.bannerLocales = getConfig(kw);

		// If we are using the first available label, need to
		// perform a lookup inside of hasAlternateRoute() to get
		// the keyword associated with the label
		var lookupKeywordFromLabel = isDefaulting;

		if (checkForAndRouteToAlternateModule(kw, lookupKeywordFromLabel)) {
			return;
		} else if (isDefaulting) {
			if (routeNavItem) {
				$scope.routeTo(Enums.routes.NAVITEM + '/' + kw, undefined, undefined, true);
			} else {
				$scope.routeTo(Enums.routes.LISTKEYWORD + '/' + kw, undefined, undefined, true);
			}
			return;
		} else {
			setupPackages(kw);
		}

		AppData.updateLastKeyword(kw, "packagelist InitializeCtrl");
		AppData.updateSelectedKeyword(kw);

		$scope.subMenuItems = getKeywordMenuByKeyword(kw);

		$scope.showNoPkgMsg = (PackageList.dataModel.packageList.length == 0);

		var keyword = $stateParams.keyword || $stateParams.navItem;
		if (angular.isDefined(keyword)) {
			keyword = Utilities.makeUnderscoreDelimited(keyword);
			if (angular.isDefined(AppData.settings['package_stacking_' + keyword]) && Utilities.getBoolean(AppData.settings['package_stacking_' + keyword])) {
				$scope.centerPackages = true;
			}
		}

		$rootScope.$broadcast('getLaunchType');
	};

	$scope.selectPackage = function($package_id) {
		var replace = false,
			stateName = '/packageDetails/:packageId',
			params = {
				packageId: $package_id
			};

		// Route the package by packageId.
		if (angular.isDefined(StandardFlowInitiatorService.currentStandardFlowType)) {
			params.flowType = StandardFlowInitiatorService.currentStandardFlowType;
			params.flowDetail = StandardFlowInitiatorService.currentStandardFlowDetail;
			stateName = 'packageDetails';
		}

		if (checkProp('$stateParams.dynamicPricing.' + $package_id, $stateParams, 'isRealObject')) {
			params.dynamicPricing = $stateParams.dynamicPricing[$package_id];
			replace = true;
		}

		// Unify all packages into one list
		var combinedPackages = [];
		PackageList.dataModel.packageList.forEach(function forEachPackageList(pkgList) {
			pkgList.forEach(function forEachPackage(pkg) {
				combinedPackages.push(pkg);
			});
		});

		// Update the last accessed package list for analytics purposes
		Package.updateLastAccessedPackageList(combinedPackages);

		// Show spinner eagerly to prevent previous view from flashing during route transition.
		// The destination controller or onSuccess hook dismisses it.
		$rootScope.showSpinner();
		Utilities.goTo(stateName, params, replace);
	};

	$scope.selectPackageList = function(route, packageId) {
		var stateName = 'packageDetails';
		var params = {
			packageId: packageId
		};

		if (angular.isDefined(StandardFlowInitiatorService.currentStandardFlowType)) {
			stateName = 'packageDetails';
			params.flowType = StandardFlowInitiatorService.currentStandardFlowType;
			params.flowDetail = StandardFlowInitiatorService.currentStandardFlowDetail;
		}

		if (checkProp('$stateParams.dynamicPricing.' + packageId, $stateParams, 'isRealObject')) {
			params.dynamicPricing = $stateParams.dynamicPricing[packageId];
		}

		// Show spinner eagerly to prevent previous view from flashing during route transition.
		// The destination controller or onSuccess hook dismisses it.
		$rootScope.showSpinner();
		return Utilities.goTo(stateName, params, true);
	};

	$scope.onKeywordMenuItemClick = function($event, data) {
		// Don't let event bubble up.
		Utilities.stopEventPropagation($event);
		// Set selected flag on item clicked.
		$scope.showAllItems = !$scope.showAllItems;

		if (data.subMenuItem.keywords != AppData.lastKeyword) {
			// Reset selected flag on all subMenuItems
			for (var i = 0; i < $scope.subMenuItems.length; i++) {
				$scope.subMenuItems[i].selected = false;
			}

			data.subMenuItem.selected = true;
			$scope.routeTo(Enums.routes.NAVITEM + '/' + data.subMenuItem.label);
		}
	};

	/**
	* function to set the new page view on DOM
	* @param $index{integer}
	*/
	$scope.handlePagination = function($index) {
		$scope.currentPageView = $index;
		$scope.previousPageView = $index > 0 ? $index : -1;
		//lets make them all false
		for (var i in $scope.pagination) {
			$scope.pagination[i].status = false;
		}
		//set the requested page to true
		$scope.pagination[$index].status = true;
	}

	/**
	* True, move forward, False move page back
	* @param boolean {boolean}
	*/
	$scope.movePage = function(boolean) {
		var position = getCurrentPageStatus();

		if (boolean) {
			position++;
		} else {
			position--;
		}

		if (position > -1 && position < $scope.pagination.length) {
			$scope.handlePagination(position);
		}
	}

	/*=======================================================
	* PRIVATE FUNCTIONS
	=======================================================*/

	function setupPackages(kw, packageIDs, overridePkgs) {
		var analyticsEventListener,
		keywordToCheck;

		//if we don't already have a flow set then set it here
		if (!StandardFlowInitiatorService.hasCurrentFlow()) {
			StandardFlowInitiatorService.setStandardFlow($stateParams);
		}

		if ($scope.isWTPPromoCode && angular.isDefined(overridePkgs)) {
			return routeForWTPPromoCodeFlow(overridePkgs);
		}

		if (angular.isDefined(kw)) {
			PackageList.getPackageKeywordList(kw);
		} else {
			PackageList.getPackagesByID(packageIDs);
		}

		$scope.dataModel = PackageList.dataModel;

		/**
		* If we are in promo mode - first check to see if we should route to an alternate module instead of the standard package list or package details.
		* Then check the first keyword from the datamodel for an alternate route if we have a data model.
		*/
		if (StandardFlowInitiatorService.currentStandardFlowType === 'promocode' && PackageList.dataModel.packageList.length) {
			keywordToCheck = angular.isArray(PackageList.dataModel.packageList[0]) ? PackageList.dataModel.packageList[0][0].keyword : PackageList.dataModel.packageList[0].keyword;

			if ($scope._checkForAndRouteToHiddenPromoNavTree(kw) || checkForAndRouteToAlternateModule(keywordToCheck)) {
				return;
			}
		}

		//Check if there is only one package, if so, check for route override or go to package details.
		if (PackageList.dataModel.packageList.length === 1) {
			var stateName = '/packageDetails/:packageId';
			var params = {};

			if (StandardFlowInitiatorService.hasCurrentFlow()) {
				stateName = 'packageDetails';
				params.flowType = StandardFlowInitiatorService.currentStandardFlowType;
				params.flowDetail = StandardFlowInitiatorService.currentStandardFlowDetail;
			}

			if (PackageList.dataModel.packageList[0].length === undefined && angular.isDefined(PackageList.dataModel.packageList[0].id)) {
				params.packageId = PackageList.dataModel.packageList[0].id;
			} else if (PackageList.dataModel.packageList[0].length === 1) {
				params.packageId = PackageList.dataModel.packageList[0][0].id;
			}

			if (params.packageId) {
				if (checkProp('$stateParams.dynamicPricing.' + params.packageId, $stateParams, 'isRealObject')) {
					params.dynamicPricing = $stateParams.dynamicPricing[params.packageId];
				}

				// Show spinner eagerly to prevent previous view from flashing during route transition.
				// The destination controller or onSuccess hook dismisses it.
				$rootScope.showSpinner();

				// This list never actually renders for the guest — tell UPD not to treat this
				// hop as a valid "back to list" origin (see UnifiedPackageDetailsService).
				$rootScope.$broadcast('packageListAutoForwarded');
				return Utilities.goTo(stateName, params, true);
			}
		}

		if (isObject($stateParams.dynamicPricing)) {
			PackageList.dataModel.packageList.forEach(function handleEachPackageList(pkg) {
				var pricing,
					ct;

				if (Array.isArray(pkg)) {
					pkg.forEach(handleEachPackageList);
				} else if (isObject(pkg)) {
					pricing = $stateParams.dynamicPricing[pkg.id];
					if (isObject(pricing)) {
						ct = Object.keys(pricing).reduce(function getLowestPriceDynamicPrice(currentLowest, nextCustomerTypeId) {
							var nextCustomerType = pricing[nextCustomerTypeId];
							if (!currentLowest) {
								return nextCustomerType;
							}

							return nextCustomerType.price < currentLowest.price ? nextCustomerType : currentLowest;
						}, null);

						pkg.showStartingLabel = true;
						pkg.startRate = $filter('currencyFormatter')((DynamicCapacityPricingService.getDynTotalPrice(ct)), $rootScope.currencyCode, $rootScope.languageSettings);
					}
				}
			});
		}

		// Loop through the package list and see if there is a package charac called "showMembershipTotals"
		// if so, then we need to grab the required attributes and set the locale swaps for that particular package
		$scope.dataModel.packageList.forEach(function combPackagesForMembershipLocaleCharac(pkg) {
			if (angular.isArray(pkg)) {
				pkg.forEach(combPackagesForMembershipLocaleCharac);
			} else if (isObject(pkg)) {
				if (checkProp('pkg.CHARACS.showMembershipTotals', pkg) && checkProp('pkg.monthly_rate', pkg) && checkProp('pkg.required_num_payments', pkg) && checkProp('pkg.comp_retail_amount', pkg)) {
					// Toggle flag to show membership totals locale
					pkg.showMembershipTotalsLocale = true;

					// Grab required attributes from the package
					const numPayments = pkg.required_num_payments;
					const minCTRetailAmount = pkg.monthly_rate;
					const minCTCompRetailAmount = pkg.comp_retail_amount;

					// Consolidate and format the price
					const consolidatedPrice = (parseFloat(numPayments) * parseFloat(minCTRetailAmount)) + parseFloat(minCTCompRetailAmount);
					const totalCost = $filter('currencyFormatter')(consolidatedPrice);

					// create the locale replacement list with the attributes above
					const replaceList = new AccessoLocaleModels.ReplacementList();
					replaceList.add('@@numMonths', numPayments);
					replaceList.add('@@minRetail', totalCost);
					pkg.membershipTotalLocaleSwap = replaceList.list;
				} else {
					// Set the toggle flag to false
					pkg.showMembershipTotalsLocale = false;
				}
			}
		});

		//Enhanced Ecommerce call
		analyticsEventListener = $rootScope.$on(AnalyticsEnumsService.events.POST_INTERNALSTATECHANGE, function fireAnalyticsAfterStateChange() {
			$rootScope.$broadcast('triggerImpressionsPackList', PackageList.dataModel.packageList, kw);
			analyticsEventListener(); //stop listening once fired
		});

		createPages();
	}

	/**
	* Check whether or not we're doing a promo code to the subkeyword module. If we are, then we need to use it.
	* @param {String} promoCode
	* @returns {Boolean} if we routed or not
	*/
	function _checkForAndRouteToHiddenPromoNavTree(promoCode) {
		var navigationLookup,
			view,
			path;

		if (!UtilsValidation.validString(promoCode)) {
			return false;
		}

		navigationLookup = Navigation.lookupTreeByProperty('label', 'APC_' + promoCode, true);
		if (!navigationLookup) {
			return false;
		}
		view = ExtraFlow.getAlternateFlowView(navigationLookup.alternateModule, promoCode);
		if (view) {
			path = ExtraFlow.isAlternateFlowViewRepresentedAsAStateName(navigationLookup.alternateModule) ? '' : '/' + navigationLookup.label;
			RouteHistoryService.registerNextRouteAsPromoRoute();

			$scope.routeTo(view + path, undefined, undefined, true);
			return true;
		}

		return false;
	}

	/**
	* Assess whether or not an alternate module is present on the item within the nav tree and if found, route accordingly to that modulekeyw
	* @param {String} keyword keyword
	* @param {String} lookupKeywordFromLabel lookup keyword
	* @returns {boolean} routed
	*/
	function checkForAndRouteToAlternateModule(keyword, lookupKeywordFromLabel) {
		if (angular.isUndefined(consolidatedData.TREE)) {
			return false;
		}

		// find the keyword associated with the label

		var lookupProperty = (lookupKeywordFromLabel) ? 'label' : 'keywords';
		var navigationLookup = Navigation.lookupTreeByProperty(lookupProperty, keyword);

		if (angular.isDefined(navigationLookup)) {
			if (angular.isDefined(navigationLookup.alternateModule) && navigationLookup.alternateModule.length > 0) {
				var view = ExtraFlow.getAlternateFlowView(navigationLookup.alternateModule, keyword);
				if (view) {
					var path = ExtraFlow.isAlternateFlowViewRepresentedAsAStateName(navigationLookup.alternateModule) ? '' : ('/' + navigationLookup.keywords);

					if (StandardFlowInitiatorService.currentStandardFlowType == 'promocode') {
						RouteHistoryService.registerNextRouteAsPromoRoute();
					}

					$scope.routeTo((view + path), undefined, undefined, true);
					return true;
				}
			}
		}

		return false;
	}

	/**
	* Creates pages for view on desktop or 1024<
	*/
	function createPages() {
		var rows = 2 //2 rows per page

		$scope.pagination = [];
		$scope.allPackages = [];
		$scope.currentPageView = 0;
		$scope.previousPageView = -1;

		for (var i = 0; i < PackageList.dataModel.packageList.length; i++) {
			var mod = i % 2;
			for (var j = 0; j < PackageList.dataModel.packageList[i].length; j++) {
				$scope.allPackages.push(PackageList.dataModel.packageList[i][j]);
			}
			//mod will build the array
			if (i % 2 == 0) {
				$scope.pagination.push({
					key: i,
					status: false,
					views: i + rows
				});
			}
		}

		if ($scope.pagination.length > 0) {
			//set the first page to true
			$scope.pagination[0].status = true;
		}

		//set the packageDetails route since we for sure know we are hitting package list
		StandardFlowInitiatorService.setStandardFlow($stateParams);
	}

	/**
	* Gets the current position of the Pagination
	* @returns {*|number}
	*/
	function getCurrentPageStatus() {
		for (var i in $scope.pagination) {
			if ($scope.pagination[i].status) {
				return Number(i);
			}
		}
	}

	/**
	 * routes to WTP module and passes packageIDs in hidden params
	 * @param {Array} pcPkgs packages for the promo code
	 */
	function routeForWTPPromoCodeFlow(pcPkgs) {
		var stateName = 'wtpnumber';
		var params = {
			wtpPromoCode: {
				promoCode: $stateParams.promocode,
				isWTPPromoCode: true
			}
		};
		return Utilities.goTo(stateName, params, true);
	}

	function isKeywordActive(keyword) {
		// Iterate through menu collection in AppData and validate keyword is active.
		// Reference to menu tree.
		var menuItemsKeywords;
		var i;
		var j;
		var k;
		keyword = keyword.trim().toLowerCase();
		for (i = 0; i < menuItems.length; i++) {
			if (menuItems[i].keywords.trim().toLowerCase() == keyword) {
				// TODO: This does not resolve for an inactive subKeyword with an active parent keyword of same value.
				// EG: parent keyword 'Daily Tickets' isactive = true
				//     sub keyword 'Daily Tickets' isactive = false.
				return menuItems[i].isactive;
			}

			if (menuItems[i].MENUITEM) {
				for (j = 0; j < menuItems[i].MENUITEM.length; j++) {
					if (menuItems[i].MENUITEM[j].keywords.toLowerCase() === keyword) {
						return menuItems[i].MENUITEM[j].isactive;
					}
				}
			}

			menuItemsKeywords = menuItems[i].keywords.trim().toLowerCase().split(',');
			for (k = 0; k < menuItemsKeywords.length; k++) {
				if (menuItemsKeywords[k] === keyword) {

					// TODO: This does not resolve for an inactive subKeyword with an active parent keyword of same value.
					// EG: parent keyword 'Daily Tickets' isactive = true
					//     sub keyword 'Daily Tickets' isactive = false.
					return menuItems[i].isactive;
				}
			}

		}

		return false;
	}

	function findKeywords(navItem) {
		navItem = decodeURIComponent(navItem.trim().toLowerCase());
		return findKeywordInMenuItems(menuItems, navItem, 0);
	}

	var MAX_MENU_DEPTH = 3;

	// Recurses into nested MENUITEM children (child, grandchild) since side-nav items can be 3 levels deep.
	// Capped at MAX_MENU_DEPTH so a misconfigured 4th level (unreachable in the rendered menu) is never matched.
	function findKeywordInMenuItems(items, navItem, depth) {
		for (var i = 0; i < items.length; i++) {
			if (items[i].label.trim().toLowerCase() == navItem) {
				// TODO: This does not resolve for an inactive subKeyword with an active parent keyword of same value.
				// EG: parent keyword 'Daily Tickets' isactive = true
				//     sub keyword 'Daily Tickets' isactive = false.
				return items[i].keywords;
			}

			if (depth < MAX_MENU_DEPTH - 1 && items[i].MENUITEM) {
				var found = findKeywordInMenuItems(items[i].MENUITEM, navItem, depth + 1);
				// found can legitimately be '' (a matched item with no keyword), so check against
				// the sentinel value explicitly rather than relying on truthiness.
				if (found !== false) {
					return found;
				}
			}
		}

		return false;
	}

	function checkPackagesByKeyword(keyword) {
		// Check for Packages with keyword and ensure thos packages are active.
		keyword = keyword.trim().toLowerCase();
		for (var i = 0; i < PackageList.packages.length; i++) {
			var itm = PackageList.packages[i];

			if (!itm || !itm.keyword) {
				continue;
			}

			var kws = itm.keyword
				.split(', ').join()
				.toLowerCase().trim()
				.split(',')
				.concat
				(
					itm.assoc_keywords
						.split(', ').join()
						.toLowerCase().trim()
						.split(',')
				);

			for (var j = 0; j < kws.length; j++) {
				var kw = kws[j];
				if (keyword == kw) {
					return true;
				}
			}
		}

		return false;
	}

	function getKeywordMenuByKeyword(keyword) {
		var kw = '';
		var broke = false;

		for (var i = 0; i < menuItems.length; i++) {
			if (broke) {
				break;
			}

			// First check if this is a parent menu and if so check its subkeywords.
			if (menuItems[i].MENUITEM) {
				if (menuItems[i].keywords == keyword) {
					//menuItems[ i ].selected = true;
					menuItems[i].showSubMenu = true;
					//menuItems[ i ].MENUITEM[ 0 ].selected = true;
					AppData.keywordMenuItems = menuItems[i].MENUITEM;
					break;
				} else {
					for (var j = 0; j < menuItems[i].MENUITEM.length; j++) {
						if (menuItems[i].MENUITEM[j].keywords == keyword) {
							//menuItems[ i ].selected = true;
							menuItems[i].showSubMenu = true;
							//menuItems[ i ].MENUITEM[ j ].selected = true;
							AppData.keywordMenuItems = menuItems[i].MENUITEM;
							broke = true;
							break;
						}
					}
				}
			} else if (menuItems[i].keywords == keyword) {
				// If it's not a prent menu item, check the keyword for this item.
				//menuItems[ i ].selected = true;
				AppData.keywordMenuItems = [menuItems[i]];
				break;
			}

			if (broke) {
				break;
			}
		}
		return AppData.keywordMenuItems;
	}

	function fetchPromoCodePackage() {
		$scope.searchingForPromoMsgLocale = Language.getLocale('ApplicationLabels', 'searchingForPromoMsg');

		$scope.showSpinner($scope.searchingForPromoMsgLocale);
		PackageList.requestPending = true;
		AppData.fetch(Enums.services.GET_MERCHANT_PACKAGE_LIST, false, {
			promos_only: 'Y',
			promo_codes: $stateParams.promocode,
			show_details: '1',
			long_desc_flag: '1'
		}).then(function(data) {
			if (data.status == Enums.status.OK) {
				if (checkProp('data.PS.P', data)) {
					filterPromosByLan(data);
					if (data.PS.P.length) {
						handlePackageListUpdates(data, $stateParams.promocode);
						$scope.isPromo = true;
						$scope.isWTPPromoCode = isWTPPromoCode(data.PS.P);
						if ($scope.isWTPPromoCode) {
							setupPackages($stateParams.promocode, undefined, data.PS.P);
						} else {
							setupPackages($stateParams.promocode);
						}
						$scope.showNoPkgMsg = (PackageList.dataModel.packageList.length == 0);
					}
				}
			} else if (data.status == Enums.status.FAILED) {
				// The request failed.
				$scope.showNoPkgMsg = true;

				// Hide the keyword nav if no packages are loaded.
				// @TODO: Should we just use one flag for both?
				$scope.showSubMenu = false;
			}

			PackageList.requestPending = false;
			if (!PackageList.requestPending) {
				$scope.hideSpinner();
			}
		})
	}

	function filterPromosByLan(data) {
		for (var i = 0; i < data.PS.P.length; i++) {
			var item = data.PS.P[i];
			if (item.CHARACS &&
				item.CHARACS.language &&
				item.CHARACS.language !== AppData.language) {
				data.PS.P.splice(i, 1);
				i--;
			}
		}
	}

	/**
	 * Determines if all of the returned packages are WTP packages
	 * @param {Array} pkgList
	 * @returns {boolean} true/false
	 */
	function isWTPPromoCode(pkgList) {
		return pkgList.every(function checkForWTP(item) {
			return checkProp('item.CHARACS.wtp_reload', item, 'returnValue') === '1';
		});
	}

	function handlePackageListUpdates(data, filter) {
		var packages = ((data || {}).PS || {}).P || [];
		// Handle package list update. This happens when we get a promocode request.
		packages = angular.isArray(packages) ? packages : [packages];

		for (var i in packages) {
			var hasItem = false;
			for (var j in PackageList.packages) {
				hasItem = PackageList.packages[j].id == packages[i].id;
				if (hasItem) {
					$scope.isPromo = true;
					addPromoDetails(PackageList.packages[j])
					break;
				}
			}

			if (!hasItem) {
				PackageList.packages.push(packages[i]);
				// Append the code to the system.
				if (typeof packages[i].promo_code != 'undefined') {
					appendPromoCodeToStorage(packages[i].promo_code.toString());
					appendPromoPackageToPackageData(data);
				}
			}
		}

		if (filter) {
			PackageList.getPackageKeywordList(filter);
			$scope.showSubMenu = false;
		}

		PackageList.isPromoFlow = true;
	}

	function addPromoDetails(packageData) {
		// Some promo packages don't contain the promo_code property and that can be problematic.
		// This block adds the promo_code property to the package if it doesn't already exist and
		// only if its applicable (i.e. promocode exists in the URL).
		var defInURL = angular.isDefined($stateParams.promocode);
		var defInProp = angular.isDefined(packageData.promo_code);
		var indexOfProp =
			(
				defInProp &&
				(packageData.promo_code.toLowerCase().indexOf($stateParams.promocode.toLowerCase()) > -1)
			);

		if (defInURL && (!defInProp || !indexOfProp)) {
			if (!packageData.isPromo) {
				packageData.promoAndPackage = true;
			}
			packageData.promo_code = $stateParams.promocode;
			packageData.isPromo = true;
		}
	}

	function appendPromoCodeToStorage(pendingPromoCode) {
		if (AppData.promoCodes.indexOf(pendingPromoCode) == -1) {
			// We have a promo_code, NOT in the pending_promo_codes list, let's add it.
			AppData.promoCodes.push(pendingPromoCode);
			// update the LocalStorage.
			AppData.Storage.set('promo_codes', AppData.promoCodes, true);
		}
	}

	function appendPromoPackageToPackageData(data) {
		// We've received a promocode package and need to append it to the packagelist data.
		var replaced = false;
		var packageListData = AppData.GetMerchantPackageList;

		for (var i = 0; i < data.PS.P.length; i++) {
			var pItem = data.PS.P[i];
			pItem.isPromo = true;

			if ((!angular.isDefined(packageListData) || packageListData.status == Enums.status.FAILED) && !replaced) {
				// This accounts for situations where no packages are defined and user loaded a promocode.
				// The packages data will have a status of FAILED. Overwrite the response on AppData with data.
				// Do this exactly once.
				AppData.GetMerchantPackageList = data;
				packageListData = data;
				replaced = true;
			} else {
				// Append the response with the packages from data.
				//check if we don't already have the current promo item in the actual AppData.GetMerchantPackageList object
				var inCurrentPackageListData = (packageListData.PS.P.filter(function(p) {
					return p.id === pItem.id
				}).length === 1);

				if (!PackageList.packageExists(pItem.id) && !inCurrentPackageListData) {
					// Added conversion to an Array because this is throwing an error otherwise
					packageListData.PS.P = angular.isArray(packageListData.PS.P) ? packageListData.PS.P : [packageListData.PS.P];
					packageListData.PS.P.push(pItem);
				}
			}
		}
	}

	/**
	 * Get a package list app config based on a keyword and prop
	 * @function
	 * @name getConfig
	 * @param {String} keyword The current keyword used with the Package List
	 * @returns {string} Whatever is set in the config
	 */
	function getConfig(keyword) {
		var config;
		try {
			config = JSON.parse(AppData.settings.package_list);
			return config.find(function iterateConfig(configObj) {
				return configObj.keyword === keyword;
			});
		} catch (ignore) {
			// ignore
		}

		return null;
	}

	InitializeCtrl();
}

angular
	.module('app')
	.controller('PaymentProviderCtrl', function(
		$location,
		$rootScope,
		$state,
		$scope,
		$window,
		AppData,
		LegacyCart,
		Purchase,
		Enums,
		Language,
		Modal,
		UserInfo,
		Utilities,
		Storage
	) {
		var vm = this;

		$scope.paymentProvider = {};

		function handleRedirect() {
			//TODO: Suppress Cart Abandonment
			var payment = UserInfo.payment;
			var isMrCash = (payment.authType == Enums.billingTypes.MISTERCASH);
			var isIdeal = (payment.authType == Enums.billingTypes.IDEAL);
			var isInIFrame = Utilities.isInIFrame();
			Storage.set('_cartAbandonment', AppData.settings.cart_abandonment);
			AppData.settings.cart_abandonment = false;

			if (isInIFrame && (isMrCash || isIdeal)) {
				promptForMrCashIdealWindow(isMrCash);
			} else {
				if (isIdeal) {
					redirectPage();
				} else {
					submitFormPost(isInIFrame);
				}
			}
		}

		function redirectPage() {
			$window.location.href = $scope.paymentProvider.redirect_url;
		}

		function submitFormPost(isInIFrame) {
			document.getElementById('paymentProviderForm').action = $scope.paymentProvider.redirect_url;
			document.getElementById('paymentProviderForm').method = $scope.paymentProvider.http_method;
			document.getElementById('paymentProviderForm').enctype = $scope.paymentProvider.content_type;

			if (isInIFrame) {
				document.getElementById('paymentProviderForm').target = 'providerWindow';
				document.getElementById('paymentProviderForm').onsubmit = function(e) {
					openProviderWindow();
					return true;
				}
			}

			document.getElementById('paymentProviderForm').submit();
			return true;
		}

		function openProviderWindow() {
			window.open($scope.paymentProvider.redirect_url, 'providerWindow');
		}

		function promptForMrCashIdealWindow(isMrCash) {
			$rootScope.hideSpinner();

			var localeTitle = isMrCash ? Language.getLocale('Purchase', 'redirectMrCashTitle') : Language.getLocale('Purchase', 'redirectIdealTitle');
			var localeMsg = isMrCash ? Language.getLocale('Purchase', 'redirectMrCashMsg') : Language.getLocale('Purchase', 'redirectIdealMsg');
			Modal.displayModal({
				category: 'Payment Provider',
				action: 'Confirm',
				label: 'Payment Provider Redirect',
				title: localeTitle,
				icon: (isMrCash ? 'sprite sprite-mrcash' : 'sprite sprite-ideal'),
				description: localeMsg,
				buttonFlags: [Enums.buttonFlags.OK],
				showCloseButton: false,
				callback: function(detail) {
					if (detail == Enums.buttonFlags.OK) {
						handleMrCashIdealWindowOpen(isMrCash);
					}
				}
			});
		}

		function handleMrCashIdealWindowOpen(isMrCash) {
			if (isMrCash) {
				submitFormPost(true);
			} else {
				openProviderWindow();
			}
			var localeTitle = isMrCash ? Language.getLocale('Purchase', 'confirmAuthMrCashTitle') : Language.getLocale('Purchase', 'confirmAuthIdealTitle');
			var localeMsg = isMrCash ? Language.getLocale('Purchase', 'confirmAuthMrCashMsg') : Language.getLocale('Purchase', 'confirmAuthIdealMsg');

			Modal.displayModal({
				category: 'Payment Provider',
				action: 'Confirm',
				label: 'Payment Provider Redirect',
				title: localeTitle,
				icon: (isMrCash ? 'sprite sprite-mrcash' : 'sprite sprite-ideal'),
				description: localeMsg,
				buttonFlags: [Enums.buttonFlags.OK],
				showCloseButton: false,
				callback: function(detail) {
					if (detail == Enums.buttonFlags.OK) {
						Purchase.executePurchase(Purchase.defaultPostPurchaseSuccess);
					}
				}
			});
		}


		function InitializeCtrl() {
			if (!$scope.hasItemsInCart()) {
				$scope.routeTo(Enums.routes.LIST);
				return;
			}

			Storage.set('_cartDetails', LegacyCart.cartDetails);
			Storage.set('_cartTotal', LegacyCart.total);
			Storage.set('_savedBilling', UserInfo.billing);
			Storage.set('_savedShipping', UserInfo.shipping);
			Storage.set('_savedPayment', UserInfo.payment);

			var total = LegacyCart.total;
			var billing = UserInfo.billing;
			var payment = UserInfo.payment;
			var payMethDetails = getPayMethDetails(payment);

			$scope.heading = payMethDetails.heading;
			$scope.instructions = payMethDetails.instructions;

			var message = {
				merchant_id: payment.cepayMerchantId,
				amount: total,
				success_url: payMethDetails.success,
				failure_url: payMethDetails.failed,
				customer: {
					email: billing.email,
					ip: AppData.clientIP,
					title: 'title',
					first_name: billing.firstName,
					last_name: billing.lastName,
					street: billing.address,
					city: billing.city,
					postcode: billing.zip,
					country: billing.country,
					language: AppData.language
				}
			};

			if (payment.authType == Enums.billingTypes.IDEAL && payment.bankId) {
				message.issuer_id = payment.bankId;
			}

			if (payMethDetails.requestType) {
				// Show the spinner.
				$scope.showSpinner(Language.getLocale('ApplicationLabels', 'purchaseLoadMsg'));
				AppData.fetch(
					payMethDetails.requestType
					, true
					, message
					, true
				).then(function(data) {
					$scope.hideSpinner();
					var display_message = Language.getLocale('ApplicationLabels', 'paymentRedirectMsg') ? Language.getLocale('ApplicationLabels', 'paymentRedirectMsg') : data.display_message;
					$scope.showSpinner(display_message);
					if (data.auth_id) {
						payment.auth_id = data.auth_id;
						UserInfo.set('payment', payment);
					}

					if (data.status == Enums.status.OK && data.redirect_url) {
						if (data.param) {
							$scope.paymentProvider.params = angular.isArray(data.param) ? data.param : [data.param];
						}
						if (payment.authType == Enums.billingTypes.IDEAL) {
							var queryString = ''
							if (((($scope).paymentProvider || {}).params || []).length) {
								if (data.redirect_url.indexOf('?') > -1) {
									queryString = '&'
								} else {
									queryString = '?'
								}
								for (var i in $scope.paymentProvider.params) {
									queryString += param.name.toString()+'='+param.value.toString();
									if (i < ($scope.params.length - 1)) {
										queryString += '&';
									}
								}
							}
							$scope.paymentProvider.redirect_url = data.redirect_url + queryString;
						} else {
							$scope.paymentProvider.redirect_url = data.redirect_url;
							if ((data.http_method.toUpperCase() == 'GET' || data.http_method.toUpperCase() == 'POST') &&
										payment.authType == Enums.billingTypes.MISTERCASH
							) {
								$scope.paymentProvider.http_method = data.http_method;
							} else {
								$scope.paymentProvider.http_method = 'GET';
							}
							$scope.paymentProvider.content_type = data.content_type;
						}

						Purchase.savePurchase(handleRedirect);
					} else {
						$scope.hideSpinner();
						Modal.displayModal(
							{
								category: 'Payment [Auth Error]',
								action: 'Error',
								label: 'Auth Error',
								title: Language.getLocale('Alert', 'errorPaymentProviderTitle'),
								icon: 'icon-info red',
								description: Language.getLocale('Alert', 'errorPaymentProviderMsg'),
								buttonFlags: [Enums.buttonFlags.OK],
								callback: function(detail) {
									$rootScope.routeTo(Enums.routes.CART);
								}
							}
						);
					}
				});
			} else {
				$scope.hideSpinner();
				Modal.displayModal(
					{
						category: 'Payment [Invalid Processor]',
						action: 'Error',
						label: 'Invalid Processor',
						title: Language.getLocale('Alert', 'errorPaymentProviderTitle'),
						icon: 'icon-info red',
						description: Language.getLocale('Alert', 'errorPaymentProviderMsg'),
						buttonFlags: [Enums.buttonFlags.OK],
						callback: function(detail) {
							$rootScope.routeTo(Enums.routes.CART);
						}
					}
				);
			}
		}

		function getPayMethDetails(payment) {
			var isIFrame = Utilities.isInIFrame();
			Language.MrCash = Language.MrCash || {};
			Language.IDeal = Language.IDeal || {};
			var isIdeal = (payment.authType == Enums.billingTypes.IDEAL);
			var isMrCash = (payment.authType == Enums.billingTypes.MISTERCASH);

			var successURL = '',
				failureURL = '',
				requestType = '',
				merchant = Utilities.getMerchant(),
				absURL = $location.$$absUrl,
				getParams = absURL.split('?')[ 1 ] || '',
				heading = '',
				instructions = '';

			if (isIFrame && (isIdeal || isMrCash)) {
				successURL = absURL.substring(0, absURL.lastIndexOf('/')) + $state.href('close');
				failureURL = absURL.substring(0, absURL.lastIndexOf('/')) + $state.href('close');
			} else {
				var returnURL =
						absURL.substring(0, absURL.lastIndexOf('/'))
						+ '/paymentResults?'
						+ getParams
						+ '&cart_key=' + AppData.cart.cart_key
						+ '&cart_id=' + AppData.cart.cart_id
						+ '&session_id=' + AppData.cart.session_id
						+ '&status=';

				returnURL = returnURL.split();

				successURL = returnURL + 'success';
				failureURL = returnURL + 'failure';
			}


			if (isMrCash) {
				requestType = Enums.services.MRCASH_AUTH;
				if (!isIFrame) {
					successURL += '&request_type=mrcash';
					failureURL += '&request_type=mrcash';
					heading = Language.MrCash.heading;
					instructions = Language.MrCash.instructions;
				}
			} else if (isIdeal && payment.bankId) {
				requestType = Enums.services.IDEAL_AUTH;
				if (!isIFrame) {
					successURL += '&request_type=ideal';
					failureURL += '&request_type=ideal';
					heading = Language.IDeal.heading;
					instructions = Language.IDeal.instructions;
				}
			}

			//Handle issues with IE9
			successURL = successURL.replace('/#', '');
			failureURL = failureURL.replace('/#', '');

			var obj =
					{
						success: successURL,
						failed: failureURL,
						heading: heading,
						instructions: instructions,
						requestType: requestType
					};

			return obj;
		}

		vm.$onInit = InitializeCtrl;
	});

angular
	.module('app')
	.controller('MainMenuCtrl', function (
		$log,
		$rootScope,
		$scope,
		$state,
		$stateParams,
		$timeout,
		$uibModal,
		AppData,
		AnalyticsDataLayerService,
		Banner,
		BannerEnums,
		ClientInfo,
		CustomActionService,
		Enums,
		ExtraFlow,
		Package,
		FocusService,
		JSONValidator,
		KnowledgeBaseService,
		Language,
		Logging,
		Modal,
		Navigation,
		GuestProfileMenuService,
		ProfileLoginSessionService,
		ProfileLoginPrepService,
		Storage,
		Utilities
	) {
		var keywordInitialized = false;
		var mainContent;

		$timeout(function () {
			mainContent = angular.element(document.getElementById('application-view'));
		}, 3000);

		$rootScope.deviceType = ClientInfo.deviceType.toLowerCase()
		$rootScope.browserName = ClientInfo.browserName.toLowerCase()
		$rootScope.engineName = ClientInfo.engineName.toLowerCase()
		$rootScope.engineVersion = Math.floor(Number(ClientInfo.engineVersion.toLowerCase())) <= 5 ? 'legacy' : 'modern'

		$scope.cartAbandonment = false;
		$scope.appVersion = window.version;
		$scope.menuLinks = [];
		$scope.securityProvider = {};
		$scope.showSecurityProvider = false;
		$scope.menuItems = [];
		$scope.subMenuItems = [];
		$scope.copyrightInfo = '&copy; ' + Utilities.getYear() + ' accesso Technology Group, plc';

		$scope.showAllItems = false;
		$scope.promoCode = { code: '' };
		$scope.routes = Enums.routes;
		$scope.year = Utilities.getYear();
		$scope.menuOpen = $rootScope.state.showMainMenu;

		// Show or hide the navigation theme.
		$rootScope.haloTheme = false;

		// Controls the view of the top navigation in application.
		$rootScope.showMenuBtn = true;
		$rootScope.showTitle = true;
		$rootScope.showCartBtn = true;

		$scope.i18n = Language;

		$scope.initialize = initialize;

		$scope.clearTextField = function () {
			// Clears the promobox field.
			$scope.promoCode = { code: '' };
		};

		//variable to determine if we are logged into the session
		$scope.isLoggedIn = function () {
			return ProfileLoginSessionService.isLoggedIn();
		};

		/**
		 * Route back to sign in
		 */
		$scope.routeToProfile = function () {
			ProfileLoginPrepService.determineProfileRouting();
		};

		$scope.handleProfileNavClick = function handleProfileNavClick() {
			GuestProfileMenuService.handleNavClick();
		};

		var removeAppActivated;
		if (AppData.applicationActivated) {
			$scope.initialize();
			// Add fee-inclusive banner once during initial load
			addFeeInclusiveBanner();
		} else {
			removeAppActivated = $rootScope.$on(Enums.services.APP_ACTIVATED, function initializeApp() {
				$scope.initialize();
				// Add fee-inclusive banner once when app becomes activated
				addFeeInclusiveBanner();
			});
		}

		$scope.merchant = Utilities.getMerchant();

		$scope.showCartRecoveryModal = function () {
			$uibModal.open(
				{
					templateUrl: '/views/modals/cartRecovery.html',
					controller: 'CartRecoveryModalCtrl'
				}
			)
		}

		$scope.changeRatioContrast = function () {
			$rootScope.contrastRatioToggle = $rootScope.contrastRatioToggle == "on" ? "off" : "on";
			AnalyticsDataLayerService.triggerAnalyticsEvent(
				Utilities.generateEventData('ADA', 'click', 'High Contrast Mode - Turned ' + $rootScope.contrastRatioToggle)
			);
		}

		$scope.targetMainContent = function () {
			mainContent[0].focus();
		}

		$scope.submitPromo = function () {
			$rootScope.$broadcast('navbarOrMenuClicked');
			this.promoForm.submitted = true;

			if (angular.isUndefined($scope.promoCode.code)) {
				return;
			}

			if ($scope.promoCode.code.indexOf(':') > -1) {
				Modal.hideModal(Enums.buttonFlags.SUBMIT, Language.getLocale('Accessibility', 'modalConfirmAndCloseButton'));
				switch ($scope.promoCode.code) {
					case ":debug":
					case ":_d":
						Logging.enabled = true;
						return true;

					case ":stop":
					case ":s":
						Logging.enabled = false;
						return true;

					case ":clearlog":
					case ":cl":
						console.clear();
						return true;

					case ":clearall":
					case ":ca":
					case ":c":
					case ":clear":
						Utilities.routeTo('reset/true');
						return true;

					case ":lso":
					case ":ls":
						$rootScope.state.debugMenu = true;
						return true;

					case ":version":
					case ":_v":
						$rootScope.state.debugMenu = true;
						return true;

					case ":devmode":
					case ":dm":
					case ":p":
						$stateParams._d = true;
						$rootScope.develop = true;
						Logging.enabled = true;
						$scope.autofill = true;
						return true;

					default:
						break;
				}
			} else if ($scope.promoCode.code.indexOf('=') > -1) {
				Modal.hideModal(Enums.buttonFlags.SUBMIT, Language.getLocale('Accessibility', 'modalConfirmAndCloseButton'));
				var keyval = $scope.promoCode.code.split('=');
				$stateParams[keyval[0]] = keyval[1];

				if (keyval[0] === '_d') {
					$rootScope.develop = keyval[1] === 'true';
					Logging.enabled = $rootScope.develop;
				}
			} else if (this.promoForm.$valid) {
				Modal.hideModal(Enums.buttonFlags.SUBMIT, Language.getLocale('Accessibility', 'modalConfirmAndCloseButton'));
				$rootScope.state.showMainMenu = false;

				// Encoding the promocode helps resolve most special character issues, except when / is used, so we must strip it out.
				var promocode = encodeURIComponent($scope.promoCode.code.replace(/\//g, ''));

				$timeout(function () {
					// Route to package list with promocode param.
					$scope.routeTo(Enums.routes.LIST + '/' + Enums.routes.PROMO + '/' + promocode);
				}, $rootScope.speed);
			}

			FocusService.setFocusToError(true);
		};

		$scope.triggerPromoBox = function () {
			// Reset the subMenuItems of the specific menu clicked
			$scope.menuItems.forEach(function resetMenuItem(item) {
				item.selected = false;
				item.submenuSelected = false;

				resetMenuItemSelected(item.MENUITEM);
			});

			Utilities.goTo('promo-code');
		};

		$scope.isPromoStateActive = function () {
			return $state.includes('promo-code');
		};

		// Exposes toggle menu function to the view
		$scope.toggleMenu = function (label) {
			if (typeof label != 'undefined') {
				var action = $rootScope.state.showMainMenu ? 'Close' : 'Open';
			}
			Utilities.toggleMenu();
			$scope.menuOpen = $rootScope.state.showMainMenu;
		}

		/**
		 *
		 * @param fromNavigationMenu If set to true, the navigation menu visibility is toggled
		 */
		$scope.showSSLModal = function (fromNavigationMenu) {
			if (typeof fromNavigationMenu !== 'undefined' && fromNavigationMenu) {
				$scope.toggleMenu('Security Provider');
			}

			var desc = '<span title="' + AppData.GetApplicationConsolidated.SETTINGS.security_provider + '" class="sprite ssl-modal-img ' + $scope.securityProvider.provider + '2x"></span><br>' + $scope.securityProvider.message;

			Modal.displayModal({
				category: 'Security Provider',
				action: 'View',
				label: $scope.securityProvider.title,
				title: $scope.securityProvider.title,
				description: desc,
				headerFlag: Modal.DEFAULT,
				buttonFlags: [Enums.buttonFlags.CANCEL, Enums.buttonFlags.VERIFY],
				callback: function (detail) {
					if (detail == Enums.buttonFlags.VERIFY) {
						window.open($scope.securityProvider.link, 'SSL')
					}
				}
			});
		}

		$scope.openAppStore = function () {
			Utilities.openAppStore($rootScope.appStoreURL);
		}

		$scope.menuButtonHandler = function (button) {
			$rootScope.$broadcast('navbarOrMenuClicked');
			switch (button) {
				case 'menuView':
					$scope.toggleMenu('Menu Button');
					break;
				case 'cartView':
					var customActionResult = CustomActionService.executeCustomAction('checkoutWizard');
					if (!customActionResult) {
						$scope.routeTo('cartView');
					}
					break;
				case 'knowledgeBaseView':
					AppData.isInCheckout = false;
					$scope.routeTo('knowledgeBaseView', true);
					break;
				default:
					break;
			}
		};

		/**
		 * Returns just the third-level sub menus.
		 * @param {AppConfig.NAV_TREE.MENUITEM} deskMenu The current menu item
		 * @returns {Object[]} The third-level sub menus
		 */
		$scope.getNavigationTieredSubMenus = function (deskMenu) {
			var menus = [];

			if (Array.isArray(deskMenu.MENUITEM)) {
				deskMenu.MENUITEM.forEach(function (submenu) {
					if (Array.isArray(submenu.MENUITEM)) {
						menus.push(submenu);
					}
				});
			}

			return menus;
		};

		$scope.showFAQModal = function () {
			KnowledgeBaseService.showFAQModal();
		};

		//Handle click for the arrow area
		$scope.onArrowClick = function ($event, data) {
			var shouldShowSubMenu = !data.menuItem.showSubMenu;

			resetOnMenuItemClick($event, false);

			data.menuItem.selected = shouldShowSubMenu;
			data.menuItem.showSubMenu = shouldShowSubMenu;
			data.menuItem.submenuSelected = false;

			// If item clicked has MENUITEM, set subMenuItems as MENUITEM
			// otherwise set it to the selected item.
			// NOTE: Updating service data directly.
			AppData.keywordMenuItems = data.menuItem.MENUITEM;
		};

		$scope.onMenuItemClick = function ($event, data) {
			resetOnMenuItemClick($event, true);

			$scope.toggleMenu();
			Utilities.scrollPosition();

			data.menuItem.selected = true;
			data.menuItem.submenuSelected = false;
			data.menuItem.showSubMenu = false;

			// NOTE: Updating service data directly.
			AppData.keywordMenuItems = [data.menuItem];

			if (data.menuItem.alternateModule) {
				// There's an alternateFlowModule and it's enabled.
				Package.resetAdvancedTicket();
				var view = ExtraFlow.getAlternateFlowView(data.menuItem.alternateModule, data.menuItem.keywords);
				if (view) {
					var path = ExtraFlow.isAlternateFlowViewRepresentedAsAStateName(data.menuItem.alternateModule) ? '' : '/' + data.menuItem.keywords;
					$scope.routeTo(view + path);
					return;
				}
			}

			$scope.routeTo($state.href('packageList/navItem', { navItem: data.menuItem.label }));
		};

		/*
		Sub-menu item click event handler.
		 */
		$scope.onSubMenuItemClicked = function ($event, data) {
			resetOnMenuItemClick($event, true);

			// Reset the subMenuItems of the specific menu clicked
			data.$parent.menuItem.submenuSelected = false;
			resetMenuItemSelected(data.$parent.menuItem.MENUITEM);

			// Select the parent menu (for the hamburger) and the actual subMenuItem for subkeyword
			data.$parent.menuItem.selected = true;
			data.$parent.menuItem.submenuSelected = true;
			data.$parent.menuItem.showSubMenu = true;
			data.subMenuItem.selected = true;

			if (data.subMenuItem.alternateModule) {
				// There's an alternateFlowModule and it's enabled.
				try {
					Package.resetAdvancedTicket();
					Navigation.routeToAlternateModule(data.subMenuItem);
					return;
				} catch (e) {
					$log.error('Failed to route to alternate module for sub menu item', e, data.subMenuItem);
				}
			}

			$scope.routeTo($state.href('packageList/navItem', { navItem: data.subMenuItem.label }));
		}

		$scope.onGrandchildMenuItemClicked = function ($event, data) {
			resetOnMenuItemClick($event, true);

			// Reset grandchild siblings
			resetMenuItemSelected(data.$parent.subMenuItem.MENUITEM);

			// Keep parent and child selected, select grandchild
			data.$parent.$parent.menuItem.selected = true;
			data.$parent.$parent.menuItem.submenuSelected = true;
			data.$parent.$parent.menuItem.showSubMenu = true;
			data.$parent.subMenuItem.selected = true;
			data.grandchildItem.selected = true;

			if (data.grandchildItem.alternateModule) {
				try {
					Package.resetAdvancedTicket();
					Navigation.routeToAlternateModule(data.grandchildItem);
					return;
				} catch (e) {
					$log.error('Failed to route to alternate module for grandchild menu item', e, data.grandchildItem);
				}
			}

			$scope.routeTo($state.href('packageList/navItem', { navItem: data.grandchildItem.label }));
		}

		function resetOnMenuItemClick(event, toggleMenu) {
			$rootScope.$broadcast('navbarOrMenuClicked');

			AppData.isInCheckout = false;

			// Destroy any storageInformation...
			Storage.remove('pkgDetailsReInitControls', true);

			// Don't let event bubble up.
			Utilities.stopEventPropagation(event);

			// Ensure subMenu is closed.
			$scope.showAllItems = false;

			if (toggleMenu) {
				$scope.toggleMenu();
				Utilities.scrollPosition();
			}

			// Reset all menu items, submenus, and grandchildren
			$scope.menuItems.forEach(function resetMenuItem(item) {
				item.selected = false;
				item.showSubMenu = false;
				resetMenuItemSelected(item.MENUITEM);
			});
		}

		$scope.showCopyrights = function (boolean) {
			if (boolean) {
				$scope.toggleMenu('Copyright & Policy');
			}

			var title = !Utilities.isEmpty(Language.getLocale('ApplicationLabels', 'copyrightTitle')) ? Language.getLocale('ApplicationLabels', 'copyrightTitle') : 'Copyright & Policy';
			var desc = Language.getLocale('ApplicationLabels', 'copyright');

			//if copyright is not empty show it
			if (desc != "") {
				//Storage.set('copyright',true,true);
				Modal.displayModal({
					category: 'Copyright & Policy',
					action: 'View',
					label: title,
					title: title,
					description: "<div class='copyright_policy'>" + desc + "</div>",
					headerFlag: Modal.DEFAULT,
					buttonFlags: [Enums.buttonFlags.CLOSE]
				});
			}
		}

		/**
		 * Function to reset selected state of menu items recursively
		 * @function
		 * @param {Array} items - The menu items to reset
		 * @returns {undefined}
		 */
		function resetMenuItemSelected(items) {
			if (!Array.isArray(items)) return;
			items.forEach(function resetItem(item) {
				item.selected = false;
				resetMenuItemSelected(item.MENUITEM);
			});
		}

		/**
		 * Function to add fee-inclusive pricing banner
		 * @function
		 * @returns {undefined}
		 */
		function addFeeInclusiveBanner() {
			// Add fee-inclusive pricing banner to Banner service queue if enabled
			if (Utilities.checkProp('AppData.settings.use_fee_inclusive_pricing', AppData, 'getBoolean') && !Storage.get('feeInclusiveBannerDismissed')) {
				Banner.addMessage(
					Language.getLocale('FeeInclusivePricing', 'bannerMessage'),
					BannerEnums.type.INFO,
					function onClose() {
						// Store dismissal in local storage to prevent showing it again
						Storage.set('feeInclusiveBannerDismissed', true);

						// Trigger banner position recalculation after banner DOM update
						Utilities.nextTick(function next() {
							$rootScope.$broadcast('feeInclusiveBannerDismissed');
						});
					},
					null,
					null,
					true, // persistent - this banner should persist across transitions
					Language.getLocale('FeeInclusivePricing', 'dismissButton') // close text
				);
			}
		}

		/**
		 * Function to be called when transition is entered
		 * @function
		 * @returns {undefined}
		 */
		function initialize() {
			var salesforceBeaconUrl = JSONValidator.validate('salesforce', AppData.settings.salesforce) && JSON.parse(AppData.settings.salesforce).beacon_url;

			if (angular.isFunction(removeAppActivated)) {
				// free memory
				removeAppActivated();
				removeAppActivated = null;
			}

			if (salesforceBeaconUrl) {
				Utilities.addScriptToDocument(salesforceBeaconUrl, "_salesforceBeaconUrl");
			}

			//Dynamically set privacy url if there is a locale for it, otherwise, default to accesso's privacy statement.
			$scope.privacyURL = angular.isDefined(AppData.settings.privacyUrl) ? AppData.settings.privacyUrl : Enums.routes.PRIVACY;
			$scope.contrastRatioOn = Utilities.getBoolean(AppData.settings.show_contrast_ratio);

			if (typeof ((AppData).securityProvider || {}).title !== 'undefined') {
				$scope.securityProvider = AppData.securityProvider;
				$scope.showSecurityProvider = true;
			} else {
				$scope.securityProvider = {};
				$scope.showSecurityProvider = false;
			}

			if (angular.isDefined(AppData.settings.replaceLogo)) {
				$rootScope.replaceLogo = $rootScope.getAssetUrl(AppData.settings.replaceLogo);
			} else {
				$rootScope.replaceLogo = false;
			}
			$scope.parkHoursEnabled = Utilities.getBoolean(AppData.settings.enableParkHours);
			$scope.showMenuIcons = angular.isDefined(AppData.settings.show_menu_icons) ? Utilities.getBoolean(AppData.settings.show_menu_icons) : true;

			$scope.menuLinks = AppData.links;
			$scope.socialLinks = AppData.socialLinks;
			$scope.menuItems = AppData.menuItems;
			$scope.menuItems.forEach(function assignIconClass(item) {
				var iconKey = item.customIcon || item.keywords || '';
				item.iconClass = iconKey.toLowerCase().split(' ').join('-');
			});
			$scope.languages = AppData.languages;

			if ($stateParams.keyword && !keywordInitialized) {
				keywordInitialized = true;
				AppData.updateLastKeyword($stateParams.keyword, 'mainmenu on $transitions.onSuccess');
				AppData.updateSelectedKeyword($stateParams.keyword);
			}

			$scope.menuIconClass = 'icon-menu';

			if (AppData.language.indexOf('en-') === 1 || AppData.language.substr(0, 2) === 'en') {
				$scope.menuIconClass += 'Icon';
			}

		}
	}
	);


angular.module('app')
	.controller('ModalCtrl', ['$scope', 'Enums', 'ModalEnums', 'Utilities', function($scope, Enums, ModalEnums, Utilities) {
	// Fixes a bug where buttons weren't showing up in modals.
		$scope.buttonFlags = Enums.buttonFlags;

		$scope.ModalEnums = ModalEnums;

		$scope.routeTo = function(url) {
			Utilities.routeTo(url);
		};
	}]);

/**
 * # OrderLookupCtrl
 *
 * Controller that manages Order look up related screens.
 */
angular
	.module('app')
	.controller('OrderLookupCtrl', function(
		$rootScope,
		$scope,
		$state,
		$stateParams,
		$timeout,
		AppData,
		Enums,
		JSONValidator,
		Language,
		Modal,
		OrderService,
		StringUtils,
		Utilities,
		UtilsValidation
	) {
		var isDefined = angular.isDefined,
			checkProp = Utilities.safelyCheckPropertyOnObject,
			orderLookUpConfig = JSONValidator.validate('order_lookup_overrides', AppData.settings.order_lookup_overrides) ?
				JSON.parse(AppData.settings.order_lookup_overrides) : {},
			validString = UtilsValidation.validString;

		var IS_BOOKING_PORTAL = checkProp('$scope.$resolve.IsBookingPortal', $scope, Utilities.getBoolean);

		var MFA_TEMPLATE = 'views/orderLookupMFAView.html';
		var SEARCH_ORDERS_TEMPLATE = 'views/search-orders.html';

		$scope.orderLookUpViewTemplate = SEARCH_ORDERS_TEMPLATE;
		$scope.showNewCodeSentMessage = false;
		$scope.hasRequestedNewCode = false;
		$scope.isInvalidCode = false;
		$scope.mfaCodeLength = 6;
		$scope.localeReplaceVariables = {
			len: $scope.mfaCodeLength
		};

		/**
		 * Process the order search as a tracking event, and route.
		 * @param  {Object} data object containing search info
		 */
		$scope.process = function(orderLookupForm, data) {
			//clear order information since we are searching for a new order
			OrderService.clear();
			if (orderLookupForm.$invalid) {
				// Invalid. Mark form as submitted to toggle errors.
				$scope.formData.submitted = true;
				return;
			}

			$scope.localeReplaceVariables.email = data.emailAddress;

			doLookup(data.emailAddress, data.phoneNumber, data.verificationCode);
		};

		$scope.selectOrder = function(order) {
			if (IS_BOOKING_PORTAL) {
				$rootScope.routeTo('booking-portal/auto/1500/' + order.oToken + '/' + order.eToken);
			} else {
				$rootScope.routeTo(order.order_link);
			}
		};

		/**
		 * Does an actual order lookup.
		 * @param {String} emailAddress The email address
		 * @param {String} phoneNumber The phone number
		 * @param {String} mfaCode The verification number provided to user
		 * @returns {undefined}
		 */
		function doLookup(emailAddress, phoneNumber, mfaCode) {
			if (isDefined(phoneNumber) && isDefined(emailAddress)) {
				// Show the spinner.
				$scope.showSpinner(Language.getLocale('ApplicationLabels', 'orderSearchLoadMsg'));

				var orderSearchParams = {
					emailAddress: emailAddress,
					//For Six Flags phone numbers that allow special characters
					phoneNumber: StringUtils.formatPhoneNumber(phoneNumber)
				};
				// We only want mfa_code as a parameter if user is trying to validate code.
				// By excluding the parameter, a request for a new code will be sent.
				if (mfaCode) {
					orderSearchParams.mfa_code = mfaCode;
				}

				AppData.fetch(
					Enums.services.ORDER_SEARCH,
					false,
					orderSearchParams,
					true
				).then(
					function(data) {
						// Hide the spinner.
						$scope.hideSpinner();
						if (data.http_response_code === '401') {
							$scope.isInvalidCode = !!orderSearchParams.mfa_code;

							if ($scope.hasRequestedNewCode) {
								//Reset form flags to avoid multiple messages.
								$scope.showNewCodeSentMessage = true;
								$scope.hasRequestedNewCode = false;
								$scope.formData.verificationCode = null;
								hideRequestNewCodeMessage(4000);
							}
							
							$scope.orderLookUpViewTemplate = MFA_TEMPLATE;
							return;
						}
						if (data.status == Enums.status.OK) {
							$scope.orderLookUpViewTemplate = SEARCH_ORDERS_TEMPLATE;
							var _orders = angular.isArray(data.MATCH) ? data.MATCH : [data.MATCH];

							for (var i = 0; i < _orders.length; i++) {
								var orderItem = _orders[ i ];
								if (typeof(orderItem.order_date) != 'string') {
									// If the order_date was already converted to date object...
									continue;
								}

								var dateObj = null;

								try {
									dateObj = orderItem.order_date.split(' ')[ 0 ].split('-');
								} catch (e) {}

								if (dateObj) {
									orderItem.order_date = new Date(Number(dateObj[ 0 ]), Number(dateObj[ 1 ]) - 1, Number(dateObj[ 2 ]));
								}

								orderItem.order_link = $state.href('order-view-encrypted', {
									cToken: orderItem.cToken,
									disableAltRoute: true,
									oToken: orderItem.oToken
								});
							}

							$scope.orders = _orders;
							// Clear MFA verification field. Assigned NULL to exclude from a new request.
							$scope.formData.verificationCode = null;
						} else if (data.status == Enums.status.FAILED) {
							Modal.displayModal({
								category: 'Order Lookup',
								action: 'Error',
								label: data.error_msg,
								title: Language.getLocale('Alert', 'noOrdersFoundTitle'),
								description: Language.getLocale('Alert', 'noOrdersFoundMsg'),
								buttonFlags: [Enums.buttonFlags.OK]
							});
						}
					}
				);
			}
		}

		/**
		 * Requests a new MFA code from API
		 * @method sendNewMFACode
		 * @param  {Object} data object containing search info
		 * @returns {undefined}
		 */
		$scope.sendNewMFACode = function(data) {
			$scope.hasRequestedNewCode = true;
			// If you omit the param mfa_code from GuestOrderSearch request, it will trigger a new code to be generated and sent in BE.
			doLookup(data.emailAddress, data.phoneNumber, null);
		};

		/**
		 * Dismiss the message after a certain amout of time has passed.
		 * @method hideRequestNewCodeMessage
		 * @protected
		 * @param {Number} timeout The number of milliseconds to delay execution
		 * @returns {undefined}
		 */
		function hideRequestNewCodeMessage(timeout) {
			$timeout(function hideNewCodeMessage() {
				$scope.showNewCodeSentMessage = false;
			}, timeout);
		}

		/**
		 * getDateFormat - if orderLookUpDateFormat appconfig exists, then use it for the date format
		 * @function
		 * @protected
		 * @returns {string}
		 */
		function getDateFormat() {
			if (validString(orderLookUpConfig.order_lookup_date_format)) {
				return orderLookUpConfig.order_lookup_date_format === 'shortDate' ? AppData.settings.date_format : orderLookUpConfig.order_lookup_date_format;
			}
			return 'mediumDate';
		}

		/**
		 * Init this controller
		 */
		function Initialize() {
			$scope.showNoOrdersFoundMsg = false;
			$scope.showErrorMessage = false;
			$scope.errorMessageText = '';
			$scope.formData = {};
			$scope.orders = [];
			$scope.dateFormat = getDateFormat();
			OrderService.clear();

			if (isDefined($stateParams.err) &&
				isDefined(Language.OrderLookupErrorCodes[$stateParams.err])
			) {
				$scope.showErrorMessage = true;
				$scope.errorMessageText = Language.OrderLookupErrorCodes[$stateParams.err];
			}

			// Dev mode only.
			if ($scope.autofill) {
				$scope.formData.phoneNumber = '1234567890';
				$scope.formData.emailAddress = 'shopv5dev@accesso.com';
			}
			doLookup();
		}
		Initialize();
	});

angular
	.module('app')
	.controller('QuickSellCtrl', function(
		$scope,
		AppData,
		CustomActionService,
		Modal,
		Package,
		Utilities,
		Enums,
		$rootScope
	) {
		// Local variables.
		var merchantPackageListData = AppData.GetMerchantPackageList;

		$scope.expandedQuicksells = {};
		$scope.toggleQuicksellExpanded = toggleQuicksellExpanded;

		/**
		 * Shows Quicksell Package Modal
		 * @memberof $scope
		 * @param {Object} quicksellPkg model
		 * @returns {undefined}
		 */
		$scope.showQuicksellPkgModal = function(quicksellPkg) {
			Modal.displayModal({
				action: 'View',
				category: 'PackageDescriptionModal',
				customHTML: 'views/modals/quick-sell-description-modal.html',
				customHTMLData: {
					description: Package.replaceDatesInText(quicksellPkg, quicksellPkg.desc),
					image: $rootScope.getAssetUrl(quicksellPkg.shop_image_v4),
					moreInfo: Package.replaceDatesInText(quicksellPkg, quicksellPkg.more_info),
					title: quicksellPkg.name
				},
				hideAllButtons: false,
				image: $rootScope.getAssetUrl(quicksellPkg.shop_image_v4),
				label: 'PackageDescriptionModal',
				showCloseButton: true,
				title: quicksellPkg.name
			});
		};

		// Store quick-sell details for access in package details.
		Package.quickSell = {
			status: false,
			keyword: Utilities.objectKeyExists('quicksell_keyword', $scope.packageDetails) ? $scope.packageDetails.quicksell_keyword : '',
			quickSalesDetails: {},
			quickSalesTypes: {}
		};

		Package.quickSellList = [];

		$scope.samePrice = function(ct) {
			if (angular.isDefined(ct) && angular.isDefined(ct.cusTypeRetail) && angular.isDefined(ct.gate_price)) {
				return (Number(ct.cusTypeRetail) === Number(ct.gate_price));
			} else {
				return false;
			}
		};

		/**
		 * Fired by the <quantity> stepper (button click or typed-blur) for the
		 * quicksell item's qty. Routes to the same PackageDetailsCtrl-inherited
		 * methods the legacy per-button/blur handlers called, keyed off the change
		 * event's inputBlur/isIncrement/isDecrement flags — inputBlur is checked
		 * first since it's the manual-edit signal (onQtyChange is the only one of
		 * the three that shows out-of-range Modal errors and emits 'qtyChanged').
		 *
		 * $scope.incrementQty/decrementQty apply their own relative +/-1 adjustment
		 * to data.qty, but <quantity> has already committed the post-click value to
		 * data.qty (via ngModel) before this handler runs. data.qty is reverted by
		 * one step first so the legacy relative adjustment nets out to the single
		 * click the guest made, instead of double-counting it.
		 *
		 * @param {object} event the <quantity> on-change payload ({ qty, id, inputBlur, isDecrement, isIncrement }).
		 * @return undefined
		 */
		$scope.onQuickSellQtyChange = function(event) {
			var data = Package.quickSell.quickSalesTypes[0];

			if (event.inputBlur) {
				$scope.onQtyChange(data);
			} else if (event.isIncrement) {
				data.qty -= 1;
				$scope.incrementQty(data);
			} else if (event.isDecrement) {
				data.qty += 1;
				$scope.decrementQty(data, true);
			}
		};

		/**
			 * Create the following scope[ variables ]
			 *
			 * $scope.quickSaleKeyword = string
			 * $rootScope.quickSalesDetails = object
			 * $rootScope.quickSalesTypes = object
			 * $rootScope.showQuickSales = boolean
			 *
			 */
		function InitializeCtrl() {
			// Check if there is a keyword.
			if ($scope.quickSaleKeyword) {
				// If we have more than one we'll populate a list and have the store display a different
				// quicksell view based the fact that we will have items in this list.
				if ($scope.quickSellPackageDetailsList.length > 1) {
					var maxPackagesLength = AppData.settings.max_quicksells_to_display || 2;

					// Truncate the packages according to the max display setting
					if ($scope.quickSellPackageDetailsList.length > maxPackagesLength) {
						$scope.quickSellPackageDetailsList.length = maxPackagesLength;
					}

					// populate the list with quickSell objects
					$scope.quickSellPackageDetailsList.forEach(function(packageDetails) {
						Package.quickSellList.push({
							status: true,
							quickSalesDetails: packageDetails,
							quickSalesTypes: setQuickSalesTypes(packageDetails)
						});
					});

					// See if there is a selected quicksell to populate
					var selectedQuickSell = CustomActionService.executeCustomAction('getSelectedQuickSellPackage', Package.quickSellList);

					if (angular.isDefined(selectedQuickSell)) {
						Package.quickSell = selectedQuickSell;
					} else {
						// Set the selected quickSell to the first item
						Package.quickSell = undefined; //Package.quickSellList[0];
					}
				} else {
					// There is only 1 quicksell to display, use the default format.
					Package.quickSell.quickSalesDetails = getQuickSaleDetails(merchantPackageListData) || {};

					if (!Utilities.isEmpty(Package.quickSell.quickSalesDetails)) {
						Package.quickSell.quickSalesTypes = setQuickSalesTypes(Package.quickSell.quickSalesDetails);
						Package.quickSell.status = true;

						Package.quickSellList.push({
							status: true,
							quickSalesDetails: Package.quickSell.quickSalesDetails,
							quickSalesTypes: Package.quickSell.quickSalesTypes
						});
					}
				}
			}
		}

		/**
		 * Toggles an expanded quicksell
		 * @param {String} id The package id
		 * @returns {undefined}
		 */
		function toggleQuicksellExpanded(id) {
			$scope.expandedQuicksells[id] = !$scope.expandedQuicksells[id];
		}

		/**
			 *
			 * @param obj, object to inspect for keyword association, if the keyword is found it will return the package Details
			 * @returns {*}, pkgData = package Details
			 */
		function getQuickSaleDetails(obj) {
			var packageArray = ((obj).PS || {}).P || [];
			var pkgData = null;
			packageArray = angular.isArray(packageArray) ? packageArray : [packageArray];

			if (packageArray.length == 0) {
				// No details for this package. Something went wrong.
				return;
			}

			for (var i in packageArray) {
				var propValue = Package.getAssociatedKeyword(packageArray[ i ]);

				for (var k in propValue) {
					if (String(propValue[ k ].toLowerCase()).trim() == String($scope.quickSaleKeyword.toLowerCase()).trim()) {
						pkgData = getCustomerTypes(packageArray[ i ]);
					}
				}
			}

			if (pkgData == null) {
				// If the packageData remains null, the keyword was not found assiated in memory.
				getMerchantQuickSale($scope.quickSaleKeyword);
			}

			return pkgData;
		}

		function getCustomerTypes(obj) {
			var cusType = (obj).CT?angular.isArray(obj.CT)?obj.CT:[obj.CT]:[]

			var handler = []

			for (var i in cusType) {
				var rate = Utilities.getTotalPrice(cusType[i]);
				handler.push(rate);
			}

			//get the last value
			handler.sort();

			if (cusType.length > 1) {
				obj.startingAt = handler[0]
				obj.retail_amount = handler[0]
			} else {
				obj.retail_amount = handler[0]
			}

			return obj;
		}


		/**
			 *	Makes call GET_MERCHANT_PACKAGE_LIST to socket to find the keyword send.
			 *  If keyword is found it will getQuickSaleDetails( data )
			 *  	-> $rootScope.quickSalesDetails
			 *  else
			 *  	-> status.FAILED > keyword not found
			 * @param keyword, string
			 */
		function getMerchantQuickSale(keyword) {
			// If quicksell_keyword does not exist well make the call to gather the information 'GetMerchantPackageList'.
			AppData.fetch
			(
				Enums.services.GET_MERCHANT_PACKAGE_LIST
				, false
				, {
					keyword: keyword,
					show_details: 1,
					_from_quicksell_ctrl: 1
				}
			).then
			(
				function(data) {
					if (data.status == Enums.status.OK) {
						// Update merchantPackageListData in localStorage with new data.
						var pkgData = getQuickSaleDetails(data) || null;
						updateMerchantPackageListData(pkgData);
					} else if (data.status == Enums.status.FAILED) {
					}
				}
			);
		}

		/**
			 * Used after a successfull getMerchantQuickSale, once fetch data is collected and status.OK, it will update
			 * merchantPackageListData with new PS.P array variable with quickSale_keyword
			 * @param data
			 */
		function updateMerchantPackageListData(pkgData) {
			var mPkgList = ((merchantPackageListData).PS || {}).P || [];
			mPkgList = angular.isArray(mPkgList) ? mPkgList : [mPkgList];

			// Push quickSalesDetails into array.
			mPkgList.push(pkgData);

			var tempMerchantPackageListData = Utilities.copyObject(merchantPackageListData);
			tempMerchantPackageListData.PS = { P: mPkgList };

			// Storage.set( Enums.services.GET_MERCHANT_PACKAGE_LIST, tempMerchantPackageListData );
		}

		/**
			 * Returns the following data
			 * @param packageData
			 *
			 * @returns {Array},
			 * 		CHARACS: Array
			 * 			shop_google_sales_class_title: string
			 * 			shop_rate_id: string
			 * 			shop_rate_name: string
			 * 		cart_limit_override: boolean
			 * 		cusTypeName: string
			 * 		cusTypeRetail: integer
			 * 		customer_type: string
			 * 		desc: string
			 *	 	extra_movie: string
			 * 		keyword: string
			 * 		keyword_description: string
			 * 		max_quantity: integer
			 * 		min_quantity: 0
			 * 		package_id: string
			 * 		promo_code: string
			 * 		qty: 0
			 * 		title: string
			 *
			 */
		function setQuickSalesTypes(packageData) {
			if (typeof packageData.shop_image_v4 == 'string' && packageData.shop_image_v4 != '') {
				packageData.image = $rootScope.getAssetUrl(packageData.shop_image_v4);
			}

			var quickSalesTypes = [];
			packageData.CT = (angular.isArray(packageData.CT)) ? packageData.CT : [packageData.CT];

			// Ensure this is always defined as an array.
			var keywords = (angular.isArray(packageData.KEYWORDS.K)) ? packageData.KEYWORDS.K : [packageData.KEYWORDS.K];

			// Iterate through all CTs in this package and store references.
			for (var i in packageData.CT) {
				var node = (angular.isDefined(keywords[0])) ?
					keywords.filter(function(obj) {
						return obj.keyword == Package.quickSell.keyword
					}) : undefined;

				var itemRef =
					{
						package_id: packageData.id,
						max_quantity: Number(packageData.max_quantity),
						min_quantity: Number(packageData.min_quantity),
						extra_movie: packageData.extra_movie,
						customer_type: packageData.CT[ i ].id,
						cusTypeName: packageData.CT[ i ].name,
						cusTypeRetail: Utilities.getTotalPrice(packageData.CT[i]),
						qty: 0,
						title: packageData.name,
						keyword: packageData.keyword,
						keyword_description: (node && angular.isDefined(node[0])) ? node[0].keyword_description : '',
						desc: packageData.desc,
						promo_code: (typeof packageData.promo_code != 'undefined') ? packageData.promo_code : '',
						cart_limit_override: packageData.cart_limit_override,
						client_gate_savings: packageData.client_gate_savings || '',
						CHARACS:
						[
							{
								shop_rate_name: packageData.CT[ i ].name,
								shop_rate_id: '',
								shop_google_sales_class_title: '',
								extra_movie: packageData.extra_movie
							}
						],
						client_app_gate_price: packageData.CT[ i ].client_app_gate_price || {},
						gate_price: angular.isDefined(packageData.CT[i].gate_price) ? packageData.CT[i].gate_price : 0
					};

				CustomActionService.executeCustomAction('populateQuickSellQuantity', itemRef);

				quickSalesTypes.push(itemRef);
			}

			return quickSalesTypes;
		}

		InitializeCtrl();
	}
	)

angular
	.module('app')
	.controller('ResetController', function(
		$http,
		$window,
		AppData,
		CustomActionService,
		Storage
	) {
		Storage.clearAll();
		var href = '/';

		if (CustomActionService.actionRegistered(CustomActionService.ACTIONS_ENUMS.ON_RESET_STORE_URL_OVERRIDE)) {
			$http.post(AppData.getApiUrl() + '/api/log', {
				m: 'ON_RESET_STORE_URL_OVERRIDE',
				s: AppData.cart.session_id,
				t: 'reset-controller-notify'
			});

			href = CustomActionService.executeCustomAction(CustomActionService.ACTIONS_ENUMS.ON_RESET_STORE_URL_OVERRIDE);
		} else {
			// By default there should be a custom action registered. if the application hasn't set one yet, just use the current params
			href += $window.location.search;
		}

		// Route to the specified state
		$window.location.href = href;
	}
);

angular
	.module('app')
	.controller('ShippingCtrl', ShippingCtrl);

/**
 * Our Shipping controller
 * @public
 * @function
 * @constructor
 * @param {Service} $document $document
 * @param {Service} $filter The angular filter service
 * @param {Service} $log The logging service
 * @param {Scope} $rootScope Our root scope
 * @param {Service} $state Our state service
 * @param {Scope} $scope Our scope
 * @param {Service} AppData Our AppData service
 * @param {Service} LegacyCart Our Cart service
 * @param {Service} ClientInfo Our ClientInfo service
 * @param {Service} CustomActionService Our Custom Action Service
 * @param {Object} countriesJSon Our country data
 * @param {Service} Enums Our enums service
 * @param {Service} Language Our language service
 * @param {Service} Modal Our Modal service
 * @param {Service} UserInfo Our User info service
 * @param {Service} Utilities Our utilities
 * @param {Service} FormValidation Our form validation service
 * @param {Service} AddrLookup Our address lookup service
 * @param {Service} BillingService BillingService
 * @param {Service} ShippingService Our shipping service
 * @param {Service} PaymentService Our payment service
 * @param {Service} PayPalService PayPalService
 * @param {Service} JSONValidator Our JSON validator service
 * @param {Service} UtilsValidation UtilsValidation
 * @returns {ShippingCtrl} Our Instance
 * @ngInject
 */
function ShippingCtrl(
	$document,
	$filter,
	$log,
	$rootScope,
	$state,
	$scope,
	AppData,
	LegacyCart,
	ClientInfo,
	CustomActionService,
	countriesJSon,
	Enums,
	Language,
	Modal,
	UserInfo,
	Utilities,
	FormValidation,
	AddrLookup,
	BillingService,
	ShippingService,
	PaymentService,
	PayPalService,
	JSONValidator,
	UtilsValidation
) {
	window.scrollTo(0, 0);

	var validString = UtilsValidation.validString;
	var consolidatedData = AppData.GetApplicationConsolidated;
	var isNonPhysicalDeliveryMethod = ShippingService.isNonPhysicalDeliveryMethod;
	var vm = this;
	var getShippingMethodOverrideLocale = ShippingService.getShippingMethodOverrideLocale;
	var allowInternational =
		(
			function() {
				if (typeof AppData.settings.allow_international_delivery != 'undefined') {
					return Utilities.getBoolean(AppData.settings.allow_international_delivery);
				} else if (Utilities.childDefined(AppData, 'GetMerchantDetails.SHIPPINGMETHOD')) {
					if (AppData.GetMerchantDetails.SHIPPINGMETHOD.length) {
						var shipMeths = AppData.GetMerchantDetails.SHIPPINGMETHOD;
						for (var i = 0; i < shipMeths.length; i++) {
							if (shipMeths[i].ship_method.toLowerCase() == 'i') {
								return true;
							}
						}
					}
				}

				return false;
			}
		)(),
		useShippingLocaleOverrides = JSONValidator.validate('shipping_locale_overrides', AppData.settings.shipping_locale_overrides),
		shippingLocaleOverrides = useShippingLocaleOverrides ? JSON.parse(AppData.settings.shipping_locale_overrides) : {},
		isEmpty = Utilities.isEmpty;

	$scope.hideSpinner();

	$scope.useJapaneseAddressSyntax = AppData.useJapaneseAddressSyntax();
	$scope.zipType = 'tel';
	$scope.dataFormEnabled = false;
	$scope.formInited = false;
	$scope.selectedShipMethDescription = '';
	$scope.selectedShipMethDescriptionSummary = '';
	$scope.countries = AppData.countries;
	$scope.regions = countriesJSon.regions;
	$scope.optins = [];
	$scope.deliveryMethods = [];
	$scope.validateEmail = true;
	$scope.isMobile = $scope.clientInfo.deviceType === Enums.deviceType.MOBILE;

	$scope.paypalSession = {};
	$scope.useAddrLookup = AppData.use_addr_lookup;
	$scope.getDeliveryMethods = getDeliveryMethods;

	/* Form Validation Utilities */
	$scope.inputHasError = FormValidation.inputHasError;
	$scope.inputShowError = FormValidation.inputShowError;

	/**
	 * Object that can dictate whether or not we can configure copying a model to another model
	 * @type {Object}
	 */
	$scope.copyFromOtherModelInfo = angular.copy(AppData.populateBillingShippingModelInfo);

	/**
	 * Handle when the user clicks on the button to copy information to the billing/shipping model from another model (e.g. profile)
	 */
	$scope.handleOptionToCopyFromOtherModelChanged = function() {
		if ($scope.copyFromOtherModelInfo.copyFromOtherModelAction && $scope.copyFromOtherModelInfo.shouldCopyFromOtherModel) {
			$scope.copyFromOtherModelInfo.copyFromOtherModelAction($scope.shipping);
		}
	}

	$scope.$on('GOOGLEZIP', function(event, data) {
		// We only want to allow GOOGLEZIP if the addresslookup directive is not showing
		if (!$scope.addrLookupActivated) {
			$scope.shipping.country = data.country;
			$scope.shipping.city = data.city;
			$scope.shipping.state = data.state;
		}
	});

	/***-----------------------------------------------------------------------
	 * PUBLIC
	 *------------------------------------------------------------------------**/

	// Is this being shipped to a physical address?
	var isPhysicalDeliveryMethod = false;

	$scope.handleDeliveryMethodChanged = function(index) {
		index = index || 0;

		setActiveDelMethod(index);

		if (!angular.isObject($scope.dataForm)) {
			$scope.dataForm = {};
		}

		$scope.dataForm.submitted = false;
	}

	$scope.handleZipChanged = function() {
		$scope.dataForm.submitted = false;
	}

	/**
	 * Returns document
	 * @public
	 * @returns {Object} document
	 */
	$scope.getDocument = function() {
		return $document[0];
	}

	/**
	 * Scrolls to shipping container
	 * @public
	 * @returns {undefined}
	 */
	$scope.scrollIntoViewAnimate = function() {
		$scope.getDocument().getElementById('shipping-form').scrollIntoView({ behavior: 'smooth' });
	};

	/**
	 * Sets different flags for when a user chooses a new shipping method.
	 * @param {Number} index The index of the shipping method they selected
	 */
	function setActiveDelMethod(index) {
		var selectedMethod;

		if (index < 0 || ($scope.deliveryMethods && index >= $scope.deliveryMethods.length)) {
			return;
		}

		selectedMethod = $scope.deliveryMethods[index];

		$scope.dataFormEnabled = false;
		$scope.selectedMethodIndex = index;
		$scope.deliveryMethods.forEach(function updateDeliveryMethodSelected(method, i) {
			method.selected = i === index;
		});
		$scope.shipping.deliveryMethod = selectedMethod.method;
		$scope.shipping.deliveryAmount = getDeliveryAmountByDeliveryType(selectedMethod.method);

		selectedMethod = $scope.shipping.deliveryMethod;

		if (selectedMethod) {
			isPhysicalDeliveryMethod = !isNonPhysicalDeliveryMethod(selectedMethod);
		}

		if ($scope.shipping.deliveryMethod && isPhysicalDeliveryMethod) {
			$scope.dataFormEnabled = UserInfo.payment.authType !== Enums.billingTypes.PAYPAL;
		}

		$rootScope.$broadcast('triggerShippingSelection', $scope.shipping.deliveryMethod);

		if ($scope.dataFormEnabled) {
			showDeliveryForm();

			setTimeout($scope.scrollIntoViewAnimate);
		}
	}

	$scope.save = function() {
		copyEmailToVerify();

		if ($scope.hasItemsInCart()) {
			if ($scope.dataForm.$invalid && $scope.dataFormEnabled) {
				if (['mobile', 'tablet'].includes(ClientInfo.deviceType)) {
					Utilities.animatedScrollTo(document.querySelector('#shipping-form'), 300);
				}
			}

			if ($scope.continueShipping) {
				if ($scope.dataFormEnabled) {
					// Based on the view information, the delivery form is showing.
					// Ensure form is valid before proceeding.
					$scope.dataForm.submitted = true;
					if (deliveryFormValid()) {
						// Valid data...
						saveShippingInfo();
					}
				} else {
					saveShippingInfo();
				}
			} else if (!$scope.continueShipping) {
				// We are in the optins view.
				// Validate a delivery method has been selected.
				if ($scope.shipping.deliveryMethod && isPhysicalDeliveryMethod && $scope.dataFormEnabled) {
					showDeliveryForm();
				} else {
					saveShippingInfo();
				}
			}
		}
	}

	function saveShippingInfo() {
		// Save the optins into the billing object.
		$scope.shipping.optins = $scope.optins;
		// Store the Shipping Data in UserInfo.
		$scope.shipping.deliveryAmount = getDeliveryAmountByDeliveryType($scope.shipping.deliveryMethod);
		$scope.shipping.isNonPhysicalDeliveryMethod = !isPhysicalDeliveryMethod;
		$scope.shipping.shippingAvailable = isPhysicalDeliveryMethod;
		$scope.shipping.valid = true;

		var hasAlternatePostShippingAction = angular.isDefined(UserInfo.payment.billingProviderName) &&
			angular.isDefined(ShippingService.getAlternatePostShippingAction(UserInfo.payment.billingProviderName));

		UserInfo.shipping = $scope.shipping;

		// Save the userData in the UserInfo.
		UserInfo.set('shipping', $scope.shipping);

		//	PayPal / Shipping Method Integration.
		//	We want to skip the billing page if the payment is through PayPal.
		if (UserInfo.billing.valid && UserInfo.payment.authType == "PPA") {
			updatePayPalShipping();
		} else {
			if (hasAlternatePostShippingAction) {
				var postShippingAction = ShippingService.getAlternatePostShippingAction(UserInfo.payment.billingProviderName);
				postShippingAction.doAction();
			} else if (($scope.paypalSession && $scope.paypalSession.token && $scope.paypalSession.showCheckout) || PayPalService.isValidPayPalSession()) {
				// Check to see if the billing is done already and we've come back from paypal.
				if ($scope.paypalSession.payerID) {
					// We are probably finishing up some paypal stuff, go to review.
					if (UserInfo.billing.valid) {
						$scope.routeTo(Enums.routes.ORDER_REVIEW);
					}
				//otherwise if we have chosen a physical delivery method, we need to provide paypal the shipping address
				} else if (!isNonPhysicalDeliveryMethod($scope.shipping.deliveryMethod)) {
					$rootScope.showSpinner(Language.getLocale('ApplicationLabels', 'updatingCartLoadMsg'));
					PayPalService.handleExpressCheckout(false).then(PaymentService.routeToPaymentMethod);
				} else {
					PaymentService.routeToPaymentMethod();
				}
			} else {
				PaymentService.routeToPaymentMethod();
			}
		}
	}

	/**
	 * Continue the shipping information
	 */
	$scope.continueShippingInformation = function() {
		// Validate a delivery method is selcted and proceed to delivery form if it's physical.
		var delMethod = $scope.shipping.deliveryMethod;
		isPhysicalDeliveryMethod = !isNonPhysicalDeliveryMethod($scope.shipping.deliveryMethod);

		copyEmailToVerify();

		// Enable the form if its a physical delivery method.
		$scope.dataFormEnabled = !!(delMethod && isPhysicalDeliveryMethod);

		//If paypal is enabled and we already have a session-- meaning the user has gone through the express checkout process
		//then we do not need to go to the shipping demographics screen.
		if (PayPalService.isValidPayPalSession() && $scope.dataFormEnabled && Utilities.safelyCheckPropertyOnObject('UserInfo.payment.authType', UserInfo)) {
			$scope.dataFormEnabled = UserInfo.payment.authType !== Enums.billingTypes.PAYPAL;
		}

		//if the user selected mobile or printAtHome and there are other delivery methods configured we need to ensure we start
		//a paypal session with the no shipping flag for PayPal
		if (shouldCallSetExpressCheckout()) {
			$rootScope.showSpinner();
			//call setExpressCheckout again with the no_shipping flag to initiate a new paypal session
			PayPalService.handleExpressCheckout(true).then(function() {
				var sessionInfo = PayPalService.getPayPalSessionInfo();
				if (validString(sessionInfo.token)) {
					assessFormAndCallSaveShipping();
				} else {
					handleSetExpressCheckoutFailure();
				}
			});
		} else {
			assessFormAndCallSaveShipping();
		}

		if ($scope.dataFormEnabled && $scope.shipping.country) {
			$scope.setZipType($scope.shipping.country);
		}
	};

	/**
	 * If SetExpressCheckout fails - no need to do anything special or notify guest because this scenario is highly unlikely.
	 * We would just use the last token from PayPal and continue on
	 */
	function handleSetExpressCheckoutFailure() {
		//We fail gracefully and log - this should never happen as this call would have to successfully go through
		$log.error('Unable to call SetExpressCheckout with no_shipping - guest can still go through as they were before');
		assessFormAndCallSaveShipping();
	}

	/**
	 * shouldCallSetExpressCheckout assesses whether or not we need to call SetExpressCheckout again for our paypal session.
	 * We call it whenever PayPal is enabled and either there is no paypal session or the user has selected a non-physical delivery method.
	 * @returns {boolean}
	 **/
	function shouldCallSetExpressCheckout() {
		return PayPalService.isPayPalNotInitiated() && isNonPhysicalDeliveryMethod($scope.shipping.deliveryMethod);
	}

	/**
	 * Assess the form and call save shipping
	 */
	function assessFormAndCallSaveShipping() {
		if ($scope.dataFormEnabled) {
			$scope.continueShipping = true;
		} else {
			$scope.save('shipping');
		}
	}

	$scope.goBack = function() {
		$scope.continueShipping = false;
	}

	/**
	 * Determines whether to toggle address lookup, and updates the zipcode field type
	 * @param {String} item The country code selected
	 * @returns {undefined}
	 */
	$scope.handleCountriesChanged = function(item) {
		if (!item) {
			item = $scope.shipping.country;
		}

		if (AddrLookup.isAddrLookupCountry(item)) {
			$scope.showAddrSearchBtnOnForm = true;
		} else {
			$scope.showAddrSearchBtnOnForm = false;
			$scope.toggleAddrLookupOnOff(false);
		}

		$scope.dataForm.submitted = false;
		$scope.setZipType(item);
	};

	$scope.toggleAddrLookupOnOff = function(bool) {
		$scope.addrLookupActivated = AppData.settings.use_addr_lookup && bool;
	};

	$scope.setZipType = function($index) {
		$scope.zipType = ($index == 'US') ? 'tel' : 'text';
	};

	/***-----------------------------------------------------------------------
	 * PRIVATE
	 *------------------------------------------------------------------------**/

	function deliveryFormValid() {
		return ($scope.dataForm.$valid && validateInternationalShipping());
	}

	function updatePayPalShipping() {
		$rootScope.showSpinner();
		// Need the following to disable crossSells from appearing on the return.
		AppData.crossSells = false;

		// Apply the PayPal information to the necessary data points for purchase.
		// The following two payment.* entries are used in a paypal call later on.
		UserInfo.payment.shipMethod = $scope.shipping.deliveryMethod;
		UserInfo.payment.shipAmount = $scope.shipping.deliveryAmount;
		UserInfo.set('payment', UserInfo.payment);

		UserInfo.shipping = $scope.shipping;
		UserInfo.set('shipping', UserInfo.shipping);

		// TODO: need to figure out a way to pass in the data I need for the updateCartCheckoutInfo.
		// TODO: Hardcode shipping method until we have shipping form implemented.
		// This should come in from the selection by the user, or the defaulted value.
		// Save the final data before redirecting to orderReview.
		// commenting out for now. may not need it.
		// TODO: Save this data in the shipping form when we implement it.

		var myUpdateCartCheckoutInfoData = {
			shippingMethod: $scope.shipping.deliveryMethod,
			shippingAmount: $scope.shipping.deliveryAmount,
			skip_requests: 'SetExpressCheckout'
		};

		if (UserInfo.payment.merchant_payment_type_ref_id) {
			myUpdateCartCheckoutInfoData.merchant_payment_type_ref_id = UserInfo.payment.merchant_payment_type_ref_id;
		} else {
			myUpdateCartCheckoutInfoData.billingId = UserInfo.payment.billingId;
		}

		LegacyCart.callUpdateCartCheckoutInfo(
			myUpdateCartCheckoutInfoData,
			function() {
				if (!CustomActionService.executeCustomAction(CustomActionService.ACTIONS_ENUMS.SHIPPING_POST_UPDATE_CHECKOUT_CART_INFO)) {
					$rootScope.hideSpinner();
					$rootScope.routeTo(Enums.routes.REVIEW);
				}
			},
			function() {
				//save the keys from myUpdateCartCheckoutInfoData to payment scope
				Object.keys(myUpdateCartCheckoutInfoData).forEach(function(key) {
					$scope.payment[key] = myUpdateCartCheckoutInfoData[key];
				});

				//save the current data from shipping into localStorage for later use
				UserInfo.set('payment', $scope.payment);

				$rootScope.hideSpinner();
				$scope.routeTo(Enums.routes.CART);

				$log.error('issue with updating cart. ');
			}
		); // end callUpdateCartCheckoutInfo
	}

	function InitializeCtrl() {
		var cartOptinsConfig = JSONValidator.validate('cartOptins', AppData.settings.cartOptins) ? JSON.parse(AppData.settings.cartOptins) : {};
		if (!$scope.hasItemsInCart()) {
			$rootScope.routeTo(Enums.routes.LIST);
			return;
		}

		$rootScope.$broadcast('accessibilityFocus');

		$scope.showRegion = Utilities.childDefined(AppData, 'GetApplicationConsolidated.SETTINGS.show_region')
			? Utilities.getBoolean(AppData.GetApplicationConsolidated.SETTINGS.show_region)
			: true;

		// Set the shipping information to the data stored in UserInfo.
		$scope.shipping = initializeShippingFormModel(UserInfo.shipping);

		if (typeof (consolidatedData.SETTINGS.nonisPhysicalDeliveryMethods) != 'undefined') {
			consolidatedData.SETTINGS.nonisPhysicalDeliveryMethods = consolidatedData.SETTINGS.non_physical_delivery_methods.split(', ').join(',').split(',');
			ShippingService.nonisPhysicalDeliveryMethods = consolidatedData.SETTINGS.nonisPhysicalDeliveryMethods;
		}

		if (angular.isUndefined(consolidatedData.SETTINGS.validate_email)) {
			$scope.validateEmail = true;
		} else {
			$scope.validateEmail = Utilities.getBoolean(consolidatedData.SETTINGS.validate_email);
		}

		var shipReq = UserInfo.shippingRequired();
		if (shipReq == 'gettingCartSummary') {
			return;
		}

		// Get reference to delivery methods.
		$scope.deliveryMethods = ShippingService.getShippingMethodsForCurrentCart();
		$scope.deliveryMethodsDisplay = $scope.getDeliveryMethods($scope.deliveryMethods);
		$scope.selectedMethodIndex = 0;

		$scope.paypalSession = PayPalService.getPayPalSessionInfo();

		updateDeliveryMethodsCollection();

		if (angular.isArray($scope.deliveryMethods)) {
			//if deliveryMethod is not define, then lets get the fist value of the array
			if (typeof ($scope.deliveryMethod) == 'undefined' && $scope.deliveryMethods.length) {
				//select the first value
				$scope.deliveryMethods[0].selected = true;
				$scope.selectedMethodIndex = 0;
				$scope.shipping.deliveryMethod = $scope.deliveryMethods[0].method;
			}
		}

		// If no delivery methods or only one delivery method and it's M redirect to billing.
		if (UserInfo.getDeliveryRouting() === Enums.routes.BILLING) {
			if (PayPalService.isValidPayPalSession()) {
				$scope.shipping.valid = true;
				$scope.routeTo(Enums.routes.ORDER_REVIEW);
			} else {
				$scope.routeTo(BillingService.useZeroDollarQuickCheckout() ? 'quick-checkout' : Enums.routes.BILLING);
			}
		}

		// Store delivery methods in cookies as fallback to local storage.
		UserInfo.set('deliveryMethods', $scope.deliveryMethods);

		// If no delivery methods or only one delivery method and it's M redirect to billing.
		if ($scope.deliveryMethods.length == 0 ||
			($scope.deliveryMethods.length == 1 && $scope.deliveryMethods[0].method == 'M')) {
			// TODO: $scope.deliveryMethods isn't alway an array

			// Store delivery methods in cookies as fallback to local storage.
			UserInfo.set('shipping', UserInfo.shipping);
			AppData.Storage.set('_shipping', UserInfo.shipping, true);
		}

		// Dev mode only.
		if ($scope.autofill && typeof ($scope.shipping.firstName) == 'undefined') {
			//set the userinfo for dev from UserInfo
			$scope.shipping = Utilities.copyObject(UserInfo.userInfo);

			$scope.shipping.deliveryMethod = $scope.deliveryMethods[0].method;
		}

		loadDeliveryDescriptions();
		overrideShippingMethodLocale();

		// Get the description of the selected delivery method.
		$scope.handleDeliveryMethodChanged();
		// Set default country.
		if (!$scope.shipping.country) {
			$scope.shipping.country = AppData.defaults.country;
		}

		for (var i in AppData.optins) {
			if (AppData.optins[i].section == 'ShippingView' && !cartOptinsConfig.enable) {
				$scope.optins.push(AppData.optins[i]);
			}
		}

		// Store the localized label as part of the optin object.
		for (var i = 0; i < $scope.optins.length; i++) {
			var section = $scope.optins[i].section;
			var target = $scope.optins[i].target;
			$scope.optins[i].label = Language.getLocale(section, target).replace('@@park', AppData.settings.merchant_name);
		}

		//set activated address lookup first based on useAddrLookup and whether or not the showAddrLookupForm has been left on from previous uses
		$scope.addrLookupActivated = $scope.useAddrLookup && AddrLookup.getShowAddrLookupOnNextForm() && AddrLookup.isAddrLookupCountry($scope.shipping.country);

		//indicator to allow user to switch to address lookup directive in case they would like to look up another address
		$scope.showAddrSearchBtnOnForm = $scope.useAddrLookup && AddrLookup.isAddrLookupCountry($scope.shipping.country);

		$scope.dataForm.submitted = false;
		$scope.formInited = true;
	}

	/**
	 * Takes the current delivery methods then creates a new array with some extra properties set for use with the ac-list component.
	 * @param {Object[]} methods The delivery methods currently assigned.
	 * @returns {Object[]} The new delivery methods.
	 */
	function getDeliveryMethods(methods) {
		return methods.map(function buildDeliveryMethod(method) {
			var ship = angular.copy(method);
			var price = parseFloat(ship.price);

			ship.name = ship.title + ' (' + (price === 0 ? Language.getLocale('ShippingView', 'priceLabel') : $filter('currencyFormatter')(price)) + ')';

			if (useShippingLocaleOverrides) {
				ship.headline = getShippingMethodOverrideLocale(ship.method, shippingLocaleOverrides, 'long_desc');
				ship.modalSummary = getShippingMethodOverrideLocale(ship.method, shippingLocaleOverrides, 'description');
				ship.modalDescription = getShippingMethodOverrideLocale(ship.method, shippingLocaleOverrides, 'summary');
			}

			if (isEmpty(ship.headline)) {
				ship.headline = method.description;
			}

			if (isEmpty(ship.modalDescription)) {
				ship.modalDescription = ShippingService.getDeliveryDescriptionSummaryByType(ship.method);
			}

			if (isEmpty(ship.modalSummary)) {
				ship.modalSummary = getDeliveryDescriptionByType(ship.method);
			}

			ship.showInfoModal = validString(ship.modalDescription);

			return ship;
		});
	}

	function updateDeliveryMethodsCollection() {
		if (!allowInternational) {
			for (var i = 0; i < $scope.deliveryMethods.length; i++) {
				if ($scope.deliveryMethods[i].method.toLowerCase() == 'i') {
					$scope.deliveryMethods.splice(i, 1);
				}
			}
		}
		// filterShippingMethods is currently only supplied by FolioService.
		CustomActionService.executeCustomAction('filterShippingMethods', null, [$scope.deliveryMethods, isNonPhysicalDeliveryMethod]);
	}

	function showDeliveryForm() {
		$scope.dataFormEnabled = true;
		$scope.continueShipping = true;
		setDefaultCountry();
	}

	function setDefaultCountry() {
		// Set default country only if dataFormEnabled && continueShipping
		var deliveryMeth = $scope.shipping.deliveryMethod.toLowerCase();

		if (!$scope.shipping.country && deliveryMeth != 'i') {
			$scope.shipping.country = AppData.settings.default_country;
			$scope.setZipType($scope.shipping.country);
		} else if (deliveryMeth == 'i') {
			$scope.shipping.country = null;
		}
	}

	function validateInternationalShipping() {
		var selCountry = '';
		var selMethod = '';
		var nonPhysDeliMeth = '';

		try {
			selCountry = $scope.shipping.country.toLowerCase();
			selMethod = $scope.shipping.deliveryMethod.toLowerCase();
			nonPhysDeliMeth = isNonPhysicalDeliveryMethod(selMethod);
		} catch (e) {
			return false;
		}

		if (!$scope.shipping.country || !selMethod) {
			// Country or delivery method not selected.
			return false;
		}

		if (!nonPhysDeliMeth && selMethod != 'i' && selCountry != AppData.settings.default_country.toLowerCase()) {
			// If it's a physical address, and the selected method is not
			// international and the country is from an international address...
			if (allowInternational) {
				showIncompatibleDeliveryMethodError(selMethod, selCountry);
				$scope.shipping.deliveryMethod = 'I';
				setActiveDelMethod(getDeliveryIndexByType('I'));
			} else {
				Modal.displayModal({
					category: 'Shipping',
					action: 'Error',
					label: 'Shipping method ' + selMethod + ' is not allowed for ' + selCountry,
					title: Language.getLocale('Alert', 'internationalShippingTitle'),
					description: Language.getLocale('Alert', 'noInternationalShippingErrorMsg'),
					buttonFlags: [Enums.buttonFlags.OK]
				});
			}

			return false;
		}

		if (selMethod == 'i' && selCountry == AppData.settings.default_country.toLowerCase()) {
			// User selected international shipping but selected US.
			showIncompatibleDeliveryMethodError(selMethod, selCountry);
			$scope.shipping.deliveryMethod = 'U';
			setActiveDelMethod(getDeliveryIndexByType('U'));
			return false;
		}

		if (selMethod == 'i' && !allowInternational) {
			// International shipping is not allowed.
			Modal.displayModal({
				category: 'Shipping',
				action: 'Error',
				label: 'Shipping method ' + selMethod + ' is not allowed for ' + selCountry,
				title: Language.getLocale('Alert', 'internationalShippingTitle'),
				description: Language.getLocale('Alert', 'noInternationalShippingErrorMsg'),
				buttonFlags: [Enums.buttonFlags.OK]
			});

			return false;
		}

		return true;
	}

	function showIncompatibleDeliveryMethodError(selMethod, selCountry) {
		Modal.displayModal({
			category: 'Shipping',
			action: 'Error',
			label: 'Shipping method ' + selMethod + ' is not allowed for ' + selCountry,
			title: Language.getLocale('Alert', 'internationalShippingTitle'),
			description: Language.getLocale('Alert', 'incompatibleDeliveryMethodErrorMsg'),
			buttonFlags: [Enums.buttonFlags.OK]
		});
	}


	function getDeliveryAmountByDeliveryType(type) {
		for (var i = 0; i < $scope.deliveryMethods.length; i++) {
			if (typeof ($scope.deliveryMethods[i].selected) != 'undefined' && $scope.deliveryMethods[i].selected) {
				$scope.shipping.deliveryMethod = $scope.deliveryMethods[i].method;
				return Number($scope.deliveryMethods[i].price);
			}
		}

		return 0;
	}

	function getDeliveryDescriptionByType(type) {
		var desc = '';
		for (var i = 0; i < $scope.deliveryMethods.length; i++) {
			if (type.toLowerCase() == $scope.deliveryMethods[i].method.toLowerCase()) {
				if (Language.localeExists('ShippingView', type.toLowerCase() + 'LongDescription')) {
					desc = Language.getLocale('ShippingView', type.toLowerCase() + 'LongDescription');
					desc += ' - ' + $filter('currencyFormatter')(parseFloat($scope.deliveryMethods[i].price), AppData.currencyCode, $scope.languageSettings);
				}
				break;
			}
		}

		return desc;
	}


	function loadDeliveryDescriptions() {
		// if the correct locale exists, this loads it into the description field.
		if (angular.isUndefined($scope.deliveryMethods)) {
			return;
		}
		if (angular.isArray($scope.deliveryMethods)) {
			$scope.deliveryMethods.forEach(function(method) {
				if (angular.isDefined(method.method)) {
					var target = method.method.toLowerCase() + 'Description';
					if (Language.localeExists('ShippingView', target)) {
						method.desc = Language.getLocale('ShippingView', target);
					}
				}
			});
		} else if (angular.isDefined($scope.deliveryMethods.method)) {
			var target = $scope.deliveryMethods.method.toLowerCase() + 'Description';
			if (Language.localeExists('ShippingView', target)) {
				$scope.deliveryMethods.desc = Language.getLocale('ShippingView', target);
			}
		}
	}

	/**
	 * Override the shipping method locale if it exists
	 * @protected
	 * @function
	 * @name overrideShippingMethodLocale
	 * @memberof {ShippingCtrl}
	 * @return {undefined}
	 */
	function overrideShippingMethodLocale() {
		var i,
			deliveryMethodsLength,
			description;
		if (useShippingLocaleOverrides) {
			if (angular.isArray($scope.deliveryMethods)) {
				deliveryMethodsLength = $scope.deliveryMethods.length;
				for (i = 0; i < deliveryMethodsLength; i++) {
					description = getShippingMethodOverrideLocale($scope.deliveryMethods[i].method, shippingLocaleOverrides, 'name');
					if (!isEmpty(description)) {
						$scope.deliveryMethods[i].desc = description;
					}
				}
			} else if (angular.isObject($scope.deliveryMethods) && angular.isString($scope.deliveryMethods.method)) {
				description = getShippingMethodOverrideLocale($scope.deliveryMethods.method, shippingLocaleOverrides, 'name');
				if (!isEmpty(description)) {
					$scope.deliveryMethods.desc = description;
				}
			}
		}
	}

	function getDeliveryIndexByType(type) {
		for (var i = 0; i < $scope.deliveryMethods.length; i++) {
			if (type.toLowerCase() == $scope.deliveryMethods[i].method.toLowerCase()) {
				return i;
			}
		}

		return -1;
	}

	/**
	 * If we're not validating the email, copy it over to the email verification model.
	 * @see $scope.save() && $scope.continueToPaymentInformation()
	 *
	 */
	function copyEmailToVerify() {
		if (!Utilities.getBoolean($scope.validateEmail)) {
			$scope.billing.emailVerify = $scope.billing.email;
		}
	}

	function initializeShippingFormModel(userShippingInfo) {
		var shipping = {};
		shipping.firstName = angular.isDefined(userShippingInfo.firstName) ? userShippingInfo.firstName : '';
		shipping.middleInitial = angular.isDefined(userShippingInfo.middleInitial) ? userShippingInfo.middleInitial : '';
		shipping.lastName = angular.isDefined(userShippingInfo.lastName) ? userShippingInfo.lastName : '';
		shipping.phone = angular.isDefined(userShippingInfo.phone) ? userShippingInfo.phone : '';
		shipping.email = angular.isDefined(userShippingInfo.email) ? userShippingInfo.email : '';
		shipping.emailVerify = angular.isDefined(userShippingInfo.emailVerify) ? userShippingInfo.emailVerify : '';
		shipping.address = angular.isDefined(userShippingInfo.address) ? userShippingInfo.address : '';
		shipping.address2 = angular.isDefined(userShippingInfo.address2) ? userShippingInfo.address2 : '';
		shipping.country = angular.isDefined(userShippingInfo.country) ? userShippingInfo.country : '';
		shipping.zip = angular.isDefined(userShippingInfo.zip) ? userShippingInfo.zip : '';
		shipping.city = angular.isDefined(userShippingInfo.city) ? userShippingInfo.city : '';
		shipping.state = angular.isDefined(userShippingInfo.state) ? userShippingInfo.state : null;
		return shipping;
	}

	$scope.$onInit = function() {
		// Set valid to false in order to force user to click continue button.
		if ($state.current.url.toLowerCase().indexOf(Enums.routes.SHIPPING.toLowerCase()) > -1) {
			if (UserInfo.shipping) {
				UserInfo.shipping.valid = false;
			}

			InitializeCtrl();
		}
	};

	vm.$onInit = $scope.$onInit;
}

(function() {
	'use strict';

	angular
		.module('app')
		.controller('SplashscreenCtrl', SplashscreenCtrl);
	/**
	 * SpalshscreenCtrl
	 * @param {Service} $uibModalInstance $uibModalInstance
	 * @param {Service} $rootScope $rootScope
	 * @param {Service} $scope $scope
	 * @param {Service} $sce $sce
	 * @param {Service} $window $window
	 * @param {Service} AppData AppData
	 * @param {Service} Language Language
	 * @param {Service} UtilsValidation UtilsValidation
	 * @returns {self} Our Controller
	 */
	function SplashscreenCtrl($uibModalInstance, $rootScope, $scope, $window, AppData, Language, UtilsValidation) {
		var getLocaleWithSuffixAndFallback = Language.getLocaleWithSuffixAndFallback,
			MERCHANT_ID_STRING = AppData.merchantId + '',
			localeSection = 'SplashScreen';

		$scope.validString = UtilsValidation.validString;
		$scope.changeParkText = getLocaleWithSuffixAndFallback(localeSection, 'changePark', MERCHANT_ID_STRING);
		$scope.continueText = getLocaleWithSuffixAndFallback(localeSection, 'continue', MERCHANT_ID_STRING);
		$scope.headerText = getLocaleWithSuffixAndFallback(localeSection, 'header', MERCHANT_ID_STRING);
		$scope.customImageAlt = getLocaleWithSuffixAndFallback('Accessibility', 'splashScreenImageAlt', MERCHANT_ID_STRING)

		$scope.dismissModal = dismissModal;
		$scope.changePark = changePark;
		$scope.getWindow = getWindow;
		$scope.getLocaleValue = getLocaleValue;
		$scope.initializeController = initializeController;

		$scope.initializeController();

		/**
		 * Controller initialization
		 * @public
		 * @returns {undefined}
		 */
		function initializeController() {
			var customImageVal = $scope.getLocaleValue('customImage');
			$scope.changeParkUrl = $scope.getLocaleValue('changeParkUrl');
			$scope.customText = $scope.getLocaleValue('customText');
			$scope.customImage = $scope.validString(customImageVal) ? $rootScope.getAssetUrl(customImageVal) : '';
		}

		/**
		 * Returns locale values
		 * @public
		 * @param {String} target target value of locale
		 * @returns {String} locale value
		 */
		function getLocaleValue(target) {
			var missingLocaleValue = '[' + localeSection + '.' + target + '] target missing';
			var value = getLocaleWithSuffixAndFallback(localeSection, target, MERCHANT_ID_STRING);
			if (value === missingLocaleValue) {
				return '';
			}
			return value;
		}

		/**
		 * Dismiss modal
		 * @public
		 * @returns {undefined}
		 */
		function dismissModal() {
			$rootScope.modalOpen = false;
			$uibModalInstance.close('');
		}

		/**
		 * Returns window
		 * @public
		 * @returns {Object} $window service
		 */
		function getWindow() {
			return $window;
		}

		/**
		 * Change Park
		 * @public
		 * @returns {undefined}
		 */
		function changePark() {
			if ($scope.validString($scope.changeParkUrl)) {
				$scope.getWindow().open($scope.changeParkUrl, '_parent');
			} else {
				$scope.dismissModal();
			}
		}

		// Dismiss modal on hidePreviousModals
		$scope.$on('hidePreviousModals', function() {
			$rootScope.modalOpen = false;
			$uibModalInstance.close('');
		});
	}
})();
(function() {
	'use strict';

	angular
		.module('app')
		.controller('SubKeywordController', SubKeywordController);
	/**
	 * Our constructor
	 * @ngInject
	 * @param {Scope} $scope $scope
	 * @param {Service} Navigation Navigation service
	 * @param {Object} subKeywordCollection route resolve for subKeywordCollection
	 * @param {Service} Utilities Utilities service
	 * @param {Service} UtilsValidation UtilsValidation service
	 * @param {Service} RestrictedPackagesService The RestrictedPackagesService
	 * @param {Service} Package The Package service
	 * @param {Service} Viewport The Viewport service
	 * @returns {self} our instance
	 * @constructor
	 */
	function SubKeywordController(
		$scope,
		Navigation,
		subKeywordCollection,
		Utilities,
		UtilsValidation,
		RestrictedPackagesService,
		Package,
		Viewport
	) {
		var vm = this;

		var merge = Utilities.merge,
			checkProp = Utilities.checkProp;

		merge(vm, {
			$onInit: $onInit,
			_: { packageInArray: _packageInArray }
		});

		merge($scope, {
			tiles: subKeywordCollection.items,
			viewport: Viewport.api,

			navigateToNext: navigateToNext
		});

		/***************************************
		 ** ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ **
		 ** ~ L I F E C Y C L E ~ H O O K S ~ **
		 ** ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ **
		 ***************************************/

		/**
		 * Lifecycle hook for when the controller is initialized
		 * @lifecycle
		 * @returns {undefined}
		 */
		function $onInit() {
			var tiles = UtilsValidation.validArray($scope.tiles) ? $scope.tiles : [];
			var keywords,
				packages,
				allRestricted,
				hasAccess;

			// Filter tiles based on both isactive and restricted access
			$scope.tiles = tiles.filter(function(tile, index) {
				// First check if tile is active
				if (!tile.isactive) {
					return false;
				}

				keywords = Utilities.getString(tile.keywords).split(',').map(function(keyword) {
					return keyword.trim();
				});

				packages = keywords.reduce(function(pkgs, keyword) {
					return pkgs.concat(Package.getPackagesByKeyword(keyword));
				}, []);

				// Remove duplicate packages
				packages = packages.reduce(function(pkgAcc, pkg) {
					if (!vm._.packageInArray(pkg, pkgAcc)) {
						pkgAcc.push(pkg);
					}
					return pkgAcc;
				}, []);

				allRestricted = packages.every(function(pkg) {
					return RestrictedPackagesService.isRestrictedPackage(pkg);
				});

				if (!allRestricted) {
					return true;
				}

				// Check if user has access to any restricted package
				hasAccess = packages.some(function(pkg) {
					return RestrictedPackagesService.restrictedPackageLoaded(pkg.id);
				});
				return hasAccess;
			});
		}

		/***************************************
		 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ **
		 * ~ P R I V A T E ~ M E T H O D S ~ **
		 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ **
		 * *************************************/

		/**
		 * Find out if a package is already in the array. This is a utility function
		 * @param {Object} pkg The package to check for
		 * @param {Object[]} packages The array of packages
		 * @returns {Boolean} true/false
		 */
		function _packageInArray(pkg, packages) {
			return packages.some(function(somePackage) {
				return somePackage.id === pkg.id;
			});
		}

		/*************************************
		 ** ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ **
		 ** ~ P U B L I C ~ M E T H O D S ~ **
		 ** ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ **
		 *************************************/

		/**
		 * Navigates to the next page
		 * @param {Object} tile The tile that was clicked
		 * @returns {undefined}
		 */
		function navigateToNext(tile) {
			if (checkProp('tile.alternateModule', tile) && tile.alternateModule.length > 0) {
				Navigation.routeToAlternateModule(tile);
			} else if (checkProp('tile.promo_code', tile)) {
				Utilities.goTo('/packageList/promocode/:promocode', { promocode: tile.promo_code })
			} else {
				Utilities.goTo('packageList/keyword', { keyword: tile.keywords });
			}
		}
	}
}());
'use strict';

angular
	.module('app')
	.controller('IneligibleForPaymentAlertCtrl', function(
		 AppData,
		 Enums,
		 IneligibleForPaymentAlert,
		 Utilities,
		 $uibModalInstance,
		 $rootScope,
		 $scope
	) {
		$scope.description = IneligibleForPaymentAlert.description;
		$scope.noticeChecked = false;

		/**
			 * Dismisses the modal and executes deleteMembershipsFromCart() function.
			 */
		$scope.dismissModal = function() {
			$rootScope.modalOpen = false;
			IneligibleForPaymentAlert.modalInView = false;
			$uibModalInstance.close('');

			if (!Utilities.childDefined(AppData, 'GetCartSummary.CART.ITEMS.ITEM') ||
				AppData.GetCartSummary.CART.ITEMS.ITEM.length == 0) {
				$scope.routeTo(Enums.routes.LIST)
			}
		}

		$rootScope.$on('hidePreviousModals', function() {
			$rootScope.modalOpen = false;
			$uibModalInstance.close('');
		});
	});

angular
	.module('app')
	.controller('ThankYouCtrl', function(
		$rootScope,
		$scope,
		$stateParams
	) {
		$rootScope.hideSpinner();

		$scope.auth = $stateParams.authID;
	});
angular
	.module('app')
	.controller('TicketCtrl', function(
		$http,
		$state,
		$stateParams,
		$scope,
		$location,
		$log,
		$filter,
		$rootScope,
		$window,
		AppData,
		AccountPortalRoutingService,
		BookingPortalRoutingService,
		ClientInfo,
		CustomActionService,
		Enums,
		GiftAidEnums,
		JSONValidator,
		Language,
		Modal,
		OneBarcodeUtilities,
		RouteHistoryService,
		OrderService,
		Utilities,
		NumeralSystemService,
		Security,
		Ticket,
		PostPurchaseActionsService,
		UrlUtils,
		UtilsValidation,
		TicketUtilsService
	) {
		var isObject = angular.isObject,
			isString = angular.isString,
			isArray = angular.isArray,
			validString = UtilsValidation.validString,
			getBoolean = Utilities.getBoolean,
			returnValue = Utilities.returnValue,
			safelyCheckPropertyOnObject = Utilities.safelyCheckPropertyOnObject,
			stripURLParams = Utilities.stripURLParams,
			vm = this;

		// Assumed attribute path (under VIEW_ORDER_REPLY) where the API layer returns the
		// Merlin external-account launcher URL on Guest View Order. Pending backend
		// confirmation (MERLIN-161) — update this single constant once finalized.
		var EXTERNAL_ACCOUNT_URL_ATTR = 'myAccountLauncherUrl';

		$scope.ticketDateFormat = 'EEE, d MMM y';
		$scope.getOrderDate = getOrderDate;
		$scope.fromSpecialReturnState = ($state.current.name === 'order-view-with-alt-return-location');
		// TODO: Remove any receipt-specific code.
		$scope.thanksPage = Utilities.childDefined(AppData, 'GuestViewOrder.VIEW_ORDER_REPLY.ORDER_STATUS_REPLY.CHARACS.thanks_page')
			? getBoolean(AppData.GuestViewOrder.VIEW_ORDER_REPLY.ORDER_STATUS_REPLY.CHARACS.thanks_page)
			: 0;

		$scope.iosVersion = parseInt(ClientInfo.osResults.version);

		var _useVat = AppData.defaults.use_vat;
		var shipMeth = safelyCheckPropertyOnObject('AppData.GuestViewOrder.VIEW_ORDER_REPLY.ORDER_STATUS_REPLY.ship_method', AppData) ? AppData.GuestViewOrder.VIEW_ORDER_REPLY.ORDER_STATUS_REPLY.ship_method : Enums.deliveryMethods.NO_SHIPPING;

		$scope.isNoShipping = (shipMeth === Enums.deliveryMethods.NO_SHIPPING);

		// indicates css hiding package_name in ticketView should be overriden
		$scope.showPackageName = getBoolean(AppData.GetApplicationConsolidated.SETTINGS.showPackageNameOnTicketView);

		$scope.isPrintAndGo = Ticket.determineIsPrintAndGo(shipMeth);
		/**
		 * @Private
		 * @type {Function}
		 * @return {Boolean}
		 */
		var ngIsDefined = angular.isDefined;


		$scope.hideSpinner();
		$scope.receiptView = false;

		// Delivery methods selected.
		$scope.isSpecialDelivery = false;
		$scope.isAddlSpecialDelivery = false;
		$scope.isWillCall = false;
		$scope.isFirstClassMail = false;
		$scope.isInternationalMail = false;
		$scope.isPassbookDevice = ClientInfo.isPassbookDevice();
		$scope.specialDeliveryTitle = '';
		$scope.specialDeliveryMessage = '';
		$scope.dateFormat = AppData.settings.date_format;
		$scope.displayDecodedBarcode = getBoolean(AppData.settings.display_decoded_barcode);
		$scope.hideSubtotal = getBoolean(AppData.settings.hide_subtotal);
		$scope.hideReceipt = false;
		$scope.SIAEEnabled = false;
		$scope.mobileTicketOptions;
		$scope.showAdditionalGuestNames = false;

		$scope.getTenant = TicketUtilsService.getTenant;
		$scope.getPrintablePackages = getPrintablePackages;

		$scope.ticketDisplayIndex =
			{
				display: [true],
				front: [true],
				back: [false]
			};


		$scope.orderDetails =
			{
				date: '',
				time: '',
				status: ''
			};

		// TODO: Does this need to live in $rootScope or can it be moved to $scope.
		$scope.ticketObject =
			{
				switchPage: '',
				selectedOrderID: OrderService.orderID || '',
				selectedOrderL4: OrderService.lastFour,
				selectedOrderPN: OrderService.phoneNumber,
				fromOrderLookup: false
			};

		$scope.isMobile = false;
		$scope.receiptHidePrices = false;
		$scope.bookingPortalButton = {};
		$scope.hidePlaceNewOrderButton = false;

		$scope.tryAgain = function(receiptView) {
			$scope.receiptView = receiptView;
			InitializeCtrl();
		};

		$scope.continueShopping = function() {
			var lastKeyword = AppData.lastKeyword;
			if (RouteHistoryService.overrideRouteWithLastRoute($state.current.name, $state)) {
				$rootScope.routeTo($rootScope.lastValidRoute);
			} else if (lastKeyword) {
				$scope.routeTo(Enums.routes.LISTKEYWORD+ '/' + lastKeyword);
			} else {
				$scope.routeTo();
			}
		};

		$scope.gotoOrderResults = function() {
			$scope.routeTo(Enums.routes.ORDER_SEARCH);
		};

		$scope.gotoOrderLookup = function() {
			$scope.routeTo(Enums.routes.ORDER_SEARCH);
		};

		$scope.goToReceiptView = function() {
			Utilities.routeToExternal($scope.receiptViewUrl);
		};

		$scope.goToSpecialReturnState = function() {
			if ($scope.fromSpecialReturnState) {
				$rootScope.routeTo($state.href($stateParams.returnState,
					JSON.parse($stateParams.returnParams)
				)
				);
			}
		}

		$scope.viewReceipt = function() {
			$scope.ticketObject.switchPage = 'receipt';
		};

		/**
		 * "Place New Order" button clicked
		 * Routes to merchant's default page
		 * @public
		 * @returns {undefined}
		 */
		$scope.placeNewOrder = function() {
			var getParams = $location.$$search;
			if (getParams.request_type && (getParams.request_type == 'ideal' || getParams.request_type == 'mrcash')) {
				/*remove params specific to redirect from mrcash and ideal so that it does not affect user's next order*/
				stripURLParams(['request_type', 'cart_key', 'cart_id', 'session_id', 'status', 'DPGReferenceId', 'TransactionId']);
			}

			stripURLParams(['fromEmail']);
			$scope.routeTo();
		}

		$scope.toggleTicketDisplay = function(index, ticket) {
			if (!$scope.ticketDisplayIndex.display[ index ]) {
				$scope.ticketDisplayIndex.display[ index ] = true;
				$scope.ticketDisplayIndex.front[ index ] = true;
				$scope.ticketDisplayIndex.back[ index ] = false;

				for (var i in $scope.ticketDisplayIndex.display) {
					if (index != i) {
						$scope.ticketDisplayIndex.display[ i ] = false;
						$scope.ticketDisplayIndex.front[ i ] = false;
						$scope.ticketDisplayIndex.back[ i ] = false;
					}
				}
			}

		};

		$scope.toggleButtonBar = function(button) {
			if (button == Language.getLocale('TicketView', 'ticketLabel') && $scope.toggleButton) {
				$scope.toggleButton = false;
			} else if (button == Language.getLocale('TicketView', 'receiptLabel') && !$scope.toggleButton) {
				$scope.toggleButton = true;
			}
		};

		vm.$onInit = function() {
			$scope.ticketObject.fromOrderLookup = false;

			// If we are coming from the order search page, we need to set the flag to true to display the "back" breadcrumb
			if ($rootScope.lastValidRoute == '/'+Enums.routes.ORDER_SEARCH) {
				$scope.ticketObject.fromOrderLookup = true;
			}

			InitializeCtrl();
		};

		/**
		 * Open HTMLTicket page and facilitate the print command
		 */
		$scope.printMobileTicket = function() {
			Utilities.routeToExternal(OrderService.getPrintTicketURL());
		}

		// Used for localizing the 'Add to Apple Wallet' image
		$scope.walletLang = angular.isDefined(AppData.language) ? AppData.language.slice(0, 2) : '';

		$scope.passbookClicked = function(barcode) {
			if (validString(barcode) && barcode.indexOf('%') > -1) {
				// encode barcode here, when it's accessed in PHP through $_GET it'll automatically be decoded
				barcode = encodeURIComponent(barcode);
			}
			// TODO: need to pull language from the order itself and not the $scope.merchant.language WHY: This breaks on order lookup if the order from the park is in a different language
			var url = $scope.merchant.passbook + '/?i=' + $scope.merchant.island + '&b=' + barcode + '&u=' + $scope.merchant.userId + '&e=' + $scope.merchant.environment+ '&l=' + $scope.merchant.language;
			var oToken = OrderService.oToken;
			var pToken = OrderService.pToken;

			if (oToken && pToken) {
				url += '&oToken=' + oToken + '&pToken=' + pToken;
			} else {
				url += '&o=' + $scope.orderId;
			}

			$rootScope.showingPassbookDisconnectError = true;
			$window.location = url;
		};

		$scope.flip = function(index) {
			label = !$scope.ticketDisplayIndex.front[ index ] ? 'Viewing Ticket Front' : 'Viewing Ticket Back';

			$scope.ticketDisplayIndex.front[ index ] = !$scope.ticketDisplayIndex.front[ index ];
			$scope.ticketDisplayIndex.back[ index ] = !$scope.ticketDisplayIndex.back[ index ];
		};

		$scope.viewAddons = false;
		$scope.addonsClicked = function() {
			if ($scope.viewAddons == true) {
				$scope.viewAddons = false;
			} else {
				$scope.viewAddons = true;
			}
		}

		$scope.hasTicketsRegistered = function() {
			return $scope.tickets.filter(function(ticket) {
				return ticket.isRegister && ticket.submitted;
			}).length > 0;
		}

		$scope.nameSubmit = function(ticket, $index) {
			var label = '';
			if (ticket.customerFirstName) {
				label += 'First Name : ' + ticket.customerFirstName;
			}

			if (ticket.customerLastName) {
				label += ' | Last Name : ' + ticket.customerLastName;
			}


			ticket.submit_attempt = true;

			if (ticket.customerFirstName && ticket.customerLastName) {
				if ($index == 0 && $scope.tickets.length > 1) {
					Modal.displayModal
					(
						{
							category: 'Ticket',
							label: 'Copy Last Name',
							replacementKeys: 'name',
							replacementValues: ticket.customerLastName,
							description: Language.getLocale('TicketView', 'ticketLastNameCopy'),
							buttonFlags: [Enums.buttonFlags.NO, Enums.buttonFlags.YES],
							callback: function(detail) {
								if (detail == Enums.buttonFlags.YES) {
									$scope.copyLastName(ticket.customerLastName);
								}
							}
						}
					);
				}

				ticket.ticket_view = true;
				ticket.isRegister = true;
				AppData.fetch(Enums.services.ADD_TICKET_CHARACTERISTICS, false, {
					oToken: OrderService.oToken,
					ticket_id: ticket.ticket_id,
					CHARACS: [{
						key: 'ticket_customer_name',
						value: ticket.customerFirstName + ' ' + ticket.customerLastName
					},
					{
						key: 'selected',
						value: 'true'
					}]
				}).then(
					function(data) {
						if (data.status == Enums.status.OK) {
							ticket.CHARACS = ticket.CHARACS || {};
							ticket.CHARACS.ticket_customer_name = ticket.customerFirstName + ' ' + ticket.customerLastName;
							ticket.submitted = true;
						} else {

						}
					}
				);
			}
		};

		$scope.copyLastName = function(lastName) {
			angular.forEach
			($scope.tickets
				, function(ticket) {
					if (!Utilities.childDefined(ticket, 'customerLastName')) {
						ticket.customerLastName = lastName;
					}
				}
			);
		};

		/**
		 * Format QR Barcode to group the main pass barcode and add on together
		 * Converting barcode to hexadecimal when the flag is true
		 * @function
		 * @public
		 * @return {undefined}
		 */
		$scope.addQRMultiBFormat = function(ticket) {
			var tempBarCode = { E1: ticket.orig_barcode };

			if (getBoolean(ticket.PRINT_AT_HOME.use_hex_converted_barcode)) {
				ticket.barcode = NumeralSystemService.convertDecimalStringToHex(ticket.orig_barcode);
			}

			if (isArray(ticket.oneBarcodePackages)) {
				ticket.oneBarcodePackages.forEach(function(barcodePackage, index) {
					tempBarCode['E' + (index + 2)] = barcodePackage.orig_barcode;
				});
			}

			if (safelyCheckPropertyOnObject('ticket.CHARACS.ph_season_pass_number', ticket)
					&& ticket.CHARACS.ph_season_pass_number !== 'NEW') {
				tempBarCode.PH = ticket.CHARACS.ph_season_pass_number;
			}

			ticket.qrBarCodeData = JSON.stringify(tempBarCode);
		}

		function InitializeCtrl() {
			$rootScope.hideSpinner();

			$scope.isMobile = getIsMobile();
			if (JSONValidator.validate('mobile_ticket_options', AppData.settings.mobile_ticket_options)) {
				$scope.mobileTicketOptions = JSON.parse(AppData.settings.mobile_ticket_options);
				$scope.showAdditionalGuestNames = getBoolean($scope.mobileTicketOptions.show_additional_guest_names);
				$scope.barcodeScale = $scope.mobileTicketOptions.barcode_scale;

				// Override for mobile ticket Date Format
				if (validString($scope.mobileTicketOptions.date_format)) {
					$scope.ticketDateFormat = $scope.mobileTicketOptions.date_format;
				}
			}

			// Reset the data.
			resetProperties();

			setMerchantDetails();

			if ($stateParams.phoneNumber) {
				OrderService.phoneNumber = $stateParams.phoneNumber;
			}

			if ($stateParams.lastFour) {
				OrderService.lastFour = $stateParams.lastFour;
			}

			if ($stateParams.emailAddress) {
				OrderService.email = $stateParams.emailAddress;
			}

			if ($stateParams.orderId) {
				OrderService.orderID = $stateParams.orderId;
			}

			if ($stateParams.token) {
				OrderService.token = $stateParams.token;
			}

			if (angular.isDefined($stateParams.customerId)) {
				OrderService.customerID = $stateParams.customerId;
			}

        	// Load OrderService if it hasn't already been populated.
			OrderService.loadFromStorage(AppData.GuestViewOrder.VIEW_ORDER_REPLY);

			$scope.viewOrder = AppData.GuestViewOrder;
			$scope.thirdPartyTransactionId = Utilities.safelyCheckPropertyOnObject('viewOrder.VIEW_ORDER_REPLY.ORDER_STATUS_REPLY.CHARACS.third_party_transaction_id', $scope.viewOrder, function(val) {
				return val;
			});

			if ($scope.viewOrder.status == Enums.status.OK) {
				//
				// Reseller POS mode
				// POS handles the printing when in this mode
				// therefore we do not require all the viewOrder processing
				// and we need to display POS specific content
				//
				if (CustomActionService.actionRegistered(CustomActionService.ACTIONS_ENUMS.RESELLER_POS_PRINT_ORDER_VIEW)) {
					CustomActionService.executeCustomAction(CustomActionService.ACTIONS_ENUMS.RESELLER_POS_PRINT_ORDER_VIEW, $scope);
					return;
				}

				var viewOrderReply = $scope.viewOrder.VIEW_ORDER_REPLY;
				var paymentDetails = viewOrderReply.PAYMENT_DETAILS;
				var customerDetailsReply = viewOrderReply.CUSTOMER_DETAILS_REPLY;
				var orderHistoryReply = viewOrderReply.ORDER_HISTORY_REPLY.ACTION;
				var orderItemsReply = viewOrderReply.ORDER_ITEMS_REPLY;
				var orderStatusReply = viewOrderReply.ORDER_STATUS_REPLY;
				var ticketDetailsReply = viewOrderReply.TICKET_DETAILS_REPLY;

				// Make payments/PAYMENT an array.
				var payments = paymentDetails.PAYMENT =
					(isArray(paymentDetails.PAYMENT))
						? paymentDetails.PAYMENT
						: [paymentDetails.PAYMENT];

				var dateObj = orderHistoryReply.date_time ? orderHistoryReply.date_time.split(' ')[0] : '';

				$scope.orderDetails.dateObject = $scope.getOrderDate(orderStatusReply.order_date);
				$scope.orderDetails.date = $filter('date')(dateObj, $scope.dateFormat);
				$scope.orderDetails.time = orderHistoryReply.date_time ? orderHistoryReply.date_time.split(' ')[1] : '';
				$scope.orderDetails.status = orderHistoryReply.status || '';
				$scope.hideSubtotal = ticketCharacToBoolean(ticketDetailsReply.TICKET, 'hide_subtotal');

				$scope.showVendorNameOnTicket = getBoolean(AppData.settings.show_vendor_name_on_ticket);

				// Verify we have a phone number and either email address or the last four digits of CC.
				var phoneNumber = getPhoneNumber(customerDetailsReply.CUSTOMER.PHONE);
				var emailAddress = emailAddressMatch(customerDetailsReply.CUSTOMER.EMAIL);
				var lastFour = lastFourCCDigitsMatch(payments);
				var token = tokenMatch(orderStatusReply.order_date, orderStatusReply.cart_id);

				// Reset all the previous info.
				resetCartObject();

				if ((((emailAddress === '' && lastFour === '') || phoneNumber === '') && token === '') &&
					(OrderService.lastFour === undefined && OrderService.email === undefined && OrderService.phoneNumber === undefined) &&
					(OrderService.customerID === undefined)) {
					//the supplied email and phone numbers don't match the order info
					Modal.displayModal(
						{
							category: 'PrintAtHome',
							action: 'Error',
							label: 'Invalid Data',
							title: Language.getLocale('Alert', 'viewOrderMismatchTitle'),
							description: Language.getLocale('Alert', 'viewOrderMismatchMsg'),
							buttonFlags: [Enums.buttonFlags.OK],
							callback: function() {
								$scope.routeTo('packageList');
							}
						}
					);

					return;
				} else {
					// Set the flags for the various delivery methods.
					determineDeliveryMessage(orderStatusReply);

					if (ticketDetailsReply.TICKET.length) {
						// Start of Visible Ticket Block.
						$scope.state.parkName = orderStatusReply.merchant_display_name || orderStatusReply.merchant_name;
						$scope.ticketObject.selectedOrderID = orderStatusReply.order_id;

						// Merlin MyAccount content card gating (MERLIN-161). Replaces the
						// Print Your Tickets button with the external-account-card when
						// configured. Called here so $scope.state.parkName is available for
						// the localized copy token replacement.
						setupExternalAccountCard();

						if (lastFour) {
							$scope.ticketObject.selectedOrderL4 = lastFour;
						} else if (!lastFour && angular.isDefined(payments) && isArray(payments) && typeof payments[ 0 ] == 'undefined') {

						} else if (!lastFour && angular.isDefined(payments[ 0 ].auth_type) && payments[ 0 ].auth_type == 'PPA') {
							// Paypal Detection.
							$scope.showPayPalPayment = true;
							$scope.showSpritePaymentType = true;
							$scope.paypalAccount = customerDetailsReply.CUSTOMER.EMAIL.address;

							$scope.ticketObject.selectedOrderL4 = false;
						}

						// Store reference to phone number in rootScope. -- ??
						$scope.ticketObject.selectedOrderPN = phoneNumber;

						// Add the ticket collection to scope.
						$scope.tickets = $scope.getPrintablePackages(ticketDetailsReply.TICKET);

						if ($scope.showAdditionalGuestNames) {
							$scope.tickets = $scope.tickets.map($scope.prepareAdditionalGuestNames);
						}

						parseOneBarcodePackages();

						//if the is isSpecialDelivery, we do not need to display every ticket confirmation number
						if ($scope.isSpecialDelivery) {
							if ($scope.tickets.length > 0) {
								$scope.tickets = [$scope.tickets[ 0 ]];
							}
						}

						// Update all the necessary info on the tickets.
						setAllTicketInfo($scope.tickets);

						// Set the confirmation number.
						$scope.confirmationNumber = getConfirmationNumber(paymentDetails);

						$scope.cartObject.cartItems = $filter('ignoreOneBarcodeAddons')(getTickets(ticketDetailsReply, orderHistoryReply, orderItemsReply));

						// TODO: This isn't working correctly and needs to be revisited.
						// Need to account for full refunds, partial refunds, refunds with pament plan orders.
						// Refunded order items.
						//$scope.cartObject.cartItems = $scope.cartObject.cartItems.concat( getRefundedItems( orderItemsReply ) );

						// Get and store all other fees.
						storeOtherFees(orderItemsReply, orderStatusReply, ticketDetailsReply);

						// Check if this receipt has Gift Aid
						setGiftAidInfo(orderStatusReply);

						// Filter out one barcode children from base tickets
						$scope.tickets = $filter('ignoreOneBarcodeAddons')($scope.tickets);
					} else {
						// Email or last four and phone number validation failed.
						$scope.showNoTicketError = true;
					}

					if ($scope.isMobile) {
						$scope.receiptHidePrices = getReceiptHidePrices(orderStatusReply);
						$scope.bookingPortalButton = getBookingPortalConfigs();
					}

					$scope.hidePlaceNewOrderButton = getHidePlaceNewOrderButton(paymentDetails);
				}
			} else if ($scope.viewOrder.status == Enums.status.FAILED) {
				$scope.showNoTicketError = true;
			}

			//
			// Social Media features.
			//
			// Ensure that at least facebook or twitter is enabled.
			$scope.enableSocialMedia = false;
			if (JSONValidator.validate('social_media', AppData.GetApplicationConsolidated.SETTINGS.feature_social_media_config)) {
				var smc = JSON.parse(AppData.GetApplicationConsolidated.SETTINGS.feature_social_media_config);
				// Now that the JSON is validated, we can freely check it.
				$scope.enableSocialMedia = smc.facebook.enabled || smc.twitter.enabled;
				$scope.smc = smc;
			}


			// Enable Coupon features
			// Note that isMobile is now required by coupons.
			$scope.ifCoupons = false;

			var adImages = [undefined, undefined, undefined];
			$scope.adImages = {
				top: undefined,
				middle: undefined,
				bottom: undefined
			};


			if (JSONValidator.validate('coupons', AppData.GetApplicationConsolidated.SETTINGS.feature_coupons)) {
				var couponSettings = JSON.parse(AppData.GetApplicationConsolidated.SETTINGS.feature_coupons);

				// Now that the JSON is validated, we can freely check it.
				adImages = ["top", "middle", "bottom"].map(function(e) {
					var keys = ["adUnit1", "adUnit2", "adUnit3"];
					for (var i=0; i<keys.length; i++) {
						if (couponSettings[keys[i]]!==undefined && couponSettings[keys[i]].position===e) {
							return couponSettings[keys[i]];
						}
					}
					return undefined;
				});

				$scope.adImages = {
					top: adImages[0],
					middle: adImages[1],
					bottom: adImages[2]
				};
			}

			$scope.ifCoupons = (adImages.filter(function(e) {
				return e !== undefined;
			}).length !==0);
			// End Coupon Feature

			// Lastly, init the links for the receipt and print buttons
			// `receipt_view`, `print_view`
			var receiptParams = {
				lastFour: OrderService.lastFour,
				phoneNumber: OrderService.phoneNumber,
				orderId: OrderService.orderID,
				cToken: OrderService.cToken,
				eToken: OrderService.eToken,
				pToken: OrderService.pToken,
				oToken: OrderService.oToken
			};

			if ((!isString(receiptParams.phoneNumber) && !angular.isNumber(receiptParams.phoneNumber)) && safelyCheckPropertyOnObject('AppData.GuestViewOrder.VIEW_ORDER_REPLY.CUSTOMER_DETAILS_REPLY.CUSTOMER.PHONE.number', AppData)) {
				receiptParams.pToken = AppData.GuestViewOrder.VIEW_ORDER_REPLY.CUSTOMER_DETAILS_REPLY.CUSTOMER.PHONE.pToken;
				receiptParams.phoneNumber = AppData.GuestViewOrder.VIEW_ORDER_REPLY.CUSTOMER_DETAILS_REPLY.CUSTOMER.PHONE.number;
			}

			var receipt_view = Utilities.getBasePath(AppData, 'receipt_view');
			var queryParams = UrlUtils.objectToQueryParams($location.search());
			var simpleStoreConfig = CustomActionService.actionRegistered(CustomActionService.ACTIONS_ENUMS.SIMPLE_STORE_CONFIG) ? CustomActionService.executeCustomAction(CustomActionService.ACTIONS_ENUMS.SIMPLE_STORE_CONFIG) : {};
			$scope.receiptViewUrl = Utilities.doCommonUriParameterReplacements(receipt_view, AppData.merchant, receiptParams);
			$scope.simpleStoreConfig = angular.extend({
				dateFormat: 'shortDate',
				dateTimeFormat: 'short',
				orderUrl: $state.href('simple-store-order', receiptParams) + (validString(queryParams) ? '?' + queryParams : '')
			}, simpleStoreConfig);

			PostPurchaseActionsService
				.executeActions()
				.catch(function() {
					$rootScope.hideSpinner();
					Modal.displayModal({
						title: Language.getLocale('CartView', 'postPurchaseActionsFailedTitle'),
						description: Language.getLocale('CartView', 'postPurchaseActionsFailedMsg')
					});
				});

			$scope.showTicketSection = $scope.checkConditionsToDisplayPrintTicket();

		}

		/**
		 * Grab guest names from the CHARACs for the ticket and make a more accessible data structure, to display the info on the ticket.
		 * Designed for use in .map()
		 * @param {Object} Ticket the ticket to prepare guestnames for
		 * @return {Object} The modified ticket.
		 */
		$scope.prepareAdditionalGuestNames = function(ticket) {
			ticket.guestNames = [];

			if (Utilities.safelyCheckPropertyOnObject('ticket.CHARACS', ticket)) {
				Object.keys(ticket.CHARACS).forEach(function(keyName) {
					if (keyName.indexOf(Enums.ticketCharacs.GUESTCUSTOMERNAME) >= 0 && UtilsValidation.validString(ticket.CHARACS[keyName])) {
						ticket.guestNames.push(ticket.CHARACS[keyName]);
					}
				});
			}

			return ticket;
		}

		/**
		 * Route to the Media Content Engine to view tickets on mobile
		 * Takes mce_url from app config and swaps in the oToken and cToken
		 * then redirects to that url
		 * @public
		 * @returns {undefined}
		 */
		$scope.routeToMCE = function() {
			var island = AppData.island;
			var stack = AppData.stack;
			var domain = AppData.baseDomain;
			var oToken = OrderService.oToken;
			var cToken = OrderService.cToken;
			var mceURL;

			if (!validString(island) || !validString(stack) || !validString(domain)) {
				$log.error('island, stack or domain is not defined');
				Modal.displayModal({
					title: Language.getLocale('CartView', 'postPurchaseActionsFailedTitle'),
					description: Language.getLocale('CartView', 'postPurchaseActionsFailedMsg')
				});
				return;
			}

			if (!validString(oToken) || !validString(cToken)) {
				$log.error('oToken or cToken is not defined');
				Modal.displayModal({
					title: Language.getLocale('CartView', 'postPurchaseActionsFailedTitle'),
					description: Language.getLocale('CartView', 'postPurchaseActionsFailedMsg')
				});
				return;
			}

			// https://media-engine.{{env}}.accessoticketing.com/tickets/v1/{{island}}?oToken={{oToken}}&cToken={{cToken}}
			mceURL = "https://media-engine." + stack + "." + domain + "/tickets/v1/" + island + "?oToken=" + oToken + "&cToken=" + cToken;

			if (validString(mceURL)) {
				if ($scope.isMobile) {
					$window.location.href = mceURL;
				} else {
					Utilities.routeToExternal(mceURL);
				}
			} else {
				$log.error('mce_url is not defined or empty');
				Modal.displayModal({
					title: Language.getLocale('CartView', 'postPurchaseActionsFailedTitle'),
					description: Language.getLocale('CartView', 'postPurchaseActionsFailedMsg')
				});
			}
		}

		/**
		 * Route to either account portal or booking portal based on the settings
		 * @public
		 * @returns {undefined}
		 */
		$scope.onRouteToPortalBtnClick = function() {
			if (Utilities.safelyCheckPropertyOnObject('AppData.settings.routeToAccountPortal', AppData, 'getBoolean')) {
				AccountPortalRoutingService.goToAccountPortal();
			} else {
				BookingPortalRoutingService.goToBookingPortal();
			}
		}
		/**
		 * Determines whether or not to display the 'Print' section of the page/s
		 * @public
		 * @returns {undefined}
		 */
		$scope.checkConditionsToDisplayPrintTicket = function() {
			return AppData.GuestViewOrder.VIEW_ORDER_REPLY.ORDER_STATUS_REPLY.order_status !== Enums.orderStatus.REFUNDED && !$scope.thanksPage && !$scope.isSpecialDelivery && !$scope.isNoShipping;
		}

		$scope.buildFeeSource = function(ticketDetailsReply, orderItemsReply) {
			var feeSource = {
					fees: [],
					tax: [],
					feeTotal: 0,
					taxTotal: 0
				},
				tax = {};

			if (angular.isDefined(ticketDetailsReply.TICKET)) {
				for (var i=0; i < ticketDetailsReply.TICKET.length; i++) {
					var ticket = ticketDetailsReply.TICKET[i];
					if (angular.isDefined(ticket.FEE)) {
						for (var j=0; j < ticket.FEE.length; j++) {
							feeSource.fees.push({
								label: Language.getLocale('CartView', 'fee' + ticket.FEE[j].id),
								amount: ticket.FEE[j].amount
							});
							feeSource.feeTotal += parseFloat(ticket.FEE[j].amount);
						}
					}
				}
			}

			if (Utilities.safelyCheckPropertyOnObject('orderItemsReply.PAID_TAXES.TAX', orderItemsReply)) {
				orderItemsReply.PAID_TAXES.TAX = Utilities.wrapObjectToArray(orderItemsReply.PAID_TAXES.TAX);
				for (i = 0; i < orderItemsReply.PAID_TAXES.TAX.length; i++) {
					tax = orderItemsReply.PAID_TAXES.TAX[i];
					feeSource.tax.push({
						label: Language.getLocale('CartView', 'tax' + tax.tax_code),
						amount: tax.total_tax
					});
					feeSource.taxTotal += parseFloat(tax.total_tax);
				}
			}

			return feeSource;
		};

		$scope.showTaxAndFeeModal = function() {
			Modal.displayModal(
				{
					category: 'Taxes and Fees',
					action: 'View',
					label: Language.getLocale('CartView', 'taxesAndFeesLabel'),
					title: Language.getLocale('CartView', 'taxesAndFeesLabel'),
					showCloseButton: false,
					noPad: true,
					buttonFlags: [Enums.buttonFlags.CLOSE],
					customHTML: '/views/modals/taxes-and-fees.html',
					description: $scope.cartObject.feeSource
				}
			);
		};

		/**
		 * Loop through each package and determine which one is good for showing barcode
		 * if print_movie value is not none, then add ticket to printables
		 * if there is multi group ticket charac on ticket, then only add the main ticket (of the whole multigroup package) to the list, and other single tickets (like daily ticket/passes/) to printables
		 * NOTE: main ticket of the multi group package should have group_multi_ticket charac and group_multi_qty property
		 * @function
		 * @public
		 * @param {Object[]} pkgs - package array object list
		 * @return {Object[]} array list of all ticket objects that can be printed
		 */
		function getPrintablePackages(pkgs) {
			var i,
				printables;

			printables = pkgs.reduce(function(acc, item) {
				var print = item.print_movie ? item.print_movie : '';

				if (print.toLowerCase() !== 'none') {
					acc.push(item);
				}
				return acc;
			}, []);

			i = printables.length;
			if (i > 0) {
				while (i--) {
					var ticket = printables[i];
					if (!ticket.group_multi_qty && safelyCheckPropertyOnObject('ticket.CHARACS.group_multi_ticket', ticket, getBoolean)) {
						printables.splice(i, 1);
					}
				}
			}

			return printables;
		}

		function parseOneBarcodePackages() {
			for (var i = 0; i < $scope.tickets.length; i++) {
				var ticket = $scope.tickets[i];

				if (angular.isDefined(ticket.CHARACS) &&
					angular.isDefined(ticket.CHARACS.one_barcode_parent) &&
					angular.isDefined(ticket.CHARACS.group_uuid)) {
					// one barcode parent package - search for all child packages
					var childPackages = OneBarcodeUtilities.findAddonPackages($scope.tickets, ticket.CHARACS.group_uuid);

					if (childPackages.length > 0) {
						ticket.oneBarcodePackages = childPackages;
					}
				}
			}
		}

		function resetProperties() {
			$scope.showPayPalPayment = false;
			$scope.showSpritePaymentType = false;
			$scope.paypalAccount = '';

			if (!$scope.receiptView) {
				$scope.ticketObject.switchPage = 'tickets';
			}

			$scope.orderId = OrderService.orderID || $stateParams.orderId;
			$rootScope.ticketIndex = 0;
			$rootScope.ticketFront = true;
			$rootScope.currentTicket = 1;
			$scope.ClientInfo = ClientInfo;
			$scope.tickets = [];
			$scope.ticketNames = false;

			// Reset flag.
			$scope.showNoTicketError = false;
		}

		function setMerchantDetails() {
			$scope.merchant = {};

			if (angular.isDefined(AppData.merchant)) {
				$scope.merchant.alias = AppData.merchant;
			}

			if (angular.isDefined(AppData.environment)) {
				$scope.merchant.environment = AppData.environment;
			}

			if (angular.isDefined(AppData.island)) {
				$scope.merchant.island = AppData.island;
			}

			if (angular.isDefined(AppData.userId)) {
				$scope.merchant.userId = AppData.userId;
			}

			if (angular.isDefined(AppData.passbook) && angular.isDefined(AppData.passbook.url)) {
				$scope.merchant.passbook = AppData.passbook.url;
			}

			if (angular.isDefined(AppData.language)) {
				$scope.merchant.language = AppData.language;
			}
		}

		function setAllTicketInfo(tickets) {
			if (tickets.length > 0) {
				// Check to see if name registration is required for at least one ticket.
				var isRegReqForOne = isRegReqForAtLeastOne(tickets);
				var ticketIDList = [];

				//AXF 15330 - We don't want to show tickets when it's id match with
				//the ticket_ids on the url
				if (ngIsDefined($location.search().ticket_ids)) {
					CustomActionService.registerCustomAction(CustomActionService.ACTIONS_ENUMS.REMOVING_TICKET_IDS_FROM_URL, removingTicketIDParam);
					ticketIDList = $location.search().ticket_ids.split(',');
				}

				for (var i in tickets) {
					var ticket = tickets[ i ];
					/* Copying barcode to original barcode to work with mobile_ticket_options app config
					If ticket.barcode isn't saved into ticket.originalBarcode, ticket.barcode will be modified by using mobile_ticket_options.bar_code_option
					which adds a prefix to the barcode */
					ticket.originalBarcode = ticket.barcode;
					ticket.isHidden = false;
					if (ticketIDList.length > 0) {
						ticketIDList.forEach(function(ticketId) {
							if (ticket.ticket_id === ticketId) {
								ticket.isHidden = true;
								$scope.hideReceipt = true;
							}
						});
					}

					ticket.CHARACS = ticket.CHARACS || [];
					setTicketViewFlag(isRegReqForOne, ticket);
					setResourceTicketFlag(ticket);
					setShowAlternateMsg(ticket);
					setShowValidDates(ticket);
					setHideBarcode(ticket);
					setBarcodeType(ticket);
					checkForMobileTicketOptions('bar_code_option', setBarcodeOverride, ticket);
					$scope.SIAEEnabled = checkForSIAEDataOnTicket(ticket);
					ticket.SVCEnabled = checkForSVCDataOnTicket(ticket);

					// Update the ticket status.
					var ticketStatus = setTicketStatus(ticket);
					ticket.printable = (ticket.printable == '1') ? 1 : 0;
					ticket.isValid = (ticketStatus == 1);
					updateTicketInfo(ticket);
					renderDateTimeInfo(ticket);
					renderChildAuxInfo(ticket);
					renderAdvancedTicketInfo(ticket);
					replaceValidFromInfo(ticket);
					formatTicketBookingInfo(ticket);

					if (safelyCheckPropertyOnObject('ticket.PRINT_AT_HOME.displaySPID', ticket, getBoolean) && safelyCheckPropertyOnObject('ticket.SEASON_PASS.id', ticket)) {
						ticket.display_season_pass_id = true;
						ticket.season_pass_id = ticket.SEASON_PASS.id;
					}

					if (doAutoSubmit(ticket)) {
						$scope.nameSubmit(ticket);
					}
				}
			}
		}

		/**
		 * Sets Gift Aid Data to scope, where applicable
		 * @public
		 * @param {Object} orderStatusReply
		 * @returns {undefined}
		 */
		function setGiftAidInfo(orderStatusReply) {
			var characs = orderStatusReply.CHARACS;
			$scope.showGiftAid = safelyCheckPropertyOnObject('characs.gift_aid_opt_in_type', characs) && [GiftAidEnums.opt.DONATION, GiftAidEnums.opt.GIFT_AID].indexOf(characs.gift_aid_opt_in_type) !== -1;

			if ($scope.showGiftAid) {
				$scope.giftAid = {
					charityName: safelyCheckPropertyOnObject('characs.gift_aid_charity_name', characs, returnValue),
					declarationFormUrl: safelyCheckPropertyOnObject('characs.gift_aid_declaration_form_url', characs, returnValue),
					donationId: OrderService.orderID,
					registrationNumber: safelyCheckPropertyOnObject('characs.gift_aid_registration_number', characs, returnValue)
				};
			}
		}

		/**
		 * Removing the ticket_ids from url if user makes new purchase after viewing
		 * tickets from email
		 * @protected
		 * @return {undefined}
		 */
		function removingTicketIDParam() {
			if (ngIsDefined($location.search().ticket_ids)) {
				$location.search('ticket_ids', null);
			}
		}

		/**
		 * Logic is added based on the request on AXF 12313
		 * Function that modify barcode
		 * @protected
		 * @param {Object} ticket - ticket that will be modifed
		 * @param {Object} mobileTicketAppConfig - appconfig that has prefix and barcode_override info
		 * @return {undefined}
		 */
		function setBarcodeOverride(ticket, mobileTicketAppConfig) {
			var prefix = mobileTicketAppConfig.prefix ? mobileTicketAppConfig.prefix : '';
			var barcodeOverride = mobileTicketAppConfig.barcode_override ? mobileTicketAppConfig.barcode_override : 'barcode';
			var extraViewOrderAttributeOnTicket = mobileTicketAppConfig.extra_view_order_data_on_ticket;
			ticket.barcode = prefix + ticket[barcodeOverride];
			if (ngIsDefined(extraViewOrderAttributeOnTicket)) {
				addingViewOrderData(extraViewOrderAttributeOnTicket);
			}
		}

		/**
		 * Checking if the attribute on appconfig is present, if it does, then create a scope and show it on ticket
		 * @protected
		 * @param {object} - view order attribute app config
		 * @return {undefined}
		 */
		function addingViewOrderData(viewOrderAttributeAppConfig) {
			if (safelyCheckPropertyOnObject('AppData.GuestViewOrder.VIEW_ORDER_REPLY.' + viewOrderAttributeAppConfig.attribute_name, AppData)) {
				var viewOrderAttribute = viewOrderAttributeAppConfig.attribute_name.split('.');
				var tempValue = null;

				var attributeValue = AppData.GuestViewOrder.VIEW_ORDER_REPLY;

				for (var i = 0; i < viewOrderAttribute.length; i++) {
					tempValue = viewOrderAttribute[i];
					attributeValue = attributeValue[tempValue];
				}

				$scope.extraViewOrderData = {
					value: attributeValue,
					title: viewOrderAttributeAppConfig.attribute_title_locale
				}
			}
		}

		/**
		 * Merlin MyAccount content card gating (MERLIN-161 / external_account app config).
		 * The card replaces the Print Your Tickets button and routes the guest to an
		 * external account using a pre-formatted launcher URL returned by the API layer on
		 * the Guest View Order response. The card is only shown when the merchant is
		 * configured (enabled) AND the launcher URL is present; otherwise the legacy Print
		 * Your Tickets button is kept (PRD fallback rule). The URL is rendered as-is and
		 * never constructed.
		 * @protected
		 * @return {undefined}
		 */
		function setupExternalAccountCard() {
			$scope.externalAccountActive = false;
			$scope.externalAccountUrl = '';
			$scope.externalAccountUseStoreButton = false;
			$scope.externalAccountShowTicketButton = false;

			if (!JSONValidator.validate('external_account', AppData.settings.external_account)) {
				return;
			}

			var config = JSON.parse(AppData.settings.external_account);
			if (!getBoolean(config.enabled)) {
				return;
			}

			// Opt-in: fall back to the accesso store gap-button branding instead of the
			// custom Merlin-branded button (default).
			$scope.externalAccountUseStoreButton = getBoolean(config.use_store_button_style);

			// Opt-in: keep the View Tickets button visible alongside the card instead of
			// suppressing it (interim fix while an external account provider issue blocks
			// ticket access some other way).
			$scope.externalAccountShowTicketButton = getBoolean(config.show_ticket_button);

			// The launcher URL is returned by the API layer on the Guest View Order
			// response. The exact attribute is pending backend confirmation (MERLIN-161);
			// EXTERNAL_ACCOUNT_URL_ATTR holds the assumed path under VIEW_ORDER_REPLY.
			// safelyCheckPropertyOnObject returns the resolved value via the callback
			// when the property exists, or false otherwise (see usage at line ~424).
			var url = safelyCheckPropertyOnObject(
				'AppData.GuestViewOrder.VIEW_ORDER_REPLY.' + EXTERNAL_ACCOUNT_URL_ATTR,
				AppData,
				function(val) {
					return val;
				}
			);

			// PRD fallback rule: config enabled but launcher URL absent -> keep the
			// legacy Print Your Tickets button (externalAccountActive stays false).
			if (!validString(url)) {
				return;
			}

			$scope.externalAccountUrl = url;
			$scope.externalAccountCardCopy = buildExternalAccountCardCopy();
			$scope.externalAccountActive = true;
		}

		/**
		 * Resolves the localized External Account card copy, replacing tokens with live
		 * order/merchant values. All lookups are safe-checked so a missing property never
		 * throws:
		 *   @@merchant -> $scope.state.parkName, falling back to AppData.settings.merchant_name
		 *   @@email    -> GuestViewOrder ...CUSTOMER.EMAIL.address, falling back to ''
		 * @protected
		 * @return {string} The localized copy with tokens replaced
		 */
		function buildExternalAccountCardCopy() {
			// safelyCheckPropertyOnObject discards the FIRST path segment (it labels the
			// obj itself), so each path must lead with the obj's name — e.g. '$scope.…' /
			// 'AppData.…' — matching the existing calls at lines ~429 and ~644.
			var parkName = safelyCheckPropertyOnObject('$scope.state.parkName', $scope, function(val) {
				return val;
			});
			var merchantSetting = safelyCheckPropertyOnObject('AppData.settings.merchant_name', AppData, function(val) {
				return val;
			});
			var merchant = validString(parkName)
				? parkName
				: (validString(merchantSetting) ? merchantSetting : '');

			// CUSTOMER.EMAIL may be a single object ({ address }) OR an array of them
			// (mirrors emailAddressMatch handling), so resolve EMAIL first, then dig out
			// the address from whichever shape we got.
			var emailNode = safelyCheckPropertyOnObject(
				'AppData.GuestViewOrder.VIEW_ORDER_REPLY.CUSTOMER_DETAILS_REPLY.CUSTOMER.EMAIL',
				AppData,
				function(val) {
					return val;
				}
			);
			if (isArray(emailNode)) {
				emailNode = emailNode[ 0 ];
			}
			var email = safelyCheckPropertyOnObject('emailNode.address', emailNode, function(val) {
				return val;
			});
			if (validString(email) && email.indexOf('@') !== -1) {
				var emailParts = email.split('@');
				var domainPart = emailParts[1];
				var lastDot = domainPart.lastIndexOf('.');
				var maskedDomain = lastDot > 2
					? new Array(lastDot - 1).join('*') + domainPart.slice(lastDot - 2)
					: domainPart;
				email = emailParts[0] + '@' + maskedDomain;
			} else {
				email = validString(email) ? email : '';
			}

			return Language.replaceAllMultiple(
				['@@merchant', '@@email'],
				[merchant, email],
				Language.getLocale('ExternalAccount', 'cardCopy')
			);
		}

		/**
		 * This function is used to add extra data we want to show on the receipt
		 * @protected
		 * @param {Object} ticket - ticket item that will be modified
		 * @param {Object} mobileTicketAppConfig - appconfig that has attribute mapping and locale info
		 * @return {undefined}
		 */
		function displayExtraDataOnReceiptTicket(ticket, mobileTicketAppConfig) {
			var dataAttribute = mobileTicketAppConfig.receipt_code_attribute_mapping;
			var dataAttributeTitle = mobileTicketAppConfig.receipt_code_locale;

			if (ngIsDefined(ticket[dataAttribute] && angular.isDefined(dataAttributeTitle))) {
				ticket.showExtraDataOnReceipt = true;
				ticket.extraData = ticket[dataAttribute];
				ticket.extraDataTitle = dataAttributeTitle;
			}
		}

		/**
		 * This function is used to check for ticketOptionAppConfigName configuration in the $scope.mobileTicketOptions,
		 * If this config is present, then we will execute the passed in function
		 * @protected
		 * @param {string} ticketOptionAppConfig - check to see if this app config is present under mobile_ticket_options
		 * @param {Function} action - passed in function, will be executed if ticketOptionAppConfig presents
		 * @param {Object} ticket - the ticket that will be modified
		 * @return {undefined}
		 */
		function checkForMobileTicketOptions(ticketOptionAppConfigName, actionFunction, ticket) {
			if (isObject($scope.mobileTicketOptions) && isObject($scope.mobileTicketOptions[ticketOptionAppConfigName])) {
				actionFunction(ticket, $scope.mobileTicketOptions[ticketOptionAppConfigName]);
			}
		}

		/**
		 * This function checks to see if the ticket is SIAE configured and sets extraViewOrderData if it is
		 * @protected
		 * @param {Object} ticket - the ticket that will be modified
		 * @return {boolean} true if SIAE is enabled
		 */
		function checkForSIAEDataOnTicket(ticket) {
			return ticket.barcodeType === 'qrcode' && safelyCheckPropertyOnObject('ticket.SIAE_DATA.issued_ticket_id', ticket);
		}

		/**
		 * This function checks to see if the ticket has SVC data configured
		 * @protected
		 * @param {Object} ticket - the ticket that will be modified
		 * @return {boolean} true if SVC data is on the ticket
		 */
		function checkForSVCDataOnTicket(ticket) {
			return (safelyCheckPropertyOnObject('ticket.svc_pin', ticket) && safelyCheckPropertyOnObject('ticket.svc_card_number', ticket));
		}

		/**
		 *  If booking information is present on a ticket, then ensure we have info properly formatted
		 * @param ticket
		 */
		function formatTicketBookingInfo(ticket) {
			if (angular.isDefined(ticket.BOOKING)) {
				ticket.BOOKING = Utilities.wrapObjectToArray(ticket.BOOKING);
			}
		}

		function setBarcodeType(ticket) {
			if (angular.isDefined(ticket.PRINT_AT_HOME) &&
				angular.isDefined(ticket.PRINT_AT_HOME.use_qrcode) &&
				getBoolean(ticket.PRINT_AT_HOME.use_qrcode)) {
				ticket.barcodeType = 'qrcode';

				if (getBoolean(ticket.PRINT_AT_HOME.QRMultiBFormat)) {
					$scope.addQRMultiBFormat(ticket);
				}
			} else {
				ticket.barcodeType = 'code128';
			}

			ticket.orderIdBarcode = ticket.PRINT_AT_HOME && Utilities.getBoolean(ticket.PRINT_AT_HOME.use_order_id_as_barcode);
		}

		/**
		 * Show alternate ticket instructions and information if flex_no_print charac is present
		 * This is used to show voucher and pass information in place of the barcode (used for some renewals)
		 * @param ticket
		 */
		function setShowAlternateMsg(ticket) {
			//initialize showAlternateMsg to false
			ticket.showAlternateMsg = false;

			if (angular.isDefined(ticket.CHARACS.flex_no_print) && ticket.CHARACS.flex_no_print == 'true') {
				ticket.showAlternateMsg = true;
			}
		}

		/**
		 * This function checks if the expire_date is set on the season_pass node and if the correct print format.
		 * is set and the ticket.showExpirationDate accordingly.
		 * @protected
		 * @param {Object} ticket - the ticket that will be modified
		 * @returns {undefined}
		 */
		function setShowValidDates(ticket) {
			ticket.showValidDates = false;
			if (safelyCheckPropertyOnObject('ticket.PRINT_AT_HOME.display_season_pass_expiry', ticket, getBoolean) && safelyCheckPropertyOnObject('ticket.SEASON_PASS.expire_date', ticket, getBoolean)) {
				ticket.showValidDates = true;
				var dateObj = Utilities.parseDate(ticket.SEASON_PASS.expire_date, 'mm-dd-yyyy', '-');
				ticket.expiration_date = $filter('date')(new Date(dateObj.year, dateObj.month, dateObj.day), $scope.dateFormat);
			}
		}

		/**
		 * This function is used to check for the package charac hide_barcode and set the ticket.hideBarcode accordingly.
		 * This will hide the barcode for this ticket, as well as add package specific verbiage to the ticket view
		 * @protected
		 * @param {Object} ticket - the ticket that will be modified
		 * @return {undefined}
		 */
		function setHideBarcode(ticket) {
			ticket.hideBarcode = false;
			if (getBoolean(ticket.CHARACS.hide_barcode)) {
				ticket.hideBarcode = true;
			}
		}

		function setTicketStatus(ticket) {
			var ticketStatuses = ['cancelled', 'deposit received', 'unknown', 'upgraded', 'used'];
			var ticketStatus = Utilities.getString(ticket.ticket_status).toLowerCase();
			return (ticketStatuses.indexOf(ticketStatus) > -1) ? 0 : 1;
		}

		function isRegReqForAtLeastOne(tickets) {
			for (var i in tickets) {
				if (getBoolean(tickets[ i ].name_required_to_print)) {
					return true;
				}
			}

			return false;
		}

		function getTicketRegistrationStatus(ticket) {
			var isTicketRegistered =
				angular.isDefined(ticket.CHARACS) &&
				ticket.CHARACS.ticket_customer_name &&
				isString(ticket.CHARACS.ticket_customer_name) &&
				ticket.CHARACS.ticket_customer_name.toUpperCase().replace(/ /g, '') != 'VOUCHER';
			return isTicketRegistered;
		}

		function setTicketViewFlag(isRegReqForOne, ticket) {
			var isRegistrationReq = getBoolean(ticket.name_required_to_print);
			var isTicketRegistered = getTicketRegistrationStatus(ticket);

			if (isRegistrationReq && isTicketRegistered) {
				ticket.ticket_view = true;
			} else if (isRegistrationReq && !isTicketRegistered) {
				ticket.ticket_view = false;
			} else if (!isRegistrationReq && !isTicketRegistered && isRegReqForOne) {
				ticket.ticket_view = false;
				ticket.customerFirstName = "Guest";
				ticket.customerLastName = "Guest";
			} else {
				ticket.ticket_view = true;
			}
		}

		/**
		 * Method that receives a ticket and sets a isResourceTicket property
		 * of the ticket if the ticket contains a resource_name.
		 * @memberOf TicketCtrl
		 * @public
		 * @function
		 * @name setResourceTicketFlag
		 * @param ticket
		 * @returns {undefined}
		 */
		function setResourceTicketFlag(ticket) {
			ticket.isResourceTicket = safelyCheckPropertyOnObject('ticket.CHARACS.resource_name', ticket, 'validString');
		}

		function doAutoSubmit(ticket) {
			// Copy reservation first name with last name to customer name.
			// Verify that the  `ticket.CHARACS` exists before proceeding.
			var submitTicket = false;
			ticket.isRegister = false;
			if (angular.isDefined(ticket.CHARACS)) {
				var firstName = ticket.CHARACS.rv_first_name ||
					ticket.CHARACS.ph_first_name ||
					ticket.CHARACS.np_first_name ||
					ticket.CHARACS.gr_pc_first_name ||
					ticket.CHARACS.FirstName ||
					ticket.CHARACS.firstName ||
					ticket.CHARACS.first_name;

				var lastName = ticket.CHARACS.rv_last_name ||
					ticket.CHARACS.ph_last_name ||
					ticket.CHARACS.np_last_name ||
					ticket.CHARACS.gr_pc_last_name ||
					ticket.CHARACS.LastName ||
					ticket.CHARACS.lastName ||
					ticket.CHARACS.last_name;

				if (firstName &&
					(angular.isUndefined(ticket.CHARACS.ticket_customer_name) ||
					ticket.CHARACS.ticket_customer_name == '')) {
					ticket.customerFirstName = firstName;
					ticket.CHARACS.ticket_customer_name = firstName;
					ticket.isRegister = true

					if (lastName) {
						ticket.customerLastName = lastName;
						ticket.CHARACS.ticket_customer_name += ' ' + lastName;
					}

					submitTicket = true;
				}

				if (angular.isDefined(ticket.CHARACS.ticket_customer_name)) {
					var name = ticket.CHARACS.ticket_customer_name.split(' ');
					ticket.isRegister = true;
					ticket.customerFirstName = name[ 0 ];
					ticket.customerLastName = name[ 1 ];
				}
			}

			return submitTicket;
		}

		/**
		@todo the result of this needs to be set in the scope, and that value
		**/
		function checkIfPassbookDevice() {
			var is_iPod = !!(((ClientInfo).deviceResults || {}).model || '').match(/iPod/i);
			var is_iPhone = !!(((ClientInfo).deviceResults || {}).model || '').match(/iPhone/i);
			var is_Safari = !!(((ClientInfo).browserResults || {}).name || '').match(/Safari/i);
			var is_iOS6 = !!((((ClientInfo).osResults || {}).name || '').match(/iOS/i) && (parseInt((((ClientInfo).osResults || {}).version || 0)) >= 6));

			return !!(((is_iPod || is_iPhone) && is_Safari && is_iOS6));
		}

		function updateTicketInfo(ticket) {
			ticket.use_passbook = 0;

			if (typeof ticket.PRINT_AT_HOME != 'undefined') {
				ticket.mobile_header = getTicketInfo(ticket, 'mobile_header', 'printMobileHeader');
				ticket.mobile_footer = getTicketInfo(ticket, 'mobile_footer', 'printMobileFooter');
				ticket.ticket_additional_info = getTicketInfo(ticket, 'ticket_additional_info', 'printTicketAdditional_info');
				ticket.ticket_more_info = getTicketInfo(ticket, 'ticket_more_info', 'printTicketMoreInfo');
				ticket.ticket_instructions = getTicketInfo(ticket, 'ticket_instructions', 'printTicketInstructions');
				ticket.ticket_terms_of_use = getTicketInfo(ticket, 'ticket_terms_of_use', 'printTicketTermsOfUse');
				ticket.ticket_disclaimer = getTicketInfo(ticket, 'ticket_disclaimer', 'printTicketDisclaimer');
				ticket.use_passbook = getBoolean(ticket.PRINT_AT_HOME.use_passbook);
			}
		}

		/**
		 *	If ticketKey is undefined, then return default locale.
			*/

		function getTicketInfo(ticket, ticketKey, defaultLocaleTarget) {
			if (typeof ticket.PRINT_AT_HOME[ ticketKey ] != 'undefined') {
				return ticket.PRINT_AT_HOME[ ticketKey ];
			} else {
				return Language.getLocale('TicketView', defaultLocaleTarget);
			}
		}

		function renderDateTimeInfo(ticket) {
			ticket.showDateTime =
				!!((
					ticket.EVENT &&
					ticket.CHARACS &&
					ticket.CHARACS.client_xfc_view != undefined &&
					ticket.CHARACS.client_xfc_view.toLowerCase().indexOf('datetime') > -1
				));
		}

		function renderChildAuxInfo(ticket) {
			ticket.showChildInfo =
				!!(safelyCheckPropertyOnObject('ticket.CHARACS.ph_children', ticket) &&
				(
					ticket.CHARACS.ph_children !== '' &&
					ticket.CHARACS.ph_children !== 0 &&
					ticket.CHARACS.ph_children !== '0'
				));

			ticket.showAuxInfo =
				!!((safelyCheckPropertyOnObject('ticket.CHARACS.ph_aux_1', ticket) &&
				ticket.CHARACS.ph_aux_1 !== '') ||
				(safelyCheckPropertyOnObject('ticket.CHARACS.ph_aux_2', ticket) &&
				ticket.CHARACS.ph_aux_2 !== ''));

			if (ticket.showChildInfo) {
				ticket.shownChildren = [];
				for (var i = 1; i <= ticket.CHARACS.ph_children; i++) {
					if (angular.isUndefined(ticket.CHARACS['ph_child_name' + i])) {
						ticket.showChildInfo = false;
						return;
					} else {
						ticket.shownChildren.push(ticket.CHARACS['ph_child_name' + i]);
					}
				}
			}

			if (ticket.showAuxInfo) {
				ticket.shownGuests = [];
				for (var i = 1; i <= 2; i++) {
					if (ticket.CHARACS['ph_aux_' + i] !== '') {
						ticket.shownGuests.push(ticket.CHARACS['ph_aux_' + i]);
					}
				}
			}
		}


		function renderAdvancedTicketInfo(ticket) {
			ticket.showAdvancedTicket =
				!!((
					ticket.EVENT &&
					ticket.CHARACS &&
					ticket.CHARACS.client_is_advanced_ticket != undefined &&
					ticket.CHARACS.client_is_advanced_ticket.toLowerCase() == 'true'
				));
		}

		function replaceValidFromInfo(ticket) {
			if (ticket.showAdvancedTicket && ticket.ticket_instructions) {
				ticket.ticket_instructions =
					Language.replaceAllMultiple
					(['@@date']
						, [$filter('date')(ticket.CHARACS.valid_from, $scope.dateFormat = AppData.settings.date_format)]
						, Language.replaceAllMultiple
						(['@@Date']
							, [$filter('date')(ticket.CHARACS.valid_from, $scope.dateFormat = AppData.settings.date_format)]
							, ticket.ticket_instructions
						)
					);
			}
		}

		function getConfirmationNumber(paymentDetails) {
			try {
				if (isArray(paymentDetails.PAYMENT)) {
					return paymentDetails.PAYMENT[ 0 ].order_id;
				} else {
					return paymentDetails.PAYMENT.order_id;
				}
			} catch (error) {
				return Utilities.childDefined(AppData, 'GuestViewOrder.VIEW_ORDER_REPLY.ORDER_STATUS_REPLY.order_id')
					? AppData.GuestViewOrder.VIEW_ORDER_REPLY.ORDER_STATUS_REPLY.order_id
					: 0;
			}
		}

		/**
		 * Determines if the ticket charac specified is present.
		 * @protected
		 * @function
		 * @name storeOtherFees
		 * @param {Object} orderItemsReply The items response from viewOrder
		 * @param {Object} orderStatusReply The status response from viewOrder
		 * @param {Object} ticketDetailsReply The ticket details response from viewOrder
		 * @return {undefined}
		 */
		function storeOtherFees(orderItemsReply, orderStatusReply, ticketDetailsReply) {
			var ignoreTaxTicketCharac = ticketCharacToBoolean(ticketDetailsReply.TICKET, 'ignore_tax'),
				i = 0,
				shouldConsolidateFees = getBoolean(AppData.settings.consolidate_fees);

			// TAX
			if (!getBoolean(AppData.settings.ignore_tax) && !ignoreTaxTicketCharac && !shouldConsolidateFees) {
				if (Utilities.safelyCheckPropertyOnObject('orderItemsReply.PAID_TAXES.TAX', orderItemsReply)) {
					orderItemsReply.PAID_TAXES.TAX = Utilities.wrapObjectToArray(orderItemsReply.PAID_TAXES.TAX);
					for (i = 0; i < orderItemsReply.PAID_TAXES.TAX.length; i++) {
						var tax = orderItemsReply.PAID_TAXES.TAX[i];
						$scope.cartObject.taxAndCartAdjustmentAndShipping.push({
							label: Language.getLocale('CartView', 'tax' + tax.tax_code),
							amount: tax.total_tax
						});
					}
				} else {
					$scope.cartObject.taxAndCartAdjustmentAndShipping.push(
						{
							label: Language.getLocale('CartView', 'taxLabel'),
							amount: orderItemsReply.TOTALS.tax_total
						}
					);
				}
			}

			if (shouldConsolidateFees) {
				// FEES - buildFeeSource should really be in a service, but there's not a viable ticket-service currently
				$scope.cartObject.feeSource = $scope.buildFeeSource(ticketDetailsReply, orderItemsReply);
			}

			// TOTALS
			$scope.cartObject.subTotal = orderItemsReply.TOTALS.retail_total;
			$scope.cartObject.total = orderItemsReply.TOTALS.current_total;

			// Build the cart Items and store fees in collections.
			if (angular.isDefined(orderItemsReply.ITEM)) {
				if (!isArray(orderItemsReply.ITEM)) {
					orderItemsReply.ITEM = [orderItemsReply.ITEM];
				}

				// this needs to be here for the display of the items to show up
				// correctly on the receipt view.
				var cartItems = {};
				var taxAndCartAdjustmentAndShipping = {};

				for (var i in orderItemsReply.ITEM) {
					// Iterate through each item and save the fees in the appropriate collection.
					var currentItem = orderItemsReply.ITEM[ i ];

					// grab the Tickets in the order for the receipt.
					saveTickets(currentItem, cartItems);

					/*
					 * The following code is to support the legacy way of displaying fees.
					 * In this manner, they are all added to the full taxAndCartAdjustmentAndShipping array.
					 * If and when the consolidated fees method is accepted globally, this code can simply be removed as well as the config dependency
					 */
					if (!shouldConsolidateFees) {
						saveFees(currentItem, taxAndCartAdjustmentAndShipping);
					}

					// grab any adjustments related to the order for the receipt.
					saveAdjustments(currentItem, taxAndCartAdjustmentAndShipping);
				}

				if (orderStatusReply.SCHEDULED_PAYMENTS) {
					// Build the cart Items and store fees in collections.
					if (ticketDetailsReply.TICKET) {
						ticketDetailsReply.TICKET = isArray(ticketDetailsReply.TICKET) ? ticketDetailsReply.TICKET : [$scope.viewOrder.VIEW_ORDER_REPLY.TICKET_DETAILS_REPLY.TICKET];

						// This needs to be here for the display of the items to show up.
						// correctly on the receipt view.
						var cartItems = {};

						for (var i in $scope.viewOrder.VIEW_ORDER_REPLY.TICKET_DETAILS_REPLY.TICKET) {
							// Iterate through each item and save the fees in the appropriate collection.
							var currentItem = $scope.viewOrder.VIEW_ORDER_REPLY.TICKET_DETAILS_REPLY.TICKET[ i ];
							// grab the Tickets in the order for the receipt.
							addTickets(currentItem, cartItems);
						}
					}
					for (var i in orderStatusReply.SCHEDULED_PAYMENTS.SP) {
						if (orderStatusReply.SCHEDULED_PAYMENTS.SP[i].status.toLowerCase() === 'paid') {
							$scope.isPaymentSchedule = true;
							$scope.cartObject.amountPaid = orderStatusReply.SCHEDULED_PAYMENTS.SP[i].amount;
							break;
						}
					}
				}

				// Add Shipping if applicable.
				saveShippingFeeDetails(orderItemsReply.TOTALS.shipping_total, taxAndCartAdjustmentAndShipping, orderStatusReply.ship_method.toLowerCase());

				// Update the scope variables for the html view. // Looping through
				// to get the output in the order we want, otherwise, if I save
				// $scope.cartObject.taxAndCartAdjustmentAndShipping = myFeeItems, will generate an
				// alphabetized results based on the keys, that would work out to be
				// Processing, then Delivery, then Taxes.
				//$scope.cartObject.cartItems = cartItems;
				for (var i in taxAndCartAdjustmentAndShipping) {
					$scope.cartObject.taxAndCartAdjustmentAndShipping.push(taxAndCartAdjustmentAndShipping[i]);
				}
			}
		}

		/**
		 * Determines if the ticket charac specified is present.
		 * @protected
		 * @function
		 * @name ticketCharacToBoolean
		 * @param {Array} tickets The array of tickets on the order
		 * @param {String} charac ticket charac to check
		 * @return {boolean} Determines value of charac
		 */
		function ticketCharacToBoolean(tickets, charac) {
			var i,
				ticketDetailsReplayLength = tickets.length;

			for (i = 0; i < ticketDetailsReplayLength; i++) {
				if (isObject(tickets[i].CHARACS)) {
					if (getBoolean(tickets[i].CHARACS[charac])) {
						return true;
					}
				}
			}
			return false;
		}

		/**
		 *	Grabs the tickets from the ViewOrder response, and groups the same tickets together.
			*/

		function getTickets(ticketDetailsReply, orderHistoryReply, orderItemsReply) {
			var items = [];

			if (!ticketDetailsReply.TICKET) {
				return;
			}

			for (var i = 0; i < ticketDetailsReply.TICKET.length; i++) {
				var itm = ticketDetailsReply.TICKET[ i ];
				var sameItem = getSameItem(itm, items);

				if (sameItem) {
					sameItem.qty++;
					continue;
				}

				itm.qty = itm.qty || 1;
				itm.retail_price = Utilities.getTotalPrice(itm, [itm.retail, itm.tax_amount]);
				itm.start_date = getStartDateByTktID(itm.ticket_id);
				itm.start_time = getStartTimeByTktID(itm.ticket_id);
				itm.valid_from = getValidFromByTktID(itm.ticket_id);
				itm.name = itm.SEASON_PASS ? getNameSP(itm.SEASON_PASS) : getNameTktID(itm.ticket_id);

				checkForMobileTicketOptions('receipt_ticket_options', displayExtraDataOnReceiptTicket, itm);

				items.push(itm);
			}

			return items;
		}

		function getSameItem(itm, items) {
			// If item exists and it's unique (CHARACS differ), then continue. Otherwise, increase the qty.
			for (var j = 0; j < items.length; j++) {
				var itm2 = items[ j ];
				if (itm2.package_id === itm.package_id && itm2.customer_type === itm.customer_type) {
					// Same package. Check if CHARACS are the same.
					if (itm2.CHARACS && itm.CHARACS) {
						var itm2Characs = JSON.stringify(itm2.CHARACS);
						var itemSubJCharacs = JSON.stringify(itm.CHARACS);

						if (itm2Characs == itemSubJCharacs) {
							return items[ j ];
						}
					}
				}
			}

			return null;
		}

		function getRefundedItems(orderItemsReply) {
			var items = [];

			for (var i = 0; i < orderItemsReply.ITEM.length; i++) {
				if (orderItemsReply.ITEM[ i ].type == 'T' &&
					orderItemsReply.ITEM[ i ].action == 'R') {
					var itm = orderItemsReply.ITEM[ i ];

					itm.qty = itm.qty || 1;
					itm.retail_price = itm.retail_amount;
					itm.start_date = getStartDateByTktID(itm.ticket_id);
					itm.start_time = getStartTimeByTktID(itm.ticket_id);
					itm.valid_from = getValidFromByTktID(itm.ticket_id);
					itm.name = getNameTktID(itm.ticket_id);

					items.push(itm);
				}
			}

			return items;
		}

		/**
		 *	grabs the tickets from the ViewOrder response, and groups the same
			*	tickets by customer_type.
			*/

		function addTickets(item, collection) {
			if (!item.action) {
				item.action = 'A';
			}
			var key = item.package_id + '|' + item.action + '|' + item.customer_type;
			if (angular.isDefined(collection[ key ])) {
				collection[ key ].qty++;
			} else {
				collection[ key ] = {};
				collection[ key ].qty = 1;
				collection[ key ].package_name = item.package_name;
				collection[ key ].retail_price = Utilities.getTotalPrice(item, [item.retail, item.tax_amount]);
					collection[key].start_date = getStartDateByTktID(item.ticket_id);
					collection[key].start_time = getStartTimeByTktID(item.ticket_id);
					collection[key].valid_from = getValidFromByTktID(item.ticket_id);
					collection[key].name = getNameTktID(item.ticket_id);
			}
		}

		/**
		 *	grabs the tickets from the ViewOrder response, and groups the same
			*	tickets by customer_type.
			*/

		function saveTickets(item, collection) {
			// Cart Item:
			if (item.type == 'T') {
				var key = item.package_id + '|' + item.action + '|' + item.customer_type;
				if (angular.isDefined(collection[ key ])) {
					collection[ key ].qty++;
				} else {
					collection[ key ] = {};
					collection[ key ].qty = 1;
					collection[ key ].package_name = item.package_name;
					collection[ key ].retail_price = Utilities.getTotalPrice(item);
					collection[ key ].customer_type_name = item.customer_type;
					collection[key].start_date = getStartDateByTktID(item.ticket_id);
					collection[key].start_time = getStartTimeByTktID(item.ticket_id);
					collection[key].valid_from = getValidFromByTktID(item.ticket_id);
					collection[key].name = getNameTktID(item.ticket_id);
				}
			}
		}

		/**
		 * Finds a ticket by a given criteria.
		 * @param {*} value
		 * @param {string} [property=ticket_id] Optional value to see what property it should check against.
		 * @returns {Object|false} Returns the ticket object if found, false otherwise.
		 */
		function findTicket(value, property) {
			property = property || 'ticket_id';

			var tickets = $scope.viewOrder.VIEW_ORDER_REPLY.TICKET_DETAILS_REPLY.TICKET;
			tickets = isArray(tickets) ? tickets : [tickets];

			for (var i = 0; i < tickets.length; i++) {
				if (tickets[i][property] === value) {
					return tickets[i];
				}
			}

			return false;
		}

		/**
		 * Retrieves a start date by a given ticket id.
		 * @param {string} id - The ticket ID.
		 * @returns {string} - The START DATE.
		 */
		function getStartDateByTktID(id) {
			var ticket = findTicket(id);

			if (ticket.EVENT) {
				if (isArray(ticket.EVENT)) {
					return ticket.EVENT[0].start_date;
				}

				return ticket.EVENT.start_date;
			}

			return '';
		}

		/**
		 * Retreives the START TIME from ticket ID.
		 * @param {string} id - The ticket ID.
		 * @returns {string} - The START TIME.
		 */
		function getStartTimeByTktID(id) {
			var ticket = findTicket(id),
				xmcName = '';

			if (ticket) {
				if (ticket.CHARACS) {
					if (isArray(ticket.CHARACS) && ticket.CHARACS.length) {
						xmcName = ticket.CHARACS[0].client_xfc_name || '';
					} else {
						xmcName = ticket.CHARACS.client_xfc_name || '';
					}
				}

				// the xmcName search should match partials
				if (ticket.EVENT && xmcName.indexOf('date') !== -1) {
					if (isArray(ticket.EVENT)) {
						return ticket.EVENT[0].start_time;
					}

					return ticket.EVENT.start_time;
				}
			}

			return '';
		}

		/**
		 * Retrieves the VALID FROM from the ticket.
		 * @param {string} id - The ticket ID.
		 * @returns {string} - The VALID FROM.
		 */
		function getValidFromByTktID(id) {
			var ticket = findTicket(id);

			if (ticket.CHARACS) {
				if (isArray(ticket.CHARACS) && ticket.CHARACS.length) {
					return ticket.CHARACS[0].valid_from || '';
				}

				return ticket.CHARACS.valid_from || '';
			}

			return '';
		}

		/**
		 * Retrieves the passholder's first and last name.
		 * @param {string} id - The ticket ID.
		 * @returns {string} - The Passholder's First and Last Name
		 */
		function getNameTktID(id) {
			var ticket = findTicket(id);

			// If it's a season pass and has gone through the season pass flow - add the name.
			if (ticket.SEASON_PASS &&
				ticket.CHARACS &&
				ticket.CHARACS.client_xfc_view &&
				ticket.CHARACS.client_xfc_view.split(' ').join().split(',').indexOf('seasonPass') !== -1
			) {
				return ticket.SEASON_PASS.first_name + ' ' + ticket.SEASON_PASS.last_name;
			}

			return '';
		}

		/**
		 * Gets the name of the season pass holder associated with the given season pass.
		 * @param sp the SEASON_PASS to use
		 * @returns {string} the name of the season pass holder, or empty string if name not defined
		 */
		function getNameSP(sp) {
			var tickets = AppData.GuestViewOrder.VIEW_ORDER_REPLY.TICKET_DETAILS_REPLY.TICKET;
			tickets = isArray(tickets) ? tickets : [tickets];

			for (var i = 0; i < tickets.length; i++) {
				var ticket = tickets[ i ];

				if (ticket.SEASON_PASS !==undefined && ticket.SEASON_PASS.season_pass_number == sp.season_pass_number) {
					// If it has gone through the season pass flow - add the name.
					if (ticket.CHARACS &&
						ticket.CHARACS.client_xfc_view &&
						ticket.CHARACS.client_xfc_view.split(' ').join().split(',').indexOf('seasonPass') > -1) {
						return ticket.SEASON_PASS.first_name + ' ' + ticket.SEASON_PASS.last_name;
					}
				}
			}

			return '';
		}

		function saveFees(item, collection) {
			// Ticket fees.
			if (item.type == 'F' && item.ticket_id) {
				var key = item.type + '|' + item.ticket_id;

				if (angular.isUndefined(collection[ key ])) {
					var label = undefined;

					//For items of type F, the ref_id is equivalent to fee_type_id from merchant_package_fee table. We match these
					//ids to locales under the CartView section. To be consistent, we use that same scheme here. If for some reason
					//the fee with ref_if doesn't exist, we default to a generic 'Fee' label.
					if (Language.localeExists('CartView', 'fee' + item.ref_id)) {
						label = Language.getLocale('CartView', 'fee' + item.ref_id);
					} else if (parseFloat(item.value) > 0) {
						label = Language.getLocale('CartView', 'fee');
					}

					if (angular.isDefined(label)) {
						collection[ key ] = {};
						collection[ key ].label = label;
						collection[ key ].amount = parseFloat(item.value);
					}
				} else {
					collection[ key ].amount += parseFloat(item.value);
				}
			}
		}

		function saveAdjustments(item, collection) {
			// Cart adjustments.
			if (item.type == 'A') {
				var key = item.type + '|' + item.cart_adjustment_id;
				if (typeof collection[ key ] == 'undefined') {
					collection[ key ] = {};
					collection[ key ].label = item.cart_adjustment_name;
					collection[ key ].amount = parseFloat(item.retail_amount);
				} else {
					collection[ key ].amount += parseFloat(item.retail_amount);
				}
			}
		}

		function saveShippingFeeDetails(shippingTotal, collection, shippingMethodCode) {
			if (shippingTotal) {
				var key = 'S|0';
				collection[ key ] = {};

				collection[ key ].label = Language.getLocale('CartView', 'deliveryFee') + getShippingMethodFromMethodCode(shippingMethodCode);
				collection[ key ].amount = (Number(shippingTotal) > 0) ? shippingTotal : Language.getLocale('CartView', 'free');
			}
		}

		/**
		 * Takes in the shippingMethodCode and returns the locael shipping method
		 * @private
		 * @param shippingMethodCode
		 * @returns i18n shipping method
		 */
		function getShippingMethodFromMethodCode(shippingMethodCode) {
			var response = '',
				shouldContinue = true;
			angular.forEach(Language.ShippingView, function(value, key) {
				if (shouldContinue) {
					if (key == shippingMethodCode + 'Description') {
						response = ': ' + value;
						shouldContinue = false;
					}
				}
			});
			return response;
		}

		function resetCartObject() {
			$scope.ticketObject.selectedOrder = {};
			$scope.ticketObject.selectedOrderID = false;
			$scope.ticketObject.selectedOrderL4 = false;
			$scope.ticketObject.selectedOrderPN = false;
			$scope.cartObject = {};
			$scope.cartObject.cartItems = [];
			$scope.cartObject.taxAndCartAdjustmentAndShipping = [];
			$scope.cartObject.feeSource = {
				fees: [],
				tax: [],
				taxTotal: 0,
				feeTotal: 0
			};
			$scope.cartObject.discountSource = [];
			$scope.cartObject.subTotal = 0;
			$scope.cartObject.discountTotal = 0;
			$scope.cartObject.total = 0;
		}

		function determineDeliveryMessage(orderStatusReply) {
			// Determine delivery type and render view accordingly.
			if (typeof(orderStatusReply) != 'undefined' &&
				typeof(orderStatusReply.ship_method) != 'undefined') {
				var shipMeth = orderStatusReply.ship_method;
				$scope.isWillCall = (shipMeth == Enums.deliveryMethods.WILL_CALL);
				$scope.isFirstClassMail = (shipMeth == Enums.deliveryMethods.FIRST_CLASS_MAIL);
				$scope.isInternationalMail = (shipMeth == Enums.deliveryMethods.INTERNATIONAL_SHIPPING);
				$scope.isPrintAndGo = Ticket.determineIsPrintAndGo(shipMeth);
				$scope.isAddlSpecialDelivery = Enums.addlSpecialDelivery.indexOf(shipMeth) > -1;
				$scope.isPriorityShipping = (shipMeth == Enums.deliveryMethods.UPS_GROUND);
				$scope.isExpedited = (shipMeth == Enums.deliveryMethods.UPS_EXPEDITED || shipMeth == Enums.deliveryMethods.UPS_EXPEDITED2);
				$scope.isOvernight = (shipMeth == Enums.deliveryMethods.FED_EX_OVERNIGHT);
				$scope.isInternational = (shipMeth === Enums.deliveryMethods.INTERNATIONAL_SHIPPING);


				$scope.isSpecialDelivery = ($scope.isWillCall || $scope.isFirstClassMail || $scope.isAddlSpecialDelivery || $scope.isPriorityShipping || $scope.isExpedited || $scope.isOvernight || $scope.isInternational);

				if ($scope.isWillCall) {
					$scope.specialDeliveryTitle = Language.getLocale('TicketView', 'willCallOrderMessageTitle');
					$scope.specialDeliveryMessage = Language.getLocale('TicketView', 'willCallOrderMessage');
				} else if ($scope.isFirstClassMail) {
					$scope.specialDeliveryTitle = Language.getLocale('TicketView', 'firstClassOrderMessageTitle');
					$scope.specialDeliveryMessage = Language.getLocale('TicketView', 'firstClassOrderMessage');
				} else if ($scope.isAddlSpecialDelivery) {
					$scope.specialDeliveryTitle = Language.getLocale('TicketView', 'addlSpecialDeliveryTitle_' + shipMeth);
					$scope.specialDeliveryMessage = Language.getLocale('TicketView', 'addlSpecialDeliveryMsg_' + shipMeth);
				} else if ($scope.isPriorityShipping) {
					$scope.specialDeliveryTitle = Language.getLocale('TicketView', 'priorityShippingDeliveryTitle');
					$scope.specialDeliveryMessage = Language.getLocale('TicketView', 'priorityShippingDeliveryMessage');
				} else if ($scope.isExpedited) {
					$scope.specialDeliveryTitle = Language.getLocale('TicketView', 'expeditedDeliveryTitle');
					$scope.specialDeliveryMessage = Language.getLocale('TicketView', 'expeditedDeliveryMessage');
				} else if ($scope.isOvernight) {
					$scope.specialDeliveryTitle = Language.getLocale('TicketView', 'overnightDeliveryTitle');
					$scope.specialDeliveryMessage = Language.getLocale('TicketView', 'overnightDeliveryMessage');
				} else if ($scope.isInternational) {
					$scope.specialDeliveryTitle = Language.getLocale('TicketView', 'internationalShippingDeliveryTitle');
					$scope.specialDeliveryMessage = Language.getLocale('TicketView', 'internationalShippingDeliveryMessage');
				}
			}
		}


		function getPhoneNumber(phone) {
			var phoneNumber = OrderService.phoneNumber || '';
			var result = '';

			// Strip hyphens from phone number.
			phoneNumber = phoneNumber.split('-').join('');

			if (isArray(phone)) {
				for (var i in phone) {
					if (phone[ i ].number == phoneNumber) {
						result = phone[i].number;
						break;
					}
				}
			} else if (phone.number == phoneNumber) {
				result = phone.number;
			}

			return result;
		}

		/**
		 * Verify that the email address used matches that of the URL parameter.
		 * NOTE: OrderService.lastFour could be email or last four digits of the CC.
		 *
		 *
		 *
		 */
		function emailAddressMatch(emailAddress) {
			var urlParam = OrderService.email || '';
			var result = '';

			if (isArray(emailAddress)) {
				for (var i in emailAddress) {
					if (emailAddress[ i ].address.toLowerCase() == urlParam.toLowerCase()) {
						result = emailAddress[ i ].address.toLowerCase();
						break;
					}
				}
			} else if (urlParam.length && ((emailAddress || {}).address || '').toLowerCase() == urlParam.toLowerCase()) {
				result = emailAddress.address.toLowerCase();
			}

			return result;
		}

		function lastFourCCDigitsMatch(payments) {
			// TODO: find out if we need to verify against other entries, if there is more than one payment.
			// Verify that the last four digits of the CC used matches that of the URL parameter.
			// NOTE: OrderService.lastFour could be email or last four digits of the CC.
			var urlParam = OrderService.lastFour || '';
			var testLastFour = '';
			try {
				var ccNumber = payments[ 0 ].card_number;
			} catch (error) {
				var ccNumber = '';
			}
			if (typeof ccNumber != 'undefined' && ccNumber) {
				testLastFour = ccNumber.substr(ccNumber.toString().length - 4);
				if (testLastFour == urlParam) {
					return testLastFour;
				}
			}

			return '';
		}

		function tokenMatch(orderDate, cartId) {
			var urlToken = OrderService.token || '';
			var token = Security.md5(orderDate + cartId);

			if (urlToken === token) {
				return token;
			}

			return '';
		}

		function getIsMobile() {
			var isMobile = false;

			if (getBoolean(AppData.mobile_tickets_on_tablet)) {
				isMobile = (ClientInfo.deviceType == 'mobile' || ClientInfo.deviceType == 'tablet');
			} else {
				isMobile = ClientInfo.deviceType == 'mobile';
			}

			return isMobile;
		}

		function getReceiptHidePrices(orderStatusReply) {
			var hasReceiptDisablePricesCharac = safelyCheckPropertyOnObject(
				'orderStatusReply.CHARACS.receipt_disable_prices', orderStatusReply);

			return (hasReceiptDisablePricesCharac &&
				getBoolean(orderStatusReply.CHARACS.receipt_disable_prices === '1'));
		}

		/**
		 * Assess if the place new order button should be hidden
		 * @protected
		 * @function
		 * @name getHidePlaceNewOrderButton
		 * @memberof {TicketCtrl}
		 * @param {Object} paymentDetails the payment details for the order
		 * @return {boolean}
		 */
		function getHidePlaceNewOrderButton(paymentDetails) {
			var hideButton = false,
				hideButtonAppConfig = '',
				match,
				payment,
				resellerAuthType = AppData.settings.reseller_auth_type || 'ACT';
			if (isObject(paymentDetails.PAYMENT[0])) {
				payment = paymentDetails.PAYMENT[0];

				// explicitly hide the place new order button if the order
				// was purchased by a reseller
				hideButton = (payment.auth_type === resellerAuthType) &&
					(payment.billing_type === resellerAuthType);
			}
			if (isString(AppData.settings.hide_place_new_order_button_by_billing_type) && isArray(paymentDetails.PAYMENT)) {
				hideButtonAppConfig = AppData.settings.hide_place_new_order_button_by_billing_type.split(',');
				hideButtonAppConfig.forEach(function(billingType) {
					match = paymentDetails.PAYMENT.filter(function(payment) {
						return payment.billing_type == billingType;
					})[0];
					if (isObject(match)) {
						hideButton = true;
					}
				})
			}
			return hideButton;
		}

		/**
		 * Get AppData settings configuration options for booking portal button, such as
		 * icon, background, text color, and label. Button also has to be set to be
		 * enabled ("true") to display.
		 * @public
		 * @returns {Object} The booking portal button config options.
		 */

		// TODO: is there a way to make this more generic to be used for both booking portal and account portal?
		function getBookingPortalConfigs() {
			var bookingPortalButtonConfig = (safelyCheckPropertyOnObject('AppData.settings.booking_portal', AppData) && JSON.parse(AppData.settings.booking_portal).receipt_button) || {};

			var isBookingPortalTicket = false;
			var buttonEnabled = getBoolean(bookingPortalButtonConfig.enabled) === true;
			var buttonIcon = bookingPortalButtonConfig.icon || 'icon-calendar';
			var buttonBackground = bookingPortalButtonConfig.background || '#45A4CE';
			var buttonTextColor = bookingPortalButtonConfig.text_color || '#FFF';

			if (safelyCheckPropertyOnObject('AppData.settings.booking_portal', AppData) &&
				safelyCheckPropertyOnObject('AppData.GuestViewOrder.VIEW_ORDER_REPLY.TICKET_DETAILS_REPLY.TICKET', AppData)) {
				isBookingPortalTicket = AppData.GuestViewOrder.VIEW_ORDER_REPLY.TICKET_DETAILS_REPLY.TICKET.some(function(ticketObj) {
					return Array.isArray(ticketObj.BOOKING);
				});
			}

			return {
				background: buttonBackground,
				icon: buttonIcon,
				isEnabled: isBookingPortalTicket && buttonEnabled,
				textColor: buttonTextColor
			};
		}

		/**
		 * Returns a Date object of the order date
		 * @public
		 * @param {String} orderDate The date string in the format YYYY-MM-DD H:MM AM|PM
		 * @returns {Date} the date object
		 */
		function getOrderDate(orderDate) {
			var dateParts = (validString(orderDate) ? orderDate : '').split(' ');

			return Utilities.dateStringToObject(dateParts[0], dateParts.slice(1).join(' '));
		}


	});
'use strict';

angular
	.module('app')
	.controller('ZipCodeOverrideCtrl', function(
		$uibModal,
		$uibModalInstance,
		$rootScope,
		$scope,
		Utilities
	) {
		$scope.formData = {
			zipcode: '',
			submitted: false
		};

		$rootScope.$on('hidePreviousModals', function() {
			$rootScope.modalOpen = false;
			$uibModalInstance.close('');
		});

		$rootScope.$on('showPreviousModals', function() {
			$uibModal.open({
				templateUrl: '/views/modals/zipCodeOverridePrompt.html',
				controller: 'ZipCodeOverrideCtrl',
				keyboard: false
			});
		});

		function dismissModal() {
			$rootScope.modalOpen = false;
			$uibModalInstance.close($scope.formData.zipcode);
		}

		$scope.submit = function() {
			$scope.formData.submitted = true;

			if (validateZip()) {
				dismissModal();
			}
		};

		$scope.cancel = function() {
			$rootScope.modalOpen = false;
			$uibModalInstance.close();
			//If we entered the store on a zip override tab, go to the default keyword on cancel
			//Otherwise, go back to the last place the user was in the store.
			if (Utilities.isEmpty($rootScope.previousRoute)) {
				$rootScope.routeTo('/');
			} else {
				$rootScope.routeTo($rootScope.previousRoute);
			}
		};

		function validateZip() {
		// NOTE: Since we are in a modal, the form object must reside in a nested object.
		// The name of the form must be objectRef.formName and will become accessible in
		// $scope.objectRef.formName.
			return $scope.formData.theForm.$valid;
		}
	});

angular
	.module('app')
	.controller('PaymentPlanCtrl', function(
		$filter,
		$scope,
		$stateParams,
		$rootScope,
		AppData,
		LegacyCart,
		Enums,
		ExtraFlow,
		StandardFlowInitiatorService,
		Language,
		Package,
		Modal,
		Utilities
	) {
		$scope.PaymentSchedule = {};

		$scope.planImage = $rootScope.assetsPath;
		$scope.cartItems = Package.itemsToBeAdded;
		$scope.packageDetails = Package.packageDetails;
		$scope.editingCartCopy = [];

		$scope.dateFormat = AppData.settings.date_format;

		$scope.suppressYes = false;
		$scope.suppressNo = false;

		// Init first before executing remainder of the code:
		// Ensure we have packages to add. This would not be true if user refreshed the browser.

		/***-----------------------------------------------------------------------
			 * PRIVATE
			 *------------------------------------------------------------------------**/
		/**
		 * Initializes the controller.
		 * @private
		 * @returns {null}
		 */
		function InitializeCtrl() {
			$scope.showSpinner(Language.getLocale('ApplicationLabels', 'paymentPlanLoadMsg'));

			if (!Package.initXFC()) {
				// Hide the spinner.
				$scope.hideSpinner();
				Package.cancelXFC();
				return;
			}

			switch ($stateParams.planType.toLowerCase()) {
			case 'easypay':
				$scope.planType = 'EasyPay';
				$scope.planLocale = 'EasyPay';
				$scope.swapPackageId = ((($scope).packageDetails || {}).CHARACS || {}).PassOptionEasyPayPackageId || '';
				break;
			case 'paylater':
				$scope.planType = 'PayLater';
				$scope.planLocale = 'PayLater';
				$scope.swapPackageId = ((($scope).packageDetails || {}).CHARACS || {}).PassOptionPayLaterPackageId || '';
				break;
			default:
				$scope.planType = '';
				$scope.planLocale = '';
				$scope.swapPackageId = '';
				break;
			}

			if (Package.isEditing()) {
				// Determine if we should default the option to yes
				// if there are any swapped payment plan packages already in the cart
				$scope.cartItems.forEach(function(cartItem) {
					if (Package.hasCharac(cartItem, 'payment_plan')) {
						$scope.suppressNo = true;
						$scope.paymentPlanSelection = 'yes';
					}
				});
			}

			if (!$scope.swapPackageId) {
				if ($scope.packageDetails.type==="L") {
					$scope.swapPackageId = "-1";
				} else {
					// Hide the spinner.
					$scope.hideSpinner();
					// Error Invalid Payment Plan Setup
					Modal.displayModal({
						title: Language.getLocale('Alert', 'errorPaymentPlanTitle'),
						description: Language.getLocale('Alert', 'errorPaymentPlanMsg'),
						icon: 'icon-info red',
						callback: function(detail) {
							$rootScope.routeTo(StandardFlowInitiatorService.getStandardFlowEntryRoute());
						}
					});
					return;
				}
			}

			$scope.PaymentSchedule.numberofPayments = $scope.packageDetails.number_of_payments ? $scope.packageDetails.number_of_payments : '2';

			var payment_plan_images = {};
			if (Utilities.childDefined(AppData, 'GetApplicationConsolidated.SETTINGS.payment_plan_images')) {
				try {
					payment_plan_images = JSON.parse(AppData.GetApplicationConsolidated.SETTINGS.payment_plan_images);
				} catch (error) {
					console.log(error);
				}
			}

			if (payment_plan_images[$scope.planType] && payment_plan_images[$scope.planType][$scope.PaymentSchedule.numberofPayments]) {
				$scope.planImage += payment_plan_images[$scope.planType][$scope.PaymentSchedule.numberofPayments];
			} else if (payment_plan_images[$scope.planType] && payment_plan_images[$scope.planType].default) {
				$scope.planImage += payment_plan_images[$scope.planType].default;
			}

			try {
				// TODO: Check for the extra_movie locale then check the payment_plan_type locale
				$scope.PaymentSchedule.instructions = Language[$scope.planLocale].instructions;

				$scope.PaymentSchedule.header = Language[$scope.planLocale].header;
				$scope.PaymentSchedule.footer = Language[$scope.planLocale].footer;

				$scope.PaymentSchedule.payment = Language[$scope.planLocale].payment;
				$scope.PaymentSchedule.date = Language[$scope.planLocale].date;
				$scope.PaymentSchedule.amount = Language[$scope.planLocale].amount;
				$scope.PaymentSchedule.tax = Language[$scope.planLocale].tax;
				$scope.PaymentSchedule.total = Language[$scope.planLocale].total;
				$scope.PaymentSchedule.fee = Language.getLocale($scope.planLocale, 'fee');

				$scope.PaymentSchedule.of = Language[$scope.planLocale].of;
				$scope.PaymentSchedule.yes = Language[$scope.planLocale].yes;
				$scope.PaymentSchedule.no = Language[$scope.planLocale].no;
			} catch (error) {
				console.log(error);
			}

			var _count = 0;
			var _qty = '';
			var _customer_type = '';
			var _index = 0;
			var _extraMovies = '';
			var message = [];
			var paymentPlanItems = [];

			if (Package.isEditing()) {
				$scope.editingCartCopy = LegacyCart.editingCartCopy;

				// Get any parent packages in the cart that are for the same product that is being edited
				var parentPackages = $scope.editingCartCopy.filter(function(itemInCart) {
					return Package.packageDetails.id == itemInCart.package_id || Package.hasPreswapPackageCharacsMatch(itemInCart);
				});

				// get the parent packages and their associated oneBarcode packages.
				$scope.editingCartCopy = $scope.editingCartCopy.filter(function(itemInCart) {
					var isParentPackage = parentPackages.some(function(parentPackage) {
						return parentPackage === itemInCart;
					});

					var isOneBarcodePackage = parentPackages.some(function(parentPackage) {
						return Package.areCharacsEqual(parentPackage, itemInCart, 'group_uuid');
					});

					return isParentPackage || isOneBarcodePackage;
				});

				// Include the parent packages and their oneBarcode packages from the cart in the payment schedule
				paymentPlanItems = paymentPlanItems.concat($scope.editingCartCopy);
			}

			// Build the request to get the payment schedule
			paymentPlanItems = paymentPlanItems.concat($scope.cartItems);
			paymentPlanItems.forEach(function(item) {
				message.push({
					qty: item.qty,
					customer_type: item.customer_type,
					package_id: item.package_id
				});

				// This just gets the count of passes for display to the guest.
				if ((item.package_id == $stateParams.packageId) || Package.hasPreswapPackageCharacsMatch(item, $stateParams.packageId)) {
					_count += Number(item.qty);
				}
			});

			$scope.PaymentSchedule.numberofPasses = _count;

			// TODO: check the min and max qtys are ok for the swap package
			var _packageList = AppData.GetMerchantPackageList;
			if (Utilities.childDefined(_packageList, 'PS.P')) {
				_packageList = angular.isArray(_packageList.PS.P) ? _packageList.PS.P : [_packageList.PS.P]
				for (var i in _packageList) {
					var _package = _packageList[i];
					if (_package.id == $scope.swapPackageId) {
						if (_count > _package.max_quantity || _count < _package.min_quantity) {
							$scope.suppressYes = true;
						}
						if (_extraMovies.indexOf('ezpaypromo') > -1 || _extraMovies.indexOf('plpromo') > -1) {
							$scope.suppressNo = true;
						}
						break;
					}
				}
			}

			AppData.fetch(
				Enums.services.GET_PAYMENT_SCHEDULE
				, false
				, message
			).then(function(data) {
				// Hide the spinner.
				$scope.hideSpinner();
				if (Utilities.childDefined(data, 'PAYMENT_SCHEDULE.PAYMENT')) {
					var payments = angular.isArray(data.PAYMENT_SCHEDULE.PAYMENT) ? data.PAYMENT_SCHEDULE.PAYMENT : [data.PAYMENT_SCHEDULE.PAYMENT]
					$scope.PaymentSchedule.payments = payments;

					$scope.showFees = false;
					payments.forEach(function(item) {
						if (angular.isDefined(item.fee_amount) && parseFloat(item.fee_amount) > 0) {
							$scope.showFees = true;
						}
					});


					if ($scope.suppressYes) {
						Modal.displayModal({
							title: Language.getLocale('Alert', 'limitsPaymentPlanTitle'),
							description: Language.getLocale('Alert', 'limitsPaymentPlanMsg'),
							icon: 'icon-info red'
						});
					}
				} else {
					// Navigate to the next XFC.
					Package.nextXFC();
				}
			});


			doLocaleReplacements();
		}

		function doLocaleReplacements() {
			var feeTotal = $filter('currencyFormatter')(LegacyCart.getTotalFees());
			$scope.PaymentSchedule.footer = Language.replaceAll('@@FEE', feeTotal, $scope.PaymentSchedule.footer);
		}

		function addSwapCharacs(items) {
			for (var i in items) {
				for (var j in items[i].CHARACS) {
					if ($scope.paymentPlanSelection.toLowerCase() == 'yes') {
						if ($scope.planType.toLowerCase() == 'easypay') {
							items[i].CHARACS[j].sp_swap_easypay_flag = 1;
						} else if ($scope.planType.toLowerCase() == 'paylater') {
							items[i].CHARACS[j].sp_swap_paylater_flag = 1;
						}
						items[i].CHARACS[j].sp_swap = 1;
						items[i].CHARACS[j].payment_plan = $scope.planType;

						if (angular.isUndefined(items[i].CHARACS[j].preswap_package_id)) {
							items[i].CHARACS[j].preswap_package_id = items[i].package_id;
						}
					} else {
						var renewalSwapFlag = items[i].CHARACS[j].sp_swap_renewal_flag;
						items[i].CHARACS[j].sp_swap = ((angular.isDefined(renewalSwapFlag) && renewalSwapFlag === 1) ? 1 : 0);
					}

					if (angular.isUndefined(items[i].CHARACS[j].client_original_price)) {
						items[i].CHARACS[j].client_original_price = items[i].retail_price;
					}
				}
			}
		}

		/***-----------------------------------------------------------------------
			 * PUBLIC
			 *------------------------------------------------------------------------**/
		$scope.back = function() {
			Package.cancelXFC();
		}

		$scope.handleSelection = function(value) {
			$scope.paymentPlanSelection = value;
		}

		$scope.save = function() {
			if (typeof $scope.paymentPlanSelection == 'undefined'
					|| ($scope.paymentPlanSelection.toLowerCase() != 'yes' && $scope.paymentPlanSelection.toLowerCase() != 'no')
					|| ($scope.paymentPlanSelection.toLowerCase() == 'yes' && $scope.suppressYes)
					|| ($scope.paymentPlanSelection.toLowerCase() == 'no' && $scope.suppressNo)) {
				Modal.displayModal({
						 title: Language.Alert.invalidPaymentPlanTitle,
					description: Language.Alert.invalidPaymentPlanMsg,
					icon: 'icon-info red'
				});
				return;
			}

			if (Package.isEditing()) {
				addSwapCharacs($scope.editingCartCopy);
			}
			addSwapCharacs($scope.cartItems);

			// Add reference of XFC to CHARACs.
			ExtraFlow.addReferenceToCartItems(Package.settings.view, $scope.cartItems, ExtraFlow.CLIENT_XFC_VIEW);
			ExtraFlow.addReferenceToCartItems(Package.settings.name, $scope.cartItems, ExtraFlow.CLIENT_XFC_NAME);

			// Navigate to the next XFC.
			Package.nextXFC();

			Utilities.scrollPosition()
		}

		InitializeCtrl();
	}
	)

angular
	.module('app')
	.controller('SeasonPassController',	function(
		$scope,
		$stateParams,
		$rootScope,
		Enums,
		ExtraFlow,
		Seasonpass,
		Language,
		Package,
		Modal,
		Utilities,
		UserInfo,
		CustomActionService
	) {
		$scope.dataModel = [];
		$scope.submitted = false;
		$scope.totalForms = 0;
		$scope.theScope = $scope;
		$scope.cartItems = Package.itemsToBeAdded;
		$scope.packageDetails = Package.packageDetails;
		$scope.fieldSettings = Seasonpass.fieldSettings;
		$scope.formOptions = Seasonpass.formOptions;
		$scope.packageRateTypes = [];
		$scope.refreshTemplate = function() {
			var json = angular.toJson($scope.dataModel);
			var cleanItemList = JSON.parse(json);
			for (var index = 1; index < cleanItemList.length; index++) {
				$scope.dataModel[index] = cleanItemList[index];
				$scope.formCollection[index].formData = cleanItemList[index];
			}
		}
		// Init first before executing remainder of the code:
		// Ensure we have packages to add. This would not be true if user refreshed the browser.

		$scope.toggleForm = function(index) {
			if ($scope.dataModel[index].valid) {
				selectForm(index)
			} else {
				if (index > 0) {
					if ($scope.dataModel[index - 1].valid) {
						selectForm(index)
					}
				}
			}
		}

		function selectForm(index) {
			for (var i in $scope.dataModel) {
				if ($scope.dataModel[i].isCurrentTicket) {
					$scope.dataModel[i].isCurrentTicket = false
				}

				if (index == i) {
					$scope.dataModel[i].isCurrentTicket = true
				}
			}
		}

		$scope.showName = function(passData) {
			if (
				Utilities.safelyCheckPropertyOnObject('passData.ph_first_name', passData) && passData.ph_first_name.length > 0 ||
					Utilities.safelyCheckPropertyOnObject('passData.ph_last_name', passData) && passData.ph_last_name.length > 0
			) {
				return true;
			} else {
				return false;
			}
		};

		$scope.deleteForm = function(formID) {
			// This form's index.
			var requestedFormIndex = Number(formID.split('_')[ 1 ]);
			var numPasses = $scope.dataModel.length;

			Package.markItemToBeAddedForDeletion(requestedFormIndex, $scope.dataModel[requestedFormIndex].characsIndex);
			$scope.dataModel.splice(requestedFormIndex, 1);
			$scope.formCollection.splice(requestedFormIndex, 1);
			numPasses--;

			if (numPasses > 0) {
				for (var i = 0; i < numPasses; i++) {
					// Update the form indexes and IDs.
					$scope.dataModel[ i ].formID = 'theForm_' + i;
					$scope.dataModel[ i ].formIndex = i;

					// Expand the first form.
					$scope.dataModel[ i ].isCurrentTicket = (i == 0);
				}
				$scope.fieldSettings.numPasses = numPasses;
			} else if (numPasses == 0) {
				// If we just deleted the last form, route to package details.
				if ($stateParams.packageId) {
					$rootScope.routeTo(Enums.routes.DETAILS + '/' + $stateParams.packageId);
				} else {
					$rootScope.routeTo(Enums.routes.LIST);
				}
			}
		};

		/***-----------------------------------------------------------------------
			 * PRIVATE
			 *------------------------------------------------------------------------**/
		/**
			 * Initializes the controller.
			 * @private
			 * @returns {null}
			 */
		function InitializeCtrl() {
			// Hide the spinner.
			$scope.hideSpinner();

			if (!Package.initXFC()) {
				return;
			}

			createDataModelFromItems(Package.itemsToBeAdded);
		}

		/**
			 * Creates a data model for items to be added to cart
			 * @private
			 * @param itemsToBeAdded {array}
			 *
			 */
		function createDataModelFromItems(itemsToBeAdded) {
			prefillFormData();

			// Iterate through items to be added once per qty.
			var count = 0;
			var seasonPassList = getSPXFCNames();

			for (var i = 0; i < itemsToBeAdded.length; i++) {
				var packageItem = itemsToBeAdded[i];
				for (var j = 0; j < packageItem.qty; j++) {
					// Make a copy of Seasonpass.characProps and add it to array for data model.
					var isSp = false;
					for (var k = 0; k < seasonPassList.length; k++) {
						if (!packageItem.CHARACS[ j ].extra_movie) {
							continue;
						}

						var extraMovies = packageItem.CHARACS[ j ].extra_movie.split(',');
						if (extraMovies.length) {
							for (var l = 0; l < extraMovies.length; l++) {
								if (seasonPassList[ k ] == extraMovies[ l ]) {
									isSp = true;
									break;
								}
							}
						}

						if (isSp) {
							break;
						}
					}

					if (!isSp) {
						break;
					}

					var copy = JSON.parse(JSON.stringify(Seasonpass.characProps));
					CustomActionService.executeCustomAction('setSeasonPassDefaults', null, [copy, packageItem]);

					// Flag the item as a season pass.
					// TODO: Don't like to muddy up itemsToBeAdded... But...
					packageItem.CHARACS[ j ].isSeasonPass = true;

					// First item should show. Others should be hidden.
					copy.isCurrentTicket = (i == 0 && j == 0);
					copy.characsIndex = j;

					// Default validation to false.
					copy.valid = false;

					// Form ID.
					copy.formID = 'theForm_' + count;

					// Form Index.
					copy.formIndex = count;

					// Submitted.
					copy.submitted = false;

					// Rate Type.
					copy.rateType = itemsToBeAdded[ i ].customer_type;
					copy.rateName = itemsToBeAdded[ i ].client_rate_name;

					// Add On Packages - One Barcode Flow
					copy.addOnPackages = [];

					if (i != 0 || j > 0) {
						delete $scope.dataModel.copy_to_billing;
					}

					for (var m = 0; m < $scope.packageDetails.CT.length; m++) {
						if ((($scope.packageDetails.CT[ m ] || {}).id || '') === copy.rateType) {
							var packageHeadline= $scope.packageDetails.CT[ m ].name;
							$scope.packageRateTypes.push(packageHeadline);
						}
					}

					var passInfo = undefined;

					if (UserInfo.get('seasonPass')!==undefined && UserInfo.get('seasonPass').length > count) {
						passInfo = UserInfo.get('seasonPass')[count];
					} else if (Package.isEditing()) {
						passInfo = Package.itemsToBeAdded[count].CHARACS[0];
					} else if (angular.isDefined(packageItem.CHARACS[0]) && angular.isDefined(packageItem.CHARACS[0]['ph_first_name'])) {
						passInfo = packageItem.CHARACS[0];
					}

					if (passInfo!==undefined) {
						Seasonpass.copyCharacs(passInfo, copy);
						// copy OneBarCode characs if they exist.
						if (passInfo.group_uuid) {
							copy.group_uuid = passInfo.group_uuid;
						}
						if (passInfo.one_barcode_parent) {
							copy.one_barcode_parent = passInfo.one_barcode_parent;
						}
						copy.valid = true;
						$scope.formIsPreFilled = true;
					} else {
						$scope.formIsPreFilled = false;
					}
					// If the email has been previously entered, assume that it has also been confirmed.
					if (copy.ph_email) {
						copy.emailConfirmation = copy.ph_email;
					}

					$scope.dataModel.push(copy);
					count++;
				}
			}

			// reset this data
			UserInfo.set('seasonPass', []);

			if (count == 0) {
				// TODO: Skip over Season Pass if the extra movie isn't supported
			}

			$scope.fieldSettings.numPasses = count;
		}

		function getSPXFCNames() {
			var arr = [];

			for (var key in ExtraFlow) {
				var settingsObj = ExtraFlow[ key ];
				if (settingsObj.view == 'seasonPass') {
					arr.push(settingsObj.name)
				}
			}

			return arr;
		}

		/**
			 * Prefills Form Data when in Dev mode
			 * @private
			 */
		function prefillFormData() {
			// Dev mode only. Pre-populate the pass information.
			if ($scope.autofill &&
					(typeof(Seasonpass.characProps.ph_first_name) == 'undefined' ||
					Seasonpass.characProps.ph_first_name == '')) {
				Seasonpass.characProps.ph_address = '212 Main St';
				Seasonpass.characProps.ph_address2 = 'Suite 1001';
				Seasonpass.characProps.ph_age = '34';
				Seasonpass.characProps.ph_birth_date = '02/01/2008';
				Seasonpass.characProps.ph_city = 'Orlando';
				Seasonpass.characProps.ph_country_code = 'US';
				Seasonpass.characProps.ph_email = 'shopv5dev@accesso.com';
				Seasonpass.characProps.emailConfirmation = 'shopv5dev@accesso.com';
				Seasonpass.characProps.ph_first_name = 'Test';
				Seasonpass.characProps.ph_had_pass = 'Y';
				Seasonpass.characProps.ph_home_phone = '1234567890';
				Seasonpass.characProps.ph_phone_number = '1234567890';
				Seasonpass.characProps.ph_last_name = 'Accesso';
				Seasonpass.characProps.ph_member_code = '29729348570245';
				Seasonpass.characProps.ph_mi = 'M';
				Seasonpass.characProps.ph_province = 'FL';
				Seasonpass.characProps.ph_state = 'FL';
				Seasonpass.characProps.ph_sex = 'm';
				Seasonpass.characProps.ph_zip = '32765';
				Seasonpass.characProps.copy_to_billing = 'yes';
			}
		}


		/***-----------------------------------------------------------------------
			 * PUBLIC
			 *------------------------------------------------------------------------**/

		/**
			 * Opens a modal for canceling a Season Pass
			 * Re-initializes Controller
			 * @public
			 */
		$scope.cancel = function() {
			// Prompt to delete.
			Modal.displayModal
			(
				{
					title: Language.Alert.cancelSeasonPassTitle,
					description: Language.Alert.cancelSeasonPassMsg,
					icon: 'icon-info red',
					buttonFlags: [Enums.buttonFlags.NO, Enums.buttonFlags.YES],
					callback: function(detail) {
						if (detail == Enums.buttonFlags.YES) {
							Seasonpass.previousView();
						}
					}
				}
			);
		}

		InitializeCtrl();
	}
	)

angular
	.module('app')
	.controller('SeasonPassOptRenewalCtrl', function(
		$scope,
		$rootScope,
		$state,
		$stateParams,
		ClientInfo,
		Enums,
		Modal,
		Package,
		Seasonpass,
		Utilities,
		UserInfo,
		Language,
		AddrLookup,
		UtilsValidation
	) {
		/*scope variables*/
		$scope.activePass = undefined;
		$scope.packageDetails = Package.packageDetails;
		$scope.deviceType = angular.copy(ClientInfo.deviceType);
		$scope.isMobile = $scope.deviceType === 'mobile' || $scope.deviceType === 'tablet';
		/**
			 * $scope.fieldSettings contains all of the settings designated in the extraflow for season_pass_renewal
			 * These get copied over to this field during the season_pass_renewal flow when the Seasonpass
			 * service is initialized
			 */
		$scope.fieldSettings = Seasonpass.fieldSettings;
		$scope.formOptions = Seasonpass.formOptions;
		$scope.submitted = false;
		$scope.passData = [];
		$scope.cartItems = Package.itemsToBeAddedForCurrentPackage();

		/**
			 * isActivePass - Function to identify if pass is active
			 * @public
			 * @param {Number} index of pass in view
			 * @returns {boolean} true if current index is the active pass
			 */
		$scope.isActivePass = function($index) {
			return $scope.activePass == $scope.passData[$index];
		}


		/**
			 * cancel - cancel the XFC and return control to Seasonpass
			 * @public
			 */
		$scope.cancel = function() {
			Modal.displayModal({
				category: 'Season Pass',
				action: 'View',
				label: 'Season Pass Renewal Cancel',
				title: Language.getLocale('SeasonPassRenewal', 'seasonPassConfirmCancelTitle'),
				description: Language.getLocale('SeasonPassRenewal', 'seasonPassConfirmCancelMsg'),
				buttonFlags: [Enums.buttonFlags.OK, Enums.buttonFlags.CANCEL],
				callback: function(response) {
					if (response == Enums.buttonFlags.OK) {
						Seasonpass.previousView();
					}
				}
			});
		};

		/**
			 * setActivePass - method to navigate to certain pass via index in scope.passData
			 */
		$scope.setActivePass = function(index, resetRoute) {
			if (index <= ($scope.passData.length-1) && index >= 0) {
				if (angular.isDefined($scope.activePass)) {
					$scope.activePass.isCurrentTicket = false;
					$scope.activePass.currentState = $state.current.name;
				}

				$scope.activePass = $scope.passData[index];
				$scope.activePass.isCurrentTicket = true;

				if (resetRoute) {
					$rootScope.routeTo($state.href($scope.activePass.currentState, { packageId: $stateParams.packageId }), undefined, undefined, true);
				} else {
					$rootScope.routeTo($state.href($scope.activePass.currentState, { packageId: $stateParams.packageId }));
				}
			}
		}

		/**
			 * setActivePassCurrTemplate
			 * @param step to set the activepasscurrTemplate
			 * @private
			 */
		function getNextState(step) {
			var currentState = $state.current.name;
			var nextState = undefined;

			if (currentState === Enums.spStates.SELECTION && step == Enums.spToggleDirections.FORWARD) {
				nextState = ($scope.activePass.renewalSelected ? Enums.spStates.RENEWALPASSFORM : Enums.spStates.NEWPASSFORM);
			} else if (currentState !== Enums.spStates.SELECTION && $scope.activePass.showRenewalOption && step == Enums.spToggleDirections.BACKWARD) {
				nextState = Enums.spStates.SELECTION;
			}

			return nextState;
		}

		/**
			 * Function to toggle forward or backward next step
			 * Note that itemsToBeAdded must be checked because sometimes if the guest attempts to add to cart
			 * The GetCartSummary call can fail due to the pass already being renewed
			 * @public
			 * @param incDecStep - either 1 for forward or -1 for backward
			 */
		$scope.toggleNextRenewalStep = function(incDecStep) {
			var nextState = getNextState(incDecStep);

			if ((incDecStep === Enums.spToggleDirections.FORWARD || incDecStep === Enums.spToggleDirections.BACKWARD) && UtilsValidation.validArray(Package.itemsToBeAdded)) {
				//swap the customer types on itemsToBeAdded if the baseCustomerType exists and the user opted for a new pass instead
				if (!$scope.activePass.renewalSelected && $state.current.name == Enums.spStates.SELECTION && angular.isDefined($scope.activePass.baseCustomerTypeInfo) && $scope.activePass.baseCustomerTypeInfo.hasOwnProperty('id')) {
					$scope.activePass.swapPackageWithBaseCustomerType = true;
				}

				if ($scope.activePass.copy_to_passes && !$scope.activePass.infoCopiedFromOtherPass) {
					Seasonpass.copyInfoToOtherNewPasses($scope.activePass, $scope.passData);
				}

				if (Package.settings.name === 'season_pass_cf_v2_copy_email' && $scope.passData.indexOf($scope.activePass) === 0) {
					$scope.passData.forEach(function(item, index, array) {
						if (index > 0) {
							//copy this as a temp field on each pass to overwrite the email if option to do so is selected
							item.first_pass_email = angular.copy(array[0].ph_email);
						}
					});
				}

				var currentPassIndex = $scope.passData.indexOf($scope.activePass);
				var nextPassIndex = currentPassIndex + incDecStep;

				if (angular.isDefined(nextState)) {
					if ($scope.activePass.submitted && nextState === Enums.spStates.SELECTION) {
						confirmEraseRenewalInfo(nextState);
					} else {
						if (nextState == Enums.spStates.SELECTION) {
							$scope.activePass.valid = false;
						}
						$scope.activePass.currentState == nextState;
						$rootScope.routeTo($state.href(nextState));

						//set the form to pristine so that we can reflect the new state of the view
						$scope.theForm.$setPristine();
					}
				} else if (nextPassIndex <= $scope.passData.length -1 && nextPassIndex >= 0) {
					$scope.setActivePass(nextPassIndex);

					//set the form to pristine so that we can reflect the new state of the view
					$scope.theForm.$setPristine();
				} else {
					incDecStep ===1 ? finalizeRenewalXFC() : $scope.cancel();
				}
			} else {
				alertInvalidXMCState();
			}

			Utilities.scrollPosition();
		};

		/**
			 * Assess if the season pass number is renewed in itemsToBeAdded
			 * @param passNumber
			 * @returns {boolean}
			 */
		$scope.checkSeasonPassNumberInPassData = function(passNumber) {
			var found = false;
			for (var i = 0; i< $scope.passData.length; i++) {
				var item = $scope.passData[i];
				if (angular.isDefined(item.ph_season_pass_number) && item.ph_season_pass_number === passNumber) {
					found = true;
					break;
				}
			}
			return found;
		};

		/**
		* Prompt user to confirm deletion
		*/
		$scope.delete = function(promptUserForConfirmation, $index) {
			if (angular.isUndefined($index)) {
				for (var i = 0; i< $scope.passData.length; i++) {
					if ($scope.passData[i]===$scope.activePass) {
						$index = i;
						break;
					}
				}
			}
			if (promptUserForConfirmation && $scope.passData.length > 1) {
				confirmEraseRenewalInfo(undefined, completeDeleteForm, $index);
			} else if ($scope.passData.length === 1) {
				$scope.cancel();
			} else {
				completeDeleteForm();
			}
		};

		/**
		*  complete the deletion of the form
		*/
		function completeDeleteForm(index) {
			var passDataLength = $scope.passData.length;
			var pass = $scope.passData[index];
			Package.markItemToBeAddedForDeletion(pass.itemsAddedIndex, pass.characsIndex);
			if (pass === $scope.activePass) {
				if ((index + 1) < passDataLength) {
					$scope.setActivePass((index + 1));
				} else {
					$scope.setActivePass(index - 1);
				}
			}

			$scope.passData.splice(index, 1);
			$scope.passData.map(function(item, index) {
				item.formID = 'theForm_' + index +1;
				item.formIndex = index +1;
			});

			Seasonpass.setPassIndexInfo($scope.passData);
			$scope.fieldSettings.numPasses--;
		}

		/**
			 * Checks that minimum Qty requirement is met.
			 * @private
			 * @returns {boolean}
			 */
		function meetsMinQtyRequirement() {
			// Check the package's max-quantity and ensure deleting one will not go below min-qty.
			var minQty = Number($scope.packageDetails.min_quantity) || 0;

			if (minQty == 0) {
				return true;
			} else if (minQty > 1) {
				if ($scope.fieldSettings.numPasses - 1 < minQty) {
					return false;
				}
			}

			return true;
		}

		function alertInvalidPasses() {
			Modal.displayModal({
				category: 'Season Pass Renewal Error',
				action: 'Renewal Errors',
				error: 'Renewal Errors',
				label: 'Renewal Invalid Passes Error',
				title: Language.getLocale('Alert', 'spAlertInvalidPassesTitle'),
				description: Language.getLocale('Alert', 'spAlertInvalidPassesMsg'),
				buttonFlags: [Enums.buttonFlags.OK, Enums.buttonFlags.CANCEL]
			});
		}

		/**
		* alertInvalidXMCState - method to display a modal to the user letting them know if the pass registration failed
		 * This will be shown on cases when GetCartSummary returns an error that the pass cannot be renewed or registered
		*/
		function alertInvalidXMCState() {
			Modal.displayModal({
				category: 'Season Pass Renewal Error',
				action: 'Renewal Errors',
				error: 'Renewal Errors',
				label: 'Invalid XMC State Error',
				title: Language.getLocale('Alert', 'seasonPassRegistrationErrorTitle'),
				description: Language.getLocale('Alert', 'seasonPassRegistrationErrorMsg'),
				buttonFlags: [Enums.buttonFlags.OK],
				callback: function(response) {
					Package.cancelXFC();
				}
			});
		}

		/**
		* confirmEraseRenewalInfo - method to confirm the erasing of the lookup pass data
		* @param nextStep - next Step to navigate to if user clicks ok to confirm the erasing of all of their pass data
		*/
		function confirmEraseRenewalInfo(nextState, callback, index) {
			var meetsMinQtyReq = meetsMinQtyRequirement();

			// Prompt to delete.
			var title = (meetsMinQtyReq)
				? Language.getLocale('Alert', 'deleteSeasonPassTitle')
				: Language.getLocale('Alert', 'deleteSeasonPassMinQtyTitle');

			var msg = (meetsMinQtyReq)
				? Language.getLocale('Alert', 'deleteSeasonPassMsg')
				: Language.getLocale('Alert', 'deleteSeasonPassMinQtyMsg');

			Modal.displayModal(
				{
					replacementKeys: ['minQty'],
					replacementValues: [$scope.packageDetails.min_quantity],
					category: 'Season Pass Renewal',
					action: 'Delete Data',
					label: 'Confirm Delete Season Pass',
					title: title,
					description: msg,
					icon: 'icon-info red',
					buttonFlags: [Enums.buttonFlags.NO, Enums.buttonFlags.YES],
					callback: function(response) {
						if (response == Enums.buttonFlags.YES) {
							if (nextState) {
								$scope.activePass.submitted = false;
								$scope.activePass.valid = false;
								$scope.activePass.currentState = nextState;
								$rootScope.routeTo($state.href(nextState));
							} else if (callback) {
								if (meetsMinQtyReq) {
									callback(index);
								} else {
									Seasonpass.cancel();
								}
							}
						}
					}
				});
		}

		/**
			 * toggleForm - toggle the other forms (if more than one) - allow toggling only if the following conditions:
			 * if the current pass is valid or the pass we are navigating to is valid, or we are on the last form
			 * @param $index of the form to go to
			 */
		$scope.toggleForm = function($index) {
			if (((!$scope.activePass.valid && ($scope.passData.indexOf($scope.activePass) == $scope.passData.length-1))
						|| $scope.passData[$index].valid || $scope.activePass.valid)) {
				$scope.activePass.currentState = $state.current.name;
				$scope.setActivePass($index);
				$scope.submitted = false;
			}
		};

		/**
			 * Format data in the model before form is submitted
			 */
		function formatFormData() {
			$scope.activePass.ph_first_name = Utilities.capitalizeFirst($scope.activePass.ph_first_name);
			$scope.activePass.ph_last_name = Utilities.capitalizeFirst($scope.activePass.ph_last_name);
		}

		function saveOneBarcodeAddons() {
			// are we in one barcode mode
			// tell the Add On Directive to save data back to formData
			$scope.$broadcast('saveData', { formHashKey: $scope.activePass.$$hashKey });
		}

		/**
			 * submitRenewalForm - method to handle logic for validating and allowing next item in renewal flow
			 */
		function submitRenewalForm() {
			var formItem = $scope.activePass;
			if (!$scope.theForm.$invalid && $state.current.name === Enums.spStates.SELECTION) {
				if ($scope.activePass.renewalSelected) {
					promptGuestToVerifyPassFromServer();
				} else {
					$scope.toggleNextRenewalStep(1);
				}
			} else if ($scope.theForm.$invalid
				|| !$scope.activePass.ph_sex
				|| !validateAge(formItem)) {
				return;
			} else {
				$scope.activePass.valid = true;
				saveDataForBilling($scope.activePass);

				AddrLookup.setShowAddrLookupOnNextForm(false);
				$scope.toggleNextRenewalStep(1);
				Utilities.scrollPosition();
			}
		}

		function validateAge(currentFormItem) {
			if ($scope.fieldSettings.age.required &&
				$scope.fieldSettings.age.visible) {
				if (isNaN(currentFormItem.formData.ph_age) || currentFormItem.formData.ph_age == '') {
					currentFormItem.formData.ph_age = '';
					return false;
				}
			}

			return true;
		}

		function saveDataForBilling(data) {
			if ($scope.activePass.copy_to_billing) {
				// Flag to check if we are using season pass data for billing.
				UserInfo.userInfo = UserInfo.userInfo || {};
				UserInfo.userInfo.firstName = data.ph_first_name;
				UserInfo.userInfo.lastName = data.ph_last_name;
				UserInfo.userInfo.country = data.ph_country_code;
				UserInfo.userInfo.address = data.ph_address;
				UserInfo.userInfo.address2 = data.ph_address2;
				UserInfo.userInfo.city = data.ph_city;
				UserInfo.userInfo.state = data.ph_state || data.ph_province;
				UserInfo.userInfo.zip = data.ph_zip;
				UserInfo.userInfo.phone = String(data.ph_home_phone);
				UserInfo.userInfo.copy_to_billing = data.copy_to_billing;
				UserInfo.userInfo.mobile = '';
				UserInfo.userInfo.email = (!Language.SeasonPass.noEmail ? data.ph_email :
					data.ph_email.toLowerCase() !== Language.SeasonPass.noEmail.toLowerCase() ? data.ph_email : ''
				);
				//UserInfo.userInfo.emailVerify = UserInfo.userInfo.email;
				UserInfo.userInfo.sameAddress = 'yes';

				UserInfo.shipping = JSON.parse(JSON.stringify(UserInfo.userInfo));
				UserInfo.billing = JSON.parse(JSON.stringify(UserInfo.userInfo));
			} else {
				UserInfo.billing.copy_to_billing = false;
			}
		}


		function promptGuestToVerifyPassFromServer() {
			Modal.displayModal({
				category: 'Season Pass Renewal',
				action: 'View',
				label: 'Season Pass Renewal Must Verify Pass',
				title: Language.getLocale('SeasonPassRenewal', 'seasonPassMustVerifyPassTitle'),
				description: Language.getLocale('SeasonPassRenewal', 'seasonPassMustVerifyPassMsg'),
				buttonFlags: [Enums.buttonFlags.OK]
			});
		}

		/**
			 * Attempts to submit form.
			 * Checks that form fields are valid and passes the data to
			 * CHARACS.
			 * @public
			 * @returns {*}
			 */
		$scope.submitForm = function() {
			if ($scope.useAddrLookup && $scope.addrLookupActivated) {
				AddrLookup.showAddrLookupIncompleteModal();
			}

			$scope.activePass.submitted = true;
			formatFormData();

			saveOneBarcodeAddons();


			if ($scope.fromRenewalFlow) {
				submitRenewalForm();
			}
			$rootScope.$broadcast('triggerPushSeasonPassInfo', $scope.formData);

			Utilities.scrollPosition();
		};

		/**
			 *finalizeRenewalXFC - method to finalize all the items for renewal
			* finalizes characs by adding the necessary characs to the itemToBeAdded
			* and then delagates to next view
			*/
		function finalizeRenewalXFC() {
			//check for invalid passes
			var invalidPasses = $scope.passData.filter(function(item) {
				return !item.valid
			});
			if (invalidPasses.length >0) {
				alertInvalidPasses()
			} else {
				Seasonpass.finalizeRenewalXFC($scope.passData);
			}
		}

		/**
			 * Initializes the controller.
			 * @private
			 * @returns {null}
			 */
		function initializeCtrl() {
			if (!Package.initXFC()) {
				return;
			}
			$scope.passData = Seasonpass.createRenewalDataModel($scope.autofill);
			$scope.fieldSettings.numPasses = $scope.passData.length;
			$scope.isEditing = Package.isEditing();
			// reset this data
			UserInfo.set('seasonPass', []);

			//set the active pass in the list to the very first one
			$scope.setActivePass(0, true);

			$scope.fromRenewalFlow = $scope.activePass.hasOwnProperty('renewalSelected');

			// Hide the spinner.
			$scope.hideSpinner();
		}


		//call initialize controller
		initializeCtrl();
	});

/**
 * Created by dsmith on 10/27/2014.
 */
angular
	.module('app')
	.controller('VerificationCtrl', function(
		$scope,
		$rootScope,
		$injector,
		$stateParams,
		$window,
		AppData,
		ClientInfo,
		Enums,
		KnowledgeBaseService,
		Package,
		JSONValidator,
		Language,
		Verification,
		Modal,
		Utilities,
		UtilsValidation
	) {
		/**
		 * Utility Functions
		 */
		var getBoolean = Utilities.getBoolean;
		var validString = UtilsValidation.validString;
		var BarcodeScannerService;

		/**
		 * Merchant suffix to use for locales
		 * @type {String}
		 */
		$scope.merchantSuffix = AppData.settings.merchant_locale_suffix;

		/**
		 * Is the active flow the verify pass alternate module
		 * @type {Boolean}
		 */
		$scope.isVerifyPassKeywordFlow = UtilsValidation.validString($stateParams.keyword);

		/**
		 * The keyword state param
		 * @type {String}
		 */
		$scope.verifyPassKeyword = $stateParams.keyword;

		/**
		 * giving the scope access to the i18n model
		 */
		$scope.i18n = Language;

		/**
		 * whether the input form was submitted or not
		 */
		$scope.submitted = false;

		/**
		 * current index in formItems (only needed if multi-verification is enabled)
		 */
		$scope.index = 0;

		/**
		 * locale prefix set in XFC settings in ExtraFlow service
		 */
		$scope.localePrefix = '';

		/**
		 * bound modified locale
		 */
		$scope.stepOfSteps = '';

		/**
		 * If the Barcode Scanner is allowed to Display or not
		 * @type {Boolean}
		 */
		$scope.showBarcodeScanner = false;

		/**
		 * The barcode pattern to validate against, false if not set
		 * @type {RegExp|Boolean}
		 */
		$scope.barcodePattern = false;

		/**
		 * Activation Locale Text
		 * @type {String}
		 */
		$scope.activationText = '';

		/**
		 * for view
		 */
		$scope.Verification = Verification;

		/**
		 * Reference to the KnowledgeBaseService showFAQModal
		 * @todo Make FAQ Modal only show relevant information for this module
		 * @type {Function}
		 * @see KnowledgeBaseService.showFAQModal
		 */
		$scope.showFAQModal = KnowledgeBaseService.showFAQModal;

		/**
		 * Disables the next button from executing any logic
		 * @type {Boolean}
		 */
		$scope.disableNextButton = false;

		/**
		 * whether or not to display the pass instruction images
		 * @type {boolean}
		 */
		$scope.showPassInstructionImages = function() {
			if (Utilities.safelyCheckPropertyOnObject('AppData.settings.showPassInstructionImages', AppData)) {
				return Utilities.getBoolean(AppData.settings.showPassInstructionImages);
			}
			return (Utilities.safelyCheckPropertyOnObject('Package.settings.showPassInstructionImages', Package) ? Package.settings.showPassInstructionImages : false);
		};

		$scope.verificationConfig = {};
		/**
		 * Lookups that are verified
		 */
		$scope.verifiedLookups = [];
		/**
		 * service call to be made
		 */
		var serviceCall;

		/**
		 * Internal variable to host barcode scanner specific configuration
		 * @type {Object}
		 */
		var barcodeScannerConfig;

		/**
		 * scope function for html button to add items to cart
		 */
		$scope.confirm = function() {
			if (!validate()) {
				return;
			}

			$scope.verify();
		};

		/**
		 * scope function for html button to cancel flow
		 */
		$scope.cancel = function() {
			// Handle the cancel button clicked.
			if ($scope.isVerifyPassKeywordFlow) {
				$window.history.back();
			} else {
				Package.cancelXFC();
			}
		};

		/**
		 * Where the barcode scanner matches a barcode, this function will be called
		 * @callback
		 * @param {Object} result
		 * @returns {undefined}
		 */
		function _barcodeScannerSuccessCallback(result) {
			// If the configuration for using pattern is set and matches OR if the configuration does not exist, set field and close scanner
			if (getBoolean(barcodeScannerConfig.disablePattern) || BarcodeScannerService.testBarcodePattern($scope.barcodePattern, result.text)) {
				$scope.PassField[0].value = result.text;
				$scope.Verification.data[$scope.index].value = result.text;
				$scope.barcodeScanner.close();
				$scope.$apply();
			}
		}

		/**
		 * If user click the Enter Manually button, do the following actions
		 * @callback
		 * @returns {undefined}
		 */
		function _enterManuallyCallback() {
			// Focus Input
			$scope.PassField[0].focus();
		}

		/**
		 * Function to open up the Barcode Scanner Modal
		 * @function
		 * @returns {undefined}
		 */
		$scope.openBarcodeScanner = function() {
			BarcodeScannerService.displayModal($scope, _enterManuallyCallback, _barcodeScannerSuccessCallback);
		}

		/**
		 * Controller initialization function. Called at the bottom of the file.
		 */
		function InitializeCtrl() {
			if (!$scope.isVerifyPassKeywordFlow && !Package.initXFC()) {
				return;
			}

			$scope.verificationLocalePrefix = "";


			// Package charac points to an object name on part of the appconfig that contains names of image sets
			if (JSONValidator.validate('verification_config', AppData.settings.verification_config)) {
				$scope.verificationConfig = JSON.parse(AppData.settings.verification_config);
				Verification.setVerificationAppConfig($scope.verificationConfig);

				if (UtilsValidation.validObject($scope.verificationConfig.barcodeScanner)) {
					// Set the barcode config to its' own variable
					barcodeScannerConfig = $scope.verificationConfig.barcodeScanner || {};

					// Check if we can offer the barcode scanner and if the device is either mobile or tablet
					if (getBoolean(barcodeScannerConfig.enable) && ['mobile', 'tablet'].includes(ClientInfo.deviceType)) {
						Utilities.cacheBustAndLazyLoad([
							'scripts/modules/barcode-scanner/services/barcode-scanner-service.js'
						]).then(function() {
							BarcodeScannerService = $injector.get('BarcodeScannerService');

							if (BarcodeScannerService.canOfferBarcodeScanner()) {
								$scope.showBarcodeScanner = true;

								if (validString(barcodeScannerConfig.barcodePattern)) {
									$scope.barcodePattern = new RegExp(barcodeScannerConfig.barcodePattern);
								}
							}
						});
					}
				}

				if (!$scope.verifyPassKeyword && Utilities.safelyCheckPropertyOnObject('Package.packageDetails.CHARACS.verification_alt_img_group', Package) && angular.isDefined($scope.verificationConfig.alternative_images)) {
					var lookupGroup = Package.packageDetails.CHARACS.verification_alt_img_group;
					var altImages = $scope.verificationConfig.alternative_images;

					var result = altImages.filter(function(item) {
						return item.group == lookupGroup;
					});

					if (angular.isDefined(result[0])) {
						var match = result[0];
						$scope.verificationConfig.voucherImage = $rootScope.getAssetUrl(match.back_image);
						$scope.verificationConfig.cardImage = $rootScope.getAssetUrl(match.card_image);
						if (angular.isDefined(match.localePrefix)) {
							$scope.verificationLocalePrefix = match.localePrefix;
						}
					} else {
						// the charac provided doesn't match any group setup in the verification_config
					}
				} else {
					$scope.verificationConfig.voucherImage = $rootScope.getAssetUrl($scope.verificationConfig.voucherImage);
					$scope.verificationConfig.cardImage = $rootScope.getAssetUrl($scope.verificationConfig.cardImage);
				}
			} else {
				$scope.verificationConfig.voucherImage = '../images/ticketCode.png';
				$scope.verificationConfig.cardImage = '../images/cardCode.png';
			}

			Verification.reset();

			Verification.verifyService = $scope.isVerifyPassKeywordFlow ? Enums.services.SEASON_PASS_ACTIVE : Package.settings.serviceCall;
			Verification.uniqueValues = $scope.isVerifyPassKeywordFlow ? false : Package.settings.uniqueValues;
			Verification.multiVerification = $scope.isVerifyPassKeywordFlow ? false : Package.settings.multiValidate;

			//set information from Extra Flow settings
			$scope.localePrefix = $scope.isVerifyPassKeywordFlow ? '' : Package.settings.localePrefix;

			// setup override for the locale prefix to pull from the app config rather than the package settings
			if ($scope.verificationLocalePrefix) {
				$scope.localePrefix = $scope.verificationLocalePrefix;
			}

			$scope.activationText = Language.getLocale('Verification', $scope.localePrefix + 'activationText');

			if (!$scope.isVerifyPassKeywordFlow) {
				var item = null;
				var qty = 0;
				var verificationPackages = Verification.getItemsEligibleForVerification();
				for (var i = 0; i < verificationPackages.length; i++) {
					item = verificationPackages[ i ];

					qty = (Verification.multiVerification) ? parseInt(item.qty, 10) : 1;
					for (var j = 0; j < qty; j++) {
						Verification.data.push(
							{
								value: '',
								valid: false,
								unique: true,
								package: angular.copy(item)
							}
						);
					}

					if (!Verification.multiVerification) {
						break;
					}
				}
			} else {
				Verification.data.push(
					{
						value: '',
						valid: false,
						unique: true,
						package: null
					}
				);
			}


			updateStepOfSteps();
		}

		function updateStepOfSteps() {
			var totalSteps = $scope.isVerifyPassKeywordFlow ? 1 : Verification.getQty();
			$scope.stepOfSteps = Language.getLocale('Verification', $scope.localePrefix + 'steps');

			if (!angular.isDefined($scope.stepOfSteps)) {
				$scope.stepOfSteps = '';
			}

			$scope.stepOfSteps = $scope.stepOfSteps.replace('@@index', $scope.index + 1);
			$scope.stepOfSteps = $scope.stepOfSteps.replace('@@total', totalSteps);
		}

		/**
		 * returns if the form is valid
		 */
		function validate() {
			$scope.submitted = true;

			return !$scope.theForm.$invalid && Verification.validate($scope.index);
		}

		/**
		 * call backend service to see if pass is valid
		 */
		$scope.verify = function() {
			$rootScope.showSpinner(Language.getLocale('Verification', $scope.localePrefix + 'spinnerMessage'));

			Verification.verify($scope.index).then($scope.handleVerificationResult).catch($scope.handleVerificationError);
		};

		/**
		 * handler for verification result from backend
		 */
		$scope.handleVerificationResult = function(data) {
			$rootScope.hideSpinner();

			if (!Verification.multiVerification || $scope.index + 1 == Verification.getQty()) {
				var packageIds = UtilsValidation.validString(data) ? data : null;
				var trimmedIds = packageIds ? $scope.trimPackages(packageIds) : packageIds;

				interactionComplete(trimmedIds);
			} else {
				$scope.verifiedLookups.length = 0;
				Verification.data.forEach(function findVerifiedLookups(lookup) {
					if (validString(lookup.value) && lookup.valid) {
						$scope.verifiedLookups.push(lookup.value);
					}
				});
				// transition to next index
				$scope.index++;
				$scope.submitted = false;
				$scope.theForm.$setPristine();
				updateStepOfSteps();
			}
		}

		/**
		 *
		 * Removes any packages not related to current keyword
		 * @param {String} packageIds - comma separated string of package IDs to trim
		 * @returns {String} trimmed comma separated string of package IDs
		 */
		$scope.trimPackages = function(packageIds) {
			var keywordPackages = Utilities.wrapObjectToArray(
				Package.filterPackagesByKeyword(undefined, $stateParams.keyword),
				true
				).map(function getPackageIDs(keywordPkg){
					return keywordPkg.id;
				});
			return packageIds.split(',').filter(function hasKeyword(pkgId){
				return keywordPackages.includes(pkgId);
			}).join(',');
		}

		/**
		 *
		 * Handle verification error method to display an error upon unsuccessful lookups
		 * @param {Object} data - the result from Backend API
		 */
		$scope.handleVerificationError = function(data) {
			var errorSection = 'Verification';
			var errorMessage = $scope.localePrefix + (Verification.getDuplicateBarcode() ? 'duplicatedBarcode' : 'verificationError');
			if (UtilsValidation.validString(data.error_code)) {
				//override the error sections our standard error codes
				errorSection = 'ErrorCodes';
				errorMessage = data.error_code;
			}
			$rootScope.hideSpinner();
			Modal.displayModal(
				{
					action: 'Error',
					category: 'Verification',
					description: Language.getLocale(errorSection, errorMessage),
					label: 'Verification Error',
					title: Language.getLocale('Verification', $scope.localePrefix + 'verificationErrorTitle')
				}
			);
		};

		function interactionComplete(packageIds) {
			Verification.interactionComplete(packageIds, $scope.isVerifyPassKeywordFlow);

			// If we are already navigating away, do nothing
			if ($scope.disableNextButton) {
				return;
			}

			if ($scope.isVerifyPassKeywordFlow) {
				if (UtilsValidation.validString(packageIds)) {
					$rootScope.routeTo('/packageList/packages/' + packageIds);
				} else {
					var defaultPackageRouteType = $scope.verificationConfig.defaultRouteTypeForValidPass || 'keyword';
					var defaultPackageRouteValue = $scope.verificationConfig.defaultRouteValueForValidPass || '';
					$rootScope.routeTo('/packageList/' + defaultPackageRouteType + '/' + defaultPackageRouteValue);
				}
			} else {
				// Navigate to the next XFC.
				Package.nextXFC();
			}

			// Disable the next button to prevent multiple clicks
			$scope.disableNextButton = true;
		}

		InitializeCtrl();
	}
	);

(function() {
	'use strict';

	angular
		.module('app')
		.controller('SplashscreenCtrl', SplashscreenCtrl);
	/**
	 * SpalshscreenCtrl
	 * @param {Service} $uibModalInstance $uibModalInstance
	 * @param {Service} $rootScope $rootScope
	 * @param {Service} $scope $scope
	 * @param {Service} $sce $sce
	 * @param {Service} $window $window
	 * @param {Service} AppData AppData
	 * @param {Service} Language Language
	 * @param {Service} UtilsValidation UtilsValidation
	 * @returns {self} Our Controller
	 */
	function SplashscreenCtrl($uibModalInstance, $rootScope, $scope, $window, AppData, Language, UtilsValidation) {
		var getLocaleWithSuffixAndFallback = Language.getLocaleWithSuffixAndFallback,
			MERCHANT_ID_STRING = AppData.merchantId + '',
			localeSection = 'SplashScreen';

		$scope.validString = UtilsValidation.validString;
		$scope.changeParkText = getLocaleWithSuffixAndFallback(localeSection, 'changePark', MERCHANT_ID_STRING);
		$scope.continueText = getLocaleWithSuffixAndFallback(localeSection, 'continue', MERCHANT_ID_STRING);
		$scope.headerText = getLocaleWithSuffixAndFallback(localeSection, 'header', MERCHANT_ID_STRING);
		$scope.customImageAlt = getLocaleWithSuffixAndFallback('Accessibility', 'splashScreenImageAlt', MERCHANT_ID_STRING)

		$scope.dismissModal = dismissModal;
		$scope.changePark = changePark;
		$scope.getWindow = getWindow;
		$scope.getLocaleValue = getLocaleValue;
		$scope.initializeController = initializeController;

		$scope.initializeController();

		/**
		 * Controller initialization
		 * @public
		 * @returns {undefined}
		 */
		function initializeController() {
			var customImageVal = $scope.getLocaleValue('customImage');
			$scope.changeParkUrl = $scope.getLocaleValue('changeParkUrl');
			$scope.customText = $scope.getLocaleValue('customText');
			$scope.customImage = $scope.validString(customImageVal) ? $rootScope.getAssetUrl(customImageVal) : '';
		}

		/**
		 * Returns locale values
		 * @public
		 * @param {String} target target value of locale
		 * @returns {String} locale value
		 */
		function getLocaleValue(target) {
			var missingLocaleValue = '[' + localeSection + '.' + target + '] target missing';
			var value = getLocaleWithSuffixAndFallback(localeSection, target, MERCHANT_ID_STRING);
			if (value === missingLocaleValue) {
				return '';
			}
			return value;
		}

		/**
		 * Dismiss modal
		 * @public
		 * @returns {undefined}
		 */
		function dismissModal() {
			$rootScope.modalOpen = false;
			$uibModalInstance.close('');
		}

		/**
		 * Returns window
		 * @public
		 * @returns {Object} $window service
		 */
		function getWindow() {
			return $window;
		}

		/**
		 * Change Park
		 * @public
		 * @returns {undefined}
		 */
		function changePark() {
			if ($scope.validString($scope.changeParkUrl)) {
				$scope.getWindow().open($scope.changeParkUrl, '_parent');
			} else {
				$scope.dismissModal();
			}
		}

		// Dismiss modal on hidePreviousModals
		$scope.$on('hidePreviousModals', function() {
			$rootScope.modalOpen = false;
			$uibModalInstance.close('');
		});
	}
})();
(function() {
	'use strict';

	angular
		.module('ab-test', []);
})();
/**
 *  AbTestService provides the ability to add AB Tests to the application. It supports any number of AB tests, each of
 *  which is determined independently of the others.
 *
 *  Usage:
 *    To configure an AB Test:
 *      Use the App Config ABTests, which is an array:
 *    	  Each AB Test should have one entry in that array of the format {"name": "ab test name", "enabled": true, "weight": 1-99, "descriptionA": "A test", "descriptionB":"B test" }
 *        If the weight is not present, 50 will be used. The weight indicates the percentage of time that test A should be used.
 *        For example: weight: 40 indicates that test A should appear 40% of the time.
 *
 *
 *    In your code:
 *
 *      AbTestService.abTest(testName) returns a 1 or a 2. 1 = test A, 2 = test B. Once this function is
 *        called once, its result is stored both in memory and in local storage (so the user will see consistent
 *        behavior throughout the store). If the test is not enabled, this function always returns 1 and does not
 *        store anything in local storage
 *
 *      AbTestService.addReferenceToCartItems(cartItems, testName) adds a charac to the item with the name "abTest_testName", but only if
 *        the test is enabled. If you don't call this, the AB test charac will not be added to the ticket!
 *
 *      AbTestService.triggerAnalytics(message, items, keyword, testName) sends the message to that triggers the call
 *        to Google Analytics. Basically, it calls $rootScope.$broadcast(message, items, keyword with testname added)
 *        If the test is not enabled, it does not alter the keyword.
 *
 *      AbTestService.abTestActive(testName) is also exposed. It returns true if the test is active. There
 *        should never be a need to call this function.
 *
 *   Format of App Config:
 *
 *   "ABTests": [{
 *		"name": "Checkout AB",
 *		"descriptionA": "Displays a different checkout locale verbiage based on the results of A/B",
 *		"descriptionB": "",
 *		"enabled": true,
 *		"weight": 50
 *	 }]
 *
 **/
(function() {
	'use strict';

	angular
		.module('ab-test')
		.factory('AbTestService', function(AppData,
			Utilities,
			JSONValidator,
			Storage) {
			var service = {
				abTest: abTest,
				abTestActive: abTestActive,
				abTestDescription: abTestDescription,
				abTestDescriptionFromPackage: abTestDescriptionFromPackage,
				addReferenceToCartItems: addReferenceToCartItems,
				tests: []
			};

			/**
			 * Returns abtest_ + name which is how the key will look in storage.
			 * @private
			 * @param  {String} name Name of test.
			 * @returns {String} Storage name
			 */
			function nameInStorage(name) {
				return "abtest_" + name;
			}

			/**
			 * Saves test name, result in storage.
			 * @private
			 * @param  {String} name Name of test
			 * @param  {Number} value Test result
			 * @returns {void}
			 */
			function saveToStorage(name, value) {
				Storage.set(nameInStorage(name), value);
			}

			/**
			 * Reads test name, value from storage and returns the value.
			 * @private
			 * @param  {String} name Name of test
			 * @returns {Number | Undefined} Test result
			 */
			function readFromStorage(name) {
				var result = Storage.get(nameInStorage(name), true);
				if (result !== null) {
					return result;
				}
				return undefined;
			}

			/**
			 * If saved tests are in memory (on the service), reads result of test from memory and returns it.
			 * @private
			 * @param  {String} name Name of test
			 * @returns {Number | Undefined} Test result
			 */
			function readFromMemory(name) {
				var i = 0;
				for (; i < service.tests.length; i++) {
					if (angular.isDefined(service.tests[i].name) && service.tests[i].name == name) {
						return service.tests[i].value;
					}
				}
				return undefined;
			}

			/**
			 * Loads test from app config and returns test matching the name parameter.
			 * @private
			 * @param  {String} name Name of test
			 * @returns {Object | Undefined} Test configuration object
			 */
			function loadFromAppConfig(name) {
				var abTests = JSONValidator.validate('ABTests', AppData.settings.ABTests) ? JSON.parse(AppData.settings.ABTests) : undefined;
				var i = 0;

				if (angular.isDefined(abTests) && angular.isArray(abTests)) {
					for (; i < abTests.length; i++) {
						if (abTests[i].name == name) {
							return abTests[i];
						}
					}
				}

				return undefined;
			}

			/**
			 * Determines if a test is active.
			 * @public
			 * @param  {String} testName Name of test
			 * @returns {Boolean} isTestActive
			 */
			function abTestActive(testName) {
				var ab = loadFromAppConfig(testName);
				if (angular.isDefined(ab)) {
					return Utilities.getBoolean(ab.enabled);
				}
				return false;
			}

			/**
			 * Saves a test configuration object to the service (memory).
			 * @private
			 * @param  {String} name Name of test
			 * @param  {Object} value Test configuration object
			 * @returns {void}
			 */
			function saveToMemory(name, value) {
				service.tests.push({
					name: name,
					value: value
				});
			}

			/**
			 * Executes A/B test and returns result
			 * @private
			 * @param  {String} testName Name of test
			 * @returns {Number} result Value of 1 or 2.
			 */
			function calculateTest(testName) {
			// return a 1 if the random value is less than weight, and a 2 if it's greater than weight.
				var ab = loadFromAppConfig(testName);
				var weight = (angular.isDefined(ab) && angular.isDefined(ab.weight)) ? Utilities.forceInt(ab.weight) : 50;
				var random = Math.floor(Math.random()*100);

				return (random <= weight) ? 1 : 2;
			}

			/**
			 * Executes a test and returns the description (if defined), or A/B if not.
			 * @public
			 * @param  {String} name Name of test
			 * @returns {String} description
			 */
			function abTestDescription(name) {
				var abTestConfig = loadFromAppConfig(name);

				if (angular.isUndefined(abTestConfig)) {
					return '';
				}

				if (abTest(name) == 1) {
					return angular.isDefined(abTestConfig.descriptionA) ? abTestConfig.descriptionA : 'A';
				}
				return angular.isDefined(abTestConfig.descriptionB) ? abTestConfig.descriptionB : 'B';
			}

			/**
			 * Executes an A/B test, saves result to storage / service if the test isn't yet saved.
			 * @public
			 * @param  {String} testName Test of name
			 * @returns {Number} result Test Result
			 */
			function abTest(testName) {
				var result;
				// Check if the test is active. If it's not, use case "1" (the "a" test)
				if (! abTestActive(testName)) {
					return 1;
				}

				result = readFromMemory(testName);

				if (angular.isUndefined(result)) {
					result = readFromStorage(testName);
				}
				if (angular.isUndefined(result)) {
					result = calculateTest(testName);
					saveToMemory(testName, result);
					saveToStorage(testName, result);
				}
				if (angular.isUndefined(result)) {
					result = 1;
				}
				return result;
			}

			/**
			 * Adds reference to cart items.
			 * @public
			 * @param  {Object[] | Object} cartItems Cart items
			 * @param  {String} testName Name of test
			 * @returns {void}
			 */
			function addReferenceToCartItems(cartItems, testName) {
				var itemArray = angular.isArray(cartItems) ? cartItems : [cartItems];
				var i = 0;
				var j;
				var item;
				var newC;
				var itemCharac;

				if (! abTestActive(testName)) {
					return false;
				}

				// client_alternate_view, client_alternate_name.
				for (; i < itemArray.length; i++) {
					item = itemArray[i];
					item.CHARACS = item.CHARACS || [];

					if (item.CHARACS.length<1) {
						newC = {};
						newC[nameInStorage(testName)] = abTestDescription(testName);
						item.CHARACS.push(newC);
					} else {
						for (j = 0; j < item.CHARACS.length; j++) {
							item.CHARACS[j] = item.CHARACS[j] || {};
							itemCharac = item.CHARACS[j];
							itemCharac[nameInStorage(testName)] = abTestDescription(testName);
						}
					}
				}
			}

			/**
			 * Tries to fetch abtest description from a package object.
			 * @public
			 * @param  {Object} pkg Package Object
			 * @returns {String} description
			 */
			function abTestDescriptionFromPackage(pkg) {
				var pkgRef = angular.isArray(pkg) ? pkg[0] : pkg;
				var property;
				var c;

				if (angular.isUndefined(pkgRef) || angular.isUndefined(pkgRef.CHARACS)) {
					return '';
				}

				c = angular.isArray(pkgRef.CHARACS) ? pkgRef.CHARACS[0] : pkgRef.CHARACS;
				for (property in c) {
					if (c.hasOwnProperty(property)) {
						if (property.indexOf('abtest_') == 0) {
							return c[property];
						}
					}
				}
				return '';
			}

			return service;
		});
})();
(function() {
	'use strict';

	angular
		.module('ab-test')
		.directive('abTestDirective', ['AbTestService', function() {
			return {
				bindToController: true,
				controller: 'AbTestDirectiveController',
				controllerAs: 'vm',
				restrict: 'E',
				scope: {
					// ID of AB Test result
					abTestId: '@',
					// Name of AB Test
					abTestName: '@'
				},
				template: '<div ng-transclude ng-show="vm.visible()"></div>',
				transclude: true
			}
		}]);
})();

(function() {
	'use strict';

	angular
		.module('ab-test')
		.controller('AbTestDirectiveController', AbTestDirectiveController);

	/**
	 * This is the controller for our AbTest directive.
	 * @public
	 * @constructor
	 * @param {Object} Utilities Our utilities service
	 * @param {Service} AbTestService The testing service.
	 * @return {undefined}
	 * @ngInject
	 */
	function AbTestDirectiveController(Utilities, AbTestService) {
		var vm = this;

		/**
		 * Determines if the directive should be shown or hidden.
		 * @public
		 * @returns {boolean} isVisible
		 */
		vm.visible = function() {
			return AbTestService.abTest(vm.abTestName) == Utilities.forceInt(vm.abTestId);
		}
	}
})();

(function() {
	'use strict';

	angular.module('quicksell', ['utilities', 'app']);
})();
(function() {
	'use strict';

	angular
		.module('quicksell')
		.factory('QuicksellService', QuicksellService);

	/**
	 * The quicksell service
	 * @param {Scope} $rootScope $rootScope
	 * @param {Service} AppData AppData
	 * @param {Service} CustomActionService Action service
	 * @param {Service} Package Package
	 * @param {Service} Utilities Utilities
	 * @param {Service} UtilsValidation Validation service
	 * @ngInject
	 * @returns {self} our instance
	 */
	function QuicksellService($rootScope, AppData, CustomActionService, Package, Utilities, UtilsValidation) {
		var forceInt = Utilities.forceInt,
			validString = UtilsValidation.validString,
			validArray = UtilsValidation.validArray,
			wrapObjectToArray = Utilities.wrapObjectToArray,
			checkProp = Utilities.checkProp;

		var service = {
			getQuicksellKeyword: getQuicksellKeyword,
			initialize: initialize,
			reset: reset,
			sendQuickSellImpressionToAnalytics: sendQuickSellImpressionToAnalytics,
		};

		return service;

		/**
		 * Returns the quicksell keyword for a package
		 * @param {Number} packageId The package ID
		 * @returns {String} The quicsell keyword
		 */
		function getQuicksellKeyword(packageId) {
			var keyword = checkProp('pkg.quicksell_keyword', Package.getPackageByID(packageId), 'returnValue');

			if (validString(keyword)) {
				return keyword;
			}
			return '';
		}

		/**
		 * Resets the quicksell
		 * @returns {undefined}
		 */
		function reset() {
			Package.quickSell = {
				keyword: '',
				quickSalesDetails: {},
				quickSalesTypes: {},
				status: false
			};
			Package.quickSellList = [];
		}

		/**
		 * Sets the quicksell package information
		 * @param {String} quicksellKeyword The quicksell keyword to use
		 * @param {Boolean} checkWizard If you want to check the packages against the getSelectedQuickSellPackage custom action for wizards
		 * @returns {Boolean} If we found quicksells or not
		 */
		function initialize(quicksellKeyword, checkWizard) {
			var maxQuicksells = parseInt(AppData.settings.max_quicksells_to_display, 10),
				updatedWizardQuicksells,
				quicksells;

			service.reset();

			if (Number.isNaN(maxQuicksells) || maxQuicksells <= 0) {
				maxQuicksells = 2;
			}

			quicksells = angular.copy(Package.filterPackagesByKeyword(undefined, quicksellKeyword, false).slice(0, maxQuicksells))

			Package.quickSell.keyword = validString(quicksellKeyword) ? quicksellKeyword : '';

			if (quicksells.length > 1) {
				Package.quickSellList = quicksells.map(function mapQuicksellList(pkg) {
					return {
						quickSalesDetails: pkg,
						quickSalesTypes: setQuicksellTypes(pkg),
						status: true
					};
				});

				// This is specifically for use on packageDetails controller
				if (checkWizard) {
					updatedWizardQuicksells = CustomActionService.executeCustomAction('getSelectedQuickSellPackage', Package.quickSellList);

					if (validArray(updatedWizardQuicksells)) {
						Package.quickSellList = updatedWizardQuicksells;
					}
				}
			} else {
				// There is only 1 quicksell to display, use the default format.
				Package.quickSell.quickSalesDetails = quicksells[0];

				if (!Utilities.isEmpty(Package.quickSell.quickSalesDetails)) {
					Package.quickSell.quickSalesTypes = setQuicksellTypes(Package.quickSell.quickSalesDetails);
					Package.quickSell.status = true;
				}
			}

			// Why this is here? I have no idea. But it specifically says the below comment in packageDetails controller...
			// Analytics - fire impressions regardless of number of quicksells
			return Package.quickSellList.length > 0 || Package.quickSell.status;
		}

		/**
		 * Sets the quicksell types. This logic was taken from packageDetails.js controller.
		 * This was copied from packageDetails controller
		 * @private
		 * @param {Object[]} packageData The package data
		 * @returns {Object[]} The item refs to use
		 */
		function setQuicksellTypes(packageData) {
			var keywords = wrapObjectToArray(packageData.KEYWORDS.K, true),
				pkgMainCustomerType = Package.getMainCustomerType(packageData.id),
				minQuantity = forceInt(packageData.min_quantity),
				node = !validArray(keywords) ? null : keywords.filter(function(kw) {
					return kw.keyword === Package.quickSell.keyword;
				}),
				useVat = AppData.defaults.use_vat,
				foundCt,
				itemRef;

			if (validString(packageData.shop_image_v4)) {
				packageData.image = $rootScope.getAssetUrl(packageData.shop_image_v4);
			}

			packageData.CT = wrapObjectToArray(packageData.CT, true);

			// We only use 1 CT for quicksells
			foundCt = packageData.CT.find(function findMainCt(ct) {
				return ct.id === pkgMainCustomerType.id;
			});

			/* eslint-disable camelcase */
			itemRef = {
				CHARACS: [
					{
						extra_movie: packageData.extra_movie,
						quicksell: "true",
						quicksell_base_package: Package.packageDetails.id,
						shop_google_sales_class_title: '',
						shop_rate_id: '',
						shop_rate_name: foundCt.name
					}
				],
				cart_limit_override: packageData.cart_limit_override,
				client_app_gate_price: foundCt.client_app_gate_price || {},
				client_gate_savings: packageData.client_gate_savings || '',
				cusTypeName: foundCt.name,
				cusTypeRetail: Utilities.getTotalPrice(foundCt),
				customer_type: foundCt.id,
				desc: packageData.desc,
				extra_movie: packageData.extra_movie,
				gate_price: foundCt.gate_price ? foundCt.gate_price : 0,
				keyword: packageData.keyword,
				keyword_description: node ? node[0].keyword_description : '',
				max_quantity: forceInt(packageData.max_quantity),
				min_quantity: minQuantity,
				package_id: packageData.id,
				promo_code: packageData.promo_code ? packageData.promo_code : '',
				qty: 0,
				title: packageData.name
			};
			/* eslint-disable camelcase */

			CustomActionService.executeCustomAction('populateQuickSellQuantity', itemRef);

			return [itemRef];
		}

		/**
		 * Send quicksell impressions to analytics
		 * @returns {undefined}
		 */
		function sendQuickSellImpressionToAnalytics() {
			var impressionPackages = [];
			Package.quickSellList.forEach(function(packageDetails) {
				var impressionPackage = {
					package_id : packageDetails.quickSalesDetails.id,
					CT: packageDetails.quickSalesTypes.map(function(ct) {
						return {
							id: ct.customer_type,
							name: ct.cusTypeName,
							cusTypeRetail: ct.cusTypeRetail
						};
					})
				};
				impressionPackages.push(impressionPackage);
			});
			$rootScope.$broadcast('triggerImpressionsSells', impressionPackages, "QuickSell");
		}
	}
})();
/* eslint-disable sort-keys */
(function() {
	'use strict';

	var MODULE_DIR = '/scripts/modules/package-details';

	angular
		.module('package-details', ['app', 'components'])
		.config(config);

	// window.accesso = window.accesso || {};
	// window.accesso.OPTIMIZE = window.accesso.OPTIMIZE || {};
	// window.accesso.OPTIMIZE.mobile_package_details = 1;

	/**
	 * Routing Config for the package-details module
	 * @public
	 * @memberOf package-details
	 * @param {Provider} $locationProvider The angular location provider
	 * @param {Provider} $stateProvider The angular state provider
	 * @param {Object} ComponentLoaderEnums The component enums
	 * @returns {undefined}
	 * @ngInject
	 */
	function config($locationProvider, $stateProvider, ComponentLoaderEnums) {
		var components = [ ComponentLoaderEnums.cartFeeNotice, ComponentLoaderEnums.estimatedSummary, ComponentLoaderEnums.quantity ];

		$stateProvider
			.state('/packageDetails', {
				url: '/packageDetails',
				components: components,
				controller: 'PackageDetailsCtrl',
				title: 'packageDetails',
				resolve: {
					initialData: initialDataWithSpinner,
					rejectIfNoPackages: rejectIfNoPackages,
					checkForDynamicPackage: checkForDynamicPackage,
					loadPackageDetailsAssets: loadPackageDetailsAssets
				},
				templateProvider: abTestTemplate
			})
			.state('/packageDetails/:packageId', {
				url: '/packageDetails/:packageId',
				components: components,
				controller: 'PackageDetailsCtrl',
				title: 'packageDetails',
				params: {
					dynamicPricing: {
						squash: true,
						value: []
					}
				},
				resolve: {
					initialData: initialDataWithSpinner,
					rejectIfNoPackages: rejectIfNoPackages,
					isUPDEnabled: isUPDEnabled,
					checkForDynamicPackage: checkForDynamicPackageAfterUPDCheck,
					loadPackageDetailsAssets: loadPackageDetailsAssets,
					checkForValidPackage: checkForValidPackage,
					dynamicPricing: function(checkForValidPackage, Package, DynamicCapacityPricingService, $stateParams) {
						return DynamicCapacityPricingService.getPackageDetailsResolve($stateParams, Package.alternateModuleItemsToBeAdded);
					}
				},
				templateProvider: abTestTemplate
			})
			.state('/packageDetails/crossSells/:packageId', {
				url: '/packageDetails/crossSells/:packageId',
				components: components,
				controller: 'PackageDetailsCtrl',
				title: 'packageDetails',
				params: {
					dynamicPricing: {
						squash: true,
						value: []
					}
				},
				resolve: {
					initialData: initialDataWithSpinner,
					rejectIfNoPackages: rejectIfNoPackages,
					checkForDynamicPackage: checkForDynamicPackage,
					loadPackageDetailsAssets: loadPackageDetailsAssets,
					dynamicPricing: function(loadPackageDetailsAssets, Package, DynamicCapacityPricingService, $stateParams) {
						return DynamicCapacityPricingService.getPackageDetailsResolve($stateParams, Package.alternateModuleItemsToBeAdded);
					}
				},
				templateProvider: abTestTemplate
			})
			.state('packageDetails', {
				url: '/packageDetails/:packageId/{flowType:(?:promocode|crosssells|navItem|keyword|calendar|savingsCalendar|calendarPricingByDay|calendarPricingWithImage|crossSells|packages|alternateEntry)}/:flowDetail',
				components: components,
				controller: 'PackageDetailsCtrl',
				title: 'packageDetails',
				params: {
					dynamicPricing: {
						squash: true,
						value: []
					}
				},
				resolve: {
					initialData: initialDataWithSpinner,
					rejectIfNoPackages: rejectIfNoPackages,
					isUPDEnabled: isUPDEnabled,
					checkForDynamicPackage: checkForDynamicPackageAfterUPDCheck,
					loadPackageDetailsAssets: loadPackageDetailsAssets,
					assessRoute: function(initialData, loadPackageDetailsAssets, RouteRejectionService, StandardFlowInitiatorService, Package, $transition$, $rootScope) {
						if (($transition$.params().flowType === 'alternateEntry' || $transition$.params().flowType === 'crossSells') && angular.isUndefined(Package.alternateModuleItemsToBeAdded)) {
							$rootScope.hideSpinner();
							throw new RouteRejectionService.UnrecoverableException(StandardFlowInitiatorService.alternateEntryState, StandardFlowInitiatorService.alternateEntryParams);
						}
					},
					checkForValidPackage: checkForValidPackage,
					dynamicPricing: function(checkForValidPackage, Package, DynamicCapacityPricingService, $stateParams) {
						return DynamicCapacityPricingService.getPackageDetailsResolve($stateParams, Package.alternateModuleItemsToBeAdded);
					}
				},
				templateProvider: abTestTemplate
			})
			.state('wizardPackageDetails', {
				url: '/packageDetails/:recommenderWizardKeyword/:packageId',
				components: components,
				controller: 'PackageDetailsCtrl',
				params: {
					dynamicPricing: {
						squash: true,
						value: []
					}
				},
				resolve: {
					initialData: initialDataWithSpinner,
					rejectIfNoPackages: rejectIfNoPackages,
					isUPDEnabled: isUPDEnabled,
					checkForDynamicPackage: checkForDynamicPackageAfterUPDCheck,
					loadPackageDetailsAssets: loadPackageDetailsAssets,
					recommenderWizard: function(initialData, loadPackageDetailsAssets, $transition$, RecommenderWizardContextService) {
						var params = $transition$.params();
						if (angular.isDefined(params.recommenderWizardKeyword) &&
							angular.isDefined(params.packageId)) {
							if (RecommenderWizardContextService.bootstrapWizard(params.recommenderWizardKeyword, 'wizardPackageDetails')) {
								RecommenderWizardContextService.registerPackageDetails();
							}
						}
					},
					dynamicPricing: function(recommenderWizard, Package, DynamicCapacityPricingService, $stateParams) {
						return DynamicCapacityPricingService.getPackageDetailsResolve($stateParams, Package.alternateModuleItemsToBeAdded);
					}
				},
				templateProvider: abTestTemplate
			});
	}

	/**
	 * Load our bootstrap and continue showing spinner.
	 * @param {Service} Bootstrap Bootstrap
	 * @param {Scope} $rootScope $rootscope
	 * @returns {Promise} to resolve our bootstrap process
	 * @ngInject
	 */
	function initialDataWithSpinner(Bootstrap, $rootScope) {
		$rootScope.showSpinner();
		return Bootstrap.bootstrapApplication(undefined, true);
	}

	/**
	 * Load Video Assets and Restricted Package component
	 * @param {Promise} rejectIfNoPackages Reject route
	 * @param {Service} TestStrategyService The Test strategy service
	 * @param {Service} Utilities Utilities service
	 * @param {Constants} VIDEO_ASSETS Video Assets
	 * @param {Constants} RESTRICTED_PACKAGES_ASSETS Restricted package assets
	 * @param {Constants} EXPANDABLE_INFO_COMPONENT_ASSETS For the expandable info component
	 * @param {Constants} PACKAGE_CARD_COMPONENT_ASSETS For the package card component
	 * @returns {Promise} to resolve loading video assets
	 * @ngInject
	 */
	function loadPackageDetailsAssets(checkForDynamicPackage, TestStrategyService, Utilities, VIDEO_ASSETS, RESTRICTED_PACKAGES_ASSETS, EXPANDABLE_INFO_COMPONENT_ASSETS, PACKAGE_CARD_COMPONENT_ASSETS) {
		var defaultFiles = [
			MODULE_DIR + '/package-details-new.css',
			'scripts/controllers/packagedetails.js'
		];

		return Utilities.cacheBustAndLazyLoad(
			defaultFiles
				.concat(EXPANDABLE_INFO_COMPONENT_ASSETS)
				.concat(PACKAGE_CARD_COMPONENT_ASSETS)
				.concat(VIDEO_ASSETS)
				.concat(RESTRICTED_PACKAGES_ASSETS)
		);
	}

	/**
	 * ROUTE GUARD
	 * Rejects a route if there is no AppData.GetMerchantPackageList
	 * @protected
	 * @param {Promise} initialData Bootstrap initialization process
	 * @param {Scope} $rootScope The root scope
	 * @param {Service} AppData The service
	 * @param {Service} RouteRejectionService To throw the exception
	 * @throws {RouteRejectionService.UnrecoverableException} an exception
	 * @return {undefined}
	 * @ngInject
	 */
	function rejectIfNoPackages(initialData, $rootScope, AppData, RouteRejectionService) {
		if (!angular.isObject(AppData.GetMerchantPackageList)) {
			$rootScope.hideSpinner();
			throw new RouteRejectionService.UnrecoverableException('/');
		}
	}

	/**
	 * Swaps the template for the AB testing
	 * @param {Service} TestStrategyService The AB test service
	 * @returns {String|Promise<String>} The template to use
	 * @ngInject
	 */
	function abTestTemplate(TestStrategyService) {
		return TestStrategyService.swapRouteTemplate('mobile_package_details', 1, '/views/packageDetails.html', MODULE_DIR + '/package-details-new.html');
	}

	/**
	 * Checks to ensure there is Restricted Packages but fail to load them.
	 * @param {resolve} initialData The initialData resolve
	 * @param {Service} $injector The $injector Service
	 * @param {Object} $transition$ The $transition$ Object
	 * @param {Service} Package The Package Service
	 * @param {Service} RestrictedPackagesService The Restricted Packages Service
	 * @param {Service} RouteRejectionService The Route Rejection Service
	 * @throws {UnrecoverableException} Throws UnrecoverableException if redirecting
	 * @returns {Boolean} true if valid, throws exception otherwise
	 * @ngInject
	 */
	function checkForValidPackage(initialData, $injector, $transition$, Package, RestrictedPackagesService, RouteRejectionService) {
		var packageId = $transition$.params().packageId,
			WTPService = $injector.has('WTPService') && $injector.get('WTPService');

		if (!RestrictedPackagesService.isRestrictedPackage(packageId) || RestrictedPackagesService.restrictedPackageLoaded(packageId)) {
			// Ignore if the package being loaded is not restricted OR is able to load.
			return true;
		}

		if (WTPService && WTPService.isWTPPackage(Package.getPackageByID(packageId))) {
			// If package is WTP, redirect to WTP reload page
			throw new RouteRejectionService.UnrecoverableException('wtpnumber');
		}

		// Default -- redirect to base page
		throw new RouteRejectionService.UnrecoverableException('/');
	}

	/**
	 * Redirects opted-in guests to UnifiedPackageDetails, bypassing the legacy flow.
	 * Runs BEFORE checkForDynamicPackage (a dependency of this resolve now) so a package UPD would otherwise handle is never diverted into a legacy alternate module first.
	 * Only entries from Cultural Member Benefits states stay on the legacy path — all other
	 * entry points (calendar modules, cross-sells, navItem, keyword, promocode) are routed to UPD.
	 * Depends on rejectIfNoPackages so bootstrap has populated AppData.unifiedPackageDetailsEnabled before this reads it.
	 * @param {Resolve} rejectIfNoPackages - Serialization dep: ensures bootstrap has populated AppData first
	 * @param {Object} $transition$ - UI-Router transition object
	 * @param {Service} $location - Angular location service
	 * @param {Service} AppData - Application data service
	 * @param {Service} RouteRejectionService - Route rejection and redirect service
	 * @param {Service} Utilities - Utilities service
	 * @returns {boolean|Promise} false to continue legacy; reroute promise to redirect to UPD
	 * @ngInject
	 */
	function isUPDEnabled(rejectIfNoPackages, $transition$, $location, AppData, RouteRejectionService, Utilities) {
		var params = $transition$.params();
		var from = $transition$.from();

		// Member Benefits only — PRD requires this entry point to remain on the legacy path.
		// flowType 'alternateEntry' is shared by many alternate modules; checking the previous
		// state name is more reliable than flowDetail (which may be a keyword/arbitrary value).
		if (/^cultural-member-benefits(\.|$)/.test(from.name)) {
			return false;
		}

		if (!AppData.unifiedPackageDetailsEnabled) {
			return false;
		}

		// promoCode: flowType==='promocode' puts the code in flowDetail (URL segment);
		// fall back to ?promoCode search param for direct /packageDetails/:packageId entries.
		// Guard params.flowDetail truthiness: a falsy flowDetail (e.g. empty string from a
		// malformed state.go call) should fall through to the search param, not pass '' to UPD.
		var promoCode = (params.flowType === 'promocode' && params.flowDetail)
			? params.flowDetail
			: ($location.search().promoCode || null);

		// preSelectedDate: params.date is not a declared param on any /packageDetails state today,
		// so this path is always null until a future story declares 'date' on those states.
		return RouteRejectionService.reroute(
			'unified-package-details.main',
			Utilities.merge({}, params, {
				preSelectedDate: params.date || null,
				promoCode: promoCode
			}),
			undefined,
			undefined,
			$transition$
		);
	}

	/**
	 * Checks if the package loading is a dynamically priced package and ensures we have dynamic pricing information passed
	 * Else we will reroute to the alternate module
	 * @param {Resolve} rejectIfNoPackages The rejectIfNoPackages resolve
	 * @param {Service} $transition$ - The Transition Service
	 * @param {Service} DynamicCapacityPricingService - The Dynamic Capacity Pricing Service
	 * @param {Service} RouteRejectionService - The Route Rejection Service
	 * @param {Service} Utilities - The Utilities Service
	 * @param {Service} UtilsValidation - The Utils Validation Service
	 * @throws {UnrecoverableException} Throws UnrecoverableException if redirecting
	 * @returns {Boolean} true if valid, throws exception otherwise
	 * @ngInject
	 */
	function checkForDynamicPackage(rejectIfNoPackages, $transition$, DynamicCapacityPricingService, RouteRejectionService, Utilities, UtilsValidation) {
		var params = $transition$.params(),
			route = null;

		// Did the module receive a valid dynamicPricing param? Or is the package not a dynamic pricing package?
		if (UtilsValidation.validObject(params.dynamicPricing) || !DynamicCapacityPricingService.isPackageDynamic(params.packageId)) {
			// Good route, exit
			return true;
		}

		// What alternate module is this package supposed to go through?
		route = DynamicCapacityPricingService.getAlternateEntryRoute(params.packageId);

		// Could we ascertain the alternate module route?
		if (route) {
			// Abort current transition and route to new one.
			$transition$.abort();
			return Utilities.goTo(route.stateName, route.params);
		}

		// Default -- redirect to base page
		throw new RouteRejectionService.UnrecoverableException('/');
	}

	/**
	 * Wraps checkForDynamicPackage with a dependency on isUPDEnabled, for the 3 states that declare it; the other 2 use checkForDynamicPackage directly.
	 * @param {Resolve} rejectIfNoPackages The rejectIfNoPackages resolve
	 * @param {Resolve} isUPDEnabled - Serialization dep: ensures the UPD redirect (if any) ran first
	 * @param {Service} $transition$ - The Transition Service
	 * @param {Service} DynamicCapacityPricingService - The Dynamic Capacity Pricing Service
	 * @param {Service} RouteRejectionService - The Route Rejection Service
	 * @param {Service} Utilities - The Utilities Service
	 * @param {Service} UtilsValidation - The Utils Validation Service
	 * @throws {UnrecoverableException} Throws UnrecoverableException if redirecting
	 * @returns {Boolean} true if valid, throws exception otherwise
	 * @ngInject
	 */
	function checkForDynamicPackageAfterUPDCheck(rejectIfNoPackages, isUPDEnabled, $transition$, DynamicCapacityPricingService, RouteRejectionService, Utilities, UtilsValidation) {
		return checkForDynamicPackage(rejectIfNoPackages, $transition$, DynamicCapacityPricingService, RouteRejectionService, Utilities, UtilsValidation);
	}
})();

!function(){"use strict";angular.module("unified-package-details",["app","components"])}(),function(){"use strict";angular.module("unified-package-details").constant("UnifiedPackageDetailsEnums",{routes:{MAIN:"unified-package-details.main"},steps:{DATE:"date",TIME:"time",QUANTITY:"quantity"},entryPoints:{CALENDAR:"calendar",PACKAGE_LIST:"packages"},charac:{UPD_FIRST_STEP:"upd_first_step",SHOW_CAPACITY_ON_TIMESLOT:"show_capacity_on_timeslot",DISPLAY_ZERO_CAPACITY:"display_zero_capacity",TIMEBLOCK_INTERVAL:"timeblock_interval",HIDE_PRICE:"hide_price",HIDE_PRICE_LABEL:"hide_price_label",UPD_TAG_KEYS:["upd_tag_1","upd_tag_2","upd_tag_3","upd_tag_4","upd_tag_5","upd_tag_6"],TAG_VARIANTS:{FILLED:"filled",ICON_LABEL:"icon-label"}},locale:{SECTION:"UnifiedPackageDetails",ADD_TO_CART:"addToCart",CHOOSE_DATE:"chooseDate",CHOOSE_TIME:"chooseTime",CHOOSE_QUANTITY:"chooseQuantity",CAPACITY_REMAINING:"capacityRemaining",SPOTS_REMAINING:"spotsRemaining",TIME_GROUP_MORNING:"timePeriodMorning",TIME_GROUP_AFTERNOON:"timePeriodAfternoon",TIME_GROUP_EVENING:"timePeriodEvening",TIME_SLOT_BEST_VALUE:"timeslotBestValue",STEP_NUMBER_1:"stepNumber1",STEP_NUMBER_2:"stepNumber2",STEP_NUMBER_3:"stepNumber3",EDIT_STEP:"stepEdit",EDIT_STEP_DATE:"stepEdit_date",EDIT_STEP_TIME:"stepEdit_time",EDIT_STEP_QUANTITY:"stepEdit_quantity",ABOUT_THIS_EXPERIENCE:"aboutThisExperience",WHATS_INCLUDED:"whatsIncluded",MORE_DETAILS:"moreDetails",PRICE_RETRY:"priceRetry",PRICE_FROM:"priceFrom",PRICE_FREE:"priceFree",CONFIRM_QUANTITY:"confirmQuantity",PRICE_TOTAL:"priceTotal",GUEST_SINGULAR:"guestSingular",GUEST_PLURAL:"guestPlural",DATE_SOLD_OUT:"dateSoldOut",MAX_AVAILABLE_FOR_DATE:"maxAvailableForDate",PRICE_TOTAL_FOR_SELECTION:"priceTotalForSelection",TICKET_COLUMN_HEADER_PREFIX:"ticketColumnHeader_",AT_GATE_ONLINE_HEADER:"atGateOnlineHeader",GUEST_LIMIT_TOOLTIP:"guestLimitTooltip",PKG_MAX_MSG:"pkgMaxMsg",MIN_QTY_MSG:"minQtyMsg",MIN_QTY_CT_MSG:"minQtyCtMsg",RATE_TYPE_MIN_QTY_MSG:"rateTypeMinQtyMessage",VARIABLE_PRICE_REQUIRED_ERROR:"variablePriceRequiredError",VARIABLE_PRICE_PATTERN_ERROR:"variablePricePatternError",VARIABLE_PRICE_MAX_ERROR:"variablePriceMaxErrorDescription",VARIABLE_PRICE_MIN_ERROR:"variablePriceMinErrorDescription"},dateAttribute:{OPEN:"0",DATE_TIME:"1",DATE_ONLY:"2"},ctaMode:{NONE:"none",CONTINUE:"continue",ADD_TO_CART:"addToCart"},stepAnimationMs:400,stepFallbackBufferMs:50,stepPauseMs:200})}(),function(){"use strict";function e(e,c){e.state("unified-package-details",{abstract:!0,title:"unifiedPackageDetails",resolve:{initialData:t,loadFiles:i}}).state("unified-package-details.main",{data:{pageBackground:"#F8F8F8"},url:"/packageDetails/:packageId",title:"unifiedPackageDetailsMain",components:[c.accessoCalendar,c.cartFeeNotice,c.mobileCta,c.skeleton],controller:"UnifiedPackageDetailsController",controllerAs:"vm",templateUrl:"unified-package-details:main",params:{dynamicPricing:{value:[]},flowDetail:{value:null},flowType:{value:null},preSelectedDate:{value:null},promoCode:{value:null},recommenderWizardKeyword:{squash:!0,value:null}},resolve:{autoForwardedFromSinglePackageList:n,prefetchAvailability:r,recommenderWizard:a,routeGuard:o}})}function a(e,a,t){var i=t.params();if(i.recommenderWizardKeyword&&i.packageId&&e.has("RecommenderWizardContextService")){var r=e.get("RecommenderWizardContextService");r.bootstrapWizard(i.recommenderWizardKeyword,"wizardPackageDetails")&&r.registerPackageDetails()}}function t(e){return e.bootstrapApplication(void 0,!0)}function i(e,a){return a.lazyLoadCollectionFiles(a.enums.UNIFIED_PACKAGE_DETAILS)}function r(e,a,t,i,r,n,o,c,l){var _=t.params();if(-1!==o.buildDefaultStepSequence(a).indexOf(r.steps.DATE)){var E=_.preSelectedDate;if(!E){var s=i.itemsToBeAdded&&i.itemsToBeAdded[0],d=s&&String(s.package_id)===String(_.packageId)&&c.checkProp("seedItem.CHARACS.0.start_date",s,"returnValue");l.isDateString(d)&&(E=d)}return n.prefetch(_.packageId,E).catch(angular.noop)}}function n(e,a){var t=e.from();if(!/packagelist/i.test(t.name||""))return!1;var i=a.dataModel.packageList;if(!i||1!==i.length)return!1;var r=void 0===i[0].length?i[0]:i[0][0];return!!r&&String(r.id)===String(e.params().packageId)}function o(e,a,t,i,r){if(!angular.isObject(a.GetMerchantPackageList))throw new t.UnrecoverableException("/");var n=r.getPackageByID(i.params().packageId);if(!n)throw new t.UnrecoverableException("/");return n}e.$inject=["$stateProvider","ComponentLoaderEnums"],a.$inject=["$injector","loadFiles","$transition$"],t.$inject=["Bootstrap"],i.$inject=["initialData","BundleService"],r.$inject=["loadFiles","routeGuard","$transition$","Package","UnifiedPackageDetailsEnums","UnifiedPackageDetailsAvailabilityService","UnifiedPackageDetailsService","Utilities","UtilsValidation"],n.$inject=["$transition$","PackageList"],o.$inject=["initialData","AppData","RouteRejectionService","$transition$","Package"],angular.module("unified-package-details").config(e)}();
'use strict';
angular.module('accesso-data-table', []);
'use strict';
angular
	.module('accesso-data-table')
	.controller('ChildrenController', function($scope, Language, Modal, Utilities) {
		// TODO: yuck
		$scope.i18n = Language;

		$scope.child = {
			name: '',
			birthDate: ''
		};
		$scope.isEditing = false;
		$scope.addChild = addChild;
		$scope.editChild = editChild;
		$scope.saveChildEdits = saveChildEdits;
		$scope.cancelChildEdits = cancelChildEdits;
		$scope.removeChild = removeChild;

		var _childIndex = 0;

		function addChild() {
			if (hasInvalidChildFields()) {
				Modal.displayModal({
					 category: 'Gift Membership',
					 action: 'Error',
					 label: 'Children Info',
					 title: Language.getLocale('GiftMembership', 'addChildErrorTitle'), //Also TODO: build directive to accept section and targets
					 description: Language.getLocale('GiftMembership', 'addChildErrorMsg')
				});
			} else if ($scope.children.length === $scope.attributes.max) {
				Modal.displayModal({
					 category: 'Gift Membership',
					 action: 'Error',
					 label: 'Children Info',
					 title: Language.getLocale('GiftMembership', 'maxNumChildrenErrorTitle'),
					 description: Language.getLocale('GiftMembership', 'maxNumChildrenErrorMsg')
				});
			} else {
				capitalizeName();

				$scope.children.push({
					name: $scope.child.name,
					birthDate: $scope.child.birthDate
				});

				resetChild();
			}
		}

		function editChild(child) {
			$scope.child.name = child.name;
			$scope.child.birthDate = child.birthDate;
			$scope.isEditing = true;

			_childIndex = $scope.children.indexOf(child);
		}

		function saveChildEdits() {
			if (hasInvalidChildFields()) {
				Modal.displayModal({
					 category: 'Membership Wizard',
					 action: 'Error',
					 label: 'Children Info',
					 title: Language.getLocale('GiftMembership', 'addChildErrorTitle'),
					 description: Language.getLocale('GiftMembership', 'addChildErrorMsg')
				});
			} else {
				capitalizeName();

				$scope.children[ _childIndex ].name = $scope.child.name;
				$scope.children[ _childIndex ].birthDate = $scope.child.birthDate;

				resetChild();
				$scope.isEditing = false;
			}
		}

		function cancelChildEdits() {
			resetChild();
			$scope.isEditing = false;
		}

		function removeChild(child) {
			var index = $scope.children.indexOf(child);
			$scope.children.splice(index, 1);

			resetChild();
			$scope.isEditing = false;
		}

		/******************************
			PRIVATE FUNCTIONS
		*******************************/
		function capitalizeName() {
			var parts = $scope.child.name.split(' ');
			var fixedName = '';

			parts.forEach(function(part, i) {
				fixedName += i > 0 ? (' ' + Utilities.capitalizeFirst(part)) : Utilities.capitalizeFirst(part);
			});

			$scope.child.name = fixedName;
		}

		function resetChild() {
			$scope.child.name = '';
			$scope.child.birthDate = '';
			$scope.isEditing = false;
		}

		function hasInvalidChildFields() {
			return Utilities.isEmpty($scope.accessoDataTable.name.$modelValue) || Utilities.isEmpty($scope.accessoDataTable.birthDate.$modelValue) ||
				$scope.accessoDataTable.name.$invalid || $scope.accessoDataTable.birthDate.$invalid;
		}
	});
'use strict';
angular
	.module('accesso-data-table')
	.directive('accessoDataTableDirective', function() {
		var config = {
			restrict: 'E',
			require: 'ngModel',
			name: 'controller',
			controller: '@',
			templateUrl: '/scripts/modules/accesso-data-table/views/accesso-data-table.html',
			link: link
		};

		function link(scope, elem, attrs) {
			scope.attributes = attrs;
		}

		return config;
	});
(function() {
	'use strict';
	angular.module('accesso-locale', []);
})();
(function() {
	'use strict';
	angular
		.module('accesso-locale')
		.factory('AccessoLocaleModels', function() {
			var factory = { ReplacementList: ReplacementList };

			function ReplacementList(search, replace, className) {
				this.list = [];

				if (angular.isDefined(search) && angular.isDefined(replace)) {
					this.add(search, replace, className);
				}
			}

			ReplacementList.prototype = {

				add: add,
				remove: remove,
				reset: reset
			};

			function add(search, replace, className) {
				// Do nothing if not given the required args
				if (angular.isUndefined(search) || angular.isUndefined(replace)) {
					return;
				}

				// Do nothing if replacement list already has given search key
				var alreadyHasSearch = this.list.some(hasSearch);

				if (alreadyHasSearch) {
					return;
				}

				if (angular.isDefined(className)) {
					this.list.push({
						search: search,
						replace: replace,
						class: className
					});
				} else {
					this.list.push({
						search: search,
						replace: replace
					});
				}

				function hasSearch(value) {
					return value.search === search;
				}
			}

			function remove(key) {
				this.list = this.list.filter(function(value) {
					return value.search !== key;
				});
			}

			function reset() {
				this.list.length = 0;
			}

			return factory;
		});
})();
(function() {
	'use strict';
	angular
		.module('accesso-locale')
		.directive('accessoLocale', function($compile, $interpolate, AppData, Enums, Language, Utilities, UtilsValidation) {
			var config = {
				restrict: 'A',
				link: function(scope, elem, attrs) {
					var deregisterListener,
						interpolateListener,
						getLocale = function() {
							return attrs.accessoLocale;
						},
						getReplace = function() {
							return attrs.replace;
						};

					elem = angular.element(elem[0]);

					// If Shopland is already activated, no need to wait
					if (Utilities.getBoolean(AppData.applicationActivated)) {
						processLocale(attrs.accessoLocale);
						scope.$watch(getLocale, processLocale);
						scope.$watch(getReplace, function() {
							processLocale(attrs.accessoLocale);
						});
					// This would only occur on load - wait for event then process
					} else {
						deregisterListener = scope.$on(Enums.services.APP_ACTIVATED, function() {
							processLocale(attrs.accessoLocale);
							scope.$watch(getLocale, processLocale);
							scope.$watch(getReplace, function() {
								processLocale(attrs.accessoLocale);
							});
							deregisterListener();
						});
					}

					function processLocale(accessoLocale) {
						var localeParts,
							suffix,
							locale;

						if (!accessoLocale) {
							return updateElement('');
						}

						localeParts = accessoLocale.split('.');
						suffix = localeParts[2] ? localeParts[2].trim() : '';
						locale = '';

						if (suffix.length === 0 && UtilsValidation.validString(AppData.settings.merchant_locale_suffix)) {
							suffix = AppData.settings.merchant_locale_suffix;
						}

						locale = Language.getLocaleWithSuffixAndFallback(localeParts[0].trim(), localeParts[1].trim(), suffix);

						// This is how we can identify a missing locale because Language.getLocale will return an empty string only if we are not in debug mode
						if (Utilities.isEmpty(locale) && Utilities.getBoolean(attrs.hideIfMissing)) {
							elem.addClass('v5-hide');
						} else {
							elem.removeClass('v5-hide');
							handleReplacements(locale);
							handleInteractiveLocale(locale);
						}
					}

					/**
					 * Looks for anchor tag on locale, if there is, then we will handle that anchor tag with data-ng-click
					 * This logic comes from interactive-locale directive
					 * @protected
					 * @param {string} locale
					 * @returns {undefined}
                     */
					function handleInteractiveLocale(locale) {
						if (Utilities.getBoolean(attrs.interactive) && UtilsValidation.validString(locale)) {
							var i = locale.indexOf('<a href="event:'),
								j,
								funcName = '',
								newLocaleVal = '';

							if (i !== -1) {
								j = locale.indexOf('">', i + 6);

								// Extract the function name.
								funcName = locale.substring(i + 15, j);

								// Add Angular specific code.
								newLocaleVal = locale.substring(0, i) + '<a class="cursor" data-ng-click="' + funcName + '()"' + locale.substring(j + 1);

								// Update the val string which will be used to set the HTML content of the element.
								locale = newLocaleVal;
								elem.html(locale);
								$compile(elem.contents())(scope);
							}
						}
					}

					function handleReplacements(locale) {
						if (angular.isDefined(attrs.replace)) {
							processStaticReplacements(locale, attrs.replace);
						} else if (angular.isDefined(attrs.dynamicReplace)) {
							processDynamicReplacements(locale, attrs.dynamicReplace);
						} else {
							updateElement(locale);
						}
					}

					function processStaticReplacements(locale, replacements) {
						replacements = JSON.parse(replacements);

						for (var i=0; i < replacements.length; i++) {
							if (angular.isDefined(replacements[i].class)) {
								replacements[i].replace = addClass(replacements[i].class, replacements[i].replace);
							}

							locale = locale.replace(new RegExp(replacements[i].search, 'g'), replacements[i].replace);
						}

						updateElement(locale);
					}

					function processDynamicReplacements(locale, replacements) {
						replacements = JSON.parse(replacements);

						var interpolateFunctions = replacements.map(function(replacement) {
							return $interpolate(replacement.replace);
						});

						// If we've already subscribed, free the previous one.
						if (interpolateListener) {
							interpolateListener();
						}

						interpolateListener = scope.$watchGroup(interpolateFunctions, function(newVal, oldVal) {
							var localeCopy = angular.copy(locale);

							for (var i=0; i < replacements.length; i++) {
								if (angular.isDefined(replacements[i].class)) {
									newVal[i] = addClass(replacements[i].class, newVal[i]);
								}

								localeCopy = localeCopy.replace(new RegExp(replacements[i].search, 'g'), newVal[i]);
							}

							updateElement(localeCopy);
						});
					}

					function updateElement(locale) {
						if (Utilities.getBoolean(attrs.trustHtml)) {
							elem.html(locale);
						} else {
							elem.text(locale);
						}
					}

					function addClass(className, value) {
						return '<span class="' + className + '">' + value + '</span>';
					}
				}
			};

			return config;
		});
})();
(function() {
	'use strict';
	angular
		.module('agreement', ['package-agreement'])
		.config(function($locationProvider, $stateProvider) {
			var AGREEMENTS_MODULE = '/scripts/modules/agreement/';
			$stateProvider
				.state('/agreementView', {
					controller: 'AgreementController',
					resolve: {
						initialData: function(Bootstrap) {
							return Bootstrap.bootstrapApplication();
						},
						load: function(initialData, $rootScope, Utilities) {
							$rootScope.showSpinner();

							return Utilities.cacheBustAndLazyLoad([
								AGREEMENTS_MODULE + 'controllers/agreement-controller.js',
								AGREEMENTS_MODULE + 'services/agreement-service.js'
							]);
						},
						initializeAgreement: function(load, $injector, RouteRejectionService) {
							var AgreementService = $injector.get('AgreementService');
							if (AgreementService.skipAgreementForm()) {
								throw new RouteRejectionService.UnrecoverableException('/orderReview');
							} else {
								return AgreementService.initialize();
							}
						},
						customAgreementFormData: function(initializeAgreement, $injector) {
							return $injector.get('AgreementService').getCustomAgreementFormData();
						}
					},
					templateUrl: AGREEMENTS_MODULE + 'views/agreement.html',
					url: '/agreementView'
				})
				.state('preCartAgreementView', {
					controller: 'PreCartAgreementController',
					resolve: {
						initialData: function(Bootstrap) {
							return Bootstrap.bootstrapApplication();
						},
						load: function(initialData, $rootScope, Utilities) {
							$rootScope.showSpinner();

							return Utilities.cacheBustAndLazyLoad([
								AGREEMENTS_MODULE + 'controllers/pre-cart-agreement-controller.js',
								AGREEMENTS_MODULE + 'services/agreement-service.js'
							]);
						},
						initializeAgreement: function(load, $injector) {
							var AgreementService = $injector.get('AgreementService');
							if (AgreementService) {
								return AgreementService.initialize();
							}
						},
						customAgreementFormData: function(initializeAgreement, $injector) {
							return $injector.get('AgreementService').getCustomAgreementFormData();
						}
					},
					templateUrl: AGREEMENTS_MODULE + 'views/pre-cart-agreement.html',
					url: '/preCartAgreementView'
				});
		})
		.run(function(AgreementBootstrapService) {});
})();
angular.module( 'agreement' )
	.service('AgreementService', function(
		$filter,
		$log,
		$sce,
		$timeout,
		AppData,
		AgreementsUtils,
		CartDataService,
		CartItemHydrateModel,
		CartService,
		CustomActionService,
		DataModelService,
		Enums,
		RouteRejectionService,
		JSONValidator,
		Language,
		Modal,
		Package,
		$q,
		$rootScope,
		UserInfo,
		Utilities,
		UtilsValidation
		){
			var isObject = UtilsValidation.isRealObject,
				validString = UtilsValidation.validString,
				validArray = UtilsValidation.validArray,
				checkProp = Utilities.safelyCheckPropertyOnObject,
				isArray = Array.isArray,
				agreementConsented = false,
				wrapObjectToArray = Utilities.wrapObjectToArray,
				firstPaymentScheduleAmount,
				_formDetails = null;
				_agreementData = null,
				_cartFormData = null,
				_customFormAgreementData = null;

			var service = {
				MAX_PAYMENTS: 6,
				TILA: 'tilaTerms',
				TILA_MEMBERSHIP: 'tilaTermsMembership',
				TILA_THRESHOLD: 6,
				BNPL: 'bnplTerms',
				MEM: 'memTerms',
				EASY: 'easyPayTerms',
				ORDER_DATA: null,
				paymentSchedule: false,
				dataModel: null,
				formData: '',
				tilaOverride: false,
				hasConvertedToMultiPacks: false,
				customAgreementForms: [],
				_savedFormIds: [],
				addForms: addForms,
				deleteForms: deleteForms,
				fetchSavedForms: fetchSavedForms,
				routeGuard: routeGuard,
				updateForms: updateForms,
				/**
				 * Set service values that are read from AppData.
				 */
				initialize: function() {
					service.tilaOverride = Utilities.getBoolean( AppData.settings.tila_override );
					service.bnplFormName = AppData.settings.bnpl_terms_form_name;
					service.easyPayFormName = AppData.settings.easypay_terms_form_name;
					service.tilaFormName = AppData.settings.tila_terms_form_name;
					service.membershipsFormName = AppData.settings.membership_terms_form_name;
					service.tilaSettings = JSONValidator.validate('tila', AppData.settings.tila)
						? JSON.parse(AppData.settings.tila)
						: {};
					service.tilaMembershipSettings = JSONValidator.validate('tila_membership', AppData.settings.tila_membership)
						? JSON.parse(AppData.settings.tila_membership)
						: {};


					// If the store requires the tila terms to show for a lower minimum
					if (checkProp('tila.minimum_payments.threshold', service.tilaSettings)) {
						service.TILA_THRESHOLD = service.tilaSettings.minimum_payments.threshold;
					}
				},
				storeFormData: function(dataModel, customFormAgreementData) {
					var tilaMembershipSettings,
						formsToAdd = [],
						formsToUpdate = [],
						formsToDelete = [],
						saveFailed = false;

					// If we're trying to save a main form such as TILA, Payment Plan, or Membership Agreement, etc
					if (dataModel) {
						// If we had an original form and that form ID does not match the current one, we need to delete the old one
						if (_cartFormData) {
							if (_cartFormData.id !== dataModel.id) {
								formsToDelete.push({
									cart_id: AppData.cart.cart_id,
									cart_key: AppData.cart.cart_key,
									form_id: _cartFormData.id
								});
							}
						}

						// I'm leaving this here as it was previously here and not sure what it's used for...
						if (this.useMembershipTila()) {
							tilaMembershipSettings = this.getMembershipTilaSettings();
							dataModel.tilaMembership = 1;
							if (checkProp('tilaMembershipSettings.addAgreementField', tilaMembershipSettings, validString)) {
								dataModel.addAgreementField = tilaMembershipSettings.addAgreementField;
							}
							if (checkProp('tilaMembershipSettings.showTodaysPayment', tilaMembershipSettings)) {
								dataModel.showTodaysPayment = Utilities.getBoolean(tilaMembershipSettings.showTodaysPayment) ? 1 : 0;
							}
						}

						dataModel.extraData = dataModel.extraData || {};
						dataModel.extraData.internalPaymentScheduleAmount = service.getPaymentScheduleAmount();


						// Finally, we need to add it to the forms to add/update to get sent to backend
						(service._savedFormIds.includes(dataModel.id) ? formsToUpdate : formsToAdd).push({
							form_id: dataModel.id,
							form_data: JSON.stringify(dataModel),
							cart_id: AppData.cart.cart_id
						});

						// Save it back on the main property
						service.setCartFormData(dataModel);
					}

					// If we are trying to save custom agreement forms...
					if (validArray(customFormAgreementData)) {
						// Add each new custom agreement to the forms to send to backend
						customFormAgreementData.forEach(function addCustomAgreementsToSave(form) {
							(service._savedFormIds.includes(form.id) ? formsToUpdate : formsToAdd).push({
								form_id: form.id,
								form_data: JSON.stringify(form),
								cart_id: AppData.cart.cart_id
							});
						});

						_customFormAgreementData = customFormAgreementData;
					}

					// Resolves true only if every add/update returned OK, so recorded forms can fail closed.
					return $q(function(resolve) {
							if (formsToDelete.length) {
								return service.deleteForms(formsToDelete).then(resolve).catch(resolve);
							}
							resolve();
						})
						.then(function() {
							if (formsToUpdate.length) {
								return service.updateForms(formsToUpdate).then(trackSaveResult);
							}
						})
						.then(function thenAddUpdateForms() {
							if (formsToAdd.length) {
								return service.addForms(formsToAdd).then(trackSaveResult);
							}
						})
						.then(function() {
							return !saveFailed;
						});

					function trackSaveResult(resp) {
						if (!resp || resp.status !== Enums.status.OK) {
							saveFailed = true;
						}
					}
				},

				setDataModel: function(dataModel) {
					_agreementData = dataModel;
				},
				getDataModel: function() {
					return angular.copy(_agreementData);
				},
				clearDataModel: function() {
					_agreementData = null;
				},

				setFormDetails: function(formDetails) {
					_formDetails = formDetails;
				},
				getFormDetails: function() {
					return angular.copy(_formDetails);
				},

				setCartFormData: function(dataModel) {
					_cartFormData = dataModel;
				},
				getCartFormData: function() {
					return angular.copy(_cartFormData);
				},
				clearCartFormData: function(skipBackendClear) {
					var formId;

					if (checkProp('data.id', _cartFormData)) {
						formId = _cartFormData.id;
					}

					_cartFormData = null;

					// Reset the consent status for the payment plan agreement (membership, tila, etc)
					service.setUserAgreementConsentStatus(false);
					service.setFirstPaymentScheduleAmount(undefined);

					if (!skipBackendClear && formId) {
						return service.deleteForms([{
							cart_id: AppData.cart.cart_id,
							cart_key: AppData.cart.cart_key,
							form_id: formId
						}]);
					}
				},

				getCustomFormData: function() {
					return angular.copy(_customFormAgreementData);
				},
				setCustomFormData: function(data) {
					_customFormAgreementData = data;
				},
				clearCustomFormData: function(skipBackendClear) {
					var forms = [];

					// If we don't want to clear the backend (e.g. we just purchased and we get a new cart id so there's no need to)
					if (!skipBackendClear && validArray(_customFormAgreementData)) {
						forms = _customFormAgreementData.map(function mapFormIds(form) {
							return {
								cart_id: AppData.cart.cart_id,
								cart_key: AppData.cart.cart_key,
								form_id: form.id
							};
						});
					}

					_customFormAgreementData = null;

					// Set our custom agreement forms back to has not consented
					if (validArray(service.customAgreementForms)) {
						service.customAgreementForms.forEach(function setToNotConsented(form) {
							form.resetAgreementStatus();
						});
					}

					if (!skipBackendClear && forms.length) {
						return service.deleteForms(forms);
					}
				},

				reset: function() {
					// This or service.
					service.paymentSchedule = false;
					service.formData = '';
				},

				showContract: function() {
					var cartSummary = CartDataService.getLastSummary();

					if (this.hasTermsForm() && cartSummary.paymentSchedule.schedule.length) {
						return cartSummary.paymentSchedule.schedule.length >= this.MAX_PAYMENTS || this.showForm();
					}
				},

				/**
				 * Find out if we should override the default membership agreement with a tila membership.
				 * @public
				 * @function
				 * @returns {Boolean} if we should use tila memberships
				 */
				useMembershipTila: function() {
					return UtilsValidation.validString(this.tilaMembershipSettings.formName);
				},

				/**
				 * Returns the Tila membership settings.
				 * @public
				 * @function
				 * @returns {Object} The tila membership settings.
				 */
				getMembershipTilaSettings: function() {
					return angular.copy(this.tilaMembershipSettings);
				},

				hasTermsForm: function() {
					return (this.bnplFormName || this.easyPayFormName || this.tilaFormName || this.membershipsFormName);
				},
				getAgreementsConfig: function () {
					return JSONValidator.validate('agreement_form', AppData.settings.agreement_form) ? JSON.parse(AppData.settings.agreement_form) : {};
				},
				getPaymentPlanType: function() {
					var cartSummary = CartDataService.getLastSummary();

					if (cartSummary.paymentSchedule.schedule.length > 0) {
						// Get the type of payment plan we are currently dealing with.
						if (cartSummary.paymentSchedule.schedule.length >= this.MAX_PAYMENTS &&
							!tilaOverride) {
							return TILA;
						} else if (cartSummary.paymentSchedule.schedule.length < this.MAX_PAYMENTS) {
							for (var i = 0; i < cartSummary.cart.items.length; i++) {
								var item = cartSummary.cart.items[i];
								if (item.characs.XMC_NAME_ATTRIBUTE.indexOf('paylater') > -1 ||
									item.characs.XMC_NAME_ATTRIBUTE.indexOf('plpromo') > -1) {
									return BNPL;
								}
							}
						}
					} else if (cartSummary.futurePayments.payments.length > 0) {
						// TODO: Why is this button hidden? Hidden due to TT 12088
						//cancelBtn.includeInLayout = false;
						//cancelBtn.visible = false;
						return MEM;
					}

					// Default value.
					return EASY;
				},

				showForm: function() {
					var cartSummary = CartDataService.getLastSummary();
					var originalPrice = 0;
					var retailPrice = 0;

					if (cartSummary.futurePayments.payments.length) {
						return false;
					}

					for (var i = 0; i < cartSummary.cart.items.length; i++) {
						var item = cartSummary.cart.items[i];

						if (item.characs.length && item.characs[0].client_original_price) {
							retailPrice = Number(item.retail_price);
							originalPrice = Number(item.characs[0].client_original_price);

							if (retailPrice > originalPrice) {
								return true;
							}
						}
					}

					return false;
				},
				clearDuplicateCustomAgreementForms: function(duplicateForms) {
					duplicateForms.forEach(function(duplicateForm) {
						var matchedDuplicateFormIndex = service.customAgreementForms.findIndex(function(form) {
							return !form.hasOwnProperty('multiPackageCustomAgreement') && form.formName === duplicateForm.name && form.associatedCartItemCharacValue === duplicateForm.value && form.associatedCartItemCharacName === duplicateForm.charac;
						});
						if (matchedDuplicateFormIndex !== undefined) {
							service.customAgreementForms.splice(matchedDuplicateFormIndex, 1);
						}
					});
				},
				convertCurrentCartCustomAgreementToMultipPackCustomAgreement: function() {
					var configuredCustomForms = service.customAgreementForms;
					var duplicateForms = [];
					if (service.hasConvertedToMultiPacks) {
						return;
					}
					configuredCustomForms = configuredCustomForms.reduce(function(acc, form) {
						var foundForm = acc.find(function(frm) {
							return frm.formName === form.formName;
						});

						if (!foundForm) {
							acc.push(form);
						} else {
							// If we found a form, mark it as a multi package custom agreement form and hold the characs and their values in there
							if (!isObject(foundForm.multiPackageCustomAgreement)) {
								foundForm.multiPackageCustomAgreement = {};

								// put the current one in since we're creating it
								foundForm.multiPackageCustomAgreement[foundForm.associatedCartItemCharacName] = wrapObjectToArray(foundForm.associatedCartItemCharacValue);
							}

							// Always make sure its an array so we dont have to check for both strings and arrays.
							if (!isArray(foundForm.multiPackageCustomAgreement[form.associatedCartItemCharacName])) {
								foundForm.multiPackageCustomAgreement[form.associatedCartItemCharacName] = []
							}
							duplicateForms.push({
								name: form.formName,
								charac: form.associatedCartItemCharacName,
								value: form.associatedCartItemCharacValue
							});
							foundForm.multiPackageCustomAgreement[form.associatedCartItemCharacName].push(form.associatedCartItemCharacValue);
						}

						return acc;
					}, []);
					service.hasConvertedToMultiPacks = true;
					this.clearDuplicateCustomAgreementForms(duplicateForms);
				},
				deleteDeferredPackagesFromCart: function deleteDeferredPackagesFromCart() {
					var cartItems = CartService.getCartItems(),
						cartLength = cartItems.length;

					// No Items to filter through
					if (!validArray(cartItems)) {
						// Exit
						return;
					}

					cartItems = cartItems.filter(function filterDeferredPackages(item) {
						return !item.characs.some(function filterDeferredPackagesCharacs(charac) {
							return Utilities.getString(charac.extra_movie).indexOf('paylater') > -1;
						});
					});

					// If the cart length is different from the cart items length
					if (cartLength !== cartItems.length) {
						// Update the cart items
						CartService
							.updateItems(cartItems)
							.finally(function onSuccess() {
								Utilities.goTo(Enums.routes.CART_VIEW);
							});

						// Exit
						return;
					}

					// Route to the cart view
					Utilities.goTo(Enums.routes.CART_VIEW);
				},
				deleteMembershipPackagesFromCart: function deleteMembershipPackagesFromCart() {
					var cartItems = CartService.getCartItems(),
						cartLength = cartItems.length,
						groups = [];

					// No Items to filter through
					if (!validArray(cartItems)) {
						// Exit
						return;
					}

					// Filter through the cart items
					cartItems = cartItems
						// Find the main items and remove them from the array
						.filter(function filterMembershipPackages(item) {
							// Is the item a membership payment plan type?
							if (item.flags.hasPaymentPlan && item.paymentPlan.type === 'MEM') {
								// Is the item a one barcode item and is it not in the groups array?
								if (item.flags.isOneBarcode && !groups.includes(item.oneBarcode.group)) {
									// Add the group to the groups array
									groups.push(item.oneBarcode.group);
								}

								// Return false to remove the item from the array
								return false;
							}

							// Return true to keep the item in the array
							return true;
						})
						.filter(function filterOneBarcodeItems(item) {
							// Return if the item if it's not a one barcode item or if it's a one barcode item and it's not in the groups array
							return !item.flags.isOneBarcode || !groups.includes(item.oneBarcode.group);
						});

					// If the cart length is different from the cart items length
					if (cartLength !== cartItems.length) {
						// Update the cart items
						CartService
							.updateItems(cartItems)
							.finally(function onSuccess() {
								Utilities.goTo(Enums.routes.CART_VIEW);
							});

						// Exit
						return;
					}

					// Route to the cart view
					Utilities.goTo(Enums.routes.CART_VIEW);
				},
				/** LIST is a path, not a ui-router state, so it routes with routeTo */
				deleteCustomFormItemsFromCart: function deleteCustomFormItemsFromCart(agreementForm) {
					var cartItems = CartService.getCartItems(),
						matchingItems = validArray(cartItems) ? service.getMatchingCartItemsForCustomAgreementForm(agreementForm, cartItems) : [];

					agreementForm.resetAgreementStatus();
					if (!validArray(matchingItems)) {
						Utilities.routeTo(Enums.routes.LIST);
						return;
					}

					CartService
						.updateItems(cartItems.filter(function keepNonMatching(item) {
							return !matchingItems.includes(item);
						}))
						.finally(function onComplete() {
							Utilities.routeTo(Enums.routes.LIST);
						});
				},
				/**
				 * Does the cart have additional agreement form identifiers
				 */
				doesCartItemsHaveCustomAgreementFormIdentifiers : function() {
					var hasIdentifiers = false,
						i,
						agreementFormsConfig = this.getAgreementsConfig();
					var nonConsentedAgreementForms = service.customAgreementForms.filter(function(form) {
						return !isConsentCurrent(form);
					});
					if (!agreementFormsConfig.showCustomAgreementsBeforeCart) {
						nonConsentedAgreementForms = service.customAgreementForms;
					}
					for(i = 0; i < nonConsentedAgreementForms.length && !hasIdentifiers; i++){
						var customAgreementForm = nonConsentedAgreementForms[i];
						if (CartDataService.api.totalQty) {
							hasIdentifiers = doesCartHaveCustomAgreementFormForForm(customAgreementForm);
						}
					}

					return hasIdentifiers;
				},
				getCustomAgreementFormsForCurrentCart : function(){
					var agreementFormsConfig = this.getAgreementsConfig();
					return service.customAgreementForms
						.filter(function(form) {
							return agreementFormsConfig.showCustomAgreementsBeforeCart ? !isConsentCurrent(form) : true;
						})
						.filter(function(frm){
							return doesCartHaveCustomAgreementFormForForm(frm);
						});
				},
				getCustomAgreementFormsForUpdatedCart : function(){
					return service.customAgreementForms
						.filter(function(frm){
							return doesCartHaveCustomAgreementFormForForm(frm);
						});
				},
				requestCustomAgreementData: function(agreement) {
					return AppData.fetch(Enums.services.GET_FORM, false, {
						cart_id: AppData.cart.cart_id,
						cart_key: AppData.cart.cart_key,
						form_name: agreement.formName,
						language: AppData.language
					});
				},
				getCustomAgreementFormData : function() {
					var cartSummary,
						customAgreementPromisesResult = [],
						requestFormData,
						deferred,
						configuredCustomForms,
						promiseChain,
						agreementFormsConfig = this.getAgreementsConfig();
					$rootScope.showSpinner(Language.getLocale('ApplicationLabels', 'loadingAgreementMsg'));
					if (!agreementFormsConfig.showCustomAgreementsBeforeCart) {
						//doing a fresh request, only if custom agreements are displayed before order review
						service.clearCustomFormData();
					}
					deferred = $q.defer();
					configuredCustomForms = service.getCustomAgreementFormsForCurrentCart();

					if (isArray(configuredCustomForms)) {
						// Make sure we're not requesting multiple of the same form
						configuredCustomForms = configuredCustomForms.reduce(function(acc, form) {
							var foundForm = acc.find(function(frm) {
								return frm.formName === form.formName;
							});

							if (!foundForm) {
								acc.push(form);
							} else {
								// If we found a form, mark it as a multi package custom agreement form and hold the characs and their values in there
								if (!isObject(foundForm.multiPackageCustomAgreement)) {
									foundForm.multiPackageCustomAgreement = {};

									// put the current one in since we're creating it
									foundForm.multiPackageCustomAgreement[foundForm.associatedCartItemCharacName] = [foundForm.associatedCartItemCharacValue];
								}

								// Always make sure its an array so we dont have to check for both strings and arrays.
								if (!isArray(foundForm.multiPackageCustomAgreement[form.associatedCartItemCharacName])) {
									foundForm.multiPackageCustomAgreement[form.associatedCartItemCharacName] = []
								}

								foundForm.multiPackageCustomAgreement[form.associatedCartItemCharacName].push(form.associatedCartItemCharacValue);
							}

							return acc;
						}, []);
					}

					if(configuredCustomForms.length > 0) {
						requestFormData = (function(customAgreement) {
							return this.requestCustomAgreementData(customAgreement);
						}).bind(this);
						promiseChain = configuredCustomForms.reduce(function(accPromise, customAgreement) {
							return accPromise.then(function(result) {
								if (result) {
									customAgreementPromisesResult.push(result);
								}
								return requestFormData(customAgreement);
							});
						}, $q.resolve());
						promiseChain.then(function(result) {
							customAgreementPromisesResult.push(result);
							return mergeMissingUpfrontPackages(configuredCustomForms);
						}).then(function() {
							customAgreementPromisesResult.forEach(function(data, formIndex) {
								if (data.status === Enums.status.OK && Utilities.safelyCheckPropertyOnObject('data.FORM.F', data)) {
									configuredCustomForms[formIndex].fillFormData(data.FORM.id, data.FORM.version, data.FORM.F);
									if (configuredCustomForms[formIndex].recordAcceptance && !renderUpfrontRates(configuredCustomForms[formIndex])) {
										service.clearCustomFormData();
										deferred.reject(new RouteRejectionService.ViewException());
									}
								} else {
									logSetupDebug('GetForm for "' + configuredCustomForms[formIndex].formName + '" returned no form fields', {status: data.status});
									service.clearCustomFormData();
									deferred.reject(new RouteRejectionService.ViewException());
								}
							});
							deferred.resolve(configuredCustomForms);
						}).catch(function() {
							service.clearCustomFormData();
							deferred.reject(new RouteRejectionService.ViewException());
						});
					} else {
						cartSummary = CartDataService.getLastSummary();

						if (!cartSummary.info.hasPaymentSchedule && !service.doesCartItemsHaveCustomAgreementFormIdentifiers()) {
							service.clearCustomFormData();
							deferred.reject(new RouteRejectionService.UnrecoverableException('/' + Enums.routes.CART, {}));
						} else {
							deferred.resolve(configuredCustomForms);
						}
					}
					return deferred.promise;
				},
				getMatchingCartItemsForCustomAgreementForm : function(customAgreementForm, cartItems) {
					cartItems = validArray(cartItems) ? cartItems : CartDataService.getLastSummary().cart.items;

					return cartItems.filter(function(item){return item.characs.some(
							function(charac) {
								return characMatchesAgreementForm(charac, customAgreementForm);
							}
						)});
				},
				/** The payment schedule id of the upfront membership items in the cart, or undefined when there are none */
				getUpfrontPaymentScheduleId: function getUpfrontPaymentScheduleId(cartItems) {
					var scheduleIds = Utilities.toArray(cartItems)
						.filter(function isUpfrontItem(item) {
							return validArray(item.characs) && item.characs.some(function(charac) {
								return Utilities.getBoolean(charac.is_upfront_membership);
							});
						})
						.map(function toScheduleId(item) {
							return isObject(item.paymentPlan) ? item.paymentPlan.id : undefined;
						})
						.filter(function hasScheduleId(id) {
							return angular.isDefined(id) && id !== null;
						});

					return scheduleIds[0];
				},
				getUpfrontRateValues: getUpfrontRateValues,
				/** True when every payment-plan item is covered by a custom form that replaces the payment-plan agreement */
				skipPaymentPlanForms: function skipPaymentPlanForms() {
					var cartItems = CartService.getCartItems(),
						skippedItems;

					if (!validArray(cartItems)) {
						return false;
					}
					skippedItems = service.customAgreementForms
						.filter(function(form) {
							return form.skipPaymentPlanForms;
						})
						.reduce(function(items, form) {
							return items.concat(service.getMatchingCartItemsForCustomAgreementForm(form, cartItems));
						}, []);

					return validArray(skippedItems) && cartItems.every(function(item) {
						return !item.flags.hasPaymentPlan || skippedItems.includes(item);
					});
				},
				hasExemptPaymentPlanForms: function hasExemptPaymentPlanForms() {
					return !CartService.getCartItems().some(function(item) {
						return item.hasPaymentPlan && !getBoolean(item.characs[0].is_exempt_from_paymentplan_forms);
					});
				},
				/**
			 * Skip Agreement Form - the form will be skipped if the agreement_form config is added with package
			 * properties that we want to used to determine if the package has form or not
			 * Then check selected auth type is matched with the one on package charac
			 * @function
			 * @public
			 * @return {boolean} should we skip the form or not
			 */
			skipAgreementForm: function() {
				var cartItems = CartDataService.getLastSummary().cart.items,
					authType = checkProp('UserInfo.payment.authType', UserInfo) ? UserInfo.payment.authType.toLowerCase() : '',
					agreementFormsConfig,
					formCharacs,
					totalSkippedAgreementPackages = 0,
					hidingAuthTypeTypesArray = [],
					shouldSkip = false,
					requiredFormPackages;

				if (JSONValidator.validate('agreement_form', AppData.settings.agreement_form)){
					agreementFormsConfig = JSON.parse(AppData.settings.agreement_form);
					if (!validString(agreementFormsConfig.skip_agreement_form)) {
						return false;
					}
					formCharacs = agreementFormsConfig.skip_agreement_form.split(',');
					requiredFormPackages = cartItems.filter(function(item) {
						return formCharacs.some(function(charac) {
							return DataModelService.convert(item, CartItemHydrateModel).hasOwnProperty(charac);
						});
					});
					requiredFormPackages.forEach(function(cartItem) {
						var packageDetails = Package.getPackageByID(cartItem.package.id);
						if (Utilities.safelyCheckPropertyOnObject('packageDetails.CHARACS.skip_using_auth_type', packageDetails, validString)) {
							hidingAuthTypeTypesArray = packageDetails.CHARACS.skip_using_auth_type.split(',');
							shouldSkip = hidingAuthTypeTypesArray.some(function(type) {
								return type.toLowerCase() === 'all' || type.toLowerCase() === authType;
							});
							if (shouldSkip) {
								totalSkippedAgreementPackages++;
							}
						}
					});
					return totalSkippedAgreementPackages > 0 && totalSkippedAgreementPackages === requiredFormPackages.length;
				}
				return false;
			},
			/**
			 * Return the number of scheduled payments
			 * @public
			 * @returns {Number} number of payment schedules
			 */
			getNumOfPayments: function() {
				var cartSummary = CartDataService.getLastSummary();

				return cartSummary.info.hasPaymentSchedule ? cartSummary.paymentSchedule.schedule.length : 0;
			},
			/**
			 * Return the form type
			 * @public
			 * @returns {String} return form type
			 */
			getFormType: function() {
				var cartSummary = CartDataService.getLastSummary(),
					type = '',
					isStandard = (service.getNumOfPayments() < service.MAX_PAYMENTS) && !service.tilaOverride;
				if (!Utilities.getBoolean(AppData.settings.tila_override) && service.showContract()) {
					type = service.TILA;
				} else if (service.getNumOfPayments() < service.MAX_PAYMENTS) {
					cartSummary.cart.items.forEach(function iterateThroughCartItems(cartItem) {
						cartItem.characs.forEach(function iterateThroughCharacs(cartItemCharac) {
							if (cartItemCharac.client_xfc_name && cartItemCharac.client_xfc_name.indexOf('paylater') > -1 ||
								cartItemCharac.payment_plan && cartItemCharac.payment_plan.toLowerCase().indexOf('paylater') > -1 ||
								cartItemCharac.extra_movie && cartItemCharac.extra_movie.indexOf('plpromo') > -1) {
								type = service.BNPL;
							}
						});
					});
				}

				if (cartSummary.info.hasFuturePayments) {
					type = service.MEM

					if (service.useMembershipTila()) {
						type = service.TILA_MEMBERSHIP;
					}
				}

				// We'll, default to Easypay if we dont know what it is by now.
				if (service.tilaOverride || (isStandard && type === '')) {
					type = service.EASY;
				}

				return type;
			},

			/**
			 * Returns the form name
			 * @public
			 * @returns {String} returns form name
			 */
			getFormName: function() {
				// Get the config based on the form type.
				switch (service.getFormType()) {
				case service.TILA:
					return service.tilaFormName;
				case service.TILA_MEMBERSHIP:
					return service.getMembershipTilaSettings().formName;
				case service.BNPL:
					return service.getFormNameUsingThreshold('BNPL', service.bnplFormName);
				case service.MEM:
					return service.getFormNameUsingThreshold('MEMBERSHIP', service.membershipsFormName);
				case service.EASY:
					return service.getFormNameUsingThreshold('EASYPAY', service.easyPayFormName);
				}

				return '';
			},

			/**
			 * Checks against the Minimum Payments Threshold to determine if we need to swap the form to be loaded.
			 * @public
			 * @param {String} formType the original type of form
			 * @param {String} defaultFormName if there is no configuration, use the provided default
			 * @returns {String} The form name to use
			 */
			getFormNameUsingThreshold: function(formType, defaultFormName) {
				var formMappings = checkProp('tila.minimum_payments.form_mapping', service.tilaSettings, 'returnValue') || [];
				var replacementForm;

				if (validString(formType) && service.getNumOfPayments() >= service.TILA_THRESHOLD) {
					replacementForm = formMappings.find(function findMap(i) { return i.original_form_type === formType; });
				}

				return replacementForm ? replacementForm.tila_form_name : defaultFormName;
			},

			/**
			 * Fetches form information from BE
			 * @public
			 * @param {String} formName form name
			 * @param {Function} onSuccessCallback success callback
			 * @returns {undefined}
			 */
			getForm: function(formName, onSuccessCallback) {
				var reqObj;
				if (!service.validateFormName(formName)) {
					return;
				}
				reqObj = {
					form_name: formName,
					cart_id: AppData.cart.cart_id,
					cart_key: AppData.cart.cart_key,
					language: AppData.language
				};
				if (service.useMembershipTila()) {
					reqObj.tila_membership = 1;
				}
				// Add reference of request in pendingRequests.
				$rootScope.pendingRequests.push(Enums.services.GET_FORM);
				$rootScope.showSpinner(Language.getLocale('ApplicationLabels', 'loadingAgreementMsg'));
				AppData
					.fetch(Enums.services.GET_FORM, false, reqObj)
					.then(function promiseHandler(data) {
						if (data.status === Enums.status.OK) {
							service.setFormDetails({
								formName: formName,
								formID: data.FORM.id
							});
							onSuccessCallback(data);
						} else {
							Modal.displayModal({
								category: 'Agreements [GetForm]',
								action: 'Error',
								label: data.error_msg,
								icon: 'icon-info red',
								title: Language.getLocale('Alert', 'failedGetFormTitle'),
								description: Language.getLocale('Alert', 'failedGetFormMsg'),
								hideAllButtons: false
							});
						}
					})
					.finally(function finallyHandler() {
						$rootScope.hideSpinner();
						$rootScope.removePendingRequest(Enums.services.GET_FORM);
					});
			},

			/**
			 * Validates form name
			 * @public
			 * @param {String} formName form name
			 * @param {Function} onUserAcknowleged callback
			 * @return {Boolean} true if form name is valid
			 */
			validateFormName: function(formName, onUserAcknowleged) {
				if (!formName) {
					Modal.displayModal({
						category: 'Agreements [GetForm]',
						action: 'Error',
						label: 'Form type is not defined. Possibly configuration error.',
						icon: 'icon-info red',
						title: Language.getLocale('Alert', 'formTypeNotDefinedTitle'),
						description: Language.getLocale('Alert', 'formTypeNotDefinedMsg'),
						buttonFlags: [Enums.buttonFlags.OK],
						callback: onUserAcknowleged
					});

					service.clearDataModel();
					service.clearCartFormData();
					service.clearCustomFormData();

					$rootScope.hideSpinner();

					return false;
				}
				return true;
			},

			/**
			 * Generates data model for agreement form
			 * @public
			 * @param {Object} data form data
			 * @param {Boolean} isPreCart is pre cart agreement
			 * @returns {Object} data model for agreement
			 */
			generateDataModel: function(data, isPreCart) {
				var cartSummary = CartDataService.getLastSummary();
				var dataModel = {};
				var itemizationDetails;
				var cartItems = cartSummary.cart.items;
				var numPayments = service.getNumOfPayments();
				var tilaMembershipSettings = service.getMembershipTilaSettings();
				data.FORM.F.forEach(function appendFieldsToDataModel(field) {
					dataModel[field.name] = field.value;
				});

				if (!service.tilaOverride) {
					if (dataModel.nonTILTerms) {
						dataModel.nonTILTermsRaw = dataModel.nonTILTerms;
						dataModel.nonTILTerms = $sce.trustAsHtml(dataModel.nonTILTerms);
					}

					if (numPayments < service.TILA_THRESHOLD) {
						// Logic copied from agreements-controller
						// BNPL or nonTILA EasyPay.
						for (var i = 0; i < cartItems.length; i++) {
							// leave the loop if we already have data
							if (dataModel.nonTILTerms && (dataModel.nonTILTerms.length > 1 || dataModel.nonTILTerms != '')) {
								continue;
							}

							dataModel.nonTILTermsRaw = data.FORM.termsText;
							dataModel.nonTILTerms = $sce.trustAsHtml(data.FORM.termsText);
							if (!service.useMembershipTila()) {
								dataModel.termsTitle = data.FORM.termsTitle;
							}
						}
					}

					// All terms type.
					if (checkProp('data.FORM.PASS', data, 'validArray')) {
						dataModel.packageItems = data.FORM.PASS.slice(0);
					} else if (checkProp('data.FORM.PASS', data, 'isRealObject')) {
						dataModel.packageItems = [data.FORM.PASS];
					}

					if (Array.isArray(dataModel.packageItems)) {
						dataModel.packageItems = AgreementsUtils.modifyPassesToPackageItems(dataModel.packageItems);
					} else {
						dataModel.packageItems = AgreementsUtils.getPaymentSchedulePackages(dataModel);
					}

					// All terms type.
					dataModel.paymentSchedule = AgreementsUtils.getPaymentSchedule(dataModel);

					// Threshold (or 6) or more.
					if (numPayments >= service.TILA_THRESHOLD) {
						itemizationDetails = AgreementsUtils.getItemizedDetails(dataModel);
						dataModel.totalSalePriceNote = itemizationDetails.totalSalePriceNote;
						dataModel.itemizedCash = itemizationDetails.itemizedCash;
						dataModel.itemizedOther = itemizationDetails.itemizedOther;
					}
				}

				dataModel.billingInfo = isPreCart ? {} : AgreementsUtils.getBillingDetails();
				// Threshold (or 6) or more
				if (numPayments >= service.TILA_THRESHOLD && !isPreCart) {

					// Get mailing address.
					dataModel.billingInfo.mailingAddress = dataModel.billingInfo.address;
					dataModel.billingInfo.address += (dataModel.billingInfo.address2) ? ', ' + dataModel.billingInfo.address2 : '';
				}
				dataModel.formInfo = AgreementsUtils.getVersionDetails(data);
				dataModel.paymentInfo = AgreementsUtils.getPaymentDetails();

				// Keys not in Form array.
				dataModel.category = data.FORM.category;
				dataModel.id = data.FORM.id;
				dataModel.language = data.FORM.language;
				dataModel.name = data.FORM.name;
				dataModel.version = data.FORM.version;
				dataModel.formDate = new Date();

				dataModel.scopeData = {
					isMembership: cartSummary.info.hasFuturePayments,
					isStandard: (numPayments < service.TILA_THRESHOLD) && !service.tilaOverride,
					isTruthInLending: (!service.tilaOverride && numPayments) >= service.TILA_THRESHOLD,
					isTruthInLendingMembership: service.useMembershipTila() && dataModel.name === tilaMembershipSettings.formName
				};

				if (dataModel.scopeData.isTruthInLendingMembership) {
					if (validString(tilaMembershipSettings.addAgreementField)) {
						dataModel.scopeData.additionalCheckbox = {
							checked: false,
							label: dataModel[tilaMembershipSettings.addAgreementField]
						};
					}

					dataModel.scopeData.showTodaysPayment = tilaMembershipSettings.showTodaysPayment;
					dataModel.numberOfPaymentsAfterToday = dataModel.numberOfPayments - 1;
				}

				AgreementsUtils.transformText(dataModel);

				service.setDataModel(dataModel);

				return dataModel;
			},

			/**
			 * Remove swap flags on packages
			 * @public
			 * @param {Function} callback callback function
			 * @returns {undefined}
			 */
			removeAgreementSwapFlags: function(callback) {
				// User confirmed canceling the agreement. Delete the agreement flags in the CHARACS
				// for each item in the cart then update the cart and route to order review.
				var cartSummary = CartDataService.getLastSummary(),
					i,
					j,
					item,
					itemCharac;
				for (i = 0; i < cartSummary.cart.items.length; i++) {
					item = cartSummary.cart.items[i];

					if (!item.characs.length) {
						continue;
					}

					for (j = 0; j < item.characs.length; j++) {
						itemCharac = item.characs[j];
						if (itemCharac.hasOwnProperty('payment_schedule_id')) {
							itemCharac.sp_swap = 1;
							delete itemCharac.sp_swap_easypay_flag;
							delete itemCharac.sp_swap_paylater_flag;
						}
					}
				}

				CartDataService
					.updateCartItems(cartSummary)
					.then(callback);
			},

			/**
			 * Sets user agreement consented status
			 * @public
			 * @param {Boolean | String} status agreement consent status
			 * @returns {undefined}
			 */
			setUserAgreementConsentStatus: function(status) {
				agreementConsented = Utilities.getBoolean(status);
			},

			/**
			 * Sets first payment schedule amount
			 * @public
			 * @param {String} amount first payment schedule amount
			 * @returns {undefined}
			 */
			setFirstPaymentScheduleAmount: function(amount) {
				firstPaymentScheduleAmount = amount;
			},

			/**
			 * Returns first payment schedule amount
			 * @public
			 * @returns {String} payment schedule amount
			 */
			getPaymentScheduleAmount: function() {
				return firstPaymentScheduleAmount;
			},

			/**
			 * Returns user agreement consent status
			 * @public
			 * @returns {Boolean} user agreement status
			 */
			getUserAgreementConsentStatus: function() {
				return agreementConsented;
			},

			/**
			 * Returns if the agreement form is consented
			 * @public
			 * @returns {Boolean} true if user consented and payment schedule amount remains same
			 */
			didUserConsentAgreementForms: function() {
				var cartSummary = CartDataService.getLastSummary();

				// Agreement forms must have a payment plan
				if (!cartSummary.info.hasPaymentSchedule) {
					return true;
				}

				return service.getUserAgreementConsentStatus() && firstPaymentScheduleAmount === cartSummary.paymentSchedule.schedule[0].pricing.total;
			}
		};

		/**
		 * This listener removes agreement forms (NOT CUSTOM AGREEMENT FORMS) from the cart if a payment plan item gets removed
		 * and we no longer need the form. If they add it back it should require them to re-sign
		 */
		$rootScope.$on(Enums.messages.CART_UPDATE, function removeNonCustomAgreements(data) {
			if (!CartService.hasPaymentPlan() && _cartFormData) {
				service.clearCartFormData();
			}
			$timeout(removeStaleCustomForms);
		});

		/** Drops and deletes stored custom form records with no matching cart item, so Purchase does not send them */
		function removeStaleCustomForms() {
			var applicableNames,
				stale;

			if (!validArray(_customFormAgreementData)) {
				return;
			}

			applicableNames = (service.getCustomAgreementFormsForUpdatedCart() || []).map(function getName(form) {
				return form.formName;
			});
			stale = _customFormAgreementData.filter(function isStale(saved) {
				return applicableNames.indexOf(saved.name) === -1;
			});
			logSetupDebug('CART_UPDATE custom form check', { stored: _customFormAgreementData.map(function(saved) { return saved.name; }), applicable: applicableNames, removed: stale.map(function(saved) { return saved.name; }) });
			if (!stale.length) {
				return;
			}

			_customFormAgreementData = _customFormAgreementData.filter(function isCurrent(saved) {
				return !stale.includes(saved);
			});
			if (!_customFormAgreementData.length) {
				_customFormAgreementData = null;
			}
			service.deleteForms(stale.map(function toDeleteRequest(saved) {
				return {
					cart_id: AppData.cart.cart_id,
					cart_key: AppData.cart.cart_key,
					form_id: saved.id
				};
			})).catch(function logDeleteFailure(error) {
				logSetupDebug('stale custom form delete failed', error);
			});
		}

		/**
		 * A guard to use for routes which require us to check if the user has signed the required forms
		 * @returns {Promise} A promise to check if the users signed the correct data.
		 */
		function routeGuard(trans) {
			var cartCustomAgreementCustomActionEnum = CustomActionService.ACTIONS_ENUMS.CUSTOM_AGREEMENTS_BEFORE_CART;
			var cartAgreementCustomActionEnum = CustomActionService.ACTIONS_ENUMS.AGREEMENTS_BEFORE_CART;

			return $q(function resolveFetchedForms(resolve) {
				if (!service.didUserConsentAgreementForms() || service.doesCartItemsHaveCustomAgreementFormIdentifiers()) {
					return service
						.fetchSavedForms()
						.finally(resolve);
				}
				resolve();
			}).then(function onFetchedSavedForms() {
				if (CustomActionService.actionRegistered(cartCustomAgreementCustomActionEnum) && service.doesCartItemsHaveCustomAgreementFormIdentifiers()) {
					service.convertCurrentCartCustomAgreementToMultipPackCustomAgreement();
					CustomActionService.executeCustomAction(cartCustomAgreementCustomActionEnum, trans);
				}
				if (CustomActionService.actionRegistered(cartAgreementCustomActionEnum) && !service.didUserConsentAgreementForms()) {
					CustomActionService.executeCustomAction(cartAgreementCustomActionEnum, trans);
				}
			});
		}

		/**
		 * Fetches saved forms from the backend and parses them then saves them on the service.
		 * @returns {Promise} To find the saved forms
		 */
		function fetchSavedForms() {
			var mainFormName;

			// Need to initialize before calling getFormName
			service.initialize();

			mainFormName = service.getFormName();

			return AppData.fetch(Enums.services.GET_CART_FORM_DATA, false, {
				cart_id: AppData.cart.cart_id,
				cart_key: AppData.cart.cart_key,
			}).then(function parseForms(resp) {
				var retrievedForms = [],
					mainForm;

				if (resp.status === 'OK') {
					retrievedForms = wrapObjectToArray(resp.CART_FORM, true);
				}

				retrievedForms = retrievedForms.map(function parseForm(f) {
					return {
						form_id: f.form_id,
						form_data: JSON.parse(f.form_data)
					};
				});

				mainForm = retrievedForms.find(function findFormByName(f) {
					return f.form_data.name === mainFormName;
				});

				if (mainForm) {
					if (!service._savedFormIds.includes(mainForm.form_id)) {
						service._savedFormIds.push(mainForm.form_id);
					}
					service.setCartFormData(mainForm.form_data);
					service.setUserAgreementConsentStatus(true);

					retrievedForms.splice(retrievedForms.indexOf(mainForm), 1);

					if (checkProp('mainForm.form_data.extraData.internalPaymentScheduleAmount', mainForm)) {
						service.setFirstPaymentScheduleAmount(mainForm.form_data.extraData.internalPaymentScheduleAmount);
					}
				}

				// The rest should be custom forms
				if (retrievedForms.length) {
					_customFormAgreementData = retrievedForms.map(function setCustomForm(f) {
						var rateField,
							foundAgreement = service.customAgreementForms.find(function findByName(agreement) {
								return agreement.formName === f.form_data.name;
							});

						if (!service._savedFormIds.includes(f.form_id)) {
							service._savedFormIds.push(f.form_id);
						}

						// We need to set it as consented otherwise they'll be required to sign again. Ain't nobody got time for that!
						if (foundAgreement) {
							foundAgreement.hasConsented = true;
							if (foundAgreement.recordAcceptance) {
								rateField = Utilities.toArray(f.form_data.F).find(function(field) {
									return field.name === 'rateValues';
								});
								foundAgreement.consentedRateSignature = rateField ? Utilities.getString(rateField.value) : '';
							}
						}

						return f.form_data;
					});
				}
			});
		}
		/**
		 * Handles deleting forms on the backend
		 * @param {Object[]} forms The forms to delete
		 * @returns {Promise} A promise to delete the forms
		 */
		function deleteForms(forms) {
			return AppData.fetch(Enums.services.DELETE_CART_FORM_DATA, false, {
					CART_FORM: forms
				}).then(function finishedDeletingIds(resp) {
					if (resp.status !== Enums.status.OK) {
						return;
					}

					forms.forEach(function removeIds(form) {
						var index = service._savedFormIds.indexOf(form.form_id);
						if (index > -1) {
							service._savedFormIds.splice(index, 1)
						}
					});
				});
		}

		/**
		 * Handles saving new forms on the backend
		 * @param {Object[]} forms The forms to add
		 * @returns {Promise} A promise to add the forms
		 */
		function addForms(forms) {
			return AppData.fetch(Enums.services.ADD_CART_FORM_DATA, false, {
					CART_FORM: forms
				}).then(function addFormsToSavedIds(resp) {
					if (resp.status !== Enums.status.OK) {
						return resp;
					}

					forms.forEach(function addIds(form) {
						service._savedFormIds.push(form.form_id);
					});
					return resp;
				});
		}

		/**
		 * Handles updating forms that have already been saved on the backend
		 * @param {Object[]} forms The forms to update
		 * @returns {Promise} A promise to update the forms
		 */
		function updateForms(forms) {
			return AppData.fetch(Enums.services.UPDATE_CART_FORM_DATA, false, {
				CART_FORM: forms
			});
		}


		/**
		 * Does the cart have associated characs for a custom agreement form
		 * @param customAgreementForm
		 * @returns {boolean}
     */
			function doesCartHaveCustomAgreementFormForForm(customAgreementForm){
				var cartSummary = CartDataService.getLastSummary();

				return !!cartSummary && cartSummary.cart.items.some(function(item){return item.characs.some(
						function(charac){
							return characMatchesAgreementForm(charac, customAgreementForm);
						}
					)}
				);
			}

			/** Recorded forms are only consented while the eligible rates in the cart match the rates they were accepted against */
			function isConsentCurrent(agreementForm) {
				var currentSignature;

				if (!agreementForm.hasConsented || !agreementForm.recordAcceptance) {
					return !!agreementForm.hasConsented;
				}
				currentSignature = JSON.stringify(getUpfrontRateValues(agreementForm));
				return agreementForm.consentedRateSignature === currentSignature;
			}

			/** Formatted resume date (last scheduled payment) and coverage end date (the day before); empty without a schedule date */
			function getResumeDates() {
				var schedule = (CartDataService.getLastSummary().paymentSchedule || {}).schedule,
					lastPayment = validArray(schedule) ? schedule[schedule.length - 1] : null,
					endDate;

				if (!lastPayment || !lastPayment.date) {
					return { resumeDate: '', upfrontCoverageEndDate: '' };
				}

				endDate = new Date(lastPayment.date);
				endDate.setDate(endDate.getDate() - 1);
				return {
					resumeDate: $filter('date')(lastPayment.date, AppData.settings.date_format),
					upfrontCoverageEndDate: $filter('date')(endDate, AppData.settings.date_format)
				};
			}

			/** One rate row per cart item matching the form's CHARAC */
			function getUpfrontRateValues(agreementForm) {
				var dates = getResumeDates();

				function formatCurrency(amount) {
					return $filter('currencyFormatter')(amount);
				}

				function hasRateData(item) {
					return isObject(item) && isObject(item.package) && isObject(item.customer) && isObject(item.pricing);
				}

				return service.getMatchingCartItemsForCustomAgreementForm(agreementForm).filter(hasRateData).map(function buildRow(item) {
					var rates = Package.getUpfrontMembershipRatesForCartItem(item),
						upfrontAmount = Number(CartDataService.getPrice(item.pricing));

					return {
						packageId: String(item.package.id),
						packageName: item.package.name,
						customerType: String(item.customer.id),
						rateName: item.customer.name,
						upfrontAmount: upfrontAmount,
						upfront: formatCurrency(upfrontAmount),
						monthlyAmount: rates ? rates.monthly : 0,
						monthly: rates ? formatCurrency(rates.monthly) : '',
						resumeMonth: rates ? String(rates.resumeIndex) : '',
						resumeDate: rates ? dates.resumeDate : '',
						upfrontCoverageEndDate: rates ? dates.upfrontCoverageEndDate : ''
					};
				});
			}

			/** Aliased packages are not in the boot package list, so fetch the ones the upfront rate rows need */
			function mergeMissingUpfrontPackages(forms) {
				var packageIds = [];

				forms.filter(function(form) {
					return form.recordAcceptance;
				}).forEach(function(form) {
					service.getMatchingCartItemsForCustomAgreementForm(form).forEach(function(item) {
						var packageId = checkProp('item.package.id', item, 'returnValue');

						if (packageId && packageIds.indexOf(String(packageId)) === -1) {
							packageIds.push(String(packageId));
						}
					});
				});

				return Package.requestAndMergeMissingPackages(packageIds);
			}

			/** Debug-only (`_d=true`) log of a package or form setup problem that blocks the upfront agreement */
			function logSetupDebug(message, details) {
				if ($rootScope.develop) {
					$log.debug('[agreement] ' + message, details);
				}
			}

			/** What GetMerchantPackageList holds for a row's package and customer type, to tell which setup piece is missing */
			function describeRateLookup(row) {
				var pkg = Package.getPackageByID(row.packageId),
					customerTypes = pkg ? Utilities.toArray(pkg.CT) : [],
					customerType = customerTypes.filter(function(ct) {
						return String(ct.id) === row.customerType;
					})[0],
					lines = customerType ? Utilities.toArray(customerType.PAYMENT_SCHEDULE && customerType.PAYMENT_SCHEDULE.SP) : [],
					listedPackages = AppData.GetMerchantPackageList && AppData.GetMerchantPackageList.PS ? Utilities.toArray(AppData.GetMerchantPackageList.PS.P) : [],
					aliasedBy = listedPackages.filter(function(listed) {
						return Utilities.toArray(listed.CT).some(function(ct) {
							return String(ct.source_package_id) === row.packageId;
						});
					}).map(function(listed) {
						return listed.id;
					});

				return {
					packageId: row.packageId,
					customerType: row.customerType,
					packageInList: !!pkg,
					listedAsSourcePackageOf: aliasedBy,
					isUpfrontMembershipCharac: pkg && pkg.CHARACS ? pkg.CHARACS.is_upfront_membership : undefined,
					customerTypeIdsInPackage: customerTypes.map(function(ct) {
						return ct.id;
					}),
					customerTypeFound: !!customerType,
					scheduleLineCount: lines.length,
					firstLine: lines[0],
					lastLine: lines[lines.length - 1]
				};
			}

			/** The reasons the upfront rates cannot be rendered for a form */
			function findUpfrontSetupProblems(agreementForm, rateValues, dates) {
				var problems = [],
					formText = agreementForm.formBody + agreementForm.consentBoxVerbiage,
					dateTokens = {resumeDate: '@@resumeDate', upfrontCoverageEndDate: '@@upfrontCoverageEndDate'};

				if (!validString(agreementForm.rateRowTemplate)) {
					problems.push('form field rateRowTemplate is empty');
				}
				if (!validArray(rateValues)) {
					problems.push('no cart item matching the form CHARAC has package, customer type and pricing');
				}
				rateValues.forEach(function(v) {
					var missing = ['upfront', 'monthly', 'resumeMonth'].filter(function(key) {
						return !validString(v[key]);
					});

					if (missing.length) {
						problems.push('package ' + v.packageId + ' / customer type ' + v.customerType + ' has no ' + missing.join(', ') + ' (needs CHARAC is_upfront_membership, 2+ PAYMENT_SCHEDULE.SP lines with differing first and last amounts, and a GetMerchantPackageList entry)');
					}
				});
				Object.keys(dateTokens).forEach(function(key) {
					var token = dateTokens[key];

					if (formText.indexOf(token) > -1 && !validString(dates[key])) {
						problems.push(token + ' is used but the cart PAYMENT_SCHEDULE has no date');
					}
					if (agreementForm.rateRowTemplate.indexOf(token) > -1 && rateValues.some(function(v) {
						return !validString(v[key]);
					})) {
						problems.push(token + ' is used in rateRowTemplate but a row has no date');
					}
				});

				return problems;
			}

			/** Substitutes the upfront rate tokens in the form; returns false when a required rate, template or schedule date is missing */
			function renderUpfrontRates(agreementForm) {
				var tokens = ['@@upfrontCoverageEndDate', '@@packageName', '@@rateName', '@@upfront', '@@monthly', '@@resumeMonth', '@@resumeDate'],
					rateValues = getUpfrontRateValues(agreementForm),
					totalUpfront,
					totalMonthly,
					dates = getResumeDates(),
					problems,
					rows;

				function formatTotal(key) {
					return $filter('currencyFormatter')(rateValues.reduce(function(sum, v) {
						return sum + v[key];
					}, 0));
				}

				agreementForm.rateValues = rateValues;
				problems = findUpfrontSetupProblems(agreementForm, rateValues, dates);
				if (problems.length) {
					logSetupDebug('form "' + agreementForm.formName + '" cannot render the upfront rates', problems);
					rateValues.filter(function(v) {
						return !validString(v.monthly) || !validString(v.resumeMonth);
					}).forEach(function(v) {
						logSetupDebug('rate lookup for package ' + v.packageId + ' / customer type ' + v.customerType, describeRateLookup(v));
					});
					return false;
				}

				totalUpfront = formatTotal('upfrontAmount');
				totalMonthly = formatTotal('monthlyAmount');
				rows = rateValues.map(function(v) {
					return Language.replaceAllMultiple(tokens, [v.upfrontCoverageEndDate, v.packageName, v.rateName, v.upfront, v.monthly, v.resumeMonth, v.resumeDate], agreementForm.rateRowTemplate);
				}).join('');
				agreementForm.formBody = Language.replaceAllMultiple(['@@upfrontRates', '@@totalUpfront', '@@totalMonthly', '@@resumeDate', '@@upfrontCoverageEndDate'], [rows, totalUpfront, totalMonthly, dates.resumeDate, dates.upfrontCoverageEndDate], agreementForm.formBody);
				agreementForm.consentBoxVerbiage = Language.replaceAllMultiple(['@@todayDate', '@@totalUpfront', '@@totalMonthly', '@@resumeDate', '@@upfrontCoverageEndDate'], [$filter('date')(new Date(), AppData.settings.date_format), totalUpfront, totalMonthly, dates.resumeDate, dates.upfrontCoverageEndDate], agreementForm.consentBoxVerbiage);
				return true;
			}

			/**
			 * Find out if the characs has an associated cart item charac and its value matches an agreement charac and value
			 * @param {Object} characs characs
			 * @param {Object} agreementForm agreement form
			 * @returns {Boolean} if the characs match an agreement.
			 */
			function characMatchesAgreementForm(characs, agreementForm) {
				var multiPackageCustomAgreement,
					characName = agreementForm.associatedCartItemCharacName,
					characValue = agreementForm.associatedCartItemCharacValue;

				// If we have multiple packages with the same custom agreement
				if (agreementForm.multiPackageCustomAgreement) {
					multiPackageCustomAgreement = agreementForm.multiPackageCustomAgreement;

					// find out if we have a matching agreement charac name/value with a cart item charac/value
					return isArray(multiPackageCustomAgreement[characName]) && Object.keys(multiPackageCustomAgreement).some(function(characName) {
						return characs.hasOwnProperty(characName) && multiPackageCustomAgreement[characName].some(function(value) {
							return characs[characName] === value;
						});
					});
				}

				return characs[characName] === characValue;
			}

			return service;
		});


/*

// Example data for Purchase request.
<FORMS>
	<FORM id="9" name="retail_installment_V1" fullVersion="RETAIL_INSTALLMENT_V1_EN_V2">
	 <F name="amountFinanced" value="480.00"/>
	 <F name="annualRate" value="0.00"/>
	 <F name="buyerMailingAddress" value="1321 Chichester Street Apt 123"/>
	 <F name="cardType" value="VISA"/>
	 <F name="city" value="Orlando"/>
	 <F name="emailAddress" value="test@accesso.com"/>
	 <F name="financeCharge" value="0.00"/>
	 <F name="firstName" value="Accesso"/>
	 <F name="homeTel" value="3211111234"/>
	 <F name="itemAFCashPrice" value="581.99"/>
	 <F name="itemAFTaxes" value="0.00"/>
	 <F name="itemAFTotal" value="581.99"/>
	 <F name="itemAmountFinanced" value="480.00"/>
	 <F name="itemDownPayment" value="101.99"/>
	 <F name="itemFinanceCharge" value="0.00"/>
	 <F name="lastFourNumbers" value="1111"/>
	 <F name="lastName" value="Test"/>
	 <F name="middleName" value="G"/>
	 <F name="mobileTel" value="N/A"/>
	 <F name="numberOfPayments" value="5"/>
	 <F name="orderData" value="&lt;ORDER_DATA>&#xA;  &lt;ORDER_ITEM finalPrice=&quot;192.00&quot; firstName=&quot;sdfgs&quot; LastName=&quot;dfgsdfgsdfgsdfgsdfg&quot; mx_internal_uid=&quot;59AF5022-AB70-C0E0-B764-04E0AF884A3D&quot; passType=&quot;2014 PLATINUM SEASON PASS REGULAR - EASY PAY&quot;/>&#xA;  &lt;ORDER_ITEM finalPrice=&quot;192.00&quot; firstName=&quot;sdfgs&quot; LastName=&quot;dfgsdfgsdfgsdfgsdfg&quot; mx_internal_uid=&quot;2459FE02-6DCB-0CBA-B321-04E0AF8C1945&quot; passType=&quot;2014 PLATINUM SEASON PASS REGULAR - EASY PAY&quot;/>&#xA;  &lt;ORDER_ITEM finalPrice=&quot;192.00&quot; firstName=&quot;sdfgs&quot; LastName=&quot;dfgsdfgsdfgsdfgsdfg&quot; mx_internal_uid=&quot;7F29D9DD-A452-9BCB-1890-04E0AF8F0BE4&quot; passType=&quot;2014 PLATINUM SEASON PASS REGULAR - EASY PAY&quot;/>&#xA;&lt;/ORDER_DATA>"/>
	 <F name="paymentSchedule" value="&lt;PAYMENT_SCHEDULE>&#xA;  &lt;PAYMENT ca_amount=&quot;5.99&quot; ca_tax_amount=&quot;0.00&quot; date=&quot;03/27/2014&quot; fee_amount=&quot;0.00&quot; index=&quot;1&quot; retail_amount=&quot;96.00&quot; ship_amount=&quot;0.00&quot; tax_amount=&quot;0.00&quot; total_amount=&quot;101.99&quot;/>&#xA;  &lt;PAYMENT ca_amount=&quot;0.00&quot; ca_tax_amount=&quot;0.00&quot; date=&quot;04/27/2014&quot; fee_amount=&quot;0.00&quot; index=&quot;2&quot; retail_amount=&quot;96.00&quot; ship_amount=&quot;0.00&quot; tax_amount=&quot;0.00&quot; total_amount=&quot;96.00&quot;/>&#xA;  &lt;PAYMENT ca_amount=&quot;0.00&quot; ca_tax_amount=&quot;0.00&quot; date=&quot;05/27/2014&quot; fee_amount=&quot;0.00&quot; index=&quot;3&quot; retail_amount=&quot;96.00&quot; ship_amount=&quot;0.00&quot; tax_amount=&quot;0.00&quot; total_amount=&quot;96.00&quot;/>&#xA;  &lt;PAYMENT ca_amount=&quot;0.00&quot; ca_tax_amount=&quot;0.00&quot; date=&quot;06/27/2014&quot; fee_amount=&quot;0.00&quot; index=&quot;4&quot; retail_amount=&quot;96.00&quot; ship_amount=&quot;0.00&quot; tax_amount=&quot;0.00&quot; total_amount=&quot;96.00&quot;/>&#xA;  &lt;PAYMENT ca_amount=&quot;0.00&quot; ca_tax_amount=&quot;0.00&quot; date=&quot;07/27/2014&quot; fee_amount=&quot;0.00&quot; index=&quot;5&quot; retail_amount=&quot;96.00&quot; ship_amount=&quot;0.00&quot; tax_amount=&quot;0.00&quot; total_amount=&quot;96.00&quot;/>&#xA;  &lt;PAYMENT ca_amount=&quot;0.00&quot; ca_tax_amount=&quot;0.00&quot; date=&quot;08/27/2014&quot; fee_amount=&quot;0.00&quot; index=&quot;6&quot; retail_amount=&quot;96.00&quot; ship_amount=&quot;0.00&quot; tax_amount=&quot;0.00&quot; total_amount=&quot;96.00&quot;/>&#xA;&lt;/PAYMENT_SCHEDULE>"/>
	 <F name="sellerAndCreditorText" value="Knott's Berry Farm"/>
	 <F name="signatureName" value="Accesso G Test"/>
	 <F name="state" value="FL"/>
	 <F name="streetAddressText" value="Cedar Fair, L.P. 1 Cedar Point Drive  Sandusky, OH 44870"/>
	 <F name="timestamp" value="Thu Mar 27 18:49:50 2014 UTC"/>
	 <F name="totalOfPayments" value="480.00"/>
	 <F name="totalSalesPrice" value="581.99"/>
	 <F name="zip" value="32803"/>
	</FORM>
  </FORMS>


*/

(function() {
	'use strict';

	angular
		.module('agreement')
		.factory('AgreementsUtils', AgreementsUtils);

	/**
	 * Utils for Agreements
	 * @constructor
	 * @param {Service} $filter $filter
	 * @param {Service} AppData AppData
	 * @param {Service} CartDataService CartDataService
	 * @param {Service} UserInfo UserInfo
	 * @param {Service} Utilities Utilities
	 * @param {Service} UtilsValidation UtilsValidation
	 * @returns {AgreementsUtils} The instance
	 * @ngInject
	 */
	function AgreementsUtils($filter, AppData, CartDataService, UserInfo, Utilities, UtilsValidation) {
		var checkProp = Utilities.safelyCheckPropertyOnObject,
			validArray = UtilsValidation.validArray,
			validString = UtilsValidation.validString,
			isRealObject = UtilsValidation.isRealObject,
			getBoolean = Utilities.getBoolean;

		var service = {
			MAX_PAYMENTS: 6,
			getBillingDetails: getBillingDetails,
			getDownPayment: getDownPayment,
			getItemizedDetails: getItemizedDetails,
			getPaymentDetails: getPaymentDetails,
			getPaymentSchedule: getPaymentSchedule,
			getPaymentSchedulePackages: getPaymentSchedulePackages,
			getShippingCostByShippingID: getShippingCostByShippingID,
			getTaxesAndProcessing: getTaxesAndProcessing,
			getVersionDetails: getVersionDetails,
			modifyPassesToPackageItems: modifyPassesToPackageItems,
			setTruthInLendingDetails: setTruthInLendingDetails,
			transformText: transformText
		};
		return service;

		/**
		 * Modifies the passes array to package items
		 * @param {Object[]} passes the passes from the GetForm response
		 * @returns {Object[]} the package items
		 */
		function modifyPassesToPackageItems(passes) {
			return passes.map(function(pass) {
				return {
					finalPrice: getBoolean(AppData.settings.use_vat) ? pass.minimum_term_price_with_tax : pass.minimum_term_price,
					firstName: pass.first_name,
					lastName: pass.last_name,
					passType: pass.package_name
				};
			});
		}

		/**
		 * Returns the payment schedule packages to be appended to the agreement data model
		 * @public
		 * @returns {Object} payment schedule to be appended
		 */
		function getPaymentSchedulePackages() {
			var packageItems = [];
			var cartSummary = CartDataService.getLastSummary();

			cartSummary.cart.items.forEach(function cartItemsIterator(cartItem) {
				var cartItemCopy = angular.copy(cartItem),
					cartItemCharacs;

				if (cartItemCopy.flags.hasPaymentPlan && cartItemCopy.characs) {
					cartItemCharacs = cartItemCopy.characs;
					cartItemCharacs.forEach(function cartItemCharacsIterator(cartItemCharac) {
						packageItems.push({
							finalPrice: cartItemCopy.pricing.retail,
							firstName: cartItemCharac.ph_first_name,
							lastName: cartItemCharac.ph_last_name,
							passType: cartItemCopy.package.name.toUpperCase()
						});
					});
				}
			});
			return packageItems;
		}

		/**
		 * Returns payment schedule to be appended to agreements data model
		 * @public
		 * @returns {Object} payment schedule
		 */
		function getPaymentSchedule() {
			var cartSummary = CartDataService.getLastSummary(),
				sequenceLabel = '@@current of @@total',
				paymentScheduleLength,
				paymentSchedule = [];

			if (!cartSummary.paymentSchedule.schedule.length) {
				return paymentSchedule;
			}
			paymentScheduleLength = cartSummary.paymentSchedule.schedule.length;

			cartSummary.paymentSchedule.schedule.forEach(function paymentScheduleIterator(payment, index) {
				var seqLbl = sequenceLabel.split('@@current').join(index + 1);
				seqLbl = seqLbl.split('@@total').join(paymentScheduleLength);

				paymentSchedule.push({
					date: payment.date,
					payment: payment.pricing.total,
					sequence: seqLbl,
					show: index === 0
				});
			});

			return paymentSchedule;
		}

		/**
		 * Returns itemized details
		 * @public
		 * @param {Object} dataModel agreement data model
		 * @returns {Object} itemized details
		 */
		function getItemizedDetails(dataModel) {
			var itemizedCash = [{
				amount: dataModel['itemAFCashPrice'],
				fieldName: 'itemAFCashPrice',
				label: dataModel['priceOfgoodsLabel'].toUpperCase(),
				sequence: ''
			}, {
				amount: dataModel['itemAFTaxes'],
				fieldName: 'itemAFTaxes',
				label: dataModel['taxesAndProcessingLabel'].toUpperCase(),
				sequence: ''
			}, {
				amount: dataModel['itemAFTotal'],
				fieldName: 'itemAFTotal',
				label: dataModel['totalPurchasePriceLabel'].toUpperCase(),
				sequence: ''
			}];

			var itemizedOther = [{
				amount: dataModel['itemDownPayment'],
				fieldName: 'itemDownPayment',
				label: dataModel['itemizationDownPaymentLabel'],
				sequence: 2
			}, {
				amount: dataModel['itemFinanceCharge'],
				fieldName: 'itemFinanceCharge',
				label: dataModel['prePaidFinanceChargeLabel'],
				sequence: 3
			}, {
				amount: dataModel['itemAmountFinanced'],
				fieldName: 'itemAmountFinanced',
				label: dataModel['itemizationAmountFinancedLabel'],
				sequence: 4
			}];

			return {
				itemizedCash: itemizedCash,
				itemizedOther: itemizedOther,
				totalSalePriceNote: dataModel['totalSalePriceNote']
					.split('@@DownPayment')
					.join(service.getDownPayment(dataModel, service.getTaxesAndProcessing()))
			};
		}

		/**
		 * Retuns tax and processing fee
		 * @public
		 * @returns {String} tax and processing fee
		 */
		function getTaxesAndProcessing() {
			var cartSummary = CartDataService.getLastSummary();
			var totalFees = 0;
			var cartFees = cartSummary.fees || [];
			var cartAdjustments = cartSummary.adjustments || [];
			var selectedShipMethod = validArray(cartSummary.cart.shipping) ? cartSummary.cart.shipping[0].method : 'N/A';
			var shippingCost = service.getShippingCostByShippingID(selectedShipMethod);

			cartFees.forEach(function addTotalFees(fee) {
				totalFees += Number(fee.amount);
			});

			cartAdjustments.forEach(function addCartAdjustmentsToTotalFees(cAdj) {
				totalFees += Number(cAdj.amount);
			});

			totalFees += shippingCost;
			return Utilities.correctFloatingPointError(totalFees);
		}

		/**
		 * Returns matching shipping cost
		 * @public
		 * @param {String} shipMethod shipping method
		 * @returns {Number} shipping price
		 */
		function getShippingCostByShippingID(shipMethod) {
			var cartSummary = CartDataService.getLastSummary(),
				matchedShippingMethod;

			shipMethod = shipMethod.toUpperCase();

			if (cartSummary.cart.shipping.length) {
				matchedShippingMethod = cartSummary.cart.shipping.find(function getPrice(shippingMethod) {
					return shippingMethod.method.toUpperCase() === shipMethod;
				});

				if (matchedShippingMethod) {
					return matchedShippingMethod.price;
				}
			}
			return 0;
		}

		/**
		 * Gets the first payment schedule item and its amount if
		 * today is the first payment, otherwise counts all payment schedule
		 * items, subtracts 1st, then subtracts deductions.
		 *
		 * @param  {Object} dataModel  the dataModel
		 * @param  {Number} deductions the total value of cart deductions
		 * @return {Number} The downpayment value (calculated)
		 */
		function getDownPayment(dataModel, deductions) {
			var today = new Date();
			var output = 0;
			var firstPmt = dataModel.paymentSchedule[0];

			if (Utilities.compareDate(today, new Date(firstPmt.date)) != -1) {
				output = Number(firstPmt.payment - deductions);
			} else {
				output = 0;
			}

			return $filter('currencyFormatter')(Utilities.correctFloatingPointError(output), AppData.currencyCode, AppData.languageSettings);
		}

		/**
		 * Returns billing details to be appended to agreements data model
		 * @public
		 * @returns {Object} billing details
		 */
		function getBillingDetails() {
			var billingInfo;
			try {
				billingInfo = JSON.parse(JSON.stringify(UserInfo.billing)) || {};
			} catch (e) {
				throw new Error('Error copying UserInfo.billing: ' + e.message);
			}

			billingInfo.middleName = billingInfo.middleName || 'N/A';
			billingInfo.mobile = billingInfo.mobile || 'N/A';

			return angular.copy(billingInfo);
		}

		/**
		 * Returns payment details
		 * @public
		 * @returns {Object} payment info
		 */
		function getPaymentDetails() {
			// Pull payment details and store it on the data model.
			var paymentInfo = angular.copy(UserInfo.payment);

			//set payment type
			if (paymentInfo.authType) {
				if (paymentInfo.authType === 'PPA') {
					paymentInfo.paymentType = 'PayPal';
				} else if (paymentInfo.ccType) {
					paymentInfo.paymentType = paymentInfo.ccType.toUpperCase()
				} else {
					paymentInfo.paymentType = 'N/A';
				}
			} else {
				paymentInfo.paymentType = 'N/A';
			}
			return paymentInfo;
		}

		/**
		 * Returns version details to be appended to the data model
		 * @public
		 * @param {Object} data form data
		 * @returns {Object} version details
		 */
		function getVersionDetails(data) {
			return {
				category: data.FORM.category,
				fullVersion: data.FORM.name.toUpperCase() + '_' + data.FORM.language.toUpperCase() + '_V' + data.FORM.version.toUpperCase(),
				id: data.FORM.id,
				language: data.FORM.language,
				name: data.FORM.name,
				version: data.FORM.version
			};
		}

		/**
		 * Transforms certain characters into data so ops can insert it where they want.
		 * @param {Object} dataModel the data model
		 * @returns {undefined}
		 */
		function transformText(dataModel) {
			var keyValueMap,
				formattedDate = '',
				firstPaymentDate = '',
				propsToChange = [
					'termsNoticeAndApplicableLaws', 'whenPaymentsAreDueText', 'numberOfPaymentsText', 'numberOfPaymentsDueDate',
					'paymentsAfterToday', 'paymentsAfterTodayDue', 'additionalCheckboxTerms'
				],
				dateConfig = AppData.settings.date_format ? AppData.settings.date_format : 'MMddyyyy';

			if (!isRealObject(dataModel)) {
				return;
			}

			formattedDate = $filter('date')(dataModel.formDate, dateConfig);

			if (validString(dataModel.firstPaymentDate)) {
				firstPaymentDate = $filter('date')(Utilities.getJavaScriptDateFromMySQLDate(dataModel.firstPaymentDate), dateConfig);
			}

			keyValueMap = [
				['%formDate%', formattedDate],
				['%numPayments%', dataModel.numberOfPayments],
				['%numPaymentsAfterToday%', dataModel.numberOfPaymentsAfterToday],
				['%firstPaymentDate%', firstPaymentDate]
			];

			propsToChange.forEach(function addPropsToDataModel(prop) {
				if (!validString(dataModel[prop])) {
					return;
				}

				dataModel[prop] = keyValueMap.reduce(function(text, keyVal) {
					return text.replace(keyVal[0], keyVal[1]);
				}, dataModel[prop]);
			});
		}

		/**
		 * Method used to set detail on the dataModel for TILA only agreements.
		 * @param {Object} dataModel agreement data model
		 * @returns {Object} TILA Details
		 */
		function setTruthInLendingDetails(dataModel) {
			return {
				amountFinanced: dataModel.itemAmountFinanced,
				annualRate: dataModel.annualRate,
				buyerMailingAddress: dataModel.billingInfo.address,
				cardType: dataModel.paymentInfo.paymentType,
				city: dataModel.billingInfo.city,
				emailAddress: dataModel.billingInfo.email,
				financeCharge: dataModel.itemFinanceCharge,
				itemAFCashPrice: dataModel.itemAFCashPrice,
				itemAFTaxes: dataModel.itemAFTaxes,
				itemAFTotal: dataModel.itemAFTotal,
				itemAmountFinanced: dataModel.itemAmountFinanced,
				itemDownPayment: dataModel.itemDownPayment,
				itemFinanceCharge: dataModel.itemFinanceCharge,
				lastFourNumbers: dataModel.paymentInfo.last4,
				mobileTel: checkProp('dataModel.billingInfo.mobile', dataModel, 'validString') ? dataModel.billingInfo.mobile.split('-').join('').split(' ').join('') : 'N/A',
				orderData: JSON.stringify({ ORDER_ITEM: dataModel.packageItems }),
				phone: dataModel.billingInfo.phone.split('-')
					.join('')
					.split(' ')
					.join(''),
				sellerAndCreditorText: dataModel.sellerAndCreditorText,
				state: dataModel.billingInfo.state,
				streetAddressText: dataModel.streetAddressText,
				totalOfPayments: dataModel.totalOfPayments,
				totalSalesPrice: dataModel.totalSalePrice,
				zip: dataModel.billingInfo.zip
			};
		}
	}
}());

angular.module('agreement')
	.service('AgreementModels',
		function(
			AppData,
			ClientInfo,
			Language,
			Utilities,
			UtilsValidation,
			UserInfo,
			$filter,
			$timeout,
			$window) {
			var validString = UtilsValidation.validString;
			/**
			 * Mapping of form node from model to request
			 */
			var formNodeMapping = {

				signature: "signatureName",
				firstName: "firstName",
				middleInitial: "middleInitial",
				lastName: "lastName",
				timeStamp: "timestamp"

			}

			/**
			 * Base model for an agreement form
			 * @param formName
			 * @constructor
       */
			function AgreementForm(formName) {
				this.formName = formName;
			}

			this.AgreementForm = AgreementForm;

			/**
			 * Model for a custom agreement form - a NON-PAYMENT-PLAN agreement form
			 * @param formName
			 * @param associatedCartItemCharacName
			 * @param associatedCartItemCharacValue
			 * @param {Boolean} required
			 * @param {String} disableBirthdayCheck If the birthday check needs to be disabled or not
			 * @constructor
			 */
			function CustomAgreementForm(formName, associatedCartItemCharacName, associatedCartItemCharacValue, required, disableBirthdayCheck, requireName, options) {
				options = options || {};
				AgreementForm.call(this, formName);
				this.formId = '';
				this.formVersion = '';
				this.associatedCartItemCharacName = associatedCartItemCharacName;
				this.associatedCartItemCharacValue = associatedCartItemCharacValue;
				this.recordAcceptance = Utilities.getBoolean(options.recordAcceptance);
				this.hideSignature = Utilities.getBoolean(options.hideSignature);
				this.hideSteps = Utilities.getBoolean(options.hideSteps);
				this.cancelRemovesItems = Utilities.getBoolean(options.cancelRemovesItems);
				this.skipPaymentPlanForms = Utilities.getBoolean(options.skipPaymentPlanForms);
				this.rateRowTemplate = '';
				this.rateValues = [];
				this.consentedRateSignature = '';
				this.formHeader = '';
				this.formBody = '';
				this.consentBoxVerbiage = '';
				this.cancellationNotificationTitle = Language.getLocale('Agreement', 'cancelTitle_' + this.formName);
				this.cancellationNotificationMsg = Language.getLocale('Agreement', 'cancelMsg_' + this.formName);
				this.showBirthdayCheck = !Utilities.getBoolean(disableBirthdayCheck);
				this.showNameField = Utilities.getBoolean(requireName);
				this.required = Utilities.getBoolean(required);
				this.hasConsented = false;
				this.signature = '';
				this.firstName = '';
				this.middleInitial = '';
				this.lastName = '';
				this.timeStamp = new Date().toUTCString();
				this.extraData = {};
			}

			/**
			 * Populate the form data with base information
			 * @param formId
			 * @param formVersion
			 * @param formDataFields
       */
			CustomAgreementForm.prototype.fillFormData = function(formId, formVersion, formDataFields) {
				this.formId = formId;
				this.formVersion = formVersion;

				this.resetAgreementStatus();

				var formElements = angular.isArray(formDataFields)? formDataFields : [formDataFields];
				formElements.forEach(function(formItem) {
					if (formItem.name === 'header') {
						this.formHeader = formItem.value;
					} else if (formItem.name === 'body') {
						this.formBody = Language.replaceAllMultiple(['@@todayDate'], [$filter('date')(new Date(), AppData.settings.date_format)], formItem.value);
					} else if (formItem.name === 'consentBoxVerbiage') {
						this.consentBoxVerbiage = formItem.value;
					} else if (formItem.name === 'rateRowTemplate') {
						this.rateRowTemplate = formItem.value;
					}
				}, this);
			}

			/** Recorded forms stamp the accepted rates so a later rate change invalidates consent */
			CustomAgreementForm.prototype.markConsented = function() {
				this.hasConsented = true;
				if (this.recordAcceptance) {
					this.timeStamp = new Date().toUTCString();
					this.consentedRateSignature = JSON.stringify(this.rateValues);
				}
			};

			/**
			 * Reset the agreement consent
			 */
			CustomAgreementForm.prototype.resetAgreementStatus = function() {
				this.hasConsented = false;
				this.signature = '';
			}

			/**
			 * Toggle off/on the consent
			 */
			CustomAgreementForm.prototype.toggleConsent = function() {
				this.hasConsented = !this.hasConsented;
			}

			/**
			 * Return a JSON formatted structure of the form data for the service request
			 * @returns {{name: *, id: (string|*), fullVersion: string, F: Array}}
       */
			CustomAgreementForm.prototype.toJSON = function() {
				var form ={

					name: this.formName,
					id: this.formId,
					extraData: angular.isObject(this.extraData) ? this.extraData: {},
					fullVersion: this.getFullVersion(),
					F: []
				}

				for (var i in formNodeMapping) {
					var formProp = {};
					formProp.name = formNodeMapping[i];
					formProp.value = this[i];
					form.F.push(formProp);
				}

				if (this.recordAcceptance) {
					form.F.push(
						{ name: 'termsTitle', value: this.formHeader },
						{ name: 'acceptedBody', value: this.formBody },
						{ name: 'consentText', value: this.consentBoxVerbiage },
						{ name: 'version', value: this.formVersion },
						{ name: 'rateValues', value: JSON.stringify(this.rateValues) }
					);
				}

				return form;
			}

			CustomAgreementForm.prototype.getFullVersion = function() {
				return this.formName.toUpperCase() + '_' + AppData.language.toUpperCase() + '_V' + this.formVersion.toUpperCase();
			}

			/**
			 * Set the name and signature
			 */
			CustomAgreementForm.prototype.setNameAndSignature = function() {
				var billingInfo = UserInfo.get('billing');
				this.firstName = angular.copy(billingInfo.firstName);
				this.middleInitial = (angular.isDefined(billingInfo.middleInitial) ? angular.copy(billingInfo.middleInitial) : '');
				this.lastName = angular.copy(billingInfo.lastName);
				this.signature = this.firstName + (this.middleInitial.length > 0 ? (' ' + this.middleInitial + ' ') : ' ') + this.lastName;
			}

			/**
			 * Set name and DOB as signature
			 * @param {String} name name
			 * @param {String} dob dob
			 * @returns {undefined}
			 */
			CustomAgreementForm.prototype.setNameDOBSignature = function(name, dob) {
				var computedName = '',
					computeDOB = validString(dob) ? ' ' + dob : '',
					nameArr;
				if (validString(name)) {
					var nameArr = name.split(' ');
					this.lastName = nameArr.length > 1 ? nameArr.pop() : '';
					this.middleInitial = nameArr.length > 1 ? nameArr.pop() : '';
					this.firstName = nameArr.join(' ');
					computedName = (this.firstName + (this.middleInitial.length > 0 ? (' ' + this.middleInitial + ' ') : ' ') + this.lastName).trim();
				} else {
					this.lastName = this.middleInitial = this.firstName = computedName = '';
				}
				this.signature = computedName + computeDOB;
			}

			/**
			 * PrintHandler is adopted from agreement-controller.js. It should either be its own service, or incorporated
			 * into an existing service. It should not be local to agreements
			 * @constructor
			 */

			function PrintHandler() {
				/**
				 * Returns the window object.
				 * @public
				 * @returns {Window} $window object
				 */
				this.getWindow = function() {
					return $window;
				};

				/**
				 * Returns the document object.
				 * @public
				 * @returns {document} The document object
				 */
				this.getDocument = function() {
					return $window.document;
				};

				/**
				 * printForm should be either a generic utility or its own service.
				 * on agreement.html, the elementToPrint is form-container
				 */
				this.printForm = function(printTitle, elementToPrint) {
					var $win = this.getWindow(),
						$doc = this.getDocument(),
						accessoPrintWindow;

					if (angular.isUndefined(elementToPrint)) {
						elementToPrint = "form-container"
					}

					if (angular.isUndefined(printTitle)) {
						printTitle = "Print";
					}

					if (!$win.print || navigator.userAgent.toLowerCase().indexOf('android') > -1) {
						this.googlePrint(printTitle, this.getDataURI(printTitle, elementToPrint));
						return;
					}


					//grab the contents of the
					var elementObj = angular.element($doc.querySelector('#'+elementToPrint))[0].innerHTML;
					var html =
						'<html><head>' + '<link rel="stylesheet" type="text/css" href="' + $doc.getElementById('accesso-styles-main').href + ' " /><title></title><script type="text/javascript"></script>' +
						'</head><body>' + elementObj + '</body>';

					//Open a new window and inject HTML into it
					accessoPrintWindow = $win.open('', printTitle, 'width=800, height=800,menubar=yes,scrollbars=yes');
					accessoPrintWindow.document.write(html);

					$timeout(function() {
						if (navigator.userAgent.toLowerCase().indexOf('firefox') > -1) {
							accessoPrintWindow.focus();
							accessoPrintWindow.print();
						} else {
							accessoPrintWindow.document.execCommand('print', false, null);
						}
					}, 2000);

					return false;
				};
				/** Support functions for printForm: getDataURI & googlePrint & loadCloudPrint	 **/
				this.getDataURI = function(printTitle, elementToPrint, embedPrintScript) {
					var printScript =
						(embedPrintScript) ? '<script>$window.onload = function(){ $window.print(); if( $window.stop && navigator.userAgent.toLowerCase().indexOf("firefox") == -1 ){ $window.stop(); } $window.onfocus=function(){ $window.close();} };</script>' : '';

					// TODO: Add IE 9 support as it does not have a btoa function.
					if (!$window.btoa) {
						$window.btoa = Security.base64.encode;
					}

					if (!$window.atob) {
						$window.atob = Security.base64.decode;
					}

					var dataUrl =
						'data:text/html;base64,' +
						$window.btoa(unescape(encodeURIComponent(
							'<link rel="stylesheet" type="text/css" href="' + $window.document.getElementsByTagName('link')[0].href + '" />' + document.getElementById(elementToPrint)
								.innerHTML + printScript
						)));

					return dataUrl;
				};

				this.googlePrint = function(printTitle, dataUrl) {
					var docTitle = String(AppData.alias + "_" + printTitle).toUpperCase(),
						gadget = new cloudprint.Gadget();
					gadget.setPrintDocument('dataUrl', docTitle, dataUrl);
					gadget.openPrintDialog();
				};

				this.loadCloudPrint = function() {
					// Preload google cloud print lib for Android users
					if ((!$window.print || navigator.userAgent.toLowerCase().indexOf('android') > -1)
					   && ! Utilities.scriptExists('//www.google.com/cloudprint/client/cpgadget.js')) {
						Utilities.addScript('//www.google.com/cloudprint/client/cpgadget.js');
						// can't lazyload because this isn't a promise.
					}
				};

				this.loadCloudPrint();
			}

			this.CustomAgreementForm = CustomAgreementForm;
			this.PrintHandler = PrintHandler;
		}
	);

(function() {
	'use strict';
	angular
		.module('agreement')
		.factory('AgreementBootstrapService', AgreementBootstrapService);

	/**
	 * AgreementBootstrapService
	 * @param {Service} $rootScope $rootScope
	 * @param {Service} $transitions $transitions
	 * @param {Service} AppData AppData
	 * @param {Service} AgreementService AgreementService
	 * @param {Service} AgreementModels AgreementModels
	 * @param {Service} LegacyCart LegacyCart
	 * @param {Service} CustomActionService CustomActionService
	 * @param {Service} Enums Enums
	 * @param {Service} JSONValidator JSONValidator
	 * @param {Service} Utilities Utilities
	 * @returns {undefined}
	 * @ngInject
	 */
	function AgreementBootstrapService(
		$rootScope,
		$transitions,
		AppData,
		AgreementService,
		AgreementModels,
		LegacyCart,
		CartService,
		CustomActionService,
		Enums,
		JSONValidator,
		Utilities
	) {
		//once the application is activated, lets go ahead and try to configure
		var listener = $rootScope.$on(Enums.services.APP_ACTIVATED, configureAgreementActions);
		var factory = {
			cartHasAgreements: cartHasAgreements,
			cartHasCustomAgreements: cartHasCustomAgreements,
			isRoutingToAgreement: isRoutingToAgreement
		};

		/**
		 * Configure the agreement actions
		 * @returns {undefined}
		 */
		function configureAgreementActions() {
			var agreementForms,
				agreementsFormConfig = JSONValidator.validate('agreement_form', AppData.settings.agreement_form) ? JSON.parse(AppData.settings.agreement_form) : {};
			if (JSONValidator.validate('custom_agreement_forms', AppData.settings.custom_agreement_forms)) {
				agreementForms = JSON.parse(AppData.settings.custom_agreement_forms);
				agreementForms.forEach(function(form) {
					AgreementService.customAgreementForms.push(new AgreementModels.CustomAgreementForm(form.form_name, form.associated_cart_item_charac_name, form.associated_cart_item_charac_value, form.required, form.disable_birthday_check, form.require_name, {
						recordAcceptance: form.record_acceptance,
						hideSignature: form.hide_signature,
						hideSteps: form.hide_steps,
						cancelRemovesItems: form.cancel_removes_items,
						skipPaymentPlanForms: form.skip_payment_plan_forms
					}));
				});
			}

			CustomActionService.registerCustomAction(CustomActionService.ACTIONS_ENUMS.BILLING_POST_UPDATE_CHECKOUT_CART_INFO, factory.isRoutingToAgreement.bind(null, agreementsFormConfig));
			CustomActionService.registerCustomAction(CustomActionService.ACTIONS_ENUMS.SHIPPING_POST_UPDATE_CHECKOUT_CART_INFO, factory.isRoutingToAgreement.bind(null, agreementsFormConfig));
			CustomActionService.registerCustomAction(CustomActionService.ACTIONS_ENUMS.MASTERPASS_POST_UPDATE_CHECKOUT_CART_INFO, factory.isRoutingToAgreement.bind(null, agreementsFormConfig));
			CustomActionService.registerCustomAction(CustomActionService.ACTIONS_ENUMS.BILLING_ROUTE_ASSESSMENT, factory.isRoutingToAgreement.bind(null, agreementsFormConfig));
			CustomActionService.registerCustomAction(CustomActionService.ACTIONS_ENUMS.CART_ON_PROCESS_UPDATE_CART_CHECKOUT_INFO, factory.isRoutingToAgreement.bind(null, agreementsFormConfig));
			CustomActionService.registerCustomAction(CustomActionService.ACTIONS_ENUMS.STORED_PAYMENTS_POST_UPDATE_CHECKOUT_CART_INFO, factory.isRoutingToAgreement.bind(null, agreementsFormConfig));

			if (agreementsFormConfig.showCustomAgreementsBeforeCart) {
				CustomActionService.registerCustomAction(CustomActionService.ACTIONS_ENUMS.CUSTOM_AGREEMENTS_BEFORE_CART, factory.cartHasCustomAgreements);
			}
			if (agreementsFormConfig.showAgreementsBeforeCart) {
				CustomActionService.registerCustomAction(CustomActionService.ACTIONS_ENUMS.AGREEMENTS_BEFORE_CART, factory.cartHasAgreements);
			}
			//turn off the listener
			listener();
		}

		/**
		 * Checks if cart has custom agreements and routes to pre cart agreements
		 * @function
		 * @public
		 * @param {Transition} trans The transition object
		 * @throws {RouteRejection.UnrecoverableException} throw a route rejection to pre cart agreements
		 * @returns {undefined}
		 */
		function cartHasCustomAgreements(trans) {
			if (AgreementService.doesCartItemsHaveCustomAgreementFormIdentifiers()) {
				trans.abort();
				Utilities.goTo(Enums.routes.PRE_CART_AGREEMENT, null, null, true);
			}
		}

		/**
		 * Checks if cart has agreements and routes to pre cart agreement
		 * @function
		 * @public
		 * @param {Transition} [trans] The transition object
		 * @throws {RouteRejection.UnrecoverableException} throw a route rejection to pre cart agreements
		 * @returns {undefined}
		 */
		function cartHasAgreements(trans) {
			if (CartService.hasPaymentPlan() && !AgreementService.skipPaymentPlanForms()) {
				trans ? trans.abort() : $transitions._router.globals.$get().transition.abort();
				Utilities.goTo(Enums.routes.PRE_CART_AGREEMENT, null, null, true);
			}
		}

		/**
		 * Check status of cart to route to agreement
		 * @param {Object} agreementsConfig agreement app config
		 * @returns {Boolean} is routing to agreement
		 */
		function isRoutingToAgreement(agreementsConfig) {
			if ((!agreementsConfig.showAgreementsBeforeCart && LegacyCart.isPaymentPlanInCart() && !AgreementService.skipPaymentPlanForms()) || (!agreementsConfig.showCustomAgreementsBeforeCart && AgreementService.doesCartItemsHaveCustomAgreementFormIdentifiers())) {
			// If this order has and agreement associated with it,
			// route to agreements view
				$rootScope.routeTo(Enums.routes.AGREEMENT);
				return true;
			} else {
				return false;
			}
		}
		return factory;
	}
})();
/**
 * Created by pMatthews on 9/13/16.
 */
angular.module('package-agreement',[])
	.config(function ($locationProvider, $stateProvider) {
		$stateProvider.state('/package-agreement', {
			url: '/package-agreement/:packageId',
			templateUrl: '/scripts/modules/agreement/modules/package-agreement/views/package-agreement.html',
			controller: 'PackageAgreementController',
			resolve: {
				load: function( $rootScope, Utilities ){
					$rootScope.showSpinner();
					return Utilities.cacheBustAndLazyLoad([
						'/scripts/modules/agreement/modules/package-agreement/controllers/package-agreement-controller.js'
					]);
				},
				initialData: function(load, Bootstrap) {
					return Bootstrap.bootstrapApplication();
				},
				assessRoutability:function(initialData,RouteRejectionService,Package,$state, $transition$){
					var rejectionRoute = Package.assessRoutabilityOfXFC($transition$.params().packageId);
					if(rejectionRoute.length > 0){
							throw new RouteRejectionService.UnrecoverableException(rejectionRoute);
					}else {
						return true;
					}
				},
				xfcMap: function(assessRoutability, Package) {
					return Package.buildXFCMap();
				},
				initializeAgreement: function(xfcMap,  Language, Package, PackageAgreementService, $rootScope) {
					var includeSignedForms = false;  // Just defined to make it clear what's happening in the next function call
					$rootScope.showSpinner( Language.getLocale('ApplicationLabels', 'checkingPackageForms') );
					return PackageAgreementService.initializeForAllItemsInItemsToBeAdded(Package.itemsToBeAdded, includeSignedForms).then(function(){
						$rootScope.hideSpinner();
					});
				},
				validateRoute: function(initializeAgreement, $q, PackageAgreementService, RouteRejectionService) {
					if (PackageAgreementService.currentFormList.length<1) {
						return new $q(RouteRejectionService.BypassXFCExceptionCallback);
					} else {
						return true;
					}
				}
			}
		})
	}).run(function(ExtraFlow) {
		ExtraFlow.registerXMC( 'package-agreement', {
			name: 'package-agreement',
			view: 'package-agreement',
			doEditMode: false,
			lockQuantity: true,
			writeSingleCharac: false,
			enabled: true,
			type: 'alternateFlowModule'
		})
	});
/**
 * Created by pMatthews on 9/15/16.
 * packageAgreementDirective will cycle through the forms on a package, displaying each one with the appropriate
 * input fields (if any are needed).
 */
angular.module('package-agreement')
	.directive('packageAgreementDirective'
		, function(Language) {
			return {
				restrict: 'E',
				scope: {
					formList: '=', // typically found by calling PackageAgreementService.getAndFilterForms
					formIdx: '=' //the index of the current form in the form list
				},
				templateUrl: '/scripts/modules/agreement/modules/package-agreement/views/package-agreement-directive.html',
				controller: 'PackageAgreementDirectiveController',
				link: function () {
					setTimeout(function () {
						var
							formElement = document.getElementById('package-agreement-form-container'),
							footer = document.getElementById('package-agreement-footer'),
							nonScrollable = Number(formElement.clientHeight - footer.clientHeight - 5);
						if (nonScrollable>0 && formElement.style) {
							// formElement.style.height = nonScrollable.toString()+'px';
						}
					}, 0);
				}
			}
		});

/**
 * Created by pMatthews on 9/15/16.
 */
angular.module('package-agreement').controller( 'PackageAgreementDirectiveController', function(
	Utilities,
	Language,
	PackageAgreementService,
	$scope
){
	function initializeController() {
		$scope.formCount = $scope.formList.length;
		$scope.i18n = Language;
		$scope.currentGuardian = {
			first_name: '',
			last_name:'',
			relationship: ''
		};
		$scope.$watch('formIdx',function(){
			var scrollable = document.getElementById('package-agreement-form-container');
			if (angular.isDefined(scrollable) && scrollable.scrollTop>0) {
				scrollable.scrollTop = 0;
			}
			$scope.thePackageAgreementGuardianForm.$setPristine();
		});
		addScrollEvent();
	}

	function addScrollEvent() {
		var scrollable = angular.element(document.querySelector('#package-agreement-form-container'));
		if (angular.isDefined(scrollable)) {
			scrollable.bind(
				'scroll',
				function () {
					var scrollTop = this.scrollTop;
					var iheight = this.clientHeight;
					var sheight = this.scrollHeight;

					if (scrollTop + 5 >= sheight - iheight) {
						$scope.formList[$scope.formIdx].scrolledToBottom = true;
					}
				}
			);
		}
	}
	$scope.guardianChanged=function(form) {
		if ($scope.currentGuardian.first_name != form.guardianFirstName ||
			$scope.currentGuardian.last_name != form.guardianLastName ||
			$scope.currentGuardian.relationship != 	form.relationship) {
			$scope.currentGuardian.first_name = form.guardianFirstName;
			$scope.currentGuardian.last_name = form.guardianLastName;
			$scope.currentGuardian.relationship = form.relationship;
			PackageAgreementService.unsignForm(form);
		}
	};
	$scope.getFullVersion = function(form){
		return  (angular.isDefined(form) &&  angular.isDefined(form.form_name) && angular.isDefined(form.language) && angular.isDefined(form.version)) ? form.form_name.toUpperCase() + '_' + form.language.toUpperCase() + '_V' + form.version.toUpperCase() : '';
	};

	initializeController();
});
/**
 * Created by pMatthews on 9/13/16.
 */
angular.module('package-agreement').factory('PackageAgreementService', function(
	AppData,
	LegacyCart,
	Enums,
	RouteRejectionService,
	Language,
	Utilities,
	Package,
	PackageAgreementModels,
	$filter,
	$q,
	$rootScope // just for the pending requests
){
	var factory = {
		pkgFormRequests: new PackageAgreementModels.RequestStorage(), // stores lists of forms associated with each package
		formRequests: new PackageAgreementModels.RequestStorage(), // stores actual form calls.
		currentFormList: [],
		characPrefix: characPrefix,
		initializeForItem: initializeForItem,
		initializeForAllItemsInItemsToBeAdded: initializeForAllItemsInItemsToBeAdded,
		signForm: signForm,
		unsignForm: unsignForm,
		signed: signed,
		setGuestAge: setGuestAge,
		setFormNames: setFormNames,
		getAgeFromCharacs: getAgeFromCharacs,
		reset: reset,
		characsForItem: characsForItem,
		removeCharacs: removeCharacs
	},
		signedForms = [];

	function characPrefix(form_id) {
		return "form_accepted_for_"+form_id.toString()+"_";
	}

	function reset() {
		signedForms = [];
		factory.currentFormList = [];
		// factory.pkgFormRequests.clear();   // no need to ever clear the request storage
		// factory.formRequestrs.clear();     // no need to ever clear the request storage
	}

	/**
	 * signForm just stores that the form has been signed. It doesn't do anything else.
	 * @param form
	 */
	function signForm(form) {
		if (angular.isUndefined(form)) {
			return;
		}
		if (form.signForm()) {
			if (! factory.signed(form.id,form.guest_no)) {
				signedForms.push({ form_id: form.form_id, guest_no: form.guest_no});
			}
		}
	}
	function unsignForm(form) {
		if (angular.isUndefined(form) || ! form.signed) {
			return;
		}
		form.signed = false;
		form.signature  = '';
		for (var i= signedForms.length-1; i >=0; i--) {
			if (signedForms[i].form_id == form.form_id && signedForms[i].guest_no == form.guest_no) {
				signedForms.splice(i,1);
			}
		}
	}
	/**
	 * Not all situations have a guest_no, but we don't have any other way of identifying who is signing the agreement form.
	 * Treat two blank guest_nos (either undefined or blank) as being blank.
	 *
	 * @param guest_noA
	 * @param guest_noB
	 * @returns {boolean}
	 */
	function guestsTheSame(guest_noA, guest_noB) {
		var a = angular.isDefined(guest_noA) ? guest_noA : '',
			b = angular.isDefined(guest_noB) ? guest_noB : '';
		return a == b;
	}
	/**
	 * signed returns true if the form has already been signed, either in the response from the API
	 * or in the current cart.
	 * @param formId
	 * @param guest_no
	 * @returns {boolean}
	**/
	function signed(formId, guest_no) {
		for (var i=0; i<signedForms.length; i++) {
			if (signedForms[i].form_id == formId && guestsTheSame(signedForms[i].guest_no, guest_no)) {
				return true;
			}
		}
		// now check if there's a version in the cart that has been signed
		if (angular.isUndefined(LegacyCart.cartItems)) {
			return false;
		}
		for (i = 0; i < LegacyCart.cartItems.length; i++ ) {
			var characs = angular.isArray(LegacyCart.cartItems[i].CHARACS) ? LegacyCart.cartItems[i].CHARACS : [LegacyCart.cartItems[i].CHARACS],
				characName = characPrefix(formId)+'datetime',
				itemIsForGuestNo = false,
				itemIsAccepted = false;

			for (var j = 0; j < characs.length; j++) {
				itemIsForGuestNo = itemIsForGuestNo || guestsTheSame(characs[j].guest_no, guest_no);
				itemIsAccepted = itemIsAccepted || angular.isDefined(characs[j][characName]);
				if (itemIsForGuestNo && itemIsAccepted) {
					// we found an item that has a signed form for this guest. Drop out and return true!
					return true;
				}
			}
		}
		return false;
	}

	/**
	 * addToCurrentFormList prevents the same form from being added multiple times for the same guest.
	 * @param newForm
	 */
	function addToCurrentFormList(newForm) {
		if (factory.currentFormList.length<1 || ! factory.currentFormList.some( function(f){ return f.equivalent(newForm); })) {
			factory.currentFormList.push(newForm);
		}
	}

	function convertFormResponseToFormData(form, validForm){
		var result = {};
		if (! validForm || angular.isUndefined(form)) {
			result.validForm = false; // flag to let us know we don't have a good form.
		} else {
			result.validForm = true;
			if (angular.isDefined(form.F)) {
				var fields = angular.isArray(form.F) ? form.F : [form.F];
				fields.forEach(function(f){
					result[f.name]=Language.replaceAllMultiple(['@@todayDate'], [$filter('date')(new Date(), AppData.settings.date_format)],f.value);
				});
			}

		}
		return result;
	}
	/**
	 * loadUnloadedForms goes through the currentFormList, loading all the forms that have not yet been loaded.
	 * @returns {*}
	 */
	function loadUnloadedForms() {
		// drop out if there are no forms left
		if (angular.isUndefined(factory.currentFormList) || factory.currentFormList.length<1) {
			return $q.when();
		}
		var firstUnfoundForm = undefined;
		for (var i=0; i<factory.currentFormList.length; i++ ) {
			if (angular.isUndefined(factory.currentFormList[i].formData)) {
				firstUnfoundForm = factory.currentFormList[i];
				break;
			}
		}
		if (angular.isUndefined(firstUnfoundForm)) {
			return $q.when();
		}
		var reqObj = new PackageAgreementModels.ApiRequest( {
			   form_name: firstUnfoundForm.form_name,
				language: firstUnfoundForm.language,
				cart_id: AppData.cart.cart_id,
				cart_key: AppData.cart.cart_key} ),

			existingReq = factory.formRequests.get(reqObj);

		if (angular.isDefined(existingReq)) {
			firstUnfoundForm.formData = angular.isDefined(existingReq.response) ? convertFormResponseToFormData(existingReq.response, true) : convertFormResponseToFormData(undefined,false);
			// return the next unloadedform
			return loadUnloadedForms();
		}
		// if we made it here, the response was not in our cache.
		$rootScope.pendingRequests.push( Enums.services.GET_FORM);
		return AppData.fetch(Enums.services.GET_FORM, false, reqObj.request, false).then(
			function(data){
				$rootScope.removePendingRequest( Enums.services.GET_FORM);
				reqObj.response = undefined;
				if (data.status == Enums.status.OK) {
					reqObj.response = data.FORM;
					firstUnfoundForm.formData = convertFormResponseToFormData(reqObj.response, true);
					factory.formRequests.add(reqObj);
				} else {
					firstUnfoundForm.formData = convertFormResponseToFormData(undefined,false);
				}
				// load the next unloaded form:
				return loadUnloadedForms();
			}
		);
	}

	/**
	 * getAndFilterForms executes the getForms promise and fills the service's currentFormList appropriately.
	 * @param requestData
	 * @returns {*}
	 */
	function getAndFilterForms(requestData) {
		if (angular.isUndefined(requestData)) {
			return $q.when();
		}
		return getFormsPromise(requestData.package_id, requestData.customer_type, requestData.start_time, requestData.guest_no).then(
			function (reqObj) {
				if (angular.isDefined(reqObj.response) && angular.isDefined(reqObj.response)) {
					var forms = angular.isArray(reqObj.response.FORM) ? angular.copy(reqObj.response.FORM) : [angular.copy(reqObj.response.FORM)];
					forms.forEach(function(f){
						if (f.language == AppData.language && (requestData.includeSigned || ! signed(f.id, requestData.guest_no))) {
							var newForm = new PackageAgreementModels.PackageAgreementForm(requestData.item_ref, f, requestData.package_id, requestData.customer_type, requestData.guest_no, requestData.guest_age, requestData.firstName, requestData.lastName);
							addToCurrentFormList(newForm);
						}
					});
					// factory.currentFormList holds the list of all the forms to be loaded, filtered and with duplicates removed
					// Now make a call to get the data for each individual form
					return loadUnloadedForms();
				} else {
					return $q.when();
				}
			}
		);
	}


	function packageHasForms(packageId) {
		var pkg = Package.getPackageByID(packageId);
		return (Utilities.safelyCheckPropertyOnObject('pkg.CHARACS.hasForms',pkg) && Utilities.getBoolean(pkg.CHARACS.hasForms));
	}

	/**
	 * The parameter for getAgeFromCharacs doesn't always have to be a characs object. The SeasonPassSelectItems
	 * have the ph_age and ph_birthdate properties, as well.
	 * @param characs
	 * @returns {*}
	 */
	function getAgeFromCharacs(characs) {
		if (angular.isDefined(characs) && !Utilities.isEmpty(characs.ph_age)) {
			return Utilities.forceInt(characs.ph_age);
		} else if (angular.isDefined(characs) && !Utilities.isEmpty(characs.ph_birth_date)) {
			return Utilities.calculateAgeGivenDateString($filter('date')(new Date(characs.ph_birth_date), 'yyyy-MM-dd'));
		}
		return 999; // if there is no guest age, set it to be high enough to never show the guardian inputs.
	}

	/**
	 * The parameter for setGuestAge doesn't always have to be a characs object. The SeasonPassSelectItems
	 * have the ph_age and ph_birthdate properties, as well.
	 *
	 * @param characs
	 */
	function setGuestAge(characs) {
		var guest_age = getAgeFromCharacs(characs);
		factory.currentFormList.forEach(function(form){
			if (form.guest_age != guest_age) {
				unsignForm(form);
			}
			form.guest_age = guest_age;
		});
	}

	function setFormNames(firstName, lastName, guardianFirstName, guardianLastName) {
		factory.currentFormList.forEach(function(form){
			form.setNames(firstName, lastName, guardianFirstName, guardianLastName);
			if (! form.signed) {
				unsignForm(form);
			}
		});
	}

	function initializeForAllItemsInItemsToBeAdded(itemsToBeAdded, includeSigned) {
		var promises = new PackageAgreementModels.PromiseChain(getAndFilterForms);

		reset();
		itemsToBeAdded.forEach(function(item) {
			var characs = angular.isUndefined(item.CHARACS) ? undefined : angular.isArray(item.CHARACS) ? item.CHARACS[0] : item.CHARACS,
				guest_age = getAgeFromCharacs(characs);

			if (packageHasForms(item.package_id)) {
				promises.addPromiseData({
					includeSigned: includeSigned,
					package_id: item.package_id,
					customer_type: item.customer_type,
					start_time: angular.isDefined(characs.start_time) ? characs.start_time : '',
					guest_no: angular.isDefined(characs.guest_no) ? characs.guest_no : '',
					firstName: angular.isDefined(characs.ph_first_name) ? characs.ph_first_name : '',
					lastName: angular.isDefined(characs.ph_last_name) ? characs.ph_last_name : '',
					guest_age: guest_age,
					item_ref: item
				});
			}
		});
		return promises.resolve();
	}

	/**
	 * initializeForItem was designed for Season Pass Select Items, but should work for any item. Just make sure
	 * the data is set properly (customer_type, start_time,guest_no, firstName, lastName, guest_age)
	 * @param packageId
	 * @param item
	 * @param data
	 * @param includeSigned
	 */
	function initializeForItem(packageId, item, data, includeSigned) {
		var promises = new PackageAgreementModels.PromiseChain(getAndFilterForms),
			promiseData = angular.copy(data);
		reset();
		promiseData.includeSigned = includeSigned;
		promiseData.package_id = packageId;
		promiseData.item_ref = item;
		promises.addPromiseData(promiseData);
		return promises.resolve();
	}

	/**
	 * getFormsPromise returns a promise that is resolved with the complete request object data (including the response)
	 * @param packageId
	 * @param customerType
	 * @param startTime
	 * @param guest_no
	 * @returns {*}
	 */
	function getFormsPromise(packageId, customerType, startTime, guest_no) {
		var reqObj = new PackageAgreementModels.ApiRequest( {
			   merchant_id: AppData.merchantId,
				package_id: packageId,
				customer_type: customerType,
				start_time: startTime,
				guest_no: guest_no } ),
				existingReq = factory.pkgFormRequests.get(reqObj);

		// If the request already exists, return a promise with that request filtered.
		if (angular.isDefined(existingReq)) {
			return $q.when(existingReq);
		}
		// if we made it here, the response was not in our cache.
		$rootScope.pendingRequests.push( Enums.services.GET_PACKAGE_FORMS);
		return AppData.fetch(Enums.services.GET_PACKAGE_FORMS, false, reqObj.request, false).then(
			function(data){
				$rootScope.removePendingRequest( Enums.services.GET_PACKAGE_FORMS);
				reqObj.response = undefined;
				if (data.status == Enums.status.OK) {
					// if no forms are available, the data.FORMS.FORM node will not be defined
					if (Utilities.safelyCheckPropertyOnObject("data.FORMS.FORM",data)) {
						reqObj.response = data.FORMS;
					}
					factory.pkgFormRequests.add(reqObj);
				}
				// resolve the promise regardless of whether or not the call is successful
				return reqObj;
			}
		);
	}

	function removeCharacs(item, characs) {
		if (angular.isUndefined(characs)) {
			return;
		}
		if (angular.isDefined(item)) {
			factory.currentFormList.forEach(function(form) {
				if (angular.isDefined(form.item_ref) && form.item_ref == item) {
					var fCharacs = form.characsForForm();
					for( var key in fCharacs ){
						if (angular.isDefined(characs[key])) {
							delete(characs[key]);
						}
					}
				}
			});
		}
	}
	/**
	 * characsForItem returns a class containing all the characs set by all the forms associated with
	 * the item passed in. If there are no characs, it returns an empty class
	 * @param item
	 * @returns {{}}
	 */
	function characsForItem(item) {
		var characs = {};
		if (angular.isDefined(item)) {
			factory.currentFormList.forEach(function(form) {
				if (angular.isDefined(form.item_ref) && form.item_ref == item) {
					angular.extend(characs, form.characsForForm());
				}
			});
		}
		return characs;
	}

	return factory;

});


/**
 * Created by pMatthews on 9/13/16.
 */
angular.module('package-agreement').service('PackageAgreementModels', function($q, $window, $timeout, $filter, ClientInfo, Utilities) {

	function ApiRequest(request) {
		this.request = request;
		this.response = undefined;
		// equals is true when the two requests are considered equivalent. It ignores responses
		this.equals = function(otherRequest) {
			var result = (angular.isDefined(this.request) && angular.isDefined(otherRequest) && angular.isDefined(otherRequest.request));
			if (result) {
				for( var p in this.request){
					if (this.request.hasOwnProperty(p) && p!= 'request_token') {
						// the new request will not have as many properties as the ones in storage,
						// because the ones in storage have properties added to them by AppData.fetch
						result = result && (! otherRequest.request.hasOwnProperty(p) || this.request[p] == otherRequest.request[p]);
					}
				}
			}
			return result;
		};
		this.valid = function() {
			/* Without inheritance, this is useless... */
			return true;
		};
		this.copy = function(otherRequest, copyResponse) {
			this.request = angular.copy(otherRequest.request);
			if (copyResponse) {
				this.response = angular.copy(otherRequest.response);
			} else {
				this.response = undefined;
			}
		};
	}

	/**
	 * RequestStorage is a caching system that works with instances of ApiRequest.
	 *    (All req parameters should be ApiRequest objects)
	 *
	 * Usage:
	 *   Add ApiRequests to storage by calling the add method. Add either pushes the object into
	 *   storage or updates al already existing request.
	 *
	 *   Example flow:
	 *	   0. Create storage (prior to making any requests):
	 *	   			var storage = new RequestStorage();
	 *     1. Create ApiRequest:
	 *     			var req = new ApiRequest({requestData});
	 *     2. Check if it already exists:
	 *     			var existingReq = storage.get(req);
	 *     3. Use the response if it's there:
	 *     			if (angular.isDefined(existingReq) && angular.isDefined(existingReq.response)) {
	 *     				processResponse(existingReq.response);
	 *     			}
	 *     4. If the response is not there, make the appdata call:
	 *     			AppData.fetch(req.request...).then(function(data){
	 *     		 		req.response = data;
	 *     		 		storage.add(req); // this puts it in storage, updating the response
	 *     				processResponse(data);
	 *     			});
	 *
	 *
	 * @constructor
	 */
	function RequestStorage() {
		this.storage = [];
		this.get = function(req) {
			for (var i=0; i<this.storage.length; i++) {
				if (this.storage[i].equals(req)) {
					return this.storage[i];
				}
			}
			return undefined;
		};
		this.clear = function() {
			this.storage = [];
		};
		this.add = function(req) {
			var existing = this.get(req);
			if (angular.isDefined(existing)) {
				existing.response = req.response
			} else {
				this.storage.push(req);
			}
		}
	}

	/**
	 * PromiseChain allows you to build a chain of promises from data.
	 *    This is ideal for building a chain of AppData requests, without actually
	 *    calling AppData until the entire chain is prepared.
	 *
	 * Usage:
	 *   1. Create a chain: var promisesPromises = new PromiseChain(promiseCallback, [{d1}, {d2}, {d3}...]);
	 *   2. Add more data: promisesPromises.addPromiseData({d4});
	 *   3. resolve the promise chain: var doIt = PromiseChain.resolve(); Resolve returns a promise.
	 *
	 *   Your callback function needs to be of the format function(data) { return a promise built with data }
	 *   For example, a callback function could be of this form:
	 *
	 *   function promiseCallback(data) {
	 *     var reqObj = buildReqObj(data);
	 *     return AppData.fetch(Enums.services.GET_FORM, false, reqObj.request, false);
	 *   }
	 *
	 * @param arrayOfPromises
	 */
	function PromiseChain(callbackToBuildPromise, arrayOfData) {
		this.storage = angular.isDefined(arrayOfData) ? arrayOfData: [];
		this.callbackToBuildPromise = callbackToBuildPromise;

		this.addPromiseData = function(data){
			this.storage.push(data);
		};
		this.resolve = function() {
			if (this.storage.length<1) {
				return $q.when();
			} else {
				return this.resolveOne(this, 0);
			}
		};
		this.promise = function(data) {
			return this.callbackToBuildPromise(data);
		};
		this.resolveOne = function(promisesPromises, idx) {
			if (idx >= promisesPromises.storage.length) {
				return $q.when()
			}
			return promisesPromises.promise(promisesPromises.storage[idx]).then(
				function() {
					return promisesPromises.resolveOne(promisesPromises,idx+1);
				}
			);
		}
	}

	PackageAgreementForm = function(item_ref, f, packageId, customerType, guest_no, guest_age, firstName, lastName) {
		for( var p in f){
			if (f.hasOwnProperty(p)) {
				this[p]=f[p];
			}
		}
		// item_ref connects each form with the item (typically in ItemsToBeAdded) that it was created for.
		this.item_ref = item_ref;
		// if there is no accept_age, set it to 0. This is the minimum age, below which additional inputs need to be shown.
		this.accept_age = Utilities.forceInt(this.accept_age);

		this.packageId = packageId;
		this.customerType = customerType;
		this.formData = undefined;
		this.guest_no = guest_no;
		// age, first name, and last name are all required.
		this.guest_age = Utilities.forceInt(guest_age);
		this.firstName = angular.isDefined(firstName) ? firstName : '';
		this.lastName = angular.isDefined(lastName) ? lastName : '';
		this.signature = '';
		this.guardianFirstName ='';
		this.guardianLastName ='';
		this.relationship = '';
		this.signed = false;
		this.termsChecked = false;
		this.attemptedToSign = false;
		this.errored = false;
		this.signForm = function() {
			if (! this.inputsValid(false)) {
				this.errored = true;
				return false;
			}
			if (this.needsAgeInputs()) {
				this.signature = this.guardianFirstName +' '+this.guardianLastName;
			} else {
				this.signature = this.firstName + ' ' + this.lastName;
			}
			this.attemptedToSign = false;
			this.signed = true;
			this.errored = false;
		};
		this.prepFormForViewing = function() {
			this.attemptedToSign = false;
		};
		this.checkTerms = function() {
			this.termsChecked = true;
		};
		this.setNames = function(firstName, lastName, guardianFirstName, guardianLastName) {
			this.firstName = angular.isDefined(firstName) ? firstName: '';
			this.lastName = angular.isDefined(lastName) ? lastName: '';
			if (this.firstName != firstName || this.lastName != lastName) {
				this.signed = false;
			}
			if (this.needsAgeInputs()) {
				if (this.guardianFirstName != guardianFirstName || this.guardianLastName != guardianLastName) {
					this.signed = false;
				}
				if (! this.guardianFirstName) {
					this.guardianFirstName = angular.isDefined(guardianFirstName) ? guardianFirstName : '';
				}
				if (! this.guardianLastName) {
					this.guardianLastName = angular.isDefined(guardianLastName) ? guardianLastName : '';
				}
			}

		};
		this.inputsValid = function(checkIfSigned) {
			// names can be blank or undefined
			var guardianSigned = (! this.needsAgeInputs() || (this.guardianFirstName && this.guardianLastName && this.relationship));
			return guardianSigned && this.termsChecked && (this.signed || ! checkIfSigned);
		};
		this.needsAgeInputs = function() {
			return this.accept_age > this.guest_age;
		};
		this.characsForForm = function() {
			var result = {},
				characPrefix = 'form_accepted_for_'+this.id+'_';

			if (this.needsAgeInputs()) {
				result[characPrefix + 'first_name'] = this.guardianFirstName;
				result[characPrefix + 'last_name'] = this.guardianLastName;
				result[characPrefix + 'relationship'] = this.relationship;
			}
			result[characPrefix+'datetime'] = $filter('date')(new Date(), 'yyyy-MM-dd HH:mm');
			return result;
		};
		this.localeForError = function(scrolledToBottom) {
			return (this.accept_age>this.guest_age)  ? 'underAgeScrollThroughTermsMsg': 'scrollThroughTermsMsg' ;
		};
		/**
		 * equivalent is not equal!
		 *
		 * equivalent returns true if the two forms are the same from the user's perspective - if
		 * they have the same ID and are for the same guest. We could also check customer type, package id, and more,
		 * but ID and guest_no are used because once a form has been signed for one guest, it does not have to be signed
		 * for that guest again.
		 * @param otherForm
		 */
		this.equivalent = function(otherForm) {
			return (this.id == otherForm.id && this.guest_no == otherForm.guest_no && this.language == otherForm.language);
		};


	};

	/**
	 * PrintHandler is adopted from agreement-controller.js. It should either be its own service, or incorporated
	 * into an existing service. It should not be local to agreements
	 * @constructor
	 */

	function PrintHandler() {
		/**
		 * printForm should be either a generic utility or its own service.
		 * on agreement.html, the elementToPrint is form-container
		 */
		this.printForm = function(printTitle, elementToPrint) {
			if (angular.isUndefined(elementToPrint)) {
				elementToPrint = "form-container"
			}
			if (angular.isUndefined(printTitle)) {
				printTitle = "Print";
			}
			if (!$window.print || navigator.userAgent.toLowerCase().indexOf('android') > -1) {
				this.googlePrint(printTitle, this.getDataURI(printTitle, elementToPrint));
				return;
			}

			var isSafariDesktop = (navigator.userAgent.indexOf('Mac') != -1 && navigator.userAgent.indexOf('Safari') != -1 && ClientInfo.deviceType == 'desktop');
			var isIE11 = (navigator.userAgent.indexOf('MSIE') !== -1 || navigator.appVersion.indexOf('Trident/') !== -1 &&
			navigator.userAgent.match(/rv:11/));

			//for IE 11 only and Mac Safari Desktop
			var myWindow;
			if (isSafariDesktop || isIE11) {

				//grab the contents of the
				var elementObj = angular.element(document.querySelector('#'+elementToPrint))[0].innerHTML;
				var html =
					'<html><head>' + '<link rel="stylesheet" type="text/css" href="' + $window.document.getElementById('accesso-styles-main').href + ' " /><title></title><script type="text/javascript"></script>' +
					'</head><body>' + elementObj + '</body>';

				//Open a new window and inject HTML into it
				myWindow = $window.open('', printTitle, 'width=800, height=800,menubar=yes,scrollbars=yes');
				myWindow.document.write(html);
				$timeout(function() {
					myWindow.document.execCommand('print', false, null);
				}, 2000);


			} else {
				myWindow = $window.open(this.getDataURI(printTitle, elementToPrint));
			}



			return false;
		};
		/** Support functions for printForm: getDataURI & googlePrint & loadCloudPrint	 **/
		this.getDataURI = function(printTitle, elementToPrint, embedPrintScript) {
			var printScript =
				(embedPrintScript) ? '<script>$window.onload = function(){ $window.print(); if( $window.stop && navigator.userAgent.toLowerCase().indexOf("firefox") == -1 ){ $window.stop(); } $window.onfocus=function(){ $window.close();} };</script>' : '';

			// TODO: Add IE 9 support as it does not have a btoa function.
			if (!$window.btoa) {
				$window.btoa = Security.base64.encode;
			}

			if (!$window.atob) {
				$window.atob = Security.base64.decode;
			}

			var dataUrl =
				'data:text/html;base64,' +
				$window.btoa(unescape(encodeURIComponent(
					'<link rel="stylesheet" type="text/css" href="' + $window.document.getElementById('accesso-styles-main').href + '" />' + document.getElementById(elementToPrint)
						.innerHTML + printScript
				)));

			return dataUrl;
		};

		this.googlePrint = function(printTitle, dataUrl) {
			var docTitle = String(AppData.alias + "_" + printTitle).toUpperCase(),
				gadget = new cloudprint.Gadget();
			gadget.setPrintDocument('dataUrl', docTitle, dataUrl);
			gadget.openPrintDialog();
		};

		this.loadCloudPrint = function() {
			// Preload google cloud print lib for Android users
			if ( (!$window.print || navigator.userAgent.toLowerCase().indexOf('android') > -1)
			   &&  ! Utilities.scriptExists('//www.google.com/cloudprint/client/cpgadget.js'))
			{
				Utilities.addScript('//www.google.com/cloudprint/client/cpgadget.js');
				// can't lazyload because this isn't a promise.
			}
		};

		this.loadCloudPrint();

	};

	return {
		PackageAgreementForm: PackageAgreementForm,
		ApiRequest: ApiRequest,           // should be moved out of this model
		RequestStorage: RequestStorage,   // should be moved out of this model
		PromiseChain: PromiseChain        // should be moved out of this model
	};

});

(function() {
	'use strict';

	angular
		.module('faq-page', ['app'])
		.config(config);

	/**
	 * Our module configuration
	 * @param {Service} $stateProvider The state provider
	 * @returns {undefined}
	 * @ngInject
	 */
	function config($stateProvider) {
		$stateProvider.state('faq-page', {
			controller: 'KnowledgeBaseCtrl',
			params: { disableFaqInModal: true },
			resolve: {
				initialData: function($rootScope, Bootstrap) {
					$rootScope.showSpinner();
					return Bootstrap.bootstrapApplication(undefined, true);
				},
				loadAssets: function(Utilities) {
					return Utilities.cacheBustAndLazyLoad([
						'scripts/modules/faq-page/faq-page.css'
					]);
				}
			},
			templateUrl: '/scripts/modules/faq-page/faq-page.html',
			url: '/faq-page'
		});
	}
}());
'use strict';
angular.module('autofill', []);
'use strict';
angular
	.module( 'autofill' )
	.directive( 'autofill', function( $log, $timeout, AutofillService ){

		return {
			restrict: 'A',
			controller: function( $scope ){

				/*
				 *	This controller would be used in special cases - An input directive that exists as a child on the form (where this directive lives)
				 *	It's not perfect, because it requires logic in the other directive (not completely encapsulated here),
				 *	But I'm not sure if there's a way around that due to lifecycle and angular's recommended method for directive<->directive communication is this.
				 */
				this.get = function( name ){

					if( $scope.autofill ){

						return AutofillService.get( name );
					}
					else{

						return undefined;
					}
				};
			},
			link: function( scope, elem, attrs ){

				// Only do this if it's turned on - duh
				if( scope.autofill ){

					if( angular.isDefined( attrs.name ) ){

						AutofillService.autofill( scope[ attrs.name ] );
					}
					else{

						$log.error( 'Autofill will only work if the name attribute is used for the form.' )
					}
				}
			}
		};
	});
'use strict';
angular
	.module( 'autofill' )
	.factory( 'AutofillService', function(){

		var factory = {
			get: get,
			autofill: autofill
		};

		// These could be abstracted to a models service which could potentially handle accepting data from a config.
		var _models = {
			'firstName': 'Shopland',
			'middleName': 'V',
			'lastName': 'Five',
			'phone,homePhone': '1234567890',
			'email': 'shopv5dev@accesso.com',
			'birthDate': '07/26/1988',
			'gender': 'm',
			'address,streetAddress': '1025 Greenwood Boulevard',
			'country': 'US',
			'zipCode': '32746',
			'state': 'FL',
			'province': 'FL',
			'city': 'Orlando'
		};

		_models.gender = Math.round( Math.random() ) ? 'm' : 'f';

		// To get the model for a specific field
		function get( name ){

			for( var inputName in _models ){

				if( inputName.indexOf( name ) !== -1 ){

					return _models[ inputName ];
				}
			}

			return undefined;
		};

		// Autofill all fields on a given form
		function autofill( form ){

			angular.forEach( form, function( value, key ){

				if( key.indexOf( '$' ) === -1 && value.$isEmpty( value.$viewValue ) ){

					// We can and should remove this loop if we can enforce form fields being consistently named
					for( var inputName in _models ){

						if( inputName.indexOf( key ) !== -1 ){

							value.$setViewValue( _models[ inputName ] );
							break;
						}
					};
				}
			});
		};

		return factory;
	});
(function() {
	'use strict';

	angular
		.module('app')
		.service('PortalRoutingModalService', PortalRoutingModalService);

	/**
	 * PortalRoutingModalService
	 * @constructor
	 * @param  {Object} $uibModal $uibModal
	 * @param  {Object} $rootScope $rootScope
	 * @param  {Object} $q $q
	 * @param  {Object} Utilities Utilities
	 * @param  {Object} JSONValidator JSONValidator
	 * @param  {Object} AppData AppData
	 * @returns {undefined}
	 * @ngInject
	 */
	function PortalRoutingModalService($uibModal, $rootScope, $q, Utilities, JSONValidator, AppData) {
		var service = { display: display };

		return service;

		/**
		 * Opens the Portal Routing Modal (previously called Complete Bookings Modal)
		 * Account Portal and Booking Portal have their own implementation of this method
		 * @returns {Promise} Promise
		 */
		function display() {
			var portalTicketsExist = false;
			if (Utilities.safelyCheckPropertyOnObject('AppData.settings.booking_portal', AppData) && JSONValidator.validate('booking_portal', AppData.settings.booking_portal)
					&& JSON.parse(AppData.settings.booking_portal).enableCompleteBookingsModal && Utilities.safelyCheckPropertyOnObject('AppData.GuestViewOrder.VIEW_ORDER_REPLY', AppData)) {
				portalTicketsExist = AppData.GuestViewOrder.VIEW_ORDER_REPLY.TICKET_DETAILS_REPLY.TICKET.some(function hasBookingNode(ticketObj) {
					return Array.isArray(ticketObj.BOOKING);
				});
				if (portalTicketsExist) {
					$rootScope.modalOpen = true;
					return $uibModal.open({
						backdrop: 'static',
						controller: 'PortalRoutingModalController',
						controllerAs: 'vm',
						size: 'round-trip-alert',
						templateUrl: 'scripts/modules/portals/portal-routing-modal/portal-routing-modal.html'
					}).result;
				}
			}

			return $q.resolve();
		}
	}
})();
(function() {
	'use strict';

	angular
		.module('app')
		.controller('PortalRoutingModalController', PortalRoutingModalController);

	/**
	 * Our constructor
	 * @ngInject
	 * @param {Service} AppData AppData
	 * @param {Service} $uibModalInstance $uibModalInstance
	 * @param {Service} $rootScope $rootScope
	 * @param {Object} BookingPortalLocaleSection BookingPortalLocaleSection
	 * @param {String|undefined} BookingPortalMerchantSuffix BookingPortalMerchantSuffix
	 * @param {Service} BookingPortalRoutingService BookingPortalRoutingService
	 * @param {Service} AccountPortalRoutingService AccountPortalRoutingService
	 * @param {Service} Utilities Utilities
	 * @returns {self} our instance
	 * @constructor
	 */
	function PortalRoutingModalController(
		AppData,
		$uibModalInstance,
		$rootScope,
		BookingPortalLocaleSection,
		BookingPortalMerchantSuffix,
		BookingPortalRoutingService,
		AccountPortalRoutingService,
		Utilities
	) {
		var vm = this,
			checkProp = Utilities.checkProp,
			merge = Object.assign || angular.merge;

		merge(vm, {
			localeSection: BookingPortalLocaleSection,
			merchantSuffix: BookingPortalMerchantSuffix,
			// UI EVENTS
			closeModal: closeModal,
			onRouteToPortalBtnClick: onRouteToPortalBtnClick,
			// METHODS
			shouldRouteToAccountPortal: shouldRouteToAccountPortal
		});

		/**
		 * Checks if the route should be directed to the account portal.
		 * @returns {Boolean} True if the route should be directed to the account portal, false otherwise.
		 */
		function shouldRouteToAccountPortal() {
			return checkProp('AppData.settings.routeToAccountPortal', AppData, 'getBoolean');
		}

		/**
		 * When user clicks the modal button, check if we are routing to account portal or booking portal
		 * @returns {undefined} If account portal, call the AccountPortalRoutingService, else call the BookingPortalRoutingService
		 */
		function onRouteToPortalBtnClick() {
			if (vm.shouldRouteToAccountPortal()) {
				AccountPortalRoutingService.goToAccountPortal(vm.closeModal);
				return;
			}
			BookingPortalRoutingService.goToBookingPortal(vm.closeModal);
		}

		/**
		 * Closes the modal and updates the modalOpen flag.
		 * @returns {undefined}
		 */
		function closeModal() {
			$rootScope.modalOpen = false;
			$uibModalInstance.close();
		}
	}
})();
(function() {
	'use strict';

	var BOOKING_PORTAL_MODULE_DIRECTORY = 'scripts/modules/portals/modules/booking-portal';

	angular
		.module('booking-portal', ['request'])
		.config(function($locationProvider, $provide, $stateProvider) {
			$stateProvider
				.state('booking-portal', {
					url: '/booking-portal',
					abstract: true,
					template: '<div ui-view></div>',
					resolve: {
						load: function($rootScope, Utilities) {
							$rootScope.showSpinner();
							return Utilities.cacheBustAndLazyLoad([
								BOOKING_PORTAL_MODULE_DIRECTORY + '/booking-portal-models.js',
								BOOKING_PORTAL_MODULE_DIRECTORY + '/filters/booking-portal-active-reservation-groupings-filter.js',
								BOOKING_PORTAL_MODULE_DIRECTORY + '/filters/booking-portal-available-passholders-filter.js',
								BOOKING_PORTAL_MODULE_DIRECTORY + '/services/booking-portal-prep-service.js',
								BOOKING_PORTAL_MODULE_DIRECTORY + '/services/booking-portal-mode-service.js',
								BOOKING_PORTAL_MODULE_DIRECTORY + '/services/booking-portal-session-service.js',
								BOOKING_PORTAL_MODULE_DIRECTORY + '/services/booking-portal-general-utilities-service.js',
								BOOKING_PORTAL_MODULE_DIRECTORY + '/services/booking-portal-experience-utilities-service.js',
								BOOKING_PORTAL_MODULE_DIRECTORY + '/services/booking-portal-reservation-utilities-service.js',
								BOOKING_PORTAL_MODULE_DIRECTORY + '/services/booking-portal-auto-login-service.js',
								BOOKING_PORTAL_MODULE_DIRECTORY + '/services/booking-portal-tracking-service.js',
								BOOKING_PORTAL_MODULE_DIRECTORY + '/controllers/booking-portal-login-controller.js',
								BOOKING_PORTAL_MODULE_DIRECTORY + '/controllers/booking-portal-home-controller.js',
								BOOKING_PORTAL_MODULE_DIRECTORY + '/controllers/booking-portal-home-reservation-controller.js',
								BOOKING_PORTAL_MODULE_DIRECTORY + '/controllers/booking-portal-instructions-controller.js',
								BOOKING_PORTAL_MODULE_DIRECTORY + '/controllers/booking-portal-entitlement-booking-controller.js',
								BOOKING_PORTAL_MODULE_DIRECTORY + '/controllers/booking-portal-multi-entitlement-summary-controller.js',
								BOOKING_PORTAL_MODULE_DIRECTORY + '/controllers/booking-portal-reservation-assembly-controller.js',
								BOOKING_PORTAL_MODULE_DIRECTORY + '/controllers/booking-portal-reservation-summary-controller.js'
							]);
						},
						initialData: function(load, Bootstrap) {
							return Bootstrap.bootstrapApplication();
						},
						assignMerchantSuffix: function(initialData, AppData) {
							$provide.value('BookingPortalMerchantSuffix', AppData.settings.merchant_locale_suffix);
						},
						getConfiguration: function(assignMerchantSuffix, BookingPortalPrepService) {
							return BookingPortalPrepService.getConfiguration();
						},
						setupMode: function(getConfiguration, $injector) {
							return $injector.get('BookingPortalModeService').configureCustomActionsForMode();
						}

					}

				})
				.state('booking-portal.login', {
					url: '',
					templateUrl: BOOKING_PORTAL_MODULE_DIRECTORY + '/views/login.html',
					controller: 'BookingPortalLoginController',
					inSessionState: false,
					controllerAs: 'vm',
					resolve: {
						loginRouteAssessment: function(setupMode, $injector) {
							return $injector.get('BookingPortalSessionService').handleLoginRouteAssessment();
						}
					}
				})
				.state('booking-portal.order-lookup', {
					url: '/order-lookup',
					templateUrl: '/views/orderLookup.html',
					controller: 'OrderLookupCtrl',
					inSessionState: false,
					controllerAs: 'vm',
					resolve: {
						IsBookingPortal: function() {
							return true;
						}
					}
				})
				.state('booking-portal.login-alt-entry', {
					url: '/login-alt-entry/:parent_application_id/:field1/:value1/:field2/:value2',
					inSessionState: false,
					params: {
						parent_application_id: {
							value: '',
							squash: true
						},
						field1: {
							value: '',
							squash: true
						},
						value1: {
							value: '',
							squash: true
						},
						field2: {
							value: '',
							squash: true
						},
						value2: {
							value: '',
							squash: true
						}
					},
					resolve: {
						handleLogin: function(setupMode, $injector, $transition$) {
							return $injector.get('BookingPortalAutoLoginService').handleAutoLogin($transition$.params());
						}
					}
				})
				.state('booking-portal.login-auto', {
					url: '/auto/:parent_application_id/:oToken/:eToken',
					inSessionState: false,
					params: {
						parent_application_id: {
							value: '',
							squash: true
						},
						oToken: {
							value: '',
							squash: true
						},
						eToken: {
							value: '',
							squash: true
						}
					},
					resolve: {
						handleLogin: function(setupMode, $injector, $transition$) {
							return $injector.get('BookingPortalAutoLoginService').autoLogin($transition$.params());
						}
					}
				})
				.state('booking-portal.login-auto-c', {
					url: '/auto-c/:parent_application_id/:oToken/:cToken',
					inSessionState: false,
					params: {
						parent_application_id: {
							value: '',
							squash: true
						},
						oToken: {
							value: '',
							squash: true
						},
						cToken: {
							value: '',
							squash: true
						}
					},
					resolve: {
						handleLogin: function(setupMode, $injector, $transition$) {
							return $injector.get('BookingPortalAutoLoginService').autoLogin($transition$.params());
						}
					}
				})
				.state('booking-portal.home', {
					url: '/home',
					abstract: true,
					templateUrl: BOOKING_PORTAL_MODULE_DIRECTORY + '/views/home.html',
					controller: 'BookingPortalHomeController',
					controllerAs: 'vm',
					inSessionState: true,
					resolve: {
						loginRouteAssessment: function(setupMode, $injector) {
							return $injector.get('BookingPortalSessionService').handleLoginRouteAssessment();
						}
					}
				})
				.state('booking-portal.home.instructions', {
					url: '',
					templateUrl: BOOKING_PORTAL_MODULE_DIRECTORY + '/views/instructions.html',
					controller: 'BookingPortalInstructionsController',
					controllerAs: 'instructionsVm',
					inSessionState: true,
					resolve: {}
				})
				.state('booking-portal.home.entitlement-summary', {
					url: '/summary/:experienceId',
					templateUrl: BOOKING_PORTAL_MODULE_DIRECTORY + '/views/experience-multi-entitlement-summary.html',
					controller: 'BookingPortalMultiEntitlementSummaryController',
					controllerAs: 'entSummaryVm',
					inSessionState: true,
					resolve: {}
				})
				.state('booking-portal.home.entitlement-booking', {
					url: '/booking/:experienceId/:eventEntitlementId',
					templateUrl: BOOKING_PORTAL_MODULE_DIRECTORY + '/views/experience-booking.html',
					controller: 'BookingPortalEntitlementBookingController',
					controllerAs: 'entitlementBookingVm',
					inSessionState: true,
					resolve: {
						handleBookingRouteAssessment: function(loginRouteAssessment, $injector, $state, $transition$) {
							return $injector.get('BookingPortalExperienceUtilitiesService').handleBookingRouteAssessment($state.current.name, $transition$.params());
						},
						eligibleDates: function(handleBookingRouteAssessment, $injector, $state, $transition$) {
							var stateParams = $transition$.params(),
								BookingPortalExperienceUtilitiesService = $injector.get('BookingPortalExperienceUtilitiesService');
							return BookingPortalExperienceUtilitiesService.requestEligibleDatesForExperience(BookingPortalExperienceUtilitiesService.getExperienceById(stateParams.experienceId), stateParams.eventEntitlementId, undefined, $state.current.name, stateParams, true);
						}
					}
				})
				.state('booking-portal.home-reservation', {
					url: '/home-reservation',
					abstract: true,
					templateUrl: BOOKING_PORTAL_MODULE_DIRECTORY + '/views/home-reservation.html',
					controller: 'BookingPortalHomeReservationController',
					controllerAs: 'vm',
					inSessionState: true,
					resolve: {
						loginRouteAssessment: function(setupMode, $injector) {
							return $injector.get('BookingPortalSessionService').handleLoginRouteAssessment();
						}
					}
				})
				.state('booking-portal.home-reservation.instructions', {
					url: '',
					templateUrl: BOOKING_PORTAL_MODULE_DIRECTORY + '/views/instructions.html',
					controller: 'BookingPortalInstructionsController',
					controllerAs: 'instructionsVm',
					inSessionState: true,
					resolve: {
						resRouteAssessment: function(loginRouteAssessment, $injector) {
							return $injector.get('BookingPortalReservationUtilitiesService').assessDefaultReservationRoute();
						}
					}
				})
				.state('booking-portal.home-reservation.summary', {
					url: '/summary',
					templateUrl: BOOKING_PORTAL_MODULE_DIRECTORY + '/views/summary.html',
					controller: 'BookingPortalReservationSummaryController',
					controllerAs: 'resSummaryVm',
					inSessionState: true,
					resolve: {}
				})
				.state('booking-portal.home-reservation.assembly', {
					url: '/assembly/{resType:(?:new|edit)}/:resDateYYYYMMDD?',
					templateUrl: BOOKING_PORTAL_MODULE_DIRECTORY + '/views/assembly.html',
					controller: 'BookingPortalReservationAssemblyController',
					controllerAs: 'assemblyVm',
					inSessionState: true,
					overrideWholeView: true,
					params: {
						resType: {
							value: 'new',
							squash: false
						},
						resDateYYYYMMDD: {
							value: '',
							squash: true
						}
					},
					resolve: {
						eligibleForAssemblyRoute: function(loginRouteAssessment, $injector, $transition$) {
							return $injector.get('BookingPortalReservationUtilitiesService').isEligibleForAssemblyRoute($transition$.params().resDateYYYYMMDD);
						},
						eligibleDates: function(eligibleForAssemblyRoute, $injector, $transition$) {
							return $injector.get('BookingPortalReservationUtilitiesService').getAvailableDates($transition$.params().resDateYYYYMMDD);
						}
					}
				})
		})
		.value('BookingPortalLocaleSection', 'BookingPortal')
		.value('BookingPortalMerchantSuffix', undefined)
		.run(function($injector, $q, $transitions, $window, $location, RouteRejectionService, PostPurchaseActionsService, PortalRoutingModalService, Utilities) {
			// intercept any transition to a state under 'booking-portal'
			$transitions.onStart({ to: 'booking-portal.**' }, function(transition) {
				var Bootstrap = transition.injector().get('Bootstrap');
				var BookingPortalPrepService = transition.injector().get('BookingPortalPrepService');
				var $state = transition.injector().get('$state');
				var AppData = transition.injector().get('AppData');
				var JSONValidator = transition.injector().get('JSONValidator');

				// return a promise so the router waits for our async check
				return Bootstrap.bootstrapApplication()
					.then(function() {
						return BookingPortalPrepService.getConfiguration();
					})
					.then(function() {
						var checkProp = Utilities.checkProp,
							environment = AppData.environment,
							bookingPortalSettings = checkProp('AppData.settings.booking_portal', AppData) && JSONValidator.validate('booking_portal', AppData.settings.booking_portal) ? JSON.parse(AppData.settings.booking_portal) : {},
							redirectUrl = checkProp('bookingPortalSettings.booking_portal_redirect_to_account_portal', bookingPortalSettings) ? bookingPortalSettings.booking_portal_redirect_to_account_portal[environment] : null;

						if (redirectUrl) {
							var originalUrl = $state.href(transition.to(), transition.params(), { absolute: false });
							var urlSuffix = originalUrl.substring('/booking-portal'.length);

							if (urlSuffix.startsWith('/auto-c')) {
								urlSuffix = urlSuffix.substring('/auto-c'.length);
							}

							$window.location.href = redirectUrl + urlSuffix;
							// abort the current transition since we are redirecting the browser
							return false;
						}
						// if no redirectUrl, return true to allow the original transition to continue
						return true;
					});
			});

			RouteRejectionService.setSplashScreenOffForRoute('booking-portal');
			// Register the action immediately
			PostPurchaseActionsService.registerAction(function() {
				var shouldRouteToBookingPortal = $injector.get('BookingPortalRoutingService').shouldRouteToBookingPortal();
				if (shouldRouteToBookingPortal) {
					return Utilities.cacheBustAndLazyLoad([
							BOOKING_PORTAL_MODULE_DIRECTORY + '/services/booking-portal-routing-service.js'
						])
						.then(function() {
							return PortalRoutingModalService.display();
						});
				} else {
					return $q.resolve();
				}
			});
		});
})();

(function() {
	'use strict';

	angular
		.module('booking-portal')
		.service('BookingPortalModels', BookingPortalModels);

	/**
	 * Booking Portals Models Constructor
	 * @param {Service} AppData AppData
	 * @param {String|undefined} BookingPortalMerchantSuffix BookingPortalMerchantSuffix
	 * @param {Service} Language Language
	 * @param {Service} Utilities Utilities
	 * @param {Service} UtilsValidation UtilsValidation
	 * @param {Service} $filter $filter
	 * @constructor
	 * @returns {self} The current instance
	 * @ngInject
	 */
	function BookingPortalModels(AppData, BookingPortalMerchantSuffix, Language, Utilities, UtilsValidation, $filter) {
		var isObject = angular.isObject;
		var wrapObjectToArray = Utilities.wrapObjectToArray;
		var validString = UtilsValidation.validString;

		/**
		 * Model to hold a session for an instance of booking portal
		 * @constructor
		 */
		function BookingSession() {
			/* eslint-disable camelcase */
			this._data = {};
			this._order_id = '';
			this._phone_number = '';
			this._customer_id = '';
			this._order_date = '';
			/* eslint-disable camelcase */
		}


		BookingSession.prototype = {
			get customer_id() {
				return this._customer_id;
			},
			set customer_id(val) {
				this._customer_id = val;
			},
			get order_date() {
				return this._order_date;
			},
			set order_date(mySQLDate) {
				var dateObj = Utilities.getJavaScriptDateFromMySQLDate(mySQLDate);
				this._order_date = $filter('date')(dateObj, 'shortDate') + ' ' + $filter('date')(dateObj, Utilities.getTimeFormat(AppData.settings));
			},
			get order_id() {
				return this._order_id;
			},
			set order_id(val) {
				this._order_id = val;
			},
			get phone_number() {
				return this._phone_number;
			},
			set phone_number(val) {
				this._phone_number = val;
			}
		}


		/**
		 * Clears the contents of the session
		 * @returns {undefined}
		 */
		BookingSession.prototype.clear = function() {
			Object.keys(this._data).forEach(function(prop) {
				delete this._data[prop];
			}, this);
		}

		/**
		 * Returns whether or not this session is active (if we have session data, then we can consider this active)
		 * @returns {Number} The length
		 */
		BookingSession.prototype.isActive = function() {
			return Object.keys(this._data).length;
		};

		/**
		 * Gets the data value from the
		 * @param {String} property The property to get
		 * @returns {*} The value if any
		 */
		BookingSession.prototype.getDataProperty= function(property) {
			return this._data[property];
		};


		/**
		 * Sets the data value from the
		 * @param {String} name The property to set
		 * @param {*} value value if any
		 * @returns {undefined}
		 */
		BookingSession.prototype.setDataProperty = function(name, value) {
			this._data[name] = value;
		};


		this.BookingSession = BookingSession;

		/**
		 * The model for a booking experience
		 * The business assumption for this model is that ALL tickets that were purchased for a specific package get the SAME exact
		 * entitlements so we can always assume that most information for display in the booking views
		 * have what we need for the most part as far as the selected dates/times/modifications left
		 * As such, the design decision of this portal is that ALL tickets for a particular experience are modified at the SAME time
		 * The grouping is by package
		 * @param id
		 * @param packageId
		 * @param packageDesc
		 * @constructor
		 */
		function BookingExperience(id, packageId, packageDesc) {
			//experiences are identified by packages at the core and then a combination of a few identifiers
			// The id here is a combination potentially of the package_id, date & time of a ticket's entitlement to create a core grouping of experiences
			this.id = id;
			this.earliest_booking_date = new Date();
			this.latest_booking_date = new Date();
			this.package_id = packageId;
			this.name = packageDesc;
			this.tickets = [];
		}

		BookingExperience.prototype.appendBookingIdToTktsIfNeeded = function(eventEntitlementId, tktResponseList) {
			for (var i = 0; i < tktResponseList.length; i++) {
				var respTkt = tktResponseList[i];
				var storedTicket = this.getTicketById(respTkt.ticket_id);
				if (angular.isDefined(storedTicket)) {
					var entitlement = storedTicket.getEntitlementByEventEntitlementId(eventEntitlementId);
					if (angular.isDefined(entitlement) && angular.isUndefined(entitlement.booking_id) && angular.isDefined(respTkt.ticket_booking_id)) {
						entitlement.booking_id = respTkt.ticket_booking_id;
					}
				}
			}
		}

		BookingExperience.prototype.removeBookingId = function(eventEntitlementId, tickets) {
			var self = this;

			wrapObjectToArray(tickets).forEach(function(item) {
				var entitlement;
				var tkt = self.getTicketById(item.ticket_id);

				if (!tkt) {
					return;
				}

				entitlement = tkt.getEntitlementByEventEntitlementId(eventEntitlementId);
				delete entitlement.booking_id;
			});
		}

		/**
		 * Has multiple entitlements for this experience
		 * @returns {boolean}
		 */
		BookingExperience.prototype.doesFirstTicketHaveMultipleEntitlements = function() {
			return this.tickets.length > 0 ? this.tickets[0].hasMultipleEntitlements() : false;
		}

		/**
		 *
		 * @param comparisonExperience
		 * @returns {boolean}
		 */
		BookingExperience.prototype.hasSameScheduleForNonMainEntitlements = function(comparisonExperience) {
			var hasSameScheduleAsComparisonExperience = true;
			var mainEventEntitlementId = this.getMainEventEntitlementId();
			var ents = this.getFirstTicketsEntitlements();
			for (var i = 0; i < ents.length; i++) {
				var ent = ents[i];
				if (ent.event_entitlement_id !== mainEventEntitlementId) {
					var comparisonEntitlement = comparisonExperience.getEntitlementFromFirstTicketByEventEntitlementId(ent.event_entitlement_id);
					if (angular.isUndefined(comparisonEntitlement) || comparisonEntitlement.start_time !== ent.start_time ||
						(angular.isDefined(ent.start_date) && angular.isDefined(comparisonEntitlement.start_date) && !Utilities.isSameDate(ent.start_date, comparisonEntitlement.start_date))) {
						hasSameScheduleAsComparisonExperience = false;
						break;
					}
				}
			}

			return hasSameScheduleAsComparisonExperience;
		}

		/**
		 * Is Main Entitlement
		 * //TODO once we actually get the flag from Backend regarding identifying the main entitlement, this will need to be adjusted
		 * @param eventEntitlementId
		 * @returns {string}
		 */
		BookingExperience.prototype.getMainEventEntitlementId = function() {
			var ents = this.getFirstTicketsEntitlements();
			return ents.length > 0 ? ents[0].event_entitlement_id : '';
		}

		/**
		 * Retrieves the count of tickets for a particular customer type id
		 * @param eventEntitlementId
		 * @returns {*}
		 */
		BookingExperience.prototype.getCountOfTicketsForCustomerTypeId = function(customerTypeId) {
			return this.tickets.filter(function(tkt) {
				return tkt.customer_type_id === customerTypeId
			}).length;
		}

		/**
		 * Retrieves the count of tickets for a particular customer type id
		 * @param eventEntitlementId
		 * @returns {*}
		 */
		BookingExperience.prototype.getCountOfTicketsForEventEntitlementId = function(eventEntitlementId) {
			return this.tickets.filter(function(tkt) {
				return angular.isDefined(tkt.getEntitlementByEventEntitlementId(eventEntitlementId));
			}).length;
		}


		/**
		 * Retrieve the experience name
		 * @returns {String} the name of the experience
		 */
		BookingExperience.prototype.getExperienceName = function() {
			return Language.localeExists('BookingPortal', 'packageNameLbl_' + this.package_id) ? Language.getLocaleWithSuffixAndFallback('BookingPortal', 'packageNameLbl_' + this.package_id, BookingPortalMerchantSuffix) : this.name;
		};

		/**
		 * Retrieve the experience date and time
		 * @returns {String} the name of the experience
		 */
		BookingExperience.prototype.getExperienceDateTime = function() {
			var firstTicket = this.tickets[0];
			var firstDatedEntitlement = firstTicket.getFirstEntitlementWithStartDate();
			var dateTime = '';
			var timeFormat = '';

			if (angular.isDefined(firstDatedEntitlement)) {
				timeFormat = validString(firstDatedEntitlement.start_time) ? Utilities.getTimeFormat(AppData.settings) : '';
				dateTime = $filter('date')(Utilities.transformDateWithTimeFromTimeString(firstDatedEntitlement.start_date, firstDatedEntitlement.start_time), 'EEE, MMM d, yyyy ' + timeFormat);
			}

			return dateTime;
		};


		/**
		 * Get the first ticket's entitlements within this experience
		 * @returns {*}
		 */
		BookingExperience.prototype.getFirstTicketsEntitlements = function() {
			return this.tickets.length > 0 ? this.tickets[0].entitlements : [];
		}

		/**
		 * Retrieves an array list of event ids for all entitlements in this experience
		 * @param eventEntitlementId
		 * @returns {*}
		 */
		BookingExperience.prototype.getListOfCustomerTypesForTickets = function() {
			var list = [];
			this.tickets.forEach(function(tkt) {
				if (list.indexOf(tkt.customer_type_id) === -1) {
					list.push(tkt.customer_type_id);
				}
			});

			return list;
		}

		/**
		 * Get entitlements from all tickets by the event entitlement id
		 */
		BookingExperience.prototype.getEntitlementsByEventEntitlementId = function(eventEntitlementId) {
			var entitlementList = [];
			this.tickets.forEach(
				function(tkt) {
					var ent = tkt.getEntitlementByEventEntitlementId(eventEntitlementId);
					if (angular.isDefined(ent)) {
						entitlementList.push(ent);
					}
				});

			return entitlementList;
		}


		/**
		 * Get Entitlement from our list via a given event entitlement id
		 * @param eventEntitlementId
		 * @returns {Entitlement object}
		 */
		BookingExperience.prototype.getEntitlementFromFirstTicketByEventEntitlementId = function(eventEntitlementId) {
			return this.tickets.length > 0 ? this.tickets[0].entitlements.filter(function(ent) {
				return ent.event_entitlement_id === eventEntitlementId
			})[0] : undefined;
		}

		/**
		 * Retrieve the first entitlement from the first ticket in this experience
		 * @returns {undefined}
		 */
		BookingExperience.prototype.getFirstTicketsFirstEntitlement = function() {
			return this.tickets.length > 0 ? this.tickets[0].entitlements[0] : undefined;
		}

		/**
		 * Find out if one of the tickets needs a reservation
		 * @returns {Boolean} whether or not it requires a reservation.
		 */
		BookingExperience.prototype.requiresReservation = function() {
			return this.tickets.some(function(ticket) {
				return ticket.entitlements.some(function(entitlement) {
					return !(entitlement.start_date instanceof Date);
				});
			})
		};


		/**
		 * Get the start month for an entitlement or default to -1 for API requests
		 * @public
		 * @memberOf BookingExperience
		 * @param {String} eventEntitlementId - the event entitlement id to reference
		 * @returns {Number} startMonth - the starting month for use in assessing and requesting date information
		 */
		BookingExperience.prototype.getStartMonthFromFirstTicketForEntitlement = function(eventEntitlementId) {
			var todaysStartMonth = new Date().getMonth() + 1;
			var todaysYear = new Date().getFullYear();
			var entitlement = this.getEntitlementFromFirstTicketByEventEntitlementId(eventEntitlementId);
			var mainEntitlementStartDate = this.getMainEntitlementStartDate();
			var entitlementOverrideStartMonth = -1,
				entitlementOverrideYear;

			if (isObject(entitlement) && isObject(entitlement.start_date)) {
				entitlementOverrideStartMonth = entitlement.start_date.getMonth() + 1;
				entitlementOverrideYear = entitlement.start_date.getFullYear();
			} else if (isObject(mainEntitlementStartDate) && mainEntitlementStartDate.getFullYear() >= todaysYear) {
				entitlementOverrideStartMonth = mainEntitlementStartDate.getMonth() + 1;
				entitlementOverrideYear = mainEntitlementStartDate.getFullYear();
			}

			if (entitlementOverrideYear > todaysYear) {
				return entitlementOverrideStartMonth;
			}
			return entitlementOverrideStartMonth >= todaysStartMonth ? entitlementOverrideStartMonth : -1;
		}


		/**
		 * Get the start date for main entitlement (assuming main entitlement is first one returned until association exists on BE)
		 * @returns {Object | undefined}
		 */
		BookingExperience.prototype.getMainEntitlementStartDate = function() {
			var entitlements = this.getFirstTicketsEntitlements().filter(function(ent) {
				return angular.isDefined(ent.start_date)
			});
			return angular.isDefined(entitlements[0]) ? entitlements[0].start_date : undefined;
		}

		/**
		 * Retrieve a ticket using the ticket id
		 * @param id
		 * @returns {*}
		 */
		BookingExperience.prototype.getTicketById = function(id) {
			return this.tickets.filter(function(tkt) {
				return tkt.id === id
			})[0];
		}

		/**
		 * Retrieve a list of tickets that have names that have been modified and are in need of saving
		 * Once the save happens, we commit the change officially to the ticket and the presaved_customer_name and customer_name become the same
		 * @returns {Array.<*>}
		 */
		BookingExperience.prototype.getTicketsWithNameModified = function() {
			return this.tickets.filter(function(tkt) {
				return tkt.hasTicketNameModified()
			});
		}

		/**
		 * Has some ticket names that have been modified and are in need of saving
		 * @returns {boolean}
		 */
		BookingExperience.prototype.hasSomeTicketNamesModified = function() {
			return this.tickets.some(function(tkt) {
				return tkt.hasTicketNameModified()
			});
		}


		/**
		 * Store the modified booking information
		 * @param eventEntitlementId
		 * @param newStartDate
		 * @param newStartTime
		 * @param {Boolean} disableCountTowardsModification Pass true if this is a cancel so it doesn't count towards modifications remaining
		 */
		BookingExperience.prototype.storeModifiedBooking = function(eventEntitlementId, newStartDate, newStartTime, disableCountTowardsModification) {
			this.tickets.forEach(function(tkt) {
				var entitlement = tkt.getEntitlementByEventEntitlementId(eventEntitlementId);

				if (angular.isDefined(entitlement)) {
					entitlement.start_date = angular.copy(newStartDate);
					entitlement.start_time = angular.copy(newStartTime);

					if (!disableCountTowardsModification) {
						entitlement.modifications_remaining --;
					}
				}
			});
		};


		this.BookingExperience = BookingExperience;

		/**
		 * Entitlement - this identifies an entitlement on a particular experience
		 * @param ticketEntitlementId
		 * @param eventEntitlementId
		 * @param eventId
		 * @constructor
		 */
		function Entitlement(ticketEntitlementId, eventEntitlementId, eventId) {
			this.id = ticketEntitlementId;
			this.booking_id = undefined;
			this.event_entitlement_id = eventEntitlementId;
			this.event_id = eventId;
			this.event_calendar_id = '';
			this.modifications_remaining = 0;
			this.start_date = undefined;
			this.start_time = undefined;
			this.pre_event_booking_hours_cutoff =0;
			this.post_event_booking_hours_cutoff = 0;
			this.duration = 0;
			this.vendor_id = '';
			this.status = '0';
		}

		/**
		 * Is the entitlement modified
		 * @param newStartDate
		 * @param newStartTime
		 * @returns {boolean}
		 */
		Entitlement.prototype.isModified = function(newStartDate, newStartTime) {
			return (angular.isDefined(this.start_date) && !Utilities.isSameDate(this.start_date, newStartDate) || !angular.equals(newStartTime, this.start_time)) ||
				(angular.isUndefined(this.start_date) && angular.isDefined(newStartDate) || angular.isUndefined(this.start_time) && angular.isDefined(newStartTime));
		}

		/**
		 * Is start date within the pre and post event booking cutoff relative to the start date/time
		 * This is time-zone agnostic right now and will evaluate the user's system computer
		 * We may want to be able to make this more robust in the future but for now this is how the implementation
		 * is for the first phase
		 * @returns {boolean}
		 */
		Entitlement.prototype.isStartDateWithinCutoff = function() {
			var isWithinCutoff = true,
				startDateWithTime,
				preCutoff,
				postCutoff,
				currentTime;

			if (angular.isDefined(this.start_date)) {
				startDateWithTime = Utilities.transformDateWithTimeFromTimeString(this.start_date, this.start_time).getTime();
				preCutoff = this.pre_event_booking_hours_cutoff * 60 * 60 * 1000;
				postCutoff = this.post_event_booking_hours_cutoff * 60 * 60 * 1000;
				currentTime = new Date().getTime();

				isWithinCutoff = currentTime < startDateWithTime - preCutoff || currentTime < startDateWithTime + postCutoff;
			}

			return isWithinCutoff;
		}

		/**
		 * Obtain the start date and time display
		 * @returns {String} the display date
		 */
		Entitlement.prototype.getStartDateWithTimeForDisplay = function() {
			var displayDate = this.getLocalizedStartDate();
			var displayTime = $filter('date')(Utilities.transformDateWithTimeFromTimeString(this.start_date, this.start_time), Utilities.getTimeFormat(AppData.settings));
			return displayDate + ' ' + displayTime;
		};

		/**
		 * YYYY_MM_DD MYSQL Date formatted start date
		 * @returns {String} The sql date
		 */
		Entitlement.prototype.getYYYY_MM_DDFormattedStartDate = function() {
			return $filter('date')(this.start_date, 'yyyy-MM-dd');
		};

		/**
		 * Retrieve a localized start date
		 * @returns {*}
		 */
		Entitlement.prototype.getLocalizedStartDate = function() {
			return angular.isDefined(this.start_date) ? $filter('date')(this.start_date, AppData.settings.date_format) : '';
		}

		this.Entitlement = Entitlement;


		/**
		 * Booking Ticket - this is an individual ticket for an entitlement
		 * @param ticketId
		 * @constructor
		 */
		function Ticket(ticketId, customerTypeId, customerTypeName) {
			this.id = ticketId;
			this.customer_type_id = customerTypeId;
			this.customer_type_name = customerTypeName;
			this.customer_name = angular.copy(customerTypeName);
			this.presaved_customer_name = angular.copy(this.customer_name);
			this.entitlements = [];
		}

		/**
		 * Commit a name change officially to the ticket
		 * @param newName
		 */
		Ticket.prototype.commitTemporaryNameChange = function(newName) {
			this.presaved_customer_name = angular.copy(this.customer_name);
			this.customer_name = angular.copy(newName);
		}

		/**
		 * Officially commit the name change as it has now been saved to the ticket in the database
		 */
		Ticket.prototype.commitOfficialNameChange = function() {
			this.presaved_customer_name = angular.copy(this.customer_name);
		}

		/**
		 * Retrieve an entitlement by the event_entitlement_id
		 * @param eventEntitlementId
		 * @returns {Entitlement || undefined}
		 */
		Ticket.prototype.getEntitlementByEventEntitlementId = function(eventEntitlementId) {
			return this.entitlements.filter(function(ent) {
				return ent.event_entitlement_id === eventEntitlementId
			})[0];
		}

		/**
		 * Retrieve the first entitlement with a start date
		 * @returns {Ticket object}
		 */
		Ticket.prototype.getFirstEntitlementWithStartDate = function() {
			return this.entitlements.filter(function(ent) {
				return angular.isDefined(ent.start_date);
			})[0];
		}


		/**
		 * Has entitlements available to modify
		 * @returns {boolean}
		 */
		Ticket.prototype.hasEntitlementsAvailable = function() {
			return this.entitlements.filter(function(ent) {
				return ent.modifications_remaining > 0 &&
					ent.isStartDateWithinCutoff() &&
					parseInt(ent.status, 10) !== 1
			}).length > 0;
		}

		/**
		 * Does the ticket have multiple entitlements
		 * @returns {boolean}
		 */
		Ticket.prototype.hasMultipleEntitlements = function() {
			return this.entitlements.length > 1;
		}

		/**
		 * Does this ticket only have one booked entitlement
		 * @returns {boolean}
		 */
		Ticket.prototype.hasOnlyOneBookedEntitlement = function() {
			return this.entitlements.filter(function(ent) {
				return angular.isDefined(ent.start_date)
			}).length === 1;
		}

		/**
		 * Did this ticket name get modified and is in need of saving
		 * @returns {boolean}
		 */
		Ticket.prototype.hasTicketNameModified = function() {
			return this.customer_name !== this.presaved_customer_name;
		}


		this.Ticket = Ticket;


		//reservation-specific models
		/**
		 * Passholder model for a passholder within the reservation booking mode
		 * @param ticketId
		 * @constructor
		 */
		function Passholder(ticketId) {
			/**
			 * The ticket id of the passholder
			 */
			this.id = ticketId;
			/**
			 * The customer name
			 * @type {string}
			 */
			this.customer_name = '';
			/**
			 * The reservations that this passholder has
			 * @type {Array}
			 */
			this.reservations = [];
			/**
			 * Temporary placeholder to track selection within new or existing reservations
			 * @type {Object|null}
			 */
			this.temp_reservation = null;
		}

		/**
		 * Returns the active reservation date for a passholder
		 * @returns {undefined}
		 */
		Passholder.prototype.clearTempReservation = function() {
			this.temp_reservation = null;
		}


		/**
		 * Create a new temporary reservation for the passholder
		 * @param group
		 * @param date
		 */
		Passholder.prototype.createNewTempReservation = function(group, date) {
			this.clearTempReservation();
			this.temp_reservation = new Reservation(group, date);
		}

		/**
		 * Commit a reservation and update active reservation or provide new active reservation
		 */
		Passholder.prototype.commitReservation = function() {
			if (this.isReservationModified()) {
				var group = angular.copy(this.temp_reservation.group);
				var date = angular.copy(this.temp_reservation.date);
				var activeRes = this.getActiveReservation();

				if (angular.isDefined(activeRes)) {
					if (!this.isTemporarilyReserved()) {
						this.reservations.splice(this.reservations.indexOf(activeRes), 1);
					} else {
						activeRes.group = group;
						activeRes.date = date;
					}
				} else {
					this.reservations.push(new Reservation(group, date));
				}
				this.clearTempReservation();
			}
		}

		/**
		 * Returns the active reservation date for a passholder
		 * @returns {undefined|Date}
		 */
		Passholder.prototype.getActiveReservationDate = function() {
			var activeResDate = undefined;
			var activeRes = this.getActiveReservation();
			if (angular.isDefined(activeRes)) {
				activeResDate = activeRes.date;
			}

			return activeResDate;
		}

		/**
		 * Returns the active reservation date for a passholder
		 * The passholder can only ever have 1 reservation so this will return the filtered item or undefined from the list of reservations
		 * @public
		 * @returns {Reservation|undefined} - returns Reservation object or undefined if there is no filtered item from the array
		 */
		Passholder.prototype.getActiveReservation = function() {
			var dateToCompare = new Date();
			return this.reservations.filter(function(r) {
				return Utilities.compareDayMonthYearOfJsDates(r.date, dateToCompare) >= 0;
			})[0];
		}

		/**
		 * Has active reservation
		 * @returns {boolean}
		 */
		Passholder.prototype.hasActiveReservation = function() {
			return angular.isDefined(this.getActiveReservationDate());
		}

		/**
		 * Is the active reservation modified
		 * @returns {boolean}
		 */
		Passholder.prototype.isActiveReservationSelectionModified = function() {
			var isModified = false;
			var activeRes = this.getActiveReservation();
			if (angular.isDefined(activeRes)) {
				if (this.temp_reservation !== null) {
					isModified = !Utilities.isSameDate(activeRes.date, this.temp_reservation.date) ||
						angular.isDefined(this.temp_reservation.group) && this.temp_reservation.group !== activeRes.group;
				}
			}

			return isModified
		}


		/**
		 * Is the reservation modified
		 * @returns {boolean}
		 */
		Passholder.prototype.isReservationModified = function() {
			return this.isActiveReservationSelectionModified() ||
				(!this.hasActiveReservation() && this.isTemporarilyReserved());
		}

		/**
		 * Is temporarily reserved
		 * @returns {boolean}
		 */
		Passholder.prototype.isTemporarilyReserved = function() {
			return this.temp_reservation !== null && this.temp_reservation.group !==null && this.temp_reservation.group.length && angular.isDefined(this.temp_reservation.date);
		}

		this.Passholder = Passholder;

		/**
		 * Reservation
		 * @constructor
		 * @param group - {String|null} required whether it be blank or a valid group name.  This will get set to null by the view if user chooses not to be a part of the reservation if on the assembly page
		 * @param mySQLDate - {Date} required date for the reservation
		 * @constructor
		 */
		function Reservation(group, date) {
			this.group = group;
			this.date = angular.isDate(date) ? date: Utilities.getJavaScriptDateFromMySQLDate(date);
		}

		this.Reservation = Reservation;
	}
})();

/**
 * Created by ltischuk on 12/5/16.
 */
(function () {
	'use strict';

	angular.module('booking-portal').factory
	('BookingPortalPrepService', BookingPortalPrepService);

	function BookingPortalPrepService(
		AppData,
		ConfigurableObjectsModels,
		CustomActionService,
		RouteRejectionService,
		JSONValidator,
		Utilities,
		$state){

		// public variable exposed to the outside

		var factory = {

			config: undefined,
			loginVerificationFields: [],
			getConfiguration: getConfiguration,
			clearLoginVerificationFieldValues : clearLoginVerificationFieldValues,
			mode: 'default'

		}


		/**
		 * Retrieve the configuration of the booking portal
		 * @returns {boolean}
		 */
		function getConfiguration() {

			//register reset url for store
			CustomActionService.registerCustomAction(CustomActionService.ACTIONS_ENUMS.ON_RESET_STORE_URL_OVERRIDE, returnResetURL);

			if (angular.isDefined(factory.config)) {

				return true;

			} else if (Utilities.safelyCheckPropertyOnObject('AppData.settings.booking_portal', AppData) && angular.isUndefined(factory.config) &&
				JSONValidator.validate('booking_portal', AppData.settings.booking_portal)) {

				factory.config = JSON.parse(AppData.settings.booking_portal);
				if (factory.loginVerificationFields.length === 0) {

					factory.config.verification_fields.forEach(function (field) {

						var fld = new ConfigurableObjectsModels.VerificationField(field.name, field.validationType, field.width);

						if (field.validationType === 'custom') {
							fld.validationPattern = field.validationPattern;
						}

						if (angular.isDefined(field.initialNameValidationType)) {
							fld.initialNameValidationType = field.initialNameValidationType;
						}
						//for custom initial name validation types - we need to supply a pattern, allowing us to be uber flexible
						if (angular.isDefined(field.initialNameValidationPattern)) {
							fld.initialNameValidationPattern = field.initialNameValidationPattern;
						}
						if (angular.isDefined(field.altNameIfInitialNameValidationFails)) {
							fld.altNameIfInitialNameValidationFails = field.altNameIfInitialNameValidationFails;
						}

						factory.loginVerificationFields.push(fld);

					});

					if(angular.isDefined(factory.config.mode)){

						factory.mode = factory.config.mode;

					}


				}

				return true;

			} else {

				throw new RouteRejectionService.ViewException();

			}


		}

		/**
		 *
		 */
		function clearLoginVerificationFieldValues(){


			factory.loginVerificationFields.forEach(function(fld){

				fld.value = '';

			})

		}


		/**
		 * Return reset URL for booking portal to override the view
		 * @returns String - state to reset the app to in case of timeout etc.
		 */
		function returnResetURL(){

			return $state.href('booking-portal', {});

		}

		return factory;

	}
})();
(function() {
	'use strict';

	angular
		.module('booking-portal')
		.factory('BookingPortalRoutingService', BookingPortalRoutingService);

	/**
	 * BookingPortalRoutingService
	 * @constructor
	 * @param {Object} $rootScope $rootScope
	 * @param {Object} $state $state
	 * @param {Object} AppData AppData
	 * @param {Object} BookingPortalLocaleSection BookingPortalLocaleSection
	 * @param {Object} BookingPortalMerchantSuffix BookingPortalMerchantSuffix
	 * @param {Object} BookingPortalSessionService BookingPortalSessionService
	 * @param {Object} JSONValidator JSONValidator
	 * @param {Object} Language Language
	 * @param {Object} Utilities Utilities
	 * @param {Object} UtilsValidation UtilsValidation
	 * @returns {undefined}
	 * @ngInject
	 */
	function BookingPortalRoutingService($rootScope, $state, AppData, BookingPortalLocaleSection, BookingPortalMerchantSuffix, BookingPortalSessionService, JSONValidator, Language, Utilities, UtilsValidation) {
		var safelyCheckPropertyOnObject = Utilities.safelyCheckPropertyOnObject;

		var service = {
			getLoginFieldMappings: getLoginFieldMappings,
			goToBookingPortal: goToBookingPortal,
			shouldRouteToBookingPortal: shouldRouteToBookingPortal
		};

		return service;

		/**
		 * Determines whether to route to the booking portal based on the AppData settings.
		 * @returns {Boolean} True if should route to booking portal, false otherwise.
		 */
		function shouldRouteToBookingPortal() {
			return (safelyCheckPropertyOnObject('AppData.settings.routeToAccountPortal', AppData)
				&& !Utilities.getBoolean(AppData.settings.routeToAccountPortal)) || Utilities.isEmpty(AppData.settings.routeToAccountPortal);
		}

		/**
		 * Routes to booking portal auto-login endpoint using configured fields.
		 * Also supports an optional method to call before routing to the booking portal.
		 * @public
		 * @function
		 * @name goToBookingPortal
		 * @param {Function} methodToCallBeforeRouting - this method is optional and is currently a close modal function
		 * @returns {undefined}
		 */
		function goToBookingPortal(methodToCallBeforeRouting) {
			var loginFieldMappings = getLoginFieldMappings();

			if (typeof methodToCallBeforeRouting === 'function') {
				methodToCallBeforeRouting();
			}

			BookingPortalSessionService.clearSession();
			$rootScope.showSpinner(Language.getLocaleWithSuffixAndFallback(BookingPortalLocaleSection, 'lookupSpinnerMsg', BookingPortalMerchantSuffix));
			$rootScope.routeTo($state.href('booking-portal.login-auto', {
				parent_application_id: 1500,
				oToken: loginFieldMappings.oToken,
				eToken: loginFieldMappings.eToken
			}));
		}

		/**
		 * Maps configurable verification fields from booking portal app config to their values in the view order response.
		 * @private
		 * @function
		 * @name getLoginFieldMappings
		 * @returns {Object} loginFieldMappings
		 */
		function getLoginFieldMappings() {
			var viewOrderResponse = AppData.GuestViewOrder.VIEW_ORDER_REPLY;

			try {
				if (JSONValidator.validate('booking_portal', AppData.settings.booking_portal)) {
					return {
						oToken: safelyCheckPropertyOnObject('viewOrderResponse.ORDER_STATUS_REPLY.oToken', viewOrderResponse, 'returnValue') || '',
						eToken: safelyCheckPropertyOnObject('viewOrderResponse.CUSTOMER_DETAILS_REPLY.CUSTOMER.EMAIL.eToken', viewOrderResponse, 'returnValue') || ''
					};
				} else {
					throw new Error('invalid json');
				}
			} catch (err) {
				throw new Error('JSON config for booking_portal is not setup correctly');
			}
		}
	}
})();
/**
 * Created by ltischuk on 12/5/16.
 */
(function() {
	'use strict';

	angular.module('booking-portal')
		.factory('BookingPortalSessionService', BookingPortalSessionService);

	function BookingPortalSessionService(BookingPortalPrepService,
		BookingPortalLocaleSection,
		BookingPortalMerchantSuffix,
		BookingPortalModels,
		CustomActionService,
		RequestService,
		RouteRejectionService,
		Language,
		Utilities,
		$state,
		$stateParams,
		$rootScope) {
		/**
		 * local private variable contained in this factory to hold all of the current session data
		 */
		var session = new BookingPortalModels.BookingSession();


		/**
		 * Factory service variable
		 * @type {Object}
		 */
		var factory = {

			clearSession: clearSession,
			createBookingSession: createBookingSession,
			getBookingIdentifierDisplay: getBookingIdentifierDisplay,
			handleLoginRouteAssessment: handleLoginRouteAssessment,
			login: login,
			logout: logout,
			get session() {
				return session;
			}


		}

		/**
		 * Clear the session
		 */
		function clearSession() {
			session.clear();
		}


		/**
		 * Start the session, parse data into models and return whether or not the session is activated
		 */
		function createBookingSession(loginResponseData) {
			//clear session of all data if one already exists
			clearSession();
			//create a session object

			//add additional items to the req
			session.order_date = loginResponseData.order_date;
			session.phone_number = loginResponseData.phone_number;
			session.customer_id = loginResponseData.customer_id;
			session.oToken = loginResponseData.oToken;
			session.cToken = loginResponseData.cToken;

			CustomActionService.executeCustomAction('onBookingLoginSuccess', loginResponseData);

			return session.isActive();
		}

		/**
		 * Retrieve the booking identifier display
		 * @returns {string}
		 */
		function getBookingIdentifierDisplay() {
			var display = '';
			//parse the locale into the scope items needed for our dynamic locale
			if (Utilities.safelyCheckPropertyOnObject('Language.BookingPortal.bookingIdentifierDisplay', Language)) {
				var localeString = Language.BookingPortal.bookingIdentifierDisplay;
				//this is a configured field so we know which session field to use as the identifier display field
				var fieldIdentifier = BookingPortalPrepService.config.booking_identifier_field;
				var identifierStringStart = localeString.indexOf('@@');
				if (identifierStringStart > -1 && angular.isDefined(fieldIdentifier)) {
					var bookingIdentifierLocaleSearchString = localeString.substring(identifierStringStart, identifierStringStart + fieldIdentifier.length + 2);
					var fieldMatch = bookingIdentifierLocaleSearchString.substring(2);
					var field = session[fieldMatch];
					if (angular.isDefined(field)) {
						var bookingIdentifierLocaleReplacement = field;
						display = Language.replaceAll(bookingIdentifierLocaleSearchString, bookingIdentifierLocaleReplacement, Language.getLocaleWithSuffixAndFallback(BookingPortalLocaleSection, 'bookingIdentifierDisplay', BookingPortalMerchantSuffix));
					}
				}
			}

			return display;
		}


		/**
		 * Is able to route to this state safely based on active session
		 * @returns {boolean}
		 */
		function handleLoginRouteAssessment() {
			var hasActiveSession = session.isActive();
			if ((hasActiveSession && $state.next.inSessionState) ||
				(!hasActiveSession && !$state.next.inSessionState)) {
				return true;
			} else if (hasActiveSession && !$state.next.inSessionState) {
				throw new RouteRejectionService.UnrecoverableException($state.current.name, $stateParams, true);
			} else {
				throw new RouteRejectionService.UnrecoverableException('booking-portal.login', {}, true);
			}
		}


		/**
		 * Request Login
		 * @param fields
		 * @param [loginRequestName] - optional override of which request to fire to Backend
		 * @returns {Promise}
		 */
		function login(fields, loginRequestNameOverride, addlReqFields) {
			var requestName = angular.isDefined(loginRequestNameOverride) ? loginRequestNameOverride : 'BookingPortalLogin';
			var req = {};
			fields.forEach(function(field) {
				var validatedName = field.getValidatedName();
				req[validatedName] = field.value;
			});

			if (angular.isDefined(addlReqFields)) {
				angular.extend(req, addlReqFields);
			}

			return RequestService.sendRequest(requestName, req);
		}


		/**
		 * Log out of this portal
		 */
		function logout() {
			BookingPortalPrepService.clearLoginVerificationFieldValues();
			clearSession();
			$rootScope.$broadcast('user:bploggedout');
			$rootScope.routeTo($state.href('booking-portal.login', {}));
		}


		return factory;
	}
})();
(function() {
	'use strict';

	var ACCOUNT_PORTAL_MODULE_DIRECTORY = 'scripts/modules/portals/modules/account-portal';

	angular
		.module('account-portal', ['request'])
		.run(run);

	/**
	 * This function is executed when the 'account-portal' module is loaded. It registers an action with the PostPurchaseActionsService that checks if the application should route to the account portal. If so, it lazy loads the necessary services.
	 * @param {Object} $injector - AngularJS's $injector service, used to retrieve other services.
	 * @param {Object} $q $q service
	 * @param {Object} RouteRejectionService - Custom service for handling route rejections.
	 * @param {Object} PostPurchaseActionsService - Custom service for registering post-purchase actions.
	 * @param {Object} PortalRoutingModalService - Custom service for displaying the portal routing modal.
	 * @param {Object} Utilities - Custom service with utility functions.
	 * @returns {undefined}
	 * @ngInject
	 */
	function run($injector, $q, RouteRejectionService, PostPurchaseActionsService, PortalRoutingModalService, Utilities) {
		RouteRejectionService.setSplashScreenOffForRoute('account-portal');
		// Register the action immediately
		PostPurchaseActionsService.registerAction(function() {
			var shouldRouteToAccountPortal = $injector.get('AccountPortalRoutingService').shouldRouteToAccountPortal();
			if (shouldRouteToAccountPortal) {
				return Utilities.cacheBustAndLazyLoad([
						ACCOUNT_PORTAL_MODULE_DIRECTORY + '/services/account-portal-routing-service.js',
						ACCOUNT_PORTAL_MODULE_DIRECTORY + '/services/account-portal-auto-login-service.js'
					])
					.then(function openModal() {
						return PortalRoutingModalService.display();
					});
			} else {
				return $q.resolve();
			}
		})
	}
})();
(function() {
	"use strict";

	angular
		.module("account-portal")
		.service(
			"AccountPortalAutoLoginService",
			AccountPortalAutoLoginService
		);

	/**
	 * This service handles automatic login to the account portal.
	 * @param {Service} $q - AngularJS $q service for promise handling.
	 * @param {Service} AppData - Service that provides application data.
	 * @param {Service} JSONValidator - Service that validates JSON data.
	 * @param {Service} OrderService - Service that handles order-related operations.
	 * @param {Service} Utilities - Service that provides utility functions.
	 * @param {Service} $window - AngularJS $window service for window manipulation.
	 * @returns {Object} - An object with methods for auto login and handling login errors.
	 * @ngInject
	 */
	function AccountPortalAutoLoginService(
		$q,
		AppData,
		JSONValidator,
		OrderService,
		Utilities,
		$window
	) {
		var checkProp = Utilities.checkProp,
			environment = AppData.environment,
			bookingPortalSettings = checkProp('AppData.settings.booking_portal', AppData) && JSONValidator.validate('booking_portal', AppData.settings.booking_portal) ? JSON.parse(AppData.settings.booking_portal) : {},
			accountPortalUrl = checkProp('bookingPortalSettings.booking_portal_redirect_to_account_portal', bookingPortalSettings) ? bookingPortalSettings.booking_portal_redirect_to_account_portal[environment] : null;

		var service = {
			autoLogin: autoLogin,
			handleLoginError: handleLoginError
		};
		return service;

		/**
		 * Handles the auto login if routeToAccountPortal is true.
		 * @public
		 * @param {String} parentApplicationId - State params of the parent application id.
		 * @param {Object} loginFieldMappings - ViewOrderResponse tokens.
		 * @returns {Promise} - Logged in success promise or failure.
		 * @throws {Error} - Throws an error if the account portal URL is invalid or malformed.
		 */
		function autoLogin(parentApplicationId, loginFieldMappings) {
			// Check if accountPortalUrl is a valid URL
			try {
				new URL(accountPortalUrl);
			} catch (e) {
				handleLoginError(accountPortalUrl);
				return;
			}
			return $q(function openAccountPortal() {
				// falling back to eToken here but I am not sure when this would happen but booking portal does this
				var secondToken = OrderService.cToken || loginFieldMappings.eToken,
					url = accountPortalUrl;
				// if "auto-c" is included in the url, it means we need to tell portal which application we are coming from and provide tokens to auto login the customer
				if (url.includes("auto-c")) {
					if (!url.endsWith('/')) {
						url += '/';
					}

					url += parentApplicationId + '/' + loginFieldMappings.oToken + '/' + secondToken;
				}
				$window.open(url, "_blank");
			});
		}

		/**
		 * Throws an error if booking_portal_redirect_to_account_portal is either null or has an invalid url pattern.
		 * @private
		 * @param {String} url - The account portal URL.
		 * @throws {Error} - If booking_portal_redirect_to_account_portal is either null or has an invalid url pattern.
		 * @returns {undefined}
		 */
		function handleLoginError(url) {
			throw new Error(
				"booking_portal_redirect_to_account_portal is either null or has an invalid url pattern: " + url + ". Please check the app config."
			);
		}
	}
})();

(function() {
	'use strict';

	angular
		.module('account-portal')
		.factory('AccountPortalRoutingService', AccountPortalRoutingService);

	/**
	 * AccountPortalRoutingService
	 * @constructor
	 * @param {Object} AppData AppData
	 * @param {Service} AccountPortalAutoLoginService AccountPortalAutoLoginService
	 * @param {Object} JSONValidator JSONValidator
	 * @param {Object} Utilities Utilities
	 * @returns {undefined}
	 * @ngInject
	 */
	function AccountPortalRoutingService(AppData, AccountPortalAutoLoginService, JSONValidator, Utilities) {
		var safelyCheckPropertyOnObject = Utilities.safelyCheckPropertyOnObject;

		var service = {
			getLoginFieldMappings: getLoginFieldMappings,
			goToAccountPortal: goToAccountPortal,
			shouldRouteToAccountPortal: shouldRouteToAccountPortal
		};

		return service;

		/**
		 * Checks if the application should route to the account portal.
		 * This is determined by the 'routeToAccountPortal' setting in the AppData object.
		 * @private
		 * @function shouldRouteToAccountPortal
		 * @returns {Boolean} - Returns true if the application should route to the account portal, false otherwise.
 		*/
		function shouldRouteToAccountPortal() {
			return safelyCheckPropertyOnObject('AppData.settings.routeToAccountPortal', AppData, 'getBoolean');
		}

		/**
		 * Supports an optional method to call before routing to the account portal.
		 * Routes to account portal auto-login endpoint using configured fields.
		 * @public
		 * @function
		 * @name goToAccountPortal
		 * @param {Function} methodToCallBeforeRouting - this method is optional and is used to close the modal
		 * @returns {undefined}
		 */
		function goToAccountPortal(methodToCallBeforeRouting) {
			var loginFieldMappings = getLoginFieldMappings();
			if (angular.isFunction(methodToCallBeforeRouting)) {
				// function is close modal
				methodToCallBeforeRouting();
			}
			AccountPortalAutoLoginService.autoLogin(1500, loginFieldMappings);
		}

		/**
		 * Maps configurable verification fields from booking portal app config to their values in the view order response.
		 * @private
		 * @function
		 * @name getLoginFieldMappings
		 * @returns {Object[]} loginFieldMappings
		 */
		function getLoginFieldMappings() {
			var viewOrderResponse = AppData.GuestViewOrder.VIEW_ORDER_REPLY;
			try {
				if (JSONValidator.validate('booking_portal', AppData.settings.booking_portal)) {
					return {
						eToken: safelyCheckPropertyOnObject('viewOrderResponse.CUSTOMER_DETAILS_REPLY.CUSTOMER.EMAIL.eToken', viewOrderResponse, 'returnValue') || '',
						oToken: safelyCheckPropertyOnObject('viewOrderResponse.ORDER_STATUS_REPLY.oToken', viewOrderResponse, 'returnValue') || ''
					};
				} else {
					throw new Error('invalid json');
				}
			} catch (err) {
				throw new Error('JSON config for booking_portal is not setup correctly for account portal routing. Please check the app config and view order response.');
			}
		}
	}
})();
(function () {
	'use strict';

	angular.module('sportal', [])
		.config(function($locationProvider, $stateProvider) {
			var SPORTAL_MODULE_DIRECTORY = 'scripts/modules/portals/modules/sportal';

			$stateProvider
				.state('sportal', {
					url: '/sportal',
					abstract: true,
					template: '<div ui-view></div>',
					resolve: {
						load: function($rootScope, Utilities) {
							$rootScope.showSpinner();
							return Utilities.cacheBustAndLazyLoad([
								SPORTAL_MODULE_DIRECTORY + '/sportal-models.js',
								SPORTAL_MODULE_DIRECTORY + '/services/sportal-prep-service.js',
								SPORTAL_MODULE_DIRECTORY + '/services/sportal-session-service.js',
								SPORTAL_MODULE_DIRECTORY + '/services/sportal-request-service.js',
								SPORTAL_MODULE_DIRECTORY + '/services/sportal-utilities-service.js',
								SPORTAL_MODULE_DIRECTORY + '/services/sportal-tracking-service.js',
								SPORTAL_MODULE_DIRECTORY + '/controllers/sportal-login-controller.js',
								SPORTAL_MODULE_DIRECTORY + '/controllers/sportal-season-pass-controller.js',
								SPORTAL_MODULE_DIRECTORY + '/controllers/sportal-account-overview-controller.js',
								SPORTAL_MODULE_DIRECTORY + '/controllers/sportal-billing-demographics-controller.js',
								SPORTAL_MODULE_DIRECTORY + '/controllers/sportal-credit-card-information-controller.js',
								SPORTAL_MODULE_DIRECTORY + '/controllers/sportal-forms-controller.js'
							]);
						},
						initialData: function(load, Bootstrap) {
							return Bootstrap.bootstrapApplication();
						},
						loadBinRanges: function(initialData, CreditCardBinRangesService) {
							return CreditCardBinRangesService.fetchBinRanges();
						},
						getConfiguration: function(loadBinRanges, $injector) {
							return $injector.get('SportalPrepService').getConfiguration();
						}
					}
				})
				.state('sportal.login', {
					url: '',
					templateUrl: SPORTAL_MODULE_DIRECTORY + '/views/login.html',
					controller: 'SportalLoginController',
					controllerAs: 'vm',
					resolve: {
						loginRouteAssessment: function(getConfiguration, $injector) {
							// we're injecting here to ensure we have the service setup and we have a configuration
							$injector.get('SportalSessionService');
						}
					}
				})
				.state('sportal.account-overview', {
					url: '/account-overview',
					templateUrl: SPORTAL_MODULE_DIRECTORY + '/views/accountOverview.html',
					controller: 'SportalAccountOverviewController',
					controllerAs: 'vm',
					resolve: {
						loginRouteAssessment: loginRouteAssessment
					}
				})
				.state('sportal.season-pass', {
					url: '/season-pass/:index',
					templateUrl: SPORTAL_MODULE_DIRECTORY + '/views/demographics.html',
					controller: 'SportalSeasonPassController',
					controllerAs: 'vm',
					resolve: {
						loginRouteAssessment: loginRouteAssessment
					}
				})
				.state('sportal.billing-demographics', {
					url: '/billing-demographics',
					templateUrl: SPORTAL_MODULE_DIRECTORY + '/views/billing.html',
					controller: 'SportalBillingDemographicsController',
					controllerAs: 'vm',
					resolve: {
						loginRouteAssessment: loginRouteAssessment
					}
				})
				.state('sportal.credit-card-info', {
					url: '/cc-info',
					templateUrl: SPORTAL_MODULE_DIRECTORY + '/views/ccInfo.html',
					controller: 'SportalCreditCardInformationController',
					controllerAs: 'vm',
					resolve: {
						loadCyberSourceAssets: function(getConfiguration, Utilities, CYBERSOURCE_CREDIT_CARD_ASSETS) {
							return Utilities.cacheBustAndLazyLoad(CYBERSOURCE_CREDIT_CARD_ASSETS);
						},
						loadFlexMicroform: function(loadCyberSourceAssets, FlexMicroformService) {
							return FlexMicroformService.loadAssets();
						}
					}
				})
				.state('sportal.forms', {
					url: '/forms',
					templateUrl: SPORTAL_MODULE_DIRECTORY + '/views/agreement.html',
					controller: 'SportalFormsController',
					controllerAs: 'vm',
					resolve: {
						loginRouteAssessment: loginRouteAssessment
					}
				})
				.state('sportal.route-to-forms',{
					url: '/routeToForms/:token',
					resolve: {
						login: function(getConfiguration, $injector, $transition$){
							return $injector.get('SportalRequestService').requestAutoLogin($transition$.params().token);
						}
					}
				});

			/**
			 * The login route assessment.
			 * @protected
			 * @param {Promise} getConfiguration The get configuration resolve
			 * @param {Service} SportalSessionService The service
			 * @return {Promise} The promise to handle the assessement.
			 * @ngInject
			 */
			function loginRouteAssessment(getConfiguration, $injector) {
				return $injector.get('SportalSessionService').handleLoginRouteAssessment();
			}
		});
})();

"use strict";angular.module("cart-abandonment",[]),function(){function a(a,t,n){return{autocaptureCartAbandonment:function(r){if(angular.isUndefined(r))return;if(t.autocaptureCartAbandonment){var e={email:r,name:"",opt_in:"1",cart_id:t.GetCartSummary.CART.cart_id,cart_key:t.cart.cart_key,lang_id:t.language,merchant_id:t.GetMerchantDetails.merchant_id,mode:"1500"};n.saveCart(e,!0,!0),a.$broadcast("triggerSaveCart")}}}}a.$inject=["$rootScope","AppData","LegacyCart"],angular.module("cart-abandonment").factory("CartAbandonmentService",a)}();
/**
 * Created by ltischuk on 12/8/16.
 */
angular.module('configurable-objects', []);
/**
 * Created by ltischuk on 12/8/16.
 */
angular.module('configurable-objects').service
('ConfigurableObjectsModels',
	function(FormValidation,
		Utilities) {
		/**
     * Model for a VerificationField - these can be configurable for a login system so we
     * want to try and allow these to be configurable so we can promote usability of this module
     * When fieldWidth is undefined, it is treated as 12 (which is full-width)
     * @param name
     * @param validationType
     * @fieldWidth
     * @capitalize
     * @constructor
     */
		function VerificationField(name, validationType, fieldWidth, capitalize) {
			/**
       * The field name
       */
			this.name = name;
			/**
       * The validation type corresponding to the available options within the form-validation-directive
       */
			this.validationType = validationType;
			/**
       * If we have a custom validationType, this optional field is the validationPattern regex
       * that will be used to evaluation the field for the FormValidation directive
       * @type {undefined}
       */
			this.validationPattern = undefined;
			/**
       * The value of the field
       * @type {string}
       */
			this.value = '';
			/**
       * The width of the field corresponding to a valid bootstrap column value (divisible by 12)
       * @type {Integer}
       */
			this.width = Utilities.forceInt(fieldWidth); // equals 0 if fieldWidth is undefined
			if (this.width < 3 || this.width > 12) {
				this.width = 12;
			}
			/**
       *  Whether or not to capitalize the field or not
       * @type {boolean}
       */
			this.capitalize = Utilities.getBoolean(capitalize);
			/**
       * Alternate name as opposed to the actual name field which can be used to send to the Backend if we
       * have a field that has two purposes
       * Some fields have the notion of either/or...for example a field that consistutes either an email or a member id
       * Backend needs the field to be sent as email if it evaluates as email and memberid otherwise
       * This hook is to allow these fields to be sent as such - thus if an initial requestion validation fails,
       * we can provide an alternate name of the field to send to the Backend
       * @type {string}
       */
			this.altNameIfInitialNameValidationFails = '';
			/**
       * We can isolate a validation type to run a field through which will correspond to the actual name of the field at a given point in time
       * If this validation fails, we assume that the altNameIfInitialValidationFails is the name we need to provide to Backend
       * @type {undefined}
       */
			this.initialNameValidationType = undefined;

			/**
       * If desired to isolate initial validation type and its a custom validation, this pattern can be evaluated as the custom validation
       * for the form-validation-directive
       * This provides complete flexibility for fields that have dual/purpose and we need to evaluate what field name to send to Backend
       * @type {undefined}
       */
			this.initialNameValidationPattern = undefined;
		}

		/**
     * Retrieve the valid name if alternate names need to be considered otherwise return the name field
     */
		VerificationField.prototype.getValidatedName = function() {
			var pattern = undefined;
			var validatedName = angular.copy(this.name);
			if (angular.isDefined(this.initialNameValidationType)) {
				pattern = FormValidation.getValidationPattern(this.initialNameValidationType, undefined, this.initialNameValidationPattern, undefined);
			}
			if (angular.isDefined(pattern) && !pattern.test(this.value) && angular.isDefined(this.altNameIfInitialNameValidationFails)) {
				validatedName = angular.copy(this.altNameIfInitialNameValidationFails);
			}

			return validatedName;
		}

		this.VerificationField = VerificationField;
	}
);
(function() {
	'use strict';

	angular.module('accesso-pay', ['app']);
})();
(function() {
	'use strict';

	angular
		.module('accesso-pay')
		.factory('AccessoPayPrepService', AccessoPayPrepService);

	/**
	 * Preloads accessoPay.
	 * @param {Service} $timeout $timeout
	 * @param {Service} $q $q
	 * @param {Service} AppData AppData
	 * @param {Service} JSONValidator JSONValidator
	 * @param {Service} Utilities Utilities
	 * @param {Service} UtilsValidation UtilsValidation
	 * @returns {AccessoPayPrepService} The instance
	 * @ngInject
	 */
	function AccessoPayPrepService($timeout, $q, AppData, JSONValidator, Utilities, UtilsValidation) {
		var initialized = false;
		var service = {
			getAccessoPaySDK: getAccessoPaySDK,
			loadAssetsAndSetup: loadAssetsAndSetup,
			setupAccessoPay: setupAccessoPay
		};

		return service;

		/**
		 * Returns accesso Pay SDK URL
		 * @public
		 * @memberof AccessoPayPrepService
		 * @returns {String} sdk url
		 */
		function getAccessoPaySDK() {
			var accessoPayConfig = JSONValidator.validate('accesso_pay', AppData.settings.accesso_pay) ? JSON.parse(AppData.settings.accesso_pay) : {};
			return accessoPayConfig.sdk;
		}

		/**
		 * Loads the aPay assets
		 * @public
		 * @memberof AccessoPayPrepService
		 * @returns {undefined} undefined
		 */
		function loadAssetsAndSetup() {
			Utilities.cacheBustAndLazyLoad([
				'/scripts/modules/accesso-pay/accesso-pay-prep-service.js',
				'/scripts/modules/accesso-pay/accesso-pay-utils.js',
				'/scripts/modules/accesso-pay/accesso-pay-service.js',
				'/scripts/modules/accesso-pay/accesso-pay-payment-service.js',
				'/scripts/modules/accesso-pay/accesso-pay-controller.js',
				'/scripts/modules/accesso-pay/accesso-pay.css'
			]).then(function() {
				setupAccessoPay();
			});
		}

		/**
		 * Setup accesso pay
		 * @public
		 * @memberof AccessoPayPrepService
		 * @returns {Promise} addScriptToDocument promise
		 */
		function setupAccessoPay() {
			var sdk = null;
			if (initialized) {
				return $q.resolve();
			}

			return $q(function(resolve, reject) {
				sdk = service.getAccessoPaySDK();
				if (!UtilsValidation.validString(sdk)) {
					// no need to download assets in this case
					return $q.resolve();
				}
				Utilities
					.addScriptToDocument(service.getAccessoPaySDK(), 'accesso-pay-sdk', undefined, 1, undefined, {
						asPromise: true,
						disableReinsert: true
					}).then(function() {
						$timeout(function waitForAccessoPay() {
							if (window.accessoPay) {
								initialized = true;
								return resolve();
							}

							$timeout(waitForAccessoPay, 100);
						}, 100);
					}).catch(reject);
			});
		}
	}
}());
/* eslint-disable sort-keys */
(function() {
	'use strict';

	angular
		.module('accesso-pay')
		.config(config);

	/**
	 * Configure our module
	 * @param {Service} $stateProvider $stateProvider
	 * @returns {undefined}
	 * @ngInject
	 */
	function config($stateProvider) {
		$stateProvider
			.state('accesso-pay', {
				abstract: true,
				onExit: onAccessoPayExit,
				resolve: {
					initialData: initialDataWithSpinner,
					getCartSummary: function(initialData, CartDataService, errorTracking, $q) {
						logResolve(errorTracking, 'getCartSummary');
						// If we don't have a proper summary yet, fetch it
						if (!CartDataService.api.totalQty) {
							return CartDataService.fetchCartSummary();
						}
						return $q.resolve();
					},
					assessShippingMethods: function(getCartSummary, ShippingService, errorTracking) {
						logResolve(errorTracking, 'assessShippingMethods');
						ShippingService.assessShippingMethods();
					},
					verifyCart: function(assessShippingMethods, CartDataService, Enums, errorTracking, Utilities, $transition$, $q) {
						logResolve(errorTracking, 'verifyCart');
						// If we still don't have a proper summary after the fetch above route to the cart
						if (!CartDataService.api.totalQty) {
							$transition$.abort();
							Utilities.goTo(Enums.routes.CART_VIEW, null, null, true);
							return $q.reject();
						}
						return $q.resolve();
					},
					dismissBanners: function(verifyCart, Banner, errorTracking) {
						logResolve(errorTracking, 'dismissBanners');
						Banner.clearAllMessages();
						Banner.api.queue.slice().forEach(function(message) {
							Banner.removeMessage(message.id);
						});
					},
					loadAgreements: function(dismissBanners, AgreementService, errorTracking) {
						logResolve(errorTracking, 'loadAgreements');
						return AgreementService.routeGuard();
					},
					loadWaivers: function(loadAgreements, OneRiskService, CustomActionService, errorTracking) {
						logResolve(errorTracking, 'loadWaivers');
						var riskWaiverEnum = CustomActionService.ACTIONS_ENUMS.CUSTOM_WAIVERS_BEFORE_CART;

						if (CustomActionService.actionRegistered(riskWaiverEnum) && OneRiskService.cartHasOneRiskPackages()) {
							CustomActionService.executeCustomAction(riskWaiverEnum);
						}
					},
					assessLogin: function(loadWaivers, $rootScope, errorTracking, RouteRejectionService, ProfileLoginPrepService, ProfileLoginSessionService, Utilities, $state) {
						logResolve(errorTracking, 'assessLogin');
						if ($rootScope.configuredForLogin && Utilities.getBoolean(ProfileLoginPrepService.config.require_login_for_non_member) && !ProfileLoginSessionService.isLoggedIn() && !ProfileLoginSessionService.isGuestCheckout()) {
							ProfileLoginSessionService.setPostSigninSuccessRoute($state.href('accesso-pay'));
							$rootScope.hideSpinner();
							throw new RouteRejectionService.UnrecoverableException('profile-login.signin', { showSignInOnly: $rootScope.disableCreateAccountOnGlobalLogin });
						} else {
							return true;
						}
					},
					loadAssets: function(assessLogin, errorTracking, Utilities, $injector) {
						logResolve(errorTracking, 'loadAssets');
						return Utilities.cacheBustAndLazyLoad([
							'/scripts/modules/accesso-pay/accesso-pay-prep-service.js',
							'/scripts/modules/accesso-pay/accesso-pay-service.js',
							'/scripts/modules/accesso-pay/accesso-pay-payment-service.js',
							'/scripts/modules/accesso-pay/accesso-pay-utils.js'
						]).then(function() {
							return $injector.get('AccessoPayPrepService').setupAccessoPay();
						});
					}
				},
				url: '/accesso-pay'
			})
			.state('accesso-pay.payment', {
				controller: 'AccessoPayController',
				controllerAs: 'vm',
				resolve: {
					loadAssets: function(loadAssets, Utilities, $rootScope) {
						// Set the flag here (in a resolve, before onSuccess fires) so onSuccess
						// does not dismiss the spinner. Ownership passes to AccessoPayService,
						// which hides it only when the payment form is ready (INITIALIZED event).
						$rootScope._skipNextOnSuccessHideSpinner = true;
						return Utilities.cacheBustAndLazyLoad([
							'/scripts/modules/accesso-pay/accesso-pay-controller.js',
							'/scripts/modules/accesso-pay/accesso-pay.css'
						]);
					}
				},
				templateUrl: '/scripts/modules/accesso-pay/accesso-pay.html',
				url: '',
				onExit: function($injector) {
					var accessoPay = $injector.get('AccessoPayService').getAccessoPayInstance();
					if (accessoPay) {
						accessoPay.destroy();
					}
				}
			});

		/**
		 * Load our bootstrap and continue showing spinner.
		 * @param {Service} Bootstrap Bootstrap
		 * @param {Service} errorTracking errorTracking
		 * @param {Service} Language Language
		 * @param {Scope} $rootScope $rootscope
		 * @returns {Promise} to resolve our bootstrap process
		 * @ngInject
		 */
		function initialDataWithSpinner(Bootstrap, errorTracking, Language, $rootScope) {
			// PEC perceived-load prototype: accesso-pay opts out of the skeleton and uses the
			// legacy spinner instead. Flip showSkeletonLoader off *before* showSpinner so the
			// loader's first paint for this transition is already #loading (no skeleton->spinner
			// flash). No-op when the prototype is off (?skeleton absent). Restored in onExit.
			$rootScope.showSkeletonLoader = false;
			$rootScope.showSpinner(Language.getLocale('Purchase', 'securingCheckoutMsg'));
			logResolve(errorTracking, 'initialData');
			return Bootstrap.bootstrapApplication(undefined, true, errorTracking.hasAccessoPayParams());
		}

		/**
		 * Logs a resolve of the accesso-pay state to Coralogix RUM when the url carries acsop_* params.
		 * @param {Service} errorTracking errorTracking
		 * @param {String} feature The resolve about to run
		 * @returns {undefined}
		 */
		function logResolve(errorTracking, feature) {
			if (errorTracking.hasAccessoPayParams()) {
				errorTracking.accessoPay('accesso-pay resolve', feature);
			}
		}

		/**
		 * Restores the skeleton loader (if the ?skeleton prototype is enabled) when leaving the
		 * accesso-pay subtree, so other routes show their skeleton again. Counterpart to the
		 * opt-out in initialDataWithSpinner.
		 * @param {Scope} $rootScope $rootScope
		 * @returns {undefined}
		 * @ngInject
		 */
		function onAccessoPayExit($rootScope) {
			$rootScope.showSkeletonLoader = !!(window.accesso && window.accesso.SHOW_SKELETON);
		}
	}
})();

/* eslint-disable sort-keys */
(function() {
	'use strict';

	angular
		.module('quick-checkout', ['app', 'utilities'])
		.config(config);

	/**
	 * Registeres the state
	 * @param {Provider} $stateProvider $stateProvider
	 * @returns {undefined}
	 * @ngInject
	 */
	function config($stateProvider) {
		var MODULE_DIRECTORY = '/scripts/modules/billing/quick-checkout',
			MULTI_GUEST_MODULE = '/scripts/modules/extraflow/multi-guest-generic-form';

		$stateProvider
			.state('quick-checkout', {
				controller: "QuickCheckoutController",
				controllerAs: "vm",
				dynamic: true,
				resolve: {
					initialData: function(Bootstrap) {
						return Bootstrap.bootstrapApplication(undefined, true);
					},
					assets: function(initialData, Utilities) {
						return Utilities.cacheBustAndLazyLoad([
							MULTI_GUEST_MODULE + '/directives/dynamic-form/dynamic-form-directive.js',
							MULTI_GUEST_MODULE + '/multi-guest-generic-form-models.js',
							MODULE_DIRECTORY + '/quick-checkout-controller.js',
							MODULE_DIRECTORY + '/quick-checkout.css'
						]);
					},
					hideSpinner: function(assets, $rootScope) {
						$rootScope.hideSpinner();
					}
				},
				templateUrl: '/scripts/modules/billing/quick-checkout/quick-checkout.html',
				url: '/quick-checkout'
			});
	}
}());

/* eslint-disable sort-keys */
(function() {
	'use strict';

	angular
		.module('cybersource', ['app', 'utilities'])
		.factory('CYBERSOURCE_CREDIT_CARD_ASSETS', function() {
			var CYBERSOURCE_MODULE_DIRECTORY = 'scripts/modules/billing/modules/cybersource',
				CYBERSOURCE_CREDIT_CARD_COMPONENT = CYBERSOURCE_MODULE_DIRECTORY + '/credit-cards/component',
				CYBERSOURCE_ALTERNATE_PAYMENTS = CYBERSOURCE_MODULE_DIRECTORY + '/alt-payments';

			return [
				CYBERSOURCE_MODULE_DIRECTORY + '/credit-cards/cybersource-credit-card-service.js',
				CYBERSOURCE_MODULE_DIRECTORY + '/cardinal/cardinal-3ds-service.js',
				CYBERSOURCE_MODULE_DIRECTORY + '/cardinal/cardinal-3ds-request-service.js',
				CYBERSOURCE_MODULE_DIRECTORY + '/flex-microform/flex-microform-service.js',
				CYBERSOURCE_CREDIT_CARD_COMPONENT + '/cybersource-credit-card-component.js',
				CYBERSOURCE_CREDIT_CARD_COMPONENT + '/cybersource-credit-card-component-controller.js',
				CYBERSOURCE_CREDIT_CARD_COMPONENT + '/cybersource-credit-card-component.css',
				CYBERSOURCE_ALTERNATE_PAYMENTS + '/services/cybersource-alt-payments-utils.js',
				CYBERSOURCE_ALTERNATE_PAYMENTS + '/services/cybersource-alt-payments-prep-service.js',
				CYBERSOURCE_ALTERNATE_PAYMENTS + '/services/cybersource-alt-payments-service.js',
				'scripts/modules/composition-library/compose-config-builder.js'
			];
		})
		.config(config);

	/**
	 * Sets up routing for the Cybersource Alt Payments module
	 * @public
	 * @function
	 * @name config
	 * @param {Provider} $stateProvider Lets us set up state
	 * @returns {undefined}
	 * @ngInject
	 */
	function config($stateProvider) {
		var CYBERSOURCE_ALTERNATE_PAYMENTS = 'scripts/modules/billing/modules/cybersource/alt-payments/';
		$stateProvider
			.state('cybersource-alt-payments-redirect', {
				controller: 'CYBSAltPaymentRedirectController',
				controllerAs: 'vm',
				resolve: {
					initialData: function(Bootstrap) {
						return Bootstrap.bootstrapApplication();
					},
					loadAssets: function(initialData, Utilities) {
						return Utilities.cacheBustAndLazyLoad([
							CYBERSOURCE_ALTERNATE_PAYMENTS + 'controllers/cybersource-alt-payments-redirect-controller.js',
							'/scripts/modules/composition-library/compose-utilities-builder.js'
						]);
					},
					allowedRoute: function(loadAssets, $injector, RouteRejectionService) {
						var CYBSAltPaymentsService = $injector.has('CYBSAltPaymentsService') ? $injector.get('CYBSAltPaymentsService') : false;
						//check if redirect service exist
						if (!CYBSAltPaymentsService || !CYBSAltPaymentsService.isRedirectInitiated()) {
							throw new RouteRejectionService.UnrecoverableException('/billingView', {});
						} else {
							CYBSAltPaymentsService.completeInitiateRedirect();
						}
					},
					savePurchaseAuthStatus: function(allowedRoute, Purchase, Enums, RouteRejectionService) {
						return Purchase.savePurchaseAuthStatus().then(function(response) {
							if (response.status === Enums.status.OK && response.saved_purchase_status &&
								response.saved_purchase_status === Enums.savedPurchaseAuthStatuses.NO_SAVED_PURCHASE_STATUS) {
								return response.saved_purchase_status;
							} else {
								throw new RouteRejectionService.ViewException('Cybersource', 'cybersourceRedirectSavePurchAuthFailStatus' + response.saved_purchase_status + 'Title', 'cybersourceRedirectSavePurchAuthFailStatus' + response.saved_purchase_status + 'Msg', '/reset', {});
							}
						});
					}
				},
				template: '<div></div>',
				url: '/cybersource-alt-payments-redirect'
			})
			.state('cybersource-alt-payments-redirect-result', {
				controller: 'CYBSAltPaymentRedirectResultController',
				controllerAs: 'vm',
				resolve: {
					initialData: function(Bootstrap) {
						return Bootstrap.bootstrapApplication();
					},
					load: function(initialData, CYBERSOURCE_CREDIT_CARD_ASSETS, Utilities) {
						var assets = angular.copy(CYBERSOURCE_CREDIT_CARD_ASSETS);
						assets.push(CYBERSOURCE_ALTERNATE_PAYMENTS + 'controllers/cybersource-alt-payments-redirect-result-controller.js');
						return Utilities.cacheBustAndLazyLoad(assets);
					},
					fetchConnection: function(load, $q, LegacyCart) {
						var defer = $q.defer();
						LegacyCart.fetchGetCartSummary(defer.resolve, defer.reject);
						return defer.promise;
					},
					assessRoute: function(fetchConnection, RouteRejectionService, $rootScope) {
						if (!$rootScope.hasItemsInCart()) {
							throw new RouteRejectionService.UnrecoverableException('/reset');
						}
						return true;
					}
				},
				template: '<div></div>',
				url: '/cybersource-alt-payments-redirect-result'
			});
	}
}());

(function() {
	'use strict';

	angular
		.module('adyen-checkout', ['ui.router'])
		.factory('ADYEN_ASSETS', function() {
			var ADYEN_MODULE_DIRECTORY = 'scripts/modules/billing/modules/adyen-checkout',
				ADYEN_CREDIT_CARD_COMPONENT = ADYEN_MODULE_DIRECTORY + '/credit-card/components';

			return [
				ADYEN_MODULE_DIRECTORY + '/services/adyen-checkout-prep-service.js',
				ADYEN_MODULE_DIRECTORY + '/services/adyen-checkout-service.js',
				ADYEN_MODULE_DIRECTORY + '/services/adyen-checkout-utils.js',
				ADYEN_MODULE_DIRECTORY + '/services/adyen-checkout-3ds-service.js',
				ADYEN_MODULE_DIRECTORY + '/services/adyen-checkout-3ds-request-service.js',
				ADYEN_MODULE_DIRECTORY + '/services/adyen-checkout-redirect-service.js',
				ADYEN_MODULE_DIRECTORY + '/services/adyen-checkout-alt-payments-service.js',
				ADYEN_MODULE_DIRECTORY + '/adyen-checkout-constant.js',
				ADYEN_CREDIT_CARD_COMPONENT + '/adyen-credit-card-component.js',
				ADYEN_CREDIT_CARD_COMPONENT + '/adyen-credit-card-component-controller.js',
				ADYEN_CREDIT_CARD_COMPONENT + '/adyen-credit-card-component.css',
				'/scripts/modules/composition-library/compose-utilities-builder.js'
			]
		})
		.config(config);

	/**
	 * Sets up routing for the Adyen Checkout module
	 * @public
	 * @function
	 * @name config
	 * @memberof {adyen-checkout}
	 * @param {Provider} $locationProvider To setup global params
	 * @param {Provider} $stateProvider Lets us set up state
	 * @returns {undefined}
	 * @ngInject
	 */
	function config($locationProvider, $stateProvider) {
		var ADYEN_MODULE_DIRECTORY = 'scripts/modules/billing/modules/adyen-checkout';
		/* eslint-disable sort-keys */
		$stateProvider
			.state('adyen-checkout-redirect', {
				controller: 'AdyenCheckoutRedirectController',
				controllerAs: 'vm',
				resolve: {
					initialData: function(Bootstrap) {
						return Bootstrap.bootstrapApplication();
					},
					loadAssets: function(initialData, Utilities) {
						return Utilities.cacheBustAndLazyLoad([
							ADYEN_MODULE_DIRECTORY + '/redirect/controllers/adyen-checkout-redirect-controller.js'
						]);
					},
					allowedRoute: function(loadAssets, $injector, RouteRejectionService) {
						var AdyenCheckoutRedirectService = $injector.has('AdyenCheckoutRedirectService') ? $injector.get('AdyenCheckoutRedirectService') : false;
						//check if redirect service exist
						if (!AdyenCheckoutRedirectService || !AdyenCheckoutRedirectService.isRedirectInitiated()) {
							throw new RouteRejectionService.UnrecoverableException('/billingView', {});
						} else {
							AdyenCheckoutRedirectService.completeInitiateRedirect();
						}
					},
					savePurchaseAuthStatus: function(allowedRoute, Purchase, Enums, RouteRejectionService) {
						return Purchase.savePurchaseAuthStatus().then(function(response) {
							if (response.status === Enums.status.OK && response.saved_purchase_status &&
								response.saved_purchase_status === Enums.savedPurchaseAuthStatuses.NO_SAVED_PURCHASE_STATUS) {
								return response.saved_purchase_status;
							} else {
								throw new RouteRejectionService.ViewException('Adyen', 'adyenRedirectSavePurchAuthFailStatus' + response.saved_purchase_status + 'Title', 'adyenRedirectSavePurchAuthFailStatus' + response.saved_purchase_status + 'Msg', '/reset', {});
							}
						});
					}
				},
				templateUrl: ADYEN_MODULE_DIRECTORY + '/redirect/views/adyen-checkout-redirect.html',
				url: '/adyen-checkout-redirect'
			})
			.state('adyen-checkout-redirect-result', {
				// This state is used on post back php file
				controller: 'AdyenCheckoutRedirectResultController',
				controllerAs: 'vm',
				resolve: {
					initialData: function(Bootstrap) {
						return Bootstrap.bootstrapApplication();
					},
					load: function(initialData, ADYEN_ASSETS, Utilities, $rootScope, Language) {
						var assets = angular.copy(ADYEN_ASSETS);
						$rootScope.showSpinner(Language.getLocale('Adyen', 'checkingTransactionStatus'));
						assets.push(ADYEN_MODULE_DIRECTORY + '/redirect/controllers/adyen-checkout-redirect-result-controller.js');
						return Utilities.cacheBustAndLazyLoad(assets);
					},
					fetchConnection: function(load, $q, LegacyCart) {
						var defer = $q.defer();
						LegacyCart.fetchGetCartSummary(defer.resolve, defer.reject);
						return defer.promise;
					},
					assessRoute: function(fetchConnection, RouteRejectionService, $rootScope) {
						if (!$rootScope.hasItemsInCart()) {
							throw new RouteRejectionService.UnrecoverableException('/reset');
						}
						return true;
					}
				},
				template: '<div></div>',
				url: '/adyen-checkout-redirect-result'
			})
			.state('adyen-checkout-ideal-bank-list', {
				controller: 'AdyenCheckoutIdealBankListController',
				controllerAs: 'vm',
				resolve: {
					initialData: function(Bootstrap) {
						return Bootstrap.bootstrapApplication();
					},
					loadAssets: function(initialData, Utilities) {
						return Utilities.cacheBustAndLazyLoad([
							ADYEN_MODULE_DIRECTORY + '/bank-list/adyen-checkout-ideal-bank-list-controller.js'
						]);
					},
					accessRoute: function(loadAssets, $injector, RouteRejectionService) {
						if (!$injector.has('AdyenCheckoutAltPaymentsService')) {
							throw new RouteRejectionService.UnrecoverableException('/paymentMethod', {});
						}
					}
				},
				templateUrl: ADYEN_MODULE_DIRECTORY + '/bank-list/adyen-checkout-ideal-bank-list.html',
				url: '/adyen-checkout-ideal-bank-list'
			});
		/* eslint-disable sort-keys */
	}
}());

(function() {
	'use strict';

	angular
		.module('google-pay', ['app', 'utilities'])
		.factory('GOOGLE_PAY_ASSETS', function() {
			var GOOGLE_PAY_SERVICES_DIRECTORY = 'scripts/modules/billing/modules/google-pay/services/';

			return [
				GOOGLE_PAY_SERVICES_DIRECTORY + 'google-pay-preloader-service.js',
				GOOGLE_PAY_SERVICES_DIRECTORY + 'google-pay-service.js',
				GOOGLE_PAY_SERVICES_DIRECTORY + 'google-pay-utils.js'
			];
		});
}());
(function() {
	'use strict';

	angular
		.module('credit-cards', ['utilities', 'app']);
})();

(function() {
	'use strict';

	angular
		.module('credit-cards')
		.service('composeValidateCreditCard', composeValidateCreditCardService);

	/**
	 * Returns a function to compose an object with common functionality for many alternate modules which require a keyword and customer types.
	 * @public
	 * @function
	 * @constructor
	 * @param {Service} AppData the service
	 * @param {Service} PaymentTypeService The service
	 * @param {Service} CreditCardModels The models
	 * @param {Service} CreditCardBinRangesService The service
	 * @param {Service} StringUtils the service
	 * @param {Service} Utilities our utilities service
	 * @param {Service} UtilsValidation our validation service
	 * @return {Function} a function which decorates objects with functions and data.
	 */
	function composeValidateCreditCardService(AppData, PaymentTypeService, CreditCardModels, CreditCardBinRangesService, StringUtils, Utilities, UtilsValidation) {
		var ERROR_PREFIX = '[composeValidateCreditCard] ';

		/**
		 * Our decorator function
		 * @param {Object} obj The object to decorate
		 * @return {undefined}
		 */
		return function composeValidateCreditCard(obj) {
			var requiredStrings = ['cardName', 'spriteName'];
			var defaultProps;

			if (!UtilsValidation.isRealObject(obj)) {
				throw new Error(ERROR_PREFIX + 'expects obj to be an object');
			} else if (obj.__composeValidateCreditCard) {
				throw new Error(ERROR_PREFIX + 'this object has already been composed');
			} else if (!UtilsValidation.validArray(obj.LENGTH_RANGE)) {
				throw new TypeError(ERROR_PREFIX + 'LENGTH_RANGE must be an array of numbers');
			} else if (!angular.isFunction(obj.setRegularBinRanges)) {
				throw new TypeError(ERROR_PREFIX + 'setRegularBinRanges must be a function');
			} else if (!UtilsValidation.validString(obj.cardNameInBillingTypes) && !UtilsValidation.validArray(obj.cardNameInBillingTypes)) {
				throw new Error(ERROR_PREFIX + 'cardNameInBillingTypes must be a valid string or array');
			}

			requiredStrings.forEach(function(prop) {
				if (!UtilsValidation.validString(obj[prop])) {
					throw new Error(ERROR_PREFIX + prop + ' must be a valid string');
				}
			});

			defaultProps = {
				// Help ensure we do not redecorate objects
				__composeValidateCreditCard: true,
				VALIDATE_LENGTH_IN_VALID_CARD_NUMBER: false,
				cardToString: cardToString,
				cardType: cardType,
				cardTypeFromBillingTable: null,
				cardValidator: null,
				getBillingTypesTable: getBillingTypesTable,
				includedInBillingTypes: false,
				initialize: initialize,
				shouldUseRegisteredBinRanges: shouldUseRegisteredBinRanges,
				usingRegisteredBinRanges: false,
				validCardNumber: validCardNumber,
				validateLength: validateLength
			};

			Object.keys(defaultProps).forEach(function(key) {
				// Don't override the service's property if it's set
				if (obj.hasOwnProperty(key)) {
					return;
				}

				obj[key] = defaultProps[key];
			});

			obj.initialize();

			return obj;

			/**
			 * Initializes the service
			 * @protected
			 * @return {undefined}
			 */
			function initialize() {
				var billingTypesTable = obj.getBillingTypesTable(obj.cardNameInBillingTypes);
				var useRegisteredBinRanges;

				obj.includedInBillingTypes = billingTypesTable.cardExists;
				obj.cardTypeFromBillingTable = billingTypesTable.cardType || billingTypesTable.cardName;

				useRegisteredBinRanges = obj.shouldUseRegisteredBinRanges(billingTypesTable.cardExists, obj.cardNameInBillingTypes);

				obj.cardValidator = new CreditCardModels.CreditCardValidator();

				if (useRegisteredBinRanges) {
					obj.usingRegisteredBinRanges = true;
					CreditCardBinRangesService
						.getBinRangesByCardType(obj.cardNameInBillingTypes)
						.forEach(function(bin) {
							obj.cardValidator.setDigitLimitOnRangeTesting(bin.bin_range_start.toString().length);
							obj.cardValidator.addBinRange(bin.bin_range_start, bin.bin_range_end);
						});
				} else {
					// to be implemented by composition object
					obj.setRegularBinRanges();
				}
			}

			/**
			 * Find out if we should use bin ranges.
			 * @public
			 * @function
			 * @name shouldUseRegisteredBinRanges
			 * @param {Boolean} existsInBillingTypes Does it exists in the AppData.billingTypes?
			 * @param {String|String[]} cardNameInBillingTypes The names to search for.
			 * @return {Boolean} if we should use it or not.
			 */
			function shouldUseRegisteredBinRanges(existsInBillingTypes, cardNameInBillingTypes) {
				var normalize = StringUtils.normalize;
				var binRanges = CreditCardBinRangesService.getBinRangeTypes();
				var cardNames = Utilities.wrapObjectToArray(cardNameInBillingTypes);
				var nameInBinRanges;

				if (!existsInBillingTypes) {
					return false;
				}

				nameInBinRanges = cardNames.some(function(nameToCheck) {
					nameToCheck = normalize(nameToCheck);
					return binRanges.some(function(rangeTypeName) {
						return normalize(rangeTypeName) === nameToCheck;
					});
				});

				if (!nameInBinRanges) {
					return false;
				}

				// We can only use bin ranges if it matches a credit card that is a payment type (NOT A BILLING TYPE)
				return cardNames.some(function(nameToCheck) {
					return PaymentTypeService.isCreditCardPaymentType(AppData.billingTypes, nameToCheck);
				});
			}

			/**
			 * Returns the billing type object to be used with credit card validation. 
			 * @public
			 * @param {String|String[]} cardNameInBillingTypes The card name used in the billingTypes. Can be an array or string. 
			 * @return {CreditCardsModel.billingTypesTable} The billing type table object
			 */
			function getBillingTypesTable(cardNameInBillingTypes) {
				var billingType,
					count,
					i = 0;

				if (UtilsValidation.validString(cardNameInBillingTypes)) {
					return new CreditCardModels.BillingTypesTable(cardNameInBillingTypes);
				} else if (UtilsValidation.validArray(cardNameInBillingTypes)) {
					for (count = cardNameInBillingTypes.length; i < count; i++) {
						billingType = new CreditCardModels.BillingTypesTable(cardNameInBillingTypes[i]);

						if (billingType.cardExists) {
							return billingType;
						// If we have no more, just return the last
						} else if (i + 1 === count) {
							return billingType;
						}
					}
				}

				throw new Error(ERROR_PREFIX + 'getBillingTypesTable expects a valid string or array');
			}

			/**
			 * validCardNumber returns true if the cardNumber param corresponds to a Maestro card.
			 * @public
			 * @param {String} cardNumber the card number the customer has typed in
			 * @return {Boolean} If we have a valid card number
			 */
			function validCardNumber(cardNumber) {
				cardNumber = obj.cardToString(cardNumber);

				if (!obj.includedInBillingTypes) {
					return false;
				} else if (!obj.cardValidator.isValidCardNumber(cardNumber)) {
					return false;
				} else if (obj.VALIDATE_LENGTH_IN_VALID_CARD_NUMBER) {
					return obj.validateLength(cardNumber);
				}

				return true;
			}

			/**
			 * Find out if we have a valid card number length.
			 * @public
			 * @function
			 * @name validateLength
			 * @param {String} cardNumber The users credit card
			 * @return {Boolean} does it match the length of the card?
			 */
			function validateLength(cardNumber) {
				var cardLength,
					min,
					max,
					range = obj.LENGTH_RANGE,
					rangeLength = range.length;

				cardLength = obj.cardToString(cardNumber).length;

				if (!rangeLength) {
					throw new Error(ERROR_PREFIX + 'LENGTH_RANGE must be a valid array');
				} else if (rangeLength === 1) {
					min = max = range[0];
				} else {
					min = range.reduce(function(acc, length) {
						return length < acc ? length : acc;
					}, Infinity);
					max = range.reduce(function(acc, length) {
						return length > acc ? length : acc;
					}, -Infinity);
				}

				return cardLength >= min && cardLength <= max;
			}

			/**
			 * cardType returns the card type that the Diners card number maps to for the current island.
			 * Currently (5/12/2016), dining club cards map to discover card.
			 * Eventually this logic may move to the backend.
			 * @public
			 * @function
			 * @name cardType
			 * @return {String} The card type from the AppData.billingTypes
			 */
			function cardType() {
				return obj.cardTypeFromBillingTable;
			}

			/**
			 * Casts a card number to a string if it's not one.
			 * @public
			 * @function
			 * @name cardToString
			 * @param {*} card The card to cast
			 * @return {String} the card number as a string
			 */
			function cardToString(card) {
				var type = typeof card;

				switch (type) {
				case 'string':
					return card;
				case 'number':
					return card.toString();
				default:
					return '';
				}
			}
		}
	}
}());

(function(){

	'use strict';
	angular
		.module( 'credit-cards' )
		.directive( 'creditCardVerification',
			function(
				CreditCardsPrepService,
				CreditCardsVerificationService
			){

			var config = {
				restrict: 'A',
				require: 'ngModel',
				link: function( scope, elem, attrs, ngModelCtrl ){

					if( !CreditCardsPrepService.isConfigBuilt ){

						CreditCardsPrepService.buildConfig();
					}

					// TODO: Expand the validation pipeline to handle any and all things we wish to validate
					// Example: ngModelCtrl.$validators.cardType( identifyType );
					// Could even by driven by some type of configuration

					// Closure in order to push ngModel error object through each time so we can determine when to do the Luhn Algorithm test
					// I don't like this, but until we move all validations in here
					ngModelCtrl.$validators.verifyCardNumber = function( cardNumber ){

						return CreditCardsVerificationService.verifyCardNumber( cardNumber, ngModelCtrl.$error );
					};
				}
			};

			return config;
		});
})();
(function(){

	'use strict';
	angular
		.module( 'credit-cards' )
		.factory( 'CreditCardsPrepService',
			function(
				AppData,
				JSONValidator,
				Utilities
			){

			var factory = {
				isConfigBuilt: false,
				buildConfig: buildConfig,
				useLuhn: useLuhn
			};

			var config = undefined;

			/*
			 *	Determine if we have a valid config and set the private variable
			 */
			function buildConfig(){

				if( factory.isConfigBuilt ){

					return;
				}

				if(
					Utilities.safelyCheckPropertyOnObject( 'AppData.settings.credit_cards', AppData ) &&
					JSONValidator.validate( 'credit_cards', AppData.settings.credit_cards )
				){

					config = JSON.parse( AppData.settings.credit_cards );
				}

				factory.isConfigBuilt = true;
			};

			/*
			 *	Dev friendly method of accessing the config to determine if the luhn algorithm should be used
			 *
			 *	@returns {Boolean}
			 */
			function useLuhn(){

				if( angular.isDefined( config ) ){

					return Utilities.getBoolean( config.use_luhn );
				}
				else{

					return false;
				}
			};

			return factory;
		});
})();
(function() {
	'use strict';
	angular
		.module('credit-cards')
		.factory('CreditCardsVerificationService',
			function(
				AmericanExpressCreditCardService,
				AppData,
				BillingService,
				errorTracking,
				LegacyCart,
				CreditCardsPrepService,
				DankortCardService,
				DinersClubCardService,
				DiscoverCreditCardService,
				DynamicCreditCardService,
				Enums,
				JCBCardService,
				MaestroCreditCardService,
				MasterCardCreditCardService,
				FormValidation,
				UserInfo,
				Utilities,
				VisaCreditCardService
			) {
				var luhnAlgorithmFailed = false,
					positiveNumbersRegex;

				var factory = {
					getBillingType: getBillingType,
					getCardOverrides: getCardOverrides,
					getCreditCardType: getCreditCardType,
					luhnAlgorithm: luhnAlgorithm,
					setTypeDisplayAlias: setTypeDisplayAlias,
					validateCardNumber: validateCardNumber,
					verifyCardNumber: verifyCardNumber
				};

				return factory;

				function verifyCardNumber(cardNumber, errors) {
					var valid = true;

					valid = positiveNumbers(cardNumber);

					if (valid) {

						if (!hasOtherErrors(errors) && CreditCardsPrepService.useLuhn()) {

							valid = factory.luhnAlgorithm(cardNumber);
						}
					}

					return valid;
				}

				function positiveNumbers(cardNumber) {

					if (angular.isUndefined(positiveNumbersRegex)) {

						positiveNumbersRegex = FormValidation.getPositiveNumbersRegex();
					}

					return positiveNumbersRegex.test(cardNumber);
				}

				function hasOtherErrors(errors) {

					return Object.keys(errors).some(function (key) {
						return key !== 'verifyCardNumber';
					});
				}

				/*
				 *	Luhn Algorithm to determine if a given card number is invalid
				 *	Core logic is identical to the verifyCardNumber method used by BE
				 *
				 *	@param cardNumber {String}
				 *	@returns {Boolean} - valid or not
				 */
				function luhnAlgorithm(cardNumber) {

					if (Utilities.isEmpty(cardNumber)) {

						return false;
					}

					// Cast to string just in case
					cardNumber = cardNumber.toString();

					// The register which will be mod 10'd
					var sum = 0;

					for (var i = (cardNumber.length - 1), multiple = 1; i >= 0; i--) {

						var digit = parseInt(cardNumber[i], 10);
						// multiply by the factor (1 | 2) and move it up or down.
						digit *= (multiple == 1) ? multiple++ : multiple--;
						// add the remainder+1 or just the digit depending on
						// if this digit is 10 or more.
						sum += ( digit >= 10 ) ? ( ( digit % 10 ) + 1 ) : digit;
					}

					// Valid credit cards will have a sum that is divisible by 10
					var valid = ( sum % 10 === 0 );

					if (!valid && !luhnAlgorithmFailed) {

						luhnAlgorithmFailed = true;
					}

					return valid;
				}

				/**
				 * Method used to map the billing type to the card selected.
				 * @public
				 * @param  {String} paymentInfo - visa, mastercard, discover, ...
				 * @return {Object}          selected billing type object in AppData.billingTypes
				 */
				function getBillingType(paymentInfo, secAcctInfo) {
					var billingTypes = AppData.billingTypes;
					var billingCount = billingTypes.length;
					var i = 0;
					var cardOverrides = getCardOverrides();
					var billType = null;
					var registeredPaymentMethod = BillingService.getRegisteredPaymentMethodByName(paymentInfo.type);

					if (angular.isDefined(registeredPaymentMethod) && registeredPaymentMethod.authType !== 'DSS') {
						AppData.billingTypes.some(function(billingType) {
							if (billingType.auth_type === registeredPaymentMethod.authType) {
								billType = billingType;
								angular.extend(paymentInfo, billType);
								paymentInfo.isRegisteredPaymentMethod = true;
								angular.extend(secAcctInfo, registeredPaymentMethod.getSecureFieldsJSON());
								angular.extend(paymentInfo, registeredPaymentMethod.getStorableFields());

								if (angular.isDefined(registeredPaymentMethod.ccTypeOverride)) {
									paymentInfo.ccType = registeredPaymentMethod.ccTypeOverride;
								}

								return paymentInfo;
							}
						})
					}

					paymentInfo = maestroToMastercardOverride(paymentInfo);

					if (JCBCardService.validCardNumber(secAcctInfo.account)) {
						paymentInfo.ccTypeDisplayAlias = JCBCardService.cardName;
					} else if (DinersClubCardService.validCardNumber(secAcctInfo.account)) {
						paymentInfo.ccTypeDisplayAlias = DinersClubCardService.cardName;
					}

					if (paymentInfo.ccType === 'dynamic') {
						angular.extend(paymentInfo, DynamicCreditCardService.getLastPaymentType());
						return paymentInfo;
					}

					if (paymentInfo.type === 'mrcash') {
						for (i = 0; i < billingCount; i++) {
							if (billingTypes[i].auth_type === Enums.billingTypes.MISTERCASH) {
								billType = billingTypes[i];
								angular.extend(paymentInfo, billType);
								return paymentInfo;
							}
						}
					}

					for (i = 0; i < billingCount; i++) {
						paymentInfo.ccType = paymentInfo.ccType === 'dss' ? paymentInfo.cardCCType : paymentInfo.ccType;
						if (billingTypes[i].name.toLowerCase() == paymentInfo.ccType.toLowerCase()) {
							billType = billingTypes[i];
							break;
						}
					}

					// merchant_payment_type_ref_id is used for the Bin Image
					/* eslint-disable camelcase */
					paymentInfo.merchant_payment_type_ref_id = null;
					if (billType) {
						if (cardOverrides.length > 0) {
							for (i = 0; i < cardOverrides.length; i++) {
								if (billType.name.toLowerCase() == cardOverrides[i].toLowerCase()) {
									// Add so we can find the bin image
									paymentInfo.merchant_payment_type_ref_id = billType.merchant_payment_type_ref_id;
									return billType;
								}
							}
						}
					}
					/* eslint-disable camelcase */

					return null;
				}

				/**
				 * Get all card overrides
				 * @public
				 * @returns {Array}
				 */
				function getCardOverrides() {
					var cardOverride = isCardOverrideCharacs(),
						cardTypes = [],
						i = 0,
						billingTypes = AppData.billingTypes,
						billingCount = billingTypes.length,
						billingTypesFilter;

					// Set a filter to the card Types by the user selected payment method. Default to credit card.
					billingTypesFilter = Enums.billingTypes.CREDITCARD || UserInfo.payment.authType;

					for (; i < billingCount; i++) {
						// Including only the cards applicable to the selected payment method.
						if (billingTypes[i].auth_type == billingTypesFilter) {
							if (cardOverride == '' || billingTypes[i].card_type_code == cardOverride) {
								cardTypes.push(billingTypes[i].name);
							}
						}
					}
					return cardTypes;
				}

				/**
				 * Function that returns credit card type based on card number
				 * @public
				 * @param {string} value - card number
                 * @param {string} type - billing type
                 * @returns {string}
                 */
				function getCreditCardType(value, type) {
					switch (true) {
					case MasterCardCreditCardService.validCardNumber(value):
						return MasterCardCreditCardService.cardType();
					case DinersClubCardService.validCardNumber(value):
						return DinersClubCardService.cardType();
					case JCBCardService.validCardNumber(value):
						return JCBCardService.cardType();
					case DankortCardService.validCardNumber(value):
						return DankortCardService.cardType();
					case MaestroCreditCardService.validCardNumber(value):
						return MaestroCreditCardService.cardType();
					case VisaCreditCardService.validCardNumber(value):
						return VisaCreditCardService.cardType();
					case AmericanExpressCreditCardService.validCardNumber(value):
						return AmericanExpressCreditCardService.cardType();
					case DiscoverCreditCardService.validCardNumber(value):
						return DiscoverCreditCardService.cardType();
					case DynamicCreditCardService.validCardNumber(value):
						return DynamicCreditCardService.cardType();
					case (/^\d{13,19}/.test(value)):
						return 'atm';
					default:
						return 'phcard';
					}
				}

				/**
				 * Look for card_type_required characs in cart item
				 * @protected
				 * @returns {string}
				 */
				function isCardOverrideCharacs() {
					// Get the card override if it exist in the CHARACS of any of the items in the cart.
					for (var i = 0; i < LegacyCart.cartItems.length; i++) {
						var item = LegacyCart.cartItems[i];
						if (angular.isDefined(item.CHARACS)) {
							for (var j = 0; j < item.CHARACS.length; j++) {
								for (var key in item.CHARACS[j]) {
									if (key == 'card_type_required')
										return item.CHARACS[j][key];
								}
							}
						}
					}
					return '';
				}

				/**
				 * Method that sets the payment.cardType to mastercard
				 * in the case of maestro being selected.
				 * @param  {Object} pmt the payment object data, ex: { cardType: "maestro", account:"4111maestro1111"}
				 * @return {Object} the modified pmt object
				 */
				function maestroToMastercardOverride(pmt) {
					if (pmt.ccType === 'maestro' && pmt.type !== 'mrcash') {
						pmt.ccType = 'mastercard';

						// add a ccTypeDisplayAlias so that the correct sprite and label can be displayed on the orderReview
						pmt.ccTypeDisplayAlias = 'maestro';
					} else if (pmt.type === 'mrcash') {
						pmt.ccType = 'mrcash';
					}
					return pmt;
				}

				/**
				 * Function that returns creditcard type logo
				 * @public
				 * @param {string} ccType - credit card Type
				 * @returns {string} The alias name
				 */
				function setTypeDisplayAlias(ccType) {
					switch (true) {
					case JCBCardService.validCardNumber(ccType):
						return JCBCardService.cardName;
					case DankortCardService.validCardNumber(ccType):
						return DankortCardService.cardName;
					case DinersClubCardService.validCardNumber(ccType):
						return DinersClubCardService.cardName;
					default:
						return ccType;
					}
				}

				/**
				 * Validate card number - make sure the card number has correct length
				 * Diners Club and Union Pay Credit Cards are only identified if the card number length is correct.
				 * No additional validity check is needed.
				 * JCB cards don't have their own type. If the card is JCB, don't do the rest of the validation.
				 * @public
				 * @param {string} value - card number
				 * @param {string} ccType - card type
				 * @returns {boolean} If its a valid card number
				 */
				function validateCardNumber(value, ccType) {
					if (!value) {
						return false;
					}

					if (DinersClubCardService.validCardNumber(value)) {
						return true;
					} else if (JCBCardService.validCardNumber(value)) {
						return JCBCardService.validateLength(value);
					} else if (DankortCardService.validCardNumber(value)) {
						return true;
					} else {
						switch (ccType.toLowerCase()) {
						case 'mastercard':
							return MasterCardCreditCardService.validateLength(value);
						case 'discover card':
							return DiscoverCreditCardService.validateLength(value);
						case 'maestro':
							return MaestroCreditCardService.validateLength(value);
						case 'visa':
							return VisaCreditCardService.validateLength(value);
						case 'american express':
							return AmericanExpressCreditCardService.validateLength(value);
						case 'dynamic':
							return DynamicCreditCardService.validateLength(value);
						case 'atm':
							return value.length <= 19 && value.length >= 13;
						default:
							return false;
						}
					}
				}
			});
})();

(function() {
	'use strict';

	angular
		.module('credit-cards')
		.service('DynamicCreditCardService', DynamicCreditCardService);

	/**
	 * Our service constructor
	 * @public
	 * @constructor
	 * @param {Function} composeValidateCreditCard The composition function to validate a credit card
	 * @param {Service} AppData AppData
	 * @param {Service} CreditCardBinRangesService CreditCardBinRangesService
	 * @param {Object} CreditCardModels CreditCardModels
	 * @param {Service} Enums Enums
	 * @return {DynamicCreditCardService} A new instance of our service
	 * @ngInject
	 */
	function DynamicCreditCardService(composeValidateCreditCard, AppData, CreditCardBinRangesService, CreditCardModels, Enums) {
		var lastPaymentType;
		var service = {
			LENGTH_RANGE: [12, 19],
			// The index into the locale for the card name: i18n.CreditCards[service.cardName]
			cardName: 'dynamic',
			cardNameInBillingTypes: 'dynamic',
			cardType: cardType,
			getLastPaymentType: getLastPaymentType,
			initialize: angular.noop,
			setRegularBinRanges: angular.noop,
			spriteName: 'atm',
			validCardNumber: validCardNumber
		};

		composeValidateCreditCard(service);

		return service;

		/**
		 * Overrides the validate credit card as we need to be dynamic here and find one based on any of the bin ranges that came back.
		 * @public
		 * @override
		 * @param {String} cardNumber The credit card to validate
		 * @return {Boolean} if it passes and we found a payment type matching the bin range.
		 */
		function validCardNumber(cardNumber) {
			var paymentType,
				number = '',
				cardLength,
				bin;

			// null is considered truthy in isNaN :|
			if (cardNumber && !isNaN(cardNumber)) {
				number = cardNumber.toString();
			}

			// If they have anything that's not a number, fail it.
			if (/[^0-9]/.test(number)) {
				lastPaymentType = null;
				return false;
			}

			cardLength = number.length;

			bin = CreditCardBinRangesService
				.getBinRanges()
				.find(function(bin) {
					var testCase;
					var start = parseInt(bin.bin_range_start, 10);
					var end = parseInt(bin.bin_range_end, 10);
					var binLength = bin.bin_range_start.toString().length;

					if (cardLength < binLength) {
						return false;
					}

					testCase = parseInt(number.slice(0, binLength), 10);

					return testCase >= start && testCase <= end;
				});

			if (bin) {
				// Make sure we can find a matching payment type otherwise that bin isn't setup correctly
				paymentType = AppData.billingTypes.find(function(type) {
					return type.auth_type === Enums.billingTypes.CREDITCARD && type.credit_card_type_id === bin.cc_type_id;
				});

				if (paymentType) {
					lastPaymentType = paymentType;
					return true;
				}
			}

			lastPaymentType = null;
			return false;
		}

		/**
		 * Returns the card type which should be 'dynamic' so we can tell if it was dynamically generated.
		 * @public
		 * @return {String} 'cardType'
		 */
		function cardType() {
			return 'dynamic';
		}

		/**
		 * Returns a copy of the last payment type found.
		 * @public
		 * @return {Object|null} the last found card type.
		 */
		function getLastPaymentType() {
			return angular.copy(lastPaymentType);
		}
	}
})();

(function() {
	'use strict';

	angular
		.module('credit-cards')
		.service('JCBCardService', JCBCardService);

	/**
	 * Our service constructor
	 * @public
	 * @constructor
	 * @param {Service} AppData The service
	 * @param {Service} Utilities The service
	 * @param {Function} composeValidateCreditCard The composition function to validate a credit card
	 * @return {JCBCardService} A new instance of our service
	 * @ngInject
	 */
	function JCBCardService(AppData, Utilities, composeValidateCreditCard) {
		var service = {
			LENGTH_RANGE: [16],
			VALIDATE_LENGTH_IN_VALID_CARD_NUMBER: true,
			// The index into the locale for the card name: i18n.CreditCards[service.cardName]
			cardName: 'jcb',
			cardNameInBillingTypes: 'jcb',
			cardType: cardType,
			setRegularBinRanges: setRegularBinRanges,
			spriteName: 'jcb'
		};

		composeValidateCreditCard(service);

		service.cardValidator.setMinLength(4);

		return service;

		/**
		 * Sets the regular bin ranges to use with the store if we didnt get back in GetCreditCardBinRanges and the
		 * it wasn't in the PAYMENTTYPE node
		 * @public
		 * @return {undefined}
		 */
		function setRegularBinRanges() {
			var cardValidator = service.cardValidator;
			cardValidator.setDigitLimitOnRangeTesting(4);
			cardValidator.addBinRange(3528, 3589);
		}

		/**
		 * cardType returns the card type that the JCB card number maps to for the current island.
		 * Currently (3/17/2016), this mapping is controlled by an application configuration.
		 * Eventually this logic may move to the backend.
		 * @returns {String} The card type to use
		 **/
		function cardType() {
			if (Utilities.getBoolean(AppData.settings.mapJCBtoAmEx)) {
				return 'american express';
			}
			return 'discover card';
		}
	}
})();

/**
 * created by pMatthews 5/12/2016
 *
 * CreditCardValidator:
 *    Provides you with a framework for checking if a card number is a valid credit card.
 *    Usage:
 *    	To set up, create a new instance:
 *    			var dinersClub = new CreditCardModels.CreditCardValidator();
 *      If the card has a required length, set that:
 *      		dinersClub.setRequiredLength(16);
 *      If the card has a minimum length, set that:
 *      		dinersClub.setMinLength(12);
 *      If the card has a minimum length, set that:
 *      		dinersClub.setMaxLength(12);
 *      If the card has an acceptable bin range, set it up by calling addBinRange:
 *      		dinersClub.addBinRange(30000000, 30599999);
 *      		dinersClub.addBinRange(30950000, 30959999);
 *          ... (add as many as you want)
 *
 *      Once set up, to validate the card number, check isValidCardNumber, passing in a cardNumber (typically a string)
 *
 *    Cool Stuff:
 *      Some cards only need to test the first n digits of the card numbers. If this is the case for the card you're
 *      setting up, call CreditCardValidator.setDigitLimitOnRangeTesting(n);
 *
 *
 * BinRangeHandler (you probably won't have to use this directly, but if you do...
 * 		use addBinRange to add each acceptable range of bin numbers
 * 	  use setDigitLimitOnRangeTesting to limit the number of digits you want to do range testing on
 * 		use inRange to check if a card number is in range.
*/
angular
	.module('app')
	.service('CreditCardModels', function(Utilities, AppData, StringUtils) {
		function CreditCardValidator() {
			this.reqLength = undefined;
			this.minLength = undefined;
			this.maxLength = undefined;
			this.BinRangeHandler = new BinRangeHandler();
			this.setDigitLimitOnRangeTesting = function(maxLength) {
				this.BinRangeHandler.setDigitLimitOnRangeTesting(maxLength);
			};
			this.addBinRange = function(min, max) {
				this.BinRangeHandler.addBinRange(min, max);
			};
			this.setMaxLength = function(maxLength) {
				this.maxLength = Utilities.forceInt(maxLength);
			};
			this.setMinLength = function(minLength) {
				this.minLength = Utilities.forceInt(minLength);
			};
			this.setRequiredLength = function(reqLength) {
				this.reqLength = reqLength;
			};
			this.isValidCardNumber = function(cardNumber) {
				if (angular.isUndefined(cardNumber)
					|| (angular.isDefined(this.reqLength) && cardNumber.length != this.reqLength)
					|| (angular.isDefined(this.minLength) && cardNumber.length < this.minLength)
					|| (angular.isDefined(this.maxLength) && cardNumber.length > this.maxLength)) {
					return false;
				}
				return this.BinRangeHandler.inRange(cardNumber);
			};
		}

		function BinRangeHandler() {
			this.binRanges=[];
			this.binRangeMaxLength = undefined;

			this.setDigitLimitOnRangeTesting = function(maxLength) {
				this.binRangeMaxLength = Utilities.forceInt(maxLength);
			};

			this.inRange = function(cardNumber) {
				var result = false;
				if (this.binRanges.length<1) {
					return true;
				}
				if (angular.isDefined(this.binRangeMaxLength)) {
					cardNumber = Utilities.forceInt(cardNumber.toString().substring(0, this.binRangeMaxLength))
				} else {
					cardNumber = Utilities.forceInt(cardNumber);
				}
				for (var i=0; i<this.binRanges.length && ! result; i++) {
					result = (cardNumber >= this.binRanges[i].min && cardNumber <= this.binRanges[i].max)
				}
				return result;
			};

			this.addBinRange = function(min, max) {
				if (angular.isUndefined(this.binRanges) || angular.isUndefined(min) || angular.isUndefined(max)) {
					// should never happen
					return false;
				}
				var newRange = {
					min: min,
					max: max
				};
				this.binRanges.push(newRange);
				return true;
			};
		}

		function BillingTypesTable(cardName) {
			var normalize = StringUtils.normalize;
			this.cardName = cardName.toLowerCase();
			this.cardNameNormalized = normalize(cardName);
			this.cardExists = false;
			this.cardType ='';

			this.initialize = function() {
				if (angular.isDefined('AppData.billingTypes')) {
					for (var i=0; i < AppData.billingTypes.length && ! this.cardExists; i++) {
						if (normalize(AppData.billingTypes[i].name).indexOf(this.cardNameNormalized) !=-1) {
							this.cardExists = true;
							if (angular.isDefined(AppData.billingTypes[i].card_type_code)) {
								this.cardType = this.mapCard_type_codeToName(AppData.billingTypes[i].card_type_code);
							}
						}
					}
				}
			};

			this.cardTypeMap = function() {
				var result = [];
				result['VI'] = 'visa';
				result['MC'] = 'mastercard';
				result['AX'] = 'american express';
				result['DS'] = 'discover card';
				return result;
			};

			this.mapCard_type_codeToName = function(card_type_code) {
				var cardTypeMap = this.cardTypeMap();
				if (angular.isDefined(card_type_code) && angular.isDefined(cardTypeMap[card_type_code.toUpperCase()])) {
					return cardTypeMap[card_type_code.toUpperCase()];
				}
				return '';
			};

			this.initialize();
		}

		this.BinRangeHandler = BinRangeHandler;
		this.CreditCardValidator = CreditCardValidator;
		this.BillingTypesTable = BillingTypesTable;
	});

(function() {
	'use strict';

	angular
		.module('credit-cards')
		.service('DinersClubCardService', DinersClubCardService);

	/**
	 * Our service constructor
	 * @public
	 * @constructor
	 * @param {Function} composeValidateCreditCard The composition function to validate a credit card
	 * @return {DinersClubCardService} A new instance of our service
	 * @ngInject
	 */
	function DinersClubCardService(composeValidateCreditCard) {
		var service = {
			LENGTH_RANGE: [14],
			VALIDATE_LENGTH_IN_VALID_CARD_NUMBER: true,
			// The index into the locale for the card name: i18n.CreditCards[service.cardName]
			cardName: 'dinersclub',
			cardNameInBillingTypes: 'diners club',
			setRegularBinRanges: setRegularBinRanges,
			spriteName: 'dinersclub'
		};

		composeValidateCreditCard(service);

		return service;

		/**
		 * Sets the regular bin ranges to use with the store if we didnt get back in GetCreditCardBinRanges and the
		 * it wasn't in the PAYMENTTYPE node
		 * @public
		 * @return {undefined}
		 */
		function setRegularBinRanges() {
			var cardValidator = service.cardValidator;
			cardValidator.setDigitLimitOnRangeTesting(8);
			[
				[30000000, 30599999],
				[30950000, 30959999],
				[36000000, 36999999],
				[38000000, 39999999]
			].forEach(function(ranges) {
				cardValidator.addBinRange(ranges[0], ranges[1]);
			});
		}
	}
})();

(function() {
	'use strict';

	angular
		.module('credit-cards')
		.factory('MasterCardCreditCardService', MasterCardCreditCardService);

	/**
	 * Our service constructor
	 * @public
	 * @constructor
	 * @param {Function} composeValidateCreditCard The composition function to validate a credit card
	 * @return {MasterCardCreditCardService} A new instance of our service
	 * @ngInject
	 */
	function MasterCardCreditCardService(composeValidateCreditCard) {
		var service = {
			LENGTH_RANGE: [16],
			// The index into the locale for the card name: i18n.CreditCards[service.cardName]
			cardName: 'mastercard',
			cardNameInBillingTypes: 'mastercard',
			setRegularBinRanges: setRegularBinRanges,
			spriteName: 'mastercard'
		};

		composeValidateCreditCard(service);

		return service;

		/**
		 * Sets the regular bin ranges to use with the store if we didnt get back in GetCreditCardBinRanges and the
		 * it wasn't in the PAYMENTTYPE node
		 * @public
		 * @return {undefined}
		 */
		function setRegularBinRanges() {
			var cardValidator = service.cardValidator;
			cardValidator.setDigitLimitOnRangeTesting(6);
			cardValidator.addBinRange(510000, 559999);
			cardValidator.addBinRange(222100, 272099);
		}
	}
})();

(function() {
	'use strict';

	angular
		.module('credit-cards')
		.service('AmericanExpressCreditCardService', AmericanExpressCreditCardService);

	/**
	 * Our service constructor
	 * @public
	 * @constructor
	 * @param {Function} composeValidateCreditCard The composition function to validate a credit card
	 * @return {AmericanExpressCreditCardService} A new instance of our service
	 * @ngInject
	 */
	function AmericanExpressCreditCardService(composeValidateCreditCard) {
		var service = {
			LENGTH_RANGE: [15],
			// The index into the locale for the card name: i18n.CreditCards[service.cardName]
			cardName: 'americanexpress',
			cardNameInBillingTypes: 'american express',
			setRegularBinRanges: setRegularBinRanges,
			spriteName: 'americanexpress'
		};

		composeValidateCreditCard(service);

		return service;

		/**
		 * Sets the regular bin ranges to use with the store if we didnt get back in GetCreditCardBinRanges and the
		 * it wasn't in the PAYMENTTYPE node
		 * @public
		 * @return {undefined}
		 */
		function setRegularBinRanges() {
			var cardValidator = service.cardValidator;
			cardValidator.setDigitLimitOnRangeTesting(2);
			cardValidator.addBinRange(34, 34);
			cardValidator.addBinRange(37, 37);
		}
	}
})();

(function() {
	'use strict';

	angular
		.module('credit-cards')
		.service('VisaCreditCardService', VisaCreditCardService);

	/**
	 * Our service constructor
	 * @public
	 * @constructor
	 * @param {Function} composeValidateCreditCard The composition function to validate a credit card
	 * @return {VisaCreditCardService} A new instance of our service
	 * @ngInject
	 */
	function VisaCreditCardService(composeValidateCreditCard) {
		var service = {
			LENGTH_RANGE: [13, 16, 19],
			// The index into the locale for the card name: i18n.CreditCards[service.cardName]
			cardName: 'visa',
			cardNameInBillingTypes: 'visa',
			setRegularBinRanges: setRegularBinRanges,
			spriteName: 'visa'
		};

		composeValidateCreditCard(service);

		return service;

		/**
		 * Sets the regular bin ranges to use with the store if we didnt get back in GetCreditCardBinRanges and the
		 * it wasn't in the PAYMENTTYPE node
		 * @public
		 * @return {undefined}
		 */
		function setRegularBinRanges() {
			var cardValidator = service.cardValidator;
			cardValidator.setDigitLimitOnRangeTesting(1);
			cardValidator.addBinRange(4, 4);
		}
	}
})();

(function() {
	'use strict';

	angular
		.module('credit-cards')
		.service('DiscoverCreditCardService', DiscoverCreditCardService);

	/**
	 * Our service constructor
	 * @public
	 * @constructor
	 * @param {Function} composeValidateCreditCard The composition function to validate a credit card
	 * @return {DiscoverCreditCardService} A new instance of our service
	 * @ngInject
	 */
	function DiscoverCreditCardService(composeValidateCreditCard) {
		var service = {
			LENGTH_RANGE: [16],
			// The index into the locale for the card name: i18n.CreditCards[service.cardName]
			cardName: 'discovercard',
			cardNameInBillingTypes: 'discover card',
			setRegularBinRanges: setRegularBinRanges,
			spriteName: 'discover'
		};

		composeValidateCreditCard(service);

		return service;

		/**
		 * Sets the regular bin ranges to use with the store if we didnt get back in GetCreditCardBinRanges and the
		 * it wasn't in the PAYMENTTYPE node
		 * @public
		 * @return {undefined}
		 */
		function setRegularBinRanges() {
			var cardValidator = service.cardValidator;
			cardValidator.setDigitLimitOnRangeTesting(6);
			[
				[601100, 601199],
				[622126, 622925],
				[644000, 649999],
				[650000, 659999]
			].forEach(function(range) {
				cardValidator.addBinRange(range[0], range[1]);
			});
		}
	}
})();

(function() {
	'use strict';

	angular
		.module('credit-cards')
		.service('MaestroCreditCardService', MaestroCreditCardService);

	/**
	 * Our service constructor
	 * @public
	 * @constructor
	 * @param {Function} composeValidateCreditCard The composition function to validate a credit card
	 * @return {MaestroCreditCardService} A new instance of our service
	 * @ngInject
	 */
	function MaestroCreditCardService(composeValidateCreditCard) {
		var service = {
			LENGTH_RANGE: [12, 19],
			// The index into the locale for the card name: i18n.CreditCards[service.cardName]
			cardName: 'maestro',
			cardNameInBillingTypes: 'maestro',
			setRegularBinRanges: setRegularBinRanges,
			spriteName: 'maestro'
		};

		composeValidateCreditCard(service);

		return service;

		/**
		 * Sets the regular bin ranges to use with the store if we didnt get back in GetCreditCardBinRanges and the
		 * it wasn't in the PAYMENTTYPE node
		 * @public
		 * @return {undefined}
		 */
		function setRegularBinRanges() {
			var cardValidator = service.cardValidator;
			cardValidator.setDigitLimitOnRangeTesting(6);
			[
				[500000, 509999],
				[560000, 589999],
				[600000, 601099],
				[601110, 601119],
				[601150, 601173],
				[601175, 601176],
				[601180, 601185],
				[601200, 643999],
				[660000, 699999]
			].forEach(function(ranges) {
				cardValidator.addBinRange(ranges[0], ranges[1]);
			});
		}
	}
})();

(function() {
	'use strict';

	angular
		.module('credit-cards')
		.service('DankortCardService', DankortCardService);

	/**
	 * Our service constructor
	 * @public
	 * @constructor
	 * @param {Service} AppData For getting app configs
	 * @param {Service} Utilities For getting booleans
	 * @param {Function} composeValidateCreditCard The composition function to validate a credit card
	 * @return {DankortCardService} A new instance of our service
	 * @ngInject
	 */
	function DankortCardService(AppData, Utilities, composeValidateCreditCard) {
		var ENABLED = Utilities.getBoolean(AppData.settings.display_dankort);
		var originalValidCardNumber;
		var internalCardType;
		var service = {
			LENGTH_RANGE: [16],
			VALIDATE_LENGTH_IN_VALID_CARD_NUMBER: true,
			// The index into the locale for the card name: i18n.CreditCards[service.cardName]
			cardName: 'Dankort',
			cardNameInBillingTypes: 'dankort',
			cardType: cardType,
			setRegularBinRanges: setRegularBinRanges,
			spriteName: 'dankort'
		};

		composeValidateCreditCard(service);

		// Override the ValidCardNumber function
		originalValidCardNumber = service.validCardNumber;
		service.validCardNumber = validCardNumber;

		return service;

		/**
		 * Sets the regular bin ranges to use with the store if we didnt get back in GetCreditCardBinRanges and the
		 * it wasn't in the PAYMENTTYPE node
		 * @public
		 * @return {undefined}
		 */
		function setRegularBinRanges() {
			var cardValidator = service.cardValidator;
			cardValidator.setDigitLimitOnRangeTesting(8);
			[
				[50190000, 50199999],
				[41750000, 41759999],
				[45710000, 45719999]
			].forEach(function(ranges) {
				cardValidator.addBinRange(ranges[0], ranges[1]);
			});
		}

		/**
		 * So here's the deal about this function. We need to override the existing one and call it, but there
		 * is special logic that happens for Dankort that our system wants to turn it into Visa or Mastercard.
		 * So this function must set the internal card type if it passes validation because cardType will get
		 * called right after.
		 * @public
		 * @function
		 * @name validCardNumber
		 * @param {String} cardNumber The credit card the user typed in.
		 * @return {Boolean} if it's valid or not
		 */
		function validCardNumber(cardNumber) {
			if (!ENABLED || !originalValidCardNumber.call(service, cardNumber)) {
				return false;
			}

			internalCardType = '5019' === service.cardToString(cardNumber).substring(0, 4) ? 'mastercard' : 'visa';

			return true;
		}

		/**
		 * Returns the internal card type if it changes when validating the card.
		 * @public
		 * @function
		 * @name cardType
		 * @return {String} The card type
		 */
		function cardType() {
			return internalCardType;
		}
	}
})();

/**
 * Created by ltischuk on 5/9/16.
 */
angular.module('date-collection', ['app'])
/*
 * Created by ltischuk on 5/9/16.
 * Modified by Michael Yuen on 5/18/16
 */
angular.module('date-collection').factory
('DateCollectionService',
	function($filter,
		$q,
		AppData,
		CustomActionService,
		Enums,
		JSONValidator,
		Language,
		Utilities,
		UtilsValidation) {

	/******************/
	/* PUBLIC METHODS */
	/******************/
	var factory = {

		config: {},
		buildConfig: buildConfig,
		buildErrors: buildErrors,
		createDateModel: createDateModel,
		parseDateStringIntoObject: parseDateStringIntoObject,
		parseDateObjectIntoString: parseDateObjectIntoString,
		parseMonthNumberIntoWord: parseMonthNumberIntoWord,
		parseMonthWordIntoNumber: parseMonthWordIntoNumber,
		parseDay: parseDay,
		parseYear: parseYear,
		shouldValidate: shouldValidate,
		validateDateObject: validateDateObject,
		validateMinAge: validateMinAge,
		validateMaxAge: validateMaxAge,
		validateAge: validateAge,
		updateDayList: updateDayList,
		standardizeFormatString: standardizeFormatString
	};
	var isNumber = angular.isNumber;

	/*
	 * This method is to consolidate the configuration for the date-collection module.
	 * There are 3 steps to building the configuration:
	 *
	 * 1) define 'defaults', which will drive the behavior for configurations when there are no others defined
	 * 2) get and validate the date_collection config, then overwrite the defaults properties with those that are present
	 * 3) overwrite the properties with the values of the attributes passed into the directive
	 *
	 * The idea is that there will always be the same configuration, which can be easily extended
	 * because the logic is all encapsulated here. Additionally, we will end up with a configuration
	 * that respects specificity: attributes > app config > defaults
	 * In this way, Ops will be able to update the global configuration for date-collection as needed,
	 * but in situations where this is not acceptable and we need specific tweaks, the attributes will make this easy.
	 */
	function buildConfig( attrs ){

		var defaults = {
						display: 				  'hybrid'
						,display_month_as_number: false
						,format_string: 		  'MM/dd/yyyy'
						,hide_label: 			  false
						,hide_input_label:		  true
						,is_required: 			  false
						,label: 				  Language.getLocale( 'FormLabels','date' )
						,max_year: 				  new Date().getFullYear()
						,min_year: 				  undefined
						,model_format: 			  undefined
						,model_is_format: 		  false
						,validation_type: 		  undefined
						,year_order: 			  'descending'
						,year_regex: 			  /^(19|20)\d{2}$/
						,min_age:				  undefined
						,max_age:				  undefined
					};

		if( Utilities.safelyCheckPropertyOnObject( 'AppData.settings.date_format', AppData ) ){

			defaults.format_string = AppData.settings.date_format;
		}

		if( Utilities.safelyCheckPropertyOnObject( 'AppData.settings.date_collection', AppData ) ){

			if( JSONValidator.validate( 'date_collection', AppData.settings.date_collection ) ){

				var app_config = JSON.parse( AppData.settings.date_collection );

				angular.forEach( app_config, function( value, key ){

					if( key !== 'error_config' ){

						if( key === 'label' ){

							defaults[ key ] = Language.getLocale( value.section, value.target );
						}
						else{

							defaults[ key ] = value;
						}
					}
				});
			}
		}

		if (UtilsValidation.validString(attrs.objConfig)) {
			try {
				var jsonConfig = JSON.parse(attrs.objConfig);
				if (UtilsValidation.isRealObject(jsonConfig)) {
					Object.keys(jsonConfig).forEach(function(key) {
						if (defaults.hasOwnProperty(key)) {
							defaults[key] = jsonConfig[key];
						}
					});
				}
			} catch(e) {}
		}

		if( angular.isDefined( attrs.display ) ){
			defaults.display = attrs.display;
		}

		if( angular.isDefined( attrs.displayMonthAsNumber ) ){
			defaults.display_month_as_number = attrs.displayMonthAsNumber;
		}

		if( angular.isDefined( attrs.formatString ) ){
			defaults.format_string = attrs.formatString;
		}

		if( angular.isDefined( attrs.hideLabel ) ){
			defaults.hide_label = attrs.hideLabel;
		}

		if (angular.isDefined(attrs.hideInputLabel)) {
			defaults.hide_input_label = attrs.hideInputLabel;
		}

		if( angular.isDefined( attrs.isRequired ) ){
			defaults.is_required = attrs.isRequired;
		}

		if( angular.isDefined( attrs.label ) ){
			defaults.label = attrs.label;
		}

		if( angular.isDefined( attrs.maxYear ) ){
			defaults.max_year = attrs.maxYear;
		}

		if( angular.isDefined( attrs.minYear ) ){
			defaults.min_year = attrs.minYear;
		}

		if( angular.isDefined( attrs.modelFormat ) ){
			defaults.model_format = attrs.modelFormat;
		}

		if( angular.isDefined( attrs.modelIsFormat ) ){
			defaults.model_is_format = attrs.modelIsFormat;
		}

		if( angular.isDefined( attrs.validationType ) ){
			defaults.validation_type = attrs.validationType;
		}

		if( angular.isDefined( attrs.yearOrder ) ){
			defaults.year_order = attrs.yearOrder;
		}

		if( angular.isDefined( attrs.yearRegex ) ){
			defaults.year_regex = attrs.yearRegex;
		}

		if (angular.isString(attrs.minAge)) {
			defaults.min_age = Number(attrs.minAge);
		}

		if (!isNaN(attrs.maxAge)) {
			defaults.max_age = parseInt(attrs.maxAge, 10);
		}

		if( Utilities.getBoolean( defaults.hide_label ) ){

			defaults.label = undefined;
		}

		// Last, need to set min_year depending on validationType, but only if it is undefined
		if( angular.isUndefined( defaults.min_year ) ){
			defaults.min_year = ( defaults.validation_type === 'birthDate' ) ? 1900 : new Date().getFullYear();
		}

		// Ensure the resulting format_string always uses the '/' separator
		defaults.format_string = factory.standardizeFormatString( defaults.format_string );

		factory.config = defaults;
	};

	/*
	 * This method is to consolidate the configuration for the date-collection module's error messages.
	 * Due to the dynamic nature of the field, this will allow for custom error messages driven via
	 * attributes or the date_collection app config.
	 *
	 * There are 3 steps to building the configuration:
	 *
	 * 1) define 'defaults', which will drive the behavior for configurations when there are no others defined
	 * 2) get and validate the date_collection config, then overwrite the defaults properties with those that are present
	 * 3) overwrite the properties with the values of the attributes passed into the directive
	 */
	function buildErrors( errorConfig ){

		var defaults = {
			section: 'FormValidation',
			errors: {
				required: 'dobRequiredError',
				minAgeError: 'minAgeRequirementError',
				minAgeNotMet: 'minAgeNotMet',
				maxAgeExceeded: 'maxAgeExceeded',
				visitAgeNotMet: 'visitAgeNotMet'
			}
		};

		if( Utilities.safelyCheckPropertyOnObject( 'AppData.settings.date_collection', AppData ) ){

			if( JSONValidator.validate( 'date_collection', AppData.settings.date_collection ) ){

				var app_config = JSON.parse( AppData.settings.date_collection );

				if( angular.isDefined( app_config.error_config ) ){

					var error_config = app_config.error_config;

					if( angular.isDefined( error_config.section ) ){
						defaults.section = error_config.section;
					}

					angular.forEach( error_config.errors, function( value, key ){

						defaults.errors[ key ] = value;
					});
				}
			}
		}

		if( angular.isDefined( errorConfig ) ){

			if( angular.isDefined( errorConfig.section ) ){
				defaults.section = errorConfig.section;
			}

			if( angular.isDefined( errorConfig.errors ) ){

				angular.forEach( errorConfig.errors, function( value, key ){

					defaults.errors[ key ] = value;
				});
			}
		}

		factory.config.errors = defaults;
	};

	/*
     * Parse a date into an object given a date string and a date format string
     * @returns dateObject {Object}
     */
	function createDateModel(customLocaleSection) {
		var localeSection = customLocaleSection ? customLocaleSection : 'FormLabels';
		factory.config.format_string + '/';

		var dateModel = [],
			dateFormatArray = factory.config.format_string.toLowerCase().split('/');

		for(var i = 0; i < dateFormatArray.length; i++) {
			var field = dateFormatArray[i],
				fieldObject = {
					name: undefined,
					placeholder: undefined,
					model: undefined,
					type: undefined,
					template: undefined,
					data: undefined
				};

			if (field.indexOf('m') > -1 ) {
				fieldObject.name = 'month';
				fieldObject.placeholder = Language.getLocale(localeSection, 'month');
				fieldObject.type  = 'dropdown';
				fieldObject.template = 'scripts/modules/date-collection/directives/views/' + fieldObject.type + '.html';
				if (factory.config.display_month_as_number) {
					var tempData = [];
					for (var x = 0; x < Language.months.length; x++) {
						tempData.push($filter('leadingZeros')((x + 1), 2));
					}
					fieldObject.data = tempData;
				} else {
					fieldObject.data = Language.months;
				}
			} else if (field.indexOf('d') > -1) {
					fieldObject.name = 'day';
					fieldObject.placeholder = Language.getLocale(localeSection, 'day');
					fieldObject.type = (factory.config.display === 'dropdown') ? 'dropdown' : 'text';
					fieldObject.template = 'scripts/modules/date-collection/directives/views/' + fieldObject.type + '.html';
			} else if (field.indexOf('y') > -1) {
					fieldObject.name = 'year';
					fieldObject.placeholder = Language.getLocale(localeSection, 'year');
					fieldObject.type = (factory.config.display === 'dropdown') ? 'dropdown' : 'text';
					fieldObject.template = 'scripts/modules/date-collection/directives/views/' + fieldObject.type + '.html';

					/*
					 * If the type is dropdown, we will need to generate the data for years
					 * Otherwise, it will be a text input so we can leave data undefined
					 */
					if (factory.config.display === 'dropdown') {
						fieldObject.data = getYearList(factory.config.min_year, factory.config.max_year);
					}
				}

				dateModel.push(fieldObject);
			}
			return dateModel;
		};

	/*
     * Parse a date into an object given a date string and a date format string
     * @param   dateString {string}
     * @returns dateObject {Object}
     */
	function parseDateStringIntoObject( dateString ){

		var separatorRegex = /[-.\/ ]/,
			separator = separatorRegex.test(dateString) ? separatorRegex.exec(dateString)[0] : '/',
			dateArray = dateString.split( separator ),
			dateFormatArray = factory.config.format_string.toLowerCase().replace(new RegExp(separatorRegex.source, 'g'), '/').split('/'),
			dateObject = {};

		if( dateFormatArray.indexOf('mm') > -1 ){

			if( factory.config.model_is_format ){

				dateObject.month = dateArray[ dateFormatArray.indexOf('mm') ];
			}
			else{

				dateObject.month = dateArray[0];
			}
		}

		if( dateFormatArray.indexOf('dd') > -1 ){

			if( factory.config.model_is_format ){

				dateObject.day = dateArray[ dateFormatArray.indexOf('dd') ];
			}
			else{

				dateObject.day = dateArray[1];
			}
		}

		if( dateFormatArray.indexOf('yyyy') > -1 ){

			if( factory.config.model_is_format ){

				dateObject.year = dateArray[ dateFormatArray.indexOf('yyyy') ];
			}
			else{

				dateObject.year = dateArray[2];
			}
		}

		return dateObject;
	};

	/*
	 * Parse a date into a string given a date object and a date format string
     * @param   dateObject {Object}
     * @param   dateFormatString {string}
     * @returns filteredDate {string}
     */
	function parseDateObjectIntoString( dateObject ){

		var date = new Date();
		date.setDate(1);

		if( angular.isDefined( dateObject.year ) ){

			date.setFullYear( dateObject.year );
		}

		if( angular.isDefined( dateObject.month ) ){

			date.setMonth( dateObject.month - 1 );
		}

		if( angular.isDefined( dateObject.day ) ){

			date.setDate( dateObject.day );
		}

		if( Utilities.getBoolean( factory.config.model_is_format ) ){

			return $filter('date')( date, factory.config.format_string );
		}
		else if( angular.isDefined( factory.config.model_format ) ){

			return $filter('date')( date, factory.config.model_format );
		}
		else{

			return $filter('date')( date, 'yyyy-MM-dd');
		}
	};

	/*
	 * Parse a month into the string word representation given the string number
     * @param   month {string (number)}
     * @returns month {string (word)}
     */
	function parseMonthNumberIntoWord( month ){

		return Language.months[ ( Utilities.forceInt(month) - 1 ) ];
	};

	/*
	 * Parse a month into the string number representation given the string word
     * @param   month {string (word)}
     * @returns month {string (number)}
     */
	function parseMonthWordIntoNumber( month ){

		for( var i=0; i < Language.months.length; i++ ){
			if( Language.months[i] === month ){
				return $filter('leadingZeros')( (i+1), 2 );
			}
		}
	};

	/*
     * Only used with date_collection_type of 'hybrid', where the day field is a text input.
     * Will ensure a max length of 2 characters.
     * Will return undefined if there are any non-digits present
     * Will return undefined if the day is 0
     * @param   day {string}
     * @returns day {string} or undefined
     */
	function parseDay( day ){

		var pattern = new RegExp( /^\d{2}$/ );

		day = day.substring(0,2);
		day = ( pattern.test(day) ) ? day : undefined;
		return ( Utilities.forceInt( day ) > 0 && Utilities.forceInt( day ) < 32 ) ? day : undefined;
	};

	/*
     * Only used with date_collection_type of 'hybrid', where the year field is a text input.
     * Will ensure a max length of 4 characters.
     * Will return undefined if year doesn't match regex
     * - regex requires the year be 19XX or 20XX
     * - regex will be overridden and use config 'year_regex' if present
     * @param   year {string}
     * @returns year {string} or undefined
     */
	function parseYear( year ){

		var pattern = new RegExp( factory.config.year_regex );

		year = year.substring(0,4);

		if( year.length < 4 ){
			return year;
		}
		else if( pattern.test(year) ){
			return year;
		}
		else{
			return undefined;
		}
	};

	/*
     * Once we have a valid date object - valid meaning that all applicable fields are present,
     * this method will ensure it is also valid in being a real date
     * If present, the attribute 'validationType' (with the value 'birthDate') will also check if the
     * date is in the past (up to now)
     * @param   year {string}
     * @returns valid {Boolean}
     */
	function validateDateObject( dateObject ){

		var valid = true,
			validationType = factory.config.validation_type;

		valid = isValidCalendarDate( dateObject );

		if( valid && angular.isDefined( validationType ) && validationType === 'birthDate' ){
			valid = isPastOrPresentDate( dateObject );
		}

		return valid;
	};

		/**
		 * Validates the minimum age against the user inputted date
		 * @public
		 * @param {Object} date user inputted date
		 * @returns {boolean} indicates if min age is valid
         */
		function validateMinAge(date) {
			var valid = true,
				dateObject = new Date(Number(date.year), Number(date.month) - 1, Number(date.day)),
				milliSecDiff,
				milliSecAge,
				minAge = factory.config.min_age;

			//create date from dateObj to compare.
			if (isNumber(minAge)) {
				milliSecDiff = Date.now() - dateObject.getTime();
				milliSecAge = new Date(milliSecDiff);

				valid = Math.abs(milliSecAge.getUTCFullYear() - 1970) >= minAge;
			}

			return valid;
		}

		/**
		 * Validates the maximum age against the user inputted date
		 * @public
		 * @param {Object} date The user's inputted date parsed into:
			{
				year: number,
				month: number (zero-indexed),
				day: number
			}
		 * @returns {Boolean} indicates if max age is valid
         */
		function validateMaxAge(date) {
			var valid = true,
				dateObject = new Date(Number(date.year), Number(date.month) - 1, Number(date.day)),
				milliSecDiff,
				milliSecAge,
				maxAge = factory.config.max_age;

			//create date from dateObj to compare.
			if (isNumber(maxAge)) {
				milliSecDiff = Date.now() - dateObject.getTime();
				milliSecAge = new Date(milliSecDiff);

				valid = Math.abs(milliSecAge.getUTCFullYear() - 1970) <= maxAge;
			}

			return valid;
		}

		/**
		 * checks if customer type characs are set up and we should validate against them
		 * @return {boolean} true if validation needs to happen against min and max age customer type characs
		 */
		function shouldValidate() {
			return isNumber(factory.config.max_age) || isNumber(factory.config.min_age);
		}

	/*
     * When the date_collection_type is 'dropdown' and the month or year changes,
     * we will update the data for the day dropdown.
     * @param   year {string}
     * @param   month {string}
     * @returns dayList {Array}
     */
	function updateDayList( year, month ){

		var numberOfDays = Utilities.getDaysInMonth( year, month );
		return getDayList( numberOfDays );
	};

	/*********************/
	/* PRIVATE FUNCTIONS */
	/*********************/

	function getDayList( numberOfDays ){

		var days = [];

		if( angular.isUndefined( numberOfDays ) ){

			numberOfDays = 31;
		}

		for( var i=1; i <= numberOfDays; i++ ){

			var string = String(i);

			if( string.length === 1 ){
				string = '0' + string;
			}

			days.push(string);
		}

		return days;
	};

	/*
     * Populate a list of years given a min and max
     * @param   [minYear] - optional - defaults to today's year if no minYear is passed in
     * @param   maxYear
     * @returns yearList {Array}
     */
    function getYearList( minYear, maxYear ){

		var yearList      = [];
		var currYearStart = angular.isDefined( minYear ) ? Number( minYear ): 1900;
		maxYear           = Number( maxYear );

		for( var i = maxYear; i >= currYearStart; i-- ){

			yearList.push( String(maxYear) );
			maxYear--;
		}

		if( factory.config.year_order === 'ascending' ){
			yearList.reverse();
		}

		return yearList;
	};

	/*
	 * @author: jeffery.wroblewski@accesso.com
	 * @modified: Michael Yuen 5/20/16
	 * Function to validate that a parsed date falls within a valid calendar date.
	 * @param dateObj {object} An object that contains the year, month, and day properties that each represent the
	 *                         numeric value to be passed to a JavaScript Date object.
	 *                         Example: { year: 1955, month: 9, day: 21 } which is October 21st, 1955
	 * @returns {boolean} True if the dateObj values are a valid date on the calendar.
	 *                    False if not (such as February 30th or June 31st)
	 */
	function isValidCalendarDate( dateObject ){

		var valid = true,
			date = new Date();

		date.setDate(1);

		/*
		 * 1) Set date using the existing fields. Must go general to specific (year > day)
		 * or else this can yield edge cases. For instance, with the UK format day will come first,
		 * and if the day selected is 31 and our current month doesn't have 31 days, it will cause
		 * the day to actually be set to the 1st of the next month.
		 */
		if( angular.isDefined( dateObject.year ) ){

			date.setFullYear( dateObject.year );
		}

		if( angular.isDefined( dateObject.month ) ){

			date.setMonth( dateObject.month - 1 );
		}

		if( angular.isDefined( dateObject.day ) ){

			date.setDate( dateObject.day );
		}

		// 2) Go through once more, this time comparing values
		if( angular.isDefined( dateObject.year ) ){

			if( date.getFullYear() !== Utilities.forceInt( dateObject.year ) ){
				valid = false;
			}
		}

		if( angular.isDefined( dateObject.month ) ){

			if( ( date.getMonth() + 1 ) !== Utilities.forceInt( dateObject.month ) ){
				valid = false;
			}
		}

		if( angular.isDefined( dateObject.day ) ){

			if( date.getDate() !== Utilities.forceInt( dateObject.day ) ){
				valid = false;
			}
		}

		return valid;
	};

	/*
	 * @author: jeffery.wroblewski@accesso.com
	 * @modified: Michael Yuen 5/20/16
	 * Function to validate that a parsed date is in the past or on the current date.
	 * @param dateObj  {object} An object that contains the year, month, and day properties that each represent the
	 *                         numeric value to be passed to a JavaScript Date object.
	 *                         Example: { year: 1955, month: 9, day: 21 } which is October 21st, 1955
	 * @returns {boolean} True if the dateObj values form a date that is less than or equal to the current date (in the past or is the present).
	 *                    False if the date is in the future.
	 */
	function isPastOrPresentDate( dateObject ){

		var valid = false,
			date = new Date(),
			currentDate = new Date();

		date.setDate(1);

		// 1) Iterate through dateObject and set date using the existing fields
		angular.forEach( dateObject, function( value, key ){

			if( key === 'month' ){
				date.setMonth( value - 1 );
			}
			else if( key === 'day' ){
				date.setDate( value );
			}
			else if( key === 'year' ){
				date.setFullYear( value );
			}
		});

		valid = date <= currentDate;

		return valid;
	};

	function standardizeFormatString( format_string ){

		// The separator is already correct - return
		if( format_string.indexOf( '/' ) !== -1 ){

			return format_string;
		}
		// Replace other possible separators with '/'
		return format_string.replace(/[-. ]/g, '/');
	};

	/**
	 * Validate Guest's Age
	 * @function
	 * @public
	 * @param {boolean} validateVisitAgeFlag boolean that determines should we make the call or not
	 * @param {object} dateObj selected visit date obj
	 * @return {Promise} - a promise that resolves with { skipped: true } when validation cannot be performed
	 */
	function validateAge(validateVisitAgeFlag, dateObj) {
		var requestObj;

		if (validateVisitAgeFlag && CustomActionService.actionRegistered(CustomActionService.ACTIONS_ENUMS.CREATE_VALIDATE_AGE_REQUEST)) {
			requestObj = CustomActionService.executeCustomAction(CustomActionService.ACTIONS_ENUMS.CREATE_VALIDATE_AGE_REQUEST, factory.parseDateObjectIntoString(dateObj));
			if (!requestObj) {
				return $q.resolve({ skipped: true });
			}
			return new $q(function(resolve, reject) {
				return AppData.fetch(Enums.services.VALIDATE_AGE, false, requestObj)
					.then(function(response) {
						if (response.status === 'FAILED') {
							return reject();
						}
						resolve(response);
					}).catch(reject);
			})
		}
		//when either the flag is false or no custom action registered, then validating age is not needed - resolve
		return $q.resolve();
	}

	return factory;
});

/*
 * Created by ltischuk on 5/9/16.
 * Modified by Michael Yuen on 5/18/16
 */
angular
	.module('date-collection')
	.directive('dateCollection', function (
		$rootScope,
		DateCollectionService,
		Language,
		Utilities,
		UtilsValidation,
		Modal
	) {
		var validString = UtilsValidation.validString;

		return {
			restrict: 'E',
			require: 'ngModel',
			templateUrl: '/scripts/modules/date-collection/directives/views/date-collection.html',
			scope: {
				submitted: "=",
				errorConfig: "=",
				isDisabled: "<",
				customLocaleSection: "@",
				onValidatingAge: "&",
				prepopulatedValidation: "<",
				validateVisitAge: "<"
			},
			link: function (scope, element, attrs, ngModelCtrl) {
				scope.i18n = $rootScope.i18n;
				DateCollectionService.buildConfig(attrs);
				DateCollectionService.buildErrors(scope.errorConfig);

				scope.id = Utilities.guid();
				scope.dateModel = DateCollectionService.createDateModel(scope.customLocaleSection);
				scope.label = DateCollectionService.config.label;
				scope.name = attrs.name;
				scope.expandFields = Utilities.getBoolean(attrs.expandFields);
				scope.isRequired = Utilities.getBoolean(DateCollectionService.config.is_required);
				scope.hideInputLabel = Utilities.getBoolean(DateCollectionService.config.hide_input_label);
				scope.originalHideInputLabel = scope.hideInputLabel;
				scope.errors = DateCollectionService.config.errors;
				scope.minMaxDateValidate = minMaxDateValidate;
				scope._validateVisitAge = _validateVisitAge;
				scope._lastValidatedDate = null;
				var display = DateCollectionService.config.display,
					displayMonthAsNumber = Utilities.getBoolean(DateCollectionService.config.display_month_as_number),
					selectedMonth,
					selectedYear,
					validateMinAge = DateCollectionService.validateMinAge,
					validateMaxAge = DateCollectionService.validateMaxAge,
					getLocale = Language.getLocale;

				/*
			 * Takes the modelValue (string) and formats it into an object for the viewValue to be rendered
			 */
				ngModelCtrl.$formatters.push(function (modelValue) {
					if (angular.isDefined(modelValue) && modelValue.length > 0) {
						return DateCollectionService.parseDateStringIntoObject(modelValue);
					} else {
						for (var i = 0; i < scope.dateModel.length; i++) {
							scope.dateModel[i].model = undefined;
						}
					}
				});

				/*
			 * Called after the formatter - will take the viewValue and apply it to scope.dateModel for the UI
			 */
				ngModelCtrl.$render = function () {
					var dateObject = ngModelCtrl.$viewValue;
					if (angular.isDefined(dateObject)) {
						var isValid = DateCollectionService.validateDateObject(dateObject);
						if (isValid) {
							// If we are coming in with an existing model and it is valid, ensure we set it as such
							if (scope.isRequired) {
								ngModelCtrl.$setValidity('required', true);
							}

							// Then populate the dateModel, but only necessary if valid
							for (var i = 0; i < scope.dateModel.length; i++) {
								if (scope.dateModel[i].name === 'month') {
									selectedMonth = dateObject.month;
									if (displayMonthAsNumber) {
										scope.dateModel[i].model = dateObject.month;
									} else {
										scope.dateModel[i].model = DateCollectionService.parseMonthNumberIntoWord(dateObject.month);
									}
								} else if (scope.dateModel[i].name === 'day') {
									scope.dateModel[i].model = dateObject.day;
									scope.dateModel[i].data = DateCollectionService.updateDayList(dateObject.year, dateObject.month);
								} else if (scope.dateModel[i].name === 'year') {
									selectedYear = dateObject.year;
									scope.dateModel[i].model = dateObject.year;
								}
							}

							if (scope.prepopulatedValidation) {
								scope.minMaxDateValidate(dateObject);
							}
							scope._validateVisitAge(dateObject);
						} else {
							ngModelCtrl.$setViewValue(undefined);
							if (scope.isRequired) {
								ngModelCtrl.$setValidity('required', false);
							}
						}
					} else if (scope.isRequired) {
						ngModelCtrl.$setValidity('required', false);
					}
				};

				/**
			 * Validate age by the visit date
			 * @function
			 * @protected
			 * @param {obj} dateObj - selected date object
			 * @return {undefined}
			 */
				function _validateVisitAge(dateObj) {
					var formattedDate;

					if (!validString(dateObj.month) || !validString(dateObj.day) || !validString(dateObj.year)) {
						return;
					}

					formattedDate = [dateObj.year, dateObj.month, dateObj.day].join('');

					if (scope._lastValidatedDate === formattedDate) {
						return;
					}

					if (angular.isFunction(scope.onValidatingAge)) {
						scope.onValidatingAge({ isLoading: true });
					}

					DateCollectionService.validateAge(scope.validateVisitAge, dateObj)
						.then(function onValidateAgeResolved(result) {
							if (result && result.skipped) {
								return;
							}
							ngModelCtrl.$setValidity('visitAgeNotMet', true);
							scope._lastValidatedDate = formattedDate;
						}).catch(function onValidateAgeRejected() {
							ngModelCtrl.$setValidity('visitAgeNotMet', false);
							scope._lastValidatedDate = formattedDate;
						}).finally(function onValidateAgeComplete() {
							if (angular.isFunction(scope.onValidatingAge)) {
								scope.onValidatingAge({ isLoading: false });
							}
						});
				}

				/**
			 * Validate min/max age when data is prepopulated
			 * @function
			 * @public
			 * @param {Object} dateObject - date object
			 * @return {undefined}
			 */
				function minMaxDateValidate(dateObject) {
					if (!validateMaxAge(dateObject)) {
						ngModelCtrl.$setValidity('maxAgeExceeded', false);
					} else if (!validateMinAge(dateObject)) {
						ngModelCtrl.$setValidity('minAgeNotMet', false);
					}
				}

				/*
			 * Upon a change in the UI, create a date object from scope.dateModel and apply it as the viewValue to be parsed
			 */
				scope.onChange = function (element) {
					var shouldValidate = true,
						shouldUpdateDayList = false,
						isValidMinDate = true,
						isValidMaxDate = true;

					/*
					First, create a dateObject from the dateModel.
					1) Conditionally get only the fields present
					2) For month, get the number representation even if the view representation is in the word format
					3) For day and year, limit to 2 and 4 characters respectively
				 */
					var dateObject = {};

					for (var i = 0; i < scope.dateModel.length; i++) {
						if (angular.isDefined(scope.dateModel[i].model)) {
							if (scope.dateModel[i].name === 'month') {
								if (scope.dateModel[i].model !== selectedMonth) {
									shouldUpdateDayList = true;
								}

								selectedMonth = scope.dateModel[i].model;

								if (displayMonthAsNumber) {
									dateObject.month = scope.dateModel[i].model;
								} else {
									dateObject.month = DateCollectionService.parseMonthWordIntoNumber(scope.dateModel[i].model);
								}
							} else if (scope.dateModel[i].name === 'day') {
								if (display === 'hybrid') {
									if (scope.dateModel[i].model.toString().length > 1) {
										scope.dateModel[i].model = DateCollectionService.parseDay(scope.dateModel[i].model);
									}
								}

								dateObject.day = scope.dateModel[i].model;

								if (angular.isUndefined(dateObject.day)) {
									shouldValidate = false;
								}
							} else if (scope.dateModel[i].name === 'year') {
								if (scope.dateModel[i].model !== selectedYear) {
									shouldUpdateDayList = true;
								}

								selectedYear = scope.dateModel[i].model;

								if (display === 'hybrid') {
									scope.dateModel[i].model = DateCollectionService.parseYear(scope.dateModel[i].model);
								}

								dateObject.year = scope.dateModel[i].model;

								if (angular.isUndefined(dateObject.year) || dateObject.year.length < 4) {
									shouldValidate = false;
								}
							}
						} else {
							shouldValidate = false;
							if (scope.isRequired) {
								ngModelCtrl.$setValidity('required', false);
							}
						}
					}

					if (shouldUpdateDayList) {
						for (var x = 0; x < scope.dateModel.length; x++) {
							if (scope.dateModel[x].name === 'day') {
								scope.dateModel[x].data = DateCollectionService.updateDayList(dateObject.year, dateObject.month);
							}
						}
					}

					if (shouldValidate) {
						/*
							Second, given a clean dateObject, validate that it is a valid date.
							At this point, I know that dateObject will contain "valid" data in each applicable field.
							But, we need to check that it is actually a valid date.
						 */
						var isValid = DateCollectionService.validateDateObject(dateObject);
						if (isValid) {
							isValidMinDate = validateMinAge(dateObject);
							isValidMaxDate = validateMaxAge(dateObject);

							if (isValidMinDate) {
								ngModelCtrl.$setValidity('minAgeNotMet', true);
							} else {
								Modal.displayModal({
									category: 'Date Collection',
									description: getLocale('DateCollection', 'minAgeNotMetDescription'),
									label: 'Date Collection',
									title: getLocale('DateCollection', 'minAgeNotMetTitle')
								});
							}

							ngModelCtrl.$setViewValue(dateObject);
							ngModelCtrl.$setValidity('required', true);
							if (DateCollectionService.shouldValidate()) {
								ngModelCtrl.$setValidity('maxAgeExceeded', true);
							}
						}
						if (!isValidMaxDate) {
							ngModelCtrl.$setValidity('maxAgeExceeded', false);
						}
						if (!isValid || !isValidMinDate) {
							element.$parent.field.model = undefined;
							ngModelCtrl.$setViewValue(undefined);
							if (scope.isRequired) {
								ngModelCtrl.$setValidity('required', false);
							}
						}
						scope._validateVisitAge(dateObject);
					} else {
						ngModelCtrl.$setViewValue(undefined);
						if (scope.isRequired) {
							ngModelCtrl.$setValidity('required', false);
						}
					}
				};

				/*
			 * Called after $setViewValue - will take the viewValue and apply it to the original model
			 */
				ngModelCtrl.$parsers.push(function (viewValue) {
					if (angular.isDefined(viewValue)) {
						return DateCollectionService.parseDateObjectIntoString(viewValue);
					}
				});
			}
		}
	});

(function() {
	'use strict';

	angular.module('ui-components', ['app']);
})();
(function() {
	'use strict';

	angular
		.module('ui-components')
		.component('email', {
			bindings: {
				email: '<',
				emailType: '<',
				emailVerified: '<',
				emailVerifying: '<',
				executeOnBlur: '&',
				form: '<',
				hasCustomBlurFn: '<',
				id: '<',
				isDisabled: '<',
				isRequired: '<',
				onEmailChange: '&',
				onEmailVerificationFailed: '&',
				onEmailVerificationSuccess: '&',
				onEmailVerifying: '&',
				options: '<',
				submitted: '<',
				triggerEmailVerification: '<'
			},
			controller: 'EmailComponentController',
			controllerAs: 'vm',
			templateUrl: '/scripts/modules/ui-components/components/email/email-component.html'
		});
}());
(function() {
	'use strict';

	angular
		.module('ui-components')
		.controller('EmailComponentController', EmailComponentController);

	/**
	 * Our component controller
	 * @public
	 * @constructor
	 * @param {Service} AppData AppData
	 * @param {Service} EmailService EmailService
	 * @param {Service} FormValidation FormValidation
	 * @param {Service} Language Language
	 * @param {Service} UtilsValidation UtilsValidation
	 * @param {Service} Utilities Utilities
	 * @returns {EmailComponentController} our instance
	 * @ngInject
	 */
	function EmailComponentController(AppData, EmailService, FormValidation, Language, UtilsValidation, Utilities) {
		var vm = this,
			lastCheckedEmail,
			validEmailRegex = FormValidation.getEmail(),
			isBoolean = UtilsValidation.isBoolean,
			validString = UtilsValidation.validString,
			isRealObject = UtilsValidation.isRealObject,
			checkProp = Utilities.safelyCheckPropertyOnObject,
			getBoolean = Utilities.getBoolean;

		/* Methods */
		vm.$onInit = $onInit;
		vm.$onChanges = $onChanges;
		vm.onBlur = onBlur;
		vm.onChange = onChange;
		vm.onSuccess = onSuccess;
		vm.verifyEmail = verifyEmail;
		vm.inputHasError = FormValidation.inputHasError;
		vm.inputShowError = FormValidation.inputShowError;
		vm.executeCustomBlurFunction = executeCustomBlurFunction;
		vm.setEmailValidationStatus = setEmailValidationStatus;
		vm.setEmailVerifyingStatus = setEmailVerifyingStatus;

		/**
		 * on Init function
		 * @public
		 * @function
		 * @returns {undefined}
		 */
		function $onInit() {
			vm.id = vm.id || 'email';
			vm.emailVerifying = vm.emailVerifying || false;
			vm.emailVerified = vm.emailVerified || false;
			vm.hasCustomBlurFn = getBoolean(vm.hasCustomBlurFn);
			if (checkProp('vm.options', vm, isRealObject)) {
				vm.options.cyEmail = vm.options.cyEmail || '';
				vm.options.cyEmailRequired = vm.options.cyEmailRequired || '';
				vm.options.cyEmailPattern = vm.options.cyEmailPattern || '';
			}
			if (validString(vm.email) && !vm.isDisabled) {
				vm.onBlur();
			}
		}

		/**
		 * Execues on Changes
		 * @function
		 * @public
		 * @param {Object} changes changes
		 * @returns {undefined}
		 */
		function $onChanges(changes) {
			['emailVerifying', 'emailVerified'].forEach(function(prop) {
				if (checkProp('changes.' + prop + '.currentValue', changes, isBoolean) && changes[prop].currentValue !== changes[prop].previousValue) {
					vm[prop] = changes[prop].currentValue;
				}
			});
			if (checkProp('changes.triggerEmailVerification.currentValue', changes, getBoolean)) {
				vm.onBlur();
			}
			//safe check when email type is text
			if (checkProp('changes.emailVerified.currentValue', changes, getBoolean) && !checkProp('changes.emailVerifying', changes, isRealObject)) {
				vm.emailVerifying = false;
			}
		}

		/**
		 * on Blur function
		 * @public
		 * @function
		 * @returns {undefined}
		 */
		function onBlur() {
			if (vm.options && vm.options.enableEmailVerification) {
				if (vm.email === lastCheckedEmail) {
					vm.setEmailValidationStatus(true, true);
					vm.onEmailVerificationSuccess();
					return;
				}

				vm.onEmailVerifying({ status: true });
				vm.verifyEmail();
				return;
			}
			vm.executeCustomBlurFunction();
		}

		/**
		 * Execute custom function passed in
		 * @function
		 * @public
		 * @returns {undefined}
		 */
		function executeCustomBlurFunction() {
			if (vm.hasCustomBlurFn) {
				vm.executeOnBlur();
			}
		}

		/**
		 * Set's email verified status
		 * @param {Boolean} status status
		 * @param {Boolean} hasOverride hasOverride
		 * @returns {undefined}
		 */
		function setEmailValidationStatus(status, hasOverride) {
			if (hasOverride || !vm.hasCustomBlurFn) {
				vm.emailVerified = getBoolean(status);
			}
		}

		/**
		 * Set's email verifying status
		 * @param {Boolean} status status
		 * @param {Boolean} hasOverride hasOverride
		 * @returns {undefined}
		 */
		function setEmailVerifyingStatus(status, hasOverride) {
			if (hasOverride || !vm.hasCustomBlurFn) {
				vm.emailVerifying = getBoolean(status);
			}
		}

		/**
		 * On email change
		 * @public
		 * @function
		 * @returns {undefined}
		 */
		function onChange() {
			vm.setEmailValidationStatus(false, true);
			vm.onEmailChange({ email: vm.email });
		}

		/**
		 * On Email verification Success
		 * @public
		 * @function
		 * @returns {undefined}
		 */
		function onSuccess() {
			vm.setEmailValidationStatus(true);
			vm.onEmailVerificationSuccess();
			vm.executeCustomBlurFunction();
		}

		/**
		 * Validate Email
		 * @public
		 * @function
		 * @returns {undefined}
		 */
		function verifyEmail() {
			if (!validEmailRegex.test(vm.email)) {
				vm.onEmailVerifying({ status: false });
				return;
			}

			vm.setEmailVerifyingStatus(true, true);
			if (getBoolean(AppData.settings.allow_no_email) && checkProp('Language.SeasonPass.noEmail', Language, validString) && vm.email.trim() === Language.SeasonPass.noEmail) {
				vm.setEmailVerifyingStatus(false);
				vm.onSuccess();
				return;
			}
			EmailService.verifyEmail(vm.email).then(function(valid) {
				vm.setEmailVerifyingStatus(false);
				if (valid) {
					vm.onSuccess();
					lastCheckedEmail = vm.email;
				} else {
					vm.setEmailValidationStatus(false, true);
					vm.onEmailVerificationFailed();
				}
			});
		}
	}
}());

(function() {
	'use strict';

	angular
		.module('ui-components')
		.component('phoneNumber', {
			bindings: {
				countryCode: '<',
				regionCode: '<',
				disable: '<',
				displayFlag: '@',
				errorConfig: '<',
				form: '<',
				hideAsterisk: '<?',
				hideLabel: '<',
				isRequired: '@',
				label: '<',
				localeSection: '@',
				model: '<',
				name: '@',
				onChange: '&',
				onCountryChange: '&',
				placeholder: '<',
				submitted: '<',
				useEnhancedPhone: '@'
			},
			controller: 'PhoneNumberComponentController',
			controllerAs: 'vm',
			templateUrl: 'scripts/modules/ui-components/components/phone-number/phone-number-component.html'
		});
})();

(function() {
	'use strict';

	angular
		.module('ui-components')
		.controller('PhoneNumberComponentController', PhoneNumberComponentController);

	/**
	* Our component constructor
	* @public
	* @constructor
	* @name PhoneNumberComponentController
	* @memberof {component.phone-number}
	* @param {Service} AppData AppData Service
	* @param {Service} CustomActionService CustomActionService Service
	* @param {Service} $rootScope $rootScope Service
	* @param {Service} PhoneNumberService Phone number service
	* @param {Service} Utilities Utilities Service
	* @param {Service} UtilsValidation UtilsValidation
	* @return {self} A new component instance
	* @ngInject
	*/
	function PhoneNumberComponentController(AppData, $window, $element, $rootScope, PhoneNumberService, Utilities, UtilsValidation) {
		var vm = this,
			copy = angular.copy,
			isObject = angular.isObject,
			getBoolean = Utilities.getBoolean,
			validString = UtilsValidation.validString;

		vm.$onInit = $onInit;
		vm.$onChanges = $onChanges;
		vm.toggleDropdown = toggleDropdown;
		vm.selectedCountry = selectedCountry;
		vm.checkDisplayError = checkDisplayError;
		vm.updatePhoneNumber = updatePhoneNumber;
		vm.initializeCountryCode = initializeCountryCode;
		vm.setDisplayDirection = setDisplayDirection;
		vm.validatePhoneNumber = validatePhoneNumber;

		/**
		 * Controller initilization code
		 * @public
		 * @returns {undefined}
		 */
		function $onInit() {
			vm.i18n = $rootScope.i18n;
			vm.toggle = false;
			vm.name = vm.name ? vm.name : 'phone';
			vm.disable = Utilities.getBoolean(vm.disable);
			vm.displayDirection = 1;
			vm.showFlag = checkConditions(vm.displayFlag, 'display_with_flags');
			vm.useEnhancedPhoneNumber = checkConditions(vm.useEnhancedPhone, 'use_enhanced_phone_number');
			vm.countries = copy(AppData.countries);
			PhoneNumberService.buildErrors(vm.errorConfig);
			vm.formErrors = PhoneNumberService.config.errors;
			vm.initializeCountryCode(vm.countryCode, vm.regionCode);
		}

		/**
		 * Listens to when we receive updated parameters.
		 * @public
		 * @param {Object} changes The changes object
		 * @returns {undefined}
		 */
		function $onChanges(changes) {
			var countryCode = Utilities.safelyCheckPropertyOnObject('changes.countryCode.currentValue', changes, validString) && vm.useEnhancedPhoneNumber ? changes.countryCode.currentValue : '',
				regionCode = Utilities.safelyCheckPropertyOnObject('changes.regionCode.currentValue', changes, validString) && vm.useEnhancedPhoneNumber ? changes.regionCode.currentValue : '';
			if (countryCode !== '' || regionCode !== '') {
				vm.initializeCountryCode(countryCode, regionCode);
			}
		}

		/**
		 * Initialize the country code
		 * @param {String} countryCode The country code to initialize
		 * @param {String} regionCode The region code to initialize
		 * @returns {undefined}
		 */
		function initializeCountryCode(countryCode, regionCode) {
			var countryCodeFound = false,
				countryIndex,
				countryToPrePopulate;

			if (!UtilsValidation.validArray(vm.countries)) {
				return;
			}

			if (validString(countryCode) || validString(regionCode)) {
				countryIndex = vm.countries.findIndex(function(currentCountry) {
					var match = false;
					if (validString(countryCode)) {
						if (currentCountry.countryCode === countryCode) {
							if (validString(regionCode)) {
								match = currentCountry.code === regionCode;
							} else {
								match = true;
							}
						}
					} else if (validString(regionCode)) {
						match = currentCountry.code === regionCode;
					}
					return match;
				});

				if (countryIndex > -1) {
					countryToPrePopulate = vm.countries[countryIndex];
					vm.countrySelected = {
						countryCode: countryToPrePopulate.countryCode,
						regionCode: countryToPrePopulate.code
					};
					countryCodeFound = true;
				}
			}

			if (!countryCodeFound) {
				vm.countrySelected = {
					countryCode: AppData.countries[0].countryCode,
					regionCode: AppData.countries[0].code
				};
				PhoneNumberService.setCountryCode(AppData.countries[0].countryCode);
				PhoneNumberService.setRegionCode(AppData.countries[0].code);
				vm.updatePhoneNumber();
			}
		}

		/**
		 * Check's whether or not to use enhanced phone number/ display flags
		 * @protected
		 * @param {String} componentInput input passed to component
		 * @param {String} appConfigAttribute attribute in enhanced_phone_number app config
		 * @returns {Boolean} true/false
		 */
		function checkConditions(componentInput, appConfigAttribute) {
			var enhancedPhoneNumberConfig = AppData.settings.enhanced_phone_number && JSON.parse(AppData.settings.enhanced_phone_number) || {},
				attribute = enhancedPhoneNumberConfig[appConfigAttribute];
			if (componentInput) {
				return getBoolean(componentInput);
			} else if (enhancedPhoneNumberConfig) {
				if (attribute) {
					return getBoolean(attribute);
				}
			}
			return false;
		}

		/**
		 * Toggle country list drop down
		 * @public
		 * @param {Boolean} enable Will be true if ng-click. False if ng-mouseleave
		 * @returns {undefined}
		 */
		function toggleDropdown(enable) {
			if (!vm.disable && enable && !vm.toggle) {
				vm.setDisplayDirection();
				vm.toggle = true;
			} else {
				vm.toggle = false;
			}
		}

		/**
		 * Update model on change
		 * @public
		 * @returns {undefined}
		 */
		function updatePhoneNumber() {
			PhoneNumberService.setPhoneNumber(vm.model);
			vm.onChange({
				countryCode: vm.useEnhancedPhoneNumber ? vm.countrySelected.countryCode : '',
				phoneNumber: vm.model,
				regionCode: vm.useEnhancedPhoneNumber ? vm.countrySelected.regionCode : '',
				phoneType: vm.phoneType || ''
			});
			validatePhoneNumber();
		}

		/**
		 * Set country code and rearrange country list based on selection
		 * @public
		 * @param {Object} country country object with countryCode and code
		 * @param {Boolean} [skipValidation] flag to skip validate
		 * @returns {undefined}
		 */
		function selectedCountry(country, skipValidation) {
			var countryIndex;
			if (!isObject(country)) {
				return;
			}

			vm.countries = copy(AppData.countries);
			vm.countrySelected = {
				regionCode: country.code,
				countryCode: country.countryCode
			};
			PhoneNumberService.setCountryCode(country.countryCode);
			PhoneNumberService.setRegionCode(country.code);
			countryIndex = vm.countries.findIndex(function(currentCountry) {
				return currentCountry.code === country.code;
			});
			if (countryIndex < 0) {
				return;
			}
			vm.countries.splice(countryIndex, 1);
			vm.countries.unshift(country);
			if (vm.onCountryChange) {
				vm.onCountryChange({
					countryCode: country.countryCode,
					regionCode: country.code
				});
			}
			if (!skipValidation) {
				vm.validatePhoneNumber();
			}
		}

		/**
		 * Check to determine whether or not to display error
		 * @public
		 * @param {String} key error key
		 * @returns {Boolean} true/false
		 */
		function checkDisplayError(key) {
			var phoneRequired = vm.form[vm.name].$error.required;
			return (key === 'required' && phoneRequired) || (vm.form[vm.name].$error[key] && !phoneRequired);
		}

		/**
		 * Sets the displayDirection so the dropdown can display above or below the input based upon the position in the window
		 * @public
		 * @returns {undefined}
		 */
		function setDisplayDirection() {
			var eleInfo = $element[0].getBoundingClientRect();
			var hasLowerRoom = eleInfo.y + eleInfo.height + 240 < $window.innerHeight;
			var hasUpperRoom = eleInfo.y > 240;

			vm.displayDirection = hasUpperRoom && !hasLowerRoom ? -1 : 1;
		}

		/**
		 * Validates the phone number
		 * @public
		 * @function
		 * @name validatePhoneNumber
		 * @returns {undefined}
		 */
		function validatePhoneNumber() {
			var phoneComp = isObject(vm.form) ? vm.form[vm.name] : null,
				currentPhone;
			if (!isObject(phoneComp) || (!vm.useEnhancedPhoneNumber)) {
				return;
			}
			// reset errors that are based on the validation service
			phoneComp.$setValidity('invalidPhoneNumber', true);
			// only call the service if is enhanced phone number field and the length is greater than 3
			if (validString(vm.model) && vm.model.length > 3) {
				currentPhone = vm.model;
				PhoneNumberService.validatePhoneNumber(vm.countrySelected.countryCode, vm.model).then(
					function handleValidateReturn(phoneValidation) {
						phoneComp.$setValidity('invalidPhoneNumber', phoneValidation.valid);
						/// use the validated regionCode to set the correct code in the drop down
						if (phoneValidation.valid && !phoneValidation.errorCode) {
							if (vm.countrySelected.regionCode !== phoneValidation.regionCode) {
								vm.selectedCountry({
									code: phoneValidation.regionCode,
									countryCode: phoneValidation.countryCode
								}, true);
							}
							// If the returned phone number doesn't match the model
							// then we have a situation where the country code was entered in the number
							// and the BE stripped it out, so we need to update the model with the stripped one
							if (currentPhone === vm.model && phoneValidation.phoneNumber !== vm.model) {
								vm.model = phoneValidation.phoneNumber;
								vm.onChange({
									countryCode: vm.useEnhancedPhoneNumber ? vm.countrySelected.countryCode : '',
									phoneNumber: vm.model,
									regionCode: vm.useEnhancedPhoneNumber ? vm.countrySelected.regionCode : ''
								});
							}
						}
					}
				);
			}
		}
	}
}());

(function() {
	'use strict';
	angular
		.module('ui-components')
		.factory('EmailService', EmailService);

	/**
	 * Email service
	 * @param {Service} AppData AppData Service
	 * @param {Service} Enums Enums Service
	 * @param {Service} Utilities Utilities
	 * @param {Service} $q $q
	 * @returns {Service} Email Service
	 * @ngInject
	 */
	function EmailService(AppData, Enums, Utilities, $q) {
		var getBoolean = Utilities.getBoolean,
			verifiedEmails = [];
		return { verifyEmail: verifyEmail };

		/**
		 * Validate Email
		 * @function
		 * @public
		 * @param {String} emailAddress email to be validated
		 * @returns {Promise} promise
		 */
		function verifyEmail(emailAddress) {
			var reqObj,
				validEmail;
			if (verifiedEmails.indexOf(emailAddress) !== -1) {
				return $q.resolve(true);
			}
			/* eslint-disable camelcase */
			reqObj = {
				email: emailAddress,
				merchant_id: AppData.GetMerchantDetails.merchant_id,
				session_id: AppData.cart.session_id
			};
			/* eslint-disable camelcase */
			verifiedEmails.push(emailAddress);
			return AppData.fetch(Enums.services.VERIFY_EMAIL, false, reqObj).then(function(response) {
				if (response.status === Enums.status.OK) {
					validEmail = getBoolean(response.valid_email)
					if (!validEmail) {
						verifiedEmails.pop();
					}
					return validEmail;
				}
				return response.status !== Enums.status.OK;
			});
		}
	}
})();

(function() {
	'use strict';
	angular
		.module('ui-components')
		.factory('PhoneNumberService', PhoneNumberService);

	/**
	 * Phone Number service
	 * @param {Service} $q $q service
	 * @param {Service} JSONValidator JSONValdator Service
	 * @param {Service} UtilsValidation UtilsValidation Service
	 * @param {Service} Utilities Utilities Service
	 * @param {Service} AppData AppData Service
	 * @param {Service} UserInfo UserInfo service
	 * @returns {Service} Phone Number Service
	 * @ngInject
	 */
	function PhoneNumberService($q, JSONValidator, UtilsValidation, Utilities, AppData, UserInfo) {
		var checkProp = Utilities.checkProp,
			isObject = angular.isObject,
			getBoolean = Utilities.getBoolean,
			currentBilling = UserInfo.billing || {};
		var service = {
			buildErrors: buildErrors,
			config: {},
			countryCode: currentBilling.countryCode || '',
			regionCode: currentBilling.regionCode || '',
			getCountryCode: getCountryCode,
			getRegionCode: getRegionCode,
			getEnhancedPhoneConfig: getEnhancedPhoneConfig,
			getPhoneNumber: getPhoneNumber,
			phoneNumber: currentBilling.phone || '',
			setCountryCode: setCountryCode,
			setPhoneNumber: setPhoneNumber,
			setRegionCode: setRegionCode,
			useEnhancedPhoneNumber: useEnhancedPhoneNumber,
			validatePhoneNumber: validatePhoneNumber
		};

		return service;

		/**
		 * Build errors
		 * @public
		 * @param {Object} errorConfig error config
		 * @returns {undefined}
		 */
		function buildErrors(errorConfig) {
			var defaults = {
				errors: {
					invalidPhoneNumber: 'phoneNumberInvalid',
					minlength: 'phoneMinLengthError',
					pattern: 'phonePatternError',
					required: 'phoneRequiredError'
				},
				section: 'FormValidation'
			};
			if (isObject(errorConfig)) {
				if (UtilsValidation.validString(errorConfig.section)) {
					defaults.section = errorConfig.section;
				}

				if (isObject(errorConfig.errors)) {
					defaults.errors = {};
					angular.forEach(errorConfig.errors, function(value, key) {
						defaults.errors[key] = value;
					});
				}
			}
			service.config.errors = defaults;
		}

		/**
		 * Set Country code
		 * @public
		 * @param {String} cc cc
		 * @returns {undefined}
		 */
		function setCountryCode(cc) {
			service.countryCode = cc || '';
		}

		/**
		 * get Country code
		 * @public
		 * @returns {String} country code
		 */
		function getCountryCode() {
			return service.countryCode;
		}

		/**
		 * Set Region code
		 * @public
		 * @param {String} rc rc
		 * @returns {undefined}
		 */
		function setRegionCode(rc) {
			service.regionCode = Utilities.getString(rc);
		}

		/**
		 * get Region code
		 * @public
		 * @returns {String} region code
		 */
		function getRegionCode() {
			return service.regionCode;
		}

		/**
		 * Set Phone Number
		 * @public
		 * @param {String} phone cc
		 * @returns {undefined}
		 */
		function setPhoneNumber(phone) {
			service.phoneNumber = phone || '';
		}

		/**
		 * get Phone Number
		 * @public
		 * @returns {String} Phone Number
		 */
		function getPhoneNumber() {
			return service.phoneNumber;
		}

		/**
		 * Determine whether or not to use enhanced phone number
		 * @public
		 * @param {Boolean} isAppConfig whether  or not the passed value is a app config
		 * @param {Boolean/String} value value to be checked
		 * @returns {Boolean} true/ false
		 */
		function useEnhancedPhoneNumber(isAppConfig, value) {
			var enhancedPhoneNumberConfig;
			if (!isAppConfig) {
				return getBoolean(value);
			}
			enhancedPhoneNumberConfig = service.getEnhancedPhoneConfig();
			return angular.isObject(enhancedPhoneNumberConfig) ? getBoolean(enhancedPhoneNumberConfig.use_enhanced_phone_number) : false;
		}

		/**
		 * Grabs the enhanced_phone_number app config
		 * @public
		 * @function
		 * @returns {Object} The enhanced_phone_number app config if set, blank object otherwise
		 */
		function getEnhancedPhoneConfig() {
			var setting = AppData.settings.enhanced_phone_number;

			return JSONValidator.validate('enhanced_phone_number', setting)
				? JSON.parse(setting)
				: {};
		}

		/**
		 * Validates the phone number and country code
		 * @public
		 * @function
		 * @name validatePhoneNumber
		 * @param {String} [countryCode] current country code
		 * @param {String} [phoneNumber] current phone number
		 * @returns {Object} response object {valid:true/false, errorMsg:string}
		 */
		function validatePhoneNumber(countryCode, phoneNumber) {
			/* eslint-disable camelcase,sort-keys */
			var request = {
				country_code: countryCode,
				number: phoneNumber
			};

			return new $q(function(resolve) {
				AppData
					.fetch('PhoneNumberValidation', false, request)
					.then(function handleValidationServiceSuccess(data) {
						if (data.status === 'OK') {
							resolve({
								valid: true,
								regionCode: data.region_code,
								countryCode: '+' + data.country_code,
								phoneNumber: data.number
							});
						} else {
							if (['17', '95'].includes(data.error_code)) {
								resolve({
									valid: false,
									errorCode: data.error_code
								});
							} else {
								resolve({
									valid: true,
									errorCode: UtilsValidation.validString(data.error_code) ? data.error_code : '0'
								});
							}
						}
					}).catch(function handleValidationServiceFailure(data) {
						resolve({
							valid: false,
							errorMsg: data.error_code
						});
					});
			});
		}
	}
})();
!function(){"use strict";function t(t){function i(t,i,e){var n=t.defer();if(!e)return n.resolve(null),n.promise;var o=new Image,r=i(function(){n.resolve(null)},5e3);return o.onload=function(){i.cancel(r),n.resolve(e)},o.onerror=function(){i.cancel(r),n.resolve(null)},o.src=e,n.promise}function e(t,e,n){return e.all(t.info.carouselImages.map(function(t){return i(e,n,t)})).then(function(t){return t.filter(Boolean)})}function n(t,e,n){return i(e,n,t.info.infographic)}function o(t,e,n){return i(e,n,t.info.desktopBanner)}function r(t,e,n){return i(e,n,t.info.confirmationBanner)}function a(t,e,n){return i(e,n,t.info.logo)}function f(t,e,n){return i(e,n,t.info.removeBanner)}function c(t,i,e,n){return!(!t.flag.hasGiftAid||!i)||n.reroute(e.routes.CART_VIEW)}e.$inject=["config","$q","$timeout"],n.$inject=["config","$q","$timeout"],o.$inject=["config","$q","$timeout"],r.$inject=["config","$q","$timeout"],a.$inject=["config","$q","$timeout"],f.$inject=["config","$q","$timeout"],c.$inject=["config","type","Enums","RouteRejectionService"],t.state("gift-aid",{url:"/gift-aid",abstract:!0,resolve:{bootstrap:["Bootstrap",function(t){return t.bootstrapApplication()}],loadAssets:["bootstrap","BundleService",function(t,i){return i.lazyLoadCollectionFiles(i.enums.GIFT_AID)}],config:["loadAssets","GiftAidService",function(t,i){return i.getConfig()}],type:["config","GiftAidService",function(t,i){return i.getType()}]}}).state("gift-aid.confirm",{url:"/confirm",templateUrl:"gift-aid:confirm",controller:"GiftAidConfirmController",title:"Gift Aid - Confirm",resolve:{routeGuard:c,confirmationBanner:r,logo:a}}).state("gift-aid.remove",{url:"/remove",templateUrl:"gift-aid:remove",controller:"GiftAidRemoveController",title:"Gift Aid - Remove",resolve:{routeGuard:c,removeBanner:f}}).state("gift-aid.selection",{url:"",templateUrl:"gift-aid:selection",controller:"GiftAidSelectionController",title:"Gift Aid - Donate",resolve:{routeGuard:c,carouselImages:e,desktopBanner:o,infographic:n}})}t.$inject=["$stateProvider"],angular.module("gift-aid",["app","utilities"]).config(t)}(),function(){"use strict";function t(t,i){i.addWhitelistParam(t.abTest.CONFIRMATION_PARAM)}function i(t,i,e,n,o,r,a,f){var c=f.checkProp,l={hasGiftAid:function(t){var i=[r.type.EXCLUSIVE,r.type.INCLUSIVE];if(!l.flags.enabled||n.getCartCharacs(r.charac.OPT_IN_TYPE))return!1;arguments.length&&(i=t?[r.type.EXCLUSIVE]:[r.type.INCLUSIVE]);return n.getCartItems().some(function(t){return t.flags.hasGiftAid&&i.includes(t.info.giftAidType)})},flags:{enabled:!1},_:{config:{},initialize:function(){l._.setConfig()},setConfig:function(){if(a.validate("gift_aid",e.settings.gift_aid))try{l._.config=JSON.parse(e.settings.gift_aid),l.flags.enabled=c("config.disabled",l._.config)&&!l._.config.disabled}catch(t){}}}};return e.applicationInitialized?l._.initialize():i.$on(o.services.APP_INIT,l._.initialize),l}t.$inject=["GiftAidEnums","UiRouterOverrideService"],i.$inject=["$log","$rootScope","AppData","CartService","Enums","GiftAidEnums","JSONValidator","Utilities"],angular.module("gift-aid").constant("GiftAidEnums",{abTest:{CONFIRMATION_PARAM:"gift_aid_extended"},charac:{OPT_IN_TYPE:"gift_aid_opt_in_type"},route:{REMOVE:"gift-aid.remove",CONFIRM:"gift-aid.confirm",SELECTION:"gift-aid.selection"},type:{EXCLUSIVE:"2",INCLUSIVE:"1",MIXED:Symbol()},opt:{REMOVE:"3",DONATION:"2",GIFT_AID:"1"}}).run(t).factory("GiftAidService",i)}();
(function() {
	'use strict';

	var ASSETS_PATH = '/scripts/modules/recaptcha';

	angular
		.module('recaptcha', ['app'])
		.constant('RECAPTCHA_ASSETS', [
			ASSETS_PATH + '/services/recaptcha-service.js',
			ASSETS_PATH + '/component/recaptcha-component.css',
			ASSETS_PATH + '/component/recaptcha-component.js',
			ASSETS_PATH + '/component/recaptcha-component-controller.js'
		]);
})();
(function() {
	'use strict';

	angular
		.module('recaptcha')
		.service('RecaptchaV3Service', RecaptchaV3Service);

	/**
	 * Our service constructor
	 * @constructor
	 * @param {Service} $q $q
	 * @param {Scope} $rootScope $rootScope
	 * @param {Scope} $window $window
	 * @param {Service} AppData AppData
	 * @param {Object} Enums Enums
	 * @param {Service} JSONValidator JSONValidator
	 * @param {Service} Utilities Utilities
	 * @param {Service} UtilsValidation UtilsValidation
	 * @ngInject
	 */
	function RecaptchaV3Service($q, $rootScope, $window, AppData, Enums, JSONValidator, Utilities, UtilsValidation) {
		var removeAppActivated;
		var service = this;

		angular.merge(service, {
			ACTION: {
				PURCHASE: 'purchase',
				SENDSMSCODE: 'sms',
				VERIFY_3DS: '3ds'
			},
			_: {
				accessoPayEnabled: false,
				assetsLoaded: false,
				config: {},
				initialize: _initialize
			},
			enabled: enabled,
			execute: execute,
			loadAssets: loadAssets
		});

		if (AppData.applicationActivated) {
			service._.initialize();
		} else {
			removeAppActivated = $rootScope.$on(Enums.services.APP_ACTIVATED, service._.initialize);
		}

		/**
		 * Initializes the service
		 * @protected
		 * @returns {undefined}
		 */
		function _initialize() {
			var recaptchaV3 = AppData.settings.recaptchav3,
				accessoPay = AppData.settings.accessoPay;

			if (removeAppActivated) {
				removeAppActivated();
				removeAppActivated = null;
			}

			if (recaptchaV3 && JSONValidator.validate('recaptchav3', recaptchaV3)) {
				service._.config = JSON.parse(recaptchaV3);
			}

			if (accessoPay && JSONValidator.validate('accesso_pay', accessoPay)) {
				service._.accessoPayEnabled = JSON.parse(accessoPay).enabled;
			}
		}

		/**
		 * Find out if the service is enabled
		 * @returns {Boolean} If its enabled or not
		 */
		function enabled() {
			return !!service._.config.enabled && UtilsValidation.validString(service._.config.key);
		}

		/**
		 * Loads the google assets
		 * @returns {Promise} To resolve the google recaptcha script
		 */
		function loadAssets() {
			var googleApiPath;

			if (service._.assetsLoaded || !service.enabled()) {
				return $q.resolve();
			}

			$rootScope.recaptchaV3Enabled = true;

			service._.assetsLoaded = true;

			googleApiPath = 'https://recaptcha.net/recaptcha/api.js?render=' + service._.config.key;

			return Utilities.addScriptToDocument(googleApiPath, 'g-recaptcha', undefined, 1, undefined, {
				asPromise: true,
				disableReinsert: true
			}).catch(function onFailedToLoad() {
				service._.assetsLoaded = false;
			});
		}

		/**
		 * Executes the reCaptcha tool to request a token from google
		 * @param {String} action The action being taken. E.g. 'login', or 'purchase'
		 * @param {Boolean} shouldIgnore If we should ignore making a recaptcha request
		 * @returns {Promise<token>} If we successfully complete a captcha, we will pass the token. If not, we do not pass anything to the resolve.
		 */
		function execute(action, shouldIgnore) {
			var deferred = $q.defer(),
				recaptcha;

			if (!shouldIgnore) {
				// If this is a 3ds verification or a purchase action and accesso pay is enabled, we need to bypass and not do recaptcha as it was done in accesso Pay
				shouldIgnore = [service.ACTION.VERIFY_3DS, service.ACTION.PURCHASE].includes(action) && service._.accessoPayEnabled;
			}

			if (shouldIgnore || !service.enabled() || !service._.assetsLoaded || !$window.grecaptcha) {
				deferred.resolve();
			} else {
				recaptcha = service._.config.enterprise ? $window.grecaptcha.enterprise : $window.grecaptcha;
				recaptcha.ready(function onRecaptchaReady() {
					recaptcha
						.execute(service._.config.key, { action: action })
						.then(function onRecaptchaToken(token) {
							deferred.resolve(token);
						});
				});
			}

			return deferred.promise;
		}
	}
}());
(function() {
	'use strict';
	angular.module('dynamic-toolbar-overrides', []);
})();
(function() {
	'use strict';
	angular
		.module('dynamic-toolbar-overrides')
		.factory('DynamicToolbarOverridesService', DynamicToolbarOverridesService);

	/**
	 * DynamicToolbarOverridesService
	 * @param {Service} $state $state
	 * @param {Service} $location $location
	 * @param {Service} JSONValidator JSONValidator
	 * @param {Service} Utilities Utilities
	 * @returns {undefined}
	 * @ngInject
	 */
	function DynamicToolbarOverridesService($state, $location, JSONValidator, Utilities) {
		var overrides = [];
		// public variable exposed to the outside
		var factory = {
			getToolbarOverride: getToolbarOverride,
			isToolbarMenuItemActiveGivenState: isToolbarMenuItemActiveGivenState,
			setupDynamicToolbarOverrides: setupDynamicToolbarOverrides
		}

		/**
		 * Setup the dynamic toolbar override list from our app config settings
		 * @param {Object} settings settings
		 * @returns {undefined}
		 */
		function setupDynamicToolbarOverrides(settings) {
			if (angular.isDefined(settings) && JSONValidator.validate('dynamic_toolbar_overrides', settings.dynamic_toolbar_overrides)) {
				overrides = JSON.parse(settings.dynamic_toolbar_overrides);
			}
		}

		/**
		 * Get the toolbar override for a launch state/url param
		 * Can only have one override for a state so we will return the first filter entry
		 * @public
		 * @param {string} stateName - state name
		 * @returns {boolean} override toolbar or not
		 */
		function getToolbarOverride(stateName) {
			var urlParams = $location.search(),
				overrideFound;
			overrideFound = overrides.find(function findOverride(override) {
				if (Utilities.getBoolean(urlParams[override.url_param])) {
					return true;
				}

				return override.states && override.states.indexOf(stateName) !== -1;
			});

			if (Utilities.getBoolean(urlParams['acsop_v5_pmt']) && Utilities.safelyCheckPropertyOnObject('$state.current.name', $state, 'validString') && $state.current.name.indexOf('accesso-pay') > -1) {
				return {
					hide_faq_icon: true,
					hide_cart_icon: true
				};
			}

			return overrideFound;
		}

		/**
		 * Get the active toolbar menu item given a state
		 * @param {String} stateName state name
		 * @param {Object} toolbarMenuItem toolbarMenuItem
		 * @returns {Boolean} true if toolbar item is active for state
		 */
		function isToolbarMenuItemActiveGivenState(stateName, toolbarMenuItem) {
			return toolbarMenuItem.route_state_on_click === stateName || Utilities.isValidChildStateOfParent(toolbarMenuItem.route_state_on_click, stateName);
		}

		return factory;
	}
})();
(function() {
	"use strict";
	angular
		.module('dynamic-toolbar-overrides')
		.directive('toolbarOverride', function($rootScope, $state, DynamicToolbarOverridesService, BookingPortalSessionService) {
			return {
				templateUrl: '/scripts/modules/dynamic-toolbar-overrides/directives/toolbar-override.html',
				restrict: 'E',
				link: function(scope, element, attrs, controller) {
					var activeToolbarItem = undefined;

					/**
					 * Return whether or not the item is active
					 * @param {Object} toolbarItem toolbar item
					 * @returns {Boolean} if items is active
					 */
					scope.isItemActive = function(toolbarItem) {
						return activeToolbarItem === toolbarItem || DynamicToolbarOverridesService.isToolbarMenuItemActiveGivenState($state.current.name, toolbarItem);
					};

					/**
					 * Set the active toolbar item
					 * @param {Object} toolbarItem toolbar item
					 * @returns {undefined}
					 */
					scope.onClick = function(toolbarItem) {
						if (!DynamicToolbarOverridesService.isToolbarMenuItemActiveGivenState($state.current.name, toolbarItem)) {
							activeToolbarItem = toolbarItem;
							$rootScope.routeTo($state.href(toolbarItem.route_state_on_click, {}));
						}
					};

					/**
					 * Logout for Booking Portal Implementation
					 * @returns {undefined}
					 */
					scope.bpLogout = function() {
						BookingPortalSessionService.logout();
					};

					// Session Tracking for Booking Portal Login
					scope.$on('user:bploggedin', function() {
						scope.sessionActiveBP = true;
					});

					scope.$on('user:bploggedout', function() {
						scope.sessionActiveBP = false;
					});
				}
			};
		});
})();
(function() {
	'use strict';
	angular.module('gender-input', []);
})();
(function(){

	/**
	 * Created by Michael Yuen 03/24/16
	 */
	'use strict';
	angular
		.module( 'gender-input' )
		.directive( 'genderInput', genderInput );

	function genderInput( Language, Utilities, $rootScope ){

		return {
			restrict: 'E',
			require: [ 'ngModel', '?^autofill' ],
			templateUrl: '/scripts/modules/gender-input/views/gender-input.html',
			scope: {
				"submitted": "=",
				"disabled": "="
			},
			link: function( scope, elm, attrs, ctrls ){

				scope.labels = {
					male:   Language.getLocale( 'FormLabels', 'male' ),
					female: Language.getLocale( 'FormLabels', 'female' ),
					error:  Language.getLocale( 'FormValidation', 'genderRequiredError')
				};

				ctrls[0].$formatters.push( setAndReturn );
				ctrls[0].$formatters.push( initialize );

				scope.setSelection = function( value ){

					ctrls[0].$setViewValue( value );
				};

				scope.contrastOn = function() {
					return $rootScope.contrastRatioToggle === 'on';
				};

				ctrls[0].$parsers.push( setAndReturn );

				function initialize( value ){

					if( Utilities.isEmpty( value ) && !Utilities.isEmpty( ctrls[1] ) ){

						// Communicate with Autofill directive
						value = ctrls[1].get( attrs.name );
					}

					return value;
				};

				function setAndReturn( value ){

					scope.model = value;
					return value;
				};
			}
		}
	};
})();
angular.module('activations', [
	'errorTracking', 'app'
]).config(function( $stateProvider ){

	$stateProvider
		.state('/activations', {
			url: '/activations',
			templateUrl: '/scripts/modules/extraflow/activations/views/activations.html',
			controller: 'ActivationsController',
			resolve: {
				initialData: function( Bootstrap ){
					return Bootstrap.bootstrapApplication();
				},
				loadAssets: loadAssets
			}
		})
		.state('/activations/:keyword', {
			url: '/activations/:keyword',
			templateUrl: '/scripts/modules/extraflow/activations/views/activations.html',
			controller: 'ActivationsController',
			resolve: {
				initialData: function( Bootstrap ){
					return Bootstrap.bootstrapApplication();
				},
				loadAssets: loadAssets
			}
		});

	/**
	 * Loads the standard assets for all routes
	 * @param {Service} Utilities Utilities
	 * @returns {Promise<void>} A promise to load the assets
	 */
	function loadAssets(Utilities) {
		return Utilities.cacheBustAndLazyLoad([
			'scripts/modules/extraflow/activations/controllers/activations-controller.js',
			'scripts/modules/extraflow/activations/services/activations-service.js'
		]);
	}
}).run(function( ExtraFlow, Enums ){

	ExtraFlow.registerXMC(
		'ActivateModule'
		, { name: 'ActivateModule'
			, view: Enums.extraFlowRoutes.ACTIVATE
			//, doEditMode: false
			//, writeSingleCharac: false
			, enabled: true
			, type: 'alternateFlowModule'
			//, characsList: [ 'start_date', 'event_id' ]
		});
});

/**
 * Created by dsmith on 12/15/2014.
 */
angular.module( 'birthdays'
	, [ 'app' ])
	.config( function( $stateProvider ) {

		$stateProvider
			.state('birthday-info'
				, { url: '/birthday-info/:packageId'
				, templateUrl: '/scripts/modules/extraflow/birthdays/views/info.html'
				, controller: 'BirthdaysInfoController'
				, resolve: {

					initialData: initialData,
					loadAssets: loadAssets,
					xfcMap: xfcMap

				}
			})
			.state('birthday-group-addon', {
				url: '/birthday-group-addon/:packageId',
				controller: 'BirthdaysAddonController',
				templateUrl: '/scripts/modules/extraflow/birthdays/views/addon.html',
				resolve: {
					//resolve failures are handled within run.js of main app
					initialData: initialData,
					loadAssets: loadAssets,
					xfcMap: xfcMap,
					availableAddons : function(xfcMap, BirthdaysAddonService, $transition$){
						return BirthdaysAddonService.findAvailableAddonPackages($transition$.params().packageId, 'per group', 'birthdaygroupaddon');

					}

				}
			})
			.state('birthday-guest-addon', {
				url: '/birthday-guest-addon/:packageId',
				controller: 'BirthdaysAddonController',
				templateUrl: '/scripts/modules/extraflow/birthdays/views/addon.html',
				resolve: {
					initialData: initialData,
					loadAssets: loadAssets,
					xfcMap: xfcMap,
					availableAddons : function(xfcMap, BirthdaysAddonService, $transition$){
						return BirthdaysAddonService.findAvailableAddonPackages($transition$.params().packageId, 'per person', 'birthdayguestaddon');

					}

				}
			})
			.state('birthday-addon', {
				url: '/birthday-addon/:packageId',
				controller: 'BirthdaysAddonController',
				templateUrl: '/scripts/modules/extraflow/birthdays/views/addon-withqty.html',
				resolve: {
					//resolve failures are handled within run.js of main app
					initialData: initialData,
					loadAssets: loadAssets,
					xfcMap: xfcMap,
					availableAddons : function(xfcMap, BirthdaysAddonService, $transition$){
						return BirthdaysAddonService.findAvailableAddonPackages($transition$.params().packageId, 'variable', 'birthdayaddon');

					}

				}
			});

		/**
		 * Our initial data
		 * @param {Service} Bootstrap Bootstrap
		 * @returns {Promise} to bootstrap the app
		 * @ngInject
		 */
		function initialData(Bootstrap) {
			return Bootstrap.bootstrapApplication();
		}

		/**
		 * Loads all the assets
		 * @param {Promise} initialData The initial data
		 * @param {Service} Utilities Utilities
		 * @ngInject
		 */
		function loadAssets(Utilities) {
			return Utilities.cacheBustAndLazyLoad([
				'scripts/modules/extraflow/birthdays/birthdays-models.js',
				'scripts/modules/extraflow/birthdays/controllers/birthdays-info-controller.js',
				'scripts/modules/extraflow/birthdays/controllers/birthdays-addon-controller.js',
				'scripts/modules/extraflow/birthdays/services/birthdays-addon-service.js'
			]);
		}

		/**
		 * Builds the XFC map
		 * @param {Service} initialData Our promise
		 * @param {Service} loadAssets Our promise
		 * @param {Service} Package Package
		 * @returns {Promise} to build the XFC map
		 * @ngInject
		 */
		function xfcMap(initialData, loadAssets, Package) {
			return Package.buildXFCMap();
		}
	})
	.run( function( ExtraFlow ) {

		ExtraFlow.registerXMC(
			'birthdayinfo'
			, { name: 'birthdayinfo'
				, view: 'birthday-info'
				, doEditMode: false
				, enabled: true
				, type: 'extraFlowControl'
			});
			ExtraFlow.registerXMC(
				'birthdaygroupaddon'
				, { name: 'birthdaygroupaddon'
					, view: 'birthday-group-addon'
					, doEditMode: false
					, enabled: true
					, lockQuantity: true
					, type: 'extraFlowControl'
				});
		ExtraFlow.registerXMC(
			'birthdayguestaddon'
			, { name: 'birthdayguestaddon'
				, view: 'birthday-guest-addon'
				, doEditMode: false
				, enabled: true
				, lockQuantity: true
				, type: 'extraFlowControl'
			});
		ExtraFlow.registerXMC(
			'birthdayaddon'
			, { name: 'birthdayaddon'
				, view: 'birthday-addon'
				, doEditMode: false
				, enabled: true
				, type: 'extraFlowControl'
			});

	});

angular.module('comp-assignment', [
	'errorTracking', 'app'
]).config(function( $stateProvider ){

	$stateProvider
		.state('/compAssignment/:packageId', {
			url: '/compAssignment/:packageId',
			templateUrl: '/scripts/modules/extraflow/comp-assignment/views/comp-assignment.html',
			controller: 'CompAssignmentController',
			resolve: {
				initialData: function( Bootstrap ){
					return Bootstrap.bootstrapApplication();
				},
				loadAssets: function(Utilities) {
					return Utilities.cacheBustAndLazyLoad([
						'scripts/modules/extraflow/comp-assignment/controllers/comp-assignment-controller.js',
						'scripts/modules/extraflow/comp-assignment/directives/comp-assignment-form-directive.js',
						'scripts/modules/extraflow/comp-assignment/services/comp-assignment-service.js'
					]);
				},
				xfcMap: function(initialData, loadAssets, Package) {
					return Package.buildXFCMap();
				},
				compAssignmentSetup: function( xfcMap, $injector, $transition$ ){
					return $injector.get('CompAssignmentService').initializeService( $transition$.params().packageId, true);
				}
			}
		})
		.state('/unassignedAddons', {
			url: '/unassignedAddons',
			templateUrl: '/scripts/modules/extraflow/comp-assignment/views/comp-assignment.html',
			controller: 'UnassignedAddonsController',
			resolve: {
				initialData: function( Bootstrap ){
					return Bootstrap.bootstrapApplication();
				},
				loadAssets: function(Utilities) {
					return Utilities.cacheBustAndLazyLoad([
						'scripts/modules/extraflow/comp-assignment/controllers/unassigned-addons-controller.js',
						'scripts/modules/extraflow/comp-assignment/directives/comp-assignment-form-directive.js',
						'scripts/modules/extraflow/comp-assignment/services/comp-assignment-service.js'
					]);
				},
				hasUnassignedAddons: function(initialData, loadAssets, LegacyCart, RouteRejectionService) {
					//we only want to route to this module if indeed we have unassigned addons (this will correctly handle the back button routing)
					if (LegacyCart.hasUnassignedAddons()) {
						return true;
					} else {
						throw new RouteRejectionService.UnrecoverableException();
					}
				},
				unassignedAddonSetup: function( hasUnassignedAddons, $injector ){
					return $injector.get('CompAssignmentService').initializeService( null, false );
				}
			}
		});
}).run(function( ExtraFlow, Enums ){

	ExtraFlow.registerXMC(
		'comp_assignment'
		, { name: 'comp_assignment'
			, view: Enums.extraFlowRoutes.COMP_ASSIGNMENT
			, enabled: true
			, doEditMode: true
			, writeSingleCharac: false
			, type: 'extraFlowControl'
		});
});

"use strict";

angular.module('comp-assignment')
    .directive
('addonSelectionDirective'
    , function
        ($filter,
		$rootScope,
		AppData,
		titlesJSon,
		countriesJSon,
		Enums,
		ExtraFlow,
		Language,
		Modal,
		Package,
		Seasonpass,
		UserInfo,
		Utilities,
		OneBarcodeUtilities,
		Security,
		$timeout,
		$log) {
        // NOTE: Use slash in front of templateUrl in order to have page load correctly.
        var dir = { templateUrl: '/scripts/modules/extraflow/comp-assignment/views/templates/addon-template.html',
            scope: {
                callbacks: '=callbacks',
                fieldSettings: '=fieldSettings',
                formData: '=formData',
                formOptions: '=formOptions',
                controllerScope: '=controllerScope',
                cartItems: '=cartItems',
                packageDetails: '=packageDetails',
                oneBarcodeActive: '=oneBarcodeActive'
            },
            link: function (scope, elm, attrs) {
                scope.i18n = Language;
				scope.$on('saveData', handleSaveData);

				function init() {
					if(Utilities.childDefined(scope.packageDetails.CHARACS,'oneBarcodeKeyword') === true) {
						scope.packages = OneBarcodeUtilities.performPackageLookup();

						if(Package.isEditing()) {
							preSelectAddonPackages();
						}
						setPriceLabels();
						$rootScope.$broadcast('triggerImpressionsSells', scope.packages, "Add Ons");
					}
				}

				/**
				 * When the checkbox of package changes, this function will handle the update and either add the addon to the formData.addOnPackages array or remove it if exists
				 * @param pkg
				 */
				scope.updateSelectedAddons = function(pkg){

					//first ensure we have the addOnPackages property set
					if(angular.isUndefined(scope.formData.addOnPackages)){
						scope.formData.addOnPackages = [];
					}

					var matchedAddonIndex = scope.formData.addOnPackages.indexOf(pkg);
					//if the guest chose this addon package and it doesn't already exist within the guest's current addon selections, then add it
					if(angular.isDefined(pkg.selected) && pkg.selected && matchedAddonIndex === -1){

						scope.formData.addOnPackages.push(pkg);

					}else if( !pkg.selected && matchedAddonIndex > -1){

						//if the guest unselected the addon package and it exists within the guest's current addon selections, then remove it
						scope.formData.addOnPackages.splice(matchedAddonIndex,1);

					}

				}

				function setPriceLabels() {
					for( var i = 0; i < scope.packages.length; i++ ) {
						var item = scope.packages[i];

						if (angular.isDefined(item.CHARACS) && angular.isDefined(item.CHARACS.addon_image)) {
							item.addonImage = $rootScope.getAssetUrl(item.CHARACS.addon_image);
						} else {
							item.addonImage = $rootScope.getAssetUrl(item.shop_image_v4);
						}

						item.priceLabel = $filter('currencyFormatter')( item.CT[0].retail_amount );

						if( Utilities.childDefined(item, 'CHARACS.package_type') &&
							item.CHARACS.package_type === "membership" ) {
							item.priceLabel = item.priceLabel + Language.getLocale('CartView', 'perMonthLabel');
						}
					}
				}

				/**
				 * Preselect the addon Packages (for edit mode)
				 */
				function preSelectAddonPackages(){

					var oneBarcodeCartItems = scope.cartItems.filter(function(item) {
						return item.oneBarcodePackages && item.oneBarcodePackages.length > 0
					});
					oneBarcodeCartItems.forEach(function(cartItem) {

						cartItem.oneBarcodePackages.forEach(function(oneBarcodePkg) {

							var matchingPkg = scope.packages.filter(
								function(pkg) {
									return pkg.id == oneBarcodePkg.package_id;
								})[0];
							if (angular.isDefined(matchingPkg)) {
								matchingPkg.selected = true;
								scope.updateSelectedAddons(matchingPkg);
							}
						});
					});
				}
				/**
				 * checkForAddonsPreviouslySelected selects the addons that were previously added. This is used when a customer has already
				 * selected addon packages and is going back through
				 * the seasonPassOptionsRenewal flow without having gone through the cart.
				 **/
				function checkForAddonsPreviouslySelected() {
					// scope.formData.addOnPackages is the list of addons selected for the current form.
					// If it exists, we've already been through this process. Drop out.
					if(angular.isDefined(scope.formData.addOnPackages) && scope.formData.addOnPackages.length>0) { return; }

					// If any addons have been added, group_uuid will be defined.
					if(! angular.isDefined(scope.formData.group_uuid)) { return; }

					// Quick variable recap:
					//   scope.packages holds all possible addon packages.
					//   Package.itemsToBeAdded holds everything (addon packages and regular packages) that have been added.
					//   scope.formData is the form that we're trying to display. group_uuid is its group id for the addons .
					//   scope.formData.addOnPackages will hold the list of addons (from scope.packages) selected for scope.formData
					//
					// NB: packages in scope.packages are in a different format than those in Package.itemsToBeAdded.
					//
					// Now we search through Package.itemsToBeAdded for all the packages that have a charac with
					// the same group_uuid as the current scope.formData. That indicates they are addons for the package loaded
					// in formData.
					Package.itemsToBeAdded.forEach(function(pkg){

						if(angular.isDefined(pkg.CHARACS) && (pkg.package_id != scope.formData.package_id)){
							for(var i=0; i<pkg.CHARACS.length; i++){
								if( angular.isDefined(pkg.CHARACS[i].group_uuid) && (pkg.CHARACS[i].group_uuid === scope.formData.group_uuid) ){
									// we found the package in itemsToBeAdded, get the matching package from scope.packages
									var newpkgs=scope.packages.filter(function(addon){return (addon.id===pkg.package_id); });
									if(newpkgs.length>0) {
										if (angular.isUndefined(scope.formData.addOnPackages)) {
											scope.formData.addOnPackages = [];
										}
										scope.formData.addOnPackages.push(newpkgs[0]);
										break;
									}
								}
							};
						}
					});
				}

				function handleSaveData(event, activeForm) {

					for(var i in scope.formData.addOnPackages) {
						$rootScope.$broadcast('triggerProductClick', scope.formData.addOnPackages[i]);
					}

				}

				scope.showPackageDetails = function(pkg) {
					if( typeof pkg.shop_image_v4 == 'string' && pkg.shop_image_v4 != '' ) {
						pkg.packageImage = $rootScope.getAssetUrl(pkg.shop_image_v4);
					}

					Modal.displayModal
					(
						{
							category: 'One Barcode'
							, action: 'Show Package Details'
							, label: pkg.name
							, title: pkg.name
							, description: '<p>'+pkg.desc+'</p>'
							, image: pkg.packageImage
							, desktop: true
							, buttonFlags: [Enums.buttonFlags.OK]
							, callback: function( detail ) {}
						}
					);
				}

			/**
			 * The way season_pass_renewal movie incorporates the seasonPassForm directive has changed.  It only uses one instance of the seasonPassForm directive per passCollection now.
			 * The instance is bound to an activePass in the seasonPassOptRenewal controller.  Because of the way the original seasonPassForm directive was coded within the
			 * SeasonPass controller, we must watch for when the formData object has changed to a different activePass and update the instances' scope.packages array to reselect the
			 * items for the view to display which ones are truly selected.  This watch will only fire changes on the seasonPassRenewal movie as the regular seasonPass movie has multiple instances (one instance per pass).
			 */
				scope.$watch(function () {

					return scope.formData;

				}, function(newVal, oldVal) {

					if(angular.isDefined(scope.packages) && !Package.isEditing()){
						checkForAddonsPreviouslySelected();
						scope.packages.forEach(function(p){

							if(angular.isDefined(scope.formData.addOnPackages) && scope.formData.addOnPackages.length > 0 &&
								scope.formData.addOnPackages.filter(function(addonPkg){return addonPkg.id === p.id}).length === 1){

								p.selected = true;

							}else{

								p.selected = false;

							}

						});

					}

				});

				init();
            }
        }
        return dir;
    }
);

angular.module('generic-form', [
	'errorTracking', 'app'
]).config(function( $stateProvider ){
	$stateProvider
		.state('/genericForm/:packageId', {
			url: '/genericForm/:packageId',
			templateUrl: '/scripts/modules/extraflow/generic-form/views/generic-form.html',
			controller: 'GenericFormController',
			resolve: {
				initialData: function( Bootstrap ){
					return Bootstrap.bootstrapApplication();
				},
				loadAssets: function(Utilities) {
					return Utilities.cacheBustAndLazyLoad([
						'scripts/modules/extraflow/generic-form/controllers/generic-form-controller.js',
						'scripts/modules/extraflow/generic-form/directives/generic-form-item-directive.js',
						'scripts/modules/extraflow/generic-form/directives/generic-input-directive.js',
						'scripts/directives/genericForm/generic-input-directive.js',
						'scripts/directives/genericForm/genericformitem.js'
					]);
				}
		   }
		});
}).run(function( ExtraFlow, Enums ){

	ExtraFlow.registerXMC(
		'generic_form'
		, { name: 'generic_form'
			, aliases: [
				 'generic_form_1'
	           , 'generic_form_2'
	           , 'generic_form_3'
	           , 'generic_form_4'
	           , 'generic_form_5'
            ]
			, view: Enums.extraFlowRoutes.GENERICFORM
			, isSingle: false
			, doEditMode: false
			, writeSingleCharac: false
			, enabled: true
			, type: 'extraFlowControl'
		});
});

angular.module('giftcode', [
	'errorTracking', 'app'
]).config(function( $stateProvider ){

	$stateProvider
		.state('/giftcode/:packageId', {
			url: '/giftcode/:packageId',
			templateUrl: '/scripts/modules/extraflow/giftcode/views/giftcode.html',
			controller: 'GiftcodeController',
			resolve: {
				initialData: function(Bootstrap) {
					return Bootstrap.bootstrapApplication();
				},
				loadAssets: function(Utilities) {
					return Utilities.cacheBustAndLazyLoad([
						'scripts/modules/extraflow/giftcode/controllers/giftcode-controller.js'
					]);
				},
				xfcMap: function(initialData, loadAssets, Package) {
					return Package.buildXFCMap();
				}
			}
		});
}).run(function( ExtraFlow, Enums ){

	ExtraFlow.registerXMC(
		'giftcode'
		, { name: 'giftcode'
			, view: Enums.extraFlowRoutes.GIFTCODE
			, isSingle: false
			, doEditMode: false
			, writeSingleCharac: false
			, enabled: true
			, type: 'extraFlowControl'
			, characsList: ['gift_code', 'gift_offer_id']
		});

	ExtraFlow.registerXMC(
		'gift_code'
		, { name: 'gift_code'
			, view: Enums.extraFlowRoutes.GIFTCODE
			, isSingle: false
			, doEditMode: false
			, writeSingleCharac: false
			, enabled: true
			, type: 'extraFlowControl'
			, characsList: ['gift_code', 'gift_offer_id']
		});

	ExtraFlow.registerXMC(
		'giftcode_multi'
		, { name: 'giftcode_multi'
			, view: Enums.extraFlowRoutes.GIFTCODE
			, isSingle: false
			, doEditMode: false
			, writeSingleCharac: false
			, enabled: true
			, type: 'extraFlowControl'
			, characsList: ['gift_code', 'gift_offer_id']
		});

	ExtraFlow.registerXMC(
		'giftcode_single'
		, { name: 'giftcode_single'
			, view: Enums.extraFlowRoutes.GIFTCODE
			, isSingle: true
			, doEditMode: false
			, writeSingleCharac: false
			, enabled: true
			, type: 'extraFlowControl'
			, characsList: ['gift_code', 'gift_offer_id']
		});

	ExtraFlow.registerXMC(
		'authcode_single'
		, { name: 'authcode_single'
			, view: Enums.extraFlowRoutes.GIFTCODE
			, isSingle: true
			, doEditMode: false
			, writeSingleCharac: false
			, enabled: true
			, type: 'extraFlowControl'
			, characsList: ['gift_code', 'gift_offer_id']
		});
});

angular.module('group-sales', [
	'errorTracking', 'app'
]).config(function( $stateProvider ){

	$stateProvider
		.state('groupSales', {
			url: '/groupSales/:packageId',
			templateUrl: '/scripts/modules/extraflow/group-sales/views/group-sales.html',
			controller: 'GroupSalesController',
			title: 'groupSales',
			resolve: {
				initialData: function( Bootstrap ){
					return Bootstrap.bootstrapApplication();
				},
				xfcMap: function( initialData, Package ){
					return Package.buildXFCMap();
				},
				groupSalesSetup: function( xfcMap, GroupSalesService, $transition$ ){
					return GroupSalesService.init( $transition$.params().packageId );
				}
			}
		})
		.state('groupSales.options', {
			url: '/options',
			templateUrl: '/scripts/modules/extraflow/group-sales/views/templates/options-template.html'
		})
		.state('groupSales.group-info', {
			url: '/group-info',
			templateUrl: '/scripts/modules/extraflow/group-sales/views/templates/group-info-template.html'
		})
		.state('groupSales.org-info', {
			url: '/org-info',
			templateUrl: '/scripts/modules/extraflow/group-sales/views/templates/org-info-template.html'
		})
		.state('groupSales.extra-info', {
			url: '/extra-info',
			templateUrl: '/scripts/modules/extraflow/group-sales/views/templates/extra-info-template.html'
		});
}).run(function( ExtraFlow, Enums ){

	ExtraFlow.registerXMC(
		'group_sales_radio'
		, { name: "group_sales_radio"
			, aliases: ['group_info']
			, view: Enums.extraFlowRoutes.GROUPSALES
			, showEmailRegistration: {
				default: true
			}
			, precheckEmailRegistration: {
				default: false
			}
			, enabled: true
			, type: 'extraFlowControl'
			, characsList: ['organization']
			, doEditMode: false
			, lockQuantity: true
			, writeSingleCharac: false
			, useAlternateUI: true
		});

	ExtraFlow.registerXMC(
		'group_sales_simple'
		, { name: 'group_sales_simple'
			, view: Enums.extraFlowRoutes.GROUPSALES
			, aliases: [
				 'cf_group_sales'
				, 'cf_group_sales_tax'
			]
			, isSingle: true
			, doEditMode: false
			, writeSingleCharac: true
			, showEmailRegistration: {
				default: false
			}
			, precheckEmailRegistration: {
				default: false
			}
			, showExtraFields: false
			, showTaxpayerId: {
				 'cf_group_sales_tax': true
				, default: false
			}
			, enabled: true
			, type: 'extraFlowControl'
			, useAlternateUI: false
			, characsList: [
				 'gr_organization_name'
				, 'gr_group_name'
				, 'gr_pc_first_name'
				, 'gr_pc_last_name'
				, 'gr_pc_phone'
				, 'gr_pc_alt_phone'
				, 'gr_pc_email'
				, 'gr_address'
				, 'gr_city'
				, 'gr_state'
				, 'gr_zip'
			]
		});

	ExtraFlow.registerXMC(
		'group_sales_extended'
		, { name: 'group_sales_extended'
			, view: Enums.extraFlowRoutes.GROUPSALES
			, aliases: [
				 'group_sales'
				, 'group_sales_HFE'
				, 'group_sales_ticket'
				, 'group_sales_midway'
				, 'sp_group_sales'
				, 'sp_group_sales_reg'
				, 'sp_group_sales_tax'
			]
			, isSingle: true
			, doEditMode: false
			, writeSingleCharac: true
			, showTaxpayerId: {
				 'sp_group_sales_tax': true
				, 'cf_group_sales_tax': true
				, default: false
			}
			, showEmailRegistration: {
				default: true
			}
			, precheckEmailRegistration: {
				 'sp_group_sales': true
				, 'sp_group_sales_reg': true
				, 'sp_group_sales_tax': true
				, default: false
			}
			, showExtraFields: true
			, requireArrivalDate: {
				 'sp_group_sales': true
				, 'sp_group_sales_reg': true
				, 'sp_group_sales_tax': true
				, default: false
			}
			, enabled: true
			, type: 'extraFlowControl'
			, useAlternateUI: false
			, characsList: [
				 'gr_organization_name'
				, 'gr_category_name'
				, 'gr_category_id'
				, 'gr_group_name'
				, 'gr_pc_first_name'
				, 'gr_pc_last_name'
				, 'gr_pc_phone'
				, 'gr_pc_alt_phone'
				, 'gr_pc_email'
				, 'gr_address'
				, 'gr_city'
				, 'gr_state'
				, 'gr_country_code'
				, 'gr_zip'
			]
		});
});

angular.module('group-sales')
	.controller
	('GroupSalesController'
		, function
			($state
				, $stateParams

				, $filter
				, $scope
				, $timeout
				, $rootScope
				, AppData
				, ClientInfo
				, countriesJSon
				, Enums
				, ExtraFlow
				, GroupSalesService
				, Language
				, Modal
				, Package
				, Utilities
				, StringUtils
			) {


			//some public things
			$scope.i18n = Language;
			$scope.xfc = ExtraFlow;

			//boolean for if we set a date previously in XFC
			$scope.preselectedDate = false;

			//show the opt in if we want to bool
			$scope.showOptIn = false;

			//show summary box flag bool
			$scope.isLastStep = false;

			$scope.orderBy = $filter('orderBy');

			$scope.regions = countriesJSon.regions;

			$scope.orgNameFocus = false;



			/**
			 * Prefills Form Data when in autofill/dev mode
			 * @private
			 */
			function prefillFormData() {
				// Dev mode only. Pre-populate the pass information.
				if ($scope.autofill && !Package.settings.useAlternateUI &&
					angular.isUndefined(GroupSalesService.dataModel.firstName)) {

					var copy = JSON.parse(JSON.stringify(GroupSalesService.defaults));
					GroupSalesService.dataModel = Utilities.mergeObjects([GroupSalesService.dataModel, copy]);
				}
			}

			/**
			 * Calls updatePostalCodeDataType based on
			 * scope.formData.ph_country_code.
			 * @public
			 * @returns undefined
			 */
			$scope.handleCountriesChanged = function () {
				$scope.dataModel.state = '';
				$scope.dataModel.province = '';
				updatePostalCodeDataType($scope.dataModel.countryCode);
			}


			/**
			 * supply of org types from database (cached request!)
			 * @type {Array}
			 */
			$scope.orgCategoryTypes = GroupSalesService.orgCategoryTypes;
			/**
			 * Method uised to query the support org types
			 * from the island configuration
			 * @private
			 */


			/**
			 * Updates Datatype of Postal Code.
			 * @private
			 * @param {string} countryCode
			 * @returns {undefined}
			 */
			function updatePostalCodeDataType(countryCode) {
				// Update postal code data type.
				$scope.fieldSettings.postalCodeDataType = ($scope.dataModel.countryCode == 'US') ? 'tel' : 'text';
			}

			/**
			 * Event Watcher for "GOOGLEZIP" to trigger input field value propogation
			 * @param  {Object} event the GOOGLEZIP event
			 * @param  {Object} data 	the event data
			 *                        ex: { country:'US', city:'City Name', state:'FL'}
			 */
			$scope.$on('GOOGLEZIP',
				function (event, data) {
					$scope.dataModel.countryCode = data.country;
					$scope.dataModel.city = data.city;
					$scope.dataModel.state = data.state;
				});

			/**
			 * show the optIn check
			 */
			function determineOptInVisibility() {
				$scope.showOptIn = ($scope.fieldSettings.optIn.visible &&
					$state.current.name === 'groupSales.extra-info' || $scope.useAlternateUI);
			}


			/**
			 * Cancel doing the things
			 * @public
			 */
			$scope.cancel = function () {

				// Prompt to delete.
				Modal.displayModal({
					title: Language.getLocale('Alert', 'cancelGroupTicketsTitle')
					, description: Language.getLocale('Alert', 'cancelGroupTicketsMsg')
					, icon: 'icon-info red'
					, buttonFlags: [Enums.buttonFlags.NO, Enums.buttonFlags.YES]
					, callback: function (detail) {
						if (detail == Enums.buttonFlags.YES) {

							Package.cancelXFC();
						}
					}
				});

			}

			/**
			 * Save things to the storage
			 * @return {[type]} [description]
			 */
			$scope.save = function () {
				$scope.dataModel.primaryPhone = StringUtils.formatPhoneNumber($scope.dataModel.primaryPhone);
				$scope.dataModel.altPhone = StringUtils.formatPhoneNumber($scope.dataModel.altPhone);
				$scope.dataModel.fax = StringUtils.formatPhoneNumber($scope.dataModel.fax);

				GroupSalesService.save($scope.cartItems);
			};

			/**
			* select - select a particular option to use for the alt uI
			* @param {Number} $index of result to use
			*/
			$scope.select = function (index, key) {
				$scope.dataModel[key + 'Index'] = index;
				$scope.dataModel[key] = getRadioValue(key, index);
			}

			$scope.sourceUpdated = function () {
				$scope.showOtherSourceField = false;

				if (GroupSalesService.dataModel.source && GroupSalesService.dataModel.source == $scope.referralSources[$scope.referralSources.length - 1]) {
					$scope.showOtherSourceField = true;
				}
			}

			$scope.focusInput = function () {
				$scope.orgNameFocus = !$scope.orgNameFocus;
			}

			$scope.setOrgType = function (org) {
				GroupSalesService.dataModel.submitted = false;
				GroupSalesService.dataModel.orgType = org;

				// set focus to org name field
				$timeout(function () {
					var element = document.getElementById('orgName');
					if (element)
						element.focus();
				});
			}

			/**
			* Method to return a string value of a data set from the service.
			* @param  {String} radioSourceKey the source to pull strings from
			* @param  {Number} index          the index in the source, based on selection
			* @return {String}                source string value
			*/
			function getRadioValue(radioSourceKey, index) {
				switch (radioSourceKey) {
					case 'orgType':
						return GroupSalesService.orgTypeOptions[index];
						break;
					case 'source':
						return GroupSalesService.referralSources[index];
						break;
				}
			}


			/**
			 * method to regress user in purchase flow
			 */
			$scope.previousView = function () {

				GroupSalesService.dataModel.submitted = false;

				switch ($state.current.name) {

					case 'groupSales.extra-info':
						$state.transitionTo('groupSales.org-info', { packageId: $stateParams.packageId });
						break;

					case 'groupSales.org-info':
						setInitialState();
						break;

					case 'groupSales.group-info':
					case 'groupSales.options':
						Package.cancelXFC();
						break;
				}

			}

			/**
			 * method to advance user in purchase flow
			 */
			$scope.nextView = function () {

				GroupSalesService.dataModel.submitted = true;

				if (!$scope.groupForm.$valid) {
					return;
				}

				GroupSalesService.dataModel.submitted = false;

				switch ($state.current.name) {

					case 'groupSales.extra-info':
						$scope.save();
						break;

					case 'groupSales.org-info':
						if (Package.settings.showExtraFields) {
							$rootScope.routeTo($state.href('groupSales.extra-info', { packageId: $stateParams.packageId }));
						} else {
							$scope.save();
						}

						break;

					case 'groupSales.group-info':
					case 'groupSales.options':
						if ($scope.useAlternateUI) {
							$scope.save();
						} else {
							$rootScope.routeTo($state.href('groupSales.org-info', { packageId: $stateParams.packageId }));
						}

						break;
				}
			}


			function setInitialState() {
				if ($scope.useAlternateUI) {
					$rootScope.routeTo($state.href('groupSales.options', { packageId: $stateParams.packageId }), undefined, undefined, true);
				} else {
					$rootScope.routeTo($state.href('groupSales.group-info', { packageId: $stateParams.packageId }), undefined, undefined, true);
				}
			}



			/**
			 * Initializes the controller.
			 * @private
			 * @returns {null}
			 */
			function InitializeController() {

				if (!Package.initXFC()) {
					return;
				}

				// For the radio select UI
				$scope.useAlternateUI = (Package.settings.useAlternateUI === true);

				if ($state.current.name === 'groupSales')
					setInitialState();

				$scope.showSpinner(Language.getLocale('GroupSales', 'loadingGroupSalesMsg'));

				$scope.cartItems = Package.itemsToBeAdded;
				$scope.fieldSettings = GroupSalesService.getFieldSettings();

				var referralSources = Language.getLocale('GroupSales', 'referralSources');

				if (angular.isDefined(referralSources)) {
					$scope.referralSources = referralSources.split(',');
				} else {
					Package.cancelXFC();
					throw new Error("Referral Sources locale not defined.");
				}

				// Providers for combo boxes
				$scope.countries = AppData.countries;
				$scope.regions = countriesJSon.regions;

				// View texts
				$scope.pkgTitle = Package.packageDetails.name;

				// For showing/hiding the summary box
				$scope.isMobile = (ClientInfo.deviceType == 'mobile');

				determineOptInVisibility();
				$scope.hideSpinner();
				prefillFormData();
				$scope.dataModel = GroupSalesService.dataModel;
			}

			InitializeController();
		})

angular.module('group-sales')
  .service
  ( 'GroupSalesService'
  	, function
  	(
		$document,
		$timeout,
  		$rootScope,
  		$stateParams,
  		$filter,
  		AppData,
  		Enums,
  		ExtraFlow,
  		Package,
  		Utilities
  	)
  	{

  		var service = {}
  			, currentViewIndex = -1
			, Pkg = null;

			// This is set on init().

			service.dataModel = {};
			service.orgCategoryTypes = [];
			service.gettingOrgTypes = false;
			service.packageId = null;

			service.defaults =
			{
			//	  orgName: 'accesso'
			//	, orgType: 'Business'
			//	, orgTypeId: '1'
				groupName: 'shopv5dev'
				, firstName: 'accesso'
				, lastName: 'dev'
				, primaryPhone: '4075551234'
				, altPhone: '4074441234'
				, email: 'shopv5dev@accesso.com'
				, fax: '4075550123'
				, address: '123 main street'
				, city: 'orlando'
				, state: 'FL'
			//	, countryCode: 'US'
			//	, countryName: 'United States of \'Merica'
				, postalCode: '34761'
			//	, source: 'the matrix'
				, optIn: false
				, arrivalDate: '06-15-2014'
			//	, lastVisitDate: '06-15-2013'
			//	, mailerCode: 'ABC 1234'
			//	, mailerReceivedDate: '05-15-2014'
				, taxpayerId: '123-45-768'
			}

			//initial settings obj
			service.fieldSettings = {};

			/**
			 * Initializes the Group Sales Service
			 * @public
			 * @param Package
			 * @returns {null}
			 */
			service.init = function(packageId) {

				if(!Package.initXFC(packageId)) {
					return true;
				}

				reset();

				currentViewIndex = 0;

				//set the xfcOptions to the package settings values

				if(!service.gettingOrgTypes) {
					service.gettingOrgTypes = true;
					service.getGroupOrgTypes();
				}

				for(var i in Package.itemsToBeAdded){
					var pkg = Package.itemsToBeAdded[ i ];

					if(pkg.extra_movie.indexOf( Package.xfcName ) != -1 ){
						service.dataModel.qty = Package.getTotalToBeAdded( false, true, Package.settings.name );

						service.dataModel.arrivalDate = '';
						if( angular.isDefined(pkg.CHARACS) &&
							angular.isArray(pkg.CHARACS) &&
							angular.isDefined(pkg.CHARACS[0].start_date ) ) {
							service.dataModel.arrivalDate = pkg.CHARACS[0].start_date;
						}


						service.dataModel.orgType_index = -1;
						service.dataModel.source_index = -1;

						//precheck the email registration is the movie wants it
						service.dataModel.optIn = ( Package.settings.precheckEmailRegistration == true);

						break;
					}
				}

			}

			service.getFieldSettings = function() {
				for(var c in Package.settings) {
					switch( c ){
						case "showExtraFields":

								var req = ( Package.settings[c] );
								for(var c in service.fieldSettings ){
									if( service.fieldSettings[ c ].isExtraField == true ){
										service.fieldSettings[ c ].visible = req;
									}
								}

							break;
						case "showTaxpayerId":
							service.fieldSettings.taxpayerId.visible = Package.settings[c];
							service.fieldSettings.taxpayerId.required = Package.settings[c];
							break;
						case "showEmailRegistration":
							service.fieldSettings.optIn.visible = Package.settings[c];
							break;
						case "precheckEmailRegistration":
							service.defaults.optIn = true;
							break;
						case "requireArrivalDate":
							service.fieldSettings.arrivalDate.required = ( Package.settings[c] && service.fieldSettings.arrivalDate.visible );
							break;
						default:
							break;
					}
				}

				return service.fieldSettings
			}

			service.getGroupOrgTypes = function(){
				var reqObj = { cart_id: AppData.cart.cart_id };

				AppData.fetch
				(	Enums.services.GET_GROUP_CATEGORY
					, false
					, reqObj
				).then( function( data ){
					if( data.status == Enums.status.OK && Utilities.childDefined( data, 'GROUP_CATEGORY_MASTER') ){
						var element = angular.element($document[0].getElementById('orgType'))[0];
						for( var i in data.GROUP_CATEGORY_MASTER ){
								var type = data.GROUP_CATEGORY_MASTER[ i ];
								service.orgCategoryTypes.push( { id: type.category_id , name: type.category_name });
						}
						$timeout(function updateOrgTypeItems() {
							if (element) {
								element.updateMenuOptions();
							}
						 }, 0);
					} else {
							$scope.hideSpinner();
							return;
					}
				}).finally(function() {
					$rootScope.hideSpinner();
				});
			}

			service.save = function() {
				Package.itemsToBeAdded.forEach( function( cartItem ){
					if(cartItem.package_id == $stateParams.packageId){
						for(var j in cartItem.CHARACS){
							var cRef = cartItem.CHARACS[j];

							if(Package.settings.useAlternateUI) {
								service.mapAlternateCharacs( cartItem );
							}else{
								service.mapDataModelToCharac( cartItem );
							}

						}
					}
				});

				// Add reference of XFC to CHARACs.
				ExtraFlow.addReferenceToCartItems( Package.settings.view, Package.itemsToBeAdded, ExtraFlow.CLIENT_XFC_VIEW );
				ExtraFlow.addReferenceToCartItems( Package.settings.name, Package.itemsToBeAdded, ExtraFlow.CLIENT_XFC_NAME );

				// Navigate to the next XFC.
				Package.nextXFC();
				Utilities.scrollPosition();
			}

			service.mapDataModelToCharac = function( cartItemObj ){
				// return an obj of the dataModel mapped to the service characList
				for( var i in service.dataModel ){

					var required = ( angular.isDefined( service.fieldSettings[i] ) && service.fieldSettings[i].required );
					//ignore non-required only if invalid
					if( (!required && angular.isUndefined( service.dataModel[i] )) ||
						i === 'submitted' ){
						continue;
					}



					var value = service.dataModel[ i ].toString();

					if( i =="arrivalDate" || i == "mailerReceivedDate" || i == "lastVisitDate" ){
						value = value.length > 0 ? $filter( 'date' )( Utilities.dateStringToObject(value.split('/').join('-')), "yyyy-MM-dd" ) : value;
					}

					if( i == 'source' && angular.isDefined(service.dataModel.otherSource) ) {
						value = service.dataModel.otherSource;
					}

					if( i == 'orgType' ) {
						ExtraFlow.addReferenceToCartItems( JSON.parse(service.dataModel[i]).name, Package.itemsToBeAdded, 'gr_category_name' );
						ExtraFlow.addReferenceToCartItems( JSON.parse(service.dataModel[i]).id, Package.itemsToBeAdded, 'gr_category_id' );
					}else{

						if( Utilities.childDefined(service.fieldSettings[i], 'characProp') ) {
							ExtraFlow.addReferenceToCartItems( value, Package.itemsToBeAdded, service.fieldSettings[ i ].characProp );
						}
					}



				}
			}

			service.mapAlternateCharacs = function (cartItem) {

				ExtraFlow.addReferenceToCartItems( service.dataModel.orgType.name + ': ' + service.dataModel.orgName, Package.itemsToBeAdded, 'organization' );
				ExtraFlow.addReferenceToCartItems( service.dataModel.source, Package.itemsToBeAdded, 'how_did_you_hear_about_us' );

				if(service.dataModel.optIn == "1") {
					ExtraFlow.addReferenceToCartItems( service.dataModel.optIn, Package.itemsToBeAdded, 'contact_us' );
				}

			}

			/**
			 * Resets the view back to an empty form
			 */
			function reset(){

				service.dataModel = {
					submitted: false
				};

				service.packageId = null;

				// Reset the currentViewIndex.
				currentViewIndex = -1;

				// Default fields - get's overwritten by each XMC view.
				service.fieldSettings =
				{	  orgName:					{ required: true, 	visible: true,	isExtraField: false, characProp: 'gr_organization_name'	}
					, groupName:				{ required: true, 	visible: true,	isExtraField: false, characProp: 'gr_group_name' }
					, firstName:				{ required: true, 	visible: true,	isExtraField: false, characProp: 'gr_pc_first_name' }
					, lastName:					{ required: true, 	visible: true,	isExtraField: false, characProp: 'gr_pc_last_name' }
					, primaryPhone:				{ required: true, 	visible: true,	isExtraField: false, characProp: 'gr_pc_phone' }
					, altPhone:					{ required: true, 	visible: true,	isExtraField: false, characProp: 'gr_pc_alt_phone' }
					, email:					{ required: true,	visible: true,	isExtraField: false, characProp: 'gr_pc_email' }
					, address:					{ required: true,	visible: true,	isExtraField: false, characProp: 'gr_address' }
					, city:						{ required: true,	visible: true,	isExtraField: false, characProp: 'gr_city' }
					, state:					{ required: true,	visible: true,	isExtraField: false, characProp: 'gr_state' }
					, postalCode:				{ required: true,	visible: true,	isExtraField: false, characProp: 'gr_zip' }
					, taxpayerId:				{ required: false,	visible: false,	isExtraField: false, characProp: 'gr_taxpayer_id' }
					, optIn:					{ required: false,	visible: true,	isExtraField: false, characProp: 'gr_opt_in' }
					, county:					{ required: false,	visible: true,	isExtraField: false, characProp: 'gr_county' }
					, countryCode:				{ required: true,	visible: true,	isExtraField: false, characProp: 'gr_country_code' }

					, mailerCode:				{ required: false,	visible: true,	isExtraField: true, characProp: 'gr_mailer_code' }
					, mailerRecievedDate:		{ required: false,	visible: true,	isExtraField: true, characProp: 'gr_mailer_receive_date' }
					, arrivalDate:				{ required: false,	visible: true,	isExtraField: true, characProp: 'gr_arrival_date' }
					, lastVisitDate:			{ required: false,	visible: true,	isExtraField: true, characProp: 'gr_last_visit_date' }
					, orgTypeName:				{ required: true,	visible: true,	isExtraField: true, characProp: 'gr_category_name' }
					, orgTypeId:				{ required: true,	visible: true,	isExtraField: true, characProp: 'gr_category_id' }
					, fax:						{ required: false,	visible: true,	isExtraField: true, characProp: 'gr_pc_fax' }
					, source:					{ required: false,	visible: true,	isExtraField: true, characProp: 'how_did_you_hear_about_us' }
				};

			}

  		return service;

  });

angular.module('group-sales-wizard', [
	'errorTracking', 'app'
]).config(function( $stateProvider ){

	$stateProvider
		.state('groupSalesWizard', {
			url: '/groupSalesWizard/:packageId',
			templateUrl: '/scripts/modules/extraflow/group-sales-wizard/views/group-sales-wizard.html',
			controller: 'GroupSalesWizardController',
			title: 'groupSales',
			resolve: {
				load: function( $rootScope, Utilities ) {

					$rootScope.showSpinner();

					return Utilities.cacheBustAndLazyLoad([
						'/scripts/modules/extraflow/group-sales-wizard/controllers/group-sales-wizard-controller.js',
						'/scripts/modules/extraflow/group-sales-wizard/services/group-sales-wizard-prep-service.js',
						'/scripts/modules/extraflow/group-sales-wizard/group-sales-wizard-models.js',
						'/scripts/modules/extraflow/group-sales-wizard/services/group-sales-wizard-finalize-service.js',
						]);
				},
				initialData: function (load, Bootstrap) {
					return Bootstrap.bootstrapApplication();
				},
				xfcMap: function(initialData, Package) {
					return Package.buildXFCMap();
				},
				initXFC: function( xfcMap, RouteRejectionService, Package, $transition$ ){

					var rejectionRoute = Package.assessRoutabilityOfXFC($transition$.params().packageId);
					if(rejectionRoute.length > 0){

						throw new RouteRejectionService.UnrecoverableException(rejectionRoute);
					}
					else{

						return true;
					}
				},
				model: function( initXFC, $injector) {
					return $injector.get('GroupSalesWizardPrepService').getModel(new $injector.get('GroupSalesWizardModels').GroupSalesWizardObj());
				},
				orgCategoryTypes: function(model, $injector) {
					return $injector.get('GroupSalesWizardPrepService').getGroupOrgTypes();
				}
			}
		});
}).run(function( ExtraFlow, Enums ){
	ExtraFlow.registerXMC(
		'group_sales_wizard_org_info'
		, { name: "group_sales_wizard_org_info"
			, aliases: ['group_sales_wizard_org_info']
			, view: Enums.extraFlowRoutes.GROUPSALESWIZARD
			, enabled: true
			, type: 'extraFlowControl'
			, characsList: ['organization']
			, doEditMode: false
			, lockQuantity: true
			, writeSingleCharac: false
			, useAlternateUI: true
		});

	ExtraFlow.registerXMC(
		'group_sales_wizard'
		, { name: 'group_sales_wizard'
			, view: Enums.extraFlowRoutes.GROUPSALESWIZARD
			, aliases: ['group_sales_wizard']
			, isSingle: true
			, doEditMode: false
			, writeSingleCharac: true
			, showExtraFields: true
			, enabled: true
			, type: 'extraFlowControl'
			, useAlternateUI: false
			, characsList: [
				'gr_organization_name'
				, 'gr_category_name'
				, 'gr_category_id'
				, 'gr_group_name'
				, 'gr_pc_first_name'
				, 'gr_pc_last_name'
				, 'gr_pc_phone'
				, 'gr_pc_alt_phone'
				, 'gr_pc_email'
				, 'gr_address'
				, 'gr_city'
				, 'gr_state'
				, 'gr_country_code'
				, 'gr_zip'
			]
		});
});

angular.module('info', [
	'errorTracking', 'app'
]).config(function( $stateProvider ){

	$stateProvider
		.state('info', {
			url: '/info',
			templateUrl: '/scripts/modules/extraflow/info/views/info.html',
			controller: 'InfoController'
		})
		.state('/info/:packageId', {
			url: '/info/:packageId',
			templateUrl: '/scripts/modules/extraflow/info/views/info.html',
			controller: 'InfoController',
			resolve: {
				initialData: function( Bootstrap ){
					return Bootstrap.bootstrapApplication();
				},
				xfcMap: function( initialData, Package ){
					return Package.buildXFCMap();
				}
			}
		});
}).run(function( ExtraFlow, Enums ){

	ExtraFlow.registerXMC(
		'id_info_mc'
		, { aliases: [
				 'generic_info_1'
				, 'generic_info_2'
				, 'generic_info_3'
				, 'generic_info_4'
				, 'generic_info_5'
				, 'cp_birthday_info'
				, 'nsh_birthday_info'
				, 'fc_birthday_info'
				, 'st_birthday_info'
				, 'ww_birthday_info'
				, 'KW_bday_info'
				, 'bz_edu_info'
				, 'coco_birthday_info'
				, 'coco_birthday_info_or'
				, 'cz_giftmembership_info'
				, 'donationInfo'
				, 'season_pass_info_lr'
				, 'season_pass_info_fr_lr'
				, 'season_pass_info_sp_2011'
			]
			, name: 'id_info_mc'
			, view: Enums.extraFlowRoutes.INFO
			, doEditMode: false
			, writeSingleCharac: false
			, enabled: true
			, type: 'extraFlowControl'
		});
});

angular.module('info')
.controller
( 'InfoController',
	function
		( $scope
		, $timeout
		, ExtraFlow
		, Modal
		, Package
		, Language
		, Utilities
		, StandardFlowInitiatorService){

		// Init first before executing remainder of the code:
		// Ensure we have packages to add. This would not be true if user refreshed the browser.
		if( !Package.initXFC() ){
			return;
		}

		StandardFlowInitiatorService.resetToPackageDetailsScreen = false;

		var _localeTarget;

		( function initializeCtrl(){
			getLocaleTarget();
			// Runs automatically.
			if( !Language.Alert.infoXMCAgreeToTermsTitle || !Language.Alert.infoXMCAgreeToTermsMsg ){
				Language.Alert.infoXMCAgreeToTermsTitle = 'Agree to Terms';
				Language.Alert.infoXMCAgreeToTermsMsg = 'Please agree to the terms before proceeding.';
			}
			// Prevent errors if locale section is not defined.
			Language.InfoXMC = Language.InfoXMC || {};

			// Sample locale section.target for this XMC: InfoXMC.id_info_mc_copy
			$scope.agreed = false;
			$scope.title = Language.getLocale('InfoXMC', _localeTarget + 'title');
			$scope.copy = Language.getLocale('InfoXMC', _localeTarget + 'copy');
			$scope.disclaimer = Language.getLocale('InfoXMC', _localeTarget + 'check_box_one');
			if (Language.localeExists('InfoXMC', _localeTarget + 'type')) {
				$scope.infoType = Language.getLocale('InfoXMC', _localeTarget + 'type');
			} else {
				$scope.infoType = "info-new";
			}
		} )();

		function getLocaleTarget() {
			var item = Package.packageDetails;

			if(Utilities.safelyCheckPropertyOnObject('item.CHARACS.locale_for_info_XMC', item)){
				_localeTarget = item.CHARACS.locale_for_info_XMC + '_';
			} else {
				_localeTarget =  Package.settings.name + '_';
			};

		}

		$scope.nextXFC = function(){
			if( isValid() ){
				// Add reference of XFC to CHARACs.
				ExtraFlow.addReferenceToCartItems( Package.settings.view, Package.itemsToBeAdded, ExtraFlow.CLIENT_XFC_VIEW );
				ExtraFlow.addReferenceToCartItems( Package.settings.name, Package.itemsToBeAdded, ExtraFlow.CLIENT_XFC_NAME );

				Package.nextXFC(true);
			} else {
				Modal.displayModal
					(
						{ category: Package.settings.name
						, action: 'Error'
						, label: 'Failed to Agree'
						, title: Language.getLocale('Alert', 'infoXMCAgreeToTermsTitle')
						, description: Language.getLocale('Alert', 'infoXMCAgreeToTermsMsg')
						}
					);
			}
		}

		$scope.cancel = function(){
			// Handle the cancel button clicked.
			Package.cancelXFC();
		}

		function isValid(){
			if( $scope.disclaimer ){
				return $scope.agreed;
			}

			return true;
		}
	}
);

angular.module('license-plate-capture', [
	'errorTracking', 'app'
]).config(function( $stateProvider ){

	$stateProvider
		.state('/licensePlateCapture/:packageId', {
			url: '/licensePlateCapture/:packageId',
			templateUrl: '/scripts/modules/extraflow/license-plate-capture/views/license-plate-capture.html',
			controller: 'LicensePlateCaptureController',
			resolve: {
				load: function( $rootScope, Utilities ){

					$rootScope.showSpinner();

					return Utilities.cacheBustAndLazyLoad([
						'/scripts/modules/extraflow/license-plate-capture/controllers/license-plate-capture-controller.js',
						'/scripts/modules/extraflow/license-plate-capture/services/license-plate-capture-service.js'
					]);
				},
				initialData: function( load, Bootstrap ){
					return Bootstrap.bootstrapApplication();
				},
				xfcMap: function( initialData, Package ){
					return Package.buildXFCMap();
				}
			}
		});
}).run(function( ExtraFlow, Enums ){

	ExtraFlow.registerXMC(
		'license_plate_capture'
		, { name: 'license_plate_capture'
			, view: Enums.extraFlowRoutes.LICENSEPLATECAPTURE
			, doEditMode: false
			, enabled: true
			, writeSingleCharac: false
			, type: 'extraFlowControl'
		});
});

angular
	.module('participant-program', [
		'errorTracking', 'app'
	])
	.config(function($stateProvider) {
		$stateProvider
			.state('/participantProgram/:packageId', {
				url: '/participantProgram/:packageId',
				templateUrl: '/scripts/modules/extraflow/participant-program/views/participant-program.html',
				controller: 'ParticipantProgramController',
				resolve: {
					load: function($rootScope, Utilities) {
						$rootScope.showSpinner();
						return Utilities.cacheBustAndLazyLoad([
							'/scripts/modules/extraflow/participant-program/controllers/participant-program-controller.js',
							'/scripts/modules/extraflow/participant-program/directives/participant-form-directive.js',
							'/scripts/modules/extraflow/participant-program/services/participant-program-service.js',
							'/scripts/modules/extraflow/participant-program/services/participant-type-service.js'
						]);
					},
					initialData: function(Bootstrap) {
						return Bootstrap.bootstrapApplication();
					},
					xfcMap: function(initialData, Package) {
						return Package.buildXFCMap();
					}
				}
			});
	})
	.run(function(ExtraFlow, Enums) {
		ExtraFlow
			.registerXMC(
				'dolphin_participant', {
					aliases: ['dolphin_participant_meal', 'sid_participant', 'tfad_participant', 'tfad_participant_dynamic'],
					name: 'dolphin_participant',
					view: Enums.extraFlowRoutes.PARTICIPANT_PROGRAM,
					enabled: true,
					doEditMode: true,
					lockQuantity: true
				});
	});
angular
	.module('reservations', [
		'errorTracking', 'app'
	])
	.config(function($stateProvider) {
		$stateProvider
			.state('/reservations/:packageId', {
				url: '/reservations/:packageId',
				templateUrl: '/scripts/modules/extraflow/reservations/views/reservations.html',
				controller: 'ReservationsController',
				resolve: {
					load: function($rootScope, Utilities) {
						$rootScope.showSpinner();
						return Utilities.cacheBustAndLazyLoad([
							'/scripts/modules/extraflow/reservations/controllers/reservations-controller.js'
						]);
					},
					initialData: function( Bootstrap ){
						return Bootstrap.bootstrapApplication();
					},
					xfcMap: function( initialData, Package ){
						return Package.buildXFCMap();
					}
				}
			});
	})
	.run(function(ExtraFlow, Enums) {

		ExtraFlow
			.registerXMC(
				'sp_reservation', {
					name: 'sp_reservation',
					view: Enums.extraFlowRoutes.RESERVATIONS,
					widgetCharacs: 'rv_first_name, rv_last_name',
					pillDataField: 'rv_first_name',
					doEditMode: false,
					writeSingleCharac: false,
					enabled: true,
					type: 'extraFlowControl'
				});
	});

/* eslint-disable sort-keys */
angular
	.module('scheduling', ['app'])
	.config(function($stateProvider) {
		'use strict';

		var MODULE_DIR = '/scripts/modules/extraflow/scheduling';
		var DEFAULT_FILES = [
			MODULE_DIR + '/services/scheduling-utilities-service.js',
			MODULE_DIR + '/services/scheduling-request-service.js',
			MODULE_DIR + '/services/scheduling-finalize-service.js',
			MODULE_DIR + '/controllers/scheduling-controller.js',
			MODULE_DIR + '/controllers/scheduling-combo-controller.js',
			MODULE_DIR + '/styles/scheduling-combo.css'
		];

		$stateProvider
			.state('scheduling', {
				controller: 'SchedulingController',
				templateUrl: '/scripts/modules/extraflow/scheduling/views/scheduling.html',
				url: '/scheduling/:packageId',
				resolve: {
					initialData: initialData,
					loadAssets: loadAssets
				}
			})
			.state('scheduling-combo', {
				controller: 'SchedulingComboController',
				components: ['cartFeeNotice'],
				templateUrl: '/scripts/modules/extraflow/scheduling/views/scheduling-combo.html',
				url: '/scheduling-combo/:packageId',
				title: 'schedulingCombo',
				resolve: {
					initialData: initialData,
					loadAssets: loadAssets,
					xfcMap: function(loadAssets, Package) {
						return Package.buildXFCMap();
					},
					initXFC: function(xfcMap, RouteRejectionService, Package, $transition$) {
						var rejectionRoute = Package.assessRoutabilityOfXFC($transition$.params().packageId);
						if (rejectionRoute.length) {
							throw new RouteRejectionService.UnrecoverableException(rejectionRoute);
						}
					},
					parentPackages: function(initXFC, SchedulingPrepService) {
						return SchedulingPrepService.getParentPackages();
					},
					summary: function(parentPackages, SchedulingPrepService) {
						return SchedulingPrepService.getSummary(parentPackages);
					},
					times: function(summary, parentPackages, SchedulingPrepService) {
						return SchedulingPrepService.requestPackages(parentPackages);
					},
					schedulingCategories: function(initXFC, times, parentPackages, SchedulingPrepService, Enums) {
						// E2e flow returns SchedulingObjects directly, legacy flow needs transformation
						if (SchedulingPrepService.getServiceRequest() === Enums.services.GET_MERCHANT_PACKAGE_EVENT_DATES) {
							return times;
						}
						return SchedulingPrepService.getSchedulingCategories(parentPackages, times);
					}
				}
			});

		/**
		 * Bootstraps the application
		 * @param {Scope} $rootScope $rootScope
		 * @param {Service} Bootstrap Bootstrap
		 * @returns {Promise} to bootstrap
		 * @ngInject
		 */
		function initialData($rootScope, Bootstrap) {
			$rootScope.showSpinner();
			return Bootstrap.bootstrapApplication(undefined, true);
		}

		/**
		 * Loads the XFC's assets
		 * @param {Promise} initialData The intial data resolver
		 * @param {Servicer} Utilities Utilities
		 * @returns {Promise} to load the assets required
		 * @ngInject
		 */
		function loadAssets(initialData, Utilities) {
			return Utilities.cacheBustAndLazyLoad(DEFAULT_FILES);
		}
	})
	.run(function(ExtraFlow, SchedulingPrepService) {
		'use strict';

		ExtraFlow.registerXMC('scheduling', {
			doEditMode: false,
			enabled: true,
			name: 'scheduling',
			type: 'extraFlowControl',
			view: 'scheduling'
		});

		ExtraFlow.registerXMC('scheduling_combo', {
			doEditMode: false,
			enabled: true,
			name: 'scheduling_combo',
			type: 'extraFlowControl',
			view: 'scheduling-combo'
		});

		SchedulingPrepService.setupAppActivatedListener();
	});

/**
 * Created by dsmith on 12/24/2014.
 */
angular.module( 'scheduling' )
	.service( 'SchedulingModels'
	, function($filter) {

		var SchedulingObject = function( pkg, cost, isDynamic ) {

			this.selectedTime = null;
			this.conflicting = false;
			this.cost = cost || 0;
			this.swappedPackage = '';
			this.name = pkg.name;
			this.desc = pkg.desc;
			this.image = pkg.shop_image_v4;
			this.isDynamic = !!isDynamic;

			var packageInfo = pkg;
			var duration = 0;
			var times = [];

			this.getName = function() {
				return this.name;
			};

			this.getDesc = function() {
				return this.desc;
			};

			this.getImage = function () {
				return this.image;
			};

			this.getDuration = function() {
				return duration;
			};

			this.setDuration = function( value ) {
				duration = (!isNaN(value)) ? value : 0;
			};

			this.getPackageInfo = function() {
				return packageInfo;
			};

			this.setPackageInfo = function(newPackageInfo) {
				packageInfo = newPackageInfo;
			};

			this.getTimes = function() {
				return times || [];
			};

			this.setTimes = function (data) {
				if(!angular.isArray(data)) {
					data = [ data ];
				}

				times = data;
			};
		};

		this.SchedulingObject = SchedulingObject;

		function CustomerTypeSummary(displayName, qty, cost, id, gatePrice) {
			this.displayName = displayName;
			this.qty = Number(qty) || 0;
			this.cost = Number(cost) || 0;
			this.baseCost = Number(cost) || 0;
			this.displayCost = $filter('currencyFormatter')(this.cost);
			this.id = id;
			this.baseGatePrice = Number(gatePrice) || 0;
			this.gatePrice = Number(gatePrice) || 0;

		}

		this.CustomerTypeSummary = CustomerTypeSummary;

		function Summary(customerTypes, cost, useVat, savings, qty, date) {
			this.customerTypes = customerTypes;
			this.baseCost = cost;
			this.cost = cost;
			this.displayCost = $filter('currencyFormatter')(this.cost);
			this.useVat = useVat;
			this.baseSavings = savings;
			this.savings = savings;
			this.displaySavings = $filter('currencyFormatter')(this.savings);
			this.totalQty = qty;
			this.date = date;
			this.displayDate = $filter('date')(this.date, 'fullDate');
		}

		this.Summary = Summary;

	} );

angular
	.module('scheduling')
	.service('SchedulingPrepService', function(
		AppData,
		CustomActionService,
		DynamicCapacityPricingService,
		Enums,
		Package,
		OneBarcodeUtilities,
		SchedulingModels,
		Utilities,
		UtilsValidation,
		RouteRejectionService,
		$filter,
		$injector,
		$log,
		$q,
		$rootScope,
		$state,
		$stateParams
	) {
		'use strict';
		var listener = undefined,
			validString = UtilsValidation.validString,
			validArray = UtilsValidation.validArray,
			checkProp = Utilities.safelyCheckPropertyOnObject,
			toArray = Utilities.wrapObjectToArray;

		/**
		 * @description - Configure some startup scheduling actions - custom action must be registered here in case guest refreshes with scheduling items in the cart at any point during flow
		 * @private
		 * @returns {undefined}
		*/
		function configureSchedulingActions() {
			//register a custom action listener if the scheduling module combo is configured on this merchant
			if (angular.isDefined(AppData.settings.scheduling_combo)) {
				CustomActionService.registerCustomActionForChain(CustomActionService.ACTIONS_ENUMS.ON_UPDATE_CART_ITEMS, swapPackageIfRemovedForUpdatedItems);
			}
			//turn off the listener
			listener();
		}

		/**
		 * Creates the appropriate request object based on the service type
		 * @private
		 * @param {String} requestType - The service type to use
		 * @param {Object[]} parentPackages - Array of parent packages
		 * @param {String} currentKeyword - The keyword for the request
		 * @param {String} requestDateString - The date string for the request
		 * @returns {Object} The formatted request object for the specified service type
		 */
		function createRequestObject(requestType, parentPackages, currentKeyword, requestDateString) {
			if (requestType === Enums.services.GET_MERCHANT_PACKAGE_EVENT_DATES) {
				// For e2e Passport clients, send the correct request format that the API expects
				var allPkgs = Package.getPackagesByKeyword(currentKeyword),
					pkgsToRequest = Package.filterByParentPackages(allPkgs);

				var P = pkgsToRequest.map(function mapStubPackage(stubPkg) {
					var fullPkg = Package.getPackageByID(stubPkg.id),
						eventId = fullPkg.E && fullPkg.E.id;

					if (!eventId) {
						$log.warn('SchedulingPrepService: missing event_id on package', stubPkg.id, fullPkg);
					}

					// Find customer types specific to this package, fallback to all if none match
					var packageMatches = parentPackages.filter(function findMatchingPackage(pp) {
						return (pp.package_id || pp.id) === stubPkg.id;
					});

					var sourcePackages = packageMatches.length ? packageMatches : parentPackages,
						CT = sourcePackages.map(function mapCustomerType(pp) {
						return { id: pp.customer_type, qty: pp.qty };
					});

					return {
						id: stubPkg.id,
						event_id: eventId,
						CT: CT
					};
				});

				/* eslint-disable camelcase */
				return {
					P: P,
					endDate: requestDateString,
					extraMovie: Package.settings.name,
					minCapacity: parentPackages.reduce(function sumQuantities(sum, pp) { return sum + pp.qty; }, 0),
					startDate: requestDateString,
					version: '2'
				};
				/* eslint-enable camelcase */
			}
				// Siriusware flow for combo clients
				var requestObj = { keyword: currentKeyword };

				if (requestDateString) {
					/* eslint-disable camelcase */
					requestObj.end_date = requestDateString;
					requestObj.start_date = requestDateString;
					/* eslint-enable camelcase */
				}

				return requestObj;
		}

		/**
		 * Creates a SchedulingObject with times for the scheduling UI
		 * @private
		 * @param {Object} oneBarcodePackage - The oneBarcode package object
		 * @param {Object[]} times - Array of time objects for this package
		 * @param {Object[]} parentPackages - Array of parent packages for context
		 * @param {String} packageId - The package ID
		 * @returns {Object} SchedulingObject instance formatted for scheduling UI
		 */
		function createSchedulingObjectWithTimes(oneBarcodePackage, times, parentPackages, packageId) {
			var validCustomerTypes = getValidCustomerTypes(parentPackages, oneBarcodePackage),
				cost = 0,
				schedulingObject,
				packageForTimes,
				formattedTimes;

			// Calculate cost
			validCustomerTypes.forEach(function findCost(customerType) {
				parentPackages.forEach(function calculatePackageCost(parentPkg) {
					if (parentPkg.customer_type === customerType.id) {
						cost += parentPkg.qty * customerType.retail_amount;
					}
				});
			});

			// Create SchedulingObject
			schedulingObject = new SchedulingModels.SchedulingObject(oneBarcodePackage, cost);

			// Set optional properties
			if (oneBarcodePackage.CHARACS && oneBarcodePackage.CHARACS.timeDuration) {
				schedulingObject.setDuration(oneBarcodePackage.CHARACS.timeDuration);
			}

			if (oneBarcodePackage.desc) {
				schedulingObject.setPackageInfo(oneBarcodePackage);
			}

			// Set customer_type on package info for conflict validation
			var compPackage = schedulingObject.getPackageInfo();
			if (checkProp('parentPackages.0.customer_type', parentPackages, Utilities.returnValue)) {
				compPackage.customer_type = parentPackages[0].customer_type;
			}

			// Build package with times for legacy getTimes function
			packageForTimes = angular.copy(oneBarcodePackage);

			if (validArray(packageForTimes.CT)) {
				packageForTimes.CT.forEach(function loopOverCT(customerType) {
					customerType.A = times.map(function mapTimeData(timeData, index) {
						var timeSlotId = timeData.externalId || timeData.id || (timeData.minutes + '_' + timeData.time);

						return {
							available: timeData.available || timeData.capacity,
							id: packageId + '_' + timeSlotId + '_' + index,
							start: timeData.time
						};
					});
				});
			}

			// Format times and set on SchedulingObject
			formattedTimes = getTimes([packageForTimes], parentPackages);

			if (validArray(formattedTimes)) {
				schedulingObject.setTimes(formattedTimes);
				setTimeInterval(formattedTimes, schedulingObject, parentPackages);
			}

			return schedulingObject;
		}

		/**
		 * @description- Get the customer type IDs from the parent packages.
		 * @param {Object[]} parentPackages - The array of parent packages.
		 * @returns {Object[]} An array of customer type IDs from the parent packages.
		 * @private
		*/
		function getCustomerTypeIds(parentPackages) {
			var customerTypesIds = [];
			for (var p in parentPackages) {
				if (parentPackages[p].customer_type) {
					customerTypesIds.push(parentPackages[p].customer_type);
				}
			}
			return customerTypesIds;
		}

		/**
		 * @description - Get the available times for a given package and its parent packages.
		 * @param {Object[]} p - The array of packages to get times for.
		 * @param {Object[]} parentPackages - The array of parent packages.
		 * @returns {Object[]} An array of available times for the given package.
		 * @private
		 * @throws {RouteRejectionService.ViewException} If no times are available for the package.
		 */
		function getTimes(p, parentPackages) {
			if (validArray(p)) {
				var pkg = p[0];
				var times = [];
				var removeAvailability = [];
				pkg.CT = toArray(pkg.CT, true);
				if (validArray(pkg.CT)) {
					var validCustomerTypes = getValidCustomerTypes(parentPackages, pkg);
					//TODO: If a client that does not use Sirusware requests this functionality, we will need to update the logic
					//to ensure that we are also checking that the availability's times are are the same for all customer types
					//in the validCustomerTypes array. Since we are only interfacing with Sirusware currently, we are able to
					//assume that all available times brought back on each customer type are going to be the same, but if we are to
					//use this internally, we would not be able to assume that any longer.
					for (var i = 0; i < validCustomerTypes.length; i++) {
						var currentCT = validCustomerTypes[i];
						var currentParentPackage = parentPackages.filter(function findMatchingCustomerType(item) {
							return item.customer_type == currentCT.id
						})[0];
						//currentCT.A is the array of available times from the GetKeywordComboCreator call for that specific customer
						//type within an available package.
						if (angular.isDefined(currentCT.A) && angular.isDefined(currentParentPackage)) {
							if (!angular.isArray(currentCT.A)) {
								currentCT.A = [currentCT.A];
							}
							for (var a in currentCT.A) {
								var availability = currentCT.A[a];
								if (availability.available >= currentParentPackage.qty) {
									var timeObj = {
										time: availability.start,
										id: availability.id,
										available: availability.available,
										used: currentParentPackage.qty
									};
									var found = times.filter(function findExistingTime(item){return item.id == timeObj.id });
									if (!found.length) {
										times.push(timeObj);
									} else {
										found[0].used += Number(timeObj.used);
										if (found[0].used > Number(found[0].available)) {
											removeAvailability.push(found[0].id);
										}
									}
								} else {
									removeAvailability.push(availability.id);
								}
							}
						} else {
							//No times available
							throw new RouteRejectionService.ViewException();
						}
					}
					for (var ra in removeAvailability) {
						var index = times.filter(function findTimeToRemove(item){return item.id == removeAvailability[ra] });
						if (index.length) {
							times.splice(times.indexOf(index[0]), 1);
						}
					}
				}

				return times
			}
		}

		/**
		 * @description- Get the valid customer types for a given package based on the parent packages.
		 * @param {Object[]} parentPackages - The array of parent packages.
		 * @param {Object} pkg - The package to get valid customer types for.
		 * @private
		 * @returns {Object[]} An array of valid customer types for the given package.
		*/
		function getValidCustomerTypes(parentPackages, pkg) {
			var validCustomerTypes = [];
			var customerTypesIds = getCustomerTypeIds(parentPackages);
			for (var ct in customerTypesIds) {
				var validCT = pkg.CT.filter(function filterByCustomerTypeId(item) {
					return (angular.isDefined(item.id)) && item.id == customerTypesIds[ct]
				});
				if (validArray(validCT)) {
					validCustomerTypes.push(validCT[0]);
				}
			}
			return validCustomerTypes;
		}

		/**
		 * Processes the API response based on the service type used
		 * @private
		 * @param {Object} data - The raw API response data
		 * @param {String} requestType - The service type that was used
		 * @param {Object[]} parentPackages - Array of parent packages for context
		 * @returns {Object[]} Processed data array suitable for scheduling UI
		 */
		function processApiResponse(data, requestType, parentPackages) {
			if (requestType === Enums.services.GET_MERCHANT_PACKAGE_EVENT_DATES) {
				// Store raw data and handle non-OK responses gracefully
				// Note: Cannot use 'this._rawApiResponse' in private function

				if (data.status !== Enums.status.OK) {
					return [];
				}

				// Normalize response and transform for e2e flow
				var DataModelService = $injector.get('DataModelService');
				var GetMerchantPackageEventDatesModel = $injector.get('GetMerchantPackageEventDatesModel');
				var normalizedData = DataModelService.convert(data, GetMerchantPackageEventDatesModel);

				if (normalizedData.status === Enums.status.OK && validArray(normalizedData.dates)) {
					return transformE2EResponseData(normalizedData, parentPackages);
				}

				return [];
			}

			// Legacy flow: validate response and extract package data
			if (data.status === Enums.status.OK && Utilities.checkProp('data.DATES.D.PS.P', data)) {
				return toArray(angular.copy(data).DATES.D.PS.P);
			}

			Package.cancelXFC();
			throw new RouteRejectionService.ViewException('Alert', 'generalErrorTitle', 'noDates', $state.current.url, $stateParams);
		}

		/**
		 * Makes individual API calls for each package to get package-specific times
		 * @private
		 * @param {Object[]} parentPackages - Array of parent packages
		 * @param {String} currentKeyword - The keyword for the request
		 * @param {String} requestDateString - The date string for the request
		 * @returns {Promise<Object[]>} Promise that resolves to transformed data for all packages
		 */
		function requestIndividualPackageTimes(parentPackages, currentKeyword, requestDateString) {
			var allPkgs = Package.getPackagesByKeyword(currentKeyword),
				pkgsToRequest = Package.filterByParentPackages(allPkgs);

			var packagePromises = pkgsToRequest.map(function mapSinglePackage(stubPkg) {
				return requestSinglePackageTimes(stubPkg, parentPackages, requestDateString);
			});

			return $q.all(packagePromises).then(
				function handleSuccess(results) {
					var allTransformedData = [];

					results.forEach(function collectValidResults(packageResult) {
						if (validArray(packageResult)) {
							allTransformedData = allTransformedData.concat(packageResult);
						}
					});

					return allTransformedData;
				},
				function handleError() {
					Package.cancelXFC();
					throw new RouteRejectionService.ViewException('Alert', 'generalErrorTitle', 'noDates', $state.current.url, $stateParams);
				}
			);
		}

		/**
		 * Makes a single GetMerchantPackageEventDates API call for one specific package
		 * @private
		 * @param {Object} stubPkg - The package stub to request times for
		 * @param {Object[]} parentPackages - Array of parent packages for context
		 * @param {String} requestDateString - The date string for the request
		 * @returns {Promise<Object[]>} Promise that resolves to transformed data for this package
		 */
		function requestSinglePackageTimes(stubPkg, parentPackages, requestDateString) {
			var fullPackage = Package.getPackageByID(stubPkg.id),
				eventId = fullPackage.E && fullPackage.E.id;

			// Early return if no event ID is found
			if (!eventId) {
				return $q.resolve([]);
			}

			// Find packages matching the current stub package ID for customer type context
			var matchingParentPackages = parentPackages.filter(function findMatchingPackages(parentPkg) {
				return String(parentPkg.package_id || parentPkg.id) === String(stubPkg.id);
			});

			// Build customer type array - use matches if found, otherwise use all parent packages
			var customerTypes = matchingParentPackages.length
				? matchingParentPackages.map(function mapMatchingPackages(pkg) {
					return { id: pkg.customer_type, qty: pkg.qty };
				})
				: parentPackages.map(function mapAllParentPackages(pkg) {
					return { id: pkg.customer_type, qty: pkg.qty };
				});

			// Calculate total capacity requirement across all parent packages
			var totalCapacity = parentPackages.reduce(function calculateCapacity(sum, pkg) {
				return sum + pkg.qty;
			}, 0);

			// Build API request object for single package timing request
			var requestObject = {
				P: [{
					id: stubPkg.id,
					event_id: eventId,
					CT: customerTypes
				}],
				endDate: requestDateString,
				extraMovie: Package.settings.name,
				minCapacity: totalCapacity,
				startDate: requestDateString,
				version: '2'
			};

			return AppData.fetch(
				Enums.services.GET_MERCHANT_PACKAGE_EVENT_DATES,
				false,
				requestObject
			).then(
				function handleSuccessfulResponse(data) {
					if (data.status === Enums.status.OK) {
						var schedulingObjects = processApiResponse(data, Enums.services.GET_MERCHANT_PACKAGE_EVENT_DATES, parentPackages);
						return fetchDynamicPrices(schedulingObjects, requestDateString, parentPackages);
					}
					// Handle non-OK status (e.g., "No Dates Available") gracefully for e2e flow
					return [];
				},
				function handleApiError(error) {
					// Handle network/API errors gracefully for e2e flow
					return [];
				}
			);
		}

		/**
		 * Fetches dynamic prices for scheduling objects if they are configured as dynamic
		 * @private
		 * @param {Object[]} schedulingObjects - Array of SchedulingObjects
		 * @param {String} requestDateString - The date being requested
		 * @param {Object[]} parentPackages - Array of parent packages
		 * @returns {Promise<Object[]>} Promise resolving to updated scheduling objects
		 */
		function fetchDynamicPrices(schedulingObjects, requestDateString, parentPackages) {
			var promises = schedulingObjects.map(function(schedObj) {
				var pkg = schedObj.getPackageInfo(),
					times, timeList, ctIds, dateToUse;

				if (!pkg || !DynamicCapacityPricingService.isPackageDynamic(pkg.id)) {
					return $q.resolve(schedObj);
				}

				// Mark as potentially dynamic, pending successful fetch
				schedObj.isDynamic = true;

				// Get times to request
				times = schedObj.getTimes();
				if (!validArray(times)) {
					return $q.resolve(schedObj);
				}

				timeList = times.map(function(t) { return t.time; }).join(',');
				ctIds = getCustomerTypeIds(parentPackages);
				// Use parent package start_date for the request
				dateToUse = Utilities.javascriptDateToSQLDate(new Date(requestDateString.replace(/-/g, '/')));

				return DynamicCapacityPricingService.fetchLivePricing(
					pkg.id,
					dateToUse,
					timeList,
					ctIds
				).then(function(pricingData) {
					var data = pricingData;
					// Standardize format to array
					if (UtilsValidation.validObject(data) && !validArray(data)) {
						data = [{
							pricing: data,
							time: times[0].time
						}];
					}

					if (validArray(data)) {
						times.forEach(function(timeObj) {
							var matchingPrice = data.find(function(p) { return p.time === timeObj.time; }),
								cost = 0, validCTs;

							if (matchingPrice && matchingPrice.pricing) {
								timeObj.pricing = matchingPrice.pricing;

								// Calculate total cost for this time slot based on parent quantities
								validCTs = getValidCustomerTypes(parentPackages, pkg);
								validCTs.forEach(function(ct) {
									var pp;

									pp = parentPackages.find(function(p) { return p.customer_type == ct.id; });

									// Fallback to static price if dynamic price missing for specific CT
									if (matchingPrice.pricing[ct.id] && matchingPrice.pricing[ct.id].price !== undefined) {
										cost += pp.qty * matchingPrice.pricing[ct.id].price;
									} else {
										cost += pp.qty * Utilities.getTotalPrice(ct);
									}
								});
								timeObj.cost = cost;
							}
						});
					}

					return schedObj;
				}, function(error) {
					// Fallback to static pricing on error
					schedObj.isDynamic = false;
					return schedObj;
				});
			});

			return $q.all(promises);
		}

		/**
		 * Set the time interval for each time in the times array.
		 * @param {Object[]} times - The array of times to set the interval for.
		 * @param {Object} schedulingObject - The scheduling object containing package information.
		 * @param {Object[]} parentPackages - The array of parent packages.
		 * @returns {undefined}
		 * @throws {RouteRejectionService.ViewException} If the scheduling package is missing the necessary timeblock_overrides or timeblock_interval.
		*/
		function setTimeInterval(times, schedulingObject, parentPackages) {
			var formatString = Utilities.getTimeFormat(AppData.settings);
			var schedulingPackage = schedulingObject.getPackageInfo();
			var timeblockInterval = parseFloat(schedulingPackage.CHARACS.timeblock_interval) || 0;

			for (var k = 0; k < times.length; k++) {
				var t = times[k];
				t.startTime = Utilities.dateStringToObject(parentPackages[0].CHARACS[0].start_date, t.time);
				t.endTime = new Date(t.startTime.getTime() + timeblockInterval * 60000);
				if (t.startTime.getTime() === t.endTime.getTime()) {
					t.displayTime = $filter('date')(t.startTime, formatString);
				} else {
					t.displayTime = $filter('date')(t.startTime, formatString) + ' - ' + $filter('date')(t.endTime, formatString);
				}
			}
		}

		/**
		 * Assess swapping back to the original parent package if a child swap required package is removed from the cart
		 * @param itemsToBeUpdated
		 */
		function swapPackageIfRemovedForUpdatedItems(itemsToBeUpdated){

			var parentSwapSchedulingItems =  itemsToBeUpdated.filter(function findParentSwapItems(item){
				return angular.isDefined(item.CHARACS) && item.CHARACS.filter(function filterSwapCharacteristics(charac){return Utilities.getBoolean(charac.one_barcode_parent)
						&& angular.isDefined(charac.group_uuid)
						&& Utilities.getBoolean(charac.scheduling_combo_swap_indicator)}).length >0
			});
			for(var i = 0; i < parentSwapSchedulingItems.length; i++){

				var parentItem = parentSwapSchedulingItems[i];
				var parentGroupUUID = parentItem.CHARACS[0].group_uuid;
				var parentPreswapPackageId = parentItem.CHARACS[0].preswap_package_id;
				var requiredChildItemsForSwap = itemsToBeUpdated.filter(function hasMatchingSwapCharacteristics(item) {
					return item.CHARACS && item.CHARACS.filter(function isRequiredSwapChild(charac) {
						return charac.group_uuid && charac.group_uuid === parentGroupUUID
							&& charac.scheduling_combo_swap_pkg_id
							&& !Utilities.getBoolean(charac.one_barcode_parent);
					}).length > 0;
				});

				//if we have no required child items for keeping the swapped package then we must return the parent package to the preswapped package id
				if (requiredChildItemsForSwap.length === 0 && angular.isDefined(parentPreswapPackageId)) {

					parentItem.package_id = parentPreswapPackageId;

				}

			}

		}

		/**
		 * Transforms e2e API response data into SchedulingObjects for the scheduling UI
		 * @private
		 * @param {Object} normalizedData - The normalized response from GetMerchantPackageEventDates
		 * @param {Object[]} parentPackages - Array of parent packages for context
		 * @returns {Object[]} Array of SchedulingObject instances
		 */
		function transformE2EResponseData(normalizedData, parentPackages) {
			var OneBarcodeUtilities = $injector.get('OneBarcodeUtilities'),
				availableOneBarcodePackages = OneBarcodeUtilities.performPackageLookup(),
				transformedData = [];

			normalizedData.dates.forEach(function processDateData(dateData) {
				var packageId = dateData.package_id || (dateData.package && dateData.package.id);

				if (!packageId) {
					return;
				}

				var oneBarcodePackage = availableOneBarcodePackages.find(function findMatchingId(p) {
					return p.id == packageId;
				});

				if (!oneBarcodePackage) {
					$log.warn('SchedulingPrepService: no oneBarcodePackage found for package_id', packageId);
					return;
				}

				var schedulingObject = createSchedulingObjectWithTimes(
					oneBarcodePackage,
					dateData.times,
					parentPackages,
					packageId
				);
				transformedData.push(schedulingObject);
			});

			return transformedData;
		}

		/**
		 * Compresses packages by combining those with matching package_id and customer type (client_rate_name).
		 * When duplicates are found, quantities are summed and CHARACS arrays are merged.
		 * @private
		 * @param {Object[]} pkgs - Array of package objects to compress
		 * @returns {Object[]} Array of compressed packages with combined quantities and merged CHARACS
		 */
		function compressPackagesByCustomerType(pkgs) {
			var grouped = {};

			pkgs.forEach(function groupByCTandPackageId(item) {
				var key = item.package_id + '|' + item.client_rate_name;

				if (grouped[key]) {
					grouped[key].qty += item.qty;
					grouped[key].CHARACS = grouped[key].CHARACS.concat(item.CHARACS);
				} else {
					// Clone the item to avoid mutating the original
					grouped[key] = Object.assign({}, item, {
						CHARACS: item.CHARACS.slice()
					});
				}
			});

			return Object.values(grouped);
		}

		/***********************************
		 ** ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ **
		 ** ~ P U B L I C ~ M E T H O D S **
		 ** ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ **
		 ***********************************/

		/**
		* Retrieves the parent packages that are to be added for the current package.
		* Ensures that the necessary characteristics (CHARACS) are present on each package.
		* If any package is missing required characteristics, a view exception is thrown.
		* @public
		* @function
		* @name getParentPackages
		* @memberof {SchedulingPrepService}
		* @returns {Object[]} A copy of the array of parent packages to be added for the current package.
		* @throws {RouteRejectionService.ViewException} If any package is missing 'oneBarcodeKeyword' or 'start_date' characs.
		*/
		this.getParentPackages = function() {
			let currentPackages = Package.itemsToBeAddedForCurrentPackage();
			currentPackages = compressPackagesByCustomerType(currentPackages);

			if (validArray(currentPackages)) {
				// Filter out any child packages that may have been added from a previous pass
				currentPackages = currentPackages.filter(function(pkg) {
					var characs = pkg.CHARACS && pkg.CHARACS[0];
					return !(characs && characs.combo_creator_addon === 'true');
				});

				for (var i = 0; i < currentPackages.length; i++) {
					var currentPackage = currentPackages[i];
					//Ensure that CHARACS are on the package and then check for the necessary characs for this functionality.
					if (validArray(currentPackage.CHARACS)) {
						if (angular.isUndefined(currentPackage.CHARACS[0].oneBarcodeKeyword) || angular.isUndefined(currentPackage.CHARACS[0].start_date)) {
							throw new RouteRejectionService.ViewException();
						}
					} else {
						throw new RouteRejectionService.ViewException();
					}
				}

				//If we have gone through all current items and none of them are missing the necessary characs, return the array
				//we should never be altering the real itemsToBeAdded until we are done finalizing the XFC - so we provide a copy
				return angular.copy(currentPackages);
			}
		};

		/**
		 * Calculates price breakdown by customer type for a specific package
		 * @param {Object} pkg - The package to calculate prices for
		 * @param {Object[]} parentPackages - Array of parent packages containing quantities and customer types
		 * @returns {Object[]} Array of objects containing customer type price breakdowns
		 */
		this.getPriceBreakdownByCT = function(pkg, parentPackages) {
			var breakdowns = [];
			var pkgInfo = pkg.getPackageInfo();

			if (!pkgInfo || !pkgInfo.CT || !parentPackages) {
				return breakdowns;
			}

			var validCustomerTypes = getValidCustomerTypes(parentPackages, pkgInfo);

			for (var i = 0; i < validCustomerTypes.length; i++) {
				var ct = validCustomerTypes[i];
				var parentPackage = parentPackages.filter(function findParentPackageByCustomerType(pp) {
					return pp.customer_type === ct.id;
				})[0];

				if (parentPackage) {
					var retailAmount = Utilities.getTotalPrice(ct);

					breakdowns.push({
						name: parentPackage.client_rate_name,
						price: retailAmount * parentPackage.qty,
						unitPrice: retailAmount,
						qty: parentPackage.qty
					});
				}
			}

			return breakdowns;
		};

		/**
		* Retrieves scheduling categories based on the provided parent packages and data.
		* This function processes packages, groups them into categories, calculates costs, durations, and times,
		* and returns an array of scheduling categories.
		*
		* @public
		* @function
		* @name getSchedulingCategories
		* @memberof {SchedulingPrepService}
		* @param {Object[]} parentPackages - An array of parent packages to be used for scheduling.
		* @param {Object[]} data - An array of package times data.
		* @returns {Object[]} An array of scheduling categories, each containing scheduling objects grouped by category.
		*/
		this.getSchedulingCategories = function (parentPackages, data) {
			var oneBarcodePackages = OneBarcodeUtilities.performPackageLookup(),
				packageTimes = data,
				schedulingPackages = [];

			for (var i = 0; i < oneBarcodePackages.length; i++) {
				var currentPackage = oneBarcodePackages[i],
					validCustomerTypes = getValidCustomerTypes(parentPackages, currentPackage),
					cost = 0;

				for (var ct in validCustomerTypes) {
					for (var p in parentPackages) {
						if (parentPackages[p]['customer_type'] == validCustomerTypes[ct].id) {
							var retailAmount = Utilities.getTotalPrice(validCustomerTypes[ct]);
							cost += parentPackages[p].qty * retailAmount;
						}
					}
				}

				var schedulingObject = new SchedulingModels.SchedulingObject(currentPackage, cost);

				if (angular.isDefined(currentPackage.CHARACS.timeDuration)) {
					schedulingObject.setDuration(currentPackage.CHARACS.timeDuration);
				}

				// Set the description if it exists
				if (angular.isDefined(currentPackage.desc)) {
					schedulingObject.setPackageInfo(currentPackage);
				}

				// Set customer_type on package info for conflict validation
				var compPackage = schedulingObject.getPackageInfo();
				if (checkProp('parentPackages.0.customer_type', parentPackages, Utilities.returnValue)) {
					compPackage.customer_type = parentPackages[0].customer_type;
				}

				var p = [];
				var schedulingObjId = schedulingObject.getPackageInfo().id;

				for (var item in packageTimes) {
					if (packageTimes[item].id == schedulingObjId) {
						p.push(packageTimes[item]);
					}
				}

				var times = getTimes(p, parentPackages);

				if (!Utilities.isEmpty(times)) {
					schedulingObject.setTimes(times);

					setTimeInterval(times, schedulingObject, parentPackages);
				}

				schedulingPackages.push(schedulingObject);
			}

			return schedulingPackages;
		};

		/**
		 * Gets the service request to use when requesting dates
		 * Determines the appropriate scheduling service type based on configuration precedence
		 * @public
		 * @returns {String} - The service request to use
		 */
		this.getServiceRequest = function determineServiceRequest() {
			var serviceType,
				comboSettings,
				parsedSettings;

			// First check for package-level scheduling_combo_call characteristic (highest precedence)
			if (Utilities.checkProp('Package.packageDetails.CHARACS.scheduling_combo_call', Package)) {
				serviceType = Package.packageDetails.CHARACS.scheduling_combo_call;
			} else {
				// Use validString to safely access the scheduling_combo setting otherwise default to empty string
				// Note: scheduling_combo is stored as a JSON string in AppData.settings
				comboSettings = validString(AppData.settings.scheduling_combo) ? AppData.settings.scheduling_combo : '';

				if (comboSettings) {
					try {
						// Parse the JSON string to get the configuration object
						parsedSettings = JSON.parse(AppData.settings.scheduling_combo);

						// Extract the service type from the parsed settings
						serviceType = Utilities.checkProp('parsedSettings.scheduling_combo_call', parsedSettings, 'returnValue');
					} catch (e) {
						// Problem with parsing the config, provide helpful debugging message
						$log.warn('SchedulingPrepService: Could not parse scheduling_combo settings');
						serviceType = null;
					}
				}
			}

			// Return the appropriate service enum based on the determined service type
			if (serviceType === "GetMerchantPackageEventDates") {
				return Enums.services.GET_MERCHANT_PACKAGE_EVENT_DATES;
			}

			// Default to legacy combo endpoint when no config is present or for any other value
			return Enums.services.GET_KEYWORD_COMBO_CREATOR;
		};

		/**
		 * Calculates the summary of customer types and their associated costs for a given set of parent packages.
		 * @param {Object[]} parentPackages - The array of parent packages to calculate the summary for.
		 * @returns {Promise<Object>} An object containing the summary of customer types, total cost, total savings, and other relevant information.
		*/
		this.getSummary = function(parentPackages) {
			var useVat = AppData.defaults.use_vat;
			var date = parentPackages[0].CHARACS[0].start_date;

			var promises = parentPackages.map(function(parentPkg) {
				var pkgId = parentPkg.package_id;
				var isDynamic = DynamicCapacityPricingService.isPackageDynamic(pkgId);
				var pkg = Package.getPackageByID(pkgId);
				var deferred = $q.defer();

				var currentCT = pkg.CT.filter(function iterateCts(item) {
					return item.id && item.id === parentPkg.customer_type;
				})[0];

				if (!currentCT) {
					deferred.resolve(null);
					return deferred.promise;
				}

				var resolveWithPrice = function(price) {
					deferred.resolve({
						pkg: parentPkg,
						ct: currentCT,
						price: price,
						gatePrice: currentCT.gate_price
					});
				};

				if (isDynamic) {
					var startTime = parentPkg.CHARACS[0].start_time;
					var dateToUse = Utilities.javascriptDateToSQLDate(new Date(date.replace(/-/g, '/')));

					DynamicCapacityPricingService.fetchLivePricing(pkgId, dateToUse, startTime, [parentPkg.customer_type])
						.then(function(pricingData) {
							var price = null, pricingObj = null;

							if (UtilsValidation.validObject(pricingData) && !validArray(pricingData)) {
								pricingObj = pricingData;
							} else if (validArray(pricingData)) {
								var match = pricingData.find(function(t) { return t.time === startTime; });
								if (match && match.pricing) {
									pricingObj = match.pricing;
								}
							}

							if (pricingObj && pricingObj[parentPkg.customer_type]) {
								var pInfo = pricingObj[parentPkg.customer_type];
								var dynamicPrice = $injector.get('SchedulingUtilitiesService').getPriceFromPricingObject(pInfo);

								if (dynamicPrice !== null) {
									price = dynamicPrice;
								}
							}

							if (price === null) {
								price = Utilities.getTotalPrice(currentCT);
							}
							resolveWithPrice(price);
						}, function() {
							resolveWithPrice(Utilities.getTotalPrice(currentCT));
						});
				} else {
					resolveWithPrice(Utilities.getTotalPrice(currentCT));
				}

				return deferred.promise;
			});

			return $q.all(promises).then(function(results) {
				var customerTypeSummaries = [];
				var totalCost = 0;
				var totalQty = 0;
				var totalGatePrice = 0;
				var totalSavings = 0;

				results.forEach(function(item) {
					if (!item) { return; }

					var parentPkg = item.pkg;
					var currentCT = item.ct;
					var retailAmount = item.price;
					var currentCTGatePrice = null;

					if (angular.isDefined(item.gatePrice)) {
						totalGatePrice += parentPkg.qty * item.gatePrice;
						currentCTGatePrice = parentPkg.qty * item.gatePrice;
					}

					var customerTypeSummary = new SchedulingModels.CustomerTypeSummary(parentPkg.client_rate_name, parentPkg.qty, retailAmount, currentCT.id, currentCTGatePrice);

					totalCost += Number(retailAmount) * parentPkg.qty;
					totalQty += parentPkg.qty;

					customerTypeSummaries.push(customerTypeSummary);
				});

				totalSavings = totalGatePrice - totalCost;

				return new SchedulingModels.Summary(customerTypeSummaries, totalCost, useVat, totalSavings, totalQty, date);
			});
		};

		/**
		 * Requests scheduling packages using either e2e or Siriusware based on configuration
		 * @param {Object[]} parentPackages - Array of parent package objects containing
		 *   customer type, quantity, and characteristics including date and event information
		 * @returns {Promise<Object[]>} Promise that resolves to:
		 *   - For e2e: Array of SchedulingObject instances with package-specific times (may be empty)
		 *   - For Siriusware: Array of package objects with availability data
		 * @throws {RouteRejectionService.ViewException} For Siriusware flow when request fails or returns invalid data.
		 *   E2e flow handles errors gracefully and does not throw error
		 * @public
		 */
		this.requestPackages = function requestPackages(parentPackages) {
			var currentKeyword = parentPackages[0].CHARACS[0].oneBarcodeKeyword,
				requestDateString = parentPackages[0].CHARACS[0].start_date,
				requestType = this.getServiceRequest();

			$rootScope.showSpinner();

			if (requestType === Enums.services.GET_MERCHANT_PACKAGE_EVENT_DATES) {
				return requestIndividualPackageTimes(parentPackages, currentKeyword, requestDateString);
			}

			// Siriusware: single API call with error handling
			var requestObj = createRequestObject(requestType, parentPackages, currentKeyword, requestDateString);

			return AppData.fetch(requestType, false, requestObj).then(
				function handleSuccess(data) {
					return processApiResponse(data, requestType, parentPackages);
				},
				function handleError() {
					Package.cancelXFC();
					throw new RouteRejectionService.ViewException('Alert', 'generalErrorTitle', 'noDates', $state.current.url, $stateParams);
				}
			);
		};

		/**
		 * Setup the listener for app-activated to ensure that certain scheduling actions are configured
		 */
		this.setupAppActivatedListener = function() {
			listener = $rootScope.$on(Enums.services.APP_ACTIVATED, configureSchedulingActions);
		}

	} );

angular.module('matrix', ['app'])
	.config(function ($locationProvider, $stateProvider) {

		$stateProvider
			.state('/matrix/:packageId', {
				url: '/matrix/:packageId',
				templateUrl: '/scripts/modules/extraflow/matrix/matrix.html',
				controller: 'MatrixController',
				title: 'matrix',
				resolve: {
					load: function( $rootScope, Utilities ){
						$rootScope.showSpinner();

						return Utilities.cacheBustAndLazyLoad([
							'/scripts/modules/extraflow/matrix/matrix-models.js',
							'/scripts/modules/extraflow/matrix/matrix-service.js',
							'/scripts/modules/extraflow/matrix/matrix-controller.js'
						]);
					},
					initialData: function(load,Bootstrap) {
						return Bootstrap.bootstrapApplication();
					},
					xfcMap: function(initialData, Package) {
						return Package.buildXFCMap();
					},
					setupMatrix: function(xfcMap, $injector, $transition$) {
						return $injector.get('MatrixService').initialize($transition$.params());
					}
				}
			});
	})
	.run(function(ExtraFlow, Enums){

		// Register this extra flow module with the extra flow service
		ExtraFlow.registerXMC
		( 'matrix_wizard',
			{
				name: 'matrix_wizard',
				aliases: [
					'matrix_wizard2',
					'matrix_wizard3',
					'matrix_wizard4',
					'matrix_wizard5'
				],
				view: Enums.extraFlowRoutes.MATRIX,
				doEditMode: false,
				noEditAndQty: true,
				writeSingleCharac: false,
				enabled: true,
				type: 'extraFlowControl'
			}
		);
	});

angular.module('camps',
['errorTracking', 'app'])
	.config(function($locationProvider, $stateProvider) {

		$stateProvider
			.state('camps', {
				abstract: true,
				url: '/camps/:packageId',
				template: '<div ui-view></div>',
				resolve: {
					load: function( $rootScope, Utilities ){

						$rootScope.showSpinner();

						return Utilities.cacheBustAndLazyLoad([
							'/scripts/modules/extraflow/camps/controllers/camps-account-controller.js',
							'/scripts/modules/extraflow/camps/controllers/camps-demographics-controller.js',
							'/scripts/modules/extraflow/camps/controllers/camps-login-controller.js',
							'/scripts/modules/extraflow/camps/controllers/camps-password-controller.js',
							'/scripts/modules/extraflow/camps/controllers/camps-finalize-controller.js',
							'/scripts/modules/extraflow/camps/controllers/camps-medical-controller.js',
							'/scripts/modules/extraflow/camps/controllers/camps-participants-controller.js',
							'/scripts/modules/extraflow/camps/controllers/camps-photo-controller.js',
							'/scripts/modules/extraflow/camps/controllers/camps-pickups-controller.js',
							'/scripts/modules/extraflow/camps/controllers/camps-review-controller.js',
							'/scripts/modules/extraflow/camps/services/camps-autofill-service.js',
							'/scripts/modules/extraflow/camps/services/camps-enums-service.js',
							'/scripts/modules/extraflow/camps/services/camps-requests-service.js',
							'/scripts/modules/extraflow/camps/services/camps-characs-service.js',
							'/scripts/modules/extraflow/camps/services/camps-simplerequest-service.js',
							'/scripts/modules/extraflow/camps/services/camps-session-service.js',
							'/scripts/modules/extraflow/camps/services/camps-routing-service.js',
							'/scripts/modules/extraflow/camps/camps-models.js'
						]);
					},
					initialData: function(load,Bootstrap) {

						return Bootstrap.bootstrapApplication();

					},
					xfcMap: function(initialData, Package, StandardFlowInitiatorService) {
						StandardFlowInitiatorService.resetToPackageDetailsScreen = false;
						return Package.buildXFCMap();
					},
					initXFC: function(xfcMap, RouteRejectionService,Package, $transition$){

						var rejectionRoute = Package.assessRoutabilityOfXFC($transition$.params().packageId);
						if(rejectionRoute.length > 0){

							throw new RouteRejectionService.UnrecoverableException(rejectionRoute);

						}else{

							return true;
						}
					},
					assessCurrentUser: function(initXFC, $injector, RouteRejectionService, Package, $transition$, $state, UtilsValidation){

						if(UtilsValidation.validArray(Package.itemsToBeAdded) &&
								angular.isUndefined($injector.get('CampsSessionService').getCurrentUser()) && ($state.next.name !== 'camps.login')){

						throw new RouteRejectionService.UnrecoverableException('camps.login',{packageId: $transition$.params().packageId});

						}else{
							//if itemsToBeAdded is undefined or has no items in the array, then the initXFC resolve will
							//force routing back to package details or entry route so we don't need to force any rerouting in this resolve
							return true;
						}
					}
				}
			})
			.state('camps.login', {
				url: '',
				belongsToXMC: 'camps',
				templateUrl: '/scripts/modules/extraflow/camps/views/login.html',
				controller: 'CampsLoginController',
				resolve: {
					assessRoute: function(assessCurrentUser, CampsSessionService, RouteRejectionService, $transition$){

						if (angular.isDefined(CampsSessionService.getCurrentUser())) {

							//reroute
							throw new RouteRejectionService.UnrecoverableException('camps.account', {packageId: $transition$.params().packageId, mode: 'edit'});

						}else{

							return true;
						}
					}
				}
			})
			.state('camps.password', {
				url: '/password',
				belongsToXMC: 'camps',
				templateUrl: '/scripts/modules/extraflow/camps/views/password.html',
				controller: 'CampsPasswordController'
			})
			.state('camps.account', {
				url: '/account/:mode',
				belongsToXMC: 'camps',
				templateUrl: '/scripts/modules/extraflow/camps/views/account.html',
				controller: 'CampsAccountController',
				resolve:{
					accountProfile: function(assessCurrentUser, CampsSessionService, CampsModels, CampsRequestsService, RouteRejectionService, $transition$, $q, $state){

						var deferred = $q.defer(),
							currentUser = CampsSessionService.getCurrentUser(),
							stateParams = $transition$.params();
						if (stateParams.mode === 'edit'){

							CampsRequestsService.getProfile(currentUser.profile_id).then(
								function(profileResponse) {

									deferred.resolve(profileResponse);

								},function(profileErr){

									deferred.reject(new RouteRejectionService.ViewException('Camps','requestFailedTitle','accountFetchFailed',$state.current.name, stateParams));
								});
						}else{

							deferred.resolve(new CampsModels.Profile());
						}

						return deferred.promise;
					},
					}
			})
			.state('camps.participants', {
				url: '/participants',
				belongsToXMC: 'camps',
				templateUrl: '/scripts/modules/extraflow/camps/views/participants.html',
				controller: 'CampsParticipantsController',
				resolve:{
					dependents:function(assessCurrentUser,CampsSessionService,CampsRequestsService,RouteRejectionService,$transition$,$q,$state){

						var deferred = $q.defer();
						CampsRequestsService.getDependents(CampsSessionService.getCurrentUser().profile_id).then(
							function(response) {

								deferred.resolve(response);

							},
							function(dependentsErr) {

								deferred.reject(new RouteRejectionService.ViewException('Camps', 'requestFailedTitle', 'accountFetchFailed', $state.current.name, $transition$.params()));

							});

						return deferred.promise;
					}
				}
			})
			.state('camps.demographics', {
				url: '/demographics/:participantId',
				belongsToXMC: 'camps',
				templateUrl: '/scripts/modules/extraflow/camps/views/demographics.html',
				controller: 'CampsDemographicsController',
				resolve: {
					currentProfile: function(assessCurrentUser,CampsSessionService, CampsRequestsService, RouteRejectionService, $transition$, $q, $state){

						// obtain the most current-up-to-date version of the customer profile (they can make changes at the account screen so we need to re-request it)
						var deferred = $q.defer();
						CampsRequestsService.getProfile(CampsSessionService.getCurrentUser().profile_id).then(
							function(profileResponse) {

								deferred.resolve(profileResponse);

							},function(profileErr){

								deferred.reject(new RouteRejectionService.ViewException('Camps', 'requestFailedTitle', 'accountFetchFailed', $state.current.name, $transition$.params()));

							});

						return deferred.promise;
					},
					relationships: function(currentProfile,CampsRequestsService,RouteRejectionService,$state,$q,$transition$){

						//if we have the current profile, then we request the relationships - we need to request a fresh copy as changes can be made to the dependents on this view
						//so if we ever route here again, we need to ensure we have a fresh copy of the relationships
						var deferred = $q.defer();
						CampsRequestsService.getRelationships().then(

							function(relationshipsResponse){

								deferred.resolve(relationshipsResponse);

							},
							function(relationshipsErr){

								deferred.reject(new RouteRejectionService.ViewException('Camps', 'requestFailedTitle', 'accountFetchFailed', $state.current.name, $transition$));

							}
						);

						return deferred.promise;
					}
				}
			})
			.state('camps.pickups', {
				url: '/pickups/:participantId',
				belongsToXMC: 'camps',
				templateUrl: '/scripts/modules/extraflow/camps/views/pickups.html',
				controller: 'CampsPickupsController'
			})
			.state('camps.medical', {
				url: '/medical/:participantId',
				templateUrl: '/scripts/modules/extraflow/camps/views/medical.html',
				controller: 'CampsMedicalController',
				belongsToXMC: 'camps_waiver_medical'
			})
			.state('camps.photo', {
				url: '/photo/:participantId',
				belongsToXMC: 'camps_waiver_photo',
				templateUrl: '/scripts/modules/extraflow/camps/views/photo.html',
				controller: 'CampsPhotoController'
			})
			.state('camps.review', {
				url: '/review/:participantId',
				belongsToXMC: 'camps_verify',
				templateUrl: '/scripts/modules/extraflow/camps/views/review.html',
				controller: 'CampsReviewController'
			})
			.state('camps.finalize', {
				url: '/finalize/:participantId',
				belongsToXMC: 'camps_verify',
				controller: 'CampsFinalizeController'
			});
})
.run(function(AppData, ExtraFlow, $log) {

	var campMovieNames = [
		'camps',
		'camps_medical_photo_verify',
		'camps_medical',
		'camps_photo',
		'camps_verify',
		'camps_medical_photo',
		'camps_medical_verify',
		'camps_photo_verify'

	];

	campMovieNames.forEach(function(xmc) {

		ExtraFlow.registerXMC(xmc, {
			name: xmc,
			view: 'camps',
			viewIsStateName: true,
			showCapacityRemaining: false,
			showTimeList: true,
			doEditMode: false,
			lockQuantity: true,
			writeSingleCharac: false,
			enabled: true,
			type: 'extraFlowControl',
			routeChain: [{
				xmc: 'camps',
				state: 'camps.pickups',
				next: 'camps.medical',
				back: false
			}, {
				xmc: 'medical',
				state: 'camps.medical',
				next: 'camps.photo',
				back: 'camps.pickups'
			}, {
				xmc: 'photo',
				state: 'camps.photo',
				next: 'camps.review',
				back: 'camps.medical'
			}, {
				xmc: 'verify',
				state: 'camps.review',
				next: 'camps.finalize',
				back: 'camps.photo'
			}]
		});
	});
});

angular.module('adoptions-donations',
	['errorTracking', 'app'])
	.config(function ($locationProvider, $stateProvider) {

	   $stateProvider
			.state('adoptions-donations', {
			   abstract: true,
			   url: '/adoptions-donations',
			   template: '<div ui-view></div>',
			   onEnter: ['$location', 'Package', '$log', function($location, Package, $log){
				//NOOP... for now.
			   }],
				resolve: {
					load: function( $rootScope, Utilities ){

						$rootScope.showSpinner();

						return Utilities.cacheBustAndLazyLoad([
							'/scripts/modules/extraflow/adoptions-donations/adoptions-donations-models.js',
							'/scripts/modules/extraflow/adoptions-donations/controllers/adoptions-donations-memorial-controller.js',
							'/scripts/modules/extraflow/adoptions-donations/controllers/adoptions-donations-animal-adoption-controller.js',
							'/scripts/modules/extraflow/adoptions-donations/services/adoptions-donations-characs-service.js',
							'/scripts/modules/extraflow/adoptions-donations/services/adoptions-donations-autofill-service.js',
							'/scripts/modules/extraflow/adoptions-donations/services/adoptions-donations-enums-service.js',
							'/scripts/modules/extraflow/adoptions-donations/services/adoptions-donations-service.js'
						]);
					},
					//resolve failures are handled within run.js of main app
					initialData: function(load,Bootstrap) {
						return Bootstrap.bootstrapApplication();
					},
					setupXFC: function(initialData, $injector) {
						return $injector.get('AdoptionsDonationsService').setupXFC();
					}
				}
			})
			.state('adoptions-donations.animal_adoption', {
				url: '/animal_adoption_multi/:packageId',
				belongsToXMC: 'adoptions-donations',
				templateUrl: '/scripts/modules/extraflow/adoptions-donations/views/animal-adoption.html',
				controller:  'AdoptionsDonationsAnimalAdoptionController'
			})
			.state('adoptions-donations.memorial', {
				url: '/memorial/:packageId',
				belongsToXMC: 'adoptions-donations',
				templateUrl: '/scripts/modules/extraflow/adoptions-donations/views/memorial.html',
				controller:  'AdoptionsDonationsMemorialController'
			});
})
.run(function(AppData, ExtraFlow, $log){

    ['animal_adoption_multi', 'memorial'].forEach(function( xmc ){

		ExtraFlow.registerXMC
		(xmc,
		{ name: xmc
		  // route to the participants screen,
		  // which will automatically load login and
		  // account mgmt screens if needed.
		  , view: 'adoptions-donations/' + xmc
		  , showCapacityRemaining: false
		  , showTimeList: true
		  , doEditMode: true
		  , lockQuantity: true
		  , writeSingleCharac: false
		  , enabled: true
		  , type: 'extraFlowControl'
		}
		);
	});
});

(function() {
	'use strict';

	angular
		.module('app')
		.constant('FormConfigurationPlugins', ['demographic_overrides', 'disabled_fields'])
		.service('FormConfiguration', FormConfigurationService);

	/**
	 * The Form Configuration Service.
	 * This service handles global configurations to be used within forms.
	 * @constructor
	 * @param {Service} $injector The $injector Service
	 * @param {Constant} FormConfigurationPlugins The FormConfigurationPlugins Constant
	 * @param {Service} Utilities The Utilities Service
	 * @param {Service} UtilsValidation The UtilsValidation Service
	 * @returns {Service} The Form Configuration Service
	 * @ngInject
	 */
	function FormConfigurationService($injector, FormConfigurationPlugins, Utilities, UtilsValidation) {

		/****************
		 * UTILITY VARS *
		 ****************/
		var validObject = UtilsValidation.validObject;

		/****************
		 * PRIVATE VARS *
		 ****************/
		var _pluginMap = [];

		/***************
		 * PUBLIC VARS *
		 ***************/
		var service = {
			plugins: {},
			_: {
				loadPlugins: _loadPlugins,
				pluginMap: _pluginMap,
				pluginsLoaded: false
			}
		};

		// Load in the plugins
		service._.loadPlugins();

		// Returns service for consumption.
		return service;

		/**
		 * Loads in plugins to the main service
		 * @function
		 * @returns {undefined}
		 */
		function _loadPlugins() {
			FormConfigurationPlugins.forEach(function loadPluginsIntoService(name) {
				// Generates and saves the angular service name
				service._.pluginMap.push(name
					.toLowerCase()
					.replace(/(?:^|_)(.)/g, function nameToPascalCase(match, group1) {
						return group1.toUpperCase();
					})
					.concat('PluginService'));
			});

			service._.pluginMap.forEach(function iteratePlugins(plugin) {
				var Plugin = $injector.has(plugin) && $injector.get(plugin);
				// Set plugin to service plugin object
				service.plugins[plugin] = Plugin;
				// Checks to see if there are any methods to add to the base service
				if (validObject(Plugin.host)) {
					// Iterates through host to set methods to service, if it is not already set
					Object.keys(Plugin.host).forEach(function iteratePluginHostMethods(key) {
						// Checks to see if it's already not set
						if (!service[key] !== undefined) {
							service[key] = Plugin.host[key];
						}
					});
				}

				service._.pluginsLoaded = true;
			});
		}
	}
})();

(function() {
	'use strict';

	angular
		.module('app')
		.service('DisabledFieldsPluginService', DisabledFieldsPluginService);

	/**
	 * Form service for disabled fields
	 * @constructor
	 * @ngInject
	 * @returns {Service} Returns the plugin service
	 */
	function DisabledFieldsPluginService() {
		/***************
		 * PUBLIC VARS *
		 ***************/
		var plugin = {
			host: {
				disabledFields: {
					normalizeFieldNames: normalizeFieldNames
				}
			}
		};

		return plugin;

		/**
		 * Normalizes the names for disabling inputs
		 * @param {Sting[]} fields the config fields
		 * @returns {String[]} The fields that have been normalized/filtered out
		 */
		function normalizeFieldNames(fields) {
			var normalizedFields = [];
			var normalizeMap = {
				age: /^age$/i,
				address: /^address\d?$/i,
				birth_date: /^(?:birth.*date|dob)$/i,
				city: /^city$/i,
				country: /^country$/i,
				email: /^email.*(?:address)?$/i,
				first_name: /^first.*name$/i,
				home_phone: /^(?:home.*|tele)?phone$/i,
				last_name: /^last.*name$/i,
				license_plate: /^license.*plate$/i,
				salutation: /^salutation$/i,
				secondary_phone: /^secondary.*phone$/i,
				selection_dropdown: /^selection.*dropdown$/i,
				sex: /^sex$/i,
				state: /^state$/i,
				zip_code: /^(?:zip|postal).*(?:code)?$/i
			};

			// Iterate through the fields
			fields.forEach(function iterateFieldsToNormalize(field) {
				// Iterate through the map
				Object.keys(normalizeMap).forEach(function iterateNormalizeMap(key) {
					// if field test passes add the normalized key
					if (normalizeMap[key].test(field)) {
						normalizedFields.push(key);
					}
				});
			});

			// Return the normalized fields
			return normalizedFields;
		}
	}
})();
(function() {
	'use strict';

	angular
		.module('app')
		.service('DemographicOverridesPluginService', DemographicOverridesPluginService);

	/**
	 * The plugin for demographic overrides
	 * @constructor
	 * @param {Service} AppData The AppData Service
	 * @param {Service} JSONValidator The JSONValidator Service
	 * @param {Service} Utilities The Utilities Service
	 * @param {Service} UtilsValidation The UtilsValidation Service
	 * @returns {Service} The Demographic Overrides Plugin Service
	 * @ngInject
	 */
	function DemographicOverridesPluginService(AppData, JSONValidator, Utilities, UtilsValidation) {
		/****************
		 * UTILITY VARS *
		 ****************/
		var checkProp = Utilities.safelyCheckPropertyOnObject;
		var validArray = UtilsValidation.validArray;
		var validObject = UtilsValidation.validObject;
		var validString = UtilsValidation.validString;

		/****************
		 * PRIVATE VARS *
		 ****************/
		var _config = {};

		/***************
		 * PUBLIC VARS *
		 ***************/

		// The plugin var to tell how the host service how to use/add its' methods
		var plugin = {
			host: {
				demographicOverrides: {
					getConfig: getConfig,
					getFormFieldOverrides: getFormFieldOverrides
				}
			},
			getConfig: getConfig,
			_: {
				config: _config
			}
		};

		return plugin;

		/**
		 * Grabs the Form Overrides
		 * @function
		 * @name getFormFieldOverrides
		 * @param {String} formName The form name in the config to check
		 * @param {Object} [options] the options the config must have e.g. {'profile.existing_guest': true}
		 * @returns {Object} demographic_form_field_overrides for the specified form name
		 */
		 function getFormFieldOverrides(formName, options) {
			var config = plugin.getConfig(formName, options),
				overrideObject =  {
					formAgeField: false,
					formDisabledFields: [],
					formGenderList: [],
					formOptionalFields: [],
					formRemoveFields: [],
					labels: []
				};

			// If there is a valid config that was
			if (config) {
				// Assign the optional fields
				overrideObject.formOptionalFields = config.optional_fields;

				// Assign the labels
				overrideObject.labels = config.labels;

				// If there are any fields that must be disabled, assign them
				if (validArray(config.disabled_fields)) {
					overrideObject.formDisabledFields = config.disabled_fields;
				}

				// If there are any fields that must be removed, assign them
				if (validArray(config.removed_fields)) {
					overrideObject.formRemoveFields = config.removed_fields;
				}

				// GPS-only: configurable gender option list
				if (validArray(config.gpsGenderList)) {
					overrideObject.formGenderList = config.gpsGenderList;
				}

				// Should the age fields be shown?
				overrideObject.formAgeField = overrideObject.formRemoveFields.indexOf('birthDate') > -1 && config.show_age_field;
			}

			return overrideObject;
		}

		/**
		 * Grabs the desired configuration.
		 * @param {String} formName the form name
		 * @param {Object} [options] the options the config must have e.g. {'profile.existing_guest': true}
		 * @param {String} [path] The path in the config that is desired. example: 'profile.existing_guest'
		 * @returns {Object|null} Returns an object unless a path is passed in and does not exist.
		 */
		 function getConfig(formName, options, path) {
			var foundConfig = [];

			// If config is not set, try and set it
			if (!validArray(plugin._.config) && JSONValidator.validate('demographic_form_field_overrides', AppData.settings.demographic_form_field_overrides)) {
				plugin._.config = JSON.parse(AppData.settings.demographic_form_field_overrides);
			}

			// Find the config with the form name
			if (validArray(plugin._.config)) {
				foundConfig = plugin._.config.filter(function filterConfigWithFormName(conf) {
					return validArray(conf.forms) && conf.forms.includes(formName);
				});
			}

			// Are there more than 1 configs that were matched?
			if (foundConfig.length && validObject(options)) {
				// Try and filter based upon options
				foundConfig = foundConfig.filter(function filterConfigsByOptions(conf) {
					var prop;
					for (prop in options) {
						if (!checkProp('config.options.' + prop, conf) || checkProp('config.options.' + prop, conf, 'returnValue') !== options[prop]) {
							return false;
						}
					}

					return true;
				});
			}

			// Set to first config, as there might be multiple that match
			foundConfig = foundConfig.length
				? foundConfig[0]
				: null;

			// If path was passed in, try and see if the desired property exists and return it
			if (validString(path)) {
				// Check config to see if the property exists
				if (checkProp('config.' + path, foundConfig)) {
					return checkProp('config.' + path, foundConfig, 'returnValue');
				}

				// Return null if it was not set
				return null;
			}

			// Return the config
			return foundConfig;
		}
	}
})();
angular.module('analytics', [
	'errorTracking',
	'app'
]).run(function ($transitions, $timeout, AnalyticsVirtualURLService, AnalyticsEnumsService, $log, $rootScope, Enums, AnalyticsDataLayerService, AnalyticsService) {
	$rootScope.$on
	(
		Enums.services.APP_ACTIVATED,
		function(event, data) {
			if (AnalyticsService.ready == false) {
				$log.info("[analytics] Loading analytics service...");

				// Expose the functionality of this module to the external world.
				window._AccessoMapper = AnalyticsVirtualURLService;

				$log.info("[analytics] Loaded URL mapper...");

				// Register this service as a hook into the purchase services.
				AnalyticsDataLayerService.init();

				// used to communicate with GTM (phase 1)
				$rootScope.$on(
					Enums.events.purchaseComplete,
					AnalyticsDataLayerService.prepareDataLayerUpdateAfterPurchase
				);

				// used to communicate with GTM (phase 2)
				$rootScope.$on(
					Enums.events.postPurchaseComplete,
					AnalyticsDataLayerService.updateDataLayerWithPurchase
				);

				// used to communicate with GTM
				$rootScope.$on(
					'$viewContentLoaded',
					AnalyticsDataLayerService.triggerInternalPageView
				);

				$transitions.onSuccess({}, function(trans) {
					// send event on the "next tick" when the browser has updated the location in bar
					$timeout(function nextTick() {
						// send event
						AnalyticsDataLayerService.triggerInternalStateChange();
					}, 0);
				});

				// used to communicate with GTM
				$rootScope.$on(
					'getLaunchType',
					AnalyticsDataLayerService.getLaunchType
				);

				// used to communicate with GTM
				$rootScope.$on(
					'triggerPromoImpressions',
					AnalyticsDataLayerService.triggerPromoImpressionsEnhancedEcommerce
				);

				// used to communicate with GTM
				$rootScope.$on(
					'triggerPromoClick',
					AnalyticsDataLayerService.triggerPromoClickEnhancedEcommerce
				);

				// used to communicate with GTM
				$rootScope.$on(
					'triggerImpressionsPackList',
					AnalyticsDataLayerService.triggerImpressionsPackListEnhancedEcommerce
				);

				// used to communicate with GTM
				$rootScope.$on(
					'triggerImpressionsSells',
					AnalyticsDataLayerService.triggerImpressionsSellsEnhancedEcommerce
				);

				// used to communicate with GTM
				$rootScope.$on(
					'triggerProductClick',
					AnalyticsDataLayerService.triggerProductClickEnhancedEcommerce
				);

				// used to communicate with GTM
				$rootScope.$on(
					'triggerProductDetails',
					AnalyticsDataLayerService.triggerProductDetailsEnhancedEcommerce
				);

				// used to communicate with GTM
				$rootScope.$on(
					'triggerAddToCart',
					AnalyticsDataLayerService.triggerAddToCartEnhancedEcommerce
				);

				// used to communicate with GTM
				$rootScope.$on(
					'triggerRemoveFromCart',
					AnalyticsDataLayerService.triggerRemoveFromCartEnhancedEcommerce
				);

				// used to communicate with GTM
				$rootScope.$on(
					'triggerCheckout',
					AnalyticsDataLayerService.triggerCheckoutEnhancedEcommerce
				);

				// used to communicate with GTM
				$rootScope.$on(
					'triggerViewCart',
					AnalyticsDataLayerService.triggerViewCart
				);

				// used to communicate with GTM
				$rootScope.$on(
					'triggerBeginCheckout',
					AnalyticsDataLayerService.triggerBeginCheckout
				);

				// used to communicate with GTM
				$rootScope.$on(
					'triggerCheckoutBilling',
					AnalyticsDataLayerService.triggerCheckoutBillingEnhancedEcommerce
				);

				// used to communicate with GTM
				$rootScope.$on(
					'triggerCheckoutPaymentInfo',
					AnalyticsDataLayerService.triggerCheckoutPaymentInfoEnhancedEcommerce
				);

				// used to communicate with GTM
				$rootScope.$on(
					'triggerPaymentSelection',
					AnalyticsDataLayerService.triggerPaymentSelectionEnhancedEcommerce
				);

				// used to communicate with GTM
				$rootScope.$on(
					'triggerShippingSelection',
					AnalyticsDataLayerService.triggerShippingSelectionEnhancedEcommerce
				);

				// used to communicate with GTM
				$rootScope.$on(
					'triggerCheckoutOrderReview',
					AnalyticsDataLayerService.triggerCheckoutOrderReviewEnhancedEcommerce
				);

				$rootScope.$on(
					'triggerCheckoutUrl',
					AnalyticsDataLayerService.triggerCheckoutUrl
				);

				// used to communicate with GTM
				$rootScope.$on(
					'triggerCartAbandonment',
					AnalyticsDataLayerService.triggerCartAbandonment
				);

				// used to communicate with GTM
				$rootScope.$on(
					'triggerSaveCart',
					AnalyticsDataLayerService.triggerSaveCart
				);

				// used to communicate with GTM
				$rootScope.$on(
					'triggerContinueShopping',
					AnalyticsDataLayerService.triggerContinueShopping
				);

				// used to communicate with GTM
				$rootScope.$on(
					'triggerVideoView',
					AnalyticsDataLayerService.triggerVideoView
				);

				// used to communicate with GTM
				$rootScope.$on(
					Enums.messages.REQUESTS_CLOSE,
					AnalyticsDataLayerService.triggerCloseStore
				);

				$rootScope.$on(
					'triggerPrepaidCardModal',
					AnalyticsDataLayerService.triggerPrepaidCardModal
				);

				$rootScope.$on(
					'triggerPushSeasonPassInfo',
					AnalyticsDataLayerService.triggerPushSeasonPassInfo
				);

				$rootScope.$on(
					'triggerSeasonPassOpen',
					AnalyticsDataLayerService.triggerSeasonPassOpen
				);

				$rootScope.$on('triggerSocialMediaClick',
					AnalyticsDataLayerService.triggerSocialMediaClick
				);

				$rootScope.$on(
					'triggerUnassignedModalShow',
					AnalyticsDataLayerService.triggerUnassignedModalShow
				);

				$rootScope.$on(
					'triggerUnassignedPageView',
					AnalyticsDataLayerService.triggerUnassignedPageView
				);

				$rootScope.$on(
					'triggerUnassignedPassholderAssign',
					AnalyticsDataLayerService.triggerUnassignedPassholderAssign
				);

				$rootScope.$on(
					'triggerUnassignedPassholderSkip',
					AnalyticsDataLayerService.triggerUnassignedPassholderSkip
				);

				$rootScope.$on(
					'triggerModuleEvent',
					AnalyticsDataLayerService.triggerModuleEvent
				);

				$rootScope.$on(
					'triggerGetCartSummary',
					AnalyticsDataLayerService.triggerGetCartSummary
				);

				$rootScope.$on(
					'triggerAccessoPayBillingInformation',
					AnalyticsDataLayerService.triggerAccessoPayBillingInformation
				);

				$rootScope.$on('triggerAnalyticsEvent', function (event, data) {
					AnalyticsDataLayerService.triggerAnalyticsEvent(data);
				});

				$rootScope.$on('triggerAccertify', AnalyticsDataLayerService.triggerAccertify);

				function onTransitionSuccess() {
					// try to scrape data off the page
					AnalyticsVirtualURLService.snarfData();
					// reset the last hard overridden url
					AnalyticsVirtualURLService.overrideCurrentUrl(undefined);
					// use this to keep pushing stuff into the data layer
					AnalyticsDataLayerService.stealData();
				}

				onTransitionSuccess();

				AnalyticsService.ready = true;
				AnalyticsDataLayerService.fireDataLayerEvent(AnalyticsEnumsService.events.INITSTORE);
			}
		});
});

angular.module(
	'analytics'
).service(
	'AnalyticsService',
	function ($log) {
		this.ready = false;
	});
angular.module(
	'analytics'               
).service
(
	'AnalyticsVirtualURLService',        // Service Name
	function($log, Package, AppData){

		var defaultURL = "/";

		var snarfed = {
			"lastKeyword" : ""
		};

		var snarfs = {
			// '/packageList/keyword/(.*)\/?'   : {
			// 	v : "{1}",
			// 	k : "lastKeyword"
			// }
		};

		var mappings = {

			'/cartView'                      : "/{root}/{cart}/",
			'/shippingView'                  : "/{root}/{cart}/shipping-information/",
			'/billingView'                   : "/{root}/{cart}/billing-information/",
			'/orderReview'                   : "/{root}/{cart}/review-order/",
			'/knowledgeBaseView'             : "/{root}/{packageDirectory}/help",
			'/help/(.*)'           : "/{root}/{packageDirectory}/help/{1}",
			'/help'                          : "/{root}/{packageDirectory}/help",
			'/packageList/keyword/(.*)\/?'   : "/{root}/{packageDirectory}/{1}",
			'/packageList/promocode/(.*)\/?' : "/{root}/{packageDirectory}/{1}",
			'/calendar/(.*)\/?'              : "/{root}/{packageDirectory}/{1}/calendar-selection",
			'/packageDetails/crossSells'     : "/{root}/{packageDirectory}/$lastKeyword$/$packageName$/description/",
			'/packageDetails'                : "/{root}/{packageDirectory}/$lastKeyword$/$packageName$/description/",
			'/webcam'                        : "/{root}/{packageDirectory}/imagecapturecameraform/",
			'/onsite-info'                   : "/{root}/{packageDirectory}/imagecaptureotherform-park/",
			'/mailing-info'                  : "/{root}/{packageDirectory}/imagecaptureotherform-mail/",
			'/upload-photo'                  : "/{root}/{packageDirectory}/imagecaptureuploadform/",
			'/imageCapture'                  : "/{root}/{packageDirectory}/$packageName$/image-capture/",
			'/matrix'                        : "/{root}/{packageDirectory}/$packageName$/matrix-wizard/",
			'/fastLane/selectPackage'        : "/{root}/{packageDirectory}/$lastKeyword$/fastlanemodule/select-package-view", //note, this is a virtual url
			'/fastLane'                      : "/{root}/{packageDirectory}/$lastKeyword$/fastlanemodule/select-date-and-qty",
			'/seasonPassOptionRenewal/([0-9]+)\/newPassInformation'     : '/{root}/{packageDirectory}/season-pass-form-new',
			'/seasonPassOptionRenewal/([0-9]+)\/renewalPassInformation' : '/{root}/{packageDirectory}/season-pass-form-renewal',
			'/seasonPassOptionRenewal/([0-9]+)\/?'                      : '/{root}/{packageDirectory}/season-pass-form-selection',

			// before falling back to the default url, we try to use the xmc default.
			'/(.*)/[0-9]+\/?' : "/{root}/{packageDirectory}/$packageName$/{1}",
				
			'/'                                                         : "/{root}/{packageDirectory}/"
		};

		var internalMappings = {
			"packageId"   : function() {return Package.packageDetails.id;   },
			"packageName" : function() {return Package.packageDetails.name; },
			"lastKeyword" : function() { if(!AppData.lastKeyword) return ""; else return AppData.lastKeyword;}
		};

		this.overrideCurrentUrl = function(url){
			this.currentURL = url;
		};

		this.overrideMappings = function(m){
			mappings = m;
		};

		//
		// Events that need to get added so I can track them.... 
		//

		// passport.knowledgeBaseSearch -> accesso:knowledgeBaseSearch
		// passport.zipOverride         -> accesso:zipOverride
		//

		this.snarfData = function(){

			try {
				var url = this.getCurrentUrl();

				// there can be multiple snarfs...
				for(var k in snarfs){
					var m = new RegExp("^" + k + ".*");
					
					if(m.exec(url)!==null){
						var mapping = snarfs[k];

						// extract the parts.
						var parts = m.exec(url);

						// construct the value
						for(var i=1; i< parts.length; i++){
							snarfed[mapping.k] = mapping.v.replace(new RegExp("\\{" + i + "\\}", "g"), parts[i]);
						}
					}
				}
			}catch(e){
				$log.error("[analytics] Error snarfing currentUrl" + e.message);
			}

		};

		this.getCurrentUrl = function(){

			if(angular.isUndefined(this.currentURL)==false){
				return this.currentURL;
			}
			
			var loc = document.location.pathname;
				
			// get the current url path
			if(document.location.hash!==undefined && document.location.hash!==""){
				loc = document.location.hash;
				
				if(loc[0]==='#'){
					loc = loc.slice(1);
				}
			}		

			return loc;
		};
		
		this.mapCurrentUrl = function(root, packageDirectory, cart){

			try {
				return this.mapUrl(this.getCurrentUrl(), root, packageDirectory, cart);
			}catch(e){
				$log.error("[analytics] Error mapping currentUrl" + e.message);
			}

			return defaultURL;
		};

		// should be in the format http://mysite.com/some/path/to/map
		this.mapUrl = function(url, root, packageDirectory, cart){

			// replace double slashes...
			var remappedUrl = url;
			var mapping     = undefined;
			var isRegEx     = false;
			
			// 1) Find a replacement pattern that matches
			
			for(var k in mappings){

				if(k.indexOf("(")!==-1){

					var m = new RegExp("^" + k + ".*");
					
					if(m.exec(url)!==null){
						mapping = k;
						isRegEx = true;
						break;
					}
					
				}else{
					if(url.indexOf(k)==0){
						mapping = k;
						break;
					}
				}
			}

			// 2) perform the mapping if possible.
			if(angular.isUndefined(mapping)==false){

				var extractedVariables = {};
				
				// Extract varaibles (and their values) from incomming url (if they exist)
				if(isRegEx){
					var matcher = new RegExp("^" + k + ".*");
					
					var parts = matcher.exec(url);

					for(var i=1; i< parts.length; i++){
						extractedVariables[String(i)] = parts[i];
					}
				}
				
				// Make standard replacements

				remappedUrl = mappings[mapping];
				
				remappedUrl = remappedUrl.replace(new RegExp("\\{packageDirectory\\}", "g"), packageDirectory);
				remappedUrl = remappedUrl.replace(new RegExp("\\{root\\}", "g"), root);
				remappedUrl = remappedUrl.replace(new RegExp("\\{cart\\}", "g"), cart);

				// Make any live variable replacements

				for(var k in internalMappings){
					if(remappedUrl.indexOf("$" + k + "$")!==-1){
						remappedUrl = remappedUrl.replace(new RegExp("\\$" + k + "\\$", "g"), internalMappings[k]());
					}
				}

				// try to replace any snarfed varaibles...

				for(var k in snarfed){
					if(remappedUrl.indexOf("{" + k + "}")!==-1){
						remappedUrl = remappedUrl.replace(new RegExp("\\{" + k + "\\}", "g"), snarfed[k]);
					}
				}
				
				// lastly, make any extracted variable replacements...
				for(var k in extractedVariables){
					if(remappedUrl.indexOf("{" + k + "}")!==-1){
						remappedUrl = remappedUrl.replace(new RegExp("\\{" + k + "\\}", "g"), extractedVariables[k]);
					}
				}

				// Cleanup
				remappedUrl = remappedUrl.replace(new RegExp("\\/\\/", "g"), "/");

				remappedUrl = remappedUrl.replace(new RegExp(" ", "g"), "-");
				remappedUrl = remappedUrl.replace(new RegExp("-+", "g"), "-");
				remappedUrl = remappedUrl.replace(new RegExp("\\?", "g"), "");
				
				remappedUrl = remappedUrl.replace(new RegExp("[^A-Za-z\\-/]", "g"), "");

				remappedUrl = remappedUrl.replace(new RegExp("([a-z])([A-Z])", "g"), "$1-$2");
				remappedUrl = remappedUrl.toLowerCase();

				
			}

			return remappedUrl;
		};

	});


angular.module(
	'analytics'
).service(
	'AnalyticsDataLayerService',
	//  eslint-disable-next-line strict
	// CartEnums is injected for CartEnums.discount.toAnalyticsType() only.
	// Avoid expanding its use here — the analytics module should not grow a wider
	// dependency on cart internals. If a future refactor moves toAnalyticsType into
	// AnalyticsEnumsService, CartEnums can be removed from this DI list.
	function($log, $window, AnalyticsEnumsService, AnalyticsVirtualURLService, Utilities, AppData, CartEnums, ClientInfo, Enums, Package, $state, $stateParams, $location, $rootScope, JSONValidator, errorTracking, UrlUtils, UtilsValidation) {
		var ERROR_PREFIX = '[Analytics] ',
			crypto = $window.crypto.subtle;

		//  Where to push dataLayer variables
		var dll = 'dataLayer',
			possibleOrderId = undefined,
			// Captured at begin_checkout; used to enrich purchase event items
			checkoutDiscount = null,
			checkoutDiscountedPackageIds = null,
			lastState = undefined,
			impressionPriceProperties = ['priceLabelOverride','price_label_override', 'cusTypeRetail','price','startRate','retail_amount','retail'],
			isObject = angular.isObject,
			copy = angular.copy,
			checkProp = Utilities.safelyCheckPropertyOnObject,
			getBoolean = Utilities.getBoolean,
			merge = Utilities.merge,
			validArray = UtilsValidation.validArray,
			validObject = UtilsValidation.validObject,
			validString = UtilsValidation.validString,
			isNumber = angular.isNumber,
			isDefined = angular.isDefined;

		this.characsStore = [];

		var lastNavKeyword = '';

		var savedImpressions = [];

		// Base Model for regular ecommerce
		var baseModel = [
			{
				dataLayerKey: 'transactionId',
				responseProp: 'VIEW_ORDER_REPLY.ORDER_STATUS_REPLY.order_id',
				defaultValue: '0000000000000',
				format: 'string'
			},

			{
				dataLayerKey: 'transactionTotal',
				responseProp: 'VIEW_ORDER_REPLY.ORDER_ITEMS_REPLY.TOTALS.current_total',
				defaultValue: 0,
				format: 'numeric'
			},

			{
				dataLayerKey: 'transactionTax',
				responseProp: 'VIEW_ORDER_REPLY.ORDER_ITEMS_REPLY.TOTALS.tax_total',
				defaultValue: 0,
				format: 'numeric'

			},

			{
				dataLayerKey: 'transactionShipping',
				responseProp: 'VIEW_ORDER_REPLY.ORDER_ITEMS_REPLY.TOTALS.shipping_total',
				defaultValue: 0,
				format: 'numeric'

			}
		];

		// Action Field for Enhanced Ecommerce (replaces the base model)
		var actionField = [
			{
				dataLayerKey: 'id',
				responseProp: 'VIEW_ORDER_REPLY.ORDER_STATUS_REPLY.order_id',
				defaultValue: '0000000000000',
				format: 'string'
			},

			{
				dataLayerKey: 'revenue',
				responseProp: 'VIEW_ORDER_REPLY.ORDER_ITEMS_REPLY.TOTALS.current_total',
				defaultValue: 0,
				format: 'numeric'
			},

			{
				dataLayerKey: 'tax',
				responseProp: 'VIEW_ORDER_REPLY.ORDER_ITEMS_REPLY.TOTALS.tax_total',
				defaultValue: 0,
				format: 'numeric'

			},

			{
				dataLayerKey: 'shipping',
				responseProp: 'VIEW_ORDER_REPLY.ORDER_ITEMS_REPLY.TOTALS.shipping_total',
				defaultValue: 0,
				format: 'numeric'

			},
			{
				dataLayerKey: 'fullTicketPrice',
				responseProp: 'VIEW_ORDER_REPLY.ORDER_ITEMS_REPLY.TOTALS.total_paid_in_full_ticket_retail',
				defaultValue: 0,
				format: 'numeric'
			}
		];

		var analyticsDataLayerConfig = {};

		/**
		 * Returns the configuration settings for the XFC
		 * @returns {Object} The settings to use
		 */
		function getConfiguration() {
			return JSONValidator.validate('analytics_data_layer', checkProp('AppData.settings.analytics_data_layer', AppData, 'returnValue'))
				? JSON.parse(AppData.settings.analytics_data_layer)
				: {};
		}

		/**
		 * Takes package id and rate type id to generate SKU
		 * @param {Number} package_id The package id
		 * @param {Number} rate_type_id The rate type id
		 * @returns {string} The SKU
		 */
		function toSKU(package_id, rate_type_id) {
			return 'P' + String(package_id) + 'CT' + String(rate_type_id);
		}

		/**
		 * Returns index of SKU
		 * @param {Array} arr Array of packages
		 * @param {Number} package_id The package id
		 * @param {Number} rate_type_id The rate type id
		 * @returns {Number} The index if found, -1 if not
		 */
		function indexOfSKU(arr, package_id, rate_type_id) {
			for (var i = 0; i < arr.length; i++) {
				if (arr[i].sku == toSKU(package_id, rate_type_id)) {
					return i;
				}
			}
			return -1;
		}

		/**
		 * Returns whether the package is in the product array
		 * @param {Array} arr Array of packages
		 * @param {Number} package_id The package id
		 * @param {Number} rate_type_id The rate type id
		 * @returns {Boolean} True if it's in the array, false if not
		 */
		function inProductArray(arr, package_id, rate_type_id) {
			return indexOfSKU(arr, package_id, rate_type_id) !== -1;
		}

		/**
		 * Updates product qualities
		 * @param {Object} pkgs The packages object
		 * @param {Object} productDetails The product details object
		 * @returns {Object} The product details object
		 */
		function updateProductQuantities(pkgs, productDetails) {
			//  Check against ids and variants that are already in the productDetailsObj
			//  Update quantities if ids and variants exist.
			for (var p in pkgs) {
				var obj = getProductDetailsFromPackage(pkgs[p]);
				//  If the obj isn't in the productDetails array, go to else.
				//  If so, make sure id's match up.
				if (productDetails.length && obj.id === productDetails[productDetails.length - 1].id) {
					//  Variants also need to match up
					if (obj.variant === productDetails[productDetails.length - 1].variant) {
						//  Only up the quantity by one
						productDetails[productDetails.length - 1].quantity++;
					} else {
						productDetails.push(obj);
					}
				} else {
					productDetails.push(obj);
				}
			}
			return productDetails;
		}
		/**
		 * Updates the product details with list name from package impressions
		 * Converts to `item_list_name` for GA compatibility
		 * @param {Array} pkg The addToCart packages array
		 * @param {Array} productDetails The GTM Formatted product details array
		 * @returns {Array} The enriched product details array
		 */
		function upsellQuicksellCheck(pkg, productDetails) {
			if (!validArray(productDetails) || !validArray(pkg)) {
				return productDetails;
			}

			for (var i = 0; i < pkg.length; i++) {
				var pkgDetail = pkg[i];

				if (!validObject(pkgDetail)) {
					continue;
				}

				if (!checkProp('pkgDetail.CHARACS', pkgDetail, 'validArray')) {
					continue;
				}

				var targetPackageId = pkgDetail.package_id;
				var matchedProduct = null;

				// Find matched product without declaring a function inside the loop
				for (var k = 0; k < productDetails.length; k++) {
					var pd = productDetails[k];
					if (checkProp('pd.id', pd, 'returnValue') === targetPackageId) {
						matchedProduct = pd;
						break;
					}
				}

				if (!matchedProduct) {
					continue;
				}

				var c0 = pkgDetail.CHARACS[0];
				var isQuicksell = getBoolean(checkProp('c0.quicksell', c0, 'returnValue'));
				var isUpsell = getBoolean(checkProp('c0.upsell', c0, 'returnValue'));

				if (isQuicksell) {
					matchedProduct.item_list_name = 'Quicksell';
				} else if (isUpsell) {
					matchedProduct.item_list_name = 'Upsell';
				} else {
					if (validArray(savedImpressions)) {
						var targetId = matchedProduct.id;
						var foundImpression = null;

						for (var j = 0; j < savedImpressions.length; j++) {
							if (checkProp('savedImpressions[j].id', savedImpressions[j], 'returnValue') === targetId) {
								foundImpression = savedImpressions[j];
								break;
							}
						}

						if (checkProp('foundImpression.list', foundImpression, 'validString')) {
							matchedProduct.item_list_name = foundImpression.list;
						} else {
							matchedProduct.item_list_name = validString(lastNavKeyword) ? lastNavKeyword : 'Unknown';
						}
					}
				}
			}
			return productDetails;
		}

		/**
		 * Fires data layer analytics event and pushes it to the data layer
		 * @param {Event} evt  The event
		 * @returns {undefined} The product details object
		 */
		this.fireDataLayerEvent = function(evt) {
			if (!$window[dll]) {
				return;
			}
			$window[dll].push({ event: evt });
		};

		/**
		 * Triggers accessoPay analytics event and pushes it to the data layer
		 * @param {Event} evt The event
		 * @returns {undefined}
		 */
		this.triggerAccessoPayEvent = function(evt) {
			var aPayEvent = angular.copy(evt);

			if (!$window[dll]) {
				return;
			}

			if (aPayEvent.eventName === 'PaymentComplete') {
				var eventPayload = aPayEvent.eventPayload;

				try {
					//  Remove Credit Card Approval Data
					delete eventPayload.approval_code;
					delete eventPayload.authId;
					delete eventPayload.maskedPan;
					delete eventPayload.lastFour;

					//  Remove PII from Donation data
					if (eventPayload.donation) {
						delete eventPayload.donation.donationApprovalCode;
						delete eventPayload.donation.donationTxnReference;
					}

					//  Remove User PII Billing Data
					delete eventPayload.user;
				} catch (e) {
					$log.error("[analytics] Error removing accessoPay Data", e);
				}
			}

			$window[dll].push({
				event: AnalyticsEnumsService.events.ACCESSO_PAY_EVENT,
				accessoPayEvent: aPayEvent
			});
		};

		/**
		 * Triggers promo impression analytics event when the user goes to the package list view and pushes impression
		 * object to the data layer
		 * @param {Event} event The event
		 * @param {String} category The category
		 * @param {Object} sells The promos object
		 * @returns {undefined}
		 */
		this.triggerPromoImpressionsEnhancedEcommerce = function(event, category, sells) {
			try {
				var impressionObj = {};
				var impressions = [];
				var promos = sells;

				if (angular.isUndefined(promos)) {
					return;
				}
				impressionObj['event'] = AnalyticsEnumsService.events.INTERNALADDPROMOIMPRESSION;
				impressionObj['ecommerce'] = {};
				impressionObj['ecommerce']['promoView'] = {};

				var position = 1;
				for (var list in promos) {
					var promo = promos[list];
					var obj = {
						name: promo.keyword,
						id: promo.keyword,
						creative: category,
						position: position
					};
					impressions.push(obj);
					position++;
				}

				impressionObj['ecommerce']['promoView']['promotions'] = impressions;

				$window[dll].push(impressionObj);
			} catch (e) {
				$log.error("[analytics] Error pushing promo impressions", e);
			}
		};

		/**
		 * Triggers promo impression click analytics event when the user goes to the package list view and pushes click
		 * object to the data layer
		 * @param {Event} event The event
		 * @param {String} category The category
		 * @param {Object} sells The promos object
		 * @returns {undefined}
		 */
		this.triggerPromoClickEnhancedEcommerce = function(event, category, sells, kw) {
			try {
				var clickObj = {};
				var click = [];
				var promos = sells;

				if (angular.isUndefined(promos)) {
					return;
				}
				clickObj['event'] = AnalyticsEnumsService.events.INTERNALADDPROMOCLICK;
				clickObj['eventCallback'] = function() {
				};
				clickObj['ecommerce'] = {};
				clickObj['ecommerce']['promoClick'] = {};

				var position = 1;
				// iterating through cross sells to get correct position.
				for (var list in promos) {
					var promo = promos[list];
					if (promo.keyword === kw.keyword) {
						var obj = {
							name: promo.keyword,
							id: promo.keyword,
							creative: category,
							position: position
						};
						click.push(obj);
					}
					position++;
				}

				clickObj['ecommerce']['promoClick']['promotions'] = click;

				$window[dll].push(clickObj);
			} catch (e) {
				$log.error("[analytics] Error pushing promo click: " + e);
			}
		};

		/**
		 * Triggers impression analytics event when the user goes to the package list view and pushes impression
		 * object to the data layer
		 * @param {Event} event The event
		 * @param {String} category The category
		 * @param {Object} sells The promos object
		 * @returns {undefined}
		 */
		this.triggerImpressionsPackListEnhancedEcommerce = function(event, packageList, kw) {
			lastNavKeyword = kw;
			try {
				var impressionObj = {};
				var impressions = [];
				var packages = packageList;
				if (angular.isUndefined(packageList)) {
					return;
				}
				impressionObj['event'] = AnalyticsEnumsService.events.INTERNALADDIMPRESSION;
				impressionObj['ecommerce'] = {};

				var position = 1;
				for (var list in packages) {
					for (var p in packages[list]) {
						var productDetails = packages[list][p];
						var pricePropertyToUse = impressionPriceProperties.filter(function(prop) {
							return validString(productDetails[prop]) || isNumber(productDetails[prop]);
						})[0];
						var obj = {
							name: productDetails.name,
							id: productDetails.id,
							displayPrice: (productDetails[pricePropertyToUse] || 0),
							brand: AppData.settings.merchant || AppData.settings.merchant_uid,
							category: productDetails.package_class || productDetails.class || productDetails.packageClass,
							list: lastNavKeyword,
							position: position,
							currency: AppData.currencyCode,
						};
						//if there was an override include it
						if (['priceLabelOverride','price_label_override'].includes(pricePropertyToUse)) {
							obj.displayPriceOverride = productDetails[pricePropertyToUse];
						}
						//Extract what number we can out of displayed Price
						if (validString(obj.displayPrice)) {
							if (obj.displayPrice.includes(';')) {
								obj.displayPrice = parseFloat(obj.displayPrice.split(';')[1]);
							} else if (obj.displayPrice.includes('&')) {
								obj.displayPrice = obj.displayPrice.match(/[-+]?\d+(?:\.)\d+/g).map(Number)[0];
							} else {
								obj.displayPrice = parseFloat(extractFirstNumbersFromString(obj.displayPrice));
							}
							obj.displayPrice = isNaN(obj.displayPrice) ? 0 : obj.displayPrice;
						}else {
							obj.displayPrice = parseFloat(obj.displayPrice);
						}
						impressions.push(obj);
						position++;
					}
				}

				if (impressions.length) {
					impressionObj['ecommerce']['impressions'] = impressions;
					$window[dll].push(impressionObj);
					// Store Impression in global variable for use later
					savedImpressions = impressions;
				}
			} catch (e) {
				$log.error("[analytics] Error pushing impression: " + e);
			}
		};

		/**
		 * Triggers analytics event when the user views a package (not the detail screen) view and pushes impression
		 * object to the data layer
		 * @param {Event} event The event
		 * @param {Array} packageList  The package list
		 * @param {String} kw  The keyword
		 * @returns {undefined}
		 */
		this.triggerImpressionsSellsEnhancedEcommerce = function(event, packageList, kw) {
			var impressionObj = {};
			var impressions = [];
			var packages = packageList;
			var customerTypes = [];
			var pkgObject;
			var ct;
			var productDetail;
			var i;
			var j;
			var pricePropertyToUse = '';
			lastNavKeyword = kw;
			/* If we choose to reconnect the AbTestService so it is called automatically, the following lines will
			  let us get the current AbTestName
			  var abTestName = AbTestService.currentlyActiveTest();
			  if (abTestName) { abTestName +='AB Test: '+abTestName; }
			*/
			try {
				// set packages to the "real" package list, because depending on the configuration,
				// the actual package list could be at the "packageList" level, or a single element in
				// the packageList that contains the array of packages.
				if (packageList.length === 0) {
					return;
				} else if (packageList.length === 1) {
					if (Object.prototype.toString.call(packageList[0]) === '[object Array]') {
						packages = packageList[0];
					}
				}
				impressionObj['event'] = AnalyticsEnumsService.events.INTERNALADDIMPRESSION;
				impressionObj['ecommerce'] = {};


				for (i = 0; i <packages.length; i++) {
					pkgObject = getProductDetailsFromPackage(packages[i]);
					if (pkgObject.id) {
						customerTypes = packages[i].CT || packages[i].rates || Utilities.wrapObjectToArray(packages[i].customer) || [];
						for (j = 0; j < customerTypes.length; j++) {
							ct = customerTypes[j];
							productDetail = angular.copy(pkgObject);
							pricePropertyToUse = impressionPriceProperties.filter(function(prop) {
								return validString(ct[prop]) || isNumber(ct[prop]);
							})[0];
							productDetail.variant = ct.name;
						productDetail.displayPrice = (ct[pricePropertyToUse] || 0);
							//ensure at least an id exists on this
							productDetail.list = lastNavKeyword;
							//  if (abTestName) { obj.label = abTestName; }
							productDetail.position = i + 1;
							//if there was an override include it
						if (['priceLabelOverride','price_label_override'].includes(pricePropertyToUse)) {
							productDetail.displayPriceOverride = productDetail[pricePropertyToUse];
						}
						//Extract what number we can out of displayed Price
						if (validString(productDetail.displayPrice)) {
							if (productDetail.displayPrice.includes(';')) {
								productDetail.displayPrice = parseFloat(productDetail.displayPrice.split(';')[1]);
							} else if (productDetail.displayPrice.includes('&')) {
								productDetail.displayPrice = productDetail.displayPrice.match(/[-+]?\d+(?:\.)\d+/g).map(Number)[0];
							} else {
								productDetail.displayPrice = parseFloat(extractFirstNumbersFromString(productDetail.displayPrice));
							}
							productDetail.displayPrice = isNaN(productDetail.displayPrice) ? 0 : productDetail.displayPrice;
						} else {
							productDetail.displayPrice = parseFloat(productDetail.displayPrice);
						}
							impressions.push(productDetail);
						}
					}
				}

				impressionObj['ecommerce']['impressions'] = impressions;

				$window[dll].push(impressionObj);
			} catch (e) {
				$log.error("[analytics] Error pushing impression: " + e);
			}
		};


		/**
		 * Triggers on the product details view.Almost identical to product details data,
		 * GA uses it both for calculations, so we need to send them as separate entities.
		 * object to the data layer
		 * @param {Event} event The event
		 * @param {Object} pkg  The package
		 * @param {String} kw  The keyword of the package
		 * @returns {undefined}
		 */
		this.triggerProductClickEnhancedEcommerce = function(event, pkg, kw) {
			try {
				if (kw) {
					lastNavKeyword = kw;
				}

				/* If we choose to reconnect the AbTestService, so it is called automatically, the following lines will
					let us get the current AbTestName
					var abTestName = AbTestService.abTestDescriptionFromPackage(pkg);
					if (abTestName) { abTestName +='AB Test: '+abTestName;  }
				*/

				var productClickObj = {};
				var productClick = [];

				if (angular.isDefined(pkg)) {
					productClickObj['event'] = AnalyticsEnumsService.events.INTERNALPRODUCTCLICK;
					productClickObj['ecommerce'] = {};
					productClickObj['ecommerce']['click'] = {};
				}

				var obj = getProductDetailsFromPackage(pkg);

				if (Package.lastAccessedPackageList) {
					// If the package is not found or the list is empty default to 0.
					// This is to account for the case of users directly to the package details page from the URL.
					var position = Package.lastAccessedPackageList.indexOf(pkg.id);
					obj.position = position > -1 ? position : 0;
				}

				productClick.push(obj);

				productClickObj['ecommerce']['click']['actionField'] = {};
				productClickObj['ecommerce']['click']['actionField']['list'] = lastNavKeyword;
				productClickObj['ecommerce']['click']['products'] = productClick;

				$window[dll].push(productClickObj);
			} catch (e) {
				$log.error("[analytics] Error pushing product click: " + e);
			}
		};

		/**
		 * Triggers analytics event when viewing product details. This happens after Impressions and Product Click.
		 * Product Array will contain each variant (Customer Type Name)
		 * object to the data layer
		 * @param {Event} event The event
		 * @param {Object} pkg  The package
		 * @param {String} kw  The keyword
		 * * @param {String} customerTypes  optional customer types list being displayed
		 * @returns {undefined}
		 */
		this.triggerProductDetailsEnhancedEcommerce = function(event, pkg, kw, displayedCustomerTypes) {
			var customerTypes = Array.isArray(displayedCustomerTypes) ? displayedCustomerTypes : [];
			var pkgObject = {};
			var i;
			var ct;
			var productDetail;
			var productDetailsObj = {};
			var productDetails = [];
			try {
				if (kw) {
					lastNavKeyword = kw;
				}

				if (angular.isDefined(pkg)) {
					productDetailsObj['event'] = AnalyticsEnumsService.events.INTERNALPRODUCTDETAILS;
					productDetailsObj['ecommerce'] = {};
					productDetailsObj['ecommerce']['detail'] = {};
				}

				pkgObject = getProductDetailsFromPackage(pkg);
				if (!customerTypes.length && (pkg.CT || pkg.rates)) {
					customerTypes = pkg.CT || pkg.rates;
				}
				for (i = 0; i < customerTypes.length; i++) {
					ct = customerTypes[i];
					productDetail = angular.copy(pkgObject);
					productDetail.variant = ct.name || ct.cusTypeName;
					if (ct.DYNAMIC_PRICING) {
						productDetail.price = Math.round(parseFloat(ct.DYNAMIC_PRICING.max_discounted_retail_amount || 0) * 100) / 100;
						productDetail.tax = Math.round(parseFloat(ct.DYNAMIC_PRICING.max_discounted_tax_amount || 0) * 100) / 100;
						productDetail.fees = Math.round(parseFloat(ct.DYNAMIC_PRICING.fee_total || 0) * 100) / 100;
					} else {
						productDetail.price = Math.round(parseFloat(ct.price || ct.retail_amount || ct.startRate || ct.cusTypeRetail || 0) * 100) / 100;
						productDetail.tax = Math.round(parseFloat(ct.tax_amount || 0) * 100) / 100;
						productDetail.fees = Math.round(parseFloat(ct.fees || 0) * 100) / 100;
					}
					productDetail.value = Math.round((productDetail.price + productDetail.tax + productDetail.fees) * 100) / 100;
					productDetail.sku = toSKU(pkgObject.id, ct.id);
					productDetails.push(productDetail);
				}

				productDetailsObj['ecommerce']['detail']['actionField'] = {};
				productDetailsObj['ecommerce']['detail']['actionField']['list'] = kw || lastNavKeyword;
				productDetailsObj['ecommerce']['detail']['products'] = productDetails;

				$window[dll].push(productDetailsObj);
			} catch (e) {
				$log.error("[analytics] Error pushing product details: " + e);
			}
		};

		/**
		 * Triggers analytics event when product is added to the cart and pushes product details to the data layer
		 * object to the data layer
		 * @param {Event} event The event
		 * @param {Array} pkgs  The packages
		 * @param {Object} cartResponse  The cart response object
		 * @returns {undefined}
		 */
		this.triggerAddToCartEnhancedEcommerce = function(event, pkgs) {
			try {
				var productDetailsObj = {};
				var productDetails = [];

				if (angular.isDefined(pkgs)) {
					productDetailsObj['event'] = AnalyticsEnumsService.events.INTERNALADDTOCART;
					productDetailsObj['ecommerce'] = {};
					productDetailsObj['ecommerce']['add'] = {};
				}

				productDetails = updateProductQuantities(pkgs, productDetails);
				productDetails = upsellQuicksellCheck(pkgs, productDetails);

				productDetailsObj['ecommerce']['add']['products'] = productDetails;

				$window[dll].push(productDetailsObj);
			} catch (e) {
				$log.error('[analytics] Error pushing add to cart data');
			}
		};
		/**
		 * Triggers an analytics event
		 * @public
		 * @param {Object} eventObject an event object with eventCategory, eventAction, eventLabel, eventValue
		 * @return {undefined}
		 */
		this.triggerAnalyticsEvent = function(eventObject) {
			var newEvent;

			if (!Utilities.objectKeyExists(dll, $window)) {
				//  Data Layer doesn't exist
				return;
			} else if (!isObject(eventObject)) {
				throw new Error('triggerAnalyticsEvent expects an object');
			}

			newEvent = copy(eventObject);
			newEvent.event = AnalyticsEnumsService.events.ANALYTICS_EVENT;
			$window[dll].push(newEvent);
		};

		/**
		 * Triggers an analytics timing event
		 * @public
		 * @param {Object} eventObject an event object with eventCategory, eventAction, eventLabel, eventValue
		 * @return {undefined}
		 */
		this.triggerAnalyticsTimingEvent = function(eventObject) {
			var newEvent;

			if (!isObject(eventObject)) {
				throw new Error('triggerAnalyticsTimingEvent expects an object');
			}

			newEvent = copy(eventObject);
			newEvent.event = AnalyticsEnumsService.events.ANALYTICS_TIMING_EVENT;
			$window[dll].push(newEvent);
		};

		/**
		 * Triggers analytics event when product is removed to the cart and pushes product details to the data layer
		 * object to the data layer
		 * @param {Event} event The event
		 * @param {Object} pkg  The package
		 * @returns {undefined}
		 */
		this.triggerRemoveFromCartEnhancedEcommerce = function(event, pkg) {
			try {
				var productDetailsObj = {};
				var productDetails = [];

				if (angular.isDefined(pkg)) {
					productDetailsObj['event'] = AnalyticsEnumsService.events.INTERNALREMOVEFROMCART;
					productDetailsObj['ecommerce'] = {};
					productDetailsObj['ecommerce']['remove'] = {};
				}

				var obj = getProductDetailsFromPackage(pkg);
				productDetails.push(obj);

				//  Making sure to remove addons with package removal
				if (angular.isArray(pkg.oneBarcodePackages)) {
					pkg.oneBarcodePackages.forEach(function(package) {
						productDetails.push(getProductDetailsFromPackage(package));
					});
				}

				productDetailsObj['ecommerce']['remove']['products'] = productDetails;

				$window[dll].push(productDetailsObj);
			} catch (e) {
				$log.error("[analytics] Error pushing remove from cart data");
			}
		};

		/**
		 * Triggers analytics event when user clicks the "checkout" button on the cartView and pushes checkout object to
		 * the data layer
		 * object to the data layer
		 * @param {Event} event The event
		 * @param {Array} pkgs  The packages
		 * @returns {undefined}
		 */
		this.triggerCheckoutEnhancedEcommerce = function(event, pkgs) {
			try {
				var checkoutObj = {};
				var productDetails = [];

				if (angular.isDefined(pkgs)) {
					checkoutObj['event'] = AnalyticsEnumsService.events.INTERNALCHECKOUT;
					checkoutObj['ecommerce'] = {};
					checkoutObj['ecommerce']['checkout'] = {};
				}
				//  Need to sort the array by ID so that quantities are properly updated
				Utilities.sortArray(pkgs, 'package_id', true);
				productDetails = updateProductQuantities(pkgs, productDetails)

				checkoutObj['ecommerce']['checkout']['actionField'] = {};
				checkoutObj['ecommerce']['checkout']['actionField']['step'] = 1;
				checkoutObj['ecommerce']['checkout']['products'] = productDetails;

				$window[dll].push(checkoutObj);
			} catch (e) {
				$log.error("[analytics] Error pushing checkout");
			}
		};

		/**
		 * Triggers analytics event when user visits the new cart screen
		 * object to the data layer
		 * @param {Event} event The event
		 * @param {Object} cartSummary  The summary of the totals and items in the cart
		 * @param {Number} total  The total amount of the cart
		 * @returns {undefined}
		 */
		this.triggerViewCart = function(event, cartSummary) {
			var checkoutObj = {};
			var products = [];
			var fees = [];
			try {
				checkoutObj['event'] = AnalyticsEnumsService.events.GA4VIEWCART;
				checkoutObj['ecommerce'] = {};
				if (checkProp('cartSummary.cart.items', cartSummary)) {
					products = transformCartForGA4(cartSummary);
					checkoutObj['ecommerce']['currency'] = AppData.currencyCode;
					checkoutObj['ecommerce']['items'] = products;
					checkoutObj['ecommerce']['value'] = cartSummary.pricing.total;
					cartSummary.fees.forEach(function(fee) {
						fees.push({
							amount: fee.amount,
							name: fee.name
						});
					});
					cartSummary.adjustments.forEach(function(adj) {
						fees.push({
							amount: adj.amount,
							name: adj.name
						});
					});
					checkoutObj['ecommerce']['fees'] = fees;
					$window[dll].push(checkoutObj);
				}
				//  Need to sort the array by ID so that quantities are properly updated
			} catch (e) {
				$log.error("[analytics] Error pushing view cart");
			}
		};

		/**
		 * Triggers analytics event when user begins the checkout on the new cart screen
		 * object to the data layer
		 * @param {Event} event The event
		 * @param {Object} cartSummary  The summary of the totals and items in the cart
		 * @param {Number} total  The total amount of the cart
		 * @returns {undefined}
		 */
		this.triggerBeginCheckout = function(event, cartSummary) {
			var checkoutObj = {};
			var products = [];
			var fees = [];
			var discount;
			try {
				checkoutObj['event'] = AnalyticsEnumsService.events.GA4BEGINCHECKOUT;
				checkoutObj['ecommerce'] = {};
				if (checkProp('cartSummary.cart.items', cartSummary)) {
					// Capture discount context for the subsequent purchase event
					discount = cartSummary.discount && cartSummary.discount.valid ? cartSummary.discount : null;
					checkoutDiscount = discount;
					// Build the set of discounted package IDs, including any pre-swap IDs.
					// The purchase event loop uses preswap_package_id for swapped packages,
					// so both the post-swap cart ID and the original pre-swap ID are needed
					// to correctly enrich those items at purchase time.
					checkoutDiscountedPackageIds = discount
						? cartSummary.cart.items
							.filter(function hasDiscount(item) { return item.flags.hasDiscount; })
							.reduce(function collectPackageIds(ids, item) {
								var preswapId = checkProp('item.characs.0.preswap_package_id', item, 'returnValue');
								ids.push(String(item.package.id));
								if (preswapId) {
									ids.push(String(preswapId));
								}
								return ids;
							}, [])
						: null;

					products = transformCartForGA4(cartSummary);
					checkoutObj['ecommerce']['currency'] = AppData.currencyCode;
					checkoutObj['ecommerce']['items'] = products;
					checkoutObj['ecommerce']['value'] = cartSummary.pricing.total;
					cartSummary.fees.forEach(function(fee) {
						fees.push({
							amount: fee.amount,
							name: fee.name
						});
					});
					cartSummary.adjustments.forEach(function(adj) {
						fees.push({
							amount: adj.amount,
							name: adj.name
						});
					});
					checkoutObj['ecommerce']['fees'] = fees;
					$window[dll].push(checkoutObj);
				}
				//  Need to sort the array by ID so that quantities are properly updated
			} catch (e) {
				$log.error("[analytics] Error pushing begin checkout data");
			}
		};

		/**
		 * Triggers analytics event when on billing screen and pushes checkout and delivery objects to the data layer
		 * object to the data layer
		 * @param {Event} event The event
		 * @param {String} deliveryMethod  The delivery method
		 * @returns {undefined}
		 */
		this.triggerCheckoutBillingEnhancedEcommerce = function(event, deliveryMethod) {
			try {
				var checkoutObj = {};

				checkoutObj['event'] = AnalyticsEnumsService.events.INTERNALCHECKOUTBILLING;
				checkoutObj['ecommerce'] = {};
				checkoutObj['ecommerce']['checkout'] = {};
				checkoutObj['ecommerce']['checkout']['actionField'] = {};
				checkoutObj['ecommerce']['checkout']['actionField']['step'] = 2;

				$window[dll].push(checkoutObj);

				// Pushing delievery Method for Six Flags
				$window[dll].push({ deliveryMethod: deliveryMethod });
			} catch (e) {
				$log.error("[analytics] Error pushing checkout billing");
			}
		};

		/**
		 * Triggers analytics event for payment method screen when user clicks on each payment type and pushes a checkout
		 * object to the data layer
		 * @param {Event} event the event
		 * @param {String} type the payment type
		 * @returns {undefined}
		 */
		this.triggerPaymentSelectionEnhancedEcommerce = function(event, type) {
			try {
				var checkoutObj = {};

				checkoutObj['event'] = AnalyticsEnumsService.events.INTERNALPAYMENTSELECT;
				checkoutObj['ecommerce'] = {};
				checkoutObj['ecommerce']['click'] = {};
				checkoutObj['ecommerce']['click']['paymentSelected'] = type;

				$window[dll].push(checkoutObj);
			} catch (e) {
				$log.error("[analytics] Error pushing payment method selection");
			}
		};

		/**
		 * Checkout Url event for GA/3rd party cart abandonment
		 * @param {*} event
		 */
		this.triggerCheckoutUrl = function( event ) {
			try {
				var checkoutUrlObj = {};
				checkoutUrlObj['event'] = AnalyticsEnumsService.events.CHECKOUTURL;
				if(analyticsDataLayerConfig.sendCheckoutUrl) {
					var checkoutUrl = 'https://' + $window.location.host + '/cartView';
					var search = $location.search();
					var queryParams = {
						'cart_id': AppData.cart.cart_id,
						'cart_key': AppData.cart.cart_key
					};
					var paramsToAddFromCurrUrl = ['l','_m','merchant_id','emerchant_id','variant_id','navTreeVersion','brandmode','brandmodenav'];
					paramsToAddFromCurrUrl.forEach(function appendParam(paramKey) {
						if (search[paramKey]) {
							queryParams[paramKey] = search[paramKey];
						}
					});
					checkoutUrl = checkoutUrl + '?' + UrlUtils.objectToQueryParams(queryParams);
					AppData.fetch('GetShortUrl', false, { original_url: checkoutUrl }, true, false, false, true).then(function(shortUrlResponse) {
						if (shortUrlResponse && shortUrlResponse.short_url) {
							checkoutUrlObj['checkoutUrl'] = shortUrlResponse.short_url;
							$window[dll].push(checkoutUrlObj);
						}
					});
				}

			} catch (e) {
				$log.error("[analytics] Error pushing checkout url event");
			}
		}

		/**
		 * Triggers analytics event for shipping screen when user clicks on each shipping method and pushes checkout
		 * object to the data layer
		 * @param {Event} event the event
		 * @param {String} shippingType the shipping type
		 * @returns {undefined}
		 */
		this.triggerShippingSelectionEnhancedEcommerce = function(event, shippingType) {
			try {
				var checkoutObj = {};

				checkoutObj['event'] = AnalyticsEnumsService.events.INTERNALSHIPPINGSELECT;
				checkoutObj['ecommerce'] = {};
				checkoutObj['ecommerce']['click'] = {};
				checkoutObj['ecommerce']['click']['shippingMethodSelected'] = shippingType;

				$window[dll].push(checkoutObj);
			} catch (e) {
				$log.error("[analytics] Error pushing shipping method selection");
			}
		};

		/**
		 * Triggers analytics event for next click on the billing info page and prepaid card object to the data layer
		 * @param {Event} event the event
		 * @param {String} paymentMethod the payment method
		 * @param {Object} billingInfo the billing information object
		 * @returns {undefined}
		 */
		this.triggerCheckoutPaymentInfoEnhancedEcommerce = function(event, paymentMethod, billingInfo) {
			try {
				var checkoutObj = {};

				checkoutObj['event'] = AnalyticsEnumsService.events.INTERNALCHECKOUTPAYMENTINFO;
				checkoutObj['ecommerce'] = {};
				checkoutObj['ecommerce']['checkout'] = {};
				checkoutObj['ecommerce']['checkout']['actionField'] = {};
				checkoutObj['ecommerce']['checkout']['actionField']['step'] = 3;
				// checkoutObj['ecommerce']['checkout']['actionField']['option'] = paymentMethod;

				$window[dll].push(checkoutObj);
			} catch (e) {
				$log.error("[analytics] Error pushing checkout payment info");
			}
		};

		/**
		 * Triggers analytics event for when user clicks on the info button on the Payment Screen and pushes prepaid
		 * card object to the data layer
		 * @param {Event} event the event
		 * @returns {undefined}
		 */
		this.triggerPrepaidCardModal = function(event) {
			try {
				var prepaidCardClickObj = {};

				prepaidCardClickObj['event'] = AnalyticsEnumsService.events.PREPARD_CARD_MODAL;

				$window[dll].push(prepaidCardClickObj);
			} catch (e) {
				$log.error("[analytics] Error prepaid card modal click event");
			}
		};

		/**
		 * Triggers analytics event for when user gets to order review and checkout object to the data layer
		 * @param {Event} event the event
		 * @param {String} cardType the card type
		 * @returns {undefined}
		 */
		this.triggerCheckoutOrderReviewEnhancedEcommerce = function(event, cardType) {
			try {
				var checkoutObj = {};

				checkoutObj['event'] = AnalyticsEnumsService.events.INTERNALCHECKOUTORDERREVIEW;
				checkoutObj['ecommerce'] = {};
				checkoutObj['ecommerce']['checkout'] = {};
				checkoutObj['ecommerce']['checkout']['actionField'] = {};
				checkoutObj['ecommerce']['checkout']['actionField']['step'] = 4;
				checkoutObj['ecommerce']['checkout']['actionField']['paymentType'] = cardType;

				$window[dll].push(checkoutObj);
			} catch (e) {
				$log.error("[analytics] Error pushing checkout order review");
			}
		};

		/**
		 * Triggers internal page view event and pushes client info to the data layer
		 * @returns {undefined}
		 */
		this.triggerInternalPageView = function() {
			if (($rootScope.enable_pageview || $rootScope.previousRoute === '') && lastState != $state.current.name) {
				$window[dll].push({ event: AnalyticsEnumsService.events.INTERNALPAGEVIEW });
				lastState = $state.current.name;

				//  decide if we should fire other page view events as well
				try {
					if (ClientInfo.deviceType === "desktop") {
						$window[dll].push({ event: AnalyticsEnumsService.events.INTERNALPAGEVIEW_DESKTOP });
					}

					if (ClientInfo.deviceType === "tablet") {
						$window[dll].push({ event: AnalyticsEnumsService.events.INTERNALPAGEVIEW_TABLET });
					}

					if (ClientInfo.deviceType === "mobile") {
						$window[dll].push({ event: AnalyticsEnumsService.events.INTERNALPAGEVIEW_MOBILE });
					}

					if (Array.isArray($window._hmt)) {
						$window._hmt.push(['_trackPageview', $window.location]);
					}
				} catch (e) {
					$log.error("[analytics] Error dispatching specific event for mobile/desktop device detection.", e);
				}
			}

			$rootScope.enable_pageview = false;
		};

		/**
		 * Triggers internal page event and pushes the URL to the data layer
		 * @param {String} url the url
		 * @returns {undefined}
		 */
		this.triggerInternalPageViewWithURL = function(url) {
			try {
				AnalyticsVirtualURLService.overrideCurrentUrl(url);
				this.triggerInternalPageView();
			} catch (e) {
				$log.error("[analytics] Failed to trigger internal pageview: ", e);
			}
		};

		/**
		 * Triggered an event on state change or each page load.
		 * @public
		 * @returns {undefined}
		 */
		this.triggerInternalStateChange = function() {
			try {
				$window[dll].push({ event: AnalyticsEnumsService.events.INTERNALSTATECHANGE });
				if (Array.isArray($window._hmt)) {
					$window._hmt.push(['_trackPageview', $window.location]);
				}
				$rootScope.$broadcast(AnalyticsEnumsService.events.POST_INTERNALSTATECHANGE);
			} catch (e) {
				$log.error('[analytics] Failed to trigger internal state change: ', e);
			}
		};

		/**
		 * Push data layer objects to characs array if they are allowed
		 * @param {Array} characs characs array
		 * @returns {undefined}
		 */
		this.dataLayerObjectsToCharacs = function(characs) {
			if (checkProp('AppData.settings.allowedOrderCharacs', AppData)) {
				this.characsStore.forEach(function(c) {
					var thisObject = {};
					thisObject[c.k] = c.v;
					if (AppData.settings.allowedOrderCharacs.indexOf((c.k).toLowerCase()) > -1) {
						characs.push(thisObject);
					}
				});
			}
		};

		/**
		 * Prepares data later after purchase event
		 * @param {Event} event event details
		 * @param {Object} data PurchaseResponse object
		 * @returns {undefined}
		 */
		this.prepareDataLayerUpdateAfterPurchase = function(event, data) {
			if (checkProp("data.purchaseResponse.order_id", data)) {
				possibleOrderId = data.purchaseResponse.order_id;
			} else {
				possibleOrderId = undefined;
			}
		};

		/**
		 * Updates data layer with purchase information
		 * @param {Event} event event details
		 * @param {Object} data ViewOrderResponse object
		 * @returns {undefined}
		 */
		this.updateDataLayerWithPurchase = function(event, data) {
			var customerData;
			try {
				if (possibleOrderId === undefined && checkProp("data.viewOrderResponse.VIEW_ORDER_REPLY.ORDER_STATUS_REPLY.order_id", data, function(v) {
					return Number(v) === Number(possibleOrderId);
				})) {
					//  notify errorTracking
					_log(ERROR_PREFIX + 'Did not have possibleOrderId match ', null, possibleOrderId);
					return;
				}

				var r = data.viewOrderResponse;
				var transactionObject = {};

				transactionObject['event'] = AnalyticsEnumsService.events.PURCHASE;

				//  Customer Information
				if (checkProp('r.VIEW_ORDER_REPLY.CUSTOMER_DETAILS_REPLY.CUSTOMER', r, 'isRealObject')) {
					customerData = r.VIEW_ORDER_REPLY.CUSTOMER_DETAILS_REPLY.CUSTOMER
					transactionObject.firstName = customerData.first_name;
					transactionObject.lastName = customerData.last_name;
					if (customerData.EMAIL) {
						transactionObject.email = customerData.EMAIL.address;
						transactionObject.optin = customerData.EMAIL.opt_in;
					}
					if (customerData.ADDRESS) {
						transactionObject.country = customerData.ADDRESS.country;
						transactionObject.state = customerData.ADDRESS.state;
						transactionObject.postalcode = customerData.ADDRESS.zip;
					}
				}
				if (checkProp('r.VIEW_ORDER_REPLY.ORDER_ITEMS_REPLY.TOTALS.cart_adjustment_total', r)) {
					transactionObject.fee = r.VIEW_ORDER_REPLY.ORDER_ITEMS_REPLY.TOTALS.cart_adjustment_total;
				}

				for (var optin = 1; optin < AppData.optins.length; optin++) {
					transactionObject['partneremails'] = AppData.optins[optin].checked;
				}

				//  create the individual products.
				var items = checkProp('r.VIEW_ORDER_REPLY.TICKET_DETAILS_REPLY.TICKET', r, 'returnValue'); // r.VIEW_ORDER_REPLY.ORDER_ITEMS_REPLY.ITEM;
				if (UtilsValidation.isRealObject(items)) {
					items = [items];
				} else if (!Array.isArray(items)) {
					items = [];
				}

				items = items.filter(function(i) {
					return i["ticket_id"] !== undefined;
				});

				//  group based on customer type + package id
				var products = [];

				items.forEach(function(i) {
					var packageDetails,
						packageId;

					/**
					 * This function converts values sent from backend for packageType.
					 * Values passed C, P, N
					 * @param {String} promo of promo package from packageDetails
					 * @returns {String} Promotional, Normal or Complimentary based on the input from backend, or original promo value if not matched.
					 */
					function isPromoPackage(promo) {
						switch (promo) {
						case 'P':
							return 'Promotional';
							break;
						case 'N':
							return 'Normal';
							break;
						case 'C':
							return 'Complimentary';
							break;
						default:
							return promo;
						}
					}

					//  Check for aliased package
					if (checkProp('Package.CHARACS.preswap_package_id', i)) {
						packageDetails = Package.getPackageByID(i.CHARACS.preswap_package_id);
						packageId = i.CHARACS.preswap_package_id;
					} else if (checkProp('Package.CHARACS.0.preswap_package_id', i)) {
						packageDetails = Package.getPackageByID(i.CHARACS[0].preswap_package_id);
						packageId = i.CHARACS[0].preswap_package_id;
					} else {
						var id = i.package_id || i.id;
						packageDetails = Package.getPackageByID(id);
						packageId = id;
					}

					//  extract anything with the same rate type and package_id
					if (inProductArray(products, packageId, i.customer_type_id)) {
						products[indexOfSKU(products, packageId, i.customer_type_id)].quantity++;

						if (angular.isDefined(products[indexOfSKU(products, packageId, i.customer_type_id)]['seasonPass'])) {
							// Add Season Pass/Membership info if it is available.
							var seasonPassObj = addSeasonPassInfo(r, i);
							// Checking if the object is defined, and has valid season pass info in it before pushing.
							if (angular.isDefined(seasonPassObj) && !Utilities.isEmpty(seasonPassObj) && angular.isDefined(seasonPassObj.firstName)) {
								if (angular.isUndefined(products[indexOfSKU(products, packageId, i.customer_type_id)]['seasonPass'])) {
									products[indexOfSKU(products, packageId, i.customer_type_id)]['seasonPass'] = [];
								}

								products[indexOfSKU(products, packageId, i.customer_type_id)]['seasonPass'].push(seasonPassObj);
							}
						}
					} else {
						//  Calculate date
						var date = '';
						if (checkProp('i.EVENT.start_date', i)) {
							date = i.EVENT.start_date;
						} else if (angular.isDefined(i.CHARACS)) {
							if (angular.isDefined(i.CHARACS.valid_from)) {
								date = i.CHARACS.valid_from;
							} else if (angular.isDefined(i.CHARACS[0]) && angular.isDefined(i.CHARACS[0].valid_from)) {
								date = i.CHARACS[0].valid_from;
							}
						}

						var obj = {
							sku: toSKU(packageId, i.customer_type_id),
							id: packageId,
							name: i.package_name,
							category: i.package_class,
							brand: AppData.settings.merchant || AppData.settings.merchant_uid,
							price: Number(i.retail),
							promoPackage: isPromoPackage(i.type),
							quantity: 1,
							variant: i.customer_type_name,
							customer_type_name: i.customer_type_name,
							tax: i.tax_amount,
							date: date,
							time: checkProp('i.EVENT.start_time', i) ? i.EVENT.start_time : '',
							paymentmethod: checkProp('r.VIEW_ORDER_REPLY.PAYMENT_DETAILS.PAYMENT.0.billing_type_desc', r, 'returnValue') || '', // Updated to allow payment method to be pushed to the main array for ApplePay
							payment_method_desc: checkProp('r.VIEW_ORDER_REPLY.PAYMENT_DETAILS.PAYMENT.0.billing_provider_desc', r, 'returnValue') || '', // Additional Support for ApplePay/GooglePay
							currency: AppData.currencyCode,
							numberOfUnavailableDates: checkProp('i.CHARACS.numberOfUnavailableDates', i) ? i.CHARACS.numberOfUnavailableDates : '',
							numberOfUnavailableTimes: checkProp('i.CHARACS.numberOfUnavailableTimes', i) ? i.CHARACS.numberOfUnavailableTimes : ''
						};
						/*
						 * AXF 7117
						 * SixFlags' analytics implementation relies upon the sku property to be the value of PLU.
						 * This will override just for their island.
						 */
						if (AppData.island.toLowerCase() === 'sixflagsv3') {
							if (checkProp('packageDetails.CT', packageDetails)) {
								for (var x = 0; x < packageDetails.CT.length; x++) {
									//  Found the right CT
									if (packageDetails.CT[x].id === i.customer_type_id) {
										obj.sku = packageDetails.CT[x].plu;
										break;
									}
								}
							}
						}

						if (checkProp('i.FEE.amount', i)) {
							obj['fee'] = i.FEE.amount;
						}

						//  Add promo code if it was used.
						if (angular.isDefined(i.referrer)) {
							obj['coupon'] = i.referrer;
						}

						// Enrich with discount fields if this package received a discount at checkout
						if (checkoutDiscount && checkoutDiscountedPackageIds && checkoutDiscountedPackageIds.indexOf(String(packageId)) !== -1) {
							merge(obj, {
								// eslint-disable-next-line camelcase
								discount_code: checkoutDiscount.code,
								// eslint-disable-next-line camelcase
								discount_type: CartEnums.discount.toAnalyticsType(checkoutDiscount.type),
								// discount_value: monetary amount for FIXED types; percentage integer (e.g. 10 = 10%) for PERCENTAGE types.
								// Consumers must check discount_type to interpret the unit.
								// eslint-disable-next-line camelcase
								discount_value: checkoutDiscount.value,
								// eslint-disable-next-line camelcase
								campaign_tag: checkoutDiscount.campaignTag || null
							});
						}

						if (angular.isDefined(i.CHARACS)) {
							//  Add gift code if it was used.
							if (angular.isDefined(i.CHARACS.gift_code)) {
								obj['gift_code'] = i.CHARACS.gift_code;
								obj['dimension1'] = i.CHARACS.gift_code;
							}

							var seasonPassObj = addSeasonPassInfo(r, i);

							//  Checking if the object is defined, and has valid season pass info in it before pushing.
							if (angular.isDefined(seasonPassObj) && !Utilities.isEmpty(seasonPassObj) && angular.isDefined(seasonPassObj.firstName)) {
								obj['seasonPass'] = [];
								obj['seasonPass'].push(seasonPassObj);
							}
						}

						if (analyticsDataLayerConfig.push_annualized_pricing) {
							if (checkProp('packageDetails.CT', packageDetails)) {
								for (var x = 0; x < packageDetails.CT.length; x++) {
									if (packageDetails.CT[x].id === i.customer_type_id && packageDetails.CT[x].PAYMENT_SCHEDULE) {
										obj.price *= parseInt(packageDetails.CT[x].PAYMENT_SCHEDULE.required_num_payments, 10);
										obj.price = Number.parseFloat(obj.price);
										break;
									}
								}
							}
						}

						obj.total = Math.round(((obj.price || 0) + (obj.tax || 0)) * 100) / 100;

						products.push(obj);
					}
				});

				//  Fill the transaction object

				//  If the client is using enhanced ecommerce, use GA's enhanced ecommerce structure for products.
				if (angular.isDefined(AppData.settings.enhancedEcommerce) && AppData.settings.enhancedEcommerce) {
					transactionObject['ecommerce'] = {};
					transactionObject['ecommerce']['purchase'] = {};

					// Add action field
					transactionObject['ecommerce']['purchase']['actionField'] = {};
					actionField.forEach(function(m) {
						if (checkProp("r." + m.responseProp, r, function(v) {
							if (m.format === 'string') {
								transactionObject['ecommerce']['purchase']['actionField'][m.dataLayerKey] = String(v);
							} else {
								transactionObject['ecommerce']['purchase']['actionField'][m.dataLayerKey] = Number(v);
							}

							return true;
						}) == false) {
							transactionObject['ecommerce']['purchase']['actionField'][m.dataLayerKey] = m.defaultValue;
						}
					});

					// Adding Order Characs into data layer
					addingOrderCharacs(r);

					// Check if purchase was through an affiliate store.
					if (($window.location.href).indexOf('merchant_id') > -1 && ($window.location.href).indexOf('emerchant_id') > -1) {
						transactionObject['ecommerce']['purchase']['actionField']['affiliation'] = AnalyticsEnumsService.settings.TRANSACTION_AFFILIATIONOTHER;
					} else {
						transactionObject['ecommerce']['purchase']['actionField']['affiliation'] = AnalyticsEnumsService.settings.TRANSACTION_AFFILIATIONSHOPLAND;
					}

					// Add products
					transactionObject['ecommerce']['purchase']['products'] = products;

					/**
					 * Adds order characs to the transaction object
					 * @param {Object} data data object
					 * @returns {undefined}
					 */
					function addingOrderCharacs(data) {
						var orderCharacs = {};

						if (checkProp('data.VIEW_ORDER_REPLY.ORDER_STATUS_REPLY.CHARACS', data) && checkProp('AppData.settings.allowedOrderCharacs', AppData)) {
							var allowedCharacsAppConfig = eval(AppData.settings.allowedOrderCharacs);
							var characsList = data.VIEW_ORDER_REPLY.ORDER_STATUS_REPLY.CHARACS;
							var dataLayerOrderCharacs = {};

							allowedCharacsAppConfig.forEach(function(charac) {
								if (angular.isDefined(characsList[charac])) {
									dataLayerOrderCharacs[charac] = characsList[charac];
								}
							});

							transactionObject['ecommerce']['purchase']['orderCharacs'] = dataLayerOrderCharacs;
						}
					}
				} else {
					// Add base elements
					baseModel.forEach(function(m) {
						if (checkProp("r." + m.responseProp, r, function(v) {
							if (m.format === 'string') {
								transactionObject[m.dataLayerKey] = String(v);
							} else {
								transactionObject[m.dataLayerKey] = Number(v);
							}

							return true;
						}) == false) {
							transactionObject[m.dataLayerKey] = m.defaultValue;
						}
					});

					// Check if purchase was through an affiliate store.
					if (($window.location.href).indexOf('merchant_id') > -1 && ($window.location.href).indexOf('emerchant_id') > -1) {
						transactionObject['transactionAffiliation'] = AnalyticsEnumsService.settings.TRANSACTION_AFFILIATIONOTHER;
					} else {
						transactionObject['transactionAffiliation'] = AnalyticsEnumsService.settings.TRANSACTION_AFFILIATIONSHOPLAND;
					}

					// Add products
					transactionObject['transactionProducts'] = products;
				}

				// Push transaction object to the data-layer
				$window[dll].push(transactionObject);

				// GA4 purchase event — fires alongside the legacy UA event for forward compatibility
				var ga4OrderId = String(checkProp('r.VIEW_ORDER_REPLY.ORDER_STATUS_REPLY.order_id', r, 'returnValue') || '');
				var ga4Value = Number(checkProp('r.VIEW_ORDER_REPLY.ORDER_ITEMS_REPLY.TOTALS.current_total', r, 'returnValue') || 0);
				var ga4Tax = Number(checkProp('r.VIEW_ORDER_REPLY.ORDER_ITEMS_REPLY.TOTALS.tax_total', r, 'returnValue') || 0);

				// Pre-compute total discounted quantity for FIXED_AMOUNT per-item distribution
				var totalDiscountedQty = 0;
				if (checkoutDiscount && checkoutDiscount.type === 'FIXED_AMOUNT') {
					products.forEach(function(p) {
						if (p.discount_code !== undefined) {
							totalDiscountedQty += p.quantity;
						}
					});
				}

				var ga4Items = products.map(function(p) {
					var hasDiscount = p.discount_code !== undefined;
					var retail = p.price || 0;
					var tax = parseFloat(p.tax) || 0;
					var postPrice, postTax;

					// checkoutDiscount is guaranteed non-null when hasDiscount is true:
					// discount_code is only merged onto p inside the UA enrichment block,
					// which itself requires checkoutDiscount to be truthy.
					if (hasDiscount) {
						if (checkoutDiscount.type === 'PERCENTAGE') {
							var rate = 1 - checkoutDiscount.value / 100;
							postPrice = Math.round(retail * rate * 100) / 100;
							postTax = Math.round(tax * rate * 100) / 100;
						} else if (checkoutDiscount.type === 'FIXED_AMOUNT' && totalDiscountedQty > 0) {
							// Even split is an approximation — rounding may cause a £0.01 discrepancy
							// across items. Acceptable for analytics; do not use for billing.
							var perItemDiscount = Math.round(checkoutDiscount.value / totalDiscountedQty * 100) / 100;
							postPrice = Math.max(0, Math.round((retail - perItemDiscount) * 100) / 100);
							postTax = retail > 0 ? Math.max(0, Math.round(tax * postPrice / retail * 100) / 100) : 0;
						} else {
							postPrice = retail;
							postTax = tax;
						}
					} else {
						postPrice = retail;
						postTax = tax;
					}

					var ga4Item = {
						affiliation: AppData.settings.merchant || AppData.settings.merchant_uid,
						// eslint-disable-next-line camelcase
						item_id: String(p.id),
						// eslint-disable-next-line camelcase
						item_name: p.name,
						// eslint-disable-next-line camelcase
						item_brand: p.brand,
						// eslint-disable-next-line camelcase
						item_variant: p.variant,
						price: postPrice,
						tax: postTax,
						total: Math.round((postPrice + postTax) * 100) / 100,
						quantity: p.quantity,
						sku: p.sku
					};

					if (hasDiscount) {
						// eslint-disable-next-line camelcase
						ga4Item.discount_code = p.discount_code;
						// eslint-disable-next-line camelcase
						ga4Item.discount_type = p.discount_type;
						// eslint-disable-next-line camelcase
						ga4Item.discount_value = p.discount_value;
						if (p.campaign_tag) {
							// eslint-disable-next-line camelcase
							ga4Item.campaign_tag = p.campaign_tag;
						}
					}

					return ga4Item;
				});

				var ga4PurchaseObj = {
					event: AnalyticsEnumsService.events.GA4PURCHASE,
					ecommerce: {
						// eslint-disable-next-line camelcase
						transaction_id: ga4OrderId,
						value: ga4Value,
						tax: ga4Tax,
						currency: AppData.currencyCode,
						items: ga4Items
					}
				};

				if (checkoutDiscount) {
					ga4PurchaseObj.ecommerce.coupon = checkoutDiscount.code;
				}

				$window[dll].push(ga4PurchaseObj);

				if (Array.isArray($window._hmt) && transactionObject.ecommerce && transactionObject.ecommerce.purchase) {
					$window._hmt.push(['_trackOrder', {
						orderId: '"' + transactionObject.ecommerce.purchase.actionField.id + '"',
						orderTotal: transactionObject.ecommerce.purchase.actionField.revenue,
						item: products.map(function(product) {
							return {
								category: product.category,
								Price: product.price,
								Currency: AppData.currencyCode,
								Quantity: product.quantity,
								skuId: product.sku,
								skuName: product.name
							};
						})
					}]);
				}
			} catch (e) {
				//  notify errorTracking of error
				_log(new Error(ERROR_PREFIX + 'Error Pushing Trasaction'), e, possibleOrderId);
			} finally {
				possibleOrderId = undefined;
				// Clear checkout discount context so a subsequent no-discount purchase
				// in the same session does not carry stale data
				checkoutDiscount = null;
				checkoutDiscountedPackageIds = null;
			}
		};


		/**
		 * Adds season pass information to object and returns it
		 * @param {Object} r order reply object
		 * @param {Object} i season pass membership information object
		 * @returns {undefined}
		 */
		function addSeasonPassInfo(r, i) {
			// Add Season Pass/Membership info if it is available.
			var seasonPassObj = {};
			if (angular.isDefined(i.CHARACS.ph_first_name)) {
				seasonPassObj['firstName'] = i.CHARACS.ph_first_name;
			}
			if (angular.isDefined(i.CHARACS.ph_last_name)) {
				seasonPassObj['lastName'] = i.CHARACS.ph_last_name;
			}
			if (angular.isDefined(i.CHARACS.ph_email)) {
				seasonPassObj['email'] = i.CHARACS.ph_email;
			}
			if (angular.isDefined(i.CHARACS.ph_age)) {
				seasonPassObj['age'] = i.CHARACS.ph_age;
			}
			if (angular.isDefined(i.CHARACS.ph_zip)) {
				seasonPassObj['postalcode'] = i.CHARACS.ph_zip;
			}
			if (checkProp('r.VIEW_ORDER_REPLY.ORDER_STATUS_REPLY.ship_method', r, 'validString') && angular.isDefined(seasonPassObj)) {
				seasonPassObj['deliverymethod'] = r.VIEW_ORDER_REPLY.ORDER_STATUS_REPLY.ship_method;
			}
			if (checkProp('r.VIEW_ORDER_REPLY.PAYMENT_DETAILS', r, 'isRealObject') &&
				angular.isDefined(r.VIEW_ORDER_REPLY.PAYMENT_DETAILS.PAYMENT) &&
				angular.isDefined(r.VIEW_ORDER_REPLY.PAYMENT_DETAILS.PAYMENT[0].billing_type_desc) &&
				angular.isDefined(seasonPassObj)) {
				seasonPassObj['paymentmethod'] = r.VIEW_ORDER_REPLY.PAYMENT_DETAILS.PAYMENT[0].billing_type_desc;
			}

			return seasonPassObj;
		}

		/**
		 * Triggers cart abandonment event and pushes it to the data layer
		 * @returns {undefined}
		 */
		this.triggerCartAbandonment = function() {
			var CartAbandonmentObj = {};
			try {
				CartAbandonmentObj['event'] = AnalyticsEnumsService.events.CARTABANDONMENTVIEW;

				// Push the transaction object to the data-layer
				$window[dll].push(CartAbandonmentObj);
			} catch (e) {
				$log.error("[analytics] Error pushing cart abandonment");
			}
		};

		/**
		 * Triggers save cart event and pushes it to the data layer
		 * @returns {undefined}
		 */
		this.triggerSaveCart = function() {
			var CartAbandonmentObj = {};
			try {
				CartAbandonmentObj['event'] = AnalyticsEnumsService.events.SAVECART;

				// Push the transaction object to the data-layer
				$window[dll].push(CartAbandonmentObj);
			} catch (e) {
				$log.error("[analytics] Error pushing cart save");
			}
		};

		/**
		 * Triggers continue shopping event and pushes it to the data layer
		 * @returns {undefined}
		 */
		this.triggerContinueShopping = function() {
			var CartAbandonmentObj = {};
			try {
				CartAbandonmentObj['event'] = AnalyticsEnumsService.events.CONTINUESHOPPING;

				// Push transaction object to the data-layer
				$window[dll].push(CartAbandonmentObj);
			} catch (e) {
				$log.error("[analytics] Error pushing continue shopping");
			}
		};

		/**
		 * Triggers close store event and pushes it to the data layer
		 * @returns {undefined}
		 */
		this.triggerCloseStore = function() {
			var CartAbandonmentObj = {};
			try {
				CartAbandonmentObj['event'] = AnalyticsEnumsService.events.CLOSESTORE;

				// Push transaction object to the data-layer
				$window[dll].push(CartAbandonmentObj);
			} catch (e) {
				$log.error("[analytics] Error pushing close store");
			}
		};

		/**
		 * Triggers view video event and pushes it to the data layer
		 * @returns {undefined}
		 */
		this.triggerVideoView = function() {
			var videoObj = {};
			try {
				videoObj['event'] = AnalyticsEnumsService.events.VIDEOVIEW;

				// Push transaction object to the data-layer
				$window[dll].push(videoObj);
			} catch (e) {
				$log.error("[analytics] Error pushing video view");
			}
		};

		/**
		 * Triggers open season pass event and pushes it to the data layer
		 * @returns {undefined}
		 */
		this.triggerSeasonPassOpen = function() {
			var eventObj = {};
			try {
				eventObj['event'] = AnalyticsEnumsService.events.SEASONPASSOPEN;

				// Push transaction object to the data-layer
				$window[dll].push(eventObj);
			} catch (e) {
				$log.error("[analytics] Error pushing season pass open event");
			}
		};

		/**
		 * Triggers push season pass info event and pushes it to the data layer
		 * @param {Event} event push season pass info event
		 * @param {Object} formData Form data
		 * @returns {undefined}
		 */
		this.triggerPushSeasonPassInfo = function(event, formData) {
			var seasonPassObj = {};
			try {
				seasonPassObj['event'] = AnalyticsEnumsService.events.SEASONPASSINFO;

				$window[dll].push(seasonPassObj);
			} catch (e) {
				$log.error("[analytics] Error pushing season pass info");
			}
		};

		/**
		 * Triggers unassigned modal show event and pushes it to the data layer
		 * @param {Event} event Unassigned modal show event
		 * @returns {undefined}
		 */
		this.triggerUnassignedModalShow = function(event) {
			var assignObj = {};
			try {
				assignObj['event'] = AnalyticsEnumsService.events.UNASSIGNEDMODALSHOW;

				$window[dll].push(assignObj);
			} catch (e) {
				$log.error("[analytics] Error pushing unassigned modal show event");
			}
		};

		/**
		 * Triggers unassigned page view event and pushes it to the data layer
		 * @param {Event} event Unassigned page view event
		 * @returns {undefined}
		 */
		this.triggerUnassignedPageView = function(event) {
			var assignObj = {};
			try {
				assignObj['event'] = AnalyticsEnumsService.events.UNASSIGNEDPAGEVIEW;

				$window[dll].push(assignObj);
			} catch (e) {
				$log.error("[analytics] Error pushing unassigned page view event");
			}
		};

		/**
		 * Triggers unassigned passholder assign event and pushes it to the data layer
		 * @param {Event} event Unassigned passholder assign event
		 * @returns {undefined}
		 */
		this.triggerUnassignedPassholderAssign = function(event) {
			var assignObj = {};
			try {
				assignObj['event'] = AnalyticsEnumsService.events.UNASSIGNEDPASSHOLDERASSIGN;

				$window[dll].push(assignObj);
			} catch (e) {
				$log.error("[analytics] Error pushing unassigned passholder assign event");
			}
		};

		/**
		 * Triggers unassigned passholder skip event and pushes it to the data layer
		 * @param {Event} event Unassigned passholder skip event
		 * @returns {undefined}
		 */
		this.triggerUnassignedPassholderSkip = function(event) {
			var assignObj = {};
			try {
				assignObj['event'] = AnalyticsEnumsService.events.UNASSIGNEDPASSHOLDERSKIP;

				$window[dll].push(assignObj);
			} catch (e) {
				$log.error("[analytics] Error pushing unassigned passholder skip event");
			}
		};

		/**
		 * Trigger social media click event and pushes it to the data layer
		 * @param {Event} event Social media click event
		 * @param {Object} data Social media data
		 * @returns {undefined}
		 */
		this.triggerSocialMediaClick = function(event, data) {
			var socialMediaObj = {};
			try {
				socialMediaObj['event'] = AnalyticsEnumsService.events.SOCIALMEDIACLICK;
				socialMediaObj['link'] = {
					label: data.label,
					url: data.url
				};

				$window[dll].push(socialMediaObj);
			} catch (e) {
				$log.error("[analytics] Error pushing social media click event");
			}
		};

		/**
		 * Triggers analytics for event module and pushes module object to the data layer
		 * @param {Event} event Module event
		 * @param {String} module Module name
		 * @param {String} eventName Event name
		 * @param {Object} value Event value
		 * @returns {undefined}
		 */
		this.triggerModuleEvent = function(event, module, eventName, value) {
			try {
				var moduleObj = {};
				moduleObj['event'] = eventName;
				moduleObj[module] = {};
				moduleObj[module][eventName] = value;

				$window[dll].push(moduleObj);
			} catch (e) {
				$log.error("[analytics] Error pushing module event");
			}
		};

		this.dataToSteal = [
			{
				dataLayerName: 'lastKeyword',
				val: function() {
					return AppData.lastKeyword;
				}
			}, {
				dataLayerName: 'formFactor',
				val: function() {
					return ClientInfo.deviceType;
				}
			}, {
				dataLayerName: 'merchantId',
				val: function() {
					return AppData.merchantId;
				}
			}, {
				dataLayerName: 'clientName',
				val: function() {
					return AppData.settings.client;
				}
			}, {
				dataLayerName: 'merchantName',
				val: function() {
					return AppData.merchantName;
				}
			}, {
				dataLayerName: 'currency',
				val: function() {
					return AppData.currencyCode;
				}
			}, {
				dataLayerName: 'language',
				val: function() {
					return AppData.language;
				}
			}
		];

		/**
		 * Triggers analytics event for get cart summary event and push it to the data layer
		 * @param {Object} data cart summary data
		 * @returns {undefined}
		 */
		this.triggerGetCartSummary = function(data) {
			try {
				$window[dll].push({
					event: AnalyticsEnumsService.events.GET_CART_SUMMARY,
					cartSummary: data
				});
			} catch (e) {
				$log.error('[analytics] Error pushing Get Cart Summary Event');
			}
		};

		/**
		 * Triggers analytics event for cart info and push it to the data layer
		 * @param {Object} data cart summary data
		 * @returns {void}
		 */
		this.triggerAccertify = function(data) {
			try {
				if (data) {
					$window[dll].push({
						accertifyId: data,
						event: AnalyticsEnumsService.events.ACCERTIFY
					});
				}
			} catch (e) {
				$log.error('[analytics] Error pushing ACCERTIFY Event');
			}
		};

		/**
		 * Pushes acccesso pay billing information to data layer
		 * @param {Object} Billing Demographics used to grab the email address from billing information
		 * @returns {undefined}
				});
			} catch (e) {
				$log.error('[analytics] Error pushing ACCERTIFY Event');
			}
		};

		/**
		 * Pushes acccesso pay billing information to data layer
		 * @param {Object} Billing Demographics used to grab the email address from billing information
		 * @returns {undefined}
		 */
		this.triggerAccessoPayBillingInformation = function(demographics) {
			try {
				var emailAddress = new TextEncoder().encode(Utilities.getString(demographics.email).toLowerCase().trim()),
					hashEmailAddress = crypto.digest('SHA-256', emailAddress);

				hashEmailAddress.then(function convertHashToHex(arrayBuffer) {
					var hashArray = Array.from(new Uint8Array(arrayBuffer));
					var hexEmail = hashArray
						.map(function(h) {
							return h.toString(16).padStart(2, '0');
						})
						.join('');
					var accessoPayBillingInfo = {};

					for (var key in demographics) {
						if (demographics.hasOwnProperty(key)) {
							accessoPayBillingInfo[key] = demographics[key];
						}
					}
					// Hex the plain valued email address before sending
					accessoPayBillingInfo.email = hexEmail;

					$window[dll].push({
						accessoPayBillingInfo: accessoPayBillingInfo,
						event: AnalyticsEnumsService.events.ACCESSO_PAY_BILLING_INFORMATION
					});
				});
			} catch (e) {
				$log.error('[analytics] Error pushing Accesso Pay Data Event');
			}
		};

		if (!AppData.hasStaticData()) {
			this.dataToSteal = this.dataToSteal.concat([
				{
					dataLayerName: 'cartId',
					val: function() {
						return String(AppData.GetNewCartID.cart_id);
					}
				}, {
					dataLayerName: 'cartKey',
					val: function() {
						return String(AppData.GetNewCartID.cart_key);
					}
				}
			]);
		}

		/**
		 * Pushes data to data layer
		 * @param {Object} d data to push
		 * @returns {undefined}
		 */
		this.pushToDataLayer = function(d) {
			$window[dll].push(d);
		};

		/**
		 * Obtain client and passbook info and push it into the data layer
		 * @returns {undefined}
		 */
		this.stealClientInfo = function() {
			var toSteal = ["browserName", "browserVersion", "currentPage", "engineName", "engineVersion", "orientation", "osName", "osVersion", "previousPage", "software", "userAgent"];
			var thePush = {};

			toSteal.forEach(function(d) {
				try {
					var layerName = d;
					var val = String(ClientInfo[d]);

					thePush[layerName] = val;
				} catch (e) {
					$log.error("[analytics] Error pushing data layer variable", d);
				}
			});

			//  also get passbook info
			try {
				thePush["isPassbookDevice"] = (ClientInfo.isPassbookDevice()) ? "1" : "0";
			} catch (e) {
				$log.error("Error getting passbook info.", e);
			}

			$window[dll].push(thePush);
		};

		/**
		 * Steal data and push it into the data layer, when possible
		 * @returns {undefined}
		 */
		this.stealData = function() {
			var thePush = {};
			this.dataToSteal.forEach(function(d) {
				try {
					var layerName = d["dataLayerName"];
					var val = d["val"]();

					thePush[layerName] = val;
				} catch (e) {
					$log.error("[analytics] Error pushing data layer variable", d);
				}
			});

			//  also get history

			try {
				thePush["previousPages"] = JSON.stringify(ClientInfo.previousPages);
			} catch (e) {
				$log.error("Error getting page history.", e);
			}

			$window[dll].push(thePush);
		};

		/**
		 * Push to the data layer the keyword or promocode used to launch the store.
		 * @returns {undefined}
		 */
		this.getLaunchType = function() {
			if (angular.isDefined($location.$$absUrl)) {
				var url = $location.$$absUrl,
					stateParams = $stateParams;
				if (url.indexOf("launch=accesso") > -1) {
					var launch = '';
					var launchType = '';

					// Figure out if promo or keyword was used.
					if (angular.isDefined(stateParams.promocode)) {
						launchType = 'promocode';
						launch = stateParams.promocode;
					} else if (angular.isDefined(stateParams.keyword)) {
						launchType = 'keyword';
						launch = stateParams.keyword;
					}

					// If promo or keyword has been used, make sure to trim to only pass promo/keyword
					if (launch !== '' && launchType !== '') {
						// push info to the datalayer
						var launchData = {};
						launchData[launchType] = launch;
						$window[dll].push(launchData);
					}

					// Strip launch param as we only want to do this calculation once.
					Utilities.stripURLParams(["launch"]);
				}
			}
		};

		/**
		 * Initialize the data layer
		 * @returns {undefined}
		 */
		this.init = function() {
			if (angular.isUndefined($window[dll])) {
				$window[dll] = [{}];
			}

			//  push in any variables we might need for the data layer (except for _ga)
			try {
				//  merge hash AND search
				var qs = $location.search(),
					dataLayerVars  = {};
				analyticsDataLayerConfig = getConfiguration();
				//  If the location hash is defined AND it contains '?', we use that.
				if (analyticsDataLayerConfig.industry) {
					$window[dll].push({ industry: analyticsDataLayerConfig.industry });
				}

				Object.keys(qs).forEach(function(k) {
					// If the param is not the google analytics param, push it to the data layer
					if (k !== Enums.urlParameters.googleAnalytics) {
						dataLayerVars[k] = qs[k];
					}
				});

				$window[dll].push(dataLayerVars);

				try {
					for (var k in dataLayerVars) {
						this.characsStore.push({
							k: k,
							v: dataLayerVars[k]
						});
					}
				} catch (e) {
					// Ignore
				}

				//  Passing the current appVersion to each view
				$window[dll].push({ build: $window.version });

				//  pull in client info
				this.stealClientInfo();

				//  pull in specific data
				this.stealData();
			} catch (e) {
				$log.error("[analytics] Error pushing params into data layer.", e);
			}
		};


		/**
		 * Gets product details from pkg object
		 * @protected
		 * @param {Object} pkg The package object
		 * @returns {Object} The product details object
		 */
		function getProductDetailsFromPackage(pkg) {
			var productDetails = {},
				packageDetails,
				packageId,
				vatInclusive = getBoolean(AppData.settings.use_vat);

			//  Check for aliased package
			if (checkProp('Package.CHARACS.0.preswap_package_id', pkg)) {
				packageDetails = Package.getPackageByID(pkg.CHARACS[0].preswap_package_id);
				packageId = pkg.CHARACS[0].preswap_package_id;
			} else {
				id = pkg.package_id || pkg.id || pkg.packageId;
				packageDetails = Package.getPackageByID(id);
				packageId = id;
			}

			//  ID
			if (angular.isDefined(packageId)) {
				productDetails.id = packageId;
			}
			//  NAME
			if (angular.isDefined(packageDetails) && angular.isDefined(packageDetails.name)) {
				productDetails.name = packageDetails.name;
			} else if (angular.isDefined(pkg.package_name || pkg.name)) {
				productDetails.name = pkg.package_name || pkg.name;
			}

			// SELECTED DATE
			if (checkProp('pkg.CHARACS.0.start_date', pkg)) {
				productDetails.selectedDate = pkg.CHARACS[0].start_date;
			}

			// UNAVAILABLE TIME SLOTS
			if (checkProp('pkg.CHARACS.0.numberOfUnavailableTimes', pkg)) {
				productDetails.numberOfUnavailableTimes = pkg.CHARACS[0].numberOfUnavailableTimes;
			}

			// UNAVAILABLE DATES
			if (checkProp('pkg.CHARACS.0.numberOfUnavailableDates', pkg)) {
				productDetails.numberOfUnavailableDates = pkg.CHARACS[0].numberOfUnavailableDates;
			}

			// SELECTED TIME
			if (checkProp('pkg.CHARACS.0.start_time', pkg)) {
				productDetails.selectedTime = pkg.CHARACS[0].start_time;
			}

			// KEYWORD
			if (angular.isDefined(packageDetails) && angular.isDefined(packageDetails.keyword)) {
				productDetails.keyword = packageDetails.keyword;
			} else if (angular.isDefined(pkg.keyword)) {
				productDetails.keyword = pkg.keyword;
			}

			//  CATEGORY
			if (angular.isDefined(packageDetails) && angular.isDefined(packageDetails.package_class)) {
				productDetails.category = packageDetails.package_class;
			} else if (angular.isDefined(pkg.package_class || pkg.action || pkg.packageClass)) {
				productDetails.category = pkg.package_class || pkg.action || pkg.packageClass;
			}
			//  BRAND
			if (angular.isDefined(AppData.settings.merchant || AppData.settings.merchant_uid)) {
				productDetails.brand = AppData.settings.merchant || AppData.settings.merchant_uid;
			}

			//  VARIANT
			if (angular.isDefined(pkg.client_rate_name || pkg.customer_type_name)) {
				productDetails.variant = pkg.client_rate_name || pkg.customer_type_name;
			}

			//  QUANTITY
			if (angular.isDefined(pkg.qty) && parseInt(pkg.qty, 10) > 0) {
				productDetails.quantity = pkg.qty;
				//  Doesn't make sense to add price if quantity isn't applicable

				//  PRICE
				//  If there are customer types, we need to pull the price from that
				if (angular.isDefined(pkg.customer_type) && angular.isDefined(packageDetails)) {
					for (var i = 0; i < packageDetails.CT.length; i++) {
						if (pkg.customer_type === packageDetails.CT[i].id) {
							if(pkg.shownPrice) {
								productDetails.price = Math.round(parseFloat(pkg.shownPrice || 0) * 100) / 100;
								productDetails.tax = Math.round(parseFloat(pkg.shownTax || 0) * 100) / 100;
								productDetails.fees = Math.round(parseFloat(pkg.shownFee || 0) * 100) / 100;
								productDetails.value = Math.round((productDetails.price + productDetails.tax + productDetails.fees) * 100) / 100;
							} else if (checkProp('ct.DYNAMIC_PRICING', packageDetails.CT[i])) {
								productDetails.price = Math.round(parseFloat(packageDetails.CT[i].DYNAMIC_PRICING.max_discounted_retail_amount || 0) * 100) / 100;
								productDetails.tax = Math.round(parseFloat(packageDetails.CT[i].DYNAMIC_PRICING.max_discounted_tax_amount || 0) * 100) / 100;
								productDetails.fees = Math.round(parseFloat(packageDetails.CT[i].DYNAMIC_PRICING.fee_total || 0) * 100) / 100;
								productDetails.value = Math.round((productDetails.price + productDetails.tax + productDetails.fees) * 100) / 100;
							} else {
								productDetails.price = Math.round(parseFloat(packageDetails.CT[i].retail_amount || packageDetails.CT[i].min_retail_amount || 0) * 100) / 100;
								productDetails.tax = Math.round(parseFloat(packageDetails.CT[i].tax_amount || 0) * 100) / 100;
								productDetails.fees = Math.round(parseFloat(pkg.fees || 0) * 100) / 100;
								productDetails.value = Math.round((productDetails.price + productDetails.tax + productDetails.fees) * 100) / 100;
							}
							if (analyticsDataLayerConfig.push_annualized_pricing && packageDetails.CT[i].PAYMENT_SCHEDULE) {
								productDetails.price *= parseInt(packageDetails.CT[i].PAYMENT_SCHEDULE.required_num_payments, 10);
								productDetails.price = Number.parseFloat(productDetails.price);
							}
							break;
						}
					}
				} else {
					if (angular.isDefined(packageDetails) && angular.isDefined(packageDetails.retail_amount || packageDetails.min_retail_amount)) {
						productDetails.price = Math.round(parseFloat(packageDetails.retail_amount || packageDetails.min_retail_amount) * 100) / 100;
					} else if (angular.isDefined(pkg.retail_price || pkg.retail_amount)) {
						productDetails.price = Math.round(parseFloat(pkg.retail_price || pkg.retail_amount) * 100) / 100;
					}
				}
			}

			//  CURRENCY CODE
			if (AppData.currencyCode) {
				productDetails.currency = AppData.currencyCode;
			}

			//  PROMO CODE
			if (pkg.promo_code) {
				productDetails.promo_code = pkg.promo_code;
			}

			return productDetails;
		}

		/**
		 * Extract the first sequence of numbers from a string
		 * @param {string} str - The input string
		 * @returns {number} - The first sequence of numbers found, or 0 if none found
		 */
		function extractFirstNumbersFromString(str) {
			// This regex matches the first sequence of digits in the string
			 var matches = str.match(/\d+(?:\.\d+)?/);
			return matches ? matches[0] : 0;
		}


		/**
		 * Transform the cart summary into a GA4 format
		 * @private
		 * @param {Object} cartSummary - getCartSummary model
		 * @returns {Array} - Transformed cart items
		 */
		function transformCartForGA4(cartSummary) {
			var discount = cartSummary.discount && cartSummary.discount.valid ? cartSummary.discount : null;
			return cartSummary.cart.items.map(function(item) {
				var obj = {
					affiliation: AppData.settings.merchant || AppData.settings.merchant_uid,
					// eslint-disable-next-line camelcase
					item_brand: AppData.settings.merchant || AppData.settings.merchant_uid,
					// eslint-disable-next-line camelcase
					item_id: item.package.id,
					// eslint-disable-next-line camelcase
					item_name: item.package.name,
					// eslint-disable-next-line camelcase
					item_variant: item.customer.name,
					price: parseFloat(item.pricing.retail),
					quantity: item.characs.length,
					sku: toSKU(item.package.id, item.customer.id),
					tax: parseFloat(item.pricing.tax),
					total: Math.round(((parseFloat(item.pricing.retail) + parseFloat(item.pricing.tax)) * 100)) / 100
				};

				if (discount && item.flags.hasDiscount) {
					merge(obj, {
						// eslint-disable-next-line camelcase
						discount_code: discount.code,
						// eslint-disable-next-line camelcase
						discount_type: CartEnums.discount.toAnalyticsType(discount.type),
						// discount_value: monetary amount for FIXED types; percentage integer (e.g. 10 = 10%) for PERCENTAGE types.
						// Consumers must check discount_type to interpret the unit.
						// eslint-disable-next-line camelcase
						discount_value: discount.value
					});
				}

				return obj;
			});
		}

		/**
		 * Log an error message to busgnag
		 * @private
		 * @param {String} message The error message
		 * @param {Object} errorObject The error object
		 * @param {String} possibleOrderId of the purchase
		 * @returns {undefined}
		 */
		function _log(message, errorObject, possibleOrderId) {
			$log.error(message, errorObject);
			errorTracking.notify(message, {
				errorDetails: errorObject,
				orderId: possibleOrderId
			});
		}
	});

(function() {
	'use strict';
	angular
		.module('analytics')
		.service('AnalyticsEnumsService', function() {
			return {
				events: {
					ACCESSO_PAY_EVENT: 'passport.accessoPay',
					ANALYTICS_EVENT: 'passport.analyticsEvent',
					ANALYTICS_TIMING_EVENT: 'passport.analyticsTimingEvent',
					GA4BEGINCHECKOUT: 'begin_checkout',
					GA4PURCHASE: 'purchase',
					GA4VIEWCART: 'view_cart',
					PURCHASE: "passport.purchaseComplete",
					INITSTORE: "passport.initStore",
					INTERACTION: "passport.interaction",
					INTERNALSTATECHANGE: "passport.internalStateChange",
					INTERNALPAGEVIEW: "passport.internalPageView",
					POST_INTERNALSTATECHANGE: "passport.postInternalStateChange",
					INTERNALPAGEVIEW_DESKTOP: "passport.desktop.internalPageView",
					INTERNALPAGEVIEW_MOBILE: "passport.mobile.internalPageView",
					INTERNALPAGEVIEW_TABLET: "passport.tablet.internalPageView",
					INTERNALADDPROMOIMPRESSION: "passport.addPromoImpression",
					INTERNALADDPROMOCLICK: "passport.addPromoClick",
					INTERNALADDIMPRESSION: "passport.addImpression",
					INTERNALPRODUCTCLICK: "passport.productClick",
					INTERNALPRODUCTDETAILS: "passport.productDetails",
					INTERNALADDTOCART: "passport.addToCart",
					INTERNALREMOVEFROMCART: "passport.removeFromCart",
					INTERNALCHECKOUT: "passport.checkout",
					INTERNALCHECKOUTCLICK: "passport.checkoutClick",
					INTERNALCHECKOUTBILLING: "passport.checkoutBilling",
					INTERNALCHECKOUTPAYMENTINFO: "passport.checkoutPaymentInfo",
					INTERNALCHECKOUTORDERREVIEW: "passport.checkoutOrderReview",
					INTERNALPAYMENTSELECT: "passport.paymentSelect",
					INTERNALSHIPPINGSELECT: "passport.shippingSelect",
					CARTABANDONMENTVIEW: "passport.cartAbandonmentView",
					CHECKOUTURL: "passport.checkoutUrl",
					SAVECART: "passport.saveCart",
					CONTINUESHOPPING: "passport.continueShopping",
					CLOSESTORE: "passport.closeStore",
					VIDEOVIEW: "passport.videoView",
					SEASONPASSOPEN: "passport.seasonPassOpen",
					SEASONPASSINFO: "passport.seasonPassInfo",
					SOCIALMEDIACLICK: "passport.socialMediaClick",
					UNASSIGNEDMODALSHOW: "passport.unassignedModalShow",
					UNASSIGNEDPAGEVIEW: "passport.unassignedPageView",
					UNASSIGNEDPASSHOLDERASSIGN: "passport.unassignedPassholderAssign",
					UNASSIGNEDPASSHOLDERSKIP: "passport.unassignedPassholderSkip",
					NEW_CART: "passport.newCart",
					PREPARD_CARD_MODAL: "passport.prepaidCardModal",
					modalInteraction: "passport.modalInteraction",
					TIMING_EVENT: 'passport.timingEvent',
					GET_CART_SUMMARY: 'passport.getCartSummary',
					ACCESSO_PAY_BILLING_INFORMATION: 'passport.accessoPayBillingInfo',
					ACCERTIFY: 'passport.accertify',
				},
				settings: {
					TRANSACTION_AFFILIATIONSHOPLAND: "SHOPLAND",
					TRANSACTION_AFFILIATIONOTHER: "SHOPLAND AFFILIATE"
				}
			};
		});
})();

angular.module('base-calendar', ['app', 'ui.bootstrap'])
	.run(function($templateCache, BaseCalendarTemplateConstant) {
		$templateCache.put('uib/template/datepicker/day.html', BaseCalendarTemplateConstant.defaultTemplate);
	});
/* eslint-disable sort-keys */

angular
	.module('base-calendar')
	.directive('baseCalendarDirective', function(Language) {
		"use strict";
		return {
			templateUrl: '/scripts/modules/base-calendar/views/calendar.html',
			controller: 'BaseCalendarController',
			controllerAs: 'vm',
			scope: {
				additionalData: '=',
				allowedDates: '=',
				calendarHeading: '=',
				calendarLocaleSuffix: '<',
				currentMonthInfo: '=',
				currentWeek: '=?',
				customTemplateFunction: '=',
				defaultDisplayType: '=',
				disableLimitedAvailabilityLegend: '<',
				disableSoldOutLegend: '<',
				displayType: '=',
				enableStickyDateSelection: '<?',
				isDateSelectable: '=?',
				loading: '=',
				loadingText: '@',
				lockCalendar: '=',
				monthChangedCallback: '=',
				onSelectDate: '=',
				onReselectDate: '=?',
				dynamicCalendarRowsDisplayedAmount: '=?',
				overrideOneYearRestriction: '=overrideYearRestriction',
				selectedDate: '=',
				selectRange: '=',
				showPricingInCell: '=',
				spanMultipleMonths: '=?',
				weekChangedCallback: '='
			},
			link: function(scope) {
				scope.minDate = new Date();
				scope.iconLeftArrowLabel = Language.getLocale('Accessibility', 'previousMonth');
				scope.iconRightArrowLabel = Language.getLocale('Accessibility', 'nextMonth');
			}
		}
	});

(function() {
	/* eslint-disable no-fallthrough */
	'use strict';

	angular
		.module('base-calendar')
		.controller('BaseCalendarController', BaseCalendarController);

	/**
	 * Our BaseCalendar controller - handles behavior for our calendars
	 * @public
	 * @memberOf {base-calendar}
	 * @param {Service} $document Our Document service - wrapper for window.document
	 * @param {Service} $filter Our Filter service
	 * @param {Service} $locale Our Locale service
	 * @param {Service} $log Our Logging service, used inplace of any console.log statements
	 * @param {Scope} $scope Our scope
	 * @param {Service} $timeout Our Timeout service, instead of setTimeout, allows for .flush() in testing
	 * @param {Service} $templateCache Our Template Cache service - so we can cache our custom templates
	 * @param {Service} AriaAnnouncer To announce dates selected and changes in month to screen readers
	 * @param {Service} AppData The AppData service
	 * @param {Const} BaseCalendarTemplateConstant Our Const templates for datepickers
	 * @param {Service} ClientInfo The device info service
	 * @param {Service} Language The lanaguage service
	 * @param {Service} Utilities The Utilities service
	 * @param {Service} UtilsValidation Validation utilities service
	 * @return {Controller} Instance of the BaseCalendarController
	 * @nginject
	 */
	function BaseCalendarController(
		$document,
		$filter,
		$locale,
		$log,
		$scope,
		$timeout,
		$templateCache,
		AriaAnnouncer,
		AppData,
		BaseCalendarTemplateConstant,
		ClientInfo,
		Language,
		Utilities,
		UtilsValidation
	) {
		var vm = this;

		/**
		 * Local isUndefined check
		 * @private
		 * @returns {bool} true if given object is undefined
		 */
		var ngIsUndefined = angular.isUndefined;

		/**
		 * Local Copy
		 * @private
		 * @returns {Object} copy of given object
		 */
		var ngCopy = angular.copy;

		/**
		 * Local isFunction check
		 * @private
		 * @returns {bool} true if given object is a function
		 */
		var ngIsFunction = angular.isFunction;

		/**
		 * Local checkProp
		 * @private
		 */
		var checkProp = Utilities.safelyCheckPropertyOnObject;
		var dateToString = Utilities.javascriptDateToSQLDate;
		var validArray = UtilsValidation.validArray;
		var validObject = UtilsValidation.validObject;
		var validString = UtilsValidation.validString;

		/**
		 * Local getBoolean
		 * @private
		 */
		var getBoolean = Utilities.getBoolean;

		/**
		 * Represents the currently highlighted date (highlighted via keyboard navigation)
		 * Is explicitly used to prevent traversal between months, wherein we must use our custom month move function
		 * @private
		 * @type {Date}
		 */
		var highlightedActiveDate = new Date();

		/**
		 * Represents whether or not the user is traversing the calendar via keyboard
		 * Used to determine if the calendar needs to be focused after reinitialization via moving to a new month
		 * @private
		 * @type {bool}
		 */
		var isKeyboardNavigated = false;

		var DAY_MILLISECONDS = 86400000;

		/**
		 * Holds the Bootstrap Calendar Reference
		 * @private
		 * @type {Object}
		 */
		$scope.$calendarRef = {};

		$scope.datepickerOptions = {};
		$scope.deviceType = ClientInfo.deviceType.toLowerCase();
		$scope.onDateSelectionToggleCalendar = onDateSelectionToggleCalendar;
		$scope.updateSelectedDateRange = updateSelectedDateRange;
		$scope.setSelectedDate = setSelectedDate;
		$scope.shouldToggleBeVisible = shouldToggleBeVisible;
		$scope.shouldInlineWeekDatePickerBeVisible = shouldInlineWeekDatePickerBeVisible;
		$scope.shouldInlineMonthDatePickerBeVisible = shouldInlineMonthDatePickerBeVisible;
		$scope.shouldModalMonthDatePickerBeVisible = shouldModalMonthDatePickerBeVisible;
		$scope.isSelectedWeekCustom = false;
		$scope.calSwap = false;
		$scope.getLocale = Language.getLocale;

		initialize();

		/**
		 * Initialize the Controller
		 * @private
		 * @returns {undefined}
		 */
		function initialize() {
			var today = createDate(),
				monthToShow = $scope.selectedDate,
				currentWeekStart,
				currentWeekEnd,
				customWeekDay = checkProp('AppData.settings.first_day_of_week', AppData, [parseInt, 10]),
				startingDay = new Date();

			/*
			 * Parameters
			 *
			 * Here we initialize a currentMonthInfo object to bind to parent controllers if we do not already have one bound
			 * (for brevity & readability - this object should be instantiated on the calling controllers for now because those controllers require access of
			 * the currentMonth property to make calls to GetMerchantPackageEventDates to populate the allowed Dates after the move in this controller executes.
			 * It is easier to read and understand controllers if bindable properties are declared first in the calling controller, especially if they are directly used
			 * later on in that controller as is the case with most parent controllers using this directive.
			 * If the property is not instantiated in the parent controller, it will be created here but it may be confusing to see a variable
			 * that is not declared suddenly used within a function later on in the parent controller, as is the case after a move of the month.
			 * This change addresses the binding/scope access issues of the currentMonth property (previously a primitive Number value).
			 */
			if (!checkProp('$scope.currentMonthInfo.currentMonthObject', $scope)) {
				$scope.currentMonthInfo = {
					currentMonth: today.getMonth() + 1,
					currentMonthObject: today
				}

				// if we don't reset the date, edge cases like 31st will not be accounted for
				$scope.currentMonthInfo.currentMonthObject.setDate(1);

				// If we don't have a monthToShow Date object, use the current month object.
				if (!(monthToShow instanceof Date)) {
					monthToShow = $scope.currentMonthInfo.currentMonthObject;
				}
			}

			if (!$scope.currentWeek) {
				currentWeekStart = createDate();
				currentWeekEnd = createDate();
				currentWeekEnd.setDate(currentWeekStart.getDate() + 6);
			} else {
				currentWeekStart = $scope.currentWeek.startDate;
				currentWeekEnd = $scope.currentWeek.endDate;
				startingDay = $scope.currentWeek.origStartDate;
			}

			if (angular.isNumber(customWeekDay) && customWeekDay >= 0 && customWeekDay < 7) {
				if ($locale.DATETIME_FORMATS.FIRSTDAYOFWEEK < 6) {
					customWeekDay = customWeekDay >= 6 ? 0 : customWeekDay + 1;
				}

				while (customWeekDay != startingDay.getDay()) {
					startingDay.setDate(startingDay.getDate() - 1);
				}
			}

			$scope.currentWeek = {
				data: [],
				endDate: currentWeekEnd,
				labels: [],
				origStartDate: createDate($scope.currentWeek ? startingDay : currentWeekStart),
				startDate: currentWeekStart
			};

			// If we don't have a monthToShow Date object, use the current month object.
			if (!(monthToShow instanceof Date) && angular.isObject($scope.currentMonthInfo) && $scope.currentMonthInfo.currentMonthObject instanceof Date) {
				monthToShow = $scope.currentMonthInfo.currentMonthObject;
			}

			// this could be set. if it's not, provide default
			if (ngIsUndefined($scope.spanMultipleMonths)) {
				$scope.spanMultipleMonths = false;
			}

			setTemplate();
			setStartingDay();
			updateTitle(monthToShow);
		}

		/**
		 * On Init Lifecycle Hook
		 * @lifecycle
		 * @returns {undefined}
		 */
		vm.$onInit = function $onInit() {
			// Set datepicker options
			angular.merge($scope.datepickerOptions, {
				dateDisabled: $scope.isDateDisabled,
				minDate: $scope.minDate,
				selectRange: $scope.selectRange,
				showWeeks: false,
				startingDay: $scope.startingDay
			});
		}

		/**
		 * This is for the title of the calendar which displays the month and year
		 * In Japan and some other countries, we need to display the year before the month, we have added a new property
		 * to the locale files (currently for languages: ja, ja-jp, and en-jp) to handle the format for these
		 * Just about every other country will have the MMMM yyyy format. This format was taken from ui bootstrap which
		 * is hardcoded in their library and does not meet our international needs.
		 *
		 * @private
		 * @param {Date} dateShowing The date that is to be used to set the title of the calendar
		 * @returns {undefined}
		 */
		function updateTitle(dateShowing) {
			var formatDayTitle = 'MMMM yyyy';

			if (ngIsUndefined(dateShowing)) {
				dateShowing = createDate();
			}

			if (checkProp('$locale.DATETIME_FORMATS.calendarMonthTitle', $locale)) {
				formatDayTitle = $locale.DATETIME_FORMATS.calendarMonthTitle;
			}

			$scope.title = $filter('date')(dateShowing, formatDayTitle);
		}


		/**
		 * Allows for a custom template to override the daypicker directive
		 * @private
		 * @returns {undefined}
		 */
		function setTemplate() {
			if (ngIsFunction($scope.customTemplateFunction)) {
				$templateCache.put('uib/template/datepicker/day.html', $scope.customTemplateFunction());
			} else {
				$templateCache.put('uib/template/datepicker/day.html', BaseCalendarTemplateConstant.defaultTemplate);
			}
		}

		$scope.$watch('selectRange', function(newValue) {
			if (!ngIsUndefined(newValue) && newValue !== false) {
				$scope.spanMultipleMonths = true;
			}
		});

		$scope.$watchCollection('additionalData', function(newValue) {
			$scope.updateAdditionalDataMap(newValue);
		});

		/**
		 * Watcher to only apply logic when dates have changed.
		 * This helps prevent digest cycles failovers
		 * @param {Object[]} rows The rows that have been altered
		 * @returns {undefined}
		 */
		$scope.$watch('$calendarRef.rows', function(rows) {
			var startDate;
			var endDate;

			if (validArray(rows)) {
				startDate = dateToString(rows[0][0].date);
				endDate = dateToString(rows[rows.length - 1][rows[rows.length - 1].length - 1].date);

				if (startDate !== $scope.$calendarRef.lastMonthStart || endDate !== $scope.$calendarRef.lastMonthEnd) {
					$scope.$calendarRef.lastMonthStart = startDate;
					$scope.$calendarRef.lastMonthEnd = endDate;

					removeEmptyLastRow(rows);

					if ($scope.dynamicCalendarRowsDisplayedAmount !== undefined) {
						$scope.dynamicCalendarRowsDisplayedAmount = rows.length;
					}
				}
			}
		});

		// Create a mapping of date to data object, this is used in $scope.getDataMap
		$scope.updateAdditionalDataMap = function(newValue) {
			if (!ngIsUndefined(newValue) && newValue !== false) {
				// Reset current week data
				$scope.currentWeek.data = null;
				$scope.currentWeek.additionalData = false;

				$scope.additionalDataMap = {};
				newValue.forEach(function(value) {
					$scope.additionalDataMap[value.date.toDateString()] = value;
				});
			}
		}

		$scope.$watch('selectedDate', function(newValue) {
			var today = createDate();

			if (!(newValue instanceof Date)) {
				if (newValue !== null) {
					setSelectedDate(null);
				}
				return;
			}

			// if we don't reset the date, edge cases like 31st will not be accounted for
			$scope.currentMonthInfo.currentMonthObject.setDate(1);
			$scope.currentMonthInfo.currentMonthObject.setMonth(newValue.getMonth());
			$scope.currentMonthInfo.currentMonthObject.setFullYear(newValue.getFullYear());

			if (newValue.getTime() > today.getTime()) {
				$scope.currentMonthInfo.currentMonth = (today.getMonth() + 1) + (monthDiff(today, newValue));
			} else {
				$scope.currentMonthInfo.currentMonth = newValue.getMonth() + 1;
			}

			if ($scope.displayType === 'week' && validArray($scope.currentWeek.data)) {
				selectRange($scope.currentWeek.data);
			}

			/*
			 * reset the minimum selectable date
			 * if the new selected date (maybe setFirstAvailableDate)
			 * is less than the current minimum
			 * this can happen in the case of Date Ranges and long time cutoffs
			 */
			if (newValue.getTime() < $scope.minDate.getTime()) {
				$scope.minDate = ngCopy(newValue);
			}

			/*
			 * AXO 2149
			 * This function is called in 3 places: initialize, $scope.move, and here.
			 * The reason this was added is specifically for the use case of date_range on the date-time calendar.
			 * For date_range, days from more than a single month will be displayed on the calendar. Because of this,
			 * it is possible to click a date (triggering this function) that is in a different calendar month than what the title
			 * indicates. In that scenario, the selected date and 'active' month will become out of sync with the month title.
			 * Calling this function updates the title based on the newly selected date and resolves the challenge.
			 ****************
			 * For the future...
			 * When we are able to undertake the massive task of refactoring the calendar, we should take a look at the 3 places this is called.
			 * From my analysis, it seems we could at least remove the call in the initialize function. The call in the $scope.move function
			 * is necessary at this point, because even though it will eventually trigger this $watch function, the selectedDate model will be null
			 * and short circuit.
			 * - MY
			 */
			updateTitle(newValue);
			highlightedActiveDate = ngCopy(newValue);

			$scope.announceSelectedDate(newValue);

			if (ngIsFunction($scope.onSelectDate)) {
				$scope.onSelectDate($scope.selectedDate);
			}

			if ($scope.$parent.vm && $scope.$parent.vm.didSelectDate && $scope.$parent.vm.displayType !== 'month'  && ngIsFunction($scope.updateSelectedDateRange)) {
				$scope.updateSelectedDateRange($scope.selectedDate);
			}
		});

		/**
		 * Checks if week and month calendar toggle buttons should be visible
		 * @public
		 * @function
		 * @param {String} [buttonType='none'] Indicates which type of button should be checked if given
		 * @returns {Boolean} should show it or not
		 */
		function shouldToggleBeVisible(buttonType) {
			var shouldIt = false;

			buttonType = buttonType || 'none';

			switch (buttonType) {
			case 'monthButton':
				shouldIt = $scope.defaultDisplayType !== 'month' && $scope.displayType === 'month';
				break;
			case 'weekButton':
				shouldIt = $scope.defaultDisplayType !== 'month' && $scope.deviceType === 'mobile';
				break;
			case 'none':
				shouldIt = $scope.defaultDisplayType !== 'month';
				break;
			default:
				break;
			}

			return shouldIt;
		}

		/**
		 * Checks if month date picker modal version should be visible
		 * @public
		 * @function
		 * @returns {Boolean} should show it or not
		 */
		function shouldModalMonthDatePickerBeVisible() {
			return $scope.deviceType !== 'mobile' && $scope.defaultDisplayType !== 'month';
		}

		/**
		 * Checks if week date picker inline version should be visible
		 * @public
		 * @function
		 * @returns {Boolean} should show it or not
		 */
		function shouldInlineWeekDatePickerBeVisible() {
			return ($scope.displayType === 'week' || $scope.deviceType !== 'mobile') &&
				$scope.defaultDisplayType !== 'month';
		}

		/**
		 * Checks if month date picker inline version should be visible
		 * @public
		 * @function
		 * @returns {Boolean} should show it or not
		 */
		function shouldInlineMonthDatePickerBeVisible() {
			return ($scope.displayType !== 'week' && $scope.deviceType === 'mobile') ||
				$scope.defaultDisplayType === 'month';
		}

		/**
		 * On Date selection at markup select a day on angular ui bootstrap and change the starting week to show full range
		 * @param {Date} date selected date
		 * @returns {undefined}
		 */
		 function updateSelectedDateRange(date) {
			var dateIndex,
			weekData = $scope.getWeekRows(),
			selectedDate = weekData.find(function getDateData (dt) {
				return Utilities.getDateByString(dt.date) == Utilities.getDateByString(date);
			});

			$scope.isSelectedWeekCustom = false;

			dateIndex =	weekData.indexOf(selectedDate);

			if ((dateIndex + $scope.selectRange) > 7) {
				$scope.$parent.vm.updateDate(date);
				$scope.isSelectedWeekCustom = true;

				if (angular.isDefined($scope.weekChangedCallback) && ngIsFunction($scope.weekChangedCallback)) {
					$scope.weekChangedCallback().then(function() {
						$scope.$calendarRef.$parent.move(1);
						$scope.displayType = 'week';

						// When traversing to a brand new month (that must be fetched and set up) we must re-focus the calendar
						if (isKeyboardNavigated) {
							// This timeout gives the calendar time to finish rendering
							// This is primarily because we cannot alter the moveFunction() (which is a function from the Angular UIB-Calendar itself) to have a callback.
							$timeout(function() {
								$document[0].getElementById('calendar-focus').focus();
							}, 100);
						}
					});
				}
			}
		}

		/**
		 * Manually sets the range
		 * @protected
		 * @function
		 * @param {Object[]} data The data to manipulate
		 * @returns {Object[]} The data with the appropriate dates selected
		 */
		function selectRange(data) {
			var range = $scope.selectRange;

			if (!$scope.selectedDate) {
				return data;
			}

			data.forEach(function(day, i) {
				var dayDiff = roundToDays(day.date) - roundToDays($scope.selectedDate);

				data[i].selected = dayDiff >= 0 && dayDiff < range;

				if (range > 1) {
					data[i].firstInRange = dayDiff === 0;
					data[i].lastInRange = dayDiff === range - 1;
					data[i].inRange = dayDiff > 0 && dayDiff < range - 1;
				}
			});

			return data;
		}

		/**
		 * Rounds the date to the nearest day since UNIX epoch
		 * @function
		 * @param {Date} date The date
		 * @returns {Number} The quantity of days since the UNIX epoch
		 */
		function roundToDays(date) {
			date = createDate(date);

			return Math.floor((date.getTime() - (date.getTimezoneOffset() * 60000)) / DAY_MILLISECONDS);
		}

		$scope.announceSelectedDate = function(date) {
			var readDate;

			if (!(date instanceof Date)) {
				return;
			}

			readDate = $filter('date')(date, 'longDate');
			if (Language.localeExists('Accessibility', 'iconCheckMarkSelected')) {
				AriaAnnouncer.assertive(Language.getLocale('Accessibility', 'iconCheckMarkSelected') + ' ' + readDate);
			} else {
				AriaAnnouncer.assertive(readDate);
			}
		};

		/**
		 * need to get the current month properly.
		 * @private
		 * @param {Date} d1 First Date
		 * @param {Date} d2 Second Date
		 * @returns {number} Number denoting difference in months
		 */
		function monthDiff(d1, d2) {
			var months;
			months = (d2.getFullYear() - d1.getFullYear()) * 12;
			months -= d1.getMonth() + 1;
			months += (d2.getMonth() + 1);
			return months <= 0 ? 0 : months;
		}

		/**
		 * Depending on the locale, starting day on calendars may be different.
		 * @private
		 * @returns {undefined}
		 */
		function setStartingDay() {
			//Clients have the ability to override the locale information with this app config.
			//This should primarily be used for legacy merchants who have not converted to the new
			//locale scheme. i.e. 'en' instead of 'en-gb'
			if (checkProp('AppData.settings.first_day_of_week', AppData)) {
				$scope.startingDay = AppData.settings.first_day_of_week;
			} else if (checkProp('$locale.DATETIME_FORMATS.FIRSTDAYOFWEEK', $locale)) {
				//The FIRSTDAYOFWEEK constant which is part of the i18n library is 1 off. I believe this is because of how we pull
				//the days of the week. Consistently the days start with 'Sunday', but it looks like this constant is expecting
				//Sunday to be the last day in the array.
				$scope.startingDay = $locale.DATETIME_FORMATS.FIRSTDAYOFWEEK + 1;
				//The days of the week range from 0-6. Doing the + 1 calculation will set some startingDays to 7. Although they behave
				//as though the starting day is 0, it is much safer to explicitly convert this value.
				if ($scope.startingDay > 6) {
					$scope.startingDay = 0;
				}
			} else {
				$scope.startingDay = 0;
			}
		}

		/**
		 * Gets a datamap
		 * @public
		 * @param {Date} date - Date to get correlating Datamap for
		 * @returns {Object} Datamap
		 */
		$scope.getDataMap = function(date) {
			var data;
			if (ngIsUndefined(date) || ngIsUndefined($scope.additionalDataMap)) {
				return;
			}
			data = $scope.additionalDataMap[date.toDateString()];
			if (data) {
				return data.dataMap;
			}
			return undefined;
		}

		/**
		 * Adds data to the given row
		 * @public
		 * @function
		 * @param {Object[]} row The row to add data to
		 * @returns {Object[]} The altered row
		 */
		$scope.addDataToRow = function(row) {
			if (!row) {
				return row;
			}

			row.forEach(function(item, i) {
				var selectDate;
				var endDate;

				row[i].data = $scope.getDataMap(item.date);
				row[i] = selectRange([row[i]])[0];

				if (!$scope.selectedDate && row[i].data) {
					selectDate = row[i].date;

					if (angular.isFunction($scope.onReselectDate)) {
						endDate = new Date(selectDate.getTime());
						endDate.setMonth(endDate.getMonth() + 1);
						endDate.setDate(endDate.getDate() - 1);

						selectDate = $scope.onReselectDate($scope.currentMonthInfo.currentMonthObject, endDate);
					}

					setSelectedDate(selectDate);
				}
			});

			return row;
		};

		/**
		 * Check if is empty all data to the given calendar row
		 * @public
		 * @function
		 * @param {Object[]} rows The rows to check data from
		 * @returns {undefined}
		 */
		function removeEmptyLastRow(rows) {
			var counter = 0,
				currentMonth,
				lastRow,
				lastRowKey;

			if (!rows) {
				return rows;
			}

			currentMonth = $scope.currentMonthInfo.currentMonthObject.getMonth();

			counter = 0;
			lastRowKey = rows.length - 1;
			lastRow = rows[lastRowKey];

			// is a next month week
			if (checkProp('row.0.date', lastRow) && lastRow[0].date.getMonth() - 1 === currentMonth) {
				lastRow.forEach(function rowIteration(column, ignore) {
					// is a next month date
					if (checkProp('column.date', column) && (column.date.getMonth() - 1) === currentMonth) {
						counter++;
					}

				});

				if (counter === lastRow.length) {
					rows.pop();
				}
			}
		}

		/**
		 * Generates Week Calendar rows for datpicker
		 * Adjusts labels for day order
		 * @public
		 * @function
		 * @param {Object[]} labels the collection of labels generated from the datepicker
		 * @returns {Object[]} The week rows
		 */
		$scope.getWeekRows = function getWeekRows() {
			var startDateTime = $scope.currentWeek.startDate.getTime(),
				dateDow,
				selDayData,
				day,
				i;

			if (!validArray($scope.currentWeek.data)) {
				$scope.currentWeek.data = [];
				$scope.currentWeek.additionalData = false;
				$scope.currentWeek.labels = [];

				for (i = 0; i < 7; i++) {
					day = createDate(startDateTime);
					day.setDate(day.getDate() + i);
					day.setHours(12, 0, 0, 0);

					$scope.currentWeek.data.push({
						current: false,
						customClass: undefined,
						date: day,
						disabled: true,
						firstInRange: false,
						inRange: false,
						label: day.getDate(),
						lastInRange: false,
						overrideDisabled: false,
						secondary: false,
						selected: false,
						uid: day.getTime() + '-' + Utilities.guid()
					});

					dateDow = day.getDay();
					$scope.currentWeek.labels.push({
						abbr: $locale.DATETIME_FORMATS.SHORTDAY[dateDow],
						full: $locale.DATETIME_FORMATS.DAY[dateDow]
					});
				}

				$scope.currentWeek.data = selectRange($scope.currentWeek.data);
			}

			if (!$scope.currentWeek.additionalData) {
				if ($scope.selectedDate) {
					selDayData = $scope.getDataMap($scope.selectedDate);
					if (selDayData && (selDayData.soldOut || (!selDayData.ignorePrice && !(selDayData.price > 0)))) {
						setSelectedDate(null);
					}
				}

				$scope.currentWeek.data.forEach(function(day, i) {
					var additionalData = $scope.getDataMap(day.date);
					var selectDate;
					if (validObject(additionalData)) {
						$scope.currentWeek.additionalData = true;
						day.data = additionalData;
						day.disabled = day.data.soldOut || (!day.data.ignorePrice && !(day.data.price > 0));

						if (!$scope.selectedDate && !day.disabled) {
							selectDate = day.date;

							if (angular.isFunction($scope.onReselectDate)) {
								selectDate = $scope.onReselectDate($scope.currentWeek.data[0].date, $scope.currentWeek.data[$scope.currentWeek.data.length - 1].date);
							}

							setSelectedDate(selectDate);
						}
					} else if (day.selected) {
						setSelectedDate(null);
						$scope.currentWeek.data[i].selected = false;
					}
				});
			}

			return $scope.currentWeek.data;
		}

		/**
		 * Determines if the date given should be displayed as disabled to the user
		 * @public
		 * @param {Date} dt The date to determine if it should be disabled or not
		 * @returns {bool} Whether or not the date should be disabled
		 */
		$scope.isDateDisabled = function(dt) {
			if (ngIsUndefined($scope.allowedDates)) {
				//$log.error('allowedDates scope variable is undefined!')
				return true;
			}
			/*
			 * Due to Angular/UI Bootstrap upgrade,
			 * something broke causing UI Bootstrap to reset the date to the 0th hour.
			 * Resetting to the 12th hour is kind of a patch, but appears to resolve the break.
			 *
			 * 6/16/16 - AXO 770
			 * Another scenario was found where UI Bootstrap would reset the date using new Date
			 * when there is no model at the time of compilation. This causes the model to be created
			 * with minutes, seconds and millisecond so when we do the reset we must do all of these,
			 * to ensure accuracy on a millisecond level.
			 */
			dt.date.setHours(12, 0, 0, 0);

			return $scope.allowedDates.indexOf(dt.date.getTime()) === -1 || checkProp('dtmap.soldOut', $scope.getDataMap(dt.date), getBoolean);
		}

		/**
		 * Handles keydowns to function exactly how we need them to, and disabling certain functionality the Calendar would normally have
		 * @public
		 * @param {event} e - The keydown event
		 * @param {Date} calendarMoveCallback - The Angular UI Bootstrap Calendar's 'move function', this will be passed to our move() and will be used on month traversal
		 * @returns {undefined}
		 */
		$scope.keyboardSelect = function(e, calendarMoveCallback) {
			var projectedDate = ngCopy(highlightedActiveDate),
				direction = 0,
				activeEl;

			isKeyboardNavigated = true;

			switch (e.keyCode) {
			// tab
			case 9:
				break;
			// enter
			case 13:
				if (e.target.className === 'thead move-cal left') {
					projectedDate.setMonth(highlightedActiveDate.getMonth() - 1);
					direction = -1;
				} else if (e.target.className === 'thead move-cal right') {
					projectedDate.setMonth(highlightedActiveDate.getMonth() + 1);
					direction = 1;
				}
				break;
			// spacebar
			case 32:
				break;
			// shift
			case 16:
			// ctrl
			case 17:
				e.stopPropagation();
				e.preventDefault();
				break;
			// pageup
			case 33:
				projectedDate.setMonth(highlightedActiveDate.getMonth() - 1);
				direction = -1;
				break;
			// pagedown
			case 34:
				projectedDate.setMonth(highlightedActiveDate.getMonth() + 1);
				direction = 1;
				break;
			// end
			case 35:
				// "set to last day of this month":
				projectedDate.setMonth(highlightedActiveDate.getMonth() + 1);
				// sets date to 'last day of previous month'
				projectedDate.setDate(0);
				break;
			// home
			case 36:
				projectedDate.setDate(1);
				break;
			// left arrow
			case 37:
				projectedDate.setDate(highlightedActiveDate.getDate() - 1);
				direction = -1;
				break;
			// up arrow
			case 38:
				projectedDate.setDate(highlightedActiveDate.getDate() - 7);
				direction = -1;
				break;
			// right arrow
			case 39:
				projectedDate.setDate(highlightedActiveDate.getDate() + 1);
				direction = 1;
				break;
			// down arrow
			case 40:
				projectedDate.setDate(highlightedActiveDate.getDate() + 7);
				direction = 1;
				break;
			// If its not listed; its not supposed to be used. Don't let it do anything.
			default:
				e.stopPropagation();
				e.preventDefault();
				return;
			}

			if (projectedDate.getMonth() != highlightedActiveDate.getMonth()) {
				e.stopPropagation();
				e.preventDefault();

				$scope.move(direction, calendarMoveCallback);
			} else {
				highlightedActiveDate = ngCopy(projectedDate);
			}

			// If an actual arrow move, focus the new date BUTTON element
			if (e.keyCode >= 33 && e.keyCode <= 40) {
				activeEl = $document[0].activeElement;
				if (activeEl && activeEl !== document && activeEl.id !== 'calendar-focus') {
					activeEl.blur();
				}

				focusDate(projectedDate);
			}
		}

		/**
		 * Focus on a specific date's button element. Id's are always 'row{Date.getMonth()}-cell{Date.getDate()}'
		 * @public
		 * @function
		 * @name focusDate
		 * @param {Date} date The date object
		 * @return {undefined}
		 */
		function focusDate(date) {
			var nextEl = $document[0].getElementById('row' + date.getMonth() + '-cell' + date.getDate());

			if (nextEl) {
				nextEl.focus();
			}
		}

		/**
		 * On Day selection at markup select a day on angular ui bootstrap and change to view month mode
		 * if conditions are met and default display is not set to month
		 * @param {Date} date selected date
		 * @param {Boolean} isDisabled boolean flag for date marked as disabled
		 * @param {Boolean} isSoldOut boolean flag for date marked as soldout
		 * @param {Function} select Angular UI Bootstrap Datepicker's Select function
		 * @param {Function} move Angular UI Bootstrap Datepicker's Move function
		 * @returns {undefined}
		 */
		function onDateSelectionToggleCalendar(date, isDisabled, isSoldOut, select, move) {
			if (!isDisabled && !isSoldOut) {
				select(date);

				if ($scope.defaultDisplayType !== 'month') {
					$scope.toggleDisplayType(move);
				}
			}
		}

		/**
		 * Determines if the user is allowed to move to a new month, and if so;
		 * Determines if the Parent Scope needs to have its callback triggered to load a new month's worth of data
		 * Then, Calls the Angular UI Bootstrap Datepicker's Move function to traverse to the new month
		 * @public
		 * @param {number} direction -1 or 1, denoting which direction the movement is in
		 * @param {Function} moveFunction Angular UI Bootstrap Datepicker's Move function
		 * @param {String} [displayType=null] The calendar type to display
		 * @param {Function} [callback=null] the callback for the function
		 * @returns {undefined}
		 */
		$scope.move = function(direction, moveFunction, displayType , callback) {
			var monthsDifference,
				newDate;

			if ($scope.lockCalendar) {
				$log.info('Calendar is locked');
				return;
			}

			newDate = ngCopy($scope.currentMonthInfo.currentMonthObject);
			direction = parseInt(direction, 10);

			if (direction === -1) {
				// can we go backward?

				newDate.setMonth($scope.currentMonthInfo.currentMonthObject.getMonth());
				newDate.setDate(0);
				newDate.setHours(23, 59, 59, 59);
				if (newDate.getTime() < createDate().getTime()) {
					// don't go back if the new "back" month is < today
					return;
				}
				//$scope.currentMonthInfo.currentMonth--;
				$scope.currentMonthInfo.currentMonthObject.setMonth($scope.currentMonthInfo.currentMonthObject.getMonth() - 1);
			} else if (direction === 1) {
				// shouldn't be able to see a year in advance
				newDate.setMonth($scope.currentMonthInfo.currentMonthObject.getMonth() + 1);
				newDate.setDate(1);
				newDate.setHours(0, 0, 0, 0);

				monthsDifference = newDate.getMonth() - createDate().getMonth() + (12 * (newDate.getFullYear() - createDate().getFullYear()));
				if (monthsDifference === 12 && !$scope.overrideOneYearRestriction) {
					return;
				}

				// moving forward a month
				// if we don't reset the date, edge cases like 31st will not be accounted for
				$scope.currentMonthInfo.currentMonthObject.setDate(1);
				$scope.currentMonthInfo.currentMonthObject.setMonth($scope.currentMonthInfo.currentMonthObject.getMonth() + 1);
			}

			$scope.currentMonthInfo.currentMonth += direction;
			if ($scope.currentWeek && Math.abs(direction) === 1) {
				$scope.currentWeek.startDate = createDate(newDate);
			}

			AriaAnnouncer.polite($filter('date')(newDate, 'MMMM yyyy'));

			updateTitle(newDate);
			highlightedActiveDate = ngCopy(newDate);
			highlightedActiveDate.setDate(1);

			if (angular.isDefined($scope.monthChangedCallback) && ngIsFunction($scope.monthChangedCallback)) {
				$scope.monthChangedCallback(direction).then(function() {
					moveFunction(direction);
					setDisplayType(displayType);

					// Prevents full calendar from blocking up
					if (direction === 0 || ($scope.selectedDate && $scope.selectedDate.getMonth() === $scope.currentMonthInfo.currentMonthObject.getMonth())) {
						reassignSelectedTime();
					} else {
						setSelectedDate(null);
					}

					// When traversing to a brand new month (that must be fetched and set up) we must re-focus the calendar
					if (isKeyboardNavigated) {
						// This timeout gives the calendar time to finish rendering
						// This is primarily because we cannot alter the moveFunction() (which is a function from the Angular UIB-Calendar itself) to have a callback.
						$timeout(function() {
							$document[0].getElementById('calendar-focus').focus();
						}, 100);
					}

					$scope.calSwap = false;

					if (callback) {
						callback();
					}
				});
			} else {
				moveFunction(direction);
				setDisplayType(displayType);

				// Prevents full calendar from blocking up
				if (direction === 0 || ($scope.selectedDate && $scope.selectedDate.getMonth() === $scope.currentMonthInfo.currentMonthObject.getMonth())) {
					reassignSelectedTime();
				} else if (!$scope.enableStickyDateSelection) {
					setSelectedDate(null);
				}

				$scope.calSwap = false;

				if (callback) {
					callback();
				}
			}
		};

		/**
		 * Checks to see if we can move the week calendar in one direction or another
		 * and then calls the datepicker move function if allowed
		 * @public
		 * @function
		 * @param {Number} direction -1 or 1, denoting which direction the movement is in
		 * @param {Function} moveFunction Angular UI Bootstrap Datepicker's Move function
		 * @param {String} [displayType=null] The type of calendar to display
		 * @param {String} [baseFromSelected=null] If you want to base it from the selected
		 * @param {Function} [callback=null] the callback for the function
		 * @returns {undefined}
		 */
		$scope.moveWeek = function(direction, moveFunction, displayType, baseFromSelected, callback) {
			var monthsDifference,
				newMonth,
				endDate,
				newDate,
				baseCalendarDirection,
				isCurrentWeek,
				startWeek,
				startDateTimezoneOffset = $scope.currentWeek.startDate.getTimezoneOffset(),
				origStartDateTimeZoneOffset = $scope.currentWeek.origStartDate.getTimezoneOffset(),
				timeZoneDiff = (startDateTimezoneOffset - origStartDateTimeZoneOffset) * 60000,
				normalizedDate = $scope.currentWeek.startDate.getTime() - timeZoneDiff;

			if ($scope.lockCalendar) {
				$log.info('Calendar is locked');
				return;
			}

			if (baseFromSelected && $scope.selectedDate) {
				// Moving from the month calendar to week, this will get the week that has the date that is currently selected
				newDate = createDate(normalizedDate - (Math.floor((normalizedDate - $scope.currentWeek.origStartDate.getTime()) / DAY_MILLISECONDS) % 7 || 0) * DAY_MILLISECONDS);
			} else {
				newDate = createDate(normalizedDate - (Math.floor(($scope.currentWeek.startDate.getTime() - $scope.currentWeek.origStartDate.getTime()) / DAY_MILLISECONDS) % 7 || 0) * DAY_MILLISECONDS);
			}
			direction = parseInt(direction, 10);
			baseCalendarDirection = direction;

			newDate.setDate(newDate.getDate() + (7 * direction));

			if (direction === -1) {
				// can we go backward?
				newDate.setHours(23, 59, 59, 59);

				isCurrentWeek = $scope.currentWeek.data.some(function isOriginalDateInCurrentWeek(day) {
					return Utilities.getDateByString(day.date) === Utilities.getDateByString($scope.currentWeek.origStartDate);
				});

				if ($scope.isSelectedWeekCustom && $scope.selectedDate) {
					startWeek = angular.copy($scope.currentWeek.origStartDate);

					while (startWeek.getTime() < $scope.selectedDate.getTime()) {
						newDate = angular.copy(startWeek);
						startWeek.setDate(newDate.getDate() + 7);
					}

					if (!$scope.isDateSelectable(newDate, true)) {
						var availableDate = angular.copy(newDate);

						availableDate.setDate(availableDate.getDate() - 1);

						while (availableDate.getTime() > $scope.currentWeek.origStartDate) {
							if ($scope.isDateSelectable(availableDate, true)) {
								newDate = angular.copy(availableDate);
								break;
							}

							availableDate.setDate(availableDate.getDate() - 1);
						}
					}

					$scope.isSelectedWeekCustom = false;
				}

				if (newDate.getTime() < createDate().getTime()) {
					if (isCurrentWeek) {
						// don't go back if the new "back" month is < today
						return;
					} else {
						newDate = $scope.currentWeek.origStartDate;
					}
				}
			} else if (direction === 1) {
				// shouldn't be able to see a year in advance
				newDate.setHours(0, 0, 0, 0);

				monthsDifference = newDate.getMonth() - createDate().getMonth() + (12 * (newDate.getFullYear() - createDate().getFullYear()));
				if (monthsDifference === 12 && !$scope.overrideOneYearRestriction) {
					return;
				}
			}

			endDate = createDate(newDate);
			endDate.setDate(endDate.getDate() + 6);

			if (baseCalendarDirection === -1) {
				baseCalendarDirection = $scope.currentWeek.startDate.getMonth() === endDate.getMonth() ? 0 : -1;
			} else if (baseCalendarDirection === 1) {
				baseCalendarDirection = $scope.currentWeek.startDate.getMonth() === $scope.currentWeek.endDate.getMonth() && $scope.currentWeek.endDate.getMonth() === newDate.getMonth() ? 0 : 1;
			}

			$scope.currentWeek.startDate = newDate;
			$scope.currentWeek.endDate = endDate;
			$scope.currentWeek.data = null;

			if ($scope.currentMonthInfo) {
				newMonth = createDate(newDate);
				newMonth.setDate(1);
				$scope.currentMonthInfo.currentMonthObject = newMonth;
				$scope.currentMonthInfo.currentMonth = newMonth.getMonth() + 1;

				$scope.$calendarRef.datepicker.activeDate = new Date(newMonth.getTime());
			}

			AriaAnnouncer.polite($filter('date')(newDate, 'MMMM yyyy'));

			highlightedActiveDate = ngCopy(newDate);

			if (direction !== 0) {
				setSelectedDate(null);
			}

			if (angular.isDefined($scope.weekChangedCallback) && ngIsFunction($scope.weekChangedCallback)) {
				$scope.weekChangedCallback(direction).then(function() {
					moveFunction(baseCalendarDirection);
					setDisplayType(displayType);

					// Prevents full calendar from blocking up
					if (direction === 0) {
						reassignSelectedTime();
					}

					// When traversing to a brand new month (that must be fetched and set up) we must re-focus the calendar
					if (isKeyboardNavigated) {
						// This timeout gives the calendar time to finish rendering
						// This is primarily because we cannot alter the moveFunction() (which is a function from the Angular UIB-Calendar itself) to have a callback.
						$timeout(function() {
							$document[0].getElementById('calendar-focus').focus();
						}, 100);
					}

					$scope.calSwap = false;

					if (callback) {
						callback();
					}
				});
			} else {
				moveFunction(baseCalendarDirection);
				setDisplayType(displayType);

				// Prevents full calendar from blocking up
				if (direction === 0) {
					reassignSelectedTime();
				}

				$scope.calSwap = false;

				if (callback) {
					callback();
				}
			}
		};

		/**
		 * Triggers calendar refresh functions and watches
		 * @function
		 * @returns {undefined}
		 */
		function reassignSelectedTime() {
			if ($scope.selectedDate === null) {
				return;
			} else if ($scope.selectedDate instanceof Date) {
				setSelectedDate($scope.selectedDate);
				return;
			}

			setSelectedDate($scope.originalStartingDay instanceof Date ? $scope.originalStartingDay : new Date());
		}

		/**
		 * Sets the selected Date and treats selectedDate if needed
		 * @protected
		 * @function
		 * @param {Date|null} value the value to set to selectedDate
		 * @returns {undefined}
		 */
		function setSelectedDate(value) {
			if (!(value instanceof Date)) {
				$scope.selectedDate = null;
				return;
			}

			$scope.selectedDate = createDate(value);
		}

		/**
		 * Generates a Date Object in the current device's timezone
		 * @param {Date|String|Number} [value] The value generate the date based off of
		 * @returns {Date} the date object in the device's timezone
		 */
		function createDate(value) {
			var dat;

			if (validString(value)) {
				value = value.replace(/GMT[-+]\d{4}.*/, '');
			}

			dat = value instanceof Date ? new Date(value.toDateString()) : ((value && value !== Object(value)) ? new Date(value) : new Date());
			dat.setHours(0, 0, 0, 0);

			return dat;
		}
		$scope.createDate = createDate;

		/**
		 * Changes the display type for the calendar
		 * @public
		 * @function
		 * @param {String} displayType month/week
		 * @returns {undefined}
		 */
		function setDisplayType(displayType) {
			if (displayType) {
				$scope.displayType = displayType;
			}
		}

		/**
		 * Toggles the calendar type based on the current display type
		 * @public
		 * @function
		 * @param {Function} moveFunction Datepicker move function
		 * @returns {undefined}
		 */
		$scope.toggleDisplayType = function(moveFunction) {
			var toggle = $scope.displayType === 'week' ? 'month' : 'week';

			$scope.calSwap = true;
			if (toggle === 'month') {
				if (!$scope.selectedDate) {
					setSelectedDate($scope.currentMonthInfo.currentMonthObject);
				}

				$scope.move(0, moveFunction, toggle);
			} else {
				$scope.moveWeek(0, moveFunction, toggle, true, false);
			}
		};

		/**
		 * Sets the calendar scope reference to the controller
		 * @public
		 * @function
		 * @param {Scope} ref - The calendar reference
		 * @returns {undefined}
		 */
		$scope.setRef = function(ref) {
			// Assign the reference
			$scope.$calendarRef = ref;

			// Tell the calendar to display the current month
			$scope.$calendarRef.datepicker.activeDate = new Date($scope.currentMonthInfo.currentMonthObject.getTime());
		};
	}
})();

angular.module('base-calendar')
	.constant('BaseCalendarTemplateConstant', {
		defaultTemplate:
'<div id="calendar-focus" role="region" aria-hidden="false" class="calendar-panel" aria-labelledby="base-cal-title" data-ng-keydown="$parent.$parent.keyboardSelect($event, move)">' +
	'<table aria-labelledby="base-cal-title">' +
		'<thead>' +
			'<tr class="panel-heading">' +
				'<td tabindex="0" role="button" data-ng-click="$parent.$parent.move(-1, move)" class="thead move-cal left" aria-label="{{$parent.$parent.iconLeftArrowLabel}}">' +
					'<span class="icon-solid-left-arrow display-block pull-left"></span>' +
				'</td>' +
				'<td colspan="5" id="base-cal-title" aria-live="polite" aria-atomic="true" class="thead cal-title" data-ng-bind="$parent.$parent.title"></td>' +
				'<td tabindex="0" role="button" data-ng-click="$parent.$parent.move(1, move)" class="thead move-cal right" aria-label="{{$parent.$parent.iconRightArrowLabel}}">' +
					'<span class="icon-solid-right-arrow display-block pull-right"></span>' +
				'</td>' +
			'</tr>' +
			'<tr scope="row" class="cal-row calendar-week-names">' +
				'<th scope="col" class="cal-cell" data-ng-repeat="label in labels track by $index" data-ng-bind="label.abbr" title="{{label.full}}" aria-label="{{label.full}}"></th>' +
			'</tr>' +
		'</thead>' +
		'<tbody class="tbody panel-body">' +
			'<tr scope="row" class="cal-row" data-ng-repeat="row in rows track by $index">' +
				'<td class="cal-cell" data-ng-repeat="dt in row track by dt.date" ng-class="{selected: dt.selected, disabled:dt.disabled, \'date-range-enabled\': $parent.$parent.$parent.$parent.selectRange}">' +
					'<span class="size-contain" data-ng-hide="dt.date.getMonth() != ($parent.$parent.$parent.$parent.currentMonthInfo.currentMonthObject.getMonth()) && !$parent.$parent.$parent.$parent.spanMultipleMonths">&nbsp;' +
						'<span class="cal-btn-contain" data-ng-init="data = $parent.$parent.$parent.$parent.getDataMap(dt.date)">' +
							'<button id="row{{dt.date.getMonth()}}-cell{{dt.date.getDate()}}" aria-label="{{dt.date | date:\'longDate\'}}" tabindex="-1" type="button" class="cal-btn chevron" data-ng-class="{selected: dt.selected, \'chevron-color-2\': data.best, \'chevron-color-1\': data.limited, \'chevron-color-3\': data.soldOut, active: isActive(dt), \'date-disabled\': dt.disabled && !dt.overrideDisabled}" ng-click="!dt.disabled && select(dt.date)" aria-disabled="{{dt.disabled || data.soldOut ? \'true\' : \'false\'}}" aria-pressed="{{dt.selected ? \'true\':\'false\'}}">' +
								'<span data-ng-class="{\'text-muted\': dt.secondary, \'text-info\': dt.current}">{{dt.label}}</span>' +
							'</button>' +
						'</span>' +
					'</span>' +
				'</td>' +
			'</tr>' +
		'</tbody>' +
	'</table>' +
'</div>',
		bootstrap: '<table role=\"grid\" aria-labelledby=\"{{::uniqueId}}-title\" aria-activedescendant=\"{{activeDateId}}\">' +
'  <thead>' +
'    <tr>' +
'      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-left\" ng-click=\"move(-1)\" tabindex=\"-1\"><i class=\"icon-solid-left-arrow\"></i></button></th>' +
'      <th colspan=\"{{::5 + showWeeks}}\" class=\"cal-month-heading\"><span id=\"{{::uniqueId}}-title\" role=\"heading\" aria-live=\"assertive\" aria-atomic=\"true\" tabindex=\"-1\" >{{title}}</span></th>' +
'      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-right\" ng-click=\"move(1)\" tabindex=\"-1\"><i class=\"icon-solid-right-arrow\"></i></button></th>' +
'    </tr>' +
'    <tr scope="row">' +
'      <th ng-if=\"showWeeks\" class=\"text-center\"></th>' +
'      <th scope="col" ng-repeat=\"label in ::labels track by $index\" class=\"text-center calendar-week-names\"><small aria-label=\"{{::label.full}}\">{{::label.abbr}}</small></th>' +
'    </tr>' +
'  </thead>' +
'  <tbody>' +
'    <tr scope="row" ng-repeat=\"row in rows track by $index\">' +
'      <td ng-if=\"showWeeks\" class=\"text-center h6\"><em>{{ weekNumbers[$index] }}</em></td>' +
'      <td ng-repeat=\"dt in row track by dt.date\" class=\"text-center\" role=\"gridcell\" id=\"{{::dt.uid}}\" ng-class=\"::dt.customClass\" aria-label="{{dt.date | date:\'longDate\'}}">' +
'        <button id="row{{dt.date.getMonth()}}-cell{{dt.date.getDate()}}" aria-label="{{dt.date | date:\'longDate\'}}" type=\"button\" style=\"min-width:100%;\" class=\"btn btn-default btn-sm\" ng-class=\"{\'btn-info\': dt.selected, active: isActive(dt)}\" ng-click=\"select(dt.date)\" ng-disabled=\"dt.disabled\" tabindex=\"-1\" aria-pressed="{{dt.selected ? \'true\':\'false\'}}"><span ng-class=\"::{\'text-muted\': dt.secondary, \'text-info\': dt.current}\">{{::dt.label}}</span></button>' +
'      </td>' +
'    </tr>' +
'  </tbody>' +
'</table>'
	});

angular.module('calendar-pricing', ['app', 'base-calendar', 'ui.bootstrap'])
	.constant("CalendarPricingViews", {
		CALENDAR_PRICING: "/scripts/modules/calendar-pricing/views/calendar-pricing.html",
		CALENDAR_PRICING_TIMES: "/scripts/modules/calendar-pricing/views/calendar-times.html",
		CALENDAR_PRICING_EVENT: "/scripts/modules/calendar-pricing/views/calendar-pricing-event.html",
		CALENDAR_SAVINGS: "/scripts/modules/calendar-pricing/views/calendar-savings.html",
		WIZARD_CALENDAR_PRICING: "/scripts/modules/calendar-pricing/views/wizard-calendar-pricing.html"
	})
	.config(function($stateProvider, CalendarPricingViews, ComponentLoaderEnums) {
		var COMPONENT_MODULE = '/scripts/components/';

		var components = [ ComponentLoaderEnums.accessoCalendar, ComponentLoaderEnums.cartFeeNotice ];

		$stateProvider
			.state('calendar', {
				url: '/calendar/{keyword:keyword}/:advanceDays?',
				templateUrl: CalendarPricingViews.CALENDAR_PRICING,
				components: components,
				controller: 'CalendarPricingController',
				components: components,
				params: {
					keyword: {
						value: '',
						squash: false
					},
					advanceDays: {
						value: '',
						squash: true
					}
				},
				resolve: {
					initialData: initialData,
					lazyLoadAssets: lazyLoadAssets,
					routeGuard: routeGuardDefault,
					isRequestingTimeInfo: function isRequestingTimeInfo(routeGuard) {
						return false;
					},
					disableBulkDayRequests: function disableBulkDayRequests(isRequestingTimeInfo) {
						return false;
					},
					singleDayOnlySearch: function singleDayOnlySearch(disableBulkDayRequests) {
						return false;
					},
					usePrevSelDate: usePrevSelDate,
					initialDisplayType: initialDisplayType,
					initialStartDate: initialStartDate,
					initialRawData: initialRawData,
					initialCalendarData: initialCalendarData
				}
			})
			.state('savingsCalendar', {
				url: '/savingsCalendar/{keyword:keyword}/:advanceDays?',
				templateUrl: CalendarPricingViews.CALENDAR_SAVINGS,
				controller: 'CalendarPricingSavingsController',
				components: components,
				params: {
					keyword: {
						value: '',
						squash: false
					},
					advanceDays: {
						value: '',
						squash: true
					}
				},
				resolve: {
					initialData: initialData,
					routeGuard: function routeGuard(initialData, $transition$, ClientInfo, Enums, RouteRejectionService, Utilities) {
						if (ClientInfo.deviceType !== Enums.deviceType.MOBILE) {
							return true;
						}

						$transition$.abort();

						Utilities.goTo('calendar', $transition$.params());

						throw new RouteRejectionService.Exception();

					},
					calendarData: calendarDataDefault,
				}
			})

			.state('calendarPricingByDay', {
				url: '/calendarPricingByDay/{keyword:keyword}/:advanceDays?',
				templateUrl: CalendarPricingViews.CALENDAR_PRICING,
				components: components,
				controller: 'CalendarPricingController',
				components: components,
				params: {
					keyword: {
						value: '',
						squash: false
					},
					advanceDays: {
						value: '',
						squash: true
					}
				},
				resolve: {
					initialData: initialData,
					lazyLoadAssets: lazyLoadAssets,
					routeGuard: routeGuardDefault,
					isRequestingTimeInfo: function isRequestingTimeInfo(routeGuard) {
						return false;
					},
					disableBulkDayRequests: function disableBulkDayRequests(isRequestingTimeInfo) {
						return false;
					},
					singleDayOnlySearch: function singleDayOnlySearch(disableBulkDayRequests) {
						return true;
					},
					usePrevSelDate: usePrevSelDate,
					initialDisplayType: initialDisplayType,
					initialStartDate: initialStartDate,
					initialRawData: initialRawData,
					initialCalendarData: initialCalendarData
				}
			})
			.state('calendarPricingTimesByDay', {
				url: '/calendarPricingTimesByDay/{keyword:keyword}/:advanceDays?',
				templateUrl: CalendarPricingViews.CALENDAR_PRICING_TIMES,
				components: components,
				controller: 'CalendarPricingController',
				components: components,
				params: {
					keyword: {
						value: '',
						squash: false
					},
					advanceDays: {
						value: '',
						squash: true
					}
				},
				resolve: {
					initialData: initialData,
					lazyLoadAssets: lazyLoadAssets,
					routeGuard: routeGuardDefault,
					isRequestingTimeInfo: function isRequestingTimeInfo(routeGuard) {
						return true;
					},
					disableBulkDayRequests: function disableBulkDayRequests(isRequestingTimeInfo) {
						return false;
					},
					singleDayOnlySearch: function singleDayOnlySearch(disableBulkDayRequests) {
						return true;
					},
					usePrevSelDate: usePrevSelDate,
					initialDisplayType: initialDisplayType,
					initialStartDate: initialStartDate,
					initialRawData: initialRawData,
					initialCalendarData: initialCalendarData
				}
			})
			.state('calendarPricingWithImage', {
				url: '/calendarPricingWithImage/{keyword:keyword}/:advanceDays?',
				templateUrl: CalendarPricingViews.CALENDAR_PRICING,
				components: components,
				controller: 'CalendarPricingController',
				components: components,
				params: {
					keyword: {
						value: '',
						squash: false
					},
					advanceDays: {
						value: '',
						squash: true
					}
				},
				resolve: {
					initialData: initialData,
					lazyLoadAssets: lazyLoadAssets,
					routeGuard: routeGuardDefault,
					isRequestingTimeInfo: function isRequestingTimeInfo(routeGuard) {
						return false;
					},
					disableBulkDayRequests: function disableBulkDayRequests(isRequestingTimeInfo) {
						return false;
					},
					singleDayOnlySearch: function singleDayOnlySearch(disableBulkDayRequests) {
						return false;
					},
					usePrevSelDate: usePrevSelDate,
					initialDisplayType: initialDisplayType,
					initialStartDate: initialStartDate,
					initialRawData: initialRawData,
					initialCalendarData: initialCalendarData
				}
			})
			.state('wizardCalendar', {
				url: '/wizardCalendar/:recommenderWizardKeyword/:keyword',
				templateUrl: CalendarPricingViews.WIZARD_CALENDAR_PRICING,
				components: components,
				controller: 'WizardCalendarPricingAcController',
				resolve: {
					initialData: initialData,
					lazyLoadAssets: lazyLoadAssets,
					routeGuard: routeGuardDefault,
					isRequestingTimeInfo: function isRequestingTimeInfo(routeGuard) {
						return false;
					},
					disableBulkDayRequests: function disableBulkDayRequests(isRequestingTimeInfo) {
						return false;
					},
					singleDayOnlySearch: function singleDayOnlySearch(disableBulkDayRequests) {
						return false;
					},
					usePrevSelDate: usePrevSelDate,
					initialDisplayType: initialDisplayType,
					initialStartDate: initialStartDate,
					initialRawData: initialRawData,
					initialCalendarData: initialCalendarData,
					recommenderWizard: function(initialCalendarData, $transition$, RecommenderWizardContextService) {
						if (RecommenderWizardContextService.bootstrapWizard($transition$.params().recommenderWizardKeyword, 'wizardCalendar')) {
							RecommenderWizardContextService.registerCalendarPricing();
						}
					}
				}
			})
			.state('calendarPricingEvent', {
				url: '/calendarPricingEvent/:keyword',
				templateUrl: CalendarPricingViews.CALENDAR_PRICING_EVENT,
				components: components,
				controller: 'CalendarPricingController',
				components: components,
				resolve: {
					initialData: initialData,
					lazyLoadAssets: lazyLoadAssets,
					routeGuard: routeGuardDefault,
					isRequestingTimeInfo: function isRequestingTimeInfo(routeGuard) {
						return true;
					},
					disableBulkDayRequests: function disableBulkDayRequests(isRequestingTimeInfo) {
						return true;
					},
					singleDayOnlySearch: function singleDayOnlySearch(disableBulkDayRequests) {
						return false;
					},
					usePrevSelDate: usePrevSelDate,
					initialDisplayType: initialDisplayType,
					initialStartDate: initialStartDate,
					initialRawData: initialRawData,
					initialCalendarData: initialCalendarData
				}
			});


		/**
		 * Initialize Data Function
		 * @public
		 * @function
		 * @param {Service} Bootstrap Our bootstrap service
		 * @param {Service} Utilities The utilities service
		 * @param {string[]} RESTRICTED_PACKAGES_ASSETS our assets to load
		 * @returns {Promise} To bootstrap and load assets
		 * @ngInject
		 */
		function initialData($transition$, Bootstrap, RestrictedPackagesService, Utilities, RESTRICTED_PACKAGES_ASSETS) {
			return Bootstrap
				.bootstrapApplication(undefined, true)
				.then(function() {
					var additionalAssets = ['scripts/modules/calendar-pricing/calendar-pricing.css'];
					if (RestrictedPackagesService.hasRegisteredPackagesForKeyword($transition$.params().keyword)) {
						additionalAssets = additionalAssets.concat(RESTRICTED_PACKAGES_ASSETS);
					}

					return Utilities.cacheBustAndLazyLoad(additionalAssets);
				});
		}

		/**
		 * Default function for Calendar Data
		 * @public
		 * @function
		 * @param {undefined} initialData
		 * @param {Object} $state
		 * @param {Service} $transition$
		 * @param {Service} CalendarPricingSavingsService
		 * @returns {Promise}
		 * @ngInject
		 */
		function calendarDataDefault(routeGuard, $state, $transition$, CalendarPricingSavingsService) {
			return CalendarPricingSavingsService.initialize($transition$.params(), false, $state, false);
		}

		/**
		 * Default Route Guard
		 * @resolve
		 * @param {Resolve} lazyLoadAssets
		 * @param {Service} $injector
		 * @param {Service} $transition$
		 * @param {Service} Package
		 * @param {Service} RouteRejectionService
		 * @returns {Boolean} Returns true if it passes, error thrown otherwise
		 * @ngInject
		 */
		function routeGuardDefault(lazyLoadAssets, $injector, $transition$, Package, RouteRejectionService) {
			var WTPService = $injector.has('WTPService') && $injector.get('WTPService');
			var keyword = $transition$.params().keyword;
			var pkgs = Package.getPackagesByKeyword(keyword);

			// if items are WTP, redirect to WTP reload page
			if (WTPService && WTPService.isAllPackagesWtp(pkgs) && !WTPService.profile) {
				throw new RouteRejectionService.UnrecoverableException('wtpnumber');
			}

			return true;
		}

		/**
		 * Lazy Loads assets
		 * @resolve
		 * @param {Resolve} initialData - The initialData resolve
		 * @param {Transition} $transition$ - The Transition instance
		 * @param {Service} Utilities - The Utilities Service
		 * @returns {Promise} The promise from loading the files in
		 * @ngInject
		 */
		function lazyLoadAssets(initialData, $transition$, Enums, Utilities) {
			var files = [
				'scripts/modules/calendar-pricing/calendar-pricing-service.js'
			];

			switch($transition$.to().name) {
			case Enums.extraFlowRoutes.WIZARD_CALENDAR:
				files.push('scripts/modules/calendar-pricing/wizard-calendar-pricing.css');
				break;
			case Enums.extraFlowRoutes.CALENDAR_PRICING_EVENT:
				files = files.concat([
					COMPONENT_MODULE + 'timed-event/timed-event-component.css',
					COMPONENT_MODULE + 'timed-event/timed-event-component.js',
					COMPONENT_MODULE + 'timed-event/timed-event-component-controller.js'
				]);
			}

			return Utilities.cacheBustAndLazyLoad(files, true);
		}

		/**
		 * If we should only search a single day
		 * @resolve
		 * @param {Resolve} singleDayOnlySearch - The singleDayOnlySearch resolve
		 * @param {Service} $injector - The injector service
		 * @returns {Boolean} true if it should only be a single day search
		 * @ngInject
		 */
		function usePrevSelDate(singleDayOnlySearch, $injector) {
			var CalendarPricingService = $injector.get('CalendarPricingService');

			return singleDayOnlySearch && CalendarPricingService.isSingleDayOnlySearch();
		}

		/**
		 * The initial display type the calendar should show as
		 * @resolve
		 * @param {Resolve} usePrevSelDate - The usePrevSelDate Resolve
		 * @param {Service} AccessoCalendarEnums - The AccessoCalendarEnums service
		 * @param {Service} Viewport - The Viewport Service
		 * @returns {String} The display type to display as
		 * @ngInject
		 */
		function initialDisplayType(usePrevSelDate, AccessoCalendarEnums, Viewport) {
			return Viewport.api.isMobile ? AccessoCalendarEnums.displayType.week : AccessoCalendarEnums.displayType.month;
		}

		/**
		 * The initial start date to search from
		 * @resolve
		 * @param {Resolve} initialDisplayType - The initialDisplayType resolve
		 * @param {Transition} $transition$ - The Transition instance
		 * @param {Service} LegacyCart - The LegacyCart service
		 * @param {Resolve} usePrevSelDate - The usePrevSelDate resolve
		 * @param {Service} AccessoCalendarService - The AccessoCalendarService service
		 * @param {Service} CustomActionService - The custom action service
		 * @param {Service} Package - The package service
		 * @returns {Date} The initial start date
		 * @ngInject
		 */
		function initialStartDate(initialDisplayType, $transition$, LegacyCart, usePrevSelDate, AccessoCalendarService, CustomActionService, Package) {
			var params = $transition$.params();

			// Use the selected date from the Recommender Wizard service if it exists
			CustomActionService.executeCustomAction('setCalendarPricingModuleDate');

			// If we are in an alt module or cross-sell
			if (usePrevSelDate) {
				// Use the Cart lastDateAdded value
				return AccessoCalendarService.createDate(LegacyCart.lastDateAdded.start_date);
			} else if (Package.calendarPricingModuleDate instanceof Date) {
				// Recommender Wizard date
				return AccessoCalendarService.createDate(Package.calendarPricingModuleDate);
			}

			// Otherwise, use today
			return AccessoCalendarService.getValidKeywordFirstAvailableDate(AccessoCalendarService.createDate(), params.keyword);
		}

		/**
		 * The raw response data from the request to backend
		 * @resolve
		 * @param {Service} $injector - The injector service
		 * @param {Service} $q - The $q service
		 * @param {Service} $rootScope - $rootScope
		 * @param {Transition} $transition$ - The Transition instance
		 * @param {Service} AccessoCalendarService - The AccessoCalendarService service
		 * @param {Resolve} initialStartDate - The initialStartDate resolve
		 * @param {Resolve} initialDisplayType - The initialDisplayType resolve
		 * @param {Resolve} isRequestingTimeInfo - The isRequestingTimeInfo resolve
		 * @param {Service} Language - The Language Service
		 * @param {Object} LanguageEnums - The Language Enums Object
		 * @param {Resolve} usePrevSelDate - The usePrevSelDate resolve
		 * @param {Service} Utilities - The Utilities service
		 * @returns {Object} The raw response object
		 * @ngInject
		 */
		function initialRawData($injector, $q, $rootScope, $transition$, AccessoCalendarService, disableBulkDayRequests, initialStartDate, initialDisplayType, isRequestingTimeInfo, Language, LanguageEnums, usePrevSelDate, Utilities) {
			var CalendarPricingService = $injector.get('CalendarPricingService');

			var deferred = $q.defer(),
				endDate,
				matchDate,
				params = $transition$.params(),
				startDate = initialStartDate;

			if (usePrevSelDate) {
				endDate = AccessoCalendarService.alterDate(initialStartDate, 1);
			} else if (disableBulkDayRequests) {
				endDate = AccessoCalendarService.createDate(initialStartDate);
			} else {
				startDate = AccessoCalendarService.getStartDate(initialStartDate, initialDisplayType);
				endDate = AccessoCalendarService.getEndDate(initialStartDate, initialDisplayType);
			}
			// Show spinner before the async HTTP request so the user sees loading feedback
			// for the full duration of the network call, not just after it completes.
			$rootScope.showSpinner(Language.getLocaleWithSuffixAndFallback('ApplicationLabels', 'gettingEventDates',
				LanguageEnums.MERCHANT_ID));

			CalendarPricingService
				.requestDates(params.keyword, startDate, endDate, isRequestingTimeInfo, initialDisplayType)
				.then(function onComplete(rawData) {
					if (usePrevSelDate && Utilities.checkProp('rawData.DATES.D', rawData)) {
						matchDate = Utilities.javascriptDateToSQLDate(initialStartDate);

						rawData.DATES.D = Utilities.wrapObjectToArray(rawData.DATES.D, true).filter(function iterateRawDataDates(dt) {
							return dt.date === matchDate;
						});
					}

					deferred.resolve(rawData);

					return rawData;
				})
				.catch(function onFailure() {
					deferred.resolve([]);
				});

			return deferred.promise;
		}

		/**
		 * Generates the formatted calendar data to be used with accessoCalendar
		 * @resolve
		 * @param {Resolve} initialRawData - The initialRawData resolve
		 * @param {Service} $injector - The injector service
		 * @param {Service} $rootScope - The $rootScope service
		 * @param {Service} AccessoCalendarDataService - The AccessoCalendarDataService service
		 * @param {Service} AccessoCalendarService - The AccessoCalendarService service
		 * @param {Resolve} disableBulkDayRequests - The disableBulkDayRequests resolve
		 * @param {Resolve} isRequestingTimeInfo - The isRequestingTimeInfo resolve
		 * @returns {Object[]} The formatted calendar data
		 * @ngInject
		 */
		function initialCalendarData(initialRawData, initialDisplayType, initialStartDate, $injector, $rootScope, AccessoCalendarDataService, AccessoCalendarService, disableBulkDayRequests, isRequestingTimeInfo) {
			var CalendarPricingService = $injector.get('CalendarPricingService');

			var normalized;

			// The accesso-calendar component needs a $timeout to fully initialize after the view renders.
			// Retain the spinner through onSuccess so it stays visible until onCalendarInit dismisses it.
			$rootScope._skipNextOnSuccessHideSpinner = true;

			normalized = AccessoCalendarDataService.normalizeDataFromResponse(initialRawData, CalendarPricingService.getServiceRequest(isRequestingTimeInfo), { markAllAvailable: true });

			if (disableBulkDayRequests) {
				return CalendarPricingService.generateEmptyDaysForSet(normalized, initialStartDate, AccessoCalendarService.getEndDate(initialStartDate, initialDisplayType));
			}

			return normalized;
		}
	})
	.run(function(ExtraFlow, Enums) {
		// Register this extra flow module with the extra flow service
		ExtraFlow.registerXMC
		('CalendarPricingModule',
			{
				name: 'CalendarPricingModule',
				view: Enums.extraFlowRoutes.CALENDAR,
				showTimeList: true,
				doEditMode: false,
				 lockQuantity: true,
				writeSingleCharac: false,
				enabled: true,
				type: 'alternateFlowModule',
				characsList: ['start_date'],
				optionalParams: ['advanceDays']
			}
		);

		ExtraFlow.registerXMC
		('SavingsCalendarModule',
			{
				name: 'SavingsCalendarModule',
				view: Enums.extraFlowRoutes.SAVINGS_CALENDAR,
				showTimeList: true,
				lockQuantity: true,
				doEditMode: false,
				writeSingleCharac: false,
				enabled: true,
				type: 'alternateFlowModule',
				optionalParams: ['advanceDays']
			}
		);

		ExtraFlow.registerXMC
		('CalendarPricingByDayModule',
			{
				name: 'CalendarPricingByDayModule',
				view: Enums.extraFlowRoutes.CALENDAR_BY_DAY,
				showTimeList: true,
				lockQuantity: true,
				doEditMode: false,
				writeSingleCharac: false,
				enabled: true,
				type: 'alternateFlowModule',
				characsList: ['start_date'],
				optionalParams: ['advanceDays']
			}
		);

		ExtraFlow.registerXMC
		('CalendarPricingTimesByDay',
			{
				name: 'CalendarPricingTimesByDay',
				view: Enums.extraFlowRoutes.CALENDAR_TIMES,
				showTimeList: true,
				lockQuantity: true,
				doEditMode: false,
				writeSingleCharac: false,
				enabled: true,
				type: 'alternateFlowModule',
				characsList: ['start_date'],
				optionalParams: ['advanceDays']
			}
		);

		ExtraFlow.registerXMC
		('CalendarPricingWithImage',
			{
				name: 'CalendarPricingWithImage',
				view: Enums.extraFlowRoutes.CALENDAR_IMAGE,
				showTimeList: true,
				lockQuantity: true,
				doEditMode: false,
				writeSingleCharac: false,
				enabled: true,
				type: 'alternateFlowModule',
				characsList: ['start_date'],
				optionalParams: ['advanceDays']
			}
		);

		ExtraFlow.registerXMC('calendarPricingEvent', {
			name: 'calendarPricingEvent',
			view: Enums.extraFlowRoutes.CALENDAR_PRICING_EVENT,
			showTimeList: true,
			lockQuantity: true,
			doEditMode: false,
			writeSingleCharac: false,
			enabled: true,
			type: 'alternateFlowModule'
		}
		);

		ExtraFlow.registerXMC
		('WizardCalendarPricingModule',
			{
				name: 'WizardCalendarPricingModule',
				view: Enums.extraFlowRoutes.WIZARD_CALENDAR,
				viewIsStateName: true,
				showTimeList: true,
				doEditMode: false,
				lockQuantity: true,
				writeSingleCharac: false,
				enabled: true,
				type: 'alternateFlowModule',
				characsList: ['start_date']
			}
		);
	});
(function() {
	'use strict';

	angular
		.module('calendar-pricing')
		.controller('CalendarPricingController', CalendarPricingController);

	/**
	 * The Calendar Pricing (Accesso Calendar) Controller
	 * @param {Service} $filter - The filter service
	 * @param {Service} $q - The promise service
	 * @param {Scope} $rootScope - The root scope
	 * @param {Scope} $scope - The controller scope
	 * @param {Service} $transition$ - The current $transition$ information
	 * @param {Service} AccessoCalendarDataService - The AccessoCalendarData Service
	 * @param {Service} AccessoCalendarEnums - The Accesso Calendar Enums Service
	 * @param {Service} AccessoCalendarService - The AccessoCalendar Service
	 * @param {Service} AnalyticsEnumsService - The Analytics Enum Service
	 * @param {Service} AppData - The AppData Service
	 * @param {Service} CalendarPricingService - The CalendarPricingAc Service
	 * @param {Service} CalendarPricingModels - The CalendarPricingModels Service
	 * @param {Service} CartService - The Cart Service
	 * @param {Service} ClientInfo - The ClientInfo Service
	 * @param {Boolean} disableBulkDayRequests - If we should disable bulk day requests
	 * @param {Service} DynamicCapacityPricingService - The DynamicCapacityPricing Service
	 * @param {Service} Enums - The Enums Service
	 * @param {Service} ExtraFlow - The ExtraFlow Service
	 * @param {Service} FeeService - The Fee Service
	 * @param {Object[]} initialCalendarData - The initial Calendar Data
	 * @param {String} initialDisplayType - The initial display type
	 * @param {Object[]} initialRawData - The initial raw data
	 * @param {Date} initialStartDate - The initial starting date
	 * @param {Boolean} isRequestingTimeInfo - If the flow is requesting time info
	 * @param {Service} Language - The Language Service
	 * @param {Object} LanguageEnums - The Language Enums object
	 * @param {Service} Modal - The Modal Service
	 * @param {Service} Package - The Package Service
	 * @param {Service} RestrictedPackagesService - The RestrictedPackages Service
	 * @param {Service} StandardFlowInitiatorService - The StandardFlowInitiator Service
	 * @param {Boolean} usePrevSelDate - If we should be using the previous passed date
	 * @param {Service} Utilities - The Utilities Service
	 * @param {Service} UtilsValidation - The UtilsValidation Service
	 * @constructor
	 * @ngInject
	 */
	function CalendarPricingController(
		$filter,
		$q,
		$rootScope,
		$scope,
		$transition$,
		AccessoCalendarDataService,
		AccessoCalendarEnums,
		AccessoCalendarService,
		AnalyticsEnumsService,
		AppData,
		CalendarPricingService,
		CalendarPricingModels,
		CartService,
		ClientInfo,
		disableBulkDayRequests,
		DynamicCapacityPricingService,
		Enums,
		ExtraFlow,
		FeeService,
		initialCalendarData,
		initialDisplayType,
		initialRawData,
		initialStartDate,
		isRequestingTimeInfo,
		Language,
		LanguageEnums,
		Modal,
		Package,
		RestrictedPackagesService,
		StandardFlowInitiatorService,
		usePrevSelDate,
		Utilities,
		UtilsValidation
	) {
		var vm = this;

		var merge = Object.assign || angular.merge;

		var checkProp = Utilities.checkProp,
			createDate = AccessoCalendarService.createDate,
			forceInt = Utilities.forceInt,
			isMonthEqual = AccessoCalendarService.isMonthEqual,
			localeExists = Language.localeExists,
			toArray = Utilities.toArray,
			validArray = UtilsValidation.validArray,
			validObject = UtilsValidation.validObject;

		merge(vm, {
			$onInit: $onInit,
			_: {
				$advanceDays: Math.max(!usePrevSelDate && Utilities.forceInt($transition$.params().advanceDays), 0),
				$anyDayPackages: [],
				$conflictResolutionBlockMode: checkProp('AppData.settings.conflictResolutionBlockPurchase', AppData, 'getBoolean'),
				$disableConflictResolutionForDates: checkProp('AppData.settings.disable_conflict_resolution_for_dates', AppData, 'getBoolean'),
				$enableCalBanner: checkProp('AppData.GetApplicationConsolidated.SETTINGS.enableCalBanner', AppData, 'getBoolean'),
				$enableConflictResolution: checkProp('AppData.settings.enable_conflict_resolution', AppData, 'getBoolean'),
				$keyword: $transition$.params().keyword,
				$lastResponse: initialRawData,
				$stateName: $transition$.to().name,
				$stateParams: $transition$.params(),
				assignBanners: _assignBanners,
				assignLocales: _assignLocales,
				calendarRequestDates: _calendarRequestDates,
				checkForDateTimeConflicts: _checkForDateTimeConflicts,
				confirmDateSelection: _confirmDateSelection,
				createAvailabilityArr: _createAvailabilityArr,
				exitModule: _exitModule,
				getFirstSelectedDate: _getFirstSelectedDate,
				localizeEventHeadline: _localizeEventHeadline,
				mapTimedEventPackages: _mapTimedEventPackages,
				routeToAnyDay: _routeToAnyDay,
				save: _save,
				setPackages: _setPackages
			}
		});

		merge($scope, {
			getAnyDayLocale: getAnyDayLocale,
			getBuyPackageLocale: getBuyPackageLocale,
			getLocale: getLocale,
			goToAnyDayKeyword: goToAnyDayKeyword,
			goToAnyDayPackage: goToAnyDayPackage,
			onCalendarInit: onCalendarInit,
			onCalendarMove: onCalendarMove,
			onCalendarSelectDate: onCalendarSelectDate,
			onSelectPackage: onSelectPackage,
			timeSelected: timeSelected
		});

		merge($scope, {
			// We need the i18n on the scope until calendar-pricing-ac-controller.js and calendar-pricing-controller.js
			// are merged
			i18n: Language
		});

		/********************
		 * PUBLIC FUNCTIONS *
		 ********************/

		/**
		 * The initialize function
		 * @lifecycle
		 * @function
		 * @returns {undefined}
		 */
		function $onInit() {
			var params = $transition$.params();

			// Set AppData lastKeyword to be the current keyword
			AppData.updateLastKeyword(params.keyword, 'Calendar Pricing Service');

			// Grab the any day packages for the current keyword
			vm._.$anyDayPackages = new CalendarPricingModels.AnyDayPackageService(params.keyword);

			merge($scope, {
				banner: {},
				calendarData: initialCalendarData,
				calendarLoading: false,
				disableLowestPrice: true,
				disableNavigation: usePrevSelDate && validArray(initialCalendarData),
				displayType: ClientInfo.deviceType === Enums.deviceType.MOBILE ? AccessoCalendarEnums.displayType.week : AccessoCalendarEnums.displayType.month,
				eventPanelHeadline: '',
				feePageKey: isRequestingTimeInfo ? FeeService.enums.COMBO_CREATOR : FeeService.enums.CALENDAR_PRICING,
				hidePrice: !CalendarPricingService.getCalPriceSortIndicator(),
				isMobile: ClientInfo.deviceType === Enums.deviceType.MOBILE,
				packageKeyword: Utilities.getKeywordByUrl(AppData.GetApplicationConsolidated.TREE.MENUITEM, vm._.$keyword),
				packageList: [],
				locale: {},
				restrictedPackageLocales: null,
				showAnyDayPackage: vm._.$anyDayPackages.exists(),
				showFeeNotice: isRequestingTimeInfo ? FeeService.isPageActive(FeeService.enums.COMBO_CREATOR) : FeeService.isPageActive(FeeService.enums.CALENDAR_PRICING),
				timedEventPackagesArray: [],
				withImage: vm._.$stateName === 'calendarPricingWithImage'
			});

			// Determine the first selected date
			// This can set items in the scope, so it cannot be called within a merge
			$scope.selectedDate = vm._.getFirstSelectedDate();

			$scope.packageList = initialRawData.status === Enums.status.OK
				? CalendarPricingService.transformToPackageList(vm._.$keyword, initialRawData, $scope.selectedDate)
				: [];

			//Package List impression trigger for analytics
			var analyticsEventListener = $rootScope.$on(AnalyticsEnumsService.events.POST_INTERNALSTATECHANGE, function fireAnalyticsAfterStateChange() {
				$rootScope.$broadcast('triggerImpressionsPackList', [$scope.packageList], 'Calendar Pricing ' + vm._.$keyword);
				analyticsEventListener(); //stop listening once fired
			});
			vm._.mapTimedEventPackages();

			vm._.assignLocales();

			vm._.assignBanners();

			vm._.localizeEventHeadline($scope.selectedDate);
		}

		/**
		 * Grabs a locale from the language service
		 * @function
		 * @memberof $scope
		 * @param {String} section - The Locale section
		 * @param {String} target - The Locale target
		 * @returns {String} - The desired locale
		 */
		function getLocale(section, target) {
			return Language.getLocaleWithSuffixAndFallback(section, target, LanguageEnums.MERCHANT_ID);
		}

		/**
		 * Grabs the any day locales
		 * @param {String} section The section
		 * @param {String} target The target
		 * @returns {String} our locale
		 */
		function getAnyDayLocale(section, target) {
			var prefix = vm._.$keyword && vm._.$keyword.replace(/\s/g, '') || '',
				suffix = AppData.settings.merchant_locale_suffix || '',
				extendedLocale,
				localeWithPrefix;

			if (suffix) {
				suffix = suffix[0] !== '_' ? '_' + suffix : suffix;
				extendedLocale = getLocaleWithPrefix(section, target, prefix, suffix);

				if (extendedLocale) {
					return extendedLocale;
				}

				if (localeExists(section, target + suffix)) {
					return getLocale(section, target + suffix);
				}
			}

			localeWithPrefix = getLocaleWithPrefix(section, target, prefix, '');
			if (localeWithPrefix) {
				return localeWithPrefix;
			}

			return getLocale(section, target);
		};

		/**
		 * Return locale based on prefix and suffix
		 * @protected
		 * @param {String} section section of the locale
		 * @param {String} target target of the locale
		 * @param {String} prefix prefix for the locale
		 * @param {String} suffix suffix for the locale
		 * @returns {String/undefined} locale/undefined
		 */
		function getLocaleWithPrefix(section, target, prefix, suffix) {
			if (prefix) {
				prefix = prefix[prefix.length - 1] !== '_' ? prefix + '_' : prefix;

				if (localeExists(section, prefix + target + suffix)) {
					return getLocale(section, prefix + target + suffix);
				}
			}
			return;
		}

		/**
		 * Unified the Any Day links, to the Savings Calendar Module and the Calendar Pricing Module work the same
		 * Left the routing methods separate, in case they have any functionality added in the future.
		 * @returns {undefined}
		 */
		function _routeToAnyDay() {
			var anyDayLink = vm._.$anyDayPackages.hrefForRouting();

			if (anyDayLink) {
				if (Package.alternateModuleItemsToBeAdded) {
					StandardFlowInitiatorService.setAlternateEntryToStandardFlow(vm._$stateName, vm._$stateName, vm._.$stateParams, true);
				} else {
					StandardFlowInitiatorService.setStandardFlow(undefined, vm._.$stateName, vm._.$keyword);
				}
				$scope.routeTo(anyDayLink);
			}
		}

		/**
		 * Called from Savings Calendar Module - keyword-based navigation
		 * @callback
		 * @returns {undefined}
		 */
		function goToAnyDayKeyword() {
			vm._.routeToAnyDay();
		}

		/**
		 * Called from Calendar Pricing Module - package ID based navigation OR keyword based navigation
		 * @callback
		 * @returns {undefined}
		 */
		function goToAnyDayPackage() {
			vm._.routeToAnyDay();
		}

		/**
		 * Logic to run when calendar initializes
		 * @callback
		 * @returns {undefined}
		 */
		function onCalendarInit() {
			$rootScope.hideSpinner();
		}

		/**
		 * Logic to run when the calendar is trying to navigate
		 * @callback
		 * @param {String} displayType - The display type the calendar will be showing after navigation
		 * @param {Date} startDate - The new start date
		 * @param {Date} endDate - The new end date
		 * @returns {Promise} - The promise of the request
		 */
		function onCalendarMove(displayType, startDate, endDate) {
			var deferred = $q.defer();

			$scope.displayType = displayType;
			$scope.selectedDate = null;

			if (disableBulkDayRequests) {
				$scope.calendarData = CalendarPricingService.generateEmptyDaysForSet([], startDate, endDate);
				deferred.resolve();
			} else {
				vm._.calendarRequestDates(startDate, endDate).then(function onComplete() {
					vm._.setPackages();

					deferred.resolve();
				});
			}

			return deferred.promise;
		}

		/**
		 * Logic to run when the calendar has a new date selected
		 * @callback
		 * @param {Date} - The new selected date
		 * @returns {undefined}
		 */
		function onCalendarSelectDate(date) {
			// If the newly selected date is the same as the old date
			if (AccessoCalendarService.isDateEqual(date, $scope.selectedDate)) {
				// Do Nothing
				return;
			}

			// Set new date as selected date
			$scope.selectedDate = date;

			if (disableBulkDayRequests && date) {
				vm._.calendarRequestDates(AccessoCalendarService.getValidStartDate(AccessoCalendarService.createDate(date, true)), AccessoCalendarService.getEndDate(date, $scope.displayType))
					.finally(vm._.setPackages);
			} else {
				vm._.setPackages();
			}
		}

		/**
		 * Logic to be ran when a user selects a package from the list
		 * @memberof $scope
		 * @param {Object} pkg - The calendar pricing package object
		 * @returns {undefined}
		 */
		function onSelectPackage(pkg) {
			if (!$scope.selectedDate) {
				// Date not selected. User is notified by displayed message.
				Modal.displayModal({
					action: 'Error',
					category: 'Date / Time',
					description: $scope.getLocale('DateTime', 'selectDateError'),
					icon: 'icon-datetime green',
					label: 'Missing Date',
					title: $scope.getLocale('Alert', 'generalErrorTitle')
				});

				return;
			}

			// Update the last accessed package list for analytics purposes
			Package.updateLastAccessedPackageList($scope.packageList);

			if (vm._.checkForDateTimeConflicts(pkg)) {
				vm._.confirmDateSelection(pkg);
			}
		}

		/**
		 * Filter out the package based on selected event, then call selectPackage function
		 * @function
		 * @memberof $scope
		 * @param {Object} event - selected event
		 * @param {Object} timeObj - selected time object
		 * @returns {undefined}
		 */
		function timeSelected(event, timeObj) {
			var selectedPackage = $scope.packageList.find(function(pkg) {
				return event.packageId === pkg.id;
			});

			if (validObject(timeObj)) {
				if (!checkProp('selectedPackage.packageDetails.CHARACS', selectedPackage, 'validObject')) {
					return;
				}

				selectedPackage.startTime = timeObj.time;
			}

			$scope.onSelectPackage(selectedPackage);
		}

		/**
		 * Show the data image in a modal
		 * @function
		 * @memberof $scope
		 * @param {Object} data - selected image
		 * @param {Object} $event - event object
		 * @returns {undefined}
		 */
		$scope.showImage = function launchImageModal(data, $event) {
			var scope = $rootScope.$new();
			$event.stopPropagation();
			scope.imageURL = data.imageURL;
			scope.header = data.imageTitle;

			Modal.displayModal({
				action: 'View',
				category: 'Calendar Pricing',
				customHTML: '/scripts/modules/calendar-pricing/views/image.html',
				description: scope,
				headerFlag: Modal.DEFAULT,
				hideAllButtons: true,
				label: data.imageTitle,
				showCloseButton: true,
				title: data.imageTitle
			});
		};

		/*********************
		 * PRIVATE FUNCTIONS *
		 *********************/

		/**
		 * Assigns the banner locales to be accessible from the scope
		 * @protected
		 * @memberof vm
		 * @returns {undefined}
		 */
		function _assignBanners() {
			var mobileCalendarBanner,
				desktopCalendarBanner;

			if (!vm._.$enableCalBanner) {
				return;
			}

			mobileCalendarBanner = Language.localeExists('CalendarPricing', vm._.$keyword + 'MobileBannerImage') && $scope.getLocale('CalendarPricing', vm._.$keyword + 'MobileBannerImage');
			if (mobileCalendarBanner) {
				$scope.banner.mobileBannerImage = $rootScope.getAssetUrl(mobileCalendarBanner);
			}

			desktopCalendarBanner = (Language.localeExists('CalendarPricing', vm._.$keyword + 'DesktopBannerImage') && $scope.getLocale('CalendarPricing', vm._.$keyword + 'DesktopBannerImage')) || CalendarPricingService.getCalendarBanner();
			if (desktopCalendarBanner) {
				$scope.banner.calendarBannerImage = $rootScope.getAssetUrl(desktopCalendarBanner);
			}
		}

		/**
		 * Assigns the locales to the locale object
		 * @protected
		 * @memberof vm
		 * @returns {undefined}
		 */
		function _assignLocales() {
			var section = 'SavingsCalendar';

			if (RestrictedPackagesService.hasRegisteredPackagesForKeyword(vm._.$keyword)) {
				$scope.restrictedPackageLocales = RestrictedPackagesService.getLocaleData(
					RestrictedPackagesService.getModuleByPackage(checkProp('calendarData.0.dataMap.packageId', $scope.calendarData, 'returnValue'))
				);
			}

			// If the state name is not savings calendar
			if (vm._.$stateName !== 'savingsCalendar') {
				// Exit
				return;
			}

			merge($scope.locale, {
				anyDayInstructions: $scope.getLocale(section, vm._.$keyword + 'AnyDayInstructions'),
				headline: $scope.getLocale(section, vm._.$keyword + 'Headline')
			});

			['Large', 'Small'].some(function iterateCalendarImageSizes(size) {
				if (Language.localeExists(section, vm._.$keyword + size + 'Image')) {
					$scope.calImage = $rootScope.getAssetUrl($scope.getLocale(section, vm._.$keyword + size + 'Image'));
					$scope[size.toLowerCase() + 'Image'] = true;

					return true;
				}

				return false;
			});

			if (CalendarPricingService.getLegendSetting('mode') === 'custom') {
				merge($scope.locale, {
					chevronOneLabel: $scope.getLocale('CalendarPricing', vm._.$keyword + 'chevronOneLabel'),
					chevronTwoLabel: $scope.getLocale('CalendarPricing', vm._.$keyword + 'chevronTwoLabel')
				});
			}
		}

		/**
		 * Requests dates for the given range
		 * @protected
		 * @memberof vm
		 * @param {Date} startDate - The start date to request
		 * @param {Date} endDate - The end date to request
		 * @returns {Promise} - The promise of the request
		 */
		function _calendarRequestDates(startDate, endDate) {
			var reqEnd = disableBulkDayRequests ? $scope.selectedDate : endDate,
				reqStart = disableBulkDayRequests ? $scope.selectedDate : startDate;

			$scope.calendarLoading = true;

			$rootScope.showSpinner($scope.getLocale('ApplicationLabels', 'gettingEventDates'));

			vm._.$lastResponse = { status: Enums.status.FAILED };

			return CalendarPricingService
				.requestDates(vm._.$keyword, reqStart, reqEnd, isRequestingTimeInfo)
				.then(function onComplete(rawData) {
					var normalized;

					vm._.$lastResponse = rawData;
					normalized = AccessoCalendarDataService.normalizeDataFromResponse(rawData, CalendarPricingService.getServiceRequest(isRequestingTimeInfo), { markAllAvailable: true });

					if (disableBulkDayRequests) {
						normalized = CalendarPricingService.generateEmptyDaysForSet(
							normalized,
							AccessoCalendarService.getStartDate($scope.selectedDate, $scope.displayType),
							AccessoCalendarService.getEndDate($scope.selectedDate, $scope.displayType)
						);
					}

					$scope.calendarData = normalized;

					$scope.calendarLoading = false;
					$rootScope.hideSpinner();
				})
				.catch(function onFailure() {
					$scope.calendarLoading = false;
					$rootScope.hideSpinner();
				});
		}

		/**
		 * Checks to see if there are any conflicts with the selection
		 * @protected
		 * @memberof vm
		 * @param {Object} pkg - The calendar pricing package object
		 * @returns {Boolean} true if the checks pass, false otherwise
		 */
		function _checkForDateTimeConflicts(pkg) {
			// check selected date against cart dates. Different dates are conflicts
			// different packages or same packages doesn't matter here. Different dates are conflicts
			var conflictFound = false,
				matchFound = false,
				modalOptions,
				cartItems = CartService.getCartItems();

			if (vm._.$disableConflictResolutionForDates || cartItems.length === 0 || !vm._.$enableConflictResolution) {
				return true;
			}
			cartItems.some(function iterateCartItems(item) {
				var startDate;

				if (checkProp('item.characs.0.start_date', item, 'isDateString')) {
					startDate = Utilities.dateStringToObject(item.characs[0].start_date);

					if (AccessoCalendarService.isDateEqual($scope.selectedDate, startDate)) {
						matchFound = true;

						return true;
					}

					conflictFound = true;
				}
				return false;
			});

			if (conflictFound && !matchFound) {
				// Conflict
				modalOptions = {
					action: 'Conflict',
					category: 'Scheduling',
					label: 'Scheduling Date Conflict'
				};

				if (vm._.$conflictResolutionBlockMode) {
					merge(modalOptions, {
						buttonFlags: [Enums.buttonFlags.OK],
						description: $scope.getLocale('Alert', 'conflictBlockDate'),
						title: $scope.getLocale('Alert', 'conflictBlockDateTitle')
					});
				} else {
					merge(modalOptions, {
						buttonFlags: [Enums.buttonFlags.NO, Enums.buttonFlags.YES],
						callback: function modalCallback(details) {
							if (details === Enums.buttonFlags.YES) {
								vm._.confirmDateSelection(pkg);
							}
						},
						description: $scope.getLocale('Alert', 'conflictBlockDate'),
						title: $scope.getLocale('Alert', 'conflictBlockDateTitle')
					});
				}

				if (vm._.$conflictResolutionBlockMode) {
					modalOptions.title = getLocale('Alert', 'conflictBlockDateTitle');
					modalOptions.description = getLocale('Alert', 'conflictBlockDate');
					modalOptions.buttonFlags = [Enums.buttonFlags.OK];
				} else {
					modalOptions.title = getLocale('Alert', 'conflictWarnDateTitle');
					modalOptions.description = getLocale('Alert', 'conflictWarnDate');
					modalOptions.buttonFlags = [Enums.buttonFlags.NO, Enums.buttonFlags.YES];
					modalOptions.callback = function(details) {
						if (details == Enums.buttonFlags.YES) {
							vm._.confirmDateSelection(pkg);
						}
					};
				}

				Modal.displayModal(modalOptions);

				return false;
			}

			return true;
		}

		/**
		 * Prompts the guest if they are sure of their selections
		 * @protected
		 * @memberof vm
		 * @param {Object} pkg - The selected calendar pricing package object
		 * @returns {undefined}
		 */
		function _confirmDateSelection(pkg) {
			var desc = $filter('date')($scope.selectedDate, 'fullDate');

			vm._.save(pkg);

			Modal.displayModal({
				category: 'Date / Time',
				action: 'Confirm',
				label: 'Add Date / Time Confirmation.',
				type: Enums.modalTypes.CONFIRMDATETIME,
				title: $scope.getLocale('Reservations', 'headingConfirm'),
				icon: 'icon-datetime green',
				description: '<span class="blue">' + desc + '</span>',
				buttonFlags: [Enums.buttonFlags.CANCEL, Enums.buttonFlags.CONFIRM],
				suppressedAction: function suppressedAction() {
					vm._.exitModule(pkg);
				},
				callback: function modalCallback(detail) {
					if (detail === Enums.buttonFlags.CONFIRM) {
						vm._.exitModule(pkg);
					}
				}
			});
		}

		/**
		 * Grabs the localized buy package text for a specific package
		 * @param {Object} pkg - The package object
		 * @returns {String} - The localized buy button text
		 */
		function getBuyPackageLocale(pkg) {
			return $scope.getLocale('Accessibility', 'buyEvent').replace(/@@eventName/g, pkg.name);
		}

		/**
		 * Create an availability array which contains specific time, sold out flag, and remaining value for timed event
		 * component
		 * @protected
		 * @memberof vm
		 * @param {Object} pkg - package details data object
		 * @param {Number} soldOutThreshold The sold out threshold
		 * @param {Number} remainingThreshold The remaining threshold
		 * @returns {Object[]} availability array
		 */
		function _createAvailabilityArr(pkg, soldOutThreshold, remainingThreshold) {
			var currentPkgCapacity = forceInt(checkProp('pkg.packageDetails.E.capacity', pkg, 'returnValue')),
				soldOutFlag,
				remaining;

			if (!validArray(pkg.times)) {
				return [];
			}

			// -1 indicates that the ticket has no limit
			if (currentPkgCapacity !== -1) {
				if (!Number.isNaN(soldOutThreshold)) {
					soldOutFlag = currentPkgCapacity <= soldOutThreshold;
				}

				if (!soldOutFlag && !isNaN(remainingThreshold) && currentPkgCapacity < remainingThreshold) {
					remaining = currentPkgCapacity - soldOutThreshold + $scope.getLocale('CalendarPricing', 'eventRemaining');
				}
			}

			return pkg.times.map(function(time, index) {
				return {
					remaining: remaining,
					soldOut: soldOutFlag,
					time: time,
					timeHasPassed: pkg.packageTimes[index].timeHasPassed
				};
			});
		}

		/**
		 * Handle the steps to move on to the rest of the flow.
		 * @protected
		 * @memberof vm
		 * @param {Object} pkg - The selected calendar pricing package object
		 * @returns {undefined}
		 */
		function _exitModule(pkg) {
			var useDynamicPricing = DynamicCapacityPricingService.isPackageDynamic(pkg.id);

			if (Package.alternateModuleItemsToBeAdded) {
				StandardFlowInitiatorService.setAlternateEntryToStandardFlow(vm._.$stateName, vm._.$stateName, vm._.$stateParams, true);
			} else {
				StandardFlowInitiatorService.setStandardFlow(undefined, vm._.$stateName, vm._.$keyword);
			}

			// Eagerly show the spinner to prevent a background image flash before onBefore fires.
			// showSpinner() is idempotent; the global onSuccess hook in run.js dismisses it.
			$rootScope.showSpinner();

			Utilities.goTo(Enums.routes.DETAILS, {
				dynamicPricing: useDynamicPricing ? DynamicCapacityPricingService.getRouteParams(pkg.CT, pkg.id) : [],
				flowDetail: StandardFlowInitiatorService.currentStandardFlowDetail,
				flowType: StandardFlowInitiatorService.currentStandardFlowType,
				packageId: pkg.id
			});
		}

		/**
		 * Determines what the first selected date should be
		 * @protected
		 * @memberof vm
		 * @returns {Date|null} The date that should be selected, null otherwise
		 */
		function _getFirstSelectedDate() {
			var firstDate;

			if (vm._.$stateParams.advanceDays) {
				return AccessoCalendarService.alterDate(initialStartDate, vm._.$advanceDays);
			} else if (usePrevSelDate) {
				return initialStartDate;
			} else if (validArray(initialCalendarData)) {
				firstDate = AccessoCalendarDataService.getFirstAvailableDate(initialCalendarData);

				if (isMonthEqual(firstDate, createDate())) {
					return firstDate;
				}
			}

			return null;
		}

		/**
		 * Helper method to localize the event panel headline with a date selected from the calendar
		 * @protected
		 * @memberof vm
		 * @param {String} date - The date string (full obj)
		 * @returns {String} the locale with @@date replaced by the localized date string.
		 */
		function _localizeEventHeadline(date) {
			var locale = $filter('date')(date, 'fullDate');

			$scope.eventPanelHeadline = Language.replaceAllMultiple(
				['@@date', '@@Date'],
				[locale, locale],
				$scope.getLocale('CalBasePricing', 'eventPanelHeadline')
			);
		}

		/**
		 * Map package to timed event format array so it can be used in the component
		 * @protected
		 * @memberof vm
		 * @returns {undefined} Object timed event packages
		 */
		function _mapTimedEventPackages() {
			if (vm._.$stateName !== Enums.extraFlowRoutes.CALENDAR_PRICING_EVENT || !validArray($scope.packageList)) {
				$scope.timedEventPackagesArray = [];
				return;
			}

			$scope.timedEventPackagesArray = $scope.packageList.map(function(pkg) {
				var pkgDetails = pkg.packageDetails || pkg,
					soldOutThreshold = forceInt(checkProp('pkgDetails.CHARACS.capacity_threshold_amount', pkgDetails, 'returnValue')),
					remainingThreshold = forceInt(checkProp('pkgDetails.CHARACS.remaining_threshold_amount', pkgDetails, 'returnValue'));

				return {
					availability: vm._.createAvailabilityArr(pkg, soldOutThreshold, remainingThreshold),
					date: $scope.selectedDate,
					desc: pkg.headline,
					image: $rootScope.getAssetUrl(pkgDetails.shop_image_v4),
					name: pkgDetails.name,
					packageId: pkgDetails.id,
					showBuyNow: checkProp('pkgDetails.E.date', pkgDetails, 'returnValue') === '2'
				};
			});
		}

		/**
		 * Saves the selection to itemsToBeAdded
		 * @protected
		 * @memberof vm
		 * @param {Object} pkg - The selected calendar pricing package object
		 * @returns {undefined}
		 */
		function _save(pkg) {
			var cts = toArray(pkg.packageDetails.CT),
				itemsToBeAdded;

			itemsToBeAdded = cts.map(function iterateCts(ct) {
				var app = CalendarPricingService.getAdvancedPurchasePriceDetails(ct, $scope.selectedDate);
				var item = {
					CHARACS: [{
						event_id: '',
						start_date: Utilities.getDateByString($scope.selectedDate),
						start_time: vm._.$stateName === Enums.extraFlowRoutes.CALENDAR_PRICING_EVENT ? checkProp('pkg.startTime', pkg, 'getString') : ''
					}],
					cart_limit_override: pkg.packageDetails.cart_limit_override || '',
					customer_type: ct.id,
					cusTypeName: ct.name,
					// Use cusTypeRetail from getPackagePrice() if set (handles dynamic pricing with fee-inclusive/VAT),
					// otherwise use APP discountedRetailAmount if valid, otherwise fall back to retail_amount
					cusTypeRetail: angular.isDefined(ct.cusTypeRetail)
						? ct.cusTypeRetail
						: (checkProp('app.discountedRetailAmount', app)
							? app.discountedRetailAmount
							: ct.retail_amount),
					extra_movie: pkg.packageDetails.extra_movie || '',
					package_id: pkg.packageDetails.id,
					package_name: pkg.name,
					promo_code: pkg.packageDetails.promo_code || '',
					qty: 1
				};

				if (app.isAdvPricingValid) {
					merge(item, {
						discountedRetailAmount: app.discountedRetailAmount,
						discountedTaxAmount: app.discountedTaxAmount
					});
				}

				if (checkProp('pkg.packageDetails.event_id', pkg)) {
					item.CHARACS[0].event_id = pkg.packageDetails.event_id;
				} else if (checkProp('pkg.packageDetails.E.id', pkg)) {
					item.CHARACS[0].event_id = pkg.packageDetails.E.id;
				}

				if (pkg.packageDetails.CHARACS) {
					merge(item.CHARACS[0], {
						bypas_time: pkg.packageDetails.CHARACS.bypas_time,
						disable_date_sel: 'true',
						oneBarcodeKeyword: pkg.packageDetails.CHARACS.oneBarcodeKeyword,
						use_prev_sel_date: pkg.packageDetails.CHARACS.use_prev_sel_date
					});
				}
				return item;
			});

			itemsToBeAdded = itemsToBeAdded.filter(function(item) {
				return !!item;
			});

			// Save item information to Package.
			ExtraFlow.addReferenceToCartItems('calendar', itemsToBeAdded, ExtraFlow.CLIENT_ALTERNATE_VIEW);
			ExtraFlow.addReferenceToCartItems('CalendarPricingModule', itemsToBeAdded, ExtraFlow.CLIENT_ALTERNATE_NAME);

			// Adding localStorage our reference view.
			ExtraFlow.getAlternateFlowView('CalendarPricingModule');
			// This is to address allowing us to clear out the itemsToBeAdded array in Package service
			Package.itemsToBeAdded = itemsToBeAdded;
			Package.alternateModuleItemsToBeAdded = itemsToBeAdded;
		}

		/**
		 * Sets the package list based upon the last response
		 * @private
		 * @memberof vm
		 * @returns {undefined}
		 */
		function _setPackages() {
			// Update Package List
			$scope.packageList = vm._.$lastResponse.status === Enums.status.OK
				? CalendarPricingService.transformToPackageList(vm._.$keyword, vm._.$lastResponse, $scope.selectedDate)
				: [];
			//Package List impression trigger for analytics
			$rootScope.$broadcast('triggerImpressionsPackList', [$scope.packageList], 'Calendar Pricing ' +vm._.$keyword);
			vm._.mapTimedEventPackages();

			// Update Event Header
			vm._.localizeEventHeadline($scope.selectedDate);
		}
	}
})();

angular.module('calendar-pricing')
	.controller('CalendarPricingSavingsController', function(
		$log,
		$filter,
		$scope,
		$q,
		$uibModal,
		$state,
		$stateParams,
		$rootScope,
		AppData,
		CalendarPricingSavingsService,
		CalendarPricingTemplateConstant,
		CalendarPricingViews,
		CartService,
		ClientInfo,
		CustomActionService,
		DynamicCapacityPricingService,
		Enums,
		ExtraFlow,
		Package,
		RestrictedPackagesService,
		StandardFlowInitiatorService,
		Language,
		Modal,
		Utilities,
		UtilsValidation
	) {
		var localeExists = Language.localeExists,
			getLocale = Language.getLocale,
			getLocaleWithSuffixAndFallback = Language.getLocaleWithSuffixAndFallback,
			checkProp = Utilities.safelyCheckPropertyOnObject,
			getBoolean = Utilities.getBoolean,
			wrapObjectToArray = Utilities.wrapObjectToArray,
			isArray = Array.isArray;

		$scope.allowedDates = CalendarPricingSavingsService.allowedDates;
		$scope.additionalDataMap = CalendarPricingSavingsService.additionalDataMap;
		$scope.i18n = Language;
		$scope.packageKeyword = Utilities.getKeywordByUrl(AppData.GetApplicationConsolidated.TREE.MENUITEM, $stateParams.keyword);
		$scope.lockCalendar = CalendarPricingSavingsService.lockCalendar();

		//bindable object to base calendar currentMonthInfo
		$scope.currentMonthInfo = {
			currentMonth: new Date().getMonth() + 1,
			currentMonthObject: new Date()
		}

		$scope.showLegend = CalendarPricingSavingsService.showLegend;
		$scope.legendMode = CalendarPricingSavingsService.legendSettings.mode;
		$scope.timedEventPackagesArray = [];

		$scope._mapTimedEventPackages = _mapTimedEventPackages;
		$scope._createAvailabilityArr = _createAvailabilityArr;
		$scope.timeSelected = timeSelected;
		$scope._getStartDateCharac = _getStartDateCharac;
		$scope.commitSave = commitSave;
		$scope.confirmDateSelection = confirmDateSelection;
		$scope.exitModule = exitModule;
		$scope._updatePackages = _updatePackages;
		$scope._getPackages = _getPackages;

		var numMonthsFromTodaysMonth = 0;

		function initialize() {
			var firstPackageId = checkProp('packageMap.0.PS.P.0.id', CalendarPricingSavingsService.packageMap, Utilities.returnValue);
			// This module supports restricted packages
			if (RestrictedPackagesService.hasRegisteredPackagesForKeyword($stateParams.keyword)) {
				$scope.restrictedPackageLocales = RestrictedPackagesService.getLocaleData(RestrictedPackagesService.getModuleByPackage(firstPackageId));
			}

			$scope.selectedDate = CalendarPricingSavingsService.selectedDate;
			$scope.showAnyDayPackage = CalendarPricingSavingsService.anyDayPackages.exists();
			setLocales();
			determineYearRestrictionOverride();
			determineTemplate();

			// This is what controls whether or not the highest or lowest prices are shown on the calendar pricing cells
			$scope.calPriceSortIndicator = CalendarPricingSavingsService.calPriceSortIndicator;

			//show image on calendar-pricing.html if we are using calendar pricing module
			$scope.withImage = ($state.current.name === 'calendarPricingWithImage');
		}

		$scope.determineBaseCalendarTemplate = function() {
			var templateHtml = CalendarPricingTemplateConstant.calendarPricingTemplate;

			switch ($state.current.name) {
				case 'calendar':
					templateHtml = CalendarPricingTemplateConstant.calendarPricingTemplate;
					break;

				case 'savingsCalendar':
					if (ClientInfo.deviceType !== 'mobile') {
						templateHtml = CalendarPricingTemplateConstant.savingsTemplate;
					}
					break;
				}
			return templateHtml;
		};

		function determineTemplate() {
			var template = CalendarPricingViews.CALENDAR_PRICING;
			switch ($state.current.name) {
			case 'savingsCalendar':
				if (ClientInfo.deviceType !== 'mobile') {
					template = CalendarPricingViews.CALENDAR_SAVINGS;
				}
			}
			$scope.template = { url: template };
		}


		function setLocales() {
			if (!$state.current.name === 'savingsCalendar') {
				return;
			}

			$scope.anyDayInstructions = getLocale('SavingsCalendar', $stateParams.keyword + 'AnyDayInstructions');

			$scope.headline = getLocale('SavingsCalendar', $stateParams.keyword + 'Headline');

			// do we have a large image?
			var largeImageTarget = $stateParams.keyword + 'LargeImage';
			var smallImageTarget = $stateParams.keyword + 'SmallImage';

			if (localeExists('SavingsCalendar', largeImageTarget)) {
				$scope.calImage = $rootScope.getAssetUrl(getLocale('SavingsCalendar', $stateParams.keyword + 'LargeImage'));
				$scope.largeImage = true;
			} else if (localeExists('SavingsCalendar', smallImageTarget)) {
				$scope.calImage = $rootScope.getAssetUrl(getLocale('SavingsCalendar', $stateParams.keyword + 'SmallImage'));
				$scope.smallImage = true;
			}

			setBanners();

			// setup Legend locales
			if (CalendarPricingSavingsService.legendSettings.mode == 'custom') {
				// custom chevrons except sold out!
				$scope.chevronOneLabel = getLocale('CalendarPricing', $stateParams.keyword + 'chevronOneLabel');
				$scope.chevronTwoLabel = getLocale('CalendarPricing', $stateParams.keyword + 'chevronTwoLabel');
			}
		}

		function setBanners() {
			// Enables|disables the 1>2>3 banner
			var enableCalBanner = Utilities.childDefined(AppData, 'GetApplicationConsolidated.SETTINGS.enableCalBanner')
				? getBoolean(AppData.GetApplicationConsolidated.SETTINGS.enableCalBanner)
				: false;

			if (enableCalBanner) {
				// see if there is a banner image provided
				if (angular.isDefined(AppData.settings.calendarBanner)) {
					$scope.calendarBannerImage = $rootScope.getAssetUrl(AppData.settings.calendarBanner);
				}

				// is there a keyword specific banner defined?
				if (!Utilities.isEmpty(getLocale('CalendarPricing', $stateParams.keyword + 'DesktopBannerImage'))) {
					$scope.calendarBannerImage = $rootScope.getAssetUrl(getLocale('CalendarPricing', $stateParams.keyword + 'DesktopBannerImage'));
				}

				// check for mobile keyword specific banner
				if (!Utilities.isEmpty(getLocale('CalendarPricing', $stateParams.keyword + 'MobileBannerImage'))) {
					$scope.mobileBannerImage = $rootScope.getAssetUrl(getLocale('CalendarPricing', $stateParams.keyword + 'MobileBannerImage'));
				}
			}
		}

		$scope.showEventList = function() {
			Modal.displayModal(
				{
					label: 'Event List',
					 title: getLocale('Alert', 'eventListTitle'),
					 description: getLocale('CalendarPricing', 'eventListDates')
				}
			);
		};

		/**
		 * Gets the locale available
		 * @public
		 * @param {String} section Section of the locale
		 * @param {String} target Target of the locale
		 * @returns {String} locale
		 */
		$scope.getAnyDayLocale = function(section, target) {
			var prefix = $stateParams.keyword && $stateParams.keyword.replace(/\s/g, '') || '',
				suffix = AppData.settings.merchant_locale_suffix || '',
				extendedLocale,
				localeWithPrefix;

			if (suffix) {
				suffix = suffix[0] !== '_' ? '_' + suffix : suffix;
				extendedLocale = getLocaleWithPrefix(section, target, prefix, suffix);

				if (extendedLocale) {
					return extendedLocale;
				}

				if (localeExists(section, target + suffix)) {
					return getLocale(section, target + suffix);
				}
			}

			localeWithPrefix = getLocaleWithPrefix(section, target, prefix, '');
			if (localeWithPrefix) {
				return localeWithPrefix;
			}

			return getLocale(section, target);
		};

		/**
		 * Return locale based on prefix and suffix
		 * @protected
		 * @param {String} section section of the locale
		 * @param {String} target target of the locale
		 * @param {String} prefix prefix for the locale
		 * @param {String} suffix suffix for the locale
		 * @returns {String/undefined} locale/undefined
		 */
		function getLocaleWithPrefix(section, target, prefix, suffix) {
			if (prefix) {
				prefix = prefix[prefix.length - 1] !== '_' ? prefix + '_' : prefix;

				if (localeExists(section, prefix + target + suffix)) {
					return getLocale(section, prefix + target + suffix);
				}
			}
			return;
		}

		/**
		 * Checks for the existence of the application config "disable_year_restriction"
		 * If true, the one year calendar navigation restriction is lifted
		 */
		function determineYearRestrictionOverride() {
			$scope.overrideYearRestriction = false;
			if (getBoolean(AppData.settings.disable_year_restriction)) {
				$scope.overrideYearRestriction = true;
			}
		}


		/**
		 * Helper method to localize the event panel headline with a date selected from the calendar
		 * @param  String date The date string (full obj)
		 * @return String the locale with @@date replaced by the localized date string.
		 */
		function localizeEventHeadline(date) {
			//var locale = Language.localizeDate( date, AppData.settings.date_format );
			var locale = $filter('date')(date, 'fullDate');
			return Language.replaceAllMultiple(['@@date', '@@Date'], [locale, locale], Language.CalBasePricing.eventPanelHeadline);
		}

		// Unified the Any Day links, to the Savings Calendar Module and the Calendar Pricing Module work the same
		// Left the routing methods separate, in case they have any functionality added in the future.
		$scope.routeToAnyDay = function() {
			var anyDayLink = CalendarPricingSavingsService.anyDayPackages.hrefForRouting();
			if (anyDayLink) {
				if (angular.isDefined(Package.alternateModuleItemsToBeAdded)) {
					StandardFlowInitiatorService.setAlternateEntryToStandardFlow($state.current.name, $state.current.name, $stateParams, true);
				} else {
					StandardFlowInitiatorService.setStandardFlow(undefined, $state.current.name, $stateParams.keyword);
				}
				$scope.routeTo(anyDayLink);
			}
		};

		// Called from Savings Calendar Module - keyword based navigation
		$scope.goToAnyDayKeyword = function() {
			$scope.routeToAnyDay();
		};

		// called from Calendar Pricing Module - package ID based navigation OR keyword based navigation
		$scope.goToAnyDayPackage = function() {
			$scope.routeToAnyDay();
		};

		/**
		 * @param int direction Either 1 or -1, represents forward or previous month navigation
		 */
		$scope.handleMonthChanged = function(direction) {
			var datePromise = $q.defer();
			$scope.selectedDate = undefined;

			if (isCalendarPricingByDayState()) {
				updateMonthChangedForCalendarPricingByDay(direction);
				datePromise.resolve();
			} else if (direction === 1) {
				// We're going to resolve the datePromise regardless
				// of whether the service request was successful or not

				var requestMonth;

				if (CalendarPricingSavingsService.lastMonth === -1) {
					requestMonth = new Date().getMonth() + 2;
				} else {
					requestMonth = $scope.currentMonthInfo.currentMonth;
				}

				CalendarPricingSavingsService.requestDates(requestMonth).then(
					function(data) {
						datePromise.resolve();
					},
					function() {
						datePromise.resolve();
					});
			} else {
				// we could be going back, but still not have dates (Savings Calendar Flow)
				// need to check if we have dates first!
				CalendarPricingSavingsService.requestDates($scope.currentMonthInfo.currentMonth).then(
					function(data) {
						datePromise.resolve();
					},
					function() {
						datePromise.resolve();
					});
			}

			return datePromise.promise;
		};


		/**
		 * For CalendarPricingByDay recalibrate the allowedDates and selectedDate to trigger the change
		 * @param direction
		 */
		function updateMonthChangedForCalendarPricingByDay(direction) {
			var today = new Date();
			numMonthsFromTodaysMonth += direction;
			$scope.allowedDates = Utilities.getListOfDatesForMonth(numMonthsFromTodaysMonth);
			//we start with today if we are currently requesting data for the current month, otherwise if we are requesting for a date in a month ahead of todays month
			// we use the numMonthsFromTodaysMonth to track this
			var dt = new Date();
			if (numMonthsFromTodaysMonth > 0) {
				dt.setDate(1);
				dt.setMonth(today.getMonth() + numMonthsFromTodaysMonth);
			}

			$scope.selectedDate = dt;
		}

		/**
		 * Is the calendar pricing module by day
		 * @returns {boolean}
		 */
		function isCalendarPricingByDayState() {
			return ['calendarPricingByDay', 'calendarPricingTimesByDay', 'calendarPricingEvent'].indexOf($state.current.name) !== -1;
		}

		/**
		 * Update packages list when new date is selected
		 * @function
		 * @protected
		 * @param {Date} newDate - new selected date
		 * @return {undefined}
		 */
		function _updatePackages(newDate) {
			if (!(newDate instanceof Date)) {
				return;
			}

			// get packages associated with this new date
			CalendarPricingSavingsService.selectedDate = newDate;

			$scope.packages = $scope._getPackages(newDate);
			$scope._mapTimedEventPackages($scope.packages);
			$scope.eventPanelHeadline = localizeEventHeadline(newDate);

			$rootScope.$broadcast('triggerImpressionsSells', $scope.packages, 'Calendar');
		}

		/**
		 * Get packages for selected date, sort packages if needed - if Keyword node exists under package level with display order
		 * use it instead of default display order
		 * @public
		 * @protected
		 * @returns {Object[]} packages array
		 */
		function _getPackages(selectedDate) {
			var packages = CalendarPricingSavingsService.getPackages(selectedDate),
				currentKeyword = $stateParams.keyword || null;

			if (checkProp('packages.P', packages, isArray)) {
				packages = angular.copy(packages.P);
				packages.forEach(function(pkg) {
					var matchedKeyword,
						availableTickets = checkProp('pkg.available', pkg, [parseInt, 10]);

					pkg.showPackage = true;

					if (!checkProp('pkg.KEYWORDS.K', pkg, isArray)) {
						return;
					}

					matchedKeyword = currentKeyword && pkg.KEYWORDS.K.find(function(k) {
						return k.display_order && currentKeyword === k.keyword;
					});

					if (matchedKeyword) {
						pkg.display_order = matchedKeyword.display_order;
					}

					if (angular.isNumber(availableTickets) && availableTickets <= 0) {
						pkg.isSoldOut = true;
						pkg.showPackage = checkProp('AppData.settings.display_zero_capacity', AppData, getBoolean);
					}
				});

				return Utilities.orderByDisplayOrder(packages);
			}
			return [];
		}

		/**
		 * Map package to timed event format array so it can be used in the component
		 * @function
		 * @public
		 * @param {Object} packages - package data
		 * @return {undefined} Object timed event packages
		 */
		function _mapTimedEventPackages(packages) {
			if ($state.current.name !== 'calendarPricingEvent' || !isArray(packages)) {
				return;
			}

			$scope.timedEventPackagesArray = packages
				.map(function(pkg) {
					var soldOutThreshold = 0,
						remainingThreshold = 0;

					if (checkProp('pkg.CHARACS.capacity_threshold_amount', pkg)) {
						soldOutThreshold = parseInt(pkg.CHARACS.capacity_threshold_amount, 10);
					}

					if (checkProp('pkg.CHARACS.remaining_threshold_amount', pkg)) {
						remainingThreshold = parseInt(pkg.CHARACS.remaining_threshold_amount, 10);
					}

					return {
						availability: $scope._createAvailabilityArr(pkg, soldOutThreshold, remainingThreshold),
						date: $scope.selectedDate,
						desc: pkg.headline,
						image: $rootScope.getAssetUrl(pkg.shop_image_v4),
						name: pkg.name,
						showBuyNow: checkProp('pkg.E.date', pkg) && pkg.E.date === '2',
						packageId: pkg.id
					};
				});
		}

		/**
		 * Filter out the package based on selected event, then call selectPackage function
		 * @public
		 * @function
		 * @param {Object} event - selected event
		 * @param {Object} timeObj - selected time object
		 * @return {undefined}
		 */
		function timeSelected(event, timeObj) {
			var selectedPackage = $scope.packages.find(function(pkg) {
				return event.packageId === pkg.id;
			});

			if (!checkProp('selectedPackage.CHARACS', selectedPackage, UtilsValidation.isRealObject)) {
				return;
			}
			selectedPackage.CHARACS.start_time = timeObj.time;
			$scope.selectPackage(selectedPackage);
		}

		/**
		 * Create availibity array which contains specific time, soldout flag, and remaining value for timed event component
		 * @function
		 * @public
		 * @param {Object} pkg - package data object
		 * @returns {Array} availibity array
		 */
		function _createAvailabilityArr(pkg, soldOutThreshold, remainingThreshold) {
			var currentPkgCapacity = checkProp('pkg.E.capacity', pkg) ? parseInt(pkg.E.capacity, 10) : 0,
				soldOutFlag,
				remaining;

			if (!isArray(pkg.times)) {
				return [];
			}

			// -1 indicates that the ticket has no limit
			if (currentPkgCapacity !== -1) {
				if (!isNaN(soldOutThreshold)) {
					soldOutFlag = currentPkgCapacity <= soldOutThreshold;
				}

				if (!soldOutFlag && !isNaN(remainingThreshold) && currentPkgCapacity < remainingThreshold) {
					remaining = currentPkgCapacity - soldOutThreshold + getLocaleWithSuffixAndFallback('CalendarPricing', 'eventRemaining', '_' + AppData.merchantId);
				}
			}

			return pkg.times.map(function(time) {
				return {
					time: time,
					soldOut: soldOutFlag,
					remaining: remaining
				}
			});
		}

		$scope.showImage = function(data) {
			var scope = $rootScope.$new();
			scope.imageURL = data.imageURL;
			scope.header = data.imageTitle;

			$uibModal.open({
				templateUrl: '/scripts/modules/calendar-pricing/views/image.html',
				 controller: 'CalendarPricingImageController',
				 backdrop: 'static',
				 scope: scope,
				 windowClass: 'calendar-image'
			});
		};

		$scope.selectPackage = function(pkg) {
			if (!$scope.selectedDate) {
				// Date not selected. User is notified by displayed message.

				Modal.displayModal(
					{
						category: 'Date / Time',
						 action: 'Error',
						 label: 'Missing Date',
						 title: getLocale('Alert', 'generalErrorTitle'),
						 icon: 'icon-datetime green',
						 description: getLocale('DateTime', 'selectDateError')
					}
				);
				return;
			}

			if (checkForDateTimeConflicts(pkg)) {
				$scope.confirmDateSelection(pkg);
			}

			// Update the last accessed package list for analytics purposes
			Package.updateLastAccessedPackageList($scope.packageList);
		};

		$scope.next = function() {
			// proceed to Package List based on package IDs
			var packages = CalendarPricingSavingsService.getPackages($scope.selectedDate),
				selectedPackages = [],
				dynamicPricing;

			if (angular.isUndefined(packages)) {
				Modal.displayModal({
					title: getLocale('Alert', 'errorTitle'),
					description: getLocale('Alert', 'calendarSelectedDateError'),
					icon: 'icon-info red'
				});

				return;
			}

			if (angular.isDefined(packages)) {
				for (var i = 0; i < packages.P.length; i++) {
					selectedPackages.push(packages.P[i].id);
				}
			}

			Package.calendarPricingModuleDate = $scope.selectedDate;

			/*
				If this is a date-time package being used on the savingsCalendar
				then set disable_date_sel so that calendar will be locked on subsequent time selection
			 */
			for (var x = 0; x < packages.P.length; x++) {
				var package = packages.P[x];

				if (angular.isDefined(package.extra_movie) && package.extra_movie.indexOf('date_time') !== -1) {
					if (checkForDateTimeConflicts(package)) {
						$scope.commitSave(package);
					}
				}
			}

			$log.log('Calendar Package IDs: ' + selectedPackages.join(','));

			if (!CustomActionService.actionRegistered('calendarAddToCart')) {
				CustomActionService.registerCustomAction('calendarAddToCart', $scope.appendCalendarCharacs);
			}

			if (angular.isDefined(Package.alternateModuleItemsToBeAdded)) {
				StandardFlowInitiatorService.setAlternateEntryToStandardFlow($state.current.name, $state.current.name, $stateParams, true);
			} else {
				StandardFlowInitiatorService.setStandardFlow(undefined, $state.current.name, $stateParams.keyword);
			}

			dynamicPricing = packages.P.reduce(function reducePackagesWithDynamicPricing(acc, pkg) {
				wrapObjectToArray(pkg.CT, true).forEach(function addCustomerTypesWithDynamicPricing(ct) {
					var pkgId = pkg.id.toString();
					var pricing = DynamicCapacityPricingService.getDynamicPricingValues(ct, pkg.id);
					if (pricing) {
						if (!angular.isObject(acc[pkg.id])) {
							acc[pkgId] = {};
						}

						acc[pkgId][ct.id.toString()] = pricing;
					}
				});

				return acc;
			}, {});

			Utilities.goTo('packageList/packages/:packages', {
				dynamicPricing: dynamicPricing,
				packages: selectedPackages.join(',')
			});
		};

		/**
		 * Used in custom action, called from CartService on AddToCart
		 * Deregisters after use.
		 * Checks for an event id to exist, and appends the appropriate characs to the provided items.
		 * @public
		 * @param {Array<Object>} items Array of Customer Types that are about to be added to the cart. These will be modified and returned out of this function.
		 * @param {Object} packageDetails the Package about to be added to the cart
		 * @returns {Array<Object>} the items array, but potentially with modified characs
		 */
		$scope.appendCalendarCharacs = function(items, packageDetails) {
			var eventId;

			if (UtilsValidation.isRealObject(packageDetails)) {
				if (UtilsValidation.validString(packageDetails.event_id)) {
					eventId = packageDetails.event_id;
				} else if (Array.isArray(packageDetails.E)) {
					eventId = packageDetails.E[0].id;
				} else if (angular.isObject(packageDetails.E)) {
					eventId = packageDetails.E.id;
				}
			}

			if (eventId && ['alternateEntry', 'calendar', 'savingsCalendar', 'calendarPricingByDay', 'calendarPricingTimesByDay', 'calendarPricingWithImage', 'calendarPricingEvent'].indexOf(StandardFlowInitiatorService.currentStandardFlowType) !== -1) {
				items = Package.addCalendarPricingDateToPackages(items, eventId);
				Package.copyCharacsToEachItem(items);
			}

			CustomActionService.deregisterCustomAction('calendarAddToCart');
			return items;
		}

		function confirmDateSelection(pkg) {
			$scope.commitSave(pkg);

			var desc = $filter('date')($scope.selectedDate, 'fullDate');

			Modal.displayModal({
				category: 'Date / Time',
				action: 'Confirm',
				label: 'Add Date / Time Confirmation.',
				type: Enums.modalTypes.CONFIRMDATETIME,
				title: getLocale('Reservations', 'headingConfirm'),
				icon: 'icon-datetime green',
				description: '<span class="blue">' + desc + '</span>',
				buttonFlags: [Enums.buttonFlags.CANCEL, Enums.buttonFlags.CONFIRM],
				suppressedAction: function() {
					$scope.exitModule(pkg);
				},
				callback: function(detail) {
					if (detail == Enums.buttonFlags.CONFIRM) {
						$scope.exitModule(pkg);
					}
				}
			});
		}

		/**
		 * Handle the steps to move on to the rest of the flow.
		 * @public
		 * @param {Object} pkg The Package chosen
		 * @returns {undefined}
		 */
		function exitModule(pkg) {
			var useDynamicPricing = DynamicCapacityPricingService.isPackageDynamic(pkg.id);

			if (angular.isDefined(Package.alternateModuleItemsToBeAdded)) {
				StandardFlowInitiatorService.setAlternateEntryToStandardFlow($state.current.name, $state.current.name, $stateParams, true);
			} else {
				StandardFlowInitiatorService.setStandardFlow(undefined, $state.current.name, $stateParams.keyword);
			}

			Utilities.goTo(Enums.routes.DETAILS, {
				dynamicPricing: useDynamicPricing ? DynamicCapacityPricingService.getRouteParams(pkg.CT, pkg.id) : [],
				flowDetail: StandardFlowInitiatorService.currentStandardFlowDetail,
				flowType: StandardFlowInitiatorService.currentStandardFlowType,
				packageId: pkg.id
			});
		}

		function checkForDateTimeConflicts(pkg) {
			if (Utilities.getBoolean(AppData.settings.enable_conflict_resolution)
				&& !Utilities.getBoolean(AppData.settings.disable_conflict_resolution_for_dates)
				&& CartService.getQty() > 0) {
				var conflictResolutionBlockMode = Utilities.getBoolean(AppData.settings.conflictResolutionBlockPurchase);

				if (CartService.getDates().length && !CartService.getDate($scope.selectedDate)) {
					//conflict
					var modalOptions = {
						action: 'Conflict',
						category: 'Scheduling',
						label: 'Scheduling Date Conflict'
					};

					if (conflictResolutionBlockMode) {
						modalOptions.title = getLocale('Alert', 'conflictBlockDateTitle');
						modalOptions.description = getLocale('Alert', 'conflictBlockDate');
						modalOptions.buttonFlags = [Enums.buttonFlags.OK];
					} else {
						modalOptions.title = getLocale('Alert', 'conflictWarnDateTitle');
						modalOptions.description = getLocale('Alert', 'conflictWarnDate');
						modalOptions.buttonFlags = [Enums.buttonFlags.NO, Enums.buttonFlags.YES];
						modalOptions.callback = function(details) {
							if (details == Enums.buttonFlags.YES) {
								$scope.confirmDateSelection(pkg);
							}
						};
					}

					Modal.displayModal(modalOptions);

					return false;
				}
			}

			return true;
		}

		function commitSave(data) {
			var customerTypes = data.CT;
			var itemsToBeAdded = [];

			// first, build up a list of allowable rate_id(s)
			// for a given package, by inspecting the date specific package
			// information
			var thisDatePackageInfo = CalendarPricingSavingsService.getPackages($scope.selectedDate);

			if (angular.isUndefined(thisDatePackageInfo)) {
				throw new Error("No allowable rate IDs found");
			}

			// extract all matching package rate info
			var thisPackageRateInfo = thisDatePackageInfo.P.filter(function(e) {
				return (Number(e.id) === Number(data.id));
			})[0].CT;
			// Map it onto a list of rates to allow
			var allowedRates = thisPackageRateInfo.map(function(e) {
				return Number(e.id);
			});

			for (var i in customerTypes) {
				// don't allow rates that don't exist for this day
				if (allowedRates.indexOf(Number(customerTypes[i].id)) == -1) {
					continue;
				}

				var item =
					{
						qty: 1, // Set to one since this is going to change in packageDetails
						package_name: data.name,
						customer_type: customerTypes[i].id,
						package_id: data.id,
						cusTypeName: customerTypes[i].name,
						// Use cusTypeRetail if already set (for dynamic pricing with fee-inclusive/VAT),
						// otherwise use discountedRetailAmount if available (APP), otherwise fall back to retail_amount
						cusTypeRetail: checkProp('customerTypes[i].cusTypeRetail', customerTypes)
							? customerTypes[i].cusTypeRetail
						: checkProp('customerTypes[i].discountedRetailAmount', customerTypes) ? customerTypes[i].discountedRetailAmount : customerTypes[i].retail_amount,
						extra_movie: data.extra_movie || '',
						promo_code: data.promo_code || '',
						cart_limit_override: data.cart_limit_override || '',
						discountedRetailAmount: customerTypes[i].discountedRetailAmount,
						discountedTaxAmount: customerTypes[i].discountedTaxAmount
					};

				for (var k = 0; k < item.qty; k++) {
					item.CHARACS = item.CHARACS || [];
					item.CHARACS[k] = item.CHARACS[k] || {};

					item.CHARACS[k].event_id = '';
					if (angular.isDefined(data.event_id)) {
						item.CHARACS[k].event_id = data.event_id;
					} else if (angular.isDefined(data.E) && angular.isDefined(data.E.id)) {
						item.CHARACS[k].event_id = data.E.id;
					}

					item.CHARACS[k].start_date = Utilities.getDateByString($scope.selectedDate);
					item.CHARACS[k].start_time = $scope._getStartDateCharac(data);

					if (data.CHARACS) {
						item.CHARACS[k].bypas_time = data.CHARACS.bypas_time;
						item.CHARACS[k].use_prev_sel_date = data.CHARACS.use_prev_sel_date;
						item.CHARACS[k].disable_date_sel = 'true';
					}
				}

				itemsToBeAdded.push(item);
			}

			// Save item information to Package.
			ExtraFlow.addReferenceToCartItems('calendar', itemsToBeAdded, ExtraFlow.CLIENT_ALTERNATE_VIEW);
			ExtraFlow.addReferenceToCartItems('CalendarPricingModule', itemsToBeAdded, ExtraFlow.CLIENT_ALTERNATE_NAME);

			// Adding localStorage our reference view.
			// TODO: getAlternateFlowView should "get the alternate flow view". Why is it being used for setting a localStorage value?
			ExtraFlow.getAlternateFlowView('CalendarPricingModule');

			//TODO once we have a more abstracted mechanism to allow us to attach properties to the future itemsToBeAdded object in Package service,
			//TODO we can rework this temporary solution so we don't have to manually set the itemsToBeAdded object to something else in PackageDetails controller
			// this is to address allowing us to clear out the itemsToBeAdded array in Package service
			Package.alternateModuleItemsToBeAdded = itemsToBeAdded;
			Package.alternateModuleItemsToBeAdded.allowedRates = allowedRates;
		}

		/**
		 * Get start date charac for package
		 * @function
		 * @public
		 * @param {Object} pkg - selected package
		 * @return {string} if calendarPricingEvent state, then return start_time selected from component, if not, then return empty string
		 */
		function _getStartDateCharac(pkg) {
			if ($state.current.name === 'calendarPricingEvent') {
				if (checkProp('pkg.CHARACS.start_time', pkg, UtilsValidation.validString)) {
					return pkg.CHARACS.start_time;
				}
			}
			return '';
		}

		$scope.$watch('selectedDate', function(newValue, oldValue) {
			if (angular.isUndefined(newValue)) {
				return;
			}

			if (isCalendarPricingByDayState() && !CalendarPricingSavingsService.hasPackageDataForDate(newValue)) {
				CalendarPricingSavingsService.requestDates(undefined, Utilities.getDateByString(newValue)).then(function() {
					$scope._updatePackages(newValue);
				});
			} else {
				$scope._updatePackages(newValue);
			}
		});

		initialize();
	});

angular.module('app')
	.controller('CalendarPricingImageController',
		function (
			$uibModalInstance,
			$scope,
			$rootScope,
			AppData,
			Language) {
			$scope.i18n = Language;

			/**
			 * cancel - discard the modal from view
			 * @public
			 */
			$scope.cancel = function() {
				$rootScope.modalOpen = false;
				$uibModalInstance.dismiss('cancel');
			};
		});

(function() {
	'use strict';

	angular
		.module('calendar-pricing')
		.controller('WizardCalendarPricingAcController', WizardCalendarPricingController);

	/**
	 * The Wizard Calendar Pricing Controller Constructor
	 * @controller
	 * @constructor
	 * @param {Service} $filter - The filter service
	 * @param {Scope} $rootScope - The root scope for the application
	 * @param {Scope} $scope - The scope for the controller
	 * @param {Transition} $transition$ - The current Transition instance
	 * @param {Service} AccessoCalendarDataService - The Accesso Calendar Data Service
	 * @param {Service} AccessoCalendarEnums - The Accesso Calendar Enums Service
	 * @param {Service} AccessoCalendarService - The Accesso Calendar Service
	 * @param {Service} AppData - The App Data Service
	 * @param {Service} CalendarPricingService - The Calendar Pricing AC Service
	 * @param {Service} LegacyCart - The Cart Service
	 * @param {Service} ClientInfo - The Client Info Service
	 * @param {Service} CustomActionService - The Custom Action Service
	 * @param {Service} DynamicCapacityPricingService - The Dynamic Capacity Pricing Service
	 * @param {Service} Enums - The Enums Service
	 * @param {Service} ExtraFlow - The Extra Flow Service
	 * @param {Service} FeeService - The Fee Service
	 * @param {Service} JSONValidator - The JSON Validator Service
	 * @param {Service} Language - The Language Service
	 * @param {Object} LanguageEnums - The Language Enums Object
	 * @param {Service} Modal - The Modal Service
	 * @param {Service} Package - The Package Service
	 * @param {Service} ParkHours - The Park Hours Service
	 * @param {Service} StandardFlowInitiatorService - The Standard Flow Initiator Service
	 * @param {Service} Utilities - The Utilities Service
	 * @param {Service} UtilsValidation - The Utils Validation Service
	 * @param {Object[]} initialCalendarData - The first normalized data to use with the accesso calendar component
	 * @param {Object} initialRawData - The first raw data that comes back
	 * @param {Date} initialStartDate - The date the calendar will start on
	 * @param {Boolean} isRequestingTimeInfo - the is requesting time info resolve
	 * @returns {Controller} - The Controller Instance
	 * @ngInject
	 */
	function WizardCalendarPricingController(
		$filter,
		$rootScope,
		$scope,
		$transition$,
		AccessoCalendarDataService,
		AccessoCalendarEnums,
		AccessoCalendarService,
		AppData,
		CalendarPricingService,
		LegacyCart,
		ClientInfo,
		CustomActionService,
		DynamicCapacityPricingService,
		Enums,
		ExtraFlow,
		FeeService,
		JSONValidator,
		Language,
		LanguageEnums,
		Modal,
		Package,
		ParkHours,
		StandardFlowInitiatorService,
		Utilities,
		UtilsValidation,
		initialCalendarData,
		initialRawData,
		initialStartDate,
		isRequestingTimeInfo
	) {
		var vm = this;

		var checkProp = Utilities.checkProp,
			createDate = AccessoCalendarService.createDate,
			first = Utilities.first,
			forceInt = Utilities.forceInt,
			merge = Object.assign || angular.merge,
			toArray = Utilities.toArray,
			validArray = UtilsValidation.validArray,
			validObject = UtilsValidation.validObject;

		merge(vm, {
			$onInit: $onInit,
			_: {
				conflictResolutionBlockMode: checkProp('AppData.settings.conflictResolutionBlockPurchase', AppData, 'getBoolean'),
				disableConflictResolutionForDates: checkProp('AppData.settings.disable_conflict_resolution_for_dates', AppData, 'getBoolean'),
				enableCalBanner: checkProp('AppData.settings.enableCalBanner', AppData, 'getBoolean'),
				enableConflictResolution: checkProp('AppData.settings.enable_conflict_resolution', AppData, 'getBoolean'),
				enableParkHours: checkProp('AppData.settings.enableParkHours', AppData, 'getBoolean'),
				lastResponse: initialRawData,
				settings: {},
				stateName: $transition$.to().name,
				validParkHours: [],
				assignBanners: _assignBanners,
				assignLocales: _assignLocales,
				checkDynamicPricing: _checkDynamicPricing,
				checkForDateTimeConflicts: _checkForDateTimeConflicts,
				confirmDateSelection: _confirmDateSelection,
				continueToSelectedPackage: _continueToSelectedPackage,
				getSettings: _getSettings,
				hasParkHoursForSelectedDate: _hasParkHoursForSelectedDate,
				routeToAnyDay: _routeToAnyDay,
				save: _save,
				updatePackages: _updatePackages
			}
		});

		merge($scope, {
			gatePrice: gatePrice,
			getLocale: getLocale,
			getPackageImageUrl: getPackageImageUrl,
			goToAnyDayPackage: goToAnyDayPackage,
			hasGatePricing: hasGatePricing,
			hasPriceLabelOverride: hasPriceLabelOverride,
			onCalendarInit: onCalendarInit,
			onCalendarMove: onCalendarMove,
			onCalendarSelectDate: onCalendarSelectDate,
			previousStep: angular.bind(null, CustomActionService.executeCustomAction, 'routeToPreviousStep'),
			samePrice: samePrice,
			selectAnyDayPackage: selectAnyDayPackage,
			selectPackage: selectPackage,
			showEventList: showEventList,
			showPackageDesc: showPackageDesc
		});

		/*************
		 * LIFECYCLE *
		 *************/

		/**
		 * The lifecycle hook for initialization of the controller
		 * @lifecycle
		 * @returns {undefiend}
		 */
		function $onInit() {
			var anyDayPackages = CustomActionService.executeCustomAction('getAnyDayPackages') || [];
			anyDayPackages.forEach(function(pkg) {
				pkg.price = CalendarPricingService.getPackagePrice(pkg, initialStartDate, pkg);
			});

			merge(vm._, { settings: vm._.getSettings() });

			if (!validObject(vm._.settings)) {
				// display error modal if settings are undefined
				Modal.displayModal({
					description: Language.replaceAll('@@errorCode', '300', $scope.getLocale('ErrorCodes', '300')),
					label: 'Error',
					title: $scope.getLocale('ErrorCodes', '300')
				});

				return;
			}

			merge($scope, {
				anyDayPackages: anyDayPackages,
				anydayBackgroundColor: checkProp('vm._.settings.anyDayKeyword_background_color', vm, 'getString') || '',
				anydayTextColor: checkProp('vm._.settings.anyDayKeyword_text_color', vm, 'getString') || '',
				banner: {},
				calendarData: initialCalendarData,
				calendarLoading: false,
				carousel: {},
				disableLowestPrice: true,
				disableYearRestriction: checkProp('AppData.settings.disable_year_restriction', AppData, 'getBoolean'),
				displayType: ClientInfo.deviceType === Enums.deviceType.MOBILE ? AccessoCalendarEnums.displayType.week : AccessoCalendarEnums.displayType.month,
				enableDesktopCalBanner: false,
				hidePrice: true,
				isDynamic: false,
				isMobile: ClientInfo.deviceType === Enums.deviceType.MOBILE,
				keyword: $transition$.params().keyword,
				locale: {},
				onlinePriceHeader: Language.getLocale('FormLabels', 'onlinePriceHeading'),
				packageList: [],
				selectedDate: validArray(initialCalendarData) ? createDate(first(initialCalendarData).date) : null,
				showAnyDayPackageList: validArray(anyDayPackages),
				showCarousel: checkProp('vm._.settings.carousel', vm, 'validObject'),
				showDatedPackageList: false,
				showFeeNotice: FeeService.isPageActive(FeeService.enums.WIZARD_CALENDAR),
				showInfoHours: false,
				showInfoHours2: false,
				showPreviousStep: CustomActionService.executeCustomAction('enablePreviousButton')
			});

			$scope.keywordDisplayName = Utilities.getKeywordByUrl(AppData.GetApplicationConsolidated.TREE.MENUITEM, $scope.keyword);

			if (validArray($scope.calendarData) && !AccessoCalendarDataService.isDateInData($scope.selectedDate, $scope.calendarData)) {
				$scope.selectedDate = Utilities.first($scope.calendarData).date;
			}

			if ($scope.showAnyDayPackageList) {
				$rootScope.$broadcast('triggerImpressionsSells', vm._.anyDayPackages, 'Wizard Calendar');
			}

			vm._.updatePackages();

			vm._.assignLocales();

			vm._.assignBanners();

			if (vm._.enableParkHours) {
				ParkHours.getParkHours().then(function parkHoursSuccess() {
					ParkHours.loadFeed(0, false, false);

					vm._.validParkHours = angular.copy(ParkHours.allowedDates);

					$scope.showInfoHours = vm._.hasParkHoursForSelectedDate();
					$scope.showInfoHours2 = ParkHours.hasMultipleFeeds;
				});
			}

			if ($scope.showCarousel && !$scope.isMobile) {
				merge($scope.carousel, {
					active: 0,
					slideImagePath: $rootScope.getAssetUrl(vm._.settings.carousel.slideImageFolder),
					sliderInterval: forceInt(vm._.settings.carousel.slideInterval),
					slides: vm._.settings.carousel.slides
				});
			}

		}

		/*********
		 * SCOPE *
		 *********/

		/**
		 * Gets the gate price for a given Customer Type
		 * @memberof $scope
		 * @param {Object} ct - The customer type
		 * @returns {String} The gate price for the customer type
		 */
		function gatePrice(ct) {
			return Utilities.getString(ct.gate_price);
		}

		/**
		 * Grabs a locale from the language service
		 * @memberof $scope
		 * @param {String} section - The Locale section
		 * @param {String} target - The Locale target
		 * @returns {String} - The desired locale
		 */
		function getLocale(section, target) {
			return Language.getLocaleWithSuffixAndFallback(section, target, LanguageEnums.MERCHANT_ID);
		}

		/**
		 * Gets the appropriate image URL for a package based on whether it's an any day package or not
		 * @memberof $scope
		 * @param {Object} pkg - The package details
		 * @param {Boolean} isAnyDay - Whether this is an any day package
		 * @returns {String} - The image URL to use
		 */
		function getPackageImageUrl(pkg, isAnyDay) {
			if (isAnyDay) {
				// For any day packages, check if there's a custom any day image configured
				var customAnyDayImage = checkProp('vm._.settings.anyDayKeyword_image', vm, 'getString');
				return $rootScope.getAssetUrl(customAnyDayImage || pkg.shop_image_v4);
			}

			// For regular packages, use the standard image
			return $rootScope.getAssetUrl(pkg.shop_image_v4);
		}

		/**
		 * Called from Calendar Pricing Module - package ID based navigation OR keyword based navigation
		 * @memberof $scope
		 * @returns {undefined}
		 */
		function goToAnyDayPackage() {
			vm._.routeToAnyDay();
		}

		/**
		 * Checks if a package has gate pricing
		 * @memberof $scope
		 * @param {Object} pkg - The package details
		 * @returns {Boolean} true if it does have gate pricing, false otherwise
		 */
		function hasGatePricing(pkg) {
			var i = 0;
			if (validArray(pkg.CT)) {
				for(; i < pkg.CT.length; i++){
					// If any package has a gate price, return true
					if (pkg.CT[i].gate_price) {
						return true;
					}
				}
			}

			return false;
		}

		/**
		 * Checks if a package has a price_label_override charac configured
		 * @memberof $scope
		 * @param {Object} pkg - The package details
		 * @returns {Boolean} true if a price_label_override is configured, false otherwise
		 */
		function hasPriceLabelOverride(pkg) {
			return checkProp('pkg.CHARACS.price_label_override', pkg, 'validString');
		}

		/**
		 * Calender Hook for when the calendar is initialized
		 * @memberof $scope
		 * @returns {undefined}
		 */
		function onCalendarInit() {
			// Ensure we set the proper flags for dynamic pricing, if enabled
			vm._.checkDynamicPricing();

			// Hide the spinner
			$rootScope.hideSpinner();
		}

		/**
		 * Calendar Hook when the calendar navigates to a new range of dates
		 * @memberof $scope
		 * @param {String} displayType - The display type the calendar will use with the new range
		 * @param {Date} startDate - The starting date of the range
		 * @param {Date} endDate - The ending date of the range
		 * @returns {undefiend}
		 */
		function onCalendarMove(displayType, startDate, endDate) {
			$scope.calendarLoading = true;
			$scope.selectedDate = null;

			$rootScope.showSpinner($scope.getLocale('ApplicationLabels', 'gettingEventDates'));

			CalendarPricingService
				.requestDates($scope.keyword, startDate, endDate, isRequestingTimeInfo)
				.then(function onComplete(rawData) {
					vm._.lastResponse = rawData;
					$scope.calendarData = AccessoCalendarDataService.normalizeDataFromResponse(rawData, CalendarPricingService.getServiceRequest(isRequestingTimeInfo));
					$scope.calendarLoading = false;
					$rootScope.hideSpinner();
				})
				.catch(function onFailure() {
					$scope.calendarLoading = false;
					$rootScope.hideSpinner();
				});
		}

		/**
		 * Calendar Hook for when a new date is selected
		 * @memberof $scope
		 * @param {Date} date - The new selected date
		 * @returns {undefined}
		 */
		function onCalendarSelectDate(date) {
			// If the newly selected date is the same as the old date
			if (AccessoCalendarService.isDateEqual(date, $scope.selectedDate)) {
				// Do Nothing
				return;
			}

			// Set new date as selected date
			$scope.selectedDate = date;

			// Update Package List
			vm._.updatePackages();

			vm._.checkDynamicPricing();

			CustomActionService.executeCustomAction('populateCustomerTypeData', $scope.packageList);

			$scope.showInfoHours = vm._.hasParkHoursForSelectedDate();

			$rootScope.$broadcast('triggerImpressionsSells', $scope.packageList, 'Wizard Calendar');
		}

		/**
		 * Checks if the gate price and retail price is the same for a given customer type
		 * @memberof $scope
		 * @param {Object} ct - The customer type
		 * @returns {Boolean} true if they are the same, false otherwise
		 */
		function samePrice(ct) {
			return Math.abs(parseFloat($scope.gatePrice(ct)) - parseFloat(ct.cusTypeRetail)) < 0.01;
		}

		/**
		 * Selects and routes to the any day package
		 * @memberof $scope
		 * @param {Object} pkg - The any day package details
		 * @returns {undefined}
		 */
		function selectAnyDayPackage(pkg) {
			var customActionResult,
				dynamicPricing = $scope.isDynamic ? DynamicCapacityPricingService.getRouteParams(pkg.CT, pkg.id) : [];
			// Update the last accessed package list for analytics purposes
			Package.updateLastAccessedPackageList(vm._.anyDayPackages);

			delete Package.calendarPricingModuleDate;

			CustomActionService.executeCustomAction('updateContextData', {
				dynamicPricing: dynamicPricing,
				selectedDate: undefined
			});

			CustomActionService.executeCustomAction('updateStageSelections', {
				alternateModuleItemsToBeAdded: [],
				dynamicPricing: dynamicPricing,
				selectedDate: undefined,
				selectedPackages: [{ package_id: pkg.id }]
			});

			customActionResult = CustomActionService.executeCustomAction('routeToNextStep', null, false);

			if (!customActionResult) {
				Utilities.goTo(Enums.routes.DETAILS, {
					dynamicPricing: dynamicPricing,
					flowDetail: StandardFlowInitiatorService.currentStandardFlowDetail,
					flowType: StandardFlowInitiatorService.currentStandardFlowType,
					packageId: pkg.id,
				});
			}
		}

		/**
		 * Selects a typical package
		 * @memberof $scope
		 * @param {Object} pkg - The package details
		 * @returns {undefined}
		 */
		function selectPackage(pkg) {
			if (!$scope.selectedDate) {
				// Date not selected. User is notified by displayed message.

				Modal.displayModal({
					action: 'Error',
					category: 'Date / Time',
					description: $scope.getLocale('DateTime', 'selectDateError'),
					icon: 'icon-datetime green',
					label: 'Missing Date',
					title: $scope.getLocale('Alert', 'generalErrorTitle'),
				});
				return;
			}

			if (vm._.checkForDateTimeConflicts(pkg)) {
				vm._.confirmDateSelection(pkg);
			}

			// Update the last accessed package list for analytics purposes
			Package.updateLastAccessedPackageList($scope.packageList);
		}

		/**
		 * Triggers a modal for the event list
		 * @memberof $scope
		 * @returns {undefined}
		 */
		function showEventList() {
			Modal.displayModal({
				description: $scope.getLocale('CalendarPricing', 'eventListDates'),
				label: 'Event List',
				title: $scope.getLocale('Alert', 'eventListTitle')
			});
		}

		/**
		 * Triggers a modal to display package description
		 * @memberof $scope
		 * @param {Object} pkg - The package object
		 * @returns {undefined}
		 */
		function showPackageDesc(pkg) {
			Modal.displayModal({
				action: 'View',
				category: 'PackageDescriptionModal',
				description: Package.replaceDatesInText(pkg, pkg.desc),
				hideAllButtons: false,
				image: $rootScope.getAssetUrl(pkg.shop_image_v4),
				label: 'PackageDescriptionModal',
				showCloseButton: true,
				title: pkg.name
			});
		}

		/***********
		 * PRIVATE *
		 ***********/

		/**
		 * Assigns the banner locales to be accessible from the scope
		 * @protected
		 * @memberof vm
		 * @returns {undefined}
		 */
		function _assignBanners() {
			var calendarBanner;

			if (!vm._.enableCalBanner) {
				return;
			}

			if ($scope.isMobile) {
				calendarBanner = $scope.getLocale('CalendarPricing', $scope.keyword + 'MobileBannerImage');

				if (calendarBanner) {
					$scope.banner.mobileBannerImage = $rootScope.getAssetUrl(calendarBanner);
				}
			} else {
				$scope.enableDesktopCalBanner = true;
				calendarBanner = $scope.getLocale('CalendarPricing', $scope.keyword + 'DesktopBannerImage') || CalendarPricingService.getCalendarBanner();

				if (calendarBanner) {
					$scope.banner.calendarBannerImage = $rootScope.getAssetUrl(calendarBanner);
				}
			}
		}

		/**
		 * Assigns the locales to the locale object
		 * @protected
		 * @memberof vm
		 * @returns {undefined}
		 */
		function _assignLocales() {
			if (CalendarPricingService.getLegendSetting('mode') === 'custom') {
				merge($scope.locale, {
					chevronOneLabel: $scope.getLocale('CalendarPricing', $scope.keyword + 'chevronOneLabel'),
					chevronTwoLabel: $scope.getLocale('CalendarPricing', $scope.keyword + 'chevronTwoLabel')
				});
			}
		}

		/**
		 * Checks if current selection has dynamic pricing and sets scope
		 * @protected
		 * @memberof vm
		 * @returns {undefined}
		 */
		function _checkDynamicPricing() {
			// If we have already determined there are dynamic pricing items, skip
			if ($scope.isDynamic) {
				return;
			}

			// Filter through and see if there is dynamic pricing set
			$scope.isDynamic = DynamicCapacityPricingService.isPackageSetDynamic($scope.packageList);

			// If we found a package with dynamic pricing
			if ($scope.isDynamic) {
				// Change header to use a dynamic pricing
				$scope.onlinePriceHeader = DynamicCapacityPricingService.getFromPriceLocale();
			}
		}

		/**
		 * Checks to see if there are any conflicts with the selection
		 * @protected
		 * @memberof vm
		 * @param {Object} pkg - The wizard package object
		 * @returns {Boolean} true if the checks pass, false otherwise
		 */
		function _checkForDateTimeConflicts(pkg) {
			// check selected date against cart dates. Different dates are conflicts
			// different packages or same packages doesn't matter here. Different dates are conflicts
			var conflictFound = false,
				matchFound = false,
				modalOptions;

			if (vm._.disableConflictResolutionForDates || LegacyCart.cartItems.length === 0 || !vm._.enableConflictResolution) {
				return true;
			}

			LegacyCart.cartItems.some(function iterateCartItems(item) {
				var startDate;

				if (checkProp('item.CHARACS.0.start_date', item, 'isDateString')) {
					startDate = Utilities.dateStringToObject(item.CHARACS[0].start_date);

					if (AccessoCalendarService.isDateEqual($scope.selectedDate, startDate)) {
						matchFound = true;

						return true;
					}

					conflictFound = true;
				}
				return false
			});

			if (conflictFound && !matchFound) {
				// Conflict
				modalOptions = {
					action: 'Conflict',
					category: 'Scheduling',
					label: 'Scheduling Date Conflict'
				};

				if (vm._.conflictResolutionBlockMode) {
					merge(modalOptions, {
						buttonFlags: [ Enums.buttonFlags.OK ],
						description: $scope.getLocale('Alert', 'conflictBlockDate'),
						title: $scope. getLocale('Alert', 'conflictBlockDateTitle')
					});
				} else {
					merge(modalOptions, {
						buttonFlags: [ Enums.buttonFlags.NO, Enums.buttonFlags.YES ],
						callback: function modalCallback(details) {
							if (details === Enums.buttonFlags.YES) {
								vm._.confirmDateSelection(pkg);
							}
						},
						description: $scope.getLocale('Alert', 'conflictBlockDate'),
						title: $scope. getLocale('Alert', 'conflictBlockDateTitle')
					});
				}

				Modal.displayModal(modalOptions);

				return false;
			}

			return true;
		}

		/**
		 * Confirms, if enabled, the selection before proceeding
		 * @protected
		 * @memberof vm
		 * @param {Object} pkg - The wizard package object
		 * @returns {undefined}
		 */
		function _confirmDateSelection(pkg) {
			var desc = $filter('date')($scope.selectedDate, 'fullDate');

			vm._.save(pkg);

			if (Utilities.getBoolean(vm._.settings.hideDateConfirmation)) {
				vm._.continueToSelectedPackage(pkg);
			} else {
				Modal.displayModal({
					action: 'Confirm',
					buttonFlags: [Enums.buttonFlags.CANCEL, Enums.buttonFlags.CONFIRM],
					category: 'Date / Time',
					description: '<span class="blue">' + desc + '</span>',
					icon: 'icon-datetime green',
					label: 'Add Date / Time Confirmation.',
					title: $scope.getLocale('Reservations', 'headingConfirm'),
					type: Enums.modalTypes.CONFIRMDATETIME,
					suppressedAction: angular.bind(null, vm._.continueToSelectedPackage, pkg),
					callback: function modalCallback(detail) {
						if (detail === Enums.buttonFlags.CONFIRM) {
							vm._.continueToSelectedPackage(pkg);
						}
					}
				});
			}
		}

		/**
		 * Routes to the selected package
		 * @protected
		 * @memberof vm
		 * @param {Object} pkg - The package details
		 * @returns {undefined}
		 */
		function _continueToSelectedPackage(pkg) {
			// Update the last accessed package list for analytics purposes
			Package.updateLastAccessedPackageList($scope.packageList);

			var customActionResult,
				dynamicPricing = $scope.isDynamic ? DynamicCapacityPricingService.getRouteParams(pkg.CT, pkg.id) : [];

			Package.calendarPricingModuleDate = $scope.selectedDate;
			CustomActionService.executeCustomAction('updateContextData', {
				dynamicPricing: dynamicPricing,
				selectedDate: angular.copy(Package.calendarPricingModuleDate)
			});

			CustomActionService.executeCustomAction('updateStageSelections', {
				dynamicPricing: dynamicPricing,
				selectedDate: angular.copy(Package.calendarPricingModuleDate),
				selectedPackages: [{package_id: pkg.id}],
				alternateModuleItemsToBeAdded: Package.alternateModuleItemsToBeAdded
			});

			customActionResult = CustomActionService.executeCustomAction('routeToNextStep', null, false);

			// if no customAction is defined, do the default behavior
			if (!customActionResult) {
				StandardFlowInitiatorService.setStandardFlow(undefined, vm._.stateName, $scope.keyword);

				Utilities.goTo(Enums.routes.DETAILS, {
					dynamicPricing: dynamicPricing,
					flowDetail: StandardFlowInitiatorService.currentStandardFlowDetail,
					flowType: StandardFlowInitiatorService.currentStandardFlowType,
					packageId: pkg.id
				});
			}
		}

		/**
		 * Gets wizard calendar settings if available
		 * @protected
		 * @memberof vm
		 * @returns {Object} The wizard settings
		 */
		function _getSettings() {
			var settings = CustomActionService.executeCustomAction('getCurrentStepSettings');

			if (JSONValidator.validate('wizard_calendar_pricing', AppData.settings.wizard_calendar_pricing)) {
				settings = JSON.parse(AppData.settings.wizard_calendar_pricing);
			}

			if (validObject(settings)) {
				return angular.copy(settings);
			}

			return {};
		}

		/**
		 * Checks if the selected date has park hours
		 * @protected
		 * @memberof vm
		 * @returns {Boolean} true if the date has park hours, false otherwise
		 */
		function _hasParkHoursForSelectedDate() {
			return vm._.validParkHours.some(function iterateParkHours(dateAsTime) {
				return AccessoCalendarService.isDateEqual($scope.selectedDate, createDate(dateAsTime));
			});
		}

		/**
		 * Routes to any day packages
		 * @protected
		 * @member vm
		 * @returns {undefined}
		 */
		function _routeToAnyDay() {
			var anyDayLink = vm._.anyDayPackages.hrefForRouting();

			if (anyDayLink) {
				StandardFlowInitiatorService.setStandardFlow(undefined, vm._.stateName, $scope.keyword);

				$rootScope.routeTo(anyDayLink);
			}
		}

		/**
		 * Saves the selection to itemsToBeAdded
		 * @protected
		 * @memberof vm
		 * @param {Object} pkg - The selected wizard package object
		 * @returns {undefined}
		 */
		function _save(pkg) {
			var cts,
				itemsToBeAdded,

			pkg = pkg.packageDetails || pkg;
			cts = toArray(pkg.CT);

			itemsToBeAdded = cts.map(function iterateCts(ct) {
				var item = {
					CHARACS: [{
						event_id: '',
						start_date: Utilities.getDateByString($scope.selectedDate),
						start_time: '',
					}],
					cart_limit_override: pkg.cart_limit_override || '',
					customer_type: ct.id,
					cusTypeName: ct.name,
					// Use cusTypeRetail if already set (for dynamic pricing with fee-inclusive/VAT),
					// otherwise use APP discountedRetailAmount if valid, otherwise fall back to retail_amount
					cusTypeRetail: checkProp('ct.cusTypeRetail', ct)
						? ct.cusTypeRetail
						: (ct.isAdvPricingValid && checkProp('ct.discountedRetailAmount', ct)
							? ct.discountedRetailAmount
							: ct.retail_amount),
					extra_movie: pkg.extra_movie || '',
					package_id: pkg.id,
					package_name: pkg.name,
					promo_code: pkg.promo_code || '',
					qty: 1
				};

				if (ct.isAdvPricingValid) {
					merge(item, {
						discountedRetailAmount: ct.discountedRetailAmount,
						discountedTaxAmount: ct.discountedTaxAmount
					});
				}

				if (checkProp('pkg.event_id', pkg)) {
					item.CHARACS[0].event_id = pkg.event_id;
				} else if(checkProp('pkg.E.id', pkg)) {
					item.CHARACS[0].event_id = pkg.E.id;
				}

				if (pkg.CHARACS) {
					merge(item.CHARACS[0], {
						bypas_time: pkg.CHARACS.bypas_time,
						disable_date_sel: 'true',
						use_prev_sel_date: pkg.CHARACS.use_prev_sel_date
					});
				}

				return item;
			});

			itemsToBeAdded = itemsToBeAdded.filter(function (item) { return !!item });

			// Save item information to Package.
			ExtraFlow.addReferenceToCartItems('wizardCalendar', itemsToBeAdded, ExtraFlow.CLIENT_ALTERNATE_VIEW);
			ExtraFlow.addReferenceToCartItems('WizardCalendarPricingModule', itemsToBeAdded, ExtraFlow.CLIENT_ALTERNATE_NAME);

			// Adding localStorage our reference view.
			// @todo getAlternateFlowView should "get the alternate flow view". Why is it being used for setting a localStorage value?
			ExtraFlow.getAlternateFlowView('WizardCalendarPricingModule');

			// @todo once we have a more abstracted mechanism to allow us to attach properties to the future itemsToBeAdded object in Package service,
			// @todo we can rework this temporary solution so we don't have to manually set the itemsToBeAdded object to something else in PackageDetails controller
			// this is to address allowing us to clear out the itemsToBeAdded array in Package service
			Package.alternateModuleItemsToBeAdded = itemsToBeAdded;
		}

		/**
		 * Updates the internal package list object
		 * @protected
		 * @memberof vm
		 * @returns {undefined}
		 */
		function _updatePackages() {
			$scope.packageList = vm._.lastResponse.status === Enums.status.OK
				? CalendarPricingService.transformToPackageList($scope.keyword, vm._.lastResponse, $scope.selectedDate)
				: [];

			$scope.showDatedPackageList = $scope.packageList.length > 0;
		}
	}
})();


angular.module('calendar-pricing')
	.service('CalendarPricingSavingsService', function(
		$log,
		$q,
		$state,
		$rootScope,
		$filter,
		AppData,
		CustomActionService,
		DynamicCapacityPricingService,
		Utilities,
		LegacyCart,
		Package,
		JSONValidator,
		Enums,
		Language,
		StandardFlowInitiatorService,
		CalendarPricingModels,
		RouteRejectionService,
		RestrictedPackagesService,
		Storage,
		UtilsPricing
	) {
		var executeCustomAction = CustomActionService.executeCustomAction,
			checkProp = Utilities.safelyCheckPropertyOnObject,
			getBoolean = Utilities.getBoolean,
			monthsRequested = [],
			currentKeyword;

		var service = {
				allowedDates: [],
				packageMap: [],
				selectedDate: undefined,
				//flag to put the service in requesting packages by day mode (the default behavior is to request all packages by month for the Calendar Pricing module
				isRequestingPackagesByDay: false,

				/**
				 * Passed into the Base Calendar directive, this object is an array
				 * that maps a date object (not string) to a freeform dataObject
				 *
				 * @example
				 * [ { date: new Date(), dataObject: { test: 1 } } ]
				 */
				additionalDataMap: [],
				legendSettings: { mode: undefined },
				calPriceSortIndicator: AppData.settings.calPriceSortIndicator,
				anyDayPackageMap: [], // anyDayPackageMap is only used for the Cedar Fair Recommender Wizard
				anyDayPackages: undefined,
				firstDateAvailableForAPP: undefined, // only defined when the advanceDays stateParam is used.
				// only defined through CF Recommender Wizard
				guestQtyTotal: null
			},
			forcedDate = {
				date: undefined,
				dateObj: undefined
			};

		function reset() {
			service.packageMap = [];
			service.anyDayPackageMap = [];
			service.allowedDates = [];
			service.selectedDate = undefined;
			service.additionalDataMap = [];
			service.anyDayPackages = undefined;
			service.legendSettings = { mode: undefined };
			service.isRequestingPackagesByDay = false;
			service.firstDateAvailableForAPP = undefined;
			service.guestQtyTotal = null;

			monthsRequested = [];
		}

		forcedDate.initialize = function(prevState) {
			var
				inAltModuleCrossSell = ($state.current.altModuleCrossSell),
				inStandardCrossSell = (angular.isDefined(StandardFlowInitiatorService.currentStandardFlowType) ? StandardFlowInitiatorService.currentStandardFlowType.toLowerCase() == 'crosssells' : false);
			this.date = undefined;
			this.dateObj = undefined;

			// If we're in a cross sell
			if (LegacyCart.lastDateCurrent('start_date') && (inAltModuleCrossSell || inStandardCrossSell)) {
				// we're in a cross sell flow and the customer has already selected a date
				this.date = LegacyCart.lastDateAdded.start_date;
				this.dateObj = Utilities.dateStringToObject(LegacyCart.lastDateAdded.start_date);
				this.dateObj.setHours(12, 0, 0, 0); //the format our date modules use to represent the current time
			}
		};

		service.lockCalendar = function() {
			return angular.isDefined(forcedDate.date);
		};

		// select the first date that is past the required advanced period.
		service.selectDateIfPossible = function(earliestPossibleDate) {
			var newDateTime = earliestPossibleDate.getTime(),
				dateTimeToUse = service.allowedDates.filter(function(d) {
					return (d >= newDateTime);
				})[0];
			if (angular.isDefined(dateTimeToUse)) {
				service.selectedDate.setTime(dateTimeToUse);
			} else {
				service.selectedDate = undefined;
			}
		};
		service.initialize = function(stateParams, requestPkgsByDay, prevState, requestTimeInfo) {
			var defer = $q.defer();
			currentKeyword = stateParams.keyword;

			// The keyword is also used as the locale prefix
			forcedDate.initialize(prevState);
			$log.info('Initializing Calendar Pricing Service');

			AppData.updateLastKeyword(currentKeyword, "Calendar Pricing Service");
			reset();
			// Find the Any Day Package (keywords, packages, etc.)
			service.anyDayPackages = new CalendarPricingModels.AnyDayPackageService(currentKeyword);

			service.isRequestingPackagesByDay = getBoolean(requestPkgsByDay);
			service.isRequestingTimeInfo = getBoolean(requestTimeInfo);

			var month;
			var requestDate = forcedDate.date;
			var advanceDays = angular.isDefined(stateParams.advanceDays) ? Utilities.forceInt(stateParams.advanceDays) : 0;

			/**
			 * If the APP advanceDays are specified and no date is being forced, find the first date that could be available for purchase
			 * at the indicated price.
			 */
			if (advanceDays>0 && angular.isUndefined(requestDate)) {
				service.firstDateAvailableForAPP = new Date();
				service.firstDateAvailableForAPP.setHours(12, 0, 0, 0); // dates stored in allowedDates have 0'th hour.
				service.firstDateAvailableForAPP.setDate(service.firstDateAvailableForAPP.getDate()+advanceDays);
			}

			// Use the selected date from the Recommender Wizard service if it exists
			executeCustomAction('setCalendarPricingModuleDate');

			if (angular.isDefined(Package.calendarPricingModuleDate)) {
				// The yearOffset fixes an issue where no dates are available when coming back to the calendar with a selected date
				// that is different from the current month.
				// For example, if we need dates for February of the next year we need to provide 14 (12 + 2)
				var nowDate = new Date();
				var yearDifference = Package.calendarPricingModuleDate.getFullYear() - nowDate.getFullYear();
				var yearOffset = (yearDifference > 0) ? (12 * yearDifference) : 0;
				month = (Package.calendarPricingModuleDate.getMonth() + yearOffset) + 1;
			} else if (service.isRequestingPackagesByDay) {
				//starting with today's date, request the packages for today upon initialization
				if (angular.isDefined(requestDate)) {
					service.selectedDate = forcedDate.dateObj;
					service.allowedDates = [forcedDate.dateObj.getTime()];
					month = forcedDate.dateObj.getMonth() + 1; // +1 because API uses 1-based list of months.
				} else {
					requestDate = Utilities.getDateByString(new Date());
					service.selectedDate = new Date();
					service.allowedDates = Utilities.getListOfDatesForMonth();
				}
			}

			service.requestDates(month, requestDate).then(function() {
				if (angular.isDefined(Package.calendarPricingModuleDate)) {
					service.selectedDate = angular.copy(Package.calendarPricingModuleDate);
					Package.calendarPricingModuleDate = undefined;
				} else if (angular.isDefined(forcedDate.date)) {
					service.selectedDate = Utilities.dateStringToObject(forcedDate.date);
				}

				// if there is a delay required on the first selected date, resolve it:
				if (angular.isDefined(service.firstDateAvailableForAPP)) {
					service.moveCurrentDateToFirstAvailableForAPP().then(function() {
						defer.resolve();
					});
				} else {
					defer.resolve();
				}
			});
			return defer.promise;
		};


		/**
		 * moveCurrentDateToFirstAvailableForAPP returns a promise that is resolved once the calendar dates have been
		 * retrieved to allow the current date to be set to the firstDateAvailableForApp
		 *
		 */
		service.moveCurrentDateToFirstAvailableForAPP = function() {
			// If there is a delay required on the first selected date,
			// and either there is no selected date, or it is before the required delay
			if (angular.isDefined(service.firstDateAvailableForAPP)
				&& (angular.isUndefined(service.selectedDate) || service.selectedDate.getTime()<service.firstDateAvailableForAPP.getTime())) {
				if (angular.isUndefined(service.selectedDate)) {
					// If there is no selected date, default it to today. We have to do this to determine if we need
					// to move the calendar forward a month
					service.selectedDate = new Date();
					service.selectedDate.setHours(12, 0, 0, 0);
				}
				if (service.firstDateAvailableForAPP.getMonth() > service.selectedDate.getMonth()) {
					var
						monthDifference = service.firstDateAvailableForAPP.getMonth() - service.selectedDate.getMonth(),
						requestMonth = service.firstDateAvailableForAPP.getMonth() + 1,
						newRequestDate = undefined;

					// when requestingPackageByDay, we need to
					//   1: send a text date into service.requestDates
					//   2: set allowed dates to include all the dates in the new month.
					if (service.isRequestingPackagesByDay) {
						service.allowedDates = Utilities.getListOfDatesForMonth(monthDifference);
						newRequestDate = Utilities.getDateByString(service.firstDateAvailableForAPP);
					}

					return service.requestDates(requestMonth, newRequestDate).then(function() {
						service.selectDateIfPossible(service.firstDateAvailableForAPP);
					});
				} else {
					service.selectDateIfPossible(service.firstDateAvailableForAPP);
					return $q.when();
				}
			} else {
				return $q.when();
			}
		};
		/**
		 * Request the dates for the module either for a month or a single date
		 * @param month
		 * @param requestDateStringYYYY_MM_DD
		 * @returns {*}
		 */
		service.requestDates = function(month, requestDateStringYYYY_MM_DD) {
			// Verify the request was not previously made for this date.
			// If so, load the dates from memory.
			var dateRequest = $q.defer();
			var requestMonth = -1;

			if (angular.isDefined(month)) {
				requestMonth = month;
			}

			for (var i = 0; i < monthsRequested.length; i++) {
				if (monthsRequested[ i ] == requestMonth) {
					// immediate resolution if we have the date in cache
					dateRequest.resolve();
					return dateRequest.promise;
				}
			}

			var reqObj = {};
			reqObj.keyword = currentKeyword;
			reqObj.display_zero_capacity = (getBoolean(AppData.settings.display_zero_capacity) && !service.isRequestingTimeInfo) ? 1 : 0;
			var cutoffDisplay = JSONValidator.validate('cutoff_display', AppData.settings.cutoff_display) ? JSON.parse(AppData.settings.cutoff_display) : null;

			if (angular.isDefined(requestDateStringYYYY_MM_DD)) {
				reqObj.start_date = requestDateStringYYYY_MM_DD;
				reqObj.end_date = requestDateStringYYYY_MM_DD;
				var dateObj = Utilities.dateStringToObject(requestDateStringYYYY_MM_DD);

				// When the backend is interfacing with an external api, it requires that we set the month
				if (angular.isDefined(dateObj)) {
					reqObj.month = dateObj.getMonth() + 1; // javascript months are 0-based and our api months are 1-based
				}
			} else {
				// Remember the months requested.
				reqObj.month = requestMonth;
				monthsRequested.push(requestMonth);
			}

			var request_type = (service.isRequestingTimeInfo) ? 'GetKeywordComboCreator' : 'GetKeywordCalendar';

			if (request_type === Enums.services.GET_KEYWORD_COMBO_CREATOR && cutoffDisplay != null) {
				reqObj.show_cutoff_item = '1';
			}

			$rootScope.showSpinner(Language.getLocale('ApplicationLabels', 'gettingEventDates'));

			AppData.fetch(
				request_type,
				false,
				reqObj
			).then(
				function(data) {
					$rootScope.hideSpinner();

					if (!angular.isDefined(data.month)) {
						data.month = requestMonth;
					}

					// Make a copy of the object to manipulate.
					// This preserves the integrity of the GetKeywordCalendar call that appears in the console.
					var dataCopy = angular.copy(data);

					if (data.status == Enums.status.OK && angular.isDefined(data.DATES) && angular.isDefined(data.DATES.D)) {
						// Calendar pricing modules support restricted packages
						RestrictedPackagesService.filterCalendarPricingPackageOverrides(
							dataCopy,
							RestrictedPackagesService.hasRegisteredPackagesForKeyword(currentKeyword)
						);

						//filter the packages by device type
						if (getBoolean(AppData.settings.calendar_pricing_filter_by_device_type)) {
							filterByDeviceType(dataCopy.DATES.D);
							calculateLowestPrice(dataCopy.DATES.D);
						}

						// If specific dates were requested, limit the dates returned to those dates
						if (angular.isDefined(forcedDate.date)) {
							var newDay = dataCopy.DATES.D.filter(function(d) {
								return d.date == forcedDate.date;
							})[0];
							if (angular.isDefined(newDay)) {
								dataCopy.DATES.D = [newDay];
							}
						}

						// if any_day_ticket is defined, use it as the override for the Any Day ticket button.
						service.anyDayPackages.setAnyDayPackageOverride(dataCopy.any_day_ticket);

						setupLegend();

						// Add keyword filter here
						executeCustomAction('filterKeywordCalendarPackages', dataCopy.DATES);

						setFirstAvailableDate(dataCopy.DATES.D);
						processResponse(dataCopy.DATES.D, cutoffDisplay);

						// just a reminder: anyDayPackageMap is only used by the recommender wizard. The packages in the
						// anyDayPackageMap get added to the dated packages added to the package list for each date.
						service.anyDayPackageMap = executeCustomAction('getAnyDayPackages') || [];
						if (service.anyDayPackageMap.length > 0) {
							service.anyDayPackageMap.forEach(function(pkg) {
								service.determinePackagePrice(pkg);
							});
						}

						service.lastMonth = angular.isDefined(dataCopy.DATES) ? parseInt(dataCopy.DATES.month) : -1;

						dateRequest.resolve(dataCopy);
					} else {
						if ($state.current.altModuleCrossSell || StandardFlowInitiatorService.currentStandardFlowType === 'crosssells') {
							dateRequest.reject(new RouteRejectionService.ViewException('Alert', 'forcedDateErrorTitle', 'forcedDateErrorMsg', $state.current.url));
						} else {
							dateRequest.resolve();
						}
					}
				}
			);

			return dateRequest.promise;
		};

		function filterByDeviceType(datesArray) {
			for (var i = 0; i < datesArray.length; i++) {
				if (angular.isDefined(datesArray[i].PS) && angular.isArray(datesArray[i].PS.P)) {
					for (var j = 0; j < datesArray[i].PS.P.length; j++) {
						var p = datesArray[i].PS.P[j];
						if (angular.isDefined(p.id)) {
							var filteredPackageDetails = $filter('filterByDeviceType')([Package.getPackageByID(p.id)]);
							if (Utilities.isEmpty(filteredPackageDetails)) {
								datesArray[i].PS.P.splice(datesArray[i].PS.P.indexOf(p), 1);
								j--;
							}
						}
					}
					if (datesArray[i].PS.P.length <= 0) {
						datesArray.splice(datesArray.indexOf(datesArray[i]), 1);
						i--;
					}
				}
			}
		}

		function calculateLowestPrice(datesArray) {
			for (var i = 0; i < datesArray.length; i++) {
				if (angular.isDefined(datesArray[i].PS) && angular.isArray(datesArray[i].PS.P)) {
					for (var j = 0; j < datesArray[i].PS.P.length; j++) {
						var p = datesArray[i].PS.P[j];
						for (var k = 0; k < p.CT.length; k++) {
							if (Number(p.CT[k].retail_amount) < Number(datesArray[i].lowest_price)) {
								datesArray[i].lowest_price = p.CT[k].retail_amount;
								datesArray[i].lowest_price_savings = p.CT[k].savings
							}
						}
					}
				}
			}
		}

		function checkIfPackageUsesExistingDate(id) {
			// useExistingDate was added to handle the case of a package which should use a date that the
			// customer already entered on a previous module.
			var p = Package.getPackageByID(id);
			if (angular.isDefined(p) && angular.isDefined(p.CHARACS)) {
			 return getBoolean(p.CHARACS.useExistingDate);
			}
			return false;
		}

		function processResponse(data, cutoffDisplay) {
			var recommenderData;
			var currentPkgs= [];
			var isRecommenderWizardFlow = (window.location.href.indexOf('wizardCalendar') > -1);
			data = modifyDataWhenCalendarPricingTimesByDay(data);

			if (isRecommenderWizardFlow) {
				recommenderData = Storage.get('RecommenderWizardContextData');
				if (!!recommenderData) {
					service.guestQtyTotal = service.getGuestQtyTotal(recommenderData.customerTypeGroupList);
				}
			}

			for (var i = 0; i < data.length; i++) {
				var dateObject = data[i];

				// if we're forcing a date, and the found date is not that date,
				// check to see if there are any packages in the found date that are not
				// requiring the date.
				if (angular.isDefined(forcedDate.date) && dateObject.date != forcedDate.date) {
					if (angular.isDefined(dateObject.PS)) {
						var useDate = false;
						for (var ii = 0; ii < dateObject.PS.P.length && !useDate; ii++) {
							useDate = checkIfPackageUsesExistingDate(dateObject.PS.P[ii].id);
						}
						if (useDate) {
							// at this point, we've stepped through all the packages for this date and all of them
							// require that this date equal forceDate (which it doesn't).
							continue;
						}
					}
				}

				var timeRepresentationOfDate = Utilities.dateStringToObject(dateObject.date).getTime();
				if (!service.isRequestingPackagesByDay) {
					// If using Recommender Wizard
					if (angular.isObject(dateObject.PS.P) && service.guestQtyTotal && isRecommenderWizardFlow) {
						// Will only disable day if all packages for this day have availablitly less than guestQtyTotal
						dateObject.PS.P.forEach(function checkAvail(pk) {
							if (LegacyCart.cartItems.length) {
								currentPkgs = LegacyCart.cartItems.filter(function filterOutOtherPkgs(pkg) {
									// Filter out packages in cart not offered on page
									return pkg.package_id === pk.id;
								})
								// Loop through packages in cart offered on page and reduce availablity
								currentPkgs.forEach(function checkPkgs(cartPkg) {
									if (cartPkg.package_id === pk.id && Utilities.dateStringToObject(cartPkg.E.start_date).getTime() === timeRepresentationOfDate) {
										pk.available -= cartPkg.qty;
									}
								});
								// Check availability against guestQtyTotal
								if (pk.available >= service.guestQtyTotal) {
									service.allowedDates.push(timeRepresentationOfDate);
								}
							} else if (pk.available >= service.guestQtyTotal ) {
								service.allowedDates.push(timeRepresentationOfDate);
							}
						});
					} else {
						service.allowedDates.push(timeRepresentationOfDate);
					}
				}

				var skipDate = true;

				// add properties from GetMerchantPackageList
				if (angular.isDefined(dateObject.PS)) {
					skipDate = false;


					service.addSavingsToDataMap(dateObject);

					//backend sends the package for each customer type and as we are adding the
					// package properties for each package, we need to dedupe
					var tmpPkgIds = [];

					/*
					 *	We are iterating through an array of packages that are available fore a given day.
					 *	This array will contain either the lowest or highest (based on config) price for each
					 *	package on that date. These will then be sorted and used to display on the calendar.
					 */
					var allPricesForDay = []

					for (var j = dateObject.PS.P.length -1; j >= 0; j--) {
						var pkg = dateObject.PS.P[j];

						if (!checkProp('CT.0.A.timeHasPassed', Utilities.wrapObjectToArray(pkg.CT, true))) {

							if (tmpPkgIds.indexOf(pkg.id) == -1) {
								var fullPackage = Package.getPackageByID(pkg.id);

								if (angular.isDefined(service.calPriceSortIndicator) && $state.next.name === 'calendar') {
									// Loop through the packages, pull the lowest price, and map it to the datamap
									var pricesForPackage = Package.getAllPricesForPackageByDate(fullPackage.CT, dateObject.date);
									allPricesForDay = allPricesForDay.concat(pricesForPackage);

									service.addLowPriceToDataMap(dateObject.date, allPricesForDay, service.calPriceSortIndicator);
								}


								addPackageProperties(pkg, dateObject.date, cutoffDisplay);

								// add it to tmpPkgIds so we don't go through this twice for the same package.
								tmpPkgIds.push(pkg.id);

								// splice out the package if if there aren't any valid CTs
								// CustomActionService is undefined if we're not in the wizard, so this test has to check
								// for false explicitly.
								if (executeCustomAction('requireAllCustomerTypes', pkg) === false) {
									dateObject.PS.P.splice(j, 1);
								}
							}
						} else {
							dateObject.PS.P.splice(j, 1);
						}
					}

					// If there are no packages available for this date, skip it.
					// Should only happen if we're in the recommender wizard, and none of the packages
					// have a required customer type.
					skipDate = (dateObject.PS.P.length < 1);
					if (!skipDate) {
						setSoldOutInfo(dateObject, data,i);
					}
				}

				// If there are no packages available for this date, skip it.
				if (!skipDate) {
					service.packageMap.push(dateObject);
				}
			}
		}

		/**
		 * For Recommender Wizard
		 * Calculates the total quanity selected by the guest
		 * @param {Array} customerTypeGroupList From the Recommender Data in local storage,
		 * @returns {Number} Quantity Total guest selected on Wizard
		 */
		service.getGuestQtyTotal = function(customerTypeGroupList) {
			var guestQty = 0;
			customerTypeGroupList.forEach(function getQty(ct) {
				guestQty += ct.qty;
			});
			return guestQty;
		};

		function modifyDataWhenCalendarPricingTimesByDay(data) {
			//The calendar pricing times by day uses the GetKeywordComboCreator call which comes back slightly
			//different than the standard GetKeywordCalendar. Once we tweak the structure, we are able to make all
			//of the same calculations.
			if (service.isRequestingTimeInfo) {
				if (checkProp('data.PS.P', data)) {
					if (!angular.isArray(data.PS.P)) {
						data.PS.P = [data.PS.P];
					}
				}
				data = [data];
			}
			return data;
		}

		/**
		 * Set the sold out information on a day or package item for the data map
		 * If a legend is configured, assess the type of legend (capacity vs. custom) to show
		 * thresholds and additional availability information to the guest based on the display configuration
		 * @param {Object} dayNode - the day node that contains information on availability for packages offered on days
		 * @returns {undefined}
		 * @param {Array} daysAvailableList - array of availability from API <D> node
		 * @param {number} currIndex - index within the array to assess if we need to reset the selectedDate in the event one is actually sold out
		 */
		function setSoldOutInfo(dayNode, daysAvailableList, currIndex) {
			var dateObject = Utilities.dateStringToObject(dayNode.date);

			if (dayNode.bookings_sold_out !== 'null' && getBoolean(dayNode.bookings_sold_out)) {
				service.populateAdditionalDataMap(dateObject, {soldOut: true});
				//reset the first available date to the next one if the current selected date which was set before
				if (service.selectedDate && service.selectedDate.getTime() === dateObject.getTime() && currIndex < daysAvailableList.length - 1) {
					service.selectedDate = Utilities.dateStringToObject(daysAvailableList[currIndex + 1].date);
				}
				return;
			}

			dayNode.PS.P.forEach(function(item) {
				var map = {};

				if (angular.isDefined(item.available) && angular.isDefined(item.capacity)) {
					var capacityRatio = Math.floor((item.available / item.capacity)*100);
				} else {
					$log.info('Capacity information not available');
				}

				if (service.legendSettings.mode == 'capacity') {
					if (capacityRatio >= service.legendSettings.bestAvailable) {
						map.best = true;
					} else if (capacityRatio <= service.legendSettings.limitedAvailability && capacityRatio > 0) {
						map.limited = true;
					} else if (isNaN(capacityRatio) || capacityRatio <= 0 || item.available < 0 || item.capacity < 0) {
						map.soldOut = true;
						item.isSoldOut = true;
					}
				} else if (service.legendSettings.mode == 'custom') {
					//sold out + two custom chevrons
					if (angular.isDefined(item.CHARACS)) {
						// is this chevron one or two?
						if (angular.isDefined(item.CHARACS.chevron_one)) {
							map.best = true;
						} else if (angular.isDefined(item.CHARACS.chevron_two)) {
							map.limited = true;
						}
						if (isNaN(capacityRatio) || capacityRatio <= 0 || item.available < 0 || item.capacity < 0) {
							map.soldOut = true;
							item.isSoldOut = true;
						}
					}
				}

				service.populateAdditionalDataMap(dateObject, map);
			});
		}

		function setFirstAvailableDate(data) {
			if (angular.isDefined(forcedDate.date)) {
        		service.selectedDate = Utilities.dateStringToObject(forcedDate.date);
			} else if (angular.isDefined(data[0]) && angular.isDefined(data[0].date)) {
				service.selectedDate = Utilities.dateStringToObject(data[0].date);
			} else {
				service.selectedDate = new Date();
			}
		}

		function addPackageProperties(packageItem, date, cutoffDisplay) {
			var packageId = packageItem.id;

			var fullPackage = Package.getPackageByID(packageId);
			if (!fullPackage) {
				$log.error('Package ' + packageId + ' does not exist in GetMerchantPackageList!');
				return;
			}
			//For CalendarPricingTimesByDay, we need the original package item before the extend because the A node on
			//the customer types is not available on the 'fullPackage'
			var originalPackageItem = angular.copy(packageItem);
			// map all properties from the full package spec onto our internal packageItem
			angular.extend(packageItem, fullPackage);

			// Loop through customer types
			packageItem.CT.forEach(function iteratePackageCts(ct, i) {
				var originalMatchingCT = Utilities.wrapObjectToArray(originalPackageItem.CT, true).find(function findCT(ogCt) {
					return ct.id === ogCt.id;
				});

				// If the package has dynamic price
				if (checkProp('originalMatchingCT.DYNAMIC_PRICING', originalMatchingCT)) {
					// Use the Dynamic Pricing values from the response, rather than what is on GetMerchantPackageList
					ct.DYNAMIC_PRICING = angular.extend(ct.DYNAMIC_PRICING || {}, originalMatchingCT.DYNAMIC_PRICING);
				}
			});

			service.determinePackagePrice(packageItem);

			// Set the starting at string.
			packageItem.startingString = getStartingString(packageItem);
			packageItem.imageURL = (checkProp('pkg.CHARACS.calendarPricingImageURL', packageItem)) ? packageItem.CHARACS.calendarPricingImageURL : '';
			packageItem.imageTitle = (checkProp('pkg.CHARACS.calendarPricingImageTitle', packageItem)) ? packageItem.CHARACS.calendarPricingImageTitle : '';

			//Times could be available in CalendarPricingTimesByDay
			addPackageItemTimes(originalPackageItem, packageItem, date, cutoffDisplay);
		}

		/**
		 * Returns the starting string
		 * @param {Object} packageItem The item
		 * @returns {String} the starting at string
		 */
		function getStartingString(packageItem) {
			var hasDynamic = packageItem.CT.some(DynamicCapacityPricingService.getDynamicPricingValues);

			if (checkProp('pkg.CHARACS.price_label_override', packageItem, 'returnValue')) {
				return '';
			}
			if (hasDynamic) {
				return packageItem.CT.length > 1 ? DynamicCapacityPricingService.getFromPriceLocale() : '';
			}

			return packageItem.starting_at ? Language.PackageList.startingLabel + '&nbsp;' : '';
		}

		function addPackageItemTimes(originalPackageItem, packageItem, date, cutoffDisplay) {
			if (angular.isDefined(originalPackageItem.CT)) {
				if (!angular.isArray(originalPackageItem.CT)) {
					originalPackageItem.CT = [originalPackageItem.CT];
				}
				//We only need the first A node for times because all availablity is shared between CTs
				if (angular.isDefined(originalPackageItem.CT[0].A)) {
					var formatString = Utilities.getTimeFormat(AppData.settings);
					packageItem.times = [];
					if (!angular.isArray(originalPackageItem.CT[0].A)) {
						originalPackageItem.CT[0].A = [originalPackageItem.CT[0].A];
					}
					for (var i = 0; i < originalPackageItem.CT[0].A.length; i++) {
						var timeObj = originalPackageItem.CT[0].A[i];

						if (Number(timeObj.available) > 0) {
							timeObj.start = new Date(date.replace(/-/g, '/') + ' ' + timeObj.start);
							timeObj.start = $filter('date')(timeObj.start, formatString);

							if (cutoffDisplay != null) {
								cutoffValues(cutoffDisplay, date, timeObj, packageItem);
							} else {
								packageItem.times.push(timeObj.start);
							}
						}
					}
				}
			}
		}

		/**
		 * cutoffValues loops through each value of cutoff display and gives appropriate results.
		 * If the cutoff value is 'omit', then it removes the passed time slots and packages.
		 * If the cutoff value is 'disabled', then it grey out passed time slots.
		 * @param {Object} cutoffDisplay - It is a JSON object and the values we are getting are from PC.
		 * @param {Date} date - Today's date.
		 * @param {Object} timeObj - Array of time objects.
		 * @param {Object} packageItem The item.
		 * @returns {undefined}
		 */
		function cutoffValues (cutoffDisplay, date, timeObj, packageItem) {
			var currentTime = new Date().toTimeString();
			var selectedDate = Utilities.javascriptDateToSQLDate(new Date());
			if (cutoffDisplay.cutoff_values === 'omit' && (date !== selectedDate || (date === selectedDate && timeObj.start >= currentTime.substring(0, 5)))) {
				if (!timeObj.timeHasPassed) {
					packageItem.times.push(timeObj.start);
				}
			} else if (cutoffDisplay.cutoff_values === 'disabled') {
				packageItem.times.push(timeObj.start);
			}
		}

		service.determinePackagePrice = function(packageItem) {
			var dynamicValues;
			var prices = [];
			var useVat = AppData.defaults.use_vat;

			if (angular.isDefined(packageItem.CT)) {
				var specificTypePrice = undefined;
				for (var i = 0; i < packageItem.CT.length; i++) {
					var customerType = packageItem.CT[i];
					var hasCTDisplayOverride = false;
					// Advanced purchase pricing functionality...
					setAdvPurchPricingDetails(customerType, service.selectedDate);
					if (checkProp('packageItem.CHARACS.ct_id_to_display', packageItem) && customerType.id == packageItem.CHARACS.ct_id_to_display) {
						hasCTDisplayOverride =true;
					}

					if (customerType.discountedRetailAmount != -1 && customerType.discountedTaxAmount != -1) {
						// This package has advanced purchase pricing enabled. Use that price instead of the regular retail price.
						isApp = true;
						startRate = Utilities.getTotalPrice(customerType, [customerType.discountedRetailAmount, customerType.discountedTaxAmount]);
					} else {
						startRate = Utilities.getTotalPrice(customerType);
					}

					// Does the Customer Type have Dynamic Pricing?
					if (checkProp('customerType.DYNAMIC_PRICING', customerType, 'validObject')) {
						// Grab the dynamic pricing values for the customer type
						dynamicValues = DynamicCapacityPricingService.getDynamicPricingValues(customerType, packageItem.id);

						// set the start rate
						startRate = DynamicCapacityPricingService.getDynTotalPrice(dynamicValues);
					}

					if (hasCTDisplayOverride) {
						specificTypePrice = startRate;
					}

					customerType.cusTypeRetail = startRate;
					customerType.gatePrice = undefined;
					prices.push(startRate);
				}
			}

			prices.sort(function(a, b) {
				return a - b;
			});
			packageItem.price = specificTypePrice || prices[0];

			if (angular.isDefined(packageItem.CHARACS) && angular.isDefined(packageItem.CHARACS.price_label_override)) {
				packageItem.price = packageItem.CHARACS.price_label_override;
			}
		}

		service.addSavingsToDataMap = function(item, overridePrice, overrideSavings) {
			var dateObject = Utilities.dateStringToObject(item.date);
			var map = {};

			map.lowestPrice = determineLowestPrice(item);

			if (angular.isDefined(overridePrice)) {
				map.lowestPrice.price = overridePrice;
			}

			if (angular.isDefined(overrideSavings)) {
				map.lowestPrice.savings = overrideSavings;
			}

			service.populateAdditionalDataMap(dateObject, map);
		}

		// Used for adding the low price to the data map (Mobile Calendar Pricing)
		service.addLowPriceToDataMap = function(date, prices, config) {
			var map = {};
			var sortedPrices = [];

			switch (config) {
			case 'low':
				sortedPrices = prices.sort(function(a, b) {
					return a - b;
				});
				break;
			case 'high':
				sortedPrices = prices.sort(function(a, b) {
					return b - a;
				});
				break;
			}

			map.displayPrice = $filter('currencyFormatter')(sortedPrices[0], true)

			var dateString = Utilities.dateStringToObject(date);

			service.populateAdditionalDataMap(dateString, map);
		}

		service.populateAdditionalDataMap = function(date, map) {
			if (angular.isUndefined(date) || (date instanceof Date) === false) {
				$log.error("Invalid date supplied when populating additional data map");
				return;
			}

			var discoveredItem;
			for (var i = 0; i<service.additionalDataMap.length; i++) {
				var item = service.additionalDataMap[i];

				if (angular.isDefined(item.date) && item.date.getTime() === date.getTime()) {
					// item exists
					discoveredItem = item;
					break;
				}
			}

			if (angular.isDefined(discoveredItem)) {
				// existing dataMap
				angular.extend(discoveredItem.dataMap, map);
			} else {
				// new dataMap
				service.additionalDataMap.push({
					date: date,
					dataMap: map
				});
			}
		}

		/**
		 * Returns the lowest price customer type of two
		 * @param {Object} customerType1 The first
		 * @param {Object} customerType2 The second
		 * @returns {Object} the lowest of the two
		 */
		function getLowestPriceBetweenCustomerTypes(customerType1, customerType2, packageIdForCt1, packageIdForCt2) {
			var pkg1 = Package.getPackageByID(packageIdForCt1);
			var pkg2 = Package.getPackageByID(packageIdForCt2);
			var useVat = AppData.defaults.use_vat;
			var customerType1DynamicPrice = DynamicCapacityPricingService.getDynamicPricingValues(customerType1, packageIdForCt1);
			var customerType2DynamicPrice = DynamicCapacityPricingService.getDynamicPricingValues(customerType2, packageIdForCt2);
			var packageCt1 = pkg1.CT.find(function(ct) {
				return ct.id === customerType1.id;
			});
			var packageCt2 = pkg2.CT.find(function(ct) {
				return ct.id === customerType2.id;
			});
			var customerType1Price;
			var customerType2Price;

			if (customerType1DynamicPrice) {
				customerType1Price = DynamicCapacityPricingService.getDynTotalPrice(customerType1DynamicPrice);
			} else {
				customerType1Price = useVat ? UtilsPricing.getPrice(customerType1.retail_amount, packageCt1.tax_amount, packageCt1.fee_total) : customerType1.retail_amount;
			}

			if (customerType2DynamicPrice) {
				customerType2Price = DynamicCapacityPricingService.getDynTotalPrice(customerType2DynamicPrice);
			} else {
				customerType2Price = useVat ? UtilsPricing.getPrice(customerType2.retail_amount, packageCt2.tax_amount, packageCt2.fee_total) : customerType2.retail_amount;
			}

			return parseFloat(customerType1Price) < parseFloat(customerType2Price) ? customerType1 : customerType2;
		}

		function determineLowestPrice(dateItem) {
			var lowestPrice = '',
				lowestPriceSavings = '',
				lowestPricePackageId,
				hasDynamicPricing = false,
				lowestDynamicCustomerType,
				lowestDynamicPrice;

			if (angular.isUndefined(dateItem)) {
				return;
			}

			/**
			 * If we have dynamic pricing, we should be calculating that instead.
			 */
			if (checkProp('dateItem.PS.P', dateItem, angular.isObject)) {
				dateItem.PS.P = Utilities.wrapObjectToArray(dateItem.PS.P, true);
				hasDynamicPricing = DynamicCapacityPricingService.isPackageSetDynamic(dateItem.PS.P);

				if (hasDynamicPricing) {
					lowestDynamicCustomerType = dateItem.PS.P.reduce(function reduceLowestPrice(currentLowest, pkg) {
						var lowest = pkg.CT.reduce(function(currentLowest, lowest) {
							if (!currentLowest) {
								return lowest;
							}
							return getLowestPriceBetweenCustomerTypes(currentLowest, lowest, pkg.id, pkg.id);
						}, null);
						var newLowest;
						if (!currentLowest) {
							lowestPricePackageId = pkg.id;
							return lowest;
						}

						newLowest = getLowestPriceBetweenCustomerTypes(currentLowest, lowest, lowestPricePackageId, pkg.id);

						if (newLowest !== currentLowest) {
							lowestPricePackageId = pkg.id;
						}
						return newLowest;
					}, null);

					lowestDynamicPrice = DynamicCapacityPricingService.getDynamicPricingValues(lowestDynamicCustomerType, lowestPricePackageId);

					if (lowestDynamicPrice) {
						return {
							price: lowestDynamicPrice.price > 0 ? $filter('currencyFormatter')(DynamicCapacityPricingService.getDynTotalPrice(lowestDynamicPrice)) : '',
							savings: lowestPriceSavings
						};
					}
				}
			}

			/**
			 * If lowest_price and lowest_price_savings exist on the D
			 * node, use that first.
			 * If not, calculate the lowest price of all PS nodes
			 */
			if (angular.isDefined(dateItem.lowest_price) &&
				angular.isDefined(dateItem.lowest_price_savings)) {
				if (dateItem.lowest_price !== "0.00") {
					var useVat = AppData.defaults.use_vat;
					var useFeeInclusive = AppData.defaults.use_fee_inclusive_pricing;

					if (useVat || useFeeInclusive) {
						var priceLabels = determineLowestPriceWithVat(dateItem);
						dateItem.lowest_price = priceLabels.lowest_price;
						dateItem.lowest_price_savings = priceLabels.lowest_price_savings;
					}

					formattedLowestPrice = $filter('currencyFormatter')(dateItem.lowest_price);

					if (dateItem.PS.P.length > 1) {
						lowestPrice = Language.getLocale('PackageList', 'startingLabel') + ' ' + formattedLowestPrice;
					} else {
						lowestPrice = formattedLowestPrice;
					}

					if (dateItem.lowest_price_savings.length > 0) {
						formattedLowestPrice = $filter('currencyFormatter')(dateItem.lowest_price_savings);
						lowestPriceSavings = Language.getLocale('SavingsCalendar', 'savingsLabel') + ' ' + formattedLowestPrice;
					}
				}
			}

			return {
				price: lowestPrice,
				savings: lowestPriceSavings
			};
		}

		function determineLowestPriceWithVat(dateItem) {
			var lowest_price,
				lowest_price_savings;
			var packages = angular.isArray(dateItem.PS.P) ? dateItem.PS.P : [dateItem.PS.P];

			for (var i = 0; i <packages.length; i++) {
				var package_details = Package.getPackageByID(packages[i].id);
				var customer_types = package_details.CT;
				var gate_price = angular.isDefined(package_details.CHARACS) ? package_details.CHARACS.GatePrice : undefined;
				// Ensure we find the matching CT and get the tax from that if applicable
				for (var j=0; j<customer_types.length; j++) {
					if (customer_types[j].retail_amount === dateItem.lowest_price) {
						if (angular.isDefined(customer_types[j].tax_amount)) {
							lowest_price = Utilities.getTotalPrice(customer_types[j]);
							break;
						}
					}
				}
			}
			lowest_price_savings = angular.isDefined(gate_price) ? (Number(gate_price) - lowest_price).toFixed(2) : '';

			return {
				lowest_price: lowest_price.toString(),
				lowest_price_savings: lowest_price_savings.toString()
			}
		}

		function setAdvPurchPricingDetails(customerType, date) {
			date = angular.copy(date);

			// Packages with Advanced Purchase Pricing will have the following configuration.
			/*
				CT: Array[2]
					APP: Array[1]
						active: "1"
						discounted_retail_amount: "20.99"
						discounted_tax_amount: "5.25"
						display_order: "255"
						end_range: "364"
						name: "2 or more days"
						paps_id: "2"
						pricing_structure_id: "1"
						start_range: "2"
						type: "1"
						value: "5.00"
			*/
			// Check it APP is defined in CT
			// If not, return null
			// If defined, iterate through each one and check if date is within any APPs start and end range
			// If not within, return null
			// If within, push discounted_retail_amount and discounted_tax_amount into a collection

			var currentDate = new Date();

			// This should be at midnight otherwise the price will not be calculated correctly
			currentDate.setHours(0, 0, 0, 0);
			date.setHours(0, 0, 0, 0);

			var currentMilli = currentDate.getTime();
			var selectedDateMilli = date.getTime();
			var startRangeMilli = 0;

			// Reset the advPurchase details in the CT node.
			customerType.discountedRetailAmount = -1;
			customerType.discountedTaxAmount = -1;

			if (customerType.APP) {
				angular.forEach
				(
					customerType.APP,
					function(advPurchasePriceItem, i) {
						startRangeMilli = Number(advPurchasePriceItem.start_range) * 24 * 60 * 60 * 1000
						if (selectedDateMilli - currentMilli >= startRangeMilli) {
							// It's within range, ammend CT.
							customerType.discountedRetailAmount = advPurchasePriceItem.discounted_retail_amount;
							customerType.discountedTaxAmount = advPurchasePriceItem.discounted_tax_amount;
						}
					}
				);
			}
		}

		service.getPackages = function(newDate) {
			if (!(newDate instanceof Date)) {
				return;
			}

			newDate.setHours(12, 0, 0, 0);

			for (var i = 0; i < service.packageMap.length; i++) {
				var dateItem = service.packageMap[i];

				if (Utilities.dateStringToObject(dateItem.date).getTime() === newDate.getTime()) {
					// update pricing for Advance Purchase Pricing
					if (angular.isDefined(dateItem.PS['P']) && angular.isArray(dateItem.PS.P)) {
						dateItem.PS.P = dateItem.PS.P.map(function(item) {
							service.determinePackagePrice(item);
							return item;
						});
					}

					return dateItem.PS;
				}
			}
		};

		/**
		 * Does the current package map for this service contain data for a particular day
		 * @param newDate
		 * @returns {boolean}
		 */
		service.hasPackageDataForDate = function(newDate) {
			newDate.setHours(12, 0, 0, 0);

			return service.packageMap.filter(function(dateItem) {
				return Utilities.dateStringToObject(dateItem.date).getTime() === newDate.getTime();
			}).length === 1;
		}


		/**
		 * Gather settings for the legend
		 *
		 * Defaults for best available and limited are 75 and 25
		 * percent respectively. Override possible by the "legend_setup"
		 * JSON config
		 */
		function setupLegend() {
			service.showLegend = false;

			if (getBoolean(AppData.settings.show_calendar_capacity_legend)) {
				service.showLegend = true;

				// override parameters from the app config
				// values are in percent
				var limitedAvailability = 30;
				var bestAvailable = 75;

				if (angular.isDefined(AppData.settings.legendSetup)) {
					var settings = AppData.settings.legendSetup;

					limitedAvailability = parseInt(settings.limitedAvailability);
					bestAvailable = parseInt(settings.bestAvailable);
				}

				service.legendSettings.limitedAvailability = limitedAvailability;
				service.legendSettings.bestAvailable = bestAvailable;

				service.legendSettings.mode = 'capacity';
			} else if (getBoolean(AppData.settings.show_calendar_custom_legend)) {
				service.showLegend = true;
				service.legendSettings.mode = 'custom';
			}
		}


		return service;
	}
	);

angular.module('calendar-pricing')
	.constant('CalendarPricingTemplateConstant', {
		savingsTemplate:
'<div id="calendar-focus" role="region" aria-hidden="false" class="calendar-panel large-calendar" data-ng-class="{ \'large-calendar\': useLargeCalendar }" data-ng-keydown="$parent.$parent.keyboardSelect($event, move)" aria-labelledby="cal-pri-base-cal-title">' +
	'<table aria-labelledby="cal-pri-base-cal-title">' +
		'<thead>' +
			'<tr class="panel-heading">' +
				'<td tabindex="0" role="button" data-ng-click="$parent.$parent.move(-1, move)" class="thead move-cal left" aria-label="{{$parent.$parent.iconLeftArrowLabel}}">' +
					'<span class="icon-solid-left-arrow display-block pull-left"></span>' +
				'</td>' +
				'<td colspan="5" id="cal-pri-base-cal-title" aria-live="polite" aria-atomic="true" class="thead cal-title" data-ng-bind="$parent.$parent.title"></td>' +
				'<td tabindex="0" role="button" data-ng-click="$parent.$parent.move(1, move)" class="thead move-cal right" aria-label="{{$parent.$parent.iconRightArrowLabel}}">' +
					'<span class="icon-solid-right-arrow display-block pull-right"></span>' +
				'</td>' +
			'</tr>' +
			'<tr scope="row" class="cal-row calendar-week-names">' +
				'<th scope="col" class="cal-cell" data-ng-repeat="label in labels track by $index" data-ng-bind="label.abbr" title="{{label.full}}" aria-label="{{label.full}}"></th>' +
			'</tr>' +
		'</thead>' +
		'<tbody class="tbody panel-body">' +
			'<tr scope="row" class="cal-row" data-ng-repeat="row in rows track by $index">' +
				'<td class="cal-cell" data-ng-repeat="dt in row track by dt.date" ng-class="{selected: dt.selected, disabled:dt.disabled, \'date-range-enabled\': $parent.$parent.$parent.$parent.selectRange}">' +
					'<span class="size-contain" data-ng-hide="dt.date.getMonth() != ($parent.$parent.$parent.$parent.currentMonthInfo.currentMonthObject.getMonth()) && !$parent.$parent.$parent.$parent.spanMultipleMonths">&nbsp;' +
						'<span class="cal-btn-contain">' +
							'<button data-cy="date-cell" id="row{{dt.date.getMonth()}}-cell{{dt.date.getDate()}}" aria-label="{{dt.date | date:\'longDate\'}}" tabindex="-1" class="cal-btn" ng-click="!dt.disabled && select(dt.date)" ng-class="{\'selected\': dt.selected, active: isActive(dt), \'date-disabled\':dt.disabled}" aria-disabled="{{dt.disabled ? \'true\' : \'false\'}}" aria-pressed="{{dt.selected ? \'true\':\'false\'}}">' +
								'<span ng-if="!$parent.$parent.$parent.$parent.getDataMap(dt.date).soldOut" class="label" ng-class="{muted: ! dt.isCurrent}" ng-bind="dt.label"></span>' +
								'<div ng-if="!$parent.$parent.$parent.$parent.getDataMap(dt.date).soldOut" class="price-container">' +
									'<div>' +
										'<span data-cy="cal-pricing_online-price" class="limit" data-ng-bind-html="$parent.$parent.$parent.$parent.$parent.getDataMap(dt.date).lowestPrice.price"></span>' +
										'<span data-cy="cal-pricing_online-sav" class="dark-red" data-ng-bind-html="$parent.$parent.$parent.$parent.$parent.getDataMap(dt.date).lowestPrice.savings"></span>' +
									'</div>' +
								'</div>' +
								'<span ng-if="$parent.$parent.$parent.$parent.getDataMap(dt.date).soldOut" class="sold-out-date-label" ng-class="{muted: ! dt.isCurrent}" ng-bind="dt.label"></span>' +
								'<div class="sold-out-display" data-ng-if="$parent.$parent.$parent.$parent.getDataMap(dt.date).soldOut">' +
									'<div>' +
										'<span ng-bind-html="$parent.$parent.$parent.$parent.$parent.getLocale(\'Calendar\',\'soldOut\')"></span>' +
									'</div>' +
								'</div>' +
							'</button>' +
						'</span>' +
					'</span>' +
				'</td>' +
			'</tr>' +
		'</tbody>' +
	'</table>' +
'</div>',
		calendarPricingTemplate:
'<div id="calendar-focus" class="calendar-panel" data-ng-keydown="$parent.$parent.keyboardSelect($event, move)">' +
	'<table>' +
		'<thead>' +
			'<tr class="panel-heading">' +
				'<td tabindex="0" role="button" data-ng-click="$parent.$parent.move(-1, move)" class="thead move-cal left" aria-label="{{$parent.$parent.iconLeftArrowLabel}}">' +
					'<span class="icon-solid-left-arrow display-block pull-left"></span>' +
				'</td>' +
				'<td colspan="5" class="thead cal-title" data-ng-bind="$parent.$parent.title"></td>' +
				'<td tabindex="0" role="button" data-ng-click="$parent.$parent.move(1, move)" class="thead move-cal right" aria-label="{{$parent.$parent.iconRightArrowLabel}}">' +
					'<span class="icon-solid-right-arrow display-block pull-right"></span>' +
				'</td>' +
			'</tr>' +
			'<tr scope="row" class="cal-row calendar-week-names">' +
				'<th scope="col" class="cal-cell" data-ng-repeat="label in labels track by $index" data-ng-bind="label.abbr" title="{{label.full}}"></th>' +
			'</tr>' +
		'</thead>' +
		'<tbody class="tbody panel-body">' +
			'<tr scope="row" class="cal-row" data-ng-repeat="row in rows track by $index">' +
				'<td class="cal-cell" data-ng-repeat="dt in row track by dt.date" id="{{dt.uid}}" ng-class="{selected: dt.selected, disabled:dt.disabled}">' +
					'<span class="size-contain" data-ng-hide="dt.date.getMonth() != ($parent.$parent.$parent.$parent.currentMonthInfo.currentMonthObject.getMonth())">&nbsp;' +
						'<span class="cal-btn-contain">' +
							'<button id="row{{dt.date.getMonth()}}-cell{{dt.date.getDate()}}" aria-label="{{dt.date | date:\'longDate\'}}" tabindex="-1" type="button" class="cal-btn chevron" data-ng-class="{\'show-cal-prices\': $parent.$parent.$parent.$parent.showPricingInCell, selected: dt.selected, \'chevron-color-2\': $parent.$parent.$parent.$parent.getDataMap(dt.date).best, \'chevron-color-1\': $parent.$parent.$parent.$parent.getDataMap(dt.date).limited, \'chevron-color-3\': $parent.$parent.$parent.$parent.getDataMap(dt.date).soldOut, active: isActive(dt), \'date-disabled\': dt.disabled}" ng-click="!dt.disabled && select(dt.date)" aria-disabled="{{dt.disabled ? \'true\' : \'false\'}}" aria-pressed="{{dt.selected ? \'true\':\'false\'}}">' +
								'<span ng-if="!$parent.$parent.$parent.$parent.getDataMap(dt.date).soldOut" data-ng-class="{\'text-muted\': dt.secondary, \'text-info\': dt.current}">{{dt.label}}</span>' +
								'<span ng-if="!$parent.$parent.$parent.$parent.getDataMap(dt.date).soldOut" class="cal-btn-price" data-ng-class="{\'text-muted\': dt.secondary, \'text-info\': dt.current}">{{$parent.$parent.$parent.$parent.getDataMap(dt.date).displayPrice}}</span>' +
								'<span ng-if="$parent.$parent.$parent.$parent.getDataMap(dt.date).soldOut" class="sold-out-date-label" ng-class="{muted: ! dt.isCurrent}" ng-bind="dt.label"></span>' +
								'<div ng-if="$parent.$parent.$parent.$parent.getDataMap(dt.date).soldOut" class="sold-out-display smaller-calendar">' +
									'<div>' +
										'<span ng-bind-html="$parent.$parent.$parent.$parent.$parent.getLocale(\'Calendar\',\'soldOut\')"></span>' +
									'</div>' +
								'</div>' +
							'</button>' +
						'</span>' +
					'</span>' +
				'</td>' +
			'</tr>' +
		'</tbody>' +
	'</table>' +
'</div>'
	});

/**
 * Created by pMatthews on 5/9/2016.
 * Models included:
 *   AnyDayButton
 *     Description:
 *       Handles getting and returning values for the any day ticket button that can appear on the savings
 *       calendar. This button lets the customer quickly select an any day ticket instead of a dated ticket. From an
 *       implementation perspective, it's just a way for the customer to quickly do a keyword search.
 *     Usage:
 *       Pass the calendar's keyword in to the constructor. AnyDayButton looks in the locales and config to
 *       see if an AnyDayButton is defined.
 *     Methods:
 *       AnyDayButton.keyword returns the keyword associated with the AnyDayButton for the calendar keyword specified in the AnyDayButton constructor
 *       AnyDayButton.exists returns true if the AnyDayButton should be displayed.
 */

angular.module('calendar-pricing').service
('CalendarPricingModels',
	function(JSONValidator,
			Language,
			AppData,
			PackageList,
			Package,
			$state,
			$log) {
		function AnyDayPackageService(calendarKeyword) {
			// private fields
			this.reference = calendarKeyword;
			this.keyword = ''; // keyword specified for anyday packages for given calendarKeyword
			this.packageIds = []; // List of IDs of anyday package specified for given calendarKeyword
			this.packageIdOverride = undefined;
			this.initialize();
		}

		AnyDayPackageService.prototype = {

			initialize: function() {
				// The AnyDayKeyword can be specified in either the SavingsCalendar section or the CalendarPricingModule
				// section of the application_locale table.
				// We're migrating from this approach to using a config: if the AnyDayKeywordFor_referencekeyword exists in the
				// config table, we use its value as the keyword of the Any Day button.
				var localeTarget = this.reference + 'AnyDayKeyword',
					configName = 'calendar_anydaykeywords',
					calendarKeyword = this.reference;

				if (JSONValidator.validate('calendar_anydaykeywords', AppData.settings[configName])) {
					var configJson = JSON.parse(AppData.settings[configName]),
						kwEntry = configJson.filter(function(kw) {
							return (angular.isDefined(kw.calendar_keyword) && angular.isDefined(kw.anyday_keyword) && kw.calendar_keyword == calendarKeyword);
						});
					if (angular.isDefined(kwEntry) && kwEntry.length>0) {
						this.keyword = kwEntry[0].anyday_keyword;
					}
				}
				if (this.keyword == '' && Language.localeExists('SavingsCalendar', localeTarget)) {
					this.keyword = Language.getLocale('SavingsCalendar', localeTarget);
				}
				if (this.keyword == '' && Language.localeExists('CalendarPricingModule', localeTarget)) {
					this.keyword = Language.getLocale('CalendarPricingModule', localeTarget);
				}

				if (this.keyword) {
					// if we have a keyword, build the list of packages
					var packageRequest = PackageList.getRequestListItems(this.keyword, AppData.settings.calendar_pricing_filter_by_device_type);
					if (packageRequest.packageIDs) {
						this.packageIds = packageRequest.packageIDs.split(',');
					} else {
						// if no packages are found for that keyword, treat it as if it doesn't exist
						this.keyword='';
					}
				}
			},

			doubleCheckId: function(packageId) {
				if (angular.isUndefined(packageId)) {
					return undefined;
				}
				// If id being checked is actually a comma separated list of packages, as it can be in the case of
				// the anydaypackageoverride, assume the list is valid
				if (packageId.indexOf(',') == -1) {
					return packageId;
				}
				// let's look for this package in GetMerchantPackageList
				var pkg = Package.getPackageByID(packageId);
				if (angular.isDefined(pkg)) {
					return packageId;
				}
				$log.error('Cannot find package ID ' + packageId + ' in GetMerchantPackageList :: CalendarPricingModule');
				return undefined;
			},

			setAnyDayPackageOverride: function(packageIds) {
				if (angular.isUndefined(packageIds)) {
					return;
				}

				var packages = packageIds.split(',');
				for (var i = 0; i < packages.length; i++) {
					var packageId = this.doubleCheckId(packages[i]);
					if (angular.isUndefined(packageId)) {
						packages.splice(i, 1);
						i--;
					}
				}

				if (packages.length) {
					this.packageIdOverride = packages.join(',');
				}
			},

			addAnyDayPackage: function(packageId) {
				if (Utilities.inArray(this.packageIds, packageId)) {
					// if we already have the package in the list, don't add it again
					return;
				}
				packageId = this.doubleCheckId(packageId);
				if (angular.isDefined(packageId)) {
					this.packageIds.push(packageId);
				}
			},

			firstPackageId: function() {
				if (angular.isDefined(this.packageIdOverride)) {
					return this.packageIdOverride;
				}
				if (this.packageIds.length>0) {
					return this.packageIds[0];
				}
				return undefined;
			},

			exists: function() {
				return (angular.isDefined(this.firstPackageId()));
			},

			// this.hrefForRouting returns the correct route for the Any Day package, routing to either a single package
			// or a keyword
			hrefForRouting: function() {
				if (angular.isDefined(this.packageIdOverride)) {
					return $state.href('packageList/packages/:packages', { packages: this.packageIdOverride });
				} else if (this.keyword) {
					return $state.href('packageList/keyword', { keyword: this.keyword });
				} else if (this.packageIds.length>0) {
					return $state.href('packageList/packages/:packages', { packages: this.firstPackageId() });
				}
				return '';
			}

		};

		this.AnyDayPackageService = AnyDayPackageService;
	});

angular.module('fast-lane', ['app', 'base-calendar'])
	.config(function($locationProvider, $stateProvider, ComponentLoaderEnums) {
		$stateProvider
			.state('/fastLane', {
				components: [ ComponentLoaderEnums.cartFeeNotice ],
				url: '/fastLane',
				templateUrl: '/scripts/modules/fast-lane/views/fast-lane.html',
				controller: 'FastLaneController',
				resolve: {
					initialData: function(Bootstrap) {
						return Bootstrap.bootstrapApplication();
					},
					fastLaneData: function(initialData, FastLaneService) {
						return FastLaneService.initialize();
					}
				}
			})
			.state('/fastLane/:keyword', {
				components: [ ComponentLoaderEnums.cartFeeNotice ],
				url: '/fastLane/{keyword:keyword}',
				templateUrl: '/scripts/modules/fast-lane/views/fast-lane.html',
				controller: 'FastLaneController',
				resolve: {
					initialData: function(Bootstrap) {
						return Bootstrap.bootstrapApplication();
					},
					fastLaneData: function(initialData, FastLaneService, $transition$) {
						return FastLaneService.initialize($transition$.params());
					}
				}
			})

			.state('/fastLane/:keyword/:step', {
				components: [ ComponentLoaderEnums.cartFeeNotice ],
				url: '/fastLane/{keyword:keyword}/:step',
				templateUrl: '/scripts/modules/fast-lane/views/fast-lane.html',
				controller: 'FastLaneController',
				resolve: {
					initialData: function(Bootstrap) {
						return Bootstrap.bootstrapApplication();
					},
					fastLaneData: function(initialData, FastLaneService, $transition$) {
						return FastLaneService.initialize($transition$.params());
					}
				}
			});
	});

angular.module('app')
	.controller('FastLaneController',
		function(
			$filter,
			$stateParams,
			$scope,
			$rootScope,
			$q,
			AppData,
			FeeService,
			LegacyCart,
			ExtraFlow,
			FastLaneService,
			Language,
			Utilities) {
			window.scrollTo(0, 0);

			// TODO: Push to locales.
			if (!Language.FastLane) {
				Language.FastLane = {};
				Language.FastLane.noKeywordErrorMsg = 'No keyword selected. Please select a keyword from the menu.'
				Language.FastLane.noDateSelected = 'Please select a date.'
				Language.FastLane.noDateAvailable = 'No dates available in the selected month.'
				Language.FastLane.maxQTYExceeded = 'You\'ve exceeded the maximum quantity.'
				Language.FastLane.numberOfPasses = 'Number of FAST LANE Passes'
				Language.FastLane.dateOfVisit = '<strong>Please select the date of your visit.</strong><br />Dates shown in gray are not available.'
				Language.FastLane.header = 'Speed past the lines on some of your favorite rides!'
				Language.FastLane.gold = 'Gold';
				Language.FastLane.silver = 'Silver';
				Language.FastLane.bronze = 'Bronze';
			}

			if (!Language.Alert.noFastLanePackagesErrorTitle) {
				Language.Alert.noFastLanePackagesErrorTitle = 'Missing Packages'
				Language.Alert.noFastLanePackagesErrorMsg = 'No fast lane packages were found. Click OK to view other packages.'
			}

			$scope.selectedDate = FastLaneService.selectedDate;

			//bindable object to base calendar currentMonthInfo
			$scope.currentMonthInfo = {
				currentMonth: new Date().getMonth() + 1,
				currentMonthObject: new Date()
			}

			var sortOrder = Utilities.childDefined(AppData, 'GetApplicationConsolidated.SETTINGS.fast_lane_sort_order')
				? AppData.GetApplicationConsolidated.SETTINGS.fast_lane_sort_order
				: 'A';

			var CALENDAR_VIEW = 1;
			var PACKAGE_VIEW = 2;

			var _packageList = AppData.GetMerchantPackageList.PS.P;
			var _calendarData = null;
			var _eventID = '';
			var _levels = ['bronze', 'gold', 'platinum'];

			$scope.view = CALENDAR_VIEW;
			$scope.quantity = 0;
			$scope.showFeeNotice = function getShowFeeNotice(pkg) {
				return FeeService.isPageActiveAndHasAdjustment(FeeService.enums.FAST_LANE, pkg.id);
			};
			$scope.errorMessage = '';
			$scope.filteredFastLaneItems = [];
			$scope.ready = false;
			$scope.headerClass = '';
			$scope.headerMsg = '';

			$scope.allowedDates = FastLaneService.allowedDates;
			$scope.keyword = FastLaneService.keyword;


			function InitializeCtrl() {
				getKeyword(FastLaneService.fastLanePackages);

				// Update the locale by replacing @@keyword with the keyword.
				$scope.numberOfPasses = Language.FastLane.numberOfPasses.replace(/@@keyword/g, $scope.label);
			}

			/**
			 * @param int direction Either 1 or -1, represents forward or previous month navigation
			 */
			$scope.handleMonthChanged = function(direction) {
				$scope.errorMessage = '';
				$scope.selectedDate = null;

				var datePromise = $q.defer();

				if (direction === 1) {
				// We're going to resolve the datePromise regardless
				// of whether the service request was successful or not

					var requestMonth;
					if (FastLaneService.lastMonth === -1) {
						requestMonth = new Date().getMonth() + 2;
					} else {
						requestMonth = $scope.currentMonthInfo.currentMonth;
					}

					FastLaneService.requestDates(requestMonth).then(
						function() {
							datePromise.resolve();
						},
						function() {
							$scope.errorMessage = Language.FastLane.noDateAvailable;
							datePromise.resolve();
						});
				} else {
				// do nothing if we're going back a month
					datePromise.resolve();
				}

				return datePromise.promise;
			}

			function getKeyword(pkgList) {
				if ($stateParams.keyword) {
				// Try getting the keyword from the URL.
					$scope.label = Utilities.getKeywordByUrl(AppData.GetApplicationConsolidated.TREE.MENUITEM, $stateParams.keyword);
					return;
				}

				if (!pkgList || pkgList.length == 0) {
				// No keyword or no packages.
					$scope.noKeywordErrorMsg = Language.FastLane.noKeywordErrorMsg;
				}

				return '';
			}

			function enableFirstDate() {
				var broke = false;
				for (var i = 0; i < _calendarData.rows.length; i++) {
					var row = _calendarData.rows[ i ];
					for (var j = 0; j < _calendarData.rows[ i ].length; j++) {
						if (!_calendarData.rows[ i ][ j ].disabled) {
							_calendarData.rows[ i ][ j ].isSelected = true;
							$scope.selectedDate = _calendarData.rows[ i ][ j ].date;
							broke = true;
						}

						if (broke) {
							break;
						}
					}

					if (broke) {
						break;
					}
				}
			}

			function toggleEnabledByDate(enabled, dateObj) {
			// Disables any date that does not meet the appropriate quantity.
				var dtObj = null;

				for (var i = 0; i < FastLaneService.allowedDates.length; i++) {
					dtObj = FastLaneService.allowedDates[i];
					if (dtObj == dateObj.getTime()) {
					// Reference the object directly rather than the reference. This will trigger
						// updates in the calendar view.
						// if(enabled) {

						// }
						// _calendarData.rows[ i ][ j ].disabled = !enabled;

						// // Reselects the previously selected item if it was disabled and then re-enabled.
						// if( _calendarData.rows[ i ][ j ].disabled ){
						// 	if( _calendarData.rows[ i ][ j ].isSelected ){
						// 		// This item was selected but now is disabled.
						// 		_calendarData.rows[ i ][ j ].prevSelected = true;
						// 		_calendarData.rows[ i ][ j ].isSelected = false;
						// 	} else {
						// 		_calendarData.rows[ i ][ j ].prevSelected = false;
						// 	}
						// } else if( _calendarData.rows[ i ][ j ].prevSelected ){
						// 	_calendarData.rows[ i ][ j ].isSelected = true;
						// }

						return;
					}
				}
			}

			function filterItemsByDate(pkgList) {
			// SAMPLE: D = date="2014-05-10" package_id="17827,17828,17844,17846"

				var filteredItems = [];
				var selectedMonth = String(Number($scope.selectedDate.getMonth() + 1));
				var selectedDay = String(Number($scope.selectedDate.getDate()));

				var dateString = String($scope.selectedDate.getFullYear());
				dateString += (selectedMonth.length == 1) ? '-0' + selectedMonth : '-' + selectedMonth;
				dateString += (selectedDay.length == 1) ? '-0' + selectedDay : '-' + selectedDay;

				var selectedDatePkgIDs =
				(function() {
					for (var i = 0; i < FastLaneService.dateResponse.length; i++) {
						if (FastLaneService.dateResponse[ i ].date == dateString) {
							return FastLaneService.dateResponse[ i ].package_id;
						}
					}
				})();

				selectedDatePkgIDs = selectedDatePkgIDs.split(' ').join().split(',');

				for (var i = 0; i < selectedDatePkgIDs.length; i++) {
					for (var j = 0; j < pkgList.length; j++) {
						if (pkgList[j].id === selectedDatePkgIDs[i]) {
							filteredItems.push(pkgList[j]);
						}
					}
				}

				return filteredItems;
			}

			function filterItemsByQuantity(pkgList) {
				var filteredItems = [];

				angular.forEach
				(
					pkgList,
					function(item, i) {
						var qtyList = item.CHARACS.fast_lane_qty;
						if (qtyList) {
							qtyList = qtyList.split(' ').join().split(',');
							angular.forEach
							(
								qtyList,
								function(qty, j) {
									if (Number(qty) == $scope.quantity) {
										filteredItems.push(item);
									}
								}
							);
						}
					}
				);

				return filteredItems;
			}

			$scope.disablePlus = function() {
			// Validate min/max qty.
				return (Utilities.forceInt($scope.quantity) >= FastLaneService.maxQuantity);
			};

			/**
			 * Fired by the <quantity> stepper (button click or typed-blur) for the
			 * pass quantity.
			 *
			 * @param {object} event the <quantity> on-change payload ({ qty, id, inputBlur, isDecrement, isIncrement }).
			 * @return {boolean} false, matching the pre-migration return value.
			 */
			$scope.onQtyChange = function(event) {
				$scope.quantity = Utilities.forceInt(event.qty);
				// Validate min/max qty.
				if ($scope.quantity > FastLaneService.maxQuantity) {
					$scope.quantity = FastLaneService.maxQuantity;
				}

				if ($scope.quantity < 0) {
					$scope.quantity = 0;
				}

				// Filter dates based on quantity.
				var available = 0;
				var dArr = null;
				var d = null;

				angular.forEach
				(
					FastLaneService.dateResponse,
					function(dateItem, i) {
						angular.forEach
						(
							dateItem.T,
							function(tItem, j) {
								// SAMPLE: dateItem.date = "2014-05-10"
								available = Number(tItem.capacity);
								dArr = dateItem.date.split('-');
								d = new Date(dArr[ 0 ], Number(dArr[ 1 ]) - 1, dArr[ 2 ]);
								if (available < $scope.quantity) {
									// Find the date in the calendar controller data model and disable it.
									toggleEnabledByDate(false, d);
								} else {
									// Find the date in the calendar controller data model and ensure the
									// date is enabled.
									toggleEnabledByDate(true, d);
								}
							}
						)
					}
				);

				return false;
			}

			$scope.addToCart = function(pkgItem) {
				var item =
				[
					{
						CHARACS:
							[
								{
									shop_google_sales_class_title: '',
									shop_rate_id: '',
									shop_rate_name: pkgItem.CT[ 0 ].name,
									event_id: _eventID,
									start_date: $filter('date')($scope.selectedDate, 'yyyy-MM-dd'),
									start_time: ''
								}
							],
							cart_limit_override: '',
							cusTypeName: pkgItem.CT[ 0 ].name,
							cusTypeRetail: pkgItem.CT[ 0 ].retail_amount,
							customer_type: pkgItem.CT[ 0 ].id,
							max_quantity: pkgItem.max_quantity,
							minRetailAmount: pkgItem.min_retail_amount,
							min_quantity: pkgItem.min_quantity,
							package_id: pkgItem.id,
							promo_code: (pkgItem.promo_code) ? pkgItem.promo_code : '',
							qty: $scope.quantity
					}
				];

				for (var i = 1; i < $scope.quantity; i++) {
					var charac = JSON.parse(JSON.stringify(item[ 0 ].CHARACS[ 0 ]));
					item[ 0 ].CHARACS.push(charac);
				}

				// Analytics - product click upon add to cart button being clicked
				$rootScope.$broadcast('triggerProductClick', item[0]);

				// Add reference of XFC to CHARACs.
				ExtraFlow.addReferenceToCartItems('fastLane', item, ExtraFlow.CLIENT_ALTERNATE_VIEW);
				ExtraFlow.addReferenceToCartItems('FastLaneModule', item, ExtraFlow.CLIENT_ALTERNATE_NAME);

				LegacyCart.addToCartWithReturnUrl(item, pkgItem, '/fastLane/' + $stateParams.keyword);
			}

			$scope.backBtnClicked = function() {
				$scope.view = CALENDAR_VIEW;
			}

			$scope.continueBtnClicked = function() {
			// Validate a date has been selected and qty is > 0.
				if (!$scope.selectedDate) {
				// Date not selected error.
					$scope.errorMessage = Language.FastLane.noDateSelected;
					return;
				}

				if ($scope.quantity <= 0 || $scope.quantity > FastLaneService.maxQuantity) {
				// Quantity error.
					$scope.errorMessage = Language.FastLane.maxQTYExceeded
					return;
				}

				// Reset error message.
				$scope.errorMessage = '';
				$scope.filteredFastLaneItems = filterItemsByDate(FastLaneService.fastLanePackages);
				$scope.filteredFastLaneItems = filterItemsByQuantity($scope.filteredFastLaneItems);

				// sortOrder = 'B'
				if (sortOrder.toUpperCase() == 'A') {
					$scope.filteredFastLaneItems.sort
					(
						function(a, b) {
							return Number(a.CT[ 0 ].retail_amount) - Number(b.CT[ 0 ].retail_amount);
						}
					);
				} else {
					$scope.filteredFastLaneItems.sort
					(
						function(a, b) {
							return Number(a.display_order) - Number(b.display_order);
						}
					);
				}

				// Leave up-to three items.
				$scope.filteredFastLaneItems.splice(3);

				for (var i = 0; i < $scope.filteredFastLaneItems.length; i++) {
					if (sortOrder.toUpperCase() == 'A') {
						$scope.filteredFastLaneItems[ i ].level = _levels[ i ];
					} else {
						$scope.filteredFastLaneItems[ i ].level = _levels[ $scope.filteredFastLaneItems.length - i ];
					}
				}

				// Analytics - product impressions after quantity and date are selected
				$rootScope.$broadcast('triggerImpressionsSells', $scope.filteredFastLaneItems, $scope.keyword);

				for (var x=0; x < $scope.filteredFastLaneItems.length; x++) {
					$rootScope.$broadcast('triggerProductDetails', $scope.filteredFastLaneItems[x]);
				}

				$scope.view = PACKAGE_VIEW;
			}

			$scope.$watch('selectedDate', function(newValue, oldValue) {
				if (angular.isUndefined(newValue)) {
					return;
				}
				//updatePackages(newValue);
			});

			InitializeCtrl();
	}

	)

angular.module('fast-lane')
	.service('FastLaneService', function(
		$log,
		$q,
		$state,
		$rootScope,
		$timeout,
		AppData,
		Language,
		PackageList,
		Utilities,
		Enums,
		Modal) {
		var requestListItems = [];
		var monthsRequested = [];

		var service = {
			fastLanePackages: [],
			allowedDates: [],
			dateResponse: [],
			keyword: undefined,
			selectedDate: undefined,
			maxQuantity: 0,
			lastMonth: -1
		};

		service.initialize = function(stateParams) {
			$log.info('Initializing Fast Lane Service');

			var initializePromise = $q.defer();

			// Reset local variables.
			service.reset();

			if (stateParams.keyword) {
				service.keyword = stateParams.keyword;
			}

			if (service.keyword) {
				requestListItems = PackageList.getRequestListItems(service.keyword);

				service.fastLanePackages = requestListItems.packages;
				service.maxQuantity = requestListItems.maxQuantity;
			}

			// This is a call to the back-end every time to get the latest dates
			// based on Fast Lane capacity defined in the package
			service.requestDates().then(function() {
				initializePromise.resolve();
			});

			return initializePromise.promise;
		};

		service.requestDates = function(month) {
			// Verify the request was not previously made for this date.
			// If so, load the dates from memory.

			var dateRequest = $q.defer();
			var requestMonth = -1;
			var pkgsList = [];
			var reqObj;
			var i;

			if (angular.isDefined(month)) {
				requestMonth = month;
			}

			for (i = 0; i < monthsRequested.length; i++) {
				if (monthsRequested[ i ] == requestMonth) {
					// immediate resolution if we have the date in cache
					$rootScope.hideSpinner();
					dateRequest.resolve();
					return dateRequest.promise;
				}
			}

			// Remember the months requested.
			monthsRequested.push(requestMonth);

			if ($rootScope.state.loaded === false) {
				$rootScope.setSpinnerMessage(Language.ApplicationLabels.gettingEventDates);
			} else {
				$rootScope.showSpinner(Language.ApplicationLabels.gettingEventDates);
			}

			requestListItems.packages.forEach(function iteratePackagesForRequeest(pkg) {
				var pkgItem = {
					CT: [],
					event_id: pkg.E[0].id,
					id: pkg.id
				};

				pkg.CT.forEach(function iterateCtForRequest(ct) {
					pkgItem.CT.push({
						id: ct.id,
						qty: 1
					});
				});

				pkgsList.push(pkgItem);
			});

			reqObj = {
				P: pkgsList,
				extraMovie: 'fast_lane',
				identifyCustomerTypes: '1',
				minCapacity: '1', //$scope.quantity
				month: requestMonth,
				version: '2'
			};

			AppData.fetch(
				'GetMerchantPackageEventDates',
				false,
				reqObj
			).then(
				function(data) {
					$rootScope.hideSpinner();

					if (!angular.isDefined(data.month)) {
						data.month = requestMonth;
					}

					// Make a copy of the object to manipulate.
					//var dataCopy = angular.copy(data);

					if (data.status == Enums.status.OK &&
						angular.isDefined(data.D)) {
						setFirstAvailableDate(data.D);
						processResponse(data.D);


						dateRequest.resolve();
					} else {
						dateRequest.reject();
					}

					service.lastMonth = parseInt(data.month);
				}
			)

			return dateRequest.promise;
		};

		service.reset = function() {
			service.allowedDates = [];
			service.fastLanePackages = [];
			service.allowedDates = [];
			service.dateResponse = [];
			service.keyword = undefined;
			service.selectedDate = undefined;
			service.maxQuantity = 0;
			service.lastMonth = -1;

			requestListItems = [];
			monthsRequested = [];
		};

		function processResponse(data) {
			for (var i = 0; i < data.length; i++) {
				var dateObject = data[i];

				service.allowedDates.push(Utilities.dateStringToObject(dateObject.date).getTime());
				service.dateResponse.push(dateObject);
			}
		}

		function setFirstAvailableDate(data) {
			service.selectedDate = Utilities.dateStringToObject(data[0].date);
		}

		return service;
	}
	);
"use strict";

angular.module('fast-lane')
	.directive
	(
		'fastLaneBannerDirective',
		function(AppData, JSONValidator, Language, Utilities, $rootScope) {
			var directive = {
				templateUrl: '/scripts/modules/fast-lane/views/banner.html',
				scope: { keyword: '=keyword' },
				link: function(scope, element, attrs, ngModelCtrl) {
				// Attempt to parse the config JSON string. If error, don't show the banner at all.
				// If no config at all, use the default value.
					var keyword = scope.keyword.replace(/ /g, '_').toLowerCase();
					scope.fastLaneBannerStyles = getConfigByKeyword(keyword);

					function getConfigByKeyword(keyword) {
					// Sample Config:
					// AppData.GetApplicationConsolidated.SETTINGS[ keyword + '_banner_styles' ] = '{"logoImage":"headerImage","bannerCopy":"header","bannerBackgroundColor":"#FF0C69","bannerBorderColor":"#3201FF"}';
						if (Utilities.safelyCheckPropertyOnObject('AppData.GetApplicationConsolidated.SETTINGS.' + keyword + '_banner_styles', AppData)) {
							try {
							// We have a config object. Use that to create the options for the banner.

								if (JSONValidator.validate('fast_lane_banner_styles', AppData.GetApplicationConsolidated.SETTINGS[ keyword + '_banner_styles' ])) {
									var obj = JSON.parse(AppData.GetApplicationConsolidated.SETTINGS[ keyword + '_banner_styles' ]);
									// Set the bannerCopy to the locale it references (i.e. bannerCopy and logoImage are references to the locale target in the FastLane section).
									obj.bannerCopy = Language.getLocale('FastLane', obj.bannerCopy);
									obj.logoImage = $rootScope.getAssetUrl(Language.getLocale('FastLane', obj.logoImage));

									return obj;
								} else {
									throw new Error('JSON Config ' + keyword + '_banner_styles is not set up correctly.');
								}
							} catch (e) {
								errorTracking.notify('Error Extracting Fast Lane Config', 'Failed to parse Fast Lane config. Ensure config is set up appropriately.');
							}
						}

						// We do not have a config. Use the default settings.
						return {
							logoImage: $rootScope.getAssetUrl(Language.getLocale('FastLane', 'headerImage')) || $rootScope.getAssetUrl('fast_lane_module.png'),
							bannerCopy: Language.getLocale('FastLane', 'header'),
							bannerBackgroundColor: '#450C69',
							bannerBorderColor: '#320152'
						};
					}
				}
			}

			return directive;
		}
	);

/**
 * Created by pMatthews on 1/21/2016.
 */
angular.module('fast-lane-wizard',
	['app'])
	.config(function($locationProvider, $stateProvider, ComponentLoaderEnums) {
		var components = [ComponentLoaderEnums.accessoCalendar, ComponentLoaderEnums.cartFeeNotice, ComponentLoaderEnums.estimatedSummary];

		$stateProvider
			.state('fastlanewizard', {
				url: '/fastlanewizard/:recommenderWizardKeyword/:keyword',
				title: 'fastLaneWizard',
				templateUrl: '/scripts/modules/fast-lane-wizard/views/fast-lane.html',
				controller: 'FastLaneWizardController',
				components: components,
				onEnter: showLoader,
				resolve: {
					initialData: initialData,
					lazyLoadAssets: lazyLoadAssets,
					routeGuard: function routeGuard(lazyLoadAssets, $q, $transition$, CustomActionService, RecommenderWizardContextService, RecommenderWizardRouteService, RecommenderWizardService, Utilities) {
						var stateParams = $transition$.params();
						if (RecommenderWizardContextService.bootstrapWizard(stateParams.recommenderWizardKeyword, 'fastlanewizard')
						   && RecommenderWizardService.wizardHasPackages()) {
							RecommenderWizardContextService.registerFastLane();
							if (Utilities.checkProp('admissionsPackage.CHARACS.skipAddlFastlaneWizard', RecommenderWizardService.wizardAdmissionsPackage(), 'getBoolean')) {
								CustomActionService.executeCustomAction('cancelSelectedPackages');
								$transition$.abort();

								return $q.reject();
							}

						} else {
							//we are in an invalid state - abort and go back to the top of the store
							RecommenderWizardRouteService.errorToFront(stateParams.recommenderWizardKeyword);
						}
						return true;
					},
					initialDisplayType: initialDisplayType,
					initialSelectedDate: initialSelectedDate,
					initialRawData: initialRawData,
					initialCalendarData: initialCalendarData,
					skipIfNoData: function(initialCalendarData, CustomActionService) {
						if (initialCalendarData.length < 1) {
							CustomActionService.executeCustomAction('cancelSelectedPackages');
						}
						return true;
					}
				}
			})
			.state('fastlanewizardstatic', {
				url: '/fastlanewizardstatic/:keyword',
				title: 'fastLaneWizard',
				templateUrl: '/scripts/modules/fast-lane-wizard/views/fast-lane.html',
				controller: 'FastLaneWizardController',
				components: components,
				onEnter: showLoader,
				resolve: {
					initialData: initialData,
					lazyLoadAssets: lazyLoadAssets,
					routeGuard: function routeGuard(lazyLoadAssets) {},
					initialDisplayType: initialDisplayType,
					initialSelectedDate: initialSelectedDate,
					initialRawData: initialRawData,
					initialCalendarData: initialCalendarData
				}
			});

			/**
			 * Shows a loader message
			 * @function
			 * @param {Scope} $rootScope - The Root scope
			 * @param {Service} Language - The Language service
			 * @returns {undefined}
			 * @ngInject
			 */
			function showLoader($rootScope, Language) {
				$rootScope.showSpinner(Language.getLocaleMerchant('ApplicationLabels', 'gettingEventDates'));
			}

			/**
			 * Bootstraps and loads the application
			 * @param {Service} Bootstrap - The Bootstrap service
			 * @returns {Promise} - The Bootstrap promise
			 * @ngInject
			 */
			function initialData(Bootstrap) {
				return Bootstrap.bootstrapApplication();
			}

			/**
			 * Loads in route's required assets
			 * @resolve
			 * @param {Resolve} initialData - The initialData resolve
			 * @param {Service} Utilities - The Utilities Service
			 * @returns {Promise} - The lazyload promise
			 * @ngInject
			 */
			function lazyLoadAssets(initialData, Utilities) {
				return Utilities.cacheBustAndLazyLoad([
					'/scripts/modules/fast-lane-wizard/controllers/fast-lane-wizard-controller.js',
					'/scripts/modules/fast-lane-wizard/controllers/fast-lane-wizard-pkg-directive-controller.js',
					'/scripts/modules/fast-lane-wizard/services/fast-lane-wizard-service.js',
					'/scripts/modules/fast-lane-wizard/fast-lane-wizard-pkg-directive.js',
					'/scripts/modules/fast-lane-wizard/fast-lane-wizard.css',
					'/scripts/directives/sticky-boi.js'
				]);
			}

			/**
			 * The initial display type the calendar should show as
			 * @resolve
			 * @param {Resolve} lazyLoadAssets - The lazyLoadAssets resolve
			 * @param {Service} $injector - The injector service
			 * @returns {String} The display type to display as
			 * @ngInject
			 */
			function initialDisplayType(routeGuard, $injector) {
				var AccessoCalendarEnums = $injector.get('AccessoCalendarEnums');

				return AccessoCalendarEnums.displayType.month;
			}

			/**
			 * Determines if there is a selected date or not
			 * @resolve
			 * @param {Resolve} initialDisplayType - The inititalDisplayType resolve
			 * @param {Service} CustomActionService - The custom action service
			 * @returns {Date|null} - The selected date, null otherwise
			 * @ngInject
			 */
			function initialSelectedDate(initialDisplayType, CustomActionService) {
				return CustomActionService.executeCustomAction('getSelectedDate') || null;
			}

			/**
			 * Requests the initial raw data
			 * @resolve
			 * @param {Date|null} initialSelectedDate - The initial selected date, if set
			 * @param {Resolve} initialDisplayType - The inititalDisplayType resolve
			 * @param {Service} $injector - The $injector service
			 * @param {Service} $transition$ - The Transition Service
			 * @returns {Object[]}
			 * @ngInject
			 */
			function initialRawData(initialSelectedDate, initialDisplayType, $injector, $transition$) {
				var FastLaneWizardService = $injector.get('FastLaneWizardService');

				// Was a previous day selected
				if (initialSelectedDate) {
					// search single day
					return FastLaneWizardService.requestDates($transition$.params().keyword, initialSelectedDate, initialSelectedDate, initialDisplayType);
				}

				return FastLaneWizardService.requestDates($transition$.params().keyword, null, null, initialDisplayType);
			}

			/**
			 * Determines the initial calendar data
			 * @resolve
			 * @param {Object} initialRawData - The initial raw data
			 * @param {Date|null} initialSelectedDate - The initial selected date, if set
			 * @param {Service} $injector - The $injector service
			 * @returns {Object[]} - The calendar data
			 * @ngInject
			 */
			function initialCalendarData(initialRawData, initialSelectedDate, $injector) {
				var AccessoCalendarDataService = $injector.get('AccessoCalendarDataService'),
					FastLaneWizardService = $injector.get('FastLaneWizardService');

				return AccessoCalendarDataService.normalizeDataFromResponse(initialRawData, FastLaneWizardService.getServiceRequest());
			}
	})
	.run(function(ExtraFlow) {
		ExtraFlow.registerXMC
		('FastLaneWizardModule',
			{
				name: 'FastLaneWizardModule',
				view: 'FastLaneWizard',
				doEditMode: false,
				lockQuantity: true,
				writeSingleCharac: false,
				enabled: true,
				type: 'alternateFlowModule',
				characsList: ['start_date', 'event_id']
			}
		);
		ExtraFlow.registerXMC
		('FastLaneWizardStaticModule',
			{
				name: 'FastLaneWizardStaticModule',
				view: 'fastlanewizardstatic',
				viewIsStateName: false,
				doEditMode: false,
				lockQuantity: true,
				writeSingleCharac: false,
				enabled: true,
				type: 'alternateFlowModule',
				characsList: ['start_date', 'event_id']
			}
		);
	});

(function() {
	'use strict';
	angular.module('date-time', ['app', 'components', 'ui.bootstrap'])
		.constant('DateTimeRoutes', {
			CAPACITY: 'dateTime.capacity',
			DATE_BY_DAY: 'dateTime.dateByDay',
			DATE_BY_DAY_SINGLE: 'dateTime.dateByDaySingle',
			DATETIME: 'dateTime.default',
			TIME_BY_DAY: 'dateTime.timeByDay',
			TIME_BY_DAY_SINGLE: 'dateTime.timeByDaySingle'
		})
		.config(function($stateProvider, ComponentLoaderEnums, DateTimeRoutes) {
			var DATE_TIME_CONTROLLER = 'DateTimeController';

			var components = [ComponentLoaderEnums.accessoCalendar, ComponentLoaderEnums.cartFeeNotice];

			$stateProvider
				.state('dateTime', {
					abstract: true,
					components: components,
					resolve: {
						initialData: initialData,
						lazyLoadAssets: lazyLoadAssets,
						xfcMap: xfcMap,
						routeGuard: routeGuard,
						usePrevSelDate: usePrevSelDate,
						initialStartDate: initialStartDate,
						initialDisplayType: initialDisplayType,
						initialModelData: initialModelData,
						initialCalendarData: initialCalendarData,
						dynamicPricing: dynamicPricing
					}
				})
				.state(DateTimeRoutes.DATETIME, {
					controller: DATE_TIME_CONTROLLER,
					url: '/dateTime/:packageId',
					templateProvider: templateProviderAll
				})
				.state(DateTimeRoutes.CAPACITY, {
					controller: DATE_TIME_CONTROLLER,
					url: '/dateTimeCapacity/:packageId',
					templateProvider: function templateProvider($templateCache, CartService, Package, Utilities) {
						var firstItemCharacs = Utilities.checkProp('itemsToBeAdded[].0.CHARACS[].0', Package.itemsToBeAdded, 'returnValue') || {};
						var useExistingDate = Utilities.checkProp('characs.useExistingDate', firstItemCharacs, 'getBoolean');

						// If we have a date already, use time only, otherwise datetime
						return $templateCache.get(
							(
								(
									Utilities.checkProp('characs.start_date', firstItemCharacs, 'isDateString')
									&& (
										Package.isForwardExtraFlowRouting()
										|| Utilities.checkProp('characs.client_alternate_view', firstItemCharacs, 'validString')
									)
								)
								|| (useExistingDate && CartService.getLastDate() && Utilities.checkProp('itemsToBeAdded[].0.CHARACS[].0.crosssell', Package.itemsToBeAdded, 'getBoolean'))
							)
								? 'date-time:time'
								: 'date-time:date-time'
						);
					}
				})
				.state(DateTimeRoutes.TIME_BY_DAY, {
					controller: DATE_TIME_CONTROLLER,
					url: '/dateTimeByDay/:packageId',
					templateProvider: templateProviderAll
				})
				.state(DateTimeRoutes.TIME_BY_DAY_SINGLE, {
					controller: DATE_TIME_CONTROLLER,
					url: '/dateTimeByDaySingle/:packageId',
					templateProvider: templateProviderAll
				})
				.state(DateTimeRoutes.DATE_BY_DAY, {
					controller: DATE_TIME_CONTROLLER,
					url: '/dateByDay/:packageId',
					templateProvider: templateProviderAll
				})
				.state(DateTimeRoutes.DATE_BY_DAY_SINGLE, {
					controller: DATE_TIME_CONTROLLER,
					url: '/dateByDaySingle/:packageId',
					templateProvider: templateProviderAll
				})


			/**
			 * The initialData resolve
			 * @resolve
			 * @function
			 * @param {Service} Bootstrap - The Bootstrap Service
			 * @returns {Promise} - The bootstrap application promise
			 * @ngInject
			 */
			function initialData(Bootstrap) {
				return Bootstrap.bootstrapApplication();
			}

			/**
			 * Lazy Loads Datetime files in
			 * @param {Resolve} initialData - The Package Resolve
			 * @param {Service} BundleService - The Bundle Service
			 * @returns {Promise} - The Lazy Load Promise
			 * @ngInject
			 */
			function lazyLoadAssets(initialData, BundleService) {
				return BundleService.lazyLoadCollectionFiles(BundleService.enums.DATE_TIME);
			}

			/**
			 * Builds the Package XFC Map
			 * @resolve
			 * @function
			 * @param {Resolve} lazyLoadAssets - The Package Resolve
			 * @param {Service} Package - The Bootstrap Service
			 * @returns {Promise} - The Package XFC Map promise
			 * @ngInject
			 */
			function xfcMap(lazyLoadAssets, Package) {
				return Package.buildXFCMap();
			}

			function routeGuard(xfcMap, $q, $transition$, ExtraFlow, Package, StandardFlowInitiatorService, Utilities) {
				var items;

				if (
					!Package.initXFC()
					|| (StandardFlowInitiatorService.currentStandardFlowType === 'alternateEntry' && !Package.isForwardExtraFlowRouting())
				) {
					$transition$.abort();

					Utilities.goTo(
						StandardFlowInitiatorService.alternateEntryState || '/packageDetails/:packageId',
						StandardFlowInitiatorService.alternateEntryParams || $transition$.params()
					);

					return $q.reject();
				} else if (
					Package.itemsToBeAdded &&
					(items = Package.itemsToBeAddedForCurrentPackage()).some(function(item) {
						return item.CHARACS &&
							item.CHARACS[0] &&
							item.CHARACS[0].unified_package_details === '1';
					})
				) {
					// Flow originates from unified-package-details — movie selection is already
					// handled upstream. Skip this XFC entirely using the same pattern as the
					// isForwardExtraFlowRouting skip below.
					// items is already set by the (items = …).some(…) assignment above.

					if (Utilities.checkProp('Package.packageDetails.E.id', Package)) {
						items.forEach(function iterateItems(item) {
							item.CHARACS.forEach(function iterateCharacs(charac) {
								if (!charac.event_id) {
									charac.event_id = Package.packageDetails.E.id;
								}
							});
						});
					}

					ExtraFlow.addReferenceToCartItems(Package.settings.view, items, ExtraFlow.CLIENT_XFC_VIEW);
					ExtraFlow.addReferenceToCartItems(Package.settings.name, items, ExtraFlow.CLIENT_XFC_NAME);

					$transition$.abort();
					// nextXFC is safe when this is the last XFC in the chain: PackageService.js
					// guards on `currentXFC < packageXFCs.length` before calling setupXFC; the
					// else branch calls xfcFinalCallback() so the flow proceeds to cart/checkout.
					Package.nextXFC(true);

					return $q.reject();
				} else if (Package.isForwardExtraFlowRouting() && Package.hasFlowType('date')) {
					// if both date and time have been added, we can skip this XFC
					if (!/time/i.test(Package.settings.name) || Package.hasFlowType('time')) {
						// Ensure that the item characs have the event id added as a charac.
						if (Utilities.checkProp('Package.packageDetails.E.id', Package)) {
							items = Package.itemsToBeAddedForCurrentPackage();

							items.forEach(function iterateItems(item) {
								item.CHARACS.forEach(function iterateCharacs(charac) {
									if (!charac.event_id) {
										charac.event_id = Package.packageDetails.E.id;
									}
								});
							});
						}

						// Add reference of XFC to CHARACs.
						ExtraFlow.addReferenceToCartItems(Package.settings.view, items, ExtraFlow.CLIENT_XFC_VIEW);
						ExtraFlow.addReferenceToCartItems(Package.settings.name, items, ExtraFlow.CLIENT_XFC_NAME);

						$transition$.abort();

						Package.nextXFC(true);

						return $q.reject();
					}
				}
			}

			/**
			 * If we should use the previous selected date
			 * @resolve
			 * @param {Resolve} routeGuard - The routeGuard resolve
			 * @param {Service} CartService - The Cart Service
			 * @param {Service} Package - The Package service
			 * @param {Service} Utilities - The Utilities service
			 * @returns {Boolean} If we should use the previous selected date
			 * @ngInject
			 */
			function usePrevSelDate(routeGuard, CartService, Package, Utilities) {
				var packageDetailsCharacs = Package.getCurrentPackageCharacs() || {};
				return Utilities.checkProp('Package.itemsToBeAdded[].0.CHARACS[].0.start_date', Package, 'isDateString')
					|| (CartService.getLastDate() && Utilities.checkProp('itemsToBeAdded[].0.CHARACS[].0.crosssell', Package.itemsToBeAdded, 'getBoolean') && Utilities.getBoolean(packageDetailsCharacs.useExistingDate));
			}


			/**
			 * Determines the initial start date
			 * @resolve
			 * @param {Boolean} usePrevSelDate - If we should use the previous selected date
			 * @param {Service} $injector - The $injector service
			 * @param {Service} CartService - The Cart Service
			 * @param {Service} DynamicCapacityPricingService - The Dynamic Capacity Pricing Service
			 * @param {Service} Package - The Package Service
			 * @param {Service} Utilities - The Utilities Service
			 * @returns {Date} - The initial start date
			 * @ngInject
			 */
			function initialStartDate(usePrevSelDate, $injector, CartService, DynamicCapacityPricingService, Package, Utilities) {
				var AccessoCalendarService = $injector.get('AccessoCalendarService');
				if (DynamicCapacityPricingService.isPackageDynamic(Package.packageDetails.id)) {
					return AccessoCalendarService.createDate(Package.itemsToBeAdded[0].CHARACS[0].start_date);
					// If we're in a cross-sell
				} else if (usePrevSelDate) {
					// we're in a cross-sell flow, and the customer has already selected a date
					return AccessoCalendarService.createDate(Utilities.checkProp('Package.itemsToBeAdded[].0.CHARACS[].0.start_date', Package, 'isDateString') ? Package.itemsToBeAdded[0].CHARACS[0].start_date : CartService.getLastDate());
				}

				return AccessoCalendarService.getValidPackageFirstAvailableDate(AccessoCalendarService.createDate(), Package.packageDetails.id);
			}

			/**
			 * Determines the initial display type
			 * @resolve
			 * @param {Date} initialStartDate - The initialStartDate
			 * @param {Service} $injector - The $injector service
			 * @param {Service} Enums - The Enums service
			 * @param {Service} Package - The Package service
			 * @param {Service} Utilities - The Utilities service
			 * @param {Service} Viewport - The Viewport service
			 * @returns {String} The display type
			 * @ngInject
			 */
			function initialDisplayType(initialStartDate, $injector, Enums, Package, Utilities, Viewport) {
				var AccessoCalendarEnums = $injector.get('AccessoCalendarEnums');
				var isDateOnly = !Package.settings.showTimeList || Utilities.first(Package.packageDetails.E).date !== Enums.packageEventType.DATE_TIME_EVENT;

				return Viewport.api.isMobile && !isDateOnly ? AccessoCalendarEnums.displayType.week : AccessoCalendarEnums.displayType.month;
			}

			/**
			 * Fetches the initial calendar data
			 * @resolve
			 * @param {String} initialDisplayType - The initial display type
			 * @param {Date} initialStartDate - The initial start date
			 * @param {Boolean} usePrevSelDate - If we should use the previous selected date
			 * @param {Service} $injector - The $injector service
			 * @param {Service} $q - The $q service
			 * @param {Scope} $rootScope - The $rootScope
			 * @param {Service} Package - The Package service
			 * @returns {Promise} - A promise that will resolve the calendar data
			 * @ngInject
			 */
			function initialModelData(
				initialDisplayType,
				initialStartDate,
				usePrevSelDate,
				$injector,
				$rootScope,
				Package,
				Utilities
			) {
				var AccessoCalendarService = $injector.get('AccessoCalendarService'),
					DateTimeService = $injector.get('DateTimeService');

				var endDate,
					range = Math.max(Utilities.checkProp('packageDetails.CHARACS.date_range', Package.packageDetails, 'forceInt'), 1),
					startDate = initialStartDate;

				if (usePrevSelDate && Package.isForwardExtraFlowRouting()) {
					// BE cannot have the startDate equal endDate, increment endDate by 1
					endDate = AccessoCalendarService.createDate(initialStartDate);
					endDate.setDate(endDate.getDate() + 1);
				} else {
					startDate = AccessoCalendarService.getStartDate(initialStartDate, initialDisplayType);
					endDate = AccessoCalendarService.getEndDate(initialStartDate, initialDisplayType, range);
				}

				$rootScope.showSpinner();

				return DateTimeService.requestDates(startDate, endDate, initialDisplayType);
			}

			/**
			 * Normalizes the date data for consumption by the calendar
			 * @param {Resolve} initialModelData - The initial model data
			 * @param {Date} initialStartDate - The initial start date
			 * @param {Boolean} usePrevSelDate - If we should use the previous selected date
			 * @param {Service} $injector - The $injector service
			 * @returns {Object[]} - The initial calendar data
			 * @ngInject
			 */
			function initialCalendarData(initialModelData, initialStartDate, usePrevSelDate, $injector, Package) {
				var AccessoCalendarService = $injector.get('AccessoCalendarService'),
					DateTimeService = $injector.get('DateTimeService');

				var calendarData = DateTimeService.normalizeDataForCalendar(initialModelData);

				if (usePrevSelDate && Package.isForwardExtraFlowRouting()) {
					calendarData = calendarData.filter(function filterCalendarData(dt) {
						return AccessoCalendarService.getDifferenceData(initialStartDate, dt.date).days === 0;
					});
				}

				return calendarData;
			}

			/**
			 * Grabs and lazy loads dynamic pricing values
			 * @resolve
			 * @param {Resolve} initialModelData - The initial model data
			 * @param {Date} initialStartDate - The initial start date
			 * @param {Service} $injector - The $injector service
			 * @returns {Object} - The dynamic pricing object
			 * @ngInject
			 */
			function dynamicPricing(initialModelData, initialStartDate, $injector) {
				var DateTimeService = $injector.get('DateTimeService');

				return DateTimeService.fetchDynamicPricing(initialModelData, initialStartDate);
			}

			/**
			 * Determines which template to load.
			 * This checks all scenarios and date/datetime/time are all possible options
			 * @provider
			 * @param {Service} $templateCache - The template cache service
			 * @param {Service} CartService - The Cart Service
			 * @param {Service} Enums - The Enums Service
			 * @param {Service} Package - The Package Service
			 * @param {Service} Utilities - The Utilities Service
			 * @ngInject
			 */
			function templateProviderAll($templateCache, CartService, Enums, Package, Utilities) {
				var firstItemCharacs = Utilities.checkProp('itemsToBeAdded[].0.CHARACS[].0', Package.itemsToBeAdded, 'returnValue') || {};
				var useExistingDate = Utilities.checkProp('characs.useExistingDate', firstItemCharacs, 'getBoolean');
				var timeTemplate = 'date-time:date-time';

				/*
				 * If the package has a pre-existing date
				 * -- AND is 1) a forward flow OR 2) has a client_alternate_view charac
				 * OR
				 * If the package is a cross-sell package with a date already recorded by the cart service
				 */
				if (
					(
						Utilities.checkProp('characs.start_date', firstItemCharacs, 'isDateString')
						&& (
							Package.isForwardExtraFlowRouting()
							|| Utilities.checkProp('characs.client_alternate_view', firstItemCharacs, 'validString')
						)
					)
					|| (useExistingDate && CartService.getLastDate() && Utilities.checkProp('characs.crosssell', firstItemCharacs, 'getBoolean'))
				) {
					// Set as Time Only
					timeTemplate = 'date-time:time';
				}

				// If the package is a date-only package, use the date template, otherwise the determined time package
				return $templateCache.get(
					(!Package.settings.showTimeList || Utilities.first(Package.packageDetails.E).date !== Enums.packageEventType.DATE_TIME_EVENT)
						? 'date-time:date'
						: timeTemplate
				);
			}
		});
})();

angular.module('interstitial-dining', ['app'])
	.config(function ($locationProvider, $stateProvider, InterstitialDiningConstants) {

		$stateProvider
			.state( InterstitialDiningConstants.CHOICE_STATE, {
				url: '/interstitial-dining-choice/:flowType/:packageId',
				templateUrl: '/scripts/modules/extraflow/interstitial-dining/views/choice.html',
				controller: 'InterstitialDiningController',
				resolve: {
					//resolve failures are handled within run.js of main app
					initialData: function(Bootstrap) {
						return Bootstrap.bootstrapApplication();
					},
					xfcMap: function( initialData, Package ){
						return Package.buildXFCMap();
					},
					interstitialData: function(initialData, $transition$, InterstitialDiningService) {
						return InterstitialDiningService.initialize($transition$.params());
					}
				}
			})
			.state( InterstitialDiningConstants.ASSIGNMENT_STATE,{
				url: '/interstitial-dining-assignment/:flowType/:packageId',
				controller: 'InterstitialDiningController',
				templateUrl: '/scripts/modules/extraflow/interstitial-dining/views/assignment.html',
				resolve: {
					//resolve failures are handled within run.js of main app
					initialData: function(Bootstrap) {
						return Bootstrap.bootstrapApplication();
					},
					xfcMap: function( initialData, Package ){
						return Package.buildXFCMap();
					},
					interstitialData: function(initialData, $transition$, InterstitialDiningService) {
						return InterstitialDiningService.initialize($transition$.params());
					}
				}
			})
			.state( InterstitialDiningConstants.OPTIN_STATE, {
				url: '/interstitial-optin/:packageId',
				controller: 'InterstitialOptinController',
				templateUrl: '/scripts/modules/extraflow/interstitial-dining/views/choice.html',
				resolve: {
					initialData: function(Bootstrap) {
						return Bootstrap.bootstrapApplication();
					},
					xfcMap: function( initialData, Package ){
						return Package.buildXFCMap();
					},
					initXFC: function(xfcMap,RouteRejectionService,Package){

						var rejectionRoute = Package.assessRoutabilityOfXFC();

						if( rejectionRoute.length > 0 ){

							throw new RouteRejectionService.UnrecoverableException(rejectionRoute);
						}
						else{

							return true;
						}
					}
				}
			});
	})
	.run(function(ExtraFlow, InterstitialDiningConstants) {

		// Register this extra flow alternate module with the extra flow service
		ExtraFlow.registerXMC
		( InterstitialDiningConstants.OPTIN_STATE,
			{
				name: InterstitialDiningConstants.OPTIN_STATE,
				view: InterstitialDiningConstants.OPTIN_STATE,
				viewIsStateName:true,
				doEditMode: true,
				writeSingleCharac: false,
				enabled: true,
				type: 'extraFlowControl'
			}
		);
	});

angular.module('interstitial-dining')
	.constant('InterstitialDiningConstants', {
		'CHOICE_CHARAC': 'FORCEALL',
		'CHOICE_STATE': 'interstitial-dining-choice',
		'SELECTION_CHARAC': 'SELECTION',
		'ASSIGNMENT_STATE': 'interstitial-dining-assignment',
		'OPTIN_STATE': 'interstitial_optin'
	});
angular.module('interstitial-dining')
	.controller('InterstitialDiningController', function(
		$log,
		$filter,
		$state,
		$stateParams,
		$scope,
		$rootScope,
		$window,
		AppData,
		Package,
		ClientInfo,
		Utilities,
		Language,
		InterstitialDiningService,
		InterstitialDiningConstants,
		AnalyticsDataLayerService
		) {

		$scope.totalDiningPasses = 0;
        $scope.viewSwapped = false;


		function initialize() {

			if($state.current.name.indexOf(InterstitialDiningConstants.CHOICE_STATE) > -1) {
				setImage();
			}else if($state.current.name.indexOf(InterstitialDiningConstants.ASSIGNMENT_STATE) > -1) {
				setCheckboxState();
				setupPassholderMap();
			}

			$scope.diningPackage = InterstitialDiningService.diningPackage;
			setText();

			$rootScope.$broadcast('triggerImpressionsSells', [$scope.diningPackage], 'Interstitial Dining');
			$rootScope.$broadcast('triggerProductDetails', $scope.diningPackage);
		};

		initialize();

		function setText() {

			// the button text will depend on the type of flow we're using
			var languageSection = 'InterstitialDining' + InterstitialDiningService.flowType.toUpperCase();

			var yesText = Language.getLocale( languageSection, 'yesButton' );

			var priceReplacement = $filter('currencyFormatter') (InterstitialDiningService.diningPackage.CT[0].retail_amount );

			// perform price replacements
			yesText = Language.replaceAll( '@@price', priceReplacement, yesText);

			var suffix;
			if( InterstitialDiningService.flowType === 'a' ) {

				// if we're a membership
				if( angular.isDefined( Package.packageDetails.CHARACS.package_type ) && Package.packageDetails.CHARACS.package_type.toLowerCase() === 'membership' ){
					suffix = Language.getLocale('InterstitialDining', 'perMonthLabel');
				}else{
					// assume we're a season pass
					suffix = Language.getLocale('InterstitialDining', 'perPassLabel');
				}


			}else{

				// if we're a membership
				if( angular.isDefined( Package.packageDetails.CHARACS.package_type ) && Package.packageDetails.CHARACS.package_type.toLowerCase() === 'membership' ){
					suffix = Language.getLocale('InterstitialDining', 'perMonthLabel');
				}else{
					// assume we're a season pass
					suffix = Language.getLocale('InterstitialDining', 'perPassLabel');
				}

				// could probably use replaceAllMultiple here...
				$scope.packageInformationLabel = Language.replaceAllMultiple(
					['@@suffix', '@@price', '@@packageName'],
					[suffix, priceReplacement, $scope.diningPackage.name],
					Language.getLocale('InterstitialDiningB', 'packageInformation'));

				$scope.assignmentHeadline = Language.replaceAllMultiple(
					['@@suffix', '@@price', '@@packageName'],
					[suffix, priceReplacement, $scope.diningPackage.name],
					Language.getLocale('InterstitialDiningB', 'assignmentHeadline'));

			}

			yesText = Language.replaceAll('@@suffix', suffix, yesText);

			$scope.yesText = yesText;
			$scope.noText = Language.getLocale( languageSection, 'noButton' );

		}

		function setImage() {

			if(ClientInfo.deviceType === 'mobile') {
				$scope.isMobile = true;

				if (angular.isUndefined(Package.packageDetails.CHARACS.interstitial_dining_image_mobile)) {
					$log.error('No interstitial dining mobile image defined!');
				} else {
					$scope.packageImage = $rootScope.getAssetUrl(Package.packageDetails.CHARACS.interstitial_dining_image_mobile);
				}
			}else{
				$scope.isMobile = false;

				if( angular.isUndefined(Package.packageDetails.CHARACS.interstitial_dining_image)) {
					$log.error('No interstitial dining desktop image defined!');
				} else {
					$scope.packageImage = $rootScope.getAssetUrl(Package.packageDetails.CHARACS.interstitial_dining_image);
				}
			}

		}

		function setCheckboxState() {

			$scope.defaultToChecked = true;

			// look to the app config
			if(angular.isUndefined(AppData.GetApplicationConsolidated.SETTINGS.interstitial_dining_default_checked)) {
				$log.info('interstitial_dining_default_checked app config not defined');
			}else{
				$scope.defaultToChecked = Utilities.getBoolean(AppData.GetApplicationConsolidated.SETTINGS.interstitial_dining_default_checked);
			}

		}

		function setupPassholderMap() {
			InterstitialDiningService.createPassholderMap();

			InterstitialDiningService.passholders.forEach(function(item) {
				item.addDining = $scope.defaultToChecked;
			});
			$scope.passholders = InterstitialDiningService.passholders;

			if($scope.defaultToChecked) {
				$scope.totalDiningPasses = angular.copy(InterstitialDiningService.passholders.length);
				pushRatioToDataLayer();
			}
		}

		function pushRatioToDataLayer() {
			var ratio = parseFloat($scope.totalDiningPasses / InterstitialDiningService.passholders.length).toFixed(2) * 100;
			$log.info('Calculated ratio: ' + ratio);
			AnalyticsDataLayerService.pushToDataLayer({"interstitialDiningAssignmentRatio": ratio});
		}

		$scope.updatePassholderSelection = function(passholder) {

			if(passholder.addDining) {
				$scope.totalDiningPasses++;
			}else{
				$scope.totalDiningPasses--;
			}

			pushRatioToDataLayer();
		}

        $scope.swapView = function () {
            if ($scope.viewSwapped == false) {
                $scope.viewSwapped = true;
            } else {
                $scope.viewSwapped = false;
            }
        }

		$scope.proceed = function() {

			if(InterstitialDiningService.flowType === 'a') {
				InterstitialDiningService.addDiningToPasses();
			}else if(InterstitialDiningService.flowType === 'b') {
				// proceed to the next state
				return $scope.routeTo( $state.href( InterstitialDiningService.routePrefix + InterstitialDiningConstants.ASSIGNMENT_STATE, { flowType: $stateParams.flowType, packageId: $stateParams.packageId}));
			}
		}

		$scope.proceedWithSelections = function() {
			InterstitialDiningService.addDiningToSelections();
		}

		$scope.cancel = function() {
			Package.nextXFC();
		}

		$scope.back = function () {
			$window.history.back();
		}


	});

"use strict";

angular.module('interstitial-dining')
	.service('InterstitialDiningService', function(
		$rootScope,
		$log,
		$state,
		$q,
		AppData,
		LegacyCart,
		Utilities,
		Package,
		Enums,
		ExtraFlow,
		InterstitialDiningConstants,
		AnalyticsDataLayerService
	) {


		var service = {
			flowType: 'a',
			diningPackage: undefined,
			routePrefix: '',
			passholders: []
		};

		service.initialize = function(stateParams,routePrefix) {

			var rejectionRoute= Package.assessRoutabilityOfXFC();
			if (rejectionRoute.length > 0) {
				// Return a failed promise, Package service is not initialized
				var rejection = $q.defer();
				rejection.reject({
					redirect: rejectionRoute
				});

				return rejection.promise;
			}

			reset();

			service.flowType = stateParams.flowType;
			service.routePrefix = angular.isDefined(routePrefix)? routePrefix: '';
			return true;
		}

		function reset() {
			service.flowType = 'a';
			//service.diningPackage = undefined;
			service.passholders = [];
		}

		service.determineFlowType = function() {

			if (angular.isUndefined(Package.packageDetails.CHARACS.interstitial_dining_type)) {
				$log.error('interstitial_dining_type CHARAC MISSING!');
				return;
			}

			var type = Package.packageDetails.CHARACS.interstitial_dining_type.toLowerCase();

			if (type === 'a' || type === 'b') {
				return type;
			} else {
				$log.error('Incorrectly configured interstitial_dining_type charac');
				return;
			}
		}

		service.determineEligibility = function(diningPackageId) {

			var moduleEligibility = true;

			// if the dining pass exists in Package.itemsToBeAdded, we
			// will skip this flow.
			for (var i = 0; i < Package.itemsToBeAdded.length; i++) {
				if (Package.itemsToBeAdded[i].package_id === diningPackageId) {
					moduleEligibility = false;
					break;
				}
			}

			// Should NOT look in the cart
			// for (var i = 0; i < LegacyCart.cartItems.length; i++) {
			// 	if (LegacyCart.cartItems[i].package_id === diningPackageId) {
			// 		moduleEligibility = false;
			// 		break;
			// 	}
			// }

			return moduleEligibility;
		}

		service.addDiningToPasses = function() {

			var diningPackages = [];

			for (var i = 0; i < Package.itemsToBeAdded.length; i++) {
				var pkg = Package.itemsToBeAdded[i];

				if (angular.isUndefined(pkg.CHARACS[0].isSeasonPass) ||
					!pkg.CHARACS[0].isSeasonPass) {
					continue;
				}

				// do we need to be filtering by XFC here?
				diningPackages.push(createDiningPackageForCart(pkg.CHARACS[0]));
			}

			finalizePackages(diningPackages);
		}

		service.addDiningToSelections = function() {

			var diningPackages = [];

			for (var i = 0; i < service.passholders.length; i++) {

				var pass = service.passholders[i];

				if (pass.addDining) {
					diningPackages.push(createDiningPackageForCart(pass.CHARACS[0]));
				}
			}

			finalizePackages(diningPackages);
		}

		function finalizePackages(diningPackages) {

			diningPackages.forEach(function(item) {
				Package.itemsToBeAdded.push(item);
			});

			Package.nextXFC();
		}

		function createDiningPackageForCart(packageCharacs) {
			var diningPackageToAdd = {
				customer_type: service.diningPackage.CT[0].id,
				package_id: service.diningPackage.id,
				qty: 1
			}

			diningPackageToAdd.CHARACS = [{}];

			if (angular.isDefined(service.diningPackage.CHARACS)) {
				diningPackageToAdd.CHARACS = [angular.copy(service.diningPackage.CHARACS)];
			}

			if (angular.isDefined(packageCharacs.group_uuid)) {
				diningPackageToAdd.CHARACS[0].group_uuid = packageCharacs.group_uuid;
			}

			// Analytics - product click for selected interstitial dining packages
			$rootScope.$broadcast('triggerProductClick', diningPackageToAdd);

			return diningPackageToAdd;
	}

		service.createPassholderMap = function() {
			for (var i = 0; i < Package.itemsToBeAdded.length; i++) {
				var pkg = Package.itemsToBeAdded[i];

				if (angular.isUndefined(pkg.CHARACS[0].isSeasonPass) ||
					!pkg.CHARACS[0].isSeasonPass) {
					continue;
				}

				service.passholders.push(angular.copy(pkg));
			}
		}

		service.getInterstitialDiningFlowTypeForPkg =function(pkg){

			var flowType = undefined;
			if(Utilities.safelyCheckPropertyOnObject('pkg.CHARACS.interstitial_dining_keyword', pkg)){
				// yes, let's go! but which one

				var interstitialDiningKeyword = pkg.CHARACS.interstitial_dining_keyword;

				// if a package exists, then go to the interstitial dining module

				var interstitialPackage = Package.filterPackagesByKeyword(AppData.GetMerchantPackageList.PS.P, interstitialDiningKeyword);

				if( interstitialPackage.length !== 0 &&
					service.determineEligibility(interstitialPackage[0].id)){

					if(Utilities.safelyCheckPropertyOnObject('pkg.CHARACS.interstitial_dining_type',pkg,function(diningType){
							return diningType === 'a' || diningType === 'b';
						})){

						service.diningPackage = interstitialPackage[0];
						flowType = pkg.CHARACS.interstitial_dining_type;
					}
				}
			}

			return flowType;

		}

		return service;


	});

/*
 * Created by Michael Yuen on 6/15/16
 */
'use strict';
angular.module( 'interstitial-dining' )
	.controller( 'InterstitialOptinController', InterstitialOptinController );

function InterstitialOptinController(
	$scope,
	$state,
	InterstitialService,
	ExtraFlow,
	Package
){

	/*********************/
	/*  PUBLIC VARIABLES */
	/*********************/
	$scope.interstitial = {
		name: undefined,
		locales: {
			heading: undefined,
			subheading: undefined,
			footnote: undefined,
			// Below here are the locales used for the swappedView
			header1: undefined,
			description1: undefined,
			header2: undefined,
			description2: undefined,
			header3: undefined,
			description3: undefined,
			header4: undefined,
			description4: undefined,
			}
	};
	$scope.packageImage = undefined;
	$scope.viewSwapped  = undefined;

	// Locales
	$scope.yesText      = undefined;
	$scope.noText       = undefined;

	/*********************/
	/*  PUBLIC METHODS   */
	/*********************/
	$scope.swapView = swapView;
	$scope.cancel   = cancel;
	$scope.proceed  = proceed;
	$scope.back     = back;

	// Kick things off
	initialize();

	/*********************/
	/*  PUBLIC METHODS   */
	/*********************/
	function swapView(){

		$scope.viewSwapped = !$scope.viewSwapped;
	};

	function cancel(){

		InterstitialService.updateCharac( 'optout' );
		ExtraFlow.addReferenceToCartItems(Package.settings.view, Package.itemsToBeAdded, ExtraFlow.CLIENT_XFC_VIEW);
		ExtraFlow.addReferenceToCartItems(Package.settings.name, Package.itemsToBeAdded, ExtraFlow.CLIENT_XFC_NAME);
		Package.nextXFC();
	};

	function proceed(){

		InterstitialService.updateCharac( 'optin' );
		ExtraFlow.addReferenceToCartItems(Package.settings.view, Package.itemsToBeAdded, ExtraFlow.CLIENT_XFC_VIEW);
		ExtraFlow.addReferenceToCartItems(Package.settings.name, Package.itemsToBeAdded, ExtraFlow.CLIENT_XFC_NAME);
		Package.nextXFC();
	};

	function back(){

		Package.cancelXFC();
	};

	/*********************/
	/* PRIVATE FUNCTIONS */
	/*********************/
	function initialize(){

		$scope.interstitial.name = $state.current.name;
		InterstitialService.buildConfig( $scope.interstitial.name );
		$scope.packageImage = InterstitialService.getImage();
		$scope.viewSwapped  = false;

		setLocales();
	};

	function setLocales(){

		var locales = InterstitialService.config.locales.targets;

		/*
		 * Creates a $scope variable for each locale dynamically -
		 * That is, every key in the config.locales.targets object, which could be more than
		 * what is defined at the top if a config is used.
		 *
		 * While not necessary, it is highly recommended to define all locales used at the top.
		 */
		angular.forEach( locales, function( value, key ){

			if( key === 'yesText' || key === 'noText' ){

				$scope[ key ] = value;
			}
			else{

				$scope.interstitial.locales[ key ] = value;
			}
		});
	};
};

/*
 * Created by Michael Yuen on 6/15/16
 */
'use strict';
angular.module( 'interstitial-dining' )
	.factory( 'InterstitialService', InterstitialService );

function InterstitialService(
	$rootScope,
	AppData,
	errorTracking,
	ClientInfo,
	JSONValidator,
	Language,
	Package,
	Utilities,
	UtilsValidation
){

	/*********************/
	/*  PUBLIC VARIABLES */
	/*********************/
	var factory = {
		config: undefined,
		buildConfig: buildConfig,
		getImage: getImage,
		updateCharac: updateCharac,
		};

	return factory;

	/*********************/
	/*  PUBLIC METHODS   */
	/*********************/
	function buildConfig( xmcName ){

		/*
		 * TODO: If/when this is extended to a generic interstitial module,
		 * It should probably not be called 'spar', which drives the default images and locale section.
		 * In fact, the defaults wouldn't really make sense except for the most general sense.
		 * The expectation would be for the required config to hold the image paths and define the section, etc.
		 *
		 * One thing I'm not sure of is how to implement different functionality on the yes/no click dynamically.
		 * Need to research existing XMCs further.
		 */
		var interstitialType = xmcName.split('_')[1];
		var capitalized = Utilities.capitalizeFirst( interstitialType );

		var defaults = {
			characs: {
				validation: 'sp_swap_eligible',
				optin: 'sp_swap_auto_renewal_flag'
			},
			images: {
				desktop: xmcName + '_image.png',
				mobile: xmcName + '_image_mobile.png'
			},
			locales: {
				section: 'Interstitial' + capitalized,
				targets: {
					noText: 'noButton',
					yesText: 'yesButton',
					heading: 'heading',
					subheading: 'subheading',
					footnote: 'footnote',
					//Below here are the locales used for the swappedView
					header1: 'header1',
					description1: 'description1',
					header2: 'header2',
					description2: 'description2',
					header3: 'header3',
					description3: 'description3',
					header4: 'header4',
					description4: 'description4'
				}
			}
		};

		/*
		 * Look for the charac 'interstitial_optin_type' on the packageDetails. If defined, this is appended
		 * to the interstitialType variable above ( 'optin_' + [charac value] ).
		 *
		 * The interstitialType variable is what will be used to get the specific config from the overall interstitial config.
		 *
		 * In this way, it is possibile to define a unique configuration for the interstitial-optin on a package leve.
		 */
		if( Utilities.safelyCheckPropertyOnObject( 'Package.packageDetails.CHARACS.interstitial_optin_type', Package ) ){

			interstitialType += '_' + Package.packageDetails.CHARACS.interstitial_optin_type.toLowerCase();
		}

		if( Utilities.safelyCheckPropertyOnObject( 'AppData.settings.interstitial', AppData ) ){

			if( JSONValidator.validate( 'interstitial', AppData.settings.interstitial ) ){

				var app_config = JSON.parse( AppData.settings.interstitial );

				if( angular.isDefined( app_config[ interstitialType ] ) ){

					var interstitial_config = app_config[ interstitialType ];
				}
			}
		}

		defaults = buildConfigCharacs( defaults, interstitial_config );
		defaults = buildConfigImages( defaults, interstitial_config );
		defaults = buildConfigLocales( defaults, interstitial_config );

		factory.config = defaults;
	};

	function getImage(){

		var isMobile = ( ClientInfo.deviceType === 'mobile' );

		if( isMobile ){

			return $rootScope.getAssetUrl(factory.config.images.mobile);
		}
		else{

			return $rootScope.getAssetUrl(factory.config.images.desktop);
		}
	};

	function updateCharac( how ){

		if(UtilsValidation.validArray(Package.itemsToBeAdded)){

			for( var i=0; i < Package.itemsToBeAdded.length; i++ ){

				var item = Package.itemsToBeAdded[i],
					packageDetails = Package.getPackageDetailsForCartItem( item );

				if( angular.isDefined( packageDetails.CHARACS ) ){

					var characs = packageDetails.CHARACS;

					if( angular.isDefined( characs[ factory.config.characs.validation ] ) && Utilities.getBoolean( characs[ factory.config.characs.validation ] ) ){

						if( angular.isDefined( item.CHARACS ) ){

							for( var x=0; x < item.CHARACS.length; x++ ){

								if( how === 'optin' ){

									item.CHARACS[x][ factory.config.characs.optin ] = '1';
								}
								else if( how === 'optout' ){

									item.CHARACS[x][ factory.config.characs.optin ] = '0';
								}
							}
						}
						else{

							errorTracking.notify(
								'CHARACS undefined',
								'Why are the CHARACS undefined on Package.itemsToBeAdded?',
								{
									tags: {
										session_id: AppData.cart.session_id,
										merchant: AppData.merchant
									}
								}
							);

							Package.cancelXFC();
						}
					}
				}
			}
		}
		else{

			errorTracking.notify(
				'No itemsToBeAdded',
				'Why is Package.itemsToBeAdded undefined here?',
				{
					tags: {
						session_id: AppData.cart.session_id,
						merchant: AppData.merchant
					}
				}
			);

			Package.cancelXFC();
		}
	};

	/*********************/
	/* PRIVATE FUNCTIONS */
	/*********************/
	function buildConfigCharacs( defaults, config ){

		if( angular.isDefined( config ) && angular.isDefined( config.characs ) ){

			angular.forEach( config.characs, function( value, key ){

				defaults.characs[ key ] = value;
			});
		}

		return defaults;
	};

	// Get the image asset paths from the config and override them in defaults, but only for those that exist
	function buildConfigImages( defaults, config ){

		if( angular.isDefined( config ) && angular.isDefined( config.images ) ){

			angular.forEach( config.images, function( value, key ){

				defaults.images[ key ] = value;
			});
		}

		return defaults;
	};

	function buildConfigLocales( defaults, config ){

		if( angular.isDefined( config ) && angular.isDefined( config.locales ) ){

			var locales = config.locales;

			if( angular.isDefined( locales.section ) ){

				defaults.locales.section = locales.section;
			}

			if( angular.isDefined( locales.suffix ) ){

				defaults.locales.section += locales.suffix;
			}

			if( angular.isDefined( locales.targets ) ){

				// Get actual locales
				angular.forEach( locales.targets, function( value, key ){

					defaults.locales.targets[ key ] = value;
				});
			}
		}

		angular.forEach( defaults.locales.targets, function( value, key ){

			defaults.locales.targets[ key ] = Language.getLocale( defaults.locales.section, value );
		});

		// Replace @@park
		defaults.locales.targets.heading = defaults.locales.targets.heading.replace( '@@park', AppData.settings.merchant_name );

		return defaults;
	};
};
/**
 * Created by pMatthews on 2/19/2016.
 */
angular
	.module('addon-selection', ['app'])
	.config(function($stateProvider) {
		$stateProvider
			.state('addonSelectionKeyword', {
				url: '/addonSelection/:packageId/:keyword',
				template: '<div ng-include="getTemplateUrl()"></div>',
				controller: 'AddonSelectionController',
				resolve: {
					load: function($rootScope, Utilities) {
						$rootScope.showSpinner();
						return Utilities.cacheBustAndLazyLoad([
							'/scripts/modules/addon-selection/controllers/addon-selection-controller.js',
							'/scripts/modules/addon-selection/addon-selection-models.js',
							'/scripts/modules/addon-selection/services/addon-selection-service.js'
						]);
					},
					initialData: function(load, Bootstrap) {
						return Bootstrap.bootstrapApplication();
					},
					xfcMap: function(initialData, Package) {
						return Package.buildXFCMap();
					},
					initXFC: function(xfcMap, RouteRejectionService, Package, $transition$) {
						var rejectionRoute = Package.assessRoutabilityOfXFC($transition$.params().packageId);
						if (rejectionRoute.length > 0) {
							throw new RouteRejectionService.UnrecoverableException(rejectionRoute);
						} else {
							return true;
						}
					},
					setupAddons: function(xfcMap, $injector, $state, $transition$) {
						var stateParams = $transition$.params(),
							AddonSelectionService = $injector.get('AddonSelectionService'),
							status = AddonSelectionService.initFor(stateParams.packageId, stateParams.keyword, $state);
						if (status.success) {
							return true;
						}
						return AddonSelectionService.errorRouting(status);
					}
				}
			})
			.state('addonSelection', {
				url: '/addonSelection/:packageId', // Uses the first keyword defined in the package's list.
				template: '<div ng-include="getTemplateUrl()"></div>',
				controller: 'AddonSelectionController',
				resolve: {
					load: function($rootScope, Utilities) {
						$rootScope.showSpinner();
						return Utilities.cacheBustAndLazyLoad([
							'/scripts/modules/addon-selection/addon-selection.css',
							'/scripts/modules/addon-selection/controllers/addon-selection-controller.js',
							'/scripts/modules/addon-selection/addon-selection-models.js',
							'/scripts/modules/addon-selection/services/addon-selection-service.js'
						]);
					},
					initialData: function(load, Bootstrap) {
						return Bootstrap.bootstrapApplication();
					},
					xfcMap: function(initialData, Package) {
						return Package.buildXFCMap();
					},
					initXFC: function(xfcMap, RouteRejectionService, Package, $transition$) {
						var rejectionRoute = Package.assessRoutabilityOfXFC($transition$.params().packageId);
						if (rejectionRoute.length > 0) {
							throw new RouteRejectionService.UnrecoverableException(rejectionRoute);
						} else {
							return true;
						}
					},
					setupAddons: function(xfcMap, $injector, $state, $transition$) {
						var AddonSelectionService = $injector.get('AddonSelectionService'),
							status = AddonSelectionService.initFor($transition$.params().packageId, '', $state);
						if (status.success) {
							return true;
						}
						return AddonSelectionService.errorRouting(status);
					}
				}
			})
			.state('ticketAddonSelection', {
				url: '/ticketAddonSelection/:packageId',
				templateUrl: '/scripts/modules/addon-selection/views/addon-selection-choice-with-quantity.html',
				controller: 'TicketAddonSelectionController',
				controllerAs: 'vm',
				resolve: {
					load: function($rootScope, Utilities) {
						$rootScope.showSpinner();
						return Utilities.cacheBustAndLazyLoad([
							'/scripts/modules/addon-selection/controllers/ticket-addon-selection-controller.js',
							'/scripts/modules/addon-selection/addon-selection-models.js',
							'/scripts/modules/addon-selection/services/addon-selection-service.js'
						]);
					},
					initialData: function(load, Bootstrap) {
						return Bootstrap.bootstrapApplication();
					},
					xfcMap: function(initialData, Package) {
						return Package.buildXFCMap();
					},
					initXFC: function(xfcMap, RouteRejectionService, Package, $transition$) {
						var rejectionRoute = Package.assessRoutabilityOfXFC($transition$.params().packageId);
						if (rejectionRoute.length > 0) {
							throw new RouteRejectionService.UnrecoverableException(rejectionRoute);
						} else {
							return true;
						}
					},
					setupAddons: function(initXFC, $injector) {
						return $injector.get('AddonSelectionService').initializeTicketFlow();
					}
				}
			});
	})
	.run(function(ExtraFlow) {
		ExtraFlow.registerXMC('addonSelection', {
			name: 'addonSelection',
			view: 'addonSelection',
			doEditMode: true,
			enabled: true,
			type: 'extraFlowControl'
		});
	})
	.run(function(ExtraFlow) {
		ExtraFlow.registerXMC('ticket_addon_selection', {
			name: 'ticket_addon_selection',
			view: 'ticketAddonSelection',
			doEditMode: false,
			enabled: true,
			type: 'extraFlowControl'
		});
	});

angular
	.module('idme', [
		'errorTracking', 'app'
	])
	.config(function ($locationProvider, $stateProvider) {
	   $stateProvider
			.state('idme', {
				abstract: true,
				url: '/idme',
				template: '<div ui-view></div>',
				resolve:{
					load: function($rootScope, Utilities){
						$rootScope.showSpinner();
						return Utilities.cacheBustAndLazyLoad([
							'/scripts/modules/extraflow/idme/controllers/idme-verify-controller.js',
							'/scripts/modules/extraflow/idme/controllers/idme-confirm-controller.js',
							'/scripts/modules/extraflow/idme/services/idme-oauth-service.js',
							'/scripts/modules/extraflow/idme/services/idme-state-service.js'
						]);
					},
					initialData: function(load, Bootstrap) {
						return Bootstrap.bootstrapApplication();
					},
					assessStorage: function(initialData, $injector, Storage, RouteRejectionService) {
						var IDMeOAuthService = $injector.get('IDMeOAuthService');

						if (IDMeOAuthService.USE_BROADCAST_CHANNEL || Storage.isStorageTypeLocalStorage()) {
							return true;
						}

						throw new RouteRejectionService.ViewException('IDme','extraFlowNotAvailableTitle','extraFlowNotAvailableMsg');
					},
					purgeExpiredOAuths: function(assessStorage, $injector) {
						$injector.get('IDMeOAuthService').purgeExpiredSession();
					},
					xfcMap: function(purgeExpiredOAuths, Package) {
						// Re-sync currentXFC before the idme.verify controller runs.
						// profile-login.signin's xfcMap resolve leaves currentXFC=1 after
						// forward navigation; without re-syncing here, nextXFC() in the
						// verify controller increments from 1 to 2 (demographics) instead
						// of 0 to 1 (profile-login).
						return Package.buildXFCMap();
					}
				}
			})
			.state('idme.confirm', {
				url: '/confirm',
				templateUrl: '/scripts/modules/extraflow/idme/views/confirm.html',
				controller: 'IDMeConfirmController'
			})
			.state('idme.verify', {
				url: '/verify/:type/:packageId/:reinitFlow',
				templateUrl: '/scripts/modules/extraflow/idme/views/verify.html',
				controller:  'IDMeVerifyController',
				params: {
					type: {value: null},
					packageId: {value: null},
					reinitFlow: {value: 'N', squash: true}
				},
				onEnter: ['$location', 'Package', '$rootScope', '$transition$', 'UtilsValidation', '$window', '$document', function($location, Package, $rootScope, $transition$, UtilsValidation, $window, $document){
					var stateParams = $transition$.params(),
						validString = UtilsValidation.validString,
						reinitFlow = UtilsValidation.isRealObject(stateParams) && stateParams.reinitFlow;

					if(!Array.isArray(Package.itemsToBeAdded) || (Array.isArray(Package.itemsToBeAdded) && Package.itemsToBeAdded.length==0)){
						// if we are re-initializing the flow, this is ok, otherwise we can't allow this navigation.
						if (!validString(reinitFlow) || (validString(reinitFlow) && reinitFlow[0] !== '1')) {
							$rootScope.routeTo('/');
						}
					}
				}]
			});
	})
	.run(function($rootScope, AppData, Enums, ExtraFlow, JSONValidator, UtilsValidation) {
		var supportedTypes = [
			'alumni',
			'alumni_canada',
			'doctor',
			'doctor_canada',
			'employee',
			'government',
			'government_canada',
			'hospital',
			'hospital_employee',
			'medical',
			'military',
			'military_canada',
			'nurse',
			'nurse_canada',
			'responder',
			'responder_canada',
			'student',
			'student_canada',
			'teacher',
			'teacher_canada'
		];

		$rootScope.$on(Enums.services.APP_ACTIVATED, function initIdmeTypes() {
			var idmeConfig = JSONValidator.validate('idme', AppData.settings.idme) ? JSON.parse(AppData.settings.idme) : null;

			// Are there configured type overrides?
			if (idmeConfig && UtilsValidation.validArray(idmeConfig.type_overrides)) {
				// Use the app config value
				supportedTypes = idmeConfig.type_overrides;
			}

			// Iterate through the supported types and register them to ExtraFlow
			supportedTypes.forEach(function(idmeType) {
				ExtraFlow.registerXMC('idme_' + idmeType, {
					name: 'idme_' + idmeType,
					view: 'idme/verify/' + idmeType,
					subView: '/verify',
					showCapacityRemaining: false,
					showTimeList: true,
					doEditMode: false,
					lockQuantity: true,
					writeSingleCharac: false,
					enabled: true,
					type: 'extraFlowControl'
				});
			});
		});
	});

angular
	.module('idme')
	.service('IDMeEnumsService',

	function(){
		return {
			actions: {
				CLEAR_AUTH: "idme-clear-auth",
			},
			redirectUri: {
				MEMORY: "{{redirectToHost}}/idme/confirm?{{localStorageKey}}={{localStorageValue}}&endpoint={{apiEndpoint}}&package_id={{packageId}}&ct={{ct}}",
				STORAGE: "{{redirectToHost}}/idme/confirm?{{localStorageKey}}={{localStorageValue}}&endpoint={{apiEndpoint}}"
			},
			routes: {
				CONFIRM: '/idme/confirm',
			},
			tokens: {
				CUSTOMER_TYPE: "ct",
				PINGBACK: "passport.pingback.idme",
				OAUTH: "passport.idme.oauth",
				ACCESS_TOKEN: "access_token",
				ENDPOINT: "endpoint",
				ERROR: "error",
				ERROR_DESCRIPTION: "error_description",
				ACCESS_TOKEN_EXPIRES: "expires_in",
				PREVIOUS_STATE: "id.me.state.previous",
				PACKAGE_ID: "package_id"
			},
			urls: {
				VERIFY: "https://api.id.me/oauth/authorize?client_id={{idMeKey}}&response_type=token&scope={{apiScope}}&redirect_uri={{redirectUri}}"
			}
		};
	});

angular.module('assigned-seating', ['app'])
	.config(function ($locationProvider, $stateProvider) {

		$stateProvider
			.state('/assignedSeating/:packageId', {
				url: '/assignedSeating/:packageId',
				templateUrl: '/scripts/modules/extraflow/assigned-seating/views/assigned-seating.html',
				controller: 'AssignedSeatingController',
				controllerAs: 'vm',
				resolve: {
					load: function( $rootScope, Utilities ){

						$rootScope.showSpinner();

						return Utilities.cacheBustAndLazyLoad([
							'/scripts/modules/extraflow/assigned-seating/controllers/assigned-seating-controller.js',
							'/scripts/modules/extraflow/assigned-seating/services/assigned-seating-service.js'
						]);
					},
					initialData: function(load, Bootstrap) {
						return Bootstrap.bootstrapApplication();
					},
					xfcMap: function(initialData, Package) {
						return Package.buildXFCMap();
					},
					skipAssignSeating: function(xfcMap, $q, $rootScope, $transition$, AppData, JSONValidator, Package, RouteRejectionService, $injector, $stateParams) {
						var AssignedSeatingService = $injector.get('AssignedSeatingService');
						if (JSONValidator.validate('skip_assign_seating', AppData.settings.skip_assign_seating)) {
							$rootScope.showSpinner();
							return AssignedSeatingService.getAssignedSeats()
								.then(function(response) {
									AssignedSeatingService.addAssignSeatingInfoToCartItems($stateParams.packageId, response);
									return new $q(RouteRejectionService.BypassXFCExceptionCallback);
								})
								.catch(function onError() {
									// If there is a previous state
									if ($transition$.from().name) {
										// Abort the transition and backstep the XFC
										$transition$.abort();
										Package.cancelXFC();
										$rootScope.hideSpinner();
									} else {
										// Otherwise give generic error and route to default
										throw new RouteRejectionService.UnrecoverableException('/');
									}
								});
						}
					}
				}
			});
	})
	.run(function(ExtraFlow, Enums){
		// Register this extra flow module with the extra flow service
		ExtraFlow.registerXMC( 'assigned_seating', {
					name: 'assigned_seating',
					view: Enums.extraFlowRoutes.ASSIGNEDSEATING,
					showCapacityRemaining: false,
					doEditMode: false,
					lockQuantity: true,
					writeSingleCharac: false,
					enabled: true,
					type: 'extraFlowControl',
					characsList: ['seat_id', 'row_name', 'seat_name', 'section_id', 'section_name', 'seat']
				}
			);
	});

(function() {
	'use strict';

	angular
		.module('seat-genius', ['app'])
		.run(SeatGeniusRun);

	/**
	 * Registers the seat-genius XFC/movie with the ExtraFlow dispatcher.
	 * @param {Service} ExtraFlow The ExtraFlow service
	 * @param {Service} Enums The Enums service
	 * @returns {undefined}
	 * @ngInject
	 */
	function SeatGeniusRun(ExtraFlow, Enums) {
		ExtraFlow.registerXMC('seat_genius', {
			name: 'seat_genius',
			view: Enums.extraFlowRoutes.SEATGENIUS,
			showCapacityRemaining: false,
			doEditMode: true,
			lockQuantity: true,
			writeSingleCharac: false,
			enabled: true,
			type: 'extraFlowControl',
			characsList: ['unit_id', 'section_id', 'section_name', 'row', 'seat_number', 'seat']
		});
	}
})();

(function() {
	'use strict';

	angular
		.module('seat-genius')
		.config(SeatGeniusConfig);

	/**
	 * Seat Genius Routing
	 * @param {Service} $stateProvider The state provider
	 * @returns {undefined}
	 * @ngInject
	 */
	function SeatGeniusConfig($stateProvider) {
		$stateProvider
			.state('/seatGenius/:packageId', {
				url: '/seatGenius/:packageId',
				templateUrl: 'seat-genius:view',
				controller: 'SeatGeniusController',
				controllerAs: 'vm',
				title: 'seatGeniusPageTitle', // Language.getLocale('pageTitle', ...) key, read by run.js's createPageTitle()
				resolve: {
					load: load,
					initialData: initialData,
					xfcMap: xfcMap,
					sdkReady: sdkReady
				}
			});

		/**
		 * Lazy-loads this module's controller/service/template/style bundle collection.
		 * @param {Service} $rootScope The rootscope
		 * @param {Service} BundleService The bundle service
		 * @returns {Promise} The lazy-load promise
		 * @ngInject
		 */
		function load($rootScope, BundleService) {
			$rootScope.showSpinner();

			return BundleService.lazyLoadCollectionFiles(BundleService.enums.SEAT_GENIUS);
		}

		/**
		 * Bootstraps the application.
		 * @param {Object} load The load resolve
		 * @param {Service} Bootstrap The bootstrap service
		 * @returns {Promise} The bootstrap promise
		 * @ngInject
		 */
		function initialData(load, Bootstrap) {
			return Bootstrap.bootstrapApplication();
		}

		/**
		 * Builds the XFC map for the current package.
		 * @param {Object} initialData The initialData resolve
		 * @param {Service} Package The package service
		 * @returns {Object} The XFC map
		 * @ngInject
		 */
		function xfcMap(initialData, Package) {
			return Package.buildXFCMap();
		}

		/**
		 * Ensures the SeatGenius SDK script is loaded and the
		 * <ac-seat-genius> custom element is registered before the view mounts it.
		 *
		 * SeatGeniusPrepService is lazy-loaded (via `load`, above) as part of this
		 * same resolve chain, so it can't be a plain injected parameter here — UI-Router
		 * builds/validates a state's resolve dependency graph for the whole block up
		 * front, before any resolve in the chain actually runs, so a not-yet-loaded
		 * service fails immediately rather than once `load` completes. $injector.get()
		 * inside the function body defers the lookup until this resolve actually runs,
		 * matching the same workaround assigned-seating-controller.js's own resolve
		 * chain uses for AssignedSeatingService.
		 * @param {Object} xfcMap The xfcMap resolve
		 * @param {Service} $injector The injector service
		 * @returns {Promise} The setup promise
		 * @ngInject
		 */
		function sdkReady(xfcMap, $injector) {
			return $injector.get('SeatGeniusPrepService').setupSeatGenius();
		}
	}
})();


angular.module('imagecaptures',
	['app'])
	.config(function ($locationProvider, $stateProvider) {

		$stateProvider
			.state('imageCapture',{
				url: '/imageCapture/:packageId',
				templateUrl: '/scripts/modules/extraflow/imagecaptures/views/imagecaptures.html'
				, controller: 'ImageCaptureController'
				, abstract: true
				, resolve: {
					initialData: function(Bootstrap) {
						return Bootstrap.bootstrapApplication();
					},
					xfcMap: function(initialData,  Package) {
						return Package.buildXFCMap();
					},
					setupConfiguration: function(xfcMap,ImageCapturePrepService){
						return ImageCapturePrepService.setupConfiguration();
					},
					resetTempFile:function(setupConfiguration,ImageCaptureTempImageService){
						return ImageCaptureTempImageService.clearTempFileInfo();
					},
					passCollection : function(resetTempFile, ImageCapturesModels, Package, RouteRejectionService, $transition$){
						var rejectionRoute = Package.assessRoutabilityOfXFC($transition$.params().packageId);
						if(rejectionRoute.length > 0){

							throw new RouteRejectionService.UnrecoverableException(rejectionRoute);

						}else{

							return new ImageCapturesModels.PassCollection(Package.itemsToBeAddedForCurrentPackage(true));
						}
					},
					correctInitialRoute: function(passCollection, $q, ImageCapturePrepService, ImageCapturesFinalizeService,ImageCapturesRoutingService,RouteRejectionService,$state,$transition$){
						//var deferred = $q.defer()
						if(ImageCapturePrepService.byPassXFC){
							ImageCapturesFinalizeService.finalizeXFCCharacs(passCollection, true);
							return new $q(RouteRejectionService.BypassXFCExceptionCallback);
						}else{
							var pass = passCollection.getActivePass();
							var nextChosenState = ImageCapturesRoutingService.checkPassValidationAndGetNextState(pass);
							if($state.next.name.indexOf(nextChosenState)=== -1){
								throw new RouteRejectionService.UnrecoverableException(nextChosenState,{
									packageId:$transition$.params().packageId,
									passIndex:pass.itemsAddedIndex
								});
							}else{
								return true;
							}
						}
					}
				}
			})
			.state('imageCapture.selection',{
				url: '/selection/:passIndex',
				templateUrl: '/scripts/modules/extraflow/imagecaptures/views/selection.html',
				controller:'ImageCaptureSelectionController',
				resolve:{
					//To handle back button and forward button issues, lets resolve the correct pass based on the passindex and ensure that the
					//appropriate valid property is set accordingly
					setActiveAndValidPass: function(correctInitialRoute,passCollection,$transition$){
						var pass = passCollection.findPassByIndex($transition$.params().passIndex);
						if(!pass.active){
							passCollection.setActivePass(pass);
						}
						pass.valid = false;
						pass.imageMethod = undefined;
						return true;
					}
				}
			})
			.state('imageCapture.mail',{
				controller: 'ImageCaptureOnsiteController',
				url: '/mailing-info/:passIndex',
				templateUrl: '/scripts/modules/extraflow/imagecaptures/views/mail.html',
				resolve:{
					//To handle back button and forward button issues, lets resolve the correct pass based on the passindex and ensure that the
					//appropriate valid property is set accordingly
					setActiveAndValidPass: function(correctInitialRoute,passCollection,$transition$){
						var pass = passCollection.findPassByIndex($transition$.params().passIndex);
						if(!pass.active){
							passCollection.setActivePass(pass);
						}
						pass.valid = true;
						pass.imageMethod = 'mail';
						return true;
					}
				}
			})
			.state('imageCapture.onsite',{
				controller: 'ImageCaptureMailController',
				url: '/onsite-info/:passIndex',
				templateUrl: '/scripts/modules/extraflow/imagecaptures/views/onsite.html',
				resolve:{
					//To handle back button and forward button issues, lets resolve the correct pass based on the passindex and ensure that the
					//appropriate valid property is set accordingly
					setActiveAndValidPass: function(correctInitialRoute,passCollection,$transition$){
						var pass = passCollection.findPassByIndex($transition$.params().passIndex);
						if(!pass.active){
							passCollection.setActivePass(pass);
						}
						pass.valid = true;
						pass.imageMethod = 'onsite';
						return true;
					}
				}
			})
			.state('imageCapture.upload',{
				controller: 'ImageCaptureUploadController',
				url: '/upload-photo/:passIndex',
				abstract: true,
				templateUrl: '/scripts/modules/extraflow/imagecaptures/views/upload.html',
				resolve:{
					//To handle back button and forward button issues, lets resolve the correct pass based on the passindex and ensure that the
					//appropriate valid property is set accordingly
					setActivePass: function(correctInitialRoute,passCollection,$transition$){
						var pass = passCollection.findPassByIndex($transition$.params().passIndex);
						if(!pass.active){
							passCollection.setActivePass(pass);
						}
						pass.imageMethod = 'upload';
						return true;
					},
					preLoadImage: function(setActivePass,passCollection,RouteRejectionService,ImageCaptureTempImageService, ImageCapturePrepService,ImageCapturesRequestService,$q,$rootScope,$transition$){

						$rootScope.showSpinner();
						var stateParams = $transition$.params();
						var preloadImagePromise = $q.defer();
						var activePass = passCollection.getActivePass();
						var currentTempFileName = angular.isDefined(ImageCaptureTempImageService.getCurrentTempFileName()) ? ImageCaptureTempImageService.getCurrentTempFileName(): '';
						if(activePass.sentImageFile && currentTempFileName !== activePass.imageFileName){

							ImageCapturesRequestService.getFileFromAmazon(ImageCapturePrepService.settings.imageAWSbucketfolder + 'tmp_' + activePass.imageFileName).then(function(resp){
								ImageCaptureTempImageService.saveTempFile(resp.data, activePass.imageFileName, activePass.imageOrientation).then(function(){
										preloadImagePromise.resolve();
									},function(err){
										preloadImagePromise.reject(new RouteRejectionService.ViewException('ImageCapture','uploadErrorTitle','uploadErrorMsg','imageCapture.selection',{packageId: stateParams.packageId}));
									})
							},function(err){
								preloadImagePromise.reject(new RouteRejectionService.ViewException('ImageCapture','uploadErrorTitle','uploadErrorMsg','imageCapture.selection',{packageId: stateParams.packageId}));
							});

						}else{

							preloadImagePromise.resolve();


						}

						return preloadImagePromise.promise;

					}

				}
			})
			.state('imageCapture.upload.fileChooser',{
				controller: 'ImageCaptureUploadFileChooserController',
				url: '',
				templateUrl: '/scripts/modules/extraflow/imagecaptures/views/file-chooser.html',
				resolve:{

					route: function(preLoadImage,passCollection, $transition$){
						var stateParams = $transition$.params();

						if(passCollection.passes[stateParams.passIndex].valid){


							throw new RouteRejectionService.UnrecoverableException('imageCapture.upload.crop-result',{packageId: packageId,passIndex:stateParams.passIndex});


						}else{

							return true;

						}
					}

				}
			})
			.state('imageCapture.upload.crop',{
				controller: 'ImageCaptureUploadCropController',
				url: '/crop/:attempt',
				templateUrl: '/scripts/modules/extraflow/imagecaptures/views/crop.html',
				resolve:{

					//To handle back button and forward button issues, lets resolve the correct pass based on the passindex and ensure that the
					//appropriate valid property is set accordingly
					setValidationOnPass: function(preLoadImage,passCollection,$transition$){
						var pass = passCollection.findPassByIndex($transition$.params().passIndex);
						pass.valid = false;
						return true;
					}

				}
			})
			.state('imageCapture.upload.crop-result',{
			controller: 'ImageCaptureUploadCropResultController',
				url: '/cropresult',
				templateUrl: '/scripts/modules/extraflow/imagecaptures/views/crop-result.html',
				resolve:{

					//To handle back button and forward button issues, lets resolve the correct pass based on the passindex and ensure that the
					//appropriate valid property is set accordingly
					setValidationOnPass: function(preLoadImage,passCollection,$transition$){
						var pass = passCollection.findPassByIndex($transition$.params().passIndex);
						pass.valid = true;
						return true;
					},
					imageForPass: function(setValidationOnPass,passCollection, ImageCaptureTempImageService){

						var activePass = passCollection.getActivePass();
						return ImageCaptureTempImageService.getCroppedVersionOfTempFileIntoCanvs(activePass.cropX,activePass.cropY,
							activePass.cropLength,activePass.cropLength,true);

					}

				}
			})
			.state('imageCapture.webcam',{
				url: '/webcam/:passIndex',
				controller: 'ImageCaptureWebcamController',
				abstract: true,
				templateUrl: '/scripts/modules/extraflow/imagecaptures/views/webcam.html',
				resolve: {

					//To handle back button and forward button issues, lets resolve the correct pass based on the passindex and ensure that the
					//appropriate valid property is set accordingly
					setActivePass: function(correctInitialRoute,passCollection,$transition$){
						var pass = passCollection.findPassByIndex($transition$.params().passIndex);
						if(!pass.active){
							passCollection.setActivePass(pass);
						}
						pass.imageMethod = 'webcam';
						return true;
					},
					preloadWebcamImage: function(setActivePass,passCollection,RouteRejectionService,ImageCaptureTempImageService, ImageCapturePrepService,ImageCapturesRequestService,$q,$rootScope,$state,$transition$){

						$rootScope.showSpinner();
						var stateParams = $transition$.params();
						var preloadWebcamImagePromise = $q.defer();
						var activePass = passCollection.getActivePass();
						var currentTempFileName = angular.isDefined(ImageCaptureTempImageService.getCurrentTempFileName()) ? ImageCaptureTempImageService.getCurrentTempFileName(): '';
						if(activePass.sentImageFile && currentTempFileName !== activePass.imageFileName){

							ImageCapturesRequestService.getFileFromAmazon(ImageCapturePrepService.settings.imageAWSbucketfolder + activePass.imageFileName).then(function(resp){

								ImageCaptureTempImageService.saveTempFile(resp.data, activePass.imageFileName, activePass.imageOrientation).then(function(){
									if($state.next.name !== 'imageCapture.webcam.result'){

										preloadWebcamImagePromise.reject(new RouteRejectionService.UnrecoverableException('imageCapture.webcam.result',{passIndex:stateParams.passIndex,packageId: stateParams.packageId}));

									}else{

										preloadWebcamImagePromise.resolve();

									}
								},function(err){
									preloadWebcamImagePromise.reject(new RouteRejectionService.ViewException('ImageCapture','uploadErrorTitle','uploadErrorMsg','imageCapture.selection',{packageId: stateParams.packageId}));
								})
							},function(err){
								preloadWebcamImagePromise.reject(new RouteRejectionService.ViewException('ImageCapture','uploadErrorTitle','uploadErrorMsg','imageCapture.selection',{packageId: stateParams.packageId}));
							});

						}else{

							preloadWebcamImagePromise.resolve();


						}

						return preloadWebcamImagePromise.promise;

					}
				}
			})

			.state('imageCapture.webcam.take-photo',{
				url: '',
				controller: 'ImageCaptureWebcamTakePhotoController',
				templateUrl: '/scripts/modules/extraflow/imagecaptures/views/webcam-take-photo.html',
				resolve:{
					//To handle back button and forward button issues, lets resolve the correct pass based on the passindex and ensure that the
					//appropriate valid property is set accordingly
					setValidationOnPass: function(preloadWebcamImage,passCollection,$transition$){
						var pass = passCollection.findPassByIndex($transition$.params().passIndex);
						pass.valid = false;
						return true;
					}
				}
			})
			.state('imageCapture.webcam.result',{
				url: '/webcam-result/:passIndex',
				controller: 'ImageCaptureWebcamResultController',
				templateUrl: '/scripts/modules/extraflow/imagecaptures/views/webcam-result.html',
				resolve:{

					webcamResultCanvas: function(preloadWebcamImage,passCollection, RouteRejectionService,ImageCaptureTempImageService,$transition$,$q){

						var activePass = passCollection.getActivePass();
						var deferred = $q.defer();
						ImageCaptureTempImageService.transformCurrentTempFileIntoCanvas(true).then(function(canvas){
							deferred.resolve(canvas);
						},function(err){
							deferred.reject(new RouteRejectionService.ViewException('ImageCapture','uploadErrorTitle','uploadErrorMsg','imageCapture.selection',{packageId: $transition$.params().packageId}));
						});

						return deferred.promise;

					},
					//To handle back button and forward button issues, lets resolve the correct pass based on the passindex and ensure that the
					//appropriate valid property is set accordingly
					setValidationOnPass: function(webcamResultCanvas,passCollection,$transition$){
						var pass = passCollection.findPassByIndex($transition$.params().passIndex);
						pass.valid = true;
						return true;
					}

				}
			})
	})
	.run(function(ExtraFlow, ImageCapturesAddImageRequestService){
		// Register this extra flow module with the extra flow service
		ExtraFlow.registerXMC
			( 'image_capture',
				{ name: 'image_capture',
					view: 'imageCapture.selection',
					viewIsStateName: true,
					viewDefaultArgs:{
						passIndex: 0
					},
					showCapacityRemaining: false,
					showTimeList: true,
					doEditMode: true,
					writeSingleCharac: false,
					enabled: true,
					type: 'extraFlowControl'
				}
			);
	})
	.constant("cropConstants", {
		POSITIONS:{
			TOP_LEFT: 1,
			TOP_RIGHT: 2,
			BOTTOM_LEFT: 3,
			BOTTOM_RIGHT :4
			}
		});


angular.module('imagecaptures').service('ImageCapturesModels',function(
   AppData,
   Package,
   ImageCapturesEnumsService,
   $filter)
{

  /**
		 * ImageCaptureInfo  holds image capture specific information
		 * @param uid
		 * @constructor
		 */
		function ImageCaptureInfo(uid){

			this.imageMethod = undefined;
			this.sentImageFile = false;
			this.imageFileName = $filter('date')(new Date(), 'MMddyy')  + '_' + uid + '_' + AppData.merchantId + '.jpg';
			this.uid = uid;
			this.cropX = undefined;
			this.cropY = undefined;
			this.cropLength = undefined;
			this.imageOrientation = 1;
			this.imageCaptureInfoValid = false;
			this.required = false;

		}

		ImageCaptureInfo.prototype.reset = function() {
			this.imageMethod = undefined;
			this.sentImageFile = false;
			this.imageFileName = $filter('date')(new Date(), 'MMddyy')  + '_' + this.uid + '_' + AppData.merchantId + '.jpg';
			this.cropX = undefined;
			this.cropY = undefined;
			this.cropLength = undefined;
			this.imageOrientation = 1;
			this.imageCaptureInfoValid = false;
		};

		ImageCaptureInfo.prototype.toJSON = function(){

			var info = {

				imageMethod : this.imageMethod,
				sentImageFile : this.sentImageFile ? 1 : 0,
				imageFileName : this.imageFileName

			};

			if(this.imageMethod === 'upload'){

				info.cropX = this.cropX;
				info.cropY = this.cropY;
				info.cropLength = this.cropLength;
				info.imageOrientation = this.imageOrientation;

			}

			return info;

		};


		function PassCollection(items){

			this.passes = [];
			this.fillPasses(items);
		}

		PassCollection.prototype.fillPasses =function(items){

			items.forEach(function(item, index){

				if(angular.isDefined(item.CHARACS) && angular.isArray(item.CHARACS) && item.CHARACS.length > 0){

					var characs = item.CHARACS[0];
					var pass = new Pass(index);
					pass.guestName = (characs.ph_first_name + ' ' + characs.ph_last_name);
					pass.uid = characs.uid;

					if(!Package.isEditing()){

						var date = new Date();
						var dateString = ("0" + (date.getMonth() + 1).toString()).substr(-2) + ("0" + date.getDate().toString()).substr(-2)  +  (date.getFullYear().toString()).substr(2);
						pass.imageFileName = dateString + '_' + pass.uid + '_' + AppData.merchantId + '.jpg';

					}else{

						pass.imageMethod = characs.imageMethod;
						pass.sentImageFile = (characs.imageMethod == ImageCapturesEnumsService.imageCaptureMethodTypes.UPLOAD || characs.imageMethod == ImageCapturesEnumsService.imageCaptureMethodTypes.WEBCAM);
						pass.imageFileName = characs.imageFileName;
						pass.cropX = angular.isDefined(characs.cropX) ? Number(characs.cropX): undefined;
						pass.cropY = angular.isDefined(characs.cropY) ? Number(characs.cropY): undefined;
						pass.cropLength = angular.isDefined(characs.cropLength) ? Number(characs.cropLength): undefined;
						pass.imageOrientation = angular.isDefined(characs.imageOrientation)? Number(characs.imageOrientation): 1;
						pass.valid = true;

					}

					if(index === 0 ){
						pass.active = true;
					}

				}
				this.passes.push(pass);

			}, this);
		}

		PassCollection.prototype.findPassByIndex = function(idx){
			return this.passes[idx];
		}

		PassCollection.prototype.findPassByUid = function(uid){
			return this.passes.filter(function(item){
				return (item.uid == uid);
			})[0];
		}

		PassCollection.prototype.getPasses = function(){
			return this.passes;
		}

		PassCollection.prototype.getActivePass = function(){
			return this.passes.filter(function(item){
				return (item.active === true);
			})[0];
		}

		PassCollection.prototype.setActivePass = function(nextPass){
			var currentActivePass = this.getActivePass();
			currentActivePass.active = false;
			nextPass.active = true;
		}

		PassCollection.prototype.getNextPass = function(){

			var currentActivePass = this.getActivePass();
			var nextIndex = this.passes.indexOf(currentActivePass) + 1;
			var nextPass = undefined;

			currentActivePass.active = false;
			if(nextIndex < this.passes.length){
				var nextPass = this.passes[nextIndex];
				nextPass.active = true;
			}
			return nextPass;

		}

		PassCollection.prototype.isImageMethodValidForGivenPass = function(pass){

			var valid = angular.isDefined(pass.imageMethod);
			if(valid && (pass.imageMethod === 'upload' || pass.imageMethod === 'webcam')){

				valid = pass.sentImageFile;

			}
			return valid;

		}

		PassCollection.prototype.getPreviousPass = function(){

			var currentActivePass = this.getActivePass();
			var previousIndex = this.passes.indexOf(currentActivePass) - 1;
			var previousPass = undefined;

			currentActivePass.active = false;
			if(previousIndex >= 0){
				var previousPass = this.passes[previousIndex];
				previousPass.active = true;
			}
			return previousPass;

		}


		/**
		 * Class containing information for passes related to image capture
		 * @param index
		 * @constructor
		 */
		function Pass(index){
			this.guestName = '';
			this.imageMethod = undefined;
			this.sentImageFile = false;
			this.imageFileName = '';
			this.uid = '';
			this.cropX = undefined;
			this.cropY = undefined;
			this.cropLength = undefined;
			this.imageOrientation = 1;
			this.valid = false;
			this.itemsAddedIndex = index;
			this.active = false;
		}

		Pass.prototype = {

			resetSelections :  function(){
				this.imageMethod = undefined;
				this.sentImageFile = false;
				this.valid = false;
				this.imageOrientation = 1;
			}

		}

  this.ImageCaptureInfo = ImageCaptureInfo;
  this.PassCollection = PassCollection;

	});

/**
 * Created by ltischuk on 12/26/14.
 */
angular.module(
	'imagecaptures'
).factory
(
	'ImageCapturePrepService',

	function(
		AppData,
		ClientInfo,
		Enums,
		ImageCapturesEnumsService,
		JSONValidator,
		Utilities
	) {

		var service = {
			byPassXFC : false,
			configured: false,  // set to true once setupConfiguration has been called.
			settings: {},
			hasMinimumSettingsRequired:hasMinimumSettingsRequired,
			setupConfiguration: setupConfiguration

		};
		return service;

		/**
		 * Setup the configuration for image capture
		 */
		function setupConfiguration(){

			service.configured = true;

			if(Object.keys(service.settings).length === 0){
				for(var settingName in ImageCapturesEnumsService.configs){

					var setting = ImageCapturesEnumsService.configs[settingName];

					if(angular.isDefined(AppData.settings) && angular.isDefined(AppData.settings[settingName])){

						var appConfigSetting = AppData.settings[settingName];
						var temp;

						if(setting.type == 'boolean'){

							temp = Utilities.getBoolean(appConfigSetting);

						}else if(setting.type == 'number'){

							temp = isFinite(appConfigSetting) ? Number(appConfigSetting) : setting.default;
						}else if(settingName == 'imagecaptures_config'){

							temp = JSONValidator.validate('imagecaptures_config',appConfigSetting) ? JSON.parse(appConfigSetting) : {};

						}
						else{

							temp = appConfigSetting;
						}
					}
					else{

						temp = setting.default;
					}

					if(angular.isDefined(setting.initializer)){

						//if the object is enabled, lets allow it to run through the initializer to assess whether or not it should be enabled
						//based on browser-feature detection for the particular setting
						if(temp){

							temp = setting.initializer();

						}

					}

					service.settings[settingName] = temp;


				}

				checkDeviceOverrides();
				if(!service.settings.enableUpload && !service.settings.enableCapture && !service.settings.enableMail && !service.settings.enableOnSite){
					service.byPassXFC = true;
				}

			}

			// Max size is static
			service.settings.maxFileSizeKb = Enums.imageUpload.MAX_SIZE;

			return true;
		}

		function hasMinimumSettingsRequired(){

			return  Object.keys(service.settings).length > 1 && Utilities.safelyCheckPropertyOnObject('settings.imagecaptures_config',service.settings);

		}


		function checkDeviceOverrides(){

			if (Utilities.safelyCheckPropertyOnObject('settings.imagecaptures_config.disable_image_methods_per_device_list',service.settings)){

				service.settings.imagecaptures_config.disable_image_methods_per_device_list.forEach(function(disableMethodConfig){

					if(Utilities.getBoolean(service.settings[disableMethodConfig.image_method_name]) && ClientInfo.deviceType == disableMethodConfig.device_type){

						service.settings[disableMethodConfig.image_method_name] = false;


					}

				})

			}


		}





	}
);

/**
 * Created by ltischuk on 12/26/14.
 */
angular.module( 'imagecaptures' )
	.service
( 'ImageCapturesFinalizeService',
	function
		(ExtraFlow,
			Language,
			Package,
			 $rootScope) {

		var imageCaptureCharacs = ['imageMethod','imageFileName','cropX','cropY','cropLength','imageOrientation'];

		/**
		 * Adds characs to package item (resource_id)
		 * @param selection
		 */
		this.finalizeXFCCharacs = function(passCollection,byPassXFC){

			//if we haven't bypassed this XFC lets add the items to the cart
			var items = Package.itemsToBeAddedForCurrentPackage(true);

			// GPS merchants do not use S3-backed image characs — photo linkage is handled server-side
			// via guestUuid on the GPS API. Only write image characs on the legacy Siriusware path.
			if(!byPassXFC && !$rootScope.configuredForPassportAuth){

				items.forEach(function(item, index){

					if(angular.isDefined(item.CHARACS) && angular.isArray(item.CHARACS) && item.CHARACS.length > 0) {

						var characs = item.CHARACS[0];
						var pass = passCollection.findPassByUid(characs.uid);

						if(angular.isDefined(pass)){
							imageCaptureCharacs.forEach(function(charac){
								if(angular.isDefined(pass[charac])){

									characs[charac] = pass[charac];

								}
							});
						}

					}

				});

			}

			ExtraFlow.addReferenceToCartItems( Package.settings.view, items, ExtraFlow.CLIENT_XFC_VIEW );
			ExtraFlow.addReferenceToCartItems( Package.settings.name, items, ExtraFlow.CLIENT_XFC_NAME );

		}

	}
);

/**
 * Created by ltischuk on 12/26/14.
 */
angular.module( 'imagecaptures' )
	.service
( 'ImageCapturesAddImageRequestService',
	function
		(AppData,
		errorTracking,
		Enums,
		JSONValidator,
		ImageCapturesEnumsService,
		Utilities,
		$rootScope) {

		/**
		 * Only need to call addImage/AddTicketCharacs if there are actual images to send
		 * @param purchaseResponse
		 */
		function saveImageData(event, data) {
			var viewOrderResponse = data.viewOrderResponse;

			if(angular.isDefined(viewOrderResponse)) {

				var callAddImage = shouldCallAddImage();
				var serviceCall = callAddImage ? ImageCapturesEnumsService.serviceRequests.ADD_IMAGE : Enums.services.ADD_TICKET_CHARACTERISTICS;

				var requests = buildRequest(viewOrderResponse,callAddImage);

				if(requests.length  > 0 ){
					makeServiceCall(requests, serviceCall, callAddImage);

				}

			}

		}

		function shouldCallAddImage(){

			return Utilities.safelyCheckPropertyOnObject('AppData.GetApplicationConsolidated.SETTINGS.imagecaptures_config', AppData,

				function(config){

					var result = false;

					if(JSONValidator.validate('imagecaptures_config', config)){
						result = Utilities.getBoolean(JSON.parse(config).sendAddImageCall);
					}

					return result;
				});

		}

		function buildRequest(viewOrderResponse, isAddImage){

			var reqs = [];
			if(Utilities.safelyCheckPropertyOnObject('viewOrderResponse.VIEW_ORDER_REPLY.ORDER_STATUS_REPLY.order_id', viewOrderResponse) &&
				Utilities.safelyCheckPropertyOnObject('viewOrderResponse.VIEW_ORDER_REPLY.TICKET_DETAILS_REPLY.TICKET', viewOrderResponse)){

					var tickets = viewOrderResponse.VIEW_ORDER_REPLY.TICKET_DETAILS_REPLY.TICKET;
					var order_id= viewOrderResponse.VIEW_ORDER_REPLY.ORDER_STATUS_REPLY.order_id;

					tickets.forEach(function(tkt){
						if(angular.isDefined(tkt.CHARACS) && angular.isDefined(tkt.CHARACS.uid)){

							if(isAddImage){

								reqs.push ({  orderId: order_id
									, imageFileName: angular.isDefined(tkt.CHARACS.imageFileName) ?  tkt.CHARACS.imageFileName : ''
								});

							}else if(angular.isDefined(tkt.CHARACS.imageFileName) && angular.isDefined(tkt.CHARACS.imageMethod) &&
								(tkt.CHARACS.imageMethod == 'webcam' || tkt.CHARACS.imageMethod == 'upload')){

								reqs.push ({  ticket_id: tkt.ticket_id
									, CHARACS:
										[
											{ key: 'image_capture_filename'
												, value: tkt.CHARACS.imageFileName
											}
										]
								});

							}

						}
					});
			}
			return reqs;

		}

		/**
		 * Make a service call to AddImage oir AddTicketCharacteristics based on the imagecaptures_config.
		 * If sendAddImageCall is set to true, then send AddImage as individual requests for each ticket,
		 * otherwise send AddTicketCharacteristics as 1 call with an array of tickets.
		 * @param {Array|Object} serviceReqs - The service requests to send in a call.
		 * @param {String} serviceCall - The type of service call, either AddImage or AddTicketCharacteristics
		 * @param {Boolean} isAddImageCall - Determines whether to send individual requests or single request for tickets.
		 * @returns {undefined}
		 */
		function makeServiceCall(serviceReqs, serviceCall, isAddImageCall) {
			var request = isAddImageCall ? serviceReqs.pop() : {TICKETS: {TICKET: serviceReqs}};

				AppData.fetch(serviceCall, false, request)
					.then(function(response) {
						if (response.status !== Enums.status.OK) {
							errorTracking.notify('Error saving image data ');
						}

						if (isAddImageCall && serviceReqs.length > 0) {
							makeServiceCall(serviceReqs, serviceCall);
						}
					}, function() {
						errorTracking.notify('Error making service request to save image data ');
					});
			}

		$rootScope.$on( 'accesso:postPurchaseComplete', saveImageData);
	}
);

/**
 * Created by ltischuk on 12/26/14.
 */
angular.module(
	'imagecaptures'               // The Camps Module
).factory
(
	'ImageCapturesEnumsService',        // Service Name

	function(ClientInfo){
		return {
			imageTypes:
				{ BASE64 : 0
				}
				,imageCaptureMethodTypes:
				{
					UPLOAD : 'upload'
					,WEBCAM : 'webcam'
					,MAIL   : 'mail'
					,ONSITE : 'onsite'
				}
				,imageCaptureSaveTypes:
				{
					AMAZONS3 : 'amazonS3'
						,BACKEND  : 'backend'
				}
				,viewUploadImgDim: 270
				,serviceRequests: {
					ADD_IMAGE: 'AddImage'
				}
				,corners: {
				NWSE : 'nwse-resize',
				NESW : 'nesw-resize'
				},
				canvasSection: {
					TOP_LEFT: 1,
					TOP_RIGHT: 2,
					BOTTOM_LEFT: 3,
					BOTTOM_RIGHT :4
				}
				,configs:{
				'enableUpload' : {type:'boolean', default: false, initializer: function(){
					return ClientInfo.isFileUploadSupported();
				}},
				'enableCapture' :{type:'boolean', default: false, initializer: function(){
					return ClientInfo.isWebcamSupported();
				}},
				'enableMail' :{type:'boolean', default: false},
				'enableOnSite' : {type:'boolean', default: false},
				'enableFacialRecognition' : {type:'boolean', default: false},
				'disableFaceRecognitionOnCrop' : {type:'boolean', default: false},
				'imageFileEncoding' :{type:'number', default: 0},
				'saveImageWidth' : {type:'number', default: 300},
				'saveImageHeight' : {type:'number', default: 300},
				'imageSaveMethod' : {type: 'string', default: 'backend'},
				'imageAWSkey' : {type: 'string', default: ''},
				'imageAWSsecret' : {type: 'string', default: ''},
				'imageAWSbucket' : {type: 'string', default: ''},
				'imageAWSbucketfolder' : {type: 'string', default: ''},
				'imageAWSregion' : {type: 'string', default: ''},
				'acceptableImageTypes' : {type: 'string', default:"image/jpeg, image/JPG, image/JPEG, image/jpeg"},
				'imagecaptures_config' : {type: 'json', default: '{}'}

			}

		}
	}
);

/**
 * Created by ltischuk on 12/26/14.
 */
angular.module( 'imagecaptures' )
	.service
( 'ImageCapturesRequestService',
	function
		(ImageCapturePrepService,
		$http,
		UrlUtils,
		$q) {

		var strToRemove = 'data:image/jpeg;base64,';
		this.getSignedUrl = getSignedUrl;
		/**
		 * Send File directly to Amazon S3 via Node
		 * @returns {deferred.promise|{then, catch, finally}}
		 */
		function sendFileToAmazon(file,fileName){

			var deferred = $q.defer();
			var form = new FormData();
			form.append("filename", ImageCapturePrepService.settings.imageAWSbucketfolder + fileName);
			form.append("fileToUpload", file);

			//to send a multi-part form request to the server in Angular, we must overried the transformRequest as Angular will attempt to serialize the formData object
			//we don't want that so we override transformRequest with angular.identity function to leave it as is
			//We also must set the ContentType as undefined because the browser will set it to multipart/form-data for us and fill in the correct boundary
			//If we try to do that manually, the request will fail to fill in the boundary parameter of the request
			$http.post(UrlUtils.getAccessoAPIHostUrl('/api/uploadFileToS3'), form, {transformRequest: angular.identity, headers: {'Content-Type':undefined}})
				.then(function(response)
				{
					deferred.resolve(response);

				})
				.catch(function(error){
					deferred.reject(error);
				});

			return deferred.promise;
		}

		this.sendFileToAmazon = sendFileToAmazon;

		/**
		 * Send File directly to Amazon S3 via Node
		 * @returns {deferred.promise|{then, catch, finally}}
		 */
		function getFileFromAmazon(fileName){

			var deferred = $q.defer();

			$http.get(UrlUtils.getAccessoAPIHostUrl('/api/getFileFromS3'), {
				params: { filename: fileName },
				responseType: 'blob'
				})
				.then(function(response) {
					deferred.resolve(response);
				})
				.catch(function(error) {
					deferred.reject(error);
				});

			return deferred.promise;
		}

		this.getFileFromAmazon = getFileFromAmazon;

		/**
		 * Send a base 64 encoded image to amazon
		 * @param fileName
		 * @param base64JpegImg
		 * @returns {deferred.promise|{then, catch, finally}}
		 */
		function sendBase64EncodedImgToAmazonS3(fileName, base64JpegImg){

			var deferred = $q.defer();

			var base64FileStr = base64JpegImg.substring(strToRemove.length);
			$http({
				method: 'POST', url: UrlUtils.getAccessoAPIHostUrl('/api/uploadBase64ImageToS3')
				, data : {
					"image": base64FileStr,
					"filename": ImageCapturePrepService.settings.imageAWSbucketfolder + fileName
				}
			})
			.then(function(response) {
				deferred.resolve(response);
			})
			.catch(function(error) {
				deferred.reject(error);
			});

			return deferred.promise;
		}

		this.sendBase64EncodedImgToAmazonS3 = sendBase64EncodedImgToAmazonS3;

		/**
		 * Get Signed Url for a file
		 * @public
		 * @param {String} fileName file name
		 * @param {String} guestNum guest number
		 * @returns {Promise} promise
		 */
		function getSignedUrl(fileName, guestNum) {
			var deferred = $q.defer(),
				extend = angular.extend,
				params = {
					filename: fileName,
					guestNum: guestNum
				},
				resolvedData = { guest_no: guestNum };

			$http.get(UrlUtils.getAccessoAPIHostUrl('/api/getSignedUrl'), { params: params })
				.then(function(response) {
					deferred.resolve(extend(resolvedData, response.data));
				})
				.catch(function(error) {
					deferred.resolve(extend(resolvedData, error.data));
				});

			return deferred.promise;
		}
	}
);

/**
 * Created by ltischuk on 1/14/16.
 */
/**
 * Created by ltischuk on 12/26/14.
 */
angular.module(
	'imagecaptures'
).service
(
	'ImageCapturesRoutingService',

	function(AppData,
					Enums,
					RouteRejectionService,
					ImageCapturePrepService,
					ImageCapturesFinalizeService,
					ImageCapturesEnumsService,
					ImageCaptureTempImageService,
					JSONValidator,
					Package,
					Utilities,
					$state,
					$rootScope
	){

		/**
		 * For the active pass in the passCollection, find the appropriate next route given the image method
		 * @param passCollection
		 * @param stateParams
		 */
		this.checkPassValidationAndGetNextState = function(pass){

			var method = pass.imageMethod;
			var nextState = '';

			switch(method){
				case Enums.imageCaptureMethodTypes.MAIL :{
					nextState = 'imageCapture.mail';
					break;
				}
				case Enums.imageCaptureMethodTypes.ONSITE :{
					nextState = 'imageCapture.onsite';
					break;
				}
				case Enums.imageCaptureMethodTypes.WEBCAM :{
					nextState = 'imageCapture.webcam';
					break;
				}
				case Enums.imageCaptureMethodTypes.UPLOAD :{
					if(pass.valid){

						nextState = 'imageCapture.upload.crop-result';

					}else{

						nextState = 'imageCapture.upload';

					}
					break;
				}
				default :{
					pass.imageMethod = undefined;
					pass.valid = false;
					ImageCaptureTempImageService.clearTempFileInfo();
					nextState = 'imageCapture.selection';
					break;
				}
			}

			return nextState;

		}

		/**
		 * Obtain the state for the previous step
		 * @param currentRoute
		 * @returns {undefined}
		 */
		this.getRouteForPreviousStep = function(currentRoute){

			var newState = '';
			switch(currentRoute){
				case 'imageCapture.selection' :{
					newState = '';
					break;
				}
				case 'imageCapture.upload.crop' :{
					newState = 'imageCapture.upload.fileChooser';
					break;
				}
				case 'imageCapture.upload.crop-result' :{
					newState = 'imageCapture.upload.crop';
					break;
				}
				case 'imageCapture.webcam.result' :{
					newState = 'imageCapture.webcam.take-photo';
					break;
				}
				default :{
					newState = 'imageCapture.selection';
					break;
				}
			}

			return newState;

		}

	}
);

/**
 * Created by ltischuk on 9/24/15.
 */
angular.module('imagecaptures')
    .factory('ImageCapturesCropSelection', function CropSelectionFactory(cropConstants) {

      /**
       * CropSelection
       * A class to support the movement of a square selector on top of a canvas
       * @param maxLength
       * @constructor
       */
      function CropSelection(){

        this.x = 0;
        this.y = 0;
        this.length = 0;
        this.outerCushion = 2;
        this.maxX = 0;
        this.maxY = 0;
        this.currentCorner = 0;

      }

      /**
       * Prototype functions
       **/
      CropSelection.prototype = {

        //accessor methods
        get x(){

          return this._x;

        },
        set x(x){

          this._x = x;

        },
        get y(){

          return this._y;

        },
        set y(y){

          this._y = y;

        },
        get length(){

          return this._length;

        },
        set length(length){

          this._length = length;

        },
        get outerCushion(){

          return this._outerCushion;

        },
        set outerCushion(outerCushion){

          this._outerCushion = outerCushion;

        },
        get maxX(){

          return this._maxX;

        },
        set maxX(maxX){

          this._maxX = maxX;

        },
        get maxY(){

          return this._maxY;

        },
        set maxY(maxY){

          this._maxY = maxY;

        },
        get currentCorner(){

          return this._currentCorner;

        },
        set currentCorner(currentCorner){

          this._currentCorner = currentCorner;

        },
        /**
         * Set the selector dimensions given a new canvas (parent) width and height
         * @param parentWidth
         * @param parentHeight
         * @param (optional) startX - starting value of X within the canvas dimensions
         * @param (optional) startY - starting value of Y within the canvas dimensions
         * @param (optional) startLength - starting value of length within the canvas dimensions
         *
         */
        initSelectorDimensions : function(parentWidth, parentHeight, startX, startY, startLength){

          this.maxX = parentWidth - this.outerCushion;
          this.maxY = parentHeight - this.outerCushion;

          startX = Number(startX);
          startY = Number(startY);
          startLength = Number(startLength);

          if(angular.isDefined(startX) && angular.isDefined(startY) && angular.isDefined(startLength) &&
              isFinite(startX), isFinite(startY), isFinite(startLength) && startLength > 0){

            this.x = startX;
            this.y = startY;
            this.length = startLength;

          }else{

            //position selector in the center of the parent canvas
            var minLenValue = Math.min(parentWidth, parentHeight);
            this.x = (this.maxX / 2) - (minLenValue/4);
            this.y = (minLenValue/4);
            this.length = minLenValue/2;

          }

        },
        /**
         * Calculate whether or not the point is in the center move zone to move the entire selector in any direction
         * @param pointX
         * @param pointY
         * @returns {boolean}
         */
        isInMoveZone : function(pointX, pointY){

          //find if point is in moveable territory and not in expandable/collapsable areas near corners
          var moveZoneMinBound = this.length / 12;
          var moveZoneMaxBound = this.length - moveZoneMinBound;
          if(pointX >= (this.x + moveZoneMinBound) && pointX <= (this.x + moveZoneMaxBound) &&
              pointY >= (this.y + moveZoneMinBound) && pointY <= (this.y + moveZoneMaxBound)){

            return true;
          }
          return false;
        },
        /**
         * isValidCornerMove - checks if the move is valid given an increment for x and y and length increment
         * @param increment for x and y
         * @param lenIncrement for the length
         * @returns {boolean}
         * @private
         */
        _isValidCornerMove : function( increment,lenIncrement){

          var newX = increment + this.x;
          var newY = increment + this.y;
          var newLen = this.length + lenIncrement;
          return (newX >= this.outerCushion && (newX + newLen) < this.maxX &&
          newY >= this.outerCushion && (newY + newLen) < this.maxY &&
          newLen > 10);

        },
        /**
         * Determines whether a given potential increment is allowed for length
         * @param acc
         * @returns {boolean}
         * @private
         */
        _isValidLengthMove: function(acc){

          var tempLength = (this.length + acc);
          if(this.x + tempLength > this.maxX || this.y + tempLength > this.maxY
              || tempLength < 10){
            return false;

          }
          return true;

        },
        /**
         * Determine whether a given potential increment can be applied to X
         * @param acc
         * @returns {boolean}
         * @private
         */
        _isValidXMove : function(acc){

          var tempX = acc + this.x;
          if(tempX < this.outerCushion || tempX + this.length > this.maxX){
            return false;
          }
          return true;

        },
        /**
         * Determine whether a given potential increment can be applied to Y
         * @param acc
         * @returns {boolean}
         * @private
         */
        _isValidYMove : function(acc){

          var tempY = acc + this.y;
          if(tempY < this.outerCushion || tempY + this.length > this.maxY){
            return false;
          }
          return true;
        },
        /**
         * Move the selector x, y coordinates given a move increment and compute new length if necessary
         * @param xMove
         * @param yMove
         * @param isCorner
         * @param cornerPosition
         */
        move : function(xMove,yMove, isCorner, cornerPosition){

          if(isCorner){

            // assess the direction of the current move, then normalize the adjustments so we maintain
            // smoothness in movement
            var movingUp = yMove < 0 ? true: false;
            var movingLeft = xMove < 0 ? true : false;
            var movingDown = yMove > 0 ? true : false;
            var moveAdj = Math.max(Math.abs(xMove),Math.abs(yMove));
            var lenAdj = moveAdj * 2;

            //if the corner passed in is the same as the currentCorner from the mousedown event,
            // calculate the move and length adjustment to expand and/or collapse square
            if(this.currentCorner == cornerPosition){

              switch(cornerPosition) {

                case cropConstants.POSITIONS.TOP_LEFT:
                {

                  lenAdj *= movingLeft || movingUp ? 1 : -1;
                  moveAdj *= movingLeft || movingUp ? -1 : 1;
                  break;

                }
                case cropConstants.POSITIONS.TOP_RIGHT:
                {

                  lenAdj *=  movingDown || movingLeft ? -1 : 1;
                  moveAdj *=  movingDown || movingLeft ? 1 : -1;
                  break;

                }
                case cropConstants.POSITIONS.BOTTOM_LEFT:
                {

                  lenAdj *=  movingDown || movingLeft ? 1 : -1;
                  moveAdj *=  movingDown || movingLeft ? -1 : 1;
                  break;
                }
                default:
                {

                  lenAdj *= movingLeft || movingUp ? -1 : 1;
                  moveAdj *= movingLeft || movingUp ? 1 : -1;
                  break;

                }
              }

              //if its a valid move, then adjust x,y and length
              if(this._isValidCornerMove(moveAdj,lenAdj)){
                this.x += moveAdj;
                this.y += moveAdj;
                this.length += lenAdj;
              }
            }

          }else{
            //otherwise move entire selector square as it is not a corner move
            this.x = this._isValidXMove(xMove) ? this.x + xMove : this.x;
            this.y = this._isValidYMove(yMove) ? this.y + yMove : this.y;
          }

        },
        /**
         * Find nearest corner given a point on the canvas
         * @param pointX
         * @param pointY
         * @private
         * @returns {number}
         */
        nearestCorner: function(pointX, pointY){

          //assess the number of pixels from the given points
          var pxFromXLeft = Math.abs(pointX - this.x);
          var pxFromXRight = Math.abs(pointX - (this.x + this.length));
          var pxFromYTop = Math.abs(pointY - this.y);
          var pxFromYBottom = Math.abs(pointY - (this.y + this.length));

          //calibrate the corners given the pixels from the points
          var topLeft = pxFromXLeft + pxFromYTop;
          var topRight = pxFromXRight + pxFromYTop;
          var bottomLeft = pxFromXLeft + pxFromYBottom;
          var bottomRight = pxFromXRight + pxFromYBottom;

          //figure out the nearest corner given the smallest value from the calibrated corners
          var chosen = Math.min(topLeft, topRight, bottomLeft, bottomRight);

          var corner = 0;

          if(chosen == topLeft){

            corner = 1;

          } else if(chosen == topRight){

            corner = 2;

          }else if(chosen == bottomLeft){

            corner = 3;

          }else{

            corner = 4;

          }
          return corner;

        },
        /**
         * Lock the current corner given an X and Y point
         * @param mouseX
         * @param mouseY
         */
        setCurrentCorner: function(mouseX, mouseY){

          this.currentCorner = this.nearestCorner(mouseX, mouseY);

        },
        resetCorner: function(){

          this.currentCorner = 0;

        }


      }

      return CropSelection;
    }
);

/**
 * Created by ltischuk on 9/24/15.
 */
angular.module('imagecaptures')
    .factory('ImageCapturesSelectorDrawCanvas',
    function SelectorDrawCanvasFactory
        (ImageCapturesCropSelection)
    {

      /**
       * Class to control the crop canvas which controls the main canvas and
       * @param canvasElement - the canvasElement to draw on
       * @param maxLength - maximum length of the canvas
       * @param selectorLineWidth - the selector square line width
       * @param selectorColor - the selector square color
       * @param onSelectorMoveComplete - callback to execute after selector square move is complete
       * @constructor
       */
      function SelectorDrawCanvas(canvasElement, maxLength, selectorLineWidth, selectorColor,onSelectorMoveComplete){

        this.canvas = canvasElement;
        this.context = canvasElement[0].getContext('2d');
        this.maxLength = maxLength;
        this.cropSelector = new ImageCapturesCropSelection(maxLength);
        this.selectorLineWidth = selectorLineWidth;
        this.selectorColor = selectorColor;
        this.isSelecting = false;
        this.moveCorner = false;
        this.lastX = 0;
        this.lastY = 0;
        this.currentX = 0;
        this.currentY = 0;
        this.corner = 0;
        this.canvasLeftPos = 0;
        this.canvasTopPos = 0;
        this.onSelectorMoveComplete = onSelectorMoveComplete;
        this._addEventHandlers();

      }


      /**
       * Prototype methods getters/setters for public accessors
       *
       **/
      SelectorDrawCanvas.prototype = {

        /**
         * adds event handlers to the canvas for mouse events
         * @private
         */
        _addEventHandlers: function(){

          var that = this;

          //on mousedown event
          this.canvas.on('mousedown', function(e) {

            that._handleDown(e);

          });

          //on mouseup event
          this.canvas.on('mouseup', function(e) {

            that._handleUp(e);

          });

          //onmousemove event
          this.canvas.on('mousemove', function(e) {

            that._handleMove(e);

          });

          //onmouseout event
          this.canvas.on('mouseout', function(e){

            that._handleUp(e);

          });

          //on touchstart event
          this.canvas.on('touchstart', function(e) {

            that._handleDown(e);

          });

          //touchmove event
          this.canvas.on('touchmove', function(e) {

            that._handleMove(e);

          });

          //on touchend event
          this.canvas.on('touchend', function(e) {

            that._handleUp(e);

          });

          //on touchleave event
          this.canvas.on('touchleave', function(e) {

            that._handleUp(e);

          });

        },

        /**
         * Sets Canvas current relative position values
         * @private
         * @returns {undefined}
         */
        _setCanvasRelativePositionValues: function() {
          //obtain bounds for the rectangle to assess mouse/touch event points
          var rect = this.canvas[0].getBoundingClientRect();
          this.canvasLeftPos = rect.left;
          this.canvasTopPos = rect.top;
        },

        /**
         * Method to encapsulate functionality for when mousedown or touchstart event is fired
         * @param e
         * @private
         */
        _handleDown: function(e){

          e.preventDefault();
          var currentEvent = angular.isDefined(e.touches) ? e.touches[0] : e;
          var scrollX = document.body && document.body.scrollLeft !== null ? document.body.scrollLeft : document.documentElement.scrollLeft;
          var scrollY = document.body && document.body.scrollTop !== null ? document.body.scrollTop : document.documentElement.scrollTop;

          this._setCanvasRelativePositionValues();

          this.currentX = ((currentEvent.pageX ? currentEvent.pageX : e.clientX + scrollX) - this.canvasLeftPos);
          this.currentY = currentEvent.clientY - this.canvasTopPos;

          this.lastX = this.currentX;
          this.lastY = this.currentY;
          this.isSelecting = true;
          this.cropSelector.setCurrentCorner(this.currentX, this.currentY);

          //if in move zone which will move selector horizontally or vertically
          //change cursor and set moveCorner to false
          if(this.cropSelector.isInMoveZone(this.currentX, this.currentY)){

            this.canvas[0].style.cursor = 'move';
            this.moveCorner = false;

          }
          else{

            // we are in corner zone - find nearest corner and set moveCorner to true
            this.canvas[0].style.cursor = 'crosshair';
            this.corner = this.cropSelector.nearestCorner(this.currentX, this.currentY);
            this.moveCorner = true;

          }

        },
        /**
         * Method to encapsulate functionality for when mousemove or touchmove event is fired
         * @param e
         * @private
         */
        _handleMove: function(e){

          e.preventDefault();
          var currentEvent = angular.isDefined(e.touches) ? e.touches[0] : e;
          var scrollX = document.body && document.body.scrollLeft !== null ? document.body.scrollLeft : document.documentElement.scrollLeft;
          var scrollY = document.body && document.body.scrollTop !== null ? document.body.scrollTop : document.documentElement.scrollTop;;

          this.currentX = ((currentEvent.pageX ? currentEvent.pageX : e.clientX + scrollX) - this.canvasLeftPos);
          this.currentY = ((currentEvent.pageY ? currentEvent.pageY : e.clientY + scrollY) - this.canvasTopPos);

          //if we are not in isSelecting state yet, assess next move
          if(!this.isSelecting){

            if(this.cropSelector.isInMoveZone(this.currentX, this.currentY)){
              this.canvas[0].style.cursor = 'move';
            }
            else{

              this.canvas[0].style.cursor = 'crosshair';
              this.moveCorner = true;

            }

          }else{

            //we are in isSelecting state, draw the canvas, assess move, then redraw canvas
            this._drawCanvas();

            var xdiff = this.currentX - this.lastX;
            var ydiff = this.currentY - this.lastY;

            this.cropSelector.move(xdiff, ydiff, this.moveCorner, this.corner);
            this.lastX = this.currentX;
            this.lastY = this.currentY;
            this._drawCanvas();
          }

        },
        /**
         * Method to encapsulate functionality for when mouseup or touchend/touchcancel event is fired
         * @private
         */
        _handleUp: function(e){

          e.preventDefault();
          //turn selector guide variables off and output cropped image data from current selector location
          this.isSelecting = false;
          this.moveCorner = false;
          this.cropSelector.resetCorner();
          this._drawCanvas();
          this.canvas[0].style.cursor = 'default';
					this.onSelectorMoveComplete({dimensions:{x:this.cropSelector.x,y:this.cropSelector.y,length: this.cropSelector.length}});

        },
        /**
         * Method to redraw the canvas, image and selector square
         * @private
         */
        _drawCanvas: function(){

          //clear the selector rectangle first
          var canvasWidth = this.canvas[0].width;
          var canvasHeight = this.canvas[0].height;
          this.context.clearRect(0, 0, canvasWidth, canvasHeight);

          var selectorMiddleX = this.cropSelector.x + (this.cropSelector.length/2);
          var selectorMiddleY = this.cropSelector.y + (this.cropSelector.length/2);
          var arrowLength = this.cropSelector.length / 4;

          //then draw the rectangle
          this.context.lineWidth = this.selectorLineWidth;
          this.context.strokeStyle = this.selectorColor;
          this.context.strokeRect(this.cropSelector.x,this.cropSelector.y,this.cropSelector.length,this.cropSelector.length);

          this.context.beginPath();
          this.context.lineWidth = 1;
          this.context.moveTo(selectorMiddleX -4, selectorMiddleY);
          this.context.lineTo(selectorMiddleX + 4, selectorMiddleY);
          this.context.stroke();

          this.context.moveTo(selectorMiddleX, selectorMiddleY-4);
          this.context.lineTo(selectorMiddleX, selectorMiddleY+4);
          this.context.stroke();

          //draw an error in the bottom lefthand corner
          this.context.lineWidth = 2;
          this.context.moveTo(this.cropSelector.x + (this.cropSelector.length  - (arrowLength/4)), this.cropSelector.y + (this.cropSelector.length  - (arrowLength/4)));
          this.context.lineTo(this.cropSelector.x + (this.cropSelector.length  - (arrowLength/2)), this.cropSelector.y + (this.cropSelector.length  - (arrowLength/4)));
          this.context.lineTo(this.cropSelector.x + (this.cropSelector.length  - (arrowLength/4)), this.cropSelector.y + (this.cropSelector.length  - (arrowLength/2)));
          this.context.lineTo(this.cropSelector.x + (this.cropSelector.length  - (arrowLength/4)), this.cropSelector.y + (this.cropSelector.length  - (arrowLength/4)));
          this.context.closePath();
          this.context.fillStyle = this.selectorColor;
          this.context.fill();


        },
        /**
         * Opportunity to provide an object containing information regarding canvas width and height if needed
         * @returns {width: canvas width, height: canvas height}
         */
        getCropCanvasInfo: function(){

          return {

            width: this.canvas[0].width,
            height : this.canvas[0].height

          }

        },
        /**
         * Process a new image on the canvas and init variables for canvas and cropSelector
         * @param img
         */
        resetSelectorSquare: function(selectorStartX, selectorStartY, selectorStartLength){

          //initialize cropSelector dimensions
          this.cropSelector.initSelectorDimensions(this.canvas[0].width, this.canvas[0].height,
              selectorStartX, selectorStartY, selectorStartLength);

          //obtain bounds for the rectangle to assess mouse/touch event points
          var rect = this.canvas[0].getBoundingClientRect();
          this.canvasLeftPos = rect.left;
          this.canvasTopPos = rect.top;

          this._drawCanvas();
					this.onSelectorMoveComplete({dimensions:{x:this.cropSelector.x,y:this.cropSelector.y,length: this.cropSelector.length}});

        },
        /**
         * When parent scope is destroyed, clean up the DOM and remove elements
         */
        destroy: function(){

          this.canvas.off('mousedown',this._handleDown);
          this.canvas.off('mouseup',this._handleUp);
          this.canvas.off('mouseout',this._handleUp);
          this.canvas.off('mousemove',this._handleMove);
          this.canvas.off('touchstart',this._handleDown);
          this.canvas.off('touchmove',this._handleMove);
          this.canvas.off('touchleave',this._handleUp);
          this.canvas.off('touchend',this._handleUp);
         // this.canvas.remove();

        }

      }

      return SelectorDrawCanvas;

    }
);

/**
 * Created by ltischuk on 12/26/14.
 */
angular.module( 'imagecaptures' )
	.service
( 'ImageCapturesFaceRecognitionService',
	function
		(Language,
		Enums,
		Modal,
			$rootScope) {


		/** Wrapper using computer vision algorithm by Liu-liu to detect faces in images.
		 * This algorithm is most accurate with images of good resolution and quality.  Grainy images that
		 * do have faces may not produce desired results.
		 * */
		this.detectFace = function (imgSrcData, successCallback, failureCallback) {
			if (!imgSrcData) {
				Modal.displayModal({
					title: Language.getLocale('Alert','faceDetectionErrorTitle')
					, description: Language.getLocale('Alert','faceDetectionErrorMsg')
					, icon: 'icon-info red'
				});
			} else {
				runDetection(imgSrcData,
					{
						complete: function (img, faceCoords) {
							if (faceCoords.length === 0) {
								$rootScope.hideSpinner();
								Modal.displayModal({
									title: Language.getLocale('Alert','faceDetectionErrorTitle')
									, description: Language.getLocale('Alert','noFaceDetectedMsg')
									, icon: 'icon-info red'
									, buttonFlags : Enums.buttonFlags.OK
									, callback: function(select){
										if( select == Enums.buttonFlags.OK ) {
											if(failureCallback){
												failureCallback();
											}
										}

									}

								});
							} else {

								successCallback(img);
							}
						},
						error: function (img, code, message) {
							$rootScope.hideSpinner();
							console.log(message);
							Modal.displayModal({
								title: Language.getLocale('Alert','faceDetectionErrorTitle')
								, description: Language.getLocale('Alert','faceDetectionErrorMsg')
								, icon: 'icon-info red'
								, buttonFlags : Enums.buttonFlags.OK
								, callback: function(select){
									if( select == Enums.buttonFlags.OK ) {
										if(failureCallback){
											failureCallback();
										}
									}

								}
							});
						}
					});
			}

		}


		/**
		 * runDetection - run the detection algorithm taken from LuiLui - copyright by LiuLiu
		 * @private
		 * @param imageSrcData
		 * @param settings
		 */
		function runDetection(imageSrcData, settings) {
			var coords = [];
			var options = {
				confidence: null,
				start: function (img) {
				},
				complete: function (img, coords) {
				},
				error: function (img, code, message) {
				}
			}

			for (var key in settings) {
				options[key] = settings[key];
			}

			options.start(imageSrcData);

			var img = new Image();

			img.onload = function () {
				coords = detect();
				options.complete(img, coords);
				return coords;
			}

			img.src = imageSrcData;

			// Grayscale function by Liu Liu copyright
			function grayscale(image) {
				var canvas = document.createElement("canvas");
				var ctx = canvas.getContext("2d");

				canvas.width = image.width;
				canvas.height = image.height;

				ctx.drawImage(image, 0, 0);
				var imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
				var data = imageData.data;
				var pix1, pix2, pix = canvas.width * canvas.height * 4;
				while (pix > 0) {
					data[pix -= 4] = data[pix1 = pix + 1] = data[pix2 = pix + 2] = (data[pix] * 0.3 + data[pix1] * 0.59 + data[pix2] * 0.11);
				}
				ctx.putImageData(imageData, 0, 0);
				return canvas;
			}

			function detect() {
				try {
					var coords = ccv.detect_objects({
						'canvas': grayscale(img),
						'cascade': cascade,
						'interval': 5,
						'min_neighbors': 1
					});
				} catch (e) {

					options.error(img, 2, 'This image is not valid');
					return [];
				}

				var positionX = img.x;
				var positionY = img.y;
				var offsetX = img.offsetX;
				var offsetY = img.offsetY;
				var newCoords = [];

				for (var i = 0; i < coords.length; i++) {
					if (options.confidence == null || coords[i].confidence >= options.confidence) {
						newCoords.push({
							x: Math.round(coords[i].x),
							y: Math.round(coords[i].y),
							width: Math.round(coords[i].width),
							height: Math.round(coords[i].height),
							positionX: positionX + coords[i].x,
							positionY: positionY + coords[i].y,
							offsetX: offsetX + coords[i].x,
							offsetY: offsetY + coords[i].y,
							confidence: coords[i].confidence,
							neighbour: coords[i].neighbour
						});
					}
				}
				return newCoords;
			}

		}

	}
);

angular.module('imagecaptures')
	.factory('ImageCaptureTempImageService',
		function(
			ImageCapturesRequestService,
			ImageCapturePrepService,
			Modal,
			Language,
			Utilities,
			$http,
			$log,
			$q,
			$rootScope) {
			/**
			 * File/Blob/String(dataURL)
			 * @type {undefined}
			 */
			var currentTempFile;
			/**
			 * File name
			 * @type {String}
			 */
			var currentTempFileName = '';
			/**
			 * Orientation of the image (for uploaded images with EXIF data)
			 * @type {Number}
			 */
			var currentTempFileOrientation = 1;
			/**
			 * Original width of the image
			 * @type {Number}
			 */
			var origWidth = 1;
			/**
			 * Original height of the image
			 * @type {Number}
			 */
			var origHeight = 1;
			/**
			 * Current scale of the image
			 * @type {Number}
			 */
			var currentScale = 1;
			/**
			 * Max view width - for sizing the image for a viewable canvas
			 * @type {Number}
			 */
			var maxViewWidth = 300;
			/**
			 * Max view height - for sizing the image for a viewable canvas
			 * @type {Number}
			 */
			var maxViewHeight = 250;

			var maxSupportedCanvasSize = 2000;

			/**
			 * Exposed factory functions to the outside
			 * @type {Object}
			 */
			var factory = {
				clearTempFileInfo: clearTempFileInfo,
				saveTempFile: saveTempFile,
				setCurrentTempFileName: setCurrentTempFileName,
				getCurrentTempFile: getCurrentTempFile,
				getCurrentTempFileName: getCurrentTempFileName,
				transformCurrentTempFileIntoCanvas: transformCurrentTempFileIntoCanvas,
				getCroppedVersionOfTempFileIntoCanvs: getCroppedVersionOfTempFileIntoCanvs,
				getFinalizedImageDataUrl: getFinalizedImageDataUrl,
				sendFinalizedFilesForPassToAmazon: sendFinalizedFilesForPassToAmazon,
				resetTempFileInfoAndSetMaxViewDimensions: resetTempFileInfoAndSetMaxViewDimensions,
				preloadWebCamImagePromise: preloadWebCamImagePromise

			};

			return factory;

			function preloadWebCamImagePromise(imageProperties) {
				var preloadWebcamImagePromise = $q.defer();
				var currentTempFileName = angular.isDefined(factory.getCurrentTempFileName()) ? factory.getCurrentTempFileName() : '';

				function handlePreloadFailure() {
					$rootScope.hideSpinner();
					Modal.displayModal({
						title: Language.getLocale('ImageCapture', 'uploadErrorTitle'),
						description: Language.getLocale('ImageCapture', 'uploadErrorMsg'),
						icon: 'icon-info red'
					});
					preloadWebcamImagePromise.resolve();
				}

				if (imageProperties.sentImageFile && currentTempFileName !== imageProperties.imageFileName) {
					$rootScope.showSpinner();
					ImageCapturesRequestService.getFileFromAmazon(
						ImageCapturePrepService.settings.imageAWSbucketfolder + imageProperties.imageFileName).then(function(resp) {
						factory.saveTempFile(resp.data,
							imageProperties.imageFileName,
							imageProperties.imageOrientation).then(function() {
							$rootScope.hideSpinner();
							preloadWebcamImagePromise.resolve();
							imageProperties.imageCaptureInfoValid = true;
						}, handlePreloadFailure);
					}, handlePreloadFailure);
				} else {
					preloadWebcamImagePromise.resolve();
				}
				return preloadWebcamImagePromise.promise;
			}

			/**
			 * Changes the temp file name to desired value
			 * @public
			 * @function
			 * @param {String} name the file name
			 * @returns {undefined}
			 */
			function setCurrentTempFileName(name) {
				if (name) {
					currentTempFileName = name;
				}
			}

			/**
			 * Save a file, blob or string as a temporary file in memory on hand for views/controllers to access
			 * @param {Object} file
			 * @param {String} filename
			 * @param [orientation] - optional orientation
			 * @returns {*}
			 */
			function saveTempFile(file, filename, orientation) {
				var deferred = $q.defer();
				// First reset the temp file
				currentTempFile = null;
				// Now save it as the new file
				currentTempFile = file;
				currentTempFileName = filename;
				if (angular.isString(file)) {
					deferred.resolve();
				} else {
					var options = {
						canvas: true,
						maxWidth: maxSupportedCanvasSize,
						maxHeight: maxSupportedCanvasSize

					};
					// If we have a presaved orientation for this file, then lets use that so we don't have to parse meta data
					if (angular.isDefined(orientation)) {
						options.orientation = orientation;
						currentTempFileOrientation = angular.copy(options.orientation);
						if (!loadImage(currentTempFile, function(canvas) {
							origHeight = canvas.height;
							origWidth = canvas.width;

							deferred.resolve();
						}, options)) {
							deferred.reject();
						}
					} else {
						// Parse the metadata to obtain the EXIF orientation if provided and then load the image
						loadImage.parseMetaData(currentTempFile, function(data) {
							if (data.exif) {
								options.orientation = data.exif.get('Orientation');
								currentTempFileOrientation = angular.copy(options.orientation);
							}
							if (!loadImage(currentTempFile, function(canvas) {
								origHeight = canvas.height;
								origWidth = canvas.width;

								deferred.resolve();
							}, options)) {
								deferred.reject();
							}
						});
					}
				}
				return deferred.promise;
			}

			/**
			 * Get the current temp file that is stored
			 * @returns {File|Blob} The current temporary file
			 */
			function getCurrentTempFile() {
				return currentTempFile;
			}

			/**
			 * Get the current temp file name
			 * @returns {String} The current temporary file name
			 */
			function getCurrentTempFileName() {
				return currentTempFileName;
			}

			/**
			 * Clear the temp file information currently stored
			 * @returns {Boolean} Denotes the clearing of the file information
			 */
			function clearTempFileInfo() {
				currentTempFile = null;
				currentTempFileName = undefined;
				return true;
			}

			/**
			 * Reset and set the max view dimensions for usage of the canvas that gets created by this service
			 * @param {Number} width The width in pixels
			 * @param {Number} height The height in pixels
			 * @returns {undefined}
			 */
			function resetTempFileInfoAndSetMaxViewDimensions(width, height) {
				clearTempFileInfo();
				maxViewWidth = width;
				maxViewHeight = height;
			}

			/**
			 * Transform the current temp file into a canvas
			 * @param {Boolean} conformToMaxViewLength Whether to conform to the max view length
			 * @param {Object} file the file to transform to a canvas
			 * @returns {deferred.promise|{then, catch, finally}} the promise to resolve the canvas
			 */
			function transformCurrentTempFileIntoCanvas(conformToMaxViewLength, file) {
				var fileToLoad = file || currentTempFile;

				var deferred = $q.defer();
				var options = {
					canvas: true,
					orientation: currentTempFileOrientation
				};
				if (conformToMaxViewLength) {
					options.minWidth = maxViewWidth;
					options.maxWidth = maxViewWidth;
					options.maxHeight = maxViewHeight;
					options.minHeight = maxViewHeight;
				} else {
					options.maxWidth = maxSupportedCanvasSize;
					options.maxHeight = maxSupportedCanvasSize;
				}

				if (!loadImage(fileToLoad, function(canvas) {
					// At this point, the load image Javascript task has transformed the image to conform to the max
					// dimensions we can grab either the width or height and compare to the canvas and get our current scale
					currentScale = canvas.width / origWidth;
					deferred.resolve(canvas);
				}, options)) {
					deferred.reject();
				}

				return deferred.promise;
			}

			/**
			 * Get a cropped version of the temp file given particular coordinates into a canvas
			 * @param {Number} x the x dimension crop
			 * @param {Number} y the y dimension crop
			 * @param {Number} width the file width
			 * @param {Number} height the file height
			 * @param {Boolean} conformToMaxViewLength whether to conform to the max view length
			 * @returns {deferred.promise|{then, catch, finally}} The promise to resolve the cropped canvas
			 */
			function getCroppedVersionOfTempFileIntoCanvs(x, y, width, height, conformToMaxViewLength) {
				var deferred = $q.defer();
				var options = {
					canvas: true,
					orientation: currentTempFileOrientation
				};

				if (conformToMaxViewLength) {
					options.minWidth = maxViewWidth;
					options.maxWidth = maxViewWidth;
					options.maxHeight = maxViewHeight;
					options.minHeight = maxViewHeight;
				} else {
					options.maxWidth = maxSupportedCanvasSize;
					options.maxHeight = maxSupportedCanvasSize;
				}
				try {
					if (!loadImage(currentTempFile, function(canvas) {
						var croppedCanvas = loadImage.scale(canvas, {
							left: x,
							top: y,
							sourceWidth: width,
							sourceHeight: height,
							minWidth: conformToMaxViewLength ? maxViewWidth / 2 : ImageCapturePrepService.settings.saveImageWidth,
							maxWidth: conformToMaxViewLength ? maxViewWidth / 2 : ImageCapturePrepService.settings.saveImageHeight,
							crop: true
						});
						if (!(croppedCanvas instanceof HTMLCanvasElement)) {
							deferred.reject();
						} else {
							deferred.resolve(croppedCanvas);
						}
					}, options)) {
						deferred.reject();
					}
				} catch (e) {
					$log.error('Error retrieving temporary image from Amazon.')
					deferred.reject();
				}

				return deferred.promise;
			}

			/**
			 * Processes the current temp file through the resize/crop pipeline and resolves with
			 * a final data:image/jpeg URL, without uploading to any storage backend.
			 * Sets pass.imageOrientation as a side effect (same as sendFinalizedFilesForPassToAmazon).
			 * Used by the GPS photo upload path to obtain the processed image before a presigned PUT.
			 * @param {Object} pass The pass object (used for crop coordinates and orientation)
			 * @returns {Promise<string>} Resolves with a data:image/jpeg;base64,... string
			 */
			function getFinalizedImageDataUrl(pass) {
				var deferred = $q.defer();

				function handleImageToDataUrl(canvas) {
					pass.imageOrientation = currentTempFileOrientation;
					deferred.resolve(canvas.toDataURL('image/jpeg'));
				}

				function handleFileUploadToDataUrl() {
					var x = pass.cropX / currentScale;
					var y = pass.cropY / currentScale;
					var length = pass.cropLength / currentScale;
					getCroppedVersionOfTempFileIntoCanvs(x, y, length, length, false)
						.then(function(croppedCanvas) {
							pass.imageOrientation = currentTempFileOrientation;
							deferred.resolve(croppedCanvas.toDataURL('image/jpeg'));
						})
						.catch(function(err) { deferred.reject(err); });
				}

				function convertBlobAndGetDataUrl(blob) {
					var reader = new FileReader();
					reader.onload = function() {
						currentTempFile = reader.result;
						if (!loadImage(currentTempFile, handleImageToDataUrl, {
							canvas: true,
							maxWidth: ImageCapturePrepService.settings.saveImageWidth,
							minWidth: ImageCapturePrepService.settings.saveImageWidth,
							maxHeight: ImageCapturePrepService.settings.saveImageHeight,
							minHeight: ImageCapturePrepService.settings.saveImageHeight
						})) {
							deferred.reject(new Error('getFinalizedImageDataUrl: failed to load image after Blob conversion'));
						}
					};
					reader.onerror = function() {
						deferred.reject(new Error('getFinalizedImageDataUrl: failed to convert Blob to data URL'));
					};
					reader.readAsDataURL(blob);
				}

				if (angular.isDefined(currentTempFile)) {
					if (angular.isString(currentTempFile)) {
						if (!loadImage(currentTempFile, handleImageToDataUrl, {
							canvas: true,
							maxWidth: ImageCapturePrepService.settings.saveImageWidth,
							minWidth: ImageCapturePrepService.settings.saveImageWidth,
							maxHeight: ImageCapturePrepService.settings.saveImageHeight,
							minHeight: ImageCapturePrepService.settings.saveImageHeight
						})) {
							deferred.reject(new Error('getFinalizedImageDataUrl: failed to load image'));
						}
					} else if (currentTempFile instanceof Blob) {
						convertBlobAndGetDataUrl(currentTempFile);
					} else {
						handleFileUploadToDataUrl();
					}
				} else {
					deferred.reject(new Error('getFinalizedImageDataUrl: no temp file available'));
				}

				return deferred.promise;
			}

			/**
			 * Finalize the pass for amazon
			 * @param {Object} pass The pass object to finalize
			 * @returns {deferred.promise|{then, catch, finally}} The promise to resolve the finalized pass
			 */
			function sendFinalizedFilesForPassToAmazon(pass) {
				var deferred = $q.defer();

				function handleImage(canvas) {
					ImageCapturesRequestService.sendBase64EncodedImgToAmazonS3(currentTempFileName, canvas.toDataURL('image/jpeg'))
						.then(function() {
							pass.imageOrientation = currentTempFileOrientation;
							deferred.resolve();
						})
						.catch(function(sendBase64EncodedImgToAmazonS3Err) {
							deferred.reject(sendBase64EncodedImgToAmazonS3Err);
						});
				}

				function handleFileUpload() {
					currentTempFile = getCurrentTempFile();
					ImageCapturesRequestService.sendFileToAmazon(currentTempFile, 'tmp_' + currentTempFileName)
						.then(function(resp) {
							var x = pass.cropX / currentScale;
							var y = pass.cropY / currentScale;
							var length = pass.cropLength / currentScale;

							getCroppedVersionOfTempFileIntoCanvs(x, y, length, length, false)
								.then(function(croppedCanvas) {
									ImageCapturesRequestService.sendBase64EncodedImgToAmazonS3(currentTempFileName, croppedCanvas.toDataURL('image/jpeg'))
										.then(function() {
											pass.imageOrientation = currentTempFileOrientation;
											deferred.resolve();
										})
										.catch(function(sendBase64EncodedImgToAmazonS3Err) {
											deferred.reject(sendBase64EncodedImgToAmazonS3Err);
										});
								})
								.catch(function(getCroppedVersionOfTempFileErr) {
									deferred.reject(getCroppedVersionOfTempFileErr);
								});
						})
						.catch(function(sendFileToAmazonErr) {
							deferred.reject(sendFileToAmazonErr);
						});
				}

				function convertBlobToDataURL(blob) {
					var reader = new FileReader();
					reader.onload = function() {
						// Update currentTempFile to be the data URL string
						currentTempFile = reader.result;
						// Now process as a string (data URL)
						if (!loadImage(currentTempFile, handleImage, {
							canvas: true,
							maxWidth: ImageCapturePrepService.settings.saveImageWidth,
							minWidth: ImageCapturePrepService.settings.saveImageWidth,
							maxHeight: ImageCapturePrepService.settings.saveImageHeight,
							minHeight: ImageCapturePrepService.settings.saveImageHeight
						})) {
							deferred.reject(new Error('Failed to load image after Blob conversion'));
						}
					};
					reader.onerror = function() {
						console.error('ImageCaptureTempImageService: Failed to convert Blob to data URL');
						deferred.reject(new Error('Failed to convert Blob to data URL'));
					};
					reader.readAsDataURL(blob);
				}

				if (angular.isDefined(currentTempFile)) {
					if (angular.isString(currentTempFile)) {
						// Handle data URL strings
						if (!loadImage(currentTempFile, handleImage, {
							canvas: true,
							maxWidth: ImageCapturePrepService.settings.saveImageWidth,
							minWidth: ImageCapturePrepService.settings.saveImageWidth,
							maxHeight: ImageCapturePrepService.settings.saveImageHeight,
							minHeight: ImageCapturePrepService.settings.saveImageHeight
						})) {
							deferred.reject(new Error('Failed to load image'));
						}
					} else if (currentTempFile instanceof Blob) {
						// Convert Blob to data URL string first, then process
						convertBlobToDataURL(currentTempFile);
					} else {
						// Handle File objects and other cases through file upload
						handleFileUpload();
					}
				} else {
					deferred.reject(new Error('No temp file available'));
				}

				return deferred.promise;
			}
		}
	);
            /**
 * @ngdoc function
 * @name shoplandApp.directive:imageFileInput
 * @description
 * # fileread
 * Directive of the shoplandApp
 */
angular.module('imagecaptures')
    .directive('imageFileInput'
    , function (Modal,
                $rootScope,
                Language,
                ImageCapturePrepService) {
      return {
        restrict: 'A'
        , scope: {
          onFileUpload: '&'
          , errorMsg: '@'
          , errorTitle: '@'
        }
        , link: function (scope, elem, attrs) {

          elem.on('click', onElemClick);
					elem.on('change', onElemChange);


					/**
					 * Ensure that when the file chooser input button is clicked, the value of the element gets reset to prevent undesirable behavior
					 * @param event
					 */
					function onElemClick(event){

            this.value = '';
          }


					/**
					 * When we detect a new file, we should initiate the upload
					 * @param event
					 */
          function onElemChange(event) {

            event.preventDefault();
            $rootScope.showSpinner(Language.getLocale('ImageCapture', 'loadingImageCaptureMsg'), true);

            if (angular.isDefined(event.currentTarget) && angular.isDefined(event.currentTarget.files) &&
                event.currentTarget.files.length > 0) {

              var file = event.currentTarget.files[0];
              if (!isValidFile(file)) {

                $rootScope.hideSpinner();
                Modal.displayModal({
                  category: 'ImageCapture'
                  , action: 'File Select'
                  , label: 'Invalid File Selection'
                  , title: scope.errorTitle || 'Error'
                  , description: scope.errorMsg || 'Error uploading file, please try a different file.'
                  , icon: 'icon-info red'
                });

              } else {


                if (scope.onFileUpload) {

                  scope.onFileUpload({file: file});

                }
              }
            }
          }

          /**
           * isValidFile - method to determine if a file is valid
           * @param file
           * @returns {boolean}
           */
          function isValidFile(file) {
            if (file && file.size && file.type &&
                ((file.size / 1024).toFixed(3) <= ImageCapturePrepService.settings.maxFileSizeKb) &&
                ImageCapturePrepService.settings.acceptableImageTypes.indexOf(file.type) > -1) {
              return true;
            }
            return false;
          }


					/**
					 * Remove all DOM elements once destroyed
					 */
					scope.$on('$destroy', function() {

						elem.find('input').remove();

					});

        }
      }
    });

(function() {
	'use strict';

	angular
		.module('imagecaptures')
		.directive('webcamPhotoCapture', webcamPhotoCaptureDirective)

	/**
	 * The shared streamObj instance
	 * @var {MediaStream}
	 */
	var streamObj = null;

	/**
	 * webcamPhotoCapture Directive
	 * @param {Service} Language Language
	 * @param {Service} Utilities Utilities
	 * @param {Service} UtilsValidation UtilsValidation
	 * @returns {self} webcamPhotoCapture directive
	 * @ngInject
	 */
	function webcamPhotoCaptureDirective(Language, Utilities, UtilsValidation) {
		return {
			controller: function($scope) {
				var checkProp = Utilities.safelyCheckPropertyOnObject;

				//assess if we can stream (set by ImageCapture service)
				$scope.canStream = checkProp('navigator.mediaDevices.getUserMedia', navigator) ? true : false;

				//message to display to the user depending on whether or not the webcam is available, erroring or loading
				$scope.notStreamingMsg = Language.getLocale('ImageCapture', 'loadingWebCamMsg');

				//message to display whether or not the view should display the webcam view or the photo capture
				$scope.isReadyForPhoto = false;

				$scope.takePhotoButtonClass = angular.isDefined($scope.takePhotoButtonClass)? $scope.takePhotoButtonClass : 'col-sm-4 col-sm-offset-4 text-center';

				/**
				 * Error callback Function called if navigator.getMedia fails
				 * @public
				 * @returns {undefined}
				 */
				function errorCallback() {
					$scope.canStream = false;
					$scope.notStreamingMsg = Language.getLocale('ImageCapture', 'errorDisplayingWebCamMsg');
				}

				/**
				 * Success callback function called if navigator.getMedia succeeds
				 * @public
				 * @param {MediaStream} stream - The MediaStream object from the promise
				 * @returns {undefined}
				 */
				$scope.onUserMediaSuccess = function(stream) {
					// Attempt to destory existing stream if one exists
					$scope.destroyStream();

					var webCamVideoDiv = $scope.getChildElementById('ic-webcam-video');
					webCamVideoDiv.srcObject = stream;
					webCamVideoDiv.play();

					$scope.setStream(stream);
				};

				/**
				 * Destroys the stream object and shuts down the webcam
				 * @public
				 * @returns {undefined}
				 */
				$scope.destroyStream = function() {
					var tracks,
						stmObj = $scope.getStream();

					if (checkProp('stmObj.getTracks', stmObj)) {
						tracks = stmObj.getTracks();
						if (UtilsValidation.validArray(tracks)) {
							tracks.forEach(function(track) {
								track.stop();
							});
						}
					}

					$scope.setStream(null);
				};

				/**
				 * Sets the global stream object
				 * @public
				 * @param {MediaStream} stream - The Media Stream Object
				 * @throws TypeError
				 * @returns {undefined}
				 */
				$scope.setStream = function(stream) {
					// For browsers that do not support MediaStream
					if (!$scope.canStream) {
						return;
					}

					if (stream !== null && !(stream instanceof window.MediaStream)) {
						throw new TypeError('stream must be of type null or MediaStream');
					}

					streamObj = stream;
				};

				/**
				 * Gets the global stream object
				 * @public
				 * @returns {MediaStream} stream object instance
				 */
				$scope.getStream = function() {
					return streamObj;
				};

				// On destroy event
				$scope.$on('$destroy', $scope.destroyStream);

				/**
				 * Initialize this directive controller by assessing the getMedia obj (set in the Image Capture service singelton instance)
				 * @public
				 * @returns {undefined}
				 */
				$scope.init = function() {
					if ($scope.canStream) {
						navigator.mediaDevices
							.getUserMedia({
								audio: false,
								video: true
							})
							.then($scope.onUserMediaSuccess)
							.catch(errorCallback);
					} else {
						$scope.notStreamingMsg = Language.getLocale('ImageCapture', 'errorUnsupportedWebCamMsg');
					}
				};
			},
			link: function(scope, element) {
				var webCamVideoDiv;
				scope.i18n = Language;
				scope.streaming = false;
				// just storing a reference to the dom object of this directive
				scope.element = element;
				scope.getChildElementById = function(id) {
					return scope.element[0].querySelector('#'+id);
				};
				//initialize the scope
				scope.init();

				webCamVideoDiv = scope.getChildElementById('ic-webcam-video');

				/**
				 * canplay -EventListener
				 * If the webcam canplay then we can go ahead and stream the webcam
				 */
				webCamVideoDiv.addEventListener('canplay', function(ev) {
					if (!scope.streaming) {
						scope.$apply(function() {
							scope.streaming = true;
						});
					}
				}, false);

				/**
				 * capturePhoto - capture the photo from the webcam and size to a square
				 * @returns {undefined}
				 */
				scope.capturePhoto = function() {
					var webCamCanvasDiv = scope.getChildElementById('ic-webcam-canvas');
					var width = webCamVideoDiv.clientWidth;
					var data;

					//Firefox needs these set here
					var videoWidth = webCamVideoDiv.videoWidth;
					var videoHeight = webCamVideoDiv.videoHeight;
					//we will size the captured photo from the webcam to whichever is the least (width or height)
					//the placeholder face image is always in the center so that the user will be prompted to place the face in the center
					var confirmedCaptureLength = Math.min(videoWidth, videoHeight);

					//we then obtain how far from the left or top we should cut off of the sides or top of the video player to obtain a perfect square
					var x = (videoWidth > videoHeight ? Math.floor(((videoWidth - videoHeight) /2)) : 0);
					var y = (videoWidth < videoHeight ? Math.floor(((videoHeight - videoWidth) /2)) : 0);

					//compute the size of the canvas that we will display in the current HTML view as the result
					//this will get resized appropriately when we send to amazon
					var resultCanvasLength = Math.min((videoHeight / (videoWidth / width)), width);
					webCamCanvasDiv.setAttribute('width', resultCanvasLength);
					webCamCanvasDiv.setAttribute('height', resultCanvasLength);
					webCamCanvasDiv.getContext('2d').drawImage(webCamVideoDiv, x, y, confirmedCaptureLength, confirmedCaptureLength, 0, 0, resultCanvasLength, resultCanvasLength);

					data = webCamCanvasDiv.toDataURL('image/jpeg');
					scope.onCapturePhoto({ dataURL: data });
				}

				scope.webCamDisabled = (scope.canStream && scope.streaming);
			},
			restrict: 'E',
			scope: {
				onCapturePhoto: '&',
				takePhotoButtonClass: '@'
			},
			templateUrl: '/scripts/modules/extraflow/imagecaptures/views/webcam-directive.html',
			}
	}
})();

/**
 * @ngdoc function
 * @name shoplandApp.directive:resultCanvas
 * @description
 * # fileread
 * Directive of the shoplandApp
 */
angular.module('imagecaptures')
	.directive('cropCanvas', function (
		ImageCaptureTempImageService,
		ImageCapturesSelectorDrawCanvas,
		$rootScope,
		Language,
		$timeout,
		$window
	) {
		return {
			restrict: 'E',
			scope: {
				onCropSelectorMoveComplete: '&',
				deferDrawing: '=',
				pass: '<'
			},
			link: function (scope, elem, attrs) {
				var overlayCanvas = null;

				// if we're not deferring the drawing of the image, draw it right away
				if (!scope.deferDrawing) {
					$rootScope.showSpinner(Language.getLocaleMerchant('ImageCapture', 'loadingImageCaptureMsg'), true);
					ImageCaptureTempImageService.transformCurrentTempFileIntoCanvas(true).then(function(canvas) {
						createAndAppendCanvasToDOM(canvas);
					});
				} else {
					// if we are deferring the image drawing, set up a listener to be able to draw it as needed.
					scope.$on('drawUploadedImage',  function(event) {
						removeCanvasAndRedraw();
					});
				}

					/**
					 * Create the cropCanvas with selector crop feature and append the canvas to the DOM
					 * @param canvas
					 */
					function createAndAppendCanvasToDOM(canvas){

						var parentDiv = elem.parent();
						parentDiv.css({

							width: canvas.width + 'px'

						});

						var imgCanvas = angular.element(canvas);
						imgCanvas.css({
							border: 'solid 2px #000000',
							position: 'absolute',
							left: '0px',
							top: '0px',
							zIndex: '0'
						});


						elem.append(imgCanvas);

						var maxLength = Math.min(canvas.width, canvas.height);
						var cropCanvas = angular.element('<canvas>');
						cropCanvas[0].width = canvas.width;
						cropCanvas[0].height = canvas.height;
						overlayCanvas = new ImageCapturesSelectorDrawCanvas(cropCanvas,maxLength,2,'#ff0000',scope.onCropSelectorMoveComplete);

						cropCanvas.css({

							position: 'absolute',
							left: '0px',
							top: '0px',
							zIndex: '1'

						});

						elem.append(cropCanvas);
						overlayCanvas.resetSelectorSquare();
						$rootScope.hideSpinner();


					}

					function removeCanvasAndRedraw(){

						$timeout(function(){

							$rootScope.showSpinner(Language.getLocale('ImageCapture','loadingImageCaptureMsg'),true);

                          if (overlayCanvas) {
							overlayCanvas.destroy();
                          }

							var canvases = elem.find('canvas');
							canvases.remove();

							ImageCaptureTempImageService.transformCurrentTempFileIntoCanvas(true).then(function(canvas){

								createAndAppendCanvasToDOM(canvas);

							});
						},200);


					}

					//add the orientationchange event listener
					$window.addEventListener('orientationchange', removeCanvasAndRedraw, false);

					/**
					 * Remove all DOM elements once destroyed
					 */
					scope.$on('$destroy', function() {

						//remove orientationchange event listener and destroy the cropCanvas
						$window.removeEventListener('orientationchange',removeCanvasAndRedraw, false);
                      if (overlayCanvas) {
						overlayCanvas.destroy();
                      }
						var canvases = elem.find('canvas');
						canvases.remove();
						elem.remove();

					});

        }
      }
    });

/**
 * @ngdoc function
 * @name shoplandApp.directive:resultCanvas
 * @description
 * # fileread
 * Directive of the shoplandApp
 */
angular.module('imagecaptures')
    .directive('resultCanvas'
    , function () {
      return {
        restrict: 'E'
        , scope: {
          x : '@',
          y : '@',
          width : '@',
          height : '@',
          image : '='
        },
        template: '<canvas></canvas>'
        , link: function (scope, elem, attrs) {

          var canvas = elem.find('canvas');
          var ctx = canvas[0].getContext('2d');
          canvas[0].width = 250;
          canvas[0].height = 250;

          /// draw source image into the canvas:
          ctx.drawImage(scope.image, Number(scope.x), Number(scope.y), Number(scope.width), Number(scope.height), 0, 0, canvas[0].width, canvas[0].height);

        }
      }
    });

angular.module('imagecaptures')
	.controller(
		'ImageCaptureController'
		,function
			($rootScope
				,$scope
				,$state
				,$stateParams
				,ClientInfo
				,Enums
				,GuestProfileImageService
				,ImageCapturesFinalizeService
				,ImageCaptureTempImageService
				,ImageCapturePrepService
				,ImageCapturesRoutingService
				,passCollection
				,Language
				,Modal
				,Package){

			$scope.i18n = Language;
			$scope.viewSettings = ImageCapturePrepService.settings;
			$scope.passCollection = passCollection;
			$scope.isMobile = ClientInfo.deviceType !== 'desktop';

			/**
			 * Cancel Image Capture and go back to previous XMC or screen
			 * @public
			 */
			$scope.cancel = function(){

				var pass = $scope.passCollection.getActivePass();
				pass.valid = false;
				if($state.current.name === 'imageCapture.selection' && pass.itemsAddedIndex > 0){

					setPreviousPassActive();

				}else{

					var route = ImageCapturesRoutingService.getRouteForPreviousStep($state.current.name);
					if(route.length > 0){

						if(route === 'imageCapture.selection'){

							pass.resetSelections();

						}
						$rootScope.routeTo($state.href(route,{packageId:$stateParams.packageId,passIndex:pass.itemsAddedIndex}));

					}else{

						// Prompt user to cancel and if yes, cancel XMC
						Modal.displayModal({
							title:Language.getLocale('Alert','cancelImageCaptureTitle')
							,description:Language.getLocale('Alert','cancelImageCaptureMsg')
							,icon:'icon-info red'
							,buttonFlags:[Enums.buttonFlags.NO,Enums.buttonFlags.YES]
							,callback:function(detail){
								if(detail == Enums.buttonFlags.YES){
									Package.cancelXFC();
								}
							}
						});

					}

				}


			}

			/**
			 * Assess state and if image capture status is valid, save image capture data and move forward to next XMC
			 * Otherwise, display a message to the user that current selections are not complete
			 * @public
			 */
			$scope.continue = function(){
				var pass = $scope.passCollection.getActivePass();
				if(pass.valid){

					if((pass.imageMethod === Enums.imageCaptureMethodTypes.UPLOAD || pass.imageMethod === Enums.imageCaptureMethodTypes.WEBCAM) && !pass.sentImageFile){

						$rootScope.showSpinner();

						// GPS path: upload photo via GPS presigned S3 PUT URL instead of the legacy node-api S3 proxy
						var uploadPromise = $rootScope.configuredForPassportAuth
							? GuestProfileImageService.uploadPhoto(pass.guest_no, pass)
							: ImageCaptureTempImageService.sendFinalizedFilesForPassToAmazon(pass);

						uploadPromise.then(function(resp){
							pass.sentImageFile = true;
							setNextPassActive();

						},function(err){
							$rootScope.hideSpinner();
							showUploadFinalizationError();
						});

					}else{

						setNextPassActive();

					}

				}
			}

			$scope.routeToNextStepForActivePass = function(){

				var pass = $scope.passCollection.getActivePass();
				var nextRoute = ImageCapturesRoutingService.checkPassValidationAndGetNextState(pass);
				$rootScope.routeTo($state.href(nextRoute,{packageId:$stateParams.packageId,passIndex:pass.itemsAddedIndex}));


			}

			/**
			 * Sets the current active pass given an index
			 * Allow toggle only if current pass is valid, or index we are toggling to is valid or the
			 * @public
			 * @param  {[type]} index [description]
			 */
			$scope.toggleForm = function(index){
				var pass = $scope.passCollection.getActivePass();
				var nextPass = $scope.passCollection.findPassByIndex(index);

				if(pass.valid && nextPass.valid && $scope.passCollection.isImageMethodValidForGivenPass(pass)){

					$scope.passCollection.setActivePass(nextPass);
					$scope.routeToNextStepForActivePass();

				}
			}


			function setNextPassActive(){

				var pass = $scope.passCollection.getActivePass();
				var nextPass = $scope.passCollection.getNextPass();
				if(angular.isDefined(nextPass)){

					$scope.passCollection.setActivePass(nextPass);
					$scope.routeToNextStepForActivePass();

				}else if(pass.imageMethod){
					// Add reference of XFC to CHARACs.
					$scope.finalizing = true;
					ImageCapturesFinalizeService.finalizeXFCCharacs($scope.passCollection,false);
					Package.nextXFC();
				}

			}

			function setPreviousPassActive(){

				var previousPass = $scope.passCollection.getPreviousPass();
				if(angular.isDefined(previousPass)){

					$scope.passCollection.setActivePass(previousPass);
					$scope.routeToNextStepForActivePass();

				}

			}

			/**
			 * Present a modal to the user if for any reason when we attempt to save an uploaded image or webcam photo to Amazon, an error occurs
			 */
			function showUploadFinalizationError(){

				// Prompt user to cancel and if yes, cancel XMC
				Modal.displayModal({
					title:Language.getLocale('ImageCapture','uploadErrorTitle')
					,description:Language.getLocale('ImageCapture','uploadErrorMsg')
					,icon:'icon-info red'
					,buttonFlags:[Enums.buttonFlags.NO,Enums.buttonFlags.YES]
					,callback:function(){

						//direct user back to selection
						$rootScope.routeTo($state.href('imageCapture.selection',{
							packageId:$stateParams.packageId,
							passIndex:$scope.passCollection.getActivePass().itemsAddedIndex
						}));
					}
				});

			}

		});

/**
 * Created by ltischuk on 1/15/16.
 */
/**
 * Created by ltischuk on 7/28/15.
 */
angular.module('imagecaptures')
	.controller(
		'ImageCaptureSelectionController'
		, function
			(	$rootScope
				, $scope
				, $state
				, ImageCapturePrepService
				, passCollection
			){

			$scope.viewSettings = ImageCapturePrepService.settings;
			$scope.passCollection = passCollection;

			$scope.selectImageMethod = function(method){

				var pass = $scope.passCollection.getActivePass();
				pass.imageMethod = method;
				$scope.routeToNextStepForActivePass();

			}


		});

angular.module('imagecaptures')
  .controller(
  	 'ImageCaptureUploadController'
  	, function
  	(	$rootScope
		, $scope
		, $state
		, $stateParams
		, ImageCapturePrepService
		, passCollection
		){

		$scope.viewSettings = ImageCapturePrepService.settings;
		$scope.passCollection = passCollection;
		$scope.activePass = passCollection.getActivePass();

		$scope.backToSelection = function(){
			$scope.passCollection.getActivePass().resetSelections();
			$rootScope.routeTo($state.href('imageCapture.selection', {packageId: $stateParams.packageId,passIndex:$stateParams.passIndex}));

		}

			function initializeController(){

				//promises will be running for the state, if we successfully route here, lets hide the spinner
				$rootScope.hideSpinner();

			}

			initializeController();



		});

angular.module('imagecaptures')
	.controller(
	'ImageCaptureUploadFileChooserController'
	, function
		(	$rootScope
			, $scope
			, $state
			, $stateParams
			, ImageCaptureTempImageService
			, ImageCapturePrepService
			, passCollection
			, Language
			, Modal
		){

		$scope.viewSettings = ImageCapturePrepService.settings;
		$scope.activePass = passCollection.getActivePass();
		$scope.activePass.valid = false;
		$scope.maxFileSizeLbl = Language.ImageCapture.maxFileSizeLabel + ' ' + ImageCapturePrepService.settings.maxFileSizeKb + ' KB';

		/**
		* getFileAction - triggers the click of the input file tag via another button if supported
		* @public
		* @param{String} id - the CSS element to complete the action on
		*/
		$scope.getFileAction = function(id){
			if(!window.FileReader){
				Modal.displayModal({
					title: Language.getLocale('Alert','fileUploadNotSupportedTitle')
					, description: Language.getLocale('Alert','fileUploadNotSupportedMsg')
					, icon: 'icon-info red'
				});
			}else{
				document.getElementById(id).click();
			}
		}

		/**
		 * Upon successful file upload, handle canvas initialization and facial recognition
		 * @param file
		 */
		$scope.onFileUpload = function(file){

			$rootScope.showSpinner(Language.getLocale('ImageCapture', 'loadingImageCaptureMsg'),true);
			ImageCaptureTempImageService.saveTempFile(file, $scope.activePass.imageFileName, $scope.activePass.imageOrientation).then(function(){

				$scope.activePass.sentImageFile = false;
				$rootScope.routeTo($state.href('imageCapture.upload.crop', {packageId: $stateParams.packageId,passIndex: $scope.activePass.itemsAddedIndex, attempt:1}));

			},function(err){

				Modal.displayModal({
					title: Language.getLocale('ImageCapture','uploadErrorTitle')
					, description: Language.getLocale('ImageCapture','uploadErrorMsg')
					, icon: 'icon-info red'
				});

			});

		}


	});

angular.module('imagecaptures')
	.controller(
	'ImageCaptureUploadCropController'
	, function
		(	$rootScope
			, $scope
			, $state
			, $stateParams
			, ClientInfo
			, ImageCaptureTempImageService
			, ImageCapturePrepService
			, passCollection
			, Language
			, Modal
		){

		$scope.viewSettings = ImageCapturePrepService.settings;
		$scope.activePass = passCollection.getActivePass();

		/**
		 * getFileAction - triggers the click of the input file tag via another button if supported
		 * @public
		 * @param{String} id - the CSS element to complete the action on
		 */
		$scope.getFileAction = function(id){
			if(!window.FileReader){
				Modal.displayModal({
					category: 'Image Capture'
					, action: 'Info'
				 	, label: 'File Type or Image Not Supported'
					, title: Language.getLocale('Alert','fileUploadNotSupportedTitle')
					, description: Language.getLocale('Alert','fileUploadNotSupportedMsg')
					, icon: 'icon-info red'
				});
			}else{
				document.getElementById(id).click();
			}
		}

		/**
		 * Upon successful file upload, handle canvas initialization and facial recognition
		 * @param file
		 */
		$scope.onFileUpload = function(file){

			$scope.activePass.cropX = undefined;
			$scope.activePass.cropY = undefined;
			$scope.activePass.cropLength = undefined;

			ImageCaptureTempImageService.saveTempFile(file, $scope.activePass.imageFileName, $scope.activePass.imageOrientation).then(function(){
				$scope.activePass.sentImageFile = false;
				$rootScope.routeTo($state.href('imageCapture.upload.crop', {packageId: $stateParams.packageId,passIndex: $scope.activePass.itemsAddedIndex,attempt:Number($stateParams.attempt)+1}));

			});

		}

		/**
		 * Each time the image is processed and recalibrated and redrawn, show a spinner
		 * as the process can take a second due to rotation requirement on mobile
		 */
		$scope.showSpinnerOnCanvasProcessing = function(){

			$rootScope.showSpinner(Language.getLocale('ImageCapture', 'processingImageCaptureForCropMsg'),true);

		}

		$scope.updateActivePassCropDimensions = function(dimensions){

			$scope.activePass.cropX = angular.copy(dimensions.x);
			$scope.activePass.cropY = angular.copy(dimensions.y);
			$scope.activePass.cropLength = angular.copy(dimensions.length);

		}

		/**
		 * Crop the image to the desired coordinates
		 */
		$scope.crop = function(){

			$scope.activePass.valid = true;
			$rootScope.routeTo($state.href('imageCapture.upload.crop-result', {packageId: $stateParams.packageId, passIndex: passCollection.passes.indexOf($scope.activePass)}));

		}

		/**
		 * Called once the cropimage directive finishes processing the image and initializing selector on the canvas
		 * @param canvasInfo
		 */
		$scope.postImageCropCanvasProcessing = function(canvasInfo){

			if(ClientInfo.deviceType !== 'desktop'){

				var canvasWidth = canvasInfo.width;
				var canvasHeight = canvasInfo.height;
				var easelDiv = angular.element(document.querySelector('#ic-easel'));

				angular.element(document.querySelector('#corner-icon-file-upload-container')).css({
					top: (easelDiv[0].offsetHeight/2) - (canvasHeight/2) + 'px',
					left: (easelDiv[0].offsetWidth/2) - (canvasWidth/2) + 4 + 'px'
				});

			}
			$rootScope.hideSpinner();

		}

			function initializeController(){

				$scope.activePass.sentImageFile = false;

			}

			initializeController();

	});

angular.module('imagecaptures')
	.controller(
	'ImageCaptureUploadCropResultController'
	, function
		(	$rootScope
			, $scope
			, $state
			, $stateParams
			, imageForPass
			, ImageCapturePrepService
			, ImageCaptureTempImageService
		){

		$scope.viewSettings = ImageCapturePrepService.settings;
		$scope.imgFile = ImageCaptureTempImageService.getCurrentTempFile();
		$scope.canvasElement = imageForPass;

		$scope.revertCrop = function(){

			$scope.activePass.valid = false;
			$rootScope.routeTo($state.href('imageCapture.upload.crop', {packageId: $stateParams.packageId, passIndex: $scope.activePass.itemsAddedIndex, attempt: 1}));

		}


	});

/**
 * Created by ltischuk on 7/28/15.
 */
angular.module('imagecaptures')
	.controller(
	'ImageCaptureOnsiteController'
	, function
		(	$rootScope
			, $scope
			, $state
			, $stateParams
			, ImageCapturePrepService
			, passCollection
		){

		$scope.viewSettings = ImageCapturePrepService.settings;
		$scope.passCollection = passCollection;

		$scope.backToSelection = function(){
			$scope.passCollection.getActivePass().resetSelections();
			$rootScope.routeTo($state.href('imageCapture.selection', {packageId: $stateParams.packageId, passIndex: $stateParams.passIndex}));

		}


	});

/**
 * Created by ltischuk on 7/28/15.
 */
angular.module('imagecaptures')
	.controller(
	'ImageCaptureMailController'
	, function
		(	$rootScope
			, $scope
			, $state
			, $stateParams
			, ImageCapturePrepService
			, passCollection
		){

		$scope.viewSettings = ImageCapturePrepService.settings;
		$scope.passCollection = passCollection;

		$scope.backToSelection = function(){
			$scope.passCollection.getActivePass().resetSelections();
			$rootScope.routeTo($state.href('imageCapture.selection', {packageId: $stateParams.packageId, passIndex: $stateParams.passIndex}));

		}


	});

/**
 * Created by ltischuk on 7/28/15.
 */
angular.module('imagecaptures')
	.controller(
	'ImageCaptureWebcamController'
	, function
		(	$rootScope
			, $scope
			, $state
			, $stateParams
			, ImageCapturePrepService
			, passCollection
		){

		$scope.viewSettings = ImageCapturePrepService.settings;
		$scope.passCollection = passCollection;
		passCollection.setActivePass(passCollection.findPassByIndex($stateParams.passIndex));

		$scope.backToSelection = function(){
			$scope.passCollection.getActivePass().resetSelections();
			$rootScope.routeTo($state.href('imageCapture.selection', {packageId: $stateParams.packageId,passIndex: $stateParams.passIndex}));

		}


	});

/**
 * Created by ltischuk on 7/28/15.
 */
angular.module('imagecaptures')
	.controller(
	'ImageCaptureWebcamResultController'
	, function
		(	$rootScope
			, $scope
			, $state
			, $stateParams
			, ImageCapturePrepService
			, passCollection
			, webcamResultCanvas
		){

		$scope.viewSettings = ImageCapturePrepService.settings;
		$scope.activePass = passCollection.getActivePass();
		$scope.canvasElement = webcamResultCanvas;

		$scope.revertCapture = function(){
			$scope.activePass.valid = false;
			$rootScope.routeTo($state.href('imageCapture.webcam.take-photo', {passIndex: $stateParams.passIndex, packageId: $stateParams.packageId}));

		}

			$rootScope.hideSpinner();


	});

angular.module('imagecaptures')
	.controller('ImageCaptureWebcamTakePhotoController',
		function (
			$rootScope,
			$scope,
			$state,
			$stateParams,
			ImageCapturePrepService,
			ImageCaptureTempImageService,
			passCollection
		) {
			$scope.viewSettings = ImageCapturePrepService.settings;
			$scope.activePass = passCollection.getActivePass();

			/**
			 * On Capture of the photo, validate the current pass and
			 * @param {String} dataURL the data URL for the image
			 * @returns {undefined}
			 */
			$scope.onCapturePhoto = function(dataURL) {
				ImageCaptureTempImageService.saveTempFile(dataURL, $scope.activePass.imageFileName).then(function (result) {
					$scope.activePass.valid = true;

					$scope.activePass.sentImageFile = false;
					$rootScope.routeTo($state.href('imageCapture.webcam.result', {
						packageId: $stateParams.packageId,
						passIndex: $stateParams.passIndex
					}));
				});
			};

			$rootScope.hideSpinner();
		});

angular.module('comp-selection', ['app'])
	.config(function ($locationProvider, $stateProvider) {

		$stateProvider
			.state('compSelection', {
				url: '/compSelection/:packageId',
				templateUrl: '/scripts/modules/extraflow/comp-selection/selection.html',
				controller: 'CompSelectionController',
				resolve: {
					initialData: function(Bootstrap) {
						return Bootstrap.bootstrapApplication();
					},
					xfcMap: function(initialData, Package) {
						return Package.buildXFCMap();
					},
					compData: function(xfcMap, $transition$, CompSelectionService) {
						return CompSelectionService.initialize($transition$.params());
					}
				}
			});

	})
	.run(function(ExtraFlow, Enums){
		// Register this extra flow module with the extra flow service
		ExtraFlow.registerXMC
			( 'comp_selection',
				{ name: 'comp_selection',
					view: 'compSelection',
					lockQuantity: true,
					doEditMode: false,
					writeSingleCharac: false,
					enabled: true,
					type: 'extraFlowControl'
				}
			);
	});

angular.module('app')
	.controller('CompSelectionController', function(
		$scope,
		$rootScope,
		$filter ,
		$state,
		Package,
		Language,
		ExtraFlow,
		AppData,
		Modal,
		Enums,
		Utilities,
		CompSelectionService,
		LegacyCart,
		ClientInfo) {

		$scope.packageDetails = Package.packageDetails;

		$scope.currentTab = "PackageDetails";

		function initialize() {
			$scope.compCollection = CompSelectionService.compCollection;

			angular.forEach($scope.compCollection, function( pkg ) {
				pkg.onQuantityChange = angular.bind(null, onQuantityChange, pkg);
			});
		}

		/**
		 *	Fired by the <quantity> stepper on every qty change (button click or manual
		 *	edit). Routes to the same Package methods the legacy per-button/blur handlers
		 *	called, keyed off the change event's inputBlur/isIncrement/isDecrement flags —
		 *	inputBlur is checked first since it's the manual-edit signal (Package.onQtyChange
		 *	is the only one of the three that shows out-of-range Modal errors and emits
		 *	'qtyChanged').
		 *
		 *	@param {object} data the rateType where you want to make the quantity adjustment at.
		 *	@param {object} event the <quantity> on-change payload ({ qty, id, inputBlur, isDecrement, isIncrement }).
		 *	@return undefined
		 */

		function onQuantityChange( data, event ) {
			// <quantity> already commits the post-click value to data.qty via
			// ng-model before this handler runs; revert by one so incrementQty/
			// decrementQty's own relative +1/-1 nets out to a single change.
			if ( event.inputBlur ) {
				Package.onQtyChange( data, false );
			} else if ( event.isIncrement ) {
				data.qty -= 1;
				Package.incrementQty( data );
			} else if ( event.isDecrement ) {
				data.qty += 1;
				Package.decrementQty( data, false );
			}
		}

		$scope.back = function() {
			Package.cancelXFC();
		}

		$scope.proceed = function() {

			// verify minimum quantity
			if($scope.compCollection[0].qty < $scope.compCollection[0].min_quantity) {
				LegacyCart.handleMinQtyModal($scope.compCollection[0]);
				$scope.compCollection[0].qty = $scope.compCollection[0].min_quantity;
				return;
			}

			CompSelectionService.save();
		}

		initialize();
	}

);

angular.module( 'comp-selection' )
	.service( 'CompSelectionService', function(
		AppData,
		$rootScope,
		$log,
		$q,
		Enums,
		Package,
		Utilities,
		ExtraFlow,
		Language) {

		this.initialize = function(stateParams) {

			var promise = $q.defer();

			if( !Package.initXFC() ){
				// Return a failed promise, Package service is not initialized
				promise.reject({
					redirect: '/packageList'
				});

				return promise.promise;
			}

			promise.resolve();
			this.buildCompCollection(stateParams.packageId);

			return promise.promise;
		}

		this.buildCompCollection = function(packageId) {
			var compCollection = [];

			removeCurrentCompsFromItemsAdded();
			for(var i=0; i<Package.packageDetails.CT.length;i++) {
				var customerType = Package.packageDetails.CT[i];
				if(angular.isUndefined(customerType.COMP)) {
					continue;
				}

				var comp = angular.isArray(customerType.COMP) ? customerType.COMP[0] : customerType.COMP;

				var packages = Package.itemsToBeAddedForCurrentPackage();
				for(var j = 0; j < packages.length; j++) {
					var pkg = packages[j];

					if(pkg.customer_type == customerType.id) {
						// calculate the ratio of this comp
						var purchasedQty = parseInt(pkg.qty);
						var ratioComp = parseInt(comp.ratio_comp);
						var ratioPurchase = parseInt(comp.ratio_purchase);
						var maxComp = parseInt(comp.max_comps);

						if(purchasedQty >= ratioPurchase) {
							effectiveMultiplier = Math.floor(purchasedQty / ratioPurchase);
							var effectiveMinComps = parseInt(comp.CHARACS.min_comp_qty) || 0;
							var effectiveMaxComps = Math.min(maxComp, effectiveMultiplier * ratioComp);

							var compToAdd = angular.copy(comp);
							compToAdd.qty = effectiveMinComps;
							compToAdd.customer_type = pkg.customer_type;
							compToAdd.min_quantity = effectiveMinComps;
							compToAdd.max_quantity = effectiveMaxComps;
							compToAdd.cart_limit_override = 0;
							compCollection.push(compToAdd);
						}

						break;
					}
				}
			}



			// if we have no comps available, log error and move to next XFC
			if(compCollection.length === 0) {
				$log.error('No comps available for package ID ' + packageId);
				Package.nextXFC();
			}

			this.compCollection = compCollection;
		}

		function removeCurrentCompsFromItemsAdded(){

			for(var m =0; m < Package.itemsToBeAdded.length; m++){

				var pkgItem = Package.itemsToBeAdded[m];
				if(Utilities.safelyCheckPropertyOnObject('pkgItem.CHARACS', pkgItem,
						function(characs){
							return(angular.isArray(characs) && characs.length > 0 && Utilities.getBoolean(characs[0].flex_is_comp))}
					)){

					Package.itemsToBeAdded.splice(m,1);
					m--;
				}
			}

		}

		this.save = function() {

			// comp assignment supports only one customer type

			for(var i=0; i<this.compCollection.length; i++) {
				var comp = this.compCollection[i];


				var currentPackage = Package.itemsToBeAddedForCurrentPackage()[0];
				var itemToAdd = angular.copy(currentPackage);

				if(angular.isUndefined(itemToAdd.CHARACS)) {
					itemToAdd.CHARACS = [];
				}

				for( var k=0; k<currentPackage.qty; k++) {
					currentPackage.CHARACS[k].overrideCompQty = comp.qty;
				}

				if(comp.qty > 0) {

					itemToAdd.package_id = comp.package_id;
					itemToAdd.qty = comp.qty;

					// If a name for the comp has been specified, use that as the new item's client_rate_name:
					// Not sure if we should also set charac.shop_rate_name, but hesitant to do so as that's used for
					// package swapping. I'm not sure of the ramifications of a comp having a different
					// shop_rate_name than its parent.
					if(comp.name){
						itemToAdd.client_rate_name=comp.name;
					}

					for(var j=0;j<comp.qty;j++) {
						itemToAdd.CHARACS[j] = angular.copy(itemToAdd.CHARACS[0]);
						itemToAdd.CHARACS[j].flex_is_comp = "true";
					}

                    ExtraFlow.removeXFCFromPackage(itemToAdd, 'giftcode_single');

                    Package.itemsToBeAdded.push(itemToAdd);
				}


			}

			// Add reference of XFC to CHARACs.
			ExtraFlow.addReferenceToCartItems( Package.settings.view, Package.itemsToBeAdded, ExtraFlow.CLIENT_XFC_VIEW );
			ExtraFlow.addReferenceToCartItems( Package.settings.name, Package.itemsToBeAdded, ExtraFlow.CLIENT_XFC_NAME );

			// Navigate to the next XFC.
			Package.nextXFC();
		}

	}
)

angular.module('reservation',[
    'errorTracking'
    , 'app'
]).config(function ($locationProvider, $stateProvider) {

    //
    // Register the routes associated with this XMC
    //

    $stateProvider
		.state('reservation', {
			abstract: true,
			url     : '/reservation',
			template: '<div ui-view></div>',
			onEnter : ['$location', 'Package', '$log', '$state', '$rootScope', function($location, Package, $log, $state, $rootScope){
			}]
		})

		.state('reservation.names', {
			url        : '/names/:packageId',
			templateUrl: '/scripts/modules/extraflow/reservation/views/names.html',
			controller :  'ReservationNamesController',
			resolve: {
				initialData: function(Bootstrap, Package, $q) {
					var deferred = $q.defer();
					if(!Array.isArray(Package.itemsToBeAdded)){
						deferred.reject({redirect: '/packageList'});
					}else{
						deferred.resolve();
					}
					return deferred.promise;
				}
			}
		});


}).run(function(AppData, ExtraFlow, $log){

    //
    // Register this extra flow module with the extra flow service
    //
	ExtraFlow.registerXMC
	('reservation_names',
	{ name: 'reservation_names'
	  // route to the participants screen,
	  // which will automatically load login and
	  // account mgmt screens if needed.
	  , view: 'reservation/names'
	  , showCapacityRemaining: false
	  , showTimeList: true
	  , doEditMode: false
	  , lockQuantity: true
	  , writeSingleCharac: false
	  , enabled: true
	  , type: 'extraFlowControl'
	}
	);

});






angular.module('reservation').service(
	'ReservationModels',
	function(ReservationAutofillService) {

		// used to promote autofilling in the models.
		var autoFiller = function(){
			for(var field in this){
				this[field] = ReservationAutofillService.fillField(field);
			};
		};
		
		/**
		 * The login model
		 */
		function Login(username, password){
			this.username = username;
			this.password = password;
		};

		Login.prototype = {
			get username(){
				return this._username;
			},
			set username(val){
				this._username = val;
			},
			get password(){
				return this._password;
			},
			set password(val){
				this._password = val;
			},
			get profile_id(){
				return this._profile_id;
			},
			set profile_id(val){
				this._profile_id = val;
			}	
		};

		Login.prototype.autofill = autoFiller;
		
		
		this.Login = Login;

	});

angular.module(
	'reservation'               
).service
(
	'ReservationAutofillService',        // Service Name
	function(){

		function getRandomInt(min, max) {
			return Math.floor(Math.random() * (max - min)) + min;
		}

		var known = {
			username : 'jsinglet001@gmail.com',
			password : 'password123'
		};


		
		return {
			fillField : function(fieldName){

				if(angular.isDefined(known[fieldName]))
					return known[fieldName];
				
				return "RANDOM";
			}
		};

	});

angular.module( 'reservation' )
    .controller
( 'ReservationNamesController',
  function
  (
	 $scope,
	 $rootScope,
	 $state,
	 Modal,
	 $log,
	 AppData,
	 Package,
	 Utilities,
	 Language,
	 ClientInfo,
	 ExtraFlow
  ){


	 $scope.formData = [];
	 $scope.currentParticipant = 0;
	 $scope.packageName = Package.packageDetails.name;

	 var idx = 0;

	 Package.itemsToBeAddedForCurrentPackage().forEach(function(item){
		 item.CHARACS.forEach(function(p){
			 $scope.formData.push
			 (
				 {
					 firstName : "Guest",
					 lastName  : "Name",
					 id: idx,
					 visited : false,
					 valid: false
				 }
			 );

			 idx = idx+1;
		 });
	 });

	 function updateFormState()
	 {
		 //set pristine on form fields
		 $scope.reservationsForm.$setPristine();

		 if($scope.formData[$scope.currentParticipant].lastName==="Name" && $scope.formData[$scope.currentParticipant].firstName==="Guest"){
			 $scope.firstName = "";
			 $scope.lastName  = "";
		 }

		 $scope.submitted = false;
		 $scope.isLast = false;
	 }

	 $scope.finish = function(){

		 if($scope.reservationsForm.$invalid){
			return;
		 }
		 saveFormData();


		 ExtraFlow.addReferenceToCartItems(
			 ExtraFlow.getXMCByName(Package.xfcName).view,
			 Package.itemsToBeAdded,
			 ExtraFlow.CLIENT_XFC_VIEW
		 );

		 ExtraFlow.addReferenceToCartItems(
			 Package.xfcName,
			 Package.itemsToBeAdded,
			 ExtraFlow.CLIENT_XFC_NAME
		 );

		 Package.itemsToBeAddedForCurrentPackage().forEach(function(i){

			i.CHARACS.forEach(function(c){
				var xfcs = (angular.isString(c.client_xfc_name)) ?
					c.client_xfc_name.split(',') : [];
				if(Utilities.inArray('reservation_names', xfcs)){
					c.rv_last_name = $scope.firstName;
					c.rv_first_name = $scope.lastName;
				}
			});

		 });


		 Package.nextXFC();

	 };

	 function saveFormData(){
		 $scope.formData[$scope.currentParticipant].firstName = $scope.firstName;
		 $scope.formData[$scope.currentParticipant].lastName  = $scope.lastName;
		 $scope.formData[$scope.currentParticipant].valid = true;
		 $scope.formData[$scope.currentParticipant].visited = true;
	 }

	 $scope.selectParticipant = function(index) {

		 $scope.submitted = true;

		 if($scope.formData[index].visited===false || $scope.reservationsForm.$invalid){
			 return;
		 }

		 saveFormData();

		 // Set the current participant
		 $scope.currentParticipant = index;
		 $scope.formData[$scope.currentParticipant].visited = true;

		 if ($scope.formData[index].visited) {
			 $scope.firstName = $scope.formData[$scope.currentParticipant].firstName;
			 $scope.lastName = $scope.formData[$scope.currentParticipant].lastName;
		 }

		 updateFormState();
	 };

	 $scope.next = function(){

		 if($scope.currentParticipant+1 < $scope.formData.length){
			 $scope.formData[$scope.currentParticipant+1].visited = true;
			 $scope.selectParticipant($scope.currentParticipant+1);
		 }else{
			 $scope.submitted = true;

			 if($scope.reservationsForm.$invalid==false){
				 saveFormData();
				 $scope.isLast = true;
			 }
		 }
	 };

	 $scope.back = function() {
		 if($scope.currentParticipant > 0){
			 $scope.selectParticipant($scope.currentParticipant-1);
		 }
	 };

	 $scope.cancel = function(){
		 Package.cancelXFC();
	 };
  });

angular.module('merch-size',[
	'errorTracking'
	, 'app'
]).config(function ($locationProvider, $stateProvider) {
	// Register the routes associated with this XMC
	$stateProvider

		.state('merchSize', {
			url        : '/merchSize/:packageId',
			templateUrl: '/scripts/modules/extraflow/merch-size/views/sizes.html',
			controller :  'MerchSizeController',
			resolve: {
				initialData: function(Bootstrap) {
					return Bootstrap.bootstrapApplication();
				}
			}
		});

}).run(function(AppData, ExtraFlow, $log){

	// Register this extra flow module with the extra flow service
	ExtraFlow.registerXMC
	('merch_size',
		{ name: 'merch_size'
		, view: 'merchSize'
		, showCapacityRemaining: false
		, showTimeList: true
		, doEditMode: false
		, lockQuantity: true
		, writeSingleCharac: false
		, enabled: true
		, type: 'extraFlowControl'
		}
	);

});
angular.module( 'merch-size' )
	.controller
	( 'MerchSizeController',
	function
	(
		$scope,
		AppData,
		Package,
		Utilities,
		ExtraFlow
	){
		/**
		 * Initializes the form and view data
		 * @private
		 */
		function init() {
			$scope.formData = [];
			$scope.shirtSizes = [];
			$scope.currentParticipant = 0;
			$scope.isLast = false;
			$scope.packageName = Package.packageDetails.name;
			$scope.customerTypes = Package.customerTypes;

			if (Utilities.childDefined(Package, 'packageDetails.CHARACS.package_size')) {
				$scope.shirtSizes = Package.packageDetails.CHARACS.package_size.split(", ");
			}

			var idx = 0;

			Package.itemsToBeAddedForCurrentPackage().forEach(function(item) {
				item.CHARACS.forEach(function(p){
					$scope.formData.push
					(
						{
							cusTypeName: p.shop_rate_name,
							shirtSize : "",
							id: idx,
							visited : false,
							valid: false
						}
					);

					idx = idx+1;
				});
			});

			if ($scope.formData.length === 1) {
				$scope.isLast = true;
			}
		}

		/**
		 * Updates the current form's state
		 * @private
		 */
		function updateFormState() {
			// Set pristine on form fields
			$scope.merchForm.$setPristine();

			if(!$scope.formData[$scope.currentParticipant].shirtSize){
				$scope.shirtSize = "";
			}else{
				$scope.shirtSize = $scope.formData[$scope.currentParticipant].shirtSize;
			}

			$scope.formData.submitted = false;
		}

		$scope.complete = function() {
			$scope.formData.submitted = true;

			if ($scope.merchForm.$invalid) {
				return;
			}

			saveFormData();

			ExtraFlow.addReferenceToCartItems(
				ExtraFlow.getXMCByName(Package.xfcName).view,
				Package.itemsToBeAdded,
				ExtraFlow.CLIENT_XFC_VIEW
			);

			ExtraFlow.addReferenceToCartItems(
				Package.xfcName,
				Package.itemsToBeAdded,
				ExtraFlow.CLIENT_XFC_NAME
			);

			Package.itemsToBeAddedForCurrentPackage().forEach(function(i) {
				i.CHARACS.forEach(function(c, index){
					var xfcs = (angular.isString(c.client_xfc_name)) ?
						c.client_xfc_name.split(',') : [];
					if (Utilities.inArray('merch_size', xfcs)) {
						c.size = $scope.formData[index].shirtSize;
						c.selectedIndex = $scope.formData[index].id;
						c.selected = true;
					}
				});
			});

			Package.nextXFC();
		};

		$scope.selectParticipant = function(index) {
			$scope.formData.submitted = true;

			if ($scope.formData[index].visited === false || $scope.merchForm.$invalid) {
				return;
			}

			saveFormData();

			// Set the current participant
			$scope.currentParticipant = index;
			$scope.formData[$scope.currentParticipant].visited = true;

			if ($scope.formData[index].visited) {
				$scope.shirtSize = $scope.formData[$scope.currentParticipant].shirtSize;
			}

			updateFormState();
		};

		function saveFormData() {
			// Copy the shirt size to the tabs
			$scope.formData[$scope.currentParticipant].shirtSize = $scope.shirtSize;
			$scope.formData[$scope.currentParticipant].valid = true;
			$scope.formData[$scope.currentParticipant].visited = true;

			if ($scope.currentParticipant + 1 === $scope.formData.length - 1) {
				$scope.isLast = true;
			} else {
				$scope.isLast = false;
			}
		}

		$scope.next = function() {
			if ($scope.currentParticipant + 1 < $scope.formData.length) {
				$scope.formData[$scope.currentParticipant + 1].visited = true;
				$scope.selectParticipant($scope.currentParticipant + 1);
			} else {
				$scope.formData.submitted = true;
				if ($scope.reservationsForm.$invalid === false) {
					saveFormData();
				}
			}
		};

		// Go back to previous participant form
		$scope.back = function() {
			$scope.currentParticipant--;
			$scope.isLast = false;
			$scope.shirtSize = $scope.formData[$scope.currentParticipant].shirtSize;
		}

		// Cancel flow
		$scope.cancel = function() {
			// Handle the cancel button clicked
			Package.cancelXFC();
		};

		init();
});

/**
 * Created by ltischuk on 1/9/15.
 */
angular.module('zoo-memberships',
	['app'])
	.config(function ($locationProvider, $stateProvider) {

		$stateProvider
			.state('zoo-memberships', {
				abstract: true,
				url: '/zoo-memberships/:packageId',
				controller: 'ZooMembershipsController',
				templateUrl: '/scripts/modules/extraflow/zoo-memberships/views/zoo-memberships.html',
				resolve: {
					//resolve failures are handled within run.js of main app
					load: function( $rootScope, Utilities ){

						$rootScope.showSpinner();

						return Utilities.cacheBustAndLazyLoad([
							'/scripts/modules/extraflow/zoo-memberships/controllers/zoo-memberships-controller.js',
							'/scripts/modules/extraflow/zoo-memberships/controllers/zoo-memberships-passholder-form-controller.js',
							'/scripts/modules/extraflow/zoo-memberships/controllers/zoo-memberships-passholder-lookup-controller.js',
							'/scripts/modules/extraflow/zoo-memberships/services/zoo-memberships-autofill-service.js',
							'/scripts/modules/extraflow/zoo-memberships/services/zoo-memberships-service.js',
							'/scripts/modules/extraflow/zoo-memberships/services/zoo-memberships-requests-service.js',
							'/scripts/modules/extraflow/zoo-memberships/zoo-memberships-models.js'
						]);
					},
					initialData: function(load,Bootstrap) {
						return Bootstrap.bootstrapApplication();
					},
					seasonPassCompPackages: function(initialData,Seasonpass) {
						return Seasonpass.getPackagesFromGetSeasonPassCount();
					},
					xfcMap: function(seasonPassCompPackages, Package) {
						return Package.buildXFCMap();
					},
					setupXFC : function(xfcMap, seasonPassCompPackages, $injector) {
						return $injector.get('ZooMembershipsService').setupXFC(seasonPassCompPackages);
					}
				}
			})
			.state('zoo-memberships.passholderLookup',{
				url: '/passholderLookup',
				controller: 'ZooMembershipsPassholderLookupController',
				templateUrl: '/scripts/modules/extraflow/zoo-memberships/views/passholder-lookup.html'
			})
			.state('zoo-memberships.passholderForm',{
				url: '/passholderForm',
				controller: 'ZooMembershipsPassholderFormController',
				templateUrl: '/scripts/modules/extraflow/zoo-memberships/views/passholder-form.html'
			})
	})
	.run(function(ZooMembershipsEnumsService,ExtraFlow) {

		ZooMembershipsEnumsService.modules.forEach(function (module) {
			// Register this extra flow alternate module with the extra flow service
			ExtraFlow.registerXMC
			(module.name,
				{
					name: module.name,
					view: module.view,
					viewIsStateName: true,
					showCapacityRemaining: false,
					showTimeList: true,
					doEditMode: true,
					lockQuantity: true,
					writeSingleCharac: false,
					enabled: true,
					type: 'extraFlowControl',
					characsList: [ 'ph_first_name', 'ph_last_name', 'ph_email', 'ph_address', 'ph_home_phone']
				}
			);
		});
	});


angular.module('zoo-memberships').factory
('ZooMembershipsEnumsService',
	function(AppData){
		return {
			configs:[
				{name: 'zoo-memberships'}
			],
			localeSection: 'ZooMemberships',
			passholderLookupMapping: {

				aux_name_1: {name: "ph_aux_1"},
				aux_name_2: {name:"ph_aux_2"},
				ph_children: {name:"ph_children"},
				season_passholder_add_ph_first_name: {name:"ph_add_ph_first_name"},
				season_passholder_add_ph_mi: {name:"ph_add_ph_mi"},
				season_passholder_add_ph_last_name: {name:"ph_add_ph_last_name"},
				season_passholder_address : {name:"ph_address"},
				season_passholder_address2 : {name:"ph_address2"},
				season_passholder_birth_date: {name:"ph_birth_date", transform:function(data){var result= data; if(angular.isDefined(data) && data == '01/01/1901'){result=''}return result;}},
				season_passholder_city: {name:"ph_city"},
				season_passholder_state_province_code: {name:"ph_state"},
				season_passholder_zip: {name:"ph_zip"},
				season_passholder_country_code: {name:"ph_country_code", transform:function(data){var countrycode = data;if(angular.isDefined(data)&&data.length>2)
				{var found = AppData.countries.filter(function(country){return country.name ==data;})[0]; if(angular.isDefined(found)){countrycode =found.code;}}return countrycode;}},
				season_passholder_emailaddress: {name:"ph_email"},
				season_passholder_firstname: {name:"ph_first_name"},
				season_passholder_mi: {name:"ph_mi"},
				season_passholder_lastname: {name:"ph_last_name"},
				season_passholder_homephone: {name:"ph_home_phone"},
				season_passholder_seasonpassnumber: {name:"ph_season_pass_number"},
				season_passholder_sex: {name:"ph_sex", transform:function(data){if(angular.isDefined(data) && data.length > 0){return data.substring(0,1).toLowerCase();}else{return data;}}}

			},
			billingMapping: {
				firstName : "ph_first_name",
				   lastName : "ph_last_name",
				   country : "ph_country_code",
				address : "ph_address",
				address2: "ph_address2",
				city: "ph_city",
				state: "ph_state",
				zip: "ph_zip",
				phone: "ph_home_phone",
				email: "ph_email"
			},
			modules : [
				{name:'zoo_memberships', view: 'zoo-memberships.passholderForm'},
				{name:'zoo_memberships_lookup', view: 'zoo-memberships.passholderLookup'}
			]
		}
	}
);

(function() {
	'use strict';

	angular
		.module('app')
		.factory('FeeService', FeeService);

	/**
	 * The Fee Service
	 * Gathers and delivers Cart Level Fee information
	 * @constructor
	 * @param {Service} $filter - The $filter Service
	 * @param {Service} AppData - The AppData Service
	 * @param {Service} JSONValidator - The JSONValidator Service
	 * @param {Service} Utilities - The Utilities Service
	 * @returns {Object} - The service API
	 * @ngInject
	 */
	function FeeService($filter, AppData, JSONValidator, Utilities) {
		var $currencyFormatter = $filter('currencyFormatter'),
			checkProp = Utilities.checkProp,
			copy = angular.copy,
			first = Utilities.first,
			getBoolean = Utilities.getBoolean,
			getString = Utilities.getString,
			toArray = Utilities.wrapObjectToArray;

		var service = {
			enums: {
				CALENDAR_PRICING: 'CalendarPricingModule',
				COMBO_CREATOR: 'ComboCreator',
				COMPARISON_CHART: 'ComparisonChart',
				DATE_TIME: 'DateTime',
				FAST_LANE: 'FastLane',
				PACKAGE_DETAILS: 'PackageDetails',
				PACKAGE_LIST: 'PackageList',
				SNAP_CALENDAR: 'SnapCalendar',
				WIZARD_CALENDAR: 'WizardCalendar',
			},
			getAdjustmentFromPackageId: getAdjustmentFromPackageId,
			hasAdjustment: hasAdjustment,
			isPageActive: isPageActive,
			isPageActiveAndHasAdjustment: isPageActiveAndHasAdjustment,
			isTaxIncluded: isTaxIncluded,
			swapLocaleVariables: swapLocaleVariables,
			_: {
				adjustments: [],
				enabledPages: [],
				highestAdjustment: null,
				pagesWithTax: [],

				initialize: _initialize
			}
		};

		service._.initialize();

		return service;

		/************************
		 ** ~ PUBLIC METHODS ~ **
		 ************************/

		/**
		 * Gets the cart level fee for the specified package ID
		 * @public
		 * @param {String} packageId - The package ID
		 * @param {String} pageKey - The page key that is being checked
		 * @returns {Object|null} - The adjustment object if found, null otherwise
		 */
		function getAdjustmentFromPackageId(packageId, pageKey) {
			var adjustments = [];
			var includeTax = service.isTaxIncluded(pageKey);
			var adj;

			// Is the package exempt from all adjustments?
			if (!service.hasAdjustment(packageId)) {
				// exit and return null
				return null;
			}

			// Filter out any adjustments that are exempt from the package
			adjustments = service._.adjustments.filter(function filterAdjustments(adj) {
				// Is the package exempt from this adjustment?
				return !adj.exempt.includes(packageId);
			});

			// Sort the adjustments
			adjustments.sort(function compareAdjustments(adjA, adjB) {
				// Is the first adjustment a percentage and the second not?
				if (adjA.isPercentage && !adjB.isPercentage) {
					// Assume A is the adjustment we want
					return -1;
				// Is the first adjustment not a percentage and the second is?
				} else if (!adjA.isPercentage && adjB.isPercentage) {
					// Assume B is the adjustment we want
					return 1;
				}

				// Sort by amount
				return adjB.amount - adjA.amount;
			});

			// Get the first adjustment (The 'largest' amount)
			adj = copy(first(adjustments)) || {};

			// Should the display amout include tax and is not displayed as a percentage?
			if (includeTax && !adj.isPercentage) {
				// Change the display amount to reflect tax
				adj.displayAmount = $currencyFormatter(adj.amount + adj.tax);
			}

			// Return the adjustment
			return adj;
		}

		/**
		 * Checks if a package ID has any adjustments associated with it
		 * @public
		 * @param {String} packageId - The package ID
		 * @returns {Boolean} - True if the package has adjustments, false otherwise
		 */
		function hasAdjustment(packageId) {
			return service._.adjustments.some(function(adj) {
				return !adj.exempt.includes(packageId);
			});
		}

		/**
		 * Checks if the specified page can show the fee notice
		 * @public
		 * @param {String} pageKey - The page key that is being checked
		 * @returns {Boolean} True if activated, false otherwise
		 */
		function isPageActive(pageKey) {
			return service._.enabledPages.includes(pageKey.toLowerCase());
		}

		/**
		 * Checks if the specified page should include tax with the fee amount
		 * @param {String} pageKey - The page key that is being checked
		 * @returns {Boolean} True if tax is included, false otherwise
		 */
		function isTaxIncluded(pageKey) {
			return service._.pagesWithTax.includes(pageKey.toLowerCase());
		}

		/**
		 * Checks if the specified page can show the fee notice and if the package ID has any adjustments
		 * @public
		 * @param {String} pageKey - The page key that is being checked
		 * @param {String} packageId - The package ID
		 * @returns {Boolean} - True if the page is active and the package has adjustments, false otherwise
		 */
		function isPageActiveAndHasAdjustment(pageKey, packageId) {
			return service.isPageActive(pageKey) && service.hasAdjustment(packageId);
		}

		/**
		 * Changes out the variables in a locale string with the specified values
		 * @public
		 * @param {String} localeString - The Locale String
		 * @param {String} feeAmount - The fee display amount
		 * @param {String} name - The fee name
		 * @returns {String} - The locale string with the variables swapped out
		 */
		function swapLocaleVariables(pageKey, localeString, feeAmount, name) {
			// If the fee amount or name are not specified and there is no highest adjustment
			if ((!feeAmount || !name) && !service._.highestAdjustment) {
				// return the locale as is
				return localeString;
			}

			// If the fee amount or name are not specified use the highest adjustment values
			feeAmount = feeAmount
				|| (service.isTaxIncluded(pageKey)
					? $currencyFormatter(service._.highestAdjustment.amount + service._.highestAdjustment.tax)
					: service._.highestAdjustment.displayAmount
				);
			name = name || service._.highestAdjustment.name;

			// Replace placeholders and return the locale string
			return getString(localeString)
				.replace('@@feeAmountAndName', feeAmount + ' - ' + name)
				.replace('@@name', name)
				.replace('@@fee', feeAmount);
		}


		/***************************
		 ** ~ PROTECTED METHODS ~ **
		 ***************************/

		/**
		 * Initialize logic for the service
		 * @protected
		 * @returns {undefined}
		 */
		function _initialize() {
			// Are the adjustments available in the store?
			if (checkProp('AppData.GetMerchantDetails.CART_ADJUSTMENTS', AppData)) {
				// Filter out inactive adjustments and simplify the data structure
				service._.adjustments = toArray(AppData.GetMerchantDetails.CART_ADJUSTMENTS, true)
					.filter(function filterOutInactiveAdjustments(adj) {
						return getBoolean(adj.active_flag);
					})
					.map(function simplifyAdjustment(adj) {
						var exempt = [],
							isPercentage = getBoolean(adj.percent_flag);

						// Are there any exempt packages?
						if (checkProp('adj.EXEMPT_PACKAGES.P', adj)) {
							// Set all the package IDs to a simple array
							exempt = toArray(adj.EXEMPT_PACKAGES.P, true).map(function mapExemptPackages(pkg) {
								return pkg.package_id;
							});
						}

						// Return the simplified adjustment
						return {
							amount: parseFloat(adj.amount),
							displayAmount: isPercentage ? adj.amount + '%' : $currencyFormatter(adj.amount),
							exempt: exempt,
							isPercentage: isPercentage,
							name: adj.name,
							tax: parseFloat(adj.tax || 0)
						};
					}
				);

				// Determine the most expensive adjustment
				service._.highestAdjustment = first(service._.adjustments.sort(function compareAdjustments(adjA, adjB) {
					return adjB.amount - adjA.amount;
				}));
			}

			// Is the fee_notice app config set and is it valid?
			if (checkProp('AppData.settings.fee_notice', AppData) && JSONValidator.validate('fee_notice', AppData.settings.fee_notice)) {
				// Create a shortlist of the enabled pages
				toArray(JSON.parse(AppData.settings.fee_notice), true).forEach(function forEachPage(page) {
					// If the show_fee property is false
					if (!getBoolean(page.show_fee)) {
						// Do not add the page to the shortlist
						return;
					}

					// Otherwise, add it to the shortlist in all lowercase
					service._.enabledPages.push(page.page_name.toLowerCase());

					// If the page is enabled to couple taxes within the displayed fee
					if (getBoolean(page.include_taxes)) {
						// Add that page to the showTaxesPages
						service._.pagesWithTax.push(page.page_name.toLowerCase());
					}
				});
			}
		}
	}
})();
/**
 * Created by ltischuk on 1/9/15.
 */
angular.module('membership-wizard',
	['passholder-lookup', 'autofill'])
	.config(function($locationProvider, $stateProvider) {
		$stateProvider
			.state('membership-wizard', {
				abstract: true,
				url: '/membership-wizard/:keyword',
				template: '<div ui-view></div>',
				resolve: {
					//resolve failures are handled within run.js of main app
					load: function($rootScope, Utilities) {
						$rootScope.showSpinner();

						return Utilities.cacheBustAndLazyLoad([
							'/scripts/modules/membership-wizard/membership-wizard-models.js',
							'/scripts/modules/membership-wizard/controllers/membership-wizard-selection-controller.js',
							'/scripts/modules/membership-wizard/controllers/membership-wizard-pass-options-controller.js',
							'/scripts/modules/membership-wizard/controllers/membership-wizard-passholder-detail-controller.js',
							'/scripts/modules/membership-wizard/controllers/membership-wizard-pass-lookup-controller.js',
							'/scripts/modules/membership-wizard/services/membership-wizard-finalize-service.js',
							'/scripts/modules/membership-wizard/services/membership-wizard-prep-service.js',
							'/scripts/modules/membership-wizard/services/membership-wizard-package-service.js',
							'/scripts/modules/membership-wizard/services/membership-wizard-enums-service.js'
						]);
					},
					initialData: function(load, Bootstrap) {
						return Bootstrap.bootstrapApplication();
					},
					config: function(initialData, $injector) {
						return $injector.get('MembershipWizardPrepService').getConfigurationSettings();
					},
					pass: function(config, $injector) {
						return $injector.get('MembershipWizardPrepService').createPassHolderModel();
					},
					packages: function(pass, $injector, $transition$) {
						return $injector.get('MembershipWizardPackageService').getMembershipWizardPackages($transition$.params().keyword);
					}
				}
			})
			.state('membership-wizard.selection', {
				url: '',
				controller: 'MembershipWizardSelectionController',
				templateUrl: '/scripts/modules/membership-wizard/views/selection.html'
			})
			.state('membership-wizard.passLookup', {
				url: '/passLookup/:passType',
				controller: 'MembershipWizardPassLookupController',
				templateUrl: '/scripts/modules/membership-wizard/views/pass-lookup.html'
			})
			.state('membership-wizard.passOptions', {
				url: '/passOptions/:passType',
				controller: 'MembershipWizardPassOptionsController',
				templateUrl: '/scripts/modules/membership-wizard/views/pass-options.html',
				resolve: {
					passOptionsRoute: function(pass, packages, MembershipWizardEnumsService, RouteRejectionService, $transition$) {
						var stateParams = $transition$.params();
						if (stateParams.passType === MembershipWizardEnumsService.MEMBERSHIP_RENEWAL && pass.ph_season_pass_number === 'NEW') {
							throw new RouteRejectionService.UnrecoverableException('membership-wizard.selection', { keyword: stateParams.keyword });
						}
					}
				}
			})
			.state('membership-wizard.passholderDetail', {
				url: '/passholderDetail/:passType',
				controller: 'MembershipWizardPassholderDetailController',
				templateUrl: '/scripts/modules/membership-wizard/views/passholder-detail.html',
				resolve: {

					passDetailRoute: function(packages, MembershipWizardPackageService, RouteRejectionService, $transition$) {
						if (MembershipWizardPackageService.getSelectedPackages().length === 0) {
							throw new RouteRejectionService.UnrecoverableException('membership-wizard.selection', { keyword: $transition$.params().keyword });
						}
					},
					rectifySelectedPackage: function(passDetailRoute, packages, MembershipWizardPackageService) {
						return MembershipWizardPackageService.rectifyPackageIfReturnedToModuleFromXFC(packages);
					}
				}
			})
	})
	.run(function(ExtraFlow) {
		// Register this extra flow alternate module with the extra flow service
		ExtraFlow.registerXMC
		('MembershipWizard',
			{
				name: 'MembershipWizard',
				view: 'membership-wizard',
				doEditMode: false,
				 lockQuantity: true,
				writeSingleCharac: false,
				enabled: true,
				type: 'alternateFlowModule'
			}
		);
	});

/* eslint-disable sort-keys, camel-case, no-unused-vars */
(function() {
	'use strict';

	var NODE_MODULES = '/scripts/modules',
		ENTITLEMENT_WIZARD_MODULE = NODE_MODULES + '/entitlement-wizard',
		DYNAMIC_PRICING_CALENDAR = NODE_MODULES + '/base-calendar/dynamic-pricing-calendar',
		DYNAMIC_PRICING_MONTH_COMPONENT = NODE_MODULES + '/base-calendar/components/dynamic-pricing-month-modal';

	angular
		.module('entitlement-wizard', ['app', 'ui.bootstrap'])
		.config(function($locationProvider, $stateProvider) {
			$stateProvider
				.state('entitlement-wizard', {
					abstract: true,
					url: '/entitlement-wizard/:keyword',
					template: '<div ui-view></div>',
					resolve: {
						load: function($rootScope, Utilities) {
							$rootScope.showSpinner();
							return Utilities.cacheBustAndLazyLoad([
								ENTITLEMENT_WIZARD_MODULE + '/entitlement-wizard-models.js',
								ENTITLEMENT_WIZARD_MODULE + '/services/entitlement-wizard-finalize-service.js',
								ENTITLEMENT_WIZARD_MODULE + '/services/entitlement-wizard-package-service.js',
								ENTITLEMENT_WIZARD_MODULE + '/services/entitlement-wizard-selection-service.js',
								ENTITLEMENT_WIZARD_MODULE + '/services/entitlement-wizard-matrix-service.js',
								ENTITLEMENT_WIZARD_MODULE + '/controllers/entitlement-wizard-selection-controller.js',
								ENTITLEMENT_WIZARD_MODULE + '/controllers/entitlement-wizard-matrix-controller.js',
								ENTITLEMENT_WIZARD_MODULE + '/styles/entitlement-wizard.css',
								DYNAMIC_PRICING_CALENDAR + '/dynamic-pricing-calendar.html',
								DYNAMIC_PRICING_CALENDAR + '/dynamic-pricing-calendar.css',
								DYNAMIC_PRICING_MONTH_COMPONENT + '/dynamic-pricing-month-modal.component.css',
								DYNAMIC_PRICING_MONTH_COMPONENT + '/dynamic-pricing-month-modal.component.js',
								DYNAMIC_PRICING_MONTH_COMPONENT + '/dynamic-pricing-month-modal-controller.component.js'
							]);
						},
						initialData: function(load, Bootstrap) {
							return Bootstrap.bootstrapApplication();
						},
						connection: function(initialData, $q, LegacyCart) {
							var defer = $q.defer();
							LegacyCart.fetchGetCartSummary(defer.resolve, defer.reject);
							return defer.promise;
						},
						config: function(connection, EntitlementWizardPrepService) {
							return EntitlementWizardPrepService.getConfigurationSettings();
						},
						packages: function(config, $injector, $transition$) {
							return $injector.get('EntitlementWizardPackageService').getEntitlementWizardPackages($transition$.params().keyword);
						},
						bundle: function(packages, config, EntitlementWizardPrepService) {
							return EntitlementWizardPrepService.createBundle(packages, config);
						},
						itemsToAdd: function(bundle) {
							return [];
						}
					}
				})
				.state('entitlement-wizard.selection', {
					controller: 'EntitlementWizardSelectionController',
					url: '',
					templateUrl: '/scripts/modules/entitlement-wizard/views/entitlement-wizard-selection.html'
				})
				.state('entitlement-wizard.preselected', {
					controller: 'EntitlementWizardSelectionController',
					url: '/select/:selectedEntitlementIds',
					params: {
						selectedEntitlementIds: {
							squash: true,
							value: null
						}
					},
					templateUrl: '/scripts/modules/entitlement-wizard/views/entitlement-wizard-selection.html'
				})
				.state('entitlement-wizard.matrix', {
					controller: 'EntitlementWizardMatrixController',
					url: '/entitlement-matrix',
					templateUrl: '/scripts/modules/entitlement-wizard/views/entitlement-wizard-matrix.html',
					resolve: {
						selectionRoute: function(itemsToAdd, RouteRejectionService, EntitlementWizardSelectionService) {
							if (angular.isUndefined(itemsToAdd) || angular.isArray(itemsToAdd) && itemsToAdd.length <= 0) {
								throw new RouteRejectionService.UnrecoverableException('entitlement-wizard.selection');
							} else {
								return true;
							}
						},
						times: function(selectionRoute, bundle, itemsToAdd, EntitlementWizardMatrixService, EntitlementWizardPackageService) {
						//This call sets the EntitlementWizardMatrixService.timesResponse
							return EntitlementWizardMatrixService.getTimesOnLoad(itemsToAdd, bundle, EntitlementWizardPackageService.finalBasePackage)
						}
					}
				});
		})
		.run(function(ExtraFlow) {
			ExtraFlow.registerXMC('EntitlementWizard', {
				doEditMode: false,
				enabled: true,
				lockQuantity: true,
				name: 'EntitlementWizard',
				type: 'alternateFlowModule',
				view: 'entitlement-wizard',
				writeSingleCharac: false
			});
		});
}());
(function() {
	'use strict';
	angular
		.module('entitlement-wizard')
		.service('EntitlementWizardPrepService', EntitlementWizardPrepService);

	/**
	 * Our constructor
	 * @param {Service} AppData AppData
	 * @param {Service} RouteRejectionService Route rejection
	 * @param {Service} JSONValidator Validator
	 * @param {Service} Utilities Utilities
	 * @param {Service} $q Promises
	 * @returns {self} Our instance
	 * @ngInject
	 */
	function EntitlementWizardPrepService(
		AppData,
		RouteRejectionService,
		JSONValidator,
		Utilities,
		$q
	) {
		var service = {
			bundle: {},
			createBundle: createBundle,
			getConfigurationSettings: getConfigurationSettings,
			settings: {}
		};

		return service;

		/**
		 * Ensure that the config is setup appropriately otherwise we show a view exception and do not resolve the route
		 * @throws {ViewException} - Throws a view exception if misconfigured
		 * @returns {Object} promise
		 */
		function getConfigurationSettings() {
			var deferred = $q.defer();
			if (!Utilities.safelyCheckPropertyOnObject('AppData.settings', AppData)) {
				throw new RouteRejectionService.UnrecoverableException('/packageList');
			} else if (JSONValidator.validate('entitlement_wizard', AppData.settings.entitlement_wizard)) {
				service.settings = JSON.parse(AppData.settings.entitlement_wizard);
				deferred.resolve(service.settings);
			} else {
				throw new RouteRejectionService.ViewException();
			}
			return deferred.promise;
		}

		/**
		 * Creates the bundle
		 * @param {Object[]} packages Our packages
		 * @param {Object} config The configuration
		 * @returns {Object} Our bundle
		 */
		function createBundle(packages, config) {
			var i = 0;
			var customerType;

			service.bundle.CT = [];
			for (; i < packages[0].CT.length; i++) {
				customerType = angular.copy(packages[0].CT[i]);
				customerType.description = packages[0].CT[i].desc || '';
				if (angular.isDefined(config.icon) && config.icon == customerType.id) {
					customerType.icon = true;
				}
				if (i == 0) {
					customerType.qty = 1;
				} else {
					customerType.qty = 0;
				}
				service.bundle.CT.push(customerType);
			}
			return service.bundle;
		}
	}
}());
angular
	.module('event-search', ['waitlist'])
	.config(function($stateProvider) {
		$stateProvider.state('event-search', {
			url: '/event-search/:keyword',
			templateUrl: '/scripts/modules/event-search/views/event-search.html',
			controller: 'EventSearchController',
			resolve: {
				load: function($rootScope, Utilities) {
					$rootScope.showSpinner();
					return Utilities.cacheBustAndLazyLoad([
						'/scripts/modules/event-search/event-search-models.js',
						'/scripts/modules/event-search/controllers/event-search-controller.js',
						'/scripts/modules/event-search/services/event-search-prep-service.js',
						'/scripts/modules/event-search/services/event-search-request-service.js',
						'/scripts/modules/waitlist/controllers/waitlist-controller.js',
						'/scripts/modules/waitlist/controllers/waitlist-logged-in-controller.js',
						'/scripts/modules/waitlist/services/waitlist-service.js'
					]);
				},
				initialData: function(load, Bootstrap) {
					return Bootstrap.bootstrapApplication();
				},
				config: function(initialData, $injector, $transition$) {
					return $injector.get('EventSearchPrepService').getConfigurationSettings($transition$.params().keyword);
				}
			}
		});
	})
	.run(function(ExtraFlow) {
		// Register this extra flow alternate module with the extra flow service
		ExtraFlow
			.registerXMC('EventSearch', {
				name: 'EventSearch',
				view: 'event-search',
				viewIsStateName: false,
				doEditMode: false,
				lockQuantity: true,
				writeSingleCharac: false,
				enabled: true,
				type: 'alternateFlowModule'
			});
	});
angular.module('waitlist',
	[]);
(function() {
	'use strict';

	angular
		.module('camps-enrollment', ['event-search', 'waitlist'])
		.config(function($locationProvider, $stateProvider, ComponentLoaderEnums) {
			$stateProvider
				.state('camps-enrollment-account', {
					abstract: true,
					url: '/camps-enrollment-account/:keyword',
					controller: 'CampsEnrollmentAccountController',
					templateUrl: 'camps-enrollment:account',
					title: 'campsEnrollmentAccount',
					resolve: {
						load: function($rootScope, BundleService) {
							$rootScope.showSpinner();
							return BundleService.lazyLoadCollectionFiles(BundleService.enums.CAMPS_ENROLLMENT);
						},
						initialData: function(load, Bootstrap) {
							return Bootstrap.bootstrapApplication(undefined, true);
						},
						enrollmentConfig: function(initialData, $injector) {
							return $injector.get('CampsEnrollmentPrepService').getEnrollmentConfiguration();
						},
						profileWithId: function(enrollmentConfig, $injector) {
							return $injector.get('CampsEnrollmentPrepService').getProfileWithInternal();
						},
						listenForRouteChange: function(profileWithId, $injector) {
							$injector.get('CampsEnrollmentPrepService').listenForRouteChange();
						}
					}
				})
				.state('camps-enrollment-account.profile', {
					url: '',
					templateUrl: 'camps-enrollment:account-profile',
					controller: 'CampsEnrollmentAccountProfileController',
					controllerAs: 'profileVm',
					title: 'campsEnrollmentAccountProfile',
					resolve: {
						assessAllowedRoute: function(profileWithId, $injector, $state, $transition$) {
							return $injector.get('CampsEnrollmentSelectionService').checkAndReRouteForInvalidLoggedInState($state.current.name, $transition$.params(), $state.next.name, $state.toParams, false);
						}
					}
				})
				.state('camps-enrollment-account.summary', {
					url: '/summary',
					controller: 'CampsEnrollmentAccountSummaryController',
					controllerAs: 'pSummaryVm',
					templateUrl: 'camps-enrollment:account-summary',
					title: 'campsEnrollmentAccountSummary',
					resolve: {
						assessAllowedRoute: function(profileWithId, $injector, $state, $transition$) {
							return $injector.get('CampsEnrollmentSelectionService').checkAndReRouteForInvalidLoggedInState($state.current.name, $transition$.params(), $state.next.name, $state.toParams, false);
						},
						attachParticipantOtherInfo: function(assessAllowedRoute, $injector) {
							return $injector.get('CampsEnrollmentParticipantService').getParticipantInfoForList();
						},
						assessProfileCompleteRoute: function(attachParticipantOtherInfo, $injector, $transition$) {
							return $injector.get('CampsEnrollmentParticipantService').assessProfileCompleteRoute($transition$.params());
						}
					}
				})
				.state('camps-enrollment-account.participants', {
					url: '/participants/:participantIds/:activeParticipantIndex',
					controller: 'CampsEnrollmentAccountParticipantController',
					templateUrl: 'camps-enrollment:account-participant',
					controllerAs: 'pAddModParentVm',
					abstract: true,
					title: 'campsEnrollmentAccountParticipant',
					params: {
						participantIds: {
							value: '',
							squash: true
						},
						activeParticipantIndex: {
							value: '',
							squash: true
						}
					},
					resolve: {
						assessAllowedRoute: function(profileWithId, $injector, $state, $transition$) {
							return $injector.get('CampsEnrollmentSelectionService').checkAndReRouteForInvalidLoggedInState($state.current.name, $transition$.params(), $state.next.name, $state.toParams, false);
						},
						participants: function(assessAllowedRoute, $injector, $transition$) {
							return $injector.get('CampsEnrollmentParticipantService').getOrCreateParticipantList($transition$.params().participantIds);
						},
						relationships: function(participants, $injector) {
							return $injector.get('CampsEnrollmentParticipantService').getRelationships();
						},
						assessOtherInfoRoute: function(relationships, participants, $transition$, $injector) {
							return $injector.get('CampsEnrollmentParticipantService').retrieveAndSetParticipantAddlInfo(participants, $transition$.params().activeParticipantIndex);
						}
					}
				})
				.state('camps-enrollment-account.participants.demographics', {
					url: '/demographics',
					title: 'campsEnrollmentAccountParticipantInfo',
					templateUrl: 'camps-enrollment:account-participant-demographics',
					controller: 'CampsEnrollmentAccountParticipantDemographicsController',
					controllerAs: 'pAddModChildVm'
				})
				.state('camps-enrollment-account.participants.info', {
					url: '/info',
					title: 'campsEnrollmentAccountParticipantInfo',
					templateUrl: 'camps-enrollment:account-participant-info',
					controller: 'CampsEnrollmentAccountParticipantInfoController',
					controllerAs: 'pAddModChildInfoVm'
				})
				.state('camps-enrollment-account.participants.medicalwaiver', {
					url: '/medical',
					title: 'campsEnrollmentAccountParticipantInfo',
					templateUrl: 'camps-enrollment:account-participant-medical',
					controller: 'CampsEnrollmentAccountParticipantMedicalController',
					controllerAs: 'pAddModChildMedicalVm'
				})
				.state('camps-enrollment-account.participants.addlwaivers', {
					url: '/waiver',
					title: 'campsEnrollmentAccountParticipantInfo',
					templateUrl: 'camps-enrollment:account-participant-waivers',
					controller: 'CampsEnrollmentAccountParticipantAddlWaiversController',
					controllerAs: 'pAddModChildWaivers'
				})
				.state('camps-enrollment-camp-participant-selection', {
					url: '/camp-participant-selection/:keyword',
					title: 'campsEnrollmentAccountParticipantInfo',
					templateUrl: 'camps-enrollment:participant-selection',
					controller: 'CampsEnrollmentCampParticipantSelectionController',
					controllerAs: 'vm',
					resolve: {
						load: function($rootScope, BundleService) {
							$rootScope.showSpinner();
							return BundleService.lazyLoadCollectionFiles(BundleService.enums.CAMPS_ENROLLMENT);
						},
						initialData: function(load, Bootstrap) {
							return Bootstrap.bootstrapApplication(undefined, true);
						},
						enrollmentConfig: function(initialData, $injector) {
							return $injector.get('CampsEnrollmentPrepService').getEnrollmentConfiguration();
						},
						config: function(enrollmentConfig, $injector, $transition$) {
							return $injector.get('CampsEnrollmentPrepService').getSearchConfiguration($transition$.params().keyword);
						},
						assessAllowedRoute: function(config, $injector, $state, $transition$) {
							return $injector.get('CampsEnrollmentSelectionService').checkAndReRouteForInvalidLoggedInState($state.current.name, $transition$.params(), $state.next.name, $state.toParams, true);
						},
						checkforMemberOnlyCamps: function(assessAllowedRoute, $injector, $transition$) {
							$injector.get('CampsEnrollmentSelectionService').checkForMemberOnlyCampAndRoute($transition$.params().keyword, false);
						},
						participants: function(checkforMemberOnlyCamps, assessAllowedRoute, $injector, ProfileLoginSessionService) {
							return $injector.get('CampsEnrollmentParticipantService').retrieveAndSetParticipantAddlInfoForList(ProfileLoginSessionService.getCurrentLoggedInProfile().getAllLinkedGuests(), 0);
						},
						fetchWaitList: function(participants, $injector) {
							return $injector.get('CampsEnrollmentSelectionService').fetchWaitList();
						},
						listenForRouteChange: function(fetchWaitList, $injector) {
							$injector.get('CampsEnrollmentPrepService').listenForRouteChange();
						},
						previousState: buildPreviousState
					}
				})
				.state('camps-enrollment-waitlisted-camp-participant-selection', {
					url: '/camp-waitlisted-participant-selection/{keyword:keyword}/:customerId/:dependentId/:packageId/:startDate/:startTime',
					templateUrl: 'camps-enrollment:participant-selection',
					controller: 'CampsEnrollmentCampParticipantSelectionController',
					controllerAs: 'vm',
					resolve: {
						load: function($rootScope, BundleService) {
							$rootScope.showSpinner();
							return BundleService.lazyLoadCollectionFiles(BundleService.enums.CAMPS_ENROLLMENT);
						},
						initialData: function(load, Bootstrap) {
							return Bootstrap.bootstrapApplication(undefined, true);
						},
						enrollmentConfig: function(initialData, $injector) {
							return $injector.get('CampsEnrollmentPrepService').getEnrollmentConfiguration();
						},
						config: function(enrollmentConfig, $injector, $transition$) {
							return $injector.get('CampsEnrollmentPrepService').getSearchConfiguration($transition$.params().keyword);
						},
						assessAllowedRoute: function(config, $injector, $state, $transition$) {
							return $injector.get('CampsEnrollmentSelectionService').checkAndReRouteForInvalidLoggedInState($state.current.name, $transition$.params(), $state.next.name, $state.toParams, false);
						},
						fetchWaitList: function(assessAllowedRoute, $injector) {
							return $injector.get('CampsEnrollmentSelectionService').fetchWaitList();
						},
						participants: function(fetchWaitList) {
							return [];
						},
						determineEligibility: function(participants, $injector, $transition$) {
							var stateParams = $transition$.params()
							return $injector.get('CampsEnrollmentSelectionService').verifyAndSelectWaitlist(stateParams.packageId, stateParams.dependentId, stateParams.startDate, stateParams.startTime, stateParams.keyword);
						},
						listenForRouteChange: function(determineEligibility, $injector) {
							$injector.get('CampsEnrollmentPrepService').listenForRouteChange();
						},
						previousState: buildPreviousState
					}
				})
				.state('camps-enrollment-camp-payment-option-selection', {
					url: '/camp-payment-option-selection/:keyword',
					templateUrl: 'camps-enrollment:payment-option',
					controller: 'CampsEnrollmentCampPaymentOptionSelectionController',
					controllerAs: 'vm',
					resolve: {
						initialData: function(Bootstrap) {
							return Bootstrap.bootstrapApplication(undefined, true);
						},
						load: function(initialData, $rootScope, BundleService) {
							$rootScope.showSpinner();
							return BundleService.lazyLoadCollectionFiles(BundleService.enums.CAMPS_ENROLLMENT);
						},
						enrollmentConfig: function(load, $injector) {
							return $injector.get('CampsEnrollmentPrepService').getEnrollmentConfiguration();
						},
						config: function(enrollmentConfig, $injector, $transition$) {
							return $injector.get('CampsEnrollmentPrepService').getSearchConfiguration($transition$.params().keyword);
						},
						assessAllowedRoute: function(config, $injector, $state, $transition$) {
							return $injector.get('CampsEnrollmentSelectionService').checkAndReRouteForInvalidLoggedInState($state.current.name, $transition$.params(), $state.next.name, $state.toParams, true);
						},
						listenForRouteChange: function(assessAllowedRoute, $injector) {
							$injector.get('CampsEnrollmentPrepService').listenForRouteChange();
						},
						previousState: buildPreviousState
					}
				})
				.state('camps-enrollment-camp-addon-selection', {
					url: '/camp-addon-selection/:keyword',
					templateUrl: 'camps-enrollment:addons',
					controller: 'CampsEnrollmentCampAddonSelectionController',
					controllerAs: 'vm',
					resolve: {
						load: function($rootScope, BundleService) {
							$rootScope.showSpinner();
							return BundleService.lazyLoadCollectionFiles(BundleService.enums.CAMPS_ENROLLMENT);
						},
						initialData: function(load, Bootstrap) {
							return Bootstrap.bootstrapApplication(undefined, true);
						},
						enrollmentConfig: function(initialData, $injector) {
							return $injector.get('CampsEnrollmentPrepService').getEnrollmentConfiguration();
						},
						config: function(initialData, $injector, $transition$) {
							return $injector.get('CampsEnrollmentPrepService').getSearchConfiguration($transition$.params().keyword);
						},
						assessAllowedRoute: function(enrollmentConfig, $injector, $state, $transition$) {
							return $injector.get('CampsEnrollmentSelectionService').checkAndReRouteForInvalidLoggedInState($state.current.name, $transition$.params(), $state.next.name, $state.toParams, true);
						},
						listenForRouteChange: function(assessAllowedRoute, $injector) {
							$injector.get('CampsEnrollmentPrepService').listenForRouteChange();
						},
						previousState: buildPreviousState
					}
				})
				.state('camps-enrollment-search', {
					url: '/camps-search/{keyword:keyword}/:errorModalType',
					templateUrl: 'camps-enrollment:camp-selection',
					components: [ ComponentLoaderEnums.accessoCalendar, ComponentLoaderEnums.mobileCta ],
					controller: 'CampsEnrollmentSearchSelectionController',
					controllerAs: 'vm',
					params: {
						errorModalType: {
							squash: true,
							value: null
						}
					},
					resolve: {
						load: function($rootScope, BundleService) {
							$rootScope.showSpinner();
							return BundleService.lazyLoadCollectionFiles(BundleService.enums.CAMPS_ENROLLMENT);
						},
						initialData: function(load, Bootstrap) {
							return Bootstrap.bootstrapApplication();
						},
						config: function(initialData, $injector, $transition$) {
							return $injector.get('CampsEnrollmentPrepService').getSearchConfiguration($transition$.params().keyword);
						},
						enrollmentConfig: function(config, $injector) {
							return $injector.get('CampsEnrollmentPrepService').getEnrollmentConfiguration();
						},
						profileWithId: function(enrollmentConfig, $injector) {
							return $injector.get('CampsEnrollmentPrepService').getProfileWithInternal();
						},
						fetchWaitList: function(profileWithId, $injector) {
							return $injector.get('CampsEnrollmentSelectionService').fetchWaitList();
						},
						hasErrorModal: function(fetchWaitList, $injector, $rootScope, UtilsValidation, $transition$) {
							var errorModalType = $transition$.params().errorModalType,
								CampsEnrollmentSelectionService = $injector.get('CampsEnrollmentSelectionService');
							$rootScope.hideSpinner();
							if (UtilsValidation.validString(errorModalType)) {
								if (errorModalType === 'purchase') {
									CampsEnrollmentSelectionService.displayPurchaseMembershipModal();
								} else if (errorModalType === 'renew') {
									CampsEnrollmentSelectionService.displayRenewMembershipModal();
								}
							}
						},
						previousState: buildPreviousState
					}
				});

			/**
				 * Resolves the current state so that once the page resolves, it will have the previous state.
				 * @public
				 * @param {Object} $state The state before we resolve to the new state
				 * @return {Object} the previous state
				 * @ngInject
				 */
			function buildPreviousState($state) {
				return {
					name: $state.current.name,
					params: $state.params
				};
			}
		})
		.run(function(ExtraFlow) {
			ExtraFlow.registerXMC('camps-search', {
				name: 'camps-search',
				view: 'camps-enrollment-search',
				viewIsStateName: true,
				doEditMode: false,
				lockQuantity: true,
				writeSingleCharac: false,
				enabled: true,
				type: 'alternateFlowModule'
			});
		})
		.value('CampsEnrollmentLocaleSection', 'CampsEnrollment')
		.value('CampsEnums', {
			ALLINCART: 'allInCartRestriction',
			ALLPURCHASED: 'allPurchasedRestriction',
			ALLWAITLISTED: 'allWaitlistedRestriction',
			DEPOSIT: 'deposit',
			NOTASSIGNED: 'not assigned',
			NOTAVAILABLE: 'campNotAvailable',
			PARTICIPATING: 'participating',
			PAYINFULL: 'payInFull',
			RESTRICTED: 'restricted',
			WAITLIST: 'wait list',
			WAITLISTED: 'waitlisted'
		});
})();
/**************************************
 * created by pMatthews on 6/30/16
 *
 * FolioService
 *
 * Loads and manages the folios associated with a token that is passed by URL Parameter (folio).
 * On load, the folio-service calls GetFolioTokenDetails to get all of a customer's folio information.
 * See the wiki page at: http://wiki.accesso.office/doku.php?id=applications:shopland5:features:folios
 *
 **************************************/
angular.module('app').factory
('FolioService',
	function(
		AppData,
		Package,
		LegacyCart,
		Language,
		PostRequestActionService,
		Utilities,
		Enums,
		$location,
		$q,
		$rootScope,
		FolioModels,
		JSONValidator,
		CustomActionService,
		Modal,
		UserInfo,
		UtilsValidation
	) {
		var safelyCheckPropertyOnObject = Utilities.safelyCheckPropertyOnObject,
			validArray = UtilsValidation.validArray,
			getLocale = Language.getLocale,
			getBoolean = Utilities.getBoolean;

		var service = {
			loaded: false,
			folio_enabled: false,
			tokenFromBackEnd: undefined,
			requestCache: undefined,
			folios: [],
			allowablePackageIds: [],
			reasonForNotPrinting: getLocale('FolioLabels', 'reasonForNotPrinting'),
			membershipUpgrade: false,
			additionalUnitsEnabled: additionalUnitsEnabled,
			clearSelected: clearSelected,
			createMemCharacsObj: createMemCharacsObj,
			createNonUpgradeMembershipCartItemObj: createNonUpgradeMembershipCartItemObj,
			selectAll: selectAll,
			folioEnabledPackage: folioEnabledPackage, // returns true if the package is folio-enabled
			folioCanPurchasePackage: folioCanPurchasePackage,
			foliosForPackage: foliosForPackage,
			folioRestrictedPackage: folioRestrictedPackage, // returns true if the package is folio restricted
			gateRedeemable: gateRedeemable, // returns true if the package is a gate redeemable
			getMembershipDepositCartItems: getMembershipDepositCartItems,
			getMembershipDepositTotalAmount: getMembershipDepositTotalAmount,
			requiresGateRedeemable: requiresGateRedeemable, // returns true if the package requires a gate-redeemable package already be purchased
			folioInfoForSeasonPass: folioInfoForSeasonPass, // pass in an item from PackagesToBeAdded, and this will add all the selected folios to it.
			bootStrap: bootStrap, // needed to call bootstrap this service in bootstrap.js
			numberOfSelectedFolios: numberOfSelectedFolios,
			addFoliosToCartItems: addFoliosToCartItems,
			canPrintTicket: canPrintTicket,
			addMediaNumbersToComps: addMediaNumbersToComps,
			loadUser: loadUser,
			respondToNewCartId: respondToNewCartId
		};

		function findGateAdmissionInArray(folio, ary) {
			if (angular.isUndefined(ary)) {
				return false;
			}
			for (var i = 0; i< ary.length; i++) {
				var characs = angular.isArray(ary[i].CHARACS) ? ary[i].CHARACS : [ary[i].CHARACS];
				for (var j = 0; j < characs.length; j++) {
					if (characs[j].client_media_number == folio.media_number && Utilities.forceInt(characs[j].gate_admission)==1) {
						return true;
					}
				}
			}
			return false;
		}
		function folioCanPurchasePackage(folio, pkg) {
			if (folio.hasValidGateRedeemable|| ! service.requiresGateRedeemable(pkg)) {
				return true;
			}
			// search the items that are on their way to the cart and the items that are in the cart:
			return (findGateAdmissionInArray(folio, Package.itemsToBeAdded) || findGateAdmissionInArray(folio, LegacyCart.cartItems));
		}

		function canViewPackage(pkg) {
			if (service.folioRestrictedPackage(pkg)) {
				for (var i=0; i<service.allowablePackageIds.length; i++) {
					if (service.allowablePackageIds[i].id == pkg.id) {
						return true;
					}
				}
				return false;
			}
			return true;
		}

		function requiresGateRedeemable(pkg) {
			// If a package is not gate redeemable, the customer is required to have a gate redeemable.
			// i.e., you can't buy a dining plan if you don't have a pass to get into the park.
			return (folioEnabledPackage(pkg) && ! gateRedeemable(pkg));
		}
		function gateRedeemable(pkg) {
			// gate_admission charac is either 00 or 01.
			var gate_admission = (angular.isDefined(pkg) && angular.isDefined(pkg.CHARACS)) ? Utilities.forceInt(pkg.CHARACS.gate_admission) : undefined;
			return gate_admission == 1;
		}
		function folioEnabledPackage(pkg) {
			if (service.folio_enabled && angular.isDefined(pkg) && angular.isDefined(pkg.CHARACS)) {
				return getBoolean(pkg.CHARACS.RequiresProcessing);
			}
			return false;
		}
		function folioRestrictedPackage(pkg) {
			if (angular.isDefined(pkg) && angular.isDefined(pkg.CHARACS)) {
				return getBoolean(pkg.CHARACS.RestrictedProduct);
			}
			return false;
		}

		/**
		 * Find out if we can show the additional units on the package details page.
		 * @param {Object} pkg The package to test
		 * @returns {Boolean} yes/no we can show it
		 */
		function additionalUnitsEnabled(pkg) {
			return getBoolean(safelyCheckPropertyOnObject('pkg.CHARACS.enableFolioAdditions', pkg, 'returnValue'));
		}

		function canPrintTicket(ticket) {
			// Note: This does not check if a folio has been loaded, because this method is
			// called by the printAtHome module which can be displayed from an order lookup
			// (where the folio token might not be included).
			if (safelyCheckPropertyOnObject('ticket.CHARACS.folio_id', ticket) && ticket.CHARACS.folio_id.length > 0
			 && safelyCheckPropertyOnObject('ticket.CHARACS.client_media_number', ticket) && ticket.CHARACS.client_media_number.length > 0) {
				return getBoolean(ticket.CHARACS.replaceMedia);
			}
			return true;
		}


		/**
		 * clearSelected de-selects the given package ID in all folios. If no package is specified, it clears all selected packages.
		 * @param package_id
     **/
		function clearSelected(package_id) {
			service.folios.forEach(function(f) {
				f.clearSelectedPackages(package_id);
			});
		}

		function selectAll(package_id) {
			service.folios.forEach(function(f) {
				f.selectForPackage(package_id, true);
			});
		}

		/**
		 * This function is for SF Membership Upgrade - we want to add both current memberships and the memberships we want to upgrade to cart
		 * It will look through all the folios and get the current membership CT, create package membership characs and add them to cartItems
		 * @function
		 * @protected
		 * @param {object} itemsForCart - items that are being added to cart
		 * @param {array} folios - folio array list
		 * @returns {undefined}
		 */
		function addingNonUpgradeMembershipItemToCart(itemsForCart, folios) {
			var foliosObjCopy = angular.copy(folios),
				nonUpgradeItems = [],
				originalCartItemsLength = itemsForCart.length;
			if (service.membershipUpgrade) {
				foliosObjCopy.forEach(function(folio) {
					var currentUpgradeItemIsMembership = false,
						i = 0,
						item,
						folioMembership,
						uuid;
					for (; i < originalCartItemsLength; i++) {
						item = itemsForCart[i];
						if (safelyCheckPropertyOnObject('item.CHARACS.0.folio_id', item) && item.CHARACS[0].folio_id === folio.id) {
							uuid = Utilities.guid();
							/* eslint-disable camelcase */
							item.CHARACS[0].group_uuid = uuid;
							folioMembership = folio.membershipInfo;
							currentUpgradeItemIsMembership = folioMembership.some(function(membershipInfoObj) {
								return membershipInfoObj.offerPackage === item.package_id && membershipInfoObj.packageClass.toLowerCase() === 'memberships';
							});
							folioMembership.forEach(function(membershipInfoObj) {
								var memCharacs;
								if (membershipInfoObj.offerPackage === item.package_id) {
									if (currentUpgradeItemIsMembership) {
										memCharacs = service.createMemCharacsObj(folio);
										angular.extend(item.CHARACS[0], memCharacs);
										item.CHARACS[0].ph_year = new Date().getFullYear().toString();
									}
								} else {
									service.createNonUpgradeMembershipCartItemObj(membershipInfoObj, folio, itemsForCart, uuid, currentUpgradeItemIsMembership);
								}
							});
							folio.addedToCart = true;
							/* eslint-disable camelcase */
						}
					}
				});
				nonUpgradeItems = foliosObjCopy.filter(function(folio) {
					return !folio.addedToCart;
				});
				nonUpgradeItems.forEach(function(item) {
					var uuid = Utilities.guid(),
						itemCopy = item;
					itemCopy.membershipInfo.forEach(function(membershipInfoObj) {
						service.createNonUpgradeMembershipCartItemObj(membershipInfoObj, item, itemsForCart, uuid, false);
					});
				});
			}
			CustomActionService.registerCustomAction('skipFolioMembershipUpgradeXFC', deregisterSkipFolioMembershipUpgradeXFC);
		}

		/**
		 * Create an object for non upgrade membership items, and then add it to cart if it is valid
		 * @function
		 * @public
		 * @param {Object} membershipInfoObj - membership info object from folio
		 * @param {Object} folio - current folio object
		 * @param {Array} itemsForCart - items to be added to cart
		 * @param {String} uuid - group uuid
		 * @param {Boolean} currentUpgradeItemIsMembership - is the upgrading is membership or addon? this determines should we add either
		 * offer package to cart or current package
		 * @returns {undefined}
		 */
		function createNonUpgradeMembershipCartItemObj(membershipInfoObj, folio, itemsForCart, uuid, currentUpgradeItemIsMembership) {
			var customerTypes,
				selectedCurrentMembershipCT,
				memCharacs,
				packageDetails = Package.getPackageByID(currentUpgradeItemIsMembership ? membershipInfoObj.offerPackage : membershipInfoObj.currentPackageId);

			if (packageDetails) {
				customerTypes = Package.setCustomerType(packageDetails);
				selectedCurrentMembershipCT = customerTypes.find(function(type) {
					return type.id === membershipInfoObj.customerType;
				});

				selectedCurrentMembershipCT.qty = 1;
				selectedCurrentMembershipCT.CHARACS[0].group_uuid = uuid;

				if (membershipInfoObj.packageClass.toLowerCase() === 'memberships') {
					memCharacs = service.createMemCharacsObj(folio);
					angular.extend(selectedCurrentMembershipCT.CHARACS[0], memCharacs);
					selectedCurrentMembershipCT.CHARACS[0].ph_year = packageDetails.season_pass_year;
				}

				selectedCurrentMembershipCT.CHARACS[0].folio_id = folio.id;
				selectedCurrentMembershipCT.CHARACS[0].client_media_number = folio.media_number;

				itemsForCart.push(selectedCurrentMembershipCT);
			}
		}

		/**
		 * Deregister CustomActionServiceAction when items are aded to cart - so incase guests add different membership to cart, they
		 * still have to go through correct XFC
		 * @function
		 * @protected
		 * @returns {undefined}
		 */
		function deregisterSkipFolioMembershipUpgradeXFC() {
			CustomActionService.deregisterCustomAction('skipFolioMembershipUpgradeXFC');
		}

		/**
		 * When upgrading membership with deposit, we want to transfer the old deposit amount to new membership
		 * so adding the deposit amount to payment node as ticket tender so we don't charge guests twice
		 * @function
		 * @protected
		 * @param {Object} payment - payment object node in purchase call
		 * @returns {Array} payment node array that contains all the deposit ticket tenders
		 */
		function addDepositAmountToPayment(payment) {
			var paymentArr = [],
				depositItems = getMembershipDepositCartItems(),
				isFolioItemInCart = LegacyCart.cartItems.some(function(item) {
					return Utilities.safelyCheckPropertyOnObject('item.CHARACS.0.folio_id', item);
				}),
				totalDepositAmount = getMembershipDepositTotalAmount(depositItems),
				ticketTenderBillingInfo = AppData.billingTypes.find(function(type) {
					return type.billing_type === 'TKT';
				});
			//If no deposit item or no ticket tender billing, then return payment
			if (!isFolioItemInCart || depositItems.length === 0 || !ticketTenderBillingInfo) {
				return payment;
			}

			//only add extra ticket tender object to payment node only when TKT billing type is set up and
			//deposit items in cart
			if (depositItems.length > 0 && ticketTenderBillingInfo) {
				service.folios.forEach(function(folio) {
					folio.membershipInfo.forEach(function(membership) {
						if (membership.packageClass.toLowerCase().indexOf('deposit') !== -1 && validArray(depositItems)) {
							paymentArr.push({
								amount: depositItems[0].retail_price,
								auth_type: ticketTenderBillingInfo.auth_type,
								billing_id: ticketTenderBillingInfo.billing_id,
								billing_type: ticketTenderBillingInfo.billing_type,
								ticket_id: membership.ticketId,
								merchant_payment_type_ref_id: ticketTenderBillingInfo.merchant_payment_type_ref_id
							});
							depositItems.splice(0, 1);
						}
					})
				});
				payment.amount = LegacyCart.useCartViewTotalCalculation ? +LegacyCart.cartDetails.deposit_transfer_total : (Number(payment.amount) - totalDepositAmount).toFixed(2);
				paymentArr.push(payment);

				return paymentArr;
			}
			return payment;
		}

		/**
		 * Filter all deposit items in cart
		 * @function
		 * @public
		 * @returns {Array} all deposit items in cart
		 */
		function getMembershipDepositCartItems() {
			return LegacyCart.cartItems.filter(function(item) {
				return item.customer_type_name.toLowerCase() === 'deposit';
			});
		}

		/**
		 * Calculate total deposit amount in deposit cart items
		 * @function
		 * @public
		 * @param {Array} depositItems - all deposit items in cart
		 * @returns {Number} total deposit amount
		 */
		function getMembershipDepositTotalAmount(depositItems) {
			return depositItems.reduce(function(accumulator, currentItem) {
				return accumulator + Number(currentItem.retail_price);
			}, 0);
		}

		/**
		 * Creating Characs Obj for membership upgrade
		 * @function
		 * @protected
		 * @param {object} folio - folio data
		 * @returns {object} - membership characs obj
		 */
		function createMemCharacsObj(folio) {
			/* eslint-disable camelcase */
			return {
				isSeasonPass: true,
				one_barcode_parent: 1,
				ph_age: folio.age,
				ph_email: folio.email,
				ph_first_name: folio.first_name,
				ph_last_name: folio.last_name,
				ph_season_pass_number: 'NEW',
				ph_zip: folio.postal_code
			}
			/* eslint-disable camelcase */
		}

		function addFoliosToCartItems(itemsForCart, folios, folioCustomerType) {
			var folioItems = [];
			if (folios.length > 0) {
				folios.forEach(function(f) {
					if (f.selectedForCurrentPackage) {
						var newItem = Utilities.copyObject(folioCustomerType);
						newItem.qty = 1;
						f.addToItem(newItem);
						// need to put them on the front of the list:
						folioItems.unshift(newItem);
					}
				});
			}
			if (folioItems.length > 0) {
				folioItems.forEach(function(f) {
					itemsForCart.unshift(f);
				});
				addingNonUpgradeMembershipItemToCart(itemsForCart, folios);
			}
		}

		function numberOfSelectedFolios(folioList) {
			var result = 0;
			if (angular.isDefined(folioList) && folioList.length>0) {
				folioList.forEach(function(f) {
					if (f.selectedForCurrentPackage) {
						result += 1;
					}
				});
			}
			return result;
		}
		/**
		 * foliosForPackage returns an array of folio items that are available to the selected item
		 * @param pkg
		 **/
		function foliosForPackage(pkg) {
			var result=[];
			if (folioEnabledPackage(pkg)) {
				service.folios.forEach(function(folio) {
					if (service.folioCanPurchasePackage(folio, pkg)) {
						var newF = angular.copy(folio);
						newF.currentPackageId = pkg.id;
						result.push(newF);
					}
				});
			}
			return result;
		}

		function findFolioFor(mediaNumber) {
			if (service.folio_enabled && angular.isDefined(mediaNumber)) {
				for (var i=0; i<service.folios.length; i++) {
					if (service.folios[i].media_number == mediaNumber) {
						return service.folios[i];
					}
				}
			}
			return undefined;
		}

		/**
		 * addFolioInfoToSeasonPass adds the appropriate folio data to a season pass, based on the folio_id stored
		 * in its CHARACS.
		 * @param item
		 **/
		function folioInfoForSeasonPass(item) {
			var
				result = {},
				folioToUse = angular.isDefined(item.CHARACS) && angular.isArray(item.CHARACS) ? findFolioFor(item.CHARACS[0].client_media_number) : undefined;

			if (angular.isDefined(folioToUse)) {
				result.ph_age = folioToUse.age;
				result.ph_email = folioToUse.email;
				result.ph_first_name = folioToUse.first_name;
				result.ph_last_name = folioToUse.last_name;
				result.ph_zip = folioToUse.postal_code;
				result.client_media_number = folioToUse.media_number;
				return result;
			} else {
				return undefined;
			}
		}
		function setSeasonPassDefaults(defaults, item) {
			// folioInfoForSeasonPass returns undefined if the folio service hasn't been enabled
			var folioInfo = folioInfoForSeasonPass(item);
			if (angular.isDefined(folioInfo)) {
				for (var property in folioInfo) {
					if (folioInfo.hasOwnProperty(property)) {
						defaults[property]=folioInfo[property];
					}
				}
				defaults.replaceMedia= '0';
			}
		}

		/**
		 * AF 12607 We want to route users back to packageList page when they click on Continue Shopping after
		 * add item to cart. This function is used to check if the addToCartItem is folio or not, if it is, then
		 * return truec and route to packageList Page.
		 * @param newItemAddedtoCart
		 * @returns {boolean}
         */
		function onContinueShopping(newItemAddedtoCart) {
			var routeToPackageList = false;

			for (var i = 0; i < newItemAddedtoCart.length; i++) {
				var item = newItemAddedtoCart[i];
				if (safelyCheckPropertyOnObject('item.CHARACS.0.folio_id', item)) {
					routeToPackageList = true;
					$rootScope.routeTo('/packageList');
					break;
				}
			}
			return routeToPackageList;
		}

		function userToken() {
			return $location.$$search[Enums.urlParameters.userToken];
		}

		/**
		 * loadUser checks the url token for the user parameter and loads the folio details from it.
		 * Always resolves so that it does not stop the bootstrap process
		 *
		 * @returns {r.promise|deferred.promise|{then, catch, finally}|*|promise|p.promise}
     */
		function loadUser(cartId, showSpinner) {
			var folioLoader = $q.defer(),
				isUpgradeFlag = getBoolean($location.$$search[Enums.urlParameters.isUpgrade]),
				reqObj = new FolioModels.FolioRequest(userToken(), cartId, isUpgradeFlag),
				paymentInfo,
				disableStoredPayments = JSONValidator.validate('disableStoredPaymentsForFolios', AppData.settings.disableStoredPaymentsForFolios);
			if (!CustomActionService.actionRegistered(CustomActionService.ACTIONS_ENUMS.ATTACH_ADDITIONAL_CHARAC_TO_COMP)) {
				CustomActionService.registerCustomAction(CustomActionService.ACTIONS_ENUMS.ATTACH_ADDITIONAL_CHARAC_TO_COMP, addMediaNumbersToComps);
			}

			// when the folio URL parameter does not exist, reqObj will be invalid, preventing the GetFolioTokenInfo call
			// requestCache is being used to prevent multiple identical GetFolioTokenInfo calls from firing.
			if (reqObj.valid() && ! reqObj.equal(service.requestCache)) {
				if (showSpinner) {
					// $rootScope.showSpinner('LOADING YOUR SPECIAL DEALS!');  Not currently updating the spinner text.
				}
				service.folios = [];
				service.folio_enabled = false;
				service.requestCache.copy(reqObj);
				// Add reference of request in pendingRequests.
				$rootScope.pendingRequests.push(Enums.services.GET_FOLIO_TOKEN_INFO);
				AppData.fetch(Enums.services.GET_FOLIO_TOKEN_INFO, false, reqObj.data, false).then(
					function(data) {
						$rootScope.removePendingRequest(Enums.services.GET_FOLIO_TOKEN_INFO);

						service.folio_enabled = false;
						if (data.status == Enums.status.OK) {
							service.folio_enabled = true;

							/* Backend is now doing the valid park check. (7/21/2016)
							 * I'm leaving this code in comments in case that ever needs to change.
							if (safelyCheckPropertyOnObject('data.TOKEN_INFO.VALID_PARKS.PARK',data)) {
							// loop through valid parks, making sure we're in one of them
								for (var i=0; i<data.TOKEN_INFO.VALID_PARKS.PARK.length && ! service.folio_enabled; i++) {
									service.folio_enabled = AppData.merchantId == Utilities.forceInt(data.TOKEN_INFO.VALID_PARKS.PARK[i].park_code);
								}
							}
							 */
							// check to make sure the current date is in the valid range
							if (service.folio_enabled) {
								// Any missing dates are treated as not being a requirement.
								// i.e., if there's no validTo date, we assume that all dates after validFrom are valid.
								var today = Date.now(),
									yesterday = safelyCheckPropertyOnObject('data.TOKEN_INFO.valid_from', data) ? new Date(data.TOKEN_INFO.valid_from) : undefined,
									tomorrow = safelyCheckPropertyOnObject('data.TOKEN_INFO.valid_to', data) ? new Date(data.TOKEN_INFO.valid_to) : undefined;
								if (angular.isDefined(yesterday)) {
									service.folio_enabled = today >= yesterday.getTime();
								}
								if (angular.isDefined(tomorrow)) {
									service.folio_enabled = today <= tomorrow.getTime();
								}
							}
							if (service.folio_enabled && safelyCheckPropertyOnObject('data.TOKEN_INFO.token_id', data)) {
								service.tokenFromBackEnd = data.TOKEN_INFO.token_id;
							} else {
								// if there's no valid token ID, disable the folios
								service.folio_enabled = false;
							}
							// loop through data, adding instances of folio: var f = new folio(first, last, id); service.folios.push(f);
							if (service.folio_enabled && safelyCheckPropertyOnObject('data.TOKEN_INFO.FOLIOS.FOLIO', data)) {
								if (! angular.isArray(data.TOKEN_INFO.FOLIOS.FOLIO)) {
									data.TOKEN_INFO.FOLIOS.FOLIO = [data.TOKEN_INFO.FOLIOS.FOLIO];
								}
								data.TOKEN_INFO.FOLIOS.FOLIO.forEach(function(folioInfo, index) {
									if (index === 0) {
										service.membershipUpgrade = Utilities.safelyCheckPropertyOnObject('f.MEMBERSHIP_TICKETS.MEMBERSHIP_TICKET', folioInfo);
									}
									var newItem = new FolioModels.Folio(folioInfo, service.tokenFromBackEnd, service.membershipUpgrade);
									if (! newItem.errored) {
										service.folios.push(newItem);
									}
								});
							}
							// loop through data, adding packages that can be viewed
							if (service.folio_enabled && safelyCheckPropertyOnObject('data.TOKEN_INFO.RESTRICTED_PRODUCTS.PACKAGE', data)) {
								buildListOfAllowablePackages(data.TOKEN_INFO.RESTRICTED_PRODUCTS.PACKAGE);
							}

							if (service.folio_enabled && !disableStoredPayments) {
								paymentInfo = new FolioModels.FolioPayment(data.TOKEN_INFO);
								CustomActionService.registerCustomAction(CustomActionService.ACTIONS_ENUMS.GET_PAYMENT_INFO_FOR_FOLIOS, function returnPaymentInformation() {
									return paymentInfo;
								});
							}

							// if the current user has folios, register the action to filter shipping methods
							if (service.folio_enabled) {
								CustomActionService.registerCustomAction('filterShippingMethods', filterShippingMethods);
								CustomActionService.registerCustomAction('filterCustomerTypes', filterCustomerTypes);
								CustomActionService.registerCustomAction('setSeasonPassDefaults', setSeasonPassDefaults);
								CustomActionService.registerCustomAction(CustomActionService.ACTIONS_ENUMS.ON_CONTINUE_SHOPPING, onContinueShopping);
							}
							prepopulateBillingInfo(data.TOKEN_INFO);
							LegacyCart.setMembershipUpgradeTotalCalculation();
						} else {
							return folioLoader.reject(data);
						}
						service.loaded = true;
						correctMerchantPackageList(AppData.GetMerchantPackageList);
						folioLoader.resolve(data);
					}
				);
			} else {
				// whether it succeeded or failed, treat it as loaded.
				service.loaded = true;
				correctMerchantPackageList(AppData.GetMerchantPackageList);
				folioLoader.resolve();
			}
			return folioLoader.promise;
		}

		/**
		 * Save User Demographic info to UserInfo if we are in SF membership upgrade flow so they don't have to type in all info again at checkout
		 * @function
		 * @protected
		 * @param {object} tokenInfo - Token Info Object where it has all the billing and customer data
		 * @returns {undefined}
		 */
		function prepopulateBillingInfo(tokenInfo) {
			var billingAddress,
				customerDetails,
				email,
				userBillingInfo;
			if (!service.folio_enabled || !service.membershipUpgrade || !safelyCheckPropertyOnObject('tokenInfo.CUSTOMER_DETAILS.BILLING_ADDRESS', tokenInfo)) {
				return;
			}
			/* eslint-disable camelcase */
			billingAddress = tokenInfo.CUSTOMER_DETAILS.BILLING_ADDRESS;
			customerDetails = tokenInfo.CUSTOMER_DETAILS;
			email = safelyCheckPropertyOnObject('customerDetails.EMAIL.email_address', customerDetails, UtilsValidation.validString) ? customerDetails.EMAIL.email_address : '';
			userBillingInfo = {
				address: billingAddress.street,
				address2: billingAddress.co_dept,
				city: billingAddress.city,
				copy_to_billing: true,
				country: billingAddress.country,
				email: email,
				emailVerify: email,
				emailVerifyIsPrepopulated: true,
				firstName: customerDetails.first_name,
				lastName: customerDetails.last_name,
				phone: safelyCheckPropertyOnObject('customerDetails.PHONE.phone_number', customerDetails) ? customerDetails.PHONE.phone_number : '',
				state: billingAddress.state,
				zip: billingAddress.zip
			};
			UserInfo.set('shipping', userBillingInfo);
			UserInfo.set('billing', userBillingInfo);
			CustomActionService.registerCustomAction(CustomActionService.ACTIONS_ENUMS.FOLIO_MEMBERSHIP_UPGRADE, addDepositAmountToPayment);
			CustomActionService.registerCustomAction(CustomActionService.ACTIONS_ENUMS.ENABLE_RESET_CART, shouldEnableResetCart);

			/**
			 * shouldEnableResetCart - return true to the variable on cart controller so the button will show up on cart view
			 * @protected
			 * @function
			 * @return {boolean} - return true when register this action
			 */
			function shouldEnableResetCart() {
				return true;
			}
		}

		function buildListOfAllowablePackages(restrictedProducts) {
			var pkgs = angular.isArray(restrictedProducts) ? restrictedProducts: [restrictedProducts];
			pkgs.forEach(function(p) {
				if (angular.isDefined(p.id)) {
					var newnode = {
						id: p.id,
						CT: []
					};
					if (angular.isDefined(p.CT)) {
						if (! angular.isArray(p.CT)) {
							newnode.CT.push(p.CT.id);
						} else {
							p.CT.forEach(function(ct) {
								newnode.CT.push(ct.id);
							});
						}
					}
					service.allowablePackageIds.push(newnode);
				}
			});
		}
		function removeRestrictedPackages(packageList) {
			if (angular.isUndefined(packageList) || ! angular.isArray(packageList)) {
				return;
			}
			// splice out any packages that this user cannot see
			for (var i = packageList.length-1; i >= 0; i--) {
				if (! canViewPackage(packageList[i])) {
					packageList.splice(i, 1);
				}
			}
		}

		/**
		 * respondToNewCartId responds to GET_NEW_CART_ID, calling loadUser. This function does not change the newCartId
		 * data, so it should always return the original data.
		 *
		 * @param data
		 **/
		function respondToNewCartId(data) {
			var responder = $q.defer(),
				originalData = data; // just for clarity.
			if (angular.isDefined(data.cart_id)) {
				loadUser(data.cart_id).then(function() {
					responder.resolve(originalData);
				}).catch(function(data) {
					$rootScope.hideSpinner();
					Modal.displayModal({
						title: getLocale('FolioLabels', 'invalidFolioTokenTitle'),
						description: Language.getLocaleWithSuffixAndFallback('FolioLabels', 'invalidFolioTokenMsg', data.error_code),
						buttonFlags: [Enums.buttonFlags.OK],
						callback: function() {
							$rootScope.routeTo('reset/true');
						}
					});
				});
			} else {
				responder.resolve(originalData);
			}
			return responder.promise;
		}
		/**
		 * correctMerchantPackageList hides the restricted packages in the GetMerchantPackageList.
		 * It's called whenever GET_MERCHANT_PACKAGE_LIST is called and whenever the user is loaded.
		 *
		 * @param data
     **/
		function correctMerchantPackageList(data) {
			if (! safelyCheckPropertyOnObject('data.PS.P', data) || ! service.loaded) {
				return;
			}
			removeRestrictedPackages(data.PS.P);
		}

		function restrictTicketPrinting(ticket) {
			if (! service.canPrintTicket(ticket)) {
				ticket.print = false;
				ticket.reasonForNotPrinting = service.reasonForNotPrinting;
			}
		}
		/**
		 * filterCustomerTypes filters the customer types
		 * @param packageDetails
     **/
		function filterCustomerTypes(packageDetails) {
			// only filter if the package is in the list of restricted packages that are allowed.
			var currentPkg = service.allowablePackageIds.filter(function(pkg) {
				return packageDetails.id == pkg.id;
			})[0];
			if (angular.isDefined(currentPkg) && angular.isDefined(packageDetails.CT)) {
				var allowedCTs=currentPkg.CT;
				packageDetails.CT = (angular.isArray(packageDetails.CT)) ? packageDetails.CT : [packageDetails.CT];
				for (var i = packageDetails.CT.length - 1; i>=0; i--) {
					var keepit = false;
					allowedCTs.forEach(function(ct) {
						if (ct == packageDetails.CT[i].id) {
							keepit = true;
						}
					});
					if (! keepit) {
						packageDetails.CT.splice(i, 1);
					}
				}
			}
		}
		/**
		 * filterShippingMethods does an in-place modification of the available delivery methods,
		 * eliminating them if all of the packages are folio packages that do not require printing.
		 * @param deliveryMethods
     **/
		function filterShippingMethods(deliveryMethods, isNonPhysicalDeliveryMethod) {
			var printNothing = true,
				folioPassExists = false;

			function isAddon(item) {
				if (angular.isUndefined(item.CHARACS)) {
					return false;
				}
				var c = angular.isArray(item.CHARACS) ? item.CHARACS[0]: item.CHARACS;
				return (angular.isDefined(c) && angular.isDefined(c.group_uuid) && c.group_uuid.length>0 && c.one_barcode_parent != '1');
			}

			function isFolioPassThatsNotBeingPrinted(item) {
				if (angular.isUndefined(item.CHARACS)) {
					return false;
				}
				// an item should not be printed if:
				//   1. it has a media number, is gate redeemable, and its replaceMedia is set to false (either "No" or "0")
				//   2. is for a folio, is not gate redeemable
				var gateRedeemable = service.gateRedeemable(Package.getPackageByID(item.package_id)),
					c = angular.isArray(item.CHARACS) ? item.CHARACS[0]: item.CHARACS,
					hasMediaNumber = (angular.isDefined(c) && angular.isDefined(c.client_media_number) && c.client_media_number.length > 0);

				if (hasMediaNumber) {
					if (gateRedeemable) {
						return (!getBoolean(c.replaceMedia));
					} else {
						return true;
					}
				}
				return false;
			}

			// If there's nothing in the cart, just drop out. That's not the responsibility of this method.
			if (angular.isUndefined(LegacyCart.cartItems) || LegacyCart.cartItems.length<1) {
				return;
			}
			for (var i = 0; i < LegacyCart.cartItems.length && printNothing; i++) {
				// if there's an item with no characs, we don't know what it is. Drop out without messing with the delivery methods.
				if (angular.isUndefined(LegacyCart.cartItems[i].CHARACS)) {
					printNothing = false;
				} else if (isFolioPassThatsNotBeingPrinted(LegacyCart.cartItems[i])) {
					// folio pass that's not being printed? leave printNothing alone, and set folioPassExists
					folioPassExists = true;
				} else if (! isAddon(LegacyCart.cartItems[i])) {
					// not a folio pass or an addon? We need to print.
					printNothing = false;
				}
			}
			// only eliminate shipping methods if none of the tickets need to be printed, and we've found folio passes.
			if (printNothing && folioPassExists) {
				for (var j = deliveryMethods.length - 1; j >= 0; j--) {
					if (! isNonPhysicalDeliveryMethod(deliveryMethods[j].ship_method.toLowerCase())) {
						deliveryMethods.splice(j, 1);
					}
				}
			}
		}

		function bootStrap() {
			// don't need to initialize anything if we've already loaded this service (it gets loaded by loadUser)
			if (! service.loaded) {
				// initialize the cache:
				service.requestCache = new FolioModels.FolioRequest();

				// set up the callbacks
				PostRequestActionService.addCallBack(Enums.services.GET_MERCHANT_PACKAGE_LIST, correctMerchantPackageList);

				// GET_NEW_CART_ID makes an API call, so it has to return a promise;
				PostRequestActionService.addCallBack(Enums.services.GET_NEW_CART_ID, service.respondToNewCartId, true);

				// register custom actions which affect the entire store
				CustomActionService.registerCustomAction('restrictTicketPrinting', restrictTicketPrinting);
			}
		}

		function addMediaNumbersToComps(parent, comp) {
			if (angular.isDefined(parent) && angular.isDefined(comp)) {
				if (angular.isDefined(parent.CHARACS[0].client_media_number) && angular.isDefined(comp.CHARACS[0])) {
					comp.CHARACS[0].client_media_number = parent.CHARACS[0].client_media_number;
				}
			}
			return comp;
		}


		return service;
	});

/**
 * Created by pMatthews on 6/27/2016.
 */
angular.module('app')
	.factory('FolioModels',	function(Enums, StringUtils, Utilities, UtilsValidation) {
		var folio_models = {
			Folio: Folio,
			FolioRequest: FolioRequest,
			FolioPayment: FolioPayment
		};
		var safelyCheckPropertyOnObject = Utilities.safelyCheckPropertyOnObject,
			validObject = UtilsValidation.validObject,
			validString = UtilsValidation.validString,
			validArray = UtilsValidation.validArray,
			returnOrDefault = UtilsValidation.returnOrDefault,
			normalize = StringUtils.normalize;

		function cleanInput(o) {
			return angular.isDefined(o) ? o : '';
		}

		function Folio(folioFromAPI, tokenFromBackend, membershipUpgrade) {
			this.first_name = cleanInput(folioFromAPI.first_name);
			this.last_name = cleanInput(folioFromAPI.last_name);
			this.hasValidGateRedeemable = Utilities.getBoolean(cleanInput(folioFromAPI.has_valid_gate_redeemable));
			this.media_number = cleanInput(folioFromAPI.media_number);
			this.postal_code = cleanInput(folioFromAPI.postal_code);
			this.email = cleanInput(folioFromAPI.email);
			this.age = cleanInput(folioFromAPI.age);
			this.id = cleanInput(folioFromAPI.folio_id);
			this.token = tokenFromBackend;
			this.packagesToBuy = [];
			this.errored = (this.id ==''); // should I also check for a media number?
			this.currentPackageId = 0;
			this.membershipInfo = [];

			//Adding extra membership data to model if we are in membership upgrade flow
			if (membershipUpgrade && safelyCheckPropertyOnObject('folioFromAPI.MEMBERSHIP_TICKETS.MEMBERSHIP_TICKET', folioFromAPI, Array.isArray)) {
				this.membershipInfo = folioFromAPI.MEMBERSHIP_TICKETS.MEMBERSHIP_TICKET.map(function(membershipTicket) {
					return {
						currentPackageId: membershipTicket.package_id,
						customerType: membershipTicket.customer_type,
						offerPackage: membershipTicket.offer_package_id,
						packageClass: membershipTicket.package_class,
						ticketId: membershipTicket.ticket_id
					};
				});
			}

			this.displayName = function() {
				return this.first_name+' '+this.last_name+' (#'+this.media_number+')';
			};

			this.selectForPackage = function(packageId, selectIt) {
				if (selectIt) {
					this.packagesToBuy.push(packageId);
				} else {
					for (var i = this.packagesToBuy.length-1; i>=0; i--) {
						if (this.packagesToBuy[i]==packageId) {
							this.packagesToBuy.splice(i, 1);
						}
					}
				}
			};

			this.selectedForPackage = function(packageId) {
				for (var i = 0; i < this.packagesToBuy.length; i++) {
					if (this.packagesToBuy[i] == packageId) {
						return true;
					}
				}
				return false;
			};
			this.clearSelectedPackages = function(packageId) {
				if (angular.isUndefined(packageId)) {
					this.packagesToBuy = [];
				} else {
					this.selectForPackage(packageId, false);
				}
			};
			this.addToItem = function(item) {
				if (angular.isDefined(item)) {
					if (angular.isUndefined(item.CHARACS)) {
						item.CHARACS = [{}];
					}
					for (var i=0; i<item.CHARACS.length; i++) {
						item.CHARACS[i].client_media_number = this.media_number;
						item.CHARACS[i].folio_id = this.id;
						item.CHARACS[i].token = this.token;
						// item.CHARACS[i].prevent_item_merging = "1"; // <= This is currently a package charac, but if it ever moves to this level, just uncomment this line.
					}
				}
			};
		}

		Folio.prototype = {
			get selectedForCurrentPackage() {
				return this.selectedForPackage(this.currentPackageId);
			},

			set selectedForCurrentPackage(value) {
				this.selectForPackage(this.currentPackageId, value);
			}
		};

		/**
		 * Folio Request model
		 * @function
		 * @public
		 * @param {string} token - folio token
		 * @param {string} cart_id - cart id
		 * @param {boolean} isUpgradeFlag - upgrade url param meter
		 * @return {undefined}
		 */
		function FolioRequest(token, cart_id, isUpgradeFlag) {
			this.data = {
				token: token,
				cart_id: cart_id,
				is_upgrade: isUpgradeFlag
			};

			this.valid = function() {
				return !!this.data.token && !!this.data.cart_id;
			};

			this.equal = function(tgt) {
				return tgt && tgt.data && tgt.data.token == this.data.token && tgt.data.cart_id == this.data.cart_id;
			};

			this.copy = function(src) {
				this.data = angular.copy(src.data);
			};
		}

		/**
		 * Returns if payment information is valid or not
		 * @private
		 * @param {Object} paymentInformation payment information
		 * @returns {Boolean} true if payment information is valid
		 */
		 function _hasValidPaymentInfo(paymentInformation) {
			return validObject(paymentInformation) && validString(paymentInformation.cc_last_four) && validString(paymentInformation.card_type_code);
		}

		/**
		 * Folio Payment Model
		 * @public
		 * @param {Object} tokenInfo token information from BE
		 * @returns {undefined}
		 */
		function FolioPayment(tokenInfo) {
			var paymentInformation = safelyCheckPropertyOnObject('tokenInfo.PAYMENT_METHOD', tokenInfo, validObject) ? tokenInfo.PAYMENT_METHOD : {},
				customerDetails = safelyCheckPropertyOnObject('tokenInfo.CUSTOMER_DETAILS', tokenInfo, validObject)? tokenInfo.CUSTOMER_DETAILS : {},
				billingInformation = safelyCheckPropertyOnObject('customerDetails.BILLING_ADDRESS', customerDetails, validObject) ? customerDetails.BILLING_ADDRESS : {},
				email = safelyCheckPropertyOnObject('customerDetails.EMAIL.email_address', customerDetails, validString) ? customerDetails.EMAIL.email_address : '',
				phone = safelyCheckPropertyOnObject('customerDetails.PHONE.phone_number', customerDetails, validString) ? customerDetails.PHONE.phone_number : '';

			if (_hasValidPaymentInfo(paymentInformation)) {
				this.CARD = {
					card_last_four: paymentInformation.cc_last_four,
					card_type: paymentInformation.card_type_code
				};
			}

			this.CARDHOLDER = {
				address: returnOrDefault(billingInformation.street, '', validString),
				address2: returnOrDefault(billingInformation.co_dept, '', validString),
				city: returnOrDefault(billingInformation.city, '', validString),
				country: returnOrDefault(billingInformation.country, '', validString),
				email: email,
				emailVerify: email,
				emailVerifyIsPrepopulated: true,
				firstName: returnOrDefault(customerDetails.first_name, '', validString),
				lastName: returnOrDefault(customerDetails.last_name, '', validString),
				phone: phone,
				state: returnOrDefault(billingInformation.state, '', validString),
				zip: returnOrDefault(billingInformation.zip, '', validString)
			};
			// token value to match the stored payments model
			if (validObject(this.CARD) && validString(this.CARD.card_last_four) && validString(this.CARD.card_type)) {
				this.token = this.CARDHOLDER.firstName + this.CARD.card_last_four + this.CARD.card_type;
			}
		}

		/**
		 * Converts the payment card type
		 * @public
		 * @param {Object[]} billingTypes billing types
		 * @returns {undefined}
		 */
		FolioPayment.prototype.convertPaymentCardType = function(billingTypes) {
			var found;

			if (validArray(billingTypes) && validObject(this.CARD)) {
				found = billingTypes.find(function findMatchingCard(billingType) {
					return billingType.auth_type === Enums.authTypes.CREDITCARD && billingType.card_type_code === this.CARD.card_type;
				}, this);

				if (found) {
					this.CARD.card_type = validArray(found.raw_card_type_list) ? found.raw_card_type_list[0] : normalize(found.name).replace('americanexpress', 'amex');
				}
			}
		}

		return folio_models;
	});

angular
	.module('upgrades-wizard', [
		'app', 'passholder-lookup', 'ui.bootstrap'
	])
	.config(function($locationProvider, $stateProvider) {
		$stateProvider
			.state('upgrades-wizard', {
				controller: 'UpgradesWizardController',
				url: '/upgrades/{keyword:keyword}/:folioId',
				templateUrl: '/scripts/modules/upgrades-wizard/views/upgrades-wizard.html',
				resolve: {
					//resolve failures are handled within run.js of main app
					load: function($rootScope, Utilities) {
						$rootScope.showSpinner();
						return Utilities.cacheBustAndLazyLoad([
							'/scripts/modules/upgrades-wizard/upgrades-wizard-models.js',
							'/scripts/modules/upgrades-wizard/controllers/upgrades-wizard-controller.js',
							'/scripts/modules/upgrades-wizard/services/upgrades-wizard-finalize-service.js',
							'/scripts/modules/upgrades-wizard/services/upgrades-wizard-prep-service.js',
							'/scripts/modules/upgrades-wizard/services/upgrades-wizard-enums-service.js'
						]);
					},
					initialData: function(Bootstrap) {
						return Bootstrap.bootstrapApplication();
					},
					folios: function(initialData, $injector, $transition$) {
						var stateParams = $transition$.params();
						return $injector.get('UpgradesWizardPrepService').getDemographicInfo(stateParams.folioId, stateParams.keyword);
					},
					packages: function(folios, $injector, $transition$) {
						return $injector.get('UpgradesWizardPrepService').getUpgradesWizardPackages($transition$.params().keyword);
					}
				}
			})
	})
	.run(function(ExtraFlow) {
		// Register this extra flow alternate module with the extra flow service
		ExtraFlow
			.registerXMC('UpgradesWizard', {
				name: 'UpgradesWizard',
				view: 'upgrades-wizard',
				doEditMode: false,
				lockQuantity: true,
				writeSingleCharac: false,
				enabled: true,
				type: 'alternateFlowModule'
			});
	});
angular.module('gift-membership',
	['passholder-lookup', 'accesso-data-table', 'autofill'])
	.config(function($locationProvider, $stateProvider) {
		$stateProvider
			.state('gift-membership', {
				abstract: true,
				url: '/gift-membership',
				template: '<div ui-view></div>',
				resolve: {
					load: function($rootScope, Utilities) {
						$rootScope.showSpinner();

						return Utilities.cacheBustAndLazyLoad([
							'/scripts/modules/gift-membership/controllers/gift-membership-activation-controller.js',
							'/scripts/modules/gift-membership/controllers/gift-membership-lookup-controller.js',
							'/scripts/modules/gift-membership/controllers/gift-membership-demographics-controller.js',
							'/scripts/modules/gift-membership/gift-membership-models.js',
							'/scripts/modules/gift-membership/services/gift-membership-finalize-service.js',
							'/scripts/modules/gift-membership/services/gift-membership-request-service.js',
							'/scripts/modules/gift-membership/services/gift-membership-enums-service.js',
							'/scripts/modules/gift-membership/services/gift-membership-configuration-factory.js'

						]);
					},
					initialData: function(load, Bootstrap) {
						return Bootstrap.bootstrapApplication();
					},
					pass: function(initialData, $injector) {
						var GiftMembershipModels = $injector.get('GiftMembershipModels');
						return new GiftMembershipModels.PassHolder();
					}
				}
			})
			.state('gift-membership.activation', {
				controller: 'GiftMembershipActivationController',
				url: '',
				templateUrl: '/scripts/modules/gift-membership/views/gift-membership-activation.html'
			})
			.state('gift-membership.lookup', {
				controller: 'GiftMembershipLookupController',
				url: 'lookup',
				templateUrl: '/scripts/modules/gift-membership/views/gift-membership-lookup.html',
				resolve: {
					passLookupRoute: function(initialData, pass, RouteRejectionService) {
						if (angular.isUndefined(pass) || pass.barcode == '' || pass.orderNumber == '' || pass.ph_season_pass_number == '') {
							throw new RouteRejectionService.UnrecoverableException('gift-membership.activation');
						}
					}
				}
			})
			.state('gift-membership.demographics', {
				controller: 'GiftMembershipDemographicsController',
				url: 'demographics',
				templateUrl: '/scripts/modules/gift-membership/views/gift-membership-demographics.html',
				resolve: {
					passDemographicsRoute: function(initialData, pass, RouteRejectionService) {
						if (angular.isUndefined(pass) || pass.barcode == '' || pass.orderNumber == '' || pass.ph_season_pass_number == '') {
							throw new RouteRejectionService.UnrecoverableException('gift-membership.activation');
						}
					}
				}
			})
	})
	.run(function(ExtraFlow) {
		// Register this extra flow alternate module with the extra flow service
		ExtraFlow.registerXMC
		('GiftMembership',
			{
				name: 'GiftMembership',
				view: 'gift-membership',
				doEditMode: false,
				lockQuantity: true,
				writeSingleCharac: false,
				enabled: true,
				type: 'alternateFlowModule'
			}
		);
	});

angular.module('passholder-lookup', ['app']);

/**
 * Created by ltischuk on 4/3/15.
 */
/**
 * Created by ltischuk on 02/20/14.
 * Directive for passholder lookup form to be used across multiple modules
 */
angular.module('passholder-lookup')
	.directive('passholderLookup'
		, function(Language,
						PassholderLookupService) {
			var directive = {
				restrict: 'E',
				templateUrl: '/scripts/modules/passholder-lookup/views/lookup.html',
				scope:
			{
				minLenForPassNumberCheck: '@',
				maxLenForPassNumberCheck: '@',
				onBypassPassLookup: '&',
				onLookupSuccess: '&',
				onLookupFailure: '&'
			},
				link: function(scope, element, attrs, ngModelCtrl) {
					scope.lookupSubmitted = false;
					scope.lookupNumber = '';
					scope.lastName = '';
					scope.i18n = Language;
					scope.minLenForPassNumberCheck = angular.isDefined(scope.minLenForPassNumberCheck) ? Number(scope.minLenForPassNumberCheck) : 0;
					scope.maxLenForPassNumberCheck = angular.isDefined(scope.maxLenForPassNumberCheck) ? Number(scope.maxLenForPassNumberCheck) : 0;

					/**
					 * Lookup the pass number
					 */
					scope.performPassholderLookup = function() {
						scope.submitted = true;
						var isBarCode = false;
						if (!scope.passholderLookupForm.$invalid) {
							if (scope.minLenForPassNumberCheck > 0 && scope.maxLenForPassNumberCheck > 0) {
								isBarCode = scope.lookupNumber.length > scope.maxLenForPassNumberCheck || scope.lookupNumber.length < scope.minLenForPassNumberCheck;
							}

							PassholderLookupService.callPassholderLookup(scope.lookupNumber, scope.lastName, isBarCode, scope.onLookupSuccess, scope.onLookupFailure);
						}
					}

					scope.bypassLookup = function() {
						scope.onBypassPassLookup();
					}
				}
			}

			return directive;
		});

angular.module('passholder-lookup')
	.service
	('PassholderLookupService',
		function(AppData,
			Utilities,
			Enums,
			$rootScope) {
		/**
		 * Call passholder lookup
		 * @param lookupNumber
		 * @param lastName
		 * @param isBarCode
		 * @param successCallback
		 * @param failureCallback
		 */
			this.callPassholderLookup = function(lookupNumber, lastName, isBarCode, successCallback, failureCallback) {
				$rootScope.showSpinner();
				var request = {};

				request.last_name = lastName;
				request.season_passholder_barcode = isBarCode ? lookupNumber : '';
				request.season_passholder_seasonpassnumber = request.season_passholder_barcode.length > 0 ? '' : lookupNumber;

				AppData.fetch(
					Enums.services.SEASON_PASS_LOAD
					, false
					, request
				).then(function(data) {
					if (data.status == Enums.status.OK && data.PASSHOLDER) {
						if (angular.isDefined(data.PASSHOLDER.ph_eligible_for_renewal) && ! Utilities.getBoolean(data.PASSHOLDER.ph_eligible_for_renewal)) {
							$rootScope.hideSpinner();
							failureCallback({
								error: {
									id: Enums.status.INELIGIBLE_PASS,
									data: data.PASSHOLDER.ph_eligible_for_renewal_date
								}
							});
						} else {
							successCallback({ data: data.PASSHOLDER });
						}
					} else {
						$rootScope.hideSpinner();
						failureCallback();
					}
				},
				function(err) {
					$rootScope.hideSpinner();
					failureCallback();
				}
				)
			}
		});

/**
 * Created by ltischuk on 1/9/15.
 */
angular.module('multi-guest-generic-form',
	['app'])
	.config(function ($locationProvider, $stateProvider) {
		var MODULE_DIR = '/scripts/modules/extraflow/multi-guest-generic-form';

		$stateProvider
			.state('multi-guest-generic-form', {
				url: '/multiGuestGenericForm/:packageId',
				templateUrl: MODULE_DIR + '/views/form.html',
				controller: 'MultiGuestGenericFormController',
				resolve: {
					//resolve failures are handled within run.js of main app
					load: function( $rootScope, Utilities ){
						$rootScope.showSpinner();

						return Utilities.cacheBustAndLazyLoad([
							MODULE_DIR + '/controllers/multi-guest-generic-form-controller.js',
							MODULE_DIR + '/services/multi-guest-generic-form-prep-service.js',
							MODULE_DIR + '/services/multi-guest-generic-form-enums-service.js',
							MODULE_DIR + '/services/multi-guest-generic-form-finalize-service.js',
							MODULE_DIR + '/multi-guest-generic-form-models.js',
							MODULE_DIR + '/multi-guest-generic-form.css',
							MODULE_DIR + '/directives/dynamic-form/dynamic-form-directive.js'
						]);
					},
					initialData: function(load,Bootstrap) {
						return Bootstrap.bootstrapApplication();
					},
					xfcMap: function(initialData, Package) {
						return Package.buildXFCMap();
					},
					configuration: function(xfcMap, $injector) {
						return $injector.get('MultiGuestGenericFormPrepService').getConfigurationSettings();
					},
					forms: function(configuration, $injector){
						return $injector.get('MultiGuestGenericFormPrepService').getForms(configuration.formItems);
					}
				}
			})
	})
	.run(function(ExtraFlow) {

		// Register this extra flow alternate module with the extra flow service
		ExtraFlow.registerXMC('multi_guest_generic_form', {
			name: 'multi_guest_generic_form',
			view: 'multiGuestGenericForm',
			showCapacityRemaining: false,
			lockQuantity: false,
			showTimeList: false,
			doEditMode: true,
			writeSingleCharac: false,
			enabled: true,
			type: 'extraFlowControl'
		});
	});

angular.module("static-include", []).directive('staticInclude', function($http, $templateCache, $compile) {
	return {
		restrict: 'A',
		transclude: true,
		replace: true,
		scope: false,
		link: function($scope, element, attrs, ctrl, transclude) {
			var templatePath = attrs.staticInclude;

			try {
				templatePath = $scope.$eval(templatePath);
			} catch (err) {
				throw new Error(attrs.staticInclude + ' is not a valid object');
			}

			$http.get(templatePath, { cache: $templateCache })
				.then(function(response) {
					var contents = element.html(response.data).contents();
					$compile(contents)($scope);
				});
		}
	};
});
(function() {
	'use strict';

	angular
		.module('apple-pay', ['app', 'utilities']);
})();

(function() {
	'use strict';

	angular
		.module('apple-pay')
		.run(run);

	/**
	 * Our run container.
	 * @public
	 * @param {Scope} $rootScope $rootScope
	 * @param {Service} BillingService Our billing service
	 * @param {Service} ApplePayPreloader Handles validating we can check Apple Pay before downloading services.
	 * @param {Object} Enums Enums
	 * @return {undefined}
	 * @ngInject
	 */
	function run($rootScope, BillingService, ApplePayPreloader, Enums) {
		// trigger loading of the prep service so that it can listen for application activated event
		var onAppActivated = $rootScope.$on(Enums.services.APP_ACTIVATED, function() {
			if (ApplePayPreloader.sessionAvailable) {
				BillingService.appendPaymentMethodLoadPromise(ApplePayPreloader.loadAssetsAndCheckDevice);
			}
			// stop listening
			onAppActivated();
		});
	}
})();

(function() {
	'use strict';

	angular
		.module('apple-pay')
		.constant('APPLE_PAY_VERSION', 2);
}());

(function() {
	'use strict';

	var isArray = Array.isArray;

	angular
		.module('apple-pay')
		.factory('ApplePayPreloader', ApplePayPreloader);


	/**
	 * Finds out if Apple Pay is available on the device, loads modules if applicable.
	 * @public
	 * @module {apple-pay}
	 * @memberof {ApplePay}
	 * @param {Service} $injector For getting an instance of the service after lazy loaded
	 * @param {Service} $log For logging failures
	 * @param {Service} $q For promises
	 * @param {Service} $window The window service
	 * @param {Service} AppData The appdata service
	 * @param {Service} Embed Embed
	 * @param {Number} APPLE_PAY_VERSION The current version we use.
	 * @param {Object} BillingModels A collection of billing models
	 * @param {Object} BillingService Our billing service
	 * @param {Object} Enums A collection of constants
	 * @param {Object} JSONValidator JSONValidator
	 * @param {Service} PaymentService Used to register the payment action
	 * @param {Service} StringUtils StringUtils Service
	 * @param {Service} Utilities a collection of utilities
	 * @param {Service} UtilsValidation  The service
	 * @return {Service} The public service
	 * @ngInject
	 */
	function ApplePayPreloader($injector, $log, $q, $window, AppData, Embed, APPLE_PAY_VERSION, BillingModels, BillingService, Enums, JSONValidator, PaymentService, StringUtils, Utilities, UtilsValidation) {
		var isObject = angular.isObject,
			validArray = UtilsValidation.validArray,
			validString = UtilsValidation.validString,
			normalize = StringUtils.normalize,
			inIframe = Utilities.isInIFrame(),
			returnOrDefault = UtilsValidation.returnOrDefault,
			getBoolean = Utilities.getBoolean,
			applePayAvailableInIframe = false;

		var PROVIDER_NAME = Enums.paymentProvider.APPLEPAY,
			NORMALIZED_CYBERSOURCE_BILLING_PROVIDER_APPLE_PAY = normalize(Enums.billingProviders.CYBERSOURCE_APPLEPAY),
			NORMALIZED_ADYEN_BILLING_PROVIDER_APPLE_PAY = normalize(Enums.billingProviders.ADYEN_APPLEPAY);

		/**
		 * Our public API.
		 */
		var service = {
			_getExpressCheckoutButtonStyles: _getExpressCheckoutButtonStyles,
			applePaySessionAvailable: applePaySessionAvailable,
			filterApplePayBillingTypes: filterApplePayBillingTypes,
			isApplePayConfigured: isApplePayConfigured,
			queryParentForAvailability: queryParentForAvailability,
			get sessionAvailable() {
				return service.applePaySessionAvailable(inIframe, $window.ApplePaySession, APPLE_PAY_VERSION);
			},
			set sessionAvailable(val) {
				throw new Error('you may not modify ApplePayPreloader.sessionAvailable');
			}
		};
		service.loadAssetsAndCheckDevice = loadAssetsAndCheckDevice.bind(service);

		if (inIframe) {
			window.addEventListener('message', function onApplePayMessage(message) {
				var msg;
				try {
					msg = JSON.parse(message.data);

					if (!UtilsValidation.isRealObject(msg)) {
						return;
					}

					if (msg.messageType === Enums.messages.APPLEPAY_ON_AVAILABLE) {
						applePayAvailableInIframe = Utilities.getBoolean(msg.isAvailable);
						$log.log('[ApplePay] availability: ' + applePayAvailableInIframe);
						$window.removeEventListener('message', onApplePayMessage);
						BillingService.appendPaymentMethodLoadPromise(service.loadAssetsAndCheckDevice);
					}
				} catch (err) {
					// ignore and just don't allow apple pay
				}
			}, false);
			service.queryParentForAvailability();
		}

		return service;

		/**
		 * Queries the parent window to find out if apple pay is available
		 * @public
		 * @returns {undefined}
		 */
		function queryParentForAvailability() {
			$window.parent.postMessage(JSON.stringify({
				messageType: Enums.messages.APPLEPAY_CHECK,
				version: APPLE_PAY_VERSION
			}), '*');
		}

		/**
		 * Find out if the session is available
		 * @public
		 * @memberof {ApplePayPreloader}
		 * @param {Boolean} isInIframe Are we in an iframe? If so, we can't load ApplePay
		 * @param {ApplePaySession} ApplePaySession The Apple Pay API
		 * @param {Number} version The version to check if the device supports
		 * @return {Boolean} Is apple pay available or not
		 */
		function applePaySessionAvailable(isInIframe, ApplePaySession, version) {
			if (inIframe) {
				return applePayAvailableInIframe;
			}

			return angular.isFunction(ApplePaySession) && ApplePaySession.supportsVersion(version) && ApplePaySession.canMakePayments();
		}

		/**
		 * Loads all assets needed for Apple Pay
		 * @public
		 * @memberof {ApplePayPreloader}
		 * @return {Promise} Returns a promise for getting the assets
		 */
		function loadAssetsAndCheckDevice() {
			return $q(function(resolve) {
				// Bail immediately if the ApplePaySession object isn't available on the window. If its not there, they can't use it.
				if (!service.sessionAvailable || !service.isApplePayConfigured(AppData.billingTypes)) {
					return resolve();
				}

				BillingService.addUnsupportedPaymentForDeferredPayments(Enums.paymentProvider.APPLEPAY);

				Utilities
					.cacheBustAndLazyLoad([
						'scripts/modules/billing/modules/apple-pay/apple-pay-utils.js',
						'scripts/modules/billing/modules/apple-pay/apple-pay-service.js'
					])
					.then(getLoadAssetsCacheOnSuccess(resolve))
					.catch(getLoadAssetsCacheOnFailure(resolve, $log));
			}.bind(this));
		}

		/**
		 * The callback function for when loading assets fails.
		 * @protected
		 * @memberof {ApplePayPreloader}
		 * @param {Function} resolve The resolve function since we never want to reject this. Otherwise the user wouldnt be able to continue.
		 * @param {Service} $log For logging the failure
		 * @return {Function} the callback function
		 */
		function getLoadAssetsCacheOnSuccess(resolve) {
			return function() {
				var applePayService = $injector.get('ApplePayService');
				registerPaymentMethod(
					applePayService.paymentAction,
					BillingModels,
					BillingService,
					PaymentService,
					Enums.billingTypes.CREDITCARD,
					Enums.authTypes.CREDITCARD,
					JSONValidator
				);
				resolve();
			};
		}

		/**
		 * Find out if we have the ApplePay payment provider setup for apple pay on any of our billing types.
		 * @protected
		 * @function
		 * @name isApplePayConfigured
		 * @memberof {ApplePayPreloaderService}
		 * @param {Array<Object>} billingTypes Our configured billing types
		 * @param {String} provider The payment provider desc name.
		 * @return {Boolean} is it configured?
		 */
		function isApplePayConfigured(billingTypes) {
			if (!validArray(billingTypes)) {
				return false;
			}

			return billingTypes.some(service.filterApplePayBillingTypes);
		}

		/**
		 * Filters items that are available for apple pay.
		 * @public
		 * @function
		 * @name filterApplePAyBillingTypes
		 * @param {Object} item The billing type to test
		 * @return {Boolean} boolean
		 */
		function filterApplePayBillingTypes(item) {
			if (!isObject(item) || isArray(item)) {
				return false;
			}

			if (item.auth_type === Enums.billingTypes.CREDITCARD && validString(item.billing_provider_desc) && (normalize(item.billing_provider_desc) === NORMALIZED_CYBERSOURCE_BILLING_PROVIDER_APPLE_PAY || normalize(item.billing_provider_desc) === NORMALIZED_ADYEN_BILLING_PROVIDER_APPLE_PAY)) {
				PROVIDER_NAME = item.billing_provider_desc.toLowerCase();
				return true;
			}

			return item.auth_type === 'EC' && item.billing_provider_desc === PROVIDER_NAME;
		}

		/**
		 * The callback function for when loading assets fails.
		 * @protected
		 * @memberof {ApplePayPreloader}
		 * @param {Function} resolve The resolve function since we never want to reject this. Otherwise the user wouldnt be able to continue.
		 * @param {Service} $log For logging the failure
		 * @return {Function} the callback function
		 */
		function getLoadAssetsCacheOnFailure(resolve, $log) {
			return function(err) {
				$log.error('Error lazy loading Apple Pay modules - this payment method will not be shown - [' + err.toString() + ']');
				resolve();
			};
		}

		/**
		 * Register the paymenth method so it shows up on the screen..
		 * @protected
		 * @memberof {ApplePayPreloader}
		 * @see https://developer.apple.com/design/human-interface-guidelines/apple-pay/overview/buttons-and-marks/ for ApplePay Mark details
		 * @param {Function} paymentAction Our payment action callback when the user selects Apple Pay as their payment action
		 * @param {Model} BillingModels We need this to create a PaymentMethod object.
		 * @param {Service} BillingService Billing service is required to register the payment model
		 * @param {Service} PaymentService Used to register the payment action
		 * @param {String} BILLING_TYPE The APPLEPAY constant from Enums.billingTypes
		 * @param {String} AUTH_TYPE The APPLEPAY constant from Enums.authTypes
		 * @param {Service} JSONValidator JSONValidator
		 * @return {undefined}
		 */
		function registerPaymentMethod(paymentAction, BillingModels, BillingService, PaymentService, BILLING_TYPE, AUTH_TYPE, JSONValidator) {
			var expressPayment,
				appDataSettings = AppData.settings,
				expressCheckoutConfig = JSONValidator.validate('expressCheckouts', appDataSettings.expressCheckouts) ? JSON.parse(appDataSettings.expressCheckouts) : {};
			var paymentMethod = new BillingModels.PaymentMethod(PROVIDER_NAME, BILLING_TYPE, 'apple-pay.png');

			if (!(expressCheckoutConfig[PROVIDER_NAME] && getBoolean(expressCheckoutConfig[PROVIDER_NAME].disable))) {
				expressPayment = new BillingModels.ExpressWalletPayment(PROVIDER_NAME, AUTH_TYPE, BILLING_TYPE, paymentAction);
				expressPayment.addCssClasses(service._getExpressCheckoutButtonStyles(expressCheckoutConfig));
				BillingService.registerExpressWalletPayment(expressPayment);
			}

			BillingService.registerBillingRoutePaymentProviders(PROVIDER_NAME);
			BillingService.registerPaymentMethod(paymentMethod);
			PaymentService.registerAlternatePaymentActions(PROVIDER_NAME, paymentAction);
		}

		/**
		 * Returns express checkout button style classes
		 * @private
		 * @memberof {ApplePayPreloader}
		 * @param {Object} expressCheckoutConfig app config
		 * @returns {String} css classes
		 */
		function _getExpressCheckoutButtonStyles(expressCheckoutConfig) {
			var expressCheckoutButtonStyle = 'apple-pay-button-black',
				expressCheckoutButtonType = 'apple-pay-button-checkout',
				expressCheckoutButtonOrderClass = '',
				stylesArr = ['apple-pay-button'];

			expressCheckoutButtonStyle = returnOrDefault(expressCheckoutConfig[PROVIDER_NAME] && expressCheckoutConfig[PROVIDER_NAME].styles && expressCheckoutConfig[PROVIDER_NAME].styles.buttonStyle, expressCheckoutButtonStyle, validString);
			expressCheckoutButtonType = returnOrDefault(expressCheckoutConfig[PROVIDER_NAME] && expressCheckoutConfig[PROVIDER_NAME].styles && expressCheckoutConfig[PROVIDER_NAME].styles.buttonType, expressCheckoutButtonType, validString);
			expressCheckoutButtonOrderClass = returnOrDefault(expressCheckoutConfig[PROVIDER_NAME] && expressCheckoutConfig[PROVIDER_NAME].orderClass, expressCheckoutButtonOrderClass, validString);
			stylesArr.push(expressCheckoutButtonStyle, expressCheckoutButtonType, expressCheckoutButtonOrderClass);

			return stylesArr.join(' ');
		}
	}
})();

(function() {
	'use strict';

	angular
		.module('billing', [
			'apple-pay',
			'three-d-secure',
			'adyen',
			'stored-value-card'
		]).config(function($locationProvider, $stateProvider) {
			$stateProvider
				.state('pending-order', {
					controller: 'SharedPendingViewController',
					controllerAs: 'vm',
					resolve: {
						initialData: function(Bootstrap) {
							return Bootstrap.bootstrapApplication();
						},
						load: function(initialData, Utilities) {
							return Utilities.cacheBustAndLazyLoad(['/scripts/modules/billing/modules/pending-order/pending-order-controller.js']);
						}
					},
					templateUrl: '/scripts/modules/billing/modules/pending-order/pending-order.html',
					url: '/pending-order'
				});
		});
})();
/**
 * Created by ltischuk on 8/30/16.
 */
(function() {
	'use strict';

	angular.module('billing')
		.service('BillingModels', BillingModels);

	/**
	 * Billing Model
	 * @constructor
	 * @public
	 * @param {Service} $rootScope $rootScope service
	 * @param {Service} AppData AppData service
	 * @param {Service} Modal Modal service
	 * @param {Service} Language Language service
	 * @param {Service} UtilsValidation UtilsValidation service
	 * @returns {undefined}
	 * @ngInject
	 */
	function BillingModels($rootScope, AppData, Modal, Language, UtilsValidation) {
		var getLocale = Language.getLocale,
			returnOrDefault = UtilsValidation.returnOrDefault,
			validString = UtilsValidation.validString;
		/**
		 * Base model for a payment method
		 * @function
		 * @constructor
		 * @param {String} name - payment name
		 * @param {String} authType - auth type
		 * @param {String} imageName - image for payment logo
		 * @param {String} billingType - billing type
		 * @returns {undefined}
		 */
		function PaymentMethod(name, authType, imageName, billingType) {
			var merchantId = AppData.merchantId,
				localeExists = Language.localeExists,
				logoTarget = merchantId + '_logo_' + authType,
				iconTarget = merchantId + '_icon_' + authType;

			this.methodName = name;
			this.authType = authType;
			this.billingId = '';
			this.billingType = returnOrDefault(billingType, '', validString);
			this.cepayMerchantId = '';
			this.imageName = imageName;
			this.customInputFields = [];
			this.ccTypeOverride = undefined;
			this.maxPartialPaymentCount = 0;
			this.showInfoMsg = false;
			this.overridePaymentFormContinueButton = false;
			this.desktopCardImage = '/images/' + authType.toLowerCase() + '.png';
			this.mobileCardImage = authType;
			this.useCssImage = false;
			this.classNames = '';
			this.customIcon = localeExists('CustomPaymentLogo', iconTarget) ? getFilePath(iconTarget) : false;
			this.customLogo = localeExists('CustomPaymentLogo', logoTarget) ? getFilePath(logoTarget) : false;
		}

		/**
		 * return image file path from server
		 * @protected
		 * @function
		 * @name checkCustomLogoLocale
		 * @param {String} target The locale target
		 * @returns {String} return file path string
		 */
		function getFilePath(target) {
			return $rootScope.getAssetUrl(getLocale('CustomPaymentLogo', target));
		}

		/**
		 * Add a custom input field required for capture on our standard paymentMethod form route
		 * @param {Object} field custom field
		 * @returns {undefined}
		 */
		PaymentMethod.prototype.addCustomInputField = function(field) {
			this.customInputFields.push(field);
		}


		/**
		 * Add a custom input field required for capture on our standard paymentMethod form route
		 * @param {String} name name
		 * @param {Boolean} required required
		 * @param {String} validationType validationType
		 * @param {String} validationRegex validationRegex
		 * @returns {undefined}
		 */
		PaymentMethod.prototype.addAndCreateCustomInputField = function(name, required, validationType, validationRegex) {
			this.customInputFields.push(new CustomInputField(name, required, validationType, validationRegex))
		}

		/**
		 * Get the custom input field given a name
		 * @param {String} fieldName field name
		 * @returns {Object} customInputField
		 */
		PaymentMethod.prototype.getCustomInputFieldByName = function(fieldName) {
			return this.customInputFields.filter(function(fld) {
				return fld.fieldName === fieldName;
			})[0];
		};

		/**
		 * Get the non-secure storable fields for the UserInfo.payment model
		 * @returns {Object} sortable fileds
		 */
		PaymentMethod.prototype.getStorableFields = function() {
			var storableFields = {};
			this.customInputFields.forEach(function(fld) {
				if (!fld.isSecureInfo) {
					storableFields[fld.fieldName] = fld.fieldValue;
				}
			});

			return storableFields;
		};

		/**
		 * Instead of showing an image, use css classes to display the payment method.
		 * @public
		 * @memberof {PaymentMethod}
		 * @param {String} cssClassNames class names
		 * @return {undefined}
		 */
		PaymentMethod.prototype.useCssNotImage = function(cssClassNames) {
			this.useCssImage = true;
			this.classNames = cssClassNames;
		};

		PaymentMethod.prototype.getSecureFieldsJSON = function() {
			var secureFieldJSON = {};
			this.customInputFields.forEach(function(fld) {
				if (fld.isSecureInfo) {
					secureFieldJSON[fld.fieldName] = fld.fieldValue;
				}
			});

			return secureFieldJSON;
		}

		/**
		 * This function will show a custom info message on any billing view
		 * @returns {undefined}
		 */
		PaymentMethod.prototype.showInfoModal = function() {
			var suffix = this.methodName;
			Modal.displayModal({
				action: 'Info Modal',
				category: 'Info Modal',
				description: Language.getLocale('PaymentView', suffix + '_infoModalMsg'),
				label: 'Info Modal',
				title: Language.getLocale('PaymentView', suffix + '_infoModalTitle')
			});
		}

		/**
		 * Base model for express wallet payments
		 * @function
		 * @constructor
		 * @param {String} providerName provider name
		 * @param {String} authType auth type
		 * @param {String} billingType billing type
		 * @param {Function} [paymentAction=null] payment action
		 * @returns {undefined}
		 */
		function ExpressWalletPayment(providerName, authType, billingType, paymentAction) {
			this.providerName = returnOrDefault(providerName, '', validString);
			this.authType = returnOrDefault(authType, '', validString);
			this.billingType = returnOrDefault(billingType, '', validString);
			this.paymentAction = angular.isFunction(paymentAction) ? paymentAction : null;
			this.useCssClasses = false;
			this.hasCustomBtnHTML = false;
			this.customBtnHTML = null;
			this.classNames = '';
		}

		/**
		 * Instead of showing an image, use css classes to display the express payment method.
		 * @public
		 * @memberof {ExpressWalletPayment}
		 * @param {String} cssClassNames css class names
		 * @returns {undefined}
		 */
		ExpressWalletPayment.prototype.addCssClasses = function(cssClassNames) {
			this.useCssClasses = true;
			this.classNames = cssClassNames;
		};

		/**
		 * Instead of showing a button, use the html passed to display the express payment method button.
		 * @public
		 * @memberof {ExpressWalletPayment}
		 * @param {HTMLButtonElement} btn button html
		 * @returns {undefined}
		 */
		ExpressWalletPayment.prototype.addCustomHTML = function(btn) {
			this.customBtnHTML = btn;
			this.hasCustomBtnHTML = true;
		}

		this.PaymentMethod = PaymentMethod;
		this.ExpressWalletPayment = ExpressWalletPayment;

		/**
		 * Custom input field
		 * @param {String} name name
		 * @param {Boolean} required required
		 * @param {String} validationType validation type
		 * @param {String} validationRegex: if custom is passes as the validationType, this can be provided to indicate what the regex should be
		 * @constructor
		 */
		function CustomInputField(name, required, validationType, validationRegex) {
			this.fieldName = name;
			this.validationType = validationType;
			this.validationRegex = validationRegex;
			this.required = required;
			this.fieldValue = '';
			this.useAsLastFourForOrderReview = false;
			this.isSecureInfo = false;
			this.desktopWidthClass = 'col-sm-12';
			this.icon = undefined;
		}


		this.CustomInputField = CustomInputField;
	}
})();

/**
 * Created by kytran on 8/8/17.
 */
(function(){
	'use strict';

	angular
		.module('billing')
		.factory('BillingRedirectService', BillingRedirectService);

	/* @ngInject */
	function BillingRedirectService($location,
									$state,
									   $rootScope,
									   AppData,
									   LegacyCart,
									   Enums,
									Language,
									CustomActionService,
									   Modal,
									Purchase,
									   Utilities,
									   UtilsValidation,
									   UserInfo){

		var initiatedRedirect = false;

		var currentRedirectUrl = '';

		var service = {
			prePurchaseAuth: prePurchaseAuth,
			callExternalPaymentStatusChange: callExternalPaymentStatusChange,
			completeInitiateRedirect: completeInitiateRedirect,
			finalizeRedirectTransaction: finalizeRedirectTransaction,
			getAccessoRedirectURL: getAccessoRedirectURL,
			getRedirectUrl: getRedirectUrl,
			isRedirectInitiated: isRedirectInitiated,
			removeBillingQueryURLParameters: removeBillingQueryURLParameters,
			removeCartParams: removeCartParams,
			startInitiateRedirect: startInitiateRedirect
		};

		/**
		 * Get the redirect url
		 * @returns {String}
		 */
		function getRedirectUrl(){
			return currentRedirectUrl;
		}

		/**
		 * Set the initiatedRedirect tracking variable to trues
		 * @param redirect URL
		 */
		function startInitiateRedirect(redirectUrl, redirectPaymentState, paymentType){
			if(angular.isDefined(redirectUrl) && !LegacyCart.checkForDeferredPayment()){
				currentRedirectUrl = redirectUrl;
				initiatedRedirect = true;

				$rootScope.routeTo($state.href(redirectPaymentState));
			} else if(LegacyCart.checkForDeferredPayment()){
				initiatedRedirect = false;
				showRedirectFailureModal(paymentType + 'DeferredRedirectFailStatusTitle', paymentType + 'DeferredRedirectFailStatusMsg', paymentType);
			} else {
				initiatedRedirect = false;
				showRedirectFailureModal(paymentType + 'GenericRedirectFailStatusTitle', paymentType + 'GenericRedirectFailStatusMsg', paymentType);
			}
		}

		/** After we receive word that the authorization failed, we attempt to delete the saved purchase entry
		 * Based on whether or not the deletion succeeds or fails, we route to certain areas
		 * @param titleLocaleTarget The target for the Title locale
		 * @param descriptionLocaleTarget The target for the Description locale
		 * @param paymentType What type of payment was this?
		 */
		function showRedirectFailureModal(titleLocaleTarget, descriptionLocaleTarget, paymentType){
			Modal.displayModal(
				{
					category: 'Cart [Purchase]',
					action: 'Error',
					label: 'Purchase Auth Error',
					title: Language.getLocale(paymentType, titleLocaleTarget),
					icon: 'icon-info red',
					description: Language.getLocale(paymentType, descriptionLocaleTarget),
					buttonFlags: [Enums.buttonFlags.OK],
					showCloseButton: false,
					callback: function(){
						$rootScope.routeTo(Enums.routes.PAYMENT_METHOD);
					}
				}
			);
		}

		/**
		 * Set the initiatedRedirect tracking variable to false as we are complete
		 */
		function completeInitiateRedirect(){
			initiatedRedirect = false;
			return true;
		}

		/**
		 * Return the result of whether or not we have initiated a redirect
		 */
		function isRedirectInitiated(){
			return initiatedRedirect;
		}

		/**
		 * Remove query params
		 * @public
		 * @returns {undefined}
		 */
		function removeCartParams() {
			var validString = UtilsValidation.validString,
				queryParams = ['cart_id', 'cart_key', 'session_id'];

			queryParams.forEach(function(param) {
				if (validString($location.search()[param])) {
					$location.search(param, null);
				}
			});
		}

		/**
		 *
		 * @param aperFlow - boolean - if not aperflow, then we just call purchase call
		 * if not, then we have to savePurchaseAuthStatus first, then do the logic base on the response
		 * @param pendingOrderState - this is used in aperflow only, we use it to route user to pending view
         */
		function finalizeRedirectTransaction(aperFlow, pendingOrderState){
			if (!aperFlow){
				Purchase.executePurchase(Purchase.defaultPostPurchaseSuccess);
			} else {
				Purchase.savePurchaseAuthStatus().then(function(response){

					if (response.status == Enums.status.OK && angular.isDefined(response.saved_purchase_status)) {
						var authStatus = response.saved_purchase_status;
						if (authStatus === Enums.savedPurchaseAuthStatuses.CONFIRMED_STATUS) {
							var donation = UserInfo.get('donation');
							var insurance = UserInfo.get('insurance');
							var requestMessage = {cart_id: AppData.cart.cart_id};
							if (donation) {
								requestMessage.DONATION = donation;
							}
							if (insurance) {
								requestMessage.INSURANCE = insurance;
							}

							//if we have a confirmed status, lets execute the purchase
							Purchase.executePurchase(Purchase.defaultPostPurchaseSuccess, 'PurchaseSavedPurchase', requestMessage, handlePurchaseSavePurchaseFailure);

						} else if (authStatus === Enums.savedPurchaseAuthStatuses.PURCHASED_STATUS) {
							//if the cart has already been purchased, lets route to the appropriate post purchase screen
							Purchase.getOrderAndRouteForPurchasedCart();
							LegacyCart.getNewCartID();

						} else if (authStatus === Enums.savedPurchaseAuthStatuses.PENDING_STATUS || authStatus === Enums.savedPurchaseAuthStatuses.NEW_STATUS || authStatus === Enums.savedPurchaseAuthStatuses.INCOMPLETE_STATUS) {
							//If we are in a pending state-- go to the pending screen
							handlePendingOrderCase(pendingOrderState);
						} else {
							handlePurchaseSavePurchaseFailure(true);
						}

					}else{
						//we were not able to get the status of what occurred
						// upon redirection so lets route to the pending page
						$rootScope.routeTo($state.href(pendingOrderState));
					}

				});
			}
		}

		/**
		 * Handle the pending order
		 */
		function handlePendingOrderCase(pendingOrderState){
			AppData.fetch(Enums.services.GET_NEW_CART_ID, true, {}, true, true)
				.then(function(){
					Purchase.cleanupPreviousCart();
					$rootScope.routeTo($state.href(pendingOrderState));
				});
		}

		/**
		 * Handle PurchaseSavePurchase failure either by showing a failure modal or directly routing to the payment method screen
		 * Call deleteSavePurchase
		 * @param handlePurchaseSavePurchaseFailure
		 */
		function handlePurchaseSavePurchaseFailure(showFailureModal){

			removeBillingQueryURLParameters(Object.values(Enums.urlParametersAccessoPay));

			//the authorization failed, lets delete the save purchase and allow the user to go back and choose a different payment method
			Purchase.deleteSavedPurchase().then(function(deleteSavedPurchaseResponse){
				if(showFailureModal){
					showAuthFailureModal(deleteSavedPurchaseResponse);
				}else{
					$rootScope.routeTo(Enums.routes.CART);
				}
			});
		}

		/**
		 * After we receive word that the authorization failed, we attempt to delete the saved purchase entry
		 * Based on whether or not the deletion succeeds or fails, we route to certain areas
		 * @param deleteSavedPurchaseResponse
		 */
		function showAuthFailureModal(deleteSavedPurchaseResponse) {
			$rootScope.hideSpinner();
			Modal.displayModal(
				{
					category: 'Cart [Purchase]',
					action: 'Error',
					label: 'Purchase Auth Error',
					title: Language.getLocale('Purchase','redirectSavePurchAuthFailStatus40Title'),
					icon: 'icon-info red',
					description: Language.getLocale('Purchase','redirectSavePurchAuthFailStatus40Msg'),
					buttonFlags: [Enums.buttonFlags.OK],
					showCloseButton: false,
					callback: function() {
					if (deleteSavedPurchaseResponse.status == Enums.status.OK){
						//if we successfully deleted the savePurchase in the DB then lets keep this cart and route to the payment method
						$rootScope.routeTo(Enums.routes.CART);
					} else{
						//if we were unsuccessful in deleting the savePurchase for whatever reason,
						//we have to reset the cart so we don't end up with an unrecoverable state later on
						//this technically shouldn't happen but just in case it does
						$rootScope.routeTo('reset/true');
					}
				}
				}
			);
		}

		function removeBillingQueryURLParameters(urlQueries){
			if (angular.isDefined(urlQueries)) {
				urlQueries.forEach(function(urlQuery){
					if(angular.isDefined($location.search()[urlQuery])){
						$location.search(urlQuery, null);
					}
				});
			}
		}

		function prePurchaseAuth(successCallback, extendedProps, ignoreFailModal) {
			$rootScope.showSpinner(Language.getLocale('ApplicationLabels', 'purchaseLoadMsg'));

			var req = buildPrePurchaseAuthRequest(extendedProps);

			if (angular.isDefined(req)){
				return AppData.fetch('PrePurchaseAuth', false, req).then(handleCallSucess);
			} else {
				throw new Error(prePurchaseAuthErrorLocale(extendedProps));
			}

			function handleCallSucess(response){
				var payment = UserInfo.get('payment'),
					title = '',
					description = '';
				if (response.status === Enums.status.OK) {
					payment.auth_id = response.auth_id;
					successCallback(response);
				} else if (ignoreFailModal) {
					successCallback(response);
				} else {
					title = Language.getLocale('Alert', 'GenericPrePurchaseAuthFailureTitle');
					description = Language.getLocale('Alert', 'GenericPrePurchaseAuthFailureDescription');
					if (response.error_code && CustomActionService.actionRegistered(CustomActionService.ACTIONS_ENUMS.PRE_PURCHASE_AUTH_ERROR_CODE_CUSTOM_DESCRIPTION)) {
						description = CustomActionService.executeCustomAction(CustomActionService.ACTIONS_ENUMS.PRE_PURCHASE_AUTH_ERROR_CODE_CUSTOM_DESCRIPTION, response);
						title = Language.replaceAll('@@errorCode', response.error_code, Language.getLocale('ErrorCodes', 'errorCodeTitle'));
					}
					$rootScope.hideSpinner();
					Modal.displayModal({
						category: 'PrePurchase Auth Error',
						action: 'Error',
						label: 'PrePurchase Auth Error',
						title: title,
						description: description,
						buttonFlags: [Enums.buttonFlags.OK],
						showCloseButton: false,
						callback: function() {
							if (CustomActionService.actionRegistered(CustomActionService.ACTIONS_ENUMS.PRE_PURCHASE_AUTH_ERROR_CODE_CUSTOM_DESCRIPTION)) {
								CustomActionService.deregisterCustomAction(CustomActionService.ACTIONS_ENUMS.PRE_PURCHASE_AUTH_ERROR_CODE_CUSTOM_DESCRIPTION);
							}
							$rootScope.routeTo($state.href('/paymentMethod', {}));
						}
					});
				}
			}
		}

		function prePurchaseAuthErrorLocale(extendedProps){
			if (Utilities.safelyCheckPropertyOnObject('extendedProps.billing_type', extendedProps)){
				var billingType;
				switch(extendedProps.billing_type){
					case Enums.billingTypes.LINEPAY:
						billingType = 'Linepay: ';
						break;
					default:
						billingType = 'BillingRedirectService: ';
				}
			}

			return billingType + 'Unable to create request object';
		}

		function buildPrePurchaseAuthRequest(extendedProps){
			if (angular.isUndefined(LegacyCart.total)){

				//if the cart total is undefined here, then the user refreshed so route back to order review
				$rootScope.routeTo($state.href('/orderReview', {}));
				$rootScope.hideSpinner();
				return undefined;

			} else {
				var request = {
					amount: LegacyCart.total,
					cart_id: AppData.cart.cart_id
				};

				if (angular.isDefined(extendedProps)){
					angular.extend(request, extendedProps);
				}
				return request;
			}
		}

		function callExternalPaymentStatusChange(extendedReq, successHandler){

			var req = {};

			angular.extend(req, extendedReq);

			$rootScope.showSpinner();

			AppData.fetch('ExternalPaymentStatusChange', false, req).then(function(response){

				$rootScope.hideSpinner();
				if (response.status == Enums.status.OK){
					if (angular.isDefined(successHandler)){
						successHandler();
					}
				} else {
					Modal.displayModal({
						category: 'PrePurchase Auth Error',
						action: 'Error',
						label: 'PrePurchase Auth Error',
						title: Language.getLocale('Alert', 'ExternalPaymentStatusChangeFailureTitle'),
						description: Language.getLocale('Alert', 'ExternalPaymentStatusChangeFailureDescription'),
						buttonFlags: [Enums.buttonFlags.OK],
						showCloseButton: false,
						callback: function(){
							$rootScope.routeTo('/reset');
						}
					});
				}
			});
		}

		function getAccessoRedirectURL(phpPage, mobileController, addingParamsFunction){
			//obtain the correct url and replace hashes for IE9
			var path = (Utilities.isInIFrame() ? phpPage: $state.href(mobileController));

			var url = $location.absUrl().replace($location.path(), path);

			if (addingParamsFunction){
				url = addingParamsFunction(url);
			}

			return Utilities.removeHashFromUrlForIE9(url);
		}

		return service;
	}
})();

(function() {
	'use strict';

	angular
		.module('billing')
		.factory('CreditCardBinRangesService', CreditCardBinRangesService);

	/**
	 * The payment type prep service
	 * @public
	 * @constructor
	 * @param {Service} $q For promises
	 * @param {Scope} $rootScope The root scope object
	 * @param {Service} AppData The service for fetching data
	 * @param {Service} PaymentTypeService The service
	 * @param {Service} RequestService service
	 * @param {Service} StringUtils The service
	 * @param {Service} Utilities service
	 * @param {Service} UtilsValidation For validating data
	 * @return {PaymentTypeService} The service
	 * @ngInject
	 */
	function CreditCardBinRangesService($q, $rootScope, AppData, PaymentTypeService, RequestService, StringUtils, Utilities, UtilsValidation) {
		var normalize = StringUtils.normalize;
		var copy = angular.copy;
		var binRangeRequested = false;
		var binRangeResponse = { RANGE: [] };
		var service = {
			appendCardImageByBinRanges: appendCardImageByBinRanges,
			fetchBinRanges: fetchBinRanges,
			getBinImage: getBinImage,
			getBinRangeTypes: getBinRangeTypes,
			getBinRanges: getBinRanges,
			getBinRangesByCardType: getBinRangesByCardType
		};

		return service;

		/**
		 * Returns the bin image if we have one.
		 * @public
		 * @param {String} merchantPaymentTypeRefId The merchant_payment_type_ref_id if available
		 * @return {String|null} The bin image.
		 */
		function getBinImage(merchantPaymentTypeRefId) {
			var billingType = PaymentTypeService.getById(AppData, merchantPaymentTypeRefId),
				creditCardDisplay = {};

			if (billingType) {
				service.appendCardImageByBinRanges(billingType, creditCardDisplay);
				return creditCardDisplay.binImage;
			}

			return null;
		}

		/**
		 * Alters a credit card display's object to include the bin range image if it's a payment type and we find the bin object.
		 * @public
		 * @function
		 * @name appendCardImageByBinRanges
		 * @param {Object} billingType The billing type object
		 * @param {OBject} creditCardDisplay The object that will display the credit card and the object that will be altered in this function
		 * @return {undefined}
		 */
		function appendCardImageByBinRanges(billingType, creditCardDisplay) {
			var binRanges = service.getBinRanges(),
				bin;

			if (!PaymentTypeService.isPaymentType(billingType) || !UtilsValidation.isRealObject(creditCardDisplay) || !UtilsValidation.validArray(binRanges)) {
				return;
			}

			bin = binRanges.find(function(bin) {
				return normalize(bin.card_type_code) === normalize(billingType.card_type_code);
			});

			if (bin && UtilsValidation.validString(bin.image_filename)) {
				creditCardDisplay.binImage = $rootScope.getAssetUrl(bin.image_filename);
			}
		}


		/**
		 * Fetches credit card bin ranges to use with a merchant for use in Bootstrap.doBootstrap
		 * @public
		 * @name fetchBinRanges
		 * @return {Promise} a promise
		 */
		function fetchBinRanges() {
			if (binRangeRequested) {
				return $q.resolve(service.getBinRanges());
			}

			// this must always resolve
			return $q(function(resolve) {
				RequestService
					.sendRequest('GetCreditCardBinInfo', {})
					.then(resolveGetCreditCardBinInfo)
					.catch(resolveGetCreditCardBinInfo)
					.finally(function() {
						binRangeRequested = true;
						resolve(service.getBinRanges());
					});
			});
		}

		/**
		 * Used to resolve the data from the request to GetCreditCardBinInfo and sets the data on the service
		 * @protected
		 * @function
		 * @param {Object} response The response object
		 * @return {undefined}
		 */
		function resolveGetCreditCardBinInfo(response) {
			var isObject = angular.isObject;

			if (!isObject(response)) {
				response = { RANGE: [] };
			} else if (!isObject(response.RANGE) && !Array.isArray(response.RANGE)) {
				response.RANGE = [];
			}

			response.RANGE = Utilities.wrapObjectToArray(response.RANGE);
			binRangeResponse = copy(response);
		}

		/**
		 * Get a list of credit card names that must use the bin ranges provided by backend. 
		 * @public
		 * @function
		 * @name getBinRangeTypes
		 * @return {String[]} The credit card types that must match internal bin ranges from backend
		 */
		function getBinRangeTypes() {
			return service
				.getBinRanges()
				.map(function(bin) {
					return normalize(bin.card_type_description);
				})
				.reduce(function(acc, type) {
					if (acc.indexOf(type) < 0) {
						acc.push(type);
					}
					return acc;
				}, []);
		}

		/**
		 * Returns a copy of the bin ranges.
		 * @public
		 * @function
		 * @name getBinRanges
		 * @return {Object[]} Bin ranges array
		 */
		function getBinRanges() {
			return copy(binRangeResponse.RANGE);
		}

		/**
		 * Returns the bin ranges matching a specific card type 
		 * @public
		 * @function
		 * @name getBinRangesByCardType
		 * @param {String|String[]} cardNames The card names to filter by
		 * @return {Object[]} Bin ranges array
		 */
		function getBinRangesByCardType(cardNames) {
			var names = Utilities
				.wrapObjectToArray(cardNames)
				.filter(angular.isString)
				.map(normalize);

			if (!names.length) {
				return [];
			}

			return service
				.getBinRanges()
				.reduce(function(acc, bin) {
					if (names.indexOf(normalize(bin.card_type_description)) > -1) {
						acc.push(bin);
					}
					return acc;
				}, []);
		}
	}
})();

(function() {
	'use strict';

	angular
		.module('billing')
		.factory('PaymentTypeService', PaymentTypeService);

	/**
	 * Our payment service has many functions which can convert payment type nodes to billing nodes for use in shopland, merge payment types and billing types and more.
	 * @public
	 * @constructor
	 * @param {Service} Enums The enums
	 * @param {Service} StringUtils The string utilities
	 * @param {Service} Utilities The utilities service
	 * @param {Service} UtilsValidation For validating data
	 * @return {PaymentTypeService} Our service
	 * @ngInject
	 */
	function PaymentTypeService(Enums, StringUtils, Utilities, UtilsValidation) {
		var validString = UtilsValidation.validString;
		var validArray = UtilsValidation.validArray;
		var isRealObject = UtilsValidation.isRealObject;
		var service = {
			convertPaymentTypeToBillingType: convertPaymentTypeToBillingType,
			getById: getById,
			hasPaymentTypes: hasPaymentTypes,
			isCreditCardPaymentType: isCreditCardPaymentType,
			isPaymentType: isPaymentType,
			mergeBillingTypesAndPaymentTypes: mergeBillingTypesAndPaymentTypes,
			paymentTypeMatchesBillingType: paymentTypeMatchesBillingType
		};

		return service;

		/**
		 * Get a payment type by id.
		 * @public
		 * @param {Service} AppData for the billing types
		 * @param {String} merchantPaymentTypeRefId The merchant_payment_type_ref_id if available
		 * @return {Object|undefined} The billing type object if it finds one.
		 */
		function getById(AppData, merchantPaymentTypeRefId) {
			return AppData.billingTypes.find(function(type) {
				return type.merchant_payment_type_ref_id === merchantPaymentTypeRefId;
			});
		}

		/**
		 * This function is for merging BILLINGTYPE and PAYMENTTYPE nodes that come back in the response
		 * from GetMerchantDetails. PAYMENTTYPE should override BILLINGTYPE if both are present, otherwise it
		 * should just be appended.
		 * @public
		 * @function
		 * @name mergeBillingTypesAndPaymentTypes
		 * @param {Service} AppData The app data service
		 * @param {Object[]} paymentTypes The node PAYMENTTYPE from GetMerchantDetails response
		 * @return {undefined}
		 */
		function mergeBillingTypesAndPaymentTypes(AppData, paymentTypes) {
			var listToAppend;

			if (!validArray(paymentTypes)) {
				return;
			}

			listToAppend = paymentTypes.reduce(function(list, currentPaymentType) {
				var isUniqueAuthType,
					paymentType,
					overwroteBillingType = false,
					count,
					i = 0;

				if (!isRealObject(currentPaymentType)) {
					return list;
				}

				paymentType = service.convertPaymentTypeToBillingType(currentPaymentType);

				isUniqueAuthType = !AppData.billingTypes.some(function(billingType) {
					return billingType.auth_type === paymentType.auth_type;
				});

				// If it's unique, we obviously don't have this in the billingTypes so go ahead and add it
				if (isUniqueAuthType) {
					AppData.billingTypes.push(paymentType);
					AppData.paymentMethodCount++;
					return list;
				}

				for (count = AppData.billingTypes.length; i < count; i++) {
					// If they match, override the billingType with the payment type node
					if (service.paymentTypeMatchesBillingType(AppData.billingTypes[i], paymentType)) {
						AppData.billingTypes[i] = paymentType;
						overwroteBillingType = true;
						break;
					}
				}

				/**
				 * If we did not overwrite a billing type, we need to add it to the list after we're done.
				 * We dont want to append them as it will change the size of the original array. We'll do that
				 * after we're done going through.
				 */
				if (!overwroteBillingType) {
					list.push(paymentType);
				}

				return list;
			}, []);

			// Finally, add the ones that were not overridden
			AppData.billingTypes = AppData.billingTypes.concat(listToAppend);
		}

		/**
		 * Find out if a billing type and a payment type are the same
		 * @public
		 * @function
		 * @name paymentTypeMatchesBillingType
		 * @param {Object} billingType The billing type object
		 * @param {Object} paymentType The payment type object
		 * @return {Boolean} if they are the same type of payment method
		 */
		function paymentTypeMatchesBillingType(billingType, paymentType) {
			if (!isRealObject(billingType) || !isRealObject(paymentType)) {
				throw new TypeError('invalid billing type or payment type');
			}

			if (billingType.auth_type !== paymentType.auth_type) {
				return false;
			} else if (billingType.billing_type !== paymentType.billing_type) {
				return false;
			} else if (validString(billingType.billing_provider_desc) && billingType.billing_provider_desc !== paymentType.billing_provider_desc) {
				return false;
			}

			if (validString(billingType.card_type_code) && validString(paymentType.card_type_code) && billingType.card_type_code === paymentType.card_type_code) {
				if (billingType.billing_provider_desc !== 'CyberSource' && paymentType.billing_provider_desc !== 'Cybersource') {
					return true;
				} else if (billingType.raw_card_type_list === paymentType.raw_card_type_list) {
					return true;
				}
			}

			return (Utilities.isEmpty(billingType.card_type_code) || billingType.card_type_code === 'NA') && (Utilities.isEmpty(paymentType.card_type_code) || paymentType.card_type_code === 'NA');
		}

		/**
		 * Converts a payment type node to a billing so it can be used within the system as a normal billing type.
		 * @public
		 * @function
		 * @name convertPaymentTypeToBillingType
		 * @param {Object} paymentType The payment type node to convert
		 * @return {Object} A new billing type object
		 */
		function convertPaymentTypeToBillingType(paymentType) {
			var billingType;

			if (!isRealObject(paymentType)) {
				throw new TypeError('invalid payment type');
			}

			billingType = angular.copy(paymentType);
			billingType.name = billingType[(billingType.auth_type === Enums.billingTypes.CREDITCARD ? 'cct' : 'pt') + '_description'];
			billingType.isPaymentType = true;

			return billingType;
		}

		/**
		 * Find out if we have any PAYMENTTYPE nodes in the billingTypes
		 * @public
		 * @function
		 * @name hasPaymentTypes
		 * @param {Object[]} billingTypes The billing types from AppData.billingTypes
		 * @return {Boolean} if we have any payment types in the billing types
		 */
		function hasPaymentTypes(billingTypes) {
			return billingTypes.some(service.isPaymentType);
		}

		/**
		 * Find out if the object is a payment type
		 * @public
		 * @function
		 * @name isPaymentType
		 * @param {Object} type The object to check
		 * @return {Boolean} if it is a payment type
		 */
		function isPaymentType(type) {
			return UtilsValidation.isRealObject(type) && type.hasOwnProperty('merchant_payment_type_ref_id');
		}

		/**
		 * Find out if the object is a payment type
		 * @public
		 * @function
		 * @name isPaymentType
		 * @param {Object[]} billingTypes The AppData.billingTypes array
		 * @param {String} cardType The card type to check for
		 * @return {Boolean} if it is a payment type
		 */
		function isCreditCardPaymentType(billingTypes, cardType) {
			var normalize = StringUtils.normalize;

			if (!validArray(billingTypes) || !validString(cardType)) {
				return false;
			}

			cardType = normalize(cardType);

			return billingTypes
				.filter(function(type) {
					return service.isPaymentType(type) && type.auth_type === Enums.billingTypes.CREDITCARD;
				})
				.some(function(type) {
					return normalize(type.cct_description) === cardType;
				});
		}
	}
})();


(function() {
	'use strict';

	angular
		.module('billing')
		.factory('CreditCardService', CreditCardService);

	/**
	 * The payment type prep service
	 * @public
	 * @constructor
	 * @param {Window} $window $window
	 * @param {Service} AppData AppData
	 * @param {Service} LegacyCart LegacyCart
	 * @param {Service} Enums Enums
	 * @param {Service} Language Language
	 * @param {Service} Modal Modal
	 * @param {Service} StringUtils StringUtils
	 * @param {Service} UtilsValidation UtilsValidation
	 * @ngInject
	 */
	function CreditCardService($window, AppData, LegacyCart, Enums, Language, Modal, StringUtils, UtilsValidation) {
		var isRealObject = UtilsValidation.isRealObject,
			validString = UtilsValidation.validString,
			validArray = UtilsValidation.validArray,
			billingProviders = Enums.billingProviders,
			normalize = StringUtils.normalize,
			getLocale = Language.getLocale;

		var NORMALIZED_BILLING_PROVIDER_CREDIT_CARD = normalize(billingProviders.CYBERSOURCE_CREDITCARD),
			NORMALIZED_CYBS_BILLING_PROVIDER_GOOGLEPAY = normalize(billingProviders.CYBERSOURCE_GOOGLEPAY),
			NORMALIZED_ADYEN_BILLING_PROVIDER_GOOGLEPAY = normalize(billingProviders.ADYEN_GOOGLEPAY),
			NORMALIZED_BILLING_PROVIDER_MASTER_PASS = normalize(billingProviders.CYBERSOURCE_MASTERPASS),
			NORMALIZED_CYBS_BILLING_PROVIDER_APPLE_PAY = normalize(billingProviders.CYBERSOURCE_APPLEPAY),
			NORMALIZED_ADYEN_BILLING_PROVIDER_APPLE_PAY = normalize(billingProviders.ADYEN_APPLEPAY),
			NORMALIZED_BILLING_PROVIDER_ADYEN = normalize(billingProviders.ADYEN);

		var service = {
			checkCreditCardsByBillingProvider: checkCreditCardsByBillingProvider,
			displayCvvModal: displayCvvModal,
			getAllowedCreditCardError: getAllowedCreditCardError,
			getCardByName: getCardByName,
			getCardTypeRequired: getCardTypeRequired,
			getWindow: getWindow,
			isAdyenCreditCard: isAdyenCreditCard,
			isApplePay: isApplePay,
			isCybersourceCreditCard: isCybersourceCreditCard,
			isGooglePay: isGooglePay,
			isValidCreditCard: isValidCreditCard
		};

		service.hasCybersourceCreditCards = service.checkCreditCardsByBillingProvider(service.isCybersourceCreditCard);
		service.hasAdyenCreditCards = service.checkCreditCardsByBillingProvider(service.isAdyenCreditCard);
		service.hasGooglePay = service.checkCreditCardsByBillingProvider(service.isGooglePay);
		service.hasApplePay = service.checkCreditCardsByBillingProvider(service.isApplePay);

		return service;

		/**
		 * Used with an array to filter credit card auth types.
		 * @public
		 * @function
		 * @param {Object} type The billing or payment type
		 * @returns {Boolean} If its a credit card or not.
		 */
		function isValidCreditCard(type) {
			return isRealObject(type) && type.auth_type === Enums.authTypes.CREDITCARD && validString(type.billing_provider_desc) && type.visible === 'true';
		}

		/**
		 * Find a payment type for a credit card by its' name
		 * @public
		 * @function
		 * @param {string} name The name of the card
		 * @returns {object|undefined} The card if it can find it
		 */
		function getCardByName(name) {
			name = normalize(name);

			if (!validString(name)) {
				return;
			}

			return AppData.billingTypes
				.filter(service.isValidCreditCard)
				.find(function(card) {
					return name === normalize(card.name);
				});
		}

		/**
		 * Checks if we have credit cards of provided billling provider
		 * @public
		 * @function
		 * @param {Function} filterFunction filter function
		 * @returns {Function} returns filter function
		 */
		function checkCreditCardsByBillingProvider(filterFunction) {
			var creditCards;
			return function() {
				creditCards = AppData.billingTypes.filter(service.isValidCreditCard);
				return creditCards.some(filterFunction);
			};
		}

		/**
		 * Return if the credit card is Adyen credit card, to be used with checkCreditCardsByBillingProvider
		 * @param {Object} creditCard credit card object
		 * @returns {Boolean} true/false
		 */
		function isAdyenCreditCard(creditCard) {
			return normalize(creditCard.billing_provider_desc) === NORMALIZED_BILLING_PROVIDER_ADYEN;
		}

		/**
		 * Return if the credit card is CYBS credit card, to be used with checkCreditCardsByBillingProvider
		 * @param {Object} creditCard credit card object
		 * @returns {Boolean} true/false
		 */
		function isCybersourceCreditCard(creditCard) {
			return normalize(creditCard.billing_provider_desc) === NORMALIZED_BILLING_PROVIDER_CREDIT_CARD || normalize(creditCard.billing_provider_desc) === NORMALIZED_BILLING_PROVIDER_MASTER_PASS || normalize(creditCard.billing_provider_desc) === NORMALIZED_CYBS_BILLING_PROVIDER_APPLE_PAY;
		}

		/**
		 * Return if the credit card is google pay credit card, to be used with checkCreditCardsByBillingProvider
		 * @param {Object} creditCard credit card object
		 * @returns {Boolean} true/false
		 */
		function isGooglePay(creditCard) {
			return normalize(creditCard.billing_provider_desc) === NORMALIZED_CYBS_BILLING_PROVIDER_GOOGLEPAY || normalize(creditCard.billing_provider_desc) === NORMALIZED_ADYEN_BILLING_PROVIDER_GOOGLEPAY;
		}

		/**
		 * Return if the credit card is apple pay credit card, to be used with checkCreditCardsByBillingProvider
		 * @param {Object} creditCard credit card object
		 * @returns {Boolean} true/false
		 */
		function isApplePay(creditCard) {
			return normalize(creditCard.billing_provider_desc) === NORMALIZED_CYBS_BILLING_PROVIDER_APPLE_PAY || normalize(creditCard.billing_provider_desc) === NORMALIZED_ADYEN_BILLING_PROVIDER_APPLE_PAY;
		}

		/**
		 * If a package was set to only be allowed to use one card, try to find it in the cart items.
		 * @public
		 * @function
		 * @param {Object[]} cartItems The cart items
		 * @return {String} the card override if we have one
		 */
		function getCardTypeRequired(cartItems) {
			var KEY = 'card_type_required',
				foundCharac = '';

			if (!validArray(cartItems)) {
				return foundCharac;
			}

			foundCharac = cartItems.reduce(function(found, item) {
				var charac;

				if (!isRealObject(item)) {
					return found;
				}

				if (validArray(item.CHARACS)) {
					charac = item.CHARACS.find(function(characs) {
						return characs.hasOwnProperty(KEY);
					});

					if (charac) {
						found = charac[KEY];
					}
				} else if (isRealObject(item.CHARACS) && item.CHARACS.hasOwnProperty(KEY)) {
					found = item.CHARACS[KEY];
				}

				return found;
			}, '');

			// Get the card override if it exist in the CHARACS of any of the items in the cart.
			if (validString(foundCharac)) {
				return foundCharac;
			}

			return '';
		}

		/**
		 * Returns the Window object.
		 * @public
		 * @function
		 * @returns {Window} the Window object
		 */
		function getWindow() {
			return $window;
		}

		/**
		 * Displays the CVV description modal so a user knows where to find it on their card.
		 * @public
		 * @param {Object[]} billingProviderCreditCards credit cards of a specific billing provider
		 * @returns {Function} function that display cvv modal
		 */
		function displayCvvModal(billingProviderCreditCards) {
			return function() {
				var cards = LegacyCart.getCardTypesToDisplay();

				service.getWindow().scrollTo(0, 0);

				Modal.displayModal({
					action: 'View',
					buttonFlags: [Enums.buttonFlags.OK],
					category: 'Billing',
					customHTML: 'views/modals/NewCVC.html',
					description: {
						cards: cards,
						hasAmex: billingProviderCreditCards
							.some(function(type) {
								var name = normalize(type.name);
								if (type.card_type_code === 'AX') {
									return true;
								} else if (['americanexpress', 'amex'].indexOf(name) != -1) {
									return true;
								}

								return false;
							})
					},
					label: 'Security Code Help',
					title: Language.getLocale('Alert', 'whatIsCVVTitle')
				});
			}
		}

		/**
		 * Returns the string to use for the allowed credit cards
		 * @public
		 * @function
		 * @param {String} FORM_LABELS_SECTION Form label section
		 * @param {String} FORM_VALIDATION_SECTION Form Validation Section
		 * @param {String[]} allowedCreditCardNames The allowed card types
		 * @returns {String} the text to use when showing the allowed credit cards error
		 */
		function getAllowedCreditCardError(FORM_LABELS_SECTION, FORM_VALIDATION_SECTION, allowedCreditCardNames) {
			var or = getLocale(FORM_LABELS_SECTION, 'or');
			var orLocale = ' ' + (validString(or) ? or.toLowerCase() : 'or') + ' ';
			var cardTypeReplacement = allowedCreditCardNames.reduce(function(text, name, index, arr) {
				// if its the last one, add an "or"
				if (index === arr.length - 1 && arr.length > 1) {
					text += orLocale;
				// if not the first and we have more than 2, add a comma
				} else if (index > 0 && arr.length > 2) {
					text += ', ';
				}

				return text + name;
			}, '');

			return Language.replaceAll('@@cardTypes', cardTypeReplacement, getLocale(FORM_VALIDATION_SECTION, 'ccOverideTypes'));
		}
	}
})();

(function() {
	'use strict';

	angular
		.module('billing')
		.factory('PaymentMethodService', PaymentMethodService);

	/**
	 * The payment type prep service
	 * @public
	 * @constructor
	 * @param {Service} AppData AppData
	 * @param {Service} Enums Enums
	 * @param {Service} StringUtils StringUtils
	 * @param {Service} Utilities Utilities
	 * @param {Service} UtilsValidation UtilsValidation
	 * @ngInject
	 */
	function PaymentMethodService(AppData, Enums, StringUtils, Utilities, UtilsValidation) {
		var checkProp = Utilities.safelyCheckPropertyOnObject,
			getBoolean = Utilities.getBoolean,
			validString = UtilsValidation.validString,
			validArray = UtilsValidation.validArray,
			isRealObject = UtilsValidation.isRealObject,
			billingProviders = Enums.billingProviders,
			normalize = StringUtils.normalize;

		var NORMALIZED_BILLING_PROVIDER_ADYEN = normalize(billingProviders.ADYEN),
			NORMALIZED_BILLING_PROVIDER_CYBERSOURCE = normalize(billingProviders.CYBERSOURCE),
			NORMALIZED_PAYPAL_AUTH = normalize(Enums.authTypes.PAYPAL);

		var service = {
			checkPaymentMethodsByBillingProvider: checkPaymentMethodsByBillingProvider,
			getPaymentMethodRequired: getPaymentMethodRequired,
			hasPayPal: hasPayPal,
			isAdyenPaymentMethod: isAdyenPaymentMethod,
			isCybersourcePaymentMethod: isCybersourcePaymentMethod,
			isV5PaymentType: isV5PaymentType,
			isValidPaymentMethod: isValidPaymentMethod
		};

		service.hasAdyenPaymentMethods = service.checkPaymentMethodsByBillingProvider(service.isAdyenPaymentMethod);
		service.hasCybersourcePaymentMethods = service.checkPaymentMethodsByBillingProvider(service.isCybersourcePaymentMethod);

		return service;

		/**
		 * Used with an array to filter valid payment methods
		 * @function
		 * @public
		 * @param {Object} type payment type
		 * @returns {Boolean} if payment type is a valid
		 */
		function isValidPaymentMethod(type) {
			return checkProp('type.auth_type', type, validString) && type.auth_type !== Enums.authTypes.CREDITCARD && type.visible === 'true';
		}

		/**
		 * Checks if Paypal is configured
		 * @function
		 * @public
		 * @returns {Boolean} true if paypal is configured
		 */
		function hasPayPal() {
			return AppData.billingTypes.some(function(type) {
				return normalize(type.auth_type) === NORMALIZED_PAYPAL_AUTH && getBoolean(type.visible);
			});
		}

		/**
		 * Checks if we have payment methods of provided billing provider
		 * @public
		 * @function
		 * @param {Function} filterFunction filter function
		 * @returns {Function} returns filter function
		 */
		function checkPaymentMethodsByBillingProvider(filterFunction) {
			var paymentMethods;
			return function() {
				paymentMethods = AppData.billingTypes
					.filter(service.isValidPaymentMethod)
					.filter(service.isV5PaymentType);
				return paymentMethods.some(filterFunction);
			};
		}

		/**
		 * Return if the payment method is Adyen payment method, to be used with checkPaymentMethodsByBillingProvider
		 * @param {Object} paymentMethod payment type object
		 * @returns {Boolean} true/false
		 */
		function isAdyenPaymentMethod(paymentMethod) {
			return normalize(paymentMethod.billing_provider_desc) === NORMALIZED_BILLING_PROVIDER_ADYEN;
		}

		/**
		 * Return if the payment method is Cybersource payment method, to be used with checkPaymentMethodsByBillingProvider
		 * @param {Object} paymentMethod payment type object
		 * @returns {Boolean} true if it is a CYBS payment method
		 */
		function isCybersourcePaymentMethod(paymentMethod) {
			return normalize(paymentMethod.billing_provider_desc) === NORMALIZED_BILLING_PROVIDER_CYBERSOURCE;
		}

		/**
		 * Returns if the payment type is for v5
		 * @function
		 * @public
		 * @param {Object} paymentType payment type
		 * @returns {Boolean} true/false
		 */
		function isV5PaymentType(paymentType) {
			return checkProp('paymentType.payment_type_categories', paymentType, validString) && paymentType.payment_type_categories.indexOf('ecommerce') !== -1;
		}

		/**
		 * If a package was set to only be allowed to use one payment method, try to find it in the cart items.
		 * @public
		 * @function
		 * @param {Object[]} cartItems The cart items
		 * @return {String} the payment method override if we have one
		 */
		function getPaymentMethodRequired(cartItems) {
			var KEY = 'payment_method_required',
				foundCharac = '';

			if (!validArray(cartItems)) {
				return foundCharac;
			}

			foundCharac = cartItems.reduce(function(found, item) {
				var charac;

				if (!isRealObject(item)) {
					return found;
				}

				if (validArray(item.CHARACS)) {
					charac = item.CHARACS.find(function(characs) {
						return characs.hasOwnProperty(KEY);
					});

					if (charac) {
						found = charac[KEY];
					}
				} else if (isRealObject(item.CHARACS) && item.CHARACS.hasOwnProperty(KEY)) {
					found = item.CHARACS[KEY];
				}

				return found;
			}, '');

			// Get the payment method override if it exist in the CHARACS of any of the items in the cart.
			if (validString(foundCharac)) {
				return foundCharac;
			}

			return '';
		}
	}
})();
/* eslint-disable sort-keys */
(function() {
	'use strict';

	angular
		.module('adyen', ['ideal', 'mistercash'])
		.config(configBlock)
		.run(intializedAdyenPrepService);

	/**
	 * Sets up routing for Adyen Module
	 * @public
	 * @function
	 * @param {stateProvider} $stateProvider Lets us set up state
	 * @return {undefined}
	 * @ngInject
	 */
	function configBlock($stateProvider) {
		var MODULE_DIRECTORY = '/scripts/modules/billing/modules/adyen';
		$stateProvider
			.state('adyen-redirect-payment', {
				url: '/adyen/redirectPayment/{paymentMethod:(?:ideal|mrcash|3ds|kcp)}',
				templateUrl: MODULE_DIRECTORY + '/views/adyen-redirect-payment-form.html',
				controller: 'AdyenRedirectPaymentController',
				dynamic: true,
				resolve: {
					initialData: initializeData,
					allowedRoute: function(initialData, AdyenRedirectService, $state, RouteRejectionService) {
						if (!AdyenRedirectService.isRedirectInitiated()) {
							throw new RouteRejectionService.UnrecoverableException('/billingView', {});
						} else {
							AdyenRedirectService.completeInitiateRedirect();
							return true;
						}
					},
					savePurchaseAuthStatus: function(allowedRoute, Purchase, Enums, RouteRejectionService) {
						return Purchase.savePurchaseAuthStatus().then(function(response) {
							if (response.status == Enums.status.OK && angular.isDefined(response.saved_purchase_status) &&
								response.saved_purchase_status === Enums.savedPurchaseAuthStatuses.NO_SAVED_PURCHASE_STATUS) {
								return response.saved_purchase_status;
							} else {
								//show an error for each specific auth status
								throw new RouteRejectionService.ViewException('Adyen', 'adyenRedirectSavePurchAuthFailStatus' + response.saved_purchase_status + 'Title', 'adyenRedirectSavePurchAuthFailStatus' + response.saved_purchase_status + 'Msg', '/reset', {});
							}
						});
					}
				}
			})
			.state('adyen-redirect-payment-results', {
				url: '/adyen/redirectPaymentResults',
				template: '<div></div>',
				controller: 'AdyenRedirectPaymentResultsController',
				dynamic: true,
				resolve: {
					initialData: function(Bootstrap, $rootScope, Language) {
						$rootScope.showSpinner(Language.getLocale('Adyen', 'checkingTransactionStatus'));
						return Bootstrap.bootstrapApplication(undefined, true);
					},
					load: function(initialData, Utilities) {
						return Utilities.cacheBustAndLazyLoad([MODULE_DIRECTORY + '/controllers/adyen-redirect-payment-results-controller.js']);
					},
					fetchConnection: function(load, $q, LegacyCart) {
						var defer = $q.defer();
						LegacyCart.fetchGetCartSummary(defer.resolve, defer.reject);
						return defer.promise;
					},
					assessRoute: function(fetchConnection, RouteRejectionService, $rootScope) {
						if (!$rootScope.hasItemsInCart()) {
							throw new RouteRejectionService.UnrecoverableException('/reset');
						} else {
							return true;
						}
					}
				}
			});
	}

	/**
	 * Adyen Module
	 * @param {Object} AdyenPrepService AdyenPrepService
	 * @param {Object} BillingService Billing Service
	 * @returns {undefined}
	 */
	function intializedAdyenPrepService(AdyenPrepService, BillingService) {
		// trigger loading of the prep service so that it can listen for application activated event
		BillingService.appendPaymentMethodLoadPromise(AdyenPrepService.initializeConfiguration);
	}

	/**
	 * Resolves the bootstrap promise
	 * @public
	 * @function
	 * @name initializeData
	 * @param {Service} Bootstrap The bootstrap service
	 * @return {Promise} A promise that we bootstrapped
	 * @ngInject
	 */
	function initializeData(Bootstrap) {
		return Bootstrap.bootstrapApplication();
	}
})();
(function() {
	'use strict';
	angular
		.module('adyen')
		.controller('AdyenRedirectPaymentController', AdyenRedirectPaymentController);
	/**
	 * AdyenRedirectPaymentController
	 * @param {Service} Enums Enums service
	 * @param {Service} AdyenRedirectService AdyenRedirectService
	 * @param {Service} Language Language
	 * @param {Service} Modal Modal
	 * @param {Service} Purchase Purchase
	 * @param {Service} $rootScope $rootScope
	 * @param {Document} $document $document
	 * @param {Service} $sce $sce
	 * @param {Service} $scope $scope
	 * @param {Service} $stateParams $stateParams
	 * @param {Window} $window $window
	 * @param {Service} Utilities Utilities
	 * @param {Service} $transitions $transitions
	 * @returns {undefined}
	 * @ngInject
	 */
	function AdyenRedirectPaymentController(
		Enums,
		AdyenRedirectService,
		Language,
		Modal,
		Purchase,
		$rootScope,
		$document,
		$sce,
		$scope,
		$stateParams,
		$window,
		Utilities,
		$transitions) {
		var paymentMethodMapping = Enums.paymentMethodLocaleMapping[$stateParams.paymentMethod],
			finalized = false,
			checkFinalization = true,
			isRedirectionCompleted = false,
			didGoOffline,
			watchOffline,
			watchOnline;

		$rootScope.showSpinner(Language.getLocale('Purchase', 'savePurchaseAuthStatusLoadingMsg'));
		//set scope variables and private variables
		$scope.paRequest = AdyenRedirectService.getPaRequest();
		$scope.md = AdyenRedirectService.getMd();
		$scope.redirectUrl = $sce.trustAsResourceUrl(AdyenRedirectService.getRedirectUrl());
		$scope.termUrl = $sce.trustAsResourceUrl(AdyenRedirectService.getPostBackURL());

		// methods
		$scope._redirectionCallback = _redirectionCallback;
		$scope.promptForRedirection = promptForRedirection;
		$scope.onSavePurchaseFailure = onSavePurchaseFailure;
		$scope.showFinalizationStepModal = showFinalizationStepModal;
		$scope.handleRedirection = handleRedirection;
		$scope.getWindow = getWindow;
		$scope.getDocument = getDocument;
		$scope.destroyListeners = destroyListeners;

		initializeController();
		/**
		 * Return window
		 * @public
		 * @returns {Window} window
		 */
		function getWindow() {
			return $window;
		}

		/**
		 * Return document
		 * @public
		 * @returns {Document} document
		 */
		function getDocument() {
			return $document[0];
		}

		/**
		 * The $onDestroy listener.
		 * @public
		 * @returns {undefined}
		 */
		function destroyListeners() {
			[watchOnline, watchOffline].forEach(function(deregisterCallback) {
				if (angular.isFunction(deregisterCallback)) {
					deregisterCallback();
				}
			});
		}

		/**
		 * Redirection callback
		 * @private
		 * @returns {undefined}
		 */
		function _redirectionCallback() {
			var $win = $scope.getWindow();
			if (Utilities.isInIFrame() && AdyenRedirectService.simpleRedirect()) {
				isRedirectionCompleted = true;
				$win.open($scope.redirectUrl, 'providerWindow');
				$scope.showFinalizationStepModal();
			} else {
				$scope.handleRedirection();
			}
		}

		/**
		 * Prompt the user with window to let them know they are redirecting
		 * @function
		 * @protected
		 * @return {undefined}
		 */
		function promptForRedirection() {
			$rootScope.hideSpinner();
			Modal.displayModal({
				action: 'Confirm',
				buttonFlags: [Enums.buttonFlags.OK],
				callback: $scope._redirectionCallback,
				category: 'Payment Provider',
				description: Language.getLocale('Purchase', 'redirect' + paymentMethodMapping.locale + 'Msg'),
				icon: 'sprite sprite-' + paymentMethodMapping.spriteName,
				label: 'Payment Provider Redirect',
				showCloseButton: false,
				title: Language.getLocale('Purchase', 'redirect' + paymentMethodMapping.locale + 'Title')
			});
		}

		/**
		 * Handles redirection
		 * @public
		 * @returns {undefined}
		 */
		function handleRedirection() {
			var $win = $scope.getWindow(),
				adyenForm;
			isRedirectionCompleted = true;
			if (AdyenRedirectService.simpleRedirect()) {
				$win.location.href = $scope.redirectUrl;
				$rootScope.showSpinner();
			} else {
				$scope.showFinalizationStepModal();
				adyenForm = $scope.getDocument().getElementById('adyenForm');
				adyenForm.action = $scope.redirectUrl;
				adyenForm.target = 'providerWindow';
				adyenForm.enctype = 'application/x-www-form-urlencoded';
				adyenForm.onsubmit = function() {
					$win.open($scope.redirectUrl, 'providerWindow');
				}
				adyenForm.submit();
			}
		}

		/**
		 * Attempt to show the finalization step
		 * @function
		 * @protected
		 * @return {undefined}
		 */
		function showFinalizationStepModal() {
			/* eslint-disable sort-keys */
			Modal.displayModal({
				action: 'Confirm',
				buttonFlags: [Enums.buttonFlags.OK],
				category: 'Payment Provider',
				description: Language.getLocale('Purchase', 'confirmAuth' + paymentMethodMapping.locale + 'Msg'),
				icon: 'sprite sprite-' + paymentMethodMapping.spriteName,
				label: 'Payment Provider Redirect',
				showCloseButton: false,
				title: Language.getLocale('Purchase', 'confirmAuth' + paymentMethodMapping.locale + 'Title'),
				callback: function(detail) {
					if (detail == Enums.buttonFlags.OK) {
						finalized = true;
						$scope.destroyListeners();
						AdyenRedirectService.finalizeRedirectTransaction();
					}
				}
			});
			/* eslint-disable sort-keys */
		}

		/**
		 * Show SavePurchaseFailure message if we need to show the modal and we redirect the user back to the PaymentMethod screen
		 * @function
		 * @protected
		 * @return {undefined}
		 */
		function onSavePurchaseFailure() {
			$rootScope.hideSpinner();
			/* eslint-disable sort-keys */
			Modal.displayModal({
				action: 'Save Purchase Error',
				buttonFlags: [Enums.buttonFlags.OK],
				category: 'Save Purchase Error',
				description: Language.getLocale('Alert', 'apersSavePurchaseErrorMessage'),
				label: Language.getLocale('Alert', 'apersSavePurchaseErrorTitle'),
				showCloseButton: false,
				title: Language.getLocale('Alert', 'apersSavePurchaseErrorTitle'),
				callback: function() {
					checkFinalization = false;
					$rootScope.routeTo(Enums.routes.PAYMENT_METHOD, undefined, undefined, true);
				}
			});
			/* eslint-disable sort-keys */
		}

		/**
		 * Try to catch state changes back to the previous screen and prevent the occurrence
		 * Technically the store should be on lock-down at this point as the guest is in
		 * the middle of a transaction
		 */
		var onStartDeregister = $transitions.onStart({from: 'adyen-redirect-payment'}, function(trans) {
			//catch routing away and enforce user to confirm whether or not they wish to leave
			if (!finalized && checkFinalization && trans.to().name.indexOf('reset') === -1) {
				trans.abort();
				return;
			}

			onStartDeregister();
		});

		/**
		 * Whether or not the user truly redirects or not, if the user happens to remain on this page and lets the timeout happen either pre or post redirect
		 * The finalization action will catch and gracefully handle all conditions and also allow the guest to reselect and attempt their payment checkout process again
		 * This is the most desirable option for now.
		 */
		$scope.$on('showPreviousModals', function() {
			if (isRedirectionCompleted) {
				$scope.showFinalizationStepModal();
			} else {
				$scope.promptForRedirection();
			}
		});

		/**
		 * Initialize controller
		 * @function
		 * @protected
		 * @return {undefined}
		 */
		function initializeController() {
			var excludeSecAcctInfo = true;

			//fire off a save purchase immediately - if successful, it will prompt the redirect window otherwise it will show an error
			if ($stateParams.paymentMethod === '3ds') {
				// include account information in save purchase call
				excludeSecAcctInfo = false;
			}

			Purchase.savePurchase($scope.promptForRedirection, $scope.onSavePurchaseFailure, excludeSecAcctInfo);

			$scope.destroyListeners();
		}
	}
})();

(function() {
	/* eslint-disable no-invalid-this, camelcase */
	'use strict';

	angular
		.module('adyen')
		.factory('AdyenPrepService', AdyenPrepService);

	/**
	 * General AdyenPrepService
	 * @param {Object} $q Service
	 * @param {Object} $rootScope $rootScope
	 * @param {Object} $state $state
	 * @param {Object} AppData Service
	 * @param {Object} Enums Service
	 * @param {Object} AdyenRedirectService Service
	 * @param {Object} AdyenRequestService Service
	 * @param {Object} BillingModels Service
	 * @param {Object} CustomActionService CustomActionService
	 * @param {Object} JSONValidator Service
	 * @param {Object} Language Service
	 * @param {Object} BillingService Service
	 * @param {Object} IdealPrepService IdealPrepService
	 * @param {Object} Purchase Service
	 * @param {Object} Utilities Service
	 * @param {Object} UtilsValidation Service
	 * @returns {Object} AdyenPrepService
	 * @ngInject
	 */
	function AdyenPrepService(
		$q,
		$rootScope,
		$state,
		AppData,
		Enums,
		AdyenRedirectService,
		AdyenRequestService,
		BillingModels,
		CustomActionService,
		JSONValidator,
		Language,
		BillingService,
		IdealPrepService,
		Purchase,
		Utilities,
		UtilsValidation) {
		var isRealObject = UtilsValidation.isRealObject,
			koreanPaymentProvider = Enums.paymentProvider.KOREANADYEN,
			koreanBillingType = Enums.billingTypes.KOREANADYEN,
			iDealPaymentProvider = Enums.paymentProvider.IDEAL,
			mrCashAuthType = Enums.authTypes.MISTERCASH,
			mrCashPaymentProvider = Enums.paymentProvider.MRCASH,
			mrCashMobilePaymentProvider = Enums.paymentProvider.MRCASHMOBILE,
			mrCashBillingType = Enums.billingTypes.MISTERCASH,
			mrCashMobileBillingType = Enums.billingTypes.MISTERCASHMOBILE,
			idealBillingType = Enums.billingTypes.IDEAL,
			idealBillingObj,
			hasMisterCashMobileFlow,
			hasMisterCashFlow;
		var factory = {
			_checkPaymentMethodByBillingType: _checkPaymentMethodByBillingType,
			_idealAlternatePurchaseAction: _idealAlternatePurchaseAction,
			_isIdealInBillingTypes: _isIdealInBillingTypes,
			config: {},
			configureAdyen: configureAdyen,
			initializeConfiguration: initializeConfiguration,
			_isMrCashInBillingTypes: _isMrCashInBillingTypes,
			_mrCashAlternatePurchaseAction: _mrCashAlternatePurchaseAction,
			_mrCashMobileAlternatePurchaseAction: _mrCashMobileAlternatePurchaseAction,
			isKoreanAdyenBillingType: isKoreanAdyenBillingType,
			isKoreanAdyenInBillingTypes: isKoreanAdyenInBillingTypes,
			koreanAdyenAlternatePurchaseAction: koreanAdyenAlternatePurchaseAction
		};

		/**
		 * Initialize the Adyen configuration
		 * @function
		 * @protected
		 * @return {undefined}
		 */
		function initializeConfiguration() {
			return $q(function(resolve) {
				configureAdyen();
				resolve();
			});
		}

		/**
		 * Configure the Adyen module if we are configured for it so it is available
		 * @function
		 * @protected
		 * @return {undefined}
		 */
		function configureAdyen() {
			if (JSONValidator.validate('adyen', AppData.settings.adyen)) {
				factory.config = JSON.parse(AppData.settings.adyen);
				if (Utilities.getBoolean(factory.config.activatePaymentProvider)) {
					registerErrorCodeOverrides();
					if (isKoreanAdyenInBillingTypes()) {
						registerPaymentMethod();
					}
					if (factory._isIdealInBillingTypes()) {
						configureIdeal();
					}
					if (factory._isMrCashInBillingTypes()) {
						configureMrCash();
					}
					if (Utilities.getBoolean(factory.config.enable3DS)) {
						configure3DS();
					}
				}
			}
		}

		/**
		 * Registeres Korean Adyen payment method
		 * @protected
		 * @returns {undefined}
		 */
		function registerPaymentMethod() {
			var paymentMethod = new BillingModels.PaymentMethod(koreanPaymentProvider, koreanBillingType, 'korean-adyen.png');
			BillingService.registerBillingRoutePaymentProviders(koreanPaymentProvider);
			BillingService.registerPaymentMethod(paymentMethod);
			BillingService.registerAuthTypeWithoutAddress(koreanPaymentProvider);
			Purchase.registerAlternatePurchaseAction(koreanPaymentProvider, factory.koreanAdyenAlternatePurchaseAction);
		}

		/**
		 * Pre purchase auth function for Korean Adyen
		 * @protected
		 * @returns {undefined}
		 */
		function koreanAdyenAlternatePurchaseAction() {
			AdyenRequestService.prePurchaseAuth(function(authResponse) {
				if (authResponse.redirect_url) {
					AdyenRedirectService.startInitiateRedirect(null, null, authResponse.redirect_url);
				}
			});
		}

		/**
		 * Checks if korean adyen is in billing types
		 * @protected
		 * @returns {Boolean} true/false
		 */
		function isKoreanAdyenInBillingTypes() {
			var koreanAdyenBillingType = AppData.billingTypes.find(factory.isKoreanAdyenBillingType);
			return isRealObject(koreanAdyenBillingType);
		}

		/**
		 * Find out if a billing type is the Korean Adyen auth type
		 * @public
		 * @function
		 * @name isKoreanAdyenBillingType
		 * @param {Object} type The billing type to test
		 * @return {Boolean} if it is or not
		 */
		function isKoreanAdyenBillingType(type) {
			return isRealObject(type) && (type.auth_type === koreanBillingType);
		}

		/**
		 * Checks if ideal is in billing types
		 * @public
		 * @returns {Boolean} true/false
		 */
		function _isIdealInBillingTypes() {
			var paymentMethodBillingType = AppData.billingTypes.find(function(item) {
				return item.auth_type === idealBillingType && UtilsValidation.validString(item.cepay_merchant_id);
			});

			if (UtilsValidation.isRealObject(paymentMethodBillingType)) {
				idealBillingObj = paymentMethodBillingType;
				return true;
			}
			return false;
		}

		/**
		 * Checks if Mrcash is in billing types
		 * @public
		 * @returns {Boolean} true/false
		 */
		function _isMrCashInBillingTypes() {
			var misterCashBillingType = AppData.billingTypes.find(function(item) {
				return item.billing_type === mrCashBillingType && UtilsValidation.validString(item.cepay_merchant_id);
			});

			var misterCashMobileBillingType = AppData.billingTypes.find(function(item) {
				return item.billing_type === mrCashMobileBillingType && UtilsValidation.validString(item.cepay_merchant_id);
			});
			hasMisterCashFlow = isRealObject(misterCashBillingType);
			hasMisterCashMobileFlow = isRealObject(misterCashMobileBillingType);
			return hasMisterCashFlow || hasMisterCashMobileFlow;
		}

		/**
		 * Configure MrCash
		 * @protected
		 * @returns {undefined}
		 */
		function configureMrCash() {
			var paymentMethod;
			if (hasMisterCashMobileFlow) {
				paymentMethod = new BillingModels.PaymentMethod(mrCashMobilePaymentProvider, mrCashAuthType, 'mrcash-payment.png', mrCashMobileBillingType);
				BillingService.registerBillingRoutePaymentProviders(mrCashMobilePaymentProvider);
				BillingService.registerPaymentMethod(paymentMethod);
				CustomActionService.registerCustomAction(CustomActionService.ACTIONS_ENUMS.PAYMENT_METHOD_BY_BILLINGTYPE, factory._checkPaymentMethodByBillingType);
				Purchase.registerAlternatePurchaseAction(mrCashMobilePaymentProvider, factory._mrCashMobileAlternatePurchaseAction);
			}
			if (hasMisterCashFlow) {
				paymentMethod = new BillingModels.PaymentMethod(mrCashPaymentProvider, mrCashAuthType, 'mrcash-payment.png', mrCashBillingType);
				BillingService.registerBillingRoutePaymentProviders(mrCashPaymentProvider);
				BillingService.registerPaymentMethod(paymentMethod);
				BillingService.registerCardCaptureAuthType(mrCashAuthType);
				Purchase.registerAlternatePurchaseAction(mrCashPaymentProvider, factory._mrCashAlternatePurchaseAction);
			}
		}

		/**
		 * Check the payment method based on billing type and payment provider
		 * @public
		 * @param {String} paymentProvider payment provider
		 * @param {Object} billingTypeObj billing type
		 * @returns {Boolean} true/ false
		 */
		function _checkPaymentMethodByBillingType(paymentProvider, billingTypeObj) {
			if (!UtilsValidation.validString(paymentProvider) || !isRealObject(billingTypeObj)) {
				return false;
			}
			if (paymentProvider === mrCashMobilePaymentProvider && billingTypeObj.billing_type === mrCashMobileBillingType) {
				BillingService.deregisterCardCaptureAuthType(mrCashAuthType);
				return false;
			}
			if (paymentProvider === mrCashPaymentProvider && billingTypeObj.billing_type === mrCashBillingType) {
				BillingService.registerCardCaptureAuthType(mrCashAuthType);
				return false;
			}
			return ((paymentProvider === mrCashMobilePaymentProvider && billingTypeObj.billing_type === mrCashBillingType) || (paymentProvider === mrCashPaymentProvider && billingTypeObj.billing_type === mrCashMobileBillingType));
		}

		/**
		 * Alternate Purchase Action for Mr Cash Mobile
		 * @public
		 * @returns {undefined}
		 */
		function _mrCashMobileAlternatePurchaseAction() {
			AdyenRequestService.prePurchaseAuth(function(authResponse) {
				if (authResponse.redirect_url) {
					AdyenRedirectService.startInitiateRedirect(null, null, authResponse.redirect_url);
				}
			});
		}

		/**
		 * Alternate Purchase Action for Mr Cash
		 * @public
		 * @returns {undefined}
		 */
		function _mrCashAlternatePurchaseAction() {
			var params,
				paramValues = {};
			AdyenRequestService.prePurchaseAuth(function(authResponse) {
				if (authResponse.redirect_url && Utilities.safelyCheckPropertyOnObject('authResponse.params.param', authResponse, Array.isArray)) {
					params = authResponse.params.param;
					params.forEach(function(param) {
						paramValues[param.name] = param.value;
					});
					if (paramValues.MD && paramValues.PaReq) {
						AdyenRedirectService.startInitiateRedirect(paramValues.MD, paramValues.PaReq, authResponse.redirect_url);
					}
				}
			});
		}

		/**
		 * Registering error code override
		 * @function
		 * @protected
		 * @return {undefined}
		 */
		function registerErrorCodeOverrides() {
			Language.registerErrorCodeOverride('PrePurchaseAuth');
		}

		/**
		 * Configure the 3DSecure billing option - register actions specific to this flow within the main application billing flow
		 * @function
		 * @protected
		 * @return {undefined}
		 */
		function configure3DS() {
			var threeDSecureBillingType = AppData.billingTypes.find(function(item) {
				return item.auth_type == Enums.billingTypes.SECURE3D && angular.isDefined(item.cepay_merchant_id);
			});
			if (threeDSecureBillingType) {
				//register important actions into the main app
				BillingService.registerCardCaptureAuthType('3DS');
				Purchase.registerAlternatePurchaseAction('cc', purchaseAction3DS);
			}
		}

		/**
		 * Should configure ideal
		 * @protected
		 * @returns {undefined}
		 */
		function configureIdeal() {
			IdealPrepService.setupIdeal(idealBillingObj, factory.config.idealLink, function() {
				//upon successful setup, register this action for adyen specifc redirection flow
				Purchase.registerAlternatePurchaseAction(iDealPaymentProvider, factory._idealAlternatePurchaseAction);
			}, true);
		}

		/**
		 * Ideal Alternate Purchase action
		 * @public
		 * @returns {undefined}
		 */
		function _idealAlternatePurchaseAction() {
			AdyenRequestService.prePurchaseAuth(function(authResponse) {
				if (authResponse.redirect_url) {
					AdyenRedirectService.startInitiateRedirect(null, null, authResponse.redirect_url);
				}
			});
		}

		/**
		 * Action to fire once guest clicks on Purchase for a 3DS enabled merchant credit card transaction
		 * @function
		 * @protected
		 * @return {undefined}
		 */
		function purchaseAction3DS() {
			AdyenRequestService.prePurchaseAuth(function(authResponse) {
				//if its 3DS we need to check if the user is registered for 3DSecure service
				if (Utilities.getBoolean(authResponse.is_registered)) {
					AdyenRedirectService.startInitiateRedirect(authResponse.md, authResponse.pa_request, authResponse.redirect_url);
				} else {
					//otherwise just call purchase as we normally would since we are not redirecting for 3DS
					Purchase.executePurchase(Purchase.defaultPostPurchaseSuccess);
				}
			});
		}

		return factory;
	}
})();

(function() {
	/* eslint-disable sort-keys, no-invalid-this, camelcase */
	'use strict';
	angular
		.module('adyen')
		.service('AdyenRequestService', AdyenRequestService);
	/**
	 * AdyenRequestService
	 * @param {Object} AdyenRedirectService Service
	 * @param {Object} AppData Service
	 * @param {Object} LegacyCart Service
	 * @param {Object} ClientInfo Service
	 * @param {Object} Enums Service
	 * @param {Object} Language Service
	 * @param {Object} Modal Service
	 * @param {Object} UserInfo Service
	 * @param {Object} Utilities Service
	 * @param {Object} $state Service
	 * @param {Object} $rootScope Service
	 * @returns {Object} AdyenRequestService
	 * @ngInject
	 */
	function AdyenRequestService(
		AdyenRedirectService,
		AppData,
		LegacyCart,
		ClientInfo,
		Enums,
		Language,
		Modal,
		UserInfo,
		Utilities,
		$state,
		$rootScope) {
		/**
		 * Get a pre purchase authorization for potential redirection
		 * Many failure scenarios can occur during the building of this request and even upon receipt of the data
		 * To account for all of the scenarios, we do not return a process here but rather we pass a param for a
		 * callback function to execute once we are completely done with this process
		 * @function
		 * @public
		 * @param {Function} successCallback - a function to call once this process is completed successfully
		 * @return {undefined}
		 */
		this.prePurchaseAuth = function(successCallback) {
			var isCartBalanceCoveredByPartialPayments = _getCartAmount() === '0.00',
				req,
				localeDescription;
			$rootScope.showSpinner(Language.getLocale('ApplicationLabels', 'purchaseLoadMsg'));
			if (isCartBalanceCoveredByPartialPayments) {
				successCallback({});
				return;
			}
			req = buildPrePurchaseAuthRequest();

			if (angular.isDefined(req)) {
				AppData.fetch('PrePurchaseAuth', false, req).then(function(response) {
					var payment = UserInfo.get('payment');
					if (response.status == Enums.status.OK && angular.isDefined(response.CEPAY)) {
						//update UserInfo.payment with the auth id we received and return the response
						payment.auth_id = response.CEPAY.auth_id;
						//attach this to the payment node for backend to identify this as a pre-purchase auth route
						//this is to handle the case where pre-authed calls are then followed
						// by a purchase call to create an order in our system
						payment.payment_route = Enums.prePurchaseAuthRoute;
						UserInfo.set('payment', payment);
						successCallback(response.CEPAY);
					} else {
						localeDescription = undefined;
						if (Utilities.safelyCheckPropertyOnObject('response.CEPAY.error_code', response)) {
							localeDescription = Language.getLocale('ErrorCodes', Enums.cepayErrorCodeToTix[response.CEPAY.error_code]);
						}
						//show the error modal
						showErrorModal(undefined, localeDescription);
					}
				});
			} else {
				throw new Error("Adyen: Unable to create request object");
			}
		}

		/**
		 * Return the cart amount after the partial payments deduction
		 * @private
		 * @function
		 * @returns {Number} cart amount
		 */
		function _getCartAmount() {
			var cartTotalRemaining = Number(LegacyCart.total),
				partialPayments = UserInfo.get('partialPayments');

			if (!partialPayments.length) {
				return cartTotalRemaining.toFixed(2);
			}

			partialPayments.forEach(function(partialPayment) {
				if (Utilities.safelyCheckPropertyOnObject('partialPayment.payment.total', partialPayment)) {
					cartTotalRemaining -= Number(partialPayment.payment.total);
				}
			});

			return cartTotalRemaining.toFixed(2);
		}

		/**
		 * Build a Pre-Purchase Auth request
		 * @function
		 * @protected
		 * @return {Object} Request Object
		 * */
		function buildPrePurchaseAuthRequest() {
			var billing = UserInfo.get('billing');
			var payment = UserInfo.get('payment');
			var secAcctInfo = UserInfo.get('secAcctInfo');
			var cartTotalRemaining = _getCartAmount();
			var misterCashObj;
			if (angular.isUndefined(LegacyCart.total)) {
				//if the cart total is undefined here, then the user refreshed so route back to order review
				$rootScope.routeTo($state.href('/orderReview', {}));
				$rootScope.hideSpinner();
				return undefined;
			}
			if (payment.authType === Enums.billingTypes.KOREANADYEN) {
				return {
					CEPAY: {
						amount: LegacyCart.total,
						auth_type: payment.authType,
						merchant_id: payment.cepayMerchantId,
						return_url: AdyenRedirectService.getPostBackURL()
					}
				}
			} else if (payment.authType === Enums.billingTypes.IDEAL) {
				return {
					CEPAY: {
						amount: LegacyCart.total,
						auth_type: payment.authType,
						language: AppData.language,
						merchant_id: payment.cepayMerchantId,
						issuer_id: payment.bankId,
						return_url: AdyenRedirectService.getPostBackURL()
					}
				}
			}
			if (payment.authType === Enums.authTypes.MISTERCASH) {
				misterCashObj = {
					CEPAY: {
						amount: LegacyCart.total,
						auth_type: payment.authType,
						merchant_id: payment.cepayMerchantId,
						language: AppData.language,
						http_accept: '*/*',
						http_user_agent: ClientInfo.userAgent,
						return_url: AdyenRedirectService.getPostBackURL()
					}
				};
				if (payment.billing_type === Enums.billingTypes.MISTERCASH) {
					misterCashObj.CEPAY.CARD = {
						number: secAcctInfo.account,
						expire_date: payment.year + payment.month,
						expire_date_format: 'YYMM'
					}
				}
				return misterCashObj
			}

			if (angular.isUndefined(secAcctInfo.account)) {
				//we are not allowed to store the credit card info in local storage so if someone happens
				// to refresh on the orderReview screen and we lose this data,
				// we show the error modal and route back to the payment method screen
				//this is the same process we do during the Purchase.executePurchase call as well
				showErrorModal(Language.getLocale('Alert', 'purchaseErrorListTitle'), Language.getLocale('Alert', 'purchaseErrorListMsg'));
				return undefined;
			}
			return {
				amount: cartTotalRemaining,
				CEPAY: {
					amount: cartTotalRemaining,
					auth_type: (payment.authType === 'EC' ? '3DS' : payment.authType),
					merchant_id: payment.cepayMerchantId,
					http_accept: '*/*',
					http_user_agent: ClientInfo.userAgent,
					language: AppData.language,
					CARDHOLDER: {
						f_name: billing.firstName,
						l_name: billing.lastName,
						m_name: '',
						address: billing.address,
						zip: billing.zip,
						city: billing.city,
						state: billing.state,
						country: billing.country
					},
					CARD: {
						number: secAcctInfo.account,
						expire_date: payment.year + payment.month,
						cvv2: angular.isDefined(secAcctInfo.securityCode) ? secAcctInfo.securityCode : ''
					}
				}
			};
		}

		/**
		 * Show an error modal if the pre purchase auth fails
		 * Route back to the paymentMethod screen so that the
		 * guest can choose a different method of payment and try again
		 * @function
		 * @protected
		 * @param {string} titleParam title parameter
		 * @param {string} descParam desc parameter
		 * @return {undefined}
		 */
		function showErrorModal(titleParam, descParam) {
			var title = angular.isUndefined(titleParam) ? Language.getLocale('Alert', 'errorPaymentProviderTitle') : titleParam;
			var description = angular.isUndefined(descParam) ? Language.getLocale('Alert', 'errorPaymentProviderMsg') : descParam;
			$rootScope.hideSpinner();
			Modal.displayModal({
				category: 'PrePurchase Auth Error',
				action: 'Error',
				label: 'PrePurchase Auth Error',
				title: title,
				description: description,
				buttonFlags: [Enums.buttonFlags.OK],
				showCloseButton: false,
				callback: function() {
					$rootScope.routeTo($state.href('/paymentMethod', {}));
				}
			});
		}
	}
})();
/* eslint-disable camelcase */
(function() {
	'use strict';

	angular
		.module('adyen')
		.factory('AdyenRedirectService', AdyenRedirectService);

	/**
	 * AdyenRedirectService
	 * @param {Object} AppData Service
	 * @param {Object} LegacyCart LegacyCartService
	 * @param {Object} Enums Service
	 * @param {Object} Language Service
	 * @param {Object} Modal Service
	 * @param {Object} Purchase Service
	 * @param {Object} UserInfo Service
	 * @param {Object} Utilities Service
	 * @param {Object} UtilsValidation UtilsValidation service
	 * @param {Object} $rootScope Service
	 * @param {Object} $location Service
	 * @param {Object} $state Service
	 * @return {Object} AdyenRedirectService
	 * ngInject
	 */
	function AdyenRedirectService(
		AppData,
		LegacyCart,
		Enums,
		Language,
		Modal,
		Purchase,
		UserInfo,
		Utilities,
		UtilsValidation,
		$rootScope,
		$location,
		$state
	) {
		/**
		 * Control tracking of when we initate a redirect - to handle back button issues
		 * @type {boolean}
		 */
		var initiatedRedirect = false;
		/**
		 * Variable to hold the md data from the prePurchaseAuth call to route into a new window
		 * @type {String}
		 */
		var currentMd = '';
		/**
		 * Variable to hold the pa request data from the prePurchaseAuth call to route into a new window
		 * @type {String}
		 */
		var currentPaRequest = '';
		var currentRedirectUrl = '';
		var usingSimpleRedirect = false;
		/**
		 * Main service variable to return
		 * @type {Object}
		 */
		var factory = {
			//exposed methods to the outside
			_appendAuthIdToPostBackUrl: _appendAuthIdToPostBackUrl,
			_authorizeThroughPHP: _authorizeThroughPHP,
			_checkForCurrentPaymentMethod: _checkForCurrentPaymentMethod,
			_handlePendingOrderCase: _handlePendingOrderCase,
			appendQueryParamsToPostBack: appendQueryParamsToPostBack,
			completeInitiateRedirect: completeInitiateRedirect,
			finalizeMobileRedirectAuthorization: finalizeMobileRedirectAuthorization,
			finalizeRedirectTransaction: finalizeRedirectTransaction,
			getMd: getMd,
			getPaRequest: getPaRequest,
			getPostBackURL: getPostBackURL,
			getRedirectUrl: getRedirectUrl,
			isRedirectInitiated: isRedirectInitiated,
			removeQueryParams: removeQueryParams,
			simpleRedirect: simpleRedirect,
			startInitiateRedirect: startInitiateRedirect
		};

		/**
		 * Get the md string to inject into a new page for redirects
		 * @function
		 * @public
		 * @returns {String} currentMd
		 */
		function getMd() {
			return currentMd;
		}

		/**
		 * Get the pa request string to inject into a new page for redirects
		 * @function
		 * @public
		 * @returns {String} currentPaRequest
		 */
		function getPaRequest() {
			return currentPaRequest;
		}

		/**
		 * Returning current redirection url
		 * @function
		 * @public
		 * @returns {String} currentRedirectUrl
		 */
		function getRedirectUrl() {
			return currentRedirectUrl;
		}

		/**
		 * Are we using simple redirect here? Just opening a new tab instead of using a form post
		 * @function
		 * @public
		 * @return {boolean} is this current auth type using simple redirection?
		 */
		function simpleRedirect() {
			return usingSimpleRedirect;
		}

		/**
		 * Set the initiatedRedirect tracking variable to true
		 * When kcp is in use, then set the simple redirect and just open new tab for making payment
		 * @function
		 * @public
		 * @param {string} md md
		 * @param {string} paRequest pa request
		 * @param {string} redirectUrl redirect url
		 * @return {undefined}
		 */
		function startInitiateRedirect(md, paRequest, redirectUrl) {
			var payment = UserInfo.get('payment'),
				currentPaymentMethod;
			currentPaymentMethod = factory._checkForCurrentPaymentMethod(redirectUrl, payment);
			if (currentPaymentMethod) {
				currentRedirectUrl = redirectUrl;
				initiatedRedirect = true;
				usingSimpleRedirect = true;
				$rootScope.routeTo($state.href('adyen-redirect-payment', { paymentMethod: currentPaymentMethod }));
			} else if (angular.isDefined(md) && angular.isDefined(paRequest) && angular.isDefined(redirectUrl)) {
				//lets decode the htmlAnswer if Desktop since we will be writing that to a new page from the redirect controller
				// for mobile, lets leave it encoded as is as we send the encoded data to a PHP page, which will decode and route us directly.
				currentMd = md;
				currentPaRequest = paRequest;
				currentRedirectUrl = redirectUrl;
				initiatedRedirect = true;
				currentPaymentMethod = payment.authType === Enums.billingTypes.MISTERCASH ? 'mrcash' : '3ds';
				$rootScope.routeTo($state.href('adyen-redirect-payment', { paymentMethod: currentPaymentMethod }));
			} else {
				initiatedRedirect = false;
				showRedirectFailureModal();
			}
		}

		/**
		 * checks for payment method
		 * @public
		 * @param {String} redirectUrl redirect url
		 * @param {Object} payment payment object
		 * @returns {String/Boolean} payment method / boolean
		 */
		function _checkForCurrentPaymentMethod(redirectUrl, payment) {
			var billingEnum = Enums.billingTypes;
			if (UtilsValidation.validString(redirectUrl)) {
				if (payment.authType === billingEnum.KOREANADYEN) {
					return 'kcp';
				} else if (payment.authType === billingEnum.IDEAL) {
					return 'ideal';
				} else if (payment.authType === Enums.authTypes.MISTERCASH && payment.billingType === billingEnum.MISTERCASHMOBILE) {
					return 'mrcash';
				}
			}
			return false;
		}

		/**
		 * Set the initiatedRedirect tracking variable to false as we are complete
		 * @function
		 * @public
		 * @return {boolean} return true when it completes initiate redirect
		 */
		function completeInitiateRedirect() {
			initiatedRedirect = false;
			return true;
		}

		/**
		 * Return the result of whether or not we have initiated a redirect
		 * @function
		 * @public
		 * @return {boolean} is Redirect initiated
		 */
		function isRedirectInitiated() {
			return initiatedRedirect;
		}

		/**
		 * Provide the return url
		 * @function
		 * @public
		 * @returns {string} postback url
		 */
		function getPostBackURL() {
			//obtain the correct url and replace hashes for IE9
			var payment,
				postBackPath;
			payment = UserInfo.get('payment');
			postBackPath = $state.href('adyen-redirect-payment-results');
			postBackPath += '?cepay_merchant_id=' + payment.cepayMerchantId + '&auth_type=' + (payment.authType === 'EC' ? '3DS' : payment.authType);
			if (payment.authType === Enums.billingTypes.MISTERCASH) {
				postBackPath += "&amount=" + LegacyCart.total;
			}
			if (factory._appendAuthIdToPostBackUrl(payment)) {
				postBackPath += "&auth_id=" + payment.auth_id;
			}

			return factory.appendQueryParamsToPostBack(postBackPath);
		}

		/**
		 * Authorize transaction through PHP
		 * @private
		 * @returns {Boolean} true/false
		 */
		function _authorizeThroughPHP() {
			var payment = UserInfo.get('payment'),
				billingTypes = Enums.billingTypes;
			if (Utilities.isInIFrame()) {
				return true;
			} else if ([billingTypes.MISTERCASHMOBILE, billingTypes.IDEAL, billingTypes.KOREANADYEN].indexOf(payment.billingType) > -1) {
				return false;
			}
			return true;
		}

		/**
		 * Check if auth_id has to be appended to postback url
		 * @public
		 * @param {Object} payment payment object
		 * @returns {Boolean} true/false
		 */
		function _appendAuthIdToPostBackUrl(payment) {
			var billingTypes = Enums.billingTypes;
			return payment.authType !== billingTypes.KOREANADYEN && UtilsValidation.validString(payment.auth_id) && payment.authType !== billingTypes.IDEAL;
		}

		/**
		 * Returns postback url
		 * @public
		 * @param {String} postBackPath post back path
		 * @returns {String} post back url
		 */
		function appendQueryParamsToPostBack(postBackPath) {
			var queryParams = $location.search(),
				hostname = $location.host();
			if (Object.keys(queryParams).length) {
				postBackPath = Object.keys(queryParams).reduce(function(qp, key) {
					var val = queryParams[key];
					if (typeof val === 'undefined' || val === null) {
						val = '';
					}
					return qp + '&' + key + '=' + val;
				}, postBackPath);
			}

			return $location.protocol() + '://' + (hostname.indexOf('localhost') === -1 ? hostname : hostname + ':' + $location.port()) + postBackPath;
		}

		/**
		 * Finalize
		 * @param {Object} queryParams query params
		 * @returns {undefined}
		 */
		function finalizeMobileRedirectAuthorization(queryParams) {
			var reqObj = {
				CEPAY: {
					amount: queryParams.amount,
					auth_id: queryParams.auth_id,
					auth_type: queryParams.auth_type,
					http_accept: '*/*',
					http_user_agent: queryParams.http_user_agent,
					md: queryParams.md,
					merchant_id: queryParams.cepay_merchant_id,
					pa_response: queryParams.pa_response,
					payload: queryParams.payload
				}
			};
			$rootScope.showSpinner();

			AppData
				.fetch('PrePurchaseAuth', false, reqObj)
				.then(function() {
					factory.removeQueryParams();
					factory.finalizeRedirectTransaction();
				});
		}

		/**
		 * Remove query params
		 * @returns {undefined}
		 */
		function removeQueryParams() {
			var validString = UtilsValidation.validString,
				queryParams = ['amount', 'auth_id', 'auth_type', 'md', 'pa_response', 'payload', 'cepay_merchant_id', 'type', 'resultCode', 'http_accept', 'http_user_agent'];

			queryParams.forEach(function(param) {
				if (validString($location.search()[param])) {
					$location.search(param, null);
				}
			});
		}

		/**
		 * Finalize the redirect transaction
		 * 1. Call SavePurchaseAuthStatus
		 * 2. Depending on response, complete actions:
		 * 	a.  If confirmed, then execute the purchase
		 * 	b.  If failed, then delete the save purchase and inform user
		 * 	c.  If pending, route to the pending order page
		 * @function
		 * @public
		 * @return {undefined}
		 */
		function finalizeRedirectTransaction() {
			/* eslint-disable camelcase */
			var authStatus;
			Purchase.savePurchaseAuthStatus().then(function(response) {
				if (response.status == Enums.status.OK && angular.isDefined(response.saved_purchase_status)) {
					authStatus = response.saved_purchase_status;
					if (authStatus === Enums.savedPurchaseAuthStatuses.CONFIRMED_STATUS) {
						//if we have a confirmed status, lets execute the purchase
						Purchase.executePurchase(Purchase.defaultPostPurchaseSuccess, 'PurchaseSavedPurchase', { cart_id: AppData.cart.cart_id }, handlePurchaseSavePurchaseFailure);
					} else if (authStatus === Enums.savedPurchaseAuthStatuses.PURCHASED_STATUS) {
						//if the cart has already been purchased, lets route to the appropriate post purchase screen
						Purchase.getOrderAndRouteForPurchasedCart();
						LegacyCart.getNewCartID();
					} else if (authStatus === Enums.savedPurchaseAuthStatuses.PENDING_STATUS || authStatus === Enums.savedPurchaseAuthStatuses.NEW_STATUS) {
						factory._handlePendingOrderCase('pending-order');
					} else {
						handlePurchaseSavePurchaseFailure(true);
					}
				} else {
					//we were not able to get the status of what occurred
					// upon redirection so lets route to the pending page
					handlePurchaseSavePurchaseFailure(true);
				}
			});
		}

		/**
		 * Handle the pending order
		 * @param {String} pendingOrderState pending state
		 * @returns {undefined}
		 */
		function _handlePendingOrderCase(pendingOrderState) {
			AppData.fetch(Enums.services.GET_NEW_CART_ID, true, {}, true, true)
				.then(function() {
					Purchase.cleanupPreviousCart();
					$rootScope.routeTo($state.href(pendingOrderState));
				});
		}

		/**
		 * Handle PurchaseSavePurchase failure either by showing a failure modal or directly routing to the payment method screen
		 * Call deleteSavePurchase
		 * @function
		 * @public
		 * @param {boolean} showFailureModal showing failure modal flag
		 * @return {undefined}
		 */
		function handlePurchaseSavePurchaseFailure(showFailureModal) {
			//the authorization failed, lets delete the save purchase and allow the user to go back and choose a different payment method
			Purchase.deleteSavedPurchase().then(function(deleteSavedPurchaseResponse) {
				if (showFailureModal) {
					showAuthFailureModal(deleteSavedPurchaseResponse);
				} else {
					$rootScope.routeTo(Enums.routes.PAYMENT_METHOD);
				}
			});
		}

		/**
		 * After we receive word that the authorization failed, we attempt to delete the saved purchase entry
		 * Based on whether or not the deletion succeeds or fails, we route to certain areas
		 * @function
		 * @protected
		 * @param {string} deleteSavedPurchaseResponse response status
		 * @return {undefined}
		 */
		function showAuthFailureModal(deleteSavedPurchaseResponse) {
			/* eslint-disable sort-keys */
			$rootScope.hideSpinner();
			Modal.displayModal({
				category: 'Cart [Purchase]',
				action: 'Error',
				label: 'Purchase Auth Error',
				title: Language.getLocale('Adyen', 'adyenRedirectSavePurchAuthFailStatus40Title'),
				icon: 'icon-info red',
				description: Language.getLocale('Adyen', 'adyenRedirectSavePurchAuthFailStatus40Msg'),
				buttonFlags: [Enums.buttonFlags.OK],
				showCloseButton: false,
				callback: function() {
					if (deleteSavedPurchaseResponse.status == Enums.status.OK) {
						//if we successfully deleted the savePurchase in the DB then lets keep this cart and route to the payment method
						$rootScope.routeTo(Enums.routes.PAYMENT_METHOD);
					} else {
						//if we were unsuccessful in deleting the savePurchase for whatever reason,
						//we have to reset the cart so we don't end up with an unrecoverable state later on
						//this technically shouldn't happen but just in case it does
						$rootScope.routeTo('reset/true');
					}
				}
			});
			/* eslint-disable sort-keys */
		}

		/**
		* After we receive word that the authorization failed, we attempt to delete the saved purchase entry
		* Based on whether or not the deletion succeeds or fails, we route to certain areas
		* @function
		* @return {undefined}
		*/
		function showRedirectFailureModal() {
			/* eslint-disable sort-keys */
			Modal.displayModal({
				category: 'Cart [Purchase]',
				action: 'Error',
				label: 'Purchase Auth Error',
				title: Language.getLocale('Adyen', 'adyeGenericRedirectFailStatusTitle'),
				icon: 'icon-info red',
				description: Language.getLocale('Adyen', 'adyenGenericRedirectFailStatusMsg'),
				buttonFlags: [Enums.buttonFlags.OK],
				showCloseButton: false,
				callback: function() {
					$rootScope.routeTo(Enums.routes.PAYMENT_METHOD);
				}
			});
			/* eslint-disable sort-keys */
		}
		return factory;
	}
})();
/* eslint-disable sort-keys */
(function() {
	'use strict';

	angular
		.module('paypal', [])
		.config(config)
		.run(intializedPayPalPrepService);

	/**
	 * PayPal Module
	 * @param {Object} PayPalPrepService PayPalPrepService
	 * @param {Object} BillingService Billing Service
	 * @returns {undefined}
	 */
	function intializedPayPalPrepService(PayPalPrepService, BillingService) {
		// trigger loading of the prep service so that it can listen for application activated event
		BillingService.appendPaymentMethodLoadPromise(PayPalPrepService.initializeAndRegister);
	}

	/**
	 * Sets up routing for the PayPal module
	 * @public
	 * @function
	 * @name config
	 * @param {Provider} $stateProvider Lets us set up state
	 * @returns {undefined}
	 * @ngInject
	 */
	function config($stateProvider) {
		$stateProvider
			.state('/paypalCancelled', {
				url: '/paypalCancelled',
				template: '<div></div>',
				controller: 'PayPalPaymentController',
				dynamic: true,
				resolve: {
					initialData: initialDataWithSpinner,
					load: load,
					loadBinRanges: loadBinRanges,
					hideSpinner: function(loadBinRanges, $rootScope) {
						$rootScope.hideSpinner();
					}
				}
			})
			.state('/paypalComplete', {
				url: '/paypalComplete?token&PayerID',
				template: '<div></div>',
				controller: 'PayPalPaymentController',
				dynamic: true,
				resolve: {
					initialData: initialDataWithSpinner,
					load: load,
					loadBinRanges: loadBinRanges,
					hideSpinner: function(loadBinRanges, $rootScope) {
						$rootScope.hideSpinner();
					}
				}
			});

		/**
		 * Load our bootstrap and continue showing spinner.
		 * @param {Service} Bootstrap Bootstrap
		 * @param {Scope} $rootScope $rootscope
		 * @returns {Promise} to resolve our bootstrap process
		 * @ngInject
		 */
		function initialDataWithSpinner(Bootstrap, $rootScope) {
			$rootScope.showSpinner();
			return Bootstrap.bootstrapApplication(undefined, true);
		}

		/**
		 * Load our controller
		 * @param {Promise} initialData Bootstrap initialization process
		 * @param {Service} Utilities Utilities
		 * @returns {Promise} to resolve loading controller
		 */
		function load(initialData, Utilities) {
			return Utilities.cacheBustAndLazyLoad(['/scripts/modules/billing/modules/paypal/controllers/paypal-payment-controller.js']);
		}

		/**
		 * ROUTE GUARD
		 * Loads the bin ranges for the PAYMENTTYPE node in GetMerchantDetails
		 * @protected
		 * @param {Promise} load loading controller
		 * @param {Service} CreditCardBinRangesService To load the data
		 * @return {Promise} To resolve the bin ranges
		 * @ngInject
		 */
		function loadBinRanges(load, CreditCardBinRangesService) {
			return CreditCardBinRangesService.fetchBinRanges();
		}
	}
})();

(function() {
	/* eslint-disable require-jsdoc, no-invalid-this, camelcase */
	'use strict';

	angular
		.module('paypal')
		.factory('PayPalPrepService', PayPalPrepService);

	/**
	 * General PayPalPrepService
	 * @param {service} $q $q
	 * @param {Service} AppData AppData
	 * @param {Service} BillingModels BillingModels
	 * @param {Service} BillingService BillingService
	 * @param {Service} Enums Enums
	 * @param {Service} JSONValidator JSONValidator
	 * @param {Service} PaymentService PaymentService
	 * @param {Service} PaymentMethodService PaymentMethodService
	 * @param {Service} PayPalService PayPalService
	 * @param {Service} Language Language
	 * @param {Service} Utilities Utilities
	 * @param {Serivce} UtilsValidation UtilsValidation
	 * @returns {Object} PayPalPrepService
	 * @ngInject
	 */
	function PayPalPrepService($q, AppData, BillingModels, BillingService, Enums, JSONValidator, PaymentService, PaymentMethodService, PayPalService, Language, Utilities, UtilsValidation) {
		var PAYPAL_AUTH = Enums.authTypes.PAYPAL,
			PAYPAL_PROVIDER = Enums.paymentProvider.PAYPAL,
			getBoolean = Utilities.getBoolean,
			returnOrDefault = UtilsValidation.returnOrDefault,
			validString = UtilsValidation.validString;
		var service = {
			initializeAndRegister: initializeAndRegister,
			registerPaymentMethod: registerPaymentMethod
		};
		return service;

		/**
		 * Initialize and Register PayPal
		 * @public
		 * @function
		 * @returns {Promise} PayPal Initialization promise
		 */
		function initializeAndRegister() {
			return $q(function(resolve) {
				if (PaymentMethodService.hasPayPal()) {
					service.registerPaymentMethod();
				}
				resolve();
			});
		}

		/**
		 * Register PayPal Payment method
		 * @public
		 * @function
		 * @returns {undefined}
		 */
		function registerPaymentMethod() {
			var shortcutOptions,
				appDataSettings = AppData.settings,
				paymentMethod = new BillingModels.PaymentMethod(PAYPAL_PROVIDER, PAYPAL_AUTH, 'paypal-payment.png'),
				expressCheckoutConfig = JSONValidator.validate('expressCheckouts', appDataSettings.expressCheckouts) ? JSON.parse(appDataSettings.expressCheckouts) : {};
			BillingService.registerPaymentMethod(paymentMethod);

			if (!(expressCheckoutConfig[PAYPAL_PROVIDER] && getBoolean(expressCheckoutConfig[PAYPAL_PROVIDER].disable))) {
				shortcutOptions = {
					authType: PAYPAL_AUTH,
					customText: Language.getLocale('ButtonLabels', 'checkout'),
					imagePath: 'images/paypal-payment.png',
					paymentProvider: PAYPAL_PROVIDER,
					styleClasses: returnOrDefault(expressCheckoutConfig[PAYPAL_PROVIDER] && expressCheckoutConfig[PAYPAL_PROVIDER].styles, '', validString)
				};
				BillingService.registerExpressPaymentMethodOption(shortcutOptions);
			}
			PaymentService.registerAlternatePaymentActions(PAYPAL_PROVIDER, PayPalService.alternatePaymentAction);
		}
	}
})();

/* eslint-disable camelcase, no-loop-func */
(function() {
	'use strict';

	angular
		.module('paypal')
		.factory('PayPalService', PayPalService);

	/**
	 * General PayPalService
	 * @param {Service} $document $document
	 * @param {Service} $location $location
	 * @param {Service} $state $state
	 * @param {Service} $timeout $timeout
	 * @param {Service} $rootScope $rootScope
	 * @param {Service} $window $window
	 * @param {Service} AppData AppData
	 * @param {Service} LegacyCart LegacyCart
	 * @param {Service} ClientInfo ClientInfo
	 * @param {Service} CustomActionService CustomActionService
	 * @param {Service} CreditCardService CreditCardService
	 * @param {Service} Embed Embed
	 * @param {Service} Enums Enums
	 * @param {Service} EnvironmentService EnvironmentService
	 * @param {Service} Language Language
	 * @param {Service} Modal Modal
	 * @param {Service} PayPalRequestService PayPalRequestService
	 * @param {Service} PaymentMethodService PaymentMethodService
	 * @param {Service} Storage Storage
	 * @param {Service} UrlUtils UrlUtils
	 * @param {Service} UserInfo UserInfo
	 * @param {Service} UtilsValidation UtilsValidation
	 * @param {Service} Utilities Utilities
	 * @returns {Object} PayPalService
	 * @ngInject
	 */
	function PayPalService($document, $location, $state, $timeout, $rootScope, $window, AppData, LegacyCart, ClientInfo, CustomActionService, CreditCardService, Embed, Enums, EnvironmentService, Language, Modal, PayPalRequestService, PaymentMethodService, Storage, UrlUtils, UserInfo, UtilsValidation, Utilities) {
		var isRealObject = UtilsValidation.isRealObject,
			validString = UtilsValidation.validString,
			validArray = UtilsValidation.validArray,
			checkProp = Utilities.safelyCheckPropertyOnObject,
			isBoolean = UtilsValidation.isBoolean,
			returnOrDefault = UtilsValidation.returnOrDefault,
			getBoolean = Utilities.getBoolean,
			getLocale = Language.getLocale,
			OK_BUTTON = Enums.buttonFlags.OK,
			CANCEL_BUTTON = Enums.buttonFlags.CANCEL,
			OK_STATUS = Enums.status.OK,
			PAYPAL_STATUS = Enums.payPalStatus,
			sessionInfo = {
				payerID: '',
				paypalID: '',
				showCheckout: false,
				token: ''
			};
		var service = {
			alternatePaymentAction: alternatePaymentAction,
			appendCartDetailsToSetExpressCheckoutRequest: appendCartDetailsToSetExpressCheckoutRequest,
			appendShippingInfoToSetExpressCheckoutRequest: appendShippingInfoToSetExpressCheckoutRequest,
			cancelPayPal: cancelPayPal,
			getDocument: getDocument,
			getPayPalSessionInfo: getPayPalSessionInfo,
			getWindow: getWindow,
			handleExpressCheckout: handleExpressCheckout,
			handlePayPalCancelled: handlePayPalCancelled,
			handlePayPalFailed: handlePayPalFailed,
			handlePayPalReturnFailed: handlePayPalReturnFailed,
			isPayPalNotInitiated: isPayPalNotInitiated,
			isPayPalReady: isPayPalReady,
			isValidPayPalSession: isValidPayPalSession,
			processGetExpressCheckoutDetails: processGetExpressCheckoutDetails,
			redirectToPaypal: redirectToPaypal,
			requestExpressCheckoutDetails: requestExpressCheckoutDetails,
			resetPayPalSession: resetPayPalSession,
			retriggerSetExpressCheckoutForPaypalPurchaseFailure: retriggerSetExpressCheckoutForPaypalPurchaseFailure,
			routeToPaymentMethod: routeToPaymentMethod,
			setCancelAndReturnUrls: setCancelAndReturnUrls,
			setPayPalSessionInfo: setPayPalSessionInfo,
			setPayPalStatus: setPayPalStatus,
			showPayPalCheckoutOption: showPayPalCheckoutOption,
			updateBilling: updateBilling,
			updatePayment: updatePayment,
			updateShipping: updateShipping
		};
		return service;

		/**
		 * Returns window
		 * @public
		 * @function
		 * @returns {Window} window
		 */
		function getWindow() {
			return $window;
		}

		/**
		 * Returns window
		 * @public
		 * @function
		 * @returns {Window} window
		 */
		function getDocument() {
			return $document[0];
		}

		/**
		 * Reset PayPal Session Info
		 * @public
		 * @function
		 * @returns {undefined}
		 */
		function resetPayPalSession() {
			sessionInfo = {
				payerID: '',
				paypalID: '',
				showCheckout: false,
				token: ''
			};
		}

		/**
		 * Payment Action for PayPal
		 * @public
		 * @function
		 * @param {Boolean} isCartPageView is called from cart
		 * @returns {undefined}
		 */
		function alternatePaymentAction(isCartPageView) {
			var device = $rootScope.isBrandMode ? Enums.deviceType.desktop : ClientInfo.deviceType,
				mobileUrl,
				normalUrl;

			if (sessionInfo.showCheckout) {
				if (validString(sessionInfo.token)) {
					if (isCartPageView) {
						$rootScope.$broadcast('triggerCheckout', LegacyCart.cartItems);
					}

					switch (device) {
					case 'mobile':
					case 'tablet':
						mobileUrl = Enums.routes.PAYPAL_MOBILE_CHECKOUT + sessionInfo.token;
						if (!EnvironmentService.isProduction()) {
							mobileUrl = Enums.routes.PAYPAL_SANDBOX_MOBILE_CHECKOUT + sessionInfo.token;
						}
						$rootScope.showSpinner(getLocale('ApplicationLabels', 'redirectingToPayPal'));
						service.getWindow().location = mobileUrl;
						break;
					case 'desktop':
					default:
						normalUrl = Enums.routes.PAYPAL_CHECKOUT + sessionInfo.token;
						if (!EnvironmentService.isProduction()) {
							normalUrl = Enums.routes.PAYPAL_SANDBOX_CHECKOUT + sessionInfo.token;
						}

						if (getBoolean(AppData.settings.show_paypal_verified_modal_for_deferred_pkgs) && LegacyCart.checkForDeferredPayment()) {
							Modal.displayModal({
								action: 'Window Opened',
								buttonFlags: [CANCEL_BUTTON, OK_BUTTON],
								callback: function(detail) {
									if (detail === OK_BUTTON) {
										service.redirectToPaypal(normalUrl);
									}
								},
								category: 'PayPal',
								description: getLocale('PayPal', 'deferredPaypalVerificationMsg'),
								label: 'Window Opened',
								showCloseButton: false,
								title: getLocale('PayPal', 'windowOpenedTitle')
							});
						} else {
							service.redirectToPaypal(normalUrl);
						}
						break;
					}
				}
			} else {
				Modal.displayModal({
					action: 'Error',
					buttonFlags: [OK_BUTTON],
					category: 'PayPal',
					description: Language.getLocale('Alert', 'errorWithPayPalMsg'),
					label: 'Set Express Checkout',
					title: Language.getLocale('Alert', 'errorWithPayPalTitle')
				});
			}
		}

		/**
		 * Redirects to PayPal
		 * @public
		 * @function
		 * @param {String} url url
		 * @returns {undefined}
		 */
		function redirectToPaypal(url) {
			var win,
				doc = service.getDocument();

			if ($rootScope.isBrandMode) {
				$rootScope.showSpinner();
				service.getWindow().open(url, $rootScope.isBrandMode ? '_top' : '');
				return;
			}

			win = service.getWindow().open(url);
			$rootScope.showSpinner(getLocale('PayPal', 'windowOpenedTitle'));
			$timeout(function watchWindow() {
				if (win.closed) {
					$rootScope.showSpinner(getLocale('PayPal', 'windowOpenedTitle'));
					Modal.hideModal();
					service.requestExpressCheckoutDetails();
				} else {
					$timeout(watchWindow, 500);
				}
			}, 500);

			$timeout(function watchDocument() {
				if (doc.visibilityState === 'visible' && !win.closed) {
					Modal.hideModal();
					$rootScope.hideSpinner();
					service.handlePayPalFailed();
				} else {
					$timeout(watchDocument, 500);
				}
			}, 500);
		}

		/**
		 * Request Express Checkout Details
		 * @public
		 * @function
		 * @returns {undefined}
		 */
		function requestExpressCheckoutDetails() {
			PayPalRequestService
				.getExpressCheckoutDetails(sessionInfo.token)
				.then(function(response) {
					var paypalResponseStatus = response.paypal_status;
					$rootScope.hideSpinner();
					if (response.status === OK_STATUS) {
						if (paypalResponseStatus === PAYPAL_STATUS.complete) {
							service.processGetExpressCheckoutDetails(response);
							if (!CustomActionService.actionRegistered(CustomActionService.ACTIONS_ENUMS.PURCHASE_CATCHALL_FAILURE_ERROR_MODAL_CALLBACK)) {
								CustomActionService.registerCustomAction(CustomActionService.ACTIONS_ENUMS.PURCHASE_CATCHALL_FAILURE_ERROR_MODAL_CALLBACK, service.retriggerSetExpressCheckoutForPaypalPurchaseFailure);
							}
						} else if (paypalResponseStatus === PAYPAL_STATUS.cancelled) {
							// cancel PayPal
							service.handlePayPalCancelled();
						} else {
							service.handlePayPalFailed();
						}
					} else {
						service.handlePayPalFailed();
					}
				});
		}

		/**
		 * Handles PayPal window closed, express checkout call failure
		 * @public
		 * @function
		 * @returns {undefined}
		 */
		function handlePayPalFailed() {
			Modal.displayModal({
				action: 'Window Opened',
				buttonFlags: [CANCEL_BUTTON],
				callback: function(detail) {
					// if condition required as hideModal from service.redirectToPaypal calls the callback
					if (detail === CANCEL_BUTTON) {
						service.handlePayPalCancelled();
					}
				},
				category: 'PayPal',
				description: getLocale('PayPal', 'incompletePayPalTransactionMsg'),
				label: 'Window Opened',
				showCloseButton: false,
				title: getLocale('PayPal', 'incompletePayPalTransactionTitle')
			});
		}

		/**
		 * Process the GetExpressCheckoutDetails response
		 * @public
		 * @function
		 * @param {Object} data response data
		 * @returns {undefined}
		 */
		function processGetExpressCheckoutDetails(data) {
			var shippingMethods,
				shipping,
				billing,
				payment,
				myUpdateCartCheckoutInfoData;
			$rootScope.showSpinner(getLocale('PayPal', 'windowOpenedTitle'));
			Storage.set('GetPaypalExpressDetails', data);

			// Update PayPal information
			service.setPayPalSessionInfo({ paypalID: data.paypal_id });

			/**
			 *	Shipping and PayPal.
			 *	- if there is more than one shipping method, we need check
			 *		- if there is a shipping defined already, updateCartCheckoutInfo
			 *		- else, go to shipping.
			 *	- if there is only one shipping , we need to determine if we have done the shipping prior.
			 *		- set it as the default.
			 *	If we did, we can jump to
			 *
			 */
			shippingMethods = LegacyCart.getShippingMethods();
			shipping = UserInfo.get('shipping');

			// if we have shipping but not have valid shipping then set some variables
			// (FYI - shipping method and price gets set once the user walks through shipping or  via below if we only have one shipping method)
			// otherwise the user will be going through shipping to determine their shipping type if there are more than one shipping method
			if (isRealObject(shipping) && !shipping.valid) {
				if (validArray(shippingMethods)) {
					/*
					 * Ensure shipping information before setting as valid
					 * We can hit this logic if the Paypal button on Cart view is clicked
					 * AND if there is a single (physical) shipping method
					 * Then we would set it to valid without any shipping info
					 */
					if (!Utilities.isEmpty(shipping) && shippingMethods.length === 1) {
						shipping.valid = true;
					}

					//set it to the first shipping method - we will only set the valid property to true if there is only one shipping method
					shipping.deliveryMethod = shippingMethods[0].ship_method;
					shipping.deliveryAmount = shippingMethods[0].price;
				} else {
					//set dummy variables for UpdateCartCheckoutInfo and leave valid to false
					//these are the legacy dummy variables
					shipping.deliveryMethod = 'M';
					shipping.deliveryAmount = '0.00';
				}
			} else if (angular.isUndefined(shipping)) {
				//set a dummy object for UpdateCartCheckoutInfo
				shipping = {
					deliveryAmount: '0.00',
					deliveryMethod: 'M',
					valid: false
				}
			}

			// Need to get any shipping information and pass it in for now.
			billing = service.updateBilling(data);
			payment = service.updatePayment(shipping);

			// Only use paypal shipping information if not already valid
			if (!shipping.valid) {
				service.updateShipping(data, shipping)
			}

			// Apply the PayPal information to the necessary data points for purchase.
			UserInfo.set('billing', billing);
			UserInfo.set('payment', payment);
			UserInfo.set('shipping', shipping);

			myUpdateCartCheckoutInfoData = {
				shippingAmount: UserInfo.payment.shipAmount,
				shippingMethod: UserInfo.payment.shipMethod,
				skip_requests: 'SetExpressCheckout'
			};

			if (UserInfo.payment.merchant_payment_type_ref_id) {
				myUpdateCartCheckoutInfoData.merchant_payment_type_ref_id = UserInfo.payment.merchant_payment_type_ref_id;
			} else {
				myUpdateCartCheckoutInfoData.billingId = UserInfo.payment.billingId;
			}

			LegacyCart.callUpdateCartCheckoutInfo(myUpdateCartCheckoutInfoData, LegacyCart.processUpdateCartCheckoutInfo, service.handlePayPalReturnFailed);
		}

		/**
		 * Update Billing Info
		 * @public
		 * @function
		 * @param {Object} data express checkout details
		 * @returns {Object} updated billing
		 */
		function updateBilling(data) {
			// Define the billing information from PayPal.
			// Use the BILLING_INFO node info if we have it, otherwise default back to shipping info
			var modelForBilling = isRealObject(data.BILLING_INFO) && Object.keys(data.BILLING_INFO).length > 1 ? data.BILLING_INFO: data.SHIPPING_INFO;
			return {
				address: modelForBilling.street,
				address2: modelForBilling.street2,
				city: modelForBilling.city,
				country: modelForBilling.country,
				email: data.BUYER_INFO.email,
				emailVerify: data.BUYER_INFO.email,
				firstName: data.BUYER_INFO.first_name,
				lastName: data.BUYER_INFO.last_name,
				mobile: modelForBilling.phone,
				phone: data.BUYER_INFO.phone_number,
				state: modelForBilling.state,
				valid: true,
				zip: modelForBilling.zip
			};
		}

		/**
		 * Update Payment Info
		 * @public
		 * @function
		 * @param {Object} shipping shipping details
		 * @returns {Object} updated payment
		 */
		function updatePayment(shipping) {
			// Get the billing details for the payment - Specific to paypal
			var paymentBillingDetails = LegacyCart.getBillingDetailsByName(AppData.GetMerchantDetails, 'PayPal');
			/**
			 * Define the Payment Information.
			 * based on AppData.payment
			 */
			var payment = {
				authType: paymentBillingDetails.auth_type,
				billingType: paymentBillingDetails.billing_type,
				cardExpirationDate: '',
				cepayMerchantId: paymentBillingDetails.cepay_merchant_id,
				number: 'null',
				securityCode: 'null',
				shipAmount: shipping.deliveryAmount,
				shipMethod: shipping.deliveryMethod,
				type: Enums.paymentProvider.PAYPAL,
				valid: true
			};

			if (paymentBillingDetails.merchant_payment_type_ref_id) {
				payment.merchant_payment_type_ref_id = paymentBillingDetails.merchant_payment_type_ref_id;
			} else {
				payment.billingId = paymentBillingDetails.billing_id;
			}

			return payment;
		}

		/**
		 * Update Shipping Info
		 * @public
		 * @function
		 * @param {Object} data express checkout details
		 * @param {Object} shipping shipping details
		 * @returns {Object} updated payment
		 */
		function updateShipping(data, shipping) {
			shipping.firstName = data.BUYER_INFO.first_name;
			shipping.middleInitial = data.BUYER_INFO.middle_name;
			shipping.lastName = data.BUYER_INFO.last_name;
			shipping.email = data.BUYER_INFO.email;
			shipping.phone = data.BUYER_INFO.phone_number.replace(/\-+/g, '');
			shipping.city = data.SHIPPING_INFO.city;
			shipping.country = data.SHIPPING_INFO.country;
			shipping.state = data.SHIPPING_INFO.state;
			shipping.address = data.SHIPPING_INFO.street;
			shipping.address2 = data.SHIPPING_INFO.street2;
			shipping.zip = data.SHIPPING_INFO.zip;
		}

		/**
		 * Update PayPal status to BE
		 * @public
		 * @function
		 * @param {Number} status status
		 * @returns {undefined}
		 */
		function setPayPalStatus(status) {
			PayPalRequestService
				.setPayPalStatus(sessionInfo.token, status)
				.then(function(response) {
					if (response.status === OK_STATUS) {
						service.requestExpressCheckoutDetails();
					}
				});
		}

		/**
		 * Handle Paypal Failed
		 * @public
		 * @function
		 * @returns {undefined}
		 */
		function handlePayPalCancelled() {
			Modal.displayModal({
				action: 'Error',
				buttonFlags: [OK_BUTTON],
				callback: function() {
					// Force a SetExpressCheckout to get a new token for a new PayPal session.
					$rootScope.showSpinner();
					service
						.handleExpressCheckout()
						.then(function() {
							/**
							 * If the user is currently at the paypalCancelled redirect, lets go back to the cart
							 */
							$rootScope.hideSpinner();
							if ($state.current.name === '/paypalCancelled') {
								$rootScope.routeTo(Enums.routes.CART);
							}
						});
				},
				category: 'Cart',
				description: getLocale('Alert', 'paypalCancelledMsg'),
				icon: 'icon-info red',
				label: 'PayPal Session Cancelled',
				showCloseButton: false,
				title: getLocale('Alert', 'paypalCancelledTitle')
			});
		}

		/**
		 * Handle PayPal return failed - Mobile flow
		 * @public
		 * @function
		 * @returns {undefined}
		 */
		function handlePayPalReturnFailed() {
			$rootScope.hideSpinner();
			Modal.displayModal({
				action: 'Error',
				buttonFlags: [OK_BUTTON],
				callback: function() {
					$rootScope.routeTo(Enums.routes.CART);
				},
				category: 'PayPal',
				description: getLocale('Alert', 'failedUpdateCheckoutInfoMsg'),
				title: getLocale('Alert', 'failedUpdateCheckoutInfoTitle')
			});
		}

		/**
		 * Retrigger Set Express Checkout call on Purchase Failure
		 * @public
		 * @function
		 * @returns {undefined}
		 */
		function retriggerSetExpressCheckoutForPaypalPurchaseFailure() {
			var paymentInfo = UserInfo.get('payment');
			if (paymentInfo.authType === Enums.authTypes.PAYPAL) {
				$rootScope.showSpinner();
				service
					.handleExpressCheckout()
					.then(service.routeToPaymentMethod);
			} else {
				service.routeToPaymentMethod();
			}
		}

		/**
		 * Route to payment method selection screen
		 * @public
		 * @function
		 * @returns {undefined}
		 */
		function routeToPaymentMethod() {
			$rootScope.routeTo(Enums.routes.PAYMENT_METHOD);
		}

		/**
		 * Set's PayPal session info
		 * @public
		 * @function
		 * @param {Object} info session info
		 * @returns {undefined}
		 */
		function setPayPalSessionInfo(info) {
			if (checkProp('info.showCheckout', info, isBoolean)) {
				sessionInfo.showCheckout = info.showCheckout;
			}
			if (checkProp('info.token', info, validString)) {
				sessionInfo.token = info.token;
			}
			if (checkProp('info.payerID', info, validString)) {
				sessionInfo.payerID = info.payerID;
			}
			if (checkProp('info.paypalID', info, validString)) {
				sessionInfo.paypalID = info.paypalID;
			}
		}

		/**
		 * Returns PayPal Session Info
		 * @public
		 * @function
		 * @returns {Object} session info
		 */
		function getPayPalSessionInfo() {
			return sessionInfo;
		}

		/**
		 * Checks if PayPal is ready
		 * @public
		 * @function
		 * @returns {Boolean} true when ready
		 */
		function isPayPalReady() {
			return PaymentMethodService.hasPayPal() && validString(sessionInfo.token);
		}

		/**
		 * Check if the user is in a valid PayPal session
		 * @public
		 * @function
		 * @returns {Boolean} true if in valid session
		 */
		function isValidPayPalSession() {
			return service.isPayPalReady() && validString(sessionInfo.paypalID);
		}

		/**
		 * Returns if PayPal is not initiated
		 * @public
		 * @function
		 * @returns {Boolean} true if not inititated
		 */
		function isPayPalNotInitiated() {
			return service.isPayPalReady() && !validString(sessionInfo.paypalID);
		}

		/**
		 * Determine whether or not to show PayPal
		 * @public
		 * @function
		 * @returns {Boolean} true if we have to show PayPal
		 */
		function showPayPalCheckoutOption() {
			return service.isPayPalReady() && !validString(CreditCardService.getCardTypeRequired(LegacyCart.cartItems)) && getBoolean(returnOrDefault(AppData.settings.display_paypal_cart_button, true)) && sessionInfo.showCheckout;
		}

		/**
		 * Handles Express Checkout
		 * @public
		 * @function
		 * @param {Boolean} overrideFlag override flag
		 * @param {Object} [req] The request object if you want to send your own.
		 * @returns {Promise} Express Checout Promise
		 */
		function handleExpressCheckout(overrideFlag, req) {
			service.cancelPayPal();

			return Embed.getParentUrl().then(function onParentUrl(parentUrl) {
				var details = LegacyCart.cartDetails,
					shouldSendNoShoppingFlag = isBoolean(overrideFlag) ? overrideFlag : UserInfo.areOnlyFreeDeliveryMethodsConfigured(),
					request = req || {},
					cartData = AppData.cart,
					appendParams = angular.merge(angular.copy($location.search()), {
						cart_id: cartData.cart_id,
						cart_key: cartData.cart_key,
						session_id: cartData.session_id
					});

				if (req || (checkProp('details.total', details) && parseFloat(details.total) > 0)) {
					service.appendCartDetailsToSetExpressCheckoutRequest(request);

					if (shouldSendNoShoppingFlag) {
						request.no_shipping = '1';
					} else {
						service.appendShippingInfoToSetExpressCheckoutRequest(request);
					}

					if (($rootScope.isBrandMode && parentUrl) || ClientInfo.deviceType !== Enums.deviceType.desktop) {
						service.setCancelAndReturnUrls(request, appendParams, $rootScope.isBrandMode, parentUrl);
					}

					return PayPalRequestService
						.requestSetExpressCheckout(request)
						.then(function onSetExpressCheckoutResponse(res) {
							if (res.status === OK_STATUS) {
								service.setPayPalSessionInfo({
									showCheckout: true,
									token: res.token
								});
							} else {
								service.setPayPalSessionInfo({
									showCheckout: false,
									token: ''
								});
							}
							$rootScope.$emit(Enums.events.checkExpressPaymentStatus);
						})
						.catch(angular.noop);
				}
			});
		}

		/**
		 * Sets the cancel and return urls
		 * @param {Object} request The request object
		 * @param {Object} appendParams The query params to add to the return urls
		 * @param {Boolean} isBrandMode If we're in brand mode
		 * @param {String} parentUrl The parent url
		 * @returns {undefined}
		 */
		function setCancelAndReturnUrls(request, appendParams, isBrandMode, parentUrl) {
			var queryParams,
				fullPath,
				$win;

			if (isBrandMode) {
				fullPath = parentUrl.split('?')[0];
				// Remove query params that wont mess with routing when coming back
				[
					'brandmode',
					'brandmodenav',
					'promo_code',
					'promoCode',
					'package',
					'packageID',
					'package_id',
					'profile_email',
					'profile_temp_password',
					'swap_token',
					'cultural_member_benefits',
					'flow',
					'keywordforfolio',
					'gift_membership',
					'open_promo_box',
					'open_knowledge_base'
				].forEach(function removeSpecificLaunchPrams(key) {
					delete appendParams[key];
				});
				appendParams.module = Enums.routes.PAYPAL_RETURN_URL;
				queryParams = UrlUtils.objectToQueryParams(appendParams);
				request.return_url = fullPath + '?' + queryParams;

				appendParams.module = Enums.routes.PAYPAL_CANCEL_URL;
				queryParams = UrlUtils.objectToQueryParams(appendParams);
				request.cancel_url = fullPath + '?' + queryParams;
				return;
			}
			$win = service.getWindow();
			queryParams = '?' + UrlUtils.objectToQueryParams(appendParams);
			request.return_url = $win.location.protocol + '//' + $win.location.host + '/' + Enums.routes.PAYPAL_RETURN_URL + queryParams;
			request.cancel_url = $win.location.protocol + '//' + $win.location.host + '/' + Enums.routes.PAYPAL_CANCEL_URL + queryParams;
		}

		/**
		 * Appends cart details to request
		 * @public
		 * @function
		 * @param {Object} request request object
		 * @returns {undefined}
		 */
		function appendCartDetailsToSetExpressCheckoutRequest(request) {
			var details = LegacyCart.cartDetails,
				requestMappingItem,
				mapper = 'CART_DETAILS_MAPPING_FOR_SET_EXPRESS_CHECKOUT' + (LegacyCart.useCartViewTotalCalculation ? '' : '_LEGACY'),
				i,
				finalPropertyToAttachToRequest;
			for (i in Enums[mapper]) {
				requestMappingItem = Enums[mapper][i];

				if (Utilities.safelyCheckPropertyOnObject(requestMappingItem.propertyOnCartDetails, details)) {
					finalPropertyToAttachToRequest = {};
					requestMappingItem.propertyOnCartDetails.split('.').forEach(function(prop, index) {
						if (index === 1) {
							finalPropertyToAttachToRequest = details[prop];
						} else if (index > 1) {
							if (prop === 'ITEMS') {
								//remove hashkey as it will break XML and to be safe make a copy so we don't affect the other one
								finalPropertyToAttachToRequest = angular.copy(finalPropertyToAttachToRequest[prop]);
								if (angular.isDefined(finalPropertyToAttachToRequest.ITEM)) {
									if (LegacyCart.useCartViewTotalCalculation) {
										finalPropertyToAttachToRequest.ITEM = finalPropertyToAttachToRequest.ITEM.filter(function(item) {
											return !getBoolean(item.is_deposit);
										});
									}

									finalPropertyToAttachToRequest.ITEM.forEach(function(i) {
										if (angular.isDefined(i.$$hashKey)) {
											delete i.$$hashKey;
										}
									});
								}
							} else {
								finalPropertyToAttachToRequest = finalPropertyToAttachToRequest[prop];
							}
						}
					});
					request[i] = angular.isDefined(requestMappingItem.valueIfPresent) ? requestMappingItem.valueIfPresent : finalPropertyToAttachToRequest;
				}
			}
		}

		/**
		 * Assess and append the shipping information to the SetExpressCheckoutRequest
		 * @public
		 * @param {Object} request request obj
		 * @returns {undefined}
		 */
		function appendShippingInfoToSetExpressCheckoutRequest(request) {
			var shippingInfo = UserInfo.get('shipping');
			if (isRealObject(shippingInfo) && Object.keys(shippingInfo).length > 1 && !shippingInfo.isNonPhysicalDeliveryMethod && shippingInfo.valid) {
				request.addr_override = '1';
				request.ship_to_name = shippingInfo.firstName + (validString(shippingInfo.middleInitial) ? ' ' + shippingInfo.middleInitial + ' ' : ' ') + shippingInfo.lastName;
				request.ship_to_street = shippingInfo.address;
				request.ship_to_city = shippingInfo.city;
				request.ship_to_state = shippingInfo.state;
				request.ship_to_zip = shippingInfo.zip;
				request.ship_to_country_code = shippingInfo.country;
			}
		}

		/**
		 * Cancel PayPal
		 * @public
		 * @function
		 * @returns {undefined}
		 */
		function cancelPayPal() {
			if (service.isValidPayPalSession()) {
				LegacyCart.removeShipping();
				service.resetPayPalSession();
				Utilities.stripURLParams(sessionInfo.token);
				UserInfo.clearPaymentData();
			}
		}
	}
})();

(function() {
	'use strict';

	angular
		.module('paypal')
		.factory('PayPalRequestService', PayPalRequestService);

	/**
	 * PayPalRequestService
	 * @param {Service} AppData AppData
	 * @param {Service} Enums Enums
	 * @returns {Object} PayPalRequestService
	 * @ngInject
	 */
	function PayPalRequestService(AppData, Enums) {
		var SERVICES = Enums.services;
		var service = {
			getExpressCheckoutDetails: getExpressCheckoutDetails,
			requestSetExpressCheckout: requestSetExpressCheckout,
			setPayPalStatus: setPayPalStatus
		};

		return service;

		/**
		 * Request Express Checkout Details
		 * @public
		 * @function
		 * @param {String} token paypal token
		 * @returns {Promise} express checkout details promise
		 */
		function getExpressCheckoutDetails(token) {
			return AppData
				.fetch(SERVICES.GET_EXPRESS_CHECKOUT_DETAILS, false, { token: token }, true);
		}

		/**
		 * Requests set express checkout
		 * @public
		 * @param {Object} reqObj request object
		 * @returns {Promise} express checkout promise
		 */
		function requestSetExpressCheckout(reqObj) {
			return AppData
				.fetch(SERVICES.SET_EXPRESS_CHECKOUT, false, reqObj, true);
		}

		/**
		 * Set PayPal Status - Mobile flow
		 * @public
		 * @function
		 * @param {String} token paypal token
		 * @param {Number} status status
		 * @returns {Promise} paypal status promise
		 */
		function setPayPalStatus(token, status) {
			return AppData
				.fetch(SERVICES.SET_PAYPAL_STATUS, false, {
					status: status,
					token: token
				}, true);
		}
	}
})();
/**
 * Created by ltischuk on 7/10/15.
 */
angular.module('ideal',[])
    .config(function ($locationProvider, $stateProvider) {

        $stateProvider
            .state('ideal-bank-list', {
                url: '/idealBankList',
                templateUrl: '/scripts/modules/billing/modules/payment-methods/ideal/views/idealbanklist.html',
                controller: 'IdealBankListController',
                resolve: {
                    initialData: function (Bootstrap) {
                        return Bootstrap.bootstrapApplication();
                    }

                }
            })
});
/**
 * Created by ltischuk on 7/10/15.
 */
angular.module('ideal')
	.controller('IdealBankListController',
	function(
		BillingService,
		IdealPrepService,
		Language,
		Storage,
		Enums,
		UserInfo,
		$rootScope,
		$scope,
		$state,
		$window) {

		$scope.hasDeliveryMethods = Storage.get('_deliveryMethods');
		$scope.arrowPositioning = $scope.hasDeliveryMethods ? 2 : 1;
		$scope.banks = IdealPrepService.idealBankList;
		$scope.billing = UserInfo.get('billing');
		$scope.chosenBank = undefined;
		$scope.continueVerbiage = BillingService.isPaymentPlanCart() ? Language.getLocale('CartView','orderReviewHeading') : Language.getLocale('ButtonLabels','continueButton');
		$scope.instructions = Language.getLocale('PaymentView','idealInstructions');
		$scope.submitted = false;
		$scope.isMobile = $scope.clientInfo.deviceType === Enums.deviceType.MOBILE;
		
		var idealInfoLink = IdealPrepService.infoLink;


		/**
		 * Open the ideal link for information
		 */
		$scope.openIdealLink = function(){

			$window.open(idealInfoLink,'provider');

		}

		/**
		 * Return to the billing demographic form
		 */
		$scope.returnToBillingDemographicForm = function(){


			$rootScope.routeTo($state.href('/billingView'));

		}

		/**
		 * Continue if the user has selected a bank
		 */
		$scope.continue = function(){

			$scope.submitted = true;

			if($scope.bankForm.$valid){

				//set the bankId on the payment object for later use
				var payment = UserInfo.get('payment');
				payment.bankId = $scope.chosenBank;
				UserInfo.set('payment',payment);

				//finalize the billing checkout
				BillingService.finalizeBillingCheckout();

			}


		}
	}
);

/**
 * Created by ltischuk on 7/10/15.
 */
angular.module('ideal').service
('IdealRequestService',
	function(
		AppData,
		LegacyCart,
		Enums,
		RouteRejectionService,
		Language,
		UserInfo,
		Utilities,
		$location,
		$rootScope,
		$state) {

		/**
		 *
		 * Get the IDEAL Bank list from the backend to display to the user if IDEAL is chosen
		 * @returns {Array} - bank list
		 */
		this.getIdealBankList = function(idealBillingType, isAdyenPayment) {
			var bankList = [],
				reqObj;
			if (isAdyenPayment) {
				reqObj = {
					merchant_id: idealBillingType.cepay_merchant_id,
					amount: LegacyCart.total
				};
			} else {
				reqObj = { merchant_id: idealBillingType.cepay_merchant_id }
			}

			return AppData.fetch(Enums.services.IDEAL_GET_BANK_LIST, true, reqObj).then(function(data) {
					if (data.status === Enums.status.OK && data.bank) {
						bankList = angular.isArray(data.bank) ? data.bank : [data.bank];
					}

					return bankList;
				}, function(err) {
					return bankList;
			});
		}

		/**
		 * Handles idealAuth request
		 * @returns {resolved data from ideal auth request}
		 */
		this.getIdealAuth = function(successURL, failureURL){

			$rootScope.showSpinner( Language.getLocale('ApplicationLabels','purchaseLoadMsg'));
			var request = constructIdealAuthRequest();
			request.success_url = successURL;
			request.failure_url = failureURL;

			return AppData.fetch(
				Enums.services.IDEAL_AUTH
				, false
				, request
				, true
			).then(function(data){

					if(data.status == Enums.status.OK && data.redirect_url) {

						//set the payment on the auth type
						var payment = UserInfo.get('payment');
						payment.auth_id = data.auth_id;
						UserInfo.set('payment', payment);

						//resolve the data
						return data;

						}else{

						throw new RouteRejectionService.ViewException('Alert','errorPaymentProviderTitle','errorPaymentProviderMsg','/cartView',{});
					}

				});

		}

		/**
		 * Construct an ideal auth request
		 * @returns {{
		 * merchant_id: *,
		 * issuer_id: *,
		 * amount: (number|*),
		 * success_url: string,
		 * failure_url: string,
		 * customer: {email: *, ip: (string|*),
		 * title: string,
		 * first_name: *,
		 * last_name: *,
		 * street: *,
		 * city: *,
		 * postcode: *,
		 * country: *,
		 * language: *}
		 * }}
		 */
		function constructIdealAuthRequest(){

			var payment = UserInfo.get('payment');
			var billing = UserInfo.get('billing');


			return {
				merchant_id : payment.cepayMerchantId,
				issuer_id : payment.bankId,
				amount : LegacyCart.total,
				customer : {
					email : billing.email,
					ip : AppData.clientIP,
					title : 'title',
					first_name : billing.firstName,
					last_name : billing.lastName,
					street : billing.address,
					city : billing.city,
					postcode : billing.zip,
					country : billing.country,
					language : AppData.language
				}
			};
		}


	}
);

(function() {
	'use strict';

	angular
		.module('ideal')
		.factory('IdealPrepService', IdealPrepService);

	/**
	 * The Ideal Prep service.
	 * @param {Service} AppData AppData
	 * @param {Service} IdealRequestService IdealRequestService
	 * @param {Service} BillingModels BillingModels
	 * @param {Service} BillingService BillingService
	 * @param {Service} Enums Enums
	 * @param {Service} $rootScope $rootScope
	 * @param {Service} $log $log
	 * @param {Service} $state $state
	 * @returns {IdealPrepService} Our instance
	 * @ngInject
	 */
	function IdealPrepService(AppData, IdealRequestService, BillingModels, BillingService, Enums, $rootScope, $log, $state) {
		var factory = {
			idealBankList: [],
			infoLink: '',
			setupIdeal: setupIdeal
		};

		/**
		 * Configure IDEAL by obtaining the bank list from the Backend and then configuring the routing to the
		 * Ideal BankList page. This logic is abstracted here so multiple payment processors (e.g. Adyen) can route to this form.
		 * @param {Object} idealBillingType idela billing object
		 * @param {String} infoLink ideal link
		 * @param {Function} finalizeCallback callback function
		 * @param {Boolean} isAdyenPayment true if payment processor is adyen
		 * @returns {undefined}
		 */
		function setupIdeal(idealBillingType, infoLink, finalizeCallback, isAdyenPayment) {

			factory.infoLink = infoLink;

			IdealRequestService.getIdealBankList(idealBillingType, isAdyenPayment).then(function(list) {
				if (list.length > 0) {
					factory.idealBankList = list;

					// Register important route to this bank list in the main app
					BillingService.registerPostDemographicFormAction('ideal', function() {
						$rootScope.routeTo($state.href('ideal-bank-list'));
					});
					finalizeCallback();
				} else {
					$log.error('No banks returned in IDEAL_GET_BANK_LIST - unregistering billing type');
					AppData.unregisterBillingType('IDL');
				}
			});
		}

		return factory;
	}
})();

/**
 * Created by ltischuk on 7/13/15.
 */
angular.module('three-d-secure', []);

/**
 * Created by ltischuk on 7/13/15.
 */
angular.module('mistercash',[]);

/**
 * Created by ltischuk on 7/13/15.
 */
angular.module('mistercash').service
('MistercashRequestService',
	function(
		AppData,
		LegacyCart,
		Enums,
		RouteRejectionService,
		Language,
		UserInfo,
		Utilities,
		$location,
		$rootScope,
		$state) {

		/**
		 * Handles Mistercash Auth request
		 * Backend has since abstracted this into a more generic PrePurchaseAuth call
		 * @returns {resolved data from auth request}
		 */
		this.getMistercashAuth = function(successURL, failureURL){

			$rootScope.showSpinner( Language.getLocale('ApplicationLabels','purchaseLoadMsg'));
			var request = constructMistercashAuthRequest();
			request.success_url = successURL;
			request.failure_url = failureURL;

			return AppData.fetch(
				Enums.services.MRCASH_AUTH
				, false
				, request
				, true
			).then(function(data){

					if(data.status == Enums.status.OK && data.redirect_url) {

						//set the payment on the auth type
						var payment = UserInfo.get('payment');
						payment.auth_id = data.auth_id;
						UserInfo.set('payment', payment);

						//resolve the data
						return data;

					}else{

						throw new RouteRejectionService.ViewException('Alert','errorPaymentProviderTitle','errorPaymentProviderMsg','/paymentMethod',{});
					}

				});

		}

		/**
		 * Construct an auth request
		 * @returns {{
		 * merchant_id: *,
		 * issuer_id: *,
		 * amount: (number|*),
		 * success_url: string,
		 * failure_url: string,
		 * customer: {email: *, ip: (string|*),
		 * title: string,
		 * first_name: *,
		 * last_name: *,
		 * street: *,
		 * city: *,
		 * postcode: *,
		 * country: *,
		 * language: *}
		 * }}
		 */
		function constructMistercashAuthRequest(){

			var payment = UserInfo.get('payment');
			var billing = UserInfo.get('billing');


			return {
				merchant_id : payment.cepayMerchantId,
				amount : LegacyCart.total,
				customer : {
					email : billing.email,
					ip : AppData.clientIP,
					title : 'title',
					first_name : billing.firstName,
					last_name : billing.lastName,
					street : billing.address,
					city : billing.city,
					postcode : billing.zip,
					country : billing.country,
					language : AppData.language
				}
			};
		}


	}
);

/**
 * Created by ltischuk on 2/21/17.
 */
angular
	.module('stored-value-card', [])
	.config(function($locationProvider, $stateProvider){
		$stateProvider
			.state('stored-value-check-balance-reload', {
				url: '/check-balance-reload/{keyword:keyword}/:reload/:checkBalance',
				templateUrl: '/scripts/modules/billing/modules/stored-value-card/views/check-balance-reload.html',
				controller: 'StoredValueCardCheckBalanceReloadController',
				controllerAs: 'vm',
				resolve: {
					initialData: function(Bootstrap){
						return Bootstrap.bootstrapApplication();
					},
					loadConfiguration: function(initialData, StoredValueCardPrepService){
						return StoredValueCardPrepService.loadConfiguration();
					},
					storedValueCardPackage: function(loadConfiguration, $transition$, StoredValueCardPrepService){
						return StoredValueCardPrepService.getRequiredPackageByStateParams($transition$.params());
					},
					storedValueCardConfig: function(initialData, AppData, JSONValidator){
						if(angular.isDefined(AppData.settings.stored_value_card) && JSONValidator.validate('stored_value_card', AppData.settings.stored_value_card)){
							return JSON.parse(AppData.settings.stored_value_card);
						}
						return {};
					}
				}
			})
			.state('stored-value-attach-giftcard', {
				url: '/attach-giftcard/:packageId',
				resolve: {
					initialData: function(Bootstrap){
						return Bootstrap.bootstrapApplication();
					},
					loadConfiguration: function(initialData, StoredValueCardPrepService){
						return StoredValueCardPrepService.loadConfiguration();
					},
					assessRoutability: function(loadConfiguration, RouteRejectionService, Package, $transition$){
						var rejectionRoute = Package.assessRoutabilityOfXFC($transition$.params().packageId);
						if(rejectionRoute.length > 0){
							throw new RouteRejectionService.UnrecoverableException(rejectionRoute);
						} else {
							return true;
						}
					},
					xfcMap: function(assessRoutability, Package){
						return Package.buildXFCMap();
					},
					attachCard: function(xfcMap, StoredValueCardPrepService){
						return StoredValueCardPrepService.addGiftCard();
					}
				}
			});
	})
	.run(function(BillingService, ExtraFlow, StoredValueCardPrepService){
		ExtraFlow
			.registerXMC('SVCCheckBalanceAndReload', {
				name: 'SVCCheckBalanceAndReload',
				view: 'stored-value-check-balance-reload',
				viewIsStateName: true,
				viewDefaultArgs: {
					reload: true,
					checkBalance: true
				},
				doEditMode: false,
				lockQuantity: true,
				writeSingleCharac: false,
				enabled: true,
				type: 'alternateFlowModule'
			});

		ExtraFlow
			.registerXMC('SVCReload', {
				name: 'SVCReload',
				view: 'stored-value-check-balance-reload',
				viewIsStateName: true,
				viewDefaultArgs: {
					reload: true,
					checkBalance: false
				},
				doEditMode: false,
				lockQuantity: true,
				writeSingleCharac: false,
				enabled: true,
				type: 'alternateFlowModule'
			});

		ExtraFlow
			.registerXMC('SVCCheckBalance', {
				name: 'SVCCheckBalance',
				view: 'stored-value-check-balance-reload',
				viewIsStateName: true,
				viewDefaultArgs: {
					reload: false,
					checkBalance: true
				},
				doEditMode: false,
				lockQuantity: true,
				writeSingleCharac: false,
				enabled: true,
				type: 'alternateFlowModule'
			});

		ExtraFlow
			.registerXMC('svc_gift_card', {
				name: 'svc_gift_card',
				view: 'stored-value-attach-giftcard',
				viewIsStateName: true,
				doEditMode: false,
				lockQuantity: true,
				writeSingleCharac: false,
				enabled: true,
				type: 'extraFlowControl'
			});

		BillingService.appendPaymentMethodLoadPromise(StoredValueCardPrepService.loadConfiguration);

	})
	.value('SvcReload', 'RELOAD')
	.value('SvcRegister', 'REGISTER')
	.value('StoredValueCardsLocaleSection', 'StoredValueCards');

/**
 * Created by ltischuk on 2/21/17.
 */
angular
	.module('stored-value-card')
	.factory('StoredValueCardPrepService',
		function(AppData,
			BillingModels,
			BillingService,
			LegacyCart,
			CustomActionService,
			Enums,
			RouteRejectionService,
			JSONValidator,
			Language,
			Modal,
			Package,
			PaymentService,
			Purchase,
			ShippingService,
			Security,
			StoredValueCardRequestService,
			UserInfo,
			Utilities,
			$log,
			$rootScope,
			$q,
			SvcRegister,
			StoredValueCardsLocaleSection,
			ExtraFlow){


			var config = {};
			var isObject = angular.isObject;

			var factory = {
				createNewPaymentMethod: createNewPaymentMethod,
				loadConfiguration: loadConfiguration,
				getRequiredPackageByStateParams: getRequiredPackageByStateParams,
				addGiftCard: addGiftCard,
				get config(){
					return config;
				},
				storedValueCardFields: []
			};

			/**
			 * Require package by state params - check if params have keyword and is a reload state, we will need a package to add to the cart
			 * @param stateParams
			 * @returns {{}}
			 */
			function getRequiredPackageByStateParams(stateParams){

				//if we have a reload state, we must have a dummy package that meets the requirements (variable priced and must contain a provider id)
				if(stateParams.reload && angular.isDefined(stateParams.keyword)){

					var pkg = Package.filterPackagesByKeyword(undefined, stateParams.keyword, false)[0];

					//package must have the provider_id charac present as well as be a variable price package and have a variable price rate on the package
					if(angular.isDefined(pkg) && Utilities.safelyCheckPropertyOnObject('pkg.CHARACS.provider_id', pkg) && Utilities.getBoolean(pkg.variable_price_flag) &&
						angular.isDefined(pkg.CT)){

						return pkg;

					}else{

						$log.error('There are no packages found for the keyword or this is not a variable price package or there is no provider id configured on the package as a charac - this is required for stored value cards.');
						throw new RouteRejectionService.ViewException();
					}

				}

				return {};

			}

			/**
			 * Configure the module if we are configured for it so it is available
			 */
			function loadConfiguration(){

				return $q(function(resolve, reject){

					if(Object.keys(config).length === 0 && angular.isDefined(AppData.settings.stored_value_card) && JSONValidator.validate('stored_value_card', AppData.settings.stored_value_card)){

						config = JSON.parse(AppData.settings.stored_value_card);

						Utilities.cacheBustAndLazyLoad([
							'scripts/modules/billing/modules/stored-value-card/controllers/stored-value-card-check-balance-reload-controller.js',
							'scripts/modules/billing/modules/stored-value-card/services/stored-value-card-request-service.js',
							'scripts/modules/billing/modules/stored-value-card/directives/gift-card-capture-directive.js'
						]).then(function(){

							registerPaymentMethod();
							resolve();

						}).catch(function(err){

							$log.error('Error lazy loading stored value card modules - this payment method will not be shown');
							resolve();

						});


					}else{

						resolve();

					}

				});

			}

			/**
			 * Register the payment method
			 */
			function registerPaymentMethod() {
				var billingType,
					storedValuePaymentMethod,
					billingType = AppData.billingTypes.find(function(item) {
						return [Enums.authTypes.STOREDVALUECARD, Enums.authTypes.TESCO].indexOf(item.auth_type) !== -1;
					});

				storedValuePaymentMethod = isObject(billingType) ? factory.createNewPaymentMethod(billingType) : {};

				//if we have a billing type for this payment method, lets register important characteristics and actions
				if (angular.isDefined(billingType) && Utilities.getBoolean(config.activatePaymentProvider)){
					//officially register this item as a gift card payment method
					BillingService.registerGiftCardPaymentMethod(storedValuePaymentMethod);
				}

				//either way lets store the payment method input fields to be exposed for check balance and reload flow - this means its not married to the billing type
				factory.storedValueCardFields = angular.copy(storedValuePaymentMethod.customInputFields);


			}

			/**
			 * Create a new stored value card payment method
			 * @returns {*|PaymentMethod}
			 */
			function createNewPaymentMethod(billingType){

				//set image default value
				var image = 'stored_value_card.jpg';

				//override image and register custom action if not SVC
				if(billingType.auth_type != Enums.billingTypes.STOREDVALUECARD){
					image = billingType.auth_type.toLowerCase() + '.png';

					CustomActionService.registerCustomAction(CustomActionService.ACTIONS_ENUMS.ON_ALTERNATE_GIFT_CARD_PAYMENT, getPromoCodesForGetBalance);
				}

				var paymentMethod = new BillingModels.PaymentMethod(billingType.billing_type.toLowerCase(), billingType.auth_type, image);
				paymentMethod.ccTypeOverride = billingType.auth_type.toLowerCase();

				//set some variables for the billing information from the Backend
				if (billingType.merchant_payment_type_ref_id) {
					paymentMethod.merchant_payment_type_ref_id = billingType.merchant_payment_type_ref_id;
				} else {
					paymentMethod.billingId = billingType.billing_id;
				}
				paymentMethod.billingType = billingType.billing_type;
				paymentMethod.cepayMerchantId = billingType.cepay_merchant_id;

				//setup the card field
				var cardRegex = config.cardValidationPattern ? config.cardValidationPattern : '';
				var svcCardField = new BillingModels.CustomInputField('card_number', true, 'custom', cardRegex);
				svcCardField.useAsLastFourForOrderReview = true;
				svcCardField.isSecureInfo = true;
				svcCardField.desktopWidthClass = Utilities.getBoolean(config.displayPinEntryField) ? 'col-sm-8' : 'col-sm-12';
				svcCardField.icon = billingType.auth_type.toLowerCase();
				paymentMethod.addCustomInputField(svcCardField);

				//setup the pin field if we are configured
				if(Utilities.getBoolean(config.displayPinEntryField)){

					var pinRegex = config.pinValidationPattern ? config.pinValidationPattern : '';
					var pinField = new BillingModels.CustomInputField('pin', Utilities.getBoolean(config.requirePinEntryField), 'custom', pinRegex);
					pinField.desktopWidthClass = 'col-sm-4';
					pinField.isSecureInfo = true;
					paymentMethod.addCustomInputField(pinField);
				}

				//this payment method allows for partial payments
				var maxPartialPaymentCount = Number(factory.config.maxPartialPaymentCount);
				paymentMethod.maxPartialPaymentCount = ((!isNaN(maxPartialPaymentCount) && maxPartialPaymentCount) > 0 ? maxPartialPaymentCount : 0);
				paymentMethod.showInfoMsg = Utilities.getBoolean(config.showInfoMsg);
				paymentMethod.overridePaymentFormContinueButton = true;

				return paymentMethod;

			}

			/**
			 * Adds a gift card to a package
			 * @returns {*|Promise|Promise<U>}
			 */
			function addGiftCard(){
				return $q(function(resolve, reject){
					$rootScope.showSpinner(Language.getLocale(StoredValueCardsLocaleSection, 'attachingCard'));
					if(!Utilities.safelyCheckPropertyOnObject('Package.packageDetails.CHARACS.provider_id', Package)){
						$log.error('Missing provider_id charac');
						return reject(new RouteRejectionService.ViewException(StoredValueCardsLocaleSection, 'cardUnavailableToAddTitle', 'cardUnavailableToAddMsg', '/packageDetails/' + Package.packageDetails.id));
					}

					var package = Package.itemsToBeAddedForCurrentPackage();
					var cards = [];
					var count = 0;

					for(var i=0; i<package.length; i++) {
						for(var j=0; j<package[i].qty; j++) {
							var cardObj = {
								provider_id: Package.packageDetails.CHARACS.provider_id,
								amount: determinePriceOfItem(package[i]),
								check_type: "REGISTER",
								id: count
							};
							cards.push(cardObj);
							count++;
						}
					}

					StoredValueCardRequestService
						.handleStoredValuePrecheck(cards)
						.then(handleSuccessResponse)
						.catch(handleFailedResponse);


					function handleSuccessResponse(response) {
						if(angular.isDefined(response)) {
							if (response.constructor === Array) {
								var responseCount = 0;
								for(var i=0; i<package.length; i++) {
									for(var j=0; j<package[i].CHARACS.length; j++) {
										package[i].CHARACS[j].card_reference_code = response[responseCount].card_reference_code;
										package[i].CHARACS[j].card_precheck_type = "REGISTER";
										responseCount++;
									}
								}
							}
							else if(typeof response == 'object') {
								package[0].CHARACS[0].card_reference_code = response.card_reference_code;
								package[0].CHARACS[0].card_precheck_type = "REGISTER";
							}
						}

						ExtraFlow.addReferenceToCartItems(Package.settings.view, Package.itemsToBeAdded, ExtraFlow.CLIENT_XFC_VIEW);
						ExtraFlow.addReferenceToCartItems(Package.settings.name, Package.itemsToBeAdded, ExtraFlow.CLIENT_XFC_NAME);
						Package.nextXFC();
						resolve();
					}

					function handleFailedResponse() {
						var rejection = new RouteRejectionService.ViewException(StoredValueCardsLocaleSection, 'cardUnavailableToAddTitle', 'cardUnavailableToAddMsg', '/packageDetails/' + Package.packageDetails.id);
						return reject(rejection);
					}
				});
			}

			function determinePriceOfItem(package) {
				if(Utilities.safelyCheckPropertyOnObject('package.CHARACS.0.variable_price', package)) {
					return package.CHARACS[0].variable_price;
				}
				else {
					for(var i=0; i<Package.packageDetails.CT.length; i++) {
						if(Package.packageDetails.CT[i].id == package.customer_type) {
							return Package.packageDetails.CT[i].retail_amount;
						}
					}
				}
			}

			function getPromoCodesForGetBalance(requestObject){
				var uniquePromoCodes = [];
				LegacyCart.cartItems.filter(function(cartItem){
					if (uniquePromoCodes.indexOf(cartItem.promo_code) === -1){
						uniquePromoCodes.push(cartItem.promo_code);
						return true;
					} else {
						return false;
					}
				});

				if(!Utilities.isEmpty(uniquePromoCodes)) {
					requestObject.promo_codes = uniquePromoCodes.toString();
				}

			}

			return factory;

		}
);

/**
 * Created by ltischuk on 2/24/17.
 */
(function () {
	'use strict';

	angular
		.module('stored-value-card')
		.service('StoredValueCardRequestService', StoredValueCardRequestService);

	function StoredValueCardRequestService(AppData, Enums, Utilities, LegacyCart, $q, CustomActionService, Modal, $rootScope, Language, UserInfo) {
		this.getStoredValueBalance = getStoredValueBalance;
		this.handleStoredValuePrecheck = handleStoredValuePrecheck;

		////////////////

		/**
		 * Retrieve a stored value card balance
		 * @param fields
		 * @param [cardNumber]
		 * @param [pin]
		 * @param billingType distinguishes between SVC and TSC
		 * @param secuirtyCheck tired to stored_value_card config entry 'security_check'
		 * @returns {*|Promise|Promise<U>}
		 */
		function getStoredValueBalance(fields, cardNumber, pin, billingType, doSecurityCheck) {
			var req = { CARD: {} };

			if(angular.isDefined(fields)) {
				fields.forEach(function(fld){
					req.CARD[fld.fieldName] = fld.fieldValue;
				});
			}else {
				//set the values for the request on the optional input if provided
				req.CARD.card_number = cardNumber;
				if(angular.isDefined(pin)) {
					req.CARD.pin = pin;
				}
				req.CARD.billing_type = billingType;
				if(doSecurityCheck) {
					var billing = UserInfo.get('billing');
					req.CARD.postcode = billing.zip;
					req.CARD.last_name = billing.lastName;
				}

				if (CustomActionService.actionRegistered(CustomActionService.ACTIONS_ENUMS.ON_ALTERNATE_GIFT_CARD_PAYMENT)){
					CustomActionService.executeCustomAction(CustomActionService.ACTIONS_ENUMS.ON_ALTERNATE_GIFT_CARD_PAYMENT, undefined, [req.CARD]);
				}
			}

			return AppData.fetch('GetStoredValueBalance', false, req)
				.then(function(response) {
					if (Utilities.safelyCheckPropertyOnObject('response.status', response) && response.status === Enums.status.OK && Utilities.safelyCheckPropertyOnObject('response.CARD', response)) {
						return response.CARD;
					} else {
						$rootScope.hideSpinner();
						if(Utilities.safelyCheckPropertyOnObject('response.CARD.error_code', response) && !Utilities.isEmpty(response.CARD.error_code)){
							Modal.displayErrorModal(response.CARD);
						} else {
							displayGenericErrorModal();
						}
						return handleGenericPromiseRejection();
					}
				})
				.catch(handleGenericPromiseRejection);
		}

		/**
		 *
		 * @param cards
		 * @returns {*|Promise|Promise<U>}
		 */
		function handleStoredValuePrecheck(cards){
			var request = {
				CARD: []
			}

			for(var i=0; i<cards.length; i++) {
				request.CARD.push(cards[i]);
			}

			return AppData.fetch('StoredValuePreCheck', false, request)
				.then(function(response){
					if (Utilities.safelyCheckPropertyOnObject('response.status', response) && response.status === Enums.status.OK && Utilities.safelyCheckPropertyOnObject('response.CARD', response)) {
						return response.CARD;
					} else {
						return handleGenericPromiseRejection();
					}
				})
				.catch(handleGenericPromiseRejection);
		}

		/**
		 * display generic failure modal
		 * @returns {*}
		 */
		function displayGenericErrorModal(){

			Modal.displayModal(
				{
					category: 'Stored Value Card'
					, action: 'Stored Value Card Balance Failure'
					, label: 'Stored Value Card Balance Failure'
					, title: Language.getLocale('StoredValueCard', 'storedValueBalanceFailTitle')
					, description: Language.getLocale('StoredValueCard', 'storedValueBalanceFailMsg')

				}
			);


		}

		/**
		 * Handle a generic failure
		 * @returns {*}
		 */
		function handleGenericPromiseRejection(){

			return $q.reject();

		}
	}

})();



angular
	.module('cultural-member-benefits', ['app', 'components', 'profile'])
	.config(function($locationProvider, $stateProvider, ComponentLoaderEnums) {
		var CULTURAL_MEMBER_BENEFITS_MODULE = '/scripts/modules/cultural-member-benefits',
			COMPONENT_MODULE = '/scripts/components/';
		$stateProvider
			.state('cultural-member-benefits', {
				abstract: true,
				components: [ComponentLoaderEnums.accessoCalendar, ComponentLoaderEnums.mobileCta],
				url: '/cultural-member-benefits',
				template: '<div ui-view></div>',
				resolve: {
					load: function($rootScope, Utilities) {
						$rootScope.showSpinner();

						return Utilities.cacheBustAndLazyLoad([
							CULTURAL_MEMBER_BENEFITS_MODULE + '/cultural-member-benefits-models.js',
							CULTURAL_MEMBER_BENEFITS_MODULE + '/services/cultural-member-benefits-prep-service.js',
							CULTURAL_MEMBER_BENEFITS_MODULE + '/services/cultural-member-benefits-request-service.js',
							CULTURAL_MEMBER_BENEFITS_MODULE + '/services/cultural-member-benefits-selection-service.js',
							CULTURAL_MEMBER_BENEFITS_MODULE + '/controllers/cultural-member-benefits-selection-controller.js',
							CULTURAL_MEMBER_BENEFITS_MODULE + '/controllers/cultural-member-benefits-selection-category-controller.js',
							CULTURAL_MEMBER_BENEFITS_MODULE + '/controllers/cultural-member-benefits-selection-product-controller.js',
							CULTURAL_MEMBER_BENEFITS_MODULE + '/controllers/cultural-member-benefits-selection-event-controller.js',
							CULTURAL_MEMBER_BENEFITS_MODULE + '/services/cultural-member-benefits-tracking-service.js'
						]);
					},
					//resolve failures are handled within run.js of main app
					initialData: function(load, Bootstrap) {
						return Bootstrap.bootstrapApplication();
					},
					config: function(initialData, $injector) {
						return $injector.get('CulturalMemberBenefitsPrepService').getConfigurationSettings();
					}
				}
			})
			.state('cultural-member-benefits.selection', {
				url: '/selection',
				abstract: true,
				controller: 'CulturalMemberBenefitsSelectionController',
				templateUrl: '/scripts/modules/cultural-member-benefits/views/selection.html',
				controllerAs: 'vm',
				resolve: {
					load: function(config, $rootScope, Utilities) {
						$rootScope.showSpinner();
						return Utilities.cacheBustAndLazyLoad([
							CULTURAL_MEMBER_BENEFITS_MODULE + '/styles/selection.css',
							COMPONENT_MODULE + 'predictive-search/predictive-search-component.js',
							COMPONENT_MODULE + 'predictive-search/predictive-search-component-controller.js'
						]);
					},
					assessLogin: function(load, CulturalMemberBenefitsPrepService) {
						// if we are not logged in, go back to login
						return CulturalMemberBenefitsPrepService.assessLoginAtRoute('profile-login.signin', { showSignInOnly: true });
					},
					assessAbilityToRedeemBenefits: function(assessLogin, CulturalMemberBenefitsPrepService) {
						return CulturalMemberBenefitsPrepService.assessAbilityToRedeemBenefits();
					},
					getInitialPackages: function(assessAbilityToRedeemBenefits, CulturalMemberBenefitsSelectionService, UserInfo) {
						return CulturalMemberBenefitsSelectionService.getPackagesForSelectedDate(UserInfo.get('memberBenefitsGuestNumber'), true)
							.catch(function(error) {
								if (error && error.errorCode === '21') {
									// The stored guest has no active passes; the service already set up a
									// fallback repo scoped to that guest.  Let the route resolve so the
									// selection view can render the empty-benefits state.
									return;
								}
								throw error;
							});
					},
					calendarOptions: function(getInitialPackages, AccessoCalendarDataService) {
						return {
							limitedThreshold: AccessoCalendarDataService.getLimitedAvailabilityThreshold(),
						};
					}
				}
			})
			.state('cultural-member-benefits.selection.category', {
				url: '',
				controller: 'CulturalMemberBenefitsSelectionCategoryController',
				templateUrl: '/scripts/modules/cultural-member-benefits/views/selection-category.html'
			})
			.state('cultural-member-benefits.selection.products', {
				url: '/products/:category',
				controller: 'CulturalMemberBenefitsSelectionProductController',
				templateUrl: '/views/packageList.html',
				resolve: {
					assessCurrentSelection: function(getInitialPackages, RouteRejectionService, CulturalMemberBenefitsSelectionService) {
						if (!angular.isObject(CulturalMemberBenefitsSelectionService.getCurrentSelection().selectedCategory)) {
							throw new RouteRejectionService.UnrecoverableException('cultural-member-benefits.selection.category', {});
						} else {
							return true;
						}
					}
				}
			})
			.state('cultural-member-benefits.events', {
				url: '/selection/events',
				controller: 'CulturalMemberBenefitsSelectionEventController',
				controllerAs: 'vm',
				templateUrl: '/scripts/modules/cultural-member-benefits/views/selection-event.html',
				resolve: {
					load: function(config, Utilities) {
						return Utilities.cacheBustAndLazyLoad([
							CULTURAL_MEMBER_BENEFITS_MODULE + '/styles/selection-event.css',
							COMPONENT_MODULE + 'timed-event/timed-event-component.css',
							COMPONENT_MODULE + 'timed-event/timed-event-component.js',
							COMPONENT_MODULE + 'timed-event/timed-event-component-controller.js',
							'scripts/modules/calendar-pricing/calendar-pricing.css'
						]);
					},
					assessLogin: function(load, CulturalMemberBenefitsPrepService) {
						// if we are not logged in, go back to login
						return CulturalMemberBenefitsPrepService.assessLoginAtRoute('profile-login.signin', { showSignInOnly: true });
					},
					assessAbilityToRedeemBenefits: function(assessLogin, CulturalMemberBenefitsPrepService) {
						return CulturalMemberBenefitsPrepService.assessAbilityToRedeemBenefits();
					},
					assessIsNewFlow: function(assessAbilityToRedeemBenefits, config, RouteRejectionService, CulturalMemberBenefitsPrepService, Utilities) {
						if (!Utilities.getBoolean(CulturalMemberBenefitsPrepService.config.is_new_flow)) {
							throw new RouteRejectionService.UnrecoverableException('cultural-member-benefits.selection.category', {});
						}
					},
					getInitialPackages: function(assessIsNewFlow, RouteRejectionService, CulturalMemberBenefitsSelectionService, CulturalMemberBenefitsPrepService) {
						if (!CulturalMemberBenefitsPrepService.getLoadPackages()) {
							throw new RouteRejectionService.UnrecoverableException('cultural-member-benefits.selection.category', {});
						}
						CulturalMemberBenefitsPrepService.resetLoadPackages();
						if (!CulturalMemberBenefitsSelectionService.getCurrentSelection().chosenMembershipBenefitRepo) {
							return CulturalMemberBenefitsSelectionService.getPackagesForSelectedDate(undefined, true);
						}
					},
					assessCurrentSelection: function(getInitialPackages, RouteRejectionService, CulturalMemberBenefitsSelectionService) {
						if (!CulturalMemberBenefitsSelectionService.getCurrentSelection().chosenMembershipBenefitRepo) {
							return CulturalMemberBenefitsSelectionService.resetSelections();
						}
					},
					getMultiGuestsList: function(assessCurrentSelection, CulturalMemberBenefitsSelectionService, ProfileLoginSessionService) {
						if (ProfileLoginSessionService.hasMultiGuestsMemberships() && !CulturalMemberBenefitsSelectionService.getCurrentSelection().multiGuestSelectedMember) {
							return CulturalMemberBenefitsSelectionService.defaultMultiGuestSelection();
						}
					},
					initialCalendarData: function(getMultiGuestsList, CulturalMemberBenefitsSelectionService) {
						return CulturalMemberBenefitsSelectionService.fetchMemberBenefitsAvailabilityEventList()
							.catch(function() {
								// there was an error, don't show modal
								// fail silently because error is returned when there aren't any event dates
								return null;
							});
						}
				}
			})
	})
	.run(function(ExtraFlow, CulturalMemberBenefitsEnumsService) {
		// Register this extra flow alternate module with the extra flow service
		ExtraFlow.registerXMC('CulturalMemberBenefits', {
			name: CulturalMemberBenefitsEnumsService.alternateModuleName,
			view: CulturalMemberBenefitsEnumsService.alternateModuleView,
			viewIsStateName: true,
			doEditMode: false,
			lockQuantity: true,
			writeSingleCharac: false,
			enabled: true,
			type: 'alternateFlowModule'
		});
	});

/**
 * Created by ltischuk on 6/6/15.
 */
angular.module('cultural-member-benefits').factory
('CulturalMemberBenefitsEnumsService',
	function(
	) {

		return {

			localeSection: 'CulturalMemberBenefits',
			 	alternateModuleName:'CulturalMemberBenefits',
		   alternateModuleView: 'cultural-member-benefits.selection',
			services:{
				MEMBER_BENEFITS: 'MemberBenefits',
				MEMBER_BENEFITS_SUMMARY: 'MemberBenefitsSummary'
			},
			BENEFIT_TYPES:{

				PACKAGE_LEVEL: 'packageLevel',
				RATE_LEVEL: 'rateLevel'

			},
			CUSTOMER_TYPE_GROUPS:{

				BENEFIT:'benefit_customer_types',
				DISCOUNT: 'discount_customer_types'

			}
		}

	}
);

(function() {
	'use strict';

	angular
		.module('cultural-membership-wizard', ['app', 'profile', 'profile-login'])
		.config(function($locationProvider, $stateProvider) {
			$stateProvider
				.state('cultural-membership-wizard', {
					abstract: true,
					url: '/cultural-membership-wizard/:keyword',
					template: '<div ui-view></div>',
					params: {
						keyword: {
							squash: true,
							value: null
						}
					},
					resolve: {
						//resolve failures are handled within run.js of main app
						load: function($rootScope, Utilities) {
							$rootScope.showSpinner();

							return Utilities.cacheBustAndLazyLoad([
								'/scripts/modules/cultural-membership-wizard/cultural-membership-wizard-models.js',
								'/scripts/modules/cultural-membership-wizard/services/cultural-membership-wizard-prep-service.js',
								'/scripts/modules/cultural-membership-wizard/services/cultural-membership-wizard-finalize-service.js',
								'/scripts/modules/cultural-membership-wizard/services/cultural-membership-wizard-selection-service.js',
								'/scripts/modules/cultural-membership-wizard/services/cultural-membership-wizard-routing-service.js',
								'/scripts/modules/cultural-membership-wizard/services/cultural-membership-wizard-enums-service.js',
								'/scripts/modules/cultural-membership-wizard/services/cultural-membership-wizard-request-service.js',
								'/scripts/modules/cultural-membership-wizard/controllers/cultural-membership-wizard-membership-type-controller.js',
								'/scripts/modules/cultural-membership-wizard/controllers/cultural-membership-wizard-membership-level-controller.js',
								'/scripts/modules/cultural-membership-wizard/controllers/cultural-membership-wizard-membership-demographics-controller.js',
								'/scripts/modules/cultural-membership-wizard/controllers/cultural-membership-wizard-opt-ins-controller.js',
								'/scripts/modules/cultural-membership-wizard/controllers/cultural-membership-wizard-optional-rate-selection-controller.js',
								'/scripts/modules/cultural-membership-wizard/controllers/cultural-membership-wizard-membership-tier-selection-controller.js'
							]);
						},
						initialData: function(load, Bootstrap) {
							return Bootstrap.bootstrapApplication();
						},
						config: function(initialData, $injector) {
							return $injector.get('CulturalMembershipWizardPrepService').getConfigurationSettings();
						},
						setupStateListener: function(config, $injector) {
							return $injector.get('CulturalMembershipWizardRoutingService').setupStateListener();
						},
						packages: function(setupStateListener, $injector, $state, $transition$) {
							var shouldClearPromoMemberships = !($state.toParams.promoIndicator === 'promo');
							return $injector.get('CulturalMembershipWizardSelectionService').compileMembershipPackages($transition$.params().keyword, false, shouldClearPromoMemberships);
						},
						checkPromoRoute: function(packages, $injector, $transition$) {
							return $injector.get('CulturalMembershipWizardRoutingService').checkAndRerouteForPromoCase($transition$.params().keyword);
						}

					}
				})
				.state('cultural-membership-wizard.membership-type-selection', {
					url: '',
					controller: 'CulturalMembershipWizardMembershipTypeController',
					templateUrl: '/scripts/modules/cultural-membership-wizard/views/membership-type.html'
					//resolve: {
					// commenting out so just in case we want to add this back in  - PSC requirement kept changing
					//	assessSelectionRoute:function(checkPromoRoute,CulturalMembershipWizardEnumsService,CulturalMembershipWizardPrepService, CulturalMembershipWizardSelectionService,RouteRejectionService){
					//
					//		//ensure selection is first cleared on each visit to this screen
					//		CulturalMembershipWizardSelectionService.resetSelection();
					//
					//		if(CulturalMembershipWizardPrepService.isLoggedInMemberWithUnsupportedMembershipLevel()){
					//
					//			throw new RouteRejectionService.ViewException(CulturalMembershipWizardEnumsService.localeSection,'unsupportedMembershipLevelTitle','unsupportedMembershipLevelMsg','/packageList',{});
					//
					//		}else{
					//
					//			return true;
					//
					//		}
					//
					//	}
					//
					//}
				})
				.state('cultural-membership-wizard.membership-tier-selection', {
					url: '/membership-tier-selection/:membershipType/{customTypeNewRenewIndicator:(?:new|renewal|na)}/{promoIndicator:(?:promo|noPromo)}',
					controller: 'CulturalMembershipWizardMembershipTierSelectionController',
					templateUrl: '/scripts/modules/cultural-membership-wizard/views/membership-tier.html',
					resolve: {
						preselectSelectionFromRoute: function(checkPromoRoute, $transition$, $injector) {
							return $injector.get('CulturalMembershipWizardRoutingService').useStateToPresetBasicAspectsOfSelectionForRoute($transition$.params());
						},
						assessEligibility: function(preselectSelectionFromRoute, $injector, $transition$) {
							return $injector.get('CulturalMembershipWizardRoutingService').isEligibleForSelectedRoute($transition$.params(), 'cultural-membership-wizard.membership-tier-selection');
						},
						membershipTiers: function(assessEligibility, $injector) {
							return $injector.get('CulturalMembershipWizardSelectionService').getCurrentSelection().getSelectedMembershipType().getMembershipTiers();
						},
						preSelectTier: function(assessEligibility, $injector, RouteRejectionService, $transition$) {
							var stateParams = $transition$.params(),
								CulturalMembershipWizardSelectionService = $injector.get('CulturalMembershipWizardSelectionService');
							if (angular.isUndefined(CulturalMembershipWizardSelectionService.getCurrentSelection().getSelectedMembershipType())) { //if we don't have a membership type in memory - we need to send the user back to the type selection (happens on refreshes)
								throw new RouteRejectionService.UnrecoverableException('cultural-membership-wizard.membership-type-selection', stateParams);
							} else {
								if (stateParams.membershipType === 'renewal') {
									CulturalMembershipWizardSelectionService.triggerReselectOfTier = true;
									CulturalMembershipWizardSelectionService.preSelectMembershipLevel();
								} else {
									return true;
								}
							}
						}
					}
				})
				/**
				 * Top Secret state to support deep linking to the membership level screen if the merchant is configured with tiers
		 */
				.state('cultural-membership-wizard.membership-level-selection-with-tier-hook', {
					url: '/membership-level-selection-with-tier-hook/:membershipType/:membershipTier/{customTypeNewRenewIndicator:(?:new|renewal|na)}/{promoIndicator:(?:promo|noPromo)}',
					controller: 'CulturalMembershipWizardMembershipTierSelectionController',
					templateUrl: '/scripts/modules/cultural-membership-wizard/views/membership-tier.html',
					resolve: {
						preselectSelectionFromRoute: function(checkPromoRoute, $transition$, $injector) {
							return $injector.get('CulturalMembershipWizardRoutingService').useStateToPresetBasicAspectsOfSelectionForRoute($transition$.params());
						},
						assessEligibility: function(preselectSelectionFromRoute, $injector, $transition$) {
							//assess eligibility for the actual level selection
							return $injector.get('CulturalMembershipWizardRoutingService').isEligibleForSelectedRoute($transition$.params(), 'cultural-membership-wizard.membership-level-selection');
						},
						routeRedirect: function(assessEligibility, RouteRejectionService, $transition$) {
							var stateParams = $transition$.params();
							throw new RouteRejectionService.UnrecoverableException('cultural-membership-wizard.membership-level-selection', {
								membershipType: stateParams.membershipType,
								customTypeNewRenewIndicator: stateParams.customTypeNewRenewIndicator,
								promoIndicator: stateParams.promoIndicator,
								keyword: stateParams.keyword
							});
						}
					}
				})
				.state('cultural-membership-wizard.membership-level-selection', {
					url: '/membership-level-selection/:membershipType/{customTypeNewRenewIndicator:(?:new|renewal|na)}/{promoIndicator:(?:promo|noPromo)}',
					controller: 'CulturalMembershipWizardMembershipLevelController',
					templateUrl: '/scripts/modules/cultural-membership-wizard/views/membership-level.html',
					resolve: {
						assessEligibility: function(checkPromoRoute, $injector, $transition$) {
							return $injector.get('CulturalMembershipWizardRoutingService').isEligibleForSelectedRoute($transition$.params(), 'cultural-membership-wizard.membership-level-selection');
						},
						preSelectMembershipLevel: function(assessEligibility, $injector, RouteRejectionService, $transition$) {
							var CulturalMembershipWizardSelectionService = $injector.get('CulturalMembershipWizardSelectionService');
							if (angular.isUndefined(CulturalMembershipWizardSelectionService.getCurrentSelection().getSelectedMembershipType())) { //if we don't have a membership type in memory - we need to send the user back to the type selection (happens on refreshes)
								throw new RouteRejectionService.UnrecoverableException('cultural-membership-wizard.membership-type-selection', $transition$.params());
							} else {
								return CulturalMembershipWizardSelectionService.preSelectMembershipLevel();
							}
						}
					}
				})
				.state('cultural-membership-wizard.membership-demographics', {
					url: '/membership-demographics/:membershipType/{customTypeNewRenewIndicator:(?:new|renewal|na)}/{promoIndicator:(?:promo|noPromo)}/:packageId',
					controller: 'CulturalMembershipWizardMembershipDemographicsController',
					templateUrl: '/scripts/modules/cultural-membership-wizard/views/membership-demographics.html',
					resolve: {
						//resolve failures are handled within run.js of main app
						assessDemographicsRoute: function(checkPromoRoute, $injector, RouteRejectionService, Utilities, $transition$) {
							var stateParams = $transition$.params(),
								CulturalMembershipWizardSelectionService = $injector.get('CulturalMembershipWizardSelectionService');
							if (angular.isUndefined(CulturalMembershipWizardSelectionService.getCurrentSelection().recommendation)) {
								throw new RouteRejectionService.UnrecoverableException('cultural-membership-wizard.membership-type-selection', stateParams);
							} else if (Utilities.getBoolean(CulturalMembershipWizardSelectionService.getCurrentSelection().recommendation.package.variable_price_flag) &&
								(angular.isUndefined(CulturalMembershipWizardSelectionService.getCurrentSelection().variablePrice) ||
								!CulturalMembershipWizardSelectionService.getCurrentSelection().variablePriceFinalized)) {
								throw new RouteRejectionService.UnrecoverableException('cultural-membership-wizard.membership-level-selection', stateParams);
							} else {
								return true;
							}
						},
						assessLogin: function(assessDemographicsRoute, $injector, RouteRejectionService, ProfileLoginSessionService, $state, $transition$) {
							if (!ProfileLoginSessionService.isLoggedIn()) {
								var stateParams = $transition$.params(),
									CulturalMembershipWizardEnumsService = $injector.get('CulturalMembershipWizardEnumsService'),
									CulturalMembershipWizardSelectionService = $injector.get('CulturalMembershipWizardSelectionService');
								var selectedMembershipType = CulturalMembershipWizardSelectionService.getCurrentSelection().getSelectedMembershipType();
								var newRoute = ((selectedMembershipType.membership_type_name === CulturalMembershipWizardEnumsService.standardMembershipTypes.NEW ||
								stateParams.customTypeNewRenewIndicator === CulturalMembershipWizardEnumsService.standardMembershipTypes.NEW) ? 'profile-login.create-acct' : 'profile-login.sign-in');
								var newRouteParams = (newRoute === 'profile-login.sign-in' ? { showSignInOnly: true } : {});
								CulturalMembershipWizardSelectionService.shouldResetSelection = false;
								ProfileLoginSessionService.setPostSigninSuccessRoute($state.href($state.next.name, stateParams));
								throw new RouteRejectionService.UnrecoverableException(newRoute, newRouteParams);
							} else {
								return true;
							}
						},
						assessMembershipLevelRoute: function(assessLogin, $injector, $transition$) {
							return $injector.get('CulturalMembershipWizardRoutingService').isEligibleForSelectedRoute($transition$.params(), 'cultural-membership-wizard.membership-level-selection');
						}
					}
				})
				.state('cultural-membership-wizard.opt-ins', {
					url: '/membership-opt-ins/:packageId',
					controller: 'CulturalMembershipWizardOptInsController',
					templateUrl: '/scripts/modules/cultural-membership-wizard/views/opt-ins.html',
					resolve: {
						//resolve failures are handled within run.js of main app
						assessOptInsRoute: function(checkPromoRoute, $injector, RouteRejectionService, ProfileLoginSessionService, $transition$) {
							if (angular.isUndefined($injector.get('CulturalMembershipWizardSelectionService').getCurrentSelection().recommendation) || !ProfileLoginSessionService.isLoggedIn()) {
								throw new RouteRejectionService.UnrecoverableException('cultural-membership-wizard.membership-type-selection', $transition$.params());
							} else {
								return true;
							}
						},
						optIns: function(assessOptInsRoute, $injector, RouteRejectionService, Package, Utilities, $transition$) {
							var optinTypeName = Utilities.safelyCheckPropertyOnObject('Package.packageDetails.CHARACS.opt_in_type', Package) ? Package.packageDetails.CHARACS.opt_in_type : '',
								CulturalMembershipWizardPrepService = $injector.get('CulturalMembershipWizardPrepService');
							if (angular.isDefined(CulturalMembershipWizardPrepService.config[optinTypeName])) {
								var configOption = angular.copy(CulturalMembershipWizardPrepService.config[optinTypeName]);
								configOption.forEach(function(item) {
									item.value = Utilities.getBoolean(item.value)
								});
								return configOption;
							} else {
								throw new RouteRejectionService.ViewException(undefined, undefined, undefined, 'cultural-membership-wizard', { keyword: $transition$.params().keyword });
							}
						},
						xfcMap: function(optIns, Package) {
							return Package.buildXFCMap();
						},
						initXFC: function(xfcMap, Package) {
							return Package.initXFC();
						}
					}
				})
				.state('cultural-membership-wizard.optional-rate-selection', {
					url: '/membership-optional-rate-selection/:membershipType/{customTypeNewRenewIndicator:(?:new|renewal|na)}/{promoIndicator:(?:promo|noPromo)}/:packageId',
					controller: 'CulturalMembershipWizardOptionalRateSelectionController',
					templateUrl: '/scripts/modules/cultural-membership-wizard/views/optional-rate-selection.html',
					resolve: {

						assessOptionalRateSelectionRoute: function(checkPromoRoute, $injector, Utilities, RouteRejectionService, $transition$) {
							var stateParams = $transition$.params(),
								CulturalMembershipWizardSelectionService = $injector.get('CulturalMembershipWizardSelectionService');
							if (angular.isUndefined(CulturalMembershipWizardSelectionService.getCurrentSelection().getSelectedMembershipType())) { //if we don't have a membership type in memory - we need to send the user back to the type selection (happens on refreshes)
								throw new RouteRejectionService.UnrecoverableException('cultural-membership-wizard.membership-type-selection', stateParams);
							} else if (Utilities.getBoolean(CulturalMembershipWizardSelectionService.getCurrentSelection().recommendation.package.variable_price_flag) &&
								angular.isUndefined(CulturalMembershipWizardSelectionService.getCurrentSelection().variablePrice)) {
								throw new RouteRejectionService.UnrecoverableException('cultural-membership-wizard.membership-level-selection', stateParams);
							} else {
								return true;
							}
						},
						assessEligibility: function(assessOptionalRateSelectionRoute, $injector, $transition$) {
							return $injector.get('CulturalMembershipWizardRoutingService').isEligibleForSelectedRoute($transition$.params(), 'cultural-membership-wizard.optional-rate-selection');
						},
						rateEffectorMbrOptions: function(assessEligibility, $injector, RouteRejectionService, $transition$) {
							var stateParams = $transition$.params(),
								configOptions = $injector.get('CulturalMembershipWizardSelectionService').getSelectionOptionalMbrOptionsForRecommendation(stateParams.membershipType);
							if (configOptions.length > 0) {
								return configOptions;
							} else {
								throw new RouteRejectionService.ViewException(undefined, undefined, undefined, 'cultural-membership-wizard', { keyword: stateParams.keyword });
							}
						}
					}
				});
		})
		.run(function(ExtraFlow, Enums, StandardFlowInitiatorService) {
			// Register this extra flow alternate module with the extra flow service
			ExtraFlow.registerXMC('CulturalMembershipWizard', {
				name: 'CulturalMembershipWizard',
				view: 'cultural-membership-wizard',
				doEditMode: false,
				lockQuantity: true,
				writeSingleCharac: false,
				enabled: true,
				type: 'alternateFlowModule'
			});

			// Register the OptIns screen as an extra flow movie XFC module with the extra flow service
			ExtraFlow.registerXMC('cultural_membership_wizard_opt_ins', {
				name: 'cultural_membership_wizard_opt_ins',
				view: 'cultural-membership-wizard.opt-ins',
				viewIsStateName: true,
				doEditMode: false,
				lockQuantity: true,
				writeSingleCharac: false,
				enabled: true,
				type: 'extraFlowControl'
			});
		});
})();

(function() {
	'use strict';

	angular
		.module('membership-experience', ['ui.router', 'ngResource', 'composition-library', 'utilities']);
}());

(function() {
	/* eslint-disable sort-keys */
	'use strict';

	angular
		.module('membership-experience')
		.config(config)
		.run(run)
		.value('MembershipExperienceLocaleSection', 'MembershipExperience');

	/**
	 * Sets up routing for the Package Planner module
	 * @public
	 * @param {Object} $stateProvider Lets us set up state
	 * @param {Service} ComponentLoaderEnums The Component Loader Enums
	 * @return {undefined}
	 * @ngInject
	 */
	function config($stateProvider, ComponentLoaderEnums) {
		var MODULE_DIRECTORY = 'scripts/modules/alternate-modules/membership-experience',
			COMPOSITION_LIBRARY = 'scripts/modules/composition-library',
			OLD_CULTURAL_MEMBERSHIP_DIRECTORY = 'scripts/modules/cultural-membership-wizard',
			DEFAULT_FILES = [
				COMPOSITION_LIBRARY + '/tracking/compose-alternate-module-google-analytics.js',
				OLD_CULTURAL_MEMBERSHIP_DIRECTORY + '/cultural-membership-wizard-models.js',
				OLD_CULTURAL_MEMBERSHIP_DIRECTORY + '/services/cultural-membership-wizard-request-service.js',
				OLD_CULTURAL_MEMBERSHIP_DIRECTORY + '/services/cultural-membership-wizard-enums-service.js',
				OLD_CULTURAL_MEMBERSHIP_DIRECTORY + '/services/cultural-membership-wizard-prep-service.js',
				OLD_CULTURAL_MEMBERSHIP_DIRECTORY + '/services/cultural-membership-wizard-selection-service.js',
				OLD_CULTURAL_MEMBERSHIP_DIRECTORY + '/services/cultural-membership-wizard-routing-service.js',
				OLD_CULTURAL_MEMBERSHIP_DIRECTORY + '/services/cultural-membership-wizard-finalize-service.js',
				MODULE_DIRECTORY + '/services/membership-experience-utilities-service.js',
				MODULE_DIRECTORY + '/services/membership-experience-tracking-service.js'
			];

		$stateProvider
			.state('membership-experience', {
				url: '/membership-experience/{keyword:keyword}/:promoIndicator/:membershipType',
				templateUrl: MODULE_DIRECTORY + '/type-selection/membership-experience-type-selection.html',
				controller: 'MembershipExperienceTypeSelectionController',
				controllerAs: 'vm',
				params: {
					promoIndicator: {
						squash: true,
						value: null
					},
					membershipType: {
						squash: true,
						value: null
					}
				},
				resolve: {
					initialData: initializeData,
					previousState: buildPreviousState,
					loadAssets: function(previousState, Utilities) {
						return Utilities.cacheBustAndLazyLoad(DEFAULT_FILES.concat([
							MODULE_DIRECTORY + '/type-selection/membership-experience-type-selection-controller.js',
							MODULE_DIRECTORY + '/type-selection/components/type/type-component.js',
							MODULE_DIRECTORY + '/type-selection/components/type/type-component-controller.js',
							MODULE_DIRECTORY + '/type-selection/membership-experience-type-selection.css'
						]));
					},
					getConfigurationSettings: getConfigurationSettings,
					getPackages: getPackages,
					checkPromoRoute: checkPromoRoute,
					clearSelectedFriendsGroups: clearSelectedFriendsGroups
				}
			})
			.state('membership-experience-level-selection', {
				url: '/membership-experience/{keyword:keyword}/level-selection/:membershipTier/:promoIndicator/:membershipType/:memberId',
				templateUrl: MODULE_DIRECTORY + '/level-selection/membership-experience-level-selection.html',
				controller: 'MembershipExperienceLevelSelectionController',
				controllerAs: 'vm',
				params: {
					membershipTier: {
						squash: true,
						value: null
					},
					memberId: {
						squash: true,
						value: null
					}
				},
				resolve: {
					initialData: initializeData,
					previousState: buildPreviousState,
					loadAssets: function(previousState, Utilities) {
						return Utilities.cacheBustAndLazyLoad(DEFAULT_FILES.concat([
							MODULE_DIRECTORY + '/level-selection/components/level/level-component.js',
							MODULE_DIRECTORY + '/level-selection/components/level/level-component-controller.js',
							MODULE_DIRECTORY + '/level-selection/components/level/level-component.css',
							MODULE_DIRECTORY + '/level-selection/components/option-field/option-field-component.js',
							MODULE_DIRECTORY + '/level-selection/components/option-field/option-field-component-controller.js',
							MODULE_DIRECTORY + '/level-selection/membership-experience-level-selection-controller.js',
							MODULE_DIRECTORY + '/level-selection/membership-experience-level-selection.css'
						]));
					},
					getConfigurationSettings: getConfigurationSettings,
					getPackages: getPackages,
					checkPromoRoute: checkPromoRoute,
					clearSelectedFriendsGroups: clearSelectedFriendsGroups,
					preSelectSelectionFromRoute: function(clearSelectedFriendsGroups, $transition$, $injector) {
						return $injector.get('CulturalMembershipWizardRoutingService').useStateToPresetBasicAspectsOfSelectionForRoute($transition$.params());
					},
					assessEligibility: function(preSelectSelectionFromRoute, $injector, $transition$) {
						return $injector.get('CulturalMembershipWizardRoutingService').isEligibleForSelectedRoute($transition$.params(), 'membership-experience-level-selection', true);
					},
					preSelectMembershipLevelAndDetermineRoute: function(assessEligibility, $injector, RouteRejectionService, $transition$) {
						var stateParams = $transition$.params(),
							CulturalMembershipWizardSelectionService = $injector.get('CulturalMembershipWizardSelectionService');

						if (!angular.isObject(CulturalMembershipWizardSelectionService.getCurrentSelection().getSelectedMembershipType())) {
							throw new RouteRejectionService.UnrecoverableException('membership-experience', stateParams);
						} else {
							if (stateParams.membershipType === 'renewal' || stateParams.promoIndicator == 'promo') {
								CulturalMembershipWizardSelectionService.triggerReselectOfTier = true;
								CulturalMembershipWizardSelectionService.preSelectMembershipLevel();
							}
						}
					},
				}
			})
			.state('membership-experience-friends-groups', {
				url: '/membership-experience/{keyword:keyword}/friends-groups/:membershipTier/:promoIndicator/:membershipType/:packageId',
				templateUrl: MODULE_DIRECTORY + '/friends-groups/membership-experience-friends-groups.html',
				controller: 'MembershipExperienceFriendsGroupsController',
				controllerAs: 'vm',
				resolve: {
					initialData: initializeData,
					previousState: buildPreviousState,
					loadAssets: function(previousState, Utilities) {
						return Utilities.cacheBustAndLazyLoad(DEFAULT_FILES.concat([
							MODULE_DIRECTORY + '/friends-groups/components/group/membership-experience-group-component.js',
							MODULE_DIRECTORY + '/friends-groups/components/group/membership-experience-group-component-controller.js',
							MODULE_DIRECTORY + '/friends-groups/components/group/membership-experience-group-component.css',
							MODULE_DIRECTORY + '/friends-groups/membership-experience-friends-groups-controller.js',
							MODULE_DIRECTORY + '/friends-groups/membership-experience-friends-groups.css'
						]));
					},
					getConfigurationSettings: getConfigurationSettings,
					assessOptionalRateSelectionRoute: function(getConfigurationSettings, $injector, Utilities, RouteRejectionService, $transition$) {
						var currentSelection = $injector.get('CulturalMembershipWizardSelectionService').getCurrentSelection(),
							stateParams = $transition$.params();

						if (!angular.isObject(currentSelection.getSelectedMembershipType())) {
							throw new RouteRejectionService.UnrecoverableException('membership-experience', stateParams);
						} else if (!currentSelection.recommendation || (Utilities.getBoolean(currentSelection.recommendation.package.variable_price_flag) && !angular.isString(currentSelection.variablePrice))) {
							throw new RouteRejectionService.UnrecoverableException('membership-experience-level-selection', stateParams);
						} else {
							return true;
						}
					},
				}
			})
			.state('membership-experience-demographics', {
				url: '/membership-experience/{keyword:keyword}/demographics/:membershipTier/:promoIndicator/:membershipType/:packageId',
				templateUrl: MODULE_DIRECTORY + '/demographics/membership-experience-demographics.html',
				components: [ ComponentLoaderEnums.paymentSchedule ],
				controller: 'MembershipExperienceDemographicsController',
				controllerAs: 'vm',
				resolve: {
					initialData: initializeData,
					previousState: buildPreviousState,
					loadAssets: function(previousState, Utilities) {
						return Utilities.cacheBustAndLazyLoad(DEFAULT_FILES.concat([
							MODULE_DIRECTORY + '/demographics/membership-experience-demographics-controller.js',
							MODULE_DIRECTORY + '/demographics/membership-experience-demographics.css'
						]));
					},
					assessDemographicsRoute: function(loadAssets, $injector, RouteRejectionService, Utilities, $transition$) {
						var currentSelection = $injector.get('CulturalMembershipWizardSelectionService').getCurrentSelection(),
							stateParams = $transition$.params();

						if (!currentSelection.recommendation) {
							throw new RouteRejectionService.UnrecoverableException('membership-experience', { keyword: stateParams.keyword });
						} else if (Utilities.getBoolean(currentSelection.recommendation.package.variable_price_flag) &&
							!currentSelection.variablePrice) {
							throw new RouteRejectionService.UnrecoverableException('membership-experience', { keyword: stateParams.keyword });
						}
						return true;
					},
					assessLogin: function(assessDemographicsRoute, $injector, RouteRejectionService, ProfileLoginSessionService, $state, $transition$) {
						if (!ProfileLoginSessionService.isLoggedIn()) {
							$injector.get('CulturalMembershipWizardSelectionService').shouldResetSelection = false;
							ProfileLoginSessionService.allowOverrideMembershipExpirationCheckOnNextSignIn();
							ProfileLoginSessionService.setPostSigninSuccessRoute($state.href($state.next.name, $transition$.params()));
							throw new RouteRejectionService.UnrecoverableException('profile-login.signin', {});
						}
						return true;
					},
					assessMembershipLevelRoute: function(assessLogin, $injector, $transition$) {
						return $injector.get('CulturalMembershipWizardRoutingService').isEligibleForSelectedRoute($transition$.params(), 'membership-experience-level-selection');
					},
					paymentOptions: function(assessMembershipLevelRoute, $injector) {
						return $injector.get('CulturalMembershipWizardSelectionService').configurePaymentOptions($injector.get('MembershipExperienceUtilitiesService').getSelectedFriendsGroups());
					},
					paymentSchedule: function(paymentOptions, $injector) {
						if (paymentOptions.hasPaymentPlan || paymentOptions.hasPaymentPlanWithDownPayment) {
							return $injector.get('CulturalMembershipWizardSelectionService').getPaymentSchedule(paymentOptions, $injector.get('MembershipExperienceUtilitiesService').getSelectedFriendsGroups());
						}
						return [];
					},
				}
			});
	}

	/**
	 * Run method for membership-experience
	 * @public
	 * @param {Service} ExtraFlow ExtraFlow Service.
	 * @return {undefined}
	 * @ngInject
	 */
	function run(ExtraFlow) {
		ExtraFlow.registerXMC('membership-experience', {
			doEditMode: false,
			enabled: true,
			itemHasAnEditableXMC: false,
			lockQuantity: true,
			name: 'membership-experience',
			type: 'alternateFlowModule',
			view: 'membership-experience'
		});
	}

	/**
	 * Resolves the bootstrap promise
	 * @public
	 * @param {Service} Bootstrap Bootstrap service
	 * @param {Service} $rootScope $rootScope
	 * @return {Promise} A promise that we bootstrapped
	 * @ngInject
	 */
	function initializeData(Bootstrap) {
		return Bootstrap.bootstrapApplication(undefined, true);
	}

	/**
	 * Resolves the current state so that once the page resolves, it will have the previous state.
	 * @public
	 * @param  {Promise.<T>} initialData initialData resolve promise
	 * @param  {Object} $state The state before we resolve to the new state
	 * @return {Object} The previous state
	 * @ngInject
	 */
	function buildPreviousState(initialData, $state) {
		return {
			name: $state.current.name,
			params: $state.params
		};
	}

	/**
 	 * @param  {Promise.<T>} loadAssets loadAssets
	 * @param  {Object} $injector $injector
	 * @param  {Object} $transition$ $transition$
	 * @returns {Promise.<T>} getConfigurationSettings
	 * @ngInject
	 */
	function getConfigurationSettings(loadAssets, $injector, $transition$) {
		return $injector.get('CulturalMembershipWizardPrepService').getConfigurationSettings($transition$.params().keyword);
	}

	/**
	 * @param  {Promise.<T>} getConfigurationSettings getConfigurationSettings
	 * @param  {Object} $injector $injector
	 * @param  {Object} $state $state
	 * @param  {Object} $transition$ $transition$
	 * @param  {Object} MembershipExperienceUtilitiesService MembershipExperienceUtilitiesService
	 * @returns {Promise.<T>} compileMembershipPackages
	 * @ngInject
	 */
	function getPackages(getConfigurationSettings, $injector, $state, $transition$) {
		var shouldClearPromoMemberships = $state.toParams.promoIndicator !== 'promo';

		return $injector.get('CulturalMembershipWizardSelectionService').compileMembershipPackages($transition$.params().keyword, false, shouldClearPromoMemberships);
	}

	/**
	 * @param  {Promise.<T>} getPackages getPackages
	 * @param  {Object} $injector $injector
	 * @param  {Object} $transition$ $transition$
	 * @returns {Promise.<T>} checkAndRerouteForPromoCase
	 * @ngInject
	 */
	function checkPromoRoute(getPackages, $injector, $transition$) {
		return $injector.get('MembershipExperienceUtilitiesService').checkAndRerouteForPromoCase($transition$.params().keyword);
	}

	/**
	 * Clears selected friends groups
	 * @param  {Promise.<T>} checkPromoRoute checkPromoRoute
	 * @param  {Object} $injector $injector
	 * @returns {undefined}
	 * @ngInject
	 */
	function clearSelectedFriendsGroups(checkPromoRoute, $injector) {
		$injector.get('MembershipExperienceUtilitiesService').setSelectedFriendsGroups([]);
	}
})();
(function() {
	/* eslint-disable sort-keys */
	'use strict';

	angular
		.module('pass-select', ['app'])
		.config(config)
		.run(run);

	/**
	 * Sets up routing for the Pass Select module
	 * @public
	 * @param {Service} $injector the injector service
	 * @param {Object} $stateProvider the state provider
	 * @returns {undefined}
	 * @ngInject
	 */
	function config($injector, $stateProvider) {
		var MODULE_DIRECTORY = 'scripts/modules/alternate-modules/pass-select/';
		$stateProvider
			.state('pass-select', {
				url: '/pass-select/:plugin',
				templateUrl: MODULE_DIRECTORY + '/templates/pass-select.html',
				controller: 'PassSelectController',
				controllerAs: 'vm',
				params: { plugin: 'all' },
				resolve: {
					initialData: function(Bootstrap, $rootScope) {
						$rootScope.showSpinner();
						return Bootstrap.bootstrapApplication();
					},
					loadCoreAssets: function(initialData, Utilities) {
						var coreAssets = [
							MODULE_DIRECTORY + '/constants/pass-select-contants.js',
							MODULE_DIRECTORY + '/controllers/pass-select-controller.js',
							MODULE_DIRECTORY + '/services/pass-select-service.js'
						];

						return Utilities.cacheBustAndLazyLoad(coreAssets);
					},
					passType: function(loadCoreAssets, $state, $stateParams, $transition$) {
						var PassSelectConstants = $injector.get('PassSelectConstants');
						var plugin = $stateParams.plugin.toUpperCase();

						if (PassSelectConstants.passType[plugin]) {
							return PassSelectConstants.passType[plugin];
						}

						$transition$.abort();
						$rootScope.routeTo($state.href('pass-select', { plugin: 'all' }));
					},
					checkProfileLoggedIn: function(passType, $state, $stateParams, $rootScope, $transition$, ProfileLoginSessionService) {
						if (ProfileLoginSessionService.isLoggedIn()) {
							return;
						}

						$transition$.abort();
						ProfileLoginSessionService.setPostSigninSuccessRoute($state.href('pass-select', $stateParams));
						$rootScope.routeTo($state.href('profile-login.signin.view'));
					},
					loadPluginAssets: function(checkProfileLoggedIn, passType, Utilities) {
						var PassSelectConstants = $injector.get('PassSelectConstants');
						var filesToLoad = PassSelectConstants.files.MAIN;

						if (PassSelectConstants.files[passType]) {
							filesToLoad = filesToLoad.concat(PassSelectConstants.files[passType]);
						}

						return Utilities.cacheBustAndLazyLoad(filesToLoad);
					},
					PassSelectPlugin: function(loadPluginAssets, $injector, passType, $log) {
						var PassSelectConstants = $injector.get('PassSelectConstants');
						var pluginToUse = PassSelectConstants.plugins[passType];

						if ($injector.has(pluginToUse)) {
							return $injector.get(pluginToUse);
						}

						$log.error('Unable to retrieve Pass Select plugin ' + pluginToUse);
					},
					pluginRequirements: function(PassSelectPlugin, $transition$) {
						var passCheck = true;
						var prevRoute = $transition$.from();

						if (angular.isFunction(PassSelectPlugin.onPluginRequirements)) {
							passCheck = PassSelectPlugin.onPluginRequirements();
						}

						if (!passCheck) {
							$transition$.abort();
							if (prevRoute.name) {
								$rootScope.routeTo($state.href(prevRoute.name, prevRoute.params), null, null, true)
							} else {
								$rootScope.routeTo('/');
							}
						}
					}
				},
				onEnter: function(pluginRequirements, $rootScope) {
					$rootScope.hideSpinner();
				}
			});
	}

	/**
	 * Sets up extra flows for the Pass Select module
	 * @public
	 * @param {Service} ExtraFlow The Extra Flow Service
	 * @returns {undefined}
	 * @ngInject
	 */
	function run(ExtraFlow) {
		var plugins = ['all', 'cultural', 'season'];

		plugins.forEach(function xfcSetter(plugin) {
			var pluginSuffix = (plugin === 'all' ? '' : '-' + plugin);

			// Register this extra flow alternate module with the extra flow service
			ExtraFlow.registerXMC('pass-select' + pluginSuffix + '.xfc', {
				name: 'pass-selection' + pluginSuffix,
				aliases: [],
				view: 'pass-select',
				viewIsStateName: true,
				viewDefaultArgs: { plugin: plugin },
				doEditMode: true,
				writeSingleCharac: false,
				enabled: true,
				type: 'extraFlowControl'
			});
		});
	}
})();

/**
 * Created by ltischuk on 1/9/15.
 */
angular.module('profile',
	['app']);



angular
	.module('profile')
	.service('ProfileModels', function($injector, AppData, ProfileEnumsService, StringUtils, Utilities, UtilsValidation) {
		var vm = this,
			forceInt = Utilities.forceInt,
			getString = Utilities.getString,
			isFunction = angular.isFunction,
			normalize = StringUtils.normalize,
			checkProp = Utilities.safelyCheckPropertyOnObject;

		function Profile() {
			this.salutation = '';
			this.first_name = '';
			this.middle_name = '';
			this.last_name = '';
			this.email = '';
			this.birth_date = '';
			this.phone_number = '';
			this.addresses = [];
			this.phones = [];
			this.password = '';
			this.sex = '';
			this.is_member = false;
			this.base_membership_info = new Membership();
			this.child_memberships = [];
			this.is_staff = false;
			this.guest_no = '';
			this.adultBeneficiaries = [];
			this.childBeneficiaries = [];
			this.adultLinkedGuests = [];
			this.childLinkedGuests = [];
			this.options = [];
			this.forms = [];
			this.image = '';
			this.relationshipType = '';
			this.renewals = [];
			this.middle_initial = '';
			this.security_contact_primary_phone = ''; // only used by camps.
			this.security_contact_phone = ''; // only used by camps.
			this.security_contact = ''; // only used by camps.
			this.entering_grade = ''; // only used by camps.
			this.current_grade = ''; // only used by camps.
			this.shirt_size = ''; // only used by camps.

			/**
			 * Passport-specific identifiers for profiles
			 * @type {undefined}
			 */
			this.parent_customer_id = undefined;
			this.customer_id = undefined;
			this.dependent_id = undefined;
			this.other_info = undefined;
		}

		Profile.prototype = {
			autofill: function(dataModel) {
				for (var i in dataModel) {
					var prop = dataModel[i];
					if (i === 'base_membership_info') {
						angular.extend(this.base_membership_info, dataModel[i]);
					} else if (i === 'child_memberships') {
						dataModel[i].forEach(function(item) {
							this.addChildMembership(item.member_id, item.membership_level, item.member_expire_date, item.wtp_no);
						}, this);
					} else {
						this[i] = prop;
					}
				}
			},
			copyEditableDataFrom: function(src) {
				this.salutation = src.salutation;
				this.first_name = src.first_name;
				this.middle_name = src.middle_name;
				this.last_name = src.last_name;
				this.email = src.email;
				this.birth_date = src.birth_date;
				this.phone_number = src.phone_number;
				this.addresses = angular.copy(src.addresses);
				this.phones = angular.copy(src.phones);
				this.password = src.password;
				this.sex = src.sex;
				this.is_member = src.is_member;
				this.options = angular.copy(src.options);

				this.relationshipType = src.relationshipType;
				this.middle_initial = src.middle_initial;
				this.security_contact_primary_phone = src.security_contact_primary_phone;
				this.security_contact_phone = src.security_contact_phone;
				this.security_contact = src.security_contact;
				this.entering_grade = src.entering_grade;
				this.current_grade = src.current_grade;
				this.shirt_size = src.shirt_size;

				// only copy the image if it exists on the source.
				if (src.image) {
					this.image = src.image;
				}
			},
			initials: function() {
				var result = (angular.isDefined(this.first_name) && this.first_name.length > 0) ? this.first_name[0] : '';
				if (angular.isDefined(this.last_name) && this.last_name.length > 0) {
					result += this.last_name[0];
				}
				return result.length > 0 ? result : '?';
			},
			addChildMembership: function(memberId, membershipLevel, membership_expires, wtpNo) {
				var existingMembership = this.child_memberships.find(function(m) {
					return m.member_id === memberId;
				});

				if (existingMembership) {
					// Update existing membership
					existingMembership.membership_product_identifier = membershipLevel;
					existingMembership.membership_level = parseMembershipLevel(membershipLevel);
					existingMembership.member_expire_date = membership_expires || '';
					existingMembership.wtp_no = wtpNo || '';
				} else {
					// Add new membership
					var childMembership = new Membership();
					childMembership.member_id = memberId;
					childMembership.membership_product_identifier = membershipLevel;
					childMembership.membership_level = parseMembershipLevel(membershipLevel);
					childMembership.member_expire_date = membership_expires || '';
					childMembership.wtp_no = wtpNo || '';
					this.child_memberships.push(childMembership);
				}
			},
			getFullNameWithSalutation: function() {
				return (this.salutation ? (this.salutation + ' ') : '') + this.first_name + ' ' + (this.middle_initial.length > 0 ? (this.middle_initial + ' ') : '') + this.last_name;
			},
			getFullName: function() {
				return this.first_name + ' ' + (this.middle_initial.length > 0 ? (this.middle_initial + ' ') : '') + this.last_name;
			},
			saveConfigurableFieldsToProfile: function(configurableFields) {
				var sectionsAlreadyMapped = [];
				if (angular.isUndefined(configurableFields) || configurableFields.length < 1) {
					return;
				}
				configurableFields.forEach(function(field) {
					var fieldsToSave = [];
					// if we've already dealt with this profile property section, don't do it again.
					if ((field.profile_property_mapping_section) && !Utilities.inArray(field.profile_property_mapping_section, sectionsAlreadyMapped)) {
						sectionsAlreadyMapped.push(field.profile_property_mapping_section);
						// build list of fields to save to profile property section of this field
						for (var i = 0; i < configurableFields.length; i++) {
							if (configurableFields[i].profile_property_mapping_section === field.profile_property_mapping_section) {
								fieldsToSave.push(configurableFields[i]);
							}
						}
						// save the list of fields for this profile section to this profile section.
						this.loadConfigurableFieldsIntoOptions(fieldsToSave, field.profile_property_mapping_section);
					}
				}, this);
			},
			loadConfigurableFieldsIntoOptions: function(configurableFieldList, sectionName, forceConfigured) {
				var newValue,
					fields,
					fld,
					i;
				// loop through the options. For each option, apply every configurable field used to calculate it.
				// in most cases, there will only be one configurable field for each option.
				// For height, however, height_inches = height % 12, and height_feet = height / 12.

				if (angular.isDefined(this[sectionName])) {
					// Add any missing fields from configurableFieldList to this[sectionName]
					// This ensures new UDF fields are added even when section already has some fields
					if (forceConfigured && configurableFieldList.length) {
						configurableFieldList.forEach(function addConfigurableFieldsToProfile(field) {
							var newField;
							var hasProp = this[sectionName].some(function hasConfigurableField(item) {
								return item.name === field.profile_property_mapping_value;
							});

							// Only add if the field doesn't already exist
							if (hasProp) {
								return;
							}

							newField = new ConfigurableOptionField(field.profile_property_mapping_value, field.field_value || '', field.field_type);

							if (field.conversion && field.conversion.operation) {
								newField.conversion = {
									operation: field.conversion.operation,
									factor: field.conversion.factor
								};
							}

							this[sectionName].push(newField);
						}, this);
					}

					// Update values for all existing fields in this[sectionName] from configurableFieldList
					this[sectionName].forEach(function(o) {
						fields = configurableFieldList.filter(function(fld) {
							// get profile field that corresponds to this field.
							return o.name == fld.profile_property_mapping_value;
						});
						if (angular.isDefined(fields) && fields.length > 0) {
							// start with an empty value
							o.value = '';
							for (i = 0; i < fields.length; i++) {
								fld = fields[i];
								newValue = vm.getFieldValueFromProfileValue(fld, fld.getValue(), true);
								if (isNaN(newValue) || newValue === null) {
									o.value = newValue;
								} else if (isFunction(fld.data_entry_type) && normalize(fld.data_entry_type()) === 'dropdown' && parseFloat(newValue) % 1 !== 0) {
									o.value = parseFloat(newValue);
								} else if (angular.isString(newValue)) {
									o.value = getString(newValue);
								} else {
									o.value = forceInt(newValue) + forceInt(o.value);
								}
							}
						}
					});
				}
			},
			updateDemoFieldsFromCopy: function(fields) {
				for (var i in fields) {
					if (this.isDemoFieldUpdated(i, fields[i])) {
						if (i === 'phone_number') {
							this.getPrimaryPhone().phone_number = fields[i];
						} else if (i === 'phone_number_country') {
							this.getPrimaryPhone().country_code = fields[i];
						} else if (i === 'phone_region_code') {
							this.getPrimaryPhone().region_code = fields[i];
						} else if (i === 'secondary_phone') {
							this.getSecondaryPhone().phone_number = fields[i];
						} else if (angular.isDefined(this.getPrimaryAddress()[i])) {
							this.getPrimaryAddress()[i] = fields[i];
						} else {
							this[i] = fields[i];
						}
					}
				}
			},
			getDemographicsFieldCopy: function() {
				var demographics = {

					salutation: this.salutation,
					first_name: this.first_name,
					middle_name: this.middle_name,
					last_name: this.last_name,
					email: this.email,
					birth_date: this.birth_date,
					phone_number: this.getPrimaryPhone().phone_number,
					phone_number_country: this.getPrimaryPhone().country_code,
					phone_region_code: this.getPrimaryPhone().region_code,
					sex: this.sex,
					relationshipType: this.relationshipType,
					current_grade: this.current_grade,
					entering_grade: this.entering_grade,
					shirt_size: this.shirt_size
				}

				angular.extend(demographics, this.getPrimaryAddress());

				var secondaryAddr = this.getSecondaryPhone();
				if (angular.isDefined(secondaryAddr)) {
					demographics.secondary_phone = this.getSecondaryPhone().phone_number;
				}


				return demographics;
			},
			getMembershipLevelNameForAMemberId: function(memberId) {
				var matchedLevelName = '';
				if (this.base_membership_info.member_id === memberId) {
					matchedLevelName = this.base_membership_info.membership_level;
				} else {
					var match = this.child_memberships.filter(function(mbrship) {
						return mbrship.member_id === memberId;
					})[0];
					if (angular.isDefined(match)) {
						matchedLevelName = match.membership_level;
					}
				}

				return matchedLevelName;
			},
			getMembershipExpireDateObj: function() {
				var formattedDate = this.base_membership_info.member_expire_date.substring(0, this.base_membership_info.member_expire_date.indexOf('T'));
				formattedDate = formattedDate.replace(/-/g, '/');
				return new Date(formattedDate);
			},
			hasModificationsToDemographics: function(demographicsCopy) {
				return Object.keys(demographicsCopy).some(function(field) {
					return this.isDemoFieldUpdated(field, demographicsCopy[field]);
				}, this);
			},
			isDemoFieldUpdated: function(fieldName, fieldValue) {
				var isUpdated = false;
				if (fieldName === 'secondary_phone') {
					isUpdated = this.getSecondaryPhone().phone_number !== fieldValue;
				} else if (fieldName === 'phone_number') {
					isUpdated = this.getPrimaryPhone().phone_number !== fieldValue;
				} else if (angular.isDefined(this.getPrimaryAddress()[fieldName])) {
					isUpdated = this.getPrimaryAddress()[fieldName] !== fieldValue;
				} else {
					isUpdated = this[fieldName] !== fieldValue;
				}

				return isUpdated;
			},
			/****
			 * Understanding IDs
			 * With Siriusware clients, every guest has a guest_no.
			 * With non-Siriusware clients, every guest has either a customer_id (if it's not a linked guest), or a dependent_id (if it is a linked guest).
			 ****/
			isSameAs: function(tgtProfile) {
				if (angular.isDefined(tgtProfile)) {
					// Undefined guest_no's occur on non-Siriusware clients.
					// Default data on all these fields is ''. For the purpose of equality, we treat that the same as undefined.
					if (angular.isDefined(this.guest_no) && this.guest_no.length > 0) {
						return (this.guest_no == tgtProfile.guest_no);
					} else if (angular.isDefined(this.customer_id) && this.customer_id.length > 0) {
						return (this.customer_id == tgtProfile.customer_id);
					} else if (angular.isDefined(this.dependent_id) && this.dependent_id.length > 0) {
						return ((this.dependent_id == tgtProfile.dependent_id) && (this.parent_customer_id == tgtProfile.parent_customer_id));
					} else {
						// at this point, we have no guest_no, customer_id, or dependent_id. Fall back on comparing the names.
						return (this.first_name == tgtProfile.first_name && this.last_name == tgtProfile.last_name);
					}
				}
				return false;
			},
			isMemberExpired: function() {
				return this.is_member && new Date(this.base_membership_info.member_expire_date) <= new Date();
			},
			isMemberEligibleForRenewal: function() {
				return this.is_member && this.base_membership_info.eligible_for_renewal;
			},
			isExistingDependent: function() {
				return angular.isDefined(this.parent_customer_id) && this.parent_customer_id.length && angular.isDefined(this.dependent_id) && this.dependent_id.length;
			},
			toJSON: function(skipLinkedGuests) {
				var profileJSON = {};

				skipLinkedGuests = !!skipLinkedGuests; // converting an undefined into a boolean

				Object.keys(this).forEach(function(property) {
					if (skipLinkedGuests && (property == 'childLinkedGuests' || property == 'adultLinkedGuests')) {
						// skipping linked guests
					} else {
						profileJSON[property] = angular.copy(this[property]);
					}
				}, this);

				return profileJSON;
			},
			getStorableProperties: function() {
				var storableMembership = {

					is_member: this.is_member,
					base_membership_info: this.base_membership_info.toJSON(),
					child_memberships: [],
					adultLinkedGuests: this.adultLinkedGuests,
					childLinkedGuests: this.childLinkedGuests,
					is_staff: this.is_staff,
					guest_no: this.guest_no
				}

				return storableMembership;
			},
			/**
			 * The type parameter for addresses is changing. What was once Primary is now Home.
			 * Primary should only appear on addresses that are read in. When we write, we need to write Home.
			 *
			 * season-pass-select, camps, and cultural-membership-wizard all require a primary (or Home) address to exist. If it doesn't, this
			 * method creates one.
			 * @returns {Address} the primary address object
						 */
			getPrimaryAddress: function() {
				var result = this.addresses.filter(function(addr) {
					return (addr.type === ProfileEnumsService.personalInfoTypes.PRIMARY || addr.type === ProfileEnumsService.personalInfoTypes.HOME);
				})[0];

				if (angular.isUndefined(result)) {
					this.addBlankAddress(ProfileEnumsService.personalInfoTypes.HOME);
					result = this.addresses[0];
				} else {
					// Option values must be a valid value or it will cause a blank option in the select
					['state', 'country_code'].forEach(function(key) {
						if (!result[key]) {
							result[key] = null;
						}
					});
				}
				return result;
			},
			addBlankAddress: function(addr_type) {
				this.addresses.push(new Address(addr_type));
			},
			getShippingAddress: function() {
				var result = this.addresses.filter(function(addr) {
					return addr.type === ProfileEnumsService.personalInfoTypes.SHIPPING;
				})[0];
				// if there is no address explicitly defined as a shipping address, use the "HOME" address.
				// This is (frustratingly) needed, because some clients will have an address with the shipping type, and
				// others will just have addresses. Camps needs a shipping address, so we arbitrarily select the primary one
				// as the shipping address.
				if (angular.isUndefined(result)) {
					result = this.getPrimaryAddress();
				}
				if (angular.isUndefined(result)) {
					this.addBlankAddress(ProfileEnumsService.personalInfoTypes.HOME);
					result = this.getPrimaryAddress();
				}
				return result;
			},
			getBillingAddress: function() {
				var result = this.addresses.filter(function(addr) {
					return addr.type === ProfileEnumsService.personalInfoTypes.BILLING;
				})[0];
				// if there is no billing address, create a blank one and return it. Again, this goes to the problem of
				// camps requiring a billing address, but some clients not having typed addresses. In this case,
				// we create a billing address and just add it to the list.
				if (angular.isUndefined(result)) {
					this.addBlankAddress(ProfileEnumsService.personalInfoTypes.BILLING);
					result = this.addresses[this.addresses.length - 1];
				}
				return result;
			},
			copyShippingToBilling: function() {
				var billing = this.getBillingAddress(),
					shipping = this.getShippingAddress();
				billing.address = shipping.address;
				billing.address2 = shipping.address2;
				billing.city = shipping.city;
				billing.state = shipping.state;
				billing.country_code = shipping.country_code;
				billing.zip_code = shipping.zip_code;
			},
			/****
			 * phones now have two sets of defining characteristics:
			 *   is_primary is used by Siriusware clients, and is either true or false
			 *   type is used by camps. It is either ProfileEnumsService.personalInfoTypes.HOME or ProfileEnumsService.personalInfoTypes.ALTERNATIVE
			 *
			 *   Our challenge is that we need to be able to support both formats, regardless of which one is loaded.
			 *   getHomePhone (like getPrimaryAddress and getPrimaryPhone) creates a blank record if one doesn't exist.
			 *   This is because modules (and their html files) depend on the data being present.
						 */
			getHomePhone: function() {
				var result = this.phones.filter(function(phone) {
					return phone.type === ProfileEnumsService.personalInfoTypes.HOME;
				})[0];
				// if no home phone, get the primary phone and set it to being the home phone.
				// Have to do this because we're switching from just one modifier (primary) to two (is_primary and type).
				if (angular.isUndefined(result)) {
					result = this.getPrimaryPhone();
					if (angular.isDefined(result)) {
						result.type = ProfileEnumsService.personalInfoTypes.HOME;
					}
				}
				return result;
			},
			getAlternatePhone: function() {
				var result = this.phones.filter(function(phone) {
					return phone.type === ProfileEnumsService.personalInfoTypes.ALTERNATIVE;
				})[0];
				if (angular.isUndefined(result)) {
					result = new Phone(ProfileEnumsService.personalInfoTypes.ALTERNATIVE, false);
					this.phones.push(result);
				}
				return result;
			},
			getPrimaryPhone: function() {
				// get the "primary" phone. This may be different than the home phone.
				var result = this.phones.filter(function(phone) {
					return (phone.is_primary);
				})[0];

				// if there is no "primary" phone, get the home phone and make it primary.
				if (angular.isUndefined(result)) {
					result = this.phones.filter(function(phone) {
						return phone.type === ProfileEnumsService.personalInfoTypes.HOME;
					})[0];
					// couldn't find a home phone either. Add one.
					if (angular.isUndefined(result)) {
						result = new Phone(ProfileEnumsService.personalInfoTypes.HOME, true);
						this.phones.push(result);
					}
					result.is_primary = true;
				}
				return result;
			},
			getSecondaryPhone: function() {
				var result = this.phones.filter(function(phone) {
					return (!phone.is_primary);
				})[0];
				if (angular.isUndefined(result)) {
					if (this.phones.length < 2) {
						result = new Phone(ProfileEnumsService.personalInfoTypes.ALTERNATIVE, false);
						this.phones.push(result);
					}
				}
				return result;
			},
			parseMembershipProductData: function(membershipLevel) {
				if (membershipLevel) {
					this.base_membership_info.membership_product_identifier = membershipLevel;

					//pull the last value of the field
					this.base_membership_info.membership_level = parseMembershipLevel(membershipLevel);
				}
			},
			setMembershipExpireDate: function(membershipExpires) {
				this.base_membership_info.member_expire_date = getString(membershipExpires);
			},
			hasAMembership: function() {
				// A profile only has a membership if it has both base_membership_info and it has a non-blank membership_level
				return (checkProp('this.base_membership_info.membership_level', this) && this.base_membership_info.membership_level != '');
			},
			addChildBeneficiaries: function(child) {
				this.childBeneficiaries.push(child);
			},
			removeChildBeneficiaries: function(child) {
				this.childBeneficiaries.splice(this.childBeneficiaries.indexOf(child), 1);
			},
			addAdultBeneficiaries: function(adult) {
				this.adultBeneficiaries.push(adult);
			},
			removeAdultBeneficiaries: function(adult) {
				this.adultBeneficiaries.splice(this.adultBeneficiaries.indexOf(adult), 1);
			},
			getAllDependents: function() {
				return this.childBeneficiaries.concat(this.adultBeneficiaries);
			},
			addChild: function(child) {
				this.childLinkedGuests.push(child);
			},
			removeChild: function(child) {
				this.childLinkedGuests.splice(this.childLinkedGuests.indexOf(child), 1);
			},
			addAdult: function(adult) {
				this.adultLinkedGuests.push(adult);
			},
			removeAdult: function(adult) {
				this.adultLinkedGuests.splice(this.adultLinkedGuests.indexOf(adult), 1);
			},
			addOption: function(option) {
				// make sure it's not already in the profile.
				var
					preExisting = (angular.isDefined(this.options) && this.options.length > 0
						&& this.options.some(function(o) {
							return (o.name == option.name);
						}));
				if (!preExisting) {
					this.options.push(option);
				}
			},
			addToLinkedGuests: function(profile, isAdult, skipCopyStep) {
				var target = isAdult ? this.adultLinkedGuests : this.childLinkedGuests;
				var newGuest = skipCopyStep ? profile : new Profile();
				var needToReassign = false;

				if (!skipCopyStep) {
					// populate newGuest
					for (var key in profile) {
						if (profile.hasOwnProperty(key) && key.indexOf('hashKey') < 0) {
							newGuest[key] = angular.copy(profile[key]);
						}
					}
				}

				// set up target as an array
				if (angular.isUndefined(target)) {
					target = [];
					needToReassign = true;
				}
				if (!angular.isArray(target)) {
					target = [target];
					needToReassign = true;
				}
				target.push(newGuest);
				// if target does not exist, just assign it
				if (needToReassign) {
					if (isAdult) {
						this.adultLinkedGuests = target;
					} else {
						this.childLinkedGuests = target;
					}
				}
			},
			getLinkedGuestWithGuestNo: function(guest_no) {
				var result = undefined;
				if (angular.isUndefined(guest_no)) {
					return result;
				}
				result = angular.isDefined(this.adultLinkedGuests) ? this.adultLinkedGuests.filter(function(g) {
					return g.guest_no == guest_no;
				})[0] : undefined;
				if (angular.isUndefined(result)) {
					result = angular.isDefined(this.childLinkedGuests) ? this.childLinkedGuests.filter(function(g) {
						return g.guest_no == guest_no;
					})[0] : undefined;
				}
				return result;
			},
			getAllLinkedGuests: function() {
				var result = [];
				this.childLinkedGuests.forEach(function(guest) {
					result.push(guest)
				});
				this.adultLinkedGuests.forEach(function(guest) {
					result.push(guest)
				});

				return result;
			},
			/**
			 * linkedGuests builds and returns an array of members linked to the profile.
			 * If there are no linked members, the result is an empty array.
			 * @returns {Array}
			 */
			linkedGuests: function(includeSelf) {
				var result = [],
					loggedInGuest = undefined;


				if (angular.isDefined(this.adultLinkedGuests) && angular.isArray(this.adultLinkedGuests)) {
					this.adultLinkedGuests.forEach(function(guest) {
						result.push(angular.copy(guest));
					});
				}
				if (angular.isDefined(this.childLinkedGuests) && angular.isArray(this.childLinkedGuests)) {
					this.childLinkedGuests.forEach(function(guest) {
						result.push(angular.copy(guest));
					});
				}
				result.forEach(function(guest) {
					guest.name = guest.first_name.trim() + ' ' + guest.last_name.trim();
					guest.name = guest.name.trim();
				});
				// alphabetize the list
				result.sort(function(a, b) {
					return (a.name < b.name) ? -1 : a.name == b.name ? 0 : 1;
				});
				if (includeSelf) {
					loggedInGuest = angular.copy(this);
					loggedInGuest.name = loggedInGuest.first_name.trim() + ' ' + loggedInGuest.last_name.trim();
					loggedInGuest.name = loggedInGuest.name.trim();
					result.unshift(loggedInGuest);
				}

				return result;
			},
			profileImageName: function() {
				// Every guest has a guest_no. It's a SiriusWare requirement
				return this.guest_no.toString() + '.jpg';
			},
			getCalculatedAge: function() {
				// birth dates on the profile are stored according to AppData.settings.date_format. We have to switch this to YYYY-MM-DD for our age calculation to work.
				// if the birth_date is not defined or is all blank, just return true.
				if (this.birth_date) {
					var reformattedBirthDate = Utilities.formatSetDateFormatToYYYY_MM_DD(this.birth_date, AppData.settings.date_format);
					return Utilities.calculateAgeGivenDateString(reformattedBirthDate);
				} else {
					return 0;
				}
			}
		};

		vm.Profile = Profile;

		/**
		 * Address for a profile
		 * @param addressType (PRIMARY, SECONDARY etc)
		 * @constructor
		 */
		function Address(addressType) {
			this.type = addressType;
			this.address = '';
			this.address2 = '';
			this.city = '';
			this.state = null;
			this.zip_code = '';
			this.country_code = null;
		}

		vm.Address = Address;

		/**
		 * Phone number for a profile
		 * @param phoneType (PRIMARY, SECONDARY)
		 * @constructor
		 */
		function Phone(phoneType, is_primary) {
			this.type = phoneType;
			this.phone_number = '';
			this.country_code = '';
			this.region_code = '';
			this.is_primary = is_primary;
		}

		vm.Phone = Phone;

		/**
		 * Abstract parent class for a linked guest
		 * @param firstName
		 * @param lastName
		 * @constructor
		 */
		function LinkedGuest(guestNo, firstName, lastName) {
			this.guest_no = guestNo;
			this.first_name = firstName;
			this.last_name = lastName;
			this.salutation = '';
		}

		/**
		 * Adult Linked Guest - type of Linked Guest to store adults
		 * @param guestNo
		 * @param firstName
		 * @param lastName
		 * @constructor
		 */
		function AdultLinkedGuest(guestNo, firstName, lastName) {
			LinkedGuest.call(this, guestNo, firstName, lastName);
		}

		AdultLinkedGuest.prototype = Object.create(LinkedGuest.prototype);
		AdultLinkedGuest.prototype.getFullName = function() {
			var fullName = '';
			if (this.salutation.length > 0) {
				fullName += this.salutation + ' ';
			}

			fullName += this.first_name + ' ' + this.last_name;
			return fullName;
		};

		// Enable adult linked guests to copy editable data from a profile
		AdultLinkedGuest.copyEditableDataFrom = this.copyEditableDataFrom;

		vm.AdultLinkedGuest = AdultLinkedGuest;

		/**
		 * Child Linked Guest - type of Linked Guest to store children
		 * @param guestNo
		 * @param firstName
		 * @param lastName
		 * @param birthDate
		 * @constructor
		 */
		function ChildLinkedGuest(guestNo, firstName, lastName, birthDate) {
			LinkedGuest.call(this, guestNo, firstName, lastName);
			this.birth_date = angular.isDefined(birthDate) ? birthDate : '';
		}

		ChildLinkedGuest.prototype = Object.create(LinkedGuest.prototype);

		// Enable child linked guests to copy editable data from a profile
		ChildLinkedGuest.copyEditableDataFrom = this.copyEditableDataFrom;
		vm.ChildLinkedGuest = ChildLinkedGuest;


		/**
		 * OtherInfo - holds additional info
		 * @param dependent_id
		 * @constructor
		 */
		function OtherGuestInfo(dependent_id) {
			this.dependent_id = dependent_id;
			this.medical_info = new MedicalInfo();
			this.emergency_contacts = [];
			this.friend_requests = [];
			this.authorized_pickups = [];
		}

		OtherGuestInfo.prototype = {

			addOrUpdateInfo: function(property, infoToUpdate) {
				var updateFields = true;
				var itemToUpdate = undefined;
				switch (property) {
				case 'emergency_contacts': {
					itemToUpdate = this.emergency_contacts.filter(
						function(contact) {
							return contact.id === infoToUpdate.id;
						})[0];
					if (angular.isUndefined(itemToUpdate)) {
						updateFields = false;
						itemToUpdate = new EmergencyContact(infoToUpdate.id, infoToUpdate.first_name, infoToUpdate.last_name, infoToUpdate.prim_phone, infoToUpdate.alt_phone, infoToUpdate.prim_phone_country, infoToUpdate.prim_phone_region, infoToUpdate.alt_phone_country, infoToUpdate.alt_phone_region);
						this.emergency_contacts.push(itemToUpdate);
					}
					break;
				}
				case 'authorized_pickups': {
					itemToUpdate = this.authorized_pickups.filter(
						function(pickup) {
							return pickup.id === infoToUpdate.id;
						})[0];
					if (angular.isUndefined(itemToUpdate)) {
						updateFields = false;
						itemToUpdate = new AuthorizedPickup(infoToUpdate.id, infoToUpdate.codeword1, infoToUpdate.codeword2, infoToUpdate.codeword3, infoToUpdate.notes);
						this.authorized_pickups.push(itemToUpdate);
					}
					break;
				}
				case 'friend_requests': {
					itemToUpdate = this.friend_requests.filter(
						function(friend) {
							return friend.id === infoToUpdate.id;
						})[0];
					if (angular.isUndefined(itemToUpdate)) {
						updateFields = false;
						itemToUpdate = new FriendRequest(infoToUpdate.id, infoToUpdate.first_name, infoToUpdate.last_name, infoToUpdate.grade_level, infoToUpdate.instructions);
						this.friend_requests.push(itemToUpdate);
					}
					break;
				}
				case 'medical_info': {
					itemToUpdate = this.medical_info;
				}
				}

				if (updateFields) {
					Object.keys(infoToUpdate).forEach(function(key) {
						if (angular.isDefined(itemToUpdate[key])) {
							itemToUpdate[key] = infoToUpdate[key];
						}
					});
				}
			},
			getTempInfoObjectForEdit: function(numEmergContacts, numFriendReqs, numAuthPickups) {
				var tmpFields = {
					emergency_contacts: [],
					friend_requests: [],
					authorized_pickups: []
				};

				if (!this.emergency_contacts.length) {
					for (var i = 0; i < numEmergContacts; i++) {
						this.emergency_contacts.push(new EmergencyContact());
					}
				}

				this.emergency_contacts.forEach(function(contact) {
					tmpFields.emergency_contacts.push(contact.getFieldsForCopy());
				});

				if (!this.friend_requests.length) {
					for (var i = 0; i < numFriendReqs; i++) {
						this.friend_requests.push(new FriendRequest());
					}
				}

				this.friend_requests.forEach(function(friendReq) {
					tmpFields.friend_requests.push(friendReq.getFieldsForCopy());
				});

				if (!this.authorized_pickups.length) {
					for (var i = 0; i < numAuthPickups; i++) {
						this.authorized_pickups.push(new AuthorizedPickup());
					}
				}

				this.authorized_pickups.forEach(function(authPickup) {
					tmpFields.authorized_pickups.push(authPickup.getFieldsForCopy());
				});


				return tmpFields;
			},
			getTempMedicalFieldsForEdit: function() {
				var medicalInfo = {};
				angular.extend(medicalInfo, this.medical_info);
				return medicalInfo;
			},
			getNumberOfFieldsForModel: function(modelName) {
				//retrieve the number of fields for a model excluding the id
				var numFields = -1;
				var currentModel = this[modelName];
				if (angular.isDefined(currentModel)) {
					if (angular.isArray(currentModel) && currentModel.length) {
						numFields = Object.keys(currentModel[0]).length - 1;
					} else {
						numFields = Object.keys(currentModel).length - 1;
					}
				}

				return numFields;
			},
			wasPreviouslySaved: function() {
				var wasPreviouslySaved = false;
				for (i in this) {
					var section = this[i];
					if (angular.isDefined(section)) {
						if (angular.isArray(section)) {
							for (var j = 0; j < section.length; j++) {
								if (!Utilities.isEmpty(section[j].id)) {
									wasPreviouslySaved = true;
									break;
								}
							}
						} else {
							if (!Utilities.isEmpty(section.id)) {
								wasPreviouslySaved = true;
								break;
							}
						}
					}

					if (wasPreviouslySaved) {
						break;
					}
				}

				return wasPreviouslySaved;
			},
			isComplete: function(requireEmergContacts, requireFriendReqs, requireAuthPickups, requireMedical) {
				var isComplete = false;
				if (requireEmergContacts) {
					isComplete = this.emergency_contacts.length && this.emergency_contacts.every(function(contact) {
						return contact.isComplete();
					});
				}
				if (isComplete && requireFriendReqs) {
					isComplete = this.friend_requests.length && this.friend_requests.every(function(friendRequest) {
						return friendRequest.isComplete();
					});
				}
				if (isComplete && requireAuthPickups) {
					isComplete = this.authorized_pickups && this.authorized_pickups.every(function(pickup) {
						return pickup.isComplete();
					});
				}

				return isComplete;
			},
			resetInfo: function() {
				this.emergency_contacts.length = 0;
				this.friend_requests.length = 0;
				this.authorized_pickups.length = 0;
			},
			updateFieldsFromCopy: function(fields) {
				for (var i in this) {
					if (angular.isDefined(fields[i])) {
						if (angular.isArray(this[i])) {
							var sectionToCopyTo = this[i];
							var fieldToCopy = null;

							sectionToCopyTo.forEach(function(item, index) {
								var copyFieldsArray = fields[i].filter(function(fld) {
									return fld.id === item.id;
								});

								if (angular.isDefined(copyFieldsArray)) {
									fieldToCopy = UtilsValidation.validString(item.id) ? copyFieldsArray[0] : copyFieldsArray[index];
									copyFieldsDataToItem(fieldToCopy, item);
								}
							});
						} else {
							this[i] = fields[i];
						}
					}
				}
			}
		};

		/**
		 * Copying data from copyField to Camp Item
		 * @protected
		 * @param {Array} copyField
		 * @param {Array} item
		 * @returns {undefined}
		 */
		function copyFieldsDataToItem(copyField, item) {
			for (var j in item) {
				if (angular.isDefined(copyField[j])) {
					item[j] = copyField[j];
				}
			}
		}

		vm.OtherGuestInfo = OtherGuestInfo;

		function EmergencyContact(id, firstName, lastName, primaryPhone, secondaryPhone, primaryPhoneCountry, primaryPhoneRegion, secondaryPhoneCountry, secondaryPhoneRegion) {
			this.id = id || '';
			this.first_name = firstName || '';
			this.last_name = lastName || '',
			this.prim_phone = primaryPhone || '';
			this.alt_phone = secondaryPhone || '';
			this.prim_phone_country = primaryPhoneCountry || '';
			this.prim_phone_region = primaryPhoneRegion || '';
			this.alt_phone_country = secondaryPhoneCountry || '';
			this.alt_phone_region = secondaryPhoneRegion || '';
		}

		EmergencyContact.prototype.getFieldsForCopy = function() {
			var flds = { id: this.id }

			flds["first_name"] = this.first_name;
			flds["last_name"] = this.last_name;
			flds["prim_phone"] = this.prim_phone;
			flds["alt_phone"] = this.alt_phone;
			flds["prim_phone_country"] = this.prim_phone_country;
			flds["prim_phone_region"] = this.prim_phone_region;
			flds["alt_phone_country"] = this.alt_phone_country;
			flds["alt_phone_region"] = this.alt_phone_region;

			return flds;
		};

		EmergencyContact.prototype.isComplete = function() {
			return this.first_name.length && this.last_name.length && this.prim_phone.length;
		};

		function FriendRequest(id, firstName, lastName, gradeLevel, instructions) {
			this.id = id || '';
			this.first_name = firstName || '';
			this.last_name = lastName || '';
			this.grade_level = gradeLevel || '';
			this.instructions = instructions || '';
		}

		FriendRequest.prototype.isComplete = function() {
			return this.first_name.length && this.last_name.length;
		};

		FriendRequest.prototype.getFieldsForCopy = function() {
			var flds = { id: this.id }

			flds["first_name"] = this.first_name;
			flds["last_name"] = this.last_name;
			flds["grade_level"] = this.grade_level;
			flds["instructions"] = this.instructions;

			return flds;
		};

		function AuthorizedPickup(id, codeWord1, codeWord2, codeWord3, notes) {
			this.id = id || '';
			this.codeword1 = codeWord1 || '';
			this.codeword2 = codeWord2 || '';
			this.codeword3 = codeWord3 || '';
			this.notes = notes || '';
		}

		AuthorizedPickup.prototype.isComplete = function() {
			return this.codeword1.length;
		};

		AuthorizedPickup.prototype.getFieldsForCopy = function() {
			var flds = { id: this.id }

			flds["codeword1"] = this.codeword1;
			flds["codeword2"] = this.codeword2;
			flds["codeword3"] = this.codeword3;
			flds["notes"] = this.notes;

			return flds;
		};

		/**
		 * Medical Informatiom
		 * @constructor
		 */
		function MedicalInfo() {
			this.id = '';
			this.medical_treatment_flag = '1';
			this.med_first_aid_staff_flag = '0';
			this.med_first_aid_emt_flag = '0';
			this.med_emergency_emt_flag = '0';
			this.med_emergency_facility_flag = '0';
			this.med_cpr_flag = '0';
			this.med_aed_flag = '0';
			this.medical_limitations = '';
			this.insurance_phone = '';
			this.insurance_company = '';
			this.insurance_policy = '';
			this.insurance_group = '';
			this.doctor_fullname = '';
			this.doctor_phone = '';
			this.photography_waiver_flag = '0';
			this.accident_waiver_flag = '0';
			this.vaccination_waiver_flag = '0';
		}


		/**
		 * Option - the notion of an opt-in
		 * @param name
		 * @param value
		 * @constructor
		 */
		function Option(name, value, skipBooleanEvaluation) {
			this.name = name;
			this.value = skipBooleanEvaluation ? value : Utilities.getBoolean(value);
		}

		vm.Option = Option;


		//models for other basic structures for the Profle modules

		/**
		 * Model for a FieldToAppendOnBackendRequest
		 *
		 * @param name
		 * @constructor
		 */
		function FieldToAppendOnBackendRequest(name) {
			this.prop_name = name;
			this.prop_value = '';
		}

		FieldToAppendOnBackendRequest.prototype.toJSON = function() {
			return {
				prop_name: this.prop_name,
				prop_value: this.prop_value
			};
		};

		vm.FieldToAppendOnBackendRequest = FieldToAppendOnBackendRequest;

		/**
		 * Stores information that relates to available memberships that can be renewed
		 * @name Renewals
		 * @class
		 * @constructor
		 */
		function Renewals() {
			this.membership_level = '';
			this.package_id = null;
			this.CT = [];
		}

		/**
		 * Sets the main membership level for Renewals
		 * @name Renewals#setMembershipLevel
		 * @function
		 * @returns {undefined}
		 */
		Renewals.prototype.setMembershipLevel = function setRenewalsMembershipLevel(value) {
			this.membership_level = value;
		};

		/**
		 * Gets the membership levekl for the renewal
		 * @name Renewals#getMembershipLevel
		 * @function
		 * @returns {String} The renewal membership level
		 */
		Renewals.prototype.getMembershipLevel = function getRenewalsMembershipLevel() {
			return this.membership_level;
		};

		/**
		 * Sets the package id that can be used for Renewals
		 * @name Renewals#setPackageId
		 * @function
		 * @returns {undefined}
		 */
		Renewals.prototype.setPackageId = function setRenewalsPackageId(value) {
			this.package_id = value;
		};

		/**
		 * Gets the package id the renewal is good for
		 * @name Renewals#getPackageId
		 * @function
		 * @returns {String} The Package Id
		 */
		Renewals.prototype.getPackageId = function getRenewalsPackageId() {
			return this.package_id;
		};

		/**
		 * Gets the Customer Types the renewal can use
		 * @name Renewals#getCustomerTypes
		 * @function
		 * @returns {Object[]} The Customer Types
		 */
		Renewals.prototype.getCustomerTypes = function getCustomerTypes() {
			return this.CT;
		};

		/**
		 * adds an unique customer type for the available renewal
		 * @name Renewals#addCustomerType
		 * @function
		 * @param {String} id the customer type id
		 * @param {String} level the membership level
		 * @returns {undefined}
		 */
		Renewals.prototype.addCustomerType = function addRenewalCustomerType(id, level) {
			// Only add customer type if it doesn't already exist in the array
			if (!this.CT.some(findRenewalsCtDuplicate)) {
				this.CT.push({
					id: id,
					membership_level: level
				});
			}

			/**
			 * Function to check for duplicates
			 * @function
			 * @param {Object} item The item to check
			 * @returns {Boolean} True if it is a duplicate, false otherwise
			 */
			function findRenewalsCtDuplicate(item) {
				return item.id === id && item.membership_level === level;
			}
		}

		// Makes Renewals pubically available to ProfileModels
		vm.Renewals = Renewals;

		function Membership() {
			this.flex_adult = 0;
			this.flex_youth = 0;
			this.member_id = '';
			this.member_expire_date = '';
			this.membership_level = '';
			this.membership_product_identifier = '';
			this.eligible_for_renewal = false;
		}

		Membership.prototype.toJSON = function() {
			return {
				flex_adult: this.flex_adult,
				flex_youth: this.flex_youth,
				member_id: this.member_id,
				member_expire_date: this.member_expire_date,
				membership_level: this.membership_level,
				eligible_for_renewal: this.eligible_for_renewal,
				membership_product_identifier: this.membership_product_identifier
			}
		};

		vm.Membership = Membership;

		/**
		 * A Class Configurable Field that ultimately we can use to guide the display customizable fields on certain views within the Cultural Membership Wizard
		 * @param name
		 * @param value
		 * @param fieldType (checkbox, radiobool, dropdown, stepper, date_dropdown)
		 * @constructor
		 */
		function ConfigurableOptionField(name, value, fieldType) {
			this.name = name;
			this.field_value = value;
			this.field_type = fieldType;
			this.show_info_modal = false;
			this.max_value = 0;
			this.min_value = 0;
			this.truth_value = 1;
			this.false_value = 0;
			this.profile_property_mapping_section = undefined;
			this.profile_property_mapping_property = undefined;
			this.profile_property_mapping_value = undefined;
			this.add_to_cart_charac_name_mapping = undefined;
			this.package_charac_name_mapping = undefined;
			this.options_locale_target = '';
			this.value_to_trigger_alt_collection = '';
			this.alt_collection_field_value = '';
			this.required = false;
			this.size = 6;
			this.supported_membership_level_mappings = [];
			this.column = 1;
			this.profile_manager_page = 0;

			this.getValue = function() {
				return this.field_value === this.value_to_trigger_alt_collection ? this.alt_collection_field_value : this.field_value;
			};

			/**
			 * data_entry_type gives us a level between the field type and validation indicated by the config and they style of input that
			 * we're going to use. Currently, the mappings done are:
			 *   1. for text fields, if the validation is positivenumbers and there is a nonzero max value, return numericFieldWithRange
			 * @returns {*}
			 */
			this.data_entry_type = function() {
				if (this.field_type == 'text') {
					if (angular.isDefined(this.validation) && this.validation == 'positivenumbers' && this.max_value > 0) {
						return 'numericFieldWithRange';
					}
				}
				return this.field_type;
			};
		}

		vm.ConfigurableOptionField = ConfigurableOptionField;


		/**
		* Get the value for a input field from the profile value
		* @param {Object} fld The field object
		* @param {String} profileValue The value from the profile
		* @param {Boolean} [reverse] True if you wish to get the opposite mathematical value
		* @returns {String|Number}
		*/
		function getFieldValueFromProfileValue(fld, profileValue, reverse) {
			var result = profileValue,
				factor,
				operation,
				reverseMap = {
					'/': '*',
					'*': '/',
					'+': '-',
					'-': '+',
					'%': null
				};

			if (angular.isDefined(fld.conversion) && angular.isDefined(fld.conversion.operation) && angular.isDefined(fld.conversion.factor)) {
				// if we're converting, we have to be working with integers. This may change in the future...
				result = forceInt(result);
				factor = forceInt(fld.conversion.factor);
				operation = reverse ? reverseMap[fld.conversion.operation] : fld.conversion.operation;
				switch (operation) {
				case '/': return (factor !== 0) ? Math.floor(result / factor) : result;
				case '*': return result * factor;
				case '+': return result + factor;
				case '-': return result - factor;
				case '%': return (factor !== 0) ? result % factor : result;
				default: return result == profileValue ? result : profileValue;
				}
			}

			return profileValue;
		}

		vm.getFieldValueFromProfileValue = getFieldValueFromProfileValue;


		/**
		 * Gets the Membership level from a pipe delimited membershipLevel string
		 * @param {String} membershipLevel the membershipLevel string
		 * @returns {String} the membershipLevel
		 */
		function parseMembershipLevel(membershipLevel) {
			return getString(membershipLevel).replace(/^.*\|/, '');
		}

		vm.parseMembershipLevel = parseMembershipLevel;
	});

(function() {
	'use strict';

	angular.module('profile').factory('ProfileUtilitiesService', ProfileUtilitiesService);

	/**
	 * The ProfileUtilitiesService
	 * @param {Service} FormValidation FormValidation service
	 * @returns {ProfileUtilitiesService} A new instance of this factory
	 * @ngInject
	 */
	function ProfileUtilitiesService(FormValidation) {
		var factory = { addEmailOrMemberIdToRequest: addEmailOrMemberIdToRequest };
		return factory;

		/**
		 * Handles adding either email or member_id to a request object based on Regex
		 * @public
		 * @param {string} field The field to check
		 * @param {object} req The request object to update
		 * @returns {undefined}
		 */
		function addEmailOrMemberIdToRequest(field, req) {
			if (FormValidation.getEmail().test(field)) {
				req.email = field;
				req.username = field;
			} else {
				req.member_id = field;
			}
		}
	}
})();

(function() {
	'use strict';

	angular
		.module('profile')
		.factory('ProfileEnumsService', function() {
			var factory = {
				personalInfoTypes: {
					PRIMARY: 'primary',
					SECONDARY: 'secondary',
					HOME: 'HOM', // matches text returned by API
					SHIPPING: 'SHP', // matches text returned by API
					BILLING: 'BIL', // matches text returned by API
					ALTERNATIVE: 'ALT' // matches text returned by API
				},
				ACTION_GROUPS: {
					MEMBER_LOGIN_SUCCESS: "memberLoginSuccess",
					MEMBER_LOGOUT: "memberLogout",
					POST_PURCHASE: "postPurchase"
				},
				CONFIGURABLE_FIELDS_MAPPING: {
					max_value: {
						config_field_name: 'max_value',
						checkBoolean: false
					},
					min_value: {
						config_field_name: 'min_value',
						checkBoolean: false
					},
					truth_value: {
						config_field_name: 'truth_value',
						checkBoolean: false
					},
					false_value: {
						config_field_name: 'false_value',
						checkBoolean: false
					},
					show_info_modal: {
						config_field_name: 'show_info_modal',
						checkBoolean: true
					},
					required: {
						config_field_name: 'required',
						checkBoolean: true
					},
					profile_property_mapping_section: {
						config_field_name: 'profile_property_mapping_section'
					},
					profile_property_mapping_property: {
						config_field_name: 'profile_property_mapping_property'
					},
					profile_property_mapping_value: {
						config_field_name: 'profile_property_mapping_value'
					},
					add_to_cart_charac_name_mapping: {
						config_field_name: 'add_to_cart_charac_name_mapping'
					},
					package_charac_name_mapping: {
						config_field_name: 'package_charac_name_mapping'
					},
					placeholder_locale_target: {
						config_field_name: 'placeholder_locale_target'
					},
					value_to_trigger_alt_collection: {
						config_field_name: 'value_to_trigger_alt_collection'
					},
					date_fields_to_display: {
						config_field_name: 'date_fields_to_display'
					},
					max_year: {
						config_field_name: 'max_year'
					},
					format_to_save: {
						config_field_name: 'format_to_save'
					},
					size: {
						config_field_name: 'size'
					},
					supports_all_membership_levels: {
						config_field_name: 'supports_all_membership_levels'
					},
					supported_membership_level_mappings: {
						config_field_name: 'supported_membership_level_mappings'
					},
					validation: {
						config_field_name: 'validation'
					},
					profile_manager_page: {
						config_field_name: 'profile_manager_page'
					},
					column: {
						config_field_name: 'column'
					}
				}
			};

			return factory;
		});
})();
angular
	.module('profile')
	.service('ProfileRequestService', function(
		AppData,
		Enums,
		RouteRejectionService,
		Language,
		ProfileEnumsService,
		ProfileModels,
		ProfileManagerEnumsService,
		Utilities,
		UtilsValidation,
		$filter,
		$q,
		$rootScope,
		$injector) {
		/**
		 * Option fields that we interpret from Backend and also send to Backend that should override the default
		 * boolean evaluation behaviour.
		 * These are fields that we will allow passed back and forth as just straight text fields
		 * @type {Array}
		 */
		var textOptionFieldOverrides = [],
			safelyCheckPropertyOnObject = Utilities.safelyCheckPropertyOnObject,
			wrapObjectToArray = Utilities.wrapObjectToArray,
			validArray = UtilsValidation.validArray,
			benefitsMembership = [];

		/**
		 * Adds base node
		 * @param {Object} baseNode The base node
		 * @param {Object} node The node to add
		 * @returns {*|string} The newly created node
		 */
		function addBaseNode(baseNode, node) {
			if (baseNode) {
				return baseNode + '.' + node;
			}
			return node;
		}

		/**
		 * The following helper classes define the schema mappings to map profile fields to sections of CREATE/UPDATE
		 * profile requests and vice versa
		 * Each one contains:
		 * 	reqRespNode: the node in the response data where this data is located
		 * 	copyToProfileAction: Copies the fields from response to profile
		 * 	copyToRequestAction: Copies the fields from the profile data structure (fields) to a request object.
		 * 	fields: The fields mapped for this section of the data.
		 * 	copyToProfileFromResponse: Only used for those sections that read entire profiles.
		 *
		 * These classes are encapsulated in ProfileRequestMapping.
		 * @param {Object} baseNode The base node for the request/response
		 * @param {Boolean} isProfileOfLinkedGuest Whether the profile is a linked guest
		 * @returns {undefined}
		 */
		function MainInfoProfileReqMapping(baseNode, isProfileOfLinkedGuest) {
			this.reqRespNode = baseNode;
			this.isProfileOfLinkedGuest = !!isProfileOfLinkedGuest;
			this.copyToProfileAction = function(profile, fields) {
				if (angular.isDefined(fields.birth_date) && fields.birth_date.length > 0) {
					var tmpDate = fields.birth_date.replace(/-/g, '/');
					fields.birth_date = $filter('date')(new Date(tmpDate), AppData.settings.date_format);
				}
				fields.sex = angular.isDefined(fields.sex) ? fields.sex.toLowerCase() : '';
				angular.extend(profile, fields);
			};

			this.copyToRequestAction = function(requestPart, fields) {
				if (angular.isDefined(fields.birth_date)) {
					fields.birth_date = (fields.birth_date.length > 0 ? Utilities.formatSetDateFormatToYYYY_MM_DD(fields.birth_date, AppData.settings.date_format) : fields.birth_date);
					angular.extend(requestPart, this.trimFieldsForRequest(fields));
				}
			};

			this.trimFieldsForRequest = function(fields) {
				var reducedFields = angular.copy(fields);
				if (!this.isProfileOfLinkedGuest) {
					// if we're not dealing with a linked guest, we need to remove the guest_no from the profile
					delete (reducedFields.guest_no);
				}
				if (angular.isDefined(reducedFields.image_path)) {
					// We never include the image name in a request. Instead, we set 'with_image' to being '1' on the
					// root of the request; that notifies the backend that there's a new file for them to find.
					delete (reducedFields.image_path);
				}
				// Trim off any undefined fields (for example, when customer_id is undefined) we don't want to send
				// undefined fields to the API
				for (var prop in reducedFields) {
					if (reducedFields.hasOwnProperty(prop) && reducedFields[prop] === undefined) {
						delete reducedFields[prop];
					}
				}
				return reducedFields;
			};

			this.fields = {
				guest_no: { mapping: 'guest_no' },
				first_name: { mapping: 'first_name' },
				last_name: { mapping: 'last_name' },
				middle_initial: { mapping: 'mi' }, // Only used by camps
				birth_date: { mapping: 'birth_date' },
				birth_place: { mapping: 'birth_place' }, // Used by SIAE
				password: { mapping: 'password' },
				security_contact_primary_phone: { mapping: 'alt_contact_prim_phone' }, // only used by camps.
				security_contact_phone: { mapping: 'alt_contact_alt_phone' }, // only used by camps.
				security_contact: { mapping: 'alt_contact_name' }, // only used by camps.
				entering_grade: { mapping: 'entering_grade' }, // only used by camps
				current_grade: { mapping: 'current_grade' }, // only used by camps
				shirt_size: { mapping: 'shirtsize' }, // only used by camps
				sex: { mapping: ['sex', 'gender'] }, // camps dependents use 'gender'
				salutation: { mapping: 'salutation' },
				image: { mapping: 'image_path' },
				email: { mapping: 'username' }
			};

			/**
			 * Understanding IDs:
			 * With Siriusware clients, every profile has a guest_no.
			 * With non-Siriusware clients, every profile has either a customer_id (if it's not a linked guest), or a
			 * dependent_id (if it is a linked guest).
			 **/
			if (!this.isProfileOfLinkedGuest) {
				// Only set by profiles that have been upated with 'create_internal' set to 1
				this.fields.customer_id = { mapping: 'customer_id' };
			} else {
				// Only set by profiles that have been upated with 'create_internal' set to 1
				this.fields.dependent_id = { mapping: 'dependent_id' };
			}
		}

		/**
		 * Handles mapping of the EMAIL node from profile
		 * @param {Object} baseNode The base node
		 * @param {Boolean} isProfileOfLinkedGuest Whether the profile is a linked guest
		 * @returns {undefined}
		 */
		function EmailProfileReqMapping(baseNode, isProfileOfLinkedGuest) {
			this.reqRespNode = addBaseNode(baseNode, 'EMAIL');
			this.copyToProfileAction = function(profile, fields) {
				angular.extend(profile, fields);
			};
			this.copyToRequestAction = function(requestPart, fields) {
				angular.extend(requestPart, fields);
			};
			this.fields = { email: { mapping: 'email_address' } };
		}

		/**
		 * Handles mapping of the Address node from profile
		 * @param {Object} baseNode The base node
		 * @param {Boolean} isProfileOfLinkedGuest Whether the profile is a linked guest
		 * @returns {undefined}
		 */
		function AddressProfileReqMapping(baseNode, isProfileOfLinkedGuest) {
			this.reqRespNode = addBaseNode(baseNode, 'ADDRESSES.ADDRESS');
			this.clearProfileAction = function(profile) {
				profile.addresses = [];
			};
			this.copyToProfileAction = function(profile, fields) {
				// calculate default types, in case the API does not return them.
				if (angular.isUndefined(fields.type) || fields.type.length < 1) {
					switch (profile.addresses.length) {
					case 0:
						fields.type = ProfileEnumsService.personalInfoTypes.HOME;
						break;
					case 1:
						fields.type = ProfileEnumsService.personalInfoTypes.SHIPPING;
						break;
					case 2:
						fields.type = ProfileEnumsService.personalInfoTypes.BILLING;
						break;
					default:
						fields.type = ProfileEnumsService.personalInfoTypes.ALTERNATIVE;
					}
				}
				var addr = new ProfileModels.Address(fields.type);
				angular.extend(addr, fields);
				profile.addresses.push(addr);
			};
			this.copyToRequestAction = function(requestPart, fields) {
				requestPart.push(fields);
			};
			this.profileModelSection = 'addresses';
			this.fields = {
				address: { mapping: 'street' },
				address2: { mapping: 'co_dept' },
				city: { mapping: 'city' },
				state: { mapping: ['state', 'state_province'] },
				country_code: { mapping: 'country' },
				zip_code: { mapping: 'zip' },
				type: { mapping: 'type' } // added for camps
			};
		}

		/**
		 * Handles mapping of the Camps Address node from profile
		 * @param {Object} baseNode The base node
		 * @param {Boolean} isProfileOfLinkedGuest Whether the profile is a linked guest
		 * @returns {undefined}
		 */
		function CampsAddressProfileReqMapping(baseNode, isProfileOfLinkedGuest) {
			// Camps dependents don't have a list of addresses, they have one.
			// We're mapping this into our regular address structure.
			// There should not be a case where 'ADDRESSES' and 'ADDRESS' both exist, but if it happens, they'll all
			// get dumped into the same ADDRESSES array.

			// copy the AddressProfileReqMapping class, so we can use its field and section.
			var classToCopy = new AddressProfileReqMapping(baseNode, isProfileOfLinkedGuest);
			this.profileModelSection = classToCopy.profileModelSection;
			this.fields = classToCopy.fields;

			this.reqRespNode = addBaseNode(baseNode, 'ADDRESS');
			this.clearProfileAction = function(profile) {
				profile.addresses = [];
			};
			this.copyToProfileAction = function(profile, fields) {
				// calculate default types, in case the API does not return them.
				if (angular.isUndefined(fields.type) || fields.type.length < 1) {
					fields.type = ProfileEnumsService.personalInfoTypes.HOME;
				}
				var addr = new ProfileModels.Address(fields.type);
				angular.extend(addr, fields);
				profile.addresses.push(addr);
			};
			this.copyToRequestAction = function(requestPart, fields) {
				// This never happens, because the data is saved as part of AddressProfileReqMapping (in ADDRESSES.ADDRESS)
			};
		}

		/**
		 * Handles mapping of the Phone node from profile
		 * @param {Object} baseNode The base node
		 * @param {Boolean} isProfileOfLinkedGuest Whether the profile is a linked guest
		 * @returns {undefined}
		 */
		function PhoneProfileReqMapping(baseNode, isProfileOfLinkedGuest) {
			this.reqRespNode = addBaseNode(baseNode, 'PHONES.PHONE');
			this.clearProfileAction = function(profile) {
				profile.phones = [];
			};

			this.copyToProfileAction = function(profile, fields) {
				// calculate default types and is_primary values, in case the API has not returned them.
				var is_primary = false;
				var phone;
				if (profile.phones.length < 1) {
					is_primary = angular.isDefined(fields.is_primary) ? Utilities.getBoolean(fields.is_primary) : true;
					fields.type = angular.isDefined(fields.type) ? fields.type : fields.type = ProfileEnumsService.personalInfoTypes.HOME;
				} else {
					is_primary = angular.isDefined(fields.is_primary) ? Utilities.getBoolean(fields.is_primary) : false;
					fields.type = angular.isDefined(fields.type) ? fields.type : fields.type = ProfileEnumsService.personalInfoTypes.ALTERNATIVE;
				}
				phone = new ProfileModels.Phone(fields.type, is_primary);
				phone.phone_number = angular.copy(fields.phone_number);
				phone.region_code = angular.copy(fields.region_code);

				// Add plus prefix to Country Code
				if (/^\d+$/.test(fields.country_code)) {
					phone.country_code = '+' + fields.country_code;
				}

				profile.phones.push(phone);
			};
			this.copyToRequestAction = function(requestPart, fields) {
				var newFields = angular.copy(fields);
				// convert boolean to '1' or '0'
				newFields.is_primary = newFields.is_primary ? '1' : '0';
				// remove plus from country code
				newFields.country_code = newFields.country_code.replace('+', '');
				requestPart.push(newFields);
			};
			this.profileModelSection = 'phones';
			this.fields = {
				country_code: { mapping: 'country_code' },
				is_primary: {
					mapping: 'is_primary',
					excludeFromCopyToProfile: true
				},
				phone_number: { mapping: 'number' },
				region_code: { mapping: 'region_code' },
				type: {
					mapping: 'type',
					excludeFromCopyToProfile: true
				}
			};
		}

		/**
		 * Handles mapping of the Adult Beneficiary node from profile
		 * @param {Object} baseNode The base node
		 * @param {Boolean} useDependentsNode Whether to use the dependent node
		 * @returns {undefined}
		 */
		function AdultBeneficiariesProfileReqMapping(baseNode, useDependentsNode) {
			this.useDependentsNode = !!useDependentsNode;

			// useDependentsNode used to control where the ADULT node lived. It doesn't anymore.
			this.reqRespNode = addBaseNode(baseNode, 'BENEFICIARIES.BENEFICIARY');
			// copyToProfileFromResponse handles mapping

			this.copyToProfileFromResponse = function(profile, response) {
				var adultArray = angular.isArray(response) ? response : [response];
				adultArray = adultArray.filter(function(beneficiary) {
					return beneficiary.type == 'adult';
				});
				adultArray.forEach(function(adult) {
					//beneficiaries use the same module as linked guest but they are a different classification
					var adultBeneficiaries = new ProfileModels.AdultLinkedGuest(adult.guest_no, adult.first_name, adult.last_name);
					adultBeneficiaries.salutation = angular.isDefined(adult.salutation) ? adult.salutation : '';

					profile.addAdultBeneficiaries(adultBeneficiaries);
				});
			};

			this.clearProfileAction = function(profile) {
				profile.adultBeneficiaries = [];
			};
			this.copyToProfileAction = function(profile, fields) {
				// Nothing to do here. The adult was added in the copyToProfileFromResponse method.
			};
			this.copyToRequestAction = function(requestPart, fields) {
				// we're never sending linked guests in the request.
				// requestPart.push(angular.copy(fields));
			};
			this.profileModelSection = 'adultBeneficiaries';
			this.fields = {
				guest_no: { mapping: 'guest_no' },
				first_name: { mapping: 'first_name' },
				last_name: { mapping: 'last_name' },
				salutation: { mapping: 'salutation' }
			};
		}

		/**
		 * Handles mapping of the Child Beneficiary node from profile
		 * @param {Object} baseNode The base node
		 * @param {Boolean} useDependentsNode Whether to use the dependent node
		 * @returns {undefined}
		 */
		function ChildBeneficiariesProfileReqMapping(baseNode, useDependentsNode) {
			this.useDependentsNode = !!useDependentsNode;

			if (this.useDependentsNode) {
				this.reqRespNode = addBaseNode(baseNode, 'DEPENDENTS');
			} else {
				this.reqRespNode = addBaseNode(baseNode, 'BENEFICIARIES.BENEFICIARY');
			}

			this.copyToProfileFromResponse = function(profile, response) {
				var childArray = angular.isArray(response) ? response : [response];
				childArray = childArray.filter(function(beneficiary) {
					return beneficiary.type == 'child'
				});
				childArray.forEach(function(child) {
					if (angular.isDefined(child.birth_date) && child.birth_date.length > 0) {
						var tmpDate = child.birth_date.replace(/-/g, '/');
						child.birth_date = $filter('date')(new Date(tmpDate), AppData.settings.date_format);
					}
					//we use the same model for beneficiaries
					var childBeneficiary = new ProfileModels.ChildLinkedGuest(child.guest_no, child.first_name, child.last_name, child.birth_date);
					profile.addChildBeneficiaries(childBeneficiary);
				});
			};

			this.clearProfileAction = function(profile) {
				profile.childBeneficiaries = [];
			};
			this.copyToProfileAction = function(profile, fields) {
				// Nothing to do here. The child was added in the copyToProfileFromResponse method.
			};
			this.copyToRequestAction = function(requestPart, fields) {
				// We're never sending linked guests in the request.
			};
			this.profileModelSection = 'childBeneficiaries';
			this.fields = {
				guest_no: { mapping: 'guest_no' },
				first_name: { mapping: 'first_name' },
				last_name: { mapping: 'last_name' },
				birth_date: { mapping: 'birth_date' }
			};
		}

		/**
		 * Handles mapping of the Linked Adults Guests node from profile
		 * @param {Object} baseNode The base node
		 * @param {Boolean} useDependentsNode Whether to use the dependent node
		 * @returns {undefined}
		 */
		function LinkedAdultGuestsProfileReqMapping(baseNode, useDependentsNode) {
			// isProfileOfLinkedGuest is always false here. We don't handle the linked guests of linked guests.
			var isProfileOfLinkedGuest = false;
			this.useDependentsNode = !!useDependentsNode;

			// useDependentsNode used to control where the ADULT node lived. It doesn't anymore.
			this.reqRespNode = addBaseNode(baseNode, 'LINKED_GUESTS.ADULTS.ADULT');

			// copyToProfileFromResponse handles mapping
			if (!isProfileOfLinkedGuest) {
				this.copyToProfileFromResponse = function(profile, response) {
					var adultArray = angular.isArray(response) ? response : [response];
					adultArray.forEach(function(adult) {
						var newProfile = new ProfileModels.Profile();
						if (angular.isDefined(profile.customer_id)) {
							newProfile.parent_customer_id = profile.customer_id;
						}
						transformResponseIntoProfile(new ProfileRequestMapping('', true), newProfile, adult);

						delete (newProfile.adultLinkedGuests);
						profile.addAdult(newProfile);
					});
				};
			}
			this.clearProfileAction = function(profile) {
				profile.adultLinkedGuests = [];
			};
			this.copyToProfileAction = function(profile, fields) {
				// Nothing to do here. The adult was added in the copyToProfileFromResponse method.
			};
			this.copyToRequestAction = function(requestPart, fields) {
				// we're never sending linked guests in the request.
				// requestPart.push(angular.copy(fields));
			};
			this.profileModelSection = 'adultLinkedGuests';
			this.fields = {
				guest_no: { mapping: 'guest_no' },
				first_name: { mapping: 'first_name' },
				last_name: { mapping: 'last_name' },
				salutation: { mapping: 'salutation' }
			};
		}

		/**
		 * Handles mapping of the Linked Child Guests node from profile
		 * @param {Object} baseNode The base node
		 * @param {Boolean} useDependentsNode Whether to use the dependent node
		 * @returns {undefined}
		 */
		function LinkedChildGuestsProfileReqMapping(baseNode, useDependentsNode) {
			// isProfileOfLinkedGuest is always false here. We don't handle the linked guests of linked guests.
			var isProfileOfLinkedGuest = false;

			this.useDependentsNode = !!useDependentsNode;

			if (this.useDependentsNode) {
				this.reqRespNode = addBaseNode(baseNode, 'DEPENDENTS');
			} else {
				this.reqRespNode = addBaseNode(baseNode, 'LINKED_GUESTS.CHILDREN.CHILD');
			}
			if (!isProfileOfLinkedGuest) {
				this.copyToProfileFromResponse = function(profile, response) {
					var childArray = angular.isArray(response) ? response : [response];
					childArray.forEach(function(child) {
						var newProfile = new ProfileModels.Profile();
						if (angular.isDefined(profile.customer_id)) {
							newProfile.parent_customer_id = profile.customer_id;
						}
						transformResponseIntoProfile(new ProfileRequestMapping('', true), newProfile, child);

						delete (newProfile.childLinkedGuests); // don't have kids on kids
						profile.addChild(newProfile);
					});
				};
			}

			this.clearProfileAction = function(profile) {
				profile.childLinkedGuests = [];
			};
			this.copyToProfileAction = function(profile, fields) {
				// Nothing to do here. The child was added in the copyToProfileFromResponse method.
			};
			this.copyToRequestAction = function(requestPart, fields) {
				// We're never sending linked guests in the request.
			};
			this.profileModelSection = 'childLinkedGuests';
			this.fields = {
				guest_no: { mapping: 'guest_no' },
				first_name: { mapping: 'first_name' },
				last_name: { mapping: 'last_name' },
				birth_date: { mapping: 'birth_date' }
			};
		}

		/**
		 * Handles mapping of the Relationship node from profile
		 * @param {Object} baseNode The base node
		 * @returns {undefined}
		 */
		function RelationshipReqMapping(baseNode) {
			this.reqRespNode = addBaseNode(baseNode, 'RELATIONSHIPS.RELATIONSHIP');
			this.clearProfileAction = function(profile) {
				profile.relationshipType = '';
			};

			this.copyToProfileAction = function(profile, fields) {
				/**
				 * Format of the RELATIONSHIPS node on the response:
				 * <RELATIONSHIPS>
				 *    <RELATIONSHIP cust_dep_rel_type='Externally Linked' cust_dep_rel_type_id='52' cust_first='F&amp;apos;irst' cust_id='119' cust_last='O&amp;apos;Last' dep_cust_rel_type='Externally Linked' dependent_id='83' />
				 * </RELATIONSHIPS>
				 *
				 * We only want the node that has a custid that equals the current profile's customer_id.
				 **/
				if (angular.isDefined(fields.parent) && fields.parent == profile.parent_customer_id) {
					profile.relationshipType = Utilities.forceInt(fields.relationship_type);
				}
			};
			this.copyToRequestAction = function(requestPart, fields) {
				// The relationship is never copied into the profile.
				// Instead, it's added to the request outside the profile node.
			};
			this.fields = {
				parent: { mapping: 'cust_id' },
				relationship_type: { mapping: 'cust_dep_rel_type_id' }
			};
		}

		/**
		 * Handles mapping of the Options node from profile
		 * @param {Object} baseNode The base node
		 * @param {Boolean} isProfileOfLinkedGuest Whether it is the profile of a linked guest
		 * @returns {undefined}
		 */
		function OptionsProfileReqMapping(baseNode, isProfileOfLinkedGuest) {
			this.reqRespNode = addBaseNode(baseNode, 'OPTIONS.OPTION');

			this.clearProfileAction = function(profile) {
				profile.options = [];
			};
			this.copyToProfileAction = function(profile, fields) {
				var option = new ProfileModels.Option(fields.name, fields.value, textOptionFieldOverrides.indexOf(fields.name) > -1);
				profile.addOption(option);
			};
			this.copyToRequestAction = function(requestPart, fields) {
				fields.value = textOptionFieldOverrides.indexOf(fields.name) > -1 ? fields.value : (Utilities.getBoolean(fields.value) ? 'true' : 'false');
				requestPart.push(angular.copy(fields));
			};
			this.profileModelSection = 'options';
			this.fields = {
				name: { mapping: 'name' },
				value: { mapping: 'value' }
			};
		}

		/**
		 * Handles mapping of Member Profiles
		 * @param {Object} baseNode The base node
		 * @returns {undefined}
		 */
		function MemberProfileReqMapping(baseNode) {
			this.reqRespNode = addBaseNode(baseNode, 'MEMBERSHIP');
			this.copyToProfileAction = function(profile, fields) {
				angular.extend(profile, fields);
			};
			this.copyToProfileFromResponse = function(profile, response) {
				var childArray = angular.isArray(response) ? response : [response];
				profile.wtp_no = [];
				childArray.forEach(function(child) {
					if (safelyCheckPropertyOnObject('child.flex_adult', child)) {
						profile.base_membership_info.flex_adult = Number(child.flex_adult);
					}
					if (safelyCheckPropertyOnObject('child.flex_youth', child)) {
						profile.base_membership_info.flex_youth = Number(child.flex_youth);
					}
					if (safelyCheckPropertyOnObject('response.wtp_no', response, 'validString')) {
						// check if wtp_no does not contain the word 'PICKUP'
						if (!response.wtp_no.trim().includes('PICKUP')) {
							profile.wtp_no.push(response.wtp_no);
						}
					}
				});
			};
			this.copyToRequestAction = function(requestPart, fields) {
				// no wtp numbers are sent with requests.
			};
			this.fields = {
				flex_adult: { mapping: 'flex_adult' },
				flex_youth: { mapping: 'flex_youth' },
				wtp_no: { mapping: 'wtp_no' }
			};
		}

		/**
		 * Handles mapping of Child Memberships
		 * @param {Object} baseNode The base node
		 * @returns {undefined}
		 */
		function ChildMembershipsMapping(baseNode) {
			this.reqRespNode = addBaseNode(baseNode, 'MEMBERSHIP.CHILD_MEMBERSHIPS.CHILD_MEMBERSHIP');

			this.copyToProfileFromResponse = function(profile, resp) {
				wrapObjectToArray(resp, true).forEach(function(childMem) {
					// Check if wtp_no exists and does not include 'PICKUP'
					if (safelyCheckPropertyOnObject('childMem.wtp_no', childMem, 'validString') && !childMem.wtp_no.trim().includes('PICKUP')) {
						// If wtp_no is not an array, make it one
						wrapObjectToArray(childMem.wtp_no, true);
					} else {
						// Initialize wtp_no as an empty array if it doesn't exist or includes 'PICKUP'
						childMem.wtp_no = [];
					}
					// Always add child membership to profile
					profile.addChildMembership(childMem.member_id, childMem.membership_level, childMem.membership_expires, childMem.wtp_no);
				});
			};

			this.copyToRequestAction = angular.noop;
		}

		/**
		 * Handles mapping of the Membership node
		 * @param {Object} baseNode The base node
		 * @returns {undefined}
		 */
		function MembershipReqMapping(baseNode) {
			this.reqRespNode = addBaseNode(baseNode, 'MEMBERSHIP');

			this.copyToProfileAction = function(profile, fields) {
				profile.parseMembershipProductData(fields.level);
				profile.setMembershipExpireDate(fields.expires);
				profile.base_membership_info.member_id = Utilities.getString(fields.memberId);
				profile.base_membership_info.eligible_for_renewal = Utilities.getBoolean(fields.eligible);
			};

			this.copyToRequestAction = angular.noop;

			this.fields = {
				eligible: { mapping: 'eligible_for_renewal' },
				expires: { mapping: 'membership_expires' },
				level: { mapping: 'membership_level' },
				memberId: { mapping: 'member_id' }
			};
		}

		/**
		 * Handles mapping of the RENEWALS node from profile
		 * @param {Object} baseNode The base node
		 * @returns {undefined}
		 */
		function MembershipRenewalsMapping(baseNode) {
			this.reqRespNode = addBaseNode(baseNode, 'RENEWALS');

			this.clearProfileAction = function(profile) {
				profile.renewals = [];
			};

			this.copyToProfileAction = function(profile, fields) {
				var items = wrapObjectToArray(angular.copy(fields.renewals), true);

				// Ensure that the profile renewals are reset
				profile.renewals = [];

				items.forEach(function loopRenewals(item) {
					var renewal = new ProfileModels.Renewals();
					var cts = safelyCheckPropertyOnObject('item.PS.P.CT', item, 'returnValue');
					cts = cts && wrapObjectToArray(cts, true);

					renewal.setMembershipLevel(item.membership_level);
					renewal.setPackageId(item.PS.P.id);

					if (validArray(cts)) {
						cts.forEach(function iterateRenewalsResponseCT(ct) {
							renewal.addCustomerType(ct.id, ct.membership_level);
						});
					}

					profile.renewals.push(renewal);
				});
			};

			this.copyToRequestAction = angular.noop;

			this.fields = { renewals: { mapping: 'RENEWAL' } };
		}

		/**
		 * Handles mapping of the Forms node
		 * @param {Object} baseNode The base node
		 * @param {Boolean} isProfileOfLinkedGuest Whether the profile is a linked guest
		 * @returns {undefined}
		 */
		function FormsProfileReqMapping(baseNode, isProfileOfLinkedGuest) {
			this.reqRespNode = addBaseNode(baseNode, 'FORMS.FORM');
			this.clearProfileAction = function(profile) {
				profile.forms = [];
			};
			this.copyToProfileAction = function(profile, fields) {
				profile.forms.push(angular.copy(fields));
			};
			this.copyToRequestAction = function(requestPart, fields) {
				// Do nothing. This section isn't included in update calls.
			};
			this.profileModelSection = 'forms';

			this.fields = {
				accept_age: { mapping: 'accept_age' },
				accepted: { mapping: 'value' },
				category: { mapping: 'category' },
				display_name: { mapping: 'display_name' },
				expires: { mapping: 'expires' },
				id: { mapping: 'id' },
				language: { mapping: 'language' },
				name: { mapping: 'name' },
				signed_date: { mapping: 'signed_date' },
				version: { mapping: 'version' }
			};
		}

		/**
		 * Handles mapping of profile requests
		 * @param {Object} baseNode The base node
		 * @param {Boolean} isProfileOfLinkedGuest Whether the profile is a linked guest
		 * @returns {undefined}
		 */
		function ProfileRequestMapping(baseNode, isProfileOfLinkedGuest) {
			isProfileOfLinkedGuest = !!isProfileOfLinkedGuest;
			this.mainInfoProfileReqMapping = new MainInfoProfileReqMapping(baseNode, isProfileOfLinkedGuest);
			if (isProfileOfLinkedGuest) {
				this.relationshipProfileReqMapping = new RelationshipReqMapping(baseNode);
			}
			this.emailProfileReqMapping = new EmailProfileReqMapping(baseNode, isProfileOfLinkedGuest);
			this.campsAddressProfileReqMapping = new CampsAddressProfileReqMapping(baseNode, isProfileOfLinkedGuest);
			this.addressProfileReqMapping = new AddressProfileReqMapping(baseNode, isProfileOfLinkedGuest);
			this.phoneProfileReqMapping = new PhoneProfileReqMapping(baseNode, isProfileOfLinkedGuest);
			this.memberProfileReqMapping = new MemberProfileReqMapping(baseNode);
			this.formsProfileReqMapping = new FormsProfileReqMapping(baseNode, isProfileOfLinkedGuest);
			this.childMembershipsReqMapping = new ChildMembershipsMapping(baseNode);
			this.membershipReqMapping = new MembershipReqMapping(baseNode);
			this.membershipRenewalsMapping = new MembershipRenewalsMapping(baseNode);

			// Don't load linked guests for linked guests.
			// They're not supposed to be there, but this is a good safeguard.
			if (!isProfileOfLinkedGuest) {
				this.adultBeneficiariesProfileReqMapping = new AdultBeneficiariesProfileReqMapping(baseNode, false);
				this.childBeneficiariesProfileReqMapping = new ChildBeneficiariesProfileReqMapping(baseNode, false);
				this.linkedAdultGuestsProfileReqMapping = new LinkedAdultGuestsProfileReqMapping(baseNode, false);
				this.linkedChildGuestsProfileReqMapping = new LinkedChildGuestsProfileReqMapping(baseNode, false);
				this.dependentChildGuestsProfileReqMapping = new LinkedChildGuestsProfileReqMapping(baseNode, true);
			}
			this.optionsProfileReqMapping = new OptionsProfileReqMapping(baseNode, isProfileOfLinkedGuest);
		}

		/**
		 * Base request template for a create/modify profile request
		 * @returns {Object} The request object
		 **/
		function getBaseProfileRequest() {
			return {
				merchant_id: AppData.merchantId,
				create_bank_account: '0',
				PROFILE: {
					EMAIL: {},
					PHONES: { PHONE: [] },
					ADDRESSES: { ADDRESS: [] },
					BENEFICIARIES: { BENEFICIARY: [] },
					LINKED_GUESTS: {
						ADULTS: { ADULT: [] },
						CHILDREN: { CHILD: [] }
					},
					OPTIONS: { OPTION: [] }
				}
			};
		}

		/**
		 * Transforms a Profile into a request object for the backend
		 * The PROFILE portion of a request to the backend is a complex structure so this helper
		 * function uses the profileModelToProfileRequestMapping to help transform a Profile into a Request for the backend
		 * @param {Object} profileModelToProfileRequestMapping The model to map the request
		 * @param {Object} profile The profile object
		 * @returns {Object} The request object based on the profile
		 **/
		function transformProfileIntoRequest(profileModelToProfileRequestMapping, profile) {
			var request = getBaseProfileRequest();

			// We never include the image name in a request. Instead, we set 'with_image' to being '1' on the root of the request
			// That notifies the backend that there's a new file for them to find.
			if (angular.isDefined(profile.image) && profile.image.trim().length > 0) {
				request.with_image = '1';
			}

			if (angular.isDefined(profile.customer_id)) {
				request.customer_id = profile.customer_id;
			}

			if (angular.isDefined(profile.dependent_id) && angular.isDefined(profile.parent_customer_id)) {
				request.customer_id = profile.parent_customer_id;
				request.dependent_id = profile.dependent_id;
			}

			if (angular.isDefined(profile.relationshipType) && profile.relationshipType != '') {
				request.parent_rel_type_id = profile.relationshipType;
			}

			// We never include linked guests in the requests
			if (angular.isDefined(profileModelToProfileRequestMapping.adultBeneficiariesProfileReqMapping)) {
				delete (profileModelToProfileRequestMapping.adultBeneficiariesProfileReqMapping);
			}
			if (angular.isDefined(profileModelToProfileRequestMapping.childBeneficiariesProfileReqMapping)) {
				delete (profileModelToProfileRequestMapping.childBeneficiariesProfileReqMapping);
			}
			if (angular.isDefined(profileModelToProfileRequestMapping.linkedAdultGuestsProfileReqMapping)) {
				delete (profileModelToProfileRequestMapping.linkedAdultGuestsProfileReqMapping);
			}
			if (angular.isDefined(profileModelToProfileRequestMapping.linkedChildGuestsProfileReqMapping)) {
				delete (profileModelToProfileRequestMapping.linkedChildGuestsProfileReqMapping);
			}
			if (angular.isDefined(profileModelToProfileRequestMapping.dependentChildGuestsProfileReqMapping)) {
				delete (profileModelToProfileRequestMapping.dependentChildGuestsProfileReqMapping);
			}

			for (var i in profileModelToProfileRequestMapping) {
				//obtain necessary parts of the mapping
				var currentMapping = profileModelToProfileRequestMapping[i];
				var currentProfileModelSection = currentMapping['profileModelSection'];
				var profileObject = angular.isDefined(currentProfileModelSection) ? profile[currentProfileModelSection] : profile;

				//obtain the part of the request we are copying with data
				var requestPartToCopyTo = request;
				var requestParts = currentMapping.reqRespNode.split('.');

				requestParts.forEach(function(part) {
					if (angular.isDefined(requestPartToCopyTo[part])) {
						requestPartToCopyTo = requestPartToCopyTo[part];
					}
				});

				var tempFields = {};
				//assess whether the profile object we are copying is an array or an object and copy the fields to the request
				if (angular.isArray(profileObject)) {
					profileObject.forEach(function(section) {
						tempFields = {};
						for (var j in currentMapping.fields) {
							var fieldToMap = currentMapping.fields[j].mapping;
							// in the case of multiple mappings, the first one is always the one we use when making requests.
							if (angular.isArray(fieldToMap)) {
								fieldToMap = fieldToMap[0];
							}
							tempFields[fieldToMap] = section[j];
						}
						currentMapping['copyToRequestAction'](requestPartToCopyTo, tempFields);
					});
				} else {
					for (var j in currentMapping.fields) {
						var fieldToMap = currentMapping.fields[j].mapping;
						// in the case of multiple mappings, the first one is always the one we use when making requests.
						if (angular.isArray(fieldToMap)) {
							fieldToMap = fieldToMap[0];
						}
						tempFields[fieldToMap] = profileObject[j];
					}
					currentMapping['copyToRequestAction'](requestPartToCopyTo, tempFields);
				}
			}
			return request;
		}

		/**
		 * Transforms a response from the backend and parses fields from a CREATE/UPDATE profile response for given profile
		 * @param {Object} profileModelToProfileRequestMapping The model to map the request
		 * @param {Object} profile The profile object to transform
		 * @param {Object} response The response from backend
		 * @returns {undefined}
		 */
		function transformResponseIntoProfile(profileModelToProfileRequestMapping, profile, response) {
			// Step 1: clear all the relevant sections of the profile:
			for (var h in profileModelToProfileRequestMapping) {
				if ('clearProfileAction' in profileModelToProfileRequestMapping[h]) {
					profileModelToProfileRequestMapping[h].clearProfileAction(profile);
				}
			}

			// Step 2: read in all the profile sections
			for (var i in profileModelToProfileRequestMapping) {
				// Get the necessary parts of the mapping
				var currentMapping = profileModelToProfileRequestMapping[i];
				var reqRespNodeToCheckForData = currentMapping['reqRespNode'];
				var action = currentMapping['copyToProfileAction'];
				var copyResponse = currentMapping.copyToProfileFromResponse;
				var fieldsToMap = currentMapping['fields'];
				var dataParts = reqRespNodeToCheckForData.split('.');
				var responseSection = response;

				// Check the response for the necessary response section
				if (reqRespNodeToCheckForData.length < 1
						|| safelyCheckPropertyOnObject(reqRespNodeToCheckForData, response[dataParts[0]])) {
					// Pull the appropriate section of the response
					dataParts.forEach(function(part) {
						responseSection = responseSection[part];
					});

					if (angular.isUndefined(responseSection)) {
						responseSection = response;
					}

					if (angular.isDefined(copyResponse)) {
						copyResponse(profile, responseSection)
					} else if (angular.isArray(responseSection)) {
						// If the response is an array we need to loop through each part of the array and map the fields
						// for each index

						// Map each response index into the temporary fields object
						responseSection.forEach(function(section, index) {
							var tempFields = {};
							for (var j in fieldsToMap) {
								var mapField = fieldsToMap[j].mapping;
								// It's possible for the mapping to be an array of possible values.
								// Step through this array, looking for each one on the profile.
								if (!angular.isArray(mapField)) {
									mapField = [mapField];
								}
								mapField.forEach(function(mapping) {
									if (angular.isDefined(section[mapping])) {
										tempFields[j] = section[mapping];
									}
								});
							}
							// Actions are required for items that can return as an array
							action(profile, tempFields);
						});
					} else {
						// Otherwise map the fields for the current response object and call the action function
						var tempFields = {};
						for (var j in fieldsToMap) {
							var mapField = fieldsToMap[j].mapping;

							// It's possible for the mapping to be an array of possible values.
							// Step through this array, looking for each one on the profile.
							if (!angular.isArray(mapField)) {
								mapField = [mapField];
							}
							mapField.forEach(function(mapping) {
								if (angular.isDefined(responseSection[mapping])) {
									tempFields[j] = responseSection[mapping];
								}
							});
						}
						if (safelyCheckPropertyOnObject('responseSection.MEMBERSHIP.member_id', responseSection)) {
							profile.membershipBenefit = true;
						}
						action(profile, tempFields);
					}
				}
			}

			// We now have a profile stored in profile. We need to set the parent_customer_id of all the dependents
			if (angular.isDefined(profile.customer_id)) {
				if (angular.isDefined(profile.adultLinkedGuests)) {
					profile.adultLinkedGuests.forEach(function(g) {
						g.parent_customer_id = profile.customer_id;
					});
				}
				if (angular.isDefined(profile.childLinkedGuests)) {
					profile.childLinkedGuests.forEach(function(g) {
						g.parent_customer_id = profile.customer_id;
					});
				}
			}
		}

		/**
		 * Changes a user's password
		 * @param {String} currentPassword The currently set password
		 * @param {String} newPassword The password to change to
		 * @returns {Promise} The promise of the fetch request response
		 */
		this.requestChangePassword = function(currentPassword, newPassword) {
			var req = {
				old_password: currentPassword,
				new_password: newPassword,
				merchant_id: AppData.merchantId
			};

			return AppData.fetch(Enums.services.CHANGE_PASSWORD, false, req);
		};

		this.profileRequest = function() {
			var result = {};
			// if displaying linked guests on the profile, we need the CP_GetProfile call to return images
			if (this.usingSidebar) {
				result.with_image = '1';
			}
			if (this.includeFormsOnProfile) {
				result.with_forms = '1';
			}
			return result;
		};


		/**
		 * Request the information for a given profile guest_no from the backend.  is only used to load the profile
		 * of the currently logged in guest (which loads in all the associated linked guests).
		 * @param {Object} profile The profile object
		 * @param {Boolean} create_internal Whether to create an internal profile
		 * @param {Boolean} isTE2Login specifies if this is for a TE2 profile
		 * @returns {Promise} The deferred promise of the fetch request response
		 */
		this.getProfile = function(profile, create_internal, isTE2Login) {
			var deferred = $q.defer(),
				req = this.profileRequest(),
				TE2Service;

			if (create_internal) {
				req.create_internal = '1';
			}
			if (isTE2Login) {
				TE2Service = $injector.get('TE2Service');
				req.access_token = TE2Service.getTE2Token();
			}
			if (profile.customer_id) {
				req.customer_id = profile.customer_id;
			}

			AppData.fetch(Enums.services.GET_PROFILE, false, req).then(function(response) {
				if (response.status === Enums.status.OK) {
					if (isTE2Login) {
						TE2Service.handleGetProfile(response);
					} else {
						transformResponseIntoProfile(new ProfileRequestMapping('PROFILE'), profile, response);
					}
					deferred.resolve();
				} else {
					//do not let user navigate to profile - we can use this to reject the route if need be
					deferred.reject(new RouteRejectionService.ViewException(ProfileManagerEnumsService.localeSection, 'getProfileErrorTitle', 'getProfileErrorMsg'));
				}
			});

			return deferred.promise;
		};

		/**
		 * Edits an existing profile
		 * @param {Object} profile The profile object to modify
		 * @param {Boolean} isProfileOfLinkedGuest Whether the profile is a linked guest
		 * @returns {Promise} The deferred promise of the fetch request response
		 */
		this.modifyProfile = function(profile, isProfileOfLinkedGuest) {
			$rootScope.showSpinner(Language.getLocale('ProfileManager', 'editProfileSpinnerMsg'));
			var req = transformProfileIntoRequest(new ProfileRequestMapping('PROFILE', isProfileOfLinkedGuest), profile);
			return AppData.fetch(Enums.services.UPDATE_PROFILE, false, req);
		};

		/**
		 * Creates a brand-new user within the system
		 * @param {Object} profile The profile object to create
		 * @returns {Promise} The deferred promise of the fetch request response
		 */
		this.requestCreateProfile = function(profile) {
			$rootScope.showSpinner(Language.getLocale('ProfileLogin', 'createProfileSpinnerMsg'));
			var req = transformProfileIntoRequest(new ProfileRequestMapping('PROFILE'), profile);
			return AppData.fetch(Enums.services.CREATE_PROFILE, false, req);
		};

		/**
		 * Adds a new guest, and sets its parent to being the currently logged in guest.
		 * @param {Object} profile The profile object to create
		 * @returns {Promise} The deferred promise of the fetch request response
		 */
		this.requestAddGuest = function(profile) {
			$rootScope.showSpinner(Language.getLocale('ProfileLogin', 'createProfileSpinnerMsg'));
			var req = transformProfileIntoRequest(new ProfileRequestMapping('PROFILE'), profile);
			return AppData.fetch(Enums.services.ADD_GUEST, false, req);
		};

		/**
		 * Registers a field to be passed as text in the request
		 * @param {String} fieldName The profile object to create
		 * @returns {undefined}
		 */
		this.registerOptionFieldNamesToPassAsText = function(fieldName) {
			if (textOptionFieldOverrides.indexOf(fieldName) === -1) {
				textOptionFieldOverrides.push(fieldName);
			}
		};

		/**
		 * Gets the password token swap info
		 * @param {String} token The password reset token
		 * @returns {Promise} The deferred promise of the fetch request response
		 */
		this.getPasswordTokenSwapInfo = function(token) {
			if (angular.isUndefined(token)) {
				throw new RouteRejectionService.ViewException(ProfileManagerEnumsService.localeSection, 'invalidPasswordResetTokenTitle', 'invalidPasswordResetTokenMsg',
					'profile-login.signin', { showSignInOnly: $rootScope.disableCreateAccountOnGlobalLogin });
			} else {
				$rootScope.showSpinner();
				var req = {
					token: token,
					merchant_id: AppData.merchantId
				};
				return AppData.fetch(Enums.services.PASSWORD_TOKEN_SWAP, false, req).then(function(response) {
					if (angular.isDefined(response) && response.status === Enums.status.OK && angular.isDefined(response.token) && angular.isDefined(response.guest_no)) {
						return {
							swap_token: response.token,
							guest_no: response.guest_no
						};
					} else {
						throw new RouteRejectionService.ViewException(ProfileManagerEnumsService.localeSection, 'invalidPasswordResetTokenTitle', 'invalidPasswordResetTokenMsg',
							'profile-login.signin', { showSignInOnly: $rootScope.disableCreateAccountOnGlobalLogin });
					}
				});
			}
		};

		/**
		 * Reset the password with the token
		 * @param {String} token The password reset token
		 * @param {String} guest_no The guest number
		 * @param {String} newPassword The new password
		 * @returns {Promise} The promise of the fetch request response
		 */
		this.resetPasswordWithToken = function(token, guest_no, newPassword) {
			var req = {
				token: token,
				merchant_id: AppData.merchantId,
				guest_no: guest_no,
				new_password: newPassword
			};
			return AppData.fetch(Enums.services.RESET_PASSWORD_WITH_TOKEN, false, req);
		};

		/**
		 * Send off an email to reset a password
		 * @param {Object} formData The request object, populated from controller via configurable fields from appconfigs
		 * @returns {Promise<Object>} The promise of the fetch request response
		 */
		this.resetPasswordWithVerificationCode = function(formData) {
			return AppData.fetch(Enums.services.RESET_PASSWORD_WITH_TOKEN, false, formData);
		};
	});
(function() {
	'use strict';

	angular
		.module('profile')
		.directive('configurableOptionField', function(Language,
			Modal,
			Utilities,
			$rootScope) {

			return {
				restrict: 'E',
				scope: {
					optionFieldModel: '=',
					submitted: '=',
					unavailableOptionLocaleSuffix: '=',
					onChange: '&',
					disableCondition: '&',
					notifyUnavailableOptionCondition: '&',
					localeSection: '@',
					selectLabelLocale: '<',
					hasPadding: '='
				},
				templateUrl: '/scripts/modules/profile/directives/configurable-option-field.html',
				controller: function($scope) {
					/**
					 * Handles initialization of fields - namely dropdowns
					 * @public
					 * @returns {undefined}
					 */
					$scope.initField = function() {
						// For now, target dropdowns but might need this for more in the future
						if(this.optionFieldModel.field_type !== 'dropdown') {
							return;
						}

						//retrieve dropdowns
						if (!this.optionFieldModel._dropdownOptions) {
							this.optionFieldModel._dropdownOptions = this.i18n.getLocale(this.localeSection, this.optionFieldModel.placeholder_locale_target).split(',');
						}
						//ensure the field is initialized or set to a valid property otherwise its null
						this.optionFieldModel.field_value = this.optionFieldModel._dropdownOptions.indexOf(Utilities.getString(this.optionFieldModel.field_value)) !== -1 ? this.optionFieldModel.field_value : null;
					};
					
				},
				link: function(scope, element, attrs) {
					scope.i18n = $rootScope.i18n;
					scope.errorConfig = {
						section: scope.localeSection,
						errors: {
							'required': 'displayFieldError_' + scope.optionFieldModel.name
						}
					};

					scope.dropDownNeedsOtherInput = function() {
						return scope.optionFieldModel.field_value == scope.optionFieldModel.value_to_trigger_alt_collection &&
							scope.optionFieldModel.value_to_trigger_alt_collection != ''
					};

					/**
					 * Assess whether or not the field should be disabled
					 * @param optionFieldModel
					 * @returns {*}
					 */
					scope.shouldBeDisabled = function(optionFieldModel) {
						return scope.disableCondition({
							optionFieldModel: optionFieldModel
						});
					};

					/**
					 * Run the configured onChange function
					 * @param optionFieldModel
					 */
					scope.runOnChangeAction = function(optionFieldModel) {
						scope.onChange({
							optionFieldModel: optionFieldModel
						});
					};

					/**
					 * Show information regarding options
					 * @param optionFieldModel
					 */
					scope.showInfoModal = function(optionFieldModel) {
						Modal.displayModal({
							category: 'Option Field Info Modal',
							action: 'Info',
							label: 'Option Field Info Modal',
							title: Language.getLocale(scope.localeSection, 'optionFieldModelInfoTitle_' + optionFieldModel.name),
							description: Language.getLocale(scope.localeSection, 'optionFieldModelInfoMsg_' + optionFieldModel.name)
						});
					};

					/**
					 * Show unavailable option panel
					 * @param optionFieldModel
					 * @returns {*}
					 */
					scope.showUnavailableOptionPanel = function(optionFieldModel) {
						return scope.notifyUnavailableOptionCondition({
							optionFieldModel: optionFieldModel
						});
					};
				}
			}
		});
})();

(function() {
	'use strict';

	angular
		.module('app')
		.factory('OptInService', OptInService);

	/**
	 * @constructor
	 * @memberOf app
	 * @param {Service} AppData AppData
     * @param {Service} Enums Enums
	 * @param {Service} Language For Locales
	 * @param {Service} Modal Modal
     * @param {Service} Utilities Utilities
	 * @param {Service} UtilsValidation UtilsValidation
	 * @return {OptInService} the public api
	 * @ngInject
	 */
	function OptInService(AppData, Enums, Language, Modal, Utilities, UtilsValidation) {
		var validString = UtilsValidation.validString;
		var isRealObject = UtilsValidation.isRealObject;
		var getBoolean = Utilities.getBoolean;

		var service = {
			checkOptInSelections: checkOptInSelections,
			notify: notify
		};

		return service;

		/**
		 * Call This function when creating new profile
		 * @public
		 * @function
		 * @memberOf OptInService
		 * @param {Array} optIns Opt ins to check
		 * @name checkOptInSelections
		 * @return {Boolean} True if all optins have a selection
		 */
		function checkOptInSelections(optIns) {
			var i = 0;
			var optInsLength;
			if (angular.isArray(optIns)) {
				optInsLength = optIns.length;
			} else if (isRealObject(optIns)) {
				optIns = [optIns];
			} else {
				return false;
			}
			for (; i < optInsLength; i++) {
				if (!isRealObject(optIns[i])) {
					return false;
				}
				if (!validString(optIns[i].value)) {
					notify('missingSelection', optIns[i].name);
					return false;
				}
				if (validString(optIns[i].value) && optIns[i].acceptance_required && !getBoolean(optIns[i].value)) {
					notify('acceptanceRequiredForSelection', optIns[i].name);
					return false;
				}
			}
			return true;
		}

		/**
		 * Call This function when creating new profile
		 * @public
		 * @function
		 * @memberOf OptInService
		 * @param {String} error Issue to notify the user about
		 * @param {String} name Name of opt in
		 * @name notify
		 * @return {undefined}
		 */
		function notify(error, name) {
			Modal.displayModal({
				category: 'Opt Ins',
				action: 'Error',
				label: 'Opt Ins Selection',
				title: Language.getLocale('OptIn', 'optInSelection'),
				description: Language.getLocale('OptIn', error + name),
				buttonFlags: [Enums.buttonFlags.OK]
			});
		}
	}
})();

(function() {
	'use strict';

	angular
		.module('profile-login', ['app', 'profile'])
		.config(function($locationProvider, $stateProvider) {
			$stateProvider
				.state('profile-login', {
					url: '/profile-login',
					abstract: true,
					template: '<div ui-view></div>',
					resolve: {
						//resolve failures are handled within run.js of main app
						initialData: function(Bootstrap) {
							return Bootstrap.bootstrapApplication(undefined, true);
						},
						load: function(initialData, $rootScope, Utilities, SMS_VERIFICATION_ASSETS) {
							$rootScope.showSpinner();
							return Utilities.cacheBustAndLazyLoad(SMS_VERIFICATION_ASSETS.concat([
								'scripts/components/opt-in/opt-in-component.js',
								'scripts/components/opt-in/opt-in-component-controller.js',
								'scripts/modules/profile/modules/profile-login/controllers/profile-login-reset-password-controller.js',
								'scripts/modules/profile/modules/profile-login/controllers/profile-login-signin-column-view-controller.js',
								'scripts/modules/profile/modules/profile-login/controllers/profile-login-signin-controller.js',
								'scripts/modules/profile/modules/profile-login/controllers/profile-login-lookup-acct-controller.js',
								'scripts/modules/profile/modules/profile-login/controllers/profile-login-create-acct-controller.js',
								'scripts/modules/profile/modules/profile-login/controllers/profile-login-member-email-collection-controller.js'
							]));
						}
					}
				})
				.state('profile-login.signin', {
					url: '/signin/{showSignInOnly:(?:true|false)}/{packageId}/{nonXFCRoute}',
					abstract: true,
					templateUrl: '/scripts/modules/profile/modules/profile-login/views/profile-login.html',
					controller: 'ProfileLoginSigninColumnViewController',
					params: {
						showSignInOnly: {
							value: 'false',
							squash: true
						},
						packageId: {
							value: '',
							squash: true
						},
						nonXFCRoute: {
							value: 'false',
							squash: true
						}
					},
					resolve: {
						xfcMap: function(load, Package, Utilities, $transition$) {
							var stateParams = $transition$.params();
							return (stateParams.packageId && !Utilities.getBoolean(stateParams.nonXFCRoute)) ? Package.buildXFCMap() : true;
						},
						assessRoute: function(xfcMap, AppData, RouteRejectionService, ProfileLoginSessionService, $q, $transition$, Utilities, ExtraFlow, Package, $rootScope) {
							var checkProp = Utilities.checkProp;

							// if we are already logged in, either go back to selection or continue down XMC route.
							if (ProfileLoginSessionService.isLoggedIn() && ProfileLoginSessionService.isProfileRetrieved()) {
								var stateParams = $transition$.params();
								// sometimes packageId is blank when it's not passed in. Sometimes it's undefined.
								if (stateParams.packageId && !Utilities.getBoolean(stateParams.skipXFCCheck) && angular.isObject(Package.settings)) {
									ExtraFlow.addReferenceToCartItems(Package.settings.view, Package.itemsToBeAdded, ExtraFlow.CLIENT_XFC_VIEW);
									ExtraFlow.addReferenceToCartItems(Package.settings.name, Package.itemsToBeAdded, ExtraFlow.CLIENT_XFC_NAME);

									$rootScope.hideSpinner();

									// Use the proper BypassXFC exception pattern instead of direct callback
									return new $q(RouteRejectionService.BypassXFCExceptionCallback);
								} else {
									$transition$.abort();

									if (checkProp('AppData.settings.route_to_new_profile_manager', AppData, 'getBoolean')) {
										Utilities.goTo('profile-manager-new.profile');
									} else {
										Utilities.goTo('profile-manager.profile.view');
									}
									return $q.reject();
								}
							} else {
								return true;
							}
						}
					}
				})
				.state('profile-login.signin.view', {
					url: '',
					resolve: {
						ensureInitialData: function(load) {
							// we need to ensure loading of files got resolved. Please leave this here.
						}
					},
					views: {
						isolatedLoginView: {
							controller: 'ProfileLoginSigninController',
							templateUrl: '/scripts/modules/profile/modules/profile-login/views/login.html'
						},
						loginSideView: {
							controller: 'ProfileLoginSigninController',
							templateUrl: '/scripts/modules/profile/modules/profile-login/views/login-side-view.html'
						},
						createProfileSideView: {
							controller: 'ProfileLoginCreateAcctController',
							templateUrl: '/scripts/modules/profile/modules/profile-login/views/create-acct-side-view.html'
						},
						forgotPasswordSideView: {
							controller: 'ProfileLoginLookupAcctController',
							templateUrl: '/scripts/modules/profile/modules/profile-login/views/lookup-acct-side-view.html'
						},
						resetPasswordSideView: {
							controller: 'ProfileLoginResetPasswordController',
							resolve: { loadAndHideSpinner: loadAndHideSpinner, },
							templateUrl: '/scripts/modules/profile/modules/profile-login/views/reset-pass-side-view.html'
						},
						guestCheckoutSideView: {
							controller: 'ProfileLoginSigninController',
							templateUrl: '/scripts/modules/profile/modules/profile-login/views/guest-checkout-side-view.html'
						}
					}
				})
				.state('profile-login.lookup-acct', {
					url: '/lookup-acct/{viewType:(?:forgotPassword|lookupExistingMember)}',
					controller: 'ProfileLoginLookupAcctController',
					templateUrl: '/scripts/modules/profile/modules/profile-login/views/lookup-acct.html',
					resolve: { loadAndHideSpinner: loadAndHideSpinner }
				})
				.state('profile-login.reset-pass', {
					url: '/reset-pass',
					controller: 'ProfileLoginResetPasswordController',
					resolve: { loadAndHideSpinner: loadAndHideSpinner, },
					templateUrl: '/scripts/modules/profile/modules/profile-login/views/reset-pass.html'
				})
				.state('profile-login.create-acct', {
					url: '/create-acct',
					controller: 'ProfileLoginCreateAcctController',
					templateUrl: '/scripts/modules/profile/modules/profile-login/views/create-acct.html',
					resolve: { loadAndHideSpinner: loadAndHideSpinner }
				})
				.state('profile-login.memberEmailCollection', {
					url: '/memberEmailCollection',
					controller: 'ProfileLoginMemberEmailCollectionController',
					templateUrl: '/scripts/modules/profile/modules/profile-login/views/member-email-collection.html',
					resolve: {
						assessRoute: function(initialData, RouteRejectionService, ProfileLoginPrepService, ProfileLoginSessionService, $rootScope) {
							// if we are already logged in, go back to selection
							// TODO also lets block state if we didn't come from lookup account
							if (ProfileLoginSessionService.isLoggedIn()) {
								throw new RouteRejectionService.UnrecoverableException('profile-manager.profile', {});
							} else if (ProfileLoginPrepService.lookupExistingMemberFields[0].value.length === 0) {
								throw new RouteRejectionService.UnrecoverableException('profile-login.signin', { showSignInOnly: $rootScope.disableCreateAccountOnGlobalLogin });
							} else {
								return true;
							}
						}
					}
				});

			/**
			 * Waits on the `load` resolve and then calls hideSpinner
			 * @param {Promise} load The load resolve.
			 * @param {Scope} $rootScope The root scope
			 * @returns {undefined}
			 * @ngInject
			 */
			function loadAndHideSpinner(load, $rootScope) {
				$rootScope.hideSpinner();
			}
		})
		.run(function(ProfileLoginPrepService, ProfileLoginImageService) {
			//trigger loading of the prep service so that it can listen for application activated event
			// trigger loading of image service to register custom actions
			// To-Do: Look at seting up hooks so ProfileLoginPrepService.configureProfileLogin() can be moved out of the promise chain in bootstrap.
		})
		.run(function(ExtraFlow) {
			ExtraFlow.registerXMC(
				'profile-login', {
					name: 'profile-login',
					view: 'profile-login.signin',
					viewIsStateName: true,
					doEditMode: false,
					enabled: true,
					type: 'extraFlowControl'
				});
		});
})();
(function() {
	'use strict';

	angular
		.module('profile-login')
		.controller('ProfileLoginModalController', ProfileLoginModalController);

	/**
	 * Profile Login Modal Controller
	 * @constructor
	 * @param  {Object} ProfileLoginModalService ProfileLoginModalService
	 * @param  {Object} ProfileLoginSessionService ProfileLoginSessionService
	 * @param  {Object} ProfileLoginRequestService ProfileLoginRequestService
	 * @param  {Object} ProfileLoginEnumsService ProfileLoginEnumsService
	 * @param  {Object} ProfileLoginPrepService ProfileLoginPrepService
	 * @param  {Object} FocusService FocusService
	 * @param  {Object} Language Language Service
	 * @param  {Object} $rootScope $rootScope Service
	 * @param  {Object} $document $document Service
	 * @param  {Object} Enums Enums Service
	 * @param  {Function} loginSuccessCallback Function to call on a successful login
	 * @param  {Function} loginFailureCallback Function to call on a failed login
	 * @returns {Object} ProfileLoginModalController
	 */
	function ProfileLoginModalController(
		ProfileLoginModalService,
		ProfileLoginSessionService,
		ProfileLoginRequestService,
		ProfileLoginEnumsService,
		ProfileLoginPrepService,
		FocusService,
		Language,
		$rootScope,
		$document,
		Enums,
		loginSuccessCallback,
		loginFailureCallback) {
		var vm = this;

		/**
		 * Function to call on login failure.
		 * @type {Function}
		 */
		var onLoginFailure = loginFailureCallback || showLoginError;

		/**
		 * Login state constant.
		 * @type {Number}
		 */
		vm.LOGIN = 0;

		/**
		 * Password recovery state constant.
		 * @type {Number}
		 */
		vm.PASSWORD_RECOVERY = 1;

		/**
		 * Locale Section.
		 * @type {String}
		 */
		vm.localeSection = 'ProfileLogin';

		/**
		 * Controls the password validation of the login modal.
		 * @type {Object}
		 */
		vm.passwordOptions = ProfileLoginPrepService.config.reset_password_requirements;

		/**
		 * Current state of the modal. Determines which piece of the modal is shown.
		 * @type {Number}
		 */
		vm.currentState = vm.LOGIN;

		/**
		 * Text to show in the status message row in the login section.
		 * @type {String}
		 */
		vm.loginStatusMessage = $rootScope._loginModalErrorCode
			? Language.getLocale('ProfileLogin', 'modalLoginError_' + $rootScope._loginModalErrorCode)
			: '';
		delete $rootScope._loginModalErrorCode;

		/**
		 * Text to show in the status message row in the password recovery section.
		 * @type {String}
		 */
		vm.passwordRecoveryStatusMessage = '';

		/**
		 * Fields to display in the password recovery section.
		 * @type {Array}
		 */
		vm.passwordRecoveryVerificationFields = getVerificationFields();

		/**
		 * Closes the profile modal.
		 * @public
		 * @function
		 * @returns {undefined}
		 */
		vm.closeModal = function() {
			ProfileLoginModalService.closeModal();
			FocusService.resetState();
		}

		/**
		 * Login when enters is pressed
		 * @public
		 * @param {Object} event event object
		 * @param {String} functionType function type - login/recoverPassword
		 * @returns {undefined}
		 */
		vm.executeOnEnter = function(event, functionType) {
			if (functionType === 'login') {
				ProfileLoginRequestService.executeOnEnter(event, vm.executeLogin);
			} else if (functionType === 'recoverPassword') {
				ProfileLoginRequestService.executeOnEnter(event, vm.recoverPassword)
			}
		}

		/**
		 * Calls loginSession and sets submitted to true.
		 * @public
		 * @function
		 * @returns {undefined}
		 */
		vm.executeLogin = function() {
			vm.submitted = true;

			if (vm.profileLoginModalSigninForm.$valid) {
				vm.closeModal();
				$rootScope.showSpinner(Language.getLocale('ProfileLogin', 'loginSpinnerMsg'));
				ProfileLoginSessionService.loginSession(undefined, vm.verificationField, vm.password, true, onLoginSuccess, onLoginFailure);
			}
		}

		/**
		 * Hides spinner and sets login error on the controller.
		 * @protected
		 * @function
		 * @param  {String} errorCode Error code from CP_Login
		 * @returns {undefined}
		 */
		function showLoginError(errorCode) {
			var displayedErrorCode = isNaN(errorCode) ? ProfileLoginEnumsService.STATUS_ERRORS.DEFAULT : errorCode;
			$rootScope.hideSpinner();
			$rootScope._loginModalErrorCode = displayedErrorCode;
			ProfileLoginModalService.displayLoginModal(loginSuccessCallback);
		}

		/**
		 * Executes after a successful login, wipes the error text and calls the success callback passed into it.
		 * @protected
		 * @function
		 * @returns {undefined}
		 */
		function onLoginSuccess() {
			vm.loginStatusMessage = '';
			if (angular.isFunction(loginSuccessCallback)) {
				loginSuccessCallback();
			}
		}

		/**
		 * Toggles the modal state between Login and Password Recovery.
		 * @public
		 * @function
		 * @returns {undefined}
		 */
		vm.changeLoginModalState = function() {
			if (vm.currentState === vm.PASSWORD_RECOVERY) {
				vm.currentState = vm.LOGIN;
			} else {
				vm.currentState = vm.PASSWORD_RECOVERY;
			}
			FocusService.setFocusToContainer('splashScreen', $document[0].activeElement, $document[0].activeElement);
		}

		/**
		 * Recovers password
		 * @public
		 * @function
		 * @returns {undefined}
		 */
		vm.recoverPassword = function() {
			vm.passwordFormSubmitted = true;
			if (vm.profileLoginModalPasswordRecoveryForm.$valid) {
				ProfileLoginRequestService
					.lookupGuest(vm.passwordRecoveryVerificationFields)
					.then(function(response) {
						if (response.status === Enums.status.OK) {
							//call send temp password then show modal that its sent
							ProfileLoginRequestService
								.sendPasswordResetEmail(vm.passwordRecoveryVerificationFields)
								.then(function(response) {
									$rootScope.hideSpinner();
									if (response.status === 'OK') {
										vm.passwordRecoveryStatusMessage = Language.getLocale('ProfileLogin', 'modalPasswordRecoverySuccess');
									} else {
										onPasswordResetFailure(response);
									}
								})
								.catch(onPasswordResetFailure);
						} else {
							onPasswordResetFailure(response);
						}
					})
					.catch(onPasswordResetFailure);
			}
		}

		/**
		 * Sets password recovery status message to the locale that corresponds to the error_code from backend.
		 * @protected
		 * @function
		 * @param  {Object} response response object from backend
		 * @returns {undefined}
		 */
		function onPasswordResetFailure(response) {
			$rootScope.hideSpinner();
			vm.passwordRecoveryStatusMessage = Language.getLocale('ProfileLogin', 'modalPasswordRecoveryError_' + response.error_code);
		}

		/**
		 * Grabs the fields used in the forgotPassword section / call.
		 * @protected
		 * @function
		 * @returns {Object[]} verificationFields
		 */
		function getVerificationFields() {
			var fields = angular.copy(ProfileLoginPrepService.getVerificationFieldsByParam('forgotPassword'));

			fields.forEach(function(field) {
				field.value = '';
			});

			return fields;
		}
	}
})();
(function() {
	'use strict';

	angular
		.module('profile-login')
		.service('ProfileLoginModalService', ProfileLoginModalService);

	/**
	 * @param {Service} $rootScope the rootscope
	 * @param {Service} $uibModal the UibModal service
	 * @returns {self} this service
	 * @ngInject
	 */
	function ProfileLoginModalService($rootScope, $uibModal) {
		var isObject = angular.isObject;
		var currentProfileLoginModal = null;

		var service = {
			closeModal: closeModal,
			displayLoginModal: displayLoginModal,
			getModalInstance: getModalInstance
		};

		return service;

		/**
		 * Creates and displays the profile login modal
		 * @public
		 * @function
		 * @param  {Function} successCallback Function to call on a successful login
		 * @param  {Function} failureCallback Function to call on a failed login
		 * @returns {undefined}
		 */
		function displayLoginModal(successCallback, failureCallback) {
			var modalObject = {
				size: "lg",
				backdrop: 'static',
				windowClass: 'splashScreen ',
				controller: 'ProfileLoginModalController',
				controllerAs: 'vm',
				templateUrl: '/scripts/modules/profile/modules/profile-login/views/profile-login-modal.html',
				resolve: {
					loginSuccessCallback: function() {
						return successCallback;
					},
					loginFailureCallback: function() {
						return failureCallback;
					}
				}
			};

			currentProfileLoginModal = service.getModalInstance(modalObject);
		}

		/**
		 * Creates and displays, and returns the UIB Modal Instance
		 * @public
		 * @function
		 * @param {Object} modalObject object containing all UIBModal settings
		 * @returns {Object} the $uibModal instance
		 */
		function getModalInstance(modalObject) {
			var modalInstance = $uibModal.open(modalObject);
			$rootScope.modalOpen = true;
			return modalInstance;
		}

		/**
		 * Closes the current modal
		 * @public
		 * @function
		 * @returns {undefined}
		 */
		function closeModal() {
			if (isObject(currentProfileLoginModal)) {
				currentProfileLoginModal.close();
			}

			currentProfileLoginModal = null;
			$rootScope.modalOpen = false;
		}
	}
})();
(function() {
	'use strict';

	angular.module('profile-login').factory('ProfileLoginEnumsService', ProfileLoginEnumsService);

	/**
	 * The Profile Login specific enums service
	 * @public
	 * @returns {ProfileLoginEnumsService} An instance of this factory
	 */
	function ProfileLoginEnumsService() {
		var factory = {
			loginTypes: {
				// these are not absolutely necessary. I'm just leaving the opening for more types in the future.
				COMBINE_SIGNIN_AND_CREATE: 0,
				SEPARATE_SIGNIN_AND_CREATE: 1
			},
			LOCALE_SECTION_FOR_CONFIGURABLE_INPUTS: 'configurableInputs',
			localeSection: 'ProfileLogin',
			CREATE_NEW_ACCOUNT: 'createNewAccount',
			FORGOT_PASSWORD: 'forgotPassword',
			LOOKUP_EXISTING_MEMBER: 'lookupExistingMember',
			RESET_PASSWORD_WITH_CODE: 'passwordResetFields',
			STATUS_ERRORS: {
				//for TESTING ONLY will remove eventually
				MEMBER_HAS_NO_EMAIL: '10',
				EMAIL_DOES_NOT_EXIST: '20',
				EMAIL_HAS_MULTI_GUEST: '21',
				WRONG_PASSWORD: '22',
				USER_LOCKED_OUT: '23',
				// This one isn't just email... it also matches against other things
				EMAIL_HAS_BEEN_USED:'24',
				// This is just email is taken
				EMAIL_TAKEN: '300',
				MEMBERSHIP_HAS_AN_EMAIL: '25',
				EMAIL_EXISTS_BUT_NAME_DOES_NOT_MATCH: '26',
				MEMBERSHIP_EXPIRY: {},
				DEFAULT: '00'
			},
			SAVE_PROPS_ON_CONNECTION_ERROR: '999',
			lookupFieldReqMapping: {
				lastName: 'last_name',
				firstName: 'first_name',
				email: 'email',
				memberId: 'member_id'
			},
			profileLoginStates: {
				LOGIN: 0,
				SIGN_UP: 1,
				FORGOT_PASSWORD: 2,
				RESET_PASSWORD: 3
			}
		};

		return factory;
	}
})();
/**
 * Created by ltischuk on 4/3/15.
 */

angular.module('profile-login').factory
('ProfileLoginPrepService',
	function ($location,
		$q,
		$rootScope,
		$state,
		AppData,
		ConfigurableObjectsModels,
		CustomActionService,
		Enums,
		JSONValidator,
		Language,
		Navigation,
		ProfileEnumsService,
		ProfileModels,
		ProfileLoginActionCoordinatorService,
		ProfileLoginActionDefinitionService,
		ProfileLoginEnumsService,
		ProfileLoginSessionService,
		ProfileLoginRequestService,
		ProfileRequestService,
		Utilities,
		UtilsValidation) {

	var factory = {
		config: {},
		getVerificationFieldsByParam: getVerificationFieldsByParam,
		configureProfileLogin: configureProfileLogin,
		createVerificationFields: createVerificationFields,
		getDemographicFieldForDisplay: getDemographicFieldForDisplay,
		getProfileConfigurableFieldsForPackage: getProfileConfigurableFieldsForPackage,
		getProfileConfigurableFieldsForProfile: getProfileConfigurableFieldsForProfile,
		hasMatchingFields: hasMatchingFields,
		getProfileConfigurableFieldsForLoggedInProfile: getProfileConfigurableFieldsForLoggedInProfile,
		updateFieldFromProfile: updateFieldFromProfile,
		obtainConfiguredFieldsForLoginProcess: obtainConfiguredFieldsForLoginProcess,
		determineProfileRouting: determineProfileRouting,
		forgotPasswordVerificationFields: [],
		newAccountLookupFields: [],
		lookupExistingMemberFields: [],
		passwordResetFields: [],
		newAccountOptions: [],
		profileConfigurableFields: [],
		loginFormat: ProfileLoginEnumsService.loginTypes.SEPARATE_SIGNIN_AND_CREATE
	};

	var getBoolean = Utilities.getBoolean;
	var getString = Utilities.getString;
	var validArray = UtilsValidation.validArray;

	/**
	* Parse the app config for profile_login and configure additional information
	*/
	function configureProfileLogin() {
		var deferred = $q.defer();
		if ($rootScope.configuredForLogin) {

		deferred.resolve();

		}else{

		//parse the app config
		parseAppConfig();
		if ($rootScope.configuredForLogin) {

			factory.obtainConfiguredFieldsForLoginProcess();
			obtainGenericConfigurableFields();
			registerErrorCodeOverides();
			configureFieldsToAppendToBackendRequests();
			configureDefinedActions();
			configureAdditionalActions();
			ProfileLoginSessionService.reinitializeSession().then(function() {

			deferred.resolve();

			});

		}else{
			deferred.resolve();
		}

		}

		return deferred.promise;

		//turn off the listener
	//listener();
	}

	/**
	* Parse the profile_login app config for the service
	*/
	function parseAppConfig() {

		if (JSONValidator.validate('profile_login', AppData.settings.profile_login)) {
		factory.config = JSON.parse(AppData.settings.profile_login);
		if (getBoolean(factory.config.configure_login_option) && !UtilsValidation.validString($location.search().te2_session)) {
			$rootScope.configuredForLogin = true;
		}

		factory.loginFormat = ProfileLoginEnumsService.loginTypes.SEPARATE_SIGNIN_AND_CREATE;

		if (getBoolean(factory.config.combine_login_and_create_account)) {
			factory.loginFormat = ProfileLoginEnumsService.loginTypes.COMBINE_SIGNIN_AND_CREATE;
		}

		ProfileRequestService.usingSidebar = getBoolean(factory.config.display_linked_guests_menu_on_profile);
		ProfileRequestService.includeFormsOnProfile = getBoolean(factory.config.display_forms_on_profile);
		$rootScope.disableCreateAccountOnGlobalLogin = getBoolean(factory.config.disable_create_account_on_global_login);
		}
	}

	function registerErrorCodeOverides() {

		Language.registerErrorCodeOverride('CP_Login');
		Language.registerErrorCodeOverride('CP_GuestLookUp');

	}

	/**
	* Obtain the various verification fields from the app config
	* These can be configurable per client - these fields indicate what info is
	* acceptable to be able to lookup and reset a password, or create new profiles
	* @public
	* @returns {undefined}
	*/
	function obtainConfiguredFieldsForLoginProcess() {
		factory.forgotPasswordVerificationFields = factory.createVerificationFields(factory.config.forgot_password_verification_fields, factory.forgotPasswordVerificationFields, true);
		factory.newAccountLookupFields = factory.createVerificationFields(factory.config.new_account_lookup_fields, factory.newAccountLookupFields, true);
		factory.lookupExistingMemberFields = factory.createVerificationFields(factory.config.lookup_existing_member_fields, factory.lookupExistingMemberFields, true);
		factory.passwordResetFields = factory.createVerificationFields(factory.config.reset_password_fields, factory.passwordResetFields, false);
	}

	/**
	* Obtain the verification fields from the app config
	* @param {Array<Object>} rawFields The fields from the app config
	* @param {Array<Object>} parsedFields The already parsed fields
	* @param {Boolean} skipValidation Whether or not to skip validation
	* @returns {Array<Object>} The newly parsed fields
	*/
	function createVerificationFields(rawFields, parsedFields, skipValidation) {
		if (skipValidation || validArray(rawFields)) {
		rawFields.forEach(function (field) {
			if (!factory.hasMatchingFields(field, parsedFields)) {
			parsedFields.push(new ConfigurableObjectsModels.VerificationField(field.name, field.validationType, field.width, field.capitalize));
			}
		});
		} else {
		parsedFields = [];
		}

		return parsedFields;
	}

	/**
	* Determines whether or not there are any matching fields in unparsedFields
	* @public
	* @param {Object} originalField The original field to match to
	* @param {Array<Object>} unparsedFields The parsed fields
	* @return {boolean} True if a matching field is found, otherwise false
	*/
	function hasMatchingFields(originalField, parsedFields) {
		return parsedFields.some(function(item) {
		return item.name === originalField.name;
		});
	}


	/**
	* Obtain Generic Configurable Fields
	*/
	function obtainGenericConfigurableFields() {

		if (JSONValidator.validate('profile_configurable_fields', AppData.settings.profile_configurable_fields)) {

		var fields = JSON.parse(AppData.settings.profile_configurable_fields);

		 // sort the fields by order (if there is one)
		 fields.sort(function(a, b) {
			 return Utilities.forceInt(a.order) - Utilities.forceInt(b.order);
		 });

		fields.forEach(function(field) {

			var optionField = new ProfileModels.ConfigurableOptionField(field.name,field.field_value,field.field_type);

			if (angular.isDefined(field.conversion) && angular.isDefined(field.conversion.operation)) {
				optionField.conversion = {
					operation: field.conversion.operation,
					factor : field.conversion.factor
				}
			}

			//loop through additional option keys and see if they are configured - if so set the properties on the MembershipSelectionOption so we can use the configuration
			Object.keys(ProfileEnumsService.CONFIGURABLE_FIELDS_MAPPING).forEach(function(mappingItem) {

			var obj = ProfileEnumsService.CONFIGURABLE_FIELDS_MAPPING[mappingItem];
			if (angular.isDefined(field[obj.config_field_name])) {
				optionField[mappingItem] = obj.checkBoolean ? getBoolean(field[obj.config_field_name]) :field[obj.config_field_name];
			}

			});

			factory.profileConfigurableFields.push(optionField);

		});

		}

	}

	/**
	 * Obtain profile configurable fields specific for a package - requires that the package have the charac that is configured in the mapping definition
	 * @param pkg
	 * @returns {Array}
	 */
	function getProfileConfigurableFieldsForPackage(pkg,previousLocaleSectionUsed) {
	var filteredFields = [];
	var profile = ProfileLoginSessionService.getCurrentLoggedInProfile();
	var fieldToAdd;
	var correspondingProfileSection;
	previousLocaleSectionUsed = configurableFieldLocale(previousLocaleSectionUsed);

	if (angular.isUndefined(profile)) {
		return filteredFields;
	}

	factory.profileConfigurableFields.forEach(function(configuredField) {
		if (Utilities.safelyCheckPropertyOnObject('pkg.CHARACS.' + configuredField.package_charac_name_mapping, pkg)) {
		fieldToAdd = angular.copy(configuredField);
		correspondingProfileSection = profile[configuredField.profile_property_mapping_section];

		if (validArray(correspondingProfileSection)) {
			correspondingProfileSection.forEach(function(item) {
			populateFieldValue(configuredField, fieldToAdd, item, previousLocaleSectionUsed);
			});
		}

		filteredFields.push(fieldToAdd);
		}
	});

	return filteredFields;
	}

		function updateFieldFromProfile(fld, profile, previousLocaleSectionUsed) {
			if (angular.isDefined(profile) && angular.isDefined(fld) && angular.isDefined(fld.profile_property_mapping_section) && angular.isDefined(profile[fld.profile_property_mapping_section])) {
				var profileSectionPart = profile[fld.profile_property_mapping_section];
				if (angular.isArray(profileSectionPart)) {

					profileSectionPart.forEach(function(item) {
						populateFieldValue(fld,fld,item,previousLocaleSectionUsed);
					});
				}
			}
		}

		/**
		 * Obtain profile configurable fields for a current logged in profile
		 * @returns {Array}
		 */
		function getProfileConfigurableFieldsForProfile(previousLocaleSectionUsed, profile, overrideEmptyProfileSection) {

			var profileFields = [];
			previousLocaleSectionUsed = configurableFieldLocale(previousLocaleSectionUsed);

			if (angular.isUndefined(profile)) {
				return profileFields;
			}
			factory.profileConfigurableFields.forEach(function(field) {

				if (angular.isDefined(profile[field.profile_property_mapping_section])) {

		var profileSectionPart = profile[field.profile_property_mapping_section];
		if (profileSectionPart.length === 0 && overrideEmptyProfileSection) {
			profileFields.push(field);
		} else if (angular.isArray(profileSectionPart)) {

						profileSectionPart.forEach(function(profilePart) {

							if ( angular.isDefined(profilePart[field.profile_property_mapping_property])
								&& profilePart[field.profile_property_mapping_property] === field.profile_property_mapping_value
								&& (
								 getBoolean(field.supports_all_membership_levels)
								 || (angular.isDefined(field.supported_membership_level_mappings) && field.supported_membership_level_mappings.indexOf(profile.base_membership_info.membership_level) > -1)
								)
							)
							{
								var fld = angular.copy(field);
								populateFieldValue(field,fld,profilePart,previousLocaleSectionUsed);
								profileFields.push(fld);

							}
						});
					}
				}
			});

			return profileFields;
		}

	/**
	* Obtain profile configurable fields for a current logged in profile
	* @returns {Array}
	*/
	function getProfileConfigurableFieldsForLoggedInProfile(previousLocaleSectionUsed) {
		 return getProfileConfigurableFieldsForProfile(previousLocaleSectionUsed, ProfileLoginSessionService.getCurrentLoggedInProfile());
	}

		/**
		 * configurableFieldLocale is used to transition from the configurable fields having locales based on where they are
		 * (profile, season pass, etc) to having a unified location. If the unified section is present, that will be used.
		 * Otherwise the previousLocaleSectionUsed is used.
		 * @param previousLocaleSectionUsed
		 */
		function configurableFieldLocale(previousLocaleSectionUsed) {
		 if (previousLocaleSectionUsed != ProfileLoginEnumsService.LOCALE_SECTION_FOR_CONFIGURABLE_INPUTS) {
		 	if (Language.sectionExists(ProfileLoginEnumsService.LOCALE_SECTION_FOR_CONFIGURABLE_INPUTS)) {
		 		return ProfileLoginEnumsService.LOCALE_SECTION_FOR_CONFIGURABLE_INPUTS;
			}
		 }
		 return previousLocaleSectionUsed;
	 }

	/**
	* Populate Configurable Field Value Using Profile Info
	* @param sourceField
	* @param destField
	* @param profilePart
	* @param localeSectionUsed
	*/
	function populateFieldValue(sourceField, destField, profilePart, previousLocaleSectionUsed) {
		var profilePartValue = getString(profilePart.value);

		previousLocaleSectionUsed = configurableFieldLocale(previousLocaleSectionUsed);

		if (angular.isDefined(profilePart[sourceField.profile_property_mapping_property]) && profilePart[sourceField.profile_property_mapping_property] === sourceField.profile_property_mapping_value) {

		if (sourceField.field_type === 'dropdown' && profilePartValue.length > 0) {

			var fieldOptions = Language.getLocale(previousLocaleSectionUsed, sourceField.placeholder_locale_target).split(',');
			if (fieldOptions.indexOf(profilePartValue) === -1 && sourceField.value_to_trigger_alt_collection != '') {

			destField.field_value = ProfileModels.getFieldValueFromProfileValue(sourceField, angular.copy(sourceField.value_to_trigger_alt_collection));
			destField.alt_collection_field_value = ProfileModels.getFieldValueFromProfileValue(sourceField, angular.copy(profilePart.value));

			} else {

			destField.field_value = ProfileModels.getFieldValueFromProfileValue(sourceField, angular.copy(profilePart.value));

			}

		} else {

			destField.field_value = ProfileModels.getFieldValueFromProfileValue(sourceField, angular.copy(profilePart.value));

		}
		destField.profile_manager_page = Utilities.forceInt(destField.profile_manager_page);
		destField.column = Utilities.forceInt(destField.column);
		if (destField.column < 1) {
			destField.column = 1;
		}
		}

	}

	/**
	* Get Verification Fields by Param - pass in a state param and obtain the array of fields required for the view
	* @param param
	* @returns {Array}
	*/
	function getVerificationFieldsByParam(param) {
		 var result = [],
			 prevIsHalfWidth = false,
			 fldWidth = 0;

		 if (param === ProfileLoginEnumsService.CREATE_NEW_ACCOUNT) {
		 	result = angular.copy(factory.newAccountLookupFields);
		 } else if (param === ProfileLoginEnumsService.FORGOT_PASSWORD) {
		 	result = angular.copy(factory.forgotPasswordVerificationFields);
		 } else if (param === ProfileLoginEnumsService.LOOKUP_EXISTING_MEMBER) {
		 	result = angular.copy(factory.lookupExistingMemberFields);
		 } else if (param === ProfileLoginEnumsService.RESET_PASSWORD_WITH_CODE) {
		 	result = angular.copy(factory.passwordResetFields);
		 }

		 // Set the class of each field, based on the field width property.
		 // If there is no field width property, assume it is full-width
		 // None of this is currently being used for cultural, just for ski.
		 for (var i=0; i<result.length; i++) {
		 	fldWidth = Utilities.forceInt(result[i].width);
			if (fldWidth < 3|| fldWidth > 12) {
				fldWidth = 12;
			}
		 	if (fldWidth < 12) {
				if (! prevIsHalfWidth) { // column 1
					result[i].class +="col-xs-12 col-sm-"+fldWidth.toString()+" responsive-padding-right"
				} else { // column 2
					result[i].class = "col-xs-12 col-sm-"+fldWidth.toString()+" responsive-padding-left clearfix no-margin-top-mobile";
				}
		 		prevIsHalfWidth = true;
			} else {
				result[i].class = "col-xs-12 no-padding";
				prevIsHalfWidth = false;
			}
		 }
		 return result;
	}

	/**
	* Configure the fields to append to backend requests
	*/
	function configureFieldsToAppendToBackendRequests() {

		factory.config.fields_for_backend_requests_post_login.forEach(function(field) {

		ProfileLoginSessionService.addFieldToAppendToBackendRequests(new ProfileModels.FieldToAppendOnBackendRequest(field));

		});

	}

	/**
	* Configure actions to run when a member logs in
	*/
	function configureDefinedActions() {

		//register actions that are configured within the profile_login app config first
		if (angular.isDefined(factory.config.configured_actions)) {

		factory.config.configured_actions.forEach(function(action) {

			if (angular.isDefined(ProfileLoginActionDefinitionService[action.key_name])) {

			ProfileLoginActionCoordinatorService.registerActionForGroup(action.group,action.key_name,ProfileLoginActionDefinitionService[action.key_name],action.params);

			}
		});
		}

		//now register actions that should always execute for members that login
		CustomActionService.registerCustomActionForChain(CustomActionService.ACTIONS_ENUMS.PRE_REQUEST_ADD_TO_CART_ITEMS,ProfileLoginActionDefinitionService.includeMemberIdOnCharacsForItemsToAddToCart);

	}

	/**
	* Configure additional actions
	*/
	function configureAdditionalActions() {
		if (getBoolean(factory.config.show_copy_profile_on_billing_shipping)) {
			AppData.setActionToPopulateBillingShippingFromOtherModel(function(billingOrShippingModel) {
				var profile = ProfileLoginSessionService.getCurrentLoggedInProfile();
				var primaryAddress;
				if (UtilsValidation.isRealObject(profile)) {
					primaryAddress = angular.copy(profile.getPrimaryAddress());
				}
				if (angular.isDefined(primaryAddress)) {
					billingOrShippingModel.firstName = angular.copy(profile.first_name);
					billingOrShippingModel.middleInitial = angular.copy(profile.middle_name);
					billingOrShippingModel.lastName = angular.copy(profile.last_name);
					billingOrShippingModel.phone = angular.copy(profile.getPrimaryPhone().phone_number);
					billingOrShippingModel.countryCode = angular.copy(profile.getPrimaryPhone().country_code);
					billingOrShippingModel.email = angular.copy(profile.email);
					billingOrShippingModel.address = angular.copy(primaryAddress.address);
					billingOrShippingModel.address2 = angular.copy(primaryAddress.address2);
					billingOrShippingModel.city = angular.copy(primaryAddress.city);
					billingOrShippingModel.state = angular.copy(primaryAddress.state);
					billingOrShippingModel.country = angular.copy(primaryAddress.country_code);
					billingOrShippingModel.zip = angular.copy(primaryAddress.zip_code);
				}
			}, ProfileLoginSessionService.isLoggedIn);
		}

		if (angular.isDefined(factory.config.keyword_to_route_for_expired_member_login)) {
			ProfileLoginSessionService.setKeywordToRouteExpiredMemberOnLogin(factory.config.keyword_to_route_for_expired_member_login);
		}

		if (angular.isDefined(factory.config.text_options)) {
			factory.config.text_options.forEach(function(textFieldName) {
				ProfileRequestService.registerOptionFieldNamesToPassAsText(textFieldName);
			});
		}
		CustomActionService.registerCustomAction(CustomActionService.ACTIONS_ENUMS.PURCHASE_COMPLETE_SUCCESS_GET_NEW_CART, transferTokenAndRunPostPurchaseActions);
	}


	/**
	* Transfer the backend session token to the new cart created after a successful purchase has occurred and run specific actions
	*/
	function transferTokenAndRunPostPurchaseActions(data) {


		Language.registerErrorCodeOverride(Enums.services.TRANSFER_TOKEN);

		//no need to check the response
		if (ProfileLoginSessionService.isLoggedIn()) {

			ProfileLoginRequestService.requestTransferToken({old_cart_id : data.old_cart_id}).then(function() {

				ProfileLoginActionCoordinatorService.executeActionsForGroup(ProfileEnumsService.ACTION_GROUPS.POST_PURCHASE);

			});

	 	}

	}

	/**
	* Obtain configuration for a global demographic field to guide whether or not we display within profile manager or the cultural membership wizard
	* @param fieldName
	* @returns {object}
	*/
	function getDemographicFieldForDisplay(fieldName) {

		var configuredField = undefined;
		if (angular.isDefined(factory.config.additional_demographic_fields_display_config)) {

		var specificFieldConfig = factory.config.additional_demographic_fields_display_config.filter(function(item) {return item.field_name === fieldName})[0];
		if (angular.isDefined(specificFieldConfig) &&getBoolean(specificFieldConfig.should_display)) {

			configuredField = specificFieldConfig;

		}

		}

		return configuredField;
	}

	function determineProfileRouting() {
		if (ProfileLoginSessionService.isLoggedIn() && getBoolean(factory.config.hide_profile_manager)) {
			ProfileLoginSessionService.displayConfirmLogoutModal();
		} else if (ProfileLoginSessionService.isLoggedIn()) {
			var targetState = Utilities.checkProp('AppData.settings.route_to_new_profile_manager', AppData, 'getBoolean')
				? 'profile-manager-new.profile'
				: 'profile-manager.profile.view';

			// Already in the profile manager (including child states) — do nothing.
			if (!$state.includes(targetState)) {
				Navigation.unSelectMenuItems();
				Utilities.goTo(targetState);
			}
		} else {
			Navigation.unSelectMenuItems();
			$rootScope.routeTo($state.href('profile-login.signin', { showSignInOnly: $rootScope.disableCreateAccountOnGlobalLogin }));
		}
	}

	return factory;


	}
);

(function() {
	'use strict';

	angular
		.module('profile-login')
		.service('ProfileLoginRequestService', function(AppData,
			Enums,
			JSONValidator,
			Language,
			Modal,
			ProfileUtilitiesService,
			RequestPropertyStorageService,
			PhoneNumberService,
			Utilities,
			UtilsValidation,
			$q,
			$rootScope,
			$state
		) {
			var validString = UtilsValidation.validString;

			this.showSentTempPasswordModal = showSentTempPasswordModal;
			this.showFailedTempPasswordModal = showFailedTempPasswordModal;
			this.lastPasswordResetEmailAddress = '';

			/**
			 * Request Login
			 * @param field
			 * @param password
			 * @returns {Promise}
			 */
			this.requestLogin = function(field, password) {
				var req = buildLoginRequest(field, password);

				return AppData.fetch(Enums.services.LOG_IN, false, req);
			}

			/**
			 * Request Logout
			 * @param field
			 * @param password
			 * @returns {Promise}
			 */
			this.requestLogout = function() {
				return AppData.fetch(Enums.services.LOG_OUT, false, {});
			}

			/**
			 * Request Transfer Token from old cart to new
			 * @param field
			 * @param password
			 * @returns {Promise}
			 */
			this.requestTransferToken = function(req) {
				return AppData.fetch(Enums.services.TRANSFER_TOKEN, false, req);
			}

			/**
			 * Build the login request given the field for identifying and the password
			 * @param field
			 * @param password
			 * @returns {{password: *, merchant_id: string}}
			 */
			function buildLoginRequest(field, password) {
				var req = {
					password: password,
					merchant_id: AppData.merchantId
				};

				ProfileUtilitiesService.addEmailOrMemberIdToRequest(field, req);

				return req;
			}


			/**
			 * Private function to send an internal node request to save properties on the socket connection
			 * @param props array of props in the format {prop_name, prop_value}
			 * @returns {*}
			 */
			this.savePropsOnCurrentConnection = function(fieldsToAppendToBackendRequests) {
				if (fieldsToAppendToBackendRequests.length) {
					fieldsToAppendToBackendRequests.forEach(function(field) {
						RequestPropertyStorageService.appendPropertyToAPIRequests(field.prop_name, field.prop_value);
					});
				}
				return $q.resolve();
			}

			/**
			 * Private function to send an internal node request to remove properties on the socket connection
			 * @param props array of props in the format [{prop_name, prop_value},..]
			 * @returns {*}
			 */
			this.removePropsFromCurrentConnection = function(fieldsToAppendToBackendRequests) {
				if (fieldsToAppendToBackendRequests.length) {
					fieldsToAppendToBackendRequests.forEach(function(field) {
						RequestPropertyStorageService.removePropertyToAPIRequests(field.prop_name);
					});
				}
				return $q.resolve();
			}


			/**
			 * Lookup a guest given either email/member_id in addition to firstname and lastname
			 * This function returns a promise unlike login because the callee may need to handle the error
			 * cases differently so the response logic is not bundled in this function.
			 * @param {array} fieldList  array of fields for the request
			 * @return {Promise} so that each callee can decide how to handle the response
			 */
			this.lookupGuest = function(fieldList) {
				$rootScope.showSpinner(Language.getLocale('ProfileLogin', 'lookupGuestSpinnerMsg'));
				var req = this.buildGenericLookupRequest(fieldList);
				return AppData.fetch(Enums.services.GUEST_LOOKUP, false, req);
			}


			/**
			 * Update the imported members profile with a valid email address
			 * @param fieldList
			 * @returns {*}
			 */
			this.updateImportedMemberProfile =function(fieldList, email) {
				$rootScope.showSpinner(Language.getLocale('ProfileLogin', 'updateMemberProfileSpinnerMsg'));
				var req = this.buildGenericLookupRequest(fieldList);
				req.is_imported = '1';
				req.email_address = email;
				return AppData.fetch(Enums.services.UPDATE_PROFILE, false, req);
			}

			/**
			 * Build the guestLookup request
			 * @param {Array} fieldList - all the fields that guests filled out
			 * @returns {object} request object
			 */
			this.buildGenericLookupRequest = function(fieldList) {
				var req = { merchant_id: AppData.merchant_id };
				var enhancedPhoneNumber = JSONValidator.validate('enhanced_phone_number', AppData.settings.enhanced_phone_number) ? JSON.parse(AppData.settings.enhanced_phone_number) : {};
				fieldList.forEach(function(field) {
					if (field.name === 'memberIdOrEmail') {
						ProfileUtilitiesService.addEmailOrMemberIdToRequest(field.value, req);
					} else if (['number', 'phone'].indexOf(field.name) !== -1) {
						req['phone'] = field.value;
						if (Utilities.getBoolean(enhancedPhoneNumber.use_enhanced_phone_number && validString(PhoneNumberService.getCountryCode()))) {
							req['country_code'] = PhoneNumberService.getCountryCode().replace('+', '');
						}
					} else {
						req[field.name] = field.value;
					}
				});

				return req;
			}

			/**
			 * Request to send temporary password to guest email
			 */
			this.sendTempPassword = function(fieldList) {
				var req = this.buildGenericLookupRequest(fieldList);
				$rootScope.showSpinner(Language.getLocale('ProfileLogin', 'handlingPasswordResetSpinnerMsg'));
				AppData.fetch(Enums.services.RANDOM_PASSWORD, false, req).then(function(response) {
					$rootScope.hideSpinner();
					if (response.status === 'OK') {
						showSentTempPasswordModal();
					} else {
						showFailedTempPasswordModal();
					}
				});
			}

			/**
			 * Executes callback function on enter
			 * @public
			 * @param {Object} event event object
			 * @param {Function} callback callback function
			 * @returns {undefined}
			 */
			this.executeOnEnter = function(event, callback) {
				if (event.key === 'Enter') {
					callback();
				} else if (event.keyIdentifier === 'Enter') {
					callback();
				} else if (event.keyCode === 13) {
					callback();
				}
			}

			/**
			 * Request to send temporary password to guest email
			 * @public
			 * @param {Object} fieldList List of fields
			 * @returns {Promise.<T>} Promise
			 */
			this.sendPasswordResetEmail = function(fieldList) {
				var req = this.buildGenericLookupRequest(fieldList);
				var requestType = Enums.services.GENERATE_PASSWORD_TOKEN;
				$rootScope.showSpinner(Language.getLocale('ProfileLogin', 'handlingPasswordResetSpinnerMsg'));
				this.lastPasswordResetEmailAddress = req.email;

				// Check if TE2 is configured, directly.
				// This way we don't add unnecessary dependancy on the TE2 service
				if (JSONValidator.validate('te2', AppData.settings.te2)) {
					req = { username: req.email };
					requestType = Enums.services.LOST_PASSWORD_EMAIL;
				}

				return AppData.fetch(requestType, false, req);
			}

			/**
			 * Show a modal to inform the guest that they have been sent a temporary password
			 */
			function showSentTempPasswordModal() {
				Modal.displayModal({
					category: 'Profile Login',
					action: 'Temp Password Sent',
					label: 'Temp Password Sent',
					title: Language.getLocale('ProfileLogin', 'sentTempPasswordTitle'),
					description: Language.getLocale('ProfileLogin', 'sentTempPasswordMsg'),
					callback: function() {
						$rootScope.routeTo($state.href('profile-login.signin', { showSignInOnly: $rootScope.disableCreateAccountOnGlobalLogin }));
					}
				});
			}

			/**
			 * Show a modal to inform the guest that they have been sent a temporary password
			 */
			function showFailedTempPasswordModal() {
				Modal.displayModal({
					category: 'Profile Login',
					action: 'Temp Password Failed',
					label: 'Temp Password Failed',
					title: Language.getLocale('ProfileLogin', 'failedTempPasswordTitle'),
					description: Language.getLocale('ProfileLogin', 'failedTempPasswordMsg'),
					callback: function() {
						$rootScope.routeTo($state.href('profile-login.signin', { showSignInOnly: $rootScope.disableCreateAccountOnGlobalLogin }));
					}
				});
			}
		});
})();

(function() {
	'use strict';

	angular
		.module('profile-login')
		.factory('ProfileLoginSessionService', function(AppData,
			CustomActionService,
			Enums,
			Language,
			Modal,
			ProfileLoginEnumsService,
			ProfileLoginActionCoordinatorService,
			ProfileEnumsService,
			ProfileModels,
			ProfileLoginRequestService,
			ProfileRequestService,
			RequestPropertyStorageService,
			Utilities,
			Package,
			ExtraFlow,
			Storage,
			$location,
			$log,
			$rootScope,
			$q,
			$state,
			$window,
			$injector,
			UtilsValidation
		) {
			var checkProp = Utilities.safelyCheckPropertyOnObject,
				getBoolean = Utilities.getBoolean,
				isObject = angular.isObject,
				validString = UtilsValidation.validString,
				multiGuestsMembershipList = [];

			//local private variable contained in this factory to hold all of the current session data
			var session = {
				currentLoggedInProfile: undefined,
				fieldsToAppendToBackendRequests: [],
				profileRetrieved: false
			};

			// the route to transition the user to after a successful login
			var postSigninSuccessRoute = '';

			var guestCheckout = false;

			var keywordToRouteExpiredMemberOnLogin = '';

			//allow the ability to globally override the membership expiration check outside of passing it to loginSession function
			var overrideMembershipExpirationCheckOnNextSignIn = false;

			// public variable exposed to the outside
			var factory = {
				addFieldToAppendToBackendRequests: addFieldToAppendToBackendRequests,
				addLinkedGuestNoToCharacs: addLinkedGuestNoToCharacs,
				allowOverrideMembershipExpirationCheckOnNextSignIn: allowOverrideMembershipExpirationCheckOnNextSignIn,
				continueToNextXFC: continueToNextXFC,
				displayConfirmLogoutModal: displayConfirmLogoutModal,
				createMultiGuestsMembershipList: createMultiGuestsMembershipList,
				getCurrentLoggedInProfile: getCurrentLoggedInProfile,
				getMultiGuestsMembershipList: getMultiGuestsMembershipList,
				getProfileWithCreateInternal: getProfileWithCreateInternal,
				getProfileDataFromLocalStorage : getProfileDataFromLocalStorage,
				handleTe2LoginResponse: handleTe2LoginResponse,
				hasMultiGuestsMemberships: hasMultiGuestsMemberships,
				isLoggedIn: isLoggedIn,
				isLoggedInActiveMember: isLoggedInActiveMember,
				isPostSignInSuccessRouteSetForState: isPostSignInSuccessRouteSetForState,
				isProfileRetrieved: isProfileRetrieved,
				loginSession: loginSession,
				logoutSession: logoutSession,
				memberBenefitGuestFormat: memberBenefitGuestFormat,
				persistSession: persistSession,
				refetchLoggedInSession: refetchLoggedInSession,
				reinitializeSession: reinitializeSession,
				setCurrentLoggedInProfile: setCurrentLoggedInProfile,
				setKeywordToRouteExpiredMemberOnLogin: setKeywordToRouteExpiredMemberOnLogin,
				setPostSigninSuccessRoute: setPostSigninSuccessRoute,
				getPostSigninSuccessRoute: getPostSigninSuccessRoute,
				setGuestCheckout: setGuestCheckout,
				isGuestCheckout: isGuestCheckout,
				setProfileRetrieved: setProfileRetrieved,
				loginSuccessHandler: loginSuccessHandler
			};

			/**
			 * Adds a guest_no charac to passed in charac for linked guests if it finds a dependent_id.
			 * @public
			 * @param {Object} characs The characs to modify
			 * @return {undefined}
			 */
			function addLinkedGuestNoToCharacs(characs) {
				var loggedInProfile = factory.getCurrentLoggedInProfile(),
					i = 0,
					linkedGuests,
					guest,
					count;

				if (!isObject(loggedInProfile) || !isObject(characs)) {
					return;
				}

				linkedGuests = loggedInProfile.getAllLinkedGuests();

				if (!UtilsValidation.validArray(linkedGuests) || !isObject(characs) || isNaN(characs.dependent_id)) {
					return;
				}

				count = linkedGuests.length;

				for (; i < count; i++) {
					guest = linkedGuests[i];

					if (isObject(guest) && validString(guest.dependent_id) && guest.dependent_id === characs.dependent_id) {
						/* eslint-disable camelcase */
						characs.guest_no = guest.guest_no;
						/* eslint-disable camelcase */
						return;
					}
				}
			}

			function continueToNextXFC() {
				if (angular.isDefined(Package.settings)) {
					ExtraFlow.addReferenceToCartItems(Package.settings.view, Package.itemsToBeAdded, ExtraFlow.CLIENT_XFC_VIEW);
					ExtraFlow.addReferenceToCartItems(Package.settings.name, Package.itemsToBeAdded, ExtraFlow.CLIENT_XFC_NAME);
				}
				if (Package.isForwardExtraFlowRouting()) {
					Package.nextXFC(true);
				} else {
					Package.cancelXFC(true);
				}
			}

			/**
			 * Return true if we are in multiGuests flow
			 * @public
			 * @function
			 * @param {Boolean} [excludePrimary] If we are to exclude the primary guest from the check
			 * @returns {Boolean} are we in multiGuests flow?
			 */
			function hasMultiGuestsMemberships(excludePrimary) {
				if (excludePrimary) {
					return multiGuestsMembershipList.filter(function(item) {
						// Linked guests only have first_name, guest_no, last_name. Primary has fully profile.
						return !(item instanceof ProfileModels.Profile);
					}).length > 0;
				}

				return multiGuestsMembershipList.length > 0;
			}

			/**
			 * Return multiGuests list
			 * @public
			 * @function
			 * @return {array} multiGuests list
			 */
			function getMultiGuestsMembershipList() {
				return multiGuestsMembershipList.slice(0);
			}

			/**
			 * Creating multiGuest list
			 * @public
			 * @function
			 * @return {undefined}
			 */
			function createMultiGuestsMembershipList() {
				var currentProfile,
					childrenLinkedGuestsMembership = session.currentLoggedInProfile.childLinkedGuests.reduce(function(acc, childGuest) {
						if (childGuest.membershipBenefit) {
							acc.push(factory.memberBenefitGuestFormat(childGuest))
						}
						return acc;
					}, []),
					adultLinkedGuestsMembership = session.currentLoggedInProfile.adultLinkedGuests.reduce(function(acc, adultGuest) {
						if (adultGuest.membershipBenefit) {
							acc.push(factory.memberBenefitGuestFormat(adultGuest))
						}
						return acc;
					}, []);

				if (session.currentLoggedInProfile.membershipBenefit) {
					currentProfile = angular.copy(session.currentLoggedInProfile);
					currentProfile.expire_date = checkProp('cur.base_membership_info.member_expire_date', currentProfile, 'returnValue') || null;
					multiGuestsMembershipList.push(currentProfile);
				}

				multiGuestsMembershipList = multiGuestsMembershipList.concat(childrenLinkedGuestsMembership, adultLinkedGuestsMembership);
			}

			/**
			 * Making format for multiGuest
			 * @protected
			 * @function
			 * @param {Object} guest object
			 * @return {Object} new guest object format
			 */
			function memberBenefitGuestFormat(guest) {
				return {
					expire_date: checkProp('guest.base_membership_info.member_expire_date', guest, 'returnValue') || null,
					first_name: guest.first_name,
					guest_no: guest.guest_no,
					last_name: guest.last_name
				};
			}

			/**
			 * Add a field to append to each backend requests for this session
			 * @param {Field} field
			 */
			function addFieldToAppendToBackendRequests(field) {
				session.fieldsToAppendToBackendRequests.push(field);
			}


			/**
			 * Check the response to see if we have data values for certain data points that we need to send to the backend on each request
			 * once a user logs in
			 * @param obj - an object containing potential data points to attach on all backend requests once logged in
			 */
			function checkForDataToAppendToBackendRequests(obj) {
				if (angular.isDefined(obj)) {
					session.fieldsToAppendToBackendRequests.forEach(function(field) {
						if (angular.isDefined(obj[field.prop_name])) {
							field.prop_value = obj[field.prop_name];
						}
					});
				}
			}

			/**
			 * Create a new profile object from the login response
			 * @param  {Object} profile profile
			 * @param  {Object} loginResponse login response from get profile call
			 * @returns {undefined}
			 */
			function mapDataFromResponseToProfile(profile, loginResponse) {
				profile.guest_no = profile.guest_no || loginResponse.guest_no;
				profile.is_member = getBoolean(loginResponse.is_member);
				profile.is_staff = getBoolean(loginResponse.is_staff);
				//add member specific fields for members
				if (profile.is_member && angular.isDefined(loginResponse.membership)) {
					profile.base_membership_info.member_id = angular.isDefined(loginResponse.membership.member_id) ? loginResponse.membership.member_id : '';
					profile.base_membership_info.member_expire_date = angular.isDefined(loginResponse.membership.membership_expires) ? loginResponse.membership.membership_expires : '';
					profile.base_membership_info.eligible_for_renewal = getBoolean(loginResponse.membership.eligible_for_renewal);
					profile.parseMembershipProductData(loginResponse.membership.membership_level);
					if (Utilities.safelyCheckPropertyOnObject('loginResponse.membership.child_memberships.child_membership', loginResponse)) {
						var childMemberships = angular.isArray(loginResponse.membership.child_memberships.child_membership) ? loginResponse.membership.child_memberships.child_membership : [loginResponse.membership.child_memberships.child_membership];
						childMemberships.forEach(function(childMem) {
							profile.addChildMembership(childMem.member_id, childMem.membership_level);
						});
					}
				}
			}

			/**
			 * Return the saved fields to append on backend requests in a format to make a request to Node
			 * @returns {Array}
			 */
			function getJSONFieldsToAppendToBackendRequests() {
				var props = [];
				session.fieldsToAppendToBackendRequests.forEach(function(field) {
					props.push(field.toJSON());
					RequestPropertyStorageService.appendPropertyToAPIRequests(field.prop_name, field.prop_value);
				});
				return props;
			}

			/**
			 * Retrieve the current logged in profile within this session
			 * @returns {*}
			 */
			function getCurrentLoggedInProfile() {
				return session.currentLoggedInProfile;
			}

			/**
			 * Set the current logged in profile to a profile
			 * @param profile
			 */
			function setCurrentLoggedInProfile(profile) {
				session.currentLoggedInProfile = profile;
			}

			/**
			 * checking if we are checking out as guest
			 * @public
			 * @return {boolean} is guest checkout
			 */
			function isGuestCheckout() {
				return guestCheckout;
			}

			/**
			 * setting guest checkout
			 * @public
			 * @param {boolean} userSelection if the user selected guest checkout
			 * @return {undefined}
			 */
			function setGuestCheckout(userSelection) {
				guestCheckout = userSelection;
			}

			function allowOverrideMembershipExpirationCheckOnNextSignIn() {
				overrideMembershipExpirationCheckOnNextSignIn = true;
			}

			/**
			 * Logout of the current session
			 * Remove the secure properties from the current connection to Node and then reset the in-memory session variables
			 * in addition to clearing out the local storage variables to prevent logged out members from leaving member-only items in cart
			 */
			function logoutSession(stateToRoutePostLogout) {
				$rootScope.showSpinner(Language.getLocale('ProfileLogin', 'logoutSpinnerMsg'));
				ProfileLoginRequestService.requestLogout().then(function() {
						return ProfileLoginRequestService.removePropsFromCurrentConnection(getJSONFieldsToAppendToBackendRequests());
				}).then(function() {
						if (isLoggedInActiveMember()) {
							ProfileLoginActionCoordinatorService.executeActionsForGroup(ProfileEnumsService.ACTION_GROUPS.MEMBER_LOGOUT);
						}
						handlePostLogoutActions();
				}).catch(function(err) {
						$log.error(err);
						handlePostLogoutActions();
				}).then(function() {
						// Keep spinner visible — full page reload resets it naturally.
						var route = stateToRoutePostLogout || $state.href('/', {});
						$window.location.href = (route + $window.location.search);
				});
		}

			/**
			 * After we logout of the store, we are clearing some local variables specific to the profile
			 * Additionally for now, we are clearing local storage and then we will reset the store until
			 * Backend provides support for clearing the cart of membership-only-related products
			 * For now, to be safe, we reset
			 */
			function handlePostLogoutActions() {
				session.currentLoggedInProfile = undefined;
				session.profileRetrieved = false;
				Storage.clearAll();
				CustomActionService.deregisterCustomAction(CustomActionService.ACTIONS_ENUMS.PURCHASE_ADD_ORDER_CHARACS);
				CustomActionService.deregisterCustomAction(CustomActionService.ACTIONS_ENUMS.TE2_ADD_IDENTITY_NODE);
			}

			/**
			 * Handle the login failure case
			 * @param response
			 */
			function handleLoginFailure(response) {
				var callback = undefined;

				if (angular.isDefined(response.error_code) && response.error_code === ProfileLoginEnumsService.STATUS_ERRORS.MEMBER_HAS_NO_EMAIL) {
					callback = function() {
						$rootScope.routeTo($state.href('profile-login.lookup-acct', { viewType: 'lookupExistingMember' }));
						$rootScope.hideSpinner();
					}
				}

				showLoginError(response.error_code, callback);
			}


			/**
			 * Assesses whether the guest is logged into the site
			 * @returns {boolean}
			 */
			function isLoggedIn() {
				return angular.isDefined(session.currentLoggedInProfile);
			}

			/**
			 * Assesses whether the guest is logged into the site as a member
			 * This excludes expired members
			 * @returns {boolean}
			 */
			function isLoggedInActiveMember() {
				return angular.isDefined(session.currentLoggedInProfile) && session.currentLoggedInProfile.is_member && !session.currentLoggedInProfile.isMemberExpired();
			}

			/**
			 * getProfileForCurrentLoggedInSession returns an empty promise if either the profile has already been retrieved or there is no
			 * logged in user. Otherwise, the profile is retrieved for the current session, the profileRetrieved flag is set.
			 * @param {boolean} isTE2Login specifies if this login request is for a TE2 profile
			 */
			function getProfileForCurrentLoggedInSession(isTE2Login) {
				if (isProfileRetrieved() || ! isLoggedIn()) {
					return $q.when();
				}
				return ProfileRequestService.getProfile(session.currentLoggedInProfile, false, isTE2Login).then(
					function() {
						// if the profile is loaded, set the profileRetrieved flag appropriately.
						setProfileRetrieved(true);
					}
				);
			}

			function getProfileWithCreateInternal() {
				// if the current user is not logged in or doesn't have a profile, just reject.
				if (! isProfileRetrieved() || ! isLoggedIn()) {
					return $q.reject();
				}
				// if the current user already has an id, we don't need to call with create_internal
				if (angular.isDefined(session.currentLoggedInProfile.customer_id)) {
					return $q.when();
				}
				// We have a logged-in user, but that user was not loaded with create_internal
				return ProfileRequestService.getProfile(session.currentLoggedInProfile, true).then(
					function() {
						// if the profile is loaded, set the profileRetrieved flag appropriately.
						setProfileRetrieved(true);
					}
				);
			}

			function handleLoginError(msg, onFailure) {
				if (angular.isDefined(onFailure)) {
					onFailure();
				} else {
					handleLoginFailure(msg);
				}
			}

			/**
			 * Attempt to login a new session
			 * @param {object} loggedInProfile optionalprofile to login
			 * @param {string} loginField validation field (either member id or email address)
			 * @param {string} password the users password
			 * @param {boolean} shouldCheckExpiredMember optional fieldwhether or not to check if the member is expired
			 * @param {function} onSuccess optional functionfunction to call if successfully logged in
			 * @param {function} onFailure optional functionfunction to call if login failed
			 * @returns {undefined}
			 */
			function loginSession(loggedInProfile, loginField, password, shouldCheckExpiredMember, onSuccess, onFailure) {
				var TE2Service,
					StoredPaymentPrepService,
					isTE2Login = false,
					memberExpired = false,
					loggedInProfileAction = CustomActionService.ACTIONS_ENUMS.GET_LOGGEDIN_PROFILE;
				// we're logging in a new user, so reset the profile loaded flag.
				setProfileRetrieved(false);

				if (!CustomActionService.actionRegistered(loggedInProfileAction)) {
					CustomActionService.registerCustomAction(loggedInProfileAction, factory.getCurrentLoggedInProfile);
				}

				// attempt to do the login
				ProfileLoginRequestService
					.requestLogin(loginField, password)
					.then(function(loginResponse) {
						if (loginResponse.status === Enums.status.OK) {
							checkForDataToAppendToBackendRequests(loginResponse);

							ProfileLoginRequestService
								.savePropsOnCurrentConnection(getJSONFieldsToAppendToBackendRequests())
								.then(function() {
									var profile = angular.isDefined(loggedInProfile) ? loggedInProfile : new ProfileModels.Profile();
									mapDataFromResponseToProfile(profile, loginResponse);
									if (validString(loginResponse.access_token)) {
										isTE2Login = true;
										TE2Service = $injector.get('TE2Service');
										TE2Service.setTE2Token(loginResponse.access_token);
									}
									profile.password = password;
									session.currentLoggedInProfile = profile;
									persistSession();
									ProfileLoginActionCoordinatorService.executeActionsForGroup(CustomActionService.ACTIONS_ENUMS.REGISTER_POST_PURCHASE_LOGOUT_ACTION);
									// now that we've logged the user in, get profile information
									getProfileForCurrentLoggedInSession(isTE2Login)
										.then(function() {
											if (!isTE2Login) {
												CustomActionService.registerCustomAction(CustomActionService.ACTIONS_ENUMS.PURCHASE_ADD_ORDER_CHARACS, addMemberOrderCharacs);

												if (isLoggedInActiveMember()) {
													//run logged in member actions
													ProfileLoginActionCoordinatorService.executeActionsForGroup(ProfileEnumsService.ACTION_GROUPS.MEMBER_LOGIN_SUCCESS);
												}

												if (shouldCheckExpiredMember && !overrideMembershipExpirationCheckOnNextSignIn && profile.is_member && profile.isMemberExpired() && keywordToRouteExpiredMemberOnLogin.length > 0 && !/^\/pass-select\//.test(factory.getPostSigninSuccessRoute())) {
													showExpiredMemberModal();
													memberExpired = true;
												}
												createMultiGuestsMembershipList();
												factory.loginSuccessHandler(memberExpired, isTE2Login, onSuccess);
											} else {
												StoredPaymentPrepService = $injector.get('StoredPaymentPrepService');
												StoredPaymentPrepService.initializeAndLoadStoredPaymentsConfig().finally(function() {
													factory.loginSuccessHandler(memberExpired, isTE2Login, onSuccess);
												});
											}
										},
										function(err) {
											if (isLoggedIn()) {
												// Loading the profile didn't work. Log them out and show a message.
												// From the user's perspective, this is the same as a failed logout.
												logoutSession();
											}
											handleLoginError(err, onFailure);
										});
								}, function(err) {
									handleLoginError(err, onFailure)
								});
						} else {
							handleLoginError(loginResponse, onFailure);
						}
					});
			}

			/**
			 * Handles a response from the TE2 auto login from te2_session query param
			 * @param {Object} loginResponse The login response
			 * @returns {undefined}
			 */
			function handleTe2LoginResponse(loginResponse) {
				var fieldsToAdd;
				var done = function() {
					var profile = new ProfileModels.Profile();
					mapDataFromResponseToProfile(profile, loginResponse);
					session.currentLoggedInProfile = profile;
				};

				checkForDataToAppendToBackendRequests(loginResponse);
				fieldsToAdd = getJSONFieldsToAppendToBackendRequests();

				if (!fieldsToAdd.length) {
					return done();
				}

				ProfileLoginRequestService
					.savePropsOnCurrentConnection(fieldsToAdd)
					.finally(done);
			}

			/**
			 * Refetches the profile, in case information has changed
			 * @returns {undefined}
			 */
			function refetchLoggedInSession() {
				var isTE2Login = getBoolean($injector.has('TE2Service') && $injector.get('TE2Service').getTE2Token());
				ProfileRequestService.getProfile(session.currentLoggedInProfile, false, isTE2Login);
			}

			/**
			 * Either routes to profile manager, the root of the store, some established postSigninSuccessRoute, or the provided onSuccess function
			 * @param {Boolean} memberExpired Whether or not the member is expired
			 * @param {Boolean} isTE2Login Whether or not this is a TE2 Login scenario
			 * @param {Fuction} onSuccess What function to call on success, instead of routing
			 * @return {undefined}
			 */
			function loginSuccessHandler(memberExpired, isTE2Login, onSuccess) {
				if (!memberExpired) {
					if (angular.isFunction(onSuccess)) {
						onSuccess();
					} else if (validString(postSigninSuccessRoute)) {
						$rootScope.routeTo(postSigninSuccessRoute);
						postSigninSuccessRoute = '';
					} else if (isTE2Login) {
						$rootScope.routeTo('/');
					}

					// TODO: Once clients are migrated this will need to route solely to the new profile-manager 'profile-manager-new.profile' and remove the else condition and the check for the app config
					else {
						if (checkProp('AppData.settings.route_to_new_profile_manager', AppData, 'getBoolean')) {
							$rootScope.routeTo($state.href('profile-manager-new.profile'));
						} else {
							$rootScope.routeTo($state.href('profile-manager.profile'));
						}
						return $q.reject();
					}
				}
			}

			/**
			 * Pushing member id to Order Characs when making purchase
			 * @function
			 * @protected
			 * @param {Object} orderCharacs Object
			 * @returns {undefined}
			 */
			function addMemberOrderCharacs(orderCharacs) {
				if (Utilities.safelyCheckPropertyOnObject('session.currentLoggedInProfile.base_membership_info.member_id', session)) {
					orderCharacs.push({ member_id: session.currentLoggedInProfile.base_membership_info.member_id});
				}
			}

			/**
			 * Persist the session to local storage under the _profile identifier
			 * We create a temporary object with JSON session info and then base64 encode the
			 * information to store in local storage for obscurity
			 * @returns {undefined}
			 */
			function persistSession() {
				//create an object to store the session token information so we can retrieve it on reinitialization
				var sessionStorageData = { profileData: {} };

				// nothing to do if the user is not logged in.
				if (!isLoggedIn()) {
					return;
				}
				angular.extend(sessionStorageData.profileData, session.currentLoggedInProfile.getStorableProperties());

				//save data for backend requests on the profile storage object
				session.fieldsToAppendToBackendRequests.forEach(function(field) {
					sessionStorageData[field.prop_name] = field.prop_value;
				});

				Storage.set('_profile', window.btoa(JSON.stringify(sessionStorageData)), true);
			}

			/**
			 * Retrieve the _profile JSON base64encoded object and parse the data into the local
			 * session variable
			 */
			function reinitializeSession() {
				var deferred = $q.defer();
				var sessionStorageData = getProfileDataFromLocalStorage();

				if (sessionStorageData !== null && !isLoggedIn() && !$location.search().access_token) {
					session.fieldsToAppendToBackendRequests.forEach(function(field) {
						if (angular.isDefined(sessionStorageData[field.prop_name])) {
							field.prop_value = sessionStorageData[field.prop_name];
						}
					});

					CustomActionService.registerCustomAction(CustomActionService.ACTIONS_ENUMS.PURCHASE_ADD_ORDER_CHARACS, addMemberOrderCharacs);

					ProfileLoginRequestService.savePropsOnCurrentConnection(getJSONFieldsToAppendToBackendRequests()).then(function(savePropsResponse) {
						session.currentLoggedInProfile = new ProfileModels.Profile();
						session.currentLoggedInProfile.autofill(sessionStorageData.profileData);

						getProfileForCurrentLoggedInSession()
							.then(
								function(response) {
									ProfileLoginActionCoordinatorService.executeActionsForGroup(CustomActionService.ACTIONS_ENUMS.REGISTER_POST_PURCHASE_LOGOUT_ACTION);
									if (isLoggedInActiveMember()) {
										ProfileLoginActionCoordinatorService.executeActionsForGroup(ProfileEnumsService.ACTION_GROUPS.MEMBER_LOGIN_SUCCESS);
									}
									createMultiGuestsMembershipList();
									deferred.resolve();
								},
								function(err) {
									// unable to load the profile. Silently fail (as we do with an unsuccessful login). They'll be able to log in again.
									if (isLoggedIn()) {
										logoutSession();
									}
									deferred.resolve();
								}
							);
						//resolve on error anyways because we give them the chance to log in again
					}, function(err) {
						deferred.resolve();
					});
				} else if (($location.search().guest_checkout === 'true')) {
					setGuestCheckout(true);
					deferred.resolve();
				} else {
					deferred.resolve();
				}

				return deferred.promise;
			}

			/**
			 * Return profile information for API requests like auth_token, guest_no, member id
			 * @public
			 * @function
			 * @returns {Object | null} decoded key from local storage.
			 */
			function getProfileDataFromLocalStorage(){
				var profileStorageData = Storage.get('_profile');
				return profileStorageData ? JSON.parse(window.atob(profileStorageData)) : profileStorageData ;
			}
			/**
			 * Set a variable indicating that we have retrieved the profile from the backend
			 * This is to prevent retrieving constantly
			 * @param {boolean} bool
			 */
			function setProfileRetrieved(bool) {
				session.profileRetrieved = bool;
			}

			/**
			 * Get the value of variable indicating that we have retrieved the profile from the backend
			 * @return {boolean}
			 */
			function isProfileRetrieved() {
				return session.profileRetrieved;
			}

			/**
			 * URL that represents state and params (state.href form) to route to after a successful signin
			 * @param stateRoute
			 */
			function setPostSigninSuccessRoute(stateRoute) {
				postSigninSuccessRoute = stateRoute;
			}

			/**
			 * Gets URL that represents state and params (state.href form) to route to after a successful signin
			 * @public
			 * @return {string} route to take after successful login
			 */
			function getPostSigninSuccessRoute() {
				return postSigninSuccessRoute;
			}

			/**
			 * Checks whether or not the post signin success route is active for a particular route
			 * This will match a full route string or just a subset of the string (easier to use if routes have parent states)
			 * @param routeToCheck
			 * @returns {boolean}
			 */
			function isPostSignInSuccessRouteSetForState(routeToCheck) {
				return !Utilities.isEmpty(postSigninSuccessRoute) && postSigninSuccessRoute.indexOf(routeToCheck) > -1;
			}

			/**
			 * Set the keyword to route expired member
			 * @param keyword
			 */
			function setKeywordToRouteExpiredMemberOnLogin(keyword) {
				if (angular.isDefined(keyword)) {
					keywordToRouteExpiredMemberOnLogin = keyword;
				}
			}

			/**
			 * Show a modal to indicate the membership has expired
			 */
			function showExpiredMemberModal() {
				$rootScope.hideSpinner();
				var title = session.currentLoggedInProfile.isMemberEligibleForRenewal() ? 'loginError_MemberExpired_Title' : 'loginError_MemberExpired_NoRenew_Title';
				var msg = session.currentLoggedInProfile.isMemberEligibleForRenewal() ? 'loginError_MemberExpired_Msg' : 'loginError_MemberExpired_NoRenew_Msg';
				Modal.displayModal(
					{
						category: 'Profile Login Member Expired',
						action: 'Error',
						label: 'Login Error Member Expired',
						title: Language.getLocale('ProfileLogin', title),
						description: Language.getLocale('ProfileLogin', msg),
						showCloseButton: false,
						buttonFlags: [Enums.buttonFlags.OK, Enums.buttonFlags.CANCEL],
						callback: function(choice) {
							$rootScope.showSpinner();
							if (choice === Enums.buttonFlags.CANCEL) {
								// TODO: Once fully tested, let's remove references to the old profile-manager and just route to the new one
								if (checkProp('AppData.settings.route_to_new_profile_manager', AppData, 'getBoolean')) {
									$rootScope.routeTo($state.href('profile-manager-new.profile'));
								} else {
									$rootScope.routeTo($state.href('profile-manager.profile'));
								}
							} else {
								$rootScope.routeTo($state.href('packageList/keyword', { keyword: keywordToRouteExpiredMemberOnLogin }));
							}
						}
					}
				);
			}

			/**
			 * Show a login error modal to the guest based on error code for locale
			 */
			function showLoginError(errorCode, callback) {
				var displayedErrorCode = angular.isDefined(errorCode) && errorCode.length > 0 ? errorCode : ProfileLoginEnumsService.STATUS_ERRORS.DEFAULT;
				$rootScope.hideSpinner();
				Modal.displayModal({
					category: 'Profile Login',
					action: 'Error',
					label: 'Login Error',
					title: Language.getLocale('ProfileLogin', 'loginError_' + displayedErrorCode + '_Title'),
					description: Language.getLocale('ProfileLogin', 'loginError_' + displayedErrorCode + '_Msg'),
					showCloseButton: false,
					callback: function(answer) {
						if (angular.isFunction(callback)) {
							callback();
						}
					}
				});
			}

			/**
			 * Display a modal upon clicking on the profile icon to sign out
			 * @public
			 * @return {undefined}
			 */
			function displayConfirmLogoutModal() {
				Modal.displayModal(
					{
						category: 'Profile Manager',
						action: 'Confirm Logout Profile',
						label: 'Confirm Logout Profile',
						title: Language.getLocale('ProfileManager', 'confirmLogoutModalTitle'),
						description: Language.getLocale('ProfileManager', 'confirmLogoutModalMsg'),
						buttonFlags: [Enums.buttonFlags.OK, Enums.buttonFlags.CANCEL],
						callback: function(answer) {
							if (answer === Enums.buttonFlags.OK) {
								logoutSession($state.href('/', {}));
							}
						}
					}
				);
			}

			return factory;
		});
})();

(function() {
	'use strict';
	angular
		.module('profile-login')
		.factory('ProfileLoginImageService', ProfileLoginImageService);

	/**
	 * Our service
	 * @public
	 * @constructor
	 * @function
	 * @param {Service} $q For promises
	 * @param {Service} AppData AppData
	 * @param {Service} JSONValidator JSONValidator
	 * @param {Service} ProfileLoginSessionService ProfileLoginSessionService
	 * @param {Service} ProfileLoginPrepService ProfileLoginPrepService
	 * @param {Service} Utilities Utilities
	 * @param {Service} UtilsValidation UtilsValidation Service
	 * @param {Service} ImageCapturesRequestService ImageCapturesRequestService
	 * @param {Service} ImageCapturePrepService ImageCapturePrepService
	 * @param {Service} CustomActionService CustomActionService
	 * @return {Object} our service
	 * @ngInject
	 */
	function ProfileLoginImageService($q, AppData, JSONValidator, ProfileLoginSessionService, ProfileLoginPrepService, Utilities, UtilsValidation, ImageCapturesRequestService, ImageCapturePrepService, CustomActionService) {
		var validString = UtilsValidation.validString,
			safelyCheck = Utilities.safelyCheckPropertyOnObject,
			returnOrDefault = UtilsValidation.returnOrDefault;
		var service = {
			_findGuest: _findGuest,
			_getFileName: _getFileName,
			_getImageAwsFolderOnProfile: _getImageAwsFolderOnProfile,
			_stripPath: _stripPath,
			getImageUrlForProfile: getImageUrlForProfile,
			getImagesForGuests: getImagesForGuests,
			imageUrlsForGuests: [],
			registerCustomActions: registerCustomActions,
			setupImagesForProfiles: setupImagesForProfiles,
			setupImagesForSeasonPasses: setupImagesForSeasonPasses,
			useAwsFolderOnProfile: null
		};
		service.registerCustomActions();

		return service;

		/**
		 * Register Custom Actions for Image handling
		 * @public
		 * @returns {undefined}
		 */
		function registerCustomActions() {
			CustomActionService.registerCustomAction(CustomActionService.ACTIONS_ENUMS.SETUP_PROFILE_LOGIN, service.setupImagesForProfiles);
			CustomActionService.registerCustomAction(CustomActionService.ACTIONS_ENUMS.SETUP_SEASON_PASS_SELECT_XFC, service.setupImagesForSeasonPasses);
		}

		/**
		 * Setup Images for Profiles
		 * @public
		 * @returns {Promise | undefined} promise
		 */
		function setupImagesForProfiles() {
			var includeImagesOnSummaryTab = Utilities.getBoolean(ProfileLoginPrepService.config.display_profile_image_selection);
			if (includeImagesOnSummaryTab) {
				ImageCapturePrepService.setupConfiguration();
				return service.getImagesForGuests();
			}
			return;
		}

		/**
		 * Setup images for seasonpasses
		 * @public
		 * @returns {Promise | undeifned} promise
		 */
		function setupImagesForSeasonPasses() {
			return service.getImagesForGuests();
		}

		/**
		 * Get signed image url for profile
		 * @public
		 * @param {Object} profile profile object
		 * @returns {String} image url
		 */
		function getImageUrlForProfile(profile) {
			var profileFound = service._findGuest(profile);

			if (profileFound) {
				return returnOrDefault(profileFound.imageUrl, '');
			}
			return '';
		}

		/**
		 * Find guest in guests array
		 * @public
		 * @param {Object} guest guest
		 * @returns {Object | undefined} guest object if found
		 */
		function _findGuest(guest) {
			if (!safelyCheck('guest.image', guest, validString)) {
				return '';
			}

			return service.imageUrlsForGuests.find(function(guestObj) {
				return guestObj.guestNo === guest.guest_no;
			});
		}

		/**
		 * Get images for all guests
		 * @public
		 * @function
		 * @param {Object} guest guest
		 * @returns {Promise} promise
		 */
		function getImagesForGuests(guest) {
			var linkedGuests = guest || ProfileLoginSessionService.getCurrentLoggedInProfile().linkedGuests(true),
				promises = [];
			linkedGuests = Utilities.wrapObjectToArray(linkedGuests);
			linkedGuests.forEach(function(guest) {
				if (safelyCheck('guest.image', guest, validString)) {
					promises.push(ImageCapturesRequestService.getSignedUrl(service._getFileName(service._stripPath(guest.image)), guest.guest_no));
				}
			});
			return $q.all(promises)
				.then((function(response) {
					var guestFound;
					response = Utilities.wrapObjectToArray(response);
					response.forEach(function(res) {
						guestFound = service.imageUrlsForGuests.find(function(guestObj) {
							return guestObj.guestNo === res.guest_no;
						});
						if (!guestFound) {
							service.imageUrlsForGuests.push({
								guestNo: res.guest_no,
								imageUrl: res.url
							});
						} else {
							guestFound.imageUrl = res.url;
						}
					});
				}));
		}

		/**
		 * Determines if we should prepend the imageAWSbucketfolder app config value to the profile image filename
		 * @protected
		 * @returns {Boolean}
		 */
		function _getImageAwsFolderOnProfile() {
			if (service.useAwsFolderOnProfile === null) {
				service.useAwsFolderOnProfile = JSONValidator.validate('image_aws_folder_on_profile', AppData.settings.image_aws_folder_on_profile) && Utilities.getBoolean(AppData.settings.image_aws_folder_on_profile);
			}

			return service.useAwsFolderOnProfile;
		}

		/**
		 * Gets the filename we will need to retrieve based upon any configurations
		 * @protected
		 * @param {String} filename The basic filename that will be used
		 * @returns {String} The filename that has been adjusted or not
		 */
		function _getFileName(filename) {
			return service._getImageAwsFolderOnProfile()
				? Utilities.getString(AppData.settings.imageAWSbucketfolder) + filename
				: filename;
		}

		/**
		 * Strip file path
		 * @public
		 * @param {String} imageFileName image file name
		 * @returns {String} path
		 */
		function _stripPath(imageFileName) {
			var index;
			if (validString(imageFileName)) {
				index = imageFileName.indexOf('/');
				return index === -1 ? imageFileName : imageFileName.substr(index + 1);
			}
			return '';
		}
	}
}());

/**
 * Created by ltischuk on 4/8/16.
 */
angular
  .module('profile-login')
  .factory('ProfileLoginActionDefinitionService',
    function (AppData,
            Enums,
            Language,
            Modal,
            Navigation,
            ProfileLoginSessionService,
			     CustomActionService,
            Utilities,
            $rootScope,
            $state) {


    var factory = {

        activateParentMenuItemById: AppData.activateParentMenuItemById,
        deActivateParentMenuItemById: AppData.deActivateParentMenuItemById,
        checkForUpcomingExpirationNotification: checkUpcomingExpirationNotification,
        includeMemberIdOnCharacsForItemsToAddToCart: includeMemberIdOnCharacsForItemsToAddToCart,
        logoutPostPurchaseForMembershipPurchases: logoutPostPurchaseForMembershipPurchases,
        registerSkipMembershipUpsell: registerSkipMembershipUpsell

    };

    return factory;

    /**
     * An action that will check whether or not a member is due to expire and if so will notify the user if they are set to expire within a configured threshold
     * @param daysToExpireThreshold
     * @param keywordToRoute
     */
    function checkUpcomingExpirationNotification(daysToExpireThreshold,keywordToRoute){

      var profile = ProfileLoginSessionService.getCurrentLoggedInProfile();
      if(ProfileLoginSessionService.isLoggedInActiveMember()){

          var expireDate = new Date(profile.base_membership_info.member_expire_date);
          if(Utilities.getNumberOfDaysBetweenTwoDays(new Date(),expireDate) <= daysToExpireThreshold && profile.isMemberEligibleForRenewal()){

            Modal.displayModal({
            	category: 'Upcoming Member Expiration Notification',
            	action: 'Notification',
            	label: 'Upcoming Member Expiration Notification',
            	title: Language.getLocale('ProfileLogin', 'upcomingMemberExpireNotifyTitle'),
            	description: Language.getLocale('ProfileLogin', 'upcomingMemberExpireNotifyMsg'),
            	showCloseButton: false,
            	buttonFlags: [Enums.buttonFlags.OK, Enums.buttonFlags.CANCEL],
            	callback: function (choice) {

            		if (choice === Enums.buttonFlags.OK) {
            			$rootScope.routeTo($state.href('packageList/keyword', {
            				keyword: keywordToRoute
            			}));
            		}
            	}
            });

          }
      }
    }

	 /**
	  * Attach the member id on the characs for all items added to the cart for a logged in member
	  * @param itemsToBeAdded
	  */
    function includeMemberIdOnCharacsForItemsToAddToCart(itemsToBeAdded){

		if(ProfileLoginSessionService.isLoggedInActiveMember()){

			var profile = ProfileLoginSessionService.getCurrentLoggedInProfile();

			itemsToBeAdded.forEach(function(item){

				if(angular.isDefined(item.CHARACS) && angular.isArray(item.CHARACS)){

					item.CHARACS.forEach(function(charac){

						if(angular.isUndefined(charac.member_id)){

							charac.member_id = angular.copy(profile.base_membership_info.member_id);

						}
					});
				}
			});
		}
	}

    /**
     * Register Skip Memberhship Upsell action so that when a logged in member happens to navigate to a package
     * that upsells to a membership, they wont see it
     */
    function registerSkipMembershipUpsell() {

      var profile = ProfileLoginSessionService.getCurrentLoggedInProfile ();
      if (ProfileLoginSessionService.isLoggedIn () && profile.is_member) {

        CustomActionService.registerCustomAction (CustomActionService.ACTIONS_ENUMS.SHOULD_SKIP_UPSELL_KEYWORD_CHECK_FOR_PACKAGE,
          doesUpsellKeywordLinkToMembershipWizard);

      }


    }

    /**
     * Does the upsell keyword link to the membership wizard
     * @param upsellKeywordList
     * @returns {boolean}
     */
    function doesUpsellKeywordLinkToMembershipWizard(upsellKeywordList){

      var shouldSkip = false;

      if(angular.isDefined(upsellKeywordList)){

        for(var i = 0; i< upsellKeywordList.length; i++){

          var upsellKeyword = upsellKeywordList[i];
          var navigationLookup = Navigation.lookupTreeByProperty('keywords', upsellKeyword);
          if(angular.isDefined(navigationLookup) && angular.isDefined(navigationLookup.alternateModule) &&
            navigationLookup.alternateModule.toLowerCase() === 'culturalmembershipwizard'){

            shouldSkip = true;
            break;

          }

        }


      }


      return shouldSkip;

    }

	 /**
	  * We only do this for post purchase if a membership was purchased and the profile_login app config is equipped with postPurchase action within the configured_actions section
	  */
	 function logoutPostPurchaseForMembershipPurchases(){

	 	//if a membership was purchased within this cart and the member is still logged in, log out the session so that they are forced to login again if they want to use their member beneftis
		 //THIS WILL GO AWAY ONCE ON THE FLY BENEFITS EXISTS
		if(ProfileLoginSessionService.isLoggedIn() && Utilities.safelyCheckPropertyOnObject( 'AppData.GuestViewOrder.VIEW_ORDER_REPLY.TICKET_DETAILS_REPLY.TICKET', AppData ) ) {
			 var tickets = AppData.GuestViewOrder.VIEW_ORDER_REPLY.TICKET_DETAILS_REPLY.TICKET;
			 for (var i = 0; i < tickets.length; i++) {
				 if (angular.isDefined(tickets[i].SEASON_PASS)) {
					 ProfileLoginSessionService.logoutSession();
				 }
			 }
		 }
	 }
  }
);

(function() {
	'use strict';

	angular
		.module('profile-login')
		.factory('ProfileLoginActionCoordinatorService', function(ProfileLoginModels) {
			var groupedActions = [];

			var factory = {
				deRegisterActionForGroup: deRegisterActionForGroup,
				deRegisterAllActionsForGroup: deRegisterAllActionsForGroup,
				executeActionsForGroup: executeActionsForGroup,
				registerActionForGroup: registerActionForGroup
			};

			return factory;

			/**
			 * Searches and returns the specified group name
			 * @param  {String} groupName Name of the group
			 * @returns {Object | undefined} actionGroup
			 */
			function getGroupFromList(groupName) {
				return groupedActions.filter(function(group) {
					return group.groupName === groupName
				})[0];
			}

			/**
			 * Registers an action under a group and action name.
			 * @param  {String} groupName groupName
			 * @param  {String} actionName actionName
			 * @param  {Function} actionToExecute function to execute
			 * @param  {Object} params list of parameters to pass to function when executed
			 * @returns {undefined}
			 */
			function registerActionForGroup(groupName, actionName, actionToExecute, params) {
				var group = undefined;
				if (angular.isUndefined(actionToExecute)) {
					throw new Error('Error registering action for group: must include an actionToExecute in order to properly register an action');
				} else {
					group = getGroupFromList(groupName);
					if (angular.isUndefined(group)) {
						group = new ProfileLoginModels.ActionGroup(groupName);
					}

					group.addAction(actionName, actionToExecute, params);
				}
				groupedActions.push(group);
			}

			/**
			 * De-registers action from group
			 * @param  {String} groupName groupName
			 * @param  {String} actionName actionName
			 * @returns {undefined}
			 */
			function deRegisterActionForGroup(groupName, actionName) {
				var group = getGroupFromList(groupName);
				if (angular.isDefined(group)) {
					group.removeAction(actionName);
				}
			}

			/**
			 * De-registers all actions for specified group
			 * @param  {String} groupName groupName
			 * @returns {undefined}
			 */
			function deRegisterAllActionsForGroup(groupName) {
				var group = getGroupFromList(groupName);
				if (angular.isDefined(group)) {
					group.actions.length = 0;
				}
			}

			/**
			 * Execute actions for a particular group of actions
			 * @param  {String} groupName groupName
			 * @returns {undefined}
			 */
			function executeActionsForGroup(groupName) {
				var group = getGroupFromList(groupName);

				if (angular.isDefined(group)) {
					group.actions.forEach(function(action) {
						action.actionToExecute.apply(null, action.params);
					});
				}
			}
		});
})();
/**
 * Created by ltischuk on 4/8/16.
 */

angular.module('profile-login').service
('ProfileLoginModels',
  function () {

    /**
     * ActionGroup class for a group of actions
     * @param groupName
     * @constructor
     */
    function ActionGroup(groupName) {

      this.groupName = groupName;
      this.actions = [];

    }

    /**
     * Function to add a new action
     * @param keyName
     * @param paramList
     */
    ActionGroup.prototype.addAction = function (keyName, actionToExecute, params) {

      this.actions.push (new Action (keyName, actionToExecute,params));

    }

    /**
     * Function to remove an action from the list
     * @param keyName
     */
    ActionGroup.prototype.removeAction = function (keyName) {

      var actionToRemove = this.actions.filter (function (action) {
        return action.keyName === keyName
      })[0];
      if (angular.isDefined (actionToRemove)) {

        this.actions.splice (this.actions.indexOf (actionToRemove), 1);

      }

    }

    this.ActionGroup = ActionGroup;

    /**
     * Class for the individual Action
     * @param keyName{string}
     * @param actionToExecute {function}
     * @param params {array}
     * @constructor
     */
    function Action(keyName, actionToExecute, params) {

      this.keyName = keyName;
      this.actionToExecute = actionToExecute;
      this.params = params;

    }

    this.Action = Action;

  });
/**
 * Created by ltischuk on 1/9/15.
 */
angular.module('profile-manager',
	['app', 'profile-login', 'waitlist'])
	.config(function($locationProvider, $stateProvider) {
		$stateProvider
			.state('profile-manager', {
				url: '/profile-manager',
				abstract: true,
				template: '<div ui-view></div>',
				resolve: {
					load: function($rootScope, Utilities) {
						$rootScope.showSpinner();
						return Utilities.cacheBustAndLazyLoad([
							'scripts/modules/waitlist/services/waitlist-service.js',
							'scripts/modules/profile/modules/profile-manager/services/profile-manager-service.js',
							'scripts/modules/profile/modules/profile-manager/controllers/profile-manager-profile-controller.js',
							'scripts/modules/profile/modules/profile-manager/controllers/profile-manager-custom-inputs-controller.js',
							'scripts/modules/profile/modules/profile-manager/controllers/profile-manager-forms-controller.js',
							'scripts/modules/profile/modules/profile-manager/controllers/profile-manager-events-controller.js',
							'scripts/modules/profile/modules/profile-manager/controllers/profile-manager-summary-controller.js',
							'scripts/modules/profile/modules/profile-manager/controllers/profile-manager-sidebar-controller.js',
							'scripts/modules/profile/modules/profile-manager/controllers/profile-manager-change-password-controller.js',
							'scripts/modules/profile/modules/profile-manager/controllers/profile-manager-change-password-token-controller.js',
							'scripts/modules/profile/services/profile-guest-additional-info-service.js'

						], true);
					},
					initialData: function(load, Bootstrap) {
						return Bootstrap.bootstrapApplication();
					}
				}

			})
			.state('profile-manager.profile', {
				url: '/profile',
				controller: 'ProfileManagerProfileController',
				templateUrl: '/scripts/modules/profile/modules/profile-manager/views/profile.html',
				abstract: true,
				resolve: {
					assessRoute: function(initialData, ProfileLoginSessionService, RouteRejectionService, $rootScope) {
						// if we are already logged in, go back to selection
						if (!ProfileLoginSessionService.isLoggedIn() || !ProfileLoginSessionService.isProfileRetrieved()) {
							throw new RouteRejectionService.UnrecoverableException('profile-login.signin', { showSignInOnly: $rootScope.disableCreateAccountOnGlobalLogin });
						} else {
							return true;
						}
					},
					setup: function(initialData, CustomActionService, ProfileLoginSessionService) {
						if (CustomActionService.actionRegistered(CustomActionService.ACTIONS_ENUMS.INVALIDATE_CP_PROFILE_CACHE)) {
							ProfileLoginSessionService.refetchLoggedInSession();
							CustomActionService.deregisterCustomAction(CustomActionService.ACTIONS_ENUMS.INVALIDATE_CP_PROFILE_CACHE);
						}
						if (CustomActionService.actionRegistered(CustomActionService.ACTIONS_ENUMS.SETUP_PROFILE_LOGIN)) {
							return CustomActionService.executeCustomAction(CustomActionService.ACTIONS_ENUMS.SETUP_PROFILE_LOGIN);
						}
						return;
					},
					persistSession: function(assessRoute, setup, ProfileLoginSessionService) {
						return ProfileLoginSessionService.persistSession();
					},
					preloadServices: function(persistSession, FormConfiguration) {
						// Do nothing
					}
				}
			})
			.state('profile-manager.profile.view', {
				url: '',
				views: {
					profileSidebarWithLinkedGuests: {
						controller: 'ProfileManagerSidebarController',
						templateUrl: '/scripts/modules/profile/modules/profile-manager/views/sidebar-with-linked-guests.html'
					},
					profileSidebarWithoutLinkedGuests: {
						controller: 'ProfileManagerSidebarController',
						templateUrl: '/scripts/modules/profile/modules/profile-manager/views/sidebar-without-linked-guests.html'
					},
					profileSummary: {
						controller: 'ProfileManagerSummaryController',
						templateUrl: '/scripts/modules/profile/modules/profile-manager/views/profile-summary.html',
						resolve: {
							loadSMS: function(Utilities, SMS_VERIFICATION_ASSETS) {
								return Utilities.cacheBustAndLazyLoad(SMS_VERIFICATION_ASSETS)
							}
						}
					},
					profileMembership: { // no controller needed!
						templateUrl: '/scripts/modules/profile/modules/profile-manager/views/profile-membership.html'
					},
					profileSeasonpass: { // no controller needed!
						templateUrl: '/scripts/modules/profile/modules/profile-manager/views/profile-season-pass.html'
					},
					profileDependents: { // no controller needed!
						templateUrl: '/scripts/modules/profile/modules/profile-manager/views/profile-dependents.html'
					},
					profileCustomInputs: {
						controller: 'ProfileManagerCustomInputsController',
						templateUrl: '/scripts/modules/profile/modules/profile-manager/views/profile-custom-inputs.html'
					},
					profileCustomInputs2: { // not currently being used. Some development needed to turn this on.
						controller: 'ProfileManagerCustomInputsController',
						templateUrl: '/scripts/modules/profile/modules/profile-manager/views/profile-custom-inputs.html'
					},
					profileForms: {
						controller: 'ProfileManagerFormsController',
						templateUrl: '/scripts/modules/profile/modules/profile-manager/views/profile-forms.html'
					},
					profileWtp: { // no controller needed!
						templateUrl: '/scripts/modules/profile/modules/profile-manager/views/profile-wtp.html'
					},
					profileEvents: {
						controller: 'ProfileManagerEventsController',
						controllerAs: 'vm',
						templateUrl: '/scripts/modules/profile/modules/profile-manager/views/profile-events.html'
					}

				},
				resolve: {
					eventInfo: function(persistSession, ProfileManagerService) {
						return ProfileManagerService.getPendingAndWaitListedEvents();
					}
				}
			})
			.state('profile-manager.change-password', {
				url: '/changePassword',
				controller: 'ProfileManagerChangePasswordController',
				templateUrl: '/scripts/modules/profile/modules/profile-manager/views/change-password.html',
				resolve: {
					assessRoute: function(initialData, ProfileLoginSessionService, RouteRejectionService, $rootScope) {
						// if we are already logged in, go back to selection
						if (!ProfileLoginSessionService.isLoggedIn()) {
							throw new RouteRejectionService.UnrecoverableException('profile-login.signin', { showSignInOnly: $rootScope.disableCreateAccountOnGlobalLogin });
						} else {
							return true;
						}
					}
				}
			})
			.state('profile-manager.change-password-from-email', {
				url: '/changePasswordFromEmail/:email/:tempPassword',
				controller: 'ProfileManagerChangePasswordController',
				templateUrl: '/scripts/modules/profile/modules/profile-manager/views/change-password.html',
				resolve: {

					assessRoute: function(initialData, RouteRejectionService, $transition$, $rootScope) {
						var stateParams = $transition$.params();
						// if we are already logged in, go back to selection
						if (!(angular.isDefined(stateParams.email) && angular.isDefined(stateParams.tempPassword))) {
							throw new RouteRejectionService.UnrecoverableException('profile-login.signin', { showSignInOnly: $rootScope.disableCreateAccountOnGlobalLogin });
						} else {
							return true;
						}
					}

				}

			})
			.state('profile-manager.change-password-from-email_token', {
				url: '/changePasswordFromEmailToken/:token',
				controller: 'ProfileManagerChangePasswordTokenController',
				templateUrl: '/scripts/modules/profile/modules/profile-manager/views/change-password-token.html',
				resolve: {

					secureTokenSwapInfo: function(initialData, ProfileRequestService, $transition$) {
						return ProfileRequestService.getPasswordTokenSwapInfo($transition$.params().token);
					}

				}

			})
	})
	// eslint-disable-next-line strict
	.run(function() {


	});



(function() {
	'use strict';

	angular
		.module('profile-manager-new', ['app', 'profile-login', 'waitlist'])
		.constant('ProfileManagerRoutes', {
			ADDRESS: 'profile-manager-new.address',
			BASIC_INFO: 'profile-manager-new.basic-info',
			CHANGE_PASSWORD: 'profile-manager-new.change-password',
			CHANGE_PASSWORD_FROM_EMAIL: 'profile-manager-new.change-password-from-email',
			CHANGE_PASSWORD_FROM_EMAIL_TOKEN: 'profile-manager-new.change-password-from-email_token',
			EVENTS: 'profile-manager-new.events',
			LINKED_GUEST: 'profile-manager-new.linked-guest',
			MEMBERSHIPS_AND_PASSES: 'profile-manager-new.passes',
			OVERVIEW: 'profile-manager-new.profile'
		})
		.config(function($stateProvider, ProfileManagerRoutes) {
			$stateProvider
				.state('profile-manager-new', {
					abstract: true,
					resolve: {
						lazyLoadAssets: lazyLoadAssets,
						initialData: initialData,
						assessRouteProfile: assessRouteProfile,
						assessRouteChangePassword: assessRouteChangePassword,
						secureTokenSwapInfo: secureTokenSwapInfo,
						loadSms: loadSms,
						setupProfile: setupProfile,
						persistSession: persistSession
					}
				})
				.state(ProfileManagerRoutes.OVERVIEW, {
					controller: 'ProfileOverviewController',
					/** currently this uses profile-overview.html but
					 * for both main profile and linked guest profile
					 * this is because the html is nearly the same for both
					 */
					controllerAs: 'vm',
					params: {
						linkedGuestID: {
							squash: true,
							type: 'string',
							value: null,
						},
						profileUpdated: false,
					},
					resolve: { eventInfo: eventInfo },
					templateUrl: 'profile-manager:main-and-guest-overview',
					title: 'ProfileManagerOverview',
					url: '/profile-manager-new/profile'
				})
				.state(ProfileManagerRoutes.BASIC_INFO, {
					controller: 'BasicInfoController',
					params: {
						linkedGuestID: {
							squash: true,
							type: 'string',
							value: null,
						}
					},
					templateUrl: 'profile-manager:basic-info',
					title: 'ProfileManagerMyInformation',
					url: '/profile-manager-new/basic-info/:linkedGuestID'
				})
				.state(ProfileManagerRoutes.ADDRESS, {
					controller: 'AddressController',
					params: {
						linkedGuestID: {
							squash: true,
							type: 'string',
							value: null,
						}
					},
					templateUrl: 'profile-manager:address',
					title: 'ProfileManagerMyAddress',
					url: '/profile-manager-new/address/:linkedGuestID'
				})
				.state(ProfileManagerRoutes.CHANGE_PASSWORD, {
					url: '/profile-manager-new/change-password',
					controller: 'ChangePasswordController',
					templateUrl: 'profile-manager:change-password',
					title: 'ProfileManagerChangePassword'
				})
				.state(ProfileManagerRoutes.CHANGE_PASSWORD_FROM_EMAIL, {
					// TODO: accesso-cdn.js and accesso.js references to changePassword will need to be updated
					url: '/profile-manager-new/changePasswordFromEmail/:email/:tempPassword',
					controller: 'ChangePasswordController',
					templateUrl: 'profile-manager:change-password',
					title: 'ProfileManagerChangePassword',
					resolve: { assessRouteChangePasswordFromEmail: assessRouteChangePasswordFromEmail }
				})
				/**  change-password routing will be completed in a different ticket */
				.state(ProfileManagerRoutes.CHANGE_PASSWORD_FROM_EMAIL_TOKEN, {
					url: '/profile-manager-new/changePasswordFromEmailToken/:token',
					controller: 'ChangePasswordController',
					templateUrl: 'profile-manager:change-password',
					title: 'ProfileManagerChangePassword',
				})
				.state(ProfileManagerRoutes.EVENTS, {
					controller: 'EventsController',
					controllerAs: 'vm',
					params: {
						linkedGuestID: {
							squash: true,
							type: 'string',
							value: null
						}
					},
					resolve: { eventInfo: eventInfo },
					templateUrl: 'profile-manager:events',
					title: 'ProfileManagerEvents',
					url: '/profile-manager-new/events'
				})
				.state(ProfileManagerRoutes.MEMBERSHIPS_AND_PASSES, {
					controller: 'MembershipAndPassesController',
					params: {
						linkedGuestID: {
							squash: true,
							type: 'string',
							value: null
						},
					},
					templateUrl: 'profile-manager:passes',
					title: 'ProfileManagerMembershipsAndPasses',
					url: '/profile-manager-new/passes'
				})
				.state(ProfileManagerRoutes.LINKED_GUEST, {
					controller: 'ProfileOverviewController',
					params: {
						linkedGuestID: {
							squash: true,
							type: 'string',
							value: null,
						},
						profileUpdated: false,
					},
					resolve: { eventInfo: eventInfo },
					templateUrl: 'profile-manager:main-and-guest-overview',
					title: 'ProfileManagerLinkedGuests',
					url: '/profile-manager-new/linked-guest/:linkedGuestID'
				})
				.state(ProfileManagerRoutes.LINKED_GUEST + '.basic-info', {
					controller: 'BasicInfoController',
					templateUrl: 'profile-manager:basic-info',
					title: 'ProfileManagerLinkedGuests',
					url: '/basic-info'
				})
				.state(ProfileManagerRoutes.LINKED_GUEST + '.address', {
					controller: 'AddressController',
					templateUrl: 'profile-manager:address',
					title: 'ProfileManagerLinkedGuests',
					url: '/address'
				})
				.state(ProfileManagerRoutes.LINKED_GUEST + '.events', {
					controller: 'EventsController',
					templateUrl: 'profile-manager:events',
					title: 'ProfileManagerLinkedGuests',
					url: '/events'
				})
				.state(ProfileManagerRoutes.LINKED_GUEST + '.passes', {
					templateUrl: 'profile-manager:passes',
					title: 'ProfileManagerLinkedGuests',
					url: '/passes'
				});

			/**
			 * The initialData resolve
			 * @resolve
			 * @function
			 * @param {Service} Bootstrap - The Bootstrap Service
			 * @param {Scope} $rootScope - The root scope
			 * @returns {Promise} - The bootstrap application promise
			 * @ngInject
			 */
			function initialData(Bootstrap, $rootScope) {
				$rootScope.showSpinner();

				return Bootstrap.bootstrapApplication();
			}

			/**
			 * Lazy Loads Profile Manager files in
			 * @param {Resolve} initialData - The Package Resolve
			 * @param {Service} BundleService - The Bundle Service
			 * @returns {Promise} - The Lazy Load Promise
			 * @ngInject
			 */
			function lazyLoadAssets(initialData, BundleService) {
				return BundleService.lazyLoadCollectionFiles(BundleService.enums.PROFILE_MANAGER_NEW);
			}

			/**
			 * Assesses the route profile based on the login status and profile retrieval status.
			 *
			 * If the user is not logged in or the profile is not retrieved, the function aborts the current transition,
			 * navigates to the 'profile-login.signin' route, and returns a rejected promise.
			 * If the user is logged in and the profile is retrieved, the function returns true.
			 *
			 * @param {Object} initialData - The initial data for assessing the route profile.
			 * @param {Object} ProfileLoginSessionService - The service to check login and profile retrieval status.
			 * @param {Object} $rootScope - The root scope to access global variables.
			 * @param {Object} $q - The $q service to create a promise.
			 * @param {Object} $transition$ - The ui-router transition instance
			 * @param {Object} Utilities - The utilities service for navigation.
			 * @returns {Promise|Boolean} - Returns a rejected promise if not logged in or profile not retrieved, otherwise returns true.
			 */
			function assessRouteProfile(
				initialData,
				ProfileLoginSessionService,
				$rootScope,
				$q,
				$transition$,
				Utilities
			) {
				// if we are already logged in, go back to selection
				if (!ProfileLoginSessionService.isLoggedIn() || !ProfileLoginSessionService.isProfileRetrieved()) {
					$transition$.abort();
					Utilities.goTo('profile-login.signin.view', { showSignInOnly: $rootScope.disableCreateAccountOnGlobalLogin });
					return $q.reject('Not Authenticated');
				} else {
					return true;
				}
			}

			/**
			 * Sets up the profile based on the registered actions in the CustomActionService.
			 *
			 * If the 'INVALIDATE_CP_PROFILE_CACHE' action is registered, it refetches the logged-in session and deregisters the action.
			 * If the 'SETUP_PROFILE_LOGIN' action is registered, it executes the action.
			 *
			 * @param {Resolve} initialData - The initial data for setting up the profile.
			 * @param {Object} CustomActionService - The service to register, deregister, and execute custom actions.
			 * @param {Object} ProfileLoginSessionService - The service to manage the profile login session.
			 * @returns {*} - Returns the result of the 'SETUP_PROFILE_LOGIN' action if it's registered, otherwise returns undefined.
			 */
			function setupProfile(initialData, CustomActionService, ProfileLoginSessionService) {
				if (CustomActionService.actionRegistered(CustomActionService.ACTIONS_ENUMS.INVALIDATE_CP_PROFILE_CACHE)) {
					ProfileLoginSessionService.refetchLoggedInSession();
					CustomActionService.deregisterCustomAction(CustomActionService.ACTIONS_ENUMS.INVALIDATE_CP_PROFILE_CACHE);
				}
				if (CustomActionService.actionRegistered(CustomActionService.ACTIONS_ENUMS.SETUP_PROFILE_LOGIN)) {
					return CustomActionService.executeCustomAction(CustomActionService.ACTIONS_ENUMS.SETUP_PROFILE_LOGIN);
				}
				return;
			}

			/**
			 * Persists the session using the ProfileLoginSessionService.
			 *
			 * @param {Function} assessRouteProfile - The function to assess the route profile.
			 * @param {Function} setupProfile - The function to setup the profile.
			 * @param {Object} ProfileLoginSessionService - The service to manage the profile login session.
			 * @returns {Undefined} - Return undefined. The function persists the session to local storage.
			 */
			function persistSession(assessRouteProfile, ProfileLoginSessionService) {
				return ProfileLoginSessionService.persistSession();
			}

			/**
			 * Retrieves the pending and waitlisted events using the ProfileManagerNewService.
			 *
			 * @param {Function} persistSession - The function to persist the session to local storage.
			 * @param {Object} ProfileManagerNewService - The service to manage the profile.
			 * @param {Object} $q - The $q service to create a promise.
			 * @returns {Promise} - Returns a promise that resolves to the pending and waitlisted events.
			 */
			function eventInfo(persistSession, ProfileManagerNewService, $q) {
				return ProfileManagerNewService.getPendingAndWaitListedEvents().catch(
					function resolveEventCall() {
						// Return a resolved promise to allow the route to load
						return $q.resolve();
					}
				);
			}

			/**
			 * Assesses the route for the 'change-password' action based on the login status.
			 *
			 * If the user is not logged in, the function aborts the current transition, navigates to the 'profile-login.signin' route,
			 * and returns a rejected promise. If the user is logged in, the function returns true.
			 *
			 * @param {Resolve} lazyLoadAssets - The function to lazy load assets.
			 * @param {Service} ProfileLoginSessionService - The service to check login status.
			 * @param {Service} $q - The $q service to create a promise.
			 * @param {Scope} $rootScope - The root scope to access global variables.
			 * @param {Object} $transition$ - The ui-router transition instance
			 * @param {Service} Utilities - The utilities service
			 * @returns {Promise|Boolean} - Returns a rejected promise if not logged in, otherwise returns true.
			 */
			function assessRouteChangePassword(
				lazyLoadAssets,
				ProfileLoginSessionService,
				$q,
				$rootScope,
				$transition$,
				Utilities
			) {
				// if we are already logged in, go back to selection
				if (!ProfileLoginSessionService.isLoggedIn()) {
					$transition$.abort();
					Utilities.goTo('profile-login.signin', { showSignInOnly: $rootScope.disableCreateAccountOnGlobalLogin });
					return $q.reject();
				} else {
					return true;
				}
			}

			/**
			 * Assesses the route for the 'change-password-from-email' action based on the presence of 'email' and 'tempPassword' in the state parameters.
			 *
			 * If 'email' and 'tempPassword' are not defined in the state parameters, the function aborts the current transition, navigates to the 'profile-login.signin' route,
			 * and returns a rejected promise. If 'email' and 'tempPassword' are defined, the function returns true.
			 *
			 * @param {Resolve} initialData - The initial data for assessing the route.
			 * @param {Service} $q - The $q service to create a promise.
			 * @param {Scope} $rootScope - The root scope to access global variables.
			 * @param {Object} $transition$ - The ui-router transition instance
			 * @param {Service} Utilities - The utilities service for navigation.
			 * @returns {Promise|Boolean} - Returns a rejected promise if 'email' and 'tempPassword' are not defined, otherwise returns true.
			 */
			function assessRouteChangePasswordFromEmail(
				initialData,
				$q,
				$rootScope,
				$transition$,
				Utilities
			) {
				var stateParams = $transition$.params();
				// if we are already logged in, go back to selection
				if (!(angular.isDefined(stateParams.email) && angular.isDefined(stateParams.tempPassword))) {
					$transition$.abort();
					Utilities.goTo('profile-login.signin', { showSignInOnly: $rootScope.disableCreateAccountOnGlobalLogin });
					return $q.reject();
				} else {
					return true;
				}
			}

			/**
			 * Retrieves the password token swap information using the ProfileRequestService.
			 *
			 * The token is retrieved from the parameters of the current transition.
			 *
			 * @param {Resolve} initialData - The initial data for securing the token swap info.
			 * @param {Service} ProfileRequestService - The service to request the password token swap info.
			 * @param {Object} $transition$ - The ui-router transition instance
			 * @returns {Promise} - Returns a promise that resolves to the password token swap info.
			 */
			function secureTokenSwapInfo(
				initialData,
				ProfileRequestService,
				$transition$
			) {
				if ($transition$.params().token) {
					return ProfileRequestService.getPasswordTokenSwapInfo(token);
				}
				
				// Return a default null if we don't have a token
				return null;
			}

			/**
			 * Loads the SMS verification assets using the Utilities service.
			 *
			 * The assets are loaded with cache busting and lazy loading.
			 *
			 * @param {Object} initialData - The initial data for loading the SMS verification assets.
			 * @param {Object} Utilities - The utilities service for loading assets.
			 * @param {Object} SMS_VERIFICATION_ASSETS - The SMS verification assets to load.
			 * @returns {Promise} - Returns a promise that resolves when the assets are loaded.
			 */
			function loadSms(initialData, Utilities, SMS_VERIFICATION_ASSETS) {
				return Utilities.cacheBustAndLazyLoad(SMS_VERIFICATION_ASSETS);
			}
		});
})();

/**
 * Created by pMatthews on 11/1/16.
 */
angular.module('profile').service('ProfileManagerModels',
	function ($state) {

		profileManagerTab = function( name,view,label,editable, functionToSeeIfTabShouldBeVisible, list) {
			this.name = name;
			this.view = view;
			this.label = label;
			this.list = list;
			this.visible = true;
			this.active = false;
			this.editable = editable;
			this.tabVisibleForGuest = functionToSeeIfTabShouldBeVisible;
			this.setActive = function() {
				if (angular.isDefined(this.list)) {
					this.list.forEach(function (t) {
						t.active = false;
					});
				}
				this.active = true;
			};
		};

		profileManagerTabList = function() {
			this.tabs = [];
		};

		profileManagerTabList.prototype = {
			addTab: function(name, view, label, editable, functionToSeeIfTabShouldBeVisible) {
				this.tabs.push(new profileManagerTab( name, view, label, editable, functionToSeeIfTabShouldBeVisible, this.tabs));
			},
			clear: function(){
				this.tabs=[];
			},
			get activeTab(){
				for(var i=0; i<this.tabs.length;i++) {
					if (this.tabs[i].active) {
						return this.tabs[i];
					}
				}
				this.tabs[0].setActive();
				return this.tabs[0];
			}
		};


		return {
			tab: profileManagerTab,
			tabList: profileManagerTabList
		};
	}
);
/**
 * Created by ltischuk on 10/7/15.
 */
angular
	.module('profile-manager')
	.factory('ProfileManagerEnumsService', function() {
		var factory = {
			localeSection: 'ProfileManager',
			sidebarViewWithLinkedGuests: '/scripts/modules/profile/modules/profile-manager/views/sidebar-with-linked-guests.html',
			sidebarViewWithoutLinkedGuests: '/scripts/modules/profile/modules/profile-manager/views/sidebar-without-linked-guests.html',
			locales: {
				maxAttemptsReached: 'failurePasswordChangeMaxAttempts',
				passwordChangeSuccessful: 'successPasswordChange'
			},
			errorCodes: {
				'29': 'failurePasswordChange',
				'30': 'failurePasswordPreviouslyUsed'
			},
			GENERIC_ERROR: '29'
		};

		return factory;
	});
!function(){"use strict";angular.module("passport-auth",[]).run(["$log","$window","$location",function(e,t,n){var o,r,i=n.search();!t.opener&&i.code&&i.state&&!i._m&&t.oidc&&(o=t.sessionStorage.getItem("passport_auth_signin_params"))&&(t.sessionStorage.removeItem("passport_auth_signin_params"),t.history.replaceState(null,"","/?_m="+encodeURIComponent(o)+"&"+t.location.search.slice(1))),t.opener&&t.oidc&&(r=new t.oidc.UserManager({authority:t.location.origin,client_id:"popup",redirect_uri:t.location.origin}),i.code&&i.state?r.signinPopupCallback().catch(function(t){e.error("[AuthService] signinPopupCallback error:",t)}):"/logout"===n.path()&&r.signoutPopupCallback().catch(function(t){e.error("[AuthService] signoutPopupCallback error:",t)}))}]).config(["$stateProvider",function(e){e.state("/logout",{template:"",url:"/logout",resolve:{logoutCallback:["AuthEnums","AuthService","$location","$window",function(e,t,n,o){return t.handleLogoutCallback().then(function(){var t="localhost"===o.location.hostname?o.sessionStorage.getItem(e.storage.LOGOUT_PARAMS_KEY):null;o.sessionStorage.removeItem(e.storage.LOGOUT_PARAMS_KEY),n.url(t?"/?_m="+encodeURIComponent(t):"/")})}]}})}])}(),function(){"use strict";angular.module("passport-auth").constant("AuthEnums",{config:{NAME:"passport_auth"},log:{PREFIX:"[passport-auth] "},storage:{KEY:"passport_auth",ACCESSO_ID_KEY:"passport_auth_accesso_id",STATE_KEY:"passport_auth_state",LOGOUT_PARAMS_KEY:"passport_auth_logout_params",SIGNIN_PARAMS_KEY:"passport_auth_signin_params",FORCE_LOGIN_PROMPT_KEY:"passport_auth_force_login_prompt"},type:{ANON:"A",ACCESSO_ID:"AI"},url:{ANON:"https://api.{{STACK}}.{{DOMAIN}}/internal/anonymousToken",ACCESSO_ID_BASE:"https://api.{{STACK}}.{{DOMAIN}}/authorization-service",LOGIN:"https://auth.{{STACK}}.{{DOMAIN}}/{{LANGUAGE}}/login"},oidc:{AUTHORIZE:"oauth2/authorize",TOKEN:"oauth2/token",USERINFO:"oauth2/userinfo",LOGOUT:"connect/logout",JWKS:".well-known/jwks.json"},oauth:{RESPONSE_TYPE:"code",SCOPES:["openid"],SCOPE_MINIMAL:"openid",FLOW_REGISTRATION:"registration",GRANT_TYPE:{AUTHORIZATION_CODE:"authorization_code",REFRESH_TOKEN:"refresh_token"},PARAMS:{ACC_FLOW:"acc_flow",REDIRECT_URI:"redirect_uri",CLIENT_ID:"client_id",RESPONSE_TYPE:"response_type",SCOPE:"scope",STATE:"state"}},validity:{REREQUST_LEAD:6e4,RETRY_AMOUNT:2},events:{USER_AUTHENTICATED:"passport-auth:userAuthenticated",USER_UNAUTHENTICATED:"passport-auth:userUnauthenticated"}})}(),function(){"use strict";function e(e,t,n,o,r,i,a,s,l,c,u,d,_,g,p,f,I){var h=I.validArray,E={bootstrap:function(){return E._.oidcStartupPromise||!0},getTokenRequestHeaders:function(){var e={};if(E._.currentAuthType===c.type.ACCESSO_ID&&E._.accessoId.values.access_token)return e.Authorization="Bearer "+E._.accessoId.values.access_token,e;E._.anon.values.token&&(e.Authorization=E._.anon.values.tokenType+" "+E._.anon.values.token);return e},get config(){return E._.config},initiateAccessoIdLogin:function(e){if(!E._.oidcUserManager)return o.error(c.log.PREFIX+"OIDC UserManager not initialized"),r.reject("OIDC UserManager not initialized");if(o.info(c.log.PREFIX+"Using OIDC for login, embedded:",f.isInIFrame()),f.isInIFrame())return E._.oidcSigninPopup(e);return E._.oidcSigninRedirect(e)},handleLogoutCallback:function(){if(!E._.oidcUserManager)return r.resolve();return E._.oidcUserManager.signoutCallback().then(function(){o.info(c.log.PREFIX+"OIDC post-logout callback processed")}).catch(function(e){o.debug(c.log.PREFIX+"signoutCallback error (state may be stale or unrelated):",e)})},linkAnonymousUser:function(e){var t={linkAnonymousUser:!0,directToRegistration:!!e};return E.initiateAccessoIdLogin(t)},logout:function(){if(!E._.oidcUserManager)return o.error(c.log.PREFIX+"OIDC UserManager not initialized"),r.reject("OIDC UserManager not initialized");if(o.info(c.log.PREFIX+"Logout initiated, embedded:",f.isInIFrame()),f.isInIFrame())return E._.oidcSignout();return E._.oidcSignoutRedirect()},terminateSessionSilently:function(){var e=E._.accessoId.values.id_token,t=E._.accessoId.url.logout;if(!E._.oidcUserManager)return r.resolve();if(e&&t)try{s.fetch(t+"?id_token_hint="+encodeURIComponent(e)+"&post_logout_redirect_uri="+encodeURIComponent(s.location.origin),{method:"GET",keepalive:!0,credentials:"include"})}catch(e){o.warn(c.log.PREFIX+"keepalive logout fetch failed: "+e)}return s.sessionStorage.setItem(c.storage.FORCE_LOGIN_PROMPT_KEY,"1"),E._.oidcSignoutLocal().catch(function(){})},isAuthenticated:function(){if(!E._.oidcUserManager)return!1;if(E._.currentAuthType!==c.type.ACCESSO_ID)return!1;try{return!!E._.accessoId.values.access_token&&!(E._.accessoId.values.expiration&&E._.accessoId.values.expiration<new Date)}catch(e){return!1}},isAccessoIdConfigured:function(){return!!E._.enabled},getUserInfo:function(){if(!E._.oidcUserManager)return null;return E._.accessoId.values&&E._.accessoId.values.user_info?E._.accessoId.values.user_info:null},getLoginUrl:function(){return E._.accessoId.url.login},hydrateState:function(){var e=n.search();if(E._.didHydrate||!e.state||!E._.validateState(e.state))return E._.didHydrate=!0,!0;return E._.restoreSavedLocation(e.state,e.code),E._.didHydrate=!0,!1},redirectToLogin:function(e){var t,n,a,l;try{return t={},i.showSpinner(),e?(o.info(c.log.PREFIX+"Custom redirect URI provided, using fallback method:",e),(n=E.getLoginUrl())?(a=-1!==n.indexOf("?")?"&":"?",l=n+a+"redirect_uri="+encodeURIComponent(e),o.info(c.log.PREFIX+"Redirecting to login with custom redirect_uri:",e),s.location.href=l,r.resolve()):(o.error(c.log.PREFIX+"Login URL not configured"),r.reject("Login URL not configured"))):(o.info(c.log.PREFIX+"Redirecting to login using initiateAccessoIdLogin"),E.initiateAccessoIdLogin(t))}catch(e){return o.error(c.log.PREFIX+"Error redirecting to login:",e),r.reject(e)}},restoreSavedLocation:function(e,t){E._.restoreSavedLocation(e,t)},getOidcUser:function(){return E._.getOidcUser()},getIdToken:function(){return E._.accessoId.values&&E._.accessoId.values.id_token||null},getAnonymousToken:function(){return E._.anon.values&&E._.anon.values.token||null},getLastPurchaseToken:function(){return E._.anon.lastPurchaseToken||null},_:{anon:{url:null,values:{auid:null,expiration:null,refresh:null,token:null,tokenType:null,type:c.type.ANON}},accessoId:{code:null,url:{authorization:null,token:null,userinfo:null,logout:null,jwks:null,login:null},values:{access_token:null,id_token:null,refresh_token:null,token_type:null,expires_in:null,scope:null,user_info:null,uuid:null,expiration:null,type:c.type.ACCESSO_ID}},anonClientId:null,accessoIdClientId:null,clientId:null,config:{},didBootstrap:!1,didHydrate:!1,enabled:!1,oidcStartupPromise:null,timeout:null,type:c.type.ANON,state:null,currentAuthType:c.type.ANON,checkToken:function(){var e=g.get(c.storage.KEY),t=!1;if(e){if(e.expiration=new Date(e.expiration),e.type&&(E._.type=e.type),E._.setValues(e,!0),e.expiration.getTime()-c.validity.REREQUST_LEAD>Date.now())return void E._.createExpirationTimeout();t=!0}E._.fetchToken(t)},createExpirationTimeout:function(){if(E._.currentAuthType===c.type.ACCESSO_ID)return;var e=E._.getValues().expiration.getTime()-Date.now()-c.validity.REREQUST_LEAD;E._.timeout&&a.cancel(E._.timeout);E._.timeout=a(function(){E._.fetchToken(!0)},e)},fetchToken:function(t,n){var i=r.defer();if(E._.currentAuthType===c.type.ACCESSO_ID)return i.resolve(),i.promise;function a(){n<c.validity.RETRY_AMOUNT&&E._.fetchToken(n<c.validity.RETRY_AMOUNT-1&&t,++n)}return n=n||0,e.get(E._.getFetchUrl()+E._.getFetchUrlParams(t),{headers:{client_id:E._.getClientId()}}).then(function(e){if(200!==e.status)return o.error(c.log.PREFIX+"Error fetching token:",e.statusText),a();E._.setValues(e.data),g.set(c.storage.KEY,E._.getValues()),E._.createExpirationTimeout()}).catch(function(e){return o.error(c.log.PREFIX+"Error fetching token:",e),a()}),i.promise},getClientId:function(){if(E._.type===c.type.ANON)return E._.anonClientId;return E._.clientId},getFetchUrl:function(){if(E._.type===c.type.ANON)return E._.anon.url;return o.error(c.log.PREFIX+"Invalid type for fetch URL"),null},getFetchUrlParams:function(e){var t=[];E._.type===c.type.ANON&&(t.push("scope="+c.oauth.SCOPE_MINIMAL),e&&(t.push("grant_type=refresh_token"),t.push("refresh_token="+E._.anon.values.refresh)));return(h(t)?"?":"")+t.join("&")},getValues:function(){return E._.anon.values},initialize:function(){E._.setConfig(),E._.setClientId(),E._.setEnabled(),E._.setAnonUrl(E._.getAuthStack(l.stack),l.baseDomain),E._.setAccessoIdUrls(E._.getAuthStack(l.stack),l.baseDomain),E._.enabled&&E._.checkToken();!E._.enabled||_.isResellerMode()||_.isResellerPOSMode()||(E._.oidcStartupPromise=E._.initializeOidc(),i.configuredForPassportAuth=!0)},getAuthStack:function(e){var t=e.split("-"),n=t[t.length-1].replace(/\d+$/,"");if(1===t.length)return n;return t[0]+"-"+n},setAnonUrl:function(e,t){E._.anon.url=c.url.ANON.replace(/\{\{STACK\}\}/g,e).replace(/\{\{DOMAIN\}\}/g,t)},setAccessoIdUrls:function(e,t){var n=c.url.ACCESSO_ID_BASE.replace(/\{\{STACK\}\}/g,e).replace(/\{\{DOMAIN\}\}/g,t);E._.accessoId.url.authorization=n+"/"+c.oidc.AUTHORIZE,E._.accessoId.url.token=n+"/"+c.oidc.TOKEN,E._.accessoId.url.userinfo=n+"/"+c.oidc.USERINFO,E._.accessoId.url.logout=n+"/"+c.oidc.LOGOUT,E._.accessoId.url.jwks=n+"/"+c.oidc.JWKS,E._.accessoId.url.login=c.url.LOGIN.replace(/\{\{STACK\}\}/g,e).replace(/\{\{DOMAIN\}\}/g,t).replace(/\{\{LANGUAGE\}\}/g,l.language||"en")},setClientId:function(){E._.anonClientId=l.anonClientId,E._.accessoIdClientId=l.clientId,E._.clientId=l.clientId},setConfig:function(){try{d.validate(c.config.NAME,l.settings.passport_auth)&&(E._.config=JSON.parse(l.settings.passport_auth))}catch(e){o.warn(c.log.PREFIX+"Error parsing passport auth config:",e)}},setEnabled:function(){E._.enabled=E._.anonClientId&&!E._.config.disable},setValues:function(e,t){var n="anon";if(t)return void(E._[n].values=angular.copy(e));E._[n].values={auid:e.auid,token:e.access_token,expiration:new Date(1e3*e.exp),refresh:e.refresh_token,tokenType:e.token_type,type:E._.type}},validateState:function(e){var t=E._.state||E._.decodeState(e);if(!t||t.id!==e)return o.error(c.log.PREFIX+"Missing state parameter"),!1;return E._.state=null,!0},generateSecureState:function(){var e,t,o=new Uint8Array(16);if(s.crypto&&s.crypto.getRandomValues)s.crypto.getRandomValues(o);else for(var r=0;r<o.length;r++)o[r]=Math.floor(256*Math.random());return e=Array.from(o,function(e){return("0"+(255&e).toString(16)).slice(-2)}).join(""),t={s:e,u:n.url()},E._.state=t,g.set(c.storage.STATE_KEY+t.s,t,null,!1),E._.state},decodeState:function(e){try{return JSON.parse(s.localStorage.getItem("oidc."+e))}catch(e){return o.warn(c.log.PREFIX+"Error decoding state:",e),{data:{}}}},restoreSavedLocation:function(e,t){var r=null;try{r=E._.decodeState(e).data.returnUrl}catch(e){o.warn(c.log.PREFIX+"Error decoding state:",e)}if(!r)return void o.info(c.log.PREFIX+"No saved location to restore");try{r!==n.url()&&(n.url(r),n.search("code",t),n.search("state",e))}catch(e){o.warn(c.log.PREFIX+"Error restoring saved location:",e)}},setAccessoIdValues:function(e){E._.accessoId.values={access_token:e.access_token,id_token:e.id_token,refresh_token:e.refresh_token,token_type:e.token_type||"Bearer",expires_in:e.expires_in,scope:e.scope,uuid:e.uuid||null,expiration:new Date(Date.now()+1e3*e.expires_in),type:c.type.ACCESSO_ID,user_info:null},e.id_token&&(E._.accessoId.values.user_info=E._.parseIdToken(e.id_token))},getAccessoIdValues:function(){return E._.accessoId.values},getAccessoIdClientId:function(){return E._.accessoIdClientId},parseIdToken:function(e){var t,n,r,i,a;try{if(3!==(t=e.split(".")).length)return o.error(c.log.PREFIX+"Invalid ID token format"),null;for(a in n=t[1],n=(n+="==".slice(0,(4-n.length%4)%4)).replace(/-/g,"+").replace(/_/g,"/"),i={sub:(r=JSON.parse(atob(n))).sub,email:r.email,name:r.name,preferred_username:r.preferred_username,given_name:r.given_name,family_name:r.family_name},r)r.hasOwnProperty(a)&&!i.hasOwnProperty(a)&&(i[a]=r[a]);return i}catch(e){return o.error(c.log.PREFIX+"Error parsing ID token:",e),null}},refreshAccessoIdToken:function(){var t=r.defer();if(!E._.accessoId.values.refresh_token)return o.error(c.log.PREFIX+"No refresh token available"),t.reject("No refresh token available"),t.promise;var n={grant_type:c.oauth.GRANT_TYPE.REFRESH_TOKEN,refresh_token:E._.accessoId.values.refresh_token,client_id:E._.getAccessoIdClientId()};return o.info(c.log.PREFIX+"Refreshing AccessoID tokens"),e.post(E._.accessoId.url.token,n).then(function(e){if(200!==e.status)return o.error(c.log.PREFIX+"Error refreshing tokens:",e.statusText),void t.reject(e.statusText);E._.setAccessoIdValues(e.data),g.set(c.storage.ACCESSO_ID_KEY,E._.getAccessoIdValues()),o.info(c.log.PREFIX+"Successfully refreshed AccessoID tokens"),t.resolve(e.data)}).catch(function(e){o.error(c.log.PREFIX+"Error refreshing tokens:",e),t.reject(e)}),t.promise},oidcUserManager:null,initializeOidc:function(){var e,a,l=t.get("Banner"),d=t.get("BannerEnums"),_=t.get("Language"),p=t.get("Modal"),f=n.search();if(!s.oidc)return o.error(c.log.PREFIX+"OIDC client library not available"),r.when();if(E._.oidcUserManager)return E._.oidcStartupPromise||r.when();try{return a={authority:e=E._.accessoId.url.authorization.replace("/"+c.oidc.AUTHORIZE,""),client_id:E._.getAccessoIdClientId(),redirect_uri:s.location.origin,post_logout_redirect_uri:s.location.origin,popup_post_logout_redirect_uri:s.location.origin+"/logout",response_type:"code",scope:c.oauth.SCOPES.join(" "),automaticSilentRenew:!0,silent_redirect_uri:s.location.origin+"/auth/silent-callback",includeIdTokenInSilentRenew:!0,loadUserInfo:!1,monitorSession:!0,checkSessionInterval:2e3,userStore:new s.oidc.WebStorageStateStore({store:s.sessionStorage}),metadata:{authorization_endpoint:E._.accessoId.url.authorization,token_endpoint:E._.accessoId.url.token,userinfo_endpoint:E._.accessoId.url.userinfo,end_session_endpoint:E._.accessoId.url.logout,jwks_uri:E._.accessoId.url.jwks,issuer:e}},E._.oidcUserManager=new s.oidc.UserManager(a),E._.oidcUserManager.events.addUserLoaded(function(e){o.info(c.log.PREFIX+"OIDC user loaded:",e.profile),E._.setAccessoIdValues({access_token:e.access_token,id_token:e.id_token,refresh_token:e.refresh_token,token_type:"Bearer",expires_in:e.expires_in,scope:e.scope,uuid:e.profile?e.profile.uuid:null}),E._.currentAuthType=c.type.ACCESSO_ID,i.$broadcast(c.events.USER_AUTHENTICATED),i.$$phase||i.$apply()}),E._.oidcUserManager.events.addUserUnloaded(function(){o.info(c.log.PREFIX+"OIDC user unloaded"),E._.currentAuthType=c.type.ANON,i.$broadcast(c.events.USER_UNAUTHENTICATED),i.$$phase||i.$apply()}),E._.oidcUserManager.events.addAccessTokenExpired(function(){o.info(c.log.PREFIX+"OIDC access token expired"),E.terminateSessionSilently().finally(function(){i.$broadcast(c.events.USER_UNAUTHENTICATED);try{p.displayModal({description:_.getLocale("ProfileLogin","sessionExpired"),icon:"icon-notice",showCloseButton:!1,buttonFlags:[u.buttonFlags.OK],callback:function(e){e==u.buttonFlags.OK&&(g.clearAll(),i.routeTo("/reset/false"))},customCss:{topModal:"top-modal"}})}catch(e){o.error(c.log.PREFIX+"Error showing session expiration modal:",e),g.clearAll(),i.routeTo("/reset/false")}i.$$phase||i.$apply()})}),E._.oidcUserManager.events.addSilentRenewError(function(e){o.error(c.log.PREFIX+"OIDC silent renew error:",e),E.terminateSessionSilently().finally(function(){i.$broadcast(c.events.USER_UNAUTHENTICATED);try{p.displayModal({description:_.getLocale("ProfileLogin","sessionRenewFailed"),icon:"icon-notice",showCloseButton:!1,buttonFlags:[u.buttonFlags.OK],callback:function(e){e==u.buttonFlags.OK&&(g.clearAll(),i.routeTo("/reset/false"))},customCss:{topModal:"top-modal"}})}catch(e){o.error(c.log.PREFIX+"Error showing silent renew error modal:",e),g.clearAll(),i.routeTo("/reset/false")}i.$$phase||i.$apply()})}),!s.opener&&f.code&&f.state?"localhost"!==s.location.hostname||f._m?(i.showSpinner(_.getLocale("ProfileLogin","loggingIn")),E._.oidcUserManager.signinRedirectCallback().then(function(e){o.info(c.log.PREFIX+"OIDC redirect signin callback successful:",e.profile),n.search("code",null),n.search("state",null);var t=e&&e.state&&e.state.returnUrl;t&&t!==n.url()&&n.url(t),i.$$phase||i.$apply()}).catch(function(e){return o.error(c.log.PREFIX+"Error handling OIDC redirect signin callback:",e),!1})):(o.debug(c.log.PREFIX+"Skipping signinRedirectCallback on localhost — no _m param (merchant not saved before login redirect)"),r.when()):E._.oidcUserManager.getUser().then(function(e){e&&!e.expired?(o.info(c.log.PREFIX+"Restoring valid OIDC session from storage:",e.profile),E._.setAccessoIdValues({access_token:e.access_token,id_token:e.id_token,refresh_token:e.refresh_token,token_type:"Bearer",expires_in:e.expires_in,scope:e.scope,uuid:e.profile?e.profile.uuid:null}),E._.currentAuthType=c.type.ACCESSO_ID,i.$broadcast(c.events.USER_AUTHENTICATED),i.$$phase||i.$apply()):e&&e.expired?(o.info(c.log.PREFIX+"OIDC session expired, clearing user"),E._.oidcUserManager.removeUser().then(function(){E._.currentAuthType=c.type.ANON,E._.accessoId.values={access_token:null,id_token:null,refresh_token:null,token_type:null,expires_in:null,scope:null,user_info:null,expiration:null,type:c.type.ACCESSO_ID};try{l.addMessage(_.getLocale("ProfileLogin","sessionExpired"),d.type.WARNING)}catch(e){o.error(c.log.PREFIX+"Error showing session expiration banner:",e)}i.$$phase||i.$apply()}).catch(function(e){o.error(c.log.PREFIX+"Error removing expired user:",e),E._.currentAuthType=c.type.ANON,E._.accessoId.values={access_token:null,id_token:null,refresh_token:null,token_type:null,expires_in:null,scope:null,user_info:null,expiration:null,type:c.type.ACCESSO_ID},i.$broadcast(c.events.USER_UNAUTHENTICATED),i.$$phase||i.$apply()})):o.info(c.log.PREFIX+"No existing OIDC session found")}).catch(function(e){return o.error(c.log.PREFIX+"Error checking for existing OIDC session:",e),!1})}catch(e){return o.error(c.log.PREFIX+"Error initializing OIDC:",e),r.when()}},getOidcUser:function(){var e;if(!E._.oidcUserManager)return r.resolve(null);return e=r.defer(),E._.oidcUserManager.getUser().then(function(t){e.resolve(t)}).catch(function(t){o.error(c.log.PREFIX+"Error getting OIDC user:",t),e.resolve(null)}),e.promise},mapLanguageForAccessoID:A,oidcSigninRedirect:function(e){var t,i;if(!E._.oidcUserManager)return r.reject("OIDC not initialized");(i=n.search())._m&&s.sessionStorage.setItem(c.storage.SIGNIN_PARAMS_KEY,i._m);t={state:{linkAnonymous:e&&e.linkAnonymousUser,directToRegistration:e&&e.directToRegistration,returnUrl:e&&e.returnUrl?e.returnUrl:n.url()},extraQueryParams:{}},e&&e.directToRegistration&&(t.extraQueryParams.acc_flow=c.oauth.FLOW_REGISTRATION);e&&e.linkAnonymousUser&&E._.anon.values.token&&(t.extraQueryParams.acc_anonymous_token=E._.anon.values.token);t.extraQueryParams.ui_locales=A(l.language),s.sessionStorage.getItem(c.storage.FORCE_LOGIN_PROMPT_KEY)&&(t.extraQueryParams.prompt="login",s.sessionStorage.removeItem(c.storage.FORCE_LOGIN_PROMPT_KEY));return r.when(E._.oidcUserManager.signinRedirect(t)).catch(function(e){return o.error(c.log.PREFIX+"Error initiating OIDC signin redirect:",e),r.reject(e)})},oidcSigninPopup:function(e){var t;if(!E._.oidcUserManager)return r.reject("OIDC not initialized");t={state:{linkAnonymous:e&&e.linkAnonymousUser,directToRegistration:e&&e.directToRegistration},extraQueryParams:{}},e&&e.directToRegistration&&(t.extraQueryParams.acc_flow=c.oauth.FLOW_REGISTRATION);e&&e.linkAnonymousUser&&E._.anon.values.token&&(t.extraQueryParams.acc_anonymous_token=E._.anon.values.token);t.extraQueryParams.ui_locales=A(l.language),s.sessionStorage.getItem(c.storage.FORCE_LOGIN_PROMPT_KEY)&&(t.extraQueryParams.prompt="login",s.sessionStorage.removeItem(c.storage.FORCE_LOGIN_PROMPT_KEY));return r.when(E._.oidcUserManager.signinPopup(t)).then(function(e){return o.info(c.log.PREFIX+"OIDC signin popup successful (PKCE handled by library)"),e}).catch(function(e){return o.error(c.log.PREFIX+"Error in OIDC signin popup:",e),r.reject(e)})},oidcSignoutRedirect:function(){var e,t;if(!E._.oidcUserManager)return r.reject("OIDC not initialized");e=E._.accessoId.values.id_token||null,(t=n.search())._m&&s.sessionStorage.setItem(c.storage.LOGOUT_PARAMS_KEY,t._m);return r.when(E._.oidcUserManager.signoutRedirect({id_token_hint:e,post_logout_redirect_uri:s.location.origin+"/logout"})).catch(function(e){return o.error(c.log.PREFIX+"signoutRedirect failed, falling back to local logout:",e),E._.oidcSignoutLocal()})},oidcSignout:function(){var e;if(!E._.oidcUserManager)return r.reject("OIDC not initialized");return e=E._.accessoId.values.id_token||null,r.when(E._.oidcUserManager.signoutPopup({id_token_hint:e})).then(function(){o.info(c.log.PREFIX+"OIDC signout popup completed")}).catch(function(e){return o.error(c.log.PREFIX+"signoutPopup failed, falling back to local logout:",e),E._.oidcSignoutLocal()})},oidcSignoutLocal:function(){var e;if(!E._.oidcUserManager)return r.reject("OIDC not initialized");return e=r.defer(),E._.oidcUserManager.removeUser().then(function(){o.info(c.log.PREFIX+"OIDC user removed locally (fallback)"),E._.currentAuthType=c.type.ANON,E._.accessoId.values={access_token:null,id_token:null,refresh_token:null,token_type:null,expires_in:null,scope:null,user_info:null,expiration:null,type:c.type.ACCESSO_ID},i.$$phase||i.$apply(),e.resolve()}).catch(function(t){o.error(c.log.PREFIX+"Error removing OIDC user:",t),E._.currentAuthType=c.type.ANON,E._.accessoId.values={access_token:null,id_token:null,refresh_token:null,token_type:null,expires_in:null,scope:null,user_info:null,expiration:null,type:c.type.ACCESSO_ID},i.$broadcast(c.events.USER_UNAUTHENTICATED),i.$$phase||i.$apply(),e.reject(t)}),e.promise},generateCodeVerifier:function(){var e,t=new Uint8Array(32);if(s.crypto&&s.crypto.getRandomValues)s.crypto.getRandomValues(t);else for(e=0;e<t.length;e++)t[e]=Math.floor(256*Math.random());return E._.base64UrlEncode(t)},generateCodeChallenge:function(e){var t,n=r.defer();if(!s.crypto||!s.crypto.subtle)return o.warn(c.log.PREFIX+"SubtleCrypto not available, using plain code verifier"),n.resolve(e),n.promise;try{t=(new TextEncoder).encode(e),s.crypto.subtle.digest("SHA-256",t).then(function(e){var t=new Uint8Array(e),o=E._.base64UrlEncode(t);n.resolve(o)}).catch(function(t){o.error(c.log.PREFIX+"Error generating code challenge:",t),n.resolve(e)})}catch(t){o.error(c.log.PREFIX+"Error in code challenge generation:",t),n.resolve(e)}return n.promise},base64UrlEncode:function(e){return btoa(String.fromCharCode.apply(null,e)).replace(/\+/g,"-").replace(/\//g,"_").replace(/=/g,"")}}};return l.applicationActivated?E._.initialize():i.$on(u.services.APP_ACTIVATED,E._.initialize),i.$on(u.events.purchaseComplete,function(){E._.type===c.type.ANON&&E._.enabled&&(E._.anon.lastPurchaseToken=E._.anon.values&&E._.anon.values.token||null,E._.fetchToken(!1))}),E;function A(e){var t,n,o={"zh-hans":"zh-Hans","zh-hant":"zh-Hant"},r=["da","de","en","es","fi","fr","fr-CA","it","ja","ko","ms","nl","pl","pt","ru","sv","th","tr","zh-Hans","zh-Hant"];return e?o[e.toLowerCase()]?o[e.toLowerCase()]:(t=p.normalizeLocale(e),-1!==r.indexOf(t)?t:(n=t.split("-")[0].toLowerCase(),-1!==r.indexOf(n)?n:"en")):"en"}}e.$inject=["$http","$injector","$location","$log","$q","$rootScope","$timeout","$window","AppData","AuthEnums","Enums","JSONValidator","ResellerService","Storage","StringUtils","Utilities","UtilsValidation"],angular.module("passport-auth").factory("AuthService",e)}();
angular.module("guest-profile",[]),angular.module("guest-profile").run(["GuestProfileBillingService","GuestProfileSessionService",angular.noop]),angular.module("guest-profile").factory("GuestProfileDataService",["$http","$log","$q","AppData","AuthService","Utilities",function(e,t,r,n,s,u){const a=u.checkProp;function i(){const e=s.getTokenRequestHeaders();let r,n;if(!e||!e.Authorization)return null;try{return r=e.Authorization.split(" ")[1],n=JSON.parse(window.atob(r.split(".")[1].replace(/-/g,"+").replace(/_/g,"/"))),n.auid||null}catch(e){return t.warn("GuestProfileDataService: could not decode auid from access token"),null}}function o(t,r,u){const a=[`${n.getApiUrl()}/api/guest-profile-service${r}`];return void 0!==u&&a.push(u),a.push({headers:angular.extend({},s.getTokenRequestHeaders(),{"com-accessopassport-client":n.island})}),e[t].apply(e,a).then(function(e){return e.data})}function d(e){return o("get",e)}function l(e,t){return o("patch",e,t)}function c(e,t){return o("post",e,t)}function p(e){return e?d(`/account/${e}`):r.reject(new Error("GuestProfileDataService: no auid provided"))}function f(e){return e?d(`/account/${e}/guests`):r.reject(new Error("GuestProfileDataService: no auid provided"))}function g(e){return e?d(`/guest/${e}/photo`):r.reject(new Error("GuestProfileDataService: no guestUuid provided"))}function h(e){return e?d(`/guest/${e}/phones`):r.reject(new Error("GuestProfileDataService: no guestUuid provided"))}return{createGuest:function(e,t){return e?c(`/account/${e}/guests`,t):r.reject(new Error("GuestProfileDataService: no auid provided"))},createGuestAddress:function(e,t){return e?c(`/guest/${e}/addresses`,t):r.reject(new Error("GuestProfileDataService: no guestUuid provided"))},createGuestPhone:function(e,t){return e?c(`/guest/${e}/phones`,t):r.reject(new Error("GuestProfileDataService: no guestUuid provided"))},deleteGuestPhone:function(e,t){return e?null==t?r.reject(new Error("GuestProfileDataService: no phoneId provided")):o("delete",`/guest/${e}/phones/${t}`):r.reject(new Error("GuestProfileDataService: no guestUuid provided"))},getAccount:p,getAuidFromToken:i,getGuestOptins:function(e){return e?d("/guest/"+e+"/optins"):r.reject(new Error("GuestProfileDataService: no guestUuid provided"))},getGuestPhoto:g,getGuestPhones:h,getGuests:f,loadProfileData:function(){const e=i();return r.all({account:p(e),guests:f(e)}).then(function(n){const s=Array.isArray(n.guests)?n.guests:[],u=s.map(function(e){return g(e.guestUuid).catch(function(r){return t.debug(`[passport-auth] /guest/${e.guestUuid}/photo failed (non-fatal):`,r),null})}),i=s.map(function(e){return h(e.guestUuid).catch(function(r){return t.debug(`[passport-auth] /guest/${e.guestUuid}/phones failed (non-fatal):`,r),[]})});return r.all({photos:r.all(u),phones:r.all(i)}).then(function(t){const r=s.map(function(e,r){const n=a("photoObj.downloadUrl",t.photos[r],"returnValue")||null,s=Array.isArray(t.phones[r])?t.phones[r]:[];return angular.extend({},e,{phones:s},n?{photoUrl:n}:{})});return{account:angular.extend({auid:e},n.account),guests:r}})})},proxyUploadToS3:function(t,u){return t?u?e.post(`${n.getApiUrl()}/api/guest-profile-s3-upload`,{contentType:"image/jpeg",image:u,uploadUrl:t},{headers:angular.extend({},s.getTokenRequestHeaders(),{"com-accessopassport-client":n.island})}).then(function(e){return e.data}):r.reject(new Error("GuestProfileDataService: no image data provided")):r.reject(new Error("GuestProfileDataService: no presignedUrl provided"))},updateGuest:function(e,t){return e?l(`/guest/${e}`,t):r.reject(new Error("GuestProfileDataService: no guestUuid provided"))},updateGuestAddress:function(e,t,n){return e?t?l(`/guest/${e}/addresses/${t}`,n):r.reject(new Error("GuestProfileDataService: no addressId provided")):r.reject(new Error("GuestProfileDataService: no guestUuid provided"))},updateGuestOptins:function(e,t){return e?o("put","/guest/"+e+"/optins",t):r.reject(new Error("GuestProfileDataService: no guestUuid provided"))},updateGuestPhone:function(e,t,n){return e?null==t?r.reject(new Error("GuestProfileDataService: no phoneId provided")):l(`/guest/${e}/phones/${t}`,n):r.reject(new Error("GuestProfileDataService: no guestUuid provided"))},uploadGuestPhoto:function(t){return t?e.put(`${n.getApiUrl()}/api/guest-profile-service/guest/${t}/photo`,{imageFormat:"jpg"},{headers:angular.extend({},s.getTokenRequestHeaders(),{"com-accessopassport-client":n.island})}).then(function(e){return e.data}):r.reject(new Error("GuestProfileDataService: no guestUuid provided"))}}}]),angular.module("guest-profile").factory("GuestProfileSessionService",["$log","$q","$rootScope","AuthEnums","GuestProfileDataService","ResellerService",function(e,t,r,n,s,u){let a=0,i=null;const o={account:null,guests:null,primaryGuest:null};function d(){if(u.isResellerMode()||u.isResellerPOSMode())return t.resolve(o);if(i)return i;const r=++a;return i=s.loadProfileData().then(function(e){if(r===a)return o.account=e.account,o.guests=e.guests,o.primaryGuest=e.guests.find(function(t){return t.guestUuid===e.account.primaryGuestUuid})||null,o}).catch(function(t){return e.warn("GuestProfileSessionService: loadProfileData failed:",t),o}).finally(function(){r===a&&(i=null)}),i}return r.$on(n.events.USER_AUTHENTICATED,d),r.$on(n.events.USER_UNAUTHENTICATED,function(){a++,i=null,o.account=null,o.guests=null,o.primaryGuest=null}),o.addGuest=function(e){e&&(Array.isArray(o.guests)||(o.guests=[]),o.guests=o.guests.concat([e]))},o.ensureLoaded=function(){return Array.isArray(o.guests)?t.when(o):d()},o.findGuest=function(e){return e&&Array.isArray(o.guests)&&o.guests.find(function(t){return t.guestUuid===e})||null},o.setPrimaryGuest=function(e){if(!e||!e.guestUuid)return;Array.isArray(o.guests)||(o.guests=[]);const t=o.guests.findIndex(function(t){return t.guestUuid===e.guestUuid});o.guests=t>=0?o.guests.map(function(r,n){return n===t?e:r}):o.guests.concat([e]),o.primaryGuest=e},o.updateGuest=function(e){e&&e.guestUuid&&Array.isArray(o.guests)&&(o.guests=o.guests.map(function(t){return t.guestUuid===e.guestUuid?e:t}),o.primaryGuest&&o.primaryGuest.guestUuid===e.guestUuid&&(o.primaryGuest=e))},o}]),angular.module("guest-profile").factory("GuestProfileModels",["Utilities",function(e){const t="BILLING",r="PRIMARY",n=/^\d{4}-\d{2}-\d{2}$/;function s(e){return e&&Array.isArray(e.phones)&&e.phones.filter(function(e){return e&&e.phoneType===r})[0]||null}function u(t,r){return t?n.test(t)?t:e.formatSetDateFormatToYYYY_MM_DD(t,r||"MM/dd/yyyy")||"":""}function a(e){return{address:e.street||"",address2:e.street2||"",city:e.city||"",country_code:e.country||"",state:e.state||"",zip_code:e.zipCode||""}}return{GPS_ADDRESS_TYPE_BILLING:t,GPS_PHONE_TYPE_PRIMARY:r,buildAddressPayload:function(e){return e.ph_address?{addressType:t,city:e.ph_city||"",country:e.ph_country_code||"",state:e.ph_state||"",street:e.ph_address||"",street2:e.ph_address2||"",zipCode:e.ph_zip||""}:null},buildCreateGuestPayload:function(e,t){const r={dependent:!0,email:e.ph_email||"",firstName:e.ph_first_name||"",lastName:e.ph_last_name||""};return e.ph_birth_date&&(r.birthDate=u(e.ph_birth_date,t)),e.ph_sex&&(r.gender=e.ph_sex),r},buildItemCharacs:function(e){return e&&e.guest_no?{gps_guestuuid:e.guest_no}:{}},buildOptinsPayload:function(e){return Array.isArray(e)?e.map(function(e){return{name:e.name,value:!!e.checked}}):[]},buildPhonePayload:function(e){return e.ph_home_phone?{countryCode:e.ph_home_phone_region_code||"",dialCode:e.ph_home_phone_country||"",number:e.ph_home_phone,phoneType:r}:null},buildUpdateAddressPayload:function(e,t,r){const n={},s=Array.isArray(r)?r:[];return[{addrVal:t.street||"",key:"street",overrideName:"address",passVal:e.ph_address||""},{addrVal:t.street2||"",key:"street2",overrideName:"address2",passVal:e.ph_address2||""},{addrVal:t.city||"",key:"city",overrideName:"city",passVal:e.ph_city||""},{addrVal:t.state||"",key:"state",overrideName:"state",passVal:e.ph_state||""},{addrVal:t.zipCode||"",key:"zipCode",overrideName:"zip",passVal:e.ph_zip||""},{addrVal:t.country||"",key:"country",overrideName:"country",passVal:e.ph_country_code||""}].forEach(function(e){e.overrideName&&s.indexOf(e.overrideName)>-1||e.passVal!==e.addrVal&&(n[e.key]=e.passVal)}),Object.keys(n).length>0?n:null},buildUpdateGuestPayload:function(e,t,r,n){const s={},a=Array.isArray(n)?n:[];return[{guestVal:t.firstName||"",key:"firstName",overrideName:"firstName",passKey:"ph_first_name",passVal:e.ph_first_name||""},{guestVal:t.lastName||"",key:"lastName",overrideName:"lastName",passKey:"ph_last_name",passVal:e.ph_last_name||""},{guestVal:t.email||"",key:"email",overrideName:"email",passKey:"ph_email",passVal:e.ph_email||""},{guestVal:t.gender||"",key:"gender",overrideName:"sex",passKey:"ph_sex",passVal:e.ph_sex||""},{guestVal:t.middleInitial||"",key:"middleInitial",overrideName:null,passKey:"ph_mi",passVal:e.ph_mi||""},{guestVal:t.birthDate||"",key:"birthDate",overrideName:"birthDate",passKey:"ph_birth_date",passVal:u(e.ph_birth_date,r)}].forEach(function(t){t.overrideName&&a.indexOf(t.overrideName)>-1||t.passKey in e&&t.passVal!==t.guestVal&&(s[t.key]=t.passVal)}),Object.keys(s).length>0?s:null},findBillingAddress:function(e){return e&&Array.isArray(e.addresses)&&e.addresses.filter(function(e){return e.addressType===t})[0]||null},findPrimaryPhone:s,mapGpsOptinsToDict:function(e){return Array.isArray(e)?e.reduce(function(e,t){return t&&t.name&&(e[t.name]=!0===t.value||"true"===t.value),e},{}):{}},mapGuestToProfile:function(e){return{first_name:e.firstName,guest_no:e.guest_no||null,guestUuid:e.guestUuid||e.uuid,last_name:e.lastName,uuid:e.uuid}},mapGuestToSelectorProfile:function(t,r,n){return{addresses:Array.isArray(t.addresses)&&t.addresses.length>0?t.addresses.map(a):void 0,birth_date:e.formatYYYY_MM_DDToSetDateFormat(t.birthDate||"",n||"MM/dd/yyyy")||"",email:t.email||"",first_name:t.firstName||"",getHomePhone:function(){const e=s(t)||{};return{country_code:e.dialCode||"",phone_number:e.number||"",region_code:e.countryCode||""}},getPrimaryAddress:function(){return this.addresses&&this.addresses[0]||{}},guest_no:t.guestUuid,guestUuid:t.guestUuid,image:t.photoUrl||null,isPrimary:!!r,isSelfPlaceholder:!!r&&!t.firstName&&!t.lastName,last_name:t.lastName||"",middle_name:t.middleInitial||"",name:`${t.firstName||""} ${t.lastName||""}`.trim(),profileImageName:function(){return""},profileImageUrl:t.photoUrl||"",sex:t.gender||"",toJSON:function(){return{email:this.email,first_name:this.first_name,guest_no:this.guest_no,last_name:this.last_name}}}},toGpsBirthDate:u}}]),angular.module("guest-profile").factory("GuestProfileInteractionService",["$log","$q","GuestProfileDataService","GuestProfileModels","GuestProfileSessionService",function(e,t,r,n,s){function u(){const e=s.account;return e&&e.auid?e.auid:r.getAuidFromToken()}function a(t,u,a,i,o){if((Array.isArray(i)?i:[]).indexOf("phone")>-1)return;if(!("ph_home_phone"in a))return;const d=n.findPrimaryPhone(u),l=n.buildPhonePayload(a);function c(e){const r=s.findGuest(t)||u;o(angular.extend({},r,{phones:e}))}return l?d?(!a.ph_home_phone_country&&d.dialCode&&(l.dialCode=d.dialCode),!a.ph_home_phone_region_code&&d.countryCode&&(l.countryCode=d.countryCode),d.number!==l.number||(d.dialCode||"")!==(l.dialCode||"")||(d.countryCode||"")!==(l.countryCode||"")?r.updateGuestPhone(t,d.id,l).then(function(e){const r=e&&void 0!==e.id?e:angular.extend({},d,l);c(((s.findGuest(t)||u).phones||[]).map(function(e){return e===d||e.id===d.id?r:e}))}).catch(function(t){e.warn("[GPS] updateGuestPhone failed (non-fatal):",t)}):void 0):r.createGuestPhone(t,l).then(function(e){const r=e&&void 0!==e.id?e:l;c(((s.findGuest(t)||u).phones||[]).concat([r]))}).catch(function(t){e.warn("[GPS] createGuestPhone failed (non-fatal):",t)}):d&&void 0!==d.id?r.deleteGuestPhone(t,d.id).then(function(){c(((s.findGuest(t)||u).phones||[]).filter(function(e){return e!==d&&e.id!==d.id}))}).catch(function(t){e.warn("[GPS] deleteGuestPhone failed (non-fatal):",t)}):void 0}return{createGuest:function(a,i){const o=u();if(!o)return e.warn("[GPS] createGuest: no auid in GPS session — aborting"),t.reject(new Error("GuestProfileInteractionService: no auid in GPS session"));if(function(e,t){const r=s.guests;if(!Array.isArray(r))return!1;const u=(e.ph_first_name||"").toLowerCase().trim(),a=(e.ph_last_name||"").toLowerCase().trim(),i=n.toGpsBirthDate(e.ph_birth_date||"",t);return r.some(function(e){return(e.firstName||"").toLowerCase().trim()===u&&(e.lastName||"").toLowerCase().trim()===a&&(e.birthDate||"")===i})}(a,i))return e.warn("[GPS] createGuest: name+DOB match found in session — rejecting as duplicate"),t.reject({gps_duplicate_guest:!0});const d=n.buildCreateGuestPayload(a,i);d.auids=[o];const l=n.buildAddressPayload(a),c=n.buildPhonePayload(a);return r.createGuest(o,d).then(function(u){const a=n.mapGuestToSelectorProfile(u,!1,i);s.addGuest(u);const o=[];return c&&o.push(r.createGuestPhone(a.guestUuid,c).then(function(e){const t=s.findGuest(a.guestUuid),r=e&&void 0!==e.id?e:c;t&&s.updateGuest(angular.extend({},t,{phones:(t.phones||[]).concat([r])}))}).catch(function(t){e.warn("[GPS] createGuestPhone failed (non-fatal):",t)})),l&&o.push(r.createGuestAddress(a.guestUuid,l).catch(function(t){e.warn("[GPS] createGuestAddress failed (non-fatal):",t)})),t.all(o).then(function(){return a})})},findGpsProfileForRenewal:function(t,r){const u=s.guests;if(!Array.isArray(u)||!u.length)return null;const a=(t.ph_first_name||"").toLowerCase().trim(),i=(t.ph_last_name||"").toLowerCase().trim(),o=n.toGpsBirthDate(t.ph_birth_date||"",r),d=u.filter(function(e){return(e.firstName||"").toLowerCase().trim()===a&&(e.lastName||"").toLowerCase().trim()===i&&(e.birthDate||"")===o});return d.length>1&&e.warn("[GPS] findGpsProfileForRenewal: multiple GPS guests matched renewal pass — using first match"),d.length?n.mapGuestToSelectorProfile(d[0],!1,r):null},getOptins:function(e){if(!e)return t.reject(new Error("GuestProfileInteractionService: no guestUuid provided"));const u=s.findGuest(e);return u&&u.optins?t.when(u.optins):r.getGuestOptins(e).then(function(t){const r=n.mapGpsOptinsToDict(t),u=s.findGuest(e);return u&&s.updateGuest(angular.extend({},u,{optins:r})),r})},getProfiles:function(e){const t=s.guests,r=s.primaryGuest&&s.primaryGuest.guestUuid;return Array.isArray(t)?t.map(function(t){return n.mapGuestToSelectorProfile(t,t.guestUuid===r,e)}):[]},saveOptins:function(e,u){if(!e)return t.reject(new Error("GuestProfileInteractionService: no guestUuid provided"));if(!Array.isArray(u)||!u.length)return t.when();const a=n.buildOptinsPayload(u);return r.updateGuestOptins(e,a).then(function(t){const r=s.findGuest(e);if(r){const e=angular.extend({},r.optins,n.mapGpsOptinsToDict(a));s.updateGuest(angular.extend({},r,{optins:e}))}return t})},updateGuest:function(i,o,d,l){if(!u())return e.warn("[GPS] updateGuest: no auid in GPS session — aborting"),t.reject(new Error("GuestProfileInteractionService: no auid in GPS session"));const c=i.guest_no,p=s.findGuest(c);if(!p)return e.warn("[GPS] updateGuest: guest not found in session, guestUuid:",c),t.reject(new Error("GuestProfileInteractionService: guest not found in session"));const f=n.buildUpdateGuestPayload(i,p,o,d);function g(){const t=n.findBillingAddress(p);if(t){if(!n.buildAddressPayload(i))return void e.debug("[GPS] updateGuest — no address in billing data, skipping address PATCH");const u=n.buildUpdateAddressPayload(i,t,l);return u?(e.debug("[GPS] updateGuest — address changed fields:",Object.keys(u)),r.updateGuestAddress(c,t.id,u).then(function(e){const r=e&&e.id?e:angular.extend({},t,u),n=s.findGuest(c);if(n){const e=(n.addresses||[]).map(function(e){return e.id===t.id?r:e});s.updateGuest(angular.extend({},n,{addresses:e}))}}).catch(function(t){e.warn("[GPS] updateGuestAddress failed (non-fatal):",t)})):void e.debug("[GPS] updateGuest — no address changes, skipping address PATCH")}const u=n.buildAddressPayload(i);if(u)return e.debug("[GPS] updateGuest — no existing billing address, creating new address for guestUuid:",c),r.createGuestAddress(c,u).then(function(e){if(e&&e.id){const t=s.findGuest(c);if(t){const r=(t.addresses||[]).concat([e]);s.updateGuest(angular.extend({},t,{addresses:r}))}}}).catch(function(t){e.warn("[GPS] createGuestAddress failed (non-fatal):",t)});e.debug("[GPS] updateGuest — no address in pass data, skipping address create")}function h(){return a(c,p,i,d,function(e){s.updateGuest(e)})}function m(){return t.all([t.when().then(g),t.when().then(h)])}return e.debug("[GPS] updateGuest — guestUuid:",c,"changedFields:",f?Object.keys(f):"none"),f?r.updateGuest(c,f).then(function(e){const t=angular.extend({},p,e&&e.guestUuid?e:f);s.updateGuest(t)}).catch(function(t){e.warn("[GPS] updateGuest demographics PATCH failed (non-fatal):",t)}).then(m):(e.debug("[GPS] updateGuest — no demographic changes, skipping guest PATCH"),m())},updatePrimaryGuest:function(i,o,d,l){const c=u();if(!c)return e.warn("[GPS] updatePrimaryGuest: no auid in GPS session — aborting"),t.reject(new Error("GuestProfileInteractionService: no auid in GPS session"));const p=s.primaryGuest||{},f=n.findBillingAddress(p),g=n.buildUpdateGuestPayload(i,p,o,d);return e.debug("[GPS] updatePrimaryGuest — changedFields:",g?Object.keys(g):"none"),(g?r.updateGuest(c,g):t.when(null)).then(function(u){const h=angular.extend({guestUuid:c},p,u&&u.guestUuid?u:g||{});g&&s.setPrimaryGuest(h);const m=n.mapGuestToSelectorProfile(h,!0,o),G=t.when(a(h.guestUuid,p,i,d,function(e){s.setPrimaryGuest(e)}));return t.all([G,function(){if(f){if(!n.buildAddressPayload(i))return e.debug("[GPS] updatePrimaryGuest — no address in pass data, skipping address PATCH"),t.when();const u=n.buildUpdateAddressPayload(i,f,l);return u?(e.debug("[GPS] updatePrimaryGuest — address changed fields:",Object.keys(u)),r.updateGuestAddress(h.guestUuid,f.id,u).then(function(e){const t=e&&e.id?e:angular.extend({},f,u),r=s.primaryGuest||{},n=(r.addresses||[]).map(function(e){return e.id===f.id?t:e});s.setPrimaryGuest(angular.extend({},r,{addresses:n}))}).catch(function(t){e.warn("[GPS] updateGuestAddress failed (non-fatal):",t)})):(e.debug("[GPS] updatePrimaryGuest — no address changes, skipping address PATCH"),t.when())}const u=n.buildAddressPayload(i);return u?(e.debug("[GPS] updatePrimaryGuest — no existing billing address, creating new address for guestUuid:",h.guestUuid),r.createGuestAddress(h.guestUuid,u).then(function(e){if(e&&e.id){const t=s.primaryGuest||{},r=(t.addresses||[]).concat([e]);s.setPrimaryGuest(angular.extend({},t,{addresses:r}))}}).catch(function(t){e.warn("[GPS] createGuestAddress failed (non-fatal):",t)})):(e.debug("[GPS] updatePrimaryGuest — no address in pass data, skipping address create"),t.when())}()]).then(function(){return m})})}}}]),angular.module("guest-profile").factory("GuestProfileImageService",["$log","$q","$rootScope","AuthEnums","GuestProfileDataService","GuestProfileSessionService","ImageCaptureTempImageService",function(e,t,r,n,s,u,a){const i=new Set,o={getImageUrlForGuest:function(e){if(!r.configuredForPassportAuth||!e)return"";const t=u.guests;if(!Array.isArray(t))return"";const n=t.find(function(t){return t.guestUuid===e});return n&&n.photoUrl||""},refreshPhotoUrl:function(n){return r.configuredForPassportAuth&&n?i.has(n)?(l(n),t.resolve(null)):s.getGuestPhoto(n).then(function(e){const t=e&&e.downloadUrl;if(!t)return i.add(n),l(n),null;const r=u.findGuest(n);return r&&u.updateGuest(angular.extend({},r,{photoUrl:t})),t}).catch(function(t){return e.debug("[GPS] GuestProfileImageService: refreshPhotoUrl failed for",n,":",t),i.add(n),l(n),null}):t.resolve(null)},uploadPhoto:function(e,n){return r.configuredForPassportAuth?e?a.getFinalizedImageDataUrl(n).then(function(t){return d(e,t)}):t.reject(new Error("GuestProfileImageService.uploadPhoto: no guestUuid provided")):t.resolve()},uploadPhotoFromDataUrl:function(e,n){return r.configuredForPassportAuth&&e&&n?d(e,n):t.resolve()}};return r.$on(n.events.USER_UNAUTHENTICATED,function(){i.clear()}),o;function d(r,n){let a;try{if(a=n.split(",")[1],!a)throw new Error("missing base64 segment")}catch(e){return t.reject(new Error(`GuestProfileImageService: failed to extract base64 from data URL — ${e.message}`))}return s.uploadGuestPhoto(r).then(function(e){const r=e&&e.uploadUrl;return r?s.proxyUploadToS3(r,a):t.reject(new Error("GuestProfileImageService: GPS did not return an uploadUrl"))}).then(function(){e.debug("[GPS] GuestProfileImageService: photo uploaded for guest",r),function(t){s.getGuestPhoto(t).then(function(e){const r=u.findGuest(t);r&&e&&e.downloadUrl&&u.updateGuest(angular.extend({},r,{photoUrl:e.downloadUrl}))}).catch(function(t){e.debug("[GPS] GuestProfileImageService: non-fatal — could not refresh photoUrl after upload:",t)})}(r)})}function l(e){const t=u.findGuest(e);t&&u.updateGuest(angular.extend({},t,{photoUrl:null}))}}]),angular.module("guest-profile").factory("GuestProfileBillingService",["$rootScope","AppData","AuthEnums","GuestProfileModels","GuestProfileSessionService","UserInfo","UtilsValidation",function(e,t,r,n,s,u,a){var i=a.validString;function o(){const e=s.primaryGuest;return!(!e||!n.findBillingAddress(e))}function d(e){const t=s.primaryGuest;if(!t)return;const r=n.findBillingAddress(t),u=n.findPrimaryPhone(t);e.firstName=t.firstName||"",e.middleInitial=t.middleInitial||"",e.lastName=t.lastName||"",e.email=t.email||"",e.emailVerify=t.email||"",e.phone=u&&u.number||"",e.countryCode=u&&u.dialCode||"",r&&(e.address=r.street||"",e.address2=r.street2||"",e.city=r.city||"",e.state=r.state||"",e.country=r.country||"",e.zip=r.zipCode||"")}return e.$on(r.events.USER_AUTHENTICATED,function(){e.configuredForPassportAuth&&(t.setActionToPopulateBillingShippingFromOtherModel(d,o),t.populateBillingShippingModelInfo.shouldCopyFromOtherModel=o())}),{buildAccessoPayUserPreFill:function(){if(u.billing&&u.billing._gpsLinkedGuestUuid)return{};var e={},t=s.primaryGuest,r=t&&n.findPrimaryPhone(t);t&&i(t.email)&&(e.email=t.email),t&&i(t.firstName)&&(e.firstName=t.firstName),t&&i(t.lastName)&&(e.lastName=t.lastName),r&&i(r.number)&&(e.phone=r.number),r&&i(r.dialCode)&&(e.phoneCountryCode=r.dialCode);var a=t&&n.findBillingAddress(t);return a&&(i(a.street)&&(e.address1=a.street),i(a.street2)&&(e.address2=a.street2),i(a.city)&&(e.city=a.city),i(a.state)&&(e.stateProvince=a.state),i(a.zipCode)&&(e.zipPostal=a.zipCode),i(a.country)&&(e.country=a.country)),e}}}]);
angular.module("guest-profile-menu",["passport-auth","guest-profile"]),function(){function e(e,o,t,n,i,r){const c=this;c.isOpen=!1,c.oidcSession=null,c.handleNavClick=function(){r.isAuthenticated()?(c.oidcSession||(c.oidcSession=r.getUserInfo()),c.isOpen?s():(c.isOpen=!0,u=t(function(){u=null,l=function(e){const t=document.querySelector(".profile-menu__popout"),n=document.getElementById("profile-nav-icon");t&&n?t.contains(e.target)||n.contains(e.target)||(c.close(),o.$evalAsync(angular.noop)):a()},document.addEventListener("click",l,!0)}))):r.initiateAccessoIdLogin().catch(function(o){e.error("Failed to initiate AccessoID login:",o)})},c.close=s,c.clearSession=function(){c.oidcSession=null},c.goToAccountPortal=function(){c.close();const e=i.getAccountPortalUrl();if(!e)return;const o=r.getIdToken(),t=e+"/accesso-login"+(o?"#id_token="+encodeURIComponent(o):"");n.open(t,"_blank")};let l=null,u=null;function s(){u&&(t.cancel(u),u=null),c.isOpen=!1,a()}function a(){l&&(document.removeEventListener("click",l,!0),l=null)}}angular.module("guest-profile-menu").service("GuestProfileMenuService",e),e.$inject=["$log","$rootScope","$timeout","$window","AppData","AuthService"]}(),function(){function e(e,o,t,n,i,r,c,l,u,s,a,f,g){(0,g.merge)(this,{_:{},getProfileInitials:function(){let e,o;const t=l.primaryGuest;if(t&&(e=(t.firstName||"").charAt(0),o=(t.lastName||"").charAt(0),e||o))return(e+o).toUpperCase();return""},goToAccountPortal:function(){f.goToAccountPortal()},gpsSession:l,logoutFromPopout:function(){f.close();const o=function(){s.clear().then(function(){return n.logout()}).then(function(){f.clearSession()}).catch(function(o){e.error("Failed to logout:",o),i.addMessage(u.getLocale("Profile","logoutErrorMessage"),r.type.ERROR,null,1e4)})};s.totalQty>0?a.displayModal({action:"Confirm",buttonFlags:[c.buttonFlags.NO,c.buttonFlags.YES],callback:function(e){e===c.buttonFlags.YES&&o()},category:"Logout",description:u.getLocale("Profile","logoutCartWarning"),headerFlag:a.DEFAULT,label:u.getLocale("Profile","logoutConfirmTitle"),title:u.getLocale("Profile","logoutConfirmTitle")}):o()},menu:f,profileColorIndex:Math.floor(3*Math.random())}),o.$on("$destroy",function(){f.close()})}angular.module("guest-profile-menu").directive("guestProfileMenu",function(){return{bindToController:!0,controller:e,controllerAs:"vm",restrict:"E",templateUrl:"/scripts/modules/guest-profile-menu/directives/views/guest-profile-menu.html"}}).directive("gpsImgRefresh",["$injector","$rootScope",function(e,o){return{restrict:"A",link:function(t,n,i){var r=!1;n.on("error",function(){if(r||!o.configuredForPassportAuth)return;const n=i.gpsImgRefresh;if(!n||!e.has("GuestProfileImageService"))return;const c=e.get("GuestProfileImageService");t.$apply(function(){c.refreshPhotoUrl(n)})}),t.$on("$destroy",function(){r=!0,n.off("error")})}}}]),e.$inject=["$log","$scope","AppData","AuthService","Banner","BannerEnums","Enums","GuestProfileSessionService","Language","LegacyCart","Modal","GuestProfileMenuService","Utilities"]}();
angular.module('payment-plan', ['app'])
	.config(function(
		$stateProvider,
		ComponentLoaderEnums
	) {

		var components = [ ComponentLoaderEnums.paymentSchedule ];

		$stateProvider
			.state('/paymentPlan/:planType/:packageId', {
				url: '/paymentPlan/:planType/:packageId',
				templateUrl: '/views/extraFlow/paymentPlan.html',
				controller: 'PaymentPlanController',
				components: components,
				resolve: {
					initialData: initialData,
					loadAssets: loadAssets,
					xfcMap: xfcMap,
					scheduleData: function(xfcMap, $injector, $transition$) {
						return $injector.get('PaymentPlanService').initialize($transition$.params(), "single");
					}
				}
			})
			.state('/paymentPlanMulti/:packageId', {
				url: '/paymentPlanMulti/:packageId',
				templateUrl: '/views/extraFlow/paymentPlan.html',
				controller: 'PaymentPlanController',
				components: components,
				resolve: {
					initialData: initialData,
					loadAssets: loadAssets,
					xfcMap: xfcMap,
					scheduleData: function(xfcMap, $injector, $transition$) {
						return $injector.get('PaymentPlanService').initialize($transition$.params());
					}
				}
			});

		/**
		 * Bootstraps the application
		 * @param {Service} Bootstrap Bootstrap
		 * @returns {Promise} To bootstrap
		 * @ngInject
		 */
		function initialData(Bootstrap) {
			return Bootstrap.bootstrapApplication();
		}

		/**
		 * Lazyloads our assets
		 * @param {Service} Utilities Utilities
		 * @returns {Promise} To load our assets
		 * @ngInject
		 */
		function loadAssets(Utilities) {
			return Utilities.cacheBustAndLazyLoad([
				'scripts/modules/payment-plan/services/payment-plan-service.js',
				'scripts/modules/payment-plan/controllers/payment-plan-controller.js'
			]);
		}

		/**
		 * Builds the XFC map
		 * @param {Promise} initialData Bootstrap
		 * @param {Service} Package The package service
		 * @returns {Promise} to build the XFC map
		 * @ngInject
		 */
		function xfcMap(initialData, loadAssets, Package) {
			return Package.buildXFCMap();
		}
	})
	.run();

(function() {
	'use strict';
	angular.module('credit-cards')
		.directive('creditCardForm',
			function() {
				return {
					bindToController: true,
					controller: 'CreditCardFormDirectiveController',
					controllerAs: 'vm',
					restrict: 'E',
					scope: {
						invalidCreditCard: '=',
						isSubmit: '=',
						payment: '='
					},
					templateUrl: '/scripts/modules/credit-cards/directives/credit-card-form/views/credit-card-form-directive.html'
				}
			}
		);

})();
(function() {
	'use strict';

	angular
		.module('credit-cards')
		.controller('CreditCardFormDirectiveController', CreditCardFormDirectiveController);

	/**
	 * This is the controller for our PaymentForm Directive.
	 * @public
	 * @constructor
	 * @returns {undefined}
	 * @ngInject
	 */
	function CreditCardFormDirectiveController(
		$filter,
		AppData,
		BillingService,
		LegacyCart,
		CreditCardBinRangesService,
		CreditCardsVerificationService,
		Enums,
		Language,
		Modal,
		StringUtils,
		UserInfo,
		UtilsValidation
	) {
		var vm = this;
		var isDefined = angular.isDefined;

		/**
		 * Get all the card types - this is used for showSecurityCode function
		 * @type {Array}
		 */
		var cardTypes = LegacyCart.getCardTypesToDisplay();

		/**
		 * Min and max card Length
		 * @type {number}
         */
		vm.ccMin = 12;
		vm.ccMax = 19;

		/**
		 * Get months and years dropdown info
		 * @type {Array}
         */
		vm.months = getMonths();
		vm.years = getYears();
		vm.accountLenError = true;
		vm.accountTypeError = true;
		vm.i18n = Language;
		vm.validCardTypes = getValidCardTypes();

		vm.ccIcon = ccIcon;
		vm.handleCardNumberChanged = handleCardNumberChanged;
		vm.showCVVField = showCVVField;
		vm.showSecurityCode = showSecurityCode;
		vm.getBinImage = getBinImage;

		/**
		 * Returns the bin image if we have one
		 * @public
		 * @function
		 * @name getBinImage
		 * @return {String|null} depending on whether we find one or not
		 */
		function getBinImage() {
			var normalize = StringUtils.normalize,
				billingType,
				creditCardName;

			if (UtilsValidation.isRealObject(vm.payment) && UtilsValidation.validString(vm.payment.ccType)) {
				creditCardName = normalize(vm.payment.ccType);
				billingType = AppData.billingTypes.find(function(type) {
					return normalize(type.name) === creditCardName;
				});

				if (billingType) {
					return CreditCardBinRangesService.getBinImage(billingType.merchant_payment_type_ref_id);
				}
			}

			return null;
		}

		/**
		 * Return card icon
		 * @public
		 * @returns {string}
		 */
		function ccIcon() {
			var ccType = getCCType();
			return ccType ? 'sprite sprite-' + ccType.split(' ').join('').toLowerCase() : 'sprite sprite-phcard';
		}

		/**
		 * Function that validate the card number that is entered into credit card field
		 * @public
		 * @returns {undefined}
		 */
		function handleCardNumberChanged() {
			var regexp = /[A-Za-z]/g;

			resetCreditCardForm();
			vm.payment.ccType = getCCType();
			vm.accountTypeError = vm.payment.ccType === 'phcard' || regexp.test(vm.payment.cardNumber);
			vm.accountLenError = !CreditCardsVerificationService.validateCardNumber(vm.payment.cardNumber, getCCType());
		}

		/**
		 * Is American Express in the array of cards?
		 * @protected
		 * @returns {boolean}
		 */
		function hasAmex() {
			return cardTypes.some(function(card) {
				return card.mobile_sprite == 'americanexpress';
			});
		}

		/**
		 * Returning the credit card type back
		 * @protected
		 * @returns {string}
         */
		function getCCType() {
			return isDefined(vm.payment.cardNumber) ? CreditCardsVerificationService.getCreditCardType(vm.payment.cardNumber, undefined) : undefined;
		}

		/**
		 * An array of month objects
		 * @protected
		 * @returns {Array} [{value:'01',text:'01 - LocalizedMonth'}, ...]
		 */
		function getMonths() {
			var months = [];
			Language.months.forEach(function(month, index) {
				var value = $filter('leadingZeros')(parseInt(index + 1), 2);
				if (AppData.language === 'ja-jp') {
					months.push(
						{
							value: value,
							text: month
						}
					);
				} else {
					months.push(
						{
							value: value,
							text: value + ' - ' + month
						}
					);
				}
			});

			return months;
		}

		/**
		 * Returning the card error message based on card type
		 * @returns {string} error message
		 */
		function getValidCardTypes() {
			var i = 0;
			var cardOverrides = CreditCardsVerificationService.getCardOverrides();
			var cardTypeReplacement = '';

			for (; i < cardOverrides.length; i++) {
				if (i == cardOverrides.length - 1 && cardOverrides.length > 1) {
					cardTypeReplacement += ' or ';
				}
				cardTypeReplacement += cardOverrides[i];
				if (i < cardOverrides.length - 1 && cardOverrides.length > 2) {
					cardTypeReplacement += ', ';
				}
			}

			return Language.replaceAll('@@cardTypes', cardTypeReplacement, Language.getLocale('FormValidation', 'ccOverideTypes'));
		}

		/**
		 * An array of YEARS based on range
		 * @protected
		 * @returns {Array} [{value:'YY',text:'YYYY'}, ...]
		 */
		function getYears() {
			var currentYear = Language.currentYear;
			var range = $filter('range')([], currentYear, currentYear + 10);
			var years = range.map(function(year) {
				return {
					text: '' + year,
					value: $filter('rightSubstring')(year, 2)
				};
			});
			return years;
		}

		/**
		 * Reset all the validation on credit card form
		 * @protected
		 * @returns {undefined}
		 */
		function resetCreditCardForm() {
			vm.accountLenError = false;
			vm.accountTypeError = false;
			vm.invalidCreditCard = false;
		}

		/**
		 * Assesses whether or not to show the CVV field
		 * Only EC authTypes require this field
		 * If we are on the credit card capture form with a APD (pin debit) or MRC (Ingenico) authType
		 * then we do not want to show the field
		 * @public
		 * @returns {boolean}
		 */
		function showCVVField() {
			return BillingService.isCVVRequiredAuthType(UserInfo.payment.authType) || BillingService.isCVVOptionalAuthType(UserInfo.payment.authType);
		}

		/**
		 * User triggered function to display the Security code Modal
		 * @public
		 * @returns {undefined}
		 */
		function showSecurityCode() {
			var modalNeeds = {
				cards: cardTypes,
				hasAmex: hasAmex()
			};
			window.scrollTo(0, 0);
			// Generates an object for the modal to use in the html

			Modal.displayModal({
				action: 'View',
				buttonFlags: [Enums.buttonFlags.OK],
				category: 'Billing',
				customHTML: 'views/modals/NewCVC.html',
				description: modalNeeds,
				label: 'Security Code Help',
				title: Language.getLocale('Alert', 'whatIsCVVTitle')
			});
		}
	}
})();

/**
 * Created by pMatthews on 2/5/2016.
 */
angular
	.module('crosssell-choice', ['app'])
	.config(function($locationProvider, $stateProvider) {
		var MODULE_DIRECTORY = '/scripts/modules/crosssell-choice/';

		$stateProvider
			.state('meals', {
				url: '/tiles/:recommenderWizardKeyword/:keyword',
				controller: 'CrossSellHListController',
				templateUrl: MODULE_DIRECTORY + 'views/tiled.html',
				resolve: {
					load: function($rootScope, Utilities) {
						$rootScope.showSpinner();

						return Utilities.cacheBustAndLazyLoad([
							MODULE_DIRECTORY + 'controllers/crosssell-hlist-controller.js',
							MODULE_DIRECTORY + 'addons-choice.css'
						]);
					},
					initialData: function(load, Bootstrap) {
						return Bootstrap.bootstrapApplication();
					},
					recommenderWizard: function($transition$, $q, initialData, CustomActionService, RecommenderWizardContextService, RecommenderWizardService, RecommenderWizardRouteService) {
						var stateParams = $transition$.params();
						if (RecommenderWizardContextService.bootstrapWizard(stateParams.recommenderWizardKeyword, 'meals')
							&& RecommenderWizardService.wizardHasPackages()) {
								RecommenderWizardContextService.registerMeals();
								if (RecommenderWizardService.shouldSkipAdditionalWizardStep('skipAddlMealsWizard')) {
									CustomActionService.executeCustomAction('cancelSelectedPackages');
									$transition$.abort();
									return $q.reject();
								}
								if(RecommenderWizardService.shouldSkipStepIfAdmissionsUpgradedToPass('skipMealsIfUpgradedToPass')){
									CustomActionService.executeCustomAction('cancelSelectedPackages');
									$transition$.abort();
									return $q.reject();
								}
						} else {
							// we are in an invalid state - abort and go back to the top of the store
							RecommenderWizardRouteService.errorToFront(stateParams.recommenderWizardKeyword);
						}

						return true;
					},
					initializeMeals: function(recommenderWizard, $injector, $transition$) {
						return $injector.get('CrossSellChoiceService').initialize($transition$.params(), '', 3, ['buy']);
					},
					skipIfNoData: function(initializeMeals, CustomActionService, $injector) {
						if ($injector.get('CrossSellChoiceService').currentPackageList().length < 1) {
							CustomActionService.executeCustomAction('cancelSelectedPackages');
						}

						return true;
					}
				}
			})
			.state('extras', {
				url: '/extras/:recommenderWizardKeyword/:keyword',
				controller: 'CrossSellVListController',
				templateUrl: MODULE_DIRECTORY + 'views/simplevertical.html',
				resolve: {
					load: function($rootScope, Utilities) {
						$rootScope.showSpinner();

						return Utilities.cacheBustAndLazyLoad([
							MODULE_DIRECTORY + 'controllers/crosssell-vlist-controller.js'
						]);
					},
					initialData: function(load, Bootstrap) {
						return Bootstrap.bootstrapApplication();
					},
					recommenderWizard: function($transition$, $q, initialData, CustomActionService, RecommenderWizardContextService, RecommenderWizardService, RecommenderWizardRouteService) {
						var stateParams = $transition$.params();
						if (RecommenderWizardContextService.bootstrapWizard(stateParams.recommenderWizardKeyword, 'extras')
							&& RecommenderWizardService.wizardHasPackages()) {
							RecommenderWizardContextService.registerExtras();
							if (RecommenderWizardService.shouldSkipAdditionalWizardStep('skipAddlExtrasWizard')) {
								CustomActionService.executeCustomAction('cancelSelectedPackages');
								$transition$.abort();
								return $q.reject();
							}
							if (RecommenderWizardService.shouldSkipStepIfAdmissionsUpgradedToPass('skipExtrasIfUpgradedToPass')) {
								CustomActionService.executeCustomAction('cancelSelectedPackages');
								$transition$.abort();
								return $q.reject();
							}

						} else {
							// we are in an invalid state - abort and go back to the top of the store
							RecommenderWizardRouteService.errorToFront(stateParams.recommenderWizardKeyword);
						}

						return true;
					},
					initializeExtras: function(recommenderWizard, $injector, $transition$) {
						return $injector.get('CrossSellChoiceService').initialize($transition$.params(), '', 3, ['buy'], false);
					},
					skipIfNoData: function(initializeExtras, $injector, CustomActionService) {
						if ($injector.get('CrossSellChoiceService').currentPackageList().length < 1) {
							CustomActionService.executeCustomAction('cancelSelectedPackages');
						}

						return true;
					},
					hideSpinner: function($rootScope) {
						$rootScope.hideSpinner();
					}
				}
			})
			.state('addons-choice', {
				url: '/addons-choice/:packageId',
				controller: 'CrossSellHListController',
				templateUrl: MODULE_DIRECTORY + 'views/tiled.html',
				resolve: {
					load: function($rootScope, Utilities) {
						$rootScope.showSpinner();

						return Utilities.cacheBustAndLazyLoad([
							MODULE_DIRECTORY + 'services/addons-choice-context-service.js',
							MODULE_DIRECTORY + 'controllers/crosssell-hlist-controller.js',
							MODULE_DIRECTORY + 'addons-choice.css'
						]);
					},
					initialData: function(load, Bootstrap) {
						return Bootstrap.bootstrapApplication();
					},
					xfcMap: function(initialData, Package) {
						return Package.buildXFCMap();
					},
					initXFC: function(xfcMap, RouteRejectionService, Package, $transition$) {
						var rejectionRoute = Package.assessRoutabilityOfXFC($transition$.params().packageId);
						if (rejectionRoute.length) {
							throw new RouteRejectionService.UnrecoverableException(rejectionRoute);
						}
					},
					initializeAddOns: function(initXFC, $injector, $transition$) {
						$injector.get('AddOnsChoiceContextService').registerCustomActions();

						return $injector.get('CrossSellChoiceService').initialize($transition$.params(), '', 3, ['buy', 'back', 'continue'], true);
					},
					skipIfNoData: function(initializeAddOns, $injector, CustomActionService) {
						if (!$injector.get('CrossSellChoiceService').currentPackageList(true).length) {
							CustomActionService.executeCustomAction('nextRouteDirection');
						}
					}
				}
			});
	})
	.run(function(Enums, ExtraFlow) {
		ExtraFlow.registerXMC
		('MealsModule',
			{
				name: 'MealsModule',
				view: Enums.extraFlowRoutes.MEALS,
				viewIsStateName: true,
				doEditMode: true,
				lockQuantity: false,
				writeSingleCharac: false,
				enabled: true,
				type: 'alternateFlowModule'
			}
		);
		ExtraFlow.registerXMC
		('ExtrasModule',
			{
				name: 'ExtrasModule',
				view: Enums.extraFlowRoutes.EXTRAS,
				viewIsStateName: true,
				doEditMode: true,
				lockQuantity: false,
				writeSingleCharac: false,
				enabled: true,
				type: 'alternateFlowModule'
			}
		);
		ExtraFlow.registerXMC('addons_choice', {
			name: 'addons_choice',
			view: 'addons-choice',
			viewIsStateName: true,
			doEditMode: true,
			enabled: true,
			type: 'extraFlowControl'
		});
	});

/* eslint-disable strict */
/**
 * Created by pMatthews on 2/4/2016.
 */
angular.module('crosssell-choice')
	.service('CrossSellChoiceService', function(
		$filter,
		$q,
		$rootScope,
		Enums,
		Utilities,
		AppData,
		Package,
		Language,
		PackageList,
		CustomActionService,
		JSONValidator,
		RecommenderWizardService,
		RecommenderWizardContextService,
		UtilityFunctions,
		UtilsValidation
	) {
		var validString = UtilsValidation.validString,
			validArray = UtilsValidation.validArray,
			isObject = angular.isObject,
			forceInt = Utilities.forceInt,
			DECONFLICT_BY_CUSTOMER_ID = 'customer_id',
			DECONFLICT_BY_QUANTITY = 'quantity';

		var promiseChainer = {
			datePackages: [],
			packages: [],
			timePackages: [],
		};

		var service = {
			initialize: initialize,
			buildCustomerTypeQuantityMap: buildCustomerTypeQuantityMap,
			currentPackageList: currentPackageList,
			currentHeader: currentHeader,
			currentFlowIsXFC: false,
			deconflictCustomerTypesById: deconflictCustomerTypesById,
			deconflictQuantity: deconflictQuantity,
			resetQuantities: resetQuantities,
			getTimeObject: getTimeObject,
			itemsForCart: itemsForCart,
			selectedDateStr: selectedDateStr,
			setKeywordAndInitPackages: setKeywordAndInitPackages,
			getPackageTimes: getPackageTimes,
			getAvailable: getAvailable,
			getConfiguration: UtilityFunctions.memoize(getConfiguration),
			getDeconflictCustomerTypeSetting: getDeconflictCustomerTypeSetting,
			shouldDeconflictTime: shouldDeconflictTime,
			getMaxQuantity: getMaxQuantity,
			overrideMinAndMaxQuantities: overrideMinAndMaxQuantities,
			includeNav: includeNav,
			setLastSelectedSlotDuration: setLastSelectedSlotDuration,
			getLastSelectedSlotDuration: getLastSelectedSlotDuration,
			cache: [],
			keyword: "",
			keywordList: [],
			availableAddons: [],
			selectedDate: undefined,
			packageLimit: 999,
			buttonlist: ['continue']
		};

		/**
		 * Gets the current package list
		 * @param {Boolean} xfc Denotes whether this is an XFC flow
		 * @returns {Array} The list of packages
		 */
		function currentPackageList(xfc) {
			var result = [];
			if (angular.isDefined(service.cache[service.keyword]) && !xfc) {
				result = service.cache[service.keyword].packages.map(function(pkg) {
					return angular.copy(pkg);
				});
				CustomActionService.executeCustomAction('filterPackageListBySelectedCustomerTypeGroups', result);
				CustomActionService.executeCustomAction('populateCustomerTypeQuantities', result);
			} else if (xfc) {
				result = service.availableAddons.map(function(pkg) {
					return angular.copy(pkg);
				});
			}

			return Utilities.orderByDisplayOrder(result);
		}

		/**
		 * Resets the quantities for the packages in the list back to 0
		 * @param {Array} packageList The list of packages
		 * @returns {undefined}
		 */
		function resetQuantities(packageList) {
			packageList.forEach(function(pkg) {
				pkg.CT.forEach(function(ct) {
					ct.qty = 0;
				});
			});
		}

		/**
		 * Returns header
		 * @param {String} packageId packageId
		 * @returns {String} header
		 */
		function currentHeader(packageId) {
			if (service.currentFlowIsXFC) {
				return Language.getLocale('CrossSellHList', 'header_' + packageId);
			} else if (angular.isDefined(service.cache[service.keyword])) {
				return service.cache[service.keyword].header;
			}
			return '';
		}

		/**
		 * Gets the last selected time slot duration
		 * @public
		 * @returns {Number} The duration for the time slot selected
		 */
		function getLastSelectedSlotDuration() {
			return this.lastSelectedSlotDuration;
		}

		/**
		 * Updates the last selected time slot duration
		 * @public
		 * @param {Number} time The duration for the time slot selected
		 * @returns {undefined}
		 */
		function setLastSelectedSlotDuration(time) {
			if (time) {
				this.lastSelectedSlotDuration = time;
			}
		}

		/**
		 * getPackagesList calculates the packages that can be shown to the user.
		 * It starts with the packages based on keyword, and then has to filter as follows:
		 *  1. Date-specific packages should only be included if a date has been chosen and they are available on that date
		 *  2. Packages should only be included for the appropriate customer groups. For example, if the user is only
		 *     interested in adult tickets, there's no reason to show kid-specific packages.
		 *
		 * After the filtering, the packages need to be sorted. If there's a maximum allowable number of packages, limit
		 * the list to being that length
		 */
		function getLastSelectedSlotDuration() {
			return this.lastSelectedSlotDuration;
		}

		/**
		 * Updates the last selected time slot duration
		 * @public
		 * @param {Number} time The duration for the time slot selected
		 * @returns {undefined}
		 */
		function setLastSelectedSlotDuration(time) {
			if (time) {
				this.lastSelectedSlotDuration = time;
			}
		}

		/**
		 * Calculates the packages to show the user.
		 * It starts with keyword-based packages, then filters them:
		 * 1. Include date-specific packages only if a date is chosen and they are available.
		 * 2. Include packages only for the relevant customer groups.
		 * After filtering, sort the packages and limit the list to the maximum allowable number.
		 * @returns {Promise} The deferred promise
		 */
		function getPackagesList() {
			var deferred = $q.defer(),
				dateStr = '',
				pkgsForDate = undefined;

			promiseChainer.packages = [];
			promiseChainer.datePackages = [];
			promiseChainer.timePackages = [];
			$rootScope.showSpinner(Language.getLocale('ApplicationLabels', 'gettingEventDates'));

			if (service.keyword) {
				// create and empty the cache for this keyword
				service.cache[service.keyword].packages = [];
				service.cache[service.keyword].selectedDate = service.selectedDate;
				// start with the list of packages, based on the keyword
				promiseChainer.packages = PackageList.getRequestListItems(service.keyword).packages;
			} else {
				deferred.resolve();
				return deferred.promise;
			}
			for (var i = 0; i < promiseChainer.packages.length; i++) {
				var currentPackage = promiseChainer.packages[i],
					hasEvent = Utilities.safelyCheckPropertyOnObject('currentPackage.E', currentPackage) && UtilsValidation.isRealObject(currentPackage.E[0]);
				currentPackage.needsDate = false;
				if (!hasEvent) {
					service.cache[service.keyword].packages.push(currentPackage);
					continue;
				}
				switch (currentPackage.E[0].date) {
				case '1':
					promiseChainer.timePackages.push(currentPackage);
					currentPackage.needsDate = true;
					break;

				case '2':
					promiseChainer.datePackages.push(currentPackage);
					currentPackage.needsDate = true;
					break;

				default:
					service.cache[service.keyword].packages.push(currentPackage);
				}
			}
			// if there's no selected date, do not include any date or time packages.
			if ((promiseChainer.datePackages.length < 1 && promiseChainer.timePackages.length < 1)
				|| !angular.isDefined(service.selectedDate)) {
				deferred.resolve();
				return deferred.promise;
			}

			// Use the promiseChainer to add the appropriate date and time packages.
			// First, handle the date packages. If there are date packages, call GetKeyWordCalendar and cycle
			// through the response, moving over the appropriate packages from datePackages to service.cache[keyword]
			if ((promiseChainer.datePackages.length > 0 || promiseChainer.timePackages.length > 0) && angular.isDefined(service.selectedDate)) {
				var reqObj = {
					end_date: service.selectedDateStr(),
					keyword: service.keyword,
					start_date: service.selectedDateStr()
				};
				AppData.fetch("GetKeywordCalendar", false, reqObj).then(
					function(data) {
						// mark the timepackages for deletion if they're not in the list
						if (promiseChainer.timePackages.length > 0) {
							promiseChainer.timePackages.forEach(function(tp) {
								tp.foundForDate = false;
							});
						}

						if (data.status == Enums.status.OK && Utilities.safelyCheckPropertyOnObject('data.DATES.D', data)) {
							// get the packages for the selected date from the keyword calendar
							dateStr = service.selectedDateStr();
							pkgsForDate = data.DATES.D.find(function(d) {
								return d.date === dateStr;
							});

							// add the matching packages from promiseChainer.datePackages
							if (angular.isDefined(pkgsForDate) && angular.isDefined(pkgsForDate.PS) && angular.isDefined(pkgsForDate.PS.P)) {
								for (var j = 0; j < pkgsForDate.PS.P.length; j++) {
									if (promiseChainer.datePackages.length > 0) {
										addMatchingPackage(pkgsForDate.PS.P[j]);
									}
									// mark any timePackages in pkgsForDate as found.
									markPackagesAsFound(promiseChainer.timePackages, pkgsForDate.PS.P[j]);
								}
							}
						} //... successfully acquired data from GetKeywordCalendar
						// Now strip out any timePackages that were not returned by the GetKeywordCalendar call
						if (promiseChainer.timePackages.length > 0) {
							for (var k = promiseChainer.timePackages.length - 1; k >= 0; k--) {
								if (!promiseChainer.timePackages[k].foundForDate) {
									promiseChainer.timePackages.splice(k, 1);
								}
							}
						}
						// Now add the time packages
						addTimePackages(deferred);
					});
			}
			return deferred.promise;
		}

		function markPackagesAsFound(timePackages, pkg) {
			var pkgId = pkg.id;
			if (timePackages.length < 1) {
				return;
			}
			timePackages.forEach(function(tp) {
				if (tp.id == pkgId) {
					tp.foundForDate = true;
					tp.event_id = pkg.event_id;
				}
			});
		}

		function addMatchingPackage(packageFromDateCall) {
			var newCTs = [],
				result = promiseChainer.datePackages.filter(function(p) {
					return (packageFromDateCall.id == p.id);
				})[0];

			if (angular.isUndefined(result) || angular.isUndefined(packageFromDateCall.CT) || angular.isUndefined(result.CT)) {
				return;
			}

			// If the package is returned as being available in the GetMerchantPackageEventDates,
			// there's no need to also check the event ID against the package selected. They have
			// the same ID.
			if (angular.isDefined(packageFromDateCall.event_id)) {
				result.event_id = packageFromDateCall.event_id;
			}

			// search through the CTs from the date package. Those are the only ones that we'll use.
			for (var i = 0; i < packageFromDateCall.CT.length; i++) {
				// get corresponding CT from package in package list
				var newCT = undefined;

				// start with the data from the package list
				for (var j = 0; j < result.CT.length && angular.isUndefined(newCT); j++) {
					if (packageFromDateCall.CT[i].id === result.CT[j].id) {
						newCT = angular.copy(result.CT[j]);
					}
				}

				// if this CT isn't in the package on the package list, ignore it.
				if (angular.isUndefined(newCT)) {
					continue;
				}

				// now grab info from the date package information
				if (angular.isDefined(packageFromDateCall.CT[i].retail_amount)) {
					newCT.retail_amount = packageFromDateCall.CT[i].retail_amount;
				}
				if (angular.isDefined(packageFromDateCall.CT[i].tax_amount)) {
					newCT.tax_amount = packageFromDateCall.CT[i].tax_amount;
				}
				if (angular.isDefined(packageFromDateCall.CT[i].gate_price)) {
					newCT.gate_price = packageFromDateCall.CT[i].gate_price;
				}

				// add the corrected CT to the list of new CTs
				newCTs.push(newCT);
			}

			// only add the package (and its new CTs) if one or more of the CTs is available.
			if (newCTs.length > 0) {
				result.CT = newCTs;
				service.cache[service.keyword].packages.push(result);
			}
		}

		function sortPackages() {
			if (angular.isUndefined(service.cache)
				|| !(service.keyword)
				|| angular.isUndefined(service.cache[service.keyword])
				|| angular.isUndefined(service.cache[service.keyword].packages)
				|| service.cache[service.keyword].packages.length < 1
			) {
				return;
			}
			removeExcludedPackages();
			service.cache[service.keyword].packages.sort(function(a, b) {
				if (angular.isDefined(a.display_order) && angular.isDefined(b.display_order)) {
					return forceInt(a.display_order) - forceInt(b.display_order);
				}
				return 0;
			});
		}

		function removeExcludedPackages() {
			for (var i = 0; i < service.cache[service.keyword].packages.length; i++) {
				var crossSell = service.cache[service.keyword].packages[i];
				if (Utilities.safelyCheckPropertyOnObject('crossSell.CHARACS.exclude_ct_group_id_for_cross_sell', crossSell)) {
					var excludeGroups = crossSell.CHARACS.exclude_ct_group_id_for_cross_sell.split(',');

					excludeGroups.forEach(function(excludeGrp) {
						if (excludeGrp === crossSell.CT[0].group_id) {
							service.cache[service.keyword].packages.splice(i, 1);
						}
					});
				}
			}
		}

		function getEventDates(timePackage) {
			var k;
			var
				defer = $q.defer(),
				reqObj = {
					P: [{
						CT: [],
						event_id: timePackage.event_id,
						id: timePackage.id.toString()
					}],
					customerType: '',
					extraMovie: '',
					startDate: service.selectedDateStr(),
					endDate: service.selectedDateStr(),
					minCapacity: 0,
					packageId: '',
					version: '2',
					identifyCustomerTypes: 1
				};

			// build CT Objects
			if (angular.isDefined(timePackage.CT)) {
				for (var j = 0; j < timePackage.CT.length; j++) {
					reqObj.P[0].CT.push({
						id: timePackage.CT[j].id,
						qty: Package.getCustomerTypeQtyById(timePackage.CT[j].id)
					});
				}
			}

			// build string of event IDs
			if (timePackage.E && !reqObj.P[0].event_id) {
				for (k = 0; k < timePackage.E.length && !reqObj.P[0].event_id; k++) {
					if (angular.isDefined(timePackage.E[k].id)) {
						reqObj.P[0].event_id = timePackage.E[k].id; // get the first one.
						timePackage.event_id = timePackage.E[k].id;
					}
				}
			}

			/****************
			 *  Data returned from GetMerchantPackageEventDates can have two very different structures.
			 *  1: If only a single package is found, the result has package_id on the root level (data.package_id)
			 *  2: If multiple packages are found, the result has package_id on the "D" level (data.D[].package_id)
			 *  Because we're passing a package ID to the API call, structure 2 is only returned when the package
			 *  we requested has aliases. In that case, we ignore the alias package IDs and use the original package ID.
			 *  We send that original package ID (and CTs) to the backend. They're taking care of the rest.
			 ******************/

			AppData.fetch('GetMerchantPackageEventDates', false, reqObj).then(
				function(data) {
					if (data.status == Enums.status.OK) {
						var selectedData = undefined;

						if (angular.isDefined(data.D)) {
							selectedData = data.D.filter(function(d) {
								return (d.date == service.selectedDateStr());
							})[0];
						}

						if (angular.isDefined(selectedData)) {
							timePackage.T = angular.copy(selectedData.T);
							// make sure that T is an array
							Utilities.arrayWrap(timePackage, "T");
							timePackage.selectedTime = undefined;
							service.cache[service.keyword].packages.push(timePackage);
						}
					}
					// want to resolve regardless of whether the call is successful.
					defer.resolve();
				});

			return defer.promise;
		}

		/**
		 * chainThosePromises recursively calls itself to call getEventDates on the timePackages list.
		*/
		function chainThosePromises(idx) {
			var thisOne = $q.defer();

			// if the chain is empty, just resolve and return
			if (idx < 0) {
				thisOne.resolve();
				return thisOne.promise;
			}
			// pop off the last one


			// resolve the previous chain, and then do this one.
			chainThosePromises(idx - 1).then(function(data) {
				getEventDates(promiseChainer.timePackages[idx]).then(function(presult) {
					thisOne.resolve();
				})
			});
			return thisOne.promise;
		}

		/**
		 * addTimePackages calls GetMerchantPackageEventDates for each time-based package
		 * to calculate which ones have time slots available.
		 **/
		function addTimePackages(requester) {
			if (angular.isUndefined(promiseChainer.timePackages) || (promiseChainer.timePackages.length < 1) || angular.isUndefined(service.selectedDate)) {
				requester.resolve();
				return;
			}
			chainThosePromises(promiseChainer.timePackages.length - 1).then(function(results) {
				requester.resolve();
			});
		}

		function getAvailable(pkg, ct) {
			var result = undefined,
				t_max = 0;

			if (!isObject(ct) || !isObject(pkg)) {
				return;
			}
			// lots of isDefineds here... These packages have a very flexible structure.
			if (angular.isDefined(ct.max_available) && angular.isDefined(pkg.max_available)) {
				result = (forceInt(ct.max_available) > forceInt(pkg.max_available)) ? forceInt(ct.max_available) : forceInt(pkg.max_available);
			} else if (angular.isDefined(ct.max_available)) {
				result = forceInt(ct.max_available);
			} else if (angular.isDefined(pkg.max_available)) {
				result = forceInt(pkg.max_available);
			}

			if (angular.isDefined(pkg.T) && angular.isDefined(pkg.selectedTime)
				&& angular.isDefined(pkg.T[pkg.selectedTime])
				&& angular.isDefined(pkg.T[pkg.selectedTime].available)) {
				t_max = forceInt(pkg.T[pkg.selectedTime].available);
				if (result == undefined || result < t_max) {
					result = t_max;
				}
			}
			return result;
		}

		/**
		 * Returns the times available for a package.
		 * @param {Object} pkg The current package to get times for
		 * @returns {Object[]} the times array
		 */
		function getPackageTimes(pkg) {
			// drop out if there are no times
			if (!validArray(pkg.T)) {
				return [];
			}

			return pkg.T.reduce(function(acc, originalTime) {
				var time = angular.copy(originalTime),
					configuredTime = angular.copy(time);

				configuredTime.packageId = pkg.id;
				acc.push(configuredTime);

				return acc;
			}, [])
		}

		/**
		 * Get the selected date in a string format of YYYY-MM-DD
		 * @public
		 * @returns {String} selected date in YYYY-MM-DD format
		 */
		function selectedDateStr() {
			if (angular.isUndefined(service.selectedDate)) {
				return '';
			}
			var selectedMonth = String(service.selectedDate.getMonth() + 1),
				selectedDay = String(service.selectedDate.getDate()),
				dateString = String(service.selectedDate.getFullYear());

			dateString += (selectedMonth.length == 1) ? '-0' + selectedMonth : '-' + selectedMonth;
			dateString += (selectedDay.length == 1) ? '-0' + selectedDay : '-' + selectedDay;
			return dateString;
		}

		function calculatedHeader() {
			var target = service.keyword.replace(/ /g, ""),
				result = Language.getLocale('FormLabels', target + '_header');
			return (result) ? result : service.keyword;
		}

		function itemsForCart(pkgs) {
			var ct = {},
				pkg = {},
				$filterDate = $filter('date'),
				result = {
					packages: [],
					items: [],
					errorMessage: '',
					addItemsError: false,
					qtyMaxError: false
				},
				selectTimeSlot = Language.getLocale('ErrorMessages', 'selectTimeSlot'),
				hasQuantity,
				i = 0;

			for (; i < pkgs.length && result.errorMessage === ''; i++) {
				pkg = pkgs[i];

				var max_quantity = angular.isDefined(pkg.max_quantity) ? forceInt(pkg.max_quantity) : 0,
					min_quantity = angular.isDefined(pkg.min_quantity) ? forceInt(pkg.min_quantity) : 0,
					max_available = getAvailable(pkg, pkg.CT[0]),
					characs = [],
					package_added = false,
					pkg_event_id = pkgs[i].event_id || Utilities.safelyCheckPropertyOnObject('pkg.E.0.id', pkgs[i], 'returnValue'),
					newCharac = {
						keyword_used: service.keyword,
						shop_rate_name: pkgs[i].name
					};

				if (angular.isDefined(pkg_event_id)) {
					newCharac.event_id = pkg_event_id;
				}
				if (angular.isDefined(pkg.T)) {
					hasQuantity = pkg.CT.find(function(ct) {
						return ct.qty && forceInt(ct.qty) > 0;
					});
					if (angular.isDefined(pkg.selectedTime)) {
						pkg.selectedTime = forceInt(pkg.selectedTime); // just to be on the safe side.
						if (pkg.selectedTime > -1 && pkg.selectedTime < pkg.T.length) {
							newCharac.start_date = service.selectedDateStr();
							newCharac.start_time = pkg.T[pkg.selectedTime].time;
							newCharac.start_time_display = $filterDate(service.getTimeObject(pkg.T[pkg.selectedTime].time), 'shortTime');
						} else {
							result.errorMessage = selectTimeSlot;
							result.addItemsError = true;
							return result;
						}
					} else if (hasQuantity) {
						result.errorMessage = selectTimeSlot;
						result.addItemsError = true;
						return result;
					}
				} else if (pkg.needsDate) {
					if (angular.isDefined(service.selectedDate)) {
						newCharac.start_date = service.selectedDateStr();
					} else {
						result.errorMessage = Language.getLocale('ErrorMessages', 'selectDate');
						result.addItemsError = true;
						return result;
					}
				}

				if ((max_available > -1) && (max_quantity > max_available)) {
					max_quantity = max_available;
				}

				for (var j = 0; j < pkgs[i].CT.length && result.errorMessage == ''; j++) {
					characs = [];
					ct = pkgs[i].CT[j];

					if (ct.qty > max_quantity) {
						// drop out of the loop, we've used up all the packages we're allowed to buy.
						result.qtyMaxError = true;
						result.errorMessage = Language.getLocale('Alert', 'maxQtyMsg');
						return result;
					}
					if (max_quantity < 1) {
						// drop out of the loop, we've used up all the packages we're allowed to buy.
						break;
					}
					if (ct.qty < min_quantity || ct.qty < 1) {
						continue;
					}

					max_quantity = max_quantity - ct.qty;

					// The charac array has one charac for each ticket ordered.
					for (var k = 0; k < ct.qty; k++) {
						characs.push(newCharac);
					}
					// Minimum of what needs to be added to the cart
					result.items.push(
						{
							qty: ct.qty,
							name: pkg.name || '',
							package_id: pkg.id,
							customer_type: ct.id,
							client_rate_name: ct.name,
							cusTypeName: ct.name, // cart.js: setItemsToBeAdded overrides client_rate_name with cusTypeName.
							CHARACS: angular.copy(characs),
							cart_limit_override: angular.isDefined(pkg.cart_limit_override) ? pkg.cart_limit_override : ''
						}
					);
					if (!package_added) {
						result.packages.push(pkg);
						package_added = true;
					}
				} //... looping through CTs
			} //... looping through packages
			if (result.items.length < 1 && result.errorMessage == '') {
				result.addItemsError = true;
				result.errorMessage = Language.getLocale('ErrorMessages', 'noItemsSelected');
			}
			return result;
		}

		function populateDataFromWizard() {
			var stepSettings = CustomActionService.executeCustomAction('getCurrentStepSettings');
			if (angular.isObject(stepSettings) && angular.isDefined(stepSettings.buttonList)) {
				service.buttonlist = stepSettings.buttonList;
			}
			service.selectedDate = CustomActionService.executeCustomAction('getSelectedDate');
			return stepSettings;
		}

		/**
		 * Check if button is in button list
		 * @param {String} btn button
		 * @returns {Boolean} true/false
		 */
		function includeNav(btn) {
			return service.buttonlist.indexOf(btn) > -1;
		}

		/**
		 * Initialize Extras/ Addons
		 * @param {Object} stateParams stateParams
		 * @param {String} headerOverride headerOverride
		 * @param {Number} packageLimit package limit
		 * @param {Array} buttonlist buttton list
		 * @param {Boolean} xfc xfc
		 * @returns {Boolean} true/false
		 */
		function initialize(stateParams, headerOverride, packageLimit, buttonlist, xfc) {
			if (angular.isDefined(packageLimit)) {
				service.packageLimit = packageLimit;
			}
			service.selectedDate = undefined;

			if (!xfc) {
				service.keyword = stateParams.keyword;
				service.currentFlowIsXFC = false;

				if (angular.isDefined(buttonlist)) {
					service.buttonlist = buttonlist;
				}

				var stepSettings = populateDataFromWizard();
				if (angular.isObject(stepSettings) && angular.isDefined(stepSettings.headingLocale)) {
					headerOverride = Language.getLocale('FormLabels', stepSettings.headingLocale);
				}

				// set the keyword's header in the cache.
				if (angular.isUndefined(service.cache[service.keyword])) {
					service.cache[service.keyword] = {
						header: (headerOverride) ? headerOverride : calculatedHeader(),
						packages: []
					};
				}

				if (service.cache[service.keyword].packages.length < 1 || service.cache[service.keyword].selectedDate != service.selectedDate) {
					return getPackagesList().then(function(data) {
						sortPackages();
					});
				}
			} else if (xfc) {
				service.currentFlowIsXFC = true;
				if (validArray(buttonlist)) {
					service.buttonlist = buttonlist;
				}
				return buildKeywordListAndFetchAddons();
			}

			return true;
		}

		/**
		 * If this is in XFC mode, we need to build a promise chain based off all the keywords and fetch the data
		 * @protected
		 * @return {Promise} A Promise to resolve all the keyword calls
		 */
		function buildKeywordListAndFetchAddons() {
			var keywordPromise;
			service.availableAddons.length = 0;

			if (Utilities.safelyCheckPropertyOnObject('Package.packageDetails.CHARACS.addonKeywords', Package, validString)) {
				service.keywordList = Package.packageDetails.CHARACS.addonKeywords.split(',');
				service.selectedDate = CustomActionService.executeCustomAction('getSelectedDateForAddons');
			}

			service.keywordList.forEach(function(keyword) {
				if (!keywordPromise) {
					service.setKeywordAndInitPackages(keyword);
					keywordPromise = getPackagesList();
				} else {
					keywordPromise.then(function() {
						service.setKeywordAndInitPackages(keyword);
						// Always return the new promise so the next one will wait since we can't call multiple get
						// keyword calendars at once
						return getPackagesList();
					});
				}
			});

			keywordPromise
				.finally(function() {
					// finally, add them all to the available addons
					service.keywordList.forEach(function(keyword) {
						service.availableAddons = service.availableAddons.concat(service.cache[keyword].packages);
					});
				});

			return keywordPromise;
		}

		/**
		 * Set keyword and initialize packages for that keyword
		 * @public
		 * @param {String} keyword keyword
		 * @returns {undefined}
		 */
		function setKeywordAndInitPackages(keyword) {
			service.keyword = keyword;
			if (!UtilsValidation.isRealObject(service.cache[service.keyword])) {
				service.cache[service.keyword] = { packages: [] };
			}
		}

		/**
		 * Returns the configuration settings for the XFC
		 * @returns {Object} The settings to use
		 */
		function getConfiguration() {
			return JSONValidator.validate('crosssell_choice_deconflict', AppData.settings.crosssell_choice_deconflict)
				? JSON.parse(AppData.settings.crosssell_choice_deconflict)
				: {};
		}

		/**
		 * Returns the deconflict setting.
		 * @param {Object} pkg The package to use
		 * @returns {String} the setting
		 */
		function getDeconflictCustomerTypeSetting(pkg) {
			var packageSetting = Utilities.safelyCheckPropertyOnObject('pkg.CHARACS.crosssell_choice_deconflict_by_ct', pkg, Utilities.returnValue);
			var configuration = service.getConfiguration();

			if (validString(packageSetting)) {
				return packageSetting;
			} else if (validString(configuration.customer_types)) {
				return configuration.customer_types;
			}
			return '';
		}

		/**
		 * Returns the deconflict setting for times.
		 * @param {Object} pkg The package to use
		 * @returns {Boolean} the setting
		 */
		function shouldDeconflictTime(pkg) {
			var packageSetting = Utilities.safelyCheckPropertyOnObject('pkg.CHARACS.crosssell_choice_deconflict_by_time', pkg, Utilities.returnValue),
				configuration = service.getConfiguration();

			if (validString(packageSetting)) {
				return Utilities.getBoolean(packageSetting);
			} else if (UtilsValidation.isBoolean(configuration.times)) {
				return configuration.times;
			}

			return false;
		}

		/**
		 * Overrides the min and max quantity if we have it configured to do so.
		 * @param {Object[]} itemsToBeAdded The array of items. This is passed when we're in XFC mode.
		 * @param {Object[]} packagelist The package list to display
		 * @param {String} basePackageId The base package id
		 * @returns {undefined}
		 */
		function overrideMinAndMaxQuantities(itemsToBeAdded, packagelist, basePackageId) {
			var customerTypeQtyMap = service.buildCustomerTypeQuantityMap(itemsToBeAdded, basePackageId),
				maxQuantity = service.getMaxQuantity(itemsToBeAdded, basePackageId)

			if (maxQuantity <= 0 || !UtilsValidation.isRealObject(customerTypeQtyMap)) {
				return;
			}

			packagelist.forEach(function(pkg, i) {
				pkg.deconflictCustomerTypesBy = service.getDeconflictCustomerTypeSetting(pkg);

				/**
				 * Case 1:
				 * Setting: "customer_id"
				 * Description: Only show customer types that they previously selected and set the max quantity to
				 * however many they previously chose.
				 * If all customer ids don't match the base package customer types, swap to using 'quantity' setting.
				 */
				if (pkg.deconflictCustomerTypesBy === DECONFLICT_BY_CUSTOMER_ID) {
					service.deconflictCustomerTypesById(pkg, customerTypeQtyMap);
				}

				/**
				 * Case 2:
				 * Setting: "customer_id"
				 * Description: Show all customer types, but they can only choose a max quantity of however many customer
				 * types they chose on the main package.
				 */
				if (pkg.deconflictCustomerTypesBy === DECONFLICT_BY_QUANTITY && maxQuantity > 0) {
					service.deconflictQuantity(pkg, maxQuantity);
				}
			});
		}

		/**
		 * Builds the customer type quantity map
		 * @param {Object[]} itemsToBeAdded The items to be added to the cart if we're in an XFC
		 * @param {String} [basePackageId] The base package id if we're in an XFC
		 * @returns {Object} A map of customer ids and their quantities
		 */
		function buildCustomerTypeQuantityMap(itemsToBeAdded, basePackageId) {
			var pkg;

			// Are we in an XFC?
			if (validArray(itemsToBeAdded)) {
				// Find all the items in the items to be added to the cart that match the current package id
				samePackageItems = itemsToBeAdded.filter(function(pkg) {
					return pkg.package_id === basePackageId;
				});

				if (!samePackageItems.length) {
					return null;
				}

				pkg = Package.getPackageByID(basePackageId);
				if (!pkg) {
					return null;
				}

				return pkg.CT.reduce(function(acc, ct) {
					acc[ct.id] = samePackageItems.reduce(function(total, item) {
						if (item.customer_type === ct.id) {
							return total + item.qty;
						}
						return total;
					}, 0);

					return acc;
				}, {});
				// Are we in the recommender wizard?
			} else if (RecommenderWizardService.wizardHasPackages()) {
				return RecommenderWizardService.contextData.customerTypeGroupList.reduce(function(acc, ct) {
					acc[ct.id] = ct.qty;
					return acc;
				}, {});
			}
			// Bye, Felicia!
			return null;
		}

		/**
		 * Returns the max number of customer types to use
		 * @param {Object[]} itemsToBeAdded The items to be added to the cart if we're in an XFC
		 * @param {String|undefined} basePackageId The base package id if we're in an XFC
		 * @returns {Number} A map of customer ids and their quantities
		 */
		function getMaxQuantity(itemsToBeAdded, basePackageId) {
			var samePackageItems;

			// Are we in an XFC?
			if (validArray(itemsToBeAdded)) {
				samePackageItems = itemsToBeAdded.filter(function(pkg) {
					return pkg.package_id === basePackageId;
				});

				if (!samePackageItems.length) {
					return 0;
				}

				// get the total
				return samePackageItems.reduce(function(qty, pkg) {
					return qty + pkg.qty;
				}, 0);

				// Are we in the recommender wizard?
			} else if (RecommenderWizardService.wizardHasPackages()) {
				return RecommenderWizardContextService.getSelectedCustomerTypeGroupsTotalQty();
			}

			// Bye, Felicia!
			return 0;
		}

		/**
		 * Overrides the max quantity to the total number of customer types added on the base package.
		 * @param {Object} pkg The package object to modify.
		 * @param {Number} maxQuantity The max quantity of customer types a user can add for the package.
		 * @returns {undefined}
		 */
		function deconflictQuantity(pkg, maxQuantity) {
			if (pkg.max_quantity >= maxQuantity) {
				pkg.max_quantity = maxQuantity;
			}

			if (pkg.hasOwnProperty('min_quantity') && pkg.min_quantity > maxQuantity) {
				pkg.min_quantity = maxQuantity;
			}
		}

		/**
		 * Adds min/max quantity per customer types.
		 * @param {Object} pkg The package object to modify
		 * @param {Object} customerTypeQtyMap The quantity of customer types per id on the base package
		 * @returns {undefined}
		 */
		function deconflictCustomerTypesById(pkg, customerTypeQtyMap) {
			var matchingCustomerTypesWithQuantity,
				allCustomerTypesMatch;

			pkg.CT = Array.isArray(pkg.CT) ? pkg.CT : [pkg.CT];

			matchingCustomerTypesWithQuantity = pkg.CT.filter(function(ct) {
				return customerTypeQtyMap.hasOwnProperty(ct.id) && customerTypeQtyMap[ct.id] > 0;
			});
			allCustomerTypesMatch = pkg.CT.every(function(ct) {
				return customerTypeQtyMap.hasOwnProperty(ct.id);
			});

			/**
			 * If all customer type ids match the base package, then only show the one's which have quantities.
			 */
			if (allCustomerTypesMatch && matchingCustomerTypesWithQuantity.length) {
				pkg.CT = matchingCustomerTypesWithQuantity;
				pkg.CT.forEach(function(ct) {
					if (!ct.hasOwnProperty('max_quantity') || ct.max_quantity > customerTypeQtyMap[ct.id]) {
						ct.max_quantity = customerTypeQtyMap[ct.id];
					}
					if (ct.hasOwnProperty('min_quantity') && ct.max_quantity < ct.min_quantity) {
						ct.min_quantity = ct.max_quantity;
					}
				});
				/**
				 * If all customer types don't match the base package customer types or we don't have any matching customer types with quantity
				 * we need to set it to setting 'quantity'.
				 */
			} else {
				pkg.deconflictCustomerTypesBy = DECONFLICT_BY_QUANTITY;
			}
		}

		/**
		 * Return a date object with the set hours based off of a time in military format.
		 * @protected
		 * @function
		 * @name getTimeObject
		 * @param {String} time In format HH:MM
		 * @return {Date} a new date object with the time set
		 */
		function getTimeObject(time) {
			var timeObj = new Date(),
				timeParts = time.split(' '),
				amPM = timeParts[1],
				// This gives us [hours, mins]
				timeArr = timeParts[0]
					.split(':')
					.map(Utilities.forceInt);

			// Swap to 24 hours
			if (validString(amPM)) {
				if (amPM.toLowerCase() === 'pm' && timeArr[0] < 12) {
					timeArr[0] += 12;
				} else if (amPM.toLowerCase() === 'am' && timeArr[0] === 12) {
					timeArr[0] = 0;
				}
			}

			// Seconds
			timeArr.push(0);
			// Milliseconds
			timeArr.push(0);

			timeObj.setHours.apply(timeObj, timeArr);

			return timeObj;
		}

		return service;
	});

/**
 * Created by jwroblewski on 12/7/2015.
 */
angular
	.module('guest-options', ['app'])
	.config(function($locationProvider, $stateProvider) {
		$stateProvider
			.state('guestOptions', {
				url: '/guestOptions/:recommenderWizardKeyword',
				templateUrl: '/scripts/modules/guest-options/views/guest-options.html',
				controller: 'GuestOptionsController',
				resolve: {
					initialData: function(Bootstrap) {
						return Bootstrap.bootstrapApplication();
					},
					loadAssets: function(initialData, $rootScope, Utilities) {
						return Utilities.cacheBustAndLazyLoad([
							'/scripts/modules/guest-options/styles/guest-options.css'
						]);
					},
					recommenderWizard: function(loadAssets, $transition$, initialData, RecommenderWizardContextService) {
						if (RecommenderWizardContextService.bootstrapWizard($transition$.params().recommenderWizardKeyword, 'guestOptions')) {
							RecommenderWizardContextService.registerGuestOptions();
						}
					},
					guestOptionsData: function(recommenderWizard, GuestOptionsService, CustomActionService) {
						GuestOptionsService.createGuestOptionsDataModel();
						GuestOptionsService.configureGuestOptions(CustomActionService.executeCustomAction('getCurrentStepSettings'));
					}
				}
			});
	})
	.run(function(ExtraFlow, Enums) {
		ExtraFlow.registerXMC('GuestOptionsModule', {
			name: 'GuestOptionsModule',
			view: Enums.extraFlowRoutes.GUESTOPTIONS,
			doEditMode: false,
			lockQuantity: true,
			writeSingleCharac: false,
			enabled: true,
			type: 'alternateFlowModule'
		});
	});

/**
 * Created by jwroblewski on 12/30/2015.
 */
angular.module('guest-options').service
('GuestOptionsModels',
	function() {
		function GuestOptions() {
			this.visitType = undefined;
			this.visitTypeSelectList = [];
			this.customerTypeGroupList = [];
			this.isMilitary = false;
			this.wizardKeyword = '';
			this.zip = '';
		}
		this.GuestOptions = GuestOptions;
	});

/**
 * Created by jwroblewski on 12/2/2015.
 */
angular
	.module('guest-options')
	.controller('GuestOptionsController',
		function(
			$rootScope,
			$scope,
			CustomActionService,
			GuestOptionsEnumsService,
			GuestOptionsService,
			Language,
			Modal,
			Utilities,
			UtilsValidation
		) {
			var config = {},
				forceInt = Utilities.forceInt,
				safelyCheckPropertyOnObject = Utilities.safelyCheckPropertyOnObject,
				validArray = UtilsValidation.validArray;

			$scope.localeSection = GuestOptionsEnumsService.localeSection;
			$scope.formData = angular.copy(GuestOptionsService.guestOptionsData);
			$scope.merchantName = GuestOptionsService.guestOptionsConfig.merchantName;
			$scope.merchantNameTextColor = '';
			$scope.showMerchantName = false;
			$scope.showNumberOfGuests = true;
			$scope.showAdultQty = true;
			$scope.showChildQty = true;
			$scope.showMilitary = true;
			$scope.showZip = true;
			$scope.showBackgroundImageView = false;

			enableMerchantName();
			configureGuestOptions();
			toggleAdditionalGuestOptions($scope.formData.visitType);

			/**
			 * Splits the NumberOfVisitsHeader locale into two parts if @@merchantName is included in the locale.
			 * This is so the view can display the merchant name with a different style from the rest of the text.
			 * @returns {undefined}
			 */
			function enableMerchantName() {
				var numberOfVisitsHeader = Language.getLocale($scope.localeSection, 'NumberOfVisitsHeader') || '';
				var merchantNamePosition = numberOfVisitsHeader.indexOf('@@merchantName');

				if (merchantNamePosition != -1) {
					$scope.showMerchantName = true;
				}
			}

			function configureGuestOptions() {
				config = GuestOptionsService.guestOptionsConfig;

				if (safelyCheckPropertyOnObject('config.settings', config)) {
					$scope.visitType = 0;
					$scope.showAdultQty = config.settings.showAdultQty;
					$scope.showChildQty = config.settings.showChildQty;
					$scope.showZip = config.settings.showZip;
					$scope.bannerImagePath = config.assetUrl + config.settings.bannerImageFolder;
					$scope.bannerImageDesktop = config.settings.bannerImageDesktop;
					$scope.bannerImageMobile = config.settings.bannerImageMobile;
					$scope.bannerImageDesktopAlt = config.settings.bannerImageDesktopAlt;
					$scope.bannerImageMobileAlt = config.settings.bannerImageMobileAlt;
					$scope.merchantNameTextColor = config.settings.merchantNameTextColor;
					$scope.showBackgroundImageView = angular.isDefined(config.settings.backgroundImage) && (angular.isUndefined(config.settings.bannerImageDesktop) && angular.isUndefined(config.settings.bannerImageMobile));
				}

				if ($scope.showBackgroundImageView) {
					$rootScope.bgImageUrl = { 'background-image': 'url(' + $rootScope.getAssetUrl(config.settings.backgroundImage) + ')' };
				}

				preselectGuestOptions();
			}

			function submitForm() {
				resetHiddenGuestOptions();
				GuestOptionsService.persistGuestOptionsData($scope.formData);

				var customActionResult = CustomActionService.executeCustomAction('routeToNextStep');

				// If no custom action is defined, use default behavior
				if (!customActionResult) {
					$rootScope.routeTo('/', undefined, undefined, false);
				}
			}

			/**
			 * show/hide additional guest options based on the type of visit
			 * @param {Number} visitType the enum value of the selected type of visit
			 * @returns {undefined}
			 */
			function toggleAdditionalGuestOptions(visitType) {
				$scope.formData.visitType = visitType;
				if (safelyCheckPropertyOnObject('config.settings', config)) {
					// Set the number of guests based on config setting and visit type
					var numberOfGuestsVisitTypes = config.settings.showNumberOfGuestsVisitTypes.split(',');

					$scope.showNumberOfGuests = numberOfGuestsVisitTypes.some(function(item) {
						return item == visitType;
					});

					// Set military based on config setting and visit type
					var militaryVisitTypes = config.settings.showMilitaryVisitTypes.split(',');
					$scope.showMilitary = militaryVisitTypes.some(function(item) {
						return item == visitType;
					});

					// Set zip based on config setting and visit type
					var zipVisitTypes = config.settings.showZipVisitTypes.split(',');
					$scope.showZip = zipVisitTypes.some(function(item) {
						return item == visitType;
					});
				}

				resetHiddenGuestOptions();
			}

			function resetHiddenGuestOptions() {
				if (!$scope.showNumberOfGuests && !$scope.showBackgroundImageView) {
					$scope.formData.customerTypeGroupList.forEach(function(ctGroup) {
						ctGroup.qty = 0;
					});

					preselectGuestOptions(true);
				}

				if (!$scope.showMilitary) {
					$scope.formData.isMilitary = false;
				}

				if (!$scope.showZip) {
					$scope.formData.zip = '';
				}
			}

			/**
			 * Preselect the default guest options based on visit type or customer type group
			 * list which will be visible in the UI as a radio button or quantity input field.
			 *
			 * This is configurable in the guest_options JSON config. Available configs
			 * are preselectCustomerTypeGroupListGroupId, preselectCustomerTypeGroupListQty,
			 * and preselectVisitTypeSelectValue.
			 * @param {Boolean} onlySetCustomerTypeGroup - Will only set customer type group quantity
			 * @returns {undefined}
			 */
			function preselectGuestOptions(onlySetCustomerTypeGroup) {
				var hasPreselected;

				if (!UtilsValidation.isRealObject($scope.formData)) {
					return;
				}

				if (!onlySetCustomerTypeGroup && validArray($scope.formData.visitTypeSelectList)) {
					$scope.formData.visitType = forceInt(config.settings.preselectVisitTypeSelectValue) || $scope.formData.visitTypeSelectList[0].value;
				}

				if (validArray($scope.formData.customerTypeGroupList)) {
					hasPreselected = $scope.formData.customerTypeGroupList.find(function(group) {
						return group.qty > 0;
					});

					if (hasPreselected) {
						return;
					}

					var ctgListIndexFound = $scope.formData.customerTypeGroupList.findIndex(function(ctg) {
						return ctg.groupId === forceInt(config.settings.preselectCustomerTypeGroupListGroupId)
					});
					var ctgListIndex = ctgListIndexFound !== -1 ? ctgListIndexFound : 0;

					$scope.formData.customerTypeGroupList[ctgListIndex].qty = forceInt(config.settings.preselectCustomerTypeGroupListQty) || 0;
				}
			}

			$scope.visitTypeChange = function(visitType) {
				toggleAdditionalGuestOptions(visitType);
			};

			$scope.showMilitaryModal = function() {
				Modal.displayModal({
					category: 'Upgrade',
					action: 'View',
					label: Language.getLocale($scope.localeSection, 'MilitaryModalTitle'),
					title: Language.getLocale($scope.localeSection, 'MilitaryModalTitle'),
					description: Language.getLocale($scope.localeSection, 'MilitaryModalDescription'),
					showCloseButton: true,
					hideAllButtons: false
				});
			};

			$scope.incrementCounter = function(customerTypeGroup) {
				customerTypeGroup.qty++;
			};

			$scope.decrementCounter = function(customerTypeGroup) {
				customerTypeGroup.qty--;

				// Do not allow negative numbers
				if (customerTypeGroup.qty < 0) {
					customerTypeGroup.qty = 0;
				}
			};

			/**
             * check for qty change and if it is greater than the max value then update it to max value
             * @public
             * @param {Object} customerTypeGroup customer type object
             * @returns {undefined}
             */
			$scope.checkAndUpdateMaxQty = function(customerTypeGroup) {
				customerTypeGroup.qty = String(customerTypeGroup.qty).replace(/\D/g, '');
				customerTypeGroup.qty = Number(customerTypeGroup.qty);
				if (customerTypeGroup.qty > customerTypeGroup.maxQty) {
					customerTypeGroup.qty = customerTypeGroup.maxQty;
				}
			};

			$scope.disableMinusBtn = function(customerTypeGroup) {
				return (forceInt(customerTypeGroup.qty) <= customerTypeGroup.minQty);
			};

			$scope.disablePlusBtn = function(customerTypeGroup) {
				return (forceInt(customerTypeGroup.qty) >= customerTypeGroup.maxQty);
			};


			// Navigation Buttons
			$scope.showPreviousStep = CustomActionService.executeCustomAction('enablePreviousButton');
			$scope.showNextStep = CustomActionService.executeCustomAction('enableNextButton');
			$scope.nextStep = function() {
				var qtyValidation = GuestOptionsService.validateQuantities($scope.showNumberOfGuests, $scope.formData, $scope.showBackgroundImageView),
					maxGuests = safelyCheckPropertyOnObject('GuestOptionsService.guestOptionsConfig.settings.maximumGuestCount', GuestOptionsService) ? GuestOptionsService.guestOptionsConfig.settings.maximumGuestCount : '',
					guestsRequested = GuestOptionsService.totalNumberOfGuestsRequested($scope.formData),
					maxReplacements = [maxGuests, guestsRequested],
					maxReplacementNames = ['@@maxQty', '@@qty'];


				$scope.formData.submitted = true;


				if (qtyValidation < 0) {
					Modal.displayModal({
						category: 'GuestOptionsQuantity',
						action: 'View',
						label: Language.getLocale($scope.localeSection, 'MinimumQuantityModalTitle'),
						title: Language.getLocale($scope.localeSection, 'MinimumQuantityModalTitle'),
						description: Language.getLocale($scope.localeSection, 'MinimumQuantityModalDescription'),
						showCloseButton: true,
						hideAllButtons: false
					});
					return false;
				} else if (qtyValidation > 0) {
					Modal.displayModal({
						category: 'GuestOptionsQuantity',
						action: 'View',
						label: Language.replaceAllMultiple(maxReplacementNames, maxReplacements, Language.getLocale($scope.localeSection, 'MaximumQuantityModalTitle')),
						title: Language.replaceAllMultiple(maxReplacementNames, maxReplacements, Language.getLocale($scope.localeSection, 'MaximumQuantityModalTitle')),
						description: Language.replaceAllMultiple(maxReplacementNames, maxReplacements, Language.getLocale($scope.localeSection, 'MaximumQuantityModalDescription')),
						showCloseButton: true,
						hideAllButtons: false
					});
					return false;
				}

				if ((angular.isDefined($scope.theForm) && $scope.theForm.$valid) || (angular.isDefined(this.theForm) && this.theForm.$valid)) {
					submitForm();
				}
			};

			$scope.previousStep = function() {
				CustomActionService.executeCustomAction('routeToPreviousStep');
			};
		}
	);

/**
 * Created by jwroblewski on 1/4/2016.
 */
angular.module('guest-options')
	.factory('GuestOptionsEnumsService', function() {
		return {
			localeSection: 'GuestOptions',
			minQtyTitle: 'MinimumQuantityModalTitle',
			minQtyDesc: 'MinimumQuantityModalDescription'
		};
	});

/**
 * Created by jwroblewski on 12/31/2015.
 */
angular.module('guest-options').factory('GuestOptionsService',
	function(
		$rootScope,
		AppData,
		Utilities,
		CustomActionService,
		GuestOptionsModels,
		JSONValidator
	) {
		var service = {
			createGuestOptionsDataModel: createGuestOptionsDataModel,
			guestOptionsData: {},
			guestOptionsConfig: {},
			persistGuestOptionsData: persistGuestOptionsData,
			configureGuestOptions: configureGuestOptions,
			validateQuantities: validateQuantities,
			totalNumberOfGuestsRequested: totalNumberOfGuestsRequested
		};

		/**
		 * Creates the Guest Options model.
		 * @public
		 * @function
		 * @memberof {GuestOptionsService}
		 * @return {undefined}
		 */
		function createGuestOptionsDataModel() {
			service.guestOptionsData = new GuestOptionsModels.GuestOptions();
			// populate wizard data
			CustomActionService.executeCustomAction('populateContextData', service.guestOptionsData);
		}

		/**
		 * Persists the guest options model to local storage.
		 * @public
		 * @function
		 * @param {Object} formData Our form data
		 * @memberof {GuestOptionsService}
		 * @return {undefined}
		 */
		function persistGuestOptionsData(formData) {
			mapFormData(formData);
			CustomActionService.executeCustomAction('updateContextData', service.guestOptionsData);
		}

		/**
		 * validateQuantites returns a 0 if everything is okay, -1 if the quantities are too low, and +1 if the quantities are too high.
		 * @public
		 * @function
		 * @memberof {GuestOptionsService}
		 * @param {Boolean} showNumberOfGuests Show number of guests
		 * @param {Object} formData Our form data object
		 * @param {Boolean} showBackgroundImageView flag to ignore showNumberOfGuestsif background view is active
		 * @returns {Number} Returns the number
		 **/
		function validateQuantities(showNumberOfGuests, formData, showBackgroundImageView) {
			// If the number of guests is not showing do not do any validation on the qty.
			if (!showNumberOfGuests && !showBackgroundImageView) {
				return 0;
			}

			var totalQty = service.totalNumberOfGuestsRequested(formData),
				settingsMax = Utilities.forceInt(service.guestOptionsConfig.settings.maximumGuestCount);

			if (totalQty < 1) {
				return -1;
			}
			if (settingsMax > 0 && totalQty > settingsMax) {
				return 1;
			}

			return 0;

		}

		/**
		 * Returns the total number of guests requested.
		 * @public
		 * @function
		 * @memberof {GuestOptionsService}
		 * @param {Object} formData Our form data
		 * @return {Number} The number of guests
		 */
		function totalNumberOfGuestsRequested(formData) {
			var result = 0;
			if (angular.isUndefined(formData) || angular.isUndefined(formData.customerTypeGroupList)) {
				return result;
			}
			formData.customerTypeGroupList.forEach(function(customerTypeGroup) {
				result += Utilities.forceInt(customerTypeGroup.qty);
			});
			return result;
		}

		/**
		 * Configures the guest options service based on settings.
		 * @public
		 * @function
		 * @memberof {GuestOptionsService}
		 * @param {Object} settingsConfig Our settings
		 * @return {undefined}
		 */
		function configureGuestOptions(settingsConfig) {
			var config = {};

			config.settings = settingsConfig;

			if (!config.settings) {
				if (JSONValidator.validate('guest_options', AppData.settings.guest_options)) {
					config.settings = JSON.parse(AppData.settings.guest_options);
				}
			}

			service.guestOptionsConfig = config;

			// Set merchant name
			if(angular.isUndefined(service.guestOptionsConfig.settings.merchantName) ||
				service.guestOptionsConfig.settings.merchantName == "") {
				service.guestOptionsConfig.merchantName = AppData.settings.merchant_name;
			}else{
				service.guestOptionsConfig.merchantName = service.guestOptionsConfig.settings.merchantName;
			}


			// set the asset folder for images
			service.guestOptionsConfig.assetUrl = $rootScope.assetsPath;

			// If the customer type groups have not be set yet, default to settings
			// in the guest_options config
			if (service.guestOptionsData.customerTypeGroupList == 0) {
				setGuestOptionsCustomerTypeGroups();
			}
		}

		/**
		 * Maps the key/values passed in to the Guest Options model
		 * @protected
		 * @function
		 * @param {Object} formData Our form data
		 * @memberof {GuestOptionsService}
		 * @return {undefined}
		 */
		function mapFormData(formData) {
			Object.keys(service.guestOptionsData).forEach(function(key) {
				service.guestOptionsData[key] = formData[key];
			});
		}

		/**
		 * Sets the customer type groups from the guest_options config if they are defined
		 * @protected
		 * @memberof {GuestOptionsService}
		 * @return {undefined}
		 */
		function setGuestOptionsCustomerTypeGroups() {
			if (angular.isDefined(service.guestOptionsConfig.settings) &&
				angular.isArray(service.guestOptionsConfig.settings.customerTypeGroupList)) {
				service.guestOptionsData.customerTypeGroupList = service.guestOptionsConfig.settings.customerTypeGroupList;
			}
		}

		return service;
	}
);

/**
 * Created by jwroblewski on 12/2/2015.
 */
angular.module('recommender-wizard',
	['app'])
	.config(function($locationProvider, $stateProvider) {
		$stateProvider
			.state('recommenderWizard', {
				url: '/recommenderWizard/:keyword',
				resolve: {
					initialData: function(Bootstrap, $rootScope) {
						// PEC perceived-load prototype: the recommender wizard opts out of the
						// skeleton in favor of the legacy spinner. Flip showSkeletonLoader off for
						// the wizard entry transition (RecommenderWizardService.isInitialized is not
						// set yet, so the onStart guard in RecommenderWizardStateService can't catch
						// this first hop). The guard keeps it off for the rest of the experience and
						// restores it on exit. No-op when the prototype is off (?skeleton absent).
						$rootScope.showSkeletonLoader = false;
						return Bootstrap.bootstrapApplication();
					},
					recommenderWizard: function(initialData, $transition$, RecommenderWizardContextService, RecommenderWizardRouteService, RecommenderWizardService) {
						RecommenderWizardService.resetWizardData();
						if (RecommenderWizardContextService.bootstrapWizard($transition$.params().keyword, 'recommenderWizard', true)) {
							RecommenderWizardRouteService.nextStep(true);
						}
					}
				}
			});
	})
	.run(function(Enums, ExtraFlow, RecommenderWizardPrepService, RecommenderWizardStateService) {
		ExtraFlow.registerXMC
		('RecommenderWizardModule',
			{
				name: 'RecommenderWizardModule',
				view: Enums.extraFlowRoutes.RECOMMENDERWIZARD,
				doEditMode: true,
				lockQuantity: false,
				writeSingleCharac: false,
				enabled: true,
				type: 'alternateFlowModule'
			}
		);
	});

/**
 * Created by jwroblewski on 12/11/2015.
 */
angular.module('recommender-wizard').service
('RecommenderWizardModels',
	function() {
		function ContextData() {
			this.dynamicPricing = [];
			this.visitType = undefined;
			this.visitTypeSelectList = [];
			this.customerTypeGroupList = [];
			this.isMilitary = false;
			this.zip = '';
			this.selectedDate = undefined;
			this.updateMode = false;
			this.keywords = {};
			this.wizard = '';
			this.flowName = '';
			this.visitedSteps = [];
			this.upSells = {};
			this.sessionId = '';
			this.stageSelections = {};
		}
		this.ContextData = ContextData;

		function StageSelections() {
			this.keyword = '';
			this.assocKeywords = [];
			this.selectedPackages = [];
			this.selectedDate = undefined;
			this.alternateModuleItemsToBeAdded = [];
			this.updateMode = false;
			this.upsells = {};
			this.quicksell = {};
		}
		this.StageSelections = StageSelections;

		function Upsells() {
			this.packageIds = [];
			this.preUpsellPkg = {};
			this.upsellPackage = {};
			this.customerTypes = {};
		}
		this.Upsells = Upsells;

		function QuickSell() {
			this.customerTypeId = '';
			this.packageId = '';
			this.qty = 0;
		}
		this.QuickSell = QuickSell;
	});
/**
 * Created by jwroblewski on 12/23/2015.
 */
angular
	.module('recommender-wizard')
	.factory('RecommenderWizardContextService', function(
		$location,
		$log,
		$rootScope,
		$state,
		AppData,
		LegacyCart,
		CustomActionService,
		Enums,
		RouteRejectionService,
		ExtraFlowValidationService,
		JSONValidator,
		Language,
		OneBarcodeUtilities,
		Package,
		Modal,
		RecommenderWizardPrepService,
		RecommenderWizardEnumsService,
		RecommenderWizardKeywordService,
		RecommenderWizardModels,
		RecommenderWizardRouteService,
		RecommenderWizardService,
		Utilities
	) {
		var service = {
			assessUpsellRouteAndRegisterUpsells: assessUpsellRouteAndRegisterUpsells,
			bootstrapWizard: bootstrapWizard,
			enableNextButton: enableNextButton,
			enablePreviousButton: enablePreviousButton,
			filterCustomerTypes: filterCustomerTypes,
			getAnyDayPackages: getAnyDayPackages,
			getSelectedCustomerTypeGroupsTotalQty: getSelectedCustomerTypeGroupsTotalQty,
			stateInWizard: stateInWizard,
			isAllowedState: isAllowedState,
			populateCustomerTypeData: populateCustomerTypeData,
			registerCustomActionsByState: registerCustomActionsByState,
			registerFastLane: registerFastLane,
			registerGuestOptions: registerGuestOptions,
			registerSnapCalendar: registerSnapCalendar,
			registerCalendarPricing: registerCalendarPricing,
			registerPackageDetails: registerPackageDetails,
			registerUpsells: registerUpsells,
			registerMeals: registerMeals,
			registerExtras: registerExtras,
			registerPackageComparison: registerPackageComparison,
			registerVerticalPackageList: registerVerticalPackageList,
			routeToFront: routeToFront
		};

		/**
		 * Filter Customer Types (CT's) in packageDetails based on guest selections from RecommenderWizardService
		 * If the guest did not visit the guestOptions view, no changes will be made.
		 * If no recommendations are selected, no changes will be made.
		 * If no matching CT's are found based on the guest's selections then no changes
		 * will be made to avoid having an empty CT array.
		 * @public
		 * @param {Object} pkg The object that will be modified in place.
		 * @param {Boolean} allowEmpty when this is true the CT array on the pkg could be set to an empty array
		 * if there were no matching customer types.
		 * @returns {undefined}
		 */
		function filterCustomerTypes(pkg, allowEmpty) {
			var guestOptionsVisited = RecommenderWizardRouteService.isStepNameInVisitedSteps('GuestOptionsModule');

			// Do not do any filtering if the GuestOptionsModule was not used
			if (angular.isUndefined(guestOptionsVisited)) {
				return;
			}

			var ctGroups = getSelectedCustomerTypeGroups();
			if (ctGroups.length > 0) {
				// Make sure CT is an array
				pkg.CT = (angular.isArray(pkg.CT)) ? pkg.CT : [pkg.CT];

				var defaultCTGroupId = RecommenderWizardService.config.defaultCustomerTypeGroupId || '';

				// Return only the CT's that match the selected ctGroups
				var matchingCTList = pkg.CT.filter(function(ct) {
					return ctGroups.some(function(ctGroup) {
						return ctGroup.groupId == ct.group_id || ct.group_id == defaultCTGroupId || ct.group_id == '';
					});
				});

				if (matchingCTList.length > 0 || allowEmpty) {
					pkg.CT = matchingCTList;
				}
			}
		}

		/**
		 * requireAllCustomerTypes returns true if a package has all the required customer types.
		 * It does not eliminate unwanted customer types from the package.
		 * @param {Object} pkg the package to check
		 * @returns {Boolean} true if the package has all the required customer types.
		 **/
		function requireAllCustomerTypes(pkg) {
			var guestOptionsVisited = RecommenderWizardRouteService.isStepNameInVisitedSteps('GuestOptionsModule'),
				ctGroups = angular.isDefined(guestOptionsVisited) ? getSelectedCustomerTypeGroups() : [],
				defaultCTGroupId = RecommenderWizardService.config.defaultCustomerTypeGroupId || '',
				result = true;

			// If no customer types selected, return true.
			if (ctGroups.length < 1) {
				return true;
			}
			// Make sure CT is an array
			pkg.CT = (angular.isArray(pkg.CT)) ? pkg.CT : [pkg.CT];

			for (var i = 0; (i < ctGroups.length) && result; i++) {
				// make sure the package includes every CT that is in the ctGroups;
				var foundThisCt = false;
				for (var j = 0; j < pkg.CT.length && !foundThisCt; j++) {
					foundThisCt = (pkg.CT[j].group_id == ctGroups[i].groupId
						|| pkg.CT[j].group_id == defaultCTGroupId
						|| pkg.CT[j].group_id == '');
				}
				result = foundThisCt;
			}
			return result;
		}

		function useWizardLayout(cts) {
			// First, make sure we're in the wizard flow - by checking if we visited the Guest Options.
			var guestOptionsVisited = RecommenderWizardRouteService.isStepNameInVisitedSteps('GuestOptionsModule');
			if (angular.isUndefined(guestOptionsVisited) || angular.isUndefined(cts) || cts.length < 1) {
				return;
			}
			cts.forEach(function(ct) {
				ct.wizardPriceLayout = true;
			});
		}

		/**
		 * Pre-populate customerType quantities from the guest selections
		 * @param {Object[]} customerTypes the CustomerType list that contains the customer types where the qty will be set
		 * Required properties: group_id, qty
		 * @returns {undefined}
		 */
		function assignCustomerTypeGroupQuantities(customerTypes) {
			customerTypes = customerTypes || [];

			var selectedCTGroups = getSelectedCustomerTypeGroups();
			var selectedCTGroupQty = getSelectedCustomerTypeGroupsTotalQty();

			// First assign qty values where the group id matches
			// subtract from the total when the assignment happens.
			customerTypes.forEach(function(customerType) {
				selectedCTGroups.forEach(function(ctGroup) {
					if (ctGroup.groupId == customerType.group_id) {
						customerType.qty = ctGroup.qty;
						selectedCTGroupQty -= ctGroup.qty;
					}
				});
			});

			// If we have any quantities left over after the group id mapping
			// assign this value to the first customer type with the default group id
			var defaultGroupId = RecommenderWizardService.config.defaultCustomerTypeGroupId || '';
			if (selectedCTGroupQty > 0) {
				for (var i = 0; i < customerTypes.length; i++) {
					var customerType = customerTypes[i];
					if (customerType.group_id == defaultGroupId) {
						customerType.qty = selectedCTGroupQty;
						break;
					}
				}
			}
		}

		/**
		 * Sets the appropriate qty in the guest data based on the group of the customerType
		 * @param {Object} customerType  the customer type that has the qty to set
		 * Required properties: group_id, qty
		 * @returns {undefined}
		 */
		function setGuestDataQuantities(customerType) {
			var ctGroups = RecommenderWizardService.contextData.customerTypeGroupList;

			ctGroups.forEach(function(ctGroup) {
				if (ctGroup.groupId == customerType.group_id) {
					ctGroup.qty = customerType.qty;
				}
			});
			RecommenderWizardService.storeWizardData();
		}

		function setSelectedPackage(packageDetails) {
			var currentStageSelections = RecommenderWizardService.getCurrentStageSelections();
			currentStageSelections.selectedPackages[0] = { package_id: packageDetails.id };
			currentStageSelections.assocKeywords = RecommenderWizardKeywordService.getKeywordArrayFromString(packageDetails.assoc_keywords);
			RecommenderWizardKeywordService.setStageSelectionsKeywords();
			RecommenderWizardService.storeWizardData();
		}

		function populateQuickSellQuantity(customerType) {
			var currentStageSelections = RecommenderWizardService.getCurrentStageSelections();

			if (!Utilities.isEmpty(currentStageSelections.quicksell)) {
				var quicksell = currentStageSelections.quicksell;
				if (customerType.customer_type == quicksell.customerTypeId &&
					customerType.package_id == quicksell.packageId) {
					customerType.qty = quicksell.qty;
				}
			}
		}

		function getSelectedQuickSellPackage(quickSellList) {
			var currentStageSelections = RecommenderWizardService.getCurrentStageSelections();
			if (!Utilities.isEmpty(currentStageSelections.quicksell)) {
				return quickSellList.filter(function(item) {
					return item.quickSalesDetails.id == currentStageSelections.quicksell.packageId;
				})[0];
			}
		}

		function setSelectedQuickSellPackage(quickSellPackage) {
			var currentStageSelections = RecommenderWizardService.getCurrentStageSelections();

			if (Utilities.isEmpty(currentStageSelections.quicksell)) {
				currentStageSelections.quicksell = new RecommenderWizardModels.QuickSell();
			}

			currentStageSelections.quicksell.customerTypeId = quickSellPackage.customer_type;
			currentStageSelections.quicksell.packageId = quickSellPackage.package_id;
			currentStageSelections.quicksell.qty = quickSellPackage.qty;

			RecommenderWizardService.storeWizardData();
		}

		function setSelectedUpsellPackages(cartItemsToBeAdded) {
			var currentStageSelections = RecommenderWizardService.getCurrentStageSelections();

			currentStageSelections.upsells.packageIds.length = 0;

			cartItemsToBeAdded.forEach(function(item) {
				if (Utilities.getBoolean(item.CHARACS[0].upsell)) {
					currentStageSelections.upsells.packageIds.push(item.package_id);
				}
			});
			storeUpsellData(currentStageSelections);
		}

		/**
		 * Prepares the data for backwards navigation.
		 * @returns {undefined}
		 */
		function setupDataForBackNavigation() {
			var currentStageSelections = RecommenderWizardService.getCurrentStageSelections();

			if (currentStageSelections.updateMode) {
				prepareCartItemsForUpdateMode();

				if (currentStageSelections.alternateModuleItemsToBeAdded.length > 0) {
					Package.alternateModuleItemsToBeAdded = currentStageSelections.alternateModuleItemsToBeAdded;
				}
			}
		}

		function enablePreviousButton() {
			// show the back button if this is not the first step
			var enabled = false;
			if (RecommenderWizardRouteService.isFirstStep()) {
				enabled = false;
			} else {
				enabled = true;
			}

			return enabled;
		}

		function enableNextButton() {
			// Do not display the next button when on the last step.
			return !RecommenderWizardRouteService.isLastStep();
		}

		/**
		 * Bootstrap the wizard.
		 * @public
		 * @param {String} wizardKeyword The keyword used.
		 * @param {String} stateName The state name.
		 * @param {Boolean|Undefined} isStepZero Is the state saying its at the first step?
		 * @return {undefined}
		 */
		function bootstrapWizard(wizardKeyword, stateName, isStepZero) {
			// isStepZero tells us when we're bootstrapping to load the data for the keyword.
			isStepZero = (angular.isDefined(isStepZero) && isStepZero);

			if (Utilities.isEmpty(RecommenderWizardService.settings.configList)) {
				RecommenderWizardPrepService.getSettings();
			}

			RecommenderWizardService.configure(wizardKeyword);

			var isConfigValid = !Utilities.isEmpty(RecommenderWizardService.config);
			var isContextValid = false;

			if (isConfigValid) {
				isContextValid = configureWizardContext(wizardKeyword, stateName);
			}

			if (isConfigValid && isContextValid) {
				RecommenderWizardService.isInitialized = true;
			}

			// if we're not initialized, and we're not on the first page, drop out:
			if (!RecommenderWizardService.isInitialized && !isStepZero) {
				service.routeToFront(wizardKeyword);
				return false;
			}

			return isConfigValid && isContextValid;
		}


		/**
		 * Route to the front of the wizard or if the service isn't defined, the packageList
		 * @public
		 * @param {String} wizardKeyword The keyword used.
		 * @throws {RouteRejectionService.UnrecoverableException} Throw a route rejection
		 * @return {undefined}
		 */
		function routeToFront(wizardKeyword) {
			// don't show the confirmation modal to the customer.
			RecommenderWizardRouteService.guardTheGate = false;

			// if the service doesn't exist, go back to the front of the store.
			if (angular.isUndefined(RecommenderWizardService)) {
				throw new RouteRejectionService.UnrecoverableException('/packageList');
			} else {
				// don't like having "recommenderWizard" hard-coded here, but I don't know what
				// else to do. After a refresh, none of our data is populated.
				throw new RouteRejectionService.UnrecoverableException('recommenderWizard', { keyword: wizardKeyword });
			}
		}

		/**
		 * Configures the wizard context data with the specified wizard config
		 * @param {string} wizardKeyword this is the keyword of the wizard that will be loaded into the wizardConfig
		 * @param {string} stateName this is the current state name that is used for setting the current step after
		 * the flow is loaded
		 * @returns {Boolean} true if the wizard context was configured successfully, false otherwise
		 */
		function configureWizardContext(wizardKeyword, stateName) {
			var result = false,
				contextData = RecommenderWizardService.contextData;

			// should we reset the data
			// Only if switching to a different wizard
			if (contextData.wizard && contextData.wizard !== wizardKeyword) {
				RecommenderWizardService.resetWizardData();
				RecommenderWizardService.config = {};

				// re-configure the service if it was reset
				RecommenderWizardService.configure(wizardKeyword);
			}

			setSessionId(contextData);

			var setFlowResult = loadFlow(contextData);

			// Load visit types
			if (contextData.visitTypeSelectList.length == 0) {
				contextData.visitTypeSelectList = RecommenderWizardService.config.visitTypeSelectList;
			}

			// Load customer type groups
			if (contextData.customerTypeGroupList.length == 0) {
				contextData.customerTypeGroupList = RecommenderWizardService.config.customerTypeGroupList;
			}

			// Set wizard keyword in dataContext if all is good
			if (!Utilities.isEmpty(RecommenderWizardService.config) &&
				setFlowResult &&
				contextData.customerTypeGroupList.length > 0) {
				contextData.wizard = wizardKeyword;
				result = true;
			} else {
				$log.error('[RecommenderWizardContextService.configureWizardContext]: ' +
					'Error: something went wrong causing the wizard configuration to be invalid.');
				$rootScope.disableSpinner = false;
				Utilities.routeTo(Enums.routes.LIST);
				return result;
			}

			RecommenderWizardRouteService.setCurrentStep(stateName);
			RecommenderWizardService.storeWizardData();
			return result;
		}

		function registerPackageDetails() {
			deRegisterRecommenderWizardCustomActions(RecommenderWizardEnumsService.CUSTOM_ACTION_GROUP_NAME);
			registerRecommenderWizardCustomAction('itemAddedThisSession', itemAddedThisSession);
			registerRecommenderWizardCustomAction('checkoutWizard', checkoutWizard);
			registerRecommenderWizardCustomAction('enablePreviousButton', enablePreviousButton);

			if (RecommenderWizardService.config.displayOnlySelectedCTGroups) {
				registerRecommenderWizardCustomAction('filterCustomerTypes', service.filterCustomerTypes);
			}

			registerRecommenderWizardCustomAction('hideParkHours', hideParkHours);
			registerRecommenderWizardCustomAction('incrementQty', setGuestDataQuantities);
			registerRecommenderWizardCustomAction('decrementQty', setGuestDataQuantities);
			registerRecommenderWizardCustomAction('setupUpdateMode', setupDataForBackNavigation);
			registerRecommenderWizardCustomAction('assignCustomerTypeGroupQuantities', assignCustomerTypeGroupQuantities);
			registerRecommenderWizardCustomAction('setForwardRouteDirection', setForwardRouteDirection);
			registerRecommenderWizardCustomAction('setSelectedPackage', setSelectedPackage);
			registerRecommenderWizardCustomAction('populateQuickSellQuantity', populateQuickSellQuantity);
			registerRecommenderWizardCustomAction('getSelectedQuickSellPackage', getSelectedQuickSellPackage);
			registerRecommenderWizardCustomAction('setSelectedQuickSellPackage', setSelectedQuickSellPackage);
			registerRecommenderWizardCustomAction('addSessionDataToPackages', addSessionDataToPackages);
			registerRecommenderWizardCustomAction('updateCartItems', updateCartItems);
			registerRecommenderWizardCustomAction('onAddCartItemResponse', onAddCartItemResponse);
			registerRecommenderWizardCustomAction('routeToUpsell', routeToUpsell);
			registerRecommenderWizardCustomAction('routeToPreviousStep', routeToPreviousStep);
			registerRecommenderWizardCustomAction('routeToCurrentStep', routeToCurrentStep);
			registerRecommenderWizardCustomAction('useWizardLayout', useWizardLayout);
			registerRecommenderWizardCustomAction('updateContextData', updateContextData);
		}

		function registerUpsells() {
			//registerCommonWizardActions();
			registerRecommenderWizardCustomAction('checkoutWizard', checkoutWizard);

			// Loading wizard data
			registerRecommenderWizardCustomAction('byPassUpsellStateChangeSuccess', byPassUpsellStateChangeSuccess);
			registerRecommenderWizardCustomAction('populateUpsellData', populateUpsellData);

			// Used when guest cancels an upsell
			registerRecommenderWizardCustomAction('setSelectedPackage', setSelectedPackage);
			// Used when guest selects an upsell
			registerRecommenderWizardCustomAction('setSelectedUpsellPackages', setSelectedUpsellPackages);

			// Add to cart actions
			registerRecommenderWizardCustomAction('addSessionDataToPackages', addSessionDataToPackages);
			registerRecommenderWizardCustomAction('updateCartItems', updateCartItems);
			registerRecommenderWizardCustomAction('onAddCartItemResponse', onAddCartItemResponse);
		}

		/**
		 * Ensure that the upsell route is in a kosher state for use to route back to
		 * Otherwise go back to the wizardPackageDetails screen
		 * @param {Object} stateParams the state params object
		 * @returns {Boolean} true if the upsell route is kosher, false otherwise
		 */
		function assessUpsellRouteAndRegisterUpsells(stateParams) {
			if (angular.isDefined(stateParams.recommenderWizardKeyword) &&
				angular.isDefined(stateParams.packageId)) {
				if (Utilities.safelyCheckPropertyOnObject('Package.packageDetails.id', Package) &&
					Package.packageDetails.id == stateParams.packageId) {
					if (bootstrapWizard(stateParams.recommenderWizardKeyword, 'wizardPackageDetails')) {
						registerUpsells();
						return true;
					}
				} else {
					throw new RouteRejectionService.UnrecoverableException('wizardPackageDetails', stateParams);
				}
			}
		}

		function registerCommonWizardActions() {
			deRegisterRecommenderWizardCustomActions();
			registerRecommenderWizardCustomAction('checkoutWizard', checkoutWizard);
			registerRecommenderWizardCustomAction('updateContextData', updateContextData);
			registerRecommenderWizardCustomAction('routeToNextStep', routeToNextStep);
			registerRecommenderWizardCustomAction('routeToPreviousStep', routeToPreviousStep);
		}

		function registerGuestOptions() {
			//registerCommonWizardActions();
			deRegisterRecommenderWizardCustomActions();
			registerRecommenderWizardCustomAction('checkoutWizard', checkoutWizard);
			registerRecommenderWizardCustomAction('updateContextData', updateContextData);
			registerRecommenderWizardCustomAction('routeToNextStep', routeToNextStep);
			registerRecommenderWizardCustomAction('routeToPreviousStep', routeToPreviousStep);

			registerRecommenderWizardCustomAction('getCurrentStepSettings', RecommenderWizardService.getCurrentStepSettings);
			registerRecommenderWizardCustomAction('enablePreviousButton', enablePreviousButton);
			registerRecommenderWizardCustomAction('enableNextButton', enableNextButton);
			registerRecommenderWizardCustomAction('populateContextData', populateContextData);
		}

		/**
		 * Registers the snap calendar custom actions
		 * @returns {undefined}
		 */
		function registerSnapCalendar() {
			deRegisterRecommenderWizardCustomActions();
			registerRecommenderWizardCustomAction('checkoutWizard', checkoutWizard);
			registerRecommenderWizardCustomAction('updateContextData', updateContextData);
			registerRecommenderWizardCustomAction('routeToNextStep', routeToNextStep);
			registerRecommenderWizardCustomAction('routeToPreviousStep', routeToPreviousStep);
			registerRecommenderWizardCustomAction('updateStageSelections', updateStageSelections);
			registerRecommenderWizardCustomAction('updateCartItems', updateCartItems);
			registerRecommenderWizardCustomAction('onAddCartItemResponse', onAddCartItemResponse);
			registerRecommenderWizardCustomAction('routeToUpsell', routeToUpsell);

			registerRecommenderWizardCustomAction('getCurrentStepSettings', RecommenderWizardService.getCurrentStepSettings);
			registerRecommenderWizardCustomAction('enablePreviousButton', enablePreviousButton);
			registerRecommenderWizardCustomAction('enableNextButton', enableNextButton);
			registerRecommenderWizardCustomAction('populateContextData', populateContextData);
		}

		function registerFastLane() {
			//registerCommonWizardActions();
			deRegisterRecommenderWizardCustomActions();
			registerRecommenderWizardCustomAction('checkoutWizard', checkoutWizard);
			registerRecommenderWizardCustomAction('getSelectedDate', getSelectedDate);
			registerRecommenderWizardCustomAction('filterFastLaneItemListBySelectedCustomerTypeGroups', filterFastLaneItemListBySelectedCustomerTypeGroups);
			registerRecommenderWizardCustomAction('populateFastLaneItemRateQuantities', populateFastLaneItemRateQuantities);
			registerRecommenderWizardCustomAction('setupUpdateMode', setupDataForBackNavigation);
			registerRecommenderWizardCustomAction('setSelectedPackageList', setSelectedPackageList);
			registerRecommenderWizardCustomAction('setForwardRouteDirection', setForwardRouteDirection);
			registerRecommenderWizardCustomAction('routeToNextStep', routeToNextStep);
			registerRecommenderWizardCustomAction('routeToPreviousStep', routeToPreviousStep);
			registerRecommenderWizardCustomAction('routeToCurrentStep', routeToCurrentStep);

			registerRecommenderWizardCustomAction('getCurrentStepSettings', RecommenderWizardService.getCurrentStepSettings);
			registerRecommenderWizardCustomAction('enablePreviousButton', enablePreviousButton);
			registerRecommenderWizardCustomAction('enableNextButton', enableNextButton);
			registerRecommenderWizardCustomAction('cancelSelectedPackages', cancelSelectedPackages);

			// Add to cart actions
			registerRecommenderWizardCustomAction('addSessionDataToPackages', addSessionDataToPackages);
			registerRecommenderWizardCustomAction('updateCartItems', updateCartItems);
			registerRecommenderWizardCustomAction('onAddCartItemResponse', onAddCartItemResponse);
		}

		function registerCalendarPricing() {
			//registerCommonWizardActions();
			deRegisterRecommenderWizardCustomActions();
			registerRecommenderWizardCustomAction('checkoutWizard', checkoutWizard);
			registerRecommenderWizardCustomAction('updateContextData', updateContextData);
			registerRecommenderWizardCustomAction('updateStageSelections', updateStageSelections);
			registerRecommenderWizardCustomAction('routeToNextStep', routeToNextStep);
			registerRecommenderWizardCustomAction('routeToPreviousStep', routeToPreviousStep);

			registerRecommenderWizardCustomAction('setCalendarPricingModuleDate', setCalendarPricingModuleDate);
			registerRecommenderWizardCustomAction('filterKeywordCalendarPackages', filterKeywordCalendarPackages);
			registerRecommenderWizardCustomAction('filterCustomerTypes', service.filterCustomerTypes);
			registerRecommenderWizardCustomAction('requireAllCustomerTypes', requireAllCustomerTypes);

			// Only get the any day packages if they are configured for the current step
			var currentStep = RecommenderWizardService.getCurrentStep();
			if (Utilities.safelyCheckPropertyOnObject('currentStep.settings.anyDayKeyword', currentStep)) {
				registerRecommenderWizardCustomAction('getAnyDayPackages', service.getAnyDayPackages);
			}
			registerRecommenderWizardCustomAction('getCurrentStepSettings', RecommenderWizardService.getCurrentStepSettings);
			registerRecommenderWizardCustomAction('enablePreviousButton', enablePreviousButton);
			registerRecommenderWizardCustomAction('populateCustomerTypeData', service.populateCustomerTypeData);
		}

		function registerVerticalPackageList() {
			//registerCommonWizardActions();
			deRegisterRecommenderWizardCustomActions();
			registerRecommenderWizardCustomAction('checkoutWizard', checkoutWizard);
			registerRecommenderWizardCustomAction('updateContextData', updateContextData);
			registerRecommenderWizardCustomAction('updateStageSelections', updateStageSelections);
			registerRecommenderWizardCustomAction('routeToNextStep', routeToNextStep);
			registerRecommenderWizardCustomAction('routeToPreviousStep', routeToPreviousStep);
			registerRecommenderWizardCustomAction('byPassUpsellStateChangeSuccess', byPassUpsellStateChangeSuccess);
			registerRecommenderWizardCustomAction('setCalendarPricingModuleDate', setCalendarPricingModuleDate);
			registerRecommenderWizardCustomAction('filterKeywordCalendarPackages', filterKeywordCalendarPackages);
			registerRecommenderWizardCustomAction('filterCustomerTypes', service.filterCustomerTypes);
			registerRecommenderWizardCustomAction('requireAllCustomerTypes', requireAllCustomerTypes);
			registerRecommenderWizardCustomAction('routeToUpsell', routeToUpsell);
			registerRecommenderWizardCustomAction('getCurrentStepSettings', RecommenderWizardService.getCurrentStepSettings);
			registerRecommenderWizardCustomAction('enablePreviousButton', enablePreviousButton);
			registerRecommenderWizardCustomAction('populateCustomerTypeData', service.populateCustomerTypeData);
			registerRecommenderWizardCustomAction('itemAddedThisSession', itemAddedThisSession);
			registerRecommenderWizardCustomAction('setupUpdateMode', setupDataForBackNavigation);
			registerRecommenderWizardCustomAction('assignCustomerTypeGroupQuantities', assignCustomerTypeGroupQuantities);
			registerRecommenderWizardCustomAction('setForwardRouteDirection', setForwardRouteDirection);
			registerRecommenderWizardCustomAction('setSelectedPackage', setSelectedPackage);
			registerRecommenderWizardCustomAction('populateQuickSellQuantity', populateQuickSellQuantity);
			registerRecommenderWizardCustomAction('getSelectedQuickSellPackage', getSelectedQuickSellPackage);
			registerRecommenderWizardCustomAction('setSelectedQuickSellPackage', setSelectedQuickSellPackage);
			registerRecommenderWizardCustomAction('addSessionDataToPackages', addSessionDataToPackages);
			registerRecommenderWizardCustomAction('updateCartItems', updateCartItems);
			registerRecommenderWizardCustomAction('onAddCartItemResponse', onAddCartItemResponse);
			registerRecommenderWizardCustomAction('routeToCurrentStep', routeToCurrentStep);
			registerRecommenderWizardCustomAction('useWizardLayout', useWizardLayout);
			registerRecommenderWizardCustomAction('setSelectedUpsellPackages', setSelectedUpsellPackages);
			registerRecommenderWizardCustomAction('getSelectedCustomerTypeGroups', getSelectedCustomerTypeGroups);
			registerRecommenderWizardCustomAction('routeToFirstStep', routeToFirstStep);
		}

		function registerMeals() {
			//registerCommonWizardActions();
			deRegisterRecommenderWizardCustomActions();
			registerRecommenderWizardCustomAction('checkoutWizard', checkoutWizard);
			registerRecommenderWizardCustomAction('getCurrentStepSettings', RecommenderWizardService.getCurrentStepSettings);
			registerRecommenderWizardCustomAction('getSelectedDate', getSelectedDate);

			registerRecommenderWizardCustomAction('filterPackageListBySelectedCustomerTypeGroups', filterPackageListBySelectedCustomerTypeGroups);

			registerRecommenderWizardCustomAction('populateCustomerTypeQuantities', populateCustomerTypeQuantities);
			registerRecommenderWizardCustomAction('setupUpdateMode', setupDataForBackNavigation);
			registerRecommenderWizardCustomAction('setSelectedPackageList', setSelectedPackageList);
			registerRecommenderWizardCustomAction('routeToPreviousStep', routeToPreviousStep);
			registerRecommenderWizardCustomAction('setForwardRouteDirection', setForwardRouteDirection);
			registerRecommenderWizardCustomAction('routeToNextStep', routeToNextStep);
			registerRecommenderWizardCustomAction('routeToCurrentStep', routeToCurrentStep);

			registerRecommenderWizardCustomAction('enablePreviousButton', enablePreviousButton);
			registerRecommenderWizardCustomAction('enableNextButton', enableNextButton);
			registerRecommenderWizardCustomAction('cancelSelectedPackages', cancelSelectedPackages);

			registerRecommenderWizardCustomAction('addSessionDataToPackages', addSessionDataToPackages);
			registerRecommenderWizardCustomAction('updateCartItems', updateCartItems);
			registerRecommenderWizardCustomAction('onAddCartItemResponse', onAddCartItemResponse);
		}

		function registerExtras() {
			//registerCommonWizardActions();
			deRegisterRecommenderWizardCustomActions();
			registerRecommenderWizardCustomAction('checkoutWizard', checkoutWizard);
			registerRecommenderWizardCustomAction('getCurrentStepSettings', RecommenderWizardService.getCurrentStepSettings);
			registerRecommenderWizardCustomAction('getSelectedDate', getSelectedDate);

			registerRecommenderWizardCustomAction('filterPackageListBySelectedCustomerTypeGroups', filterPackageListBySelectedCustomerTypeGroups);

			registerRecommenderWizardCustomAction('populateCustomerTypeQuantities', populateCustomerTypeQuantities);
			registerRecommenderWizardCustomAction('setupUpdateMode', setupDataForBackNavigation);
			registerRecommenderWizardCustomAction('setSelectedPackageList', setSelectedPackageList);
			registerRecommenderWizardCustomAction('routeToPreviousStep', routeToPreviousStep);
			registerRecommenderWizardCustomAction('setForwardRouteDirection', setForwardRouteDirection);
			registerRecommenderWizardCustomAction('routeToNextStep', routeToNextStep);
			registerRecommenderWizardCustomAction('routeToCurrentStep', routeToCurrentStep);

			registerRecommenderWizardCustomAction('enablePreviousButton', enablePreviousButton);
			registerRecommenderWizardCustomAction('enableNextButton', enableNextButton);
			registerRecommenderWizardCustomAction('cancelSelectedPackages', cancelSelectedPackages);

			registerRecommenderWizardCustomAction('addSessionDataToPackages', addSessionDataToPackages);
			registerRecommenderWizardCustomAction('updateCartItems', updateCartItems);
			registerRecommenderWizardCustomAction('onAddCartItemResponse', onAddCartItemResponse);
		}

		function registerPackageComparison(moduleConfigSettingsForOverrides) {
			registerCommonWizardActions();
			RecommenderWizardService.resetSwappedFlow();
			var wizardStepSettings = RecommenderWizardService.getCurrentStepSettings();
			if (Utilities.isEmpty(wizardStepSettings)) {
				return false;
			} else if (angular.isDefined(wizardStepSettings.settingOverridesPerContextData) &&
				angular.isArray(wizardStepSettings.settingOverridesPerContextData)) {
				wizardStepSettings.settingOverridesPerContextData.forEach(function(override) {
					if (angular.isDefined(moduleConfigSettingsForOverrides[override.configSetting]) &&
						!override.checkBooleanOfConfigValue || (override.checkBooleanOfConfigValue &&
						Utilities.getBoolean(moduleConfigSettingsForOverrides[override.configSetting]))) {
						moduleConfigSettingsForOverrides[override.configSetting] = (RecommenderWizardService.contextData[override.contextDataField] == override.contextDataFieldValue ? override.configValueIfConditionValid : override.configValueIfConditionInvalid);
					}
				});
			}

			registerRecommenderWizardCustomAction('setSelectedPackageList', setSelectedPackageList);
			registerRecommenderWizardCustomAction('enablePreviousButton', enablePreviousButton);
			registerRecommenderWizardCustomAction('enableNextButton', enableNextButton);
			registerRecommenderWizardCustomAction('populateContextData', populateContextData);
			registerRecommenderWizardCustomAction('mapContextFieldsToItemsAddedCharacs', mapContextFieldsToItemsAddedCharacs);
			registerRecommenderWizardCustomAction('checkAndExecuteConfiguredAltFlowAction', checkAndExecuteConfiguredAltFlowAction);
			return true;
		}

		/**
		 * Check which alternate flow action we should run
		 * (route to the keyword or route to a swapped wizard step and change the flow)
		 * @param {string} actionName the action name
		 * @param {string} actionParam the action parameter
		 * @returns {undefined}
		 */
		function checkAndExecuteConfiguredAltFlowAction(actionName, actionParam) {
			if (actionName == RecommenderWizardEnumsService.ALT_FLOW_ACTIONS.ROUTE_TO_KEYWORD) {
				$rootScope.routeTo('/packageList/keyword/' + actionParam);
			} else if (actionName == RecommenderWizardEnumsService.ALT_FLOW_ACTIONS.SWAP_SUBSEQUENT_FLOW_STEPS) {
				//validate the swapped steps
				var configuredSwapSteps = [];
				if (JSONValidator.validate('recommender_wizard_alt_flow_steps', AppData.settings['recommender_wizard_alt_flow_steps_' + actionParam])) {
					configuredSwapSteps = JSON.parse(AppData.settings['recommender_wizard_alt_flow_steps_' + actionParam]).swappable_next_steps;
					if (configuredSwapSteps.length > 0) {
						RecommenderWizardService.swapSubsequentFlowSteps(configuredSwapSteps);
						routeToNextStep();
					}
				} else {
					//display an error 300 (standard package setup error) to the guest because OPS does not have this properly setup
					Modal.displayModal({
						label: 'Error',
						title: Language.getLocale('ErrorCodes', '300'),
						description: Language.replaceAll('@@errorCode', 'ErrorCodes', '300')
					});
				}
			}
		}

		/**
		 * Map fields from the context data to the items added characs
		 * @param {Object[]} itemsAddedList the list of added items to map the context data to
		 * @returns {undefined}
		 */
		function mapContextFieldsToItemsAddedCharacs(itemsAddedList) {
			var wizardStepSettings = RecommenderWizardService.getCurrentStepSettings();
			if (!Utilities.isEmpty(wizardStepSettings) && angular.isDefined(wizardStepSettings.fieldsToMapToItemsAddedCharacs)) {
				var mappingList = wizardStepSettings.fieldsToMapToItemsAddedCharacs;
				itemsAddedList.forEach(function(item, passIndex) {
					mappingList.forEach(function(mapping) {
						item.CHARACS.forEach(function(characsObj, characsIndex) {
							if ((Utilities.getBoolean(mapping.limitToFirstPass) && passIndex === 0 && characsIndex === 0) ||
										!Utilities.getBoolean(mapping.limitToFirstPass)) {
								characsObj[mapping.modelDataFieldToMap] = RecommenderWizardService.contextData[mapping.contextDataField];
							}
						});
					});
				});
			}
		}

		/**
	  	* This is a helper/wrapper function that just calls RecommenderWizardRouteService.nextStep
	  	* Adding the option to replace the route as we need to be able to affect it from callbacks and
	  	* other places that use this helper function
	  	* @param {Boolean} shouldReplaceRoute indicates if we should replace the route
	  	* @returns {Boolean} true if the route was replaced`
	  	*/
		function routeToNextStep(shouldReplaceRoute) {
			RecommenderWizardRouteService.nextStep.apply(null, arguments);
			return true;
		}

		function routeToPreviousStep() {
			RecommenderWizardRouteService.previousStep();
			return true;
		}

		function routeToFirstStep() {
			RecommenderWizardRouteService.firstStep();
			return true;
		}

		function routeToCurrentStep() {
			RecommenderWizardRouteService.routeToCurrentStep();
			return true;
		}

		function stateInWizard(state, stateParams, treatCartAsNotInWizard) {
			return RecommenderWizardRouteService.isStateInSteps(state.name, treatCartAsNotInWizard)
				|| ExtraFlowValidationService.isActiveXFCRoute(state, stateParams)
				|| service.isAllowedState(state);
		}

		/**
		 * checkoutWizard shows the modal confirming that the customer wants to leave the recommender wizard and go
		 * to the cart. When checkoutWizard returns true, no routing is performed. When it returns false, regular
		 * routing happens.
		 * @param {function} callback the callback function
		 * @returns {Boolean} returns true if the modal was shown, false if regular routing happened
		 */
		function checkoutWizard(callback) {
			var inWizard = RecommenderWizardService.isInitialized
				&& service.stateInWizard($state.current, $state.params, true);

			// if we're not in the wizard, don't show this modal
			if (!inWizard) {
				return false;
			}

			// Only show the wizard if items have already been added to the cart.
			// Note that this will also show a modal if the cart
			// already has items in it that were not added by the wizard.
			if ($rootScope.hasItemsInCart()) {
				RecommenderWizardRouteService.displayCheckoutWizardModal(callback);
			}

			return true;
		}

		function getSelectedCustomerTypeGroups() {
			return RecommenderWizardService.contextData.customerTypeGroupList.filter(function(ctGroup) {
				return ctGroup.qty > 0;
			});
		}

		function getSelectedCustomerTypeGroupsTotalQty() {
			var sumQty = 0;
			RecommenderWizardService.contextData.customerTypeGroupList.forEach(function(ctGroup) {
				sumQty += ctGroup.qty;
			});
			return sumQty;
		}

		function onAddCartItemResponse() {
			var currentStageSelections = RecommenderWizardService.getCurrentStageSelections();
			currentStageSelections.updateMode = true;

			RecommenderWizardService.storeWizardData();
			RecommenderWizardRouteService.nextStep();
			return true;
		}

		function updateCartItems(itemsToBeAdded) {
			//ByPassing an XFC should elicit a replacement for the next route - however, due to the promise that executes regarding the updateCartItems call
			// we lose context of that on the digest cycle after promises and the route doesn't get properly replaced, hence once LegacyCart.updateCartItems resolves
			// Keeping the context of it so that we can tell the routeToNextStep to forward that along to the routing of the next route
			var shouldReplaceNextRoute = $location.$$replace;
			var currentStageSelections = RecommenderWizardService.getCurrentStageSelections();
			if (currentStageSelections.updateMode) {
				itemsToBeAdded = LegacyCart.splitCartItems(itemsToBeAdded);
				//var qtyBeingAdded = LegacyCart.getQtyAdded( Package.itemsToBeAdded );
				var flags = LegacyCart.getFlags();
				flags.hasQuickSells = false;
				flags.hasCrossSells = false;
				flags.hasUpSells = false;
				for (var i in itemsToBeAdded) {
					if (itemsToBeAdded[i].CHARACS[0].quicksell == 'true') {
						flags.hasQuickSells = true;
					}
					if (itemsToBeAdded[i].CHARACS[0].crosssell == 'true') {
						flags.hasCrossSells = true;
					}
					if (itemsToBeAdded[i].CHARACS[0].upsell == 'true') {
						flags.hasUpSells = true;
					}
				}

				var items = LegacyCart.editingCartCopy;
				if (itemsToBeAdded.length > 0) {
					items = Utilities.finalizeArraysForEditing(LegacyCart.editingCartCopy, itemsToBeAdded);
				}

				LegacyCart.updateCartItems(items, function() {
					// Pivot!!!
					if (RecommenderWizardRouteService.routeDirection === -1) {
						routeToPreviousStep();
					} else {
						routeToNextStep(shouldReplaceNextRoute);
					}
				}, true);
				return true;
			}
			return false;
		}

		function populateContextData(model) {
			var contextData = RecommenderWizardService.contextData;
			Object.keys(model).forEach(function(key) {
				model[key] = contextData[key];
			});
		}

		function updateContextData(model) {
			var previousContextData = angular.copy(RecommenderWizardService.contextData);
			var contextData = RecommenderWizardService.contextData;

			Object.keys(model).forEach(function(key) {
				contextData[key] = model[key];
			});

			// Change flow when necessary
			var changeFlow = determineFlowChange(previousContextData);
			if (changeFlow) {
				loadFlow(contextData, changeFlow);
			}

			// Set customerTypeGroup keywords
			//var ctGroups = getSelectedCustomerTypeGroups();
			//RecommenderWizardKeywordService.setCustomerTypeGroup(contextData, ctGroups);

			// Override current keywords if a guestOrganization is specified
			RecommenderWizardKeywordService.setGuestOrganization(contextData);

			RecommenderWizardService.storeWizardData();
		}

		function updateStageSelections(model) {
			var currentStageSelections = RecommenderWizardService.getCurrentStageSelections();
			Object.keys(model).forEach(function(key) {
				currentStageSelections[key] = model[key];
			});
			RecommenderWizardService.storeWizardData();
		}

		function determineFlowChange(previousContextData) {
			var currentContextData = RecommenderWizardService.contextData;
			var contextDataKey = RecommenderWizardService.config.flowSelector.dataKey;
			var flowsLength = RecommenderWizardService.config.flows.length;
			var contextDataChanged = (previousContextData[contextDataKey] !== currentContextData[contextDataKey]);
			return (contextDataChanged && flowsLength > 1);
		}

		function loadFlow(contextData, changeFlow) {
			var result = false;

			// only load the flow if a change is necessary or if the stepListDetails are empty
			if (changeFlow || RecommenderWizardService.steps.length == 0) {
				// Use default if no flowName has been set yet
				if (!contextData.flowName) {
					contextData.flowName = RecommenderWizardService.config.defaultFlowName;
					changeFlow = true;
				}

				// next, check the contextData key value to see if we can get the name
				// from the flow selector rule
				var contextDataKey = RecommenderWizardService.config.flowSelector.dataKey;
				var flowSelectorRule = RecommenderWizardService.config.flowSelector.rules.filter(function(rule) {
					return rule.value == contextData[contextDataKey];
				})[0];

				if (angular.isDefined(flowSelectorRule)) {
					contextData.flowName = flowSelectorRule.flowName;
					//RecommenderWizardKeywordService.setAdmission(contextData, flowSelectorRule.admissionKeyword);
				}

				// With the flowName set, we can now load the flow into the steps
				RecommenderWizardService.currentFlow = RecommenderWizardService.config.flows.filter(function(flow) {
					return flow.name == contextData.flowName;
				})[0];

				if (angular.isUndefined(RecommenderWizardService.currentFlow)) {
					$log.error('[RecommenderWizardService.initRecommenderWizardFlow]: ' +
						'Error: could not locate a flow with the "' + RecommenderWizardService.config.defaultFlowName +
						'" name in the "' + params.wizardKeyword + '" wizard configuration.');
					RecommenderWizardService.resetWizardData();
					Utilities.routeTo('/');
					return result;
				}

				RecommenderWizardService.steps = angular.copy(RecommenderWizardService.currentFlow.steps);
				if (RecommenderWizardService.steps.length > 0) {
					// create stageSelections keys if the flow has changed
					if (changeFlow) {
						RecommenderWizardService.createStageSelectionsForCurrentFlow();
					}

					RecommenderWizardService.storeWizardData();
					result = true;
				}
			} else {
				// This is set to true here to let the system know
				// that the flow is loaded.
				result = true;
			}

			return result;
		}

		function setCalendarPricingModuleDate() {
			Package.calendarPricingModuleDate = RecommenderWizardService.getCurrentStageSelections().selectedDate;
		}

		function populateCustomerTypeData(packageList) {
			packageList = packageList || [];
			packageList.forEach(function(pkg) {
				assignCustomerTypeGroupQuantities((pkg.packageDetails || pkg).CT);
			});
		}

		function filterKeywordCalendarPackages(dateObject) {
			var settings = RecommenderWizardService.getCurrentStepSettings();
			var maxPackagesLength = settings.maxDatedPackagesToDisplay || 3;
			var dates = dateObject.D || [];
			var filteredDates = [];

			dates.forEach(function(date) {
				var packageList = date.PS.P || [];

				// Truncate the list if it exceeds the max length
				if (packageList.length > maxPackagesLength) {
					packageList.length = maxPackagesLength
				}

				var newDateObject = angular.copy(date);
				newDateObject.PS.P = packageList;
				filteredDates.push(newDateObject);
			});

			dateObject.D = filteredDates;
		}

		/**
		 * Gets a (configurably sorted or not) list of AnyDay packages
		 * @public
		 * @returns {Object[]} Array of AnyDay package
		 */
		function getAnyDayPackages() {
			var settings = RecommenderWizardService.getCurrentStepSettings();
			var maxAnyDayPackagesToDisplay = angular.isDefined(settings.maxAnyDayPackagesToDisplay) ? settings.maxAnyDayPackagesToDisplay : 1;
			var anyDayKeywords = RecommenderWizardKeywordService.getKeywordArrayFromString(settings.anyDayKeyword);
			var anyDayPackages = RecommenderWizardService.settings.GetMerchantPackageList.PS.P.filter(function(pkg) {
				return RecommenderWizardKeywordService.packageFound(pkg, anyDayKeywords, RecommenderWizardEnumsService.KEYWORD_SEARCH_TYPE.EVERY);
			});

			if (angular.isDefined(anyDayPackages)) {
				anyDayPackages = angular.copy(anyDayPackages);

				// Truncate the package list according to the max display settings
				if (anyDayPackages.length > maxAnyDayPackagesToDisplay) {
					anyDayPackages.length = maxAnyDayPackagesToDisplay;
				}

				// Prepare the package for the wizard
				service.populateCustomerTypeData(anyDayPackages);
				if (RecommenderWizardService.config.displayOnlySelectedCTGroups) {
					anyDayPackages.forEach(function(pkg) {
						service.filterCustomerTypes(pkg);
					});
				}
			} else {
				anyDayPackages = [];
			}
			return anyDayPackages;
		}

		function routeToUpsell(upsellStateName) {
			var currentStageSelections = RecommenderWizardService.getCurrentStageSelections();
			storeUpsellData(currentStageSelections);
			RecommenderWizardRouteService.routeToUpsell(upsellStateName, currentStageSelections.selectedPackages[0].package_id);
			return true;
		}

		function storeUpsellData(currentStageSelections) {
			Package.preUpsellPkg = angular.copy(Package.packageDetails);

			if (Utilities.isEmpty(currentStageSelections.upsells)) {
				currentStageSelections.upsells = new RecommenderWizardModels.Upsells();
			}

			currentStageSelections.upsells.preUpsellPkg = angular.copy(Package.preUpsellPkg);
			currentStageSelections.upsells.upsellPackage = angular.copy(Package.upsellPackage);
			currentStageSelections.upsells.customerTypes = angular.copy(Package.customerTypes);
			RecommenderWizardService.storeWizardData();
		}

		function populateUpsellData() {
			var currentStageSelections = RecommenderWizardService.getCurrentStageSelections();

			if (Utilities.isEmpty(Package.packageDetails)) {
				Package.packageDetails = angular.copy(currentStageSelections.upsells.preUpsellPkg);
			}

			if (Utilities.isEmpty(Package.preUpsellPkg)) {
				Package.preUpsellPkg = angular.copy(currentStageSelections.upsells.preUpsellPkg);
			}

			if (Utilities.isEmpty(Package.upsellPackage.packageDetails)) {
				Package.upsellPackage = angular.copy(currentStageSelections.upsells.upsellPackage);
			}

			if (Utilities.isEmpty(Package.customerTypes)) {
				Package.customerTypes = currentStageSelections.upsells.customerTypes;
			}
		}

		function byPassUpsellStateChangeSuccess() {
			return true;
		}

		function isAllowedState(toState) {
			return RecommenderWizardEnumsService.ALLOWED_STATE_NAMES.some(function(stateName) {
				return toState.name == stateName;
			});
		}

		function setSessionId(contextData) {
			if (!contextData.sessionId) {
				contextData.sessionId = Utilities.guid();
			}
		}

		function addSessionDataToPackages(packages) {
			packages = packages || [];

			var currentStep = RecommenderWizardService.getCurrentStep();

			packages.forEach(function(pkg) {
				if (angular.isDefined(pkg.CHARACS)) {
					pkg.CHARACS.forEach(function(charac) {
						charac[RecommenderWizardEnumsService.PACKAGE_CHARACS.sessionId] = RecommenderWizardService.contextData.sessionId;

						if (angular.isDefined(currentStep.stageName)) {
							charac[RecommenderWizardEnumsService.PACKAGE_CHARACS.stageName] = currentStep.stageName;
						}
					});
				}
			});
		}

		/**
		 * itemAddedThisSession returns true if the cart item was added during this recommender wizard session and stage.
		 *   It is needed for when we're calculating quantities in the cart, so that we can ignore items that are
		 *   going to be replaced.
		 *
		 * Checking both the session and stage name means we're excluding only those items that match the current stage
		 * (i.e., are the same product we're about to add) and session (were added during this pass through the
		 * recommender wizard).
		 */
		function itemAddedThisSession(cartItem) {
			if (!cartItem.characs.length) {
				return false;
			}
			var currentStep = RecommenderWizardService.getCurrentStep(),
				sessionId = RecommenderWizardService.contextData.sessionId,
				stageName = angular.isDefined(currentStep) ? currentStep.stageName : undefined,
				charac = cartItem.characs[0];

			return (charac[RecommenderWizardEnumsService.PACKAGE_CHARACS.sessionId] == sessionId &&
					charac[RecommenderWizardEnumsService.PACKAGE_CHARACS.stageName] == stageName);
		}

		function prepareCartItemsForUpdateMode() {
			var currentStep = RecommenderWizardService.getCurrentStep();
			var sessionId = RecommenderWizardService.contextData.sessionId;
			var stageName = currentStep.stageName;

			// Prepare Cart for update
			LegacyCart.editingCartCopy = [];
			Package.cartItemsForCurrentPackage = [];

			// step 1, create a copy of the old cart.
			var cartCopy = Utilities.toOrderPreservingArray(LegacyCart.cartItems);

			// step 2, extract the current package items from this copy.
			var cartItemsForCurrentPackage = LegacyCart.cartItems.filter(function(cartItem) {
				var condition = false;

				if (angular.isDefined(cartItem.CHARACS)) {
					condition = cartItem.CHARACS.some(function(charac) {
						if (charac[RecommenderWizardEnumsService.PACKAGE_CHARACS.sessionId] == sessionId &&
							charac[RecommenderWizardEnumsService.PACKAGE_CHARACS.stageName] == stageName) {
							return true;
						}
					});
				}

				return condition;
			});

			// step 3, get a copy of the cart that contains none of the edited items
			cartCopy = cartCopy.filter(function(e) {
				return !cartItemsForCurrentPackage.some(function(i) {
					return (i.id == e.id);
				});
			});

			// step 3A - remove related one barcode items from the cart as they will get readded
			if (OneBarcodeUtilities.hasOneBarcodeItems(cartItemsForCurrentPackage)) {
				OneBarcodeUtilities.prepareOneBarcodeCartForEditing(cartItemsForCurrentPackage, cartCopy);
			}

			// Remove xfc references from cartItemsForCurrentPackage
			cartItemsForCurrentPackage.forEach(function(cartItem) {
				cartItem.CHARACS.forEach(function(charac) {
					delete charac.client_xfc_name;
					delete charac.client_xfc_view;
					delete charac.datetime_added;
				});
			});

			// step 4 - make the new cart collections public
			LegacyCart.editingCartCopy = cartCopy;
			Package.cartItemsForCurrentPackage = cartItemsForCurrentPackage;
		}

		function getSelectedDate() {
			return RecommenderWizardService.contextData.selectedDate;
		}

		function setSelectedPackageList(packageList) {
			var currentStageSelections = RecommenderWizardService.getCurrentStageSelections();
			currentStageSelections.selectedPackages.length = 0;
			packageList.forEach(function(pkg) {
				currentStageSelections.selectedPackages.push({
					customer_type: pkg.customer_type,
					package_id: pkg.package_id,
					qty: pkg.qty
				});
			});
			RecommenderWizardService.storeWizardData();
			return true;
		}

		function filterFastLaneItemListBySelectedCustomerTypeGroups(packageList) {
			packageList = packageList || [];
			for (var i = packageList.length - 1; i >= 0; i--) {
				service.filterCustomerTypes(packageList[i], true);
				if (packageList[i].CT.length === 0) {
					packageList.splice(i, 1);
				}
			}
			return true;
		}

		function populateFastLaneItemRateQuantities(items) {
			items = items || [];
			var currentStageSelections = RecommenderWizardService.getCurrentStageSelections();
			currentStageSelections.selectedPackages.forEach(function(selectedPackage) {
				items.forEach(function(item) {
					if (selectedPackage.package_id == item.packageId) {
						item.rates.forEach(function(rate) {
							if (selectedPackage.customer_type == rate.id) {
								rate.quantity = Number(selectedPackage.qty);
							}
						});
					}
				});
			});
			return true;
		}

		function populateCustomerTypeQuantities(items) {
			items = items || [];
			var currentStageSelections = RecommenderWizardService.getCurrentStageSelections();
			currentStageSelections.selectedPackages.forEach(function(selectedPackage) {
				items.forEach(function(item) {
					if (selectedPackage.package_id == item.id) {
						item.CT.forEach(function(ct) {
							if (selectedPackage.customer_type == ct.id) {
								ct.qty = Number(selectedPackage.qty);
							}
						});
					}
				});
			});
			return true;
		}


		function cancelSelectedPackages() {
			var currentStageSelections = RecommenderWizardService.getCurrentStageSelections();
			if (currentStageSelections.updateMode) {
				currentStageSelections.selectedPackages.length = 0;
				RecommenderWizardService.storeWizardData();
				updateCartItems([]);
			} else {
				// Pivot!!!
				if (RecommenderWizardRouteService.routeDirection === -1) {
					routeToPreviousStep();
				} else {
					routeToNextStep();
				}
			}
			return true;
		}

		function filterPackageListBySelectedCustomerTypeGroups(packageList) {
			packageList = packageList || [];
			for (var i = packageList.length - 1; i >= 0; i--) {
				service.filterCustomerTypes(packageList[i], true);
				if (packageList[i].CT.length === 0) {
					packageList.splice(i, 1);
				}
			}
			return true;
		}

		function hideParkHours() {
			return (RecommenderWizardRouteService.isStepNameInVisitedSteps('WizardCalendarPricingModule') ||
			RecommenderWizardRouteService.isStepNameInVisitedSteps('FastLaneWizardModule'));
		}

		function setForwardRouteDirection() {
			RecommenderWizardRouteService.routeDirection = 1;
		}

		function registerRecommenderWizardCustomAction(keyName, actionToExecute) {
			CustomActionService.registerCustomAction(keyName, actionToExecute, RecommenderWizardEnumsService.CUSTOM_ACTION_GROUP_NAME);
		}

		function deRegisterRecommenderWizardCustomActions() {
			CustomActionService.deregisterCustomActionsForGroup(RecommenderWizardEnumsService.CUSTOM_ACTION_GROUP_NAME);
		}

		/**
		 * Registers custom actions based on a state name.
		 * @public
		 * @name registerCustomActionsList
		 * @memberof {RecommenderWizardContextService}
		 * @param {String} stateName The states name
		 * @return {undefined}
		 */
		function registerCustomActionsByState(stateName) {
			switch (stateName) {
			case 'vertical-package-list':
				service.registerVerticalPackageList();
				break;
			case 'snapCalendarWizard':
				service.registerSnapCalendar();
				break;
			case 'guestOptions':
				service.registerGuestOptions();
				break;
			case 'fastlanewizard':
				service.registerFastLane();
				break;
			case 'wizardCalendar':
				service.registerCalendarPricing();
				break;
			case 'wizardPackageDetails':
				service.registerPackageDetails();
				break;
			case 'upsellRecommenderWizard':
				service.registerUpsells();
				break;
			case 'meals':
				service.registerMeals();
				break;
			case 'extras':
				service.registerExtras();
				break;
			case 'package-comparison-wizard':
				service.registerPackageComparison();
				break;
			}
		}

		return service;
	}
	);

/**
 * Created by jwroblewski on 12/22/2015.
 */
angular
	.module('recommender-wizard')
	.factory('RecommenderWizardEnumsService', function(){
		return {
			STORAGE_KEYS: {
				CONTEXT_DATA: '_RecommenderWizardContextData'
			},
			CUSTOM_ACTION_GROUP_NAME: 'RecommenderWizard',
			LOCALE_SECTION: 'RecommenderWizard',
			LOCALE_TARGETS: {
				WIZARD_DESC: 'Description',
				EXIT_MODAL_TITLE: 'ExitModalTitle',
				EXIT_MODAL_DESC: 'ExitModalDescription',
				CHECKOUT_MODAL_TITLE: 'CheckoutModalTitle',
				CHECKOUT_MODAL_DESC: 'CheckoutModalDescription'
			},
			STATE_PARAMS: {
				WIZARD_KEYWORD: 'recommenderWizardKeyword',
				KEYWORD: 'keyword',
				CROSSSELL: 'crosssell',
				PACKAGE_ID: 'packageId'
			},
			KEYWORD_CATEGORIES: {
				ADMISSION: 'admission',
				CUSTOMER_TYPE_GROUP: 'customerTypeGroup',
				GUEST_ORGANIZATION: 'guestOrganization',
				MEALS: 'meals',
				EXTRAS: 'extras'
			},
			KEYWORD_SEARCH_TYPE: {
				EVERY: 'every',
				SOME: 'some'
			},
			PACKAGE_CHARACS: {
				sessionId: 'recommender_wizard_session_id',
				stageName: 'recommender_wizard_stage_name'
			},
			ALLOWED_STATE_NAMES: [
				'upsellRecommenderWizard',
				'upsellRecommenderWizard.selection',
				'upsellRecommenderWizard.quantity',
				'upgradeRecommenderWizard',
				'unified-package-details.main'
			],
			ALT_FLOW_ACTIONS: {
				ROUTE_TO_KEYWORD: 'routeToKeyword',
				SWAP_SUBSEQUENT_FLOW_STEPS: 'swapSubsequentFlowSteps'
			}
		};
	}
);


/**
 * Created by jwroblewski on 1/7/2016.
 */
angular.module('recommender-wizard').factory
('RecommenderWizardKeywordService',
	function(
		RecommenderWizardEnumsService,
		RecommenderWizardService,
		Utilities
	) {
		var service = {
			getKeywordArrayFromString: getKeywordArrayFromString,
			getStageKeyword: getStageKeyword,
			setCustomerTypeGroup: setCustomerTypeGroup,
			setGuestOrganization: setGuestOrganization,
			setStageKeyword: setStageKeyword,
			setStageSelectionsKeywords: setStageSelectionsKeywords,
			packageFound: packageFound
		};

		// -------------------------------------------------------------------------------------------------------------
		// Public Functions
		// -------------------------------------------------------------------------------------------------------------
		/**
		 * Converts a comma separated string of keywords into an array
		 * @param {string} keywordString  the comma separated keywords
		 * @returns {Array} an array of keyword strings
		 */
		function getKeywordArrayFromString(keywordString) {
			keywordString = keywordString || '';
			var keywords = [];
			if (keywordString) {
				keywords = keywordString.split(',');
				keywords.forEach(function(keyword) {
					keyword.trim();
				});
			}
			return keywords;
		}

		/**
		 * Sets the keyword for the specified stage in the contextData
		 * @param {string} stageName  the name of the stage that the keyword is for
		 * @param {string} keyword  the keyword value to set
		 * @returns {void}
		 */
		function setStageKeyword(stageName, keyword) {
			//var keywords = RecommenderWizardService.contextData.keywords;
			//if (angular.isUndefined(keywords[stageName])) {
			//    keywords[stageName] = keyword;
			//}
			RecommenderWizardService.getStageSelections(stageName).keyword = keyword;
			RecommenderWizardService.storeWizardData();
		}

		/**
		 * Gets the keyword for the specified stage from contextData
		 * or the currentStep settings object if it exists
		 * @param {string} stageName  the name of the current stage
		 * @returns {string} the keyword value for the specified stage
		 */
		function getStageKeyword(stageName) {
			var stageKeyword = '';

			//if (angular.isDefined(stageName)) {
			//
			//    stageKeyword = RecommenderWizardService.contextData.keywords[stageName];
			//
			//    if (angular.isUndefined(stageKeyword)) {
			//        stageKeyword = getDefaultKeywordForStep();
			//    }
			//}

			var stageNameSelections = RecommenderWizardService.getStageSelections(stageName);
			stageKeyword = stageNameSelections.keyword;

			// If the stageKeyword is empty get the default keyword and set it in context data for future use
			if (!stageKeyword) {
				stageKeyword = getDefaultKeywordForStep();
				setStageKeyword(stageName, stageKeyword);
			}

			return stageKeyword;
		}

		function setCustomerTypeGroup(contextData, ctGroups) {
			contextData.keywords.customerTypeGroup.length = 0;
			if (ctGroups.length > 0) {
				var keywordString = '';
				ctGroups.forEach(function(group, idx) {
					keywordString += ((idx > 0) ? ',' : '') + group.keyword;
				});
				contextData.keywords.customerTypeGroup = getKeywordArrayFromString(keywordString);
			}
		}

		function setGuestOrganization(contextData) {
			//contextData.keywords.guestOrganization.length = 0;
			var currentStep = RecommenderWizardService.getCurrentStep();
			var currentStepSettings = RecommenderWizardService.getCurrentStepSettings();

			if (angular.isDefined(currentStep.stageName)) {
				if (Utilities.safelyCheckPropertyOnObject('currentStepSettings.guestOrganizationSelector.dataKey', currentStepSettings)) {
					deleteStageKeywords(currentStep.stageName);
					var contextDataKey = currentStepSettings.guestOrganizationSelector.dataKey;
					var selectorRule = currentStepSettings.guestOrganizationSelector.rules.filter(function(rule) {
						return rule.value === contextData[contextDataKey];
					})[0];

					// Set current stage keyword to the guest organization
					if (Utilities.safelyCheckPropertyOnObject('selectorRule.keyword', selectorRule)) {
						setStageKeyword(currentStep.stageName, selectorRule.keyword);
					}
				}
			}
		}

		/**
		 * case-insensitive keyword search on a single package.
		 * @param {Object} pkg  the package to compare the searchKeywords against.
		 * @param {Array} searchKeywords  an array of keywords to search for
		 * @param {string} searchType  indicates which matching logic to use, -
		 * use the RecommenderWizardEnumsService.KEYWORD_SEARCH_TYPE object to set its value.
		 * @returns {boolean} if the searchKeywords match the package keywords, this will return true.
		 */
		function packageFound(pkg, searchKeywords, searchType) {
			searchKeywords = searchKeywords || [];
			var result = false;

			if (Utilities.safelyCheckPropertyOnObject('pkg.KEYWORDS.K', pkg)) {
				// Add the package keywords to a lookup object.
				var lookup = {};
				pkg.KEYWORDS.K.forEach(function(kw) {
					var keyword = kw.keyword.toLowerCase();
					lookup[keyword] = keyword;
				});

				switch (searchType) {
				case RecommenderWizardEnumsService.KEYWORD_SEARCH_TYPE.EVERY:
					result = searchKeywords.length > 0 ? searchKeywords.every(function(searchKeyword) {
						return angular.isDefined(lookup[searchKeyword.toLowerCase()]);
					}) : false;
					break;
				default:
					result = searchKeywords.some(function(searchKeyword) {
						return angular.isDefined(lookup[searchKeyword.toLowerCase()]);
					});
					break;
				}
			}

			return result;
		}

		function setStageSelectionsKeywords() {
			resetStageSelectionKeywords();
			var keywordMap = RecommenderWizardService.getCurrentKeywordMap();

			if (angular.isDefined(keywordMap)) {
				var currentStageSelections = RecommenderWizardService.getCurrentStageSelections();

				currentStageSelections.assocKeywords.forEach(function(assocKeyword) {
					var assocKeywordMap = keywordMap[assocKeyword];
					if (angular.isDefined(assocKeywordMap)) {
						Object.keys(assocKeywordMap).forEach(function(targetStageName) {
							setStageKeyword(targetStageName, assocKeywordMap[targetStageName])
						});
					}
				});
			}
		}

		// -------------------------------------------------------------------------------------------------------------
		// Private Functions
		// -------------------------------------------------------------------------------------------------------------
		function getDefaultKeywordForStep() {
			var settings = RecommenderWizardService.getCurrentStepSettings();
			return settings.keyword || '';
		}

		function deleteStageKeywords(stageName) {
			//delete RecommenderWizardService.contextData.keywords[stageName];
			RecommenderWizardService.getStageSelections(stageName).keyword = '';
		}

		function resetStageSelectionKeywords() {
			var currentStageKeywordMap = RecommenderWizardService.getCurrentStageKeywordMap();
			if (angular.isDefined(currentStageKeywordMap)) {
				var stageSelections = RecommenderWizardService.contextData.stageSelections;
				var currentStageName = RecommenderWizardService.getCurrentStep().stageName;
				Object.keys(stageSelections).forEach(function(key) {
					if (key != currentStageName) {
						stageSelections[key].keyword = '';
					}
				});
			}
		}

		return service;
	}
);

/**
 * Created by jwroblewski on 1/30/2016.
 */
angular.module('recommender-wizard').factory
('RecommenderWizardLoaderService',
	function(
		$rootScope,
		$timeout,
		Language,
		Modal,
		RecommenderWizardEnumsService,
		RecommenderWizardService,
		Utilities
	) {
		/**
		 * Tracks the status of the loader timer
		 * @type {Boolean}
		 */
		var hasMinLoaderTimeElapsed = false;

		/**
		 * Tracks the loading Status of the current step
		 * @type {Boolean}
		 */
		var isCurrentStepReady = false;

		var service = {
			loadingScreenShowing: false,
			dismissLoader: dismissLoader,
			setCurrentStepReadyStatus: setCurrentStepReadyStatus,
			showLoader: showLoader
		};

		// -------------------------------------------------------------------------------------------------------------
		// Public Functions
		// -------------------------------------------------------------------------------------------------------------
		/**
         * Displays the recommender wizard loading screen
         * @param {Object} currentStep  the current step in the current flow
         * @returns {Boolean} returns true if the loader actually displays,
         * false if the loader was not defined for the current step.
         */
		function showLoader(currentStep) {
			var loadingScreen = currentStep.loadingScreen;

			// If the loading screen object is not provided on the step
			// Then don't display the loader
			if (angular.isUndefined(loadingScreen)) {
				return false;
			}

			// The loading screen is defined on this step
			// so display the loading screen

			// Prevent other promises from showing the spinner while the loading screen is up
			$rootScope.disableSpinner = true;
			$rootScope.hideSpinner();

			hasMinLoaderTimeElapsed = false;
			isCurrentStepReady = false;
			var locales = loadingScreen.locales || {};
			var loaderImage = '';
			if (loadingScreen.imageFolder && loadingScreen.imageFolder !== '' && loadingScreen.imageName && loadingScreen.imageName !== '') {
				// Ensure empty configurations do not lead a 404 error
				loaderImage = RecommenderWizardService.getFullImageUrl(loadingScreen.imageFolder, loadingScreen.imageName);
			}
			var loaderTitle = Language.getLocale(RecommenderWizardEnumsService.LOCALE_SECTION, locales.titleTarget);
			var loaderStageList = [];
			var stageCounter = 0;
			RecommenderWizardService.steps.forEach(function(step, idx) {
				if (angular.isDefined(step.loadingScreen)) {
					stageCounter++;
					var stageLocales = step.loadingScreen.locales || {};
					var stageLabel = Language.getLocale(RecommenderWizardEnumsService.LOCALE_SECTION, stageLocales.labelTarget);
					var isPreviousStage = (idx < RecommenderWizardService.currentStepIndex) && RecommenderWizardService.contextData.visitedSteps.indexOf(step.name) > -1;
					var isCurrentStage = (idx === RecommenderWizardService.currentStepIndex);
					loaderStageList.push({
						counter: stageCounter,
						label: stageLabel,
						selected: isCurrentStage,
						previous: isPreviousStage
					});
				}
			});
			$timeout(setMinLoadingTimeElapsed, RecommenderWizardService.config.minimumLoadScreenInterval);
			service.loadingScreenShowing = true;
			Modal.displayModal({
				label: 'RecommenderWizardLoading',
				image: loaderImage,
				customDescription: loaderTitle,
				trueFullscreen: true,
				customHTML: '/views/modals/recommender-wizard-loader.html',
				description: loaderStageList,
				customCardClasses: $rootScope.isBrandMode ? 'recommender-wizard-loader--brand-mode' : 'recommender-wizard-loader',
				hideAllButtons: true
			});
			return true;
		}

		/**
         * Hides the loader.
         * Call this function when the current step is ready for use.
		 * @returns {undefined}
         */
		function setCurrentStepReadyStatus() {
			isCurrentStepReady = true;
			hideLoader();
		}

		// -------------------------------------------------------------------------------------------------------------
		// Private Functions
		// -------------------------------------------------------------------------------------------------------------
		function setMinLoadingTimeElapsed() {
			hasMinLoaderTimeElapsed = true;
			hideLoader();
		}

		function dismissLoader() {
			if (service.loadingScreenShowing) {
				hasMinLoaderTimeElapsed = false;
				isCurrentStepReady = false;
				service.loadingScreenShowing = false;
				Modal.hideModal();
				$rootScope.disableSpinner = false;
			}
		}

		function hideLoader() {
			if (hasMinLoaderTimeElapsed && isCurrentStepReady === true) {
				hasMinLoaderTimeElapsed = false;
				isCurrentStepReady = false;
				service.loadingScreenShowing = false;
				Modal.hideModal();
				$rootScope.disableSpinner = false;
			}
		}
		return service;
	}
);

/**
 * Created by jwroblewski on 12/7/2015.
 */
angular.module('recommender-wizard').factory
('RecommenderWizardPrepService',
	function(
		$rootScope,
		AppData,
		Enums,
		RouteRejectionService,
		JSONValidator,
		RecommenderWizardService,
		Utilities
	) {
		var MAIN_APP_CONFIG_NAME = 'recommender_wizard',
			FLOW_APP_CONFIG_PREFIX = 'recommender_wizard_flow',
			factory = { getSettings: getSettings };

		return factory;

		/**
		 * Configures the RecommenderWizardService with applicable
		 * settings from AppData
		 * @returns {undefined}
		 */
		function getSettings() {
			var config = parseAndCreateWizardConfigList();
			if (Utilities.isEmpty(config)) {
				// throw a view exception letting OPS know that the packages are not
				// configured properly (this defaults to ErrorCode 300)
				throw new RouteRejectionService.ViewException();
			} else {
				RecommenderWizardService.settings.configList = config;
				RecommenderWizardService.settings.GetMerchantPackageList = AppData.GetMerchantPackageList;
				RecommenderWizardService.settings.assetsUrl = $rootScope.assetsPath;
			}
		}

		/**
		 * Parse the app config for the wizard config list
		 * @returns {Object} the wizard config list
		 */
		function parseAndCreateWizardConfigList() {
			var wizardConfigList = {};

			if (JSONValidator.validate(MAIN_APP_CONFIG_NAME, AppData.settings.recommender_wizard)) {
				wizardConfigList = JSON.parse(AppData.settings[MAIN_APP_CONFIG_NAME]);
				wizardConfigList.wizards.forEach(function(wizardConfigSection) {
					var wizardFlowAppConfig = AppData.settings[FLOW_APP_CONFIG_PREFIX + '_' + wizardConfigSection.wizardKeyword];
					if (angular.isDefined(wizardFlowAppConfig) && JSONValidator.validate(FLOW_APP_CONFIG_PREFIX, wizardFlowAppConfig)) {
						var flowConfig = JSON.parse(wizardFlowAppConfig);
						if (angular.isUndefined(flowConfig.flows)) {
							throw new RouteRejectionService.ViewException();
						} else {
							wizardConfigSection.flows = flowConfig.flows;
						}
					}
				})
			}
			return angular.isDefined(wizardConfigList.wizards) ? wizardConfigList.wizards : wizardConfigList;
		}
	}
);

/**
 * Created by jwroblewski on 1/30/2016.
 */
angular
	.module('recommender-wizard')
	.factory('RecommenderWizardRouteService', function(
		$log,
		$rootScope,
		$state,
		Enums,
		GuestOptionsEnumsService,
		Language,
		Modal,
		Package,
		RouteRejectionService,
		Utilities,
		UtilsValidation,
		RecommenderWizardEnumsService,
		RecommenderWizardKeywordService,
		RecommenderWizardLoaderService,
		RecommenderWizardService
	) {
		var isString = angular.isString,
			validArray = UtilsValidation.validArray;

		var service = {
			displayCheckoutWizardModal: displayCheckoutWizardModal,
			displayExitWizardModal: displayExitWizardModal,
			ensureRouteHasCustomerTypes: ensureRouteHasCustomerTypes,
			hasCustomerTypeSelected: hasCustomerTypeSelected,
			isFirstStep: isFirstStep,
			isLastStep: isLastStep,
			isStateInSteps: isStateInSteps,
			isStepNameInVisitedSteps: isStepNameInVisitedSteps,
			nextStep: nextStep,
			rejectRouteForCustomerTypes: rejectRouteForCustomerTypes,
			routeDirection: 0,
			routeToCurrentStep: routeToCurrentStep,
			routeToUpsell: routeToUpsell,
			setCurrentStep: setCurrentStep,
			previousStep: previousStep,
			firstStep: firstStep,
			showingModalToExitWizard: false,
			guardTheGate: true, // indicates we should show the "are you sure you want to leave" modal
			errorToFront: errorToFront
		};

		return service;

		// -------------------------------------------------------------------------------------------------------------
		// Public Functions
		// -------------------------------------------------------------------------------------------------------------
		/**
		 * Sets the RecommenderWizardService.currentStepIndex if the step.stateName property matches
		 * the currentStateName.  It also adds the step to the RecommenderWizardService.contextData.visitedSteps array.
		 * If there is no match this value remains unchanged no entry is made in the array.
		 * @param {string} currentStateName the name of the state that matches
		 * @returns {undefined}
		 */
		function setCurrentStep(currentStateName) {
			for (var stepIndex = 0; stepIndex < RecommenderWizardService.steps.length; stepIndex++) {
				var step = RecommenderWizardService.steps[stepIndex];
				if (step.stateName.indexOf(currentStateName) !== -1) {
					RecommenderWizardService.currentStepIndex = stepIndex;
					addVisitedStep(RecommenderWizardService.getCurrentStep().name);
					break;
				}
			}
			// if we're past the first step, set the flag to warn the user about leaving
			service.guardTheGate = (RecommenderWizardService.currentStepIndex > 0);
		}

		/**
		 * Decrements theRecommenderWizardService.currentStepIndex by 1 and starts the backward route
		 * @returns {undefined}
		 */
		function previousStep() {
			service.routeDirection = -1;
			RecommenderWizardService.currentStepIndex = RecommenderWizardService.currentStepIndex + service.routeDirection;
			$rootScope.showSpinner();
			routeToCurrentStep();
		}

		/**
		 * Sets the RecommenderWizardService.currentStepIndex to 0 to start at the first step.
		 * @returns {undefined}
		 */
		function firstStep() {
			RecommenderWizardService.currentStepIndex = 0;
			routeToCurrentStep();
		}

		/**
		 * Increments theRecommenderWizardService.currentStepIndex by 1 and starts the forward route
		 * @param {boolean} shouldReplaceRoute If the browser history should be overwritten instead appended to
		 * @returns {undefined}
		 */
		function nextStep(shouldReplaceRoute) {
			var currentStep;

			service.routeDirection = 1;
			RecommenderWizardService.currentStepIndex = RecommenderWizardService.currentStepIndex + service.routeDirection;
			currentStep = RecommenderWizardService.getCurrentStep();

			if (!RecommenderWizardLoaderService.showLoader(currentStep)) {
				$rootScope.showSpinner();
			}
			routeToCurrentStep(shouldReplaceRoute);
		}

		/**
		 * Use this to find out if a specific step in the current flow has been visited.
		 * @param {string} stepName the name of the step to determine if the guest has visited
		 * @returns {boolean} If the guest has visited the step that matches the stepName this will return true, else false.
		 */
		function isStepNameInVisitedSteps(stepName) {
			return RecommenderWizardService.contextData.visitedSteps.indexOf(stepName) > -1;
		}

		/**
		 * Use this to see if a specific state is in the current flow.
		 * @param {string} stateName the name of the state to check
		 * @param {boolean} treatCartAsNotInWizard if true, the cartView state will be treated as not in the wizard
		 * @returns {boolean} returns true if the state is found in the steps, false if not.
		 */
		function isStateInSteps(stateName, treatCartAsNotInWizard) {
			// The cart can be listed in the wizard steps, but when the user is viewing the cart,
			// we do not want the regular "leaving the wizard" modals to appear
			if (treatCartAsNotInWizard && stateName.indexOf('cartView') !== -1) {
				return false;
			}
			var match = false;
			var validSnapStateForSnapWizardResult = /^snap-calendar(?:-wizard)?\.(?:legacy-)?(?:results|package)$/i;
			var matchingSteps = RecommenderWizardService.steps.filter(function(step) {
				var stateMatches = step.stateName === stateName;

				// This is custom due to the fact that snap-calendar-wizard.result/legacy and .package are technically -
				// the same step in recommender wizard
				if (!stateMatches && validSnapStateForSnapWizardResult.test(stateName) &&
					step.stateName === 'snap-calendar-wizard.results') {
					return true;
				}

				return stateMatches;
			});
			if (matchingSteps.length > 0) {
				match = true;
				$log.info('[RecommenderWizardStateService]: wizard step detected from state: ' + stateName);
			}
			return match;
		}

		/**
		 * Use this to determine if the current step is the first step in the current flow.
		 * @returns {boolean} returns true if the current step is first in the current flow, false if not.
		 */
		function isFirstStep() {
			return (RecommenderWizardService.currentStepIndex === 0);
		}

		/**
		 * Use this to determine if the current step is the last step in the current flow.
		 * @returns {boolean} returns true if the current step is last in the current flow, false if not.
		 */
		function isLastStep() {
			return (RecommenderWizardService.currentStepIndex >= RecommenderWizardService.steps.length-1);
		}

		/**
		 * Prompt the user with an option to cancel or continue if they do something to cause them
		 * to exit the wizard flow
		 * @param {string}  toStateName if the user decides to exit the wizard, this is the state that it will route to
		 * @param {Object} toStateParams the parameters for the toState
		 * @returns {undefined}
		 */
		function displayExitWizardModal(toStateName, toStateParams) {
			var wizardDescription = getWizardDescription();

			var title = Language.getLocale(RecommenderWizardEnumsService.LOCALE_SECTION,
				RecommenderWizardEnumsService.LOCALE_TARGETS.EXIT_MODAL_TITLE);

			var description = Language.getLocale(RecommenderWizardEnumsService.LOCALE_SECTION,
				RecommenderWizardEnumsService.LOCALE_TARGETS.EXIT_MODAL_DESC);

			// Replace the wizard description in the locale text if it exists
			if (angular.isDefined(wizardDescription)) {
				var replace = getWizardDescriptionReplaceText();

				title = Language.replaceAll(replace, wizardDescription, title);
				description = Language.replaceAll(replace, wizardDescription, description);
			}

			service.showingModalToExitWizard = true;

			// we're already showing the modal. No need to show another one if they hit the back button while this one is up.
			service.guardTheGate = false;

			Modal.displayModal
			(
				{
					label: 'RecommenderWizardExit',
					title: title,
					description: description,
					showCloseButton: false,
					buttonFlags: [Enums.buttonFlags.CANCEL, Enums.buttonFlags.CONTINUE_SHOPPING],
					callback: function(detail) {
						Modal.hideModal();
						service.showingModalToExitWizard = false;
						if (detail === Enums.buttonFlags.CONTINUE_SHOPPING) {
							RecommenderWizardService.resetWizardData();
							Package.itemsToBeAdded = [];
							service.guardTheGate = false;
							$rootScope.routeTo($state.href(toStateName, toStateParams));
						} else {
							// cancelled out. We want to keep guarding the gate.
							service.guardTheGate = true;
						}
					}
				}
			);
		}

		/**
		 * Prompt the user with an option to cancel or checkout before they navigate to the cart.
		 * @param {function} callback  this gets executed when the guest selects the checkout option in case
		 * anything needs to be done while routing to the cart.
		 * @returns {undefined}
		 */
		function displayCheckoutWizardModal(callback) {
			var wizardDescription = getWizardDescription();

			var title = Language.getLocale(RecommenderWizardEnumsService.LOCALE_SECTION,
				RecommenderWizardEnumsService.LOCALE_TARGETS.CHECKOUT_MODAL_TITLE);

			var description = Language.getLocale(RecommenderWizardEnumsService.LOCALE_SECTION,
				RecommenderWizardEnumsService.LOCALE_TARGETS.CHECKOUT_MODAL_DESC);

			// Replace the wizard description in the locale text if it exists
			if (angular.isDefined(wizardDescription)) {
				var replace = getWizardDescriptionReplaceText();

				title = Language.replaceAll(replace, wizardDescription, title);
				description = Language.replaceAll(replace, wizardDescription, description);
			}

			var lastStepIndex = RecommenderWizardService.steps.length - 1;
			Modal.displayModal
			(
				{
					label: 'RecommenderWizardCart',
					title: title,
					description: description,
					showCloseButton: false,
					buttonFlags: [Enums.buttonFlags.CANCEL, Enums.buttonFlags.PROCEED_TO_CHECKOUT],
					callback: function(detail) {
						if (detail === Enums.buttonFlags.CANCEL) {
							// Don't go anywhere. This modal is happening before the state change is started.
						} else if (detail === Enums.buttonFlags.PROCEED_TO_CHECKOUT) {
							RecommenderWizardService.currentStepIndex = lastStepIndex;
							// Resetting the wizard data on the last step re-enables spinner, ensure it is stays hidden -
							// during the last step of the wizard loader
							RecommenderWizardService.resetWizardData(true);
							$rootScope.routeTo(Enums.routes.CART);
							if (angular.isDefined(callback)) {
								callback();
							}
						}
					}
				}
			);
		}

		function routeToUpsell(upsellStateName, packageId) {
			var stateParams = {},
				route;
			addRequiredStateParams(stateParams);
			stateParams.packageId = packageId;

			// This is always a forward route from package details
			service.routeDirection = 1;

			route = $state.href(upsellStateName, stateParams);
			$rootScope.routeTo(route, undefined, undefined, false);
		}

		function errorToFront(wizardKeyword) {
			// don't show the "leaving the wizard" confirmation modal to the customer. There's no choice.
			service.guardTheGate = false;

			// if we don't have a keyword, we don't know which wizard to go to, return to the front of the store.
			if (angular.isUndefined(wizardKeyword) || (wizardKeyword.length < 1)) {
				throw new RouteRejectionService.UnrecoverableException('/packageList');
			} else {
				RecommenderWizardService.resetWizardData();
				// don't like having "recommenderWizard" hard-coded here, but I don't know what
				// else to do. After a refresh, none of our data is populated.
				throw new RouteRejectionService.UnrecoverableException('recommenderWizard', { keyword: wizardKeyword });
			}
		}

		/**
		 * Find out if we need to reject visiting a route due to not having customer types selected.
		 * @public
		 * @function
		 * @name ensureRouteHasCustomerTypes
		 * @memberof {RecommenderWizardRouteService}
		 * @param {String} routeName The route name before transitioning to the new route
		 * @param {Object} routeParams The route params before transitioning to the new route
		 * @throws {RouteRejectionService.ViewException}
		 * @returns {undefined}
		 */
		function ensureRouteHasCustomerTypes(routeName, routeParams) {
			// If they are coming to this page from a first page view they won't have a routeTo value. Don't reroute -
			// as our Recommender Wizard will do it for us.
			if (routeName && !this.hasCustomerTypeSelected(RecommenderWizardService.contextData.customerTypeGroupList)) {
				this.rejectRouteForCustomerTypes(routeName, routeParams);
			}
		}

		/**
		 * Find out if we have a number of guests selected.
		 * @public
		 * @function
		 * @name hasCustomerTypeSelected
		 * @memberof {RecommenderWizardRouteService}
		 * @param {Array<Object>} customerTypes Our customer types array.
		 * For instance: RecommenderWizardService.contextData.customerTypeGroupList.
		 * @returns {boolean} if we have at least 1 quantity selected in our customer types
		 */
		function hasCustomerTypeSelected(customerTypes) {
			var quantity;
			if (!Array.isArray(customerTypes) || !customerTypes.length) {
				return false;
			}

			quantity = customerTypes.reduce(function(total, type) {
				return total + parseInt(type.qty, 10);
			}, 0);

			if (isNaN(quantity)) {
				return false;
			}

			return quantity > 0;
		}

		/**
		 * Reroute and show the min quantity modal.
		 * @public
		 * @function
		 * @name rejectRouteForCustomerTypes
		 * @memberof {RecommenderWizardRouteService}
		 * @param {String} routeToName The route they should be going to
		 * @param {Object} routeToParams The params to send.
		 * @throws {RouteRejectionService.ViewException} Throws exception to send them back to where they came from with
		 * a message that they need to select a guest quantity
		 * @returns {undefined}
		 */
		function rejectRouteForCustomerTypes(routeToName, routeToParams) {
			if (!isString(routeToName) || !routeToName.length) {
				routeToName = '/';
			}

			throw new RouteRejectionService.ViewException(GuestOptionsEnumsService.localeSection,
				GuestOptionsEnumsService.minQtyTitle, GuestOptionsEnumsService.minQtyDesc, routeToName, routeToParams);
		}

		// -------------------------------------------------------------------------------------------------------------
		// Private Functions
		// -------------------------------------------------------------------------------------------------------------
		function addVisitedStep(stepName) {
			if (!isStepNameInVisitedSteps(stepName)) {
				RecommenderWizardService.contextData.visitedSteps.push(stepName);
			}
		}

		/**
		 * Routes to the current step
		 * @function
		 * @param {boolean} shouldReplaceRoute If the browser history should be overwritten instead appended to
		 * @returns {undefined}
		 */
		function routeToCurrentStep(shouldReplaceRoute) {
			var currentStep = RecommenderWizardService.getCurrentStep();
			var stateParams = getStateParams(currentStep);
			// Force reload when already on the target state to prevent an IGNORED transition (e.g. re-entering wizard from step 0).
			var needsReload = $state.current.name === currentStep.stateName;

			// This function may be called when routing backwards, ensure we can move forward from packageDetails
			if (!Package.alternateModuleItemsToBeAdded && validArray(Package.itemsToBeAdded)) {
				Package.alternateModuleItemsToBeAdded = Package.itemsToBeAdded;
			}

			// Route to the state
			Utilities.goTo(currentStep.stateName, stateParams, shouldReplaceRoute, needsReload);

			// If the last step of the flow, reset the wizard data
			if (isLastStep()) {
				RecommenderWizardService.resetWizardData(true);
			}
		}

		function getStateParams(currentStep) {
			var stateParams = {};
			addRequiredStateParams(stateParams);
			addOptionalStateParams(stateParams, currentStep);
			return stateParams;
		}

		function addRequiredStateParams(stateParams) {
			stateParams[RecommenderWizardEnumsService.STATE_PARAMS.WIZARD_KEYWORD] = RecommenderWizardService.config.wizardKeyword;
		}

		function addOptionalStateParams(stateParams, currentStep) {
			// keyword
			var keywordParam = RecommenderWizardEnumsService.STATE_PARAMS.KEYWORD;
			if (paramExistsOnState(currentStep.stateName, keywordParam) &&
				angular.isDefined(currentStep.stageName)) {
				stateParams[keywordParam] = RecommenderWizardKeywordService.getStageKeyword(currentStep.stageName);
				// using @@ to mark when a package property should be used instead of a keyword.
				if (stateParams[keywordParam] === '@@crosssell') {
					var pkg = RecommenderWizardService.wizardAdmissionsPackage();
					if (Utilities.safelyCheckPropertyOnObject('pkg.CROSS_SELL.CS', pkg)) {
						stateParams[keywordParam] = (angular.isArray(pkg.CROSS_SELL.CS)) ? pkg.CROSS_SELL.CS[0].keyword : pkg.CROSS_SELL.CS.keyword;
						if (angular.isUndefined(stateParams[keywordParam])) { // should never happen.
							stateParams[keywordParam] = '@@crosssell'; // But if it does, there's nothing to look for
						}
					}
				}
			}

			// Dynamic Pricing
			if (RecommenderWizardService.contextData.dynamicPricing) {
				stateParams.dynamicPricing = RecommenderWizardService.contextData.dynamicPricing;
			}

			// packageId
			var packageIdParam = RecommenderWizardEnumsService.STATE_PARAMS.PACKAGE_ID;
			var isPackageIdOnStepSettings = Utilities.safelyCheckPropertyOnObject('currentStep.settings.packageId', currentStep);
			if (paramExistsOnState(currentStep.stateName, packageIdParam) &&
				(angular.isDefined(RecommenderWizardService.getCurrentStageSelections().selectedPackages[0]) || isPackageIdOnStepSettings)
			) {
				stateParams[packageIdParam] = !isPackageIdOnStepSettings ? RecommenderWizardService.getCurrentStageSelections().selectedPackages[0].package_id : currentStep.settings.packageId;
			}
		}

		function paramExistsOnState(stateName, param) {
			var stateToCheck = $state.get(stateName === '/cartView' ? 'cart.view' : stateName);

			if (Utilities.checkProp('stateToCheck.url', stateToCheck, 'validString')) {
				return stateToCheck.url.indexOf(':' + param) !== -1;
			}
		}

		/**
		 * The locale for the wizard description combines the wizardKeyword for the wizard and the wizard desc locale
		 * @returns {string} the wizard description
		 */
		function getWizardDescription() {
			return Language.getLocale(RecommenderWizardEnumsService.LOCALE_SECTION,
				(RecommenderWizardService.config.wizardKeyword + RecommenderWizardEnumsService.LOCALE_TARGETS.WIZARD_DESC));
		}

		/**
		 * Gets the replacement value which is a combination of the Locale Section and the wizard desc locale
		 * @returns {string} the wizard description replace text
		 */
		function getWizardDescriptionReplaceText() {
			return '@@' + RecommenderWizardEnumsService.LOCALE_SECTION +
				RecommenderWizardEnumsService.LOCALE_TARGETS.WIZARD_DESC;
		}
	}
	);

/**
 * Created by jwroblewski on 12/28/2015.
 */
angular
	.module('recommender-wizard')
	.factory('RecommenderWizardStateService', function(
		$log,
		$rootScope,
		$transitions,
		AnalyticsDataLayerService,
		Enums,
		ExtraFlowValidationService,
		IdleTimeout,
		Modal,
		RecommenderWizardContextService,
		RecommenderWizardLoaderService,
		RecommenderWizardRouteService,
		RecommenderWizardService,
		Utilities
	) {

		/**
		 * Checks if a value is an array.
		 * @function
		 * @protected
		 */
		var isArray = Array.isArray;

		/**
		 * Checks if a value is an Object.
		 * @function
		 * @protected
		 */
		var ngObject = angular.isObject;

		/**
		 * Holds the callback to deregister the $onStateChangeSuccess if assigned
		 * @protected
		 * @type {Function}
		 */
		var onSuccessDeregister;

		//
		// State changes
		//
		$transitions.onStart({}, onStateChangeStart);
		$transitions.onError({from: 'wizardCalendar', to:'wizardCalendar'}, onTransitionError);
		$transitions.onError({from: 'snap-calendar-wizard.*', to:'snap-calendar-wizard.*'}, onTransitionError);
		$transitions.onError({}, onWizardLoadError);
		$rootScope.$on('$viewContentLoaded', onViewContentLoaded);

		/**
		 * Callback for state change error for wizard calendar
		 * @public
		 * @function
		 * @name onTransitionError
		 * @memberof {RecommenderWizardStateService}
		 * @param {Transition} trans transition object from uiRouter
		 * @returns {undefined}
		 */
		function onTransitionError (trans) {
			var rejection = trans.error();
			if (rejection.type === Enums.transitionRejectionType.IGNORED) { //if ignored status remain at state and hide loader
			  if(trans.to().name === 'wizardCalendar'){
				RecommenderWizardContextService.registerCalendarPricing();
			  }
			  RecommenderWizardLoaderService.setCurrentStepReadyStatus();
			}
		 }

		/**
		 * Dismisses the wizard loader when a resolve error occurs while it's showing.
		 * Skips aborted (type 3), superseded (type 2), and ignored (type 5) transitions
		 * since those are intentional (e.g. component lazy-loading aborts).
		 * @param {Transition} trans transition object from uiRouter
		 * @returns {undefined}
		 */
		function onWizardLoadError(trans) {
			var rejection = trans.error();
			if (rejection.type === Enums.transitionRejectionType.SUPERSEDED || rejection.type === Enums.transitionRejectionType.ABORTED || rejection.type === Enums.transitionRejectionType.IGNORED) {
				return;
			}
			if (RecommenderWizardLoaderService.loadingScreenShowing) {
				RecommenderWizardLoaderService.dismissLoader();
			}
		}

		/**
		 * The callback when the state change starts
		 * @public
		 * @function
		 * @name onStateChangeStart
		 * @memberof {RecommenderWizardStateService}
		 * @param {Transition} trans The Transition object
		 * @return {undefined}
		 */
		function onStateChangeStart(trans) {
			var toState = trans.to();
			var toParams = trans.params('to');
			var fromState = trans.from();
			var fromParams = trans.params('from');
			var wizardInitialized = RecommenderWizardService.isInitialized;
			var inWizard = wizardInitialized && RecommenderWizardContextService.stateInWizard(fromState, fromParams, true);
			var toCart = toState.name === 'cart.view';
			var steps = RecommenderWizardService.steps;
			var currentStepIndex = RecommenderWizardService.currentStepIndex;
			var stepAction = '';
			var label = '';

			// PEC perceived-load prototype: while in the wizard, the global loader that fills the
			// small gaps between the wizard's own step loaders must be the legacy spinner, not the
			// skeleton. This onStart guard runs app-wide, so set the flag on every transition: off
			// only while the destination is genuinely a wizard step, restored to the SHOW_SKELETON
			// global everywhere else. The restore must be unconditional (not gated on a wizard being
			// initialized) because some exit paths reset the wizard *before* navigating away — so
			// isInitialized is already false on the leaving transition, and a guarded restore would
			// leave the skeleton stuck off for the rest of the session. Per-route opt-outs (e.g.
			// accesso-pay) set the flag in their resolve, which runs after this hook, so they still
			// win. The wizard *entry* hop is handled by the recommenderWizard resolve (isInitialized
			// is not set yet here). No-op when ?skeleton is off.
			$rootScope.showSkeletonLoader = (wizardInitialized && RecommenderWizardContextService.stateInWizard(toState, toParams, false))
				? false
				: !!(window.accesso && window.accesso.SHOW_SKELETON);

			addOrRemoveOnStateChangeSuccess(wizardInitialized, toCart);

			if (toCart && Utilities.safelyCheckPropertyOnObject('fromParams.recommenderWizardKeyword', fromParams)) {
				stepAction = 'Wizard Complete';
				label = 'Cart View';
				broadcastAnalyticsEvents(steps, stepAction, label);
			} else if (wizardInitialized) {
				if (ExtraFlowValidationService.isActiveXFCRoute(toState, trans.params('to'))) {
					stepAction = 'Step ' + (parseInt(currentStepIndex, 10) + 2) + ' - Extra Movie';
					label = toState.name;
					broadcastAnalyticsEvents(steps, stepAction, label);
				} else if (ExtraFlowValidationService.isActiveXFCRoute(fromState, fromParams)) {
					stepAction = 'Step ' + (parseInt(currentStepIndex, 10) + 2);
					label = ngObject(steps[currentStepIndex]) ? steps[currentStepIndex].name.replace(/([A-Z])/g, ' $1') : '';
					broadcastAnalyticsEvents(steps, stepAction, label);
				} else if (ngObject(steps[currentStepIndex]) && steps[currentStepIndex].stateName === toState.name) {
					stepAction = 'Step ' + (parseInt(currentStepIndex, 10) + 1);
					label = ngObject(steps[currentStepIndex]) ? steps[currentStepIndex].name.replace(/([A-Z])/g, ' $1') : '';
					broadcastAnalyticsEvents(steps, stepAction, label);
				}
			}

			// If we're timing out, or we're not in the wizard, just continue.
			if (IdleTimeout.timingOut() || !inWizard) {
				// we're not in the wizard. Don't worry about guarding it
				RecommenderWizardRouteService.guardTheGate = false;
				return;
			}

			// if we don't need to guard the gate, even though we're in the wizard, hide the current modal
			// and leave.
			if (!RecommenderWizardRouteService.guardTheGate) {
				if (Modal.modal && Modal.modal.show && !RecommenderWizardLoaderService.loadingScreenShowing) {
					Modal.hideModal();
				}

				/*
				*	AXO 2079
				*	You will see below, there is a condition to determine if we are leaving the wizard flow and to reset the wizard if we are.
				*	However, there is an edge case involving exiting the wizard flow when guardTheGate is false.
				*	From my understanding, guardTheGate (leave the wizard modal) is tied to every step in the wizard EXCEPT the first.
				*	Thus, if the user enters the wizard and exits without proceeding then guardTheGate will still be false and the wizard date is not reset.
				*	So we just need to do an additional check here to see if we need to reset the wizard.
				*	- MY
				*/
				if (!RecommenderWizardContextService.stateInWizard(toState, toParams, false)) {
					RecommenderWizardService.resetWizardData();
				}

				return;
			}

			// If a modal is showing, it means the customer hit the back button when a modal is showing.
			// Just close the modal and leave.
			if (Modal.modal && Modal.modal.show && !RecommenderWizardLoaderService.loadingScreenShowing) {
				Modal.hideModal();
				return;
			}

			// Show the "are you sure you want to exit?" modal, if appropriate
			if(!RecommenderWizardContextService.stateInWizard(toState,toParams, false)) {
				$rootScope.disableSpinner = false;
				trans.abort();
				$rootScope.hideSpinner();
				RecommenderWizardRouteService.displayExitWizardModal(toState.name, toParams);
				return false;
			}
		}

		/**
		 * Broadcasts events based on state from onStateChangeStart
		 * @protected
		 * @function
		 * @param {Array} steps Recommender Wizard steps
		 * @param {String} action Action for analytics
		 * @param {String} label Label for analytics
		 * @return {undefined}
		 */
		function broadcastAnalyticsEvents(steps, action, label) {
			AnalyticsDataLayerService.triggerAnalyticsEvent(
				Utilities.generateEventData('Wizard', action, label)
			);
		}

		/**
		 * The below functionality is for reconsiling the RecommenderWizardService.currentStepIndex.
		 * @public
		 * @function
		 * @name onStateChangeSuccess
		 * @memberof {RecommenderWizardStateService}
		 * @param {Transition} trans The Transition object
		 * @return {undefined}
		 */
		function onStateChangeSuccess(trans) {
			var toState = trans.to();
			var toParams = trans.params('to');
			var fromState = trans.from();
			var fromParams = trans.params('from');
			var inWizard = RecommenderWizardService.isInitialized && RecommenderWizardContextService.stateInWizard(fromState, fromParams, true);
			var toCart = toState.name === 'cart.view';
			var toIsXFC = ExtraFlowValidationService.isActiveXFCRoute(toState, toParams);
			var fromIsXFC = ExtraFlowValidationService.isActiveXFCRoute(fromState, fromParams);
			var packageId = toParams.packageId;

			// If we're going to the cart, not in the wizard, or don't have a package Id in the to params, bail.
			if (toCart || !inWizard || !packageId) {
				return;
			}

			// We only we only want to check when were NOT coming from another XFC and we're going to an XFC
			if (!fromIsXFC && toIsXFC) {
				var stageName = getStageNameByPackageId(packageId);
				var realIndex = getLastStepIndexForStage(stageName);
				var oldIndex = RecommenderWizardService.currentStepIndex;

				// If we didn't find it or it's at the correct index, bail.
				if (realIndex === -1 || realIndex === oldIndex) {
					return;
				}

				$log.warn('[RecommenderWizardStateService] changing state index from ' + oldIndex + ' to ' + realIndex);
				var lastStep = RecommenderWizardService.currentFlow.steps[realIndex];
				RecommenderWizardRouteService.setCurrentStep(lastStep.stateName);
				RecommenderWizardContextService.registerCustomActionsByState(lastStep.stateName);
			}
		}

		/**
		 * The callback when the view contents loaded
		 * @public
		 * @function
		 * @name onViewContentLoaded
		 * @memberof {RecommenderWizardStateService}
		 * @return {undefined}
		 */
		function onViewContentLoaded() {
			// Hide the loadingScreen
			RecommenderWizardLoaderService.setCurrentStepReadyStatus();
		}

		/**
		 * Gets a stage name by a specific package ID
		 * @protected
		 * @function
		 * @name getStageNameByPackageId
		 * @memberof {RecommenderWizardStateService}
		 * @param {Number} packageId The package id to search for.
		 * @return {String} The stage name if there is one.
		 */
		function getStageNameByPackageId(packageId) {
			var stages = RecommenderWizardService.contextData.stageSelections,
				foundPackage,
				stage;

			if (!angular.isObject(stages)) {
				return '';
			}

			for (var stageName in stages) {
				stage = stages[stageName];

				if (!isArray(stage.selectedPackages)) {
					continue;
				}

				foundPackage = stage.selectedPackages.some(function(package) {
					return parseInt(packageId, 10) === parseInt(package.package_id, 10);
				});

				if (foundPackage) {
					return stageName;
				}
			}

			return '';
		}

		/**
		 * Loops through all the Recomender Wizard steps and finds the last occuring index for a specific stageName. The reason we get the last is because steps can have the same stageName. We want the last one because an XFC would be after the last step for that stage.
		 * @protected
		 * @function
		 * @name getLastStepIndexForStage
		 * @memberof {RecommenderWizardStateService}
		 * @param {String} stageName The stage name to look for.
		 * @return {Number} The index for the specific step. It will return -1 if it can't find anything.
		 */
		function getLastStepIndexForStage(stageName) {
			if (!isArray(RecommenderWizardService.currentFlow.steps) || !stageName) {
				return -1;
			}

			return RecommenderWizardService.currentFlow.steps.reduce(function(stepIndex, step, index) {
				if (step.stageName === stageName) {
					return index;
				}

				return stepIndex;
			}, -1);
		}

		/**
		 * Adds or removes the event $on('stateChangeSuccess') depending on if we're coming or leaving the recommender wizard
		 * @protected
		 * @function
		 * @name getLastStepIndexForStage
		 * @memberof {RecommenderWizardStateService}
		 * @param {Boolean} wizardInitialized Is the recommender wizard initialized?
		 * @param {Boolean} isToCart Are we routing to the cart?
		 * @return {undefined}
		 */
		function addOrRemoveOnStateChangeSuccess(wizardInitialized, isToCart) {
			if (!onSuccessDeregister && wizardInitialized) {
				onSuccessDeregister = $transitions.onSuccess({}, onStateChangeSuccess);
			} else if (onSuccessDeregister && (isToCart || !wizardInitialized)) {
				onSuccessDeregister();
				onSuccessDeregister = null;
			}
		}

		return {};
	}
);

/**
 * Created by jwroblewski on 12/2/2015.
 */
angular.module('recommender-wizard')
	.factory('RecommenderWizardService', function(
		$log,
		$rootScope,
		Modal,
		CustomActionService,
		RecommenderWizardEnumsService,
		RecommenderWizardModels,
		Storage,
		Package,
		Utilities
	) {
		var service = {
			config: {},
			configure: configure,
			contextData: {},
			createStageSelectionsForCurrentFlow: createStageSelectionsForCurrentFlow,
			currentFlow: {},
			currentStepIndex: -1,
			getCurrentKeywordMap: getCurrentKeywordMap,
			getCurrentStageKeywordMap: getCurrentStageKeywordMap,
			getCurrentStageSelections: getCurrentStageSelections,
			getCurrentStep: getCurrentStep,
			getCurrentStepSettings: getCurrentStepSettings,
			getFullImageUrl: getFullImageUrl,
			getStageSelections: getStageSelections,
			wizardHasPackages: wizardHasPackages,
			wizardAdmissionsPackage: wizardAdmissionsPackage,
			isInitialized: false,
			loadWizardData: loadWizardData,
			preswapSteps: [],
			preswapStepIndex: -1,
			resetWizardData: resetWizardData,
			resetSwappedFlow: resetSwappedFlow,
			settings: {},
			steps: [],
			shouldSkipAdditionalWizardStep: shouldSkipAdditionalWizardStep,
			shouldSkipStepIfAdmissionsUpgradedToPass: shouldSkipStepIfAdmissionsUpgradedToPass,
			storeWizardData: storeWizardData,
			swapSubsequentFlowSteps: swapSubsequentFlowSteps
		};

		// -------------------------------------------------------------------------------------------------------------
		// Public Functions
		// -------------------------------------------------------------------------------------------------------------

		/**
		 * This is called from the RecommenderWizardContextService
		 * This loads the appropriate wizard from the list of available wizards
		 * @param {string} wizardKeyword  the keyword of the wizard to load
		 * @returns {undefined}
		 */
		function configure(wizardKeyword) {
			loadWizardData(wizardKeyword);

			// Configure the wizard if we have settings and it isn't already configured.
			if (angular.isDefined(service.settings.configList) &&
                wizardKeyword &&
                Utilities.isEmpty(service.config)) {
				// select the wizard with the matching keyword from the configList
				var selectedConfig = service.settings.configList.find(function(config) {
					return config.wizardKeyword === wizardKeyword;
				});

				if (angular.isUndefined(selectedConfig)) {
					$rootScope.disableSpinner = false;
					$log.info('[RecommenderWizardService.configure]: could not locate a wizard config with the "' +
						wizardKeyword + '" keyword within list of wizards from the recommender_wizard app config.');
					return;
				} else {
					// Use default value for loading screen if not provided
					service.config.minimumLoadScreenInterval = service.config.minimumLoadScreenInterval || 2000;
				}

				// Set the selected wizard config
				service.config = angular.copy(selectedConfig);
			}
		}

		function wizardHasPackages() {
			return (Utilities.safelyCheckPropertyOnObject('service.contextData.stageSelections.Admissions.selectedPackages', service) &&
				service.contextData.stageSelections.Admissions.selectedPackages.length > 0 &&
				angular.isDefined(service.contextData.stageSelections.Admissions.selectedPackages[0].package_id));
		}

		function wizardUpsellPackageId() {
			return Utilities.checkProp('service.contextData.stageSelections.Admissions.upsells.upsellPackage.packageDetails.id', service) ?
			service.contextData.stageSelections.Admissions.upsells.upsellPackage.packageDetails.id : null;
		}

		function wizardAdmissionsPackage() {
			if (service.wizardHasPackages()) {
				return Package.getPackageByID(service.contextData.stageSelections.Admissions.selectedPackages[0].package_id);
			}
			return undefined;
		}

		/**
		 * Should skip the wizard step if the admissions package has the specified charac
		 * Used for bundle products that include meals/extras/etc
		 * @param {string} characName - The charac name to check (e.g., 'skipAddlMealsWizard')
		 * @returns {boolean} true if the step should be skipped
		 */
		function shouldSkipAdditionalWizardStep(characName) {
			var admissionsPackage = service.wizardAdmissionsPackage();
			return characName && admissionsPackage && Utilities.checkProp('admissionsPackage.CHARACS.' + characName, admissionsPackage, 'getBoolean');
		}

		/**
		 * Should skip the meals and extras if the admissions step upgraded to a season pass
		 * @param {string} characName - The charac name to check
		 * @returns {boolean} true if should skip
		 */
		function shouldSkipStepIfAdmissionsUpgradedToPass (characName) {
			var admissionsPackage = service.wizardAdmissionsPackage();
			return characName && Utilities.checkProp('admissionsPackage.CHARACS.' + characName, admissionsPackage) && admissionsPackage.id === wizardUpsellPackageId();
		}

		/**
		 * Sets the service.contextData object.
		 * Gets the wizard contextData from storage or creates a new one.
		 * @param {String} wizardKeyword the keyword of the wizard to load
		 * @returns {undefined}
		 */
		function loadWizardData(wizardKeyword) {
			// Load context data from local storage if it exists
			var storageContextData = Storage.get(RecommenderWizardEnumsService.STORAGE_KEYS.CONTEXT_DATA);

			// If there is no context data in storage or the wizard keyword has changed, create a new context data model
			if (Utilities.isEmpty(storageContextData) || storageContextData.wizard !== wizardKeyword) {
				createContextDataModel();
			} else {
				service.contextData = storageContextData;

				if (angular.isDefined(storageContextData.selectedDate)) {
					service.contextData.selectedDate = new Date(storageContextData.selectedDate);
				}

				// convert each date string from storage to a date object
				var stageSelections = storageContextData.stageSelections;
				if (angular.isDefined(stageSelections)) {
					Object.keys(stageSelections).forEach(function(key) {
						if (angular.isDefined(stageSelections[key].selectedDate)) {
							service.contextData.stageSelections[key].selectedDate = new Date(stageSelections[key].selectedDate);
						}
					});
				}
			}
		}

		/**
		 * Saves the service.contextData object to local storage
		 * @returns {undefined}
		 */
		function storeWizardData() {
			Storage.set(RecommenderWizardEnumsService.STORAGE_KEYS.CONTEXT_DATA, service.contextData);
		}

		/**
		 * Resets the state of the recommender wizard,
		 * Empties context data and removes local storage.
		 * @param {Boolean} keepSpinnerDisabled denotes whether to enable the keep the rootScope spinner disabled
		 * @returns {undefined}
		 */
		function resetWizardData(keepSpinnerDisabled) {
			service.config = {};
			service.steps.length = 0;
			service.currentStepIndex = -1;
			service.isInitialized = false;
			service.contextData = new RecommenderWizardModels.ContextData();
			Storage.remove(RecommenderWizardEnumsService.STORAGE_KEYS.CONTEXT_DATA);
			if (!keepSpinnerDisabled) {
				$rootScope.disableSpinner = false;
			}
			CustomActionService.deregisterCustomActionsForGroup(RecommenderWizardEnumsService.CUSTOM_ACTION_GROUP_NAME);
			$log.warn('[RecommenderWizardStateService]: wizard data was reset.');
		}

		/**
		 * Gets a fully qualified path for the requested image
		 * @param {string} imagePath  the folder that contains the image.
		 * @param {string} imageFilename  the name of the requested image to
		 * @returns {string} fully qualified path of the image
		 */
		function getFullImageUrl(imagePath, imageFilename) {
			return service.settings.assetsUrl + imagePath + '/' + $rootScope.encodeAsset(imageFilename);
		}

		/**
		 * Gets the step object of the current step in the current flow
		 * If there is no step object at the currentStepIndex an empty object is returned.
		 * @returns {Object} the step object of the current step.
		 * */
		function getCurrentStep() {
			return service.steps[service.currentStepIndex] || {};
		}

		/**
		 * Gets the settings object of the current step in the current flow
		 * If there is no settings object on the step an empty object will be returned.
		 * @returns {Object} the settings object of the current step.
		 */
		function getCurrentStepSettings() {
			var settings = {};
			var currentStep = service.steps[service.currentStepIndex];
			if (Utilities.safelyCheckPropertyOnObject('currentStep.settings', currentStep)) {
				settings = angular.copy(currentStep.settings);
			}
			return settings;
		}

		/**
		 * Creates a new instance of the StageSelections model in the contextData.stageSelections object.
		 * The last step is excluded because the last step should be the cart itself.
		 * where the selections for the specified stage will be stored.
		 * @returns {undefined}
		 */
		function createStageSelectionsForCurrentFlow() {
			var stageSelections = {};
			service.steps.forEach(function(step, idx) {
				if (idx < service.steps.length-1 &&
                    angular.isDefined(step.stageName) &&
                    angular.isUndefined(stageSelections[step.stageName])) {
					stageSelections[step.stageName] = new RecommenderWizardModels.StageSelections();
				}
			});
			service.contextData.stageSelections = stageSelections;
		}

		/**
		 * Returns the stageSelections object for the specified stageName
		 * @param {string} stageName the name of the stage that will be used to retrieve the selections object
		 * @returns {object} the StageSelections object for the specified stage,
		 * returns a new object if it does not exist
		 */
		function getStageSelections(stageName) {
			return service.contextData.stageSelections[stageName] || new RecommenderWizardModels.StageSelections();
		}

		/**
		 * Gets the StageSelections object for the current step's stageName.
		 * @returns {object} the StageSelection object if it exists, otherwise it will be a new StageSelections object
		 */
		function getCurrentStageSelections() {
			var stageSelections = new RecommenderWizardModels.StageSelections();
			var currentStep = service.getCurrentStep();
			if (angular.isDefined(currentStep.stageName)) {
				stageSelections = service.getStageSelections(currentStep.stageName);
			}
			return stageSelections;
		}

		/**
		 * Get the keyword mapping based on the current stage and the keyword that is on StageSelection object.
		 * This is the level of mapping that defines if an assocKeyword on the packge overrides the default keyword
		 * for other stages.
		 * @returns {object} The keyword map object if it exists.  Returns undefined if there is no mapping defined.
		 */
		function getCurrentKeywordMap() {
			var stageKeywordMap = getCurrentStageKeywordMap();
			if (angular.isDefined(stageKeywordMap)) {
				var currentStageKeyword = getCurrentStageSelections().keyword;
				return stageKeywordMap[currentStageKeyword];
			}
		}

		/**
         * Gets the keyword mapping based on only stageName from the current step
         * @returns {object} the stageName level keyword mapping. It will be undefined if there are no
         * keyword mappings defined for the current stage
         */
		function getCurrentStageKeywordMap() {
			var keywordMap = service.currentFlow.keywordMap;
			if (angular.isDefined(keywordMap)) {
				var currentStageName = service.getCurrentStep().stageName;
				if (currentStageName) {
					return keywordMap[currentStageName];
				}
			}
		}

		/**
		 * Swap subsequent steps in the current wizard flow
		 * Currently must pass steps in an array format (can use the JSONValidator schema for recommender_wizard_alt_
		 * flow_steps to validate if needed)
		 * We can perhaps change the enforcement later on if we decide to
		 * It is the responsibility of the caller to properly validate and ensure that steps are passed appropriately
		 * @param {Array} stepsToSwap array of steps to swap in
		 * @returns {undefined}
		 */
		function swapSubsequentFlowSteps(stepsToSwap) {
			//check if we have steps to swap and if so go ahead and change the subsequent steps
			if (stepsToSwap.length > 0) {
				service.preswapSteps = angular.copy(service.steps);
				service.preswapStepIndex = service.currentStepIndex;
				service.steps.splice(service.currentStepIndex + 1, (service.steps.length - service.currentStepIndex));
				service.steps = service.steps.concat(stepsToSwap);
			}
		}


		function resetSwappedFlow() {
			if (service.preswapSteps.length > 0) {
				service.steps = angular.copy(service.preswapSteps);
				service.preswapSteps.length = 0;
				service.preswapStepIndex = -1;
			}
		}

		// -------------------------------------------------------------------------------------------------------------
		// Private Functions
		// -------------------------------------------------------------------------------------------------------------

		function createContextDataModel() {
			service.contextData = new RecommenderWizardModels.ContextData();
		}

		return service;
	}
	);

angular
	.module('order', [])
	.config(function($locationProvider, $stateProvider) {
		$stateProvider
			.state('order-verification', {
				url: '/order-verification/:orderId/:fromState/:fromParams',
				controller: 'OrderVerificationController',
				template: '<div></div>',
				resolve: {
					load: function($rootScope, Utilities) {
						$rootScope.showSpinner();
						return Utilities.cacheBustAndLazyLoad([
							'scripts/modules/order/controllers/order-verification-controller.js',
							'scripts/modules/order/controllers/order-phone-prompt-modal-controller.js'
						]);
					},
					initialData: function(load, Bootstrap) {
						return Bootstrap.bootstrapApplication();
					}

				}

			})
	});


/* eslint-disable sort-keys */
(function() {
	'use strict';

	angular
		.module('package-comparison', ['app'])
		.config(function($stateProvider, ComponentLoaderEnums) {
			$stateProvider
				// For use in the RECOMMENDER WIZARD
				.state('package-comparison-wizard', {
					components: [ ComponentLoaderEnums.cartFeeNotice ],
					controller: 'PackageComparisonController',
					resolve: {
						initialData: initialData,
						loadAssets: loadAssets,
						baseConfig: baseConfig,
						recommenderWizard: function(baseConfig, $injector, $transition$, RouteRejectionService, RecommenderWizardService, RecommenderWizardContextService) {
							if (
								!RecommenderWizardContextService.bootstrapWizard($transition$.params().recommenderWizardKeyword, 'package-comparison-wizard')
								|| !RecommenderWizardContextService.registerPackageComparison($injector.get('PackageComparisonSelectionService').currentViewSettings)
							) {
								// we hit here due to the back button and we are in an invalid state - abort and go back to the top of the store
								RecommenderWizardService.resetWizardData();
								throw new RouteRejectionService.UnrecoverableException();
							}
						}
					},
					title: 'packageComparisonWizard',
					templateUrl: '/scripts/modules/package-comparison/views/package-comparison.html',
					url: '/packageComparisonWizard/:recommenderWizardKeyword/:keyword'
				})
				// For use in the by itself
					.state('package-comparison', {
					components: [ ComponentLoaderEnums.cartFeeNotice ],
					controller: 'PackageComparisonController',
					resolve: {
						initialData: initialData,
						loadAssets: loadAssets,
						baseConfig: baseConfig
					},
					title: 'packageComparison',
					templateUrl: '/scripts/modules/package-comparison/views/package-comparison.html',
					url: '/packageComparison/:keyword'
				});

			/**
			 * Bootstraps the application
			 * @param {Service} Bootstrap Bootstrap
			 * @returns {Promise} A promise to bootup
			 * @ngInject
			 */
			function initialData(Bootstrap) {
				return Bootstrap.bootstrapApplication();
			}

			/**
			 * Loads additional assets
			 * @param {Service} Utilities Utilities
			 * @returns {Promise} To download additional assets
			 * @ngInject
			 */
			function loadAssets(Utilities) {
				return Utilities.cacheBustAndLazyLoad([
					'scripts/modules/package-comparison/package-comparison.css',
					'scripts/modules/package-comparison/controllers/package-comparison-controller.js',
					'scripts/modules/package-comparison/services/package-comparison-prep-service.js',
					'scripts/modules/package-comparison/services/package-comparison-selection-service.js',
					'scripts/modules/package-comparison/package-comparison-models.js'
				]);
			}

			/**
			 * Loads the base configuration
			 * @param {Promise} initialData The promise to bootstrap
			 * @param {Promise} loadAssets The promise to load our assets
			 * @param {Service} $injector $injector
			 * @param {Service} $transition$ The transition service
			 * @returns {Promise} to parse the config
			 * @ngInject
			 */
			function baseConfig(initialData, loadAssets, $injector, $transition$) {
				return $injector.get('PackageComparisonPrepService').parseConfigurationSettings($transition$.params());
			}
		})
		.run(function(Enums, ExtraFlow) {
			ExtraFlow.registerXMC('PackageComparisonWizardModule', {
				name: 'PackageComparisonWizardModule',
				view: Enums.extraFlowRoutes.PACKAGE_COMPARISON_WIZARD,
				doEditMode: true,
				lockQuantity: false,
				writeSingleCharac: false,
				enabled: true,
				type: 'alternateFlowModule'
			});
			ExtraFlow.registerXMC('PackageComparisonModule', {
				name: 'PackageComparisonModule',
				view: Enums.extraFlowRoutes.PACKAGE_COMPARISON,
				doEditMode: true,
				lockQuantity: false,
				writeSingleCharac: false,
				enabled: true,
				type: 'alternateFlowModule'
			});
		});
}());
angular
	.module('promo-code-override', [])
	.config(function($stateProvider) {
		$stateProvider.state('promo-code-override', {
			url: '/promo-code-override/{keyword:keyword}/:modalOnly',
			controller: 'PromoCodeOverrideController',
			title: 'promoOverride',
			resolve: {
				load: function(Utilities, $rootScope) {
					$rootScope.showSpinner();
					return Utilities.cacheBustAndLazyLoad([
						'/scripts/modules/alternate-modules/promo-code-override/services/promo-code-override-prep-service.js',
						'/scripts/modules/alternate-modules/promo-code-override/controllers/promo-code-override-controller.js',
						'/scripts/modules/alternate-modules/promo-code-override/controllers/promo-code-override-modal-prompt-controller.js',
						'/scripts/modules/alternate-modules/promo-code-override/controllers/promo-code-override-packages-controller.js'

					]);
				},
				initialData: function(load, Bootstrap) {
					return Bootstrap.bootstrapApplication();
				},
				getConfigurationAndHandleRouting: function(initialData, $injector, $state, $transition$) {
					return $injector.get('PromoCodeOverridePrepService').getConfigurationAndHandleRouting($state.next.name, $transition$.params());
				}
			}
		})
		$stateProvider.state('promo-code-override-set-promo', {
			url: '/promo-code-override-set-promo/{keyword:keyword}/:promo',
			controller: 'PromoCodeOverrideController',
			title: 'promoOverride',
			resolve: {
				load: function(Utilities, $rootScope) {
					$rootScope.showSpinner();
					return Utilities.cacheBustAndLazyLoad([
						'/scripts/modules/alternate-modules/promo-code-override/services/promo-code-override-prep-service.js',
						'/scripts/modules/alternate-modules/promo-code-override/controllers/promo-code-override-controller.js',
						'/scripts/modules/alternate-modules/promo-code-override/controllers/promo-code-override-modal-prompt-controller.js',
						'/scripts/modules/alternate-modules/promo-code-override/controllers/promo-code-override-packages-controller.js'

					]);
				},
				initialData: function(load, Bootstrap) {
					return Bootstrap.bootstrapApplication();
				},
				handleSetPromoRoute: function(initialData, $transition$, $injector) {
					return $injector.get('PromoCodeOverridePrepService').handleSetPromoRoute($transition$.params().promo);
				},
				getConfigurationAndHandleRouting: function(handleSetPromoRoute, $injector, $state, $transition$) {
					return $injector.get('PromoCodeOverridePrepService').getConfigurationAndHandleRouting($state.next.name, $transition$.params());
				}
			}
		})
		$stateProvider.state('promo-code-override-packages', {
			url: '/promo-override-packages/{keyword:keyword}/',
			controller: 'PromoCodeOverridePackagesController',
			controllerAs: 'vm',
			templateUrl: 'scripts/modules/alternate-modules/promo-code-override/views/packages.html',
			title: 'promoOverridePackages',
			resolve: {
				load: function(Utilities, $rootScope) {
					$rootScope.showSpinner();
					return Utilities.cacheBustAndLazyLoad([
						'/scripts/modules/alternate-modules/promo-code-override/services/promo-code-override-prep-service.js',
						'/scripts/modules/alternate-modules/promo-code-override/controllers/promo-code-override-controller.js',
						'/scripts/modules/alternate-modules/promo-code-override/controllers/promo-code-override-modal-prompt-controller.js',
						'/scripts/modules/alternate-modules/promo-code-override/controllers/promo-code-override-packages-controller.js'

					]);
				},
				initialData: function(load, Bootstrap) {
					return Bootstrap.bootstrapApplication();
				},
				getConfigurationAndHandleRouting: function(initialData, $injector, $state, $transition$) {
					return $injector.get('PromoCodeOverridePrepService').getConfigurationAndHandleRouting($state.next.name, $transition$.params());
				},
				handlePromoCodeOverridePackageRoute: function(getConfigurationAndHandleRouting, $injector, $transition$) {
					return $injector.get('PromoCodeOverridePrepService').handlePromoCodeOverridePackageRoute($transition$.params());
				}
			}
		})
	})
	.run(function(ExtraFlow) {
		// Register this extra flow alternate module with the extra flow service
		ExtraFlow.registerXMC('PromoCodeOverridePackages', {
			name: 'PromoCodeOverridePackages',
			view: 'promo-code-override-packages',
			viewIsStateName: true,
			doEditMode: false,
			lockQuantity: true,
			writeSingleCharac: false,
			enabled: true,
			type: 'alternateFlowModule'
		});

		ExtraFlow.registerXMC('PromoCodeOverrideModalOnly', {
			name: 'PromoCodeOverrideModalOnly',
			view: 'promo-code-override',
			viewIsStateName: true,
			viewDefaultArgs: { modalOnly: true },
			doEditMode: false,
			lockQuantity: true,
			writeSingleCharac: false,
			enabled: true,
			type: 'alternateFlowModule'
		});
	});

angular.module('payment-plan', ['app'])
	.config(function(
		$stateProvider,
		ComponentLoaderEnums
	) {

		var components = [ ComponentLoaderEnums.paymentSchedule ];

		$stateProvider
			.state('/paymentPlan/:planType/:packageId', {
				url: '/paymentPlan/:planType/:packageId',
				templateUrl: '/views/extraFlow/paymentPlan.html',
				controller: 'PaymentPlanController',
				components: components,
				resolve: {
					initialData: initialData,
					loadAssets: loadAssets,
					xfcMap: xfcMap,
					scheduleData: function(xfcMap, $injector, $transition$) {
						return $injector.get('PaymentPlanService').initialize($transition$.params(), "single");
					}
				}
			})
			.state('/paymentPlanMulti/:packageId', {
				url: '/paymentPlanMulti/:packageId',
				templateUrl: '/views/extraFlow/paymentPlan.html',
				controller: 'PaymentPlanController',
				components: components,
				resolve: {
					initialData: initialData,
					loadAssets: loadAssets,
					xfcMap: xfcMap,
					scheduleData: function(xfcMap, $injector, $transition$) {
						return $injector.get('PaymentPlanService').initialize($transition$.params());
					}
				}
			});

		/**
		 * Bootstraps the application
		 * @param {Service} Bootstrap Bootstrap
		 * @returns {Promise} To bootstrap
		 * @ngInject
		 */
		function initialData(Bootstrap) {
			return Bootstrap.bootstrapApplication();
		}

		/**
		 * Lazyloads our assets
		 * @param {Service} Utilities Utilities
		 * @returns {Promise} To load our assets
		 * @ngInject
		 */
		function loadAssets(Utilities) {
			return Utilities.cacheBustAndLazyLoad([
				'scripts/modules/payment-plan/services/payment-plan-service.js',
				'scripts/modules/payment-plan/controllers/payment-plan-controller.js'
			]);
		}

		/**
		 * Builds the XFC map
		 * @param {Promise} initialData Bootstrap
		 * @param {Service} Package The package service
		 * @returns {Promise} to build the XFC map
		 * @ngInject
		 */
		function xfcMap(initialData, loadAssets, Package) {
			return Package.buildXFCMap();
		}
	})
	.run();

angular.module('payment-plan')
	.factory('PaymentPlanService', function(
		$log,
		$q,
		$rootScope,
		AppData,
		Package,
		LegacyCart,
		RouteRejectionService,
		Language,
		Enums,
		Utilities,
		UtilsValidation,
		ExtraFlow,
		Modal,
		StandardFlowInitiatorService
	) {
		var checkProp = Utilities.checkProp,
			toArray = Utilities.wrapObjectToArray,
			validArray = UtilsValidation.validArray;

		var service = {
			basePackage: {},
			numberOfPasses: 0,
			numberOfPayments: 0,
			showFees: false,
			paymentSchedules: [],
			suppressionOptions: new SuppressionOptions(),
			_: { getAddons: _getAddons }
		};

		service.reset = function() {
			this.basePackage = {};
			this.numberOfPasses = 0;
			this.showFees = false;
			this.paymentSchedules = [];
			this.numberOfPayments = 0;
			this.suppressionOptions = new SuppressionOptions();
		};

		service.initialize = function(stateParams, planLimit) {
			service.reset();

			if (angular.isUndefined(stateParams.packageId)) {
				$log.error("State parameters are missing for Payment Plan");
				throw new RouteRejectionService.ViewException();
			}

			var rejectionRoute = Package.assessRoutabilityOfXFC(stateParams.packageId);
			if (rejectionRoute.length > 0) {
				throw new RouteRejectionService.UnrecoverableException(rejectionRoute);
			}

			if (angular.isUndefined(stateParams.planType) && angular.isUndefined(Package.settings.requestMultiplePlans)) {
				$log.error("State parameters are missing for Payment Plan");
				throw new RouteRejectionService.ViewException();
			}


			service.packageId = stateParams.packageId;
			service.planType = stateParams.planType;

			service.basePackage = service.determineBasePackage();
			var items = service.determinePaymentPlanItems();
			if (!service.determinePaymentPlanType()) {
				return $q.reject();
			}
			service.numberOfPayments = service.determineNumberOfPayments();
			service.suppressionOptions = service.determineSuppressionOptions();
			return service.getPaymentSchedule(items);
		};

		service.determineBasePackage = function() {
			var basePackage = angular.copy(Package.packageDetails);
			if (Package.isEditing() &&
				angular.isDefined(Package.itemsToBeAdded[0].CHARACS) &&
				angular.isArray(Package.itemsToBeAdded[0].CHARACS)) {
				basePackage = Package.getPackageByID(Package.itemsToBeAdded[0].CHARACS[0].preswap_package_id);
			}

			return basePackage;
		};

		service.determinePaymentPlanItems = function() {
			var addons = [];
			var message = [],
				paymentPlanItems = [];
			if (Package.isEditing()) {
				service.editingCartCopy = angular.copy(LegacyCart.editingCartCopy);

				// Get any parent packages in the cart that are for the same product that is being edited
				var parentPackages = service.editingCartCopy.filter(function(itemInCart) {
					return Package.packageDetails.id == itemInCart.package_id;
				});

				// get the parent packages and their associated oneBarcode packages.
				service.editingCartCopy = service.editingCartCopy.filter(function(itemInCart) {
					var isParentPackage = parentPackages.some(function(parentPackage) {
						return parentPackage === itemInCart;
					});

					var isOneBarcodePackage = parentPackages.some(function(parentPackage) {
						return Package.areCharacsEqual(parentPackage, itemInCart, 'group_uuid');
					});

					return isParentPackage || isOneBarcodePackage;
				});

				// Include the parent packages and their oneBarcode packages from the cart in the payment schedule
				paymentPlanItems = service.editingCartCopy;
			}

			var groupAddonsWithPasses = false;

			if (Utilities.safelyCheckPropertyOnObject('service.basePackage.CHARACS.group_payment_plan_passes', service, function(prop) {
				return Utilities.getBoolean(prop);
			})) {
				groupAddonsWithPasses = true;
			}

			// Build the request to get the payment schedule
			paymentPlanItems = paymentPlanItems.concat(Package.itemsToBeAdded);
			paymentPlanItems.forEach(function(item) {
				message.push({
					qty: item.qty,
					customer_type: item.customer_type,
					package_id: item.package_id
				});

				// This just gets the count of passes for display to the guest.
				if (groupAddonsWithPasses) {
					service.numberOfPasses += Number(item.qty);
				} else if ((item.package_id == service.packageId) || Package.hasPreswapPackageCharacsMatch(item, service.packageId)) {
					service.numberOfPasses += Number(item.qty);
				}
			});

			addons = service._.getAddons(paymentPlanItems);

			// Filter out addons that should be excluded from payment plan
			if (validArray(addons)) {
				addons = addons.filter(function filterAddonsFromPaymentPlan(addon) {
					return !excludeFromPaymentPlanSwap(addon);
				});
				message = message.concat(addons);
			}

			return message;
		};

		service.determineNumberOfPayments = function() {
			return angular.isDefined(service.basePackage.number_of_payments) ? service.basePackage.number_of_payments : 2;
		};

		service.determinePaymentPlanType = function() {
			if (angular.isUndefined(service.planType)) {
				return false;
			}

			// if the base package has no characs, we won't be able find the plan type
			if (angular.isUndefined(service.basePackage.CHARACS)) {
				return false;
			}

			switch (service.planType.toLowerCase()) {
			case 'easypay':
				service.planType = 'EasyPay';
				service.planLocale = 'EasyPay';
				service.swapPackageId = service.basePackage.CHARACS.PassOptionEasyPayPackageId || false;
				break;
			case 'paylater':
				service.planType = 'PayLater';
				service.planLocale = 'PayLater';
				service.swapPackageId = service.basePackage.CHARACS.PassOptionPayLaterPackageId || false;
				break;
			case 'multi':
				service.planType = undefined;
				service.planLocale = 'PaymentPlanMulti';
				break;
			default:
				service.planType = undefined;
				service.planLocale = '';
				service.swapPackageId = '';
				break;
			}

			if (!service.swapPackageId) {
				if (service.basePackage.type === "L") {
					service.swapPackageId = "-1";
				} else {
					// TODO: NEED TO FAIL THIS STATE


					// Hide the spinner.
					$rootScope.hideSpinner();
					// Error Invalid Payment Plan Setup
					Modal.displayModal({
						title: Language.getLocale('Alert', 'errorPaymentPlanTitle'),
						description: Language.getLocale('Alert', 'errorPaymentPlanMsg'),
						icon: 'icon-info red',
						callback: function(detail) {
							$rootScope.routeTo(StandardFlowInitiatorService.getStandardFlowEntryRoute());
						}
					});
					return false;
				}
			}

			return true;
		};

		service.determineSuppressionOptions = function() {
			if (!Utilities.safelyCheckPropertyOnObject('AppData.GetMerchantPackageList.PS.P', AppData)) {
				return;
			}

			var suppressYes = false,
				suppressNo = false,
				pkg,
				extraMovies = angular.isDefined(Package.packageDetails.extra_movie) ? Package.packageDetails.extra_movie.split(',') : '';


			for (var i = 0; i < AppData.GetMerchantPackageList.PS.P.length; i++) {
				pkg = AppData.GetMerchantPackageList.PS.P[i];
				if (pkg.id == service.swapPackageId) {
					if (service.numberOfPasses > pkg.max_quantity || service.numberOfPasses < pkg.min_quantity) {
						suppressYes = true;
					}
					if (extraMovies.indexOf('ezpaypromo') > -1 || extraMovies.indexOf('plpromo') > -1) {
						suppressNo = true;
					}
					break;
				}
			}


			return new SuppressionOptions(suppressYes, suppressNo);
		};

		service.addSwapCharacs = function(items, selection) {
			items = angular.copy(items);

			for (var i in items) {
				if (!excludeFromPaymentPlanSwap(items[i])) {
					characsLoop:
					for (var j in items[i].CHARACS) {
						if (selection.toLowerCase() === 'yes' || selection.toLowerCase() === 'easypay' || selection.toLowerCase() === 'paylater') {
							if (service.planType.toLowerCase() === 'easypay') {
								items[i].CHARACS[j].sp_swap_easypay_flag = 1;
								items[i].CHARACS[j].number_of_payments = service.determineNumberOfPayments();
							} else if (service.planType.toLowerCase() === 'paylater') {
								items[i].CHARACS[j].sp_swap_paylater_flag = 1;
								items[i].CHARACS[j].number_of_payments = 2;
							} else {
								continue characsLoop;
							}

							items[i].CHARACS[j].sp_swap = 1;
							items[i].CHARACS[j].payment_plan = service.planType;

							if (angular.isUndefined(items[i].CHARACS[j].preswap_package_id)) {
								items[i].CHARACS[j].preswap_package_id = items[i].package_id;
							}
						} else {
							var renewalSwapFlag = items[i].CHARACS[j].sp_swap_renewal_flag;
							items[i].CHARACS[j].sp_swap = ((angular.isDefined(renewalSwapFlag) && renewalSwapFlag === 1) ? 1 : 0);
						}

						if (angular.isUndefined(items[i].CHARACS[j].client_original_price)) {
							items[i].CHARACS[j].client_original_price = items[i].retail_price;
						}
					}
				}
			}
			return items;
		};

		service.save = function(selection) {
			if (angular.isUndefined(selection)) {
				return false;
			}

			if (Package.isEditing()) {
				service.editingCartCopy = service.addSwapCharacs(service.editingCartCopy, selection);
			}

			Package.itemsToBeAdded = service.addSwapCharacs(Package.itemsToBeAdded, selection);

			// Add reference of XFC to CHARACs.
			ExtraFlow.addReferenceToCartItems(Package.settings.view, Package.itemsToBeAdded, ExtraFlow.CLIENT_XFC_VIEW);
			ExtraFlow.addReferenceToCartItems(Package.settings.name, Package.itemsToBeAdded, ExtraFlow.CLIENT_XFC_NAME);

			// Navigate to the next XFC.
			Package.nextXFC();

			Utilities.scrollPosition();
		};

		service.getPaymentSchedule = function(items) {
			var message = { P: items };

			if (Utilities.getBoolean(Package.settings.requestMultiplePlans)) {
				message.get_all_schedules = '1';
			}

			return AppData.fetch(
				Enums.services.GET_PAYMENT_SCHEDULE,
				false,
				message
			).then(service.handlePaymentScheduleResponse);
		};

		service.mapPaymentPlanTypeForPassOptionCharac = function(passOptionCharac) {
			switch (passOptionCharac) {
			case 'PassOptionEasyPayPackageId':
				service.planType = 'EasyPay';
				break;

			case 'PassOptionPayLaterPackageId':
				service.planType = 'PayLater';
				break;
			}

			return service.planType;
		};

		service.handlePaymentScheduleResponse = function(data) {
			if (angular.isDefined(data.PAYMENT_SCHEDULE) && data.PAYMENT_SCHEDULE.length > 0) {
				service.paymentSchedules = data.PAYMENT_SCHEDULE;
				service.paymentSchedules.forEach(function(schedule) {
					if (angular.isDefined(schedule.pass_option) && service.planType === undefined) {
						service.mapPaymentPlanTypeForPassOptionCharac(schedule.pass_option);
					}

					var payments = schedule.PAYMENT;
					payments.forEach(function mapPaymentSchedules(item) {
						if (angular.isDefined(item.fee_amount) && parseFloat(item.fee_amount) > 0) {
							service.showFees = true;
						}
						if (item.date == 'NOW') {
							item.date = Language.getLocale('FormLabels', 'now');
						}
					});
				});
			} else {
				// Add reference of XFC to CHARACs.
				ExtraFlow.addReferenceToCartItems(Package.settings.view, Package.itemsToBeAdded, ExtraFlow.CLIENT_XFC_VIEW);
				ExtraFlow.addReferenceToCartItems(Package.settings.name, Package.itemsToBeAdded, ExtraFlow.CLIENT_XFC_NAME);

				// Navigate to the next XFC.
				Package.nextXFC();
			}
		};

		/**
		 * Checks whether a package item to be added has a payment plan XFC so that we can attach swap characs to it
		 * @param {Object} item - package item
		 * @returns {Boolean} - whether to exclude item from payment plan
		 * */
		function excludeFromPaymentPlanSwap(item) {
			var packageDetails = Package.getPackageDetailsForCartItem(item),
				excludeFromPaymentPlanSwap = false;

			// Assume that we don't want to exclude, just in case, so we don't break any other additional functionality.
			// Only exclude if we have this charac which can be added to quicksells to eliminate adding swap characs
			// that induce unwanted alerts.
			if (Utilities.safelyCheckPropertyOnObject('packageDetails.CHARACS.exclude_from_payment_plan', packageDetails)) {
				excludeFromPaymentPlanSwap = Utilities.getBoolean(packageDetails.CHARACS.exclude_from_payment_plan)
			}

			return excludeFromPaymentPlanSwap;
		}

		function SuppressionOptions(suppressYes, suppressNo) {
			this.suppressYes = suppressYes || false;
			this.suppressNo = suppressNo || false;
		}

		/**
		 * Pulls embedded addons from host packages
		 * @function
		 * @protected
		 * @param {Object[]} items The items to be added to cart
		 * @returns {Object[]} The addon items
		 */
		function _getAddons(items) {
			var formattedAddons = [];

			// Loop through all the items
			items.forEach(function loopThroughItemsToBeAdded(item) {
				var characs = toArray(item.CHARACS, true);

				// Take each item and loop through each charac (if set)
				characs.forEach(function loopThroughItemCharacs(charac) {
					var characAddons;

					// Does the charac contain a embedded addon?
					if (checkProp('charac.addon', charac, 'validString')) {
						// Break apart of the addon charac and generate an object for GetPaymentSchedule consumption
						characAddons = charac.addon.split(',').map(function loopThroughCharacAddons(addon) {
							// Each addon is in <package_id>:<customer_type_id>:<quantity>
							addon = addon.split(':');

							return {
								customer_type: addon[1],
								package_id: addon[0],
								qty: addon[2]
							};
						});

						// Add the addon(s) to the formattedAddons object
						formattedAddons = formattedAddons.concat(characAddons);
					}
				});
			});

			return formattedAddons;
		}

		return service;
	});

angular.module('payment-plan')
	.controller('PaymentPlanController', function(
		$log,
		$scope,
		$rootScope,
		$filter,
		$timeout,
		Package,
		ClientInfo,
		Enums,
		AppData,
		Utilities,
		UtilsPricing,
		UtilsValidation,
		LegacyCart,
		Language,
		AnalyticsDataLayerService,
		Modal,
		PaymentPlanService
	) {
		$scope.buttonWidth = null;
		$scope.paymentSchedules = PaymentPlanService.paymentSchedules;
		$scope.selectedSchedule = $scope.paymentSchedules[0];
		$scope.planLocale = PaymentPlanService.planType;
		$scope.numberOfPasses = PaymentPlanService.numberOfPasses;
		$scope.showFees = PaymentPlanService.showFees;
		$scope.dateFormat = AppData.settings.date_format;
		$scope.updatePaymentDateFormat = updatePaymentDateFormat;

		/**
		 * Initialize Controller
		 * @returns {undefined}
		 */
		function initialize() {
			$scope.isMobile = ClientInfo.deviceType === Enums.deviceType.MOBILE;
			_determineSuppressionOptions();
			setupLocales();
			setupImage();
			$scope.updatePaymentDateFormat();
			$scope.showRetailOnly = Package.xfcName === 'easy_pay_retail_only';
			$scope.buttonFlags = Enums.buttonFlags;
		}

		initialize();

		/**
		 * On view content loaded life cycle hook
		 * @public
		 * @returns {undefined}
		 */
		$scope.$on('$viewContentLoaded', function() {
			_setButtonWidths();
		});

		/**
		 * Sets button widths to the maximum of all buttons that dynamically render
		 * @private
		 * @returns {undefined}
		 */
		function _setButtonWidths() {
			var buttonWidths = [],
				buttonElems = [],
				maxWidth;
			// To account for dynamically rendered buttons
			$timeout(function nextTick() {
				document.querySelectorAll('.payment-container__select-button')
					.forEach(function forEachButton(button) {
						buttonWidths.push(button.offsetWidth);
						buttonElems.push(button);
					});
				maxWidth = Math.max.apply(null, buttonWidths) + 'px';
				buttonElems.forEach(function forEachButton(button) {
					button.style.minWidth = maxWidth;
				});
			});
		}

		/**
		 * Suppresses and removes payment schedules that don't match the payment plan type or number of payments of
		 * packages already in the cart.
		 * @private
		 * @returns {undefined}
		 */
		function _determineSuppressionOptions() {
			var cartItems = angular.copy(LegacyCart.cartItems),
				containsSamePlanType = false,
				cartItemPlans = [],
				suppressedOptionCount = 0;
			// Determine the packages in the cart that have a payment plan and their number of payments
			cartItems.forEach(function forEachCartItem(cartItem) {
				if (cartItem.CHARACS) {
					cartItem.CHARACS.forEach(function obtainPlanType(cartItemCharac) {
						var itemPaymentPlan = cartItemCharac.payment_plan,
							itemPayments = cartItemCharac.number_of_payments;
						if (itemPaymentPlan && itemPayments) {
							itemPaymentPlan = itemPaymentPlan.toLowerCase() === 'easypay' ? 'PassOptionEasyPayPackageId' : 'PassOptionPayLaterPackageId';
							cartItemPlans.push({
								numberOfPayments: itemPayments,
								planType: itemPaymentPlan
							});
						}
					});
				}
			});
			// Mark schedules as suppressed if their payment plan type or number of payments differ from the ones
			// exising in the cart.
			cartItemPlans.forEach(function forEachCartItemPlan(itemPlan) {
				$scope.paymentSchedules.forEach(function forEachPaymentSchedule(schedule) {
					if (schedule.pass_option !== itemPlan.planType || schedule.PAYMENT.length !== parseInt(itemPlan.numberOfPayments, 10)) {
						suppressedOptionCount += 1;
						schedule.surpressOption = true;
					} else {
						containsSamePlanType = true;
					}
				});
			});
			// If there are no valid payment schedules left, add the full payment option to the cart and skip the movie
			if (suppressedOptionCount >= $scope.paymentSchedules.length && !containsSamePlanType) {
				PaymentPlanService.save('full');
			}
		}

		/**
		 * Update payment schedule format
		 * @public
		 * @returns {undefined}
		 */
		function updatePaymentDateFormat() {
			if (!Utilities.safelyCheckPropertyOnObject('$scope.selectedSchedule.PAYMENT', $scope, UtilsValidation.validArray)) {
				return;
			}
			$scope.selectedSchedule.PAYMENT.forEach(function (payment) {
				payment.date = Utilities.formatSetDateFormatToYYYY_MM_DD(payment.date, 'MM/dd/yyyy');
			});
		}

		/**
		 * Sets up payment plan image, if available, based on the number of payments,
		 * the payment plan type, and mobile/desktop
		 * @function setupImage
		 * @public
		 * @returns {undefined}
		 */
		function setupImage() {
			$scope.planImage = $rootScope.assetsPath;
			var paymentPlanImages = {},
				key = ($scope.isMobile ? 'Mobile' : '') + PaymentPlanService.numberOfPayments,
				defaultKey = $scope.isMobile ? 'Mobiledefault' : 'default';
			// Check the package to see if it's a multi-plan package. Multi-plan packages are marked as 'easypay'
			if (Utilities.safelyCheckPropertyOnObject('Package.settings.requestMultiplePlans', Package, 'isBoolean')) {
				PaymentPlanService.planType = 'PaymentPlanMultiPayLater';
			}
			if (Utilities.safelyCheckPropertyOnObject('AppData.settings.payment_plan_images', AppData)) {
				try {
					paymentPlanImages = JSON.parse(AppData.settings.payment_plan_images);
				} catch (error) {
					$log.error(error);
				}
			}
			if (paymentPlanImages[PaymentPlanService.planType]) {
				if (paymentPlanImages[PaymentPlanService.planType][key]) {
					$scope.planImage += $rootScope.encodeAsset(paymentPlanImages[PaymentPlanService.planType][key]);
				} else if (paymentPlanImages[PaymentPlanService.planType][defaultKey]) {
					$scope.planImage += $rootScope.encodeAsset(paymentPlanImages[PaymentPlanService.planType][defaultKey]);
				} else {
					$log.warn('No image found for payment plan type: ' + PaymentPlanService.planType + '.  Please makes sure payment_plan_images has defaults for both mobile and desktop.');
					$scope.planImage = null;
				}
			} else {
				$log.warn('Not a valid plan type');
				$scope.planImage = null;
			}
		}

		/**
		 * Sets static locales
		 * @public
		 * @returns {undefined}
		 */
		function setupLocales() {
			var feeTotal = $filter('currencyFormatter')(LegacyCart.getTotalFees());
			$scope.footer = Language.replaceAll('@@FEE', feeTotal, Language.getLocale(PaymentPlanService.planType, 'footer'));
			$scope.title = Language.getLocaleMerchant(PaymentPlanService.planType, 'title') || Package.packageDetails.name;
			$scope.headerLabel = Language.getLocaleMerchant(PaymentPlanService.planType, 'header');
			$scope.paymentScheduleLabel = Language.getLocaleMerchant('PaymentSchedule', 'ViewPaymentSchedule');
			$scope.dueTodayLabel = Language.getLocaleMerchant('PaymentSchedule', 'DueToday');
			$scope.selectLabel = Language.getLocaleMerchant('ButtonLabels', 'select');
			$scope.payLaterTitle = Language.getLocaleMerchant('PaymentSchedule', 'BuyNowPayLaterTitle');
			$scope.selectPayLaterLabel = Language.getLocaleMerchant('ButtonLabels', 'SelectBuyNowPayLater');
			$scope.payLaterDescription = Language.getLocaleMerchant('PaymentSchedule', 'BuyNowPayLaterDescription');
			$scope.selectPayFullLabel = Language.getLocaleMerchant('ButtonLabels', 'SelectPayInFull');
			$scope.payFullDescription = Language.getLocaleMerchant('PaymentSchedule', 'PayFullDescription');
			$scope.easyPayTitle = Language.getLocaleMerchant('PaymentSchedule', 'FlexPayTitle');
			$scope.selectEasyPayLabel = Language.getLocaleMerchant('ButtonLabels', 'SelectEasyPay');
			$scope.easyPayDescription = Language.getLocaleMerchant('PaymentSchedule', 'FlexPayDescription');
			$scope.backLabel = Language.getLocaleMerchant('ButtonLabels', 'backButton');
		}

		/**
		 * Routes backwards in the application to the previous stage
		 * @public
		 * @returns {undefined}
		 */
		$scope.back = function() {
			Package.cancelXFC();
		};

		/**
		 * Obtains the first payment of the payment plan
		 * @public
		 * @param {Object} paymentPlan - the paymentPlan object that contains payment plan information
		 * @returns {Number} - the payment amount
		 */
		$scope.getFirstPayment = function (paymentPlan) {
			if (!Utilities.checkProp('paymentPlan.PAYMENT', paymentPlan, 'validArray') || paymentPlan.PAYMENT.length === 0) {
				return 0;
			}
			return parseFloat(paymentPlan.PAYMENT[0].total_amount);
		};

		/**
		 * Obtains the second payment of the payment plan
		 * @public
		 * @param {Object} paymentPlan - the paymentPlan object that contains payment plan information
		 * @returns {Number} - the payment amount
		 */
		$scope.getSecondPayment = function(paymentPlan) {
			if (!Utilities.checkProp('paymentPlan.PAYMENT', paymentPlan, 'validArray') || paymentPlan.PAYMENT.length === 0) {
				return 0;
			}
			var payment = paymentPlan.PAYMENT[1];
			return UtilsPricing.getPrice(payment.retail_amount, payment.tax_amount, payment.fee_amount);
		};

		/**
		 * Determines if a first payment is required for a specific payment plan
		 * @public
		 * @param {Object} paymentPlan - the paymentPlan object that contains payment plan information
		 * @returns {Boolean} - true if a first payment is required, false otherwise
		 */
		$scope.isFirstPaymentRequired = function (paymentPlan) {
			if (!Utilities.checkProp('paymentPlan.PAYMENT', paymentPlan, 'validArray') || paymentPlan.PAYMENT.length === 0) {
				return false;
			}
			return parseFloat(paymentPlan.PAYMENT[0].retail_amount) > 0;
		};

		/**
		 * Gets the title for the payment plan
		 * @public
		 * @param {Object} paymentPlan - the paymentPlan object that contains payment plan information
		 * @returns {String} - the title of the payment plan
		 */
		$scope.getPlanTitle = function(paymentPlan) {
			if (!Utilities.checkProp('paymentPlan.pass_option', paymentPlan, 'validString')) {
				return '';
			}

			switch (paymentPlan.pass_option) {
				case 'PassOptionEasyPayPackageId':
					return $scope.easyPayTitle;
				case 'PassOptionPayLaterPackageId':
					return $scope.payLaterTitle;
				default:
					return '';
			}
		};

		/**
		 * Gets the description for the payment plan
		 * @public
		 * @param {Object} paymentPlan - the paymentPlan object that contains payment plan information
		 * @returns {String} - the description of the payment plan
		 */
		$scope.getPlanDescription = function(paymentPlan) {
			if (!Utilities.checkProp('paymentPlan.pass_option', paymentPlan, 'validString')) {
				return '';
			}

			switch (paymentPlan.pass_option) {
				case 'PassOptionEasyPayPackageId':
					return $scope.easyPayDescription;
				case 'PassOptionPayLaterPackageId':
					return $scope.payLaterDescription;
				default:
					return '';
			}
		};

		/**
		 * Gets the total amount due for the payment plan
		 * @public
		 * @param {Object} paymentPlan - the paymentPlan object that contains payment plan information
		 * @returns {Number} - the total amount due for the payment plan (includes retail + fees)
		 */
		$scope.getPlanTotalDue = function(paymentPlan) {
			var total = 0;
			if (!Utilities.checkProp('paymentPlan.PAYMENT', paymentPlan, 'validArray')) {
				return 0;
			}

			paymentPlan.PAYMENT.forEach(function forEachPayment(payment) {
				total += UtilsPricing.getPrice(payment.retail_amount, payment.tax_amount, payment.fee_amount);
			});

			return total;
		};

		/**
		 * Gets the due date for the pay later payment plans
		 * @public
		 * @param {Object} paymentPlan - the paymentPlan object that contains payment plan information
		 * @returns {String} - string representation of the due date
		 */
		$scope.getPaymentDueDate = function(paymentPlan) {
			if (!Utilities.checkProp('paymentPlan.pass_option', paymentPlan, 'validString') || paymentPlan.PAYMENT.length === 0) {
				return '';
			}
			return paymentPlan.PAYMENT[paymentPlan.PAYMENT.length - 1].date;
		};

		/**
		 * Gets the plan type for the payment plan
		 * @public
		 * @param {Object} paymentPlan - the paymentPlan object that contains payment plan information
		 * @returns {String} - string denoting plan type
		 */
		$scope.getPlanType = function(paymentPlan) {
			if (!Utilities.checkProp('paymentPlan.pass_option', paymentPlan, 'validString')) {
				return '';
			}
			return paymentPlan.pass_option;
		};

		/**
		 * Saves the plan selection
		 * @public
		 * @param {Object} paymentPlan - payment plan object containing payment plan information
		 * @returns {undefined}
		 */
		$scope.savePlanSelection = function (paymentPlan) {
			var triggerName;
			if (paymentPlan) {
				$scope.paymentPlanSelection = $scope.getPlanType(paymentPlan) === 'PassOptionEasyPayPackageId' ? 'easypay' : 'paylater';
				// trigger analytics button click for payment plan selection
				triggerName = $scope.paymentPlanSelection === 'easypay' ? 'select_easyPay' : 'select_buyNowPayLater';
				PaymentPlanService.planType = $scope.paymentPlanSelection;
			} else {
				$scope.paymentPlanSelection = 'full';
				triggerName = 'select_payInFull';
			}
			AnalyticsDataLayerService.triggerAnalyticsEvent(Utilities.generateEventData('passport.buttonClick', triggerName));
			PaymentPlanService.save($scope.paymentPlanSelection);
		};

		/**
		 * Determines button label based on payment plan type
		 * @public
		 * @param {Object} paymentPlan - payment plan object containing payment plan information
		 * @returns {String} - the Locale to be used for the button label
		 */
		$scope.determineButtonLabel = function(paymentPlan) {
			if (paymentPlan.pass_option.toLowerCase().indexOf('easypay') !== -1) {
				return $scope.selectEasyPayLabel;
			} else if (paymentPlan.pass_option.toLowerCase().indexOf('paylater') !== -1) {
				return $scope.selectPayLaterLabel;
			} else {
				return $scope.selectLabel;
			}
		};
	});

(function() {
	'use strict';

	angular.module('upsell', ['app', 'upsell-page', 'upsell-wizard'])
		.value('UpsellDisplayTypes', {
			ONETOONE: 'one-to-one',
			ONETOMANY: 'one-to-many',
			MANYTOONE: 'many-to-one',
			MANYTOMANY: 'many-to-many',
			UNKNOWN: 'unknown'
		});
})();
(function() {
	'use strict';

	angular
		.module('upsell')
		.service('Upsell', UpsellService);

	/**
	 * Handles all logic regarding upsells, save for a few interactions in the Cart service and Package service.
	 * Handles common behavior between the different Upsell submodules
	 * @returns {Object} The Upsell Service
	 */
	function UpsellService($rootScope,
		$filter,
		$location,
		$log,
		$q,
		AppData,
		LegacyCart,
		CustomActionService,
		DynamicCapacityPricingService,
		DynamicPricingService,
		Enums,
		Modal,
		Language,
		Package,
		ReservationService,
		Security,
		UpsellDisplayTypes,
		UtilsValidation,
		Utilities) {
		var service = this;
		var ngIsNumber = angular.isNumber,
			ngisObject = angular.isObject,
			ngIsFunction = angular.isFunction,
			ngIsString = angular.isString,
			ngCopy = angular.copy,
			aIsArray = Array.isArray,
			validString = UtilsValidation.validString,
			checkProps = Utilities.safelyCheckPropertyOnObject,
			isRealObject = UtilsValidation.isRealObject,
			validArray = UtilsValidation.validArray,
			toArray = Utilities.wrapObjectToArray;

		var ERROR_PREFIX = 'Upsell Service: ';

		/**
		 * Used for mapping the Original Package Customer Types to the appropriate Upsell Package Customer Types.
		 * @protected
		 * @type {Array} Array of Objects in the structure of { baseCustomerTypeId: #, upsellCustomerTypeId: # }
		 */
		var customerTypeMappings = [];

		/**
		 * Used in displaying the lowest price among all possible Upsell CTs
		 * @public
		 * @type {Number}
		 */
		service.lowestPriceDifference = undefined;

		/**
		 * Represents what type of Upsell flow the user is working through
		 * @public
		 * @type {String} String Enum from UpsellDisplayTypes declared in the Upsell Module
		 */
		service.displayType = undefined;

		/**
		 * The 'Temp' Upsell Customer Types that the user will be interacting with and changing quantity on.
		 * These are subject to have their retail_amounts changed as a part of incrementQty / decrementQty / onQtyChange as a result of Multipacks (Dynamic Pricing)
		 * @public
		 * @type {Array} Array of CustomerType objects
		 */
		service.upsellCustomerTypes = [];

		/**
		 * Customer Types for Base package used for comparing quantity. If the base package quantity is changed this is used to compare the quantity
		 * @public
		 * @type {Array} Array of CustomerType objects
		 */
		service.baseCustomerTypes = undefined;

		/**
		 * Set as a part of the getUpsellAvailableDates() functions
		 * Used to determine whether or not the Upsell should display
		 * @public
		 * @type {Boolean} True if the date requested for was valid (or no calendar set for the upsell), False otherwise
		 */
		service.calendarValidity = true;

		// Functions
		service.checkUpsellDatesAvailability = checkUpsellDatesAvailability;

		service.showUpsell = showUpsell;

		/**
		 * Handles all quantity checking and adjusting for the addToCart process
		 * @protected
		 * @param {Number} upsellSelectedQuantity Centralized quantity selected by the user, used in One-to-Many scenarios
		 * @param {Number} upsellMaxQuantity Total Max Quantity, dictated by the Base Package's CustomerType in a One-to-Many scenario
		 * @returns {Boolean} False if any quantity is incorrect/invalid
		 */
		service._addToCartQuantityHandling = function(upsellSelectedQuantity, upsellMaxQuantity) {
			var tempUpsellCustomerTypes = service.upsellCustomerTypes;
			var dynamicBaseCustomerTypes = Package.customerTypes;
			var dynamicUpsellCustomerTypes = Package.upsellPackage.customerTypes;

			resetQuantities(dynamicUpsellCustomerTypes);

			// Loop through the customerTypes in the upsell, grab the quantities from each, calculate the difference betweem the max_quantity and qty, to get the new quantity for the original package.
			service._evaluateQuantities(tempUpsellCustomerTypes, dynamicBaseCustomerTypes, dynamicUpsellCustomerTypes);

			if (!service.validateOriginalPkgMinQty(Package.customerTypes, Package.preUpsellPkg) || !service.validateUpsellPkgMinQty(Package.upsellPackage)) {
				//reset changing this value
				resetPackageQty();
				return false;
			}

			// The following is the case for one-to-many, where the qty adjustments from above will not work correctly.
			if (service.displayType === UpsellDisplayTypes.ONETOMANY) {
				service._evaluateOneToManyQuantity(upsellSelectedQuantity, upsellMaxQuantity, tempUpsellCustomerTypes, dynamicBaseCustomerTypes)
			}

			return true;
		}

		/**
		 * Adjust the Base CustomerType involved in this One-to-Many scenario, based on the Quantity selected by the user.
		 * @protected
		 * @param {Number} upsellSelectedQuantity Centralized quantity used in One-to-Many scenarios
		 * @param {Number} upsellMaxQuantity Maximum quantity used in One-to-Many scenarios, is based on total quantity of the sole Customer Type on the Base Package
		 * @param {Array} tempUpsellCTs The temporary Upsell Customer Types (from service.upsellCustomerTypes)
		 * @param {Array} dynamicBaseCTs The dynamic Base Customer Types that the user selected quantities for prior to the Upsell flow
		 * @returns {undefined}
		 */
		service._evaluateOneToManyQuantity = function(upsellSelectedQuantity, upsellMaxQuantity, tempUpsellCTs, dynamicBaseCTs) {
			if (isNaN(upsellSelectedQuantity)) {
				upsellSelectedQuantity = tempUpsellCTs.reduce(function(accu, current) {
					return accu + current.qty;
				}, 0);
			}

			dynamicBaseCTs[0].qty = upsellMaxQuantity - upsellSelectedQuantity;
		}

		/**
		 * Adjust the dynamic Upsell CustomerTypes and dynamic Base CustomerTypes based on the quantity the user selected for each of the Upsell CustomerTypes
		 * @protected
		 * @param {Object} tempUpsellCTs The temporary Upsell Customer Types (from service.upsellCustomerTypes)
		 * @param {Array} dynamicBaseCTs The dynamic Base Customer Types that the user selected quantities for prior to the Upsell flow
		 * @param {Array} dynamicUpsellCTs The dynamic Upsell Customer Types that will be updated by the user's selections
		 * @returns {undefined}
		 */
		service._evaluateQuantities = function(tempUpsellCTs, dynamicBaseCTs, dynamicUpsellCTs) {
			var tempUpsellCTLength = tempUpsellCTs.length;

			for(var i = 0; i < tempUpsellCTLength; i++) {
				var upsellCT = tempUpsellCTs[i];

				// Adjust each customerType in the original package with a corrected quantity
				// The Dynamic Customer Type of the Base Package, the customer type the user chose/edited
				// baseCustomerTypeId is set when we make the service.upsellCustomerTypes in getTempUpsellCustomerType()
				var dynamicBaseCT = getMatchingById(upsellCT.baseCustomerTypeId, dynamicBaseCTs);

				// The Dynamic Customer Type of the Upsell Package
				var dynamicUpsellCT = getMatchingById(upsellCT.id, dynamicUpsellCTs);

				// In a Many-to-One (or in a Many-to-Many) there can be 2+ Base Customer Types pointing to a single Upsell Customer Type
				// We need to go through all the temporary Upsell Customer Types (that were shown to the user) and sum them all up.
				dynamicUpsellCT.qty += upsellCT.qty;

				// Standard upsell behavior: reduce base package quantity by upsell quantity
				// This ensures only the upsell package is added to cart, not both base and upsell
				dynamicBaseCT.qty = (upsellCT.max_quantity - upsellCT.qty);
			}
		}

		/**
		 * Determines whether or not the user has entered any quantities for the Upsell Customer Types
		 * @protected
		 * @param {String} upsellDisplayStyle Enum representing what type of Upsell this is
		 * @param {Number} upsellSelectedQuantity Centralized quantity used in 1 to Many scenarios
		 * @returns {Boolean} Whether or not the user has entered any quantities for the Upsell Customer Types
		 */
		service._hasUpsellQtySelected = function(upsellDisplayStyle, upsellSelectedQuantity) {
			if (upsellDisplayStyle === UpsellDisplayTypes.ONETOMANY && ngIsNumber(upsellSelectedQuantity)) {
				return upsellSelectedQuantity > 0;
			}

			var testQty = service.upsellCustomerTypes.reduce(function(accu, current) {
				return accu + Number(current.qty);
			}, 0);

			return !isNaN(testQty) && testQty > 0;
		}

		/**
		 * On the CustomerTypes that are going to be added to the cart, set Characs for tracking what package/s the user came from before the upsell and what the original prices were.
		 * This is for situations where "Alias Packages" are used
		 * @protected
		 * @param {Array} customerTypes The customer types that are being added to the Cart
		 * @returns {undefined}
		 */
		service._mapTrackingCharacsToCustomerTypes = function(customerTypes) {
			if(service.upsellCustomerTypes.length > 0 && aIsArray(customerTypes)) {
				var customerTypesLength = customerTypes.length;
				var tempCustomerTypesLength = service.upsellCustomerTypes.length;

				for(var i = 0; i < customerTypesLength; i++) {
					var characIndex = 0;
					var currentCusType = customerTypes[i];

					for(var j = 0; j < tempCustomerTypesLength; j++) {
						var currentcusTypeTemp = service.upsellCustomerTypes[j];
						var tempQuantity = ngCopy(currentcusTypeTemp.qty);

						if (currentCusType.customer_type == currentcusTypeTemp.customer_type && currentCusType.package_id != currentcusTypeTemp.originalPackageId) {
							var characsLength = currentCusType.CHARACS.length;
							for(var k = characIndex; k < characsLength; k++) {
								var currentCharacs = currentCusType.CHARACS[k];

								if(tempQuantity > 0) {
									currentCharacs.pre_upsell_id = currentcusTypeTemp.originalPackageId;
									currentCharacs.pre_upsell_price = currentcusTypeTemp.originalPrice;
									tempQuantity--;
								} else {
									//Once we have iterated through the current temp's amount, we need to save our place
									// in the charac array and move on to the temp object. This occurs in the many-to-one
									//situation.
									characIndex = k;
									break;
								}
							}
						}
					}
				}
			}
		}

		/**
		 * Goes through and does any price swapping needed, using the DynamicPricing service.
		 * Then, after all swapping is complete, calculate lowest price differences between each Base CustomerType and each Upsell CustomerType
		 * This is done on initilization AND whenever a quantity is changed for an Upsell CustomeType
		 * @protected
		 * @param {Array} tempUpsellCustomerTypes The 'temp' Customer Types of the Upsell Package (The ones that will have quantities chosen by the user and have their Prices swapped by DynamicPricing service)
		 * @param {Array} dynamicBaseCustomerTypes The 'dynamic' Customer Types of the Base Package (The ones that will have quantities chosen by the user)
		 * @param {Object} basePackageDetails The PackageDetails for the Package that is being upselled to the Upsell Package (used for DynamicPrice service here)
		 * @param {Object} upsellPackageDetails The PackageDetails Package that is being upselled to (used for DynamicPrice service here)
		 * @returns {undefined}
		 */
		service._setPricing = function(tempUpsellCustomerTypes, dynamicBaseCustomerTypes, basePackageDetails, upsellPackageDetails, fromPricing) {

			var useMembershipMessage = false;
			if (Utilities.childDefined(upsellPackageDetails, 'CHARACS.package_type') && upsellPackageDetails.CHARACS.package_type.toLowerCase() === 'membership') {
				useMembershipMessage = true;
			}

			// We need temporary customer types, just to get the swap price so that we can compare pricing
			// We do this, so that we do not actually change the prices of the provided dynamicBaseCustomerTypes
			var tempBaseCustomerTypes = dynamicBaseCustomerTypes.map(function(dynamicBaseCT) {
				var matchingUpsellCT;

				var length = tempUpsellCustomerTypes.length;
				for(var i = 0; i < length; i++) {
					var currentUpsellCT = tempUpsellCustomerTypes[i];
					if(currentUpsellCT.originalBaseCT.id === dynamicBaseCT.id) {
						matchingUpsellCT = currentUpsellCT;
						break;
					}
				}

				var tempBaseCT = ngCopy(dynamicBaseCT);

				// For price comparisons, we are comparing "If the quantity on the Base Package CT is the same as the quantity on the Upsell CT"
				// Because we are explicitly comparing what the Price-Per-Ticket difference is, if they went with the Upsell Package VS the Base Package
				if(ngisObject(matchingUpsellCT)) {
					tempBaseCT.qty = matchingUpsellCT.qty;
				}

				return tempBaseCT;
			});

			// Check and swap on the temporary Base Customer Types
			DynamicPricingService.setDynamicPrice(basePackageDetails, tempBaseCustomerTypes, undefined);

			// Check and swap on the Upsell Customer Types
			DynamicPricingService.setDynamicPrice(upsellPackageDetails, tempUpsellCustomerTypes, undefined);

			var tempUpsellLength = tempUpsellCustomerTypes.length;
			for (var i = 0; i < tempUpsellLength; i++) {
				var currentTempUpsellCT = tempUpsellCustomerTypes[i];

				// After Package Swapping, we still can't garuntee that the Dynamic Customer Type (of Base or Upsell packages) will have retail amounts,
				// So we have to fall back on the Original Customer Type in that event.
				// (These were set in service.createTempUpsellCustomerTypes() in order to save time re-iterating through their respective CT arrays here)
				var upsellCTtoComparePrice = currentTempUpsellCT.originalUpsellCT;
				var baseCTtoComparePrice = currentTempUpsellCT.originalBaseCT;

				if(!isNaN(currentTempUpsellCT.retail_amount)) {
					upsellCTtoComparePrice = currentTempUpsellCT;
				}

				//Grab the 'temp' dynamic Customer Type for the Base Package that should of had its price changed
				var tempBaseCT = getMatchingById(currentTempUpsellCT.originalBaseCT.id, tempBaseCustomerTypes);
				if(!isNaN(tempBaseCT.retail_amount)) {
					baseCTtoComparePrice = tempBaseCT;
				}

				if (checkProps('ct.' + currentTempUpsellCT.originalBaseCT.id, fromPricing)) {
					baseCTtoComparePrice = fromPricing[currentTempUpsellCT.originalBaseCT.id];
				}

				currentTempUpsellCT.priceDifferenceNumeric = service.getPriceDifference(baseCTtoComparePrice, upsellCTtoComparePrice);
				currentTempUpsellCT.priceDifference = $filter('currencyFormatter')(currentTempUpsellCT.priceDifferenceNumeric);

				if (useMembershipMessage) {
					currentTempUpsellCT.membershipUpsellMonthlyPrice = parseFloat(upsellCTtoComparePrice.retail_amount);
					currentTempUpsellCT.priceDifference = currentTempUpsellCT.originalUpsellCT.membershipMessage;
				}
			}
		}

		/**
		 * Handles back button click event. Routes back to the packagelist.
		 * @public
		 * @param {Boolean} dontSkip where or not we should set the skip value, whicih in turns tells PackageDetailsCtrl if it should show the displayModal or not.
		 * @param {number} packageID Id of the original Package, used for routing back upon cancelling or erroring
		 * @param {function} routeCallback used for routing in the event the user is allowed to skip
		 * @return {undefined}
		 */
		service.cancelUpsell = function(dontSkip, packageID, routeCallback) {
			Package.upsellPackage.skip = dontSkip || false;

			// @TODO we could support an option config the destination of the cancel action.
			//	it could go back to the packageDetails, or proceed with the add to cart action.
			//
			//	$rootScope.routeTo( Enums.routes.DETAILS + '/' + packageID , false );
			//	NOTE: if dontSkip is true, don't call the onCancelAddToCart function,
			//	 it's most likely a reset to return to the package details.
			if (!dontSkip) {
				CustomActionService.executeCustomAction('postUpsellProcessing', undefined, [false, Package.customerTypes]);
				resetBasePackageQuantity();
				service.onCancelAddToCart();
			} else {
				if (ngIsFunction(routeCallback)) {
					service.resetUpsell();
					routeCallback();
				} else {
					service.resetUpsell();
					$rootScope.routeTo(Enums.routes.DETAILS + '/' + packageID);
				}
			}
		}

		/**
		 * Resets base package quanity
		 * @protected
		 * @returns {undefined}
		 */
		function resetBasePackageQuantity() {
			Package.customerTypes.forEach(function(CT) {
				service.baseCustomerTypes.forEach(function(BCT) {
					if (CT.customer_type === BCT.customer_type && CT.package_id === BCT.package_id) {
						CT.qty = BCT.qty;
					}
				})
			});
		}

		/**
		 * Used for only the one-to-many display. this will verify if we have hit the maximum amount of units that can be selected.
		 * @param {String} upsellDisplayStyle Enum that indicates which display style the upsell is using
		 * @param {Number} upsellMaxQuantity the maximum quantity for a an upsell package
		 * @param {Number} upsellSelectedQuantity the current quantity shown in the stepper
		 * @returns {Boolean} if true, we've maxed out, otherwise, we're fine.
		 */
		service.checkUpsellOneToManyQty = function(upsellDisplayStyle, upsellMaxQuantity, upsellSelectedQuantity) {
			return upsellDisplayStyle === UpsellDisplayTypes.ONETOMANY && upsellMaxQuantity > 0 && upsellSelectedQuantity > 0 && upsellMaxQuantity === upsellSelectedQuantity;
		}

		/**
		 * Create the mappings between the original package, and the upsell package at the customerType level
		 * @public
		 * @param {Array} baseCustomerTypes the customer types belonging to the Base Package
		 * @param {Array} upsellCustomerTypes the customer types belonging to the Upsell Package
		 * @param {Object} packageCharacs the customer types belonging to the Upsell Package
		 * @return {Array} array Mapping objects that have baseCustomerTypeId and upsellCustomerTypeId
		 */
		service.createCustomerTypeMappings = function(baseCustomerTypes, upsellCustomerTypes, packageCharacs) {
			var currentCT = {};
			var mappings = [];

			var characsExist = ngisObject(packageCharacs);

			var matchingUpsellCTs = upsellCustomerTypes;
			var matchingUpsellCTsLength = matchingUpsellCTs.length;

			var baseCustomerTypesLength = baseCustomerTypes.length;
			for (var i = 0; i < baseCustomerTypesLength; i++) {
				currentCT = baseCustomerTypes[i];
				var characLink;

				// If QTY is 0, we clearly shouldn't care about mapping and displaying an Upsell CT for it, because the user didn't select it.
				if (currentCT.qty > 0) {
					// Check for explicit CHARAC mapping (e.g., rateUpsell_389 = 450 for different customer types)
					if (characsExist) {
						characLink = packageCharacs['rateUpsell_' + currentCT.id];
					}

					for (var j = 0; j < matchingUpsellCTsLength; j++) {
						var currentUpsellCT = matchingUpsellCTs[j];

						// Priority 1: Use CHARAC mapping if it exists (handles different customer type scenarios)
						// Priority 2: Direct ID match when customer types are the same (e.g., 389 -> 389)
						// Only use this when no CHARAC mapping exists for this customer type
						if (characLink === currentUpsellCT.id || (!ngIsString(characLink) && currentCT.id === currentUpsellCT.id)) {
							mappings.push({
								baseCustomerTypeId: currentCT.id,
								upsellCustomerTypeId: matchingUpsellCTs[j].id
							});
						}
					}
				}
			}

			if (mappings.length === 0 && baseCustomerTypes.length === 1 && matchingUpsellCTs.length === 1) {
				// If theres only 1 Base CT, 1 UpsellCt, and they don't share a CHARAC link nor the same Ids
				// Assume they are related (becuase otherwise there wouldn't be an Upsell Package tied to the Base package in the first place)
				// If this happens and the client did not want such functionality, the Upsell Package should be removed from the Base package
				mappings.push({
					baseCustomerTypeId: baseCustomerTypes[0].id,
					upsellCustomerTypeId: matchingUpsellCTs[0].id
				});
			}

			return mappings;
		}

		/**
		 * Prepares an array of Upsell Customer Types that were copied from a given set, and modified.
		 * These are the customer types that will be modified by the user (in terms of quantity, etc).
		 *
		 * NOTE: There may be duplicates in Many-to-One or Many-to-Many scenarios, which IS correct as each of the Base Customer Types need a Customer Type to "Upsell into"
		 * Its important because we differentiate these duplicates at a later step, and show them seperately to the user.
		 * @public
		 * @param {Array} ctMappings The Mappings between the Upsell Customer Types and the Base Customer Types in the form of { baseCustomerTypeId: #, upsellCustomerTypeId: # }
		 * @param {Object} upsellCustomerTypesToCopy The Customer Types that will be copied and modified (commonly the 'dynamic' Upsell Customer Types)
		 * @param {Array} dynamicBaseCustomerTypes The 'dynamic' Customer Types of the Base Package (The ones that will have quantities chosen by the user)
		 * @param {Array} originalBaseCustomerTypes The 'static' Customer Types of the Base Package (The ones that should never be altered)
		 * @param {Array} originalUpsellCustomerTypes The 'static' Customer Types of the Upsell Package (The ones that should never be altered)
		 * @param {String} displayType String ENUM denoting what type of Scenario this is, (used in Quantity Initialization)
		 * @returns {Array} Array of copied Upsell Customer Types
		 */
		service.createTempUpsellCustomerTypes = function(ctMappings, upsellCustomerTypesToCopy, dynamicBaseCustomerTypes, originalBaseCustomerTypes, originalUpsellCustomerTypes, displayType) {
			var tempCTs = [];

			var ctMappingsLength = ctMappings.length;

			if(!aIsArray(ctMappings) || !aIsArray(upsellCustomerTypesToCopy) ||	ctMappingsLength === 0 || upsellCustomerTypesToCopy.length === 0) {
				return [];
			}

			for(var i = 0; i < ctMappingsLength; i++) {
				var link = ctMappings[i];
				var correctUpsellCT = getMatchingById(link.upsellCustomerTypeId, upsellCustomerTypesToCopy);

				if(ngisObject(correctUpsellCT)) {
					// Grab the Linked CustomerType that exists on the BasePackage (the dynamic one that was edited by the user)
					var linkedBaseCT = getMatchingById(link.baseCustomerTypeId, dynamicBaseCustomerTypes);

					// The Original Customer Type of the Base Package, the pure non-altered customer type
					var originalBaseCT = getMatchingById(link.baseCustomerTypeId, originalBaseCustomerTypes);

					// The Original Customer Type of the Upsell Package, the pure non-altered customer type
					var originalUpsellCT = getMatchingById(correctUpsellCT.id, originalUpsellCustomerTypes);


					if(ngisObject(linkedBaseCT) && ngisObject(originalBaseCT) && ngisObject(originalUpsellCT)) {
						var upsellCTcopy = getTempUpsellCustomerType(correctUpsellCT, linkedBaseCT, originalBaseCT, originalUpsellCT, displayType);

						tempCTs.push(upsellCTcopy);
					}
				}
			}

			return tempCTs;
		}

		/**
		 * Decrements the quantity for the specified Customer Type by 1
		 * If this is a One-to-Many scenario, adjust the provided centralized Quantity variable
		 * @public
		 * @param {Object} customerType The Customer Type to update
		 * @param {Number} upsellSelectedQuantity Centralized quantity variable used to keep track of a single total quantity, used in One-to-Many scenarios
		 * @returns {Number} returns the upsellSelectedQuantity which may/may not be modified
		 */
		service.decrementQty = function(customerType, upsellSelectedQuantity, fromPricing) {
			if (service.displayType === UpsellDisplayTypes.ONETOMANY) {
				if (upsellSelectedQuantity > 0 && customerType.qty > 0) {
					Package.decrementQty(customerType, false);
					upsellSelectedQuantity--;
				} else {
					upsellSelectedQuantity = calcTotalUpsellQuantity();
				}
			} else {
				Package.decrementQty(customerType, false);
			}

			service._setPricing(service.upsellCustomerTypes, Package.customerTypes, Package.packageDetails, Package.upsellPackage.packageDetails, fromPricing);
			return upsellSelectedQuantity;
		}

		/**
		 * Calculates the "Lowest Price Difference" of all the Customer Types provided
		 * @public
		 * @param {Array} upsellTemporaryCustomerTypes the Customer Types that will be displayed to the user
		 * @returns {Number} The lowest price difference of all provided Customer Types
		 */
		service.getLowestPriceDifference = function(upsellTemporaryCustomerTypes) {
			var lowestPriceDifference;

			var upsellTemporaryCustomerTypesLength = upsellTemporaryCustomerTypes.length;
			for(var i = 0; i < upsellTemporaryCustomerTypesLength; i++) {
				var upsellCT = upsellTemporaryCustomerTypes[i];

				if ((!ngIsNumber(lowestPriceDifference) && upsellCT.priceDifferenceNumeric >= 0) || (upsellCT.priceDifferenceNumeric < lowestPriceDifference && upsellCT.priceDifferenceNumeric > 0)) {
					lowestPriceDifference = upsellCT.priceDifferenceNumeric;
				}
			}

			return lowestPriceDifference;
		}

		/**
		 * Calculate the price difference between the Base Customer Type and the Upsell Customer Type
		 * @public
		 * @param {Object} baseCustomerType The Customer Type from the Base Package
		 * @param {Object} upsellCustomerType The Customer Type from the Upsell Package
		 * @returns {Number} The price difference between the two Customer Types provided
		 */
		service.getPriceDifference = function(baseCustomerType, upsellCustomerType) {
			var baseTotal,
				customerType,
				includeComps = true,
				preselectedStartDate,
				upsellTotal = 0,
				useVat = AppData.defaults.use_vat;

			if (!ngisObject(baseCustomerType) || !ngisObject(upsellCustomerType)) {
				return 0;
			}

			preselectedStartDate = Package.getSelectedCustomerTypeHaveItemsAddedStartDate(baseCustomerType);

			// Is the package Dynamically priced?
			if (DynamicCapacityPricingService.isPackageDynamic(Package.packageDetails.id)) {
				// Find the customer type from the Package service
				customerType = Package.customerTypes.find(function findCustomerType(ct) {
					return ct.id == baseCustomerType.id;
				});

				// cusTypeRetail already has the total calculated based upon useVat or not
				baseTotal = +customerType.cusTypeRetail;

				// Include any comps if flagged true
				if (includeComps) {
					baseTotal = +(baseTotal + Package.getFullCompPrice(baseCustomerType, useVat)).toFixed(2);
				}
			} else {
				baseTotal = Package.getFullPrice(baseCustomerType, useVat, includeComps);
			}
			if (DynamicCapacityPricingService.isPackageDynamic(Package.upsellPackage.packageDetails.id)) {
				upsellTotal = service._getDynamicPriceTotal(upsellCustomerType, useVat, includeComps);
			} else if (angular.isDate(preselectedStartDate)) {
				upsellTotal = Package.getFullPriceForDate(upsellCustomerType, preselectedStartDate, includeComps);
			} else {
				upsellTotal = Package.getFullPrice(upsellCustomerType, useVat, includeComps);
			}

			return +(upsellTotal - baseTotal).toFixed(2);
		}

		/**
		 * Calculates the dynamic pricing for a upsell customer type
		 * @function
		 * @protected
		 * @param {Object} upsellCustomerType - The upsell customer type
		 * @param {Boolean} useVat - If we should use vat or not
		 * @param {Boolean} includeComps - If the price should include comps
		 * @returns {Number} The total for the customer type.
		 */
		service._getDynamicPriceTotal = function(upsellCustomerType, useVat, includeComps) {
			var customerType;
			var total;
			// Find the customer type from the Package service
			customerType = Package.upsellPackage.customerTypes.find(function findCustomerType(ct) {
				return ct.id == upsellCustomerType.id;
			});

			// Use DYNAMIC_PRICING.price if available (set by _copyLowestDynamicPricingToUpsell / _copyDynamicPricingToUpsell)
			// DYNAMIC_PRICING.price already includes retail + tax + fees via getDynTotalPrice()
			// Fall back to cusTypeRetail for non-dynamic or when DYNAMIC_PRICING is not yet set
			if (checkProps('customerType.DYNAMIC_PRICING.price', customerType)) {
				total = +customerType.DYNAMIC_PRICING.price;
			} else {
				total = +customerType.cusTypeRetail;
			}

			if (includeComps) {
				total = +(total + Package.getFullCompPrice(upsellCustomerType, useVat)).toFixed(2);
			}

			return total;
		};

		/**
		 * Returns the Display Type Enum (Enum.upsellDisplayTypes) indicating the relationship between the original and upsell packages,
		 * Based solely on the Current Base Package's Active Customer Types, and the Upsell Customer types that were linked in the createCustomerTypeMappings
		 * @public
		 * @param {Array} customerTypeMappings Array of Mappings, each entry being an object with baseCustomerTypeId & upsellCustomerTypeId
		 * @returns {String} Enum indicator for what type of display style this upsell is
		 */
		service.getUpsellDisplayStyle = function(customerTypeMappings) {
			var uniquebaseCustomerTypeIds = 0;
			var uniqueupsellCustomerTypeIds = 0;

			var customerTypeMappingsLength = customerTypeMappings.length;
			for(var x = 0; x < customerTypeMappingsLength; x++) {

				// If the values we need to check for this object do not exist;
				// Return Unknown because that indicates some incorrect data being provided in the input
				if(!ngIsString(customerTypeMappings[x].baseCustomerTypeId) || !ngIsString(customerTypeMappings[x].upsellCustomerTypeId)) {
					return UpsellDisplayTypes.UNKNOWN;
				}

				for(var y = 0; y < customerTypeMappingsLength; y++) {

					if(x === 0 && y == 0) {
						uniquebaseCustomerTypeIds++;
						uniqueupsellCustomerTypeIds++;
					} else {
						if(customerTypeMappings[x].baseCustomerTypeId !== customerTypeMappings[y].baseCustomerTypeId) {
							uniquebaseCustomerTypeIds++;
						}
						if(customerTypeMappings[x].upsellCustomerTypeId !== customerTypeMappings[y].upsellCustomerTypeId) {
							uniqueupsellCustomerTypeIds++;
						}
					}
				}
			}

			if(uniquebaseCustomerTypeIds === 1) {
				if (uniqueupsellCustomerTypeIds === 1) {
					return UpsellDisplayTypes.ONETOONE;
				}
				if (uniqueupsellCustomerTypeIds > 1) {
					return UpsellDisplayTypes.ONETOMANY;
				}

			} else if(uniquebaseCustomerTypeIds > 1) {
				if (uniqueupsellCustomerTypeIds === 1) {
					return UpsellDisplayTypes.MANYTOONE;
				}
				if (uniqueupsellCustomerTypeIds > 1) {
					return UpsellDisplayTypes.MANYTOMANY;
				}
			}

			return UpsellDisplayTypes.UNKNOWN;
		}

		/**
		 * Retrieves background image that the a view can use from the current upsell package CHARACS.
		 * imageName is the name of the image to retrieve.  Where the actual image is can be determined
		 * by the caller of this function.
		 * textColor specified the color of any html text that is displayed on the background image.
		 * @public
		 * @returns {{imageName: string, textColor: string}} the background image that the a view can use
		 */
		service.getUpsellPackageBackgroundImageInfo = function() {
			var backgroundImageInfo = {
				imageName: '',
				textColor: ''
			};

			var pkg = Package.upsellPackage.packageDetails;

			if (checkProps('pkg.CHARACS', pkg)) {
				backgroundImageInfo.imageName = pkg.CHARACS.upsell_background_image_name || '';
				backgroundImageInfo.textColor = pkg.CHARACS.upsell_background_image_text_color || '';
			}

			return backgroundImageInfo;
		}

		/**
		 * Retrieves the title and bullet points to display from the upsell package characs.
		 * @public
		 * @returns {{title: string, bulletList: Array}} the title and bullet points to display
		 */
		service.getUpsellPackageSelectionInfo = function() {
			var packageSelectionInfo = {
				title: '',
				bulletList: []
			};

			var pkg = Package.upsellPackage.packageDetails;

			if (checkProps('pkg.CHARACS', pkg)) {

				packageSelectionInfo.title = pkg.CHARACS.upsell_selection_title || '';
				if (packageSelectionInfo.title) {
					packageSelectionInfo.title = service.updatePageVerbiage(packageSelectionInfo.title);
				}

				// Get the bullet CHARACS
				for (var i = 0; i < 3; i++) {
					var bulletCharacKey = 'upsell_selection_bullet_' + (i+1);

					if (ngIsString(pkg.CHARACS[bulletCharacKey])) {
						packageSelectionInfo.bulletList.push(pkg.CHARACS[bulletCharacKey]);
					} else {
						break;
					}
				}
			}

			return packageSelectionInfo;
		}

		/**
		 * Does all of the initial setup for the Upsell / Upsell-Wizard
		 * This includes preparing:
		 * 		+ the mapping between Base Package and Upsell Package customer types
		 * 		+ the display type
		 * 		+ the Upsell CustomerTypes that will be shown
		 * 		+ the lowest price difference
		 * @public
		 * @param {number} packageId The ID of the Base Package that the user came from, used for routing.
		 * @param {function} updateMaxQuantityCallback Called in the even this is a One-to-Many scenario - Used to QTY manipulation
		 * @returns {undefined}
		 */
		service.initializeUpsell = function(packageId, updateMaxQuantityCallback, fromPricing) {
			service.upsellCustomerTypes = [];
			service.lowestPriceDifference = '';
			service.displayType = UpsellDisplayTypes.UNKNOWN;

			var basePackageDetails = Package.packageDetails;
			var dynamicBaseCustomerTypes = Package.customerTypes;
			var dynamicUpsellCustomerTypes = Package.upsellPackage.customerTypes;
			service.baseCustomerTypes = angular.copy(Package.customerTypes);
			customerTypeMappings = service.createCustomerTypeMappings(dynamicBaseCustomerTypes, dynamicUpsellCustomerTypes, basePackageDetails.CHARACS);
			service.displayType = service.getUpsellDisplayStyle(customerTypeMappings);

			var originalBaseCustomerTypes = Package.packageDetails.CT;
			var originalUpsellCustomerTypes = Package.upsellPackage.packageDetails.CT;
			var upsellPackageDetails = Package.upsellPackage.packageDetails;

			service.upsellCustomerTypes = service.createTempUpsellCustomerTypes(customerTypeMappings, dynamicUpsellCustomerTypes, dynamicBaseCustomerTypes, originalBaseCustomerTypes, originalUpsellCustomerTypes, service.displayType);

			// Error output message for Operations for incorrect Upsell Package Setup
			if (!validArray(service.upsellCustomerTypes)) {
				$log.error('Rate Upsell has been incorrectly setup, please review base package ' + basePackageDetails.id + ' and ensure customer types have been setup correctly. Reference RateUpsell Charac.');
			}

			service._setPricing(service.upsellCustomerTypes, dynamicBaseCustomerTypes, basePackageDetails, upsellPackageDetails, fromPricing);

			service.lowestPriceDifference = service.getLowestPriceDifference(service.upsellCustomerTypes);
			if (Package.upsellPackage.packageDetails.isMembership) {
				service.membershipUpsellAmount = service.upsellCustomerTypes[0].membershipUpsellMonthlyPrice;
			}
			if(service.displayType === UpsellDisplayTypes.UNKNOWN) {
				service.cancelUpsell(true, packageId);
			} else if (service.displayType === UpsellDisplayTypes.ONETOMANY) {
				if (ngIsFunction(updateMaxQuantityCallback)) {
					updateMaxQuantityCallback();
				}
			}
		}

		/**
		 * Increments the quantity for the specified Customer Type by 1
		 * If this is a One-to-Many scenario, adjust the provided centralized Quantity variable
		 * @public
		 * @param {Object} customerType The Customer Type to update
		 * @param {Number} upsellSelectedQuantity Centralized quantity variable used to keep track of a single total quantity, used in One-to-Many scenarios
		 * @param {Number} upsellMaxQuantity Maximum total quantity to be comapred to, used in One-to-Many scenarios
		 * @returns {Number} returns the upsellSelectedQuantity which may/may not be modified
		 */
		service.incrementQty = function(customerType, upsellSelectedQuantity, upsellMaxQuantity, fromPricing) {
			if (service.displayType === UpsellDisplayTypes.ONETOMANY) {
				if (upsellSelectedQuantity < upsellMaxQuantity) {
					Package.incrementQty(customerType, false);
					upsellSelectedQuantity++;
				} else {
					upsellSelectedQuantity = calcTotalUpsellQuantity();
				}
			} else {
				Package.incrementQty(customerType, false);
			}

			service._setPricing(service.upsellCustomerTypes, Package.customerTypes, Package.packageDetails, Package.upsellPackage.packageDetails, fromPricing);
			return upsellSelectedQuantity;
		}

		/**
		 * This Add to cart functionality is different from the PackageDetails.
		 * A number of quantity adjustments are needed prior to next phase for adding to cart.
		 * @param {Number} viewportWidth For determining when to show a modal
		 * @param {Boolean} toggleButton indicates the current state of the toggle button
		 * @param {Number} upsellSelectedQuantity Centralized quantity selected by the user, used in One-to-Many scenarios
		 * @param {Number} upsellMaxQuantity Total Max Quantity, dictated by the Base Package's CustomerType in a One-to-Many scenario
		 * @param {Object} additionalCharacs Additional characs to add
		 * @param {Object} [modalCallbacks] Callbacks that will be triggered based on modals
		 * @returns {Boolean} True if successful, False otherwise
		 */
		service.onAddToCart = function(viewportWidth, toggleButton, upsellSelectedQuantity, upsellMaxQuantity, additionalCharacs, modalCallbacks) {
			var safeToResetUpsell = false,
				reservationModalCallback,
				isPackageTimeValid = true;

			// If adding to cart and no quantity selected and in info view, notify the user.
			// We want to show modal when the upsell quantity is 0, or when users use mobile devices and did not select quantity
			if ((toggleButton && viewportWidth < 638) || !service._hasUpsellQtySelected(upsellSelectedQuantity)) {
				showSelectErrorModal();
				return false;
			}

			// Do all quantity verifying and adjusting,
			// If this returns false it means that a quantity was invalid.
			if(!service._addToCartQuantityHandling(upsellSelectedQuantity, upsellMaxQuantity)) {
				return false;
			}

			//	make a copy of the items being added to cart
			var addItems = [];

			// using the tempObject to properly format each entry before it goes to the LegacyCart.addToCartUpsells

			// upsell package =================================
			var upsellPackageForCart = prepareUpsellForCart()
			addItems.push(upsellPackageForCart);

			// original package ================================
			var basePackageForCart = prepareBasePackageForCart();
			addItems.push(basePackageForCart);

			var customerTypes = [];
			var addItemsLength = addItems.length;
			for (var i = 0; i < addItemsLength; i++) {
				var addItemCTlength = addItems[i].customerTypes.length;
				for (var j = 0; j < addItemCTlength; j++) {
					if (addItems[i].customerTypes[j].qty > 0) {
						customerTypes.push(addItems[i].customerTypes[j]);
					}
				}
			}

			// quicksell package ==================================
			if (ngisObject(Package.quickSell) && Package.quickSell.status) {
				var quicksellForCart = prepareQuicksellForCart();
				addItems.push(quicksellForCart);
			} else if (validArray(Package.quickSellList)) {
				Package.quickSellList.forEach(function addQuicksellToCart(quickSellData) {
					var quickSellCT = quickSellData.quickSalesTypes[0];

					if (parseInt(quickSellCT.qty, 10) !== 0) {
						addItems.push(prepareQuicksellForCart(quickSellData));
					}
				});
			}

			Package.copyCharacsToEachItem(customerTypes);
			service._mapTrackingCharacsToCustomerTypes(customerTypes);

			if (isRealObject(additionalCharacs)) {
				customerTypes.forEach(function(ct) {
					if (Array.isArray(ct.CHARACS)) {
						ct.CHARACS.forEach(function(characs) {
							var newCharacs = {};

							if (additionalCharacs.event_id) {
								newCharacs.event_id = additionalCharacs.event_id;
							}

							if (additionalCharacs.start_date) {
								newCharacs.start_date = additionalCharacs.start_date;

								if (additionalCharacs.start_time) {
									newCharacs.start_time = additionalCharacs.start_time;
								}
							}

							if (isRealObject(additionalCharacs.dynamic_id)) {
								newCharacs.dynamic_pricing_id = additionalCharacs.dynamic_id[ct.id];
							}

							angular.extend(characs, newCharacs);
						});
					}
				});
			}

			// set isPackageTimeValid as false if the ticket is timed and it doesn't have a start_time
			if (checkProps('Package.packageDetails.E.date', Package, 'returnValue') === '1'
				&& !validString(additionalCharacs.start_time)) {
					isPackageTimeValid = false;
			}

			// We will place reserve the package before the the guest enters in any additional information
			if (ReservationService.canCallPlaceReservation(upsellPackageForCart.packageDetails.id)
				&& validArray(customerTypes)
				&& isPackageTimeValid) {

				// Sets as closure function so it can access the passed modalCallbacks parameter
				reservationModalCallback = function reservationModalCallback(sel) {
					// If callback is set and is a function, call it
					checkProps('modalCallbacks.PlaceReservation.' + sel, modalCallbacks, 'isFunction')
						&& modalCallbacks[Enums.services.PLACE_RESERVATION][sel]();
				}

				// Show spinner with locale to give feedback to the guest that we are try to reservce their selection
				$rootScope.showSpinner(Language.getLocale('UpSells', 'placeReservationLoadingText'));

				// Try and reserve their selection
				ReservationService
					.placeReservation(upsellPackageForCart.packageDetails.id, customerTypes, additionalCharacs.start_date, additionalCharacs.start_time, reservationModalCallback)
					.then(postAcceptUpsell);
			} else {
				postAcceptUpsell();
			}

			/**
			 * Closure function that holds actions after Place Reservation is complete
			 * or to be accessed directly if it doesn't get called
			 * @private
			 * @function
			 * @returns {undefined}
			 */
			function postAcceptUpsell() {
				safeToResetUpsell = LegacyCart.addUpsellsToCart(addItems);
				if (safeToResetUpsell) {
					// Dump all data that was for this specific upsell process
					service.resetUpsell();
				}
			}

			return true;
		}

		/**
		 * When the user clicks on the cancel action, we will add the original package, and quicksell, if one, exists to the cart.
		 * NOTE: I would have put the code into Package, but because Package is included in LegacyCart, including Cart in Package would have
		 * created a circular reference issue. At some point, figuring out a better layering
		 * strategy would be beneficial.
		 * @public
		 * @returns {undefined}
		 */
		service.onCancelAddToCart = function() {
			//make a copy of the items being added to cart
			var addItems = Utilities.copyObject(Package.customerTypes);
			if ($location.absUrl().indexOf('crossSells') != -1) {
				var addItemsLength = addItems.length;
				for (var i = 0; i < addItemsLength; i++) {
					addItems[i].CHARACS[0].crosssell = 'true';
				}
			}
			//if the package has quickSales then add to items
			if (ngisObject(Package.quickSell) && Package.quickSell.status) {
				// Adding only the first item in the array. There should not be more than one
				// quicksale, but if there is, let's limit the range to the first
				var quickSellPackage = Package.quickSell.quickSalesTypes[0];

				quickSellPackage.CHARACS[0].quicksell = 'true';
				quickSellPackage.CHARACS[0].quicksell_base_package = Package.packageDetails.id;
				addItems.push(quickSellPackage);
				CustomActionService.executeCustomAction('setSelectedQuickSellPackage', quickSellPackage);
			} else if (validArray(Package.quickSellList)) {
				Package.quickSellList.forEach(function addQuicksellToCart(quickSellData) {
					var quickSellPackage = quickSellData.quickSalesTypes[0];

					if (parseInt(quickSellPackage.qty, 10) !== 0) {
						quickSellPackage.CHARACS[0].quicksell = 'true';
						quickSellPackage.CHARACS[0].quicksell_base_package = Package.packageDetails.id;
						addItems.push(quickSellPackage);
						CustomActionService.executeCustomAction('setSelectedQuickSellPackage', quickSellPackage);
					}
				});
			}

			copyCharacs(addItems);

			Package.resetUpsellSkip();
			LegacyCart.addToCart(addItems, Package.packageDetails);
		}

		/**
		 * Modified version of Package.onQtyChange.
		 * Calculate the sum of fields, and ensure the sum is <= maxQuantity.
		 * @param {Object} customerType the Customer Type where you want to make the quantity adjustment on.
		 * @param {Number} upsellSelectedQuantity Centralized quantity variable used to keep track of a single total quantity, used in One-to-Many scenarios
		 * @param {Number} upsellMaxQuantity Maximum total quantity to be comapred to, used in One-to-Many scenarios
		 * @returns {Number} returns the upsellSelectedQuantity which may/may not be modified
		 */
		service.onQtyChange = function(customerType, upsellSelectedQuantity, upsellMaxQuantity, fromPricing) {
			// Validate the customerType entry.
			if (ngIsString(customerType.qty)) {
				customerType.qty = customerType.qty.replace(/\D/g, '');
			}

			if (customerType.qty === '' || isNaN(customerType.qty)) {
				if(service.displayType === UpsellDisplayTypes.ONETOMANY) {
					upsellSelectedQuantity = calcTotalUpsellQuantity();
				}
				return upsellSelectedQuantity;
			}

			if (service.displayType === UpsellDisplayTypes.ONETOMANY) {
				// Calculate the sum of all entries from the temp array.
				var currentQty = calcTotalUpsellQuantity();

				// Has it exceed the max quantity? If so, reset the value of the current, and return.
				if (currentQty > upsellMaxQuantity) {
					customerType.qty = 0;
					return currentQty;
				}
			}

			var qtyEntered = Number(customerType.qty);
			if (qtyEntered < customerType.min_quantity || qtyEntered > customerType.max_quantity) {
				qtyEntered = 0;
			}
			customerType.qty = qtyEntered;

			service._setPricing(service.upsellCustomerTypes, Package.customerTypes, Package.packageDetails, Package.upsellPackage.packageDetails, fromPricing);

			return upsellSelectedQuantity;
		}

		/**
		 * Replaces the original and upsell package names in the verbiage string
		 * @public
		 * @param {String} verbiage The string that contains the text to replace.
		 * @returns {String} The new string with the replaced values.
		 */
		service.updatePageVerbiage = function(verbiage) {
			// Update the verbiage on the page.
			var findStr = [];
			var replStr = [];

			findStr.push('@@packageName');
			replStr.push(Package.packageDetails.name); // original package name.

			findStr.push('@@upsellPackageName');
			replStr.push(Package.upsellPackage.packageDetails.name); // upsell package name.

			// create the necessary verbiage for the page.
			return Language.replaceAllMultiple(findStr, replStr, verbiage);
		}

		/**
		 * Validates the quantity of each Customer Type in relation to the given Base Package's PackageDetails, to ensure Package's minimum quantity rule is upheld.
		 * NOTE: This throws a Modal if total Quantity is below Package minimum
		 * @param {Array} cts Customer Types to iterate through
		 * @param {Object} pkgDetails The Package Details of the Base Package
		 * @returns {Boolean} True if minimum quantity is met for all items, False otherwise
		 */
		service.validateOriginalPkgMinQty = function(cts, pkgDetails) {
			// Count the total being added to the original pacakge.
			// If > 0 && < pkg min qty - error 1
			// Count the total being added to upsell pkg
			// If > 0 && < upsell pkg min qty - error 2
			var totalQty = cts.reduce(function(accu, current) {
				return accu + Number(current.qty);
			}, 0);

			if (!isNaN(totalQty) && totalQty > 0 &&	totalQty < Number(pkgDetails.min_quantity) && Number(pkgDetails.min_quantity) > 0) {
				var desc = Language.getLocale('UpSells', 'originalPkgErrorMsg').replace(/@@pkgName/g, pkgDetails.name).replace(/@@pkgMinQty/g, pkgDetails.min_quantity).replace(/@@totalQty/g, totalQty);

				Modal.displayModal({
					title: Language.getLocale('UpSells', 'originalPkgErrorTitle'),
					description: desc,
					icon: 'icon-info red',
					buttonFlags: [Enums.buttonFlags.OK]
				});

				return false;
			}

			return true;
		}

		/**
		 * Validates the quantity of each Customer Type in relation to the given Upsell Package's PackageDetails, to ensure Package's minimum quantity rule is upheld.
		 * NOTE: This throws a Modal if total Quantity is below Package minimum
		 * @param {Object} upsellPkgDetails The Package Details of the Upsell Package
		 * @returns {Boolean} True if minimum quantity is met for all items, False otherwise
		 */
		service.validateUpsellPkgMinQty = function(upsellPkgDetails) {
			var pkgMinQty = Number(upsellPkgDetails.packageDetails.min_quantity);
			var pkgMaxQty = Number(upsellPkgDetails.packageDetails.max_quantity);
			var selectedQty = 0;
			var msg = [];

			var customerTypesLength = upsellPkgDetails.customerTypes.length;
			for(var i = 0; i < customerTypesLength; i++) {
				var item = upsellPkgDetails.customerTypes[i];

				var minQty = Number(item.min_quantity) || 0;
				var maxQty = Number(item.max_quantity) || 0;
				var qty = Number(item.qty);

				if (qty > 0 && qty < minQty && minQty > 0) {
					msg.push(getUpsellErrorMsg(item.cusTypeName, Language.getLocale('UpSells', 'upsellErrorTypeMin'), minQty, qty, Language.getLocale('UpSells', 'upsellPkgErrorMsg')) + '<br>');
				} else if (maxQty > 0 && qty > maxQty) {
					msg.push(getUpsellErrorMsg(item.cusTypeName, Language.getLocale('UpSells', 'upsellErrorTypeMax'), maxQty, qty, Language.getLocale('UpSells', 'upsellPkgErrorMsg')) + '<br>');
				}

				selectedQty += item.qty;
			}

			if (selectedQty > 0 && selectedQty < pkgMinQty && pkgMinQty > 0) {
				msg.push(getUpsellErrorMsg(upsellPkgDetails.packageDetails.name, Language.getLocale('UpSells', 'upsellErrorTypeMin'), pkgMinQty, selectedQty, Language.getLocale('UpSells', 'upsellPkgErrorMsg')) + '<br>');
			} else if (selectedQty > 0 && selectedQty > pkgMaxQty && pkgMaxQty > 0) {
				msg.push(getUpsellErrorMsg(upsellPkgDetails.packageDetails.name, Language.getLocale('UpSells', 'upsellErrorTypeMax'), pkgMaxQty, selectedQty, Language.getLocale('UpSells', 'upsellPkgErrorMsg')) + '<br>');
			}

			if (msg.length) {
				var modalMsg = '<b>' + Language.getLocale('UpSells', 'upsellErrorHeader') + '</b><br><br>' + msg.join('<br><br>');
				Modal.displayModal({
					title: Language.getLocale('UpSells', 'upsellPkgErrorTitle'),
					description: modalMsg,
					icon: 'icon-info red',
					buttonFlags: [Enums.buttonFlags.OK]
				});

				return false;
			}

			return true;
		}

		/**
		 * Calculate the Total current quantity of all upsell customer types
		 * @protected
		 * @return {Number} Total current quantity of all upsell customer types
		 */
		function calcTotalUpsellQuantity() {
			var currentQty = service.upsellCustomerTypes.reduce(function(accu, current) {
				return accu + Number(current.qty);
			}, 0);

			return currentQty;
		}

		/**
		 * Modify the given addItems by copying the Characs array once for each qty
		 * @param {Array} addItems The Items that require Characs mapped to them
		 * @returns {undefined}
		 */
		function copyCharacs(addItems) {
			var addItemsLength = addItems.length;
			for (var i = 0; i < addItemsLength; i++) {
				if (ngIsNumber(addItems[i].qty) && aIsArray(addItems[i].CHARACS)) {
					if (addItems[i].qty > 1) {
						var copyCharacs = addItems[i].CHARACS[0];
						var qty = addItems[i].qty;
						for (var j = 1; j < qty; j++) {
							addItems[i].CHARACS[j] = ngCopy(copyCharacs);
						}
					}
				}
			}
		}

		/**
		 * Package.customerTypes.CHARACS = Package.itemsToBeAdded.CHARACS
		 * @protected
		 * @returns {undefined}
		 */
		function copyCharacsFromPendingItems() {
			var dynamicBaseCTsLength = Package.customerTypes.length;
			var itemsToBeAddedLength = Package.itemsToBeAdded.length;

			for (var i = 0; i < dynamicBaseCTsLength; i++) {
				for (var j = 0; j < itemsToBeAddedLength; j++) {
					var currentCt = Package.customerTypes[i];
					var currentItemToBeAdded = Package.itemsToBeAdded[j];

					if (currentCt.cusTypeName == currentItemToBeAdded.cusTypeName && currentCt.package_id == currentItemToBeAdded.package_id && currentCt.customer_type == currentItemToBeAdded.customer_type) {
						currentCt.CHARACS = currentItemToBeAdded.CHARACS;
					}
				}
			}
		}

		/**
		 * Grabs a matching Customer Type whos ID matches the provided one
		 * @private
		 * @param {number} id The Id you are searching against
		 * @param {Array} arrayOfCustomerTypes Array of Customer Types to iterate through
		 * @returns {Object} the matching Customer Type
		 */
		function getMatchingById(id, arrayOfCustomerTypes) {
			var length = arrayOfCustomerTypes.length;
			for(var i = 0; i < length; i++) {
				var entry = arrayOfCustomerTypes[i];
				if(entry.id === id) {
					return entry;
				}
			}
			return undefined;
		}

		/**
		 * Prepares a copy of the upsellCT provided
		 * In addition, supplants additional information from the linkedBaseCT
		 * @protected
		 * @param {Object} correctUpsellCT The Customer Type from the Upsell Package that is to be copied and updated
		 * @param {Object} linkedBaseCT The dynamic Customer Type from the Base Package (the one the user selected quantities for / interacted with)
		 * @param {String} displayType The display type / What type of upsell it is, defined by Enums
		 * @returns {Object} the updated copy Customer Type
		 */
		function getTempUpsellCustomerType(correctUpsellCT, linkedBaseCT, originalBaseCT, originalUpsellCT, displayType) {
			var upsellCTcopy = ngCopy(correctUpsellCT);
			upsellCTcopy.originalBaseCT = originalBaseCT;
			upsellCTcopy.originalUpsellCT = originalUpsellCT;

			// get the mapped customer type name, to indicate what we're upgrading from.
			upsellCTcopy.originalCusTypeName = linkedBaseCT.cusTypeName;

			// save the ID for the Base CT this UpsellCT was linked to, used in addToCart to grab original CT for quantity calculations
			upsellCTcopy.baseCustomerTypeId = linkedBaseCT.id;

			//Save Original Package Id and Retail Price for tracking
			upsellCTcopy.originalPackageId = linkedBaseCT.package_id;
			upsellCTcopy.originalPrice = linkedBaseCT.cusTypeRetail;

			upsellCTcopy.min_quantity = 0;
			upsellCTcopy.max_quantity = linkedBaseCT.qty;

			// one-to-many has a different setup.
			if (displayType === UpsellDisplayTypes.ONETOMANY) {
				// one-to-many requires the user to select the quantity differently from the other styles.
				upsellCTcopy.qty = 0;
			} else {
				// Make the adjustments.
				upsellCTcopy.qty = ngCopy(linkedBaseCT.qty);
			}

			return upsellCTcopy;
		}

		/**
		 * Prepares an error message by replacing placeholders with the provided information.
		 * @private
		 * @param {String} ctName Name of the Customer Type
		 * @param {String} type Type of the Error
		 * @param {String} minMaxQty The Min or Max quantity, based on the type of error
		 * @param {String} qty The current Quantity
		 * @param {String} locale The Locale that needs information supplanted
		 * @returns {String} The concatinated message
		 */
		function getUpsellErrorMsg(ctName, type, minMaxQty, qty, locale) {
			var msg = locale
					.replace(/@@ctName/g, ctName)
					.replace(/@@minMaxType/g, type)
					.replace(/@@ctMinQty/g, minMaxQty)
					.replace(/@@ctQty/g, qty) + '<br>';

			return msg;
		}

		/**
		 * Makes and returns a cart-ready object based on the Base package.
		 * @protected
		 * @returns {Object} cart-ready object based on the Base package.
		 */
		function prepareBasePackageForCart() {
			var basePackageForCart = {
				packageDetails: Package.packageDetails,
				customerTypes: [],
				isAdvancedTicket: Package.isAdvancedTicket,
				advanceTicketDate: Package.advanceTicketDate
			};

			if (Package.itemsToBeAdded) {
				copyCharacsFromPendingItems();
			}

			var customerTypesLength = Package.customerTypes.length;
			for (var i = 0; i < customerTypesLength; i++) {
				basePackageForCart.customerTypes.push(Package.customerTypes[i]);
			}

			return basePackageForCart;
		}

		/**
		 * Create and return an object for this Quicksell
		 * @protected
		 * @param {Object} [quickSellData] A single entry from Package.quickSellList to use instead of the default Package.quickSell (multi-quicksell case)
		 * @returns {Object} The Quicksell to be returned
		 */
		function prepareQuicksellForCart(quickSellData) {
			var quicksellSource = quickSellData || Package.quickSell;

			//add only the first item in the array there should not be more than one
			//quicksale, but if there is, let's limit the range to the first
			var tempObject = {
				packageDetails: quicksellSource.quickSalesDetails,
				customerTypes: [quicksellSource.quickSalesTypes[0]],
				isAdvancedTicket: false,
				advanceTicketDate: null
			};

			// using the same structure as the others.
			if(aIsArray(tempObject.customerTypes[0].CHARACS)) {
				tempObject.customerTypes[0].CHARACS[0].quicksell = 'true';
				tempObject.customerTypes[0].CHARACS[0].quicksell_base_package = Package.packageDetails.id;
			}

			CustomActionService.executeCustomAction('setSelectedQuickSellPackage', tempObject.customerTypes[0]);

			return tempObject;
		}

		/**
		 * Makes and returns a cart-ready object based on the upsell package.
		 * @protected
		 * @returns {Object} cart-ready object based on the upsell package.
		 */
		function prepareUpsellForCart() {
			var upsellPackageForCart = {
				packageDetails: Package.upsellPackage.packageDetails,
				customerTypes: [],
				isAdvancedTicket: Package.upsellPackage.isAdvancedTicket,
				advanceTicketDate: Package.upsellPackage.advanceTicketDate
			};

			var upsellCustomerTypesLength = Package.upsellPackage.customerTypes.length;
			for (var i = 0; i < upsellCustomerTypesLength; i ++) {
				upsellPackageForCart.customerTypes.push(Package.upsellPackage.customerTypes[i]);
			}

			if (startDateExists(upsellPackageForCart)) {
				upsellPackageForCart.packageDetails.CHARACS.start_date = Package.itemsToBeAdded[0].CHARACS[0].start_date;
			}

			return upsellPackageForCart;
		}

		/**
		 * If the upsell quantity of a package is out of its valid range, reset quantities of the dynamic Upsell CT's and the dynamic Base CT's
		 * @protected
		 * @returns {undefined}
		 */
		function resetPackageQty() {
			// Iterate through the Customer Types that are interacted with by the user
			var upsellCustomerTypesLength = service.upsellCustomerTypes.length;
			for(var i = 0; i < upsellCustomerTypesLength; i++) {
				var upsellCT = service.upsellCustomerTypes[i];

				// The Dynamic Customer Type of the Base Package, the customer type the user chose/edited
				var dynamicBaseCT = getMatchingById(upsellCT.baseCustomerTypeId, Package.customerTypes);

				// The Dynamic Customer Type of the Upsell Package
				var dynamicUpsellCT = getMatchingById(upsellCT.id, Package.upsellPackage.customerTypes);

				var upsellQty = upsellCT.qty;
				var packageQty = (dynamicBaseCT.qty + upsellQty);

				dynamicUpsellCT.qty -= upsellQty;
				dynamicBaseCT.qty = packageQty;
			}
		}

		/**
		 * We assume that Package.upsellPackage.customerTypes[i] will begin with the default quantity of 0,
		 * but in the case of single rate types, it is set to the min_quantity.
		 * To fix this, we will iterate through the CTs prior to this logic and reset them to 0 to ensure
		 * that the quantity calculations will be accurate. This should be acceptable because at this point
		 * the service.upsellCustomerTypes has all the quantity data needed to make the calculations.
		 * @protected
		 * @param {Array} dynamicUpsellCTs The dynamic Upsell Customer Types that will be updated by the user's selections, whose Quantities need to be reset to 0
		 * @returns {undefined}
		 */
		function resetQuantities(dynamicUpsellCTs) {
			var dynamicUpsellCTLength = dynamicUpsellCTs.length;
			for(var x = 0; x < dynamicUpsellCTLength; x++) {
				dynamicUpsellCTs[x].qty = 0;
			}
		}

		/**
		 * Resets all data related to the upsell
		 * @public
		 * @returns {undefined}
		 */
		service.resetUpsell = function() {
			service.lowestPriceDifference = undefined;
			service.displayType = undefined;
			service.upsellCustomerTypes.length = 0;
		}

		/**
		 * Alert the user to select qty.
		 * @private
		 * @returns {undefined}
		 */
		function showSelectErrorModal() {
			Modal.displayModal({
				title: Language.getLocale('Alert', 'cartNoQtySelectedTitle'),
				description: Language.getLocale('Alert', 'cartNoUpsellQtySelectedMsg'),
				icon: 'icon-info red',
				buttonFlags: [Enums.buttonFlags.OK]
			});
		}

		/**
		 * Returns whether or not the package provided has a preselected start date AND the correlating Package.itemsToBeAdded object has a start date
		 * @param {Object} packageObj The Package that is going to be added to the cart
		 * @returns {Boolean} True if it has a preselected start date AND the correlating Package.itemsToBeAdded has a start date
		 */
		function startDateExists(packageObj) {
			return checkProps('itemsToBeAdded[].0.CHARACS[].0.start_date', Package.itemsToBeAdded, 'isDateString')
				&& (
					checkProps('packageObj.packageDetails.CHARACS.use_prev_sel_date', packageObj, 'getBoolean')
					|| [Enums.packageEventType.DATE_TIME_EVENT, Enums.packageEventType.DATE_ONLY_EVENT].includes(Package.upsellPackage.packageDetails.E.date)
				);
		}

		/**
		 * Build a request body for getMerchantPackageEventDates and fetch the call
		 * @function
		 * @public
		 * @returns {Promise} return a promise upsell available dates
		 * @throws {TypeError} error when event ID and package ID are not valid
		 */
		function checkUpsellDatesAvailability() {
			var deferred = $q.defer(),
				event = checkProps('Package.upsellPackage.packageDetails.E', Package, 'returnValue'),
				upsellPackageId = checkProps('Package.upsellPackage.packageDetails.id', Package, 'returnValue'),
				startDate = checkProps('Package.itemsToBeAdded.0.CHARACS.0.start_date', Package, 'returnValue'),
				isDynamic = DynamicCapacityPricingService.isPackageDynamic(upsellPackageId),
				promiseChain = $q.resolve(true),
				hasAvailability = false;

			if (!event.id) {
				throw new TypeError(ERROR_PREFIX + 'invalid upsell event id');
			} else if (!upsellPackageId) {
				throw new TypeError(ERROR_PREFIX + 'invalid upsell package id');
			}

			if (isDynamic && startDate) {
				switch (event.date) {
				// DateTime
				case '1':
					promiseChain = service._getDynamicDatetimeUpsellValues(event.id, upsellPackageId, startDate);
					break;
				// Dated
				default:
					promiseChain = DynamicCapacityPricingService
						.fetchLivePricing(upsellPackageId, startDate, null, service._getUpsellCustomerTypes())
						.then(service._copyDynamicPricingToUpsell);
					break;
				}
			}

			// No start date means upsell package does not require date - resolve with availabity
			// We can bypass this check by adding disable_upsell_quantity_check
			if (!startDate || parseInt(event.capacity, 10) === -1 || checkProps('Package.packageDetails.CHARACS.disable_upsell_quantity_check', Package, 'getBoolean')) {
				return $q.resolve(true);
			}

			$rootScope.showSpinner(Language.getLocale('ApplicationLabels', 'extendedLoadingSpinner'));

			promiseChain.then(function promiseChain() {
				service._getUpsellPackageEventDates(event.id, upsellPackageId, startDate)
					.then(function promiseSuccess(data) {
						// If there is no available date, BE doesn't return us D or DT node back from this call
						hasAvailability = data.status === Enums.status.OK && !!(data.D || data.DT) && [data.package_id, checkProps('data.D.0.package_id', data, 'returnValue')].includes(upsellPackageId);
					}).finally(function promiseComplete() {
						deferred.resolve(hasAvailability);
					});
			});

			return deferred.promise;
		}

		/**
		 * Calls GetMerchantPackageEventDates with the supplied parameters
		 * @function
		 * @protected
		 * @param {String} eventId - The upsell event ID
		 * @param {String} packageId - The upsell package ID
		 * @param {String} startDate - The start date to search
		 * @returns {Promise} - The promise object for the request
		 */
		service._getUpsellPackageEventDates = function(eventId, packageId, startDate) {
			var requestObject = service._getUpsellDatesReqObj(eventId, packageId, startDate);
			if (!requestObject) {
				return $q.reject(new TypeError(ERROR_PREFIX + 'invalid request object'));
			}
			return AppData.fetch(
				Enums.services.GET_MERCHANT_PACKAGE_EVENT_DATES,
				false,
				requestObject
			);
		};

		/**
		 * Grabs the pricing information for all available time slots on dynamic priced items that are date + time
		 * @function
		 * @protected
		 * @param {String} eventId - The upsell event ID
		 * @param {String} packageId - The upsell package ID
		 * @param {String} startDate - The start date
		 * @returns {Promise} - The promise object that will be resolved after the call promise chain
		 */
		service._getDynamicDatetimeUpsellValues = function(eventId, packageId, startDate) {
			var deferred = $q.defer();

			$rootScope.showSpinner(Language.getLocale('ApplicationLabels', 'extendedLoadingSpinner'));

			service._getUpsellPackageEventDates(eventId, packageId, startDate)
				.then(function eventDatesSuccess(data) {
					var availableTimes = [];
					var customerTypes = service._getUpsellCustomerTypes();

					toArray(data.D).forEach(function findAvailableTimes(day) {
						if (day.T) {
							toArray(day.T).forEach(function collectAvailableTime(timeslot) {
								if (+timeslot.available) {
									availableTimes.push(timeslot.time);
								}
							});
						}
					});

					var timeString = availableTimes.length ? availableTimes.join(',') : undefined;

					DynamicCapacityPricingService
						.fetchCachedPricing(packageId, startDate, timeString, customerTypes)
						.then(service._copyLowestDynamicPricingToUpsell)
						.finally(deferred.resolve);
				})
				.catch(deferred.resolve);

			return deferred.promise;
		};

		/**
		 * Sets the dynamic pricing information to each of the upsell customer types
		 * @function
		 * @protected
		 * @param {Object} prices - The calculated Dynamic Pricing object
		 * @returns {undefined}
		 */
		service._copyDynamicPricingToUpsell = function(prices) {
			Package.upsellPackage.customerTypes.forEach(function iterateUpsellCustomerTypes(ct) {
				if (prices[ct.id]) {
					ct.DYNAMIC_PRICING = ngCopy(prices[ct.id]);
				}
			});
		};

		/**
		 * Copies the lowest dynamic pricing across all time slots to the upsell customer types.
		 * Handles both single-time (object) and multi-time (array of {pricing, time}) responses.
		 * @function
		 * @protected
		 * @param {Object|Array} pricingResult - Single pricing object or array of {pricing, time} objects
		 * @returns {undefined}
		 */
		service._copyLowestDynamicPricingToUpsell = function(pricingResult) {
			if (!angular.isArray(pricingResult)) {
				return service._copyDynamicPricingToUpsell(pricingResult);
			}

			Package.upsellPackage.customerTypes.forEach(function iterateUpsellCustomerTypes(ct) {
				var lowestPricing;

				pricingResult.forEach(function findLowestPricing(entry) {
					var ctPricing = entry.pricing[ct.id];

					if (ctPricing && (!lowestPricing || ctPricing.price < lowestPricing.price)) {
						lowestPricing = ctPricing;
					}
				});

				if (lowestPricing) {
					ct.DYNAMIC_PRICING = ngCopy(lowestPricing);
				}
			});
		};

		/**
		 * Gets the customer types for the upsell package
		 * @function
		 * @protected
		 * @returns {String[]} - The customer types assigned to the upsell package
		 */
		service._getUpsellCustomerTypes = function() {
			var customerTypes = [];

			Package.upsellPackage.customerTypes.forEach(function iterateUpsellCustomerTypes(ct) {
				customerTypes.push(ct.id);
			});

			return customerTypes;
		};

		/**
		 * Handles showing an upsell or routing to the upsell wizard
		 * @param {Object} currentPackageDetails The current package we're trying to upsell from.
		 * @param {Object} upsellPackageDetails The package we're going to upsell to
		 * @param {Function} onNoCallback If this ends up becoming a modal, you have to handle them choosing no.
		 * @param {Date} jsonString If this is a non-standard package details page and you want add have continuous package characs for start date/time and other characs, pass the json string here.
		 * @param {Object} fromPricing A customerTypeId -> price map JSON stringified
		 * 		{
		 * 			"123": {
		 * 				"FEE": { "amount": "1.00" },
		 * 				"retail_amount": "10.00",
		 * 				"tax_amount": "3.00",
		 * 			},
		 * 			"343": {...}
		 * 		}
		 * @returns {undefined}
		 */
		function showUpsell(currentPackageDetails, upsellPackageDetails, onNoCallback, jsonString, fromPricing) {
			var priceDifference;
			var findStr = [];
			var replStr = [];
			var image;
			var modalTitle = "";
			var modalBody;
			var desc;
			var extraRouteParams;

			if (validString(jsonString)) {
				extraRouteParams = '/' + jsonString;

				if (fromPricing) {
					extraRouteParams += '/' + Security.base64.encode(JSON.stringify(fromPricing));
				}
			}

			// Store selected package info in wizard.
			CustomActionService.executeCustomAction('setSelectedPackage', currentPackageDetails);

			if (Utilities.childDefined(upsellPackageDetails, 'CHARACS.upsell_wizard') && Utilities.getBoolean(upsellPackageDetails.CHARACS.upsell_wizard)) {
				// Attempt to route to Upsell Recommender Wizard
				if (!CustomActionService.executeCustomAction('routeToUpsell', Enums.routes.UPSELL_RECOMMENDER_WIZARD)) {
					Package.preUpsellPkg = Package.packageDetails;
					if (validString(extraRouteParams)) {
						$rootScope.routeTo(Enums.routes.UPSELL_WIZARD_ALT + '/' + Package.packageDetails.id + extraRouteParams);
					} else {
						$rootScope.routeTo(Enums.routes.UPSELL_WIZARD + '/' + Package.packageDetails.id);
					}
				}
			} else {
				// Do default upsell, the Modal
				// The spinner may be showing from checkUpsellDatesAvailability(). The modal does not
				// trigger a state transition, so onSuccess in run.js will never dismiss it — do it here.
				$rootScope.hideSpinner();

				service.initializeUpsell(currentPackageDetails.id, undefined, fromPricing);

				// Hack for newer versions of iOS not rendering the Upsell
				// Modal correctly. This forces the browser to redraw the
				// page elements by scrolling to the top of the page.
				Utilities.scrollPosition();

				image = (UtilsValidation.validString(upsellPackageDetails.shop_image_v4)) ? $rootScope.getAssetUrl(upsellPackageDetails.shop_image_v4) : null;

				priceDifference = $filter('currencyFormatter')(service.lowestPriceDifference);

				if (checkProps('packageDetails.CHARACS.package_type', upsellPackageDetails) && upsellPackageDetails.CHARACS.package_type.toLowerCase() === 'membership') {
					priceDifference += ' ' + Language.getLocale('PackageList', 'perMonthLabel');
				}

				findStr.push('@@upsellPackageName');
				replStr.push(Package.upsellPackage.packageDetails.name);

				findStr.push('@@difference');
				replStr.push(priceDifference);

				findStr.push('@@packageName');
				replStr.push(Package.packageDetails.name);

				//If the upsell package charac has been set, use that, otherwise default to the title
				if (Utilities.childDefined(upsellPackageDetails, 'CHARACS.upsell_package_title')) {
					modalTitle = Language.replaceAllMultiple(findStr, replStr, upsellPackageDetails.CHARACS.upsell_package_title);
				} else {
					modalTitle = Language.replaceAllMultiple(findStr, replStr, Language.getLocale('UpSells', 'modalTitle'));
				}

				modalBody = Language.replaceAllMultiple(findStr, replStr, Language.getLocale('UpSells', 'modalBody'));

				desc = '<p class="blue"><b>' + modalBody + '</b></p>';
				//If the upsell package charac has been set, use that, otherwise default to the description
				if (Utilities.childDefined(upsellPackageDetails, 'CHARACS.upsell_package_desc')) {
					desc += '<p>' + upsellPackageDetails.CHARACS.upsell_package_desc + '</p>';
				} else {
					desc += '<p>' + upsellPackageDetails.desc + '</p>';
				}

				if (UtilsValidation.validObject(Package.upsellPackage) && Package.hasUpsellPackage() && Package.upsellPackage.skip === false) {
					$rootScope.$broadcast('triggerPromoImpressions', 'Upsells', [Package.upsellPackage.packageDetails]);
				}

				Modal.displayModal({
					action: 'Upsell',
					buttonFlags: [Enums.buttonFlags.NO_THANKS, Enums.buttonFlags.LEARN],
					callback: function(detail) {
						var upsellRoute;

						if (detail === Enums.buttonFlags.NO_THANKS) {
							Package.upsellPackage.skip = true;
							onNoCallback();
						} else if (detail === Enums.buttonFlags.LEARN) {
							if (validString(extraRouteParams)) {
								return $rootScope.routeTo(Enums.routes.UPSELL_ALT + '/' + Package.packageDetails.id + extraRouteParams);
							}

							// assume modal closes itself.
							// display the upsell version.
							if (!CustomActionService.executeCustomAction('routeToUpsell', Enums.routes.UPGRADE_RECOMMENDER_WIZARD)) {
								Package.preUpsellPkg = Package.packageDetails;
								upsellRoute = Enums.routes.UPSELL + '/' + Package.packageDetails.id;

								if (checkProps('preupsellPkg.CHARACS.alt_upsell_route_state', Package.preUpsellPkg)) {
									upsellRoute = Package.preUpsellPkg.CHARACS.alt_upsell_route_state;
									if (checkProps('preupsellPkg.CHARACS.alt_upsell_route_params', Package.preUpsellPkg)) {
										Package.preUpsellPkg.CHARACS.alt_upsell_route_params.split(',').forEach(function(param) {
											upsellRoute += '/' + param;
										});
									}
									CustomActionService.registerCustomAction(CustomActionService.ACTIONS_ENUMS.ALT_MODULE_ON_CANCEL_UPSELL, service.cancelUpsell, [false, Package.preUpsellPkg.id]);
								}

								$rootScope.routeTo(upsellRoute);
							}
						}
					},
					category: 'Upgrade',
					description: desc,
					desktop: true,
					image: image,
					label: 'Upgrade Options',
					showCloseButton: false,
					title: modalTitle
				});
			}
		}

		/**
		 * Determines the request object for GetMerchantPackageEventDates API call.
		 *
		 * IMPORTANT: This function consolidates customer type quantities to prevent duplicate
		 * customer type IDs in the API request, which would cause "Invalid parameter in request" errors.
		 *
		 * This handles all upsell scenarios:
		 * - One-to-One: Adult (ID: 2) → VIP Adult (ID: 2) - no consolidation needed
		 * - Many-to-One: Adult (ID: 2) + Senior (ID: 4) → VIP Pass (ID: 581) - consolidation required
		 * - One-to-Many: Adult (ID: 2) → VIP Adult (ID: 581) + VIP Parking (ID: 582) - no consolidation needed
		 * - Many-to-Many: Multiple base types → Multiple upsell types - consolidation where needed
		 *
		 * Example scenario:
		 * - Base package has: Adult (ID: 2, qty: 1) and Senior (ID: 4, qty: 1)
		 * - Both map to same upsell customer type: VIP Pass (ID: 581)
		 * - Without consolidation: API gets [{id: 581, qty: 1}, {id: 581, qty: 1}] = ERROR
		 * - With consolidation: API gets [{id: 581, qty: 2}] = SUCCESS
		 *
		 * @function
		 * @private
		 * @param {String} upsellEventId ID of the Upsell event
		 * @param {String} upsellPackageId ID of the Upsell package
		 * @param {String} startDate The date to use for start/end date
		 * @returns {Object} A request object for use in GetMerchantPackageEventDates
		 */
		service._getUpsellDatesReqObj = function getUpsellDates(upsellEventId, upsellPackageId, startDate) {
			var currentPackage = Package.packageDetails,
				mappings,
				minQty = 0,
				// This map prevents duplicate customer type IDs by consolidating quantities
				customerTypeMap = {},
				pkgs = [{
					// Will be populated with consolidated customer types
					CT: [],
					event_id: upsellEventId,
					id: upsellPackageId
				}];

			// Create mappings between base customer types and upsell customer types
			// This tells us which base customer type maps to which upsell customer type
			mappings = service.createCustomerTypeMappings(Package.customerTypes, Package.upsellPackage.customerTypes, currentPackage.CHARACS);

			// Process each base customer type that the user selected
			Package.customerTypes.forEach(function iterateCtForRequest(item) {
				// Find which upsell customer type this base customer type maps to
				var correspondingMapping = mappings.find(function findMapping(mapping) {
					return mapping.baseCustomerTypeId === item.id;
				});

				if (correspondingMapping) {
					var upsellCustomerTypeId = correspondingMapping.upsellCustomerTypeId;

					// CONSOLIDATION LOGIC: Handle Many-to-One scenarios
					// If we've already seen this upsell customer type ID, add to existing quantity
					// Otherwise, create new entry with current quantity
					if (!customerTypeMap[upsellCustomerTypeId]) {
						customerTypeMap[upsellCustomerTypeId] = 0;
					}
					customerTypeMap[upsellCustomerTypeId] += item.qty;

					// Track total minimum capacity needed
					minQty += item.qty;
				}
			});

			// Convert our consolidated map into the API format
			// Each unique customer type ID becomes one entry with total consolidated quantity
			Object.keys(customerTypeMap).forEach(function buildApiCustomerType(customerTypeId) {
				pkgs[0].CT.push({
					id: customerTypeId,
					// This is the consolidated total
					qty: customerTypeMap[customerTypeId]
				});
			});

			// Return the API request object
			return {
				P: pkgs,
				endDate: startDate,
				extraMovie: 'upsell_wizard',
				minCapacity: minQty,
				startDate: startDate,
				version: '2'
			};
		}

		return service;
	}
})();

angular
.module('upsell-page', ['app', 'upsell'])
.config(function($locationProvider, $stateProvider) {
	$stateProvider
	.state('/upgrade', {
		url: '/upgrade',
		templateUrl: '/scripts/modules/upsell/modules/upsell-page/views/upsellView.html',
		controller: 'UpsellCtrl',
		title: 'upsell',
		resolve: {
			load: function(Utilities, $rootScope) {
				$rootScope.showSpinner();
				return Utilities.cacheBustAndLazyLoad([
					'/scripts/modules/upsell/modules/upsell-page/controllers/upsell-page-controller.js'
				]);
			},
			initialData: function(load, Bootstrap) {
				return Bootstrap.bootstrapApplication();
			}
		},
		onEnter: onEnter
	})
	.state('/upgrade/:packageId', {
		url: '/upgrade/:packageId',
		templateUrl: '/scripts/modules/upsell/modules/upsell-page/views/upsellView.html',
		controller: 'UpsellCtrl',
		title: 'upsell',
		resolve: {
			load: function(Utilities, $rootScope) {
				$rootScope.showSpinner();
				return Utilities.cacheBustAndLazyLoad([
					'/scripts/modules/upsell/modules/upsell-page/controllers/upsell-page-controller.js'
				]);
			},
			initialData: function(load, Bootstrap) {
				return Bootstrap.bootstrapApplication();
			}
		},
		onEnter: onEnter
	})
	.state('upgrade-alt', {
		url: '/upgrade-alt/:packageId/:jsonCharacs/:fromPricing',
		templateUrl: '/scripts/modules/upsell/modules/upsell-page/views/upsellView.html',
		controller: 'UpsellCtrl',
		title: 'upsell',
		params: {
			jsonCharacs: {
				squash: true,
				value: null
			},
			fromPricing: {
				squash: true,
				value: null
			},
		},
		resolve: {
			load: function(Utilities, $rootScope) {
				$rootScope.showSpinner();
				return Utilities.cacheBustAndLazyLoad([
					'/scripts/modules/upsell/modules/upsell-page/controllers/upsell-page-controller.js'
				]);
			},
			initialData: function(load, Bootstrap) {
				return Bootstrap.bootstrapApplication();
			}
		},
		onEnter: onEnter
	})
	.state('upgradeRecommenderWizard', {
		url: '/upgrade/:recommenderWizardKeyword/:packageId',
		templateUrl: '/scripts/modules/upsell/modules/upsell-page/views/upsellView.html',
		controller: 'UpsellCtrl',
		title: 'upsell',
		resolve: {
			load: function(Utilities, $rootScope) {
				$rootScope.showSpinner();
				return Utilities.cacheBustAndLazyLoad([
					'/scripts/modules/upsell/modules/upsell-page/controllers/upsell-page-controller.js'
				]);
			},
			initialData: function(load, Bootstrap) {
				return Bootstrap.bootstrapApplication();
			},
			recommenderWizard: function(initialData, RecommenderWizardContextService, $transition$) {
				return RecommenderWizardContextService.assessUpsellRouteAndRegisterUpsells($transition$.params());
			}
		},
		onEnter: onEnter
	});

	/**
	 * A generic onEnter hook for the upsell module
	 * @param {Service} $rootScope $rootScope Service
	 * @param {Service} $transition$ The transition service instance
	 * @param {Object} Enums Enums Object
	 * @returns {undefined}
	 * @ngInject
	 */
	function onEnter($rootScope, $transition$, Enums, CustomActionService) {
		// If the user comes from anywhere other than package details (e.g.
		// user hit the back button on SP demo after choosing to upsell),
		// attempt to route the user back to the package details.
		// Otherwise route back to the package list.
		// State information is lost when user hits the back button.
		// The alternative is to reset all the details to prep this
		// module for upselling - may want to consider that instead.
		var fp = $transition$.params('from'),
			fromName = $transition$.from().name,
			er = Enums.routes,
			shouldAbort;

		if (CustomActionService.executeCustomAction('byPassUpsellStateChangeSuccess')) {
			return;
		}

		shouldAbort = !['package-planner', 'snap-calendar', 'buy-now', 'unified-package-details', er.DETAILS].some(function(page) {
			return fromName.indexOf(page) > -1;
		});

		if (shouldAbort) {
			$transition$.abort();
			$rootScope.routeTo(fp.packageId ? er.DETAILS + '/' + fp.packageId : er.LIST, undefined, undefined, undefined, true)
		}
	}
});
/**
 * Created by jwroblewski on 2/3/2016.
 */
angular
	.module('upsell-wizard', ['app', 'upsell'])
	.config(function($locationProvider, $stateProvider) {
		$stateProvider
			.state('upsellWizard', {
				abstract: true,
				url: '/upsellWizard/:packageId',
				controller: 'UpsellWizardController',
				templateUrl: '/scripts/modules/upsell/modules/upsell-wizard/views/upsell-wizard.html',
				title: 'upsell',
				resolve: {
					load: function(Utilities, $rootScope) {
						$rootScope.showSpinner();
						return Utilities.cacheBustAndLazyLoad([
							'/scripts/modules/upsell/modules/upsell-wizard/controllers/upsell-wizard-quantity-controller.js',
							'/scripts/modules/upsell/modules/upsell-wizard/controllers/upsell-wizard-selection-controller.js',
							'/scripts/modules/upsell/modules/upsell-wizard/controllers/upsell-wizard-controller.js'
						]);
					},
					initialData: function(load, Bootstrap) {
						return Bootstrap.bootstrapApplication();
					},
					upsellWizardCurrentRoutes: function(initialData) {
						return { quantity: 'upsellWizard.quantity' };
					}
				},
				onEnter: onEnter
			})
			.state('upsellWizard.selection', {
				url: '',
				templateUrl: '/scripts/modules/upsell/modules/upsell-wizard/views/upsell-wizard-selection.html',
				controller: 'UpsellWizardSelectionController'
			})
			.state('upsellWizard.quantity', {
				url: '/quantity',
				templateUrl: '/scripts/modules/upsell/modules/upsell-wizard/views/upsell-wizard-quantity.html',
				controller: 'UpsellWizardQuantityController'
			})

			.state('upsellRecommenderWizard', {
				abstract: true,
				url: '/upsellWizard/:recommenderWizardKeyword/:packageId',
				controller: 'UpsellWizardController',
				templateUrl: '/scripts/modules/upsell/modules/upsell-wizard/views/upsell-wizard.html',
				title: 'upsell',
				resolve: {
					load: function(Utilities, $rootScope) {
						$rootScope.showSpinner();
						return Utilities.cacheBustAndLazyLoad([
							'/scripts/modules/upsell/modules/upsell-wizard/controllers/upsell-wizard-quantity-controller.js',
							'/scripts/modules/upsell/modules/upsell-wizard/controllers/upsell-wizard-selection-controller.js',
							'/scripts/modules/upsell/modules/upsell-wizard/controllers/upsell-wizard-controller.js'
						]);
					},
					initialData: function(load, Bootstrap) {
						return Bootstrap.bootstrapApplication();
					},
					upsellWizardCurrentRoutes: function(initialData) {
						return { quantity: 'upsellRecommenderWizard.quantity' };
					},
					recommenderWizard: function(upsellWizardCurrentRoutes, $transition$, RecommenderWizardContextService) {
						var stateParams = $transition$.params();
						if (angular.isDefined(stateParams.recommenderWizardKeyword) &&
							angular.isDefined(stateParams.packageId)) {
							if (RecommenderWizardContextService.bootstrapWizard(stateParams.recommenderWizardKeyword, 'wizardPackageDetails')) {
								RecommenderWizardContextService.registerUpsells();
							}
						}
					}
				},
				onEnter: onEnter
			})
			.state('upsellRecommenderWizard.selection', {
				url: '',
				templateUrl: '/scripts/modules/upsell/modules/upsell-wizard/views/upsell-wizard-selection.html',
				controller: 'UpsellWizardSelectionController'
			})
			.state('upsellRecommenderWizard.quantity', {
				url: '/quantity',
				templateUrl: '/scripts/modules/upsell/modules/upsell-wizard/views/upsell-wizard-quantity.html',
				controller: 'UpsellWizardQuantityController'
			})
			/**
			 * The following routes are made for alternate modules who want to use the upsell flow
			 * but are not the recommender wizard or coming directly from package details, such as PackagePlanner
			 */
			.state('upsellWizardAlt', {
				abstract: true,
				url: '/upsellWizardAlt/:packageId/:jsonCharacs/:fromPricing',
				controller: 'UpsellWizardController',
				templateUrl: '/scripts/modules/upsell/modules/upsell-wizard/views/upsell-wizard.html',
				title: 'upsell',
				params: {
					jsonCharacs: {
						squash: true,
						value: null
					},
					fromPricing: {
						squash: true,
						value: null
					}
				},
				resolve: {
					load: function(Utilities, $rootScope) {
						$rootScope.showSpinner();
						return Utilities.cacheBustAndLazyLoad([
							'/scripts/modules/upsell/modules/upsell-wizard/controllers/upsell-wizard-quantity-controller.js',
							'/scripts/modules/upsell/modules/upsell-wizard/controllers/upsell-wizard-selection-controller.js',
							'/scripts/modules/upsell/modules/upsell-wizard/controllers/upsell-wizard-controller.js'
						]);
					},
					initialData: function(load, Bootstrap) {
						return Bootstrap.bootstrapApplication();
					},
					upsellWizardCurrentRoutes: function(initialData) {
						return { quantity: 'upsellWizardAlt.quantity' };
					}
				},
				onEnter: onEnter
			})
			.state('upsellWizardAlt.selection', {
				url: '',
				templateUrl: '/scripts/modules/upsell/modules/upsell-wizard/views/upsell-wizard-selection.html',
				controller: 'UpsellWizardSelectionController'
			})
			.state('upsellWizardAlt.quantity', {
				url: '/quantity',
				templateUrl: '/scripts/modules/upsell/modules/upsell-wizard/views/upsell-wizard-quantity.html',
				controller: 'UpsellWizardQuantityController'
			})

			/**
			 * A generic onEnter hook for the upsell wizard module
			 * @param {Service} $rootScope $rootScope Service
			 * @param {Service} $transition$ The transition service instance
			 * @param {Object} Enums Enums Object
			 * @param {Service} StandardFlowInitiatorService The StandardFlowInitiatorService
			 * @returns {undefined}
			 * @ngInject
			 */
		function onEnter($rootScope, $transition$, Enums, StandardFlowInitiatorService, CustomActionService) {
			// If the user comes from anywhere other than package details (e.g.
			// user hit the back button on SP demo after choosing to upsell),
			// attempt to route the user back to the package details.
			// Otherwise route back to the package list.
			// State information is lost when user hits the back button.
			// The alternative is to reset all the details to prep this
			// module for upselling - may want to consider that instead.
			var routes = Enums.routes,
				fromName = $transition$.from().name,
				acceptFrom = [
					routes.DETAILS,
					routes.UPSELL_WIZARD + '.selection',
					routes.ENTITLEMENT_WIZARD,
					'package-planner',
					'snap-calendar',
					'buy-now',
					'unified-package-details'
				],
				shouldAbort;

			if (CustomActionService.executeCustomAction('byPassUpsellStateChangeSuccess')) {
				return;
			}

			shouldAbort = acceptFrom.every(function(path) {
				return fromName.indexOf(path) === -1;
			});

			if (shouldAbort) {
				$transition$.abort();
				if ($transition$.params('from').packageId) {
					$rootScope.routeTo(StandardFlowInitiatorService.getStandardFlowEntryRoute());
				} else {
					$rootScope.routeTo(routes.LIST);
				}
			}
		}
	})
	.run(function(Enums, ExtraFlow) {
		ExtraFlow.registerXMC
		('UpsellWizardModule',
			{
				name: 'UpsellWizardModule',
				view: Enums.extraFlowRoutes.UPSELL_WIZARD,
				doEditMode: false,
				lockQuantity: false,
				writeSingleCharac: false,
				enabled: true,
				type: 'alternateFlowModule'
			}
		);
	});

(function() {
	'use strict';

	angular.module('post-purchase-actions', []);
})();
(function() {
	'use strict';

	angular
		.module('post-purchase-actions')
		.factory('PostPurchaseActionsService', PostPurchaseActionsService);

	/**
	 * Post Purchase Actions Service
	 * @constructor
	 * @param {Object} $rootScope $rootScope
	 * @param {Object} $q $q
	 * @returns {Service} PostPurchaseActionsService
	 */
	function PostPurchaseActionsService($rootScope, $q) {
		var service = {
			clearActions: clearActions,
			executeActions: executeActions,
			getActions: getActions,
			isActionRegistered: isActionRegistered,
			registerAction: registerAction
		};

		var postPurchaseActions = [];

		return service;

		/**
		 * Appends an action to the array of post purchase actions.
		 * @public
		 * @param  {Function} postPurchaseAction Function to be executed post-purchase
		 * @returns {undefined}
		 */
		function registerAction(postPurchaseAction) {
			if (angular.isFunction(postPurchaseAction) && !service.isActionRegistered(postPurchaseAction)) {
				postPurchaseActions.push(postPurchaseAction);
			}
		}

		/**
		 * Checks if passed in function is a registered post purchase action.
		 * @public
		 * @param  {Function} postPurchaseAction Post purchase action
		 * @returns {Boolean} isRegistered
		 */
		function isActionRegistered(postPurchaseAction) {
			return postPurchaseActions.indexOf(postPurchaseAction) !== -1;
		}

		/**
		 * Returns post purchase actions.
		 * @public
		 * @returns {Function[]} postPurchaseActions
		 */
		function getActions() {
			return postPurchaseActions.slice(0);
		}

		/**
		 * Clears all post purchase actions
		 * @returns {undefined}
		 */
		function clearActions() {
			postPurchaseActions.length = 0;
		}

		/**
		 * Executes post purchase actions and then returns once all have finished.
		 * @public
		 * @returns {Promise.<T>} Promise
		 */
		function executeActions() {
			var promiseChain = $q.resolve();

			$rootScope.showSpinner();

			postPurchaseActions.reduce(function(promiseChain, currentTask) {
				return promiseChain.then(currentTask);
			}, promiseChain);

			return promiseChain.finally($rootScope.hideSpinner);
		}
	}
})();
(function() {
	'use strict';

	angular
		.module('jwt', [])
})();
(function() {
	'use strict';

	angular
		.module('jwt')
		.factory('jwtService', jwtService);

	/**
	 * Json Web Token Encryption and Verification service.
	 * @public
	 * @constructor
	 * @param  {Object} $q $q Object
	 * @param  {Object} Utilities Utilities
	 * @returns {Object} jwtRequestService
	 */
	function jwtService($q, Utilities) {
		var service = {
			createJWT: createJWT,
			lazyLoadJWTLibrary: lazyLoadJWTLibrary,
			libraryLoaded: false
		};

		return service;

		/**
		 * Creates a Json Web Token using a payload and key.
		 * @public
		 * @param  {Object | String} payload Javascript Object or Json String
		 * @param  {String} key Encryption Key
		 * @returns {String} JWT
		 */
		function createJWT(payload, key) {
			var stringifiedPayload = '';
			var signatureKey = {};
			var jwtHeader = {
				alg: 'HS256',
				typ: 'JWT'
			};

			return $q(function(resolve, reject) {
				service
					.lazyLoadJWTLibrary()
					.then(function() {
						if (payload && key) {
							stringifiedPayload = angular.isString(payload) ? payload : JSON.stringify(payload);
							signatureKey = { utf8: key };

							// eslint-disable-next-line no-undef
							resolve(KJUR.jws.JWS.sign('HS256', jwtHeader, stringifiedPayload, signatureKey));
						} else {
							reject(new Error('A payload and key are required for jwt encryption.'));
						}
					})
			});
		}

		/**
		 * Lazy loads the JWT library called 'jsrsasign' or returns true if it's already been loaded.
		 * @returns {Promise.<T>} Promise
		 */
		function lazyLoadJWTLibrary() {
			return $q(function(resolve, reject) {
				if (service.libraryLoaded) {
					resolve()
				} else {
					Utilities
						.cacheBustAndLazyLoad([{
							ignoreCacheBust: true,
							path: 'https://cdnjs.cloudflare.com/ajax/libs/jsrsasign/8.0.6/jsrsasign-all-min.js',
							type: 'js'
						}])
						.then(function() {
							service.libraryLoaded = true;
							resolve();
						})
						.catch(reject);
				}
			});
		}
	}
})();
angular.module("json-validator-constants", [])

.constant("JsonValidatorConfig", {
	"ABTests": {
		"_internalName": "AB Tests",
		"$id": "1500_ABTests",
		"additionalItems": false,
		"description": "1500_abtests__d",
		"items": {
			"properties": {
				"descriptionA": {
					"description": "1500_abtests_desc_a__d",
					"type": "string"
				},
				"descriptionB": {
					"description": "1500_abtests_desc_b__d",
					"type": "string"
				},
				"enabled": {
					"description": "1500_abtests_enabled__d",
					"type": "boolean"
				},
				"name": {
					"description": "1500_abtests_name__d",
					"type": "string"
				},
				"weight": {
					"description": "1500_abtests_weight__d",
					"pattern": "^[0-9]",
					"type": "number"
				}
			},
			"type": "object"
		},
		"title": "1500_abtests__t",
		"type": "array"
	},
	"accesso_pay": {
		"_internalName": "accesso Pay",
		"$id": "1500_accessoPay",
		"description": "1500_accessopay__d",
		"properties": {
			"disableDonation": {
				"description": "1500_accessopay_dis_don__d",
				"enum": [
					false,
					true
				],
				"type": "boolean"
			},
			"disableInsurance": {
				"description": "1500_accessopay_dis_ins__d",
				"enum": [
					false,
					true
				],
				"type": "boolean"
			},
			"disableSaveCreditCard": {
				"description": "1500_accessopay_dis_scc__d",
				"enum": [
					true
				],
				"type": "boolean"
			},
			"enable": {
				"description": "1500_accessopay_enbl__d",
				"enum": [
					true
				],
				"type": "boolean"
			},
			"hideAccessoPayCartIcon": {
				"description": "1500_accessopay_hd_crt_icn__d",
				"type": "boolean"
			},
			"locale": {
				"description": "1500_accessopay_loc__d",
				"type": "string"
			},
			"merchantOverrideParam": {
				"description": "1500_accessopay_mer_over_p__d",
				"minLength": 1,
				"type": "string"
			},
			"redirectUrl": {
				"description": "1500_accessopay_red__d",
				"pattern": "^https://",
				"type": "string"
			},
			"sdk": {
				"description": "1500_accessopay_sdk__d",
				"type": "string"
			},
			"supportMultiplePayments": {
				"description": "1500_accessopay_sprtmulpay__d",
				"enum": [
					true
				],
				"type": "boolean"
			},
			"tescoPromoCode": {
				"description": "1500_accessopay_tscopc__d",
				"type": "string"
			}
		},
		"title": "1500_accessopay__t",
		"type": "object"
	},
	"additional_guest_names_optional": {
		"_internalName": "Additional Guest Names Optional",
		"$id": "1500_additional_guest_names_optional",
		"description": "1500_addgn__d",
		"title": "1500_addgn__t",
		"type": "boolean"
	},
	"addonSelection": {
		"_internalName": "Addon Configurator",
		"$id": "1500_addonSelection",
		"description": "1500_addon_sel__d",
		"properties": {
			"gridViews": {
				"additionalItems": false,
				"description": "1500_addon_sel_grid__d",
				"items": {
					"properties": {
						"bannerImage": {
							"description": "1500_addon_sel_banner_img__d",
							"type": "string"
						},
						"benefits": {
							"additionalItems": false,
							"description": "1500_addon_sel_benefits__d",
							"items": {
								"type": "string"
							},
							"type": "array"
						},
						"benefitTitle": {
							"description": "1500_addon_sel_benefits_title__d",
							"type": "string"
						},
						"keyword": {
							"description": "1500_addon_sel_keyword__d",
							"type": "string"
						}
					},
					"type": "object"
				},
				"type": "array"
			},
			"nonExclusiveKeywords": {
				"description": "1500_addon_sel_non_excl_keywords__d",
				"type": "string"
			}
		},
		"title": "1500_addon_sel__t",
		"type": "object"
	},
	"adyen": {
		"_internalName": "Adyen Configuration",
		"$id": "1500_adyen",
		"description": "1500_adyen__d",
		"properties": {
			"activatePaymentProvider": {
				"description": "1500_adyen_activate_provider__d",
				"type": "boolean"
			},
			"enable3DS": {
				"description": "1500_adyen_enable_3ds__d",
				"type": "boolean"
			},
			"redirectPHPUrl": {
				"description": "1500_adyen_redirect_php_url__d",
				"type": "string"
			}
		},
		"required": [
			"activatePaymentProvider"
		],
		"title": "1500_adyen__t",
		"type": "object"
	},
	"adyenOriginKey": {
		"_internalName": "Adyen Origin Key",
		"$id": "1500_adyenOriginKey",
		"description": "1500_adyen_o_key__d",
		"minLength": 1,
		"title": "1500_adyen_o_key__t",
		"type": "string"
	},
	"agreement": {
		"_internalName": "Cart Agreement",
		"_internalDescription": "Cart Agreement Content Message",
		"$id": "1500_agreement",
		"deprecated": true,
		"description": "1500_agree__d",
		"minLength": 1,
		"title": "1500_agree__t",
		"type": "string"
	},
	"agreement_form": {
		"_internalName": "Agreement Form Configs",
		"$id": "1500_agreement_form",
		"description": "1500_agree_form__d",
		"properties": {
			"dob_field_minimum_age": {
				"description": "1500_agree_form_dob_min_age__d",
				"type": "number"
			},
			"showAgreementsBeforeCart": {
				"description": "1500_agree_form_show_abc__d",
				"type": "boolean"
			},
			"showCustomAgreementsBeforeCart": {
				"description": "1500_agree_form_show_cabc__d",
				"type": "boolean"
			},
			"skipCopyingPassInfoToAgreements": {
				"description": "1500_agree_form_skip_cpy_inf_agr__d",
				"type": "boolean"
			},
			"skip_agreement_form": {
				"description": "1500_agree_form_skip_form__d",
				"type": "string"
			}
		},
		"title": "1500_agree_form__t",
		"type": "object"
	},
	"allow_international_delivery": {
		"_internalName": "Allow international delivery",
		"$id": "1500_allow_international_delivery",
		"description": "1500_allow_intd__d",
		"title": "1500_allow_intd__t",
		"type": "boolean"
	},
	"allowedOrderCharacs": {
		"_internalDescription": "Allowed Order Characs",
		"_internalName": "Allowed Order Characs",
		"$id": "1500_allowedOrderCharacs",
		"description": "1500_allooc__d",
		"items": {
			"type": "string"
		},
		"title": "1500_allooc__t",
		"type": "array"
	},
	"analytics_data_layer": {
		"_internalName": "Holds data layer push configurations",
		"$id": "1500_analytics_data_layer",
		"description": "1500_analytics_data_layer__d",
		"properties": {
			"push_annualized_pricing": {
				"_internalDescription": "Calculates the data layer 'price' attribute by taking the monthly price and multiplying it by the 'required_num_payment'",
				"_internalName": "Push Annualized Pricing",
				"description": "1500_push_annualized_pricing__d",
				"enum": [
					true
				],
				"title": "1500_push_annualized_pricing__t",
				"type": "boolean"
			},
			"industry": {
				"_internalDescription": "Holds the industry of each Merchant attraction.",
				"_internalName": "Industry",
				"title": "1500_industry",
				"type": "string"
			},
			"get_full_cart_summary": {
				"_internalDescription": "Boolean value to determine if the cart-services should send the entire cart summary to the data layer",
				"_internalName": "Get Full Cart Summary",
				"title": "1500_get_full_cart_summary",
				"type": "boolean",
				"description": "1500_get_full_cart_summary__d"
			},
			"sendCheckoutUrl": {
				"description": "1500_send_checkout_url__d",
				"type": "boolean",
				"_internalDescription": "Boolean value to determine if a checkout url should be sent to the datalayer - typically for 3rd party cart abandonment",
				"_internalName": "Send Checkout URL",
				"title": "1500_send_checkout_url"
			}
		},
		"title": "1500_analytics_data_layer__t",
		"type": "object"
	},
	"applePayCountryCode": {
		"_internalName": "Country Code for Apple Pay",
		"$id": "1500_applePayCountryCode",
		"description": "1500_apay_cc__d",
		"maxLength": 2,
		"minLength": 2,
		"title": "1500_apay_cc__t",
		"type": "string"
	},
	"barcode_scanner": {
		"_internalName": "Barcode Scanner configuration",
		"_internalDescription": "Barcode Scanner global settings",
		"$id": "1500_barcode_scanner",
		"additionalProperties": false,
		"description": "1500_barcs__d",
		"properties": {
			"disable": {
				"_internalName": "Disable Barcode Scanner",
				"_internalDescription": "Globally disable Barcode Scanner",
				"description": "1500_barcs_disa__d",
				"title": "1500_barcs_disa__t",
				"type": "boolean"
			},
			"use_device_selection_logic": {
				"_internalName": "Use Device Selection Logic",
				"_internalDescription": "Instead of relying on the browser to determine the selected camera, use code based logic",
				"description": "1500_barcs_usedsl__d",
				"title": "1500_barcs_usedsl__t",
				"type": "boolean"
			}
		},
		"title": "1500_barcs__t",
		"type": "object"
	},
	"billing_last_before_first_name": {
		"_internalName": "Display Billing Last Name Before First Name",
		"$id": "1500_billing_last_before_first_name",
		"description": "1500_billing_lb4f__d",
		"maximum": 1,
		"minimum": 1,
		"title": "1500_billing_lb4f__t",
		"type": "integer"
	},
	"routeToAccountPortal": {
		"_internalName": "Route to Account Portal",
		"_internalDescription": "When true, the user will be redirected to the account portal, in a new tab, instead of booking portal",
		"$id": "1500_routeToAccountPortal",
		"description": "1500_rtap__d",
		"title": "1500_rtap__t",
		"type": "boolean"
	},
	"booking_portal": {
		"_internalName": "Booking Portal Configuration",
		"$id": "1500_booking_portal",
		"description": "1500_b_prtl__d",
		"properties": {
			"booking_identifier_field": {
				"description": "1500_b_prtl_ident_field__d",
				"type": "string"
			},
			"capture_prompt_email_list": {
				"additionalItems": false,
				"description": "1500_b_prtl_capt_prmpt_email__d",
				"items": {
					"type": "string"
				},
				"type": "array"
			},
			"display_modifications_remaining": {
				"description": "1500_b_prtl_disp_mod_remaining__d",
				"type": "boolean"
			},
			"email_return_urls": {
				"description": "1500_b_prtl_e_r_urls__d",
				"properties": {
					"development": {
						"description": "1500_b_prtl_e_r_urls_dev__d",
						"type": "string"
					},
					"production": {
						"description": "1500_b_prtl_e_r_urls_prod__d",
						"type": "string"
					},
					"staging": {
						"description": "1500_b_prtl_e_r_urls_stg__d",
						"type": "string"
					}
				},
				"required": [
					"development",
					"production",
					"staging"
				],
				"title": "1500_b_prtl_e_r_urls__t",
				"type": "object"
			},
			"booking_portal_redirect_to_account_portal": {
				"description": "1500_b_prtl_redir_to_acc_prtl__d",
				"properties": {
					"development": {
						"description": "1500_b_prtl_redir_to_acc_prtl_dev__d",
						"type": "string"
					},
					"production": {
						"description": "1500_b_prtl_redir_to_acc_prtl_prod__d",
						"type": "string"
					},
					"staging": {
						"description": "1500_b_prtl_redir_to_acc_prtl_stg__d",
						"type": "string"
					},
					"test": {
						"description": "1500_b_prtl_redir_to_acc_prtl_test__d",
						"type": "string"
					}
				},
				"required": [
					"development",
					"production",
					"staging",
					"test"
				],
				"title": "1500_b_prtl_redir_to_acc_prtl__t",
				"type": "object"
			},
			"enableCancellation": {
				"_internalDescription": "Enables the Cancellation Reservation feature for Booking Portal",
				"_internalName": "Enable Cancellations",
				"description": "1500_b_prtl_enabc__d",
				"title": "1500_b_prtl_enabc__t",
				"type": "boolean"
			},
			"enableCompleteBookingsModal": {
				"description": "1500_b_prtl_enbl_complt_bk_modal__d",
				"type": "boolean"
			},
			"experience_options": {
				"description": "1500_b_prtl_xp_opt__d",
				"properties": {
					"enable_conflict_resolution": {
						"description": "1500_b_prtl_xp_opt_enbl_cnflt_res__d",
						"type": "boolean"
					},
					"vendor_time_buffers": {
						"additionalItems": false,
						"description": "1500_b_prtl_xp_opt_vend_t_b__d",
						"items": {
							"properties": {
								"buffer_minutes": {
									"description": "1500_b_prtl_xp_opt_vend_t_b_min__d",
									"type": "number"
								},
								"vendor_id_1": {
									"description": "1500_b_prtl_xp_opt_vend_t_b_id_1__d",
									"type": "string"
								},
								"vendor_id_2": {
									"description": "1500_b_prtl_xp_opt_vend_t_b_id_2__d",
									"type": "string"
								}
							},
							"required": [
								"buffer_minutes",
								"vendor_id_1",
								"vendor_id_2"
							],
							"type": "object"
						},
						"title": "1500_b_prtl_xp_opt_vend_t_b__t",
						"type": "array"
					}
				},
				"title": "1500_b_prtl_xp_opt__t",
				"type": "object"
			},
			"group_reservation_options": {
				"description": "1500_b_prtl_grp_res_opt__d",
				"properties": {
					"group_id_format": {
						"description": "1500_b_prtl_grp_res_opt_id_fmt__d",
						"pattern": "alpha|numeric",
						"type": "string"
					},
					"group_name_prefix": {
						"description": "1500_b_prtl_grp_res_opt_name_pfx__d",
						"type": "string"
					},
					"max_groups": {
						"description": "1500_b_prtl_grp_res_opt_max_grps__d",
						"type": "number"
					},
					"max_per_group": {
						"description": "1500_b_prtl_grp_res_opt_max_p_grp__d",
						"type": "number"
					}
				},
				"title": "1500_b_prtl_grp_res_opt__t",
				"type": "object"
			},
			"hide_lookup_order": {
				"_internalDescription": "Hides the Lookup Order link on the booking portal login page",
				"_internalName": "Hide Lookup Order",
				"desciption": "1500_b_prtl_hlo__d",
				"title": "1500_b_prtl_hlo__t",
				"type": "boolean"
			},
			"login_image_name": {
				"description": "1500_b_prtl_login_img_name__d",
				"type": "string"
			},
			"mode": {
				"description": "1500_b_prtl_mode__d",
				"pattern": "default|group_reservation",
				"type": "string"
			},
			"receipt_button": {
				"description": "1500_b_prtl_recpt_btn__d",
				"properties": {
					"background": {
						"description": "1500_b_prtl_recpt_btn_bg__d",
						"type": "string"
					},
					"enabled": {
						"description": "1500_b_prtl_recpt_btn_enbl__d",
						"type": "string"
					},
					"icon": {
						"description": "1500_b_prtl_recpt_btn_icon__d",
						"type": "string"
					},
					"text_color": {
						"description": "1500_b_prtl_recpt_btn_txt_clr__d",
						"type": "string"
					}
				},
				"title": "1500_b_prtl_recpt_btn__t",
				"type": "object"
			},
			"verification_fields": {
				"additionalItems": false,
				"description": "1500_b_prtl_ver_flds__d",
				"items": {
					"properties": {
						"name": {
							"description": "1500_b_prtl_ver_flds_name__d",
							"type": "string"
						},
						"validationPattern": {
							"description": "1500_b_prtl_ver_flds_val_ptrn__d",
							"type": "string"
						},
						"validationType": {
							"description": "1500_b_prtl_ver_flds_val_type__d",
							"type": "string"
						},
						"width": {
							"description": "1500_b_prtl_ver_flds_width__d",
							"type": "number"
						}
					},
					"type": "object"
				},
				"title": "1500_b_prtl_ver_flds__t",
				"type": "array"
			}
		},
		"required": [
			"verification_fields"
		],
		"title": "1500_b_prtl__t",
		"type": "object"
	},
	"cabana_settings_map": {
		"_internalName": "Cabana Settings Map",
		"$id": "1500_cabana_settings_map",
		"description": "1500_cabana_map__d",
		"properties": {
			"imageName": {
				"description": "1500_cabana_map_img_name__d",
				"type": "string"
			},
			"locations": {
				"additionalItems": false,
				"description": "1500_cabana_map_loc__d",
				"items": {
					"properties": {
						"diameter": {
							"description": "1500_cabana_map_loc_diameter__d",
							"type": "number"
						},
						"imageName": {
							"description": "1500_cabana_map_loc_img_name__d",
							"type": "string"
						},
						"name": {
							"description": "1500_cabana_map_loc_name__d",
							"type": "string"
						},
						"resources": {
							"additionalItems": false,
							"description": "1500_cabana_map_loc_res__d",
							"items": {
								"properties": {
									"h": {
										"description": "1500_cabana_map_loc_res_h__d",
										"type": "number"
									},
									"id": {
										"description": "1500_cabana_map_loc_res_id__d",
										"type": "string"
									},
									"lblPos": {
										"description": "1500_cabana_map_loc_res_lbl_pos__d",
										"type": "string"
									},
									"showLabel": {
										"description": "1500_cabana_map_loc_res_show_lbl__d",
										"type": "boolean"
									},
									"w": {
										"description": "1500_cabana_map_loc_res_w__d",
										"type": "number"
									},
									"x": {
										"description": "1500_cabana_map_loc_res_x__d",
										"type": "number"
									},
									"y": {
										"description": "1500_cabana_map_loc_res_y__d",
										"type": "number"
									}
								},
								"required": [
									"h",
									"id",
									"w",
									"x",
									"y"
								],
								"type": "object"
							},
							"title": "1500_cabana_map_loc_res__t",
							"type": "array"
						},
						"x": {
							"description": "1500_cabana_map_loc_x__d",
							"type": "number"
						},
						"y": {
							"description": "1500_cabana_map_loc_y__d",
							"type": "number"
						}
					},
					"required": [
						"diameter",
						"imageName",
						"name",
						"x",
						"y"
					],
					"type": "object"
				},
				"title": "1500_cabana_map_loc__t",
				"type": "array"
			},
			"name": {
				"description": "1500_cabana_map_name__d",
				"type": "string"
			}
		},
		"title": "1500_cabana_map__t",
		"type": "object"
	},
	"calendar_anydaykeywords": {
		"_internalName": "Any Day Keywords for Savings Calender and Calendar Pricing",
		"$id": "1500_calendar_anydaykeywords",
		"additionalItems": false,
		"description": "1500_cal_neday_key__d",
		"items": {
			"properties": {
				"anyday_keyword": {
					"description": "1500_cal_neday_key_neday_key__d",
					"type": "string"
				},
				"calendar_keyword": {
					"description": "1500_cal_neday_key_cal_key__d",
					"type": "string"
				}
			},
			"required": [
				"anyday_keyword",
				"calendar_keyword"
			],
			"type": "object"
		},
		"title": "1500_cal_neday_key__t",
		"type": "array"
	},
	"calendar_availability_max_months": {
		"_internalName": "Calendar Availability Max Months",
		"_internalDescription": "Max amount of months to request for calendar availability",
		"$id": "1500_cal_avail_max_mo",
		"description": "1500_calmo__d",
		"maximum": 12,
		"minimum": 0,
		"title": "1500_calmo__t",
		"type": "integer"
	},
	"camps_enrollment": {
		"_internalName": "Camps Enrollment Flow",
		"$id": "1500_camps_enrollment",
		"description": "1500_cmps_nroll__d",
		"properties": {
			"camps_addon_charac_map": {
				"additionalProperties": {
					"type": "string"
				},
				"description": "1500_cmps_nroll_addon_charac_map__d",
				"title": "1500_cmps_nroll_addon_charac_map__t",
				"type": "object"
			},
			"camps_addon_mapping_characs": {
				"additionalItems": false,
				"description": "1500_cmps_nroll_addon_characs__d",
				"items": {
					"description": "1500_cmps_nroll_addon_characs_t_name__d",
					"type": "string"
				},
				"title": "1500_cmps_nroll_addon_characs__t",
				"type": "array"
			},
			"check_for_expired_membership_dates": {
				"description": "1500_cmps_nroll_chk_exp_mem_dates__d",
				"type": "boolean"
			},
			"disabled_participant_demographics_fields": {
				"additionalItems": false,
				"description": "1500_cmps_nroll_dsbl_part_demo__d",
				"items": {
					"description": "1500_cmps_nroll_dsbl_part_demo_i__d",
					"type": "string"
				},
				"title": "1500_cmps_nroll_dsbl_part_demo__t",
				"type": "array"
			},
			"enable_waitlist": {
				"description": "1500_cmps_nroll_enbl_wait__d",
				"type": "boolean"
			},
			"membership_route_keyword": {
				"description": "1500_cmps_nroll_mem_rt_key__d",
				"type": "string"
			},
			"min_threshold_to_display_waitlist": {
				"description": "1500_cmps_nroll_min_thrsh_disp_wait__d",
				"type": "number"
			},
			"participant_info_collection_configured_sections": {
				"description": "1500_cmps_nroll_part__d",
				"properties": {
					"addl_waivers_sections": {
						"additionalItems": false,
						"description": "1500_cmps_nroll_part_addl_w__d",
						"items": {
							"properties": {
								"is_required_to_optin": {
									"description": "1500_cmps_nroll_part_addl_w_req_optin__d",
									"type": "boolean"
								},
								"waiver_name": {
									"description": "1500_cmps_nroll_part_addl_w_name__d",
									"type": "string"
								},
								"waiver_reference_flag": {
									"description": "1500_cmps_nroll_part_addl_w_ref_flag__d",
									"type": "string"
								},
								"waiver_type": {
									"description": "1500_cmps_nroll_part_addl_w_type__d",
									"pattern": "boolean|acknowledgement",
									"type": "string"
								}
							},
							"required": [
								"is_required_to_optin",
								"waiver_name",
								"waiver_reference_flag",
								"waiver_type"
							],
							"type": "object"
						},
						"title": "1500_cmps_nroll_part__t",
						"type": "array"
					},
					"info_sections": {
						"additionalItems": false,
						"description": "1500_cmps_nroll_part_info__d",
						"items": {
							"properties": {
								"num_of_items_to_collect": {
									"description": "1500_cmps_nroll_part_info_num_itms__d",
									"type": "number"
								},
								"optional_fields": {
									"description": "1500_cmps_nroll_part_info_opt_flds__d",
									"type": "array"
								},
								"section_name": {
									"description": "1500_cmps_nroll_part_info_sec_name__d",
									"pattern": "emergency_contacts|authorized_pickups|friend_requests",
									"type": "string"
								}
							},
							"type": "object"
						},
						"title": "1500_cmps_nroll_part_info__t",
						"type": "array"
					},
					"medical_section": {
						"description": "1500_cmps_nroll_part_med__d",
						"properties": {
							"display_insurance_info": {
								"description": "1500_cmps_nroll_part_med_disp_insc__d",
								"type": "boolean"
							},
							"treatments": {
								"additionalItems": false,
								"description": "1500_cmps_nroll_part_med_treat__d",
								"items": {
									"type": "string"
								},
								"type": "array",
								"uniqueItems": true
							}
						},
						"title": "1500_cmps_nroll_part_med__t",
						"type": "object"
					}
				},
				"title": "1500_cmps_nroll_part__t",
				"type": "object"
			},
			"participant_info_collection_views": {
				"additionalItems": false,
				"description": "1500_cmps_nroll_part_coll__d",
				"items": {
					"description": "1500_cmps_nroll_part_coll_i__d",
					"type": "string"
				},
				"title": "1500_cmps_nroll_part_coll__t",
				"type": "array"
			}
		},
		"title": "1500_cmps_nroll__t",
		"type": "object"
	},
	"cart_abandonment": {
		"$id": "1500_cart_abandonment",
		"type": "boolean"
	},
	"cartOptinFieldLabel": {
		"$id": "1500_cartOptinFieldLabel",
		"deprecated": true,
		"type": "object"
	},
	"customTermsFieldLabel": {
		"$id": "1500_customTermsFieldLabel",
		"deprecated": true,
		"properties": {
			"section": {
				"minLength": 1,
				"type": "string"
			},
			"target": {
				"minLength": 1,
				"type": "string"
			}
		},
		"required": [
			"section",
			"target"
		],
		"type": "object"
	},
	"cartOptins": {
		"_internalName": "Cart Optins",
		"$id": "1500_cart_optins",
		"additionaProperties": false,
		"deprecated": true,
		"description": "1500_co__d",
		"properties": {
			"enable": {
				"title": "1500_co_e__t",
				"description": "1500_co_e__d",
				"type": "boolean"
			},
			"truncateLimit": {
				"description": "1500_co_tL__d",
				"type": "number"
			},
			"enable_mandatory_optin_selection": {
				"title": "1500_co_emos__t",
				"description": "1500_co_emo__d",
				"type": "boolean",
				"default": false
			},
			"mandatory_optins": {
				"title": "1500_co_mo__t",
				"description": "1500_co_mo__d",
				"type": "object",
				"properties": {
					"optin": {
						"type": "object",
						"properties": {
							"heading": {
								"type": "string",
								"default": "optinSubHeading"
							},
							"section": {
								"type": "string",
								"default": "CartView"
							},
							"target": {
								"type": "string",
								"default": "mandatoryOptinYes"
							},
							"checked": {
								"type": "boolean",
								"default": false
							}
						},
						"required": [
							"section",
							"target"
						]
					},
					"optout": {
						"type": "object",
						"properties": {
							"heading": {
								"type": "string",
								"default": "optoutSubHeading"
							},
							"section": {
								"type": "string",
								"default": "CartView"
							},
							"target": {
								"type": "string",
								"default": "mandatoryOptinNo"
							},
							"checked": {
								"type": "boolean",
								"default": false
							}
						},
						"required": [
							"section",
							"target"
						]
					}
				},
				"required": [
					"optin",
					"optout"
				]
			}
		},
		"required": [
			"enable"
		],
		"title": "1500_co__t",
		"type": "object"
	},
	"cartView": {
		"_internalName": "Cart View Options",
		"_internalDescription": "Options for the cart view",
		"$id": "1500_cart_view",
		"definitions": {
			"mandatory_optin": {
				"properties": {
					"checked": {
						"_internalName": "Mandatory Opt-in Checked",
						"_internalDescription": "Checked for mandatory opt-in",
						"default": false,
						"description": "1500_cartv_opti_mand_opti_chec__d",
						"title": "1500_cartv_opti_mand_opti_chec__t",
						"type": "boolean"
					},
					"heading": {
						"_internalName": "Mandatory Opt-in Heading",
						"_internalDescription": "Heading for mandatory opt-in",
						"default": "optinSubHeading",
						"description": "1500_cartv_opti_mand_opti_head__d",
						"minLength": 1,
						"title": "1500_cartv_opti_mand_opti_head__t",
						"type": "string"
					},
					"section": {
						"_internalName": "Mandatory Opt-in Label Section",
						"_internalDescription": "Section for mandatory opt-in",
						"default": "CartView",
						"description": "1500_cartv_opti_mand_opti_sect__d",
						"minLength": 1,
						"title": "1500_cartv_opti_mand_opti_sect__t",
						"type": "string"
					},
					"target": {
						"_internalName": "Mandatory Opt-in Label Target",
						"_internalDescription": "Target for mandatory opt-in",
						"description": "1500_cartv_opti_mand_opti_targ__d",
						"minLength": 1,
						"title": "1500_cartv_opti_mand_opti_targ__t",
						"type": "string"
					}
				},
				"required": [
					"section",
					"target"
				],
				"type": "object"
			},
			"standard_optin": {
				"properties": {
					"checked": {
						"_internalName": "Standard Opt-in Checked",
						"_internalDescription": "Checked for standard opt-in",
						"default": false,
						"description": "1500_cartv_opti_std_opti_chec__d",
						"title": "1500_cartv_opti_std_opti_chec__t",
						"type": "boolean"
					},
					"section": {
						"_internalName": "Standard Opt-in Label Section",
						"_internalDescription": "Section for standard opt-in",
						"default": "CartView",
						"description": "1500_cartv_opti_std_opti_sect__d",
						"minLength": 1,
						"title": "1500_cartv_opti_std_opti_sect__t",
						"type": "string"
					},
					"target": {
						"_internalName": "Standard Opt-in Label Target",
						"_internalDescription": "Target for standard opt-in",
						"description": "1500_cartv_opti_std_opti_targ__d",
						"minLength": 1,
						"title": "1500_cartv_opti_std_opti_targ__t",
						"type": "string"
					}
				},
				"required": [
					"section",
					"target"
				],
				"type": "object"
			}
		},
		"description": "1500_cartv__d",
		"properties": {
			"advertisement": {
				"_internalName": "Cart Advertisement",
				"_internalDescription": "Cart advertisement image asset",
				"description": "1500_cartv_ad__d",
				"title": "1500_cartv_ad__t",
				"type": "string"
			},
			"cart_timer": {
				"_internalName": "Cart Timer",
				"_internalDescription": "Configuration for the cart timer",
				"description": "1500_cartv_timer__d",
				"properties": {
					"show_timer": {
						"_internalName": "Enable Cart Timer",
						"_internalDescription": "Enable the cart timer",
						"description": "1500_cartv_timer_enbl__d",
						"title": "1500_cartv_timer_enbl__t",
						"type": "boolean"
					},
					"timer_minutes": {
						"_internalName": "Cart Timer Duration Minutes",
						"_internalDescription": "Duration in minutes for the cart timer",
						"description": "1500_cartv_timer_dur_min__d",
						"minimum": 1,
						"title": "1500_cartv_timer_dur_min__t",
						"type": "integer"
					}
				},
				"title": "1500_cartv_timer__t",
				"type": "object"
			},
			"cross_sell": {
				"_internalName": "Cart Cross Sells",
				"_internalDescription": "Coniguration for the cart cross sells",
				"desciption": "1500_cartv_cs__d",
				"properties": {
					"hide": {
						"_internalName": "Hide Cross Sells",
						"_internalDescription": "Hide the cross sells section for the cart view",
						"description": "1500_cartv_cs_hide__d",
						"type": "boolean"
					},
					"hide_query_params": {
						"_internalName": "Hide Cross Sells by Query Param",
						"_internalDescription": "Hides the cross sell when a specified query param is present",
						"description": "1500_cartv_cs_hideqp__d",
						"items": {
							"_internalName": "Query Param",
							"_internalDescription": "The query param to hide the cross sell on",
							"description": "1500_cartv_cs_hideqp_qp__d",
							"title": "1500_cartv_cs_hideqp_qp__t",
							"type": "string"
						},
						"title": "1500_cartv_cs_hideqp__t",
						"type": "array"
					}
				},
				"title": "1500_cartv_cs__t",
				"type": "object"
			},
			"discounts": {
				"_internalName": "Cart Discounts",
				"_internalDescription": "Configuration for cart discounts",
				"description": "1500_cartv_disc__d",
				"properties": {
					"enable": {
						"_internalName": "Enable Discount Code Entry",
						"_internalDescription": "Enables the discount code entry field in the cart",
						"description": "1500_cartv_disc_enbl__d",
						"title": "1500_cartv_disc_enbl__t",
						"type": "boolean"
					}
				},
				"title": "1500_cartv_disc__t",
				"type": "object"
			},
			"items": {
				"_internalName": "Cart Items",
				"_internalDescription": "Configuration for cart items",
				"description": "1500_cartv_items__d",
				"properties": {
					"date_format": {
						"_internalName": "Cart Item Date Format",
						"_internalDescription": "Date format for cart items",
						"description": "1500_cartv_items_date_fmt__d",
						"minLength": 1,
						"title": "1500_cartv_items_date_fmt__t",
						"type": "string"
					}
				},
				"title": "1500_cartv_items__t",
				"type": "object"
			},
			"opt_ins": {
				"_internalName": "Cart Opt-ins",
				"_internalDescription": "Configuration for cart opt-ins",
				"description": "1500_cartv_opti__d",
				"properties": {
					"enable": {
						"_internalName": "Enable Cart Opt-ins",
						"_internalDescription": "Enable cart opt-ins",
						"description": "1500_cartv_opti_enbl__d",
						"title": "1500_cartv_opti_enbl__t",
						"type": "boolean"
					},
					"guest_profiles_opt_in_mappings": {
						"_internalName": "Guest Profile Opt-in Mappings",
						"_internalDescription": "Maps each displayed cart opt-in slot to its accesso Passport (GPS) guest profile opt-in name. Slots not listed here are never read from or written to GPS.",
						"description": "1500_cartv_opti_gpsm__d",
						"properties": {
							"optin": {
								"_internalName": "GPS Opt-in Name (1st slot)",
								"_internalDescription": "GPS opt-in name for the first standard opt-in, or the single mandatory opt-in",
								"description": "1500_cartv_opti_gpsm_o__d",
								"minLength": 1,
								"title": "1500_cartv_opti_gpsm_o__t",
								"type": "string"
							},
							"optin1": {
								"_internalName": "GPS Opt-in Name (2nd slot)",
								"_internalDescription": "GPS opt-in name for the second standard opt-in",
								"description": "1500_cartv_opti_gpsm_o1__d",
								"minLength": 1,
								"title": "1500_cartv_opti_gpsm_o1__t",
								"type": "string"
							},
							"optin2": {
								"_internalName": "GPS Opt-in Name (3rd slot)",
								"_internalDescription": "GPS opt-in name for the third standard opt-in",
								"description": "1500_cartv_opti_gpsm_o2__d",
								"minLength": 1,
								"title": "1500_cartv_opti_gpsm_o2__t",
								"type": "string"
							}
						},
						"title": "1500_cartv_opti_gpsm__t",
						"type": "object"
					},
					"mandatory_optins": {
						"_internalName": "Mandatory Opt-ins",
						"_internalDescription": "Configuration for mandatory opt-ins",
						"description": "1500_cartv_opti_mand__d",
						"properties": {
							"enabled": {
								"_internalName": "Enable Mandatory Opt-ins",
								"_internalDescription": "Enable mandatory opt-ins",
								"default": false,
								"description": "1500_cartv_opti_mand_enbl__d",
								"title": "1500_cartv_opti_mand_enbl__t",
								"type": "boolean"
							},
							"opt_in": {
								"_internalName": "Mandatory Opt-in",
								"_internalDescription": "Configuration for mandatory opting in value",
								"$ref": "#/definitions/mandatory_optin",
								"description": "1500_cartv_opti_mand_opti__d",
								"properties": {
									"target": {
										"default": "mandatoryOptinYes"
									}
								},
								"title": "1500_cartv_opti_mand_opti__t"
							},
							"opt_out": {
								"_internalName": "Mandatory Opt-out",
								"_internalDescription": "Configuration for mandatory opting out value",
								"$ref": "#/definitions/mandatory_optin",
								"description": "1500_cartv_opti_mand_opto__d",
								"properties": {
									"target": {
										"default": "mandatoryOptinNo"
									}
								},
								"title": "1500_cartv_opti_mand_opto__t"
							}
						},
						"required": [
							"enabled",
							"opt_in",
							"opt_out"
						],
						"title": "1500_cartv_opti_mand__t",
						"type": "object"
					},
					"optins_label": {
						"_internalName": "Optins Label",
						"_internalDescription": "Locale override for cart optins",
						"description": "1500_cartv_opti_optil__d",
						"properties": {
							"section": {
								"_internalName": "Optins Section Label Section",
								"_internalDescription": "Locale Section for Optins container label",
								"default": "CartView",
								"description": "1500_cartv_opti_optil_sect__d",
								"minLength": 1,
								"title": "1500_cartv_opti_optil_sect__t",
								"type": "string"
							},
							"target": {
								"_internalName": "Optins Section Label Target",
								"_internalDescription": "Locale Target for Optins container label",
								"default": "OptinLabel",
								"description": "1500_cartv_opti_optil_targ__d",
								"minLength": 1,
								"title": "1500_cartv_opti_optil_targ__t",
								"type": "string"
							}
						}
					},
					"standard_optins": {
						"_internalName": "Standard Opt-ins",
						"_internalDescription": "Configuration for standard opt-ins",
						"description": "1500_cartv_opti_std__d",
						"items": {
							"$ref": "#/definitions/standard_optin"
						},
						"title": "1500_cartv_opti_std__t",
						"type": "array"
					},
					"truncate_limit": {
						"_internalName": "Cart Opt-ins Label Truncate Limit",
						"_internalDescription": "Truncate limit for cart opt-ins label",
						"default": 150,
						"description": "1500_cartv_opti_trunl__d",
						"minimum": 1,
						"title": "1500_cartv_opti_trunl__t",
						"type": "number"
					}
				},
				"title": "1500_cartv_opti__t",
				"type": "object"
			},
			"recurring_billing": {
				"_internalName": "Cart Recurring Billing",
				"_internalDescription": "Configuration for cart recurring billing",
				"description": "1500_cartv_rec_bil__d",
				"properties": {
					"memberships": {
						"_internalName": "Recurring Billing Memberships",
						"_internalDescription": "Configuration for recurring billing memberships",
						"description": "1500_cartv_rec_bil_mem__d",
						"properties": {
							"cumulative_total_includes_comps": {
								"_internalName": "Cumulative Total Includes Comps",
								"_internalDescription": "Cumulative total includes comps for recurring billing",
								"description": "1500_cartv_rec_bil_mem_cum__d",
								"title": "1500_cartv_rec_bil_mem_cum__t",
								"type": "boolean"
							},
							"show_cumulative_total": {
								"_internalName": "Show Cumulative Total",
								"_internalDescription": "Show cumulative total for recurring billing memberships",
								"description": "1500_cartv_rec_bil_mem_show_cum__d",
								"title": "1500_cartv_rec_bil_mem_show_cum__t",
								"type": "boolean"
							}
						},
						"title": "1500_cartv_rec_bil_mem__t",
						"type": "object"
					}
				},
				"title": "1500_cartv_rec_bil__t",
				"type": "object"
			},
			"sanitization": {
				"_internalName": "Cart Sanitization",
				"_internalDescription": "Configuration for cart sanitization",
				"description": "1500_cartv_sani__d",
				"properties": {
					"disable": {
						"_internalName": "Disable Cart Sanitization",
						"_internalDescription": "Disable cart sanitization",
						"description": "1500_cartv_sani_disa__d",
						"title": "1500_cartv_sani_disa__t",
						"type": "boolean"
					}
				},
				"title": "1500_cartv_sani__t",
				"type": "object"
			},
			"taxes_and_fees": {
				"_internalName": "Cart Terms and Conditions",
				"_internalDescription": "Configuration for the cart terms and conditions",
				"description": "1500_cartv_taf__d",
				"properties": {
					"condense": {
						"_internalName": "Condense Taxes and Fees",
						"_internalDescription": "Use an accordion to condense the taxes and fees section",
						"description": "1500_cartv_taf_cond__d",
						"title": "1500_cartv_taf_cond__t",
						"type": "boolean"
					},
					"denote_tax": {
						"_internalName": "Denote Taxes",
						"_internalDescription": "Add Denotion to taxes in the taxes and fees section",
						"desciption": "1500_cartv_taf_denot__d",
						"title": "1500_cartv_taf_denot__t",
						"type": "boolean"
					}
				},
				"title": "1500_cartv_taf__t",
				"type": "object"
			},
			"terms": {
				"_internalName": "Cart Terms and Conditions",
				"_internalDescription": "Configuration for the cart terms and conditions",
				"desciption": "1500_cartv_term__d",
				"properties": {
					"agreement": {
						"_internalName": "Agreement content",
						"_internalDescription": "The agreement content for the terms and conditions",
						"description": "1500_cartv_term_agre__d",
						"title": "1500_cartv_term_agre__t",
						"type": "string"
					},
					"display_agreement": {
						"_internalName": "Display Agreement",
						"_internalDescription": "Display Terms And Conditions on Cart View as agreement",
						"desciption": "1500_cartv_term_disp_agr__d",
						"title": "1500_cartv_term_disp_agr__t",
						"type": "boolean"
					},
					"terms_label": {
						"_internalName": "Terms and Condition Label",
						"_internalDescription": "Locale override for cart terms and condition",
						"description": "1500_cartv_term_terml__d",
						"properties": {
							"section": {
								"_internalName": "Terms Section Label Section",
								"_internalDescription": "Locale Section for Terms container label",
								"default": "CartView",
								"description": "1500_cartv_term_terml_sect__d",
								"minLength": 1,
								"title": "1500_cartv_term_terml_sect__t",
								"type": "string"
							},
							"target": {
								"_internalName": "Terms Section Label Target",
								"_internalDescription": "Locale Target for Terms container label",
								"default": "termsAndConditionsLabel",
								"description": "1500_cartv_term_terml_targ__d",
								"minLength": 1,
								"title": "1500_cartv_term_terml_targ__t",
								"type": "string"
							}
						},
						"required": [
							"section",
							"target"
						],
						"title": "1500_cartv_term_terml__t",
						"type": "object"
					}
				},
				"title": "1500_cartv_term__t",
				"type": "object"
			}
		},
		"title": "1500_cv__t",
		"type": "object"
	},
	"countriesjson_override": {
		"_internalName": "Countries JSON Override",
		"$id": "1500_countriesjson_override",
		"additionalItems": false,
		"description": "1500_cntry_json_override__d",
		"items": {
			"properties": {
				"code": {
					"description": "1500_cntry_json_override_code__d",
					"type": "string"
				},
				"countryCode": {
					"description": "1500_cntry_json_override_cntry_code__d",
					"type": "string"
				},
				"name": {
					"description": "1500_cntry_json_override_name__d",
					"type": "string"
				}
			},
			"required": [
				"code",
				"name"
			],
			"type": "object"
		},
		"title": "1500_cntry_json_override__t",
		"type": "array"
	},
	"coupons": {
		"_internalName": "Ad Configuration",
		"$id": "1500_coupons",
		"description": "1500_cpons__d",
		"properties": {
			"adUnit1": {
				"description": "1500_cpons_a_1__d",
				"properties": {
					"image": {
						"description": "1500_cpons_a_1_img__d",
						"format": "url",
						"type": "string"
					},
					"position": {
						"description": "1500_cpons_a_1_pos__d",
						"enum": [
							"bottom",
							"middle",
							"top"
						],
						"type": "string"
					},
					"url": {
						"description": "1500_cpons_a_1_url__d",
						"format": "url",
						"type": "string"
					}
				},
				"title": "1500_cpons_a_1__t",
				"type": "object"
			},
			"adUnit2": {
				"description": "1500_cpons_a_2__d",
				"properties": {
					"image": {
						"description": "1500_cpons_a_2_img__d",
						"format": "url",
						"type": "string"
					},
					"position": {
						"description": "1500_cpons_a_2_pos__d",
						"enum": [
							"bottom",
							"middle",
							"top"
						],
						"type": "string"
					},
					"url": {
						"description": "1500_cpons_a_2_url__d",
						"format": "url",
						"type": "string"
					}
				},
				"title": "1500_cpons_a_2__t",
				"type": "object"
			},
			"adUnit3": {
				"description": "1500_cpons_a_3__d",
				"properties": {
					"image": {
						"description": "1500_cpons_a_3_img__d",
						"format": "url",
						"type": "string"
					},
					"position": {
						"description": "1500_cpons_a_3_pos__d",
						"enum": [
							"bottom",
							"middle",
							"top"
						],
						"type": "string"
					},
					"url": {
						"description": "1500_cpons_a_3_url__d",
						"format": "url",
						"type": "string"
					}
				},
				"title": "1500_cpons_a_3__t",
				"type": "object"
			}
		},
		"title": "1500_cpons__t",
		"type": "object"
	},
	"credit_cards": {
		"_internalName": "Credit Cards",
		"$id": "1500_credit_cards",
		"description": "1500_cc__d",
		"properties": {
			"use_luhn": {
				"description": "1500_cc_use_luhn__d",
				"type": "boolean"
			}
		},
		"title": "1500_cc__t",
		"type": "object"
	},
	"crosssell_choice_deconflict": {
		"_internalName": "CrossSell Choice and Addon Choice Deconflict Settings",
		"$id": "1500_crosssell_choice_deconflict",
		"description": "1500_xsell_dcnflct__d",
		"properties": {
			"customer_types": {
				"description": "1500_xsell_dcnflct_cust_types__d",
				"enum": [
					"quantity",
					"customer_id"
				],
				"type": "string"
			},
			"times": {
				"description": "1500_xsell_dcnflct_times__d",
				"enum": [
					true
				],
				"type": "boolean"
			}
		},
		"title": "1500_xsell_dcnflct__t",
		"type": "object"
	},
	"css_overrides": {
		"_internalName": "CSS Overrides",
		"$id": "1500_css_overrides",
		"description": "1500_css__d",
		"properties": {
			"brandTitle": {
				"description": "1500_css_brand_title__d",
				"pattern": "^#(?=(?:.{3}|.{6})$)[0-9A-Za-z]*$",
				"type": "string"
			},
			"btnDefault": {
				"description": "1500_css_btn_def__d",
				"type": "string"
			},
			"btnDefaultActive": {
				"description": "1500_css_btn_def_act__d",
				"type": "string"
			},
			"btnDefaultHover": {
				"description": "1500_css_btn_def_hov__d",
				"type": "string"
			},
			"btnPrimary": {
				"description": "1500_css_btn_pri__d",
				"type": "string"
			},
			"btnPrimaryActive": {
				"description": "1500_css_btn_pri_act__d",
				"type": "string"
			},
			"btnPrimaryHover": {
				"description": "1500_css_btn_pri_hov__d",
				"type": "string"
			},
			"btnSuccess": {
				"description": "1500_css_btn_suc__d",
				"type": "string"
			},
			"btnSuccessActive": {
				"description": "1500_css_btn_suc_act__d",
				"type": "string"
			},
			"btnSuccessHover": {
				"description": "1500_css_btn_suc_hov__d",
				"type": "string"
			},
			"btnWarn": {
				"description": "1500_css_btn_warn__d",
				"type": "string"
			},
			"btnWarnActive": {
				"description": "1500_css_btn_warn_act__d",
				"type": "string"
			},
			"btnWarnHover": {
				"description": "1500_css_btn_warn_hov__d",
				"type": "string"
			},
			"cacheBuster": {
				"description": "1500_css_cache_bust__d",
				"pattern": "^[0-9]+$",
				"type": "string"
			},
			"fixedNavBg": {
				"description": "1500_css_fixed_nav_bg__d",
				"pattern": "^#(?=(?:.{3}|.{6})$)[0-9A-Za-z]*$",
				"type": "string"
			},
			"iconModalClose": {
				"description": "1500_css_icn_modal_cls__d",
				"pattern": "^#(?=(?:.{3}|.{6})$)[0-9A-Za-z]*$",
				"type": "string"
			},
			"pkgHeading": {
				"description": "1500_css_pkg_heading__d",
				"pattern": "^#(?=(?:.{3}|.{6})$)[0-9A-Za-z]*$",
				"type": "string"
			},
			"pkgPriceBg": {
				"description": "1500_css_pkg_prc_bg__d",
				"pattern": "^#(?=(?:.{3}|.{6})$)[0-9A-Za-z]*$",
				"type": "string"
			},
			"pkgPriceBgTag": {
				"description": "1500_css_pkg_prc_bg_tag__d",
				"pattern": "^#(?=(?:.{3}|.{6})$)[0-9A-Za-z]*$",
				"type": "string"
			},
			"pkgPriceBrdrAfter": {
				"description": "1500_css_pkg_prc_brdr_aft__d",
				"pattern": "^#(?=(?:.{3}|.{6})$)[0-9A-Za-z]*$",
				"type": "string"
			},
			"pkgPriceBrdrBefore": {
				"description": "1500_css_pkg_prc_brdr_bfr__d",
				"pattern": "^#(?=(?:.{3}|.{6})$)[0-9A-Za-z]*$",
				"type": "string"
			},
			"pkgPriceBuyBtnBg": {
				"description": "1500_css_pkg_prc_buy_btn_bg__d",
				"pattern": "^#(?=(?:.{3}|.{6})$)[0-9A-Za-z]*$",
				"type": "string"
			},
			"pkgPriceBuyBtnText": {
				"description": "1500_css_pkg_prc_buy_btn_txt__d",
				"pattern": "^#(?=(?:.{3}|.{6})$)[0-9A-Za-z]*$",
				"type": "string"
			},
			"topBarBg": {
				"description": "1500_css_top_bar_bg__d",
				"pattern": "^#(?=(?:.{3}|.{6})$)[0-9A-Za-z]*$",
				"type": "string"
			},
			"topBarTxt": {
				"description": "1500_css_top_bar_txt__d",
				"pattern": "^#(?=(?:.{3}|.{6})$)[0-9A-Za-z]*$",
				"type": "string"
			}
		},
		"required": [
			"cacheBuster"
		],
		"title": "1500_css__t",
		"type": "object"
	},
	"css_variables": {
		"_internalName": "CSS Variables",
		"$id": "1500_css_variables",
		"definitions": {
			"css-variable": {
				"pattern": "^#(?=(?:.{3}|.{6})$)[0-9A-Za-z]*$",
				"type": "string"
			}
		},
		"description": "1500_css_v__d",
		"properties": {
			"gap-selected": {
				"$ref": "#/definitions/css-variable"
			},
			"gap-selected-lighter": {
				"$ref": "#/definitions/css-variable"
			},
			"gap-selected-darker": {
				"$ref": "#/definitions/css-variable"
			},
			"gap-currency": {
				"$ref": "#/definitions/css-variable"
			},
			"gap-best-value": {
				"$ref": "#/definitions/css-variable"
			},
			"gap-low-threshold": {
				"$ref": "#/definitions/css-variable"
			},
			"gap-primary": {
				"$ref": "#/definitions/css-variable"
			},
			"gap-primary-on-surface": {
				"$ref": "#/definitions/css-variable"
			},
			"gap-primary-lighter": {
				"$ref": "#/definitions/css-variable"
			},
			"gap-primary-darker": {
				"$ref": "#/definitions/css-variable"
			},
			"gap-secondary": {
				"$ref": "#/definitions/css-variable"
			},
			"gap-secondary-on-surface": {
				"$ref": "#/definitions/css-variable"
			},
			"gap-secondary-lighter": {
				"$ref": "#/definitions/css-variable"
			},
			"gap-secondary-darker": {
				"$ref": "#/definitions/css-variable"
			},
			"gap-tertiary": {
				"$ref": "#/definitions/css-variable"
			},
			"gap-tertiary-on-surface": {
				"$ref": "#/definitions/css-variable"
			},
			"gap-tertiary-lighter": {
				"$ref": "#/definitions/css-variable"
			},
			"gap-tertiary-darker": {
				"$ref": "#/definitions/css-variable"
			},
			"gap-error": {
				"$ref": "#/definitions/css-variable"
			},
			"gap-error-on-surface": {
				"$ref": "#/definitions/css-variable"
			},
			"gap-error-lighter": {
				"$ref": "#/definitions/css-variable"
			},
			"gap-error-darker": {
				"$ref": "#/definitions/css-variable"
			},
			"gap-success": {
				"$ref": "#/definitions/css-variable"
			},
			"gap-success-on-surface": {
				"$ref": "#/definitions/css-variable"
			},
			"gap-success-lighter": {
				"$ref": "#/definitions/css-variable"
			},
			"gap-success-darker": {
				"$ref": "#/definitions/css-variable"
			},
			"gap-checkbox-focus-color": {
				"$ref": "#/definitions/css-variable"
			},
			"gap-font-family": {
				"type": "string"
			}
		}
	},
	"cultural_client_checkbox_options": {
		"_internalName": "Cultural Client Checkbox Options for numerous different use cases",
		"$id": "1500_cultural_client_checkbox_options",
		"additionalItems": false,
		"description": "1500_cult_chk_opt__d",
		"items": {
			"properties": {
				"charac_name": {
					"description": "1500_cult_chk_opt_charac__d",
					"type": "string"
				},
				"false_value": {
					"description": "1500_cult_chk_opt_false_val__d",
					"type": "boolean"
				},
				"name": {
					"description": "1500_cult_chk_opt_name__d",
					"type": "string"
				},
				"true_value": {
					"description": "1500_cult_chk_opt_true_val__d",
					"type": "boolean"
				},
				"value": {
					"description": "1500_cult_chk_opt_val__d",
					"type": "boolean"
				}
			},
			"required": [
				"charac_name",
				"name",
				"value"
			],
			"type": "object"
		},
		"title": "1500_cult_chk_opt__t",
		"type": "array"
	},
	"cultural_member_benefits": {
		"_internalName": "Cultural Member Benefits",
		"$id": "1500_cultural_member_benefits",
		"description": "1500_cult_mben__d",
		"properties": {
			"category_images": {
				"additionalItems": false,
				"description": "1500_cult_mben_ct_img__d",
				"items": {
					"properties": {
						"benefit_category_name": {
							"description": "1500_cult_mben_ct_img_ben_name__d",
							"type": "string"
						},
						"category_direct_to_calendar": {
							"description": "1500_cat_dir_to_cal__d",
							"type": "boolean"
						},
						"display": {
							"description": "1500_cult_mben_ct_img_disp__d",
							"type": "string"
						},
						"image_name": {
							"description": "1500_cult_mben_ct_img_name__d",
							"type": "string"
						},
						"category_banner_image": {
							"description": "1500_cult_mben_ct_ban_img__d",
							"type": "string"
						},
						"order": {
							"description": "1500_cult_mben_ct_img_ord__d",
							"type": "number"
						},
						"pagination": {
							"description": "1500_cult_mben_ct_img_pag__d",
							"type": "number"
						}
					},
					"required": [
						"benefit_category_name",
						"image_name"
					],
					"type": "object"
				},
				"title": "1500_cult_mben_ct_img__t",
				"type": "array"
			},
			"customer_type_groups": {
				"additionalItems": false,
				"description": "1500_cult_mben_cst_typ__d",
				"items": {
					"properties": {
						"group_id": {
							"description": "1500_cult_mben_cst_typ_grp_id__d",
							"type": "string"
						},
						"group_name": {
							"description": "1500_cult_mben_cst_typ_grp_name__d",
							"type": "string"
						}
					},
					"type": "object"
				},
				"title": "1500_cult_mben_cst_typ__t",
				"type": "array"
			},
			"collapse_benefit_blurb": {
				"_internalName": "Collapse Benefit Blurb",
				"_internalDescription": "Enable/disable auto expanding of benefit blurb",
				"title": "1500_cult_mben_col_ben_blurb__t",
				"description": "1500_cult_mben_col_ben_blurb__d",
				"type": "boolean"
			},
			"default_calendar_view": {
				"description": "1500_cult_mben_def_cal_view__d",
				"type": "boolean"
			},
			"default_capacity_threshold": {
				"description": "1500_cult_mben_def_cap_thrsh__d",
				"type": "number"
			},
			"default_remaining_threshold": {
				"description": "1500_cult_mben_def_rem_thrsh__d",
				"type": "number"
			},
			"extend_dates_retrieved": {
				"description": "1500_cult_mben_xtnd_dat__d",
				"type": "number"
			},
			"hide_available_benefits": {
				"description": "1500_cult_mben_hide_avail_ben__d",
				"type": "boolean"
			},
			"is_new_flow": {
				"description": "1500_cult_mben_is_new_flow__d",
				"type": "boolean"
			},
			"paginate_categories": {
				"description": "1500_cult_mben_pag_cat__d",
				"type": "boolean"
			},
			"profile_props_to_prevent_benefit_redemption": {
				"additionalItems": false,
				"description": "1500_cult_mben_prof_prp__d",
				"items": {
					"properties": {
						"prop_name": {
							"description": "1500_cult_mben_prof_prp_name__d",
							"type": "string"
						},
						"prop_value": {
							"description": "1500_cult_mben_prof_prp_val__d"
						}
					},
					"required": [
						"prop_name",
						"prop_value"
					],
					"type": "object"
				},
				"title": "1500_cult_mben_prof_prp__t",
				"type": "array"
			},
			"request_overrides": {
				"additionalItems": false,
				"description": "1500_cult_mben_req__d",
				"items": {
					"properties": {
						"additional_params": {
							"additionalItems": false,
							"description": "1500_cult_mben_req_add_params__d",
							"items": {
								"type": "object"
							},
							"type": "array"
						},
						"enabled": {
							"description": "1500_cult_mben_req_enabled__d",
							"type": "boolean"
						},
						"request_name": {
							"description": "1500_cult_mben_req_name__d",
							"type": "string"
						}
					},
					"required": [
						"enabled",
						"request_name"
					],
					"type": "object"
				},
				"title": "1500_cult_mben_req__t",
				"type": "array"
			},
			"show_all_membership_option": {
				"description": "1500_cult_mben_show_mem_opts__d",
				"type": "boolean"
			},
			"show_guest_info": {
				"description": "1500_cult_mben_show_guest_info__d",
				"type": "boolean"
			}
		},
		"required": [
			"category_images",
			"customer_type_groups"
		],
		"title": "1500_cult_mben__t",
		"type": "object"
	},
	"cultural_membership_wizard": {
		"_internalName": "Cultural Membership Wizard",
		"$id": "1500_cultural_membership_wizard",
		"description": "1500_cult_mwiz__d",
		"properties": {
			"charac_mappings_for_addl_guests": {
				"description": "1500_cult_mwiz_c_add_gst__d",
				"properties": {
					"additional_adult": {
						"description": "1500_cult_mwiz_c_add_gst_alt__d",
						"type": "object"
					},
					"additional_youth": {
						"description": "1500_cult_mwiz_c_add_gst_yth__d",
						"type": "object"
					}
				},
				"title": "1500_cult_mwiz_c_add_gst__t",
				"type": "object"
			},
			"hide_membership_payment_plan_option": {
				"description": "1500_cult_mwiz_h_plan_opt__d",
				"enum": [
					true
				],
				"title": "1500_cult_mwiz_h_plan_opt__t",
				"type": "boolean"
			},
			"membership_level_charac_name": {
				"description": "1500_cult_mwiz_lvl_c_name__d",
				"type": "string"
			},
			"membership_levels_config": {
				"additionalItems": false,
				"description": "1500_cult_mwiz_lvl_cfg__d",
				"items": {
					"properties": {
						"name": {
							"description": "1500_cult_mwiz_lvl_cfg_name__d",
							"type": "string"
						},
						"order": {
							"description": "1500_cult_mwiz_lvl_cfg_ord__d",
							"type": "number"
						},
						"profile_membership_level_name_mapping": {
							"description": "1500_cult_mwiz_lvl_cfg_prof_mem__d",
							"type": "string"
						},
						"renewal_package_charac": {
							"description": "1500_cult_mwiz_lvl_cfg_renew_pkg_c__d",
							"type": "string"
						},
						"tier": {
							"description": "1500_cult_mwiz_lvl_cfg_tier__d",
							"type": "string"
						},
						"image": {
							"description": "1500_cult_mwiz_lvl_cfg_image__d",
							"type": "string"
						}
					},
					"required": [
						"name",
						"order"
					],
					"type": "object"
				},
				"title": "1500_cult_mwiz_lvl_cfg__t",
				"type": "array"
			},
			"membership_selection_options": {
				"$ref": "1500_cultural_membership_wizard_membership_selection_options/properties/membership_selection_options",
				"description": "1500_cult_mwiz_sel_opt__d"
			},
			"membership_type_charac_name": {
				"description": "1500_cult_mwiz_typ_c_name__d",
				"type": "string"
			},
			"membership_types_config": {
				"additionalItems": false,
				"description": "1500_cult_mwiz_typ_cfg__d",
				"items": {
					"properties": {
						"image_file_name": {
							"description": "1500_cult_mwiz_typ_cfg_img_name__d",
							"type": "string"
						},
						"membership_type": {
							"title": "1500_cult_mwiz_typ_cfg_type__d",
							"type": "string"
						},
						"non_wizard_keyword_route": {
							"description": "1500_cult_mwiz_typ_cfg_nwiz_key_rt__d",
							"type": "string"
						},
						"order": {
							"description": "1500_cult_mwiz_typ_cfg_ord__d",
							"type": "number"
						},
						"supported_profile_membership_level_names": {
							"additionalItems": false,
							"description": "1500_cult_mwiz_typ_cfg_sup_pmem_lvl__d",
							"items": {
								"type": "string"
							},
							"type": "array"
						},
						"unsupported_profile_membership_level_names": {
							"additionalItems": false,
							"description": "1500_cult_mwiz_typ_cfg_usup_pmem_lvl__d",
							"items": {
								"type": "string"
							},
							"type": "array"
						}
					},
					"required": [
						"image_file_name",
						"membership_type"
					],
					"type": "object"
				},
				"title": "1500_cult_mwiz_typ_cfg__t",
				"type": "array"
			},
			"new_member_optins": {
				"$ref": "1500_cultural_client_checkbox_options",
				"description": "1500_cult_mwiz_new_mem_optn__d"
			},
			"optional_screens": {
				"additionalItems": false,
				"description": "1500_cult_mwiz_optl_screens__d",
				"items": {
					"type": "string"
				},
				"type": "array"
			},
			"unsupported_profile_membership_level_names": {
				"additionalItems": false,
				"description": "1500_cult_mwiz_usup_pmem_lvl__d",
				"items": {
					"type": "string"
				},
				"type": "array"
			},
			"use_membership_type_column_view": {
				"description": "1500_cult_mwiz_use_mtype_col_vw__d",
				"type": "boolean"
			},
			"use_new_membership_for_upgrade_or_downgrade_renewals": {
				"description": "1500_cult_mwiz_use_new_mem_uod_renew__d",
				"type": "boolean"
			}
		},
		"required": [
			"membership_level_charac_name",
			"membership_levels_config",
			"membership_type_charac_name",
			"membership_types_config"
		],
		"title": "1500_cult_mwiz__t",
		"type": "object"
	},
	"cultural_membership_wizard_dynamic_checkbox_options": {
		"_internalName": "Cultural Membership Wizard Dynamic Checkbox Options",
		"$id": "1500_cultural_membership_wizard_dynamic_checkbox_options",
		"$ref": "1500_cultural_client_checkbox_options",
		"description": "1500_cult_mem_wiz_dy_chk_opt__d",
		"title": "1500_cult_mem_wiz_dy_chk_opt__t"
	},
	"cultural_membership_wizard_membership_selection_options": {
		"_internalName": "Cultural Membership Wizard Membership Selection Options",
		"$id": "1500_cultural_membership_wizard_membership_selection_options",
		"description": "1500_cmwiz_sopt__d",
		"properties": {
			"membership_selection_options": {
				"additionalItems": false,
				"description": "1500_cmwiz_sopt_opts__d",
				"items": {
					"properties": {
						"allow_undefined_ct_charac": {
							"description": "1500_cmwiz_sopt_opts_alw_und_ct_c__d",
							"type": "boolean"
						},
						"false_value": {
							"description": "1500_cmwiz_sopt_opts_f_val__d",
							"type": "number"
						},
						"field_type": {
							"description": "1500_cmwiz_sopt_opts_fld_type__d",
							"pattern": "stepper|radiobool|checkbox",
							"type": "string"
						},
						"is_demographic_option": {
							"description": "1500_cmwiz_sopt_opts_is_demo_opt__d",
							"type": "boolean"
						},
						"is_level_effector": {
							"description": "1500_cmwiz_sopt_opts_is_lvl_eff__d",
							"type": "boolean"
						},
						"is_required_on_demographic_option": {
							"description": "1500_cmwiz_sopt_opts_is_req_demo_opt__d",
							"type": "boolean"
						},
						"max_value": {
							"description": "1500_cmwiz_sopt_opts_max_val__d",
							"type": "number"
						},
						"min_value": {
							"description": "1500_cmwiz_sopt_opts_min_val__d",
							"type": "number"
						},
						"name": {
							"description": "1500_cmwiz_sopt_opts_name__d",
							"type": "string"
						},
						"order": {
							"description": "1500_cmwiz_sopt_opts_ord__d",
							"type": "number"
						},
						"product_identifier_strings_to_set_renewal_truth_value": {
							"additionalItems": false,
							"description": "1500_cmwiz_sopt_opts_prd_id_strs__d",
							"items": {
								"type": "string"
							},
							"type": "array"
						},
						"show_info_modal": {
							"description": "1500_cmwiz_sopt_opts_show_info_mdl__d",
							"type": "boolean"
						},
						"show_on_optional_rate_selection": {
							"description": "1500_cmwiz_sopt_opts_show_optl_rate__d",
							"type": "boolean"
						},
						"supported_tiers": {
							"additionalItems": false,
							"description": "1500_cmwiz_sopt_opts_sup_tiers__d",
							"items": {
								"type": "string"
							},
							"type": "array"
						},
						"truth_value": {
							"description": "1500_cmwiz_sopt_opts_t_val__d",
							"type": "number"
						},
						"value": {
							"description": "1500_cmwiz_sopt_opts_val__d",
							"type": "number"
						}
					},
					"required": [
						"allow_undefined_ct_charac",
						"field_type",
						"is_level_effector",
						"name",
						"order",
						"value"
					],
					"type": "object"
				},
				"title": "1500_cmwiz_sopt_opts__t",
				"type": "array"
			}
		},
		"required": [
			"membership_selection_options"
		],
		"title": "1500_cmwiz_sopt__t",
		"type": "object"
	},
	"custom_agreement_forms": {
		"_internalName": "Custom Agreement Forms Movie Configuration",
		"$id": "1500_custom_agreement_forms",
		"additionalItems": false,
		"description": "1500_cstm_agree_forms__d",
		"items": {
			"properties": {
				"associated_cart_item_charac_name": {
					"description": "1500_cstm_agree_forms_assc_crt_i_c_name__d",
					"type": "string"
				},
				"associated_cart_item_charac_value": {
					"description": "1500_cstm_agree_forms_assc_crt_i_c_val__d",
					"type": "string"
				},
				"disable_birthday_check": {
					"description": "1500_cstm_agree_forms_disabd__d",
					"enum": [
						true
					],
					"type": "boolean"
				},
				"form_name": {
					"description": "1500_cstm_agree_forms_name__d",
					"type": "string"
				},
				"hide_steps": {
					"description": "1500_cstm_agree_forms_hide_steps__d",
					"enum": [
						true
					],
					"type": "boolean"
				},
				"cancel_removes_items": {
					"description": "1500_cstm_agree_forms_cancel_rm__d",
					"enum": [
						true
					],
					"type": "boolean"
				},
				"skip_payment_plan_forms": {
					"description": "1500_cstm_agree_forms_skip_pp__d",
					"enum": [
						true
					],
					"type": "boolean"
				},
				"hide_signature": {
					"description": "1500_cstm_agree_forms_hide_sig__d",
					"enum": [
						true
					],
					"type": "boolean"
				},
				"record_acceptance": {
					"description": "1500_cstm_agree_forms_rec_acc__d",
					"enum": [
						true
					],
					"type": "boolean"
				},
				"required": {
					"description": "1500_cstm_agree_forms_req__d",
					"type": "boolean",
					"enum": [
						true
					]
				},
				"require_name": {
					"description": "1500_cstm_agree_forms_req_name__d",
					"type": "boolean"
				}
			},
			"required": [
				"form_name"
			],
			"type": "object"
		},
		"title": "1500_cstm_agree_forms__t",
		"type": "array"
	},
	"custom_notifications": {
		"_internalName": "Notify User At Checkout Configuration",
		"$id": "1500_custom_notifications",
		"additionalItems": false,
		"description": "1500_cstm_ntf__d",
		"items": {
			"properties": {
				"display": {
					"description": "1500_cstm_ntf_disp__d",
					"type": "string"
				},
				"locale_description": {
					"description": "1500_cstm_ntf_lcle_desc__d",
					"type": "string"
				},
				"locale_section": {
					"description": "1500_cstm_ntf_lcle_sect__d",
					"type": "string"
				},
				"locale_title": {
					"description": "1500_cstm_ntf_lcle_title__d",
					"type": "string"
				},
				"package_ids": {
					"additionalItems": false,
					"description": "1500_cstm_ntf_pkg_ids__d",
					"items": {
						"pattern": "^\\d+$",
						"type": [
							"integer",
							"string"
						]
					},
					"type": "array"
				}
			},
			"type": "object"
		},
		"required": [],
		"title": "1500_cstm_ntf__t",
		"type": "array"
	},
	"customPaymentMethod": {
		"_internalName": "Custom Payment Method Display",
		"$id": "1500_customPaymentMethod",
		"description": "1500_cstm_pay_mthd__d",
		"properties": {
			"image": {
				"description": "1500_cstm_pay_mthd_img__d",
				"type": "string"
			},
			"subType": {
				"description": "1500_cstm_pay_mthd_sub_type__d",
				"type": "string"
			},
			"type": {
				"description": "1500_cstm_pay_mthd_type__d",
				"type": "string"
			}
		},
		"required": [
			"image",
			"type"
		],
		"title": "1500_cstm_pay_mthd__t",
		"type": "object"
	},
	"date_collection": {
		"_internalName": "Date Collection",
		"$id": "1500_date_collection",
		"description": "1500_dcol__d",
		"properties": {
			"display": {
				"description": "1500_dcol_disp__d",
				"type": "string"
			},
			"display_month_as_number": {
				"description": "1500_dcol_month_as_num__d",
				"type": "boolean"
			},
			"format_string": {
				"description": "1500_dcol_fmt_str__d",
				"type": "string"
			},
			"hide_label": {
				"description": "1500_dcol_hide_lbl__d",
				"type": "boolean"
			},
			"is_required": {
				"description": "1500_dcol_is_req__d",
				"type": "boolean"
			},
			"label": {
				"description": "1500_dcol_lbl__d",
				"properties": {
					"section": {
						"description": "1500_dcol_lbl_sect__d",
						"type": "string"
					},
					"target": {
						"description": "1500_dcol_lbl_target__d",
						"type": "string"
					}
				},
				"title": "1500_dcol_lbl__t",
				"type": "object"
			},
			"maxYear": {
				"description": "1500_dcol_max_yr__d",
				"type": "string"
			},
			"minYear": {
				"description": "1500_dcol_min_yr__d",
				"type": "string"
			},
			"model_format": {
				"description": "1500_dcol_model_fmt__d",
				"type": "string"
			},
			"model_is_format": {
				"description": "1500_dcol_model_is_fmt__d",
				"type": "boolean"
			},
			"validation_type": {
				"description": "1500_dcol_val_type__d",
				"type": "string"
			},
			"year_order": {
				"description": "1500_dcol_yr_ord__d",
				"type": "string"
			},
			"year_regex": {
				"description": "1500_dcol_yr_regex__d",
				"type": "string"
			}
		},
		"required": [],
		"title": "1500_dcol__t",
		"type": "object"
	},
	"default_package_type": {
		"_internalName": "Default Package Type",
		"_internalDescription": "UPD/PDP only merchant wide setting for the default package type",
		"$id": "1500_default_package_type",
		"description": "1500_dflt_pkg_type__d",
		"enum": [
			"ticket",
			"retail",
			"gift_card"
		],
		"title": "1500_dflt_pkg_type__t",
		"type": "string"
	},
	"debit_success": {
		"_internalName": "Debit Success",
		"$id": "1500_debit_success",
		"description": "1500_deb_succ__d",
		"properties": {
			"hide_ongoing_payment": {
				"description": "1500_deb_succ_hide_ongo_pay__d",
				"type": "boolean"
			}
		},
		"title": "1500_deb_succ__t",
		"type": "object"
	},
	"demographic_form_field_overrides": {
		"_internalName": "Demographic Form Field Overrides",
		"$id": "1500_demographic_form_field_overrides",
		"additionalItems": false,
		"description": "1500_demofm__d",
		"items": {
			"properties": {
				"auth_types": {
					"additionalItems": false,
					"description": "1500_demofm_auth_types__d",
					"items": {
						"type": "string"
					},
					"type": "array"
				},
				"disabled_fields": {
					"_internalDescription": "Disable the specified fields",
					"_internalTitle": "Disabled Fields",
					"additionalItems": false,
					"description": "1500_demofm_disaf__d",
					"items": {
						"type": "string"
					},
					"title": "1500_demofm_disaf__t",
					"type": "array",
					"uniqueItems": true
				},
				"forms": {
					"additionalItems": false,
					"description": "1500_demofm_forms__d",
					"items": {
						"type": "string"
					},
					"type": "array"
				},
				"labels": {
					"additionalItems": false,
					"description": "1500_demofm_lbls__d",
					"item": {
						"enum": [
							"copyInfoToBilling",
							"email",
							"instruction",
							"passDisclosure",
							"pillLabel"
						],
						"type": "string"
					},
					"type": "array"
				},
				"optional_fields": {
					"additionalItems": false,
					"description": "1500_demofm_opt_flds__d",
					"items": {
						"type": "string"
					},
					"type": "array"
				},
				"options": {
					"_internalDescription": "Extra Options and criteria for the config to apply",
					"_internalTitle": "Options",
					"description": "1500_demofm_disaf_opti__d",
					"properties": {
						"profile": {
							"_internalDescription": "Options specific to forms that use profiles",
							"_internalTitle": "Profile Options",
							"description": "1500_demofm_disaf_opti_prof__d",
							"properties": {
								"existing_guest": {
									"_internalDescription": "Apply configuration if the form is currently using an existing guest",
									"_internalTitle": "Existing Guest",
									"description": "1500_demofm_disaf_opti_prof_exitg__d",
									"default": false,
									"title": "1500_demofm_disaf_opti_prof_exitg__t",
									"type": "boolean"
								}
							},
							"title": "1500_demofm_disaf_opti_prof__d",
							"type": "object"
						}
					},
					"title": "1500_demofm_disaf_opti__t",
					"type": "object"
				},
				"gpsGenderList": {
					"_internalDescription": "GPS-only: ordered list of gender option values shown in the demographics dropdown. Lowercase, underscores for spaces. Each value is the locale target under FormLabels.",
					"_internalTitle": "GPS Gender List",
					"additionalItems": false,
					"description": "1500_demofm_gps_gender_list__d",
					"items": {
						"pattern": "^[a-z]+(_[a-z]+)*$",
						"type": "string"
					},
					"title": "1500_demofm_gps_gender_list__t",
					"type": "array",
					"uniqueItems": true
				},
				"removed_fields": {
					"additionalItems": false,
					"description": "1500_demofm_rm_flds__d",
					"items": {
						"type": "string"
					},
					"type": "array"
				},
				"show_age_field": {
					"description": "1500_demofm_show_age_fld__d",
					"enum": [
						true
					],
					"type": "boolean"
				}
			},
			"required": [
				"forms",
				"optional_fields"
			],
			"type": "object"
		},
		"title": "1500_demofm__t",
		"type": "array"
	},
	"disable_form_validation": {
		"_internalName": "Disable Form Validation",
		"$id": "1500_disable_form_validation",
		"description": "1500_disfv__d",
		"enum": [
			true
		],
		"title": "1500_disfv__t",
		"type": "boolean"
	},
	"disable_modified_post_purchase_route": {
		"_internalName": "Disable Altercation Of Post Purchase Route",
		"$id": "1500_disable_modified_post_purchase_route",
		"description": "1500_dismppr__d",
		"enum": [
			true
		],
		"title": "1500_dismppr__t",
		"type": "boolean"
	},
	"disable_terms_on_cart_view": {
		"_internalName": "Disable showing terms on cart view",
		"$id": "1500_disable_terms_on_cart_view",
		"description": "1500_distermoncart__d",
		"enum": [
			true
		],
		"title": "1500_distermoncart__t",
		"type": "boolean"
	},
	"disable_trade_merchant_assessement": {
		"_internalName": "Disable the extra trade merchant assessement",
		"$id": "1500_disable_trade_merchant_assessement",
		"description": "1500_distma__d",
		"maximum": 1,
		"minimum": 1,
		"title": "1500_distma__t",
		"type": "integer"
	},
	"disable_year_restriction": {
		"_internalDescription": "Disables the calendar year restriction",
		"_internalName": "Disable Year Restriction",
		"$id": "1500_disable_year_restriction",
		"desciption": "1500_disayr__d",
		"title": "1500_disayr__t",
		"type": "boolean"
	},
	"disableSkipFolioShippingPage": {
		"_internalName": "Disable Skip Folio Shipping Page",
		"$id": "1500_disableSkipFolioShippingPage",
		"description": "1500_dissfsp__d",
		"enum": [
			true
		],
		"title": "1500_dissfsp__t",
		"type": "boolean"
	},
	"disableSkipShippingPage": {
		"_internalName": "Disable Skip Shipping Page",
		"$id": "1500_disableSkipShippingPage",
		"description": "1500_disssp__d",
		"enum": [
			true
		],
		"title": "1500_disssp__t",
		"type": "boolean"
	},
	"display_dankort": {
		"_internalName": "Display Dankort Card",
		"$id": "1500_display_dankort",
		"description": "1500_disp_dan__d",
		"title": "1500_disp_dan__t",
		"type": "boolean"
	},
	"display_zero_capacity": {
		"_internalName": "Display Zero Capacity",
		"_internalDescription": "When enabled, shows sold-out/unavailable times as disabled. When disabled, those times don't display at all.",
		"$id": "1500_display_zero_capacity",
		"description": "1500_dzc__d",
		"title": "1500_dzc__t",
		"type": "boolean"
	},
	"dolphin_programs": {
		"_internalName": "Dolphin Program Configuration",
		"$id": "1500_dolphin_programs",
		"description": "1500_dolphin__d",
		"properties": {
			"dolphin_participant_heightRequired": {
				"description": "1500_dolphin_part_h_req__d",
				"enum": [
					0,
					1
				],
				"type": "integer"
			},
			"dolphin_participant_meal_heightRequired": {
				"description": "1500_dolphin_part_ml_h_req__d",
				"enum": [
					0,
					1
				],
				"type": "integer"
			},
			"dolphin_participant_meal_mealRequired": {
				"description": "1500_dolphin_part_ml_ml_req__d",
				"enum": [
					0,
					1
				],
				"type": "integer"
			},
			"dolphin_participant_meal_minAge": {
				"description": "1500_dolphin_part_ml_min_age__d",
				"pattern": "^[0-9]",
				"type": "number"
			},
			"dolphin_participant_meal_shirtFieldEnabled": {
				"description": "1500_dolphin_part_ml_sf_enbl__d",
				"enum": [
					0,
					1
				],
				"type": "integer"
			},
			"dolphin_participant_meal_shoeRequired": {
				"description": "1500_dolphin_part_ml_shoe_req__d",
				"enum": [
					0,
					1
				],
				"type": "integer"
			},
			"dolphin_participant_meal_showAbilityOptions": {
				"description": "1500_dolphin_part_ml_show_abl_opt__d",
				"enum": [
					0,
					1
				],
				"type": "integer"
			},
			"dolphin_participant_meal_specialNeedsEnabled": {
				"description": "1500_dolphin_part_ml_sp_nds_enbl__d",
				"enum": [
					0,
					1
				],
				"type": "integer"
			},
			"dolphin_participant_meal_weightRequired": {
				"description": "1500_dolphin_part_ml_wt_req__d",
				"enum": [
					0,
					1
				],
				"type": "integer"
			},
			"dolphin_participant_mealRequired": {
				"description": "1500_dolphin_part_ml_req__d",
				"enum": [
					0,
					1
				],
				"type": "integer"
			},
			"dolphin_participant_minAge": {
				"description": "1500_dolphin_part_min_age__d",
				"pattern": "^[0-9]",
				"type": "number"
			},
			"dolphin_participant_shirtFieldEnabled": {
				"description": "1500_dolphin_part_sf_enbl__d",
				"enum": [
					0,
					1
				],
				"type": "integer"
			},
			"dolphin_participant_shoeRequired": {
				"description": "1500_dolphin_part_shoe_req__d",
				"enum": [
					0,
					1
				],
				"type": "integer"
			},
			"dolphin_participant_showAbilityOptions": {
				"description": "1500_dolphin_part_show_abl_opt__d",
				"enum": [
					0,
					1
				],
				"type": "integer"
			},
			"dolphin_participant_specialNeedsEnabled": {
				"description": "1500_dolphin_part_sp_nds_enbl__d",
				"enum": [
					0,
					1
				],
				"type": "integer"
			},
			"dolphin_participant_weightRequired": {
				"description": "1500_dolphin_part_wt_req__d",
				"enum": [
					0,
					1
				],
				"type": "integer"
			},
			"sid_participant_heightRequired": {
				"description": "1500_dolphin_sid_h_req__d",
				"enum": [
					0,
					1
				],
				"type": "integer"
			},
			"sid_participant_meal_mealRequired": {
				"description": "1500_dolphin_sid_ml_ml_req__d",
				"enum": [
					0,
					1
				],
				"type": "integer"
			},
			"sid_participant_minAge": {
				"description": "1500_dolphin_sid_min_age__d",
				"pattern": "^[0-9]",
				"type": "number"
			},
			"sid_participant_shirtFieldEnabled": {
				"description": "1500_dolphin_sid_sf_enbl__d",
				"enum": [
					0,
					1
				],
				"type": "integer"
			},
			"sid_participant_shoeRequired": {
				"description": "1500_dolphin_sid_shoe_req__d",
				"enum": [
					0,
					1
				],
				"type": "integer"
			},
			"sid_participant_showAbilityOptions": {
				"description": "1500_dolphin_sid_show_abl_opt__d",
				"enum": [
					0,
					1
				],
				"type": "integer"
			},
			"sid_participant_specialNeedsEnabled": {
				"description": "1500_dolphin_sid_sp_nds_enbl__d",
				"enum": [
					0,
					1
				],
				"type": "integer"
			},
			"sid_participant_weightRequired": {
				"description": "1500_dolphin_sid_wt_req__d",
				"enum": [
					0,
					1
				],
				"type": "integer"
			},
			"tfad_participant_dynamic_heightRequired": {
				"description": "1500_dolphin_tfad_dy_h_req__d",
				"enum": [
					0,
					1
				],
				"type": "integer"
			},
			"tfad_participant_dynamic_mealRequired": {
				"description": "1500_dolphin_tfad_dy_ml_req__d",
				"enum": [
					0,
					1
				],
				"type": "integer"
			},
			"tfad_participant_dynamic_minAge": {
				"description": "1500_dolphin_tfad_dy_min_age__d",
				"pattern": "^[0-9]",
				"type": "number"
			},
			"tfad_participant_dynamic_shirtFieldEnabled": {
				"description": "1500_dolphin_tfad_dy_sf_enbl__d",
				"enum": [
					0,
					1
				],
				"type": "integer"
			},
			"tfad_participant_dynamic_shoeRequired": {
				"description": "1500_dolphin_tfad_dy_shoe_req__d",
				"enum": [
					0,
					1
				],
				"type": "integer"
			},
			"tfad_participant_dynamic_showAbilityOptions": {
				"description": "1500_dolphin_tfad_dy_show_abl_opt__d",
				"enum": [
					0,
					1
				],
				"type": "integer"
			},
			"tfad_participant_dynamic_specialNeedsEnabled": {
				"description": "1500_dolphin_tfad_dy_sp_nds_enbl__d",
				"enum": [
					0,
					1
				],
				"type": "integer"
			},
			"tfad_participant_dynamic_weightRequired": {
				"description": "1500_dolphin_tfad_dy_wt_req__d",
				"enum": [
					0,
					1
				],
				"type": "integer"
			},
			"tfad_participant_heightRequired": {
				"description": "1500_dolphin_tfad_h_req__d",
				"enum": [
					0,
					1
				],
				"type": "integer"
			},
			"tfad_participant_meal_mealRequired": {
				"description": "1500_dolphin_tfad_ml_ml_req__d",
				"enum": [
					0,
					1
				],
				"type": "integer"
			},
			"tfad_participant_minAge": {
				"description": "1500_dolphin_tfad_min_age__d",
				"pattern": "^[0-9]",
				"type": "number"
			},
			"tfad_participant_shirtFieldEnabled": {
				"description": "1500_dolphin_tfad_sf_enbl__d",
				"enum": [
					0,
					1
				],
				"type": "integer"
			},
			"tfad_participant_shoeRequired": {
				"description": "1500_dolphin_tfad_shoe_req__d",
				"enum": [
					0,
					1
				],
				"type": "integer"
			},
			"tfad_participant_showAbilityOptions": {
				"description": "1500_dolphin_tfad_show_abl_opt__d",
				"enum": [
					0,
					1
				],
				"type": "integer"
			},
			"tfad_participant_specialNeedsEnabled": {
				"description": "1500_dolphin_tfad_sp_nds_enbl__d",
				"enum": [
					0,
					1
				],
				"type": "integer"
			},
			"tfad_participant_weightRequired": {
				"description": "1500_dolphin_wt_req__d",
				"enum": [
					0,
					1
				],
				"type": "integer"
			}
		},
		"title": "1500_dolphin__t",
		"type": "object"
	},
	"disableStoredPaymentsForFolios": {
		"_internalName": "Disable Stored Payments for Folios",
		"$id": "1500_disableStoredPaymentsForFolios",
		"description": "1500_disstpf__d",
		"enum": [
			true
		],
		"title": "1500_disstpf__t",
		"type": "boolean"
	},
	"displayTermsAsCheckboxOnCartView": {
		"_internalName": "Display Terms And Conditions on Cart View as checkbox",
		"$id": "1500_displayTermsAsCheckboxOnCartView",
		"description": "1500_disptermcc__d",
		"title": "1500_disptermcc__t",
		"type": "boolean"
	},
	"dynamic_toolbar_overrides": {
		"_internalName": "Dynamic Toolbar Overrides based on States",
		"$id": "1500_dynamic_toolbar_overrides",
		"additionalItems": false,
		"description": "1500_dytool__d",
		"items": {
			"properties": {
				"hide_cart_icon": {
					"description": "1500_dytool_hide_crt_icn__d",
					"type": "boolean"
				},
				"hide_faq_icon": {
					"description": "1500_dytool_hide_faq_icn__d",
					"type": "boolean"
				},
				"hide_toolbar": {
					"description": "1500_dytool_hide_tool__d",
					"type": "boolean"
				},
				"menuitems": {
					"additionalItems": false,
					"description": "1500_dytool_menu__d",
					"items": {
						"properties": {
							"item_name": {
								"description": "1500_dytool_menu_i_name__d",
								"type": "string"
							},
							"route_state_on_click": {
								"description": "1500_dytool_menu_rt_st_clk__d",
								"type": "string"
							}
						},
						"required": [
							"item_name",
							"route_state_on_click"
						],
						"type": "object"
					},
					"title": "1500_dytool_menu__t",
					"type": "array"
				},
				"show_client_icon_or_name": {
					"description": "1500_dytool_show_clnt_icn_name__d",
					"type": "boolean"
				},
				"states": {
					"additionalItems": false,
					"description": "1500_dytool_states__d",
					"items": {
						"description": "1500_dytool_states_i__d",
						"type": "string"
					},
					"type": "array"
				},
				"url_param": {
					"description": "1500_dytool_url_prm__d",
					"type": "string"
				}
			},
			"type": "object"
		},
		"title": "1500_dytool__t",
		"type": "array"
	},
	"enableEmailVerification": {
		"_internalName": "Enable Email Verification",
		"$id": "1500_enableEmailVerification",
		"description": "1500_enableev__d",
		"enum": [
			true
		],
		"title": "1500_enableev__t",
		"type": "boolean"
	},
	"enableEmailVerificationOnSeasonPass": {
		"_internalName": "Enable Email Verification - Season Pass",
		"$id": "1500_enableEmailVerificationOnSeasonPass",
		"description": "1500_enableevsp__d",
		"title": "1500_enableevsp__t",
		"type": "string"
	},
	"enable_google_wallet": {
		"_internalName": "Enable Save to Google Wallet - Post Purchase",
		"$id": "1500_enableGoogleWallet",
		"description": "1500_enablegw__d",
		"title": "1500_enablegw__t",
		"type": "boolean"
	},
	"enhanced_phone_number": {
		"_internalName": "Enhanced Phone Number",
		"$id": "1500_enhanced_phone_number",
		"description": "1500_enhpn__d",
		"properties": {
			"display_with_flags": {
				"description": "1500_enhpn_disp_w_flags__d",
				"type": "boolean"
			},
			"use_enhanced_phone_number": {
				"description": "1500_enhpn_use_enh_ph_num__d",
				"type": "boolean"
			}
		},
		"title": "1500_enhpn__t",
		"type": "object"
	},
	"entitlement_wizard": {
		"_internalName": "Merlin Wizard",
		"$id": "1500_entitlement_wizard",
		"description": "1500_entw__d",
		"properties": {
			"customerTypeDescriptions": {
				"description": "1500_entw_cust_typ_desc__d",
				"type": "object"
			},
			"entitlements": {
				"additionalItems": false,
				"description": "1500_entw_ents__d",
				"items": {
					"properties": {
						"id": {
							"type": [
								"integer",
								"string"
							]
						},
						"imageFileName": {
							"type": "string"
						},
						"name": {
							"type": "string"
						}
					},
					"type": "object"
				},
				"type": "array"
			},
			"enable_recursive_multipack_checks": {
				"type": "boolean",
				"description": "1500_entw_ermc__d"
			}
		},
		"required": [
			"entitlements"
		],
		"title": "1500_entw__t",
		"type": "object"
	},
	"event_search": {
		"_internalName": "Event Search",
		"$id": "1500_event_search",
		"description": "1500_entw__d",
		"properties": {
			"configurable_search_fields": {
				"$ref": "1500_profile_configurable_fields",
				"description": "1500_entw_confsf__d"
			},
			"hideLabelOnFieldByName": {
				"additionalItems": false,
				"description": "1500_entw_hidelofbn__d",
				"items": {
					"type": "string"
				},
				"type": "array"
			},
			"noEventsBanner": {
				"_internalDescription": "Banner to display when no events are available on search",
				"_internalName": "No Events Banner",
				"description": "1500_entw_noeb__d",
				"title": "1500_entw_noeb__t",
				"type": "string"
			},
			"passSearchAsListCharacParamOnFieldByName": {
				"additionalItems": false,
				"description": "1500_entw_passsalcpofbn__d",
				"items": {
					"type": "string"
				},
				"type": "array"
			},
			"supportWaitList": {
				"description": "1500_entw_suppwl__d",
				"type": "boolean"
			}
		},
		"title": "1500_entw__t",
		"type": "object"
	},
	"exp_sched_images": {
		"_internalName": "Experience Scheduler Images",
		"$id": "1500_exp_sched_images",
		"description": "1500_expsi__d",
		"title": "1500_expsi__t",
		"type": "object"
	},
	"expressCheckouts": {
		"_internalName": "Express Checkouts Configuration",
		"$id": "1500_expressCheckouts",
		"description": "1500_expChk__d",
		"definitions": {
			"WALLET_EXPRESS_CHECKOUT": {
				"properties": {
					"disable": {
						"description": "1500_expChk_walletpay_dis__d",
						"title": "1500_expChk_walletpay_dis__t",
						"type": "boolean"
					},
					"orderClass": {
						"description": "1500_expChk_walletpay_ordc__d",
						"title": "1500_expChk_walletpay_ordc__t",
						"type": "string"
					},
					"styles": {
						"description": "1500_expChk_walletpay_sty__d",
						"properties": {
							"buttonStyle": {
								"description": "1500_expChk_walletpay_sty_btnsty__d",
								"title": "1500_expChk_walletpay_sty_btnsty__t",
								"type": "string"
							},
							"buttonType": {
								"description": "1500_expChk_walletpay_sty_btntyp__d",
								"title": "1500_expChk_walletpay_sty_btntyp__t",
								"type": "string"
							}
						},
						"title": "1500_expChk_walletpay_sty__t",
						"type": "object"
					}
				},
				"type": "object"
			}
		},
		"properties": {
			"adyen_applepay": {
				"description": "1500_expChk_adyenapay__d",
				"$ref": "#/definitions/WALLET_EXPRESS_CHECKOUT",
				"title": "1500_expChk_adyenapay__t"
			},
			"adyen_googlepay": {
				"description": "1500_expChk_adyengpay__d",
				"$ref": "#/definitions/WALLET_EXPRESS_CHECKOUT",
				"title": "1500_expChk_adyengpay__t"
			},
			"cybersource_applepay": {
				"description": "1500_expChk_cybsapay__d",
				"$ref": "#/definitions/WALLET_EXPRESS_CHECKOUT",
				"title": "1500_expChk_cybsapay__t"
			},
			"cybersource_googlepay": {
				"description": "1500_expChk_cybsgpay__d",
				"$ref": "#/definitions/WALLET_EXPRESS_CHECKOUT",
				"title": "1500_expChk_cybsgpay__t"
			},
			"masterpass": {
				"description": "1500_expChk_masp__d",
				"properties": {
					"styles": {
						"description": "1500_expChk_masp_sty__d",
						"title": "1500_expChk_masp_sty__t",
						"type": "string"
					}
				},
				"title": "1500_expChk_masp__t",
				"type": "object"
			},
			"paypal": {
				"description": "1500_expChk_payp__d",
				"properties": {
					"disable": {
						"description": "1500_expChk_payp_dis__d",
						"title": "1500_expChk_payp_dis__t",
						"type": "boolean"
					},
					"styles": {
						"description": "1500_expChk_payp_sty__d",
						"title": "1500_expChk_payp_sty__t",
						"type": "string"
					}
				},
				"title": "1500_expChk_payp__t",
				"type": "object"
			}
		},
		"title": "1500_expChk__t",
		"type": "object"
	},
	"expYearsRange": {
		"_internalName": "Expire Years Range",
		"$id": "1500_expYearsRange",
		"description": "1500_expyr__d",
		"maximum": 50,
		"minimum": 10,
		"title": "1500_expyr__t",
		"type": "number"
	},
	"external_account": {
		"_internalName": "External Account Content Card",
		"_internalDescription": "Merlin MyAccount content card on the order confirmation page (MERLIN-161). Replaces the Print Your Tickets button with a launcher card that routes the guest to their external account using a pre-formatted URL returned on the view order response.",
		"$id": "1500_external_account",
		"description": "1500_ext_acct__d",
		"properties": {
			"enabled": {
				"description": "1500_ext_acct_enabled__d",
				"type": "boolean"
			},
			"use_store_button_style": {
				"description": "1500_ext_acct_use_store_btn__d",
				"type": "boolean"
			},
			"show_ticket_button": {
				"description": "1500_ext_acct_show_ticket_btn__d",
				"type": "boolean"
			}
		},
		"title": "1500_ext_acct__t",
		"type": "object"
	},
	"fast_lane_wizard": {
		"_internalName": "Fast Lane Wizard Message Banner Styles",
		"$id": "1500_fast_lane_wizard",
		"description": "1500_fastl_wiz__d",
		"properties": {
			"outline_color": {
				"description": "1500_outl_col__d",
				"type": "string",
				"default": ""
			},
			"info_text_color": {
				"description": "1500_inf_txt_col__d",
				"type": "string",
				"default": ""
			},
			"info_text": {
				"description": "1500_inf_txt__d",
				"type": "string",
				"default": ""
			}
		},
		"title": "1500_fastl_wiz__d",
		"type": "object"
	},
	"fast_lane_banner_styles": {
		"_internalName": "Fast lane Banner Styles",
		"$id": "1500_fast_lane_banner_styles",
		"description": "1500_faslbs__d",
		"properties": {
			"bannerBackgroundColor": {
				"description": "1500_faslbs_bannbgc__d",
				"type": "string"
			},
			"bannerBorderColor": {
				"description": "1500_faslbs_bannboc__d",
				"type": "string"
			},
			"bannerCopy": {
				"description": "1500_faslbs_bannc__d",
				"type": "string"
			},
			"logoImage": {
				"description": "1500_faslbs_logoi__d",
				"type": "string"
			},
			"show": {
				"description": "1500_faslbs_show__d",
				"type": "boolean"
			}
		},
		"title": "1500_faslbs__t",
		"type": "object"
	},
	"fee_notice": {
		"_internalName": "Fee Notice",
		"_internalDescription": "Controls display of the fee notices on a per page basis",
		"$id": "1500_fee_notice",
		"description": "1500_feen__d",
		"items": {
			"properties": {
				"include_taxes": {
					"_internalName": "Include Taxes",
					"_internalDescription": "If the fee notice should display the taxes within the price",
					"description": "1500_feen_inclt__d",
					"title": "1500_feen_inclt__t",
					"type": "boolean"
				},
				"page_name": {
					"_internalName": "Page Name",
					"_internalDescription": "The page identifier to display the fee notice on",
					"description": "1500_feen_pagen__d",
					"enum": [
						"CalendarPricingModule",
						"ComboCreator",
						"ComparisonChart",
						"DateTime",
						"FastLane",
						"PackageDetails",
						"PackageList",
						"SnapCalendar",
						"WizardCalendar"
					],
					"minLength": 1,
					"title": "1500_feen_pagen__t",
					"type": "string"
				},
				"show_fee": {
					"_internalName": "Show Fee",
					"_internalDescription": "Whether or not to show the fee notice on the page",
					"description": "1500_feen_showf__d",
					"title": "1500_feen_showf__t",
					"type": "boolean"
				}
			},
			"required": [
				"page_name",
				"show_fee"
			],
			"type": "object"
		},
		"title": "1500_feen__t",
		"type": "array"
	},
	"flashpass_video_settings": {
		"_internalName": "Flash Pass HTML 5 Video Configuration",
		"$id": "1500_flashpass_video_settings",
		"description": "1500_flavs__d",
		"definitions": {
			"FLASH_PASS_VIDEO_ITEM": {
				"description": "1500_flavs_flaspvi__d",
				"properties": {
					"path": {
						"description": "1500_flavs_flaspvi_path__d",
						"type": "string"
					},
					"type": {
						"description": "1500_flavs_flaspvi_type__d",
						"type": "string"
					}
				},
				"required": [
					"path",
					"type"
				],
				"title": "1500_flavs_flaspvi__t",
				"type": "object"
			}
		},
		"properties": {
			"flashMovie": {
				"description": "1500_flavs_fl_mov__d",
				"type": "string"
			},
			"mv4index": {
				"description": "1500_flavs_mv4_idx__d",
				"type": "integer"
			},
			"poster": {
				"description": "1500_flavs_poster__d",
				"type": "string"
			},
			"videos": {
				"description": "1500_flavs_vid__d",
				"items": {
					"$ref": "#/definitions/FLASH_PASS_VIDEO_ITEM",
					"type": "object"
				},
				"minItems": 0,
				"type": "array"
			}
		},
		"required": [],
		"title": "1500_flavs__t",
		"type": "object"
	},
	"flex_microform": {
		"_internalName": "Flex Microform",
		"$id": "1500_flex_microform",
		"description": "1500_flexm__d",
		"properties": {
			"setup_timeout": {
				"description": "1500_flexm_setup_to__d",
				"minimum": "6000",
				"type": "number"
			},
			"token_timeout": {
				"description": "1500_flexm_token_to__d",
				"maximum": "900000",
				"minimum": "60000",
				"type": "number"
			}
		},
		"title": "1500_flexm__t",
		"type": "object"
	},
	"gift_aid": {
		"_internalName": "Gift Aid Configuration",
		"$id": "1500_gift_aid",
		"description": "1500_gifta__d",
		"definitions": {
			"preselect_option": {
				"properties": {
					"value": {
						"_internalDescription": "What default selection for the respective gift_aid_type",
						"_internalName": "Preselect Value",
						"default": "Unselected",
						"description": "1500_gifta_d_preso_valu__d",
						"title": "1500_gifta_d_preso_valu__t",
						"type": "string"
					}
				},
				"type": "object"
			}
		},
		"properties": {
			"disabled": {
				"description": "1500_gifta_disa__d",
				"title": "1500_gifta_disa__t",
				"type": "boolean"
			},
			"enable_confirmation_screens": {
				"_internalDescription": "Enable Gift Aid Retention Screens",
				"_internalName": "Enable Retention Screens",
				"description": "1500_gifta_enab_ret__d",
				"title": "1500_gifta_enab_ret__t",
				"type": "boolean"
			},
			"images": {
				"_internalDescription": "Gift Aid images",
				"_internalName": "Images",
				"description": "1500_gifta_img__d",
				"properties": {
					"carousel": {
						"additionalItems": false,
						"_internalDescription": "Carousel Gift Aid Images",
						"_internalName": "Carousel Images",
						"description": "1500_gifta_car__d",
						"title": "1500_gifta_car__t",
						"items": {
							"type": "string"
						},
						"type": "array"
					},
					"confirmation": {
						"_internalDescription": "Retention Page Image",
						"_internalName": "Retention Page Image",
						"description": "1500_gifta_ret__d",
						"title": "1500_gifta_ret__t",
						"type": "string"
					},
					"desktop": {
						"_internalDescription": "Main Page - Desktop",
						"_internalName": "Main Page - Desktop",
						"description": "1500_gifta_desk__d",
						"title": "1500_gifta_desk__t",
						"type": "string"
					},
					"infographic": {
						"_internalDescription": "Card - Infographic",
						"_internalName": "Card - Infographic",
						"description": "1500_gifta_infographic__d",
						"title": "1500_gifta_infographic__t",
						"type": "string"
					},
					"remove": {
						"_internalDescription": "Donation Retention",
						"_internalName": "Donation Retention",
						"description": "1500_gifta_rem__d",
						"title": "1500_gifta_rem__t",
						"type": "string"
					}
				},
				"title": "1500_gifta_img__t",
				"type": "object"
			},
			"percent": {
				"description": "1500_gifta_perc__d",
				"maximum": 100,
				"minimum": 1,
				"title": "1500_gifta_perc__t",
				"type": "number"
			},
			"preselect": {
				"_internalDescription": "Automatically Presets a gift aid option",
				"_internalName": "Preselect Option",
				"description": "1500_gifta_pres__d",
				"properties": {
					"donation": {
						"_internalDescription": "Gift Aid / Donate Only (gift_aid_type = 2)",
						"_internalName": "Donation Eligible",
						"$ref": "#/definitions/preselect_option",
						"description": "1500_gifta_pres_dona__d",
						"properties": {
							"value": {
								"enum": [
									"Gift Aid",
									"Donation",
									"Unselected"
								]
							}
						},
						"title": "1500_gifta_pres_dona__t"
					},
					"no_donation": {
						"_internalDescription": "Gift Aid Only (gift_aid_type = 1)",
						"_internalName": "Gift Aid Only",
						"$ref": "#/definitions/preselect_option",
						"description": "1500_gifta_pres_nod__d",
						"properties": {
							"value": {
								"enum": [
									"Gift Aid",
									"Unselected"
								]
							}
						},
						"title": "1500_gifta_pres_nod__t"
					}
				},
				"title": "1500_gifta_pres__t",
				"type": "object"
			}
		},
		"required": [
			"percent"
		],
		"title": "1500_gifta__t",
		"type": "object"
	},
	"gift_membership": {
		"_internalName": "Gift Membership Configuration",
		"$id": "1500_gift_membership",
		"description": "1500_giftm__d",
		"properties": {
			"children_display": {
				"description": "1500_giftm_child_disp__d",
				"type": "string"
			},
			"default_field_values": {
				"description": "1500_giftm_deffv__d",
				"properties": {
					"add_ph_first": {
						"title": "1500_giftm_deffv_addphf__d",
						"type": "string"
					},
					"add_ph_last": {
						"title": "1500_giftm_deffv_addphl__d",
						"type": "string"
					},
					"add_ph_mi": {
						"title": "1500_giftm_deffv_addphm__d",
						"type": "string"
					},
					"aux_name_1": {
						"title": "1500_giftm_deffv_auxn1__d",
						"type": "string"
					},
					"aux_name_2": {
						"title": "1500_giftm_deffv_auxn2__d",
						"type": "string"
					}
				},
				"title": "1500_giftm_deffv__t",
				"type": "object"
			}
		},
		"title": "1500_giftm__t",
		"type": "object"
	},
	"guest_options": {
		"_internalName": "Guest Options",
		"$id": "1500_guest_options",
		"additionalItems": false,
		"description": "1500_guesto__d",
		"items": {
			"description": "1500_guesto_i__d",
			"properties": {
				"name": {
					"description": "1500_guesto_name__d",
					"type": "string"
				},
				"settings": {
					"description": "1500_guesto_s__d",
					"properties": {
						"customerTypeGroupList": {
							"additionalItems": false,
							"description": "1500_guesto_s_custtgl__d",
							"items": {
								"description": "1500_guesto_s_custtgl_i__d",
								"properties": {
									"groupId": {
										"description": "1500_guesto_s_custtgl_grpid__d",
										"type": "integer"
									},
									"keyword": {
										"description": "1500_guesto_s_custtgl_key__d",
										"type": "string"
									},
									"localeTargets": {
										"description": "1500_guesto_s_custtgl_lcletarg__d",
										"properties": {
											"subTitle": {
												"description": "1500_guesto_s_custtgl_lcletarg_sub_title__d",
												"type": "string"
											},
											"title": {
												"description": "1500_guesto_s_custtgl_lcletarg_title__d",
												"type": "string"
											}
										},
										"required": [
											"title"
										],
										"title": "1500_guesto_s_custtgl_lcletarg__t",
										"type": "object"
									},
									"maxQty": {
										"description": "1500_guesto_s_custtgl_max_qty__d",
										"type": "integer"
									},
									"minQty": {
										"description": "1500_guesto_s_custtgl_min_qty__d",
										"type": "integer"
									},
									"name": {
										"description": "1500_guesto_s_custtgl_name__d",
										"type": "string"
									},
									"qty": {
										"description": "1500_guesto_s_custtgl_qty__d",
										"type": "integer"
									}
								},
								"required": [],
								"type": "object"
							},
							"title": "1500_guesto_s_custtgl__t",
							"type": "array"
						},
						"merchantName": {
							"description": "1500_guesto_s_merch_name__d",
							"type": "string"
						},
						"showMilitaryVisitTypes": {
							"description": "1500_guesto_s_show_milvt__d",
							"type": "string"
						},
						"showNumberOfGuestsVisitTypes": {
							"description": "1500_guesto_s_show_numogvt__d",
							"type": "string"
						},
						"showZip": {
							"description": "1500_guesto_s_show_zip__d",
							"type": "boolean"
						},
						"visitTypeSelectList": {
							"additionalItems": false,
							"description": "1500_guesto_s_vistsl__d",
							"items": {
								"description": "1500_guesto_s_vistsl_i__d",
								"properties": {
									"localeTarget": {
										"description": "1500_guesto_s_vistsl_lcletarg__d",
										"type": "string"
									},
									"value": {
										"description": "1500_guesto_s_vistsl_val__d",
										"type": "integer"
									}
								},
								"required": [
									"localeTarget",
									"value"
								],
								"type": "object"
							},
							"title": "1500_guesto_s_vistsl__t",
							"type": "array"
						}
					},
					"title": "1500_guesto_s__t",
					"type": "object"
				}
			},
			"required": [
				"name",
				"settings"
			],
			"type": "object"
		},
		"title": "1500_guesto__t",
		"type": "array"
	},
	"hide_cart_cross_sells": {
		"_internalName": "Hide Cart Cross Sells",
		"$id": "1500_hide_cart_cross_sells",
		"description": "1500_hidepcartcs__d",
		"properties": {
			"url_params": {
				"additionalItems": false,
				"description": "1500_hidepcartcs_urlp__d",
				"items": {
					"description": "1500_hidepcartcs_urlp_i__d",
					"type": "string"
				},
				"title": "1500_hidepcartcs_urlp__t",
				"type": "array"
			}
		},
		"title": "1500_hidepcartcs__t",
		"type": "object"
	},
	"idme": {
		"_internalDescription": "Configuration relating to ID.me",
		"_internalName": "ID.me Configuration",
		"$id": "1500_idme",
		"description": "1500_idme__d",
		"properties": {
			"type_overrides": {
				"_internalDescription": "Overrides for the supported types for ID.me",
				"_internalName": "ID.me Type Overrides",
				"description": "1500_idme_typeo__d",
				"items": {
					"_internalDescription": "Type override value (e.g. 'student' or 'hospital_employee'). Must be lowercase and contain only letters and underscores.",
					"_internalName": "ID.me Type Value",
					"description": "1500_idme_typeo_i__d",
					"pattern": "^[a-z_]+$",
					"title": "1500_idme_typeo_i__t",
					"type": "string"
				},
				"minItems": 1,
				"title": "1500_idme_typeo__t",
				"type": "array",
				"uniqueItems": true
			},
			"use_legacy_auth": {
				"_internalDescription": "Whether or not to use the legacy storage authentication flow for ID.me",
				"_internalName": "Use Legacy Authentication",
				"description": "1500_idme_uselegauth__d",
				"title": "1500_idme_uselegauth__t",
				"type": "boolean"
			}
		},
		"title": "1500_idme__t",
		"type": "object"
	},
	"image_aws_folder_on_profile": {
		"_internalDescription": "Append image aws folder name to image file name",
		"_internalName": "Image AWS Folder On Profile",
		"$id": "1500_image_aws_folder_on_profile",
		"default": false,
		"desciption": "1500_imagafop__d",
		"title": "1500_imagafop__t",
		"type": "boolean"
	},
	"imagecaptures_config": {
		"_internalName": "Image Capture",
		"$id": "1500_imagecaptures_config",
		"description": "1500_imgcc__d",
		"properties": {
			"park_send_photo_info": {
				"description": "1500_imgcc_parkspi__d",
				"type": "string"
			},
			"sendAddImageCall": {
				"description": "1500_imgcc_sendaic__d",
				"type": "boolean"
			}
		},
		"title": "1500_imgcc__t",
		"type": "object"
	},
	"ingenico": {
		"_internalName": "Ingenico (Ogone) Configuration",
		"$id": "1500_ingenico",
		"description": "1500_ingenico__d",
		"properties": {
			"activatePaymentProvider": {
				"description": "1500_ingenico_actpp__d",
				"enum": [
					false,
					true
				],
				"type": "boolean"
			},
			"idealLink": {
				"description": "1500_ingenico_ideal__d",
				"type": "string"
			},
			"redirectPHPUrl": {
				"description": "1500_ingenico_redirphpu__d",
				"type": "string"
			}
		},
		"required": [
			"activatePaymentProvider",
			"redirectPHPUrl"
		],
		"title": "1500_ingenico__t",
		"type": "object"
	},
	"interstitial": {
		"_internalName": "Interstitial",
		"$id": "1500_interstitial",
		"description": "1500_inter__d",
		"properties": {
			"spar": {
				"description": "1500_inter_spar__d",
				"properties": {
					"characs": {
						"description": "1500_inter_spar_c__d",
						"properties": {
							"optin": {
								"description": "1500_inter_spar_c_optin__d",
								"type": "string"
							},
							"validation": {
								"description": "1500_inter_spar_c_vald__d",
								"type": "string"
							}
						},
						"title": "1500_inter_spar_c__t",
						"type": "object"
					},
					"images": {
						"description": "1500_inter_spar_img__d",
						"properties": {
							"desktop": {
								"description": "1500_inter_spar_img_dsk__d",
								"type": "string"
							},
							"mobile": {
								"description": "1500_inter_spar_img_mob__d",
								"type": "string"
							}
						},
						"title": "1500_inter_spar_img__t",
						"type": "object"
					},
					"locales": {
						"description": "1500_inter_spar_lcle__d",
						"properties": {
							"section": {
								"description": "1500_inter_spar_lcle_sect__d",
								"type": "string"
							},
							"suffix": {
								"description": "1500_inter_spar_lcle_suff__d",
								"type": "string"
							},
							"targets": {
								"description": "1500_inter_spar_lcle_targ__d",
								"properties": {
									"description1": {
										"description": "1500_inter_spar_lcle_targ_des1__d",
										"type": "string"
									},
									"description2": {
										"description": "1500_inter_spar_lcle_targ_des2__d",
										"type": "string"
									},
									"description3": {
										"description": "1500_inter_spar_lcle_targ_des3__d",
										"type": "string"
									},
									"description4": {
										"description": "1500_inter_spar_lcle_targ_des4__d",
										"type": "string"
									},
									"footnote": {
										"description": "1500_inter_spar_lcle_targ_foot__d",
										"type": "string"
									},
									"header1": {
										"description": "1500_inter_spar_lcle_targ_hed1__d",
										"type": "string"
									},
									"header2": {
										"description": "1500_inter_spar_lcle_targ_hed2__d",
										"type": "string"
									},
									"header3": {
										"description": "1500_inter_spar_lcle_targ_hed3__d",
										"type": "string"
									},
									"header4": {
										"description": "1500_inter_spar_lcle_targ_hed4__d",
										"type": "string"
									},
									"heading": {
										"description": "1500_inter_spar_lcle_targ_hdng__d",
										"type": "string"
									},
									"noText": {
										"description": "1500_inter_spar_lcle_targ_ntxt__d",
										"type": "string"
									},
									"subheading": {
										"description": "1500_inter_spar_lcle_targ_shdg__d",
										"type": "string"
									},
									"yesText": {
										"description": "1500_inter_spar_lcle_targ_ytxt__d",
										"type": "string"
									}
								},
								"title": "1500_inter_spar_lcle_targ__t",
								"type": "object"
							}
						},
						"title": "1500_inter_spar_lcle__t",
						"type": "object"
					}
				},
				"title": "1500_inter_spar__t",
				"type": "object"
			}
		},
		"required": [],
		"title": "1500_inter__t",
		"type": "object"
	},
	"legend_setup": {
		"_internalName": "Calendar Legend",
		"$id": "1500_legend_setup",
		"description": "1500_legends__d",
		"properties": {
			"bestAvailable": {
				"description": "1500_legends_besta__d",
				"type": "string"
			},
			"limitedAvailability": {
				"description": "1500_legends_limia__d",
				"type": "integer"
			}
		},
		"required": [
			"bestAvailable",
			"limitedAvailability"
		],
		"title": "1500_legends__t",
		"type": "object"
	},
	"localization": {
		"_internalName": "Localization Overrides",
		"_internalDescription": "A way to alter the standard localization settings",
		"$id": "1500_localization",
		"description": "1500_locali__d",
		"properties": {
			"dateTime": {
				"_internalName": "Date and Time",
				"_internalDescription": "Date and Time Localization Overrides",
				"description": "1500_locali_datet__d",
				"properties": {
					"calendarDay": {
						"_internalDescription": "How the day on a calendar is displayed (Default 'd')",
						"_internalName": "Calendar Day",
						"description": "1500_locali_datet_caled__d",
						"title": "1500_locali_datet_caled__t",
						"type": "string"
					},
					"calendarDayHeader": {
						"_internalDescription": "How the day of the week shows on the calendar (Default 'EEE')",
						"_internalName": "Calendar Day Header",
						"description": "1500_locali_datet_calhd__d",
						"title": "1500_locali_datet_calhd__t",
						"type": "string"
					},
					"calendarMonth": {
						"_internalDescription": "How the month picker on a calendar is displayed (Default 'MMM')",
						"_internalName": "Calendar Month",
						"description": "1500_locali_datet_calem__d",
						"title": "1500_locali_datet_calem__t",
						"type": "string"
					},
					"calendarMonthTitle": {
						"_internalDescription": "Title for the month selection in the calendar (e.g. 'MMMM yyyy' for 'January 2023')",
						"_internalName": "Calendar Month Title",
						"description": "1500_locali_datet_calemt__d",
						"title": "1500_locali_datet_calemt__t",
						"type": "string"
					},
					"calendarYearTitle": {
						"_internalDescription": "Title for the year selection in the calendar (e.g. 'yyyy' for '2023')",
						"_internalName": "Calendar Year Title",
						"description": "1500_locali_datet_caleyt__d",
						"title": "1500_locali_datet_caleyt__t",
						"type": "string"
					},
					"fullDate": {
						"_internalDescription": "Format for displaying a full date",
						"_internalName": "Full Date Format",
						"description": "1500_locali_datet_fulld__d",
						"title": "1500_locali_datet_fulld__t",
						"type": "string"
					},
					"longDate": {
						"_internalDescription": "Format for displaying a long date",
						"_internalName": "Long Date Format",
						"description": "1500_locali_datet_longd__d",
						"title": "1500_locali_datet_longd__t",
						"type": "string"
					},
					"medium": {
						"_internalDescription": "Format for displaying a medium date and time",
						"_internalName": "Medium Date and Time Format",
						"description": "1500_locali_datet_medium__d",
						"title": "1500_locali_datet_medium__t",
						"type": "string"
					},
					"mediumDate": {
						"_internalDescription": "Format for displaying a medium date",
						"_internalName": "Medium Date Format",
						"description": "1500_locali_datet_mediumd__d",
						"title": "1500_locali_datet_mediumd__t",
						"type": "string"
					},
					"mediumTime": {
						"_internalDescription": "Format for displaying a medium time",
						"_internalName": "Medium Time Format",
						"description": "1500_locali_datet_mediumt__d",
						"title": "1500_locali_datet_mediumt__t",
						"type": "string"
					},
					"pickerRangeStartShort": {
						"_internalDescription": "Picker Format for displaying the start of a date range (Entire Range contained within a single month - Default 'MMM d')",
						"_internalName": "Picker Range Start Short Format",
						"description": "1500_locali_datet_pickrs__d",
						"title": "1500_locali_datet_pickrs__t",
						"type": "string"
					},
					"pickerRangeStartMedium": {
						"_internalDescription": "Picker Format for displaying the start of a date range (Entire Range contained within a single year - Default 'MMM d')",
						"_internalName": "Picker Range Start Medium Format",
						"description": "1500_locali_datet_pickrm__d",
						"title": "1500_locali_datet_pickrm__t",
						"type": "string"
					},
					"pickerRangeStartLong": {
						"_internalDescription": "Picker Format for displaying the start of a date range (Range spans multiple years - Default 'MMM d, yyyy')",
						"_internalName": "Picker Range Start Long Format",
						"description": "1500_locali_datet_pickrl__d",
						"title": "1500_locali_datet_pickrl__t",
						"type": "string"
					},
					"pickerRangeEndShort": {
						"_internalDescription": "Picker Format for displaying the end of a date range (Entire Range contained within a single month - Default 'd, yyyy')",
						"_internalName": "Picker Range End Short Format",
						"description": "1500_locali_datet_pickres__d",
						"title": "1500_locali_datet_pickres__t",
						"type": "string"
					},
					"pickerRangeEndMedium": {
						"_internalDescription": "Picker Format for displaying the end of a date range (Entire Range contained within a single year - Default 'MMM d, yyyy')",
						"_internalName": "Picker Range End Medium Format",
						"description": "1500_locali_datet_pickrem__d",
						"title": "1500_locali_datet_pickrem__t",
						"type": "string"
					},
					"pickerRangeEndLong": {
						"_internalDescription": "Picker Format for displaying the end of a date range (Range spans multiple years - Default 'MMM d, yyyy')",
						"_internalName": "Picker Range End Long Format",
						"description": "1500_locali_datet_pickrel__d",
						"title": "1500_locali_datet_pickrel__t",
						"type": "string"
					},
					"pickerSelection": {
						"_internalDescription": "Picker Format for displaying a single selected date (Default 'EEEE, MMM d, y')",
						"_internalName": "Picker Selection Format",
						"description": "1500_locali_datet_picks__d",
						"title": "1500_locali_datet_picks__t",
						"type": "string"
					},
					"short": {
						"_internalDescription": "Format for displaying a short date and time",
						"_internalName": "Short Date and Time Format",
						"description": "1500_locali_datet_short__d",
						"title": "1500_locali_datet_short__t",
						"type": "string"
					},
					"shortDate": {
						"_internalDescription": "Format for displaying a short date",
						"_internalName": "Short Date Format",
						"description": "1500_locali_datet_shortd__d",
						"title": "1500_locali_datet_shortd__t",
						"type": "string"
					},
					"shortTime": {
						"_internalDescription": "Format for displaying a short time",
						"_internalName": "Short Time Format",
						"description": "1500_locali_datet_shortt__d",
						"title": "1500_locali_datet_shortt__t",
						"type": "string"
					}
				},
				"title": "1500_locali_datet__t",
				"type": "object"
			}
		},
		"title": "1500_locali__t",
		"type": "object"
	},
	"master_merchant_id": {
		"_internalName": "Master Merchant ID",
		"$id": "1500_master_merchant_id",
		"description": "1500_mastmi__d",
		"title": "1500_mastmi__t",
		"type": "number"
	},
	"master_pass": {
		"_internalName": "MasterPass",
		"$id": "1500_master_pass",
		"description": "1500_mastp__d",
		"properties": {
			"allowed_card_types": {
				"description": "1500_mastp_alloct__d",
				"type": "array"
			},
			"footer_image_icon": {
				"description": "1500_mastp_footii__d",
				"type": "string"
			},
			"footer_link": {
				"description": "1500_mastp_footl__d",
				"type": "string"
			},
			"footer_verbiage": {
				"description": "1500_mastp_footv__d",
				"type": "string"
			},
			"master_pass_pre_script": {
				"description": "1500_mastp_mastpps__d",
				"type": "string"
			},
			"master_pass_script": {
				"description": "1500_mastp_mastps__d",
				"type": "string"
			},
			"merchant_checkout_id": {
				"description": "1500_mastp_mercci__d",
				"type": "string"
			},
			"mobile_payment_method_icon": {
				"description": "1500_mastp_mobipmi__d",
				"type": "string"
			},
			"order_review_icon": {
				"description": "1500_mastp_orderi__d",
				"type": "string"
			},
			"payment_method_icon": {
				"description": "1500_mastp_paymmi__d",
				"type": "string"
			},
			"payment_method_shortcut_icon": {
				"description": "1500_mastp_paymmsi__d",
				"type": "string"
			},
			"show_checkout_shortcut": {
				"description": "1500_mastp_showcs__d",
				"enum": [
					false,
					true
				],
				"type": "boolean"
			},
			"show_info_in_footer": {
				"description": "1500_mastp_showiif__d",
				"enum": [
					false,
					true
				],
				"type": "boolean"
			}
		},
		"required": [
			"allowed_card_types",
			"master_pass_pre_script",
			"master_pass_script",
			"merchant_checkout_id",
			"mobile_payment_method_icon",
			"payment_method_icon",
			"payment_method_shortcut_icon"
		],
		"title": "1500_mastp__t",
		"type": "object"
	},
	"matrix_config": {
		"_internalName": "Matrix",
		"$id": "1500_matrix_config",
		"description": "1500_matrc__d",
		"properties": {
			"columns": {
				"description": "1500_matrc_colu__d",
				"items": {
					"icon": {
						"description": "1500_matrc_colu_icon__d",
						"type": "string"
					},
					"timeblock_name": {
						"description": "1500_matrc_colu_timen__d",
						"type": "string"
					}
				},
				"title": "1500_matrc_colu__t",
				"type": "array"
			},
			"upsell": {
				"description": "1500_matrc_upse__d",
				"properties": {
					"image": {
						"description": "1500_matrc_upse_imag__d",
						"type": "string"
					},
					"include": {
						"description": "1500_matrc_upse_incl__d",
						"type": "boolean"
					}
				},
				"title": "1500_matrc_upse__t",
				"type": "object"
			}
		},
		"title": "1500_matrc__t",
		"type": "object"
	},
	"matrix_time_interval": {
		"_internalName": "Matrix Time Interval",
		"$id": "1500_matrix_time_interval",
		"description": "1500_matrti__d",
		"properties": {
			"1": {
				"description": "1500_matrti_1__d",
				"type": "integer"
			},
			"2": {
				"description": "1500_matrti_2__d",
				"type": "integer"
			},
			"3": {
				"description": "1500_matrti_3__d",
				"type": "integer"
			}
		},
		"title": "1500_matrti__t",
		"type": "object"
	},
	"membership_upgrade": {
		"_internalName": "Membership Upgrade",
		"$id": "1500_membership_upgrade",
		"description": "1500_membu__d",
		"properties": {
			"cart_view_legacy_calculations": {
				"default": false,
				"description": "1500_membu_cartvlc__d",
				"enum": [
					false,
					true
				],
				"type": "boolean"
			},
			"cart_view_upgrade_message": {
				"default": true,
				"description": "1500_membu_cartvum__d",
				"enum": [
					false,
					true
				],
				"type": "boolean"
			}
		},
		"title": "1500_membu__t",
		"type": "object"
	},
	"membership_wizard": {
		"_internalName": "Memberships Configuration",
		"$id": "1500_membership_wizard",
		"description": "1500_membw__d",
		"properties": {
			"giftKeyword": {
				"description": "1500_membw_giftk__d",
				"type": "string"
			},
			"imageFileNames": {
				"description": "1500_membw_imagfn__d",
				"properties": {
					"gift": {
						"description": "1500_membw_imagfn_gift__d",
						"type": "string"
					},
					"new": {
						"description": "1500_membw_imagfn_new__d",
						"type": "string"
					},
					"renewal": {
						"description": "1500_membw_imagfn_rene__d",
						"type": "string"
					}
				},
				"title": "1500_membw_imagfn__t",
				"type": "object"
			},
			"maxNamedAdults": {
				"description": "1500_membw_maxna__d",
				"type": "number"
			},
			"maxNumChildren": {
				"description": "1500_membw_maxnc__d",
				"type": "number"
			}
		},
		"required": [
			"giftKeyword",
			"imageFileNames",
			"maxNamedAdults"
		],
		"title": "1500_membw__t",
		"type": "object"
	},
	"merchantPreferredCardMappings": {
		"_internalName": "Merchant Preferred Card Mappings",
		"$id": "1500_merchant_preferred_card_mappings",
		"description": "1500_mpcm__d",
		"patternProperties": {
			"^\\d+$": {
				"type": "string"
			}
		},
		"title": "1500_mpcm__t",
		"type": "object"
	},
	"mobile_ticket_options": {
		"_internalName": "Mobile Ticket Options",
		"$id": "1500_mobile_ticket_options",
		"description": "1500_mobito__d",
		"properties": {
			"bar_code_option": {
				"description": "1500_mobito_barco__d",
				"properties": {
					"barcode_override": {
						"description": "1500_mobito_barco_barcoo__d",
						"pattern": "order_id",
						"type": "string"
					},
					"extra_view_order_data_on_ticket": {
						"description": "1500_mobito_barco_extrvodot__d",
						"properties": {
							"attribute_name": {
								"description": "1500_mobito_barco_extrvodot_attrn__d",
								"type": "string"
							},
							"attribute_title_locale": {
								"description": "1500_mobito_barco_extrvodot_attrtl__d",
								"type": "string"
							}
						},
						"title": "1500_mobito_barco_extrvodot__t",
						"type": "object"
					},
					"prefix": {
						"description": "1500_mobito_barco_pref__d",
						"type": "string"
					}
				},
				"title": "1500_mobito_barco__t",
				"type": "object"
			},
			"date_format": {
				"_example": "EEE, d MMM y",
				"_internalDescription": "Date Format to display in header of mobile ticket",
				"_internalName": "Mobile Ticket Date Format",
				"description": "1500_mobito_datef__d",
				"title": "1500_mobito_datef__d",
				"type": "string"
			},
			"receipt_ticket_options": {
				"description": "1500_mobito_receto__d",
				"properties": {
					"receipt_code_attribute_mapping": {
						"description": "1500_mobito_receto_rececam__d",
						"type": "string"
					},
					"receipt_code_locale": {
						"description": "1500_mobito_receto_rececl__d",
						"type": "string"
					}
				},
				"title": "1500_mobito_receto__t",
				"type": "object"
			}
		},
		"title": "1500_mobito__t",
		"type": "object"
	},
	"modal_suppression": {
		"_internalName": "Modal Suppression Config",
		"$id": "1500_modal_suppression",
		"description": "1500_modas__d",
		"items": {
			"type": "string"
		},
		"title": "1500_modas__t",
		"type": "array"
	},
	"one_risk": {
		"_internalName": "1Risk Configuration",
		"$id": "1500_one_risk",
		"description": "1500_oner__d",
		"properties": {
			"beforePurchase": {
				"description": "1500_oner_befp__d",
				"type": "boolean"
			},
			"disableOneRiskJwtEndpoint": {
				"default": false,
				"description": "1500_oner_djwt__d",
				"type": "boolean"
			},
			"jwtKey": {
				"description": "1500_oner_jwtk__d",
				"type": "string"
			},
			"url": {
				"description": "1500_oner_url__d",
				"type": "string"
			},
			"useNewIntegration": {
				"_internalDescription": "Uses the new 1Risk integration",
				"_internalName": "Use New 1Risk Integration",
				"description": "1500_oner_useni__d",
				"title": "1500_oner_useni__t",
				"type": "boolean"
			}
		},
		"title": "1500_oner__t",
		"type": "object"
	},
	"optins": {
		"$id": "1500_optins",
		"deprecated": true,
		"items": {
			"properties": {
				"checked": {
					"default": false,
					"type": [
						"boolean",
						"integer"
					]
				},
				"section": {
					"default": "CartView",
					"minLength": 1,
					"type": "string"
				},
				"target": {
					"minLength": 1,
					"type": "string"
				}
			},
			"required": [
				"section",
				"target"
			],
			"type": "object"
		},
		"type": "array"
	},
	"order_lookup_overrides": {
		"_internalName": "Order Look Up Config",
		"$id": "1500_order_lookup_overrides",
		"description": "1500_ordelo__d",
		"properties": {
			"order_lookup_date_format": {
				"description": "1500_ordelo_ordeldf__d",
				"type": "string"
			}
		},
		"title": "1500_ordelo__t",
		"type": "object"
	},
	"package_comparison": {
		"_internalName": "Package Comparison Module",
		"$id": "1500_package_comparison",
		"definitions": {
			"comparison_config": {
				"description": "1500_packc_d_compc__d",
				"properties": {
					"additional_offering": {
						"description": "1500_packc_d_compc_addo__d",
						"properties": {
							"action_on_click": {
								"description": "1500_packc_d_compc_addo_actioc__d",
								"enum": [
									"routeToKeyword",
									"swapSubsequentFlowSteps"
								],
								"type": "string"
							},
							"action_params": {
								"description": "1500_packc_d_compc_addo_actip__d",
								"items": {
									"type": "string"
								},
								"type": "array"
							},
							"disable_additional_offering_outside_wizard": {
								"description": "1500_packc_d_compc_addo_disaaoow__d",
								"type": "boolean"
							},
							"enabled": {
								"description": "1500_packc_d_compc_addo_enbl__d",
								"type": "boolean"
							},
							"keyword_name": {
								"description": "1500_packc_d_compc_addo_keywn__d",
								"type": "string"
							}
						},
						"title": "1500_packc_d_compc_addo__t",
						"type": "object"
					},
					"images": {
						"description": "1500_packc_d_compc_imag__d",
						"properties": {
							"background": {
								"description": "1500_packc_d_compc_imag_back__d",
								"type": "string"
							},
							"first_column_display": {
								"description": "1500_packc_d_compc_imag_firscd__d",
								"type": "string"
							},
							"banner_mobile": {
								"description": "1500_packc_d_compc_imag_banm__d",
								"type": "string"
							},
							"banner_tablet": {
								"description": "1500_packc_d_compc_imag_bant__d",
								"type": "string"
							},
							"banner_desktop": {
								"description": "1500_packc_d_compc_imag_band__d",
								"type": "string"
							}
						},
						"title": "1500_packc_d_compc_imag__t",
						"type": "object"
					},
					"main_keywords_for_comparison": {
						"description": "1500_packc_d_compc_mainkfc__d",
						"items": {
							"description": "1500_packc_d_compc_mainkfc_i__d",
							"properties": {
								"color": {
									"description": "1500_packc_d_compc_mainkfc_colo__d",
									"type": "string"
								},
								"keyword_name": {
									"description": "1500_packc_d_compc_mainkfc_keywn__d",
									"type": "string"
								},
								"header_text_color": {
									"title": "1500_packc_d_compc_mainkfc_header_text_color__t",
									"description": "1500_packc_d_compc_mainkfc_header_text_color__d",
									"type": "string"
								},
								"order": {
									"description": "1500_packc_d_compc_mainkfc_orde__d",
									"type": "number"
								},
								"custom_icon": {
									"description": "1500_packc_d_compc_imag_cusico__d",
									"type": "string"
								},
								"accent": {
									"title": "1500_packc_d_compc_mainkfc_accent__t",
									"description": "1500_packc_d_compc_mainkfc_accent__d",
									"type": "boolean"
								},
								"accent_label": {
									"title": "1500_packc_d_compc_mainkfc_accentl__t",
									"description": "1500_packc_d_compc_mainkfc_accentl__d",
									"type": "string"
								}
							},
							"required": [
								"keyword_name",
								"order"
							],
							"type": "object"
						},
						"title": "1500_packc_d_compc_mainkfc__t",
						"type": "array"
					},
					"parent_keyword": {
						"description": "1500_packc_d_compc_parek__d",
						"type": "string"
					},
					"price_comparisons": {
						"description": "1500_packc_d_compc_pricc__d",
						"items": {
							"properties": {
								"customer_type": {
									"description": "1500_packc_d_compc_pricc_custt__d",
									"type": "string"
								},
								"full_price_display_customer_type": {
									"description": "1500_packc_d_compc_pricc_offeas__d",
									"type": "string"
								},
								"offered_as_selectable": {
									"description": "1500_packc_d_compc_pricc_offeas__d",
									"enum": [
										false,
										true
									],
									"type": "boolean"
								},
								"savings_customer_type": {
									"description": "1500_packc_d_compc_pricc_savict__d",
									"type": "string"
								}
							},
							"required": [
								"customer_type",
								"full_price_display_customer_type",
								"offered_as_selectable"
							],
							"type": "object"
						},
						"title": "1500_packc_d_compc_pricc__t",
						"type": "array"
					},
					"rewards_and_benefits_mapping": {
						"description": "1500_packc_d_compc_rewaabm__d",
						"items": {
							"description": "1500_packc_d_compc_rewaabm_i__d",
							"properties": {
								"keywords_offered": {
									"description": "1500_packc_d_compc_rewaabm_keywo__d",
									"type": "array"
								},
								"reward_name": {
									"description": "1500_packc_d_compc_rewaabm_rewan__d",
									"type": "string"
								},
								"text_overrides": {
									"description": "1500_packc_d_compc_rewaabm_textov__d",
									"additionalProperties": {
										"type": "string"
									},
									"type": "object"
								}
							},
							"required": [
								"keywords_offered",
								"reward_name"
							],
							"type": "object"
						},
						"title": "1500_packc_d_compc_rewaabm__t",
						"type": "array"
					},
					"use_list_view": {
						"_internalName": "Use Package Comparison List View",
						"_internalDescription": "Denotes whether to use list view for package comparison.",
						"description": "1500_packc_d_compc_uselv__d",
						"type": "boolean",
						"default": false,
						"title": "1500_packc_d_compc_uselv__t"
					}
				},
				"title": "1500_packc_d_compc__t",
				"type": "object"
			}
		},
		"description": "1500_packc__d",
		"properties": {
			"comparisons": {
				"description": "1500_packc_comp__d",
				"items": {
					"$ref": "#/definitions/comparison_config",
					"required": [
						"main_keywords_for_comparison"
					],
					"type": "object"
				},
				"title": "1500_packc_comp__t",
				"type": "array"
			}
		},
		"required": [
			"comparisons"
		],
		"title": "1500_packc__t",
		"type": "object"
	},
	"package_details_customer_type_groups": {
		"_internalName": "Package Details Customer Type Groups",
		"$id": "1500_package_details_customer_type_groups",
		"description": "1500_packdctg__d",
		"items": {
			"properties": {
				"group_id": {
					"description": "1500_packdctg_groui__d",
					"type": "string"
				},
				"group_name": {
					"description": "1500_packdctg_groun__d",
					"type": "string"
				}
			},
			"required": [
				"group_id",
				"group_name"
			],
			"type": "object"
		},
		"title": "1500_packdctg__t",
		"type": "array"
	},
	"package_planner": {
		"_internalDescription": "Configuration related to the Package Planner module",
		"_internalName": "Package Planner Configuration",
		"$id": "1500_package_planner",
		"additionalProperties": false,
		"definitions": {
			"savings_cluster": {
				"_internalDescription": "Configuration for savings",
				"_internalName": "Savings Configuration",
				"properties": {
					"hide": {
						"_internalDescription": "Hides the product summary",
						"_internalName": "Hide Product Summary",
						"type": "boolean"
					},
					"threshold": {
						"_internalDescription": "Threshold for product summary",
						"_internalName": "Threshold",
						"minimum": 0,
						"type": "number"
					},
					"use_threshold_percentage": {
						"_internalDescription": "Use product summary threshold as percentage",
						"_internalName": "Use Threshold As Percentage",
						"type": "boolean"
					}
				},
				"type": "object"
			}
		},
		"description": "1500_pkgp__d",
		"properties": {
			"calendar": {
				"_internalDescription": "Configuration for the calendar",
				"_internalName": "Calendar Configuration",
				"description": "1500_pkgp_calen__d",
				"properties": {
					"accesso_calendar": {
						"_internalDescription": "Configuration for the accesso calendar",
						"_internalName": "Accesso Calendar Configuration",
						"description": "1500_pkgp_calen_acce__d",
						"properties": {
							"limited_threshold": {
								"_internalDescription": "Threshold for limited availability",
								"_internalName": "Limited Threshold",
								"description": "1500_pkgp_calen_acce_limi__d",
								"minimum": 1,
								"title": "1500_pkgp_calen_acce_limi__t",
								"type": "integer"
							},
							"lowest_price_display": {
								"_internalDescription": "Configuration for lowest price display",
								"_internalName": "Lowest Price Display",
								"description": "1500_pkgp_calen_acce_low_pri_dis__d",
								"properties": {
									"low_price_indicator": {
										"_internalDescription": "Display lowest price indicator",
										"_internalName": "Low Price Indicator",
										"description": "1500_pkgp_calen_acce_low_pri_dis_ind__d",
										"title": "1500_pkgp_calen_acce_low_pri_dis_ind__t",
										"type": "boolean"
									}
								},
								"title": "1500_pkgp_calen_acce_low_pri_dis__t",
								"type": "object"
							},
							"range_all_valid": {
								"_internalDescription": "Ranges must have all valid dates within the selected range",
								"_internalName": "Range All Valid",
								"description": "1500_pkgp_calen_acce_rang__d",
								"title": "1500_pkgp_calen_acce_rang__t",
								"type": "boolean"
							}
						},
						"title": "1500_pkgp_calen_acce__t",
						"type": "object"
					},
					"legend": {
						"_internalDescription": "Configuration for the calendar legend",
						"_internalName": "Calendar Legend Configuration",
						"desciption": "1500_pkgp_calen_leg__d",
						"properties": {
							"hide_sold_out": {
								"_internalDescription": "Hides the sold out dates on the calendar",
								"_internalName": "Hide Sold Out",
								"description": "1500_pkgp_calen_leg_hide__d",
								"title": "1500_pkgp_calen_leg_hide__t",
								"type": "boolean"
							}
						},
						"title": "1500_pkgp_calen_leg__t",
						"type": "object"
					},
					"product_summary": {
						"_internalDescription": "Configuration for the product summary",
						"_internalName": "Product Summary Configuration",
						"description": "1500_pkgp_calen_prods__d",
						"properties": {
							"quantity": {
								"_internalDescription": "Configuration for the quantity",
								"_internalName": "Quantity Configuration",
								"description": "1500_pkgp_calen_prods_quan__d",
								"properties": {
									"hide": {
										"_internalDescription": "Hides the quantity",
										"_internalName": "Hide Quantity",
										"description": "1500_pkgp_calen_prods_quan_hide__d",
										"title": "1500_pkgp_calen_prods_quan_hide__t",
										"type": "boolean"
									},
									"threshold": {
										"_internalDescription": "Threshold for quantity",
										"_internalName": "Threshold",
										"description": "1500_pkgp_calen_prods_quan_thre__d",
										"minimum": 0,
										"title": "1500_pkgp_calen_prods_quan_thre__t",
										"type": "number"
									}
								},
								"title": "1500_pkgp_calen_prods_quan__t",
								"type": "object"
							},
							"savings": {
								"$ref": "#/definitions/savings_cluster",
								"description": "1500_pkgp_calen_prods_savi__d",
								"properties": {
									"hide": {
										"description": "1500_pkgp_calen_prods_savi_hide__d",
										"title": "1500_pkgp_calen_prods_savi_hide__t"
									},
									"threshold": {
										"description": "1500_pkgp_calen_prods_savi_thre__d",
										"title": "1500_pkgp_calen_prods_savi_thre__t"
									},
									"use_threshold_percentage": {
										"description": "1500_pkgp_calen_prods_savi_use_thre_per__d",
										"title": "1500_pkgp_calen_prods_savi_use_thre_per__t"
									}
								},
								"title": "1500_pkgp_calen_prods_savi__t"
							},
							"show_fee": {
								"_internalDescription": "Shows the package level fees in the product summary",
								"_internalName": "Show Fees",
								"description": "1500_pkgp_calen_prods_show_fee__d",
								"title": "1500_pkgp_calen_prods_show_fee__t",
								"type": "boolean"
							}
						},
						"title": "1500_pkgp_calen_prods__t",
						"type": "object"
					},
					"totals": {
						"_internalDescription": "Configuration for the totals",
						"_internalName": "Totals Configuration",
						"description": "1500_pkgp_calen_tota__d",
						"properties": {
							"savings": {
								"$ref": "#/definitions/savings_cluster",
								"description": "1500_pkgp_calen_tota_savi__d",
								"properties": {
									"hide": {
										"description": "1500_pkgp_calen_tota_savi_hide__d",
										"title": "1500_pkgp_calen_tota_savi_hide__t"
									},
									"threshold": {
										"description": "1500_pkgp_calen_tota_savi_thre__d",
										"title": "1500_pkgp_calen_tota_savi_thre__t"
									},
									"use_threshold_percentage": {
										"description": "1500_pkgp_calen_tota_savi_use_thre_per__d",
										"title": "1500_pkgp_calen_tota_savi_use_thre_per__t"
									}
								},
								"title": "1500_pkgp_calen_tota_savi__t"
							}
						},
						"title": "1500_pkgp_calen_tota__t",
						"type": "object"
					}
				},
				"title": "1500_pkgp_calen__t",
				"type": "object"
			},
			"selection": {
				"_internalDescription": "Configuration for the guest & package selection pages",
				"_internalName": "Guest & Package Selection Page Configuration",
				"description": "1500_pkgp_selec__d",
				"properties": {
					"banner": {
						"properties": {
							"desktop": {
								"_internalDescription": "The desktop banner image",
								"_internalName": "Desktop Banner Image",
								"description": "1500_pkgp_selec_ban_desk__d",
								"title": "1500_pkgp_selec_ban_desk__t",
								"type": "string"
							},
							"enable": {
								"_internalDescription": "Enables the banner",
								"_internalName": "Enable Banner",
								"description": "1500_pkgp_selec_ban_enab__d",
								"title": "1500_pkgp_selec_ban_enab__t",
								"type": "boolean"
							},
							"mobile": {
								"_internalDescription": "The mobile banner image",
								"_internalName": "Mobile Banner Image",
								"description": "1500_pkgp_selec_ban_mobi__d",
								"title": "1500_pkgp_selec_ban_mobi__t",
								"type": "string"
							}
						}
					},
					"info_bar": {
						"_internalDescription": "Configuration for the info bar",
						"_internalName": "Info Bar Configuration",
						"description": "1500_pkgp_selec_infob__d",
						"properties": {
							"cta_label": {
								"_internalDescription": "The label for the CTA",
								"_internalName": "CTA Label",
								"description": "1500_pkgp_selec_infob_ctal__d",
								"title": "1500_pkgp_selec_infob_ctal__t",
								"type": "string"
							},
							"cta_route": {
								"_internalDescription": "The route for the CTA",
								"_internalName": "CTA Route",
								"description": "1500_pkgp_selec_infob_ctar__d",
								"title": "1500_pkgp_selec_infob_ctar__t",
								"type": "string"
							},
							"description": {
								"_internalDescription": "The description for the info bar",
								"_internalName": "Description",
								"description": "1500_pkgp_selec_infob_desc__d",
								"title": "1500_pkgp_selec_infob_desc__t",
								"type": "string"
							}
						},
						"title": "1500_pkgp_selec_infob__t",
						"type": "object"
					},
					"pricing": {
						"_internalDescription": "Configuration for pricing on the selection pages",
						"_internalName": "Pricing Configuration",
						"description": "1500_pkgp_selec_prici__d",
						"properties": {
							"enable": {
								"_internalDescription": "Enables pricing on the selection pages",
								"_internalName": "Enable Pricing",
								"description": "1500_pkgp_selec_prici_enab__d",
								"title": "1500_pkgp_selec_prici_enab__t",
								"type": "boolean"
							},
							"dynamic": {
								"_internalDescription": "Enables dynamic pricing on the selection pages",
								"_internalName": "Enable Dynamic Pricing",
								"description": "1500_pkgp_selec_prici_dyn__d",
								"title": "1500_pkgp_selec_prici_dyn__t",
								"type": "boolean"
							}
						},
						"title": "1500_pkgp_selec_prici__t",
						"type": "object"
					}
				},
				"title": "1500_pkgp_selec__t",
				"type": "object"
			}
		},
		"title": "1500_pkgp__t",
		"type": "object"
	},
	"package_planner__legacy": {
		"_internalName": "Package Planner Customer Types",
		"$id": "1500_package_planner_legacy",
		"description": "1500_packp__d",
		"properties": {
			"banner_locales": {
				"description": "1500_packp_bannl__d",
				"properties": {
					"buttonLabel": {
						"description": "1500_packp_bannl_buttla__d",
						"type": "string"
					},
					"buttonLink": {
						"description": "1500_packp_bannl_buttli__d",
						"type": "string"
					},
					"description": {
						"description": "1500_packp_bannl_desc__d",
						"type": "string"
					},
					"bannerImageName": {
						"description": "1500_packp_bannl_bannin__d",
						"type": "string"
					}
				},
				"title": "1500_packp_bannl__t",
				"type": "object"
			},
			"disable_sold_out_in_range": {
				"description": "1500_packp_dis_sldoutrange__d",
				"type": "boolean"
			},
			"disable_unavailable_in_range_modal": {
				"description": "1500_packp_dis_uavailrange__d",
				"type": "boolean"
			},
			"dynamic_guest_options_pricing": {
				"title": "1500_packp_dprice__t",
				"description": "1500_packp_dprice__d",
				"type": "boolean"
			},
			"enable_guest_options_pricing": {
				"tiel": "1500_packp_price__t",
				"description": "1500_packp_price__d",
				"type": "boolean"
			},
			"legend": {
				"additionalProperties": false,
				"description": "1500_packp_lege__d",
				"properties": {
					"hide_sold_out": {
						"description": "1500_packp_lege_hideso__d",
						"title": "1500_packp_lege_hideso__t",
						"type": "boolean"
					}
				},
				"title": "1500_packp_lege__t",
				"type": "object"
			},
			"limited_avail": {
				"description": "1500_packp_limia__d",
				"minimum": 1,
				"type": "integer"
			},
			"package_description_string_limit": {
				"description": "1500_packp_packdsl__d",
				"type": "number"
			},
			"product_summary": {
				"_internalDescription": "Configuration for the product summary that accompanies the dynamic pricing calendar",
				"_internalName": "Product Summary configuration",
				"description": "1500_packp_prods__d",
				"definitions": {
					"hideSavings": {
						"_internalDescription": "Hides the savings text",
						"_internalName": "Hide Savings",
						"default": false,
						"description": "1500_packp_prods_hides__d",
						"title": "1500_packp_prods_hides__t",
						"type": "boolean"
					},
					"savingsFormat": {
						"_internalDescription": "How the savings will be displayed",
						"_internalName": "Savings Format",
						"description": "1500_packp_prods_savif__d",
						"enum": [
							"Dollar",
							"Percentage"
						],
						"title": "1500_packp_prods_savif__t",
						"type": "string"
					},
					"savingsThreshold": {
						"_internalDescription": "The minimum amount based upon the Savings Format to display",
						"_internalName": "Savings Threshold",
						"description": "1500_packp_prods_savit__d",
						"minimum": 0,
						"title": "1500_packp_prods_savit__t",
						"type": "number"
					}
				},
				"properties": {
					"summary": {
						"_internalDescription": "The summary section where customer type breakdown is shown",
						"_internalName": "Summary",
						"description": "1500_packp_prods_summ__d",
						"properties": {
							"hideSavings": {
								"$ref": "#/product_summary/definitions/hideSavings"
							},
							"quantityThreshold": {
								"_internalDescription": "The maximum quantity left to display",
								"_internalName": "Quantity Left Threshold",
								"description": "1500_packp_prods_quant__d",
								"minimum": 0,
								"title": "1500_packp_prods_quant__t",
								"type": "number"
							},
							"savingsFormat": {
								"$ref": "#/product_summary/definitions/savingsFormat",
								"default": "Percentage"
							},
							"savingsThreshold": {
								"$ref": "#/product_summary/definitions/savingsThreshold"
							},
							"showQuantity": {
								"_internalDescription": "Shows the quantity remaining text",
								"_internalName": "Show Quantity",
								"default": false,
								"description": "1500_packp_prods_showq__d",
								"title": "1500_packp_prods_showq__t",
								"type": "boolean"
							}
						},
						"title": "1500_packp_prods_summ__t"
					},
					"totals": {
						"_internalDescription": "The totals section where overall information of the breakdown is shown",
						"_internalName": "Totals",
						"description": "1500_packp_prods_tota__d",
						"properties": {
							"hideSavings": {
								"$ref": "#/product_summary/definitions/hideSavings"
							},
							"savingsFormat": {
								"$ref": "#/product_summary/definitions/savingsFormat",
								"default": "Dollar"
							},
							"savingsThreshold": {
								"$ref": "#/product_summary/definitions/savingsThreshold"
							}
						},
						"title": "1500_packp_prods_tota__t"
					}
				},
				"title": "1500_packp_prods__t"
			}
		},
		"title": "1500_packp__t",
		"type": "object"
	},
	"passport_auth": {
		"_internalName": "Passport Access Control Configuration",
		"$id": "1500_accessControl",
		"description": "1500_accessControl__d",
		"properties": {
			"disable": {
				"_internalDescription": "Disable Passport Authentication",
				"_internalName": "Disable",
				"description": "1500_accessControl_disa__d",
				"title": "1500_accessControl_disa__t",
				"type": "boolean"
			},
			"redirect_url": {
				"description": "1500_accessControl_redirect_url__d",
				"title": "1500_accessControl_redirect_url__t",
				"type": "string"
			},
			"auth_token_url": {
				"description": "1500_accessControl_auth_token_url__d",
				"title": "1500_accessControl_auth_token_url__t",
				"type": "string"
			},
			"account-portal-url": {
				"_internalDescription": "Full account portal URL including island, merchantId, and language (e.g. https://accountportal.custom.com/myisland/100/en-US). Returned as-is; callers still append /accesso-login and any tokens. Has no effect on localhost.",
				"_internalName": "Account Portal URL Override",
				"description": "1500_accessControl_account_portal_url__d",
				"title": "1500_accessControl_account_portal_url__t",
				"type": "string"
			}
		},
		"title": "1500_accessControl__t",
		"type": "object"
	},
	"payment_plan_images": {
		"_internalName": "Payment Plan Images",
		"$id": "1500_payment_plan_images",
		"description": "1500_paypli__d",
		"type": "object",
		"properties": {
			"EasyPay": {
				"type": "object",
				"properties": {
					"2": {
						"type": "string",
						"default": ""
					},
					"3": {
						"type": "string",
						"default": ""
					},
					"4": {
						"type": "string",
						"default": ""
					},
					"5": {
						"type": "string",
						"default": ""
					},
					"6": {
						"type": "string",
						"default": ""
					},
					"7": {
						"type": "string",
						"default": ""
					},
					"8": {
						"type": "string",
						"default": ""
					},
					"9": {
						"type": "string",
						"default": ""
					},
					"10": {
						"type": "string",
						"default": ""
					},
					"11": {
						"type": "string",
						"default": ""
					},
					"12": {
						"type": "string",
						"default": ""
					},
					"Mobile2": {
						"type": "string",
						"default": ""
					},
					"Mobile3": {
						"type": "string",
						"default": ""
					},
					"Mobile4": {
						"type": "string",
						"default": ""
					},
					"Mobile5": {
						"type": "string",
						"default": ""
					},
					"Mobile6": {
						"type": "string",
						"default": ""
					},
					"Mobile7": {
						"type": "string",
						"default": ""
					},
					"Mobile8": {
						"type": "string",
						"default": ""
					},
					"Mobile9": {
						"type": "string",
						"default": ""
					},
					"Mobile10": {
						"type": "string",
						"default": ""
					},
					"Mobile11": {
						"type": "string",
						"default": ""
					},
					"Mobile12": {
						"type": "string",
						"default": ""
					},
					"Mobiledefault": {
						"type": "string",
						"default": ""
					},
					"default": {
						"type": "string",
						"default": ""
					}
				}
			},
			"PayLater": {
				"type": "object",
				"properties": {
					"Mobiledefault": {
						"type": "string",
						"default": ""
					},
					"default": {
						"type": "string",
						"default": ""
					}
				}
			},
			"PaymentPlanMultiPayLater": {
				"type": "object",
				"properties": {
					"Mobiledefault": {
						"type": "string",
						"default": ""
					},
					"default": {
						"type": "string",
						"default": ""
					}
				}
			}
		}
	},
	"post_purchase_survey": {
		"_internalName": "Post Purchase Survey",
		"$id": "1500_post_purchase_survey",
		"definitions": {
			"single_post_purchase_survey": {
				"additionalProperties": false,
				"properties": {
					"dynamicParams": {
						"description": "1500_postps_dynap__d",
						"properties": {
							"name": {
								"description": "1500_postps_dynap_name__d",
								"type": "string"
							},
							"value": {
								"description": "1500_postps_dynap_valu__d",
								"type": "string"
							}
						},
						"required": [
							"name",
							"value"
						],
						"title": "1500_postps_dynap__t",
						"type": "array"
					},
					"image": {
						"description": "1500_postps_imag__d",
						"type": "string"
					},
					"localeSuffix": {
						"description": "1500_postps_locas__d",
						"type": "string"
					},
					"surveyURL": {
						"description": "1500_postps_survurl__d",
						"type": "string"
					},
					"ticketCharac": {
						"type": "string"
					}
				},
				"required": [
					"image",
					"surveyURL"
				],
				"type": "object"
			}
		},
		"description": "1500_postps__d",
		"oneOf": [
			{
				"additionalItems": false,
				"items": {
					"$ref": "#/definitions/single_post_purchase_survey"
				},
				"minItems": 1,
				"type": "array"
			},
			{
				"$ref": "#/definitions/single_post_purchase_survey"
			}
		],
		"title": "1500_postps__t",
		"type": [
			"object",
			"array"
		]
	},
	"profile_configurable_fields": {
		"_internalName": "Configurable Fields list for views that tap into the profile functionality'",
		"$id": "1500_profile_configurable_fields",
		"description": "1500_profcf__d",
		"items": {
			"properties": {
				"add_to_cart_charac_name_mapping": {
					"description": "1500_profcf_addtcnm__d",
					"type": "string"
				},
				"column": {
					"description": "1500_profcf_colu__d",
					"type": "number"
				},
				"conversion": {
					"description": "1500_profcf_conv__d",
					"properties": {
						"factor": {
							"description": "1500_profcf_conv_fact__d",
							"type": "integer"
						},
						"operation": {
							"description": "1500_profcf_conv_oper__d",
							"type": "string"
						}
					},
					"type": "object"
				},
				"false_value": {
					"description": "1500_profcf_falsv__d",
					"type": "number"
				},
				"field_type": {
					"description": "1500_profcf_fielt__d",
					"pattern": "stepper|radiobool|checkbox|dropdown|date_dropdown|date_picker|text|label",
					"type": "string"
				},
				"max_value": {
					"description": "1500_profcf_maxv__d",
					"type": "number"
				},
				"min_value": {
					"description": "1500_profcf_minv__d",
					"type": "number"
				},
				"name": {
					"description": "1500_profcf_name__d",
					"type": "string"
				},
				"options_locale_target": {
					"description": "1500_profcf_optilt__d",
					"type": "string"
				},
				"order": {
					"description": "1500_profcf_orde__d",
					"type": "number"
				},
				"package_charac_name_mapping": {
					"description": "1500_profcf_packcnm__d",
					"type": "string"
				},
				"profile_manager_page": {
					"description": "1500_profcf_profmp__d",
					"type": "number"
				},
				"profile_property_mapping_property": {
					"description": "1500_profcf_profpmp__d",
					"type": "string"
				},
				"profile_property_mapping_section": {
					"description": "1500_profcf_profpms__d",
					"type": "string"
				},
				"profile_property_mapping_value": {
					"description": "1500_profcf_profpmv__d",
					"type": "string"
				},
				"required": {
					"description": "1500_profcf_requ__d",
					"enum": [
						false,
						true
					],
					"type": "boolean"
				},
				"size": {
					"description": "1500_profcf_size__d",
					"type": "number"
				},
				"supported_membership_level_mappings": {
					"description": "1500_profcf_suppmlm__d",
					"type": "array"
				},
				"supports_all_membership_levels": {
					"description": "1500_profcf_suppaml__d",
					"enum": [
						false,
						true
					],
					"type": "boolean"
				},
				"truth_value": {
					"description": "1500_profcf_trutv__d",
					"type": "number"
				},
				"validation": {
					"description": "1500_profcf_vali__d",
					"type": "string"
				},
				"value": {
					"description": "1500_profcf_valu__d",
					"type": "string"
				},
				"value_to_trigger_alt_collection": {
					"description": "1500_profcf_valuttac__d",
					"type": "string"
				}
			},
			"required": [
				"field_type",
				"name",
				"value"
			],
			"type": "object"
		},
		"title": "1500_profcf__t",
		"type": "array"
	},
	"profile_login": {
		"_internalName": "Login for Profiles",
		"$id": "1500_profile_login",
		"description": "1500_profl__d",
		"properties": {
			"additional_demographic_fields_display_config": {
				"description": "1500_profl_addidfdc__d",
				"items": {
					"description": "1500_profl_addidfdc_i__d",
					"properties": {
						"field_name": {
							"description": "1500_profl_addidfdc_fieln__d",
							"type": "string"
						},
						"required": {
							"description": "1500_profl_addidfdc_requ__d",
							"enum": [
								false,
								true
							],
							"type": "boolean"
						},
						"should_display": {
							"description": "1500_profl_addidfdc_should__d",
							"enum": [
								false,
								true
							],
							"type": "boolean"
						}
					},
					"type": "object"
				},
				"title": "1500_profl_addidfdc__t",
				"type": "array"
			},
			"combine_login_and_create_account": {
				"description": "1500_profl_comblaca__d",
				"enum": [
					false,
					true
				],
				"type": "boolean"
			},
			"configure_login_option": {
				"description": "1500_profl_comblo__d",
				"enum": [
					false,
					true
				],
				"type": "boolean"
			},
			"configured_actions": {
				"description": "1500_profl_confa__d",
				"items": {
					"description": "1500_profl_confa_i__d",
					"properties": {
						"group": {
							"description": "1500_profl_confa_grou__d",
							"type": "string"
						},
						"key_name": {
							"description": "1500_profl_confa_keyn__d",
							"type": "string"
						},
						"params": {
							"description": "1500_profl_confa_para__d",
							"type": "array"
						}
					},
					"required": [
						"group",
						"key_name",
						"params"
					],
					"type": "object"
				},
				"title": "1500_profl_confa__t",
				"type": "array"
			},
			"create_account_options": {
				"description": "1500_profl_creaao__d",
				"type": "array"
			},
			"custom_input_tabs": {
				"description": "1500_profl_custit__d",
				"items": {
					"description": "1500_profl_custit_i__d",
					"properties": {
						"localePrefix": {
							"description": "1500_profl_custit_locap__d",
							"type": "string"
						},
						"orderId": {
							"description": "1500_profl_custit_ordei__d",
							"type": "integer"
						}
					},
					"type": "object"
				},
				"title": "1500_profl_custit__t",
				"type": "array"
			},
			"disable_create_account_on_global_login": {
				"description": "1500_profl_disacaogl__d",
				"enum": [
					false,
					true
				],
				"type": "boolean"
			},
			"disable_dependents_tab_on_profile": {
				"description": "1500_profl_disadtop__d",
				"enum": [
					false,
					true
				],
				"type": "boolean"
			},
			"disable_email_for_guests_under_age": {
				"description": "1500_profl_disaefgu__d",
				"type": "number"
			},
			"display_forms_on_profile": {
				"description": "1500_profl_dispfop__d",
				"enum": [
					false,
					true
				],
				"type": "boolean"
			},
			"display_linked_guests_menu_on_profile": {
				"description": "1500_profl_displgmop__d",
				"enum": [
					false,
					true
				],
				"type": "boolean"
			},
			"display_profile_image_selection": {
				"description": "1500_profl_disppis__d",
				"enum": [
					false,
					true
				],
				"type": "boolean"
			},
			"events_tab_keyword": {
				"description": "1500_profl_eventk__d",
				"type": "string"
			},
			"fields_for_backend_requests_post_login": {
				"description": "1500_profl_fielfbrpl__d",
				"type": "array"
			},
			"forgot_password_verification_fields": {
				"description": "1500_profl_forgpvf__d",
				"type": "array"
			},
			"isolatePasswordReset": {
				"description": "1500_profl_isolpr__d",
				"enum": [
					true
				],
				"type": "boolean"
			},
			"keyword_to_route_for_expired_member_login": {
				"description": "1500_profl_keywtrfeml__d",
				"type": "string"
			},
			"lookup_existing_member_fields": {
				"description": "1500_profl_lookemf__d",
				"type": "array"
			},
			"member_customer_type_group_id": {
				"description": "1500_profl_membctgi__d",
				"type": "number"
			},
			"new_account_lookup_fields": {
				"description": "1500_profl_newalf__d",
				"type": "array"
			},
			"photo_guide": {
				"_internalDescription": "Configuration for the profile manager photo guide",
				"_internalName": "Photo Guide",
				"description": "1500_profile_photg__d",
				"items": {
					"properties": {
						"label": {
							"_internalDescription": "The label for the photo guide",
							"_internalName": "Label",
							"description": "1500_prof_phto_lbl_d",
							"type": "string"
						},
						"src": {
							"_internalDescription": "The source for the photo guide",
							"_internalName": "Source",
							"description": "1500_prof_phto_src_d",
							"type": "string"
						}
					},
					"required": [
						"label",
						"src"
					],
					"type": "object"
				},
				"title": "1500_prof_phto_t",
				"type": "array"
			},
			"remove_gender_from_profile": {
				"description": "1500_profl_remogfp__d",
				"enum": [
					false,
					true
				],
				"type": "boolean"
			},
			"require_login_for_non_member": {
				"description": "1500_profl_requlfnm__d",
				"enum": [
					false,
					true
				],
				"type": "boolean"
			},
			"reset_password_fields": {
				"description": "1500_profl_resepf__d",
				"items": {
					"description": "1500_profl_resepf_i__d",
					"properties": {
						"capitalize": {
							"description": "1500_profl_resepf_capi__d",
							"type": "boolean"
						},
						"name": {
							"description": "1500_profl_resepf_name__d",
							"type": "string"
						},
						"validationType": {
							"description": "1500_profl_resepf_valit__d",
							"type": "string"
						},
						"width": {
							"description": "1500_profl_resepf_widt__d",
							"type": "string"
						}
					},
					"type": "object"
				},
				"title": "1500_profl_resepf__t",
				"type": "array"
			},
			"reset_password_requirements": {
				"description": "1500_profl_resepr__d",
				"properties": {
					"maxLength": {
						"description": "1500_profl_resepr_maxl__d",
						"type": "number"
					},
					"minLength": {
						"description": "1500_profl_resepr_minl__d",
						"type": "number"
					},
					"requireNumber": {
						"description": "1500_profl_resepr_requn__d",
						"type": "boolean"
					},
					"requireLetter": {
						"description": "1500_profl_resepr_requl__d",
						"type": "boolean"
					},
					"requireSpecialCharacter": {
						"description": "1500_profl_resepr_requsc__d",
						"type": "boolean"
					},
					"requireUpperAndLowercaseAlpha": {
						"description": "1500_profl_resepr_requuala__d",
						"type": "boolean"
					},
					"showAllRequirements": {
						"_internalName": "1500_profl_resepr_showar__t",
						"_internalDescription": "When true, users will see all password requirements while typing in their password.",
						"title": "1500_profl_resepr_showar__t",
						"description": "1500_te2_onbo_passo_showar__d",
						"type": "boolean"
					}
				},
				"title": "1500_profl_resepr__t",
				"type": "object"
			},
			"same_session_password_reset": {
				"description": "1500_profl_samespr__d",
				"enum": [
					true
				],
				"type": "boolean"
			},
			"show_copy_profile_on_billing_shipping": {
				"description": "1500_profl_showcpobs__d",
				"enum": [
					false,
					true
				],
				"type": "boolean"
			},
			"show_flex_guest_info": {
				"description": "1500_profl_showfgi__d",
				"enum": [
					false,
					true
				],
				"type": "boolean"
			},
			"show_guest_column": {
				"description": "1500_profl_showgc__d",
				"enum": [
					false,
					true
				],
				"type": "boolean"
			},
			"show_guest_deterrent": {
				"description": "1500_profl_showgd__d",
				"enum": [
					false,
					true
				],
				"type": "boolean"
			},
			"show_membership_number": {
				"description": "1500_profl_showmn__d",
				"enum": [
					false,
					true
				],
				"type": "boolean"
			},
			"show_modal_on_profile_after_create_account": {
				"description": "1500_profl_showmopaca__d",
				"enum": [
					false,
					true
				],
				"type": "boolean"
			},
			"tab_disable_rules": {
				"description": "1500_profl_tabdr__d",
				"items": {
					"description": "1500_profl_tabdr_i__d",
					"properties": {
						"profile_model_property_name": {
							"description": "1500_profl_tabdr_profmpn__d",
							"type": "string"
						},
						"tab_name": {
							"description": "1500_profl_tabdr_tabn__d",
							"type": "string"
						}
					},
					"type": "object"
				},
				"title": "1500_profl_tabdr__t",
				"type": "array"
			},
			"text_options": {
				"description": "1500_profl_texto__d",
				"type": "array"
			},
			"use_events_tab_on_profile": {
				"description": "1500_profl_useetop__d",
				"enum": [
					false,
					true
				],
				"type": "boolean"
			},
			"use_membership_tab_on_profile": {
				"description": "1500_profl_usemtop__d",
				"enum": [
					false,
					true
				],
				"type": "boolean"
			},
			"use_seasonpass_tab_on_profile": {
				"description": "1500_profl_usestop__d",
				"enum": [
					false,
					true
				],
				"type": "boolean"
			}
		},
		"required": [
			"configure_login_option",
			"create_account_options",
			"fields_for_backend_requests_post_login",
			"forgot_password_verification_fields",
			"lookup_existing_member_fields",
			"new_account_lookup_fields",
			"require_login_for_non_member",
			"reset_password_requirements"
		],
		"title": "1500_profl__t",
		"type": "object"
	},
	"profile_manager": {
		"$id": "1500_profile_manager",
		"_internalName": "Profile Manager Configuration",
		"_internalDescription": "Configuration related to the Profile Manager Module",
		"description": "1500_profm__d",
		"properties": {
			"photo_guide": {
				"_internalDescription": "Configuration for the profile manager photo guide",
				"_internalName": "Photo Guide",
				"description": "1500_profile_photg__d",
				"items": {
					"properties": {
						"label": {
							"_internalDescription": "The label for the photo guide",
							"_internalName": "Label",
							"description": "1500_prof_phto_lbl_d",
							"type": "string"
						},
						"src": {
							"_internalDescription": "The source for the photo guide",
							"_internalName": "Source",
							"description": "1500_prof_phto_src_d",
							"type": "string"
						}
					},
					"required": [
						"label",
						"src"
					],
					"type": "object"
				},
				"title": "1500_prof_phto_t",
				"type": "array"
			}
		}
	},
	"promo_code_override": {
		"_internalName": "Promo Code Override",
		"$id": "1500_promo_code_override",
		"description": "1500_promco__d",
		"properties": {
			"keyword_to_select_on_lookup_success": {
				"description": "1500_promco_keywtsols__d",
				"type": "string"
			},
			"promotional_code_section_override": {
				"description": "1500_promco_promcso__d",
				"type": "string"
			},
			"restrict_to_one_successful_lookup": {
				"description": "1500_promco_resttosl__d",
				"type": "boolean"
			}
		},
		"title": "1500_promco__t",
		"type": "object"
	},
	"quick_checkout": {
		"_internalName": "Quick Checkout",
		"$id": "1500_quick_checkout",
		"title": "1500_qkchkout__t",
		"description": "1500_qkchkout__d",
		"properties": {
			"fields": {
				"title": "1500_qkchkout_fields__t",
				"description": "1500_qkchkout_fields__d",
				"type": "array",
				"items": {
					"properties": {
						"dateCollectionOptions": {
							"title": "1500_qkchkout_dtc__t",
							"description": "1500_qkchkout_dtc__d",
							"type": "object",
							"properties": {
								"display": {
									"title": "1500_qkchkout_dtc_displ__t",
									"description": "1500_qkchkout_dtc_displ__d",
									"type": "string",
									"enum": [
										"dropdown",
										"hybrid"
									]
								},
								"display_month_as_number": {
									"title": "1500_qkchkout_dtc_dispman__t",
									"description": "1500_qkchkout_dtc_dispman__d",
									"type": "boolean"
								},
								"format_string": {
									"title": "1500_qkchkout_dtc_fmtst__t",
									"description": "1500_qkchkout_dtc_fmtst__d",
									"type": "string"
								},
								"is_required": {
									"title": "1500_qkchkout_dtc_req__t",
									"description": "1500_qkchkout_dtc_req__d",
									"type": "boolean"
								},
								"max_age": {
									"title": "1500_qkchkout_dtc_mxa__t",
									"description": "1500_qkchkout_dtc_mxa__d",
									"type": "number"
								},
								"max_year": {
									"title": "1500_qkchkout_dtc_mxy__t",
									"description": "1500_qkchkout_dtc_mxy__d",
									"type": "number"
								},
								"min_age": {
									"title": "1500_qkchkout_dtc_mna__t",
									"description": "1500_qkchkout_dtc_mna__d",
									"type": "number"
								},
								"min_year": {
									"title": "1500_qkchkout_dtc_mny__t",
									"description": "1500_qkchkout_dtc_mny__d",
									"type": "number"
								},
								"model_format": {
									"title": "1500_qkchkout_dtc_mfmt__t",
									"description": "1500_qkchkout_dtc_mfmt__d",
									"type": "string"
								},
								"model_is_format": {
									"title": "1500_qkchkout_dtc_mift__t",
									"description": "1500_qkchkout_dtc_mift__d",
									"type": "boolean"
								},
								"validation_type": {
									"title": "1500_qkchkout_dtc_vdt__t",
									"description": "1500_qkchkout_dtc_vdt__d",
									"type": "string",
									"enum": [
										"birthDate"
									]
								},
								"year_order": {
									"title": "1500_qkchkout_dtc_yo__t",
									"description": "1500_qkchkout_dtc_yo__d",
									"type": "string",
									"enum": [
										"ascending",
										"descending"
									]
								},
								"year_regex": {
									"title": "1500_qkchkout_dtc_yr__t",
									"description": "1500_qkchkout_dtc_yr__d",
									"type": "string"
								}
							}
						},
						"formValidationType": {
							"title": "1500_qkchkout_fmvdtype__t",
							"description": "1500_qkchkout_fmvdtype__d",
							"type": "string",
							"enum": [
								"city",
								"configurablepassword",
								"custom",
								"email",
								"minmaxnumber",
								"name",
								"namewithnumbers",
								"password",
								"phone",
								"phonebycountry",
								"positivenumbers",
								"securitycode",
								"seasonPass",
								"stateProvince",
								"taxid",
								"variablePrice",
								"zip"
							]
						},
						"group": {
							"title": "1500_qkchkout_grp__t",
							"description": "1500_qkchkout_grp__d",
							"type": "number"
						},
						"type": {
							"title": "1500_qkchkout_type__t",
							"description": "1500_qkchkout_type__d",
							"type": "string",
							"enum": [
								"text_input",
								"checkbox_input",
								"drop_down",
								"text_area",
								"city_input",
								"state_province_input",
								"country_input",
								"zip_input",
								"date_collection"
							]
						},
						"inputType": {
							"title": "1500_qkchkout_inpttyp__t",
							"description": "1500_qkchkout_inpttyp__d",
							"type": "string",
							"enum": [
								"text",
								"email",
								"number",
								"password",
								"tel",
								"url"
							]
						},
						"isOptin": {
							"title": "1500_qkchkout_dtc_opt__t",
							"description": "1500_qkchkout_dtc_opt__d",
							"type": "boolean"
						},
						"key": {
							"title": "1500_qkchkout_key__t",
							"description": "1500_qkchkout_key__d",
							"type": "string"
						},
						"label": {
							"title": "1500_qkchkout_lbl__t",
							"description": "1500_qkchkout_lbl__d",
							"type": "string"
						},
						"maxLength": {
							"title": "1500_qkchkout_mxlen__t",
							"description": "1500_qkchkout_mxlen__d",
							"type": "number"
						},
						"order": {
							"title": "1500_qkchkout_ordr__t",
							"description": "1500_qkchkout_ordr__d",
							"type": "number"
						},
						"size": {
							"title": "1500_qkchkout_sz__t",
							"description": "1500_qkchkout_sz__d",
							"type": "string"
						},
						"validationOptions": {
							"title": "1500_qkchkout_valopt__t",
							"description": "1500_qkchkout_valopt__d",
							"type": "object",
							"properties": {
								"max": {
									"title": "1500_qkchkout_valopt_mx__t",
									"description": "1500_qkchkout_valopt_mx__d",
									"type": "number"
								},
								"min": {
									"title": "1500_qkchkout_valopt_min__t",
									"description": "1500_qkchkout_valopt_min__d",
									"type": "number"
								}
							}
						},
						"disableRequired": {
							"title": "1500_qkchkout_dsreq__t",
							"description": "1500_qkchkout_dsreq__d",
							"type": "boolean"
						}
					},
					"type": "object"
				},
				"required": [
					"key",
					"group",
					"order",
					"label",
					"size",
					"type"
				]
			},
			"layout": {
				"title": "1500_qkchkout_layout__t",
				"description": "1500_qkchkout_layout__d",
				"type": "array",
				"items": {
					"title": "1500_qkchkout_layout_rw__t",
					"description": "1500_qkchkout_layout_rw__d",
					"type": "array",
					"items": {
						"title": "1500_qkchkout_layout_grp__t",
						"description": "1500_qkchkout_layout_grp__d",
						"type": "object",
						"properties": {
							"columnSize": {
								"title": "1500_qkchkout_layout_clm__t",
								"description": "1500_qkchkout_layout_clm__d",
								"type": "number"
							},
							"group": {
								"title": "1500_qkchkout_layout_clmnum__t",
								"description": "1500_qkchkout_layout_clmnum__d",
								"type": "number"
							}
						},
						"require": [
							"columnSize",
							"group"
						]
					}
				}
			}
		},
		"type": "object"
	},
	"recaptcha": {
		"_internalName": "Recaptcha",
		"$id": "1500_recaptcha",
		"description": "1500_reca__d",
		"properties": {
			"secret_key": {
				"description": "1500_reca_secrk__d",
				"type": "string"
			},
			"site_key": {
				"description": "1500_reca_sitek__d",
				"type": "string"
			}
		},
		"required": [
			"secret_key",
			"site_key"
		],
		"title": "1500_reca__t",
		"type": "object"
	},
	"recaptchav3": {
		"_internalName": "Recaptcha V3",
		"$id": "1500_recaptchav3",
		"description": "1500_recav3__d",
		"properties": {
			"enabled": {
				"description": "1500_recav3_ena__d",
				"title": "1500_recav3_ena__t",
				"type": "boolean"
			},
			"key": {
				"description": "1500_recav3_key__d",
				"title": "1500_recav3_key__t",
				"type": "string"
			},
			"enterprise": {
				"description": "1500_recav3_ent__d",
				"title": "1500_recav3_ent__t",
				"type": "boolean"
			}
		},
		"required": [
			"enabled",
			"key"
		],
		"title": "1500_recav3__t",
		"type": "object"
	},
	"recommender_wizard": {
		"_internalName": "Recommender Wizard",
		"$id": "1500_recommender_wizard",
		"definitions": {
			"single_wizard_config": {
				"description": "1500_recow_singwc__d",
				"properties": {
					"customerTypeGroupList": {
						"description": "1500_recow_singwc_custtgl__d",
						"type": "array"
					},
					"defaultCustomerTypeGroupId": {
						"description": "1500_recow_singwc_defactgi__d",
						"type": "string"
					},
					"defaultFlowName": {
						"description": "1500_recow_singwc_defafn__d",
						"type": "string"
					},
					"displayOnlySelectedCTGroups": {
						"description": "1500_recow_singwc_disposcg__d",
						"enum": [
							false,
							true
						],
						"type": "boolean"
					},
					"flowSelector": {
						"description": "1500_recow_singwc_flows__d",
						"type": "object"
					},
					"minimumLoadScreenInterval": {
						"description": "1500_recow_singwc_minilsi__d",
						"type": "number"
					},
					"visitTypeSelectList": {
						"description": "1500_recow_singwc_visitsl__d",
						"type": "array"
					},
					"wizardKeyword": {
						"description": "1500_recow_singwc_wizak__d",
						"type": "string"
					}
				},
				"required": [],
				"title": "1500_recow_singwc__t",
				"type": "object"
			}
		},
		"description": "1500_recow__d",
		"properties": {
			"wizards": {
				"description": "1500_recow_wiza__d",
				"items": {
					"$ref": "#/definitions/single_wizard_config",
					"type": "object"
				},
				"title": "1500_recow_wiza__t",
				"type": "array"
			}
		},
		"required": [
			"wizards"
		],
		"title": "1500_recow__t",
		"type": "object"
	},
	"recommender_wizard_alt_flow_steps": {
		"_internalName": "Steps to swap for alternate flow for each flow that exists in the wizard",
		"$id": "1500_recommender_wizard_alt_flow_steps",
		"description": "1500_recowafs__d",
		"properties": {
			"swappable_next_steps": {
				"description": "1500_recowafs_swapns__d",
				"items": {
					"properties": {
						"loadingScreen": {
							"description": "1500_recowafs_swapns_loads__d",
							"properties": {
								"imageFolder": {
									"description": "1500_recowafs_swapns_loads_imagef__d",
									"type": "string"
								},
								"imageName": {
									"description": "1500_recowafs_swapns_loads_imagen__d",
									"type": "string"
								},
								"locales": {
									"description": "1500_recowafs_swapns_loads_imagel__d",
									"properties": {
										"titleTarget": {
											"description": "1500_recowafs_swapns_loads_imagel_titlet__d",
											"type": "string"
										},
										"labelTarget": {
											"description": "1500_recowafs_swapns_loads_imagel_labelt__d",
											"type": "string"
										}
									},
									"title": "1500_recowafs_swapns_loads_imagel__t",
									"type": "object"
								}
							},
							"title": "1500_recowafs_swapns_loads__t",
							"type": "object"
						},
						"name": {
							"description": "1500_recowafs_swapns_name__d",
							"type": "string"
						},
						"settings": {
							"description": "1500_recowafs_swapns_sett__d",
							"type": "object"
						},
						"stageName": {
							"description": "1500_recowafs_swapns_stagn__d",
							"type": "string"
						},
						"stateName": {
							"description": "1500_recowafs_swapns_statn__d",
							"type": "string"
						}
					},
					"type": "object"
				},
				"title": "1500_recowafs_swapns__t",
				"type": "array"
			}
		},
		"required": [],
		"title": "1500_recowafs__t",
		"type": "object"
	},
	"recommender_wizard_flow": {
		"_internalName": "Flows for each flow that exists in the wizard",
		"$id": "1500_recommender_wizard_flow",
		"description": "1500_recowf__d",
		"properties": {
			"flows": {
				"description": "1500_recowf_flow__d",
				"items": {
					"properties": {
						"keywordMap": {
							"description": "1500_recowf_flow_keym__d",
							"type": "object"
						},
						"name": {
							"description": "1500_recowf_flow_name__d",
							"type": "string"
						},
						"steps": {
							"description": "1500_recowf_flow_step__d",
							"items": {
								"properties": {
									"loadingScreen": {
										"description": "1500_recowf_flow_step_loads__d",
										"properties": {
											"imageFolder": {
												"description": "1500_recowf_flow_step_loads_imagef__d",
												"type": "string"
											},
											"imageName": {
												"description": "1500_recowf_flow_step_loads_imagen__d",
												"type": "string"
											},
											"locales": {
												"description": "1500_recowf_flow_step_loads_imagel__d",
												"properties": {
													"titleTarget": {
														"description": "1500_recowf_flow_step_loads_imagel_titlet__d",
														"type": "string"
													},
													"labelTarget": {
														"description": "1500_recowf_flow_step_loads_imagel_labelt__d",
														"type": "string"
													}
												},
												"title": "1500_recowf_flow_step_loads_imagel__t",
												"type": "object"
											}
										},
										"title": "1500_recowf_flow_step_loads__t",
										"type": "object"
									},
									"name": {
										"description": "1500_recowf_flow_step_name__d",
										"type": "string"
									},
									"settings": {
										"description": "1500_recowf_flow_step_sett__d",
										"type": "object"
									},
									"stageName": {
										"description": "1500_recowf_flow_step_stagn__d",
										"type": "string"
									},
									"stateName": {
										"description": "1500_recowf_flow_step_statn__d",
										"type": "string"
									}
								},
								"type": "object"
							},
							"title": "1500_recowf_flow_step__t",
							"type": "array"
						}
					},
					"required": [
						"name"
					],
					"type": "object"
				},
				"title": "1500_recowf_flow__t",
				"type": "array"
			}
		},
		"required": [],
		"title": "1500_recowf__t",
		"type": "object"
	},
	"reg_ex": {
		"_internalName": "Regular Expressions",
		"$id": "1500_reg_ex",
		"description": "1500_rege__d",
		"properties": {
			"city": {
				"description": "1500_rege_city__d",
				"type": "string"
			},
			"zip": {
				"description": "1500_rege_zip__d",
				"type": "object"
			}
		},
		"title": "1500_rege__t",
		"type": "object"
	},
	"require_country_zip": {
		"$id": "1500_require_country_zip",
		"description": "1500_req_cnty_zip__d",
		"properties": {
			"disable": {
				"description": "1500_req_cnty_zip__dis_d",
				"enum": [
					true
				],
				"title": "1500_req_cnty_zip__dis_t",
				"type": "boolean"
			}
		},
		"title": "1500_req_cnty_zip__t",
		"type": "object"
	},
	"reseller_skip_step": {
		"_internalName": "Skip Checkout Steps for Resellers",
		"$id": "1500_reseller_skip_step",
		"description": "1500_resess__d",
		"items": {
			"properties": {
				"name": {
					"description": "1500_resess_name__d",
					"enum": [
						"affiliate",
						"exchange",
						"pos"
					],
					"type": "string"
				},
				"value": {
					"description": "1500_resess_valu__d",
					"enum": [
						"add_to_cart",
						"order_review"
					],
					"type": "array"
				}
			},
			"type": "object"
		},
		"title": "1500_resess__t",
		"type": "array"
	},
	"reservation": {
		"_internalDescription": "Configuration for the reservation service",
		"_internalName": "Reservation Service",
		"$id": "1500_reservation",
		"description": "1500_rese__d",
		"properties": {
			"place_reservation": {
				"_internalDescription": "Configuration that deals with the Place Reservation call",
				"_internalName": "Place Reservation",
				"description": "1500_rese_placr__d",
				"properties": {
					"enable": {
						"_internalDescription": "Enables the Place Reservation call",
						"_internalName": "Enable Place Reservation",
						"description": "1500_rese_placr_enab__d",
						"title": "1500_rese_placr_enab__t",
						"type": "boolean"
					}
				},
				"title": "1500_rese_placr__t",
				"type": "object"
			}
		},
		"title": "1500_rese__t",
		"type": "object"
	},
	"resource_selector": {
		"_internalName": "Resource Selector",
		"$id": "1500_resource_selector",
		"description": "1500_ressel__d",
		"title": "1500_ressel__t",
		"type": "array",
		"items": {
			"required": [
				"keyword"
			],
			"properties": {
				"keyword": {
					"description": "1500_ressel_key__d",
					"title": "1500_ressel_key__t",
					"type": "string"
				},
				"customLink": {
					"description": "1500_ressel_link__d",
					"properties": {
						"text": {
							"title": "1500_ressel_linkt__t",
							"type": "string"
						},
						"url": {
							"title": "1500_ressel_linku__t",
							"type": "string"
						}
					},
					"required": [
						"text",
						"url"
					],
					"title": "1500_ressel_link__t",
					"type": "object"
				},
				"startDate": {
					"_internalDescription": "Configuration that overrides the start date we request for calendar dates",
					"_internalName": "Start Date",
					"description": "1500_ressel_date__d",
					"title": "1500_ressel_date__t",
					"type": "string"
				}
			},
			"type": "object"
		}
	},
	"route_to_new_profile_manager": {
		"_internalName": "Route to New Profile Manager (Unified Design Only)",
		"_internalDescription": "UNIFIED DESIGN ONLY: When true, the user will be redirected to the new profile manager",
		"$id": "1500_route_to_new_profile_manager",
		"description": "1500_routenewpro__d",
		"title": "1500_routenewpro_ena__t",
		"type": "boolean"
	},
	"salesforce": {
		"_internalName": "Salesforce",
		"$id": "1500_salesforce",
		"description": "1500_salesf__d",
		"properties": {
			"beacon_url": {
				"description": "1500_salesf_burl__d",
				"type": "string"
			}
		},
		"required": [
			"beacon_url"
		],
		"title": "1500_salesf__t",
		"type": "object"
	},
	"scheduling_combo": {
		"_internalName": "Scheduling Combo",
		"$id": "1500_scheduling_combo",
		"description": "1500_schec__d",
		"properties": {
			"images": {
				"description": "1500_schec_imag__d",
				"type": "object"
			},
			"locale_post_fix": {
				"description": "1500_schec_locapf__d",
				"type": "string"
			},
			"scheduling_combo_call": {
				"description": "1500_schec_scheduling_service_type__d",
				"enum": [
					"GetKeywordComboCreator",
					"GetMerchantPackageEventDates"
				],
				"title": "1500_schec_scheduling_service_type__t"
			}
		},
		"required": [
			"images"
		],
		"title": "1500_schec__t",
		"type": "object"
	},
	"season_pass": {
		"_internalName": "Season Pass",
		"$id": "1500_season_pass",
		"description": "1500_seasp__d",
		"properties": {
			"disable_copy_to_other_passes": {
				"description": "1500_seasp_disactop__d",
				"type": "string"
			}
		},
		"title": "1500_seasp__t",
		"type": "object"
	},
	"season_pass_select": {
		"_internalName": "Season Pass Module",
		"$id": "1500_season_pass_select",
		"description": "1500_seasps__d",
		"properties": {
			"birth_date_to_date_format": {
				"description": "1500_seasps_demoo_bdaymdl__d",
				"type": "boolean"
			},
			"addon_options": {
				"description": "1500_seasps_addoo__d",
				"properties": {
					"secondary_addons_grouping_image": {
						"description": "1500_seasps_addoo_secoagi__d",
						"type": "string"
					},
					"use_mapping_from_pkg_list": {
						"_internalDescription": "Enables the use of the addon mapping from GetMerchantPackageList",
						"_internalName": "Use Mapping From Package List",
						"description": "1500_seasps_addoo_usemfpl__d",
						"title": "1500_seasps_addoo_usemfpl__t",
						"type": "boolean"
					},
					"addons": {
						"desciption": "1500_seasps_addons__d",
						"items": {
							"description": "1500_seasps_addons_i__d",
							"properties": {
								"addon_group_name": {
									"description": "1500_seasps_addons_group_name__d",
									"type": "string"
								},
								"addon_group_image": {
									"description": "1500_seasps_addons_group_image__d",
									"type": "string"
								},
								"addon_group_header": {
									"description": "1500_seasps_addons_group_header__d",
									"type": "string"
								},
								"addon_group_description": {
									"description": "1500_seasps_addons_group_description__d",
									"type": "string"
								}
							},
							"required": [
								"addon_group_name",
								"addon_group_image",
								"addon_group_header",
								"addon_group_description"
							],
							"type": "object"
						},
						"title": "1500_seasps_addons__t",
						"type": "array"
					},
					"title": "1500_seasps_addoo__t",
					"type": "object"
				}
			},
			"age_restrictions": {
				"description": "1500_seasps_ager__d",
				"items": {
					"description": "1500_seasps_ager_i__d",
					"properties": {
						"customer_type": {
							"description": "1500_seasps_ager_custt__d",
							"type": "string"
						},
						"max_age": {
							"description": "1500_seasps_ager_maxa__d",
							"type": "number"
						},
						"min_age": {
							"description": "1500_seasps_ager_mina__d",
							"type": "number"
						}
					},
					"required": [
						"customer_type",
						"max_age",
						"min_age"
					],
					"type": "object"
				},
				"title": "1500_seasps_ager__t",
				"type": "array"
			},
			"demographics_options": {
				"description": "1500_seasps_demoo__d",
				"properties": {
					"allowed_fields_to_copy_from_first_pass": {
						"description": "1500_seasps_demoo_alloftcfp__d",
						"type": "array"
					},
					"disable_customer_name_charac": {
						"description": "1500_seasps_demoo_discnc__d",
						"enum": [
							true
						],
						"title": "1500_seasps_demoo_discnc__t",
						"type": "boolean"
					},
					"enable_email_verification": {
						"description": "1500_seasps_demoo_enableev__d",
						"enum": [
							true
						],
						"title": "1500_seasps_demoo_enableev__t",
						"type": "boolean"
					},
					"show_copy_email_from_first": {
						"description": "1500_seasps_demoo_showceff__d",
						"enum": [
							false,
							true
						],
						"type": "boolean"
					},
					"show_email_confirmation": {
						"description": "1500_seasps_demoo_showec__d",
						"enum": [
							false,
							true
						],
						"type": "boolean"
					},
					"show_passholder_registration_header": {
						"description": "1500_seasps_demoo_showprh__d",
						"enum": [
							false,
							true
						],
						"type": "boolean"
					}
				},
				"title": "1500_seasps_demoo__t",
				"type": "object"
			},
			"fields_to_lock_on_linked_guests": {
				"description": "1500_seasps_fieltlolg__d",
				"items": {
					"description": "1500_seasps_fieltlolg_i__d",
					"type": "string"
				},
				"title": "1500_seasps_fieltlolg__t",
				"type": "array"
			},
			"image_capture_options": {
				"description": "1500_seasps_imagco__d",
				"properties": {
					"enabled_methods": {
						"description": "1500_seasps_imagco_enam__d",
						"items": {
							"enum": [
								"mail",
								"onsite",
								"upload",
								"webcam"
							],
							"type": "string"
						},
						"type": "array"
					},
					"is_enabled_on_demo_form": {
						"description": "1500_seasps_iseodf__d",
						"enum": [
							false,
							true
						],
						"type": "boolean"
					}
				},
				"title": "1500_seasps_imagco__t",
				"type": "object"
			},
			"include_agreements": {
				"description": "1500_seasps_incla__d",
				"enum": [
					false,
					true
				],
				"type": "boolean"
			},
			"package_characs_pass_through_list": {
				"description": "1500_seasps_packcptl__d",
				"items": {
					"type": "string"
				},
				"type": "array"
			},
			"package_characs_to_add_on_passes": {
				"description": "1500_seasps_packctaop__d",
				"type": "array"
			},
			"photo_guide": {
				"description": "1500_seasps_photg__d",
				"items": {
					"properties": {
						"label": {
							"description": "1500_seasps_photg_labe__d",
							"type": "string"
						},
						"src": {
							"description": "1500_seasps_photg_src__d",
							"type": "string"
						}
					},
					"required": [
						"label",
						"src"
					],
					"type": "object"
				},
				"title": "1500_seasps_photg__t",
				"type": "array"
			},
			"renewal_options": {
				"description": "1500_seasps_reneo__d",
				"properties": {
					"all_fields_required": {
						"description": "1500_seasps_reneo_allfr__d",
						"type": "boolean"
					},
					"characs_to_add_if_renewal": {
						"description": "1500_seasps_reneo_chartair__d",
						"items": {
							"description": "1500_seasps_reneo_chartair_i__d",
							"properties": {
								"charac_name": {
									"description": "1500_seasps_reneo_chartair_charn__d",
									"type": "string"
								},
								"value": {
									"description": "1500_seasps_reneo_chartair_valu__d",
									"type": "string"
								}
							},
							"type": "object"
						},
						"title": "1500_seasps_reneo_chartair__t",
						"type": "array"
					},
					"choose_renewal_on_offer_renewal_option_screen": {
						"description": "1500_seasps_reneo_choorooros__d",
						"enum": [
							false,
							true
						],
						"type": "boolean"
					},
					"disable_image_capture": {
						"description": "1500_seasps_reneo_disaic__d",
						"type": "boolean"
					},
					"lookup_fields": {
						"description": "1500_seasps_reneo_lookf__d",
						"items": {
							"description": "1500_seasps_reneo_lookf__d",
							"properties": {
								"option_field_name": {
									"description": "1500_seasps_reneo_lookf_optifn__d",
									"type": "string"
								},
								"option_field_validation_type": {
									"description": "1500_seasps_reneo_lookf_optifvt__d",
									"type": "string"
								},
								"order": {
									"description": "1500_seasps_reneo_lookf_orde__d",
									"type": "number"
								}
							},
							"type": "object"
						},
						"title": "1500_seasps_reneo_lookf__t",
						"type": "array"
					},
					"renewal_lookup_service_call": {
						"description": "1500_seasps_reneo_renelsc__d",
						"type": "string"
					},
					"fields_to_lock_on_renewal": {
						"description": "1500_seasps_reneo_fieltlor__d",
						"type": "array"
					}
				},
				"title": "1500_seasps_reneo__t",
				"type": "object"
			},
			"use_profiles_on_season_pass_select": {
				"description": "1500_seasps_useposps__d",
				"enum": [
					false,
					true
				],
				"type": "boolean"
			}
		},
		"required": [
			"demographics_options",
			"image_capture_options",
			"renewal_options"
		],
		"title": "1500_seasps__t",
		"type": "object"
	},
	"shipment_overrides": {
		"_internalName": "Shipment Overrides",
		"$id": "1500_shipment_overrides",
		"description": "1500_shipo__d",
		"properties": {
			"shipment_method": {
				"description": "1500_shipo_shipm__d",
				"type": "string"
			},
			"shipment_override": {
				"description": "1500_shipo_shipo__d",
				"type": "string"
			}
		},
		"title": "1500_shipo__t",
		"type": "array"
	},
	"shipping_disable_rules": {
		"_internalName": "Shipping Disable Rules",
		"$id": "1500_shipping_disable_rules",
		"description": "1500_shipdr__d",
		"properties": {
			"cart_item_charac_name": {
				"description": "1500_shipdr_carticn__d",
				"type": "string"
			},
			"cart_item_charac_value": {
				"description": "1500_shipdr_carticv__d",
				"type": "string"
			},
			"shipping_methods": {
				"description": "1500_shipdr_shipm__d",
				"type": "array"
			}
		},
		"title": "1500_shipdr__t",
		"type": "array"
	},
	"shipping_locale_overrides": {
		"_internalName": "Shippling Locale Overrides",
		"$id": "1500_shipping_locale_overrides",
		"description": "1500_shiplo__d",
		"properties": {
			"overrides": {
				"description": "1500_shiplo_over__d",
				"type": "array"
			},
			"section": {
				"description": "1500_shiplo_sec__d",
				"type": "string"
			}
		},
		"title": "1500_shiplo__t",
		"type": "object"
	},
	"show_contrast_ratio": {
		"$id": "1500_show_contrastratio",
		"description": "1500_contrast__d",
		"title": "1500_contrast__t",
		"type": "boolean"
	},
	"show_menu_icons": {
		"$id": "1500_show_menuicons",
		"description": "1500_show_menuicons__d",
		"title": "1500_show_menuicons__t",
		"type": "boolean",
		"default": true
	},
	"skip_payment_selection": {
		"$id": "1500_skip_pymtselection",
		"title": "1500_skippymt__t",
		"description": "1500_skippymt__d",
		"type": "boolean"
	},
	"sign_up_opt_ins": {
		"_internalName": "Sign Up Opt-Ins",
		"$id": "1500_sign_up_opt_ins",
		"description": "1500_signuoi__d",
		"items": {
			"properties": {
				"acceptance_required": {
					"description": "1500_signuoi_accer__d",
					"maximum": 1,
					"minimum": 1,
					"type": "number"
				},
				"name": {
					"description": "1500_signuoi_name__d",
					"type": "string"
				},
				"value": {
					"description": "1500_signuoi_valu__d",
					"enum": [
						"no",
						"yes"
					],
					"type": "string"
				}
			},
			"required": [
				"name"
			],
			"type": "object"
		},
		"title": "1500_signuoi__t",
		"type": "array"
	},
	"simpleStore": {
		"_internalName": "Simple Store",
		"$id": "1500_simpleStore",
		"description": "1500_simps__d",
		"properties": {
			"authType": {
				"description": "1500_simps_autht__d",
				"type": "string"
			},
			"dateFormat": {
				"description": "1500_simps_datef__d",
				"minLength": 1,
				"type": "string"
			},
			"dateTimeFormat": {
				"description": "1500_simps_datetf__d",
				"minLength": 1,
				"type": "string"
			},
			"hideZeroTotal": {
				"description": "1500_simps_hidezt__d",
				"type": "boolean"
			},
			"paymentActionName": {
				"description": "1500_simps_payman__d",
				"type": "string"
			},
			"shipMethod": {
				"description": "1500_simps_shipm__d",
				"type": "string"
			}
		},
		"required": [
			"authType",
			"shipMethod"
		],
		"title": "1500_simps__t",
		"type": "object"
	},
	"skip_assign_seating": {
		"_internalName": "Skip assign seating",
		"$id": "1500_skip_assign_seating",
		"description": "1500_skipas__d",
		"enum": [
			true
		],
		"title": "1500_skipas__t",
		"type": "boolean"
	},
	"sms_verification": {
		"_internalName": "SMS Verification",
		"$id": "1500_sms_verification",
		"description": "1500_smsv__d",
		"properties": {
			"display_flags": {
				"description": "1500_smsv_dispf__d",
				"enum": [
					false,
					true
				],
				"type": "boolean"
			},
			"enable_sms_verification": {
				"description": "1500_smsv_enabsv__d",
				"enum": [
					false,
					true
				],
				"type": "boolean"
			},
			"module": {
				"description": "1500_smsv_modu__d",
				"items": {
					"type": "string"
				},
				"type": "array"
			},
			"timer": {
				"description": "1500_smsv_time__d",
				"minimum": 0,
				"type": "number"
			},
			"use_enhanced_phone_number": {
				"description": "1500_smsv_useepn__d",
				"enum": [
					false,
					true
				],
				"type": "boolean"
			}
		},
		"title": "1500_smsv__t",
		"type": "object"
	},
	"snap_calendar": {
		"_internalName": "Snap Calendar Configs",
		"$id": "1500_snapCalendar",
		"description": "1500_snapcalendar__d",
		"items": {
			"properties": {
				"description": "1500_snapcalendar_desc_dpbs__d",
				"keyword": {
					"description": "1500_snapcalendar_desc_kw__d",
					"title": "1500_snapcalendar_desc_kw__t",
					"type": "string"
				},
				"configs": {
					"properties": {
						"defaultTab": {
							"description": "1500_snapcalendar_desc_ds__d",
							"enum": [
								"All Products",
								"Choose Date"
							],
							"title": "1500_snapcalendar_desc_ds__t",
							"type": "string"
						},
						"desktop_banner_image": {
							"description": "1500_snapcalendar_desc_dbi__d",
							"title": "1500_snapcalendar_desc_dbi__t",
							"type": "string"
						},
						"disable_preselected_date": {
							"description": "1500_snapcalendar_desc_spd__d",
							"title": "1500_snapcalendar_desc_spd__t",
							"type": "boolean"
						},
						"hide_date_picker": {
							"description": "1500_snapcalendar_desc_hdp__d",
							"title": "1500_snapcalendar_desc_hdp__t",
							"type": "boolean",
							"default": false
						},
						"mobile_banner_image": {
							"description": "1500_snapcalendar_desc_mbi__d",
							"title": "1500_snapcalendar_desc_mbi__t",
							"type": "string"
						},
						"show_dual_month": {
							"description": "1500_snapcalendar_desc_sdm__d",
							"title": "1500_snapcalendar_desc_sdm__t",
							"type": "boolean"
						},
						"use_2025_version": {
							"description": "1500_snapcalendar_desc_2v__d",
							"title": "1500_snapcalendar_desc_2v__t",
							"type": "boolean"
						}
					},
					"description": "1500_snapcalendar_desc_c__d",
					"title": "1500_snapcalendar_desc_c__t",
					"type": "object"
				}
			},
			"type": "object"
		},
		"title": "1500_snapcalendar__t",
		"type": "array"
	},
	"social_media": {
		"_internalName": "Social Media Configuration",
		"$id": "1500_social_media",
		"definitions": {
			"fb_social_media_disabled": {
				"description": "1500_socim_fbsmd__d",
				"properties": {
					"enabled": {
						"default": false,
						"description": "1500_socim_fbsmd_enab__d",
						"enum": [
							false
						],
						"format": "hidden",
						"type": "boolean"
					},
					"venue_url": {
						"description": "1500_socim_fbsmd_venuu__d",
						"default": "N/A",
						"pattern": "^N/A$",
						"type": "string"
					}
				},
				"title": "1500_socim_fbsmd__t",
				"type": "object"
			},
			"fb_social_media_enabled": {
				"description": "1500_socim_fbsme__d",
				"properties": {
					"enabled": {
						"default": true,
						"description": "1500_socim_fbsme_enab__d",
						"enum": [
							true
						],
						"type": "boolean"
					},
					"venue_url": {
						"description": "1500_socim_fbsme_venuu__d",
						"format": "url",
						"type": "string"
					}
				},
				"title": "1500_socim_fbsme__t",
				"type": "object"
			},
			"twitter_social_media_disabled": {
				"description": "1500_socim_twitsmd__d",
				"properties": {
					"enabled": {
						"default": false,
						"description": "1500_socim_twitsmd_enab__d",
						"enum": [
							false
						],
						"format": "hidden",
						"type": "boolean"
					},
					"message": {
						"default": "N/A",
						"description": "1500_socim_twitsmd_mess__d",
						"maxLength": 140,
						"pattern": "^N/A$",
						"type": "string"
					}
				},
				"title": "1500_socim_twitsmd__t",
				"type": "object"
			},
			"twitter_social_media_enabled": {
				"description": "1500_socim_twitsme__d",
				"properties": {
					"enabled": {
						"default": true,
						"description": "1500_socim_twitsme_enab__d",
						"enum": [
							true
						],
						"type": "boolean"
					},
					"message": {
						"description": "1500_socim_twitsme_mess__d",
						"maxLength": 140,
						"type": "string"
					}
				},
				"title": "1500_socim_twitsme__t",
				"type": "object"
			}
		},
		"description": "1500_socim__d",
		"properties": {
			"facebook": {
				"description": "1500_socim_face__d",
				"oneOf": [
					{
						"$ref": "#/definitions/fb_social_media_disabled"
					},
					{
						"$ref": "#/definitions/fb_social_media_enabled"
					}
				],
				"title": "1500_socim_face__t",
				"type": "object"
			},
			"twitter": {
				"description": "1500_socim_twit__d",
				"oneOf": [
					{
						"$ref": "#/definitions/twitter_social_media_disabled"
					},
					{
						"$ref": "#/definitions/twitter_social_media_enabled"
					}
				],
				"title": "1500_socim_twit__t",
				"type": "object"
			}
		},
		"required": [
			"facebook",
			"twitter"
		],
		"title": "1500_socim__t",
		"type": "object"
	},
	"sportal": {
		"_internalName": "Sportal Configuration",
		"$id": "1500_sportal",
		"description": "1500_spor__d",
		"properties": {
			"ad_image": {
				"description": "1500_spor_adi__d",
				"type": "string"
			},
			"add_on_images": {
				"description": "1500_spor_addoi__d",
				"items": {
					"properties": {
						"source": {
							"description": "1500_spor_addoi_sour__d",
							"type": "string"
						},
						"spar_renewal_code_id": {
							"description": "1500_spor_addoi_sparrci__d",
							"type": "string"
						}
					},
					"type": "object"
				},
				"title": "1500_spor_addoi__t",
				"type": "array"
			},
			"auto_renewal_image": {
				"description": "1500_spor_autori__d",
				"type": "string"
			},
			"options_request_year": {
				"description": "1500_spor_optiry__d",
				"type": "string"
			},
			"package_comparison_modal": {
				"description": "1500_spor_packcm__d",
				"properties": {
					"form_names": {
						"description": "1500_spor_packcm_formn__d",
						"items": {
							"description": "1500_spor_packcm_formn_i__d",
							"properties": {
								"form_type": {
									"description": "1500_spor_packcm_formn_formt__d",
									"type": "string"
								},
								"name": {
									"description": "1500_spor_packcm_formn_name__d",
									"type": "string"
								}
							},
							"required": [
								"form_type",
								"name"
							],
							"type": "object"
						},
						"title": "1500_spor_packcm_formn__t",
						"type": "array"
					},
					"main_keywords_for_comparison": {
						"description": "1500_spor_packcm_mainkfc__d",
						"items": {
							"description": "1500_spor_packcm_mainkfc_i__d",
							"properties": {
								"color": {
									"description": "1500_spor_packcm_mainkfc_colo__d",
									"type": "string"
								},
								"keyword_name": {
									"description": "1500_spor_packcm_mainkfc_keyw__d",
									"type": "string"
								},
								"order": {
									"description": "1500_spor_packcm_mainkfc_orde__d",
									"type": "number"
								}
							},
							"required": [
								"keyword_name",
								"order"
							],
							"type": "object"
						},
						"title": "1500_spor_packcm_mainkfc__t",
						"type": "array"
					},
					"payment_portal": {
						"description": "1500_spor_packcm_paymp__d",
						"type": "string"
					},
					"rewards_and_benefits_mapping": {
						"description": "1500_spor_packcm_rewaabm__d",
						"items": {
							"description": "1500_spor_packcm_rewaabm_i__d",
							"properties": {
								"keywords_offered": {
									"description": "1500_spor_packcm_rewaabm_keywo__d",
									"type": "string"
								},
								"reward_name": {
									"description": "1500_spor_packcm_rewaabm_rewan__d",
									"type": "string"
								}
							},
							"required": [
								"keywords_offered",
								"reward_name"
							],
							"type": "object"
						},
						"title": "1500_spor_packcm_rewaabm__t",
						"type": "array"
					}
				},
				"title": "1500_spor_packcm__t",
				"type": "object"
			},
			"verification_fields": {
				"description": "1500_spor_packcm_verif__d",
				"items": {
					"properties": {
						"name": {
							"description": "1500_spor_packcm_verif_name__d",
							"type": "string"
						},
						"validationPattern": {
							"description": "1500_spor_packcm_verif_valip__d",
							"type": "string"
						},
						"validationType": {
							"description": "1500_spor_packcm_verif_valit__d",
							"type": "string"
						},
						"width": {
							"description": "1500_spor_packcm_verif_widt__d",
							"type": "number"
						}
					},
					"type": "object"
				},
				"title": "1500_spor_packcm_verif__t",
				"type": "array"
			}
		},
		"required": [
			"verification_fields"
		],
		"title": "1500_spor__t",
		"type": "object"
	},
	"stored_payments_cvv_capture": {
		"_internalName": "Enable CVV Capture",
		"$id": "1500_stored_payments_cvv_capture",
		"description": "1500_storpcc__d",
		"enum": [
			true
		],
		"title": "1500_storpcc__t",
		"type": "boolean"
	},
	"stored_payments_max_cards": {
		"_internalName": "Stored Payments max cards",
		"$id": "1500_stored_payments_max_cards",
		"description": "1500_storpmc__d",
		"title": "1500_storpmc__t",
		"type": "number"
	},
	"stored_value_card": {
		"_internalName": "Stored Value Card Configuration",
		"$id": "1500_stored_value_card",
		"description": "1500_storvc__d",
		"properties": {
			"activatePaymentProvider": {
				"description": "1500_storvc_actipp__d",
				"enum": [
					false,
					true
				],
				"type": "boolean"
			},
			"cardValidationPattern": {
				"description": "1500_storvc_cardvp__d",
				"type": "string"
			},
			"displayPinEntryField": {
				"description": "1500_storvc_disppef__d",
				"enum": [
					false,
					true
				],
				"type": "boolean"
			},
			"doSecurityCheck": {
				"description": "1500_storvc_dosc__d",
				"enum": [
					false,
					true
				],
				"type": "boolean"
			},
			"hideBalance": {
				"description": "1500_storvc_hideb__d",
				"enum": [
					false,
					true
				],
				"type": "boolean"
			},
			"images": {
				"_internalDescription": "Images for Gift Card check balance and reload screens",
				"description": "1500_storvc_img__d",
				"properties": {
					"desktop": {
						"description": "1500_storvc_img_dsk__d",
						"type": "string"
					},
					"mobile": {
						"description": "1500_storvc_img_mob__d",
						"type": "string"
					}
				},
				"title": "1500_storvc_img__t",
				"type": "object"
			},
			"maxPartialPaymentCount": {
				"description": "1500_storvc_maxppc__d",
				"type": "number"
			},
			"optionalCreditCardView": {
				"description": "1500_storvc_opticcv__d",
				"enum": [
					false,
					true
				],
				"type": "boolean"
			},
			"pinValidationPattern": {
				"description": "1500_storvc_pinvp__d",
				"type": "string"
			},
			"reloadAmounts": {
				"_internalDescription": "Preset reload amounts for Gift Card reload screen",
				"description": "1500_storvc_rla__d",
				"items": {
					"properties": {
						"amount": {
							"description": "1500_storvc_rla_amt__d",
							"type": "number"
						}
					},
					"required": [
						"amount"
					],
					"type": "object"
				},
				"maxItems": 3,
				"title": "1500_storvc_rla__t",
				"type": "array"
			},
			"requirePinEntryField": {
				"description": "1500_storvc_requpef__d",
				"enum": [
					false,
					true
				],
				"type": "boolean"
			},
			"showInfoMsg": {
				"description": "1500_storvc_showim__d",
				"enum": [
					false,
					true
				],
				"type": "boolean"
			}
		},
		"required": [
			"activatePaymentProvider"
		],
		"title": "1500_storvc__t",
		"type": "object"
	},
	"te2": {
		"_internalName": "TE2 Settings",
		"$id": "1500_te2",
		"description": "1500_te2__d",
		"properties": {
			"androidAppImageUrl": {
				"description": "1500_te2_andraiu__d",
				"type": "string"
			},
			"androidAppLink": {
				"description": "1500_te2_andral__d",
				"type": "string"
			},
			"customLocaleSuffix": {
				"description": "1500_te2_custls__d",
				"type": "string"
			},
			"genericImageUrl": {
				"description": "1500_te2_geneiu__d",
				"type": "string"
			},
			"iOSAppImageUrl": {
				"description": "1500_te2_iosaiu__d",
				"type": "string"
			},
			"iOSAppLink": {
				"description": "1500_te2_iosal__d",
				"type": "string"
			},
			"onboard": {
				"description": "1500_te2_onbo__d",
				"properties": {
					"imageUrl": {
						"description": "1500_te2_onbo_imagu__d",
						"type": "string"
					},
					"passwordOptions": {
						"description": "1500_te2_onbo_passo__d",
						"properties": {
							"maxLength": {
								"description": "1500_te2_onbo_passo_maxl__d",
								"type": "number"
							},
							"minLength": {
								"description": "1500_te2_onbo_passo_minl__d",
								"type": "number"
							},
							"regEx": {
								"description": "1500_te2_onbo_passo_rege__d",
								"type": "string"
							},
							"requireNumber": {
								"description": "1500_te2_onbo_passo_requn__d",
								"type": "boolean"
							},
							"requireLetter": {
								"description": "1500_te2_onbo_passo_requl__d",
								"type": "boolean"
							},
							"requireSpecialCharacter": {
								"description": "1500_te2_onbo_passo_requsc__d",
								"type": "boolean"
							},
							"requireUpperAndLowercaseAlpha": {
								"description": "1500_te2_onbo_passo_requuala__d",
								"type": "boolean"
							},
							"showAllRequirements": {
								"description": "1500_te2_onbo_passo_showar__d",
								"type": "boolean"
							}
						},
						"title": "1500_te2_onbo_passo__t",
						"type": "object"
					}
				},
				"title": "1500_te2_onbo__t",
				"type": "object"
			}
		},
		"title": "1500_te2__t",
		"type": "object"
	},
	"theme": {
		"$id": "1500_theme",
		"description": "1500_theme__d",
		"properties": {
			"navigation": {
				"enum": [
					"white",
					"primary",
					"secondary",
					"tertiary"
				],
				"default": "tertiary",
				"type": "string"
			},
			"navigationType": {
				"enum": [
					"dark",
					"light"
				],
				"type": "string"
			},
			"spinner": {
				"default": "secondary",
				"enum": [
					"primary",
					"secondary",
					"tertiary"
				],
				"type": "string"
			}
		},
		"title": "1500_theme__t",
		"type": "object"
	},
	"tila": {
		"_internalDescription": "General TILA configurations",
		"_internalName": "TILA",
		"$id": "1500_tila",
		"description": "1500_tila__d",
		"properties": {
			"minimum_payments": {
				"_internalDescription": "Configurations surrounding minimum payments required to trigger TILA",
				"_internalName": "TILA Minimum Payments",
				"description": "1500_tila_minip__d",
				"properties": {
					"form_mapping": {
						"_internalDescription": "Custom TILA form mappings when min payment threshold is met",
						"_internalName": "TILA Form Mappings",
						"description": "1500_tila_minip_formm__d",
						"items": {
							"properties": {
								"original_form_type": {
									"_internalDescription": "The original form type that will be changed to a TILA Form",
									"_internalName": "Original Form Type",
									"description": "1500_tila_minip_formm_origft__d",
									"enum": [
										"BNPL",
										"EASYPAY",
										"MEMBERSHIP"
									],
									"title": "1500_tila_minip_formm_origft__t",
									"type": "string"
								},
								"tila_form_name": {
									"_internalDescription": "The name of the TILA form that will replace the original form type",
									"_internalName": "TILA Form Name",
									"description": "1500_tila_minip_formm_tilafn__d",
									"title": "1500_tila_minip_formm_tilafn__t",
									"type": "string"
								}
							},
							"required": [
								"original_form_type",
								"tila_form_name"
							],
							"type": "object"
						},
						"title": "1500_tila_minip_formm__t",
						"type": "array"
					},
					"threshold": {
						"_internalDescription": "The minimum payment threshold required to trigger the TILA agreement.",
						"_internalName": "Minimum Payment Threshold",
						"description": "1500_tila_minip_thre__d",
						"maximum": 6,
						"minimum": 0,
						"title": "1500_tila_minip_thre__t",
						"type": "number"
					}
				},
				"required": [
					"threshold"
				],
				"title": "1500_tila_minip__t",
				"type": "object"
			}
		},
		"title": "1500_tila__t",
		"type": "object"
	},
	"tila_membership": {
		"_internalName": "TILA for Memberships",
		"$id": "1500_tila_membership",
		"description": "1500_tilam__d",
		"properties": {
			"addAgreementField": {
				"description": "1500_tilam_addaf__d",
				"minLength": "1",
				"type": "string"
			},
			"formName": {
				"description": "1500_tilam_formn__d",
				"minLength": "1",
				"type": "string"
			},
			"showTodaysPayment": {
				"description": "1500_tilam_showtp__d",
				"enum": [
					false,
					true
				],
				"type": "boolean"
			}
		},
		"required": [
			"formName"
		],
		"title": "1500_tilam__t",
		"type": "object"
	},
	"tila_terms_form_name": {
		"_internalDescription": "The assigned name for TILA.",
		"_internalName": "TILA Terms Form Name",
		"$id": "1500_tila_terms_form_name",
		"description": "1500_tilatfn__d",
		"title": "1500_tilatfn__t",
		"type": "string"
	},
	"timeblock_overrides": {
		"_internalName": "Time Block Overrides",
		"$id": "1500_timeblock_overrides",
		"description": "1500_timeo__d",
		"title": "1500_timeo__t",
		"type": "array"
	},
	"trip_select": {
		"_internalName": "Trip Select Customer Types",
		"$id": "1500_trip_select",
		"description": "1500_trips__d",
		"properties": {
			"bg_img": {
				"description": "1500_trips_bgi__d",
				"type": "string"
			},
			"customer_types": {
				"description": "1500_trips_custt__d",
				"items": {
					"properties": {
						"id": {
							"description": "1500_trips_custt_id__d",
							"type": "number"
						},
						"type": {
							"description": "1500_trips_custt_type__d",
							"type": "string"
						}
					},
					"type": "object"
				},
				"required": [
					"id",
					"type"
				],
				"title": "1500_trips_custt__t",
				"type": "array",
				"uniqueItems": true
			},
			"leg_icon": {
				"description": "1500_trips_legi__d",
				"properties": {
					"depart_icon": {
						"description": "1500_trips_legi_depai__d",
						"type": "string"
					},
					"return_icon": {
						"description": "1500_trips_legi_retui__d",
						"type": "string"
					}
				},
				"title": "1500_trips_legi__t",
				"type": "object"
			},
			"limited_avail": {
				"description": "1500_trips_limia__d",
				"pattern": "^[0-9]+%*$",
				"type": "string"
			},
			"start_dates": {
				"description": "1500_trips_stard__d",
				"properties": {
					"items": {
						"description": "1500_trips_stard_item__d",
						"type": "number"
					},
					"type": "array"
				},
				"title": "1500_trips_stard__t",
				"type": "object"
			},
			"title_color": {
				"description": "1500_trips_titlc__d",
				"pattern": "^#(?=(?:.{3}|.{6})$)[0-9A-Za-z]*$",
				"type": "string"
			},
			"trip_type_icon": {
				"description": "1500_trips_tripti__d",
				"properties": {
					"one-way": {
						"description": "1500_trips_tripti_onew__d",
						"type": "string"
					},
					"round-trip": {
						"description": "1500_trips_tripti_rount__d",
						"type": "string"
					}
				},
				"title": "1500_trips_tripti__t",
				"type": "object"
			}
		},
		"required": [
			"customer_types"
		],
		"title": "1500_trips__t",
		"type": "object"
	},
	"use_location": {
		"_internalName": "Geo Location",
		"$id": "1500_use_location",
		"description": "1500_usel__d",
		"properties": {
			"enableMobile": {
				"description": "1500_usel_enabm__d",
				"enum": [
					0,
					1
				],
				"type": "number"
			},
			"enableTablet": {
				"description": "1500_usel_enabt__d",
				"enum": [
					0,
					1
				],
				"type": "number"
			}
		},
		"title": "1500_usel__t",
		"type": "object"
	},
	"unified_package_details_enabled": {
		"_internalName": "Unified Package Details Enabled",
		"_internalDescription": "When true, package detail navigation routes to the new UnifiedPackageDetails page instead of the legacy page. Pair with ?unifiedpackagedetails=true for session-scoped testing without changing this flag.",
		"$id": "1500_upd_enbl",
		"description": "1500_upd_enbl__d",
		"title": "1500_upd_enbl__t",
		"type": "boolean",
		"default": false
	},
	"use_fee_inclusive_pricing": {
		"_internalName": "Use Fee Inclusive Pricing",
		"_internalDescription": "When true, user will see fee inclusive pricing and banner",
		"$id": "1500_use_fee_inclusive_pricing",
		"description": "1500_usef_inc_pri__d",
		"title": "1500_usef_inc_pri__t",
		"type": "boolean"
	},
	"verification_config": {
		"_internalName": "Verification Config",
		"$id": "1500_verification_config",
		"description": "1500_veric__d",
		"properties": {
			"alternative_images": {
				"description": "1500_veric_altei__d",
				"items": {
					"properties": {
						"back_image": {
							"description": "1500_veric_altei_backi__d",
							"type": "string"
						},
						"card_image": {
							"description": "1500_veric_altei_cardi__d",
							"type": "string"
						},
						"group": {
							"description": "1500_veric_altei_grou__d",
							"type": "string"
						},
						"localePrefix": {
							"description": "1500_veric_altei_locap__d",
							"type": "string"
						}
					},
					"type": "object"
				},
				"title": "1500_veric_altei__t",
				"type": "array"
			},
			"barcodeScanner": {
				"_internalDescription": "Barcode Scanner configuration",
				"_internalName": "Barcode Scanner",
				"description": "1500_veric_barc__d",
				"properties": {
					"barcodePattern": {
						"_example": "^[8-9]\\d+$",
						"_internalDescription": "Will only scan in barcodes that match the given pattern",
						"_internalName": "Barcode Pattern",
						"description": "1500_veric_barc_barcp__d",
						"title": "1500_veric_barc_barcp__t",
						"type": "string"
					},
					"disablePattern": {
						"_internalDescription": "Disables the barcodePattern and allows all barcodes to match",
						"_internalName": "Disable barcode pattern",
						"description": "1500_veric_barc_disap__d",
						"enum": [
							true
						],
						"title": "1500_veric_barc_disap__t",
						"type": "boolean"
					},
					"enable": {
						"_internalDescription": "Enable the Barcode Scanner for mobile",
						"_internalName": "Enable Barcode Scanner",
						"description": "1500_veric_barc_enab__d",
						"enum": [
							true
						],
						"title": "1500_veric_barc_enab__t",
						"type": "boolean"
					}
				},
				"title": "1500_veric_barc__t",
				"type": "object"
			},
			"cardImage": {
				"description": "1500_veric_cardi__d",
				"minLength": 1,
				"type": "string"
			},
			"defaultRouteTypeForValidPass": {
				"description": "1500_veric_defaultR__d",
				"type": "string"
			},
			"defaultRouteValueForValidPass": {
				"description": "1500_veric_defaultRV__d",
				"type": "string"
			},
			"sendEventDetails": {
				"description": "1500_veric_sendED__d",
				"type": "boolean"
			},
			"showVoucherOnly": {
				"description": "1500_veric_showV__d",
				"type": "boolean"
			},
			"validate_duplicated_barcode": {
				"description": "1500_veric_validb__d",
				"type": "string"
			},
			"validateAsMediaNumber": {
				"description": "1500_veric_validM__d",
				"type": "boolean"
			},
			"voucherImage": {
				"description": "1500_veric_vouci__d",
				"minLength": 1,
				"type": "string"
			}
		},
		"title": "1500_veric__t",
		"type": "object"
	},
	"whitelist_params": {
		"_internalDescription": "Whitelist Parameters that will retain in the address bar",
		"_internalName": "Whitelist Parameters",
		"$id": "1500_whitelist_params",
		"description": "1500_whitp__d",
		"items": {
			"type": "string"
		},
		"title": "1500_whitp__t",
		"type": "array"
	},
	"wizard_config": {
		"_internalName": "Wizard Config",
		"$id": "1500_wizard_config",
		"definitions": {
			"individual_wizard_config": {
				"descripton": "1500_wizac_indiwc__d",
				"properties": {
					"imageSubFolder": {
						"description": "1500_wizac_indiwc_imagsf__d",
						"type": "string"
					},
					"keyword": {
						"description": "1500_wizac_indiwc_keyw__d",
						"pattern": "[A-Za-z0-9\\s]*",
						"type": "string"
					},
					"mainImageName": {
						"description": "1500_wizac_indiwc_mainin__d",
						"pattern": "[A-Za-z0-9\\s]*",
						"type": "string"
					},
					"rates": {
						"description": "1500_wizac_indiwc_rate__d",
						"items": {
							"items": {
								"properties": {
									"name": {
										"description": "1500_wizac_indiwc_rate_name__d",
										"enum": [
											"adult",
											"child",
											"general",
											"jr/sr"
										],
										"type": "string"
									}
								},
								"required": [
									"name"
								],
								"type": "object"
							},
							"type": "object"
						},
						"maxItems": 2,
						"title": "1500_wizac_indiwc_rate__t",
						"type": "array"
					},
					"slides": {
						"description": "1500_wizac_indiwc_slid__d",
						"items": {
							"description": "1500_wizac_indiwc_slid_i__d",
							"properties": {
								"default_enabled": {
									"description": "1500_wizac_indiwc_slid_defae__d",
									"enum": [
										false,
										true
									],
									"type": "boolean"
								},
								"name": {
									"description": "1500_wizac_indiwc_slid_name__d",
									"type": "string"
								},
								"props": {
									"description": "1500_wizac_indiwc_slid_prop__d",
									"type": "object"
								}
							},
							"required": [
								"name"
							],
							"type": "object"
						},
						"title": "1500_wizac_indiwc_slid__t",
						"type": "array",
						"uniqueItems": true
					},
					"type": {
						"description": "1500_wizac_indiwc_type__d",
						"pattern": "^.*multi(Park|Day)$",
						"type": "string"
					},
					"venue": {
						"description": "1500_wizac_indiwc_venu__d",
						"type": "string"
					}
				},
				"required": [
					"keyword",
					"mainImageName",
					"rates",
					"slides",
					"type",
					"venue"
				],
				"title": "1500_wizac_indiwc__t",
				"type": "object"
			}
		},
		"description": "1500_wizac__d",
		"properties": {
			"imageFolder": {
				"description": "1500_wizac_imagf__d",
				"type": "string"
			},
			"wizards": {
				"description": "1500_wizac_wiza__d",
				"items": {
					"$ref": "#/definitions/individual_wizard_config",
					"type": "object"
				},
				"title": "1500_wizac_wiza__t",
				"type": "array"
			}
		},
		"required": [
			"imageFolder",
			"wizards"
		],
		"title": "1500_wizac__t",
		"type": "object"
	},
	"wizard_launcher": {
		"_internalName": "Wizard Launcher Configuration",
		"$id": "1500_wizard_launcher",
		"description": "1500_wizal__d",
		"properties": {
			"bannerImageFolder": {
				"description": "1500_wizal_bannif__d",
				"type": "string"
			},
			"banners": {
				"description": "1500_wizal_bann__d",
				"items": {
					"properties": {
						"keyword": {
							"description": "1500_wizal_bann_keyw__d",
							"type": "string"
						},
						"promo_code": {
							"description": "1500_wizal_bann_promc__d",
							"type": "string"
						},
						"source": {
							"description": "1500_wizal_bann_sour__d",
							"type": "string"
						}
					},
					"required": [
						"source"
					],
					"type": "object"
				},
				"title": "1500_wizal_bann__t",
				"type": "array"
			},
			"launcherItemImageFolder": {
				"description": "1500_wizal_launiif__d",
				"type": "string"
			}
		},
		"required": [
			"banners"
		],
		"title": "1500_wizal__t",
		"type": "object"
	},
	"wtp": {
		"_internalName": "Wireless Transfer Protocol (WTP)",
		"$id": "1500_wtp",
		"definitions": {
			"lengthCollection": {
				"additionalProperties": false,
				"properties": {
					"passLength": {
						"_example": "[14,15,20]",
						"_internalDescription": "The acceptable length (without hyphens) of the input number",
						"_internalName": "Acceptable WTP Length(s)",
						"description": "1500_wtp_wtpl_passl__d",
						"minimum": 1,
						"title": "1500_wtp_wtpl_passl__t",
						"type": "integer"
					},
					"format": {
						"_example": "XXXXXXXX-AAA-NNN",
						"_internalDescription": "Custom Format that the system must follow (X = Alphanumeric, A = Alphabetical, N = Numeric), blank if not format",
						"_internalName": "Custom Format",
						"description": "1500_wtp_wtpl_form__d",
						"title": "1500_wtp_wtpl_form__t",
						"type": "string"
					},
					"removeLeadingZeros": {
						"_internalDescription": "If the system should strip out any leading zeros from the number",
						"_internalName": "Remove Leading Zeros",
						"description": "1500_wtp_wtpl_remolz__d",
						"title": "1500_wtp_wtpl_remolz__t",
						"type": "boolean"
					}
				},
				"required": [
					"passLength"
				]
			}
		},
		"description": "1500_wtp__d",
		"properties": {
			"enabled": {
				"description": "1500_wtp_enab__d",
				"enum": [
					false,
					true
				],
				"type": "boolean"
			},
			"firstNameOnlyOnTicket": {
				"description": "1500_wtp_firsnoot__d",
				"enum": [
					false,
					true
				],
				"type": "boolean"
			},
			"instructionImage": {
				"description": "1500_wtp_insti__d",
				"type": "string"
			},
			"loadingIcon": {
				"description": "1500_wtp_loadi__d",
				"type": "string"
			},
			"replaceQuantityStepperOnOneOptionAvailable": {
				"_internalDescription": "On only one cust type option available at package planner guest options view the stepper is replaced by a label and its value is fixed to one",
				"_internalName": "Replace stepper for one cust type",
				"description": "1500_wtp_wtpl_repstepper__d",
				"enum": [
					false,
					true
				],
				"title": "1500_wtp_wtpl_repstepper__t",
				"type": "boolean"
			},
			"restrictPurchase": {
				"_internalName": "Restrictions on Purchase",
				"_internalDescription": "Rules that WTP numbers must follow to be eligible for purchase",
				"description": "1500_wtp_restp__d",
				"enum": [
					"none",
					"order",
					"package"
				],
				"title": "1500_wtp_restp__t",
				"type": "string"
			},
			"wtpLength": {
				"$ref": "#/definitions/lengthCollection",
				"additonalItems": false,
				"description": "1500_wtp_wtpl__d",
				"items": {
					"minimum": 1,
					"$ref": "#/definitions/lengthCollection",
					"type": "object"
				},
				"title": "1500_wtp_wtpl__t",
				"type": [
					"object",
					"array"
				]
			}
		},
		"title": "1500_wtp__t",
		"type": "object"
	},
	"validate_zips": {
		"_internalName": "Validate Zip Code Groups",
		"$id": "1500_valzips",
		"description": "1500_valzips__d",
		"title": "1500_valzips__t",
		"type": "boolean"
	},
	"zip_code_notice": {
		"_internalName": "Zip Code Notice",
		"$id": "1500_zip_code_notice",
		"description": "1500_zcn__d",
		"title": "1500_zcn__t",
		"properties": {
			"codes": {
				"description": "1500_zcn_codes__d",
				"type": "array",
				"properties": {
					"minLength": 1,
					"type": "string"
				}
			},
			"prefix": {
				"description": "1500_zcn_prefix__d",
				"type": "array",
				"properties": {
					"minLength": 1,
					"type": "string"
				}
			},
			"range": {
				"description": "1500_zcn_range__d",
				"type": "array",
				"items": {
					"type": "object",
					"required": [
						"start",
						"end"
					],
					"properties": {
						"start": {
							"description": "1500_zcn_start__d",
							"minLength": 1,
							"type": "string"
						},
						"end": {
							"description": "1500_zcn_end__d",
							"minLength": 1,
							"type": "string"
						}
					}
				}
			}
		}
	},
	"zoo_memberships": {
		"_internalName": "Zoo Memberships Configuration",
		"$id": "1500_zoo_memberships",
		"description": "1500_zoom__d",
		"properties": {
			"defaultGuestName": {
				"description": "1500_zoom_defagn__d",
				"type": "string"
			},
			"defaultMaxChildren": {
				"description": "1500_zoom_defamc__d",
				"pattern": "^[0-9]",
				"type": "number"
			},
			"lookupPassDetectorMaxLength": {
				"description": "1500_zoom_lookpdmaxl__d",
				"pattern": "^[0-9]",
				"type": "number"
			},
			"lookupPassDetectorMinLength": {
				"description": "1500_zoom_lookpdminl__d",
				"pattern": "^[0-9]",
				"type": "number"
			},
			"pillLabelType": {
				"description": "1500_zoom_pilllt__d",
				"type": "string"
			}
		},
		"title": "1500_zoom__t",
		"type": "object"
	},
	"cutoff_display": {
		"_internalName": "Cutoff Display",
		"$id": "1500_cutoff_display",
		"description": "1500_coffd__d",
		"title": "1500_coffd__t",
		"type": "boolean"
	},
	"package_list": {
		"_internalName": "Package List",
		"$id": "1500_package_list",
		"description": "1500_pckli__d",
		"items": {
			"properties": {
				"keyword": {
					"description": "1500_pckli_bannl_bannin__d",
					"type": "string"
				},
				"image_url": {
					"description": "1500_pckli_bannl_bannim__d",
					"type": "string"
				}
			},
			"type": "object"
		},
		"title": "1500_pckli_bannl__t",
		"type": "array"
	}
})

;
angular.module('json-validator-constants')

	.constant('InternalConfig', {
		resellerInitializationData: {
			$id: '1500_resellerInitializationData',
			properties: {
				idle_timeout_minutes: {
					title: 'Idle Timeout Minutes',
					type: 'integer'
				},
				idle_warning_minutes: {
					title: 'Idle Warning Minutes',
					type: 'integer'
				},
				keepalive_interval_minutes: {
					title: 'Keep Alive Interval Minutes',
					type: 'integer'
				},
				pos_flag: {
					title: 'POS Flag',
					type: 'integer'
				},
				reseller_account: {
					title: 'Reseller Account',
					type: 'integer'
				},
				reseller_first_name: {
					title: 'Reseller First Name',
					type: 'string'
				},
				reseller_id: {
					title: 'Reseller ID',
					type: 'integer'
				},
				reseller_last_name: {
					title: 'Reseller Last Name',
					type: 'string'
				},
				reseller_location_id: {
					title: 'Reseller Location ID',
					type: 'integer'
				},
				reseller_name: {
					title: 'Reseller Name',
					type: 'string'
				},
				reseller_phone: {
					title: 'Reseller Phone',
					type: 'string'
				},
				reseller_zip: {
					title: 'Reseller Zip/Postal',
					type: 'string'
				},
				store_checkout_enable_postal_code_field: {
					title: 'Store Checkout - Enable Postal Code Field',
					type: 'boolean'
				},
				store_checkout_enable_receipt_email_option: {
					title: 'Store Checkout - Enable Receipt Email Option',
					type: 'boolean'
				},
				store_checkout_enable_shipping_selection: {
					title: 'Store Checkout - Enable Shipping Selection',
					type: 'boolean'
				},
				store_checkout_require_postal_code_field: {
					title: 'Store Checkout - Require Zip/Postal Code Field',
					type: 'boolean'
				},
				store_checkout_require_voucher_id_field: {
					title: 'Store Checkout - Require Voucher ID Field',
					type: 'boolean'
				},
				store_enable_reset_cart: {
					title: 'Store Enable Reset Cart',
					type: 'boolean'
				},
				type: {
					enum: [
						'accesso:resellerInitialization',
						'accesso:resellerKeepalive',
						'accesso:resellerPOSPrintOrderTickets'
					],
					title: 'Type',
					type: 'string'
				},
				user_id: {
					title: 'User ID',
					type: 'integer'
				},
				user_token: {
					title: 'User Token',
					type: 'string'
				}
			},
			required: [
				'idle_timeout_minutes',
				'idle_warning_minutes',
				'keepalive_interval_minutes',
				'reseller_account',
				'reseller_id',
				'reseller_location_id',
				'reseller_name',
				'reseller_zip',
				'type',
				'user_id',
				'user_token'
			],
			title: 'Reseller Initialization Data',
			type: 'object'
		}
	});
(function() {
	'use strict';

	angular
		.module('one-risk', ['utilities'])
		.config(function($locationProvider, $stateProvider) {
			var ONE_RISK_DIR = '/scripts/modules/one-risk/';

			$stateProvider
				.state('riskWaiver', {
					controller: 'OneRiskCartWaiverController',
					resolve: {
						initialData: function(Bootstrap) {
							return Bootstrap.bootstrapApplication();
						},
						routeGuard: function(initialData, $rootScope, CartDataService, Enums, OneRiskService) {
							if (!CartDataService.api.totalQty) {
								$rootScope.routeTo('/');
							} else if (!OneRiskService.canShowBeforePurchase() || !OneRiskService.cartHasOneRiskPackages()) {
								$rootScope.routeTo(Enums.routes.CART);
							}
						},
						load: function(routeGuard, $rootScope, Utilities) {
							// Keep the spinner visible past onSuccess so the oneRiskSignedFilter async chain
							// (getPackageForms calls) can complete before buildPayloadAndLaunchOneRisk shows
							// the waiver iframe. Without this, onSuccess hides the spinner, briefly exposing
							// the shell before the iframe is ready.
							$rootScope._skipNextOnSuccessHideSpinner = true;
							$rootScope.showSpinner();

							return Utilities.cacheBustAndLazyLoad([
								ONE_RISK_DIR + 'controllers/one-risk-cart-waiver-controller.js'
							]);
						}
					},
					templateUrl: ONE_RISK_DIR + 'views/one-risk-cart-waiver.html',
					url: '/riskWaiver'
				});
		})
		.run(function(OneRiskService) {
			OneRiskService.registerOneRisk();
		});
})();
(function() {
	'use strict';

	angular
		.module('one-risk')
		.factory('OneRiskService', OneRiskService);

	/**
	 * Service to handle interactions with 1Risk
	 * @param {Service} $log $log
	 * @param {Object} $q $q Service
	 * @param {Object} $rootScope $rootScope
	 * @param {Object} $filter $filter
	 * @param {Object} $window $window Service
	 * @param {Object} AppData AppData Service
	 * @param {Object} CartDataService CartDataService
	 * @param {Ojbect} CustomActionService CustomActionService
	 * @param {Object} Enums Enums Service
	 * @param {Object} jwtService Jwt Service
	 * @param {Object} Package Package Service
	 * @param {Object} Utilities Utilities Service
	 * @param {Object} PostPurchaseActionsService PostPurchaseActionsService
	 * @param {Object} JSONValidator JSONValidator
	 * @param {Object} UtilsValidation UtilsValidation
	 * @param {Object} UrlUtils UrlUtils
	 * @param {Object} ProfileLoginSessionService ProfileLoginSessionService
	 * @param {Object} $document $document
	 * @param {Object} $state $state
	 * @returns {Object} OneRiskService
	 */
	function OneRiskService($log, $q, $rootScope, $filter, $window, AppData, CartDataService, CustomActionService, Enums, jwtService, Package, Utilities, PostPurchaseActionsService, JSONValidator, UtilsValidation, UrlUtils, ProfileLoginSessionService, $document, $state) {
		var service = {
			buildPayloadAndLaunchOneRisk: buildPayloadAndLaunchOneRisk,
			postPurchaseOneRisk: postPurchaseOneRisk,
			oneRiskSignedFilter: oneRiskSignedFilter,
			canShowBeforePurchase: canShowBeforePurchase,
			cartHasOneRiskPackages: cartHasOneRiskPackages,
			determineGuestDemographics: determineGuestDemographics,
			getGuestNoFromCartItem: getGuestNoFromCartItem,
			getPackageForms: getPackageForms,
			hasUnacceptedGuests: hasUnacceptedGuests,
			registerOneRisk: registerOneRisk,
			setGuestAsAccepted: setGuestAsAccepted,
			_: {
				generateGuestObject: _generateGuestObject,
				getBaseWaiverObject: _getBaseWaiverObject,
				getDateFormat: _getDateFormat,
				getTimeFormat: _getTimeFormat,
				getPayloadWaiverObject: _getPayloadWaiverObject,
				getSignedGuests: _getSignedGuests,
				isLegacyFormat: _isLegacyFormat,
				scanForPrefix: _scanForPrefix
			}
		};

		var validArray = UtilsValidation.validArray;
		var validObject = UtilsValidation.validObject;
		var isValidString = UtilsValidation.validString;
		var checkProp = Utilities.safelyCheckPropertyOnObject;
		var createObjNest = Utilities.createObjectNest;
		var formatYYYYMMDD = Utilities.formatSetDateFormatToYYYY_MM_DD;
		var orderID;
		var wrapObjectToArray = Utilities.wrapObjectToArray;
		var _oneRiskConfig = {};
		var _signedGuests = {};
		var dateFormat = null;
		var merge = Object.assign || angular.merge;

		registerOneRisk();

		return service;

		/**
		 * Function executed at module run, registers 1Risk action in the orderService.
		 * @public
		 * @returns {undefined}
		 */
		function registerOneRisk() {
			CustomActionService.registerCustomAction(CustomActionService.ACTIONS_ENUMS.CUSTOM_WAIVERS_BEFORE_CART, onCartShowWaivers);
			PostPurchaseActionsService.registerAction(postPurchaseOneRisk);
		}

		/**
		 * If we are able to show the waiver before a Purchase is made or not
		 * Looks at the configs to see what is set
		 * Post purchase is default
		 * @public
		 * @function
		 * @returns {Boolean} True if we can, false otherwise
		 */
		function canShowBeforePurchase() {
			var config = getConfig();

			return checkProp('config.beforePurchase', config, 'getBoolean');
		}

		/**
		 * Sets Cart ID to be ignored during cartHasOneRiskPackages check
		 * @param {String|String[]} guestId the cart id reference
		 * @public
		 * @function
		 * @returns {undefined}
		 */
		function setGuestAsAccepted(guestId, oneRiskWaiverIds, formNumbers) {
			var waivers,
				forms;

			if (!oneRiskWaiverIds || !formNumbers) {
				return;
			}

			if (validArray(guestId)) {
				guestId.forEach(function forEachGuestAsAccepted(gId) {
					setGuestAsAccepted(gId, oneRiskWaiverIds, formNumbers)
				});
			} else {
				waivers = oneRiskWaiverIds.replace(/\s/g, '').split(',');
				forms = formNumbers.replace(/\s/g, '').split(',');

				waivers.forEach(function waiverIterator(w, i) {
					if (!forms[i]) {
						return;
					}

					createObjNest(_signedGuests, 'obj.' + w + '[' + forms[i] + ']');

					if (!_signedGuests[w][forms[i]].includes(guestId)) {
						_signedGuests[w][forms[i]].push(guestId);
					}
				});
			}
		}

		/**
		 * Callback for CustomActionService CUSTOM_WAIVERS_BEFORE_CART
		 * Will route to waivers if conditions are met, removes action if not
		 * @public
		 * @function
		 * @param {Transition} trans The transition object
		 * @returns {undefined}
		 */
		function onCartShowWaivers(trans) {
			if (canShowBeforePurchase()) {
				if (cartHasOneRiskPackages()) {
					// Keep the spinner visible through the abort → riskWaiver load cycle.
					// Without this, onError for the ABORTED cart transition calls hideSpinner(),
					// briefly exposing the shell before the riskWaiver load resolve re-shows it.
					$rootScope._skipNextHideSpinner = true;
					trans.abort();
					Utilities.goTo(Enums.routes.PRE_CART_WAIVER);
				}
			} else {
				// Since App Configs are not loaded when the custom actions are loaded, we will deregister this here
				CustomActionService.deregisterCustomAction(CustomActionService.ACTIONS_ENUMS.CUSTOM_WAIVERS_BEFORE_CART);
			}
		}

		/**
		 * Loops through the View Order response and creates an array of waivers and guest information to encrypt into JWT and pass to 1Risk.
		 * @public
		 * @param {Object[]} [eligibleItems] Items to loop through (if exists)
		 * @param {Function} [onCloseCallback] callback once 1risk waiver is closed
		 * @param {Object[]} [prePurchaseFlag] checks if waivers are signed
		 * @returns {Promise.<T>} Promise
		 */
		function buildPayloadAndLaunchOneRisk(eligibleItems, onCloseCallback, prePurchaseFlag) {
			var oneRiskConfig = {};
			var jsonPayload = {};
			var waiverObject = {};
			var splitWaivers = [];
			var splitFormNumbers = [];
			var guestObj = {};
			var itemsIterator;
			var isBeforePurchase = canShowBeforePurchase();

			if (!isBeforePurchase && ($state.current.name.indexOf('orderView') !== -1 || isValidString(orderID) && orderID === AppData.GuestViewOrder.VIEW_ORDER_REPLY.ORDER_STATUS_REPLY.order_id)) {
				return;
			}

			return $q(function(resolve) {
				var createJwtRequest,
					ticketIds = [],
					handleSuccessfulJwt;

				if (Utilities.safelyCheckPropertyOnObject('AppData.settings.one_risk', AppData) && JSONValidator.validate('one_risk', AppData.settings.one_risk) && (validArray(eligibleItems) || Utilities.safelyCheckPropertyOnObject('AppData.GuestViewOrder.VIEW_ORDER_REPLY', AppData))) {
					oneRiskConfig = getConfig();
					jsonPayload = {
						displayFormat: service._.getDateFormat().toLowerCase(),
						integration: 'passport',
						waivers: []
					};

					if (!isBeforePurchase) {
						orderID = AppData.GuestViewOrder.VIEW_ORDER_REPLY.ORDER_STATUS_REPLY.order_id;
						jsonPayload.orderId = orderID;
					}

					itemsIterator = isBeforePurchase ? eligibleItems || [] : AppData.GuestViewOrder.VIEW_ORDER_REPLY.TICKET_DETAILS_REPLY.TICKET;
					waiverObject = {};

					itemsIterator.forEach(function(item) {
						var guestID;
						var CHARACS = item.pkgCharacs || item.characs || {};
						var tixCharacs = item.characs;
						if (validObject(CHARACS) && isValidString(CHARACS.oneRiskWaiverIds) && isValidString(CHARACS.formNumbers)) {
							tixCharacs.forEach(function tixCharacsIterator(characSet) {
								var itemCopy = angular.copy(item);
								itemCopy.characs = characSet;

								guestObj = service.determineGuestDemographics(itemCopy);
								// Look for different properties/values based upon which format we are using
								guestID = service._.isLegacyFormat() ? guestObj.guestId : guestObj.posGuestId;
								if (guestObj) {
									splitWaivers = CHARACS.oneRiskWaiverIds.split(',');
									splitFormNumbers = CHARACS.formNumbers.split(',');
									splitWaivers.forEach(function(waiver, index) {
										// This particular guest was already signed or added to waiver, ignore
										if (isGuestAddedForForm(waiverObject, guestObj) || !hasUnacceptedGuests([guestID], waiver, splitFormNumbers[index])) {
											return;
										}

										ticketIds.push(item.ticket_id);

										if (waiverObject[waiver]) {
											waiverObject[waiver].guests.push(guestObj);
										} else {
											waiverObject[waiver] = service._.getBaseWaiverObject(splitFormNumbers[index], guestObj);
										}
									});
								}
							});
						}
					});

					handleSuccessfulJwt = function(jwtToken) {
						var config = getConfig();
						var oneRiskUrl = config.url + '?g=' + jwtToken;
						var body = null;
						var iframe = null;
						var parsedEventBody = {};

						body = $document[0].body;
						iframe = $document[0].createElement('iframe');

						iframe.src = oneRiskUrl;
						iframe.id = 'oneRiskFrame';
						iframe.name = 'oneRiskFrame';
						iframe.class = 'hide';
						iframe.frameborder = '0';
						iframe.width = '100%';
						iframe.height = '100%';

						iframe.onload = function iframeClearSpinner() {
							iframe.class = '';
							$rootScope.hideSpinner();
						};

						iframe.onclose = function() {
							body.removeChild(iframe);
							if (angular.isFunction(onCloseCallback)) {
								onCloseCallback(eligibleItems, prePurchaseFlag);
							}
						};

						$window.addEventListener('message', function onMessage(event) {
							if (config.url.indexOf(event.origin) !== -1) {
								if (event.data) {
									parsedEventBody = JSON.parse(event.data);
									if (['oneRiskClosed', 'allWaiversCompleted'].includes(parsedEventBody.messageType)) {
										body.removeChild(iframe);
										$window.removeEventListener("message", onMessage);
										if (angular.isFunction(onCloseCallback)) {
											onCloseCallback(eligibleItems, prePurchaseFlag);
										}
									}
								}
							}
						}, false);

						body.appendChild(iframe);

						resolve();
					};

					if (!guestObj) {
						return resolve();

					// if post purchase...
					} else if (!isBeforePurchase && !oneRiskConfig.disableOneRiskJwtEndpoint) {
						if (!ticketIds.length) {
							return;
						}

						createJwtRequest = {
							cToken: checkProp('AppData.GuestViewOrder.VIEW_ORDER_REPLY.CUSTOMER_DETAILS_REPLY.CUSTOMER.cToken', AppData, 'returnValue'),
							callback_url: UrlUtils.createCloseControllerUrl(),
							oToken: checkProp('AppData.GuestViewOrder.VIEW_ORDER_REPLY.ORDER_STATUS_REPLY.oToken', AppData, 'returnValue'),
							ticket_ids: ticketIds.join(',')
						};

						if (!service._.isLegacyFormat()) {
							createJwtRequest.version = '2';
						}

						return AppData
							.fetch('CreateOneRiskJWT', false, createJwtRequest)
							.then(function onCreateOneRiskJWTSuccess(data) {
								if (checkProp('data.status', data, 'returnValue') === 'OK' && isValidString(data.jwt)) {
									return handleSuccessfulJwt(data.jwt);
								} else {
									resolve();
								}
							})
							.catch(function onCreateOneRiskJWTFailed(err) {
								$log.error(err);
								resolve();
							});
					}

					jsonPayload.waivers = Object.keys(waiverObject).map(function(key) {
						return service._.getPayloadWaiverObject(waiverObject[key], key);
					});

					if (jsonPayload.waivers.length) {
						jwtService
							.createJWT(jsonPayload, oneRiskConfig.jwtKey)
							.then(handleSuccessfulJwt)
							.catch(resolve);
					} else {
						resolve();
					}
				} else {
					resolve();
				}
			});
		}

		/**
		 * Loops through the checkPackageForms and creates an array of waivers and guest information and pass to 1Risk.
		 * @public
		 * @param {Object[]} [signedCustomer] Items to loop through (if exists)
		 * @param {Object[]} [prePurchaseFlag] checks if waivers are signed
		 * @returns {resolve()}
		 */
		function oneRiskSignedFilter(signedCustomer, prePurchaseFlag) {
			var eligibleItems = [];
			signedCustomer.forEach(function oneRiskPackageIterator(item) {
				var eItem;
				var pkg = item.package ? Package.getPackageByID(item.package.id) : Package.getPackageByID(item.package_id);

				if (checkProp('pkg.CHARACS.oneRiskWaiverIds', pkg) && checkProp('pkg.CHARACS.formNumbers', pkg)) {
					eItem = angular.copy(item);
					eItem.pkgCharacs = merge({}, pkg.CHARACS);
					eligibleItems.push(eItem);
				}
			});

			$q(function checkPackageForms(pfResolve) {
				if (eligibleItems.length) {
					eligibleItems.reduce(function eligibleItemsIterator(prevPromise, item, i) {
						var guestId = getGuestNoFromCartItem(item);

						return prevPromise.then(function() {
							if (item.pkgCharacs.hasForms && item.pkgCharacs.oneRiskWaiverIds) {
								return getPackageForms(item.package.id, item.customer.id, item.characs[0].start_date, item.characs[0].start_time, guestId)
									.then(function(resp) {
										var selectedGuest = checkProp('resp.FORMS', resp) ? resp.FORMS : {};
										var selectedGuestForms = checkProp('selectedGuest.FORM', selectedGuest, 'wrapObjectToArray');
										var acceptedFormNumbers = [];
										var pkgFormNumbers = item.pkgCharacs.formNumbers.replace(/\s/g, '').split(',');
										var oneRiskWaiverIds = item.pkgCharacs.oneRiskWaiverIds.replace(/\s/g, '').split(',');

										if (guestId[0] !== selectedGuest.guest_no) {
											throw 'getPackageForms: Response has incorrect guest number';
										}

										if (validArray(selectedGuestForms)) {
											selectedGuestForms.forEach(function formsIterator(form) {
												var pkgFormIndex;

												if (Utilities.getBoolean(form.accepted) && form.id) {
													acceptedFormNumbers.push(form.id);
													pkgFormIndex = pkgFormNumbers.indexOf(form.id);
													// They must match the same index otherwise we could be adding an incorrect one to the accepted list...
													if (pkgFormIndex > -1 && pkgFormIndex === oneRiskWaiverIds.indexOf(oneRiskWaiverIds[pkgFormIndex])) {
														setGuestAsAccepted(selectedGuest.guest_no, oneRiskWaiverIds[pkgFormIndex], form.id);
													}
												}
											});
										}

										var isPkgFormAccepted = pkgFormNumbers.every(function pkgFormNumberIterator(fNum) {
											return acceptedFormNumbers.includes(fNum);
										});

										eligibleItems[i].hasSignedWaiver = !!isPkgFormAccepted;
									})
									.catch($q.resolve);
							} else {
								return $q.resolve();
						    }
						});
					}, $q.resolve())
					.then(pfResolve)
					.catch(pfResolve);
				} else {
					pfResolve();
				}
			})
			.then(function showWaivers() {
				var hashes = [];
				var reducedItems;

				eligibleItems = removeCartItemsWithAcceptedForm(eligibleItems);

				if (eligibleItems.length) {
					// dedupe and prevent showing already presented waiver
					reducedItems = eligibleItems.reduce(function dedupeEligibleItems(acc, item) {
						var guestNo = getGuestNoFromCartItem(item);
						var canAddItem = false;
						var hash;
						var waivers;
						var forms;

						if (!validArray(guestNo)) {
							return acc;
						}

						waivers = item.pkgCharacs.oneRiskWaiverIds.replace(/\s/g, '').split(',');
						forms = item.pkgCharacs.formNumbers.replace(/\s/g, '').split(',');

						// If any one risk waiver id + form number combincation doesn't exist for an item, we want to show the waiver
						// Also dedupes based on this hash structure to remove multiple cart items with the same information from being
						// signed twice
						waivers.forEach(function(w, i) {
							guestNo.forEach(function(gId) {
								hash = w + '_' + forms[i] + '_' + gId;

								if (!hashes.includes(hash)) {
									hashes.push(hash);
									canAddItem = true;
								}
							});
						});

						// Double checks to see if this was already signed
						if (canAddItem && hasUnacceptedGuests(guestNo, item.pkgCharacs.oneRiskWaiverIds, item.pkgCharacs.formNumbers)) {
							acc.push(item);
						}
						return acc;
					}, []);

						if (reducedItems.length) {
							$rootScope.showSpinner();
							buildPayloadAndLaunchOneRisk(reducedItems, onCloseWaivers, prePurchaseFlag);
						} else {
							if (prePurchaseFlag) {
								routeToCart();
							}
						}
				} else {
						if (prePurchaseFlag) {
							routeToCart();
						}
					}
			})
			.catch(function() {
				return $q.resolve();
			});
		}

		/**
         * Grab the eligible items and show waivers for post purchase flow.
         * @public
         * @function
         * @returns {undefined}
         */
        function postPurchaseOneRisk() {
            var config;
            if (!canShowBeforePurchase()) {
                config = checkProp('AppData.GuestViewOrder.VIEW_ORDER_REPLY.TICKET_DETAILS_REPLY.TICKET', AppData, 'returnValue')
                oneRiskSignedFilter(config, false);
			}
        }

		/**
		 * Handles removal of cart item from form/waiver eligible items.
		 * Form eligibility is for unsigned waivers.
		 * @param {Object[]} eligibleItems eligible items
		 * @returns {Object[]} new array of filtered eligibleItems
		 */
		function removeCartItemsWithAcceptedForm(eligibleItems) {
			if (!Array.isArray(eligibleItems)) {
				return [];
			}

			return eligibleItems.filter(function iterateCartItems(item) {
				return !item.hasSignedWaiver;
			});
		}

		/**
		 * Handles when the waivers are closed
		 * Sets One Risk Service to recognize that the specified cart items have signed the waiver
		 * to prevent a double signing, then calls to redirect
		 * @callback
		 * @param {Object[]} eligibleItems eligible items
		 * @param {Object[]} [prePurchaseFlag] checks if waivers are signed
		 * @returns {undefined}
		 */
		function onCloseWaivers(eligibleItems, prePurchaseFlag) {
			eligibleItems.forEach(function(item) {
				setGuestAsAccepted(getGuestNoFromCartItem(item), item.pkgCharacs.oneRiskWaiverIds, item.pkgCharacs.formNumbers);
			});
			if (prePurchaseFlag) {
				routeToCart();
			}
		}

		/**
		 * Should 1Risk be using the legacy format?
		 * @function
		 * @returns {Boolean} True if we are using legacy format, false otherwise
		 */
		function _isLegacyFormat() {
			// Check if we are using the new payload format
			return !checkProp('config.useNewIntegration', getConfig(), 'getBoolean');
		}

		/**
		 * Generates the base waiver object
		 * @function
		 * @param {String} posWaiverId The waiver id
		 * @param {Object} guest The guest object
		 * @returns {Object} The waiver object
		 */
		function _getBaseWaiverObject(posWaiverId, guest) {
			if (service._.isLegacyFormat()) {
				return {
					formId: posWaiverId,
					guests: [guest]
				};
			}

			// Uses new format
			return {
				pos: 'SW',
				posWaiverId: posWaiverId,
				guests: [guest]
			};
		}

		/**
		 * Generates waiver object for JWT consumption
		 * @function
		 * @param {Object} waiver The waiver object
		 * @param {String} key The waiver key
		 * @returns {Object} The JWT Waiver Object
		 */
		function _getPayloadWaiverObject(waiver, key) {
			if (service._.isLegacyFormat()) {
				return {
					formId: waiver.formId,
					guests: waiver.guests,
					waiverId: key
				};
			}

			// Uses new format
			return {
				posWaiverId: waiver.posWaiverId,
				pos: waiver.pos,
				guests: waiver.guests,
				waiverId: key
			};
		}

		/**
		 * Checks if Guest already exists in waiver object
		 * @function
		 * @param {Object} waiver The Waiver Object
		 * @param {Object} guest The Guest Object
		 * @returns {Boolean} true if the guest already exists, false otherwise
		 */
		function isGuestAddedForForm(waiver, guest) {
			return checkProp('waiver.guests', waiver, 'validArray') && waiver.guests.some(function waiverGuestsIterator(wGuest) {
				return service._.isLegacyFormat()
					? wGuest.guestId === guest.guestId
					: wGuest.posGuestId === guest.posGuestId;
			});
		}

		/**
		 * Grabs singleton confi1g for one risk
		 * @function
		 * @returns {Object} The configuration, if exists
		 */
		function getConfig() {
			if (!validObject(_oneRiskConfig) && checkProp('AppData.settings.one_risk', AppData) && JSONValidator.validate('one_risk', AppData.settings.one_risk)) {
				_oneRiskConfig = JSON.parse(AppData.settings.one_risk);
			}

			return _oneRiskConfig;
		}

		/**
		 * Grabs Guest Number, where present
		 * @oublic
		 * @function
		 * @param {Object} item the Cart Item to check
		 * @returns {String[]|null} The Guest Number, where present
		 */
		function getGuestNoFromCartItem(item) {
			var characs = item.characs;
			var guestNo = [];
			var profile;
			var i;

			if (validArray(characs)) {
				for (i = 0; i < characs.length; i++) {
					if (characs[i].guest_no) {
						guestNo.push(characs[i].guest_no);
					} else if (characs[i].WTP_guest_no) {
						guestNo.push(characs[i].WTP_guest_no);
					}
				}
			} else if (ProfileLoginSessionService.isLoggedIn()) {
				profile = ProfileLoginSessionService.getCurrentLoggedInProfile();

				guestNo.push(profile.guest_no);
			}

			// Ensure all guest numbers are unique
			if (guestNo.length > 1) {
				guestNo = guestNo.filter(function guestNoUniqueFilter(item, i, self) {
					return self.indexOf(item) === i;
				});
			}

			return validArray(guestNo) ? guestNo : null;
		}

		/**
		 * Checks if the selection of guest numbers has any unaccepted guests
		 * @public
		 * @function
		 * @param {String[]|null} guestNo The Guest Numbers
		 * @param {String} oneRiskWaiverIds The One Risk Waiver ID
		 * @param {String[]|null} formNumbers The Form Numbers
		 * @returns {Boolean} True if there are unaccepted guests, false otherwise
		 */
		function hasUnacceptedGuests(guestNo, oneRiskWaiverIds, formNumbers) {
			var waivers,
				forms;

			if (!validArray(guestNo) || !oneRiskWaiverIds || !formNumbers) {
				return false;
			}

			waivers = oneRiskWaiverIds.replace(/\s/g, '').split(',');
			forms = formNumbers.replace(/\s/g, '').split(',');

			return !waivers.every(function(w, i) {
				if (!forms[i]) {
					return;
				}

				return guestNo.every(function(gId) {
					createObjNest(_signedGuests, 'obj.' + w + '[' + forms[i] + ']');
					return _signedGuests[w][forms[i]].includes(gId);
				});
			});
		}

		/**
		 * Attempts to find guest demographic information within the order characs of a ticket.
		 * @public
		 * @param  {Object} ticket Ticket from view order response
		 * @returns {Object|null} Ticket
		 */
		function determineGuestDemographics(ticket) {
			var dob, guestObj, profile;
			var ticketCharacs = ticket.characs;
			var prefix = service._.scanForPrefix(ticketCharacs);

			if (ticketCharacs.guest_no && prefix !== null) {
				dob = formatYYYYMMDD(ticketCharacs[prefix + 'birth_date'], service._.getDateFormat());
				guestObj = service._.generateGuestObject(prefix, ticketCharacs.guest_no, dob, ticketCharacs);
			} else if (ticketCharacs.guest_no && ProfileLoginSessionService.isLoggedIn()) {
				// guest_no is known but characs lack demographic prefix fields (e.g. member benefit items).
				// Look up the guest from the profile rather than defaulting to the logged-in user,
				// which would cause the wrong guest's signed state to be checked for multi-guest flows.
				profile = ProfileLoginSessionService.getCurrentLoggedInProfile();
				var guestSource = [profile].concat(profile.linkedGuests()).find(function(g) {
					return g.guest_no == ticketCharacs.guest_no;
				}) || profile;
				dob = formatYYYYMMDD(guestSource.birth_date, service._.getDateFormat());
				guestObj = service._.generateGuestObject('', guestSource.guest_no, dob, guestSource);
			} else if (isValidString(ticketCharacs.WTP_guest_no)) {
				dob = ticketCharacs.WTP_birth_date.replace(/^(\d\d).(\d\d).(\d{4})$/, '$3-$1-$2');
				guestObj = service._.generateGuestObject('WTP_', ticketCharacs.WTP_guest_no, dob, ticketCharacs);
			} else if (ProfileLoginSessionService.isLoggedIn()) {
				profile = ProfileLoginSessionService.getCurrentLoggedInProfile();
				dob = formatYYYYMMDD(profile.birth_date, service._.getDateFormat());
				guestObj = service._.generateGuestObject('', profile.guest_no, dob, profile);
			} else {
				return null;
			}

			return guestObj;
		}

		/**
		 * Sends GetPackageForms request
		 * @public
		 * @function
		 * @param {String} packageId The package id
		 * @param {String} customerType The customer type
		 * @param {String} startDate The start date
		 * @param {String} startTime The start time
		 * @param {String[]} guestNo The guest number(s)
		 * @returns {Promise} GetPackageForms Promise
		 */
		function getPackageForms(packageId, customerType, startDate, startTime, guestNo) {
			var request = {
				customer_type: customerType,
				guest_no: guestNo[0],
				merchant_id: AppData.merchantId,
				package_id: packageId,
				show_1Risk_forms: '1'
			};

			if (isValidString(startDate)) {
				request.start_date = startDate;
			}

			if (isValidString(startTime)) {
				request.start_time = _getTimeFormat(startTime);
			}

			return AppData.fetch(Enums.services.GET_PACKAGE_FORMS, false, request, false);
		}

		/**
		 * Checks cart items if they have One Risk Setup
		 * @public
		 * @function
		 * @returns {Boolean} True if cart has items that need signing, false otherwise
		 */
		function cartHasOneRiskPackages() {
			return CartDataService.getLastSummary().cart.items.some(function oneRiskPackageFilter(item) {
				var pkg = Package.getPackageByID(item.package.id);

				if (!checkProp('pkg.CHARACS', pkg, 'validObject')) {
					return false;
				}

				return hasUnacceptedGuests(getGuestNoFromCartItem(item), pkg.CHARACS.oneRiskWaiverIds, pkg.CHARACS.formNumbers);
			});
		}

		/**
		 * Getter Function for private method _signedGuests
		 * @public
		 * @returns {Object} returns deep copy of Object
		 */
		function _getSignedGuests(){
			return angular.copy(_signedGuests);
		}

		/**
		 * Scans characs for a prefix for guest demographics
		 * @param {Object} characs The ticket characs
		 * @param {String} [key=first_name] The key to search
		 * @function
		 * @returns {String|null} The prefix found, null otherwise
		 */
		function _scanForPrefix(characs, key) {
			var foundKey = null;
			var re = new RegExp('^(\\w*)' + (key || 'first_name') + '$', 'i');

			Object.keys(characs).forEach(function iterateKeysForPrefix(key) {
				var matches;

				if ((matches = re.exec(key)) !== null && matches[1] !== 'WTP_') {
					foundKey = matches[1];
				}
			});

			return foundKey;
		}

		/**
		 * Generates a Guest Object while searching for optional fields
		 * @param {String} prefix The prefix (if any) that precededs the guest demographics
		 * @param {String} guestId The unique guest Id
		 * @param {String} dob The day of birth that should be sent in a YYYY-MM-DD or similar format
		 * @param {Object} info The object that contains all the potential values
		 * @function
		 * @returns {Object} The Guest Object
		 */
		function _generateGuestObject(prefix, guestId, dob, info) {
			// Email prefix as it may exist under a different prefix than the main
			var emailPrefix = service._.scanForPrefix(info, 'email');

			// Optional Fields for Guest (keys: 1Risk, values: Passport)
			var guestMap = {
				email: 'email',
				phone: 'phone_number'
			};

			// Optional Fields for Address (keys: 1Risk, values: Passport)
			var addressMap = {
				street1: 'address',
				street2: 'address2',
				country: 'country_code',
				city: 'city',
				state: 'state',
				postal: 'zip'
			};

			// Guest Object defined with required
			var guest = {
				firstName: info[prefix + 'first_name'],
				lastName: info[prefix + 'last_name'],
				dob: dob,
			};

			// Set different properties/values based upon which format we are using
			if (service._.isLegacyFormat()) {
				guest.guestId = guestId;
			} else {
				guest.posGuestId = guestId;
				guest.dob = guest.dob.replace(/[^\d]/gi, '');
			}

			// Iterate through guest optional fields to add, if exists
			Object.keys(guestMap).forEach(function guestMapIterator(infoKey) {
				var value = info[prefix + guestMap[infoKey]];
				if (value) {
					guest[infoKey] = value;
				}
			});

			// Iterate through address optional fields to add, if exists
			Object.keys(addressMap).forEach(function addressMapIterator(infoKey) {
				var value = info[prefix + addressMap[infoKey]];
				if (value) {
					if (!guest.address) {
						guest.address = {};
					}

					guest.address[infoKey] = value;
				}
			});

			// Add email, if exists, does not used main prefix, and is not already set
			if (emailPrefix !== null && !guest.email && isValidString(info[emailPrefix + 'email'])) {
				guest.email = info[emailPrefix + 'email'];
			}

			// Return our guest object
			return guest;
		}

		/**
		 * Gets the application date format
		 * @function
		 * @returns {String} The date format, default if doesn't exist
		 */
		function _getDateFormat() {
			if (!dateFormat) {
				dateFormat = AppData.settings.date_format || 'dd/MM/yyyy';
			}

			return dateFormat;
		}

		/**
		 * Sets the time format to HH:mm:ss
		 * @private
		 * @param {String} startTime the time to be formatted
		 * @returns {String} The time formatted to HH:mm:ss
		 */
		 function _getTimeFormat(startTime){
			var date = Utilities.transformDateWithTimeFromTimeString(new Date(), startTime),
			dateArr = startTime.split(':');

			date.setSeconds(isValidString(dateArr[2]) ? dateArr[2].split(' ')[0] : 0);

			return $filter('date')(date, 'HH:mm:ss');
		}

		/**
		 * Routes to CartView
		 * @function
		 * @returns {undefined}
		 */
		 function routeToCart() {
			$rootScope.showSpinner();
			$rootScope.routeTo(Enums.routes.CART);
		}
	}
})();

(function() {
	'use strict';

	angular
		.module('sms-verification', ['app'])
		.constant('SMS_VERIFICATION_ASSETS', [
			'scripts/modules/sms-verification/controllers/sms-verification-modal-controller.js'
		])
		.run(run);

	/**
	 * Always remove sms verification after purchase.
	 * @public
	 * @param {Service} CustomActionService CustomActionService
	 * @param {Service} Storage Storage
	 * @param {Service} SMSVerificationService SMSVerificationService
	 * @returns {undefined}
	 * @ngInject
	 */
	function run(CustomActionService, Storage, SMSVerificationService) {
		CustomActionService.registerCustomActionForChain(CustomActionService.ACTIONS_ENUMS.PURCHASE_COMPLETE_SUCCESS, function() {
			SMSVerificationService.setSMSVerificationStatus(false);
		});
	}
})();

/* eslint-disable camelcase */
(function() {
	'use strict';

	angular
		.module('sms-verification')
		.factory('SMSVerificationService', SMSVerificationService);

	/**
	 * SMS Verification Service
	 * @constructor
	 * @param {Service} $q $q service
	 * @param {Service} $rootScope $rootScope service
	 * @param {Service} $uibModal $uibModal service
	 * @param {Service} AppData AppData service
	 * @param {Service} Enums Enums service
	 * @param {Service} JSONValidator JSONValidator service
	 * @param {Service} CustomActionService CustomActionService
	 * @param {Service} RecaptchaV3Service RecaptchaV3Service
	 * @param {Service} Storage Storage
	 * @param {Service} Utilities Utilities service
	 * @param {Service} UtilsValidation Validation service
	 * @param {Service} UserInfo UserInfo
	 * @returns {self} SMSVerificationService
	 * @ngInject
	 */
	function SMSVerificationService($q, $rootScope, $uibModal, AppData, Enums, JSONValidator, CustomActionService, RecaptchaV3Service, Storage, Utilities, UtilsValidation, UserInfo) {
		var validString = UtilsValidation.validString;
		var service = {
				closeModal: closeModal,
				displaySMSVerification: displaySMSVerification,
				isSMSVerificationConfigured: isSMSVerificationConfigured,
				moduleConfiguredForVerification: moduleConfiguredForVerification,
				openModal: openModal,
				requestSMSCode: requestSMSCode,
				setSMSVerificationStatus: setSMSVerificationStatus,
				verifySMSCode: verifySMSCode
			},
			modalInstance = null,
			isSMSVerificationCompleted = Storage.get('sms_verify') === '1' && validString((UserInfo.billing || {}).phone);

		return service;

		/**
		 * Find out if we should verify their phone number with SMS
		 * @param {Object} config The sms_verification config
		 * @param {String} moduleName The module to find in the modules array
		 * @returns {boolean} If we should verify or not.
		 */
		function moduleConfiguredForVerification(config, moduleName) {
			if (!Utilities.safelyCheckPropertyOnObject('config.module', config, UtilsValidation.validArray) || !validString(moduleName)) {
				return false;
			}

			return config.module.indexOf(moduleName) > -1;
		}

		/**
		 * Checks if SMS Verification is configured
		 * @public
		 * @returns {Boolean} true/false
		 */
		function isSMSVerificationConfigured() {
			var smsVerificationConfig;
			if (JSONValidator.validate('sms_verification', AppData.settings.sms_verification)) {
				smsVerificationConfig = JSON.parse(AppData.settings.sms_verification);
				if (smsVerificationConfig.enable_sms_verification && !CustomActionService.actionRegistered(CustomActionService.ACTIONS_ENUMS.ALLOW_SMS_VERIFICATION)) {
					CustomActionService.registerCustomAction(CustomActionService.ACTIONS_ENUMS.ALLOW_SMS_VERIFICATION, allowSMSVerification);
				}
				return smsVerificationConfig.enable_sms_verification;
			}
			return false;
		}

		/**
		 * Display SMS Verification Modal if SMS Verification is not completed
		 * @protected
		 * @returns {Boolean} true/false
		 */
		function allowSMSVerification() {
			if (!isSMSVerificationCompleted) {
				service.displaySMSVerification();
				return true;
			}
			return false;
		}

		/**
		 * Display SMS modal
		 * @public
		 * @param {Object} options The options object to extend the default properties
		 * @returns {undefined}
		 */
		function displaySMSVerification(options) {
			var isFunction = angular.isFunction;
			var modalObject = angular.extend({
				animation: false,
				backdrop: 'static',
				controller: 'SMSVerificationModalController',
				controllerAs: 'vm',
				templateUrl: 'scripts/modules/sms-verification/views/sms-verification-modal.html',
				windowClass: "modal-small"
			}, options);

			if (!UtilsValidation.isRealObject(modalObject.resolve)) {
				modalObject.resolve = {};
			}

			['onVerify', 'prepopulateCountryCode', 'prepopulatePhoneNumber'].forEach(function(functionName) {
				if (!isFunction(modalObject.resolve[functionName])) {
					modalObject.resolve[functionName] = angular.noop;
				}
			});

			if (!UtilsValidation.isBoolean(modalObject.resolve.resetStatusOnVerify)) {
				modalObject.resolve.resetStatusOnVerify = false;
			}

			service.openModal(modalObject);
		}

		/**
		 * Sets if sms verification is completed or not
		 * Executes SMS Verification Complete custom action if SMS Verification is completed
		 * @param {Boolean} status sms verification completed / not
		 * @returns {undefined}
		 */
		function setSMSVerificationStatus(status) {
			isSMSVerificationCompleted = Utilities.getBoolean(status);
			if (isSMSVerificationCompleted) {
				if (CustomActionService.actionRegistered(CustomActionService.ACTIONS_ENUMS.SMS_VERIFICATION_COMPLETE)) {
					CustomActionService.executeCustomAction(CustomActionService.ACTIONS_ENUMS.SMS_VERIFICATION_COMPLETE);
					CustomActionService.registerCustomAction(CustomActionService.ACTIONS_ENUMS.SMS_VERIFICATION_PURCHASE_COMPLETE, setSMSVerificationCompleted);

					Storage.set('sms_verify', '1');
				}
			} else {
				Storage.remove('sms_verify');
			}
		}

		/**
		 * Set SMSVerification as completed to show SMS Verification Modal on new orders
		 * @protected
		 * @returns {undefined}
		 */
		function setSMSVerificationCompleted() {
			service.setSMSVerificationStatus(false);
		}

		/**
		 * Opens uibModal
		 * @public
		 * @param {Object} modalObject modalObject
		 * @returns {undefined}
		 */
		function openModal(modalObject) {
			modalInstance = $uibModal.open(modalObject);
			$rootScope.modalOpen = true;
		}

		/**
		 * Close Modal
		 * @public
		 * @returns {undefined}
		 */
		function closeModal() {
			if (angular.isObject(modalInstance)) {
				modalInstance.close();
			}
			modalInstance = null;
			$rootScope.modalOpen = false;
		}

		/**
		 * Request SMS Code
		 * @public
		 * @param {String} countryCode country code
		 * @param {String} phone Phone number
		 * @returns {Boolean} true/false
		 */
		function requestSMSCode(countryCode, phone) {
			var requestObj = {
				cart_id: AppData.cart.cart_id,
				country_code: countryCode,
				language: AppData.language,
				merchant_id: AppData.GetMerchantDetails.merchant_id,
				mobile_number: phone,
				session_id: $rootScope.sessionID
			};
			return $q(function(resolve, reject) {
				RecaptchaV3Service.execute(RecaptchaV3Service.ACTION.SENDSMSCODE).then(function onRecaptchaToken(token) {
					if (validString(token)) {
						requestObj.recaptcha_token = token;
					}

					AppData.fetch(Enums.services.REQUEST_SMS_CODE, false, requestObj)
						.then(function(response) {
							resolve(response);
						}).catch(function() {
							reject();
						});
				})
			});
		}

		/**
         * Validate PIN
         * @public
		 * @param {String} countryCode country code
         * @param {String} phone Phone number
         * @param {String} validationCode Validation Code
         * @returns {Boolean} true/false
         */
		function verifySMSCode(countryCode, phone, validationCode) {
			var requestObj = {
				cart_id: AppData.cart.cart_id,
				country_code: countryCode,
				merchant_id: AppData.GetMerchantDetails.merchant_id,
				mobile_number: phone,
				session_id: $rootScope.sessionID,
				validation_code: validationCode
			};
			return AppData.fetch(Enums.services.VERIFY_SMS_CODE, false, requestObj).then(function(response) {
				return response.status === Enums.status.OK;
			});
		}
	}
})();

(function() {
	'use strict';

	angular
		.module('te2', ['app', 'te2-onboarding', 'te2-generic-modal'])
		// Used for determining which section to use, for Locale strings on the Generic Modal
		.constant('TE2GenericModalTypes', {
			ACC_ALREADY_EXIST: "TE2GenericAccExists",
			ACC_REG_SUCCESS: "TE2GenericCreateAcc",
			EMBED_ORDER_LINKED: "TE2GenericEmbedOrderLinked",
			EMBED_PROMPT_CREATE: "TE2GenericEmbedPromptCreate",
			ORDER_LINKED: "TE2GenericOrderLinked"
		})
		// "Guest Account" is a backend-only opt status denoting a hidden account was made for this order, and we don't want to show the user a popup
		.constant('TE2OrderOptStatus', {
			EXISTING_ACCOUNT_LINK: "EXISTING_ACCOUNT_LINK",
			GUEST_ACCOUNT: "GUEST_ACCOUNT",
			OPT_IN_INITIAL: "OPT_IN_INITIAL",
			OPT_IN_SUBSEQUENT: "OPT_IN_SUBSEQUENT",
			OPT_OUT_ORDER: "OPT_OUT_ORDER",
			OPT_OUT_SESSION: "OPT_OUT_SESSION",
			UNKNOWN: "UNKNOWN"
		});
})();
(function() {
	'use strict';

	angular
		.module('te2')
		.service('TE2PrepService', TE2PrepService);

	/**
	 * The TE2 Prep Service
	 * @param {Service} $location location service
	 * @param {Service} $q the $q
	 * @param {Service} $injector the $injector service
	 * @param {Service} AppData The Appdata service
	 * @param {Service} CustomActionService The CustomAction service
	 * @param {Service} JSONValidator the JSON validator
	 * @param {Service} Utilities our utilities service
	 * @param {Service} UtilsValidation our validation utility service
	 * @returns {self} this service
	 * @ngInject
	 */
	function TE2PrepService($location, $q, $injector, AppData, CustomActionService, JSONValidator, Utilities, UtilsValidation) {
		var validString = UtilsValidation.validString;
		var originalTe2Session = $location.search().te2_session;
		var service = {
			getTE2Token: getTE2Token,
			initialize: initialize,
			initialized: false,
			resetInitializeFlag: resetInitializeFlag
		};

		return service;

		/**
		 * Returns the original te2_session parameter that was in the url
		 * @public
		 * @returns {undefined|string} The original te2 session
		 */
		function getTE2Token() {
			return originalTe2Session;
		}

		/**
		 * Lazily loads and initializes the TE2 module and all dependant modules.
		 * @public
		 * @returns {Promise} Promise that lazily loads and initializes the TE2 module and all dependant modules.
		 */
		function initialize() {
			return $q(function(resolve) {
				if (service.initialized) {
					resolve();
					return;
				} else if (!validString(AppData.settings.te2) || !JSONValidator.validate('te2', AppData.settings.te2)) {
					service.initialized = true;
					resolve();
					return;
				}

				service.initialized = true;
				Utilities.cacheBustAndLazyLoad([
					'/scripts/modules/te2/services/te2-service.js',
					'/scripts/modules/te2/modules/te2-generic-modal/controllers/te2-generic-modal-controller.js'
				]).then(function() {
					var TE2Service = $injector.get('TE2Service');
					var token = service.getTE2Token() || $location.search().access_token;
					var te2Settings = TE2Service.getSettings();
					if (!angular.isObject(te2Settings)) {
						TE2Service.initializeSettings();
					}
					CustomActionService.registerCustomActionForChain(CustomActionService.ACTIONS_ENUMS.PURCHASE_COMPLETE_SUCCESS, service.resetInitializeFlag, 'TE2');

					if (validString(token)) {
						TE2Service.setTE2Token(token);
						return TE2Service.getTE2Profile();
					}
				}).finally(resolve);
			});
		}

		/**
		 * Resets the initialized flag.
		 * This is a function so that it may be called from a custom action, and so it can be expanded on or tested independently.
		 * @public
		 * @returns {undefined}
		 */
		function resetInitializeFlag() {
			service.initialized = false;
		}
	}

})();
(function() {
	'use strict';

	angular
		.module('te2-onboarding', ['app', 'te2'])
		.run(function($q, $injector, $rootScope, AppData, Enums, JSONValidator, PostPurchaseActionsService, Utilities) {
			PostPurchaseActionsService.registerAction(function() {
				if (angular.isString(AppData.settings.te2) && JSONValidator.validate('te2', AppData.settings.te2)) {
					return Utilities
						.cacheBustAndLazyLoad([
							'/scripts/modules/te2/modules/te2-onboarding/services/te2-onboarding-service.js',
							'/scripts/modules/te2/modules/te2-onboarding/controllers/te2-onboarding-controller.js'
						])
						.then(function() {
							var TE2OnboardingService = $injector.get('TE2OnboardingService');
							return TE2OnboardingService.displayPostPurchaseModal();
						});
				} else {
					return $q.resolve();
				}
			});
		});
})();
(function() {
	'use strict';

	angular.module('te2-generic-modal', ['app', 'te2']);
})();
/* eslint-disable sort-keys */
(function() {
	'use strict';

	angular
		.module('stored-payments', [])
		.run(initializePrepService);
	/**
	 * Initialize the StoredPaymentPrepService
	 * @param {Object} BillingService Billing Service
	 * @param {Object} StoredPaymentPrepService StoredPaymentPrepService
	 * @returns {undefined}
	 */
	function initializePrepService(BillingService, StoredPaymentPrepService) {
		// trigger loading of the prep service so that it can listen for application activated event
		BillingService.appendPaymentMethodLoadPromise(StoredPaymentPrepService.initializeAndLoadStoredPaymentsConfig);
	}
})();

(function() {
	'use strict';

	angular
		.module('stored-payments')
		.factory('StoredPaymentPrepService', StoredPaymentPrepService);

	/**
	 * General StoredPaymentsPrepService
	 * @param {Service} $injector Injector Service
	 * @param {Service} $q Promise Service
	 * @param {Service} $location $location
	 * @param {Service} AppData our AppData Service
	 * @param {Service} CustomActionService CustomActionService
	 * @param {Service} Enums our Enums Service
	 * @param {Service} JSONValidator JSONValidator
	 * @param {Service} Utilities our Utilities Service
	 * @param {Service} UtilsValidation our UtilsValidation Service
	 * @returns {Service} StoredPaymentsPrepService
	 * @ngInject
	 */
	function StoredPaymentPrepService($injector, $q, $location, AppData, CustomActionService, Enums, JSONValidator, Utilities, UtilsValidation) {
		var isObject = angular.isObject;
		var validString = UtilsValidation.validString;
		var validArray = UtilsValidation.validArray;
		var validObject = UtilsValidation.validObject;
		var STORED_PAYMENTS_DIRECTORY = '/scripts/modules/stored-payments/';
		var SUPPORTED_BILLING_TYPES = ['Adyen', 'Cybersource'];
		var service = {
			getStoredPaymentBillingTypes: getStoredPaymentBillingTypes,
			initializeAndLoadStoredPaymentsConfig: initializeAndLoadStoredPaymentsConfig,
			storedPaymentBillingTypeExists: storedPaymentBillingTypeExists,
			storedPaymentsIsConfigured: storedPaymentsIsConfigured,
			useStoredPaymentsForFolios: useStoredPaymentsForFolios
		};

		return service;

		/**
		 * Function to initialize and load configs
		 * @public
		 * @returns {undefined}
		 */
		function initializeAndLoadStoredPaymentsConfig() {
			return $q(function(resolve) {
				if (storedPaymentsIsConfigured()) {
					Utilities.cacheBustAndLazyLoad([
						STORED_PAYMENTS_DIRECTORY + 'services/stored-payments-collection-service.js',
						STORED_PAYMENTS_DIRECTORY + 'components/stored-card-selection/stored-card-selection-controller.js',
						STORED_PAYMENTS_DIRECTORY + 'components/stored-card-selection/stored-card-selection.css',
						STORED_PAYMENTS_DIRECTORY + 'components/stored-card-selection/stored-card-selection.html',
						STORED_PAYMENTS_DIRECTORY + 'components/stored-card-selection/stored-card-selection-component.js',
						STORED_PAYMENTS_DIRECTORY + 'components/save-card-check/save-card-check-controller.js',
						STORED_PAYMENTS_DIRECTORY + 'components/save-card-check/save-card-check.html',
						STORED_PAYMENTS_DIRECTORY + 'components/save-card-check/save-card-check-component.js'
					]).then(function() {
						var StoredPaymentsCollectionService = $injector.get('StoredPaymentsCollectionService');
						return StoredPaymentsCollectionService.initialize();
					}).finally(resolve);
				} else {
					resolve();
				}
			});
		}

		/**
		 * Returns whether or not Stored Payments behavior is configured in the Merchant's App Config
		 * @public
		 * @returns {boolean} whether or not Stored Payments behavior is configured in the Merchant's App Config
		 */
		function storedPaymentsIsConfigured() {
			var TE2Service,
				te2Settings;
			try {
				if ($injector.has('TE2Service')) {
					TE2Service = $injector.get('TE2Service');
					te2Settings = TE2Service.getSettings();
					return Utilities.getBoolean(AppData.settings.use_stored_payments) && isObject(te2Settings) && isObject(te2Settings.TE2AccountInfo) && service.storedPaymentBillingTypeExists();
				} else {
					return service.useStoredPaymentsForFolios();
				}
			} catch (e) {}
			return false;
		}

		/**
		 * Returns if we can use stored payments for folios
		 * @returns {Boolean} true, if we can use stored payments
		 */
		function useStoredPaymentsForFolios() {
			var paymentInformation;
			if (CustomActionService.actionRegistered(CustomActionService.ACTIONS_ENUMS.GET_PAYMENT_INFO_FOR_FOLIOS)) {
				paymentInformation = CustomActionService.executeCustomAction(CustomActionService.ACTIONS_ENUMS.GET_PAYMENT_INFO_FOR_FOLIOS);
			}
			return validString($location.search().sfOffer) && validObject(paymentInformation) && validString(paymentInformation.token) && !JSONValidator.validate('disableStoredPaymentsForFolios', AppData.settings.disableStoredPaymentsForFolios);
		}

		/**
		 * Checks AppData for the StoredPayments billing type and returns it.
		 * @public
		 * @returns {boolean} StoredPayment billing type object or undefined.
		 */
		function storedPaymentBillingTypeExists() {
			return validArray(service.getStoredPaymentBillingTypes());
		}

		/**
		 * Get all billing types that are for the StoredPayments provider
		 * @public
		 * @returns {Array} Array of billing types
		 */
		function getStoredPaymentBillingTypes() {
			return AppData.billingTypes.filter(function(billingType) {
				return validString(billingType.billing_provider_desc) && SUPPORTED_BILLING_TYPES.indexOf(billingType.billing_provider_desc) > -1 && billingType.auth_type === Enums.authTypes.CREDITCARD;
			});
		}
	}
})();

/* global URL */
angular
	.module('season-pass-select', [
		'app',
		'passholder-lookup',
		'imagecaptures',
		'interstitial-dining',
		'composition-library'
	])
	.config(function($locationProvider, $stateProvider, ComponentLoaderEnums, InterstitialDiningConstants) {
		const SEASON_PASS_SELECT_DIRECTORY = '/scripts/modules/season-pass-select';
		const GPS_LOGIN_RETURN_PATH_KEY = 'gps_login_return_path';
		const GPS_LOGIN_RETURN_TS_KEY = 'gps_login_return_ts';
		const GPS_LOGIN_MAX_AGE_MS = 30 * 60 * 1000;

		// GPS-1276: on bfcache Back from IdP, resolves don't re-run; hide body in pagehide so cached page starts blank, then redirect in pageshow.
		window.addEventListener('pagehide', function onGpsLoginPageHide() {
			if (sessionStorage.getItem(GPS_LOGIN_RETURN_PATH_KEY)) {
				document.body.style.display = 'none';
			}
		});

		window.addEventListener('pageshow', function onGpsLoginPageShow(event) {
			if (!event.persisted) { return; }
			var returnPath = sessionStorage.getItem(GPS_LOGIN_RETURN_PATH_KEY);
			var savedTs = parseInt(sessionStorage.getItem(GPS_LOGIN_RETURN_TS_KEY) || '0', 10);
			if (returnPath && savedTs && (Date.now() - savedTs < GPS_LOGIN_MAX_AGE_MS)) {
				sessionStorage.removeItem(GPS_LOGIN_RETURN_PATH_KEY);
				sessionStorage.removeItem(GPS_LOGIN_RETURN_TS_KEY);
				sessionStorage.removeItem('gps_xfc_pending');
				window.location.replace(returnPath);
			} else {
				if (returnPath) {
					sessionStorage.removeItem(GPS_LOGIN_RETURN_PATH_KEY);
					sessionStorage.removeItem(GPS_LOGIN_RETURN_TS_KEY);
					sessionStorage.removeItem('gps_xfc_pending');
				}
				document.body.style.display = '';
			}
		});

		//main parent state is season-pass-select - the reason why we have a main parent state is if we ever want to offer this module as an actual
		//alternate module, we can easily build an extension to do so - this decouples the season pass module from the XFC flow
		$stateProvider
			.state('season-pass-select', {
				abstract: true,
				components: [ComponentLoaderEnums.imageCapture, ComponentLoaderEnums.verticalSlider],
				resolve: {
					assessGpsLogin: function(config, $rootScope, $q, $injector, $location, $log, $window, Package, $transition$, $state, RouteRejectionService) {
						const savedReturnPath = $window.sessionStorage.getItem(GPS_LOGIN_RETURN_PATH_KEY);
						const savedTs = parseInt($window.sessionStorage.getItem(GPS_LOGIN_RETURN_TS_KEY) || '0', 10);
						const isPendingAndFresh = !!(savedReturnPath && savedTs && (Date.now() - savedTs < GPS_LOGIN_MAX_AGE_MS));

						function clearLoginState() {
							$window.sessionStorage.removeItem(GPS_LOGIN_RETURN_PATH_KEY);
							$window.sessionStorage.removeItem(GPS_LOGIN_RETURN_TS_KEY);
							$window.sessionStorage.removeItem('gps_xfc_pending');
						}

						// Successful OIDC return re-enters here authenticated with key set; isAuthenticated() below handles it.
						const isAuthenticatedReturn = $rootScope.configuredForPassportAuth &&
							$injector.has('AuthService') && $injector.get('AuthService').isAuthenticated();

						// Back-nav check runs before configuredForPassportAuth guard: on cold reload that flag may not be set yet.
						if (isPendingAndFresh && !isAuthenticatedReturn) {
							var redirectPath = savedReturnPath.split('?')[0];
							clearLoginState();
							// Path matches the saved target: fall through to OIDC. Otherwise route back (query stripped).
							if ($location.path() !== redirectPath) {
								throw new RouteRejectionService.UnrecoverableException(redirectPath);
							}
						}

						if (!$rootScope.configuredForPassportAuth || !$injector.has('AuthService')) {
							if (savedReturnPath) { clearLoginState(); }
							return $q.when();
						}

						const AuthService = $injector.get('AuthService');

						if (AuthService.isAuthenticated()) {
							$window.sessionStorage.removeItem(GPS_LOGIN_RETURN_PATH_KEY);
							$window.sessionStorage.removeItem(GPS_LOGIN_RETURN_TS_KEY);
							return $q.when();
						}

						// Stale key present (older than GPS_LOGIN_MAX_AGE_MS) — clear it and proceed normally.
						if (savedReturnPath) {
							$window.sessionStorage.removeItem(GPS_LOGIN_RETURN_PATH_KEY);
							$window.sessionStorage.removeItem(GPS_LOGIN_RETURN_TS_KEY);
						}

						// During a resolve $location.url() is the FROM (package details) URL — save as return target.
						const merchantId = $location.search()['_m'];
						var rawUrl = $location.url();
						// Exception: bfcache-restored packageDetails auto-resuming a transition freezes $location.url() at SSP URL; redirect instead to break the loop.
						if (rawUrl && rawUrl.indexOf('/season-pass-select') === 0) {
							var pkgId = Package.packageDetails && Package.packageDetails.id;
							var sspFallbackPath = pkgId ? ('/packageDetails/' + pkgId) : '/';
							throw new RouteRejectionService.UnrecoverableException(sspFallbackPath);
						}
						const returnPath = rawUrl;
						if (returnPath) {
							$window.sessionStorage.setItem(GPS_LOGIN_RETURN_PATH_KEY, returnPath);
							$window.sessionStorage.setItem(GPS_LOGIN_RETURN_TS_KEY, String(Date.now()));
						}

						let targetUrl = $state.href($transition$.to().name, $transition$.params('to'));
						if (merchantId) {
							targetUrl += `${targetUrl.indexOf('?') !== -1 ? '&' : '?' }_m=${ encodeURIComponent(merchantId)}`;
						}

						try {
							$window.sessionStorage.setItem('gps_xfc_pending', JSON.stringify({
								itemsToBeAdded: Package.itemsToBeAdded,
								packageDetails: Package.packageDetails
							}));
						} catch (e) {
							$log.warn('[GPS] Failed to serialize XFC state for login redirect — user will return to package details:', e);
						}

						return AuthService.initiateAccessoIdLogin({ returnUrl: targetUrl })
							.catch(function onLoginCancelled() {
								clearLoginState();
								throw new RouteRejectionService.UnrecoverableException($rootScope.previousRoute);
							});
					},
					assessRoutability: function(assessGpsLogin, gpsProfilesReady, RouteRejectionService, Package, $q, $state, $transition$, $window, $log, $rootScope, $injector, Enums) {
						const pendingXfcJson = $window.sessionStorage.getItem('gps_xfc_pending'),
							routing = $q.defer();
						let pendingXfc,
							rejectionRoute;

						// Restore XFC state that was saved before the OIDC login redirect.
						// Package.itemsToBeAdded is empty after a page reload so assessRoutabilityOfXFC
						// would otherwise reject and bounce the user back to package details.
						if (pendingXfcJson && (!Package.itemsToBeAdded || !Package.itemsToBeAdded.length)) {
							try {
								pendingXfc = JSON.parse(pendingXfcJson);
								if (!pendingXfc || !pendingXfc.packageDetails || !pendingXfc.itemsToBeAdded) {
									$log.warn('[GPS] Malformed XFC state in sessionStorage — falling back to package details');
									$window.sessionStorage.removeItem('gps_xfc_pending');
								} else {
									Package.resumeXFCState(
										pendingXfc.packageDetails,
										pendingXfc.itemsToBeAdded,
										function onXfcComplete() {
											$injector.get('LegacyCart').addCartItems(Package.itemsToBeAdded, function() {
												$rootScope.routeTo(Enums.routes.CART);
											});
										}
									);
									$window.sessionStorage.removeItem('gps_xfc_pending');
								}
							} catch (e) {
								$log.warn('[GPS] Failed to restore XFC state from sessionStorage — falling back to package details:', e);
							}
						}

						if ($state.next.name.indexOf('season-pass-select.xfc') > -1) {
							rejectionRoute = Package.assessRoutabilityOfXFC($transition$.params().packageId);
							if (rejectionRoute.length > 0) {
								routing.reject(new RouteRejectionService.UnrecoverableException(rejectionRoute));
							} else {
								routing.resolve();
							}
						} else {
							routing.resolve();
						}
						return routing.promise;
					},
					config: function(initialData, $log, $q, $rootScope, FormConfiguration, RouteRejectionService, $injector) {
						// FormConfiguration included to ensure it loads before controller

						if ($injector.get('SeasonPassSelectPrepService').getConfigurationSettings()) {
							return $q.when()
						} else {
							$log.error('Season Pass Select app config not present');
							return $q.reject(new RouteRejectionService.ViewException(undefined, undefined, undefined, $rootScope.previousRoute));
						}
					},
					gpsProfilesReady: function(assessGpsLogin, $rootScope, $q, $injector) {
						if (!$rootScope.configuredForPassportAuth || !$injector.has('AuthService')) {
							return $q.when();
						}
						const AuthService = $injector.get('AuthService');
						if (!AuthService.isAuthenticated()) {
							return $q.when();
						}
						const GuestProfileSessionService = $injector.get('GuestProfileSessionService');
						if (Array.isArray(GuestProfileSessionService.guests)) {
							return $q.when();
						}
						return GuestProfileSessionService.ensureLoaded()
							.catch(function onProfilesError() {
								// Non-fatal — controller will render the 'self' placeholder fallback.
							});
					},
					initialData: function(load, Bootstrap) {
						return Bootstrap.bootstrapApplication();
					},
					//resolve failures are handled within run.js of main app
					load: function($rootScope, Utilities) {
						$rootScope.showSpinner();

						return Utilities.cacheBustAndLazyLoad([
							'/scripts/modules/composition-library/tracking/compose-alternate-module-google-analytics.js',
							`${SEASON_PASS_SELECT_DIRECTORY }/controllers/season-pass-select-controller.js`,
							`${SEASON_PASS_SELECT_DIRECTORY }/controllers/season-pass-select-addons-controller.js`,
							`${SEASON_PASS_SELECT_DIRECTORY }/controllers/season-pass-select-pass-type-selection-controller.js`,
							`${SEASON_PASS_SELECT_DIRECTORY }/controllers/season-pass-select-pass-demographics-controller.js`,
							`${SEASON_PASS_SELECT_DIRECTORY }/controllers/season-pass-select-capture-selection-controller.js`,
							`${SEASON_PASS_SELECT_DIRECTORY }/controllers/season-pass-select-onsite-controller.js`,
							`${SEASON_PASS_SELECT_DIRECTORY }/controllers/season-pass-select-profileimage-controller.js`,
							`${SEASON_PASS_SELECT_DIRECTORY }/controllers/season-pass-select-mail-controller.js`,
							`${SEASON_PASS_SELECT_DIRECTORY }/controllers/season-pass-select-agreements-controller.js`,
							`${SEASON_PASS_SELECT_DIRECTORY }/services/season-pass-select-enums-service.js`,
							`${SEASON_PASS_SELECT_DIRECTORY }/services/season-pass-select-pass-collection-service.js`,
							`${SEASON_PASS_SELECT_DIRECTORY }/services/season-pass-select-prep-service.js`,
							`${SEASON_PASS_SELECT_DIRECTORY }/services/season-pass-select-routing-service.js`,
							`${SEASON_PASS_SELECT_DIRECTORY }/services/season-pass-select-request-service.js`,
							`${SEASON_PASS_SELECT_DIRECTORY }/services/season-pass-select-tracking-service.js`,
							`${SEASON_PASS_SELECT_DIRECTORY }/styles/sp-photo-guide.css`,
							`${SEASON_PASS_SELECT_DIRECTORY }/season-pass-select-models.js`,
							`${SEASON_PASS_SELECT_DIRECTORY }/directives/duplicate-email-validator-directive.js`,
							`${SEASON_PASS_SELECT_DIRECTORY }/components/season-pass-select-progress-component.js`,
							`${SEASON_PASS_SELECT_DIRECTORY }/components/season-pass-profile-selector/styles/season-pass-profile-selector.css`,
							`${SEASON_PASS_SELECT_DIRECTORY }/components/season-pass-profile-selector/controllers/season-pass-profile-selector-controller.js`,
							`${SEASON_PASS_SELECT_DIRECTORY }/components/season-pass-profile-selector/season-pass-profile-selector.js`
						]);
					},
					loadPackageCharacs: function(resetTempFile, Package, CustomerTypeService, $transition$, $q) {
						if ($transition$.to().name.indexOf('season-pass-select.xfc') === -1) {
							return $q.when();
						}

						return CustomerTypeService.loadCTCharacs($transition$.params().packageId);
					},
					//resolve failures are handled within run.js of main app
					passCollection: function(loadPackageCharacs, $injector, Package, Utilities) {
						const isNotASeasonPass = Package.settings.name == 'ticket_demographics',
							useDateFormat = Utilities.safelyCheckPropertyOnObject('service.config.birth_date_to_date_format', $injector.get('SeasonPassSelectPrepService'), 'returnValue');
						let imageCaptureNeeded = true;

						if (!$injector.has('SeasonPassSelectPassCollectionService')) {
							return;
						}

						if (isNotASeasonPass) {
							imageCaptureNeeded = (angular.isDefined(Package.packageDetails.CHARACS) && Utilities.getBoolean(Package.packageDetails.CHARACS.includeImageCapture));
						}

						return $injector.get('SeasonPassSelectPassCollectionService').createPassCollectionForXFC(isNotASeasonPass, imageCaptureNeeded, useDateFormat);
					},
					previousState: buildPreviousState,
					resetTempFile: function(xfcMap, ImageCaptureTempImageService) {
						return ImageCaptureTempImageService.resetTempFileInfoAndSetMaxViewDimensions(200, 200);
					},
					xfcMap: function(assessRoutability, Package) {
						return Package.buildXFCMap();
					}

				},
				template: '<div ui-view></div>',
				title: 'seasonPassSelect',
				url: '/season-pass-select'
			})
			.state('season-pass-select.xfc', {
				abstract: true,
				components: [ComponentLoaderEnums.imageCapture, ComponentLoaderEnums.verticalSlider],
				controller: 'SeasonPassSelectController',
				resolve: {
					setActivePassAndRoute: function(passCollection, RouteRejectionService, Package,
						SeasonPassSelectPassCollectionService, SeasonPassSelectPrepService,
						$state, $transition$, CustomActionService, $q, $rootScope) {
						const settingPass = $q.defer();
						const stateParams = $transition$.params();

						// unregister all custom actions associated with this state. The ones that are needed will be registered.
						CustomActionService.deregisterArrayofActions(['SeasonPassSelectContinueButton', 'SeasonPassSelectImageCaptureSelection', 'SeasonPassSelectBackButton', 'SeasonPassSelectPrintButton', 'SeasonPassSelectContinueButtonText']);

						SeasonPassSelectPassCollectionService.setPassAsActiveForGivenIndex(stateParams.itemIndex, stateParams.characIndex, passCollection);
						let activePass = SeasonPassSelectPassCollectionService.findActivePassInCollection(passCollection);

						if (angular.isUndefined(activePass)) {
							const nextItemIndex = passCollection[0].items_to_be_added_array_idx;
							const nextCharacIndex = passCollection[0].characs_array_idx;

							SeasonPassSelectPassCollectionService.setPassAsActiveForGivenIndex(nextItemIndex, nextCharacIndex, passCollection);
							activePass = SeasonPassSelectPassCollectionService.findActivePassInCollection(passCollection);
						}

						if (activePass && activePass.addon_packages) {
							activePass.addon_packages.forEach(function setParentPassId(passAddon) {
								passAddon.parent_pass_id = activePass.group_uuid; // eslint-disable-line camelcase
							});
						}

						//Get images for profiles if profiles enabled
						if (CustomActionService.actionRegistered(CustomActionService.ACTIONS_ENUMS.SETUP_SEASON_PASS_SELECT_XFC) && SeasonPassSelectPrepService.useProfilesOnSeasonPass) {
							CustomActionService.executeCustomAction(CustomActionService.ACTIONS_ENUMS.SETUP_SEASON_PASS_SELECT_XFC);
						}

						$rootScope.showSpinner();
						if (angular.isDefined(activePass) && activePass.isValid() && !Package.isEditing() && $state.next.name.indexOf('season-pass-select.xfc.addons') === -1 && activePass.addon_packages.length > 0) {
							settingPass.reject(new RouteRejectionService.UnrecoverableException('season-pass-select.xfc.addons', stateParams));
						} else if (angular.isDefined(activePass) && !activePass.offer_renewal_option && $state.next.name.indexOf('season-pass-select.xfc.pass-demographics') === -1 && (activePass.addon_packages.length <= 0 || Package.isEditing())) {
							//otherwise if the pass does is not to be offered the renewal option and its not yet valid, go immediately to demographics
							settingPass.reject(new RouteRejectionService.UnrecoverableException('season-pass-select.xfc.pass-demographics', stateParams));
						} else {
							settingPass.resolve();
						}
						return settingPass.promise;
					}
				},
				templateUrl: `${SEASON_PASS_SELECT_DIRECTORY }/views/season-pass-select.html`,
				title: 'seasonPassSelectXfc',
				url: '/xfc/:packageId/:itemIndex/:characIndex'
			})
			.state('season-pass-select.xfc.pass-type-selection', {
				controller: 'SeasonPassSelectPassTypeSelectionController',
				resolve: {
					loadAssets: function(Utilities) {
						return Utilities.cacheBustAndLazyLoad([
							`${SEASON_PASS_SELECT_DIRECTORY }/styles/pass-type.css`
						]);
					},
					previousState: buildPreviousState,
					skipPassTypeSelection: function(setActivePassAndRoute, passCollection, $stateParams, RouteRejectionService, SeasonPassSelectPassCollectionService) {
						const activePass = SeasonPassSelectPassCollectionService.findActivePassInCollection(passCollection);
						if (activePass && !activePass.offer_renewal_option) {
							throw new RouteRejectionService.UnrecoverableException('season-pass-select.xfc.pass-demographics', $stateParams);
						}
					}
				},
				templateUrl: `${SEASON_PASS_SELECT_DIRECTORY }/views/pass-type-selection.html`,
				title: 'seasonPassSelectPassTypeSelection',
				url: ''
			})
			.state('season-pass-select.xfc.pass-demographics', {
				controller: 'SeasonPassSelectPassDemographicsController',
				resolve: {
					assessDemographicsRoute: function(getAgreements, passCollection, Package, RouteRejectionService, SeasonPassSelectPrepService,
						SeasonPassSelectEnumsService, SeasonPassSelectRoutingService, SeasonPassSelectPassCollectionService,
						$q, $state, $transition$) {
						const routing = $q.defer(),
							activePass = SeasonPassSelectPassCollectionService.findActivePassInCollection(passCollection),
							isDefined = angular.isDefined(activePass),
							isRenewal = activePass.isRenewal();

						//if the guest chose a renewal but they managed to get passed the form without a value season pass number, we must reject this route
						if (isDefined && isRenewal && activePass.registration_info.ph_season_pass_number.length === 0) {
							routing.reject(new RouteRejectionService.ViewException(SeasonPassSelectEnumsService.localeSection, 'renewalPassWithNoNumberTitle', 'renewalPassWithNoNumberMsg', 'season-pass-select.xfc.pass-type-selection', $transition$.params()));
						} else if (isDefined && SeasonPassSelectPrepService.includesImageCapture(activePass.isRenewal())) {
							const route = SeasonPassSelectRoutingService.getInitialImageCaptureRouteForPass(activePass);

							if ($state.next.name !== route) {
								routing.reject(new RouteRejectionService.UnrecoverableException(route, $transition$.params()));
							} else {
								routing.resolve();
							}
						} else {
							routing.resolve();
						}
						return routing.promise;
					},
					getAgreements: function(setActivePassAndRoute, AppData, Package, passCollection, SeasonPassSelectPassCollectionService) {
						// loadAgreementsForActivePass only loads agreements if the app config season_pass_select.include_agreements is true. Otherwise, it does nothing.
						const activePass = SeasonPassSelectPassCollectionService.findActivePassInCollection(passCollection);
						if (angular.isDefined(activePass)) {
							return SeasonPassSelectPassCollectionService.loadAgreementsForActivePass(AppData.merchant_id, activePass, AppData.language, AppData.cart.cart_id, AppData.cart.cart_key, Package.itemsToBeAdded);
						}
					},
					//assess whether or not we can route here - we check if this view has image capture and if so, then we route to the appropriate image capture child state
					//based on whether or not the pass has valid image capture data
					loadImageOnEdit: function(assessDemographicsRoute, passCollection, $q, ProfileLoginImageService, ImageCapturePrepService, ImageCapturesRequestService, ImageCaptureTempImageService, Package, SeasonPassSelectPassCollectionService) {
						const deferred = $q.defer(),
							activePass = SeasonPassSelectPassCollectionService.findActivePassInCollection(passCollection);

						if (!ProfileLoginImageService.useAwsFolderOnProfile && activePass.image_capture_info.sentImageFile && Package.isEditing() && ['upload', 'webcam'].includes(activePass.image_capture_info.imageMethod)) {
							ImageCapturesRequestService.getFileFromAmazon(ImageCapturePrepService.settings.imageAWSbucketfolder + activePass.image_capture_info.imageFileName).then(
								function onFileRetrieveSuccess(response) {
									ImageCaptureTempImageService.setCurrentTempFileName(activePass.image_capture_info.imageFileName);
									ImageCaptureTempImageService.saveTempFile(response.data, activePass.image_capture_info.imageFileName, activePass.image_capture_info.imageOrientation).then(function() {
										const blobUrl = URL.createObjectURL(response.data);
										if (activePass.image_capture_info.imageMethod === 'webcam') {
											activePass.webcamFile.preview = blobUrl;
										} else {
											activePass.uploadFile.preview = blobUrl;
										}
										deferred.resolve();
									});
								},
								function onFileRetrieveFailure(error) {
									deferred.reject(error);
								}
							);
						} else {
							deferred.resolve();
						}

						return deferred.promise;
					},
					previousState: buildPreviousState
				},
				templateUrl: `${SEASON_PASS_SELECT_DIRECTORY }/views/pass-demographics.html`,
				title: 'seasonPassSelectPassDemographics',
				url: '/xfc-pass-demographics'
			})
			.state('season-pass-select.xfc.gate-enhancement', {
				controller: 'SeasonPassSelectGateEnhancementController',
				controllerAs: 'vm',
				resolve: {
					assets: function(Utilities) {
						return Utilities.cacheBustAndLazyLoad([
							`${SEASON_PASS_SELECT_DIRECTORY }/gate-enhancement/gate-enhancement-controller.js`,
							`${SEASON_PASS_SELECT_DIRECTORY }/gate-enhancement/gate-enhancement.css`
						]);
					},
					setCustomerType: function(assets, passCollection, SeasonPassSelectPassCollectionService, Utilities) {
						const activePass = SeasonPassSelectPassCollectionService.findActivePassInCollection(passCollection);
						activePass.setGateEnhancementCt(Utilities.safelyCheckPropertyOnObject('activePass.registration_info.selected_customer_type.id', activePass, 'returnValue'));
					}
				},
				templateUrl: `${SEASON_PASS_SELECT_DIRECTORY }/gate-enhancement/gate-enhancement.html`,
				title: 'seasonPassSelectGateEnhancement',
				url: '/gate-enhancement'
			})
			.state('season-pass-select.xfc.pass-demographics.capture-selection', {
				controller: 'SeasonPassSelectCaptureSelectionController',
				templateUrl: `${SEASON_PASS_SELECT_DIRECTORY }/views/capture-selection.html`,
				title: 'seasonPassSelectPassDemographics',
				url: '/capture-selection'
			})
			.state('season-pass-select.xfc.pass-demographics.profileimage', {
				controller: 'SeasonPassSelectProfileImageController',
				templateUrl: `${SEASON_PASS_SELECT_DIRECTORY }/views/profileimage.html`,
				title: 'seasonPassSelectPassDemographics',
				url: '/profileimage'
			})
			.state('season-pass-select.xfc.pass-demographics.onsite', {
				controller: 'SeasonPassSelectOnsiteController',
				templateUrl: `${SEASON_PASS_SELECT_DIRECTORY }/views/onsite.html`,
				title: 'seasonPassSelectPassDemographics',
				url: '/onsite'
			})
			.state('season-pass-select.xfc.pass-demographics.mail', {
				controller: 'SeasonPassSelectPassMailController',
				templateUrl: `${SEASON_PASS_SELECT_DIRECTORY }/views/mail.html`,
				title: 'seasonPassSelectPassDemographics',
				url: '/mail'
			})
			.state('season-pass-select.xfc.addons', {
				controller: 'SeasonPassSelectAddonsController',
				resolve: {
					loadAssets: function(Utilities) {
						return Utilities.cacheBustAndLazyLoad([
							`${SEASON_PASS_SELECT_DIRECTORY }/styles/addons.css`
						]);
					},
					previousState: buildPreviousState
				},
				templateUrl: `${SEASON_PASS_SELECT_DIRECTORY }/views/addons.html`,
				title: 'seasonPassSelectAddons',
				url: '/addons'
			})
			.state(`season-pass-select.xfc.${ InterstitialDiningConstants.CHOICE_STATE}`, {
				controller: 'InterstitialDiningController',
				resolve: {
					interstitialData: function(setActivePassAndRoute, $transition$, InterstitialDiningService) {
						return InterstitialDiningService.initialize($transition$.params(), 'season-pass-select.xfc.');
					}
				},
				templateUrl: '/scripts/modules/extraflow/interstitial-dining/views/choice.html',
				url: '/interstitial-dining-choice/:flowType'
			})
			.state(`season-pass-select.xfc.${ InterstitialDiningConstants.ASSIGNMENT_STATE}`, {
				controller: 'InterstitialDiningController',
				resolve: {
					interstitialData: function(setActivePassAndRoute, $transition$, InterstitialDiningService) {
						return InterstitialDiningService.initialize($transition$.params(), 'season-pass-select.xfc.');
					}
				},
				templateUrl: '/scripts/modules/extraflow/interstitial-dining/views/assignment.html',
				url: '/interstitial-dining-assignment/:flowType'
			})
			.state('season-pass-select.xfc.agreements', {
				controller: 'SeasonPassSelectAgreementsController',
				resolve: { previousState: buildPreviousState },
				templateUrl: `${SEASON_PASS_SELECT_DIRECTORY }/views/agreements.html`,
				title: 'seasonPassSelectAgreements',
				url: '/agreements'
			});


		/**
		 * Resolves the current state so that once the page resolves, it will have the previous state.
		 * @public
		 * @function
		 * @name buildPreviousState
		 * @param {Object} $state The state before we resolve to the new state
		 * @return {Object} the previous state
		 * @ngInject
		 */
		function buildPreviousState($state) {
			return {
				name: $state.current.name,
				params: $state.params
			};
		}
	})
	.run(function(ExtraFlow) {
		// Register this extra flow alternate module with the extra flow service
		ExtraFlow.registerXMC('season_pass_select', {
			aliases: ['ticket_demographics'],
			characsList: ['ph_last_name'],
			doEditMode: true,
			enabled: true,
			hasOptionalCharacs: true,
			lockQuantity: true,
			name: 'season_pass_select',
			type: 'extraFlowControl',
			view: 'season-pass-select.xfc.pass-type-selection',
			viewDefaultArgs: {
				characIndex: 0,
				itemIndex: 0
			},
			viewIsStateName: true,
			writeSingleCharac: false
		}, { ticket_demographics: ['np_last_name'] }); // eslint-disable-line camelcase
	});

angular.module('wtp', ['wtp-number']);
angular.module('wtp').factory('WTPService',
	function(
		$injector,
		$location,
		$log,
		Enums,
		AppData,
		Utilities,
		Modal,
		WTPModels,
		PackageList,
		Package,
		Language,
		CustomActionService,
		$rootScope,
		$q,
		$state,
		$timeout,
		$uibModal,
		JSONValidator,
		RestrictedPackagesService,
		UrlUtils,
		UtilsValidation,
		StandardFlowInitiatorService
	) {
		var wtpDisplayTime = 1500,
			wtp_localePrefix = AppData.merchant_id,
			checkProp = Utilities.safelyCheckPropertyOnObject,
			getBoolean = Utilities.getBoolean,
			returnValue = Utilities.returnValue,
			validArray = UtilsValidation.validArray,
			validObject = UtilsValidation.validObject,
			validString = UtilsValidation.validString,
			isRealObject = UtilsValidation.isRealObject,
			registerCustomAction = CustomActionService.registerCustomAction,
			registerCustomActionForChain = CustomActionService.registerCustomActionForChain,
			deregisterCustomAction = CustomActionService.deregisterCustomAction;

		var service = {
			requestObject: undefined,
			packageList: [],
			loadedPackages: [],
			profile: undefined,
			isWTPPromoCode: false,
			wtpPromoCodeIDs: [],
			wtpPromoCode: '',
			reset: reset,
			loadWTPNumber: loadWTPNumber,
			isAllPackagesWtp: isAllPackagesWtp,
			isDisplayableWtpNumber: isDisplayableWtpNumber,
			isWTPPackage: isWTPPackage,
			resetWTPPromoCodeData: resetWTPPromoCodeData,
			availableToCurrentWTP: availableToCurrentWTP,
			infoForItem: infoForItem,
			isCartItemQuantityModifiable: isCartItemQuantityModifiable,
			getFormatForLength: getFormatForLength,
			regExForWTPNumber: regExForWTPNumber,
			makeStringReplacements: makeStringReplacements,
			modifyCustomerTypesForCartItems: modifyCustomerTypesForCartItems,
			initialize: initialize,
			loadWTPNumberWithModals: loadWTPNumberWithModals,
			parseFormat: parseFormat,
			setupCustomActions: setupCustomActions,
			showNoPackagesFoundModal: showNoPackagesFoundModal,
			routeToWtpPackages: routeToWtpPackages,
			wtpIsValidLength: wtpIsValidLength,
			wtpNumbersEquivalent: wtpNumbersEquivalent,
			buildPackageListFromIDs: buildPackageListFromIDs,
			reloadCard : reloadCard,
			locale: locale, // wraps Language with the appropriate string replace
			get prefixForLocales() {
				return wtp_localePrefix;
			},
			set prefixForLocales(prefix) {
				wtp_localePrefix = !! prefix ? prefix : '';
			},
			get packageIdsForPackageList() {
				var result = [];
				if (service.loaded) {
					for (var i=0; i<service.packageList.length; i++) {
						result.push(service.packageList[i].id);
					}
				}
				return result;
			},
			get wtpNumber(){
				// return the WTP number of the currently loaded WTP user.
				return (service.loaded) ? wtp_number : undefined;
			},
			get wtpRegexStringForAll() {
				return wtp_allValidate;
			},
			get defaultFormat() {
				return parseFormat('XXXXXXXX-XXX-XXX', 14, false);
			},
			get loaded() {
				return checkProp('service.profile', service, isRealObject);
			},
			get config() {
				if (angular.isUndefined(wtp_config)) {
					if (JSONValidator.validate('wtp', AppData.settings.wtp)) {
						wtp_config = JSON.parse(AppData.settings.wtp);
						parseFormatsForLengths(wtp_config.wtpLength);
					} else {
						wtp_config={};
					}
				}
				return wtp_config;
			},
			get instructionImage() {
				return angular.isDefined(service.config.instructionImage) ? $rootScope.getAssetUrl(service.config.instructionImage) : '';
			},
			get loadingIcon() {
				return angular.isDefined(service.config.loadingIcon) ? $rootScope.getAssetUrl(service.config.loadingIcon) : '';
			},
			get firstNameOnlyOnTicket() {
				return Utilities.getBoolean(service.config.firstNameOnlyOnTicket);
			}
		},
		// now, some private values:
		queryParams = UrlUtils.objectToQueryParams($location.search()),
		wtp_number,
		wtp_allValidate,
		wtp_numberlink = $state.href('wtpnumber') + (validString(queryParams) ? '?' + queryParams : ''),
		wtp_config = undefined;

		service.initialize();

		return service;

		function wtpNumbersEquivalent(wtp1, wtp2){
			// remove formatting from wtp numbers
			if (angular.isDefined(wtp1) & angular.isDefined(wtp2)) {
				return wtp1.replace(/[ -]/g,'') == wtp2.replace(/[ -]/g,'');
			}
			return false;
		}

		function makeStringReplacements(str){
			if ( service.loaded) {
				str = str.replace('@@name', service.profile.first_name + ' ' + service.profile.last_name)
					.replace('@@firstname', service.profile.first_name)
					.replace('@@lastname', service.profile.last_name)
					.replace('@@guestnumber', service.profile.guest_no)
					.replace('@@wtpnumberlink', wtp_numberlink)
					.replace('@@wtp', service.wtpNumber);
			}
			return str;
		}
		function infoForItem(item) {
			if (angular.isDefined(item.CHARACS)) {
				var c =  angular.isArray(item.CHARACS) ? item.CHARACS[0]: item.CHARACS;
				if (angular.isDefined(c.WTP_number)) {
					return {
						first_name: angular.isDefined(c.WTP_first_name) ? c.WTP_first_name : '',
						last_name:  angular.isDefined(c.WTP_last_name) ? c.WTP_last_name : '',
						guest_no:  angular.isDefined(c.WTP_guest_no) ? c.WTP_guest_no : '',
						WTP_number: c.WTP_number
					}
				}
			}
			return undefined;
		}

		function addToCharac(c) {
			if (angular.isDefined(service.profile)) {
				c.WTP_first_name = service.profile.first_name;
				c.WTP_last_name= service.profile.last_name;
				c.WTP_guest_no = service.profile.guest_no;
				c.WTP_number = service.wtpNumber;
				c.ticket_customer_name = service.firstNameOnlyOnTicket ?  c.WTP_first_name : c.WTP_first_name + ' ' + c.WTP_last_name;

				if (service.profile.birth_date) {
					c.WTP_birth_date = service.profile.birth_date;
				}
			}
		}
		function modifyCharacArray(pkg) {
			if (angular.isDefined(pkg)) {
				if (angular.isUndefined(pkg.CHARACS)) {
					pkg.CHARACS = [{}];
				}
				if (! angular.isArray(pkg.CHARACS)) {
					pkg.CHARACS = [pkg.CHARACS];
				}
				pkg.CHARACS.forEach(addToCharac);
			}
		}

		function ctsAvailableToPackage(pkgId) {
			var pkgs = service.packageList.filter(function(p){
				return p.id == pkgId;
			});
			if (pkgs.length<1) {
				return []
			}
			return pkgs[0].ct;
		}

		/**
		 * Filter Customer Types (CT's) in packageDetails both eliminates CTs that cannot be used by the currently
		 * loaded WTP, and adds text information to the names of the CTs.
		 * @param pkg {Object} The object that will be modified in place.
		 * @param allowEmpty {boolean} when this is true the CT array on the pkg could be set to an empty array if
		 * there were no matching customer types.
		 */
		function filterCustomerTypes(pkg, allowEmpty) {
			// drop out if no WTP has been loaded or if this is not a WTP package
			if (angular.isUndefined(pkg) || ! service.loaded || ! service.isWTPPackage(pkg)) {
				return true;
			}
			var cts = ctsAvailableToPackage(pkg.id);

			pkg.CT = ( angular.isArray( pkg.CT ) ) ? pkg.CT : [ pkg.CT ];
			for (var i = pkg.CT.length-1; i>=0; i--) {
				if (! Utilities.inArray(pkg.CT[i].id,cts)) {
					pkg.CT.splice(i,1);
				}
			}
		}

		function routeToWtpPackages() {
			var restrictedNavTree = RestrictedPackagesService.getRestrictedNavTree();

			if (!restrictedNavTree) {
				$rootScope.routeTo('/packageList/packages/' + service.packageIdsForPackageList.join(','));
			} else {
				RestrictedPackagesService.doRouting('wtp', (validString(service.wtpPromoCode) ? service.wtpPromoCode : null));
			}

			Modal.hideModal();
		}

		function locale(target) {
			if (service.prefixForLocales && Language.localeExists('wtp',service.prefixForLocales + target)) {
				return service.makeStringReplacements(Language.getLocale('wtp',service.prefixForLocales + target));
			}
			return service.makeStringReplacements(Language.getLocale('wtp',target));
		}

		/**
		 * onItemsAddedToCart is called by cart.js when items are added to the cart. If one of those items is
		 * a WTP package, it registers the onAddCartItemResponse custom action.
		 * @param data
		 **/
		function onItemsAddedToCart(data) {
			if (angular.isDefined(data) && angular.isArray(data)) {
				for (var i=0; i<data.length; i++ ) {
					if (service.isWTPPackage(data[i])) {
						registerCustomAction('onAddCartItemResponse',onAddCartItemResponse);
						break;
					}
				}
			}
		}

		function customModalLabelOverride(buttonflag, label) {
			return (buttonflag==Enums.buttonFlags.CONTINUE_SHOPPING) ? Language.getLocale('wtp','reloadButtonOnCart'): label;
		}
		/**
		 * onAddCartItemResponse is a custom action used by cart.js when the Add Cart Item modal is supposed
		 * to be shown. It returns true to indicate that the modal has been handled and no other modal should
		 * be shown.
		 *
		 * It deregisters itself as soon as it's used to prevent it from being called on carts that do not have wtp items.
		 *
		 * @param data
		 * @param flags
		 * @param qtyAdded
		 * @param qtyBeingAdded
		 * @returns {boolean}
		 **/

		function onAddCartItemResponse(data, flags, qtyAdded, qtyBeingAdded){
			var LegacyCart = $injector.get('LegacyCart');
			// If this method is needed again, it will be registered in the onItemsAddedToCart method.
			deregisterCustomAction('onAddCartItemResponse',onAddCartItemResponse);
			StandardFlowInitiatorService.resetStandardFlow();
			if (service.loaded) {
				if (service.isWTPPromoCode) {
					service.resetWTPPromoCodeData();
				}
				Modal.displayModal({
					category: 'Cart'
					, label: 'Items Added'
					, value: qtyAdded
					, replacementKeys: 'qtyAdded'
					, replacementValues: qtyBeingAdded
					, replaceInTitle: true
					, icon:'icon-cartmodal green'
					, title: service.locale('cartAddedTitle')
					, description: service.locale('cartOrContinueShoppingTitle')
					, buttonFlags: [ Enums.buttonFlags.CONTINUE_SHOPPING, Enums.buttonFlags.PROCEED_TO_CHECKOUT ]
					, showCloseButton: false
					, customLabelOverride: customModalLabelOverride
					, callback: function( detail ){
						if( detail === Enums.buttonFlags.CONTINUE_SHOPPING ){
							$rootScope.routeTo( Enums.routes.WTPNUMBER);
						} else if( detail === Enums.buttonFlags.PROCEED_TO_CHECKOUT ){
							LegacyCart.routeToCrossSellsOrCartAsAppropriate();
						}
					}
				});
				return true;
			}
			return false;
		}

		// This call is made in LegacyCart.addToCart.
		function modifyCustomerTypesForCart(customerTypes, packageDetails) {
			if (service.isWTPPackage(packageDetails)) {
				if (Array.isArray(customerTypes)) {
					customerTypes.forEach(service.availableToCurrentWTP(packageDetails.id) ? modifyCharacArray : function(ct) {
						ct.qty = 0;
					});
				}
			}
		}

		/**
		 * Modifies the items being added to the cart to include WTP details if added.
		 * @param {Object[]} itemsToBeAdded
		 */
		function modifyCustomerTypesForCartItems(itemsToBeAdded) {
			var removeItems = [];

			if (Array.isArray(itemsToBeAdded)) {
				itemsToBeAdded.forEach(function(item) {
					var pkg;
					if (!isRealObject(item)) {
						return;
					}

					pkg = Package.getPackageByID(item.package_id);
					if (!pkg) {
						return;
					}

					if (service.isWTPPackage(pkg)) {
						if (service.availableToCurrentWTP(pkg.id)) {
							modifyCharacArray(item);
						} else {
							removeItems.push(item);
						}
					}
				});

				// Don't let them add items that aren't for their WTP number or are WTP number and not currently available to them.
				if (removeItems.length) {
					removeItems.forEach(function(item) {
						var index = itemsToBeAdded.indexOf(item);
						if (index > -1) {
							itemsToBeAdded.splice(index, 1);
						}
					});
				}
			}
		}

		function setupCustomActions(needThem) {
			registerCustomAction(CustomActionService.ACTIONS_ENUMS.VALIDATE_CART_ADDITION, onValidateCartAddition);

			if (needThem) {
				registerCustomAction('filterCustomerTypes', filterCustomerTypes);
				registerCustomAction('modifyCustomerTypesForCart', modifyCustomerTypesForCart);
				registerCustomActionForChain('modifyCustomerTypesForCartItems', service.modifyCustomerTypesForCartItems);
				registerCustomActionForChain(CustomActionService.ACTIONS_ENUMS.ON_ITEMS_ADDED_TO_CART, onItemsAddedToCart);
			} else {
				deregisterCustomAction('filterCustomerTypes', filterCustomerTypes);
				deregisterCustomAction('modifyCustomerTypesForCart', modifyCustomerTypesForCart);
				deregisterCustomAction('modifyCustomerTypesForCartItems', service.modifyCustomerTypesForCartItems);
				deregisterCustomAction('onAddCartItemResponse', onAddCartItemResponse);
				deregisterCustomAction(CustomActionService.ACTIONS_ENUMS.ON_ITEMS_ADDED_TO_CART, onItemsAddedToCart);
			}
		}

		/**
		 * Callback to determine if we can add the item to the cart
		 * @callback
		 * @public
		 * @returns {Boolean} True if we can add, false otherwise
		 */
		function onValidateCartAddition() {
			return checkWtpRestriction.apply(null, arguments) && checkOneRiskBirthdate.apply(null, arguments);
		}

		/**
		 * Checks to see if the WTP item requires a one risk waiver and if a birthdate
		 * has been loaded to the WTP profile. Then prompts for a birthdate if not.
		 * @function
		 * @public
		 * @param {Object[]} customerTypes The customer types to be added
		 * @param {Object[]} cartItems The current list of cart items
		 * @param {Object} packageDetails The current package Details
		 * @param {Function} retriggerFunction The function to reengage the addToCart Function
		 * @returns {Boolean} True if there is no birthdate check needed, false otherwise
		 */
		function checkOneRiskBirthdate(customerTypes, cartItems, packageDetails, retriggerFunction) {
			if (!isWTPPackage(packageDetails) || service.profile.birth_date || !validObject(packageDetails.CHARACS) || !validString(packageDetails.CHARACS.oneRiskWaiverIds) || !validString(packageDetails.CHARACS.formNumbers)) {
				return true;
			}

			// The caller (UPD's onContinue, or the cart flow) shows the spinner before
			// reaching this validation step. Hide it before opening the modal so the
			// spinner overlay doesn't intercept touch/click events on the modal (PEC-24491).
			$rootScope.hideSpinner();

			$uibModal.open({
				controller: 'CheckBirthdateModalController',
				controllerAs: 'vm',
				resolve: {
					onSuccessCallback: function() {
						return function() {
							$rootScope.showSpinner();
							retriggerFunction();
						}
					}
				},
				templateUrl: 'scripts/modules/wtp/templates/check-birthdate-modal.html',
			});

			return false;
		}

		/**
		 * Checks to see if the WTP package can be added
		 * @public
		 * @callback
		 * @param {Object[]} customerTypes The customer types to be added
		 * @param {Object[]} cartItems The cart items
		 * @param {Object} packageDetails The package that is trying to be added to the cart
		 * @returns {Boolean} false if the item can be added to the cart, true if it can
		 */
		function checkWtpRestriction(customerTypes, cartItems, packageDetails) {
			if (isWTPPackage(packageDetails)) {
				switch(checkProp('config.restrictPurchase', service.config, returnValue)) {
				case 'order':
					if (checkWtpPackageRestriction(cartItems, packageDetails) || checkWtpPackageExceededQuantity(customerTypes)) {
						displayRestrictionModal('orderRestrictionTitle', 'orderRestrictionDescription');
						return false;
					}
					break;
				case 'package':
					if (checkWtpPackageRestriction(cartItems, packageDetails, true) || checkWtpPackageExceededQuantity(customerTypes)) {
						displayRestrictionModal('packageRestrictionTitle', 'packageRestrictionDescription');
						return false;
					}
					break;
				}
			}

			return true;
		}

		/**
		 * Checks a cart item if it can be qty modifiable
		 * @public
		 * @function
		 * @param {Object[]} characs The cart item characs
		 * @returns {Boolean} True if the item should be quantity modifiable, false otherwise.
		 */
		function isCartItemQuantityModifiable(characs) {
			var isWtp = characs.some(function iterateCharacs(charac) {
				return validString(charac.WTP_number);
			});
			return !(isWtp && ['package', 'order'].includes(checkProp('config.restrictPurchase', service.config, returnValue)));
		}

		/**
		 * Checks to see if the package has more (or less) than one added quantity
		 * @public
		 * @function
		 * @param {Object[]} customerTypes The customer types to be added
		 * @returns {Boolean} true if the quantity is exceeded, false otherwise
		 */
		function checkWtpPackageExceededQuantity(customerTypes) {
			// If there is no customer types, return true as there are invalid customer types
			if (!validArray(customerTypes)) {
				return true;
			}

			// Grabs the total quantity of customer types to be added and fails if the quantity is anything other than 1
			return customerTypes.reduce(function(acc, ct) {
				return acc + parseInt(ct.qty, 10);
			}, 0) !== 1;
		}

		/**
		 * Check to see if the WTP package is restricted against the cart
		 * @public
		 * @function
		 * @param {Object[]} cartItems The cart items
		 * @param {Object} packageDetails The package that is trying to be added to the cart
		 * @param {Boolean} [checkPackage] Flag to check the package level compared to order level
		 * @returns {Boolean} True if restricted, false otherwise
		 */
		function checkWtpPackageRestriction(cartItems, packageDetails, checkPackage) {

			return cartItems.some(function(item) {
				if ((checkPackage && item.package_id !== packageDetails.id) || !validArray(item.CHARACS) || !isWTPPackage(packageDetails)) {
					return false;
				}

				return item.CHARACS.some(function(characSet) {
					return characSet.WTP_number === service.wtpNumber;
				});
			});
		}

		/**
		 * Displays an error modal when an ineligible wtp is attempted to be added.
		 * @public
		 * @function
		 * @param {String} modalTitleLocale The locale title for the modal
		 * @param {String} modalDescLocale The locale Message for the modal
		 * @returns {undefined}
		 */
		function displayRestrictionModal(modalTitleLocale, modalDescLocale) {
			Modal.displayModal({
				callback: function() {
					$rootScope.routeTo(Enums.routes.WTPNUMBER);
				},
				label: 'WTP Restriction',
				title: Language.getLocale('wtp', modalTitleLocale),
				icon: 'icon-cartmodal blue',
				description: Language.getLocale('wtp', modalDescLocale),
				buttonFlags: [Enums.buttonFlags.CONTINUE_SHOPPING]
			});
		}

		function reset() {
			service.profile = undefined;
			service.packageList = [];
			service.loadedPackages = [];
			wtp_number = undefined;
			wtp_config = undefined;
			service.setupCustomActions(false);
		}

		function buildProfileFromResponse(data) {
			if (angular.isDefined(data)) {
				service.profile.first_name = angular.isDefined(data.first_name) ? data.first_name : '';
				service.profile.last_name = angular.isDefined(data.last_name) ? data.last_name : '';
				service.profile.guest_no = angular.isDefined(data.guest_no) ? data.guest_no : '';
			}
		}

		function buildPackageListElement(data) {
			var element,
				includePackage = angular.isDefined(data.id) && angular.isDefined(data.CT) && (angular.isUndefined(data.hide_reason) || data.hide_reason.length < 1);
			if (includePackage) {
				element = {id: data.id, ct: []};
				if (angular.isArray(data.CT)) {
					for (var i = 0; i < data.CT.length; i++) {
						if (angular.isDefined(data.CT[i].id)) {
							element.ct.push(data.CT[i].id);
						}
					}
				} else if (angular.isDefined(data.CT.id)) {
					element.ct.push(data.CT.id);
				}
			}
			return element;
		}
		function buildPackageListFromResponse(data) {
			service.packageList = [];
			if (checkProp('data.P',data)) {
				if  (angular.isArray(data.P) && data.P.length>0) {
					data.P.forEach(function (p) {
						var newElement = buildPackageListElement(p);
						if(angular.isDefined(newElement)) {
							service.packageList.push(newElement);
						}
					});
				} else  if (! angular.isArray(data.P)) {
					var newElement = buildPackageListElement(data.P);
					if(angular.isDefined(newElement)) {
						service.packageList.push(newElement);
					}
				}
			}
		}

		/**
		 * Gets packages from the IDs and build local package list
		 * @public
		 * @function
		 * @param {Array} idList The list of package ids
		 * @returns {undefined}
		 */
		function buildPackageListFromIDs(idList) {
			service.packageList = [];

			idList.forEach( function getFullPkgs(item) {
				var pkg = Package.getPackageByID(item),
					newElement;
				if (angular.isDefined(pkg)) {
					newElement = buildPackageListElement(pkg);
					if (angular.isDefined(newElement)) {
						service.packageList.push(newElement);
					}
				}
			});
		}

		function showNoPackagesFoundModal(){
			Modal.displayModal(
				{
					category: 'Loading WTP'
					, action: 'Error'
					, label: 'No Packages Found'
					, title: service.locale('nopackagesfoundTitle')
					, description: service.locale('nopackagesfound')
				});
		}
		function reloadCard() {
			// no need to reload anything or make any other calls.
			if (service.packageIdsForPackageList.length>0) {
				service.routeToWtpPackages();
			} else {
				service.showNoPackagesFoundModal();
			}
		};
		function loadWTPNumberWithModals(wtpToLoad) {
			$rootScope.showSpinner( service.locale('spinnerMessage'  ));

			return service
				.loadWTPNumber(wtpToLoad)
				.then(function() {
					$rootScope.hideSpinner();

					if (service.loaded) {
						if (validArray(service.packageIdsForPackageList)) {
							service.loadedPackages = service.packageIdsForPackageList.map(function(id) {
								return Package.getPackageByID(id);
							}).filter(UtilsValidation.isRealObject);
							RestrictedPackagesService.registerPackageList('wtp', service.loadedPackages);
							RestrictedPackagesService.setLocaleData(
								'wtp',
								service.locale('headerMain'),
								service.locale('headerTitle'),
								service.locale('headerDescription')
							);
							PackageList.packages = service.loadedPackages.slice(0);
							PackageList.getPackagesByID(service.packageIdsForPackageList.join(','));

							$timeout(service.routeToWtpPackages, wtpDisplayTime);
							Modal.displayModal(
								{ label: 'LoadingWTPPackages'
									, image: service.loadingIcon
									, customDescription: service.locale('loadingWTPPackages')
									, trueFullscreen: true
									, customHTML: '/scripts/modules/wtp/views/wtp-loader.html'
									, description: service.locale('loadingWTPPackages')
									, hideAllButtons: true
								} );
						} else {
							showNoPackagesFoundModal();
						}
					} else {
						Modal.displayModal(
							{
								category: 'Loading WTP'
								, action: 'Error'
								, label: 'WTP Error'
								, title: service.locale('unabletoloadWTPTitle')
								, description: service.locale('unabletoloadWTP')
							});
					}
				}
				).catch(function() {
					$rootScope.hideSpinner();
					Modal.displayModal({
						category: 'Loading WTP',
						action: 'Error',
						label: 'WTP Error',
						title: service.locale('unabletoloadWTPTitle'),
						description: service.locale('unabletoloadWTP')
					});
				});
		}
		function loadWTPNumber(id, birthDate) {
			var wtpLoader = $q.defer(),
				reqObj = new WTPModels.RequestObject(id, birthDate),
				currentRequest = angular.isDefined(service.profile) ? service.requestObject : undefined;

			// birth date is used to verify only, reset if it was not provided.
			if (!birthDate) {
				service.reset();
				RestrictedPackagesService.reset('wtp');
			}

			if (reqObj.valid && !reqObj.equal(currentRequest)) {
				if(service.isWTPPromoCode) reqObj.data.promo_codes = service.wtpPromoCode;
				$rootScope.pendingRequests.push( Enums.services.GET_WTP_RELOAD);
				AppData.fetch(Enums.services.GET_WTP_RELOAD, false, reqObj.data,false).then(
					function(data) {
						$rootScope.removePendingRequest(Enums.services.GET_WTP_RELOAD);
						if (data.status == Enums.status.OK) {
							service.setupCustomActions(true);
							service.profile = new WTPModels.Profile();
							wtp_number = id;
							if (birthDate) {
								service.profile.birth_date = birthDate;
							}
							buildPackageListFromResponse(data.PACKAGE);
							buildProfileFromResponse(data.PASSHOLDER);
							wtpLoader.resolve(data);
						} else {
							// birth date is used to verify only, reset if it was not provided.
							if (!birthDate) {
								service.reset();
							}
							wtpLoader.resolve(data);
						}
					}
				).catch(function() {
					$rootScope.removePendingRequest(Enums.services.GET_WTP_RELOAD);
					wtpLoader.reject();
				});
			} else {
				wtpLoader.resolve();
			}

			return wtpLoader.promise;
		}

		function availableToCurrentWTP(package_id){
			if (service.loaded) {
				for (var i=0; i<service.packageList.length; i++) {
					if (service.packageList[i].id == package_id) {
						return true;
					}
				}
			}
			return false;
		}

		/**
		 * isWTPPackage analyzes the passed in package to see if it's a WTP_reload package.
		 * It handles two different types of classes: packages coming from the back end and cart items.
		 * Packages from the back end have "wtp_reload" set on their characs.
		 * Packages in the cart have WTP_number set.
		 *
		 * @param pkg
		 * @returns {boolean}
		 **/
		function isWTPPackage(pkg) {
			if (angular.isDefined(pkg) && angular.isDefined(pkg.CHARACS)) {
				if (angular.isArray(pkg.CHARACS)) {
					for (var i=0; i<pkg.CHARACS.length; i++) {
						if (Utilities.getBoolean(pkg.CHARACS[i].wtp_reload) || angular.isDefined(pkg.CHARACS[i].WTP_number)) {
							return true;
						}
					}
				} else {
					if (Utilities.getBoolean(pkg.CHARACS.wtp_reload) || angular.isDefined(pkg.CHARACS.WTP_number)) {
						return true;
					}
				}
			}
			return false;
		}

		/**
		 * Checks to see if entire array of packages are WTP
		 * @public
		 * @param {Object[]} pkgs The array of packages to test against
		 * @returns {Boolean} Returns true is ALL packages are WTP, false otherwise
		 */
		function isAllPackagesWtp(pkgs) {
			return !!pkgs.length && pkgs.every(isWTPPackage);
		}

		function isDisplayableWtpNumber(wtpNumber) {
			// Must be a real string
			if (!validString(wtpNumber)) return false;
			// Exclude “pickup box” sentinel
			var raw = ('' + wtpNumber).trim();
			if (/^pickup\s*box$/i.test(raw)) return false;

			// Normalize, then validate against config lengths and per-length regex
			var normalized = raw.replace(/[ -]/g, '');
			if (!service.wtpIsValidLength(normalized)) return false;

			var rx = service.regExForWTPNumber(normalized.length);
			return rx ? rx.test(raw) : true;
		}

		/**
		 * Resets all of the WTPPromoCode data
		 * @public
		 * @returns null
		 */
		function resetWTPPromoCodeData() {
			service.isWTPPromoCode = false;
			service.wtpPromoCode = null;
			service.wtpPromoCodeIDs = [];
		}

		/**
		 * Getter function for the a regular expression validation of the WTP Number
		 * @function
		 * @public
		 * @see https://regex101.com/r/MJ9XMI/1/ - Reference and breakdown of this expression
		 * @returns {RegExp}
		 */
		function regExForWTPNumber(wtpNumLength) {
			return getFormatForLength(wtpNumLength).regex;
		}

		/**
		 * Gets the parsedFormat for a given WTP Length
		 * @function
		 * @public
		 * @param {Number} wtpNumberLength The Length
		 * @returns {Object} The parsed format
		 */
		function getFormatForLength(wtpNumberLength) {
			var wtpLengthConfig = service.config.wtpLength;

			if (validObject(wtpLengthConfig)) {
				return wtpLengthConfig.parsedFormat;
			} else if (validArray(wtpLengthConfig)) {
				return wtpLengthConfig.find(function(config, i) {
					return config.passLength >= wtpNumberLength || i === wtpLengthConfig.length - 1;
				}).parsedFormat;
			}

			return service.defaultFormat;
		}

		/**
		 * Take the configs and parses WTP Length formats into something that the system can understand
		 * @function
		 * @public
		 * @param {Object} wtpLengthConfig The wtp.wtpLength app config
		 * @returns {undefined}
		 */
		function parseFormatsForLengths(wtpLengthConfig) {
			if (!wtpLengthConfig) {
				return;
			} else if (validObject(wtpLengthConfig)) {
				wtpLengthConfig.parsedFormat = parseFormat(wtpLengthConfig.format, wtpLengthConfig.passLength, wtpLengthConfig.removeLeadingZeros);
			} else if (validArray(wtpLengthConfig)) {
				wtpLengthConfig.forEach(function(config) {
					if (validObject(config)) {
						config.parsedFormat = parseFormat(config.format, config.passLength, config.removeLeadingZeros);
					};
				});

				wtpLengthConfig.sort(function(a, b) {
					return a.passLength - b.passLength;
				});
			}

			wtp_allValidate = buildAllAcceptedWtpRegex();
		}

		/**
		 * Parses a single format to be machine readable
		 * @public
		 * @function
		 * @param {String} format the String Format e.g. XXXXXXXX-XXXX-XXXX
		 * @param {Number} expectedLength The expected length (must match the format XAN count)
		 * @param {Boolean} removeLeadingZeros if the system should remove leading zeros
		 * @returns {Object} The parsed format
		 */
		function parseFormat(format, expectedLength, removeLeadingZeros) {
			var regexConvert = format,
				actualLength = format.replace(/[^XNA]/ig, '').length,
				separators = [],
				sequence,
				i;


			// If the XAN count doesn't match the expectedLength, do not recognize this format
			if (actualLength !== expectedLength) {
				$log.error('Ignoring formatting for ' + format + ' as the expected length of ' + expectedLength + ' does not match the actual length of ' + actualLength);
				return {
					format: format,
					ignore: true,
					regex: new RegExp('^[A-Z\\d]{' + expectedLength + '}$', 'i'),
					removeLeadingZeros: false,
					separators: [],
					sequence: [].fill(/^[A-Z\d]$/i, 0, expectedLength - 1)
				};
			}

			// Get the position and separator characters
			for (i = 0; i < format.length; i++) {
				if (/[^A-Z\d]/i.test(format[i])) {
					separators.push({
						character: format[i],
						pos: i - separators.length
					});
				}
			}

			/**
			 * Conversion of the XAN format to a regex string
			 * 1: Strip any parenthesis out
			 * 2: escape any non-alphanumeric characters
			 * 3: make groups and parenthesis alpahanumeric vs non-alphanumeric
			 * 4: convert A to be any alpha character
			 * 5: convert X to be regex any alphanumic character
			 * 6: convert N to be any integer
			 */
			regexConvert = regexConvert
				.replace(/([\(\)])/g, '')
				.replace(/([^A-Z\d])/ig, '\\$1')
				.replace(/([XNA]+|\\?[^A-Z])/ig, '($1)')
				.replace(/A/ig, '[A-Z]')
				.replace(/X/ig, '[A-Z\\d]')
				.replace(/N/ig, '[\\d]');

			// Record the individual sequence for each character
			sequence = regexConvert
				.replace(/([\(\)])/g, '')
				.match(/(\[[^\]]+\])/g);

			// Make each sequence its' own regex
			sequence.forEach(function(seq, i) {
				sequence[i] = new RegExp('^' + seq + '$', 'i');
			});

			return {
				format: format,
				regex: new RegExp('^' + regexConvert + '$', 'i'),
				removeLeadingZeros: getBoolean(removeLeadingZeros),
				separators: separators,
				sequence: sequence
			};
		}

		/**
		 * Take all the parsed Regex and combine them to a single regex string
		 * @public
		 * @function
		 * @returns {String} The combined regex string
		 */
		function buildAllAcceptedWtpRegex() {
			var wtpLengthConfig = service.config.wtpLength;

			if (validObject(wtpLengthConfig)) {
				return wtpLengthConfig.parsedFormat.regex.toString().replace(/(^\/|\/[gimsuy]+$)/g, '');
			} else if (validArray(wtpLengthConfig)) {
				return wtpLengthConfig.reduce(function(acc, config, i) {
					return acc + (i ? '|' : '') + '(' + config.parsedFormat.regex.toString().replace(/(^\/|\/[gimsuy]+$)/g, '') + ')';
				}, '');
			}

			return '.+';
		}

		/**
		 * Validates a WTP Number against the required length in wtp configuration, if present
		 * @function
		 * @public
		 * @param {String} wtpNumber
		 * @returns {Boolean}
		 */
		function wtpIsValidLength(wtpNumber) {
			var wtpLengthConfig = service.config.wtpLength;
			wtpNumber = wtpNumber.toString().replace(/[^\dA-Z]/ig, '');

			if (validArray(wtpLengthConfig)) {
				return wtpLengthConfig.some(function(config) {
					return config.passLength === wtpNumber.length
				});
			} else if (validObject(wtpLengthConfig)) {
				return wtpLengthConfig.passLength === wtpNumber.length;
			}

			return wtpNumber.length === 14;
		}

		/**
		 * Initializes the service.
		 * @public
		 * @returns {undefined}
		 */
		function initialize() {
			PackageList.initialize({});
		}
	});

/**
 * Created by pMatthews on 7/8/2016.
 */
angular.module('wtp').factory
('WTPModels',
	function($injector) {
		function Profile() {
			this.first_name = '';
			this.last_name = '';
			this.guest_no = '';
			this.birth_date = '';
		}
		function RequestObject(id, birthDate) {
			id = angular.isDefined(id) ? id.toString().toUpperCase() : '';

			this.data = { WTP_number: id };

			if (/^(\d{2}-){2}\d{4}$/.test(birthDate)) {
				this.data.birth_date = birthDate;
			}

			this.valid = function() {
				var WTPService = $injector.get('WTPService');
				return WTPService.regExForWTPNumber(this.data.WTP_number.length).test(this.data.WTP_number) && WTPService.wtpIsValidLength(this.data.WTP_number);
			};
			this.equal = function(tgt) {
				return (angular.isDefined(tgt) && angular.isDefined(tgt.data) && tgt.data.WTP_number == this.data.WTP_number);
			};
			this.copy = function(src) {
				this.data = angular.copy(src.data);
			};
		}
		return {
			RequestObject: RequestObject,
			Profile: Profile
		};
	}
);

(function() {
	'use strict';

	angular
		.module('wtp-number', [])
		.config(config)
		.run(run);

	/**
	 * Configures our urls for this module
	 * @param {Provider} $stateProvider The state provider
	 * @returns {undefined}
	 */
	function config($stateProvider) {
		$stateProvider
			.state('wtpnumber', {
				params: {
					wtpRFID: {
						squash: true,
						type: 'string',
						value: null
					},
					wtpPromoCode: {
						isWTPPromoCode: true,
						promoCode: ''
					},
				},
				resolve: {
					initialData: initialData,
					loadAssets: loadAssets,
					hideSpinner: function(loadAssets, $rootScope) {
						$rootScope.hideSpinner();
					}
				},
				templateUrl: '/scripts/modules/wtp/views/wtpnumber.html',
				url: '/wtpnumber?',
			})
			.state('wtpnumber-reset', {
				resolve: {
					initialData: initialData,
					loadAssets: loadAssets,
					redirect: function(loadAssets, RouteRejectionService, WTPService, RestrictedPackagesService) {
						WTPService.reset();
						RestrictedPackagesService.deregisterPackageList('wtp');
						throw new RouteRejectionService.UnrecoverableException('wtpnumber');
					}
				},
				template: '<div></div>',
				url: '/wtpnumber/reset'
			});
	}

	/**
	 * Our bootstrap function
	 * @param {Service} Bootstrap Our service
	 * @returns {Promise} to bootstrap
	 * @ngInject
	 */
	function initialData(Bootstrap) {
		return Bootstrap.bootstrapApplication(true);
	}

	/**
	 * Loads the assets required for WTP
	 * @param {Promise} initialData initial data promise
	 * @param {Service} Utilities The utilities for lazy loading
	 * @returns {Promise} to load the assets
	 * @ngInject
	 */
	function loadAssets(initialData, Utilities) {
		var WTP_DIR = '/scripts/modules/wtp';
		return Utilities.cacheBustAndLazyLoad([
			WTP_DIR + '/directives/wtp-reload-page.js',
			WTP_DIR + '/controllers/wtp-reload-page-controller.js'
		]);
	}

	/**
	 * Register this alternate module with the extra flow service
	 * @public
	 * @param {WTPService} WTPService The wtp service. We have to initialize it so dependency injection does that.
	 * @param {Service} ExtraFlow To register the alternate module.
	 * @returns {undefined}
	 */
	function run(WTPService, ExtraFlow) {
		ExtraFlow.registerXMC('WTPNumber', {
			doEditMode: false,
			enabled: true,
			lockQuantity: true,
			name: 'WTPNumber',
			type: 'alternateFlowModule',
			view: 'wtpnumber',
			// this has to be true to allow wtpnumber to be accessed directly from a navigation item.
			viewIsStateName: true,
			writeSingleCharac: false
		});
	}
}());

(function() {
	'use strict';

	angular
		.module('app')
		.controller('CheckBirthdateModalController', checkBirthdateModalController);

	/**
	 * The WTP Check Birthdate Modal Controller
	 * @constructor
	 * @param {Object} $rootScope $rootScope
	 * @param {Object} $uibModalInstance $uibModalInstance
	 * @param {Object} Enums Enums
	 * @param {Object} Modal Modal service
	 * @param {Object} onSuccessCallback onSuccessCallback
	 * @param {Object} UtilsValidation UtilsValidation
	 * @param {Object} WTPService WTPService
	 * @returns {undefined}
	 * @ngInject
	 */
	function checkBirthdateModalController($rootScope, $uibModalInstance, Enums, Modal, onSuccessCallback, UtilsValidation, WTPService) {
		var vm = this;
		var validString = UtilsValidation.validString;

		vm.isSubmitLoading = false;
		vm.formErrors = {};
		vm.localeSection = 'wtp';
		vm.guest_name = WTPService.profile.first_name + ' ' + WTPService.profile.last_name;

		/**
		 * Ensure we follow the same practice for hiding the modal so that we close this modal instance
		 */
		var deregister = $rootScope.$on('hidePreviousModals', function() {
			$rootScope.modalOpen = false;
			vm.onCancel();
		});

		/**
		 * Clean up lifecycle call
		 */
		vm.$onDestroy = function() {
			deregister();
		};

		/**
		 * When the user confirms their birthdate
		 * @function
		 * @public
		 * @param {String} birthDate The birthdate to be validated
		 * @returns {undefined}
		 */
		vm.onSubmit = function(birthDate) {
			vm.submitted = true;
			vm.formErrors = {};

			if (!validString(birthDate)) {
				addError('missing');
				return;
			}

			vm.isSubmitLoading = true;
			WTPService.loadWTPNumber(WTPService.wtpNumber, birthDate.replace(/\//g, '-')).then(function(data) {
				vm.isSubmitLoading = false;
				if (data.status === Enums.status.OK) {
					onSuccessCallback(birthDate);
					$uibModalInstance.close();
					return;
				}

				addError('mismatch');
			}).catch(function() {
				// Network/API failure — not a birthdate mismatch. Dismiss the modal
				// (semantically distinct from a successful close) and show the standard
				// WTP network error so the guest knows something went wrong.
				vm.isSubmitLoading = false;
				$uibModalInstance.dismiss('network-error');
				Modal.displayModal({
					category: 'Loading WTP',
					action: 'Error',
					label: 'WTP Error',
					title: WTPService.locale('unabletoloadWTPTitle'),
					description: WTPService.locale('unabletoloadWTP')
				});
			});
		}

		/**
		 * When the user cancels the modal, close the modal
		 * @function
		 * @public
		 * @returns {undefined}
		 */
		vm.onCancel = function() {
			$uibModalInstance.close();
		}

		/**
		 * Adds a Form Error to Display
		 * @function
		 * @public
		 * @param {String} error the error to display
		 * @returns {undefined}
		 */
		function addError(error) {
			vm.formErrors[error] = true;
			vm.formErrors.$hasErrors = true;
		}
	}
})();

(function() {
	'use strict';
	var ASSETS_PATH = '/scripts/modules/video/components/video-player/'
	angular
		.module('video', ['app'])
		.constant('VIDEO_ASSETS', [
			ASSETS_PATH + 'video-player-component.js',
			ASSETS_PATH + 'video-player-component-controller.js',
			ASSETS_PATH + 'video-player-component.css',
			'/scripts/modules/video/services/video-service.js'
		]);
})();
/**
 * Created by jwroblewski on 6/28/2016.
 */
(function() {
	'use strict';

	angular
		.module('reseller', [])
		.config(function($locationProvider, $stateProvider) {
			$stateProvider
				.state('resellerBillingView', {
					controller: 'ResellerBillingController',
					url: '/resellerBillingView',
					templateUrl: '/scripts/modules/reseller/views/reseller-billing.html',
					resolve: {
						initialData: function(Bootstrap) {
							return Bootstrap.bootstrapApplication();
						},
						loadAssets: function(Utilities) {
							return Utilities.cacheBustAndLazyLoad([
								'scripts/modules/reseller/controllers/reseller-billing-controller.js'
							]);
						}
					}
				});
		});
})();

/**
 * Created by jwroblewski on 11/9/2016.
 */
(function() {
	'use strict';

	angular
		.module('reseller')
		.constant('RESELLER_CONST', { POS_DEFAULT_EMAIL: 'ExchangeSupport@accesso.com' });
})();

/**
 * Created by jwroblewski on 7/15/2016.
 */
(function() {
	'use strict';

	angular
		.module('reseller')
		.factory('ResellerPrepService', ResellerPrepService);
	/**
	 * @param  {Object} $q $q
	 * @param  {Object} $rootScope $rootScope
	 * @param  {Object} $state $state
	 * @param  {Object} $window $window
	 * @param  {Object} AppData AppData
	 * @param  {Object} CustomActionService CustomActionService
	 * @param  {Object} Enums Enums
	 * @param  {Object} Language Language
	 * @param  {Object} Package Package
	 * @returns {undefined}
	 * @ngInject
	 */
	function ResellerPrepService($q,
		$rootScope,
		$state,
		$window,
		AppData,
		CustomActionService,
		Enums,
		Language,
		Package) {
		var isArray = Array.isArray;
		var appActivatedListener = angular.noop;

		return {
			registerInitializeSocket: registerInitializeSocket,
			routeToUnrecoverableError: routeToUnrecoverableError,
			setupResellerAffiliateMode: setupResellerAffiliateMode,
			setupResellerMode: setupResellerMode
		};

		/**
		 * Registeres a post initialize socket request custom action using a reseller
		 * @param  {Object} reseller reseller merchant
		 * @returns {undefined}
		 */
		function registerInitializeSocket(reseller) {
			reseller = reseller || {};
			CustomActionService.registerCustomAction(CustomActionService.ACTIONS_ENUMS.INITIALIZE_SOCKET_POST_BUILD_REQUEST, addResellerToRequest, 'RESELLER');

			/**
			 * Appends reseller properties to a request object
			 * @param  {Object} request request object
			 * @returns {undefined}
			 */
			function addResellerToRequest(request) {
				var resellerRequestProperties = [
					'reseller_affiliate_flag',
					'reseller_id',
					'reseller_location_id',
					'trades_flag',
					'user_id',
					'user_token'
				];

				request.reseller = {};

				resellerRequestProperties.forEach(function(prop) {
					if (angular.isDefined(reseller[prop])) {
						request.reseller[prop] = reseller[prop];
					}
				});

				// copy the reseller_id to the root of the request so it can be used in a cache key
				request.reseller_id = reseller.reseller_id;

				// only copy the reseller_affiliate_flag to the root if it exists
				// this will be used in a cache key
				if (angular.isDefined(reseller.reseller_affiliate_flag)) {
					request.reseller_affiliate_flag = reseller.reseller_affiliate_flag;
				}
			}
		}

		/**
		 * Configures the store to run in reseller mode
		 * @param  {Boolean} initializeResellerModeStatus initializeResellerModeStatus
		 * @param  {Object} reseller reseller
		 * @param  {String} tradesOrigin tradesOrigin
		 * @returns {undefined}
		 */
		function setupResellerMode(initializeResellerModeStatus, reseller, tradesOrigin) {
			if (AppData.applicationActivated) {
				validateResellerInitializationSetup();
			} else {
				appActivatedListener = $rootScope.$on(Enums.services.APP_ACTIVATED, validateResellerInitializationSetup);
			}

			/**
			 * Validates user token and calls reseller register functions to initialize reseller mode
			 * @returns {undefined}
			 */
			function validateResellerInitializationSetup() {
				// deregister the listener so this does not get called again
				appActivatedListener();

				// the reseller did not get initialized properly
				// so there is no need to try to validate the user token
				if (!initializeResellerModeStatus) {
					routeToUnrecoverableError('0');
					return;
				}

				validateUserToken(reseller).then(configureResellerMode);

				/**
				 * Calls all of the reseller register functions
				 * @returns {undefined}
				 */
				function configureResellerMode() {
					registerOrderReviewTermsAndConditionsOverride();
					registerOrderReviewAutofillTermsAndConditions();
					registerPurchaseErrorCodeCustomDescription();
					registerPurchasePaymentDeleteOverride();
					registerPurchaseDisableReceiptEmail();
					registerPurchaseDisableReceiptPrices();
					registerPurchaseAddOrderCharacs(reseller);
					registerPurchaseComplete();

					if (reseller.store_enable_reset_cart) {
						registerEnableResetCart();
					}

					// POS only configuration items
					if (angular.isDefined(reseller.pos_flag)) {
						registerResellerPOSPrintOrder();
					}
				}
			}

			/**
			 * Registers custom action for terms and conditions override.
			 * @returns {undefined}
			 */
			function registerOrderReviewTermsAndConditionsOverride() {
				CustomActionService.registerCustomAction(CustomActionService.ACTIONS_ENUMS.ORDER_REVIEW_SHOW_TERMS_AND_CONDITIONS_OVERRIDE, shouldDisplayTerms, 'RESELLER');

				/**
				 * Returns false as resellers don't display terms
				 * @returns {Boolean} false
				 */
				function shouldDisplayTerms() {
					return false;
				}
			}

			/**
			 * Registers custom action for autofilling terms and conditions.
			 * @returns {undefined}
			 */
			function registerOrderReviewAutofillTermsAndConditions() {
				CustomActionService.registerCustomAction(CustomActionService.ACTIONS_ENUMS.ORDER_REVIEW_AUTOFILL_TERMS_AND_CONDITIONS, termsChecked, 'RESELLER');

				/**
				 * Returns true to autofill terms and conditions.
				 * @returns {undefined}
				 */
				function termsChecked() {
					return true;
				}
			}

			/**
			 * Registers custom action for overriding error code messages by reseller.
			 * @returns {undefined}
			 */
			function registerPurchaseErrorCodeCustomDescription() {

				CustomActionService.registerCustomAction(CustomActionService.ACTIONS_ENUMS.PURCHASE_ERROR_CODE_CUSTOM_DESCRIPTION, getCustomErrorCodeDescription, 'RESELLER');

				/**
				 * Overrides the error message locale with a reseller error message if one exists
				 * @param  {String} errorCode errorCode
				 * @param  {String} originalDescription originalDescription
				 * @returns {string} Error message description
				 */
				function getCustomErrorCodeDescription(errorCode, originalDescription) {
					if (!errorCode) {
						return originalDescription;
					}

					// get the custom locale value
					var localeSection = 'ErrorCodes';
					var localeTarget = '5000.' + errorCode;
					var customDescription = Language.getLocale(localeSection, localeTarget);

					// if no locale value is found, return the original description
					if (customDescription.length === 0 ||
						($rootScope.develop && customDescription.toLowerCase().indexOf('target missing') > -1)) {
						customDescription = originalDescription
					}

					return customDescription;
				}
			}

			/**
			 * Registers custom action for deleting payment node
			 * @returns {undefined}
			 */
			function registerPurchasePaymentDeleteOverride() {
				CustomActionService.registerCustomAction(CustomActionService.ACTIONS_ENUMS.PURCHASE_DELETE_PAYMENT_OVERRIDE, shouldDeletePayment, 'RESELLER');

				/**
				 * Returns false, don't delete the payment node on purchase
				 * @returns {Boolean} false
				 */
				function shouldDeletePayment() {
					return false;
				}
			}

			/**
			 * Registers custom action for disabling receipt email.
			 * @returns {undefined}
			 */
			function registerPurchaseDisableReceiptEmail() {
				CustomActionService.registerCustomAction(CustomActionService.ACTIONS_ENUMS.PURCHASE_DISABLE_RECEIPT_EMAIL, shouldDisableReceiptEmail, 'RESELLER');

				/**
				 * Determines if we should disable receipt email for reseller mode.
				 * @param  {Object} savedBilling savedBilling object
				 * @returns {Boolean} Should disable receipt
				 */
				function shouldDisableReceiptEmail(savedBilling) {
					return !savedBilling.enableReceiptEmail;
				}
			}

			/**
			 * Registers custom action for disabling receipt email prices.
			 * @returns {undefined}
			 */
			function registerPurchaseDisableReceiptPrices() {
				CustomActionService.registerCustomAction(CustomActionService.ACTIONS_ENUMS.PURCHASE_DISABLE_RECEIPT_PRICES, shouldDisableReceiptPrices, 'RESELLER');

				/**
				 * Determines if we should add the disable receipt prices charac on purchase.
				 * @param  {Object} savedBilling savedBilling object
				 * @returns {Boolean} Should disable receipt prices
				 */
				function shouldDisableReceiptPrices(savedBilling) {
					// this condition will be true if a reseller agent has chosen to send an email to the customer (guest)
					return angular.isDefined(savedBilling.enableReceiptEmail) && savedBilling.enableReceiptEmail;
				}
			}

			/**
			 * Registers custom action to execute after a successful purchase.
			 * @returns {undefined}
			 */
			function registerPurchaseComplete() {
				CustomActionService.registerCustomActionForChain(CustomActionService.ACTIONS_ENUMS.PURCHASE_COMPLETE_SUCCESS, sendPurchaseMessage, 'RESELLER');

				/**
				 * Posts a successful payment message to the reseller parent window.
				 * @returns {undefined}
				 */
				function sendPurchaseMessage() {
					// Build post message data
					var message = {
						type: 'accesso:resellerPurchase'
					};

					// Send a message to tell the Reseller site that
					// a successful purchase was completed
					$window.parent.postMessage(JSON.stringify(message), tradesOrigin);
				}
			}

			/**
			 * Registers custom action to enable the reset cart button.
			 * @returns {undefined}
			 */
			function registerEnableResetCart() {
				CustomActionService.registerCustomAction(CustomActionService.ACTIONS_ENUMS.ENABLE_RESET_CART, shouldEnableResetCart, 'RESELLER');

				/**
				 * Returns true, enable reset cart button
				 * @returns {Boolean} Should enable reset cart
				 */
				function shouldEnableResetCart() {
					return true;
				}
			}

			/**
			 * Registers custom action to skip view order processing and allow POS to do its ticket printing.
			 * @returns {undefined}
			 */
			function registerResellerPOSPrintOrder() {
				CustomActionService.registerCustomAction(CustomActionService.ACTIONS_ENUMS.RESELLER_POS_PRINT_ORDER_VIEW, resellerPOSPrintOrder, 'RESELLER');

				/**
				 * Enables isResellerPOSPrintOrder on the ticket controller and sends a message to the parent reseller window.
				 * @param  {Object} scope $scope from ticket controller
				 * @returns {undefined}
				 */
				function resellerPOSPrintOrder(scope) {
					// Enable an alternate order view
					scope.isResellerPOSPrintOrder = true;

					// Send the order data back to reseller site
					if (angular.isDefined(scope.viewOrder)) {
						sendPOSPrintOrderTicketsMessage();
					}

					/**
					 * Sends a message to the parent reseller window
					 * @returns {undefined}
					 */
					function sendPOSPrintOrderTicketsMessage() {
						// Build post message data
						var message = {
							type: 'accesso:resellerPOSPrintOrderTickets',
							viewOrder: {
								VIEW_ORDER_REPLY: scope.viewOrder.VIEW_ORDER_REPLY
							}
						};

						// Send a message to tell the Reseller site to
						// print POS tickets
						$window.parent.postMessage(JSON.stringify(message), tradesOrigin);
					}
				}
			}
		}

		/**
		 * Configures the store for reseller affiliate mode.
		 * @param  {Object} reseller reseller merchant object
		 * @returns {undefined}
		 */
		function setupResellerAffiliateMode(reseller) {
			if (AppData.applicationActivated) {
				validateResellerAffiliateSetup();
			} else {
				appActivatedListener = $rootScope.$on(Enums.services.APP_ACTIVATED, validateResellerAffiliateSetup);
			}

			/**
			 * Ensures the configuration is accurate for Reseller Affiliate mode.
			 * @returns {undefined}
			 */
			function validateResellerAffiliateSetup() {
				// deregister the listener so this does not get called again
				appActivatedListener();

				// Look for the trades_affiliate_flag here.
				// If it is 0 route to unrecoverable error
				if (AppData.GetMerchantDetails.trades_affiliate_flag !== '1') {
					routeToUnrecoverableError('1');
					return;
				}

				getResellerDetails()
					.then(mapDataToReseller)
					.then(configureResellerAffiliateMode)
					.finally($rootScope.hideSpinner);

				/**
				 * Maps data from the response on get reseller details.
				 * @param  {Object} data response object
				 * @returns {undefined}
				 */
				function mapDataToReseller(data) {
					var resellerDetails = data.RESELLER[0];

					if (angular.isObject(resellerDetails)) {
						reseller.reseller_name = resellerDetails.name;
					}
				}

				/**
				 * Configures Reseller Affiliate mode.
				 * @returns {undefined}
				 */
				function configureResellerAffiliateMode() {
					registerPurchaseAddOrderCharacs(reseller);
				}
			}
		}

		/**
		 * Fetches and acts on GetResellerDetails.
		 * @returns {Promise.<T>} Promise
		 */
		function getResellerDetails() {
			return $q(function(resolve, reject) {
				AppData
					.fetch(Enums.services.GET_RESELLER_DETAILS, false, {})
					.then(handleResponse);

				/**
				 * Handles response data from GetResellerDetails.
				 * @param  {Object} data response object
				 * @returns {undefined}
				 */
				function handleResponse(data) {
					if (data.status === Enums.status.FAILED) {
						routeToUnrecoverableError(data.error_code);
						reject();
					} else if (data.status === Enums.status.OK) {
						data.RESELLER = isArray(data.RESELLER) ? data.RESELLER : [data.RESELLER];
						resolve(data);
					}
				}
			});
		}

		/**
		 * Calls and acts on KeepaliveToken.
		 * @param  {Object} reseller reseller merchant object
		 * @returns {Promise.<T>} Promise
		 */
		function validateUserToken(reseller) {
			return $q(function(resolve, reject) {
				reseller = reseller || {};

				var request = {
					user_id: reseller.user_id,
					token: reseller.user_token
				};

				AppData
					.fetch(Enums.services.KEEPALIVE_TOKEN, false, request)
					.then(handleResponse)
					.finally($rootScope.hideSpinner);

				/**
				 * Handles response data from KeepaliveToken.
				 * @param  {Object} data response object
				 * @returns {undefined}
				 */
				function handleResponse(data) {
					if (data.status === Enums.status.FAILED) {
						routeToUnrecoverableError(data.error_code);
						reject();
					} else if (data.status === Enums.status.OK) {
						resolve();
					}
				}
			});
		}

		/**
		 * Routes to error code with specified reseller merchant error code.
		 * @param  {String} errorCode Error code
		 * @returns {undefined}
		 */
		function routeToUnrecoverableError(errorCode) {
			errorCode = errorCode || '0';
			$rootScope.hideSpinner();
			$rootScope.$broadcast('hidePreviousModals');

			// errorCode is the error_code with a prefix of the Trades application id (which is 5000)
			$rootScope.routeTo($state.href('/error/:errorCode/:noButtons', {
				errorCode: '5000.' + errorCode,
				noButtons: true
			}));
		}

		/**
		 * Registers custom action to add reseller order characs before purchase.
		 * @param  {Object} reseller reseller merchant object
		 * @returns {undefined}
		 */
		function registerPurchaseAddOrderCharacs(reseller) {
			CustomActionService.registerCustomAction(CustomActionService.ACTIONS_ENUMS.PURCHASE_ADD_ORDER_CHARACS, addResellerOrderCharacs, 'RESELLER');

			/**
			 * Appends reseller specific order characs to the purchase request.
			 * @param  {Array} orderCharacs Order characs array
			 * @returns {undefined}
			 */
			function addResellerOrderCharacs(orderCharacs) {
				addCharac(Enums.orderCharacs.RESELLER_ID, reseller.reseller_id);
				addCharac(Enums.orderCharacs.RESELLER_LOCATION_ID, reseller.reseller_location_id);
				addCharac(Enums.orderCharacs.RESELLER_NAME, reseller.reseller_name);

				/**
				 * Pushes objects with passed in key value pair to order characs
				 * @param  {String} keyName keyName
				 * @param  {String} value value
				 * @returns {undefined}
				 */
				function addCharac(keyName, value) {
					if (angular.isDefined(keyName) && angular.isDefined(value)) {
						var newCharac = {};
						newCharac[keyName] = value;

						orderCharacs.push(newCharac);
					}
				}
			}
		}
	}
})();


/**
 * Created by jwroblewski on 7/11/2016.
 */
(function() {
	'use strict';

	angular
		.module('reseller')
		.factory('ResellerRouteService', ResellerRouteService);

	function ResellerRouteService($rootScope, $state, $timeout, $transitions, CustomActionService, Enums) {
		var onBeforeRoutesDeregister = angular.noop,
			onBeforeShippingSelectionDeregister = angular.noop;

		return {
			registerRoutes: registerRoutes,
			registerShippingSelectionRoutes: registerShippingSelectionRoutes
		};

		function registerRoutes() {
			onBeforeRoutesDeregister = $transitions.onBefore({
				to: function resellerBillingTransitionHookTo(state) {
					return [
						Enums.routes.SHIPPING,
						Enums.routes.BILLING,
						Enums.routes.PAYMENT_METHOD
					].includes(state.name.replace(/^\/(.+)/, '$1'));
				}
			}, setupRouteOverrides);
			CustomActionService.registerCustomAction(CustomActionService.ACTIONS_ENUMS.CART_CHECKOUT_GET_ROUTE, getResellerCheckoutRoute, 'RESELLER');
		}

		function registerShippingSelectionRoutes() {
			onBeforeShippingSelectionDeregister = $transitions.onBefore({
				to: function resellerShippingTransitionHookTo(state) {
					return [
						Enums.routes.BILLING,
						Enums.routes.PAYMENT_METHOD
					].includes(state.name.replace(/^\/(.+)/, '$1'));
				}
			}, setupShippingSelectionRouteOverrides);
			CustomActionService.registerCustomAction(CustomActionService.ACTIONS_ENUMS.CART_CHECKOUT_GET_ROUTE, getResellerShippingSelectionCheckoutRoute, 'RESELLER');
		}

		/**
		 * Registered on the $transitions.onStart event and only if a reseller is provided to the store.
		 * This is required to prevent multiple checkout error conditions from routing
		 * back to a state that does not apply to the reseller checkout process
		 * @public
		 * @function
		 * @param {Transition} trans The Transition Object
		 * @returns {undefined}
        */
		function setupRouteOverrides() {
			// Use routeTo to transition to new url to perserve query params
			return $rootScope.routeTo(getResellerCheckoutRoute());
		}

		/**
		 * Setup's the shipping selection route overrides
		 * @public
		 * @function
		 * @param {Transition} trans The Transition Object
		 * @returns {undefined}
		 */
		function setupShippingSelectionRouteOverrides(trans) {
			// Use routeTo to transition to new url to perserve query params
			return $rootScope.routeTo(getResellerCheckoutRoute());
		}

		/**
		 * The route to use for the reseller checkout process
		 * @returns {string}
        */
		function getResellerCheckoutRoute() {
			return Enums.routes.RESELLER_BILLING;
		}

		function getResellerShippingSelectionCheckoutRoute() {
			return Enums.routes.SHIPPING;
		}

	}
})();

/**
 * Created by jwroblewski on 6/20/2016.
 */
(function() {
	'use strict';

	angular
		.module('reseller')
		.factory('ResellerService', ResellerService);

	/**
	 * Our reseller service
	 * @public
	 * @function
	 * @param {Service} $http $http
	 * @param {Service} $location $location
	 * @param {Service} $log $log
	 * @param {Scope} $rootScope $rootScope
	 * @param {Service} $q $q
	 * @param {Service} $timeout $timeout
	 * @param {Service} $window $window
	 * @param {Service} AppData AppData
	 * @param {Service} CustomActionService CustomActionService
	 * @param {Service} Enums Enums
	 * @param {Service} IdleTimeout IdleTimeout
	 * @param {Service} JSONValidator JSONValidator
	 * @param {Service} Keepalive Keepalive
	 * @param {Service} Utilities Utilities
	 * @param {Service} UrlUtils UrlUtils
	 * @param {Service} UtilsValidation UtilsValidation
	 * @param {Service} ResellerPrepService ResellerPrepService
	 * @param {Service} ResellerRouteService ResellerRouteService
	 * @return {ResellerService} our singleton instance
	 * @ngInject
	 */
	function ResellerService(
		$http,
		$location,
		$log,
		$rootScope,
		$q,
		$timeout,
		$window,
		AppData,
		CustomActionService,
		Enums,
		IdleTimeout,
		JSONValidator,
		Keepalive,
		Utilities,
		UrlUtils,
		UtilsValidation,
		ResellerPrepService,
		ResellerRouteService
	) {
		var reseller = undefined;
		var initialized = false;
		var merchantId = '';
		var resellerId = '';
		var resellerLocationId = '';
		var tradesFlag = '';
		var tradesOrigin = '';
		var idle = {};
		var checkProp = Utilities.safelyCheckPropertyOnObject;
		/**
		 * Keeping this list private because it is less likely and more difficult to modify here.
		 * Despite its name, it is possible to modify a complex type in a constant
		 * @type {string[]}
    */

		var service = {
			/**
			 * Holds the cached result of us running checks to see if the user is in reseller mode and is allowed access or not
			 * @protected
			 * @type {Boolean}
			 */
			_assessInvalidAccessResult: null,
			assessInvalidAccess: assessInvalidAccess,
			bootstrapReseller: bootstrapReseller,
			getBillingType: getBillingType,
			getReseller: getReseller,
			isResellerAffiliateMode: isResellerAffiliateMode,
			isResellerMode: isResellerMode,
			isResellerPOSMode: isResellerPOSMode,
			resellerSkipStep: resellerSkipStep,
			verifyAffiliateJwt: verifyAffiliateJwt
		};

		return service;

		/**
		 * Check reseller_skip_step app config is v5 opened on the right mode and
		 * the page we want to skip matches with app config value
		 * @function
		 * @public
		 * @param {string} stepName - step that we want to skip
		 * @return {boolean} true if all the conditions are met
		 */
		function resellerSkipStep(stepName) {
			var resellerSkipStepConfig;
			if (!JSONValidator.validate('reseller_skip_step', AppData.settings.reseller_skip_step)) {
				return false;
			}
			resellerSkipStepConfig = JSON.parse(AppData.settings.reseller_skip_step);
			return resellerSkipStepConfig.some(function(mode) {
				if (service.isResellerMode() && !service.isResellerPOSMode() && mode['exchange']) {
					return mode['exchange'].indexOf(stepName) > -1;
				} else if (service.isResellerPOSMode() && mode['pos']) {
					return mode['pos'].indexOf(stepName) > -1;
				} else if (service.isResellerAffiliateMode() && mode['affiliate']) {
					return mode['affiliate'].indexOf(stepName) > -1;
				}
				return false;
			});
		}

		function initializeServiceValues() {
			var locationSearch = $location.search();
			merchantId = locationSearch['merchant_id'];
			resellerId = locationSearch[Enums.urlParameters.resellerId];
			resellerLocationId = locationSearch[Enums.urlParameters.resellerLocationId];
			tradesFlag = locationSearch[Enums.urlParameters.tradesFlag];
			tradesOrigin = locationSearch[Enums.urlParameters.tradesOrigin];
		}

		/**
		 * Assess if the user has come to the store with invalid parameters to load the reseller store.
		 * @public
		 * @function assessInvalidAccess
		 * @return {Promise} To resolve if the user has valid access to the store.
		 */
		function assessInvalidAccess() {
			return $q(function(resolve, reject) {
				var responseIsTradesMerchant,
					isResellerMode,
					isResellerAffiliateMode,
					passed = true;

				// Check if we have already done these checks so we don't go through all this logic again.
				if (service._assessInvalidAccessResult !== null) {
					return service._assessInvalidAccessResult ? resolve() : reject();
				}

				responseIsTradesMerchant = checkProp('AppData.GetMerchantDetails.is_trade_merchant', AppData, Utilities.getBoolean);
				isResellerMode = service.isResellerMode();
				isResellerAffiliateMode = service.isResellerAffiliateMode();

				if (!JSONValidator.validate('disable_trade_merchant_assessement', AppData.settings.disable_trade_merchant_assessement)) {
					// If the user has correct URL paremters to load the affiliate store, but backend responds that GetMerchantDetails.is_trade_merchant is false, fail
					if ((isResellerMode || isResellerAffiliateMode) && !responseIsTradesMerchant) {
						passed = false;
					// If the user incorrect URL paremters but backend responds that GetMerchantDetails.is_trade_merchant is true and should be loading a reseller, fail
					} else if ((!isResellerMode && !isResellerAffiliateMode) && responseIsTradesMerchant) {
						passed = false;
					}
				}

				if (passed && !isResellerMode && (isResellerAffiliateMode || checkProp('AppData.GetMerchantDetails.AFFILIATE', AppData, UtilsValidation.isRealObject))) {
					return service.verifyAffiliateJwt(resolve, reject);
				}

				service._assessInvalidAccessResult = passed;

				if (passed) {
					return resolve();
				}

				ResellerPrepService.routeToUnrecoverableError('0');
				return reject();
			});
		}

		/**
		 * Verifies that the user is signed in with a valid JWT.
		 * @param {Function} success Your success callback
		 * @param {Function} failure Your failure callback
		 * @returns {Promise} To verify.
		 */
		function verifyAffiliateJwt(success, failure) {
			var queryParams = UrlUtils.objectToQueryParams($location.search());

			return $http.get('/embed/affiliate/validate.php?' + queryParams)
				.then(function(resp) {
					var valid = checkProp('resp.data.status', resp, Utilities.getBoolean);
					var hostname;
					var redirectUrl;
					service._assessInvalidAccessResult = valid;

					if (valid) {
						return success();
					}

					hostname = $location.host();
					redirectUrl = $location.protocol() + '://' + hostname + (hostname.indexOf('localhost') > -1 ? ':' + $location.port() : '') + '/embed/login.php?' + queryParams;

					try {
						if (Utilities.isInIFrame()) {
							window.top.location.href = redirectUrl
						} else {
							window.location.href = redirectUrl;
						}
					} catch (ignore) {
						// ignore and just show them the failure modal
					}

					ResellerPrepService.routeToUnrecoverableError('0');
					failure();
				})
				.catch(function() {
					service._assessInvalidAccessResult = false;
					failure();
					ResellerPrepService.routeToUnrecoverableError('0');
				});
		}

		/**
		 * Reads url params to determine if the store should bootup in reseller mode
		 * If the store should not be in reseller move it will return a resolved promise
		 * and store initialization should continue unaffected.
		 * If the store should be in reseller mode then it will attempt to get reseller
		 * data from the reseller site via post messages
		 * Once the data is received and is valid the promise is resolved and the store
		 * will bootup in reseller mode.
		 * If the data is not received or something else fails with the reseller setup
		 * the promise will resolve and after the store finishes booting up it should
		 * show errors that will deny access to the store.
		 * @returns {*} promise.
    */
		function bootstrapReseller() {
			return $q(function(resolve) {
				// Only execute the bootstrap logic once
				if (initialized) {
					resolve();
					return;
				} else {
					initialized = true;
				}

				initializeServiceValues();

				//reseller affiliate
				if (service.isResellerAffiliateMode()) {
					reseller = {};
					reseller.reseller_affiliate_flag = 1;
					reseller.reseller_id = Number(resellerId);
					reseller.reseller_location_id = Number(resellerLocationId);
					ResellerPrepService.registerInitializeSocket(reseller);
					ResellerPrepService.setupResellerAffiliateMode(reseller);
					CustomActionService.registerCustomAction(CustomActionService.ACTIONS_ENUMS.RESELLER_SKIP_STEP, service.resellerSkipStep);
					resolve();
					return;
				}

				// Only attempt to boot in reseller mode if the store
				// should be in reseller mode
				if (!service.isResellerMode()) {
					resolve();
					return;
				}

				CustomActionService.registerCustomAction(CustomActionService.ACTIONS_ENUMS.RESELLER_SKIP_STEP, service.resellerSkipStep);
				// remove a post message listener in case it didn't get removed
				$window.removeEventListener('message', receiveInitializationMessage);

				// setup the post message listener so we can receive messages from the Reseller site
				$window.addEventListener('message', receiveInitializationMessage);

				// Register a timeout in case we can't send or receive a message within 20 seconds
				var timeoutPromise = $timeout(handleResellerInitializationFailure, 20000);

				// If we have a trusted origin, send the message
				if (isTrustedTradesOrigin(tradesOrigin)) {
					sendInitializationMessage();
				} else {
					// If the origin is not trusted
					// handle the failure
					handleResellerInitializationFailure();
				}

				function sendInitializationMessage() {
					// Build post message data
					var message = {
						type: 'accesso:resellerInitialization'
					};

					// Send a message to tell the Reseller site that the store
					// is listening and ready to receive a message with data
					$window.parent.postMessage(JSON.stringify(message), tradesOrigin);
				}

				function receiveInitializationMessage(event) {

					// Do we trust the sender?
					if (event.origin.toLowerCase() !== tradesOrigin.toLowerCase()) {
						return;
					}

					// Is the content valid?
					try {
						if (!verifyResellerData(event.data)) {
							return;
						}
					} catch (e) {
						var msg = 'Shopland: handleResellerDataPostMessage: data sent to iframe is not a valid JSON string.';
						$log.error(msg, e);
						return;
					}

					// Setup Reseller Mode
					handleResellerInitializationSuccess(event);
				}

				function handleResellerInitializationSuccess(event) {
					// we have the message and it is valid so we can cancel the timeout
					$timeout.cancel(timeoutPromise);

					// no need to keep listening, deregister the listener
					$window.removeEventListener('message', receiveInitializationMessage);

					// Setup reseller mode
					var eventData = JSON.parse(event.data);
					mapDataToReseller(eventData);
					mapDataToIdle(eventData);
					setUpKeepaliveService();
					ResellerPrepService.registerInitializeSocket(reseller);
					ResellerPrepService.setupResellerMode(true, reseller, tradesOrigin);
					registerRouting();

					resolve();
				}

				function handleResellerInitializationFailure() {
					// Remove the timeout if it has not been removed already
					$timeout.cancel(timeoutPromise);

					// we should not keep listening, deregister the listener
					$window.removeEventListener('message', receiveInitializationMessage);

					// This is here so we can display a localized error and disable the store
					// after the store has retrieved locale data
					ResellerPrepService.setupResellerMode(false);
					resolve();
				}
			});
		}

		/**
		 * Gets the current reseller data
		 * @returns {object}
    */
		function getReseller() {
			return reseller;
		}

		/**
		 * checks the url query string for the required parameters
		 * to put the store in reseller mode
		 * @returns {boolean} true if reseller mode, false if not
		 */
		function isResellerAffiliateMode() {
			var merchantIdValid = (angular.isDefined(merchantId) && !isNaN(parseInt(merchantId)));
			var resellerIdValid = (angular.isDefined(resellerId) && !isNaN(parseInt(resellerId)));
			var resellerLocationIdValid = (angular.isDefined(resellerLocationId) && !isNaN(parseInt(resellerLocationId)));

			return (merchantIdValid && resellerIdValid && resellerLocationIdValid);
		}


		/**
		 * checks the url query string for the required parameters
		 * to put the store in reseller mode
		 * @returns {boolean} true if reseller mode, false if not
    */
		function isResellerMode() {
			var merchantIdValid = (angular.isDefined(merchantId) && !isNaN(parseInt(merchantId)));
			var tradesFlagValid = (angular.isDefined(tradesFlag) && tradesFlag === '1');

			return (merchantIdValid && tradesFlagValid);
		}

		function isResellerPOSMode() {
			return !!reseller && angular.isDefined(reseller.pos_flag);
		}

		function isShippingSelectionEnabled() {
			return reseller.store_checkout_enable_shipping_selection || false;
		}

		/**
		 * check to ensure that the trades origin is trusted
		 * @protected
		 * @param {string} origin the trades url
		 * @returns {boolean} specifies if the trades origin is trusted
         */
		function isTrustedTradesOrigin(origin) {
			var isTrusted = false,
				domain,
				originDomain,
				originHostname;

			if (UtilsValidation.validString(origin)) {
				originHostname = getOriginHostname(origin);

				if (originHostname) {
					domain = getDomain($location.host());
					originDomain = getDomain(originHostname);
					isTrusted = domain.toLowerCase() === originDomain.toLowerCase();
				}

				if (!isTrusted && isDevEnvironment()) {
					isTrusted = isTrustedDevOrigin(origin);
				}
			}

			return isTrusted;
		}

		/**
		 * get the domain without subdomain
		 * @protected
		 * @param {string} url the url
		 * @returns {string} domain without subdomain
		 */
		function getDomain(url) {
			var domains = url.split('.'),
				domainsLength = domains.length;
			if (domainsLength > 1) {
				return domains.slice(domains.length - 2).join('.');
			}
			return url;
		}

		function isDevEnvironment() {
			var currentHost = $location.host().toLowerCase();
			return (currentHost === 'localhost' ||
				Utilities.isHostOrSubdomain(currentHost, 'ceiris.com') ||
				Utilities.isHostOrSubdomain(currentHost, 'dev-secure.accesso.com'));
		}

		/**
		 * Safely extracts the lowercased hostname from an origin string, guarding against substring/lookalike bypasses
		 * @protected
		 * @param {string} origin the origin to parse
		 * @returns {string} the lowercased hostname, or '' if origin cannot be parsed as a host
		 */
		function getOriginHostname(origin) {
			// A bare 'host:port' (no scheme) is valid opaque-scheme syntax to new URL() (e.g. 'localhost:7080'
			// parses as scheme 'localhost:' with no host), so it must be prefixed before parsing rather than
			// relying on a parse failure to trigger the http:// fallback.
			var bareHostRegex = /^[a-z0-9.-]+(:\d+)?$/i;

			try {
				if (bareHostRegex.test(origin)) {
					return new URL('http://' + origin).hostname.toLowerCase();
				}
				return new URL(origin).hostname.toLowerCase();
			} catch (err) {
				return '';
			}
		}

		/**
		 * localhost, and any ceiris.com domains are trusted dev trades origins
		 * Additionally any host in a trade origin that matches passportexchange.dev-*
		 * or passportexchange.test-* under accessoticketing.com is considered to be
		 * a dev origin. This allows for custom builds that a specific developer may
		 * need to run from the dev server using the following url convention:
		 * https://passportexchange.dev-%customName%.accessoticketing.com
		 * @param origin the Trades Origin
		 * @returns {boolean}
		 */
		function isTrustedDevOrigin(origin) {
			var hostname = getOriginHostname(origin),
				devOriginRegEx = /^passportexchange\.(dev|test)-.*\.accessoticketing\.com$/,
				hasHttpScheme = /^https?:\/\//i.test(origin);

			return hostname === 'localhost' ||
				Utilities.isHostOrSubdomain(hostname, 'ceiris.com') ||
				(hasHttpScheme && devOriginRegEx.test(hostname));
		}

		function verifyResellerData(resellerData) {
			return JSONValidator.validate('resellerInitializationData', resellerData);
		}

		function mapDataToReseller(eventData) {
			reseller = angular.copy(eventData);
			reseller.trades_flag = tradesFlag;

			//delete idle properties
			delete reseller.idle_timeout_minutes;
			delete reseller.idle_warning_minutes;
			delete reseller.keepalive_interval_minutes;
		}

		function mapDataToIdle(eventData) {
			//map only idle properties here;

			idle = {
				idle_timeout_minutes: eventData.idle_timeout_minutes,
				idle_warning_minutes: eventData.idle_warning_minutes,
				keepalive_interval_minutes: eventData.keepalive_interval_minutes
			};

		}

		function setUpKeepaliveService() {
			if (idle.idle_warning_minutes && idle.idle_warning_minutes > 0 ) {
				//Timeout is set to thier warning, and idle is set to their timeout
				IdleTimeout.changeIdleTimeout(idle.idle_warning_minutes * 60);
			}

			if (idle.idle_timeout_minutes && idle.idle_timeout_minutes > 0) {
				//Timeout is set to thier warning, and idle is set to their timeout
				IdleTimeout.changeIdleWarning(idle.idle_timeout_minutes * 60);
			}

			if (idle.keepalive_interval_minutes && idle.keepalive_interval_minutes > 0) {
				Keepalive.setInterval(idle.keepalive_interval_minutes * 60);

				Keepalive.start();

				$rootScope.$on('Keepalive', postKeepaliveMessage);
				$rootScope.$on('IdleStart', postIdleStartMessage);

			}

			function postIdleStartMessage() {
				var message = {
					type: 'accesso:resellerIdleStart'
				};

				$window.parent.postMessage(JSON.stringify(message), tradesOrigin);
			}

			function postKeepaliveMessage() {
				var message = {

					type: 'accesso:resellerKeepalive'
				};

				$window.parent.postMessage(JSON.stringify(message), tradesOrigin);
			}
		}

		function registerRouting() {
			if (service.isResellerPOSMode()) {
				ResellerRouteService.registerRoutes();
			} else {
				if (isShippingSelectionEnabled()) {
					ResellerRouteService.registerShippingSelectionRoutes();
				} else {
					ResellerRouteService.registerRoutes();
				}
			}
		}

		function getBillingType(billingTypes, resellerAuthType) {
			billingTypes = billingTypes || [];
			return billingTypes.filter(function(billingType) {
				return billingType.auth_type === resellerAuthType;
			})[0];
		}
	}
})();

/**
 * Created by jwroblewski on 3/15/2017.
 */
(function() {
	'use strict';

	angular
		.module('reseller')
		.factory('ResellerUrlService', ResellerUrlService);

	/* @ngInject */
	function ResellerUrlService($location,
								Enums) {
		return {
			getParameterValuesAsString: getParameterValuesAsString
		};

		/**
		 * Concatenates reseller url param values
		 * that can be used to generate a unique key
		 * or to determine if any of these params exist
		 * @returns {string}
		 */
		function getParameterValuesAsString() {
			var locationSearch = $location.search();
			var resellerId = locationSearch[Enums.urlParameters.resellerId];
			var resellerLocationId = locationSearch[Enums.urlParameters.resellerLocationId];
			var tradesFlag = locationSearch[Enums.urlParameters.tradesFlag];
			var tradesOrigin = locationSearch[Enums.urlParameters.tradesOrigin];

			var urlParamValues = [resellerId, resellerLocationId, tradesFlag, tradesOrigin];

			return urlParamValues.join('');
		}
	}
})();
angular.module('app').factory
('NotificationActionsService',
	function($q, JSONValidator, Modal, Utilities, AppData, Enums, Language){
		var service = {
			configs: [],
			decideToDisplayModal:decideToDisplayModal

		};
		function decideToDisplayModal(cartItems, callback){
			var hasPackageInCart = false;
			var config = {};
			for(var i = 0; i < cartItems.length; i++){
				for( var k= 0 ; k < service.configs.length; k++){
					for(var p = 0; p < service.configs[k].package_ids; p++) {
						var pkdId = service.configs[k].package_ids[p];
						if (pkdId == cartItems[i].package_id) {
							hasPackageInCart = true;
							config = service.configs[k];
							break;
						}
					}
				}
			}
			if(!hasPackageInCart){
				callback();
			} else {
				Modal.displayModal(
					{
						category: 'Cart'
						, action: 'Cart Notification'
						, title: Language.getLocale(config.locale_section, config.locale_title)
						, description: Language.getLocale(config.locale_section, config.locale_description)
						, buttonFlags: [Enums.buttonFlags.OK]
						, callback: function () {
						callback();
					}
					}
				);
			}
		}

		return service;

	});

angular.module('app').factory
('NotificationPrepService',
	function($q, JSONValidator, CustomActionService, AppData, NotificationActionsService){
		var service = {
			getConfig:getConfig,
			registerCustomAction:registerCustomAction

		};

		function getConfig(){
			var configs = [];
			if(JSONValidator.validate('custom_notifications', AppData.settings.custom_notifications)){

				var configsJSON = JSON.parse(AppData.settings.custom_notifications);
				configsJSON.forEach(function(c){
					configs.push(c);
				});

			}
			return configs
		}

		function registerCustomAction(configs){
			if(configs.length > 0){
				CustomActionService.registerCustomAction(CustomActionService.ACTIONS_ENUMS.NOTIFY_USER_AT_CHECKOUT, NotificationActionsService.decideToDisplayModal);

			}
		}

		return service;

	});

angular.module('notification', [
]).run(function($rootScope, Enums, NotificationActionsService, NotificationPrepService) {
	var listener = $rootScope.$on(Enums.services.APP_ACTIVATED, configureNotifications);

	function configureNotifications() {
		NotificationActionsService.configs = NotificationPrepService.getConfig();
		NotificationPrepService.registerCustomAction(NotificationActionsService.configs);
		listener();
	}
});

/**
 * Created by ltischuk on 4/10/17.
 */
(function() {
	'use strict';

	angular
		.module('request', [])
})();

(function() {
	'use strict';

	angular
		.module('request')
		.factory('RequestService', RequestService);
	/**
	 * Request Service
	 * @param  {Object} AppData AppData Service
	 * @param  {Object} Enums Enums Service
	 * @param  {Object} Utilities Utilities Service
	 * @param  {Object} $q $q Service
	 * @returns {Object} RequestService
	 */
	function RequestService(AppData,
		Enums,
		Utilities,
		$q) {
		var service = {
			sendRequest: sendRequest
		};

		return service;

		////////////////

		/**
		 * Wrapper to simply retrieve uncached Backend request
		 * @param {String} requestName name of request.
		 * @param {Object} req request object
		 * @returns {*} promise
		 */
		function sendRequest(requestName, req) {
			return $q(function(resolve, reject) {
				AppData
					.fetch(requestName, false, req)
					.then(function(response) {
						if (Utilities.safelyCheckPropertyOnObject('response.status', response) && response.status === Enums.status.OK) {
							resolve(response);
						} else {
							return reject(response);
						}
					})
					.catch(reject);
			});
		}
	}

})();


(function() {
	'use strict';

	angular
		.module('request')
		.factory('RequestPropertyStorageService', RequestPropertyStorageService);

	/**
	 * Request Property Storage Service
	 * This is a facilitator of local storage saving of properties that need to be attached on all requests
	 * Node already has a mechanism for attaching params to requests but there was no way to hook into this on
	 * startup yet, which is what this allows for
	 * There are two main callees of this in the app:
	 * 1. On startup via formulating the initializeSocket request,
	 *   we can assess what properties were previously stored and need to be sent
	 * 2.  On an important action (i.e. for cultual clients, when a member logs in
	 *   so that any member-specific products can persist if user refreshes)
	 * This data store does not need to be saved in memory as there are no accesses outside of those
	 * use cases for now
	 * @public
	 * @param {Service} ClientInfo - ClientInfo service
	 * @param {Service} Storage - Storage service
	 * @param {Service} $window - the $window service
	 * @module {request}
	 * @return {RequestPropertyStorageService} The singleton instance of the service
	 * @ngInject
	 */
	function RequestPropertyStorageService(ClientInfo, Storage, $window) {
		/**
		 * isString function reference
		 * @type function
		 * @private
		 */
		var isString = angular.isString;


		/**
		 * In Memory store backup if local storage is not able to be leveraged
		 */
		var _inMemoryStore = {};

		/**
		 * Storage key of global request properties
		 * @type String
		 */
		var STORAGE_KEY = '_globalAPIRequestProperties';

		/**
		 * The API of the RequestService
		 */
		var service = {
			appendPropertyToAPIRequests: appendPropertyToAPIRequests,
			removePropertyToAPIRequests: removePropertyToAPIRequests,
			createStoreForGlobalAPIReqProps: createStoreForGlobalAPIReqProps,
			getGlobalAPIRequestProperties: getGlobalAPIRequestProperties
		};

		return service;

		/**
		 * Append a property to the list of properties to attached to all API requests
		 * @public
		 * @param {String} key - the property key
		 * @param {Any} value - the property value
		 * @return {undefined}
		 */
		function appendPropertyToAPIRequests(key, value) {
			var storedProperties = getGlobalAPIRequestProperties();
			if (isString(key) && !storedProperties.find(function itemIsInStoredProperties(item) {
				return item.prop_name === key && item.prop_value === value
			})) {
				storedProperties.push(
				/* eslint-disable camelcase */
					{
						prop_name: key,
						prop_value: value
					});
				/* eslint-disable camelcase */
				Storage.set(STORAGE_KEY, storedProperties);
				_inMemoryStore[STORAGE_KEY] = storedProperties;
			}
		}

		/**
		 * Removes properties to add to our backend request.
		 * @param {String} key The key
		 * @returns {undefined}
		 */
		function removePropertyToAPIRequests(key) {
			var storedProperties = getGlobalAPIRequestProperties();

			if (isString(key)) {
				storedProperties = storedProperties.reduce(function(acc, el) {
					/* eslint-disable camelcase */
					if (el.prop_name === key) {
						return acc;
					}
					/* eslint-disable camelcase */
					acc.push(el);
					return acc;
				}, []);
				Storage.set(STORAGE_KEY, storedProperties);
				_inMemoryStore[STORAGE_KEY] = storedProperties;
			}
		}

		/**
		 * Create the store for global API request properties that should be attached to all API requests
		 * @public
		 * @return {Array<Object>} - the stored properties list
		 */
		function createStoreForGlobalAPIReqProps() {
			var storedProperties = [];
			/* eslint-disable camelcase */
			storedProperties.push(
				{
					prop_name: 'device',
					prop_value: ClientInfo.deviceType
				}
			);
			storedProperties.push(
				{
					prop_name: 'language',
					prop_value: $window.accessoLanguage
				}
			)
			/* eslint-disable camelcase */
			Storage.set(STORAGE_KEY, storedProperties);
			_inMemoryStore[STORAGE_KEY] = storedProperties;
			return storedProperties;
		}

		/**
		 * Get the stored API Request properties that should be appended to all API requests
		 * @public
		 * @return {Object} - stored request properties
		 */
		function getGlobalAPIRequestProperties() {
			var storedProperties = Storage.get(STORAGE_KEY) || _inMemoryStore[STORAGE_KEY];
			if (!storedProperties || !storedProperties.length) {
				storedProperties = createStoreForGlobalAPIReqProps();
			}
			return storedProperties;
		}
	}
})();

(function() {
	'use strict';

	angular.module('accessibility', []);
})();
(function() {
	'use strict';

	angular
		.module('accessibility')
		.factory('AriaAnnouncer', AriaAnnounce);

	/**
	 * Speak to screen readers.
	 * @public
	 * @constructor
	 * @param {Service} $document The document service
	 * @param {Service} UtilsValidation For validating data
	 * @return {AriaAnnounce} the service
	 * @ngInject
	 */
	function AriaAnnounce($document, UtilsValidation) {
		var elements = {
			assertive: $document[0].getElementById('aria-announcer-assertive'),
			polite: $document[0].getElementById('aria-announcer-polite')
		};

		return {
			assertive: createAnnouncer('assertive'),
			polite: createAnnouncer('polite')
		};

		/**
		 * A function to create our announcers.
		 * @public
		 * @param {String} type Either polite or assertive
		 * @return {Function} to create the service calls.
		 */
		function createAnnouncer(type) {
			return function(msg) {
				if (UtilsValidation.validString(msg)) {
					elements[type].innerHTML = msg;
				}
			}
		}
	}
})();

(function() {
	'use strict';

	angular
		.module('accessibility')
		.directive('focusContent', focusContent);

	/**
	 * Directive used for focusing the content of a page on statechange / viewload events
	 */
	function focusContent($rootScope, $document, $timeout, FocusService) {
		// Usage: Sets focus to store menu on state change.
		//
		// Creates: An attribute directive that assists in accessibility.
		//
		var directive = {
			link: link,
			restrict: 'A',
			scope: {}
		};
		var pageDocument = $document[0];

		return directive;

		/**
		 * The link function that triggers on directive usage
		 * @public
		 * @returns {undefined}
		 */
		function link() {
			$rootScope.$on('$viewContentLoaded', focusContentDelay);
			$rootScope.$on('accessibilityFocus', focusContent);

			/**
			 * Used to focus the content window of the page
			 * @private
			 * @returns {undefined}
			 */
			function focusContentDelay() {
				if ($rootScope.previousRoute) {
					$timeout(setFocus, 300);
				}
			}

			/**
			 * Used to focus the content window of the page
			 * @private
			 * @returns {undefined}
			 */
			function focusContent() {
				var element = pageDocument.getElementById('application-view');
				if (element) {
					element.focus({ preventScroll: true });
				}
			}

			/**
			 * Set the focus of the page depending if a modal is displayed or default to application-view element.
			 * @private
			 * @returns {undefined}
			 */
			function setFocus() {
				var mainMenuVisible = pageDocument.querySelector('.navigation-enabled #navigation-view');
				var modalVisible = pageDocument.querySelector('#modal-view-container.show');
				var splashVisible = pageDocument.querySelector('.splashScreen');

				if (mainMenuVisible) {
					FocusService.setFocusToContainer('mainMenu', document.activeElement);
				} else if (modalVisible) {
					FocusService.setFocusToContainer('modal', document.activeElement);
				} else if (splashVisible) {
					FocusService.setFocusToContainer('splashScreen', document.activeElement);
				} else {
					focusContent();
				}
			}
		}
	}
})();
(function() {
	'use strict';

	angular
		.module('accessibility')
		.factory('FocusService', FocusService);

	/**
	 * Focus service to manage getting or setting the focus within modals and other elements to satisfy ADA Compliance.
	 * @public
	 * @constructor
	 * @function
	 * @param {Service} $document For getting elements on the page
	 * @param {Service} $injector $injector service
	 * @param {Service} $timeout Timeout used to wait for modal to be visible
	 * @param {Service} $window For adding event listeners for key events
	 * @return {Object} Our api
	 * @ngInject
	 */
	function FocusService($document, $injector, $timeout, $window) {
		var isObject = angular.isObject,
			pageDocument = $document[0],
			containerType,
			elementLosingFocus,
			focusButton,
			triggeringElements = [],
			tabKey = 9,
			escapeKey = 27;

		var containers = {
			mainMenu: {
				containerSelector: '.navigation-enabled #navigation-view',
				focusButtonSelector: '#accessibilityFocus',
				focusableElementSelector: '#navigation-view button:not(.ng-hide):not(.hide), ' +
					'#navigation-view input:not(.ng-hide):not(.hide), ' +
					'#navigation-view select:not(.ng-hide):not(.hide), ' +
					'#navigation-view textarea:not(.ng-hide):not(.hide), ' +
					'#navigation-view [href]:not(.ng-hide):not(.hide), ' +
					'#navigation-view [tabindex]:not([tabindex="-1"]):not(.ng-hide):not(.hide), ' +
					'#navigation-view [role="button"]:not(.ng-hide):not(.hide)'
			},
			modal: {
				containerSelector: '#modal-view-container',
				focusButtonSelector: '#defaultModalClose:not(.ng-hide), #promoModalClose:not(.ng-hide), .modal button, .s-modal gap-button',
				focusableElementSelector: '.modal button:not(.hide), ' +
					'.modal input:not(.ng-hide):not(.hide), ' +
					'.modal select:not(.ng-hide):not(.hide), ' +
					'.modal textarea:not(.ng-hide):not(.hide), ' +
					'.modal [href]:not(.ng-hide):not(.hide), ' +
					'.modal [tabindex]:not([tabindex="-1"]):not(.ng-hide):not(.hide), ' +
					'.modal [role="button"]:not(.ng-hide):not(.hide), ' +
					'.o-modal button:not(.hide), ' +
					'.o-modal input:not(.ng-hide):not(.hide), ' +
					'.o-modal select:not(.ng-hide):not(.hide), ' +
					'.o-modal textarea:not(.ng-hide):not(.hide), ' +
					'.o-modal a:not(.ng-hide):not(.hide), ' +
					'.o-modal [tabindex]:not([tabindex="-1"]):not(.ng-hide):not(.hide), ' +
					'.o-modal [role="button"]:not(.ng-hide):not(.hide), ' +
					'.o-modal #faq-knowledge-articles-listbox, ' +
					'.s-modal gap-button:not(.hide) button, ' +
					'.s-modal gap-input:not(.ng-hide):not(.hide) input, ' +
					'.s-modal gap-select:not(.ng-hide):not(.hide) select, ' +
					'.s-modal textarea:not(.ng-hide):not(.hide), ' +
					'.s-modal a:not(.ng-hide):not(.hide), ' +
					'.s-modal [tabindex]:not([tabindex="-1"]):not(.ng-hide):not(.hide), ' +
					'.s-modal [role="button"]:not(.ng-hide):not(.hide)'
			},
			splashScreen: {
				containerSelector: '.splashScreen',
				focusButtonSelector: '.splashScreen button',
				focusableElementSelector: '.splashScreen button:not(.hide), ' +
					'.splashScreen input:not(.ng-hide):not(.hide), ' +
					'.splashScreen select:not(.ng-hide):not(.hide), ' +
					'.splashScreen textarea:not(.ng-hide):not(.hide), ' +
					'.splashScreen [href]:not(.ng-hide):not(.hide), ' +
					'.splashScreen [tabindex]:not([tabindex="-1"]):not(.ng-hide):not(.hide), ' +
					'.splashScreen [role="button"]:not(.ng-hide):not(.hide)'
			}
		};

		/**
		 * Our public API
		 */
		var service = {
			resetState: resetState,
			scrollContainerToElement: scrollContainerToElement,
			setFocusToContainer: setFocusToContainer,
			setFocusToElement: setFocusToElement,
			setFocusToError: setFocusToError,
			setFocusToTriggeringElement: setFocusToTriggeringElement
		};

		return service;

		// -----------------------------------------------------------------------------------------
		// Public Functions
		// -----------------------------------------------------------------------------------------

		/**
		 * Set the default focus within a container element (such as main menu or modal) which will be the
		 * customFocusButton parameter, otherwise default to the corresponding focus button depending on container.
		 * Must use $timeout to wait for digest, since we need to wait for Modal to be visible.
		 * @public
		 * @function
		 * @param {string} type - The type of container element, such as main menu or modal.
		 * @param {Object} currentTriggerElement - The current trigger element that opened the container.
		 * @param {Object} customFocusButton - A custom focus button to set as default, otherwise get the default focus button.
		 * @returns {undefined}
		 */
		function setFocusToContainer(type, currentTriggerElement, customFocusButton) {
			$timeout(function() {
				var containerElement = pageDocument.querySelector(containers[type].containerSelector);

				if (!isObject(containerElement)) {
					return;
				}

				resetState();
				containerType = type;
				focusButton = customFocusButton || pageDocument.querySelector(containers[type].focusButtonSelector);
				triggeringElements.push({
					type: type,
					container: containerElement,
					trigger: currentTriggerElement
				});

				if (isObject(focusButton)) {
					trapFocus(type, focusButton);
				}
			});
		}

		/**
		 * Set the focus to the first error field visible on the page or set focus on the promo code input
		 * field within the main menu or modal while container is open.
		 * @public
		 * @function
		 * @param {boolean} forPromo - Determines whether to query for promo code in main menu or modal.
		 * @returns {undefined}
		 */
		function setFocusToError(forPromo) {
			$timeout(function() {
				var errorField = getFirstErrorField(forPromo);

				if (isObject(errorField)) {
					errorField.focus();
				}
			});
		}

		/**
		 * Set the focus to the element ID passed in if it exists on timeout.
		 * @public
		 * @function
		 * @param {string} elementID - Element ID used for focusing something on the page.
		 * @returns {undefined}
		 */
		function setFocusToElement(elementID) {
			$timeout(function() {
				var element = pageDocument.getElementById(elementID);

				if (isObject(element)) {
					element.focus();
				}
			});
		}

		/**
		 * Scrolls a container ID passed in to the element ID passed in if it exists on timeout.
		 * @public
		 * @function
		 * @param {string} containerID - Element ID used for determining what container to scroll.
		 * @param {string} elementID - Element ID used for determining where to scroll to.
		 * @returns {undefined}
		 */
		function scrollContainerToElement(containerID, elementID) {
			$timeout(function() {
				// Get a reference for the element and it's container
				var container = pageDocument.getElementById(containerID);
				var element = pageDocument.getElementById(elementID);

				// Scroll the container to where the element is
				if (isObject(element) && isObject(container)) {
					container.scrollTop = element.offsetTop;
				}
			});
		}

		/**
		 * Set the focus to the triggering element that opened the container element.
		 * Also remove the event listener for keydown and focusin events so page is interactive again.
		 * @public
		 * @function
		 * @returns {undefined}
		 */
		function setFocusToTriggeringElement() {
			$timeout(function() {
				var errorField = getFirstErrorField(false),
					uniqueTriggers = getUniqueTriggers(),
					checkProp = $injector.get('Utilities').safelyCheckPropertyOnObject,
					topNavScenario;

				if (!isObject(uniqueTriggers)) {
					return;
				}

				// Building a special case check for FAQ top nav button, since it is possible to open FAQ
				// modal from the top or side menu. Side menu should trap focus, main menu doesn't trap focus.
				topNavScenario = uniqueTriggers.list.some(function isFAQTopNavButton(obj) {
					return obj.trigger.id === "navigation-faq-btn";
				});

				// If there are multiple unique triggers, then we are dealing with a modal opened within main menu,
				// or a modal opened another modal, etc. In these cases, do not set focus back to last trigger,
				// but rather set focus to previous trigger.
				if (uniqueTriggers.list.length > 1 && !topNavScenario) {
					// Reset focus to previous container, such as when FAQ modal opens from within main menu.
					triggeringElements = [];
					setFocusToContainer(uniqueTriggers.previous.type, uniqueTriggers.previous.trigger, uniqueTriggers.last.trigger);
				} else {
					$window.removeEventListener('keydown', handleKeyDown, false);
					$window.removeEventListener('focusin', handleFocusIn, false);
					$window.removeEventListener('focusout', handleFocusOut, false);
					triggeringElements = [];

					if (isObject(errorField)) {
						errorField.focus();
					} else if (checkProp('uniqueTriggers.last.trigger.focus', uniqueTriggers, angular.isFunction)) {
						uniqueTriggers.last.trigger.focus();
					}
				}
			});
		}

		// -----------------------------------------------------------------------------------------
		// Private Functions
		// -----------------------------------------------------------------------------------------

		/**
		 * Get the first error field visible on the page or in the main menu or modal. For special cases
		 * where the modal displays a page error and user closes modal, then set the focus on the page
		 * error element. An example is the select quantity modal, after closing there is no visible error,
		 * but focus should be set on the add quantity (+) icon. There are a lot of special cases to
		 * account for, so trying to capture them all here.
		 * @private
		 * @function
		 * @param {boolean} forPromo - Determines whether to query for promo code in main menu or modal.
		 * @returns {Object} The first error field to focus on if available.
		 */
		function getFirstErrorField(forPromo) {
			var termsAndConditionsButton;
			var firstErrorField = forPromo ? pageDocument.querySelector(
				'.navigation-enabled #navigation-view .ng-submitted #promobox-nav.ng-invalid, ' +
					'#modal-view-container.show #promobox-input.ng-invalid.submitted') :
				pageDocument.querySelector(
					'#application-view button.ng-invalid.submitted:not(.ng-hide), ' +
					'#application-view input.ng-invalid.submitted:not(.ng-hide), ' +
					'#application-view select.ng-invalid.submitted:not(.ng-hide), ' +
					'#application-view textarea.ng-invalid.submitted:not(.ng-hide), ' +
					'#application-view [href].ng-invalid.submitted:not(.ng-hide), ' +
					'#application-view [tabindex].ng-invalid.submitted:not([tabindex="-1"]):not(.ng-hide), ' +
					'#application-view .update-quantity:not(.ng-hide)');
			var firstAddQtyButton = pageDocument.querySelector('.icon-add');
			var selectedDate = pageDocument.querySelector('#application-view .cal-btn.selected:not(.ng-hide)');
			var dateButton = pageDocument.querySelector('#application-view #calendar-focus:not(.ng-hide)');
			var dateTimeButton = pageDocument.querySelector('#application-view .time-container [tabindex]:not([tabindex="-1"]):not(.ng-hide)');
			var timeMatrixButton = pageDocument.querySelector('#application-view .matrix-block .matrixButton:not(.no-click) input');
			var firstRedBorderField = pageDocument.querySelector('#application-view .red-border:not(.ng-hide)');

			if (isObject(firstErrorField)) {
				return firstErrorField;
			} else if (isObject(firstAddQtyButton) && isObject(firstAddQtyButton.parentNode)) {
				return firstAddQtyButton.parentNode;
			} else if (isObject(timeMatrixButton)) {
				return timeMatrixButton;
			} else if (isObject(dateButton) || (isObject(selectedDate) && isObject(dateTimeButton))) {
				return selectedDate ? dateTimeButton : dateButton;
			} else if (isObject(firstRedBorderField)) {
				termsAndConditionsButton = firstRedBorderField.querySelector('[tabindex]:not([tabindex="-1"]):not(.ng-hide)');
				return isObject(termsAndConditionsButton) ? termsAndConditionsButton : firstRedBorderField;
			} else {
				return;
			}
		}

		/**
		 * Get the unique trigger elements tracked by history of whether a modal was opened within a main
		 * menu, or a modal opened another modal, etc. Remove duplicate entries for cases when setFocusToContainer
		 * is called twice from special cases like FAQ modal triggering showModal twice.
		 * @private
		 * @function
		 * @returns {Object} The list of unique trigger elements including last and previous triggers.
		 */
		function getUniqueTriggers() {
			var uniqueElements = triggeringElements.reduce(function(accumulator, current) {
				var containerExists = pageDocument.body.contains(current.container);
				var triggerExistsInContainer = current.container.contains(current.trigger);
				var duplicate = accumulator.some(function(previous) {
					return previous.type === current.type &&
						previous.container === current.container &&
						previous.trigger === current.trigger;
				});

				if (!duplicate && containerExists && !triggerExistsInContainer) {
					accumulator.push(current);
				}

				return accumulator;
			}, []);
			var arrayLength = uniqueElements.length;
			var lastTriggerElement = arrayLength >= 1 ? uniqueElements[arrayLength - 1] : { trigger: pageDocument.getElementById('application-view') };
			var prevTriggerElement = arrayLength > 1 ? uniqueElements[arrayLength - 2] : null;

			return {
				last: lastTriggerElement,
				list: uniqueElements,
				previous: prevTriggerElement
			};
		}

		/**
		 * Get the available focusable elements querying by a selector, such as single or multiple string of
		 * ids or classes, etc. Only get visible elements that can be interacted with inside the container element.
		 * @private
		 * @function
		 * @param {string} selector - A css selector, single or multiple string of ids or classes, etc.
		 * @returns {Object} The focusable elements within the container including first and last elements.
		 */
		function getFocusableElements(selector) {
			var allFocusableElements = pageDocument.querySelectorAll(selector);
			var elementsArray = Array.prototype.slice.call(allFocusableElements);
			var firstFocusableElement = elementsArray[0];
			var lastFocusableElement = elementsArray[elementsArray.length - 1];

			return {
				list: elementsArray,
				first: firstFocusableElement,
				last: lastFocusableElement
			};
		}

		/**
		 * Handle when shift + tab is used to navigate the container's focusable elements in reverse.
		 * Set the focus to the last element in the container when user reaches the first element in container.
		 * Main menu is a special case because the hamburger menu icon is in a separate div, so tab order
		 * is not correct. For the second element in main menu, reset focus back to first element (the hamburger icon).
		 * @private
		 * @function
		 * @param {KeyboardEvent} event The keyboard event
		 * @returns {undefined}
		 */
		function handleBackTab(event) {
			var focusableElements = getFocusableElements(containers[containerType].focusableElementSelector);
			if (event.target === focusableElements.first) {
				event.preventDefault();
				focusableElements.last.focus();
			}
		}

		/**
		 * Handle when forward tabbing to navigate the container's focusable elements.
		 * Set the focus to the first element in the container when user reaches the last element in container.
		 * @private
		 * @function
		 * @param {KeyboardEvent} event The keyboard event
		 * @returns {undefined}
		 */
		function handleForwardTab(event) {
			var focusableElements = getFocusableElements(containers[containerType].focusableElementSelector);
			if (event.target === focusableElements.last) {
				event.preventDefault();
				focusableElements.first.focus();
			}
		}

		/**
		 * Handle the keydown event within the container. When tabbing or shift-tabbing through the container,
		 * we must trap the focus within the container until the container closes or is hidden.
		 * @private
		 * @function
		 * @param {KeyboardEvent} event The keyboard event
		 * @returns {undefined}
		 */
		function handleKeyDown(event) {
			var focusableElements = getFocusableElements(containers[containerType].focusableElementSelector);
			var foundInContainer = focusableElements.list.some(function(elem) {
				return elem === event.target;
			});

			if (!foundInContainer) {
				event.preventDefault();
				if (focusableElements.first) {
					focusableElements.first.focus();
				}
			}

			switch (event.keyCode) {
			case tabKey:
				if (event.shiftKey) {
					handleBackTab(event);
				} else {
					handleForwardTab(event);
				}
				break;
			case escapeKey:
				// Close or hide container element
				focusButton.click();
				break;
			default:
				break;
			}
		}

		/**
		 * Handle the focusin event within the container. When tabbing or shift-tabbing through the container,
		 * check the element about to receive focus to make sure it is not outside of the container. If it is
		 * not found in the container element, reset focus to first element within container. Main menu is a
		 * special case since the hamburger menu icon is in a separate div, the focus tab order is not correct
		 * and needs to get set to the second element in the list instead. Also the FAQ modal is another special
		 * case where Firefox detects the parent container, so when tabbing forward from the input field, then
		 * focus on the first FAQ article. When back tabbing from the input field, then focus on the first FAQ article.
		 * @private
		 * @function
		 * @param {KeyboardEvent} event The keyboard event
		 * @returns {undefined}
		 */
		function handleFocusIn(event) {
			var focusableElements = getFocusableElements(containers[containerType].focusableElementSelector);
			var isFaqParentContainer = containerType === 'modal' && event.target.id === 'faq-knowledge-articles-listbox';
			var faqInputField = pageDocument.getElementById('faq-filter-knowledgebase');
			var firstFaqArticle = isFaqParentContainer ? event.target.querySelector('.article-heading') : null;
			var foundInContainer = focusableElements.list.some(function(elem) {
				return elem === event.target;
			});

			if (!foundInContainer) {
				event.preventDefault();

				if (isObject(firstFaqArticle) && elementLosingFocus === faqInputField) {
					// Forward tab from FAQ input field, so focus on first FAQ article
					firstFaqArticle.focus();
				} else if (isObject(faqInputField) && elementLosingFocus === firstFaqArticle) {
					// Back tab from first FAQ article, so focus on FAQ input field
					faqInputField.focus();
				} else if (focusableElements.first) {
					focusableElements.first.focus();
				}
			}
		}

		/**
		 * Handle the focusout event to keep track of the element about to lose focus.
		 * @private
		 * @function
		 * @param {KeyboardEvent} event The keyboard event
		 * @returns {undefined}
		 */
		function handleFocusOut(event) {
			elementLosingFocus = event.target;
		}

		/**
		 * Trap the focus in a container, such as main menu or modal, when the container is visible
		 * so that a user cannot tab outside of the container. Focus will only be trapped until the
		 * container closes or is hidden.
		 * @private
		 * @function
		 * @param {string} container - The container element, such as main menu or modal.
		 * @param {HTMLElement} focusElement The elemen to focus if available
		 * @returns {undefined}
		 */
		function trapFocus(container, focusElement) {
			var focusableElements = getFocusableElements(containers[container].focusableElementSelector);

			if (isObject(focusableElements) && focusableElements.list.length) {
				$window.addEventListener('keydown', handleKeyDown, false);
				$window.addEventListener('focusin', handleFocusIn, false);
				$window.addEventListener('focusout', handleFocusOut, false);

				if (focusElement && container !== 'mainMenu') {
					focusElement.focus();
				} else {
					focusableElements.first.focus();
				}
			}
		}

		/**
		 * Reset all variables back to initial state and remove event listener.
		 * @private
		 * @function
		 * @returns {undefined}
		 */
		function resetState() {
			containerType = null;
			focusButton = null;
			$window.removeEventListener('keydown', handleKeyDown, false);
			$window.removeEventListener('focusin', handleFocusIn, false);
			$window.removeEventListener('focusout', handleFocusOut, false);
		}
	}
}());

(function() {
	'use strict';

	angular
		.module('vertical-package-list', [])
		.config(function($locationProvider, $stateProvider) {
			$stateProvider
				.state('vertical-package-list', {
					url: '/vertical-package-list/:recommenderWizardKeyword/:keyword',
					controller: 'VerticalPackageListController',
					controllerAs: 'vm',
					templateUrl: '/scripts/modules/alternate-modules/vertical-package-list/views/vertical-package-list.html',
					resolve: {
						load: function(Utilities, $rootScope) {
							$rootScope.showSpinner();
							return Utilities.cacheBustAndLazyLoad([
								'/scripts/modules/alternate-modules/vertical-package-list/controllers/vertical-package-list-controller.js',
								'/scripts/modules/alternate-modules/vertical-package-list/styles/vertical-package-list.css'
							]);
						},
						initialData: function(load, Bootstrap) {
							return Bootstrap.bootstrapApplication(undefined, true);
						},
						recommenderWizard: function(initialData, $transition$, RecommenderWizardContextService) {
							if (RecommenderWizardContextService.bootstrapWizard($transition$.params().recommenderWizardKeyword, 'vertical-package-list')) {
								RecommenderWizardContextService.registerVerticalPackageList();
							}
						},
						ensureQuantitySelected: function ensureQuantitySelected(recommenderWizard, $state, RecommenderWizardRouteService) {
							RecommenderWizardRouteService.ensureRouteHasCustomerTypes($state.current.name, $state.params);
						}
					}
				});
		})
		.run(function(ExtraFlow) {
			ExtraFlow.registerXMC('vertical-package-list', {
				name: 'vertical-package-list',
				view: 'vertical-package-list',
				viewIsStateName: true,
				doEditMode: false,
				lockQuantity: true,
				writeSingleCharac: false,
				enabled: true,
				type: 'alternateFlowModule'
			});
		})
		.value('VerticalPackageListLocaleSection', 'VerticalPackageList');
})();

(function(){
	'use strict';

	angular
		.module('date-matrix-time-selection', [])
		.config(function($locationProvider, $stateProvider){
			$stateProvider
				.state('date-matrix-time-selection', {
					url: '/date-matrix-time-selection/:packageId',
					controller: 'DateMatrixTimeSelectionController',
					controllerAs: 'vm',
					templateUrl: '/scripts/modules/extraflow/date-matrix-time-selection/views/date-matrix-time-selection.html',
					resolve: {
						load: function(Utilities, $rootScope){
							$rootScope.showSpinner();
							return Utilities.cacheBustAndLazyLoad([
								'/scripts/modules/extraflow/date-matrix-time-selection/services/date-matrix-time-selection-service.js',
								'/scripts/modules/extraflow/date-matrix-time-selection/controllers/date-matrix-time-selection-controller.js',
								'/scripts/modules/extraflow/date-matrix-time-selection/styles/date-matrix-time-selection.css'
							]);
						},
						initialData: function(load, Bootstrap){
							return Bootstrap.bootstrapApplication();
						},
						xfcMap: function(initialData, Package){
							return Package.buildXFCMap();
						},
						initXFC: function(xfcMap, RouteRejectionService, Package){
							var rejectionRoute = Package.assessRoutabilityOfXFC();
							if(rejectionRoute.length > 0){
								throw new RouteRejectionService.UnrecoverableException(rejectionRoute);
							} else {
								return true;
							}
						},
						dateData: function(initXFC, $injector, $transition$){
							return $injector.get('DateMatrixTimeSelectionService').retrieveInitialDataForRoute($transition$.params());
						}
					}
				});
		})
		.run(function(ExtraFlow){
			ExtraFlow.registerXMC('date-matrix-time-selection', {
				name: 'date-matrix-time-selection',
				view: 'date-matrix-time-selection',
				doEditMode: false,
				lockQuantity: true,
				writeSingleCharac: false,
				enabled: true,
				type: 'extraFlowControl'
			});
		})
		.value('DateMatrixTimeSelectionLocaleSection', 'DateMatrixTimeSelection');
})();
(function() {
	'use strict';

	angular
		.module('input-capture-modal', [])
})();
(function() {
	'use strict';

	angular
		.module('input-capture-modal')
		.factory('InputCaptureModalService', InputCaptureModalService);


	/**
	 * Input capture service
	 * @param {Service} Utilities - Utilities Service
	 * @param {Object} $rootScope - Main parent angular scope
	 * @param {Object} $uibModal - uib modal Service
	 * @returns {Object} - Service
	 * @constructor
	 */
	function InputCaptureModalService(
		Utilities,
		$rootScope,
		$uibModal
	) {


		/**
		 * Service object
		 * @type {Object}
		 */
		var service = {

			getAndOpenCaptureModal: getAndOpenCaptureModal

		};
		return service;

		////////////////

		/**
		 *  Get and open a new capture modal instance
		 * @param {string} fieldValidationType - field validation type (from FormValidationService patterns)
		 * @param {string} localeSection - locale section to use
		 * @param {boolean} showModalCloseButton  -
		 * @returns {Object} modInstance - the new modal instance
		 */
		function getAndOpenCaptureModal(fieldValidationType, localeSection, showModalCloseButton) {

			var modInstance = $uibModal.open({
				templateUrl: 'scripts/modules/input-capture-modal/views/input-capture-modal.html',
				controller: 'InputCaptureModalController',
				controllerAs: 'vm',
				resolve: {
					fieldValidationType: function() {

						return fieldValidationType;

					},
					localeSection: function() {

						return localeSection;

					},
					showModalCloseButton: function() {

						return Utilities.getBoolean(showModalCloseButton);

					}
				},
				backdrop: 'static'
			});
			$rootScope.modalOpen = true;
			return modInstance;

		}

	}

})();



(function() {
	'use strict';

	angular
		.module('input-capture-modal')
		.controller('InputCaptureModalController', InputCaptureModalController);

	/**
	 *
	 * @param fieldValidationType
	 * @param localeSection
	 * @param $rootScope
	 * @param $scope
	 * @param $uibModalInstance
	 * @constructor
	 */
	function InputCaptureModalController(
		fieldValidationType,
		localeSection,
		showModalCloseButton,
		$rootScope,
		$scope,
		$transitions,
		$uibModalInstance) {


		/**
		 * View model
		 * @type {Object}
		 */
		var vm = this;

		/**
		 * Field validation type
		 * @type {string}
		 */
		vm.fieldValidationType = fieldValidationType;

		/**
		 * Input model data
		 * @type {string}
		 */
		vm.inputModelData = '';

		/**
		 * Submitted
		 * @type {boolean}
		 */
		vm.submitted = false;

		/**
		 * Locale section
		 * @type {string}
		 */
		vm.localeSection = localeSection;

		/**
		 * Show the modal close button
		 * @type {boolean}
		 */
		vm.showModalCloseButton = showModalCloseButton;


		/**
		 * Confirm the input modal
		 * @type {Function} - confirm the input modal
		 */
		vm.confirmInput = confirmInput;

		/**
		 * Close the input modal
		 * @type {Function} - close the input modal
		 */
		vm.closeInput = closeInput;


		/**
		 * Confirm the input - check for validity
		 * @returns {undefined}
		 */
		function confirmInput() {

			vm.submitted = true;
			if(vm.inputCaptureForm.$valid) {

				$uibModalInstance.close(vm.inputModelData);

			}

		}

		/**
		 *
		 * Close the input
		 * @returns {undefined}
		 */
		function closeInput() {

			//close with an empty string
			$uibModalInstance.close('');

		}


		/**
		 * Ensure we follow the same practice for hiding the modal so that we close this modal instance
		 */
		$rootScope.$on('hidePreviousModals', function() {
			$rootScope.modalOpen = false;
			$uibModalInstance.close();
		});

		/**
		 * Try to catch state changes back to the previous screen and prevent the occurrence
		 * Technically the store should be on lock-down at this point as the guest is in
		 * the middle of a transaction
		 */
		var onExitDeregister = $transitions.onExit({}, function() {
			//catch routing away and enforce user to confirm whether or not they wish to leave
			if ($rootScope.modalOpen) {
				$rootScope.modalOpen = false;
				$uibModalInstance.close();
				return;
			}

			onExitDeregister();
		});


	}

})();


(function() {
	'use strict';

	angular
		.module('post-purchase-survey', ['app'])
		.run(function($q, $injector, AppData, JSONValidator, PostPurchaseActionsService, Utilities) {
			PostPurchaseActionsService.registerAction(function() {
				if (JSONValidator.validate('post_purchase_survey', AppData.settings.post_purchase_survey)) {
					return Utilities
						.cacheBustAndLazyLoad([
							'/scripts/modules/post-purchase-survey/services/post-purchase-survey-service.js',
							'/scripts/modules/post-purchase-survey/controllers/post-purchase-survey-modal-controller.js'
						])
						.then(function() {
							var PostPurchaseSurveyService = $injector.get('PostPurchaseSurveyService');
							PostPurchaseSurveyService.initializeSettings();
							return PostPurchaseSurveyService.displayModal();
						});
				} else {
					return $q.resolve();
				}
			});
		});
})();